
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
const $5834f5097160e8a3$export$b2b1a9147d6336c4 = 0x1800; //6144; // 0x1800
const $5834f5097160e8a3$export$d85a48ab169c2576 = 0x2a00; //10752; // 0x2a00
const $5834f5097160e8a3$export$1f06ff4b93d17df6 = 0x1826; // 6182; // 0x1826
const $5834f5097160e8a3$export$ebfc1f1d8e8ebad2 = 0x2acd; //10957; // 0x2acd
const $5834f5097160e8a3$export$97ebc12d623fde23 = 10963; // 0x2ad3
const $5834f5097160e8a3$export$f0942e471d10bf81 = 10970; // 0x2ada
const $5834f5097160e8a3$export$21d24f7635c1d044 = 0x2ad9; // Control Point
const $5834f5097160e8a3$export$81beafb8a1f75496 = 0x2acc; // Fitness Machine Feature
async function $5834f5097160e8a3$export$17b446b869dad473() {
    return await navigator?.bluetooth?.getAvailability();
}
async function $5834f5097160e8a3$export$30c823bc834d6ab4() {
    return await navigator?.bluetooth?.requestDevice({
        filters: [
            {
                services: [
                    $5834f5097160e8a3$export$1f06ff4b93d17df6
                ]
            }
        ],
        optionalServices: [
            $5834f5097160e8a3$export$b2b1a9147d6336c4
        ]
    });
}
async function $5834f5097160e8a3$export$64605811ab45167f(d) {
    if (!d.gatt) return Promise.reject("no gatt available");
    d.addEventListener("gattserverdisconnected", ()=>console.error("! device disconnected"));
    return await d.gatt.connect();
}
async function $5834f5097160e8a3$export$37dfea93db2e14ed(d) {
    d?.gatt?.disconnect;
}
async function $5834f5097160e8a3$export$4c0029b0ace0292a(s) {
    console.log("[BT] Starting service discovery...");
    console.log("[BT] Device:", s.device.name, "Connected:", s.connected);
    // First, let's see what services are available
    try {
        console.log("[BT] Getting primary services...");
        const services = await s.getPrimaryServices();
        console.log("[BT] Available services:", services.length);
        for (const svc of services){
            console.log("[BT]   Service UUID:", svc.uuid);
            try {
                const chars = await svc.getCharacteristics();
                for (const char of chars)console.log("[BT]     Characteristic:", char.uuid, "Properties:", {
                    read: char.properties.read,
                    write: char.properties.write,
                    notify: char.properties.notify,
                    indicate: char.properties.indicate
                });
            } catch (e) {
                console.log("[BT]     Could not enumerate characteristics:", e);
            }
        }
    } catch (e) {
        console.warn("[BT] Could not enumerate services:", e);
    }
    // Generic Access is optional - device name comes from device.name
    let genericAccess;
    let deviceName;
    try {
        console.log("[BT] Looking for Generic Access Service (0x1800)...");
        genericAccess = await s.getPrimaryService($5834f5097160e8a3$export$b2b1a9147d6336c4);
        console.log("[BT] Found Generic Access Service");
        deviceName = await genericAccess.getCharacteristic($5834f5097160e8a3$export$d85a48ab169c2576);
        console.log("[BT] Found Device Name Characteristic");
    } catch (e) {
        console.warn("[BT] Generic Access Service not available (this is OK):", e);
    }
    let fitnessMachine;
    let treadmillData;
    let trainingStatus;
    let fitnessMachineStatus;
    let controlPoint;
    let feature;
    try {
        console.log("[BT] Looking for Fitness Machine Service (0x1826)...");
        fitnessMachine = await s.getPrimaryService($5834f5097160e8a3$export$1f06ff4b93d17df6);
        console.log("[BT] Found Fitness Machine Service");
        // List all characteristics in the service
        try {
            const chars = await fitnessMachine.getCharacteristics();
            console.log("[BT] Fitness Machine characteristics:");
            for (const char of chars)console.log("[BT]   ", char.uuid, {
                read: char.properties.read,
                write: char.properties.write,
                notify: char.properties.notify,
                indicate: char.properties.indicate
            });
        } catch (e) {
            console.warn("[BT] Could not list characteristics:", e);
        }
        console.log("[BT] Looking for Treadmill Data (0x2acd)...");
        treadmillData = await fitnessMachine.getCharacteristic($5834f5097160e8a3$export$ebfc1f1d8e8ebad2);
        console.log("[BT] Found Treadmill Data Characteristic");
        console.log("[BT] Looking for Training Status (0x2ad3)...");
        trainingStatus = await fitnessMachine.getCharacteristic($5834f5097160e8a3$export$97ebc12d623fde23);
        console.log("[BT] Found Training Status Characteristic");
        // Fitness Machine Status is optional
        try {
            console.log("[BT] Looking for Fitness Machine Status (0x2ada)...");
            fitnessMachineStatus = await fitnessMachine.getCharacteristic($5834f5097160e8a3$export$f0942e471d10bf81);
            console.log("[BT] Found Fitness Machine Status Characteristic");
        } catch  {
            console.warn("[BT] Fitness Machine Status characteristic not available");
        }
        // Control Point is optional
        try {
            console.log("[BT] Looking for Control Point (0x2ad9)...");
            controlPoint = await fitnessMachine.getCharacteristic($5834f5097160e8a3$export$21d24f7635c1d044);
            console.log("[BT] Found Control Point Characteristic - treadmill control available!");
        } catch  {
            console.warn("[BT] Control Point characteristic not available - no treadmill control");
        }
        // Feature characteristic is optional
        try {
            console.log("[BT] Looking for Feature (0x2acc)...");
            feature = await fitnessMachine.getCharacteristic($5834f5097160e8a3$export$81beafb8a1f75496);
            console.log("[BT] Found Feature Characteristic");
        } catch  {
            console.warn("[BT] Feature characteristic not available");
        }
    } catch (e) {
        console.error("[BT] Failed to discover Fitness Machine Service:", e);
        throw new Error("failed to discover fitness machine service and associated characteristics");
    }
    console.log("[BT] Service discovery complete!");
    console.log("[BT] Summary:");
    console.log("[BT]   Generic Access:", !!genericAccess);
    console.log("[BT]   Treadmill Data:", !!treadmillData);
    console.log("[BT]   Training Status:", !!trainingStatus);
    console.log("[BT]   Fitness Machine Status:", !!fitnessMachineStatus);
    console.log("[BT]   Control Point:", !!controlPoint);
    console.log("[BT]   Feature:", !!feature);
    return {
        genericAccess: {
            service: genericAccess,
            deviceName: deviceName
        },
        fitnessMachine: {
            service: fitnessMachine,
            treadmillData: treadmillData,
            trainingStatus: trainingStatus,
            fitnessMachineStatus: fitnessMachineStatus,
            controlPoint: controlPoint,
            feature: feature
        }
    };
}
const $5834f5097160e8a3$export$dc2bc4b267a994c2 = {
    REQUEST_CONTROL: 0x00,
    RESET: 0x01,
    SET_TARGET_SPEED: 0x02,
    SET_TARGET_INCLINATION: 0x03,
    START_OR_RESUME: 0x07,
    STOP_OR_PAUSE: 0x08,
    RESPONSE_CODE: 0x80
};
const $5834f5097160e8a3$export$9cecc721d059acf0 = {
    SUCCESS: 0x01,
    OP_CODE_NOT_SUPPORTED: 0x02,
    INVALID_PARAMETER: 0x03,
    OPERATION_FAILED: 0x04,
    CONTROL_NOT_PERMITTED: 0x05
};
function $5834f5097160e8a3$export$70c3c3653bbab88f() {
    return new Uint8Array([
        $5834f5097160e8a3$export$dc2bc4b267a994c2.REQUEST_CONTROL
    ]);
}
function $5834f5097160e8a3$export$23b69923adf01b9c() {
    return new Uint8Array([
        $5834f5097160e8a3$export$dc2bc4b267a994c2.START_OR_RESUME
    ]);
}
function $5834f5097160e8a3$export$4387efe3be2b0da2() {
    // 0x01 = Stop, 0x02 = Pause
    return new Uint8Array([
        $5834f5097160e8a3$export$dc2bc4b267a994c2.STOP_OR_PAUSE,
        0x01
    ]);
}
function $5834f5097160e8a3$export$37dba2039df9bd65() {
    return new Uint8Array([
        $5834f5097160e8a3$export$dc2bc4b267a994c2.STOP_OR_PAUSE,
        0x02
    ]);
}
function $5834f5097160e8a3$export$175e6420edf6da60(speedKmph) {
    // Speed in 1/100 km/h as uint16 little-endian
    const speedValue = Math.round(speedKmph * 100);
    return new Uint8Array([
        $5834f5097160e8a3$export$dc2bc4b267a994c2.SET_TARGET_SPEED,
        speedValue & 0xff,
        speedValue >> 8 & 0xff
    ]);
}
function $5834f5097160e8a3$export$d991cbeaacf80d3f(data) {
    return {
        opCode: data.getUint8(0),
        requestOpCode: data.getUint8(1),
        result: data.getUint8(2)
    };
}
//https://btprodspecificationrefs.blob.core.windows.net/gatt-specification-supplement/GATT_Specification_Supplement.pdf 3.234
// Field length, if present, in octets
const $5834f5097160e8a3$var$TreadmillNotificationFieldLength = {
    FLAGS: 2,
    INSTANTANEOUS_SPEED: 2,
    AVERAGE_SPEED: 2,
    TOTAL_DISTANCE: 3,
    INCLINATION: 2,
    RAMP_ANGLE_SETTING: 2,
    POSITIVE_ELEVATION_GAIN: 2,
    NEGATIVE_ELEVATION_GAIN: 2,
    INSTANTANEOUS_PACE: 2,
    AVERAGE_PACE: 2,
    TOTAL_ENERGY: 2,
    ENERGY_PER_HOUR: 2,
    ENERGY_PER_MINUTE: 1,
    HEART_RATE: 1,
    METABOLIC_EQUIVALENT: 1,
    ELAPSED_TIME: 2,
    REMAINING_TIME: 2,
    FORCE_ON_BELT: 2,
    POWER_OUTPUT: 2
};
function $5834f5097160e8a3$var$parseTreadmillNotificationFlags(v) {
    return {
        instantaneousSpeed: (v & 1) != 1,
        averageSpeed: (v & 2) != 0,
        totalDistance: (v & 4) != 0,
        inclinationAndRampAngle: (v & 8) != 0,
        elevationGain: (v & 16) != 0,
        instantaneousPace: (v & 32) != 0,
        averagePace: (v & 64) != 0,
        expendedEnergy: (v & 128) != 0,
        heartRate: (v & 256) != 0,
        metabolicEquivalent: (v & 512) != 0,
        elapsedTime: (v & 1024) != 0,
        remainingTime: (v & 2048) != 0,
        forceOnBeltAndPowerOutput: (v & 4096) != 0
    };
}
function $5834f5097160e8a3$export$5b03a248c90de598(v) {
    let pos = 0;
    const flags = $5834f5097160e8a3$var$parseTreadmillNotificationFlags(v.getUint16(pos, true));
    pos += $5834f5097160e8a3$var$TreadmillNotificationFieldLength.FLAGS;
    if (!flags.instantaneousSpeed) throw new Error("multi-packet notifications not supported");
    let instantaneousSpeed = v.getUint16(pos, true) / 100;
    pos += $5834f5097160e8a3$var$TreadmillNotificationFieldLength.INSTANTANEOUS_SPEED;
    let averageSpeed = 0;
    if (flags.averageSpeed) {
        averageSpeed = v.getUint16(pos, true) / 100;
        pos += $5834f5097160e8a3$var$TreadmillNotificationFieldLength.AVERAGE_SPEED;
    }
    let totalDistance = 0;
    if (flags.totalDistance) {
        totalDistance = v.getUint16(pos, true) + (v.getUint8(pos + 2) << 16);
        pos += $5834f5097160e8a3$var$TreadmillNotificationFieldLength.TOTAL_DISTANCE;
    }
    let inclination = 0;
    let rampAngleSetting = 0;
    if (flags.inclinationAndRampAngle) {
        inclination = v.getInt16(pos, true);
        pos += $5834f5097160e8a3$var$TreadmillNotificationFieldLength.INCLINATION;
        rampAngleSetting = v.getInt16(pos, true);
        pos += $5834f5097160e8a3$var$TreadmillNotificationFieldLength.RAMP_ANGLE_SETTING;
    }
    let positiveElevationGain = 0;
    let negativeElevationGain = 0;
    if (flags.elevationGain) {
        positiveElevationGain = v.getUint16(pos, true);
        pos += $5834f5097160e8a3$var$TreadmillNotificationFieldLength.POSITIVE_ELEVATION_GAIN;
        negativeElevationGain = v.getUint16(pos, true);
        pos += $5834f5097160e8a3$var$TreadmillNotificationFieldLength.NEGATIVE_ELEVATION_GAIN;
    }
    let instantaneousPace = 0;
    if (flags.instantaneousPace) {
        instantaneousPace = v.getUint16(pos, true);
        pos += $5834f5097160e8a3$var$TreadmillNotificationFieldLength.INSTANTANEOUS_PACE;
    }
    let averagePace = 0;
    if (flags.averagePace) {
        averagePace = v.getUint16(pos, true);
        pos += $5834f5097160e8a3$var$TreadmillNotificationFieldLength.AVERAGE_PACE;
    }
    let totalEnergy = 0;
    let energyPerHour = 0;
    let energyPerMinute = 0;
    if (flags.expendedEnergy) {
        totalEnergy = v.getUint16(pos, true);
        pos += $5834f5097160e8a3$var$TreadmillNotificationFieldLength.TOTAL_ENERGY;
        energyPerHour = v.getUint16(pos, true);
        pos += $5834f5097160e8a3$var$TreadmillNotificationFieldLength.ENERGY_PER_HOUR;
        energyPerMinute = v.getUint8(pos);
        pos += $5834f5097160e8a3$var$TreadmillNotificationFieldLength.ENERGY_PER_MINUTE;
    }
    let heartRate = 0;
    if (flags.heartRate) {
        heartRate = v.getUint8(pos);
        pos += $5834f5097160e8a3$var$TreadmillNotificationFieldLength.HEART_RATE;
    }
    let metabolicEquivalent = 0;
    if (flags.metabolicEquivalent) {
        metabolicEquivalent = v.getUint8(pos);
        pos += $5834f5097160e8a3$var$TreadmillNotificationFieldLength.METABOLIC_EQUIVALENT;
    }
    let elapsedTime = 0;
    if (flags.elapsedTime) {
        elapsedTime = v.getUint16(pos, true);
        pos += $5834f5097160e8a3$var$TreadmillNotificationFieldLength.ELAPSED_TIME;
    }
    let remainingTime = 0;
    if (flags.remainingTime) {
        remainingTime = v.getUint16(pos, true);
        pos += $5834f5097160e8a3$var$TreadmillNotificationFieldLength.REMAINING_TIME;
    }
    let forceOnBelt = 0;
    let powerOutput = 0;
    if (flags.forceOnBeltAndPowerOutput) {
        forceOnBelt = v.getInt16(pos, true);
        pos += $5834f5097160e8a3$var$TreadmillNotificationFieldLength.FORCE_ON_BELT;
        powerOutput = v.getInt16(pos, true);
        pos += $5834f5097160e8a3$var$TreadmillNotificationFieldLength.POWER_OUTPUT;
    }
    return {
        instantaneousSpeed: instantaneousSpeed,
        averageSpeed: averageSpeed,
        totalDistance: totalDistance,
        inclination: inclination,
        rampAngleSetting: rampAngleSetting,
        positiveElevationGain: positiveElevationGain,
        negativeElevationGain: negativeElevationGain,
        instantaneousPace: instantaneousPace,
        averagePace: averagePace,
        totalEnergy: totalEnergy,
        energyPerHour: energyPerHour,
        energyPerMinute: energyPerMinute,
        heartRate: heartRate,
        metabolicEquivalent: metabolicEquivalent,
        elapsedTime: elapsedTime,
        remainingTime: remainingTime,
        forceOnBelt: forceOnBelt,
        powerOutput: powerOutput
    };
}
const $5834f5097160e8a3$var$TrainingStatusNotificationFieldLength = {
    FLAGS: 1,
    TRAINING_STATUS: 1
};
// FTMS 4.10.1.2
function $5834f5097160e8a3$var$trainingStatusFieldState(v) {
    switch(v){
        case 0x00:
            return "Other";
        case 0x01:
            return "Idle";
        case 0x02:
            return "Warming Up";
        case 0x03:
            return "Low Intensity Interval";
        case 0x04:
            return "High Intensity Interval";
        case 0x05:
            return "Recovery Interval";
        case 0x06:
            return "Isometric";
        case 0x07:
            return "Heart Rate Control";
        case 0x08:
            return "Fitness Test";
        case 0x09:
            return "Speed Outside of Control Region - Low (increase speed to return to controllable region)";
        case 0x0a:
            return "Speed outside of Control Region - High (decrease speed to return to controllable region)";
        case 0x0b:
            return "Cool Down";
        case 0x0c:
            return "Watt Control";
        case 0x0d:
            return "Manual Mode (Quick Start)";
        case 0x0e:
            return "Pre-Workout";
        case 0x0f:
            return "Post-Workout";
        default:
            return "Reserved for Future Use";
    }
}
function $5834f5097160e8a3$var$parseTrainingStatusNotificationFlags(v) {
    return {
        statusString: (v & 1) != 1,
        extendedString: (v & 2) != 0
    };
}
function $5834f5097160e8a3$export$4ac06a731c8c3c15(v) {
    let pos = 0;
    const flags = $5834f5097160e8a3$var$parseTrainingStatusNotificationFlags(v.getUint8(pos));
    pos += $5834f5097160e8a3$var$TrainingStatusNotificationFieldLength.FLAGS;
    const status = v.getUint8(pos);
    const stringFromStatus = $5834f5097160e8a3$var$trainingStatusFieldState(status);
    pos += $5834f5097160e8a3$var$TrainingStatusNotificationFieldLength.TRAINING_STATUS;
    let statusString = "";
    if (flags.statusString) {
        if (flags.extendedString) console.warn("training status notification received with extended string. long-read not supported. reading only current notification.");
        const d = new TextDecoder();
        statusString = d.decode(new DataView(v.buffer, v.byteOffset + pos));
    }
    return {
        status: status,
        statusString: statusString,
        stringFromStatus: stringFromStatus
    };
}



/*
 * Dexie.js - a minimalistic wrapper for IndexedDB
 * ===============================================
 *
 * By David Fahlander, david.fahlander@gmail.com
 *
 * Version 3.2.5, Thu Feb 08 2024
 *
 * https://dexie.org
 *
 * Apache License Version 2.0, January 2004, http://www.apache.org/licenses/
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $2f895839ac78ac6c$var$__assign = function() {
    $2f895839ac78ac6c$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2f895839ac78ac6c$var$__assign.apply(this, arguments);
};
function $2f895839ac78ac6c$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
var $2f895839ac78ac6c$var$_global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
var $2f895839ac78ac6c$var$keys = Object.keys;
var $2f895839ac78ac6c$var$isArray = Array.isArray;
if (typeof Promise !== "undefined" && !$2f895839ac78ac6c$var$_global.Promise) $2f895839ac78ac6c$var$_global.Promise = Promise;
function $2f895839ac78ac6c$var$extend(obj, extension) {
    if (typeof extension !== "object") return obj;
    $2f895839ac78ac6c$var$keys(extension).forEach(function(key) {
        obj[key] = extension[key];
    });
    return obj;
}
var $2f895839ac78ac6c$var$getProto = Object.getPrototypeOf;
var $2f895839ac78ac6c$var$_hasOwn = {}.hasOwnProperty;
function $2f895839ac78ac6c$var$hasOwn(obj, prop) {
    return $2f895839ac78ac6c$var$_hasOwn.call(obj, prop);
}
function $2f895839ac78ac6c$var$props(proto, extension) {
    if (typeof extension === "function") extension = extension($2f895839ac78ac6c$var$getProto(proto));
    (typeof Reflect === "undefined" ? $2f895839ac78ac6c$var$keys : Reflect.ownKeys)(extension).forEach(function(key) {
        $2f895839ac78ac6c$var$setProp(proto, key, extension[key]);
    });
}
var $2f895839ac78ac6c$var$defineProperty = Object.defineProperty;
function $2f895839ac78ac6c$var$setProp(obj, prop, functionOrGetSet, options) {
    $2f895839ac78ac6c$var$defineProperty(obj, prop, $2f895839ac78ac6c$var$extend(functionOrGetSet && $2f895839ac78ac6c$var$hasOwn(functionOrGetSet, "get") && typeof functionOrGetSet.get === "function" ? {
        get: functionOrGetSet.get,
        set: functionOrGetSet.set,
        configurable: true
    } : {
        value: functionOrGetSet,
        configurable: true,
        writable: true
    }, options));
}
function $2f895839ac78ac6c$var$derive(Child) {
    return {
        from: function(Parent) {
            Child.prototype = Object.create(Parent.prototype);
            $2f895839ac78ac6c$var$setProp(Child.prototype, "constructor", Child);
            return {
                extend: $2f895839ac78ac6c$var$props.bind(null, Child.prototype)
            };
        }
    };
}
var $2f895839ac78ac6c$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
function $2f895839ac78ac6c$var$getPropertyDescriptor(obj, prop) {
    var pd = $2f895839ac78ac6c$var$getOwnPropertyDescriptor(obj, prop);
    var proto;
    return pd || (proto = $2f895839ac78ac6c$var$getProto(obj)) && $2f895839ac78ac6c$var$getPropertyDescriptor(proto, prop);
}
var $2f895839ac78ac6c$var$_slice = [].slice;
function $2f895839ac78ac6c$var$slice(args, start, end) {
    return $2f895839ac78ac6c$var$_slice.call(args, start, end);
}
function $2f895839ac78ac6c$var$override(origFunc, overridedFactory) {
    return overridedFactory(origFunc);
}
function $2f895839ac78ac6c$var$assert(b) {
    if (!b) throw new Error("Assertion Failed");
}
function $2f895839ac78ac6c$var$asap$1(fn) {
    if ($2f895839ac78ac6c$var$_global.setImmediate) setImmediate(fn);
    else setTimeout(fn, 0);
}
function $2f895839ac78ac6c$var$arrayToObject(array, extractor) {
    return array.reduce(function(result, item, i) {
        var nameAndValue = extractor(item, i);
        if (nameAndValue) result[nameAndValue[0]] = nameAndValue[1];
        return result;
    }, {});
}
function $2f895839ac78ac6c$var$tryCatch(fn, onerror, args) {
    try {
        fn.apply(null, args);
    } catch (ex) {
        onerror && onerror(ex);
    }
}
function $2f895839ac78ac6c$var$getByKeyPath(obj, keyPath) {
    if (typeof keyPath === "string" && $2f895839ac78ac6c$var$hasOwn(obj, keyPath)) return obj[keyPath];
    if (!keyPath) return obj;
    if (typeof keyPath !== "string") {
        var rv = [];
        for(var i = 0, l = keyPath.length; i < l; ++i){
            var val = $2f895839ac78ac6c$var$getByKeyPath(obj, keyPath[i]);
            rv.push(val);
        }
        return rv;
    }
    var period = keyPath.indexOf(".");
    if (period !== -1) {
        var innerObj = obj[keyPath.substr(0, period)];
        return innerObj === undefined ? undefined : $2f895839ac78ac6c$var$getByKeyPath(innerObj, keyPath.substr(period + 1));
    }
    return undefined;
}
function $2f895839ac78ac6c$var$setByKeyPath(obj, keyPath, value) {
    if (!obj || keyPath === undefined) return;
    if ("isFrozen" in Object && Object.isFrozen(obj)) return;
    if (typeof keyPath !== "string" && "length" in keyPath) {
        $2f895839ac78ac6c$var$assert(typeof value !== "string" && "length" in value);
        for(var i = 0, l = keyPath.length; i < l; ++i)$2f895839ac78ac6c$var$setByKeyPath(obj, keyPath[i], value[i]);
    } else {
        var period = keyPath.indexOf(".");
        if (period !== -1) {
            var currentKeyPath = keyPath.substr(0, period);
            var remainingKeyPath = keyPath.substr(period + 1);
            if (remainingKeyPath === "") {
                if (value === undefined) {
                    if ($2f895839ac78ac6c$var$isArray(obj) && !isNaN(parseInt(currentKeyPath))) obj.splice(currentKeyPath, 1);
                    else delete obj[currentKeyPath];
                } else obj[currentKeyPath] = value;
            } else {
                var innerObj = obj[currentKeyPath];
                if (!innerObj || !$2f895839ac78ac6c$var$hasOwn(obj, currentKeyPath)) innerObj = obj[currentKeyPath] = {};
                $2f895839ac78ac6c$var$setByKeyPath(innerObj, remainingKeyPath, value);
            }
        } else if (value === undefined) {
            if ($2f895839ac78ac6c$var$isArray(obj) && !isNaN(parseInt(keyPath))) obj.splice(keyPath, 1);
            else delete obj[keyPath];
        } else obj[keyPath] = value;
    }
}
function $2f895839ac78ac6c$var$delByKeyPath(obj, keyPath) {
    if (typeof keyPath === "string") $2f895839ac78ac6c$var$setByKeyPath(obj, keyPath, undefined);
    else if ("length" in keyPath) [].map.call(keyPath, function(kp) {
        $2f895839ac78ac6c$var$setByKeyPath(obj, kp, undefined);
    });
}
function $2f895839ac78ac6c$var$shallowClone(obj) {
    var rv = {};
    for(var m in obj)if ($2f895839ac78ac6c$var$hasOwn(obj, m)) rv[m] = obj[m];
    return rv;
}
var $2f895839ac78ac6c$var$concat = [].concat;
function $2f895839ac78ac6c$var$flatten(a) {
    return $2f895839ac78ac6c$var$concat.apply([], a);
}
var $2f895839ac78ac6c$var$intrinsicTypeNames = "BigUint64Array,BigInt64Array,Array,Boolean,String,Date,RegExp,Blob,File,FileList,FileSystemFileHandle,FileSystemDirectoryHandle,ArrayBuffer,DataView,Uint8ClampedArray,ImageBitmap,ImageData,Map,Set,CryptoKey".split(",").concat($2f895839ac78ac6c$var$flatten([
    8,
    16,
    32,
    64
].map(function(num) {
    return [
        "Int",
        "Uint",
        "Float"
    ].map(function(t) {
        return t + num + "Array";
    });
}))).filter(function(t) {
    return $2f895839ac78ac6c$var$_global[t];
});
var $2f895839ac78ac6c$var$intrinsicTypes = $2f895839ac78ac6c$var$intrinsicTypeNames.map(function(t) {
    return $2f895839ac78ac6c$var$_global[t];
});
$2f895839ac78ac6c$var$arrayToObject($2f895839ac78ac6c$var$intrinsicTypeNames, function(x) {
    return [
        x,
        true
    ];
});
var $2f895839ac78ac6c$var$circularRefs = null;
function $2f895839ac78ac6c$var$deepClone(any) {
    $2f895839ac78ac6c$var$circularRefs = typeof WeakMap !== "undefined" && new WeakMap();
    var rv = $2f895839ac78ac6c$var$innerDeepClone(any);
    $2f895839ac78ac6c$var$circularRefs = null;
    return rv;
}
function $2f895839ac78ac6c$var$innerDeepClone(any) {
    if (!any || typeof any !== "object") return any;
    var rv = $2f895839ac78ac6c$var$circularRefs && $2f895839ac78ac6c$var$circularRefs.get(any);
    if (rv) return rv;
    if ($2f895839ac78ac6c$var$isArray(any)) {
        rv = [];
        $2f895839ac78ac6c$var$circularRefs && $2f895839ac78ac6c$var$circularRefs.set(any, rv);
        for(var i = 0, l = any.length; i < l; ++i)rv.push($2f895839ac78ac6c$var$innerDeepClone(any[i]));
    } else if ($2f895839ac78ac6c$var$intrinsicTypes.indexOf(any.constructor) >= 0) rv = any;
    else {
        var proto = $2f895839ac78ac6c$var$getProto(any);
        rv = proto === Object.prototype ? {} : Object.create(proto);
        $2f895839ac78ac6c$var$circularRefs && $2f895839ac78ac6c$var$circularRefs.set(any, rv);
        for(var prop in any)if ($2f895839ac78ac6c$var$hasOwn(any, prop)) rv[prop] = $2f895839ac78ac6c$var$innerDeepClone(any[prop]);
    }
    return rv;
}
var $2f895839ac78ac6c$var$toString = {}.toString;
function $2f895839ac78ac6c$var$toStringTag(o) {
    return $2f895839ac78ac6c$var$toString.call(o).slice(8, -1);
}
var $2f895839ac78ac6c$var$iteratorSymbol = typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
var $2f895839ac78ac6c$var$getIteratorOf = typeof $2f895839ac78ac6c$var$iteratorSymbol === "symbol" ? function(x) {
    var i;
    return x != null && (i = x[$2f895839ac78ac6c$var$iteratorSymbol]) && i.apply(x);
} : function() {
    return null;
};
var $2f895839ac78ac6c$var$NO_CHAR_ARRAY = {};
function $2f895839ac78ac6c$var$getArrayOf(arrayLike) {
    var i, a, x, it;
    if (arguments.length === 1) {
        if ($2f895839ac78ac6c$var$isArray(arrayLike)) return arrayLike.slice();
        if (this === $2f895839ac78ac6c$var$NO_CHAR_ARRAY && typeof arrayLike === "string") return [
            arrayLike
        ];
        if (it = $2f895839ac78ac6c$var$getIteratorOf(arrayLike)) {
            a = [];
            while(x = it.next(), !x.done)a.push(x.value);
            return a;
        }
        if (arrayLike == null) return [
            arrayLike
        ];
        i = arrayLike.length;
        if (typeof i === "number") {
            a = new Array(i);
            while(i--)a[i] = arrayLike[i];
            return a;
        }
        return [
            arrayLike
        ];
    }
    i = arguments.length;
    a = new Array(i);
    while(i--)a[i] = arguments[i];
    return a;
}
var $2f895839ac78ac6c$var$isAsyncFunction = typeof Symbol !== "undefined" ? function(fn) {
    return fn[Symbol.toStringTag] === "AsyncFunction";
} : function() {
    return false;
};
var $2f895839ac78ac6c$var$debug = typeof location !== "undefined" && /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);
function $2f895839ac78ac6c$var$setDebug(value, filter) {
    $2f895839ac78ac6c$var$debug = value;
    $2f895839ac78ac6c$var$libraryFilter = filter;
}
var $2f895839ac78ac6c$var$libraryFilter = function() {
    return true;
};
var $2f895839ac78ac6c$var$NEEDS_THROW_FOR_STACK = !new Error("").stack;
function $2f895839ac78ac6c$var$getErrorWithStack() {
    if ($2f895839ac78ac6c$var$NEEDS_THROW_FOR_STACK) try {
        $2f895839ac78ac6c$var$getErrorWithStack.arguments;
        throw new Error();
    } catch (e) {
        return e;
    }
    return new Error();
}
function $2f895839ac78ac6c$var$prettyStack(exception, numIgnoredFrames) {
    var stack = exception.stack;
    if (!stack) return "";
    numIgnoredFrames = numIgnoredFrames || 0;
    if (stack.indexOf(exception.name) === 0) numIgnoredFrames += (exception.name + exception.message).split("\n").length;
    return stack.split("\n").slice(numIgnoredFrames).filter($2f895839ac78ac6c$var$libraryFilter).map(function(frame) {
        return "\n" + frame;
    }).join("");
}
var $2f895839ac78ac6c$var$dexieErrorNames = [
    "Modify",
    "Bulk",
    "OpenFailed",
    "VersionChange",
    "Schema",
    "Upgrade",
    "InvalidTable",
    "MissingAPI",
    "NoSuchDatabase",
    "InvalidArgument",
    "SubTransaction",
    "Unsupported",
    "Internal",
    "DatabaseClosed",
    "PrematureCommit",
    "ForeignAwait"
];
var $2f895839ac78ac6c$var$idbDomErrorNames = [
    "Unknown",
    "Constraint",
    "Data",
    "TransactionInactive",
    "ReadOnly",
    "Version",
    "NotFound",
    "InvalidState",
    "InvalidAccess",
    "Abort",
    "Timeout",
    "QuotaExceeded",
    "Syntax",
    "DataClone"
];
var $2f895839ac78ac6c$var$errorList = $2f895839ac78ac6c$var$dexieErrorNames.concat($2f895839ac78ac6c$var$idbDomErrorNames);
var $2f895839ac78ac6c$var$defaultTexts = {
    VersionChanged: "Database version changed by other database connection",
    DatabaseClosed: "Database has been closed",
    Abort: "Transaction aborted",
    TransactionInactive: "Transaction has already completed or failed",
    MissingAPI: "IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb"
};
function $2f895839ac78ac6c$var$DexieError(name, msg) {
    this._e = $2f895839ac78ac6c$var$getErrorWithStack();
    this.name = name;
    this.message = msg;
}
$2f895839ac78ac6c$var$derive($2f895839ac78ac6c$var$DexieError).from(Error).extend({
    stack: {
        get: function() {
            return this._stack || (this._stack = this.name + ": " + this.message + $2f895839ac78ac6c$var$prettyStack(this._e, 2));
        }
    },
    toString: function() {
        return this.name + ": " + this.message;
    }
});
function $2f895839ac78ac6c$var$getMultiErrorMessage(msg, failures) {
    return msg + ". Errors: " + Object.keys(failures).map(function(key) {
        return failures[key].toString();
    }).filter(function(v, i, s) {
        return s.indexOf(v) === i;
    }).join("\n");
}
function $2f895839ac78ac6c$var$ModifyError(msg, failures, successCount, failedKeys) {
    this._e = $2f895839ac78ac6c$var$getErrorWithStack();
    this.failures = failures;
    this.failedKeys = failedKeys;
    this.successCount = successCount;
    this.message = $2f895839ac78ac6c$var$getMultiErrorMessage(msg, failures);
}
$2f895839ac78ac6c$var$derive($2f895839ac78ac6c$var$ModifyError).from($2f895839ac78ac6c$var$DexieError);
function $2f895839ac78ac6c$var$BulkError(msg, failures) {
    this._e = $2f895839ac78ac6c$var$getErrorWithStack();
    this.name = "BulkError";
    this.failures = Object.keys(failures).map(function(pos) {
        return failures[pos];
    });
    this.failuresByPos = failures;
    this.message = $2f895839ac78ac6c$var$getMultiErrorMessage(msg, failures);
}
$2f895839ac78ac6c$var$derive($2f895839ac78ac6c$var$BulkError).from($2f895839ac78ac6c$var$DexieError);
var $2f895839ac78ac6c$var$errnames = $2f895839ac78ac6c$var$errorList.reduce(function(obj, name) {
    return obj[name] = name + "Error", obj;
}, {});
var $2f895839ac78ac6c$var$BaseException = $2f895839ac78ac6c$var$DexieError;
var $2f895839ac78ac6c$var$exceptions = $2f895839ac78ac6c$var$errorList.reduce(function(obj, name) {
    var fullName = name + "Error";
    function DexieError(msgOrInner, inner) {
        this._e = $2f895839ac78ac6c$var$getErrorWithStack();
        this.name = fullName;
        if (!msgOrInner) {
            this.message = $2f895839ac78ac6c$var$defaultTexts[name] || fullName;
            this.inner = null;
        } else if (typeof msgOrInner === "string") {
            this.message = "" + msgOrInner + (!inner ? "" : "\n " + inner);
            this.inner = inner || null;
        } else if (typeof msgOrInner === "object") {
            this.message = msgOrInner.name + " " + msgOrInner.message;
            this.inner = msgOrInner;
        }
    }
    $2f895839ac78ac6c$var$derive(DexieError).from($2f895839ac78ac6c$var$BaseException);
    obj[name] = DexieError;
    return obj;
}, {});
$2f895839ac78ac6c$var$exceptions.Syntax = SyntaxError;
$2f895839ac78ac6c$var$exceptions.Type = TypeError;
$2f895839ac78ac6c$var$exceptions.Range = RangeError;
var $2f895839ac78ac6c$var$exceptionMap = $2f895839ac78ac6c$var$idbDomErrorNames.reduce(function(obj, name) {
    obj[name + "Error"] = $2f895839ac78ac6c$var$exceptions[name];
    return obj;
}, {});
function $2f895839ac78ac6c$var$mapError(domError, message) {
    if (!domError || domError instanceof $2f895839ac78ac6c$var$DexieError || domError instanceof TypeError || domError instanceof SyntaxError || !domError.name || !$2f895839ac78ac6c$var$exceptionMap[domError.name]) return domError;
    var rv = new $2f895839ac78ac6c$var$exceptionMap[domError.name](message || domError.message, domError);
    if ("stack" in domError) $2f895839ac78ac6c$var$setProp(rv, "stack", {
        get: function() {
            return this.inner.stack;
        }
    });
    return rv;
}
var $2f895839ac78ac6c$var$fullNameExceptions = $2f895839ac78ac6c$var$errorList.reduce(function(obj, name) {
    if ([
        "Syntax",
        "Type",
        "Range"
    ].indexOf(name) === -1) obj[name + "Error"] = $2f895839ac78ac6c$var$exceptions[name];
    return obj;
}, {});
$2f895839ac78ac6c$var$fullNameExceptions.ModifyError = $2f895839ac78ac6c$var$ModifyError;
$2f895839ac78ac6c$var$fullNameExceptions.DexieError = $2f895839ac78ac6c$var$DexieError;
$2f895839ac78ac6c$var$fullNameExceptions.BulkError = $2f895839ac78ac6c$var$BulkError;
function $2f895839ac78ac6c$var$nop() {}
function $2f895839ac78ac6c$var$mirror(val) {
    return val;
}
function $2f895839ac78ac6c$var$pureFunctionChain(f1, f2) {
    if (f1 == null || f1 === $2f895839ac78ac6c$var$mirror) return f2;
    return function(val) {
        return f2(f1(val));
    };
}
function $2f895839ac78ac6c$var$callBoth(on1, on2) {
    return function() {
        on1.apply(this, arguments);
        on2.apply(this, arguments);
    };
}
function $2f895839ac78ac6c$var$hookCreatingChain(f1, f2) {
    if (f1 === $2f895839ac78ac6c$var$nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res !== undefined) arguments[0] = res;
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $2f895839ac78ac6c$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $2f895839ac78ac6c$var$callBoth(onerror, this.onerror) : onerror;
        return res2 !== undefined ? res2 : res;
    };
}
function $2f895839ac78ac6c$var$hookDeletingChain(f1, f2) {
    if (f1 === $2f895839ac78ac6c$var$nop) return f2;
    return function() {
        f1.apply(this, arguments);
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = this.onerror = null;
        f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $2f895839ac78ac6c$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $2f895839ac78ac6c$var$callBoth(onerror, this.onerror) : onerror;
    };
}
function $2f895839ac78ac6c$var$hookUpdatingChain(f1, f2) {
    if (f1 === $2f895839ac78ac6c$var$nop) return f2;
    return function(modifications) {
        var res = f1.apply(this, arguments);
        $2f895839ac78ac6c$var$extend(modifications, res);
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $2f895839ac78ac6c$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $2f895839ac78ac6c$var$callBoth(onerror, this.onerror) : onerror;
        return res === undefined ? res2 === undefined ? undefined : res2 : $2f895839ac78ac6c$var$extend(res, res2);
    };
}
function $2f895839ac78ac6c$var$reverseStoppableEventChain(f1, f2) {
    if (f1 === $2f895839ac78ac6c$var$nop) return f2;
    return function() {
        if (f2.apply(this, arguments) === false) return false;
        return f1.apply(this, arguments);
    };
}
function $2f895839ac78ac6c$var$promisableChain(f1, f2) {
    if (f1 === $2f895839ac78ac6c$var$nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res && typeof res.then === "function") {
            var thiz = this, i = arguments.length, args = new Array(i);
            while(i--)args[i] = arguments[i];
            return res.then(function() {
                return f2.apply(thiz, args);
            });
        }
        return f2.apply(this, arguments);
    };
}
var $2f895839ac78ac6c$var$INTERNAL = {};
var $2f895839ac78ac6c$var$LONG_STACKS_CLIP_LIMIT = 100, $2f895839ac78ac6c$var$MAX_LONG_STACKS = 20, $2f895839ac78ac6c$var$ZONE_ECHO_LIMIT = 100, $2f895839ac78ac6c$var$_a$1 = typeof Promise === "undefined" ? [] : function() {
    var globalP = Promise.resolve();
    if (typeof crypto === "undefined" || !crypto.subtle) return [
        globalP,
        $2f895839ac78ac6c$var$getProto(globalP),
        globalP
    ];
    var nativeP = crypto.subtle.digest("SHA-512", new Uint8Array([
        0
    ]));
    return [
        nativeP,
        $2f895839ac78ac6c$var$getProto(nativeP),
        globalP
    ];
}(), $2f895839ac78ac6c$var$resolvedNativePromise = $2f895839ac78ac6c$var$_a$1[0], $2f895839ac78ac6c$var$nativePromiseProto = $2f895839ac78ac6c$var$_a$1[1], $2f895839ac78ac6c$var$resolvedGlobalPromise = $2f895839ac78ac6c$var$_a$1[2], $2f895839ac78ac6c$var$nativePromiseThen = $2f895839ac78ac6c$var$nativePromiseProto && $2f895839ac78ac6c$var$nativePromiseProto.then;
var $2f895839ac78ac6c$var$NativePromise = $2f895839ac78ac6c$var$resolvedNativePromise && $2f895839ac78ac6c$var$resolvedNativePromise.constructor;
var $2f895839ac78ac6c$var$patchGlobalPromise = !!$2f895839ac78ac6c$var$resolvedGlobalPromise;
var $2f895839ac78ac6c$var$stack_being_generated = false;
var $2f895839ac78ac6c$var$schedulePhysicalTick = $2f895839ac78ac6c$var$resolvedGlobalPromise ? function() {
    $2f895839ac78ac6c$var$resolvedGlobalPromise.then($2f895839ac78ac6c$var$physicalTick);
} : $2f895839ac78ac6c$var$_global.setImmediate ? setImmediate.bind(null, $2f895839ac78ac6c$var$physicalTick) : $2f895839ac78ac6c$var$_global.MutationObserver ? function() {
    var hiddenDiv = document.createElement("div");
    new MutationObserver(function() {
        $2f895839ac78ac6c$var$physicalTick();
        hiddenDiv = null;
    }).observe(hiddenDiv, {
        attributes: true
    });
    hiddenDiv.setAttribute("i", "1");
} : function() {
    setTimeout($2f895839ac78ac6c$var$physicalTick, 0);
};
var $2f895839ac78ac6c$var$asap = function(callback, args) {
    $2f895839ac78ac6c$var$microtickQueue.push([
        callback,
        args
    ]);
    if ($2f895839ac78ac6c$var$needsNewPhysicalTick) {
        $2f895839ac78ac6c$var$schedulePhysicalTick();
        $2f895839ac78ac6c$var$needsNewPhysicalTick = false;
    }
};
var $2f895839ac78ac6c$var$isOutsideMicroTick = true, $2f895839ac78ac6c$var$needsNewPhysicalTick = true, $2f895839ac78ac6c$var$unhandledErrors = [], $2f895839ac78ac6c$var$rejectingErrors = [], $2f895839ac78ac6c$var$currentFulfiller = null, $2f895839ac78ac6c$var$rejectionMapper = $2f895839ac78ac6c$var$mirror;
var $2f895839ac78ac6c$var$globalPSD = {
    id: "global",
    global: true,
    ref: 0,
    unhandleds: [],
    onunhandled: $2f895839ac78ac6c$var$globalError,
    pgp: false,
    env: {},
    finalize: function() {
        this.unhandleds.forEach(function(uh) {
            try {
                $2f895839ac78ac6c$var$globalError(uh[0], uh[1]);
            } catch (e) {}
        });
    }
};
var $2f895839ac78ac6c$var$PSD = $2f895839ac78ac6c$var$globalPSD;
var $2f895839ac78ac6c$var$microtickQueue = [];
var $2f895839ac78ac6c$var$numScheduledCalls = 0;
var $2f895839ac78ac6c$var$tickFinalizers = [];
function $2f895839ac78ac6c$var$DexiePromise(fn) {
    if (typeof this !== "object") throw new TypeError("Promises must be constructed via new");
    this._listeners = [];
    this.onuncatched = $2f895839ac78ac6c$var$nop;
    this._lib = false;
    var psd = this._PSD = $2f895839ac78ac6c$var$PSD;
    if ($2f895839ac78ac6c$var$debug) {
        this._stackHolder = $2f895839ac78ac6c$var$getErrorWithStack();
        this._prev = null;
        this._numPrev = 0;
    }
    if (typeof fn !== "function") {
        if (fn !== $2f895839ac78ac6c$var$INTERNAL) throw new TypeError("Not a function");
        this._state = arguments[1];
        this._value = arguments[2];
        if (this._state === false) $2f895839ac78ac6c$var$handleRejection(this, this._value);
        return;
    }
    this._state = null;
    this._value = null;
    ++psd.ref;
    $2f895839ac78ac6c$var$executePromiseTask(this, fn);
}
var $2f895839ac78ac6c$var$thenProp = {
    get: function() {
        var psd = $2f895839ac78ac6c$var$PSD, microTaskId = $2f895839ac78ac6c$var$totalEchoes;
        function then(onFulfilled, onRejected) {
            var _this = this;
            var possibleAwait = !psd.global && (psd !== $2f895839ac78ac6c$var$PSD || microTaskId !== $2f895839ac78ac6c$var$totalEchoes);
            var cleanup = possibleAwait && !$2f895839ac78ac6c$var$decrementExpectedAwaits();
            var rv = new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
                $2f895839ac78ac6c$var$propagateToListener(_this, new $2f895839ac78ac6c$var$Listener($2f895839ac78ac6c$var$nativeAwaitCompatibleWrap(onFulfilled, psd, possibleAwait, cleanup), $2f895839ac78ac6c$var$nativeAwaitCompatibleWrap(onRejected, psd, possibleAwait, cleanup), resolve, reject, psd));
            });
            $2f895839ac78ac6c$var$debug && $2f895839ac78ac6c$var$linkToPreviousPromise(rv, this);
            return rv;
        }
        then.prototype = $2f895839ac78ac6c$var$INTERNAL;
        return then;
    },
    set: function(value) {
        $2f895839ac78ac6c$var$setProp(this, "then", value && value.prototype === $2f895839ac78ac6c$var$INTERNAL ? $2f895839ac78ac6c$var$thenProp : {
            get: function() {
                return value;
            },
            set: $2f895839ac78ac6c$var$thenProp.set
        });
    }
};
$2f895839ac78ac6c$var$props($2f895839ac78ac6c$var$DexiePromise.prototype, {
    then: $2f895839ac78ac6c$var$thenProp,
    _then: function(onFulfilled, onRejected) {
        $2f895839ac78ac6c$var$propagateToListener(this, new $2f895839ac78ac6c$var$Listener(null, null, onFulfilled, onRejected, $2f895839ac78ac6c$var$PSD));
    },
    catch: function(onRejected) {
        if (arguments.length === 1) return this.then(null, onRejected);
        var type = arguments[0], handler = arguments[1];
        return typeof type === "function" ? this.then(null, function(err) {
            return err instanceof type ? handler(err) : $2f895839ac78ac6c$var$PromiseReject(err);
        }) : this.then(null, function(err) {
            return err && err.name === type ? handler(err) : $2f895839ac78ac6c$var$PromiseReject(err);
        });
    },
    finally: function(onFinally) {
        return this.then(function(value) {
            onFinally();
            return value;
        }, function(err) {
            onFinally();
            return $2f895839ac78ac6c$var$PromiseReject(err);
        });
    },
    stack: {
        get: function() {
            if (this._stack) return this._stack;
            try {
                $2f895839ac78ac6c$var$stack_being_generated = true;
                var stacks = $2f895839ac78ac6c$var$getStack(this, [], $2f895839ac78ac6c$var$MAX_LONG_STACKS);
                var stack = stacks.join("\nFrom previous: ");
                if (this._state !== null) this._stack = stack;
                return stack;
            } finally{
                $2f895839ac78ac6c$var$stack_being_generated = false;
            }
        }
    },
    timeout: function(ms, msg) {
        var _this = this;
        return ms < Infinity ? new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            var handle = setTimeout(function() {
                return reject(new $2f895839ac78ac6c$var$exceptions.Timeout(msg));
            }, ms);
            _this.then(resolve, reject).finally(clearTimeout.bind(null, handle));
        }) : this;
    }
});
if (typeof Symbol !== "undefined" && Symbol.toStringTag) $2f895839ac78ac6c$var$setProp($2f895839ac78ac6c$var$DexiePromise.prototype, Symbol.toStringTag, "Dexie.Promise");
$2f895839ac78ac6c$var$globalPSD.env = $2f895839ac78ac6c$var$snapShot();
function $2f895839ac78ac6c$var$Listener(onFulfilled, onRejected, resolve, reject, zone) {
    this.onFulfilled = typeof onFulfilled === "function" ? onFulfilled : null;
    this.onRejected = typeof onRejected === "function" ? onRejected : null;
    this.resolve = resolve;
    this.reject = reject;
    this.psd = zone;
}
$2f895839ac78ac6c$var$props($2f895839ac78ac6c$var$DexiePromise, {
    all: function() {
        var values = $2f895839ac78ac6c$var$getArrayOf.apply(null, arguments).map($2f895839ac78ac6c$var$onPossibleParallellAsync);
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            if (values.length === 0) resolve([]);
            var remaining = values.length;
            values.forEach(function(a, i) {
                return $2f895839ac78ac6c$var$DexiePromise.resolve(a).then(function(x) {
                    values[i] = x;
                    if (!--remaining) resolve(values);
                }, reject);
            });
        });
    },
    resolve: function(value) {
        if (value instanceof $2f895839ac78ac6c$var$DexiePromise) return value;
        if (value && typeof value.then === "function") return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            value.then(resolve, reject);
        });
        var rv = new $2f895839ac78ac6c$var$DexiePromise($2f895839ac78ac6c$var$INTERNAL, true, value);
        $2f895839ac78ac6c$var$linkToPreviousPromise(rv, $2f895839ac78ac6c$var$currentFulfiller);
        return rv;
    },
    reject: $2f895839ac78ac6c$var$PromiseReject,
    race: function() {
        var values = $2f895839ac78ac6c$var$getArrayOf.apply(null, arguments).map($2f895839ac78ac6c$var$onPossibleParallellAsync);
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            values.map(function(value) {
                return $2f895839ac78ac6c$var$DexiePromise.resolve(value).then(resolve, reject);
            });
        });
    },
    PSD: {
        get: function() {
            return $2f895839ac78ac6c$var$PSD;
        },
        set: function(value) {
            return $2f895839ac78ac6c$var$PSD = value;
        }
    },
    totalEchoes: {
        get: function() {
            return $2f895839ac78ac6c$var$totalEchoes;
        }
    },
    newPSD: $2f895839ac78ac6c$var$newScope,
    usePSD: $2f895839ac78ac6c$var$usePSD,
    scheduler: {
        get: function() {
            return $2f895839ac78ac6c$var$asap;
        },
        set: function(value) {
            $2f895839ac78ac6c$var$asap = value;
        }
    },
    rejectionMapper: {
        get: function() {
            return $2f895839ac78ac6c$var$rejectionMapper;
        },
        set: function(value) {
            $2f895839ac78ac6c$var$rejectionMapper = value;
        }
    },
    follow: function(fn, zoneProps) {
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            return $2f895839ac78ac6c$var$newScope(function(resolve, reject) {
                var psd = $2f895839ac78ac6c$var$PSD;
                psd.unhandleds = [];
                psd.onunhandled = reject;
                psd.finalize = $2f895839ac78ac6c$var$callBoth(function() {
                    var _this = this;
                    $2f895839ac78ac6c$var$run_at_end_of_this_or_next_physical_tick(function() {
                        _this.unhandleds.length === 0 ? resolve() : reject(_this.unhandleds[0]);
                    });
                }, psd.finalize);
                fn();
            }, zoneProps, resolve, reject);
        });
    }
});
if ($2f895839ac78ac6c$var$NativePromise) {
    if ($2f895839ac78ac6c$var$NativePromise.allSettled) $2f895839ac78ac6c$var$setProp($2f895839ac78ac6c$var$DexiePromise, "allSettled", function() {
        var possiblePromises = $2f895839ac78ac6c$var$getArrayOf.apply(null, arguments).map($2f895839ac78ac6c$var$onPossibleParallellAsync);
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve) {
            if (possiblePromises.length === 0) resolve([]);
            var remaining = possiblePromises.length;
            var results = new Array(remaining);
            possiblePromises.forEach(function(p, i) {
                return $2f895839ac78ac6c$var$DexiePromise.resolve(p).then(function(value) {
                    return results[i] = {
                        status: "fulfilled",
                        value: value
                    };
                }, function(reason) {
                    return results[i] = {
                        status: "rejected",
                        reason: reason
                    };
                }).then(function() {
                    return --remaining || resolve(results);
                });
            });
        });
    });
    if ($2f895839ac78ac6c$var$NativePromise.any && typeof AggregateError !== "undefined") $2f895839ac78ac6c$var$setProp($2f895839ac78ac6c$var$DexiePromise, "any", function() {
        var possiblePromises = $2f895839ac78ac6c$var$getArrayOf.apply(null, arguments).map($2f895839ac78ac6c$var$onPossibleParallellAsync);
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            if (possiblePromises.length === 0) reject(new AggregateError([]));
            var remaining = possiblePromises.length;
            var failures = new Array(remaining);
            possiblePromises.forEach(function(p, i) {
                return $2f895839ac78ac6c$var$DexiePromise.resolve(p).then(function(value) {
                    return resolve(value);
                }, function(failure) {
                    failures[i] = failure;
                    if (!--remaining) reject(new AggregateError(failures));
                });
            });
        });
    });
}
function $2f895839ac78ac6c$var$executePromiseTask(promise, fn) {
    try {
        fn(function(value) {
            if (promise._state !== null) return;
            if (value === promise) throw new TypeError("A promise cannot be resolved with itself.");
            var shouldExecuteTick = promise._lib && $2f895839ac78ac6c$var$beginMicroTickScope();
            if (value && typeof value.then === "function") $2f895839ac78ac6c$var$executePromiseTask(promise, function(resolve, reject) {
                value instanceof $2f895839ac78ac6c$var$DexiePromise ? value._then(resolve, reject) : value.then(resolve, reject);
            });
            else {
                promise._state = true;
                promise._value = value;
                $2f895839ac78ac6c$var$propagateAllListeners(promise);
            }
            if (shouldExecuteTick) $2f895839ac78ac6c$var$endMicroTickScope();
        }, $2f895839ac78ac6c$var$handleRejection.bind(null, promise));
    } catch (ex) {
        $2f895839ac78ac6c$var$handleRejection(promise, ex);
    }
}
function $2f895839ac78ac6c$var$handleRejection(promise, reason) {
    $2f895839ac78ac6c$var$rejectingErrors.push(reason);
    if (promise._state !== null) return;
    var shouldExecuteTick = promise._lib && $2f895839ac78ac6c$var$beginMicroTickScope();
    reason = $2f895839ac78ac6c$var$rejectionMapper(reason);
    promise._state = false;
    promise._value = reason;
    $2f895839ac78ac6c$var$debug && reason !== null && typeof reason === "object" && !reason._promise && $2f895839ac78ac6c$var$tryCatch(function() {
        var origProp = $2f895839ac78ac6c$var$getPropertyDescriptor(reason, "stack");
        reason._promise = promise;
        $2f895839ac78ac6c$var$setProp(reason, "stack", {
            get: function() {
                return $2f895839ac78ac6c$var$stack_being_generated ? origProp && (origProp.get ? origProp.get.apply(reason) : origProp.value) : promise.stack;
            }
        });
    });
    $2f895839ac78ac6c$var$addPossiblyUnhandledError(promise);
    $2f895839ac78ac6c$var$propagateAllListeners(promise);
    if (shouldExecuteTick) $2f895839ac78ac6c$var$endMicroTickScope();
}
function $2f895839ac78ac6c$var$propagateAllListeners(promise) {
    var listeners = promise._listeners;
    promise._listeners = [];
    for(var i = 0, len = listeners.length; i < len; ++i)$2f895839ac78ac6c$var$propagateToListener(promise, listeners[i]);
    var psd = promise._PSD;
    --psd.ref || psd.finalize();
    if ($2f895839ac78ac6c$var$numScheduledCalls === 0) {
        ++$2f895839ac78ac6c$var$numScheduledCalls;
        $2f895839ac78ac6c$var$asap(function() {
            if (--$2f895839ac78ac6c$var$numScheduledCalls === 0) $2f895839ac78ac6c$var$finalizePhysicalTick();
        }, []);
    }
}
function $2f895839ac78ac6c$var$propagateToListener(promise, listener) {
    if (promise._state === null) {
        promise._listeners.push(listener);
        return;
    }
    var cb = promise._state ? listener.onFulfilled : listener.onRejected;
    if (cb === null) return (promise._state ? listener.resolve : listener.reject)(promise._value);
    ++listener.psd.ref;
    ++$2f895839ac78ac6c$var$numScheduledCalls;
    $2f895839ac78ac6c$var$asap($2f895839ac78ac6c$var$callListener, [
        cb,
        promise,
        listener
    ]);
}
function $2f895839ac78ac6c$var$callListener(cb, promise, listener) {
    try {
        $2f895839ac78ac6c$var$currentFulfiller = promise;
        var ret, value = promise._value;
        if (promise._state) ret = cb(value);
        else {
            if ($2f895839ac78ac6c$var$rejectingErrors.length) $2f895839ac78ac6c$var$rejectingErrors = [];
            ret = cb(value);
            if ($2f895839ac78ac6c$var$rejectingErrors.indexOf(value) === -1) $2f895839ac78ac6c$var$markErrorAsHandled(promise);
        }
        listener.resolve(ret);
    } catch (e) {
        listener.reject(e);
    } finally{
        $2f895839ac78ac6c$var$currentFulfiller = null;
        if (--$2f895839ac78ac6c$var$numScheduledCalls === 0) $2f895839ac78ac6c$var$finalizePhysicalTick();
        --listener.psd.ref || listener.psd.finalize();
    }
}
function $2f895839ac78ac6c$var$getStack(promise, stacks, limit) {
    if (stacks.length === limit) return stacks;
    var stack = "";
    if (promise._state === false) {
        var failure = promise._value, errorName, message;
        if (failure != null) {
            errorName = failure.name || "Error";
            message = failure.message || failure;
            stack = $2f895839ac78ac6c$var$prettyStack(failure, 0);
        } else {
            errorName = failure;
            message = "";
        }
        stacks.push(errorName + (message ? ": " + message : "") + stack);
    }
    if ($2f895839ac78ac6c$var$debug) {
        stack = $2f895839ac78ac6c$var$prettyStack(promise._stackHolder, 2);
        if (stack && stacks.indexOf(stack) === -1) stacks.push(stack);
        if (promise._prev) $2f895839ac78ac6c$var$getStack(promise._prev, stacks, limit);
    }
    return stacks;
}
function $2f895839ac78ac6c$var$linkToPreviousPromise(promise, prev) {
    var numPrev = prev ? prev._numPrev + 1 : 0;
    if (numPrev < $2f895839ac78ac6c$var$LONG_STACKS_CLIP_LIMIT) {
        promise._prev = prev;
        promise._numPrev = numPrev;
    }
}
function $2f895839ac78ac6c$var$physicalTick() {
    $2f895839ac78ac6c$var$beginMicroTickScope() && $2f895839ac78ac6c$var$endMicroTickScope();
}
function $2f895839ac78ac6c$var$beginMicroTickScope() {
    var wasRootExec = $2f895839ac78ac6c$var$isOutsideMicroTick;
    $2f895839ac78ac6c$var$isOutsideMicroTick = false;
    $2f895839ac78ac6c$var$needsNewPhysicalTick = false;
    return wasRootExec;
}
function $2f895839ac78ac6c$var$endMicroTickScope() {
    var callbacks, i, l;
    do while($2f895839ac78ac6c$var$microtickQueue.length > 0){
        callbacks = $2f895839ac78ac6c$var$microtickQueue;
        $2f895839ac78ac6c$var$microtickQueue = [];
        l = callbacks.length;
        for(i = 0; i < l; ++i){
            var item = callbacks[i];
            item[0].apply(null, item[1]);
        }
    }
    while ($2f895839ac78ac6c$var$microtickQueue.length > 0);
    $2f895839ac78ac6c$var$isOutsideMicroTick = true;
    $2f895839ac78ac6c$var$needsNewPhysicalTick = true;
}
function $2f895839ac78ac6c$var$finalizePhysicalTick() {
    var unhandledErrs = $2f895839ac78ac6c$var$unhandledErrors;
    $2f895839ac78ac6c$var$unhandledErrors = [];
    unhandledErrs.forEach(function(p) {
        p._PSD.onunhandled.call(null, p._value, p);
    });
    var finalizers = $2f895839ac78ac6c$var$tickFinalizers.slice(0);
    var i = finalizers.length;
    while(i)finalizers[--i]();
}
function $2f895839ac78ac6c$var$run_at_end_of_this_or_next_physical_tick(fn) {
    function finalizer() {
        fn();
        $2f895839ac78ac6c$var$tickFinalizers.splice($2f895839ac78ac6c$var$tickFinalizers.indexOf(finalizer), 1);
    }
    $2f895839ac78ac6c$var$tickFinalizers.push(finalizer);
    ++$2f895839ac78ac6c$var$numScheduledCalls;
    $2f895839ac78ac6c$var$asap(function() {
        if (--$2f895839ac78ac6c$var$numScheduledCalls === 0) $2f895839ac78ac6c$var$finalizePhysicalTick();
    }, []);
}
function $2f895839ac78ac6c$var$addPossiblyUnhandledError(promise) {
    if (!$2f895839ac78ac6c$var$unhandledErrors.some(function(p) {
        return p._value === promise._value;
    })) $2f895839ac78ac6c$var$unhandledErrors.push(promise);
}
function $2f895839ac78ac6c$var$markErrorAsHandled(promise) {
    var i = $2f895839ac78ac6c$var$unhandledErrors.length;
    while(i)if ($2f895839ac78ac6c$var$unhandledErrors[--i]._value === promise._value) {
        $2f895839ac78ac6c$var$unhandledErrors.splice(i, 1);
        return;
    }
}
function $2f895839ac78ac6c$var$PromiseReject(reason) {
    return new $2f895839ac78ac6c$var$DexiePromise($2f895839ac78ac6c$var$INTERNAL, false, reason);
}
function $2f895839ac78ac6c$var$wrap(fn, errorCatcher) {
    var psd = $2f895839ac78ac6c$var$PSD;
    return function() {
        var wasRootExec = $2f895839ac78ac6c$var$beginMicroTickScope(), outerScope = $2f895839ac78ac6c$var$PSD;
        try {
            $2f895839ac78ac6c$var$switchToZone(psd, true);
            return fn.apply(this, arguments);
        } catch (e) {
            errorCatcher && errorCatcher(e);
        } finally{
            $2f895839ac78ac6c$var$switchToZone(outerScope, false);
            if (wasRootExec) $2f895839ac78ac6c$var$endMicroTickScope();
        }
    };
}
var $2f895839ac78ac6c$var$task = {
    awaits: 0,
    echoes: 0,
    id: 0
};
var $2f895839ac78ac6c$var$taskCounter = 0;
var $2f895839ac78ac6c$var$zoneStack = [];
var $2f895839ac78ac6c$var$zoneEchoes = 0;
var $2f895839ac78ac6c$var$totalEchoes = 0;
var $2f895839ac78ac6c$var$zone_id_counter = 0;
function $2f895839ac78ac6c$var$newScope(fn, props, a1, a2) {
    var parent = $2f895839ac78ac6c$var$PSD, psd = Object.create(parent);
    psd.parent = parent;
    psd.ref = 0;
    psd.global = false;
    psd.id = ++$2f895839ac78ac6c$var$zone_id_counter;
    var globalEnv = $2f895839ac78ac6c$var$globalPSD.env;
    psd.env = $2f895839ac78ac6c$var$patchGlobalPromise ? {
        Promise: $2f895839ac78ac6c$var$DexiePromise,
        PromiseProp: {
            value: $2f895839ac78ac6c$var$DexiePromise,
            configurable: true,
            writable: true
        },
        all: $2f895839ac78ac6c$var$DexiePromise.all,
        race: $2f895839ac78ac6c$var$DexiePromise.race,
        allSettled: $2f895839ac78ac6c$var$DexiePromise.allSettled,
        any: $2f895839ac78ac6c$var$DexiePromise.any,
        resolve: $2f895839ac78ac6c$var$DexiePromise.resolve,
        reject: $2f895839ac78ac6c$var$DexiePromise.reject,
        nthen: $2f895839ac78ac6c$var$getPatchedPromiseThen(globalEnv.nthen, psd),
        gthen: $2f895839ac78ac6c$var$getPatchedPromiseThen(globalEnv.gthen, psd)
    } : {};
    if (props) $2f895839ac78ac6c$var$extend(psd, props);
    ++parent.ref;
    psd.finalize = function() {
        --this.parent.ref || this.parent.finalize();
    };
    var rv = $2f895839ac78ac6c$var$usePSD(psd, fn, a1, a2);
    if (psd.ref === 0) psd.finalize();
    return rv;
}
function $2f895839ac78ac6c$var$incrementExpectedAwaits() {
    if (!$2f895839ac78ac6c$var$task.id) $2f895839ac78ac6c$var$task.id = ++$2f895839ac78ac6c$var$taskCounter;
    ++$2f895839ac78ac6c$var$task.awaits;
    $2f895839ac78ac6c$var$task.echoes += $2f895839ac78ac6c$var$ZONE_ECHO_LIMIT;
    return $2f895839ac78ac6c$var$task.id;
}
function $2f895839ac78ac6c$var$decrementExpectedAwaits() {
    if (!$2f895839ac78ac6c$var$task.awaits) return false;
    if (--$2f895839ac78ac6c$var$task.awaits === 0) $2f895839ac78ac6c$var$task.id = 0;
    $2f895839ac78ac6c$var$task.echoes = $2f895839ac78ac6c$var$task.awaits * $2f895839ac78ac6c$var$ZONE_ECHO_LIMIT;
    return true;
}
if (("" + $2f895839ac78ac6c$var$nativePromiseThen).indexOf("[native code]") === -1) $2f895839ac78ac6c$var$incrementExpectedAwaits = $2f895839ac78ac6c$var$decrementExpectedAwaits = $2f895839ac78ac6c$var$nop;
function $2f895839ac78ac6c$var$onPossibleParallellAsync(possiblePromise) {
    if ($2f895839ac78ac6c$var$task.echoes && possiblePromise && possiblePromise.constructor === $2f895839ac78ac6c$var$NativePromise) {
        $2f895839ac78ac6c$var$incrementExpectedAwaits();
        return possiblePromise.then(function(x) {
            $2f895839ac78ac6c$var$decrementExpectedAwaits();
            return x;
        }, function(e) {
            $2f895839ac78ac6c$var$decrementExpectedAwaits();
            return $2f895839ac78ac6c$var$rejection(e);
        });
    }
    return possiblePromise;
}
function $2f895839ac78ac6c$var$zoneEnterEcho(targetZone) {
    ++$2f895839ac78ac6c$var$totalEchoes;
    if (!$2f895839ac78ac6c$var$task.echoes || --$2f895839ac78ac6c$var$task.echoes === 0) $2f895839ac78ac6c$var$task.echoes = $2f895839ac78ac6c$var$task.id = 0;
    $2f895839ac78ac6c$var$zoneStack.push($2f895839ac78ac6c$var$PSD);
    $2f895839ac78ac6c$var$switchToZone(targetZone, true);
}
function $2f895839ac78ac6c$var$zoneLeaveEcho() {
    var zone = $2f895839ac78ac6c$var$zoneStack[$2f895839ac78ac6c$var$zoneStack.length - 1];
    $2f895839ac78ac6c$var$zoneStack.pop();
    $2f895839ac78ac6c$var$switchToZone(zone, false);
}
function $2f895839ac78ac6c$var$switchToZone(targetZone, bEnteringZone) {
    var currentZone = $2f895839ac78ac6c$var$PSD;
    if (bEnteringZone ? $2f895839ac78ac6c$var$task.echoes && (!$2f895839ac78ac6c$var$zoneEchoes++ || targetZone !== $2f895839ac78ac6c$var$PSD) : $2f895839ac78ac6c$var$zoneEchoes && (!--$2f895839ac78ac6c$var$zoneEchoes || targetZone !== $2f895839ac78ac6c$var$PSD)) $2f895839ac78ac6c$var$enqueueNativeMicroTask(bEnteringZone ? $2f895839ac78ac6c$var$zoneEnterEcho.bind(null, targetZone) : $2f895839ac78ac6c$var$zoneLeaveEcho);
    if (targetZone === $2f895839ac78ac6c$var$PSD) return;
    $2f895839ac78ac6c$var$PSD = targetZone;
    if (currentZone === $2f895839ac78ac6c$var$globalPSD) $2f895839ac78ac6c$var$globalPSD.env = $2f895839ac78ac6c$var$snapShot();
    if ($2f895839ac78ac6c$var$patchGlobalPromise) {
        var GlobalPromise_1 = $2f895839ac78ac6c$var$globalPSD.env.Promise;
        var targetEnv = targetZone.env;
        $2f895839ac78ac6c$var$nativePromiseProto.then = targetEnv.nthen;
        GlobalPromise_1.prototype.then = targetEnv.gthen;
        if (currentZone.global || targetZone.global) {
            Object.defineProperty($2f895839ac78ac6c$var$_global, "Promise", targetEnv.PromiseProp);
            GlobalPromise_1.all = targetEnv.all;
            GlobalPromise_1.race = targetEnv.race;
            GlobalPromise_1.resolve = targetEnv.resolve;
            GlobalPromise_1.reject = targetEnv.reject;
            if (targetEnv.allSettled) GlobalPromise_1.allSettled = targetEnv.allSettled;
            if (targetEnv.any) GlobalPromise_1.any = targetEnv.any;
        }
    }
}
function $2f895839ac78ac6c$var$snapShot() {
    var GlobalPromise = $2f895839ac78ac6c$var$_global.Promise;
    return $2f895839ac78ac6c$var$patchGlobalPromise ? {
        Promise: GlobalPromise,
        PromiseProp: Object.getOwnPropertyDescriptor($2f895839ac78ac6c$var$_global, "Promise"),
        all: GlobalPromise.all,
        race: GlobalPromise.race,
        allSettled: GlobalPromise.allSettled,
        any: GlobalPromise.any,
        resolve: GlobalPromise.resolve,
        reject: GlobalPromise.reject,
        nthen: $2f895839ac78ac6c$var$nativePromiseProto.then,
        gthen: GlobalPromise.prototype.then
    } : {};
}
function $2f895839ac78ac6c$var$usePSD(psd, fn, a1, a2, a3) {
    var outerScope = $2f895839ac78ac6c$var$PSD;
    try {
        $2f895839ac78ac6c$var$switchToZone(psd, true);
        return fn(a1, a2, a3);
    } finally{
        $2f895839ac78ac6c$var$switchToZone(outerScope, false);
    }
}
function $2f895839ac78ac6c$var$enqueueNativeMicroTask(job) {
    $2f895839ac78ac6c$var$nativePromiseThen.call($2f895839ac78ac6c$var$resolvedNativePromise, job);
}
function $2f895839ac78ac6c$var$nativeAwaitCompatibleWrap(fn, zone, possibleAwait, cleanup) {
    return typeof fn !== "function" ? fn : function() {
        var outerZone = $2f895839ac78ac6c$var$PSD;
        if (possibleAwait) $2f895839ac78ac6c$var$incrementExpectedAwaits();
        $2f895839ac78ac6c$var$switchToZone(zone, true);
        try {
            return fn.apply(this, arguments);
        } finally{
            $2f895839ac78ac6c$var$switchToZone(outerZone, false);
            if (cleanup) $2f895839ac78ac6c$var$enqueueNativeMicroTask($2f895839ac78ac6c$var$decrementExpectedAwaits);
        }
    };
}
function $2f895839ac78ac6c$var$getPatchedPromiseThen(origThen, zone) {
    return function(onResolved, onRejected) {
        return origThen.call(this, $2f895839ac78ac6c$var$nativeAwaitCompatibleWrap(onResolved, zone), $2f895839ac78ac6c$var$nativeAwaitCompatibleWrap(onRejected, zone));
    };
}
var $2f895839ac78ac6c$var$UNHANDLEDREJECTION = "unhandledrejection";
function $2f895839ac78ac6c$var$globalError(err, promise) {
    var rv;
    try {
        rv = promise.onuncatched(err);
    } catch (e) {}
    if (rv !== false) try {
        var event, eventData = {
            promise: promise,
            reason: err
        };
        if ($2f895839ac78ac6c$var$_global.document && document.createEvent) {
            event = document.createEvent("Event");
            event.initEvent($2f895839ac78ac6c$var$UNHANDLEDREJECTION, true, true);
            $2f895839ac78ac6c$var$extend(event, eventData);
        } else if ($2f895839ac78ac6c$var$_global.CustomEvent) {
            event = new CustomEvent($2f895839ac78ac6c$var$UNHANDLEDREJECTION, {
                detail: eventData
            });
            $2f895839ac78ac6c$var$extend(event, eventData);
        }
        if (event && $2f895839ac78ac6c$var$_global.dispatchEvent) {
            dispatchEvent(event);
            if (!$2f895839ac78ac6c$var$_global.PromiseRejectionEvent && $2f895839ac78ac6c$var$_global.onunhandledrejection) try {
                $2f895839ac78ac6c$var$_global.onunhandledrejection(event);
            } catch (_) {}
        }
        if ($2f895839ac78ac6c$var$debug && event && !event.defaultPrevented) console.warn("Unhandled rejection: " + (err.stack || err));
    } catch (e) {}
}
var $2f895839ac78ac6c$var$rejection = $2f895839ac78ac6c$var$DexiePromise.reject;
function $2f895839ac78ac6c$var$tempTransaction(db, mode, storeNames, fn) {
    if (!db.idbdb || !db._state.openComplete && !$2f895839ac78ac6c$var$PSD.letThrough && !db._vip) {
        if (db._state.openComplete) return $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.DatabaseClosed(db._state.dbOpenError));
        if (!db._state.isBeingOpened) {
            if (!db._options.autoOpen) return $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.DatabaseClosed());
            db.open().catch($2f895839ac78ac6c$var$nop);
        }
        return db._state.dbReadyPromise.then(function() {
            return $2f895839ac78ac6c$var$tempTransaction(db, mode, storeNames, fn);
        });
    } else {
        var trans = db._createTransaction(mode, storeNames, db._dbSchema);
        try {
            trans.create();
            db._state.PR1398_maxLoop = 3;
        } catch (ex) {
            if (ex.name === $2f895839ac78ac6c$var$errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                console.warn("Dexie: Need to reopen db");
                db._close();
                return db.open().then(function() {
                    return $2f895839ac78ac6c$var$tempTransaction(db, mode, storeNames, fn);
                });
            }
            return $2f895839ac78ac6c$var$rejection(ex);
        }
        return trans._promise(mode, function(resolve, reject) {
            return $2f895839ac78ac6c$var$newScope(function() {
                $2f895839ac78ac6c$var$PSD.trans = trans;
                return fn(resolve, reject, trans);
            });
        }).then(function(result) {
            return trans._completion.then(function() {
                return result;
            });
        });
    }
}
var $2f895839ac78ac6c$var$DEXIE_VERSION = "3.2.5";
var $2f895839ac78ac6c$var$maxString = String.fromCharCode(65535);
var $2f895839ac78ac6c$var$minKey = -Infinity;
var $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT = "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.";
var $2f895839ac78ac6c$var$STRING_EXPECTED = "String expected.";
var $2f895839ac78ac6c$var$connections = [];
var $2f895839ac78ac6c$var$isIEOrEdge = typeof navigator !== "undefined" && /(MSIE|Trident|Edge)/.test(navigator.userAgent);
var $2f895839ac78ac6c$var$hasIEDeleteObjectStoreBug = $2f895839ac78ac6c$var$isIEOrEdge;
var $2f895839ac78ac6c$var$hangsOnDeleteLargeKeyRange = $2f895839ac78ac6c$var$isIEOrEdge;
var $2f895839ac78ac6c$var$dexieStackFrameFilter = function(frame) {
    return !/(dexie\.js|dexie\.min\.js)/.test(frame);
};
var $2f895839ac78ac6c$var$DBNAMES_DB = "__dbnames";
var $2f895839ac78ac6c$var$READONLY = "readonly";
var $2f895839ac78ac6c$var$READWRITE = "readwrite";
function $2f895839ac78ac6c$var$combine(filter1, filter2) {
    return filter1 ? filter2 ? function() {
        return filter1.apply(this, arguments) && filter2.apply(this, arguments);
    } : filter1 : filter2;
}
var $2f895839ac78ac6c$var$AnyRange = {
    type: 3,
    lower: -Infinity,
    lowerOpen: false,
    upper: [
        []
    ],
    upperOpen: false
};
function $2f895839ac78ac6c$var$workaroundForUndefinedPrimKey(keyPath) {
    return typeof keyPath === "string" && !/\./.test(keyPath) ? function(obj) {
        if (obj[keyPath] === undefined && keyPath in obj) {
            obj = $2f895839ac78ac6c$var$deepClone(obj);
            delete obj[keyPath];
        }
        return obj;
    } : function(obj) {
        return obj;
    };
}
var $2f895839ac78ac6c$var$Table = function() {
    function Table() {}
    Table.prototype._trans = function(mode, fn, writeLocked) {
        var trans = this._tx || $2f895839ac78ac6c$var$PSD.trans;
        var tableName = this.name;
        function checkTableInTransaction(resolve, reject, trans) {
            if (!trans.schema[tableName]) throw new $2f895839ac78ac6c$var$exceptions.NotFound("Table " + tableName + " not part of transaction");
            return fn(trans.idbtrans, trans);
        }
        var wasRootExec = $2f895839ac78ac6c$var$beginMicroTickScope();
        try {
            return trans && trans.db === this.db ? trans === $2f895839ac78ac6c$var$PSD.trans ? trans._promise(mode, checkTableInTransaction, writeLocked) : $2f895839ac78ac6c$var$newScope(function() {
                return trans._promise(mode, checkTableInTransaction, writeLocked);
            }, {
                trans: trans,
                transless: $2f895839ac78ac6c$var$PSD.transless || $2f895839ac78ac6c$var$PSD
            }) : $2f895839ac78ac6c$var$tempTransaction(this.db, mode, [
                this.name
            ], checkTableInTransaction);
        } finally{
            if (wasRootExec) $2f895839ac78ac6c$var$endMicroTickScope();
        }
    };
    Table.prototype.get = function(keyOrCrit, cb) {
        var _this = this;
        if (keyOrCrit && keyOrCrit.constructor === Object) return this.where(keyOrCrit).first(cb);
        return this._trans("readonly", function(trans) {
            return _this.core.get({
                trans: trans,
                key: keyOrCrit
            }).then(function(res) {
                return _this.hook.reading.fire(res);
            });
        }).then(cb);
    };
    Table.prototype.where = function(indexOrCrit) {
        if (typeof indexOrCrit === "string") return new this.db.WhereClause(this, indexOrCrit);
        if ($2f895839ac78ac6c$var$isArray(indexOrCrit)) return new this.db.WhereClause(this, "[" + indexOrCrit.join("+") + "]");
        var keyPaths = $2f895839ac78ac6c$var$keys(indexOrCrit);
        if (keyPaths.length === 1) return this.where(keyPaths[0]).equals(indexOrCrit[keyPaths[0]]);
        var compoundIndex = this.schema.indexes.concat(this.schema.primKey).filter(function(ix) {
            if (ix.compound && keyPaths.every(function(keyPath) {
                return ix.keyPath.indexOf(keyPath) >= 0;
            })) {
                for(var i = 0; i < keyPaths.length; ++i){
                    if (keyPaths.indexOf(ix.keyPath[i]) === -1) return false;
                }
                return true;
            }
            return false;
        }).sort(function(a, b) {
            return a.keyPath.length - b.keyPath.length;
        })[0];
        if (compoundIndex && this.db._maxKey !== $2f895839ac78ac6c$var$maxString) {
            var keyPathsInValidOrder = compoundIndex.keyPath.slice(0, keyPaths.length);
            return this.where(keyPathsInValidOrder).equals(keyPathsInValidOrder.map(function(kp) {
                return indexOrCrit[kp];
            }));
        }
        if (!compoundIndex && $2f895839ac78ac6c$var$debug) console.warn("The query " + JSON.stringify(indexOrCrit) + " on " + this.name + " would benefit of a " + ("compound index [" + keyPaths.join("+") + "]"));
        var idxByName = this.schema.idxByName;
        var idb = this.db._deps.indexedDB;
        function equals(a, b) {
            try {
                return idb.cmp(a, b) === 0;
            } catch (e) {
                return false;
            }
        }
        var _a = keyPaths.reduce(function(_a, keyPath) {
            var prevIndex = _a[0], prevFilterFn = _a[1];
            var index = idxByName[keyPath];
            var value = indexOrCrit[keyPath];
            return [
                prevIndex || index,
                prevIndex || !index ? $2f895839ac78ac6c$var$combine(prevFilterFn, index && index.multi ? function(x) {
                    var prop = $2f895839ac78ac6c$var$getByKeyPath(x, keyPath);
                    return $2f895839ac78ac6c$var$isArray(prop) && prop.some(function(item) {
                        return equals(value, item);
                    });
                } : function(x) {
                    return equals(value, $2f895839ac78ac6c$var$getByKeyPath(x, keyPath));
                }) : prevFilterFn
            ];
        }, [
            null,
            null
        ]), idx = _a[0], filterFunction = _a[1];
        return idx ? this.where(idx.name).equals(indexOrCrit[idx.keyPath]).filter(filterFunction) : compoundIndex ? this.filter(filterFunction) : this.where(keyPaths).equals("");
    };
    Table.prototype.filter = function(filterFunction) {
        return this.toCollection().and(filterFunction);
    };
    Table.prototype.count = function(thenShortcut) {
        return this.toCollection().count(thenShortcut);
    };
    Table.prototype.offset = function(offset) {
        return this.toCollection().offset(offset);
    };
    Table.prototype.limit = function(numRows) {
        return this.toCollection().limit(numRows);
    };
    Table.prototype.each = function(callback) {
        return this.toCollection().each(callback);
    };
    Table.prototype.toArray = function(thenShortcut) {
        return this.toCollection().toArray(thenShortcut);
    };
    Table.prototype.toCollection = function() {
        return new this.db.Collection(new this.db.WhereClause(this));
    };
    Table.prototype.orderBy = function(index) {
        return new this.db.Collection(new this.db.WhereClause(this, $2f895839ac78ac6c$var$isArray(index) ? "[" + index.join("+") + "]" : index));
    };
    Table.prototype.reverse = function() {
        return this.toCollection().reverse();
    };
    Table.prototype.mapToClass = function(constructor) {
        this.schema.mappedClass = constructor;
        var readHook = function(obj) {
            if (!obj) return obj;
            var res = Object.create(constructor.prototype);
            for(var m in obj)if ($2f895839ac78ac6c$var$hasOwn(obj, m)) try {
                res[m] = obj[m];
            } catch (_) {}
            return res;
        };
        if (this.schema.readHook) this.hook.reading.unsubscribe(this.schema.readHook);
        this.schema.readHook = readHook;
        this.hook("reading", readHook);
        return constructor;
    };
    Table.prototype.defineClass = function() {
        function Class(content) {
            $2f895839ac78ac6c$var$extend(this, content);
        }
        return this.mapToClass(Class);
    };
    Table.prototype.add = function(obj, key) {
        var _this = this;
        var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
        var objToAdd = obj;
        if (keyPath && auto) objToAdd = $2f895839ac78ac6c$var$workaroundForUndefinedPrimKey(keyPath)(obj);
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "add",
                keys: key != null ? [
                    key
                ] : null,
                values: [
                    objToAdd
                ]
            });
        }).then(function(res) {
            return res.numFailures ? $2f895839ac78ac6c$var$DexiePromise.reject(res.failures[0]) : res.lastResult;
        }).then(function(lastResult) {
            if (keyPath) try {
                $2f895839ac78ac6c$var$setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
            return lastResult;
        });
    };
    Table.prototype.update = function(keyOrObject, modifications) {
        if (typeof keyOrObject === "object" && !$2f895839ac78ac6c$var$isArray(keyOrObject)) {
            var key = $2f895839ac78ac6c$var$getByKeyPath(keyOrObject, this.schema.primKey.keyPath);
            if (key === undefined) return $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Given object does not contain its primary key"));
            try {
                if (typeof modifications !== "function") $2f895839ac78ac6c$var$keys(modifications).forEach(function(keyPath) {
                    $2f895839ac78ac6c$var$setByKeyPath(keyOrObject, keyPath, modifications[keyPath]);
                });
                else modifications(keyOrObject, {
                    value: keyOrObject,
                    primKey: key
                });
            } catch (_a) {}
            return this.where(":id").equals(key).modify(modifications);
        } else return this.where(":id").equals(keyOrObject).modify(modifications);
    };
    Table.prototype.put = function(obj, key) {
        var _this = this;
        var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
        var objToAdd = obj;
        if (keyPath && auto) objToAdd = $2f895839ac78ac6c$var$workaroundForUndefinedPrimKey(keyPath)(obj);
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "put",
                values: [
                    objToAdd
                ],
                keys: key != null ? [
                    key
                ] : null
            });
        }).then(function(res) {
            return res.numFailures ? $2f895839ac78ac6c$var$DexiePromise.reject(res.failures[0]) : res.lastResult;
        }).then(function(lastResult) {
            if (keyPath) try {
                $2f895839ac78ac6c$var$setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
            return lastResult;
        });
    };
    Table.prototype.delete = function(key) {
        var _this = this;
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "delete",
                keys: [
                    key
                ]
            });
        }).then(function(res) {
            return res.numFailures ? $2f895839ac78ac6c$var$DexiePromise.reject(res.failures[0]) : undefined;
        });
    };
    Table.prototype.clear = function() {
        var _this = this;
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "deleteRange",
                range: $2f895839ac78ac6c$var$AnyRange
            });
        }).then(function(res) {
            return res.numFailures ? $2f895839ac78ac6c$var$DexiePromise.reject(res.failures[0]) : undefined;
        });
    };
    Table.prototype.bulkGet = function(keys) {
        var _this = this;
        return this._trans("readonly", function(trans) {
            return _this.core.getMany({
                keys: keys,
                trans: trans
            }).then(function(result) {
                return result.map(function(res) {
                    return _this.hook.reading.fire(res);
                });
            });
        });
    };
    Table.prototype.bulkAdd = function(objects, keysOrOptions, options) {
        var _this = this;
        var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
        options = options || (keys ? undefined : keysOrOptions);
        var wantResults = options ? options.allKeys : undefined;
        return this._trans("readwrite", function(trans) {
            var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            if (keyPath && keys) throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");
            if (keys && keys.length !== objects.length) throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Arguments objects and keys must have the same length");
            var numObjects = objects.length;
            var objectsToAdd = keyPath && auto ? objects.map($2f895839ac78ac6c$var$workaroundForUndefinedPrimKey(keyPath)) : objects;
            return _this.core.mutate({
                trans: trans,
                type: "add",
                keys: keys,
                values: objectsToAdd,
                wantResults: wantResults
            }).then(function(_a) {
                var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                var result = wantResults ? results : lastResult;
                if (numFailures === 0) return result;
                throw new $2f895839ac78ac6c$var$BulkError(_this.name + ".bulkAdd(): " + numFailures + " of " + numObjects + " operations failed", failures);
            });
        });
    };
    Table.prototype.bulkPut = function(objects, keysOrOptions, options) {
        var _this = this;
        var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
        options = options || (keys ? undefined : keysOrOptions);
        var wantResults = options ? options.allKeys : undefined;
        return this._trans("readwrite", function(trans) {
            var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            if (keyPath && keys) throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");
            if (keys && keys.length !== objects.length) throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Arguments objects and keys must have the same length");
            var numObjects = objects.length;
            var objectsToPut = keyPath && auto ? objects.map($2f895839ac78ac6c$var$workaroundForUndefinedPrimKey(keyPath)) : objects;
            return _this.core.mutate({
                trans: trans,
                type: "put",
                keys: keys,
                values: objectsToPut,
                wantResults: wantResults
            }).then(function(_a) {
                var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                var result = wantResults ? results : lastResult;
                if (numFailures === 0) return result;
                throw new $2f895839ac78ac6c$var$BulkError(_this.name + ".bulkPut(): " + numFailures + " of " + numObjects + " operations failed", failures);
            });
        });
    };
    Table.prototype.bulkDelete = function(keys) {
        var _this = this;
        var numKeys = keys.length;
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "delete",
                keys: keys
            });
        }).then(function(_a) {
            var numFailures = _a.numFailures, lastResult = _a.lastResult, failures = _a.failures;
            if (numFailures === 0) return lastResult;
            throw new $2f895839ac78ac6c$var$BulkError(_this.name + ".bulkDelete(): " + numFailures + " of " + numKeys + " operations failed", failures);
        });
    };
    return Table;
}();
function $2f895839ac78ac6c$var$Events(ctx) {
    var evs = {};
    var rv = function(eventName, subscriber) {
        if (subscriber) {
            var i = arguments.length, args = new Array(i - 1);
            while(--i)args[i - 1] = arguments[i];
            evs[eventName].subscribe.apply(null, args);
            return ctx;
        } else if (typeof eventName === "string") return evs[eventName];
    };
    rv.addEventType = add;
    for(var i = 1, l = arguments.length; i < l; ++i)add(arguments[i]);
    return rv;
    function add(eventName, chainFunction, defaultFunction) {
        if (typeof eventName === "object") return addConfiguredEvents(eventName);
        if (!chainFunction) chainFunction = $2f895839ac78ac6c$var$reverseStoppableEventChain;
        if (!defaultFunction) defaultFunction = $2f895839ac78ac6c$var$nop;
        var context = {
            subscribers: [],
            fire: defaultFunction,
            subscribe: function(cb) {
                if (context.subscribers.indexOf(cb) === -1) {
                    context.subscribers.push(cb);
                    context.fire = chainFunction(context.fire, cb);
                }
            },
            unsubscribe: function(cb) {
                context.subscribers = context.subscribers.filter(function(fn) {
                    return fn !== cb;
                });
                context.fire = context.subscribers.reduce(chainFunction, defaultFunction);
            }
        };
        evs[eventName] = rv[eventName] = context;
        return context;
    }
    function addConfiguredEvents(cfg) {
        $2f895839ac78ac6c$var$keys(cfg).forEach(function(eventName) {
            var args = cfg[eventName];
            if ($2f895839ac78ac6c$var$isArray(args)) add(eventName, cfg[eventName][0], cfg[eventName][1]);
            else if (args === "asap") var context = add(eventName, $2f895839ac78ac6c$var$mirror, function fire() {
                var i = arguments.length, args = new Array(i);
                while(i--)args[i] = arguments[i];
                context.subscribers.forEach(function(fn) {
                    $2f895839ac78ac6c$var$asap$1(function fireEvent() {
                        fn.apply(null, args);
                    });
                });
            });
            else throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Invalid event config");
        });
    }
}
function $2f895839ac78ac6c$var$makeClassConstructor(prototype, constructor) {
    $2f895839ac78ac6c$var$derive(constructor).from({
        prototype: prototype
    });
    return constructor;
}
function $2f895839ac78ac6c$var$createTableConstructor(db) {
    return $2f895839ac78ac6c$var$makeClassConstructor($2f895839ac78ac6c$var$Table.prototype, function Table(name, tableSchema, trans) {
        this.db = db;
        this._tx = trans;
        this.name = name;
        this.schema = tableSchema;
        this.hook = db._allTables[name] ? db._allTables[name].hook : $2f895839ac78ac6c$var$Events(null, {
            "creating": [
                $2f895839ac78ac6c$var$hookCreatingChain,
                $2f895839ac78ac6c$var$nop
            ],
            "reading": [
                $2f895839ac78ac6c$var$pureFunctionChain,
                $2f895839ac78ac6c$var$mirror
            ],
            "updating": [
                $2f895839ac78ac6c$var$hookUpdatingChain,
                $2f895839ac78ac6c$var$nop
            ],
            "deleting": [
                $2f895839ac78ac6c$var$hookDeletingChain,
                $2f895839ac78ac6c$var$nop
            ]
        });
    });
}
function $2f895839ac78ac6c$var$isPlainKeyRange(ctx, ignoreLimitFilter) {
    return !(ctx.filter || ctx.algorithm || ctx.or) && (ignoreLimitFilter ? ctx.justLimit : !ctx.replayFilter);
}
function $2f895839ac78ac6c$var$addFilter(ctx, fn) {
    ctx.filter = $2f895839ac78ac6c$var$combine(ctx.filter, fn);
}
function $2f895839ac78ac6c$var$addReplayFilter(ctx, factory, isLimitFilter) {
    var curr = ctx.replayFilter;
    ctx.replayFilter = curr ? function() {
        return $2f895839ac78ac6c$var$combine(curr(), factory());
    } : factory;
    ctx.justLimit = isLimitFilter && !curr;
}
function $2f895839ac78ac6c$var$addMatchFilter(ctx, fn) {
    ctx.isMatch = $2f895839ac78ac6c$var$combine(ctx.isMatch, fn);
}
function $2f895839ac78ac6c$var$getIndexOrStore(ctx, coreSchema) {
    if (ctx.isPrimKey) return coreSchema.primaryKey;
    var index = coreSchema.getIndexByKeyPath(ctx.index);
    if (!index) throw new $2f895839ac78ac6c$var$exceptions.Schema("KeyPath " + ctx.index + " on object store " + coreSchema.name + " is not indexed");
    return index;
}
function $2f895839ac78ac6c$var$openCursor(ctx, coreTable, trans) {
    var index = $2f895839ac78ac6c$var$getIndexOrStore(ctx, coreTable.schema);
    return coreTable.openCursor({
        trans: trans,
        values: !ctx.keysOnly,
        reverse: ctx.dir === "prev",
        unique: !!ctx.unique,
        query: {
            index: index,
            range: ctx.range
        }
    });
}
function $2f895839ac78ac6c$var$iter(ctx, fn, coreTrans, coreTable) {
    var filter = ctx.replayFilter ? $2f895839ac78ac6c$var$combine(ctx.filter, ctx.replayFilter()) : ctx.filter;
    if (!ctx.or) return $2f895839ac78ac6c$var$iterate($2f895839ac78ac6c$var$openCursor(ctx, coreTable, coreTrans), $2f895839ac78ac6c$var$combine(ctx.algorithm, filter), fn, !ctx.keysOnly && ctx.valueMapper);
    else {
        var set_1 = {};
        var union = function(item, cursor, advance) {
            if (!filter || filter(cursor, advance, function(result) {
                return cursor.stop(result);
            }, function(err) {
                return cursor.fail(err);
            })) {
                var primaryKey = cursor.primaryKey;
                var key = "" + primaryKey;
                if (key === "[object ArrayBuffer]") key = "" + new Uint8Array(primaryKey);
                if (!$2f895839ac78ac6c$var$hasOwn(set_1, key)) {
                    set_1[key] = true;
                    fn(item, cursor, advance);
                }
            }
        };
        return Promise.all([
            ctx.or._iterate(union, coreTrans),
            $2f895839ac78ac6c$var$iterate($2f895839ac78ac6c$var$openCursor(ctx, coreTable, coreTrans), ctx.algorithm, union, !ctx.keysOnly && ctx.valueMapper)
        ]);
    }
}
function $2f895839ac78ac6c$var$iterate(cursorPromise, filter, fn, valueMapper) {
    var mappedFn = valueMapper ? function(x, c, a) {
        return fn(valueMapper(x), c, a);
    } : fn;
    var wrappedFn = $2f895839ac78ac6c$var$wrap(mappedFn);
    return cursorPromise.then(function(cursor) {
        if (cursor) return cursor.start(function() {
            var c = function() {
                return cursor.continue();
            };
            if (!filter || filter(cursor, function(advancer) {
                return c = advancer;
            }, function(val) {
                cursor.stop(val);
                c = $2f895839ac78ac6c$var$nop;
            }, function(e) {
                cursor.fail(e);
                c = $2f895839ac78ac6c$var$nop;
            })) wrappedFn(cursor.value, cursor, function(advancer) {
                return c = advancer;
            });
            c();
        });
    });
}
function $2f895839ac78ac6c$var$cmp(a, b) {
    try {
        var ta = $2f895839ac78ac6c$var$type(a);
        var tb = $2f895839ac78ac6c$var$type(b);
        if (ta !== tb) {
            if (ta === "Array") return 1;
            if (tb === "Array") return -1;
            if (ta === "binary") return 1;
            if (tb === "binary") return -1;
            if (ta === "string") return 1;
            if (tb === "string") return -1;
            if (ta === "Date") return 1;
            if (tb !== "Date") return NaN;
            return -1;
        }
        switch(ta){
            case "number":
            case "Date":
            case "string":
                return a > b ? 1 : a < b ? -1 : 0;
            case "binary":
                return $2f895839ac78ac6c$var$compareUint8Arrays($2f895839ac78ac6c$var$getUint8Array(a), $2f895839ac78ac6c$var$getUint8Array(b));
            case "Array":
                return $2f895839ac78ac6c$var$compareArrays(a, b);
        }
    } catch (_a) {}
    return NaN;
}
function $2f895839ac78ac6c$var$compareArrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for(var i = 0; i < l; ++i){
        var res = $2f895839ac78ac6c$var$cmp(a[i], b[i]);
        if (res !== 0) return res;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
}
function $2f895839ac78ac6c$var$compareUint8Arrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for(var i = 0; i < l; ++i){
        if (a[i] !== b[i]) return a[i] < b[i] ? -1 : 1;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
}
function $2f895839ac78ac6c$var$type(x) {
    var t = typeof x;
    if (t !== "object") return t;
    if (ArrayBuffer.isView(x)) return "binary";
    var tsTag = $2f895839ac78ac6c$var$toStringTag(x);
    return tsTag === "ArrayBuffer" ? "binary" : tsTag;
}
function $2f895839ac78ac6c$var$getUint8Array(a) {
    if (a instanceof Uint8Array) return a;
    if (ArrayBuffer.isView(a)) return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
    return new Uint8Array(a);
}
var $2f895839ac78ac6c$var$Collection = function() {
    function Collection() {}
    Collection.prototype._read = function(fn, cb) {
        var ctx = this._ctx;
        return ctx.error ? ctx.table._trans(null, $2f895839ac78ac6c$var$rejection.bind(null, ctx.error)) : ctx.table._trans("readonly", fn).then(cb);
    };
    Collection.prototype._write = function(fn) {
        var ctx = this._ctx;
        return ctx.error ? ctx.table._trans(null, $2f895839ac78ac6c$var$rejection.bind(null, ctx.error)) : ctx.table._trans("readwrite", fn, "locked");
    };
    Collection.prototype._addAlgorithm = function(fn) {
        var ctx = this._ctx;
        ctx.algorithm = $2f895839ac78ac6c$var$combine(ctx.algorithm, fn);
    };
    Collection.prototype._iterate = function(fn, coreTrans) {
        return $2f895839ac78ac6c$var$iter(this._ctx, fn, coreTrans, this._ctx.table.core);
    };
    Collection.prototype.clone = function(props) {
        var rv = Object.create(this.constructor.prototype), ctx = Object.create(this._ctx);
        if (props) $2f895839ac78ac6c$var$extend(ctx, props);
        rv._ctx = ctx;
        return rv;
    };
    Collection.prototype.raw = function() {
        this._ctx.valueMapper = null;
        return this;
    };
    Collection.prototype.each = function(fn) {
        var ctx = this._ctx;
        return this._read(function(trans) {
            return $2f895839ac78ac6c$var$iter(ctx, fn, trans, ctx.table.core);
        });
    };
    Collection.prototype.count = function(cb) {
        var _this = this;
        return this._read(function(trans) {
            var ctx = _this._ctx;
            var coreTable = ctx.table.core;
            if ($2f895839ac78ac6c$var$isPlainKeyRange(ctx, true)) return coreTable.count({
                trans: trans,
                query: {
                    index: $2f895839ac78ac6c$var$getIndexOrStore(ctx, coreTable.schema),
                    range: ctx.range
                }
            }).then(function(count) {
                return Math.min(count, ctx.limit);
            });
            else {
                var count = 0;
                return $2f895839ac78ac6c$var$iter(ctx, function() {
                    ++count;
                    return false;
                }, trans, coreTable).then(function() {
                    return count;
                });
            }
        }).then(cb);
    };
    Collection.prototype.sortBy = function(keyPath, cb) {
        var parts = keyPath.split(".").reverse(), lastPart = parts[0], lastIndex = parts.length - 1;
        function getval(obj, i) {
            if (i) return getval(obj[parts[i]], i - 1);
            return obj[lastPart];
        }
        var order = this._ctx.dir === "next" ? 1 : -1;
        function sorter(a, b) {
            var aVal = getval(a, lastIndex), bVal = getval(b, lastIndex);
            return aVal < bVal ? -order : aVal > bVal ? order : 0;
        }
        return this.toArray(function(a) {
            return a.sort(sorter);
        }).then(cb);
    };
    Collection.prototype.toArray = function(cb) {
        var _this = this;
        return this._read(function(trans) {
            var ctx = _this._ctx;
            if (ctx.dir === "next" && $2f895839ac78ac6c$var$isPlainKeyRange(ctx, true) && ctx.limit > 0) {
                var valueMapper_1 = ctx.valueMapper;
                var index = $2f895839ac78ac6c$var$getIndexOrStore(ctx, ctx.table.core.schema);
                return ctx.table.core.query({
                    trans: trans,
                    limit: ctx.limit,
                    values: true,
                    query: {
                        index: index,
                        range: ctx.range
                    }
                }).then(function(_a) {
                    var result = _a.result;
                    return valueMapper_1 ? result.map(valueMapper_1) : result;
                });
            } else {
                var a_1 = [];
                return $2f895839ac78ac6c$var$iter(ctx, function(item) {
                    return a_1.push(item);
                }, trans, ctx.table.core).then(function() {
                    return a_1;
                });
            }
        }, cb);
    };
    Collection.prototype.offset = function(offset) {
        var ctx = this._ctx;
        if (offset <= 0) return this;
        ctx.offset += offset;
        if ($2f895839ac78ac6c$var$isPlainKeyRange(ctx)) $2f895839ac78ac6c$var$addReplayFilter(ctx, function() {
            var offsetLeft = offset;
            return function(cursor, advance) {
                if (offsetLeft === 0) return true;
                if (offsetLeft === 1) {
                    --offsetLeft;
                    return false;
                }
                advance(function() {
                    cursor.advance(offsetLeft);
                    offsetLeft = 0;
                });
                return false;
            };
        });
        else $2f895839ac78ac6c$var$addReplayFilter(ctx, function() {
            var offsetLeft = offset;
            return function() {
                return --offsetLeft < 0;
            };
        });
        return this;
    };
    Collection.prototype.limit = function(numRows) {
        this._ctx.limit = Math.min(this._ctx.limit, numRows);
        $2f895839ac78ac6c$var$addReplayFilter(this._ctx, function() {
            var rowsLeft = numRows;
            return function(cursor, advance, resolve) {
                if (--rowsLeft <= 0) advance(resolve);
                return rowsLeft >= 0;
            };
        }, true);
        return this;
    };
    Collection.prototype.until = function(filterFunction, bIncludeStopEntry) {
        $2f895839ac78ac6c$var$addFilter(this._ctx, function(cursor, advance, resolve) {
            if (filterFunction(cursor.value)) {
                advance(resolve);
                return bIncludeStopEntry;
            } else return true;
        });
        return this;
    };
    Collection.prototype.first = function(cb) {
        return this.limit(1).toArray(function(a) {
            return a[0];
        }).then(cb);
    };
    Collection.prototype.last = function(cb) {
        return this.reverse().first(cb);
    };
    Collection.prototype.filter = function(filterFunction) {
        $2f895839ac78ac6c$var$addFilter(this._ctx, function(cursor) {
            return filterFunction(cursor.value);
        });
        $2f895839ac78ac6c$var$addMatchFilter(this._ctx, filterFunction);
        return this;
    };
    Collection.prototype.and = function(filter) {
        return this.filter(filter);
    };
    Collection.prototype.or = function(indexName) {
        return new this.db.WhereClause(this._ctx.table, indexName, this);
    };
    Collection.prototype.reverse = function() {
        this._ctx.dir = this._ctx.dir === "prev" ? "next" : "prev";
        if (this._ondirectionchange) this._ondirectionchange(this._ctx.dir);
        return this;
    };
    Collection.prototype.desc = function() {
        return this.reverse();
    };
    Collection.prototype.eachKey = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        return this.each(function(val, cursor) {
            cb(cursor.key, cursor);
        });
    };
    Collection.prototype.eachUniqueKey = function(cb) {
        this._ctx.unique = "unique";
        return this.eachKey(cb);
    };
    Collection.prototype.eachPrimaryKey = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        return this.each(function(val, cursor) {
            cb(cursor.primaryKey, cursor);
        });
    };
    Collection.prototype.keys = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        var a = [];
        return this.each(function(item, cursor) {
            a.push(cursor.key);
        }).then(function() {
            return a;
        }).then(cb);
    };
    Collection.prototype.primaryKeys = function(cb) {
        var ctx = this._ctx;
        if (ctx.dir === "next" && $2f895839ac78ac6c$var$isPlainKeyRange(ctx, true) && ctx.limit > 0) return this._read(function(trans) {
            var index = $2f895839ac78ac6c$var$getIndexOrStore(ctx, ctx.table.core.schema);
            return ctx.table.core.query({
                trans: trans,
                values: false,
                limit: ctx.limit,
                query: {
                    index: index,
                    range: ctx.range
                }
            });
        }).then(function(_a) {
            var result = _a.result;
            return result;
        }).then(cb);
        ctx.keysOnly = !ctx.isMatch;
        var a = [];
        return this.each(function(item, cursor) {
            a.push(cursor.primaryKey);
        }).then(function() {
            return a;
        }).then(cb);
    };
    Collection.prototype.uniqueKeys = function(cb) {
        this._ctx.unique = "unique";
        return this.keys(cb);
    };
    Collection.prototype.firstKey = function(cb) {
        return this.limit(1).keys(function(a) {
            return a[0];
        }).then(cb);
    };
    Collection.prototype.lastKey = function(cb) {
        return this.reverse().firstKey(cb);
    };
    Collection.prototype.distinct = function() {
        var ctx = this._ctx, idx = ctx.index && ctx.table.schema.idxByName[ctx.index];
        if (!idx || !idx.multi) return this;
        var set = {};
        $2f895839ac78ac6c$var$addFilter(this._ctx, function(cursor) {
            var strKey = cursor.primaryKey.toString();
            var found = $2f895839ac78ac6c$var$hasOwn(set, strKey);
            set[strKey] = true;
            return !found;
        });
        return this;
    };
    Collection.prototype.modify = function(changes) {
        var _this = this;
        var ctx = this._ctx;
        return this._write(function(trans) {
            var modifyer;
            if (typeof changes === "function") modifyer = changes;
            else {
                var keyPaths = $2f895839ac78ac6c$var$keys(changes);
                var numKeys = keyPaths.length;
                modifyer = function(item) {
                    var anythingModified = false;
                    for(var i = 0; i < numKeys; ++i){
                        var keyPath = keyPaths[i], val = changes[keyPath];
                        if ($2f895839ac78ac6c$var$getByKeyPath(item, keyPath) !== val) {
                            $2f895839ac78ac6c$var$setByKeyPath(item, keyPath, val);
                            anythingModified = true;
                        }
                    }
                    return anythingModified;
                };
            }
            var coreTable = ctx.table.core;
            var _a = coreTable.schema.primaryKey, outbound = _a.outbound, extractKey = _a.extractKey;
            var limit = _this.db._options.modifyChunkSize || 200;
            var totalFailures = [];
            var successCount = 0;
            var failedKeys = [];
            var applyMutateResult = function(expectedCount, res) {
                var failures = res.failures, numFailures = res.numFailures;
                successCount += expectedCount - numFailures;
                for(var _i = 0, _a = $2f895839ac78ac6c$var$keys(failures); _i < _a.length; _i++){
                    var pos = _a[_i];
                    totalFailures.push(failures[pos]);
                }
            };
            return _this.clone().primaryKeys().then(function(keys) {
                var nextChunk = function(offset) {
                    var count = Math.min(limit, keys.length - offset);
                    return coreTable.getMany({
                        trans: trans,
                        keys: keys.slice(offset, offset + count),
                        cache: "immutable"
                    }).then(function(values) {
                        var addValues = [];
                        var putValues = [];
                        var putKeys = outbound ? [] : null;
                        var deleteKeys = [];
                        for(var i = 0; i < count; ++i){
                            var origValue = values[i];
                            var ctx_1 = {
                                value: $2f895839ac78ac6c$var$deepClone(origValue),
                                primKey: keys[offset + i]
                            };
                            if (modifyer.call(ctx_1, ctx_1.value, ctx_1) !== false) {
                                if (ctx_1.value == null) deleteKeys.push(keys[offset + i]);
                                else if (!outbound && $2f895839ac78ac6c$var$cmp(extractKey(origValue), extractKey(ctx_1.value)) !== 0) {
                                    deleteKeys.push(keys[offset + i]);
                                    addValues.push(ctx_1.value);
                                } else {
                                    putValues.push(ctx_1.value);
                                    if (outbound) putKeys.push(keys[offset + i]);
                                }
                            }
                        }
                        var criteria = $2f895839ac78ac6c$var$isPlainKeyRange(ctx) && ctx.limit === Infinity && (typeof changes !== "function" || changes === $2f895839ac78ac6c$var$deleteCallback) && {
                            index: ctx.index,
                            range: ctx.range
                        };
                        return Promise.resolve(addValues.length > 0 && coreTable.mutate({
                            trans: trans,
                            type: "add",
                            values: addValues
                        }).then(function(res) {
                            for(var pos in res.failures)deleteKeys.splice(parseInt(pos), 1);
                            applyMutateResult(addValues.length, res);
                        })).then(function() {
                            return (putValues.length > 0 || criteria && typeof changes === "object") && coreTable.mutate({
                                trans: trans,
                                type: "put",
                                keys: putKeys,
                                values: putValues,
                                criteria: criteria,
                                changeSpec: typeof changes !== "function" && changes
                            }).then(function(res) {
                                return applyMutateResult(putValues.length, res);
                            });
                        }).then(function() {
                            return (deleteKeys.length > 0 || criteria && changes === $2f895839ac78ac6c$var$deleteCallback) && coreTable.mutate({
                                trans: trans,
                                type: "delete",
                                keys: deleteKeys,
                                criteria: criteria
                            }).then(function(res) {
                                return applyMutateResult(deleteKeys.length, res);
                            });
                        }).then(function() {
                            return keys.length > offset + count && nextChunk(offset + limit);
                        });
                    });
                };
                return nextChunk(0).then(function() {
                    if (totalFailures.length > 0) throw new $2f895839ac78ac6c$var$ModifyError("Error modifying one or more objects", totalFailures, successCount, failedKeys);
                    return keys.length;
                });
            });
        });
    };
    Collection.prototype.delete = function() {
        var ctx = this._ctx, range = ctx.range;
        if ($2f895839ac78ac6c$var$isPlainKeyRange(ctx) && (ctx.isPrimKey && !$2f895839ac78ac6c$var$hangsOnDeleteLargeKeyRange || range.type === 3)) return this._write(function(trans) {
            var primaryKey = ctx.table.core.schema.primaryKey;
            var coreRange = range;
            return ctx.table.core.count({
                trans: trans,
                query: {
                    index: primaryKey,
                    range: coreRange
                }
            }).then(function(count) {
                return ctx.table.core.mutate({
                    trans: trans,
                    type: "deleteRange",
                    range: coreRange
                }).then(function(_a) {
                    var failures = _a.failures;
                    _a.lastResult;
                    _a.results;
                    var numFailures = _a.numFailures;
                    if (numFailures) throw new $2f895839ac78ac6c$var$ModifyError("Could not delete some values", Object.keys(failures).map(function(pos) {
                        return failures[pos];
                    }), count - numFailures);
                    return count - numFailures;
                });
            });
        });
        return this.modify($2f895839ac78ac6c$var$deleteCallback);
    };
    return Collection;
}();
var $2f895839ac78ac6c$var$deleteCallback = function(value, ctx) {
    return ctx.value = null;
};
function $2f895839ac78ac6c$var$createCollectionConstructor(db) {
    return $2f895839ac78ac6c$var$makeClassConstructor($2f895839ac78ac6c$var$Collection.prototype, function Collection(whereClause, keyRangeGenerator) {
        this.db = db;
        var keyRange = $2f895839ac78ac6c$var$AnyRange, error = null;
        if (keyRangeGenerator) try {
            keyRange = keyRangeGenerator();
        } catch (ex) {
            error = ex;
        }
        var whereCtx = whereClause._ctx;
        var table = whereCtx.table;
        var readingHook = table.hook.reading.fire;
        this._ctx = {
            table: table,
            index: whereCtx.index,
            isPrimKey: !whereCtx.index || table.schema.primKey.keyPath && whereCtx.index === table.schema.primKey.name,
            range: keyRange,
            keysOnly: false,
            dir: "next",
            unique: "",
            algorithm: null,
            filter: null,
            replayFilter: null,
            justLimit: true,
            isMatch: null,
            offset: 0,
            limit: Infinity,
            error: error,
            or: whereCtx.or,
            valueMapper: readingHook !== $2f895839ac78ac6c$var$mirror ? readingHook : null
        };
    });
}
function $2f895839ac78ac6c$var$simpleCompare(a, b) {
    return a < b ? -1 : a === b ? 0 : 1;
}
function $2f895839ac78ac6c$var$simpleCompareReverse(a, b) {
    return a > b ? -1 : a === b ? 0 : 1;
}
function $2f895839ac78ac6c$var$fail(collectionOrWhereClause, err, T) {
    var collection = collectionOrWhereClause instanceof $2f895839ac78ac6c$var$WhereClause ? new collectionOrWhereClause.Collection(collectionOrWhereClause) : collectionOrWhereClause;
    collection._ctx.error = T ? new T(err) : new TypeError(err);
    return collection;
}
function $2f895839ac78ac6c$var$emptyCollection(whereClause) {
    return new whereClause.Collection(whereClause, function() {
        return $2f895839ac78ac6c$var$rangeEqual("");
    }).limit(0);
}
function $2f895839ac78ac6c$var$upperFactory(dir) {
    return dir === "next" ? function(s) {
        return s.toUpperCase();
    } : function(s) {
        return s.toLowerCase();
    };
}
function $2f895839ac78ac6c$var$lowerFactory(dir) {
    return dir === "next" ? function(s) {
        return s.toLowerCase();
    } : function(s) {
        return s.toUpperCase();
    };
}
function $2f895839ac78ac6c$var$nextCasing(key, lowerKey, upperNeedle, lowerNeedle, cmp, dir) {
    var length = Math.min(key.length, lowerNeedle.length);
    var llp = -1;
    for(var i = 0; i < length; ++i){
        var lwrKeyChar = lowerKey[i];
        if (lwrKeyChar !== lowerNeedle[i]) {
            if (cmp(key[i], upperNeedle[i]) < 0) return key.substr(0, i) + upperNeedle[i] + upperNeedle.substr(i + 1);
            if (cmp(key[i], lowerNeedle[i]) < 0) return key.substr(0, i) + lowerNeedle[i] + upperNeedle.substr(i + 1);
            if (llp >= 0) return key.substr(0, llp) + lowerKey[llp] + upperNeedle.substr(llp + 1);
            return null;
        }
        if (cmp(key[i], lwrKeyChar) < 0) llp = i;
    }
    if (length < lowerNeedle.length && dir === "next") return key + upperNeedle.substr(key.length);
    if (length < key.length && dir === "prev") return key.substr(0, upperNeedle.length);
    return llp < 0 ? null : key.substr(0, llp) + lowerNeedle[llp] + upperNeedle.substr(llp + 1);
}
function $2f895839ac78ac6c$var$addIgnoreCaseAlgorithm(whereClause, match, needles, suffix) {
    var upper, lower, compare, upperNeedles, lowerNeedles, direction, nextKeySuffix, needlesLen = needles.length;
    if (!needles.every(function(s) {
        return typeof s === "string";
    })) return $2f895839ac78ac6c$var$fail(whereClause, $2f895839ac78ac6c$var$STRING_EXPECTED);
    function initDirection(dir) {
        upper = $2f895839ac78ac6c$var$upperFactory(dir);
        lower = $2f895839ac78ac6c$var$lowerFactory(dir);
        compare = dir === "next" ? $2f895839ac78ac6c$var$simpleCompare : $2f895839ac78ac6c$var$simpleCompareReverse;
        var needleBounds = needles.map(function(needle) {
            return {
                lower: lower(needle),
                upper: upper(needle)
            };
        }).sort(function(a, b) {
            return compare(a.lower, b.lower);
        });
        upperNeedles = needleBounds.map(function(nb) {
            return nb.upper;
        });
        lowerNeedles = needleBounds.map(function(nb) {
            return nb.lower;
        });
        direction = dir;
        nextKeySuffix = dir === "next" ? "" : suffix;
    }
    initDirection("next");
    var c = new whereClause.Collection(whereClause, function() {
        return $2f895839ac78ac6c$var$createRange(upperNeedles[0], lowerNeedles[needlesLen - 1] + suffix);
    });
    c._ondirectionchange = function(direction) {
        initDirection(direction);
    };
    var firstPossibleNeedle = 0;
    c._addAlgorithm(function(cursor, advance, resolve) {
        var key = cursor.key;
        if (typeof key !== "string") return false;
        var lowerKey = lower(key);
        if (match(lowerKey, lowerNeedles, firstPossibleNeedle)) return true;
        else {
            var lowestPossibleCasing = null;
            for(var i = firstPossibleNeedle; i < needlesLen; ++i){
                var casing = $2f895839ac78ac6c$var$nextCasing(key, lowerKey, upperNeedles[i], lowerNeedles[i], compare, direction);
                if (casing === null && lowestPossibleCasing === null) firstPossibleNeedle = i + 1;
                else if (lowestPossibleCasing === null || compare(lowestPossibleCasing, casing) > 0) lowestPossibleCasing = casing;
            }
            if (lowestPossibleCasing !== null) advance(function() {
                cursor.continue(lowestPossibleCasing + nextKeySuffix);
            });
            else advance(resolve);
            return false;
        }
    });
    return c;
}
function $2f895839ac78ac6c$var$createRange(lower, upper, lowerOpen, upperOpen) {
    return {
        type: 2,
        lower: lower,
        upper: upper,
        lowerOpen: lowerOpen,
        upperOpen: upperOpen
    };
}
function $2f895839ac78ac6c$var$rangeEqual(value) {
    return {
        type: 1,
        lower: value,
        upper: value
    };
}
var $2f895839ac78ac6c$var$WhereClause = function() {
    function WhereClause() {}
    Object.defineProperty(WhereClause.prototype, "Collection", {
        get: function() {
            return this._ctx.table.db.Collection;
        },
        enumerable: false,
        configurable: true
    });
    WhereClause.prototype.between = function(lower, upper, includeLower, includeUpper) {
        includeLower = includeLower !== false;
        includeUpper = includeUpper === true;
        try {
            if (this._cmp(lower, upper) > 0 || this._cmp(lower, upper) === 0 && (includeLower || includeUpper) && !(includeLower && includeUpper)) return $2f895839ac78ac6c$var$emptyCollection(this);
            return new this.Collection(this, function() {
                return $2f895839ac78ac6c$var$createRange(lower, upper, !includeLower, !includeUpper);
            });
        } catch (e) {
            return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        }
    };
    WhereClause.prototype.equals = function(value) {
        if (value == null) return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$rangeEqual(value);
        });
    };
    WhereClause.prototype.above = function(value) {
        if (value == null) return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$createRange(value, undefined, true);
        });
    };
    WhereClause.prototype.aboveOrEqual = function(value) {
        if (value == null) return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$createRange(value, undefined, false);
        });
    };
    WhereClause.prototype.below = function(value) {
        if (value == null) return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$createRange(undefined, value, false, true);
        });
    };
    WhereClause.prototype.belowOrEqual = function(value) {
        if (value == null) return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$createRange(undefined, value);
        });
    };
    WhereClause.prototype.startsWith = function(str) {
        if (typeof str !== "string") return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$STRING_EXPECTED);
        return this.between(str, str + $2f895839ac78ac6c$var$maxString, true, true);
    };
    WhereClause.prototype.startsWithIgnoreCase = function(str) {
        if (str === "") return this.startsWith(str);
        return $2f895839ac78ac6c$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return x.indexOf(a[0]) === 0;
        }, [
            str
        ], $2f895839ac78ac6c$var$maxString);
    };
    WhereClause.prototype.equalsIgnoreCase = function(str) {
        return $2f895839ac78ac6c$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return x === a[0];
        }, [
            str
        ], "");
    };
    WhereClause.prototype.anyOfIgnoreCase = function() {
        var set = $2f895839ac78ac6c$var$getArrayOf.apply($2f895839ac78ac6c$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return $2f895839ac78ac6c$var$emptyCollection(this);
        return $2f895839ac78ac6c$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return a.indexOf(x) !== -1;
        }, set, "");
    };
    WhereClause.prototype.startsWithAnyOfIgnoreCase = function() {
        var set = $2f895839ac78ac6c$var$getArrayOf.apply($2f895839ac78ac6c$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return $2f895839ac78ac6c$var$emptyCollection(this);
        return $2f895839ac78ac6c$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return a.some(function(n) {
                return x.indexOf(n) === 0;
            });
        }, set, $2f895839ac78ac6c$var$maxString);
    };
    WhereClause.prototype.anyOf = function() {
        var _this = this;
        var set = $2f895839ac78ac6c$var$getArrayOf.apply($2f895839ac78ac6c$var$NO_CHAR_ARRAY, arguments);
        var compare = this._cmp;
        try {
            set.sort(compare);
        } catch (e) {
            return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        }
        if (set.length === 0) return $2f895839ac78ac6c$var$emptyCollection(this);
        var c = new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$createRange(set[0], set[set.length - 1]);
        });
        c._ondirectionchange = function(direction) {
            compare = direction === "next" ? _this._ascending : _this._descending;
            set.sort(compare);
        };
        var i = 0;
        c._addAlgorithm(function(cursor, advance, resolve) {
            var key = cursor.key;
            while(compare(key, set[i]) > 0){
                ++i;
                if (i === set.length) {
                    advance(resolve);
                    return false;
                }
            }
            if (compare(key, set[i]) === 0) return true;
            else {
                advance(function() {
                    cursor.continue(set[i]);
                });
                return false;
            }
        });
        return c;
    };
    WhereClause.prototype.notEqual = function(value) {
        return this.inAnyRange([
            [
                $2f895839ac78ac6c$var$minKey,
                value
            ],
            [
                value,
                this.db._maxKey
            ]
        ], {
            includeLowers: false,
            includeUppers: false
        });
    };
    WhereClause.prototype.noneOf = function() {
        var set = $2f895839ac78ac6c$var$getArrayOf.apply($2f895839ac78ac6c$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return new this.Collection(this);
        try {
            set.sort(this._ascending);
        } catch (e) {
            return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        }
        var ranges = set.reduce(function(res, val) {
            return res ? res.concat([
                [
                    res[res.length - 1][1],
                    val
                ]
            ]) : [
                [
                    $2f895839ac78ac6c$var$minKey,
                    val
                ]
            ];
        }, null);
        ranges.push([
            set[set.length - 1],
            this.db._maxKey
        ]);
        return this.inAnyRange(ranges, {
            includeLowers: false,
            includeUppers: false
        });
    };
    WhereClause.prototype.inAnyRange = function(ranges, options) {
        var _this = this;
        var cmp = this._cmp, ascending = this._ascending, descending = this._descending, min = this._min, max = this._max;
        if (ranges.length === 0) return $2f895839ac78ac6c$var$emptyCollection(this);
        if (!ranges.every(function(range) {
            return range[0] !== undefined && range[1] !== undefined && ascending(range[0], range[1]) <= 0;
        })) return $2f895839ac78ac6c$var$fail(this, "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower", $2f895839ac78ac6c$var$exceptions.InvalidArgument);
        var includeLowers = !options || options.includeLowers !== false;
        var includeUppers = options && options.includeUppers === true;
        function addRange(ranges, newRange) {
            var i = 0, l = ranges.length;
            for(; i < l; ++i){
                var range = ranges[i];
                if (cmp(newRange[0], range[1]) < 0 && cmp(newRange[1], range[0]) > 0) {
                    range[0] = min(range[0], newRange[0]);
                    range[1] = max(range[1], newRange[1]);
                    break;
                }
            }
            if (i === l) ranges.push(newRange);
            return ranges;
        }
        var sortDirection = ascending;
        function rangeSorter(a, b) {
            return sortDirection(a[0], b[0]);
        }
        var set;
        try {
            set = ranges.reduce(addRange, []);
            set.sort(rangeSorter);
        } catch (ex) {
            return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        }
        var rangePos = 0;
        var keyIsBeyondCurrentEntry = includeUppers ? function(key) {
            return ascending(key, set[rangePos][1]) > 0;
        } : function(key) {
            return ascending(key, set[rangePos][1]) >= 0;
        };
        var keyIsBeforeCurrentEntry = includeLowers ? function(key) {
            return descending(key, set[rangePos][0]) > 0;
        } : function(key) {
            return descending(key, set[rangePos][0]) >= 0;
        };
        function keyWithinCurrentRange(key) {
            return !keyIsBeyondCurrentEntry(key) && !keyIsBeforeCurrentEntry(key);
        }
        var checkKey = keyIsBeyondCurrentEntry;
        var c = new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$createRange(set[0][0], set[set.length - 1][1], !includeLowers, !includeUppers);
        });
        c._ondirectionchange = function(direction) {
            if (direction === "next") {
                checkKey = keyIsBeyondCurrentEntry;
                sortDirection = ascending;
            } else {
                checkKey = keyIsBeforeCurrentEntry;
                sortDirection = descending;
            }
            set.sort(rangeSorter);
        };
        c._addAlgorithm(function(cursor, advance, resolve) {
            var key = cursor.key;
            while(checkKey(key)){
                ++rangePos;
                if (rangePos === set.length) {
                    advance(resolve);
                    return false;
                }
            }
            if (keyWithinCurrentRange(key)) return true;
            else if (_this._cmp(key, set[rangePos][1]) === 0 || _this._cmp(key, set[rangePos][0]) === 0) return false;
            else {
                advance(function() {
                    if (sortDirection === ascending) cursor.continue(set[rangePos][0]);
                    else cursor.continue(set[rangePos][1]);
                });
                return false;
            }
        });
        return c;
    };
    WhereClause.prototype.startsWithAnyOf = function() {
        var set = $2f895839ac78ac6c$var$getArrayOf.apply($2f895839ac78ac6c$var$NO_CHAR_ARRAY, arguments);
        if (!set.every(function(s) {
            return typeof s === "string";
        })) return $2f895839ac78ac6c$var$fail(this, "startsWithAnyOf() only works with strings");
        if (set.length === 0) return $2f895839ac78ac6c$var$emptyCollection(this);
        return this.inAnyRange(set.map(function(str) {
            return [
                str,
                str + $2f895839ac78ac6c$var$maxString
            ];
        }));
    };
    return WhereClause;
}();
function $2f895839ac78ac6c$var$createWhereClauseConstructor(db) {
    return $2f895839ac78ac6c$var$makeClassConstructor($2f895839ac78ac6c$var$WhereClause.prototype, function WhereClause(table, index, orCollection) {
        this.db = db;
        this._ctx = {
            table: table,
            index: index === ":id" ? null : index,
            or: orCollection
        };
        var indexedDB1 = db._deps.indexedDB;
        if (!indexedDB1) throw new $2f895839ac78ac6c$var$exceptions.MissingAPI();
        this._cmp = this._ascending = indexedDB1.cmp.bind(indexedDB1);
        this._descending = function(a, b) {
            return indexedDB1.cmp(b, a);
        };
        this._max = function(a, b) {
            return indexedDB1.cmp(a, b) > 0 ? a : b;
        };
        this._min = function(a, b) {
            return indexedDB1.cmp(a, b) < 0 ? a : b;
        };
        this._IDBKeyRange = db._deps.IDBKeyRange;
    });
}
function $2f895839ac78ac6c$var$eventRejectHandler(reject) {
    return $2f895839ac78ac6c$var$wrap(function(event) {
        $2f895839ac78ac6c$var$preventDefault(event);
        reject(event.target.error);
        return false;
    });
}
function $2f895839ac78ac6c$var$preventDefault(event) {
    if (event.stopPropagation) event.stopPropagation();
    if (event.preventDefault) event.preventDefault();
}
var $2f895839ac78ac6c$var$DEXIE_STORAGE_MUTATED_EVENT_NAME = "storagemutated";
var $2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME = "x-storagemutated-1";
var $2f895839ac78ac6c$var$globalEvents = $2f895839ac78ac6c$var$Events(null, $2f895839ac78ac6c$var$DEXIE_STORAGE_MUTATED_EVENT_NAME);
var $2f895839ac78ac6c$var$Transaction = function() {
    function Transaction() {}
    Transaction.prototype._lock = function() {
        $2f895839ac78ac6c$var$assert(!$2f895839ac78ac6c$var$PSD.global);
        ++this._reculock;
        if (this._reculock === 1 && !$2f895839ac78ac6c$var$PSD.global) $2f895839ac78ac6c$var$PSD.lockOwnerFor = this;
        return this;
    };
    Transaction.prototype._unlock = function() {
        $2f895839ac78ac6c$var$assert(!$2f895839ac78ac6c$var$PSD.global);
        if (--this._reculock === 0) {
            if (!$2f895839ac78ac6c$var$PSD.global) $2f895839ac78ac6c$var$PSD.lockOwnerFor = null;
            while(this._blockedFuncs.length > 0 && !this._locked()){
                var fnAndPSD = this._blockedFuncs.shift();
                try {
                    $2f895839ac78ac6c$var$usePSD(fnAndPSD[1], fnAndPSD[0]);
                } catch (e) {}
            }
        }
        return this;
    };
    Transaction.prototype._locked = function() {
        return this._reculock && $2f895839ac78ac6c$var$PSD.lockOwnerFor !== this;
    };
    Transaction.prototype.create = function(idbtrans) {
        var _this = this;
        if (!this.mode) return this;
        var idbdb = this.db.idbdb;
        var dbOpenError = this.db._state.dbOpenError;
        $2f895839ac78ac6c$var$assert(!this.idbtrans);
        if (!idbtrans && !idbdb) switch(dbOpenError && dbOpenError.name){
            case "DatabaseClosedError":
                throw new $2f895839ac78ac6c$var$exceptions.DatabaseClosed(dbOpenError);
            case "MissingAPIError":
                throw new $2f895839ac78ac6c$var$exceptions.MissingAPI(dbOpenError.message, dbOpenError);
            default:
                throw new $2f895839ac78ac6c$var$exceptions.OpenFailed(dbOpenError);
        }
        if (!this.active) throw new $2f895839ac78ac6c$var$exceptions.TransactionInactive();
        $2f895839ac78ac6c$var$assert(this._completion._state === null);
        idbtrans = this.idbtrans = idbtrans || (this.db.core ? this.db.core.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
        }) : idbdb.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
        }));
        idbtrans.onerror = $2f895839ac78ac6c$var$wrap(function(ev) {
            $2f895839ac78ac6c$var$preventDefault(ev);
            _this._reject(idbtrans.error);
        });
        idbtrans.onabort = $2f895839ac78ac6c$var$wrap(function(ev) {
            $2f895839ac78ac6c$var$preventDefault(ev);
            _this.active && _this._reject(new $2f895839ac78ac6c$var$exceptions.Abort(idbtrans.error));
            _this.active = false;
            _this.on("abort").fire(ev);
        });
        idbtrans.oncomplete = $2f895839ac78ac6c$var$wrap(function() {
            _this.active = false;
            _this._resolve();
            if ("mutatedParts" in idbtrans) $2f895839ac78ac6c$var$globalEvents.storagemutated.fire(idbtrans["mutatedParts"]);
        });
        return this;
    };
    Transaction.prototype._promise = function(mode, fn, bWriteLock) {
        var _this = this;
        if (mode === "readwrite" && this.mode !== "readwrite") return $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.ReadOnly("Transaction is readonly"));
        if (!this.active) return $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.TransactionInactive());
        if (this._locked()) return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            _this._blockedFuncs.push([
                function() {
                    _this._promise(mode, fn, bWriteLock).then(resolve, reject);
                },
                $2f895839ac78ac6c$var$PSD
            ]);
        });
        else if (bWriteLock) return $2f895839ac78ac6c$var$newScope(function() {
            var p = new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
                _this._lock();
                var rv = fn(resolve, reject, _this);
                if (rv && rv.then) rv.then(resolve, reject);
            });
            p.finally(function() {
                return _this._unlock();
            });
            p._lib = true;
            return p;
        });
        else {
            var p = new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
                var rv = fn(resolve, reject, _this);
                if (rv && rv.then) rv.then(resolve, reject);
            });
            p._lib = true;
            return p;
        }
    };
    Transaction.prototype._root = function() {
        return this.parent ? this.parent._root() : this;
    };
    Transaction.prototype.waitFor = function(promiseLike) {
        var root = this._root();
        var promise = $2f895839ac78ac6c$var$DexiePromise.resolve(promiseLike);
        if (root._waitingFor) root._waitingFor = root._waitingFor.then(function() {
            return promise;
        });
        else {
            root._waitingFor = promise;
            root._waitingQueue = [];
            var store = root.idbtrans.objectStore(root.storeNames[0]);
            (function spin() {
                ++root._spinCount;
                while(root._waitingQueue.length)root._waitingQueue.shift()();
                if (root._waitingFor) store.get(-Infinity).onsuccess = spin;
            })();
        }
        var currentWaitPromise = root._waitingFor;
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            promise.then(function(res) {
                return root._waitingQueue.push($2f895839ac78ac6c$var$wrap(resolve.bind(null, res)));
            }, function(err) {
                return root._waitingQueue.push($2f895839ac78ac6c$var$wrap(reject.bind(null, err)));
            }).finally(function() {
                if (root._waitingFor === currentWaitPromise) root._waitingFor = null;
            });
        });
    };
    Transaction.prototype.abort = function() {
        if (this.active) {
            this.active = false;
            if (this.idbtrans) this.idbtrans.abort();
            this._reject(new $2f895839ac78ac6c$var$exceptions.Abort());
        }
    };
    Transaction.prototype.table = function(tableName) {
        var memoizedTables = this._memoizedTables || (this._memoizedTables = {});
        if ($2f895839ac78ac6c$var$hasOwn(memoizedTables, tableName)) return memoizedTables[tableName];
        var tableSchema = this.schema[tableName];
        if (!tableSchema) throw new $2f895839ac78ac6c$var$exceptions.NotFound("Table " + tableName + " not part of transaction");
        var transactionBoundTable = new this.db.Table(tableName, tableSchema, this);
        transactionBoundTable.core = this.db.core.table(tableName);
        memoizedTables[tableName] = transactionBoundTable;
        return transactionBoundTable;
    };
    return Transaction;
}();
function $2f895839ac78ac6c$var$createTransactionConstructor(db) {
    return $2f895839ac78ac6c$var$makeClassConstructor($2f895839ac78ac6c$var$Transaction.prototype, function Transaction(mode, storeNames, dbschema, chromeTransactionDurability, parent) {
        var _this = this;
        this.db = db;
        this.mode = mode;
        this.storeNames = storeNames;
        this.schema = dbschema;
        this.chromeTransactionDurability = chromeTransactionDurability;
        this.idbtrans = null;
        this.on = $2f895839ac78ac6c$var$Events(this, "complete", "error", "abort");
        this.parent = parent || null;
        this.active = true;
        this._reculock = 0;
        this._blockedFuncs = [];
        this._resolve = null;
        this._reject = null;
        this._waitingFor = null;
        this._waitingQueue = null;
        this._spinCount = 0;
        this._completion = new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
        this._completion.then(function() {
            _this.active = false;
            _this.on.complete.fire();
        }, function(e) {
            var wasActive = _this.active;
            _this.active = false;
            _this.on.error.fire(e);
            _this.parent ? _this.parent._reject(e) : wasActive && _this.idbtrans && _this.idbtrans.abort();
            return $2f895839ac78ac6c$var$rejection(e);
        });
    });
}
function $2f895839ac78ac6c$var$createIndexSpec(name, keyPath, unique, multi, auto, compound, isPrimKey) {
    return {
        name: name,
        keyPath: keyPath,
        unique: unique,
        multi: multi,
        auto: auto,
        compound: compound,
        src: (unique && !isPrimKey ? "&" : "") + (multi ? "*" : "") + (auto ? "++" : "") + $2f895839ac78ac6c$var$nameFromKeyPath(keyPath)
    };
}
function $2f895839ac78ac6c$var$nameFromKeyPath(keyPath) {
    return typeof keyPath === "string" ? keyPath : keyPath ? "[" + [].join.call(keyPath, "+") + "]" : "";
}
function $2f895839ac78ac6c$var$createTableSchema(name, primKey, indexes) {
    return {
        name: name,
        primKey: primKey,
        indexes: indexes,
        mappedClass: null,
        idxByName: $2f895839ac78ac6c$var$arrayToObject(indexes, function(index) {
            return [
                index.name,
                index
            ];
        })
    };
}
function $2f895839ac78ac6c$var$safariMultiStoreFix(storeNames) {
    return storeNames.length === 1 ? storeNames[0] : storeNames;
}
var $2f895839ac78ac6c$var$getMaxKey = function(IdbKeyRange) {
    try {
        IdbKeyRange.only([
            []
        ]);
        $2f895839ac78ac6c$var$getMaxKey = function() {
            return [
                []
            ];
        };
        return [
            []
        ];
    } catch (e) {
        $2f895839ac78ac6c$var$getMaxKey = function() {
            return $2f895839ac78ac6c$var$maxString;
        };
        return $2f895839ac78ac6c$var$maxString;
    }
};
function $2f895839ac78ac6c$var$getKeyExtractor(keyPath) {
    if (keyPath == null) return function() {
        return undefined;
    };
    else if (typeof keyPath === "string") return $2f895839ac78ac6c$var$getSinglePathKeyExtractor(keyPath);
    else return function(obj) {
        return $2f895839ac78ac6c$var$getByKeyPath(obj, keyPath);
    };
}
function $2f895839ac78ac6c$var$getSinglePathKeyExtractor(keyPath) {
    var split = keyPath.split(".");
    if (split.length === 1) return function(obj) {
        return obj[keyPath];
    };
    else return function(obj) {
        return $2f895839ac78ac6c$var$getByKeyPath(obj, keyPath);
    };
}
function $2f895839ac78ac6c$var$arrayify(arrayLike) {
    return [].slice.call(arrayLike);
}
var $2f895839ac78ac6c$var$_id_counter = 0;
function $2f895839ac78ac6c$var$getKeyPathAlias(keyPath) {
    return keyPath == null ? ":id" : typeof keyPath === "string" ? keyPath : "[" + keyPath.join("+") + "]";
}
function $2f895839ac78ac6c$var$createDBCore(db, IdbKeyRange, tmpTrans) {
    function extractSchema(db, trans) {
        var tables = $2f895839ac78ac6c$var$arrayify(db.objectStoreNames);
        return {
            schema: {
                name: db.name,
                tables: tables.map(function(table) {
                    return trans.objectStore(table);
                }).map(function(store) {
                    var keyPath = store.keyPath, autoIncrement = store.autoIncrement;
                    var compound = $2f895839ac78ac6c$var$isArray(keyPath);
                    var outbound = keyPath == null;
                    var indexByKeyPath = {};
                    var result = {
                        name: store.name,
                        primaryKey: {
                            name: null,
                            isPrimaryKey: true,
                            outbound: outbound,
                            compound: compound,
                            keyPath: keyPath,
                            autoIncrement: autoIncrement,
                            unique: true,
                            extractKey: $2f895839ac78ac6c$var$getKeyExtractor(keyPath)
                        },
                        indexes: $2f895839ac78ac6c$var$arrayify(store.indexNames).map(function(indexName) {
                            return store.index(indexName);
                        }).map(function(index) {
                            var name = index.name, unique = index.unique, multiEntry = index.multiEntry, keyPath = index.keyPath;
                            var compound = $2f895839ac78ac6c$var$isArray(keyPath);
                            var result = {
                                name: name,
                                compound: compound,
                                keyPath: keyPath,
                                unique: unique,
                                multiEntry: multiEntry,
                                extractKey: $2f895839ac78ac6c$var$getKeyExtractor(keyPath)
                            };
                            indexByKeyPath[$2f895839ac78ac6c$var$getKeyPathAlias(keyPath)] = result;
                            return result;
                        }),
                        getIndexByKeyPath: function(keyPath) {
                            return indexByKeyPath[$2f895839ac78ac6c$var$getKeyPathAlias(keyPath)];
                        }
                    };
                    indexByKeyPath[":id"] = result.primaryKey;
                    if (keyPath != null) indexByKeyPath[$2f895839ac78ac6c$var$getKeyPathAlias(keyPath)] = result.primaryKey;
                    return result;
                })
            },
            hasGetAll: tables.length > 0 && "getAll" in trans.objectStore(tables[0]) && !(typeof navigator !== "undefined" && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604)
        };
    }
    function makeIDBKeyRange(range) {
        if (range.type === 3) return null;
        if (range.type === 4) throw new Error("Cannot convert never type to IDBKeyRange");
        var lower = range.lower, upper = range.upper, lowerOpen = range.lowerOpen, upperOpen = range.upperOpen;
        var idbRange = lower === undefined ? upper === undefined ? null : IdbKeyRange.upperBound(upper, !!upperOpen) : upper === undefined ? IdbKeyRange.lowerBound(lower, !!lowerOpen) : IdbKeyRange.bound(lower, upper, !!lowerOpen, !!upperOpen);
        return idbRange;
    }
    function createDbCoreTable(tableSchema) {
        var tableName = tableSchema.name;
        function mutate(_a) {
            var trans = _a.trans, type = _a.type, keys = _a.keys, values = _a.values, range = _a.range;
            return new Promise(function(resolve, reject) {
                resolve = $2f895839ac78ac6c$var$wrap(resolve);
                var store = trans.objectStore(tableName);
                var outbound = store.keyPath == null;
                var isAddOrPut = type === "put" || type === "add";
                if (!isAddOrPut && type !== "delete" && type !== "deleteRange") throw new Error("Invalid operation type: " + type);
                var length = (keys || values || {
                    length: 1
                }).length;
                if (keys && values && keys.length !== values.length) throw new Error("Given keys array must have same length as given values array.");
                if (length === 0) return resolve({
                    numFailures: 0,
                    failures: {},
                    results: [],
                    lastResult: undefined
                });
                var req;
                var reqs = [];
                var failures = [];
                var numFailures = 0;
                var errorHandler = function(event) {
                    ++numFailures;
                    $2f895839ac78ac6c$var$preventDefault(event);
                };
                if (type === "deleteRange") {
                    if (range.type === 4) return resolve({
                        numFailures: numFailures,
                        failures: failures,
                        results: [],
                        lastResult: undefined
                    });
                    if (range.type === 3) reqs.push(req = store.clear());
                    else reqs.push(req = store.delete(makeIDBKeyRange(range)));
                } else {
                    var _a = isAddOrPut ? outbound ? [
                        values,
                        keys
                    ] : [
                        values,
                        null
                    ] : [
                        keys,
                        null
                    ], args1 = _a[0], args2 = _a[1];
                    if (isAddOrPut) for(var i = 0; i < length; ++i){
                        reqs.push(req = args2 && args2[i] !== undefined ? store[type](args1[i], args2[i]) : store[type](args1[i]));
                        req.onerror = errorHandler;
                    }
                    else for(var i = 0; i < length; ++i){
                        reqs.push(req = store[type](args1[i]));
                        req.onerror = errorHandler;
                    }
                }
                var done = function(event) {
                    var lastResult = event.target.result;
                    reqs.forEach(function(req, i) {
                        return req.error != null && (failures[i] = req.error);
                    });
                    resolve({
                        numFailures: numFailures,
                        failures: failures,
                        results: type === "delete" ? keys : reqs.map(function(req) {
                            return req.result;
                        }),
                        lastResult: lastResult
                    });
                };
                req.onerror = function(event) {
                    errorHandler(event);
                    done(event);
                };
                req.onsuccess = done;
            });
        }
        function openCursor(_a) {
            var trans = _a.trans, values = _a.values, query = _a.query, reverse = _a.reverse, unique = _a.unique;
            return new Promise(function(resolve, reject) {
                resolve = $2f895839ac78ac6c$var$wrap(resolve);
                var index = query.index, range = query.range;
                var store = trans.objectStore(tableName);
                var source = index.isPrimaryKey ? store : store.index(index.name);
                var direction = reverse ? unique ? "prevunique" : "prev" : unique ? "nextunique" : "next";
                var req = values || !("openKeyCursor" in source) ? source.openCursor(makeIDBKeyRange(range), direction) : source.openKeyCursor(makeIDBKeyRange(range), direction);
                req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                req.onsuccess = $2f895839ac78ac6c$var$wrap(function(ev) {
                    var cursor = req.result;
                    if (!cursor) {
                        resolve(null);
                        return;
                    }
                    cursor.___id = ++$2f895839ac78ac6c$var$_id_counter;
                    cursor.done = false;
                    var _cursorContinue = cursor.continue.bind(cursor);
                    var _cursorContinuePrimaryKey = cursor.continuePrimaryKey;
                    if (_cursorContinuePrimaryKey) _cursorContinuePrimaryKey = _cursorContinuePrimaryKey.bind(cursor);
                    var _cursorAdvance = cursor.advance.bind(cursor);
                    var doThrowCursorIsNotStarted = function() {
                        throw new Error("Cursor not started");
                    };
                    var doThrowCursorIsStopped = function() {
                        throw new Error("Cursor not stopped");
                    };
                    cursor.trans = trans;
                    cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsNotStarted;
                    cursor.fail = $2f895839ac78ac6c$var$wrap(reject);
                    cursor.next = function() {
                        var _this = this;
                        var gotOne = 1;
                        return this.start(function() {
                            return gotOne-- ? _this.continue() : _this.stop();
                        }).then(function() {
                            return _this;
                        });
                    };
                    cursor.start = function(callback) {
                        var iterationPromise = new Promise(function(resolveIteration, rejectIteration) {
                            resolveIteration = $2f895839ac78ac6c$var$wrap(resolveIteration);
                            req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(rejectIteration);
                            cursor.fail = rejectIteration;
                            cursor.stop = function(value) {
                                cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsStopped;
                                resolveIteration(value);
                            };
                        });
                        var guardedCallback = function() {
                            if (req.result) try {
                                callback();
                            } catch (err) {
                                cursor.fail(err);
                            }
                            else {
                                cursor.done = true;
                                cursor.start = function() {
                                    throw new Error("Cursor behind last entry");
                                };
                                cursor.stop();
                            }
                        };
                        req.onsuccess = $2f895839ac78ac6c$var$wrap(function(ev) {
                            req.onsuccess = guardedCallback;
                            guardedCallback();
                        });
                        cursor.continue = _cursorContinue;
                        cursor.continuePrimaryKey = _cursorContinuePrimaryKey;
                        cursor.advance = _cursorAdvance;
                        guardedCallback();
                        return iterationPromise;
                    };
                    resolve(cursor);
                }, reject);
            });
        }
        function query(hasGetAll) {
            return function(request) {
                return new Promise(function(resolve, reject) {
                    resolve = $2f895839ac78ac6c$var$wrap(resolve);
                    var trans = request.trans, values = request.values, limit = request.limit, query = request.query;
                    var nonInfinitLimit = limit === Infinity ? undefined : limit;
                    var index = query.index, range = query.range;
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ? store : store.index(index.name);
                    var idbKeyRange = makeIDBKeyRange(range);
                    if (limit === 0) return resolve({
                        result: []
                    });
                    if (hasGetAll) {
                        var req = values ? source.getAll(idbKeyRange, nonInfinitLimit) : source.getAllKeys(idbKeyRange, nonInfinitLimit);
                        req.onsuccess = function(event) {
                            return resolve({
                                result: event.target.result
                            });
                        };
                        req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                    } else {
                        var count_1 = 0;
                        var req_1 = values || !("openKeyCursor" in source) ? source.openCursor(idbKeyRange) : source.openKeyCursor(idbKeyRange);
                        var result_1 = [];
                        req_1.onsuccess = function(event) {
                            var cursor = req_1.result;
                            if (!cursor) return resolve({
                                result: result_1
                            });
                            result_1.push(values ? cursor.value : cursor.primaryKey);
                            if (++count_1 === limit) return resolve({
                                result: result_1
                            });
                            cursor.continue();
                        };
                        req_1.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                    }
                });
            };
        }
        return {
            name: tableName,
            schema: tableSchema,
            mutate: mutate,
            getMany: function(_a) {
                var trans = _a.trans, keys = _a.keys;
                return new Promise(function(resolve, reject) {
                    resolve = $2f895839ac78ac6c$var$wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var length = keys.length;
                    var result = new Array(length);
                    var keyCount = 0;
                    var callbackCount = 0;
                    var req;
                    var successHandler = function(event) {
                        var req = event.target;
                        result[req._pos] = req.result;
                        if (++callbackCount === keyCount) resolve(result);
                    };
                    var errorHandler = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                    for(var i = 0; i < length; ++i){
                        var key = keys[i];
                        if (key != null) {
                            req = store.get(keys[i]);
                            req._pos = i;
                            req.onsuccess = successHandler;
                            req.onerror = errorHandler;
                            ++keyCount;
                        }
                    }
                    if (keyCount === 0) resolve(result);
                });
            },
            get: function(_a) {
                var trans = _a.trans, key = _a.key;
                return new Promise(function(resolve, reject) {
                    resolve = $2f895839ac78ac6c$var$wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var req = store.get(key);
                    req.onsuccess = function(event) {
                        return resolve(event.target.result);
                    };
                    req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                });
            },
            query: query(hasGetAll),
            openCursor: openCursor,
            count: function(_a) {
                var query = _a.query, trans = _a.trans;
                var index = query.index, range = query.range;
                return new Promise(function(resolve, reject) {
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ? store : store.index(index.name);
                    var idbKeyRange = makeIDBKeyRange(range);
                    var req = idbKeyRange ? source.count(idbKeyRange) : source.count();
                    req.onsuccess = $2f895839ac78ac6c$var$wrap(function(ev) {
                        return resolve(ev.target.result);
                    });
                    req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                });
            }
        };
    }
    var _a = extractSchema(db, tmpTrans), schema = _a.schema, hasGetAll = _a.hasGetAll;
    var tables = schema.tables.map(function(tableSchema) {
        return createDbCoreTable(tableSchema);
    });
    var tableMap = {};
    tables.forEach(function(table) {
        return tableMap[table.name] = table;
    });
    return {
        stack: "dbcore",
        transaction: db.transaction.bind(db),
        table: function(name) {
            var result = tableMap[name];
            if (!result) throw new Error("Table '" + name + "' not found");
            return tableMap[name];
        },
        MIN_KEY: -Infinity,
        MAX_KEY: $2f895839ac78ac6c$var$getMaxKey(IdbKeyRange),
        schema: schema
    };
}
function $2f895839ac78ac6c$var$createMiddlewareStack(stackImpl, middlewares) {
    return middlewares.reduce(function(down, _a) {
        var create = _a.create;
        return $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, down), create(down));
    }, stackImpl);
}
function $2f895839ac78ac6c$var$createMiddlewareStacks(middlewares, idbdb, _a, tmpTrans) {
    var IDBKeyRange = _a.IDBKeyRange;
    _a.indexedDB;
    var dbcore = $2f895839ac78ac6c$var$createMiddlewareStack($2f895839ac78ac6c$var$createDBCore(idbdb, IDBKeyRange, tmpTrans), middlewares.dbcore);
    return {
        dbcore: dbcore
    };
}
function $2f895839ac78ac6c$var$generateMiddlewareStacks(_a, tmpTrans) {
    var db = _a._novip;
    var idbdb = tmpTrans.db;
    var stacks = $2f895839ac78ac6c$var$createMiddlewareStacks(db._middlewares, idbdb, db._deps, tmpTrans);
    db.core = stacks.dbcore;
    db.tables.forEach(function(table) {
        var tableName = table.name;
        if (db.core.schema.tables.some(function(tbl) {
            return tbl.name === tableName;
        })) {
            table.core = db.core.table(tableName);
            if (db[tableName] instanceof db.Table) db[tableName].core = table.core;
        }
    });
}
function $2f895839ac78ac6c$var$setApiOnPlace(_a, objs, tableNames, dbschema) {
    var db = _a._novip;
    tableNames.forEach(function(tableName) {
        var schema = dbschema[tableName];
        objs.forEach(function(obj) {
            var propDesc = $2f895839ac78ac6c$var$getPropertyDescriptor(obj, tableName);
            if (!propDesc || "value" in propDesc && propDesc.value === undefined) {
                if (obj === db.Transaction.prototype || obj instanceof db.Transaction) $2f895839ac78ac6c$var$setProp(obj, tableName, {
                    get: function() {
                        return this.table(tableName);
                    },
                    set: function(value) {
                        $2f895839ac78ac6c$var$defineProperty(this, tableName, {
                            value: value,
                            writable: true,
                            configurable: true,
                            enumerable: true
                        });
                    }
                });
                else obj[tableName] = new db.Table(tableName, schema);
            }
        });
    });
}
function $2f895839ac78ac6c$var$removeTablesApi(_a, objs) {
    var db = _a._novip;
    objs.forEach(function(obj) {
        for(var key in obj)if (obj[key] instanceof db.Table) delete obj[key];
    });
}
function $2f895839ac78ac6c$var$lowerVersionFirst(a, b) {
    return a._cfg.version - b._cfg.version;
}
function $2f895839ac78ac6c$var$runUpgraders(db, oldVersion, idbUpgradeTrans, reject) {
    var globalSchema = db._dbSchema;
    var trans = db._createTransaction("readwrite", db._storeNames, globalSchema);
    trans.create(idbUpgradeTrans);
    trans._completion.catch(reject);
    var rejectTransaction = trans._reject.bind(trans);
    var transless = $2f895839ac78ac6c$var$PSD.transless || $2f895839ac78ac6c$var$PSD;
    $2f895839ac78ac6c$var$newScope(function() {
        $2f895839ac78ac6c$var$PSD.trans = trans;
        $2f895839ac78ac6c$var$PSD.transless = transless;
        if (oldVersion === 0) {
            $2f895839ac78ac6c$var$keys(globalSchema).forEach(function(tableName) {
                $2f895839ac78ac6c$var$createTable(idbUpgradeTrans, tableName, globalSchema[tableName].primKey, globalSchema[tableName].indexes);
            });
            $2f895839ac78ac6c$var$generateMiddlewareStacks(db, idbUpgradeTrans);
            $2f895839ac78ac6c$var$DexiePromise.follow(function() {
                return db.on.populate.fire(trans);
            }).catch(rejectTransaction);
        } else $2f895839ac78ac6c$var$updateTablesAndIndexes(db, oldVersion, trans, idbUpgradeTrans).catch(rejectTransaction);
    });
}
function $2f895839ac78ac6c$var$updateTablesAndIndexes(_a, oldVersion, trans, idbUpgradeTrans) {
    var db = _a._novip;
    var queue = [];
    var versions = db._versions;
    var globalSchema = db._dbSchema = $2f895839ac78ac6c$var$buildGlobalSchema(db, db.idbdb, idbUpgradeTrans);
    var anyContentUpgraderHasRun = false;
    var versToRun = versions.filter(function(v) {
        return v._cfg.version >= oldVersion;
    });
    versToRun.forEach(function(version) {
        queue.push(function() {
            var oldSchema = globalSchema;
            var newSchema = version._cfg.dbschema;
            $2f895839ac78ac6c$var$adjustToExistingIndexNames(db, oldSchema, idbUpgradeTrans);
            $2f895839ac78ac6c$var$adjustToExistingIndexNames(db, newSchema, idbUpgradeTrans);
            globalSchema = db._dbSchema = newSchema;
            var diff = $2f895839ac78ac6c$var$getSchemaDiff(oldSchema, newSchema);
            diff.add.forEach(function(tuple) {
                $2f895839ac78ac6c$var$createTable(idbUpgradeTrans, tuple[0], tuple[1].primKey, tuple[1].indexes);
            });
            diff.change.forEach(function(change) {
                if (change.recreate) throw new $2f895839ac78ac6c$var$exceptions.Upgrade("Not yet support for changing primary key");
                else {
                    var store_1 = idbUpgradeTrans.objectStore(change.name);
                    change.add.forEach(function(idx) {
                        return $2f895839ac78ac6c$var$addIndex(store_1, idx);
                    });
                    change.change.forEach(function(idx) {
                        store_1.deleteIndex(idx.name);
                        $2f895839ac78ac6c$var$addIndex(store_1, idx);
                    });
                    change.del.forEach(function(idxName) {
                        return store_1.deleteIndex(idxName);
                    });
                }
            });
            var contentUpgrade = version._cfg.contentUpgrade;
            if (contentUpgrade && version._cfg.version > oldVersion) {
                $2f895839ac78ac6c$var$generateMiddlewareStacks(db, idbUpgradeTrans);
                trans._memoizedTables = {};
                anyContentUpgraderHasRun = true;
                var upgradeSchema_1 = $2f895839ac78ac6c$var$shallowClone(newSchema);
                diff.del.forEach(function(table) {
                    upgradeSchema_1[table] = oldSchema[table];
                });
                $2f895839ac78ac6c$var$removeTablesApi(db, [
                    db.Transaction.prototype
                ]);
                $2f895839ac78ac6c$var$setApiOnPlace(db, [
                    db.Transaction.prototype
                ], $2f895839ac78ac6c$var$keys(upgradeSchema_1), upgradeSchema_1);
                trans.schema = upgradeSchema_1;
                var contentUpgradeIsAsync_1 = $2f895839ac78ac6c$var$isAsyncFunction(contentUpgrade);
                if (contentUpgradeIsAsync_1) $2f895839ac78ac6c$var$incrementExpectedAwaits();
                var returnValue_1;
                var promiseFollowed = $2f895839ac78ac6c$var$DexiePromise.follow(function() {
                    returnValue_1 = contentUpgrade(trans);
                    if (returnValue_1) {
                        if (contentUpgradeIsAsync_1) {
                            var decrementor = $2f895839ac78ac6c$var$decrementExpectedAwaits.bind(null, null);
                            returnValue_1.then(decrementor, decrementor);
                        }
                    }
                });
                return returnValue_1 && typeof returnValue_1.then === "function" ? $2f895839ac78ac6c$var$DexiePromise.resolve(returnValue_1) : promiseFollowed.then(function() {
                    return returnValue_1;
                });
            }
        });
        queue.push(function(idbtrans) {
            if (!anyContentUpgraderHasRun || !$2f895839ac78ac6c$var$hasIEDeleteObjectStoreBug) {
                var newSchema = version._cfg.dbschema;
                $2f895839ac78ac6c$var$deleteRemovedTables(newSchema, idbtrans);
            }
            $2f895839ac78ac6c$var$removeTablesApi(db, [
                db.Transaction.prototype
            ]);
            $2f895839ac78ac6c$var$setApiOnPlace(db, [
                db.Transaction.prototype
            ], db._storeNames, db._dbSchema);
            trans.schema = db._dbSchema;
        });
    });
    function runQueue() {
        return queue.length ? $2f895839ac78ac6c$var$DexiePromise.resolve(queue.shift()(trans.idbtrans)).then(runQueue) : $2f895839ac78ac6c$var$DexiePromise.resolve();
    }
    return runQueue().then(function() {
        $2f895839ac78ac6c$var$createMissingTables(globalSchema, idbUpgradeTrans);
    });
}
function $2f895839ac78ac6c$var$getSchemaDiff(oldSchema, newSchema) {
    var diff = {
        del: [],
        add: [],
        change: []
    };
    var table;
    for(table in oldSchema)if (!newSchema[table]) diff.del.push(table);
    for(table in newSchema){
        var oldDef = oldSchema[table], newDef = newSchema[table];
        if (!oldDef) diff.add.push([
            table,
            newDef
        ]);
        else {
            var change = {
                name: table,
                def: newDef,
                recreate: false,
                del: [],
                add: [],
                change: []
            };
            if ("" + (oldDef.primKey.keyPath || "") !== "" + (newDef.primKey.keyPath || "") || oldDef.primKey.auto !== newDef.primKey.auto && !$2f895839ac78ac6c$var$isIEOrEdge) {
                change.recreate = true;
                diff.change.push(change);
            } else {
                var oldIndexes = oldDef.idxByName;
                var newIndexes = newDef.idxByName;
                var idxName = void 0;
                for(idxName in oldIndexes)if (!newIndexes[idxName]) change.del.push(idxName);
                for(idxName in newIndexes){
                    var oldIdx = oldIndexes[idxName], newIdx = newIndexes[idxName];
                    if (!oldIdx) change.add.push(newIdx);
                    else if (oldIdx.src !== newIdx.src) change.change.push(newIdx);
                }
                if (change.del.length > 0 || change.add.length > 0 || change.change.length > 0) diff.change.push(change);
            }
        }
    }
    return diff;
}
function $2f895839ac78ac6c$var$createTable(idbtrans, tableName, primKey, indexes) {
    var store = idbtrans.db.createObjectStore(tableName, primKey.keyPath ? {
        keyPath: primKey.keyPath,
        autoIncrement: primKey.auto
    } : {
        autoIncrement: primKey.auto
    });
    indexes.forEach(function(idx) {
        return $2f895839ac78ac6c$var$addIndex(store, idx);
    });
    return store;
}
function $2f895839ac78ac6c$var$createMissingTables(newSchema, idbtrans) {
    $2f895839ac78ac6c$var$keys(newSchema).forEach(function(tableName) {
        if (!idbtrans.db.objectStoreNames.contains(tableName)) $2f895839ac78ac6c$var$createTable(idbtrans, tableName, newSchema[tableName].primKey, newSchema[tableName].indexes);
    });
}
function $2f895839ac78ac6c$var$deleteRemovedTables(newSchema, idbtrans) {
    [].slice.call(idbtrans.db.objectStoreNames).forEach(function(storeName) {
        return newSchema[storeName] == null && idbtrans.db.deleteObjectStore(storeName);
    });
}
function $2f895839ac78ac6c$var$addIndex(store, idx) {
    store.createIndex(idx.name, idx.keyPath, {
        unique: idx.unique,
        multiEntry: idx.multi
    });
}
function $2f895839ac78ac6c$var$buildGlobalSchema(db, idbdb, tmpTrans) {
    var globalSchema = {};
    var dbStoreNames = $2f895839ac78ac6c$var$slice(idbdb.objectStoreNames, 0);
    dbStoreNames.forEach(function(storeName) {
        var store = tmpTrans.objectStore(storeName);
        var keyPath = store.keyPath;
        var primKey = $2f895839ac78ac6c$var$createIndexSpec($2f895839ac78ac6c$var$nameFromKeyPath(keyPath), keyPath || "", false, false, !!store.autoIncrement, keyPath && typeof keyPath !== "string", true);
        var indexes = [];
        for(var j = 0; j < store.indexNames.length; ++j){
            var idbindex = store.index(store.indexNames[j]);
            keyPath = idbindex.keyPath;
            var index = $2f895839ac78ac6c$var$createIndexSpec(idbindex.name, keyPath, !!idbindex.unique, !!idbindex.multiEntry, false, keyPath && typeof keyPath !== "string", false);
            indexes.push(index);
        }
        globalSchema[storeName] = $2f895839ac78ac6c$var$createTableSchema(storeName, primKey, indexes);
    });
    return globalSchema;
}
function $2f895839ac78ac6c$var$readGlobalSchema(_a, idbdb, tmpTrans) {
    var db = _a._novip;
    db.verno = idbdb.version / 10;
    var globalSchema = db._dbSchema = $2f895839ac78ac6c$var$buildGlobalSchema(db, idbdb, tmpTrans);
    db._storeNames = $2f895839ac78ac6c$var$slice(idbdb.objectStoreNames, 0);
    $2f895839ac78ac6c$var$setApiOnPlace(db, [
        db._allTables
    ], $2f895839ac78ac6c$var$keys(globalSchema), globalSchema);
}
function $2f895839ac78ac6c$var$verifyInstalledSchema(db, tmpTrans) {
    var installedSchema = $2f895839ac78ac6c$var$buildGlobalSchema(db, db.idbdb, tmpTrans);
    var diff = $2f895839ac78ac6c$var$getSchemaDiff(installedSchema, db._dbSchema);
    return !(diff.add.length || diff.change.some(function(ch) {
        return ch.add.length || ch.change.length;
    }));
}
function $2f895839ac78ac6c$var$adjustToExistingIndexNames(_a, schema, idbtrans) {
    var db = _a._novip;
    var storeNames = idbtrans.db.objectStoreNames;
    for(var i = 0; i < storeNames.length; ++i){
        var storeName = storeNames[i];
        var store = idbtrans.objectStore(storeName);
        db._hasGetAll = "getAll" in store;
        for(var j = 0; j < store.indexNames.length; ++j){
            var indexName = store.indexNames[j];
            var keyPath = store.index(indexName).keyPath;
            var dexieName = typeof keyPath === "string" ? keyPath : "[" + $2f895839ac78ac6c$var$slice(keyPath).join("+") + "]";
            if (schema[storeName]) {
                var indexSpec = schema[storeName].idxByName[dexieName];
                if (indexSpec) {
                    indexSpec.name = indexName;
                    delete schema[storeName].idxByName[dexieName];
                    schema[storeName].idxByName[indexName] = indexSpec;
                }
            }
        }
    }
    if (typeof navigator !== "undefined" && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && $2f895839ac78ac6c$var$_global.WorkerGlobalScope && $2f895839ac78ac6c$var$_global instanceof $2f895839ac78ac6c$var$_global.WorkerGlobalScope && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604) db._hasGetAll = false;
}
function $2f895839ac78ac6c$var$parseIndexSyntax(primKeyAndIndexes) {
    return primKeyAndIndexes.split(",").map(function(index, indexNum) {
        index = index.trim();
        var name = index.replace(/([&*]|\+\+)/g, "");
        var keyPath = /^\[/.test(name) ? name.match(/^\[(.*)\]$/)[1].split("+") : name;
        return $2f895839ac78ac6c$var$createIndexSpec(name, keyPath || null, /\&/.test(index), /\*/.test(index), /\+\+/.test(index), $2f895839ac78ac6c$var$isArray(keyPath), indexNum === 0);
    });
}
var $2f895839ac78ac6c$var$Version = function() {
    function Version() {}
    Version.prototype._parseStoresSpec = function(stores, outSchema) {
        $2f895839ac78ac6c$var$keys(stores).forEach(function(tableName) {
            if (stores[tableName] !== null) {
                var indexes = $2f895839ac78ac6c$var$parseIndexSyntax(stores[tableName]);
                var primKey = indexes.shift();
                if (primKey.multi) throw new $2f895839ac78ac6c$var$exceptions.Schema("Primary key cannot be multi-valued");
                indexes.forEach(function(idx) {
                    if (idx.auto) throw new $2f895839ac78ac6c$var$exceptions.Schema("Only primary key can be marked as autoIncrement (++)");
                    if (!idx.keyPath) throw new $2f895839ac78ac6c$var$exceptions.Schema("Index must have a name and cannot be an empty string");
                });
                outSchema[tableName] = $2f895839ac78ac6c$var$createTableSchema(tableName, primKey, indexes);
            }
        });
    };
    Version.prototype.stores = function(stores) {
        var db = this.db;
        this._cfg.storesSource = this._cfg.storesSource ? $2f895839ac78ac6c$var$extend(this._cfg.storesSource, stores) : stores;
        var versions = db._versions;
        var storesSpec = {};
        var dbschema = {};
        versions.forEach(function(version) {
            $2f895839ac78ac6c$var$extend(storesSpec, version._cfg.storesSource);
            dbschema = version._cfg.dbschema = {};
            version._parseStoresSpec(storesSpec, dbschema);
        });
        db._dbSchema = dbschema;
        $2f895839ac78ac6c$var$removeTablesApi(db, [
            db._allTables,
            db,
            db.Transaction.prototype
        ]);
        $2f895839ac78ac6c$var$setApiOnPlace(db, [
            db._allTables,
            db,
            db.Transaction.prototype,
            this._cfg.tables
        ], $2f895839ac78ac6c$var$keys(dbschema), dbschema);
        db._storeNames = $2f895839ac78ac6c$var$keys(dbschema);
        return this;
    };
    Version.prototype.upgrade = function(upgradeFunction) {
        this._cfg.contentUpgrade = $2f895839ac78ac6c$var$promisableChain(this._cfg.contentUpgrade || $2f895839ac78ac6c$var$nop, upgradeFunction);
        return this;
    };
    return Version;
}();
function $2f895839ac78ac6c$var$createVersionConstructor(db) {
    return $2f895839ac78ac6c$var$makeClassConstructor($2f895839ac78ac6c$var$Version.prototype, function Version(versionNumber) {
        this.db = db;
        this._cfg = {
            version: versionNumber,
            storesSource: null,
            dbschema: {},
            tables: {},
            contentUpgrade: null
        };
    });
}
function $2f895839ac78ac6c$var$getDbNamesTable(indexedDB1, IDBKeyRange) {
    var dbNamesDB = indexedDB1["_dbNamesDB"];
    if (!dbNamesDB) {
        dbNamesDB = indexedDB1["_dbNamesDB"] = new $2f895839ac78ac6c$export$4ece27d405df7279($2f895839ac78ac6c$var$DBNAMES_DB, {
            addons: [],
            indexedDB: indexedDB1,
            IDBKeyRange: IDBKeyRange
        });
        dbNamesDB.version(1).stores({
            dbnames: "name"
        });
    }
    return dbNamesDB.table("dbnames");
}
function $2f895839ac78ac6c$var$hasDatabasesNative(indexedDB1) {
    return indexedDB1 && typeof indexedDB1.databases === "function";
}
function $2f895839ac78ac6c$var$getDatabaseNames(_a) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    return $2f895839ac78ac6c$var$hasDatabasesNative(indexedDB1) ? Promise.resolve(indexedDB1.databases()).then(function(infos) {
        return infos.map(function(info) {
            return info.name;
        }).filter(function(name) {
            return name !== $2f895839ac78ac6c$var$DBNAMES_DB;
        });
    }) : $2f895839ac78ac6c$var$getDbNamesTable(indexedDB1, IDBKeyRange).toCollection().primaryKeys();
}
function $2f895839ac78ac6c$var$_onDatabaseCreated(_a, name) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    !$2f895839ac78ac6c$var$hasDatabasesNative(indexedDB1) && name !== $2f895839ac78ac6c$var$DBNAMES_DB && $2f895839ac78ac6c$var$getDbNamesTable(indexedDB1, IDBKeyRange).put({
        name: name
    }).catch($2f895839ac78ac6c$var$nop);
}
function $2f895839ac78ac6c$var$_onDatabaseDeleted(_a, name) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    !$2f895839ac78ac6c$var$hasDatabasesNative(indexedDB1) && name !== $2f895839ac78ac6c$var$DBNAMES_DB && $2f895839ac78ac6c$var$getDbNamesTable(indexedDB1, IDBKeyRange).delete(name).catch($2f895839ac78ac6c$var$nop);
}
function $2f895839ac78ac6c$var$vip(fn) {
    return $2f895839ac78ac6c$var$newScope(function() {
        $2f895839ac78ac6c$var$PSD.letThrough = true;
        return fn();
    });
}
function $2f895839ac78ac6c$var$idbReady() {
    var isSafari = !navigator.userAgentData && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\//.test(navigator.userAgent);
    if (!isSafari || !indexedDB.databases) return Promise.resolve();
    var intervalId;
    return new Promise(function(resolve) {
        var tryIdb = function() {
            return indexedDB.databases().finally(resolve);
        };
        intervalId = setInterval(tryIdb, 100);
        tryIdb();
    }).finally(function() {
        return clearInterval(intervalId);
    });
}
function $2f895839ac78ac6c$var$dexieOpen(db) {
    var state = db._state;
    var indexedDB1 = db._deps.indexedDB;
    if (state.isBeingOpened || db.idbdb) return state.dbReadyPromise.then(function() {
        return state.dbOpenError ? $2f895839ac78ac6c$var$rejection(state.dbOpenError) : db;
    });
    $2f895839ac78ac6c$var$debug && (state.openCanceller._stackHolder = $2f895839ac78ac6c$var$getErrorWithStack());
    state.isBeingOpened = true;
    state.dbOpenError = null;
    state.openComplete = false;
    var openCanceller = state.openCanceller;
    function throwIfCancelled() {
        if (state.openCanceller !== openCanceller) throw new $2f895839ac78ac6c$var$exceptions.DatabaseClosed("db.open() was cancelled");
    }
    var resolveDbReady = state.dbReadyResolve, upgradeTransaction = null, wasCreated = false;
    var tryOpenDB = function() {
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            throwIfCancelled();
            if (!indexedDB1) throw new $2f895839ac78ac6c$var$exceptions.MissingAPI();
            var dbName = db.name;
            var req = state.autoSchema ? indexedDB1.open(dbName) : indexedDB1.open(dbName, Math.round(db.verno * 10));
            if (!req) throw new $2f895839ac78ac6c$var$exceptions.MissingAPI();
            req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
            req.onblocked = $2f895839ac78ac6c$var$wrap(db._fireOnBlocked);
            req.onupgradeneeded = $2f895839ac78ac6c$var$wrap(function(e) {
                upgradeTransaction = req.transaction;
                if (state.autoSchema && !db._options.allowEmptyDB) {
                    req.onerror = $2f895839ac78ac6c$var$preventDefault;
                    upgradeTransaction.abort();
                    req.result.close();
                    var delreq = indexedDB1.deleteDatabase(dbName);
                    delreq.onsuccess = delreq.onerror = $2f895839ac78ac6c$var$wrap(function() {
                        reject(new $2f895839ac78ac6c$var$exceptions.NoSuchDatabase("Database " + dbName + " doesnt exist"));
                    });
                } else {
                    upgradeTransaction.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                    var oldVer = e.oldVersion > Math.pow(2, 62) ? 0 : e.oldVersion;
                    wasCreated = oldVer < 1;
                    db._novip.idbdb = req.result;
                    $2f895839ac78ac6c$var$runUpgraders(db, oldVer / 10, upgradeTransaction, reject);
                }
            }, reject);
            req.onsuccess = $2f895839ac78ac6c$var$wrap(function() {
                upgradeTransaction = null;
                var idbdb = db._novip.idbdb = req.result;
                var objectStoreNames = $2f895839ac78ac6c$var$slice(idbdb.objectStoreNames);
                if (objectStoreNames.length > 0) try {
                    var tmpTrans = idbdb.transaction($2f895839ac78ac6c$var$safariMultiStoreFix(objectStoreNames), "readonly");
                    if (state.autoSchema) $2f895839ac78ac6c$var$readGlobalSchema(db, idbdb, tmpTrans);
                    else {
                        $2f895839ac78ac6c$var$adjustToExistingIndexNames(db, db._dbSchema, tmpTrans);
                        if (!$2f895839ac78ac6c$var$verifyInstalledSchema(db, tmpTrans)) console.warn("Dexie SchemaDiff: Schema was extended without increasing the number passed to db.version(). Some queries may fail.");
                    }
                    $2f895839ac78ac6c$var$generateMiddlewareStacks(db, tmpTrans);
                } catch (e) {}
                $2f895839ac78ac6c$var$connections.push(db);
                idbdb.onversionchange = $2f895839ac78ac6c$var$wrap(function(ev) {
                    state.vcFired = true;
                    db.on("versionchange").fire(ev);
                });
                idbdb.onclose = $2f895839ac78ac6c$var$wrap(function(ev) {
                    db.on("close").fire(ev);
                });
                if (wasCreated) $2f895839ac78ac6c$var$_onDatabaseCreated(db._deps, dbName);
                resolve();
            }, reject);
        }).catch(function(err) {
            if (err && err.name === "UnknownError" && state.PR1398_maxLoop > 0) {
                state.PR1398_maxLoop--;
                console.warn("Dexie: Workaround for Chrome UnknownError on open()");
                return tryOpenDB();
            } else return $2f895839ac78ac6c$var$DexiePromise.reject(err);
        });
    };
    return $2f895839ac78ac6c$var$DexiePromise.race([
        openCanceller,
        (typeof navigator === "undefined" ? $2f895839ac78ac6c$var$DexiePromise.resolve() : $2f895839ac78ac6c$var$idbReady()).then(tryOpenDB)
    ]).then(function() {
        throwIfCancelled();
        state.onReadyBeingFired = [];
        return $2f895839ac78ac6c$var$DexiePromise.resolve($2f895839ac78ac6c$var$vip(function() {
            return db.on.ready.fire(db.vip);
        })).then(function fireRemainders() {
            if (state.onReadyBeingFired.length > 0) {
                var remainders_1 = state.onReadyBeingFired.reduce($2f895839ac78ac6c$var$promisableChain, $2f895839ac78ac6c$var$nop);
                state.onReadyBeingFired = [];
                return $2f895839ac78ac6c$var$DexiePromise.resolve($2f895839ac78ac6c$var$vip(function() {
                    return remainders_1(db.vip);
                })).then(fireRemainders);
            }
        });
    }).finally(function() {
        state.onReadyBeingFired = null;
        state.isBeingOpened = false;
    }).then(function() {
        return db;
    }).catch(function(err) {
        state.dbOpenError = err;
        try {
            upgradeTransaction && upgradeTransaction.abort();
        } catch (_a) {}
        if (openCanceller === state.openCanceller) db._close();
        return $2f895839ac78ac6c$var$rejection(err);
    }).finally(function() {
        state.openComplete = true;
        resolveDbReady();
    });
}
function $2f895839ac78ac6c$var$awaitIterator(iterator) {
    var callNext = function(result) {
        return iterator.next(result);
    }, doThrow = function(error) {
        return iterator.throw(error);
    }, onSuccess = step(callNext), onError = step(doThrow);
    function step(getNext) {
        return function(val) {
            var next = getNext(val), value = next.value;
            return next.done ? value : !value || typeof value.then !== "function" ? $2f895839ac78ac6c$var$isArray(value) ? Promise.all(value).then(onSuccess, onError) : onSuccess(value) : value.then(onSuccess, onError);
        };
    }
    return step(callNext)();
}
function $2f895839ac78ac6c$var$extractTransactionArgs(mode, _tableArgs_, scopeFunc) {
    var i = arguments.length;
    if (i < 2) throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Too few arguments");
    var args = new Array(i - 1);
    while(--i)args[i - 1] = arguments[i];
    scopeFunc = args.pop();
    var tables = $2f895839ac78ac6c$var$flatten(args);
    return [
        mode,
        tables,
        scopeFunc
    ];
}
function $2f895839ac78ac6c$var$enterTransactionScope(db, mode, storeNames, parentTransaction, scopeFunc) {
    return $2f895839ac78ac6c$var$DexiePromise.resolve().then(function() {
        var transless = $2f895839ac78ac6c$var$PSD.transless || $2f895839ac78ac6c$var$PSD;
        var trans = db._createTransaction(mode, storeNames, db._dbSchema, parentTransaction);
        var zoneProps = {
            trans: trans,
            transless: transless
        };
        if (parentTransaction) trans.idbtrans = parentTransaction.idbtrans;
        else try {
            trans.create();
            db._state.PR1398_maxLoop = 3;
        } catch (ex) {
            if (ex.name === $2f895839ac78ac6c$var$errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                console.warn("Dexie: Need to reopen db");
                db._close();
                return db.open().then(function() {
                    return $2f895839ac78ac6c$var$enterTransactionScope(db, mode, storeNames, null, scopeFunc);
                });
            }
            return $2f895839ac78ac6c$var$rejection(ex);
        }
        var scopeFuncIsAsync = $2f895839ac78ac6c$var$isAsyncFunction(scopeFunc);
        if (scopeFuncIsAsync) $2f895839ac78ac6c$var$incrementExpectedAwaits();
        var returnValue;
        var promiseFollowed = $2f895839ac78ac6c$var$DexiePromise.follow(function() {
            returnValue = scopeFunc.call(trans, trans);
            if (returnValue) {
                if (scopeFuncIsAsync) {
                    var decrementor = $2f895839ac78ac6c$var$decrementExpectedAwaits.bind(null, null);
                    returnValue.then(decrementor, decrementor);
                } else if (typeof returnValue.next === "function" && typeof returnValue.throw === "function") returnValue = $2f895839ac78ac6c$var$awaitIterator(returnValue);
            }
        }, zoneProps);
        return (returnValue && typeof returnValue.then === "function" ? $2f895839ac78ac6c$var$DexiePromise.resolve(returnValue).then(function(x) {
            return trans.active ? x : $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn"));
        }) : promiseFollowed.then(function() {
            return returnValue;
        })).then(function(x) {
            if (parentTransaction) trans._resolve();
            return trans._completion.then(function() {
                return x;
            });
        }).catch(function(e) {
            trans._reject(e);
            return $2f895839ac78ac6c$var$rejection(e);
        });
    });
}
function $2f895839ac78ac6c$var$pad(a, value, count) {
    var result = $2f895839ac78ac6c$var$isArray(a) ? a.slice() : [
        a
    ];
    for(var i = 0; i < count; ++i)result.push(value);
    return result;
}
function $2f895839ac78ac6c$var$createVirtualIndexMiddleware(down) {
    return $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, down), {
        table: function(tableName) {
            var table = down.table(tableName);
            var schema = table.schema;
            var indexLookup = {};
            var allVirtualIndexes = [];
            function addVirtualIndexes(keyPath, keyTail, lowLevelIndex) {
                var keyPathAlias = $2f895839ac78ac6c$var$getKeyPathAlias(keyPath);
                var indexList = indexLookup[keyPathAlias] = indexLookup[keyPathAlias] || [];
                var keyLength = keyPath == null ? 0 : typeof keyPath === "string" ? 1 : keyPath.length;
                var isVirtual = keyTail > 0;
                var virtualIndex = $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, lowLevelIndex), {
                    isVirtual: isVirtual,
                    keyTail: keyTail,
                    keyLength: keyLength,
                    extractKey: $2f895839ac78ac6c$var$getKeyExtractor(keyPath),
                    unique: !isVirtual && lowLevelIndex.unique
                });
                indexList.push(virtualIndex);
                if (!virtualIndex.isPrimaryKey) allVirtualIndexes.push(virtualIndex);
                if (keyLength > 1) {
                    var virtualKeyPath = keyLength === 2 ? keyPath[0] : keyPath.slice(0, keyLength - 1);
                    addVirtualIndexes(virtualKeyPath, keyTail + 1, lowLevelIndex);
                }
                indexList.sort(function(a, b) {
                    return a.keyTail - b.keyTail;
                });
                return virtualIndex;
            }
            var primaryKey = addVirtualIndexes(schema.primaryKey.keyPath, 0, schema.primaryKey);
            indexLookup[":id"] = [
                primaryKey
            ];
            for(var _i = 0, _a = schema.indexes; _i < _a.length; _i++){
                var index = _a[_i];
                addVirtualIndexes(index.keyPath, 0, index);
            }
            function findBestIndex(keyPath) {
                var result = indexLookup[$2f895839ac78ac6c$var$getKeyPathAlias(keyPath)];
                return result && result[0];
            }
            function translateRange(range, keyTail) {
                return {
                    type: range.type === 1 ? 2 : range.type,
                    lower: $2f895839ac78ac6c$var$pad(range.lower, range.lowerOpen ? down.MAX_KEY : down.MIN_KEY, keyTail),
                    lowerOpen: true,
                    upper: $2f895839ac78ac6c$var$pad(range.upper, range.upperOpen ? down.MIN_KEY : down.MAX_KEY, keyTail),
                    upperOpen: true
                };
            }
            function translateRequest(req) {
                var index = req.query.index;
                return index.isVirtual ? $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, req), {
                    query: {
                        index: index,
                        range: translateRange(req.query.range, index.keyTail)
                    }
                }) : req;
            }
            var result = $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, table), {
                schema: $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, schema), {
                    primaryKey: primaryKey,
                    indexes: allVirtualIndexes,
                    getIndexByKeyPath: findBestIndex
                }),
                count: function(req) {
                    return table.count(translateRequest(req));
                },
                query: function(req) {
                    return table.query(translateRequest(req));
                },
                openCursor: function(req) {
                    var _a = req.query.index, keyTail = _a.keyTail, isVirtual = _a.isVirtual, keyLength = _a.keyLength;
                    if (!isVirtual) return table.openCursor(req);
                    function createVirtualCursor(cursor) {
                        function _continue(key) {
                            key != null ? cursor.continue($2f895839ac78ac6c$var$pad(key, req.reverse ? down.MAX_KEY : down.MIN_KEY, keyTail)) : req.unique ? cursor.continue(cursor.key.slice(0, keyLength).concat(req.reverse ? down.MIN_KEY : down.MAX_KEY, keyTail)) : cursor.continue();
                        }
                        var virtualCursor = Object.create(cursor, {
                            continue: {
                                value: _continue
                            },
                            continuePrimaryKey: {
                                value: function(key, primaryKey) {
                                    cursor.continuePrimaryKey($2f895839ac78ac6c$var$pad(key, down.MAX_KEY, keyTail), primaryKey);
                                }
                            },
                            primaryKey: {
                                get: function() {
                                    return cursor.primaryKey;
                                }
                            },
                            key: {
                                get: function() {
                                    var key = cursor.key;
                                    return keyLength === 1 ? key[0] : key.slice(0, keyLength);
                                }
                            },
                            value: {
                                get: function() {
                                    return cursor.value;
                                }
                            }
                        });
                        return virtualCursor;
                    }
                    return table.openCursor(translateRequest(req)).then(function(cursor) {
                        return cursor && createVirtualCursor(cursor);
                    });
                }
            });
            return result;
        }
    });
}
var $2f895839ac78ac6c$var$virtualIndexMiddleware = {
    stack: "dbcore",
    name: "VirtualIndexMiddleware",
    level: 1,
    create: $2f895839ac78ac6c$var$createVirtualIndexMiddleware
};
function $2f895839ac78ac6c$var$getObjectDiff(a, b, rv, prfx) {
    rv = rv || {};
    prfx = prfx || "";
    $2f895839ac78ac6c$var$keys(a).forEach(function(prop) {
        if (!$2f895839ac78ac6c$var$hasOwn(b, prop)) rv[prfx + prop] = undefined;
        else {
            var ap = a[prop], bp = b[prop];
            if (typeof ap === "object" && typeof bp === "object" && ap && bp) {
                var apTypeName = $2f895839ac78ac6c$var$toStringTag(ap);
                var bpTypeName = $2f895839ac78ac6c$var$toStringTag(bp);
                if (apTypeName !== bpTypeName) rv[prfx + prop] = b[prop];
                else if (apTypeName === "Object") $2f895839ac78ac6c$var$getObjectDiff(ap, bp, rv, prfx + prop + ".");
                else if (ap !== bp) rv[prfx + prop] = b[prop];
            } else if (ap !== bp) rv[prfx + prop] = b[prop];
        }
    });
    $2f895839ac78ac6c$var$keys(b).forEach(function(prop) {
        if (!$2f895839ac78ac6c$var$hasOwn(a, prop)) rv[prfx + prop] = b[prop];
    });
    return rv;
}
function $2f895839ac78ac6c$var$getEffectiveKeys(primaryKey, req) {
    if (req.type === "delete") return req.keys;
    return req.keys || req.values.map(primaryKey.extractKey);
}
var $2f895839ac78ac6c$var$hooksMiddleware = {
    stack: "dbcore",
    name: "HooksMiddleware",
    level: 2,
    create: function(downCore) {
        return $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, downCore), {
            table: function(tableName) {
                var downTable = downCore.table(tableName);
                var primaryKey = downTable.schema.primaryKey;
                var tableMiddleware = $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, downTable), {
                    mutate: function(req) {
                        var dxTrans = $2f895839ac78ac6c$var$PSD.trans;
                        var _a = dxTrans.table(tableName).hook, deleting = _a.deleting, creating = _a.creating, updating = _a.updating;
                        switch(req.type){
                            case "add":
                                if (creating.fire === $2f895839ac78ac6c$var$nop) break;
                                return dxTrans._promise("readwrite", function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case "put":
                                if (creating.fire === $2f895839ac78ac6c$var$nop && updating.fire === $2f895839ac78ac6c$var$nop) break;
                                return dxTrans._promise("readwrite", function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case "delete":
                                if (deleting.fire === $2f895839ac78ac6c$var$nop) break;
                                return dxTrans._promise("readwrite", function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case "deleteRange":
                                if (deleting.fire === $2f895839ac78ac6c$var$nop) break;
                                return dxTrans._promise("readwrite", function() {
                                    return deleteRange(req);
                                }, true);
                        }
                        return downTable.mutate(req);
                        function addPutOrDelete(req) {
                            var dxTrans = $2f895839ac78ac6c$var$PSD.trans;
                            var keys = req.keys || $2f895839ac78ac6c$var$getEffectiveKeys(primaryKey, req);
                            if (!keys) throw new Error("Keys missing");
                            req = req.type === "add" || req.type === "put" ? $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, req), {
                                keys: keys
                            }) : $2f895839ac78ac6c$var$__assign({}, req);
                            if (req.type !== "delete") req.values = $2f895839ac78ac6c$var$__spreadArray([], req.values, true);
                            if (req.keys) req.keys = $2f895839ac78ac6c$var$__spreadArray([], req.keys, true);
                            return $2f895839ac78ac6c$var$getExistingValues(downTable, req, keys).then(function(existingValues) {
                                var contexts = keys.map(function(key, i) {
                                    var existingValue = existingValues[i];
                                    var ctx = {
                                        onerror: null,
                                        onsuccess: null
                                    };
                                    if (req.type === "delete") deleting.fire.call(ctx, key, existingValue, dxTrans);
                                    else if (req.type === "add" || existingValue === undefined) {
                                        var generatedPrimaryKey = creating.fire.call(ctx, key, req.values[i], dxTrans);
                                        if (key == null && generatedPrimaryKey != null) {
                                            key = generatedPrimaryKey;
                                            req.keys[i] = key;
                                            if (!primaryKey.outbound) $2f895839ac78ac6c$var$setByKeyPath(req.values[i], primaryKey.keyPath, key);
                                        }
                                    } else {
                                        var objectDiff = $2f895839ac78ac6c$var$getObjectDiff(existingValue, req.values[i]);
                                        var additionalChanges_1 = updating.fire.call(ctx, objectDiff, key, existingValue, dxTrans);
                                        if (additionalChanges_1) {
                                            var requestedValue_1 = req.values[i];
                                            Object.keys(additionalChanges_1).forEach(function(keyPath) {
                                                if ($2f895839ac78ac6c$var$hasOwn(requestedValue_1, keyPath)) requestedValue_1[keyPath] = additionalChanges_1[keyPath];
                                                else $2f895839ac78ac6c$var$setByKeyPath(requestedValue_1, keyPath, additionalChanges_1[keyPath]);
                                            });
                                        }
                                    }
                                    return ctx;
                                });
                                return downTable.mutate(req).then(function(_a) {
                                    var failures = _a.failures, results = _a.results, numFailures = _a.numFailures, lastResult = _a.lastResult;
                                    for(var i = 0; i < keys.length; ++i){
                                        var primKey = results ? results[i] : keys[i];
                                        var ctx = contexts[i];
                                        if (primKey == null) ctx.onerror && ctx.onerror(failures[i]);
                                        else ctx.onsuccess && ctx.onsuccess(req.type === "put" && existingValues[i] ? req.values[i] : primKey);
                                    }
                                    return {
                                        failures: failures,
                                        results: results,
                                        numFailures: numFailures,
                                        lastResult: lastResult
                                    };
                                }).catch(function(error) {
                                    contexts.forEach(function(ctx) {
                                        return ctx.onerror && ctx.onerror(error);
                                    });
                                    return Promise.reject(error);
                                });
                            });
                        }
                        function deleteRange(req) {
                            return deleteNextChunk(req.trans, req.range, 10000);
                        }
                        function deleteNextChunk(trans, range, limit) {
                            return downTable.query({
                                trans: trans,
                                values: false,
                                query: {
                                    index: primaryKey,
                                    range: range
                                },
                                limit: limit
                            }).then(function(_a) {
                                var result = _a.result;
                                return addPutOrDelete({
                                    type: "delete",
                                    keys: result,
                                    trans: trans
                                }).then(function(res) {
                                    if (res.numFailures > 0) return Promise.reject(res.failures[0]);
                                    if (result.length < limit) return {
                                        failures: [],
                                        numFailures: 0,
                                        lastResult: undefined
                                    };
                                    else return deleteNextChunk(trans, $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, range), {
                                        lower: result[result.length - 1],
                                        lowerOpen: true
                                    }), limit);
                                });
                            });
                        }
                    }
                });
                return tableMiddleware;
            }
        });
    }
};
function $2f895839ac78ac6c$var$getExistingValues(table, req, effectiveKeys) {
    return req.type === "add" ? Promise.resolve([]) : table.getMany({
        trans: req.trans,
        keys: effectiveKeys,
        cache: "immutable"
    });
}
function $2f895839ac78ac6c$var$getFromTransactionCache(keys, cache, clone) {
    try {
        if (!cache) return null;
        if (cache.keys.length < keys.length) return null;
        var result = [];
        for(var i = 0, j = 0; i < cache.keys.length && j < keys.length; ++i){
            if ($2f895839ac78ac6c$var$cmp(cache.keys[i], keys[j]) !== 0) continue;
            result.push(clone ? $2f895839ac78ac6c$var$deepClone(cache.values[i]) : cache.values[i]);
            ++j;
        }
        return result.length === keys.length ? result : null;
    } catch (_a) {
        return null;
    }
}
var $2f895839ac78ac6c$var$cacheExistingValuesMiddleware = {
    stack: "dbcore",
    level: -1,
    create: function(core) {
        return {
            table: function(tableName) {
                var table = core.table(tableName);
                return $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, table), {
                    getMany: function(req) {
                        if (!req.cache) return table.getMany(req);
                        var cachedResult = $2f895839ac78ac6c$var$getFromTransactionCache(req.keys, req.trans["_cache"], req.cache === "clone");
                        if (cachedResult) return $2f895839ac78ac6c$var$DexiePromise.resolve(cachedResult);
                        return table.getMany(req).then(function(res) {
                            req.trans["_cache"] = {
                                keys: req.keys,
                                values: req.cache === "clone" ? $2f895839ac78ac6c$var$deepClone(res) : res
                            };
                            return res;
                        });
                    },
                    mutate: function(req) {
                        if (req.type !== "add") req.trans["_cache"] = null;
                        return table.mutate(req);
                    }
                });
            }
        };
    }
};
var $2f895839ac78ac6c$var$_a;
function $2f895839ac78ac6c$var$isEmptyRange(node) {
    return !("from" in node);
}
var $2f895839ac78ac6c$export$34cb5241245008dd = function(fromOrTree, to) {
    if (this) $2f895839ac78ac6c$var$extend(this, arguments.length ? {
        d: 1,
        from: fromOrTree,
        to: arguments.length > 1 ? to : fromOrTree
    } : {
        d: 0
    });
    else {
        var rv = new $2f895839ac78ac6c$export$34cb5241245008dd();
        if (fromOrTree && "d" in fromOrTree) $2f895839ac78ac6c$var$extend(rv, fromOrTree);
        return rv;
    }
};
$2f895839ac78ac6c$var$props($2f895839ac78ac6c$export$34cb5241245008dd.prototype, ($2f895839ac78ac6c$var$_a = {
    add: function(rangeSet) {
        $2f895839ac78ac6c$export$4876cc3130d3f820(this, rangeSet);
        return this;
    },
    addKey: function(key) {
        $2f895839ac78ac6c$var$addRange(this, key, key);
        return this;
    },
    addKeys: function(keys) {
        var _this = this;
        keys.forEach(function(key) {
            return $2f895839ac78ac6c$var$addRange(_this, key, key);
        });
        return this;
    }
}, $2f895839ac78ac6c$var$_a[$2f895839ac78ac6c$var$iteratorSymbol] = function() {
    return $2f895839ac78ac6c$var$getRangeSetIterator(this);
}, $2f895839ac78ac6c$var$_a));
function $2f895839ac78ac6c$var$addRange(target, from, to) {
    var diff = $2f895839ac78ac6c$var$cmp(from, to);
    if (isNaN(diff)) return;
    if (diff > 0) throw RangeError();
    if ($2f895839ac78ac6c$var$isEmptyRange(target)) return $2f895839ac78ac6c$var$extend(target, {
        from: from,
        to: to,
        d: 1
    });
    var left = target.l;
    var right = target.r;
    if ($2f895839ac78ac6c$var$cmp(to, target.from) < 0) {
        left ? $2f895839ac78ac6c$var$addRange(left, from, to) : target.l = {
            from: from,
            to: to,
            d: 1,
            l: null,
            r: null
        };
        return $2f895839ac78ac6c$var$rebalance(target);
    }
    if ($2f895839ac78ac6c$var$cmp(from, target.to) > 0) {
        right ? $2f895839ac78ac6c$var$addRange(right, from, to) : target.r = {
            from: from,
            to: to,
            d: 1,
            l: null,
            r: null
        };
        return $2f895839ac78ac6c$var$rebalance(target);
    }
    if ($2f895839ac78ac6c$var$cmp(from, target.from) < 0) {
        target.from = from;
        target.l = null;
        target.d = right ? right.d + 1 : 1;
    }
    if ($2f895839ac78ac6c$var$cmp(to, target.to) > 0) {
        target.to = to;
        target.r = null;
        target.d = target.l ? target.l.d + 1 : 1;
    }
    var rightWasCutOff = !target.r;
    if (left && !target.l) $2f895839ac78ac6c$export$4876cc3130d3f820(target, left);
    if (right && rightWasCutOff) $2f895839ac78ac6c$export$4876cc3130d3f820(target, right);
}
function $2f895839ac78ac6c$export$4876cc3130d3f820(target, newSet) {
    function _addRangeSet(target, _a) {
        var from = _a.from, to = _a.to, l = _a.l, r = _a.r;
        $2f895839ac78ac6c$var$addRange(target, from, to);
        if (l) _addRangeSet(target, l);
        if (r) _addRangeSet(target, r);
    }
    if (!$2f895839ac78ac6c$var$isEmptyRange(newSet)) _addRangeSet(target, newSet);
}
function $2f895839ac78ac6c$export$8f43b23b5d8de905(rangeSet1, rangeSet2) {
    var i1 = $2f895839ac78ac6c$var$getRangeSetIterator(rangeSet2);
    var nextResult1 = i1.next();
    if (nextResult1.done) return false;
    var a = nextResult1.value;
    var i2 = $2f895839ac78ac6c$var$getRangeSetIterator(rangeSet1);
    var nextResult2 = i2.next(a.from);
    var b = nextResult2.value;
    while(!nextResult1.done && !nextResult2.done){
        if ($2f895839ac78ac6c$var$cmp(b.from, a.to) <= 0 && $2f895839ac78ac6c$var$cmp(b.to, a.from) >= 0) return true;
        $2f895839ac78ac6c$var$cmp(a.from, b.from) < 0 ? a = (nextResult1 = i1.next(b.from)).value : b = (nextResult2 = i2.next(a.from)).value;
    }
    return false;
}
function $2f895839ac78ac6c$var$getRangeSetIterator(node) {
    var state = $2f895839ac78ac6c$var$isEmptyRange(node) ? null : {
        s: 0,
        n: node
    };
    return {
        next: function(key) {
            var keyProvided = arguments.length > 0;
            while(state)switch(state.s){
                case 0:
                    state.s = 1;
                    if (keyProvided) while(state.n.l && $2f895839ac78ac6c$var$cmp(key, state.n.from) < 0)state = {
                        up: state,
                        n: state.n.l,
                        s: 1
                    };
                    else while(state.n.l)state = {
                        up: state,
                        n: state.n.l,
                        s: 1
                    };
                case 1:
                    state.s = 2;
                    if (!keyProvided || $2f895839ac78ac6c$var$cmp(key, state.n.to) <= 0) return {
                        value: state.n,
                        done: false
                    };
                case 2:
                    if (state.n.r) {
                        state.s = 3;
                        state = {
                            up: state,
                            n: state.n.r,
                            s: 0
                        };
                        continue;
                    }
                case 3:
                    state = state.up;
            }
            return {
                done: true
            };
        }
    };
}
function $2f895839ac78ac6c$var$rebalance(target) {
    var _a, _b;
    var diff = (((_a = target.r) === null || _a === void 0 ? void 0 : _a.d) || 0) - (((_b = target.l) === null || _b === void 0 ? void 0 : _b.d) || 0);
    var r = diff > 1 ? "r" : diff < -1 ? "l" : "";
    if (r) {
        var l = r === "r" ? "l" : "r";
        var rootClone = $2f895839ac78ac6c$var$__assign({}, target);
        var oldRootRight = target[r];
        target.from = oldRootRight.from;
        target.to = oldRootRight.to;
        target[r] = oldRootRight[r];
        rootClone[r] = oldRootRight[l];
        target[l] = rootClone;
        rootClone.d = $2f895839ac78ac6c$var$computeDepth(rootClone);
    }
    target.d = $2f895839ac78ac6c$var$computeDepth(target);
}
function $2f895839ac78ac6c$var$computeDepth(_a) {
    var r = _a.r, l = _a.l;
    return (r ? l ? Math.max(r.d, l.d) : r.d : l ? l.d : 0) + 1;
}
var $2f895839ac78ac6c$var$observabilityMiddleware = {
    stack: "dbcore",
    level: 0,
    create: function(core) {
        var dbName = core.schema.name;
        var FULL_RANGE = new $2f895839ac78ac6c$export$34cb5241245008dd(core.MIN_KEY, core.MAX_KEY);
        return $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, core), {
            table: function(tableName) {
                var table = core.table(tableName);
                var schema = table.schema;
                var primaryKey = schema.primaryKey;
                var extractKey = primaryKey.extractKey, outbound = primaryKey.outbound;
                var tableClone = $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, table), {
                    mutate: function(req) {
                        var trans = req.trans;
                        var mutatedParts = trans.mutatedParts || (trans.mutatedParts = {});
                        var getRangeSet = function(indexName) {
                            var part = "idb://" + dbName + "/" + tableName + "/" + indexName;
                            return mutatedParts[part] || (mutatedParts[part] = new $2f895839ac78ac6c$export$34cb5241245008dd());
                        };
                        var pkRangeSet = getRangeSet("");
                        var delsRangeSet = getRangeSet(":dels");
                        var type = req.type;
                        var _a = req.type === "deleteRange" ? [
                            req.range
                        ] : req.type === "delete" ? [
                            req.keys
                        ] : req.values.length < 50 ? [
                            [],
                            req.values
                        ] : [], keys = _a[0], newObjs = _a[1];
                        var oldCache = req.trans["_cache"];
                        return table.mutate(req).then(function(res) {
                            if ($2f895839ac78ac6c$var$isArray(keys)) {
                                if (type !== "delete") keys = res.results;
                                pkRangeSet.addKeys(keys);
                                var oldObjs = $2f895839ac78ac6c$var$getFromTransactionCache(keys, oldCache);
                                if (!oldObjs && type !== "add") delsRangeSet.addKeys(keys);
                                if (oldObjs || newObjs) $2f895839ac78ac6c$var$trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs);
                            } else if (keys) {
                                var range = {
                                    from: keys.lower,
                                    to: keys.upper
                                };
                                delsRangeSet.add(range);
                                pkRangeSet.add(range);
                            } else {
                                pkRangeSet.add(FULL_RANGE);
                                delsRangeSet.add(FULL_RANGE);
                                schema.indexes.forEach(function(idx) {
                                    return getRangeSet(idx.name).add(FULL_RANGE);
                                });
                            }
                            return res;
                        });
                    }
                });
                var getRange = function(_a) {
                    var _b, _c;
                    var _d = _a.query, index = _d.index, range = _d.range;
                    return [
                        index,
                        new $2f895839ac78ac6c$export$34cb5241245008dd((_b = range.lower) !== null && _b !== void 0 ? _b : core.MIN_KEY, (_c = range.upper) !== null && _c !== void 0 ? _c : core.MAX_KEY)
                    ];
                };
                var readSubscribers = {
                    get: function(req) {
                        return [
                            primaryKey,
                            new $2f895839ac78ac6c$export$34cb5241245008dd(req.key)
                        ];
                    },
                    getMany: function(req) {
                        return [
                            primaryKey,
                            new $2f895839ac78ac6c$export$34cb5241245008dd().addKeys(req.keys)
                        ];
                    },
                    count: getRange,
                    query: getRange,
                    openCursor: getRange
                };
                $2f895839ac78ac6c$var$keys(readSubscribers).forEach(function(method) {
                    tableClone[method] = function(req) {
                        var subscr = $2f895839ac78ac6c$var$PSD.subscr;
                        if (subscr) {
                            var getRangeSet = function(indexName) {
                                var part = "idb://" + dbName + "/" + tableName + "/" + indexName;
                                return subscr[part] || (subscr[part] = new $2f895839ac78ac6c$export$34cb5241245008dd());
                            };
                            var pkRangeSet_1 = getRangeSet("");
                            var delsRangeSet_1 = getRangeSet(":dels");
                            var _a = readSubscribers[method](req), queriedIndex = _a[0], queriedRanges = _a[1];
                            getRangeSet(queriedIndex.name || "").add(queriedRanges);
                            if (!queriedIndex.isPrimaryKey) {
                                if (method === "count") delsRangeSet_1.add(FULL_RANGE);
                                else {
                                    var keysPromise_1 = method === "query" && outbound && req.values && table.query($2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, req), {
                                        values: false
                                    }));
                                    return table[method].apply(this, arguments).then(function(res) {
                                        if (method === "query") {
                                            if (outbound && req.values) return keysPromise_1.then(function(_a) {
                                                var resultingKeys = _a.result;
                                                pkRangeSet_1.addKeys(resultingKeys);
                                                return res;
                                            });
                                            var pKeys = req.values ? res.result.map(extractKey) : res.result;
                                            if (req.values) pkRangeSet_1.addKeys(pKeys);
                                            else delsRangeSet_1.addKeys(pKeys);
                                        } else if (method === "openCursor") {
                                            var cursor_1 = res;
                                            var wantValues_1 = req.values;
                                            return cursor_1 && Object.create(cursor_1, {
                                                key: {
                                                    get: function() {
                                                        delsRangeSet_1.addKey(cursor_1.primaryKey);
                                                        return cursor_1.key;
                                                    }
                                                },
                                                primaryKey: {
                                                    get: function() {
                                                        var pkey = cursor_1.primaryKey;
                                                        delsRangeSet_1.addKey(pkey);
                                                        return pkey;
                                                    }
                                                },
                                                value: {
                                                    get: function() {
                                                        wantValues_1 && pkRangeSet_1.addKey(cursor_1.primaryKey);
                                                        return cursor_1.value;
                                                    }
                                                }
                                            });
                                        }
                                        return res;
                                    });
                                }
                            }
                        }
                        return table[method].apply(this, arguments);
                    };
                });
                return tableClone;
            }
        });
    }
};
function $2f895839ac78ac6c$var$trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs) {
    function addAffectedIndex(ix) {
        var rangeSet = getRangeSet(ix.name || "");
        function extractKey(obj) {
            return obj != null ? ix.extractKey(obj) : null;
        }
        var addKeyOrKeys = function(key) {
            return ix.multiEntry && $2f895839ac78ac6c$var$isArray(key) ? key.forEach(function(key) {
                return rangeSet.addKey(key);
            }) : rangeSet.addKey(key);
        };
        (oldObjs || newObjs).forEach(function(_, i) {
            var oldKey = oldObjs && extractKey(oldObjs[i]);
            var newKey = newObjs && extractKey(newObjs[i]);
            if ($2f895839ac78ac6c$var$cmp(oldKey, newKey) !== 0) {
                if (oldKey != null) addKeyOrKeys(oldKey);
                if (newKey != null) addKeyOrKeys(newKey);
            }
        });
    }
    schema.indexes.forEach(addAffectedIndex);
}
var $2f895839ac78ac6c$export$4ece27d405df7279 = function() {
    function Dexie(name, options) {
        var _this = this;
        this._middlewares = {};
        this.verno = 0;
        var deps = Dexie.dependencies;
        this._options = options = $2f895839ac78ac6c$var$__assign({
            addons: Dexie.addons,
            autoOpen: true,
            indexedDB: deps.indexedDB,
            IDBKeyRange: deps.IDBKeyRange
        }, options);
        this._deps = {
            indexedDB: options.indexedDB,
            IDBKeyRange: options.IDBKeyRange
        };
        var addons = options.addons;
        this._dbSchema = {};
        this._versions = [];
        this._storeNames = [];
        this._allTables = {};
        this.idbdb = null;
        this._novip = this;
        var state = {
            dbOpenError: null,
            isBeingOpened: false,
            onReadyBeingFired: null,
            openComplete: false,
            dbReadyResolve: $2f895839ac78ac6c$var$nop,
            dbReadyPromise: null,
            cancelOpen: $2f895839ac78ac6c$var$nop,
            openCanceller: null,
            autoSchema: true,
            PR1398_maxLoop: 3
        };
        state.dbReadyPromise = new $2f895839ac78ac6c$var$DexiePromise(function(resolve) {
            state.dbReadyResolve = resolve;
        });
        state.openCanceller = new $2f895839ac78ac6c$var$DexiePromise(function(_, reject) {
            state.cancelOpen = reject;
        });
        this._state = state;
        this.name = name;
        this.on = $2f895839ac78ac6c$var$Events(this, "populate", "blocked", "versionchange", "close", {
            ready: [
                $2f895839ac78ac6c$var$promisableChain,
                $2f895839ac78ac6c$var$nop
            ]
        });
        this.on.ready.subscribe = $2f895839ac78ac6c$var$override(this.on.ready.subscribe, function(subscribe) {
            return function(subscriber, bSticky) {
                Dexie.vip(function() {
                    var state = _this._state;
                    if (state.openComplete) {
                        if (!state.dbOpenError) $2f895839ac78ac6c$var$DexiePromise.resolve().then(subscriber);
                        if (bSticky) subscribe(subscriber);
                    } else if (state.onReadyBeingFired) {
                        state.onReadyBeingFired.push(subscriber);
                        if (bSticky) subscribe(subscriber);
                    } else {
                        subscribe(subscriber);
                        var db_1 = _this;
                        if (!bSticky) subscribe(function unsubscribe() {
                            db_1.on.ready.unsubscribe(subscriber);
                            db_1.on.ready.unsubscribe(unsubscribe);
                        });
                    }
                });
            };
        });
        this.Collection = $2f895839ac78ac6c$var$createCollectionConstructor(this);
        this.Table = $2f895839ac78ac6c$var$createTableConstructor(this);
        this.Transaction = $2f895839ac78ac6c$var$createTransactionConstructor(this);
        this.Version = $2f895839ac78ac6c$var$createVersionConstructor(this);
        this.WhereClause = $2f895839ac78ac6c$var$createWhereClauseConstructor(this);
        this.on("versionchange", function(ev) {
            if (ev.newVersion > 0) console.warn("Another connection wants to upgrade database '" + _this.name + "'. Closing db now to resume the upgrade.");
            else console.warn("Another connection wants to delete database '" + _this.name + "'. Closing db now to resume the delete request.");
            _this.close();
        });
        this.on("blocked", function(ev) {
            if (!ev.newVersion || ev.newVersion < ev.oldVersion) console.warn("Dexie.delete('" + _this.name + "') was blocked");
            else console.warn("Upgrade '" + _this.name + "' blocked by other connection holding version " + ev.oldVersion / 10);
        });
        this._maxKey = $2f895839ac78ac6c$var$getMaxKey(options.IDBKeyRange);
        this._createTransaction = function(mode, storeNames, dbschema, parentTransaction) {
            return new _this.Transaction(mode, storeNames, dbschema, _this._options.chromeTransactionDurability, parentTransaction);
        };
        this._fireOnBlocked = function(ev) {
            _this.on("blocked").fire(ev);
            $2f895839ac78ac6c$var$connections.filter(function(c) {
                return c.name === _this.name && c !== _this && !c._state.vcFired;
            }).map(function(c) {
                return c.on("versionchange").fire(ev);
            });
        };
        this.use($2f895839ac78ac6c$var$virtualIndexMiddleware);
        this.use($2f895839ac78ac6c$var$hooksMiddleware);
        this.use($2f895839ac78ac6c$var$observabilityMiddleware);
        this.use($2f895839ac78ac6c$var$cacheExistingValuesMiddleware);
        this.vip = Object.create(this, {
            _vip: {
                value: true
            }
        });
        addons.forEach(function(addon) {
            return addon(_this);
        });
    }
    Dexie.prototype.version = function(versionNumber) {
        if (isNaN(versionNumber) || versionNumber < 0.1) throw new $2f895839ac78ac6c$var$exceptions.Type("Given version is not a positive number");
        versionNumber = Math.round(versionNumber * 10) / 10;
        if (this.idbdb || this._state.isBeingOpened) throw new $2f895839ac78ac6c$var$exceptions.Schema("Cannot add version when database is open");
        this.verno = Math.max(this.verno, versionNumber);
        var versions = this._versions;
        var versionInstance = versions.filter(function(v) {
            return v._cfg.version === versionNumber;
        })[0];
        if (versionInstance) return versionInstance;
        versionInstance = new this.Version(versionNumber);
        versions.push(versionInstance);
        versions.sort($2f895839ac78ac6c$var$lowerVersionFirst);
        versionInstance.stores({});
        this._state.autoSchema = false;
        return versionInstance;
    };
    Dexie.prototype._whenReady = function(fn) {
        var _this = this;
        return this.idbdb && (this._state.openComplete || $2f895839ac78ac6c$var$PSD.letThrough || this._vip) ? fn() : new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            if (_this._state.openComplete) return reject(new $2f895839ac78ac6c$var$exceptions.DatabaseClosed(_this._state.dbOpenError));
            if (!_this._state.isBeingOpened) {
                if (!_this._options.autoOpen) {
                    reject(new $2f895839ac78ac6c$var$exceptions.DatabaseClosed());
                    return;
                }
                _this.open().catch($2f895839ac78ac6c$var$nop);
            }
            _this._state.dbReadyPromise.then(resolve, reject);
        }).then(fn);
    };
    Dexie.prototype.use = function(_a) {
        var stack = _a.stack, create = _a.create, level = _a.level, name = _a.name;
        if (name) this.unuse({
            stack: stack,
            name: name
        });
        var middlewares = this._middlewares[stack] || (this._middlewares[stack] = []);
        middlewares.push({
            stack: stack,
            create: create,
            level: level == null ? 10 : level,
            name: name
        });
        middlewares.sort(function(a, b) {
            return a.level - b.level;
        });
        return this;
    };
    Dexie.prototype.unuse = function(_a) {
        var stack = _a.stack, name = _a.name, create = _a.create;
        if (stack && this._middlewares[stack]) this._middlewares[stack] = this._middlewares[stack].filter(function(mw) {
            return create ? mw.create !== create : name ? mw.name !== name : false;
        });
        return this;
    };
    Dexie.prototype.open = function() {
        return $2f895839ac78ac6c$var$dexieOpen(this);
    };
    Dexie.prototype._close = function() {
        var state = this._state;
        var idx = $2f895839ac78ac6c$var$connections.indexOf(this);
        if (idx >= 0) $2f895839ac78ac6c$var$connections.splice(idx, 1);
        if (this.idbdb) {
            try {
                this.idbdb.close();
            } catch (e) {}
            this._novip.idbdb = null;
        }
        state.dbReadyPromise = new $2f895839ac78ac6c$var$DexiePromise(function(resolve) {
            state.dbReadyResolve = resolve;
        });
        state.openCanceller = new $2f895839ac78ac6c$var$DexiePromise(function(_, reject) {
            state.cancelOpen = reject;
        });
    };
    Dexie.prototype.close = function() {
        this._close();
        var state = this._state;
        this._options.autoOpen = false;
        state.dbOpenError = new $2f895839ac78ac6c$var$exceptions.DatabaseClosed();
        if (state.isBeingOpened) state.cancelOpen(state.dbOpenError);
    };
    Dexie.prototype.delete = function() {
        var _this = this;
        var hasArguments = arguments.length > 0;
        var state = this._state;
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            var doDelete = function() {
                _this.close();
                var req = _this._deps.indexedDB.deleteDatabase(_this.name);
                req.onsuccess = $2f895839ac78ac6c$var$wrap(function() {
                    $2f895839ac78ac6c$var$_onDatabaseDeleted(_this._deps, _this.name);
                    resolve();
                });
                req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                req.onblocked = _this._fireOnBlocked;
            };
            if (hasArguments) throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Arguments not allowed in db.delete()");
            if (state.isBeingOpened) state.dbReadyPromise.then(doDelete);
            else doDelete();
        });
    };
    Dexie.prototype.backendDB = function() {
        return this.idbdb;
    };
    Dexie.prototype.isOpen = function() {
        return this.idbdb !== null;
    };
    Dexie.prototype.hasBeenClosed = function() {
        var dbOpenError = this._state.dbOpenError;
        return dbOpenError && dbOpenError.name === "DatabaseClosed";
    };
    Dexie.prototype.hasFailed = function() {
        return this._state.dbOpenError !== null;
    };
    Dexie.prototype.dynamicallyOpened = function() {
        return this._state.autoSchema;
    };
    Object.defineProperty(Dexie.prototype, "tables", {
        get: function() {
            var _this = this;
            return $2f895839ac78ac6c$var$keys(this._allTables).map(function(name) {
                return _this._allTables[name];
            });
        },
        enumerable: false,
        configurable: true
    });
    Dexie.prototype.transaction = function() {
        var args = $2f895839ac78ac6c$var$extractTransactionArgs.apply(this, arguments);
        return this._transaction.apply(this, args);
    };
    Dexie.prototype._transaction = function(mode, tables, scopeFunc) {
        var _this = this;
        var parentTransaction = $2f895839ac78ac6c$var$PSD.trans;
        if (!parentTransaction || parentTransaction.db !== this || mode.indexOf("!") !== -1) parentTransaction = null;
        var onlyIfCompatible = mode.indexOf("?") !== -1;
        mode = mode.replace("!", "").replace("?", "");
        var idbMode, storeNames;
        try {
            storeNames = tables.map(function(table) {
                var storeName = table instanceof _this.Table ? table.name : table;
                if (typeof storeName !== "string") throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");
                return storeName;
            });
            if (mode == "r" || mode === $2f895839ac78ac6c$var$READONLY) idbMode = $2f895839ac78ac6c$var$READONLY;
            else if (mode == "rw" || mode == $2f895839ac78ac6c$var$READWRITE) idbMode = $2f895839ac78ac6c$var$READWRITE;
            else throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Invalid transaction mode: " + mode);
            if (parentTransaction) {
                if (parentTransaction.mode === $2f895839ac78ac6c$var$READONLY && idbMode === $2f895839ac78ac6c$var$READWRITE) {
                    if (onlyIfCompatible) parentTransaction = null;
                    else throw new $2f895839ac78ac6c$var$exceptions.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");
                }
                if (parentTransaction) storeNames.forEach(function(storeName) {
                    if (parentTransaction && parentTransaction.storeNames.indexOf(storeName) === -1) {
                        if (onlyIfCompatible) parentTransaction = null;
                        else throw new $2f895839ac78ac6c$var$exceptions.SubTransaction("Table " + storeName + " not included in parent transaction.");
                    }
                });
                if (onlyIfCompatible && parentTransaction && !parentTransaction.active) parentTransaction = null;
            }
        } catch (e) {
            return parentTransaction ? parentTransaction._promise(null, function(_, reject) {
                reject(e);
            }) : $2f895839ac78ac6c$var$rejection(e);
        }
        var enterTransaction = $2f895839ac78ac6c$var$enterTransactionScope.bind(null, this, idbMode, storeNames, parentTransaction, scopeFunc);
        return parentTransaction ? parentTransaction._promise(idbMode, enterTransaction, "lock") : $2f895839ac78ac6c$var$PSD.trans ? $2f895839ac78ac6c$var$usePSD($2f895839ac78ac6c$var$PSD.transless, function() {
            return _this._whenReady(enterTransaction);
        }) : this._whenReady(enterTransaction);
    };
    Dexie.prototype.table = function(tableName) {
        if (!$2f895839ac78ac6c$var$hasOwn(this._allTables, tableName)) throw new $2f895839ac78ac6c$var$exceptions.InvalidTable("Table " + tableName + " does not exist");
        return this._allTables[tableName];
    };
    return Dexie;
}();
var $2f895839ac78ac6c$var$symbolObservable = typeof Symbol !== "undefined" && "observable" in Symbol ? Symbol.observable : "@@observable";
var $2f895839ac78ac6c$var$Observable = function() {
    function Observable(subscribe) {
        this._subscribe = subscribe;
    }
    Observable.prototype.subscribe = function(x, error, complete) {
        return this._subscribe(!x || typeof x === "function" ? {
            next: x,
            error: error,
            complete: complete
        } : x);
    };
    Observable.prototype[$2f895839ac78ac6c$var$symbolObservable] = function() {
        return this;
    };
    return Observable;
}();
function $2f895839ac78ac6c$var$extendObservabilitySet(target, newSet) {
    $2f895839ac78ac6c$var$keys(newSet).forEach(function(part) {
        var rangeSet = target[part] || (target[part] = new $2f895839ac78ac6c$export$34cb5241245008dd());
        $2f895839ac78ac6c$export$4876cc3130d3f820(rangeSet, newSet[part]);
    });
    return target;
}
function $2f895839ac78ac6c$export$6a9705d8f6f38796(querier) {
    var hasValue = false;
    var currentValue = undefined;
    var observable = new $2f895839ac78ac6c$var$Observable(function(observer) {
        var scopeFuncIsAsync = $2f895839ac78ac6c$var$isAsyncFunction(querier);
        function execute(subscr) {
            if (scopeFuncIsAsync) $2f895839ac78ac6c$var$incrementExpectedAwaits();
            var exec = function() {
                return $2f895839ac78ac6c$var$newScope(querier, {
                    subscr: subscr,
                    trans: null
                });
            };
            var rv = $2f895839ac78ac6c$var$PSD.trans ? $2f895839ac78ac6c$var$usePSD($2f895839ac78ac6c$var$PSD.transless, exec) : exec();
            if (scopeFuncIsAsync) rv.then($2f895839ac78ac6c$var$decrementExpectedAwaits, $2f895839ac78ac6c$var$decrementExpectedAwaits);
            return rv;
        }
        var closed = false;
        var accumMuts = {};
        var currentObs = {};
        var subscription = {
            get closed () {
                return closed;
            },
            unsubscribe: function() {
                closed = true;
                $2f895839ac78ac6c$var$globalEvents.storagemutated.unsubscribe(mutationListener);
            }
        };
        observer.start && observer.start(subscription);
        var querying = false, startedListening = false;
        function shouldNotify() {
            return $2f895839ac78ac6c$var$keys(currentObs).some(function(key) {
                return accumMuts[key] && $2f895839ac78ac6c$export$8f43b23b5d8de905(accumMuts[key], currentObs[key]);
            });
        }
        var mutationListener = function(parts) {
            $2f895839ac78ac6c$var$extendObservabilitySet(accumMuts, parts);
            if (shouldNotify()) doQuery();
        };
        var doQuery = function() {
            if (querying || closed) return;
            accumMuts = {};
            var subscr = {};
            var ret = execute(subscr);
            if (!startedListening) {
                $2f895839ac78ac6c$var$globalEvents($2f895839ac78ac6c$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, mutationListener);
                startedListening = true;
            }
            querying = true;
            Promise.resolve(ret).then(function(result) {
                hasValue = true;
                currentValue = result;
                querying = false;
                if (closed) return;
                if (shouldNotify()) doQuery();
                else {
                    accumMuts = {};
                    currentObs = subscr;
                    observer.next && observer.next(result);
                }
            }, function(err) {
                querying = false;
                hasValue = false;
                observer.error && observer.error(err);
                subscription.unsubscribe();
            });
        };
        doQuery();
        return subscription;
    });
    observable.hasValue = function() {
        return hasValue;
    };
    observable.getValue = function() {
        return currentValue;
    };
    return observable;
}
var $2f895839ac78ac6c$var$domDeps;
try {
    $2f895839ac78ac6c$var$domDeps = {
        indexedDB: $2f895839ac78ac6c$var$_global.indexedDB || $2f895839ac78ac6c$var$_global.mozIndexedDB || $2f895839ac78ac6c$var$_global.webkitIndexedDB || $2f895839ac78ac6c$var$_global.msIndexedDB,
        IDBKeyRange: $2f895839ac78ac6c$var$_global.IDBKeyRange || $2f895839ac78ac6c$var$_global.webkitIDBKeyRange
    };
} catch (e) {
    $2f895839ac78ac6c$var$domDeps = {
        indexedDB: null,
        IDBKeyRange: null
    };
}
var $2f895839ac78ac6c$var$Dexie = $2f895839ac78ac6c$export$4ece27d405df7279;
$2f895839ac78ac6c$var$props($2f895839ac78ac6c$var$Dexie, $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, $2f895839ac78ac6c$var$fullNameExceptions), {
    delete: function(databaseName) {
        var db = new $2f895839ac78ac6c$var$Dexie(databaseName, {
            addons: []
        });
        return db.delete();
    },
    exists: function(name) {
        return new $2f895839ac78ac6c$var$Dexie(name, {
            addons: []
        }).open().then(function(db) {
            db.close();
            return true;
        }).catch("NoSuchDatabaseError", function() {
            return false;
        });
    },
    getDatabaseNames: function(cb) {
        try {
            return $2f895839ac78ac6c$var$getDatabaseNames($2f895839ac78ac6c$var$Dexie.dependencies).then(cb);
        } catch (_a) {
            return $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.MissingAPI());
        }
    },
    defineClass: function() {
        function Class(content) {
            $2f895839ac78ac6c$var$extend(this, content);
        }
        return Class;
    },
    ignoreTransaction: function(scopeFunc) {
        return $2f895839ac78ac6c$var$PSD.trans ? $2f895839ac78ac6c$var$usePSD($2f895839ac78ac6c$var$PSD.transless, scopeFunc) : scopeFunc();
    },
    vip: $2f895839ac78ac6c$var$vip,
    async: function(generatorFn) {
        return function() {
            try {
                var rv = $2f895839ac78ac6c$var$awaitIterator(generatorFn.apply(this, arguments));
                if (!rv || typeof rv.then !== "function") return $2f895839ac78ac6c$var$DexiePromise.resolve(rv);
                return rv;
            } catch (e) {
                return $2f895839ac78ac6c$var$rejection(e);
            }
        };
    },
    spawn: function(generatorFn, args, thiz) {
        try {
            var rv = $2f895839ac78ac6c$var$awaitIterator(generatorFn.apply(thiz, args || []));
            if (!rv || typeof rv.then !== "function") return $2f895839ac78ac6c$var$DexiePromise.resolve(rv);
            return rv;
        } catch (e) {
            return $2f895839ac78ac6c$var$rejection(e);
        }
    },
    currentTransaction: {
        get: function() {
            return $2f895839ac78ac6c$var$PSD.trans || null;
        }
    },
    waitFor: function(promiseOrFunction, optionalTimeout) {
        var promise = $2f895839ac78ac6c$var$DexiePromise.resolve(typeof promiseOrFunction === "function" ? $2f895839ac78ac6c$var$Dexie.ignoreTransaction(promiseOrFunction) : promiseOrFunction).timeout(optionalTimeout || 60000);
        return $2f895839ac78ac6c$var$PSD.trans ? $2f895839ac78ac6c$var$PSD.trans.waitFor(promise) : promise;
    },
    Promise: $2f895839ac78ac6c$var$DexiePromise,
    debug: {
        get: function() {
            return $2f895839ac78ac6c$var$debug;
        },
        set: function(value) {
            $2f895839ac78ac6c$var$setDebug(value, value === "dexie" ? function() {
                return true;
            } : $2f895839ac78ac6c$var$dexieStackFrameFilter);
        }
    },
    derive: $2f895839ac78ac6c$var$derive,
    extend: $2f895839ac78ac6c$var$extend,
    props: $2f895839ac78ac6c$var$props,
    override: $2f895839ac78ac6c$var$override,
    Events: $2f895839ac78ac6c$var$Events,
    on: $2f895839ac78ac6c$var$globalEvents,
    liveQuery: $2f895839ac78ac6c$export$6a9705d8f6f38796,
    extendObservabilitySet: $2f895839ac78ac6c$var$extendObservabilitySet,
    getByKeyPath: $2f895839ac78ac6c$var$getByKeyPath,
    setByKeyPath: $2f895839ac78ac6c$var$setByKeyPath,
    delByKeyPath: $2f895839ac78ac6c$var$delByKeyPath,
    shallowClone: $2f895839ac78ac6c$var$shallowClone,
    deepClone: $2f895839ac78ac6c$var$deepClone,
    getObjectDiff: $2f895839ac78ac6c$var$getObjectDiff,
    cmp: $2f895839ac78ac6c$var$cmp,
    asap: $2f895839ac78ac6c$var$asap$1,
    minKey: $2f895839ac78ac6c$var$minKey,
    addons: [],
    connections: $2f895839ac78ac6c$var$connections,
    errnames: $2f895839ac78ac6c$var$errnames,
    dependencies: $2f895839ac78ac6c$var$domDeps,
    semVer: $2f895839ac78ac6c$var$DEXIE_VERSION,
    version: $2f895839ac78ac6c$var$DEXIE_VERSION.split(".").map(function(n) {
        return parseInt(n);
    }).reduce(function(p, c, i) {
        return p + c / Math.pow(10, i * 2);
    })
}));
$2f895839ac78ac6c$var$Dexie.maxKey = $2f895839ac78ac6c$var$getMaxKey($2f895839ac78ac6c$var$Dexie.dependencies.IDBKeyRange);
if (typeof dispatchEvent !== "undefined" && typeof addEventListener !== "undefined") {
    $2f895839ac78ac6c$var$globalEvents($2f895839ac78ac6c$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(updatedParts) {
        if (!$2f895839ac78ac6c$var$propagatingLocally) {
            var event_1;
            if ($2f895839ac78ac6c$var$isIEOrEdge) {
                event_1 = document.createEvent("CustomEvent");
                event_1.initCustomEvent($2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME, true, true, updatedParts);
            } else event_1 = new CustomEvent($2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME, {
                detail: updatedParts
            });
            $2f895839ac78ac6c$var$propagatingLocally = true;
            dispatchEvent(event_1);
            $2f895839ac78ac6c$var$propagatingLocally = false;
        }
    });
    addEventListener($2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME, function(_a) {
        var detail = _a.detail;
        if (!$2f895839ac78ac6c$var$propagatingLocally) $2f895839ac78ac6c$var$propagateLocally(detail);
    });
}
function $2f895839ac78ac6c$var$propagateLocally(updateParts) {
    var wasMe = $2f895839ac78ac6c$var$propagatingLocally;
    try {
        $2f895839ac78ac6c$var$propagatingLocally = true;
        $2f895839ac78ac6c$var$globalEvents.storagemutated.fire(updateParts);
    } finally{
        $2f895839ac78ac6c$var$propagatingLocally = wasMe;
    }
}
var $2f895839ac78ac6c$var$propagatingLocally = false;
if (typeof BroadcastChannel !== "undefined") {
    var $2f895839ac78ac6c$var$bc_1 = new BroadcastChannel($2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME);
    if (typeof $2f895839ac78ac6c$var$bc_1.unref === "function") $2f895839ac78ac6c$var$bc_1.unref();
    $2f895839ac78ac6c$var$globalEvents($2f895839ac78ac6c$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(changedParts) {
        if (!$2f895839ac78ac6c$var$propagatingLocally) $2f895839ac78ac6c$var$bc_1.postMessage(changedParts);
    });
    $2f895839ac78ac6c$var$bc_1.onmessage = function(ev) {
        if (ev.data) $2f895839ac78ac6c$var$propagateLocally(ev.data);
    };
} else if (typeof self !== "undefined" && typeof navigator !== "undefined") {
    $2f895839ac78ac6c$var$globalEvents($2f895839ac78ac6c$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(changedParts) {
        try {
            if (!$2f895839ac78ac6c$var$propagatingLocally) {
                if (typeof localStorage !== "undefined") localStorage.setItem($2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME, JSON.stringify({
                    trig: Math.random(),
                    changedParts: changedParts
                }));
                if (typeof self["clients"] === "object") $2f895839ac78ac6c$var$__spreadArray([], self["clients"].matchAll({
                    includeUncontrolled: true
                }), true).forEach(function(client) {
                    return client.postMessage({
                        type: $2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME,
                        changedParts: changedParts
                    });
                });
            }
        } catch (_a) {}
    });
    if (typeof addEventListener !== "undefined") addEventListener("storage", function(ev) {
        if (ev.key === $2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME) {
            var data = JSON.parse(ev.newValue);
            if (data) $2f895839ac78ac6c$var$propagateLocally(data.changedParts);
        }
    });
    var $2f895839ac78ac6c$var$swContainer = self.document && navigator.serviceWorker;
    if ($2f895839ac78ac6c$var$swContainer) $2f895839ac78ac6c$var$swContainer.addEventListener("message", $2f895839ac78ac6c$var$propagateMessageLocally);
}
function $2f895839ac78ac6c$var$propagateMessageLocally(_a) {
    var data = _a.data;
    if (data && data.type === $2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME) $2f895839ac78ac6c$var$propagateLocally(data.changedParts);
}
$2f895839ac78ac6c$var$DexiePromise.rejectionMapper = $2f895839ac78ac6c$var$mapError;
$2f895839ac78ac6c$var$setDebug($2f895839ac78ac6c$var$debug, $2f895839ac78ac6c$var$dexieStackFrameFilter);


class $372d9dcfc71c4a48$export$a0911963a0fbc1ef extends (0, $2f895839ac78ac6c$export$4ece27d405df7279) {
    constructor(){
        super("treadmill");
        this.version(1).stores({
            treadmillData: "timestamp",
            trainingStatus: "timestamp",
            session: "++id, started, ended, duration, distance, averageSpeed, energyExpended"
        });
        this.version(2).stores({
            treadmillData: "timestamp",
            trainingStatus: "timestamp",
            session: "++id, started, ended, duration, distance, averageSpeed, energyExpended",
            settings: "id"
        });
    }
    async getSettings() {
        const settings = await this.settings.get(1);
        if (settings) return settings;
        const defaultSettings = {
            id: 1,
            weightLbs: 0,
            goalDistanceMiles: null,
            goalDurationMinutes: null
        };
        await this.settings.put(defaultSettings);
        return defaultSettings;
    }
    async saveSettings(settings) {
        const current = await this.getSettings();
        await this.settings.put({
            ...current,
            ...settings
        });
    }
}


const $bffbb1fe8606acaa$var$supportedTrainingStatuses = [
    "Idle",
    "Pre-Workout",
    "Post-Workout",
    "Manual Mode (Quick Start)"
];
const $bffbb1fe8606acaa$var$isSupportedTrainingStatus = (s)=>$bffbb1fe8606acaa$var$supportedTrainingStatuses.includes(s);
class $bffbb1fe8606acaa$export$d29d5a99a033a8c6 {
    static{
        // todo: there's a better way to do this
        this.supportedTrainingStatuses = [
            "Idle",
            "Pre-Workout",
            "Post-Workout",
            "Manual Mode (Quick Start)"
        ];
    }
    get targetSpeed() {
        return this._targetSpeed;
    }
    set targetSpeed(speed) {
        this._targetSpeed = Math.max(0, Math.min(speed, 12)); // Clamp 0-12 mph
        document.dispatchEvent(new CustomEvent("targetspeedchanged", {
            detail: this._targetSpeed
        }));
    }
    get status() {
        return this._status;
    }
    set status(data) {
        this._status = data.stringFromStatus;
        document.dispatchEvent(new CustomEvent("trainingstatuschanged", {
            detail: data
        }));
    }
    get name() {
        return this.device?.name || "Unknown";
    }
    get connectionState() {
        return this._connectionState;
    }
    setConnectionState(state, attempt) {
        this._connectionState = state;
        document.dispatchEvent(new CustomEvent("connectionstatechanged", {
            detail: {
                state: state,
                attempt: attempt
            }
        }));
    }
    constructor(d){
        // Target speed for pre-start adjustment and control
        this._targetSpeed = 0.6;
        // Reconnection state
        this._connectionState = "disconnected";
        this.reconnectAttempts = 0;
        this.maxReconnectAttempts = 5;
        this.wasConnected = false;
        this._status = "Idle";
        this.device = d;
    }
    async connect() {
        this.setConnectionState("connecting");
        this.device.addEventListener("gattserverdisconnected", ()=>{
            this.onDisconnected();
        });
        try {
            this.gatt = await (0, $5834f5097160e8a3$export$64605811ab45167f)(this.device);
        } catch (e) {
            this.setConnectionState("disconnected");
            throw new Error("failed to connect to gatt");
        }
        try {
            this.profile = await (0, $5834f5097160e8a3$export$4c0029b0ace0292a)(this.gatt);
        } catch (e) {
            this.setConnectionState("disconnected");
            throw new Error("failed to discover profile");
        }
        this.profile.fitnessMachine.treadmillData.addEventListener("characteristicvaluechanged", (e)=>this.onTreadmillDataNotification(e));
        this.profile.fitnessMachine.treadmillData.startNotifications();
        try {
            this.status = await this.readTrainingStatus();
            // if the status is not idle, we connected mid-session
            // we need to set the session start time by catching the next
            // treadmill data and using it to derive start time
            if (this.status !== "Idle") this.profile.fitnessMachine.treadmillData.addEventListener("characteristicvaluechanged", (_e)=>{
                const e = _e;
                const data = $bffbb1fe8606acaa$var$toTreadmillData((0, $5834f5097160e8a3$export$5b03a248c90de598)(e.target.value));
                this.sessionStarted = Date.now() - data.elapsedTime * 1000;
            }, // @ts-expect-error
            {
                once: true
            });
        } catch (e) {
            console.error("could not initialize treadmill status: ", e);
        }
        this.profile.fitnessMachine.trainingStatus.addEventListener("characteristicvaluechanged", (e)=>this.onTrainingStatusNotification(e));
        this.profile.fitnessMachine.trainingStatus.startNotifications();
        this.setConnectionState("connected");
        this.wasConnected = true;
        this.reconnectAttempts = 0;
    }
    disconnect() {
        // Clear any pending reconnect
        if (this.reconnectTimeout) {
            clearTimeout(this.reconnectTimeout);
            this.reconnectTimeout = undefined;
        }
        this.wasConnected = false;
        this.profile?.fitnessMachine.treadmillData.stopNotifications();
        this.profile?.fitnessMachine.trainingStatus.stopNotifications();
        (0, $5834f5097160e8a3$export$37dfea93db2e14ed)(this.device);
        this.setConnectionState("disconnected");
        document.dispatchEvent(new CustomEvent("treadmilldisconnected"));
    }
    onDisconnected() {
        // If this was an unexpected disconnect and we were connected, try to reconnect
        if (this.wasConnected && this.reconnectAttempts < this.maxReconnectAttempts) this.attemptReconnect();
        else {
            this.setConnectionState("disconnected");
            document.dispatchEvent(new CustomEvent("treadmilldisconnected"));
        }
    }
    attemptReconnect() {
        this.reconnectAttempts++;
        this.setConnectionState("reconnecting", this.reconnectAttempts);
        // Exponential backoff: 1s, 2s, 4s, 8s, 16s
        const delay = Math.min(1000 * Math.pow(2, this.reconnectAttempts - 1), 16000);
        this.reconnectTimeout = setTimeout(async ()=>{
            try {
                if (this.device.gatt) {
                    this.gatt = await this.device.gatt.connect();
                    this.profile = await (0, $5834f5097160e8a3$export$4c0029b0ace0292a)(this.gatt);
                    // Re-setup notifications
                    this.profile.fitnessMachine.treadmillData.addEventListener("characteristicvaluechanged", (e)=>this.onTreadmillDataNotification(e));
                    this.profile.fitnessMachine.treadmillData.startNotifications();
                    this.profile.fitnessMachine.trainingStatus.addEventListener("characteristicvaluechanged", (e)=>this.onTrainingStatusNotification(e));
                    this.profile.fitnessMachine.trainingStatus.startNotifications();
                    this.setConnectionState("connected");
                    this.reconnectAttempts = 0;
                    document.dispatchEvent(new CustomEvent("treadmillreconnected"));
                }
            } catch (e) {
                console.error("Reconnection attempt failed:", e);
                if (this.reconnectAttempts < this.maxReconnectAttempts) this.attemptReconnect();
                else {
                    this.setConnectionState("disconnected");
                    document.dispatchEvent(new CustomEvent("treadmilldisconnected"));
                }
            }
        }, delay);
    }
    cancelReconnect() {
        if (this.reconnectTimeout) {
            clearTimeout(this.reconnectTimeout);
            this.reconnectTimeout = undefined;
        }
        this.wasConnected = false;
        this.reconnectAttempts = 0;
        this.setConnectionState("disconnected");
    }
    get hasControlPoint() {
        return !!this.profile?.fitnessMachine.controlPoint;
    }
    async writeControlPoint(command) {
        const controlPoint = this.profile?.fitnessMachine.controlPoint;
        if (!controlPoint) {
            console.warn("[CP] Control Point not available");
            return false;
        }
        console.log("[CP] Writing command:", Array.from(command).map((b)=>"0x" + b.toString(16).padStart(2, "0")).join(" "));
        console.log("[CP] Control Point properties:", {
            write: controlPoint.properties.write,
            writeWithoutResponse: controlPoint.properties.writeWithoutResponse,
            indicate: controlPoint.properties.indicate,
            notify: controlPoint.properties.notify
        });
        try {
            // FTMS Control Point typically requires write-with-response
            if (controlPoint.properties.write) {
                console.log("[CP] Using writeValueWithResponse");
                await controlPoint.writeValueWithResponse(command);
            } else if (controlPoint.properties.writeWithoutResponse) {
                console.log("[CP] Using writeValueWithoutResponse");
                await controlPoint.writeValueWithoutResponse(command);
            } else {
                console.log("[CP] Using writeValue (fallback)");
                await controlPoint.writeValue(command);
            }
            console.log("[CP] Write successful");
            return true;
        } catch (e) {
            console.error("[CP] Failed to write control point:", e);
            return false;
        }
    }
    async requestControl() {
        console.log("[CP] Requesting control...");
        const result = await this.writeControlPoint((0, $5834f5097160e8a3$export$70c3c3653bbab88f)());
        console.log("[CP] Request control result:", result);
        return result;
    }
    async start() {
        console.log("[CP] Starting workout...");
        // Subscribe to control point indications to see responses
        const controlPoint = this.profile?.fitnessMachine.controlPoint;
        if (controlPoint && controlPoint.properties.indicate) try {
            console.log("[CP] Subscribing to Control Point indications...");
            controlPoint.addEventListener("characteristicvaluechanged", (e)=>{
                const event = e;
                const response = (0, $5834f5097160e8a3$export$d991cbeaacf80d3f)(event.target.value);
                console.log("[CP] Response received:", {
                    opCode: "0x" + response.opCode.toString(16),
                    requestOpCode: "0x" + response.requestOpCode.toString(16),
                    result: "0x" + response.result.toString(16),
                    resultMeaning: response.result === 1 ? "SUCCESS" : response.result === 2 ? "OP_CODE_NOT_SUPPORTED" : response.result === 3 ? "INVALID_PARAMETER" : response.result === 4 ? "OPERATION_FAILED" : response.result === 5 ? "CONTROL_NOT_PERMITTED" : "UNKNOWN"
                });
            });
            await controlPoint.startNotifications();
            console.log("[CP] Subscribed to indications");
        } catch (e) {
            console.warn("[CP] Could not subscribe to indications:", e);
        }
        // Request control
        const hasControl = await this.requestControl();
        console.log("[CP] Has control:", hasControl);
        if (!hasControl) return false;
        // Some treadmills require setting a speed before starting
        console.log("[CP] Setting initial speed to", this._targetSpeed, "mph...");
        await this.setSpeed(this._targetSpeed);
        // Small delay to let the treadmill process
        await new Promise((resolve)=>setTimeout(resolve, 500));
        // Now send start command
        const result = await this.writeControlPoint((0, $5834f5097160e8a3$export$23b69923adf01b9c)());
        console.log("[CP] Start result:", result);
        return result;
    }
    async stop() {
        console.log("[CP] Stopping workout...");
        return this.writeControlPoint((0, $5834f5097160e8a3$export$4387efe3be2b0da2)());
    }
    async setSpeed(speedMph) {
        // Convert mph to km/h for the command
        const speedKmph = speedMph / 0.6213712;
        return this.writeControlPoint((0, $5834f5097160e8a3$export$175e6420edf6da60)(speedKmph));
    }
    async increaseSpeed(increment = 0.1) {
        const currentSpeed = this.lastData?.speed ?? this._targetSpeed;
        const newSpeed = currentSpeed + increment;
        this.targetSpeed = newSpeed; // Update target
        // If running, also send command to treadmill
        if (this.status === "Manual Mode (Quick Start)") return this.setSpeed(newSpeed);
        return true; // Just updated target, no command needed
    }
    async decreaseSpeed(decrement = 0.1) {
        const currentSpeed = this.lastData?.speed ?? this._targetSpeed;
        const newSpeed = Math.max(0.6, currentSpeed - decrement); // Min 0.6 mph
        this.targetSpeed = newSpeed; // Update target
        // If running, also send command to treadmill
        if (this.status === "Manual Mode (Quick Start)") return this.setSpeed(newSpeed);
        return true; // Just updated target, no command needed
    }
    async readTrainingStatus() {
        const v = await this.profile?.fitnessMachine.trainingStatus.readValue();
        if (!v) throw new Error("no training status value read");
        return $bffbb1fe8606acaa$var$toTrainingStatus((0, $5834f5097160e8a3$export$4ac06a731c8c3c15)(v));
    }
    onTreadmillDataNotification(_e) {
        const e = _e;
        if (this.status === "Idle") // machine sends constant treadmill notifications. ignore these until we're
        // out of idle state.
        return;
        const data = $bffbb1fe8606acaa$var$toTreadmillData((0, $5834f5097160e8a3$export$5b03a248c90de598)(e.target.value));
        if (this.status === "Manual Mode (Quick Start)") this.lastData = data;
        document.dispatchEvent(new CustomEvent("treadmilldata", {
            detail: data
        }));
    }
    async onTrainingStatusNotification(_e) {
        const e = _e;
        try {
            const data = $bffbb1fe8606acaa$var$toTrainingStatus((0, $5834f5097160e8a3$export$4ac06a731c8c3c15)(e.target.value));
            this.status = data;
            if (data.stringFromStatus === "Pre-Workout") this.sessionStarted = data.timestamp;
            if (data.stringFromStatus === "Post-Workout") {
                // if we don't have a last notification, we're kinda screwed.
                // TODO: handle this
                if (!this.lastData) {
                    console.error("no previous notification available to finish session");
                    return;
                }
                // session is ended. box up a new session and send it off
                // if we haven't found a start time at this point, derive it from the
                // last notification
                // TODO: listen for the 'Idle' status event once to get the last notification of the session
                if (!this.sessionStarted) this.sessionStarted = Date.now() - this.lastData?.elapsedTime * 1000;
                const session = {
                    started: this.sessionStarted,
                    ended: data.timestamp,
                    distance: this.lastData.distance,
                    duration: this.lastData.elapsedTime,
                    energyExpended: this.lastData.kcal,
                    averageSpeed: await $bffbb1fe8606acaa$var$averageSpeed(this.sessionStarted, this.lastData.timestamp)
                };
                document.dispatchEvent(new CustomEvent("sessionended", {
                    detail: session
                }));
            }
        } catch (e) {
            console.error(e);
            return;
        }
    }
}
function $bffbb1fe8606acaa$var$kmphToMph(kmph) {
    return Math.round(kmph * 6.213712) / 10;
}
function $bffbb1fe8606acaa$var$metersToMiles(meters) {
    return Math.round(meters * 0.0621371) / 100;
}
function $bffbb1fe8606acaa$var$formatTime(seconds) {
    return new Date(seconds * 1000).toISOString().substring(11, 19);
}
function $bffbb1fe8606acaa$var$toTreadmillData(d) {
    return {
        timestamp: Date.now(),
        speed: $bffbb1fe8606acaa$var$kmphToMph(d.instantaneousSpeed),
        distance: $bffbb1fe8606acaa$var$metersToMiles(d.totalDistance),
        formattedTime: $bffbb1fe8606acaa$var$formatTime(d.elapsedTime),
        elapsedTime: d.elapsedTime,
        kcal: d.totalEnergy
    };
}
function $bffbb1fe8606acaa$var$toTrainingStatus(d) {
    if ($bffbb1fe8606acaa$var$isSupportedTrainingStatus(d.stringFromStatus)) return {
        timestamp: Date.now(),
        status: d.status,
        stringFromStatus: d.stringFromStatus
    };
    throw new Error(`cannot convert unsupported training status: ${d.stringFromStatus}`);
}
async function $bffbb1fe8606acaa$var$averageSpeed(start, end) {
    const db = new (0, $372d9dcfc71c4a48$export$a0911963a0fbc1ef)();
    const points = await db.treadmillData.where("timestamp").between(start, end).toArray();
    console.log(points);
    return points.map((p)=>p.speed).reduce((s, v)=>s + v, 0) / points.length;
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $73ff38dc46896811$var$extendStatics = function(d, b) {
    $73ff38dc46896811$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $73ff38dc46896811$var$extendStatics(d, b);
};
function $73ff38dc46896811$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $73ff38dc46896811$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $73ff38dc46896811$export$18ce0697a983be9b = function() {
    $73ff38dc46896811$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $73ff38dc46896811$export$18ce0697a983be9b.apply(this, arguments);
};
function $73ff38dc46896811$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $73ff38dc46896811$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $73ff38dc46896811$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $73ff38dc46896811$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $73ff38dc46896811$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $73ff38dc46896811$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $73ff38dc46896811$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $73ff38dc46896811$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $73ff38dc46896811$export$45d3717a4c69092e(o, m, p);
}
function $73ff38dc46896811$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $73ff38dc46896811$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $73ff38dc46896811$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($73ff38dc46896811$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $73ff38dc46896811$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $73ff38dc46896811$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}
function $73ff38dc46896811$export$10c90e4f7922046c(v) {
    return this instanceof $73ff38dc46896811$export$10c90e4f7922046c ? (this.v = v, this) : new $73ff38dc46896811$export$10c90e4f7922046c(v);
}
function $73ff38dc46896811$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $73ff38dc46896811$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $73ff38dc46896811$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $73ff38dc46896811$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $73ff38dc46896811$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $73ff38dc46896811$export$19a8beecd37a4c45 === "function" ? $73ff38dc46896811$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $73ff38dc46896811$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $73ff38dc46896811$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $73ff38dc46896811$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $73ff38dc46896811$export$45d3717a4c69092e(result, mod, k);
    }
    $73ff38dc46896811$var$__setModuleDefault(result, mod);
    return result;
}
function $73ff38dc46896811$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $73ff38dc46896811$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $73ff38dc46896811$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}


/*!
* ZRender, a high performance 2d drawing library.
*
* Copyright (c) 2013, Baidu Inc.
* All rights reserved.
*
* LICENSE
* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
*/ var $ce6dd58693a21851$var$Browser = function() {
    function Browser() {
        this.firefox = false;
        this.ie = false;
        this.edge = false;
        this.newEdge = false;
        this.weChat = false;
    }
    return Browser;
}();
var $ce6dd58693a21851$var$Env = function() {
    function Env() {
        this.browser = new $ce6dd58693a21851$var$Browser();
        this.node = false;
        this.wxa = false;
        this.worker = false;
        this.svgSupported = false;
        this.touchEventsSupported = false;
        this.pointerEventsSupported = false;
        this.domSupported = false;
        this.transformSupported = false;
        this.transform3dSupported = false;
        this.hasGlobalWindow = typeof window !== "undefined";
    }
    return Env;
}();
var $ce6dd58693a21851$var$env = new $ce6dd58693a21851$var$Env();
if (typeof wx === "object" && typeof wx.getSystemInfoSync === "function") {
    $ce6dd58693a21851$var$env.wxa = true;
    $ce6dd58693a21851$var$env.touchEventsSupported = true;
} else if (typeof document === "undefined" && typeof self !== "undefined") $ce6dd58693a21851$var$env.worker = true;
else if (!$ce6dd58693a21851$var$env.hasGlobalWindow || "Deno" in window || typeof navigator !== "undefined" && typeof navigator.userAgent === "string" && navigator.userAgent.indexOf("Node.js") > -1) {
    $ce6dd58693a21851$var$env.node = true;
    $ce6dd58693a21851$var$env.svgSupported = true;
} else $ce6dd58693a21851$var$detect(navigator.userAgent, $ce6dd58693a21851$var$env);
function $ce6dd58693a21851$var$detect(ua, env) {
    var browser = env.browser;
    var firefox = ua.match(/Firefox\/([\d.]+)/);
    var ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/.+?rv:(([\d.]+))/);
    var edge = ua.match(/Edge?\/([\d.]+)/);
    var weChat = /micromessenger/i.test(ua);
    if (firefox) {
        browser.firefox = true;
        browser.version = firefox[1];
    }
    if (ie) {
        browser.ie = true;
        browser.version = ie[1];
    }
    if (edge) {
        browser.edge = true;
        browser.version = edge[1];
        browser.newEdge = +edge[1].split(".")[0] > 18;
    }
    if (weChat) browser.weChat = true;
    env.svgSupported = typeof SVGRect !== "undefined";
    env.touchEventsSupported = "ontouchstart" in window && !browser.ie && !browser.edge;
    env.pointerEventsSupported = "onpointerdown" in window && (browser.edge || browser.ie && +browser.version >= 11);
    var domSupported = env.domSupported = typeof document !== "undefined";
    if (domSupported) {
        var style = document.documentElement.style;
        env.transform3dSupported = (browser.ie && "transition" in style || browser.edge || "WebKitCSSMatrix" in window && "m11" in new WebKitCSSMatrix() || "MozPerspective" in style) && !("OTransition" in style);
        env.transformSupported = env.transform3dSupported || browser.ie && +browser.version >= 9;
    }
}
var $ce6dd58693a21851$export$2e2bcd8739ae039 = $ce6dd58693a21851$var$env;


var $c6341dcc9d86826e$export$b1461457ea2c1179 = 12;
var $c6341dcc9d86826e$export$2653e0d5dd45b294 = "sans-serif";
var $c6341dcc9d86826e$export$7d7a232b6d2cc80c = $c6341dcc9d86826e$export$b1461457ea2c1179 + "px " + $c6341dcc9d86826e$export$2653e0d5dd45b294;
var $c6341dcc9d86826e$var$OFFSET = 20;
var $c6341dcc9d86826e$var$SCALE = 100;
var $c6341dcc9d86826e$var$defaultWidthMapStr = "007LLmW'55;N0500LLLLLLLLLL00NNNLzWW\\\\WQb\\0FWLg\\bWb\\WQ\\WrWWQ000CL5LLFLL0LL**F*gLLLL5F0LF\\FFF5.5N";
function $c6341dcc9d86826e$var$getTextWidthMap(mapStr) {
    var map = {};
    if (typeof JSON === "undefined") return map;
    for(var i = 0; i < mapStr.length; i++){
        var char = String.fromCharCode(i + 32);
        var size = (mapStr.charCodeAt(i) - $c6341dcc9d86826e$var$OFFSET) / $c6341dcc9d86826e$var$SCALE;
        map[char] = size;
    }
    return map;
}
var $c6341dcc9d86826e$export$69462fcc6bf851a4 = $c6341dcc9d86826e$var$getTextWidthMap($c6341dcc9d86826e$var$defaultWidthMapStr);
var $c6341dcc9d86826e$export$ef5e599365494451 = {
    createCanvas: function() {
        return typeof document !== "undefined" && document.createElement("canvas");
    },
    measureText: function() {
        var _ctx;
        var _cachedFont;
        return function(text, font) {
            if (!_ctx) {
                var canvas = $c6341dcc9d86826e$export$ef5e599365494451.createCanvas();
                _ctx = canvas && canvas.getContext("2d");
            }
            if (_ctx) {
                if (_cachedFont !== font) _cachedFont = _ctx.font = font || $c6341dcc9d86826e$export$7d7a232b6d2cc80c;
                return _ctx.measureText(text);
            } else {
                text = text || "";
                font = font || $c6341dcc9d86826e$export$7d7a232b6d2cc80c;
                var res = /((?:\d+)?\.?\d*)px/.exec(font);
                var fontSize = res && +res[1] || $c6341dcc9d86826e$export$b1461457ea2c1179;
                var width = 0;
                if (font.indexOf("mono") >= 0) width = fontSize * text.length;
                else for(var i = 0; i < text.length; i++){
                    var preCalcWidth = $c6341dcc9d86826e$export$69462fcc6bf851a4[text[i]];
                    width += preCalcWidth == null ? fontSize : preCalcWidth * fontSize;
                }
                return {
                    width: width
                };
            }
        };
    }(),
    loadImage: function(src, onload, onerror) {
        var image = new Image();
        image.onload = onload;
        image.onerror = onerror;
        image.src = src;
        return image;
    }
};
function $c6341dcc9d86826e$export$61bcfd79465c1b7c(newPlatformApis) {
    for(var key in $c6341dcc9d86826e$export$ef5e599365494451)if (newPlatformApis[key]) $c6341dcc9d86826e$export$ef5e599365494451[key] = newPlatformApis[key];
}


var $7a1bd9c2710fea0d$var$BUILTIN_OBJECT = $7a1bd9c2710fea0d$export$533b26079ad0b4b([
    "Function",
    "RegExp",
    "Date",
    "Error",
    "CanvasGradient",
    "CanvasPattern",
    "Image",
    "Canvas"
], function(obj, val) {
    obj["[object " + val + "]"] = true;
    return obj;
}, {});
var $7a1bd9c2710fea0d$var$TYPED_ARRAY = $7a1bd9c2710fea0d$export$533b26079ad0b4b([
    "Int8",
    "Uint8",
    "Uint8Clamped",
    "Int16",
    "Uint16",
    "Int32",
    "Uint32",
    "Float32",
    "Float64"
], function(obj, val) {
    obj["[object " + val + "Array]"] = true;
    return obj;
}, {});
var $7a1bd9c2710fea0d$var$objToString = Object.prototype.toString;
var $7a1bd9c2710fea0d$var$arrayProto = Array.prototype;
var $7a1bd9c2710fea0d$var$nativeForEach = $7a1bd9c2710fea0d$var$arrayProto.forEach;
var $7a1bd9c2710fea0d$var$nativeFilter = $7a1bd9c2710fea0d$var$arrayProto.filter;
var $7a1bd9c2710fea0d$var$nativeSlice = $7a1bd9c2710fea0d$var$arrayProto.slice;
var $7a1bd9c2710fea0d$var$nativeMap = $7a1bd9c2710fea0d$var$arrayProto.map;
var $7a1bd9c2710fea0d$var$ctorFunction = (function() {}).constructor;
var $7a1bd9c2710fea0d$var$protoFunction = $7a1bd9c2710fea0d$var$ctorFunction ? $7a1bd9c2710fea0d$var$ctorFunction.prototype : null;
var $7a1bd9c2710fea0d$var$protoKey = "__proto__";
var $7a1bd9c2710fea0d$var$idStart = 0x0907;
function $7a1bd9c2710fea0d$export$46e8f25c7328f77e() {
    return $7a1bd9c2710fea0d$var$idStart++;
}
function $7a1bd9c2710fea0d$export$58da9968c3170cb1() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (typeof console !== "undefined") console.error.apply(console, args);
}
function $7a1bd9c2710fea0d$export$9cd59f9826255e47(source) {
    if (source == null || typeof source !== "object") return source;
    var result = source;
    var typeStr = $7a1bd9c2710fea0d$var$objToString.call(source);
    if (typeStr === "[object Array]") {
        if (!$7a1bd9c2710fea0d$export$c3825b437cbdea5c(source)) {
            result = [];
            for(var i = 0, len = source.length; i < len; i++)result[i] = $7a1bd9c2710fea0d$export$9cd59f9826255e47(source[i]);
        }
    } else if ($7a1bd9c2710fea0d$var$TYPED_ARRAY[typeStr]) {
        if (!$7a1bd9c2710fea0d$export$c3825b437cbdea5c(source)) {
            var Ctor = source.constructor;
            if (Ctor.from) result = Ctor.from(source);
            else {
                result = new Ctor(source.length);
                for(var i = 0, len = source.length; i < len; i++)result[i] = source[i];
            }
        }
    } else if (!$7a1bd9c2710fea0d$var$BUILTIN_OBJECT[typeStr] && !$7a1bd9c2710fea0d$export$c3825b437cbdea5c(source) && !$7a1bd9c2710fea0d$export$9f57505b7bd8dae(source)) {
        result = {};
        for(var key in source)if (source.hasOwnProperty(key) && key !== $7a1bd9c2710fea0d$var$protoKey) result[key] = $7a1bd9c2710fea0d$export$9cd59f9826255e47(source[key]);
    }
    return result;
}
function $7a1bd9c2710fea0d$export$4950aa0f605343fb(target, source, overwrite) {
    if (!$7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(source) || !$7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(target)) return overwrite ? $7a1bd9c2710fea0d$export$9cd59f9826255e47(source) : target;
    for(var key in source)if (source.hasOwnProperty(key) && key !== $7a1bd9c2710fea0d$var$protoKey) {
        var targetProp = target[key];
        var sourceProp = source[key];
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(sourceProp) && $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(targetProp) && !$7a1bd9c2710fea0d$export$43bee75e5e14138e(sourceProp) && !$7a1bd9c2710fea0d$export$43bee75e5e14138e(targetProp) && !$7a1bd9c2710fea0d$export$9f57505b7bd8dae(sourceProp) && !$7a1bd9c2710fea0d$export$9f57505b7bd8dae(targetProp) && !$7a1bd9c2710fea0d$export$fa523b2c4941fd4f(sourceProp) && !$7a1bd9c2710fea0d$export$fa523b2c4941fd4f(targetProp) && !$7a1bd9c2710fea0d$export$c3825b437cbdea5c(sourceProp) && !$7a1bd9c2710fea0d$export$c3825b437cbdea5c(targetProp)) $7a1bd9c2710fea0d$export$4950aa0f605343fb(targetProp, sourceProp, overwrite);
        else if (overwrite || !(key in target)) target[key] = $7a1bd9c2710fea0d$export$9cd59f9826255e47(source[key]);
    }
    return target;
}
function $7a1bd9c2710fea0d$export$18aef43295bbe906(targetAndSources, overwrite) {
    var result = targetAndSources[0];
    for(var i = 1, len = targetAndSources.length; i < len; i++)result = $7a1bd9c2710fea0d$export$4950aa0f605343fb(result, targetAndSources[i], overwrite);
    return result;
}
function $7a1bd9c2710fea0d$export$8b58be045bf06082(target, source) {
    if (Object.assign) Object.assign(target, source);
    else {
        for(var key in source)if (source.hasOwnProperty(key) && key !== $7a1bd9c2710fea0d$var$protoKey) target[key] = source[key];
    }
    return target;
}
function $7a1bd9c2710fea0d$export$ebe90cb607ad99e(target, source, overlay) {
    var keysArr = $7a1bd9c2710fea0d$export$ed97f33186d4b816(source);
    for(var i = 0, len = keysArr.length; i < len; i++){
        var key = keysArr[i];
        if (overlay ? source[key] != null : target[key] == null) target[key] = source[key];
    }
    return target;
}
var $7a1bd9c2710fea0d$export$cd3d1f114b139967 = (0, $c6341dcc9d86826e$export$ef5e599365494451).createCanvas;
function $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(array, value) {
    if (array) {
        if (array.indexOf) return array.indexOf(value);
        for(var i = 0, len = array.length; i < len; i++){
            if (array[i] === value) return i;
        }
    }
    return -1;
}
function $7a1bd9c2710fea0d$export$69f1b2dcda23c5f8(clazz, baseClazz) {
    var clazzPrototype = clazz.prototype;
    function F() {}
    F.prototype = baseClazz.prototype;
    clazz.prototype = new F();
    for(var prop in clazzPrototype)if (clazzPrototype.hasOwnProperty(prop)) clazz.prototype[prop] = clazzPrototype[prop];
    clazz.prototype.constructor = clazz;
    clazz.superClass = baseClazz;
}
function $7a1bd9c2710fea0d$export$e36fc9d62a853069(target, source, override) {
    target = "prototype" in target ? target.prototype : target;
    source = "prototype" in source ? source.prototype : source;
    if (Object.getOwnPropertyNames) {
        var keyList = Object.getOwnPropertyNames(source);
        for(var i = 0; i < keyList.length; i++){
            var key = keyList[i];
            if (key !== "constructor") {
                if (override ? source[key] != null : target[key] == null) target[key] = source[key];
            }
        }
    } else $7a1bd9c2710fea0d$export$ebe90cb607ad99e(target, source, override);
}
function $7a1bd9c2710fea0d$export$1e2f57719e155213(data) {
    if (!data) return false;
    if (typeof data === "string") return false;
    return typeof data.length === "number";
}
function $7a1bd9c2710fea0d$export$79b2f7037acddd43(arr, cb, context) {
    if (!(arr && cb)) return;
    if (arr.forEach && arr.forEach === $7a1bd9c2710fea0d$var$nativeForEach) arr.forEach(cb, context);
    else if (arr.length === +arr.length) for(var i = 0, len = arr.length; i < len; i++)cb.call(context, arr[i], i, arr);
    else {
        for(var key in arr)if (arr.hasOwnProperty(key)) cb.call(context, arr[key], key, arr);
    }
}
function $7a1bd9c2710fea0d$export$871de8747c9eaa88(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $7a1bd9c2710fea0d$export$58adb3bec8346d0f(arr);
    if (arr.map && arr.map === $7a1bd9c2710fea0d$var$nativeMap) return arr.map(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)result.push(cb.call(context, arr[i], i, arr));
        return result;
    }
}
function $7a1bd9c2710fea0d$export$533b26079ad0b4b(arr, cb, memo, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++)memo = cb.call(context, memo, arr[i], i, arr);
    return memo;
}
function $7a1bd9c2710fea0d$export$3dea766d36a8935f(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $7a1bd9c2710fea0d$export$58adb3bec8346d0f(arr);
    if (arr.filter && arr.filter === $7a1bd9c2710fea0d$var$nativeFilter) return arr.filter(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)if (cb.call(context, arr[i], i, arr)) result.push(arr[i]);
        return result;
    }
}
function $7a1bd9c2710fea0d$export$71aa6c912b956294(arr, cb, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++){
        if (cb.call(context, arr[i], i, arr)) return arr[i];
    }
}
function $7a1bd9c2710fea0d$export$ed97f33186d4b816(obj) {
    if (!obj) return [];
    if (Object.keys) return Object.keys(obj);
    var keyList = [];
    for(var key in obj)if (obj.hasOwnProperty(key)) keyList.push(key);
    return keyList;
}
function $7a1bd9c2710fea0d$var$bindPolyfill(func, context) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return function() {
        return func.apply(context, args.concat($7a1bd9c2710fea0d$var$nativeSlice.call(arguments)));
    };
}
var $7a1bd9c2710fea0d$export$2385a24977818dd0 = $7a1bd9c2710fea0d$var$protoFunction && $7a1bd9c2710fea0d$export$f6e2535fb5126e54($7a1bd9c2710fea0d$var$protoFunction.bind) ? $7a1bd9c2710fea0d$var$protoFunction.call.bind($7a1bd9c2710fea0d$var$protoFunction.bind) : $7a1bd9c2710fea0d$var$bindPolyfill;
function $7a1bd9c2710fea0d$export$c3095a23b368d1f2(func) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return function() {
        return func.apply(this, args.concat($7a1bd9c2710fea0d$var$nativeSlice.call(arguments)));
    };
}
function $7a1bd9c2710fea0d$export$43bee75e5e14138e(value) {
    if (Array.isArray) return Array.isArray(value);
    return $7a1bd9c2710fea0d$var$objToString.call(value) === "[object Array]";
}
function $7a1bd9c2710fea0d$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
function $7a1bd9c2710fea0d$export$844ec244b1367d54(value) {
    return typeof value === "string";
}
function $7a1bd9c2710fea0d$export$29d0bb2a4e07b252(value) {
    return $7a1bd9c2710fea0d$var$objToString.call(value) === "[object String]";
}
function $7a1bd9c2710fea0d$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}
function $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(value) {
    var type = typeof value;
    return type === "function" || !!value && type === "object";
}
function $7a1bd9c2710fea0d$export$fa523b2c4941fd4f(value) {
    return !!$7a1bd9c2710fea0d$var$BUILTIN_OBJECT[$7a1bd9c2710fea0d$var$objToString.call(value)];
}
function $7a1bd9c2710fea0d$export$b119cc7e1840e59c(value) {
    return !!$7a1bd9c2710fea0d$var$TYPED_ARRAY[$7a1bd9c2710fea0d$var$objToString.call(value)];
}
function $7a1bd9c2710fea0d$export$9f57505b7bd8dae(value) {
    return typeof value === "object" && typeof value.nodeType === "number" && typeof value.ownerDocument === "object";
}
function $7a1bd9c2710fea0d$export$fa2c283003ed971c(value) {
    return value.colorStops != null;
}
function $7a1bd9c2710fea0d$export$a49bbf3a55dcef7b(value) {
    return value.image != null;
}
function $7a1bd9c2710fea0d$export$49841c62b9eff15(value) {
    return $7a1bd9c2710fea0d$var$objToString.call(value) === "[object RegExp]";
}
function $7a1bd9c2710fea0d$export$7d667b9a0c48c975(value) {
    return value !== value;
}
function $7a1bd9c2710fea0d$export$8a4d17b6e8486e66() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    for(var i = 0, len = args.length; i < len; i++){
        if (args[i] != null) return args[i];
    }
}
function $7a1bd9c2710fea0d$export$995e01f2f5c9d030(value0, value1) {
    return value0 != null ? value0 : value1;
}
function $7a1bd9c2710fea0d$export$2e94551289abb95b(value0, value1, value2) {
    return value0 != null ? value0 : value1 != null ? value1 : value2;
}
function $7a1bd9c2710fea0d$export$58adb3bec8346d0f(arr) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return $7a1bd9c2710fea0d$var$nativeSlice.apply(arr, args);
}
function $7a1bd9c2710fea0d$export$f3a38102c49f4268(val) {
    if (typeof val === "number") return [
        val,
        val,
        val,
        val
    ];
    var len = val.length;
    if (len === 2) return [
        val[0],
        val[1],
        val[0],
        val[1]
    ];
    else if (len === 3) return [
        val[0],
        val[1],
        val[2],
        val[1]
    ];
    return val;
}
function $7a1bd9c2710fea0d$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message);
}
function $7a1bd9c2710fea0d$export$87c2784dc9fc4ab(str) {
    if (str == null) return null;
    else if (typeof str.trim === "function") return str.trim();
    else return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
}
var $7a1bd9c2710fea0d$var$primitiveKey = "__ec_primitive__";
function $7a1bd9c2710fea0d$export$112e66431016387b(obj) {
    obj[$7a1bd9c2710fea0d$var$primitiveKey] = true;
}
function $7a1bd9c2710fea0d$export$c3825b437cbdea5c(obj) {
    return obj[$7a1bd9c2710fea0d$var$primitiveKey];
}
var $7a1bd9c2710fea0d$var$MapPolyfill = function() {
    function MapPolyfill() {
        this.data = {};
    }
    MapPolyfill.prototype["delete"] = function(key) {
        var existed = this.has(key);
        if (existed) delete this.data[key];
        return existed;
    };
    MapPolyfill.prototype.has = function(key) {
        return this.data.hasOwnProperty(key);
    };
    MapPolyfill.prototype.get = function(key) {
        return this.data[key];
    };
    MapPolyfill.prototype.set = function(key, value) {
        this.data[key] = value;
        return this;
    };
    MapPolyfill.prototype.keys = function() {
        return $7a1bd9c2710fea0d$export$ed97f33186d4b816(this.data);
    };
    MapPolyfill.prototype.forEach = function(callback) {
        var data = this.data;
        for(var key in data)if (data.hasOwnProperty(key)) callback(data[key], key);
    };
    return MapPolyfill;
}();
var $7a1bd9c2710fea0d$var$isNativeMapSupported = typeof Map === "function";
function $7a1bd9c2710fea0d$var$maybeNativeMap() {
    return $7a1bd9c2710fea0d$var$isNativeMapSupported ? new Map() : new $7a1bd9c2710fea0d$var$MapPolyfill();
}
var $7a1bd9c2710fea0d$export$60ef0b43d585640a = function() {
    function HashMap(obj) {
        var isArr = $7a1bd9c2710fea0d$export$43bee75e5e14138e(obj);
        this.data = $7a1bd9c2710fea0d$var$maybeNativeMap();
        var thisMap = this;
        obj instanceof HashMap ? obj.each(visit) : obj && $7a1bd9c2710fea0d$export$79b2f7037acddd43(obj, visit);
        function visit(value, key) {
            isArr ? thisMap.set(value, key) : thisMap.set(key, value);
        }
    }
    HashMap.prototype.hasKey = function(key) {
        return this.data.has(key);
    };
    HashMap.prototype.get = function(key) {
        return this.data.get(key);
    };
    HashMap.prototype.set = function(key, value) {
        this.data.set(key, value);
        return value;
    };
    HashMap.prototype.each = function(cb, context) {
        this.data.forEach(function(value, key) {
            cb.call(context, value, key);
        });
    };
    HashMap.prototype.keys = function() {
        var keys = this.data.keys();
        return $7a1bd9c2710fea0d$var$isNativeMapSupported ? Array.from(keys) : keys;
    };
    HashMap.prototype.removeKey = function(key) {
        this.data["delete"](key);
    };
    return HashMap;
}();
function $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4(obj) {
    return new $7a1bd9c2710fea0d$export$60ef0b43d585640a(obj);
}
function $7a1bd9c2710fea0d$export$4fd8af2c48c43416(a, b) {
    var newArray = new a.constructor(a.length + b.length);
    for(var i = 0; i < a.length; i++)newArray[i] = a[i];
    var offset = a.length;
    for(var i = 0; i < b.length; i++)newArray[i + offset] = b[i];
    return newArray;
}
function $7a1bd9c2710fea0d$export$79c7e160a7743efd(proto, properties) {
    var obj;
    if (Object.create) obj = Object.create(proto);
    else {
        var StyleCtor = function() {};
        StyleCtor.prototype = proto;
        obj = new StyleCtor();
    }
    if (properties) $7a1bd9c2710fea0d$export$8b58be045bf06082(obj, properties);
    return obj;
}
function $7a1bd9c2710fea0d$export$23a5d775868fdd2c(dom) {
    var domStyle = dom.style;
    domStyle.webkitUserSelect = "none";
    domStyle.userSelect = "none";
    domStyle.webkitTapHighlightColor = "rgba(0,0,0,0)";
    domStyle["-webkit-touch-callout"] = "none";
}
function $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3(own, prop) {
    return own.hasOwnProperty(prop);
}
function $7a1bd9c2710fea0d$export$8793edee2d425525() {}
var $7a1bd9c2710fea0d$export$bce8e055322a0ce6 = 180 / Math.PI;
var $7a1bd9c2710fea0d$export$fd293b15f47e270 = Number.EPSILON || Math.pow(2, -52);


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $995fbf2af591395d$var$extendStatics = function(d, b) {
    $995fbf2af591395d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $995fbf2af591395d$var$extendStatics(d, b);
};
function $995fbf2af591395d$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $995fbf2af591395d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $995fbf2af591395d$export$18ce0697a983be9b = function() {
    $995fbf2af591395d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $995fbf2af591395d$export$18ce0697a983be9b.apply(this, arguments);
};
function $995fbf2af591395d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $995fbf2af591395d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $995fbf2af591395d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $995fbf2af591395d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $995fbf2af591395d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $995fbf2af591395d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $995fbf2af591395d$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $995fbf2af591395d$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $995fbf2af591395d$export$45d3717a4c69092e(o, m, p);
}
function $995fbf2af591395d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $995fbf2af591395d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $995fbf2af591395d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($995fbf2af591395d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $995fbf2af591395d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $995fbf2af591395d$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}
function $995fbf2af591395d$export$10c90e4f7922046c(v) {
    return this instanceof $995fbf2af591395d$export$10c90e4f7922046c ? (this.v = v, this) : new $995fbf2af591395d$export$10c90e4f7922046c(v);
}
function $995fbf2af591395d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $995fbf2af591395d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $995fbf2af591395d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $995fbf2af591395d$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $995fbf2af591395d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $995fbf2af591395d$export$19a8beecd37a4c45 === "function" ? $995fbf2af591395d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $995fbf2af591395d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $995fbf2af591395d$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $995fbf2af591395d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $995fbf2af591395d$export$45d3717a4c69092e(result, mod, k);
    }
    $995fbf2af591395d$var$__setModuleDefault(result, mod);
    return result;
}
function $995fbf2af591395d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $995fbf2af591395d$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $995fbf2af591395d$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}



function $6de594cf8ac295ff$export$185802fd694ee1f5(x, y) {
    if (x == null) x = 0;
    if (y == null) y = 0;
    return [
        x,
        y
    ];
}
function $6de594cf8ac295ff$export$784d13d8ee351f07(out, v) {
    out[0] = v[0];
    out[1] = v[1];
    return out;
}
function $6de594cf8ac295ff$export$9cd59f9826255e47(v) {
    return [
        v[0],
        v[1]
    ];
}
function $6de594cf8ac295ff$export$adaa4cf7ef1b65be(out, a, b) {
    out[0] = a;
    out[1] = b;
    return out;
}
function $6de594cf8ac295ff$export$e16d8520af44a096(out, v1, v2) {
    out[0] = v1[0] + v2[0];
    out[1] = v1[1] + v2[1];
    return out;
}
function $6de594cf8ac295ff$export$19cedf1da84ba854(out, v1, v2, a) {
    out[0] = v1[0] + v2[0] * a;
    out[1] = v1[1] + v2[1] * a;
    return out;
}
function $6de594cf8ac295ff$export$f93b5905241a7cca(out, v1, v2) {
    out[0] = v1[0] - v2[0];
    out[1] = v1[1] - v2[1];
    return out;
}
function $6de594cf8ac295ff$export$fc1400facf92c78(v) {
    return Math.sqrt($6de594cf8ac295ff$export$48e33bc611e4c25a(v));
}
var $6de594cf8ac295ff$export$f24224f1c91d8156 = $6de594cf8ac295ff$export$fc1400facf92c78;
function $6de594cf8ac295ff$export$48e33bc611e4c25a(v) {
    return v[0] * v[0] + v[1] * v[1];
}
var $6de594cf8ac295ff$export$2f106540dd9a5136 = $6de594cf8ac295ff$export$48e33bc611e4c25a;
function $6de594cf8ac295ff$export$6e3a27864ab166fe(out, v1, v2) {
    out[0] = v1[0] * v2[0];
    out[1] = v1[1] * v2[1];
    return out;
}
function $6de594cf8ac295ff$export$159d9494db57879b(out, v1, v2) {
    out[0] = v1[0] / v2[0];
    out[1] = v1[1] / v2[1];
    return out;
}
function $6de594cf8ac295ff$export$94132a0e348806d4(v1, v2) {
    return v1[0] * v2[0] + v1[1] * v2[1];
}
function $6de594cf8ac295ff$export$dcdf75081b88279d(out, v, s) {
    out[0] = v[0] * s;
    out[1] = v[1] * s;
    return out;
}
function $6de594cf8ac295ff$export$a3295358bff77e(out, v) {
    var d = $6de594cf8ac295ff$export$fc1400facf92c78(v);
    if (d === 0) {
        out[0] = 0;
        out[1] = 0;
    } else {
        out[0] = v[0] / d;
        out[1] = v[1] / d;
    }
    return out;
}
function $6de594cf8ac295ff$export$9f17032d917177de(v1, v2) {
    return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
}
var $6de594cf8ac295ff$export$6c4a311cc157c764 = $6de594cf8ac295ff$export$9f17032d917177de;
function $6de594cf8ac295ff$export$137c0a69d1ff4a79(v1, v2) {
    return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
}
var $6de594cf8ac295ff$export$c68db45a034c13b0 = $6de594cf8ac295ff$export$137c0a69d1ff4a79;
function $6de594cf8ac295ff$export$aef51622e549b8b0(out, v) {
    out[0] = -v[0];
    out[1] = -v[1];
    return out;
}
function $6de594cf8ac295ff$export$3a89f8d6f6bf6c9f(out, v1, v2, t) {
    out[0] = v1[0] + t * (v2[0] - v1[0]);
    out[1] = v1[1] + t * (v2[1] - v1[1]);
    return out;
}
function $6de594cf8ac295ff$export$9f9dcb98c894b623(out, v, m) {
    var x = v[0];
    var y = v[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $6de594cf8ac295ff$export$96ec731ed4dcb222(out, v1, v2) {
    out[0] = Math.min(v1[0], v2[0]);
    out[1] = Math.min(v1[1], v2[1]);
    return out;
}
function $6de594cf8ac295ff$export$8960430cfd85939f(out, v1, v2) {
    out[0] = Math.max(v1[0], v2[0]);
    out[1] = Math.max(v1[1], v2[1]);
    return out;
}


var $4e8ea7ab4b22b6b2$var$Param = function() {
    function Param(target, e) {
        this.target = target;
        this.topTarget = e && e.topTarget;
    }
    return Param;
}();
var $4e8ea7ab4b22b6b2$var$Draggable = function() {
    function Draggable(handler) {
        this.handler = handler;
        handler.on("mousedown", this._dragStart, this);
        handler.on("mousemove", this._drag, this);
        handler.on("mouseup", this._dragEnd, this);
    }
    Draggable.prototype._dragStart = function(e) {
        var draggingTarget = e.target;
        while(draggingTarget && !draggingTarget.draggable)draggingTarget = draggingTarget.parent || draggingTarget.__hostTarget;
        if (draggingTarget) {
            this._draggingTarget = draggingTarget;
            draggingTarget.dragging = true;
            this._x = e.offsetX;
            this._y = e.offsetY;
            this.handler.dispatchToElement(new $4e8ea7ab4b22b6b2$var$Param(draggingTarget, e), "dragstart", e.event);
        }
    };
    Draggable.prototype._drag = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) {
            var x = e.offsetX;
            var y = e.offsetY;
            var dx = x - this._x;
            var dy = y - this._y;
            this._x = x;
            this._y = y;
            draggingTarget.drift(dx, dy, e);
            this.handler.dispatchToElement(new $4e8ea7ab4b22b6b2$var$Param(draggingTarget, e), "drag", e.event);
            var dropTarget = this.handler.findHover(x, y, draggingTarget).target;
            var lastDropTarget = this._dropTarget;
            this._dropTarget = dropTarget;
            if (draggingTarget !== dropTarget) {
                if (lastDropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $4e8ea7ab4b22b6b2$var$Param(lastDropTarget, e), "dragleave", e.event);
                if (dropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $4e8ea7ab4b22b6b2$var$Param(dropTarget, e), "dragenter", e.event);
            }
        }
    };
    Draggable.prototype._dragEnd = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) draggingTarget.dragging = false;
        this.handler.dispatchToElement(new $4e8ea7ab4b22b6b2$var$Param(draggingTarget, e), "dragend", e.event);
        if (this._dropTarget) this.handler.dispatchToElement(new $4e8ea7ab4b22b6b2$var$Param(this._dropTarget, e), "drop", e.event);
        this._draggingTarget = null;
        this._dropTarget = null;
    };
    return Draggable;
}();
var $4e8ea7ab4b22b6b2$export$2e2bcd8739ae039 = $4e8ea7ab4b22b6b2$var$Draggable;


var $63441a86293f101f$var$Eventful = function() {
    function Eventful(eventProcessors) {
        if (eventProcessors) this._$eventProcessor = eventProcessors;
    }
    Eventful.prototype.on = function(event, query, handler, context) {
        if (!this._$handlers) this._$handlers = {};
        var _h = this._$handlers;
        if (typeof query === "function") {
            context = handler;
            handler = query;
            query = null;
        }
        if (!handler || !event) return this;
        var eventProcessor = this._$eventProcessor;
        if (query != null && eventProcessor && eventProcessor.normalizeQuery) query = eventProcessor.normalizeQuery(query);
        if (!_h[event]) _h[event] = [];
        for(var i = 0; i < _h[event].length; i++){
            if (_h[event][i].h === handler) return this;
        }
        var wrap = {
            h: handler,
            query: query,
            ctx: context || this,
            callAtLast: handler.zrEventfulCallAtLast
        };
        var lastIndex = _h[event].length - 1;
        var lastWrap = _h[event][lastIndex];
        lastWrap && lastWrap.callAtLast ? _h[event].splice(lastIndex, 0, wrap) : _h[event].push(wrap);
        return this;
    };
    Eventful.prototype.isSilent = function(eventName) {
        var _h = this._$handlers;
        return !_h || !_h[eventName] || !_h[eventName].length;
    };
    Eventful.prototype.off = function(eventType, handler) {
        var _h = this._$handlers;
        if (!_h) return this;
        if (!eventType) {
            this._$handlers = {};
            return this;
        }
        if (handler) {
            if (_h[eventType]) {
                var newList = [];
                for(var i = 0, l = _h[eventType].length; i < l; i++)if (_h[eventType][i].h !== handler) newList.push(_h[eventType][i]);
                _h[eventType] = newList;
            }
            if (_h[eventType] && _h[eventType].length === 0) delete _h[eventType];
        } else delete _h[eventType];
        return this;
    };
    Eventful.prototype.trigger = function(eventType) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[eventType];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(eventType, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(hItem.ctx);
                        break;
                    case 1:
                        hItem.h.call(hItem.ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(hItem.ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(hItem.ctx, args);
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(eventType);
        return this;
    };
    Eventful.prototype.triggerWithContext = function(type) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[type];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var ctx = args[argLen - 1];
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(ctx);
                        break;
                    case 1:
                        hItem.h.call(ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(ctx, args.slice(1, argLen - 1));
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
        return this;
    };
    return Eventful;
}();
var $63441a86293f101f$export$2e2bcd8739ae039 = $63441a86293f101f$var$Eventful;





var $a9b673cb651a68dc$var$LN2 = Math.log(2);
function $a9b673cb651a68dc$var$determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
    var cacheKey = rowMask + "-" + colMask;
    var fullRank = rows.length;
    if (detCache.hasOwnProperty(cacheKey)) return detCache[cacheKey];
    if (rank === 1) {
        var colStart = Math.round(Math.log((1 << fullRank) - 1 & ~colMask) / $a9b673cb651a68dc$var$LN2);
        return rows[rowStart][colStart];
    }
    var subRowMask = rowMask | 1 << rowStart;
    var subRowStart = rowStart + 1;
    while(rowMask & 1 << subRowStart)subRowStart++;
    var sum = 0;
    for(var j = 0, colLocalIdx = 0; j < fullRank; j++){
        var colTag = 1 << j;
        if (!(colTag & colMask)) {
            sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j] * $a9b673cb651a68dc$var$determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
            colLocalIdx++;
        }
    }
    detCache[cacheKey] = sum;
    return sum;
}
function $a9b673cb651a68dc$export$fbdb2748a8171a7e(src, dest) {
    var mA = [
        [
            src[0],
            src[1],
            1,
            0,
            0,
            0,
            -dest[0] * src[0],
            -dest[0] * src[1]
        ],
        [
            0,
            0,
            0,
            src[0],
            src[1],
            1,
            -dest[1] * src[0],
            -dest[1] * src[1]
        ],
        [
            src[2],
            src[3],
            1,
            0,
            0,
            0,
            -dest[2] * src[2],
            -dest[2] * src[3]
        ],
        [
            0,
            0,
            0,
            src[2],
            src[3],
            1,
            -dest[3] * src[2],
            -dest[3] * src[3]
        ],
        [
            src[4],
            src[5],
            1,
            0,
            0,
            0,
            -dest[4] * src[4],
            -dest[4] * src[5]
        ],
        [
            0,
            0,
            0,
            src[4],
            src[5],
            1,
            -dest[5] * src[4],
            -dest[5] * src[5]
        ],
        [
            src[6],
            src[7],
            1,
            0,
            0,
            0,
            -dest[6] * src[6],
            -dest[6] * src[7]
        ],
        [
            0,
            0,
            0,
            src[6],
            src[7],
            1,
            -dest[7] * src[6],
            -dest[7] * src[7]
        ]
    ];
    var detCache = {};
    var det = $a9b673cb651a68dc$var$determinant(mA, 8, 0, 0, 0, detCache);
    if (det === 0) return;
    var vh = [];
    for(var i = 0; i < 8; i++)for(var j = 0; j < 8; j++){
        vh[j] == null && (vh[j] = 0);
        vh[j] += ((i + j) % 2 ? -1 : 1) * $a9b673cb651a68dc$var$determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache) / det * dest[i];
    }
    return function(out, srcPointX, srcPointY) {
        var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
        out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
        out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
    };
}



var $664e052f390bd76e$var$EVENT_SAVED_PROP = "___zrEVENTSAVED";
var $664e052f390bd76e$var$_calcOut = [];
function $664e052f390bd76e$export$8c5c02e118307e20(out, elFrom, elTarget, inX, inY) {
    return $664e052f390bd76e$export$1219648acc517df4($664e052f390bd76e$var$_calcOut, elFrom, inX, inY, true) && $664e052f390bd76e$export$1219648acc517df4(out, elTarget, $664e052f390bd76e$var$_calcOut[0], $664e052f390bd76e$var$_calcOut[1]);
}
function $664e052f390bd76e$export$a29dbe4b7d3cd586(elFrom, elTarget) {
    elFrom && dealClear(elFrom);
    elTarget && dealClear(elTarget);
    function dealClear(el) {
        var saved = el[$664e052f390bd76e$var$EVENT_SAVED_PROP];
        if (saved) {
            saved.clearMarkers && saved.clearMarkers();
            delete el[$664e052f390bd76e$var$EVENT_SAVED_PROP];
        }
    }
}
function $664e052f390bd76e$export$1219648acc517df4(out, el, inX, inY, inverse) {
    if (el.getBoundingClientRect && (0, $ce6dd58693a21851$export$2e2bcd8739ae039).domSupported && !$664e052f390bd76e$export$1b92e4fe606eff6d(el)) {
        var saved = el[$664e052f390bd76e$var$EVENT_SAVED_PROP] || (el[$664e052f390bd76e$var$EVENT_SAVED_PROP] = {});
        var markers = $664e052f390bd76e$var$prepareCoordMarkers(el, saved);
        var transformer = $664e052f390bd76e$var$preparePointerTransformer(markers, saved, inverse);
        if (transformer) {
            transformer(out, inX, inY);
            return true;
        }
    }
    return false;
}
function $664e052f390bd76e$var$prepareCoordMarkers(el, saved) {
    var markers = saved.markers;
    if (markers) return markers;
    markers = saved.markers = [];
    var propLR = [
        "left",
        "right"
    ];
    var propTB = [
        "top",
        "bottom"
    ];
    for(var i = 0; i < 4; i++){
        var marker = document.createElement("div");
        var stl = marker.style;
        var idxLR = i % 2;
        var idxTB = (i >> 1) % 2;
        stl.cssText = [
            "position: absolute",
            "visibility: hidden",
            "padding: 0",
            "margin: 0",
            "border-width: 0",
            "user-select: none",
            "width:0",
            "height:0",
            propLR[idxLR] + ":0",
            propTB[idxTB] + ":0",
            propLR[1 - idxLR] + ":auto",
            propTB[1 - idxTB] + ":auto",
            ""
        ].join("!important;");
        el.appendChild(marker);
        markers.push(marker);
    }
    saved.clearMarkers = function() {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(markers, function(marker) {
            marker.parentNode && marker.parentNode.removeChild(marker);
        });
    };
    return markers;
}
function $664e052f390bd76e$var$preparePointerTransformer(markers, saved, inverse) {
    var transformerName = inverse ? "invTrans" : "trans";
    var transformer = saved[transformerName];
    var oldSrcCoords = saved.srcCoords;
    var srcCoords = [];
    var destCoords = [];
    var oldCoordTheSame = true;
    for(var i = 0; i < 4; i++){
        var rect = markers[i].getBoundingClientRect();
        var ii = 2 * i;
        var x = rect.left;
        var y = rect.top;
        srcCoords.push(x, y);
        oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
        destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
    }
    return oldCoordTheSame && transformer ? transformer : (saved.srcCoords = srcCoords, saved[transformerName] = inverse ? (0, $a9b673cb651a68dc$export$fbdb2748a8171a7e)(destCoords, srcCoords) : (0, $a9b673cb651a68dc$export$fbdb2748a8171a7e)(srcCoords, destCoords));
}
function $664e052f390bd76e$export$1b92e4fe606eff6d(el) {
    return el.nodeName.toUpperCase() === "CANVAS";
}
var $664e052f390bd76e$var$replaceReg = /([&<>"'])/g;
var $664e052f390bd76e$var$replaceMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
function $664e052f390bd76e$export$f9d6449b9af28dc1(source) {
    return source == null ? "" : (source + "").replace($664e052f390bd76e$var$replaceReg, function(str, c) {
        return $664e052f390bd76e$var$replaceMap[c];
    });
}


var $b3864a78637ff9ed$var$MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
var $b3864a78637ff9ed$var$_calcOut = [];
var $b3864a78637ff9ed$var$firefoxNotSupportOffsetXY = (0, $ce6dd58693a21851$export$2e2bcd8739ae039).browser.firefox && +(0, $ce6dd58693a21851$export$2e2bcd8739ae039).browser.version.split(".")[0] < 39;
function $b3864a78637ff9ed$export$7d5fecde839eee88(el, e, out, calculate) {
    out = out || {};
    if (calculate) $b3864a78637ff9ed$var$calculateZrXY(el, e, out);
    else if ($b3864a78637ff9ed$var$firefoxNotSupportOffsetXY && e.layerX != null && e.layerX !== e.offsetX) {
        out.zrX = e.layerX;
        out.zrY = e.layerY;
    } else if (e.offsetX != null) {
        out.zrX = e.offsetX;
        out.zrY = e.offsetY;
    } else $b3864a78637ff9ed$var$calculateZrXY(el, e, out);
    return out;
}
function $b3864a78637ff9ed$var$calculateZrXY(el, e, out) {
    if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).domSupported && el.getBoundingClientRect) {
        var ex = e.clientX;
        var ey = e.clientY;
        if ((0, $664e052f390bd76e$export$1b92e4fe606eff6d)(el)) {
            var box = el.getBoundingClientRect();
            out.zrX = ex - box.left;
            out.zrY = ey - box.top;
            return;
        } else if ((0, $664e052f390bd76e$export$1219648acc517df4)($b3864a78637ff9ed$var$_calcOut, el, ex, ey)) {
            out.zrX = $b3864a78637ff9ed$var$_calcOut[0];
            out.zrY = $b3864a78637ff9ed$var$_calcOut[1];
            return;
        }
    }
    out.zrX = out.zrY = 0;
}
function $b3864a78637ff9ed$export$4abe0e945399ac1d(e) {
    return e || window.event;
}
function $b3864a78637ff9ed$export$40fadb093aebad71(el, e, calculate) {
    e = $b3864a78637ff9ed$export$4abe0e945399ac1d(e);
    if (e.zrX != null) return e;
    var eventType = e.type;
    var isTouch = eventType && eventType.indexOf("touch") >= 0;
    if (!isTouch) {
        $b3864a78637ff9ed$export$7d5fecde839eee88(el, e, e, calculate);
        var wheelDelta = $b3864a78637ff9ed$var$getWheelDeltaMayPolyfill(e);
        e.zrDelta = wheelDelta ? wheelDelta / 120 : -(e.detail || 0) / 3;
    } else {
        var touch = eventType !== "touchend" ? e.targetTouches[0] : e.changedTouches[0];
        touch && $b3864a78637ff9ed$export$7d5fecde839eee88(el, touch, e, calculate);
    }
    var button = e.button;
    if (e.which == null && button !== undefined && $b3864a78637ff9ed$var$MOUSE_EVENT_REG.test(e.type)) e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
    return e;
}
function $b3864a78637ff9ed$var$getWheelDeltaMayPolyfill(e) {
    var rawWheelDelta = e.wheelDelta;
    if (rawWheelDelta) return rawWheelDelta;
    var deltaX = e.deltaX;
    var deltaY = e.deltaY;
    if (deltaX == null || deltaY == null) return rawWheelDelta;
    var delta = deltaY !== 0 ? Math.abs(deltaY) : Math.abs(deltaX);
    var sign = deltaY > 0 ? -1 : deltaY < 0 ? 1 : deltaX > 0 ? -1 : 1;
    return 3 * delta * sign;
}
function $b3864a78637ff9ed$export$3f65cefe8380dbea(el, name, handler, opt) {
    el.addEventListener(name, handler, opt);
}
function $b3864a78637ff9ed$export$8ff9f68337b520c0(el, name, handler, opt) {
    el.removeEventListener(name, handler, opt);
}
var $b3864a78637ff9ed$export$fa6813432f753b0d = function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.cancelBubble = true;
};
function $b3864a78637ff9ed$export$b7ae4cded3e71bd2(e) {
    return e.which === 2 || e.which === 3;
}



var $225ab5cf635fc62d$export$f7557d6f27e9503 = function() {
    function GestureMgr() {
        this._track = [];
    }
    GestureMgr.prototype.recognize = function(event, target, root) {
        this._doTrack(event, target, root);
        return this._recognize(event);
    };
    GestureMgr.prototype.clear = function() {
        this._track.length = 0;
        return this;
    };
    GestureMgr.prototype._doTrack = function(event, target, root) {
        var touches = event.touches;
        if (!touches) return;
        var trackItem = {
            points: [],
            touches: [],
            target: target,
            event: event
        };
        for(var i = 0, len = touches.length; i < len; i++){
            var touch = touches[i];
            var pos = $b3864a78637ff9ed$export$7d5fecde839eee88(root, touch, {});
            trackItem.points.push([
                pos.zrX,
                pos.zrY
            ]);
            trackItem.touches.push(touch);
        }
        this._track.push(trackItem);
    };
    GestureMgr.prototype._recognize = function(event) {
        for(var eventName in $225ab5cf635fc62d$var$recognizers)if ($225ab5cf635fc62d$var$recognizers.hasOwnProperty(eventName)) {
            var gestureInfo = $225ab5cf635fc62d$var$recognizers[eventName](this._track, event);
            if (gestureInfo) return gestureInfo;
        }
    };
    return GestureMgr;
}();
function $225ab5cf635fc62d$var$dist(pointPair) {
    var dx = pointPair[1][0] - pointPair[0][0];
    var dy = pointPair[1][1] - pointPair[0][1];
    return Math.sqrt(dx * dx + dy * dy);
}
function $225ab5cf635fc62d$var$center(pointPair) {
    return [
        (pointPair[0][0] + pointPair[1][0]) / 2,
        (pointPair[0][1] + pointPair[1][1]) / 2
    ];
}
var $225ab5cf635fc62d$var$recognizers = {
    pinch: function(tracks, event) {
        var trackLen = tracks.length;
        if (!trackLen) return;
        var pinchEnd = (tracks[trackLen - 1] || {}).points;
        var pinchPre = (tracks[trackLen - 2] || {}).points || pinchEnd;
        if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
            var pinchScale = $225ab5cf635fc62d$var$dist(pinchEnd) / $225ab5cf635fc62d$var$dist(pinchPre);
            !isFinite(pinchScale) && (pinchScale = 1);
            event.pinchScale = pinchScale;
            var pinchCenter = $225ab5cf635fc62d$var$center(pinchEnd);
            event.pinchX = pinchCenter[0];
            event.pinchY = pinchCenter[1];
            return {
                type: "pinch",
                target: tracks[0].target,
                event: event
            };
        }
    }
};


function $f41ebb9dd60b55b4$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $f41ebb9dd60b55b4$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = 0;
    out[5] = 0;
    return out;
}
function $f41ebb9dd60b55b4$export$784d13d8ee351f07(out, m) {
    out[0] = m[0];
    out[1] = m[1];
    out[2] = m[2];
    out[3] = m[3];
    out[4] = m[4];
    out[5] = m[5];
    return out;
}
function $f41ebb9dd60b55b4$export$6e3a27864ab166fe(out, m1, m2) {
    var out0 = m1[0] * m2[0] + m1[2] * m2[1];
    var out1 = m1[1] * m2[0] + m1[3] * m2[1];
    var out2 = m1[0] * m2[2] + m1[2] * m2[3];
    var out3 = m1[1] * m2[2] + m1[3] * m2[3];
    var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
    var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = out3;
    out[4] = out4;
    out[5] = out5;
    return out;
}
function $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(out, a, v) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4] + v[0];
    out[5] = a[5] + v[1];
    return out;
}
function $f41ebb9dd60b55b4$export$bb628a54ab399bc9(out, a, rad, pivot) {
    if (pivot === void 0) pivot = [
        0,
        0
    ];
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var st = Math.sin(rad);
    var ct = Math.cos(rad);
    out[0] = aa * ct + ab * st;
    out[1] = -aa * st + ab * ct;
    out[2] = ac * ct + ad * st;
    out[3] = -ac * st + ct * ad;
    out[4] = ct * (atx - pivot[0]) + st * (aty - pivot[1]) + pivot[0];
    out[5] = ct * (aty - pivot[1]) - st * (atx - pivot[0]) + pivot[1];
    return out;
}
function $f41ebb9dd60b55b4$export$dcdf75081b88279d(out, a, v) {
    var vx = v[0];
    var vy = v[1];
    out[0] = a[0] * vx;
    out[1] = a[1] * vy;
    out[2] = a[2] * vx;
    out[3] = a[3] * vy;
    out[4] = a[4] * vx;
    out[5] = a[5] * vy;
    return out;
}
function $f41ebb9dd60b55b4$export$6897c284b6f9f4dc(out, a) {
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var det = aa * ad - ab * ac;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = ad * det;
    out[1] = -ab * det;
    out[2] = -ac * det;
    out[3] = aa * det;
    out[4] = (ac * aty - ad * atx) * det;
    out[5] = (ab * atx - aa * aty) * det;
    return out;
}
function $f41ebb9dd60b55b4$export$9cd59f9826255e47(a) {
    var b = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
    $f41ebb9dd60b55b4$export$784d13d8ee351f07(b, a);
    return b;
}


var $b887f038f104fe7e$var$Point = function() {
    function Point(x, y) {
        this.x = x || 0;
        this.y = y || 0;
    }
    Point.prototype.copy = function(other) {
        this.x = other.x;
        this.y = other.y;
        return this;
    };
    Point.prototype.clone = function() {
        return new Point(this.x, this.y);
    };
    Point.prototype.set = function(x, y) {
        this.x = x;
        this.y = y;
        return this;
    };
    Point.prototype.equal = function(other) {
        return other.x === this.x && other.y === this.y;
    };
    Point.prototype.add = function(other) {
        this.x += other.x;
        this.y += other.y;
        return this;
    };
    Point.prototype.scale = function(scalar) {
        this.x *= scalar;
        this.y *= scalar;
    };
    Point.prototype.scaleAndAdd = function(other, scalar) {
        this.x += other.x * scalar;
        this.y += other.y * scalar;
    };
    Point.prototype.sub = function(other) {
        this.x -= other.x;
        this.y -= other.y;
        return this;
    };
    Point.prototype.dot = function(other) {
        return this.x * other.x + this.y * other.y;
    };
    Point.prototype.len = function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    };
    Point.prototype.lenSquare = function() {
        return this.x * this.x + this.y * this.y;
    };
    Point.prototype.normalize = function() {
        var len = this.len();
        this.x /= len;
        this.y /= len;
        return this;
    };
    Point.prototype.distance = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return Math.sqrt(dx * dx + dy * dy);
    };
    Point.prototype.distanceSquare = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return dx * dx + dy * dy;
    };
    Point.prototype.negate = function() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    };
    Point.prototype.transform = function(m) {
        if (!m) return;
        var x = this.x;
        var y = this.y;
        this.x = m[0] * x + m[2] * y + m[4];
        this.y = m[1] * x + m[3] * y + m[5];
        return this;
    };
    Point.prototype.toArray = function(out) {
        out[0] = this.x;
        out[1] = this.y;
        return out;
    };
    Point.prototype.fromArray = function(input) {
        this.x = input[0];
        this.y = input[1];
    };
    Point.set = function(p, x, y) {
        p.x = x;
        p.y = y;
    };
    Point.copy = function(p, p2) {
        p.x = p2.x;
        p.y = p2.y;
    };
    Point.len = function(p) {
        return Math.sqrt(p.x * p.x + p.y * p.y);
    };
    Point.lenSquare = function(p) {
        return p.x * p.x + p.y * p.y;
    };
    Point.dot = function(p0, p1) {
        return p0.x * p1.x + p0.y * p1.y;
    };
    Point.add = function(out, p0, p1) {
        out.x = p0.x + p1.x;
        out.y = p0.y + p1.y;
    };
    Point.sub = function(out, p0, p1) {
        out.x = p0.x - p1.x;
        out.y = p0.y - p1.y;
    };
    Point.scale = function(out, p0, scalar) {
        out.x = p0.x * scalar;
        out.y = p0.y * scalar;
    };
    Point.scaleAndAdd = function(out, p0, p1, scalar) {
        out.x = p0.x + p1.x * scalar;
        out.y = p0.y + p1.y * scalar;
    };
    Point.lerp = function(out, p0, p1, t) {
        var onet = 1 - t;
        out.x = onet * p0.x + t * p1.x;
        out.y = onet * p0.y + t * p1.y;
    };
    return Point;
}();
var $b887f038f104fe7e$export$2e2bcd8739ae039 = $b887f038f104fe7e$var$Point;


var $1bebe7106c895823$var$mathMin = Math.min;
var $1bebe7106c895823$var$mathMax = Math.max;
var $1bebe7106c895823$var$mathAbs = Math.abs;
var $1bebe7106c895823$var$XY = [
    "x",
    "y"
];
var $1bebe7106c895823$var$WH = [
    "width",
    "height"
];
var $1bebe7106c895823$var$lt = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $1bebe7106c895823$var$rb = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $1bebe7106c895823$var$lb = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $1bebe7106c895823$var$rt = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $1bebe7106c895823$var$_intersectCtx = $1bebe7106c895823$export$a0be2bdbd2369e0e();
var $1bebe7106c895823$var$_minTv = $1bebe7106c895823$var$_intersectCtx.minTv;
var $1bebe7106c895823$var$_maxTv = $1bebe7106c895823$var$_intersectCtx.maxTv;
var $1bebe7106c895823$var$_lenMinMax = [
    0,
    0
];
var $1bebe7106c895823$var$BoundingRect = function() {
    function BoundingRect(x, y, width, height) {
        BoundingRect.set(this, x, y, width, height);
    }
    BoundingRect.set = function(target, x, y, width, height) {
        if (width < 0) {
            x = x + width;
            width = -width;
        }
        if (height < 0) {
            y = y + height;
            height = -height;
        }
        target.x = x;
        target.y = y;
        target.width = width;
        target.height = height;
        return target;
    };
    BoundingRect.prototype.union = function(other) {
        var x = $1bebe7106c895823$var$mathMin(other.x, this.x);
        var y = $1bebe7106c895823$var$mathMin(other.y, this.y);
        if (isFinite(this.x) && isFinite(this.width)) this.width = $1bebe7106c895823$var$mathMax(other.x + other.width, this.x + this.width) - x;
        else this.width = other.width;
        if (isFinite(this.y) && isFinite(this.height)) this.height = $1bebe7106c895823$var$mathMax(other.y + other.height, this.y + this.height) - y;
        else this.height = other.height;
        this.x = x;
        this.y = y;
    };
    BoundingRect.prototype.applyTransform = function(m) {
        BoundingRect.applyTransform(this, this, m);
    };
    BoundingRect.prototype.calculateTransform = function(b) {
        var a = this;
        var sx = b.width / a.width;
        var sy = b.height / a.height;
        var m = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
        $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(m, m, [
            -a.x,
            -a.y
        ]);
        $f41ebb9dd60b55b4$export$dcdf75081b88279d(m, m, [
            sx,
            sy
        ]);
        $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(m, m, [
            b.x,
            b.y
        ]);
        return m;
    };
    BoundingRect.prototype.intersect = function(b, mtv, opt) {
        return BoundingRect.intersect(this, b, mtv, opt);
    };
    BoundingRect.intersect = function(a, b, mtv, opt) {
        if (mtv) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).set(mtv, 0, 0);
        var outIntersectRect = opt && opt.outIntersectRect || null;
        var clamp = opt && opt.clamp;
        if (outIntersectRect) outIntersectRect.x = outIntersectRect.y = outIntersectRect.width = outIntersectRect.height = NaN;
        if (!a || !b) return false;
        if (!(a instanceof BoundingRect)) a = BoundingRect.set($1bebe7106c895823$var$_tmpIntersectA, a.x, a.y, a.width, a.height);
        if (!(b instanceof BoundingRect)) b = BoundingRect.set($1bebe7106c895823$var$_tmpIntersectB, b.x, b.y, b.width, b.height);
        var useMTV = !!mtv;
        $1bebe7106c895823$var$_intersectCtx.reset(opt, useMTV);
        var touchThreshold = $1bebe7106c895823$var$_intersectCtx.touchThreshold;
        var ax0 = a.x + touchThreshold;
        var ax1 = a.x + a.width - touchThreshold;
        var ay0 = a.y + touchThreshold;
        var ay1 = a.y + a.height - touchThreshold;
        var bx0 = b.x + touchThreshold;
        var bx1 = b.x + b.width - touchThreshold;
        var by0 = b.y + touchThreshold;
        var by1 = b.y + b.height - touchThreshold;
        if (ax0 > ax1 || ay0 > ay1 || bx0 > bx1 || by0 > by1) return false;
        var overlap = !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
        if (useMTV || outIntersectRect) {
            $1bebe7106c895823$var$_lenMinMax[0] = Infinity;
            $1bebe7106c895823$var$_lenMinMax[1] = 0;
            $1bebe7106c895823$var$intersectOneDim(ax0, ax1, bx0, bx1, 0, useMTV, outIntersectRect, clamp);
            $1bebe7106c895823$var$intersectOneDim(ay0, ay1, by0, by1, 1, useMTV, outIntersectRect, clamp);
            if (useMTV) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy(mtv, overlap ? $1bebe7106c895823$var$_intersectCtx.useDir ? $1bebe7106c895823$var$_intersectCtx.dirMinTv : $1bebe7106c895823$var$_minTv : $1bebe7106c895823$var$_maxTv);
        }
        return overlap;
    };
    BoundingRect.contain = function(rect, x, y) {
        return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
    };
    BoundingRect.prototype.contain = function(x, y) {
        return BoundingRect.contain(this, x, y);
    };
    BoundingRect.prototype.clone = function() {
        return new BoundingRect(this.x, this.y, this.width, this.height);
    };
    BoundingRect.prototype.copy = function(other) {
        BoundingRect.copy(this, other);
    };
    BoundingRect.prototype.plain = function() {
        return {
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height
        };
    };
    BoundingRect.prototype.isFinite = function() {
        return isFinite(this.x) && isFinite(this.y) && isFinite(this.width) && isFinite(this.height);
    };
    BoundingRect.prototype.isZero = function() {
        return this.width === 0 || this.height === 0;
    };
    BoundingRect.create = function(rect) {
        return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
    };
    BoundingRect.copy = function(target, source) {
        target.x = source.x;
        target.y = source.y;
        target.width = source.width;
        target.height = source.height;
        return target;
    };
    BoundingRect.applyTransform = function(target, source, m) {
        if (!m) {
            if (target !== source) BoundingRect.copy(target, source);
            return;
        }
        if (m[1] < 1e-5 && m[1] > -0.00001 && m[2] < 1e-5 && m[2] > -0.00001) {
            var sx = m[0];
            var sy = m[3];
            var tx = m[4];
            var ty = m[5];
            target.x = source.x * sx + tx;
            target.y = source.y * sy + ty;
            target.width = source.width * sx;
            target.height = source.height * sy;
            if (target.width < 0) {
                target.x += target.width;
                target.width = -target.width;
            }
            if (target.height < 0) {
                target.y += target.height;
                target.height = -target.height;
            }
            return;
        }
        $1bebe7106c895823$var$lt.x = $1bebe7106c895823$var$lb.x = source.x;
        $1bebe7106c895823$var$lt.y = $1bebe7106c895823$var$rt.y = source.y;
        $1bebe7106c895823$var$rb.x = $1bebe7106c895823$var$rt.x = source.x + source.width;
        $1bebe7106c895823$var$rb.y = $1bebe7106c895823$var$lb.y = source.y + source.height;
        $1bebe7106c895823$var$lt.transform(m);
        $1bebe7106c895823$var$rt.transform(m);
        $1bebe7106c895823$var$rb.transform(m);
        $1bebe7106c895823$var$lb.transform(m);
        target.x = $1bebe7106c895823$var$mathMin($1bebe7106c895823$var$lt.x, $1bebe7106c895823$var$rb.x, $1bebe7106c895823$var$lb.x, $1bebe7106c895823$var$rt.x);
        target.y = $1bebe7106c895823$var$mathMin($1bebe7106c895823$var$lt.y, $1bebe7106c895823$var$rb.y, $1bebe7106c895823$var$lb.y, $1bebe7106c895823$var$rt.y);
        var maxX = $1bebe7106c895823$var$mathMax($1bebe7106c895823$var$lt.x, $1bebe7106c895823$var$rb.x, $1bebe7106c895823$var$lb.x, $1bebe7106c895823$var$rt.x);
        var maxY = $1bebe7106c895823$var$mathMax($1bebe7106c895823$var$lt.y, $1bebe7106c895823$var$rb.y, $1bebe7106c895823$var$lb.y, $1bebe7106c895823$var$rt.y);
        target.width = maxX - target.x;
        target.height = maxY - target.y;
    };
    return BoundingRect;
}();
var $1bebe7106c895823$var$_tmpIntersectA = new $1bebe7106c895823$var$BoundingRect(0, 0, 0, 0);
var $1bebe7106c895823$var$_tmpIntersectB = new $1bebe7106c895823$var$BoundingRect(0, 0, 0, 0);
function $1bebe7106c895823$var$intersectOneDim(a0, a1, b0, b1, updateDimIdx, useMTV, outIntersectRect, clamp) {
    var d0 = $1bebe7106c895823$var$mathAbs(a1 - b0);
    var d1 = $1bebe7106c895823$var$mathAbs(b1 - a0);
    var d01min = $1bebe7106c895823$var$mathMin(d0, d1);
    var updateDim = $1bebe7106c895823$var$XY[updateDimIdx];
    var zeroDim = $1bebe7106c895823$var$XY[1 - updateDimIdx];
    var wh = $1bebe7106c895823$var$WH[updateDimIdx];
    if (a1 < b0 || b1 < a0) {
        if (d0 < d1) {
            if (useMTV) $1bebe7106c895823$var$_maxTv[updateDim] = -d0;
            if (clamp) {
                outIntersectRect[updateDim] = a1;
                outIntersectRect[wh] = 0;
            }
        } else {
            if (useMTV) $1bebe7106c895823$var$_maxTv[updateDim] = d1;
            if (clamp) {
                outIntersectRect[updateDim] = a0;
                outIntersectRect[wh] = 0;
            }
        }
    } else {
        if (outIntersectRect) {
            outIntersectRect[updateDim] = $1bebe7106c895823$var$mathMax(a0, b0);
            outIntersectRect[wh] = $1bebe7106c895823$var$mathMin(a1, b1) - outIntersectRect[updateDim];
        }
        if (useMTV) {
            if (d01min < $1bebe7106c895823$var$_lenMinMax[0] || $1bebe7106c895823$var$_intersectCtx.useDir) {
                $1bebe7106c895823$var$_lenMinMax[0] = $1bebe7106c895823$var$mathMin(d01min, $1bebe7106c895823$var$_lenMinMax[0]);
                if (d0 < d1 || !$1bebe7106c895823$var$_intersectCtx.bidirectional) {
                    $1bebe7106c895823$var$_minTv[updateDim] = d0;
                    $1bebe7106c895823$var$_minTv[zeroDim] = 0;
                    if ($1bebe7106c895823$var$_intersectCtx.useDir) $1bebe7106c895823$var$_intersectCtx.calcDirMTV();
                }
                if (d0 >= d1 || !$1bebe7106c895823$var$_intersectCtx.bidirectional) {
                    $1bebe7106c895823$var$_minTv[updateDim] = -d1;
                    $1bebe7106c895823$var$_minTv[zeroDim] = 0;
                    if ($1bebe7106c895823$var$_intersectCtx.useDir) $1bebe7106c895823$var$_intersectCtx.calcDirMTV();
                }
            }
        }
    }
}
function $1bebe7106c895823$export$a0be2bdbd2369e0e() {
    var _direction = 0;
    var _dirCheckVec = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
    var _dirTmp = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
    var _ctx = {
        minTv: new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(),
        maxTv: new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(),
        useDir: false,
        dirMinTv: new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(),
        touchThreshold: 0,
        bidirectional: true,
        negativeSize: false,
        reset: function(opt, useMTV) {
            _ctx.touchThreshold = 0;
            if (opt && opt.touchThreshold != null) _ctx.touchThreshold = $1bebe7106c895823$var$mathMax(0, opt.touchThreshold);
            _ctx.negativeSize = false;
            if (!useMTV) return;
            _ctx.minTv.set(Infinity, Infinity);
            _ctx.maxTv.set(0, 0);
            _ctx.useDir = false;
            if (opt && opt.direction != null) {
                _ctx.useDir = true;
                _ctx.dirMinTv.copy(_ctx.minTv);
                _dirTmp.copy(_ctx.minTv);
                _direction = opt.direction;
                _ctx.bidirectional = opt.bidirectional == null || !!opt.bidirectional;
                if (!_ctx.bidirectional) _dirCheckVec.set(Math.cos(_direction), Math.sin(_direction));
            }
        },
        calcDirMTV: function() {
            var minTv = _ctx.minTv;
            var dirMinTv = _ctx.dirMinTv;
            var squareMag = minTv.y * minTv.y + minTv.x * minTv.x;
            var dirSin = Math.sin(_direction);
            var dirCos = Math.cos(_direction);
            var dotProd = dirSin * minTv.y + dirCos * minTv.x;
            if (nearZero(dotProd)) {
                if (nearZero(minTv.x) && nearZero(minTv.y)) dirMinTv.set(0, 0);
                return;
            }
            _dirTmp.x = squareMag * dirCos / dotProd;
            _dirTmp.y = squareMag * dirSin / dotProd;
            if (nearZero(_dirTmp.x) && nearZero(_dirTmp.y)) {
                dirMinTv.set(0, 0);
                return;
            }
            if ((_ctx.bidirectional || _dirCheckVec.dot(_dirTmp) > 0) && _dirTmp.len() < dirMinTv.len()) dirMinTv.copy(_dirTmp);
        }
    };
    function nearZero(val) {
        return $1bebe7106c895823$var$mathAbs(val) < 1e-10;
    }
    return _ctx;
}
var $1bebe7106c895823$export$2e2bcd8739ae039 = $1bebe7106c895823$var$BoundingRect;


var $b30f5d021af2ec5a$var$SILENT = "silent";
function $b30f5d021af2ec5a$var$makeEventPacket(eveType, targetInfo, event) {
    return {
        type: eveType,
        event: event,
        target: targetInfo.target,
        topTarget: targetInfo.topTarget,
        cancelBubble: false,
        offsetX: event.zrX,
        offsetY: event.zrY,
        gestureEvent: event.gestureEvent,
        pinchX: event.pinchX,
        pinchY: event.pinchY,
        pinchScale: event.pinchScale,
        wheelDelta: event.zrDelta,
        zrByTouch: event.zrByTouch,
        which: event.which,
        stop: $b30f5d021af2ec5a$var$stopEvent
    };
}
function $b30f5d021af2ec5a$var$stopEvent() {
    $b3864a78637ff9ed$export$fa6813432f753b0d(this.event);
}
var $b30f5d021af2ec5a$var$EmptyProxy = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(EmptyProxy, _super);
    function EmptyProxy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handler = null;
        return _this;
    }
    EmptyProxy.prototype.dispose = function() {};
    EmptyProxy.prototype.setCursor = function() {};
    return EmptyProxy;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
var $b30f5d021af2ec5a$var$HoveredResult = function() {
    function HoveredResult(x, y) {
        this.x = x;
        this.y = y;
    }
    return HoveredResult;
}();
var $b30f5d021af2ec5a$var$handlerNames = [
    "click",
    "dblclick",
    "mousewheel",
    "mouseout",
    "mouseup",
    "mousedown",
    "mousemove",
    "contextmenu"
];
var $b30f5d021af2ec5a$var$tmpRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $b30f5d021af2ec5a$var$Handler = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Handler, _super);
    function Handler(storage, painter, proxy, painterRoot, pointerSize) {
        var _this = _super.call(this) || this;
        _this._hovered = new $b30f5d021af2ec5a$var$HoveredResult(0, 0);
        _this.storage = storage;
        _this.painter = painter;
        _this.painterRoot = painterRoot;
        _this._pointerSize = pointerSize;
        proxy = proxy || new $b30f5d021af2ec5a$var$EmptyProxy();
        _this.proxy = null;
        _this.setHandlerProxy(proxy);
        _this._draggingMgr = new (0, $4e8ea7ab4b22b6b2$export$2e2bcd8739ae039)(_this);
        return _this;
    }
    Handler.prototype.setHandlerProxy = function(proxy) {
        if (this.proxy) this.proxy.dispose();
        if (proxy) {
            $7a1bd9c2710fea0d$export$79b2f7037acddd43($b30f5d021af2ec5a$var$handlerNames, function(name) {
                proxy.on && proxy.on(name, this[name], this);
            }, this);
            proxy.handler = this;
        }
        this.proxy = proxy;
    };
    Handler.prototype.mousemove = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $b30f5d021af2ec5a$var$isOutsideBoundary(this, x, y);
        var lastHovered = this._hovered;
        var lastHoveredTarget = lastHovered.target;
        if (lastHoveredTarget && !lastHoveredTarget.__zr) {
            lastHovered = this.findHover(lastHovered.x, lastHovered.y);
            lastHoveredTarget = lastHovered.target;
        }
        var hovered = this._hovered = isOutside ? new $b30f5d021af2ec5a$var$HoveredResult(x, y) : this.findHover(x, y);
        var hoveredTarget = hovered.target;
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : "default");
        if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(lastHovered, "mouseout", event);
        this.dispatchToElement(hovered, "mousemove", event);
        if (hoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(hovered, "mouseover", event);
    };
    Handler.prototype.mouseout = function(event) {
        var eventControl = event.zrEventControl;
        if (eventControl !== "only_globalout") this.dispatchToElement(this._hovered, "mouseout", event);
        if (eventControl !== "no_globalout") this.trigger("globalout", {
            type: "globalout",
            event: event
        });
    };
    Handler.prototype.resize = function() {
        this._hovered = new $b30f5d021af2ec5a$var$HoveredResult(0, 0);
    };
    Handler.prototype.dispatch = function(eventName, eventArgs) {
        var handler = this[eventName];
        handler && handler.call(this, eventArgs);
    };
    Handler.prototype.dispose = function() {
        this.proxy.dispose();
        this.storage = null;
        this.proxy = null;
        this.painter = null;
    };
    Handler.prototype.setCursorStyle = function(cursorStyle) {
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(cursorStyle);
    };
    Handler.prototype.dispatchToElement = function(targetInfo, eventName, event) {
        targetInfo = targetInfo || {};
        var el = targetInfo.target;
        if (el && el.silent) return;
        var eventKey = "on" + eventName;
        var eventPacket = $b30f5d021af2ec5a$var$makeEventPacket(eventName, targetInfo, event);
        while(el){
            el[eventKey] && (eventPacket.cancelBubble = !!el[eventKey].call(el, eventPacket));
            el.trigger(eventName, eventPacket);
            el = el.__hostTarget ? el.__hostTarget : el.parent;
            if (eventPacket.cancelBubble) break;
        }
        if (!eventPacket.cancelBubble) {
            this.trigger(eventName, eventPacket);
            if (this.painter && this.painter.eachOtherLayer) this.painter.eachOtherLayer(function(layer) {
                if (typeof layer[eventKey] === "function") layer[eventKey].call(layer, eventPacket);
                if (layer.trigger) layer.trigger(eventName, eventPacket);
            });
        }
    };
    Handler.prototype.findHover = function(x, y, exclude) {
        var list = this.storage.getDisplayList();
        var out = new $b30f5d021af2ec5a$var$HoveredResult(x, y);
        $b30f5d021af2ec5a$var$setHoverTarget(list, out, x, y, exclude);
        if (this._pointerSize && !out.target) {
            var candidates = [];
            var pointerSize = this._pointerSize;
            var targetSizeHalf = pointerSize / 2;
            var pointerRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x - targetSizeHalf, y - targetSizeHalf, pointerSize, pointerSize);
            for(var i = list.length - 1; i >= 0; i--){
                var el = list[i];
                if (el !== exclude && !el.ignore && !el.ignoreCoarsePointer && (!el.parent || !el.parent.ignoreCoarsePointer)) {
                    $b30f5d021af2ec5a$var$tmpRect.copy(el.getBoundingRect());
                    if (el.transform) $b30f5d021af2ec5a$var$tmpRect.applyTransform(el.transform);
                    if ($b30f5d021af2ec5a$var$tmpRect.intersect(pointerRect)) candidates.push(el);
                }
            }
            if (candidates.length) {
                var rStep = 4;
                var thetaStep = Math.PI / 12;
                var PI2 = Math.PI * 2;
                for(var r = 0; r < targetSizeHalf; r += rStep)for(var theta = 0; theta < PI2; theta += thetaStep){
                    var x1 = x + r * Math.cos(theta);
                    var y1 = y + r * Math.sin(theta);
                    $b30f5d021af2ec5a$var$setHoverTarget(candidates, out, x1, y1, exclude);
                    if (out.target) return out;
                }
            }
        }
        return out;
    };
    Handler.prototype.processGesture = function(event, stage) {
        if (!this._gestureMgr) this._gestureMgr = new (0, $225ab5cf635fc62d$export$f7557d6f27e9503)();
        var gestureMgr = this._gestureMgr;
        stage === "start" && gestureMgr.clear();
        var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
        stage === "end" && gestureMgr.clear();
        if (gestureInfo) {
            var type = gestureInfo.type;
            event.gestureEvent = type;
            var res = new $b30f5d021af2ec5a$var$HoveredResult();
            res.target = gestureInfo.target;
            this.dispatchToElement(res, type, gestureInfo.event);
        }
    };
    return Handler;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$79b2f7037acddd43([
    "click",
    "mousedown",
    "mouseup",
    "mousewheel",
    "dblclick",
    "contextmenu"
], function(name) {
    $b30f5d021af2ec5a$var$Handler.prototype[name] = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $b30f5d021af2ec5a$var$isOutsideBoundary(this, x, y);
        var hovered;
        var hoveredTarget;
        if (name !== "mouseup" || !isOutside) {
            hovered = this.findHover(x, y);
            hoveredTarget = hovered.target;
        }
        if (name === "mousedown") {
            this._downEl = hoveredTarget;
            this._downPoint = [
                event.zrX,
                event.zrY
            ];
            this._upEl = hoveredTarget;
        } else if (name === "mouseup") this._upEl = hoveredTarget;
        else if (name === "click") {
            if (this._downEl !== this._upEl || !this._downPoint || $6de594cf8ac295ff$export$6c4a311cc157c764(this._downPoint, [
                event.zrX,
                event.zrY
            ]) > 4) return;
            this._downPoint = null;
        }
        this.dispatchToElement(hovered, name, event);
    };
});
function $b30f5d021af2ec5a$var$isHover(displayable, x, y) {
    if (displayable[displayable.rectHover ? "rectContain" : "contain"](x, y)) {
        var el = displayable;
        var isSilent = void 0;
        var ignoreClip = false;
        while(el){
            if (el.ignoreClip) ignoreClip = true;
            if (!ignoreClip) {
                var clipPath = el.getClipPath();
                if (clipPath && !clipPath.contain(x, y)) return false;
            }
            if (el.silent) isSilent = true;
            var hostEl = el.__hostTarget;
            el = hostEl ? el.ignoreHostSilent ? null : hostEl : el.parent;
        }
        return isSilent ? $b30f5d021af2ec5a$var$SILENT : true;
    }
    return false;
}
function $b30f5d021af2ec5a$var$setHoverTarget(list, out, x, y, exclude) {
    for(var i = list.length - 1; i >= 0; i--){
        var el = list[i];
        var hoverCheckResult = void 0;
        if (el !== exclude && !el.ignore && (hoverCheckResult = $b30f5d021af2ec5a$var$isHover(el, x, y))) {
            !out.topTarget && (out.topTarget = el);
            if (hoverCheckResult !== $b30f5d021af2ec5a$var$SILENT) {
                out.target = el;
                break;
            }
        }
    }
}
function $b30f5d021af2ec5a$var$isOutsideBoundary(handlerInstance, x, y) {
    var painter = handlerInstance.painter;
    return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
}
var $b30f5d021af2ec5a$export$2e2bcd8739ae039 = $b30f5d021af2ec5a$var$Handler;



var $97579a54749e4b24$var$DEFAULT_MIN_MERGE = 32;
var $97579a54749e4b24$var$DEFAULT_MIN_GALLOPING = 7;
function $97579a54749e4b24$var$minRunLength(n) {
    var r = 0;
    while(n >= $97579a54749e4b24$var$DEFAULT_MIN_MERGE){
        r |= n & 1;
        n >>= 1;
    }
    return n + r;
}
function $97579a54749e4b24$var$makeAscendingRun(array, lo, hi, compare) {
    var runHi = lo + 1;
    if (runHi === hi) return 1;
    if (compare(array[runHi++], array[lo]) < 0) {
        while(runHi < hi && compare(array[runHi], array[runHi - 1]) < 0)runHi++;
        $97579a54749e4b24$var$reverseRun(array, lo, runHi);
    } else while(runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0)runHi++;
    return runHi - lo;
}
function $97579a54749e4b24$var$reverseRun(array, lo, hi) {
    hi--;
    while(lo < hi){
        var t = array[lo];
        array[lo++] = array[hi];
        array[hi--] = t;
    }
}
function $97579a54749e4b24$var$binaryInsertionSort(array, lo, hi, start, compare) {
    if (start === lo) start++;
    for(; start < hi; start++){
        var pivot = array[start];
        var left = lo;
        var right = start;
        var mid;
        while(left < right){
            mid = left + right >>> 1;
            if (compare(pivot, array[mid]) < 0) right = mid;
            else left = mid + 1;
        }
        var n = start - left;
        switch(n){
            case 3:
                array[left + 3] = array[left + 2];
            case 2:
                array[left + 2] = array[left + 1];
            case 1:
                array[left + 1] = array[left];
                break;
            default:
                while(n > 0){
                    array[left + n] = array[left + n - 1];
                    n--;
                }
        }
        array[left] = pivot;
    }
}
function $97579a54749e4b24$var$gallopLeft(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) > 0) {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) > 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    } else {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) <= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) > 0) lastOffset = m + 1;
        else offset = m;
    }
    return offset;
}
function $97579a54749e4b24$var$gallopRight(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) < 0) {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) < 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    } else {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) >= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) < 0) offset = m;
        else lastOffset = m + 1;
    }
    return offset;
}
function $97579a54749e4b24$var$TimSort(array, compare) {
    var minGallop = $97579a54749e4b24$var$DEFAULT_MIN_GALLOPING;
    var runStart;
    var runLength;
    var stackSize = 0;
    var tmp = [];
    runStart = [];
    runLength = [];
    function pushRun(_runStart, _runLength) {
        runStart[stackSize] = _runStart;
        runLength[stackSize] = _runLength;
        stackSize += 1;
    }
    function mergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
                if (runLength[n - 1] < runLength[n + 1]) n--;
            } else if (runLength[n] > runLength[n + 1]) break;
            mergeAt(n);
        }
    }
    function forceMergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n > 0 && runLength[n - 1] < runLength[n + 1]) n--;
            mergeAt(n);
        }
    }
    function mergeAt(i) {
        var start1 = runStart[i];
        var length1 = runLength[i];
        var start2 = runStart[i + 1];
        var length2 = runLength[i + 1];
        runLength[i] = length1 + length2;
        if (i === stackSize - 3) {
            runStart[i + 1] = runStart[i + 2];
            runLength[i + 1] = runLength[i + 2];
        }
        stackSize--;
        var k = $97579a54749e4b24$var$gallopRight(array[start2], array, start1, length1, 0, compare);
        start1 += k;
        length1 -= k;
        if (length1 === 0) return;
        length2 = $97579a54749e4b24$var$gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
        if (length2 === 0) return;
        if (length1 <= length2) mergeLow(start1, length1, start2, length2);
        else mergeHigh(start1, length1, start2, length2);
    }
    function mergeLow(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length1; i++)tmp[i] = array[start1 + i];
        var cursor1 = 0;
        var cursor2 = start2;
        var dest = start1;
        array[dest++] = array[cursor2++];
        if (--length2 === 0) {
            for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
            return;
        }
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
            return;
        }
        var _minGallop = minGallop;
        var count1;
        var count2;
        var exit;
        while(true){
            count1 = 0;
            count2 = 0;
            exit = false;
            do if (compare(array[cursor2], tmp[cursor1]) < 0) {
                array[dest++] = array[cursor2++];
                count2++;
                count1 = 0;
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest++] = tmp[cursor1++];
                count1++;
                count2 = 0;
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = $97579a54749e4b24$var$gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
                if (count1 !== 0) {
                    for(i = 0; i < count1; i++)array[dest + i] = tmp[cursor1 + i];
                    dest += count1;
                    cursor1 += count1;
                    length1 -= count1;
                    if (length1 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = array[cursor2++];
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
                count2 = $97579a54749e4b24$var$gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
                if (count2 !== 0) {
                    for(i = 0; i < count2; i++)array[dest + i] = array[cursor2 + i];
                    dest += count2;
                    cursor2 += count2;
                    length2 -= count2;
                    if (length2 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = tmp[cursor1++];
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $97579a54749e4b24$var$DEFAULT_MIN_GALLOPING || count2 >= $97579a54749e4b24$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        minGallop < 1 && (minGallop = 1);
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
        } else if (length1 === 0) throw new Error();
        else for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
    }
    function mergeHigh(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length2; i++)tmp[i] = array[start2 + i];
        var cursor1 = start1 + length1 - 1;
        var cursor2 = length2 - 1;
        var dest = start2 + length2 - 1;
        var customCursor = 0;
        var customDest = 0;
        array[dest--] = array[cursor1--];
        if (--length1 === 0) {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
            return;
        }
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
            return;
        }
        var _minGallop = minGallop;
        while(true){
            var count1 = 0;
            var count2 = 0;
            var exit = false;
            do if (compare(tmp[cursor2], array[cursor1]) < 0) {
                array[dest--] = array[cursor1--];
                count1++;
                count2 = 0;
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest--] = tmp[cursor2--];
                count2++;
                count1 = 0;
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = length1 - $97579a54749e4b24$var$gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
                if (count1 !== 0) {
                    dest -= count1;
                    cursor1 -= count1;
                    length1 -= count1;
                    customDest = dest + 1;
                    customCursor = cursor1 + 1;
                    for(i = count1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
                    if (length1 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = tmp[cursor2--];
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
                count2 = length2 - $97579a54749e4b24$var$gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
                if (count2 !== 0) {
                    dest -= count2;
                    cursor2 -= count2;
                    length2 -= count2;
                    customDest = dest + 1;
                    customCursor = cursor2 + 1;
                    for(i = 0; i < count2; i++)array[customDest + i] = tmp[customCursor + i];
                    if (length2 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = array[cursor1--];
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $97579a54749e4b24$var$DEFAULT_MIN_GALLOPING || count2 >= $97579a54749e4b24$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        if (minGallop < 1) minGallop = 1;
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
        } else if (length2 === 0) throw new Error();
        else {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
        }
    }
    return {
        mergeRuns: mergeRuns,
        forceMergeRuns: forceMergeRuns,
        pushRun: pushRun
    };
}
function $97579a54749e4b24$export$2e2bcd8739ae039(array, compare, lo, hi) {
    if (!lo) lo = 0;
    if (!hi) hi = array.length;
    var remaining = hi - lo;
    if (remaining < 2) return;
    var runLength = 0;
    if (remaining < $97579a54749e4b24$var$DEFAULT_MIN_MERGE) {
        runLength = $97579a54749e4b24$var$makeAscendingRun(array, lo, hi, compare);
        $97579a54749e4b24$var$binaryInsertionSort(array, lo, hi, lo + runLength, compare);
        return;
    }
    var ts = $97579a54749e4b24$var$TimSort(array, compare);
    var minRun = $97579a54749e4b24$var$minRunLength(remaining);
    do {
        runLength = $97579a54749e4b24$var$makeAscendingRun(array, lo, hi, compare);
        if (runLength < minRun) {
            var force = remaining;
            if (force > minRun) force = minRun;
            $97579a54749e4b24$var$binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
            runLength = force;
        }
        ts.pushRun(lo, runLength);
        ts.mergeRuns();
        remaining -= runLength;
        lo += runLength;
    }while (remaining !== 0);
    ts.forceMergeRuns();
}


var $ddf76b16f1246ba9$export$a7b6db622c6c7dbd = 1;
var $ddf76b16f1246ba9$export$ada8b2beb3d76671 = 2;
var $ddf76b16f1246ba9$export$f75fe89a33ebe115 = 4;


var $319574df0bc66e80$var$invalidZErrorLogged = false;
function $319574df0bc66e80$var$logInvalidZError() {
    if ($319574df0bc66e80$var$invalidZErrorLogged) return;
    $319574df0bc66e80$var$invalidZErrorLogged = true;
    console.warn("z / z2 / zlevel of displayable is invalid, which may cause unexpected errors");
}
function $319574df0bc66e80$var$shapeCompareFunc(a, b) {
    if (a.zlevel === b.zlevel) {
        if (a.z === b.z) return a.z2 - b.z2;
        return a.z - b.z;
    }
    return a.zlevel - b.zlevel;
}
var $319574df0bc66e80$var$Storage = function() {
    function Storage() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        this.displayableSortFunc = $319574df0bc66e80$var$shapeCompareFunc;
    }
    Storage.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._roots.length; i++)this._roots[i].traverse(cb, context);
    };
    Storage.prototype.getDisplayList = function(update, includeIgnore) {
        includeIgnore = includeIgnore || false;
        var displayList = this._displayList;
        if (update || !displayList.length) this.updateDisplayList(includeIgnore);
        return displayList;
    };
    Storage.prototype.updateDisplayList = function(includeIgnore) {
        this._displayListLen = 0;
        var roots = this._roots;
        var displayList = this._displayList;
        for(var i = 0, len = roots.length; i < len; i++)this._updateAndAddDisplayable(roots[i], null, includeIgnore);
        displayList.length = this._displayListLen;
        (0, $97579a54749e4b24$export$2e2bcd8739ae039)(displayList, $319574df0bc66e80$var$shapeCompareFunc);
    };
    Storage.prototype._updateAndAddDisplayable = function(el, parentClipPaths, includeIgnore) {
        if (el.ignore && !includeIgnore) return;
        el.beforeUpdate();
        el.update();
        el.afterUpdate();
        var userSetClipPath = el.getClipPath();
        var parentHasClipPaths = parentClipPaths && parentClipPaths.length;
        var clipPathIdx = 0;
        var thisClipPaths = el.__clipPaths;
        if (!el.ignoreClip && (parentHasClipPaths || userSetClipPath)) {
            if (!thisClipPaths) thisClipPaths = el.__clipPaths = [];
            if (parentHasClipPaths) for(var idx = 0; idx < parentClipPaths.length; idx++)thisClipPaths[clipPathIdx++] = parentClipPaths[idx];
            var currentClipPath = userSetClipPath;
            var parentClipPath = el;
            while(currentClipPath){
                currentClipPath.parent = parentClipPath;
                currentClipPath.updateTransform();
                thisClipPaths[clipPathIdx++] = currentClipPath;
                parentClipPath = currentClipPath;
                currentClipPath = currentClipPath.getClipPath();
            }
        }
        if (thisClipPaths) thisClipPaths.length = clipPathIdx;
        if (el.childrenRef) {
            var children = el.childrenRef();
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (el.__dirty) child.__dirty |= (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
                this._updateAndAddDisplayable(child, thisClipPaths, includeIgnore);
            }
            el.__dirty = 0;
        } else {
            var disp = el;
            if (isNaN(disp.z)) {
                $319574df0bc66e80$var$logInvalidZError();
                disp.z = 0;
            }
            if (isNaN(disp.z2)) {
                $319574df0bc66e80$var$logInvalidZError();
                disp.z2 = 0;
            }
            if (isNaN(disp.zlevel)) {
                $319574df0bc66e80$var$logInvalidZError();
                disp.zlevel = 0;
            }
            this._displayList[this._displayListLen++] = disp;
        }
        var decalEl = el.getDecalElement && el.getDecalElement();
        if (decalEl) this._updateAndAddDisplayable(decalEl, thisClipPaths, includeIgnore);
        var textGuide = el.getTextGuideLine();
        if (textGuide) this._updateAndAddDisplayable(textGuide, thisClipPaths, includeIgnore);
        var textEl = el.getTextContent();
        if (textEl) this._updateAndAddDisplayable(textEl, thisClipPaths, includeIgnore);
    };
    Storage.prototype.addRoot = function(el) {
        if (el.__zr && el.__zr.storage === this) return;
        this._roots.push(el);
    };
    Storage.prototype.delRoot = function(el) {
        if (el instanceof Array) {
            for(var i = 0, l = el.length; i < l; i++)this.delRoot(el[i]);
            return;
        }
        var idx = $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(this._roots, el);
        if (idx >= 0) this._roots.splice(idx, 1);
    };
    Storage.prototype.delAllRoots = function() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        return;
    };
    Storage.prototype.getRoots = function() {
        return this._roots;
    };
    Storage.prototype.dispose = function() {
        this._displayList = null;
        this._roots = null;
    };
    return Storage;
}();
var $319574df0bc66e80$export$2e2bcd8739ae039 = $319574df0bc66e80$var$Storage;





var $731d42ad1858cd4c$var$requestAnimationFrame;
$731d42ad1858cd4c$var$requestAnimationFrame = (0, $ce6dd58693a21851$export$2e2bcd8739ae039).hasGlobalWindow && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function(func) {
    return setTimeout(func, 16);
};
var $731d42ad1858cd4c$export$2e2bcd8739ae039 = $731d42ad1858cd4c$var$requestAnimationFrame;


var $9668111025b0b56f$var$easingFuncs = {
    linear: function(k) {
        return k;
    },
    quadraticIn: function(k) {
        return k * k;
    },
    quadraticOut: function(k) {
        return k * (2 - k);
    },
    quadraticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k;
        return -0.5 * (--k * (k - 2) - 1);
    },
    cubicIn: function(k) {
        return k * k * k;
    },
    cubicOut: function(k) {
        return --k * k * k + 1;
    },
    cubicInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k;
        return 0.5 * ((k -= 2) * k * k + 2);
    },
    quarticIn: function(k) {
        return k * k * k * k;
    },
    quarticOut: function(k) {
        return 1 - --k * k * k * k;
    },
    quarticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k;
        return -0.5 * ((k -= 2) * k * k * k - 2);
    },
    quinticIn: function(k) {
        return k * k * k * k * k;
    },
    quinticOut: function(k) {
        return --k * k * k * k * k + 1;
    },
    quinticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k * k;
        return 0.5 * ((k -= 2) * k * k * k * k + 2);
    },
    sinusoidalIn: function(k) {
        return 1 - Math.cos(k * Math.PI / 2);
    },
    sinusoidalOut: function(k) {
        return Math.sin(k * Math.PI / 2);
    },
    sinusoidalInOut: function(k) {
        return 0.5 * (1 - Math.cos(Math.PI * k));
    },
    exponentialIn: function(k) {
        return k === 0 ? 0 : Math.pow(1024, k - 1);
    },
    exponentialOut: function(k) {
        return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
    },
    exponentialInOut: function(k) {
        if (k === 0) return 0;
        if (k === 1) return 1;
        if ((k *= 2) < 1) return 0.5 * Math.pow(1024, k - 1);
        return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
    },
    circularIn: function(k) {
        return 1 - Math.sqrt(1 - k * k);
    },
    circularOut: function(k) {
        return Math.sqrt(1 - --k * k);
    },
    circularInOut: function(k) {
        if ((k *= 2) < 1) return -0.5 * (Math.sqrt(1 - k * k) - 1);
        return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
    },
    elasticIn: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
    },
    elasticOut: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
    },
    elasticInOut: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        if ((k *= 2) < 1) return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
        return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
    },
    backIn: function(k) {
        var s = 1.70158;
        return k * k * ((s + 1) * k - s);
    },
    backOut: function(k) {
        var s = 1.70158;
        return --k * k * ((s + 1) * k + s) + 1;
    },
    backInOut: function(k) {
        var s = 2.5949095;
        if ((k *= 2) < 1) return 0.5 * (k * k * ((s + 1) * k - s));
        return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
    },
    bounceIn: function(k) {
        return 1 - $9668111025b0b56f$var$easingFuncs.bounceOut(1 - k);
    },
    bounceOut: function(k) {
        if (k < 1 / 2.75) return 7.5625 * k * k;
        else if (k < 2 / 2.75) return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
        else if (k < 2.5 / 2.75) return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
        else return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
    },
    bounceInOut: function(k) {
        if (k < 0.5) return $9668111025b0b56f$var$easingFuncs.bounceIn(k * 2) * 0.5;
        return $9668111025b0b56f$var$easingFuncs.bounceOut(k * 2 - 1) * 0.5 + 0.5;
    }
};
var $9668111025b0b56f$export$2e2bcd8739ae039 = $9668111025b0b56f$var$easingFuncs;




var $747cfc5611b57cea$var$mathPow = Math.pow;
var $747cfc5611b57cea$var$mathSqrt = Math.sqrt;
var $747cfc5611b57cea$var$EPSILON = 1e-8;
var $747cfc5611b57cea$var$EPSILON_NUMERIC = 1e-4;
var $747cfc5611b57cea$var$THREE_SQRT = $747cfc5611b57cea$var$mathSqrt(3);
var $747cfc5611b57cea$var$ONE_THIRD = 1 / 3;
var $747cfc5611b57cea$var$_v0 = (0, $6de594cf8ac295ff$export$185802fd694ee1f5)();
var $747cfc5611b57cea$var$_v1 = (0, $6de594cf8ac295ff$export$185802fd694ee1f5)();
var $747cfc5611b57cea$var$_v2 = (0, $6de594cf8ac295ff$export$185802fd694ee1f5)();
function $747cfc5611b57cea$var$isAroundZero(val) {
    return val > -$747cfc5611b57cea$var$EPSILON && val < $747cfc5611b57cea$var$EPSILON;
}
function $747cfc5611b57cea$var$isNotAroundZero(val) {
    return val > $747cfc5611b57cea$var$EPSILON || val < -$747cfc5611b57cea$var$EPSILON;
}
function $747cfc5611b57cea$export$547c21de482bbcb2(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
}
function $747cfc5611b57cea$export$55fce925c60b6271(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
}
function $747cfc5611b57cea$export$ca5d13faa10b167e(p0, p1, p2, p3, val, roots) {
    var a = p3 + 3 * (p1 - p2) - p0;
    var b = 3 * (p2 - p1 * 2 + p0);
    var c = 3 * (p1 - p0);
    var d = p0 - val;
    var A = b * b - 3 * a * c;
    var B = b * c - 9 * a * d;
    var C = c * c - 3 * b * d;
    var n = 0;
    if ($747cfc5611b57cea$var$isAroundZero(A) && $747cfc5611b57cea$var$isAroundZero(B)) {
        if ($747cfc5611b57cea$var$isAroundZero(b)) roots[0] = 0;
        else {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = B * B - 4 * A * C;
        if ($747cfc5611b57cea$var$isAroundZero(disc)) {
            var K = B / A;
            var t1 = -b / a + K;
            var t2 = -K / 2;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        } else if (disc > 0) {
            var discSqrt = $747cfc5611b57cea$var$mathSqrt(disc);
            var Y1 = A * b + 1.5 * a * (-B + discSqrt);
            var Y2 = A * b + 1.5 * a * (-B - discSqrt);
            if (Y1 < 0) Y1 = -$747cfc5611b57cea$var$mathPow(-Y1, $747cfc5611b57cea$var$ONE_THIRD);
            else Y1 = $747cfc5611b57cea$var$mathPow(Y1, $747cfc5611b57cea$var$ONE_THIRD);
            if (Y2 < 0) Y2 = -$747cfc5611b57cea$var$mathPow(-Y2, $747cfc5611b57cea$var$ONE_THIRD);
            else Y2 = $747cfc5611b57cea$var$mathPow(Y2, $747cfc5611b57cea$var$ONE_THIRD);
            var t1 = (-b - (Y1 + Y2)) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else {
            var T = (2 * A * b - 3 * a * B) / (2 * $747cfc5611b57cea$var$mathSqrt(A * A * A));
            var theta = Math.acos(T) / 3;
            var ASqrt = $747cfc5611b57cea$var$mathSqrt(A);
            var tmp = Math.cos(theta);
            var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
            var t2 = (-b + ASqrt * (tmp + $747cfc5611b57cea$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            var t3 = (-b + ASqrt * (tmp - $747cfc5611b57cea$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
            if (t3 >= 0 && t3 <= 1) roots[n++] = t3;
        }
    }
    return n;
}
function $747cfc5611b57cea$export$df1a172f100d0457(p0, p1, p2, p3, extrema) {
    var b = 6 * p2 - 12 * p1 + 6 * p0;
    var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
    var c = 3 * p1 - 3 * p0;
    var n = 0;
    if ($747cfc5611b57cea$var$isAroundZero(a)) {
        if ($747cfc5611b57cea$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($747cfc5611b57cea$var$isAroundZero(disc)) extrema[0] = -b / (2 * a);
        else if (disc > 0) {
            var discSqrt = $747cfc5611b57cea$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
            if (t2 >= 0 && t2 <= 1) extrema[n++] = t2;
        }
    }
    return n;
}
function $747cfc5611b57cea$export$a2ee23a0567039da(p0, p1, p2, p3, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p23 = (p3 - p2) * t + p2;
    var p012 = (p12 - p01) * t + p01;
    var p123 = (p23 - p12) * t + p12;
    var p0123 = (p123 - p012) * t + p012;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p0123;
    out[4] = p0123;
    out[5] = p123;
    out[6] = p23;
    out[7] = p3;
}
function $747cfc5611b57cea$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    var prev;
    var next;
    var d1;
    var d2;
    $747cfc5611b57cea$var$_v0[0] = x;
    $747cfc5611b57cea$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $747cfc5611b57cea$var$_v1[0] = $747cfc5611b57cea$export$547c21de482bbcb2(x0, x1, x2, x3, _t);
        $747cfc5611b57cea$var$_v1[1] = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, _t);
        d1 = (0, $6de594cf8ac295ff$export$c68db45a034c13b0)($747cfc5611b57cea$var$_v0, $747cfc5611b57cea$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $747cfc5611b57cea$var$EPSILON_NUMERIC) break;
        prev = t - interval;
        next = t + interval;
        $747cfc5611b57cea$var$_v1[0] = $747cfc5611b57cea$export$547c21de482bbcb2(x0, x1, x2, x3, prev);
        $747cfc5611b57cea$var$_v1[1] = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, prev);
        d1 = (0, $6de594cf8ac295ff$export$c68db45a034c13b0)($747cfc5611b57cea$var$_v1, $747cfc5611b57cea$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $747cfc5611b57cea$var$_v2[0] = $747cfc5611b57cea$export$547c21de482bbcb2(x0, x1, x2, x3, next);
            $747cfc5611b57cea$var$_v2[1] = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, next);
            d2 = (0, $6de594cf8ac295ff$export$c68db45a034c13b0)($747cfc5611b57cea$var$_v2, $747cfc5611b57cea$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $747cfc5611b57cea$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        out[1] = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, t);
    }
    return $747cfc5611b57cea$var$mathSqrt(d);
}
function $747cfc5611b57cea$export$af1875d576f60d7c(x0, y0, x1, y1, x2, y2, x3, y3, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $747cfc5611b57cea$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        var y = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}
function $747cfc5611b57cea$export$af17094a950f5073(p0, p1, p2, t) {
    var onet = 1 - t;
    return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
}
function $747cfc5611b57cea$export$7e161e77e6fff8cb(p0, p1, p2, t) {
    return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
}
function $747cfc5611b57cea$export$fd895ac7ee764967(p0, p1, p2, val, roots) {
    var a = p0 - 2 * p1 + p2;
    var b = 2 * (p1 - p0);
    var c = p0 - val;
    var n = 0;
    if ($747cfc5611b57cea$var$isAroundZero(a)) {
        if ($747cfc5611b57cea$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($747cfc5611b57cea$var$isAroundZero(disc)) {
            var t1 = -b / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else if (disc > 0) {
            var discSqrt = $747cfc5611b57cea$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        }
    }
    return n;
}
function $747cfc5611b57cea$export$752e1f8c6e7f7e11(p0, p1, p2) {
    var divider = p0 + p2 - 2 * p1;
    if (divider === 0) return 0.5;
    else return (p0 - p1) / divider;
}
function $747cfc5611b57cea$export$117c659e21a7a060(p0, p1, p2, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p012 = (p12 - p01) * t + p01;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p012;
    out[4] = p12;
    out[5] = p2;
}
function $747cfc5611b57cea$export$81915a594fe10dee(x0, y0, x1, y1, x2, y2, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    $747cfc5611b57cea$var$_v0[0] = x;
    $747cfc5611b57cea$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $747cfc5611b57cea$var$_v1[0] = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, _t);
        $747cfc5611b57cea$var$_v1[1] = $747cfc5611b57cea$export$af17094a950f5073(y0, y1, y2, _t);
        var d1 = (0, $6de594cf8ac295ff$export$c68db45a034c13b0)($747cfc5611b57cea$var$_v0, $747cfc5611b57cea$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $747cfc5611b57cea$var$EPSILON_NUMERIC) break;
        var prev = t - interval;
        var next = t + interval;
        $747cfc5611b57cea$var$_v1[0] = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, prev);
        $747cfc5611b57cea$var$_v1[1] = $747cfc5611b57cea$export$af17094a950f5073(y0, y1, y2, prev);
        var d1 = (0, $6de594cf8ac295ff$export$c68db45a034c13b0)($747cfc5611b57cea$var$_v1, $747cfc5611b57cea$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $747cfc5611b57cea$var$_v2[0] = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, next);
            $747cfc5611b57cea$var$_v2[1] = $747cfc5611b57cea$export$af17094a950f5073(y0, y1, y2, next);
            var d2 = (0, $6de594cf8ac295ff$export$c68db45a034c13b0)($747cfc5611b57cea$var$_v2, $747cfc5611b57cea$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, t);
        out[1] = $747cfc5611b57cea$export$af17094a950f5073(y0, y1, y2, t);
    }
    return $747cfc5611b57cea$var$mathSqrt(d);
}
function $747cfc5611b57cea$export$8a68adee46f3cf55(x0, y0, x1, y1, x2, y2, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, t);
        var y = $747cfc5611b57cea$export$af17094a950f5073(y0, y1, y2, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}



var $0aea98bda0b4be1f$var$regexp = /cubic-bezier\(([0-9,\.e ]+)\)/;
function $0aea98bda0b4be1f$export$ec0863d806fd857e(cubicEasingStr) {
    var cubic = cubicEasingStr && $0aea98bda0b4be1f$var$regexp.exec(cubicEasingStr);
    if (cubic) {
        var points = cubic[1].split(",");
        var a_1 = +(0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(points[0]);
        var b_1 = +(0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(points[1]);
        var c_1 = +(0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(points[2]);
        var d_1 = +(0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(points[3]);
        if (isNaN(a_1 + b_1 + c_1 + d_1)) return;
        var roots_1 = [];
        return function(p) {
            return p <= 0 ? 0 : p >= 1 ? 1 : (0, $747cfc5611b57cea$export$ca5d13faa10b167e)(0, a_1, c_1, 1, p, roots_1) && (0, $747cfc5611b57cea$export$547c21de482bbcb2)(0, b_1, d_1, 1, roots_1[0]);
        };
    }
}


var $00f1e1cb3568b9c5$var$Clip = function() {
    function Clip(opts) {
        this._inited = false;
        this._startTime = 0;
        this._pausedTime = 0;
        this._paused = false;
        this._life = opts.life || 1000;
        this._delay = opts.delay || 0;
        this.loop = opts.loop || false;
        this.onframe = opts.onframe || (0, $7a1bd9c2710fea0d$export$8793edee2d425525);
        this.ondestroy = opts.ondestroy || (0, $7a1bd9c2710fea0d$export$8793edee2d425525);
        this.onrestart = opts.onrestart || (0, $7a1bd9c2710fea0d$export$8793edee2d425525);
        opts.easing && this.setEasing(opts.easing);
    }
    Clip.prototype.step = function(globalTime, deltaTime) {
        if (!this._inited) {
            this._startTime = globalTime + this._delay;
            this._inited = true;
        }
        if (this._paused) {
            this._pausedTime += deltaTime;
            return;
        }
        var life = this._life;
        var elapsedTime = globalTime - this._startTime - this._pausedTime;
        var percent = elapsedTime / life;
        if (percent < 0) percent = 0;
        percent = Math.min(percent, 1);
        var easingFunc = this.easingFunc;
        var schedule = easingFunc ? easingFunc(percent) : percent;
        this.onframe(schedule);
        if (percent === 1) {
            if (this.loop) {
                var remainder = elapsedTime % life;
                this._startTime = globalTime - remainder;
                this._pausedTime = 0;
                this.onrestart();
            } else return true;
        }
        return false;
    };
    Clip.prototype.pause = function() {
        this._paused = true;
    };
    Clip.prototype.resume = function() {
        this._paused = false;
    };
    Clip.prototype.setEasing = function(easing) {
        this.easing = easing;
        this.easingFunc = (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(easing) ? easing : (0, $9668111025b0b56f$export$2e2bcd8739ae039)[easing] || (0, $0aea98bda0b4be1f$export$ec0863d806fd857e)(easing);
    };
    return Clip;
}();
var $00f1e1cb3568b9c5$export$2e2bcd8739ae039 = $00f1e1cb3568b9c5$var$Clip;


var $d91b0b6fc564d9c7$export$3bb977b3ba9d3b59 = function() {
    function Entry(val) {
        this.value = val;
    }
    return Entry;
}();
var $d91b0b6fc564d9c7$export$f0ef28713f767754 = function() {
    function LinkedList() {
        this._len = 0;
    }
    LinkedList.prototype.insert = function(val) {
        var entry = new $d91b0b6fc564d9c7$export$3bb977b3ba9d3b59(val);
        this.insertEntry(entry);
        return entry;
    };
    LinkedList.prototype.insertEntry = function(entry) {
        if (!this.head) this.head = this.tail = entry;
        else {
            this.tail.next = entry;
            entry.prev = this.tail;
            entry.next = null;
            this.tail = entry;
        }
        this._len++;
    };
    LinkedList.prototype.remove = function(entry) {
        var prev = entry.prev;
        var next = entry.next;
        if (prev) prev.next = next;
        else this.head = next;
        if (next) next.prev = prev;
        else this.tail = prev;
        entry.next = entry.prev = null;
        this._len--;
    };
    LinkedList.prototype.len = function() {
        return this._len;
    };
    LinkedList.prototype.clear = function() {
        this.head = this.tail = null;
        this._len = 0;
    };
    return LinkedList;
}();
var $d91b0b6fc564d9c7$var$LRU = function() {
    function LRU(maxSize) {
        this._list = new $d91b0b6fc564d9c7$export$f0ef28713f767754();
        this._maxSize = 10;
        this._map = {};
        this._maxSize = maxSize;
    }
    LRU.prototype.put = function(key, value) {
        var list = this._list;
        var map = this._map;
        var removed = null;
        if (map[key] == null) {
            var len = list.len();
            var entry = this._lastRemovedEntry;
            if (len >= this._maxSize && len > 0) {
                var leastUsedEntry = list.head;
                list.remove(leastUsedEntry);
                delete map[leastUsedEntry.key];
                removed = leastUsedEntry.value;
                this._lastRemovedEntry = leastUsedEntry;
            }
            if (entry) entry.value = value;
            else entry = new $d91b0b6fc564d9c7$export$3bb977b3ba9d3b59(value);
            entry.key = key;
            list.insertEntry(entry);
            map[key] = entry;
        }
        return removed;
    };
    LRU.prototype.get = function(key) {
        var entry = this._map[key];
        var list = this._list;
        if (entry != null) {
            if (entry !== list.tail) {
                list.remove(entry);
                list.insertEntry(entry);
            }
            return entry.value;
        }
    };
    LRU.prototype.clear = function() {
        this._list.clear();
        this._map = {};
    };
    LRU.prototype.len = function() {
        return this._list.len();
    };
    return LRU;
}();
var $d91b0b6fc564d9c7$export$2e2bcd8739ae039 = $d91b0b6fc564d9c7$var$LRU;



var $2c037f5bda6341ca$var$kCSSColorTable = {
    "transparent": [
        0,
        0,
        0,
        0
    ],
    "aliceblue": [
        240,
        248,
        255,
        1
    ],
    "antiquewhite": [
        250,
        235,
        215,
        1
    ],
    "aqua": [
        0,
        255,
        255,
        1
    ],
    "aquamarine": [
        127,
        255,
        212,
        1
    ],
    "azure": [
        240,
        255,
        255,
        1
    ],
    "beige": [
        245,
        245,
        220,
        1
    ],
    "bisque": [
        255,
        228,
        196,
        1
    ],
    "black": [
        0,
        0,
        0,
        1
    ],
    "blanchedalmond": [
        255,
        235,
        205,
        1
    ],
    "blue": [
        0,
        0,
        255,
        1
    ],
    "blueviolet": [
        138,
        43,
        226,
        1
    ],
    "brown": [
        165,
        42,
        42,
        1
    ],
    "burlywood": [
        222,
        184,
        135,
        1
    ],
    "cadetblue": [
        95,
        158,
        160,
        1
    ],
    "chartreuse": [
        127,
        255,
        0,
        1
    ],
    "chocolate": [
        210,
        105,
        30,
        1
    ],
    "coral": [
        255,
        127,
        80,
        1
    ],
    "cornflowerblue": [
        100,
        149,
        237,
        1
    ],
    "cornsilk": [
        255,
        248,
        220,
        1
    ],
    "crimson": [
        220,
        20,
        60,
        1
    ],
    "cyan": [
        0,
        255,
        255,
        1
    ],
    "darkblue": [
        0,
        0,
        139,
        1
    ],
    "darkcyan": [
        0,
        139,
        139,
        1
    ],
    "darkgoldenrod": [
        184,
        134,
        11,
        1
    ],
    "darkgray": [
        169,
        169,
        169,
        1
    ],
    "darkgreen": [
        0,
        100,
        0,
        1
    ],
    "darkgrey": [
        169,
        169,
        169,
        1
    ],
    "darkkhaki": [
        189,
        183,
        107,
        1
    ],
    "darkmagenta": [
        139,
        0,
        139,
        1
    ],
    "darkolivegreen": [
        85,
        107,
        47,
        1
    ],
    "darkorange": [
        255,
        140,
        0,
        1
    ],
    "darkorchid": [
        153,
        50,
        204,
        1
    ],
    "darkred": [
        139,
        0,
        0,
        1
    ],
    "darksalmon": [
        233,
        150,
        122,
        1
    ],
    "darkseagreen": [
        143,
        188,
        143,
        1
    ],
    "darkslateblue": [
        72,
        61,
        139,
        1
    ],
    "darkslategray": [
        47,
        79,
        79,
        1
    ],
    "darkslategrey": [
        47,
        79,
        79,
        1
    ],
    "darkturquoise": [
        0,
        206,
        209,
        1
    ],
    "darkviolet": [
        148,
        0,
        211,
        1
    ],
    "deeppink": [
        255,
        20,
        147,
        1
    ],
    "deepskyblue": [
        0,
        191,
        255,
        1
    ],
    "dimgray": [
        105,
        105,
        105,
        1
    ],
    "dimgrey": [
        105,
        105,
        105,
        1
    ],
    "dodgerblue": [
        30,
        144,
        255,
        1
    ],
    "firebrick": [
        178,
        34,
        34,
        1
    ],
    "floralwhite": [
        255,
        250,
        240,
        1
    ],
    "forestgreen": [
        34,
        139,
        34,
        1
    ],
    "fuchsia": [
        255,
        0,
        255,
        1
    ],
    "gainsboro": [
        220,
        220,
        220,
        1
    ],
    "ghostwhite": [
        248,
        248,
        255,
        1
    ],
    "gold": [
        255,
        215,
        0,
        1
    ],
    "goldenrod": [
        218,
        165,
        32,
        1
    ],
    "gray": [
        128,
        128,
        128,
        1
    ],
    "green": [
        0,
        128,
        0,
        1
    ],
    "greenyellow": [
        173,
        255,
        47,
        1
    ],
    "grey": [
        128,
        128,
        128,
        1
    ],
    "honeydew": [
        240,
        255,
        240,
        1
    ],
    "hotpink": [
        255,
        105,
        180,
        1
    ],
    "indianred": [
        205,
        92,
        92,
        1
    ],
    "indigo": [
        75,
        0,
        130,
        1
    ],
    "ivory": [
        255,
        255,
        240,
        1
    ],
    "khaki": [
        240,
        230,
        140,
        1
    ],
    "lavender": [
        230,
        230,
        250,
        1
    ],
    "lavenderblush": [
        255,
        240,
        245,
        1
    ],
    "lawngreen": [
        124,
        252,
        0,
        1
    ],
    "lemonchiffon": [
        255,
        250,
        205,
        1
    ],
    "lightblue": [
        173,
        216,
        230,
        1
    ],
    "lightcoral": [
        240,
        128,
        128,
        1
    ],
    "lightcyan": [
        224,
        255,
        255,
        1
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210,
        1
    ],
    "lightgray": [
        211,
        211,
        211,
        1
    ],
    "lightgreen": [
        144,
        238,
        144,
        1
    ],
    "lightgrey": [
        211,
        211,
        211,
        1
    ],
    "lightpink": [
        255,
        182,
        193,
        1
    ],
    "lightsalmon": [
        255,
        160,
        122,
        1
    ],
    "lightseagreen": [
        32,
        178,
        170,
        1
    ],
    "lightskyblue": [
        135,
        206,
        250,
        1
    ],
    "lightslategray": [
        119,
        136,
        153,
        1
    ],
    "lightslategrey": [
        119,
        136,
        153,
        1
    ],
    "lightsteelblue": [
        176,
        196,
        222,
        1
    ],
    "lightyellow": [
        255,
        255,
        224,
        1
    ],
    "lime": [
        0,
        255,
        0,
        1
    ],
    "limegreen": [
        50,
        205,
        50,
        1
    ],
    "linen": [
        250,
        240,
        230,
        1
    ],
    "magenta": [
        255,
        0,
        255,
        1
    ],
    "maroon": [
        128,
        0,
        0,
        1
    ],
    "mediumaquamarine": [
        102,
        205,
        170,
        1
    ],
    "mediumblue": [
        0,
        0,
        205,
        1
    ],
    "mediumorchid": [
        186,
        85,
        211,
        1
    ],
    "mediumpurple": [
        147,
        112,
        219,
        1
    ],
    "mediumseagreen": [
        60,
        179,
        113,
        1
    ],
    "mediumslateblue": [
        123,
        104,
        238,
        1
    ],
    "mediumspringgreen": [
        0,
        250,
        154,
        1
    ],
    "mediumturquoise": [
        72,
        209,
        204,
        1
    ],
    "mediumvioletred": [
        199,
        21,
        133,
        1
    ],
    "midnightblue": [
        25,
        25,
        112,
        1
    ],
    "mintcream": [
        245,
        255,
        250,
        1
    ],
    "mistyrose": [
        255,
        228,
        225,
        1
    ],
    "moccasin": [
        255,
        228,
        181,
        1
    ],
    "navajowhite": [
        255,
        222,
        173,
        1
    ],
    "navy": [
        0,
        0,
        128,
        1
    ],
    "oldlace": [
        253,
        245,
        230,
        1
    ],
    "olive": [
        128,
        128,
        0,
        1
    ],
    "olivedrab": [
        107,
        142,
        35,
        1
    ],
    "orange": [
        255,
        165,
        0,
        1
    ],
    "orangered": [
        255,
        69,
        0,
        1
    ],
    "orchid": [
        218,
        112,
        214,
        1
    ],
    "palegoldenrod": [
        238,
        232,
        170,
        1
    ],
    "palegreen": [
        152,
        251,
        152,
        1
    ],
    "paleturquoise": [
        175,
        238,
        238,
        1
    ],
    "palevioletred": [
        219,
        112,
        147,
        1
    ],
    "papayawhip": [
        255,
        239,
        213,
        1
    ],
    "peachpuff": [
        255,
        218,
        185,
        1
    ],
    "peru": [
        205,
        133,
        63,
        1
    ],
    "pink": [
        255,
        192,
        203,
        1
    ],
    "plum": [
        221,
        160,
        221,
        1
    ],
    "powderblue": [
        176,
        224,
        230,
        1
    ],
    "purple": [
        128,
        0,
        128,
        1
    ],
    "red": [
        255,
        0,
        0,
        1
    ],
    "rosybrown": [
        188,
        143,
        143,
        1
    ],
    "royalblue": [
        65,
        105,
        225,
        1
    ],
    "saddlebrown": [
        139,
        69,
        19,
        1
    ],
    "salmon": [
        250,
        128,
        114,
        1
    ],
    "sandybrown": [
        244,
        164,
        96,
        1
    ],
    "seagreen": [
        46,
        139,
        87,
        1
    ],
    "seashell": [
        255,
        245,
        238,
        1
    ],
    "sienna": [
        160,
        82,
        45,
        1
    ],
    "silver": [
        192,
        192,
        192,
        1
    ],
    "skyblue": [
        135,
        206,
        235,
        1
    ],
    "slateblue": [
        106,
        90,
        205,
        1
    ],
    "slategray": [
        112,
        128,
        144,
        1
    ],
    "slategrey": [
        112,
        128,
        144,
        1
    ],
    "snow": [
        255,
        250,
        250,
        1
    ],
    "springgreen": [
        0,
        255,
        127,
        1
    ],
    "steelblue": [
        70,
        130,
        180,
        1
    ],
    "tan": [
        210,
        180,
        140,
        1
    ],
    "teal": [
        0,
        128,
        128,
        1
    ],
    "thistle": [
        216,
        191,
        216,
        1
    ],
    "tomato": [
        255,
        99,
        71,
        1
    ],
    "turquoise": [
        64,
        224,
        208,
        1
    ],
    "violet": [
        238,
        130,
        238,
        1
    ],
    "wheat": [
        245,
        222,
        179,
        1
    ],
    "white": [
        255,
        255,
        255,
        1
    ],
    "whitesmoke": [
        245,
        245,
        245,
        1
    ],
    "yellow": [
        255,
        255,
        0,
        1
    ],
    "yellowgreen": [
        154,
        205,
        50,
        1
    ]
};
function $2c037f5bda6341ca$var$clampCssByte(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 255 ? 255 : i;
}
function $2c037f5bda6341ca$var$clampCssAngle(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 360 ? 360 : i;
}
function $2c037f5bda6341ca$var$clampCssFloat(f) {
    return f < 0 ? 0 : f > 1 ? 1 : f;
}
function $2c037f5bda6341ca$export$e6be818e738239a(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === "%") return $2c037f5bda6341ca$var$clampCssByte(parseFloat(str) / 100 * 255);
    return $2c037f5bda6341ca$var$clampCssByte(parseInt(str, 10));
}
function $2c037f5bda6341ca$export$7638a67891c3b497(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === "%") return $2c037f5bda6341ca$var$clampCssFloat(parseFloat(str) / 100);
    return $2c037f5bda6341ca$var$clampCssFloat(parseFloat(str));
}
function $2c037f5bda6341ca$var$cssHueToRgb(m1, m2, h) {
    if (h < 0) h += 1;
    else if (h > 1) h -= 1;
    if (h * 6 < 1) return m1 + (m2 - m1) * h * 6;
    if (h * 2 < 1) return m2;
    if (h * 3 < 2) return m1 + (m2 - m1) * (2 / 3 - h) * 6;
    return m1;
}
function $2c037f5bda6341ca$var$lerpNumber(a, b, p) {
    return a + (b - a) * p;
}
function $2c037f5bda6341ca$var$setRgba(out, r, g, b, a) {
    out[0] = r;
    out[1] = g;
    out[2] = b;
    out[3] = a;
    return out;
}
function $2c037f5bda6341ca$var$copyRgba(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
var $2c037f5bda6341ca$var$colorCache = new (0, $d91b0b6fc564d9c7$export$2e2bcd8739ae039)(20);
var $2c037f5bda6341ca$var$lastRemovedArr = null;
function $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr) {
    if ($2c037f5bda6341ca$var$lastRemovedArr) $2c037f5bda6341ca$var$copyRgba($2c037f5bda6341ca$var$lastRemovedArr, rgbaArr);
    $2c037f5bda6341ca$var$lastRemovedArr = $2c037f5bda6341ca$var$colorCache.put(colorStr, $2c037f5bda6341ca$var$lastRemovedArr || rgbaArr.slice());
}
function $2c037f5bda6341ca$export$98e6a39c04603d36(colorStr, rgbaArr) {
    if (!colorStr) return;
    rgbaArr = rgbaArr || [];
    var cached = $2c037f5bda6341ca$var$colorCache.get(colorStr);
    if (cached) return $2c037f5bda6341ca$var$copyRgba(rgbaArr, cached);
    colorStr = colorStr + "";
    var str = colorStr.replace(/ /g, "").toLowerCase();
    if (str in $2c037f5bda6341ca$var$kCSSColorTable) {
        $2c037f5bda6341ca$var$copyRgba(rgbaArr, $2c037f5bda6341ca$var$kCSSColorTable[str]);
        $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr);
        return rgbaArr;
    }
    var strLen = str.length;
    if (str.charAt(0) === "#") {
        if (strLen === 4 || strLen === 5) {
            var iv = parseInt(str.slice(1, 4), 16);
            if (!(iv >= 0 && iv <= 0xfff)) {
                $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $2c037f5bda6341ca$var$setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, strLen === 5 ? parseInt(str.slice(4), 16) / 0xf : 1);
            $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        } else if (strLen === 7 || strLen === 9) {
            var iv = parseInt(str.slice(1, 7), 16);
            if (!(iv >= 0 && iv <= 0xffffff)) {
                $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $2c037f5bda6341ca$var$setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, strLen === 9 ? parseInt(str.slice(7), 16) / 0xff : 1);
            $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        }
        return;
    }
    var op = str.indexOf("(");
    var ep = str.indexOf(")");
    if (op !== -1 && ep + 1 === strLen) {
        var fname = str.substr(0, op);
        var params = str.substr(op + 1, ep - (op + 1)).split(",");
        var alpha = 1;
        switch(fname){
            case "rgba":
                if (params.length !== 4) return params.length === 3 ? $2c037f5bda6341ca$var$setRgba(rgbaArr, +params[0], +params[1], +params[2], 1) : $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
                alpha = $2c037f5bda6341ca$export$7638a67891c3b497(params.pop());
            case "rgb":
                if (params.length >= 3) {
                    $2c037f5bda6341ca$var$setRgba(rgbaArr, $2c037f5bda6341ca$export$e6be818e738239a(params[0]), $2c037f5bda6341ca$export$e6be818e738239a(params[1]), $2c037f5bda6341ca$export$e6be818e738239a(params[2]), params.length === 3 ? alpha : $2c037f5bda6341ca$export$7638a67891c3b497(params[3]));
                    $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr);
                    return rgbaArr;
                } else {
                    $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
            case "hsla":
                if (params.length !== 4) {
                    $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                params[3] = $2c037f5bda6341ca$export$7638a67891c3b497(params[3]);
                $2c037f5bda6341ca$var$hsla2rgba(params, rgbaArr);
                $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            case "hsl":
                if (params.length !== 3) {
                    $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $2c037f5bda6341ca$var$hsla2rgba(params, rgbaArr);
                $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            default:
                return;
        }
    }
    $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
    return;
}
function $2c037f5bda6341ca$var$hsla2rgba(hsla, rgba) {
    var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360;
    var s = $2c037f5bda6341ca$export$7638a67891c3b497(hsla[1]);
    var l = $2c037f5bda6341ca$export$7638a67891c3b497(hsla[2]);
    var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
    var m1 = l * 2 - m2;
    rgba = rgba || [];
    $2c037f5bda6341ca$var$setRgba(rgba, $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$cssHueToRgb(m1, m2, h + 1 / 3) * 255), $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$cssHueToRgb(m1, m2, h) * 255), $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
    if (hsla.length === 4) rgba[3] = hsla[3];
    return rgba;
}
function $2c037f5bda6341ca$var$rgba2hsla(rgba) {
    if (!rgba) return;
    var R = rgba[0] / 255;
    var G = rgba[1] / 255;
    var B = rgba[2] / 255;
    var vMin = Math.min(R, G, B);
    var vMax = Math.max(R, G, B);
    var delta = vMax - vMin;
    var L = (vMax + vMin) / 2;
    var H;
    var S;
    if (delta === 0) {
        H = 0;
        S = 0;
    } else {
        if (L < 0.5) S = delta / (vMax + vMin);
        else S = delta / (2 - vMax - vMin);
        var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
        var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
        var deltaB = ((vMax - B) / 6 + delta / 2) / delta;
        if (R === vMax) H = deltaB - deltaG;
        else if (G === vMax) H = 1 / 3 + deltaR - deltaB;
        else if (B === vMax) H = 2 / 3 + deltaG - deltaR;
        if (H < 0) H += 1;
        if (H > 1) H -= 1;
    }
    var hsla = [
        H * 360,
        S,
        L
    ];
    if (rgba[3] != null) hsla.push(rgba[3]);
    return hsla;
}
function $2c037f5bda6341ca$export$590e8b2c435046d9(color, level) {
    var colorArr = $2c037f5bda6341ca$export$98e6a39c04603d36(color);
    if (colorArr) {
        for(var i = 0; i < 3; i++){
            if (level < 0) colorArr[i] = colorArr[i] * (1 - level) | 0;
            else colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
            if (colorArr[i] > 255) colorArr[i] = 255;
            else if (colorArr[i] < 0) colorArr[i] = 0;
        }
        return $2c037f5bda6341ca$export$fac44ee5b035f737(colorArr, colorArr.length === 4 ? "rgba" : "rgb");
    }
}
function $2c037f5bda6341ca$export$7ea66e3774a60b67(color) {
    var colorArr = $2c037f5bda6341ca$export$98e6a39c04603d36(color);
    if (colorArr) return (16777216 + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
}
function $2c037f5bda6341ca$export$66cb3c0e9efc61c8(normalizedValue, colors, out) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    out = out || [];
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = colors[leftIndex];
    var rightColor = colors[rightIndex];
    var dv = value - leftIndex;
    out[0] = $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$lerpNumber(leftColor[0], rightColor[0], dv));
    out[1] = $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$lerpNumber(leftColor[1], rightColor[1], dv));
    out[2] = $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$lerpNumber(leftColor[2], rightColor[2], dv));
    out[3] = $2c037f5bda6341ca$var$clampCssFloat($2c037f5bda6341ca$var$lerpNumber(leftColor[3], rightColor[3], dv));
    return out;
}
var $2c037f5bda6341ca$export$daa5a65daad5df58 = $2c037f5bda6341ca$export$66cb3c0e9efc61c8;
function $2c037f5bda6341ca$export$3a89f8d6f6bf6c9f(normalizedValue, colors, fullOutput) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = $2c037f5bda6341ca$export$98e6a39c04603d36(colors[leftIndex]);
    var rightColor = $2c037f5bda6341ca$export$98e6a39c04603d36(colors[rightIndex]);
    var dv = value - leftIndex;
    var color = $2c037f5bda6341ca$export$fac44ee5b035f737([
        $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$lerpNumber(leftColor[0], rightColor[0], dv)),
        $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$lerpNumber(leftColor[1], rightColor[1], dv)),
        $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$lerpNumber(leftColor[2], rightColor[2], dv)),
        $2c037f5bda6341ca$var$clampCssFloat($2c037f5bda6341ca$var$lerpNumber(leftColor[3], rightColor[3], dv))
    ], "rgba");
    return fullOutput ? {
        color: color,
        leftIndex: leftIndex,
        rightIndex: rightIndex,
        value: value
    } : color;
}
var $2c037f5bda6341ca$export$296e08242b78a3ec = $2c037f5bda6341ca$export$3a89f8d6f6bf6c9f;
function $2c037f5bda6341ca$export$d898ae866e27bf18(color, h, s, l) {
    var colorArr = $2c037f5bda6341ca$export$98e6a39c04603d36(color);
    if (color) {
        colorArr = $2c037f5bda6341ca$var$rgba2hsla(colorArr);
        h != null && (colorArr[0] = $2c037f5bda6341ca$var$clampCssAngle((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(h) ? h(colorArr[0]) : h));
        s != null && (colorArr[1] = $2c037f5bda6341ca$export$7638a67891c3b497((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(s) ? s(colorArr[1]) : s));
        l != null && (colorArr[2] = $2c037f5bda6341ca$export$7638a67891c3b497((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(l) ? l(colorArr[2]) : l));
        return $2c037f5bda6341ca$export$fac44ee5b035f737($2c037f5bda6341ca$var$hsla2rgba(colorArr), "rgba");
    }
}
function $2c037f5bda6341ca$export$ab4754bf42583a26(color, alpha) {
    var colorArr = $2c037f5bda6341ca$export$98e6a39c04603d36(color);
    if (colorArr && alpha != null) {
        colorArr[3] = $2c037f5bda6341ca$var$clampCssFloat(alpha);
        return $2c037f5bda6341ca$export$fac44ee5b035f737(colorArr, "rgba");
    }
}
function $2c037f5bda6341ca$export$fac44ee5b035f737(arrColor, type) {
    if (!arrColor || !arrColor.length) return;
    var colorStr = arrColor[0] + "," + arrColor[1] + "," + arrColor[2];
    if (type === "rgba" || type === "hsva" || type === "hsla") colorStr += "," + arrColor[3];
    return type + "(" + colorStr + ")";
}
function $2c037f5bda6341ca$export$16c0ec21a6f9ef95(color, backgroundLum) {
    var arr = $2c037f5bda6341ca$export$98e6a39c04603d36(color);
    return arr ? (0.299 * arr[0] + 0.587 * arr[1] + 0.114 * arr[2]) * arr[3] / 255 + (1 - arr[3]) * backgroundLum : 0;
}
function $2c037f5bda6341ca$export$4385e60b38654f68() {
    return $2c037f5bda6341ca$export$fac44ee5b035f737([
        Math.round(Math.random() * 255),
        Math.round(Math.random() * 255),
        Math.round(Math.random() * 255)
    ], "rgb");
}
var $2c037f5bda6341ca$var$liftedColorCache = new (0, $d91b0b6fc564d9c7$export$2e2bcd8739ae039)(100);
function $2c037f5bda6341ca$export$2b47e247dfb87a73(color) {
    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(color)) {
        var liftedColor = $2c037f5bda6341ca$var$liftedColorCache.get(color);
        if (!liftedColor) {
            liftedColor = $2c037f5bda6341ca$export$590e8b2c435046d9(color, -0.1);
            $2c037f5bda6341ca$var$liftedColorCache.put(color, liftedColor);
        }
        return liftedColor;
    } else if ((0, $7a1bd9c2710fea0d$export$fa2c283003ed971c)(color)) {
        var ret = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, color);
        ret.colorStops = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(color.colorStops, function(stop) {
            return {
                offset: stop.offset,
                color: $2c037f5bda6341ca$export$590e8b2c435046d9(stop.color, -0.1)
            };
        });
        return ret;
    }
    return color;
}








/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $999d81abec723db8$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
var $999d81abec723db8$var$mathRound = Math.round;
function $999d81abec723db8$export$4cde5df63f53f473(color) {
    var opacity;
    if (!color || color === "transparent") color = "none";
    else if (typeof color === "string" && color.indexOf("rgba") > -1) {
        var arr = (0, $2c037f5bda6341ca$export$98e6a39c04603d36)(color);
        if (arr) {
            color = "rgb(" + arr[0] + "," + arr[1] + "," + arr[2] + ")";
            opacity = arr[3];
        }
    }
    return {
        color: color,
        opacity: opacity == null ? 1 : opacity
    };
}
var $999d81abec723db8$var$EPSILON = 1e-4;
function $999d81abec723db8$export$4701367f5b4de464(transform) {
    return transform < $999d81abec723db8$var$EPSILON && transform > -$999d81abec723db8$var$EPSILON;
}
function $999d81abec723db8$export$4b9074ac37ee5a23(transform) {
    return $999d81abec723db8$var$mathRound(transform * 1e3) / 1e3;
}
function $999d81abec723db8$export$52bfc6d3e2ff0fc2(transform) {
    return $999d81abec723db8$var$mathRound(transform * 1e4) / 1e4;
}
function $999d81abec723db8$export$19676ab5cb1de150(transform) {
    return $999d81abec723db8$var$mathRound(transform * 10) / 10;
}
function $999d81abec723db8$export$f29a4456cf56ff21(m) {
    return "matrix(" + $999d81abec723db8$export$4b9074ac37ee5a23(m[0]) + "," + $999d81abec723db8$export$4b9074ac37ee5a23(m[1]) + "," + $999d81abec723db8$export$4b9074ac37ee5a23(m[2]) + "," + $999d81abec723db8$export$4b9074ac37ee5a23(m[3]) + "," + $999d81abec723db8$export$52bfc6d3e2ff0fc2(m[4]) + "," + $999d81abec723db8$export$52bfc6d3e2ff0fc2(m[5]) + ")";
}
var $999d81abec723db8$export$4062150f0600d971 = {
    left: "start",
    right: "end",
    center: "middle",
    middle: "middle"
};
function $999d81abec723db8$export$bf7d6802d2badd9(y, lineHeight, textBaseline) {
    if (textBaseline === "top") y += lineHeight / 2;
    else if (textBaseline === "bottom") y -= lineHeight / 2;
    return y;
}
function $999d81abec723db8$export$c62076b3a966c94b(style) {
    return style && (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY);
}
function $999d81abec723db8$export$9e4c657be710688a(displayable) {
    var style = displayable.style;
    var globalScale = displayable.getGlobalScale();
    return [
        style.shadowColor,
        (style.shadowBlur || 0).toFixed(2),
        (style.shadowOffsetX || 0).toFixed(2),
        (style.shadowOffsetY || 0).toFixed(2),
        globalScale[0],
        globalScale[1]
    ].join(",");
}
function $999d81abec723db8$export$8abc07640cab0527(clipPaths) {
    var key = [];
    if (clipPaths) for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        key.push(clipPath.id);
    }
    return key.join(",");
}
function $999d81abec723db8$export$2ade673ac4f85dfe(val) {
    return val && !!val.image;
}
function $999d81abec723db8$export$30352f47600a13cd(val) {
    return val && !!val.svgElement;
}
function $999d81abec723db8$export$41a28f5a000a9d0f(val) {
    return $999d81abec723db8$export$2ade673ac4f85dfe(val) || $999d81abec723db8$export$30352f47600a13cd(val);
}
function $999d81abec723db8$export$7d961bca9d3b47d0(val) {
    return val.type === "linear";
}
function $999d81abec723db8$export$2a9cca6692a0ce3a(val) {
    return val.type === "radial";
}
function $999d81abec723db8$export$545e02bbd5f8fe95(val) {
    return val && (val.type === "linear" || val.type === "radial");
}
function $999d81abec723db8$export$bb094196179998a5(id) {
    return "url(#" + id + ")";
}
function $999d81abec723db8$export$93fa1ae8a509371c(el) {
    var scale = el.getGlobalScale();
    var size = Math.max(scale[0], scale[1]);
    return Math.max(Math.ceil(Math.log(size) / Math.log(10)), 1);
}
function $999d81abec723db8$export$3fe07c0888ff6164(transform) {
    var x = transform.x || 0;
    var y = transform.y || 0;
    var rotation = (transform.rotation || 0) * (0, $7a1bd9c2710fea0d$export$bce8e055322a0ce6);
    var scaleX = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(transform.scaleX, 1);
    var scaleY = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(transform.scaleY, 1);
    var skewX = transform.skewX || 0;
    var skewY = transform.skewY || 0;
    var res = [];
    if (x || y) res.push("translate(" + x + "px," + y + "px)");
    if (rotation) res.push("rotate(" + rotation + ")");
    if (scaleX !== 1 || scaleY !== 1) res.push("scale(" + scaleX + "," + scaleY + ")");
    if (skewX || skewY) res.push("skew(" + $999d81abec723db8$var$mathRound(skewX * (0, $7a1bd9c2710fea0d$export$bce8e055322a0ce6)) + "deg, " + $999d81abec723db8$var$mathRound(skewY * (0, $7a1bd9c2710fea0d$export$bce8e055322a0ce6)) + "deg)");
    return res.join(" ");
}
var $999d81abec723db8$export$8fb536984ec8b4d7 = function() {
    if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).hasGlobalWindow && (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(window.btoa)) return function(str) {
        return window.btoa(unescape(encodeURIComponent(str)));
    };
    if (typeof $999d81abec723db8$require$Buffer !== "undefined") return function(str) {
        return $999d81abec723db8$require$Buffer.from(str).toString("base64");
    };
    return function(str) {
        return null;
    };
}();


var $76d8a142a20276fc$var$arraySlice = Array.prototype.slice;
function $76d8a142a20276fc$var$interpolateNumber(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
function $76d8a142a20276fc$var$interpolate1DArray(out, p0, p1, percent) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = $76d8a142a20276fc$var$interpolateNumber(p0[i], p1[i], percent);
    return out;
}
function $76d8a142a20276fc$var$interpolate2DArray(out, p0, p1, percent) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = $76d8a142a20276fc$var$interpolateNumber(p0[i][j], p1[i][j], percent);
    }
    return out;
}
function $76d8a142a20276fc$var$add1DArray(out, p0, p1, sign) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = p0[i] + p1[i] * sign;
    return out;
}
function $76d8a142a20276fc$var$add2DArray(out, p0, p1, sign) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = p0[i][j] + p1[i][j] * sign;
    }
    return out;
}
function $76d8a142a20276fc$var$fillColorStops(val0, val1) {
    var len0 = val0.length;
    var len1 = val1.length;
    var shorterArr = len0 > len1 ? val1 : val0;
    var shorterLen = Math.min(len0, len1);
    var last = shorterArr[shorterLen - 1] || {
        color: [
            0,
            0,
            0,
            0
        ],
        offset: 0
    };
    for(var i = shorterLen; i < Math.max(len0, len1); i++)shorterArr.push({
        offset: last.offset,
        color: last.color.slice()
    });
}
function $76d8a142a20276fc$var$fillArray(val0, val1, arrDim) {
    var arr0 = val0;
    var arr1 = val1;
    if (!arr0.push || !arr1.push) return;
    var arr0Len = arr0.length;
    var arr1Len = arr1.length;
    if (arr0Len !== arr1Len) {
        var isPreviousLarger = arr0Len > arr1Len;
        if (isPreviousLarger) arr0.length = arr1Len;
        else for(var i = arr0Len; i < arr1Len; i++)arr0.push(arrDim === 1 ? arr1[i] : $76d8a142a20276fc$var$arraySlice.call(arr1[i]));
    }
    var len2 = arr0[0] && arr0[0].length;
    for(var i = 0; i < arr0.length; i++){
        if (arrDim === 1) {
            if (isNaN(arr0[i])) arr0[i] = arr1[i];
        } else {
            for(var j = 0; j < len2; j++)if (isNaN(arr0[i][j])) arr0[i][j] = arr1[i][j];
        }
    }
}
function $76d8a142a20276fc$export$c5e92b7f105af84e(value) {
    if ((0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(value)) {
        var len = value.length;
        if ((0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(value[0])) {
            var ret = [];
            for(var i = 0; i < len; i++)ret.push($76d8a142a20276fc$var$arraySlice.call(value[i]));
            return ret;
        }
        return $76d8a142a20276fc$var$arraySlice.call(value);
    }
    return value;
}
function $76d8a142a20276fc$var$rgba2String(rgba) {
    rgba[0] = Math.floor(rgba[0]) || 0;
    rgba[1] = Math.floor(rgba[1]) || 0;
    rgba[2] = Math.floor(rgba[2]) || 0;
    rgba[3] = rgba[3] == null ? 1 : rgba[3];
    return "rgba(" + rgba.join(",") + ")";
}
function $76d8a142a20276fc$var$guessArrayDim(value) {
    return (0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(value && value[0]) ? 2 : 1;
}
var $76d8a142a20276fc$var$VALUE_TYPE_NUMBER = 0;
var $76d8a142a20276fc$var$VALUE_TYPE_1D_ARRAY = 1;
var $76d8a142a20276fc$var$VALUE_TYPE_2D_ARRAY = 2;
var $76d8a142a20276fc$var$VALUE_TYPE_COLOR = 3;
var $76d8a142a20276fc$var$VALUE_TYPE_LINEAR_GRADIENT = 4;
var $76d8a142a20276fc$var$VALUE_TYPE_RADIAL_GRADIENT = 5;
var $76d8a142a20276fc$var$VALUE_TYPE_UNKOWN = 6;
function $76d8a142a20276fc$var$isGradientValueType(valType) {
    return valType === $76d8a142a20276fc$var$VALUE_TYPE_LINEAR_GRADIENT || valType === $76d8a142a20276fc$var$VALUE_TYPE_RADIAL_GRADIENT;
}
function $76d8a142a20276fc$var$isArrayValueType(valType) {
    return valType === $76d8a142a20276fc$var$VALUE_TYPE_1D_ARRAY || valType === $76d8a142a20276fc$var$VALUE_TYPE_2D_ARRAY;
}
var $76d8a142a20276fc$var$tmpRgba = [
    0,
    0,
    0,
    0
];
var $76d8a142a20276fc$var$Track = function() {
    function Track(propName) {
        this.keyframes = [];
        this.discrete = false;
        this._invalid = false;
        this._needsSort = false;
        this._lastFr = 0;
        this._lastFrP = 0;
        this.propName = propName;
    }
    Track.prototype.isFinished = function() {
        return this._finished;
    };
    Track.prototype.setFinished = function() {
        this._finished = true;
        if (this._additiveTrack) this._additiveTrack.setFinished();
    };
    Track.prototype.needsAnimate = function() {
        return this.keyframes.length >= 1;
    };
    Track.prototype.getAdditiveTrack = function() {
        return this._additiveTrack;
    };
    Track.prototype.addKeyframe = function(time, rawValue, easing) {
        this._needsSort = true;
        var keyframes = this.keyframes;
        var len = keyframes.length;
        var discrete = false;
        var valType = $76d8a142a20276fc$var$VALUE_TYPE_UNKOWN;
        var value = rawValue;
        if ((0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(rawValue)) {
            var arrayDim = $76d8a142a20276fc$var$guessArrayDim(rawValue);
            valType = arrayDim;
            if (arrayDim === 1 && !(0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rawValue[0]) || arrayDim === 2 && !(0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rawValue[0][0])) discrete = true;
        } else {
            if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rawValue) && !(0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(rawValue)) valType = $76d8a142a20276fc$var$VALUE_TYPE_NUMBER;
            else if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(rawValue)) {
                if (!isNaN(+rawValue)) valType = $76d8a142a20276fc$var$VALUE_TYPE_NUMBER;
                else {
                    var colorArray = $2c037f5bda6341ca$export$98e6a39c04603d36(rawValue);
                    if (colorArray) {
                        value = colorArray;
                        valType = $76d8a142a20276fc$var$VALUE_TYPE_COLOR;
                    }
                }
            } else if ((0, $7a1bd9c2710fea0d$export$fa2c283003ed971c)(rawValue)) {
                var parsedGradient = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, value);
                parsedGradient.colorStops = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(rawValue.colorStops, function(colorStop) {
                    return {
                        offset: colorStop.offset,
                        color: $2c037f5bda6341ca$export$98e6a39c04603d36(colorStop.color)
                    };
                });
                if ((0, $999d81abec723db8$export$7d961bca9d3b47d0)(rawValue)) valType = $76d8a142a20276fc$var$VALUE_TYPE_LINEAR_GRADIENT;
                else if ((0, $999d81abec723db8$export$2a9cca6692a0ce3a)(rawValue)) valType = $76d8a142a20276fc$var$VALUE_TYPE_RADIAL_GRADIENT;
                value = parsedGradient;
            }
        }
        if (len === 0) this.valType = valType;
        else if (valType !== this.valType || valType === $76d8a142a20276fc$var$VALUE_TYPE_UNKOWN) discrete = true;
        this.discrete = this.discrete || discrete;
        var kf = {
            time: time,
            value: value,
            rawValue: rawValue,
            percent: 0
        };
        if (easing) {
            kf.easing = easing;
            kf.easingFunc = (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(easing) ? easing : (0, $9668111025b0b56f$export$2e2bcd8739ae039)[easing] || (0, $0aea98bda0b4be1f$export$ec0863d806fd857e)(easing);
        }
        keyframes.push(kf);
        return kf;
    };
    Track.prototype.prepare = function(maxTime, additiveTrack) {
        var kfs = this.keyframes;
        if (this._needsSort) kfs.sort(function(a, b) {
            return a.time - b.time;
        });
        var valType = this.valType;
        var kfsLen = kfs.length;
        var lastKf = kfs[kfsLen - 1];
        var isDiscrete = this.discrete;
        var isArr = $76d8a142a20276fc$var$isArrayValueType(valType);
        var isGradient = $76d8a142a20276fc$var$isGradientValueType(valType);
        for(var i = 0; i < kfsLen; i++){
            var kf = kfs[i];
            var value = kf.value;
            var lastValue = lastKf.value;
            kf.percent = kf.time / maxTime;
            if (!isDiscrete) {
                if (isArr && i !== kfsLen - 1) $76d8a142a20276fc$var$fillArray(value, lastValue, valType);
                else if (isGradient) $76d8a142a20276fc$var$fillColorStops(value.colorStops, lastValue.colorStops);
            }
        }
        if (!isDiscrete && valType !== $76d8a142a20276fc$var$VALUE_TYPE_RADIAL_GRADIENT && additiveTrack && this.needsAnimate() && additiveTrack.needsAnimate() && valType === additiveTrack.valType && !additiveTrack._finished) {
            this._additiveTrack = additiveTrack;
            var startValue = kfs[0].value;
            for(var i = 0; i < kfsLen; i++){
                if (valType === $76d8a142a20276fc$var$VALUE_TYPE_NUMBER) kfs[i].additiveValue = kfs[i].value - startValue;
                else if (valType === $76d8a142a20276fc$var$VALUE_TYPE_COLOR) kfs[i].additiveValue = $76d8a142a20276fc$var$add1DArray([], kfs[i].value, startValue, -1);
                else if ($76d8a142a20276fc$var$isArrayValueType(valType)) kfs[i].additiveValue = valType === $76d8a142a20276fc$var$VALUE_TYPE_1D_ARRAY ? $76d8a142a20276fc$var$add1DArray([], kfs[i].value, startValue, -1) : $76d8a142a20276fc$var$add2DArray([], kfs[i].value, startValue, -1);
            }
        }
    };
    Track.prototype.step = function(target, percent) {
        if (this._finished) return;
        if (this._additiveTrack && this._additiveTrack._finished) this._additiveTrack = null;
        var isAdditive = this._additiveTrack != null;
        var valueKey = isAdditive ? "additiveValue" : "value";
        var valType = this.valType;
        var keyframes = this.keyframes;
        var kfsNum = keyframes.length;
        var propName = this.propName;
        var isValueColor = valType === $76d8a142a20276fc$var$VALUE_TYPE_COLOR;
        var frameIdx;
        var lastFrame = this._lastFr;
        var mathMin = Math.min;
        var frame;
        var nextFrame;
        if (kfsNum === 1) frame = nextFrame = keyframes[0];
        else {
            if (percent < 0) frameIdx = 0;
            else if (percent < this._lastFrP) {
                var start = mathMin(lastFrame + 1, kfsNum - 1);
                for(frameIdx = start; frameIdx >= 0; frameIdx--){
                    if (keyframes[frameIdx].percent <= percent) break;
                }
                frameIdx = mathMin(frameIdx, kfsNum - 2);
            } else {
                for(frameIdx = lastFrame; frameIdx < kfsNum; frameIdx++){
                    if (keyframes[frameIdx].percent > percent) break;
                }
                frameIdx = mathMin(frameIdx - 1, kfsNum - 2);
            }
            nextFrame = keyframes[frameIdx + 1];
            frame = keyframes[frameIdx];
        }
        if (!(frame && nextFrame)) return;
        this._lastFr = frameIdx;
        this._lastFrP = percent;
        var interval = nextFrame.percent - frame.percent;
        var w = interval === 0 ? 1 : mathMin((percent - frame.percent) / interval, 1);
        if (nextFrame.easingFunc) w = nextFrame.easingFunc(w);
        var targetArr = isAdditive ? this._additiveValue : isValueColor ? $76d8a142a20276fc$var$tmpRgba : target[propName];
        if (($76d8a142a20276fc$var$isArrayValueType(valType) || isValueColor) && !targetArr) targetArr = this._additiveValue = [];
        if (this.discrete) target[propName] = w < 1 ? frame.rawValue : nextFrame.rawValue;
        else if ($76d8a142a20276fc$var$isArrayValueType(valType)) valType === $76d8a142a20276fc$var$VALUE_TYPE_1D_ARRAY ? $76d8a142a20276fc$var$interpolate1DArray(targetArr, frame[valueKey], nextFrame[valueKey], w) : $76d8a142a20276fc$var$interpolate2DArray(targetArr, frame[valueKey], nextFrame[valueKey], w);
        else if ($76d8a142a20276fc$var$isGradientValueType(valType)) {
            var val = frame[valueKey];
            var nextVal_1 = nextFrame[valueKey];
            var isLinearGradient_1 = valType === $76d8a142a20276fc$var$VALUE_TYPE_LINEAR_GRADIENT;
            target[propName] = {
                type: isLinearGradient_1 ? "linear" : "radial",
                x: $76d8a142a20276fc$var$interpolateNumber(val.x, nextVal_1.x, w),
                y: $76d8a142a20276fc$var$interpolateNumber(val.y, nextVal_1.y, w),
                colorStops: (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(val.colorStops, function(colorStop, idx) {
                    var nextColorStop = nextVal_1.colorStops[idx];
                    return {
                        offset: $76d8a142a20276fc$var$interpolateNumber(colorStop.offset, nextColorStop.offset, w),
                        color: $76d8a142a20276fc$var$rgba2String($76d8a142a20276fc$var$interpolate1DArray([], colorStop.color, nextColorStop.color, w))
                    };
                }),
                global: nextVal_1.global
            };
            if (isLinearGradient_1) {
                target[propName].x2 = $76d8a142a20276fc$var$interpolateNumber(val.x2, nextVal_1.x2, w);
                target[propName].y2 = $76d8a142a20276fc$var$interpolateNumber(val.y2, nextVal_1.y2, w);
            } else target[propName].r = $76d8a142a20276fc$var$interpolateNumber(val.r, nextVal_1.r, w);
        } else if (isValueColor) {
            $76d8a142a20276fc$var$interpolate1DArray(targetArr, frame[valueKey], nextFrame[valueKey], w);
            if (!isAdditive) target[propName] = $76d8a142a20276fc$var$rgba2String(targetArr);
        } else {
            var value = $76d8a142a20276fc$var$interpolateNumber(frame[valueKey], nextFrame[valueKey], w);
            if (isAdditive) this._additiveValue = value;
            else target[propName] = value;
        }
        if (isAdditive) this._addToTarget(target);
    };
    Track.prototype._addToTarget = function(target) {
        var valType = this.valType;
        var propName = this.propName;
        var additiveValue = this._additiveValue;
        if (valType === $76d8a142a20276fc$var$VALUE_TYPE_NUMBER) target[propName] = target[propName] + additiveValue;
        else if (valType === $76d8a142a20276fc$var$VALUE_TYPE_COLOR) {
            $2c037f5bda6341ca$export$98e6a39c04603d36(target[propName], $76d8a142a20276fc$var$tmpRgba);
            $76d8a142a20276fc$var$add1DArray($76d8a142a20276fc$var$tmpRgba, $76d8a142a20276fc$var$tmpRgba, additiveValue, 1);
            target[propName] = $76d8a142a20276fc$var$rgba2String($76d8a142a20276fc$var$tmpRgba);
        } else if (valType === $76d8a142a20276fc$var$VALUE_TYPE_1D_ARRAY) $76d8a142a20276fc$var$add1DArray(target[propName], target[propName], additiveValue, 1);
        else if (valType === $76d8a142a20276fc$var$VALUE_TYPE_2D_ARRAY) $76d8a142a20276fc$var$add2DArray(target[propName], target[propName], additiveValue, 1);
    };
    return Track;
}();
var $76d8a142a20276fc$var$Animator = function() {
    function Animator(target, loop, allowDiscreteAnimation, additiveTo) {
        this._tracks = {};
        this._trackKeys = [];
        this._maxTime = 0;
        this._started = 0;
        this._clip = null;
        this._target = target;
        this._loop = loop;
        if (loop && additiveTo) {
            (0, $7a1bd9c2710fea0d$export$58da9968c3170cb1)("Can' use additive animation on looped animation.");
            return;
        }
        this._additiveAnimators = additiveTo;
        this._allowDiscrete = allowDiscreteAnimation;
    }
    Animator.prototype.getMaxTime = function() {
        return this._maxTime;
    };
    Animator.prototype.getDelay = function() {
        return this._delay;
    };
    Animator.prototype.getLoop = function() {
        return this._loop;
    };
    Animator.prototype.getTarget = function() {
        return this._target;
    };
    Animator.prototype.changeTarget = function(target) {
        this._target = target;
    };
    Animator.prototype.when = function(time, props, easing) {
        return this.whenWithKeys(time, props, (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(props), easing);
    };
    Animator.prototype.whenWithKeys = function(time, props, propNames, easing) {
        var tracks = this._tracks;
        for(var i = 0; i < propNames.length; i++){
            var propName = propNames[i];
            var track = tracks[propName];
            if (!track) {
                track = tracks[propName] = new $76d8a142a20276fc$var$Track(propName);
                var initialValue = void 0;
                var additiveTrack = this._getAdditiveTrack(propName);
                if (additiveTrack) {
                    var addtiveTrackKfs = additiveTrack.keyframes;
                    var lastFinalKf = addtiveTrackKfs[addtiveTrackKfs.length - 1];
                    initialValue = lastFinalKf && lastFinalKf.value;
                    if (additiveTrack.valType === $76d8a142a20276fc$var$VALUE_TYPE_COLOR && initialValue) initialValue = $76d8a142a20276fc$var$rgba2String(initialValue);
                } else initialValue = this._target[propName];
                if (initialValue == null) continue;
                if (time > 0) track.addKeyframe(0, $76d8a142a20276fc$export$c5e92b7f105af84e(initialValue), easing);
                this._trackKeys.push(propName);
            }
            track.addKeyframe(time, $76d8a142a20276fc$export$c5e92b7f105af84e(props[propName]), easing);
        }
        this._maxTime = Math.max(this._maxTime, time);
        return this;
    };
    Animator.prototype.pause = function() {
        this._clip.pause();
        this._paused = true;
    };
    Animator.prototype.resume = function() {
        this._clip.resume();
        this._paused = false;
    };
    Animator.prototype.isPaused = function() {
        return !!this._paused;
    };
    Animator.prototype.duration = function(duration) {
        this._maxTime = duration;
        this._force = true;
        return this;
    };
    Animator.prototype._doneCallback = function() {
        this._setTracksFinished();
        this._clip = null;
        var doneList = this._doneCbs;
        if (doneList) {
            var len = doneList.length;
            for(var i = 0; i < len; i++)doneList[i].call(this);
        }
    };
    Animator.prototype._abortedCallback = function() {
        this._setTracksFinished();
        var animation = this.animation;
        var abortedList = this._abortedCbs;
        if (animation) animation.removeClip(this._clip);
        this._clip = null;
        if (abortedList) for(var i = 0; i < abortedList.length; i++)abortedList[i].call(this);
    };
    Animator.prototype._setTracksFinished = function() {
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < tracksKeys.length; i++)tracks[tracksKeys[i]].setFinished();
    };
    Animator.prototype._getAdditiveTrack = function(trackName) {
        var additiveTrack;
        var additiveAnimators = this._additiveAnimators;
        if (additiveAnimators) for(var i = 0; i < additiveAnimators.length; i++){
            var track = additiveAnimators[i].getTrack(trackName);
            if (track) additiveTrack = track;
        }
        return additiveTrack;
    };
    Animator.prototype.start = function(easing) {
        if (this._started > 0) return;
        this._started = 1;
        var self = this;
        var tracks = [];
        var maxTime = this._maxTime || 0;
        for(var i = 0; i < this._trackKeys.length; i++){
            var propName = this._trackKeys[i];
            var track = this._tracks[propName];
            var additiveTrack = this._getAdditiveTrack(propName);
            var kfs = track.keyframes;
            var kfsNum = kfs.length;
            track.prepare(maxTime, additiveTrack);
            if (track.needsAnimate()) {
                if (!this._allowDiscrete && track.discrete) {
                    var lastKf = kfs[kfsNum - 1];
                    if (lastKf) self._target[track.propName] = lastKf.rawValue;
                    track.setFinished();
                } else tracks.push(track);
            }
        }
        if (tracks.length || this._force) {
            var clip = new (0, $00f1e1cb3568b9c5$export$2e2bcd8739ae039)({
                life: maxTime,
                loop: this._loop,
                delay: this._delay || 0,
                onframe: function(percent) {
                    self._started = 2;
                    var additiveAnimators = self._additiveAnimators;
                    if (additiveAnimators) {
                        var stillHasAdditiveAnimator = false;
                        for(var i = 0; i < additiveAnimators.length; i++)if (additiveAnimators[i]._clip) {
                            stillHasAdditiveAnimator = true;
                            break;
                        }
                        if (!stillHasAdditiveAnimator) self._additiveAnimators = null;
                    }
                    for(var i = 0; i < tracks.length; i++)tracks[i].step(self._target, percent);
                    var onframeList = self._onframeCbs;
                    if (onframeList) for(var i = 0; i < onframeList.length; i++)onframeList[i](self._target, percent);
                },
                ondestroy: function() {
                    self._doneCallback();
                }
            });
            this._clip = clip;
            if (this.animation) this.animation.addClip(clip);
            if (easing) clip.setEasing(easing);
        } else this._doneCallback();
        return this;
    };
    Animator.prototype.stop = function(forwardToLast) {
        if (!this._clip) return;
        var clip = this._clip;
        if (forwardToLast) clip.onframe(1);
        this._abortedCallback();
    };
    Animator.prototype.delay = function(time) {
        this._delay = time;
        return this;
    };
    Animator.prototype.during = function(cb) {
        if (cb) {
            if (!this._onframeCbs) this._onframeCbs = [];
            this._onframeCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.done = function(cb) {
        if (cb) {
            if (!this._doneCbs) this._doneCbs = [];
            this._doneCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.aborted = function(cb) {
        if (cb) {
            if (!this._abortedCbs) this._abortedCbs = [];
            this._abortedCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.getClip = function() {
        return this._clip;
    };
    Animator.prototype.getTrack = function(propName) {
        return this._tracks[propName];
    };
    Animator.prototype.getTracks = function() {
        var _this = this;
        return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(this._trackKeys, function(key) {
            return _this._tracks[key];
        });
    };
    Animator.prototype.stopTracks = function(propNames, forwardToLast) {
        if (!propNames.length || !this._clip) return true;
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < propNames.length; i++){
            var track = tracks[propNames[i]];
            if (track && !track.isFinished()) {
                if (forwardToLast) track.step(this._target, 1);
                else if (this._started === 1) track.step(this._target, 0);
                track.setFinished();
            }
        }
        var allAborted = true;
        for(var i = 0; i < tracksKeys.length; i++)if (!tracks[tracksKeys[i]].isFinished()) {
            allAborted = false;
            break;
        }
        if (allAborted) this._abortedCallback();
        return allAborted;
    };
    Animator.prototype.saveTo = function(target, trackKeys, firstOrLast) {
        if (!target) return;
        trackKeys = trackKeys || this._trackKeys;
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track || track.isFinished()) continue;
            var kfs = track.keyframes;
            var kf = kfs[firstOrLast ? 0 : kfs.length - 1];
            if (kf) target[propName] = $76d8a142a20276fc$export$c5e92b7f105af84e(kf.rawValue);
        }
    };
    Animator.prototype.__changeFinalValue = function(finalProps, trackKeys) {
        trackKeys = trackKeys || (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(finalProps);
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track) continue;
            var kfs = track.keyframes;
            if (kfs.length > 1) {
                var lastKf = kfs.pop();
                track.addKeyframe(lastKf.time, finalProps[propName]);
                track.prepare(this._maxTime, track.getAdditiveTrack());
            }
        }
    };
    return Animator;
}();
var $76d8a142a20276fc$export$2e2bcd8739ae039 = $76d8a142a20276fc$var$Animator;


function $fad434a4044c956a$export$1428f42a7de81803() {
    return new Date().getTime();
}
var $fad434a4044c956a$var$Animation = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Animation, _super);
    function Animation(opts) {
        var _this = _super.call(this) || this;
        _this._running = false;
        _this._time = 0;
        _this._pausedTime = 0;
        _this._pauseStart = 0;
        _this._paused = false;
        opts = opts || {};
        _this.stage = opts.stage || {};
        return _this;
    }
    Animation.prototype.addClip = function(clip) {
        if (clip.animation) this.removeClip(clip);
        if (!this._head) this._head = this._tail = clip;
        else {
            this._tail.next = clip;
            clip.prev = this._tail;
            clip.next = null;
            this._tail = clip;
        }
        clip.animation = this;
    };
    Animation.prototype.addAnimator = function(animator) {
        animator.animation = this;
        var clip = animator.getClip();
        if (clip) this.addClip(clip);
    };
    Animation.prototype.removeClip = function(clip) {
        if (!clip.animation) return;
        var prev = clip.prev;
        var next = clip.next;
        if (prev) prev.next = next;
        else this._head = next;
        if (next) next.prev = prev;
        else this._tail = prev;
        clip.next = clip.prev = clip.animation = null;
    };
    Animation.prototype.removeAnimator = function(animator) {
        var clip = animator.getClip();
        if (clip) this.removeClip(clip);
        animator.animation = null;
    };
    Animation.prototype.update = function(notTriggerFrameAndStageUpdate) {
        var time = $fad434a4044c956a$export$1428f42a7de81803() - this._pausedTime;
        var delta = time - this._time;
        var clip = this._head;
        while(clip){
            var nextClip = clip.next;
            var finished = clip.step(time, delta);
            if (finished) {
                clip.ondestroy();
                this.removeClip(clip);
                clip = nextClip;
            } else clip = nextClip;
        }
        this._time = time;
        if (!notTriggerFrameAndStageUpdate) {
            this.trigger("frame", delta);
            this.stage.update && this.stage.update();
        }
    };
    Animation.prototype._startLoop = function() {
        var self = this;
        this._running = true;
        function step() {
            if (self._running) {
                (0, $731d42ad1858cd4c$export$2e2bcd8739ae039)(step);
                !self._paused && self.update();
            }
        }
        (0, $731d42ad1858cd4c$export$2e2bcd8739ae039)(step);
    };
    Animation.prototype.start = function() {
        if (this._running) return;
        this._time = $fad434a4044c956a$export$1428f42a7de81803();
        this._pausedTime = 0;
        this._startLoop();
    };
    Animation.prototype.stop = function() {
        this._running = false;
    };
    Animation.prototype.pause = function() {
        if (!this._paused) {
            this._pauseStart = $fad434a4044c956a$export$1428f42a7de81803();
            this._paused = true;
        }
    };
    Animation.prototype.resume = function() {
        if (this._paused) {
            this._pausedTime += $fad434a4044c956a$export$1428f42a7de81803() - this._pauseStart;
            this._paused = false;
        }
    };
    Animation.prototype.clear = function() {
        var clip = this._head;
        while(clip){
            var nextClip = clip.next;
            clip.prev = clip.next = clip.animation = null;
            clip = nextClip;
        }
        this._head = this._tail = null;
    };
    Animation.prototype.isFinished = function() {
        return this._head == null;
    };
    Animation.prototype.animate = function(target, options) {
        options = options || {};
        this.start();
        var animator = new (0, $76d8a142a20276fc$export$2e2bcd8739ae039)(target, options.loop);
        this.addAnimator(animator);
        return animator;
    };
    return Animation;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
var $fad434a4044c956a$export$2e2bcd8739ae039 = $fad434a4044c956a$var$Animation;







var $c0dbbc6989260eee$var$TOUCH_CLICK_DELAY = 300;
var $c0dbbc6989260eee$var$globalEventSupported = (0, $ce6dd58693a21851$export$2e2bcd8739ae039).domSupported;
var $c0dbbc6989260eee$var$localNativeListenerNames = function() {
    var mouseHandlerNames = [
        "click",
        "dblclick",
        "mousewheel",
        "wheel",
        "mouseout",
        "mouseup",
        "mousedown",
        "mousemove",
        "contextmenu"
    ];
    var touchHandlerNames = [
        "touchstart",
        "touchend",
        "touchmove"
    ];
    var pointerEventNameMap = {
        pointerdown: 1,
        pointerup: 1,
        pointermove: 1,
        pointerout: 1
    };
    var pointerHandlerNames = $7a1bd9c2710fea0d$export$871de8747c9eaa88(mouseHandlerNames, function(name) {
        var nm = name.replace("mouse", "pointer");
        return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
    });
    return {
        mouse: mouseHandlerNames,
        touch: touchHandlerNames,
        pointer: pointerHandlerNames
    };
}();
var $c0dbbc6989260eee$var$globalNativeListenerNames = {
    mouse: [
        "mousemove",
        "mouseup"
    ],
    pointer: [
        "pointermove",
        "pointerup"
    ]
};
var $c0dbbc6989260eee$var$wheelEventSupported = false;
function $c0dbbc6989260eee$var$isPointerFromTouch(event) {
    var pointerType = event.pointerType;
    return pointerType === "pen" || pointerType === "touch";
}
function $c0dbbc6989260eee$var$setTouchTimer(scope) {
    scope.touching = true;
    if (scope.touchTimer != null) {
        clearTimeout(scope.touchTimer);
        scope.touchTimer = null;
    }
    scope.touchTimer = setTimeout(function() {
        scope.touching = false;
        scope.touchTimer = null;
    }, 700);
}
function $c0dbbc6989260eee$var$markTouch(event) {
    event && (event.zrByTouch = true);
}
function $c0dbbc6989260eee$var$normalizeGlobalEvent(instance, event) {
    return (0, $b3864a78637ff9ed$export$40fadb093aebad71)(instance.dom, new $c0dbbc6989260eee$var$FakeGlobalEvent(instance, event), true);
}
function $c0dbbc6989260eee$var$isLocalEl(instance, el) {
    var elTmp = el;
    var isLocal = false;
    while(elTmp && elTmp.nodeType !== 9 && !(isLocal = elTmp.domBelongToZr || elTmp !== el && elTmp === instance.painterRoot))elTmp = elTmp.parentNode;
    return isLocal;
}
var $c0dbbc6989260eee$var$FakeGlobalEvent = function() {
    function FakeGlobalEvent(instance, event) {
        this.stopPropagation = $7a1bd9c2710fea0d$export$8793edee2d425525;
        this.stopImmediatePropagation = $7a1bd9c2710fea0d$export$8793edee2d425525;
        this.preventDefault = $7a1bd9c2710fea0d$export$8793edee2d425525;
        this.type = event.type;
        this.target = this.currentTarget = instance.dom;
        this.pointerType = event.pointerType;
        this.clientX = event.clientX;
        this.clientY = event.clientY;
    }
    return FakeGlobalEvent;
}();
var $c0dbbc6989260eee$var$localDOMHandlers = {
    mousedown: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        this.__mayPointerCapture = [
            event.zrX,
            event.zrY
        ];
        this.trigger("mousedown", event);
    },
    mousemove: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        var downPoint = this.__mayPointerCapture;
        if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) this.__togglePointerCapture(true);
        this.trigger("mousemove", event);
    },
    mouseup: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        this.__togglePointerCapture(false);
        this.trigger("mouseup", event);
    },
    mouseout: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        var element = event.toElement || event.relatedTarget;
        if (!$c0dbbc6989260eee$var$isLocalEl(this, element)) {
            if (this.__pointerCapturing) event.zrEventControl = "no_globalout";
            this.trigger("mouseout", event);
        }
    },
    wheel: function(event) {
        $c0dbbc6989260eee$var$wheelEventSupported = true;
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        this.trigger("mousewheel", event);
    },
    mousewheel: function(event) {
        if ($c0dbbc6989260eee$var$wheelEventSupported) return;
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        this.trigger("mousewheel", event);
    },
    touchstart: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        $c0dbbc6989260eee$var$markTouch(event);
        this.__lastTouchMoment = new Date();
        this.handler.processGesture(event, "start");
        $c0dbbc6989260eee$var$localDOMHandlers.mousemove.call(this, event);
        $c0dbbc6989260eee$var$localDOMHandlers.mousedown.call(this, event);
    },
    touchmove: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        $c0dbbc6989260eee$var$markTouch(event);
        this.handler.processGesture(event, "change");
        $c0dbbc6989260eee$var$localDOMHandlers.mousemove.call(this, event);
    },
    touchend: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        $c0dbbc6989260eee$var$markTouch(event);
        this.handler.processGesture(event, "end");
        $c0dbbc6989260eee$var$localDOMHandlers.mouseup.call(this, event);
        if (+new Date() - +this.__lastTouchMoment < $c0dbbc6989260eee$var$TOUCH_CLICK_DELAY) $c0dbbc6989260eee$var$localDOMHandlers.click.call(this, event);
    },
    pointerdown: function(event) {
        $c0dbbc6989260eee$var$localDOMHandlers.mousedown.call(this, event);
    },
    pointermove: function(event) {
        if (!$c0dbbc6989260eee$var$isPointerFromTouch(event)) $c0dbbc6989260eee$var$localDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function(event) {
        $c0dbbc6989260eee$var$localDOMHandlers.mouseup.call(this, event);
    },
    pointerout: function(event) {
        if (!$c0dbbc6989260eee$var$isPointerFromTouch(event)) $c0dbbc6989260eee$var$localDOMHandlers.mouseout.call(this, event);
    }
};
$7a1bd9c2710fea0d$export$79b2f7037acddd43([
    "click",
    "dblclick",
    "contextmenu"
], function(name) {
    $c0dbbc6989260eee$var$localDOMHandlers[name] = function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        this.trigger(name, event);
    };
});
var $c0dbbc6989260eee$var$globalDOMHandlers = {
    pointermove: function(event) {
        if (!$c0dbbc6989260eee$var$isPointerFromTouch(event)) $c0dbbc6989260eee$var$globalDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function(event) {
        $c0dbbc6989260eee$var$globalDOMHandlers.mouseup.call(this, event);
    },
    mousemove: function(event) {
        this.trigger("mousemove", event);
    },
    mouseup: function(event) {
        var pointerCaptureReleasing = this.__pointerCapturing;
        this.__togglePointerCapture(false);
        this.trigger("mouseup", event);
        if (pointerCaptureReleasing) {
            event.zrEventControl = "only_globalout";
            this.trigger("mouseout", event);
        }
    }
};
function $c0dbbc6989260eee$var$mountLocalDOMEventListeners(instance, scope) {
    var domHandlers = scope.domHandlers;
    if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).pointerEventsSupported) $7a1bd9c2710fea0d$export$79b2f7037acddd43($c0dbbc6989260eee$var$localNativeListenerNames.pointer, function(nativeEventName) {
        $c0dbbc6989260eee$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
            domHandlers[nativeEventName].call(instance, event);
        });
    });
    else {
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).touchEventsSupported) $7a1bd9c2710fea0d$export$79b2f7037acddd43($c0dbbc6989260eee$var$localNativeListenerNames.touch, function(nativeEventName) {
            $c0dbbc6989260eee$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                domHandlers[nativeEventName].call(instance, event);
                $c0dbbc6989260eee$var$setTouchTimer(scope);
            });
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($c0dbbc6989260eee$var$localNativeListenerNames.mouse, function(nativeEventName) {
            $c0dbbc6989260eee$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                event = (0, $b3864a78637ff9ed$export$4abe0e945399ac1d)(event);
                if (!scope.touching) domHandlers[nativeEventName].call(instance, event);
            });
        });
    }
}
function $c0dbbc6989260eee$var$mountGlobalDOMEventListeners(instance, scope) {
    if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).pointerEventsSupported) $7a1bd9c2710fea0d$export$79b2f7037acddd43($c0dbbc6989260eee$var$globalNativeListenerNames.pointer, mount);
    else if (!(0, $ce6dd58693a21851$export$2e2bcd8739ae039).touchEventsSupported) $7a1bd9c2710fea0d$export$79b2f7037acddd43($c0dbbc6989260eee$var$globalNativeListenerNames.mouse, mount);
    function mount(nativeEventName) {
        function nativeEventListener(event) {
            event = (0, $b3864a78637ff9ed$export$4abe0e945399ac1d)(event);
            if (!$c0dbbc6989260eee$var$isLocalEl(instance, event.target)) {
                event = $c0dbbc6989260eee$var$normalizeGlobalEvent(instance, event);
                scope.domHandlers[nativeEventName].call(instance, event);
            }
        }
        $c0dbbc6989260eee$var$mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, {
            capture: true
        });
    }
}
function $c0dbbc6989260eee$var$mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
    scope.mounted[nativeEventName] = listener;
    scope.listenerOpts[nativeEventName] = opt;
    (0, $b3864a78637ff9ed$export$3f65cefe8380dbea)(scope.domTarget, nativeEventName, listener, opt);
}
function $c0dbbc6989260eee$var$unmountDOMEventListeners(scope) {
    var mounted = scope.mounted;
    for(var nativeEventName in mounted)if (mounted.hasOwnProperty(nativeEventName)) (0, $b3864a78637ff9ed$export$8ff9f68337b520c0)(scope.domTarget, nativeEventName, mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
    scope.mounted = {};
}
var $c0dbbc6989260eee$var$DOMHandlerScope = function() {
    function DOMHandlerScope(domTarget, domHandlers) {
        this.mounted = {};
        this.listenerOpts = {};
        this.touching = false;
        this.domTarget = domTarget;
        this.domHandlers = domHandlers;
    }
    return DOMHandlerScope;
}();
var $c0dbbc6989260eee$var$HandlerDomProxy = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(HandlerDomProxy, _super);
    function HandlerDomProxy(dom, painterRoot) {
        var _this = _super.call(this) || this;
        _this.__pointerCapturing = false;
        _this.dom = dom;
        _this.painterRoot = painterRoot;
        _this._localHandlerScope = new $c0dbbc6989260eee$var$DOMHandlerScope(dom, $c0dbbc6989260eee$var$localDOMHandlers);
        if ($c0dbbc6989260eee$var$globalEventSupported) _this._globalHandlerScope = new $c0dbbc6989260eee$var$DOMHandlerScope(document, $c0dbbc6989260eee$var$globalDOMHandlers);
        $c0dbbc6989260eee$var$mountLocalDOMEventListeners(_this, _this._localHandlerScope);
        return _this;
    }
    HandlerDomProxy.prototype.dispose = function() {
        $c0dbbc6989260eee$var$unmountDOMEventListeners(this._localHandlerScope);
        if ($c0dbbc6989260eee$var$globalEventSupported) $c0dbbc6989260eee$var$unmountDOMEventListeners(this._globalHandlerScope);
    };
    HandlerDomProxy.prototype.setCursor = function(cursorStyle) {
        this.dom.style && (this.dom.style.cursor = cursorStyle || "default");
    };
    HandlerDomProxy.prototype.__togglePointerCapture = function(isPointerCapturing) {
        this.__mayPointerCapture = null;
        if ($c0dbbc6989260eee$var$globalEventSupported && +this.__pointerCapturing ^ +isPointerCapturing) {
            this.__pointerCapturing = isPointerCapturing;
            var globalHandlerScope = this._globalHandlerScope;
            isPointerCapturing ? $c0dbbc6989260eee$var$mountGlobalDOMEventListeners(this, globalHandlerScope) : $c0dbbc6989260eee$var$unmountDOMEventListeners(globalHandlerScope);
        }
    };
    return HandlerDomProxy;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
var $c0dbbc6989260eee$export$2e2bcd8739ae039 = $c0dbbc6989260eee$var$HandlerDomProxy;




var $4b0cedd85979c776$var$dpr = 1;
if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).hasGlobalWindow) $4b0cedd85979c776$var$dpr = Math.max(window.devicePixelRatio || window.screen && window.screen.deviceXDPI / window.screen.logicalXDPI || 1, 1);
var $4b0cedd85979c776$export$7cdcde344c85339c = 0;
var $4b0cedd85979c776$export$508f096bfcdaac40 = $4b0cedd85979c776$var$dpr;
var $4b0cedd85979c776$export$fd81e7ebc7dae256 = 0.4;
var $4b0cedd85979c776$export$f8ce94761f39398d = "#333";
var $4b0cedd85979c776$export$3c6e95f318c8369b = "#ccc";
var $4b0cedd85979c776$export$27682248795c3c6b = "#eee";






var $becf2d727f9cf450$var$mIdentity = $f41ebb9dd60b55b4$export$f0954fd7d5368655;
var $becf2d727f9cf450$var$EPSILON = 5e-5;
function $becf2d727f9cf450$var$isNotAroundZero(val) {
    return val > $becf2d727f9cf450$var$EPSILON || val < -$becf2d727f9cf450$var$EPSILON;
}
var $becf2d727f9cf450$var$scaleTmp = [];
var $becf2d727f9cf450$var$tmpTransform = [];
var $becf2d727f9cf450$var$originTransform = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
var $becf2d727f9cf450$var$abs = Math.abs;
var $becf2d727f9cf450$var$Transformable = function() {
    function Transformable() {}
    Transformable.prototype.getLocalTransform = function(m) {
        return Transformable.getLocalTransform(this, m);
    };
    Transformable.prototype.setPosition = function(arr) {
        this.x = arr[0];
        this.y = arr[1];
    };
    Transformable.prototype.setScale = function(arr) {
        this.scaleX = arr[0];
        this.scaleY = arr[1];
    };
    Transformable.prototype.setSkew = function(arr) {
        this.skewX = arr[0];
        this.skewY = arr[1];
    };
    Transformable.prototype.setOrigin = function(arr) {
        this.originX = arr[0];
        this.originY = arr[1];
    };
    Transformable.prototype.needLocalTransform = function() {
        return $becf2d727f9cf450$var$isNotAroundZero(this.rotation) || $becf2d727f9cf450$var$isNotAroundZero(this.x) || $becf2d727f9cf450$var$isNotAroundZero(this.y) || $becf2d727f9cf450$var$isNotAroundZero(this.scaleX - 1) || $becf2d727f9cf450$var$isNotAroundZero(this.scaleY - 1) || $becf2d727f9cf450$var$isNotAroundZero(this.skewX) || $becf2d727f9cf450$var$isNotAroundZero(this.skewY);
    };
    Transformable.prototype.updateTransform = function() {
        var parentTransform = this.parent && this.parent.transform;
        var needLocalTransform = this.needLocalTransform();
        var m = this.transform;
        if (!(needLocalTransform || parentTransform)) {
            if (m) {
                $becf2d727f9cf450$var$mIdentity(m);
                this.invTransform = null;
            }
            return;
        }
        m = m || $f41ebb9dd60b55b4$export$185802fd694ee1f5();
        if (needLocalTransform) this.getLocalTransform(m);
        else $becf2d727f9cf450$var$mIdentity(m);
        if (parentTransform) {
            if (needLocalTransform) $f41ebb9dd60b55b4$export$6e3a27864ab166fe(m, parentTransform, m);
            else $f41ebb9dd60b55b4$export$784d13d8ee351f07(m, parentTransform);
        }
        this.transform = m;
        this._resolveGlobalScaleRatio(m);
    };
    Transformable.prototype._resolveGlobalScaleRatio = function(m) {
        var globalScaleRatio = this.globalScaleRatio;
        if (globalScaleRatio != null && globalScaleRatio !== 1) {
            this.getGlobalScale($becf2d727f9cf450$var$scaleTmp);
            var relX = $becf2d727f9cf450$var$scaleTmp[0] < 0 ? -1 : 1;
            var relY = $becf2d727f9cf450$var$scaleTmp[1] < 0 ? -1 : 1;
            var sx = (($becf2d727f9cf450$var$scaleTmp[0] - relX) * globalScaleRatio + relX) / $becf2d727f9cf450$var$scaleTmp[0] || 0;
            var sy = (($becf2d727f9cf450$var$scaleTmp[1] - relY) * globalScaleRatio + relY) / $becf2d727f9cf450$var$scaleTmp[1] || 0;
            m[0] *= sx;
            m[1] *= sx;
            m[2] *= sy;
            m[3] *= sy;
        }
        this.invTransform = this.invTransform || $f41ebb9dd60b55b4$export$185802fd694ee1f5();
        $f41ebb9dd60b55b4$export$6897c284b6f9f4dc(this.invTransform, m);
    };
    Transformable.prototype.getComputedTransform = function() {
        var transformNode = this;
        var ancestors = [];
        while(transformNode){
            ancestors.push(transformNode);
            transformNode = transformNode.parent;
        }
        while(transformNode = ancestors.pop())transformNode.updateTransform();
        return this.transform;
    };
    Transformable.prototype.setLocalTransform = function(m) {
        if (!m) return;
        var sx = m[0] * m[0] + m[1] * m[1];
        var sy = m[2] * m[2] + m[3] * m[3];
        var rotation = Math.atan2(m[1], m[0]);
        var shearX = Math.PI / 2 + rotation - Math.atan2(m[3], m[2]);
        sy = Math.sqrt(sy) * Math.cos(shearX);
        sx = Math.sqrt(sx);
        this.skewX = shearX;
        this.skewY = 0;
        this.rotation = -rotation;
        this.x = +m[4];
        this.y = +m[5];
        this.scaleX = sx;
        this.scaleY = sy;
        this.originX = 0;
        this.originY = 0;
    };
    Transformable.prototype.decomposeTransform = function() {
        if (!this.transform) return;
        var parent = this.parent;
        var m = this.transform;
        if (parent && parent.transform) {
            parent.invTransform = parent.invTransform || $f41ebb9dd60b55b4$export$185802fd694ee1f5();
            $f41ebb9dd60b55b4$export$6e3a27864ab166fe($becf2d727f9cf450$var$tmpTransform, parent.invTransform, m);
            m = $becf2d727f9cf450$var$tmpTransform;
        }
        var ox = this.originX;
        var oy = this.originY;
        if (ox || oy) {
            $becf2d727f9cf450$var$originTransform[4] = ox;
            $becf2d727f9cf450$var$originTransform[5] = oy;
            $f41ebb9dd60b55b4$export$6e3a27864ab166fe($becf2d727f9cf450$var$tmpTransform, m, $becf2d727f9cf450$var$originTransform);
            $becf2d727f9cf450$var$tmpTransform[4] -= ox;
            $becf2d727f9cf450$var$tmpTransform[5] -= oy;
            m = $becf2d727f9cf450$var$tmpTransform;
        }
        this.setLocalTransform(m);
    };
    Transformable.prototype.getGlobalScale = function(out) {
        var m = this.transform;
        out = out || [];
        if (!m) {
            out[0] = 1;
            out[1] = 1;
            return out;
        }
        out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
        out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
        if (m[0] < 0) out[0] = -out[0];
        if (m[3] < 0) out[1] = -out[1];
        return out;
    };
    Transformable.prototype.transformCoordToLocal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var invTransform = this.invTransform;
        if (invTransform) $6de594cf8ac295ff$export$9f9dcb98c894b623(v2, v2, invTransform);
        return v2;
    };
    Transformable.prototype.transformCoordToGlobal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var transform = this.transform;
        if (transform) $6de594cf8ac295ff$export$9f9dcb98c894b623(v2, v2, transform);
        return v2;
    };
    Transformable.prototype.getLineScale = function() {
        var m = this.transform;
        return m && $becf2d727f9cf450$var$abs(m[0] - 1) > 1e-10 && $becf2d727f9cf450$var$abs(m[3] - 1) > 1e-10 ? Math.sqrt($becf2d727f9cf450$var$abs(m[0] * m[3] - m[2] * m[1])) : 1;
    };
    Transformable.prototype.copyTransform = function(source) {
        $becf2d727f9cf450$export$234b1c16dfa57d6a(this, source);
    };
    Transformable.getLocalTransform = function(target, m) {
        m = m || [];
        var ox = target.originX || 0;
        var oy = target.originY || 0;
        var sx = target.scaleX;
        var sy = target.scaleY;
        var ax = target.anchorX;
        var ay = target.anchorY;
        var rotation = target.rotation || 0;
        var x = target.x;
        var y = target.y;
        var skewX = target.skewX ? Math.tan(target.skewX) : 0;
        var skewY = target.skewY ? Math.tan(-target.skewY) : 0;
        if (ox || oy || ax || ay) {
            var dx = ox + ax;
            var dy = oy + ay;
            m[4] = -dx * sx - skewX * dy * sy;
            m[5] = -dy * sy - skewY * dx * sx;
        } else m[4] = m[5] = 0;
        m[0] = sx;
        m[3] = sy;
        m[1] = skewY * sx;
        m[2] = skewX * sy;
        rotation && $f41ebb9dd60b55b4$export$bb628a54ab399bc9(m, m, rotation);
        m[4] += ox + x;
        m[5] += oy + y;
        return m;
    };
    Transformable.initDefaultProps = function() {
        var proto = Transformable.prototype;
        proto.scaleX = proto.scaleY = proto.globalScaleRatio = 1;
        proto.x = proto.y = proto.originX = proto.originY = proto.skewX = proto.skewY = proto.rotation = proto.anchorX = proto.anchorY = 0;
    }();
    return Transformable;
}();
var $becf2d727f9cf450$export$98ab6203ec3396e2 = [
    "x",
    "y",
    "originX",
    "originY",
    "anchorX",
    "anchorY",
    "rotation",
    "scaleX",
    "scaleY",
    "skewX",
    "skewY"
];
function $becf2d727f9cf450$export$234b1c16dfa57d6a(target, source) {
    for(var i = 0; i < $becf2d727f9cf450$export$98ab6203ec3396e2.length; i++){
        var propName = $becf2d727f9cf450$export$98ab6203ec3396e2[i];
        target[propName] = source[propName];
    }
}
var $becf2d727f9cf450$export$2e2bcd8739ae039 = $becf2d727f9cf450$var$Transformable;








function $6c308355c7107803$export$3c49c185de0c2bfc(text, font) {
    return $6c308355c7107803$export$e6849d91c2a0b61f($6c308355c7107803$export$23ef3ef10b010856(font), text);
}
function $6c308355c7107803$export$23ef3ef10b010856(font) {
    if (!$6c308355c7107803$var$_fontMeasureInfoCache) $6c308355c7107803$var$_fontMeasureInfoCache = new (0, $d91b0b6fc564d9c7$export$2e2bcd8739ae039)(100);
    font = font || (0, $c6341dcc9d86826e$export$7d7a232b6d2cc80c);
    var measureInfo = $6c308355c7107803$var$_fontMeasureInfoCache.get(font);
    if (!measureInfo) {
        measureInfo = {
            font: font,
            strWidthCache: new (0, $d91b0b6fc564d9c7$export$2e2bcd8739ae039)(500),
            asciiWidthMap: null,
            asciiWidthMapTried: false,
            stWideCharWidth: (0, $c6341dcc9d86826e$export$ef5e599365494451).measureText("\u56FD", font).width,
            asciiCharWidth: (0, $c6341dcc9d86826e$export$ef5e599365494451).measureText("a", font).width
        };
        $6c308355c7107803$var$_fontMeasureInfoCache.put(font, measureInfo);
    }
    return measureInfo;
}
var $6c308355c7107803$var$_fontMeasureInfoCache;
function $6c308355c7107803$var$tryCreateASCIIWidthMap(font) {
    if ($6c308355c7107803$var$_getASCIIWidthMapLongCount >= $6c308355c7107803$var$GET_ASCII_WIDTH_LONG_COUNT_MAX) return;
    font = font || (0, $c6341dcc9d86826e$export$7d7a232b6d2cc80c);
    var asciiWidthMap = [];
    var start = +new Date();
    for(var code = 0; code <= 127; code++)asciiWidthMap[code] = (0, $c6341dcc9d86826e$export$ef5e599365494451).measureText(String.fromCharCode(code), font).width;
    var cost = +new Date() - start;
    if (cost > 16) $6c308355c7107803$var$_getASCIIWidthMapLongCount = $6c308355c7107803$var$GET_ASCII_WIDTH_LONG_COUNT_MAX;
    else if (cost > 2) $6c308355c7107803$var$_getASCIIWidthMapLongCount++;
    return asciiWidthMap;
}
var $6c308355c7107803$var$_getASCIIWidthMapLongCount = 0;
var $6c308355c7107803$var$GET_ASCII_WIDTH_LONG_COUNT_MAX = 5;
function $6c308355c7107803$export$4e92f5603b5c7bb3(fontMeasureInfo, charCode) {
    if (!fontMeasureInfo.asciiWidthMapTried) {
        fontMeasureInfo.asciiWidthMap = $6c308355c7107803$var$tryCreateASCIIWidthMap(fontMeasureInfo.font);
        fontMeasureInfo.asciiWidthMapTried = true;
    }
    return 0 <= charCode && charCode <= 127 ? fontMeasureInfo.asciiWidthMap != null ? fontMeasureInfo.asciiWidthMap[charCode] : fontMeasureInfo.asciiCharWidth : fontMeasureInfo.stWideCharWidth;
}
function $6c308355c7107803$export$e6849d91c2a0b61f(fontMeasureInfo, text) {
    var strWidthCache = fontMeasureInfo.strWidthCache;
    var width = strWidthCache.get(text);
    if (width == null) {
        width = (0, $c6341dcc9d86826e$export$ef5e599365494451).measureText(text, fontMeasureInfo.font).width;
        strWidthCache.put(text, width);
    }
    return width;
}
function $6c308355c7107803$export$85aabf24202fbe9b(text, font, textAlign, textBaseline) {
    var width = $6c308355c7107803$export$e6849d91c2a0b61f($6c308355c7107803$export$23ef3ef10b010856(font), text);
    var height = $6c308355c7107803$export$56204a27a2958a55(font);
    var x = $6c308355c7107803$export$eb5a525ef00ef9a4(0, width, textAlign);
    var y = $6c308355c7107803$export$bf7d6802d2badd9(0, height, textBaseline);
    var rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height);
    return rect;
}
function $6c308355c7107803$export$c381147bfed79d9f(text, font, textAlign, textBaseline) {
    var textLines = ((text || "") + "").split("\n");
    var len = textLines.length;
    if (len === 1) return $6c308355c7107803$export$85aabf24202fbe9b(textLines[0], font, textAlign, textBaseline);
    else {
        var uniondRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
        for(var i = 0; i < textLines.length; i++){
            var rect = $6c308355c7107803$export$85aabf24202fbe9b(textLines[i], font, textAlign, textBaseline);
            i === 0 ? uniondRect.copy(rect) : uniondRect.union(rect);
        }
        return uniondRect;
    }
}
function $6c308355c7107803$export$eb5a525ef00ef9a4(x, width, textAlign, inverse) {
    if (textAlign === "right") !inverse ? x -= width : x += width;
    else if (textAlign === "center") !inverse ? x -= width / 2 : x += width / 2;
    return x;
}
function $6c308355c7107803$export$bf7d6802d2badd9(y, height, verticalAlign, inverse) {
    if (verticalAlign === "middle") !inverse ? y -= height / 2 : y += height / 2;
    else if (verticalAlign === "bottom") !inverse ? y -= height : y += height;
    return y;
}
function $6c308355c7107803$export$56204a27a2958a55(font) {
    return $6c308355c7107803$export$23ef3ef10b010856(font).stWideCharWidth;
}
function $6c308355c7107803$export$866cc30a33805630(text, font) {
    return (0, $c6341dcc9d86826e$export$ef5e599365494451).measureText(text, font);
}
function $6c308355c7107803$export$e8514cb5a5e2b40f(value, maxValue) {
    if (typeof value === "string") {
        if (value.lastIndexOf("%") >= 0) return parseFloat(value) / 100 * maxValue;
        return parseFloat(value);
    }
    return value;
}
function $6c308355c7107803$export$eee3603b512feab7(out, opts, rect) {
    var textPosition = opts.position || "inside";
    var distance = opts.distance != null ? opts.distance : 5;
    var height = rect.height;
    var width = rect.width;
    var halfHeight = height / 2;
    var x = rect.x;
    var y = rect.y;
    var textAlign = "left";
    var textVerticalAlign = "top";
    if (textPosition instanceof Array) {
        x += $6c308355c7107803$export$e8514cb5a5e2b40f(textPosition[0], rect.width);
        y += $6c308355c7107803$export$e8514cb5a5e2b40f(textPosition[1], rect.height);
        textAlign = null;
        textVerticalAlign = null;
    } else switch(textPosition){
        case "left":
            x -= distance;
            y += halfHeight;
            textAlign = "right";
            textVerticalAlign = "middle";
            break;
        case "right":
            x += distance + width;
            y += halfHeight;
            textVerticalAlign = "middle";
            break;
        case "top":
            x += width / 2;
            y -= distance;
            textAlign = "center";
            textVerticalAlign = "bottom";
            break;
        case "bottom":
            x += width / 2;
            y += height + distance;
            textAlign = "center";
            break;
        case "inside":
            x += width / 2;
            y += halfHeight;
            textAlign = "center";
            textVerticalAlign = "middle";
            break;
        case "insideLeft":
            x += distance;
            y += halfHeight;
            textVerticalAlign = "middle";
            break;
        case "insideRight":
            x += width - distance;
            y += halfHeight;
            textAlign = "right";
            textVerticalAlign = "middle";
            break;
        case "insideTop":
            x += width / 2;
            y += distance;
            textAlign = "center";
            break;
        case "insideBottom":
            x += width / 2;
            y += height - distance;
            textAlign = "center";
            textVerticalAlign = "bottom";
            break;
        case "insideTopLeft":
            x += distance;
            y += distance;
            break;
        case "insideTopRight":
            x += width - distance;
            y += distance;
            textAlign = "right";
            break;
        case "insideBottomLeft":
            x += distance;
            y += height - distance;
            textVerticalAlign = "bottom";
            break;
        case "insideBottomRight":
            x += width - distance;
            y += height - distance;
            textAlign = "right";
            textVerticalAlign = "bottom";
            break;
    }
    out = out || {};
    out.x = x;
    out.y = y;
    out.align = textAlign;
    out.verticalAlign = textVerticalAlign;
    return out;
}







var $4bb0f26b847654d5$export$97b5e845c7286801 = "__zr_normal__";
var $4bb0f26b847654d5$var$PRIMARY_STATES_KEYS = (0, $becf2d727f9cf450$export$98ab6203ec3396e2).concat([
    "ignore"
]);
var $4bb0f26b847654d5$var$DEFAULT_ANIMATABLE_MAP = (0, $7a1bd9c2710fea0d$export$533b26079ad0b4b)((0, $becf2d727f9cf450$export$98ab6203ec3396e2), function(obj, key) {
    obj[key] = true;
    return obj;
}, {
    ignore: false
});
var $4bb0f26b847654d5$var$tmpTextPosCalcRes = {};
var $4bb0f26b847654d5$var$tmpBoundingRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $4bb0f26b847654d5$var$tmpInnerTextTrans = [];
var $4bb0f26b847654d5$var$Element = function() {
    function Element(props) {
        this.id = (0, $7a1bd9c2710fea0d$export$46e8f25c7328f77e)();
        this.animators = [];
        this.currentStates = [];
        this.states = {};
        this._init(props);
    }
    Element.prototype._init = function(props) {
        this.attr(props);
    };
    Element.prototype.drift = function(dx, dy, e) {
        switch(this.draggable){
            case "horizontal":
                dy = 0;
                break;
            case "vertical":
                dx = 0;
                break;
        }
        var m = this.transform;
        if (!m) m = this.transform = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        m[4] += dx;
        m[5] += dy;
        this.decomposeTransform();
        this.markRedraw();
    };
    Element.prototype.beforeUpdate = function() {};
    Element.prototype.afterUpdate = function() {};
    Element.prototype.update = function() {
        this.updateTransform();
        if (this.__dirty) this.updateInnerText();
    };
    Element.prototype.updateInnerText = function(forceUpdate) {
        var textEl = this._textContent;
        if (textEl && (!textEl.ignore || forceUpdate)) {
            if (!this.textConfig) this.textConfig = {};
            var textConfig = this.textConfig;
            var isLocal = textConfig.local;
            var innerTransformable = textEl.innerTransformable;
            var textAlign = void 0;
            var textVerticalAlign = void 0;
            var textStyleChanged = false;
            innerTransformable.parent = isLocal ? this : null;
            var innerOrigin = false;
            innerTransformable.copyTransform(textEl);
            var hasPosition = textConfig.position != null;
            var autoOverflowArea = textConfig.autoOverflowArea;
            var layoutRect = void 0;
            if (autoOverflowArea || hasPosition) {
                layoutRect = $4bb0f26b847654d5$var$tmpBoundingRect;
                if (textConfig.layoutRect) layoutRect.copy(textConfig.layoutRect);
                else layoutRect.copy(this.getBoundingRect());
                if (!isLocal) layoutRect.applyTransform(this.transform);
            }
            if (hasPosition) {
                if (this.calculateTextPosition) this.calculateTextPosition($4bb0f26b847654d5$var$tmpTextPosCalcRes, textConfig, layoutRect);
                else (0, $6c308355c7107803$export$eee3603b512feab7)($4bb0f26b847654d5$var$tmpTextPosCalcRes, textConfig, layoutRect);
                innerTransformable.x = $4bb0f26b847654d5$var$tmpTextPosCalcRes.x;
                innerTransformable.y = $4bb0f26b847654d5$var$tmpTextPosCalcRes.y;
                textAlign = $4bb0f26b847654d5$var$tmpTextPosCalcRes.align;
                textVerticalAlign = $4bb0f26b847654d5$var$tmpTextPosCalcRes.verticalAlign;
                var textOrigin = textConfig.origin;
                if (textOrigin && textConfig.rotation != null) {
                    var relOriginX = void 0;
                    var relOriginY = void 0;
                    if (textOrigin === "center") {
                        relOriginX = layoutRect.width * 0.5;
                        relOriginY = layoutRect.height * 0.5;
                    } else {
                        relOriginX = (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(textOrigin[0], layoutRect.width);
                        relOriginY = (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(textOrigin[1], layoutRect.height);
                    }
                    innerOrigin = true;
                    innerTransformable.originX = -innerTransformable.x + relOriginX + (isLocal ? 0 : layoutRect.x);
                    innerTransformable.originY = -innerTransformable.y + relOriginY + (isLocal ? 0 : layoutRect.y);
                }
            }
            if (textConfig.rotation != null) innerTransformable.rotation = textConfig.rotation;
            var textOffset = textConfig.offset;
            if (textOffset) {
                innerTransformable.x += textOffset[0];
                innerTransformable.y += textOffset[1];
                if (!innerOrigin) {
                    innerTransformable.originX = -textOffset[0];
                    innerTransformable.originY = -textOffset[1];
                }
            }
            var innerTextDefaultStyle = this._innerTextDefaultStyle || (this._innerTextDefaultStyle = {});
            if (autoOverflowArea) {
                var overflowRect = innerTextDefaultStyle.overflowRect = innerTextDefaultStyle.overflowRect || new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
                innerTransformable.getLocalTransform($4bb0f26b847654d5$var$tmpInnerTextTrans);
                (0, $f41ebb9dd60b55b4$export$6897c284b6f9f4dc)($4bb0f26b847654d5$var$tmpInnerTextTrans, $4bb0f26b847654d5$var$tmpInnerTextTrans);
                (0, $1bebe7106c895823$export$2e2bcd8739ae039).copy(overflowRect, layoutRect);
                overflowRect.applyTransform($4bb0f26b847654d5$var$tmpInnerTextTrans);
            } else innerTextDefaultStyle.overflowRect = null;
            var isInside = textConfig.inside == null ? typeof textConfig.position === "string" && textConfig.position.indexOf("inside") >= 0 : textConfig.inside;
            var textFill = void 0;
            var textStroke = void 0;
            var autoStroke = void 0;
            if (isInside && this.canBeInsideText()) {
                textFill = textConfig.insideFill;
                textStroke = textConfig.insideStroke;
                if (textFill == null || textFill === "auto") textFill = this.getInsideTextFill();
                if (textStroke == null || textStroke === "auto") {
                    textStroke = this.getInsideTextStroke(textFill);
                    autoStroke = true;
                }
            } else {
                textFill = textConfig.outsideFill;
                textStroke = textConfig.outsideStroke;
                if (textFill == null || textFill === "auto") textFill = this.getOutsideFill();
                if (textStroke == null || textStroke === "auto") {
                    textStroke = this.getOutsideStroke(textFill);
                    autoStroke = true;
                }
            }
            textFill = textFill || "#000";
            if (textFill !== innerTextDefaultStyle.fill || textStroke !== innerTextDefaultStyle.stroke || autoStroke !== innerTextDefaultStyle.autoStroke || textAlign !== innerTextDefaultStyle.align || textVerticalAlign !== innerTextDefaultStyle.verticalAlign) {
                textStyleChanged = true;
                innerTextDefaultStyle.fill = textFill;
                innerTextDefaultStyle.stroke = textStroke;
                innerTextDefaultStyle.autoStroke = autoStroke;
                innerTextDefaultStyle.align = textAlign;
                innerTextDefaultStyle.verticalAlign = textVerticalAlign;
                textEl.setDefaultTextStyle(innerTextDefaultStyle);
            }
            textEl.__dirty |= (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
            if (textStyleChanged) textEl.dirtyStyle(true);
        }
    };
    Element.prototype.canBeInsideText = function() {
        return true;
    };
    Element.prototype.getInsideTextFill = function() {
        return "#fff";
    };
    Element.prototype.getInsideTextStroke = function(textFill) {
        return "#000";
    };
    Element.prototype.getOutsideFill = function() {
        return this.__zr && this.__zr.isDarkMode() ? (0, $4b0cedd85979c776$export$3c6e95f318c8369b) : (0, $4b0cedd85979c776$export$f8ce94761f39398d);
    };
    Element.prototype.getOutsideStroke = function(textFill) {
        var backgroundColor = this.__zr && this.__zr.getBackgroundColor();
        var colorArr = typeof backgroundColor === "string" && (0, $2c037f5bda6341ca$export$98e6a39c04603d36)(backgroundColor);
        if (!colorArr) colorArr = [
            255,
            255,
            255,
            1
        ];
        var alpha = colorArr[3];
        var isDark = this.__zr.isDarkMode();
        for(var i = 0; i < 3; i++)colorArr[i] = colorArr[i] * alpha + (isDark ? 0 : 255) * (1 - alpha);
        colorArr[3] = 1;
        return (0, $2c037f5bda6341ca$export$fac44ee5b035f737)(colorArr, "rgba");
    };
    Element.prototype.traverse = function(cb, context) {};
    Element.prototype.attrKV = function(key, value) {
        if (key === "textConfig") this.setTextConfig(value);
        else if (key === "textContent") this.setTextContent(value);
        else if (key === "clipPath") this.setClipPath(value);
        else if (key === "extra") {
            this.extra = this.extra || {};
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(this.extra, value);
        } else this[key] = value;
    };
    Element.prototype.hide = function() {
        this.ignore = true;
        this.markRedraw();
    };
    Element.prototype.show = function() {
        this.ignore = false;
        this.markRedraw();
    };
    Element.prototype.attr = function(keyOrObj, value) {
        if (typeof keyOrObj === "string") this.attrKV(keyOrObj, value);
        else if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(keyOrObj)) {
            var obj = keyOrObj;
            var keysArr = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(obj);
            for(var i = 0; i < keysArr.length; i++){
                var key = keysArr[i];
                this.attrKV(key, keyOrObj[key]);
            }
        }
        this.markRedraw();
        return this;
    };
    Element.prototype.saveCurrentToNormalState = function(toState) {
        this._innerSaveToNormal(toState);
        var normalState = this._normalState;
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var fromStateTransition = animator.__fromStateTransition;
            if (animator.getLoop() || fromStateTransition && fromStateTransition !== $4bb0f26b847654d5$export$97b5e845c7286801) continue;
            var targetName = animator.targetName;
            var target = targetName ? normalState[targetName] : normalState;
            animator.saveTo(target);
        }
    };
    Element.prototype._innerSaveToNormal = function(toState) {
        var normalState = this._normalState;
        if (!normalState) normalState = this._normalState = {};
        if (toState.textConfig && !normalState.textConfig) normalState.textConfig = this.textConfig;
        this._savePrimaryToNormal(toState, normalState, $4bb0f26b847654d5$var$PRIMARY_STATES_KEYS);
    };
    Element.prototype._savePrimaryToNormal = function(toState, normalState, primaryKeys) {
        for(var i = 0; i < primaryKeys.length; i++){
            var key = primaryKeys[i];
            if (toState[key] != null && !(key in normalState)) normalState[key] = this[key];
        }
    };
    Element.prototype.hasState = function() {
        return this.currentStates.length > 0;
    };
    Element.prototype.getState = function(name) {
        return this.states[name];
    };
    Element.prototype.ensureState = function(name) {
        var states = this.states;
        if (!states[name]) states[name] = {};
        return states[name];
    };
    Element.prototype.clearStates = function(noAnimation) {
        this.useState($4bb0f26b847654d5$export$97b5e845c7286801, false, noAnimation);
    };
    Element.prototype.useState = function(stateName, keepCurrentStates, noAnimation, forceUseHoverLayer) {
        var toNormalState = stateName === $4bb0f26b847654d5$export$97b5e845c7286801;
        var hasStates = this.hasState();
        if (!hasStates && toNormalState) return;
        var currentStates = this.currentStates;
        var animationCfg = this.stateTransition;
        if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(currentStates, stateName) >= 0 && (keepCurrentStates || currentStates.length === 1)) return;
        var state;
        if (this.stateProxy && !toNormalState) state = this.stateProxy(stateName);
        if (!state) state = this.states && this.states[stateName];
        if (!state && !toNormalState) {
            (0, $7a1bd9c2710fea0d$export$58da9968c3170cb1)("State " + stateName + " not exists.");
            return;
        }
        if (!toNormalState) this.saveCurrentToNormalState(state);
        var useHoverLayer = !!(state && state.hoverLayer || forceUseHoverLayer);
        if (useHoverLayer) this._toggleHoverLayerFlag(true);
        this._applyStateObj(stateName, state, this._normalState, keepCurrentStates, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
        var textContent = this._textContent;
        var textGuide = this._textGuide;
        if (textContent) textContent.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
        if (textGuide) textGuide.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
        if (toNormalState) {
            this.currentStates = [];
            this._normalState = {};
        } else if (!keepCurrentStates) this.currentStates = [
            stateName
        ];
        else this.currentStates.push(stateName);
        this._updateAnimationTargets();
        this.markRedraw();
        if (!useHoverLayer && this.__inHover) {
            this._toggleHoverLayerFlag(false);
            this.__dirty &= ~(0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
        }
        return state;
    };
    Element.prototype.useStates = function(states, noAnimation, forceUseHoverLayer) {
        if (!states.length) this.clearStates();
        else {
            var stateObjects = [];
            var currentStates = this.currentStates;
            var len = states.length;
            var notChange = len === currentStates.length;
            if (notChange) {
                for(var i = 0; i < len; i++)if (states[i] !== currentStates[i]) {
                    notChange = false;
                    break;
                }
            }
            if (notChange) return;
            for(var i = 0; i < len; i++){
                var stateName = states[i];
                var stateObj = void 0;
                if (this.stateProxy) stateObj = this.stateProxy(stateName, states);
                if (!stateObj) stateObj = this.states[stateName];
                if (stateObj) stateObjects.push(stateObj);
            }
            var lastStateObj = stateObjects[len - 1];
            var useHoverLayer = !!(lastStateObj && lastStateObj.hoverLayer || forceUseHoverLayer);
            if (useHoverLayer) this._toggleHoverLayerFlag(true);
            var mergedState = this._mergeStates(stateObjects);
            var animationCfg = this.stateTransition;
            this.saveCurrentToNormalState(mergedState);
            this._applyStateObj(states.join(","), mergedState, this._normalState, false, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
            var textContent = this._textContent;
            var textGuide = this._textGuide;
            if (textContent) textContent.useStates(states, noAnimation, useHoverLayer);
            if (textGuide) textGuide.useStates(states, noAnimation, useHoverLayer);
            this._updateAnimationTargets();
            this.currentStates = states.slice();
            this.markRedraw();
            if (!useHoverLayer && this.__inHover) {
                this._toggleHoverLayerFlag(false);
                this.__dirty &= ~(0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
            }
        }
    };
    Element.prototype.isSilent = function() {
        var el = this;
        while(el){
            if (el.silent) return true;
            var hostEl = el.__hostTarget;
            el = hostEl ? el.ignoreHostSilent ? null : hostEl : el.parent;
        }
        return false;
    };
    Element.prototype._updateAnimationTargets = function() {
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            if (animator.targetName) animator.changeTarget(this[animator.targetName]);
        }
    };
    Element.prototype.removeState = function(state) {
        var idx = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(this.currentStates, state);
        if (idx >= 0) {
            var currentStates = this.currentStates.slice();
            currentStates.splice(idx, 1);
            this.useStates(currentStates);
        }
    };
    Element.prototype.replaceState = function(oldState, newState, forceAdd) {
        var currentStates = this.currentStates.slice();
        var idx = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(currentStates, oldState);
        var newStateExists = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(currentStates, newState) >= 0;
        if (idx >= 0) {
            if (!newStateExists) currentStates[idx] = newState;
            else currentStates.splice(idx, 1);
        } else if (forceAdd && !newStateExists) currentStates.push(newState);
        this.useStates(currentStates);
    };
    Element.prototype.toggleState = function(state, enable) {
        if (enable) this.useState(state, true);
        else this.removeState(state);
    };
    Element.prototype._mergeStates = function(states) {
        var mergedState = {};
        var mergedTextConfig;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(mergedState, state);
            if (state.textConfig) {
                mergedTextConfig = mergedTextConfig || {};
                (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(mergedTextConfig, state.textConfig);
            }
        }
        if (mergedTextConfig) mergedState.textConfig = mergedTextConfig;
        return mergedState;
    };
    Element.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        var needsRestoreToNormal = !(state && keepCurrentStates);
        if (state && state.textConfig) {
            this.textConfig = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, keepCurrentStates ? this.textConfig : normalState.textConfig);
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(this.textConfig, state.textConfig);
        } else if (needsRestoreToNormal) {
            if (normalState.textConfig) this.textConfig = normalState.textConfig;
        }
        var transitionTarget = {};
        var hasTransition = false;
        for(var i = 0; i < $4bb0f26b847654d5$var$PRIMARY_STATES_KEYS.length; i++){
            var key = $4bb0f26b847654d5$var$PRIMARY_STATES_KEYS[i];
            var propNeedsTransition = transition && $4bb0f26b847654d5$var$DEFAULT_ANIMATABLE_MAP[key];
            if (state && state[key] != null) {
                if (propNeedsTransition) {
                    hasTransition = true;
                    transitionTarget[key] = state[key];
                } else this[key] = state[key];
            } else if (needsRestoreToNormal) {
                if (normalState[key] != null) {
                    if (propNeedsTransition) {
                        hasTransition = true;
                        transitionTarget[key] = normalState[key];
                    } else this[key] = normalState[key];
                }
            }
        }
        if (!transition) for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var targetName = animator.targetName;
            if (!animator.getLoop()) animator.__changeFinalValue(targetName ? (state || normalState)[targetName] : state || normalState);
        }
        if (hasTransition) this._transitionState(stateName, transitionTarget, animationCfg);
    };
    Element.prototype._attachComponent = function(componentEl) {
        if (componentEl.__zr && !componentEl.__hostTarget) return;
        if (componentEl === this) return;
        var zr = this.__zr;
        if (zr) componentEl.addSelfToZr(zr);
        componentEl.__zr = zr;
        componentEl.__hostTarget = this;
    };
    Element.prototype._detachComponent = function(componentEl) {
        if (componentEl.__zr) componentEl.removeSelfFromZr(componentEl.__zr);
        componentEl.__zr = null;
        componentEl.__hostTarget = null;
    };
    Element.prototype.getClipPath = function() {
        return this._clipPath;
    };
    Element.prototype.setClipPath = function(clipPath) {
        if (this._clipPath && this._clipPath !== clipPath) this.removeClipPath();
        this._attachComponent(clipPath);
        this._clipPath = clipPath;
        this.markRedraw();
    };
    Element.prototype.removeClipPath = function() {
        var clipPath = this._clipPath;
        if (clipPath) {
            this._detachComponent(clipPath);
            this._clipPath = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextContent = function() {
        return this._textContent;
    };
    Element.prototype.setTextContent = function(textEl) {
        var previousTextContent = this._textContent;
        if (previousTextContent === textEl) return;
        if (previousTextContent && previousTextContent !== textEl) this.removeTextContent();
        textEl.innerTransformable = new (0, $becf2d727f9cf450$export$2e2bcd8739ae039)();
        this._attachComponent(textEl);
        this._textContent = textEl;
        this.markRedraw();
    };
    Element.prototype.setTextConfig = function(cfg) {
        if (!this.textConfig) this.textConfig = {};
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(this.textConfig, cfg);
        this.markRedraw();
    };
    Element.prototype.removeTextConfig = function() {
        this.textConfig = null;
        this.markRedraw();
    };
    Element.prototype.removeTextContent = function() {
        var textEl = this._textContent;
        if (textEl) {
            textEl.innerTransformable = null;
            this._detachComponent(textEl);
            this._textContent = null;
            this._innerTextDefaultStyle = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextGuideLine = function() {
        return this._textGuide;
    };
    Element.prototype.setTextGuideLine = function(guideLine) {
        if (this._textGuide && this._textGuide !== guideLine) this.removeTextGuideLine();
        this._attachComponent(guideLine);
        this._textGuide = guideLine;
        this.markRedraw();
    };
    Element.prototype.removeTextGuideLine = function() {
        var textGuide = this._textGuide;
        if (textGuide) {
            this._detachComponent(textGuide);
            this._textGuide = null;
            this.markRedraw();
        }
    };
    Element.prototype.markRedraw = function() {
        this.__dirty |= (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
        var zr = this.__zr;
        if (zr) {
            if (this.__inHover) zr.refreshHover();
            else zr.refresh();
        }
        if (this.__hostTarget) this.__hostTarget.markRedraw();
    };
    Element.prototype.dirty = function() {
        this.markRedraw();
    };
    Element.prototype._toggleHoverLayerFlag = function(inHover) {
        this.__inHover = inHover;
        var textContent = this._textContent;
        var textGuide = this._textGuide;
        if (textContent) textContent.__inHover = inHover;
        if (textGuide) textGuide.__inHover = inHover;
    };
    Element.prototype.addSelfToZr = function(zr) {
        if (this.__zr === zr) return;
        this.__zr = zr;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.addAnimator(animators[i]);
        if (this._clipPath) this._clipPath.addSelfToZr(zr);
        if (this._textContent) this._textContent.addSelfToZr(zr);
        if (this._textGuide) this._textGuide.addSelfToZr(zr);
    };
    Element.prototype.removeSelfFromZr = function(zr) {
        if (!this.__zr) return;
        this.__zr = null;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.removeAnimator(animators[i]);
        if (this._clipPath) this._clipPath.removeSelfFromZr(zr);
        if (this._textContent) this._textContent.removeSelfFromZr(zr);
        if (this._textGuide) this._textGuide.removeSelfFromZr(zr);
    };
    Element.prototype.animate = function(key, loop, allowDiscreteAnimation) {
        var target = key ? this[key] : this;
        var animator = new (0, $76d8a142a20276fc$export$2e2bcd8739ae039)(target, loop, allowDiscreteAnimation);
        key && (animator.targetName = key);
        this.addAnimator(animator, key);
        return animator;
    };
    Element.prototype.addAnimator = function(animator, key) {
        var zr = this.__zr;
        var el = this;
        animator.during(function() {
            el.updateDuringAnimation(key);
        }).done(function() {
            var animators = el.animators;
            var idx = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(animators, animator);
            if (idx >= 0) animators.splice(idx, 1);
        });
        this.animators.push(animator);
        if (zr) zr.animation.addAnimator(animator);
        zr && zr.wakeUp();
    };
    Element.prototype.updateDuringAnimation = function(key) {
        this.markRedraw();
    };
    Element.prototype.stopAnimation = function(scope, forwardToLast) {
        var animators = this.animators;
        var len = animators.length;
        var leftAnimators = [];
        for(var i = 0; i < len; i++){
            var animator = animators[i];
            if (!scope || scope === animator.scope) animator.stop(forwardToLast);
            else leftAnimators.push(animator);
        }
        this.animators = leftAnimators;
        return this;
    };
    Element.prototype.animateTo = function(target, cfg, animationProps) {
        $4bb0f26b847654d5$var$animateTo(this, target, cfg, animationProps);
    };
    Element.prototype.animateFrom = function(target, cfg, animationProps) {
        $4bb0f26b847654d5$var$animateTo(this, target, cfg, animationProps, true);
    };
    Element.prototype._transitionState = function(stateName, target, cfg, animationProps) {
        var animators = $4bb0f26b847654d5$var$animateTo(this, target, cfg, animationProps);
        for(var i = 0; i < animators.length; i++)animators[i].__fromStateTransition = stateName;
    };
    Element.prototype.getBoundingRect = function() {
        return null;
    };
    Element.prototype.getPaintRect = function() {
        return null;
    };
    Element.initDefaultProps = function() {
        var elProto = Element.prototype;
        elProto.type = "element";
        elProto.name = "";
        elProto.ignore = elProto.silent = elProto.ignoreHostSilent = elProto.isGroup = elProto.draggable = elProto.dragging = elProto.ignoreClip = elProto.__inHover = false;
        elProto.__dirty = (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
        var logs = {};
        function logDeprecatedError(key, xKey, yKey) {
            if (!logs[key + xKey + yKey]) {
                console.warn("DEPRECATED: '" + key + "' has been deprecated. use '" + xKey + "', '" + yKey + "' instead");
                logs[key + xKey + yKey] = true;
            }
        }
        function createLegacyProperty(key, privateKey, xKey, yKey) {
            Object.defineProperty(elProto, key, {
                get: function() {
                    if (!this[privateKey]) {
                        var pos = this[privateKey] = [];
                        enhanceArray(this, pos);
                    }
                    return this[privateKey];
                },
                set: function(pos) {
                    this[xKey] = pos[0];
                    this[yKey] = pos[1];
                    this[privateKey] = pos;
                    enhanceArray(this, pos);
                }
            });
            function enhanceArray(self, pos) {
                Object.defineProperty(pos, 0, {
                    get: function() {
                        return self[xKey];
                    },
                    set: function(val) {
                        self[xKey] = val;
                    }
                });
                Object.defineProperty(pos, 1, {
                    get: function() {
                        return self[yKey];
                    },
                    set: function(val) {
                        self[yKey] = val;
                    }
                });
            }
        }
        if (Object.defineProperty) {
            createLegacyProperty("position", "_legacyPos", "x", "y");
            createLegacyProperty("scale", "_legacyScale", "scaleX", "scaleY");
            createLegacyProperty("origin", "_legacyOrigin", "originX", "originY");
        }
    }();
    return Element;
}();
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($4bb0f26b847654d5$var$Element, (0, $63441a86293f101f$export$2e2bcd8739ae039));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($4bb0f26b847654d5$var$Element, (0, $becf2d727f9cf450$export$2e2bcd8739ae039));
function $4bb0f26b847654d5$var$animateTo(animatable, target, cfg, animationProps, reverse) {
    cfg = cfg || {};
    var animators = [];
    $4bb0f26b847654d5$var$animateToShallow(animatable, "", animatable, target, cfg, animationProps, animators, reverse);
    var finishCount = animators.length;
    var doneHappened = false;
    var cfgDone = cfg.done;
    var cfgAborted = cfg.aborted;
    var doneCb = function() {
        doneHappened = true;
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    var abortedCb = function() {
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    if (!finishCount) cfgDone && cfgDone();
    if (animators.length > 0 && cfg.during) animators[0].during(function(target, percent) {
        cfg.during(percent);
    });
    for(var i = 0; i < animators.length; i++){
        var animator = animators[i];
        if (doneCb) animator.done(doneCb);
        if (abortedCb) animator.aborted(abortedCb);
        if (cfg.force) animator.duration(cfg.duration);
        animator.start(cfg.easing);
    }
    return animators;
}
function $4bb0f26b847654d5$var$copyArrShallow(source, target, len) {
    for(var i = 0; i < len; i++)source[i] = target[i];
}
function $4bb0f26b847654d5$var$is2DArray(value) {
    return (0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(value[0]);
}
function $4bb0f26b847654d5$var$copyValue(target, source, key) {
    if ((0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(source[key])) {
        if (!(0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(target[key])) target[key] = [];
        if ((0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(source[key])) {
            var len = source[key].length;
            if (target[key].length !== len) {
                target[key] = new source[key].constructor(len);
                $4bb0f26b847654d5$var$copyArrShallow(target[key], source[key], len);
            }
        } else {
            var sourceArr = source[key];
            var targetArr = target[key];
            var len0 = sourceArr.length;
            if ($4bb0f26b847654d5$var$is2DArray(sourceArr)) {
                var len1 = sourceArr[0].length;
                for(var i = 0; i < len0; i++)if (!targetArr[i]) targetArr[i] = Array.prototype.slice.call(sourceArr[i]);
                else $4bb0f26b847654d5$var$copyArrShallow(targetArr[i], sourceArr[i], len1);
            } else $4bb0f26b847654d5$var$copyArrShallow(targetArr, sourceArr, len0);
            targetArr.length = sourceArr.length;
        }
    } else target[key] = source[key];
}
function $4bb0f26b847654d5$var$isValueSame(val1, val2) {
    return val1 === val2 || (0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(val1) && (0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(val2) && $4bb0f26b847654d5$var$is1DArraySame(val1, val2);
}
function $4bb0f26b847654d5$var$is1DArraySame(arr0, arr1) {
    var len = arr0.length;
    if (len !== arr1.length) return false;
    for(var i = 0; i < len; i++){
        if (arr0[i] !== arr1[i]) return false;
    }
    return true;
}
function $4bb0f26b847654d5$var$animateToShallow(animatable, topKey, animateObj, target, cfg, animationProps, animators, reverse) {
    var targetKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(target);
    var duration = cfg.duration;
    var delay = cfg.delay;
    var additive = cfg.additive;
    var setToFinal = cfg.setToFinal;
    var animateAll = !(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(animationProps);
    var existsAnimators = animatable.animators;
    var animationKeys = [];
    for(var k = 0; k < targetKeys.length; k++){
        var innerKey = targetKeys[k];
        var targetVal = target[innerKey];
        if (targetVal != null && animateObj[innerKey] != null && (animateAll || animationProps[innerKey])) {
            if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(targetVal) && !(0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(targetVal) && !(0, $7a1bd9c2710fea0d$export$fa2c283003ed971c)(targetVal)) {
                if (topKey) {
                    if (!reverse) {
                        animateObj[innerKey] = targetVal;
                        animatable.updateDuringAnimation(topKey);
                    }
                    continue;
                }
                $4bb0f26b847654d5$var$animateToShallow(animatable, innerKey, animateObj[innerKey], targetVal, cfg, animationProps && animationProps[innerKey], animators, reverse);
            } else animationKeys.push(innerKey);
        } else if (!reverse) {
            animateObj[innerKey] = targetVal;
            animatable.updateDuringAnimation(topKey);
            animationKeys.push(innerKey);
        }
    }
    var keyLen = animationKeys.length;
    if (!additive && keyLen) for(var i = 0; i < existsAnimators.length; i++){
        var animator = existsAnimators[i];
        if (animator.targetName === topKey) {
            var allAborted = animator.stopTracks(animationKeys);
            if (allAborted) {
                var idx = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(existsAnimators, animator);
                existsAnimators.splice(idx, 1);
            }
        }
    }
    if (!cfg.force) {
        animationKeys = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(animationKeys, function(key) {
            return !$4bb0f26b847654d5$var$isValueSame(target[key], animateObj[key]);
        });
        keyLen = animationKeys.length;
    }
    if (keyLen > 0 || cfg.force && !animators.length) {
        var revertedSource = void 0;
        var reversedTarget = void 0;
        var sourceClone = void 0;
        if (reverse) {
            reversedTarget = {};
            if (setToFinal) revertedSource = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animationKeys[i];
                reversedTarget[innerKey] = animateObj[innerKey];
                if (setToFinal) revertedSource[innerKey] = target[innerKey];
                else animateObj[innerKey] = target[innerKey];
            }
        } else if (setToFinal) {
            sourceClone = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animationKeys[i];
                sourceClone[innerKey] = (0, $76d8a142a20276fc$export$c5e92b7f105af84e)(animateObj[innerKey]);
                $4bb0f26b847654d5$var$copyValue(animateObj, target, innerKey);
            }
        }
        var animator = new (0, $76d8a142a20276fc$export$2e2bcd8739ae039)(animateObj, false, false, additive ? (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(existsAnimators, function(animator) {
            return animator.targetName === topKey;
        }) : null);
        animator.targetName = topKey;
        if (cfg.scope) animator.scope = cfg.scope;
        if (setToFinal && revertedSource) animator.whenWithKeys(0, revertedSource, animationKeys);
        if (sourceClone) animator.whenWithKeys(0, sourceClone, animationKeys);
        animator.whenWithKeys(duration == null ? 500 : duration, reverse ? reversedTarget : target, animationKeys).delay(delay || 0);
        animatable.addAnimator(animator, topKey);
        animators.push(animator);
    }
}
var $4bb0f26b847654d5$export$2e2bcd8739ae039 = $4bb0f26b847654d5$var$Element;



var $7ef7583d8302ffce$var$Group = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Group, _super);
    function Group(opts) {
        var _this = _super.call(this) || this;
        _this.isGroup = true;
        _this._children = [];
        _this.attr(opts);
        return _this;
    }
    Group.prototype.childrenRef = function() {
        return this._children;
    };
    Group.prototype.children = function() {
        return this._children.slice();
    };
    Group.prototype.childAt = function(idx) {
        return this._children[idx];
    };
    Group.prototype.childOfName = function(name) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            if (children[i].name === name) return children[i];
        }
    };
    Group.prototype.childCount = function() {
        return this._children.length;
    };
    Group.prototype.add = function(child) {
        if (child) {
            if (child !== this && child.parent !== this) {
                this._children.push(child);
                this._doAdd(child);
            }
        }
        return this;
    };
    Group.prototype.addBefore = function(child, nextSibling) {
        if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
            var children = this._children;
            var idx = children.indexOf(nextSibling);
            if (idx >= 0) {
                children.splice(idx, 0, child);
                this._doAdd(child);
            }
        }
        return this;
    };
    Group.prototype.replace = function(oldChild, newChild) {
        var idx = $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(this._children, oldChild);
        if (idx >= 0) this.replaceAt(newChild, idx);
        return this;
    };
    Group.prototype.replaceAt = function(child, index) {
        var children = this._children;
        var old = children[index];
        if (child && child !== this && child.parent !== this && child !== old) {
            children[index] = child;
            old.parent = null;
            var zr = this.__zr;
            if (zr) old.removeSelfFromZr(zr);
            this._doAdd(child);
        }
        return this;
    };
    Group.prototype._doAdd = function(child) {
        if (child.parent) child.parent.remove(child);
        child.parent = this;
        var zr = this.__zr;
        if (zr && zr !== child.__zr) child.addSelfToZr(zr);
        zr && zr.refresh();
    };
    Group.prototype.remove = function(child) {
        var zr = this.__zr;
        var children = this._children;
        var idx = $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(children, child);
        if (idx < 0) return this;
        children.splice(idx, 1);
        child.parent = null;
        if (zr) child.removeSelfFromZr(zr);
        zr && zr.refresh();
        return this;
    };
    Group.prototype.removeAll = function() {
        var children = this._children;
        var zr = this.__zr;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (zr) child.removeSelfFromZr(zr);
            child.parent = null;
        }
        children.length = 0;
        return this;
    };
    Group.prototype.eachChild = function(cb, context) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            cb.call(context, child, i);
        }
        return this;
    };
    Group.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            var stopped = cb.call(context, child);
            if (child.isGroup && !stopped) child.traverse(cb, context);
        }
        return this;
    };
    Group.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.addSelfToZr(zr);
        }
    };
    Group.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.removeSelfFromZr(zr);
        }
    };
    Group.prototype.getBoundingRect = function(includeChildren) {
        var tmpRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
        var children = includeChildren || this._children;
        var tmpMat = [];
        var rect = null;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (child.ignore || child.invisible) continue;
            var childRect = child.getBoundingRect();
            var transform = child.getLocalTransform(tmpMat);
            if (transform) {
                (0, $1bebe7106c895823$export$2e2bcd8739ae039).applyTransform(tmpRect, childRect, transform);
                rect = rect || tmpRect.clone();
                rect.union(tmpRect);
            } else {
                rect = rect || childRect.clone();
                rect.union(childRect);
            }
        }
        return rect || tmpRect;
    };
    return Group;
}((0, $4bb0f26b847654d5$export$2e2bcd8739ae039));
$7ef7583d8302ffce$var$Group.prototype.type = "group";
var $7ef7583d8302ffce$export$2e2bcd8739ae039 = $7ef7583d8302ffce$var$Group;


var $6eba88f9eebe6af9$var$painterCtors = {};
var $6eba88f9eebe6af9$var$instances = {};
function $6eba88f9eebe6af9$var$delInstance(id) {
    delete $6eba88f9eebe6af9$var$instances[id];
}
function $6eba88f9eebe6af9$var$isDarkMode(backgroundColor) {
    if (!backgroundColor) return false;
    if (typeof backgroundColor === "string") return (0, $2c037f5bda6341ca$export$16c0ec21a6f9ef95)(backgroundColor, 1) < (0, $4b0cedd85979c776$export$fd81e7ebc7dae256);
    else if (backgroundColor.colorStops) {
        var colorStops = backgroundColor.colorStops;
        var totalLum = 0;
        var len = colorStops.length;
        for(var i = 0; i < len; i++)totalLum += (0, $2c037f5bda6341ca$export$16c0ec21a6f9ef95)(colorStops[i].color, 1);
        totalLum /= len;
        return totalLum < (0, $4b0cedd85979c776$export$fd81e7ebc7dae256);
    }
    return false;
}
var $6eba88f9eebe6af9$var$ZRender = function() {
    function ZRender(id, dom, opts) {
        var _this = this;
        this._sleepAfterStill = 10;
        this._stillFrameAccum = 0;
        this._needsRefresh = true;
        this._needsRefreshHover = true;
        this._darkMode = false;
        opts = opts || {};
        this.dom = dom;
        this.id = id;
        var storage = new (0, $319574df0bc66e80$export$2e2bcd8739ae039)();
        var rendererType = opts.renderer || "canvas";
        if (!$6eba88f9eebe6af9$var$painterCtors[rendererType]) rendererType = $7a1bd9c2710fea0d$export$ed97f33186d4b816($6eba88f9eebe6af9$var$painterCtors)[0];
        opts.useDirtyRect = opts.useDirtyRect == null ? false : opts.useDirtyRect;
        var painter = new $6eba88f9eebe6af9$var$painterCtors[rendererType](dom, storage, opts, id);
        var ssrMode = opts.ssr || painter.ssrOnly;
        this.storage = storage;
        this.painter = painter;
        var handlerProxy = !(0, $ce6dd58693a21851$export$2e2bcd8739ae039).node && !(0, $ce6dd58693a21851$export$2e2bcd8739ae039).worker && !ssrMode ? new (0, $c0dbbc6989260eee$export$2e2bcd8739ae039)(painter.getViewportRoot(), painter.root) : null;
        var useCoarsePointer = opts.useCoarsePointer;
        var usePointerSize = useCoarsePointer == null || useCoarsePointer === "auto" ? (0, $ce6dd58693a21851$export$2e2bcd8739ae039).touchEventsSupported : !!useCoarsePointer;
        var defaultPointerSize = 44;
        var pointerSize;
        if (usePointerSize) pointerSize = $7a1bd9c2710fea0d$export$995e01f2f5c9d030(opts.pointerSize, defaultPointerSize);
        this.handler = new (0, $b30f5d021af2ec5a$export$2e2bcd8739ae039)(storage, painter, handlerProxy, painter.root, pointerSize);
        this.animation = new (0, $fad434a4044c956a$export$2e2bcd8739ae039)({
            stage: {
                update: ssrMode ? null : function() {
                    return _this._flush(true);
                }
            }
        });
        if (!ssrMode) this.animation.start();
    }
    ZRender.prototype.add = function(el) {
        if (this._disposed || !el) return;
        this.storage.addRoot(el);
        el.addSelfToZr(this);
        this.refresh();
    };
    ZRender.prototype.remove = function(el) {
        if (this._disposed || !el) return;
        this.storage.delRoot(el);
        el.removeSelfFromZr(this);
        this.refresh();
    };
    ZRender.prototype.configLayer = function(zLevel, config) {
        if (this._disposed) return;
        if (this.painter.configLayer) this.painter.configLayer(zLevel, config);
        this.refresh();
    };
    ZRender.prototype.setBackgroundColor = function(backgroundColor) {
        if (this._disposed) return;
        if (this.painter.setBackgroundColor) this.painter.setBackgroundColor(backgroundColor);
        this.refresh();
        this._backgroundColor = backgroundColor;
        this._darkMode = $6eba88f9eebe6af9$var$isDarkMode(backgroundColor);
    };
    ZRender.prototype.getBackgroundColor = function() {
        return this._backgroundColor;
    };
    ZRender.prototype.setDarkMode = function(darkMode) {
        this._darkMode = darkMode;
    };
    ZRender.prototype.isDarkMode = function() {
        return this._darkMode;
    };
    ZRender.prototype.refreshImmediately = function(fromInside) {
        if (this._disposed) return;
        if (!fromInside) this.animation.update(true);
        this._needsRefresh = false;
        this.painter.refresh();
        this._needsRefresh = false;
    };
    ZRender.prototype.refresh = function() {
        if (this._disposed) return;
        this._needsRefresh = true;
        this.animation.start();
    };
    ZRender.prototype.flush = function() {
        if (this._disposed) return;
        this._flush(false);
    };
    ZRender.prototype._flush = function(fromInside) {
        var triggerRendered;
        var start = (0, $fad434a4044c956a$export$1428f42a7de81803)();
        if (this._needsRefresh) {
            triggerRendered = true;
            this.refreshImmediately(fromInside);
        }
        if (this._needsRefreshHover) {
            triggerRendered = true;
            this.refreshHoverImmediately();
        }
        var end = (0, $fad434a4044c956a$export$1428f42a7de81803)();
        if (triggerRendered) {
            this._stillFrameAccum = 0;
            this.trigger("rendered", {
                elapsedTime: end - start
            });
        } else if (this._sleepAfterStill > 0) {
            this._stillFrameAccum++;
            if (this._stillFrameAccum > this._sleepAfterStill) this.animation.stop();
        }
    };
    ZRender.prototype.setSleepAfterStill = function(stillFramesCount) {
        this._sleepAfterStill = stillFramesCount;
    };
    ZRender.prototype.wakeUp = function() {
        if (this._disposed) return;
        this.animation.start();
        this._stillFrameAccum = 0;
    };
    ZRender.prototype.refreshHover = function() {
        this._needsRefreshHover = true;
    };
    ZRender.prototype.refreshHoverImmediately = function() {
        if (this._disposed) return;
        this._needsRefreshHover = false;
        if (this.painter.refreshHover && this.painter.getType() === "canvas") this.painter.refreshHover();
    };
    ZRender.prototype.resize = function(opts) {
        if (this._disposed) return;
        opts = opts || {};
        this.painter.resize(opts.width, opts.height);
        this.handler.resize();
    };
    ZRender.prototype.clearAnimation = function() {
        if (this._disposed) return;
        this.animation.clear();
    };
    ZRender.prototype.getWidth = function() {
        if (this._disposed) return;
        return this.painter.getWidth();
    };
    ZRender.prototype.getHeight = function() {
        if (this._disposed) return;
        return this.painter.getHeight();
    };
    ZRender.prototype.setCursorStyle = function(cursorStyle) {
        if (this._disposed) return;
        this.handler.setCursorStyle(cursorStyle);
    };
    ZRender.prototype.findHover = function(x, y) {
        if (this._disposed) return;
        return this.handler.findHover(x, y);
    };
    ZRender.prototype.on = function(eventName, eventHandler, context) {
        if (!this._disposed) this.handler.on(eventName, eventHandler, context);
        return this;
    };
    ZRender.prototype.off = function(eventName, eventHandler) {
        if (this._disposed) return;
        this.handler.off(eventName, eventHandler);
    };
    ZRender.prototype.trigger = function(eventName, event) {
        if (this._disposed) return;
        this.handler.trigger(eventName, event);
    };
    ZRender.prototype.clear = function() {
        if (this._disposed) return;
        var roots = this.storage.getRoots();
        for(var i = 0; i < roots.length; i++)if (roots[i] instanceof (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)) roots[i].removeSelfFromZr(this);
        this.storage.delAllRoots();
        this.painter.clear();
    };
    ZRender.prototype.dispose = function() {
        if (this._disposed) return;
        this.animation.stop();
        this.clear();
        this.storage.dispose();
        this.painter.dispose();
        this.handler.dispose();
        this.animation = this.storage = this.painter = this.handler = null;
        this._disposed = true;
        $6eba88f9eebe6af9$var$delInstance(this.id);
    };
    return ZRender;
}();
function $6eba88f9eebe6af9$export$2cd8252107eb640b(dom, opts) {
    var zr = new $6eba88f9eebe6af9$var$ZRender($7a1bd9c2710fea0d$export$46e8f25c7328f77e(), dom, opts);
    $6eba88f9eebe6af9$var$instances[zr.id] = zr;
    return zr;
}
function $6eba88f9eebe6af9$export$fcfbbcec2cb820d5(zr) {
    zr.dispose();
}
function $6eba88f9eebe6af9$export$825f692fb04800ef() {
    for(var key in $6eba88f9eebe6af9$var$instances)if ($6eba88f9eebe6af9$var$instances.hasOwnProperty(key)) $6eba88f9eebe6af9$var$instances[key].dispose();
    $6eba88f9eebe6af9$var$instances = {};
}
function $6eba88f9eebe6af9$export$8bedcca5bbd73999(id) {
    return $6eba88f9eebe6af9$var$instances[id];
}
function $6eba88f9eebe6af9$export$a3e793ccb11823a5(name, Ctor) {
    $6eba88f9eebe6af9$var$painterCtors[name] = Ctor;
}
var $6eba88f9eebe6af9$var$ssrDataGetter;
function $6eba88f9eebe6af9$export$dd7015a5412ca583(el) {
    if (typeof $6eba88f9eebe6af9$var$ssrDataGetter === "function") return $6eba88f9eebe6af9$var$ssrDataGetter(el);
}
function $6eba88f9eebe6af9$export$e7a09d7fe68a4f7(getter) {
    $6eba88f9eebe6af9$var$ssrDataGetter = getter;
}
var $6eba88f9eebe6af9$export$83d89fbfd8236492 = "6.0.0";






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embedded for some of the code in this file:
* The method "quantile" was copied from "d3.js".
* (See more details in the comment of the method below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ 
var $cfc1f3b422a3185f$var$RADIAN_EPSILON = 1e-4;
// Although chrome already enlarge this number to 100 for `toFixed`, but
// we sill follow the spec for compatibility.
var $cfc1f3b422a3185f$var$ROUND_SUPPORTED_PRECISION_MAX = 20;
function $cfc1f3b422a3185f$var$_trim(str) {
    return str.replace(/^\s+|\s+$/g, "");
}
var $cfc1f3b422a3185f$export$e411eeaf23dccbe8 = Math.min;
var $cfc1f3b422a3185f$export$2ca8010d037f830f = Math.max;
var $cfc1f3b422a3185f$export$5860c226b237d9a6 = Math.abs;
function $cfc1f3b422a3185f$export$d3f68fbaa670562(val, domain, range, clamp) {
    var d0 = domain[0];
    var d1 = domain[1];
    var r0 = range[0];
    var r1 = range[1];
    var subDomain = d1 - d0;
    var subRange = r1 - r0;
    if (subDomain === 0) return subRange === 0 ? r0 : (r0 + r1) / 2;
    // Avoid accuracy problem in edge, such as
    // 146.39 - 62.83 === 83.55999999999999.
    // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
    // It is a little verbose for efficiency considering this method
    // is a hotspot.
    if (clamp) {
        if (subDomain > 0) {
            if (val <= d0) return r0;
            else if (val >= d1) return r1;
        } else {
            if (val >= d0) return r0;
            else if (val <= d1) return r1;
        }
    } else {
        if (val === d0) return r0;
        if (val === d1) return r1;
    }
    return (val - d0) / subDomain * subRange + r0;
}
var $cfc1f3b422a3185f$export$e8514cb5a5e2b40f = $cfc1f3b422a3185f$export$249e1c100b47bcef;
function $cfc1f3b422a3185f$export$249e1c100b47bcef(option, percentBase, percentOffset) {
    switch(option){
        case "center":
        case "middle":
            option = "50%";
            break;
        case "left":
        case "top":
            option = "0%";
            break;
        case "right":
        case "bottom":
            option = "100%";
            break;
    }
    return $cfc1f3b422a3185f$export$6b392db7c2374a1a(option, percentBase, percentOffset);
}
function $cfc1f3b422a3185f$export$6b392db7c2374a1a(option, percentBase, percentOffset) {
    if ($7a1bd9c2710fea0d$export$844ec244b1367d54(option)) {
        if ($cfc1f3b422a3185f$var$_trim(option).match(/%$/)) return parseFloat(option) / 100 * percentBase + (percentOffset || 0);
        return parseFloat(option);
    }
    // Allow flexible input due to backward compatibility.
    return option == null ? NaN : +option;
}
function $cfc1f3b422a3185f$export$2077e0241d6afd3c(x, precision, returnStr) {
    if (precision == null) // FIXME: the default precision should not be provided, since there is no universally adaptable
    //  precision. The caller need to input a precision according to the scenarios.
    precision = 10;
    // Avoid range error
    precision = Math.min(Math.max(0, precision), $cfc1f3b422a3185f$var$ROUND_SUPPORTED_PRECISION_MAX);
    // PENDING: 1.005.toFixed(2) is '1.00' rather than '1.01'
    x = (+x).toFixed(precision);
    return returnStr ? x : +x;
}
function $cfc1f3b422a3185f$export$debe6e778e0a6d32(arr) {
    arr.sort(function(a, b) {
        return a - b;
    });
    return arr;
}
function $cfc1f3b422a3185f$export$e0c74b50bbd10f68(val) {
    val = +val;
    if (isNaN(val)) return 0;
    // It is much faster than methods converting number to string as follows
    //      let tmp = val.toString();
    //      return tmp.length - 1 - tmp.indexOf('.');
    // especially when precision is low
    // Notice:
    // (1) If the loop count is over about 20, it is slower than `getPrecisionSafe`.
    //     (see https://jsbench.me/2vkpcekkvw/1)
    // (2) If the val is less than for example 1e-15, the result may be incorrect.
    //     (see test/ut/spec/util/number.test.ts `getPrecision_equal_random`)
    if (val > 1e-14) {
        var e = 1;
        for(var i = 0; i < 15; i++, e *= 10){
            if (Math.round(val * e) / e === val) return i;
        }
    }
    return $cfc1f3b422a3185f$export$6d86ba4ca4984d31(val);
}
function $cfc1f3b422a3185f$export$6d86ba4ca4984d31(val) {
    // toLowerCase for: '3.4E-12'
    var str = val.toString().toLowerCase();
    // Consider scientific notation: '3.4e-12' '3.4e+12'
    var eIndex = str.indexOf("e");
    var exp = eIndex > 0 ? +str.slice(eIndex + 1) : 0;
    var significandPartLen = eIndex > 0 ? eIndex : str.length;
    var dotIndex = str.indexOf(".");
    var decimalPartLen = dotIndex < 0 ? 0 : significandPartLen - 1 - dotIndex;
    return Math.max(0, decimalPartLen - exp);
}
function $cfc1f3b422a3185f$export$666260d9a2dda8a7(dataExtent, pixelExtent) {
    var log = Math.log;
    var LN10 = Math.LN10;
    var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
    var sizeQuantity = Math.round(log($cfc1f3b422a3185f$export$5860c226b237d9a6(pixelExtent[1] - pixelExtent[0])) / LN10);
    // toFixed() digits argument must be between 0 and 20.
    var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
    return !isFinite(precision) ? 20 : precision;
}
function $cfc1f3b422a3185f$export$70cc11b075afeb90(valueList, idx, precision) {
    if (!valueList[idx]) return 0;
    var seats = $cfc1f3b422a3185f$export$222dabb13d5320df(valueList, precision);
    return seats[idx] || 0;
}
function $cfc1f3b422a3185f$export$222dabb13d5320df(valueList, precision) {
    var sum = $7a1bd9c2710fea0d$export$533b26079ad0b4b(valueList, function(acc, val) {
        return acc + (isNaN(val) ? 0 : val);
    }, 0);
    if (sum === 0) return [];
    var digits = Math.pow(10, precision);
    var votesPerQuota = $7a1bd9c2710fea0d$export$871de8747c9eaa88(valueList, function(val) {
        return (isNaN(val) ? 0 : val) / sum * digits * 100;
    });
    var targetSeats = digits * 100;
    var seats = $7a1bd9c2710fea0d$export$871de8747c9eaa88(votesPerQuota, function(votes) {
        // Assign automatic seats.
        return Math.floor(votes);
    });
    var currentSum = $7a1bd9c2710fea0d$export$533b26079ad0b4b(seats, function(acc, val) {
        return acc + val;
    }, 0);
    var remainder = $7a1bd9c2710fea0d$export$871de8747c9eaa88(votesPerQuota, function(votes, idx) {
        return votes - seats[idx];
    });
    // Has remainding votes.
    while(currentSum < targetSeats){
        // Find next largest remainder.
        var max = Number.NEGATIVE_INFINITY;
        var maxId = null;
        for(var i = 0, len = remainder.length; i < len; ++i)if (remainder[i] > max) {
            max = remainder[i];
            maxId = i;
        }
        // Add a vote to max remainder.
        ++seats[maxId];
        remainder[maxId] = 0;
        ++currentSum;
    }
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88(seats, function(seat) {
        return seat / digits;
    });
}
function $cfc1f3b422a3185f$export$d3389a301c3a5706(val0, val1) {
    var maxPrecision = Math.max($cfc1f3b422a3185f$export$e0c74b50bbd10f68(val0), $cfc1f3b422a3185f$export$e0c74b50bbd10f68(val1));
    // const multiplier = Math.pow(10, maxPrecision);
    // return (Math.round(val0 * multiplier) + Math.round(val1 * multiplier)) / multiplier;
    var sum = val0 + val1;
    // // PENDING: support more?
    return maxPrecision > $cfc1f3b422a3185f$var$ROUND_SUPPORTED_PRECISION_MAX ? sum : $cfc1f3b422a3185f$export$2077e0241d6afd3c(sum, maxPrecision);
}
var $cfc1f3b422a3185f$export$18510406f204a1b9 = 9007199254740991;
function $cfc1f3b422a3185f$export$2ca6dd70a288b1c3(radian) {
    var pi2 = Math.PI * 2;
    return (radian % pi2 + pi2) % pi2;
}
function $cfc1f3b422a3185f$export$d1df570aea2868f(val) {
    return val > -$cfc1f3b422a3185f$var$RADIAN_EPSILON && val < $cfc1f3b422a3185f$var$RADIAN_EPSILON;
}
// eslint-disable-next-line
var $cfc1f3b422a3185f$var$TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d{1,2})(?::(\d{1,2})(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line
function $cfc1f3b422a3185f$export$6b862160d295c8e(value) {
    if (value instanceof Date) return value;
    else if ($7a1bd9c2710fea0d$export$844ec244b1367d54(value)) {
        // Different browsers parse date in different way, so we parse it manually.
        // Some other issues:
        // new Date('1970-01-01') is UTC,
        // new Date('1970/01/01') and new Date('1970-1-01') is local.
        // See issue #3623
        var match = $cfc1f3b422a3185f$var$TIME_REG.exec(value);
        if (!match) // return Invalid Date.
        return new Date(NaN);
        // Use local time when no timezone offset is specified.
        if (!match[8]) // match[n] can only be string or undefined.
        // But take care of '12' + 1 => '121'.
        return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0);
        else {
            var hour = +match[4] || 0;
            if (match[8].toUpperCase() !== "Z") hour -= +match[8].slice(0, 3);
            return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0));
        }
    } else if (value == null) return new Date(NaN);
    return new Date(Math.round(value));
}
function $cfc1f3b422a3185f$export$82dd68b83a44b253(val) {
    return Math.pow(10, $cfc1f3b422a3185f$export$97256a17b20a0c24(val));
}
function $cfc1f3b422a3185f$export$97256a17b20a0c24(val) {
    if (val === 0) return 0;
    var exp = Math.floor(Math.log(val) / Math.LN10);
    /**
   * exp is expected to be the rounded-down result of the base-10 log of val.
   * But due to the precision loss with Math.log(val), we need to restore it
   * using 10^exp to make sure we can get val back from exp. #11249
   */ if (val / Math.pow(10, exp) >= 10) exp++;
    return exp;
}
function $cfc1f3b422a3185f$export$7a695fe44258210b(val, round) {
    var exponent = $cfc1f3b422a3185f$export$97256a17b20a0c24(val);
    var exp10 = Math.pow(10, exponent);
    var f = val / exp10; // 1 <= f < 10
    var nf;
    if (round) {
        if (f < 1.5) nf = 1;
        else if (f < 2.5) nf = 2;
        else if (f < 4) nf = 3;
        else if (f < 7) nf = 5;
        else nf = 10;
    } else {
        if (f < 1) nf = 1;
        else if (f < 2) nf = 2;
        else if (f < 3) nf = 3;
        else if (f < 5) nf = 5;
        else nf = 10;
    }
    val = nf * exp10;
    // Fix 3 * 0.1 === 0.30000000000000004 issue (see IEEE 754).
    // 20 is the uppper bound of toFixed.
    return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
}
function $cfc1f3b422a3185f$export$651fb4afdb6caa4b(ascArr, p) {
    var H = (ascArr.length - 1) * p + 1;
    var h = Math.floor(H);
    var v = +ascArr[h - 1];
    var e = H - h;
    return e ? v + e * (ascArr[h] - v) : v;
}
function $cfc1f3b422a3185f$export$12f7386070bc380a(list) {
    list.sort(function(a, b) {
        return littleThan(a, b, 0) ? -1 : 1;
    });
    var curr = -Infinity;
    var currClose = 1;
    for(var i = 0; i < list.length;){
        var interval = list[i].interval;
        var close_1 = list[i].close;
        for(var lg = 0; lg < 2; lg++){
            if (interval[lg] <= curr) {
                interval[lg] = curr;
                close_1[lg] = !lg ? 1 - currClose : 1;
            }
            curr = interval[lg];
            currClose = close_1[lg];
        }
        if (interval[0] === interval[1] && close_1[0] * close_1[1] !== 1) list.splice(i, 1);
        else i++;
    }
    return list;
    function littleThan(a, b, lg) {
        return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
    }
}
function $cfc1f3b422a3185f$export$8b4007b942b45a96(val) {
    var valFloat = parseFloat(val);
    return valFloat == val // eslint-disable-line eqeqeq
     && (valFloat !== 0 || !$7a1bd9c2710fea0d$export$844ec244b1367d54(val) || val.indexOf("x") <= 0 // For case ' 0x0 '.
    ) ? valFloat : NaN;
}
function $cfc1f3b422a3185f$export$e90fb89750dba83f(val) {
    return !isNaN($cfc1f3b422a3185f$export$8b4007b942b45a96(val));
}
function $cfc1f3b422a3185f$export$474d2ec9aa44a22() {
    return Math.round(Math.random() * 9);
}
function $cfc1f3b422a3185f$export$a368fd580c0d0fe4(a, b) {
    if (b === 0) return a;
    return $cfc1f3b422a3185f$export$a368fd580c0d0fe4(b, a % b);
}
function $cfc1f3b422a3185f$export$680a45b749323f49(a, b) {
    if (a == null) return b;
    if (b == null) return a;
    return a * b / $cfc1f3b422a3185f$export$a368fd580c0d0fe4(a, b);
}



function $76d619f648247e6d$var$interpolateNumber(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
/**
 * Make the name displayable. But we should
 * make sure it is not duplicated with user
 * specified name, so use '\0';
 */ var $76d619f648247e6d$var$DUMMY_COMPONENT_NAME_PREFIX = "series\x00";
var $76d619f648247e6d$var$INTERNAL_COMPONENT_ID_PREFIX = "\x00_ec_\x00";
function $76d619f648247e6d$export$4f07b212a02c8051(value) {
    return value instanceof Array ? value : value == null ? [] : [
        value
    ];
}
function $76d619f648247e6d$export$abdcc6a26372f94b(opt, key, subOpts) {
    // Caution: performance sensitive.
    if (opt) {
        opt[key] = opt[key] || {};
        opt.emphasis = opt.emphasis || {};
        opt.emphasis[key] = opt.emphasis[key] || {};
        // Default emphasis option from normal
        for(var i = 0, len = subOpts.length; i < len; i++){
            var subOptName = subOpts[i];
            if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) opt.emphasis[key][subOptName] = opt[key][subOptName];
        }
    }
}
var $76d619f648247e6d$export$df45610347a602ad = [
    "fontStyle",
    "fontWeight",
    "fontSize",
    "fontFamily",
    "rich",
    "tag",
    "color",
    "textBorderColor",
    "textBorderWidth",
    "width",
    "height",
    "lineHeight",
    "align",
    "verticalAlign",
    "baseline",
    "shadowColor",
    "shadowBlur",
    "shadowOffsetX",
    "shadowOffsetY",
    "textShadowColor",
    "textShadowBlur",
    "textShadowOffsetX",
    "textShadowOffsetY",
    "backgroundColor",
    "borderColor",
    "borderWidth",
    "borderRadius",
    "padding"
];
function $76d619f648247e6d$export$2c944e12edb48d4b(dataItem) {
    return (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dataItem) && !(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
}
function $76d619f648247e6d$export$3e1a543f33ef6883(dataItem) {
    return (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dataItem) && !(dataItem instanceof Array);
// // markLine data can be array
// && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
}
function $76d619f648247e6d$export$574f818966e4da87(existings, newCmptOptions, mode) {
    var isNormalMergeMode = mode === "normalMerge";
    var isReplaceMergeMode = mode === "replaceMerge";
    var isReplaceAllMode = mode === "replaceAll";
    existings = existings || [];
    newCmptOptions = (newCmptOptions || []).slice();
    var existingIdIdxMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    // Validate id and name on user input option.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(cmptOption)) {
            newCmptOptions[index] = null;
            return;
        }
    });
    var result = $76d619f648247e6d$var$prepareResult(existings, existingIdIdxMap, mode);
    if (isNormalMergeMode || isReplaceMergeMode) $76d619f648247e6d$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions);
    if (isNormalMergeMode) $76d619f648247e6d$var$mappingByName(result, newCmptOptions);
    if (isNormalMergeMode || isReplaceMergeMode) $76d619f648247e6d$var$mappingByIndex(result, newCmptOptions, isReplaceMergeMode);
    else if (isReplaceAllMode) $76d619f648247e6d$var$mappingInReplaceAllMode(result, newCmptOptions);
    $76d619f648247e6d$var$makeIdAndName(result);
    // The array `result` MUST NOT contain elided items, otherwise the
    // forEach will omit those items and result in incorrect result.
    return result;
}
function $76d619f648247e6d$var$prepareResult(existings, existingIdIdxMap, mode) {
    var result = [];
    if (mode === "replaceAll") return result;
    // Do not use native `map` to in case that the array `existings`
    // contains elided items, which will be omitted.
    for(var index = 0; index < existings.length; index++){
        var existing = existings[index];
        // Because of replaceMerge, `existing` may be null/undefined.
        if (existing && existing.id != null) existingIdIdxMap.set(existing.id, index);
        // For non-internal-componnets:
        //     Mode "normalMerge": all existings kept.
        //     Mode "replaceMerge": all existing removed unless mapped by id.
        // For internal-components:
        //     go with "replaceMerge" approach in both mode.
        result.push({
            existing: mode === "replaceMerge" || $76d619f648247e6d$export$feece3e7d52a102b(existing) ? null : existing,
            newOption: null,
            keyInfo: null,
            brandNew: null
        });
    }
    return result;
}
function $76d619f648247e6d$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions) {
    // Mapping by id if specified.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.id == null) return;
        var optionId = $76d619f648247e6d$var$makeComparableKey(cmptOption.id);
        var existingIdx = existingIdIdxMap.get(optionId);
        if (existingIdx != null) {
            var resultItem = result[existingIdx];
            (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(!resultItem.newOption, 'Duplicated option on id "' + optionId + '".');
            resultItem.newOption = cmptOption;
            // In both mode, if id matched, new option will be merged to
            // the existings rather than creating new component model.
            resultItem.existing = existings[existingIdx];
            newCmptOptions[index] = null;
        }
    });
}
function $76d619f648247e6d$var$mappingByName(result, newCmptOptions) {
    // Mapping by name if specified.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.name == null) return;
        for(var i = 0; i < result.length; i++){
            var existing = result[i].existing;
            if (!result[i].newOption // Consider name: two map to one.
             && existing && (existing.id == null || cmptOption.id == null) && !$76d619f648247e6d$export$feece3e7d52a102b(cmptOption) && !$76d619f648247e6d$export$feece3e7d52a102b(existing) && $76d619f648247e6d$var$keyExistAndEqual("name", existing, cmptOption)) {
                result[i].newOption = cmptOption;
                newCmptOptions[index] = null;
                return;
            }
        }
    });
}
function $76d619f648247e6d$var$mappingByIndex(result, newCmptOptions, brandNew) {
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption) {
        if (!cmptOption) return;
        // Find the first place that not mapped by id and not internal component (consider the "hole").
        var resultItem;
        var nextIdx = 0;
        while(// Be `!resultItem` only when `nextIdx >= result.length`.
        (resultItem = result[nextIdx]) && (resultItem.newOption || $76d619f648247e6d$export$feece3e7d52a102b(resultItem.existing) || // In mode "replaceMerge", here no not-mapped-non-internal-existing.
        resultItem.existing && cmptOption.id != null && !$76d619f648247e6d$var$keyExistAndEqual("id", cmptOption, resultItem.existing)))nextIdx++;
        if (resultItem) {
            resultItem.newOption = cmptOption;
            resultItem.brandNew = brandNew;
        } else result.push({
            newOption: cmptOption,
            brandNew: brandNew,
            existing: null,
            keyInfo: null
        });
        nextIdx++;
    });
}
function $76d619f648247e6d$var$mappingInReplaceAllMode(result, newCmptOptions) {
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption) {
        // The feature "reproduce" requires "hole" will also reproduced
        // in case that component index referring are broken.
        result.push({
            newOption: cmptOption,
            brandNew: true,
            existing: null,
            keyInfo: null
        });
    });
}
/**
 * Make id and name for mapping result (result of mappingToExists)
 * into `keyInfo` field.
 */ function $76d619f648247e6d$var$makeIdAndName(mapResult) {
    // We use this id to hash component models and view instances
    // in echarts. id can be specified by user, or auto generated.
    // The id generation rule ensures new view instance are able
    // to mapped to old instance when setOption are called in
    // no-merge mode. So we generate model id by name and plus
    // type in view id.
    // name can be duplicated among components, which is convenient
    // to specify multi components (like series) by one name.
    // Ensure that each id is distinct.
    var idMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mapResult, function(item) {
        var existing = item.existing;
        existing && idMap.set(existing.id, item);
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mapResult, function(item) {
        var opt = item.newOption;
        // Force ensure id not duplicated.
        (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, "id duplicates: " + (opt && opt.id));
        opt && opt.id != null && idMap.set(opt.id, item);
        !item.keyInfo && (item.keyInfo = {});
    });
    // Make name and id.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mapResult, function(item, index) {
        var existing = item.existing;
        var opt = item.newOption;
        var keyInfo = item.keyInfo;
        if (!(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(opt)) return;
        // Name can be overwritten. Consider case: axis.name = '20km'.
        // But id generated by name will not be changed, which affect
        // only in that case: setOption with 'not merge mode' and view
        // instance will be recreated, which can be accepted.
        keyInfo.name = opt.name != null ? $76d619f648247e6d$var$makeComparableKey(opt.name) : existing ? existing.name : $76d619f648247e6d$var$DUMMY_COMPONENT_NAME_PREFIX + index;
        if (existing) keyInfo.id = $76d619f648247e6d$var$makeComparableKey(existing.id);
        else if (opt.id != null) keyInfo.id = $76d619f648247e6d$var$makeComparableKey(opt.id);
        else {
            // Consider this situatoin:
            //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
            //  optionB [{..}, {name: 'a'}, {name: 'a'}]
            // Series with the same name between optionA and optionB
            // should be mapped.
            var idNum = 0;
            do keyInfo.id = "\x00" + keyInfo.name + "\x00" + idNum++;
            while (idMap.get(keyInfo.id));
        }
        idMap.set(keyInfo.id, item);
    });
}
function $76d619f648247e6d$var$keyExistAndEqual(attr, obj1, obj2) {
    var key1 = $76d619f648247e6d$export$fb1a222ba5dd6e51(obj1[attr], null);
    var key2 = $76d619f648247e6d$export$fb1a222ba5dd6e51(obj2[attr], null);
    // See `MappingExistingItem`. `id` and `name` trade string equals to number.
    return key1 != null && key2 != null && key1 === key2;
}
/**
 * @return return null if not exist.
 */ function $76d619f648247e6d$var$makeComparableKey(val) {
    return $76d619f648247e6d$export$fb1a222ba5dd6e51(val, "");
}
function $76d619f648247e6d$export$fb1a222ba5dd6e51(idOrName, defaultValue) {
    if (idOrName == null) return defaultValue;
    return (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(idOrName) ? idOrName : (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(idOrName) || (0, $7a1bd9c2710fea0d$export$29d0bb2a4e07b252)(idOrName) ? idOrName + "" : defaultValue;
}
function $76d619f648247e6d$var$warnInvalidateIdOrName(idOrName) {}
function $76d619f648247e6d$var$isValidIdOrName(idOrName) {
    return (0, $7a1bd9c2710fea0d$export$29d0bb2a4e07b252)(idOrName) || (0, $cfc1f3b422a3185f$export$e90fb89750dba83f)(idOrName);
}
function $76d619f648247e6d$export$beae19a2652b3368(componentModel) {
    var name = componentModel.name;
    // Is specified when `indexOf` get -1 or > 0.
    return !!(name && name.indexOf($76d619f648247e6d$var$DUMMY_COMPONENT_NAME_PREFIX));
}
function $76d619f648247e6d$export$feece3e7d52a102b(cmptOption) {
    return cmptOption && cmptOption.id != null && $76d619f648247e6d$var$makeComparableKey(cmptOption.id).indexOf($76d619f648247e6d$var$INTERNAL_COMPONENT_ID_PREFIX) === 0;
}
function $76d619f648247e6d$export$1753133c42e665e8(idSuffix) {
    return $76d619f648247e6d$var$INTERNAL_COMPONENT_ID_PREFIX + idSuffix;
}
function $76d619f648247e6d$export$5ac61aca2ba0282d(mappingResult, mainType, componentModelCtor) {
    // Set mainType and complete subType.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mappingResult, function(item) {
        var newOption = item.newOption;
        if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(newOption)) {
            item.keyInfo.mainType = mainType;
            item.keyInfo.subType = $76d619f648247e6d$var$determineSubType(mainType, newOption, item.existing, componentModelCtor);
        }
    });
}
function $76d619f648247e6d$var$determineSubType(mainType, newCmptOption, existComponent, componentModelCtor) {
    var subType = newCmptOption.type ? newCmptOption.type : existComponent ? existComponent.subType : componentModelCtor.determineSubType(mainType, newCmptOption);
    // tooltip, markline, markpoint may always has no subType
    return subType;
}
function $76d619f648247e6d$export$6d12cabb0c9bf8e3(batchA, batchB) {
    var mapA = {};
    var mapB = {};
    makeMap(batchA || [], mapA);
    makeMap(batchB || [], mapB, mapA);
    return [
        mapToArray(mapA),
        mapToArray(mapB)
    ];
    function makeMap(sourceBatch, map, otherMap) {
        for(var i = 0, len = sourceBatch.length; i < len; i++){
            var seriesId = $76d619f648247e6d$export$fb1a222ba5dd6e51(sourceBatch[i].seriesId, null);
            if (seriesId == null) return;
            var dataIndices = $76d619f648247e6d$export$4f07b212a02c8051(sourceBatch[i].dataIndex);
            var otherDataIndices = otherMap && otherMap[seriesId];
            for(var j = 0, lenj = dataIndices.length; j < lenj; j++){
                var dataIndex = dataIndices[j];
                if (otherDataIndices && otherDataIndices[dataIndex]) otherDataIndices[dataIndex] = null;
                else (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
            }
        }
    }
    function mapToArray(map, isData) {
        var result = [];
        for(var i in map)if (map.hasOwnProperty(i) && map[i] != null) {
            if (isData) result.push(+i);
            else {
                var dataIndices = mapToArray(map[i], true);
                dataIndices.length && result.push({
                    seriesId: i,
                    dataIndex: dataIndices
                });
            }
        }
        return result;
    }
}
function $76d619f648247e6d$export$42b26cae8b8d10(data, payload) {
    if (payload.dataIndexInside != null) return payload.dataIndexInside;
    else if (payload.dataIndex != null) return (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(payload.dataIndex) ? (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(payload.dataIndex, function(value) {
        return data.indexOfRawIndex(value);
    }) : data.indexOfRawIndex(payload.dataIndex);
    else if (payload.name != null) return (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(payload.name) ? (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(payload.name, function(value) {
        return data.indexOfName(value);
    }) : data.indexOfName(payload.name);
}
function $76d619f648247e6d$export$64df9f8d92ae083f() {
    var key = "__ec_inner_" + $76d619f648247e6d$var$innerUniqueIndex++;
    return function(hostObj) {
        return hostObj[key] || (hostObj[key] = {});
    };
}
var $76d619f648247e6d$var$innerUniqueIndex = (0, $cfc1f3b422a3185f$export$474d2ec9aa44a22)();
function $76d619f648247e6d$export$95de80076abac814(ecModel, finderInput, opt) {
    var _a = $76d619f648247e6d$export$fe600815775d9400(finderInput, opt), mainTypeSpecified = _a.mainTypeSpecified, queryOptionMap = _a.queryOptionMap, others = _a.others;
    var result = others;
    var defaultMainType = opt ? opt.defaultMainType : null;
    if (!mainTypeSpecified && defaultMainType) queryOptionMap.set(defaultMainType, {});
    queryOptionMap.each(function(queryOption, mainType) {
        var queryResult = $76d619f648247e6d$export$dc741340f7e5f186(ecModel, mainType, queryOption, {
            useDefault: defaultMainType === mainType,
            enableAll: opt && opt.enableAll != null ? opt.enableAll : true,
            enableNone: opt && opt.enableNone != null ? opt.enableNone : true
        });
        result[mainType + "Models"] = queryResult.models;
        result[mainType + "Model"] = queryResult.models[0];
    });
    return result;
}
function $76d619f648247e6d$export$fe600815775d9400(finderInput, opt) {
    var finder;
    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(finderInput)) {
        var obj = {};
        obj[finderInput + "Index"] = 0;
        finder = obj;
    } else finder = finderInput;
    var queryOptionMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var others = {};
    var mainTypeSpecified = false;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(finder, function(value, key) {
        // Exclude 'dataIndex' and other illegal keys.
        if (key === "dataIndex" || key === "dataIndexInside") {
            others[key] = value;
            return;
        }
        var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
        var mainType = parsedKey[1];
        var queryType = (parsedKey[2] || "").toLowerCase();
        if (!mainType || !queryType || opt && opt.includeMainTypes && (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(opt.includeMainTypes, mainType) < 0) return;
        mainTypeSpecified = mainTypeSpecified || !!mainType;
        var queryOption = queryOptionMap.get(mainType) || queryOptionMap.set(mainType, {});
        queryOption[queryType] = value;
    });
    return {
        mainTypeSpecified: mainTypeSpecified,
        queryOptionMap: queryOptionMap,
        others: others
    };
}
var $76d619f648247e6d$export$f076738ec84e693c = {
    useDefault: true,
    enableAll: false,
    enableNone: false
};
var $76d619f648247e6d$export$48d598924ce4892c = {
    useDefault: false,
    enableAll: true,
    enableNone: true
};
function $76d619f648247e6d$export$dc741340f7e5f186(ecModel, mainType, userOption, opt) {
    opt = opt || $76d619f648247e6d$export$f076738ec84e693c;
    var indexOption = userOption.index;
    var idOption = userOption.id;
    var nameOption = userOption.name;
    var result = {
        models: null,
        specified: indexOption != null || idOption != null || nameOption != null
    };
    if (!result.specified) {
        // Use the first as default if `useDefault`.
        var firstCmpt = void 0;
        result.models = opt.useDefault && (firstCmpt = ecModel.getComponent(mainType)) ? [
            firstCmpt
        ] : [];
        return result;
    }
    if (indexOption === "none" || indexOption === false) {
        if (opt.enableNone) {
            result.models = [];
            return result;
        } else indexOption = -1; // Can not query by index but may still query by id/name if specified.
    }
    // `queryComponents` will return all components if
    // both all of index/id/name are null/undefined.
    if (indexOption === "all") {
        if (opt.enableAll) indexOption = idOption = nameOption = null;
        else indexOption = -1;
    }
    result.models = ecModel.queryComponents({
        mainType: mainType,
        index: indexOption,
        id: idOption,
        name: nameOption
    });
    return result;
}
function $76d619f648247e6d$export$9fec4d97f1922e0b(dom, key, value) {
    dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
}
function $76d619f648247e6d$export$735ee1799fd02602(dom, key) {
    return dom.getAttribute ? dom.getAttribute(key) : dom[key];
}
function $76d619f648247e6d$export$cc0a17a5d27b4e17(renderModeOption) {
    if (renderModeOption === "auto") // Using html when `document` exists, use richText otherwise
    return (0, $ce6dd58693a21851$export$2e2bcd8739ae039).domSupported ? "html" : "richText";
    else return renderModeOption || "html";
}
function $76d619f648247e6d$export$7ab5bda43e13168f(array, getKey // return key
) {
    var buckets = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var keys = [];
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(array, function(item) {
        var key = getKey(item);
        (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
    });
    return {
        keys: keys,
        buckets: buckets
    };
}
function $76d619f648247e6d$export$bd0439821a1869f3(data, precision, sourceValue, targetValue, percent) {
    var isAutoPrecision = precision == null || precision === "auto";
    if (targetValue == null) return targetValue;
    if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(targetValue)) {
        var value = $76d619f648247e6d$var$interpolateNumber(sourceValue || 0, targetValue, percent);
        return (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(value, isAutoPrecision ? Math.max((0, $cfc1f3b422a3185f$export$e0c74b50bbd10f68)(sourceValue || 0), (0, $cfc1f3b422a3185f$export$e0c74b50bbd10f68)(targetValue)) : precision);
    } else if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(targetValue)) return percent < 1 ? sourceValue : targetValue;
    else {
        var interpolated = [];
        var leftArr = sourceValue;
        var rightArr = targetValue;
        var length_1 = Math.max(leftArr ? leftArr.length : 0, rightArr.length);
        for(var i = 0; i < length_1; ++i){
            var info = data.getDimensionInfo(i);
            // Don't interpolate ordinal dims
            if (info && info.type === "ordinal") // In init, there is no `sourceValue`, but should better not to get undefined result.
            interpolated[i] = (percent < 1 && leftArr ? leftArr : rightArr)[i];
            else {
                var leftVal = leftArr && leftArr[i] ? leftArr[i] : 0;
                var rightVal = rightArr[i];
                var value = $76d619f648247e6d$var$interpolateNumber(leftVal, rightVal, percent);
                interpolated[i] = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(value, isAutoPrecision ? Math.max((0, $cfc1f3b422a3185f$export$e0c74b50bbd10f68)(leftVal), (0, $cfc1f3b422a3185f$export$e0c74b50bbd10f68)(rightVal)) : precision);
            }
        }
        return interpolated;
    }
}
/**
 * Use an iterator to avoid exposing the internal list or duplicating it
 * for the outside traveller, and no extra heap allocation.
 * @usage
 *  for (const it = resetIterator(); it.next();) {
 *      const item = it.item;
 *      const key = it.key;
 *      const itIdx = it.itIdx;
 *      // ...
 *  }
 * @usage
 *  const it = resetIterator();
 *  while (it.next()) { ... }
 * @usage
 *  for (resetIterator(it); it.next();) { ... }
 */ var $76d619f648247e6d$export$4e38036c4470d56c = /** @class */ function() {
    function ListIterator() {}
    /**
   * The loop condition is `idx < end` if `step > 0`;
   * The loop condition is `idx >= end` if `step < 0`.
   *
   * @param end By default `list.length` if `step > 0`; `0` if `step < 0`.
   * @param step By default `1`.
   */ ListIterator.prototype.reset = function(list, start, end, step) {
        this._list = list;
        this._step = step = step || 1;
        this._idx = start;
        this._end = end != null ? end : step > 0 ? list.length : 0;
        this.item = null;
        this.key = NaN;
        return this;
    };
    ListIterator.prototype.next = function() {
        if (this._step > 0 ? this._idx < this._end : this._idx >= this._end) {
            this.item = this._list[this._idx];
            this.key = this._idx = this._idx + this._step;
            return true;
        }
        return false;
    };
    return ListIterator;
}();
function $76d619f648247e6d$export$be44d6593b016f3e(model) {
    // Clear to avoid memory leak.
    model.option = model.parentModel = model.ecModel = null;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $cd5f95cf03b4e3e7$var$TYPE_DELIMITER = ".";
var $cd5f95cf03b4e3e7$var$IS_CONTAINER = "___EC__COMPONENT__CONTAINER___";
var $cd5f95cf03b4e3e7$var$IS_EXTENDED_CLASS = "___EC__EXTENDED_CLASS___";
function $cd5f95cf03b4e3e7$export$fbe18865d303bf01(componentType) {
    var ret = {
        main: "",
        sub: ""
    };
    if (componentType) {
        var typeArr = componentType.split($cd5f95cf03b4e3e7$var$TYPE_DELIMITER);
        ret.main = typeArr[0] || "";
        ret.sub = typeArr[1] || "";
    }
    return ret;
}
/**
 * @public
 */ function $cd5f95cf03b4e3e7$var$checkClassType(componentType) {
    $7a1bd9c2710fea0d$export$a7a9523472993e97(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
}
function $cd5f95cf03b4e3e7$export$4f3b818f3dd2d182(clz) {
    return !!(clz && clz[$cd5f95cf03b4e3e7$var$IS_EXTENDED_CLASS]);
}
function $cd5f95cf03b4e3e7$export$cd4c3a4dca301c70(rootClz, mandatoryMethods) {
    rootClz.$constructor = rootClz; // FIXME: not necessary?
    rootClz.extend = function(proto) {
        var superClass = this;
        var ExtendedClass;
        if ($cd5f95cf03b4e3e7$var$isESClass(superClass)) ExtendedClass = /** @class */ function(_super) {
            (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(class_1, _super);
            function class_1() {
                return _super.apply(this, arguments) || this;
            }
            return class_1;
        }(superClass);
        else {
            // For backward compat, we both support ts class inheritance and this
            // "extend" approach.
            // The constructor should keep the same behavior as ts class inheritance:
            // If this constructor/$constructor is not declared, auto invoke the super
            // constructor.
            // If this constructor/$constructor is declared, it is responsible for
            // calling the super constructor.
            ExtendedClass = function() {
                (proto.$constructor || superClass).apply(this, arguments);
            };
            $7a1bd9c2710fea0d$export$69f1b2dcda23c5f8(ExtendedClass, this);
        }
        $7a1bd9c2710fea0d$export$8b58be045bf06082(ExtendedClass.prototype, proto);
        ExtendedClass[$cd5f95cf03b4e3e7$var$IS_EXTENDED_CLASS] = true;
        ExtendedClass.extend = this.extend;
        ExtendedClass.superCall = $cd5f95cf03b4e3e7$var$superCall;
        ExtendedClass.superApply = $cd5f95cf03b4e3e7$var$superApply;
        ExtendedClass.superClass = superClass;
        return ExtendedClass;
    };
}
function $cd5f95cf03b4e3e7$var$isESClass(fn) {
    return $7a1bd9c2710fea0d$export$f6e2535fb5126e54(fn) && /^class\s/.test(Function.prototype.toString.call(fn));
}
function $cd5f95cf03b4e3e7$export$c9c2d87774f1275d(SubClz, SupperClz) {
    SubClz.extend = SupperClz.extend;
}
// A random offset.
var $cd5f95cf03b4e3e7$var$classBase = Math.round(Math.random() * 10);
function $cd5f95cf03b4e3e7$export$e1aac4552ae82081(target) {
    var classAttr = [
        "__\x00is_clz",
        $cd5f95cf03b4e3e7$var$classBase++
    ].join("_");
    target.prototype[classAttr] = true;
    target.isInstance = function(obj) {
        return !!(obj && obj[classAttr]);
    };
}
// superCall should have class info, which can not be fetched from 'this'.
// Consider this case:
// class A has method f,
// class B inherits class A, overrides method f, f call superApply('f'),
// class C inherits class B, does not override method f,
// then when method of class C is called, dead loop occurred.
function $cd5f95cf03b4e3e7$var$superCall(context, methodName) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return this.superClass.prototype[methodName].apply(context, args);
}
function $cd5f95cf03b4e3e7$var$superApply(context, methodName, args) {
    return this.superClass.prototype[methodName].apply(context, args);
}
function $cd5f95cf03b4e3e7$export$241315e45585454d(target) {
    /**
   * Component model classes
   * key: componentType,
   * value:
   *     componentClass, when componentType is 'a'
   *     or Object.<subKey, componentClass>, when componentType is 'a.b'
   */ var storage = {};
    target.registerClass = function(clz) {
        // `type` should not be a "instance member".
        // If using TS class, should better declared as `static type = 'series.pie'`.
        // otherwise users have to mount `type` on prototype manually.
        // For backward compat and enable instance visit type via `this.type`,
        // we still support fetch `type` from prototype.
        var componentFullType = clz.type || clz.prototype.type;
        if (componentFullType) {
            $cd5f95cf03b4e3e7$var$checkClassType(componentFullType);
            // If only static type declared, we assign it to prototype mandatorily.
            clz.prototype.type = componentFullType;
            var componentTypeInfo = $cd5f95cf03b4e3e7$export$fbe18865d303bf01(componentFullType);
            if (!componentTypeInfo.sub) storage[componentTypeInfo.main] = clz;
            else if (componentTypeInfo.sub !== $cd5f95cf03b4e3e7$var$IS_CONTAINER) {
                var container = makeContainer(componentTypeInfo);
                container[componentTypeInfo.sub] = clz;
            }
        }
        return clz;
    };
    target.getClass = function(mainType, subType, throwWhenNotFound) {
        var clz = storage[mainType];
        if (clz && clz[$cd5f95cf03b4e3e7$var$IS_CONTAINER]) clz = subType ? clz[subType] : null;
        if (throwWhenNotFound && !clz) throw new Error(!subType ? mainType + "." + "type should be specified." : "Component " + mainType + "." + (subType || "") + " is used but not imported.");
        return clz;
    };
    target.getClassesByMainType = function(componentType) {
        var componentTypeInfo = $cd5f95cf03b4e3e7$export$fbe18865d303bf01(componentType);
        var result = [];
        var obj = storage[componentTypeInfo.main];
        if (obj && obj[$cd5f95cf03b4e3e7$var$IS_CONTAINER]) $7a1bd9c2710fea0d$export$79b2f7037acddd43(obj, function(o, type) {
            type !== $cd5f95cf03b4e3e7$var$IS_CONTAINER && result.push(o);
        });
        else result.push(obj);
        return result;
    };
    target.hasClass = function(componentType) {
        // Just consider componentType.main.
        var componentTypeInfo = $cd5f95cf03b4e3e7$export$fbe18865d303bf01(componentType);
        return !!storage[componentTypeInfo.main];
    };
    /**
   * @return Like ['aa', 'bb'], but can not be ['aa.xx']
   */ target.getAllClassMainTypes = function() {
        var types = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(storage, function(obj, type) {
            types.push(type);
        });
        return types;
    };
    /**
   * If a main type is container and has sub types
   */ target.hasSubTypes = function(componentType) {
        var componentTypeInfo = $cd5f95cf03b4e3e7$export$fbe18865d303bf01(componentType);
        var obj = storage[componentTypeInfo.main];
        return obj && obj[$cd5f95cf03b4e3e7$var$IS_CONTAINER];
    };
    function makeContainer(componentTypeInfo) {
        var container = storage[componentTypeInfo.main];
        if (!container || !container[$cd5f95cf03b4e3e7$var$IS_CONTAINER]) {
            container = storage[componentTypeInfo.main] = {};
            container[$cd5f95cf03b4e3e7$var$IS_CONTAINER] = true;
        }
        return container;
    }
} // /**
 //  * @param {string|Array.<string>} properties
 //  */
 // export function setReadOnly(obj, properties) {
 // FIXME It seems broken in IE8 simulation of IE11
 // if (!zrUtil.isArray(properties)) {
 //     properties = properties != null ? [properties] : [];
 // }
 // zrUtil.each(properties, function (prop) {
 //     let value = obj[prop];
 //     Object.defineProperty
 //         && Object.defineProperty(obj, prop, {
 //             value: value, writable: false
 //         });
 //     zrUtil.isArray(obj[prop])
 //         && Object.freeze
 //         && Object.freeze(obj[prop]);
 // });
 // }


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO Parse shadow style
// TODO Only shallow path support

function $06542048a26d4d91$export$2e2bcd8739ae039(properties, ignoreParent) {
    // Normalize
    for(var i = 0; i < properties.length; i++)if (!properties[i][1]) properties[i][1] = properties[i][0];
    ignoreParent = ignoreParent || false;
    return function(model, excludes, includes) {
        var style = {};
        for(var i = 0; i < properties.length; i++){
            var propName = properties[i][1];
            if (excludes && $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(excludes, propName) >= 0 || includes && $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(includes, propName) < 0) continue;
            var val = model.getShallow(propName, ignoreParent);
            if (val != null) style[properties[i][0]] = val;
        }
        // TODO Text or image?
        return style;
    };
}


var $cb2a96727da5284d$export$52de6e304d934d85 = [
    [
        "fill",
        "color"
    ],
    [
        "shadowBlur"
    ],
    [
        "shadowOffsetX"
    ],
    [
        "shadowOffsetY"
    ],
    [
        "opacity"
    ],
    [
        "shadowColor"
    ]
];
var $cb2a96727da5284d$var$getAreaStyle = (0, $06542048a26d4d91$export$2e2bcd8739ae039)($cb2a96727da5284d$export$52de6e304d934d85);
var $cb2a96727da5284d$export$a3a0ed7e2dd84c9e = /** @class */ function() {
    function AreaStyleMixin() {}
    AreaStyleMixin.prototype.getAreaStyle = function(excludes, includes) {
        return $cb2a96727da5284d$var$getAreaStyle(this, excludes, includes);
    };
    return AreaStyleMixin;
}();


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $a53bd598adfb7ebe$var$globalImageCache = new (0, $d91b0b6fc564d9c7$export$2e2bcd8739ae039)(50);
function $a53bd598adfb7ebe$export$1b614f30ac2c8867(newImageOrSrc) {
    if (typeof newImageOrSrc === "string") {
        var cachedImgObj = $a53bd598adfb7ebe$var$globalImageCache.get(newImageOrSrc);
        return cachedImgObj && cachedImgObj.image;
    } else return newImageOrSrc;
}
function $a53bd598adfb7ebe$export$46c791b69ff9a0f(newImageOrSrc, image, hostEl, onload, cbPayload) {
    if (!newImageOrSrc) return image;
    else if (typeof newImageOrSrc === "string") {
        if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) return image;
        var cachedImgObj = $a53bd598adfb7ebe$var$globalImageCache.get(newImageOrSrc);
        var pendingWrap = {
            hostEl: hostEl,
            cb: onload,
            cbPayload: cbPayload
        };
        if (cachedImgObj) {
            image = cachedImgObj.image;
            !$a53bd598adfb7ebe$export$37ca7dd901d0236d(image) && cachedImgObj.pending.push(pendingWrap);
        } else {
            image = (0, $c6341dcc9d86826e$export$ef5e599365494451).loadImage(newImageOrSrc, $a53bd598adfb7ebe$var$imageOnLoad, $a53bd598adfb7ebe$var$imageOnLoad);
            image.__zrImageSrc = newImageOrSrc;
            $a53bd598adfb7ebe$var$globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
                image: image,
                pending: [
                    pendingWrap
                ]
            });
        }
        return image;
    } else return newImageOrSrc;
}
function $a53bd598adfb7ebe$var$imageOnLoad() {
    var cachedImgObj = this.__cachedImgObj;
    this.onload = this.onerror = this.__cachedImgObj = null;
    for(var i = 0; i < cachedImgObj.pending.length; i++){
        var pendingWrap = cachedImgObj.pending[i];
        var cb = pendingWrap.cb;
        cb && cb(this, pendingWrap.cbPayload);
        pendingWrap.hostEl.dirty();
    }
    cachedImgObj.pending.length = 0;
}
function $a53bd598adfb7ebe$export$37ca7dd901d0236d(image) {
    return image && image.width && image.height;
}





var $64fa9b3825ba2dec$var$STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
function $64fa9b3825ba2dec$export$59a943b34a82e690(text, containerWidth, font, ellipsis, options) {
    var out = {};
    $64fa9b3825ba2dec$var$truncateText2(out, text, containerWidth, font, ellipsis, options);
    return out.text;
}
function $64fa9b3825ba2dec$var$truncateText2(out, text, containerWidth, font, ellipsis, options) {
    if (!containerWidth) {
        out.text = "";
        out.isTruncated = false;
        return;
    }
    var textLines = (text + "").split("\n");
    options = $64fa9b3825ba2dec$var$prepareTruncateOptions(containerWidth, font, ellipsis, options);
    var isTruncated = false;
    var truncateOut = {};
    for(var i = 0, len = textLines.length; i < len; i++){
        $64fa9b3825ba2dec$var$truncateSingleLine(truncateOut, textLines[i], options);
        textLines[i] = truncateOut.textLine;
        isTruncated = isTruncated || truncateOut.isTruncated;
    }
    out.text = textLines.join("\n");
    out.isTruncated = isTruncated;
}
function $64fa9b3825ba2dec$var$prepareTruncateOptions(containerWidth, font, ellipsis, options) {
    options = options || {};
    var preparedOpts = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, options);
    ellipsis = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(ellipsis, "...");
    preparedOpts.maxIterations = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(options.maxIterations, 2);
    var minChar = preparedOpts.minChar = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(options.minChar, 0);
    var fontMeasureInfo = preparedOpts.fontMeasureInfo = (0, $6c308355c7107803$export$23ef3ef10b010856)(font);
    var ascCharWidth = fontMeasureInfo.asciiCharWidth;
    preparedOpts.placeholder = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(options.placeholder, "");
    var contentWidth = containerWidth = Math.max(0, containerWidth - 1);
    for(var i = 0; i < minChar && contentWidth >= ascCharWidth; i++)contentWidth -= ascCharWidth;
    var ellipsisWidth = (0, $6c308355c7107803$export$e6849d91c2a0b61f)(fontMeasureInfo, ellipsis);
    if (ellipsisWidth > contentWidth) {
        ellipsis = "";
        ellipsisWidth = 0;
    }
    contentWidth = containerWidth - ellipsisWidth;
    preparedOpts.ellipsis = ellipsis;
    preparedOpts.ellipsisWidth = ellipsisWidth;
    preparedOpts.contentWidth = contentWidth;
    preparedOpts.containerWidth = containerWidth;
    return preparedOpts;
}
function $64fa9b3825ba2dec$var$truncateSingleLine(out, textLine, options) {
    var containerWidth = options.containerWidth;
    var contentWidth = options.contentWidth;
    var fontMeasureInfo = options.fontMeasureInfo;
    if (!containerWidth) {
        out.textLine = "";
        out.isTruncated = false;
        return;
    }
    var lineWidth = (0, $6c308355c7107803$export$e6849d91c2a0b61f)(fontMeasureInfo, textLine);
    if (lineWidth <= containerWidth) {
        out.textLine = textLine;
        out.isTruncated = false;
        return;
    }
    for(var j = 0;; j++){
        if (lineWidth <= contentWidth || j >= options.maxIterations) {
            textLine += options.ellipsis;
            break;
        }
        var subLength = j === 0 ? $64fa9b3825ba2dec$var$estimateLength(textLine, contentWidth, fontMeasureInfo) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
        textLine = textLine.substr(0, subLength);
        lineWidth = (0, $6c308355c7107803$export$e6849d91c2a0b61f)(fontMeasureInfo, textLine);
    }
    if (textLine === "") textLine = options.placeholder;
    out.textLine = textLine;
    out.isTruncated = true;
}
function $64fa9b3825ba2dec$var$estimateLength(text, contentWidth, fontMeasureInfo) {
    var width = 0;
    var i = 0;
    for(var len = text.length; i < len && width < contentWidth; i++)width += (0, $6c308355c7107803$export$4e92f5603b5c7bb3)(fontMeasureInfo, text.charCodeAt(i));
    return i;
}
function $64fa9b3825ba2dec$export$5772575e34ef80f9(rawText, style, defaultOuterWidth, defaultOuterHeight) {
    var text = $64fa9b3825ba2dec$var$formatText(rawText);
    var overflow = style.overflow;
    var padding = style.padding;
    var paddingH = padding ? padding[1] + padding[3] : 0;
    var paddingV = padding ? padding[0] + padding[2] : 0;
    var font = style.font;
    var truncate = overflow === "truncate";
    var calculatedLineHeight = (0, $6c308355c7107803$export$56204a27a2958a55)(font);
    var lineHeight = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(style.lineHeight, calculatedLineHeight);
    var truncateLineOverflow = style.lineOverflow === "truncate";
    var isTruncated = false;
    var width = style.width;
    if (width == null && defaultOuterWidth != null) width = defaultOuterWidth - paddingH;
    var height = style.height;
    if (height == null && defaultOuterHeight != null) height = defaultOuterHeight - paddingV;
    var lines;
    if (width != null && (overflow === "break" || overflow === "breakAll")) lines = text ? $64fa9b3825ba2dec$var$wrapText(text, style.font, width, overflow === "breakAll", 0).lines : [];
    else lines = text ? text.split("\n") : [];
    var contentHeight = lines.length * lineHeight;
    if (height == null) height = contentHeight;
    if (contentHeight > height && truncateLineOverflow) {
        var lineCount = Math.floor(height / lineHeight);
        isTruncated = isTruncated || lines.length > lineCount;
        lines = lines.slice(0, lineCount);
        contentHeight = lines.length * lineHeight;
    }
    if (text && truncate && width != null) {
        var options = $64fa9b3825ba2dec$var$prepareTruncateOptions(width, font, style.ellipsis, {
            minChar: style.truncateMinChar,
            placeholder: style.placeholder
        });
        var singleOut = {};
        for(var i = 0; i < lines.length; i++){
            $64fa9b3825ba2dec$var$truncateSingleLine(singleOut, lines[i], options);
            lines[i] = singleOut.textLine;
            isTruncated = isTruncated || singleOut.isTruncated;
        }
    }
    var outerHeight = height;
    var contentWidth = 0;
    var fontMeasureInfo = (0, $6c308355c7107803$export$23ef3ef10b010856)(font);
    for(var i = 0; i < lines.length; i++)contentWidth = Math.max((0, $6c308355c7107803$export$e6849d91c2a0b61f)(fontMeasureInfo, lines[i]), contentWidth);
    if (width == null) width = contentWidth;
    var outerWidth = width;
    outerHeight += paddingV;
    outerWidth += paddingH;
    return {
        lines: lines,
        height: height,
        outerWidth: outerWidth,
        outerHeight: outerHeight,
        lineHeight: lineHeight,
        calculatedLineHeight: calculatedLineHeight,
        contentWidth: contentWidth,
        contentHeight: contentHeight,
        width: width,
        isTruncated: isTruncated
    };
}
var $64fa9b3825ba2dec$var$RichTextToken = function() {
    function RichTextToken() {}
    return RichTextToken;
}();
var $64fa9b3825ba2dec$var$RichTextLine = function() {
    function RichTextLine(tokens) {
        this.tokens = [];
        if (tokens) this.tokens = tokens;
    }
    return RichTextLine;
}();
var $64fa9b3825ba2dec$export$ca607d3c98caaf7e = function() {
    function RichTextContentBlock() {
        this.width = 0;
        this.height = 0;
        this.contentWidth = 0;
        this.contentHeight = 0;
        this.outerWidth = 0;
        this.outerHeight = 0;
        this.lines = [];
        this.isTruncated = false;
    }
    return RichTextContentBlock;
}();
function $64fa9b3825ba2dec$export$15ec9472ff2d721(rawText, style, defaultOuterWidth, defaultOuterHeight, topTextAlign) {
    var contentBlock = new $64fa9b3825ba2dec$export$ca607d3c98caaf7e();
    var text = $64fa9b3825ba2dec$var$formatText(rawText);
    if (!text) return contentBlock;
    var stlPadding = style.padding;
    var stlPaddingH = stlPadding ? stlPadding[1] + stlPadding[3] : 0;
    var stlPaddingV = stlPadding ? stlPadding[0] + stlPadding[2] : 0;
    var topWidth = style.width;
    if (topWidth == null && defaultOuterWidth != null) topWidth = defaultOuterWidth - stlPaddingH;
    var topHeight = style.height;
    if (topHeight == null && defaultOuterHeight != null) topHeight = defaultOuterHeight - stlPaddingV;
    var overflow = style.overflow;
    var wrapInfo = (overflow === "break" || overflow === "breakAll") && topWidth != null ? {
        width: topWidth,
        accumWidth: 0,
        breakAll: overflow === "breakAll"
    } : null;
    var lastIndex = $64fa9b3825ba2dec$var$STYLE_REG.lastIndex = 0;
    var result;
    while((result = $64fa9b3825ba2dec$var$STYLE_REG.exec(text)) != null){
        var matchedIndex = result.index;
        if (matchedIndex > lastIndex) $64fa9b3825ba2dec$var$pushTokens(contentBlock, text.substring(lastIndex, matchedIndex), style, wrapInfo);
        $64fa9b3825ba2dec$var$pushTokens(contentBlock, result[2], style, wrapInfo, result[1]);
        lastIndex = $64fa9b3825ba2dec$var$STYLE_REG.lastIndex;
    }
    if (lastIndex < text.length) $64fa9b3825ba2dec$var$pushTokens(contentBlock, text.substring(lastIndex, text.length), style, wrapInfo);
    var pendingList = [];
    var calculatedHeight = 0;
    var calculatedWidth = 0;
    var truncate = overflow === "truncate";
    var truncateLine = style.lineOverflow === "truncate";
    var tmpTruncateOut = {};
    function finishLine(line, lineWidth, lineHeight) {
        line.width = lineWidth;
        line.lineHeight = lineHeight;
        calculatedHeight += lineHeight;
        calculatedWidth = Math.max(calculatedWidth, lineWidth);
    }
    outer: for(var i = 0; i < contentBlock.lines.length; i++){
        var line = contentBlock.lines[i];
        var lineHeight = 0;
        var lineWidth = 0;
        for(var j = 0; j < line.tokens.length; j++){
            var token = line.tokens[j];
            var tokenStyle = token.styleName && style.rich[token.styleName] || {};
            var textPadding = token.textPadding = tokenStyle.padding;
            var paddingH = textPadding ? textPadding[1] + textPadding[3] : 0;
            var font = token.font = tokenStyle.font || style.font;
            token.contentHeight = (0, $6c308355c7107803$export$56204a27a2958a55)(font);
            var tokenHeight = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(tokenStyle.height, token.contentHeight);
            token.innerHeight = tokenHeight;
            textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
            token.height = tokenHeight;
            token.lineHeight = (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(tokenStyle.lineHeight, style.lineHeight, tokenHeight);
            token.align = tokenStyle && tokenStyle.align || topTextAlign;
            token.verticalAlign = tokenStyle && tokenStyle.verticalAlign || "middle";
            if (truncateLine && topHeight != null && calculatedHeight + token.lineHeight > topHeight) {
                var originalLength = contentBlock.lines.length;
                if (j > 0) {
                    line.tokens = line.tokens.slice(0, j);
                    finishLine(line, lineWidth, lineHeight);
                    contentBlock.lines = contentBlock.lines.slice(0, i + 1);
                } else contentBlock.lines = contentBlock.lines.slice(0, i);
                contentBlock.isTruncated = contentBlock.isTruncated || contentBlock.lines.length < originalLength;
                break outer;
            }
            var styleTokenWidth = tokenStyle.width;
            var tokenWidthNotSpecified = styleTokenWidth == null || styleTokenWidth === "auto";
            if (typeof styleTokenWidth === "string" && styleTokenWidth.charAt(styleTokenWidth.length - 1) === "%") {
                token.percentWidth = styleTokenWidth;
                pendingList.push(token);
                token.contentWidth = (0, $6c308355c7107803$export$e6849d91c2a0b61f)((0, $6c308355c7107803$export$23ef3ef10b010856)(font), token.text);
            } else {
                if (tokenWidthNotSpecified) {
                    var textBackgroundColor = tokenStyle.backgroundColor;
                    var bgImg = textBackgroundColor && textBackgroundColor.image;
                    if (bgImg) {
                        bgImg = $a53bd598adfb7ebe$export$1b614f30ac2c8867(bgImg);
                        if ($a53bd598adfb7ebe$export$37ca7dd901d0236d(bgImg)) token.width = Math.max(token.width, bgImg.width * tokenHeight / bgImg.height);
                    }
                }
                var remainTruncWidth = truncate && topWidth != null ? topWidth - lineWidth : null;
                if (remainTruncWidth != null && remainTruncWidth < token.width) {
                    if (!tokenWidthNotSpecified || remainTruncWidth < paddingH) {
                        token.text = "";
                        token.width = token.contentWidth = 0;
                    } else {
                        $64fa9b3825ba2dec$var$truncateText2(tmpTruncateOut, token.text, remainTruncWidth - paddingH, font, style.ellipsis, {
                            minChar: style.truncateMinChar
                        });
                        token.text = tmpTruncateOut.text;
                        contentBlock.isTruncated = contentBlock.isTruncated || tmpTruncateOut.isTruncated;
                        token.width = token.contentWidth = (0, $6c308355c7107803$export$e6849d91c2a0b61f)((0, $6c308355c7107803$export$23ef3ef10b010856)(font), token.text);
                    }
                } else token.contentWidth = (0, $6c308355c7107803$export$e6849d91c2a0b61f)((0, $6c308355c7107803$export$23ef3ef10b010856)(font), token.text);
            }
            token.width += paddingH;
            lineWidth += token.width;
            tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
        }
        finishLine(line, lineWidth, lineHeight);
    }
    contentBlock.outerWidth = contentBlock.width = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(topWidth, calculatedWidth);
    contentBlock.outerHeight = contentBlock.height = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(topHeight, calculatedHeight);
    contentBlock.contentHeight = calculatedHeight;
    contentBlock.contentWidth = calculatedWidth;
    contentBlock.outerWidth += stlPaddingH;
    contentBlock.outerHeight += stlPaddingV;
    for(var i = 0; i < pendingList.length; i++){
        var token = pendingList[i];
        var percentWidth = token.percentWidth;
        token.width = parseInt(percentWidth, 10) / 100 * contentBlock.width;
    }
    return contentBlock;
}
function $64fa9b3825ba2dec$var$pushTokens(block, str, style, wrapInfo, styleName) {
    var isEmptyStr = str === "";
    var tokenStyle = styleName && style.rich[styleName] || {};
    var lines = block.lines;
    var font = tokenStyle.font || style.font;
    var newLine = false;
    var strLines;
    var linesWidths;
    if (wrapInfo) {
        var tokenPadding = tokenStyle.padding;
        var tokenPaddingH = tokenPadding ? tokenPadding[1] + tokenPadding[3] : 0;
        if (tokenStyle.width != null && tokenStyle.width !== "auto") {
            var outerWidth_1 = (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(tokenStyle.width, wrapInfo.width) + tokenPaddingH;
            if (lines.length > 0) {
                if (outerWidth_1 + wrapInfo.accumWidth > wrapInfo.width) {
                    strLines = str.split("\n");
                    newLine = true;
                }
            }
            wrapInfo.accumWidth = outerWidth_1;
        } else {
            var res = $64fa9b3825ba2dec$var$wrapText(str, font, wrapInfo.width, wrapInfo.breakAll, wrapInfo.accumWidth);
            wrapInfo.accumWidth = res.accumWidth + tokenPaddingH;
            linesWidths = res.linesWidths;
            strLines = res.lines;
        }
    }
    if (!strLines) strLines = str.split("\n");
    var fontMeasureInfo = (0, $6c308355c7107803$export$23ef3ef10b010856)(font);
    for(var i = 0; i < strLines.length; i++){
        var text = strLines[i];
        var token = new $64fa9b3825ba2dec$var$RichTextToken();
        token.styleName = styleName;
        token.text = text;
        token.isLineHolder = !text && !isEmptyStr;
        if (typeof tokenStyle.width === "number") token.width = tokenStyle.width;
        else token.width = linesWidths ? linesWidths[i] : (0, $6c308355c7107803$export$e6849d91c2a0b61f)(fontMeasureInfo, text);
        if (!i && !newLine) {
            var tokens = (lines[lines.length - 1] || (lines[0] = new $64fa9b3825ba2dec$var$RichTextLine())).tokens;
            var tokensLen = tokens.length;
            tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : (text || !tokensLen || isEmptyStr) && tokens.push(token);
        } else lines.push(new $64fa9b3825ba2dec$var$RichTextLine([
            token
        ]));
    }
}
function $64fa9b3825ba2dec$var$isAlphabeticLetter(ch) {
    var code = ch.charCodeAt(0);
    return code >= 0x20 && code <= 0x24F || code >= 0x370 && code <= 0x10FF || code >= 0x1200 && code <= 0x13FF || code >= 0x1E00 && code <= 0x206F;
}
var $64fa9b3825ba2dec$var$breakCharMap = (0, $7a1bd9c2710fea0d$export$533b26079ad0b4b)(",&?/;] ".split(""), function(obj, ch) {
    obj[ch] = true;
    return obj;
}, {});
function $64fa9b3825ba2dec$var$isWordBreakChar(ch) {
    if ($64fa9b3825ba2dec$var$isAlphabeticLetter(ch)) {
        if ($64fa9b3825ba2dec$var$breakCharMap[ch]) return true;
        return false;
    }
    return true;
}
function $64fa9b3825ba2dec$var$wrapText(text, font, lineWidth, isBreakAll, lastAccumWidth) {
    var lines = [];
    var linesWidths = [];
    var line = "";
    var currentWord = "";
    var currentWordWidth = 0;
    var accumWidth = 0;
    var fontMeasureInfo = (0, $6c308355c7107803$export$23ef3ef10b010856)(font);
    for(var i = 0; i < text.length; i++){
        var ch = text.charAt(i);
        if (ch === "\n") {
            if (currentWord) {
                line += currentWord;
                accumWidth += currentWordWidth;
            }
            lines.push(line);
            linesWidths.push(accumWidth);
            line = "";
            currentWord = "";
            currentWordWidth = 0;
            accumWidth = 0;
            continue;
        }
        var chWidth = (0, $6c308355c7107803$export$4e92f5603b5c7bb3)(fontMeasureInfo, ch.charCodeAt(0));
        var inWord = isBreakAll ? false : !$64fa9b3825ba2dec$var$isWordBreakChar(ch);
        if (!lines.length ? lastAccumWidth + accumWidth + chWidth > lineWidth : accumWidth + chWidth > lineWidth) {
            if (!accumWidth) {
                if (inWord) {
                    lines.push(currentWord);
                    linesWidths.push(currentWordWidth);
                    currentWord = ch;
                    currentWordWidth = chWidth;
                } else {
                    lines.push(ch);
                    linesWidths.push(chWidth);
                }
            } else if (line || currentWord) {
                if (inWord) {
                    if (!line) {
                        line = currentWord;
                        currentWord = "";
                        currentWordWidth = 0;
                        accumWidth = currentWordWidth;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth - currentWordWidth);
                    currentWord += ch;
                    currentWordWidth += chWidth;
                    line = "";
                    accumWidth = currentWordWidth;
                } else {
                    if (currentWord) {
                        line += currentWord;
                        currentWord = "";
                        currentWordWidth = 0;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth);
                    line = ch;
                    accumWidth = chWidth;
                }
            }
            continue;
        }
        accumWidth += chWidth;
        if (inWord) {
            currentWord += ch;
            currentWordWidth += chWidth;
        } else {
            if (currentWord) {
                line += currentWord;
                currentWord = "";
                currentWordWidth = 0;
            }
            line += ch;
        }
    }
    if (currentWord) line += currentWord;
    if (line) {
        lines.push(line);
        linesWidths.push(accumWidth);
    }
    if (lines.length === 1) accumWidth += lastAccumWidth;
    return {
        accumWidth: accumWidth,
        lines: lines,
        linesWidths: linesWidths
    };
}
function $64fa9b3825ba2dec$export$9a4428591d825b14(out, overflowRect, baseX, baseY, textAlign, textVerticalAlign) {
    out.baseX = baseX;
    out.baseY = baseY;
    out.outerWidth = out.outerHeight = null;
    if (!overflowRect) return;
    var textWidth = overflowRect.width * 2;
    var textHeight = overflowRect.height * 2;
    (0, $1bebe7106c895823$export$2e2bcd8739ae039).set($64fa9b3825ba2dec$var$tmpCITCTextRect, (0, $6c308355c7107803$export$eb5a525ef00ef9a4)(baseX, textWidth, textAlign), (0, $6c308355c7107803$export$bf7d6802d2badd9)(baseY, textHeight, textVerticalAlign), textWidth, textHeight);
    (0, $1bebe7106c895823$export$2e2bcd8739ae039).intersect(overflowRect, $64fa9b3825ba2dec$var$tmpCITCTextRect, null, $64fa9b3825ba2dec$var$tmpCITCIntersectRectOpt);
    var outIntersectRect = $64fa9b3825ba2dec$var$tmpCITCIntersectRectOpt.outIntersectRect;
    out.outerWidth = outIntersectRect.width;
    out.outerHeight = outIntersectRect.height;
    out.baseX = (0, $6c308355c7107803$export$eb5a525ef00ef9a4)(outIntersectRect.x, outIntersectRect.width, textAlign, true);
    out.baseY = (0, $6c308355c7107803$export$bf7d6802d2badd9)(outIntersectRect.y, outIntersectRect.height, textVerticalAlign, true);
}
var $64fa9b3825ba2dec$var$tmpCITCTextRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $64fa9b3825ba2dec$var$tmpCITCIntersectRectOpt = {
    outIntersectRect: {},
    clamp: true
};
function $64fa9b3825ba2dec$var$formatText(text) {
    return text != null ? text += "" : text = "";
}
function $64fa9b3825ba2dec$export$d79289ac0f53b974(style) {
    var text = $64fa9b3825ba2dec$var$formatText(style.text);
    var font = style.font;
    var contentWidth = (0, $6c308355c7107803$export$e6849d91c2a0b61f)((0, $6c308355c7107803$export$23ef3ef10b010856)(font), text);
    var contentHeight = (0, $6c308355c7107803$export$56204a27a2958a55)(font);
    return $64fa9b3825ba2dec$export$bd5d12d7bf7c9027(style, contentWidth, contentHeight, null);
}
function $64fa9b3825ba2dec$export$bd5d12d7bf7c9027(style, contentWidth, contentHeight, forceLineWidth) {
    var rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)((0, $6c308355c7107803$export$eb5a525ef00ef9a4)(style.x || 0, contentWidth, style.textAlign), (0, $6c308355c7107803$export$bf7d6802d2badd9)(style.y || 0, contentHeight, style.textBaseline), contentWidth, contentHeight);
    var lineWidth = forceLineWidth != null ? forceLineWidth : $64fa9b3825ba2dec$export$c7aae0ffd99a8643(style) ? style.lineWidth : 0;
    if (lineWidth > 0) {
        rect.x -= lineWidth / 2;
        rect.y -= lineWidth / 2;
        rect.width += lineWidth;
        rect.height += lineWidth;
    }
    return rect;
}
function $64fa9b3825ba2dec$export$c7aae0ffd99a8643(style) {
    var stroke = style.stroke;
    return stroke != null && stroke !== "none" && style.lineWidth > 0;
}








var $56206a6cb4666931$var$STYLE_MAGIC_KEY = "__zr_style_" + Math.round(Math.random() * 10);
var $56206a6cb4666931$export$737672163db00fe3 = {
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    shadowColor: "#000",
    opacity: 1,
    blend: "source-over"
};
var $56206a6cb4666931$export$9908943fb57fbe51 = {
    style: {
        shadowBlur: true,
        shadowOffsetX: true,
        shadowOffsetY: true,
        shadowColor: true,
        opacity: true
    }
};
$56206a6cb4666931$export$737672163db00fe3[$56206a6cb4666931$var$STYLE_MAGIC_KEY] = true;
var $56206a6cb4666931$var$PRIMARY_STATES_KEYS = [
    "z",
    "z2",
    "invisible"
];
var $56206a6cb4666931$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER = [
    "invisible"
];
var $56206a6cb4666931$var$Displayable = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Displayable, _super);
    function Displayable(props) {
        return _super.call(this, props) || this;
    }
    Displayable.prototype._init = function(props) {
        var keysArr = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(props);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            if (key === "style") this.useStyle(props[key]);
            else _super.prototype.attrKV.call(this, key, props[key]);
        }
        if (!this.style) this.useStyle({});
    };
    Displayable.prototype.beforeBrush = function() {};
    Displayable.prototype.afterBrush = function() {};
    Displayable.prototype.innerBeforeBrush = function() {};
    Displayable.prototype.innerAfterBrush = function() {};
    Displayable.prototype.shouldBePainted = function(viewWidth, viewHeight, considerClipPath, considerAncestors) {
        var m = this.transform;
        if (this.ignore || this.invisible || this.style.opacity === 0 || this.culling && $56206a6cb4666931$var$isDisplayableCulled(this, viewWidth, viewHeight) || m && !m[0] && !m[3]) return false;
        if (considerClipPath && this.__clipPaths && this.__clipPaths.length) for(var i = 0; i < this.__clipPaths.length; ++i){
            if (this.__clipPaths[i].isZeroArea()) return false;
        }
        if (considerAncestors && this.parent) {
            var parent_1 = this.parent;
            while(parent_1){
                if (parent_1.ignore) return false;
                parent_1 = parent_1.parent;
            }
        }
        return true;
    };
    Displayable.prototype.contain = function(x, y) {
        return this.rectContain(x, y);
    };
    Displayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    Displayable.prototype.rectContain = function(x, y) {
        var coord = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        return rect.contain(coord[0], coord[1]);
    };
    Displayable.prototype.getPaintRect = function() {
        var rect = this._paintRect;
        if (!this._paintRect || this.__dirty) {
            var transform = this.transform;
            var elRect = this.getBoundingRect();
            var style = this.style;
            var shadowSize = style.shadowBlur || 0;
            var shadowOffsetX = style.shadowOffsetX || 0;
            var shadowOffsetY = style.shadowOffsetY || 0;
            rect = this._paintRect || (this._paintRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0));
            if (transform) (0, $1bebe7106c895823$export$2e2bcd8739ae039).applyTransform(rect, elRect, transform);
            else rect.copy(elRect);
            if (shadowSize || shadowOffsetX || shadowOffsetY) {
                rect.width += shadowSize * 2 + Math.abs(shadowOffsetX);
                rect.height += shadowSize * 2 + Math.abs(shadowOffsetY);
                rect.x = Math.min(rect.x, rect.x + shadowOffsetX - shadowSize);
                rect.y = Math.min(rect.y, rect.y + shadowOffsetY - shadowSize);
            }
            var tolerance = this.dirtyRectTolerance;
            if (!rect.isZero()) {
                rect.x = Math.floor(rect.x - tolerance);
                rect.y = Math.floor(rect.y - tolerance);
                rect.width = Math.ceil(rect.width + 1 + tolerance * 2);
                rect.height = Math.ceil(rect.height + 1 + tolerance * 2);
            }
        }
        return rect;
    };
    Displayable.prototype.setPrevPaintRect = function(paintRect) {
        if (paintRect) {
            this._prevPaintRect = this._prevPaintRect || new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
            this._prevPaintRect.copy(paintRect);
        } else this._prevPaintRect = null;
    };
    Displayable.prototype.getPrevPaintRect = function() {
        return this._prevPaintRect;
    };
    Displayable.prototype.animateStyle = function(loop) {
        return this.animate("style", loop);
    };
    Displayable.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === "style") this.dirtyStyle();
        else this.markRedraw();
    };
    Displayable.prototype.attrKV = function(key, value) {
        if (key !== "style") _super.prototype.attrKV.call(this, key, value);
        else if (!this.style) this.useStyle(value);
        else this.setStyle(value);
    };
    Displayable.prototype.setStyle = function(keyOrObj, value) {
        if (typeof keyOrObj === "string") this.style[keyOrObj] = value;
        else (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(this.style, keyOrObj);
        this.dirtyStyle();
        return this;
    };
    Displayable.prototype.dirtyStyle = function(notRedraw) {
        if (!notRedraw) this.markRedraw();
        this.__dirty |= (0, $ddf76b16f1246ba9$export$ada8b2beb3d76671);
        if (this._rect) this._rect = null;
    };
    Displayable.prototype.dirty = function() {
        this.dirtyStyle();
    };
    Displayable.prototype.styleChanged = function() {
        return !!(this.__dirty & (0, $ddf76b16f1246ba9$export$ada8b2beb3d76671));
    };
    Displayable.prototype.styleUpdated = function() {
        this.__dirty &= ~(0, $ddf76b16f1246ba9$export$ada8b2beb3d76671);
    };
    Displayable.prototype.createStyle = function(obj) {
        return (0, $7a1bd9c2710fea0d$export$79c7e160a7743efd)($56206a6cb4666931$export$737672163db00fe3, obj);
    };
    Displayable.prototype.useStyle = function(obj) {
        if (!obj[$56206a6cb4666931$var$STYLE_MAGIC_KEY]) obj = this.createStyle(obj);
        if (this.__inHover) this.__hoverStyle = obj;
        else this.style = obj;
        this.dirtyStyle();
    };
    Displayable.prototype.isStyleObject = function(obj) {
        return obj[$56206a6cb4666931$var$STYLE_MAGIC_KEY];
    };
    Displayable.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.style && !normalState.style) normalState.style = this._mergeStyle(this.createStyle(), this.style);
        this._savePrimaryToNormal(toState, normalState, $56206a6cb4666931$var$PRIMARY_STATES_KEYS);
    };
    Displayable.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetStyle;
        if (state && state.style) {
            if (transition) {
                if (keepCurrentStates) targetStyle = state.style;
                else {
                    targetStyle = this._mergeStyle(this.createStyle(), normalState.style);
                    this._mergeStyle(targetStyle, state.style);
                }
            } else {
                targetStyle = this._mergeStyle(this.createStyle(), keepCurrentStates ? this.style : normalState.style);
                this._mergeStyle(targetStyle, state.style);
            }
        } else if (needsRestoreToNormal) targetStyle = normalState.style;
        if (targetStyle) {
            if (transition) {
                var sourceStyle = this.style;
                this.style = this.createStyle(needsRestoreToNormal ? {} : sourceStyle);
                if (needsRestoreToNormal) {
                    var changedKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(sourceStyle);
                    for(var i = 0; i < changedKeys.length; i++){
                        var key = changedKeys[i];
                        if (key in targetStyle) {
                            targetStyle[key] = targetStyle[key];
                            this.style[key] = sourceStyle[key];
                        }
                    }
                }
                var targetKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(targetStyle);
                for(var i = 0; i < targetKeys.length; i++){
                    var key = targetKeys[i];
                    this.style[key] = this.style[key];
                }
                this._transitionState(stateName, {
                    style: targetStyle
                }, animationCfg, this.getAnimationStyleProps());
            } else this.useStyle(targetStyle);
        }
        var statesKeys = this.__inHover ? $56206a6cb4666931$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER : $56206a6cb4666931$var$PRIMARY_STATES_KEYS;
        for(var i = 0; i < statesKeys.length; i++){
            var key = statesKeys[i];
            if (state && state[key] != null) this[key] = state[key];
            else if (needsRestoreToNormal) {
                if (normalState[key] != null) this[key] = normalState[key];
            }
        }
    };
    Displayable.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedStyle;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.style) {
                mergedStyle = mergedStyle || {};
                this._mergeStyle(mergedStyle, state.style);
            }
        }
        if (mergedStyle) mergedState.style = mergedStyle;
        return mergedState;
    };
    Displayable.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(targetStyle, sourceStyle);
        return targetStyle;
    };
    Displayable.prototype.getAnimationStyleProps = function() {
        return $56206a6cb4666931$export$9908943fb57fbe51;
    };
    Displayable.initDefaultProps = function() {
        var dispProto = Displayable.prototype;
        dispProto.type = "displayable";
        dispProto.invisible = false;
        dispProto.z = 0;
        dispProto.z2 = 0;
        dispProto.zlevel = 0;
        dispProto.culling = false;
        dispProto.cursor = "pointer";
        dispProto.rectHover = false;
        dispProto.incremental = false;
        dispProto._rect = null;
        dispProto.dirtyRectTolerance = 0;
        dispProto.__dirty = (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd) | (0, $ddf76b16f1246ba9$export$ada8b2beb3d76671);
    }();
    return Displayable;
}((0, $4bb0f26b847654d5$export$2e2bcd8739ae039));
var $56206a6cb4666931$var$tmpRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $56206a6cb4666931$var$viewRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
function $56206a6cb4666931$var$isDisplayableCulled(el, width, height) {
    $56206a6cb4666931$var$tmpRect.copy(el.getBoundingRect());
    if (el.transform) $56206a6cb4666931$var$tmpRect.applyTransform(el.transform);
    $56206a6cb4666931$var$viewRect.width = width;
    $56206a6cb4666931$var$viewRect.height = height;
    return !$56206a6cb4666931$var$tmpRect.intersect($56206a6cb4666931$var$viewRect);
}
var $56206a6cb4666931$export$2e2bcd8739ae039 = $56206a6cb4666931$var$Displayable;









var $af3aab2435198f82$var$mathMin = Math.min;
var $af3aab2435198f82$var$mathMax = Math.max;
var $af3aab2435198f82$var$mathSin = Math.sin;
var $af3aab2435198f82$var$mathCos = Math.cos;
var $af3aab2435198f82$var$PI2 = Math.PI * 2;
var $af3aab2435198f82$var$start = $6de594cf8ac295ff$export$185802fd694ee1f5();
var $af3aab2435198f82$var$end = $6de594cf8ac295ff$export$185802fd694ee1f5();
var $af3aab2435198f82$var$extremity = $6de594cf8ac295ff$export$185802fd694ee1f5();
function $af3aab2435198f82$export$188c3cd07b4129dd(points, min, max) {
    if (points.length === 0) return;
    var p = points[0];
    var left = p[0];
    var right = p[0];
    var top = p[1];
    var bottom = p[1];
    for(var i = 1; i < points.length; i++){
        p = points[i];
        left = $af3aab2435198f82$var$mathMin(left, p[0]);
        right = $af3aab2435198f82$var$mathMax(right, p[0]);
        top = $af3aab2435198f82$var$mathMin(top, p[1]);
        bottom = $af3aab2435198f82$var$mathMax(bottom, p[1]);
    }
    min[0] = left;
    min[1] = top;
    max[0] = right;
    max[1] = bottom;
}
function $af3aab2435198f82$export$d2b1491e4450bf2c(x0, y0, x1, y1, min, max) {
    min[0] = $af3aab2435198f82$var$mathMin(x0, x1);
    min[1] = $af3aab2435198f82$var$mathMin(y0, y1);
    max[0] = $af3aab2435198f82$var$mathMax(x0, x1);
    max[1] = $af3aab2435198f82$var$mathMax(y0, y1);
}
var $af3aab2435198f82$var$xDim = [];
var $af3aab2435198f82$var$yDim = [];
function $af3aab2435198f82$export$c1bc6be456bb6609(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
    var cubicExtrema = $747cfc5611b57cea$export$df1a172f100d0457;
    var cubicAt = $747cfc5611b57cea$export$547c21de482bbcb2;
    var n = cubicExtrema(x0, x1, x2, x3, $af3aab2435198f82$var$xDim);
    min[0] = Infinity;
    min[1] = Infinity;
    max[0] = -Infinity;
    max[1] = -Infinity;
    for(var i = 0; i < n; i++){
        var x = cubicAt(x0, x1, x2, x3, $af3aab2435198f82$var$xDim[i]);
        min[0] = $af3aab2435198f82$var$mathMin(x, min[0]);
        max[0] = $af3aab2435198f82$var$mathMax(x, max[0]);
    }
    n = cubicExtrema(y0, y1, y2, y3, $af3aab2435198f82$var$yDim);
    for(var i = 0; i < n; i++){
        var y = cubicAt(y0, y1, y2, y3, $af3aab2435198f82$var$yDim[i]);
        min[1] = $af3aab2435198f82$var$mathMin(y, min[1]);
        max[1] = $af3aab2435198f82$var$mathMax(y, max[1]);
    }
    min[0] = $af3aab2435198f82$var$mathMin(x0, min[0]);
    max[0] = $af3aab2435198f82$var$mathMax(x0, max[0]);
    min[0] = $af3aab2435198f82$var$mathMin(x3, min[0]);
    max[0] = $af3aab2435198f82$var$mathMax(x3, max[0]);
    min[1] = $af3aab2435198f82$var$mathMin(y0, min[1]);
    max[1] = $af3aab2435198f82$var$mathMax(y0, max[1]);
    min[1] = $af3aab2435198f82$var$mathMin(y3, min[1]);
    max[1] = $af3aab2435198f82$var$mathMax(y3, max[1]);
}
function $af3aab2435198f82$export$16fbe795323a1f4c(x0, y0, x1, y1, x2, y2, min, max) {
    var quadraticExtremum = $747cfc5611b57cea$export$752e1f8c6e7f7e11;
    var quadraticAt = $747cfc5611b57cea$export$af17094a950f5073;
    var tx = $af3aab2435198f82$var$mathMax($af3aab2435198f82$var$mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
    var ty = $af3aab2435198f82$var$mathMax($af3aab2435198f82$var$mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
    var x = quadraticAt(x0, x1, x2, tx);
    var y = quadraticAt(y0, y1, y2, ty);
    min[0] = $af3aab2435198f82$var$mathMin(x0, x2, x);
    min[1] = $af3aab2435198f82$var$mathMin(y0, y2, y);
    max[0] = $af3aab2435198f82$var$mathMax(x0, x2, x);
    max[1] = $af3aab2435198f82$var$mathMax(y0, y2, y);
}
function $af3aab2435198f82$export$161c8bb0e1d9ef49(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
    var vec2Min = $6de594cf8ac295ff$export$96ec731ed4dcb222;
    var vec2Max = $6de594cf8ac295ff$export$8960430cfd85939f;
    var diff = Math.abs(startAngle - endAngle);
    if (diff % $af3aab2435198f82$var$PI2 < 1e-4 && diff > 1e-4) {
        min[0] = x - rx;
        min[1] = y - ry;
        max[0] = x + rx;
        max[1] = y + ry;
        return;
    }
    $af3aab2435198f82$var$start[0] = $af3aab2435198f82$var$mathCos(startAngle) * rx + x;
    $af3aab2435198f82$var$start[1] = $af3aab2435198f82$var$mathSin(startAngle) * ry + y;
    $af3aab2435198f82$var$end[0] = $af3aab2435198f82$var$mathCos(endAngle) * rx + x;
    $af3aab2435198f82$var$end[1] = $af3aab2435198f82$var$mathSin(endAngle) * ry + y;
    vec2Min(min, $af3aab2435198f82$var$start, $af3aab2435198f82$var$end);
    vec2Max(max, $af3aab2435198f82$var$start, $af3aab2435198f82$var$end);
    startAngle = startAngle % $af3aab2435198f82$var$PI2;
    if (startAngle < 0) startAngle = startAngle + $af3aab2435198f82$var$PI2;
    endAngle = endAngle % $af3aab2435198f82$var$PI2;
    if (endAngle < 0) endAngle = endAngle + $af3aab2435198f82$var$PI2;
    if (startAngle > endAngle && !anticlockwise) endAngle += $af3aab2435198f82$var$PI2;
    else if (startAngle < endAngle && anticlockwise) startAngle += $af3aab2435198f82$var$PI2;
    if (anticlockwise) {
        var tmp = endAngle;
        endAngle = startAngle;
        startAngle = tmp;
    }
    for(var angle = 0; angle < endAngle; angle += Math.PI / 2)if (angle > startAngle) {
        $af3aab2435198f82$var$extremity[0] = $af3aab2435198f82$var$mathCos(angle) * rx + x;
        $af3aab2435198f82$var$extremity[1] = $af3aab2435198f82$var$mathSin(angle) * ry + y;
        vec2Min(min, $af3aab2435198f82$var$extremity, min);
        vec2Max(max, $af3aab2435198f82$var$extremity, max);
    }
}



var $20ebe2448f123f2e$var$CMD = {
    M: 1,
    L: 2,
    C: 3,
    Q: 4,
    A: 5,
    Z: 6,
    R: 7
};
var $20ebe2448f123f2e$var$tmpOutX = [];
var $20ebe2448f123f2e$var$tmpOutY = [];
var $20ebe2448f123f2e$var$min = [];
var $20ebe2448f123f2e$var$max = [];
var $20ebe2448f123f2e$var$min2 = [];
var $20ebe2448f123f2e$var$max2 = [];
var $20ebe2448f123f2e$var$mathMin = Math.min;
var $20ebe2448f123f2e$var$mathMax = Math.max;
var $20ebe2448f123f2e$var$mathCos = Math.cos;
var $20ebe2448f123f2e$var$mathSin = Math.sin;
var $20ebe2448f123f2e$var$mathAbs = Math.abs;
var $20ebe2448f123f2e$var$PI = Math.PI;
var $20ebe2448f123f2e$var$PI2 = $20ebe2448f123f2e$var$PI * 2;
var $20ebe2448f123f2e$var$hasTypedArray = typeof Float32Array !== "undefined";
var $20ebe2448f123f2e$var$tmpAngles = [];
function $20ebe2448f123f2e$var$modPI2(radian) {
    var n = Math.round(radian / $20ebe2448f123f2e$var$PI * 1e8) / 1e8;
    return n % 2 * $20ebe2448f123f2e$var$PI;
}
function $20ebe2448f123f2e$export$bc668021e937022a(angles, anticlockwise) {
    var newStartAngle = $20ebe2448f123f2e$var$modPI2(angles[0]);
    if (newStartAngle < 0) newStartAngle += $20ebe2448f123f2e$var$PI2;
    var delta = newStartAngle - angles[0];
    var newEndAngle = angles[1];
    newEndAngle += delta;
    if (!anticlockwise && newEndAngle - newStartAngle >= $20ebe2448f123f2e$var$PI2) newEndAngle = newStartAngle + $20ebe2448f123f2e$var$PI2;
    else if (anticlockwise && newStartAngle - newEndAngle >= $20ebe2448f123f2e$var$PI2) newEndAngle = newStartAngle - $20ebe2448f123f2e$var$PI2;
    else if (!anticlockwise && newStartAngle > newEndAngle) newEndAngle = newStartAngle + ($20ebe2448f123f2e$var$PI2 - $20ebe2448f123f2e$var$modPI2(newStartAngle - newEndAngle));
    else if (anticlockwise && newStartAngle < newEndAngle) newEndAngle = newStartAngle - ($20ebe2448f123f2e$var$PI2 - $20ebe2448f123f2e$var$modPI2(newEndAngle - newStartAngle));
    angles[0] = newStartAngle;
    angles[1] = newEndAngle;
}
var $20ebe2448f123f2e$var$PathProxy = function() {
    function PathProxy(notSaveData) {
        this.dpr = 1;
        this._xi = 0;
        this._yi = 0;
        this._x0 = 0;
        this._y0 = 0;
        this._len = 0;
        if (notSaveData) this._saveData = false;
        if (this._saveData) this.data = [];
    }
    PathProxy.prototype.increaseVersion = function() {
        this._version++;
    };
    PathProxy.prototype.getVersion = function() {
        return this._version;
    };
    PathProxy.prototype.setScale = function(sx, sy, segmentIgnoreThreshold) {
        segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
        if (segmentIgnoreThreshold > 0) {
            this._ux = $20ebe2448f123f2e$var$mathAbs(segmentIgnoreThreshold / (0, $4b0cedd85979c776$export$508f096bfcdaac40) / sx) || 0;
            this._uy = $20ebe2448f123f2e$var$mathAbs(segmentIgnoreThreshold / (0, $4b0cedd85979c776$export$508f096bfcdaac40) / sy) || 0;
        }
    };
    PathProxy.prototype.setDPR = function(dpr) {
        this.dpr = dpr;
    };
    PathProxy.prototype.setContext = function(ctx) {
        this._ctx = ctx;
    };
    PathProxy.prototype.getContext = function() {
        return this._ctx;
    };
    PathProxy.prototype.beginPath = function() {
        this._ctx && this._ctx.beginPath();
        this.reset();
        return this;
    };
    PathProxy.prototype.reset = function() {
        if (this._saveData) this._len = 0;
        if (this._pathSegLen) {
            this._pathSegLen = null;
            this._pathLen = 0;
        }
        this._version++;
    };
    PathProxy.prototype.moveTo = function(x, y) {
        this._drawPendingPt();
        this.addData($20ebe2448f123f2e$var$CMD.M, x, y);
        this._ctx && this._ctx.moveTo(x, y);
        this._x0 = x;
        this._y0 = y;
        this._xi = x;
        this._yi = y;
        return this;
    };
    PathProxy.prototype.lineTo = function(x, y) {
        var dx = $20ebe2448f123f2e$var$mathAbs(x - this._xi);
        var dy = $20ebe2448f123f2e$var$mathAbs(y - this._yi);
        var exceedUnit = dx > this._ux || dy > this._uy;
        this.addData($20ebe2448f123f2e$var$CMD.L, x, y);
        if (this._ctx && exceedUnit) this._ctx.lineTo(x, y);
        if (exceedUnit) {
            this._xi = x;
            this._yi = y;
            this._pendingPtDist = 0;
        } else {
            var d2 = dx * dx + dy * dy;
            if (d2 > this._pendingPtDist) {
                this._pendingPtX = x;
                this._pendingPtY = y;
                this._pendingPtDist = d2;
            }
        }
        return this;
    };
    PathProxy.prototype.bezierCurveTo = function(x1, y1, x2, y2, x3, y3) {
        this._drawPendingPt();
        this.addData($20ebe2448f123f2e$var$CMD.C, x1, y1, x2, y2, x3, y3);
        if (this._ctx) this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
        this._xi = x3;
        this._yi = y3;
        return this;
    };
    PathProxy.prototype.quadraticCurveTo = function(x1, y1, x2, y2) {
        this._drawPendingPt();
        this.addData($20ebe2448f123f2e$var$CMD.Q, x1, y1, x2, y2);
        if (this._ctx) this._ctx.quadraticCurveTo(x1, y1, x2, y2);
        this._xi = x2;
        this._yi = y2;
        return this;
    };
    PathProxy.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
        this._drawPendingPt();
        $20ebe2448f123f2e$var$tmpAngles[0] = startAngle;
        $20ebe2448f123f2e$var$tmpAngles[1] = endAngle;
        $20ebe2448f123f2e$export$bc668021e937022a($20ebe2448f123f2e$var$tmpAngles, anticlockwise);
        startAngle = $20ebe2448f123f2e$var$tmpAngles[0];
        endAngle = $20ebe2448f123f2e$var$tmpAngles[1];
        var delta = endAngle - startAngle;
        this.addData($20ebe2448f123f2e$var$CMD.A, cx, cy, r, r, startAngle, delta, 0, anticlockwise ? 0 : 1);
        this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
        this._xi = $20ebe2448f123f2e$var$mathCos(endAngle) * r + cx;
        this._yi = $20ebe2448f123f2e$var$mathSin(endAngle) * r + cy;
        return this;
    };
    PathProxy.prototype.arcTo = function(x1, y1, x2, y2, radius) {
        this._drawPendingPt();
        if (this._ctx) this._ctx.arcTo(x1, y1, x2, y2, radius);
        return this;
    };
    PathProxy.prototype.rect = function(x, y, w, h) {
        this._drawPendingPt();
        this._ctx && this._ctx.rect(x, y, w, h);
        this.addData($20ebe2448f123f2e$var$CMD.R, x, y, w, h);
        return this;
    };
    PathProxy.prototype.closePath = function() {
        this._drawPendingPt();
        this.addData($20ebe2448f123f2e$var$CMD.Z);
        var ctx = this._ctx;
        var x0 = this._x0;
        var y0 = this._y0;
        if (ctx) ctx.closePath();
        this._xi = x0;
        this._yi = y0;
        return this;
    };
    PathProxy.prototype.fill = function(ctx) {
        ctx && ctx.fill();
        this.toStatic();
    };
    PathProxy.prototype.stroke = function(ctx) {
        ctx && ctx.stroke();
        this.toStatic();
    };
    PathProxy.prototype.len = function() {
        return this._len;
    };
    PathProxy.prototype.setData = function(data) {
        if (!this._saveData) return;
        var len = data.length;
        if (!(this.data && this.data.length === len) && $20ebe2448f123f2e$var$hasTypedArray) this.data = new Float32Array(len);
        for(var i = 0; i < len; i++)this.data[i] = data[i];
        this._len = len;
    };
    PathProxy.prototype.appendPath = function(path) {
        if (!this._saveData) return;
        if (!(path instanceof Array)) path = [
            path
        ];
        var len = path.length;
        var appendSize = 0;
        var offset = this._len;
        for(var i = 0; i < len; i++)appendSize += path[i].len();
        var oldData = this.data;
        if ($20ebe2448f123f2e$var$hasTypedArray && (oldData instanceof Float32Array || !oldData)) {
            this.data = new Float32Array(offset + appendSize);
            if (offset > 0 && oldData) for(var k = 0; k < offset; k++)this.data[k] = oldData[k];
        }
        for(var i = 0; i < len; i++){
            var appendPathData = path[i].data;
            for(var k = 0; k < appendPathData.length; k++)this.data[offset++] = appendPathData[k];
        }
        this._len = offset;
    };
    PathProxy.prototype.addData = function(cmd, a, b, c, d, e, f, g, h) {
        if (!this._saveData) return;
        var data = this.data;
        if (this._len + arguments.length > data.length) {
            this._expandData();
            data = this.data;
        }
        for(var i = 0; i < arguments.length; i++)data[this._len++] = arguments[i];
    };
    PathProxy.prototype._drawPendingPt = function() {
        if (this._pendingPtDist > 0) {
            this._ctx && this._ctx.lineTo(this._pendingPtX, this._pendingPtY);
            this._pendingPtDist = 0;
        }
    };
    PathProxy.prototype._expandData = function() {
        if (!(this.data instanceof Array)) {
            var newData = [];
            for(var i = 0; i < this._len; i++)newData[i] = this.data[i];
            this.data = newData;
        }
    };
    PathProxy.prototype.toStatic = function() {
        if (!this._saveData) return;
        this._drawPendingPt();
        var data = this.data;
        if (data instanceof Array) {
            data.length = this._len;
            if ($20ebe2448f123f2e$var$hasTypedArray && this._len > 11) this.data = new Float32Array(data);
        }
    };
    PathProxy.prototype.getBoundingRect = function() {
        $20ebe2448f123f2e$var$min[0] = $20ebe2448f123f2e$var$min[1] = $20ebe2448f123f2e$var$min2[0] = $20ebe2448f123f2e$var$min2[1] = Number.MAX_VALUE;
        $20ebe2448f123f2e$var$max[0] = $20ebe2448f123f2e$var$max[1] = $20ebe2448f123f2e$var$max2[0] = $20ebe2448f123f2e$var$max2[1] = -Number.MAX_VALUE;
        var data = this.data;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        var i;
        for(i = 0; i < this._len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            switch(cmd){
                case $20ebe2448f123f2e$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    $20ebe2448f123f2e$var$min2[0] = x0;
                    $20ebe2448f123f2e$var$min2[1] = y0;
                    $20ebe2448f123f2e$var$max2[0] = x0;
                    $20ebe2448f123f2e$var$max2[1] = y0;
                    break;
                case $20ebe2448f123f2e$var$CMD.L:
                    (0, $af3aab2435198f82$export$d2b1491e4450bf2c)(xi, yi, data[i], data[i + 1], $20ebe2448f123f2e$var$min2, $20ebe2448f123f2e$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $20ebe2448f123f2e$var$CMD.C:
                    (0, $af3aab2435198f82$export$c1bc6be456bb6609)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], $20ebe2448f123f2e$var$min2, $20ebe2448f123f2e$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $20ebe2448f123f2e$var$CMD.Q:
                    (0, $af3aab2435198f82$export$16fbe795323a1f4c)(xi, yi, data[i++], data[i++], data[i], data[i + 1], $20ebe2448f123f2e$var$min2, $20ebe2448f123f2e$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $20ebe2448f123f2e$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var endAngle = data[i++] + startAngle;
                    i += 1;
                    var anticlockwise = !data[i++];
                    if (isFirst) {
                        x0 = $20ebe2448f123f2e$var$mathCos(startAngle) * rx + cx;
                        y0 = $20ebe2448f123f2e$var$mathSin(startAngle) * ry + cy;
                    }
                    (0, $af3aab2435198f82$export$161c8bb0e1d9ef49)(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, $20ebe2448f123f2e$var$min2, $20ebe2448f123f2e$var$max2);
                    xi = $20ebe2448f123f2e$var$mathCos(endAngle) * rx + cx;
                    yi = $20ebe2448f123f2e$var$mathSin(endAngle) * ry + cy;
                    break;
                case $20ebe2448f123f2e$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    (0, $af3aab2435198f82$export$d2b1491e4450bf2c)(x0, y0, x0 + width, y0 + height, $20ebe2448f123f2e$var$min2, $20ebe2448f123f2e$var$max2);
                    break;
                case $20ebe2448f123f2e$var$CMD.Z:
                    xi = x0;
                    yi = y0;
                    break;
            }
            $6de594cf8ac295ff$export$96ec731ed4dcb222($20ebe2448f123f2e$var$min, $20ebe2448f123f2e$var$min, $20ebe2448f123f2e$var$min2);
            $6de594cf8ac295ff$export$8960430cfd85939f($20ebe2448f123f2e$var$max, $20ebe2448f123f2e$var$max, $20ebe2448f123f2e$var$max2);
        }
        if (i === 0) $20ebe2448f123f2e$var$min[0] = $20ebe2448f123f2e$var$min[1] = $20ebe2448f123f2e$var$max[0] = $20ebe2448f123f2e$var$max[1] = 0;
        return new (0, $1bebe7106c895823$export$2e2bcd8739ae039)($20ebe2448f123f2e$var$min[0], $20ebe2448f123f2e$var$min[1], $20ebe2448f123f2e$var$max[0] - $20ebe2448f123f2e$var$min[0], $20ebe2448f123f2e$var$max[1] - $20ebe2448f123f2e$var$min[1]);
    };
    PathProxy.prototype._calculateLength = function() {
        var data = this.data;
        var len = this._len;
        var ux = this._ux;
        var uy = this._uy;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        if (!this._pathSegLen) this._pathSegLen = [];
        var pathSegLen = this._pathSegLen;
        var pathTotalLen = 0;
        var segCount = 0;
        for(var i = 0; i < len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            var l = -1;
            switch(cmd){
                case $20ebe2448f123f2e$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    break;
                case $20ebe2448f123f2e$var$CMD.L:
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var dx = x2 - xi;
                    var dy = y2 - yi;
                    if ($20ebe2448f123f2e$var$mathAbs(dx) > ux || $20ebe2448f123f2e$var$mathAbs(dy) > uy || i === len - 1) {
                        l = Math.sqrt(dx * dx + dy * dy);
                        xi = x2;
                        yi = y2;
                    }
                    break;
                case $20ebe2448f123f2e$var$CMD.C:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var x3 = data[i++];
                    var y3 = data[i++];
                    l = (0, $747cfc5611b57cea$export$af1875d576f60d7c)(xi, yi, x1, y1, x2, y2, x3, y3, 10);
                    xi = x3;
                    yi = y3;
                    break;
                case $20ebe2448f123f2e$var$CMD.Q:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    l = (0, $747cfc5611b57cea$export$8a68adee46f3cf55)(xi, yi, x1, y1, x2, y2, 10);
                    xi = x2;
                    yi = y2;
                    break;
                case $20ebe2448f123f2e$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var delta = data[i++];
                    var endAngle = delta + startAngle;
                    i += 1;
                    if (isFirst) {
                        x0 = $20ebe2448f123f2e$var$mathCos(startAngle) * rx + cx;
                        y0 = $20ebe2448f123f2e$var$mathSin(startAngle) * ry + cy;
                    }
                    l = $20ebe2448f123f2e$var$mathMax(rx, ry) * $20ebe2448f123f2e$var$mathMin($20ebe2448f123f2e$var$PI2, Math.abs(delta));
                    xi = $20ebe2448f123f2e$var$mathCos(endAngle) * rx + cx;
                    yi = $20ebe2448f123f2e$var$mathSin(endAngle) * ry + cy;
                    break;
                case $20ebe2448f123f2e$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    l = width * 2 + height * 2;
                    break;
                case $20ebe2448f123f2e$var$CMD.Z:
                    var dx = x0 - xi;
                    var dy = y0 - yi;
                    l = Math.sqrt(dx * dx + dy * dy);
                    xi = x0;
                    yi = y0;
                    break;
            }
            if (l >= 0) {
                pathSegLen[segCount++] = l;
                pathTotalLen += l;
            }
        }
        this._pathLen = pathTotalLen;
        return pathTotalLen;
    };
    PathProxy.prototype.rebuildPath = function(ctx, percent) {
        var d = this.data;
        var ux = this._ux;
        var uy = this._uy;
        var len = this._len;
        var x0;
        var y0;
        var xi;
        var yi;
        var x;
        var y;
        var drawPart = percent < 1;
        var pathSegLen;
        var pathTotalLen;
        var accumLength = 0;
        var segCount = 0;
        var displayedLength;
        var pendingPtDist = 0;
        var pendingPtX;
        var pendingPtY;
        if (drawPart) {
            if (!this._pathSegLen) this._calculateLength();
            pathSegLen = this._pathSegLen;
            pathTotalLen = this._pathLen;
            displayedLength = percent * pathTotalLen;
            if (!displayedLength) return;
        }
        lo: for(var i = 0; i < len;){
            var cmd = d[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = d[i];
                yi = d[i + 1];
                x0 = xi;
                y0 = yi;
            }
            if (cmd !== $20ebe2448f123f2e$var$CMD.L && pendingPtDist > 0) {
                ctx.lineTo(pendingPtX, pendingPtY);
                pendingPtDist = 0;
            }
            switch(cmd){
                case $20ebe2448f123f2e$var$CMD.M:
                    x0 = xi = d[i++];
                    y0 = yi = d[i++];
                    ctx.moveTo(xi, yi);
                    break;
                case $20ebe2448f123f2e$var$CMD.L:
                    x = d[i++];
                    y = d[i++];
                    var dx = $20ebe2448f123f2e$var$mathAbs(x - xi);
                    var dy = $20ebe2448f123f2e$var$mathAbs(y - yi);
                    if (dx > ux || dy > uy) {
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var t = (displayedLength - accumLength) / l;
                                ctx.lineTo(xi * (1 - t) + x * t, yi * (1 - t) + y * t);
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.lineTo(x, y);
                        xi = x;
                        yi = y;
                        pendingPtDist = 0;
                    } else {
                        var d2 = dx * dx + dy * dy;
                        if (d2 > pendingPtDist) {
                            pendingPtX = x;
                            pendingPtY = y;
                            pendingPtDist = d2;
                        }
                    }
                    break;
                case $20ebe2448f123f2e$var$CMD.C:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    var x3 = d[i++];
                    var y3 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $747cfc5611b57cea$export$a2ee23a0567039da)(xi, x1, x2, x3, t, $20ebe2448f123f2e$var$tmpOutX);
                            (0, $747cfc5611b57cea$export$a2ee23a0567039da)(yi, y1, y2, y3, t, $20ebe2448f123f2e$var$tmpOutY);
                            ctx.bezierCurveTo($20ebe2448f123f2e$var$tmpOutX[1], $20ebe2448f123f2e$var$tmpOutY[1], $20ebe2448f123f2e$var$tmpOutX[2], $20ebe2448f123f2e$var$tmpOutY[2], $20ebe2448f123f2e$var$tmpOutX[3], $20ebe2448f123f2e$var$tmpOutY[3]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                    xi = x3;
                    yi = y3;
                    break;
                case $20ebe2448f123f2e$var$CMD.Q:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $747cfc5611b57cea$export$117c659e21a7a060)(xi, x1, x2, t, $20ebe2448f123f2e$var$tmpOutX);
                            (0, $747cfc5611b57cea$export$117c659e21a7a060)(yi, y1, y2, t, $20ebe2448f123f2e$var$tmpOutY);
                            ctx.quadraticCurveTo($20ebe2448f123f2e$var$tmpOutX[1], $20ebe2448f123f2e$var$tmpOutY[1], $20ebe2448f123f2e$var$tmpOutX[2], $20ebe2448f123f2e$var$tmpOutY[2]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.quadraticCurveTo(x1, y1, x2, y2);
                    xi = x2;
                    yi = y2;
                    break;
                case $20ebe2448f123f2e$var$CMD.A:
                    var cx = d[i++];
                    var cy = d[i++];
                    var rx = d[i++];
                    var ry = d[i++];
                    var startAngle = d[i++];
                    var delta = d[i++];
                    var psi = d[i++];
                    var anticlockwise = !d[i++];
                    var r = rx > ry ? rx : ry;
                    var isEllipse = $20ebe2448f123f2e$var$mathAbs(rx - ry) > 1e-3;
                    var endAngle = startAngle + delta;
                    var breakBuild = false;
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            endAngle = startAngle + delta * (displayedLength - accumLength) / l;
                            breakBuild = true;
                        }
                        accumLength += l;
                    }
                    if (isEllipse && ctx.ellipse) ctx.ellipse(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise);
                    else ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
                    if (breakBuild) break lo;
                    if (isFirst) {
                        x0 = $20ebe2448f123f2e$var$mathCos(startAngle) * rx + cx;
                        y0 = $20ebe2448f123f2e$var$mathSin(startAngle) * ry + cy;
                    }
                    xi = $20ebe2448f123f2e$var$mathCos(endAngle) * rx + cx;
                    yi = $20ebe2448f123f2e$var$mathSin(endAngle) * ry + cy;
                    break;
                case $20ebe2448f123f2e$var$CMD.R:
                    x0 = xi = d[i];
                    y0 = yi = d[i + 1];
                    x = d[i++];
                    y = d[i++];
                    var width = d[i++];
                    var height = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var d_1 = displayedLength - accumLength;
                            ctx.moveTo(x, y);
                            ctx.lineTo(x + $20ebe2448f123f2e$var$mathMin(d_1, width), y);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x + width, y + $20ebe2448f123f2e$var$mathMin(d_1, height));
                            d_1 -= height;
                            if (d_1 > 0) ctx.lineTo(x + $20ebe2448f123f2e$var$mathMax(width - d_1, 0), y + height);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x, y + $20ebe2448f123f2e$var$mathMax(height - d_1, 0));
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.rect(x, y, width, height);
                    break;
                case $20ebe2448f123f2e$var$CMD.Z:
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            ctx.lineTo(xi * (1 - t) + x0 * t, yi * (1 - t) + y0 * t);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.closePath();
                    xi = x0;
                    yi = y0;
            }
        }
    };
    PathProxy.prototype.clone = function() {
        var newProxy = new PathProxy();
        var data = this.data;
        newProxy.data = data.slice ? data.slice() : Array.prototype.slice.call(data);
        newProxy._len = this._len;
        return newProxy;
    };
    PathProxy.prototype.canSave = function() {
        return !!this._saveData;
    };
    PathProxy.CMD = $20ebe2448f123f2e$var$CMD;
    PathProxy.initDefaultProps = function() {
        var proto = PathProxy.prototype;
        proto._saveData = true;
        proto._ux = 0;
        proto._uy = 0;
        proto._pendingPtDist = 0;
        proto._version = 0;
    }();
    return PathProxy;
}();
var $20ebe2448f123f2e$export$2e2bcd8739ae039 = $20ebe2448f123f2e$var$PathProxy;



function $beafddd7270f4bea$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    var _a = 0;
    var _b = x0;
    if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) return false;
    if (x0 !== x1) {
        _a = (y0 - y1) / (x0 - x1);
        _b = (x0 * y1 - x1 * y0) / (x0 - x1);
    } else return Math.abs(x - x0) <= _l / 2;
    var tmp = _a * x - y + _b;
    var _s = tmp * tmp / (_a * _a + 1);
    return _s <= _l / 2 * _l / 2;
}



function $e22e0fd22a005e8a$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) return false;
    var d = $747cfc5611b57cea$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
    return d <= _l / 2;
}



function $a1d80a5bf05b597b$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) return false;
    var d = (0, $747cfc5611b57cea$export$81915a594fe10dee)(x0, y0, x1, y1, x2, y2, x, y, null);
    return d <= _l / 2;
}


var $b44a8536c7214e4f$var$PI2 = Math.PI * 2;
function $b44a8536c7214e4f$export$d44861331f213635(angle) {
    angle %= $b44a8536c7214e4f$var$PI2;
    if (angle < 0) angle += $b44a8536c7214e4f$var$PI2;
    return angle;
}


var $6e9b0f2fe4e39376$var$PI2 = Math.PI * 2;
function $6e9b0f2fe4e39376$export$8d36b1b5d19157c5(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    if (d - _l > r || d + _l < r) return false;
    if (Math.abs(startAngle - endAngle) % $6e9b0f2fe4e39376$var$PI2 < 1e-4) return true;
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(endAngle);
        endAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(tmp);
    } else {
        startAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(startAngle);
        endAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(endAngle);
    }
    if (startAngle > endAngle) endAngle += $6e9b0f2fe4e39376$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $6e9b0f2fe4e39376$var$PI2;
    return angle >= startAngle && angle <= endAngle || angle + $6e9b0f2fe4e39376$var$PI2 >= startAngle && angle + $6e9b0f2fe4e39376$var$PI2 <= endAngle;
}



function $e1acc0b10546155f$export$2e2bcd8739ae039(x0, y0, x1, y1, x, y) {
    if (y > y0 && y > y1 || y < y0 && y < y1) return 0;
    if (y1 === y0) return 0;
    var t = (y - y0) / (y1 - y0);
    var dir = y1 < y0 ? 1 : -1;
    if (t === 1 || t === 0) dir = y1 < y0 ? 0.5 : -0.5;
    var x_ = t * (x1 - x0) + x0;
    return x_ === x ? Infinity : x_ > x ? dir : 0;
}


var $347a114fcc5254ff$var$CMD = (0, $20ebe2448f123f2e$export$2e2bcd8739ae039).CMD;
var $347a114fcc5254ff$var$PI2 = Math.PI * 2;
var $347a114fcc5254ff$var$EPSILON = 1e-4;
function $347a114fcc5254ff$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $347a114fcc5254ff$var$EPSILON;
}
var $347a114fcc5254ff$var$roots = [
    -1,
    -1,
    -1
];
var $347a114fcc5254ff$var$extrema = [
    -1,
    -1
];
function $347a114fcc5254ff$var$swapExtrema() {
    var tmp = $347a114fcc5254ff$var$extrema[0];
    $347a114fcc5254ff$var$extrema[0] = $347a114fcc5254ff$var$extrema[1];
    $347a114fcc5254ff$var$extrema[1] = tmp;
}
function $347a114fcc5254ff$var$windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
    if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) return 0;
    var nRoots = $747cfc5611b57cea$export$ca5d13faa10b167e(y0, y1, y2, y3, y, $347a114fcc5254ff$var$roots);
    if (nRoots === 0) return 0;
    else {
        var w = 0;
        var nExtrema = -1;
        var y0_ = void 0;
        var y1_ = void 0;
        for(var i = 0; i < nRoots; i++){
            var t = $347a114fcc5254ff$var$roots[i];
            var unit = t === 0 || t === 1 ? 0.5 : 1;
            var x_ = $747cfc5611b57cea$export$547c21de482bbcb2(x0, x1, x2, x3, t);
            if (x_ < x) continue;
            if (nExtrema < 0) {
                nExtrema = $747cfc5611b57cea$export$df1a172f100d0457(y0, y1, y2, y3, $347a114fcc5254ff$var$extrema);
                if ($347a114fcc5254ff$var$extrema[1] < $347a114fcc5254ff$var$extrema[0] && nExtrema > 1) $347a114fcc5254ff$var$swapExtrema();
                y0_ = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, $347a114fcc5254ff$var$extrema[0]);
                if (nExtrema > 1) y1_ = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, $347a114fcc5254ff$var$extrema[1]);
            }
            if (nExtrema === 2) {
                if (t < $347a114fcc5254ff$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
                else if (t < $347a114fcc5254ff$var$extrema[1]) w += y1_ < y0_ ? unit : -unit;
                else w += y3 < y1_ ? unit : -unit;
            } else if (t < $347a114fcc5254ff$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
            else w += y3 < y0_ ? unit : -unit;
        }
        return w;
    }
}
function $347a114fcc5254ff$var$windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
    if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) return 0;
    var nRoots = $747cfc5611b57cea$export$fd895ac7ee764967(y0, y1, y2, y, $347a114fcc5254ff$var$roots);
    if (nRoots === 0) return 0;
    else {
        var t = $747cfc5611b57cea$export$752e1f8c6e7f7e11(y0, y1, y2);
        if (t >= 0 && t <= 1) {
            var w = 0;
            var y_ = $747cfc5611b57cea$export$af17094a950f5073(y0, y1, y2, t);
            for(var i = 0; i < nRoots; i++){
                var unit = $347a114fcc5254ff$var$roots[i] === 0 || $347a114fcc5254ff$var$roots[i] === 1 ? 0.5 : 1;
                var x_ = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, $347a114fcc5254ff$var$roots[i]);
                if (x_ < x) continue;
                if ($347a114fcc5254ff$var$roots[i] < t) w += y_ < y0 ? unit : -unit;
                else w += y2 < y_ ? unit : -unit;
            }
            return w;
        } else {
            var unit = $347a114fcc5254ff$var$roots[0] === 0 || $347a114fcc5254ff$var$roots[0] === 1 ? 0.5 : 1;
            var x_ = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, $347a114fcc5254ff$var$roots[0]);
            if (x_ < x) return 0;
            return y2 < y0 ? unit : -unit;
        }
    }
}
function $347a114fcc5254ff$var$windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
    y -= cy;
    if (y > r || y < -r) return 0;
    var tmp = Math.sqrt(r * r - y * y);
    $347a114fcc5254ff$var$roots[0] = -tmp;
    $347a114fcc5254ff$var$roots[1] = tmp;
    var dTheta = Math.abs(startAngle - endAngle);
    if (dTheta < 1e-4) return 0;
    if (dTheta >= $347a114fcc5254ff$var$PI2 - 1e-4) {
        startAngle = 0;
        endAngle = $347a114fcc5254ff$var$PI2;
        var dir = anticlockwise ? 1 : -1;
        if (x >= $347a114fcc5254ff$var$roots[0] + cx && x <= $347a114fcc5254ff$var$roots[1] + cx) return dir;
        else return 0;
    }
    if (startAngle > endAngle) {
        var tmp_1 = startAngle;
        startAngle = endAngle;
        endAngle = tmp_1;
    }
    if (startAngle < 0) {
        startAngle += $347a114fcc5254ff$var$PI2;
        endAngle += $347a114fcc5254ff$var$PI2;
    }
    var w = 0;
    for(var i = 0; i < 2; i++){
        var x_ = $347a114fcc5254ff$var$roots[i];
        if (x_ + cx > x) {
            var angle = Math.atan2(y, x_);
            var dir = anticlockwise ? 1 : -1;
            if (angle < 0) angle = $347a114fcc5254ff$var$PI2 + angle;
            if (angle >= startAngle && angle <= endAngle || angle + $347a114fcc5254ff$var$PI2 >= startAngle && angle + $347a114fcc5254ff$var$PI2 <= endAngle) {
                if (angle > Math.PI / 2 && angle < Math.PI * 1.5) dir = -dir;
                w += dir;
            }
        }
    }
    return w;
}
function $347a114fcc5254ff$var$containPath(path, lineWidth, isStroke, x, y) {
    var data = path.data;
    var len = path.len();
    var w = 0;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    for(var i = 0; i < len;){
        var cmd = data[i++];
        var isFirst = i === 1;
        if (cmd === $347a114fcc5254ff$var$CMD.M && i > 1) {
            if (!isStroke) w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y);
        }
        if (isFirst) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        switch(cmd){
            case $347a114fcc5254ff$var$CMD.M:
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $347a114fcc5254ff$var$CMD.L:
                if (isStroke) {
                    if ($beafddd7270f4bea$export$8d36b1b5d19157c5(xi, yi, data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(xi, yi, data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $347a114fcc5254ff$var$CMD.C:
                if (isStroke) {
                    if ($e22e0fd22a005e8a$export$8d36b1b5d19157c5(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $347a114fcc5254ff$var$windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $347a114fcc5254ff$var$CMD.Q:
                if (isStroke) {
                    if ($a1d80a5bf05b597b$export$8d36b1b5d19157c5(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $347a114fcc5254ff$var$windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $347a114fcc5254ff$var$CMD.A:
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++];
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy;
                if (!isFirst) w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(xi, yi, x1, y1, x, y);
                else {
                    x0 = x1;
                    y0 = y1;
                }
                var _x = (x - cx) * ry / rx + cx;
                if (isStroke) {
                    if ($6e9b0f2fe4e39376$export$8d36b1b5d19157c5(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) return true;
                } else w += $347a114fcc5254ff$var$windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $347a114fcc5254ff$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                x1 = x0 + width;
                y1 = y0 + height;
                if (isStroke) {
                    if ($beafddd7270f4bea$export$8d36b1b5d19157c5(x0, y0, x1, y0, lineWidth, x, y) || $beafddd7270f4bea$export$8d36b1b5d19157c5(x1, y0, x1, y1, lineWidth, x, y) || $beafddd7270f4bea$export$8d36b1b5d19157c5(x1, y1, x0, y1, lineWidth, x, y) || $beafddd7270f4bea$export$8d36b1b5d19157c5(x0, y1, x0, y0, lineWidth, x, y)) return true;
                } else {
                    w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(x1, y0, x1, y1, x, y);
                    w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(x0, y1, x0, y0, x, y);
                }
                break;
            case $347a114fcc5254ff$var$CMD.Z:
                if (isStroke) {
                    if ($beafddd7270f4bea$export$8d36b1b5d19157c5(xi, yi, x0, y0, lineWidth, x, y)) return true;
                } else w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y);
                xi = x0;
                yi = y0;
                break;
        }
    }
    if (!isStroke && !$347a114fcc5254ff$var$isAroundEqual(yi, y0)) w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y) || 0;
    return w !== 0;
}
function $347a114fcc5254ff$export$8893e2b90ba10d92(pathProxy, x, y) {
    return $347a114fcc5254ff$var$containPath(pathProxy, 0, false, x, y);
}
function $347a114fcc5254ff$export$8d36b1b5d19157c5(pathProxy, lineWidth, x, y) {
    return $347a114fcc5254ff$var$containPath(pathProxy, lineWidth, true, x, y);
}







var $b02ffe7acd508c08$export$deade517576e293a = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
    fill: "#000",
    stroke: null,
    strokePercent: 1,
    fillOpacity: 1,
    strokeOpacity: 1,
    lineDashOffset: 0,
    lineWidth: 1,
    lineCap: "butt",
    miterLimit: 10,
    strokeNoScale: false,
    strokeFirst: false
}, (0, $56206a6cb4666931$export$737672163db00fe3));
var $b02ffe7acd508c08$export$71bb6c3c6862c6a5 = {
    style: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        fill: true,
        stroke: true,
        strokePercent: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineDashOffset: true,
        lineWidth: true,
        miterLimit: true
    }, (0, $56206a6cb4666931$export$9908943fb57fbe51).style)
};
var $b02ffe7acd508c08$var$pathCopyParams = (0, $becf2d727f9cf450$export$98ab6203ec3396e2).concat([
    "invisible",
    "culling",
    "z",
    "z2",
    "zlevel",
    "parent"
]);
var $b02ffe7acd508c08$var$Path = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Path, _super);
    function Path(opts) {
        return _super.call(this, opts) || this;
    }
    Path.prototype.update = function() {
        var _this = this;
        _super.prototype.update.call(this);
        var style = this.style;
        if (style.decal) {
            var decalEl = this._decalEl = this._decalEl || new Path();
            if (decalEl.buildPath === Path.prototype.buildPath) decalEl.buildPath = function(ctx) {
                _this.buildPath(ctx, _this.shape);
            };
            decalEl.silent = true;
            var decalElStyle = decalEl.style;
            for(var key in style)if (decalElStyle[key] !== style[key]) decalElStyle[key] = style[key];
            decalElStyle.fill = style.fill ? style.decal : null;
            decalElStyle.decal = null;
            decalElStyle.shadowColor = null;
            style.strokeFirst && (decalElStyle.stroke = null);
            for(var i = 0; i < $b02ffe7acd508c08$var$pathCopyParams.length; ++i)decalEl[$b02ffe7acd508c08$var$pathCopyParams[i]] = this[$b02ffe7acd508c08$var$pathCopyParams[i]];
            decalEl.__dirty |= (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
        } else if (this._decalEl) this._decalEl = null;
    };
    Path.prototype.getDecalElement = function() {
        return this._decalEl;
    };
    Path.prototype._init = function(props) {
        var keysArr = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(props);
        this.shape = this.getDefaultShape();
        var defaultStyle = this.getDefaultStyle();
        if (defaultStyle) this.useStyle(defaultStyle);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            var value = props[key];
            if (key === "style") {
                if (!this.style) this.useStyle(value);
                else (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(this.style, value);
            } else if (key === "shape") (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(this.shape, value);
            else _super.prototype.attrKV.call(this, key, value);
        }
        if (!this.style) this.useStyle({});
    };
    Path.prototype.getDefaultStyle = function() {
        return null;
    };
    Path.prototype.getDefaultShape = function() {
        return {};
    };
    Path.prototype.canBeInsideText = function() {
        return this.hasFill();
    };
    Path.prototype.getInsideTextFill = function() {
        var pathFill = this.style.fill;
        if (pathFill !== "none") {
            if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(pathFill)) {
                var fillLum = (0, $2c037f5bda6341ca$export$16c0ec21a6f9ef95)(pathFill, 0);
                if (fillLum > 0.5) return 0, $4b0cedd85979c776$export$f8ce94761f39398d;
                else if (fillLum > 0.2) return 0, $4b0cedd85979c776$export$27682248795c3c6b;
                return 0, $4b0cedd85979c776$export$3c6e95f318c8369b;
            } else if (pathFill) return 0, $4b0cedd85979c776$export$3c6e95f318c8369b;
        }
        return 0, $4b0cedd85979c776$export$f8ce94761f39398d;
    };
    Path.prototype.getInsideTextStroke = function(textFill) {
        var pathFill = this.style.fill;
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(pathFill)) {
            var zr = this.__zr;
            var isDarkMode = !!(zr && zr.isDarkMode());
            var isDarkLabel = (0, $2c037f5bda6341ca$export$16c0ec21a6f9ef95)(textFill, 0) < (0, $4b0cedd85979c776$export$fd81e7ebc7dae256);
            if (isDarkMode === isDarkLabel) return pathFill;
        }
    };
    Path.prototype.buildPath = function(ctx, shapeCfg, inBatch) {};
    Path.prototype.pathUpdated = function() {
        this.__dirty &= ~(0, $ddf76b16f1246ba9$export$f75fe89a33ebe115);
    };
    Path.prototype.getUpdatedPathProxy = function(inBatch) {
        !this.path && this.createPathProxy();
        this.path.beginPath();
        this.buildPath(this.path, this.shape, inBatch);
        return this.path;
    };
    Path.prototype.createPathProxy = function() {
        this.path = new (0, $20ebe2448f123f2e$export$2e2bcd8739ae039)(false);
    };
    Path.prototype.hasStroke = function() {
        var style = this.style;
        var stroke = style.stroke;
        return !(stroke == null || stroke === "none" || !(style.lineWidth > 0));
    };
    Path.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== "none";
    };
    Path.prototype.getBoundingRect = function() {
        var rect = this._rect;
        var style = this.style;
        var needsUpdateRect = !rect;
        if (needsUpdateRect) {
            var firstInvoke = false;
            if (!this.path) {
                firstInvoke = true;
                this.createPathProxy();
            }
            var path = this.path;
            if (firstInvoke || this.__dirty & (0, $ddf76b16f1246ba9$export$f75fe89a33ebe115)) {
                path.beginPath();
                this.buildPath(path, this.shape, false);
                this.pathUpdated();
            }
            rect = path.getBoundingRect();
        }
        this._rect = rect;
        if (this.hasStroke() && this.path && this.path.len() > 0) {
            var rectStroke = this._rectStroke || (this._rectStroke = rect.clone());
            if (this.__dirty || needsUpdateRect) {
                rectStroke.copy(rect);
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                var w = style.lineWidth;
                if (!this.hasFill()) {
                    var strokeContainThreshold = this.strokeContainThreshold;
                    w = Math.max(w, strokeContainThreshold == null ? 4 : strokeContainThreshold);
                }
                if (lineScale > 1e-10) {
                    rectStroke.width += w / lineScale;
                    rectStroke.height += w / lineScale;
                    rectStroke.x -= w / lineScale / 2;
                    rectStroke.y -= w / lineScale / 2;
                }
            }
            return rectStroke;
        }
        return rect;
    };
    Path.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        var style = this.style;
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            var pathProxy = this.path;
            if (this.hasStroke()) {
                var lineWidth = style.lineWidth;
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                if (lineScale > 1e-10) {
                    if (!this.hasFill()) lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
                    if ($347a114fcc5254ff$export$8d36b1b5d19157c5(pathProxy, lineWidth / lineScale, x, y)) return true;
                }
            }
            if (this.hasFill()) return $347a114fcc5254ff$export$8893e2b90ba10d92(pathProxy, x, y);
        }
        return false;
    };
    Path.prototype.dirtyShape = function() {
        this.__dirty |= (0, $ddf76b16f1246ba9$export$f75fe89a33ebe115);
        if (this._rect) this._rect = null;
        if (this._decalEl) this._decalEl.dirtyShape();
        this.markRedraw();
    };
    Path.prototype.dirty = function() {
        this.dirtyStyle();
        this.dirtyShape();
    };
    Path.prototype.animateShape = function(loop) {
        return this.animate("shape", loop);
    };
    Path.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === "style") this.dirtyStyle();
        else if (targetKey === "shape") this.dirtyShape();
        else this.markRedraw();
    };
    Path.prototype.attrKV = function(key, value) {
        if (key === "shape") this.setShape(value);
        else _super.prototype.attrKV.call(this, key, value);
    };
    Path.prototype.setShape = function(keyOrObj, value) {
        var shape = this.shape;
        if (!shape) shape = this.shape = {};
        if (typeof keyOrObj === "string") shape[keyOrObj] = value;
        else (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(shape, keyOrObj);
        this.dirtyShape();
        return this;
    };
    Path.prototype.shapeChanged = function() {
        return !!(this.__dirty & (0, $ddf76b16f1246ba9$export$f75fe89a33ebe115));
    };
    Path.prototype.createStyle = function(obj) {
        return (0, $7a1bd9c2710fea0d$export$79c7e160a7743efd)($b02ffe7acd508c08$export$deade517576e293a, obj);
    };
    Path.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.shape && !normalState.shape) normalState.shape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, this.shape);
    };
    Path.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetShape;
        if (state && state.shape) {
            if (transition) {
                if (keepCurrentStates) targetShape = state.shape;
                else {
                    targetShape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, normalState.shape);
                    (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(targetShape, state.shape);
                }
            } else {
                targetShape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, keepCurrentStates ? this.shape : normalState.shape);
                (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(targetShape, state.shape);
            }
        } else if (needsRestoreToNormal) targetShape = normalState.shape;
        if (targetShape) {
            if (transition) {
                this.shape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, this.shape);
                var targetShapePrimaryProps = {};
                var shapeKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(targetShape);
                for(var i = 0; i < shapeKeys.length; i++){
                    var key = shapeKeys[i];
                    if (typeof targetShape[key] === "object") this.shape[key] = targetShape[key];
                    else targetShapePrimaryProps[key] = targetShape[key];
                }
                this._transitionState(stateName, {
                    shape: targetShapePrimaryProps
                }, animationCfg);
            } else {
                this.shape = targetShape;
                this.dirtyShape();
            }
        }
    };
    Path.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedShape;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.shape) {
                mergedShape = mergedShape || {};
                this._mergeStyle(mergedShape, state.shape);
            }
        }
        if (mergedShape) mergedState.shape = mergedShape;
        return mergedState;
    };
    Path.prototype.getAnimationStyleProps = function() {
        return $b02ffe7acd508c08$export$71bb6c3c6862c6a5;
    };
    Path.prototype.isZeroArea = function() {
        return false;
    };
    Path.extend = function(defaultProps) {
        var Sub = function(_super) {
            (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Sub, _super);
            function Sub(opts) {
                var _this = _super.call(this, opts) || this;
                defaultProps.init && defaultProps.init.call(_this, opts);
                return _this;
            }
            Sub.prototype.getDefaultStyle = function() {
                return (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(defaultProps.style);
            };
            Sub.prototype.getDefaultShape = function() {
                return (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(defaultProps.shape);
            };
            return Sub;
        }(Path);
        for(var key in defaultProps)if (typeof defaultProps[key] === "function") Sub.prototype[key] = defaultProps[key];
        return Sub;
    };
    Path.initDefaultProps = function() {
        var pathProto = Path.prototype;
        pathProto.type = "path";
        pathProto.strokeContainThreshold = 5;
        pathProto.segmentIgnoreThreshold = 0;
        pathProto.subPixelOptimize = false;
        pathProto.autoBatch = false;
        pathProto.__dirty = (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd) | (0, $ddf76b16f1246ba9$export$ada8b2beb3d76671) | (0, $ddf76b16f1246ba9$export$f75fe89a33ebe115);
    }();
    return Path;
}((0, $56206a6cb4666931$export$2e2bcd8739ae039));
var $b02ffe7acd508c08$export$2e2bcd8739ae039 = $b02ffe7acd508c08$var$Path;





var $c9d5c769fe2f591f$export$5fbb6d98091bcb56 = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
    strokeFirst: true,
    font: (0, $c6341dcc9d86826e$export$7d7a232b6d2cc80c),
    x: 0,
    y: 0,
    textAlign: "left",
    textBaseline: "top",
    miterLimit: 2
}, (0, $b02ffe7acd508c08$export$deade517576e293a));
var $c9d5c769fe2f591f$var$TSpan = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(TSpan, _super);
    function TSpan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TSpan.prototype.hasStroke = function() {
        return (0, $64fa9b3825ba2dec$export$c7aae0ffd99a8643)(this.style);
    };
    TSpan.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== "none";
    };
    TSpan.prototype.createStyle = function(obj) {
        return (0, $7a1bd9c2710fea0d$export$79c7e160a7743efd)($c9d5c769fe2f591f$export$5fbb6d98091bcb56, obj);
    };
    TSpan.prototype.setBoundingRect = function(rect) {
        this._rect = rect;
    };
    TSpan.prototype.getBoundingRect = function() {
        if (!this._rect) this._rect = (0, $64fa9b3825ba2dec$export$d79289ac0f53b974)(this.style);
        return this._rect;
    };
    TSpan.initDefaultProps = function() {
        var tspanProto = TSpan.prototype;
        tspanProto.dirtyRectTolerance = 10;
    }();
    return TSpan;
}((0, $56206a6cb4666931$export$2e2bcd8739ae039));
$c9d5c769fe2f591f$var$TSpan.prototype.type = "tspan";
var $c9d5c769fe2f591f$export$2e2bcd8739ae039 = $c9d5c769fe2f591f$var$TSpan;








var $86adec94217b86c6$export$8993f922aeeac642 = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
    x: 0,
    y: 0
}, (0, $56206a6cb4666931$export$737672163db00fe3));
var $86adec94217b86c6$export$4aba8ad70847a488 = {
    style: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        x: true,
        y: true,
        width: true,
        height: true,
        sx: true,
        sy: true,
        sWidth: true,
        sHeight: true
    }, (0, $56206a6cb4666931$export$9908943fb57fbe51).style)
};
function $86adec94217b86c6$var$isImageLike(source) {
    return !!(source && typeof source !== "string" && source.width && source.height);
}
var $86adec94217b86c6$var$ZRImage = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(ZRImage, _super);
    function ZRImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ZRImage.prototype.createStyle = function(obj) {
        return (0, $7a1bd9c2710fea0d$export$79c7e160a7743efd)($86adec94217b86c6$export$8993f922aeeac642, obj);
    };
    ZRImage.prototype._getSize = function(dim) {
        var style = this.style;
        var size = style[dim];
        if (size != null) return size;
        var imageSource = $86adec94217b86c6$var$isImageLike(style.image) ? style.image : this.__image;
        if (!imageSource) return 0;
        var otherDim = dim === "width" ? "height" : "width";
        var otherDimSize = style[otherDim];
        if (otherDimSize == null) return imageSource[dim];
        else return imageSource[dim] / imageSource[otherDim] * otherDimSize;
    };
    ZRImage.prototype.getWidth = function() {
        return this._getSize("width");
    };
    ZRImage.prototype.getHeight = function() {
        return this._getSize("height");
    };
    ZRImage.prototype.getAnimationStyleProps = function() {
        return $86adec94217b86c6$export$4aba8ad70847a488;
    };
    ZRImage.prototype.getBoundingRect = function() {
        var style = this.style;
        if (!this._rect) this._rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(style.x || 0, style.y || 0, this.getWidth(), this.getHeight());
        return this._rect;
    };
    return ZRImage;
}((0, $56206a6cb4666931$export$2e2bcd8739ae039));
$86adec94217b86c6$var$ZRImage.prototype.type = "image";
var $86adec94217b86c6$export$2e2bcd8739ae039 = $86adec94217b86c6$var$ZRImage;




function $a351e275fffc3a77$export$5cc7f731b5937e99(ctx, shape) {
    var x = shape.x;
    var y = shape.y;
    var width = shape.width;
    var height = shape.height;
    var r = shape.r;
    var r1;
    var r2;
    var r3;
    var r4;
    if (width < 0) {
        x = x + width;
        width = -width;
    }
    if (height < 0) {
        y = y + height;
        height = -height;
    }
    if (typeof r === "number") r1 = r2 = r3 = r4 = r;
    else if (r instanceof Array) {
        if (r.length === 1) r1 = r2 = r3 = r4 = r[0];
        else if (r.length === 2) {
            r1 = r3 = r[0];
            r2 = r4 = r[1];
        } else if (r.length === 3) {
            r1 = r[0];
            r2 = r4 = r[1];
            r3 = r[2];
        } else {
            r1 = r[0];
            r2 = r[1];
            r3 = r[2];
            r4 = r[3];
        }
    } else r1 = r2 = r3 = r4 = 0;
    var total;
    if (r1 + r2 > width) {
        total = r1 + r2;
        r1 *= width / total;
        r2 *= width / total;
    }
    if (r3 + r4 > width) {
        total = r3 + r4;
        r3 *= width / total;
        r4 *= width / total;
    }
    if (r2 + r3 > height) {
        total = r2 + r3;
        r2 *= height / total;
        r3 *= height / total;
    }
    if (r1 + r4 > height) {
        total = r1 + r4;
        r1 *= height / total;
        r4 *= height / total;
    }
    ctx.moveTo(x + r1, y);
    ctx.lineTo(x + width - r2, y);
    r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
    ctx.lineTo(x + width, y + height - r3);
    r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
    ctx.lineTo(x + r4, y + height);
    r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
    ctx.lineTo(x, y + r1);
    r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
}


var $4d5544821af8d796$var$round = Math.round;
function $4d5544821af8d796$export$8b4b620d7f4aad1b(outputShape, inputShape, style) {
    if (!inputShape) return;
    var x1 = inputShape.x1;
    var x2 = inputShape.x2;
    var y1 = inputShape.y1;
    var y2 = inputShape.y2;
    outputShape.x1 = x1;
    outputShape.x2 = x2;
    outputShape.y1 = y1;
    outputShape.y2 = y2;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    if ($4d5544821af8d796$var$round(x1 * 2) === $4d5544821af8d796$var$round(x2 * 2)) outputShape.x1 = outputShape.x2 = $4d5544821af8d796$export$72c4fd4c1b8fcb10(x1, lineWidth, true);
    if ($4d5544821af8d796$var$round(y1 * 2) === $4d5544821af8d796$var$round(y2 * 2)) outputShape.y1 = outputShape.y2 = $4d5544821af8d796$export$72c4fd4c1b8fcb10(y1, lineWidth, true);
    return outputShape;
}
function $4d5544821af8d796$export$60e2aa74957d0b9d(outputShape, inputShape, style) {
    if (!inputShape) return;
    var originX = inputShape.x;
    var originY = inputShape.y;
    var originWidth = inputShape.width;
    var originHeight = inputShape.height;
    outputShape.x = originX;
    outputShape.y = originY;
    outputShape.width = originWidth;
    outputShape.height = originHeight;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    outputShape.x = $4d5544821af8d796$export$72c4fd4c1b8fcb10(originX, lineWidth, true);
    outputShape.y = $4d5544821af8d796$export$72c4fd4c1b8fcb10(originY, lineWidth, true);
    outputShape.width = Math.max($4d5544821af8d796$export$72c4fd4c1b8fcb10(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
    outputShape.height = Math.max($4d5544821af8d796$export$72c4fd4c1b8fcb10(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
    return outputShape;
}
function $4d5544821af8d796$export$72c4fd4c1b8fcb10(position, lineWidth, positiveOrNegative) {
    if (!lineWidth) return position;
    var doubledPosition = $4d5544821af8d796$var$round(position * 2);
    return (doubledPosition + $4d5544821af8d796$var$round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
}


var $419e5ff2f303755e$export$51140d6b71bb4ed5 = function() {
    function RectShape() {
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
    }
    return RectShape;
}();
var $419e5ff2f303755e$var$subPixelOptimizeOutputShape = {};
var $419e5ff2f303755e$var$Rect = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Rect, _super);
    function Rect(opts) {
        return _super.call(this, opts) || this;
    }
    Rect.prototype.getDefaultShape = function() {
        return new $419e5ff2f303755e$export$51140d6b71bb4ed5();
    };
    Rect.prototype.buildPath = function(ctx, shape) {
        var x;
        var y;
        var width;
        var height;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $4d5544821af8d796$export$60e2aa74957d0b9d)($419e5ff2f303755e$var$subPixelOptimizeOutputShape, shape, this.style);
            x = optimizedShape.x;
            y = optimizedShape.y;
            width = optimizedShape.width;
            height = optimizedShape.height;
            optimizedShape.r = shape.r;
            shape = optimizedShape;
        } else {
            x = shape.x;
            y = shape.y;
            width = shape.width;
            height = shape.height;
        }
        if (!shape.r) ctx.rect(x, y, width, height);
        else $a351e275fffc3a77$export$5cc7f731b5937e99(ctx, shape);
    };
    Rect.prototype.isZeroArea = function() {
        return !this.shape.width || !this.shape.height;
    };
    return Rect;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$419e5ff2f303755e$var$Rect.prototype.type = "rect";
var $419e5ff2f303755e$export$2e2bcd8739ae039 = $419e5ff2f303755e$var$Rect;





var $fe885cc21795562b$var$DEFAULT_RICH_TEXT_COLOR = {
    fill: "#000"
};
var $fe885cc21795562b$var$DEFAULT_STROKE_LINE_WIDTH = 2;
var $fe885cc21795562b$var$tmpCITOverflowAreaOut = {};
var $fe885cc21795562b$export$21aaaa0607ee0e2b = {
    style: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        fill: true,
        stroke: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineWidth: true,
        fontSize: true,
        lineHeight: true,
        width: true,
        height: true,
        textShadowColor: true,
        textShadowBlur: true,
        textShadowOffsetX: true,
        textShadowOffsetY: true,
        backgroundColor: true,
        padding: true,
        borderColor: true,
        borderWidth: true,
        borderRadius: true
    }, (0, $56206a6cb4666931$export$9908943fb57fbe51).style)
};
var $fe885cc21795562b$var$ZRText = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(ZRText, _super);
    function ZRText(opts) {
        var _this = _super.call(this) || this;
        _this.type = "text";
        _this._children = [];
        _this._defaultStyle = $fe885cc21795562b$var$DEFAULT_RICH_TEXT_COLOR;
        _this.attr(opts);
        return _this;
    }
    ZRText.prototype.childrenRef = function() {
        return this._children;
    };
    ZRText.prototype.update = function() {
        _super.prototype.update.call(this);
        if (this.styleChanged()) this._updateSubTexts();
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.zlevel = this.zlevel;
            child.z = this.z;
            child.z2 = this.z2;
            child.culling = this.culling;
            child.cursor = this.cursor;
            child.invisible = this.invisible;
        }
    };
    ZRText.prototype.updateTransform = function() {
        var innerTransformable = this.innerTransformable;
        if (innerTransformable) {
            innerTransformable.updateTransform();
            if (innerTransformable.transform) this.transform = innerTransformable.transform;
        } else _super.prototype.updateTransform.call(this);
    };
    ZRText.prototype.getLocalTransform = function(m) {
        var innerTransformable = this.innerTransformable;
        return innerTransformable ? innerTransformable.getLocalTransform(m) : _super.prototype.getLocalTransform.call(this, m);
    };
    ZRText.prototype.getComputedTransform = function() {
        if (this.__hostTarget) {
            this.__hostTarget.getComputedTransform();
            this.__hostTarget.updateInnerText(true);
        }
        return _super.prototype.getComputedTransform.call(this);
    };
    ZRText.prototype._updateSubTexts = function() {
        this._childCursor = 0;
        $fe885cc21795562b$export$176336068cc5371f(this.style);
        this.style.rich ? this._updateRichTexts() : this._updatePlainTexts();
        this._children.length = this._childCursor;
        this.styleUpdated();
    };
    ZRText.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = zr;
    };
    ZRText.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = null;
    };
    ZRText.prototype.getBoundingRect = function() {
        if (this.styleChanged()) this._updateSubTexts();
        if (!this._rect) {
            var tmpRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
            var children = this._children;
            var tmpMat = [];
            var rect = null;
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                var childRect = child.getBoundingRect();
                var transform = child.getLocalTransform(tmpMat);
                if (transform) {
                    tmpRect.copy(childRect);
                    tmpRect.applyTransform(transform);
                    rect = rect || tmpRect.clone();
                    rect.union(tmpRect);
                } else {
                    rect = rect || childRect.clone();
                    rect.union(childRect);
                }
            }
            this._rect = rect || tmpRect;
        }
        return this._rect;
    };
    ZRText.prototype.setDefaultTextStyle = function(defaultTextStyle) {
        this._defaultStyle = defaultTextStyle || $fe885cc21795562b$var$DEFAULT_RICH_TEXT_COLOR;
    };
    ZRText.prototype.setTextContent = function(textContent) {};
    ZRText.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        if (!sourceStyle) return targetStyle;
        var sourceRich = sourceStyle.rich;
        var targetRich = targetStyle.rich || sourceRich && {};
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(targetStyle, sourceStyle);
        if (sourceRich && targetRich) {
            this._mergeRich(targetRich, sourceRich);
            targetStyle.rich = targetRich;
        } else if (targetRich) targetStyle.rich = targetRich;
        return targetStyle;
    };
    ZRText.prototype._mergeRich = function(targetRich, sourceRich) {
        var richNames = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(sourceRich);
        for(var i = 0; i < richNames.length; i++){
            var richName = richNames[i];
            targetRich[richName] = targetRich[richName] || {};
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(targetRich[richName], sourceRich[richName]);
        }
    };
    ZRText.prototype.getAnimationStyleProps = function() {
        return $fe885cc21795562b$export$21aaaa0607ee0e2b;
    };
    ZRText.prototype._getOrCreateChild = function(Ctor) {
        var child = this._children[this._childCursor];
        if (!child || !(child instanceof Ctor)) child = new Ctor();
        this._children[this._childCursor++] = child;
        child.__zr = this.__zr;
        child.parent = this;
        return child;
    };
    ZRText.prototype._updatePlainTexts = function() {
        var style = this.style;
        var textFont = style.font || (0, $c6341dcc9d86826e$export$7d7a232b6d2cc80c);
        var textPadding = style.padding;
        var defaultStyle = this._defaultStyle;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        var textAlign = style.align || defaultStyle.align || "left";
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign || "top";
        (0, $64fa9b3825ba2dec$export$9a4428591d825b14)($fe885cc21795562b$var$tmpCITOverflowAreaOut, defaultStyle.overflowRect, baseX, baseY, textAlign, verticalAlign);
        baseX = $fe885cc21795562b$var$tmpCITOverflowAreaOut.baseX;
        baseY = $fe885cc21795562b$var$tmpCITOverflowAreaOut.baseY;
        var text = $fe885cc21795562b$var$getStyleText(style);
        var contentBlock = (0, $64fa9b3825ba2dec$export$5772575e34ef80f9)(text, style, $fe885cc21795562b$var$tmpCITOverflowAreaOut.outerWidth, $fe885cc21795562b$var$tmpCITOverflowAreaOut.outerHeight);
        var needDrawBg = $fe885cc21795562b$var$needDrawBackground(style);
        var bgColorDrawn = !!style.backgroundColor;
        var outerHeight = contentBlock.outerHeight;
        var outerWidth = contentBlock.outerWidth;
        var textLines = contentBlock.lines;
        var lineHeight = contentBlock.lineHeight;
        this.isTruncated = !!contentBlock.isTruncated;
        var textX = baseX;
        var textY = (0, $6c308355c7107803$export$bf7d6802d2badd9)(baseY, contentBlock.contentHeight, verticalAlign);
        if (needDrawBg || textPadding) {
            var boxX = (0, $6c308355c7107803$export$eb5a525ef00ef9a4)(baseX, outerWidth, textAlign);
            var boxY = (0, $6c308355c7107803$export$bf7d6802d2badd9)(baseY, outerHeight, verticalAlign);
            needDrawBg && this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        }
        textY += lineHeight / 2;
        if (textPadding) {
            textX = $fe885cc21795562b$var$getTextXForPadding(baseX, textAlign, textPadding);
            if (verticalAlign === "top") textY += textPadding[0];
            else if (verticalAlign === "bottom") textY -= textPadding[2];
        }
        var defaultLineWidth = 0;
        var usingDefaultStroke = false;
        var useDefaultFill = false;
        var textFill = $fe885cc21795562b$var$getFill("fill" in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $fe885cc21795562b$var$getStroke("stroke" in style ? style.stroke : !bgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $fe885cc21795562b$var$DEFAULT_STROKE_LINE_WIDTH, usingDefaultStroke = true, defaultStyle.stroke) : null);
        var hasShadow = style.textShadowBlur > 0;
        for(var i = 0; i < textLines.length; i++){
            var el = this._getOrCreateChild((0, $c9d5c769fe2f591f$export$2e2bcd8739ae039));
            var subElStyle = el.createStyle();
            el.useStyle(subElStyle);
            subElStyle.text = textLines[i];
            subElStyle.x = textX;
            subElStyle.y = textY;
            if (textAlign) subElStyle.textAlign = textAlign;
            subElStyle.textBaseline = "middle";
            subElStyle.opacity = style.opacity;
            subElStyle.strokeFirst = true;
            if (hasShadow) {
                subElStyle.shadowBlur = style.textShadowBlur || 0;
                subElStyle.shadowColor = style.textShadowColor || "transparent";
                subElStyle.shadowOffsetX = style.textShadowOffsetX || 0;
                subElStyle.shadowOffsetY = style.textShadowOffsetY || 0;
            }
            subElStyle.stroke = textStroke;
            subElStyle.fill = textFill;
            if (textStroke) {
                subElStyle.lineWidth = style.lineWidth || defaultLineWidth;
                subElStyle.lineDash = style.lineDash;
                subElStyle.lineDashOffset = style.lineDashOffset || 0;
            }
            subElStyle.font = textFont;
            $fe885cc21795562b$var$setSeparateFont(subElStyle, style);
            textY += lineHeight;
            el.setBoundingRect((0, $64fa9b3825ba2dec$export$bd5d12d7bf7c9027)(subElStyle, contentBlock.contentWidth, contentBlock.calculatedLineHeight, usingDefaultStroke ? 0 : null));
        }
    };
    ZRText.prototype._updateRichTexts = function() {
        var style = this.style;
        var defaultStyle = this._defaultStyle;
        var textAlign = style.align || defaultStyle.align;
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        (0, $64fa9b3825ba2dec$export$9a4428591d825b14)($fe885cc21795562b$var$tmpCITOverflowAreaOut, defaultStyle.overflowRect, baseX, baseY, textAlign, verticalAlign);
        baseX = $fe885cc21795562b$var$tmpCITOverflowAreaOut.baseX;
        baseY = $fe885cc21795562b$var$tmpCITOverflowAreaOut.baseY;
        var text = $fe885cc21795562b$var$getStyleText(style);
        var contentBlock = (0, $64fa9b3825ba2dec$export$15ec9472ff2d721)(text, style, $fe885cc21795562b$var$tmpCITOverflowAreaOut.outerWidth, $fe885cc21795562b$var$tmpCITOverflowAreaOut.outerHeight, textAlign);
        var contentWidth = contentBlock.width;
        var outerWidth = contentBlock.outerWidth;
        var outerHeight = contentBlock.outerHeight;
        var textPadding = style.padding;
        this.isTruncated = !!contentBlock.isTruncated;
        var boxX = (0, $6c308355c7107803$export$eb5a525ef00ef9a4)(baseX, outerWidth, textAlign);
        var boxY = (0, $6c308355c7107803$export$bf7d6802d2badd9)(baseY, outerHeight, verticalAlign);
        var xLeft = boxX;
        var lineTop = boxY;
        if (textPadding) {
            xLeft += textPadding[3];
            lineTop += textPadding[0];
        }
        var xRight = xLeft + contentWidth;
        if ($fe885cc21795562b$var$needDrawBackground(style)) this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        var bgColorDrawn = !!style.backgroundColor;
        for(var i = 0; i < contentBlock.lines.length; i++){
            var line = contentBlock.lines[i];
            var tokens = line.tokens;
            var tokenCount = tokens.length;
            var lineHeight = line.lineHeight;
            var remainedWidth = line.width;
            var leftIndex = 0;
            var lineXLeft = xLeft;
            var lineXRight = xRight;
            var rightIndex = tokenCount - 1;
            var token = void 0;
            while(leftIndex < tokenCount && (token = tokens[leftIndex], !token.align || token.align === "left")){
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft, "left", bgColorDrawn);
                remainedWidth -= token.width;
                lineXLeft += token.width;
                leftIndex++;
            }
            while(rightIndex >= 0 && (token = tokens[rightIndex], token.align === "right")){
                this._placeToken(token, style, lineHeight, lineTop, lineXRight, "right", bgColorDrawn);
                remainedWidth -= token.width;
                lineXRight -= token.width;
                rightIndex--;
            }
            lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - remainedWidth) / 2;
            while(leftIndex <= rightIndex){
                token = tokens[leftIndex];
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft + token.width / 2, "center", bgColorDrawn);
                lineXLeft += token.width;
                leftIndex++;
            }
            lineTop += lineHeight;
        }
    };
    ZRText.prototype._placeToken = function(token, style, lineHeight, lineTop, x, textAlign, parentBgColorDrawn) {
        var tokenStyle = style.rich[token.styleName] || {};
        tokenStyle.text = token.text;
        var verticalAlign = token.verticalAlign;
        var y = lineTop + lineHeight / 2;
        if (verticalAlign === "top") y = lineTop + token.height / 2;
        else if (verticalAlign === "bottom") y = lineTop + lineHeight - token.height / 2;
        var needDrawBg = !token.isLineHolder && $fe885cc21795562b$var$needDrawBackground(tokenStyle);
        needDrawBg && this._renderBackground(tokenStyle, style, textAlign === "right" ? x - token.width : textAlign === "center" ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
        var bgColorDrawn = !!tokenStyle.backgroundColor;
        var textPadding = token.textPadding;
        if (textPadding) {
            x = $fe885cc21795562b$var$getTextXForPadding(x, textAlign, textPadding);
            y -= token.height / 2 - textPadding[0] - token.innerHeight / 2;
        }
        var el = this._getOrCreateChild((0, $c9d5c769fe2f591f$export$2e2bcd8739ae039));
        var subElStyle = el.createStyle();
        el.useStyle(subElStyle);
        var defaultStyle = this._defaultStyle;
        var useDefaultFill = false;
        var defaultLineWidth = 0;
        var usingDefaultStroke = false;
        var textFill = $fe885cc21795562b$var$getFill("fill" in tokenStyle ? tokenStyle.fill : "fill" in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $fe885cc21795562b$var$getStroke("stroke" in tokenStyle ? tokenStyle.stroke : "stroke" in style ? style.stroke : !bgColorDrawn && !parentBgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $fe885cc21795562b$var$DEFAULT_STROKE_LINE_WIDTH, usingDefaultStroke = true, defaultStyle.stroke) : null);
        var hasShadow = tokenStyle.textShadowBlur > 0 || style.textShadowBlur > 0;
        subElStyle.text = token.text;
        subElStyle.x = x;
        subElStyle.y = y;
        if (hasShadow) {
            subElStyle.shadowBlur = tokenStyle.textShadowBlur || style.textShadowBlur || 0;
            subElStyle.shadowColor = tokenStyle.textShadowColor || style.textShadowColor || "transparent";
            subElStyle.shadowOffsetX = tokenStyle.textShadowOffsetX || style.textShadowOffsetX || 0;
            subElStyle.shadowOffsetY = tokenStyle.textShadowOffsetY || style.textShadowOffsetY || 0;
        }
        subElStyle.textAlign = textAlign;
        subElStyle.textBaseline = "middle";
        subElStyle.font = token.font || (0, $c6341dcc9d86826e$export$7d7a232b6d2cc80c);
        subElStyle.opacity = (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(tokenStyle.opacity, style.opacity, 1);
        $fe885cc21795562b$var$setSeparateFont(subElStyle, tokenStyle);
        if (textStroke) {
            subElStyle.lineWidth = (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(tokenStyle.lineWidth, style.lineWidth, defaultLineWidth);
            subElStyle.lineDash = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(tokenStyle.lineDash, style.lineDash);
            subElStyle.lineDashOffset = style.lineDashOffset || 0;
            subElStyle.stroke = textStroke;
        }
        if (textFill) subElStyle.fill = textFill;
        el.setBoundingRect((0, $64fa9b3825ba2dec$export$bd5d12d7bf7c9027)(subElStyle, token.contentWidth, token.contentHeight, usingDefaultStroke ? 0 : null));
    };
    ZRText.prototype._renderBackground = function(style, topStyle, x, y, width, height) {
        var textBackgroundColor = style.backgroundColor;
        var textBorderWidth = style.borderWidth;
        var textBorderColor = style.borderColor;
        var isImageBg = textBackgroundColor && textBackgroundColor.image;
        var isPlainOrGradientBg = textBackgroundColor && !isImageBg;
        var textBorderRadius = style.borderRadius;
        var self = this;
        var rectEl;
        var imgEl;
        if (isPlainOrGradientBg || style.lineHeight || textBorderWidth && textBorderColor) {
            rectEl = this._getOrCreateChild((0, $419e5ff2f303755e$export$2e2bcd8739ae039));
            rectEl.useStyle(rectEl.createStyle());
            rectEl.style.fill = null;
            var rectShape = rectEl.shape;
            rectShape.x = x;
            rectShape.y = y;
            rectShape.width = width;
            rectShape.height = height;
            rectShape.r = textBorderRadius;
            rectEl.dirtyShape();
        }
        if (isPlainOrGradientBg) {
            var rectStyle = rectEl.style;
            rectStyle.fill = textBackgroundColor || null;
            rectStyle.fillOpacity = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(style.fillOpacity, 1);
        } else if (isImageBg) {
            imgEl = this._getOrCreateChild((0, $86adec94217b86c6$export$2e2bcd8739ae039));
            imgEl.onload = function() {
                self.dirtyStyle();
            };
            var imgStyle = imgEl.style;
            imgStyle.image = textBackgroundColor.image;
            imgStyle.x = x;
            imgStyle.y = y;
            imgStyle.width = width;
            imgStyle.height = height;
        }
        if (textBorderWidth && textBorderColor) {
            var rectStyle = rectEl.style;
            rectStyle.lineWidth = textBorderWidth;
            rectStyle.stroke = textBorderColor;
            rectStyle.strokeOpacity = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(style.strokeOpacity, 1);
            rectStyle.lineDash = style.borderDash;
            rectStyle.lineDashOffset = style.borderDashOffset || 0;
            rectEl.strokeContainThreshold = 0;
            if (rectEl.hasFill() && rectEl.hasStroke()) {
                rectStyle.strokeFirst = true;
                rectStyle.lineWidth *= 2;
            }
        }
        var commonStyle = (rectEl || imgEl).style;
        commonStyle.shadowBlur = style.shadowBlur || 0;
        commonStyle.shadowColor = style.shadowColor || "transparent";
        commonStyle.shadowOffsetX = style.shadowOffsetX || 0;
        commonStyle.shadowOffsetY = style.shadowOffsetY || 0;
        commonStyle.opacity = (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(style.opacity, topStyle.opacity, 1);
    };
    ZRText.makeFont = function(style) {
        var font = "";
        if ($fe885cc21795562b$export$4685c95d5118e76a(style)) font = [
            style.fontStyle,
            style.fontWeight,
            $fe885cc21795562b$export$51b066d9cfc2578e(style.fontSize),
            style.fontFamily || "sans-serif"
        ].join(" ");
        return font && (0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(font) || style.textFont || style.font;
    };
    return ZRText;
}((0, $56206a6cb4666931$export$2e2bcd8739ae039));
var $fe885cc21795562b$var$VALID_TEXT_ALIGN = {
    left: true,
    right: 1,
    center: 1
};
var $fe885cc21795562b$var$VALID_TEXT_VERTICAL_ALIGN = {
    top: 1,
    bottom: 1,
    middle: 1
};
var $fe885cc21795562b$var$FONT_PARTS = [
    "fontStyle",
    "fontWeight",
    "fontSize",
    "fontFamily"
];
function $fe885cc21795562b$export$51b066d9cfc2578e(fontSize) {
    if (typeof fontSize === "string" && (fontSize.indexOf("px") !== -1 || fontSize.indexOf("rem") !== -1 || fontSize.indexOf("em") !== -1)) return fontSize;
    else if (!isNaN(+fontSize)) return fontSize + "px";
    else return (0, $c6341dcc9d86826e$export$b1461457ea2c1179) + "px";
}
function $fe885cc21795562b$var$setSeparateFont(targetStyle, sourceStyle) {
    for(var i = 0; i < $fe885cc21795562b$var$FONT_PARTS.length; i++){
        var fontProp = $fe885cc21795562b$var$FONT_PARTS[i];
        var val = sourceStyle[fontProp];
        if (val != null) targetStyle[fontProp] = val;
    }
}
function $fe885cc21795562b$export$4685c95d5118e76a(style) {
    return style.fontSize != null || style.fontFamily || style.fontWeight;
}
function $fe885cc21795562b$export$176336068cc5371f(style) {
    $fe885cc21795562b$var$normalizeStyle(style);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(style.rich, $fe885cc21795562b$var$normalizeStyle);
    return style;
}
function $fe885cc21795562b$var$normalizeStyle(style) {
    if (style) {
        style.font = $fe885cc21795562b$var$ZRText.makeFont(style);
        var textAlign = style.align;
        textAlign === "middle" && (textAlign = "center");
        style.align = textAlign == null || $fe885cc21795562b$var$VALID_TEXT_ALIGN[textAlign] ? textAlign : "left";
        var verticalAlign = style.verticalAlign;
        verticalAlign === "center" && (verticalAlign = "middle");
        style.verticalAlign = verticalAlign == null || $fe885cc21795562b$var$VALID_TEXT_VERTICAL_ALIGN[verticalAlign] ? verticalAlign : "top";
        var textPadding = style.padding;
        if (textPadding) style.padding = (0, $7a1bd9c2710fea0d$export$f3a38102c49f4268)(style.padding);
    }
}
function $fe885cc21795562b$var$getStroke(stroke, lineWidth) {
    return stroke == null || lineWidth <= 0 || stroke === "transparent" || stroke === "none" ? null : stroke.image || stroke.colorStops ? "#000" : stroke;
}
function $fe885cc21795562b$var$getFill(fill) {
    return fill == null || fill === "none" ? null : fill.image || fill.colorStops ? "#000" : fill;
}
function $fe885cc21795562b$var$getTextXForPadding(x, textAlign, textPadding) {
    return textAlign === "right" ? x - textPadding[1] : textAlign === "center" ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
}
function $fe885cc21795562b$var$getStyleText(style) {
    var text = style.text;
    text != null && (text += "");
    return text;
}
function $fe885cc21795562b$var$needDrawBackground(style) {
    return !!(style.backgroundColor || style.lineHeight || style.borderWidth && style.borderColor);
}
var $fe885cc21795562b$export$2e2bcd8739ae039 = $fe885cc21795562b$var$ZRText;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $b1983a2fffd47d56$export$b1c39b2bacd1ddc2 = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $b1983a2fffd47d56$export$30d6736ebb8e18d5 = function(seriesIndex, dataType, dataIdx, el) {
    if (el) {
        var ecData = $b1983a2fffd47d56$export$b1c39b2bacd1ddc2(el);
        // Add data index and series index for indexing the data by element
        // Useful in tooltip
        ecData.dataIndex = dataIdx;
        ecData.dataType = dataType;
        ecData.seriesIndex = seriesIndex;
        ecData.ssrType = "chart";
        // TODO: not store dataIndex on children.
        if (el.type === "group") el.traverse(function(child) {
            var childECData = $b1983a2fffd47d56$export$b1c39b2bacd1ddc2(child);
            childECData.seriesIndex = seriesIndex;
            childECData.dataIndex = dataIdx;
            childECData.dataType = dataType;
            childECData.ssrType = "chart";
        });
    }
};






// Reserve 0 as default.
var $2bf82c0980125b62$var$_highlightNextDigit = 1;
var $2bf82c0980125b62$var$_highlightKeyMap = {};
var $2bf82c0980125b62$var$getSavedStates = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $2bf82c0980125b62$var$getComponentStates = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $2bf82c0980125b62$export$5542daa30722333e = 0;
var $2bf82c0980125b62$export$1307d6a87d56baa = 1;
var $2bf82c0980125b62$export$f0f2bee145debb31 = 2;
var $2bf82c0980125b62$export$151308dceb52d5b = [
    "emphasis",
    "blur",
    "select"
];
var $2bf82c0980125b62$export$57ee5306b85ad7d5 = [
    "normal",
    "emphasis",
    "blur",
    "select"
];
var $2bf82c0980125b62$export$1cb9fc6ed5b9836c = 10;
var $2bf82c0980125b62$export$3a2f97d39514bbc = 9;
var $2bf82c0980125b62$export$df035d873a9de64f = "highlight";
var $2bf82c0980125b62$export$f8a2f7807cc185ea = "downplay";
var $2bf82c0980125b62$export$89616263e7d38fe9 = "select";
var $2bf82c0980125b62$export$7636ad95c0f68a79 = "unselect";
var $2bf82c0980125b62$export$1e90ed8a25542516 = "toggleSelect";
var $2bf82c0980125b62$export$67f8c62bcdfbd39f = "selectchanged";
function $2bf82c0980125b62$var$hasFillOrStroke(fillOrStroke) {
    return fillOrStroke != null && fillOrStroke !== "none";
}
function $2bf82c0980125b62$var$doChangeHoverState(el, stateName, hoverStateEnum) {
    if (el.onHoverStateChange && (el.hoverState || 0) !== hoverStateEnum) el.onHoverStateChange(stateName);
    el.hoverState = hoverStateEnum;
}
function $2bf82c0980125b62$var$singleEnterEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    $2bf82c0980125b62$var$doChangeHoverState(el, "emphasis", $2bf82c0980125b62$export$f0f2bee145debb31);
}
function $2bf82c0980125b62$var$singleLeaveEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    if (el.hoverState === $2bf82c0980125b62$export$f0f2bee145debb31) $2bf82c0980125b62$var$doChangeHoverState(el, "normal", $2bf82c0980125b62$export$5542daa30722333e);
}
function $2bf82c0980125b62$var$singleEnterBlur(el) {
    $2bf82c0980125b62$var$doChangeHoverState(el, "blur", $2bf82c0980125b62$export$1307d6a87d56baa);
}
function $2bf82c0980125b62$var$singleLeaveBlur(el) {
    if (el.hoverState === $2bf82c0980125b62$export$1307d6a87d56baa) $2bf82c0980125b62$var$doChangeHoverState(el, "normal", $2bf82c0980125b62$export$5542daa30722333e);
}
function $2bf82c0980125b62$var$singleEnterSelect(el) {
    el.selected = true;
}
function $2bf82c0980125b62$var$singleLeaveSelect(el) {
    el.selected = false;
}
function $2bf82c0980125b62$var$updateElementState(el, updater, commonParam) {
    updater(el, commonParam);
}
function $2bf82c0980125b62$var$traverseUpdateState(el, updater, commonParam) {
    $2bf82c0980125b62$var$updateElementState(el, updater, commonParam);
    el.isGroup && el.traverse(function(child) {
        $2bf82c0980125b62$var$updateElementState(child, updater, commonParam);
    });
}
function $2bf82c0980125b62$export$868ba38adffa9e39(el, stateName) {
    switch(stateName){
        case "emphasis":
            el.hoverState = $2bf82c0980125b62$export$f0f2bee145debb31;
            break;
        case "normal":
            el.hoverState = $2bf82c0980125b62$export$5542daa30722333e;
            break;
        case "blur":
            el.hoverState = $2bf82c0980125b62$export$1307d6a87d56baa;
            break;
        case "select":
            el.selected = true;
    }
}
function $2bf82c0980125b62$export$35330f949342a669(el) {
    if (el.isGroup) el.traverse(function(child) {
        child.clearStates();
    });
    else el.clearStates();
}
function $2bf82c0980125b62$var$getFromStateStyle(el, props, toStateName, defaultValue) {
    var style = el.style;
    var fromState = {};
    for(var i = 0; i < props.length; i++){
        var propName = props[i];
        var val = style[propName];
        fromState[propName] = val == null ? defaultValue && defaultValue[propName] : val;
    }
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.__fromStateTransition && animator.__fromStateTransition.indexOf(toStateName) < 0 && animator.targetName === "style") animator.saveTo(fromState, props);
    }
    return fromState;
}
function $2bf82c0980125b62$var$createEmphasisDefaultState(el, stateName, targetStates, state) {
    var hasSelect = targetStates && (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(targetStates, "select") >= 0;
    var cloned = false;
    if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) {
        var store = $2bf82c0980125b62$var$getSavedStates(el);
        var fromFill = hasSelect ? store.selectFill || store.normalFill : store.normalFill;
        var fromStroke = hasSelect ? store.selectStroke || store.normalStroke : store.normalStroke;
        if ($2bf82c0980125b62$var$hasFillOrStroke(fromFill) || $2bf82c0980125b62$var$hasFillOrStroke(fromStroke)) {
            state = state || {};
            var emphasisStyle = state.style || {};
            // inherit case
            if (emphasisStyle.fill === "inherit") {
                cloned = true;
                state = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, state);
                emphasisStyle = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, emphasisStyle);
                emphasisStyle.fill = fromFill;
            } else if (!$2bf82c0980125b62$var$hasFillOrStroke(emphasisStyle.fill) && $2bf82c0980125b62$var$hasFillOrStroke(fromFill)) {
                cloned = true;
                // Not modify the original value.
                state = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, state);
                emphasisStyle = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, emphasisStyle);
                // Already being applied 'emphasis'. DON'T lift color multiple times.
                emphasisStyle.fill = (0, $2c037f5bda6341ca$export$2b47e247dfb87a73)(fromFill);
            } else if (!$2bf82c0980125b62$var$hasFillOrStroke(emphasisStyle.stroke) && $2bf82c0980125b62$var$hasFillOrStroke(fromStroke)) {
                if (!cloned) {
                    state = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, state);
                    emphasisStyle = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, emphasisStyle);
                }
                emphasisStyle.stroke = (0, $2c037f5bda6341ca$export$2b47e247dfb87a73)(fromStroke);
            }
            state.style = emphasisStyle;
        }
    }
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            if (!cloned) state = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, state);
            var z2EmphasisLift = el.z2EmphasisLift;
            state.z2 = el.z2 + (z2EmphasisLift != null ? z2EmphasisLift : $2bf82c0980125b62$export$1cb9fc6ed5b9836c);
        }
    }
    return state;
}
function $2bf82c0980125b62$var$createSelectDefaultState(el, stateName, state) {
    // const hasSelect = indexOf(el.currentStates, stateName) >= 0;
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            state = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, state);
            var z2SelectLift = el.z2SelectLift;
            state.z2 = el.z2 + (z2SelectLift != null ? z2SelectLift : $2bf82c0980125b62$export$3a2f97d39514bbc);
        }
    }
    return state;
}
function $2bf82c0980125b62$var$createBlurDefaultState(el, stateName, state) {
    var hasBlur = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(el.currentStates, stateName) >= 0;
    var currentOpacity = el.style.opacity;
    var fromState = !hasBlur ? $2bf82c0980125b62$var$getFromStateStyle(el, [
        "opacity"
    ], stateName, {
        opacity: 1
    }) : null;
    state = state || {};
    var blurStyle = state.style || {};
    if (blurStyle.opacity == null) {
        // clone state
        state = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, state);
        blurStyle = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
            // Already being applied 'emphasis'. DON'T mul opacity multiple times.
            opacity: hasBlur ? currentOpacity : fromState.opacity * 0.1
        }, blurStyle);
        state.style = blurStyle;
    }
    return state;
}
function $2bf82c0980125b62$var$elementStateProxy(stateName, targetStates) {
    var state = this.states[stateName];
    if (this.style) {
        if (stateName === "emphasis") return $2bf82c0980125b62$var$createEmphasisDefaultState(this, stateName, targetStates, state);
        else if (stateName === "blur") return $2bf82c0980125b62$var$createBlurDefaultState(this, stateName, state);
        else if (stateName === "select") return $2bf82c0980125b62$var$createSelectDefaultState(this, stateName, state);
    }
    return state;
}
function $2bf82c0980125b62$export$20f39bbe322fb9ab(el) {
    el.stateProxy = $2bf82c0980125b62$var$elementStateProxy;
    var textContent = el.getTextContent();
    var textGuide = el.getTextGuideLine();
    if (textContent) textContent.stateProxy = $2bf82c0980125b62$var$elementStateProxy;
    if (textGuide) textGuide.stateProxy = $2bf82c0980125b62$var$elementStateProxy;
}
function $2bf82c0980125b62$export$d899507e2598e4ae(el, e) {
    !$2bf82c0980125b62$var$shouldSilent(el, e) && !el.__highByOuter && $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleEnterEmphasis);
}
function $2bf82c0980125b62$export$784cba1f7fe58cca(el, e) {
    !$2bf82c0980125b62$var$shouldSilent(el, e) && !el.__highByOuter && $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleLeaveEmphasis);
}
function $2bf82c0980125b62$export$b2d02638cc34c042(el, highlightDigit) {
    el.__highByOuter |= 1 << (highlightDigit || 0);
    $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleEnterEmphasis);
}
function $2bf82c0980125b62$export$11be6f716239ac55(el, highlightDigit) {
    !(el.__highByOuter &= ~(1 << (highlightDigit || 0))) && $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleLeaveEmphasis);
}
function $2bf82c0980125b62$export$207f9cb3e1099375(el) {
    $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleEnterBlur);
}
function $2bf82c0980125b62$export$fd4a9ec75456d3c1(el) {
    $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleLeaveBlur);
}
function $2bf82c0980125b62$export$252d028dda8ef765(el) {
    $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleEnterSelect);
}
function $2bf82c0980125b62$export$ea9a904bd6e32bd3(el) {
    $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleLeaveSelect);
}
function $2bf82c0980125b62$var$shouldSilent(el, e) {
    return el.__highDownSilentOnTouch && e.zrByTouch;
}
function $2bf82c0980125b62$export$b2a593c7b5243584(api) {
    var model = api.getModel();
    var leaveBlurredSeries = [];
    var allComponentViews = [];
    model.eachComponent(function(componentType, componentModel) {
        var componentStates = $2bf82c0980125b62$var$getComponentStates(componentModel);
        var isSeries = componentType === "series";
        var view = isSeries ? api.getViewOfSeriesModel(componentModel) : api.getViewOfComponentModel(componentModel);
        !isSeries && allComponentViews.push(view);
        if (componentStates.isBlured) {
            // Leave blur anyway
            view.group.traverse(function(child) {
                $2bf82c0980125b62$var$singleLeaveBlur(child);
            });
            isSeries && leaveBlurredSeries.push(componentModel);
        }
        componentStates.isBlured = false;
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(allComponentViews, function(view) {
        if (view && view.toggleBlurSeries) view.toggleBlurSeries(leaveBlurredSeries, false, model);
    });
}
function $2bf82c0980125b62$export$7d399e067d6552e3(targetSeriesIndex, focus, blurScope, api) {
    var ecModel = api.getModel();
    blurScope = blurScope || "coordinateSystem";
    function leaveBlurOfIndices(data, dataIndices) {
        for(var i = 0; i < dataIndices.length; i++){
            var itemEl = data.getItemGraphicEl(dataIndices[i]);
            itemEl && $2bf82c0980125b62$export$fd4a9ec75456d3c1(itemEl);
        }
    }
    if (targetSeriesIndex == null) return;
    if (!focus || focus === "none") return;
    var targetSeriesModel = ecModel.getSeriesByIndex(targetSeriesIndex);
    var targetCoordSys = targetSeriesModel.coordinateSystem;
    if (targetCoordSys && targetCoordSys.master) targetCoordSys = targetCoordSys.master;
    var blurredSeries = [];
    ecModel.eachSeries(function(seriesModel) {
        var sameSeries = targetSeriesModel === seriesModel;
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.master) coordSys = coordSys.master;
        var sameCoordSys = coordSys && targetCoordSys ? coordSys === targetCoordSys : sameSeries; // If there is no coordinate system. use sameSeries instead.
        if (!// Not blur other series if blurScope series
        (blurScope === "series" && !sameSeries || blurScope === "coordinateSystem" && !sameCoordSys || focus === "series" && sameSeries)) {
            var view = api.getViewOfSeriesModel(seriesModel);
            view.group.traverse(function(child) {
                // For the elements that have been triggered by other components,
                // and are still required to be highlighted,
                // because the current is directly forced to blur the element,
                // it will cause the focus self to be unable to highlight, so skip the blur of this element.
                if (child.__highByOuter && sameSeries && focus === "self") return;
                $2bf82c0980125b62$var$singleEnterBlur(child);
            });
            if ((0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(focus)) leaveBlurOfIndices(seriesModel.getData(), focus);
            else if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(focus)) {
                var dataTypes = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(focus);
                for(var d = 0; d < dataTypes.length; d++)leaveBlurOfIndices(seriesModel.getData(dataTypes[d]), focus[dataTypes[d]]);
            }
            blurredSeries.push(seriesModel);
            $2bf82c0980125b62$var$getComponentStates(seriesModel).isBlured = true;
        }
    });
    ecModel.eachComponent(function(componentType, componentModel) {
        if (componentType === "series") return;
        var view = api.getViewOfComponentModel(componentModel);
        if (view && view.toggleBlurSeries) view.toggleBlurSeries(blurredSeries, true, ecModel);
    });
}
function $2bf82c0980125b62$export$569da03256c8a55f(componentMainType, componentIndex, api) {
    if (componentMainType == null || componentIndex == null) return;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return;
    $2bf82c0980125b62$var$getComponentStates(componentModel).isBlured = true;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.focusBlurEnabled) return;
    view.group.traverse(function(child) {
        $2bf82c0980125b62$var$singleEnterBlur(child);
    });
}
function $2bf82c0980125b62$export$64f1fd4daefef21b(seriesModel, payload, api) {
    var seriesIndex = seriesModel.seriesIndex;
    var data = seriesModel.getData(payload.dataType);
    if (!data) return;
    var dataIndex = (0, $76d619f648247e6d$export$42b26cae8b8d10)(data, payload);
    // Pick the first one if there is multiple/none exists.
    dataIndex = ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(dataIndex) ? dataIndex[0] : dataIndex) || 0;
    var el = data.getItemGraphicEl(dataIndex);
    if (!el) {
        var count = data.count();
        var current = 0;
        // If data on dataIndex is NaN.
        while(!el && current < count)el = data.getItemGraphicEl(current++);
    }
    if (el) {
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
        $2bf82c0980125b62$export$7d399e067d6552e3(seriesIndex, ecData.focus, ecData.blurScope, api);
    } else {
        // If there is no element put on the data. Try getting it from raw option
        // TODO Should put it on seriesModel?
        var focus_1 = seriesModel.get([
            "emphasis",
            "focus"
        ]);
        var blurScope = seriesModel.get([
            "emphasis",
            "blurScope"
        ]);
        if (focus_1 != null) $2bf82c0980125b62$export$7d399e067d6552e3(seriesIndex, focus_1, blurScope, api);
    }
}
function $2bf82c0980125b62$export$f31a644ccca0ef23(componentMainType, componentIndex, name, api) {
    var ret = {
        focusSelf: false,
        dispatchers: null
    };
    if (componentMainType == null || componentMainType === "series" || componentIndex == null || name == null) return ret;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return ret;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.findHighDownDispatchers) return ret;
    var dispatchers = view.findHighDownDispatchers(name);
    // At presnet, the component (like Geo) only blur inside itself.
    // So we do not use `blurScope` in component.
    var focusSelf;
    for(var i = 0; i < dispatchers.length; i++)if ((0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(dispatchers[i]).focus === "self") {
        focusSelf = true;
        break;
    }
    return {
        focusSelf: focusSelf,
        dispatchers: dispatchers
    };
}
function $2bf82c0980125b62$export$416765b6198234ff(dispatcher, e, api) {
    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(dispatcher);
    var _a = $2bf82c0980125b62$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api), dispatchers = _a.dispatchers, focusSelf = _a.focusSelf;
    // If `findHighDownDispatchers` is supported on the component,
    // highlight/downplay elements with the same name.
    if (dispatchers) {
        if (focusSelf) $2bf82c0980125b62$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
            return $2bf82c0980125b62$export$d899507e2598e4ae(dispatcher, e);
        });
    } else {
        // Try blur all in the related series. Then emphasis the hoverred.
        // TODO. progressive mode.
        $2bf82c0980125b62$export$7d399e067d6552e3(ecData.seriesIndex, ecData.focus, ecData.blurScope, api);
        if (ecData.focus === "self") $2bf82c0980125b62$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
        // Other than series, component that not support `findHighDownDispatcher` will
        // also use it. But in this case, highlight/downplay are only supported in
        // mouse hover but not in dispatchAction.
        $2bf82c0980125b62$export$d899507e2598e4ae(dispatcher, e);
    }
}
function $2bf82c0980125b62$export$bb1c7b62436282a(dispatcher, e, api) {
    $2bf82c0980125b62$export$b2a593c7b5243584(api);
    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(dispatcher);
    var dispatchers = $2bf82c0980125b62$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api).dispatchers;
    if (dispatchers) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
        return $2bf82c0980125b62$export$784cba1f7fe58cca(dispatcher, e);
    });
    else $2bf82c0980125b62$export$784cba1f7fe58cca(dispatcher, e);
}
function $2bf82c0980125b62$export$1c7d489f62372d73(seriesModel, payload, api) {
    if (!$2bf82c0980125b62$export$72aea10e60e45351(payload)) return;
    var dataType = payload.dataType;
    var data = seriesModel.getData(dataType);
    var dataIndex = (0, $76d619f648247e6d$export$42b26cae8b8d10)(data, payload);
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(dataIndex)) dataIndex = [
        dataIndex
    ];
    seriesModel[payload.type === $2bf82c0980125b62$export$1e90ed8a25542516 ? "toggleSelect" : payload.type === $2bf82c0980125b62$export$89616263e7d38fe9 ? "select" : "unselect"](dataIndex, dataType);
}
function $2bf82c0980125b62$export$e4ea08ef52e0a73(seriesModel) {
    var allData = seriesModel.getAllData();
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(allData, function(_a) {
        var data = _a.data, type = _a.type;
        data.eachItemGraphicEl(function(el, idx) {
            seriesModel.isSelected(idx, type) ? $2bf82c0980125b62$export$252d028dda8ef765(el) : $2bf82c0980125b62$export$ea9a904bd6e32bd3(el);
        });
    });
}
function $2bf82c0980125b62$export$c529643b619af6b3(ecModel) {
    var ret = [];
    ecModel.eachSeries(function(seriesModel) {
        var allData = seriesModel.getAllData();
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(allData, function(_a) {
            var data = _a.data, type = _a.type;
            var dataIndices = seriesModel.getSelectedDataIndices();
            if (dataIndices.length > 0) {
                var item = {
                    dataIndex: dataIndices,
                    seriesIndex: seriesModel.seriesIndex
                };
                if (type != null) item.dataType = type;
                ret.push(item);
            }
        });
    });
    return ret;
}
function $2bf82c0980125b62$export$5f393df0b5aee2e7(el, focus, blurScope) {
    $2bf82c0980125b62$export$9ba15aea1e048d48(el, true);
    $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$export$20f39bbe322fb9ab);
    $2bf82c0980125b62$export$24972466b2b62ac2(el, focus, blurScope);
}
function $2bf82c0980125b62$export$912cae7b47c8e437(el) {
    $2bf82c0980125b62$export$9ba15aea1e048d48(el, false);
}
function $2bf82c0980125b62$export$e51187539ff11209(el, focus, blurScope, isDisabled) {
    isDisabled ? $2bf82c0980125b62$export$912cae7b47c8e437(el) : $2bf82c0980125b62$export$5f393df0b5aee2e7(el, focus, blurScope);
}
function $2bf82c0980125b62$export$24972466b2b62ac2(el, focus, blurScope) {
    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
    if (focus != null) {
        // TODO dataIndex may be set after this function. This check is not useful.
        // if (ecData.dataIndex == null) {
        //     if (__DEV__) {
        //         console.warn('focus can only been set on element with dataIndex');
        //     }
        // }
        // else {
        ecData.focus = focus;
        ecData.blurScope = blurScope;
    // }
    } else if (ecData.focus) ecData.focus = null;
}
var $2bf82c0980125b62$var$OTHER_STATES = [
    "emphasis",
    "blur",
    "select"
];
var $2bf82c0980125b62$var$defaultStyleGetterMap = {
    itemStyle: "getItemStyle",
    lineStyle: "getLineStyle",
    areaStyle: "getAreaStyle"
};
function $2bf82c0980125b62$export$48b68047d330bbc9(el, itemModel, styleType, // default itemStyle
getter) {
    styleType = styleType || "itemStyle";
    for(var i = 0; i < $2bf82c0980125b62$var$OTHER_STATES.length; i++){
        var stateName = $2bf82c0980125b62$var$OTHER_STATES[i];
        var model = itemModel.getModel([
            stateName,
            styleType
        ]);
        var state = el.ensureState(stateName);
        // Let it throw error if getterType is not found.
        state.style = getter ? getter(model) : model[$2bf82c0980125b62$var$defaultStyleGetterMap[styleType]]();
    }
}
function $2bf82c0980125b62$export$9ba15aea1e048d48(el, asDispatcher) {
    var disable = asDispatcher === false;
    var extendedEl = el;
    // Make `highDownSilentOnTouch` and `onStateChange` only work after
    // `setAsHighDownDispatcher` called. Avoid it is modified by user unexpectedly.
    if (el.highDownSilentOnTouch) extendedEl.__highDownSilentOnTouch = el.highDownSilentOnTouch;
    // Simple optimize, since this method might be
    // called for each elements of a group in some cases.
    if (!disable || extendedEl.__highDownDispatcher) {
        // Emphasis, normal can be triggered manually by API or other components like hover link.
        // el[method]('emphasis', onElementEmphasisEvent)[method]('normal', onElementNormalEvent);
        // Also keep previous record.
        extendedEl.__highByOuter = extendedEl.__highByOuter || 0;
        extendedEl.__highDownDispatcher = !disable;
    }
}
function $2bf82c0980125b62$export$77d1445f699c58b5(el) {
    return !!(el && el.__highDownDispatcher);
}
function $2bf82c0980125b62$export$4da05a9639f01954(el, componentModel, componentHighDownName) {
    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
    ecData.componentMainType = componentModel.mainType;
    ecData.componentIndex = componentModel.componentIndex;
    ecData.componentHighDownName = componentHighDownName;
}
function $2bf82c0980125b62$export$824af40eb714530d(highlightKey) {
    var highlightDigit = $2bf82c0980125b62$var$_highlightKeyMap[highlightKey];
    if (highlightDigit == null && $2bf82c0980125b62$var$_highlightNextDigit <= 32) highlightDigit = $2bf82c0980125b62$var$_highlightKeyMap[highlightKey] = $2bf82c0980125b62$var$_highlightNextDigit++;
    return highlightDigit;
}
function $2bf82c0980125b62$export$72aea10e60e45351(payload) {
    var payloadType = payload.type;
    return payloadType === $2bf82c0980125b62$export$89616263e7d38fe9 || payloadType === $2bf82c0980125b62$export$7636ad95c0f68a79 || payloadType === $2bf82c0980125b62$export$1e90ed8a25542516;
}
function $2bf82c0980125b62$export$aebe71265c1b77bf(payload) {
    var payloadType = payload.type;
    return payloadType === $2bf82c0980125b62$export$df035d873a9de64f || payloadType === $2bf82c0980125b62$export$f8a2f7807cc185ea;
}
function $2bf82c0980125b62$export$9fe78019e6f395b6(el) {
    var store = $2bf82c0980125b62$var$getSavedStates(el);
    store.normalFill = el.style.fill;
    store.normalStroke = el.style.stroke;
    var selectState = el.states.select || {};
    store.selectFill = selectState.style && selectState.style.fill || null;
    store.selectStroke = selectState.style && selectState.style.stroke || null;
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $8b353638fbedfefa$export$ae7433df314f6ec3 = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $8b353638fbedfefa$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, // Extra opts can override the option in animatable model.
extraOpts, // TODO It's only for pictorial bar now.
extraDelayParams) {
    var animationPayload;
    // Check if there is global animation configuration from dataZoom/resize can override the config in option.
    // If animation is enabled. Will use this animation config in payload.
    // If animation is disabled. Just ignore it.
    if (animatableModel && animatableModel.ecModel) {
        var updatePayload = animatableModel.ecModel.getUpdatePayload();
        animationPayload = updatePayload && updatePayload.animation;
    }
    var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
    var isUpdate = animationType === "update";
    if (animationEnabled) {
        var duration = void 0;
        var easing = void 0;
        var delay = void 0;
        if (extraOpts) {
            duration = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(extraOpts.duration, 200);
            easing = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(extraOpts.easing, "cubicOut");
            delay = 0;
        } else {
            duration = animatableModel.getShallow(isUpdate ? "animationDurationUpdate" : "animationDuration");
            easing = animatableModel.getShallow(isUpdate ? "animationEasingUpdate" : "animationEasing");
            delay = animatableModel.getShallow(isUpdate ? "animationDelayUpdate" : "animationDelay");
        }
        // animation from payload has highest priority.
        if (animationPayload) {
            animationPayload.duration != null && (duration = animationPayload.duration);
            animationPayload.easing != null && (easing = animationPayload.easing);
            animationPayload.delay != null && (delay = animationPayload.delay);
        }
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(delay)) delay = delay(dataIndex, extraDelayParams);
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(duration)) duration = duration(dataIndex);
        var config = {
            duration: duration || 0,
            delay: delay,
            easing: easing
        };
        return config;
    } else return null;
}
function $8b353638fbedfefa$var$animateOrSetProps(animationType, el, props, animatableModel, dataIndex, cb, during) {
    var isFrom = false;
    var removeOpt;
    if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(dataIndex)) {
        during = cb;
        cb = dataIndex;
        dataIndex = null;
    } else if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dataIndex)) {
        cb = dataIndex.cb;
        during = dataIndex.during;
        isFrom = dataIndex.isFrom;
        removeOpt = dataIndex.removeOpt;
        dataIndex = dataIndex.dataIndex;
    }
    var isRemove = animationType === "leave";
    if (!isRemove) // Must stop the remove animation.
    el.stopAnimation("leave");
    var animationConfig = $8b353638fbedfefa$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, isRemove ? removeOpt || {} : null, animatableModel && animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
    if (animationConfig && animationConfig.duration > 0) {
        var duration = animationConfig.duration;
        var animationDelay = animationConfig.delay;
        var animationEasing = animationConfig.easing;
        var animateConfig = {
            duration: duration,
            delay: animationDelay || 0,
            easing: animationEasing,
            done: cb,
            force: !!cb || !!during,
            // Set to final state in update/init animation.
            // So the post processing based on the path shape can be done correctly.
            setToFinal: !isRemove,
            scope: animationType,
            during: during
        };
        isFrom ? el.animateFrom(props, animateConfig) : el.animateTo(props, animateConfig);
    } else {
        el.stopAnimation();
        // If `isFrom`, the props is the "from" props.
        !isFrom && el.attr(props);
        // Call during at least once.
        during && during(1);
        cb && cb();
    }
}
/**
 * Update graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 * @example
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
 *     // Or
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, function () { console.log('Animation done!'); });
 */ function $8b353638fbedfefa$export$c8dce3c08436e91e(el, props, // TODO: TYPE AnimatableModel
animatableModel, dataIndex, cb, during) {
    $8b353638fbedfefa$var$animateOrSetProps("update", el, props, animatableModel, dataIndex, cb, during);
}
function $8b353638fbedfefa$export$a121566aadcfe021(el, props, animatableModel, dataIndex, cb, during) {
    $8b353638fbedfefa$var$animateOrSetProps("enter", el, props, animatableModel, dataIndex, cb, during);
}
function $8b353638fbedfefa$export$5b89d4b643713034(el) {
    if (!el.__zr) return true;
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.scope === "leave") return true;
    }
    return false;
}
function $8b353638fbedfefa$export$f883456a56996078(el, props, animatableModel, dataIndex, cb, during) {
    // Don't do remove animation twice.
    if ($8b353638fbedfefa$export$5b89d4b643713034(el)) return;
    $8b353638fbedfefa$var$animateOrSetProps("leave", el, props, animatableModel, dataIndex, cb, during);
}
function $8b353638fbedfefa$var$fadeOutDisplayable(el, animatableModel, dataIndex, done) {
    el.removeTextContent();
    el.removeTextGuideLine();
    $8b353638fbedfefa$export$f883456a56996078(el, {
        style: {
            opacity: 0
        }
    }, animatableModel, dataIndex, done);
}
function $8b353638fbedfefa$export$6d0fd725cb4aee8a(el, animatableModel, dataIndex) {
    function doRemove() {
        el.parent && el.parent.remove(el);
    }
    // Hide label and labelLine first
    // TODO Also use fade out animation?
    if (!el.isGroup) $8b353638fbedfefa$var$fadeOutDisplayable(el, animatableModel, dataIndex, doRemove);
    else el.traverse(function(disp) {
        if (!disp.isGroup) // Can invoke doRemove multiple times.
        $8b353638fbedfefa$var$fadeOutDisplayable(disp, animatableModel, dataIndex, doRemove);
    });
}
function $8b353638fbedfefa$export$bca7290a9faf0ec9(el) {
    $8b353638fbedfefa$export$ae7433df314f6ec3(el).oldStyle = el.style;
}
function $8b353638fbedfefa$export$ccb1f1e4d2fa86ac(el) {
    return $8b353638fbedfefa$export$ae7433df314f6ec3(el).oldStyle;
}

var $5b455ae6f843ac47$exports = {};

$parcel$export($5b455ae6f843ac47$exports, "XY", () => $5b455ae6f843ac47$export$cb4c12294149dd2d);
$parcel$export($5b455ae6f843ac47$exports, "WH", () => $5b455ae6f843ac47$export$a3fe6d967173a3ac);
$parcel$export($5b455ae6f843ac47$exports, "extendShape", () => $5b455ae6f843ac47$export$d0d5398c9d612037);
$parcel$export($5b455ae6f843ac47$exports, "extendPath", () => $5b455ae6f843ac47$export$53b54a3137026af0);
$parcel$export($5b455ae6f843ac47$exports, "registerShape", () => $5b455ae6f843ac47$export$2b95b62e3aaf6fdd);
$parcel$export($5b455ae6f843ac47$exports, "getShapeClass", () => $5b455ae6f843ac47$export$51df4b5565a58189);
$parcel$export($5b455ae6f843ac47$exports, "makePath", () => $5b455ae6f843ac47$export$aa9bab72412f5613);
$parcel$export($5b455ae6f843ac47$exports, "resizePath", () => $5b455ae6f843ac47$export$566dbf1c62b04fc7);
$parcel$export($5b455ae6f843ac47$exports, "makeImage", () => $5b455ae6f843ac47$export$7a2bdede98851ac5);
$parcel$export($5b455ae6f843ac47$exports, "mergePath", () => $5b455ae6f843ac47$export$7b1dd269fbc4e903);
$parcel$export($5b455ae6f843ac47$exports, "subPixelOptimizeLine", () => $5b455ae6f843ac47$export$8b4b620d7f4aad1b);
$parcel$export($5b455ae6f843ac47$exports, "subPixelOptimizeRect", () => $5b455ae6f843ac47$export$60e2aa74957d0b9d);
$parcel$export($5b455ae6f843ac47$exports, "subPixelOptimize", () => $5b455ae6f843ac47$export$72c4fd4c1b8fcb10);
$parcel$export($5b455ae6f843ac47$exports, "getTransform", () => $5b455ae6f843ac47$export$fce0c6cfca85ed96);
$parcel$export($5b455ae6f843ac47$exports, "applyTransform", () => $5b455ae6f843ac47$export$9f9dcb98c894b623);
$parcel$export($5b455ae6f843ac47$exports, "transformDirection", () => $5b455ae6f843ac47$export$fff94e9792354cfa);
$parcel$export($5b455ae6f843ac47$exports, "groupTransition", () => $5b455ae6f843ac47$export$64fcab7860c216ae);
$parcel$export($5b455ae6f843ac47$exports, "clipPointsByRect", () => $5b455ae6f843ac47$export$e2f409471bbbc1dc);
$parcel$export($5b455ae6f843ac47$exports, "clipRectByRect", () => $5b455ae6f843ac47$export$d0d3709202b8b2a);
$parcel$export($5b455ae6f843ac47$exports, "createIcon", () => $5b455ae6f843ac47$export$274edc73af1ae9c8);
$parcel$export($5b455ae6f843ac47$exports, "linePolygonIntersect", () => $5b455ae6f843ac47$export$4f47c855a5e9ae9);
$parcel$export($5b455ae6f843ac47$exports, "lineLineIntersect", () => $5b455ae6f843ac47$export$6c0a70ea1d8d158b);
$parcel$export($5b455ae6f843ac47$exports, "expandOrShrinkRect", () => $5b455ae6f843ac47$export$81ed941fdeb91c7c);
$parcel$export($5b455ae6f843ac47$exports, "setTooltipConfig", () => $5b455ae6f843ac47$export$fc6410d97fab306c);
$parcel$export($5b455ae6f843ac47$exports, "traverseElements", () => $5b455ae6f843ac47$export$3e564442729bf048);
$parcel$export($5b455ae6f843ac47$exports, "isBoundingRectAxisAligned", () => $5b455ae6f843ac47$export$576610ccf2234b72);
$parcel$export($5b455ae6f843ac47$exports, "ensureCopyRect", () => $5b455ae6f843ac47$export$38128dfd9a498e1);
$parcel$export($5b455ae6f843ac47$exports, "ensureCopyTransform", () => $5b455ae6f843ac47$export$4d61283a070e0362);
$parcel$export($5b455ae6f843ac47$exports, "retrieveZInfo", () => $5b455ae6f843ac47$export$1500a631bea5adda);
$parcel$export($5b455ae6f843ac47$exports, "calcZ2Range", () => $5b455ae6f843ac47$export$8215ea00957327f2);
$parcel$export($5b455ae6f843ac47$exports, "traverseUpdateZ", () => $5b455ae6f843ac47$export$d31cf465bf5e8879);
$parcel$export($5b455ae6f843ac47$exports, "updateProps", () => $8b353638fbedfefa$export$c8dce3c08436e91e);
$parcel$export($5b455ae6f843ac47$exports, "initProps", () => $8b353638fbedfefa$export$a121566aadcfe021);
$parcel$export($5b455ae6f843ac47$exports, "removeElement", () => $8b353638fbedfefa$export$f883456a56996078);
$parcel$export($5b455ae6f843ac47$exports, "removeElementWithFadeOut", () => $8b353638fbedfefa$export$6d0fd725cb4aee8a);
$parcel$export($5b455ae6f843ac47$exports, "isElementRemoved", () => $8b353638fbedfefa$export$5b89d4b643713034);
$parcel$export($5b455ae6f843ac47$exports, "Group", () => $7ef7583d8302ffce$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Image", () => $86adec94217b86c6$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Text", () => $fe885cc21795562b$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Circle", () => $1e68d8727773abb7$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Ellipse", () => $4a809f055a7e524c$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Sector", () => $a3e1dec0a3875b49$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Ring", () => $9da0cbfd3f86fdc1$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Polygon", () => $51acf033123e1a30$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Polyline", () => $d28119f30e6bb670$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Rect", () => $419e5ff2f303755e$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Line", () => $7a316ae5ceff7b27$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "BezierCurve", () => $6c7800c49630e431$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Arc", () => $2b5c23eb3597b84a$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "IncrementalDisplayable", () => $ee829f116f003981$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "CompoundPath", () => $e152f3dbf8fba6e2$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "LinearGradient", () => $cf44c01491b58e53$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "RadialGradient", () => $cd2ee2ba32bb26c3$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "BoundingRect", () => $1bebe7106c895823$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "OrientedBoundingRect", () => $f9793b4d8aade116$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Point", () => $b887f038f104fe7e$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Path", () => $b02ffe7acd508c08$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $07911aacc70e67cc$var$CMD = (0, $20ebe2448f123f2e$export$2e2bcd8739ae039).CMD;
var $07911aacc70e67cc$var$points = [
    [],
    [],
    []
];
var $07911aacc70e67cc$var$mathSqrt = Math.sqrt;
var $07911aacc70e67cc$var$mathAtan2 = Math.atan2;
function $07911aacc70e67cc$export$2e2bcd8739ae039(path, m) {
    if (!m) return;
    var data = path.data;
    var len = path.len();
    var cmd;
    var nPoint;
    var i;
    var j;
    var k;
    var p;
    var M = $07911aacc70e67cc$var$CMD.M;
    var C = $07911aacc70e67cc$var$CMD.C;
    var L = $07911aacc70e67cc$var$CMD.L;
    var R = $07911aacc70e67cc$var$CMD.R;
    var A = $07911aacc70e67cc$var$CMD.A;
    var Q = $07911aacc70e67cc$var$CMD.Q;
    for(i = 0, j = 0; i < len;){
        cmd = data[i++];
        j = i;
        nPoint = 0;
        switch(cmd){
            case M:
                nPoint = 1;
                break;
            case L:
                nPoint = 1;
                break;
            case C:
                nPoint = 3;
                break;
            case Q:
                nPoint = 2;
                break;
            case A:
                var x = m[4];
                var y = m[5];
                var sx = $07911aacc70e67cc$var$mathSqrt(m[0] * m[0] + m[1] * m[1]);
                var sy = $07911aacc70e67cc$var$mathSqrt(m[2] * m[2] + m[3] * m[3]);
                var angle = $07911aacc70e67cc$var$mathAtan2(-m[1] / sy, m[0] / sx);
                data[i] *= sx;
                data[i++] += x;
                data[i] *= sy;
                data[i++] += y;
                data[i++] *= sx;
                data[i++] *= sy;
                data[i++] += angle;
                data[i++] += angle;
                i += 2;
                j = i;
                break;
            case R:
                p[0] = data[i++];
                p[1] = data[i++];
                (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
                p[0] += data[i++];
                p[1] += data[i++];
                (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
        }
        for(k = 0; k < nPoint; k++){
            var p_1 = $07911aacc70e67cc$var$points[k];
            p_1[0] = data[i++];
            p_1[1] = data[i++];
            (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(p_1, p_1, m);
            data[j++] = p_1[0];
            data[j++] = p_1[1];
        }
    }
    path.increaseVersion();
}



var $15b38920672b9006$var$mathSqrt = Math.sqrt;
var $15b38920672b9006$var$mathSin = Math.sin;
var $15b38920672b9006$var$mathCos = Math.cos;
var $15b38920672b9006$var$PI = Math.PI;
function $15b38920672b9006$var$vMag(v) {
    return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
}
function $15b38920672b9006$var$vRatio(u, v) {
    return (u[0] * v[0] + u[1] * v[1]) / ($15b38920672b9006$var$vMag(u) * $15b38920672b9006$var$vMag(v));
}
function $15b38920672b9006$var$vAngle(u, v) {
    return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos($15b38920672b9006$var$vRatio(u, v));
}
function $15b38920672b9006$var$processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
    var psi = psiDeg * ($15b38920672b9006$var$PI / 180.0);
    var xp = $15b38920672b9006$var$mathCos(psi) * (x1 - x2) / 2.0 + $15b38920672b9006$var$mathSin(psi) * (y1 - y2) / 2.0;
    var yp = -1 * $15b38920672b9006$var$mathSin(psi) * (x1 - x2) / 2.0 + $15b38920672b9006$var$mathCos(psi) * (y1 - y2) / 2.0;
    var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
    if (lambda > 1) {
        rx *= $15b38920672b9006$var$mathSqrt(lambda);
        ry *= $15b38920672b9006$var$mathSqrt(lambda);
    }
    var f = (fa === fs ? -1 : 1) * $15b38920672b9006$var$mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
    var cxp = f * rx * yp / ry;
    var cyp = f * -ry * xp / rx;
    var cx = (x1 + x2) / 2.0 + $15b38920672b9006$var$mathCos(psi) * cxp - $15b38920672b9006$var$mathSin(psi) * cyp;
    var cy = (y1 + y2) / 2.0 + $15b38920672b9006$var$mathSin(psi) * cxp + $15b38920672b9006$var$mathCos(psi) * cyp;
    var theta = $15b38920672b9006$var$vAngle([
        1,
        0
    ], [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ]);
    var u = [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ];
    var v = [
        (-1 * xp - cxp) / rx,
        (-1 * yp - cyp) / ry
    ];
    var dTheta = $15b38920672b9006$var$vAngle(u, v);
    if ($15b38920672b9006$var$vRatio(u, v) <= -1) dTheta = $15b38920672b9006$var$PI;
    if ($15b38920672b9006$var$vRatio(u, v) >= 1) dTheta = 0;
    if (dTheta < 0) {
        var n = Math.round(dTheta / $15b38920672b9006$var$PI * 1e6) / 1e6;
        dTheta = $15b38920672b9006$var$PI * 2 + n % 2 * $15b38920672b9006$var$PI;
    }
    path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
}
var $15b38920672b9006$var$commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig;
var $15b38920672b9006$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function $15b38920672b9006$var$createPathProxyFromString(data) {
    var path = new (0, $20ebe2448f123f2e$export$2e2bcd8739ae039)();
    if (!data) return path;
    var cpx = 0;
    var cpy = 0;
    var subpathX = cpx;
    var subpathY = cpy;
    var prevCmd;
    var CMD = (0, $20ebe2448f123f2e$export$2e2bcd8739ae039).CMD;
    var cmdList = data.match($15b38920672b9006$var$commandReg);
    if (!cmdList) return path;
    for(var l = 0; l < cmdList.length; l++){
        var cmdText = cmdList[l];
        var cmdStr = cmdText.charAt(0);
        var cmd = void 0;
        var p = cmdText.match($15b38920672b9006$var$numberReg) || [];
        var pLen = p.length;
        for(var i = 0; i < pLen; i++)p[i] = parseFloat(p[i]);
        var off = 0;
        while(off < pLen){
            var ctlPtx = void 0;
            var ctlPty = void 0;
            var rx = void 0;
            var ry = void 0;
            var psi = void 0;
            var fa = void 0;
            var fs = void 0;
            var x1 = cpx;
            var y1 = cpy;
            var len = void 0;
            var pathData = void 0;
            switch(cmdStr){
                case "l":
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "L":
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "m":
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = "l";
                    break;
                case "M":
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = "L";
                    break;
                case "h":
                    cpx += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "H":
                    cpx = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "v":
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "V":
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "C":
                    cmd = CMD.C;
                    path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
                    cpx = p[off - 2];
                    cpy = p[off - 1];
                    break;
                case "c":
                    cmd = CMD.C;
                    path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
                    cpx += p[off - 2];
                    cpy += p[off - 1];
                    break;
                case "S":
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case "s":
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = cpx + p[off++];
                    y1 = cpy + p[off++];
                    cpx += p[off++];
                    cpy += p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case "Q":
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case "q":
                    x1 = p[off++] + cpx;
                    y1 = p[off++] + cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case "T":
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case "t":
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case "A":
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.A;
                    $15b38920672b9006$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
                case "a":
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.A;
                    $15b38920672b9006$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
            }
        }
        if (cmdStr === "z" || cmdStr === "Z") {
            cmd = CMD.Z;
            path.addData(cmd);
            cpx = subpathX;
            cpy = subpathY;
        }
        prevCmd = cmd;
    }
    path.toStatic();
    return path;
}
var $15b38920672b9006$var$SVGPath = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(SVGPath, _super);
    function SVGPath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVGPath.prototype.applyTransform = function(m) {};
    return SVGPath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
function $15b38920672b9006$var$isPathProxy(path) {
    return path.setData != null;
}
function $15b38920672b9006$var$createPathOptions(str, opts) {
    var pathProxy = $15b38920672b9006$var$createPathProxyFromString(str);
    var innerOpts = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, opts);
    innerOpts.buildPath = function(path) {
        var beProxy = $15b38920672b9006$var$isPathProxy(path);
        if (beProxy && path.canSave()) {
            path.appendPath(pathProxy);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        } else {
            var ctx = beProxy ? path.getContext() : path;
            if (ctx) pathProxy.rebuildPath(ctx, 1);
        }
    };
    innerOpts.applyTransform = function(m) {
        (0, $07911aacc70e67cc$export$2e2bcd8739ae039)(pathProxy, m);
        this.dirtyShape();
    };
    return innerOpts;
}
function $15b38920672b9006$export$ae5b259626f00aeb(str, opts) {
    return new $15b38920672b9006$var$SVGPath($15b38920672b9006$var$createPathOptions(str, opts));
}
function $15b38920672b9006$export$68e3a51ba2ed417c(str, defaultOpts) {
    var innerOpts = $15b38920672b9006$var$createPathOptions(str, defaultOpts);
    var Sub = function(_super) {
        (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Sub, _super);
        function Sub(opts) {
            var _this = _super.call(this, opts) || this;
            _this.applyTransform = innerOpts.applyTransform;
            _this.buildPath = innerOpts.buildPath;
            return _this;
        }
        return Sub;
    }($15b38920672b9006$var$SVGPath);
    return Sub;
}
function $15b38920672b9006$export$7b1dd269fbc4e903(pathEls, opts) {
    var pathList = [];
    var len = pathEls.length;
    for(var i = 0; i < len; i++){
        var pathEl = pathEls[i];
        pathList.push(pathEl.getUpdatedPathProxy(true));
    }
    var pathBundle = new (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)(opts);
    pathBundle.createPathProxy();
    pathBundle.buildPath = function(path) {
        if ($15b38920672b9006$var$isPathProxy(path)) {
            path.appendPath(pathList);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        }
    };
    return pathBundle;
}
function $15b38920672b9006$export$18711d956bf1c3eb(sourcePath, opts) {
    opts = opts || {};
    var path = new (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)();
    if (sourcePath.shape) path.setShape(sourcePath.shape);
    path.setStyle(sourcePath.style);
    if (opts.bakeTransform) (0, $07911aacc70e67cc$export$2e2bcd8739ae039)(path.path, sourcePath.getComputedTransform());
    else if (opts.toLocal) path.setLocalTransform(sourcePath.getComputedTransform());
    else path.copyTransform(sourcePath);
    path.buildPath = sourcePath.buildPath;
    path.applyTransform = path.applyTransform;
    path.z = sourcePath.z;
    path.z2 = sourcePath.z2;
    path.zlevel = sourcePath.zlevel;
    return path;
}











var $1e68d8727773abb7$export$2c0b65c9c7b57845 = function() {
    function CircleShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
    }
    return CircleShape;
}();
var $1e68d8727773abb7$var$Circle = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Circle, _super);
    function Circle(opts) {
        return _super.call(this, opts) || this;
    }
    Circle.prototype.getDefaultShape = function() {
        return new $1e68d8727773abb7$export$2c0b65c9c7b57845();
    };
    Circle.prototype.buildPath = function(ctx, shape) {
        ctx.moveTo(shape.cx + shape.r, shape.cy);
        ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2);
    };
    return Circle;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$1e68d8727773abb7$var$Circle.prototype.type = "circle";
var $1e68d8727773abb7$export$2e2bcd8739ae039 = $1e68d8727773abb7$var$Circle;




var $4a809f055a7e524c$export$817919dfe2806d31 = function() {
    function EllipseShape() {
        this.cx = 0;
        this.cy = 0;
        this.rx = 0;
        this.ry = 0;
    }
    return EllipseShape;
}();
var $4a809f055a7e524c$var$Ellipse = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Ellipse, _super);
    function Ellipse(opts) {
        return _super.call(this, opts) || this;
    }
    Ellipse.prototype.getDefaultShape = function() {
        return new $4a809f055a7e524c$export$817919dfe2806d31();
    };
    Ellipse.prototype.buildPath = function(ctx, shape) {
        var k = 0.5522848;
        var x = shape.cx;
        var y = shape.cy;
        var a = shape.rx;
        var b = shape.ry;
        var ox = a * k;
        var oy = b * k;
        ctx.moveTo(x - a, y);
        ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
        ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
        ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
        ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
        ctx.closePath();
    };
    return Ellipse;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$4a809f055a7e524c$var$Ellipse.prototype.type = "ellipse";
var $4a809f055a7e524c$export$2e2bcd8739ae039 = $4a809f055a7e524c$var$Ellipse;





var $a2aa1e91473aa9ab$var$PI = Math.PI;
var $a2aa1e91473aa9ab$var$PI2 = $a2aa1e91473aa9ab$var$PI * 2;
var $a2aa1e91473aa9ab$var$mathSin = Math.sin;
var $a2aa1e91473aa9ab$var$mathCos = Math.cos;
var $a2aa1e91473aa9ab$var$mathACos = Math.acos;
var $a2aa1e91473aa9ab$var$mathATan2 = Math.atan2;
var $a2aa1e91473aa9ab$var$mathAbs = Math.abs;
var $a2aa1e91473aa9ab$var$mathSqrt = Math.sqrt;
var $a2aa1e91473aa9ab$var$mathMax = Math.max;
var $a2aa1e91473aa9ab$var$mathMin = Math.min;
var $a2aa1e91473aa9ab$var$e = 1e-4;
function $a2aa1e91473aa9ab$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var dx10 = x1 - x0;
    var dy10 = y1 - y0;
    var dx32 = x3 - x2;
    var dy32 = y3 - y2;
    var t = dy32 * dx10 - dx32 * dy10;
    if (t * t < $a2aa1e91473aa9ab$var$e) return;
    t = (dx32 * (y0 - y2) - dy32 * (x0 - x2)) / t;
    return [
        x0 + t * dx10,
        y0 + t * dy10
    ];
}
function $a2aa1e91473aa9ab$var$computeCornerTangents(x0, y0, x1, y1, radius, cr, clockwise) {
    var x01 = x0 - x1;
    var y01 = y0 - y1;
    var lo = (clockwise ? cr : -cr) / $a2aa1e91473aa9ab$var$mathSqrt(x01 * x01 + y01 * y01);
    var ox = lo * y01;
    var oy = -lo * x01;
    var x11 = x0 + ox;
    var y11 = y0 + oy;
    var x10 = x1 + ox;
    var y10 = y1 + oy;
    var x00 = (x11 + x10) / 2;
    var y00 = (y11 + y10) / 2;
    var dx = x10 - x11;
    var dy = y10 - y11;
    var d2 = dx * dx + dy * dy;
    var r = radius - cr;
    var s = x11 * y10 - x10 * y11;
    var d = (dy < 0 ? -1 : 1) * $a2aa1e91473aa9ab$var$mathSqrt($a2aa1e91473aa9ab$var$mathMax(0, r * r * d2 - s * s));
    var cx0 = (s * dy - dx * d) / d2;
    var cy0 = (-s * dx - dy * d) / d2;
    var cx1 = (s * dy + dx * d) / d2;
    var cy1 = (-s * dx + dy * d) / d2;
    var dx0 = cx0 - x00;
    var dy0 = cy0 - y00;
    var dx1 = cx1 - x00;
    var dy1 = cy1 - y00;
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) {
        cx0 = cx1;
        cy0 = cy1;
    }
    return {
        cx: cx0,
        cy: cy0,
        x0: -ox,
        y0: -oy,
        x1: cx0 * (radius / r - 1),
        y1: cy0 * (radius / r - 1)
    };
}
function $a2aa1e91473aa9ab$var$normalizeCornerRadius(cr) {
    var arr;
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(cr)) {
        var len = cr.length;
        if (!len) return cr;
        if (len === 1) arr = [
            cr[0],
            cr[0],
            0,
            0
        ];
        else if (len === 2) arr = [
            cr[0],
            cr[0],
            cr[1],
            cr[1]
        ];
        else if (len === 3) arr = cr.concat(cr[2]);
        else arr = cr;
    } else arr = [
        cr,
        cr,
        cr,
        cr
    ];
    return arr;
}
function $a2aa1e91473aa9ab$export$5cc7f731b5937e99(ctx, shape) {
    var _a;
    var radius = $a2aa1e91473aa9ab$var$mathMax(shape.r, 0);
    var innerRadius = $a2aa1e91473aa9ab$var$mathMax(shape.r0 || 0, 0);
    var hasRadius = radius > 0;
    var hasInnerRadius = innerRadius > 0;
    if (!hasRadius && !hasInnerRadius) return;
    if (!hasRadius) {
        radius = innerRadius;
        innerRadius = 0;
    }
    if (innerRadius > radius) {
        var tmp = radius;
        radius = innerRadius;
        innerRadius = tmp;
    }
    var startAngle = shape.startAngle, endAngle = shape.endAngle;
    if (isNaN(startAngle) || isNaN(endAngle)) return;
    var cx = shape.cx, cy = shape.cy;
    var clockwise = !!shape.clockwise;
    var arc = $a2aa1e91473aa9ab$var$mathAbs(endAngle - startAngle);
    var mod = arc > $a2aa1e91473aa9ab$var$PI2 && arc % $a2aa1e91473aa9ab$var$PI2;
    mod > $a2aa1e91473aa9ab$var$e && (arc = mod);
    if (!(radius > $a2aa1e91473aa9ab$var$e)) ctx.moveTo(cx, cy);
    else if (arc > $a2aa1e91473aa9ab$var$PI2 - $a2aa1e91473aa9ab$var$e) {
        ctx.moveTo(cx + radius * $a2aa1e91473aa9ab$var$mathCos(startAngle), cy + radius * $a2aa1e91473aa9ab$var$mathSin(startAngle));
        ctx.arc(cx, cy, radius, startAngle, endAngle, !clockwise);
        if (innerRadius > $a2aa1e91473aa9ab$var$e) {
            ctx.moveTo(cx + innerRadius * $a2aa1e91473aa9ab$var$mathCos(endAngle), cy + innerRadius * $a2aa1e91473aa9ab$var$mathSin(endAngle));
            ctx.arc(cx, cy, innerRadius, endAngle, startAngle, clockwise);
        }
    } else {
        var icrStart = void 0;
        var icrEnd = void 0;
        var ocrStart = void 0;
        var ocrEnd = void 0;
        var ocrs = void 0;
        var ocre = void 0;
        var icrs = void 0;
        var icre = void 0;
        var ocrMax = void 0;
        var icrMax = void 0;
        var limitedOcrMax = void 0;
        var limitedIcrMax = void 0;
        var xre = void 0;
        var yre = void 0;
        var xirs = void 0;
        var yirs = void 0;
        var xrs = radius * $a2aa1e91473aa9ab$var$mathCos(startAngle);
        var yrs = radius * $a2aa1e91473aa9ab$var$mathSin(startAngle);
        var xire = innerRadius * $a2aa1e91473aa9ab$var$mathCos(endAngle);
        var yire = innerRadius * $a2aa1e91473aa9ab$var$mathSin(endAngle);
        var hasArc = arc > $a2aa1e91473aa9ab$var$e;
        if (hasArc) {
            var cornerRadius = shape.cornerRadius;
            if (cornerRadius) _a = $a2aa1e91473aa9ab$var$normalizeCornerRadius(cornerRadius), icrStart = _a[0], icrEnd = _a[1], ocrStart = _a[2], ocrEnd = _a[3];
            var halfRd = $a2aa1e91473aa9ab$var$mathAbs(radius - innerRadius) / 2;
            ocrs = $a2aa1e91473aa9ab$var$mathMin(halfRd, ocrStart);
            ocre = $a2aa1e91473aa9ab$var$mathMin(halfRd, ocrEnd);
            icrs = $a2aa1e91473aa9ab$var$mathMin(halfRd, icrStart);
            icre = $a2aa1e91473aa9ab$var$mathMin(halfRd, icrEnd);
            limitedOcrMax = ocrMax = $a2aa1e91473aa9ab$var$mathMax(ocrs, ocre);
            limitedIcrMax = icrMax = $a2aa1e91473aa9ab$var$mathMax(icrs, icre);
            if (ocrMax > $a2aa1e91473aa9ab$var$e || icrMax > $a2aa1e91473aa9ab$var$e) {
                xre = radius * $a2aa1e91473aa9ab$var$mathCos(endAngle);
                yre = radius * $a2aa1e91473aa9ab$var$mathSin(endAngle);
                xirs = innerRadius * $a2aa1e91473aa9ab$var$mathCos(startAngle);
                yirs = innerRadius * $a2aa1e91473aa9ab$var$mathSin(startAngle);
                if (arc < $a2aa1e91473aa9ab$var$PI) {
                    var it_1 = $a2aa1e91473aa9ab$var$intersect(xrs, yrs, xirs, yirs, xre, yre, xire, yire);
                    if (it_1) {
                        var x0 = xrs - it_1[0];
                        var y0 = yrs - it_1[1];
                        var x1 = xre - it_1[0];
                        var y1 = yre - it_1[1];
                        var a = 1 / $a2aa1e91473aa9ab$var$mathSin($a2aa1e91473aa9ab$var$mathACos((x0 * x1 + y0 * y1) / ($a2aa1e91473aa9ab$var$mathSqrt(x0 * x0 + y0 * y0) * $a2aa1e91473aa9ab$var$mathSqrt(x1 * x1 + y1 * y1))) / 2);
                        var b = $a2aa1e91473aa9ab$var$mathSqrt(it_1[0] * it_1[0] + it_1[1] * it_1[1]);
                        limitedOcrMax = $a2aa1e91473aa9ab$var$mathMin(ocrMax, (radius - b) / (a + 1));
                        limitedIcrMax = $a2aa1e91473aa9ab$var$mathMin(icrMax, (innerRadius - b) / (a - 1));
                    }
                }
            }
        }
        if (!hasArc) ctx.moveTo(cx + xrs, cy + yrs);
        else if (limitedOcrMax > $a2aa1e91473aa9ab$var$e) {
            var crStart = $a2aa1e91473aa9ab$var$mathMin(ocrStart, limitedOcrMax);
            var crEnd = $a2aa1e91473aa9ab$var$mathMin(ocrEnd, limitedOcrMax);
            var ct0 = $a2aa1e91473aa9ab$var$computeCornerTangents(xirs, yirs, xrs, yrs, radius, crStart, clockwise);
            var ct1 = $a2aa1e91473aa9ab$var$computeCornerTangents(xre, yre, xire, yire, radius, crEnd, clockwise);
            ctx.moveTo(cx + ct0.cx + ct0.x0, cy + ct0.cy + ct0.y0);
            if (limitedOcrMax < ocrMax && crStart === crEnd) ctx.arc(cx + ct0.cx, cy + ct0.cy, limitedOcrMax, $a2aa1e91473aa9ab$var$mathATan2(ct0.y0, ct0.x0), $a2aa1e91473aa9ab$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            else {
                crStart > 0 && ctx.arc(cx + ct0.cx, cy + ct0.cy, crStart, $a2aa1e91473aa9ab$var$mathATan2(ct0.y0, ct0.x0), $a2aa1e91473aa9ab$var$mathATan2(ct0.y1, ct0.x1), !clockwise);
                ctx.arc(cx, cy, radius, $a2aa1e91473aa9ab$var$mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1), $a2aa1e91473aa9ab$var$mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1), !clockwise);
                crEnd > 0 && ctx.arc(cx + ct1.cx, cy + ct1.cy, crEnd, $a2aa1e91473aa9ab$var$mathATan2(ct1.y1, ct1.x1), $a2aa1e91473aa9ab$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
        } else {
            ctx.moveTo(cx + xrs, cy + yrs);
            ctx.arc(cx, cy, radius, startAngle, endAngle, !clockwise);
        }
        if (!(innerRadius > $a2aa1e91473aa9ab$var$e) || !hasArc) ctx.lineTo(cx + xire, cy + yire);
        else if (limitedIcrMax > $a2aa1e91473aa9ab$var$e) {
            var crStart = $a2aa1e91473aa9ab$var$mathMin(icrStart, limitedIcrMax);
            var crEnd = $a2aa1e91473aa9ab$var$mathMin(icrEnd, limitedIcrMax);
            var ct0 = $a2aa1e91473aa9ab$var$computeCornerTangents(xire, yire, xre, yre, innerRadius, -crEnd, clockwise);
            var ct1 = $a2aa1e91473aa9ab$var$computeCornerTangents(xrs, yrs, xirs, yirs, innerRadius, -crStart, clockwise);
            ctx.lineTo(cx + ct0.cx + ct0.x0, cy + ct0.cy + ct0.y0);
            if (limitedIcrMax < icrMax && crStart === crEnd) ctx.arc(cx + ct0.cx, cy + ct0.cy, limitedIcrMax, $a2aa1e91473aa9ab$var$mathATan2(ct0.y0, ct0.x0), $a2aa1e91473aa9ab$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            else {
                crEnd > 0 && ctx.arc(cx + ct0.cx, cy + ct0.cy, crEnd, $a2aa1e91473aa9ab$var$mathATan2(ct0.y0, ct0.x0), $a2aa1e91473aa9ab$var$mathATan2(ct0.y1, ct0.x1), !clockwise);
                ctx.arc(cx, cy, innerRadius, $a2aa1e91473aa9ab$var$mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1), $a2aa1e91473aa9ab$var$mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1), clockwise);
                crStart > 0 && ctx.arc(cx + ct1.cx, cy + ct1.cy, crStart, $a2aa1e91473aa9ab$var$mathATan2(ct1.y1, ct1.x1), $a2aa1e91473aa9ab$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
        } else {
            ctx.lineTo(cx + xire, cy + yire);
            ctx.arc(cx, cy, innerRadius, endAngle, startAngle, clockwise);
        }
    }
    ctx.closePath();
}


var $a3e1dec0a3875b49$export$98af62de8a972c99 = function() {
    function SectorShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
        this.cornerRadius = 0;
    }
    return SectorShape;
}();
var $a3e1dec0a3875b49$var$Sector = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Sector, _super);
    function Sector(opts) {
        return _super.call(this, opts) || this;
    }
    Sector.prototype.getDefaultShape = function() {
        return new $a3e1dec0a3875b49$export$98af62de8a972c99();
    };
    Sector.prototype.buildPath = function(ctx, shape) {
        $a2aa1e91473aa9ab$export$5cc7f731b5937e99(ctx, shape);
    };
    Sector.prototype.isZeroArea = function() {
        return this.shape.startAngle === this.shape.endAngle || this.shape.r === this.shape.r0;
    };
    return Sector;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$a3e1dec0a3875b49$var$Sector.prototype.type = "sector";
var $a3e1dec0a3875b49$export$2e2bcd8739ae039 = $a3e1dec0a3875b49$var$Sector;




var $9da0cbfd3f86fdc1$export$4a506b3cd4ea73db = function() {
    function RingShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.r0 = 0;
    }
    return RingShape;
}();
var $9da0cbfd3f86fdc1$var$Ring = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Ring, _super);
    function Ring(opts) {
        return _super.call(this, opts) || this;
    }
    Ring.prototype.getDefaultShape = function() {
        return new $9da0cbfd3f86fdc1$export$4a506b3cd4ea73db();
    };
    Ring.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var PI2 = Math.PI * 2;
        ctx.moveTo(x + shape.r, y);
        ctx.arc(x, y, shape.r, 0, PI2, false);
        ctx.moveTo(x + shape.r0, y);
        ctx.arc(x, y, shape.r0, 0, PI2, true);
    };
    return Ring;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$9da0cbfd3f86fdc1$var$Ring.prototype.type = "ring";
var $9da0cbfd3f86fdc1$export$2e2bcd8739ae039 = $9da0cbfd3f86fdc1$var$Ring;





function $de6f6db626660fc1$export$2e2bcd8739ae039(points, smooth, isLoop, constraint) {
    var cps = [];
    var v = [];
    var v1 = [];
    var v2 = [];
    var prevPoint;
    var nextPoint;
    var min;
    var max;
    if (constraint) {
        min = [
            Infinity,
            Infinity
        ];
        max = [
            -Infinity,
            -Infinity
        ];
        for(var i = 0, len = points.length; i < len; i++){
            (0, $6de594cf8ac295ff$export$96ec731ed4dcb222)(min, min, points[i]);
            (0, $6de594cf8ac295ff$export$8960430cfd85939f)(max, max, points[i]);
        }
        (0, $6de594cf8ac295ff$export$96ec731ed4dcb222)(min, min, constraint[0]);
        (0, $6de594cf8ac295ff$export$8960430cfd85939f)(max, max, constraint[1]);
    }
    for(var i = 0, len = points.length; i < len; i++){
        var point = points[i];
        if (isLoop) {
            prevPoint = points[i ? i - 1 : len - 1];
            nextPoint = points[(i + 1) % len];
        } else if (i === 0 || i === len - 1) {
            cps.push((0, $6de594cf8ac295ff$export$9cd59f9826255e47)(points[i]));
            continue;
        } else {
            prevPoint = points[i - 1];
            nextPoint = points[i + 1];
        }
        (0, $6de594cf8ac295ff$export$f93b5905241a7cca)(v, nextPoint, prevPoint);
        (0, $6de594cf8ac295ff$export$dcdf75081b88279d)(v, v, smooth);
        var d0 = (0, $6de594cf8ac295ff$export$9f17032d917177de)(point, prevPoint);
        var d1 = (0, $6de594cf8ac295ff$export$9f17032d917177de)(point, nextPoint);
        var sum = d0 + d1;
        if (sum !== 0) {
            d0 /= sum;
            d1 /= sum;
        }
        (0, $6de594cf8ac295ff$export$dcdf75081b88279d)(v1, v, -d0);
        (0, $6de594cf8ac295ff$export$dcdf75081b88279d)(v2, v, d1);
        var cp0 = (0, $6de594cf8ac295ff$export$e16d8520af44a096)([], point, v1);
        var cp1 = (0, $6de594cf8ac295ff$export$e16d8520af44a096)([], point, v2);
        if (constraint) {
            (0, $6de594cf8ac295ff$export$8960430cfd85939f)(cp0, cp0, min);
            (0, $6de594cf8ac295ff$export$96ec731ed4dcb222)(cp0, cp0, max);
            (0, $6de594cf8ac295ff$export$8960430cfd85939f)(cp1, cp1, min);
            (0, $6de594cf8ac295ff$export$96ec731ed4dcb222)(cp1, cp1, max);
        }
        cps.push(cp0);
        cps.push(cp1);
    }
    if (isLoop) cps.push(cps.shift());
    return cps;
}


function $68ae9e1c9ba70ac1$export$5cc7f731b5937e99(ctx, shape, closePath) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (points && points.length >= 2) {
        if (smooth) {
            var controlPoints = (0, $de6f6db626660fc1$export$2e2bcd8739ae039)(points, smooth, closePath, shape.smoothConstraint);
            ctx.moveTo(points[0][0], points[0][1]);
            var len = points.length;
            for(var i = 0; i < (closePath ? len : len - 1); i++){
                var cp1 = controlPoints[i * 2];
                var cp2 = controlPoints[i * 2 + 1];
                var p = points[(i + 1) % len];
                ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
            }
        } else {
            ctx.moveTo(points[0][0], points[0][1]);
            for(var i = 1, l = points.length; i < l; i++)ctx.lineTo(points[i][0], points[i][1]);
        }
        closePath && ctx.closePath();
    }
}


var $51acf033123e1a30$export$a34d87b9aaeedd46 = function() {
    function PolygonShape() {
        this.points = null;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolygonShape;
}();
var $51acf033123e1a30$var$Polygon = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Polygon, _super);
    function Polygon(opts) {
        return _super.call(this, opts) || this;
    }
    Polygon.prototype.getDefaultShape = function() {
        return new $51acf033123e1a30$export$a34d87b9aaeedd46();
    };
    Polygon.prototype.buildPath = function(ctx, shape) {
        $68ae9e1c9ba70ac1$export$5cc7f731b5937e99(ctx, shape, true);
    };
    return Polygon;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$51acf033123e1a30$var$Polygon.prototype.type = "polygon";
var $51acf033123e1a30$export$2e2bcd8739ae039 = $51acf033123e1a30$var$Polygon;





var $d28119f30e6bb670$export$e9e5cc3985e19d11 = function() {
    function PolylineShape() {
        this.points = null;
        this.percent = 1;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolylineShape;
}();
var $d28119f30e6bb670$var$Polyline = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Polyline, _super);
    function Polyline(opts) {
        return _super.call(this, opts) || this;
    }
    Polyline.prototype.getDefaultStyle = function() {
        return {
            stroke: "#000",
            fill: null
        };
    };
    Polyline.prototype.getDefaultShape = function() {
        return new $d28119f30e6bb670$export$e9e5cc3985e19d11();
    };
    Polyline.prototype.buildPath = function(ctx, shape) {
        $68ae9e1c9ba70ac1$export$5cc7f731b5937e99(ctx, shape, false);
    };
    return Polyline;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$d28119f30e6bb670$var$Polyline.prototype.type = "polyline";
var $d28119f30e6bb670$export$2e2bcd8739ae039 = $d28119f30e6bb670$var$Polyline;






var $7a316ae5ceff7b27$var$subPixelOptimizeOutputShape = {};
var $7a316ae5ceff7b27$export$64b674d0815308 = function() {
    function LineShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.percent = 1;
    }
    return LineShape;
}();
var $7a316ae5ceff7b27$var$Line = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Line, _super);
    function Line(opts) {
        return _super.call(this, opts) || this;
    }
    Line.prototype.getDefaultStyle = function() {
        return {
            stroke: "#000",
            fill: null
        };
    };
    Line.prototype.getDefaultShape = function() {
        return new $7a316ae5ceff7b27$export$64b674d0815308();
    };
    Line.prototype.buildPath = function(ctx, shape) {
        var x1;
        var y1;
        var x2;
        var y2;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $4d5544821af8d796$export$8b4b620d7f4aad1b)($7a316ae5ceff7b27$var$subPixelOptimizeOutputShape, shape, this.style);
            x1 = optimizedShape.x1;
            y1 = optimizedShape.y1;
            x2 = optimizedShape.x2;
            y2 = optimizedShape.y2;
        } else {
            x1 = shape.x1;
            y1 = shape.y1;
            x2 = shape.x2;
            y2 = shape.y2;
        }
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (percent < 1) {
            x2 = x1 * (1 - percent) + x2 * percent;
            y2 = y1 * (1 - percent) + y2 * percent;
        }
        ctx.lineTo(x2, y2);
    };
    Line.prototype.pointAt = function(p) {
        var shape = this.shape;
        return [
            shape.x1 * (1 - p) + shape.x2 * p,
            shape.y1 * (1 - p) + shape.y2 * p
        ];
    };
    return Line;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$7a316ae5ceff7b27$var$Line.prototype.type = "line";
var $7a316ae5ceff7b27$export$2e2bcd8739ae039 = $7a316ae5ceff7b27$var$Line;






var $6c7800c49630e431$var$out = [];
var $6c7800c49630e431$export$e10089729fef29aa = function() {
    function BezierCurveShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.cpx1 = 0;
        this.cpy1 = 0;
        this.percent = 1;
    }
    return BezierCurveShape;
}();
function $6c7800c49630e431$var$someVectorAt(shape, t, isTangent) {
    var cpx2 = shape.cpx2;
    var cpy2 = shape.cpy2;
    if (cpx2 != null || cpy2 != null) return [
        (isTangent ? (0, $747cfc5611b57cea$export$55fce925c60b6271) : (0, $747cfc5611b57cea$export$547c21de482bbcb2))(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t),
        (isTangent ? (0, $747cfc5611b57cea$export$55fce925c60b6271) : (0, $747cfc5611b57cea$export$547c21de482bbcb2))(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)
    ];
    else return [
        (isTangent ? (0, $747cfc5611b57cea$export$7e161e77e6fff8cb) : (0, $747cfc5611b57cea$export$af17094a950f5073))(shape.x1, shape.cpx1, shape.x2, t),
        (isTangent ? (0, $747cfc5611b57cea$export$7e161e77e6fff8cb) : (0, $747cfc5611b57cea$export$af17094a950f5073))(shape.y1, shape.cpy1, shape.y2, t)
    ];
}
var $6c7800c49630e431$var$BezierCurve = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(BezierCurve, _super);
    function BezierCurve(opts) {
        return _super.call(this, opts) || this;
    }
    BezierCurve.prototype.getDefaultStyle = function() {
        return {
            stroke: "#000",
            fill: null
        };
    };
    BezierCurve.prototype.getDefaultShape = function() {
        return new $6c7800c49630e431$export$e10089729fef29aa();
    };
    BezierCurve.prototype.buildPath = function(ctx, shape) {
        var x1 = shape.x1;
        var y1 = shape.y1;
        var x2 = shape.x2;
        var y2 = shape.y2;
        var cpx1 = shape.cpx1;
        var cpy1 = shape.cpy1;
        var cpx2 = shape.cpx2;
        var cpy2 = shape.cpy2;
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (cpx2 == null || cpy2 == null) {
            if (percent < 1) {
                (0, $747cfc5611b57cea$export$117c659e21a7a060)(x1, cpx1, x2, percent, $6c7800c49630e431$var$out);
                cpx1 = $6c7800c49630e431$var$out[1];
                x2 = $6c7800c49630e431$var$out[2];
                (0, $747cfc5611b57cea$export$117c659e21a7a060)(y1, cpy1, y2, percent, $6c7800c49630e431$var$out);
                cpy1 = $6c7800c49630e431$var$out[1];
                y2 = $6c7800c49630e431$var$out[2];
            }
            ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
        } else {
            if (percent < 1) {
                (0, $747cfc5611b57cea$export$a2ee23a0567039da)(x1, cpx1, cpx2, x2, percent, $6c7800c49630e431$var$out);
                cpx1 = $6c7800c49630e431$var$out[1];
                cpx2 = $6c7800c49630e431$var$out[2];
                x2 = $6c7800c49630e431$var$out[3];
                (0, $747cfc5611b57cea$export$a2ee23a0567039da)(y1, cpy1, cpy2, y2, percent, $6c7800c49630e431$var$out);
                cpy1 = $6c7800c49630e431$var$out[1];
                cpy2 = $6c7800c49630e431$var$out[2];
                y2 = $6c7800c49630e431$var$out[3];
            }
            ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
        }
    };
    BezierCurve.prototype.pointAt = function(t) {
        return $6c7800c49630e431$var$someVectorAt(this.shape, t, false);
    };
    BezierCurve.prototype.tangentAt = function(t) {
        var p = $6c7800c49630e431$var$someVectorAt(this.shape, t, true);
        return $6de594cf8ac295ff$export$a3295358bff77e(p, p);
    };
    return BezierCurve;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$6c7800c49630e431$var$BezierCurve.prototype.type = "bezier-curve";
var $6c7800c49630e431$export$2e2bcd8739ae039 = $6c7800c49630e431$var$BezierCurve;




var $2b5c23eb3597b84a$export$a259dbdc51948277 = function() {
    function ArcShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return ArcShape;
}();
var $2b5c23eb3597b84a$var$Arc = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Arc, _super);
    function Arc(opts) {
        return _super.call(this, opts) || this;
    }
    Arc.prototype.getDefaultStyle = function() {
        return {
            stroke: "#000",
            fill: null
        };
    };
    Arc.prototype.getDefaultShape = function() {
        return new $2b5c23eb3597b84a$export$a259dbdc51948277();
    };
    Arc.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var r = Math.max(shape.r, 0);
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var unitX = Math.cos(startAngle);
        var unitY = Math.sin(startAngle);
        ctx.moveTo(unitX * r + x, unitY * r + y);
        ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
    };
    return Arc;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$2b5c23eb3597b84a$var$Arc.prototype.type = "arc";
var $2b5c23eb3597b84a$export$2e2bcd8739ae039 = $2b5c23eb3597b84a$var$Arc;




var $e152f3dbf8fba6e2$var$CompoundPath = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(CompoundPath, _super);
    function CompoundPath() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "compound";
        return _this;
    }
    CompoundPath.prototype._updatePathDirty = function() {
        var paths = this.shape.paths;
        var dirtyPath = this.shapeChanged();
        for(var i = 0; i < paths.length; i++)dirtyPath = dirtyPath || paths[i].shapeChanged();
        if (dirtyPath) this.dirtyShape();
    };
    CompoundPath.prototype.beforeBrush = function() {
        this._updatePathDirty();
        var paths = this.shape.paths || [];
        var scale = this.getGlobalScale();
        for(var i = 0; i < paths.length; i++){
            if (!paths[i].path) paths[i].createPathProxy();
            paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
        }
    };
    CompoundPath.prototype.buildPath = function(ctx, shape) {
        var paths = shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].buildPath(ctx, paths[i].shape, true);
    };
    CompoundPath.prototype.afterBrush = function() {
        var paths = this.shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].pathUpdated();
    };
    CompoundPath.prototype.getBoundingRect = function() {
        this._updatePathDirty.call(this);
        return (0, $b02ffe7acd508c08$export$2e2bcd8739ae039).prototype.getBoundingRect.call(this);
    };
    return CompoundPath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
var $e152f3dbf8fba6e2$export$2e2bcd8739ae039 = $e152f3dbf8fba6e2$var$CompoundPath;



var $8273248bf9338d40$var$Gradient = function() {
    function Gradient(colorStops) {
        this.colorStops = colorStops || [];
    }
    Gradient.prototype.addColorStop = function(offset, color) {
        this.colorStops.push({
            offset: offset,
            color: color
        });
    };
    return Gradient;
}();
var $8273248bf9338d40$export$2e2bcd8739ae039 = $8273248bf9338d40$var$Gradient;


var $cf44c01491b58e53$var$LinearGradient = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(LinearGradient, _super);
    function LinearGradient(x, y, x2, y2, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0 : x;
        _this.y = y == null ? 0 : y;
        _this.x2 = x2 == null ? 1 : x2;
        _this.y2 = y2 == null ? 0 : y2;
        _this.type = "linear";
        _this.global = globalCoord || false;
        return _this;
    }
    return LinearGradient;
}((0, $8273248bf9338d40$export$2e2bcd8739ae039));
var $cf44c01491b58e53$export$2e2bcd8739ae039 = $cf44c01491b58e53$var$LinearGradient;




var $cd2ee2ba32bb26c3$var$RadialGradient = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(RadialGradient, _super);
    function RadialGradient(x, y, r, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0.5 : x;
        _this.y = y == null ? 0.5 : y;
        _this.r = r == null ? 0.5 : r;
        _this.type = "radial";
        _this.global = globalCoord || false;
        return _this;
    }
    return RadialGradient;
}((0, $8273248bf9338d40$export$2e2bcd8739ae039));
var $cd2ee2ba32bb26c3$export$2e2bcd8739ae039 = $cd2ee2ba32bb26c3$var$RadialGradient;





var $f9793b4d8aade116$var$mathMin = Math.min;
var $f9793b4d8aade116$var$mathMax = Math.max;
var $f9793b4d8aade116$var$mathAbs = Math.abs;
var $f9793b4d8aade116$var$_extent = [
    0,
    0
];
var $f9793b4d8aade116$var$_extent2 = [
    0,
    0
];
var $f9793b4d8aade116$var$_intersectCtx = (0, $1bebe7106c895823$export$a0be2bdbd2369e0e)();
var $f9793b4d8aade116$var$_minTv = $f9793b4d8aade116$var$_intersectCtx.minTv;
var $f9793b4d8aade116$var$_maxTv = $f9793b4d8aade116$var$_intersectCtx.maxTv;
var $f9793b4d8aade116$var$OrientedBoundingRect = function() {
    function OrientedBoundingRect(rect, transform) {
        this._corners = [];
        this._axes = [];
        this._origin = [
            0,
            0
        ];
        for(var i = 0; i < 4; i++)this._corners[i] = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
        for(var i = 0; i < 2; i++)this._axes[i] = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
        if (rect) this.fromBoundingRect(rect, transform);
    }
    OrientedBoundingRect.prototype.fromBoundingRect = function(rect, transform) {
        var corners = this._corners;
        var axes = this._axes;
        var x = rect.x;
        var y = rect.y;
        var x2 = x + rect.width;
        var y2 = y + rect.height;
        corners[0].set(x, y);
        corners[1].set(x2, y);
        corners[2].set(x2, y2);
        corners[3].set(x, y2);
        if (transform) for(var i = 0; i < 4; i++)corners[i].transform(transform);
        (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub(axes[0], corners[1], corners[0]);
        (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub(axes[1], corners[3], corners[0]);
        axes[0].normalize();
        axes[1].normalize();
        for(var i = 0; i < 2; i++)this._origin[i] = axes[i].dot(corners[0]);
    };
    OrientedBoundingRect.prototype.intersect = function(other, mtv, opt) {
        var overlapped = true;
        var noMtv = !mtv;
        if (mtv) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).set(mtv, 0, 0);
        $f9793b4d8aade116$var$_intersectCtx.reset(opt, !noMtv);
        if (!this._intersectCheckOneSide(this, other, noMtv, 1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!this._intersectCheckOneSide(other, this, noMtv, -1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!noMtv && !$f9793b4d8aade116$var$_intersectCtx.negativeSize) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy(mtv, overlapped ? $f9793b4d8aade116$var$_intersectCtx.useDir ? $f9793b4d8aade116$var$_intersectCtx.dirMinTv : $f9793b4d8aade116$var$_minTv : $f9793b4d8aade116$var$_maxTv);
        return overlapped;
    };
    OrientedBoundingRect.prototype._intersectCheckOneSide = function(self, other, noMtv, inverse) {
        var overlapped = true;
        for(var i = 0; i < 2; i++){
            var axis = self._axes[i];
            self._getProjMinMaxOnAxis(i, self._corners, $f9793b4d8aade116$var$_extent);
            self._getProjMinMaxOnAxis(i, other._corners, $f9793b4d8aade116$var$_extent2);
            if ($f9793b4d8aade116$var$_intersectCtx.negativeSize || $f9793b4d8aade116$var$_extent[1] < $f9793b4d8aade116$var$_extent2[0] || $f9793b4d8aade116$var$_extent[0] > $f9793b4d8aade116$var$_extent2[1]) {
                overlapped = false;
                if ($f9793b4d8aade116$var$_intersectCtx.negativeSize || noMtv) return overlapped;
                var dist0 = $f9793b4d8aade116$var$mathAbs($f9793b4d8aade116$var$_extent2[0] - $f9793b4d8aade116$var$_extent[1]);
                var dist1 = $f9793b4d8aade116$var$mathAbs($f9793b4d8aade116$var$_extent[0] - $f9793b4d8aade116$var$_extent2[1]);
                if ($f9793b4d8aade116$var$mathMin(dist0, dist1) > $f9793b4d8aade116$var$_maxTv.len()) {
                    if (dist0 < dist1) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).scale($f9793b4d8aade116$var$_maxTv, axis, -dist0 * inverse);
                    else (0, $b887f038f104fe7e$export$2e2bcd8739ae039).scale($f9793b4d8aade116$var$_maxTv, axis, dist1 * inverse);
                }
            } else if (!noMtv) {
                var dist0 = $f9793b4d8aade116$var$mathAbs($f9793b4d8aade116$var$_extent2[0] - $f9793b4d8aade116$var$_extent[1]);
                var dist1 = $f9793b4d8aade116$var$mathAbs($f9793b4d8aade116$var$_extent[0] - $f9793b4d8aade116$var$_extent2[1]);
                if ($f9793b4d8aade116$var$_intersectCtx.useDir || $f9793b4d8aade116$var$mathMin(dist0, dist1) < $f9793b4d8aade116$var$_minTv.len()) {
                    if (dist0 < dist1 || !$f9793b4d8aade116$var$_intersectCtx.bidirectional) {
                        (0, $b887f038f104fe7e$export$2e2bcd8739ae039).scale($f9793b4d8aade116$var$_minTv, axis, dist0 * inverse);
                        if ($f9793b4d8aade116$var$_intersectCtx.useDir) $f9793b4d8aade116$var$_intersectCtx.calcDirMTV();
                    }
                    if (dist0 >= dist1 || !$f9793b4d8aade116$var$_intersectCtx.bidirectional) {
                        (0, $b887f038f104fe7e$export$2e2bcd8739ae039).scale($f9793b4d8aade116$var$_minTv, axis, -dist1 * inverse);
                        if ($f9793b4d8aade116$var$_intersectCtx.useDir) $f9793b4d8aade116$var$_intersectCtx.calcDirMTV();
                    }
                }
            }
        }
        return overlapped;
    };
    OrientedBoundingRect.prototype._getProjMinMaxOnAxis = function(dim, corners, out) {
        var axis = this._axes[dim];
        var origin = this._origin;
        var proj = corners[0].dot(axis) + origin[dim];
        var min = proj;
        var max = proj;
        for(var i = 1; i < corners.length; i++){
            var proj_1 = corners[i].dot(axis) + origin[dim];
            min = $f9793b4d8aade116$var$mathMin(proj_1, min);
            max = $f9793b4d8aade116$var$mathMax(proj_1, max);
        }
        out[0] = min + $f9793b4d8aade116$var$_intersectCtx.touchThreshold;
        out[1] = max - $f9793b4d8aade116$var$_intersectCtx.touchThreshold;
        $f9793b4d8aade116$var$_intersectCtx.negativeSize = out[1] < out[0];
    };
    return OrientedBoundingRect;
}();
var $f9793b4d8aade116$export$2e2bcd8739ae039 = $f9793b4d8aade116$var$OrientedBoundingRect;






var $ee829f116f003981$var$m = [];
var $ee829f116f003981$var$IncrementalDisplayable = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(IncrementalDisplayable, _super);
    function IncrementalDisplayable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notClear = true;
        _this.incremental = true;
        _this._displayables = [];
        _this._temporaryDisplayables = [];
        _this._cursor = 0;
        return _this;
    }
    IncrementalDisplayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    IncrementalDisplayable.prototype.useStyle = function() {
        this.style = {};
    };
    IncrementalDisplayable.prototype.getCursor = function() {
        return this._cursor;
    };
    IncrementalDisplayable.prototype.innerAfterBrush = function() {
        this._cursor = this._displayables.length;
    };
    IncrementalDisplayable.prototype.clearDisplaybles = function() {
        this._displayables = [];
        this._temporaryDisplayables = [];
        this._cursor = 0;
        this.markRedraw();
        this.notClear = false;
    };
    IncrementalDisplayable.prototype.clearTemporalDisplayables = function() {
        this._temporaryDisplayables = [];
    };
    IncrementalDisplayable.prototype.addDisplayable = function(displayable, notPersistent) {
        if (notPersistent) this._temporaryDisplayables.push(displayable);
        else this._displayables.push(displayable);
        this.markRedraw();
    };
    IncrementalDisplayable.prototype.addDisplayables = function(displayables, notPersistent) {
        notPersistent = notPersistent || false;
        for(var i = 0; i < displayables.length; i++)this.addDisplayable(displayables[i], notPersistent);
    };
    IncrementalDisplayable.prototype.getDisplayables = function() {
        return this._displayables;
    };
    IncrementalDisplayable.prototype.getTemporalDisplayables = function() {
        return this._temporaryDisplayables;
    };
    IncrementalDisplayable.prototype.eachPendingDisplayable = function(cb) {
        for(var i = this._cursor; i < this._displayables.length; i++)cb && cb(this._displayables[i]);
        for(var i = 0; i < this._temporaryDisplayables.length; i++)cb && cb(this._temporaryDisplayables[i]);
    };
    IncrementalDisplayable.prototype.update = function() {
        this.updateTransform();
        for(var i = this._cursor; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
        for(var i = 0; i < this._temporaryDisplayables.length; i++){
            var displayable = this._temporaryDisplayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
    };
    IncrementalDisplayable.prototype.getBoundingRect = function() {
        if (!this._rect) {
            var rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(Infinity, Infinity, -Infinity, -Infinity);
            for(var i = 0; i < this._displayables.length; i++){
                var displayable = this._displayables[i];
                var childRect = displayable.getBoundingRect().clone();
                if (displayable.needLocalTransform()) childRect.applyTransform(displayable.getLocalTransform($ee829f116f003981$var$m));
                rect.union(childRect);
            }
            this._rect = rect;
        }
        return this._rect;
    };
    IncrementalDisplayable.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        if (rect.contain(localPos[0], localPos[1])) for(var i = 0; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            if (displayable.contain(x, y)) return true;
        }
        return false;
    };
    return IncrementalDisplayable;
}((0, $56206a6cb4666931$export$2e2bcd8739ae039));
var $ee829f116f003981$export$2e2bcd8739ae039 = $ee829f116f003981$var$IncrementalDisplayable;







var $5b455ae6f843ac47$var$_customShapeMap = {};
var $5b455ae6f843ac47$export$cb4c12294149dd2d = [
    "x",
    "y"
];
var $5b455ae6f843ac47$export$a3fe6d967173a3ac = [
    "width",
    "height"
];
function $5b455ae6f843ac47$export$d0d5398c9d612037(opts) {
    return (0, $b02ffe7acd508c08$export$2e2bcd8739ae039).extend(opts);
}
var $5b455ae6f843ac47$var$extendPathFromString = $15b38920672b9006$export$68e3a51ba2ed417c;
function $5b455ae6f843ac47$export$53b54a3137026af0(pathData, opts) {
    return $5b455ae6f843ac47$var$extendPathFromString(pathData, opts);
}
function $5b455ae6f843ac47$export$2b95b62e3aaf6fdd(name, ShapeClass) {
    $5b455ae6f843ac47$var$_customShapeMap[name] = ShapeClass;
}
function $5b455ae6f843ac47$export$51df4b5565a58189(name) {
    if ($5b455ae6f843ac47$var$_customShapeMap.hasOwnProperty(name)) return $5b455ae6f843ac47$var$_customShapeMap[name];
}
function $5b455ae6f843ac47$export$aa9bab72412f5613(pathData, opts, rect, layout) {
    var path = $15b38920672b9006$export$ae5b259626f00aeb(pathData, opts);
    if (rect) {
        if (layout === "center") rect = $5b455ae6f843ac47$var$centerGraphic(rect, path.getBoundingRect());
        $5b455ae6f843ac47$export$566dbf1c62b04fc7(path, rect);
    }
    return path;
}
function $5b455ae6f843ac47$export$7a2bdede98851ac5(imageUrl, rect, layout) {
    var zrImg = new (0, $86adec94217b86c6$export$2e2bcd8739ae039)({
        style: {
            image: imageUrl,
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        onload: function(img) {
            if (layout === "center") {
                var boundingRect = {
                    width: img.width,
                    height: img.height
                };
                zrImg.setStyle($5b455ae6f843ac47$var$centerGraphic(rect, boundingRect));
            }
        }
    });
    return zrImg;
}
/**
 * Get position of centered element in bounding box.
 *
 * @param  rect         element local bounding box
 * @param  boundingRect constraint bounding box
 * @return element position containing x, y, width, and height
 */ function $5b455ae6f843ac47$var$centerGraphic(rect, boundingRect) {
    // Set rect to center, keep width / height ratio.
    var aspect = boundingRect.width / boundingRect.height;
    var width = rect.height * aspect;
    var height;
    if (width <= rect.width) height = rect.height;
    else {
        width = rect.width;
        height = width / aspect;
    }
    var cx = rect.x + rect.width / 2;
    var cy = rect.y + rect.height / 2;
    return {
        x: cx - width / 2,
        y: cy - height / 2,
        width: width,
        height: height
    };
}
var $5b455ae6f843ac47$export$7b1dd269fbc4e903 = $15b38920672b9006$export$7b1dd269fbc4e903;
function $5b455ae6f843ac47$export$566dbf1c62b04fc7(path, rect) {
    if (!path.applyTransform) return;
    var pathRect = path.getBoundingRect();
    var m = pathRect.calculateTransform(rect);
    path.applyTransform(m);
}
function $5b455ae6f843ac47$export$8b4b620d7f4aad1b(shape, lineWidth) {
    $4d5544821af8d796$export$8b4b620d7f4aad1b(shape, shape, {
        lineWidth: lineWidth
    });
    return shape;
}
function $5b455ae6f843ac47$export$60e2aa74957d0b9d(shape, style) {
    $4d5544821af8d796$export$60e2aa74957d0b9d(shape, shape, style);
    return shape;
}
var $5b455ae6f843ac47$export$72c4fd4c1b8fcb10 = $4d5544821af8d796$export$72c4fd4c1b8fcb10;
function $5b455ae6f843ac47$export$fce0c6cfca85ed96(target, ancestor) {
    var mat = $f41ebb9dd60b55b4$export$f0954fd7d5368655([]);
    while(target && target !== ancestor){
        $f41ebb9dd60b55b4$export$6e3a27864ab166fe(mat, target.getLocalTransform(), mat);
        target = target.parent;
    }
    return mat;
}
function $5b455ae6f843ac47$export$9f9dcb98c894b623(target, transform, invert) {
    if (transform && !(0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(transform)) transform = (0, $becf2d727f9cf450$export$2e2bcd8739ae039).getLocalTransform(transform);
    if (invert) transform = $f41ebb9dd60b55b4$export$6897c284b6f9f4dc([], transform);
    return $6de594cf8ac295ff$export$9f9dcb98c894b623([], target, transform);
}
function $5b455ae6f843ac47$export$fff94e9792354cfa(direction, transform, invert) {
    // Pick a base, ensure that transform result will not be (0, 0).
    var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : (0, $cfc1f3b422a3185f$export$5860c226b237d9a6)(2 * transform[4] / transform[0]);
    var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : (0, $cfc1f3b422a3185f$export$5860c226b237d9a6)(2 * transform[4] / transform[2]);
    var vertex = [
        direction === "left" ? -hBase : direction === "right" ? hBase : 0,
        direction === "top" ? -vBase : direction === "bottom" ? vBase : 0
    ];
    vertex = $5b455ae6f843ac47$export$9f9dcb98c894b623(vertex, transform, invert);
    return (0, $cfc1f3b422a3185f$export$5860c226b237d9a6)(vertex[0]) > (0, $cfc1f3b422a3185f$export$5860c226b237d9a6)(vertex[1]) ? vertex[0] > 0 ? "right" : "left" : vertex[1] > 0 ? "bottom" : "top";
}
function $5b455ae6f843ac47$var$isNotGroup(el) {
    return !el.isGroup;
}
function $5b455ae6f843ac47$var$isPath(el) {
    return el.shape != null;
}
function $5b455ae6f843ac47$export$64fcab7860c216ae(g1, g2, animatableModel) {
    if (!g1 || !g2) return;
    function getElMap(g) {
        var elMap = {};
        g.traverse(function(el) {
            if ($5b455ae6f843ac47$var$isNotGroup(el) && el.anid) elMap[el.anid] = el;
        });
        return elMap;
    }
    function getAnimatableProps(el) {
        var obj = {
            x: el.x,
            y: el.y,
            rotation: el.rotation
        };
        if ($5b455ae6f843ac47$var$isPath(el)) obj.shape = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(el.shape);
        return obj;
    }
    var elMap1 = getElMap(g1);
    g2.traverse(function(el) {
        if ($5b455ae6f843ac47$var$isNotGroup(el) && el.anid) {
            var oldEl = elMap1[el.anid];
            if (oldEl) {
                var newProp = getAnimatableProps(el);
                el.attr(getAnimatableProps(oldEl));
                (0, $8b353638fbedfefa$export$c8dce3c08436e91e)(el, newProp, animatableModel, (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).dataIndex);
            }
        }
    });
}
function $5b455ae6f843ac47$export$e2f409471bbbc1dc(points, rect) {
    // FIXME: This way might be incorrect when graphic clipped by a corner
    // and when element has a border.
    return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(points, function(point) {
        var x = point[0];
        x = (0, $cfc1f3b422a3185f$export$2ca8010d037f830f)(x, rect.x);
        x = (0, $cfc1f3b422a3185f$export$e411eeaf23dccbe8)(x, rect.x + rect.width);
        var y = point[1];
        y = (0, $cfc1f3b422a3185f$export$2ca8010d037f830f)(y, rect.y);
        y = (0, $cfc1f3b422a3185f$export$e411eeaf23dccbe8)(y, rect.y + rect.height);
        return [
            x,
            y
        ];
    });
}
function $5b455ae6f843ac47$export$d0d3709202b8b2a(targetRect, rect) {
    var x = (0, $cfc1f3b422a3185f$export$2ca8010d037f830f)(targetRect.x, rect.x);
    var x2 = (0, $cfc1f3b422a3185f$export$e411eeaf23dccbe8)(targetRect.x + targetRect.width, rect.x + rect.width);
    var y = (0, $cfc1f3b422a3185f$export$2ca8010d037f830f)(targetRect.y, rect.y);
    var y2 = (0, $cfc1f3b422a3185f$export$e411eeaf23dccbe8)(targetRect.y + targetRect.height, rect.y + rect.height);
    // If the total rect is cliped, nothing, including the border,
    // should be painted. So return undefined.
    if (x2 >= x && y2 >= y) return {
        x: x,
        y: y,
        width: x2 - x,
        height: y2 - y
    };
}
function $5b455ae6f843ac47$export$274edc73af1ae9c8(iconStr, // Support 'image://' or 'path://' or direct svg path.
opt, rect) {
    var innerOpts = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
        rectHover: true
    }, opt);
    var style = innerOpts.style = {
        strokeNoScale: true
    };
    rect = rect || {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    };
    if (iconStr) return iconStr.indexOf("image://") === 0 ? (style.image = iconStr.slice(8), (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(style, rect), new (0, $86adec94217b86c6$export$2e2bcd8739ae039)(innerOpts)) : $5b455ae6f843ac47$export$aa9bab72412f5613(iconStr.replace("path://", ""), innerOpts, rect, "center");
}
function $5b455ae6f843ac47$export$4f47c855a5e9ae9(a1x, a1y, a2x, a2y, points) {
    for(var i = 0, p2 = points[points.length - 1]; i < points.length; i++){
        var p = points[i];
        if ($5b455ae6f843ac47$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) return true;
        p2 = p;
    }
}
function $5b455ae6f843ac47$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
    // let `vec_m` to be `vec_a2 - vec_a1` and `vec_n` to be `vec_b2 - vec_b1`.
    var mx = a2x - a1x;
    var my = a2y - a1y;
    var nx = b2x - b1x;
    var ny = b2y - b1y;
    // `vec_m` and `vec_n` are parallel iff
    //     existing `k` such that `vec_m = k · vec_n`, equivalent to `vec_m X vec_n = 0`.
    var nmCrossProduct = $5b455ae6f843ac47$var$crossProduct2d(nx, ny, mx, my);
    if ($5b455ae6f843ac47$var$nearZero(nmCrossProduct)) return false;
    // `vec_m` and `vec_n` are intersect iff
    //     existing `p` and `q` in [0, 1] such that `vec_a1 + p * vec_m = vec_b1 + q * vec_n`,
    //     such that `q = ((vec_a1 - vec_b1) X vec_m) / (vec_n X vec_m)`
    //           and `p = ((vec_a1 - vec_b1) X vec_n) / (vec_n X vec_m)`.
    var b1a1x = a1x - b1x;
    var b1a1y = a1y - b1y;
    var q = $5b455ae6f843ac47$var$crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;
    if (q < 0 || q > 1) return false;
    var p = $5b455ae6f843ac47$var$crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
    if (p < 0 || p > 1) return false;
    return true;
}
/**
 * Cross product of 2-dimension vector.
 */ function $5b455ae6f843ac47$var$crossProduct2d(x1, y1, x2, y2) {
    return x1 * y2 - x2 * y1;
}
function $5b455ae6f843ac47$var$nearZero(val) {
    return val <= 1e-6 && val >= -0.000001;
}
function $5b455ae6f843ac47$export$81ed941fdeb91c7c(rect, delta, shrinkOrExpand, noNegative, minSize // by default [0, 0].
) {
    if (delta == null) return rect;
    else if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(delta)) $5b455ae6f843ac47$var$_tmpExpandRectDelta[0] = $5b455ae6f843ac47$var$_tmpExpandRectDelta[1] = $5b455ae6f843ac47$var$_tmpExpandRectDelta[2] = $5b455ae6f843ac47$var$_tmpExpandRectDelta[3] = delta;
    else {
        $5b455ae6f843ac47$var$_tmpExpandRectDelta[0] = delta[0];
        $5b455ae6f843ac47$var$_tmpExpandRectDelta[1] = delta[1];
        $5b455ae6f843ac47$var$_tmpExpandRectDelta[2] = delta[2];
        $5b455ae6f843ac47$var$_tmpExpandRectDelta[3] = delta[3];
    }
    if (noNegative) {
        $5b455ae6f843ac47$var$_tmpExpandRectDelta[0] = (0, $cfc1f3b422a3185f$export$2ca8010d037f830f)(0, $5b455ae6f843ac47$var$_tmpExpandRectDelta[0]);
        $5b455ae6f843ac47$var$_tmpExpandRectDelta[1] = (0, $cfc1f3b422a3185f$export$2ca8010d037f830f)(0, $5b455ae6f843ac47$var$_tmpExpandRectDelta[1]);
        $5b455ae6f843ac47$var$_tmpExpandRectDelta[2] = (0, $cfc1f3b422a3185f$export$2ca8010d037f830f)(0, $5b455ae6f843ac47$var$_tmpExpandRectDelta[2]);
        $5b455ae6f843ac47$var$_tmpExpandRectDelta[3] = (0, $cfc1f3b422a3185f$export$2ca8010d037f830f)(0, $5b455ae6f843ac47$var$_tmpExpandRectDelta[3]);
    }
    if (shrinkOrExpand) {
        $5b455ae6f843ac47$var$_tmpExpandRectDelta[0] = -$5b455ae6f843ac47$var$_tmpExpandRectDelta[0];
        $5b455ae6f843ac47$var$_tmpExpandRectDelta[1] = -$5b455ae6f843ac47$var$_tmpExpandRectDelta[1];
        $5b455ae6f843ac47$var$_tmpExpandRectDelta[2] = -$5b455ae6f843ac47$var$_tmpExpandRectDelta[2];
        $5b455ae6f843ac47$var$_tmpExpandRectDelta[3] = -$5b455ae6f843ac47$var$_tmpExpandRectDelta[3];
    }
    $5b455ae6f843ac47$var$expandRectOnOneDimension(rect, $5b455ae6f843ac47$var$_tmpExpandRectDelta, "x", "width", 3, 1, minSize && minSize[0] || 0);
    $5b455ae6f843ac47$var$expandRectOnOneDimension(rect, $5b455ae6f843ac47$var$_tmpExpandRectDelta, "y", "height", 0, 2, minSize && minSize[1] || 0);
    return rect;
}
var $5b455ae6f843ac47$var$_tmpExpandRectDelta = [
    0,
    0,
    0,
    0
];
function $5b455ae6f843ac47$var$expandRectOnOneDimension(rect, delta, xy, wh, ltIdx, rbIdx, minSize) {
    var deltaSum = delta[rbIdx] + delta[ltIdx];
    var oldSize = rect[wh];
    rect[wh] += deltaSum;
    minSize = (0, $cfc1f3b422a3185f$export$2ca8010d037f830f)(0, (0, $cfc1f3b422a3185f$export$e411eeaf23dccbe8)(minSize, oldSize));
    if (rect[wh] < minSize) {
        rect[wh] = minSize;
        // Try to make the position of the zero rect reasonable in most visual cases.
        rect[xy] += delta[ltIdx] >= 0 ? -delta[ltIdx] : delta[rbIdx] >= 0 ? oldSize + delta[rbIdx] : (0, $cfc1f3b422a3185f$export$5860c226b237d9a6)(deltaSum) > 1e-8 ? (oldSize - minSize) * delta[ltIdx] / deltaSum : 0;
    } else rect[xy] -= delta[ltIdx];
}
function $5b455ae6f843ac47$export$fc6410d97fab306c(opt) {
    var itemTooltipOption = opt.itemTooltipOption;
    var componentModel = opt.componentModel;
    var itemName = opt.itemName;
    var itemTooltipOptionObj = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(itemTooltipOption) ? {
        formatter: itemTooltipOption
    } : itemTooltipOption;
    var mainType = componentModel.mainType;
    var componentIndex = componentModel.componentIndex;
    var formatterParams = {
        componentType: mainType,
        name: itemName,
        $vars: [
            "name"
        ]
    };
    formatterParams[mainType + "Index"] = componentIndex;
    var formatterParamsExtra = opt.formatterParamsExtra;
    if (formatterParamsExtra) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(formatterParamsExtra), function(key) {
        if (!(0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(formatterParams, key)) {
            formatterParams[key] = formatterParamsExtra[key];
            formatterParams.$vars.push(key);
        }
    });
    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(opt.el);
    ecData.componentMainType = mainType;
    ecData.componentIndex = componentIndex;
    ecData.tooltipConfig = {
        name: itemName,
        option: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
            content: itemName,
            encodeHTMLContent: true,
            formatterParams: formatterParams
        }, itemTooltipOptionObj)
    };
}
function $5b455ae6f843ac47$var$traverseElement(el, cb) {
    var stopped;
    // TODO
    // Polyfill for fixing zrender group traverse don't visit it's root issue.
    if (el.isGroup) stopped = cb(el);
    if (!stopped) el.traverse(cb);
}
function $5b455ae6f843ac47$export$3e564442729bf048(els, cb) {
    if (els) {
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(els)) for(var i = 0; i < els.length; i++)$5b455ae6f843ac47$var$traverseElement(els[i], cb);
        else $5b455ae6f843ac47$var$traverseElement(els, cb);
    }
}
function $5b455ae6f843ac47$export$576610ccf2234b72(transform) {
    return !transform || (0, $cfc1f3b422a3185f$export$5860c226b237d9a6)(transform[1]) < $5b455ae6f843ac47$var$AXIS_ALIGN_EPSILON && (0, $cfc1f3b422a3185f$export$5860c226b237d9a6)(transform[2]) < $5b455ae6f843ac47$var$AXIS_ALIGN_EPSILON || (0, $cfc1f3b422a3185f$export$5860c226b237d9a6)(transform[0]) < $5b455ae6f843ac47$var$AXIS_ALIGN_EPSILON && (0, $cfc1f3b422a3185f$export$5860c226b237d9a6)(transform[3]) < $5b455ae6f843ac47$var$AXIS_ALIGN_EPSILON;
}
var $5b455ae6f843ac47$var$AXIS_ALIGN_EPSILON = 1e-5;
function $5b455ae6f843ac47$export$38128dfd9a498e1(target, source) {
    return target ? (0, $1bebe7106c895823$export$2e2bcd8739ae039).copy(target, source) : source.clone();
}
function $5b455ae6f843ac47$export$4d61283a070e0362(target, source) {
    return source ? $f41ebb9dd60b55b4$export$784d13d8ee351f07(target || $f41ebb9dd60b55b4$export$185802fd694ee1f5(), source) : undefined;
}
function $5b455ae6f843ac47$export$1500a631bea5adda(model) {
    return {
        z: model.get("z") || 0,
        zlevel: model.get("zlevel") || 0
    };
}
function $5b455ae6f843ac47$export$8215ea00957327f2(el) {
    var max = -Infinity;
    var min = Infinity;
    $5b455ae6f843ac47$var$traverseElement(el, function(el) {
        visitEl(el);
        visitEl(el.getTextContent());
        visitEl(el.getTextGuideLine());
    });
    function visitEl(el) {
        if (!el || el.isGroup) return;
        var currentStates = el.currentStates;
        if (currentStates.length) for(var idx = 0; idx < currentStates.length; idx++)calcZ2(el.states[currentStates[idx]]);
        calcZ2(el);
    }
    function calcZ2(entity) {
        if (entity) {
            var z2 = entity.z2;
            // Consider z2 may be NullUndefined
            if (z2 > max) max = z2;
            if (z2 < min) min = z2;
        }
    }
    if (min > max) min = max = 0;
    return {
        min: min,
        max: max
    };
}
function $5b455ae6f843ac47$export$d31cf465bf5e8879(el, z, zlevel) {
    $5b455ae6f843ac47$var$doUpdateZ(el, z, zlevel, -Infinity);
}
function $5b455ae6f843ac47$var$doUpdateZ(el, z, zlevel, // FIXME: Ideally all the labels should be above all the glyphs by default,
//  e.g. in graph, edge labels should be above node elements.
//  Currently impl does not guarantee that.
maxZ2) {
    // `ignoreModelZ` is used to intentionally lift elements to cover other elements,
    // where maxZ2 (for label.z2) should also not be counted for its parents.
    if (el.ignoreModelZ) return maxZ2;
    // Group may also have textContent
    var label = el.getTextContent();
    var labelLine = el.getTextGuideLine();
    var isGroup = el.isGroup;
    if (isGroup) {
        // set z & zlevel of children elements of Group
        var children = el.childrenRef();
        for(var i = 0; i < children.length; i++)maxZ2 = (0, $cfc1f3b422a3185f$export$2ca8010d037f830f)($5b455ae6f843ac47$var$doUpdateZ(children[i], z, zlevel, maxZ2), maxZ2);
    } else {
        // not Group
        el.z = z;
        el.zlevel = zlevel;
        maxZ2 = (0, $cfc1f3b422a3185f$export$2ca8010d037f830f)(el.z2 || 0, maxZ2);
    }
    // always set z and zlevel if label/labelLine exists
    if (label) {
        label.z = z;
        label.zlevel = zlevel;
        // lift z2 of text content
        // TODO if el.emphasis.z2 is spcefied, what about textContent.
        isFinite(maxZ2) && (label.z2 = maxZ2 + 2);
    }
    if (labelLine) {
        var textGuideLineConfig = el.textGuideLineConfig;
        labelLine.z = z;
        labelLine.zlevel = zlevel;
        isFinite(maxZ2) && (labelLine.z2 = maxZ2 + (textGuideLineConfig && textGuideLineConfig.showAbove ? 1 : -1));
    }
    return maxZ2;
}
// Register built-in shapes. These shapes might be overwritten
// by users, although we do not recommend that.
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("circle", (0, $1e68d8727773abb7$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("ellipse", (0, $4a809f055a7e524c$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("sector", (0, $a3e1dec0a3875b49$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("ring", (0, $9da0cbfd3f86fdc1$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("polygon", (0, $51acf033123e1a30$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("polyline", (0, $d28119f30e6bb670$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("rect", (0, $419e5ff2f303755e$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("line", (0, $7a316ae5ceff7b27$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("bezierCurve", (0, $6c7800c49630e431$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("arc", (0, $2b5c23eb3597b84a$export$2e2bcd8739ae039));


var $6800dfcb6e1e2a44$var$EMPTY_OBJ = {};
function $6800dfcb6e1e2a44$export$b533918394a58529(label, labelTexts) {
    for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
        var stateName = (0, $2bf82c0980125b62$export$151308dceb52d5b)[i];
        var text = labelTexts[stateName];
        var state = label.ensureState(stateName);
        state.style = state.style || {};
        state.style.text = text;
    }
    var oldStates = label.currentStates.slice();
    label.clearStates(true);
    label.setStyle({
        text: labelTexts.normal
    });
    label.useStates(oldStates, true);
}
function $6800dfcb6e1e2a44$var$getLabelText(opt, stateModels, interpolatedValue) {
    var labelFetcher = opt.labelFetcher;
    var labelDataIndex = opt.labelDataIndex;
    var labelDimIndex = opt.labelDimIndex;
    var normalModel = stateModels.normal;
    var baseText;
    if (labelFetcher) baseText = labelFetcher.getFormattedLabel(labelDataIndex, "normal", null, labelDimIndex, normalModel && normalModel.get("formatter"), interpolatedValue != null ? {
        interpolatedValue: interpolatedValue
    } : null);
    if (baseText == null) baseText = (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(opt.defaultText) ? opt.defaultText(labelDataIndex, opt, interpolatedValue) : opt.defaultText;
    var statesText = {
        normal: baseText
    };
    for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
        var stateName = (0, $2bf82c0980125b62$export$151308dceb52d5b)[i];
        var stateModel = stateModels[stateName];
        statesText[stateName] = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, stateName, null, labelDimIndex, stateModel && stateModel.get("formatter")) : null, baseText);
    }
    return statesText;
}
function $6800dfcb6e1e2a44$export$9a13992917966657(targetEl, labelStatesModels, opt, stateSpecified) {
    opt = opt || $6800dfcb6e1e2a44$var$EMPTY_OBJ;
    var isSetOnText = targetEl instanceof (0, $fe885cc21795562b$export$2e2bcd8739ae039);
    var needsCreateText = false;
    for(var i = 0; i < (0, $2bf82c0980125b62$export$57ee5306b85ad7d5).length; i++){
        var stateModel = labelStatesModels[(0, $2bf82c0980125b62$export$57ee5306b85ad7d5)[i]];
        if (stateModel && stateModel.getShallow("show")) {
            needsCreateText = true;
            break;
        }
    }
    var textContent = isSetOnText ? targetEl : targetEl.getTextContent();
    if (needsCreateText) {
        if (!isSetOnText) {
            // Reuse the previous
            if (!textContent) {
                textContent = new (0, $fe885cc21795562b$export$2e2bcd8739ae039)();
                targetEl.setTextContent(textContent);
            }
            // Use same state proxy
            if (targetEl.stateProxy) textContent.stateProxy = targetEl.stateProxy;
        }
        var labelStatesTexts = $6800dfcb6e1e2a44$var$getLabelText(opt, labelStatesModels);
        var normalModel = labelStatesModels.normal;
        var showNormal = !!normalModel.getShallow("show");
        var normalStyle = $6800dfcb6e1e2a44$export$f8998c3d0a13de59(normalModel, stateSpecified && stateSpecified.normal, opt, false, !isSetOnText);
        normalStyle.text = labelStatesTexts.normal;
        if (!isSetOnText) // Always create new
        targetEl.setTextConfig($6800dfcb6e1e2a44$export$e149afab8df6e053(normalModel, opt, false));
        for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
            var stateName = (0, $2bf82c0980125b62$export$151308dceb52d5b)[i];
            var stateModel = labelStatesModels[stateName];
            if (stateModel) {
                var stateObj = textContent.ensureState(stateName);
                var stateShow = !!(0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(stateModel.getShallow("show"), showNormal);
                if (stateShow !== showNormal) stateObj.ignore = !stateShow;
                stateObj.style = $6800dfcb6e1e2a44$export$f8998c3d0a13de59(stateModel, stateSpecified && stateSpecified[stateName], opt, true, !isSetOnText);
                stateObj.style.text = labelStatesTexts[stateName];
                if (!isSetOnText) {
                    var targetElEmphasisState = targetEl.ensureState(stateName);
                    targetElEmphasisState.textConfig = $6800dfcb6e1e2a44$export$e149afab8df6e053(stateModel, opt, true);
                }
            }
        }
        // PENDING: if there is many requirements that emphasis position
        // need to be different from normal position, we might consider
        // auto silent is those cases.
        textContent.silent = !!normalModel.getShallow("silent");
        // Keep x and y
        if (textContent.style.x != null) normalStyle.x = textContent.style.x;
        if (textContent.style.y != null) normalStyle.y = textContent.style.y;
        textContent.ignore = !showNormal;
        // Always create new style.
        textContent.useStyle(normalStyle);
        textContent.dirty();
        if (opt.enableTextSetter) $6800dfcb6e1e2a44$export$f62786d3261ab0f4(textContent).setLabelText = function(interpolatedValue) {
            var labelStatesTexts = $6800dfcb6e1e2a44$var$getLabelText(opt, labelStatesModels, interpolatedValue);
            $6800dfcb6e1e2a44$export$b533918394a58529(textContent, labelStatesTexts);
        };
    } else if (textContent) // Not display rich text.
    textContent.ignore = true;
    targetEl.dirty();
}
function $6800dfcb6e1e2a44$export$9739a32674be5893(itemModel, labelName) {
    labelName = labelName || "label";
    var statesModels = {
        normal: itemModel.getModel(labelName)
    };
    for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
        var stateName = (0, $2bf82c0980125b62$export$151308dceb52d5b)[i];
        statesModels[stateName] = itemModel.getModel([
            stateName,
            labelName
        ]);
    }
    return statesModels;
}
function $6800dfcb6e1e2a44$export$f8998c3d0a13de59(textStyleModel, specifiedTextStyle, // Fixed style in the code. Can't be set by model.
opt, isNotNormal, isAttached // If text is attached on an element. If so, auto color will handling in zrender.
) {
    var textStyle = {};
    $6800dfcb6e1e2a44$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached);
    specifiedTextStyle && (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(textStyle, specifiedTextStyle);
    // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
    return textStyle;
}
function $6800dfcb6e1e2a44$export$e149afab8df6e053(textStyleModel, opt, isNotNormal) {
    opt = opt || {};
    var textConfig = {};
    var labelPosition;
    var labelRotate = textStyleModel.getShallow("rotate");
    var labelDistance = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.getShallow("distance"), isNotNormal ? null : 5);
    var labelOffset = textStyleModel.getShallow("offset");
    labelPosition = textStyleModel.getShallow("position") || (isNotNormal ? null : "inside");
    // 'outside' is not a valid zr textPostion value, but used
    // in bar series, and magic type should be considered.
    labelPosition === "outside" && (labelPosition = opt.defaultOutsidePosition || "top");
    if (labelPosition != null) textConfig.position = labelPosition;
    if (labelOffset != null) textConfig.offset = labelOffset;
    if (labelRotate != null) {
        labelRotate *= Math.PI / 180;
        textConfig.rotation = labelRotate;
    }
    if (labelDistance != null) textConfig.distance = labelDistance;
    // fill and auto is determined by the color of path fill if it's not specified by developers.
    textConfig.outsideFill = textStyleModel.get("color") === "inherit" ? opt.inheritColor || null : "auto";
    if (opt.autoOverflowArea != null) textConfig.autoOverflowArea = opt.autoOverflowArea;
    if (opt.layoutRect != null) textConfig.layoutRect = opt.layoutRect;
    return textConfig;
}
/**
 * The uniform entry of set text style, that is, retrieve style definitions
 * from `model` and set to `textStyle` object.
 *
 * Never in merge mode, but in overwrite mode, that is, all of the text style
 * properties will be set. (Consider the states of normal and emphasis and
 * default value can be adopted, merge would make the logic too complicated
 * to manage.)
 */ function $6800dfcb6e1e2a44$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached) {
    // Consider there will be abnormal when merge hover style to normal style if given default value.
    opt = opt || $6800dfcb6e1e2a44$var$EMPTY_OBJ;
    var ecModel = textStyleModel.ecModel;
    var globalTextStyle = ecModel && ecModel.option.textStyle;
    // Consider case:
    // {
    //     data: [{
    //         value: 12,
    //         label: {
    //             rich: {
    //                 // no 'a' here but using parent 'a'.
    //             }
    //         }
    //     }],
    //     rich: {
    //         a: { ... }
    //     }
    // }
    var richItemNames = $6800dfcb6e1e2a44$var$getRichItemNames(textStyleModel);
    var richResult;
    if (richItemNames) {
        richResult = {};
        var richInheritPlainLabelOptionName = "richInheritPlainLabel";
        var richInheritPlainLabel = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.get(richInheritPlainLabelOptionName), ecModel ? ecModel.get(richInheritPlainLabelOptionName) : undefined);
        for(var name_1 in richItemNames)if (richItemNames.hasOwnProperty(name_1)) {
            // Cascade is supported in rich.
            var richTextStyle = textStyleModel.getModel([
                "rich",
                name_1
            ]);
            // In rich, never `disableBox`.
            // consider `label: {formatter: '{a|xx}', color: 'blue', rich: {a: {}}}`,
            // the default color `'blue'` will not be adopted if no color declared in `rich`.
            // That might confuses users. So probably we should put `textStyleModel` as the
            // root ancestor of the `richTextStyle`. But that would be a break change.
            // Since v6, the rich style inherits plain label by default
            // but this behavior can be disabled by setting `richInheritPlainLabel` to `false`.
            $6800dfcb6e1e2a44$var$setTokenTextStyle(richResult[name_1] = {}, richTextStyle, globalTextStyle, textStyleModel, richInheritPlainLabel, opt, isNotNormal, isAttached, false, true);
        }
    }
    if (richResult) textStyle.rich = richResult;
    var overflow = textStyleModel.get("overflow");
    if (overflow) textStyle.overflow = overflow;
    var lineOverflow = textStyleModel.get("lineOverflow");
    if (lineOverflow) textStyle.lineOverflow = lineOverflow;
    var labelTextStyle = textStyle;
    // `minMargin` has a higher precedence than `textMargin`, because `textMargin` is allowed
    // to be set in `defaultOption`.
    var minMargin = textStyleModel.get("minMargin");
    if (minMargin != null) {
        // `minMargin` only support number value.
        minMargin = !(0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(minMargin) ? 0 : minMargin / 2;
        labelTextStyle.margin = [
            minMargin,
            minMargin,
            minMargin,
            minMargin
        ];
        labelTextStyle.__marginType = $6800dfcb6e1e2a44$export$2b18df2bc75ae422.minMargin;
    } else {
        var textMargin = textStyleModel.get("textMargin");
        if (textMargin != null) {
            labelTextStyle.margin = (0, $7a1bd9c2710fea0d$export$f3a38102c49f4268)(textMargin);
            labelTextStyle.__marginType = $6800dfcb6e1e2a44$export$2b18df2bc75ae422.textMargin;
        }
    }
    $6800dfcb6e1e2a44$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, null, null, opt, isNotNormal, isAttached, true, false);
}
// Consider case:
// {
//     data: [{
//         value: 12,
//         label: {
//             rich: {
//                 // no 'a' here but using parent 'a'.
//             }
//         }
//     }],
//     rich: {
//         a: { ... }
//     }
// }
// TODO TextStyleModel
function $6800dfcb6e1e2a44$var$getRichItemNames(textStyleModel) {
    // Use object to remove duplicated names.
    var richItemNameMap;
    while(textStyleModel && textStyleModel !== textStyleModel.ecModel){
        var rich = (textStyleModel.option || $6800dfcb6e1e2a44$var$EMPTY_OBJ).rich;
        if (rich) {
            richItemNameMap = richItemNameMap || {};
            var richKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(rich);
            for(var i = 0; i < richKeys.length; i++){
                var richKey = richKeys[i];
                richItemNameMap[richKey] = 1;
            }
        }
        textStyleModel = textStyleModel.parentModel;
    }
    return richItemNameMap;
}
var $6800dfcb6e1e2a44$var$TEXT_PROPS_WITH_GLOBAL = [
    "fontStyle",
    "fontWeight",
    "fontSize",
    "fontFamily",
    "textShadowColor",
    "textShadowBlur",
    "textShadowOffsetX",
    "textShadowOffsetY"
];
var $6800dfcb6e1e2a44$var$TEXT_PROPS_SELF = [
    "align",
    "lineHeight",
    "width",
    "height",
    "tag",
    "verticalAlign",
    "ellipsis"
];
var $6800dfcb6e1e2a44$var$TEXT_PROPS_BOX = [
    "padding",
    "borderWidth",
    "borderRadius",
    "borderDashOffset",
    "backgroundColor",
    "borderColor",
    "shadowColor",
    "shadowBlur",
    "shadowOffsetX",
    "shadowOffsetY"
];
function $6800dfcb6e1e2a44$var$setTokenTextStyle(textStyle, // FIXME: check/refactor for ellipsis handling of rich text.
textStyleModel, globalTextStyle, plainTextModel, richInheritPlainLabel, opt, isNotNormal, isAttached, isBlock, inRich) {
    // In merge mode, default value should not be given.
    globalTextStyle = !isNotNormal && globalTextStyle || $6800dfcb6e1e2a44$var$EMPTY_OBJ;
    var inheritColor = opt && opt.inheritColor;
    var fillColor = textStyleModel.getShallow("color");
    var strokeColor = textStyleModel.getShallow("textBorderColor");
    var opacity = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.getShallow("opacity"), globalTextStyle.opacity);
    if (fillColor === "inherit" || fillColor === "auto") {
        if (inheritColor) fillColor = inheritColor;
        else fillColor = null;
    }
    if (strokeColor === "inherit" || strokeColor === "auto") {
        if (inheritColor) strokeColor = inheritColor;
        else strokeColor = null;
    }
    if (!isAttached) {
        // Only use default global textStyle.color if text is individual.
        // Otherwise it will use the strategy of attached text color because text may be on a path.
        fillColor = fillColor || globalTextStyle.color;
        strokeColor = strokeColor || globalTextStyle.textBorderColor;
    }
    if (fillColor != null) // Might not be a string, e.g, it's a function in axisLabel case; but assume that it will
    // be erased by a correct value outside.
    textStyle.fill = fillColor;
    if (strokeColor != null) textStyle.stroke = strokeColor;
    var textBorderWidth = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.getShallow("textBorderWidth"), globalTextStyle.textBorderWidth);
    if (textBorderWidth != null) textStyle.lineWidth = textBorderWidth;
    var textBorderType = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.getShallow("textBorderType"), globalTextStyle.textBorderType);
    if (textBorderType != null) textStyle.lineDash = textBorderType;
    var textBorderDashOffset = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.getShallow("textBorderDashOffset"), globalTextStyle.textBorderDashOffset);
    if (textBorderDashOffset != null) textStyle.lineDashOffset = textBorderDashOffset;
    if (!isNotNormal && opacity == null && !inRich) opacity = opt && opt.defaultOpacity;
    if (opacity != null) textStyle.opacity = opacity;
    // TODO
    if (!isNotNormal && !isAttached) // Set default finally.
    {
        if (textStyle.fill == null && opt.inheritColor) textStyle.fill = opt.inheritColor;
    }
    // Do not use `getFont` here, because merge should be supported, where
    // part of these properties may be changed in emphasis style, and the
    // others should remain their original value got from normal style.
    for(var i = 0; i < $6800dfcb6e1e2a44$var$TEXT_PROPS_WITH_GLOBAL.length; i++){
        var key = $6800dfcb6e1e2a44$var$TEXT_PROPS_WITH_GLOBAL[i];
        // props width, height, padding, margin, tag, backgroundColor, borderColor,
        // borderWidth, borderRadius, shadowColor, shadowBlur, shadowOffsetX, shadowOffsetY
        // may inappropriate to inherit from plainTextStyle.
        // And if some props is specified in default options, users may have to reset them one by one.
        // Therefore, we only allow these props to inherit from plainTextStyle.
        // `richInheritPlainLabel` is switch for backward compatibility
        var val = richInheritPlainLabel !== false && plainTextModel ? (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(textStyleModel.getShallow(key), plainTextModel.getShallow(key), globalTextStyle[key]) : (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.getShallow(key), globalTextStyle[key]);
        if (val != null) textStyle[key] = val;
    }
    for(var i = 0; i < $6800dfcb6e1e2a44$var$TEXT_PROPS_SELF.length; i++){
        var key = $6800dfcb6e1e2a44$var$TEXT_PROPS_SELF[i];
        var val = textStyleModel.getShallow(key);
        if (val != null) textStyle[key] = val;
    }
    if (textStyle.verticalAlign == null) {
        var baseline = textStyleModel.getShallow("baseline");
        if (baseline != null) textStyle.verticalAlign = baseline;
    }
    if (!isBlock || !opt.disableBox) {
        for(var i = 0; i < $6800dfcb6e1e2a44$var$TEXT_PROPS_BOX.length; i++){
            var key = $6800dfcb6e1e2a44$var$TEXT_PROPS_BOX[i];
            var val = textStyleModel.getShallow(key);
            if (val != null) textStyle[key] = val;
        }
        var borderType = textStyleModel.getShallow("borderType");
        if (borderType != null) textStyle.borderDash = borderType;
        if ((textStyle.backgroundColor === "auto" || textStyle.backgroundColor === "inherit") && inheritColor) textStyle.backgroundColor = inheritColor;
        if ((textStyle.borderColor === "auto" || textStyle.borderColor === "inherit") && inheritColor) textStyle.borderColor = inheritColor;
    }
}
function $6800dfcb6e1e2a44$export$155316a870a9d61e(opt, ecModel) {
    var gTextStyleModel = ecModel && ecModel.getModel("textStyle");
    return (0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)([
        // FIXME in node-canvas fontWeight is before fontStyle
        opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow("fontStyle") || "",
        opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow("fontWeight") || "",
        (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow("fontSize") || 12) + "px",
        opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow("fontFamily") || "sans-serif"
    ].join(" "));
}
var $6800dfcb6e1e2a44$export$f62786d3261ab0f4 = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $6800dfcb6e1e2a44$export$7bdbceaf9ab378f2(label, labelStatesModels, value, getDefaultText) {
    if (!label) return;
    var obj = $6800dfcb6e1e2a44$export$f62786d3261ab0f4(label);
    obj.prevValue = obj.value;
    obj.value = value;
    var normalLabelModel = labelStatesModels.normal;
    obj.valueAnimation = normalLabelModel.get("valueAnimation");
    if (obj.valueAnimation) {
        obj.precision = normalLabelModel.get("precision");
        obj.defaultInterpolatedText = getDefaultText;
        obj.statesModels = labelStatesModels;
    }
}
function $6800dfcb6e1e2a44$export$dd6101605f5c186(textEl, dataIndex, data, animatableModel, labelFetcher) {
    var labelInnerStore = $6800dfcb6e1e2a44$export$f62786d3261ab0f4(textEl);
    if (!labelInnerStore.valueAnimation || labelInnerStore.prevValue === labelInnerStore.value) // Value not changed, no new label animation
    return;
    var defaultInterpolatedText = labelInnerStore.defaultInterpolatedText;
    // Consider the case that being animating, do not use the `obj.value`,
    // Otherwise it will jump to the `obj.value` when this new animation started.
    var currValue = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(labelInnerStore.interpolatedValue, labelInnerStore.prevValue);
    var targetValue = labelInnerStore.value;
    function during(percent) {
        var interpolated = (0, $76d619f648247e6d$export$bd0439821a1869f3)(data, labelInnerStore.precision, currValue, targetValue, percent);
        labelInnerStore.interpolatedValue = percent === 1 ? null : interpolated;
        var labelText = $6800dfcb6e1e2a44$var$getLabelText({
            labelDataIndex: dataIndex,
            labelFetcher: labelFetcher,
            defaultText: defaultInterpolatedText ? defaultInterpolatedText(interpolated) : interpolated + ""
        }, labelInnerStore.statesModels, interpolated);
        $6800dfcb6e1e2a44$export$b533918394a58529(textEl, labelText);
    }
    textEl.percent = 0;
    (labelInnerStore.prevValue == null ? (0, $8b353638fbedfefa$export$a121566aadcfe021) : (0, $8b353638fbedfefa$export$c8dce3c08436e91e))(textEl, {
        // percent is used to prevent animation from being aborted #15916
        percent: 1
    }, animatableModel, dataIndex, null, during);
}
var $6800dfcb6e1e2a44$export$2b18df2bc75ae422 = {
    minMargin: 1,
    textMargin: 2
};



var $a8b74de3c15b55c3$var$PATH_COLOR = [
    "textStyle",
    "color"
];
var $a8b74de3c15b55c3$var$textStyleParams = [
    "fontStyle",
    "fontWeight",
    "fontSize",
    "fontFamily",
    "padding",
    "lineHeight",
    "rich",
    "width",
    "height",
    "overflow"
];
// TODO Performance improvement?
var $a8b74de3c15b55c3$var$tmpText = new (0, $fe885cc21795562b$export$2e2bcd8739ae039)();
var $a8b74de3c15b55c3$var$TextStyleMixin = /** @class */ function() {
    function TextStyleMixin() {}
    /**
   * Get color property or get color from option.textStyle.color
   */ // TODO Callback
    TextStyleMixin.prototype.getTextColor = function(isEmphasis) {
        var ecModel = this.ecModel;
        return this.getShallow("color") || (!isEmphasis && ecModel ? ecModel.get($a8b74de3c15b55c3$var$PATH_COLOR) : null);
    };
    /**
   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
   * @return {string}
   */ TextStyleMixin.prototype.getFont = function() {
        return (0, $6800dfcb6e1e2a44$export$155316a870a9d61e)({
            fontStyle: this.getShallow("fontStyle"),
            fontWeight: this.getShallow("fontWeight"),
            fontSize: this.getShallow("fontSize"),
            fontFamily: this.getShallow("fontFamily")
        }, this.ecModel);
    };
    TextStyleMixin.prototype.getTextRect = function(text) {
        var style = {
            text: text,
            verticalAlign: this.getShallow("verticalAlign") || this.getShallow("baseline")
        };
        for(var i = 0; i < $a8b74de3c15b55c3$var$textStyleParams.length; i++)style[$a8b74de3c15b55c3$var$textStyleParams[i]] = this.getShallow($a8b74de3c15b55c3$var$textStyleParams[i]);
        $a8b74de3c15b55c3$var$tmpText.useStyle(style);
        $a8b74de3c15b55c3$var$tmpText.update();
        return $a8b74de3c15b55c3$var$tmpText.getBoundingRect();
    };
    return TextStyleMixin;
}();
var $a8b74de3c15b55c3$export$2e2bcd8739ae039 = $a8b74de3c15b55c3$var$TextStyleMixin;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9c5206e1bd69e88f$export$9f34de5b59222949 = [
    [
        "lineWidth",
        "width"
    ],
    [
        "stroke",
        "color"
    ],
    [
        "opacity"
    ],
    [
        "shadowBlur"
    ],
    [
        "shadowOffsetX"
    ],
    [
        "shadowOffsetY"
    ],
    [
        "shadowColor"
    ],
    [
        "lineDash",
        "type"
    ],
    [
        "lineDashOffset",
        "dashOffset"
    ],
    [
        "lineCap",
        "cap"
    ],
    [
        "lineJoin",
        "join"
    ],
    [
        "miterLimit"
    ]
];
var $9c5206e1bd69e88f$var$getLineStyle = (0, $06542048a26d4d91$export$2e2bcd8739ae039)($9c5206e1bd69e88f$export$9f34de5b59222949);
var $9c5206e1bd69e88f$export$91eeeeed4a69a7e7 = /** @class */ function() {
    function LineStyleMixin() {}
    LineStyleMixin.prototype.getLineStyle = function(excludes) {
        return $9c5206e1bd69e88f$var$getLineStyle(this, excludes);
    };
    return LineStyleMixin;
}();


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $c42afdfd2f0ddc96$export$ffb0bba5dde0130b = [
    [
        "fill",
        "color"
    ],
    [
        "stroke",
        "borderColor"
    ],
    [
        "lineWidth",
        "borderWidth"
    ],
    [
        "opacity"
    ],
    [
        "shadowBlur"
    ],
    [
        "shadowOffsetX"
    ],
    [
        "shadowOffsetY"
    ],
    [
        "shadowColor"
    ],
    [
        "lineDash",
        "borderType"
    ],
    [
        "lineDashOffset",
        "borderDashOffset"
    ],
    [
        "lineCap",
        "borderCap"
    ],
    [
        "lineJoin",
        "borderJoin"
    ],
    [
        "miterLimit",
        "borderMiterLimit"
    ]
];
var $c42afdfd2f0ddc96$var$getItemStyle = (0, $06542048a26d4d91$export$2e2bcd8739ae039)($c42afdfd2f0ddc96$export$ffb0bba5dde0130b);
var $c42afdfd2f0ddc96$export$e4f01e48d6fda412 = /** @class */ function() {
    function ItemStyleMixin() {}
    ItemStyleMixin.prototype.getItemStyle = function(excludes, includes) {
        return $c42afdfd2f0ddc96$var$getItemStyle(this, excludes, includes);
    };
    return ItemStyleMixin;
}();



var $6818646a97528290$var$Model = /** @class */ function() {
    function Model(option, parentModel, ecModel) {
        this.parentModel = parentModel;
        this.ecModel = ecModel;
        this.option = option;
    // Simple optimization
    // if (this.init) {
    //     if (arguments.length <= 4) {
    //         this.init(option, parentModel, ecModel, extraOpt);
    //     }
    //     else {
    //         this.init.apply(this, arguments);
    //     }
    // }
    }
    Model.prototype.init = function(option, parentModel, ecModel) {
        var rest = [];
        for(var _i = 3; _i < arguments.length; _i++)rest[_i - 3] = arguments[_i];
    };
    /**
   * Merge the input option to me.
   */ Model.prototype.mergeOption = function(option, ecModel) {
        (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(this.option, option, true);
    };
    // `path` can be 'a.b.c', so the return value type have to be `ModelOption`
    // TODO: TYPE strict key check?
    // get(path: string | string[], ignoreParent?: boolean): ModelOption;
    Model.prototype.get = function(path, ignoreParent) {
        if (path == null) return this.option;
        return this._doGet(this.parsePath(path), !ignoreParent && this.parentModel);
    };
    Model.prototype.getShallow = function(key, ignoreParent) {
        var option = this.option;
        var val = option == null ? option : option[key];
        if (val == null && !ignoreParent) {
            var parentModel = this.parentModel;
            if (parentModel) // FIXME:TS do not know how to make it works
            val = parentModel.getShallow(key);
        }
        return val;
    };
    // `path` can be 'a.b.c', so the return value type have to be `Model<ModelOption>`
    // getModel(path: string | string[], parentModel?: Model): Model;
    // TODO 'a.b.c' is deprecated
    Model.prototype.getModel = function(path, parentModel) {
        var hasPath = path != null;
        var pathFinal = hasPath ? this.parsePath(path) : null;
        var obj = hasPath ? this._doGet(pathFinal) : this.option;
        parentModel = parentModel || this.parentModel && this.parentModel.getModel(this.resolveParentPath(pathFinal));
        return new Model(obj, parentModel, this.ecModel);
    };
    /**
   * If model has option
   */ Model.prototype.isEmpty = function() {
        return this.option == null;
    };
    Model.prototype.restoreData = function() {};
    // Pending
    Model.prototype.clone = function() {
        var Ctor = this.constructor;
        return new Ctor((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(this.option));
    };
    // setReadOnly(properties): void {
    // clazzUtil.setReadOnly(this, properties);
    // }
    // If path is null/undefined, return null/undefined.
    Model.prototype.parsePath = function(path) {
        if (typeof path === "string") return path.split(".");
        return path;
    };
    // Resolve path for parent. Perhaps useful when parent use a different property.
    // Default to be a identity resolver.
    // Can be modified to a different resolver.
    Model.prototype.resolveParentPath = function(path) {
        return path;
    };
    // FIXME:TS check whether put this method here
    Model.prototype.isAnimationEnabled = function() {
        if (!(0, $ce6dd58693a21851$export$2e2bcd8739ae039).node && this.option) {
            if (this.option.animation != null) return !!this.option.animation;
            else if (this.parentModel) return this.parentModel.isAnimationEnabled();
        }
    };
    Model.prototype._doGet = function(pathArr, parentModel) {
        var obj = this.option;
        if (!pathArr) return obj;
        for(var i = 0; i < pathArr.length; i++){
            // Ignore empty
            if (!pathArr[i]) continue;
            // obj could be number/string/... (like 0)
            obj = obj && typeof obj === "object" ? obj[pathArr[i]] : null;
            if (obj == null) break;
        }
        if (obj == null && parentModel) obj = parentModel._doGet(this.resolveParentPath(pathArr), parentModel.parentModel);
        return obj;
    };
    return Model;
}();
// Enable Model.extend.
(0, $cd5f95cf03b4e3e7$export$cd4c3a4dca301c70)($6818646a97528290$var$Model);
(0, $cd5f95cf03b4e3e7$export$e1aac4552ae82081)($6818646a97528290$var$Model);
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($6818646a97528290$var$Model, (0, $9c5206e1bd69e88f$export$91eeeeed4a69a7e7));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($6818646a97528290$var$Model, (0, $c42afdfd2f0ddc96$export$e4f01e48d6fda412));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($6818646a97528290$var$Model, (0, $cb2a96727da5284d$export$a3a0ed7e2dd84c9e));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($6818646a97528290$var$Model, (0, $a8b74de3c15b55c3$export$2e2bcd8739ae039));
var $6818646a97528290$export$2e2bcd8739ae039 = $6818646a97528290$var$Model;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


// A random offset
var $5370df662b2caf37$var$base = Math.round(Math.random() * 10);
function $5370df662b2caf37$export$6d2b3473b0986646(type) {
    // Considering the case of crossing js context,
    // use Math.random to make id as unique as possible.
    return [
        type || "",
        $5370df662b2caf37$var$base++
    ].join("_");
}
function $5370df662b2caf37$export$b9faf30b7d655a6f(target) {
    var subTypeDefaulters = {};
    target.registerSubTypeDefaulter = function(componentType, defaulter) {
        var componentTypeInfo = (0, $cd5f95cf03b4e3e7$export$fbe18865d303bf01)(componentType);
        subTypeDefaulters[componentTypeInfo.main] = defaulter;
    };
    target.determineSubType = function(componentType, option) {
        var type = option.type;
        if (!type) {
            var componentTypeMain = (0, $cd5f95cf03b4e3e7$export$fbe18865d303bf01)(componentType).main;
            if (target.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) type = subTypeDefaulters[componentTypeMain](option);
        }
        return type;
    };
}
function $5370df662b2caf37$export$ce592d345a3ec040(entity, dependencyGetter) {
    /**
   * @param targetNameList Target Component type list.
   *                       Can be ['aa', 'bb', 'aa.xx']
   * @param fullNameList By which we can build dependency graph.
   * @param callback Params: componentType, dependencies.
   * @param context Scope of callback.
   */ entity.topologicalTravel = function(targetNameList, fullNameList, callback, context) {
        if (!targetNameList.length) return;
        var result = makeDepndencyGraph(fullNameList);
        var graph = result.graph;
        var noEntryList = result.noEntryList;
        var targetNameSet = {};
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(targetNameList, function(name) {
            targetNameSet[name] = true;
        });
        while(noEntryList.length){
            var currComponentType = noEntryList.pop();
            var currVertex = graph[currComponentType];
            var isInTargetNameSet = !!targetNameSet[currComponentType];
            if (isInTargetNameSet) {
                callback.call(context, currComponentType, currVertex.originalDeps.slice());
                delete targetNameSet[currComponentType];
            }
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
        }
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(targetNameSet, function() {
            var errMsg = "";
            throw new Error(errMsg);
        });
        function removeEdge(succComponentType) {
            graph[succComponentType].entryCount--;
            if (graph[succComponentType].entryCount === 0) noEntryList.push(succComponentType);
        }
        // Consider this case: legend depends on series, and we call
        // chart.setOption({series: [...]}), where only series is in option.
        // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
        // not be called, but only sereis.mergeOption is called. Thus legend
        // have no chance to update its local record about series (like which
        // name of series is available in legend).
        function removeEdgeAndAdd(succComponentType) {
            targetNameSet[succComponentType] = true;
            removeEdge(succComponentType);
        }
    };
    function makeDepndencyGraph(fullNameList) {
        var graph = {};
        var noEntryList = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(fullNameList, function(name) {
            var thisItem = createDependencyGraphItem(graph, name);
            var originalDeps = thisItem.originalDeps = dependencyGetter(name);
            var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
            thisItem.entryCount = availableDeps.length;
            if (thisItem.entryCount === 0) noEntryList.push(name);
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(availableDeps, function(dependentName) {
                if ($7a1bd9c2710fea0d$export$305f7d4e9d4624f2(thisItem.predecessor, dependentName) < 0) thisItem.predecessor.push(dependentName);
                var thatItem = createDependencyGraphItem(graph, dependentName);
                if ($7a1bd9c2710fea0d$export$305f7d4e9d4624f2(thatItem.successor, dependentName) < 0) thatItem.successor.push(name);
            });
        });
        return {
            graph: graph,
            noEntryList: noEntryList
        };
    }
    function createDependencyGraphItem(graph, name) {
        if (!graph[name]) graph[name] = {
            predecessor: [],
            successor: []
        };
        return graph[name];
    }
    function getAvailableDependencies(originalDeps, fullNameList) {
        var availableDeps = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(originalDeps, function(dep) {
            $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(fullNameList, dep) >= 0 && availableDeps.push(dep);
        });
        return availableDeps;
    }
}
function $5370df662b2caf37$export$68acc510e46fef2(superOption, subOption) {
    // See also `model/Component.ts#getDefaultOption`
    return $7a1bd9c2710fea0d$export$4950aa0f605343fb($7a1bd9c2710fea0d$export$4950aa0f605343fb({}, superOption, true), subOption, true);
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Layout helpers for each component positioning



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */ /**
 * Language: English.
 */ var $af0c4f5df0270dd8$export$2e2bcd8739ae039 = {
    time: {
        month: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        monthAbbr: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        dayOfWeek: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        dayOfWeekAbbr: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ]
    },
    legend: {
        selector: {
            all: "All",
            inverse: "Inv"
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: "Box Select",
                polygon: "Lasso Select",
                lineX: "Horizontally Select",
                lineY: "Vertically Select",
                keep: "Keep Selections",
                clear: "Clear Selections"
            }
        },
        dataView: {
            title: "Data View",
            lang: [
                "Data View",
                "Close",
                "Refresh"
            ]
        },
        dataZoom: {
            title: {
                zoom: "Zoom",
                back: "Zoom Reset"
            }
        },
        magicType: {
            title: {
                line: "Switch to Line Chart",
                bar: "Switch to Bar Chart",
                stack: "Stack",
                tiled: "Tile"
            }
        },
        restore: {
            title: "Restore"
        },
        saveAsImage: {
            title: "Save as Image",
            lang: [
                "Right Click to Save Image"
            ]
        }
    },
    series: {
        typeNames: {
            pie: "Pie chart",
            bar: "Bar chart",
            line: "Line chart",
            scatter: "Scatter plot",
            effectScatter: "Ripple scatter plot",
            radar: "Radar chart",
            tree: "Tree",
            treemap: "Treemap",
            boxplot: "Boxplot",
            candlestick: "Candlestick",
            k: "K line chart",
            heatmap: "Heat map",
            map: "Map",
            parallel: "Parallel coordinate map",
            lines: "Line graph",
            graph: "Relationship graph",
            sankey: "Sankey diagram",
            funnel: "Funnel chart",
            gauge: "Gauge",
            pictorialBar: "Pictorial bar",
            themeRiver: "Theme River Map",
            sunburst: "Sunburst",
            custom: "Custom chart",
            chart: "Chart"
        }
    },
    aria: {
        general: {
            withTitle: 'This is a chart about "{title}"',
            withoutTitle: "This is a chart"
        },
        series: {
            single: {
                prefix: "",
                withName: " with type {seriesType} named {seriesName}.",
                withoutName: " with type {seriesType}."
            },
            multiple: {
                prefix: ". It consists of {seriesCount} series count.",
                withName: " The {seriesId} series is a {seriesType} representing {seriesName}.",
                withoutName: " The {seriesId} series is a {seriesType}.",
                separator: {
                    middle: "",
                    end: ""
                }
            }
        },
        data: {
            allData: "The data is as follows: ",
            partialData: "The first {displayCnt} items are: ",
            withName: "the data for {name} is {value}",
            withoutName: "{value}",
            separator: {
                middle: ", ",
                end: ". "
            }
        }
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */ var $b3a62bfb11b19829$export$2e2bcd8739ae039 = {
    time: {
        month: [
            "\u4E00\u6708",
            "\u4E8C\u6708",
            "\u4E09\u6708",
            "\u56DB\u6708",
            "\u4E94\u6708",
            "\u516D\u6708",
            "\u4E03\u6708",
            "\u516B\u6708",
            "\u4E5D\u6708",
            "\u5341\u6708",
            "\u5341\u4E00\u6708",
            "\u5341\u4E8C\u6708"
        ],
        monthAbbr: [
            "1\u6708",
            "2\u6708",
            "3\u6708",
            "4\u6708",
            "5\u6708",
            "6\u6708",
            "7\u6708",
            "8\u6708",
            "9\u6708",
            "10\u6708",
            "11\u6708",
            "12\u6708"
        ],
        dayOfWeek: [
            "\u661F\u671F\u65E5",
            "\u661F\u671F\u4E00",
            "\u661F\u671F\u4E8C",
            "\u661F\u671F\u4E09",
            "\u661F\u671F\u56DB",
            "\u661F\u671F\u4E94",
            "\u661F\u671F\u516D"
        ],
        dayOfWeekAbbr: [
            "\u65E5",
            "\u4E00",
            "\u4E8C",
            "\u4E09",
            "\u56DB",
            "\u4E94",
            "\u516D"
        ]
    },
    legend: {
        selector: {
            all: "\u5168\u9009",
            inverse: "\u53CD\u9009"
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: "\u77E9\u5F62\u9009\u62E9",
                polygon: "\u5708\u9009",
                lineX: "\u6A2A\u5411\u9009\u62E9",
                lineY: "\u7EB5\u5411\u9009\u62E9",
                keep: "\u4FDD\u6301\u9009\u62E9",
                clear: "\u6E05\u9664\u9009\u62E9"
            }
        },
        dataView: {
            title: "\u6570\u636E\u89C6\u56FE",
            lang: [
                "\u6570\u636E\u89C6\u56FE",
                "\u5173\u95ED",
                "\u5237\u65B0"
            ]
        },
        dataZoom: {
            title: {
                zoom: "\u533A\u57DF\u7F29\u653E",
                back: "\u533A\u57DF\u7F29\u653E\u8FD8\u539F"
            }
        },
        magicType: {
            title: {
                line: "\u5207\u6362\u4E3A\u6298\u7EBF\u56FE",
                bar: "\u5207\u6362\u4E3A\u67F1\u72B6\u56FE",
                stack: "\u5207\u6362\u4E3A\u5806\u53E0",
                tiled: "\u5207\u6362\u4E3A\u5E73\u94FA"
            }
        },
        restore: {
            title: "\u8FD8\u539F"
        },
        saveAsImage: {
            title: "\u4FDD\u5B58\u4E3A\u56FE\u7247",
            lang: [
                "\u53F3\u952E\u53E6\u5B58\u4E3A\u56FE\u7247"
            ]
        }
    },
    series: {
        typeNames: {
            pie: "\u997C\u56FE",
            bar: "\u67F1\u72B6\u56FE",
            line: "\u6298\u7EBF\u56FE",
            scatter: "\u6563\u70B9\u56FE",
            effectScatter: "\u6D9F\u6F2A\u6563\u70B9\u56FE",
            radar: "\u96F7\u8FBE\u56FE",
            tree: "\u6811\u56FE",
            treemap: "\u77E9\u5F62\u6811\u56FE",
            boxplot: "\u7BB1\u578B\u56FE",
            candlestick: "K\u7EBF\u56FE",
            k: "K\u7EBF\u56FE",
            heatmap: "\u70ED\u529B\u56FE",
            map: "\u5730\u56FE",
            parallel: "\u5E73\u884C\u5750\u6807\u56FE",
            lines: "\u7EBF\u56FE",
            graph: "\u5173\u7CFB\u56FE",
            sankey: "\u6851\u57FA\u56FE",
            funnel: "\u6F0F\u6597\u56FE",
            gauge: "\u4EEA\u8868\u76D8\u56FE",
            pictorialBar: "\u8C61\u5F62\u67F1\u56FE",
            themeRiver: "\u4E3B\u9898\u6CB3\u6D41\u56FE",
            sunburst: "\u65ED\u65E5\u56FE",
            custom: "\u81EA\u5B9A\u4E49\u56FE\u8868",
            chart: "\u56FE\u8868"
        }
    },
    aria: {
        general: {
            withTitle: "\u8FD9\u662F\u4E00\u4E2A\u5173\u4E8E\u201C{title}\u201D\u7684\u56FE\u8868\u3002",
            withoutTitle: "\u8FD9\u662F\u4E00\u4E2A\u56FE\u8868\uFF0C"
        },
        series: {
            single: {
                prefix: "",
                withName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\uFF0C\u8868\u793A{seriesName}\u3002",
                withoutName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\u3002"
            },
            multiple: {
                prefix: "\u5B83\u7531{seriesCount}\u4E2A\u56FE\u8868\u7CFB\u5217\u7EC4\u6210\u3002",
                withName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A\u8868\u793A{seriesName}\u7684{seriesType}\uFF0C",
                withoutName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A{seriesType}\uFF0C",
                separator: {
                    middle: "\uFF1B",
                    end: "\u3002"
                }
            }
        },
        data: {
            allData: "\u5176\u6570\u636E\u662F\u2014\u2014",
            partialData: "\u5176\u4E2D\uFF0C\u524D{displayCnt}\u9879\u662F\u2014\u2014",
            withName: "{name}\u7684\u6570\u636E\u662F{value}",
            withoutName: "{value}",
            separator: {
                middle: "\uFF0C",
                end: ""
            }
        }
    }
};



var $9b0a1ef4bcc91e7d$var$LOCALE_ZH = "ZH";
var $9b0a1ef4bcc91e7d$var$LOCALE_EN = "EN";
var $9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE = $9b0a1ef4bcc91e7d$var$LOCALE_EN;
var $9b0a1ef4bcc91e7d$var$localeStorage = {};
var $9b0a1ef4bcc91e7d$var$localeModels = {};
var $9b0a1ef4bcc91e7d$export$9a2147b3808d4c6b = !(0, $ce6dd58693a21851$export$2e2bcd8739ae039).domSupported ? $9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE : function() {
    var langStr = /* eslint-disable-next-line */ (document.documentElement.lang || navigator.language || navigator.browserLanguage || $9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE).toUpperCase();
    return langStr.indexOf($9b0a1ef4bcc91e7d$var$LOCALE_ZH) > -1 ? $9b0a1ef4bcc91e7d$var$LOCALE_ZH : $9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE;
}();
function $9b0a1ef4bcc91e7d$export$bab6a7822cc1e2cd(locale, localeObj) {
    locale = locale.toUpperCase();
    $9b0a1ef4bcc91e7d$var$localeModels[locale] = new (0, $6818646a97528290$export$2e2bcd8739ae039)(localeObj);
    $9b0a1ef4bcc91e7d$var$localeStorage[locale] = localeObj;
}
function $9b0a1ef4bcc91e7d$export$ddc371781a6af754(locale) {
    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(locale)) {
        var localeObj = $9b0a1ef4bcc91e7d$var$localeStorage[locale.toUpperCase()] || {};
        if (locale === $9b0a1ef4bcc91e7d$var$LOCALE_ZH || locale === $9b0a1ef4bcc91e7d$var$LOCALE_EN) return (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(localeObj);
        else return (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(localeObj), (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)($9b0a1ef4bcc91e7d$var$localeStorage[$9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE]), false);
    } else return (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(locale), (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)($9b0a1ef4bcc91e7d$var$localeStorage[$9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE]), false);
}
function $9b0a1ef4bcc91e7d$export$37cc638e0e11865f(lang) {
    return $9b0a1ef4bcc91e7d$var$localeModels[lang];
}
function $9b0a1ef4bcc91e7d$export$1188f179b2597821() {
    return $9b0a1ef4bcc91e7d$var$localeModels[$9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE];
}
// Default locale
$9b0a1ef4bcc91e7d$export$bab6a7822cc1e2cd($9b0a1ef4bcc91e7d$var$LOCALE_EN, (0, $af0c4f5df0270dd8$export$2e2bcd8739ae039));
$9b0a1ef4bcc91e7d$export$bab6a7822cc1e2cd($9b0a1ef4bcc91e7d$var$LOCALE_ZH, (0, $b3a62bfb11b19829$export$2e2bcd8739ae039));



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ var $639a5974fe354f7a$var$_impl = null;
function $639a5974fe354f7a$export$11977f1e90ef55cf(impl) {
    if (!$639a5974fe354f7a$var$_impl) $639a5974fe354f7a$var$_impl = impl;
}
function $639a5974fe354f7a$export$e79b20ac82c2d660() {
    return $639a5974fe354f7a$var$_impl;
}


var $0ae0381fb3fd176f$export$32c0454ceff7f92d = 1000;
var $0ae0381fb3fd176f$export$35acaebf644db34e = $0ae0381fb3fd176f$export$32c0454ceff7f92d * 60;
var $0ae0381fb3fd176f$export$82541edf19e5e3b0 = $0ae0381fb3fd176f$export$35acaebf644db34e * 60;
var $0ae0381fb3fd176f$export$a97a1358cbb650ab = $0ae0381fb3fd176f$export$82541edf19e5e3b0 * 24;
var $0ae0381fb3fd176f$export$99cafda57477293d = $0ae0381fb3fd176f$export$a97a1358cbb650ab * 365;
var $0ae0381fb3fd176f$var$primaryTimeUnitFormatterMatchers = {
    year: /({yyyy}|{yy})/,
    month: /({MMMM}|{MMM}|{MM}|{M})/,
    day: /({dd}|{d})/,
    hour: /({HH}|{H}|{hh}|{h})/,
    minute: /({mm}|{m})/,
    second: /({ss}|{s})/,
    millisecond: /({SSS}|{S})/
};
var $0ae0381fb3fd176f$var$defaultFormatterSeed = {
    year: "{yyyy}",
    month: "{MMM}",
    day: "{d}",
    hour: "{HH}:{mm}",
    minute: "{HH}:{mm}",
    second: "{HH}:{mm}:{ss}",
    millisecond: "{HH}:{mm}:{ss} {SSS}"
};
var $0ae0381fb3fd176f$var$defaultFullFormatter = "{yyyy}-{MM}-{dd} {HH}:{mm}:{ss} {SSS}";
var $0ae0381fb3fd176f$var$fullDayFormatter = "{yyyy}-{MM}-{dd}";
var $0ae0381fb3fd176f$export$445bdbd8d2334e40 = {
    year: "{yyyy}",
    month: "{yyyy}-{MM}",
    day: $0ae0381fb3fd176f$var$fullDayFormatter,
    hour: $0ae0381fb3fd176f$var$fullDayFormatter + " " + $0ae0381fb3fd176f$var$defaultFormatterSeed.hour,
    minute: $0ae0381fb3fd176f$var$fullDayFormatter + " " + $0ae0381fb3fd176f$var$defaultFormatterSeed.minute,
    second: $0ae0381fb3fd176f$var$fullDayFormatter + " " + $0ae0381fb3fd176f$var$defaultFormatterSeed.second,
    millisecond: $0ae0381fb3fd176f$var$defaultFullFormatter
};
var $0ae0381fb3fd176f$export$87100da04d711986 = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
];
var $0ae0381fb3fd176f$export$833c398a55654bb7 = [
    "year",
    "half-year",
    "quarter",
    "month",
    "week",
    "half-week",
    "day",
    "half-day",
    "quarter-day",
    "hour",
    "minute",
    "second",
    "millisecond"
];
function $0ae0381fb3fd176f$export$f16a827770bdffb5(formatter) {
    // Keep the logic the same with function `leveledFormat`.
    return !$7a1bd9c2710fea0d$export$844ec244b1367d54(formatter) && !$7a1bd9c2710fea0d$export$f6e2535fb5126e54(formatter) ? $0ae0381fb3fd176f$var$parseTimeAxisLabelFormatterDictionary(formatter) : formatter;
}
/**
 * The final generated dictionary is like:
 *  generated_dict = {
 *      year: {
 *          year: ['{yyyy}', ...<higher_levels_if_any>]
 *      },
 *      month: {
 *          year: ['{yyyy} {MMM}', ...<higher_levels_if_any>],
 *          month: ['{MMM}', ...<higher_levels_if_any>]
 *      },
 *      day: {
 *          year: ['{yyyy} {MMM} {d}', ...<higher_levels_if_any>],
 *          month: ['{MMM} {d}', ...<higher_levels_if_any>],
 *          day: ['{d}', ...<higher_levels_if_any>]
 *      },
 *      ...
 *  }
 *
 * In echarts option, users can specify the entire dictionary or typically just:
 *  {formatter: {
 *      year: '{yyyy}', // Or an array of leveled templates: `['{yyyy}', '{bold1|{yyyy}}', ...]`,
 *                      // corresponding to `[level0, level1, level2, ...]`.
 *      month: '{MMM}',
 *      day: '{d}',
 *      hour: '{HH}:{mm}',
 *      second: '{HH}:{mm}',
 *      ...
 *  }}
 *  If any time unit is not specified in echarts option, the default template is used,
 *  such as `['{yyyy}', {primary|{yyyy}']`.
 *
 * The `tick.level` is only used to read string from each array, meaning the style type.
 *
 * Let `lowerUnit = getUnitFromValue(tick.value)`.
 * The non-break axis ticks only use `generated_dict[lowerUnit][lowerUnit][level]`.
 * The break axis ticks may use `generated_dict[lowerUnit][upperUnit][level]`, because:
 *  Consider the case: the non-break ticks are `16th, 23th, Feb, 7th, ...`, where `Feb` is in the break
 *  range and pruned by breaks, and the break ends might be in lower time unit than day. e.g., break start
 *  is `Jan 25th 18:00`(in unit `hour`) and break end is `Feb 6th 18:30` (in unit `minute`). Thus the break
 *  label prefers `Jan 25th 18:00` and `Feb 6th 18:30` rather than only `18:00` and `18:30`, otherwise it
 *  causes misleading.
 *  In this case, the tick of the break start and end will both be:
 *      `{level: 1, lowerTimeUnit: 'minute', upperTimeUnit: 'month'}`
 *  And get the final template by `generated_dict[lowerTimeUnit][upperTimeUnit][level]`.
 *  Note that the time unit can not be calculated directly by a single tick value, since the two breaks have
 *  to be at the same time unit to avoid awkward appearance. i.e., `Jan 25th 18:00` is in the time unit "hour"
 *  but we need it to be "minute", following `Feb 6th 18:30`.
 */ function $0ae0381fb3fd176f$var$parseTimeAxisLabelFormatterDictionary(dictOption) {
    dictOption = dictOption || {};
    var dict = {};
    // Currently if any template is specified by user, it may contain rich text tag,
    // such as `'{my_bold|{YYYY}}'`, thus we do add highlight style to it.
    // (Note that nested tag (`'{some|{some2|xxx}}'`) in rich text is not supported yet.)
    var canAddHighlight = true;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43($0ae0381fb3fd176f$export$87100da04d711986, function(lowestUnit) {
        canAddHighlight && (canAddHighlight = dictOption[lowestUnit] == null);
    });
    $7a1bd9c2710fea0d$export$79b2f7037acddd43($0ae0381fb3fd176f$export$87100da04d711986, function(lowestUnit, lowestUnitIdx) {
        var upperDictOption = dictOption[lowestUnit];
        dict[lowestUnit] = {};
        var lowerTpl = null;
        for(var upperUnitIdx = lowestUnitIdx; upperUnitIdx >= 0; upperUnitIdx--){
            var upperUnit = $0ae0381fb3fd176f$export$87100da04d711986[upperUnitIdx];
            var upperDictItemOption = $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(upperDictOption) && !$7a1bd9c2710fea0d$export$43bee75e5e14138e(upperDictOption) ? upperDictOption[upperUnit] : upperDictOption;
            var tplArr = void 0;
            if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(upperDictItemOption)) {
                tplArr = upperDictItemOption.slice();
                lowerTpl = tplArr[0] || "";
            } else if ($7a1bd9c2710fea0d$export$844ec244b1367d54(upperDictItemOption)) {
                lowerTpl = upperDictItemOption;
                tplArr = [
                    lowerTpl
                ];
            } else {
                if (lowerTpl == null) lowerTpl = $0ae0381fb3fd176f$var$defaultFormatterSeed[lowestUnit];
                else if (!$0ae0381fb3fd176f$var$primaryTimeUnitFormatterMatchers[upperUnit].test(lowerTpl)) lowerTpl = dict[upperUnit][upperUnit][0] + " " + lowerTpl;
                tplArr = [
                    lowerTpl
                ];
                if (canAddHighlight) tplArr[1] = "{primary|" + lowerTpl + "}";
            }
            dict[lowestUnit][upperUnit] = tplArr;
        }
    });
    return dict;
}
function $0ae0381fb3fd176f$export$5d04458e2a6c373e(str, len) {
    str += "";
    return "0000".substr(0, len - str.length) + str;
}
function $0ae0381fb3fd176f$export$1da4b91a25d7e1c8(timeUnit) {
    switch(timeUnit){
        case "half-year":
        case "quarter":
            return "month";
        case "week":
        case "half-week":
            return "day";
        case "half-day":
        case "quarter-day":
            return "hour";
        default:
            // year, minutes, second, milliseconds
            return timeUnit;
    }
}
function $0ae0381fb3fd176f$export$beb5920b69c13da(timeUnit) {
    return timeUnit === $0ae0381fb3fd176f$export$1da4b91a25d7e1c8(timeUnit);
}
function $0ae0381fb3fd176f$export$124c820721c4f66b(timeUnit) {
    switch(timeUnit){
        case "year":
        case "month":
            return "day";
        case "millisecond":
            return "millisecond";
        default:
            // Also for day, hour, minute, second
            return "second";
    }
}
function $0ae0381fb3fd176f$export$d9468344d3651243(// Note: The result based on `isUTC` are totally different, which can not be just simply
// substituted by the result without `isUTC`. So we make the param `isUTC` mandatory.
time, template, isUTC, lang) {
    var date = $cfc1f3b422a3185f$export$6b862160d295c8e(time);
    var y = date[$0ae0381fb3fd176f$export$8d046fefed9a548e(isUTC)]();
    var M = date[$0ae0381fb3fd176f$export$5c242a801a23eec7(isUTC)]() + 1;
    var q = Math.floor((M - 1) / 3) + 1;
    var d = date[$0ae0381fb3fd176f$export$4189e6cbc9753260(isUTC)]();
    var e = date["get" + (isUTC ? "UTC" : "") + "Day"]();
    var H = date[$0ae0381fb3fd176f$export$8b40b55b3c06cbe2(isUTC)]();
    var h = (H - 1) % 12 + 1;
    var m = date[$0ae0381fb3fd176f$export$8807847c5c71eded(isUTC)]();
    var s = date[$0ae0381fb3fd176f$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$0ae0381fb3fd176f$export$312207a92d041116(isUTC)]();
    var a = H >= 12 ? "pm" : "am";
    var A = a.toUpperCase();
    var localeModel = lang instanceof (0, $6818646a97528290$export$2e2bcd8739ae039) ? lang : (0, $9b0a1ef4bcc91e7d$export$37cc638e0e11865f)(lang || (0, $9b0a1ef4bcc91e7d$export$9a2147b3808d4c6b)) || (0, $9b0a1ef4bcc91e7d$export$1188f179b2597821)();
    var timeModel = localeModel.getModel("time");
    var month = timeModel.get("month");
    var monthAbbr = timeModel.get("monthAbbr");
    var dayOfWeek = timeModel.get("dayOfWeek");
    var dayOfWeekAbbr = timeModel.get("dayOfWeekAbbr");
    return (template || "").replace(/{a}/g, a + "").replace(/{A}/g, A + "").replace(/{yyyy}/g, y + "").replace(/{yy}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(y % 100 + "", 2)).replace(/{Q}/g, q + "").replace(/{MMMM}/g, month[M - 1]).replace(/{MMM}/g, monthAbbr[M - 1]).replace(/{MM}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(M, 2)).replace(/{M}/g, M + "").replace(/{dd}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(d, 2)).replace(/{d}/g, d + "").replace(/{eeee}/g, dayOfWeek[e]).replace(/{ee}/g, dayOfWeekAbbr[e]).replace(/{e}/g, e + "").replace(/{HH}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(H, 2)).replace(/{H}/g, H + "").replace(/{hh}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(h + "", 2)).replace(/{h}/g, h + "").replace(/{mm}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(m, 2)).replace(/{m}/g, m + "").replace(/{ss}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(s, 2)).replace(/{s}/g, s + "").replace(/{SSS}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(S, 3)).replace(/{S}/g, S + "");
}
function $0ae0381fb3fd176f$export$fe777b6293828b5d(tick, idx, formatter, lang, isUTC) {
    var template = null;
    if ($7a1bd9c2710fea0d$export$844ec244b1367d54(formatter)) // Single formatter for all units at all levels
    template = formatter;
    else if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(formatter)) {
        var extra = {
            time: tick.time,
            level: tick.time.level
        };
        var scaleBreakHelper = (0, $639a5974fe354f7a$export$e79b20ac82c2d660)();
        if (scaleBreakHelper) scaleBreakHelper.makeAxisLabelFormatterParamBreak(extra, tick["break"]);
        template = formatter(tick.value, idx, extra);
    } else {
        var tickTime = tick.time;
        if (tickTime) {
            var leveledTplArr = formatter[tickTime.lowerTimeUnit][tickTime.upperTimeUnit];
            template = leveledTplArr[Math.min(tickTime.level, leveledTplArr.length - 1)] || "";
        } else {
            // tick may be from customTicks or timeline therefore no tick.time.
            var unit = $0ae0381fb3fd176f$export$4dfb0417ad6555b7(tick.value, isUTC);
            template = formatter[unit][unit][0];
        }
    }
    return $0ae0381fb3fd176f$export$d9468344d3651243(new Date(tick.value), template, isUTC, lang);
}
function $0ae0381fb3fd176f$export$4dfb0417ad6555b7(value, isUTC) {
    var date = $cfc1f3b422a3185f$export$6b862160d295c8e(value);
    var M = date[$0ae0381fb3fd176f$export$5c242a801a23eec7(isUTC)]() + 1;
    var d = date[$0ae0381fb3fd176f$export$4189e6cbc9753260(isUTC)]();
    var h = date[$0ae0381fb3fd176f$export$8b40b55b3c06cbe2(isUTC)]();
    var m = date[$0ae0381fb3fd176f$export$8807847c5c71eded(isUTC)]();
    var s = date[$0ae0381fb3fd176f$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$0ae0381fb3fd176f$export$312207a92d041116(isUTC)]();
    var isSecond = S === 0;
    var isMinute = isSecond && s === 0;
    var isHour = isMinute && m === 0;
    var isDay = isHour && h === 0;
    var isMonth = isDay && d === 1;
    var isYear = isMonth && M === 1;
    if (isYear) return "year";
    else if (isMonth) return "month";
    else if (isDay) return "day";
    else if (isHour) return "hour";
    else if (isMinute) return "minute";
    else if (isSecond) return "second";
    else return "millisecond";
}
function $0ae0381fb3fd176f$export$2ed3384313b02c28(date, timeUnit, isUTC) {
    switch(timeUnit){
        case "year":
            date[$0ae0381fb3fd176f$export$233f59998ed71c09(isUTC)](0);
        case "month":
            date[$0ae0381fb3fd176f$export$82fd379a67f37fa0(isUTC)](1);
        case "day":
            date[$0ae0381fb3fd176f$export$b6f943e8d23c15bb(isUTC)](0);
        case "hour":
            date[$0ae0381fb3fd176f$export$50303078793fc7d(isUTC)](0);
        case "minute":
            date[$0ae0381fb3fd176f$export$a4a908acda9c3118(isUTC)](0);
        case "second":
            date[$0ae0381fb3fd176f$export$c047afab75f6d84(isUTC)](0);
    }
    return date;
}
function $0ae0381fb3fd176f$export$8d046fefed9a548e(isUTC) {
    return isUTC ? "getUTCFullYear" : "getFullYear";
}
function $0ae0381fb3fd176f$export$5c242a801a23eec7(isUTC) {
    return isUTC ? "getUTCMonth" : "getMonth";
}
function $0ae0381fb3fd176f$export$4189e6cbc9753260(isUTC) {
    return isUTC ? "getUTCDate" : "getDate";
}
function $0ae0381fb3fd176f$export$8b40b55b3c06cbe2(isUTC) {
    return isUTC ? "getUTCHours" : "getHours";
}
function $0ae0381fb3fd176f$export$8807847c5c71eded(isUTC) {
    return isUTC ? "getUTCMinutes" : "getMinutes";
}
function $0ae0381fb3fd176f$export$8f49e73e2eebd168(isUTC) {
    return isUTC ? "getUTCSeconds" : "getSeconds";
}
function $0ae0381fb3fd176f$export$312207a92d041116(isUTC) {
    return isUTC ? "getUTCMilliseconds" : "getMilliseconds";
}
function $0ae0381fb3fd176f$export$43fbeac90913b151(isUTC) {
    return isUTC ? "setUTCFullYear" : "setFullYear";
}
function $0ae0381fb3fd176f$export$233f59998ed71c09(isUTC) {
    return isUTC ? "setUTCMonth" : "setMonth";
}
function $0ae0381fb3fd176f$export$82fd379a67f37fa0(isUTC) {
    return isUTC ? "setUTCDate" : "setDate";
}
function $0ae0381fb3fd176f$export$b6f943e8d23c15bb(isUTC) {
    return isUTC ? "setUTCHours" : "setHours";
}
function $0ae0381fb3fd176f$export$50303078793fc7d(isUTC) {
    return isUTC ? "setUTCMinutes" : "setMinutes";
}
function $0ae0381fb3fd176f$export$a4a908acda9c3118(isUTC) {
    return isUTC ? "setUTCSeconds" : "setSeconds";
}
function $0ae0381fb3fd176f$export$c047afab75f6d84(isUTC) {
    return isUTC ? "setUTCMilliseconds" : "setMilliseconds";
}





function $c84c9521536c601a$export$b6fe44657ce35c42(x) {
    if (!(0, $cfc1f3b422a3185f$export$e90fb89750dba83f)(x)) return $7a1bd9c2710fea0d$export$844ec244b1367d54(x) ? x : "-";
    var parts = (x + "").split(".");
    return parts[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, "$1,") + (parts.length > 1 ? "." + parts[1] : "");
}
function $c84c9521536c601a$export$86f54f62aa7a7514(str, upperCaseFirst) {
    str = (str || "").toLowerCase().replace(/-(.)/g, function(match, group1) {
        return group1.toUpperCase();
    });
    if (upperCaseFirst && str) str = str.charAt(0).toUpperCase() + str.slice(1);
    return str;
}
var $c84c9521536c601a$export$f3a38102c49f4268 = $7a1bd9c2710fea0d$export$f3a38102c49f4268;
function $c84c9521536c601a$export$3cd8db88714decfc(value, valueType, useUTC) {
    var USER_READABLE_DEFUALT_TIME_PATTERN = "{yyyy}-{MM}-{dd} {HH}:{mm}:{ss}";
    function stringToUserReadable(str) {
        return str && $7a1bd9c2710fea0d$export$87c2784dc9fc4ab(str) ? str : "-";
    }
    function isNumberUserReadable(num) {
        return !!(num != null && !isNaN(num) && isFinite(num));
    }
    var isTypeTime = valueType === "time";
    var isValueDate = value instanceof Date;
    if (isTypeTime || isValueDate) {
        var date = isTypeTime ? (0, $cfc1f3b422a3185f$export$6b862160d295c8e)(value) : value;
        if (!isNaN(+date)) return (0, $0ae0381fb3fd176f$export$d9468344d3651243)(date, USER_READABLE_DEFUALT_TIME_PATTERN, useUTC);
        else if (isValueDate) return "-";
    // In other cases, continue to try to display the value in the following code.
    }
    if (valueType === "ordinal") return $7a1bd9c2710fea0d$export$29d0bb2a4e07b252(value) ? stringToUserReadable(value) : $7a1bd9c2710fea0d$export$7e4aa119212bc614(value) ? isNumberUserReadable(value) ? value + "" : "-" : "-";
    // By default.
    var numericResult = (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(value);
    return isNumberUserReadable(numericResult) ? $c84c9521536c601a$export$b6fe44657ce35c42(numericResult) : $7a1bd9c2710fea0d$export$29d0bb2a4e07b252(value) ? stringToUserReadable(value) : typeof value === "boolean" ? value + "" : "-";
}
var $c84c9521536c601a$var$TPL_VAR_ALIAS = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g"
];
var $c84c9521536c601a$var$wrapVar = function(varName, seriesIdx) {
    return "{" + varName + (seriesIdx == null ? "" : seriesIdx) + "}";
};
function $c84c9521536c601a$export$2028496a35766e41(tpl, paramsList, encode) {
    if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(paramsList)) paramsList = [
        paramsList
    ];
    var seriesLen = paramsList.length;
    if (!seriesLen) return "";
    var $vars = paramsList[0].$vars || [];
    for(var i = 0; i < $vars.length; i++){
        var alias = $c84c9521536c601a$var$TPL_VAR_ALIAS[i];
        tpl = tpl.replace($c84c9521536c601a$var$wrapVar(alias), $c84c9521536c601a$var$wrapVar(alias, 0));
    }
    for(var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++)for(var k = 0; k < $vars.length; k++){
        var val = paramsList[seriesIdx][$vars[k]];
        tpl = tpl.replace($c84c9521536c601a$var$wrapVar($c84c9521536c601a$var$TPL_VAR_ALIAS[k], seriesIdx), encode ? (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(val) : val);
    }
    return tpl;
}
function $c84c9521536c601a$export$2fa08233ee42f8e1(tpl, param, encode) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(param, function(value, key) {
        tpl = tpl.replace("{" + key + "}", encode ? (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(value) : value);
    });
    return tpl;
}
function $c84c9521536c601a$export$1987a3dbdf3c45ca(inOpt, extraCssText) {
    var opt = $7a1bd9c2710fea0d$export$844ec244b1367d54(inOpt) ? {
        color: inOpt,
        extraCssText: extraCssText
    } : inOpt || {};
    var color = opt.color;
    var type = opt.type;
    extraCssText = opt.extraCssText;
    var renderMode = opt.renderMode || "html";
    if (!color) return "";
    if (renderMode === "html") return type === "subItem" ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;border-radius:4px;width:4px;height:4px;background-color:' + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(color) + ";" + (extraCssText || "") + '"></span>' : '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(color) + ";" + (extraCssText || "") + '"></span>';
    else {
        // Should better not to auto generate style name by auto-increment number here.
        // Because this util is usually called in tooltip formatter, which is probably
        // called repeatedly when mouse move and the auto-increment number increases fast.
        // Users can make their own style name by theirselves, make it unique and readable.
        var markerId = opt.markerId || "markerX";
        return {
            renderMode: renderMode,
            content: "{" + markerId + "|}  ",
            style: type === "subItem" ? {
                width: 4,
                height: 4,
                borderRadius: 2,
                backgroundColor: color
            } : {
                width: 10,
                height: 10,
                borderRadius: 5,
                backgroundColor: color
            }
        };
    }
}
function $c84c9521536c601a$export$3203edd9e5edd663(tpl, value, isUTC) {
    if (tpl === "week" || tpl === "month" || tpl === "quarter" || tpl === "half-year" || tpl === "year") tpl = "MM-dd\nyyyy";
    var date = (0, $cfc1f3b422a3185f$export$6b862160d295c8e)(value);
    var getUTC = isUTC ? "getUTC" : "get";
    var y = date[getUTC + "FullYear"]();
    var M = date[getUTC + "Month"]() + 1;
    var d = date[getUTC + "Date"]();
    var h = date[getUTC + "Hours"]();
    var m = date[getUTC + "Minutes"]();
    var s = date[getUTC + "Seconds"]();
    var S = date[getUTC + "Milliseconds"]();
    tpl = tpl.replace("MM", (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(M, 2)).replace("M", M).replace("yyyy", y).replace("yy", (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(y % 100 + "", 2)).replace("dd", (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(d, 2)).replace("d", d).replace("hh", (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(h, 2)).replace("h", h).replace("mm", (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(m, 2)).replace("m", m).replace("ss", (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(s, 2)).replace("s", s).replace("SSS", (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(S, 3));
    return tpl;
}
function $c84c9521536c601a$export$38a1e7552f497c0e(str) {
    return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
}
function $c84c9521536c601a$export$cda04d03233e5555(color, defaultColor) {
    defaultColor = defaultColor || "transparent";
    return $7a1bd9c2710fea0d$export$844ec244b1367d54(color) ? color : $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(color) ? color.colorStops && (color.colorStops[0] || {}).color || defaultColor : defaultColor;
}
function $c84c9521536c601a$export$13e13f9b96dbe8fa(link, target) {
    /* global window */ if (target === "_blank" || target === "blank") {
        var blank = window.open();
        blank.opener = null;
        blank.location.href = link;
    } else window.open(link, target);
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/**
 * FIXME:
 * `nonSeriesBoxCoordSysCreators` and `_nonSeriesBoxMasterList` are hardcoded implementations.
 * Regarding "coord sys layout based on another coord sys", currently we only exprimentally support one level
 * dpendency, such as, "grid(cartesian)s can be laid out based on matrix/calendar coord sys."
 * But a comprehensive implementation may need to support:
 *  - Recursive dependencies. e.g., a matrix coord sys lays out based on another matrix coord sys.
 *    That requires in the implementation `create` and `update` of coord sys are called by a dependency graph.
 *    (@see enableTopologicalTravel in `util/component.ts`)
 */ var $70c3ede7d3b64757$var$nonSeriesBoxCoordSysCreators = {};
var $70c3ede7d3b64757$var$normalCoordSysCreators = {};
var $70c3ede7d3b64757$var$CoordinateSystemManager = /** @class */ function() {
    function CoordinateSystemManager() {
        this._normalMasterList = [];
        this._nonSeriesBoxMasterList = [];
    }
    /**
   * Typically,
   *  - in `create`, a coord sys lays out based on a given rect;
   *  - in `update`, update the pixel and data extent of there axes (if any) based on processed `series.data`.
   * After that, a coord sys can serve (typically by `dataToPoint`/`dataToLayout`/`pointToData`).
   * If the coordinate system do not lay out based on `series.data`, `update` is not needed.
   */ CoordinateSystemManager.prototype.create = function(ecModel, api) {
        this._nonSeriesBoxMasterList = dealCreate($70c3ede7d3b64757$var$nonSeriesBoxCoordSysCreators, true);
        this._normalMasterList = dealCreate($70c3ede7d3b64757$var$normalCoordSysCreators, false);
        function dealCreate(creatorMap, canBeNonSeriesBox) {
            var coordinateSystems = [];
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(creatorMap, function(creator, type) {
                var list = creator.create(ecModel, api);
                coordinateSystems = coordinateSystems.concat(list || []);
            });
            return coordinateSystems;
        }
    };
    /**
   * @see CoordinateSystem['create']
   */ CoordinateSystemManager.prototype.update = function(ecModel, api) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._normalMasterList, function(coordSys) {
            coordSys.update && coordSys.update(ecModel, api);
        });
    };
    CoordinateSystemManager.prototype.getCoordinateSystems = function() {
        return this._normalMasterList.concat(this._nonSeriesBoxMasterList);
    };
    CoordinateSystemManager.register = function(type, creator) {
        if (type === "matrix" || type === "calendar") {
            // FIXME: hardcode, @see nonSeriesBoxCoordSysCreators
            $70c3ede7d3b64757$var$nonSeriesBoxCoordSysCreators[type] = creator;
            return;
        }
        $70c3ede7d3b64757$var$normalCoordSysCreators[type] = creator;
    };
    CoordinateSystemManager.get = function(type) {
        return $70c3ede7d3b64757$var$normalCoordSysCreators[type] || $70c3ede7d3b64757$var$nonSeriesBoxCoordSysCreators[type];
    };
    return CoordinateSystemManager;
}();
function $70c3ede7d3b64757$var$canBeNonSeriesBoxCoordSys(coordSysType) {
    return !!$70c3ede7d3b64757$var$nonSeriesBoxCoordSysCreators[coordSysType];
}
var $70c3ede7d3b64757$export$b0f4b35a5e5703d9 = {
    // By default fetch coord from `model.get('coord')`.
    coord: 1,
    // Some model/series, such as pie, is allowed to also get coord from `model.get('center')`,
    // if cannot get from `model.get('coord')`. But historically pie use `center` option, but
    // geo use `layoutCenter` option to specify layout center; they are not able to be unified.
    // Therefor it is not recommended.
    coord2: 2
};
function $70c3ede7d3b64757$export$b8fb890203e861d5(opt) {
    $70c3ede7d3b64757$var$coordSysUseMap.set(opt.fullType, {
        getCoord2: undefined
    }).getCoord2 = opt.getCoord2;
}
var $70c3ede7d3b64757$var$coordSysUseMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
function $70c3ede7d3b64757$export$86c4e85e47608a23(model) {
    var coord = model.getShallow("coord", true);
    var from = $70c3ede7d3b64757$export$b0f4b35a5e5703d9.coord;
    if (coord == null) {
        var store = $70c3ede7d3b64757$var$coordSysUseMap.get(model.type);
        if (store && store.getCoord2) {
            from = $70c3ede7d3b64757$export$b0f4b35a5e5703d9.coord2;
            coord = store.getCoord2(model);
        }
    }
    return {
        coord: coord,
        from: from
    };
}
var $70c3ede7d3b64757$export$20673ff3ebf85e08 = {
    none: 0,
    dataCoordSys: 1,
    boxCoordSys: 2
};
function $70c3ede7d3b64757$export$29cb72d70b6b3a71(// Component or series
model, printError) {
    // For backward compat, still not use `true` in model.get.
    var coordSysType = model.getShallow("coordinateSystem");
    var coordSysUsageOption = model.getShallow("coordinateSystemUsage", true);
    var isDeclaredExplicitly = coordSysUsageOption != null;
    var kind = $70c3ede7d3b64757$export$20673ff3ebf85e08.none;
    if (coordSysType) {
        var isSeries = model.mainType === "series";
        if (coordSysUsageOption == null) coordSysUsageOption = isSeries ? "data" : "box";
        if (coordSysUsageOption === "data") {
            kind = $70c3ede7d3b64757$export$20673ff3ebf85e08.dataCoordSys;
            if (!isSeries) kind = $70c3ede7d3b64757$export$20673ff3ebf85e08.none;
        } else if (coordSysUsageOption === "box") {
            kind = $70c3ede7d3b64757$export$20673ff3ebf85e08.boxCoordSys;
            if (!isSeries && !$70c3ede7d3b64757$var$canBeNonSeriesBoxCoordSys(coordSysType)) kind = $70c3ede7d3b64757$export$20673ff3ebf85e08.none;
        }
    }
    return {
        coordSysType: coordSysType,
        kind: kind
    };
}
function $70c3ede7d3b64757$export$7ed0c09d4f5c932e(opt) {
    var targetModel = opt.targetModel, coordSysType = opt.coordSysType, coordSysProvider = opt.coordSysProvider, isDefaultDataCoordSys = opt.isDefaultDataCoordSys, allowNotFound = opt.allowNotFound;
    var _a = $70c3ede7d3b64757$export$29cb72d70b6b3a71(targetModel, true), kind = _a.kind, declaredType = _a.coordSysType;
    if (isDefaultDataCoordSys && kind !== $70c3ede7d3b64757$export$20673ff3ebf85e08.dataCoordSys) {
        // If both dataCoordSys and boxCoordSys declared in one model.
        // There is the only case in series-graph, and no other cases yet.
        kind = $70c3ede7d3b64757$export$20673ff3ebf85e08.dataCoordSys;
        declaredType = coordSysType;
    }
    if (kind === $70c3ede7d3b64757$export$20673ff3ebf85e08.none || declaredType !== coordSysType) return false;
    var coordSys = coordSysProvider(coordSysType, targetModel);
    if (!coordSys) return false;
    if (kind === $70c3ede7d3b64757$export$20673ff3ebf85e08.dataCoordSys) targetModel.coordinateSystem = coordSys;
    else // kind === 'boxCoordSys'
    targetModel.boxCoordinateSystem = coordSys;
    return true;
}
var $70c3ede7d3b64757$export$33b06c851894cd19 = function(coordSysType, injectTargetModel) {
    var coordSysModel = injectTargetModel.getReferringComponents(coordSysType, (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
    return coordSysModel && coordSysModel.coordinateSystem;
};
var $70c3ede7d3b64757$export$2e2bcd8739ae039 = $70c3ede7d3b64757$var$CoordinateSystemManager;


var $93b9bc7f22ac7369$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $93b9bc7f22ac7369$export$a9aa2cc018afbed = [
    "left",
    "right",
    "top",
    "bottom",
    "width",
    "height"
];
var $93b9bc7f22ac7369$export$d7fd4338c7b20804 = [
    [
        "width",
        "left",
        "right"
    ],
    [
        "height",
        "top",
        "bottom"
    ]
];
function $93b9bc7f22ac7369$var$boxLayout(orient, group, gap, maxWidth, maxHeight) {
    var x = 0;
    var y = 0;
    if (maxWidth == null) maxWidth = Infinity;
    if (maxHeight == null) maxHeight = Infinity;
    var currentLineMaxSize = 0;
    group.eachChild(function(child, idx) {
        var rect = child.getBoundingRect();
        var nextChild = group.childAt(idx + 1);
        var nextChildRect = nextChild && nextChild.getBoundingRect();
        var nextX;
        var nextY;
        if (orient === "horizontal") {
            var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
            nextX = x + moveX;
            // Wrap when width exceeds maxWidth or meet a `newline` group
            // FIXME compare before adding gap?
            if (nextX > maxWidth || child.newline) {
                x = 0;
                nextX = moveX;
                y += currentLineMaxSize + gap;
                currentLineMaxSize = rect.height;
            } else // FIXME: consider rect.y is not `0`?
            currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
        } else {
            var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
            nextY = y + moveY;
            // Wrap when width exceeds maxHeight or meet a `newline` group
            if (nextY > maxHeight || child.newline) {
                x += currentLineMaxSize + gap;
                y = 0;
                nextY = moveY;
                currentLineMaxSize = rect.width;
            } else currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
        }
        if (child.newline) return;
        child.x = x;
        child.y = y;
        child.markRedraw();
        orient === "horizontal" ? x = nextX + gap : y = nextY + gap;
    });
}
var $93b9bc7f22ac7369$export$827f4ee28efc37 = $93b9bc7f22ac7369$var$boxLayout;
var $93b9bc7f22ac7369$export$be20d9158c17374c = $7a1bd9c2710fea0d$export$c3095a23b368d1f2($93b9bc7f22ac7369$var$boxLayout, "vertical");
var $93b9bc7f22ac7369$export$ae65a483d943e7a7 = $7a1bd9c2710fea0d$export$c3095a23b368d1f2($93b9bc7f22ac7369$var$boxLayout, "horizontal");
function $93b9bc7f22ac7369$export$22344244a123da8(boxLayoutModel, ignoreParent) {
    return {
        left: boxLayoutModel.getShallow("left", ignoreParent),
        top: boxLayoutModel.getShallow("top", ignoreParent),
        right: boxLayoutModel.getShallow("right", ignoreParent),
        bottom: boxLayoutModel.getShallow("bottom", ignoreParent),
        width: boxLayoutModel.getShallow("width", ignoreParent),
        height: boxLayoutModel.getShallow("height", ignoreParent)
    };
}
function $93b9bc7f22ac7369$var$getViewRectAndCenterForCircleLayout(seriesModel, api) {
    var layoutRef = $93b9bc7f22ac7369$export$5aec1e94f566e59f(seriesModel, api, {
        enableLayoutOnlyByCenter: true
    });
    var boxLayoutParams = seriesModel.getBoxLayoutParams();
    var viewRect;
    var center;
    if (layoutRef.type === $93b9bc7f22ac7369$export$953b11ffc6912560.point) {
        center = layoutRef.refPoint;
        // `viewRect` is required in `pie/labelLayout.ts`.
        viewRect = $93b9bc7f22ac7369$export$4517a5ca639a7293(boxLayoutParams, {
            width: api.getWidth(),
            height: api.getHeight()
        });
    } else {
        // layoutRef.type === layout.BoxLayoutReferenceType.rect
        var centerOption = seriesModel.get("center");
        var centerOptionArr = $7a1bd9c2710fea0d$export$43bee75e5e14138e(centerOption) ? centerOption : [
            centerOption,
            centerOption
        ];
        viewRect = $93b9bc7f22ac7369$export$4517a5ca639a7293(boxLayoutParams, layoutRef.refContainer);
        center = layoutRef.boxCoordFrom === (0, $70c3ede7d3b64757$export$b0f4b35a5e5703d9).coord2 ? layoutRef.refPoint // option `series.center` has been used as coord.
         : [
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(centerOptionArr[0], viewRect.width) + viewRect.x,
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(centerOptionArr[1], viewRect.height) + viewRect.y
        ];
    }
    return {
        viewRect: viewRect,
        center: center
    };
}
function $93b9bc7f22ac7369$export$3101c00baac0ee1f(seriesModel, api) {
    // center can be string or number when coordinateSystem is specified
    var _a = $93b9bc7f22ac7369$var$getViewRectAndCenterForCircleLayout(seriesModel, api), viewRect = _a.viewRect, center = _a.center;
    var radius = seriesModel.get("radius");
    if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(radius)) radius = [
        0,
        radius
    ];
    var width = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(viewRect.width, api.getWidth());
    var height = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(viewRect.height, api.getHeight());
    var size = Math.min(width, height);
    var r0 = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(radius[0], size / 2);
    var r = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(radius[1], size / 2);
    return {
        cx: center[0],
        cy: center[1],
        r0: r0,
        r: r,
        viewRect: viewRect
    };
}
function $93b9bc7f22ac7369$export$4517a5ca639a7293(positionInfo, containerRect, // This is the space from the `containerRect` to the returned bounding rect.
// Commonly used in option `legend.padding`, `timeline.padding`, `title.padding`,
//  `visualMap.padding`, ...
// [NOTICE]:
//  It's named `margin`, because it's the space that outside the bounding rect. But from
//  the perspective of the the caller, it's commonly used as the `padding` of a component,
//  because conventionally background color covers this space.
// [BEHAVIOR]:
//  - If width/height is specified, `margin` does not effect them.
//  - Otherwise, they are calculated based on the rect that `containerRect` shrinked by `margin`.
//  - left/right/top/bottom are based on the rect that `containerRect` shrinked by `margin`.
margin) {
    margin = $c84c9521536c601a$export$f3a38102c49f4268(margin || 0);
    var containerWidth = containerRect.width;
    var containerHeight = containerRect.height;
    var left = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.left, containerWidth);
    var top = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.top, containerHeight);
    var right = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.right, containerWidth);
    var bottom = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.bottom, containerHeight);
    var width = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.width, containerWidth);
    var height = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.height, containerHeight);
    var verticalMargin = margin[2] + margin[0];
    var horizontalMargin = margin[1] + margin[3];
    var aspect = positionInfo.aspect;
    // If width is not specified, calculate width from left and right
    if (isNaN(width)) width = containerWidth - right - horizontalMargin - left;
    if (isNaN(height)) height = containerHeight - bottom - verticalMargin - top;
    if (aspect != null) {
        // If width and height are not given
        // 1. Graph should not exceeds the container
        // 2. Aspect must be keeped
        // 3. Graph should take the space as more as possible
        // FIXME
        // Margin is not considered, because there is no case that both
        // using margin and aspect so far.
        if (isNaN(width) && isNaN(height)) {
            // PENDING: if only `left` or `right` is defined, perhaps it's more preferable to
            // calculate size based on `containerWidth - left` or `containerWidth - left` here,
            // but for backward compatibility we do not change it.
            if (aspect > containerWidth / containerHeight) width = containerWidth * 0.8;
            else height = containerHeight * 0.8;
        }
        // Calculate width or height with given aspect
        if (isNaN(width)) width = aspect * height;
        if (isNaN(height)) height = width / aspect;
    }
    // If left is not specified, calculate left from right and width
    if (isNaN(left)) left = containerWidth - right - width - horizontalMargin;
    if (isNaN(top)) top = containerHeight - bottom - height - verticalMargin;
    // Align left and top
    switch(positionInfo.left || positionInfo.right){
        case "center":
            left = containerWidth / 2 - width / 2 - margin[3];
            break;
        case "right":
            left = containerWidth - width - horizontalMargin;
            break;
    }
    switch(positionInfo.top || positionInfo.bottom){
        case "middle":
        case "center":
            top = containerHeight / 2 - height / 2 - margin[0];
            break;
        case "bottom":
            top = containerHeight - height - verticalMargin;
            break;
    }
    // If something is wrong and left, top, width, height are calculated as NaN
    left = left || 0;
    top = top || 0;
    if (isNaN(width)) // Width may be NaN if only one value is given except width
    width = containerWidth - horizontalMargin - left - (right || 0);
    if (isNaN(height)) // Height may be NaN if only one value is given except height
    height = containerHeight - verticalMargin - top - (bottom || 0);
    var rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)((containerRect.x || 0) + left + margin[3], (containerRect.y || 0) + top + margin[0], width, height);
    rect.margin = margin;
    return rect;
}
function $93b9bc7f22ac7369$export$9fec79e40d579ea7(component, layoutRect, // That is, `width / height`.
// Assume `aspect` is positive.
aspect) {
    var preserveAspect = component.getShallow("preserveAspect", true);
    if (!preserveAspect) return layoutRect;
    var actualAspect = layoutRect.width / layoutRect.height;
    if (Math.abs(Math.atan(aspect) - Math.atan(actualAspect)) < 1e-9) return layoutRect;
    var preserveAspectAlign = component.getShallow("preserveAspectAlign", true);
    var preserveAspectVerticalAlign = component.getShallow("preserveAspectVerticalAlign", true);
    var layoutOptInner = {
        width: layoutRect.width,
        height: layoutRect.height
    };
    var isCover = preserveAspect === "cover";
    if (actualAspect > aspect && !isCover || actualAspect < aspect && isCover) {
        layoutOptInner.width = layoutRect.height * aspect;
        preserveAspectAlign === "left" ? layoutOptInner.left = 0 : preserveAspectAlign === "right" ? layoutOptInner.right = 0 : layoutOptInner.left = "center";
    } else {
        layoutOptInner.height = layoutRect.width / aspect;
        preserveAspectVerticalAlign === "top" ? layoutOptInner.top = 0 : preserveAspectVerticalAlign === "bottom" ? layoutOptInner.bottom = 0 : layoutOptInner.top = "middle";
    }
    return $93b9bc7f22ac7369$export$4517a5ca639a7293(layoutOptInner, layoutRect);
}
var $93b9bc7f22ac7369$export$953b11ffc6912560 = {
    rect: 1,
    point: 2
};
function $93b9bc7f22ac7369$export$5aec1e94f566e59f(model, api, opt) {
    var refContainer;
    var refPoint;
    var layoutRefType;
    var boxCoordSys = model.boxCoordinateSystem;
    var boxCoordFrom;
    if (boxCoordSys) {
        var _a = (0, $70c3ede7d3b64757$export$86c4e85e47608a23)(model), coord = _a.coord, from = _a.from;
        // Do not use `clamp` in `dataToLayout` and `dataToPoint`, because:
        //  1. Should support overflow (such as, by dataZoom), where NaN should be in the result.
        //  2. Be consistent with the way used in `series.data`
        if (boxCoordSys.dataToLayout) {
            layoutRefType = $93b9bc7f22ac7369$export$953b11ffc6912560.rect;
            boxCoordFrom = from;
            var result = boxCoordSys.dataToLayout(coord);
            refContainer = result.contentRect || result.rect;
        } else if (opt && opt.enableLayoutOnlyByCenter && boxCoordSys.dataToPoint) {
            layoutRefType = $93b9bc7f22ac7369$export$953b11ffc6912560.point;
            boxCoordFrom = from;
            refPoint = boxCoordSys.dataToPoint(coord);
        }
    }
    if (layoutRefType == null) layoutRefType = $93b9bc7f22ac7369$export$953b11ffc6912560.rect;
    if (layoutRefType === $93b9bc7f22ac7369$export$953b11ffc6912560.rect) {
        if (!refContainer) refContainer = {
            x: 0,
            y: 0,
            width: api.getWidth(),
            height: api.getHeight()
        };
        refPoint = [
            refContainer.x + refContainer.width / 2,
            refContainer.y + refContainer.height / 2
        ];
    }
    return {
        type: layoutRefType,
        refContainer: refContainer,
        refPoint: refPoint,
        boxCoordFrom: boxCoordFrom
    };
}
function $93b9bc7f22ac7369$export$74054bd96b5eeef1(el, positionInfo, containerRect, margin, opt, out) {
    var h = !opt || !opt.hv || opt.hv[0];
    var v = !opt || !opt.hv || opt.hv[1];
    var boundingMode = opt && opt.boundingMode || "all";
    out = out || el;
    out.x = el.x;
    out.y = el.y;
    if (!h && !v) return false;
    var rect;
    if (boundingMode === "raw") rect = el.type === "group" ? new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
    else {
        rect = el.getBoundingRect();
        if (el.needLocalTransform()) {
            var transform = el.getLocalTransform();
            // Notice: raw rect may be inner object of el,
            // which should not be modified.
            rect = rect.clone();
            rect.applyTransform(transform);
        }
    }
    // The real width and height can not be specified but calculated by the given el.
    var layoutRect = $93b9bc7f22ac7369$export$4517a5ca639a7293($7a1bd9c2710fea0d$export$ebe90cb607ad99e({
        width: rect.width,
        height: rect.height
    }, positionInfo), containerRect, margin);
    // Because 'tranlate' is the last step in transform
    // (see zrender/core/Transformable#getLocalTransform),
    // we can just only modify el.position to get final result.
    var dx = h ? layoutRect.x - rect.x : 0;
    var dy = v ? layoutRect.y - rect.y : 0;
    if (boundingMode === "raw") {
        out.x = dx;
        out.y = dy;
    } else {
        out.x += dx;
        out.y += dy;
    }
    if (out === el) el.markRedraw();
    return true;
}
function $93b9bc7f22ac7369$export$7ede609e8ebc9650(option, hvIdx) {
    return option[$93b9bc7f22ac7369$export$d7fd4338c7b20804[hvIdx][0]] != null || option[$93b9bc7f22ac7369$export$d7fd4338c7b20804[hvIdx][1]] != null && option[$93b9bc7f22ac7369$export$d7fd4338c7b20804[hvIdx][2]] != null;
}
function $93b9bc7f22ac7369$export$3968a28a7cbd6063(ins) {
    var layoutMode = ins.layoutMode || ins.constructor.layoutMode;
    return $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(layoutMode) ? layoutMode : layoutMode ? {
        type: layoutMode
    } : null;
}
function $93b9bc7f22ac7369$export$1754cb91f16ca028(targetOption, newOption, opt) {
    var ignoreSize = opt && opt.ignoreSize;
    !$7a1bd9c2710fea0d$export$43bee75e5e14138e(ignoreSize) && (ignoreSize = [
        ignoreSize,
        ignoreSize
    ]);
    var hResult = merge($93b9bc7f22ac7369$export$d7fd4338c7b20804[0], 0);
    var vResult = merge($93b9bc7f22ac7369$export$d7fd4338c7b20804[1], 1);
    copy($93b9bc7f22ac7369$export$d7fd4338c7b20804[0], targetOption, hResult);
    copy($93b9bc7f22ac7369$export$d7fd4338c7b20804[1], targetOption, vResult);
    function merge(names, hvIdx) {
        var newParams = {};
        var newValueCount = 0;
        var merged = {};
        var mergedValueCount = 0;
        var enoughParamNumber = 2;
        $93b9bc7f22ac7369$var$each(names, function(name) {
            merged[name] = targetOption[name];
        });
        $93b9bc7f22ac7369$var$each(names, function(name) {
            // Consider case: newOption.width is null, which is
            // set by user for removing width setting.
            $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
            hasValue(newParams, name) && newValueCount++;
            hasValue(merged, name) && mergedValueCount++;
        });
        if (ignoreSize[hvIdx]) {
            // Only one of left/right is premitted to exist.
            if (hasValue(newOption, names[1])) merged[names[2]] = null;
            else if (hasValue(newOption, names[2])) merged[names[1]] = null;
            return merged;
        }
        // Case: newOption: {width: ..., right: ...},
        // or targetOption: {right: ...} and newOption: {width: ...},
        // There is no conflict when merged only has params count
        // little than enoughParamNumber.
        if (mergedValueCount === enoughParamNumber || !newValueCount) return merged;
        else if (newValueCount >= enoughParamNumber) return newParams;
        else {
            // Chose another param from targetOption by priority.
            for(var i = 0; i < names.length; i++){
                var name_1 = names[i];
                if (!$7a1bd9c2710fea0d$export$b5a638e9b3fff9f3(newParams, name_1) && $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3(targetOption, name_1)) {
                    newParams[name_1] = targetOption[name_1];
                    break;
                }
            }
            return newParams;
        }
    }
    function hasValue(obj, name) {
        return obj[name] != null && obj[name] !== "auto";
    }
    function copy(names, target, source) {
        $93b9bc7f22ac7369$var$each(names, function(name) {
            target[name] = source[name];
        });
    }
}
function $93b9bc7f22ac7369$export$4b0d20af19c9875e(source) {
    return $93b9bc7f22ac7369$export$7438999faea9b6cc({}, source);
}
function $93b9bc7f22ac7369$export$7438999faea9b6cc(target, source) {
    source && target && $93b9bc7f22ac7369$var$each($93b9bc7f22ac7369$export$a9aa2cc018afbed, function(name) {
        $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3(source, name) && (target[name] = source[name]);
    });
    return target;
}


var $116d65051f61bdfe$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $116d65051f61bdfe$var$ComponentModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ComponentModel, _super);
    function ComponentModel(option, parentModel, ecModel) {
        var _this = _super.call(this, option, parentModel, ecModel) || this;
        _this.uid = $5370df662b2caf37$export$6d2b3473b0986646("ec_cpt_model");
        return _this;
    }
    ComponentModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
    };
    ComponentModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = $93b9bc7f22ac7369$export$3968a28a7cbd6063(this);
        var inputPositionParams = layoutMode ? $93b9bc7f22ac7369$export$4b0d20af19c9875e(option) : {};
        var themeModel = ecModel.getTheme();
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(option, themeModel.get(this.mainType));
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(option, this.getDefaultOption());
        if (layoutMode) $93b9bc7f22ac7369$export$1754cb91f16ca028(option, inputPositionParams, layoutMode);
    };
    ComponentModel.prototype.mergeOption = function(option, ecModel) {
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(this.option, option, true);
        var layoutMode = $93b9bc7f22ac7369$export$3968a28a7cbd6063(this);
        if (layoutMode) $93b9bc7f22ac7369$export$1754cb91f16ca028(this.option, option, layoutMode);
    };
    /**
   * Called immediately after `init` or `mergeOption` of this instance called.
   */ ComponentModel.prototype.optionUpdated = function(newCptOption, isInit) {};
    /**
   * [How to declare defaultOption]:
   *
   * (A) If using class declaration in typescript (since echarts 5):
   * ```ts
   * import {ComponentOption} from '../model/option.js';
   * export interface XxxOption extends ComponentOption {
   *     aaa: number
   * }
   * export class XxxModel extends Component {
   *     static type = 'xxx';
   *     static defaultOption: XxxOption = {
   *         aaa: 123
   *     }
   * }
   * Component.registerClass(XxxModel);
   * ```
   * ```ts
   * import {inheritDefaultOption} from '../util/component.js';
   * import {XxxModel, XxxOption} from './XxxModel.js';
   * export interface XxxSubOption extends XxxOption {
   *     bbb: number
   * }
   * class XxxSubModel extends XxxModel {
   *     static defaultOption: XxxSubOption = inheritDefaultOption(XxxModel.defaultOption, {
   *         bbb: 456
   *     })
   *     fn() {
   *         let opt = this.getDefaultOption();
   *         // opt is {aaa: 123, bbb: 456}
   *     }
   * }
   * ```
   *
   * (B) If using class extend (previous approach in echarts 3 & 4):
   * ```js
   * let XxxComponent = Component.extend({
   *     defaultOption: {
   *         xx: 123
   *     }
   * })
   * ```
   * ```js
   * let XxxSubComponent = XxxComponent.extend({
   *     defaultOption: {
   *         yy: 456
   *     },
   *     fn: function () {
   *         let opt = this.getDefaultOption();
   *         // opt is {xx: 123, yy: 456}
   *     }
   * })
   * ```
   */ ComponentModel.prototype.getDefaultOption = function() {
        var ctor = this.constructor;
        if (!(0, $cd5f95cf03b4e3e7$export$4f3b818f3dd2d182)(ctor)) // When using ES class declaration, defaultOption must be declared as static.
        // And manually inherit the defaultOption from its parent class if needed, such as,
        //  ```ts
        //  static defaultOption = inheritDefaultOption(ParentModel.defaultOption, {...});
        //  ```
        return ctor.defaultOption;
        // FIXME: remove this approach?
        // Legacy: auto merge defaultOption from ancestor classes if using ParentClass.extend(subProto)
        var fields = $116d65051f61bdfe$var$inner(this);
        if (!fields.defaultOption) {
            var optList = [];
            var clz = ctor;
            while(clz){
                var opt = clz.prototype.defaultOption;
                opt && optList.push(opt);
                clz = clz.superClass;
            }
            var defaultOption = {};
            for(var i = optList.length - 1; i >= 0; i--)defaultOption = $7a1bd9c2710fea0d$export$4950aa0f605343fb(defaultOption, optList[i], true);
            fields.defaultOption = defaultOption;
        }
        return fields.defaultOption;
    };
    /**
   * Notice: always force to input param `useDefault` in case that forget to consider it.
   * The same behavior as `modelUtil.parseFinder`.
   *
   * @param useDefault In many cases like series refer axis and axis refer grid,
   *        If axis index / axis id not specified, use the first target as default.
   *        In other cases like dataZoom refer axis, if not specified, measn no refer.
   */ ComponentModel.prototype.getReferringComponents = function(mainType, opt) {
        var indexKey = mainType + "Index";
        var idKey = mainType + "Id";
        return (0, $76d619f648247e6d$export$dc741340f7e5f186)(this.ecModel, mainType, {
            index: this.get(indexKey, true),
            id: this.get(idKey, true)
        }, opt);
    };
    ComponentModel.prototype.getBoxLayoutParams = function() {
        // Consider itself having box layout configs.
        // For backward compatibility, by default do not `ignoreParent`.
        return $93b9bc7f22ac7369$export$22344244a123da8(this, false);
    };
    /**
   * Get key for zlevel.
   * If developers don't configure zlevel. We will assign zlevel to series based on the key.
   * For example, lines with trail effect and progressive series will in an individual zlevel.
   */ ComponentModel.prototype.getZLevelKey = function() {
        return "";
    };
    ComponentModel.prototype.setZLevel = function(zlevel) {
        this.option.zlevel = zlevel;
    };
    ComponentModel.protoInitialize = function() {
        var proto = ComponentModel.prototype;
        proto.type = "component";
        proto.id = "";
        proto.name = "";
        proto.mainType = "";
        proto.subType = "";
        proto.componentIndex = 0;
    }();
    return ComponentModel;
}((0, $6818646a97528290$export$2e2bcd8739ae039));
(0, $cd5f95cf03b4e3e7$export$c9c2d87774f1275d)($116d65051f61bdfe$var$ComponentModel, (0, $6818646a97528290$export$2e2bcd8739ae039));
(0, $cd5f95cf03b4e3e7$export$241315e45585454d)($116d65051f61bdfe$var$ComponentModel);
$5370df662b2caf37$export$b9faf30b7d655a6f($116d65051f61bdfe$var$ComponentModel);
$5370df662b2caf37$export$ce592d345a3ec040($116d65051f61bdfe$var$ComponentModel, $116d65051f61bdfe$var$getDependencies);
function $116d65051f61bdfe$var$getDependencies(componentType) {
    var deps = [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43($116d65051f61bdfe$var$ComponentModel.getClassesByMainType(componentType), function(clz) {
        deps = deps.concat(clz.dependencies || clz.prototype.dependencies || []);
    });
    // Ensure main type.
    deps = $7a1bd9c2710fea0d$export$871de8747c9eaa88(deps, function(type) {
        return (0, $cd5f95cf03b4e3e7$export$fbe18865d303bf01)(type).main;
    });
    // Hack dataset for convenience.
    if (componentType !== "dataset" && $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(deps, "dataset") <= 0) deps.unshift("dataset");
    return deps;
}
var $116d65051f61bdfe$export$2e2bcd8739ae039 = $116d65051f61bdfe$var$ComponentModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $02653a4b1be313bf$var$tokens = {
    color: {},
    darkColor: {},
    size: {}
};
var $02653a4b1be313bf$var$color = $02653a4b1be313bf$var$tokens.color = {
    theme: [
        "#5070dd",
        "#b6d634",
        "#505372",
        "#ff994d",
        "#0ca8df",
        "#ffd10a",
        "#fb628b",
        "#785db0",
        "#3fbe95"
    ],
    neutral00: "#fff",
    neutral05: "#f4f7fd",
    neutral10: "#e8ebf0",
    neutral15: "#dbdee4",
    neutral20: "#cfd2d7",
    neutral25: "#c3c5cb",
    neutral30: "#b7b9be",
    neutral35: "#aaacb2",
    neutral40: "#9ea0a5",
    neutral45: "#929399",
    neutral50: "#86878c",
    neutral55: "#797b7f",
    neutral60: "#6d6e73",
    neutral65: "#616266",
    neutral70: "#54555a",
    neutral75: "#48494d",
    neutral80: "#3c3c41",
    neutral85: "#303034",
    neutral90: "#232328",
    neutral95: "#17171b",
    neutral99: "#000",
    accent05: "#eff1f9",
    accent10: "#e0e4f2",
    accent15: "#d0d6ec",
    accent20: "#c0c9e6",
    accent25: "#b1bbdf",
    accent30: "#a1aed9",
    accent35: "#91a0d3",
    accent40: "#8292cc",
    accent45: "#7285c6",
    accent50: "#6578ba",
    accent55: "#5c6da9",
    accent60: "#536298",
    accent65: "#4a5787",
    accent70: "#404c76",
    accent75: "#374165",
    accent80: "#2e3654",
    accent85: "#252b43",
    accent90: "#1b2032",
    accent95: "#121521",
    transparent: "rgba(0,0,0,0)",
    highlight: "rgba(255,231,130,0.8)"
};
(0, $7a1bd9c2710fea0d$export$8b58be045bf06082)($02653a4b1be313bf$var$color, {
    primary: $02653a4b1be313bf$var$color.neutral80,
    secondary: $02653a4b1be313bf$var$color.neutral70,
    tertiary: $02653a4b1be313bf$var$color.neutral60,
    quaternary: $02653a4b1be313bf$var$color.neutral50,
    disabled: $02653a4b1be313bf$var$color.neutral20,
    border: $02653a4b1be313bf$var$color.neutral30,
    borderTint: $02653a4b1be313bf$var$color.neutral20,
    borderShade: $02653a4b1be313bf$var$color.neutral40,
    background: $02653a4b1be313bf$var$color.neutral05,
    backgroundTint: "rgba(234,237,245,0.5)",
    backgroundTransparent: "rgba(255,255,255,0)",
    backgroundShade: $02653a4b1be313bf$var$color.neutral10,
    shadow: "rgba(0,0,0,0.2)",
    shadowTint: "rgba(129,130,136,0.2)",
    axisLine: $02653a4b1be313bf$var$color.neutral70,
    axisLineTint: $02653a4b1be313bf$var$color.neutral40,
    axisTick: $02653a4b1be313bf$var$color.neutral70,
    axisTickMinor: $02653a4b1be313bf$var$color.neutral60,
    axisLabel: $02653a4b1be313bf$var$color.neutral70,
    axisSplitLine: $02653a4b1be313bf$var$color.neutral15,
    axisMinorSplitLine: $02653a4b1be313bf$var$color.neutral05
});
for(var $02653a4b1be313bf$var$key in $02653a4b1be313bf$var$color)if ($02653a4b1be313bf$var$color.hasOwnProperty($02653a4b1be313bf$var$key)) {
    var $02653a4b1be313bf$var$hex = $02653a4b1be313bf$var$color[$02653a4b1be313bf$var$key];
    if ($02653a4b1be313bf$var$key === "theme") // Don't modify theme colors.
    $02653a4b1be313bf$var$tokens.darkColor.theme = $02653a4b1be313bf$var$color.theme.slice();
    else if ($02653a4b1be313bf$var$key === "highlight") $02653a4b1be313bf$var$tokens.darkColor.highlight = "rgba(255,231,130,0.4)";
    else if ($02653a4b1be313bf$var$key.indexOf("accent") === 0) // Desaturate and lighten accent colors.
    $02653a4b1be313bf$var$tokens.darkColor[$02653a4b1be313bf$var$key] = (0, $2c037f5bda6341ca$export$d898ae866e27bf18)($02653a4b1be313bf$var$hex, null, function(s) {
        return s * 0.5;
    }, function(l) {
        return Math.min(1, 1.3 - l);
    });
    else $02653a4b1be313bf$var$tokens.darkColor[$02653a4b1be313bf$var$key] = (0, $2c037f5bda6341ca$export$d898ae866e27bf18)($02653a4b1be313bf$var$hex, null, function(s) {
        return s * 0.9;
    }, function(l) {
        return 1 - Math.pow(l, 1.5);
    });
}
$02653a4b1be313bf$var$tokens.size = {
    xxs: 2,
    xs: 5,
    s: 10,
    m: 15,
    l: 20,
    xl: 30,
    xxl: 40,
    xxxl: 50
};
var $02653a4b1be313bf$export$2e2bcd8739ae039 = $02653a4b1be313bf$var$tokens;


var $2d7ac35b3b3d57e3$var$platform = "";
// Navigator not exists in node
if (typeof navigator !== "undefined") /* global navigator */ $2d7ac35b3b3d57e3$var$platform = navigator.platform || "";
var $2d7ac35b3b3d57e3$var$decalColor = "rgba(0, 0, 0, 0.2)";
var $2d7ac35b3b3d57e3$var$themeColor = (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.theme[0];
var $2d7ac35b3b3d57e3$var$lightThemeColor = (0, $2c037f5bda6341ca$export$d898ae866e27bf18)($2d7ac35b3b3d57e3$var$themeColor, null, null, 0.9);
var $2d7ac35b3b3d57e3$export$2e2bcd8739ae039 = {
    darkMode: "auto",
    // backgroundColor: 'rgba(0,0,0,0)',
    colorBy: "series",
    color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.theme,
    gradientColor: [
        $2d7ac35b3b3d57e3$var$lightThemeColor,
        $2d7ac35b3b3d57e3$var$themeColor
    ],
    aria: {
        decal: {
            decals: [
                {
                    color: $2d7ac35b3b3d57e3$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        2,
                        5
                    ],
                    symbolSize: 1,
                    rotation: Math.PI / 6
                },
                {
                    color: $2d7ac35b3b3d57e3$var$decalColor,
                    symbol: "circle",
                    dashArrayX: [
                        [
                            8,
                            8
                        ],
                        [
                            0,
                            8,
                            8,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ],
                    symbolSize: 0.8
                },
                {
                    color: $2d7ac35b3b3d57e3$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        4,
                        3
                    ],
                    rotation: -Math.PI / 4
                },
                {
                    color: $2d7ac35b3b3d57e3$var$decalColor,
                    dashArrayX: [
                        [
                            6,
                            6
                        ],
                        [
                            0,
                            6,
                            6,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ]
                },
                {
                    color: $2d7ac35b3b3d57e3$var$decalColor,
                    dashArrayX: [
                        [
                            1,
                            0
                        ],
                        [
                            1,
                            6
                        ]
                    ],
                    dashArrayY: [
                        1,
                        0,
                        6,
                        0
                    ],
                    rotation: Math.PI / 4
                },
                {
                    color: $2d7ac35b3b3d57e3$var$decalColor,
                    symbol: "triangle",
                    dashArrayX: [
                        [
                            9,
                            9
                        ],
                        [
                            0,
                            9,
                            9,
                            0
                        ]
                    ],
                    dashArrayY: [
                        7,
                        2
                    ],
                    symbolSize: 0.75
                }
            ]
        }
    },
    // If xAxis and yAxis declared, grid is created by default.
    // grid: {},
    textStyle: {
        // color: '#000',
        // decoration: 'none',
        // PENDING
        fontFamily: $2d7ac35b3b3d57e3$var$platform.match(/^Win/) ? "Microsoft YaHei" : "sans-serif",
        // fontFamily: 'Arial, Verdana, sans-serif',
        fontSize: 12,
        fontStyle: "normal",
        fontWeight: "normal"
    },
    // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
    // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
    // Default is source-over
    blendMode: null,
    stateAnimation: {
        duration: 300,
        easing: "cubicOut"
    },
    animation: "auto",
    animationDuration: 1000,
    animationDurationUpdate: 500,
    animationEasing: "cubicInOut",
    animationEasingUpdate: "cubicInOut",
    animationThreshold: 2000,
    // Configuration for progressive/incremental rendering
    progressiveThreshold: 3000,
    progressive: 400,
    // Threshold of if use single hover layer to optimize.
    // It is recommended that `hoverLayerThreshold` is equivalent to or less than
    // `progressiveThreshold`, otherwise hover will cause restart of progressive,
    // which is unexpected.
    // see example <echarts/test/heatmap-large.html>.
    hoverLayerThreshold: 3000,
    // See: module:echarts/scale/Time
    useUTC: false
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $cab29724515ce2b8$export$cd51b5ca77f6f0e4 = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)([
    "tooltip",
    "label",
    "itemName",
    "itemId",
    "itemGroupId",
    "itemChildGroupId",
    "seriesName"
]);
var $cab29724515ce2b8$export$2823037fb9d8f0c6 = "original";
var $cab29724515ce2b8$export$fcd62ebf51387903 = "arrayRows";
var $cab29724515ce2b8$export$703ae8a2d83f441 = "objectRows";
var $cab29724515ce2b8$export$6a32b42c754a3cb8 = "keyedColumns";
var $cab29724515ce2b8$export$a918cb016a382d45 = "typedArray";
var $cab29724515ce2b8$export$c78f1330778d30d = "unknown";
var $cab29724515ce2b8$export$7b3f3c6551b4949b = "column";
var $cab29724515ce2b8$export$d55da1467cdf7804 = "row";


var $7dc6cdfd7450ef29$export$328749e9c5b40760 = {
    Must: 1,
    Might: 2,
    Not: 3 // Other cases
};
var $7dc6cdfd7450ef29$var$innerGlobalModel = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $7dc6cdfd7450ef29$export$b30cdea50aa00e6(ecModel) {
    // `datasetMap` is used to make default encode.
    $7dc6cdfd7450ef29$var$innerGlobalModel(ecModel).datasetMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
}
function $7dc6cdfd7450ef29$export$37682b8fdd2e83d(coordDimensions, seriesModel, source) {
    var encode = {};
    var datasetModel = $7dc6cdfd7450ef29$export$8da66f73a1eda454(seriesModel);
    // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel || !coordDimensions) return encode;
    var encodeItemName = [];
    var encodeSeriesName = [];
    var ecModel = seriesModel.ecModel;
    var datasetMap = $7dc6cdfd7450ef29$var$innerGlobalModel(ecModel).datasetMap;
    var key = datasetModel.uid + "_" + source.seriesLayoutBy;
    var baseCategoryDimIndex;
    var categoryWayValueDimStart;
    coordDimensions = coordDimensions.slice();
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordDimensions, function(coordDimInfoLoose, coordDimIdx) {
        var coordDimInfo = (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(coordDimInfoLoose) ? coordDimInfoLoose : coordDimensions[coordDimIdx] = {
            name: coordDimInfoLoose
        };
        if (coordDimInfo.type === "ordinal" && baseCategoryDimIndex == null) {
            baseCategoryDimIndex = coordDimIdx;
            categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimInfo);
        }
        encode[coordDimInfo.name] = [];
    });
    var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
        categoryWayDim: categoryWayValueDimStart,
        valueWayDim: 0
    });
    // TODO
    // Auto detect first time axis and do arrangement.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordDimensions, function(coordDimInfo, coordDimIdx) {
        var coordDimName = coordDimInfo.name;
        var count = getDataDimCountOnCoordDim(coordDimInfo);
        // In value way.
        if (baseCategoryDimIndex == null) {
            var start = datasetRecord.valueWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.valueWayDim += count;
        // ??? TODO give a better default series name rule?
        // especially when encode x y specified.
        // consider: when multiple series share one dimension
        // category axis, series name should better use
        // the other dimension name. On the other hand, use
        // both dimensions name.
        } else if (baseCategoryDimIndex === coordDimIdx) {
            pushDim(encode[coordDimName], 0, count);
            pushDim(encodeItemName, 0, count);
        } else {
            var start = datasetRecord.categoryWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.categoryWayDim += count;
        }
    });
    function pushDim(dimIdxArr, idxFrom, idxCount) {
        for(var i = 0; i < idxCount; i++)dimIdxArr.push(idxFrom + i);
    }
    function getDataDimCountOnCoordDim(coordDimInfo) {
        var dimsDef = coordDimInfo.dimsDef;
        return dimsDef ? dimsDef.length : 1;
    }
    encodeItemName.length && (encode.itemName = encodeItemName);
    encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
    return encode;
}
function $7dc6cdfd7450ef29$export$60b8a57d1f2fed26(seriesModel, source, dimCount) {
    var encode = {};
    var datasetModel = $7dc6cdfd7450ef29$export$8da66f73a1eda454(seriesModel);
    // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel) return encode;
    var sourceFormat = source.sourceFormat;
    var dimensionsDefine = source.dimensionsDefine;
    var potentialNameDimIndex;
    if (sourceFormat === (0, $cab29724515ce2b8$export$703ae8a2d83f441) || sourceFormat === (0, $cab29724515ce2b8$export$6a32b42c754a3cb8)) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dimensionsDefine, function(dim, idx) {
        if (((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dim) ? dim.name : dim) === "name") potentialNameDimIndex = idx;
    });
    var idxResult = function() {
        var idxRes0 = {};
        var idxRes1 = {};
        var guessRecords = [];
        // 5 is an experience value.
        for(var i = 0, len = Math.min(5, dimCount); i < len; i++){
            var guessResult = $7dc6cdfd7450ef29$var$doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
            guessRecords.push(guessResult);
            var isPureNumber = guessResult === $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
            // [Strategy of idxRes0]: find the first BE_ORDINAL.Not as the value dim,
            // and then find a name dim with the priority:
            // "BE_ORDINAL.Might|BE_ORDINAL.Must" > "other dim" > "the value dim itself".
            if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) idxRes0.v = i;
            if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === $7dc6cdfd7450ef29$export$328749e9c5b40760.Not) idxRes0.n = i;
            if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== $7dc6cdfd7450ef29$export$328749e9c5b40760.Not) return idxRes0;
            // [Strategy of idxRes1]: if idxRes0 not satisfied (that is, no BE_ORDINAL.Not),
            // find the first BE_ORDINAL.Might as the value dim,
            // and then find a name dim with the priority:
            // "other dim" > "the value dim itself".
            // That is for backward compat: number-like (e.g., `'3'`, `'55'`) can be
            // treated as number.
            if (!isPureNumber) {
                if (guessResult === $7dc6cdfd7450ef29$export$328749e9c5b40760.Might && idxRes1.v == null && i !== potentialNameDimIndex) idxRes1.v = i;
                if (idxRes1.n == null || idxRes1.n === idxRes1.v) idxRes1.n = i;
            }
        }
        function fulfilled(idxResult) {
            return idxResult.v != null && idxResult.n != null;
        }
        return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
    }();
    if (idxResult) {
        encode.value = [
            idxResult.v
        ];
        // `potentialNameDimIndex` has highest priority.
        var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n;
        // By default, label uses itemName in charts.
        // So we don't set encodeLabel here.
        encode.itemName = [
            nameDimIndex
        ];
        encode.seriesName = [
            nameDimIndex
        ];
    }
    return encode;
}
function $7dc6cdfd7450ef29$export$8da66f73a1eda454(seriesModel) {
    // Caution: consider the scenario:
    // A dataset is declared and a series is not expected to use the dataset,
    // and at the beginning `setOption({series: { noData })` (just prepare other
    // option but no data), then `setOption({series: {data: [...]}); In this case,
    // the user should set an empty array to avoid that dataset is used by default.
    var thisData = seriesModel.get("data", true);
    if (!thisData) return (0, $76d619f648247e6d$export$dc741340f7e5f186)(seriesModel.ecModel, "dataset", {
        index: seriesModel.get("datasetIndex", true),
        id: seriesModel.get("datasetId", true)
    }, (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
}
function $7dc6cdfd7450ef29$export$397ba553479711e7(datasetModel) {
    // Only these attributes declared, we by default reference to `datasetIndex: 0`.
    // Otherwise, no reference.
    if (!datasetModel.get("transform", true) && !datasetModel.get("fromTransformResult", true)) return [];
    return (0, $76d619f648247e6d$export$dc741340f7e5f186)(datasetModel.ecModel, "dataset", {
        index: datasetModel.get("fromDatasetIndex", true),
        id: datasetModel.get("fromDatasetId", true)
    }, (0, $76d619f648247e6d$export$f076738ec84e693c)).models;
}
function $7dc6cdfd7450ef29$export$c51adf1a2be01b9c(source, dimIndex) {
    return $7dc6cdfd7450ef29$var$doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
}
// dimIndex may be overflow source data.
// return {BE_ORDINAL}
function $7dc6cdfd7450ef29$var$doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
    var result;
    // Experience value.
    var maxLoop = 5;
    if ((0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(data)) return $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
    // When sourceType is 'objectRows' or 'keyedColumns', dimensionsDefine
    // always exists in source.
    var dimName;
    var dimType;
    if (dimensionsDefine) {
        var dimDefItem = dimensionsDefine[dimIndex];
        if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dimDefItem)) {
            dimName = dimDefItem.name;
            dimType = dimDefItem.type;
        } else if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(dimDefItem)) dimName = dimDefItem;
    }
    if (dimType != null) return dimType === "ordinal" ? $7dc6cdfd7450ef29$export$328749e9c5b40760.Must : $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
    if (sourceFormat === (0, $cab29724515ce2b8$export$fcd62ebf51387903)) {
        var dataArrayRows = data;
        if (seriesLayoutBy === (0, $cab29724515ce2b8$export$d55da1467cdf7804)) {
            var sample = dataArrayRows[dimIndex];
            for(var i = 0; i < (sample || []).length && i < maxLoop; i++){
                if ((result = detectValue(sample[startIndex + i])) != null) return result;
            }
        } else for(var i = 0; i < dataArrayRows.length && i < maxLoop; i++){
            var row = dataArrayRows[startIndex + i];
            if (row && (result = detectValue(row[dimIndex])) != null) return result;
        }
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$703ae8a2d83f441)) {
        var dataObjectRows = data;
        if (!dimName) return $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
        for(var i = 0; i < dataObjectRows.length && i < maxLoop; i++){
            var item = dataObjectRows[i];
            if (item && (result = detectValue(item[dimName])) != null) return result;
        }
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$6a32b42c754a3cb8)) {
        var dataKeyedColumns = data;
        if (!dimName) return $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
        var sample = dataKeyedColumns[dimName];
        if (!sample || (0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(sample)) return $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
        for(var i = 0; i < sample.length && i < maxLoop; i++){
            if ((result = detectValue(sample[i])) != null) return result;
        }
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6)) {
        var dataOriginal = data;
        for(var i = 0; i < dataOriginal.length && i < maxLoop; i++){
            var item = dataOriginal[i];
            var val = (0, $76d619f648247e6d$export$2c944e12edb48d4b)(item);
            if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(val)) return $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
            if ((result = detectValue(val[dimIndex])) != null) return result;
        }
    }
    function detectValue(val) {
        var beStr = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(val);
        // Consider usage convenience, '1', '2' will be treated as "number".
        // `Number('')` (or any whitespace) is `0`.
        if (val != null && Number.isFinite(Number(val)) && val !== "") return beStr ? $7dc6cdfd7450ef29$export$328749e9c5b40760.Might : $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
        else if (beStr && val !== "-") return $7dc6cdfd7450ef29$export$328749e9c5b40760.Must;
    }
    return $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $a625fe571efb4064$var$internalOptionCreatorMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
function $a625fe571efb4064$export$5a90be4668898d38(mainType, creator) {
    (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)($a625fe571efb4064$var$internalOptionCreatorMap.get(mainType) == null && creator);
    $a625fe571efb4064$var$internalOptionCreatorMap.set(mainType, creator);
}
function $a625fe571efb4064$export$c713a6a3b43f401d(ecModel, mainType, newCmptOptionList) {
    var internalOptionCreator = $a625fe571efb4064$var$internalOptionCreatorMap.get(mainType);
    if (!internalOptionCreator) return newCmptOptionList;
    var internalOptions = internalOptionCreator(ecModel);
    if (!internalOptions) return newCmptOptionList;
    var i;
    return newCmptOptionList.concat(internalOptions);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $e7fbd47751ca3c28$var$innerColor = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $e7fbd47751ca3c28$var$innerDecal = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $e7fbd47751ca3c28$export$55a3c39e852b90f4 = /** @class */ function() {
    function PaletteMixin() {}
    PaletteMixin.prototype.getColorFromPalette = function(name, scope, requestNum) {
        var defaultPalette = (0, $76d619f648247e6d$export$4f07b212a02c8051)(this.get("color", true));
        var layeredPalette = this.get("colorLayer", true);
        return $e7fbd47751ca3c28$var$getFromPalette(this, $e7fbd47751ca3c28$var$innerColor, defaultPalette, layeredPalette, name, scope, requestNum);
    };
    PaletteMixin.prototype.clearColorPalette = function() {
        $e7fbd47751ca3c28$var$clearPalette(this, $e7fbd47751ca3c28$var$innerColor);
    };
    return PaletteMixin;
}();
function $e7fbd47751ca3c28$export$e4d892222945a227(ecModel, name, scope, requestNum) {
    var defaultDecals = (0, $76d619f648247e6d$export$4f07b212a02c8051)(ecModel.get([
        "aria",
        "decal",
        "decals"
    ]));
    return $e7fbd47751ca3c28$var$getFromPalette(ecModel, $e7fbd47751ca3c28$var$innerDecal, defaultDecals, null, name, scope, requestNum);
}
function $e7fbd47751ca3c28$var$getNearestPalette(palettes, requestColorNum) {
    var paletteNum = palettes.length;
    // TODO palettes must be in order
    for(var i = 0; i < paletteNum; i++){
        if (palettes[i].length > requestColorNum) return palettes[i];
    }
    return palettes[paletteNum - 1];
}
/**
 * @param name MUST NOT be null/undefined. Otherwise call this function
 *             twise with the same parameters will get different result.
 * @param scope default this.
 * @return Can be null/undefined
 */ function $e7fbd47751ca3c28$var$getFromPalette(that, inner, defaultPalette, layeredPalette, name, scope, requestNum) {
    scope = scope || that;
    var scopeFields = inner(scope);
    var paletteIdx = scopeFields.paletteIdx || 0;
    var paletteNameMap = scopeFields.paletteNameMap = scopeFields.paletteNameMap || {};
    // Use `hasOwnProperty` to avoid conflict with Object.prototype.
    if (paletteNameMap.hasOwnProperty(name)) return paletteNameMap[name];
    var palette = requestNum == null || !layeredPalette ? defaultPalette : $e7fbd47751ca3c28$var$getNearestPalette(layeredPalette, requestNum);
    // In case can't find in layered color palette.
    palette = palette || defaultPalette;
    if (!palette || !palette.length) return;
    var pickedPaletteItem = palette[paletteIdx];
    if (name) paletteNameMap[name] = pickedPaletteItem;
    scopeFields.paletteIdx = (paletteIdx + 1) % palette.length;
    return pickedPaletteItem;
}
function $e7fbd47751ca3c28$var$clearPalette(that, inner) {
    inner(that).paletteIdx = 0;
    inner(that).paletteNameMap = {};
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $84bc7667c27ccedc$var$ECHARTS_PREFIX = "[ECharts] ";
var $84bc7667c27ccedc$var$storedLogs = {};
var $84bc7667c27ccedc$var$hasConsole = typeof console !== "undefined" && console.warn && console.log;
function $84bc7667c27ccedc$var$outputLog(type, str, onlyOnce) {
    if ($84bc7667c27ccedc$var$hasConsole) {
        if (onlyOnce) {
            if ($84bc7667c27ccedc$var$storedLogs[str]) return;
            $84bc7667c27ccedc$var$storedLogs[str] = true;
        }
        // eslint-disable-next-line
        console[type]($84bc7667c27ccedc$var$ECHARTS_PREFIX + str);
    }
}
function $84bc7667c27ccedc$export$bef1f36f5486a6a3(str, onlyOnce) {
    $84bc7667c27ccedc$var$outputLog("log", str, onlyOnce);
}
function $84bc7667c27ccedc$export$c106dd0671a0fc2d(str, onlyOnce) {
    $84bc7667c27ccedc$var$outputLog("warn", str, onlyOnce);
}
function $84bc7667c27ccedc$export$a3bc9b8ed74fc(str, onlyOnce) {
    $84bc7667c27ccedc$var$outputLog("error", str, onlyOnce);
}
function $84bc7667c27ccedc$export$4a9c0b74eb885aa1(str) {}
function $84bc7667c27ccedc$export$bbd91d66002c4ea6(oldOpt, newOpt, scope) {}
function $84bc7667c27ccedc$export$a68bb8b222a6bd43() {
    var hintInfo = [];
    for(var _i = 0; _i < arguments.length; _i++)hintInfo[_i] = arguments[_i];
    var msg = "";
    var makePrintableStringIfPossible_1;
    return msg;
}
function $84bc7667c27ccedc$export$8bf7aba4a9e09055(msg) {
    throw new Error(msg);
}


// -----------------------
// Internal method names:
// -----------------------
var $51f6ef0dd9546916$var$reCreateSeriesIndices;
var $51f6ef0dd9546916$var$assertSeriesInitialized;
var $51f6ef0dd9546916$var$initBase;
var $51f6ef0dd9546916$var$OPTION_INNER_KEY = "\x00_ec_inner";
var $51f6ef0dd9546916$var$OPTION_INNER_VALUE = 1;
var $51f6ef0dd9546916$var$BUITIN_COMPONENTS_MAP = {
    grid: "GridComponent",
    polar: "PolarComponent",
    geo: "GeoComponent",
    singleAxis: "SingleAxisComponent",
    parallel: "ParallelComponent",
    calendar: "CalendarComponent",
    matrix: "MatrixComponent",
    graphic: "GraphicComponent",
    toolbox: "ToolboxComponent",
    tooltip: "TooltipComponent",
    axisPointer: "AxisPointerComponent",
    brush: "BrushComponent",
    title: "TitleComponent",
    timeline: "TimelineComponent",
    markPoint: "MarkPointComponent",
    markLine: "MarkLineComponent",
    markArea: "MarkAreaComponent",
    legend: "LegendComponent",
    dataZoom: "DataZoomComponent",
    visualMap: "VisualMapComponent",
    // aria: 'AriaComponent',
    // dataset: 'DatasetComponent',
    // Dependencies
    xAxis: "GridComponent",
    yAxis: "GridComponent",
    angleAxis: "PolarComponent",
    radiusAxis: "PolarComponent"
};
var $51f6ef0dd9546916$var$BUILTIN_CHARTS_MAP = {
    line: "LineChart",
    bar: "BarChart",
    pie: "PieChart",
    scatter: "ScatterChart",
    radar: "RadarChart",
    map: "MapChart",
    tree: "TreeChart",
    treemap: "TreemapChart",
    graph: "GraphChart",
    chord: "ChordChart",
    gauge: "GaugeChart",
    funnel: "FunnelChart",
    parallel: "ParallelChart",
    sankey: "SankeyChart",
    boxplot: "BoxplotChart",
    candlestick: "CandlestickChart",
    effectScatter: "EffectScatterChart",
    lines: "LinesChart",
    heatmap: "HeatmapChart",
    pictorialBar: "PictorialBarChart",
    themeRiver: "ThemeRiverChart",
    sunburst: "SunburstChart",
    custom: "CustomChart"
};
var $51f6ef0dd9546916$var$componetsMissingLogPrinted = {};
function $51f6ef0dd9546916$var$checkMissingComponents(option) {
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(option, function(componentOption, mainType) {
        if (!(0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(mainType)) {
            var componentImportName = $51f6ef0dd9546916$var$BUITIN_COMPONENTS_MAP[mainType];
            if (componentImportName && !$51f6ef0dd9546916$var$componetsMissingLogPrinted[componentImportName]) {
                (0, $84bc7667c27ccedc$export$a3bc9b8ed74fc)("Component " + mainType + " is used but not imported.\nimport { " + componentImportName + " } from 'echarts/components';\necharts.use([" + componentImportName + "]);");
                $51f6ef0dd9546916$var$componetsMissingLogPrinted[componentImportName] = true;
            }
        }
    });
}
var $51f6ef0dd9546916$var$GlobalModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GlobalModel, _super);
    function GlobalModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GlobalModel.prototype.init = function(option, parentModel, ecModel, theme, locale, optionManager) {
        theme = theme || {};
        this.option = null; // Mark as not initialized.
        this._theme = new (0, $6818646a97528290$export$2e2bcd8739ae039)(theme);
        this._locale = new (0, $6818646a97528290$export$2e2bcd8739ae039)(locale);
        this._optionManager = optionManager;
    };
    GlobalModel.prototype.setOption = function(option, opts, optionPreprocessorFuncs) {
        var innerOpt = $51f6ef0dd9546916$var$normalizeSetOptionInput(opts);
        this._optionManager.setOption(option, optionPreprocessorFuncs, innerOpt);
        this._resetOption(null, innerOpt);
    };
    /**
   * @param type null/undefined: reset all.
   *        'recreate': force recreate all.
   *        'timeline': only reset timeline option
   *        'media': only reset media query option
   * @return Whether option changed.
   */ GlobalModel.prototype.resetOption = function(type, opt) {
        return this._resetOption(type, $51f6ef0dd9546916$var$normalizeSetOptionInput(opt));
    };
    GlobalModel.prototype._resetOption = function(type, opt) {
        var optionChanged = false;
        var optionManager = this._optionManager;
        if (!type || type === "recreate") {
            var baseOption = optionManager.mountOption(type === "recreate");
            if (!this.option || type === "recreate") $51f6ef0dd9546916$var$initBase(this, baseOption);
            else {
                this.restoreData();
                this._mergeOption(baseOption, opt);
            }
            optionChanged = true;
        }
        if (type === "timeline" || type === "media") this.restoreData();
        // By design, if `setOption(option2)` at the second time, and `option2` is a `ECUnitOption`,
        // it should better not have the same props with `MediaUnit['option']`.
        // Because either `option2` or `MediaUnit['option']` will be always merged to "current option"
        // rather than original "baseOption". If they both override a prop, the result might be
        // unexpected when media state changed after `setOption` called.
        // If we really need to modify a props in each `MediaUnit['option']`, use the full version
        // (`{baseOption, media}`) in `setOption`.
        // For `timeline`, the case is the same.
        if (!type || type === "recreate" || type === "timeline") {
            var timelineOption = optionManager.getTimelineOption(this);
            if (timelineOption) {
                optionChanged = true;
                this._mergeOption(timelineOption, opt);
            }
        }
        if (!type || type === "recreate" || type === "media") {
            var mediaOptions = optionManager.getMediaOption(this);
            if (mediaOptions.length) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mediaOptions, function(mediaOption) {
                optionChanged = true;
                this._mergeOption(mediaOption, opt);
            }, this);
        }
        return optionChanged;
    };
    GlobalModel.prototype.mergeOption = function(option) {
        this._mergeOption(option, null);
    };
    GlobalModel.prototype._mergeOption = function(newOption, opt) {
        var option = this.option;
        var componentsMap = this._componentsMap;
        var componentsCount = this._componentsCount;
        var newCmptTypes = [];
        var newCmptTypeMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        var replaceMergeMainTypeMap = opt && opt.replaceMergeMainTypeMap;
        (0, $7dc6cdfd7450ef29$export$b30cdea50aa00e6)(this);
        // If no component class, merge directly.
        // For example: color, animaiton options, etc.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newOption, function(componentOption, mainType) {
            if (componentOption == null) return;
            if (!(0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(mainType)) // globalSettingTask.dirty();
            option[mainType] = option[mainType] == null ? (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(componentOption) : (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(option[mainType], componentOption, true);
            else if (mainType) {
                newCmptTypes.push(mainType);
                newCmptTypeMap.set(mainType, true);
            }
        });
        if (replaceMergeMainTypeMap) // If there is a mainType `xxx` in `replaceMerge` but not declared in option,
        // we trade it as it is declared in option as `{xxx: []}`. Because:
        // (1) for normal merge, `{xxx: null/undefined}` are the same meaning as `{xxx: []}`.
        // (2) some preprocessor may convert some of `{xxx: null/undefined}` to `{xxx: []}`.
        replaceMergeMainTypeMap.each(function(val, mainTypeInReplaceMerge) {
            if ((0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(mainTypeInReplaceMerge) && !newCmptTypeMap.get(mainTypeInReplaceMerge)) {
                newCmptTypes.push(mainTypeInReplaceMerge);
                newCmptTypeMap.set(mainTypeInReplaceMerge, true);
            }
        });
        (0, $116d65051f61bdfe$export$2e2bcd8739ae039).topologicalTravel(newCmptTypes, (0, $116d65051f61bdfe$export$2e2bcd8739ae039).getAllClassMainTypes(), visitComponent, this);
        function visitComponent(mainType) {
            var newCmptOptionList = (0, $a625fe571efb4064$export$c713a6a3b43f401d)(this, mainType, $76d619f648247e6d$export$4f07b212a02c8051(newOption[mainType]));
            var oldCmptList = componentsMap.get(mainType);
            var mergeMode = // `!oldCmptList` means init. See the comment in `mappingToExists`
            !oldCmptList ? "replaceAll" : replaceMergeMainTypeMap && replaceMergeMainTypeMap.get(mainType) ? "replaceMerge" : "normalMerge";
            var mappingResult = $76d619f648247e6d$export$574f818966e4da87(oldCmptList, newCmptOptionList, mergeMode);
            // Set mainType and complete subType.
            $76d619f648247e6d$export$5ac61aca2ba0282d(mappingResult, mainType, (0, $116d65051f61bdfe$export$2e2bcd8739ae039));
            // Empty it before the travel, in order to prevent `this._componentsMap`
            // from being used in the `init`/`mergeOption`/`optionUpdated` of some
            // components, which is probably incorrect logic.
            option[mainType] = null;
            componentsMap.set(mainType, null);
            componentsCount.set(mainType, 0);
            var optionsByMainType = [];
            var cmptsByMainType = [];
            var cmptsCountByMainType = 0;
            var tooltipExists;
            var tooltipWarningLogged;
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mappingResult, function(resultItem, index) {
                var componentModel = resultItem.existing;
                var newCmptOption = resultItem.newOption;
                if (!newCmptOption) {
                    if (componentModel) {
                        // Consider where is no new option and should be merged using {},
                        // see removeEdgeAndAdd in topologicalTravel and
                        // ComponentModel.getAllClassMainTypes.
                        componentModel.mergeOption({}, this);
                        componentModel.optionUpdated({}, false);
                    }
                } else {
                    var isSeriesType = mainType === "series";
                    var ComponentModelClass = (0, $116d65051f61bdfe$export$2e2bcd8739ae039).getClass(mainType, resultItem.keyInfo.subType, !isSeriesType // Give a more detailed warn later if series don't exists
                    );
                    if (!ComponentModelClass) {
                        var subType, seriesImportName;
                        return;
                    }
                    // TODO Before multiple tooltips get supported, we do this check to avoid unexpected exception.
                    if (mainType === "tooltip") {
                        if (tooltipExists) return;
                        tooltipExists = true;
                    }
                    if (componentModel && componentModel.constructor === ComponentModelClass) {
                        componentModel.name = resultItem.keyInfo.name;
                        // componentModel.settingTask && componentModel.settingTask.dirty();
                        componentModel.mergeOption(newCmptOption, this);
                        componentModel.optionUpdated(newCmptOption, false);
                    } else {
                        // PENDING Global as parent ?
                        var extraOpt = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
                            componentIndex: index
                        }, resultItem.keyInfo);
                        componentModel = new ComponentModelClass(newCmptOption, this, this, extraOpt);
                        // Assign `keyInfo`
                        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(componentModel, extraOpt);
                        if (resultItem.brandNew) componentModel.__requireNewView = true;
                        componentModel.init(newCmptOption, this, this);
                        // Call optionUpdated after init.
                        // newCmptOption has been used as componentModel.option
                        // and may be merged with theme and default, so pass null
                        // to avoid confusion.
                        componentModel.optionUpdated(null, true);
                    }
                }
                if (componentModel) {
                    optionsByMainType.push(componentModel.option);
                    cmptsByMainType.push(componentModel);
                    cmptsCountByMainType++;
                } else {
                    // Always do assign to avoid elided item in array.
                    optionsByMainType.push(void 0);
                    cmptsByMainType.push(void 0);
                }
            }, this);
            option[mainType] = optionsByMainType;
            componentsMap.set(mainType, cmptsByMainType);
            componentsCount.set(mainType, cmptsCountByMainType);
            // Backup series for filtering.
            if (mainType === "series") $51f6ef0dd9546916$var$reCreateSeriesIndices(this);
        }
        // If no series declared, ensure `_seriesIndices` initialized.
        if (!this._seriesIndices) $51f6ef0dd9546916$var$reCreateSeriesIndices(this);
    };
    /**
   * Get option for output (cloned option and inner info removed)
   */ GlobalModel.prototype.getOption = function() {
        var option = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(this.option);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(option, function(optInMainType, mainType) {
            if ((0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(mainType)) {
                var opts = $76d619f648247e6d$export$4f07b212a02c8051(optInMainType);
                // Inner cmpts need to be removed.
                // Inner cmpts might not be at last since ec5.0, but still
                // compatible for users: if inner cmpt at last, splice the returned array.
                var realLen = opts.length;
                var metNonInner = false;
                for(var i = realLen - 1; i >= 0; i--)// Remove options with inner id.
                if (opts[i] && !$76d619f648247e6d$export$feece3e7d52a102b(opts[i])) metNonInner = true;
                else {
                    opts[i] = null;
                    !metNonInner && realLen--;
                }
                opts.length = realLen;
                option[mainType] = opts;
            }
        });
        delete option[$51f6ef0dd9546916$var$OPTION_INNER_KEY];
        return option;
    };
    GlobalModel.prototype.setTheme = function(theme) {
        this._theme = new (0, $6818646a97528290$export$2e2bcd8739ae039)(theme);
        this._resetOption("recreate", null);
    };
    GlobalModel.prototype.getTheme = function() {
        return this._theme;
    };
    GlobalModel.prototype.getLocaleModel = function() {
        return this._locale;
    };
    GlobalModel.prototype.setUpdatePayload = function(payload) {
        this._payload = payload;
    };
    GlobalModel.prototype.getUpdatePayload = function() {
        return this._payload;
    };
    /**
   * @param idx If not specified, return the first one.
   */ GlobalModel.prototype.getComponent = function(mainType, idx) {
        var list = this._componentsMap.get(mainType);
        if (list) {
            var cmpt = list[idx || 0];
            if (cmpt) return cmpt;
            else if (idx == null) for(var i = 0; i < list.length; i++){
                if (list[i]) return list[i];
            }
        }
    };
    /**
   * @return Never be null/undefined.
   */ GlobalModel.prototype.queryComponents = function(condition) {
        var mainType = condition.mainType;
        if (!mainType) return [];
        var index = condition.index;
        var id = condition.id;
        var name = condition.name;
        var cmpts = this._componentsMap.get(mainType);
        if (!cmpts || !cmpts.length) return [];
        var result;
        if (index != null) {
            result = [];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($76d619f648247e6d$export$4f07b212a02c8051(index), function(idx) {
                cmpts[idx] && result.push(cmpts[idx]);
            });
        } else if (id != null) result = $51f6ef0dd9546916$var$queryByIdOrName("id", id, cmpts);
        else if (name != null) result = $51f6ef0dd9546916$var$queryByIdOrName("name", name, cmpts);
        else // Return all non-empty components in that mainType
        result = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return !!cmpt;
        });
        return $51f6ef0dd9546916$var$filterBySubType(result, condition);
    };
    /**
   * The interface is different from queryComponents,
   * which is convenient for inner usage.
   *
   * @usage
   * let result = findComponents(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series',
   *     filter: function (model, index) {...}}
   * );
   * // result like [component0, componnet1, ...]
   */ GlobalModel.prototype.findComponents = function(condition) {
        var query = condition.query;
        var mainType = condition.mainType;
        var queryCond = getQueryCond(query);
        var result = queryCond ? this.queryComponents(queryCond) : (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(this._componentsMap.get(mainType), function(cmpt) {
            return !!cmpt;
        });
        return doFilter($51f6ef0dd9546916$var$filterBySubType(result, condition));
        function getQueryCond(q) {
            var indexAttr = mainType + "Index";
            var idAttr = mainType + "Id";
            var nameAttr = mainType + "Name";
            return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
                mainType: mainType,
                // subType will be filtered finally.
                index: q[indexAttr],
                id: q[idAttr],
                name: q[nameAttr]
            } : null;
        }
        function doFilter(res) {
            return condition.filter ? (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(res, condition.filter) : res;
        }
    };
    GlobalModel.prototype.eachComponent = function(mainType, cb, context) {
        var componentsMap = this._componentsMap;
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(mainType)) {
            var ctxForAll_1 = cb;
            var cbForAll_1 = mainType;
            componentsMap.each(function(cmpts, componentType) {
                for(var i = 0; cmpts && i < cmpts.length; i++){
                    var cmpt = cmpts[i];
                    cmpt && cbForAll_1.call(ctxForAll_1, componentType, cmpt, cmpt.componentIndex);
                }
            });
        } else {
            var cmpts = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(mainType) ? componentsMap.get(mainType) : (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(mainType) ? this.findComponents(mainType) : null;
            for(var i = 0; cmpts && i < cmpts.length; i++){
                var cmpt = cmpts[i];
                cmpt && cb.call(context, cmpt, cmpt.componentIndex);
            }
        }
    };
    /**
   * Get series list before filtered by name.
   */ GlobalModel.prototype.getSeriesByName = function(name) {
        var nameStr = $76d619f648247e6d$export$fb1a222ba5dd6e51(name, null);
        return (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(this._componentsMap.get("series"), function(oneSeries) {
            return !!oneSeries && nameStr != null && oneSeries.name === nameStr;
        });
    };
    /**
   * Get series list before filtered by index.
   */ GlobalModel.prototype.getSeriesByIndex = function(seriesIndex) {
        return this._componentsMap.get("series")[seriesIndex];
    };
    /**
   * Get series list before filtered by type.
   * FIXME: rename to getRawSeriesByType?
   */ GlobalModel.prototype.getSeriesByType = function(subType) {
        return (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(this._componentsMap.get("series"), function(oneSeries) {
            return !!oneSeries && oneSeries.subType === subType;
        });
    };
    /**
   * Get all series before filtered.
   */ GlobalModel.prototype.getSeries = function() {
        return (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(this._componentsMap.get("series"), function(oneSeries) {
            return !!oneSeries;
        });
    };
    /**
   * Count series before filtered.
   */ GlobalModel.prototype.getSeriesCount = function() {
        return this._componentsCount.get("series");
    };
    /**
   * After filtering, series may be different
   * from raw series.
   */ GlobalModel.prototype.eachSeries = function(cb, context) {
        $51f6ef0dd9546916$var$assertSeriesInitialized(this);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get("series")[rawSeriesIndex];
            cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered.
   *
   * @param {Function} cb
   * @param {*} context
   */ GlobalModel.prototype.eachRawSeries = function(cb, context) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._componentsMap.get("series"), function(series) {
            series && cb.call(context, series, series.componentIndex);
        });
    };
    /**
   * After filtering, series may be different.
   * from raw series.
   */ GlobalModel.prototype.eachSeriesByType = function(subType, cb, context) {
        $51f6ef0dd9546916$var$assertSeriesInitialized(this);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get("series")[rawSeriesIndex];
            if (series.subType === subType) cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered of given type.
   */ GlobalModel.prototype.eachRawSeriesByType = function(subType, cb, context) {
        return (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this.getSeriesByType(subType), cb, context);
    };
    GlobalModel.prototype.isSeriesFiltered = function(seriesModel) {
        $51f6ef0dd9546916$var$assertSeriesInitialized(this);
        return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
    };
    GlobalModel.prototype.getCurrentSeriesIndices = function() {
        return (this._seriesIndices || []).slice();
    };
    GlobalModel.prototype.filterSeries = function(cb, context) {
        $51f6ef0dd9546916$var$assertSeriesInitialized(this);
        var newSeriesIndices = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._seriesIndices, function(seriesRawIdx) {
            var series = this._componentsMap.get("series")[seriesRawIdx];
            cb.call(context, series, seriesRawIdx) && newSeriesIndices.push(seriesRawIdx);
        }, this);
        this._seriesIndices = newSeriesIndices;
        this._seriesIndicesMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)(newSeriesIndices);
    };
    GlobalModel.prototype.restoreData = function(payload) {
        $51f6ef0dd9546916$var$reCreateSeriesIndices(this);
        var componentsMap = this._componentsMap;
        var componentTypes = [];
        componentsMap.each(function(components, componentType) {
            if ((0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(componentType)) componentTypes.push(componentType);
        });
        (0, $116d65051f61bdfe$export$2e2bcd8739ae039).topologicalTravel(componentTypes, (0, $116d65051f61bdfe$export$2e2bcd8739ae039).getAllClassMainTypes(), function(componentType) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(componentsMap.get(componentType), function(component) {
                if (component && (componentType !== "series" || !$51f6ef0dd9546916$var$isNotTargetSeries(component, payload))) component.restoreData();
            });
        });
    };
    GlobalModel.internalField = function() {
        $51f6ef0dd9546916$var$reCreateSeriesIndices = function(ecModel) {
            var seriesIndices = ecModel._seriesIndices = [];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ecModel._componentsMap.get("series"), function(series) {
                // series may have been removed by `replaceMerge`.
                series && seriesIndices.push(series.componentIndex);
            });
            ecModel._seriesIndicesMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)(seriesIndices);
        };
        $51f6ef0dd9546916$var$assertSeriesInitialized = function(ecModel) {};
        $51f6ef0dd9546916$var$initBase = function(ecModel, baseOption) {
            // Using OPTION_INNER_KEY to mark that this option cannot be used outside,
            // i.e. `chart.setOption(chart.getModel().option);` is forbidden.
            ecModel.option = {};
            ecModel.option[$51f6ef0dd9546916$var$OPTION_INNER_KEY] = $51f6ef0dd9546916$var$OPTION_INNER_VALUE;
            // Init with series: [], in case of calling findSeries method
            // before series initialized.
            ecModel._componentsMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)({
                series: []
            });
            ecModel._componentsCount = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
            // If user spefied `option.aria`, aria will be enable. This detection should be
            // performed before theme and globalDefault merge.
            var airaOption = baseOption.aria;
            if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(airaOption) && airaOption.enabled == null) airaOption.enabled = true;
            $51f6ef0dd9546916$var$mergeTheme(baseOption, ecModel._theme.option);
            // TODO Needs clone when merging to the unexisted property
            (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(baseOption, (0, $2d7ac35b3b3d57e3$export$2e2bcd8739ae039), false);
            ecModel._mergeOption(baseOption, null);
        };
    }();
    return GlobalModel;
}((0, $6818646a97528290$export$2e2bcd8739ae039));
function $51f6ef0dd9546916$var$isNotTargetSeries(seriesModel, payload) {
    if (payload) {
        var index = payload.seriesIndex;
        var id = payload.seriesId;
        var name_1 = payload.seriesName;
        return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name_1 != null && seriesModel.name !== name_1;
    }
}
function $51f6ef0dd9546916$var$mergeTheme(option, theme) {
    // PENDING
    // NOT use `colorLayer` in theme if option has `color`
    var notMergeColorLayer = option.color && !option.colorLayer;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(theme, function(themeItem, name) {
        if (name === "colorLayer" && notMergeColorLayer || name === "color" && option.color) return;
        // If it is component model mainType, the model handles that merge later.
        // otherwise, merge them here.
        if (!(0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(name)) {
            if (typeof themeItem === "object") option[name] = !option[name] ? (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(themeItem) : (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(option[name], themeItem, false);
            else if (option[name] == null) option[name] = themeItem;
        }
    });
}
function $51f6ef0dd9546916$var$queryByIdOrName(attr, idOrName, cmpts) {
    // Here is a break from echarts4: string and number are
    // treated as equal.
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(idOrName)) {
        var keyMap_1 = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(idOrName, function(idOrNameItem) {
            if (idOrNameItem != null) {
                var idName = $76d619f648247e6d$export$fb1a222ba5dd6e51(idOrNameItem, null);
                idName != null && keyMap_1.set(idOrNameItem, true);
            }
        });
        return (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return cmpt && keyMap_1.get(cmpt[attr]);
        });
    } else {
        var idName_1 = $76d619f648247e6d$export$fb1a222ba5dd6e51(idOrName, null);
        return (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return cmpt && idName_1 != null && cmpt[attr] === idName_1;
        });
    }
}
function $51f6ef0dd9546916$var$filterBySubType(components, condition) {
    // Using hasOwnProperty for restrict. Consider
    // subType is undefined in user payload.
    return condition.hasOwnProperty("subType") ? (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(components, function(cmpt) {
        return cmpt && cmpt.subType === condition.subType;
    }) : components;
}
function $51f6ef0dd9546916$var$normalizeSetOptionInput(opts) {
    var replaceMergeMainTypeMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    opts && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($76d619f648247e6d$export$4f07b212a02c8051(opts.replaceMerge), function(mainType) {
        replaceMergeMainTypeMap.set(mainType, true);
    });
    return {
        replaceMergeMainTypeMap: replaceMergeMainTypeMap
    };
}
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($51f6ef0dd9546916$var$GlobalModel, (0, $e7fbd47751ca3c28$export$55a3c39e852b90f4));
var $51f6ef0dd9546916$export$2e2bcd8739ae039 = $51f6ef0dd9546916$var$GlobalModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $a6d7e6163195660e$var$availableMethods = [
    "getDom",
    "getZr",
    "getWidth",
    "getHeight",
    "getDevicePixelRatio",
    "dispatchAction",
    "isSSR",
    "isDisposed",
    "on",
    "off",
    "getDataURL",
    "getConnectedDataURL",
    // 'getModel',
    "getOption",
    // 'getViewOfComponentModel',
    // 'getViewOfSeriesModel',
    "getId",
    "updateLabelLayout"
];
var $a6d7e6163195660e$var$ExtensionAPI = /** @class */ function() {
    function ExtensionAPI(ecInstance) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($a6d7e6163195660e$var$availableMethods, function(methodName) {
            this[methodName] = $7a1bd9c2710fea0d$export$2385a24977818dd0(ecInstance[methodName], ecInstance);
        }, this);
    }
    return ExtensionAPI;
}();
var $a6d7e6163195660e$export$2e2bcd8739ae039 = $a6d7e6163195660e$var$ExtensionAPI;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $bf4c0a9077b4e970$var$QUERY_REG = /^(min|max)?(.+)$/;
// Key: mainType
// type FakeComponentsMap = HashMap<(MappingExistingItem & { subType: string })[]>;
/**
 * TERM EXPLANATIONS:
 * See `ECOption` and `ECUnitOption` in `src/util/types.ts`.
 */ var $bf4c0a9077b4e970$var$OptionManager = /** @class */ function() {
    // timeline.notMerge is not supported in ec3. Firstly there is rearly
    // case that notMerge is needed. Secondly supporting 'notMerge' requires
    // rawOption cloned and backuped when timeline changed, which does no
    // good to performance. What's more, that both timeline and setOption
    // method supply 'notMerge' brings complex and some problems.
    // Consider this case:
    // (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
    // (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);
    function OptionManager(api) {
        this._timelineOptions = [];
        this._mediaList = [];
        /**
     * -1, means default.
     * empty means no media.
     */ this._currentMediaIndices = [];
        this._api = api;
    }
    OptionManager.prototype.setOption = function(rawOption, optionPreprocessorFuncs, opt) {
        if (rawOption) {
            // That set dat primitive is dangerous if user reuse the data when setOption again.
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(rawOption.series), function(series) {
                series && series.data && (0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(series.data) && (0, $7a1bd9c2710fea0d$export$112e66431016387b)(series.data);
            });
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(rawOption.dataset), function(dataset) {
                dataset && dataset.source && (0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(dataset.source) && (0, $7a1bd9c2710fea0d$export$112e66431016387b)(dataset.source);
            });
        }
        // Caution: some series modify option data, if do not clone,
        // it should ensure that the repeat modify correctly
        // (create a new object when modify itself).
        rawOption = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(rawOption);
        // FIXME
        // If some property is set in timeline options or media option but
        // not set in baseOption, a warning should be given.
        var optionBackup = this._optionBackup;
        var newParsedOption = $bf4c0a9077b4e970$var$parseRawOption(rawOption, optionPreprocessorFuncs, !optionBackup);
        this._newBaseOption = newParsedOption.baseOption;
        // For setOption at second time (using merge mode);
        if (optionBackup) {
            // FIXME
            // the restore merge solution is essentially incorrect.
            // the mapping can not be 100% consistent with ecModel, which probably brings
            // potential bug!
            // The first merge is delayed, because in most cases, users do not call `setOption` twice.
            // let fakeCmptsMap = this._fakeCmptsMap;
            // if (!fakeCmptsMap) {
            //     fakeCmptsMap = this._fakeCmptsMap = createHashMap();
            //     mergeToBackupOption(fakeCmptsMap, null, optionBackup.baseOption, null);
            // }
            // mergeToBackupOption(
            //     fakeCmptsMap, optionBackup.baseOption, newParsedOption.baseOption, opt
            // );
            // For simplicity, timeline options and media options do not support merge,
            // that is, if you `setOption` twice and both has timeline options, the latter
            // timeline options will not be merged to the former, but just substitute them.
            if (newParsedOption.timelineOptions.length) optionBackup.timelineOptions = newParsedOption.timelineOptions;
            if (newParsedOption.mediaList.length) optionBackup.mediaList = newParsedOption.mediaList;
            if (newParsedOption.mediaDefault) optionBackup.mediaDefault = newParsedOption.mediaDefault;
        } else this._optionBackup = newParsedOption;
    };
    OptionManager.prototype.mountOption = function(isRecreate) {
        var optionBackup = this._optionBackup;
        this._timelineOptions = optionBackup.timelineOptions;
        this._mediaList = optionBackup.mediaList;
        this._mediaDefault = optionBackup.mediaDefault;
        this._currentMediaIndices = [];
        return (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(isRecreate ? optionBackup.baseOption : this._newBaseOption);
    };
    OptionManager.prototype.getTimelineOption = function(ecModel) {
        var option;
        var timelineOptions = this._timelineOptions;
        if (timelineOptions.length) {
            // getTimelineOption can only be called after ecModel inited,
            // so we can get currentIndex from timelineModel.
            var timelineModel = ecModel.getComponent("timeline");
            if (timelineModel) option = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(// FIXME:TS as TimelineModel or quivlant interface
            timelineOptions[timelineModel.getCurrentIndex()]);
        }
        return option;
    };
    OptionManager.prototype.getMediaOption = function(ecModel) {
        var ecWidth = this._api.getWidth();
        var ecHeight = this._api.getHeight();
        var mediaList = this._mediaList;
        var mediaDefault = this._mediaDefault;
        var indices = [];
        var result = [];
        // No media defined.
        if (!mediaList.length && !mediaDefault) return result;
        // Multi media may be applied, the latter defined media has higher priority.
        for(var i = 0, len = mediaList.length; i < len; i++)if ($bf4c0a9077b4e970$var$applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) indices.push(i);
        // FIXME
        // Whether mediaDefault should force users to provide? Otherwise
        // the change by media query can not be recorvered.
        if (!indices.length && mediaDefault) indices = [
            -1
        ];
        if (indices.length && !$bf4c0a9077b4e970$var$indicesEquals(indices, this._currentMediaIndices)) result = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(indices, function(index) {
            return (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(index === -1 ? mediaDefault.option : mediaList[index].option);
        });
        // Otherwise return nothing.
        this._currentMediaIndices = indices;
        return result;
    };
    return OptionManager;
}();
/**
 * [RAW_OPTION_PATTERNS]
 * (Note: "series: []" represents all other props in `ECUnitOption`)
 *
 * (1) No prop "baseOption" declared:
 * Root option is used as "baseOption" (except prop "options" and "media").
 * ```js
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 * };
 * option = {
 *     series: [],
 *     media: {},
 * };
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 *     media: {},
 * }
 * ```
 *
 * (2) Prop "baseOption" declared:
 * If "baseOption" declared, `ECUnitOption` props can only be declared
 * inside "baseOption" except prop "timeline" (compat ec2).
 * ```js
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 * };
 * option = {
 *     baseOption: {
 *         series: [],
 *     },
 *     media: []
 * };
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 *     media: []
 * };
 * option = {
 *     // ec3 compat ec2: allow (only) `timeline` declared
 *     // outside baseOption. Keep this setting for compat.
 *     timeline: {},
 *     baseOption: {
 *         series: [],
 *     },
 *     options: [],
 *     media: []
 * };
 * ```
 */ function $bf4c0a9077b4e970$var$parseRawOption(// `rawOption` May be modified
rawOption, optionPreprocessorFuncs, isNew) {
    var mediaList = [];
    var mediaDefault;
    var baseOption;
    var declaredBaseOption = rawOption.baseOption;
    // Compatible with ec2, [RAW_OPTION_PATTERNS] above.
    var timelineOnRoot = rawOption.timeline;
    var timelineOptionsOnRoot = rawOption.options;
    var mediaOnRoot = rawOption.media;
    var hasMedia = !!rawOption.media;
    var hasTimeline = !!(timelineOptionsOnRoot || timelineOnRoot || declaredBaseOption && declaredBaseOption.timeline);
    if (declaredBaseOption) {
        baseOption = declaredBaseOption;
        // For merge option.
        if (!baseOption.timeline) baseOption.timeline = timelineOnRoot;
    } else {
        if (hasTimeline || hasMedia) rawOption.options = rawOption.media = null;
        baseOption = rawOption;
    }
    if (hasMedia) {
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(mediaOnRoot)) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mediaOnRoot, function(singleMedia) {
            if (singleMedia && singleMedia.option) {
                if (singleMedia.query) mediaList.push(singleMedia);
                else if (!mediaDefault) // Use the first media default.
                mediaDefault = singleMedia;
            }
        });
    }
    doPreprocess(baseOption);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(timelineOptionsOnRoot, function(option) {
        return doPreprocess(option);
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mediaList, function(media) {
        return doPreprocess(media.option);
    });
    function doPreprocess(option) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(optionPreprocessorFuncs, function(preProcess) {
            preProcess(option, isNew);
        });
    }
    return {
        baseOption: baseOption,
        timelineOptions: timelineOptionsOnRoot || [],
        mediaDefault: mediaDefault,
        mediaList: mediaList
    };
}
/**
 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
 * Support: width, height, aspectRatio
 * Can use max or min as prefix.
 */ function $bf4c0a9077b4e970$var$applyMediaQuery(query, ecWidth, ecHeight) {
    var realMap = {
        width: ecWidth,
        height: ecHeight,
        aspectratio: ecWidth / ecHeight // lower case for convenience.
    };
    var applicable = true;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(query, function(value, attr) {
        var matched = attr.match($bf4c0a9077b4e970$var$QUERY_REG);
        if (!matched || !matched[1] || !matched[2]) return;
        var operator = matched[1];
        var realAttr = matched[2].toLowerCase();
        if (!$bf4c0a9077b4e970$var$compare(realMap[realAttr], value, operator)) applicable = false;
    });
    return applicable;
}
function $bf4c0a9077b4e970$var$compare(real, expect, operator) {
    if (operator === "min") return real >= expect;
    else if (operator === "max") return real <= expect;
    else // Equals
    return real === expect;
}
function $bf4c0a9077b4e970$var$indicesEquals(indices1, indices2) {
    // indices is always order by asc and has only finite number.
    return indices1.join(",") === indices2.join(",");
}
var /**
 * Consider case:
 * `chart.setOption(opt1);`
 * Then user do some interaction like dataZoom, dataView changing.
 * `chart.setOption(opt2);`
 * Then user press 'reset button' in toolbox.
 *
 * After doing that all of the interaction effects should be reset, the
 * chart should be the same as the result of invoke
 * `chart.setOption(opt1); chart.setOption(opt2);`.
 *
 * Although it is not able ensure that
 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
 * `chart.setOption(merge(opt1, opt2));` exactly,
 * this might be the only simple way to implement that feature.
 *
 * MEMO: We've considered some other approaches:
 * 1. Each model handles its self restoration but not uniform treatment.
 *     (Too complex in logic and error-prone)
 * 2. Use a shadow ecModel. (Performance expensive)
 *
 * FIXME: A possible solution:
 * Add a extra level of model for each component model. The inheritance chain would be:
 * ecModel <- componentModel <- componentActionModel <- dataItemModel
 * And all of the actions can only modify the `componentActionModel` rather than
 * `componentModel`. `setOption` will only modify the `ecModel` and `componentModel`.
 * When "resotre" action triggered, model from `componentActionModel` will be discarded
 * instead of recreating the "ecModel" from the "_optionBackup".
 */ // function mergeToBackupOption(
//     fakeCmptsMap: FakeComponentsMap,
//     // `tarOption` Can be null/undefined, means init
//     tarOption: ECUnitOption,
//     newOption: ECUnitOption,
//     // Can be null/undefined
//     opt: InnerSetOptionOpts
// ): void {
//     newOption = newOption || {} as ECUnitOption;
//     const notInit = !!tarOption;
//     each(newOption, function (newOptsInMainType, mainType) {
//         if (newOptsInMainType == null) {
//             return;
//         }
//         if (!ComponentModel.hasClass(mainType)) {
//             if (tarOption) {
//                 tarOption[mainType] = merge(tarOption[mainType], newOptsInMainType, true);
//             }
//         }
//         else {
//             const oldTarOptsInMainType = notInit ? normalizeToArray(tarOption[mainType]) : null;
//             const oldFakeCmptsInMainType = fakeCmptsMap.get(mainType) || [];
//             const resultTarOptsInMainType = notInit ? (tarOption[mainType] = [] as ComponentOption[]) : null;
//             const resultFakeCmptsInMainType = fakeCmptsMap.set(mainType, []);
//             const mappingResult = mappingToExists(
//                 oldFakeCmptsInMainType,
//                 normalizeToArray(newOptsInMainType),
//                 (opt && opt.replaceMergeMainTypeMap.get(mainType)) ? 'replaceMerge' : 'normalMerge'
//             );
//             setComponentTypeToKeyInfo(mappingResult, mainType, ComponentModel as ComponentModelConstructor);
//             each(mappingResult, function (resultItem, index) {
//                 // The same logic as `Global.ts#_mergeOption`.
//                 let fakeCmpt = resultItem.existing;
//                 const newOption = resultItem.newOption;
//                 const keyInfo = resultItem.keyInfo;
//                 let fakeCmptOpt;
//                 if (!newOption) {
//                     fakeCmptOpt = oldTarOptsInMainType[index];
//                 }
//                 else {
//                     if (fakeCmpt && fakeCmpt.subType === keyInfo.subType) {
//                         fakeCmpt.name = keyInfo.name;
//                         if (notInit) {
//                             fakeCmptOpt = merge(oldTarOptsInMainType[index], newOption, true);
//                         }
//                     }
//                     else {
//                         fakeCmpt = extend({}, keyInfo);
//                         if (notInit) {
//                             fakeCmptOpt = clone(newOption);
//                         }
//                     }
//                 }
//                 if (fakeCmpt) {
//                     notInit && resultTarOptsInMainType.push(fakeCmptOpt);
//                     resultFakeCmptsInMainType.push(fakeCmpt);
//                 }
//                 else {
//                     notInit && resultTarOptsInMainType.push(void 0);
//                     resultFakeCmptsInMainType.push(void 0);
//                 }
//             });
//         }
//     });
// }
$bf4c0a9077b4e970$export$2e2bcd8739ae039 = $bf4c0a9077b4e970$var$OptionManager;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $621cc5e1b758ea39$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $621cc5e1b758ea39$var$isObject = $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a;
var $621cc5e1b758ea39$var$POSSIBLE_STYLES = [
    "areaStyle",
    "lineStyle",
    "nodeStyle",
    "linkStyle",
    "chordStyle",
    "label",
    "labelLine"
];
function $621cc5e1b758ea39$var$compatEC2ItemStyle(opt) {
    var itemStyleOpt = opt && opt.itemStyle;
    if (!itemStyleOpt) return;
    for(var i = 0, len = $621cc5e1b758ea39$var$POSSIBLE_STYLES.length; i < len; i++){
        var styleName = $621cc5e1b758ea39$var$POSSIBLE_STYLES[i];
        var normalItemStyleOpt = itemStyleOpt.normal;
        var emphasisItemStyleOpt = itemStyleOpt.emphasis;
        if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].normal) opt[styleName].normal = normalItemStyleOpt[styleName];
            else $7a1bd9c2710fea0d$export$4950aa0f605343fb(opt[styleName].normal, normalItemStyleOpt[styleName]);
            normalItemStyleOpt[styleName] = null;
        }
        if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].emphasis) opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
            else $7a1bd9c2710fea0d$export$4950aa0f605343fb(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
            emphasisItemStyleOpt[styleName] = null;
        }
    }
}
function $621cc5e1b758ea39$var$convertNormalEmphasis(opt, optType, useExtend) {
    if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
        var normalOpt = opt[optType].normal;
        var emphasisOpt = opt[optType].emphasis;
        if (normalOpt) {
            // Timeline controlStyle has other properties besides normal and emphasis
            if (useExtend) {
                opt[optType].normal = opt[optType].emphasis = null;
                $7a1bd9c2710fea0d$export$ebe90cb607ad99e(opt[optType], normalOpt);
            } else opt[optType] = normalOpt;
        }
        if (emphasisOpt) {
            opt.emphasis = opt.emphasis || {};
            opt.emphasis[optType] = emphasisOpt;
            // Also compat the case user mix the style and focus together in ec3 style
            // for example: { itemStyle: { normal: {}, emphasis: {focus, shadowBlur} } }
            if (emphasisOpt.focus) opt.emphasis.focus = emphasisOpt.focus;
            if (emphasisOpt.blurScope) opt.emphasis.blurScope = emphasisOpt.blurScope;
        }
    }
}
function $621cc5e1b758ea39$var$removeEC3NormalStatus(opt) {
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, "itemStyle");
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, "lineStyle");
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, "areaStyle");
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, "label");
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, "labelLine");
    // treemap
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, "upperLabel");
    // graph
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, "edgeLabel");
}
function $621cc5e1b758ea39$var$compatTextStyle(opt, propName) {
    // Check whether is not object (string\null\undefined ...)
    var labelOptSingle = $621cc5e1b758ea39$var$isObject(opt) && opt[propName];
    var textStyle = $621cc5e1b758ea39$var$isObject(labelOptSingle) && labelOptSingle.textStyle;
    if (textStyle) for(var i = 0, len = $76d619f648247e6d$export$df45610347a602ad.length; i < len; i++){
        var textPropName = $76d619f648247e6d$export$df45610347a602ad[i];
        if (textStyle.hasOwnProperty(textPropName)) labelOptSingle[textPropName] = textStyle[textPropName];
    }
}
function $621cc5e1b758ea39$var$compatEC3CommonStyles(opt) {
    if (opt) {
        $621cc5e1b758ea39$var$removeEC3NormalStatus(opt);
        $621cc5e1b758ea39$var$compatTextStyle(opt, "label");
        opt.emphasis && $621cc5e1b758ea39$var$compatTextStyle(opt.emphasis, "label");
    }
}
function $621cc5e1b758ea39$var$processSeries(seriesOpt) {
    if (!$621cc5e1b758ea39$var$isObject(seriesOpt)) return;
    $621cc5e1b758ea39$var$compatEC2ItemStyle(seriesOpt);
    $621cc5e1b758ea39$var$removeEC3NormalStatus(seriesOpt);
    $621cc5e1b758ea39$var$compatTextStyle(seriesOpt, "label");
    // treemap
    $621cc5e1b758ea39$var$compatTextStyle(seriesOpt, "upperLabel");
    // graph
    $621cc5e1b758ea39$var$compatTextStyle(seriesOpt, "edgeLabel");
    if (seriesOpt.emphasis) {
        $621cc5e1b758ea39$var$compatTextStyle(seriesOpt.emphasis, "label");
        // treemap
        $621cc5e1b758ea39$var$compatTextStyle(seriesOpt.emphasis, "upperLabel");
        // graph
        $621cc5e1b758ea39$var$compatTextStyle(seriesOpt.emphasis, "edgeLabel");
    }
    var markPoint = seriesOpt.markPoint;
    if (markPoint) {
        $621cc5e1b758ea39$var$compatEC2ItemStyle(markPoint);
        $621cc5e1b758ea39$var$compatEC3CommonStyles(markPoint);
    }
    var markLine = seriesOpt.markLine;
    if (markLine) {
        $621cc5e1b758ea39$var$compatEC2ItemStyle(markLine);
        $621cc5e1b758ea39$var$compatEC3CommonStyles(markLine);
    }
    var markArea = seriesOpt.markArea;
    if (markArea) $621cc5e1b758ea39$var$compatEC3CommonStyles(markArea);
    var data = seriesOpt.data;
    // Break with ec3: if `setOption` again, there may be no `type` in option,
    // then the backward compat based on option type will not be performed.
    if (seriesOpt.type === "graph") {
        data = data || seriesOpt.nodes;
        var edgeData = seriesOpt.links || seriesOpt.edges;
        if (edgeData && !$7a1bd9c2710fea0d$export$b119cc7e1840e59c(edgeData)) for(var i = 0; i < edgeData.length; i++)$621cc5e1b758ea39$var$compatEC3CommonStyles(edgeData[i]);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(seriesOpt.categories, function(opt) {
            $621cc5e1b758ea39$var$removeEC3NormalStatus(opt);
        });
    }
    if (data && !$7a1bd9c2710fea0d$export$b119cc7e1840e59c(data)) for(var i = 0; i < data.length; i++)$621cc5e1b758ea39$var$compatEC3CommonStyles(data[i]);
    // mark point data
    markPoint = seriesOpt.markPoint;
    if (markPoint && markPoint.data) {
        var mpData = markPoint.data;
        for(var i = 0; i < mpData.length; i++)$621cc5e1b758ea39$var$compatEC3CommonStyles(mpData[i]);
    }
    // mark line data
    markLine = seriesOpt.markLine;
    if (markLine && markLine.data) {
        var mlData = markLine.data;
        for(var i = 0; i < mlData.length; i++)if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(mlData[i])) {
            $621cc5e1b758ea39$var$compatEC3CommonStyles(mlData[i][0]);
            $621cc5e1b758ea39$var$compatEC3CommonStyles(mlData[i][1]);
        } else $621cc5e1b758ea39$var$compatEC3CommonStyles(mlData[i]);
    }
    // Series
    if (seriesOpt.type === "gauge") {
        $621cc5e1b758ea39$var$compatTextStyle(seriesOpt, "axisLabel");
        $621cc5e1b758ea39$var$compatTextStyle(seriesOpt, "title");
        $621cc5e1b758ea39$var$compatTextStyle(seriesOpt, "detail");
    } else if (seriesOpt.type === "treemap") {
        $621cc5e1b758ea39$var$convertNormalEmphasis(seriesOpt.breadcrumb, "itemStyle");
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(seriesOpt.levels, function(opt) {
            $621cc5e1b758ea39$var$removeEC3NormalStatus(opt);
        });
    } else if (seriesOpt.type === "tree") $621cc5e1b758ea39$var$removeEC3NormalStatus(seriesOpt.leaves);
// sunburst starts from ec4, so it does not need to compat levels.
}
function $621cc5e1b758ea39$var$toArr(o) {
    return $7a1bd9c2710fea0d$export$43bee75e5e14138e(o) ? o : o ? [
        o
    ] : [];
}
function $621cc5e1b758ea39$var$toObj(o) {
    return ($7a1bd9c2710fea0d$export$43bee75e5e14138e(o) ? o[0] : o) || {};
}
function $621cc5e1b758ea39$export$2e2bcd8739ae039(option, isTheme) {
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.series), function(seriesOpt) {
        $621cc5e1b758ea39$var$isObject(seriesOpt) && $621cc5e1b758ea39$var$processSeries(seriesOpt);
    });
    var axes = [
        "xAxis",
        "yAxis",
        "radiusAxis",
        "angleAxis",
        "singleAxis",
        "parallelAxis",
        "radar"
    ];
    isTheme && axes.push("valueAxis", "categoryAxis", "logAxis", "timeAxis");
    $621cc5e1b758ea39$var$each(axes, function(axisName) {
        $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option[axisName]), function(axisOpt) {
            if (axisOpt) {
                $621cc5e1b758ea39$var$compatTextStyle(axisOpt, "axisLabel");
                $621cc5e1b758ea39$var$compatTextStyle(axisOpt.axisPointer, "label");
            }
        });
    });
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.parallel), function(parallelOpt) {
        var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
        $621cc5e1b758ea39$var$compatTextStyle(parallelAxisDefault, "axisLabel");
        $621cc5e1b758ea39$var$compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, "label");
    });
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.calendar), function(calendarOpt) {
        $621cc5e1b758ea39$var$convertNormalEmphasis(calendarOpt, "itemStyle");
        $621cc5e1b758ea39$var$compatTextStyle(calendarOpt, "dayLabel");
        $621cc5e1b758ea39$var$compatTextStyle(calendarOpt, "monthLabel");
        $621cc5e1b758ea39$var$compatTextStyle(calendarOpt, "yearLabel");
    });
    // radar.name.textStyle
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.radar), function(radarOpt) {
        $621cc5e1b758ea39$var$compatTextStyle(radarOpt, "name");
        // Use axisName instead of name because component has name property
        if (radarOpt.name && radarOpt.axisName == null) {
            radarOpt.axisName = radarOpt.name;
            delete radarOpt.name;
        }
        if (radarOpt.nameGap != null && radarOpt.axisNameGap == null) {
            radarOpt.axisNameGap = radarOpt.nameGap;
            delete radarOpt.nameGap;
        }
    });
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.geo), function(geoOpt) {
        if ($621cc5e1b758ea39$var$isObject(geoOpt)) {
            $621cc5e1b758ea39$var$compatEC3CommonStyles(geoOpt);
            $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(geoOpt.regions), function(regionObj) {
                $621cc5e1b758ea39$var$compatEC3CommonStyles(regionObj);
            });
        }
    });
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.timeline), function(timelineOpt) {
        $621cc5e1b758ea39$var$compatEC3CommonStyles(timelineOpt);
        $621cc5e1b758ea39$var$convertNormalEmphasis(timelineOpt, "label");
        $621cc5e1b758ea39$var$convertNormalEmphasis(timelineOpt, "itemStyle");
        $621cc5e1b758ea39$var$convertNormalEmphasis(timelineOpt, "controlStyle", true);
        var data = timelineOpt.data;
        $7a1bd9c2710fea0d$export$43bee75e5e14138e(data) && $7a1bd9c2710fea0d$export$79b2f7037acddd43(data, function(item) {
            if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(item)) {
                $621cc5e1b758ea39$var$convertNormalEmphasis(item, "label");
                $621cc5e1b758ea39$var$convertNormalEmphasis(item, "itemStyle");
            }
        });
    });
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.toolbox), function(toolboxOpt) {
        $621cc5e1b758ea39$var$convertNormalEmphasis(toolboxOpt, "iconStyle");
        $621cc5e1b758ea39$var$each(toolboxOpt.feature, function(featureOpt) {
            $621cc5e1b758ea39$var$convertNormalEmphasis(featureOpt, "iconStyle");
        });
    });
    $621cc5e1b758ea39$var$compatTextStyle($621cc5e1b758ea39$var$toObj(option.axisPointer), "label");
    $621cc5e1b758ea39$var$compatTextStyle($621cc5e1b758ea39$var$toObj(option.tooltip).axisPointer, "label");
// Clean logs
// storedLogs = {};
}




function $c4489ebdf95633b6$var$get(opt, path) {
    var pathArr = path.split(",");
    var obj = opt;
    for(var i = 0; i < pathArr.length; i++){
        obj = obj && obj[pathArr[i]];
        if (obj == null) break;
    }
    return obj;
}
function $c4489ebdf95633b6$var$set(opt, path, val, overwrite) {
    var pathArr = path.split(",");
    var obj = opt;
    var key;
    var i = 0;
    for(; i < pathArr.length - 1; i++){
        key = pathArr[i];
        if (obj[key] == null) obj[key] = {};
        obj = obj[key];
    }
    if (overwrite || obj[pathArr[i]] == null) obj[pathArr[i]] = val;
}
function $c4489ebdf95633b6$var$compatLayoutProperties(option) {
    option && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($c4489ebdf95633b6$var$LAYOUT_PROPERTIES, function(prop) {
        if (prop[0] in option && !(prop[1] in option)) option[prop[1]] = option[prop[0]];
    });
}
var $c4489ebdf95633b6$var$LAYOUT_PROPERTIES = [
    [
        "x",
        "left"
    ],
    [
        "y",
        "top"
    ],
    [
        "x2",
        "right"
    ],
    [
        "y2",
        "bottom"
    ]
];
var $c4489ebdf95633b6$var$COMPATITABLE_COMPONENTS = [
    "grid",
    "geo",
    "parallel",
    "legend",
    "toolbox",
    "title",
    "visualMap",
    "dataZoom",
    "timeline"
];
var $c4489ebdf95633b6$var$BAR_ITEM_STYLE_MAP = [
    [
        "borderRadius",
        "barBorderRadius"
    ],
    [
        "borderColor",
        "barBorderColor"
    ],
    [
        "borderWidth",
        "barBorderWidth"
    ]
];
function $c4489ebdf95633b6$var$compatBarItemStyle(option) {
    var itemStyle = option && option.itemStyle;
    if (itemStyle) for(var i = 0; i < $c4489ebdf95633b6$var$BAR_ITEM_STYLE_MAP.length; i++){
        var oldName = $c4489ebdf95633b6$var$BAR_ITEM_STYLE_MAP[i][1];
        var newName = $c4489ebdf95633b6$var$BAR_ITEM_STYLE_MAP[i][0];
        if (itemStyle[oldName] != null) itemStyle[newName] = itemStyle[oldName];
    }
}
function $c4489ebdf95633b6$var$compatPieLabel(option) {
    if (!option) return;
    if (option.alignTo === "edge" && option.margin != null && option.edgeDistance == null) option.edgeDistance = option.margin;
}
function $c4489ebdf95633b6$var$compatSunburstState(option) {
    if (!option) return;
    if (option.downplay && !option.blur) option.blur = option.downplay;
}
function $c4489ebdf95633b6$var$compatGraphFocus(option) {
    if (!option) return;
    if (option.focusNodeAdjacency != null) {
        option.emphasis = option.emphasis || {};
        if (option.emphasis.focus == null) option.emphasis.focus = "adjacency";
    }
}
function $c4489ebdf95633b6$var$traverseTree(data, cb) {
    if (data) for(var i = 0; i < data.length; i++){
        cb(data[i]);
        data[i] && $c4489ebdf95633b6$var$traverseTree(data[i].children, cb);
    }
}
function $c4489ebdf95633b6$export$2e2bcd8739ae039(option, isTheme) {
    (0, $621cc5e1b758ea39$export$2e2bcd8739ae039)(option, isTheme);
    // Make sure series array for model initialization.
    option.series = (0, $76d619f648247e6d$export$4f07b212a02c8051)(option.series);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(option.series, function(seriesOpt) {
        if (!(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(seriesOpt)) return;
        var seriesType = seriesOpt.type;
        if (seriesType === "line") {
            if (seriesOpt.clipOverflow != null) seriesOpt.clip = seriesOpt.clipOverflow;
        } else if (seriesType === "pie" || seriesType === "gauge") {
            if (seriesOpt.clockWise != null) seriesOpt.clockwise = seriesOpt.clockWise;
            $c4489ebdf95633b6$var$compatPieLabel(seriesOpt.label);
            var data = seriesOpt.data;
            if (data && !(0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(data)) for(var i = 0; i < data.length; i++)$c4489ebdf95633b6$var$compatPieLabel(data[i]);
            if (seriesOpt.hoverOffset != null) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                seriesOpt.emphasis.scaleSize = null;
            }
        } else if (seriesType === "gauge") {
            var pointerColor = $c4489ebdf95633b6$var$get(seriesOpt, "pointer.color");
            pointerColor != null && $c4489ebdf95633b6$var$set(seriesOpt, "itemStyle.color", pointerColor);
        } else if (seriesType === "bar") {
            $c4489ebdf95633b6$var$compatBarItemStyle(seriesOpt);
            $c4489ebdf95633b6$var$compatBarItemStyle(seriesOpt.backgroundStyle);
            $c4489ebdf95633b6$var$compatBarItemStyle(seriesOpt.emphasis);
            var data = seriesOpt.data;
            if (data && !(0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(data)) {
                for(var i = 0; i < data.length; i++)if (typeof data[i] === "object") {
                    $c4489ebdf95633b6$var$compatBarItemStyle(data[i]);
                    $c4489ebdf95633b6$var$compatBarItemStyle(data[i] && data[i].emphasis);
                }
            }
        } else if (seriesType === "sunburst") {
            var highlightPolicy = seriesOpt.highlightPolicy;
            if (highlightPolicy) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                if (!seriesOpt.emphasis.focus) seriesOpt.emphasis.focus = highlightPolicy;
            }
            $c4489ebdf95633b6$var$compatSunburstState(seriesOpt);
            $c4489ebdf95633b6$var$traverseTree(seriesOpt.data, $c4489ebdf95633b6$var$compatSunburstState);
        } else if (seriesType === "graph" || seriesType === "sankey") $c4489ebdf95633b6$var$compatGraphFocus(seriesOpt);
        else if (seriesType === "map") {
            if (seriesOpt.mapType && !seriesOpt.map) seriesOpt.map = seriesOpt.mapType;
            if (seriesOpt.mapLocation) (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(seriesOpt, seriesOpt.mapLocation);
        }
        if (seriesOpt.hoverAnimation != null) {
            seriesOpt.emphasis = seriesOpt.emphasis || {};
            if (seriesOpt.emphasis && seriesOpt.emphasis.scale == null) seriesOpt.emphasis.scale = seriesOpt.hoverAnimation;
        }
        $c4489ebdf95633b6$var$compatLayoutProperties(seriesOpt);
    });
    // dataRange has changed to visualMap
    if (option.dataRange) option.visualMap = option.dataRange;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($c4489ebdf95633b6$var$COMPATITABLE_COMPONENTS, function(componentName) {
        var options = option[componentName];
        if (options) {
            if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(options)) options = [
                options
            ];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(options, function(option) {
                $c4489ebdf95633b6$var$compatLayoutProperties(option);
            });
        }
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $92eb0b43a1e7607a$export$2e2bcd8739ae039(ecModel) {
    var stackInfoMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    ecModel.eachSeries(function(seriesModel) {
        var stack = seriesModel.get("stack");
        // Compatible: when `stack` is set as '', do not stack.
        if (stack) {
            var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
            var data = seriesModel.getData();
            var stackInfo = {
                // Used for calculate axis extent automatically.
                // TODO: Type getCalculationInfo return more specific type?
                stackResultDimension: data.getCalculationInfo("stackResultDimension"),
                stackedOverDimension: data.getCalculationInfo("stackedOverDimension"),
                stackedDimension: data.getCalculationInfo("stackedDimension"),
                stackedByDimension: data.getCalculationInfo("stackedByDimension"),
                isStackedByIndex: data.getCalculationInfo("isStackedByIndex"),
                data: data,
                seriesModel: seriesModel
            };
            // If stacked on axis that do not support data stack.
            if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) return;
            stackInfoList.push(stackInfo);
        }
    });
    // Process each stack group
    stackInfoMap.each(function(stackInfoList) {
        if (stackInfoList.length === 0) return;
        // Check if stack order needs to be reversed
        var firstSeries = stackInfoList[0].seriesModel;
        var stackOrder = firstSeries.get("stackOrder") || "seriesAsc";
        if (stackOrder === "seriesDesc") stackInfoList.reverse();
        // Set stackedOnSeries for each series in the final order
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(stackInfoList, function(stackInfo, index) {
            stackInfo.data.setCalculationInfo("stackedOnSeries", index > 0 ? stackInfoList[index - 1].seriesModel : null);
        });
        // Calculate stack values
        $92eb0b43a1e7607a$var$calculateStack(stackInfoList);
    });
}
function $92eb0b43a1e7607a$var$calculateStack(stackInfoList) {
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(stackInfoList, function(targetStackInfo, idxInStack) {
        var resultVal = [];
        var resultNaN = [
            NaN,
            NaN
        ];
        var dims = [
            targetStackInfo.stackResultDimension,
            targetStackInfo.stackedOverDimension
        ];
        var targetData = targetStackInfo.data;
        var isStackedByIndex = targetStackInfo.isStackedByIndex;
        var stackStrategy = targetStackInfo.seriesModel.get("stackStrategy") || "samesign";
        // Should not write on raw data, because stack series model list changes
        // depending on legend selection.
        targetData.modify(dims, function(v0, v1, dataIndex) {
            var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex);
            // Consider `connectNulls` of line area, if value is NaN, stackedOver
            // should also be NaN, to draw a appropriate belt area.
            if (isNaN(sum)) return resultNaN;
            var byValue;
            var stackedDataRawIndex;
            if (isStackedByIndex) stackedDataRawIndex = targetData.getRawIndex(dataIndex);
            else byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
            // If stackOver is NaN, chart view will render point on value start.
            var stackedOver = NaN;
            for(var j = idxInStack - 1; j >= 0; j--){
                var stackInfo = stackInfoList[j];
                // Has been optimized by inverted indices on `stackedByDimension`.
                if (!isStackedByIndex) stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
                if (stackedDataRawIndex >= 0) {
                    var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex);
                    // Considering positive stack, negative stack and empty data
                    if (stackStrategy === "all" // single stack group
                     || stackStrategy === "positive" && val > 0 || stackStrategy === "negative" && val < 0 || stackStrategy === "samesign" && sum >= 0 && val > 0 // All positive stack
                     || stackStrategy === "samesign" && sum <= 0 && val < 0 // All negative stack
                    ) {
                        // The sum has to be very small to be affected by the
                        // floating arithmetic problem. An incorrect result will probably
                        // cause axis min/max to be filtered incorrectly.
                        sum = (0, $cfc1f3b422a3185f$export$d3389a301c3a5706)(sum, val);
                        stackedOver = val;
                        break;
                    }
                }
            }
            resultVal[0] = sum;
            resultVal[1] = stackedOver;
            return resultVal;
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



// @inner
var $99e22f5c2aa5094b$var$SourceImpl = /** @class */ function() {
    function SourceImpl(fields) {
        this.data = fields.data || (fields.sourceFormat === (0, $cab29724515ce2b8$export$6a32b42c754a3cb8) ? {} : []);
        this.sourceFormat = fields.sourceFormat || (0, $cab29724515ce2b8$export$c78f1330778d30d);
        // Visit config
        this.seriesLayoutBy = fields.seriesLayoutBy || (0, $cab29724515ce2b8$export$7b3f3c6551b4949b);
        this.startIndex = fields.startIndex || 0;
        this.dimensionsDetectedCount = fields.dimensionsDetectedCount;
        this.metaRawOption = fields.metaRawOption;
        var dimensionsDefine = this.dimensionsDefine = fields.dimensionsDefine;
        if (dimensionsDefine) for(var i = 0; i < dimensionsDefine.length; i++){
            var dim = dimensionsDefine[i];
            if (dim.type == null) {
                if ((0, $7dc6cdfd7450ef29$export$c51adf1a2be01b9c)(this, i) === (0, $7dc6cdfd7450ef29$export$328749e9c5b40760).Must) dim.type = "ordinal";
            }
        }
    }
    return SourceImpl;
}();
function $99e22f5c2aa5094b$export$22b808bc02a60488(val) {
    return val instanceof $99e22f5c2aa5094b$var$SourceImpl;
}
function $99e22f5c2aa5094b$export$1921362e86c73c88(sourceData, thisMetaRawOption, // can be null. If not provided, auto detect it from `sourceData`.
sourceFormat) {
    sourceFormat = sourceFormat || $99e22f5c2aa5094b$export$52a469afa4653e57(sourceData);
    var seriesLayoutBy = thisMetaRawOption.seriesLayoutBy;
    var determined = $99e22f5c2aa5094b$var$determineSourceDimensions(sourceData, sourceFormat, seriesLayoutBy, thisMetaRawOption.sourceHeader, thisMetaRawOption.dimensions);
    var source = new $99e22f5c2aa5094b$var$SourceImpl({
        data: sourceData,
        sourceFormat: sourceFormat,
        seriesLayoutBy: seriesLayoutBy,
        dimensionsDefine: determined.dimensionsDefine,
        startIndex: determined.startIndex,
        dimensionsDetectedCount: determined.dimensionsDetectedCount,
        metaRawOption: (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(thisMetaRawOption)
    });
    return source;
}
function $99e22f5c2aa5094b$export$75aef3f97c0a5edf(data) {
    return new $99e22f5c2aa5094b$var$SourceImpl({
        data: data,
        sourceFormat: (0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(data) ? (0, $cab29724515ce2b8$export$a918cb016a382d45) : (0, $cab29724515ce2b8$export$2823037fb9d8f0c6)
    });
}
function $99e22f5c2aa5094b$export$e0365e7e3555ddd4(source) {
    return new $99e22f5c2aa5094b$var$SourceImpl({
        data: source.data,
        sourceFormat: source.sourceFormat,
        seriesLayoutBy: source.seriesLayoutBy,
        dimensionsDefine: (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(source.dimensionsDefine),
        startIndex: source.startIndex,
        dimensionsDetectedCount: source.dimensionsDetectedCount
    });
}
function $99e22f5c2aa5094b$export$52a469afa4653e57(data) {
    var sourceFormat = (0, $cab29724515ce2b8$export$c78f1330778d30d);
    if ((0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(data)) sourceFormat = (0, $cab29724515ce2b8$export$a918cb016a382d45);
    else if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(data)) {
        // FIXME Whether tolerate null in top level array?
        if (data.length === 0) sourceFormat = (0, $cab29724515ce2b8$export$fcd62ebf51387903);
        for(var i = 0, len = data.length; i < len; i++){
            var item = data[i];
            if (item == null) continue;
            else if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(item) || (0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(item)) {
                sourceFormat = (0, $cab29724515ce2b8$export$fcd62ebf51387903);
                break;
            } else if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(item)) {
                sourceFormat = (0, $cab29724515ce2b8$export$703ae8a2d83f441);
                break;
            }
        }
    } else if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(data)) {
        for(var key in data)if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(data, key) && (0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(data[key])) {
            sourceFormat = (0, $cab29724515ce2b8$export$6a32b42c754a3cb8);
            break;
        }
    }
    return sourceFormat;
}
/**
 * Determine the source definitions from data standalone dimensions definitions
 * are not specified.
 */ function $99e22f5c2aa5094b$var$determineSourceDimensions(data, sourceFormat, seriesLayoutBy, sourceHeader, // standalone raw dimensions definition, like:
// {
//     dimensions: ['aa', 'bb', { name: 'cc', type: 'time' }]
// }
// in `dataset` or `series`
dimensionsDefine) {
    var dimensionsDetectedCount;
    var startIndex;
    // PENDING: Could data be null/undefined here?
    // currently, if `dataset.source` not specified, error thrown.
    // if `series.data` not specified, nothing rendered without error thrown.
    // Should test these cases.
    if (!data) return {
        dimensionsDefine: $99e22f5c2aa5094b$var$normalizeDimensionsOption(dimensionsDefine),
        startIndex: startIndex,
        dimensionsDetectedCount: dimensionsDetectedCount
    };
    if (sourceFormat === (0, $cab29724515ce2b8$export$fcd62ebf51387903)) {
        var dataArrayRows = data;
        // Rule: Most of the first line are string: it is header.
        // Caution: consider a line with 5 string and 1 number,
        // it still can not be sure it is a head, because the
        // 5 string may be 5 values of category columns.
        if (sourceHeader === "auto" || sourceHeader == null) $99e22f5c2aa5094b$var$arrayRowsTravelFirst(function(val) {
            // '-' is regarded as null/undefined.
            if (val != null && val !== "-") {
                if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(val)) startIndex == null && (startIndex = 1);
                else startIndex = 0;
            }
        // 10 is an experience number, avoid long loop.
        }, seriesLayoutBy, dataArrayRows, 10);
        else startIndex = (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(sourceHeader) ? sourceHeader : sourceHeader ? 1 : 0;
        if (!dimensionsDefine && startIndex === 1) {
            dimensionsDefine = [];
            $99e22f5c2aa5094b$var$arrayRowsTravelFirst(function(val, index) {
                dimensionsDefine[index] = val != null ? val + "" : "";
            }, seriesLayoutBy, dataArrayRows, Infinity);
        }
        dimensionsDetectedCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === (0, $cab29724515ce2b8$export$d55da1467cdf7804) ? dataArrayRows.length : dataArrayRows[0] ? dataArrayRows[0].length : null;
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$703ae8a2d83f441)) {
        if (!dimensionsDefine) dimensionsDefine = $99e22f5c2aa5094b$var$objectRowsCollectDimensions(data);
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$6a32b42c754a3cb8)) {
        if (!dimensionsDefine) {
            dimensionsDefine = [];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(data, function(colArr, key) {
                dimensionsDefine.push(key);
            });
        }
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6)) {
        var value0 = (0, $76d619f648247e6d$export$2c944e12edb48d4b)(data[0]);
        dimensionsDetectedCount = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(value0) && value0.length || 1;
    }
    return {
        startIndex: startIndex,
        dimensionsDefine: $99e22f5c2aa5094b$var$normalizeDimensionsOption(dimensionsDefine),
        dimensionsDetectedCount: dimensionsDetectedCount
    };
}
function $99e22f5c2aa5094b$var$objectRowsCollectDimensions(data) {
    var firstIndex = 0;
    var obj;
    while(firstIndex < data.length && !(obj = data[firstIndex++])); // jshint ignore: line
    if (obj) return (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(obj);
}
// Consider dimensions defined like ['A', 'price', 'B', 'price', 'C', 'price'],
// which is reasonable. But dimension name is duplicated.
// Returns undefined or an array contains only object without null/undefined or string.
function $99e22f5c2aa5094b$var$normalizeDimensionsOption(dimensionsDefine) {
    if (!dimensionsDefine) // The meaning of null/undefined is different from empty array.
    return;
    var nameMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dimensionsDefine, function(rawItem, index) {
        rawItem = (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(rawItem) ? rawItem : {
            name: rawItem
        };
        // Other fields will be discarded.
        var item = {
            name: rawItem.name,
            displayName: rawItem.displayName,
            type: rawItem.type
        };
        // User can set null in dimensions.
        // We don't auto specify name, otherwise a given name may
        // cause it to be referred unexpectedly.
        if (item.name == null) return item;
        // Also consider number form like 2012.
        item.name += "";
        // User may also specify displayName.
        // displayName will always exists except user not
        // specified or dim name is not specified or detected.
        // (A auto generated dim name will not be used as
        // displayName).
        if (item.displayName == null) item.displayName = item.name;
        var exist = nameMap.get(item.name);
        if (!exist) nameMap.set(item.name, {
            count: 1
        });
        else item.name += "-" + exist.count++;
        return item;
    });
}
function $99e22f5c2aa5094b$var$arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
    if (seriesLayoutBy === (0, $cab29724515ce2b8$export$d55da1467cdf7804)) for(var i = 0; i < data.length && i < maxLoop; i++)cb(data[i] ? data[i][0] : null, i);
    else {
        var value0 = data[0] || [];
        for(var i = 0; i < value0.length && i < maxLoop; i++)cb(value0[i], i);
    }
}
function $99e22f5c2aa5094b$export$8911336b527f8517(source) {
    var sourceFormat = source.sourceFormat;
    return sourceFormat === (0, $cab29724515ce2b8$export$703ae8a2d83f441) || sourceFormat === (0, $cab29724515ce2b8$export$6a32b42c754a3cb8);
}




var $8ffb0d67e9446edb$var$_a, $8ffb0d67e9446edb$var$_b, $8ffb0d67e9446edb$var$_c, $8ffb0d67e9446edb$var$_d;
var $8ffb0d67e9446edb$var$providerMethods;
var $8ffb0d67e9446edb$var$mountMethods;
/**
 * If normal array used, mutable chunk size is supported.
 * If typed array used, chunk size must be fixed.
 */ var $8ffb0d67e9446edb$export$b900d7c4c3952a40 = /** @class */ function() {
    function DefaultDataProvider(sourceParam, dimSize) {
        // let source: Source;
        var source = !(0, $99e22f5c2aa5094b$export$22b808bc02a60488)(sourceParam) ? (0, $99e22f5c2aa5094b$export$75aef3f97c0a5edf)(sourceParam) : sourceParam;
        // declare source is Source;
        this._source = source;
        var data = this._data = source.data;
        var sourceFormat = source.sourceFormat;
        var seriesLayoutBy = source.seriesLayoutBy;
        // Typed array. TODO IE10+?
        if (sourceFormat === (0, $cab29724515ce2b8$export$a918cb016a382d45)) {
            this._offset = 0;
            this._dimSize = dimSize;
            this._data = data;
        }
        var validator;
        $8ffb0d67e9446edb$var$mountMethods(this, data, source);
    }
    DefaultDataProvider.prototype.getSource = function() {
        return this._source;
    };
    DefaultDataProvider.prototype.count = function() {
        return 0;
    };
    DefaultDataProvider.prototype.getItem = function(idx, out) {
        return;
    };
    DefaultDataProvider.prototype.appendData = function(newData) {};
    DefaultDataProvider.prototype.clean = function() {};
    DefaultDataProvider.protoInitialize = function() {
        // PENDING: To avoid potential incompat (e.g., prototype
        // is visited somewhere), still init them on prototype.
        var proto = DefaultDataProvider.prototype;
        proto.pure = false;
        proto.persistent = true;
    }();
    DefaultDataProvider.internalField = function() {
        var _a;
        $8ffb0d67e9446edb$var$mountMethods = function(provider, data, source) {
            var sourceFormat = source.sourceFormat;
            var seriesLayoutBy = source.seriesLayoutBy;
            var startIndex = source.startIndex;
            var dimsDef = source.dimensionsDefine;
            var methods = $8ffb0d67e9446edb$var$providerMethods[$8ffb0d67e9446edb$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(provider, methods);
            if (sourceFormat === (0, $cab29724515ce2b8$export$a918cb016a382d45)) {
                provider.getItem = getItemForTypedArray;
                provider.count = countForTypedArray;
                provider.fillStorage = fillStorageForTypedArray;
            } else {
                var rawItemGetter = $8ffb0d67e9446edb$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy);
                provider.getItem = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(rawItemGetter, null, data, startIndex, dimsDef);
                var rawCounter = $8ffb0d67e9446edb$export$803742e832f4b52c(sourceFormat, seriesLayoutBy);
                provider.count = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(rawCounter, null, data, startIndex, dimsDef);
            }
        };
        var getItemForTypedArray = function(idx, out) {
            idx = idx - this._offset;
            out = out || [];
            var data = this._data;
            var dimSize = this._dimSize;
            var offset = dimSize * idx;
            for(var i = 0; i < dimSize; i++)out[i] = data[offset + i];
            return out;
        };
        var fillStorageForTypedArray = function(start, end, storage, extent) {
            var data = this._data;
            var dimSize = this._dimSize;
            for(var dim = 0; dim < dimSize; dim++){
                var dimExtent = extent[dim];
                var min = dimExtent[0] == null ? Infinity : dimExtent[0];
                var max = dimExtent[1] == null ? -Infinity : dimExtent[1];
                var count = end - start;
                var arr = storage[dim];
                for(var i = 0; i < count; i++){
                    // appendData with TypedArray will always do replace in provider.
                    var val = data[i * dimSize + dim];
                    arr[start + i] = val;
                    val < min && (min = val);
                    val > max && (max = val);
                }
                dimExtent[0] = min;
                dimExtent[1] = max;
            }
        };
        var countForTypedArray = function() {
            return this._data ? this._data.length / this._dimSize : 0;
        };
        $8ffb0d67e9446edb$var$providerMethods = (_a = {}, _a[(0, $cab29724515ce2b8$export$fcd62ebf51387903) + "_" + (0, $cab29724515ce2b8$export$7b3f3c6551b4949b)] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[(0, $cab29724515ce2b8$export$fcd62ebf51387903) + "_" + (0, $cab29724515ce2b8$export$d55da1467cdf7804)] = {
            pure: true,
            appendData: function() {
                throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
            }
        }, _a[0, $cab29724515ce2b8$export$703ae8a2d83f441] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[0, $cab29724515ce2b8$export$6a32b42c754a3cb8] = {
            pure: true,
            appendData: function(newData) {
                var data = this._data;
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newData, function(newCol, key) {
                    var oldCol = data[key] || (data[key] = []);
                    for(var i = 0; i < (newCol || []).length; i++)oldCol.push(newCol[i]);
                });
            }
        }, _a[0, $cab29724515ce2b8$export$2823037fb9d8f0c6] = {
            appendData: appendDataSimply
        }, _a[0, $cab29724515ce2b8$export$a918cb016a382d45] = {
            persistent: false,
            pure: true,
            appendData: function(newData) {
                this._data = newData;
            },
            // Clean self if data is already used.
            clean: function() {
                // PENDING
                this._offset += this.count();
                this._data = null;
            }
        }, _a);
        function appendDataSimply(newData) {
            for(var i = 0; i < newData.length; i++)this._data.push(newData[i]);
        }
    }();
    return DefaultDataProvider;
}();
var $8ffb0d67e9446edb$var$validateSimply = function(rawData) {
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(rawData)) (0, $84bc7667c27ccedc$export$a3bc9b8ed74fc)("series.data or dataset.source must be an array.");
};
/**
 * Only run in dev mode - hint users for debug.
 */ var $8ffb0d67e9446edb$var$rawSourceDataValidatorMap = ($8ffb0d67e9446edb$var$_a = {}, $8ffb0d67e9446edb$var$_a[(0, $cab29724515ce2b8$export$fcd62ebf51387903) + "_" + (0, $cab29724515ce2b8$export$7b3f3c6551b4949b)] = $8ffb0d67e9446edb$var$validateSimply, $8ffb0d67e9446edb$var$_a[(0, $cab29724515ce2b8$export$fcd62ebf51387903) + "_" + (0, $cab29724515ce2b8$export$d55da1467cdf7804)] = $8ffb0d67e9446edb$var$validateSimply, $8ffb0d67e9446edb$var$_a[0, $cab29724515ce2b8$export$703ae8a2d83f441] = $8ffb0d67e9446edb$var$validateSimply, $8ffb0d67e9446edb$var$_a[0, $cab29724515ce2b8$export$6a32b42c754a3cb8] = function(rawData, dimsDef) {
    for(var i = 0; i < dimsDef.length; i++){
        var dimName = dimsDef[i].name;
        if (dimName == null) (0, $84bc7667c27ccedc$export$a3bc9b8ed74fc)("dimension name must not be null/undefined.");
    }
}, $8ffb0d67e9446edb$var$_a[0, $cab29724515ce2b8$export$2823037fb9d8f0c6] = $8ffb0d67e9446edb$var$validateSimply, $8ffb0d67e9446edb$var$_a);
var $8ffb0d67e9446edb$var$getItemSimply = function(rawData, startIndex, dimsDef, idx) {
    return rawData[idx];
};
var $8ffb0d67e9446edb$var$rawSourceItemGetterMap = ($8ffb0d67e9446edb$var$_b = {}, $8ffb0d67e9446edb$var$_b[(0, $cab29724515ce2b8$export$fcd62ebf51387903) + "_" + (0, $cab29724515ce2b8$export$7b3f3c6551b4949b)] = function(rawData, startIndex, dimsDef, idx) {
    return rawData[idx + startIndex];
}, $8ffb0d67e9446edb$var$_b[(0, $cab29724515ce2b8$export$fcd62ebf51387903) + "_" + (0, $cab29724515ce2b8$export$d55da1467cdf7804)] = function(rawData, startIndex, dimsDef, idx, out) {
    idx += startIndex;
    var item = out || [];
    var data = rawData;
    for(var i = 0; i < data.length; i++){
        var row = data[i];
        item[i] = row ? row[idx] : null;
    }
    return item;
}, $8ffb0d67e9446edb$var$_b[0, $cab29724515ce2b8$export$703ae8a2d83f441] = $8ffb0d67e9446edb$var$getItemSimply, $8ffb0d67e9446edb$var$_b[0, $cab29724515ce2b8$export$6a32b42c754a3cb8] = function(rawData, startIndex, dimsDef, idx, out) {
    var item = out || [];
    for(var i = 0; i < dimsDef.length; i++){
        var dimName = dimsDef[i].name;
        var col = dimName != null ? rawData[dimName] : null;
        item[i] = col ? col[idx] : null;
    }
    return item;
}, $8ffb0d67e9446edb$var$_b[0, $cab29724515ce2b8$export$2823037fb9d8f0c6] = $8ffb0d67e9446edb$var$getItemSimply, $8ffb0d67e9446edb$var$_b);
function $8ffb0d67e9446edb$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy) {
    var method = $8ffb0d67e9446edb$var$rawSourceItemGetterMap[$8ffb0d67e9446edb$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $8ffb0d67e9446edb$var$countSimply = function(rawData, startIndex, dimsDef) {
    return rawData.length;
};
var $8ffb0d67e9446edb$var$rawSourceDataCounterMap = ($8ffb0d67e9446edb$var$_c = {}, $8ffb0d67e9446edb$var$_c[(0, $cab29724515ce2b8$export$fcd62ebf51387903) + "_" + (0, $cab29724515ce2b8$export$7b3f3c6551b4949b)] = function(rawData, startIndex, dimsDef) {
    return Math.max(0, rawData.length - startIndex);
}, $8ffb0d67e9446edb$var$_c[(0, $cab29724515ce2b8$export$fcd62ebf51387903) + "_" + (0, $cab29724515ce2b8$export$d55da1467cdf7804)] = function(rawData, startIndex, dimsDef) {
    var row = rawData[0];
    return row ? Math.max(0, row.length - startIndex) : 0;
}, $8ffb0d67e9446edb$var$_c[0, $cab29724515ce2b8$export$703ae8a2d83f441] = $8ffb0d67e9446edb$var$countSimply, $8ffb0d67e9446edb$var$_c[0, $cab29724515ce2b8$export$6a32b42c754a3cb8] = function(rawData, startIndex, dimsDef) {
    var dimName = dimsDef[0].name;
    var col = dimName != null ? rawData[dimName] : null;
    return col ? col.length : 0;
}, $8ffb0d67e9446edb$var$_c[0, $cab29724515ce2b8$export$2823037fb9d8f0c6] = $8ffb0d67e9446edb$var$countSimply, $8ffb0d67e9446edb$var$_c);
function $8ffb0d67e9446edb$export$803742e832f4b52c(sourceFormat, seriesLayoutBy) {
    var method = $8ffb0d67e9446edb$var$rawSourceDataCounterMap[$8ffb0d67e9446edb$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $8ffb0d67e9446edb$var$getRawValueSimply = function(dataItem, dimIndex, property) {
    return dataItem[dimIndex];
};
var $8ffb0d67e9446edb$var$rawSourceValueGetterMap = ($8ffb0d67e9446edb$var$_d = {}, $8ffb0d67e9446edb$var$_d[0, $cab29724515ce2b8$export$fcd62ebf51387903] = $8ffb0d67e9446edb$var$getRawValueSimply, $8ffb0d67e9446edb$var$_d[0, $cab29724515ce2b8$export$703ae8a2d83f441] = function(dataItem, dimIndex, property) {
    return dataItem[property];
}, $8ffb0d67e9446edb$var$_d[0, $cab29724515ce2b8$export$6a32b42c754a3cb8] = $8ffb0d67e9446edb$var$getRawValueSimply, $8ffb0d67e9446edb$var$_d[0, $cab29724515ce2b8$export$2823037fb9d8f0c6] = function(dataItem, dimIndex, property) {
    // FIXME: In some case (markpoint in geo (geo-map.html)),
    // dataItem is {coord: [...]}
    var value = (0, $76d619f648247e6d$export$2c944e12edb48d4b)(dataItem);
    return !(value instanceof Array) ? value : value[dimIndex];
}, $8ffb0d67e9446edb$var$_d[0, $cab29724515ce2b8$export$a918cb016a382d45] = $8ffb0d67e9446edb$var$getRawValueSimply, $8ffb0d67e9446edb$var$_d);
function $8ffb0d67e9446edb$export$1752de8084789a14(sourceFormat) {
    var method = $8ffb0d67e9446edb$var$rawSourceValueGetterMap[sourceFormat];
    return method;
}
function $8ffb0d67e9446edb$var$getMethodMapKey(sourceFormat, seriesLayoutBy) {
    return sourceFormat === (0, $cab29724515ce2b8$export$fcd62ebf51387903) ? sourceFormat + "_" + seriesLayoutBy : sourceFormat;
}
function $8ffb0d67e9446edb$export$cde9373da9aad801(data, dataIndex, // If dimIndex is null/undefined, return OptionDataItem.
// Otherwise, return OptionDataValue.
dim) {
    if (!data) return;
    // Consider data may be not persistent.
    var dataItem = data.getRawDataItem(dataIndex);
    if (dataItem == null) return;
    var store = data.getStore();
    var sourceFormat = store.getSource().sourceFormat;
    if (dim != null) {
        var dimIndex = data.getDimensionIndex(dim);
        var property = store.getDimensionProperty(dimIndex);
        return $8ffb0d67e9446edb$export$1752de8084789a14(sourceFormat)(dataItem, dimIndex, property);
    } else {
        var result = dataItem;
        if (sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6)) result = (0, $76d619f648247e6d$export$2c944e12edb48d4b)(dataItem);
        return result;
    }
}
function $8ffb0d67e9446edb$export$c8ae9e77e0ddc42a(data, dataIndex, attr) {
    if (!data) return;
    var sourceFormat = data.getStore().getSource().sourceFormat;
    if (sourceFormat !== (0, $cab29724515ce2b8$export$2823037fb9d8f0c6) && sourceFormat !== (0, $cab29724515ce2b8$export$703ae8a2d83f441)) return;
    var dataItem = data.getRawDataItem(dataIndex);
    if (sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6) && !(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dataItem)) dataItem = null;
    if (dataItem) return dataItem[attr];
}




var $655dd6075cc63601$var$DIMENSION_LABEL_REG = /\{@(.+?)\}/g;
var $655dd6075cc63601$export$f23396ae04ea95a7 = /** @class */ function() {
    function DataFormatMixin() {}
    /**
   * Get params for formatter
   */ DataFormatMixin.prototype.getDataParams = function(dataIndex, dataType) {
        var data = this.getData(dataType);
        var rawValue = this.getRawValue(dataIndex, dataType);
        var rawDataIndex = data.getRawIndex(dataIndex);
        var name = data.getName(dataIndex);
        var itemOpt = data.getRawDataItem(dataIndex);
        var style = data.getItemVisual(dataIndex, "style");
        var color = style && style[data.getItemVisual(dataIndex, "drawType") || "fill"];
        var borderColor = style && style.stroke;
        var mainType = this.mainType;
        var isSeries = mainType === "series";
        var userOutput = data.userOutput && data.userOutput.get();
        return {
            componentType: mainType,
            componentSubType: this.subType,
            componentIndex: this.componentIndex,
            seriesType: isSeries ? this.subType : null,
            seriesIndex: this.seriesIndex,
            seriesId: isSeries ? this.id : null,
            seriesName: isSeries ? this.name : null,
            name: name,
            dataIndex: rawDataIndex,
            data: itemOpt,
            dataType: dataType,
            value: rawValue,
            color: color,
            borderColor: borderColor,
            dimensionNames: userOutput ? userOutput.fullDimensions : null,
            encode: userOutput ? userOutput.encode : null,
            // Param name list for mapping `a`, `b`, `c`, `d`, `e`
            $vars: [
                "seriesName",
                "name",
                "value"
            ]
        };
    };
    /**
   * Format label
   * @param dataIndex
   * @param status 'normal' by default
   * @param dataType
   * @param labelDimIndex Only used in some chart that
   *        use formatter in different dimensions, like radar.
   * @param formatter Formatter given outside.
   * @return return null/undefined if no formatter
   */ DataFormatMixin.prototype.getFormattedLabel = function(dataIndex, status, dataType, labelDimIndex, formatter, extendParams) {
        status = status || "normal";
        var data = this.getData(dataType);
        var params = this.getDataParams(dataIndex, dataType);
        if (extendParams) params.value = extendParams.interpolatedValue;
        if (labelDimIndex != null && $7a1bd9c2710fea0d$export$43bee75e5e14138e(params.value)) params.value = params.value[labelDimIndex];
        if (!formatter) {
            var itemModel = data.getItemModel(dataIndex);
            // @ts-ignore
            formatter = itemModel.get(status === "normal" ? [
                "label",
                "formatter"
            ] : [
                status,
                "label",
                "formatter"
            ]);
        }
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(formatter)) {
            params.status = status;
            params.dimensionIndex = labelDimIndex;
            return formatter(params);
        } else if ($7a1bd9c2710fea0d$export$844ec244b1367d54(formatter)) {
            var str = (0, $c84c9521536c601a$export$2028496a35766e41)(formatter, params);
            // Support 'aaa{@[3]}bbb{@product}ccc'.
            // Do not support '}' in dim name util have to.
            return str.replace($655dd6075cc63601$var$DIMENSION_LABEL_REG, function(origin, dimStr) {
                var len = dimStr.length;
                var dimLoose = dimStr;
                if (dimLoose.charAt(0) === "[" && dimLoose.charAt(len - 1) === "]") dimLoose = +dimLoose.slice(1, len - 1); // Also support: '[]' => 0
                var val = (0, $8ffb0d67e9446edb$export$cde9373da9aad801)(data, dataIndex, dimLoose);
                if (extendParams && $7a1bd9c2710fea0d$export$43bee75e5e14138e(extendParams.interpolatedValue)) {
                    var dimIndex = data.getDimensionIndex(dimLoose);
                    if (dimIndex >= 0) val = extendParams.interpolatedValue[dimIndex];
                }
                return val != null ? val + "" : "";
            });
        }
    };
    /**
   * Get raw value in option
   */ DataFormatMixin.prototype.getRawValue = function(idx, dataType) {
        return (0, $8ffb0d67e9446edb$export$cde9373da9aad801)(this.getData(dataType), idx);
    };
    /**
   * Should be implemented.
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {string} [dataType]
   */ DataFormatMixin.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        // Empty function
        return;
    };
    return DataFormatMixin;
}();
function $655dd6075cc63601$export$2d16fa82a50c4741(result) {
    var markupText;
    // let markers: Dictionary<ColorString>;
    var markupFragment;
    if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(result)) {
        if (result.type) markupFragment = result;
    } else markupText = result;
    return {
        text: markupText,
        // markers: markers || markersExisting,
        frag: markupFragment
    };
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $4d16404c851dcec6$export$f7292ab7796be73c(define) {
    return new $4d16404c851dcec6$export$2dea7024bcdd7731(define);
}
var $4d16404c851dcec6$export$2dea7024bcdd7731 = /** @class */ function() {
    function Task(define) {
        define = define || {};
        this._reset = define.reset;
        this._plan = define.plan;
        this._count = define.count;
        this._onDirty = define.onDirty;
        this._dirty = true;
    }
    /**
   * @param step Specified step.
   * @param skip Skip customer perform call.
   * @param modBy Sampling window size.
   * @param modDataCount Sampling count.
   * @return whether unfinished.
   */ Task.prototype.perform = function(performArgs) {
        var upTask = this._upstream;
        var skip = performArgs && performArgs.skip;
        // TODO some refactor.
        // Pull data. Must pull data each time, because context.data
        // may be updated by Series.setData.
        if (this._dirty && upTask) {
            var context = this.context;
            context.data = context.outputData = upTask.context.outputData;
        }
        if (this.__pipeline) this.__pipeline.currentTask = this;
        var planResult;
        if (this._plan && !skip) planResult = this._plan(this.context);
        // Support sharding by mod, which changes the render sequence and makes the rendered graphic
        // elements uniformed distributed when progress, especially when moving or zooming.
        var lastModBy = normalizeModBy(this._modBy);
        var lastModDataCount = this._modDataCount || 0;
        var modBy = normalizeModBy(performArgs && performArgs.modBy);
        var modDataCount = performArgs && performArgs.modDataCount || 0;
        if (lastModBy !== modBy || lastModDataCount !== modDataCount) planResult = "reset";
        function normalizeModBy(val) {
            !(val >= 1) && (val = 1); // jshint ignore:line
            return val;
        }
        var forceFirstProgress;
        if (this._dirty || planResult === "reset") {
            this._dirty = false;
            forceFirstProgress = this._doReset(skip);
        }
        this._modBy = modBy;
        this._modDataCount = modDataCount;
        var step = performArgs && performArgs.step;
        if (upTask) this._dueEnd = upTask._outputDueEnd;
        else this._dueEnd = this._count ? this._count(this.context) : Infinity;
        // Note: Stubs, that its host overall task let it has progress, has progress.
        // If no progress, pass index from upstream to downstream each time plan called.
        if (this._progress) {
            var start = this._dueIndex;
            var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);
            if (!skip && (forceFirstProgress || start < end)) {
                var progress = this._progress;
                if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(progress)) for(var i = 0; i < progress.length; i++)this._doProgress(progress[i], start, end, modBy, modDataCount);
                else this._doProgress(progress, start, end, modBy, modDataCount);
            }
            this._dueIndex = end;
            // If no `outputDueEnd`, assume that output data and
            // input data is the same, so use `dueIndex` as `outputDueEnd`.
            var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;
            this._outputDueEnd = outputDueEnd;
        } else // (1) Some overall task has no progress.
        // (2) Stubs, that its host overall task do not let it has progress, has no progress.
        // This should always be performed so it can be passed to downstream.
        this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
        return this.unfinished();
    };
    Task.prototype.dirty = function() {
        this._dirty = true;
        this._onDirty && this._onDirty(this.context);
    };
    Task.prototype._doProgress = function(progress, start, end, modBy, modDataCount) {
        $4d16404c851dcec6$var$iterator.reset(start, end, modBy, modDataCount);
        this._callingProgress = progress;
        this._callingProgress({
            start: start,
            end: end,
            count: end - start,
            next: $4d16404c851dcec6$var$iterator.next
        }, this.context);
    };
    Task.prototype._doReset = function(skip) {
        this._dueIndex = this._outputDueEnd = this._dueEnd = 0;
        this._settedOutputEnd = null;
        var progress;
        var forceFirstProgress;
        if (!skip && this._reset) {
            progress = this._reset(this.context);
            if (progress && progress.progress) {
                forceFirstProgress = progress.forceFirstProgress;
                progress = progress.progress;
            }
            // To simplify no progress checking, array must has item.
            if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(progress) && !progress.length) progress = null;
        }
        this._progress = progress;
        this._modBy = this._modDataCount = null;
        var downstream = this._downstream;
        downstream && downstream.dirty();
        return forceFirstProgress;
    };
    Task.prototype.unfinished = function() {
        return this._progress && this._dueIndex < this._dueEnd;
    };
    /**
   * @param downTask The downstream task.
   * @return The downstream task.
   */ Task.prototype.pipe = function(downTask) {
        // If already downstream, do not dirty downTask.
        if (this._downstream !== downTask || this._dirty) {
            this._downstream = downTask;
            downTask._upstream = this;
            downTask.dirty();
        }
    };
    Task.prototype.dispose = function() {
        if (this._disposed) return;
        this._upstream && (this._upstream._downstream = null);
        this._downstream && (this._downstream._upstream = null);
        this._dirty = false;
        this._disposed = true;
    };
    Task.prototype.getUpstream = function() {
        return this._upstream;
    };
    Task.prototype.getDownstream = function() {
        return this._downstream;
    };
    Task.prototype.setOutputEnd = function(end) {
        // This only happens in dataTask, dataZoom, map, currently.
        // where dataZoom do not set end each time, but only set
        // when reset. So we should record the set end, in case
        // that the stub of dataZoom perform again and earse the
        // set end by upstream.
        this._outputDueEnd = this._settedOutputEnd = end;
    };
    return Task;
}();
var $4d16404c851dcec6$var$iterator = function() {
    var end;
    var current;
    var modBy;
    var modDataCount;
    var winCount;
    var it = {
        reset: function(s, e, sStep, sCount) {
            current = s;
            end = e;
            modBy = sStep;
            modDataCount = sCount;
            winCount = Math.ceil(modDataCount / modBy);
            it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
        }
    };
    return it;
    function sequentialNext() {
        return current < end ? current++ : null;
    }
    function modNext() {
        var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
        var result = current >= end ? null : dataIndex < modDataCount ? dataIndex : current;
        current++;
        return result;
    }
}(); // -----------------------------------------------------------------------------
 // For stream debug (Should be commented out after used!)
 // @usage: printTask(this, 'begin');
 // @usage: printTask(this, null, {someExtraProp});
 // @usage: Use `__idxInPipeline` as conditional breakpiont.
 //
 // window.printTask = function (task: any, prefix: string, extra: { [key: string]: unknown }): void {
 //     window.ecTaskUID == null && (window.ecTaskUID = 0);
 //     task.uidDebug == null && (task.uidDebug = `task_${window.ecTaskUID++}`);
 //     task.agent && task.agent.uidDebug == null && (task.agent.uidDebug = `task_${window.ecTaskUID++}`);
 //     let props = [];
 //     if (task.__pipeline) {
 //         let val = `${task.__idxInPipeline}/${task.__pipeline.tail.__idxInPipeline} ${task.agent ? '(stub)' : ''}`;
 //         props.push({text: '__idxInPipeline/total', value: val});
 //     } else {
 //         let stubCount = 0;
 //         task.agentStubMap.each(() => stubCount++);
 //         props.push({text: 'idx', value: `overall (stubs: ${stubCount})`});
 //     }
 //     props.push({text: 'uid', value: task.uidDebug});
 //     if (task.__pipeline) {
 //         props.push({text: 'pipelineId', value: task.__pipeline.id});
 //         task.agent && props.push(
 //             {text: 'stubFor', value: task.agent.uidDebug}
 //         );
 //     }
 //     props.push(
 //         {text: 'dirty', value: task._dirty},
 //         {text: 'dueIndex', value: task._dueIndex},
 //         {text: 'dueEnd', value: task._dueEnd},
 //         {text: 'outputDueEnd', value: task._outputDueEnd}
 //     );
 //     if (extra) {
 //         Object.keys(extra).forEach(key => {
 //             props.push({text: key, value: extra[key]});
 //         });
 //     }
 //     let args = ['color: blue'];
 //     let msg = `%c[${prefix || 'T'}] %c` + props.map(item => (
 //         args.push('color: green', 'color: red'),
 //         `${item.text}: %c${item.value}`
 //     )).join('%c, ');
 //     console.log.apply(console, [msg].concat(args));
 //     // console.log(this);
 // };
 // window.printPipeline = function (task: any, prefix: string) {
 //     const pipeline = task.__pipeline;
 //     let currTask = pipeline.head;
 //     while (currTask) {
 //         window.printTask(currTask, prefix);
 //         currTask = currTask._downstream;
 //     }
 // };
 // window.showChain = function (chainHeadTask) {
 //     var chain = [];
 //     var task = chainHeadTask;
 //     while (task) {
 //         chain.push({
 //             task: task,
 //             up: task._upstream,
 //             down: task._downstream,
 //             idxInPipeline: task.__idxInPipeline
 //         });
 //         task = task._downstream;
 //     }
 //     return chain;
 // };
 // window.findTaskInChain = function (task, chainHeadTask) {
 //     let chain = window.showChain(chainHeadTask);
 //     let result = [];
 //     for (let i = 0; i < chain.length; i++) {
 //         let chainItem = chain[i];
 //         if (chainItem.task === task) {
 //             result.push(i);
 //         }
 //     }
 //     return result;
 // };
 // window.printChainAEachInChainB = function (chainHeadTaskA, chainHeadTaskB) {
 //     let chainA = window.showChain(chainHeadTaskA);
 //     for (let i = 0; i < chainA.length; i++) {
 //         console.log('chainAIdx:', i, 'inChainB:', window.findTaskInChain(chainA[i].task, chainHeadTaskB));
 //     }
 // };



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $40ab59f44b7d2db6$export$cc7175145baad076(value, // For high performance, do not omit the second param.
opt) {
    // Performance sensitive.
    var dimType = opt && opt.type;
    if (dimType === "ordinal") // If given value is a category string
    return value;
    if (dimType === "time" && !(0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(value) && value != null && value !== "-") value = +(0, $cfc1f3b422a3185f$export$6b862160d295c8e)(value);
    // dimType defaults 'number'.
    // If dimType is not ordinal and value is null or undefined or NaN or '-',
    // parse to NaN.
    // number-like string (like ' 123 ') can be converted to a number.
    // where null/undefined or other string will be converted to NaN.
    return value == null || value === "" ? NaN : Number(value);
}
var $40ab59f44b7d2db6$var$valueParserMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)({
    "number": function(val) {
        // Do not use `numericToNumber` here. We have `numericToNumber` by default.
        // Here the number parser can have loose rule:
        // enable to cut suffix: "120px" => 120, "14%" => 14.
        return parseFloat(val);
    },
    "time": function(val) {
        // return timestamp.
        return +(0, $cfc1f3b422a3185f$export$6b862160d295c8e)(val);
    },
    "trim": function(val) {
        return (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(val) ? (0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(val) : val;
    }
});
function $40ab59f44b7d2db6$export$c88237b7c265b36b(type) {
    return $40ab59f44b7d2db6$var$valueParserMap.get(type);
}
var $40ab59f44b7d2db6$var$ORDER_COMPARISON_OP_MAP = {
    lt: function(lval, rval) {
        return lval < rval;
    },
    lte: function(lval, rval) {
        return lval <= rval;
    },
    gt: function(lval, rval) {
        return lval > rval;
    },
    gte: function(lval, rval) {
        return lval >= rval;
    }
};
var $40ab59f44b7d2db6$var$FilterOrderComparator = /** @class */ function() {
    function FilterOrderComparator(op, rval) {
        if (!(0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rval)) {
            var errMsg = "";
            (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        }
        this._opFn = $40ab59f44b7d2db6$var$ORDER_COMPARISON_OP_MAP[op];
        this._rvalFloat = (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(rval);
    }
    // Performance sensitive.
    FilterOrderComparator.prototype.evaluate = function(lval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        return (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(lval) ? this._opFn(lval, this._rvalFloat) : this._opFn((0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(lval), this._rvalFloat);
    };
    return FilterOrderComparator;
}();
var $40ab59f44b7d2db6$export$ed75a5d7b0144167 = /** @class */ function() {
    /**
   * @param order by default: 'asc'
   * @param incomparable by default: Always on the tail.
   *        That is, if 'asc' => 'max', if 'desc' => 'min'
   *        See the definition of "incomparable" in [SORT_COMPARISON_RULE].
   */ function SortOrderComparator(order, incomparable) {
        var isDesc = order === "desc";
        this._resultLT = isDesc ? 1 : -1;
        if (incomparable == null) incomparable = isDesc ? "min" : "max";
        this._incomparable = incomparable === "min" ? -Infinity : Infinity;
    }
    // See [SORT_COMPARISON_RULE].
    // Performance sensitive.
    SortOrderComparator.prototype.evaluate = function(lval, rval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        var lvalFloat = (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(lval) ? lval : (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(lval);
        var rvalFloat = (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rval) ? rval : (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(rval);
        var lvalNotNumeric = isNaN(lvalFloat);
        var rvalNotNumeric = isNaN(rvalFloat);
        if (lvalNotNumeric) lvalFloat = this._incomparable;
        if (rvalNotNumeric) rvalFloat = this._incomparable;
        if (lvalNotNumeric && rvalNotNumeric) {
            var lvalIsStr = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(lval);
            var rvalIsStr = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(rval);
            if (lvalIsStr) lvalFloat = rvalIsStr ? lval : 0;
            if (rvalIsStr) rvalFloat = lvalIsStr ? rval : 0;
        }
        return lvalFloat < rvalFloat ? this._resultLT : lvalFloat > rvalFloat ? -this._resultLT : 0;
    };
    return SortOrderComparator;
}();
var $40ab59f44b7d2db6$var$FilterEqualityComparator = /** @class */ function() {
    function FilterEqualityComparator(isEq, rval) {
        this._rval = rval;
        this._isEQ = isEq;
        this._rvalTypeof = typeof rval;
        this._rvalFloat = (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(rval);
    }
    // Performance sensitive.
    FilterEqualityComparator.prototype.evaluate = function(lval) {
        var eqResult = lval === this._rval;
        if (!eqResult) {
            var lvalTypeof = typeof lval;
            if (lvalTypeof !== this._rvalTypeof && (lvalTypeof === "number" || this._rvalTypeof === "number")) eqResult = (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(lval) === this._rvalFloat;
        }
        return this._isEQ ? eqResult : !eqResult;
    };
    return FilterEqualityComparator;
}();
function $40ab59f44b7d2db6$export$f2644c3485f94c4e(op, rval) {
    return op === "eq" || op === "ne" ? new $40ab59f44b7d2db6$var$FilterEqualityComparator(op === "eq", rval) : (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)($40ab59f44b7d2db6$var$ORDER_COMPARISON_OP_MAP, op) ? new $40ab59f44b7d2db6$var$FilterOrderComparator(op, rval) : null;
}




/**
 * TODO: disable writable.
 * This structure will be exposed to users.
 */ var $523dedd0a2328c06$export$ffc19e40a21f08eb = /** @class */ function() {
    function ExternalSource() {}
    ExternalSource.prototype.getRawData = function() {
        // Only built-in transform available.
        throw new Error("not supported");
    };
    ExternalSource.prototype.getRawDataItem = function(dataIndex) {
        // Only built-in transform available.
        throw new Error("not supported");
    };
    ExternalSource.prototype.cloneRawData = function() {
        return;
    };
    /**
   * @return If dimension not found, return null/undefined.
   */ ExternalSource.prototype.getDimensionInfo = function(dim) {
        return;
    };
    /**
   * dimensions defined if and only if either:
   * (a) dataset.dimensions are declared.
   * (b) dataset data include dimensions definitions in data (detected or via specified `sourceHeader`).
   * If dimensions are defined, `dimensionInfoAll` is corresponding to
   * the defined dimensions.
   * Otherwise, `dimensionInfoAll` is determined by data columns.
   * @return Always return an array (even empty array).
   */ ExternalSource.prototype.cloneAllDimensionInfo = function() {
        return;
    };
    ExternalSource.prototype.count = function() {
        return;
    };
    /**
   * Only support by dimension index.
   * No need to support by dimension name in transform function,
   * because transform function is not case-specific, no need to use name literally.
   */ ExternalSource.prototype.retrieveValue = function(dataIndex, dimIndex) {
        return;
    };
    ExternalSource.prototype.retrieveValueFromItem = function(dataItem, dimIndex) {
        return;
    };
    ExternalSource.prototype.convertValue = function(rawVal, dimInfo) {
        return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(rawVal, dimInfo);
    };
    return ExternalSource;
}();
function $523dedd0a2328c06$var$createExternalSource(internalSource, externalTransform) {
    var extSource = new $523dedd0a2328c06$export$ffc19e40a21f08eb();
    var data = internalSource.data;
    var sourceFormat = extSource.sourceFormat = internalSource.sourceFormat;
    var sourceHeaderCount = internalSource.startIndex;
    var errMsg = "";
    if (internalSource.seriesLayoutBy !== (0, $cab29724515ce2b8$export$7b3f3c6551b4949b)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    // [MEMO]
    // Create a new dimensions structure for exposing.
    // Do not expose all dimension info to users directly.
    // Because the dimension is probably auto detected from data and not might reliable.
    // Should not lead the transformers to think that is reliable and return it.
    // See [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
    var dimensions = [];
    var dimsByName = {};
    var dimsDef = internalSource.dimensionsDefine;
    if (dimsDef) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dimsDef, function(dimDef, idx) {
        var name = dimDef.name;
        var dimDefExt = {
            index: idx,
            name: name,
            displayName: dimDef.displayName
        };
        dimensions.push(dimDefExt);
        // Users probably do not specify dimension name. For simplicity, data transform
        // does not generate dimension name.
        if (name != null) {
            // Dimension name should not be duplicated.
            // For simplicity, data transform forbids name duplication, do not generate
            // new name like module `completeDimensions.ts` did, but just tell users.
            var errMsg_1 = "";
            if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(dimsByName, name)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg_1);
            dimsByName[name] = dimDefExt;
        }
    });
    else for(var i = 0; i < internalSource.dimensionsDetectedCount || 0; i++)// Do not generete name or anything others. The consequence process in
    // `transform` or `series` probably have there own name generation strategry.
    dimensions.push({
        index: i
    });
    // Implement public methods:
    var rawItemGetter = (0, $8ffb0d67e9446edb$export$92c8ea8642b3957d)(sourceFormat, (0, $cab29724515ce2b8$export$7b3f3c6551b4949b));
    if (externalTransform.__isBuiltIn) {
        extSource.getRawDataItem = function(dataIndex) {
            return rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        };
        extSource.getRawData = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($523dedd0a2328c06$var$getRawData, null, internalSource);
    }
    extSource.cloneRawData = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($523dedd0a2328c06$var$cloneRawData, null, internalSource);
    var rawCounter = (0, $8ffb0d67e9446edb$export$803742e832f4b52c)(sourceFormat, (0, $cab29724515ce2b8$export$7b3f3c6551b4949b));
    extSource.count = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(rawCounter, null, data, sourceHeaderCount, dimensions);
    var rawValueGetter = (0, $8ffb0d67e9446edb$export$1752de8084789a14)(sourceFormat);
    extSource.retrieveValue = function(dataIndex, dimIndex) {
        var rawItem = rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        return retrieveValueFromItem(rawItem, dimIndex);
    };
    var retrieveValueFromItem = extSource.retrieveValueFromItem = function(dataItem, dimIndex) {
        if (dataItem == null) return;
        var dimDef = dimensions[dimIndex];
        // When `dimIndex` is `null`, `rawValueGetter` return the whole item.
        if (dimDef) return rawValueGetter(dataItem, dimIndex, dimDef.name);
    };
    extSource.getDimensionInfo = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($523dedd0a2328c06$var$getDimensionInfo, null, dimensions, dimsByName);
    extSource.cloneAllDimensionInfo = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($523dedd0a2328c06$var$cloneAllDimensionInfo, null, dimensions);
    return extSource;
}
function $523dedd0a2328c06$var$getRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    if (!$523dedd0a2328c06$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = "";
        (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    }
    return upstream.data;
}
function $523dedd0a2328c06$var$cloneRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    var data = upstream.data;
    if (!$523dedd0a2328c06$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = "";
        (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    }
    if (sourceFormat === (0, $cab29724515ce2b8$export$fcd62ebf51387903)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push(data[i].slice());
        return result;
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$703ae8a2d83f441)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, data[i]));
        return result;
    }
}
function $523dedd0a2328c06$var$getDimensionInfo(dimensions, dimsByName, dim) {
    if (dim == null) return;
    // Keep the same logic as `List::getDimension` did.
    if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(dim) || !isNaN(dim) && !(0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(dimsByName, dim)) return dimensions[dim];
    else if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(dimsByName, dim)) return dimsByName[dim];
}
function $523dedd0a2328c06$var$cloneAllDimensionInfo(dimensions) {
    return (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(dimensions);
}
var $523dedd0a2328c06$var$externalTransformMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
function $523dedd0a2328c06$export$92c96c6d8b255b7d(externalTransform) {
    externalTransform = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(externalTransform);
    var type = externalTransform.type;
    var errMsg = "";
    if (!type) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    var typeParsed = type.split(":");
    if (typeParsed.length !== 2) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    // Namespace 'echarts:xxx' is official namespace, where the transforms should
    // be called directly via 'xxx' rather than 'echarts:xxx'.
    var isBuiltIn = false;
    if (typeParsed[0] === "echarts") {
        type = typeParsed[1];
        isBuiltIn = true;
    }
    externalTransform.__isBuiltIn = isBuiltIn;
    $523dedd0a2328c06$var$externalTransformMap.set(type, externalTransform);
}
function $523dedd0a2328c06$export$42a68f09db16803f(rawTransOption, sourceList, infoForPrint) {
    var pipedTransOption = (0, $76d619f648247e6d$export$4f07b212a02c8051)(rawTransOption);
    var pipeLen = pipedTransOption.length;
    var errMsg = "";
    if (!pipeLen) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    for(var i = 0, len = pipeLen; i < len; i++){
        var transOption = pipedTransOption[i];
        sourceList = $523dedd0a2328c06$var$applySingleDataTransform(transOption, sourceList, infoForPrint, pipeLen === 1 ? null : i);
        // piped transform only support single input, except the fist one.
        // piped transform only support single output, except the last one.
        if (i !== len - 1) sourceList.length = Math.max(sourceList.length, 1);
    }
    return sourceList;
}
function $523dedd0a2328c06$var$applySingleDataTransform(transOption, upSourceList, infoForPrint, // If `pipeIndex` is null/undefined, no piped transform.
pipeIndex) {
    var errMsg = "";
    if (!upSourceList.length) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    if (!(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(transOption)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    var transType = transOption.type;
    var externalTransform = $523dedd0a2328c06$var$externalTransformMap.get(transType);
    if (!externalTransform) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    // Prepare source
    var extUpSourceList = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(upSourceList, function(upSource) {
        return $523dedd0a2328c06$var$createExternalSource(upSource, externalTransform);
    });
    var resultList = (0, $76d619f648247e6d$export$4f07b212a02c8051)(externalTransform.transform({
        upstream: extUpSourceList[0],
        upstreamList: extUpSourceList,
        config: (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(transOption.config)
    }));
    var printStrArr;
    return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(resultList, function(result, resultIndex) {
        var errMsg = "";
        if (!(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(result)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        if (!result.data) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        var sourceFormat = (0, $99e22f5c2aa5094b$export$52a469afa4653e57)(result.data);
        if (!$523dedd0a2328c06$var$isSupportedSourceFormat(sourceFormat)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        var resultMetaRawOption;
        var firstUpSource = upSourceList[0];
        /**
     * Intuitively, the end users known the content of the original `dataset.source`,
     * calucating the transform result in mind.
     * Suppose the original `dataset.source` is:
     * ```js
     * [
     *     ['product', '2012', '2013', '2014', '2015'],
     *     ['AAA', 41.1, 30.4, 65.1, 53.3],
     *     ['BBB', 86.5, 92.1, 85.7, 83.1],
     *     ['CCC', 24.1, 67.2, 79.5, 86.4]
     * ]
     * ```
     * The dimension info have to be detected from the source data.
     * Some of the transformers (like filter, sort) will follow the dimension info
     * of upstream, while others use new dimensions (like aggregate).
     * Transformer can output a field `dimensions` to define the its own output dimensions.
     * We also allow transformers to ignore the output `dimensions` field, and
     * inherit the upstream dimensions definition. It can reduce the burden of handling
     * dimensions in transformers.
     *
     * See also [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
     */ if (firstUpSource && resultIndex === 0 && !result.dimensions) {
            var startIndex = firstUpSource.startIndex;
            // We copy the header of upstream to the result, because:
            // (1) The returned data always does not contain header line and can not be used
            // as dimension-detection. In this case we can not use "detected dimensions" of
            // upstream directly, because it might be detected based on different `seriesLayoutBy`.
            // (2) We should support that the series read the upstream source in `seriesLayoutBy: 'row'`.
            // So the original detected header should be add to the result, otherwise they can not be read.
            if (startIndex) result.data = firstUpSource.data.slice(0, startIndex).concat(result.data);
            resultMetaRawOption = {
                seriesLayoutBy: (0, $cab29724515ce2b8$export$7b3f3c6551b4949b),
                sourceHeader: startIndex,
                dimensions: firstUpSource.metaRawOption.dimensions
            };
        } else resultMetaRawOption = {
            seriesLayoutBy: (0, $cab29724515ce2b8$export$7b3f3c6551b4949b),
            sourceHeader: 0,
            dimensions: result.dimensions
        };
        return (0, $99e22f5c2aa5094b$export$1921362e86c73c88)(result.data, resultMetaRawOption, null);
    });
}
function $523dedd0a2328c06$var$isSupportedSourceFormat(sourceFormat) {
    return sourceFormat === (0, $cab29724515ce2b8$export$fcd62ebf51387903) || sourceFormat === (0, $cab29724515ce2b8$export$703ae8a2d83f441);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $370e5aa482d8420b$var$UNDEFINED = "undefined";
var $370e5aa482d8420b$export$859a1fa4f1106aa0 = typeof Uint32Array === $370e5aa482d8420b$var$UNDEFINED ? Array : Uint32Array;
var $370e5aa482d8420b$export$78cf73566f32c185 = typeof Uint16Array === $370e5aa482d8420b$var$UNDEFINED ? Array : Uint16Array;
var $370e5aa482d8420b$export$b60d945128546f53 = typeof Int32Array === $370e5aa482d8420b$var$UNDEFINED ? Array : Int32Array;
var $370e5aa482d8420b$export$365b104db51a490a = typeof Float64Array === $370e5aa482d8420b$var$UNDEFINED ? Array : Float64Array;
/**
 * Multi dimensional data store
 */ var $370e5aa482d8420b$var$dataCtors = {
    "float": $370e5aa482d8420b$export$365b104db51a490a,
    "int": $370e5aa482d8420b$export$b60d945128546f53,
    // Ordinal data type can be string or int
    "ordinal": Array,
    "number": Array,
    "time": $370e5aa482d8420b$export$365b104db51a490a
};
var $370e5aa482d8420b$var$defaultDimValueGetters;
function $370e5aa482d8420b$var$getIndicesCtor(rawCount) {
    // The possible max value in this._indicies is always this._rawCount despite of filtering.
    return rawCount > 65535 ? $370e5aa482d8420b$export$859a1fa4f1106aa0 : $370e5aa482d8420b$export$78cf73566f32c185;
}
function $370e5aa482d8420b$var$getInitialExtent() {
    return [
        Infinity,
        -Infinity
    ];
}
function $370e5aa482d8420b$var$cloneChunk(originalChunk) {
    var Ctor = originalChunk.constructor;
    // Only shallow clone is enough when Array.
    return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
}
function $370e5aa482d8420b$var$prepareStore(store, dimIdx, dimType, end, append) {
    var DataCtor = $370e5aa482d8420b$var$dataCtors[dimType || "float"];
    if (append) {
        var oldStore = store[dimIdx];
        var oldLen = oldStore && oldStore.length;
        if (!(oldLen === end)) {
            var newStore = new DataCtor(end);
            // The cost of the copy is probably inconsiderable
            // within the initial chunkSize.
            for(var j = 0; j < oldLen; j++)newStore[j] = oldStore[j];
            store[dimIdx] = newStore;
        }
    } else store[dimIdx] = new DataCtor(end);
}
/**
 * Basically, DataStore API keep immutable.
 */ var $370e5aa482d8420b$var$DataStore = /** @class */ function() {
    function DataStore() {
        this._chunks = [];
        // It will not be calculated until needed.
        this._rawExtent = [];
        this._extent = [];
        this._count = 0;
        this._rawCount = 0;
        this._calcDimNameToIdx = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    }
    /**
   * Initialize from data
   */ DataStore.prototype.initData = function(provider, inputDimensions, dimValueGetter) {
        this._provider = provider;
        // Clear
        this._chunks = [];
        this._indices = null;
        this.getRawIndex = this._getRawIdxIdentity;
        var source = provider.getSource();
        var defaultGetter = this.defaultDimValueGetter = $370e5aa482d8420b$var$defaultDimValueGetters[source.sourceFormat];
        // Default dim value getter
        this._dimValueGetter = dimValueGetter || defaultGetter;
        // Reset raw extent.
        this._rawExtent = [];
        var willRetrieveDataByName = (0, $99e22f5c2aa5094b$export$8911336b527f8517)(source);
        this._dimensions = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(inputDimensions, function(dim) {
            return {
                // Only pick these two props. Not leak other properties like orderMeta.
                type: dim.type,
                property: dim.property
            };
        });
        this._initDataFromProvider(0, provider.count());
    };
    DataStore.prototype.getProvider = function() {
        return this._provider;
    };
    /**
   * Caution: even when a `source` instance owned by a series, the created data store
   * may still be shared by different sereis (the source hash does not use all `source`
   * props, see `sourceManager`). In this case, the `source` props that are not used in
   * hash (like `source.dimensionDefine`) probably only belongs to a certain series and
   * thus should not be fetch here.
   */ DataStore.prototype.getSource = function() {
        return this._provider.getSource();
    };
    /**
   * @caution Only used in dataStack.
   */ DataStore.prototype.ensureCalculationDimension = function(dimName, type) {
        var calcDimNameToIdx = this._calcDimNameToIdx;
        var dimensions = this._dimensions;
        var calcDimIdx = calcDimNameToIdx.get(dimName);
        if (calcDimIdx != null) {
            if (dimensions[calcDimIdx].type === type) return calcDimIdx;
        } else calcDimIdx = dimensions.length;
        dimensions[calcDimIdx] = {
            type: type
        };
        calcDimNameToIdx.set(dimName, calcDimIdx);
        this._chunks[calcDimIdx] = new $370e5aa482d8420b$var$dataCtors[type || "float"](this._rawCount);
        this._rawExtent[calcDimIdx] = $370e5aa482d8420b$var$getInitialExtent();
        return calcDimIdx;
    };
    DataStore.prototype.collectOrdinalMeta = function(dimIdx, ordinalMeta) {
        var chunk = this._chunks[dimIdx];
        var dim = this._dimensions[dimIdx];
        var rawExtents = this._rawExtent;
        var offset = dim.ordinalOffset || 0;
        var len = chunk.length;
        if (offset === 0) // We need to reset the rawExtent if collect is from start.
        // Because this dimension may be guessed as number and calcuating a wrong extent.
        rawExtents[dimIdx] = $370e5aa482d8420b$var$getInitialExtent();
        var dimRawExtent = rawExtents[dimIdx];
        // Parse from previous data offset. len may be changed after appendData
        for(var i = offset; i < len; i++){
            var val = chunk[i] = ordinalMeta.parseAndCollect(chunk[i]);
            if (!isNaN(val)) {
                dimRawExtent[0] = Math.min(val, dimRawExtent[0]);
                dimRawExtent[1] = Math.max(val, dimRawExtent[1]);
            }
        }
        dim.ordinalMeta = ordinalMeta;
        dim.ordinalOffset = len;
        dim.type = "ordinal"; // Force to be ordinal
    };
    DataStore.prototype.getOrdinalMeta = function(dimIdx) {
        var dimInfo = this._dimensions[dimIdx];
        var ordinalMeta = dimInfo.ordinalMeta;
        return ordinalMeta;
    };
    DataStore.prototype.getDimensionProperty = function(dimIndex) {
        var item = this._dimensions[dimIndex];
        return item && item.property;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ DataStore.prototype.appendData = function(data) {
        var provider = this._provider;
        var start = this.count();
        provider.appendData(data);
        var end = provider.count();
        if (!provider.persistent) end += start;
        if (start < end) this._initDataFromProvider(start, end, true);
        return [
            start,
            end
        ];
    };
    DataStore.prototype.appendValues = function(values, minFillLen) {
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var start = this.count();
        var end = start + Math.max(values.length, minFillLen || 0);
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            $370e5aa482d8420b$var$prepareStore(chunks, i, dim.type, end, true);
        }
        var emptyDataItem = [];
        for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start;
            // Store the data by dimensions
            for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                var dim = dimensions[dimIdx];
                var val = $370e5aa482d8420b$var$defaultDimValueGetters.arrayRows.call(this, values[sourceIdx] || emptyDataItem, dim.property, sourceIdx, dimIdx);
                chunks[dimIdx][idx] = val;
                var dimRawExtent = rawExtent[dimIdx];
                val < dimRawExtent[0] && (dimRawExtent[0] = val);
                val > dimRawExtent[1] && (dimRawExtent[1] = val);
            }
        }
        this._rawCount = this._count = end;
        return {
            start: start,
            end: end
        };
    };
    DataStore.prototype._initDataFromProvider = function(start, end, append) {
        var provider = this._provider;
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var dimNames = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dimensions, function(dim) {
            return dim.property;
        });
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            if (!rawExtent[i]) rawExtent[i] = $370e5aa482d8420b$var$getInitialExtent();
            $370e5aa482d8420b$var$prepareStore(chunks, i, dim.type, end, append);
        }
        if (provider.fillStorage) provider.fillStorage(start, end, chunks, rawExtent);
        else {
            var dataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                dataItem = provider.getItem(idx, dataItem);
                // Each data item is value
                // [1, 2]
                // 2
                // Bar chart, line chart which uses category axis
                // only gives the 'y' value. 'x' value is the indices of category
                // Use a tempValue to normalize the value to be a (x, y) value
                // Store the data by dimensions
                for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                    var dimStorage = chunks[dimIdx];
                    // PENDING NULL is empty or zero
                    var val = this._dimValueGetter(dataItem, dimNames[dimIdx], idx, dimIdx);
                    dimStorage[idx] = val;
                    var dimRawExtent = rawExtent[dimIdx];
                    val < dimRawExtent[0] && (dimRawExtent[0] = val);
                    val > dimRawExtent[1] && (dimRawExtent[1] = val);
                }
            }
        }
        if (!provider.persistent && provider.clean) // Clean unused data if data source is typed array.
        provider.clean();
        this._rawCount = this._count = end;
        // Reset data extent
        this._extent = [];
    };
    DataStore.prototype.count = function() {
        return this._count;
    };
    /**
   * Get value. Return NaN if idx is out of range.
   */ DataStore.prototype.get = function(dim, idx) {
        if (!(idx >= 0 && idx < this._count)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[this.getRawIndex(idx)] : NaN;
    };
    DataStore.prototype.getValues = function(dimensions, idx) {
        var values = [];
        var dimArr = [];
        if (idx == null) {
            idx = dimensions;
            // TODO get all from store?
            dimensions = [];
            // All dimensions
            for(var i = 0; i < this._dimensions.length; i++)dimArr.push(i);
        } else dimArr = dimensions;
        for(var i = 0, len = dimArr.length; i < len; i++)values.push(this.get(dimArr[i], idx));
        return values;
    };
    /**
   * @param dim concrete dim
   */ DataStore.prototype.getByRawIndex = function(dim, rawIdx) {
        if (!(rawIdx >= 0 && rawIdx < this._rawCount)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[rawIdx] : NaN;
    };
    /**
   * Get sum of data in one dimension
   */ DataStore.prototype.getSum = function(dim) {
        var dimData = this._chunks[dim];
        var sum = 0;
        if (dimData) for(var i = 0, len = this.count(); i < len; i++){
            var value = this.get(dim, i);
            if (!isNaN(value)) sum += value;
        }
        return sum;
    };
    /**
   * Get median of data in one dimension
   */ DataStore.prototype.getMedian = function(dim) {
        var dimDataArray = [];
        // map all data of one dimension
        this.each([
            dim
        ], function(val) {
            if (!isNaN(val)) dimDataArray.push(val);
        });
        // TODO
        // Use quick select?
        var sortedDimDataArray = dimDataArray.sort(function(a, b) {
            return a - b;
        });
        var len = this.count();
        // calculate median
        return len === 0 ? 0 : len % 2 === 1 ? sortedDimDataArray[(len - 1) / 2] : (sortedDimDataArray[len / 2] + sortedDimDataArray[len / 2 - 1]) / 2;
    };
    /**
   * Retrieve the index with given raw data index.
   */ DataStore.prototype.indexOfRawIndex = function(rawIndex) {
        if (rawIndex >= this._rawCount || rawIndex < 0) return -1;
        if (!this._indices) return rawIndex;
        // Indices are ascending
        var indices = this._indices;
        // If rawIndex === dataIndex
        var rawDataIndex = indices[rawIndex];
        if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) return rawIndex;
        var left = 0;
        var right = this._count - 1;
        while(left <= right){
            var mid = (left + right) / 2 | 0;
            if (indices[mid] < rawIndex) left = mid + 1;
            else if (indices[mid] > rawIndex) right = mid - 1;
            else return mid;
        }
        return -1;
    };
    DataStore.prototype.getIndices = function() {
        var newIndices;
        var indices = this._indices;
        if (indices) {
            var Ctor = indices.constructor;
            var thisCount = this._count;
            // `new Array(a, b, c)` is different from `new Uint32Array(a, b, c)`.
            if (Ctor === Array) {
                newIndices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)newIndices[i] = indices[i];
            } else newIndices = new Ctor(indices.buffer, 0, thisCount);
        } else {
            var Ctor = $370e5aa482d8420b$var$getIndicesCtor(this._rawCount);
            newIndices = new Ctor(this.count());
            for(var i = 0; i < newIndices.length; i++)newIndices[i] = i;
        }
        return newIndices;
    };
    /**
   * Data filter.
   */ DataStore.prototype.filter = function(dims, cb) {
        if (!this._count) return this;
        var newStore = this.clone();
        var count = newStore.count();
        var Ctor = $370e5aa482d8420b$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(count);
        var value = [];
        var dimSize = dims.length;
        var offset = 0;
        var dim0 = dims[0];
        var chunks = newStore._chunks;
        for(var i = 0; i < count; i++){
            var keep = void 0;
            var rawIdx = newStore.getRawIndex(i);
            // Simple optimization
            if (dimSize === 0) keep = cb(i);
            else if (dimSize === 1) {
                var val = chunks[dim0][rawIdx];
                keep = cb(val, i);
            } else {
                var k = 0;
                for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                value[k] = i;
                keep = cb.apply(null, value);
            }
            if (keep) newIndices[offset++] = rawIdx;
        }
        // Set indices after filtered.
        if (offset < count) newStore._indices = newIndices;
        newStore._count = offset;
        // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ DataStore.prototype.selectRange = function(range) {
        var newStore = this.clone();
        var len = newStore._count;
        if (!len) return this;
        var dims = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(range);
        var dimSize = dims.length;
        if (!dimSize) return this;
        var originalCount = newStore.count();
        var Ctor = $370e5aa482d8420b$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(originalCount);
        var offset = 0;
        var dim0 = dims[0];
        var min = range[dim0][0];
        var max = range[dim0][1];
        var storeArr = newStore._chunks;
        var quickFinished = false;
        if (!newStore._indices) {
            // Extreme optimization for common case. About 2x faster in chrome.
            var idx = 0;
            if (dimSize === 1) {
                var dimStorage = storeArr[dims[0]];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i];
                    // NaN will not be filtered. Consider the case, in line chart, empty
                    // value indicates the line should be broken. But for the case like
                    // scatter plot, a data item with empty value will not be rendered,
                    // but the axis extent may be effected if some other dim of the data
                    // item has value. Fortunately it is not a significant negative effect.
                    if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            } else if (dimSize === 2) {
                var dimStorage = storeArr[dims[0]];
                var dimStorage2 = storeArr[dims[1]];
                var min2 = range[dims[1]][0];
                var max2 = range[dims[1]][1];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i];
                    var val2 = dimStorage2[i];
                    // Do not filter NaN, see comment above.
                    if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            }
        }
        if (!quickFinished) {
            if (dimSize === 1) for(var i = 0; i < originalCount; i++){
                var rawIndex = newStore.getRawIndex(i);
                var val = storeArr[dims[0]][rawIndex];
                // Do not filter NaN, see comment above.
                if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = rawIndex;
            }
            else for(var i = 0; i < originalCount; i++){
                var keep = true;
                var rawIndex = newStore.getRawIndex(i);
                for(var k = 0; k < dimSize; k++){
                    var dimk = dims[k];
                    var val = storeArr[dimk][rawIndex];
                    // Do not filter NaN, see comment above.
                    if (val < range[dimk][0] || val > range[dimk][1]) keep = false;
                }
                if (keep) newIndices[offset++] = newStore.getRawIndex(i);
            }
        }
        // Set indices after filtered.
        if (offset < originalCount) newStore._indices = newIndices;
        newStore._count = offset;
        // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    };
    // /**
    //  * Data mapping to a plain array
    //  */
    // mapArray(dims: DimensionIndex[], cb: MapArrayCb): any[] {
    //     const result: any[] = [];
    //     this.each(dims, function () {
    //         result.push(cb && (cb as MapArrayCb).apply(null, arguments));
    //     });
    //     return result;
    // }
    /**
   * Data mapping to a new List with given dimensions
   */ DataStore.prototype.map = function(dims, cb) {
        // TODO only clone picked chunks.
        var target = this.clone(dims);
        this._updateDims(target, dims, cb);
        return target;
    };
    /**
   * @caution Danger!! Only used in dataStack.
   */ DataStore.prototype.modify = function(dims, cb) {
        this._updateDims(this, dims, cb);
    };
    DataStore.prototype._updateDims = function(target, dims, cb) {
        var targetChunks = target._chunks;
        var tmpRetValue = [];
        var dimSize = dims.length;
        var dataCount = target.count();
        var values = [];
        var rawExtent = target._rawExtent;
        for(var i = 0; i < dims.length; i++)rawExtent[dims[i]] = $370e5aa482d8420b$var$getInitialExtent();
        for(var dataIndex = 0; dataIndex < dataCount; dataIndex++){
            var rawIndex = target.getRawIndex(dataIndex);
            for(var k = 0; k < dimSize; k++)values[k] = targetChunks[dims[k]][rawIndex];
            values[dimSize] = dataIndex;
            var retValue = cb && cb.apply(null, values);
            if (retValue != null) {
                // a number or string (in oridinal dimension)?
                if (typeof retValue !== "object") {
                    tmpRetValue[0] = retValue;
                    retValue = tmpRetValue;
                }
                for(var i = 0; i < retValue.length; i++){
                    var dim = dims[i];
                    var val = retValue[i];
                    var rawExtentOnDim = rawExtent[dim];
                    var dimStore = targetChunks[dim];
                    if (dimStore) dimStore[rawIndex] = val;
                    if (val < rawExtentOnDim[0]) rawExtentOnDim[0] = val;
                    if (val > rawExtentOnDim[1]) rawExtentOnDim[1] = val;
                }
            }
        }
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ DataStore.prototype.lttbDownSample = function(valueDimension, rate) {
        var target = this.clone([
            valueDimension
        ], true);
        var targetStorage = target._chunks;
        var dimStore = targetStorage[valueDimension];
        var len = this.count();
        var sampledIndex = 0;
        var frameSize = Math.floor(1 / rate);
        var currentRawIndex = this.getRawIndex(0);
        var maxArea;
        var area;
        var nextRawIndex;
        var newIndices = new ($370e5aa482d8420b$var$getIndicesCtor(this._rawCount))(Math.min((Math.ceil(len / frameSize) + 2) * 2, len));
        // First frame use the first data.
        newIndices[sampledIndex++] = currentRawIndex;
        for(var i = 1; i < len - 1; i += frameSize){
            var nextFrameStart = Math.min(i + frameSize, len - 1);
            var nextFrameEnd = Math.min(i + frameSize * 2, len);
            var avgX = (nextFrameEnd + nextFrameStart) / 2;
            var avgY = 0;
            for(var idx = nextFrameStart; idx < nextFrameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) continue;
                avgY += y;
            }
            avgY /= nextFrameEnd - nextFrameStart;
            var frameStart = i;
            var frameEnd = Math.min(i + frameSize, len);
            var pointAX = i - 1;
            var pointAY = dimStore[currentRawIndex];
            maxArea = -1;
            nextRawIndex = frameStart;
            var firstNaNIndex = -1;
            var countNaN = 0;
            // Find a point from current frame that construct a triangle with largest area with previous selected point
            // And the average of next frame.
            for(var idx = frameStart; idx < frameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) {
                    countNaN++;
                    if (firstNaNIndex < 0) firstNaNIndex = rawIndex;
                    continue;
                }
                // Calculate triangle area over three buckets
                area = Math.abs((pointAX - avgX) * (y - pointAY) - (pointAX - idx) * (avgY - pointAY));
                if (area > maxArea) {
                    maxArea = area;
                    nextRawIndex = rawIndex; // Next a is this b
                }
            }
            if (countNaN > 0 && countNaN < frameEnd - frameStart) {
                // Append first NaN point in every bucket.
                // It is necessary to ensure the correct order of indices.
                newIndices[sampledIndex++] = Math.min(firstNaNIndex, nextRawIndex);
                nextRawIndex = Math.max(firstNaNIndex, nextRawIndex);
            }
            newIndices[sampledIndex++] = nextRawIndex;
            currentRawIndex = nextRawIndex; // This a is the next a (chosen b)
        }
        // First frame use the last data.
        newIndices[sampledIndex++] = this.getRawIndex(len - 1);
        target._count = sampledIndex;
        target._indices = newIndices;
        target.getRawIndex = this._getRawIdx;
        return target;
    };
    /**
   * Large data down sampling using min-max
   * @param {string} valueDimension
   * @param {number} rate
   */ DataStore.prototype.minmaxDownSample = function(valueDimension, rate) {
        var target = this.clone([
            valueDimension
        ], true);
        var targetStorage = target._chunks;
        var frameSize = Math.floor(1 / rate);
        var dimStore = targetStorage[valueDimension];
        var len = this.count();
        // Each frame results in 2 data points, one for min and one for max
        var newIndices = new ($370e5aa482d8420b$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize) * 2);
        var offset = 0;
        for(var i = 0; i < len; i += frameSize){
            var minIndex = i;
            var minValue = dimStore[this.getRawIndex(minIndex)];
            var maxIndex = i;
            var maxValue = dimStore[this.getRawIndex(maxIndex)];
            var thisFrameSize = frameSize;
            // Handle final smaller frame
            if (i + frameSize > len) thisFrameSize = len - i;
            // Determine min and max within the current frame
            for(var k = 0; k < thisFrameSize; k++){
                var rawIndex = this.getRawIndex(i + k);
                var value = dimStore[rawIndex];
                if (value < minValue) {
                    minValue = value;
                    minIndex = i + k;
                }
                if (value > maxValue) {
                    maxValue = value;
                    maxIndex = i + k;
                }
            }
            var rawMinIndex = this.getRawIndex(minIndex);
            var rawMaxIndex = this.getRawIndex(maxIndex);
            // Set the order of the min and max values, based on their ordering in the frame
            if (minIndex < maxIndex) {
                newIndices[offset++] = rawMinIndex;
                newIndices[offset++] = rawMaxIndex;
            } else {
                newIndices[offset++] = rawMaxIndex;
                newIndices[offset++] = rawMinIndex;
            }
        }
        target._count = offset;
        target._indices = newIndices;
        target._updateGetRawIdx();
        return target;
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ DataStore.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var target = this.clone([
            dimension
        ], true);
        var targetStorage = target._chunks;
        var frameValues = [];
        var frameSize = Math.floor(1 / rate);
        var dimStore = targetStorage[dimension];
        var len = this.count();
        var rawExtentOnDim = target._rawExtent[dimension] = $370e5aa482d8420b$var$getInitialExtent();
        var newIndices = new ($370e5aa482d8420b$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize));
        var offset = 0;
        for(var i = 0; i < len; i += frameSize){
            // Last frame
            if (frameSize > len - i) {
                frameSize = len - i;
                frameValues.length = frameSize;
            }
            for(var k = 0; k < frameSize; k++){
                var dataIdx = this.getRawIndex(i + k);
                frameValues[k] = dimStore[dataIdx];
            }
            var value = sampleValue(frameValues);
            var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1));
            // Only write value on the filtered data
            dimStore[sampleFrameIdx] = value;
            if (value < rawExtentOnDim[0]) rawExtentOnDim[0] = value;
            if (value > rawExtentOnDim[1]) rawExtentOnDim[1] = value;
            newIndices[offset++] = sampleFrameIdx;
        }
        target._count = offset;
        target._indices = newIndices;
        target._updateGetRawIdx();
        return target;
    };
    /**
   * Data iteration
   * @param ctx default this
   * @example
   *  list.each('x', function (x, idx) {});
   *  list.each(['x', 'y'], function (x, y, idx) {});
   *  list.each(function (idx) {})
   */ DataStore.prototype.each = function(dims, cb) {
        if (!this._count) return;
        var dimSize = dims.length;
        var chunks = this._chunks;
        for(var i = 0, len = this.count(); i < len; i++){
            var rawIdx = this.getRawIndex(i);
            // Simple optimization
            switch(dimSize){
                case 0:
                    cb(i);
                    break;
                case 1:
                    cb(chunks[dims[0]][rawIdx], i);
                    break;
                case 2:
                    cb(chunks[dims[0]][rawIdx], chunks[dims[1]][rawIdx], i);
                    break;
                default:
                    var k = 0;
                    var value = [];
                    for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                    // Index
                    value[k] = i;
                    cb.apply(null, value);
            }
        }
    };
    /**
   * Get extent of data in one dimension
   */ DataStore.prototype.getDataExtent = function(dim) {
        // Make sure use concrete dim as cache name.
        var dimData = this._chunks[dim];
        var initialExtent = $370e5aa482d8420b$var$getInitialExtent();
        if (!dimData) return initialExtent;
        // Make more strict checkings to ensure hitting cache.
        var currEnd = this.count();
        // Consider the most cases when using data zoom, `getDataExtent`
        // happened before filtering. We cache raw extent, which is not
        // necessary to be cleared and recalculated when restore data.
        var useRaw = !this._indices;
        var dimExtent;
        if (useRaw) return this._rawExtent[dim].slice();
        dimExtent = this._extent[dim];
        if (dimExtent) return dimExtent.slice();
        dimExtent = initialExtent;
        var min = dimExtent[0];
        var max = dimExtent[1];
        for(var i = 0; i < currEnd; i++){
            var rawIdx = this.getRawIndex(i);
            var value = dimData[rawIdx];
            value < min && (min = value);
            value > max && (max = value);
        }
        dimExtent = [
            min,
            max
        ];
        this._extent[dim] = dimExtent;
        return dimExtent;
    };
    /**
   * Get raw data item
   */ DataStore.prototype.getRawDataItem = function(idx) {
        var rawIdx = this.getRawIndex(idx);
        if (!this._provider.persistent) {
            var val = [];
            var chunks = this._chunks;
            for(var i = 0; i < chunks.length; i++)val.push(chunks[i][rawIdx]);
            return val;
        } else return this._provider.getItem(rawIdx);
    };
    /**
   * Clone shallow.
   *
   * @param clonedDims Determine which dims to clone. Will share the data if not specified.
   */ DataStore.prototype.clone = function(clonedDims, ignoreIndices) {
        var target = new DataStore();
        var chunks = this._chunks;
        var clonedDimsMap = clonedDims && (0, $7a1bd9c2710fea0d$export$533b26079ad0b4b)(clonedDims, function(obj, dimIdx) {
            obj[dimIdx] = true;
            return obj;
        }, {});
        if (clonedDimsMap) for(var i = 0; i < chunks.length; i++)// Not clone if dim is not picked.
        target._chunks[i] = !clonedDimsMap[i] ? chunks[i] : $370e5aa482d8420b$var$cloneChunk(chunks[i]);
        else target._chunks = chunks;
        this._copyCommonProps(target);
        if (!ignoreIndices) target._indices = this._cloneIndices();
        target._updateGetRawIdx();
        return target;
    };
    DataStore.prototype._copyCommonProps = function(target) {
        target._count = this._count;
        target._rawCount = this._rawCount;
        target._provider = this._provider;
        target._dimensions = this._dimensions;
        target._extent = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(this._extent);
        target._rawExtent = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(this._rawExtent);
    };
    DataStore.prototype._cloneIndices = function() {
        if (this._indices) {
            var Ctor = this._indices.constructor;
            var indices = void 0;
            if (Ctor === Array) {
                var thisCount = this._indices.length;
                indices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)indices[i] = this._indices[i];
            } else indices = new Ctor(this._indices);
            return indices;
        }
        return null;
    };
    DataStore.prototype._getRawIdxIdentity = function(idx) {
        return idx;
    };
    DataStore.prototype._getRawIdx = function(idx) {
        if (idx < this._count && idx >= 0) return this._indices[idx];
        return -1;
    };
    DataStore.prototype._updateGetRawIdx = function() {
        this.getRawIndex = this._indices ? this._getRawIdx : this._getRawIdxIdentity;
    };
    DataStore.internalField = function() {
        function getDimValueSimply(dataItem, property, dataIndex, dimIndex) {
            return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(dataItem[dimIndex], this._dimensions[dimIndex]);
        }
        $370e5aa482d8420b$var$defaultDimValueGetters = {
            arrayRows: getDimValueSimply,
            objectRows: function(dataItem, property, dataIndex, dimIndex) {
                return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(dataItem[property], this._dimensions[dimIndex]);
            },
            keyedColumns: getDimValueSimply,
            original: function(dataItem, property, dataIndex, dimIndex) {
                // Performance sensitive, do not use modelUtil.getDataItemValue.
                // If dataItem is an plain object with no value field, the let `value`
                // will be assigned with the object, but it will be tread correctly
                // in the `convertValue`.
                var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value);
                return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(value instanceof Array ? value[dimIndex] : value, this._dimensions[dimIndex]);
            },
            typedArray: function(dataItem, property, dataIndex, dimIndex) {
                return dataItem[dimIndex];
            }
        };
    }();
    return DataStore;
}();
var $370e5aa482d8420b$export$2e2bcd8739ae039 = $370e5aa482d8420b$var$DataStore;



/**
 * [REQUIREMENT_MEMO]:
 * (0) `metaRawOption` means `dimensions`/`sourceHeader`/`seriesLayoutBy` in raw option.
 * (1) Keep support the feature: `metaRawOption` can be specified both on `series` and
 * `root-dataset`. Them on `series` has higher priority.
 * (2) Do not support to set `metaRawOption` on a `non-root-dataset`, because it might
 * confuse users: whether those props indicate how to visit the upstream source or visit
 * the transform result source, and some transforms has nothing to do with these props,
 * and some transforms might have multiple upstream.
 * (3) Transforms should specify `metaRawOption` in each output, just like they can be
 * declared in `root-dataset`.
 * (4) At present only support visit source in `SERIES_LAYOUT_BY_COLUMN` in transforms.
 * That is for reducing complexity in transforms.
 * PENDING: Whether to provide transposition transform?
 *
 * [IMPLEMENTAION_MEMO]:
 * "sourceVisitConfig" are calculated from `metaRawOption` and `data`.
 * They will not be calculated until `source` is about to be visited (to prevent from
 * duplicate calcuation). `source` is visited only in series and input to transforms.
 *
 * [DIMENSION_INHERIT_RULE]:
 * By default the dimensions are inherited from ancestors, unless a transform return
 * a new dimensions definition.
 * Consider the case:
 * ```js
 * dataset: [{
 *     source: [ ['Product', 'Sales', 'Prise'], ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * dataset: [{
 *     dimension: ['Product', 'Sales', 'Prise'],
 *     source: [ ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * ```
 * The two types of option should have the same behavior after transform.
 *
 *
 * [SCENARIO]:
 * (1) Provide source data directly:
 * ```js
 * series: {
 *     encode: {...},
 *     dimensions: [...]
 *     seriesLayoutBy: 'row',
 *     data: [[...]]
 * }
 * ```
 * (2) Series refer to dataset.
 * ```js
 * series: [{
 *     encode: {...}
 *     // Ignore datasetIndex means `datasetIndex: 0`
 *     // and the dimensions defination in dataset is used
 * }, {
 *     encode: {...},
 *     seriesLayoutBy: 'column',
 *     datasetIndex: 1
 * }]
 * ```
 * (3) dataset transform
 * ```js
 * dataset: [{
 *     source: [...]
 * }, {
 *     source: [...]
 * }, {
 *     // By default from 0.
 *     transform: { type: 'filter', config: {...} }
 * }, {
 *     // Piped.
 *     transform: [
 *         { type: 'filter', config: {...} },
 *         { type: 'sort', config: {...} }
 *     ]
 * }, {
 *     id: 'regressionData',
 *     fromDatasetIndex: 1,
 *     // Third-party transform
 *     transform: { type: 'ecStat:regression', config: {...} }
 * }, {
 *     // retrieve the extra result.
 *     id: 'regressionFormula',
 *     fromDatasetId: 'regressionData',
 *     fromTransformResult: 1
 * }]
 * ```
 */ var $1c87d176de397e7e$export$af4db9ec7e200ea2 = /** @class */ function() {
    function SourceManager(sourceHost) {
        // Cached source. Do not repeat calculating if not dirty.
        this._sourceList = [];
        this._storeList = [];
        // version sign of each upstream source manager.
        this._upstreamSignList = [];
        this._versionSignBase = 0;
        this._dirty = true;
        this._sourceHost = sourceHost;
    }
    /**
   * Mark dirty.
   */ SourceManager.prototype.dirty = function() {
        this._setLocalSource([], []);
        this._storeList = [];
        this._dirty = true;
    };
    SourceManager.prototype._setLocalSource = function(sourceList, upstreamSignList) {
        this._sourceList = sourceList;
        this._upstreamSignList = upstreamSignList;
        this._versionSignBase++;
        if (this._versionSignBase > 9e10) this._versionSignBase = 0;
    };
    /**
   * For detecting whether the upstream source is dirty, so that
   * the local cached source (in `_sourceList`) should be discarded.
   */ SourceManager.prototype._getVersionSign = function() {
        return this._sourceHost.uid + "_" + this._versionSignBase;
    };
    /**
   * Always return a source instance. Otherwise throw error.
   */ SourceManager.prototype.prepareSource = function() {
        // For the case that call `setOption` multiple time but no data changed,
        // cache the result source to prevent from repeating transform.
        if (this._isDirty()) {
            this._createSource();
            this._dirty = false;
        }
    };
    SourceManager.prototype._createSource = function() {
        this._setLocalSource([], []);
        var sourceHost = this._sourceHost;
        var upSourceMgrList = this._getUpstreamSourceManagers();
        var hasUpstream = !!upSourceMgrList.length;
        var resultSourceList;
        var upstreamSignList;
        if ($1c87d176de397e7e$var$isSeries(sourceHost)) {
            var seriesModel = sourceHost;
            var data = void 0;
            var sourceFormat = void 0;
            var upSource = void 0;
            // Has upstream dataset
            if (hasUpstream) {
                var upSourceMgr = upSourceMgrList[0];
                upSourceMgr.prepareSource();
                upSource = upSourceMgr.getSource();
                data = upSource.data;
                sourceFormat = upSource.sourceFormat;
                upstreamSignList = [
                    upSourceMgr._getVersionSign()
                ];
            } else {
                data = seriesModel.get("data", true);
                sourceFormat = (0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(data) ? (0, $cab29724515ce2b8$export$a918cb016a382d45) : (0, $cab29724515ce2b8$export$2823037fb9d8f0c6);
                upstreamSignList = [];
            }
            // See [REQUIREMENT_MEMO], merge settings on series and parent dataset if it is root.
            var newMetaRawOption = this._getSourceMetaRawOption() || {};
            var upMetaRawOption = upSource && upSource.metaRawOption || {};
            var seriesLayoutBy = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(newMetaRawOption.seriesLayoutBy, upMetaRawOption.seriesLayoutBy) || null;
            var sourceHeader = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(newMetaRawOption.sourceHeader, upMetaRawOption.sourceHeader);
            // Note here we should not use `upSource.dimensionsDefine`. Consider the case:
            // `upSource.dimensionsDefine` is detected by `seriesLayoutBy: 'column'`,
            // but series need `seriesLayoutBy: 'row'`.
            var dimensions = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(newMetaRawOption.dimensions, upMetaRawOption.dimensions);
            // We share source with dataset as much as possible
            // to avoid extra memory cost of high dimensional data.
            var needsCreateSource = seriesLayoutBy !== upMetaRawOption.seriesLayoutBy || !!sourceHeader !== !!upMetaRawOption.sourceHeader || dimensions;
            resultSourceList = needsCreateSource ? [
                (0, $99e22f5c2aa5094b$export$1921362e86c73c88)(data, {
                    seriesLayoutBy: seriesLayoutBy,
                    sourceHeader: sourceHeader,
                    dimensions: dimensions
                }, sourceFormat)
            ] : [];
        } else {
            var datasetModel = sourceHost;
            // Has upstream dataset.
            if (hasUpstream) {
                var result = this._applyTransform(upSourceMgrList);
                resultSourceList = result.sourceList;
                upstreamSignList = result.upstreamSignList;
            } else {
                var sourceData = datasetModel.get("source", true);
                resultSourceList = [
                    (0, $99e22f5c2aa5094b$export$1921362e86c73c88)(sourceData, this._getSourceMetaRawOption(), null)
                ];
                upstreamSignList = [];
            }
        }
        this._setLocalSource(resultSourceList, upstreamSignList);
    };
    SourceManager.prototype._applyTransform = function(upMgrList) {
        var datasetModel = this._sourceHost;
        var transformOption = datasetModel.get("transform", true);
        var fromTransformResult = datasetModel.get("fromTransformResult", true);
        if (fromTransformResult != null) {
            var errMsg = "";
            if (upMgrList.length !== 1) $1c87d176de397e7e$var$doThrow(errMsg);
        }
        var sourceList;
        var upSourceList = [];
        var upstreamSignList = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(upMgrList, function(upMgr) {
            upMgr.prepareSource();
            var upSource = upMgr.getSource(fromTransformResult || 0);
            var errMsg = "";
            if (fromTransformResult != null && !upSource) $1c87d176de397e7e$var$doThrow(errMsg);
            upSourceList.push(upSource);
            upstreamSignList.push(upMgr._getVersionSign());
        });
        if (transformOption) sourceList = (0, $523dedd0a2328c06$export$42a68f09db16803f)(transformOption, upSourceList, {
            datasetIndex: datasetModel.componentIndex
        });
        else if (fromTransformResult != null) sourceList = [
            (0, $99e22f5c2aa5094b$export$e0365e7e3555ddd4)(upSourceList[0])
        ];
        return {
            sourceList: sourceList,
            upstreamSignList: upstreamSignList
        };
    };
    SourceManager.prototype._isDirty = function() {
        if (this._dirty) return true;
        // All sourceList is from the some upstream.
        var upSourceMgrList = this._getUpstreamSourceManagers();
        for(var i = 0; i < upSourceMgrList.length; i++){
            var upSrcMgr = upSourceMgrList[i];
            if (// Consider the case that there is ancestor diry, call it recursively.
            // The performance is probably not an issue because usually the chain is not long.
            upSrcMgr._isDirty() || this._upstreamSignList[i] !== upSrcMgr._getVersionSign()) return true;
        }
    };
    /**
   * @param sourceIndex By default 0, means "main source".
   *                    In most cases there is only one source.
   */ SourceManager.prototype.getSource = function(sourceIndex) {
        sourceIndex = sourceIndex || 0;
        var source = this._sourceList[sourceIndex];
        if (!source) {
            // Series may share source instance with dataset.
            var upSourceMgrList = this._getUpstreamSourceManagers();
            return upSourceMgrList[0] && upSourceMgrList[0].getSource(sourceIndex);
        }
        return source;
    };
    /**
   *
   * Get a data store which can be shared across series.
   * Only available for series.
   *
   * @param seriesDimRequest Dimensions that are generated in series.
   *        Should have been sorted by `storeDimIndex` asc.
   */ SourceManager.prototype.getSharedDataStore = function(seriesDimRequest) {
        var schema = seriesDimRequest.makeStoreSchema();
        return this._innerGetDataStore(schema.dimensions, seriesDimRequest.source, schema.hash);
    };
    SourceManager.prototype._innerGetDataStore = function(storeDims, seriesSource, sourceReadKey) {
        // TODO Can use other sourceIndex?
        var sourceIndex = 0;
        var storeList = this._storeList;
        var cachedStoreMap = storeList[sourceIndex];
        if (!cachedStoreMap) cachedStoreMap = storeList[sourceIndex] = {};
        var cachedStore = cachedStoreMap[sourceReadKey];
        if (!cachedStore) {
            var upSourceMgr = this._getUpstreamSourceManagers()[0];
            if ($1c87d176de397e7e$var$isSeries(this._sourceHost) && upSourceMgr) cachedStore = upSourceMgr._innerGetDataStore(storeDims, seriesSource, sourceReadKey);
            else {
                cachedStore = new (0, $370e5aa482d8420b$export$2e2bcd8739ae039)();
                // Always create store from source of series.
                cachedStore.initData(new (0, $8ffb0d67e9446edb$export$b900d7c4c3952a40)(seriesSource, storeDims.length), storeDims);
            }
            cachedStoreMap[sourceReadKey] = cachedStore;
        }
        return cachedStore;
    };
    /**
   * PENDING: Is it fast enough?
   * If no upstream, return empty array.
   */ SourceManager.prototype._getUpstreamSourceManagers = function() {
        // Always get the relationship from the raw option.
        // Do not cache the link of the dependency graph, so that
        // there is no need to update them when change happens.
        var sourceHost = this._sourceHost;
        if ($1c87d176de397e7e$var$isSeries(sourceHost)) {
            var datasetModel = (0, $7dc6cdfd7450ef29$export$8da66f73a1eda454)(sourceHost);
            return !datasetModel ? [] : [
                datasetModel.getSourceManager()
            ];
        } else return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7dc6cdfd7450ef29$export$397ba553479711e7)(sourceHost), function(datasetModel) {
            return datasetModel.getSourceManager();
        });
    };
    SourceManager.prototype._getSourceMetaRawOption = function() {
        var sourceHost = this._sourceHost;
        var seriesLayoutBy;
        var sourceHeader;
        var dimensions;
        if ($1c87d176de397e7e$var$isSeries(sourceHost)) {
            seriesLayoutBy = sourceHost.get("seriesLayoutBy", true);
            sourceHeader = sourceHost.get("sourceHeader", true);
            dimensions = sourceHost.get("dimensions", true);
        } else if (!this._getUpstreamSourceManagers().length) {
            var model = sourceHost;
            seriesLayoutBy = model.get("seriesLayoutBy", true);
            sourceHeader = model.get("sourceHeader", true);
            dimensions = model.get("dimensions", true);
        }
        return {
            seriesLayoutBy: seriesLayoutBy,
            sourceHeader: sourceHeader,
            dimensions: dimensions
        };
    };
    return SourceManager;
}();
function $1c87d176de397e7e$export$9451f4e9047441ec(datasetModel) {
    var transformOption = datasetModel.option.transform;
    transformOption && (0, $7a1bd9c2710fea0d$export$112e66431016387b)(datasetModel.option.transform);
}
function $1c87d176de397e7e$var$isSeries(sourceHost) {
    // Avoid circular dependency with Series.ts
    return sourceHost.mainType === "series";
}
function $1c87d176de397e7e$var$doThrow(errMsg) {
    throw new Error(errMsg);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $d5ab84c08d6657ec$var$TOOLTIP_LINE_HEIGHT_CSS = "line-height:1";
function $d5ab84c08d6657ec$var$getTooltipLineHeight(textStyle) {
    var lineHeight = textStyle.lineHeight;
    if (lineHeight == null) return $d5ab84c08d6657ec$var$TOOLTIP_LINE_HEIGHT_CSS;
    else return "line-height:" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(lineHeight + "") + "px";
}
// TODO: more textStyle option
function $d5ab84c08d6657ec$var$getTooltipTextStyle(textStyle, renderMode) {
    var nameFontColor = textStyle.color || (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.tertiary;
    var nameFontSize = textStyle.fontSize || 12;
    var nameFontWeight = textStyle.fontWeight || "400";
    var valueFontColor = textStyle.color || (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.secondary;
    var valueFontSize = textStyle.fontSize || 14;
    var valueFontWeight = textStyle.fontWeight || "900";
    if (renderMode === "html") // `textStyle` is probably from user input, should be encoded to reduce security risk.
    return {
        // eslint-disable-next-line max-len
        nameStyle: "font-size:" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(nameFontSize + "") + "px;color:" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(nameFontColor) + ";font-weight:" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(nameFontWeight + ""),
        // eslint-disable-next-line max-len
        valueStyle: "font-size:" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(valueFontSize + "") + "px;color:" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(valueFontColor) + ";font-weight:" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(valueFontWeight + "")
    };
    else return {
        nameStyle: {
            fontSize: nameFontSize,
            fill: nameFontColor,
            fontWeight: nameFontWeight
        },
        valueStyle: {
            fontSize: valueFontSize,
            fill: valueFontColor,
            fontWeight: valueFontWeight
        }
    };
}
// See `TooltipMarkupLayoutIntent['innerGapLevel']`.
// (value from UI design)
var $d5ab84c08d6657ec$var$HTML_GAPS = [
    0,
    10,
    20,
    30
];
var $d5ab84c08d6657ec$var$RICH_TEXT_GAPS = [
    "",
    "\n",
    "\n\n",
    "\n\n\n"
];
function $d5ab84c08d6657ec$export$cf63b23ce77d1921(type, option) {
    option.type = type;
    return option;
}
function $d5ab84c08d6657ec$var$isSectionFragment(frag) {
    return frag.type === "section";
}
function $d5ab84c08d6657ec$var$getBuilder(frag) {
    return $d5ab84c08d6657ec$var$isSectionFragment(frag) ? $d5ab84c08d6657ec$var$buildSection : $d5ab84c08d6657ec$var$buildNameValue;
}
function $d5ab84c08d6657ec$var$getBlockGapLevel(frag) {
    if ($d5ab84c08d6657ec$var$isSectionFragment(frag)) {
        var gapLevel_1 = 0;
        var subBlockLen = frag.blocks.length;
        var hasInnerGap_1 = subBlockLen > 1 || subBlockLen > 0 && !frag.noHeader;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(frag.blocks, function(subBlock) {
            var subGapLevel = $d5ab84c08d6657ec$var$getBlockGapLevel(subBlock);
            // If the some of the sub-blocks have some gaps (like 10px) inside, this block
            // should use a larger gap (like 20px) to distinguish those sub-blocks.
            if (subGapLevel >= gapLevel_1) gapLevel_1 = subGapLevel + +(hasInnerGap_1 && // 0 always can not be readable gap level.
            (!subGapLevel || $d5ab84c08d6657ec$var$isSectionFragment(subBlock) && !subBlock.noHeader));
        });
        return gapLevel_1;
    }
    return 0;
}
function $d5ab84c08d6657ec$var$buildSection(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
    var noHeader = fragment.noHeader;
    var gaps = $d5ab84c08d6657ec$var$getGap($d5ab84c08d6657ec$var$getBlockGapLevel(fragment));
    var subMarkupTextList = [];
    var subBlocks = fragment.blocks || [];
    (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(!subBlocks || (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(subBlocks));
    subBlocks = subBlocks || [];
    var orderMode = ctx.orderMode;
    if (fragment.sortBlocks && orderMode) {
        subBlocks = subBlocks.slice();
        var orderMap = {
            valueAsc: "asc",
            valueDesc: "desc"
        };
        if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(orderMap, orderMode)) {
            var comparator_1 = new (0, $40ab59f44b7d2db6$export$ed75a5d7b0144167)(orderMap[orderMode], null);
            subBlocks.sort(function(a, b) {
                return comparator_1.evaluate(a.sortParam, b.sortParam);
            });
        } else if (orderMode === "seriesDesc") subBlocks.reverse();
    }
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(subBlocks, function(subBlock, idx) {
        var valueFormatter = fragment.valueFormatter;
        var subMarkupText = $d5ab84c08d6657ec$var$getBuilder(subBlock)(// Inherit valueFormatter
        valueFormatter ? (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, ctx), {
            valueFormatter: valueFormatter
        }) : ctx, subBlock, idx > 0 ? gaps.html : 0, toolTipTextStyle);
        subMarkupText != null && subMarkupTextList.push(subMarkupText);
    });
    var subMarkupText = ctx.renderMode === "richText" ? subMarkupTextList.join(gaps.richText) : $d5ab84c08d6657ec$var$wrapBlockHTML(toolTipTextStyle, subMarkupTextList.join(""), noHeader ? topMarginForOuterGap : gaps.html);
    if (noHeader) return subMarkupText;
    var displayableHeader = (0, $c84c9521536c601a$export$3cd8db88714decfc)(fragment.header, "ordinal", ctx.useUTC);
    var nameStyle = $d5ab84c08d6657ec$var$getTooltipTextStyle(toolTipTextStyle, ctx.renderMode).nameStyle;
    var tooltipLineHeight = $d5ab84c08d6657ec$var$getTooltipLineHeight(toolTipTextStyle);
    if (ctx.renderMode === "richText") return $d5ab84c08d6657ec$var$wrapInlineNameRichText(ctx, displayableHeader, nameStyle) + gaps.richText + subMarkupText;
    else return $d5ab84c08d6657ec$var$wrapBlockHTML(toolTipTextStyle, '<div style="' + nameStyle + ";" + tooltipLineHeight + ';">' + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(displayableHeader) + "</div>" + subMarkupText, topMarginForOuterGap);
}
function $d5ab84c08d6657ec$var$buildNameValue(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
    var renderMode = ctx.renderMode;
    var noName = fragment.noName;
    var noValue = fragment.noValue;
    var noMarker = !fragment.markerType;
    var name = fragment.name;
    var useUTC = ctx.useUTC;
    var valueFormatter = fragment.valueFormatter || ctx.valueFormatter || function(value) {
        value = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(value) ? value : [
            value
        ];
        return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(value, function(val, idx) {
            return (0, $c84c9521536c601a$export$3cd8db88714decfc)(val, (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(valueTypeOption) ? valueTypeOption[idx] : valueTypeOption, useUTC);
        });
    };
    if (noName && noValue) return;
    var markerStr = noMarker ? "" : ctx.markupStyleCreator.makeTooltipMarker(fragment.markerType, fragment.markerColor || (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.secondary, renderMode);
    var readableName = noName ? "" : (0, $c84c9521536c601a$export$3cd8db88714decfc)(name, "ordinal", useUTC);
    var valueTypeOption = fragment.valueType;
    var readableValueList = noValue ? [] : valueFormatter(fragment.value, fragment.dataIndex);
    var valueAlignRight = !noMarker || !noName;
    // It little weird if only value next to marker but far from marker.
    var valueCloseToMarker = !noMarker && noName;
    var _a = $d5ab84c08d6657ec$var$getTooltipTextStyle(toolTipTextStyle, renderMode), nameStyle = _a.nameStyle, valueStyle = _a.valueStyle;
    return renderMode === "richText" ? (noMarker ? "" : markerStr) + (noName ? "" : $d5ab84c08d6657ec$var$wrapInlineNameRichText(ctx, readableName, nameStyle)) + (noValue ? "" : $d5ab84c08d6657ec$var$wrapInlineValueRichText(ctx, readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)) : $d5ab84c08d6657ec$var$wrapBlockHTML(toolTipTextStyle, (noMarker ? "" : markerStr) + (noName ? "" : $d5ab84c08d6657ec$var$wrapInlineNameHTML(readableName, !noMarker, nameStyle)) + (noValue ? "" : $d5ab84c08d6657ec$var$wrapInlineValueHTML(readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)), topMarginForOuterGap);
}
function $d5ab84c08d6657ec$export$6969ffb02c1cb49a(fragment, markupStyleCreator, renderMode, orderMode, useUTC, toolTipTextStyle) {
    if (!fragment) return;
    var builder = $d5ab84c08d6657ec$var$getBuilder(fragment);
    var ctx = {
        useUTC: useUTC,
        renderMode: renderMode,
        orderMode: orderMode,
        markupStyleCreator: markupStyleCreator,
        valueFormatter: fragment.valueFormatter
    };
    return builder(ctx, fragment, 0, toolTipTextStyle);
}
function $d5ab84c08d6657ec$var$getGap(gapLevel) {
    return {
        html: $d5ab84c08d6657ec$var$HTML_GAPS[gapLevel],
        richText: $d5ab84c08d6657ec$var$RICH_TEXT_GAPS[gapLevel]
    };
}
function $d5ab84c08d6657ec$var$wrapBlockHTML(textStyle, encodedContent, topGap) {
    var clearfix = '<div style="clear:both"></div>';
    var marginCSS = "margin: " + topGap + "px 0 0";
    var tooltipLineHeight = $d5ab84c08d6657ec$var$getTooltipLineHeight(textStyle);
    return '<div style="' + marginCSS + ";" + tooltipLineHeight + ';">' + encodedContent + clearfix + "</div>";
}
function $d5ab84c08d6657ec$var$wrapInlineNameHTML(name, leftHasMarker, style) {
    var marginCss = leftHasMarker ? "margin-left:2px" : "";
    return '<span style="' + style + ";" + marginCss + '">' + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(name) + "</span>";
}
function $d5ab84c08d6657ec$var$wrapInlineValueHTML(valueList, alignRight, valueCloseToMarker, style) {
    // Do not too close to marker, considering there are multiple values separated by spaces.
    var paddingStr = valueCloseToMarker ? "10px" : "20px";
    var alignCSS = alignRight ? "float:right;margin-left:" + paddingStr : "";
    valueList = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(valueList) ? valueList : [
        valueList
    ];
    return '<span style="' + alignCSS + ";" + style + '">' + (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(valueList, function(value) {
        return (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(value);
    }).join("&nbsp;&nbsp;") + "</span>";
}
function $d5ab84c08d6657ec$var$wrapInlineNameRichText(ctx, name, style) {
    return ctx.markupStyleCreator.wrapRichTextStyle(name, style);
}
function $d5ab84c08d6657ec$var$wrapInlineValueRichText(ctx, values, alignRight, valueCloseToMarker, style) {
    var styles = [
        style
    ];
    var paddingLeft = valueCloseToMarker ? 10 : 20;
    alignRight && styles.push({
        padding: [
            0,
            0,
            0,
            paddingLeft
        ],
        align: "right"
    });
    // Value has commas inside, so use '  ' as delimiter for multiple values.
    return ctx.markupStyleCreator.wrapRichTextStyle((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(values) ? values.join("  ") : values, styles);
}
function $d5ab84c08d6657ec$export$ea15628039c0fa93(series, dataIndex) {
    var style = series.getData().getItemVisual(dataIndex, "style");
    var color = style[series.visualDrawType];
    return (0, $c84c9521536c601a$export$cda04d03233e5555)(color);
}
function $d5ab84c08d6657ec$export$3048212c802df496(model, renderMode) {
    var padding = model.get("padding");
    return padding != null ? padding : renderMode === "richText" ? [
        8,
        10
    ] : 10;
}
/**
 * The major feature is generate styles for `renderMode: 'richText'`.
 * But it also serves `renderMode: 'html'` to provide
 * "renderMode-independent" API.
 */ var $d5ab84c08d6657ec$export$2fba3afbcdcf3e18 = /** @class */ function() {
    function TooltipMarkupStyleCreator() {
        this.richTextStyles = {};
        // Notice that "generate a style name" usually happens repeatedly when mouse is moving and
        // a tooltip is displayed. So we put the `_nextStyleNameId` as a member of each creator
        // rather than static shared by all creators (which will cause it increase to fast).
        this._nextStyleNameId = (0, $cfc1f3b422a3185f$export$474d2ec9aa44a22)();
    }
    TooltipMarkupStyleCreator.prototype._generateStyleName = function() {
        return "__EC_aUTo_" + this._nextStyleNameId++;
    };
    TooltipMarkupStyleCreator.prototype.makeTooltipMarker = function(markerType, colorStr, renderMode) {
        var markerId = renderMode === "richText" ? this._generateStyleName() : null;
        var marker = (0, $c84c9521536c601a$export$1987a3dbdf3c45ca)({
            color: colorStr,
            type: markerType,
            renderMode: renderMode,
            markerId: markerId
        });
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(marker)) return marker;
        else {
            this.richTextStyles[markerId] = marker.style;
            return marker.content;
        }
    };
    /**
   * @usage
   * ```ts
   * const styledText = markupStyleCreator.wrapRichTextStyle([
   *     // The styles will be auto merged.
   *     {
   *         fontSize: 12,
   *         color: 'blue'
   *     },
   *     {
   *         padding: 20
   *     }
   * ]);
   * ```
   */ TooltipMarkupStyleCreator.prototype.wrapRichTextStyle = function(text, styles) {
        var finalStl = {};
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(styles)) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(styles, function(stl) {
            return (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(finalStl, stl);
        });
        else (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(finalStl, styles);
        var styleName = this._generateStyleName();
        this.richTextStyles[styleName] = finalStl;
        return "{" + styleName + "|" + text + "}";
    };
    return TooltipMarkupStyleCreator;
}();




function $b0d4c63a14430ca1$export$3a110b9fb5c88b34(opt) {
    var series = opt.series;
    var dataIndex = opt.dataIndex;
    var multipleSeries = opt.multipleSeries;
    var data = series.getData();
    var tooltipDims = data.mapDimensionsAll("defaultedTooltip");
    var tooltipDimLen = tooltipDims.length;
    var value = series.getRawValue(dataIndex);
    var isValueArr = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(value);
    var markerColor = (0, $d5ab84c08d6657ec$export$ea15628039c0fa93)(series, dataIndex);
    // Complicated rule for pretty tooltip.
    var inlineValue;
    var inlineValueType;
    var subBlocks;
    var sortParam;
    if (tooltipDimLen > 1 || isValueArr && !tooltipDimLen) {
        var formatArrResult = $b0d4c63a14430ca1$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, markerColor);
        inlineValue = formatArrResult.inlineValues;
        inlineValueType = formatArrResult.inlineValueTypes;
        subBlocks = formatArrResult.blocks;
        // Only support tooltip sort by the first inline value. It's enough in most cases.
        sortParam = formatArrResult.inlineValues[0];
    } else if (tooltipDimLen) {
        var dimInfo = data.getDimensionInfo(tooltipDims[0]);
        sortParam = inlineValue = (0, $8ffb0d67e9446edb$export$cde9373da9aad801)(data, dataIndex, tooltipDims[0]);
        inlineValueType = dimInfo.type;
    } else sortParam = inlineValue = isValueArr ? value[0] : value;
    // Do not show generated series name. It might not be readable.
    var seriesNameSpecified = (0, $76d619f648247e6d$export$beae19a2652b3368)(series);
    var seriesName = seriesNameSpecified && series.name || "";
    var itemName = data.getName(dataIndex);
    var inlineName = multipleSeries ? seriesName : itemName;
    return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("section", {
        header: seriesName,
        // When series name is not specified, do not show a header line with only '-'.
        // This case always happens in tooltip.trigger: 'item'.
        noHeader: multipleSeries || !seriesNameSpecified,
        sortParam: sortParam,
        blocks: [
            (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
                markerType: "item",
                markerColor: markerColor,
                // Do not mix display seriesName and itemName in one tooltip,
                // which might confuses users.
                name: inlineName,
                // name dimension might be auto assigned, where the name might
                // be not readable. So we check trim here.
                noName: !(0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(inlineName),
                value: inlineValue,
                valueType: inlineValueType,
                dataIndex: dataIndex
            })
        ].concat(subBlocks || [])
    });
}
function $b0d4c63a14430ca1$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, colorStr) {
    // check: category-no-encode-has-axis-data in dataset.html
    var data = series.getData();
    var isValueMultipleLine = (0, $7a1bd9c2710fea0d$export$533b26079ad0b4b)(value, function(isValueMultipleLine, val, idx) {
        var dimItem = data.getDimensionInfo(idx);
        return isValueMultipleLine = isValueMultipleLine || dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
    }, false);
    var inlineValues = [];
    var inlineValueTypes = [];
    var blocks = [];
    tooltipDims.length ? (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(tooltipDims, function(dim) {
        setEachItem((0, $8ffb0d67e9446edb$export$cde9373da9aad801)(data, dataIndex, dim), dim);
    }) : (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(value, setEachItem);
    function setEachItem(val, dim) {
        var dimInfo = data.getDimensionInfo(dim);
        // If `dimInfo.tooltip` is not set, show tooltip.
        if (!dimInfo || dimInfo.otherDims.tooltip === false) return;
        if (isValueMultipleLine) blocks.push((0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
            markerType: "subItem",
            markerColor: colorStr,
            name: dimInfo.displayName,
            value: val,
            valueType: dimInfo.type
        }));
        else {
            inlineValues.push(val);
            inlineValueTypes.push(dimInfo.type);
        }
    }
    return {
        inlineValues: inlineValues,
        inlineValueTypes: inlineValueTypes,
        blocks: blocks
    };
}


var $7c10febb2cdef0d8$var$inner = $76d619f648247e6d$export$64df9f8d92ae083f();
function $7c10febb2cdef0d8$var$getSelectionKey(data, dataIndex) {
    return data.getName(dataIndex) || data.getId(dataIndex);
}
var $7c10febb2cdef0d8$export$e960441116ae2799 = "__universalTransitionEnabled";
var $7c10febb2cdef0d8$var$SeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SeriesModel, _super);
    function SeriesModel() {
        // [Caution]: Because this class or desecendants can be used as `XXX.extend(subProto)`,
        // the class members must not be initialized in constructor or declaration place.
        // Otherwise there is bad case:
        //   class A {xxx = 1;}
        //   enableClassExtend(A);
        //   class B extends A {}
        //   var C = B.extend({xxx: 5});
        //   var c = new C();
        //   console.log(c.xxx); // expect 5 but always 1.
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // ---------------------------------------
        // Props about data selection
        // ---------------------------------------
        _this._selectedDataIndicesMap = {};
        return _this;
    }
    SeriesModel.prototype.init = function(option, parentModel, ecModel) {
        this.seriesIndex = this.componentIndex;
        this.dataTask = (0, $4d16404c851dcec6$export$f7292ab7796be73c)({
            count: $7c10febb2cdef0d8$var$dataTaskCount,
            reset: $7c10febb2cdef0d8$var$dataTaskReset
        });
        this.dataTask.context = {
            model: this
        };
        this.mergeDefaultAndTheme(option, ecModel);
        var sourceManager = $7c10febb2cdef0d8$var$inner(this).sourceManager = new (0, $1c87d176de397e7e$export$af4db9ec7e200ea2)(this);
        sourceManager.prepareSource();
        var data = this.getInitialData(option, ecModel);
        $7c10febb2cdef0d8$var$wrapData(data, this);
        this.dataTask.context.data = data;
        $7c10febb2cdef0d8$var$inner(this).dataBeforeProcessed = data;
        // If we reverse the order (make data firstly, and then make
        // dataBeforeProcessed by cloneShallow), cloneShallow will
        // cause data.graph.data !== data when using
        // module:echarts/data/Graph or module:echarts/data/Tree.
        // See module:echarts/data/helper/linkSeriesData
        // Theoretically, it is unreasonable to call `seriesModel.getData()` in the model
        // init or merge stage, because the data can be restored. So we do not `restoreData`
        // and `setData` here, which forbids calling `seriesModel.getData()` in this stage.
        // Call `seriesModel.getRawData()` instead.
        // this.restoreData();
        $7c10febb2cdef0d8$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    /**
   * Util for merge default and theme to option
   */ SeriesModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = (0, $93b9bc7f22ac7369$export$3968a28a7cbd6063)(this);
        var inputPositionParams = layoutMode ? (0, $93b9bc7f22ac7369$export$4b0d20af19c9875e)(option) : {};
        // Backward compat: using subType on theme.
        // But if name duplicate between series subType
        // (for example: parallel) add component mainType,
        // add suffix 'Series'.
        var themeSubType = this.subType;
        if ((0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(themeSubType)) themeSubType += "Series";
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(option, ecModel.getTheme().get(this.subType));
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(option, this.getDefaultOption());
        // Default label emphasis `show`
        $76d619f648247e6d$export$abdcc6a26372f94b(option, "label", [
            "show"
        ]);
        this.fillDataTextStyle(option.data);
        if (layoutMode) (0, $93b9bc7f22ac7369$export$1754cb91f16ca028)(option, inputPositionParams, layoutMode);
    };
    SeriesModel.prototype.mergeOption = function(newSeriesOption, ecModel) {
        // this.settingTask.dirty();
        newSeriesOption = $7a1bd9c2710fea0d$export$4950aa0f605343fb(this.option, newSeriesOption, true);
        this.fillDataTextStyle(newSeriesOption.data);
        var layoutMode = (0, $93b9bc7f22ac7369$export$3968a28a7cbd6063)(this);
        if (layoutMode) (0, $93b9bc7f22ac7369$export$1754cb91f16ca028)(this.option, newSeriesOption, layoutMode);
        var sourceManager = $7c10febb2cdef0d8$var$inner(this).sourceManager;
        sourceManager.dirty();
        sourceManager.prepareSource();
        var data = this.getInitialData(newSeriesOption, ecModel);
        $7c10febb2cdef0d8$var$wrapData(data, this);
        this.dataTask.dirty();
        this.dataTask.context.data = data;
        $7c10febb2cdef0d8$var$inner(this).dataBeforeProcessed = data;
        $7c10febb2cdef0d8$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    SeriesModel.prototype.fillDataTextStyle = function(data) {
        // Default data label emphasis `show`
        // FIXME Tree structure data ?
        // FIXME Performance ?
        if (data && !$7a1bd9c2710fea0d$export$b119cc7e1840e59c(data)) {
            var props = [
                "show"
            ];
            for(var i = 0; i < data.length; i++)if (data[i] && data[i].label) $76d619f648247e6d$export$abdcc6a26372f94b(data[i], "label", props);
        }
    };
    /**
   * Init a data structure from data related option in series
   * Must be overridden.
   */ SeriesModel.prototype.getInitialData = function(option, ecModel) {
        return;
    };
    /**
   * Append data to list
   */ SeriesModel.prototype.appendData = function(params) {
        // FIXME ???
        // (1) If data from dataset, forbidden append.
        // (2) support append data of dataset.
        var data = this.getRawData();
        data.appendData(params.data);
    };
    /**
   * Consider some method like `filter`, `map` need make new data,
   * We should make sure that `seriesModel.getData()` get correct
   * data in the stream procedure. So we fetch data from upstream
   * each time `task.perform` called.
   */ SeriesModel.prototype.getData = function(dataType) {
        var task = $7c10febb2cdef0d8$var$getCurrentTask(this);
        if (task) {
            var data = task.context.data;
            return dataType == null || !data.getLinkedData ? data : data.getLinkedData(dataType);
        } else // When series is not alive (that may happen when click toolbox
        // restore or setOption with not merge mode), series data may
        // be still need to judge animation or something when graphic
        // elements want to know whether fade out.
        return $7c10febb2cdef0d8$var$inner(this).data;
    };
    SeriesModel.prototype.getAllData = function() {
        var mainData = this.getData();
        return mainData && mainData.getLinkedDataAll ? mainData.getLinkedDataAll() : [
            {
                data: mainData
            }
        ];
    };
    SeriesModel.prototype.setData = function(data) {
        var task = $7c10febb2cdef0d8$var$getCurrentTask(this);
        if (task) {
            var context = task.context;
            // Consider case: filter, data sample.
            // FIXME:TS never used, so comment it
            // if (context.data !== data && task.modifyOutputEnd) {
            //     task.setOutputEnd(data.count());
            // }
            context.outputData = data;
            // Caution: setData should update context.data,
            // Because getData may be called multiply in a
            // single stage and expect to get the data just
            // set. (For example, AxisProxy, x y both call
            // getData and setDate sequentially).
            // So the context.data should be fetched from
            // upstream each time when a stage starts to be
            // performed.
            if (task !== this.dataTask) context.data = data;
        }
        $7c10febb2cdef0d8$var$inner(this).data = data;
    };
    SeriesModel.prototype.getEncode = function() {
        var encode = this.get("encode", true);
        if (encode) return $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4(encode);
    };
    SeriesModel.prototype.getSourceManager = function() {
        return $7c10febb2cdef0d8$var$inner(this).sourceManager;
    };
    SeriesModel.prototype.getSource = function() {
        return this.getSourceManager().getSource();
    };
    /**
   * Get data before processed
   */ SeriesModel.prototype.getRawData = function() {
        return $7c10febb2cdef0d8$var$inner(this).dataBeforeProcessed;
    };
    SeriesModel.prototype.getColorBy = function() {
        var colorBy = this.get("colorBy");
        return colorBy || "series";
    };
    SeriesModel.prototype.isColorBySeries = function() {
        return this.getColorBy() === "series";
    };
    /**
   * Get base axis if has coordinate system and has axis.
   * By default use coordSys.getBaseAxis();
   * Can be overridden for some chart.
   * @return {type} description
   */ SeriesModel.prototype.getBaseAxis = function() {
        var coordSys = this.coordinateSystem;
        // @ts-ignore
        return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
    };
    /**
   * Retrieve the index of nearest value in the view coordinate.
   * Data position is compared with each axis's dataToCoord.
   *
   * @param axisDim axis dimension
   * @param dim data dimension
   * @param value
   * @param [maxDistance=Infinity] The maximum distance in view coordinate space
   * @return If and only if multiple indices has
   *         the same value, they are put to the result.
   */ SeriesModel.prototype.indicesOfNearest = function(axisDim, dim, value, maxDistance) {
        var data = this.getData();
        var coordSys = this.coordinateSystem;
        var axis = coordSys && coordSys.getAxis(axisDim);
        if (!coordSys || !axis) return [];
        var targetCoord = axis.dataToCoord(value);
        if (maxDistance == null) maxDistance = Infinity;
        var nearestIndices = [];
        var minDist = Infinity;
        var minDiff = -1;
        var nearestIndicesLen = 0;
        data.each(dim, function(dimValue, idx) {
            var dataCoord = axis.dataToCoord(dimValue);
            var diff = targetCoord - dataCoord;
            var dist = Math.abs(diff);
            if (dist <= maxDistance) {
                // When the `value` is at the middle of `this.get(dim, i)` and `this.get(dim, i+1)`,
                // we'd better not push both of them to `nearestIndices`, otherwise it is easy to
                // get more than one item in `nearestIndices` (more specifically, in `tooltip`).
                // So we choose the one that `diff >= 0` in this case.
                // But if `this.get(dim, i)` and `this.get(dim, j)` get the same value, both of them
                // should be push to `nearestIndices`.
                if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
                    minDist = dist;
                    minDiff = diff;
                    nearestIndicesLen = 0;
                }
                if (diff === minDiff) nearestIndices[nearestIndicesLen++] = idx;
            }
        });
        nearestIndices.length = nearestIndicesLen;
        return nearestIndices;
    };
    /**
   * Default tooltip formatter
   *
   * @param dataIndex
   * @param multipleSeries
   * @param dataType
   * @param renderMode valid values: 'html'(by default) and 'richText'.
   *        'html' is used for rendering tooltip in extra DOM form, and the result
   *        string is used as DOM HTML content.
   *        'richText' is used for rendering tooltip in rich text form, for those where
   *        DOM operation is not supported.
   * @return formatted tooltip with `html` and `markers`
   *        Notice: The override method can also return string
   */ SeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        return (0, $b0d4c63a14430ca1$export$3a110b9fb5c88b34)({
            series: this,
            dataIndex: dataIndex,
            multipleSeries: multipleSeries
        });
    };
    SeriesModel.prototype.isAnimationEnabled = function() {
        var ecModel = this.ecModel;
        // Disable animation if using echarts in node but not give ssr flag.
        // In ssr mode, renderToString will generate svg with css animation.
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node && !(ecModel && ecModel.ssr)) return false;
        var animationEnabled = this.getShallow("animation");
        if (animationEnabled) {
            if (this.getData().count() > this.getShallow("animationThreshold")) animationEnabled = false;
        }
        return !!animationEnabled;
    };
    SeriesModel.prototype.restoreData = function() {
        this.dataTask.dirty();
    };
    SeriesModel.prototype.getColorFromPalette = function(name, scope, requestColorNum) {
        var ecModel = this.ecModel;
        // PENDING
        var color = (0, $e7fbd47751ca3c28$export$55a3c39e852b90f4).prototype.getColorFromPalette.call(this, name, scope, requestColorNum);
        if (!color) color = ecModel.getColorFromPalette(name, scope, requestColorNum);
        return color;
    };
    /**
   * Use `data.mapDimensionsAll(coordDim)` instead.
   * @deprecated
   */ SeriesModel.prototype.coordDimToDataDim = function(coordDim) {
        return this.getRawData().mapDimensionsAll(coordDim);
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressive = function() {
        return this.get("progressive");
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressiveThreshold = function() {
        return this.get("progressiveThreshold");
    };
    // PENGING If selectedMode is null ?
    SeriesModel.prototype.select = function(innerDataIndices, dataType) {
        this._innerSelect(this.getData(dataType), innerDataIndices);
    };
    SeriesModel.prototype.unselect = function(innerDataIndices, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return;
        var selectedMode = this.option.selectedMode;
        var data = this.getData(dataType);
        if (selectedMode === "series" || selectedMap === "all") {
            this.option.selectedMap = {};
            this._selectedDataIndicesMap = {};
            return;
        }
        for(var i = 0; i < innerDataIndices.length; i++){
            var dataIndex = innerDataIndices[i];
            var nameOrId = $7c10febb2cdef0d8$var$getSelectionKey(data, dataIndex);
            selectedMap[nameOrId] = false;
            this._selectedDataIndicesMap[nameOrId] = -1;
        }
    };
    SeriesModel.prototype.toggleSelect = function(innerDataIndices, dataType) {
        var tmpArr = [];
        for(var i = 0; i < innerDataIndices.length; i++){
            tmpArr[0] = innerDataIndices[i];
            this.isSelected(innerDataIndices[i], dataType) ? this.unselect(tmpArr, dataType) : this.select(tmpArr, dataType);
        }
    };
    SeriesModel.prototype.getSelectedDataIndices = function() {
        if (this.option.selectedMap === "all") return [].slice.call(this.getData().getIndices());
        var selectedDataIndicesMap = this._selectedDataIndicesMap;
        var nameOrIds = $7a1bd9c2710fea0d$export$ed97f33186d4b816(selectedDataIndicesMap);
        var dataIndices = [];
        for(var i = 0; i < nameOrIds.length; i++){
            var dataIndex = selectedDataIndicesMap[nameOrIds[i]];
            if (dataIndex >= 0) dataIndices.push(dataIndex);
        }
        return dataIndices;
    };
    SeriesModel.prototype.isSelected = function(dataIndex, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return false;
        var data = this.getData(dataType);
        return (selectedMap === "all" || selectedMap[$7c10febb2cdef0d8$var$getSelectionKey(data, dataIndex)]) && !data.getItemModel(dataIndex).get([
            "select",
            "disabled"
        ]);
    };
    SeriesModel.prototype.isUniversalTransitionEnabled = function() {
        if (this[$7c10febb2cdef0d8$export$e960441116ae2799]) return true;
        var universalTransitionOpt = this.option.universalTransition;
        // Quick reject
        if (!universalTransitionOpt) return false;
        if (universalTransitionOpt === true) return true;
        // Can be simply 'universalTransition: true'
        return universalTransitionOpt && universalTransitionOpt.enabled;
    };
    SeriesModel.prototype._innerSelect = function(data, innerDataIndices) {
        var _a, _b;
        var option = this.option;
        var selectedMode = option.selectedMode;
        var len = innerDataIndices.length;
        if (!selectedMode || !len) return;
        if (selectedMode === "series") option.selectedMap = "all";
        else if (selectedMode === "multiple") {
            if (!$7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(option.selectedMap)) option.selectedMap = {};
            var selectedMap = option.selectedMap;
            for(var i = 0; i < len; i++){
                var dataIndex = innerDataIndices[i];
                // TODO different types of data share same object.
                var nameOrId = $7c10febb2cdef0d8$var$getSelectionKey(data, dataIndex);
                selectedMap[nameOrId] = true;
                this._selectedDataIndicesMap[nameOrId] = data.getRawIndex(dataIndex);
            }
        } else if (selectedMode === "single" || selectedMode === true) {
            var lastDataIndex = innerDataIndices[len - 1];
            var nameOrId = $7c10febb2cdef0d8$var$getSelectionKey(data, lastDataIndex);
            option.selectedMap = (_a = {}, _a[nameOrId] = true, _a);
            this._selectedDataIndicesMap = (_b = {}, _b[nameOrId] = data.getRawIndex(lastDataIndex), _b);
        }
    };
    SeriesModel.prototype._initSelectedMapFromData = function(data) {
        // Ignore select info in data if selectedMap exists.
        // NOTE It's only for legacy usage. edge data is not supported.
        if (this.option.selectedMap) return;
        var dataIndices = [];
        if (data.hasItemOption) data.each(function(idx) {
            var rawItem = data.getRawDataItem(idx);
            if (rawItem && rawItem.selected) dataIndices.push(idx);
        });
        if (dataIndices.length > 0) this._innerSelect(data, dataIndices);
    };
    // /**
    //  * @see {module:echarts/stream/Scheduler}
    //  */
    // abstract pipeTask: null
    SeriesModel.registerClass = function(clz) {
        return (0, $116d65051f61bdfe$export$2e2bcd8739ae039).registerClass(clz);
    };
    SeriesModel.protoInitialize = function() {
        var proto = SeriesModel.prototype;
        proto.type = "series.__base__";
        proto.seriesIndex = 0;
        proto.ignoreStyleOnData = false;
        proto.hasSymbolVisual = false;
        proto.defaultSymbol = "circle";
        // Make sure the values can be accessed!
        proto.visualStyleAccessPath = "itemStyle";
        proto.visualDrawType = "fill";
    }();
    return SeriesModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($7c10febb2cdef0d8$var$SeriesModel, (0, $655dd6075cc63601$export$f23396ae04ea95a7));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($7c10febb2cdef0d8$var$SeriesModel, (0, $e7fbd47751ca3c28$export$55a3c39e852b90f4));
(0, $cd5f95cf03b4e3e7$export$c9c2d87774f1275d)($7c10febb2cdef0d8$var$SeriesModel, (0, $116d65051f61bdfe$export$2e2bcd8739ae039));
/**
 * MUST be called after `prepareSource` called
 * Here we need to make auto series, especially for auto legend. But we
 * do not modify series.name in option to avoid side effects.
 */ function $7c10febb2cdef0d8$var$autoSeriesName(seriesModel) {
    // User specified name has higher priority, otherwise it may cause
    // series can not be queried unexpectedly.
    var name = seriesModel.name;
    if (!$76d619f648247e6d$export$beae19a2652b3368(seriesModel)) seriesModel.name = $7c10febb2cdef0d8$var$getSeriesAutoName(seriesModel) || name;
}
function $7c10febb2cdef0d8$var$getSeriesAutoName(seriesModel) {
    var data = seriesModel.getRawData();
    var dataDims = data.mapDimensionsAll("seriesName");
    var nameArr = [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(dataDims, function(dataDim) {
        var dimInfo = data.getDimensionInfo(dataDim);
        dimInfo.displayName && nameArr.push(dimInfo.displayName);
    });
    return nameArr.join(" ");
}
function $7c10febb2cdef0d8$var$dataTaskCount(context) {
    return context.model.getRawData().count();
}
function $7c10febb2cdef0d8$var$dataTaskReset(context) {
    var seriesModel = context.model;
    seriesModel.setData(seriesModel.getRawData().cloneShallow());
    return $7c10febb2cdef0d8$var$dataTaskProgress;
}
function $7c10febb2cdef0d8$var$dataTaskProgress(param, context) {
    // Avoid repeat cloneShallow when data just created in reset.
    if (context.outputData && param.end > context.outputData.count()) context.model.getRawData().cloneShallow(context.outputData);
}
// TODO refactor
function $7c10febb2cdef0d8$var$wrapData(data, seriesModel) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43($7a1bd9c2710fea0d$export$4fd8af2c48c43416(data.CHANGABLE_METHODS, data.DOWNSAMPLE_METHODS), function(methodName) {
        data.wrapMethod(methodName, $7a1bd9c2710fea0d$export$c3095a23b368d1f2($7c10febb2cdef0d8$var$onDataChange, seriesModel));
    });
}
function $7c10febb2cdef0d8$var$onDataChange(seriesModel, newList) {
    var task = $7c10febb2cdef0d8$var$getCurrentTask(seriesModel);
    if (task) // Consider case: filter, selectRange
    task.setOutputEnd((newList || this).count());
    return newList;
}
function $7c10febb2cdef0d8$var$getCurrentTask(seriesModel) {
    var scheduler = (seriesModel.ecModel || {}).scheduler;
    var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);
    if (pipeline) {
        // When pipline finished, the currrentTask keep the last
        // task (renderTask).
        var task = pipeline.currentTask;
        if (task) {
            var agentStubMap = task.agentStubMap;
            if (agentStubMap) task = agentStubMap.get(seriesModel.uid);
        }
        return task;
    }
}
var $7c10febb2cdef0d8$export$2e2bcd8739ae039 = $7c10febb2cdef0d8$var$SeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $737c88aa0711f65a$var$ComponentView = /** @class */ function() {
    function ComponentView() {
        this.group = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        this.uid = $5370df662b2caf37$export$6d2b3473b0986646("viewComponent");
    }
    ComponentView.prototype.init = function(ecModel, api) {};
    ComponentView.prototype.render = function(model, ecModel, api, payload) {};
    ComponentView.prototype.dispose = function(ecModel, api) {};
    ComponentView.prototype.updateView = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    ComponentView.prototype.updateLayout = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    ComponentView.prototype.updateVisual = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    /**
   * Hook for toggle blur target series.
   * Can be used in marker for blur or leave blur the markers
   */ ComponentView.prototype.toggleBlurSeries = function(seriesModels, isBlur, ecModel) {
    // Do nothing;
    };
    /**
   * Traverse the new rendered elements.
   *
   * It will traverse the new added element in progressive rendering.
   * And traverse all in normal rendering.
   */ ComponentView.prototype.eachRendered = function(cb) {
        var group = this.group;
        if (group) group.traverse(cb);
    };
    return ComponentView;
}();
$cd5f95cf03b4e3e7$export$cd4c3a4dca301c70($737c88aa0711f65a$var$ComponentView);
$cd5f95cf03b4e3e7$export$241315e45585454d($737c88aa0711f65a$var$ComponentView);
var $737c88aa0711f65a$export$2e2bcd8739ae039 = $737c88aa0711f65a$var$ComponentView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $cd70075c57b35175$export$2e2bcd8739ae039() {
    var inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
    return function(seriesModel) {
        var fields = inner(seriesModel);
        var pipelineContext = seriesModel.pipelineContext;
        var originalLarge = !!fields.large;
        var originalProgressive = !!fields.progressiveRender;
        // FIXME: if the planner works on a filtered series, `pipelineContext` does not
        // exists. See #11611 . Probably we need to modify this structure, see the comment
        // on `performRawSeries` in `Schedular.js`.
        var large = fields.large = !!(pipelineContext && pipelineContext.large);
        var progressive = fields.progressiveRender = !!(pipelineContext && pipelineContext.progressiveRender);
        return !!(originalLarge !== large || originalProgressive !== progressive) && "reset";
    };
}




var $0dc5061053e23cd3$var$inner = $76d619f648247e6d$export$64df9f8d92ae083f();
var $0dc5061053e23cd3$var$renderPlanner = (0, $cd70075c57b35175$export$2e2bcd8739ae039)();
var $0dc5061053e23cd3$var$ChartView = /** @class */ function() {
    function ChartView() {
        this.group = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        this.uid = $5370df662b2caf37$export$6d2b3473b0986646("viewChart");
        this.renderTask = (0, $4d16404c851dcec6$export$f7292ab7796be73c)({
            plan: $0dc5061053e23cd3$var$renderTaskPlan,
            reset: $0dc5061053e23cd3$var$renderTaskReset
        });
        this.renderTask.context = {
            view: this
        };
    }
    ChartView.prototype.init = function(ecModel, api) {};
    ChartView.prototype.render = function(seriesModel, ecModel, api, payload) {};
    /**
   * Highlight series or specified data item.
   */ ChartView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData(payload && payload.dataType);
        if (!data) return;
        $0dc5061053e23cd3$var$toggleHighlight(data, payload, "emphasis");
    };
    /**
   * Downplay series or specified data item.
   */ ChartView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData(payload && payload.dataType);
        if (!data) return;
        $0dc5061053e23cd3$var$toggleHighlight(data, payload, "normal");
    };
    /**
   * Remove self.
   */ ChartView.prototype.remove = function(ecModel, api) {
        this.group.removeAll();
    };
    /**
   * Dispose self.
   */ ChartView.prototype.dispose = function(ecModel, api) {};
    ChartView.prototype.updateView = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    // FIXME never used?
    ChartView.prototype.updateLayout = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    // FIXME never used?
    ChartView.prototype.updateVisual = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    /**
   * Traverse the new rendered elements.
   *
   * It will traverse the new added element in progressive rendering.
   * And traverse all in normal rendering.
   */ ChartView.prototype.eachRendered = function(cb) {
        (0, $5b455ae6f843ac47$export$3e564442729bf048)(this.group, cb);
    };
    ChartView.markUpdateMethod = function(payload, methodName) {
        $0dc5061053e23cd3$var$inner(payload).updateMethod = methodName;
    };
    ChartView.protoInitialize = function() {
        var proto = ChartView.prototype;
        proto.type = "chart";
    }();
    return ChartView;
}();
/**
 * Set state of single element
 */ function $0dc5061053e23cd3$var$elSetState(el, state, highlightDigit) {
    if (el && (0, $2bf82c0980125b62$export$77d1445f699c58b5)(el)) (state === "emphasis" ? (0, $2bf82c0980125b62$export$b2d02638cc34c042) : (0, $2bf82c0980125b62$export$11be6f716239ac55))(el, highlightDigit);
}
function $0dc5061053e23cd3$var$toggleHighlight(data, payload, state) {
    var dataIndex = $76d619f648247e6d$export$42b26cae8b8d10(data, payload);
    var highlightDigit = payload && payload.highlightKey != null ? (0, $2bf82c0980125b62$export$824af40eb714530d)(payload.highlightKey) : null;
    if (dataIndex != null) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($76d619f648247e6d$export$4f07b212a02c8051(dataIndex), function(dataIdx) {
        $0dc5061053e23cd3$var$elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
    });
    else data.eachItemGraphicEl(function(el) {
        $0dc5061053e23cd3$var$elSetState(el, state, highlightDigit);
    });
}
$cd5f95cf03b4e3e7$export$cd4c3a4dca301c70($0dc5061053e23cd3$var$ChartView, [
    "dispose"
]);
$cd5f95cf03b4e3e7$export$241315e45585454d($0dc5061053e23cd3$var$ChartView);
function $0dc5061053e23cd3$var$renderTaskPlan(context) {
    return $0dc5061053e23cd3$var$renderPlanner(context.model);
}
function $0dc5061053e23cd3$var$renderTaskReset(context) {
    var seriesModel = context.model;
    var ecModel = context.ecModel;
    var api = context.api;
    var payload = context.payload;
    // FIXME: remove updateView updateVisual
    var progressiveRender = seriesModel.pipelineContext.progressiveRender;
    var view = context.view;
    var updateMethod = payload && $0dc5061053e23cd3$var$inner(payload).updateMethod;
    var methodName = progressiveRender ? "incrementalPrepareRender" : updateMethod && view[updateMethod] ? updateMethod : "render";
    if (methodName !== "render") view[methodName](seriesModel, ecModel, api, payload);
    return $0dc5061053e23cd3$var$progressMethodMap[methodName];
}
var $0dc5061053e23cd3$var$progressMethodMap = {
    incrementalPrepareRender: {
        progress: function(params, context) {
            context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
        }
    },
    render: {
        // Put view.render in `progress` to support appendData. But in this case
        // view.render should not be called in reset, otherwise it will be called
        // twise. Use `forceFirstProgress` to make sure that view.render is called
        // in any cases.
        forceFirstProgress: true,
        progress: function(params, context) {
            context.view.render(context.model, context.ecModel, context.api, context.payload);
        }
    }
};
var $0dc5061053e23cd3$export$2e2bcd8739ae039 = $0dc5061053e23cd3$var$ChartView;






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $c98659a9437a3d2e$var$ORIGIN_METHOD = "\x00__throttleOriginMethod";
var $c98659a9437a3d2e$var$RATE = "\x00__throttleRate";
var $c98659a9437a3d2e$var$THROTTLE_TYPE = "\x00__throttleType";
function $c98659a9437a3d2e$export$de363e709c412c8a(fn, delay, debounce) {
    var currCall;
    var lastCall = 0;
    var lastExec = 0;
    var timer = null;
    var diff;
    var scope;
    var args;
    var debounceNextCall;
    delay = delay || 0;
    function exec() {
        lastExec = new Date().getTime();
        timer = null;
        fn.apply(scope, args || []);
    }
    var cb = function() {
        var cbArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)cbArgs[_i] = arguments[_i];
        currCall = new Date().getTime();
        scope = this;
        args = cbArgs;
        var thisDelay = debounceNextCall || delay;
        var thisDebounce = debounceNextCall || debounce;
        debounceNextCall = null;
        diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
        clearTimeout(timer);
        // Here we should make sure that: the `exec` SHOULD NOT be called later
        // than a new call of `cb`, that is, preserving the command order. Consider
        // calculating "scale rate" when roaming as an example. When a call of `cb`
        // happens, either the `exec` is called dierectly, or the call is delayed.
        // But the delayed call should never be later than next call of `cb`. Under
        // this assurance, we can simply update view state each time `dispatchAction`
        // triggered by user roaming, but not need to add extra code to avoid the
        // state being "rolled-back".
        if (thisDebounce) timer = setTimeout(exec, thisDelay);
        else if (diff >= 0) exec();
        else timer = setTimeout(exec, -diff);
        lastCall = currCall;
    };
    /**
   * Clear throttle.
   * @public
   */ cb.clear = function() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    };
    /**
   * Enable debounce once.
   */ cb.debounceNextCall = function(debounceDelay) {
        debounceNextCall = debounceDelay;
    };
    return cb;
}
function $c98659a9437a3d2e$export$958e3e1a02eac4b6(obj, fnAttr, rate, throttleType) {
    var fn = obj[fnAttr];
    if (!fn) return;
    var originFn = fn[$c98659a9437a3d2e$var$ORIGIN_METHOD] || fn;
    var lastThrottleType = fn[$c98659a9437a3d2e$var$THROTTLE_TYPE];
    var lastRate = fn[$c98659a9437a3d2e$var$RATE];
    if (lastRate !== rate || lastThrottleType !== throttleType) {
        if (rate == null || !throttleType) return obj[fnAttr] = originFn;
        fn = obj[fnAttr] = $c98659a9437a3d2e$export$de363e709c412c8a(originFn, rate, throttleType === "debounce");
        fn[$c98659a9437a3d2e$var$ORIGIN_METHOD] = originFn;
        fn[$c98659a9437a3d2e$var$THROTTLE_TYPE] = throttleType;
        fn[$c98659a9437a3d2e$var$RATE] = rate;
    }
    return fn;
}
function $c98659a9437a3d2e$export$42ffd38884aecdac(obj, fnAttr) {
    var fn = obj[fnAttr];
    if (fn && fn[$c98659a9437a3d2e$var$ORIGIN_METHOD]) {
        // Clear throttle
        fn.clear && fn.clear();
        obj[fnAttr] = fn[$c98659a9437a3d2e$var$ORIGIN_METHOD];
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $a617f62dd17b10f1$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $a617f62dd17b10f1$var$defaultStyleMappers = {
    itemStyle: (0, $06542048a26d4d91$export$2e2bcd8739ae039)((0, $c42afdfd2f0ddc96$export$ffb0bba5dde0130b), true),
    lineStyle: (0, $06542048a26d4d91$export$2e2bcd8739ae039)((0, $9c5206e1bd69e88f$export$9f34de5b59222949), true)
};
var $a617f62dd17b10f1$var$defaultColorKey = {
    lineStyle: "stroke",
    itemStyle: "fill"
};
function $a617f62dd17b10f1$var$getStyleMapper(seriesModel, stylePath) {
    var styleMapper = seriesModel.visualStyleMapper || $a617f62dd17b10f1$var$defaultStyleMappers[stylePath];
    if (!styleMapper) {
        console.warn("Unknown style type '" + stylePath + "'.");
        return $a617f62dd17b10f1$var$defaultStyleMappers.itemStyle;
    }
    return styleMapper;
}
function $a617f62dd17b10f1$var$getDefaultColorKey(seriesModel, stylePath) {
    // return defaultColorKey[stylePath] ||
    var colorKey = seriesModel.visualDrawType || $a617f62dd17b10f1$var$defaultColorKey[stylePath];
    if (!colorKey) {
        console.warn("Unknown style type '" + stylePath + "'.");
        return "fill";
    }
    return colorKey;
}
var $a617f62dd17b10f1$export$7ce4d65f9b69240 = {
    createOnAllSeries: true,
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || "itemStyle";
        // Set in itemStyle
        var styleModel = seriesModel.getModel(stylePath);
        var getStyle = $a617f62dd17b10f1$var$getStyleMapper(seriesModel, stylePath);
        var globalStyle = getStyle(styleModel);
        var decalOption = styleModel.getShallow("decal");
        if (decalOption) {
            data.setVisual("decal", decalOption);
            decalOption.dirty = true;
        }
        // TODO
        var colorKey = $a617f62dd17b10f1$var$getDefaultColorKey(seriesModel, stylePath);
        var color = globalStyle[colorKey];
        // TODO style callback
        var colorCallback = (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(color) ? color : null;
        var hasAutoColor = globalStyle.fill === "auto" || globalStyle.stroke === "auto";
        // Get from color palette by default.
        if (!globalStyle[colorKey] || colorCallback || hasAutoColor) {
            // Note: If some series has color specified (e.g., by itemStyle.color), we DO NOT
            // make it effect palette. Because some scenarios users need to make some series
            // transparent or as background, which should better not effect the palette.
            var colorPalette = seriesModel.getColorFromPalette(// TODO series count changed.
            seriesModel.name, null, ecModel.getSeriesCount());
            if (!globalStyle[colorKey]) {
                globalStyle[colorKey] = colorPalette;
                data.setVisual("colorFromPalette", true);
            }
            globalStyle.fill = globalStyle.fill === "auto" || (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(globalStyle.fill) ? colorPalette : globalStyle.fill;
            globalStyle.stroke = globalStyle.stroke === "auto" || (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(globalStyle.stroke) ? colorPalette : globalStyle.stroke;
        }
        data.setVisual("style", globalStyle);
        data.setVisual("drawType", colorKey);
        // Only visible series has each data be visual encoded
        if (!ecModel.isSeriesFiltered(seriesModel) && colorCallback) {
            data.setVisual("colorFromPalette", false);
            return {
                dataEach: function(data, idx) {
                    var dataParams = seriesModel.getDataParams(idx);
                    var itemStyle = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, globalStyle);
                    itemStyle[colorKey] = colorCallback(dataParams);
                    data.setItemVisual(idx, "style", itemStyle);
                }
            };
        }
    }
};
var $a617f62dd17b10f1$var$sharedModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)();
var $a617f62dd17b10f1$export$f7dcb66a065003d1 = {
    createOnAllSeries: true,
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        if (seriesModel.ignoreStyleOnData || ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || "itemStyle";
        // Set in itemStyle
        var getStyle = $a617f62dd17b10f1$var$getStyleMapper(seriesModel, stylePath);
        var colorKey = data.getVisual("drawType");
        return {
            dataEach: data.hasItemOption ? function(data, idx) {
                // Not use getItemModel for performance considuration
                var rawItem = data.getRawDataItem(idx);
                if (rawItem && rawItem[stylePath]) {
                    $a617f62dd17b10f1$var$sharedModel.option = rawItem[stylePath];
                    var style = getStyle($a617f62dd17b10f1$var$sharedModel);
                    var existsStyle = data.ensureUniqueItemVisual(idx, "style");
                    (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(existsStyle, style);
                    if ($a617f62dd17b10f1$var$sharedModel.option.decal) {
                        data.setItemVisual(idx, "decal", $a617f62dd17b10f1$var$sharedModel.option.decal);
                        $a617f62dd17b10f1$var$sharedModel.option.decal.dirty = true;
                    }
                    if (colorKey in style) data.setItemVisual(idx, "colorFromPalette", false);
                }
            } : null
        };
    }
};
// Pick color from palette for the data which has not been set with color yet.
// Note: do not support stream rendering. No such cases yet.
var $a617f62dd17b10f1$export$cf9758b0d6dc0aa9 = {
    performRawSeries: true,
    overallReset: function(ecModel) {
        // Each type of series uses one scope.
        // Pie and funnel are using different scopes.
        var paletteScopeGroupByType = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        ecModel.eachSeries(function(seriesModel) {
            var colorBy = seriesModel.getColorBy();
            if (seriesModel.isColorBySeries()) return;
            var key = seriesModel.type + "-" + colorBy;
            var colorScope = paletteScopeGroupByType.get(key);
            if (!colorScope) {
                colorScope = {};
                paletteScopeGroupByType.set(key, colorScope);
            }
            $a617f62dd17b10f1$var$inner(seriesModel).scope = colorScope;
        });
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.isColorBySeries() || ecModel.isSeriesFiltered(seriesModel)) return;
            var dataAll = seriesModel.getRawData();
            var idxMap = {};
            var data = seriesModel.getData();
            var colorScope = $a617f62dd17b10f1$var$inner(seriesModel).scope;
            var stylePath = seriesModel.visualStyleAccessPath || "itemStyle";
            var colorKey = $a617f62dd17b10f1$var$getDefaultColorKey(seriesModel, stylePath);
            data.each(function(idx) {
                var rawIdx = data.getRawIndex(idx);
                idxMap[rawIdx] = idx;
            });
            // Iterate on data before filtered. To make sure color from palette can be
            // Consistent when toggling legend.
            dataAll.each(function(rawIdx) {
                var idx = idxMap[rawIdx];
                var fromPalette = data.getItemVisual(idx, "colorFromPalette");
                // Get color from palette for each data only when the color is inherited from series color, which is
                // also picked from color palette. So following situation is not in the case:
                // 1. series.itemStyle.color is set
                // 2. color is encoded by visualMap
                if (fromPalette) {
                    var itemStyle = data.ensureUniqueItemVisual(idx, "style");
                    var name_1 = dataAll.getName(rawIdx) || rawIdx + "";
                    var dataCount = dataAll.count();
                    itemStyle[colorKey] = seriesModel.getColorFromPalette(name_1, colorScope, dataCount);
                }
            });
        });
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $f23f99c31dceac8f$var$PI = Math.PI;
function $f23f99c31dceac8f$export$2e2bcd8739ae039(api, opts) {
    opts = opts || {};
    $7a1bd9c2710fea0d$export$ebe90cb607ad99e(opts, {
        text: "loading",
        textColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.primary,
        fontSize: 12,
        fontWeight: "normal",
        fontStyle: "normal",
        fontFamily: "sans-serif",
        maskColor: "rgba(255,255,255,0.8)",
        showSpinner: true,
        color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.theme[0],
        spinnerRadius: 10,
        lineWidth: 5,
        zlevel: 0
    });
    var group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
    var mask = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        style: {
            fill: opts.maskColor
        },
        zlevel: opts.zlevel,
        z: 10000
    });
    group.add(mask);
    var textContent = new $fe885cc21795562b$export$2e2bcd8739ae039({
        style: {
            text: opts.text,
            fill: opts.textColor,
            fontSize: opts.fontSize,
            fontWeight: opts.fontWeight,
            fontStyle: opts.fontStyle,
            fontFamily: opts.fontFamily
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    var labelRect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        style: {
            fill: "none"
        },
        textContent: textContent,
        textConfig: {
            position: "right",
            distance: 10
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    group.add(labelRect);
    var arc;
    if (opts.showSpinner) {
        arc = new $2b5c23eb3597b84a$export$2e2bcd8739ae039({
            shape: {
                startAngle: -$f23f99c31dceac8f$var$PI / 2,
                endAngle: -$f23f99c31dceac8f$var$PI / 2 + 0.1,
                r: opts.spinnerRadius
            },
            style: {
                stroke: opts.color,
                lineCap: "round",
                lineWidth: opts.lineWidth
            },
            zlevel: opts.zlevel,
            z: 10001
        });
        arc.animateShape(true).when(1000, {
            endAngle: $f23f99c31dceac8f$var$PI * 3 / 2
        }).start("circularInOut");
        arc.animateShape(true).when(1000, {
            startAngle: $f23f99c31dceac8f$var$PI * 3 / 2
        }).delay(300).start("circularInOut");
        group.add(arc);
    }
    // Inject resize
    group.resize = function() {
        var textWidth = textContent.getBoundingRect().width;
        var r = opts.showSpinner ? opts.spinnerRadius : 0;
        // cx = (containerWidth - arcDiameter - textDistance - textWidth) / 2
        // textDistance needs to be calculated when both animation and text exist
        var cx = (api.getWidth() - r * 2 - (opts.showSpinner && textWidth ? 10 : 0) - textWidth) / 2 - (opts.showSpinner && textWidth ? 0 : 5 + textWidth / 2) + (opts.showSpinner ? 0 : textWidth / 2) + (textWidth ? 0 : r);
        var cy = api.getHeight() / 2;
        opts.showSpinner && arc.setShape({
            cx: cx,
            cy: cy
        });
        labelRect.setShape({
            x: cx - r,
            y: cy - r,
            width: r * 2,
            height: r * 2
        });
        mask.setShape({
            x: 0,
            y: 0,
            width: api.getWidth(),
            height: api.getHeight()
        });
    };
    group.resize();
    return group;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $94ae4e8744638a8a$var$Scheduler = /** @class */ function() {
    function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
        // key: handlerUID
        this._stageTaskMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        this.ecInstance = ecInstance;
        this.api = api;
        // Fix current processors in case that in some rear cases that
        // processors might be registered after echarts instance created.
        // Register processors incrementally for a echarts instance is
        // not supported by this stream architecture.
        dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
        visualHandlers = this._visualHandlers = visualHandlers.slice();
        this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
    }
    Scheduler.prototype.restoreData = function(ecModel, payload) {
        // TODO: Only restore needed series and components, but not all components.
        // Currently `restoreData` of all of the series and component will be called.
        // But some independent components like `title`, `legend`, `graphic`, `toolbox`,
        // `tooltip`, `axisPointer`, etc, do not need series refresh when `setOption`,
        // and some components like coordinate system, axes, dataZoom, visualMap only
        // need their target series refresh.
        // (1) If we are implementing this feature some day, we should consider these cases:
        // if a data processor depends on a component (e.g., dataZoomProcessor depends
        // on the settings of `dataZoom`), it should be re-performed if the component
        // is modified by `setOption`.
        // (2) If a processor depends on sevral series, speicified by its `getTargetSeries`,
        // it should be re-performed when the result array of `getTargetSeries` changed.
        // We use `dependencies` to cover these issues.
        // (3) How to update target series when coordinate system related components modified.
        // TODO: simply the dirty mechanism? Check whether only the case here can set tasks dirty,
        // and this case all of the tasks will be set as dirty.
        ecModel.restoreData(payload);
        // Theoretically an overall task not only depends on each of its target series, but also
        // depends on all of the series.
        // The overall task is not in pipeline, and `ecModel.restoreData` only set pipeline tasks
        // dirty. If `getTargetSeries` of an overall task returns nothing, we should also ensure
        // that the overall task is set as dirty and to be performed, otherwise it probably cause
        // state chaos. So we have to set dirty of all of the overall tasks manually, otherwise it
        // probably cause state chaos (consider `dataZoomProcessor`).
        this._stageTaskMap.each(function(taskRecord) {
            var overallTask = taskRecord.overallTask;
            overallTask && overallTask.dirty();
        });
    };
    // If seriesModel provided, incremental threshold is check by series data.
    Scheduler.prototype.getPerformArgs = function(task, isBlock) {
        // For overall task
        if (!task.__pipeline) return;
        var pipeline = this._pipelineMap.get(task.__pipeline.id);
        var pCtx = pipeline.context;
        var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
        var step = incremental ? pipeline.step : null;
        var modDataCount = pCtx && pCtx.modDataCount;
        var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
        return {
            step: step,
            modBy: modBy,
            modDataCount: modDataCount
        };
    };
    Scheduler.prototype.getPipeline = function(pipelineId) {
        return this._pipelineMap.get(pipelineId);
    };
    /**
   * Current, progressive rendering starts from visual and layout.
   * Always detect render mode in the same stage, avoiding that incorrect
   * detection caused by data filtering.
   * Caution:
   * `updateStreamModes` use `seriesModel.getData()`.
   */ Scheduler.prototype.updateStreamModes = function(seriesModel, view) {
        var pipeline = this._pipelineMap.get(seriesModel.uid);
        var data = seriesModel.getData();
        var dataLen = data.count();
        // `progressiveRender` means that can render progressively in each
        // animation frame. Note that some types of series do not provide
        // `view.incrementalPrepareRender` but support `chart.appendData`. We
        // use the term `incremental` but not `progressive` to describe the
        // case that `chart.appendData`.
        var progressiveRender = pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold;
        var large = seriesModel.get("large") && dataLen >= seriesModel.get("largeThreshold");
        // TODO: modDataCount should not updated if `appendData`, otherwise cause whole repaint.
        // see `test/candlestick-large3.html`
        var modDataCount = seriesModel.get("progressiveChunkMode") === "mod" ? dataLen : null;
        seriesModel.pipelineContext = pipeline.context = {
            progressiveRender: progressiveRender,
            modDataCount: modDataCount,
            large: large
        };
    };
    Scheduler.prototype.restorePipelines = function(ecModel) {
        var scheduler = this;
        var pipelineMap = scheduler._pipelineMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        ecModel.eachSeries(function(seriesModel) {
            var progressive = seriesModel.getProgressive();
            var pipelineId = seriesModel.uid;
            pipelineMap.set(pipelineId, {
                id: pipelineId,
                head: null,
                tail: null,
                threshold: seriesModel.getProgressiveThreshold(),
                progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
                blockIndex: -1,
                step: Math.round(progressive || 700),
                count: 0
            });
            scheduler._pipe(seriesModel, seriesModel.dataTask);
        });
    };
    Scheduler.prototype.prepareStageTasks = function() {
        var stageTaskMap = this._stageTaskMap;
        var ecModel = this.api.getModel();
        var api = this.api;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._allHandlers, function(handler) {
            var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, {});
            var errMsg = "";
            (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(!(handler.reset && handler.overallReset), errMsg);
            handler.reset && this._createSeriesStageTask(handler, record, ecModel, api);
            handler.overallReset && this._createOverallStageTask(handler, record, ecModel, api);
        }, this);
    };
    Scheduler.prototype.prepareView = function(view, model, ecModel, api) {
        var renderTask = view.renderTask;
        var context = renderTask.context;
        context.model = model;
        context.ecModel = ecModel;
        context.api = api;
        renderTask.__block = !view.incrementalPrepareRender;
        this._pipe(model, renderTask);
    };
    Scheduler.prototype.performDataProcessorTasks = function(ecModel, payload) {
        // If we do not use `block` here, it should be considered when to update modes.
        this._performStageTasks(this._dataProcessorHandlers, ecModel, payload, {
            block: true
        });
    };
    Scheduler.prototype.performVisualTasks = function(ecModel, payload, opt) {
        this._performStageTasks(this._visualHandlers, ecModel, payload, opt);
    };
    Scheduler.prototype._performStageTasks = function(stageHandlers, ecModel, payload, opt) {
        opt = opt || {};
        var unfinished = false;
        var scheduler = this;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(stageHandlers, function(stageHandler, idx) {
            if (opt.visualType && opt.visualType !== stageHandler.visualType) return;
            var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);
            var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
            var overallTask = stageHandlerRecord.overallTask;
            if (overallTask) {
                var overallNeedDirty_1;
                var agentStubMap = overallTask.agentStubMap;
                agentStubMap.each(function(stub) {
                    if (needSetDirty(opt, stub)) {
                        stub.dirty();
                        overallNeedDirty_1 = true;
                    }
                });
                overallNeedDirty_1 && overallTask.dirty();
                scheduler.updatePayload(overallTask, payload);
                var performArgs_1 = scheduler.getPerformArgs(overallTask, opt.block);
                // Execute stubs firstly, which may set the overall task dirty,
                // then execute the overall task. And stub will call seriesModel.setData,
                // which ensures that in the overallTask seriesModel.getData() will not
                // return incorrect data.
                agentStubMap.each(function(stub) {
                    stub.perform(performArgs_1);
                });
                if (overallTask.perform(performArgs_1)) unfinished = true;
            } else if (seriesTaskMap) seriesTaskMap.each(function(task, pipelineId) {
                if (needSetDirty(opt, task)) task.dirty();
                var performArgs = scheduler.getPerformArgs(task, opt.block);
                // FIXME
                // if intending to declare `performRawSeries` in handlers, only
                // stream-independent (specifically, data item independent) operations can be
                // performed. Because if a series is filtered, most of the tasks will not
                // be performed. A stream-dependent operation probably cause wrong biz logic.
                // Perhaps we should not provide a separate callback for this case instead
                // of providing the config `performRawSeries`. The stream-dependent operations
                // and stream-independent operations should better not be mixed.
                performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
                scheduler.updatePayload(task, payload);
                if (task.perform(performArgs)) unfinished = true;
            });
        });
        function needSetDirty(opt, task) {
            return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
        }
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.performSeriesTasks = function(ecModel) {
        var unfinished;
        ecModel.eachSeries(function(seriesModel) {
            // Progress to the end for dataInit and dataRestore.
            unfinished = seriesModel.dataTask.perform() || unfinished;
        });
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.plan = function() {
        // Travel pipelines, check block.
        this._pipelineMap.each(function(pipeline) {
            var task = pipeline.tail;
            do {
                if (task.__block) {
                    pipeline.blockIndex = task.__idxInPipeline;
                    break;
                }
                task = task.getUpstream();
            }while (task);
        });
    };
    Scheduler.prototype.updatePayload = function(task, payload) {
        payload !== "remain" && (task.context.payload = payload);
    };
    Scheduler.prototype._createSeriesStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var oldSeriesTaskMap = stageHandlerRecord.seriesTaskMap;
        // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newSeriesTaskMap = stageHandlerRecord.seriesTaskMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries;
        // If a stageHandler should cover all series, `createOnAllSeries` should be declared mandatorily,
        // to avoid some typo or abuse. Otherwise if an extension do not specify a `seriesType`,
        // it works but it may cause other irrelevant charts blocked.
        if (stageHandler.createOnAllSeries) ecModel.eachRawSeries(create);
        else if (seriesType) ecModel.eachRawSeriesByType(seriesType, create);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(create);
        function create(seriesModel) {
            var pipelineId = seriesModel.uid;
            // Init tasks for each seriesModel only once.
            // Reuse original task instance.
            var task = newSeriesTaskMap.set(pipelineId, oldSeriesTaskMap && oldSeriesTaskMap.get(pipelineId) || (0, $4d16404c851dcec6$export$f7292ab7796be73c)({
                plan: $94ae4e8744638a8a$var$seriesTaskPlan,
                reset: $94ae4e8744638a8a$var$seriesTaskReset,
                count: $94ae4e8744638a8a$var$seriesTaskCount
            }));
            task.context = {
                model: seriesModel,
                ecModel: ecModel,
                api: api,
                // PENDING: `useClearVisual` not used?
                useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
                plan: stageHandler.plan,
                reset: stageHandler.reset,
                scheduler: scheduler
            };
            scheduler._pipe(seriesModel, task);
        }
    };
    Scheduler.prototype._createOverallStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask || (0, $4d16404c851dcec6$export$f7292ab7796be73c)({
            reset: $94ae4e8744638a8a$var$overallTaskReset
        });
        overallTask.context = {
            ecModel: ecModel,
            api: api,
            overallReset: stageHandler.overallReset,
            scheduler: scheduler
        };
        var oldAgentStubMap = overallTask.agentStubMap;
        // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newAgentStubMap = overallTask.agentStubMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries;
        var overallProgress = true;
        var shouldOverallTaskDirty = false;
        // FIXME:TS never used, so comment it
        // let modifyOutputEnd = stageHandler.modifyOutputEnd;
        // An overall task with seriesType detected or has `getTargetSeries`, we add
        // stub in each pipelines, it will set the overall task dirty when the pipeline
        // progress. Moreover, to avoid call the overall task each frame (too frequent),
        // we set the pipeline block.
        var errMsg = "";
        (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(!stageHandler.createOnAllSeries, errMsg);
        if (seriesType) ecModel.eachRawSeriesByType(seriesType, createStub);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(createStub);
        else {
            overallProgress = false;
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ecModel.getSeries(), createStub);
        }
        function createStub(seriesModel) {
            var pipelineId = seriesModel.uid;
            var stub = newAgentStubMap.set(pipelineId, oldAgentStubMap && oldAgentStubMap.get(pipelineId) || // When the result of `getTargetSeries` changed, the overallTask
            // should be set as dirty and re-performed.
            (shouldOverallTaskDirty = true, (0, $4d16404c851dcec6$export$f7292ab7796be73c)({
                reset: $94ae4e8744638a8a$var$stubReset,
                onDirty: $94ae4e8744638a8a$var$stubOnDirty
            })));
            stub.context = {
                model: seriesModel,
                overallProgress: overallProgress
            };
            stub.agent = overallTask;
            stub.__block = overallProgress;
            scheduler._pipe(seriesModel, stub);
        }
        if (shouldOverallTaskDirty) overallTask.dirty();
    };
    Scheduler.prototype._pipe = function(seriesModel, task) {
        var pipelineId = seriesModel.uid;
        var pipeline = this._pipelineMap.get(pipelineId);
        !pipeline.head && (pipeline.head = task);
        pipeline.tail && pipeline.tail.pipe(task);
        pipeline.tail = task;
        task.__idxInPipeline = pipeline.count++;
        task.__pipeline = pipeline;
    };
    Scheduler.wrapStageHandler = function(stageHandler, visualType) {
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(stageHandler)) stageHandler = {
            overallReset: stageHandler,
            seriesType: $94ae4e8744638a8a$var$detectSeriseType(stageHandler)
        };
        stageHandler.uid = (0, $5370df662b2caf37$export$6d2b3473b0986646)("stageHandler");
        visualType && (stageHandler.visualType = visualType);
        return stageHandler;
    };
    return Scheduler;
}();
function $94ae4e8744638a8a$var$overallTaskReset(context) {
    context.overallReset(context.ecModel, context.api, context.payload);
}
function $94ae4e8744638a8a$var$stubReset(context) {
    return context.overallProgress && $94ae4e8744638a8a$var$stubProgress;
}
function $94ae4e8744638a8a$var$stubProgress() {
    this.agent.dirty();
    this.getDownstream().dirty();
}
function $94ae4e8744638a8a$var$stubOnDirty() {
    this.agent && this.agent.dirty();
}
function $94ae4e8744638a8a$var$seriesTaskPlan(context) {
    return context.plan ? context.plan(context.model, context.ecModel, context.api, context.payload) : null;
}
function $94ae4e8744638a8a$var$seriesTaskReset(context) {
    if (context.useClearVisual) context.data.clearAllVisual();
    var resetDefines = context.resetDefines = (0, $76d619f648247e6d$export$4f07b212a02c8051)(context.reset(context.model, context.ecModel, context.api, context.payload));
    return resetDefines.length > 1 ? (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(resetDefines, function(v, idx) {
        return $94ae4e8744638a8a$var$makeSeriesTaskProgress(idx);
    }) : $94ae4e8744638a8a$var$singleSeriesTaskProgress;
}
var $94ae4e8744638a8a$var$singleSeriesTaskProgress = $94ae4e8744638a8a$var$makeSeriesTaskProgress(0);
function $94ae4e8744638a8a$var$makeSeriesTaskProgress(resetDefineIdx) {
    return function(params, context) {
        var data = context.data;
        var resetDefine = context.resetDefines[resetDefineIdx];
        if (resetDefine && resetDefine.dataEach) for(var i = params.start; i < params.end; i++)resetDefine.dataEach(data, i);
        else if (resetDefine && resetDefine.progress) resetDefine.progress(params, data);
    };
}
function $94ae4e8744638a8a$var$seriesTaskCount(context) {
    return context.data.count();
}
/**
 * Only some legacy stage handlers (usually in echarts extensions) are pure function.
 * To ensure that they can work normally, they should work in block mode, that is,
 * they should not be started util the previous tasks finished. So they cause the
 * progressive rendering disabled. We try to detect the series type, to narrow down
 * the block range to only the series type they concern, but not all series.
 */ function $94ae4e8744638a8a$var$detectSeriseType(legacyFunc) {
    $94ae4e8744638a8a$var$seriesType = null;
    try {
        // Assume there is no async when calling `eachSeriesByType`.
        legacyFunc($94ae4e8744638a8a$var$ecModelMock, $94ae4e8744638a8a$var$apiMock);
    } catch (e) {}
    return $94ae4e8744638a8a$var$seriesType;
}
var $94ae4e8744638a8a$var$ecModelMock = {};
var $94ae4e8744638a8a$var$apiMock = {};
var $94ae4e8744638a8a$var$seriesType;
$94ae4e8744638a8a$var$mockMethods($94ae4e8744638a8a$var$ecModelMock, (0, $51f6ef0dd9546916$export$2e2bcd8739ae039));
$94ae4e8744638a8a$var$mockMethods($94ae4e8744638a8a$var$apiMock, (0, $a6d7e6163195660e$export$2e2bcd8739ae039));
$94ae4e8744638a8a$var$ecModelMock.eachSeriesByType = $94ae4e8744638a8a$var$ecModelMock.eachRawSeriesByType = function(type) {
    $94ae4e8744638a8a$var$seriesType = type;
};
$94ae4e8744638a8a$var$ecModelMock.eachComponent = function(cond) {
    if (cond.mainType === "series" && cond.subType) $94ae4e8744638a8a$var$seriesType = cond.subType;
};
function $94ae4e8744638a8a$var$mockMethods(target, Clz) {
    /* eslint-disable */ for(var name_1 in Clz.prototype)// Do not use hasOwnProperty
    target[name_1] = (0, $7a1bd9c2710fea0d$export$8793edee2d425525);
/* eslint-enable */ }
var $94ae4e8744638a8a$export$2e2bcd8739ae039 = $94ae4e8744638a8a$var$Scheduler;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $985c98ffd51c6ff6$var$color = (0, $02653a4b1be313bf$export$2e2bcd8739ae039).darkColor;
var $985c98ffd51c6ff6$var$backgroundColor = $985c98ffd51c6ff6$var$color.background;
var $985c98ffd51c6ff6$var$axisCommon = function() {
    return {
        axisLine: {
            lineStyle: {
                color: $985c98ffd51c6ff6$var$color.axisLine
            }
        },
        splitLine: {
            lineStyle: {
                color: $985c98ffd51c6ff6$var$color.axisSplitLine
            }
        },
        splitArea: {
            areaStyle: {
                color: [
                    $985c98ffd51c6ff6$var$color.backgroundTint,
                    $985c98ffd51c6ff6$var$color.backgroundTransparent
                ]
            }
        },
        minorSplitLine: {
            lineStyle: {
                color: $985c98ffd51c6ff6$var$color.axisMinorSplitLine
            }
        },
        axisLabel: {
            color: $985c98ffd51c6ff6$var$color.axisLabel
        },
        axisName: {}
    };
};
var $985c98ffd51c6ff6$var$matrixAxis = {
    label: {
        color: $985c98ffd51c6ff6$var$color.secondary
    },
    itemStyle: {
        borderColor: $985c98ffd51c6ff6$var$color.borderTint
    },
    dividerLineStyle: {
        color: $985c98ffd51c6ff6$var$color.border
    }
};
var $985c98ffd51c6ff6$var$theme = {
    darkMode: true,
    color: $985c98ffd51c6ff6$var$color.theme,
    backgroundColor: $985c98ffd51c6ff6$var$backgroundColor,
    axisPointer: {
        lineStyle: {
            color: $985c98ffd51c6ff6$var$color.border
        },
        crossStyle: {
            color: $985c98ffd51c6ff6$var$color.borderShade
        },
        label: {
            color: $985c98ffd51c6ff6$var$color.tertiary
        }
    },
    legend: {
        textStyle: {
            color: $985c98ffd51c6ff6$var$color.secondary
        },
        pageTextStyle: {
            color: $985c98ffd51c6ff6$var$color.tertiary
        }
    },
    textStyle: {
        color: $985c98ffd51c6ff6$var$color.secondary
    },
    title: {
        textStyle: {
            color: $985c98ffd51c6ff6$var$color.primary
        },
        subtextStyle: {
            color: $985c98ffd51c6ff6$var$color.quaternary
        }
    },
    toolbox: {
        iconStyle: {
            borderColor: $985c98ffd51c6ff6$var$color.accent50
        }
    },
    tooltip: {
        backgroundColor: $985c98ffd51c6ff6$var$color.neutral20,
        defaultBorderColor: $985c98ffd51c6ff6$var$color.border,
        textStyle: {
            color: $985c98ffd51c6ff6$var$color.tertiary
        }
    },
    dataZoom: {
        borderColor: $985c98ffd51c6ff6$var$color.accent10,
        textStyle: {
            color: $985c98ffd51c6ff6$var$color.tertiary
        },
        brushStyle: {
            color: $985c98ffd51c6ff6$var$color.backgroundTint
        },
        handleStyle: {
            color: $985c98ffd51c6ff6$var$color.neutral00,
            borderColor: $985c98ffd51c6ff6$var$color.accent20
        },
        moveHandleStyle: {
            color: $985c98ffd51c6ff6$var$color.accent40
        },
        emphasis: {
            handleStyle: {
                borderColor: $985c98ffd51c6ff6$var$color.accent50
            }
        },
        dataBackground: {
            lineStyle: {
                color: $985c98ffd51c6ff6$var$color.accent30
            },
            areaStyle: {
                color: $985c98ffd51c6ff6$var$color.accent20
            }
        },
        selectedDataBackground: {
            lineStyle: {
                color: $985c98ffd51c6ff6$var$color.accent50
            },
            areaStyle: {
                color: $985c98ffd51c6ff6$var$color.accent30
            }
        }
    },
    visualMap: {
        textStyle: {
            color: $985c98ffd51c6ff6$var$color.secondary
        },
        handleStyle: {
            borderColor: $985c98ffd51c6ff6$var$color.neutral30
        }
    },
    timeline: {
        lineStyle: {
            color: $985c98ffd51c6ff6$var$color.accent10
        },
        label: {
            color: $985c98ffd51c6ff6$var$color.tertiary
        },
        controlStyle: {
            color: $985c98ffd51c6ff6$var$color.accent30,
            borderColor: $985c98ffd51c6ff6$var$color.accent30
        }
    },
    calendar: {
        itemStyle: {
            color: $985c98ffd51c6ff6$var$color.neutral00,
            borderColor: $985c98ffd51c6ff6$var$color.neutral20
        },
        dayLabel: {
            color: $985c98ffd51c6ff6$var$color.tertiary
        },
        monthLabel: {
            color: $985c98ffd51c6ff6$var$color.secondary
        },
        yearLabel: {
            color: $985c98ffd51c6ff6$var$color.secondary
        }
    },
    matrix: {
        x: $985c98ffd51c6ff6$var$matrixAxis,
        y: $985c98ffd51c6ff6$var$matrixAxis,
        backgroundColor: {
            borderColor: $985c98ffd51c6ff6$var$color.axisLine
        },
        body: {
            itemStyle: {
                borderColor: $985c98ffd51c6ff6$var$color.borderTint
            }
        }
    },
    timeAxis: $985c98ffd51c6ff6$var$axisCommon(),
    logAxis: $985c98ffd51c6ff6$var$axisCommon(),
    valueAxis: $985c98ffd51c6ff6$var$axisCommon(),
    categoryAxis: $985c98ffd51c6ff6$var$axisCommon(),
    line: {
        symbol: "circle"
    },
    graph: {
        color: $985c98ffd51c6ff6$var$color.theme
    },
    gauge: {
        title: {
            color: $985c98ffd51c6ff6$var$color.secondary
        },
        axisLine: {
            lineStyle: {
                color: [
                    [
                        1,
                        $985c98ffd51c6ff6$var$color.neutral05
                    ]
                ]
            }
        },
        axisLabel: {
            color: $985c98ffd51c6ff6$var$color.axisLabel
        },
        detail: {
            color: $985c98ffd51c6ff6$var$color.primary
        }
    },
    candlestick: {
        itemStyle: {
            color: "#f64e56",
            color0: "#54ea92",
            borderColor: "#f64e56",
            borderColor0: "#54ea92"
        }
    },
    funnel: {
        itemStyle: {
            borderColor: $985c98ffd51c6ff6$var$color.background
        }
    },
    radar: function() {
        var radar = $985c98ffd51c6ff6$var$axisCommon();
        radar.axisName = {
            color: $985c98ffd51c6ff6$var$color.axisLabel
        };
        radar.axisLine.lineStyle.color = $985c98ffd51c6ff6$var$color.neutral20;
        return radar;
    }(),
    treemap: {
        breadcrumb: {
            itemStyle: {
                color: $985c98ffd51c6ff6$var$color.neutral20,
                textStyle: {
                    color: $985c98ffd51c6ff6$var$color.secondary
                }
            },
            emphasis: {
                itemStyle: {
                    color: $985c98ffd51c6ff6$var$color.neutral30
                }
            }
        }
    },
    sunburst: {
        itemStyle: {
            borderColor: $985c98ffd51c6ff6$var$color.background
        }
    },
    map: {
        itemStyle: {
            borderColor: $985c98ffd51c6ff6$var$color.border,
            areaColor: $985c98ffd51c6ff6$var$color.neutral10
        },
        label: {
            color: $985c98ffd51c6ff6$var$color.tertiary
        },
        emphasis: {
            label: {
                color: $985c98ffd51c6ff6$var$color.primary
            },
            itemStyle: {
                areaColor: $985c98ffd51c6ff6$var$color.highlight
            }
        },
        select: {
            label: {
                color: $985c98ffd51c6ff6$var$color.primary
            },
            itemStyle: {
                areaColor: $985c98ffd51c6ff6$var$color.highlight
            }
        }
    },
    geo: {
        itemStyle: {
            borderColor: $985c98ffd51c6ff6$var$color.border,
            areaColor: $985c98ffd51c6ff6$var$color.neutral10
        },
        emphasis: {
            label: {
                color: $985c98ffd51c6ff6$var$color.primary
            },
            itemStyle: {
                areaColor: $985c98ffd51c6ff6$var$color.highlight
            }
        },
        select: {
            label: {
                color: $985c98ffd51c6ff6$var$color.primary
            },
            itemStyle: {
                color: $985c98ffd51c6ff6$var$color.highlight
            }
        }
    }
};
$985c98ffd51c6ff6$var$theme.categoryAxis.splitLine.show = false;
var $985c98ffd51c6ff6$export$2e2bcd8739ae039 = $985c98ffd51c6ff6$var$theme;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/**
 * Usage of query:
 * `chart.on('click', query, handler);`
 * The `query` can be:
 * + The component type query string, only `mainType` or `mainType.subType`,
 *   like: 'xAxis', 'series', 'xAxis.category' or 'series.line'.
 * + The component query object, like:
 *   `{seriesIndex: 2}`, `{seriesName: 'xx'}`, `{seriesId: 'some'}`,
 *   `{xAxisIndex: 2}`, `{xAxisName: 'xx'}`, `{xAxisId: 'some'}`.
 * + The data query object, like:
 *   `{dataIndex: 123}`, `{dataType: 'link'}`, `{name: 'some'}`.
 * + The other query object (cmponent customized query), like:
 *   `{element: 'some'}` (only available in custom series).
 *
 * Caveat: If a prop in the `query` object is `null/undefined`, it is the
 * same as there is no such prop in the `query` object.
 */ var $82d62ed69f6abce3$export$d0fd09f950257b52 = /** @class */ function() {
    function ECEventProcessor() {}
    ECEventProcessor.prototype.normalizeQuery = function(query) {
        var cptQuery = {};
        var dataQuery = {};
        var otherQuery = {};
        // `query` is `mainType` or `mainType.subType` of component.
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(query)) {
            var condCptType = (0, $cd5f95cf03b4e3e7$export$fbe18865d303bf01)(query);
            // `.main` and `.sub` may be ''.
            cptQuery.mainType = condCptType.main || null;
            cptQuery.subType = condCptType.sub || null;
        } else {
            // `xxxIndex`, `xxxName`, `xxxId`, `name`, `dataIndex`, `dataType` is reserved,
            // can not be used in `compomentModel.filterForExposedEvent`.
            var suffixes_1 = [
                "Index",
                "Name",
                "Id"
            ];
            var dataKeys_1 = {
                name: 1,
                dataIndex: 1,
                dataType: 1
            };
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(query, function(val, key) {
                var reserved = false;
                for(var i = 0; i < suffixes_1.length; i++){
                    var propSuffix = suffixes_1[i];
                    var suffixPos = key.lastIndexOf(propSuffix);
                    if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
                        var mainType = key.slice(0, suffixPos);
                        // Consider `dataIndex`.
                        if (mainType !== "data") {
                            cptQuery.mainType = mainType;
                            cptQuery[propSuffix.toLowerCase()] = val;
                            reserved = true;
                        }
                    }
                }
                if (dataKeys_1.hasOwnProperty(key)) {
                    dataQuery[key] = val;
                    reserved = true;
                }
                if (!reserved) otherQuery[key] = val;
            });
        }
        return {
            cptQuery: cptQuery,
            dataQuery: dataQuery,
            otherQuery: otherQuery
        };
    };
    ECEventProcessor.prototype.filter = function(eventType, query) {
        // They should be assigned before each trigger call.
        var eventInfo = this.eventInfo;
        if (!eventInfo) return true;
        var targetEl = eventInfo.targetEl;
        var packedEvent = eventInfo.packedEvent;
        var model = eventInfo.model;
        var view = eventInfo.view;
        // For event like 'globalout'.
        if (!model || !view) return true;
        var cptQuery = query.cptQuery;
        var dataQuery = query.dataQuery;
        return check(cptQuery, model, "mainType") && check(cptQuery, model, "subType") && check(cptQuery, model, "index", "componentIndex") && check(cptQuery, model, "name") && check(cptQuery, model, "id") && check(dataQuery, packedEvent, "name") && check(dataQuery, packedEvent, "dataIndex") && check(dataQuery, packedEvent, "dataType") && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));
        function check(query, host, prop, propOnHost) {
            return query[prop] == null || host[propOnHost || prop] === query[prop];
        }
    };
    ECEventProcessor.prototype.afterTrigger = function() {
        // Make sure the eventInfo won't be used in next trigger.
        this.eventInfo = null;
    };
    return ECEventProcessor;
}();


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $f8e1f1a448782588$var$SYMBOL_PROPS_WITH_CB = [
    "symbol",
    "symbolSize",
    "symbolRotate",
    "symbolOffset"
];
var $f8e1f1a448782588$var$SYMBOL_PROPS = $f8e1f1a448782588$var$SYMBOL_PROPS_WITH_CB.concat([
    "symbolKeepAspect"
]);
// Encoding visual for all series include which is filtered for legend drawing
var $f8e1f1a448782588$export$144ac3beded415d9 = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        if (seriesModel.legendIcon) data.setVisual("legendIcon", seriesModel.legendIcon);
        if (!seriesModel.hasSymbolVisual) return;
        var symbolOptions = {};
        var symbolOptionsCb = {};
        var hasCallback = false;
        for(var i = 0; i < $f8e1f1a448782588$var$SYMBOL_PROPS_WITH_CB.length; i++){
            var symbolPropName = $f8e1f1a448782588$var$SYMBOL_PROPS_WITH_CB[i];
            var val = seriesModel.get(symbolPropName);
            if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(val)) {
                hasCallback = true;
                symbolOptionsCb[symbolPropName] = val;
            } else symbolOptions[symbolPropName] = val;
        }
        symbolOptions.symbol = symbolOptions.symbol || seriesModel.defaultSymbol;
        data.setVisual((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
            legendIcon: seriesModel.legendIcon || symbolOptions.symbol,
            symbolKeepAspect: seriesModel.get("symbolKeepAspect")
        }, symbolOptions));
        // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var symbolPropsCb = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(symbolOptionsCb);
        function dataEach(data, idx) {
            var rawValue = seriesModel.getRawValue(idx);
            var params = seriesModel.getDataParams(idx);
            for(var i = 0; i < symbolPropsCb.length; i++){
                var symbolPropName = symbolPropsCb[i];
                data.setItemVisual(idx, symbolPropName, symbolOptionsCb[symbolPropName](rawValue, params));
            }
        }
        return {
            dataEach: hasCallback ? dataEach : null
        };
    }
};
var $f8e1f1a448782588$export$435b956f7f1071fb = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        if (!seriesModel.hasSymbolVisual) return;
        // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        function dataEach(data, idx) {
            var itemModel = data.getItemModel(idx);
            for(var i = 0; i < $f8e1f1a448782588$var$SYMBOL_PROPS.length; i++){
                var symbolPropName = $f8e1f1a448782588$var$SYMBOL_PROPS[i];
                var val = itemModel.getShallow(symbolPropName, true);
                if (val != null) data.setItemVisual(idx, symbolPropName, val);
            }
        }
        return {
            dataEach: data.hasItemOption ? dataEach : null
        };
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $ea13f1ab2169d82d$export$91d919a86b2df624(data, dataIndex, key) {
    switch(key){
        case "color":
            var style = data.getItemVisual(dataIndex, "style");
            return style[data.getVisual("drawType")];
        case "opacity":
            return data.getItemVisual(dataIndex, "style").opacity;
        case "symbol":
        case "symbolSize":
        case "liftZ":
            return data.getItemVisual(dataIndex, key);
        default:
    }
}
function $ea13f1ab2169d82d$export$d76e333a86ea1a2(data, key) {
    switch(key){
        case "color":
            var style = data.getVisual("style");
            return style[data.getVisual("drawType")];
        case "opacity":
            return data.getVisual("style").opacity;
        case "symbol":
        case "symbolSize":
        case "liftZ":
            return data.getVisual(key);
        default:
    }
}
function $ea13f1ab2169d82d$export$3aab879e9d0e7c75(data, dataIndex, key, value) {
    switch(key){
        case "color":
            // Make sure not sharing style object.
            var style = data.ensureUniqueItemVisual(dataIndex, "style");
            style[data.getVisual("drawType")] = value;
            // Mark the color has been changed, not from palette anymore
            data.setItemVisual(dataIndex, "colorFromPalette", false);
            break;
        case "opacity":
            data.ensureUniqueItemVisual(dataIndex, "style").opacity = value;
            break;
        case "symbol":
        case "symbolSize":
        case "liftZ":
            data.setItemVisual(dataIndex, key, value);
            break;
        default:
    }
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $e855ccf7eff48bce$export$62942ba95693dbfc(seriesType, ecRegisterAction) {
    function getSeriesIndices(ecModel, payload) {
        var seriesIndices = [];
        ecModel.eachComponent({
            mainType: "series",
            subType: seriesType,
            query: payload
        }, function(seriesModel) {
            seriesIndices.push(seriesModel.seriesIndex);
        });
        return seriesIndices;
    }
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        [
            seriesType + "ToggleSelect",
            "toggleSelect"
        ],
        [
            seriesType + "Select",
            "select"
        ],
        [
            seriesType + "UnSelect",
            "unselect"
        ]
    ], function(eventsMap) {
        ecRegisterAction(eventsMap[0], function(payload, ecModel, api) {
            payload = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, payload);
            api.dispatchAction((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(payload, {
                type: eventsMap[1],
                seriesIndex: getSeriesIndices(ecModel, payload)
            }));
        });
    });
}
function $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents(type, eventPostfix, ecIns, ecModel, payload) {
    var legacyEventName = type + eventPostfix;
    if (!ecIns.isSilent(legacyEventName)) ecModel.eachComponent({
        mainType: "series",
        subType: "pie"
    }, function(seriesModel) {
        var seriesIndex = seriesModel.seriesIndex;
        var selectedMap = seriesModel.option.selectedMap;
        var selected = payload.selected;
        for(var i = 0; i < selected.length; i++)if (selected[i].seriesIndex === seriesIndex) {
            var data = seriesModel.getData();
            var dataIndex = (0, $76d619f648247e6d$export$42b26cae8b8d10)(data, payload.fromActionPayload);
            ecIns.trigger(legacyEventName, {
                type: legacyEventName,
                seriesId: seriesModel.id,
                name: (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(dataIndex) ? data.getName(dataIndex[0]) : data.getName(dataIndex),
                selected: (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(selectedMap) ? selectedMap : (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, selectedMap)
            });
        }
    });
}
function $e855ccf7eff48bce$export$2575c83262e49d0c(messageCenter, ecIns, api) {
    messageCenter.on("selectchanged", function(params) {
        var ecModel = api.getModel();
        if (params.isFromClick) {
            $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents("map", "selectchanged", ecIns, ecModel, params);
            $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents("pie", "selectchanged", ecIns, ecModel, params);
        } else if (params.fromAction === "select") {
            $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents("map", "selected", ecIns, ecModel, params);
            $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents("pie", "selected", ecIns, ecModel, params);
        } else if (params.fromAction === "unselect") {
            $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents("map", "unselected", ecIns, ecModel, params);
            $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents("pie", "unselected", ecIns, ecModel, params);
        }
    });
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $808c5a2823518f68$export$8a4fca9e04eb4df6(target, det, returnFirstMatch) {
    var found;
    while(target){
        if (det(target)) {
            found = target;
            if (returnFirstMatch) break;
        }
        target = target.__hostTarget || target.parent;
    }
    return found;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $56aadf5b08ec1b47$var$wmUniqueIndex = Math.round(Math.random() * 9);
var $56aadf5b08ec1b47$var$supportDefineProperty = typeof Object.defineProperty === "function";
var $56aadf5b08ec1b47$var$WeakMap = function() {
    function WeakMap() {
        this._id = "__ec_inner_" + $56aadf5b08ec1b47$var$wmUniqueIndex++;
    }
    WeakMap.prototype.get = function(key) {
        return this._guard(key)[this._id];
    };
    WeakMap.prototype.set = function(key, value) {
        var target = this._guard(key);
        if ($56aadf5b08ec1b47$var$supportDefineProperty) Object.defineProperty(target, this._id, {
            value: value,
            enumerable: false,
            configurable: true
        });
        else target[this._id] = value;
        return this;
    };
    WeakMap.prototype["delete"] = function(key) {
        if (this.has(key)) {
            delete this._guard(key)[this._id];
            return true;
        }
        return false;
    };
    WeakMap.prototype.has = function(key) {
        return !!this._guard(key)[this._id];
    };
    WeakMap.prototype._guard = function(key) {
        if (key !== Object(key)) throw TypeError("Value of WeakMap is not a non-null object.");
        return key;
    };
    return WeakMap;
}();
var $56aadf5b08ec1b47$export$2e2bcd8739ae039 = $56aadf5b08ec1b47$var$WeakMap;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Symbol factory






/**
 * Triangle shape
 * @inner
 */ var $5370466dadc978d7$var$Triangle = $b02ffe7acd508c08$export$2e2bcd8739ae039.extend({
    type: "triangle",
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy + height);
        path.lineTo(cx - width, cy + height);
        path.closePath();
    }
});
/**
 * Diamond shape
 * @inner
 */ var $5370466dadc978d7$var$Diamond = $b02ffe7acd508c08$export$2e2bcd8739ae039.extend({
    type: "diamond",
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy);
        path.lineTo(cx, cy + height);
        path.lineTo(cx - width, cy);
        path.closePath();
    }
});
/**
 * Pin shape
 * @inner
 */ var $5370466dadc978d7$var$Pin = $b02ffe7acd508c08$export$2e2bcd8739ae039.extend({
    type: "pin",
    shape: {
        // x, y on the cusp
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var x = shape.x;
        var y = shape.y;
        var w = shape.width / 5 * 3;
        // Height must be larger than width
        var h = Math.max(w, shape.height);
        var r = w / 2;
        // Dist on y with tangent point and circle center
        var dy = r * r / (h - r);
        var cy = y - h + r + dy;
        var angle = Math.asin(dy / r);
        // Dist on x with tangent point and circle center
        var dx = Math.cos(angle) * r;
        var tanX = Math.sin(angle);
        var tanY = Math.cos(angle);
        var cpLen = r * 0.6;
        var cpLen2 = r * 0.7;
        path.moveTo(x - dx, cy + dy);
        path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
        path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
        path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
        path.closePath();
    }
});
/**
 * Arrow shape
 * @inner
 */ var $5370466dadc978d7$var$Arrow = $b02ffe7acd508c08$export$2e2bcd8739ae039.extend({
    type: "arrow",
    shape: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(ctx, shape) {
        var height = shape.height;
        var width = shape.width;
        var x = shape.x;
        var y = shape.y;
        var dx = width / 3 * 2;
        ctx.moveTo(x, y);
        ctx.lineTo(x + dx, y + height);
        ctx.lineTo(x, y + height / 4 * 3);
        ctx.lineTo(x - dx, y + height);
        ctx.lineTo(x, y);
        ctx.closePath();
    }
});
/**
 * Map of path constructors
 */ // TODO Use function to build symbol path.
var $5370466dadc978d7$var$symbolCtors = {
    line: $7a316ae5ceff7b27$export$2e2bcd8739ae039,
    rect: $419e5ff2f303755e$export$2e2bcd8739ae039,
    roundRect: $419e5ff2f303755e$export$2e2bcd8739ae039,
    square: $419e5ff2f303755e$export$2e2bcd8739ae039,
    circle: $1e68d8727773abb7$export$2e2bcd8739ae039,
    diamond: $5370466dadc978d7$var$Diamond,
    pin: $5370466dadc978d7$var$Pin,
    arrow: $5370466dadc978d7$var$Arrow,
    triangle: $5370466dadc978d7$var$Triangle
};
var $5370466dadc978d7$var$symbolShapeMakers = {
    line: function(x, y, w, h, shape) {
        shape.x1 = x;
        shape.y1 = y + h / 2;
        shape.x2 = x + w;
        shape.y2 = y + h / 2;
    },
    rect: function(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
    },
    roundRect: function(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
        shape.r = Math.min(w, h) / 4;
    },
    square: function(x, y, w, h, shape) {
        var size = Math.min(w, h);
        shape.x = x;
        shape.y = y;
        shape.width = size;
        shape.height = size;
    },
    circle: function(x, y, w, h, shape) {
        // Put circle in the center of square
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.r = Math.min(w, h) / 2;
    },
    diamond: function(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    pin: function(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    arrow: function(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    triangle: function(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    }
};
var $5370466dadc978d7$export$33fc3b478d332725 = {};
(0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($5370466dadc978d7$var$symbolCtors, function(Ctor, name) {
    $5370466dadc978d7$export$33fc3b478d332725[name] = new Ctor();
});
var $5370466dadc978d7$var$SymbolClz = $b02ffe7acd508c08$export$2e2bcd8739ae039.extend({
    type: "symbol",
    shape: {
        symbolType: "",
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    calculateTextPosition: function(out, config, rect) {
        var res = (0, $6c308355c7107803$export$eee3603b512feab7)(out, config, rect);
        var shape = this.shape;
        if (shape && shape.symbolType === "pin" && config.position === "inside") res.y = rect.y + rect.height * 0.4;
        return res;
    },
    buildPath: function(ctx, shape, inBundle) {
        var symbolType = shape.symbolType;
        if (symbolType !== "none") {
            var proxySymbol = $5370466dadc978d7$export$33fc3b478d332725[symbolType];
            if (!proxySymbol) {
                // Default rect
                symbolType = "rect";
                proxySymbol = $5370466dadc978d7$export$33fc3b478d332725[symbolType];
            }
            $5370466dadc978d7$var$symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
            proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
        }
    }
});
// Provide setColor helper method to avoid determine if set the fill or stroke outside
function $5370466dadc978d7$var$symbolPathSetColor(color, innerColor) {
    if (this.type !== "image") {
        var symbolStyle = this.style;
        if (this.__isEmptyBrush) {
            symbolStyle.stroke = color;
            symbolStyle.fill = innerColor || (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral00;
            // TODO Same width with lineStyle in LineView
            symbolStyle.lineWidth = 2;
        } else if (this.shape.symbolType === "line") symbolStyle.stroke = color;
        else symbolStyle.fill = color;
        this.markRedraw();
    }
}
function $5370466dadc978d7$export$af050e04da3a02e8(symbolType, x, y, w, h, color, // whether to keep the ratio of w/h,
keepAspect) {
    // TODO Support image object, DynamicImage.
    var isEmpty = symbolType.indexOf("empty") === 0;
    if (isEmpty) symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
    var symbolPath;
    if (symbolType.indexOf("image://") === 0) symbolPath = $5b455ae6f843ac47$export$7a2bdede98851ac5(symbolType.slice(8), new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, w, h), keepAspect ? "center" : "cover");
    else if (symbolType.indexOf("path://") === 0) symbolPath = $5b455ae6f843ac47$export$aa9bab72412f5613(symbolType.slice(7), {}, new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, w, h), keepAspect ? "center" : "cover");
    else symbolPath = new $5370466dadc978d7$var$SymbolClz({
        shape: {
            symbolType: symbolType,
            x: x,
            y: y,
            width: w,
            height: h
        }
    });
    symbolPath.__isEmptyBrush = isEmpty;
    // TODO Should deprecate setColor
    symbolPath.setColor = $5370466dadc978d7$var$symbolPathSetColor;
    if (color) symbolPath.setColor(color);
    return symbolPath;
}
function $5370466dadc978d7$export$a84524f03e8e8dfb(symbolSize) {
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(symbolSize)) symbolSize = [
        +symbolSize,
        +symbolSize
    ];
    return [
        symbolSize[0] || 0,
        symbolSize[1] || 0
    ];
}
function $5370466dadc978d7$export$e3e292895c033f6d(symbolOffset, symbolSize) {
    if (symbolOffset == null) return;
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(symbolOffset)) symbolOffset = [
        symbolOffset,
        symbolOffset
    ];
    return [
        (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(symbolOffset[0], symbolSize[0]) || 0,
        (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)((0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(symbolOffset[1], symbolOffset[0]), symbolSize[1]) || 0
    ];
}





function $d76b6507633b3c44$var$isSafeNum(num) {
    return isFinite(num);
}
function $d76b6507633b3c44$export$235c7ac50fe1db0a(ctx, obj, rect) {
    var x = obj.x == null ? 0 : obj.x;
    var x2 = obj.x2 == null ? 1 : obj.x2;
    var y = obj.y == null ? 0 : obj.y;
    var y2 = obj.y2 == null ? 0 : obj.y2;
    if (!obj.global) {
        x = x * rect.width + rect.x;
        x2 = x2 * rect.width + rect.x;
        y = y * rect.height + rect.y;
        y2 = y2 * rect.height + rect.y;
    }
    x = $d76b6507633b3c44$var$isSafeNum(x) ? x : 0;
    x2 = $d76b6507633b3c44$var$isSafeNum(x2) ? x2 : 1;
    y = $d76b6507633b3c44$var$isSafeNum(y) ? y : 0;
    y2 = $d76b6507633b3c44$var$isSafeNum(y2) ? y2 : 0;
    var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
    return canvasGradient;
}
function $d76b6507633b3c44$export$57f098206d57a443(ctx, obj, rect) {
    var width = rect.width;
    var height = rect.height;
    var min = Math.min(width, height);
    var x = obj.x == null ? 0.5 : obj.x;
    var y = obj.y == null ? 0.5 : obj.y;
    var r = obj.r == null ? 0.5 : obj.r;
    if (!obj.global) {
        x = x * width + rect.x;
        y = y * height + rect.y;
        r = r * min;
    }
    x = $d76b6507633b3c44$var$isSafeNum(x) ? x : 0.5;
    y = $d76b6507633b3c44$var$isSafeNum(y) ? y : 0.5;
    r = r >= 0 && $d76b6507633b3c44$var$isSafeNum(r) ? r : 0.5;
    var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
    return canvasGradient;
}
function $d76b6507633b3c44$export$3dab6afd018d48c7(ctx, obj, rect) {
    var canvasGradient = obj.type === "radial" ? $d76b6507633b3c44$export$57f098206d57a443(ctx, obj, rect) : $d76b6507633b3c44$export$235c7ac50fe1db0a(ctx, obj, rect);
    var colorStops = obj.colorStops;
    for(var i = 0; i < colorStops.length; i++)canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
    return canvasGradient;
}
function $d76b6507633b3c44$export$beeddc5150cb2e83(clipPaths, prevClipPaths) {
    if (clipPaths === prevClipPaths || !clipPaths && !prevClipPaths) return false;
    if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) return true;
    for(var i = 0; i < clipPaths.length; i++){
        if (clipPaths[i] !== prevClipPaths[i]) return true;
    }
    return false;
}
function $d76b6507633b3c44$var$parseInt10(val) {
    return parseInt(val, 10);
}
function $d76b6507633b3c44$export$31b21d0167753bb4(root, whIdx, opts) {
    var wh = [
        "width",
        "height"
    ][whIdx];
    var cwh = [
        "clientWidth",
        "clientHeight"
    ][whIdx];
    var plt = [
        "paddingLeft",
        "paddingTop"
    ][whIdx];
    var prb = [
        "paddingRight",
        "paddingBottom"
    ][whIdx];
    if (opts[wh] != null && opts[wh] !== "auto") return parseFloat(opts[wh]);
    var stl = document.defaultView.getComputedStyle(root);
    return (root[cwh] || $d76b6507633b3c44$var$parseInt10(stl[wh]) || $d76b6507633b3c44$var$parseInt10(root.style[wh])) - ($d76b6507633b3c44$var$parseInt10(stl[plt]) || 0) - ($d76b6507633b3c44$var$parseInt10(stl[prb]) || 0) | 0;
}







function $21ab8baf7c1f083c$export$9efb2ae8a603855d(lineType, lineWidth) {
    if (!lineType || lineType === "solid" || !(lineWidth > 0)) return null;
    return lineType === "dashed" ? [
        4 * lineWidth,
        2 * lineWidth
    ] : lineType === "dotted" ? [
        lineWidth
    ] : (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(lineType) ? [
        lineType
    ] : (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(lineType) ? lineType : null;
}
function $21ab8baf7c1f083c$export$9d315911f153b3b2(el) {
    var style = el.style;
    var lineDash = style.lineDash && style.lineWidth > 0 && $21ab8baf7c1f083c$export$9efb2ae8a603855d(style.lineDash, style.lineWidth);
    var lineDashOffset = style.lineDashOffset;
    if (lineDash) {
        var lineScale_1 = style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1;
        if (lineScale_1 && lineScale_1 !== 1) {
            lineDash = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(lineDash, function(rawVal) {
                return rawVal / lineScale_1;
            });
            lineDashOffset /= lineScale_1;
        }
    }
    return [
        lineDash,
        lineDashOffset
    ];
}




var $4f71e35e4552e3dd$var$pathProxyForDraw = new (0, $20ebe2448f123f2e$export$2e2bcd8739ae039)(true);
function $4f71e35e4552e3dd$var$styleHasStroke(style) {
    var stroke = style.stroke;
    return !(stroke == null || stroke === "none" || !(style.lineWidth > 0));
}
function $4f71e35e4552e3dd$var$isValidStrokeFillStyle(strokeOrFill) {
    return typeof strokeOrFill === "string" && strokeOrFill !== "none";
}
function $4f71e35e4552e3dd$var$styleHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== "none";
}
function $4f71e35e4552e3dd$var$doFillPath(ctx, style) {
    if (style.fillOpacity != null && style.fillOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.fillOpacity * style.opacity;
        ctx.fill();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.fill();
}
function $4f71e35e4552e3dd$var$doStrokePath(ctx, style) {
    if (style.strokeOpacity != null && style.strokeOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.strokeOpacity * style.opacity;
        ctx.stroke();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.stroke();
}
function $4f71e35e4552e3dd$export$8eb5db6b7bc27903(ctx, pattern, el) {
    var image = (0, $a53bd598adfb7ebe$export$46c791b69ff9a0f)(pattern.image, pattern.__image, el);
    if ((0, $a53bd598adfb7ebe$export$37ca7dd901d0236d)(image)) {
        var canvasPattern = ctx.createPattern(image, pattern.repeat || "repeat");
        if (typeof DOMMatrix === "function" && canvasPattern && canvasPattern.setTransform) {
            var matrix = new DOMMatrix();
            matrix.translateSelf(pattern.x || 0, pattern.y || 0);
            matrix.rotateSelf(0, 0, (pattern.rotation || 0) * (0, $7a1bd9c2710fea0d$export$bce8e055322a0ce6));
            matrix.scaleSelf(pattern.scaleX || 1, pattern.scaleY || 1);
            canvasPattern.setTransform(matrix);
        }
        return canvasPattern;
    }
}
function $4f71e35e4552e3dd$var$brushPath(ctx, el, style, inBatch) {
    var _a;
    var hasStroke = $4f71e35e4552e3dd$var$styleHasStroke(style);
    var hasFill = $4f71e35e4552e3dd$var$styleHasFill(style);
    var strokePercent = style.strokePercent;
    var strokePart = strokePercent < 1;
    var firstDraw = !el.path;
    if ((!el.silent || strokePart) && firstDraw) el.createPathProxy();
    var path = el.path || $4f71e35e4552e3dd$var$pathProxyForDraw;
    var dirtyFlag = el.__dirty;
    if (!inBatch) {
        var fill = style.fill;
        var stroke = style.stroke;
        var hasFillGradient = hasFill && !!fill.colorStops;
        var hasStrokeGradient = hasStroke && !!stroke.colorStops;
        var hasFillPattern = hasFill && !!fill.image;
        var hasStrokePattern = hasStroke && !!stroke.image;
        var fillGradient = void 0;
        var strokeGradient = void 0;
        var fillPattern = void 0;
        var strokePattern = void 0;
        var rect = void 0;
        if (hasFillGradient || hasStrokeGradient) rect = el.getBoundingRect();
        if (hasFillGradient) {
            fillGradient = dirtyFlag ? (0, $d76b6507633b3c44$export$3dab6afd018d48c7)(ctx, fill, rect) : el.__canvasFillGradient;
            el.__canvasFillGradient = fillGradient;
        }
        if (hasStrokeGradient) {
            strokeGradient = dirtyFlag ? (0, $d76b6507633b3c44$export$3dab6afd018d48c7)(ctx, stroke, rect) : el.__canvasStrokeGradient;
            el.__canvasStrokeGradient = strokeGradient;
        }
        if (hasFillPattern) {
            fillPattern = dirtyFlag || !el.__canvasFillPattern ? $4f71e35e4552e3dd$export$8eb5db6b7bc27903(ctx, fill, el) : el.__canvasFillPattern;
            el.__canvasFillPattern = fillPattern;
        }
        if (hasStrokePattern) {
            strokePattern = dirtyFlag || !el.__canvasStrokePattern ? $4f71e35e4552e3dd$export$8eb5db6b7bc27903(ctx, stroke, el) : el.__canvasStrokePattern;
            el.__canvasStrokePattern = strokePattern;
        }
        if (hasFillGradient) ctx.fillStyle = fillGradient;
        else if (hasFillPattern) {
            if (fillPattern) ctx.fillStyle = fillPattern;
            else hasFill = false;
        }
        if (hasStrokeGradient) ctx.strokeStyle = strokeGradient;
        else if (hasStrokePattern) {
            if (strokePattern) ctx.strokeStyle = strokePattern;
            else hasStroke = false;
        }
    }
    var scale = el.getGlobalScale();
    path.setScale(scale[0], scale[1], el.segmentIgnoreThreshold);
    var lineDash;
    var lineDashOffset;
    if (ctx.setLineDash && style.lineDash) _a = (0, $21ab8baf7c1f083c$export$9d315911f153b3b2)(el), lineDash = _a[0], lineDashOffset = _a[1];
    var needsRebuild = true;
    if (firstDraw || dirtyFlag & (0, $ddf76b16f1246ba9$export$f75fe89a33ebe115)) {
        path.setDPR(ctx.dpr);
        if (strokePart) path.setContext(null);
        else {
            path.setContext(ctx);
            needsRebuild = false;
        }
        path.reset();
        el.buildPath(path, el.shape, inBatch);
        path.toStatic();
        el.pathUpdated();
    }
    if (needsRebuild) path.rebuildPath(ctx, strokePart ? strokePercent : 1);
    if (lineDash) {
        ctx.setLineDash(lineDash);
        ctx.lineDashOffset = lineDashOffset;
    }
    if (!inBatch) {
        if (style.strokeFirst) {
            if (hasStroke) $4f71e35e4552e3dd$var$doStrokePath(ctx, style);
            if (hasFill) $4f71e35e4552e3dd$var$doFillPath(ctx, style);
        } else {
            if (hasFill) $4f71e35e4552e3dd$var$doFillPath(ctx, style);
            if (hasStroke) $4f71e35e4552e3dd$var$doStrokePath(ctx, style);
        }
    }
    if (lineDash) ctx.setLineDash([]);
}
function $4f71e35e4552e3dd$var$brushImage(ctx, el, style) {
    var image = el.__image = (0, $a53bd598adfb7ebe$export$46c791b69ff9a0f)(style.image, el.__image, el, el.onload);
    if (!image || !(0, $a53bd598adfb7ebe$export$37ca7dd901d0236d)(image)) return;
    var x = style.x || 0;
    var y = style.y || 0;
    var width = el.getWidth();
    var height = el.getHeight();
    var aspect = image.width / image.height;
    if (width == null && height != null) width = height * aspect;
    else if (height == null && width != null) height = width / aspect;
    else if (width == null && height == null) {
        width = image.width;
        height = image.height;
    }
    if (style.sWidth && style.sHeight) {
        var sx = style.sx || 0;
        var sy = style.sy || 0;
        ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
    } else if (style.sx && style.sy) {
        var sx = style.sx;
        var sy = style.sy;
        var sWidth = width - sx;
        var sHeight = height - sy;
        ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
    } else ctx.drawImage(image, x, y, width, height);
}
function $4f71e35e4552e3dd$var$brushText(ctx, el, style) {
    var _a;
    var text = style.text;
    text != null && (text += "");
    if (text) {
        ctx.font = style.font || (0, $c6341dcc9d86826e$export$7d7a232b6d2cc80c);
        ctx.textAlign = style.textAlign;
        ctx.textBaseline = style.textBaseline;
        var lineDash = void 0;
        var lineDashOffset = void 0;
        if (ctx.setLineDash && style.lineDash) _a = (0, $21ab8baf7c1f083c$export$9d315911f153b3b2)(el), lineDash = _a[0], lineDashOffset = _a[1];
        if (lineDash) {
            ctx.setLineDash(lineDash);
            ctx.lineDashOffset = lineDashOffset;
        }
        if (style.strokeFirst) {
            if ($4f71e35e4552e3dd$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
            if ($4f71e35e4552e3dd$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
        } else {
            if ($4f71e35e4552e3dd$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
            if ($4f71e35e4552e3dd$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
        }
        if (lineDash) ctx.setLineDash([]);
    }
}
var $4f71e35e4552e3dd$var$SHADOW_NUMBER_PROPS = [
    "shadowBlur",
    "shadowOffsetX",
    "shadowOffsetY"
];
var $4f71e35e4552e3dd$var$STROKE_PROPS = [
    [
        "lineCap",
        "butt"
    ],
    [
        "lineJoin",
        "miter"
    ],
    [
        "miterLimit",
        10
    ]
];
function $4f71e35e4552e3dd$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope) {
    var styleChanged = false;
    if (!forceSetAll) {
        prevStyle = prevStyle || {};
        if (style === prevStyle) return false;
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
        styleChanged = true;
        var opacity = Math.max(Math.min(style.opacity, 1), 0);
        ctx.globalAlpha = isNaN(opacity) ? (0, $56206a6cb4666931$export$737672163db00fe3).opacity : opacity;
    }
    if (forceSetAll || style.blend !== prevStyle.blend) {
        if (!styleChanged) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalCompositeOperation = style.blend || (0, $56206a6cb4666931$export$737672163db00fe3).blend;
    }
    for(var i = 0; i < $4f71e35e4552e3dd$var$SHADOW_NUMBER_PROPS.length; i++){
        var propName = $4f71e35e4552e3dd$var$SHADOW_NUMBER_PROPS[i];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = ctx.dpr * (style[propName] || 0);
        }
    }
    if (forceSetAll || style.shadowColor !== prevStyle.shadowColor) {
        if (!styleChanged) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.shadowColor = style.shadowColor || (0, $56206a6cb4666931$export$737672163db00fe3).shadowColor;
    }
    return styleChanged;
}
function $4f71e35e4552e3dd$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetAll, scope) {
    var style = $4f71e35e4552e3dd$var$getStyle(el, scope.inHover);
    var prevStyle = forceSetAll ? null : prevEl && $4f71e35e4552e3dd$var$getStyle(prevEl, scope.inHover) || {};
    if (style === prevStyle) return false;
    var styleChanged = $4f71e35e4552e3dd$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope);
    if (forceSetAll || style.fill !== prevStyle.fill) {
        if (!styleChanged) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $4f71e35e4552e3dd$var$isValidStrokeFillStyle(style.fill) && (ctx.fillStyle = style.fill);
    }
    if (forceSetAll || style.stroke !== prevStyle.stroke) {
        if (!styleChanged) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $4f71e35e4552e3dd$var$isValidStrokeFillStyle(style.stroke) && (ctx.strokeStyle = style.stroke);
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        if (!styleChanged) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
    }
    if (el.hasStroke()) {
        var lineWidth = style.lineWidth;
        var newLineWidth = lineWidth / (style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1);
        if (ctx.lineWidth !== newLineWidth) {
            if (!styleChanged) {
                $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx.lineWidth = newLineWidth;
        }
    }
    for(var i = 0; i < $4f71e35e4552e3dd$var$STROKE_PROPS.length; i++){
        var prop = $4f71e35e4552e3dd$var$STROKE_PROPS[i];
        var propName = prop[0];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = style[propName] || prop[1];
        }
    }
    return styleChanged;
}
function $4f71e35e4552e3dd$var$bindImageStyle(ctx, el, prevEl, forceSetAll, scope) {
    return $4f71e35e4552e3dd$var$bindCommonProps(ctx, $4f71e35e4552e3dd$var$getStyle(el, scope.inHover), prevEl && $4f71e35e4552e3dd$var$getStyle(prevEl, scope.inHover), forceSetAll, scope);
}
function $4f71e35e4552e3dd$var$setContextTransform(ctx, el) {
    var m = el.transform;
    var dpr = ctx.dpr || 1;
    if (m) ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
    else ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
}
function $4f71e35e4552e3dd$var$updateClipStatus(clipPaths, ctx, scope) {
    var allClipped = false;
    for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        allClipped = allClipped || clipPath.isZeroArea();
        $4f71e35e4552e3dd$var$setContextTransform(ctx, clipPath);
        ctx.beginPath();
        clipPath.buildPath(ctx, clipPath.shape);
        ctx.clip();
    }
    scope.allClipped = allClipped;
}
function $4f71e35e4552e3dd$var$isTransformChanged(m0, m1) {
    if (m0 && m1) return m0[0] !== m1[0] || m0[1] !== m1[1] || m0[2] !== m1[2] || m0[3] !== m1[3] || m0[4] !== m1[4] || m0[5] !== m1[5];
    else if (!m0 && !m1) return false;
    return true;
}
var $4f71e35e4552e3dd$var$DRAW_TYPE_PATH = 1;
var $4f71e35e4552e3dd$var$DRAW_TYPE_IMAGE = 2;
var $4f71e35e4552e3dd$var$DRAW_TYPE_TEXT = 3;
var $4f71e35e4552e3dd$var$DRAW_TYPE_INCREMENTAL = 4;
function $4f71e35e4552e3dd$var$canPathBatch(style) {
    var hasFill = $4f71e35e4552e3dd$var$styleHasFill(style);
    var hasStroke = $4f71e35e4552e3dd$var$styleHasStroke(style);
    return !(style.lineDash || !(+hasFill ^ +hasStroke) || hasFill && typeof style.fill !== "string" || hasStroke && typeof style.stroke !== "string" || style.strokePercent < 1 || style.strokeOpacity < 1 || style.fillOpacity < 1);
}
function $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope) {
    scope.batchFill && ctx.fill();
    scope.batchStroke && ctx.stroke();
    scope.batchFill = "";
    scope.batchStroke = "";
}
function $4f71e35e4552e3dd$var$getStyle(el, inHover) {
    return inHover ? el.__hoverStyle || el.style : el.style;
}
function $4f71e35e4552e3dd$export$567881adfc3eb7f3(ctx, el) {
    $4f71e35e4552e3dd$export$da5d6544e8c27bc1(ctx, el, {
        inHover: false,
        viewWidth: 0,
        viewHeight: 0
    }, true);
}
function $4f71e35e4552e3dd$export$da5d6544e8c27bc1(ctx, el, scope, isLast) {
    var m = el.transform;
    if (!el.shouldBePainted(scope.viewWidth, scope.viewHeight, false, false)) {
        el.__dirty &= ~(0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
        el.__isRendered = false;
        return;
    }
    var clipPaths = el.__clipPaths;
    var prevElClipPaths = scope.prevElClipPaths;
    var forceSetTransform = false;
    var forceSetStyle = false;
    if (!prevElClipPaths || (0, $d76b6507633b3c44$export$beeddc5150cb2e83)(clipPaths, prevElClipPaths)) {
        if (prevElClipPaths && prevElClipPaths.length) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            ctx.restore();
            forceSetStyle = forceSetTransform = true;
            scope.prevElClipPaths = null;
            scope.allClipped = false;
            scope.prevEl = null;
        }
        if (clipPaths && clipPaths.length) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            ctx.save();
            $4f71e35e4552e3dd$var$updateClipStatus(clipPaths, ctx, scope);
            forceSetTransform = true;
        }
        scope.prevElClipPaths = clipPaths;
    }
    if (scope.allClipped) {
        el.__isRendered = false;
        return;
    }
    el.beforeBrush && el.beforeBrush();
    el.innerBeforeBrush();
    var prevEl = scope.prevEl;
    if (!prevEl) forceSetStyle = forceSetTransform = true;
    var canBatchPath = el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039) && el.autoBatch && $4f71e35e4552e3dd$var$canPathBatch(el.style);
    if (forceSetTransform || $4f71e35e4552e3dd$var$isTransformChanged(m, prevEl.transform)) {
        $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
        $4f71e35e4552e3dd$var$setContextTransform(ctx, el);
    } else if (!canBatchPath) $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
    var style = $4f71e35e4552e3dd$var$getStyle(el, scope.inHover);
    if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) {
        if (scope.lastDrawType !== $4f71e35e4552e3dd$var$DRAW_TYPE_PATH) {
            forceSetStyle = true;
            scope.lastDrawType = $4f71e35e4552e3dd$var$DRAW_TYPE_PATH;
        }
        $4f71e35e4552e3dd$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
        if (!canBatchPath || !scope.batchFill && !scope.batchStroke) ctx.beginPath();
        $4f71e35e4552e3dd$var$brushPath(ctx, el, style, canBatchPath);
        if (canBatchPath) {
            scope.batchFill = style.fill || "";
            scope.batchStroke = style.stroke || "";
        }
    } else {
        if (el instanceof (0, $c9d5c769fe2f591f$export$2e2bcd8739ae039)) {
            if (scope.lastDrawType !== $4f71e35e4552e3dd$var$DRAW_TYPE_TEXT) {
                forceSetStyle = true;
                scope.lastDrawType = $4f71e35e4552e3dd$var$DRAW_TYPE_TEXT;
            }
            $4f71e35e4552e3dd$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
            $4f71e35e4552e3dd$var$brushText(ctx, el, style);
        } else if (el instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
            if (scope.lastDrawType !== $4f71e35e4552e3dd$var$DRAW_TYPE_IMAGE) {
                forceSetStyle = true;
                scope.lastDrawType = $4f71e35e4552e3dd$var$DRAW_TYPE_IMAGE;
            }
            $4f71e35e4552e3dd$var$bindImageStyle(ctx, el, prevEl, forceSetStyle, scope);
            $4f71e35e4552e3dd$var$brushImage(ctx, el, style);
        } else if (el.getTemporalDisplayables) {
            if (scope.lastDrawType !== $4f71e35e4552e3dd$var$DRAW_TYPE_INCREMENTAL) {
                forceSetStyle = true;
                scope.lastDrawType = $4f71e35e4552e3dd$var$DRAW_TYPE_INCREMENTAL;
            }
            $4f71e35e4552e3dd$var$brushIncremental(ctx, el, scope);
        }
    }
    if (canBatchPath && isLast) $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
    el.innerAfterBrush();
    el.afterBrush && el.afterBrush();
    scope.prevEl = el;
    el.__dirty = 0;
    el.__isRendered = true;
}
function $4f71e35e4552e3dd$var$brushIncremental(ctx, el, scope) {
    var displayables = el.getDisplayables();
    var temporalDisplayables = el.getTemporalDisplayables();
    ctx.save();
    var innerScope = {
        prevElClipPaths: null,
        prevEl: null,
        allClipped: false,
        viewWidth: scope.viewWidth,
        viewHeight: scope.viewHeight,
        inHover: scope.inHover
    };
    var i;
    var len;
    for(i = el.getCursor(), len = displayables.length; i < len; i++){
        var displayable = displayables[i];
        displayable.beforeBrush && displayable.beforeBrush();
        displayable.innerBeforeBrush();
        $4f71e35e4552e3dd$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i === len - 1);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    for(var i_1 = 0, len_1 = temporalDisplayables.length; i_1 < len_1; i_1++){
        var displayable = temporalDisplayables[i_1];
        displayable.beforeBrush && displayable.beforeBrush();
        displayable.innerBeforeBrush();
        $4f71e35e4552e3dd$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i_1 === len_1 - 1);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    el.clearTemporalDisplayables();
    el.notClear = true;
    ctx.restore();
}



var $c6d646aacd243427$var$decalMap = new (0, $56aadf5b08ec1b47$export$2e2bcd8739ae039)();
var $c6d646aacd243427$var$decalCache = new (0, $d91b0b6fc564d9c7$export$2e2bcd8739ae039)(100);
var $c6d646aacd243427$var$decalKeys = [
    "symbol",
    "symbolSize",
    "symbolKeepAspect",
    "color",
    "backgroundColor",
    "dashArrayX",
    "dashArrayY",
    "maxTileWidth",
    "maxTileHeight"
];
function $c6d646aacd243427$export$a3ba048e1a648972(decalObject, api) {
    if (decalObject === "none") return null;
    var dpr = api.getDevicePixelRatio();
    var zr = api.getZr();
    var isSVG = zr.painter.type === "svg";
    if (decalObject.dirty) $c6d646aacd243427$var$decalMap["delete"](decalObject);
    var oldPattern = $c6d646aacd243427$var$decalMap.get(decalObject);
    if (oldPattern) return oldPattern;
    var decalOpt = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(decalObject, {
        symbol: "rect",
        symbolSize: 1,
        symbolKeepAspect: true,
        color: "rgba(0, 0, 0, 0.2)",
        backgroundColor: null,
        dashArrayX: 5,
        dashArrayY: 5,
        rotation: 0,
        maxTileWidth: 512,
        maxTileHeight: 512
    });
    if (decalOpt.backgroundColor === "none") decalOpt.backgroundColor = null;
    var pattern = {
        repeat: "repeat"
    };
    setPatternnSource(pattern);
    pattern.rotation = decalOpt.rotation;
    pattern.scaleX = pattern.scaleY = isSVG ? 1 : 1 / dpr;
    $c6d646aacd243427$var$decalMap.set(decalObject, pattern);
    decalObject.dirty = false;
    return pattern;
    function setPatternnSource(pattern) {
        var keys = [
            dpr
        ];
        var isValidKey = true;
        for(var i = 0; i < $c6d646aacd243427$var$decalKeys.length; ++i){
            var value = decalOpt[$c6d646aacd243427$var$decalKeys[i]];
            if (value != null && !(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(value) && !(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(value) && !(0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(value) && typeof value !== "boolean") {
                isValidKey = false;
                break;
            }
            keys.push(value);
        }
        var cacheKey;
        if (isValidKey) {
            cacheKey = keys.join(",") + (isSVG ? "-svg" : "");
            var cache = $c6d646aacd243427$var$decalCache.get(cacheKey);
            if (cache) isSVG ? pattern.svgElement = cache : pattern.image = cache;
        }
        var dashArrayX = $c6d646aacd243427$var$normalizeDashArrayX(decalOpt.dashArrayX);
        var dashArrayY = $c6d646aacd243427$var$normalizeDashArrayY(decalOpt.dashArrayY);
        var symbolArray = $c6d646aacd243427$var$normalizeSymbolArray(decalOpt.symbol);
        var lineBlockLengthsX = $c6d646aacd243427$var$getLineBlockLengthX(dashArrayX);
        var lineBlockLengthY = $c6d646aacd243427$var$getLineBlockLengthY(dashArrayY);
        var canvas = !isSVG && (0, $c6341dcc9d86826e$export$ef5e599365494451).createCanvas();
        var svgRoot = isSVG && {
            tag: "g",
            attrs: {},
            key: "dcl",
            children: []
        };
        var pSize = getPatternSize();
        var ctx;
        if (canvas) {
            canvas.width = pSize.width * dpr;
            canvas.height = pSize.height * dpr;
            ctx = canvas.getContext("2d");
        }
        brushDecal();
        if (isValidKey) $c6d646aacd243427$var$decalCache.put(cacheKey, canvas || svgRoot);
        pattern.image = canvas;
        pattern.svgElement = svgRoot;
        pattern.svgWidth = pSize.width;
        pattern.svgHeight = pSize.height;
        /**
     * Get minimum length that can make a repeatable pattern.
     *
     * @return {Object} pattern width and height
     */ function getPatternSize() {
            /**
       * For example, if dash is [[3, 2], [2, 1]] for X, it looks like
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * So the minimum length of X is 15,
       * which is the least common multiple of `3 + 2` and `2 + 1`
       * |---  ---  ---  |---  --- ...
       * |-- -- -- -- -- |-- -- -- ...
       */ var width = 1;
            for(var i = 0, xlen = lineBlockLengthsX.length; i < xlen; ++i)width = (0, $cfc1f3b422a3185f$export$680a45b749323f49)(width, lineBlockLengthsX[i]);
            var symbolRepeats = 1;
            for(var i = 0, xlen = symbolArray.length; i < xlen; ++i)symbolRepeats = (0, $cfc1f3b422a3185f$export$680a45b749323f49)(symbolRepeats, symbolArray[i].length);
            width *= symbolRepeats;
            var height = lineBlockLengthY * lineBlockLengthsX.length * symbolArray.length;
            var warn;
            return {
                width: Math.max(1, Math.min(width, decalOpt.maxTileWidth)),
                height: Math.max(1, Math.min(height, decalOpt.maxTileHeight))
            };
        }
        function brushDecal() {
            if (ctx) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                if (decalOpt.backgroundColor) {
                    ctx.fillStyle = decalOpt.backgroundColor;
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                }
            }
            var ySum = 0;
            for(var i = 0; i < dashArrayY.length; ++i)ySum += dashArrayY[i];
            if (ySum <= 0) // dashArrayY is 0, draw nothing
            return;
            var y = -lineBlockLengthY;
            var yId = 0;
            var yIdTotal = 0;
            var xId0 = 0;
            while(y < pSize.height){
                if (yId % 2 === 0) {
                    var symbolYId = yIdTotal / 2 % symbolArray.length;
                    var x = 0;
                    var xId1 = 0;
                    var xId1Total = 0;
                    while(x < pSize.width * 2){
                        var xSum = 0;
                        for(var i = 0; i < dashArrayX[xId0].length; ++i)xSum += dashArrayX[xId0][i];
                        if (xSum <= 0) break;
                        // E.g., [15, 5, 20, 5] draws only for 15 and 20
                        if (xId1 % 2 === 0) {
                            var size = (1 - decalOpt.symbolSize) * 0.5;
                            var left = x + dashArrayX[xId0][xId1] * size;
                            var top_1 = y + dashArrayY[yId] * size;
                            var width = dashArrayX[xId0][xId1] * decalOpt.symbolSize;
                            var height = dashArrayY[yId] * decalOpt.symbolSize;
                            var symbolXId = xId1Total / 2 % symbolArray[symbolYId].length;
                            brushSymbol(left, top_1, width, height, symbolArray[symbolYId][symbolXId]);
                        }
                        x += dashArrayX[xId0][xId1];
                        ++xId1Total;
                        ++xId1;
                        if (xId1 === dashArrayX[xId0].length) xId1 = 0;
                    }
                    ++xId0;
                    if (xId0 === dashArrayX.length) xId0 = 0;
                }
                y += dashArrayY[yId];
                ++yIdTotal;
                ++yId;
                if (yId === dashArrayY.length) yId = 0;
            }
            function brushSymbol(x, y, width, height, symbolType) {
                var scale = isSVG ? 1 : dpr;
                var symbol = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symbolType, x * scale, y * scale, width * scale, height * scale, decalOpt.color, decalOpt.symbolKeepAspect);
                if (isSVG) {
                    var symbolVNode = zr.painter.renderOneToVNode(symbol);
                    if (symbolVNode) svgRoot.children.push(symbolVNode);
                } else // Paint to canvas for all other renderers.
                (0, $4f71e35e4552e3dd$export$567881adfc3eb7f3)(ctx, symbol);
            }
        }
    }
}
/**
 * Convert symbol array into normalized array
 *
 * @param {string | (string | string[])[]} symbol symbol input
 * @return {string[][]} normolized symbol array
 */ function $c6d646aacd243427$var$normalizeSymbolArray(symbol) {
    if (!symbol || symbol.length === 0) return [
        [
            "rect"
        ]
    ];
    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(symbol)) return [
        [
            symbol
        ]
    ];
    var isAllString = true;
    for(var i = 0; i < symbol.length; ++i)if (!(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(symbol[i])) {
        isAllString = false;
        break;
    }
    if (isAllString) return $c6d646aacd243427$var$normalizeSymbolArray([
        symbol
    ]);
    var result = [];
    for(var i = 0; i < symbol.length; ++i)if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(symbol[i])) result.push([
        symbol[i]
    ]);
    else result.push(symbol[i]);
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayX} dash dash input
 * @return {number[][]} normolized dash array
 */ function $c6d646aacd243427$var$normalizeDashArrayX(dash) {
    if (!dash || dash.length === 0) return [
        [
            0,
            0
        ]
    ];
    if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(dash)) {
        var dashValue = Math.ceil(dash);
        return [
            [
                dashValue,
                dashValue
            ]
        ];
    }
    /**
   * [20, 5] should be normalized into [[20, 5]],
   * while [20, [5, 10]] should be normalized into [[20, 20], [5, 10]]
   */ var isAllNumber = true;
    for(var i = 0; i < dash.length; ++i)if (!(0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(dash[i])) {
        isAllNumber = false;
        break;
    }
    if (isAllNumber) return $c6d646aacd243427$var$normalizeDashArrayX([
        dash
    ]);
    var result = [];
    for(var i = 0; i < dash.length; ++i)if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(dash[i])) {
        var dashValue = Math.ceil(dash[i]);
        result.push([
            dashValue,
            dashValue
        ]);
    } else {
        var dashValue = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dash[i], function(n) {
            return Math.ceil(n);
        });
        if (dashValue.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
        // so normalize it to be [4, 2, 1, 4, 2, 1]
        result.push(dashValue.concat(dashValue));
        else result.push(dashValue);
    }
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayY} dash dash input
 * @return {number[]} normolized dash array
 */ function $c6d646aacd243427$var$normalizeDashArrayY(dash) {
    if (!dash || typeof dash === "object" && dash.length === 0) return [
        0,
        0
    ];
    if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(dash)) {
        var dashValue_1 = Math.ceil(dash);
        return [
            dashValue_1,
            dashValue_1
        ];
    }
    var dashValue = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dash, function(n) {
        return Math.ceil(n);
    });
    return dash.length % 2 ? dashValue.concat(dashValue) : dashValue;
}
/**
 * Get block length of each line. A block is the length of dash line and space.
 * For example, a line with [4, 1] has a dash line of 4 and a space of 1 after
 * that, so the block length of this line is 5.
 *
 * @param {number[][]} dash dash array of X or Y
 * @return {number[]} block length of each line
 */ function $c6d646aacd243427$var$getLineBlockLengthX(dash) {
    return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dash, function(line) {
        return $c6d646aacd243427$var$getLineBlockLengthY(line);
    });
}
function $c6d646aacd243427$var$getLineBlockLengthY(dash) {
    var blockLength = 0;
    for(var i = 0; i < dash.length; ++i)blockLength += dash[i];
    if (dash.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
    // So total length is (4 + 2 + 1) * 2
    return blockLength * 2;
    return blockLength;
}


function $d82adaf1a5a5cfeb$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachRawSeries(function(seriesModel) {
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        if (data.hasItemVisual()) data.each(function(idx) {
            var decal = data.getItemVisual(idx, "decal");
            if (decal) {
                var itemStyle = data.ensureUniqueItemVisual(idx, "style");
                itemStyle.decal = (0, $c6d646aacd243427$export$a3ba048e1a648972)(decal, api);
            }
        });
        var decal = data.getVisual("decal");
        if (decal) {
            var style = data.getVisual("style");
            style.decal = (0, $c6d646aacd243427$export$a3ba048e1a648972)(decal, api);
        }
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $8022924a3c5c0bb5$var$lifecycle = new (0, $63441a86293f101f$export$2e2bcd8739ae039)();
var $8022924a3c5c0bb5$export$2e2bcd8739ae039 = $8022924a3c5c0bb5$var$lifecycle;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
// Implementation of exported APIs. For example registerMap, getMap.
// The implementations will be registered when installing the component.
// Avoid these code being bundled to the core module.
var $f773aa0508c1d920$var$implsStore = {};
function $f773aa0508c1d920$export$9b808fd12256ddd3(name, impl) {
    $f773aa0508c1d920$var$implsStore[name] = impl;
}
function $f773aa0508c1d920$export$73333eb8a09d5f61(name) {
    return $f773aa0508c1d920$var$implsStore[name];
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $b11674322a1bd845$var$customRenderers = {};
function $b11674322a1bd845$export$c3e61191887968da(type, renderItem) {
    $b11674322a1bd845$var$customRenderers[type] = renderItem;
}
function $b11674322a1bd845$export$2b5db8e5650e8d15(type) {
    return $b11674322a1bd845$var$customRenderers[type];
}


var $4d59907f44a2d0ad$export$83d89fbfd8236492 = "6.0.0";
var $4d59907f44a2d0ad$export$b74ff737e0e298b5 = {
    zrender: "6.0.0"
};
var $4d59907f44a2d0ad$var$TEST_FRAME_REMAIN_TIME = 1;
var $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_SERIES_FILTER = 800;
// Some data processors depends on the stack result dimension (to calculate data extent).
// So data stack stage should be in front of data processing stage.
var $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_DATASTACK = 900;
// "Data filter" will block the stream, so it should be
// put at the beginning of data processing.
var $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_FILTER = 1000;
var $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_DEFAULT = 2000;
var $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_STATISTIC = 5000;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_LAYOUT = 1000;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_GLOBAL = 2000;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART = 3000;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_COMPONENT = 4000;
// Visual property in data. Greater than `PRIORITY_VISUAL_COMPONENT` to enable to
// overwrite the viusal result of component (like `visualMap`)
// using data item specific setting (like itemStyle.xxx on data item)
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM = 4500;
// Greater than `PRIORITY_VISUAL_CHART_DATA_CUSTOM` to enable to layout based on
// visual result like `symbolSize`.
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_POST_CHART_LAYOUT = 4600;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_BRUSH = 5000;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_ARIA = 6000;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_DECAL = 7000;
var $4d59907f44a2d0ad$export$bb34f3538ba26c7e = {
    PROCESSOR: {
        FILTER: $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_FILTER,
        SERIES_FILTER: $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_SERIES_FILTER,
        STATISTIC: $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_STATISTIC
    },
    VISUAL: {
        LAYOUT: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_LAYOUT,
        PROGRESSIVE_LAYOUT: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
        GLOBAL: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_GLOBAL,
        CHART: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART,
        POST_CHART_LAYOUT: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_POST_CHART_LAYOUT,
        COMPONENT: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_COMPONENT,
        BRUSH: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_BRUSH,
        CHART_ITEM: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM,
        ARIA: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_ARIA,
        DECAL: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_DECAL
    }
};
// Main process have three entries: `setOption`, `dispatchAction` and `resize`,
// where they must not be invoked nestedly, except the only case: invoke
// dispatchAction with updateMethod "none" in main process.
// This flag is used to carry out this rule.
// All events will be triggered out side main process (i.e. when !this[IN_MAIN_PROCESS]).
var $4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY = "__flagInMainProcess";
// Useful for detecting outdated rendering results in scenarios that these issues are involved:
//  - Use shortcut (such as, updateTransform, or no update) to start a main process.
//  - Asynchronously update rendered view (e.g., graph force layout).
//  - Multiple ChartView/ComponentView render to one group cooperatively.
var $4d59907f44a2d0ad$var$MAIN_PROCESS_VERSION_KEY = "__mainProcessVersion";
var $4d59907f44a2d0ad$var$PENDING_UPDATE = "__pendingUpdate";
var $4d59907f44a2d0ad$var$STATUS_NEEDS_UPDATE_KEY = "__needsUpdateStatus";
var $4d59907f44a2d0ad$var$ACTION_REG = /^[a-zA-Z0-9_]+$/;
var $4d59907f44a2d0ad$var$CONNECT_STATUS_KEY = "__connectUpdateStatus";
var $4d59907f44a2d0ad$var$CONNECT_STATUS_PENDING = 0;
var $4d59907f44a2d0ad$var$CONNECT_STATUS_UPDATING = 1;
var $4d59907f44a2d0ad$var$CONNECT_STATUS_UPDATED = 2;
function $4d59907f44a2d0ad$var$createRegisterEventWithLowercaseECharts(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.isDisposed()) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        return $4d59907f44a2d0ad$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $4d59907f44a2d0ad$var$createRegisterEventWithLowercaseMessageCenter(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $4d59907f44a2d0ad$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $4d59907f44a2d0ad$var$toLowercaseNameAndCallEventful(host, method, args) {
    // `args[0]` is event name. Event name is all lowercase.
    args[0] = args[0] && args[0].toLowerCase();
    return (0, $63441a86293f101f$export$2e2bcd8739ae039).prototype[method].apply(host, args);
}
var $4d59907f44a2d0ad$var$MessageCenter = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MessageCenter, _super);
    function MessageCenter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MessageCenter;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
var $4d59907f44a2d0ad$var$messageCenterProto = $4d59907f44a2d0ad$var$MessageCenter.prototype;
$4d59907f44a2d0ad$var$messageCenterProto.on = $4d59907f44a2d0ad$var$createRegisterEventWithLowercaseMessageCenter("on");
$4d59907f44a2d0ad$var$messageCenterProto.off = $4d59907f44a2d0ad$var$createRegisterEventWithLowercaseMessageCenter("off");
// ---------------------------------------
// Internal method names for class ECharts
// ---------------------------------------
var $4d59907f44a2d0ad$var$prepare;
var $4d59907f44a2d0ad$var$prepareView;
var $4d59907f44a2d0ad$var$updateDirectly;
var $4d59907f44a2d0ad$var$updateMethods;
var $4d59907f44a2d0ad$var$doConvertPixel;
var $4d59907f44a2d0ad$var$updateStreamModes;
var $4d59907f44a2d0ad$var$doDispatchAction;
var $4d59907f44a2d0ad$var$flushPendingActions;
var $4d59907f44a2d0ad$var$triggerUpdatedEvent;
var $4d59907f44a2d0ad$var$bindRenderedEvent;
var $4d59907f44a2d0ad$var$bindMouseEvent;
var $4d59907f44a2d0ad$var$render;
var $4d59907f44a2d0ad$var$renderComponents;
var $4d59907f44a2d0ad$var$renderSeries;
var $4d59907f44a2d0ad$var$createExtensionAPI;
var $4d59907f44a2d0ad$var$enableConnect;
var $4d59907f44a2d0ad$var$markStatusToUpdate;
var $4d59907f44a2d0ad$var$applyChangedStates;
var $4d59907f44a2d0ad$var$updateMainProcessVersion;
var $4d59907f44a2d0ad$var$ECharts = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ECharts, _super);
    function ECharts(dom, // Theme name or themeOption.
    theme, opts) {
        var _this = _super.call(this, new (0, $82d62ed69f6abce3$export$d0fd09f950257b52)()) || this;
        _this._chartsViews = [];
        _this._chartsMap = {};
        _this._componentsViews = [];
        _this._componentsMap = {};
        // Can't dispatch action during rendering procedure
        _this._pendingActions = [];
        opts = opts || {};
        _this._dom = dom;
        var defaultRenderer = "canvas";
        var defaultCoarsePointer = "auto";
        var defaultUseDirtyRect = false;
        _this[$4d59907f44a2d0ad$var$MAIN_PROCESS_VERSION_KEY] = 1;
        var root;
        if (opts.ssr) $6eba88f9eebe6af9$export$e7a09d7fe68a4f7(function(el) {
            var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
            var dataIndex = ecData.dataIndex;
            if (dataIndex == null) return;
            var hashMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
            hashMap.set("series_index", ecData.seriesIndex);
            hashMap.set("data_index", dataIndex);
            ecData.ssrType && hashMap.set("ssr_type", ecData.ssrType);
            return hashMap;
        });
        var zr = _this._zr = $6eba88f9eebe6af9$export$2cd8252107eb640b(dom, {
            renderer: opts.renderer || defaultRenderer,
            devicePixelRatio: opts.devicePixelRatio,
            width: opts.width,
            height: opts.height,
            ssr: opts.ssr,
            useDirtyRect: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(opts.useDirtyRect, defaultUseDirtyRect),
            useCoarsePointer: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(opts.useCoarsePointer, defaultCoarsePointer),
            pointerSize: opts.pointerSize
        });
        _this._ssr = opts.ssr;
        // Expect 60 fps.
        _this._throttledZrFlush = (0, $c98659a9437a3d2e$export$de363e709c412c8a)((0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(zr.flush, zr), 17);
        _this._updateTheme(theme);
        _this._locale = (0, $9b0a1ef4bcc91e7d$export$ddc371781a6af754)(opts.locale || (0, $9b0a1ef4bcc91e7d$export$9a2147b3808d4c6b));
        _this._coordSysMgr = new (0, $70c3ede7d3b64757$export$2e2bcd8739ae039)();
        var api = _this._api = $4d59907f44a2d0ad$var$createExtensionAPI(_this);
        // Sort on demand
        function prioritySortFunc(a, b) {
            return a.__prio - b.__prio;
        }
        (0, $97579a54749e4b24$export$2e2bcd8739ae039)($4d59907f44a2d0ad$var$visualFuncs, prioritySortFunc);
        (0, $97579a54749e4b24$export$2e2bcd8739ae039)($4d59907f44a2d0ad$var$dataProcessorFuncs, prioritySortFunc);
        _this._scheduler = new (0, $94ae4e8744638a8a$export$2e2bcd8739ae039)(_this, api, $4d59907f44a2d0ad$var$dataProcessorFuncs, $4d59907f44a2d0ad$var$visualFuncs);
        _this._messageCenter = new $4d59907f44a2d0ad$var$MessageCenter();
        // Init mouse events
        _this._initEvents();
        // In case some people write `window.onresize = chart.resize`
        _this.resize = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this.resize, _this);
        zr.animation.on("frame", _this._onframe, _this);
        $4d59907f44a2d0ad$var$bindRenderedEvent(zr, _this);
        $4d59907f44a2d0ad$var$bindMouseEvent(zr, _this);
        // ECharts instance can be used as value.
        (0, $7a1bd9c2710fea0d$export$112e66431016387b)(_this);
        return _this;
    }
    ECharts.prototype._onframe = function() {
        if (this._disposed) return;
        $4d59907f44a2d0ad$var$applyChangedStates(this);
        var scheduler = this._scheduler;
        // Lazy update
        if (this[$4d59907f44a2d0ad$var$PENDING_UPDATE]) {
            var silent = this[$4d59907f44a2d0ad$var$PENDING_UPDATE].silent;
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = true;
            $4d59907f44a2d0ad$var$updateMainProcessVersion(this);
            try {
                $4d59907f44a2d0ad$var$prepare(this);
                $4d59907f44a2d0ad$var$updateMethods.update.call(this, null, this[$4d59907f44a2d0ad$var$PENDING_UPDATE].updateParams);
            } catch (e) {
                this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
                this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = null;
                throw e;
            }
            // At present, in each frame, zrender performs:
            //   (1) animation step forward.
            //   (2) trigger('frame') (where this `_onframe` is called)
            //   (3) zrender flush (render).
            // If we do nothing here, since we use `setToFinal: true`, the step (3) above
            // will render the final state of the elements before the real animation started.
            this._zr.flush();
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
            this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = null;
            $4d59907f44a2d0ad$var$flushPendingActions.call(this, silent);
            $4d59907f44a2d0ad$var$triggerUpdatedEvent.call(this, silent);
        } else if (scheduler.unfinished) {
            // Stream progress.
            var remainTime = $4d59907f44a2d0ad$var$TEST_FRAME_REMAIN_TIME;
            var ecModel = this._model;
            var api = this._api;
            scheduler.unfinished = false;
            do {
                var startTime = +new Date();
                scheduler.performSeriesTasks(ecModel);
                // Currently dataProcessorFuncs do not check threshold.
                scheduler.performDataProcessorTasks(ecModel);
                $4d59907f44a2d0ad$var$updateStreamModes(this, ecModel);
                // Do not update coordinate system here. Because that coord system update in
                // each frame is not a good user experience. So we follow the rule that
                // the extent of the coordinate system is determined in the first frame (the
                // frame is executed immediately after task reset.
                // this._coordSysMgr.update(ecModel, api);
                // console.log('--- ec frame visual ---', remainTime);
                scheduler.performVisualTasks(ecModel);
                $4d59907f44a2d0ad$var$renderSeries(this, this._model, api, "remain", {});
                remainTime -= +new Date() - startTime;
            }while (remainTime > 0 && scheduler.unfinished);
            // Call flush explicitly for trigger finished event.
            if (!scheduler.unfinished) this._zr.flush();
        // Else, zr flushing be ensue within the same frame,
        // because zr flushing is after onframe event.
        }
    };
    ECharts.prototype.getDom = function() {
        return this._dom;
    };
    ECharts.prototype.getId = function() {
        return this.id;
    };
    ECharts.prototype.getZr = function() {
        return this._zr;
    };
    ECharts.prototype.isSSR = function() {
        return this._ssr;
    };
    /* eslint-disable-next-line */ ECharts.prototype.setOption = function(option, notMerge, lazyUpdate) {
        if (this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY]) return;
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        var silent;
        var replaceMerge;
        var transitionOpt;
        if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(notMerge)) {
            lazyUpdate = notMerge.lazyUpdate;
            silent = notMerge.silent;
            replaceMerge = notMerge.replaceMerge;
            transitionOpt = notMerge.transition;
            notMerge = notMerge.notMerge;
        }
        this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = true;
        $4d59907f44a2d0ad$var$updateMainProcessVersion(this);
        if (!this._model || notMerge) {
            var optionManager = new (0, $bf4c0a9077b4e970$export$2e2bcd8739ae039)(this._api);
            var theme = this._theme;
            var ecModel = this._model = new (0, $51f6ef0dd9546916$export$2e2bcd8739ae039)();
            ecModel.scheduler = this._scheduler;
            ecModel.ssr = this._ssr;
            ecModel.init(null, null, null, theme, this._locale, optionManager);
        }
        this._model.setOption(option, {
            replaceMerge: replaceMerge
        }, $4d59907f44a2d0ad$var$optionPreprocessorFuncs);
        var updateParams = {
            seriesTransition: transitionOpt,
            optionChanged: true
        };
        if (lazyUpdate) {
            this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = {
                silent: silent,
                updateParams: updateParams
            };
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
            // `setOption(option, {lazyMode: true})` may be called when zrender has been slept.
            // It should wake it up to make sure zrender start to render at the next frame.
            this.getZr().wakeUp();
        } else {
            try {
                $4d59907f44a2d0ad$var$prepare(this);
                $4d59907f44a2d0ad$var$updateMethods.update.call(this, null, updateParams);
            } catch (e) {
                this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = null;
                this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
                throw e;
            }
            // Ensure zr refresh sychronously, and then pixel in canvas can be
            // fetched after `setOption`.
            if (!this._ssr) // not use flush when using ssr mode.
            this._zr.flush();
            this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = null;
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
            $4d59907f44a2d0ad$var$flushPendingActions.call(this, silent);
            $4d59907f44a2d0ad$var$triggerUpdatedEvent.call(this, silent);
        }
    };
    /**
   * Update theme with name or theme option and repaint the chart.
   * @param theme Theme name or theme option.
   * @param opts Optional settings
   */ ECharts.prototype.setTheme = function(theme, opts) {
        if (this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY]) return;
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        var ecModel = this._model;
        if (!ecModel) return;
        var silent = opts && opts.silent;
        var updateParams = null;
        if (this[$4d59907f44a2d0ad$var$PENDING_UPDATE]) {
            if (silent == null) silent = this[$4d59907f44a2d0ad$var$PENDING_UPDATE].silent;
            updateParams = this[$4d59907f44a2d0ad$var$PENDING_UPDATE].updateParams;
            this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = null;
        }
        this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = true;
        $4d59907f44a2d0ad$var$updateMainProcessVersion(this);
        try {
            this._updateTheme(theme);
            ecModel.setTheme(this._theme);
            $4d59907f44a2d0ad$var$prepare(this);
            $4d59907f44a2d0ad$var$updateMethods.update.call(this, {
                type: "setTheme"
            }, updateParams);
        } catch (e) {
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
            throw e;
        }
        this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
        $4d59907f44a2d0ad$var$flushPendingActions.call(this, silent);
        $4d59907f44a2d0ad$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype._updateTheme = function(theme) {
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(theme)) theme = $4d59907f44a2d0ad$var$themeStorage[theme];
        if (theme) {
            theme = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(theme);
            theme && (0, $c4489ebdf95633b6$export$2e2bcd8739ae039)(theme, true);
            this._theme = theme;
        }
    };
    // We don't want developers to use getModel directly.
    ECharts.prototype.getModel = function() {
        return this._model;
    };
    ECharts.prototype.getOption = function() {
        return this._model && this._model.getOption();
    };
    ECharts.prototype.getWidth = function() {
        return this._zr.getWidth();
    };
    ECharts.prototype.getHeight = function() {
        return this._zr.getHeight();
    };
    ECharts.prototype.getDevicePixelRatio = function() {
        return this._zr.painter.dpr || (0, $ce6dd58693a21851$export$2e2bcd8739ae039).hasGlobalWindow && window.devicePixelRatio || 1;
    };
    /**
   * Get canvas which has all thing rendered
   * @deprecated Use renderToCanvas instead.
   */ ECharts.prototype.getRenderedCanvas = function(opts) {
        return this.renderToCanvas(opts);
    };
    ECharts.prototype.renderToCanvas = function(opts) {
        opts = opts || {};
        var painter = this._zr.painter;
        return painter.getRenderedCanvas({
            backgroundColor: opts.backgroundColor || this._model.get("backgroundColor"),
            pixelRatio: opts.pixelRatio || this.getDevicePixelRatio()
        });
    };
    ECharts.prototype.renderToSVGString = function(opts) {
        opts = opts || {};
        var painter = this._zr.painter;
        return painter.renderToString({
            useViewBox: opts.useViewBox
        });
    };
    /**
   * Get svg data url
   */ ECharts.prototype.getSvgDataURL = function() {
        var zr = this._zr;
        var list = zr.storage.getDisplayList();
        // Stop animations
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(list, function(el) {
            el.stopAnimation(null, true);
        });
        return zr.painter.toDataURL();
    };
    ECharts.prototype.getDataURL = function(opts) {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        opts = opts || {};
        var excludeComponents = opts.excludeComponents;
        var ecModel = this._model;
        var excludesComponentViews = [];
        var self = this;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(excludeComponents, function(componentType) {
            ecModel.eachComponent({
                mainType: componentType
            }, function(component) {
                var view = self._componentsMap[component.__viewId];
                if (!view.group.ignore) {
                    excludesComponentViews.push(view);
                    view.group.ignore = true;
                }
            });
        });
        var url = this._zr.painter.getType() === "svg" ? this.getSvgDataURL() : this.renderToCanvas(opts).toDataURL("image/" + (opts && opts.type || "png"));
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(excludesComponentViews, function(view) {
            view.group.ignore = false;
        });
        return url;
    };
    ECharts.prototype.getConnectedDataURL = function(opts) {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        var isSvg = opts.type === "svg";
        var groupId = this.group;
        var mathMin = Math.min;
        var mathMax = Math.max;
        var MAX_NUMBER = Infinity;
        if ($4d59907f44a2d0ad$var$connectedGroups[groupId]) {
            var left_1 = MAX_NUMBER;
            var top_1 = MAX_NUMBER;
            var right_1 = -MAX_NUMBER;
            var bottom_1 = -MAX_NUMBER;
            var canvasList_1 = [];
            var dpr_1 = opts && opts.pixelRatio || this.getDevicePixelRatio();
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($4d59907f44a2d0ad$var$instances, function(chart, id) {
                if (chart.group === groupId) {
                    var canvas = isSvg ? chart.getZr().painter.getSvgDom().innerHTML : chart.renderToCanvas((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(opts));
                    var boundingRect = chart.getDom().getBoundingClientRect();
                    left_1 = mathMin(boundingRect.left, left_1);
                    top_1 = mathMin(boundingRect.top, top_1);
                    right_1 = mathMax(boundingRect.right, right_1);
                    bottom_1 = mathMax(boundingRect.bottom, bottom_1);
                    canvasList_1.push({
                        dom: canvas,
                        left: boundingRect.left,
                        top: boundingRect.top
                    });
                }
            });
            left_1 *= dpr_1;
            top_1 *= dpr_1;
            right_1 *= dpr_1;
            bottom_1 *= dpr_1;
            var width = right_1 - left_1;
            var height = bottom_1 - top_1;
            var targetCanvas = (0, $c6341dcc9d86826e$export$ef5e599365494451).createCanvas();
            var zr_1 = $6eba88f9eebe6af9$export$2cd8252107eb640b(targetCanvas, {
                renderer: isSvg ? "svg" : "canvas"
            });
            zr_1.resize({
                width: width,
                height: height
            });
            if (isSvg) {
                var content_1 = "";
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(canvasList_1, function(item) {
                    var x = item.left - left_1;
                    var y = item.top - top_1;
                    content_1 += '<g transform="translate(' + x + "," + y + ')">' + item.dom + "</g>";
                });
                zr_1.painter.getSvgRoot().innerHTML = content_1;
                if (opts.connectedBackgroundColor) zr_1.painter.setBackgroundColor(opts.connectedBackgroundColor);
                zr_1.refreshImmediately();
                return zr_1.painter.toDataURL();
            } else {
                // Background between the charts
                if (opts.connectedBackgroundColor) zr_1.add(new $419e5ff2f303755e$export$2e2bcd8739ae039({
                    shape: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    },
                    style: {
                        fill: opts.connectedBackgroundColor
                    }
                }));
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(canvasList_1, function(item) {
                    var img = new $86adec94217b86c6$export$2e2bcd8739ae039({
                        style: {
                            x: item.left * dpr_1 - left_1,
                            y: item.top * dpr_1 - top_1,
                            image: item.dom
                        }
                    });
                    zr_1.add(img);
                });
                zr_1.refreshImmediately();
                return targetCanvas.toDataURL("image/" + (opts && opts.type || "png"));
            }
        } else return this.getDataURL(opts);
    };
    ECharts.prototype.convertToPixel = function(finder, value, opt) {
        return $4d59907f44a2d0ad$var$doConvertPixel(this, "convertToPixel", finder, value, opt);
    };
    /**
   * Convert from logical coordinate system to pixel coordinate system.
   * See CoordinateSystem#convertToPixel.
   *
   * @see CoordinateSystem['dataToLayout'] for parameters and return.
   * @see CoordinateSystemDataCoord
   */ ECharts.prototype.convertToLayout = function(finder, value, opt) {
        return $4d59907f44a2d0ad$var$doConvertPixel(this, "convertToLayout", finder, value, opt);
    };
    // The above are signatures from before v6, thus they should be preserved for backward compat.
    ECharts.prototype.convertFromPixel = function(finder, value, opt) {
        return $4d59907f44a2d0ad$var$doConvertPixel(this, "convertFromPixel", finder, value, opt);
    };
    /**
   * Is the specified coordinate systems or components contain the given pixel point.
   * @param {Array|number} value
   * @return {boolean} result
   */ ECharts.prototype.containPixel = function(finder, value) {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        var ecModel = this._model;
        var result;
        var findResult = $76d619f648247e6d$export$95de80076abac814(ecModel, finder);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(findResult, function(models, key) {
            key.indexOf("Models") >= 0 && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(models, function(model) {
                var coordSys = model.coordinateSystem;
                if (coordSys && coordSys.containPoint) result = result || !!coordSys.containPoint(value);
                else if (key === "seriesModels") {
                    var view = this._chartsMap[model.__viewId];
                    if (view && view.containPoint) result = result || view.containPoint(value, model);
                }
            }, this);
        }, this);
        return !!result;
    };
    /**
   * Get visual from series or data.
   * @param finder
   *        If string, e.g., 'series', means {seriesIndex: 0}.
   *        If Object, could contain some of these properties below:
   *        {
   *            seriesIndex / seriesId / seriesName,
   *            dataIndex / dataIndexInside
   *        }
   *        If dataIndex is not specified, series visual will be fetched,
   *        but not data item visual.
   *        If all of seriesIndex, seriesId, seriesName are not specified,
   *        visual will be fetched from first series.
   * @param visualType 'color', 'symbol', 'symbolSize'
   */ ECharts.prototype.getVisual = function(finder, visualType) {
        var ecModel = this._model;
        var parsedFinder = $76d619f648247e6d$export$95de80076abac814(ecModel, finder, {
            defaultMainType: "series"
        });
        var seriesModel = parsedFinder.seriesModel;
        var data = seriesModel.getData();
        var dataIndexInside = parsedFinder.hasOwnProperty("dataIndexInside") ? parsedFinder.dataIndexInside : parsedFinder.hasOwnProperty("dataIndex") ? data.indexOfRawIndex(parsedFinder.dataIndex) : null;
        return dataIndexInside != null ? (0, $ea13f1ab2169d82d$export$91d919a86b2df624)(data, dataIndexInside, visualType) : (0, $ea13f1ab2169d82d$export$d76e333a86ea1a2)(data, visualType);
    };
    /**
   * Get view of corresponding component model
   */ ECharts.prototype.getViewOfComponentModel = function(componentModel) {
        return this._componentsMap[componentModel.__viewId];
    };
    /**
   * Get view of corresponding series model
   */ ECharts.prototype.getViewOfSeriesModel = function(seriesModel) {
        return this._chartsMap[seriesModel.__viewId];
    };
    ECharts.prototype._initEvents = function() {
        var _this = this;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($4d59907f44a2d0ad$var$MOUSE_EVENT_NAMES, function(eveName) {
            var handler = function(e) {
                var ecModel = _this.getModel();
                var el = e.target;
                var params;
                var isGlobalOut = eveName === "globalout";
                // no e.target when 'globalout'.
                if (isGlobalOut) params = {};
                else el && (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(el, function(parent) {
                    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(parent);
                    if (ecData && ecData.dataIndex != null) {
                        var dataModel = ecData.dataModel || ecModel.getSeriesByIndex(ecData.seriesIndex);
                        params = dataModel && dataModel.getDataParams(ecData.dataIndex, ecData.dataType, el) || {};
                        return true;
                    } else if (ecData.eventData) {
                        params = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, ecData.eventData);
                        return true;
                    }
                }, true);
                // Contract: if params prepared in mouse event,
                // these properties must be specified:
                // {
                //    componentType: string (component main type)
                //    componentIndex: number
                // }
                // Otherwise event query can not work.
                if (params) {
                    var componentType = params.componentType;
                    var componentIndex = params.componentIndex;
                    // Special handling for historic reason: when trigger by
                    // markLine/markPoint/markArea, the componentType is
                    // 'markLine'/'markPoint'/'markArea', but we should better
                    // enable them to be queried by seriesIndex, since their
                    // option is set in each series.
                    if (componentType === "markLine" || componentType === "markPoint" || componentType === "markArea") {
                        componentType = "series";
                        componentIndex = params.seriesIndex;
                    }
                    var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
                    var view = model && _this[model.mainType === "series" ? "_chartsMap" : "_componentsMap"][model.__viewId];
                    params.event = e;
                    params.type = eveName;
                    _this._$eventProcessor.eventInfo = {
                        targetEl: el,
                        packedEvent: params,
                        model: model,
                        view: view
                    };
                    _this.trigger(eveName, params);
                }
            };
            // Consider that some component (like tooltip, brush, ...)
            // register zr event handler, but user event handler might
            // do anything, such as call `setOption` or `dispatchAction`,
            // which probably update any of the content and probably
            // cause problem if it is called previous other inner handlers.
            handler.zrEventfulCallAtLast = true;
            _this._zr.on(eveName, handler, _this);
        });
        var messageCenter = this._messageCenter;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($4d59907f44a2d0ad$var$publicEventTypeMap, function(_, eventType) {
            messageCenter.on(eventType, function(event) {
                _this.trigger(eventType, event);
            });
        });
        (0, $e855ccf7eff48bce$export$2575c83262e49d0c)(messageCenter, this, this._api);
    };
    ECharts.prototype.isDisposed = function() {
        return this._disposed;
    };
    ECharts.prototype.clear = function() {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        this.setOption({
            series: []
        }, true);
    };
    ECharts.prototype.dispose = function() {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        this._disposed = true;
        var dom = this.getDom();
        if (dom) $76d619f648247e6d$export$9fec4d97f1922e0b(this.getDom(), $4d59907f44a2d0ad$var$DOM_ATTRIBUTE_KEY, "");
        var chart = this;
        var api = chart._api;
        var ecModel = chart._model;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(chart._componentsViews, function(component) {
            component.dispose(ecModel, api);
        });
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(chart._chartsViews, function(chart) {
            chart.dispose(ecModel, api);
        });
        // Dispose after all views disposed
        chart._zr.dispose();
        // Set properties to null.
        // To reduce the memory cost in case the top code still holds this instance unexpectedly.
        chart._dom = chart._model = chart._chartsMap = chart._componentsMap = chart._chartsViews = chart._componentsViews = chart._scheduler = chart._api = chart._zr = chart._throttledZrFlush = chart._theme = chart._coordSysMgr = chart._messageCenter = null;
        delete $4d59907f44a2d0ad$var$instances[chart.id];
    };
    /**
   * Resize the chart
   */ ECharts.prototype.resize = function(opts) {
        if (this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY]) return;
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        this._zr.resize(opts);
        var ecModel = this._model;
        // Resize loading effect
        this._loadingFX && this._loadingFX.resize();
        if (!ecModel) return;
        var needPrepare = ecModel.resetOption("media");
        var silent = opts && opts.silent;
        // There is some real cases that:
        // chart.setOption(option, { lazyUpdate: true });
        // chart.resize();
        if (this[$4d59907f44a2d0ad$var$PENDING_UPDATE]) {
            if (silent == null) silent = this[$4d59907f44a2d0ad$var$PENDING_UPDATE].silent;
            needPrepare = true;
            this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = null;
        }
        this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = true;
        $4d59907f44a2d0ad$var$updateMainProcessVersion(this);
        try {
            needPrepare && $4d59907f44a2d0ad$var$prepare(this);
            $4d59907f44a2d0ad$var$updateMethods.update.call(this, {
                type: "resize",
                animation: (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
                    // Disable animation
                    duration: 0
                }, opts && opts.animation)
            });
        } catch (e) {
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
            throw e;
        }
        this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
        $4d59907f44a2d0ad$var$flushPendingActions.call(this, silent);
        $4d59907f44a2d0ad$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.showLoading = function(name, cfg) {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(name)) {
            cfg = name;
            name = "";
        }
        name = name || "default";
        this.hideLoading();
        if (!$4d59907f44a2d0ad$var$loadingEffects[name]) return;
        var el = $4d59907f44a2d0ad$var$loadingEffects[name](this._api, cfg);
        var zr = this._zr;
        this._loadingFX = el;
        zr.add(el);
    };
    /**
   * Hide loading effect
   */ ECharts.prototype.hideLoading = function() {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        this._loadingFX && this._zr.remove(this._loadingFX);
        this._loadingFX = null;
    };
    ECharts.prototype.makeActionFromEvent = function(eventObj) {
        var payload = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, eventObj);
        payload.type = $4d59907f44a2d0ad$var$connectionEventRevertMap[eventObj.type];
        return payload;
    };
    /**
   * @param opt If pass boolean, means opt.silent
   * @param opt.silent Default `false`. Whether trigger events.
   * @param opt.flush Default `undefined`.
   *        true: Flush immediately, and then pixel in canvas can be fetched
   *            immediately. Caution: it might affect performance.
   *        false: Not flush.
   *        undefined: Auto decide whether perform flush.
   */ ECharts.prototype.dispatchAction = function(payload, opt) {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        if (!(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(opt)) opt = {
            silent: !!opt
        };
        if (!$4d59907f44a2d0ad$var$actions[payload.type]) return;
        // Avoid dispatch action before setOption. Especially in `connect`.
        if (!this._model) return;
        // May dispatchAction in rendering procedure
        if (this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY]) {
            this._pendingActions.push(payload);
            return;
        }
        var silent = opt.silent;
        $4d59907f44a2d0ad$var$doDispatchAction.call(this, payload, silent);
        var flush = opt.flush;
        if (flush) this._zr.flush();
        else if (flush !== false && (0, $ce6dd58693a21851$export$2e2bcd8739ae039).browser.weChat) // In WeChat embedded browser, `requestAnimationFrame` and `setInterval`
        // hang when sliding page (on touch event), which cause that zr does not
        // refresh until user interaction finished, which is not expected.
        // But `dispatchAction` may be called too frequently when pan on touch
        // screen, which impacts performance if do not throttle them.
        this._throttledZrFlush();
        $4d59907f44a2d0ad$var$flushPendingActions.call(this, silent);
        $4d59907f44a2d0ad$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.updateLabelLayout = function() {
        (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("series:layoutlabels", this._model, this._api, {
            // Not adding series labels.
            // TODO
            updatedSeries: []
        });
    };
    ECharts.prototype.appendData = function(params) {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        var seriesIndex = params.seriesIndex;
        var ecModel = this.getModel();
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        seriesModel.appendData(params);
        // Note: `appendData` does not support that update extent of coordinate
        // system, util some scenario require that. In the expected usage of
        // `appendData`, the initial extent of coordinate system should better
        // be fixed by axis `min`/`max` setting or initial data, otherwise if
        // the extent changed while `appendData`, the location of the painted
        // graphic elements have to be changed, which make the usage of
        // `appendData` meaningless.
        this._scheduler.unfinished = true;
        this.getZr().wakeUp();
    };
    // A work around for no `internal` modifier in ts yet but
    // need to strictly hide private methods to JS users.
    ECharts.internalField = function() {
        $4d59907f44a2d0ad$var$prepare = function(ecIns) {
            var scheduler = ecIns._scheduler;
            scheduler.restorePipelines(ecIns._model);
            scheduler.prepareStageTasks();
            $4d59907f44a2d0ad$var$prepareView(ecIns, true);
            $4d59907f44a2d0ad$var$prepareView(ecIns, false);
            scheduler.plan();
        };
        /**
     * Prepare view instances of charts and components
     */ $4d59907f44a2d0ad$var$prepareView = function(ecIns, isComponent) {
            var ecModel = ecIns._model;
            var scheduler = ecIns._scheduler;
            var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
            var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
            var zr = ecIns._zr;
            var api = ecIns._api;
            for(var i = 0; i < viewList.length; i++)viewList[i].__alive = false;
            isComponent ? ecModel.eachComponent(function(componentType, model) {
                componentType !== "series" && doPrepare(model);
            }) : ecModel.eachSeries(doPrepare);
            function doPrepare(model) {
                // By default view will be reused if possible for the case that `setOption` with "notMerge"
                // mode and need to enable transition animation. (Usually, when they have the same id, or
                // especially no id but have the same type & name & index. See the `model.id` generation
                // rule in `makeIdAndName` and `viewId` generation rule here).
                // But in `replaceMerge` mode, this feature should be able to disabled when it is clear that
                // the new model has nothing to do with the old model.
                var requireNewView = model.__requireNewView;
                // This command should not work twice.
                model.__requireNewView = false;
                // Consider: id same and type changed.
                var viewId = "_ec_" + model.id + "_" + model.type;
                var view = !requireNewView && viewMap[viewId];
                if (!view) {
                    var classType = (0, $cd5f95cf03b4e3e7$export$fbe18865d303bf01)(model.type);
                    var Clazz = isComponent ? (0, $737c88aa0711f65a$export$2e2bcd8739ae039).getClass(classType.main, classType.sub) : // FIXME:TS
                    // (ChartView as ChartViewConstructor).getClass('series', classType.sub)
                    // For backward compat, still support a chart type declared as only subType
                    // like "liquidfill", but recommend "series.liquidfill"
                    // But need a base class to make a type series.
                    (0, $0dc5061053e23cd3$export$2e2bcd8739ae039).getClass(classType.sub);
                    view = new Clazz();
                    view.init(ecModel, api);
                    viewMap[viewId] = view;
                    viewList.push(view);
                    zr.add(view.group);
                }
                model.__viewId = view.__id = viewId;
                view.__alive = true;
                view.__model = model;
                view.group.__ecComponentInfo = {
                    mainType: model.mainType,
                    index: model.componentIndex
                };
                !isComponent && scheduler.prepareView(view, model, ecModel, api);
            }
            for(var i = 0; i < viewList.length;){
                var view = viewList[i];
                if (!view.__alive) {
                    !isComponent && view.renderTask.dispose();
                    zr.remove(view.group);
                    view.dispose(ecModel, api);
                    viewList.splice(i, 1);
                    if (viewMap[view.__id] === view) delete viewMap[view.__id];
                    view.__id = view.group.__ecComponentInfo = null;
                } else i++;
            }
        };
        $4d59907f44a2d0ad$var$updateDirectly = function(ecIns, method, payload, mainType, subType) {
            var ecModel = ecIns._model;
            ecModel.setUpdatePayload(payload);
            // broadcast
            if (!mainType) {
                // FIXME
                // Chart will not be update directly here, except set dirty.
                // But there is no such scenario now.
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([].concat(ecIns._componentsViews).concat(ecIns._chartsViews), callView);
                return;
            }
            var query = {};
            query[mainType + "Id"] = payload[mainType + "Id"];
            query[mainType + "Index"] = payload[mainType + "Index"];
            query[mainType + "Name"] = payload[mainType + "Name"];
            var condition = {
                mainType: mainType,
                query: query
            };
            subType && (condition.subType = subType); // subType may be '' by parseClassType;
            var excludeSeriesId = payload.excludeSeriesId;
            var excludeSeriesIdMap;
            if (excludeSeriesId != null) {
                excludeSeriesIdMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($76d619f648247e6d$export$4f07b212a02c8051(excludeSeriesId), function(id) {
                    var modelId = $76d619f648247e6d$export$fb1a222ba5dd6e51(id, null);
                    if (modelId != null) excludeSeriesIdMap.set(modelId, true);
                });
            }
            // If dispatchAction before setOption, do nothing.
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) != null;
                if (isExcluded) return;
                if ((0, $2bf82c0980125b62$export$aebe71265c1b77bf)(payload)) {
                    if (model instanceof (0, $7c10febb2cdef0d8$export$2e2bcd8739ae039)) {
                        if (payload.type === (0, $2bf82c0980125b62$export$df035d873a9de64f) && !payload.notBlur && !model.get([
                            "emphasis",
                            "disabled"
                        ])) (0, $2bf82c0980125b62$export$64f1fd4daefef21b)(model, payload, ecIns._api);
                    } else {
                        var _a = (0, $2bf82c0980125b62$export$f31a644ccca0ef23)(model.mainType, model.componentIndex, payload.name, ecIns._api), focusSelf = _a.focusSelf, dispatchers = _a.dispatchers;
                        if (payload.type === (0, $2bf82c0980125b62$export$df035d873a9de64f) && focusSelf && !payload.notBlur) (0, $2bf82c0980125b62$export$569da03256c8a55f)(model.mainType, model.componentIndex, ecIns._api);
                        // PENDING:
                        // Whether to put this "enter emphasis" code in `ComponentView`,
                        // which will be the same as `ChartView` but might be not necessary
                        // and will be far from this logic.
                        if (dispatchers) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
                            payload.type === (0, $2bf82c0980125b62$export$df035d873a9de64f) ? (0, $2bf82c0980125b62$export$b2d02638cc34c042)(dispatcher) : (0, $2bf82c0980125b62$export$11be6f716239ac55)(dispatcher);
                        });
                    }
                } else if ((0, $2bf82c0980125b62$export$72aea10e60e45351)(payload)) // TODO geo
                {
                    if (model instanceof (0, $7c10febb2cdef0d8$export$2e2bcd8739ae039)) {
                        (0, $2bf82c0980125b62$export$1c7d489f62372d73)(model, payload, ecIns._api);
                        (0, $2bf82c0980125b62$export$e4ea08ef52e0a73)(model);
                        $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                    }
                }
            }, ecIns);
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) != null;
                if (isExcluded) return;
                callView(ecIns[mainType === "series" ? "_chartsMap" : "_componentsMap"][model.__viewId]);
            }, ecIns);
            function callView(view) {
                view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
            }
        };
        $4d59907f44a2d0ad$var$updateMethods = {
            prepareAndUpdate: function(payload) {
                $4d59907f44a2d0ad$var$prepare(this);
                $4d59907f44a2d0ad$var$updateMethods.update.call(this, payload, payload && {
                    // Needs to mark option changed if newOption is given.
                    // It's from MagicType.
                    // TODO If use a separate flag optionChanged in payload?
                    optionChanged: payload.newOption != null
                });
            },
            update: function(payload, updateParams) {
                var ecModel = this._model;
                var api = this._api;
                var zr = this._zr;
                var coordSysMgr = this._coordSysMgr;
                var scheduler = this._scheduler;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                scheduler.restoreData(ecModel, payload);
                scheduler.performSeriesTasks(ecModel);
                // TODO
                // Save total ecModel here for undo/redo (after restoring data and before processing data).
                // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
                // Create new coordinate system each update
                // In LineView may save the old coordinate system and use it to get the original point.
                coordSysMgr.create(ecModel, api);
                scheduler.performDataProcessorTasks(ecModel, payload);
                // Current stream render is not supported in data process. So we can update
                // stream modes after data processing, where the filtered data is used to
                // determine whether to use progressive rendering.
                $4d59907f44a2d0ad$var$updateStreamModes(this, ecModel);
                // We update stream modes before coordinate system updated, then the modes info
                // can be fetched when coord sys updating (consider the barGrid extent fix). But
                // the drawback is the full coord info can not be fetched. Fortunately this full
                // coord is not required in stream mode updater currently.
                coordSysMgr.update(ecModel, api);
                clearColorPalette(ecModel);
                scheduler.performVisualTasks(ecModel, payload);
                // Set background and dark mode before rendering, because they affect auto-color-determination
                // in zrender Text, and consequently affect the bounding rect if stroke is added.
                var backgroundColor = ecModel.get("backgroundColor") || "transparent";
                zr.setBackgroundColor(backgroundColor);
                // Force set dark mode.
                var darkMode = ecModel.get("darkMode");
                if (darkMode != null && darkMode !== "auto") zr.setDarkMode(darkMode);
                $4d59907f44a2d0ad$var$render(this, ecModel, api, payload, updateParams);
                (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("afterupdate", ecModel, api);
            },
            updateTransform: function(payload) {
                var _this = this;
                var ecModel = this._model;
                var api = this._api;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                // ChartView.markUpdateMethod(payload, 'updateTransform');
                var componentDirtyList = [];
                ecModel.eachComponent(function(componentType, componentModel) {
                    if (componentType === "series") return;
                    var componentView = _this.getViewOfComponentModel(componentModel);
                    if (componentView && componentView.__alive) {
                        if (componentView.updateTransform) {
                            var result = componentView.updateTransform(componentModel, ecModel, api, payload);
                            result && result.update && componentDirtyList.push(componentView);
                        } else componentDirtyList.push(componentView);
                    }
                });
                var seriesDirtyMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = _this._chartsMap[seriesModel.__viewId];
                    if (chartView.updateTransform) {
                        var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
                        result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
                    } else seriesDirtyMap.set(seriesModel.uid, 1);
                });
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
                this._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true,
                    dirtyMap: seriesDirtyMap
                });
                // Currently, not call render of components. Geo render cost a lot.
                // renderComponents(ecIns, ecModel, api, payload, componentDirtyList);
                $4d59907f44a2d0ad$var$renderSeries(this, ecModel, api, payload, {}, seriesDirtyMap);
                (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("afterupdate", ecModel, api);
            },
            updateView: function(payload) {
                var ecModel = this._model;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                (0, $0dc5061053e23cd3$export$2e2bcd8739ae039).markUpdateMethod(payload, "updateView");
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true
                });
                $4d59907f44a2d0ad$var$render(this, ecModel, this._api, payload, {});
                (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("afterupdate", ecModel, this._api);
            },
            updateVisual: function(payload) {
                // updateMethods.update.call(this, payload);
                var _this = this;
                var ecModel = this._model;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                // clear all visual
                ecModel.eachSeries(function(seriesModel) {
                    seriesModel.getData().clearAllVisual();
                });
                // Perform visual
                (0, $0dc5061053e23cd3$export$2e2bcd8739ae039).markUpdateMethod(payload, "updateVisual");
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    visualType: "visual",
                    setDirty: true
                });
                ecModel.eachComponent(function(componentType, componentModel) {
                    if (componentType !== "series") {
                        var componentView = _this.getViewOfComponentModel(componentModel);
                        componentView && componentView.__alive && componentView.updateVisual(componentModel, ecModel, _this._api, payload);
                    }
                });
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = _this._chartsMap[seriesModel.__viewId];
                    chartView.updateVisual(seriesModel, ecModel, _this._api, payload);
                });
                (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("afterupdate", ecModel, this._api);
            },
            updateLayout: function(payload) {
                $4d59907f44a2d0ad$var$updateMethods.update.call(this, payload);
            }
        };
        function doConvertPixelImpl(ecIns, methodName, finder, value, opt) {
            if (ecIns._disposed) {
                $4d59907f44a2d0ad$var$disposedWarning(ecIns.id);
                return;
            }
            var ecModel = ecIns._model;
            var coordSysList = ecIns._coordSysMgr.getCoordinateSystems();
            var result;
            var parsedFinder = $76d619f648247e6d$export$95de80076abac814(ecModel, finder);
            for(var i = 0; i < coordSysList.length; i++){
                var coordSys = coordSysList[i];
                if (coordSys[methodName] && (result = coordSys[methodName](ecModel, parsedFinder, value, opt)) != null) return result;
            }
        }
        $4d59907f44a2d0ad$var$doConvertPixel = doConvertPixelImpl;
        $4d59907f44a2d0ad$var$updateStreamModes = function(ecIns, ecModel) {
            var chartsMap = ecIns._chartsMap;
            var scheduler = ecIns._scheduler;
            ecModel.eachSeries(function(seriesModel) {
                scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
            });
        };
        $4d59907f44a2d0ad$var$doDispatchAction = function(payload, silent) {
            var _this = this;
            var ecModel = this.getModel();
            var payloadType = payload.type;
            var escapeConnect = payload.escapeConnect;
            var actionInfo = $4d59907f44a2d0ad$var$actions[payloadType];
            var cptTypeTmp = (actionInfo.update || "update").split(":");
            var updateMethod = cptTypeTmp.pop();
            var cptType = cptTypeTmp[0] != null && (0, $cd5f95cf03b4e3e7$export$fbe18865d303bf01)(cptTypeTmp[0]);
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = true;
            $4d59907f44a2d0ad$var$updateMainProcessVersion(this);
            var payloads = [
                payload
            ];
            var batched = false;
            // Batch action
            if (payload.batch) {
                batched = true;
                payloads = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(payload.batch, function(item) {
                    item = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, item), payload);
                    item.batch = null;
                    return item;
                });
            }
            var eventObjBatch = [];
            var eventObj;
            var actionResultBatch = [];
            var nonRefinedEventType = actionInfo.nonRefinedEventType;
            var isSelectChange = (0, $2bf82c0980125b62$export$72aea10e60e45351)(payload);
            var isHighDown = (0, $2bf82c0980125b62$export$aebe71265c1b77bf)(payload);
            // Only leave blur once if there are multiple batches.
            if (isHighDown) (0, $2bf82c0980125b62$export$b2a593c7b5243584)(this._api);
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(payloads, function(batchItem) {
                // Action can specify the event by return it.
                var actionResult = actionInfo.action(batchItem, ecModel, _this._api);
                if (actionInfo.refineEvent) actionResultBatch.push(actionResult);
                else eventObj = actionResult;
                eventObj = eventObj || (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, batchItem);
                eventObj.type = nonRefinedEventType;
                eventObjBatch.push(eventObj);
                // light update does not perform data process, layout and visual.
                if (isHighDown) {
                    var _a = $76d619f648247e6d$export$fe600815775d9400(payload), queryOptionMap = _a.queryOptionMap, mainTypeSpecified = _a.mainTypeSpecified;
                    var componentMainType = mainTypeSpecified ? queryOptionMap.keys()[0] : "series";
                    $4d59907f44a2d0ad$var$updateDirectly(_this, updateMethod, batchItem, componentMainType);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(_this);
                } else if (isSelectChange) {
                    // At present `dispatchAction({ type: 'select', ... })` is not supported on components.
                    // geo still use 'geoselect'.
                    $4d59907f44a2d0ad$var$updateDirectly(_this, updateMethod, batchItem, "series");
                    $4d59907f44a2d0ad$var$markStatusToUpdate(_this);
                } else if (cptType) $4d59907f44a2d0ad$var$updateDirectly(_this, updateMethod, batchItem, cptType.main, cptType.sub);
            });
            if (updateMethod !== "none" && !isHighDown && !isSelectChange && !cptType) try {
                // Still dirty
                if (this[$4d59907f44a2d0ad$var$PENDING_UPDATE]) {
                    $4d59907f44a2d0ad$var$prepare(this);
                    $4d59907f44a2d0ad$var$updateMethods.update.call(this, payload);
                    this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = null;
                } else $4d59907f44a2d0ad$var$updateMethods[updateMethod].call(this, payload);
            } catch (e) {
                this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
                throw e;
            }
            // Follow the rule of action batch
            if (batched) eventObj = {
                type: nonRefinedEventType,
                escapeConnect: escapeConnect,
                batch: eventObjBatch
            };
            else eventObj = eventObjBatch[0];
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
            if (!silent) {
                var refinedEvent = void 0;
                if (actionInfo.refineEvent) {
                    var eventContent = actionInfo.refineEvent(actionResultBatch, payload, ecModel, this._api).eventContent;
                    (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(eventContent));
                    refinedEvent = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                        type: actionInfo.refinedEventType
                    }, eventContent);
                    refinedEvent.fromAction = payload.type;
                    refinedEvent.fromActionPayload = payload;
                    refinedEvent.escapeConnect = true;
                }
                var messageCenter = this._messageCenter;
                // - If `refineEvent` created a `refinedEvent`, `eventObj` (replicated from the original payload)
                //  is still needed to be triggered for the feature `connect`. But it will not be triggered to
                //  users in this case.
                // - If no `refineEvent` used, `eventObj` will be triggered for both `connect` and users.
                messageCenter.trigger(eventObj.type, eventObj);
                if (refinedEvent) messageCenter.trigger(refinedEvent.type, refinedEvent);
            }
        };
        $4d59907f44a2d0ad$var$flushPendingActions = function(silent) {
            var pendingActions = this._pendingActions;
            while(pendingActions.length){
                var payload = pendingActions.shift();
                $4d59907f44a2d0ad$var$doDispatchAction.call(this, payload, silent);
            }
        };
        $4d59907f44a2d0ad$var$triggerUpdatedEvent = function(silent) {
            !silent && this.trigger("updated");
        };
        /**
     * Event `rendered` is triggered when zr
     * rendered. It is useful for realtime
     * snapshot (reflect animation).
     *
     * Event `finished` is triggered when:
     * (1) zrender rendering finished.
     * (2) initial animation finished.
     * (3) progressive rendering finished.
     * (4) no pending action.
     * (5) no delayed setOption needs to be processed.
     */ $4d59907f44a2d0ad$var$bindRenderedEvent = function(zr, ecIns) {
            zr.on("rendered", function(params) {
                ecIns.trigger("rendered", params);
                // The `finished` event should not be triggered repeatedly,
                // so it should only be triggered when rendering indeed happens
                // in zrender. (Consider the case that dipatchAction is keep
                // triggering when mouse move).
                if (// Although zr is dirty if initial animation is not finished
                // and this checking is called on frame, we also check
                // animation finished for robustness.
                zr.animation.isFinished() && !ecIns[$4d59907f44a2d0ad$var$PENDING_UPDATE] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) ecIns.trigger("finished");
            });
        };
        $4d59907f44a2d0ad$var$bindMouseEvent = function(zr, ecIns) {
            zr.on("mouseover", function(e) {
                var el = e.target;
                var dispatcher = (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(el, (0, $2bf82c0980125b62$export$77d1445f699c58b5));
                if (dispatcher) {
                    (0, $2bf82c0980125b62$export$416765b6198234ff)(dispatcher, e, ecIns._api);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                }
            }).on("mouseout", function(e) {
                var el = e.target;
                var dispatcher = (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(el, (0, $2bf82c0980125b62$export$77d1445f699c58b5));
                if (dispatcher) {
                    (0, $2bf82c0980125b62$export$bb1c7b62436282a)(dispatcher, e, ecIns._api);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                }
            }).on("click", function(e) {
                var el = e.target;
                var dispatcher = (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(el, function(target) {
                    return (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(target).dataIndex != null;
                }, true);
                if (dispatcher) {
                    var actionType = dispatcher.selected ? "unselect" : "select";
                    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(dispatcher);
                    ecIns._api.dispatchAction({
                        type: actionType,
                        dataType: ecData.dataType,
                        dataIndexInside: ecData.dataIndex,
                        seriesIndex: ecData.seriesIndex,
                        isFromClick: true
                    });
                }
            });
        };
        function clearColorPalette(ecModel) {
            ecModel.clearColorPalette();
            ecModel.eachSeries(function(seriesModel) {
                seriesModel.clearColorPalette();
            });
        }
        // Allocate zlevels for series and components
        function allocateZlevels(ecModel) {
            var componentZLevels = [];
            var seriesZLevels = [];
            var hasSeparateZLevel = false;
            ecModel.eachComponent(function(componentType, componentModel) {
                var zlevel = componentModel.get("zlevel") || 0;
                var z = componentModel.get("z") || 0;
                var zlevelKey = componentModel.getZLevelKey();
                hasSeparateZLevel = hasSeparateZLevel || !!zlevelKey;
                (componentType === "series" ? seriesZLevels : componentZLevels).push({
                    zlevel: zlevel,
                    z: z,
                    idx: componentModel.componentIndex,
                    type: componentType,
                    key: zlevelKey
                });
            });
            if (hasSeparateZLevel) {
                // Series after component
                var zLevels = componentZLevels.concat(seriesZLevels);
                var lastSeriesZLevel_1;
                var lastSeriesKey_1;
                (0, $97579a54749e4b24$export$2e2bcd8739ae039)(zLevels, function(a, b) {
                    if (a.zlevel === b.zlevel) return a.z - b.z;
                    return a.zlevel - b.zlevel;
                });
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(zLevels, function(item) {
                    var componentModel = ecModel.getComponent(item.type, item.idx);
                    var zlevel = item.zlevel;
                    var key = item.key;
                    if (lastSeriesZLevel_1 != null) zlevel = Math.max(lastSeriesZLevel_1, zlevel);
                    if (key) {
                        if (zlevel === lastSeriesZLevel_1 && key !== lastSeriesKey_1) zlevel++;
                        lastSeriesKey_1 = key;
                    } else if (lastSeriesKey_1) {
                        if (zlevel === lastSeriesZLevel_1) zlevel++;
                        lastSeriesKey_1 = "";
                    }
                    lastSeriesZLevel_1 = zlevel;
                    componentModel.setZLevel(zlevel);
                });
            }
        }
        $4d59907f44a2d0ad$var$render = function(ecIns, ecModel, api, payload, updateParams) {
            allocateZlevels(ecModel);
            $4d59907f44a2d0ad$var$renderComponents(ecIns, ecModel, api, payload, updateParams);
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ecIns._chartsViews, function(chart) {
                chart.__alive = false;
            });
            $4d59907f44a2d0ad$var$renderSeries(ecIns, ecModel, api, payload, updateParams);
            // Remove groups of unrendered charts
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ecIns._chartsViews, function(chart) {
                if (!chart.__alive) chart.remove(ecModel, api);
            });
        };
        $4d59907f44a2d0ad$var$renderComponents = function(ecIns, ecModel, api, payload, updateParams, dirtyList) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dirtyList || ecIns._componentsViews, function(componentView) {
                var componentModel = componentView.__model;
                clearStates(componentModel, componentView);
                componentView.render(componentModel, ecModel, api, payload);
                updateZ(componentModel, componentView);
                updateStates(componentModel, componentView);
            });
        };
        /**
     * Render each chart and component
     */ $4d59907f44a2d0ad$var$renderSeries = function(ecIns, ecModel, api, payload, updateParams, dirtyMap) {
            // Render all charts
            var scheduler = ecIns._scheduler;
            updateParams = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(updateParams || {}, {
                updatedSeries: ecModel.getSeries()
            });
            // TODO progressive?
            (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("series:beforeupdate", ecModel, api, updateParams);
            var unfinished = false;
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                chartView.__alive = true;
                var renderTask = chartView.renderTask;
                scheduler.updatePayload(renderTask, payload);
                // TODO states on marker.
                clearStates(seriesModel, chartView);
                if (dirtyMap && dirtyMap.get(seriesModel.uid)) renderTask.dirty();
                if (renderTask.perform(scheduler.getPerformArgs(renderTask))) unfinished = true;
                chartView.group.silent = !!seriesModel.get("silent");
                // Should not call markRedraw on group, because it will disable zrender
                // incremental render (always render from the __startIndex each frame)
                // chartView.group.markRedraw();
                updateBlend(seriesModel, chartView);
                (0, $2bf82c0980125b62$export$e4ea08ef52e0a73)(seriesModel);
            });
            scheduler.unfinished = unfinished || scheduler.unfinished;
            (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("series:layoutlabels", ecModel, api, updateParams);
            // transition after label is layouted.
            (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("series:transition", ecModel, api, updateParams);
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                // Update Z after labels updated. Before applying states.
                updateZ(seriesModel, chartView);
                // NOTE: Update states after label is updated.
                // label should be in normal status when layouting.
                updateStates(seriesModel, chartView);
            });
            // If use hover layer
            updateHoverLayerStatus(ecIns, ecModel);
            (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("series:afterupdate", ecModel, api, updateParams);
        };
        $4d59907f44a2d0ad$var$markStatusToUpdate = function(ecIns) {
            ecIns[$4d59907f44a2d0ad$var$STATUS_NEEDS_UPDATE_KEY] = true;
            // Wake up zrender if it's sleep. Let it update states in the next frame.
            ecIns.getZr().wakeUp();
        };
        $4d59907f44a2d0ad$var$updateMainProcessVersion = function(ecIns) {
            ecIns[$4d59907f44a2d0ad$var$MAIN_PROCESS_VERSION_KEY] = (ecIns[$4d59907f44a2d0ad$var$MAIN_PROCESS_VERSION_KEY] + 1) % 1000;
        };
        $4d59907f44a2d0ad$var$applyChangedStates = function(ecIns) {
            if (!ecIns[$4d59907f44a2d0ad$var$STATUS_NEEDS_UPDATE_KEY]) return;
            ecIns.getZr().storage.traverse(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($8b353638fbedfefa$export$5b89d4b643713034(el)) return;
                applyElementStates(el);
            });
            ecIns[$4d59907f44a2d0ad$var$STATUS_NEEDS_UPDATE_KEY] = false;
        };
        function applyElementStates(el) {
            var newStates = [];
            var oldStates = el.currentStates;
            // Keep other states.
            for(var i = 0; i < oldStates.length; i++){
                var stateName = oldStates[i];
                if (!(stateName === "emphasis" || stateName === "blur" || stateName === "select")) newStates.push(stateName);
            }
            // Only use states when it's exists.
            if (el.selected && el.states.select) newStates.push("select");
            if (el.hoverState === (0, $2bf82c0980125b62$export$f0f2bee145debb31) && el.states.emphasis) newStates.push("emphasis");
            else if (el.hoverState === (0, $2bf82c0980125b62$export$1307d6a87d56baa) && el.states.blur) newStates.push("blur");
            el.useStates(newStates);
        }
        function updateHoverLayerStatus(ecIns, ecModel) {
            var zr = ecIns._zr;
            var storage = zr.storage;
            var elCount = 0;
            storage.traverse(function(el) {
                if (!el.isGroup) elCount++;
            });
            if (elCount > ecModel.get("hoverLayerThreshold") && !(0, $ce6dd58693a21851$export$2e2bcd8739ae039).node && !(0, $ce6dd58693a21851$export$2e2bcd8739ae039).worker) ecModel.eachSeries(function(seriesModel) {
                if (seriesModel.preventUsingHoverLayer) return;
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                if (chartView.__alive) chartView.eachRendered(function(el) {
                    if (el.states.emphasis) el.states.emphasis.hoverLayer = true;
                });
            });
        }
        /**
     * Update chart and blend.
     */ function updateBlend(seriesModel, chartView) {
            var blendMode = seriesModel.get("blendMode") || null;
            chartView.eachRendered(function(el) {
                // FIXME marker and other components
                if (!el.isGroup) // DON'T mark the element dirty. In case element is incremental and don't want to rerender.
                el.style.blend = blendMode;
            });
        }
        function updateZ(model, view) {
            if (model.preventAutoZ) return;
            var zInfo = $5b455ae6f843ac47$export$1500a631bea5adda(model);
            // Set z and zlevel
            view.eachRendered(function(el) {
                $5b455ae6f843ac47$export$d31cf465bf5e8879(el, zInfo.z, zInfo.zlevel);
                // Don't traverse the children because it has been traversed in _updateZ.
                return true;
            });
        }
        // Clear states without animation.
        // TODO States on component.
        function clearStates(model, view) {
            view.eachRendered(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($8b353638fbedfefa$export$5b89d4b643713034(el)) return;
                var textContent = el.getTextContent();
                var textGuide = el.getTextGuideLine();
                if (el.stateTransition) el.stateTransition = null;
                if (textContent && textContent.stateTransition) textContent.stateTransition = null;
                if (textGuide && textGuide.stateTransition) textGuide.stateTransition = null;
                // TODO If el is incremental.
                if (el.hasState()) {
                    el.prevStates = el.currentStates;
                    el.clearStates();
                } else if (el.prevStates) el.prevStates = null;
            });
        }
        function updateStates(model, view) {
            var stateAnimationModel = model.getModel("stateAnimation");
            var enableAnimation = model.isAnimationEnabled();
            var duration = stateAnimationModel.get("duration");
            var stateTransition = duration > 0 ? {
                duration: duration,
                delay: stateAnimationModel.get("delay"),
                easing: stateAnimationModel.get("easing")
            } : null;
            view.eachRendered(function(el) {
                if (el.states && el.states.emphasis) {
                    // Not applied on removed elements, it may still in fading.
                    if ($8b353638fbedfefa$export$5b89d4b643713034(el)) return;
                    if (el instanceof $b02ffe7acd508c08$export$2e2bcd8739ae039) (0, $2bf82c0980125b62$export$9fe78019e6f395b6)(el);
                    // Only updated on changed element. In case element is incremental and don't want to rerender.
                    // TODO, a more proper way?
                    if (el.__dirty) {
                        var prevStates = el.prevStates;
                        // Restore states without animation
                        if (prevStates) el.useStates(prevStates);
                    }
                    // Update state transition and enable animation again.
                    if (enableAnimation) {
                        el.stateTransition = stateTransition;
                        var textContent = el.getTextContent();
                        var textGuide = el.getTextGuideLine();
                        // TODO Is it necessary to animate label?
                        if (textContent) textContent.stateTransition = stateTransition;
                        if (textGuide) textGuide.stateTransition = stateTransition;
                    }
                    // Use highlighted and selected flag to toggle states.
                    if (el.__dirty) applyElementStates(el);
                }
            });
        }
        $4d59907f44a2d0ad$var$createExtensionAPI = function(ecIns) {
            return new /** @class */ (function(_super) {
                (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(class_1, _super);
                function class_1() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                class_1.prototype.getCoordinateSystems = function() {
                    return ecIns._coordSysMgr.getCoordinateSystems();
                };
                class_1.prototype.getComponentByElement = function(el) {
                    while(el){
                        var modelInfo = el.__ecComponentInfo;
                        if (modelInfo != null) return ecIns._model.getComponent(modelInfo.mainType, modelInfo.index);
                        el = el.parent;
                    }
                };
                class_1.prototype.enterEmphasis = function(el, highlightDigit) {
                    (0, $2bf82c0980125b62$export$b2d02638cc34c042)(el, highlightDigit);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveEmphasis = function(el, highlightDigit) {
                    (0, $2bf82c0980125b62$export$11be6f716239ac55)(el, highlightDigit);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterBlur = function(el) {
                    (0, $2bf82c0980125b62$export$207f9cb3e1099375)(el);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveBlur = function(el) {
                    (0, $2bf82c0980125b62$export$fd4a9ec75456d3c1)(el);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterSelect = function(el) {
                    (0, $2bf82c0980125b62$export$252d028dda8ef765)(el);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveSelect = function(el) {
                    (0, $2bf82c0980125b62$export$ea9a904bd6e32bd3)(el);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.getModel = function() {
                    return ecIns.getModel();
                };
                class_1.prototype.getViewOfComponentModel = function(componentModel) {
                    return ecIns.getViewOfComponentModel(componentModel);
                };
                class_1.prototype.getViewOfSeriesModel = function(seriesModel) {
                    return ecIns.getViewOfSeriesModel(seriesModel);
                };
                class_1.prototype.getMainProcessVersion = function() {
                    return ecIns[$4d59907f44a2d0ad$var$MAIN_PROCESS_VERSION_KEY];
                };
                return class_1;
            }((0, $a6d7e6163195660e$export$2e2bcd8739ae039)))(ecIns);
        };
        $4d59907f44a2d0ad$var$enableConnect = function(chart) {
            function updateConnectedChartsStatus(charts, status) {
                for(var i = 0; i < charts.length; i++){
                    var otherChart = charts[i];
                    otherChart[$4d59907f44a2d0ad$var$CONNECT_STATUS_KEY] = status;
                }
            }
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($4d59907f44a2d0ad$var$connectionEventRevertMap, function(_, eventType) {
                chart._messageCenter.on(eventType, function(event) {
                    if ($4d59907f44a2d0ad$var$connectedGroups[chart.group] && chart[$4d59907f44a2d0ad$var$CONNECT_STATUS_KEY] !== $4d59907f44a2d0ad$var$CONNECT_STATUS_PENDING) {
                        if (event && event.escapeConnect) return;
                        var action_1 = chart.makeActionFromEvent(event);
                        var otherCharts_1 = [];
                        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($4d59907f44a2d0ad$var$instances, function(otherChart) {
                            if (otherChart !== chart && otherChart.group === chart.group) otherCharts_1.push(otherChart);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $4d59907f44a2d0ad$var$CONNECT_STATUS_PENDING);
                        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(otherCharts_1, function(otherChart) {
                            if (otherChart[$4d59907f44a2d0ad$var$CONNECT_STATUS_KEY] !== $4d59907f44a2d0ad$var$CONNECT_STATUS_UPDATING) otherChart.dispatchAction(action_1);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $4d59907f44a2d0ad$var$CONNECT_STATUS_UPDATED);
                    }
                });
            });
        };
    }();
    return ECharts;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
var $4d59907f44a2d0ad$var$echartsProto = $4d59907f44a2d0ad$var$ECharts.prototype;
$4d59907f44a2d0ad$var$echartsProto.on = $4d59907f44a2d0ad$var$createRegisterEventWithLowercaseECharts("on");
$4d59907f44a2d0ad$var$echartsProto.off = $4d59907f44a2d0ad$var$createRegisterEventWithLowercaseECharts("off");
/**
 * @deprecated
 */ // @ts-ignore
$4d59907f44a2d0ad$var$echartsProto.one = function(eventName, cb, ctx) {
    var self = this;
    (0, $84bc7667c27ccedc$export$4a9c0b74eb885aa1)("ECharts#one is deprecated.");
    function wrapped() {
        var args2 = [];
        for(var _i = 0; _i < arguments.length; _i++)args2[_i] = arguments[_i];
        cb && cb.apply && cb.apply(this, args2);
        // @ts-ignore
        self.off(eventName, wrapped);
    }
    // @ts-ignore
    this.on.call(this, eventName, wrapped, ctx);
};
var $4d59907f44a2d0ad$var$MOUSE_EVENT_NAMES = [
    "click",
    "dblclick",
    "mouseover",
    "mouseout",
    "mousemove",
    "mousedown",
    "mouseup",
    "globalout",
    "contextmenu"
];
function $4d59907f44a2d0ad$var$disposedWarning(id) {}
var $4d59907f44a2d0ad$var$actions = {};
/**
 * Map event type to action type for reproducing action from event for `connect`.
 */ var $4d59907f44a2d0ad$var$connectionEventRevertMap = {};
/**
 * To remove duplication.
 */ var $4d59907f44a2d0ad$var$publicEventTypeMap = {};
var $4d59907f44a2d0ad$var$dataProcessorFuncs = [];
var $4d59907f44a2d0ad$var$optionPreprocessorFuncs = [];
var $4d59907f44a2d0ad$var$visualFuncs = [];
var $4d59907f44a2d0ad$var$themeStorage = {};
var $4d59907f44a2d0ad$var$loadingEffects = {};
var $4d59907f44a2d0ad$var$instances = {};
var $4d59907f44a2d0ad$var$connectedGroups = {};
var $4d59907f44a2d0ad$var$idBase = +new Date() - 0;
var $4d59907f44a2d0ad$var$groupIdBase = +new Date() - 0;
var $4d59907f44a2d0ad$var$DOM_ATTRIBUTE_KEY = "_echarts_instance_";
function $4d59907f44a2d0ad$export$2cd8252107eb640b(dom, theme, opts) {
    var isClient = !(opts && opts.ssr);
    if (isClient) {
        var existInstance = $4d59907f44a2d0ad$export$33b6fbccd4f643f8(dom);
        if (existInstance) return existInstance;
    }
    var chart = new $4d59907f44a2d0ad$var$ECharts(dom, theme, opts);
    chart.id = "ec_" + $4d59907f44a2d0ad$var$idBase++;
    $4d59907f44a2d0ad$var$instances[chart.id] = chart;
    isClient && $76d619f648247e6d$export$9fec4d97f1922e0b(dom, $4d59907f44a2d0ad$var$DOM_ATTRIBUTE_KEY, chart.id);
    $4d59907f44a2d0ad$var$enableConnect(chart);
    (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("afterinit", chart);
    return chart;
}
function $4d59907f44a2d0ad$export$64605811ab45167f(groupId) {
    // Is array of charts
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(groupId)) {
        var charts = groupId;
        groupId = null;
        // If any chart has group
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(charts, function(chart) {
            if (chart.group != null) groupId = chart.group;
        });
        groupId = groupId || "g_" + $4d59907f44a2d0ad$var$groupIdBase++;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(charts, function(chart) {
            chart.group = groupId;
        });
    }
    $4d59907f44a2d0ad$var$connectedGroups[groupId] = true;
    return groupId;
}
function $4d59907f44a2d0ad$export$37dfea93db2e14ed(groupId) {
    $4d59907f44a2d0ad$var$connectedGroups[groupId] = false;
}
var $4d59907f44a2d0ad$export$87cd6834112ecb52 = $4d59907f44a2d0ad$export$37dfea93db2e14ed;
function $4d59907f44a2d0ad$export$fcfbbcec2cb820d5(chart) {
    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(chart)) chart = $4d59907f44a2d0ad$var$instances[chart];
    else if (!(chart instanceof $4d59907f44a2d0ad$var$ECharts)) // Try to treat as dom
    chart = $4d59907f44a2d0ad$export$33b6fbccd4f643f8(chart);
    if (chart instanceof $4d59907f44a2d0ad$var$ECharts && !chart.isDisposed()) chart.dispose();
}
function $4d59907f44a2d0ad$export$33b6fbccd4f643f8(dom) {
    return $4d59907f44a2d0ad$var$instances[$76d619f648247e6d$export$735ee1799fd02602(dom, $4d59907f44a2d0ad$var$DOM_ATTRIBUTE_KEY)];
}
function $4d59907f44a2d0ad$export$89b4be35062c4a3f(key) {
    return $4d59907f44a2d0ad$var$instances[key];
}
function $4d59907f44a2d0ad$export$f9c59eed5de5ff80(name, theme) {
    $4d59907f44a2d0ad$var$themeStorage[name] = theme;
}
function $4d59907f44a2d0ad$export$77095792a057b768(preprocessorFunc) {
    if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)($4d59907f44a2d0ad$var$optionPreprocessorFuncs, preprocessorFunc) < 0) $4d59907f44a2d0ad$var$optionPreprocessorFuncs.push(preprocessorFunc);
}
function $4d59907f44a2d0ad$export$d575e6557ac1729f(priority, processor) {
    $4d59907f44a2d0ad$var$normalizeRegister($4d59907f44a2d0ad$var$dataProcessorFuncs, priority, processor, $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_DEFAULT);
}
function $4d59907f44a2d0ad$export$c8c249911ee8c1ed(postInitFunc) {
    $4d59907f44a2d0ad$export$c9ec4b5faef04865("afterinit", postInitFunc);
}
function $4d59907f44a2d0ad$export$99560909c18c76bb(postUpdateFunc) {
    $4d59907f44a2d0ad$export$c9ec4b5faef04865("afterupdate", postUpdateFunc);
}
function $4d59907f44a2d0ad$export$c9ec4b5faef04865(name, cb) {
    (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).on(name, cb);
}
function $4d59907f44a2d0ad$export$408c24786cd729c6(arg0, arg1, action) {
    var actionType;
    var publicEventType;
    var refineEvent;
    var update;
    var publishNonRefinedEvent;
    if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(arg1)) {
        action = arg1;
        arg1 = "";
    }
    if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(arg0)) {
        actionType = arg0.type;
        publicEventType = arg0.event;
        update = arg0.update;
        publishNonRefinedEvent = arg0.publishNonRefinedEvent;
        if (!action) action = arg0.action;
        refineEvent = arg0.refineEvent;
    } else {
        actionType = arg0;
        publicEventType = arg1;
    }
    function createEventType(actionOrEventType) {
        // Event type should be all lowercase
        return actionOrEventType.toLowerCase();
    }
    publicEventType = createEventType(publicEventType || actionType);
    // See comments on {ActionInfo} for the reason.
    var nonRefinedEventType = refineEvent ? createEventType(actionType) : publicEventType;
    // Support calling `registerAction` multiple times with the same action
    // type; subsequent calls have no effect.
    if ($4d59907f44a2d0ad$var$actions[actionType]) return;
    // Validate action type and event name.
    (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)($4d59907f44a2d0ad$var$ACTION_REG.test(actionType) && $4d59907f44a2d0ad$var$ACTION_REG.test(publicEventType));
    if (refineEvent) // An event replicated from the action will be triggered internally for `connect` in this case.
    (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(publicEventType !== actionType);
    $4d59907f44a2d0ad$var$actions[actionType] = {
        actionType: actionType,
        refinedEventType: publicEventType,
        nonRefinedEventType: nonRefinedEventType,
        update: update,
        action: action,
        refineEvent: refineEvent
    };
    $4d59907f44a2d0ad$var$publicEventTypeMap[publicEventType] = 1;
    if (refineEvent && publishNonRefinedEvent) $4d59907f44a2d0ad$var$publicEventTypeMap[nonRefinedEventType] = 1;
    $4d59907f44a2d0ad$var$connectionEventRevertMap[nonRefinedEventType] = actionType;
}
function $4d59907f44a2d0ad$export$1dd5e025a8a37dd(type, coordSysCreator) {
    (0, $70c3ede7d3b64757$export$2e2bcd8739ae039).register(type, coordSysCreator);
}
function $4d59907f44a2d0ad$export$fc2638719e4159b9(type) {
    var coordSysCreator = (0, $70c3ede7d3b64757$export$2e2bcd8739ae039).get(type);
    if (coordSysCreator) return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
}
function $4d59907f44a2d0ad$export$c3e61191887968da(seriesType, renderItem) {
    (0, $b11674322a1bd845$export$c3e61191887968da)(seriesType, renderItem);
}
function $4d59907f44a2d0ad$export$d768f97700ca6bea(priority, layoutTask) {
    $4d59907f44a2d0ad$var$normalizeRegister($4d59907f44a2d0ad$var$visualFuncs, priority, layoutTask, $4d59907f44a2d0ad$var$PRIORITY_VISUAL_LAYOUT, "layout");
}
function $4d59907f44a2d0ad$export$5f32c1eb94c381bb(priority, visualTask) {
    $4d59907f44a2d0ad$var$normalizeRegister($4d59907f44a2d0ad$var$visualFuncs, priority, visualTask, $4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART, "visual");
}
var $4d59907f44a2d0ad$var$registeredTasks = [];
function $4d59907f44a2d0ad$var$normalizeRegister(targetList, priority, fn, defaultPriority, visualType) {
    if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(priority) || (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(priority)) {
        fn = priority;
        priority = defaultPriority;
    }
    // Already registered
    if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)($4d59907f44a2d0ad$var$registeredTasks, fn) >= 0) return;
    $4d59907f44a2d0ad$var$registeredTasks.push(fn);
    var stageHandler = (0, $94ae4e8744638a8a$export$2e2bcd8739ae039).wrapStageHandler(fn, visualType);
    stageHandler.__prio = priority;
    stageHandler.__raw = fn;
    targetList.push(stageHandler);
}
function $4d59907f44a2d0ad$export$e06b68a82007c015(name, loadingFx) {
    $4d59907f44a2d0ad$var$loadingEffects[name] = loadingFx;
}
function $4d59907f44a2d0ad$export$10425ea7a243b114(creator) {
    (0, $c6341dcc9d86826e$export$61bcfd79465c1b7c)({
        createCanvas: creator
    });
}
function $4d59907f44a2d0ad$export$d456de060be2dba1(mapName, geoJson, specialAreas) {
    var registerMap = (0, $f773aa0508c1d920$export$73333eb8a09d5f61)("registerMap");
    registerMap && registerMap(mapName, geoJson, specialAreas);
}
function $4d59907f44a2d0ad$export$b8586192aead8a7e(mapName) {
    var getMap = (0, $f773aa0508c1d920$export$73333eb8a09d5f61)("getMap");
    return getMap && getMap(mapName);
}
var $4d59907f44a2d0ad$export$f01d71dd0389d7e4 = (0, $523dedd0a2328c06$export$92c96c6d8b255b7d);
/**
 * Globa dispatchAction to a specified chart instance.
 */ // export function dispatchAction(payload: { chartId: string } & Payload, opt?: Parameters<ECharts['dispatchAction']>[1]) {
//     if (!payload || !payload.chartId) {
//         // Must have chartId to find chart
//         return;
//     }
//     const chart = instances[payload.chartId];
//     if (chart) {
//         chart.dispatchAction(payload, opt);
//     }
// }
// Builtin global visual
$4d59907f44a2d0ad$export$5f32c1eb94c381bb($4d59907f44a2d0ad$var$PRIORITY_VISUAL_GLOBAL, (0, $a617f62dd17b10f1$export$7ce4d65f9b69240));
$4d59907f44a2d0ad$export$5f32c1eb94c381bb($4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $a617f62dd17b10f1$export$f7dcb66a065003d1));
$4d59907f44a2d0ad$export$5f32c1eb94c381bb($4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $a617f62dd17b10f1$export$cf9758b0d6dc0aa9));
$4d59907f44a2d0ad$export$5f32c1eb94c381bb($4d59907f44a2d0ad$var$PRIORITY_VISUAL_GLOBAL, (0, $f8e1f1a448782588$export$144ac3beded415d9));
$4d59907f44a2d0ad$export$5f32c1eb94c381bb($4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $f8e1f1a448782588$export$435b956f7f1071fb));
$4d59907f44a2d0ad$export$5f32c1eb94c381bb($4d59907f44a2d0ad$var$PRIORITY_VISUAL_DECAL, (0, $d82adaf1a5a5cfeb$export$2e2bcd8739ae039));
$4d59907f44a2d0ad$export$77095792a057b768((0, $c4489ebdf95633b6$export$2e2bcd8739ae039));
$4d59907f44a2d0ad$export$d575e6557ac1729f($4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_DATASTACK, (0, $92eb0b43a1e7607a$export$2e2bcd8739ae039));
$4d59907f44a2d0ad$export$e06b68a82007c015("default", (0, $f23f99c31dceac8f$export$2e2bcd8739ae039));
// Default actions
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: (0, $2bf82c0980125b62$export$df035d873a9de64f),
    event: (0, $2bf82c0980125b62$export$df035d873a9de64f),
    update: (0, $2bf82c0980125b62$export$df035d873a9de64f)
}, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: (0, $2bf82c0980125b62$export$f8a2f7807cc185ea),
    event: (0, $2bf82c0980125b62$export$f8a2f7807cc185ea),
    update: (0, $2bf82c0980125b62$export$f8a2f7807cc185ea)
}, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: (0, $2bf82c0980125b62$export$89616263e7d38fe9),
    event: (0, $2bf82c0980125b62$export$67f8c62bcdfbd39f),
    update: (0, $2bf82c0980125b62$export$89616263e7d38fe9),
    action: (0, $7a1bd9c2710fea0d$export$8793edee2d425525),
    refineEvent: $4d59907f44a2d0ad$var$makeSelectChangedEvent,
    publishNonRefinedEvent: true
});
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: (0, $2bf82c0980125b62$export$7636ad95c0f68a79),
    event: (0, $2bf82c0980125b62$export$67f8c62bcdfbd39f),
    update: (0, $2bf82c0980125b62$export$7636ad95c0f68a79),
    action: (0, $7a1bd9c2710fea0d$export$8793edee2d425525),
    refineEvent: $4d59907f44a2d0ad$var$makeSelectChangedEvent,
    publishNonRefinedEvent: true
});
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: (0, $2bf82c0980125b62$export$1e90ed8a25542516),
    event: (0, $2bf82c0980125b62$export$67f8c62bcdfbd39f),
    update: (0, $2bf82c0980125b62$export$1e90ed8a25542516),
    action: (0, $7a1bd9c2710fea0d$export$8793edee2d425525),
    refineEvent: $4d59907f44a2d0ad$var$makeSelectChangedEvent,
    publishNonRefinedEvent: true
});
function $4d59907f44a2d0ad$var$makeSelectChangedEvent(actionResultBatch, payload, ecModel, api) {
    return {
        eventContent: {
            selected: (0, $2bf82c0980125b62$export$c529643b619af6b3)(ecModel),
            isFromClick: payload.isFromClick || false
        }
    };
}
// Default theme, so that we can use `chart.setTheme('default')` to revert to
// the default theme after changing to other themes.
$4d59907f44a2d0ad$export$f9c59eed5de5ff80("default", {});
$4d59907f44a2d0ad$export$f9c59eed5de5ff80("dark", (0, $985c98ffd51c6ff6$export$2e2bcd8739ae039));
var $4d59907f44a2d0ad$export$73cae5e090579589 = {};










var $d657479d857c7ab3$var$extensions = [];
var $d657479d857c7ab3$var$extensionRegisters = {
    registerPreprocessor: (0, $4d59907f44a2d0ad$export$77095792a057b768),
    registerProcessor: (0, $4d59907f44a2d0ad$export$d575e6557ac1729f),
    registerPostInit: (0, $4d59907f44a2d0ad$export$c8c249911ee8c1ed),
    registerPostUpdate: (0, $4d59907f44a2d0ad$export$99560909c18c76bb),
    registerUpdateLifecycle: (0, $4d59907f44a2d0ad$export$c9ec4b5faef04865),
    registerAction: (0, $4d59907f44a2d0ad$export$408c24786cd729c6),
    registerCoordinateSystem: (0, $4d59907f44a2d0ad$export$1dd5e025a8a37dd),
    registerLayout: (0, $4d59907f44a2d0ad$export$d768f97700ca6bea),
    registerVisual: (0, $4d59907f44a2d0ad$export$5f32c1eb94c381bb),
    registerTransform: (0, $4d59907f44a2d0ad$export$f01d71dd0389d7e4),
    registerLoading: (0, $4d59907f44a2d0ad$export$e06b68a82007c015),
    registerMap: (0, $4d59907f44a2d0ad$export$d456de060be2dba1),
    registerImpl: (0, $f773aa0508c1d920$export$9b808fd12256ddd3),
    PRIORITY: (0, $4d59907f44a2d0ad$export$bb34f3538ba26c7e),
    ComponentModel: (0, $116d65051f61bdfe$export$2e2bcd8739ae039),
    ComponentView: (0, $737c88aa0711f65a$export$2e2bcd8739ae039),
    SeriesModel: (0, $7c10febb2cdef0d8$export$2e2bcd8739ae039),
    ChartView: (0, $0dc5061053e23cd3$export$2e2bcd8739ae039),
    // TODO Use ComponentModel and SeriesModel instead of Constructor
    registerComponentModel: function(ComponentModelClass) {
        (0, $116d65051f61bdfe$export$2e2bcd8739ae039).registerClass(ComponentModelClass);
    },
    registerComponentView: function(ComponentViewClass) {
        (0, $737c88aa0711f65a$export$2e2bcd8739ae039).registerClass(ComponentViewClass);
    },
    registerSeriesModel: function(SeriesModelClass) {
        (0, $7c10febb2cdef0d8$export$2e2bcd8739ae039).registerClass(SeriesModelClass);
    },
    registerChartView: function(ChartViewClass) {
        (0, $0dc5061053e23cd3$export$2e2bcd8739ae039).registerClass(ChartViewClass);
    },
    registerCustomSeries: function(seriesType, renderItem) {
        (0, $b11674322a1bd845$export$c3e61191887968da)(seriesType, renderItem);
    },
    registerSubTypeDefaulter: function(componentType, defaulter) {
        (0, $116d65051f61bdfe$export$2e2bcd8739ae039).registerSubTypeDefaulter(componentType, defaulter);
    },
    registerPainter: function(painterType, PainterCtor) {
        (0, $6eba88f9eebe6af9$export$a3e793ccb11823a5)(painterType, PainterCtor);
    }
};
function $d657479d857c7ab3$export$1f96ae73734a86cc(ext) {
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(ext)) {
        // use([ChartLine, ChartBar]);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ext, function(singleExt) {
            $d657479d857c7ab3$export$1f96ae73734a86cc(singleExt);
        });
        return;
    }
    if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)($d657479d857c7ab3$var$extensions, ext) >= 0) return;
    $d657479d857c7ab3$var$extensions.push(ext);
    if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(ext)) ext = {
        install: ext
    };
    ext.install($d657479d857c7ab3$var$extensionRegisters);
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 










function $f88637d76300101e$var$createDom(id, painter, dpr) {
    var newDom = (0, $c6341dcc9d86826e$export$ef5e599365494451).createCanvas();
    var width = painter.getWidth();
    var height = painter.getHeight();
    var newDomStyle = newDom.style;
    if (newDomStyle) {
        newDomStyle.position = "absolute";
        newDomStyle.left = "0";
        newDomStyle.top = "0";
        newDomStyle.width = width + "px";
        newDomStyle.height = height + "px";
        newDom.setAttribute("data-zr-dom-id", id);
    }
    newDom.width = width * dpr;
    newDom.height = height * dpr;
    return newDom;
}
var $f88637d76300101e$var$Layer = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Layer, _super);
    function Layer(id, painter, dpr) {
        var _this = _super.call(this) || this;
        _this.motionBlur = false;
        _this.lastFrameAlpha = 0.7;
        _this.dpr = 1;
        _this.virtual = false;
        _this.config = {};
        _this.incremental = false;
        _this.zlevel = 0;
        _this.maxRepaintRectCount = 5;
        _this.__dirty = true;
        _this.__firstTimePaint = true;
        _this.__used = false;
        _this.__drawIndex = 0;
        _this.__startIndex = 0;
        _this.__endIndex = 0;
        _this.__prevStartIndex = null;
        _this.__prevEndIndex = null;
        var dom;
        dpr = dpr || (0, $4b0cedd85979c776$export$508f096bfcdaac40);
        if (typeof id === "string") dom = $f88637d76300101e$var$createDom(id, painter, dpr);
        else if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(id)) {
            dom = id;
            id = dom.id;
        }
        _this.id = id;
        _this.dom = dom;
        var domStyle = dom.style;
        if (domStyle) {
            $7a1bd9c2710fea0d$export$23a5d775868fdd2c(dom);
            dom.onselectstart = function() {
                return false;
            };
            domStyle.padding = "0";
            domStyle.margin = "0";
            domStyle.borderWidth = "0";
        }
        _this.painter = painter;
        _this.dpr = dpr;
        return _this;
    }
    Layer.prototype.getElementCount = function() {
        return this.__endIndex - this.__startIndex;
    };
    Layer.prototype.afterBrush = function() {
        this.__prevStartIndex = this.__startIndex;
        this.__prevEndIndex = this.__endIndex;
    };
    Layer.prototype.initContext = function() {
        this.ctx = this.dom.getContext("2d");
        this.ctx.dpr = this.dpr;
    };
    Layer.prototype.setUnpainted = function() {
        this.__firstTimePaint = true;
    };
    Layer.prototype.createBackBuffer = function() {
        var dpr = this.dpr;
        this.domBack = $f88637d76300101e$var$createDom("back-" + this.id, this.painter, dpr);
        this.ctxBack = this.domBack.getContext("2d");
        if (dpr !== 1) this.ctxBack.scale(dpr, dpr);
    };
    Layer.prototype.createRepaintRects = function(displayList, prevList, viewWidth, viewHeight) {
        if (this.__firstTimePaint) {
            this.__firstTimePaint = false;
            return null;
        }
        var mergedRepaintRects = [];
        var maxRepaintRectCount = this.maxRepaintRectCount;
        var full = false;
        var pendingRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
        function addRectToMergePool(rect) {
            if (!rect.isFinite() || rect.isZero()) return;
            if (mergedRepaintRects.length === 0) {
                var boundingRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
                boundingRect.copy(rect);
                mergedRepaintRects.push(boundingRect);
            } else {
                var isMerged = false;
                var minDeltaArea = Infinity;
                var bestRectToMergeIdx = 0;
                for(var i = 0; i < mergedRepaintRects.length; ++i){
                    var mergedRect = mergedRepaintRects[i];
                    if (mergedRect.intersect(rect)) {
                        var pendingRect_1 = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
                        pendingRect_1.copy(mergedRect);
                        pendingRect_1.union(rect);
                        mergedRepaintRects[i] = pendingRect_1;
                        isMerged = true;
                        break;
                    } else if (full) {
                        pendingRect.copy(rect);
                        pendingRect.union(mergedRect);
                        var aArea = rect.width * rect.height;
                        var bArea = mergedRect.width * mergedRect.height;
                        var pendingArea = pendingRect.width * pendingRect.height;
                        var deltaArea = pendingArea - aArea - bArea;
                        if (deltaArea < minDeltaArea) {
                            minDeltaArea = deltaArea;
                            bestRectToMergeIdx = i;
                        }
                    }
                }
                if (full) {
                    mergedRepaintRects[bestRectToMergeIdx].union(rect);
                    isMerged = true;
                }
                if (!isMerged) {
                    var boundingRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
                    boundingRect.copy(rect);
                    mergedRepaintRects.push(boundingRect);
                }
                if (!full) full = mergedRepaintRects.length >= maxRepaintRectCount;
            }
        }
        for(var i = this.__startIndex; i < this.__endIndex; ++i){
            var el = displayList[i];
            if (el) {
                var shouldPaint = el.shouldBePainted(viewWidth, viewHeight, true, true);
                var prevRect = el.__isRendered && (el.__dirty & (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd) || !shouldPaint) ? el.getPrevPaintRect() : null;
                if (prevRect) addRectToMergePool(prevRect);
                var curRect = shouldPaint && (el.__dirty & (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd) || !el.__isRendered) ? el.getPaintRect() : null;
                if (curRect) addRectToMergePool(curRect);
            }
        }
        for(var i = this.__prevStartIndex; i < this.__prevEndIndex; ++i){
            var el = prevList[i];
            var shouldPaint = el && el.shouldBePainted(viewWidth, viewHeight, true, true);
            if (el && (!shouldPaint || !el.__zr) && el.__isRendered) {
                var prevRect = el.getPrevPaintRect();
                if (prevRect) addRectToMergePool(prevRect);
            }
        }
        var hasIntersections;
        do {
            hasIntersections = false;
            for(var i = 0; i < mergedRepaintRects.length;){
                if (mergedRepaintRects[i].isZero()) {
                    mergedRepaintRects.splice(i, 1);
                    continue;
                }
                for(var j = i + 1; j < mergedRepaintRects.length;)if (mergedRepaintRects[i].intersect(mergedRepaintRects[j])) {
                    hasIntersections = true;
                    mergedRepaintRects[i].union(mergedRepaintRects[j]);
                    mergedRepaintRects.splice(j, 1);
                } else j++;
                i++;
            }
        }while (hasIntersections);
        this._paintRects = mergedRepaintRects;
        return mergedRepaintRects;
    };
    Layer.prototype.debugGetPaintRects = function() {
        return (this._paintRects || []).slice();
    };
    Layer.prototype.resize = function(width, height) {
        var dpr = this.dpr;
        var dom = this.dom;
        var domStyle = dom.style;
        var domBack = this.domBack;
        if (domStyle) {
            domStyle.width = width + "px";
            domStyle.height = height + "px";
        }
        dom.width = width * dpr;
        dom.height = height * dpr;
        if (domBack) {
            domBack.width = width * dpr;
            domBack.height = height * dpr;
            if (dpr !== 1) this.ctxBack.scale(dpr, dpr);
        }
    };
    Layer.prototype.clear = function(clearAll, clearColor, repaintRects) {
        var dom = this.dom;
        var ctx = this.ctx;
        var width = dom.width;
        var height = dom.height;
        clearColor = clearColor || this.clearColor;
        var haveMotionBLur = this.motionBlur && !clearAll;
        var lastFrameAlpha = this.lastFrameAlpha;
        var dpr = this.dpr;
        var self = this;
        if (haveMotionBLur) {
            if (!this.domBack) this.createBackBuffer();
            this.ctxBack.globalCompositeOperation = "copy";
            this.ctxBack.drawImage(dom, 0, 0, width / dpr, height / dpr);
        }
        var domBack = this.domBack;
        function doClear(x, y, width, height) {
            ctx.clearRect(x, y, width, height);
            if (clearColor && clearColor !== "transparent") {
                var clearColorGradientOrPattern = void 0;
                if ($7a1bd9c2710fea0d$export$fa2c283003ed971c(clearColor)) {
                    var shouldCache = clearColor.global || clearColor.__width === width && clearColor.__height === height;
                    clearColorGradientOrPattern = shouldCache && clearColor.__canvasGradient || (0, $d76b6507633b3c44$export$3dab6afd018d48c7)(ctx, clearColor, {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    });
                    clearColor.__canvasGradient = clearColorGradientOrPattern;
                    clearColor.__width = width;
                    clearColor.__height = height;
                } else if ($7a1bd9c2710fea0d$export$a49bbf3a55dcef7b(clearColor)) {
                    clearColor.scaleX = clearColor.scaleX || dpr;
                    clearColor.scaleY = clearColor.scaleY || dpr;
                    clearColorGradientOrPattern = (0, $4f71e35e4552e3dd$export$8eb5db6b7bc27903)(ctx, clearColor, {
                        dirty: function() {
                            self.setUnpainted();
                            self.painter.refresh();
                        }
                    });
                }
                ctx.save();
                ctx.fillStyle = clearColorGradientOrPattern || clearColor;
                ctx.fillRect(x, y, width, height);
                ctx.restore();
            }
            if (haveMotionBLur) {
                ctx.save();
                ctx.globalAlpha = lastFrameAlpha;
                ctx.drawImage(domBack, x, y, width, height);
                ctx.restore();
            }
        }
        if (!repaintRects || haveMotionBLur) doClear(0, 0, width, height);
        else if (repaintRects.length) $7a1bd9c2710fea0d$export$79b2f7037acddd43(repaintRects, function(rect) {
            doClear(rect.x * dpr, rect.y * dpr, rect.width * dpr, rect.height * dpr);
        });
    };
    return Layer;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
var $f88637d76300101e$export$2e2bcd8739ae039 = $f88637d76300101e$var$Layer;







var $19d742a3d88cea2b$var$HOVER_LAYER_ZLEVEL = 1e5;
var $19d742a3d88cea2b$var$CANVAS_ZLEVEL = 314159;
var $19d742a3d88cea2b$var$EL_AFTER_INCREMENTAL_INC = 0.01;
var $19d742a3d88cea2b$var$INCREMENTAL_INC = 0.001;
function $19d742a3d88cea2b$var$isLayerValid(layer) {
    if (!layer) return false;
    if (layer.__builtin__) return true;
    if (typeof layer.resize !== "function" || typeof layer.refresh !== "function") return false;
    return true;
}
function $19d742a3d88cea2b$var$createRoot(width, height) {
    var domRoot = document.createElement("div");
    domRoot.style.cssText = [
        "position:relative",
        "width:" + width + "px",
        "height:" + height + "px",
        "padding:0",
        "margin:0",
        "border-width:0"
    ].join(";") + ";";
    return domRoot;
}
var $19d742a3d88cea2b$var$CanvasPainter = function() {
    function CanvasPainter(root, storage, opts, id) {
        this.type = "canvas";
        this._zlevelList = [];
        this._prevDisplayList = [];
        this._layers = {};
        this._layerConfig = {};
        this._needsManuallyCompositing = false;
        this.type = "canvas";
        var singleCanvas = !root.nodeName || root.nodeName.toUpperCase() === "CANVAS";
        this._opts = opts = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, opts || {});
        this.dpr = opts.devicePixelRatio || (0, $4b0cedd85979c776$export$508f096bfcdaac40);
        this._singleCanvas = singleCanvas;
        this.root = root;
        var rootStyle = root.style;
        if (rootStyle) {
            $7a1bd9c2710fea0d$export$23a5d775868fdd2c(root);
            root.innerHTML = "";
        }
        this.storage = storage;
        var zlevelList = this._zlevelList;
        this._prevDisplayList = [];
        var layers = this._layers;
        if (!singleCanvas) {
            this._width = (0, $d76b6507633b3c44$export$31b21d0167753bb4)(root, 0, opts);
            this._height = (0, $d76b6507633b3c44$export$31b21d0167753bb4)(root, 1, opts);
            var domRoot = this._domRoot = $19d742a3d88cea2b$var$createRoot(this._width, this._height);
            root.appendChild(domRoot);
        } else {
            var rootCanvas = root;
            var width = rootCanvas.width;
            var height = rootCanvas.height;
            if (opts.width != null) width = opts.width;
            if (opts.height != null) height = opts.height;
            this.dpr = opts.devicePixelRatio || 1;
            rootCanvas.width = width * this.dpr;
            rootCanvas.height = height * this.dpr;
            this._width = width;
            this._height = height;
            var mainLayer = new (0, $f88637d76300101e$export$2e2bcd8739ae039)(rootCanvas, this, this.dpr);
            mainLayer.__builtin__ = true;
            mainLayer.initContext();
            layers[$19d742a3d88cea2b$var$CANVAS_ZLEVEL] = mainLayer;
            mainLayer.zlevel = $19d742a3d88cea2b$var$CANVAS_ZLEVEL;
            zlevelList.push($19d742a3d88cea2b$var$CANVAS_ZLEVEL);
            this._domRoot = root;
        }
    }
    CanvasPainter.prototype.getType = function() {
        return "canvas";
    };
    CanvasPainter.prototype.isSingleCanvas = function() {
        return this._singleCanvas;
    };
    CanvasPainter.prototype.getViewportRoot = function() {
        return this._domRoot;
    };
    CanvasPainter.prototype.getViewportRootOffset = function() {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) return {
            offsetLeft: viewportRoot.offsetLeft || 0,
            offsetTop: viewportRoot.offsetTop || 0
        };
    };
    CanvasPainter.prototype.refresh = function(paintAll) {
        var list = this.storage.getDisplayList(true);
        var prevList = this._prevDisplayList;
        var zlevelList = this._zlevelList;
        this._redrawId = Math.random();
        this._paintList(list, prevList, paintAll, this._redrawId);
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (!layer.__builtin__ && layer.refresh) {
                var clearColor = i === 0 ? this._backgroundColor : null;
                layer.refresh(clearColor);
            }
        }
        if (this._opts.useDirtyRect) this._prevDisplayList = list.slice();
        return this;
    };
    CanvasPainter.prototype.refreshHover = function() {
        this._paintHoverList(this.storage.getDisplayList(false));
    };
    CanvasPainter.prototype._paintHoverList = function(list) {
        var len = list.length;
        var hoverLayer = this._hoverlayer;
        hoverLayer && hoverLayer.clear();
        if (!len) return;
        var scope = {
            inHover: true,
            viewWidth: this._width,
            viewHeight: this._height
        };
        var ctx;
        for(var i = 0; i < len; i++){
            var el = list[i];
            if (el.__inHover) {
                if (!hoverLayer) hoverLayer = this._hoverlayer = this.getLayer($19d742a3d88cea2b$var$HOVER_LAYER_ZLEVEL);
                if (!ctx) {
                    ctx = hoverLayer.ctx;
                    ctx.save();
                }
                (0, $4f71e35e4552e3dd$export$da5d6544e8c27bc1)(ctx, el, scope, i === len - 1);
            }
        }
        if (ctx) ctx.restore();
    };
    CanvasPainter.prototype.getHoverLayer = function() {
        return this.getLayer($19d742a3d88cea2b$var$HOVER_LAYER_ZLEVEL);
    };
    CanvasPainter.prototype.paintOne = function(ctx, el) {
        (0, $4f71e35e4552e3dd$export$567881adfc3eb7f3)(ctx, el);
    };
    CanvasPainter.prototype._paintList = function(list, prevList, paintAll, redrawId) {
        if (this._redrawId !== redrawId) return;
        paintAll = paintAll || false;
        this._updateLayerStatus(list);
        var _a = this._doPaintList(list, prevList, paintAll), finished = _a.finished, needsRefreshHover = _a.needsRefreshHover;
        if (this._needsManuallyCompositing) this._compositeManually();
        if (needsRefreshHover) this._paintHoverList(list);
        if (!finished) {
            var self_1 = this;
            (0, $731d42ad1858cd4c$export$2e2bcd8739ae039)(function() {
                self_1._paintList(list, prevList, paintAll, redrawId);
            });
        } else this.eachLayer(function(layer) {
            layer.afterBrush && layer.afterBrush();
        });
    };
    CanvasPainter.prototype._compositeManually = function() {
        var ctx = this.getLayer($19d742a3d88cea2b$var$CANVAS_ZLEVEL).ctx;
        var width = this._domRoot.width;
        var height = this._domRoot.height;
        ctx.clearRect(0, 0, width, height);
        this.eachBuiltinLayer(function(layer) {
            if (layer.virtual) ctx.drawImage(layer.dom, 0, 0, width, height);
        });
    };
    CanvasPainter.prototype._doPaintList = function(list, prevList, paintAll) {
        var _this = this;
        var layerList = [];
        var useDirtyRect = this._opts.useDirtyRect;
        for(var zi = 0; zi < this._zlevelList.length; zi++){
            var zlevel = this._zlevelList[zi];
            var layer = this._layers[zlevel];
            if (layer.__builtin__ && layer !== this._hoverlayer && (layer.__dirty || paintAll)) layerList.push(layer);
        }
        var finished = true;
        var needsRefreshHover = false;
        var _loop_1 = function(k) {
            var layer = layerList[k];
            var ctx = layer.ctx;
            var repaintRects = useDirtyRect && layer.createRepaintRects(list, prevList, this_1._width, this_1._height);
            var start = paintAll ? layer.__startIndex : layer.__drawIndex;
            var useTimer = !paintAll && layer.incremental && Date.now;
            var startTime = useTimer && Date.now();
            var clearColor = layer.zlevel === this_1._zlevelList[0] ? this_1._backgroundColor : null;
            if (layer.__startIndex === layer.__endIndex) layer.clear(false, clearColor, repaintRects);
            else if (start === layer.__startIndex) {
                var firstEl = list[start];
                if (!firstEl.incremental || !firstEl.notClear || paintAll) layer.clear(false, clearColor, repaintRects);
            }
            if (start === -1) {
                console.error("For some unknown reason. drawIndex is -1");
                start = layer.__startIndex;
            }
            var i;
            var repaint = function(repaintRect) {
                var scope = {
                    inHover: false,
                    allClipped: false,
                    prevEl: null,
                    viewWidth: _this._width,
                    viewHeight: _this._height
                };
                for(i = start; i < layer.__endIndex; i++){
                    var el = list[i];
                    if (el.__inHover) needsRefreshHover = true;
                    _this._doPaintEl(el, layer, useDirtyRect, repaintRect, scope, i === layer.__endIndex - 1);
                    if (useTimer) {
                        var dTime = Date.now() - startTime;
                        if (dTime > 15) break;
                    }
                }
                if (scope.prevElClipPaths) ctx.restore();
            };
            if (repaintRects) {
                if (repaintRects.length === 0) i = layer.__endIndex;
                else {
                    var dpr = this_1.dpr;
                    for(var r = 0; r < repaintRects.length; ++r){
                        var rect = repaintRects[r];
                        ctx.save();
                        ctx.beginPath();
                        ctx.rect(rect.x * dpr, rect.y * dpr, rect.width * dpr, rect.height * dpr);
                        ctx.clip();
                        repaint(rect);
                        ctx.restore();
                    }
                }
            } else {
                ctx.save();
                repaint();
                ctx.restore();
            }
            layer.__drawIndex = i;
            if (layer.__drawIndex < layer.__endIndex) finished = false;
        };
        var this_1 = this;
        for(var k = 0; k < layerList.length; k++)_loop_1(k);
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).wxa) $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._layers, function(layer) {
            if (layer && layer.ctx && layer.ctx.draw) layer.ctx.draw();
        });
        return {
            finished: finished,
            needsRefreshHover: needsRefreshHover
        };
    };
    CanvasPainter.prototype._doPaintEl = function(el, currentLayer, useDirtyRect, repaintRect, scope, isLast) {
        var ctx = currentLayer.ctx;
        if (useDirtyRect) {
            var paintRect = el.getPaintRect();
            if (!repaintRect || paintRect && paintRect.intersect(repaintRect)) {
                (0, $4f71e35e4552e3dd$export$da5d6544e8c27bc1)(ctx, el, scope, isLast);
                el.setPrevPaintRect(paintRect);
            }
        } else (0, $4f71e35e4552e3dd$export$da5d6544e8c27bc1)(ctx, el, scope, isLast);
    };
    CanvasPainter.prototype.getLayer = function(zlevel, virtual) {
        if (this._singleCanvas && !this._needsManuallyCompositing) zlevel = $19d742a3d88cea2b$var$CANVAS_ZLEVEL;
        var layer = this._layers[zlevel];
        if (!layer) {
            layer = new (0, $f88637d76300101e$export$2e2bcd8739ae039)("zr_" + zlevel, this, this.dpr);
            layer.zlevel = zlevel;
            layer.__builtin__ = true;
            if (this._layerConfig[zlevel]) $7a1bd9c2710fea0d$export$4950aa0f605343fb(layer, this._layerConfig[zlevel], true);
            else if (this._layerConfig[zlevel - $19d742a3d88cea2b$var$EL_AFTER_INCREMENTAL_INC]) $7a1bd9c2710fea0d$export$4950aa0f605343fb(layer, this._layerConfig[zlevel - $19d742a3d88cea2b$var$EL_AFTER_INCREMENTAL_INC], true);
            if (virtual) layer.virtual = virtual;
            this.insertLayer(zlevel, layer);
            layer.initContext();
        }
        return layer;
    };
    CanvasPainter.prototype.insertLayer = function(zlevel, layer) {
        var layersMap = this._layers;
        var zlevelList = this._zlevelList;
        var len = zlevelList.length;
        var domRoot = this._domRoot;
        var prevLayer = null;
        var i = -1;
        if (layersMap[zlevel]) return;
        if (!$19d742a3d88cea2b$var$isLayerValid(layer)) return;
        if (len > 0 && zlevel > zlevelList[0]) {
            for(i = 0; i < len - 1; i++){
                if (zlevelList[i] < zlevel && zlevelList[i + 1] > zlevel) break;
            }
            prevLayer = layersMap[zlevelList[i]];
        }
        zlevelList.splice(i + 1, 0, zlevel);
        layersMap[zlevel] = layer;
        if (!layer.virtual) {
            if (prevLayer) {
                var prevDom = prevLayer.dom;
                if (prevDom.nextSibling) domRoot.insertBefore(layer.dom, prevDom.nextSibling);
                else domRoot.appendChild(layer.dom);
            } else if (domRoot.firstChild) domRoot.insertBefore(layer.dom, domRoot.firstChild);
            else domRoot.appendChild(layer.dom);
        }
        layer.painter || (layer.painter = this);
    };
    CanvasPainter.prototype.eachLayer = function(cb, context) {
        var zlevelList = this._zlevelList;
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            cb.call(context, this._layers[z], z);
        }
    };
    CanvasPainter.prototype.eachBuiltinLayer = function(cb, context) {
        var zlevelList = this._zlevelList;
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (layer.__builtin__) cb.call(context, layer, z);
        }
    };
    CanvasPainter.prototype.eachOtherLayer = function(cb, context) {
        var zlevelList = this._zlevelList;
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (!layer.__builtin__) cb.call(context, layer, z);
        }
    };
    CanvasPainter.prototype.getLayers = function() {
        return this._layers;
    };
    CanvasPainter.prototype._updateLayerStatus = function(list) {
        this.eachBuiltinLayer(function(layer, z) {
            layer.__dirty = layer.__used = false;
        });
        function updatePrevLayer(idx) {
            if (prevLayer) {
                if (prevLayer.__endIndex !== idx) prevLayer.__dirty = true;
                prevLayer.__endIndex = idx;
            }
        }
        if (this._singleCanvas) for(var i_1 = 1; i_1 < list.length; i_1++){
            var el = list[i_1];
            if (el.zlevel !== list[i_1 - 1].zlevel || el.incremental) {
                this._needsManuallyCompositing = true;
                break;
            }
        }
        var prevLayer = null;
        var incrementalLayerCount = 0;
        var prevZlevel;
        var i;
        for(i = 0; i < list.length; i++){
            var el = list[i];
            var zlevel = el.zlevel;
            var layer = void 0;
            if (prevZlevel !== zlevel) {
                prevZlevel = zlevel;
                incrementalLayerCount = 0;
            }
            if (el.incremental) {
                layer = this.getLayer(zlevel + $19d742a3d88cea2b$var$INCREMENTAL_INC, this._needsManuallyCompositing);
                layer.incremental = true;
                incrementalLayerCount = 1;
            } else layer = this.getLayer(zlevel + (incrementalLayerCount > 0 ? $19d742a3d88cea2b$var$EL_AFTER_INCREMENTAL_INC : 0), this._needsManuallyCompositing);
            if (!layer.__builtin__) $7a1bd9c2710fea0d$export$58da9968c3170cb1("ZLevel " + zlevel + " has been used by unkown layer " + layer.id);
            if (layer !== prevLayer) {
                layer.__used = true;
                if (layer.__startIndex !== i) layer.__dirty = true;
                layer.__startIndex = i;
                if (!layer.incremental) layer.__drawIndex = i;
                else layer.__drawIndex = -1;
                updatePrevLayer(i);
                prevLayer = layer;
            }
            if (el.__dirty & (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd) && !el.__inHover) {
                layer.__dirty = true;
                if (layer.incremental && layer.__drawIndex < 0) layer.__drawIndex = i;
            }
        }
        updatePrevLayer(i);
        this.eachBuiltinLayer(function(layer, z) {
            if (!layer.__used && layer.getElementCount() > 0) {
                layer.__dirty = true;
                layer.__startIndex = layer.__endIndex = layer.__drawIndex = 0;
            }
            if (layer.__dirty && layer.__drawIndex < 0) layer.__drawIndex = layer.__startIndex;
        });
    };
    CanvasPainter.prototype.clear = function() {
        this.eachBuiltinLayer(this._clearLayer);
        return this;
    };
    CanvasPainter.prototype._clearLayer = function(layer) {
        layer.clear();
    };
    CanvasPainter.prototype.setBackgroundColor = function(backgroundColor) {
        this._backgroundColor = backgroundColor;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._layers, function(layer) {
            layer.setUnpainted();
        });
    };
    CanvasPainter.prototype.configLayer = function(zlevel, config) {
        if (config) {
            var layerConfig = this._layerConfig;
            if (!layerConfig[zlevel]) layerConfig[zlevel] = config;
            else $7a1bd9c2710fea0d$export$4950aa0f605343fb(layerConfig[zlevel], config, true);
            for(var i = 0; i < this._zlevelList.length; i++){
                var _zlevel = this._zlevelList[i];
                if (_zlevel === zlevel || _zlevel === zlevel + $19d742a3d88cea2b$var$EL_AFTER_INCREMENTAL_INC) {
                    var layer = this._layers[_zlevel];
                    $7a1bd9c2710fea0d$export$4950aa0f605343fb(layer, layerConfig[zlevel], true);
                }
            }
        }
    };
    CanvasPainter.prototype.delLayer = function(zlevel) {
        var layers = this._layers;
        var zlevelList = this._zlevelList;
        var layer = layers[zlevel];
        if (!layer) return;
        layer.dom.parentNode.removeChild(layer.dom);
        delete layers[zlevel];
        zlevelList.splice($7a1bd9c2710fea0d$export$305f7d4e9d4624f2(zlevelList, zlevel), 1);
    };
    CanvasPainter.prototype.resize = function(width, height) {
        if (!this._domRoot.style) {
            if (width == null || height == null) return;
            this._width = width;
            this._height = height;
            this.getLayer($19d742a3d88cea2b$var$CANVAS_ZLEVEL).resize(width, height);
        } else {
            var domRoot = this._domRoot;
            domRoot.style.display = "none";
            var opts = this._opts;
            var root = this.root;
            width != null && (opts.width = width);
            height != null && (opts.height = height);
            width = (0, $d76b6507633b3c44$export$31b21d0167753bb4)(root, 0, opts);
            height = (0, $d76b6507633b3c44$export$31b21d0167753bb4)(root, 1, opts);
            domRoot.style.display = "";
            if (this._width !== width || height !== this._height) {
                domRoot.style.width = width + "px";
                domRoot.style.height = height + "px";
                for(var id in this._layers)if (this._layers.hasOwnProperty(id)) this._layers[id].resize(width, height);
                this.refresh(true);
            }
            this._width = width;
            this._height = height;
        }
        return this;
    };
    CanvasPainter.prototype.clearLayer = function(zlevel) {
        var layer = this._layers[zlevel];
        if (layer) layer.clear();
    };
    CanvasPainter.prototype.dispose = function() {
        this.root.innerHTML = "";
        this.root = this.storage = this._domRoot = this._layers = null;
    };
    CanvasPainter.prototype.getRenderedCanvas = function(opts) {
        opts = opts || {};
        if (this._singleCanvas && !this._compositeManually) return this._layers[$19d742a3d88cea2b$var$CANVAS_ZLEVEL].dom;
        var imageLayer = new (0, $f88637d76300101e$export$2e2bcd8739ae039)("image", this, opts.pixelRatio || this.dpr);
        imageLayer.initContext();
        imageLayer.clear(false, opts.backgroundColor || this._backgroundColor);
        var ctx = imageLayer.ctx;
        if (opts.pixelRatio <= this.dpr) {
            this.refresh();
            var width_1 = imageLayer.dom.width;
            var height_1 = imageLayer.dom.height;
            this.eachLayer(function(layer) {
                if (layer.__builtin__) ctx.drawImage(layer.dom, 0, 0, width_1, height_1);
                else if (layer.renderToCanvas) {
                    ctx.save();
                    layer.renderToCanvas(ctx);
                    ctx.restore();
                }
            });
        } else {
            var scope = {
                inHover: false,
                viewWidth: this._width,
                viewHeight: this._height
            };
            var displayList = this.storage.getDisplayList(true);
            for(var i = 0, len = displayList.length; i < len; i++){
                var el = displayList[i];
                (0, $4f71e35e4552e3dd$export$da5d6544e8c27bc1)(ctx, el, scope, i === len - 1);
            }
        }
        return imageLayer.dom;
    };
    CanvasPainter.prototype.getWidth = function() {
        return this._width;
    };
    CanvasPainter.prototype.getHeight = function() {
        return this._height;
    };
    return CanvasPainter;
}();
var $19d742a3d88cea2b$export$2e2bcd8739ae039 = $19d742a3d88cea2b$var$CanvasPainter;


function $e792bf2f67d76098$export$4b3e715f166fdd78(registers) {
    registers.registerPainter("canvas", (0, $19d742a3d88cea2b$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $c8b2ce72d2349eb5$var$mathSin = Math.sin;
var $c8b2ce72d2349eb5$var$mathCos = Math.cos;
var $c8b2ce72d2349eb5$var$PI = Math.PI;
var $c8b2ce72d2349eb5$var$PI2 = Math.PI * 2;
var $c8b2ce72d2349eb5$var$degree = 180 / $c8b2ce72d2349eb5$var$PI;
var $c8b2ce72d2349eb5$var$SVGPathRebuilder = function() {
    function SVGPathRebuilder() {}
    SVGPathRebuilder.prototype.reset = function(precision) {
        this._start = true;
        this._d = [];
        this._str = "";
        this._p = Math.pow(10, precision || 4);
    };
    SVGPathRebuilder.prototype.moveTo = function(x, y) {
        this._add("M", x, y);
    };
    SVGPathRebuilder.prototype.lineTo = function(x, y) {
        this._add("L", x, y);
    };
    SVGPathRebuilder.prototype.bezierCurveTo = function(x, y, x2, y2, x3, y3) {
        this._add("C", x, y, x2, y2, x3, y3);
    };
    SVGPathRebuilder.prototype.quadraticCurveTo = function(x, y, x2, y2) {
        this._add("Q", x, y, x2, y2);
    };
    SVGPathRebuilder.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
        this.ellipse(cx, cy, r, r, 0, startAngle, endAngle, anticlockwise);
    };
    SVGPathRebuilder.prototype.ellipse = function(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise) {
        var dTheta = endAngle - startAngle;
        var clockwise = !anticlockwise;
        var dThetaPositive = Math.abs(dTheta);
        var isCircle = (0, $999d81abec723db8$export$4701367f5b4de464)(dThetaPositive - $c8b2ce72d2349eb5$var$PI2) || (clockwise ? dTheta >= $c8b2ce72d2349eb5$var$PI2 : -dTheta >= $c8b2ce72d2349eb5$var$PI2);
        var unifiedTheta = dTheta > 0 ? dTheta % $c8b2ce72d2349eb5$var$PI2 : dTheta % $c8b2ce72d2349eb5$var$PI2 + $c8b2ce72d2349eb5$var$PI2;
        var large = false;
        if (isCircle) large = true;
        else if ((0, $999d81abec723db8$export$4701367f5b4de464)(dThetaPositive)) large = false;
        else large = unifiedTheta >= $c8b2ce72d2349eb5$var$PI === !!clockwise;
        var x0 = cx + rx * $c8b2ce72d2349eb5$var$mathCos(startAngle);
        var y0 = cy + ry * $c8b2ce72d2349eb5$var$mathSin(startAngle);
        if (this._start) this._add("M", x0, y0);
        var xRot = Math.round(psi * $c8b2ce72d2349eb5$var$degree);
        if (isCircle) {
            var p = 1 / this._p;
            var dTheta_1 = (clockwise ? 1 : -1) * ($c8b2ce72d2349eb5$var$PI2 - p);
            this._add("A", rx, ry, xRot, 1, +clockwise, cx + rx * $c8b2ce72d2349eb5$var$mathCos(startAngle + dTheta_1), cy + ry * $c8b2ce72d2349eb5$var$mathSin(startAngle + dTheta_1));
            if (p > 1e-2) this._add("A", rx, ry, xRot, 0, +clockwise, x0, y0);
        } else {
            var x = cx + rx * $c8b2ce72d2349eb5$var$mathCos(endAngle);
            var y = cy + ry * $c8b2ce72d2349eb5$var$mathSin(endAngle);
            this._add("A", rx, ry, xRot, +large, +clockwise, x, y);
        }
    };
    SVGPathRebuilder.prototype.rect = function(x, y, w, h) {
        this._add("M", x, y);
        this._add("l", w, 0);
        this._add("l", 0, h);
        this._add("l", -w, 0);
        this._add("Z");
    };
    SVGPathRebuilder.prototype.closePath = function() {
        if (this._d.length > 0) this._add("Z");
    };
    SVGPathRebuilder.prototype._add = function(cmd, a, b, c, d, e, f, g, h) {
        var vals = [];
        var p = this._p;
        for(var i = 1; i < arguments.length; i++){
            var val = arguments[i];
            if (isNaN(val)) {
                this._invalid = true;
                return;
            }
            vals.push(Math.round(val * p) / p);
        }
        this._d.push(cmd + vals.join(" "));
        this._start = cmd === "Z";
    };
    SVGPathRebuilder.prototype.generateStr = function() {
        this._str = this._invalid ? "" : this._d.join("");
        this._d = [];
    };
    SVGPathRebuilder.prototype.getStr = function() {
        return this._str;
    };
    return SVGPathRebuilder;
}();
var $c8b2ce72d2349eb5$export$2e2bcd8739ae039 = $c8b2ce72d2349eb5$var$SVGPathRebuilder;







var $6f6b3090476bfa7b$var$NONE = "none";
var $6f6b3090476bfa7b$var$mathRound = Math.round;
function $6f6b3090476bfa7b$var$pathHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== $6f6b3090476bfa7b$var$NONE;
}
function $6f6b3090476bfa7b$var$pathHasStroke(style) {
    var stroke = style.stroke;
    return stroke != null && stroke !== $6f6b3090476bfa7b$var$NONE;
}
var $6f6b3090476bfa7b$var$strokeProps = [
    "lineCap",
    "miterLimit",
    "lineJoin"
];
var $6f6b3090476bfa7b$var$svgStrokeProps = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)($6f6b3090476bfa7b$var$strokeProps, function(prop) {
    return "stroke-" + prop.toLowerCase();
});
function $6f6b3090476bfa7b$export$2e2bcd8739ae039(updateAttr, style, el, forceUpdate) {
    var opacity = style.opacity == null ? 1 : style.opacity;
    if (el instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
        updateAttr("opacity", opacity);
        return;
    }
    if ($6f6b3090476bfa7b$var$pathHasFill(style)) {
        var fill = (0, $999d81abec723db8$export$4cde5df63f53f473)(style.fill);
        updateAttr("fill", fill.color);
        var fillOpacity = style.fillOpacity != null ? style.fillOpacity * fill.opacity * opacity : fill.opacity * opacity;
        if (forceUpdate || fillOpacity < 1) updateAttr("fill-opacity", fillOpacity);
    } else updateAttr("fill", $6f6b3090476bfa7b$var$NONE);
    if ($6f6b3090476bfa7b$var$pathHasStroke(style)) {
        var stroke = (0, $999d81abec723db8$export$4cde5df63f53f473)(style.stroke);
        updateAttr("stroke", stroke.color);
        var strokeScale = style.strokeNoScale ? el.getLineScale() : 1;
        var strokeWidth = strokeScale ? (style.lineWidth || 0) / strokeScale : 0;
        var strokeOpacity = style.strokeOpacity != null ? style.strokeOpacity * stroke.opacity * opacity : stroke.opacity * opacity;
        var strokeFirst = style.strokeFirst;
        if (forceUpdate || strokeWidth !== 1) updateAttr("stroke-width", strokeWidth);
        if (forceUpdate || strokeFirst) updateAttr("paint-order", strokeFirst ? "stroke" : "fill");
        if (forceUpdate || strokeOpacity < 1) updateAttr("stroke-opacity", strokeOpacity);
        if (style.lineDash) {
            var _a = (0, $21ab8baf7c1f083c$export$9d315911f153b3b2)(el), lineDash = _a[0], lineDashOffset = _a[1];
            if (lineDash) {
                lineDashOffset = $6f6b3090476bfa7b$var$mathRound(lineDashOffset || 0);
                updateAttr("stroke-dasharray", lineDash.join(","));
                if (lineDashOffset || forceUpdate) updateAttr("stroke-dashoffset", lineDashOffset);
            }
        } else if (forceUpdate) updateAttr("stroke-dasharray", $6f6b3090476bfa7b$var$NONE);
        for(var i = 0; i < $6f6b3090476bfa7b$var$strokeProps.length; i++){
            var propName = $6f6b3090476bfa7b$var$strokeProps[i];
            if (forceUpdate || style[propName] !== (0, $b02ffe7acd508c08$export$deade517576e293a)[propName]) {
                var val = style[propName] || (0, $b02ffe7acd508c08$export$deade517576e293a)[propName];
                val && updateAttr($6f6b3090476bfa7b$var$svgStrokeProps[i], val);
            }
        }
    } else if (forceUpdate) updateAttr("stroke", $6f6b3090476bfa7b$var$NONE);
}




var $f6ad3c9e333d7ffc$export$a690ad4c9a38f86e = "http://www.w3.org/2000/svg";
var $f6ad3c9e333d7ffc$export$b22c6da1792ecec8 = "http://www.w3.org/1999/xlink";
var $f6ad3c9e333d7ffc$export$fac09d762d15fa3b = "http://www.w3.org/2000/xmlns/";
var $f6ad3c9e333d7ffc$export$ad4c4fdecd3b4156 = "http://www.w3.org/XML/1998/namespace";
var $f6ad3c9e333d7ffc$export$d3f79611f155197c = "ecmeta_";
function $f6ad3c9e333d7ffc$export$c8a8987d4410bf2d(name) {
    return document.createElementNS($f6ad3c9e333d7ffc$export$a690ad4c9a38f86e, name);
}
function $f6ad3c9e333d7ffc$export$bf5c4cf060303d58(tag, key, attrs, children, text) {
    return {
        tag: tag,
        attrs: attrs || {},
        children: children,
        text: text,
        key: key
    };
}
function $f6ad3c9e333d7ffc$var$createElementOpen(name, attrs) {
    var attrsStr = [];
    if (attrs) for(var key in attrs){
        var val = attrs[key];
        var part = key;
        if (val === false) continue;
        else if (val !== true && val != null) part += '="' + val + '"';
        attrsStr.push(part);
    }
    return "<" + name + " " + attrsStr.join(" ") + ">";
}
function $f6ad3c9e333d7ffc$var$createElementClose(name) {
    return "</" + name + ">";
}
function $f6ad3c9e333d7ffc$export$f5c4a9a0e027f2b(el, opts) {
    opts = opts || {};
    var S = opts.newline ? "\n" : "";
    function convertElToString(el) {
        var children = el.children, tag = el.tag, attrs = el.attrs, text = el.text;
        return $f6ad3c9e333d7ffc$var$createElementOpen(tag, attrs) + (tag !== "style" ? (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(text) : text || "") + (children ? "" + S + (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(children, function(child) {
            return convertElToString(child);
        }).join(S) + S : "") + $f6ad3c9e333d7ffc$var$createElementClose(tag);
    }
    return convertElToString(el);
}
function $f6ad3c9e333d7ffc$export$e2b4f3597c7a7dcb(selectorNodes, animationNodes, opts) {
    opts = opts || {};
    var S = opts.newline ? "\n" : "";
    var bracketBegin = " {" + S;
    var bracketEnd = S + "}";
    var selectors = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(selectorNodes), function(className) {
        return className + bracketBegin + (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(selectorNodes[className]), function(attrName) {
            return attrName + ":" + selectorNodes[className][attrName] + ";";
        }).join(S) + bracketEnd;
    }).join(S);
    var animations = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(animationNodes), function(animationName) {
        return "@keyframes " + animationName + bracketBegin + (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(animationNodes[animationName]), function(percent) {
            return percent + bracketBegin + (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(animationNodes[animationName][percent]), function(attrName) {
                var val = animationNodes[animationName][percent][attrName];
                if (attrName === "d") val = 'path("' + val + '")';
                return attrName + ":" + val + ";";
            }).join(S) + bracketEnd;
        }).join(S) + bracketEnd;
    }).join(S);
    if (!selectors && !animations) return "";
    return [
        "<![CDATA[",
        selectors,
        animations,
        "]]>"
    ].join(S);
}
function $f6ad3c9e333d7ffc$export$96fee5f38ed01741(zrId) {
    return {
        zrId: zrId,
        shadowCache: {},
        patternCache: {},
        gradientCache: {},
        clipPathCache: {},
        defs: {},
        cssNodes: {},
        cssAnims: {},
        cssStyleCache: {},
        cssAnimIdx: 0,
        shadowIdx: 0,
        gradientIdx: 0,
        patternIdx: 0,
        clipPathIdx: 0
    };
}
function $f6ad3c9e333d7ffc$export$5529a6aad332ee75(width, height, children, useViewBox) {
    return $f6ad3c9e333d7ffc$export$bf5c4cf060303d58("svg", "root", {
        "width": width,
        "height": height,
        "xmlns": $f6ad3c9e333d7ffc$export$a690ad4c9a38f86e,
        "xmlns:xlink": $f6ad3c9e333d7ffc$export$b22c6da1792ecec8,
        "version": "1.1",
        "baseProfile": "full",
        "viewBox": useViewBox ? "0 0 " + width + " " + height : false
    }, children);
}












var $849cb89161be4359$var$cssClassIdx = 0;
function $849cb89161be4359$export$9c80c36b7367fb56() {
    return $849cb89161be4359$var$cssClassIdx++;
}


var $a85a6a2869494a29$export$54ee1847795bcf37 = {
    cubicIn: "0.32,0,0.67,0",
    cubicOut: "0.33,1,0.68,1",
    cubicInOut: "0.65,0,0.35,1",
    quadraticIn: "0.11,0,0.5,0",
    quadraticOut: "0.5,1,0.89,1",
    quadraticInOut: "0.45,0,0.55,1",
    quarticIn: "0.5,0,0.75,0",
    quarticOut: "0.25,1,0.5,1",
    quarticInOut: "0.76,0,0.24,1",
    quinticIn: "0.64,0,0.78,0",
    quinticOut: "0.22,1,0.36,1",
    quinticInOut: "0.83,0,0.17,1",
    sinusoidalIn: "0.12,0,0.39,0",
    sinusoidalOut: "0.61,1,0.88,1",
    sinusoidalInOut: "0.37,0,0.63,1",
    exponentialIn: "0.7,0,0.84,0",
    exponentialOut: "0.16,1,0.3,1",
    exponentialInOut: "0.87,0,0.13,1",
    circularIn: "0.55,0,1,0.45",
    circularOut: "0,0.55,0.45,1",
    circularInOut: "0.85,0,0.15,1"
};
var $a85a6a2869494a29$var$transformOriginKey = "transform-origin";
function $a85a6a2869494a29$var$buildPathString(el, kfShape, path) {
    var shape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, el.shape);
    (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(shape, kfShape);
    el.buildPath(path, shape);
    var svgPathBuilder = new (0, $c8b2ce72d2349eb5$export$2e2bcd8739ae039)();
    svgPathBuilder.reset((0, $999d81abec723db8$export$93fa1ae8a509371c)(el));
    path.rebuildPath(svgPathBuilder, 1);
    svgPathBuilder.generateStr();
    return svgPathBuilder.getStr();
}
function $a85a6a2869494a29$var$setTransformOrigin(target, transform) {
    var originX = transform.originX, originY = transform.originY;
    if (originX || originY) target[$a85a6a2869494a29$var$transformOriginKey] = originX + "px " + originY + "px";
}
var $a85a6a2869494a29$export$f0dede2064ee89d7 = {
    fill: "fill",
    opacity: "opacity",
    lineWidth: "stroke-width",
    lineDashOffset: "stroke-dashoffset"
};
function $a85a6a2869494a29$var$addAnimation(cssAnim, scope) {
    var animationName = scope.zrId + "-ani-" + scope.cssAnimIdx++;
    scope.cssAnims[animationName] = cssAnim;
    return animationName;
}
function $a85a6a2869494a29$var$createCompoundPathCSSAnimation(el, attrs, scope) {
    var paths = el.shape.paths;
    var composedAnim = {};
    var cssAnimationCfg;
    var cssAnimationName;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(paths, function(path) {
        var subScope = (0, $f6ad3c9e333d7ffc$export$96fee5f38ed01741)(scope.zrId);
        subScope.animation = true;
        $a85a6a2869494a29$export$dc9722e37397d426(path, {}, subScope, true);
        var cssAnims = subScope.cssAnims;
        var cssNodes = subScope.cssNodes;
        var animNames = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(cssAnims);
        var len = animNames.length;
        if (!len) return;
        cssAnimationName = animNames[len - 1];
        var lastAnim = cssAnims[cssAnimationName];
        for(var percent in lastAnim){
            var kf = lastAnim[percent];
            composedAnim[percent] = composedAnim[percent] || {
                d: ""
            };
            composedAnim[percent].d += kf.d || "";
        }
        for(var className in cssNodes){
            var val = cssNodes[className].animation;
            if (val.indexOf(cssAnimationName) >= 0) cssAnimationCfg = val;
        }
    });
    if (!cssAnimationCfg) return;
    attrs.d = false;
    var animationName = $a85a6a2869494a29$var$addAnimation(composedAnim, scope);
    return cssAnimationCfg.replace(cssAnimationName, animationName);
}
function $a85a6a2869494a29$var$getEasingFunc(easing) {
    return (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(easing) ? $a85a6a2869494a29$export$54ee1847795bcf37[easing] ? "cubic-bezier(" + $a85a6a2869494a29$export$54ee1847795bcf37[easing] + ")" : (0, $0aea98bda0b4be1f$export$ec0863d806fd857e)(easing) ? easing : "" : "";
}
function $a85a6a2869494a29$export$dc9722e37397d426(el, attrs, scope, onlyShape) {
    var animators = el.animators;
    var len = animators.length;
    var cssAnimations = [];
    if (el instanceof (0, $e152f3dbf8fba6e2$export$2e2bcd8739ae039)) {
        var animationCfg = $a85a6a2869494a29$var$createCompoundPathCSSAnimation(el, attrs, scope);
        if (animationCfg) cssAnimations.push(animationCfg);
        else if (!len) return;
    } else if (!len) return;
    var groupAnimators = {};
    for(var i = 0; i < len; i++){
        var animator = animators[i];
        var cfgArr = [
            animator.getMaxTime() / 1000 + "s"
        ];
        var easing = $a85a6a2869494a29$var$getEasingFunc(animator.getClip().easing);
        var delay = animator.getDelay();
        if (easing) cfgArr.push(easing);
        else cfgArr.push("linear");
        if (delay) cfgArr.push(delay / 1000 + "s");
        if (animator.getLoop()) cfgArr.push("infinite");
        var cfg = cfgArr.join(" ");
        groupAnimators[cfg] = groupAnimators[cfg] || [
            cfg,
            []
        ];
        groupAnimators[cfg][1].push(animator);
    }
    function createSingleCSSAnimation(groupAnimator) {
        var animators = groupAnimator[1];
        var len = animators.length;
        var transformKfs = {};
        var shapeKfs = {};
        var finalKfs = {};
        var animationTimingFunctionAttrName = "animation-timing-function";
        function saveAnimatorTrackToCssKfs(animator, cssKfs, toCssAttrName) {
            var tracks = animator.getTracks();
            var maxTime = animator.getMaxTime();
            for(var k = 0; k < tracks.length; k++){
                var track = tracks[k];
                if (track.needsAnimate()) {
                    var kfs = track.keyframes;
                    var attrName = track.propName;
                    toCssAttrName && (attrName = toCssAttrName(attrName));
                    if (attrName) for(var i = 0; i < kfs.length; i++){
                        var kf = kfs[i];
                        var percent = Math.round(kf.time / maxTime * 100) + "%";
                        var kfEasing = $a85a6a2869494a29$var$getEasingFunc(kf.easing);
                        var rawValue = kf.rawValue;
                        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(rawValue) || (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rawValue)) {
                            cssKfs[percent] = cssKfs[percent] || {};
                            cssKfs[percent][attrName] = kf.rawValue;
                            if (kfEasing) cssKfs[percent][animationTimingFunctionAttrName] = kfEasing;
                        }
                    }
                }
            }
        }
        for(var i = 0; i < len; i++){
            var animator = animators[i];
            var targetProp = animator.targetName;
            if (!targetProp) !onlyShape && saveAnimatorTrackToCssKfs(animator, transformKfs);
            else if (targetProp === "shape") saveAnimatorTrackToCssKfs(animator, shapeKfs);
        }
        for(var percent in transformKfs){
            var transform = {};
            (0, $becf2d727f9cf450$export$234b1c16dfa57d6a)(transform, el);
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(transform, transformKfs[percent]);
            var str = (0, $999d81abec723db8$export$3fe07c0888ff6164)(transform);
            var timingFunction = transformKfs[percent][animationTimingFunctionAttrName];
            finalKfs[percent] = str ? {
                transform: str
            } : {};
            $a85a6a2869494a29$var$setTransformOrigin(finalKfs[percent], transform);
            if (timingFunction) finalKfs[percent][animationTimingFunctionAttrName] = timingFunction;
        }
        var path;
        var canAnimateShape = true;
        for(var percent in shapeKfs){
            finalKfs[percent] = finalKfs[percent] || {};
            var isFirst = !path;
            var timingFunction = shapeKfs[percent][animationTimingFunctionAttrName];
            if (isFirst) path = new (0, $20ebe2448f123f2e$export$2e2bcd8739ae039)();
            var len_1 = path.len();
            path.reset();
            finalKfs[percent].d = $a85a6a2869494a29$var$buildPathString(el, shapeKfs[percent], path);
            var newLen = path.len();
            if (!isFirst && len_1 !== newLen) {
                canAnimateShape = false;
                break;
            }
            if (timingFunction) finalKfs[percent][animationTimingFunctionAttrName] = timingFunction;
        }
        if (!canAnimateShape) for(var percent in finalKfs)delete finalKfs[percent].d;
        if (!onlyShape) for(var i = 0; i < len; i++){
            var animator = animators[i];
            var targetProp = animator.targetName;
            if (targetProp === "style") saveAnimatorTrackToCssKfs(animator, finalKfs, function(propName) {
                return $a85a6a2869494a29$export$f0dede2064ee89d7[propName];
            });
        }
        var percents = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(finalKfs);
        var allTransformOriginSame = true;
        var transformOrigin;
        for(var i = 1; i < percents.length; i++){
            var p0 = percents[i - 1];
            var p1 = percents[i];
            if (finalKfs[p0][$a85a6a2869494a29$var$transformOriginKey] !== finalKfs[p1][$a85a6a2869494a29$var$transformOriginKey]) {
                allTransformOriginSame = false;
                break;
            }
            transformOrigin = finalKfs[p0][$a85a6a2869494a29$var$transformOriginKey];
        }
        if (allTransformOriginSame && transformOrigin) {
            for(var percent in finalKfs)if (finalKfs[percent][$a85a6a2869494a29$var$transformOriginKey]) delete finalKfs[percent][$a85a6a2869494a29$var$transformOriginKey];
            attrs[$a85a6a2869494a29$var$transformOriginKey] = transformOrigin;
        }
        if ((0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(percents, function(percent) {
            return (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(finalKfs[percent]).length > 0;
        }).length) {
            var animationName = $a85a6a2869494a29$var$addAnimation(finalKfs, scope);
            return animationName + " " + groupAnimator[0] + " both";
        }
    }
    for(var key in groupAnimators){
        var animationCfg = createSingleCSSAnimation(groupAnimators[key]);
        if (animationCfg) cssAnimations.push(animationCfg);
    }
    if (cssAnimations.length) {
        var className = scope.zrId + "-cls-" + (0, $849cb89161be4359$export$9c80c36b7367fb56)();
        scope.cssNodes["." + className] = {
            animation: cssAnimations.join(",")
        };
        attrs["class"] = className;
    }
}






function $05e38a5f94c3c427$export$b4c8f742d3cb22ba(el, attrs, scope) {
    if (!el.ignore) {
        if (el.isSilent()) {
            var style = {
                "pointer-events": "none"
            };
            $05e38a5f94c3c427$var$setClassAttribute(style, attrs, scope, true);
        } else {
            var emphasisStyle = el.states.emphasis && el.states.emphasis.style ? el.states.emphasis.style : {};
            var fill = emphasisStyle.fill;
            if (!fill) {
                var normalFill = el.style && el.style.fill;
                var selectFill = el.states.select && el.states.select.style && el.states.select.style.fill;
                var fromFill = el.currentStates.indexOf("select") >= 0 ? selectFill || normalFill : normalFill;
                if (fromFill) fill = (0, $2c037f5bda6341ca$export$2b47e247dfb87a73)(fromFill);
            }
            var lineWidth = emphasisStyle.lineWidth;
            if (lineWidth) {
                var scaleX = !emphasisStyle.strokeNoScale && el.transform ? el.transform[0] : 1;
                lineWidth = lineWidth / scaleX;
            }
            var style = {
                cursor: "pointer"
            };
            if (fill) style.fill = fill;
            if (emphasisStyle.stroke) style.stroke = emphasisStyle.stroke;
            if (lineWidth) style["stroke-width"] = lineWidth;
            $05e38a5f94c3c427$var$setClassAttribute(style, attrs, scope, true);
        }
    }
}
function $05e38a5f94c3c427$var$setClassAttribute(style, attrs, scope, withHover) {
    var styleKey = JSON.stringify(style);
    var className = scope.cssStyleCache[styleKey];
    if (!className) {
        className = scope.zrId + "-cls-" + (0, $849cb89161be4359$export$9c80c36b7367fb56)();
        scope.cssStyleCache[styleKey] = className;
        scope.cssNodes["." + className + (withHover ? ":hover" : "")] = style;
    }
    attrs["class"] = attrs["class"] ? attrs["class"] + " " + className : className;
}



var $5a7f1b53a6723dcf$var$round = Math.round;
function $5a7f1b53a6723dcf$var$isImageLike(val) {
    return val && (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(val.src);
}
function $5a7f1b53a6723dcf$var$isCanvasLike(val) {
    return val && (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(val.toDataURL);
}
function $5a7f1b53a6723dcf$var$setStyleAttrs(attrs, style, el, scope) {
    (0, $6f6b3090476bfa7b$export$2e2bcd8739ae039)(function(key, val) {
        var isFillStroke = key === "fill" || key === "stroke";
        if (isFillStroke && (0, $999d81abec723db8$export$545e02bbd5f8fe95)(val)) $5a7f1b53a6723dcf$export$afaa8352c6a43a44(style, attrs, key, scope);
        else if (isFillStroke && (0, $999d81abec723db8$export$41a28f5a000a9d0f)(val)) $5a7f1b53a6723dcf$export$faed90dbedc3b6d5(el, attrs, key, scope);
        else attrs[key] = val;
        if (isFillStroke && scope.ssr && val === "none") attrs["pointer-events"] = "visible";
    }, style, el, false);
    $5a7f1b53a6723dcf$var$setShadow(el, attrs, scope);
}
function $5a7f1b53a6723dcf$var$setMetaData(attrs, el) {
    var metaData = (0, $6eba88f9eebe6af9$export$dd7015a5412ca583)(el);
    if (metaData) {
        metaData.each(function(val, key) {
            val != null && (attrs[((0, $f6ad3c9e333d7ffc$export$d3f79611f155197c) + key).toLowerCase()] = val + "");
        });
        if (el.isSilent()) attrs[(0, $f6ad3c9e333d7ffc$export$d3f79611f155197c) + "silent"] = "true";
    }
}
function $5a7f1b53a6723dcf$var$noRotateScale(m) {
    return (0, $999d81abec723db8$export$4701367f5b4de464)(m[0] - 1) && (0, $999d81abec723db8$export$4701367f5b4de464)(m[1]) && (0, $999d81abec723db8$export$4701367f5b4de464)(m[2]) && (0, $999d81abec723db8$export$4701367f5b4de464)(m[3] - 1);
}
function $5a7f1b53a6723dcf$var$noTranslate(m) {
    return (0, $999d81abec723db8$export$4701367f5b4de464)(m[4]) && (0, $999d81abec723db8$export$4701367f5b4de464)(m[5]);
}
function $5a7f1b53a6723dcf$var$setTransform(attrs, m, compress) {
    if (m && !($5a7f1b53a6723dcf$var$noTranslate(m) && $5a7f1b53a6723dcf$var$noRotateScale(m))) {
        var mul = compress ? 10 : 1e4;
        attrs.transform = $5a7f1b53a6723dcf$var$noRotateScale(m) ? "translate(" + $5a7f1b53a6723dcf$var$round(m[4] * mul) / mul + " " + $5a7f1b53a6723dcf$var$round(m[5] * mul) / mul + ")" : (0, $999d81abec723db8$export$f29a4456cf56ff21)(m);
    }
}
function $5a7f1b53a6723dcf$var$convertPolyShape(shape, attrs, mul) {
    var points = shape.points;
    var strArr = [];
    for(var i = 0; i < points.length; i++){
        strArr.push($5a7f1b53a6723dcf$var$round(points[i][0] * mul) / mul);
        strArr.push($5a7f1b53a6723dcf$var$round(points[i][1] * mul) / mul);
    }
    attrs.points = strArr.join(" ");
}
function $5a7f1b53a6723dcf$var$validatePolyShape(shape) {
    return !shape.smooth;
}
function $5a7f1b53a6723dcf$var$createAttrsConvert(desc) {
    var normalizedDesc = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(desc, function(item) {
        return typeof item === "string" ? [
            item,
            item
        ] : item;
    });
    return function(shape, attrs, mul) {
        for(var i = 0; i < normalizedDesc.length; i++){
            var item = normalizedDesc[i];
            var val = shape[item[0]];
            if (val != null) attrs[item[1]] = $5a7f1b53a6723dcf$var$round(val * mul) / mul;
        }
    };
}
var $5a7f1b53a6723dcf$var$builtinShapesDef = {
    circle: [
        $5a7f1b53a6723dcf$var$createAttrsConvert([
            "cx",
            "cy",
            "r"
        ])
    ],
    polyline: [
        $5a7f1b53a6723dcf$var$convertPolyShape,
        $5a7f1b53a6723dcf$var$validatePolyShape
    ],
    polygon: [
        $5a7f1b53a6723dcf$var$convertPolyShape,
        $5a7f1b53a6723dcf$var$validatePolyShape
    ]
};
function $5a7f1b53a6723dcf$var$hasShapeAnimation(el) {
    var animators = el.animators;
    for(var i = 0; i < animators.length; i++){
        if (animators[i].targetName === "shape") return true;
    }
    return false;
}
function $5a7f1b53a6723dcf$export$1dc017d31b76c55b(el, scope) {
    var style = el.style;
    var shape = el.shape;
    var builtinShpDef = $5a7f1b53a6723dcf$var$builtinShapesDef[el.type];
    var attrs = {};
    var needsAnimate = scope.animation;
    var svgElType = "path";
    var strokePercent = el.style.strokePercent;
    var precision = scope.compress && (0, $999d81abec723db8$export$93fa1ae8a509371c)(el) || 4;
    if (builtinShpDef && !scope.willUpdate && !(builtinShpDef[1] && !builtinShpDef[1](shape)) && !(needsAnimate && $5a7f1b53a6723dcf$var$hasShapeAnimation(el)) && !(strokePercent < 1)) {
        svgElType = el.type;
        var mul = Math.pow(10, precision);
        builtinShpDef[0](shape, attrs, mul);
    } else {
        var needBuildPath = !el.path || el.shapeChanged();
        if (!el.path) el.createPathProxy();
        var path = el.path;
        if (needBuildPath) {
            path.beginPath();
            el.buildPath(path, el.shape);
            el.pathUpdated();
        }
        var pathVersion = path.getVersion();
        var elExt = el;
        var svgPathBuilder = elExt.__svgPathBuilder;
        if (elExt.__svgPathVersion !== pathVersion || !svgPathBuilder || strokePercent !== elExt.__svgPathStrokePercent) {
            if (!svgPathBuilder) svgPathBuilder = elExt.__svgPathBuilder = new (0, $c8b2ce72d2349eb5$export$2e2bcd8739ae039)();
            svgPathBuilder.reset(precision);
            path.rebuildPath(svgPathBuilder, strokePercent);
            svgPathBuilder.generateStr();
            elExt.__svgPathVersion = pathVersion;
            elExt.__svgPathStrokePercent = strokePercent;
        }
        attrs.d = svgPathBuilder.getStr();
    }
    $5a7f1b53a6723dcf$var$setTransform(attrs, el.transform);
    $5a7f1b53a6723dcf$var$setStyleAttrs(attrs, style, el, scope);
    $5a7f1b53a6723dcf$var$setMetaData(attrs, el);
    scope.animation && (0, $a85a6a2869494a29$export$dc9722e37397d426)(el, attrs, scope);
    scope.emphasis && (0, $05e38a5f94c3c427$export$b4c8f742d3cb22ba)(el, attrs, scope);
    return (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)(svgElType, el.id + "", attrs);
}
function $5a7f1b53a6723dcf$export$a35ef46dc8240635(el, scope) {
    var style = el.style;
    var image = style.image;
    if (image && !(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(image)) {
        if ($5a7f1b53a6723dcf$var$isImageLike(image)) image = image.src;
        else if ($5a7f1b53a6723dcf$var$isCanvasLike(image)) image = image.toDataURL();
    }
    if (!image) return;
    var x = style.x || 0;
    var y = style.y || 0;
    var dw = style.width;
    var dh = style.height;
    var attrs = {
        href: image,
        width: dw,
        height: dh
    };
    if (x) attrs.x = x;
    if (y) attrs.y = y;
    $5a7f1b53a6723dcf$var$setTransform(attrs, el.transform);
    $5a7f1b53a6723dcf$var$setStyleAttrs(attrs, style, el, scope);
    $5a7f1b53a6723dcf$var$setMetaData(attrs, el);
    scope.animation && (0, $a85a6a2869494a29$export$dc9722e37397d426)(el, attrs, scope);
    return (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("image", el.id + "", attrs);
}
function $5a7f1b53a6723dcf$export$d506f5385e62a84a(el, scope) {
    var style = el.style;
    var text = style.text;
    text != null && (text += "");
    if (!text || isNaN(style.x) || isNaN(style.y)) return;
    var font = style.font || (0, $c6341dcc9d86826e$export$7d7a232b6d2cc80c);
    var x = style.x || 0;
    var y = (0, $999d81abec723db8$export$bf7d6802d2badd9)(style.y || 0, (0, $6c308355c7107803$export$56204a27a2958a55)(font), style.textBaseline);
    var textAlign = (0, $999d81abec723db8$export$4062150f0600d971)[style.textAlign] || style.textAlign;
    var attrs = {
        "dominant-baseline": "central",
        "text-anchor": textAlign
    };
    if ((0, $fe885cc21795562b$export$4685c95d5118e76a)(style)) {
        var separatedFontStr = "";
        var fontStyle = style.fontStyle;
        var fontSize = (0, $fe885cc21795562b$export$51b066d9cfc2578e)(style.fontSize);
        if (!parseFloat(fontSize)) return;
        var fontFamily = style.fontFamily || (0, $c6341dcc9d86826e$export$2653e0d5dd45b294);
        var fontWeight = style.fontWeight;
        separatedFontStr += "font-size:" + fontSize + ";font-family:" + fontFamily + ";";
        if (fontStyle && fontStyle !== "normal") separatedFontStr += "font-style:" + fontStyle + ";";
        if (fontWeight && fontWeight !== "normal") separatedFontStr += "font-weight:" + fontWeight + ";";
        attrs.style = separatedFontStr;
    } else attrs.style = "font: " + font;
    if (text.match(/\s/)) attrs["xml:space"] = "preserve";
    if (x) attrs.x = x;
    if (y) attrs.y = y;
    $5a7f1b53a6723dcf$var$setTransform(attrs, el.transform);
    $5a7f1b53a6723dcf$var$setStyleAttrs(attrs, style, el, scope);
    $5a7f1b53a6723dcf$var$setMetaData(attrs, el);
    scope.animation && (0, $a85a6a2869494a29$export$dc9722e37397d426)(el, attrs, scope);
    return (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("text", el.id + "", attrs, undefined, text);
}
function $5a7f1b53a6723dcf$export$da5d6544e8c27bc1(el, scope) {
    if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) return $5a7f1b53a6723dcf$export$1dc017d31b76c55b(el, scope);
    else if (el instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) return $5a7f1b53a6723dcf$export$a35ef46dc8240635(el, scope);
    else if (el instanceof (0, $c9d5c769fe2f591f$export$2e2bcd8739ae039)) return $5a7f1b53a6723dcf$export$d506f5385e62a84a(el, scope);
}
function $5a7f1b53a6723dcf$var$setShadow(el, attrs, scope) {
    var style = el.style;
    if ((0, $999d81abec723db8$export$c62076b3a966c94b)(style)) {
        var shadowKey = (0, $999d81abec723db8$export$9e4c657be710688a)(el);
        var shadowCache = scope.shadowCache;
        var shadowId = shadowCache[shadowKey];
        if (!shadowId) {
            var globalScale = el.getGlobalScale();
            var scaleX = globalScale[0];
            var scaleY = globalScale[1];
            if (!scaleX || !scaleY) return;
            var offsetX = style.shadowOffsetX || 0;
            var offsetY = style.shadowOffsetY || 0;
            var blur_1 = style.shadowBlur;
            var _a = (0, $999d81abec723db8$export$4cde5df63f53f473)(style.shadowColor), opacity = _a.opacity, color = _a.color;
            var stdDx = blur_1 / 2 / scaleX;
            var stdDy = blur_1 / 2 / scaleY;
            var stdDeviation = stdDx + " " + stdDy;
            shadowId = scope.zrId + "-s" + scope.shadowIdx++;
            scope.defs[shadowId] = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("filter", shadowId, {
                "id": shadowId,
                "x": "-100%",
                "y": "-100%",
                "width": "300%",
                "height": "300%"
            }, [
                (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("feDropShadow", "", {
                    "dx": offsetX / scaleX,
                    "dy": offsetY / scaleY,
                    "stdDeviation": stdDeviation,
                    "flood-color": color,
                    "flood-opacity": opacity
                })
            ]);
            shadowCache[shadowKey] = shadowId;
        }
        attrs.filter = (0, $999d81abec723db8$export$bb094196179998a5)(shadowId);
    }
}
function $5a7f1b53a6723dcf$export$afaa8352c6a43a44(style, attrs, target, scope) {
    var val = style[target];
    var gradientTag;
    var gradientAttrs = {
        "gradientUnits": val.global ? "userSpaceOnUse" : "objectBoundingBox"
    };
    if ((0, $999d81abec723db8$export$7d961bca9d3b47d0)(val)) {
        gradientTag = "linearGradient";
        gradientAttrs.x1 = val.x;
        gradientAttrs.y1 = val.y;
        gradientAttrs.x2 = val.x2;
        gradientAttrs.y2 = val.y2;
    } else if ((0, $999d81abec723db8$export$2a9cca6692a0ce3a)(val)) {
        gradientTag = "radialGradient";
        gradientAttrs.cx = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(val.x, 0.5);
        gradientAttrs.cy = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(val.y, 0.5);
        gradientAttrs.r = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(val.r, 0.5);
    } else return;
    var colors = val.colorStops;
    var colorStops = [];
    for(var i = 0, len = colors.length; i < len; ++i){
        var offset = (0, $999d81abec723db8$export$52bfc6d3e2ff0fc2)(colors[i].offset) * 100 + "%";
        var stopColor = colors[i].color;
        var _a = (0, $999d81abec723db8$export$4cde5df63f53f473)(stopColor), color = _a.color, opacity = _a.opacity;
        var stopsAttrs = {
            "offset": offset
        };
        stopsAttrs["stop-color"] = color;
        if (opacity < 1) stopsAttrs["stop-opacity"] = opacity;
        colorStops.push((0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("stop", i + "", stopsAttrs));
    }
    var gradientVNode = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)(gradientTag, "", gradientAttrs, colorStops);
    var gradientKey = (0, $f6ad3c9e333d7ffc$export$f5c4a9a0e027f2b)(gradientVNode);
    var gradientCache = scope.gradientCache;
    var gradientId = gradientCache[gradientKey];
    if (!gradientId) {
        gradientId = scope.zrId + "-g" + scope.gradientIdx++;
        gradientCache[gradientKey] = gradientId;
        gradientAttrs.id = gradientId;
        scope.defs[gradientId] = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)(gradientTag, gradientId, gradientAttrs, colorStops);
    }
    attrs[target] = (0, $999d81abec723db8$export$bb094196179998a5)(gradientId);
}
function $5a7f1b53a6723dcf$export$faed90dbedc3b6d5(el, attrs, target, scope) {
    var val = el.style[target];
    var boundingRect = el.getBoundingRect();
    var patternAttrs = {};
    var repeat = val.repeat;
    var noRepeat = repeat === "no-repeat";
    var repeatX = repeat === "repeat-x";
    var repeatY = repeat === "repeat-y";
    var child;
    if ((0, $999d81abec723db8$export$2ade673ac4f85dfe)(val)) {
        var imageWidth_1 = val.imageWidth;
        var imageHeight_1 = val.imageHeight;
        var imageSrc = void 0;
        var patternImage = val.image;
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(patternImage)) imageSrc = patternImage;
        else if ($5a7f1b53a6723dcf$var$isImageLike(patternImage)) imageSrc = patternImage.src;
        else if ($5a7f1b53a6723dcf$var$isCanvasLike(patternImage)) imageSrc = patternImage.toDataURL();
        if (typeof Image === "undefined") {
            var errMsg = "Image width/height must been given explictly in svg-ssr renderer.";
            (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(imageWidth_1, errMsg);
            (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(imageHeight_1, errMsg);
        } else if (imageWidth_1 == null || imageHeight_1 == null) {
            var setSizeToVNode_1 = function(vNode, img) {
                if (vNode) {
                    var svgEl = vNode.elm;
                    var width = imageWidth_1 || img.width;
                    var height = imageHeight_1 || img.height;
                    if (vNode.tag === "pattern") {
                        if (repeatX) {
                            height = 1;
                            width /= boundingRect.width;
                        } else if (repeatY) {
                            width = 1;
                            height /= boundingRect.height;
                        }
                    }
                    vNode.attrs.width = width;
                    vNode.attrs.height = height;
                    if (svgEl) {
                        svgEl.setAttribute("width", width);
                        svgEl.setAttribute("height", height);
                    }
                }
            };
            var createdImage = (0, $a53bd598adfb7ebe$export$46c791b69ff9a0f)(imageSrc, null, el, function(img) {
                noRepeat || setSizeToVNode_1(patternVNode, img);
                setSizeToVNode_1(child, img);
            });
            if (createdImage && createdImage.width && createdImage.height) {
                imageWidth_1 = imageWidth_1 || createdImage.width;
                imageHeight_1 = imageHeight_1 || createdImage.height;
            }
        }
        child = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("image", "img", {
            href: imageSrc,
            width: imageWidth_1,
            height: imageHeight_1
        });
        patternAttrs.width = imageWidth_1;
        patternAttrs.height = imageHeight_1;
    } else if (val.svgElement) {
        child = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(val.svgElement);
        patternAttrs.width = val.svgWidth;
        patternAttrs.height = val.svgHeight;
    }
    if (!child) return;
    var patternWidth;
    var patternHeight;
    if (noRepeat) patternWidth = patternHeight = 1;
    else if (repeatX) {
        patternHeight = 1;
        patternWidth = patternAttrs.width / boundingRect.width;
    } else if (repeatY) {
        patternWidth = 1;
        patternHeight = patternAttrs.height / boundingRect.height;
    } else patternAttrs.patternUnits = "userSpaceOnUse";
    if (patternWidth != null && !isNaN(patternWidth)) patternAttrs.width = patternWidth;
    if (patternHeight != null && !isNaN(patternHeight)) patternAttrs.height = patternHeight;
    var patternTransform = (0, $999d81abec723db8$export$3fe07c0888ff6164)(val);
    patternTransform && (patternAttrs.patternTransform = patternTransform);
    var patternVNode = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("pattern", "", patternAttrs, [
        child
    ]);
    var patternKey = (0, $f6ad3c9e333d7ffc$export$f5c4a9a0e027f2b)(patternVNode);
    var patternCache = scope.patternCache;
    var patternId = patternCache[patternKey];
    if (!patternId) {
        patternId = scope.zrId + "-p" + scope.patternIdx++;
        patternCache[patternKey] = patternId;
        patternAttrs.id = patternId;
        patternVNode = scope.defs[patternId] = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("pattern", patternId, patternAttrs, [
            child
        ]);
    }
    attrs[target] = (0, $999d81abec723db8$export$bb094196179998a5)(patternId);
}
function $5a7f1b53a6723dcf$export$8f1d80b445d4fc(clipPath, attrs, scope) {
    var clipPathCache = scope.clipPathCache, defs = scope.defs;
    var clipPathId = clipPathCache[clipPath.id];
    if (!clipPathId) {
        clipPathId = scope.zrId + "-c" + scope.clipPathIdx++;
        var clipPathAttrs = {
            id: clipPathId
        };
        clipPathCache[clipPath.id] = clipPathId;
        defs[clipPathId] = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("clipPath", clipPathId, clipPathAttrs, [
            $5a7f1b53a6723dcf$export$1dc017d31b76c55b(clipPath, scope)
        ]);
    }
    attrs["clip-path"] = (0, $999d81abec723db8$export$bb094196179998a5)(clipPathId);
}







function $a4f5b07c584c2741$export$b2ce9ad90858ed7a(text) {
    return document.createTextNode(text);
}
function $a4f5b07c584c2741$export$2a15b079e3f46654(text) {
    return document.createComment(text);
}
function $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
}
function $a4f5b07c584c2741$export$7ae609f7af59e4f7(node, child) {
    node.removeChild(child);
}
function $a4f5b07c584c2741$export$1b8e57c9ea42f1d2(node, child) {
    node.appendChild(child);
}
function $a4f5b07c584c2741$export$b54be7ce267a037b(node) {
    return node.parentNode;
}
function $a4f5b07c584c2741$export$335219007e689d29(node) {
    return node.nextSibling;
}
function $a4f5b07c584c2741$export$45e0b80f1e500bd4(elm) {
    return elm.tagName;
}
function $a4f5b07c584c2741$export$94b0296cab6203e(node, text) {
    node.textContent = text;
}
function $a4f5b07c584c2741$export$132e79e4118a78e0(node) {
    return node.textContent;
}
function $a4f5b07c584c2741$export$45a5e7f76e0caa8d(node) {
    return node.nodeType === 1;
}
function $a4f5b07c584c2741$export$1879817ac5c922b7(node) {
    return node.nodeType === 3;
}
function $a4f5b07c584c2741$export$3ab01370f5e64ac8(node) {
    return node.nodeType === 8;
}


var $57ac702d7860318b$var$colonChar = 58;
var $57ac702d7860318b$var$xChar = 120;
var $57ac702d7860318b$var$emptyNode = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("", "");
function $57ac702d7860318b$var$isUndef(s) {
    return s === undefined;
}
function $57ac702d7860318b$var$isDef(s) {
    return s !== undefined;
}
function $57ac702d7860318b$var$createKeyToOldIdx(children, beginIdx, endIdx) {
    var map = {};
    for(var i = beginIdx; i <= endIdx; ++i){
        var key = children[i].key;
        if (key !== undefined) map[key] = i;
    }
    return map;
}
function $57ac702d7860318b$var$sameVnode(vnode1, vnode2) {
    var isSameKey = vnode1.key === vnode2.key;
    var isSameTag = vnode1.tag === vnode2.tag;
    return isSameTag && isSameKey;
}
function $57ac702d7860318b$var$createElm(vnode) {
    var i;
    var children = vnode.children;
    var tag = vnode.tag;
    if ($57ac702d7860318b$var$isDef(tag)) {
        var elm = vnode.elm = (0, $f6ad3c9e333d7ffc$export$c8a8987d4410bf2d)(tag);
        $57ac702d7860318b$export$277dcc6f06048f24($57ac702d7860318b$var$emptyNode, vnode);
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(children)) for(i = 0; i < children.length; ++i){
            var ch = children[i];
            if (ch != null) $a4f5b07c584c2741$export$1b8e57c9ea42f1d2(elm, $57ac702d7860318b$var$createElm(ch));
        }
        else if ($57ac702d7860318b$var$isDef(vnode.text) && !(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(vnode.text)) $a4f5b07c584c2741$export$1b8e57c9ea42f1d2(elm, $a4f5b07c584c2741$export$b2ce9ad90858ed7a(vnode.text));
    } else vnode.elm = $a4f5b07c584c2741$export$b2ce9ad90858ed7a(vnode.text);
    return vnode.elm;
}
function $57ac702d7860318b$var$addVnodes(parentElm, before, vnodes, startIdx, endIdx) {
    for(; startIdx <= endIdx; ++startIdx){
        var ch = vnodes[startIdx];
        if (ch != null) $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentElm, $57ac702d7860318b$var$createElm(ch), before);
    }
}
function $57ac702d7860318b$var$removeVnodes(parentElm, vnodes, startIdx, endIdx) {
    for(; startIdx <= endIdx; ++startIdx){
        var ch = vnodes[startIdx];
        if (ch != null) {
            if ($57ac702d7860318b$var$isDef(ch.tag)) {
                var parent_1 = $a4f5b07c584c2741$export$b54be7ce267a037b(ch.elm);
                $a4f5b07c584c2741$export$7ae609f7af59e4f7(parent_1, ch.elm);
            } else $a4f5b07c584c2741$export$7ae609f7af59e4f7(parentElm, ch.elm);
        }
    }
}
function $57ac702d7860318b$export$277dcc6f06048f24(oldVnode, vnode) {
    var key;
    var elm = vnode.elm;
    var oldAttrs = oldVnode && oldVnode.attrs || {};
    var attrs = vnode.attrs || {};
    if (oldAttrs === attrs) return;
    for(key in attrs){
        var cur = attrs[key];
        var old = oldAttrs[key];
        if (old !== cur) {
            if (cur === true) elm.setAttribute(key, "");
            else if (cur === false) elm.removeAttribute(key);
            else {
                if (key === "style") elm.style.cssText = cur;
                else if (key.charCodeAt(0) !== $57ac702d7860318b$var$xChar) elm.setAttribute(key, cur);
                else if (key === "xmlns:xlink" || key === "xmlns") elm.setAttributeNS((0, $f6ad3c9e333d7ffc$export$fac09d762d15fa3b), key, cur);
                else if (key.charCodeAt(3) === $57ac702d7860318b$var$colonChar) elm.setAttributeNS((0, $f6ad3c9e333d7ffc$export$ad4c4fdecd3b4156), key, cur);
                else if (key.charCodeAt(5) === $57ac702d7860318b$var$colonChar) elm.setAttributeNS((0, $f6ad3c9e333d7ffc$export$b22c6da1792ecec8), key, cur);
                else elm.setAttribute(key, cur);
            }
        }
    }
    for(key in oldAttrs)if (!(key in attrs)) elm.removeAttribute(key);
}
function $57ac702d7860318b$var$updateChildren(parentElm, oldCh, newCh) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx;
    var idxInOld;
    var elmToMove;
    var before;
    while(oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx){
        if (oldStartVnode == null) oldStartVnode = oldCh[++oldStartIdx];
        else if (oldEndVnode == null) oldEndVnode = oldCh[--oldEndIdx];
        else if (newStartVnode == null) newStartVnode = newCh[++newStartIdx];
        else if (newEndVnode == null) newEndVnode = newCh[--newEndIdx];
        else if ($57ac702d7860318b$var$sameVnode(oldStartVnode, newStartVnode)) {
            $57ac702d7860318b$var$patchVnode(oldStartVnode, newStartVnode);
            oldStartVnode = oldCh[++oldStartIdx];
            newStartVnode = newCh[++newStartIdx];
        } else if ($57ac702d7860318b$var$sameVnode(oldEndVnode, newEndVnode)) {
            $57ac702d7860318b$var$patchVnode(oldEndVnode, newEndVnode);
            oldEndVnode = oldCh[--oldEndIdx];
            newEndVnode = newCh[--newEndIdx];
        } else if ($57ac702d7860318b$var$sameVnode(oldStartVnode, newEndVnode)) {
            $57ac702d7860318b$var$patchVnode(oldStartVnode, newEndVnode);
            $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentElm, oldStartVnode.elm, $a4f5b07c584c2741$export$335219007e689d29(oldEndVnode.elm));
            oldStartVnode = oldCh[++oldStartIdx];
            newEndVnode = newCh[--newEndIdx];
        } else if ($57ac702d7860318b$var$sameVnode(oldEndVnode, newStartVnode)) {
            $57ac702d7860318b$var$patchVnode(oldEndVnode, newStartVnode);
            $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentElm, oldEndVnode.elm, oldStartVnode.elm);
            oldEndVnode = oldCh[--oldEndIdx];
            newStartVnode = newCh[++newStartIdx];
        } else {
            if ($57ac702d7860318b$var$isUndef(oldKeyToIdx)) oldKeyToIdx = $57ac702d7860318b$var$createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
            idxInOld = oldKeyToIdx[newStartVnode.key];
            if ($57ac702d7860318b$var$isUndef(idxInOld)) $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentElm, $57ac702d7860318b$var$createElm(newStartVnode), oldStartVnode.elm);
            else {
                elmToMove = oldCh[idxInOld];
                if (elmToMove.tag !== newStartVnode.tag) $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentElm, $57ac702d7860318b$var$createElm(newStartVnode), oldStartVnode.elm);
                else {
                    $57ac702d7860318b$var$patchVnode(elmToMove, newStartVnode);
                    oldCh[idxInOld] = undefined;
                    $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentElm, elmToMove.elm, oldStartVnode.elm);
                }
            }
            newStartVnode = newCh[++newStartIdx];
        }
    }
    if (oldStartIdx <= oldEndIdx || newStartIdx <= newEndIdx) {
        if (oldStartIdx > oldEndIdx) {
            before = newCh[newEndIdx + 1] == null ? null : newCh[newEndIdx + 1].elm;
            $57ac702d7860318b$var$addVnodes(parentElm, before, newCh, newStartIdx, newEndIdx);
        } else $57ac702d7860318b$var$removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
}
function $57ac702d7860318b$var$patchVnode(oldVnode, vnode) {
    var elm = vnode.elm = oldVnode.elm;
    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (oldVnode === vnode) return;
    $57ac702d7860318b$export$277dcc6f06048f24(oldVnode, vnode);
    if ($57ac702d7860318b$var$isUndef(vnode.text)) {
        if ($57ac702d7860318b$var$isDef(oldCh) && $57ac702d7860318b$var$isDef(ch)) {
            if (oldCh !== ch) $57ac702d7860318b$var$updateChildren(elm, oldCh, ch);
        } else if ($57ac702d7860318b$var$isDef(ch)) {
            if ($57ac702d7860318b$var$isDef(oldVnode.text)) $a4f5b07c584c2741$export$94b0296cab6203e(elm, "");
            $57ac702d7860318b$var$addVnodes(elm, null, ch, 0, ch.length - 1);
        } else if ($57ac702d7860318b$var$isDef(oldCh)) $57ac702d7860318b$var$removeVnodes(elm, oldCh, 0, oldCh.length - 1);
        else if ($57ac702d7860318b$var$isDef(oldVnode.text)) $a4f5b07c584c2741$export$94b0296cab6203e(elm, "");
    } else if (oldVnode.text !== vnode.text) {
        if ($57ac702d7860318b$var$isDef(oldCh)) $57ac702d7860318b$var$removeVnodes(elm, oldCh, 0, oldCh.length - 1);
        $a4f5b07c584c2741$export$94b0296cab6203e(elm, vnode.text);
    }
}
function $57ac702d7860318b$export$2e2bcd8739ae039(oldVnode, vnode) {
    if ($57ac702d7860318b$var$sameVnode(oldVnode, vnode)) $57ac702d7860318b$var$patchVnode(oldVnode, vnode);
    else {
        var elm = oldVnode.elm;
        var parent_2 = $a4f5b07c584c2741$export$b54be7ce267a037b(elm);
        $57ac702d7860318b$var$createElm(vnode);
        if (parent_2 !== null) {
            $a4f5b07c584c2741$export$86b68c7dbeb53c22(parent_2, vnode.elm, $a4f5b07c584c2741$export$335219007e689d29(elm));
            $57ac702d7860318b$var$removeVnodes(parent_2, [
                oldVnode
            ], 0, 0);
        }
    }
    return vnode;
}



var $c7b90ea532fd792a$var$svgId = 0;
var $c7b90ea532fd792a$var$SVGPainter = function() {
    function SVGPainter(root, storage, opts) {
        this.type = "svg";
        this.refreshHover = $c7b90ea532fd792a$var$createMethodNotSupport("refreshHover");
        this.configLayer = $c7b90ea532fd792a$var$createMethodNotSupport("configLayer");
        this.storage = storage;
        this._opts = opts = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, opts);
        this.root = root;
        this._id = "zr" + $c7b90ea532fd792a$var$svgId++;
        this._oldVNode = (0, $f6ad3c9e333d7ffc$export$5529a6aad332ee75)(opts.width, opts.height);
        if (root && !opts.ssr) {
            var viewport = this._viewport = document.createElement("div");
            viewport.style.cssText = "position:relative;overflow:hidden";
            var svgDom = this._svgDom = this._oldVNode.elm = (0, $f6ad3c9e333d7ffc$export$c8a8987d4410bf2d)("svg");
            (0, $57ac702d7860318b$export$277dcc6f06048f24)(null, this._oldVNode);
            viewport.appendChild(svgDom);
            root.appendChild(viewport);
        }
        this.resize(opts.width, opts.height);
    }
    SVGPainter.prototype.getType = function() {
        return this.type;
    };
    SVGPainter.prototype.getViewportRoot = function() {
        return this._viewport;
    };
    SVGPainter.prototype.getViewportRootOffset = function() {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) return {
            offsetLeft: viewportRoot.offsetLeft || 0,
            offsetTop: viewportRoot.offsetTop || 0
        };
    };
    SVGPainter.prototype.getSvgDom = function() {
        return this._svgDom;
    };
    SVGPainter.prototype.refresh = function() {
        if (this.root) {
            var vnode = this.renderToVNode({
                willUpdate: true
            });
            vnode.attrs.style = "position:absolute;left:0;top:0;user-select:none";
            (0, $57ac702d7860318b$export$2e2bcd8739ae039)(this._oldVNode, vnode);
            this._oldVNode = vnode;
        }
    };
    SVGPainter.prototype.renderOneToVNode = function(el) {
        return (0, $5a7f1b53a6723dcf$export$da5d6544e8c27bc1)(el, (0, $f6ad3c9e333d7ffc$export$96fee5f38ed01741)(this._id));
    };
    SVGPainter.prototype.renderToVNode = function(opts) {
        opts = opts || {};
        var list = this.storage.getDisplayList(true);
        var width = this._width;
        var height = this._height;
        var scope = (0, $f6ad3c9e333d7ffc$export$96fee5f38ed01741)(this._id);
        scope.animation = opts.animation;
        scope.willUpdate = opts.willUpdate;
        scope.compress = opts.compress;
        scope.emphasis = opts.emphasis;
        scope.ssr = this._opts.ssr;
        var children = [];
        var bgVNode = this._bgVNode = $c7b90ea532fd792a$var$createBackgroundVNode(width, height, this._backgroundColor, scope);
        bgVNode && children.push(bgVNode);
        var mainVNode = !opts.compress ? this._mainVNode = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("g", "main", {}, []) : null;
        this._paintList(list, scope, mainVNode ? mainVNode.children : children);
        mainVNode && children.push(mainVNode);
        var defs = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(scope.defs), function(id) {
            return scope.defs[id];
        });
        if (defs.length) children.push((0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("defs", "defs", {}, defs));
        if (opts.animation) {
            var animationCssStr = (0, $f6ad3c9e333d7ffc$export$e2b4f3597c7a7dcb)(scope.cssNodes, scope.cssAnims, {
                newline: true
            });
            if (animationCssStr) {
                var styleNode = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("style", "stl", {}, [], animationCssStr);
                children.push(styleNode);
            }
        }
        return (0, $f6ad3c9e333d7ffc$export$5529a6aad332ee75)(width, height, children, opts.useViewBox);
    };
    SVGPainter.prototype.renderToString = function(opts) {
        opts = opts || {};
        return (0, $f6ad3c9e333d7ffc$export$f5c4a9a0e027f2b)(this.renderToVNode({
            animation: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(opts.cssAnimation, true),
            emphasis: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(opts.cssEmphasis, true),
            willUpdate: false,
            compress: true,
            useViewBox: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(opts.useViewBox, true)
        }), {
            newline: true
        });
    };
    SVGPainter.prototype.setBackgroundColor = function(backgroundColor) {
        this._backgroundColor = backgroundColor;
    };
    SVGPainter.prototype.getSvgRoot = function() {
        return this._mainVNode && this._mainVNode.elm;
    };
    SVGPainter.prototype._paintList = function(list, scope, out) {
        var listLen = list.length;
        var clipPathsGroupsStack = [];
        var clipPathsGroupsStackDepth = 0;
        var currentClipPathGroup;
        var prevClipPaths;
        var clipGroupNodeIdx = 0;
        for(var i = 0; i < listLen; i++){
            var displayable = list[i];
            if (!displayable.invisible) {
                var clipPaths = displayable.__clipPaths;
                var len = clipPaths && clipPaths.length || 0;
                var prevLen = prevClipPaths && prevClipPaths.length || 0;
                var lca = void 0;
                for(lca = Math.max(len - 1, prevLen - 1); lca >= 0; lca--){
                    if (clipPaths && prevClipPaths && clipPaths[lca] === prevClipPaths[lca]) break;
                }
                for(var i_1 = prevLen - 1; i_1 > lca; i_1--){
                    clipPathsGroupsStackDepth--;
                    currentClipPathGroup = clipPathsGroupsStack[clipPathsGroupsStackDepth - 1];
                }
                for(var i_2 = lca + 1; i_2 < len; i_2++){
                    var groupAttrs = {};
                    (0, $5a7f1b53a6723dcf$export$8f1d80b445d4fc)(clipPaths[i_2], groupAttrs, scope);
                    var g = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("g", "clip-g-" + clipGroupNodeIdx++, groupAttrs, []);
                    (currentClipPathGroup ? currentClipPathGroup.children : out).push(g);
                    clipPathsGroupsStack[clipPathsGroupsStackDepth++] = g;
                    currentClipPathGroup = g;
                }
                prevClipPaths = clipPaths;
                var ret = (0, $5a7f1b53a6723dcf$export$da5d6544e8c27bc1)(displayable, scope);
                if (ret) (currentClipPathGroup ? currentClipPathGroup.children : out).push(ret);
            }
        }
    };
    SVGPainter.prototype.resize = function(width, height) {
        var opts = this._opts;
        var root = this.root;
        var viewport = this._viewport;
        width != null && (opts.width = width);
        height != null && (opts.height = height);
        if (root && viewport) {
            viewport.style.display = "none";
            width = (0, $d76b6507633b3c44$export$31b21d0167753bb4)(root, 0, opts);
            height = (0, $d76b6507633b3c44$export$31b21d0167753bb4)(root, 1, opts);
            viewport.style.display = "";
        }
        if (this._width !== width || this._height !== height) {
            this._width = width;
            this._height = height;
            if (viewport) {
                var viewportStyle = viewport.style;
                viewportStyle.width = width + "px";
                viewportStyle.height = height + "px";
            }
            if (!(0, $999d81abec723db8$export$41a28f5a000a9d0f)(this._backgroundColor)) {
                var svgDom = this._svgDom;
                if (svgDom) {
                    svgDom.setAttribute("width", width);
                    svgDom.setAttribute("height", height);
                }
                var bgEl = this._bgVNode && this._bgVNode.elm;
                if (bgEl) {
                    bgEl.setAttribute("width", width);
                    bgEl.setAttribute("height", height);
                }
            } else this.refresh();
        }
    };
    SVGPainter.prototype.getWidth = function() {
        return this._width;
    };
    SVGPainter.prototype.getHeight = function() {
        return this._height;
    };
    SVGPainter.prototype.dispose = function() {
        if (this.root) this.root.innerHTML = "";
        this._svgDom = this._viewport = this.storage = this._oldVNode = this._bgVNode = this._mainVNode = null;
    };
    SVGPainter.prototype.clear = function() {
        if (this._svgDom) this._svgDom.innerHTML = null;
        this._oldVNode = null;
    };
    SVGPainter.prototype.toDataURL = function(base64) {
        var str = this.renderToString();
        var prefix = "data:image/svg+xml;";
        if (base64) {
            str = (0, $999d81abec723db8$export$8fb536984ec8b4d7)(str);
            return str && prefix + "base64," + str;
        }
        return prefix + "charset=UTF-8," + encodeURIComponent(str);
    };
    return SVGPainter;
}();
function $c7b90ea532fd792a$var$createMethodNotSupport(method) {
    return function() {};
}
function $c7b90ea532fd792a$var$createBackgroundVNode(width, height, backgroundColor, scope) {
    var bgVNode;
    if (backgroundColor && backgroundColor !== "none") {
        bgVNode = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("rect", "bg", {
            width: width,
            height: height,
            x: "0",
            y: "0"
        });
        if ((0, $999d81abec723db8$export$545e02bbd5f8fe95)(backgroundColor)) (0, $5a7f1b53a6723dcf$export$afaa8352c6a43a44)({
            fill: backgroundColor
        }, bgVNode.attrs, "fill", scope);
        else if ((0, $999d81abec723db8$export$41a28f5a000a9d0f)(backgroundColor)) (0, $5a7f1b53a6723dcf$export$faed90dbedc3b6d5)({
            style: {
                fill: backgroundColor
            },
            dirty: (0, $7a1bd9c2710fea0d$export$8793edee2d425525),
            getBoundingRect: function() {
                return {
                    width: width,
                    height: height
                };
            }
        }, bgVNode.attrs, "fill", scope);
        else {
            var _a = (0, $999d81abec723db8$export$4cde5df63f53f473)(backgroundColor), color = _a.color, opacity = _a.opacity;
            bgVNode.attrs.fill = color;
            opacity < 1 && (bgVNode.attrs["fill-opacity"] = opacity);
        }
    }
    return bgVNode;
}
var $c7b90ea532fd792a$export$2e2bcd8739ae039 = $c7b90ea532fd792a$var$SVGPainter;


function $8d8c6eb926bbdd0e$export$4b3e715f166fdd78(registers) {
    registers.registerPainter("svg", (0, $c7b90ea532fd792a$export$2e2bcd8739ae039));
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $85b723b311a86ffc$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $85b723b311a86ffc$var$dimTypeShort = {
    float: "f",
    int: "i",
    ordinal: "o",
    number: "n",
    time: "t"
};
/**
 * Represents the dimension requirement of a series.
 *
 * NOTICE:
 * When there are too many dimensions in dataset and many series, only the used dimensions
 * (i.e., used by coord sys and declared in `series.encode`) are add to `dimensionDefineList`.
 * But users may query data by other unused dimension names.
 * In this case, users can only query data if and only if they have defined dimension names
 * via ec option, so we provide `getDimensionIndexFromSource`, which only query them from
 * `source` dimensions.
 */ var $85b723b311a86ffc$export$a1ef064685775f3e = /** @class */ function() {
    function SeriesDataSchema(opt) {
        this.dimensions = opt.dimensions;
        this._dimOmitted = opt.dimensionOmitted;
        this.source = opt.source;
        this._fullDimCount = opt.fullDimensionCount;
        this._updateDimOmitted(opt.dimensionOmitted);
    }
    SeriesDataSchema.prototype.isDimensionOmitted = function() {
        return this._dimOmitted;
    };
    SeriesDataSchema.prototype._updateDimOmitted = function(dimensionOmitted) {
        this._dimOmitted = dimensionOmitted;
        if (!dimensionOmitted) return;
        if (!this._dimNameMap) this._dimNameMap = $85b723b311a86ffc$export$be39ae17310c33f7(this.source);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Get index by user defined dimension name (i.e., not internal generate name).
   * That is, get index from `dimensionsDefine`.
   * If no `dimensionsDefine`, or no name get, return -1.
   */ SeriesDataSchema.prototype.getSourceDimensionIndex = function(dimName) {
        return (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(this._dimNameMap.get(dimName), -1);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Notice: may return `null`/`undefined` if user not specify dimension names.
   */ SeriesDataSchema.prototype.getSourceDimension = function(dimIndex) {
        var dimensionsDefine = this.source.dimensionsDefine;
        if (dimensionsDefine) return dimensionsDefine[dimIndex];
    };
    SeriesDataSchema.prototype.makeStoreSchema = function() {
        var dimCount = this._fullDimCount;
        var willRetrieveDataByName = (0, $99e22f5c2aa5094b$export$8911336b527f8517)(this.source);
        var makeHashStrict = !$85b723b311a86ffc$export$238b87930d825d87(dimCount);
        // If source don't have dimensions or series don't omit unsed dimensions.
        // Generate from seriesDimList directly
        var dimHash = "";
        var dims = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < dimCount; fullDimIdx++){
            var property = void 0;
            var type = void 0;
            var ordinalMeta = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx];
            // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                property = willRetrieveDataByName ? seriesDimDef.name : null;
                type = seriesDimDef.type;
                ordinalMeta = seriesDimDef.ordinalMeta;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) {
                    property = willRetrieveDataByName ? sourceDimDef.name : null;
                    type = sourceDimDef.type;
                }
            }
            dims.push({
                property: property,
                type: type,
                ordinalMeta: ordinalMeta
            });
            // If retrieving data by index,
            //   use <index, type, ordinalMeta> to determine whether data can be shared.
            //   (Because in this case there might be no dimension name defined in dataset, but indices always exists).
            //   (Indices are always 0, 1, 2, ..., so we can ignore them to shorten the hash).
            // Otherwise if retrieving data by property name (like `data: [{aa: 123, bb: 765}, ...]`),
            //   use <property, type, ordinalMeta> in hash.
            if (willRetrieveDataByName && property != null && (!seriesDimDef || !seriesDimDef.isCalculationCoord)) dimHash += makeHashStrict ? property.replace(/\`/g, "`1").replace(/\$/g, "`2") : property;
            dimHash += "$";
            dimHash += $85b723b311a86ffc$var$dimTypeShort[type] || "f";
            if (ordinalMeta) dimHash += ordinalMeta.uid;
            dimHash += "$";
        }
        // Source from endpoint(usually series) will be read differently
        // when seriesLayoutBy or startIndex(which is affected by sourceHeader) are different.
        // So we use this three props as key.
        var source = this.source;
        var hash = [
            source.seriesLayoutBy,
            source.startIndex,
            dimHash
        ].join("$$");
        return {
            dimensions: dims,
            hash: hash
        };
    };
    SeriesDataSchema.prototype.makeOutputDimensionNames = function() {
        var result = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < this._fullDimCount; fullDimIdx++){
            var name_1 = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx];
            // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                if (!seriesDimDef.isCalculationCoord) name_1 = seriesDimDef.name;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) name_1 = sourceDimDef.name;
            }
            result.push(name_1);
        }
        return result;
    };
    SeriesDataSchema.prototype.appendCalculationDimension = function(dimDef) {
        this.dimensions.push(dimDef);
        dimDef.isCalculationCoord = true;
        this._fullDimCount++;
        // If append dimension on a data store, consider the store
        // might be shared by different series, series dimensions not
        // really map to store dimensions.
        this._updateDimOmitted(true);
    };
    return SeriesDataSchema;
}();
function $85b723b311a86ffc$export$fafbc856132a3a0e(schema) {
    return schema instanceof $85b723b311a86ffc$export$a1ef064685775f3e;
}
function $85b723b311a86ffc$export$a477f5bebfd07944(dimsDef) {
    var dataDimNameMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    for(var i = 0; i < (dimsDef || []).length; i++){
        var dimDefItemRaw = dimsDef[i];
        var userDimName = (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dimDefItemRaw) ? dimDefItemRaw.name : dimDefItemRaw;
        if (userDimName != null && dataDimNameMap.get(userDimName) == null) dataDimNameMap.set(userDimName, i);
    }
    return dataDimNameMap;
}
function $85b723b311a86ffc$export$be39ae17310c33f7(source) {
    var innerSource = $85b723b311a86ffc$var$inner(source);
    return innerSource.dimNameMap || (innerSource.dimNameMap = $85b723b311a86ffc$export$a477f5bebfd07944(source.dimensionsDefine));
}
function $85b723b311a86ffc$export$238b87930d825d87(dimCount) {
    return dimCount > 30;
}


function $efdd976e4917927c$export$f2165f9e8499b278(seriesModel, dimensionsInput, opt) {
    opt = opt || {};
    var byIndex = opt.byIndex;
    var stackedCoordDimension = opt.stackedCoordDimension;
    var dimensionDefineList;
    var schema;
    var store;
    if ($efdd976e4917927c$var$isLegacyDimensionsInput(dimensionsInput)) dimensionDefineList = dimensionsInput;
    else {
        schema = dimensionsInput.schema;
        dimensionDefineList = schema.dimensions;
        store = dimensionsInput.store;
    }
    // Compatibal: when `stack` is set as '', do not stack.
    var mayStack = !!(seriesModel && seriesModel.get("stack"));
    var stackedByDimInfo;
    var stackedDimInfo;
    var stackResultDimension;
    var stackedOverDimension;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dimensionDefineList, function(dimensionInfo, index) {
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(dimensionInfo)) dimensionDefineList[index] = dimensionInfo = {
            name: dimensionInfo
        };
        if (mayStack && !dimensionInfo.isExtraCoord) {
            // Find the first ordinal dimension as the stackedByDimInfo.
            if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) stackedByDimInfo = dimensionInfo;
            // Find the first stackable dimension as the stackedDimInfo.
            if (!stackedDimInfo && dimensionInfo.type !== "ordinal" && dimensionInfo.type !== "time" && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) stackedDimInfo = dimensionInfo;
        }
    });
    if (stackedDimInfo && !byIndex && !stackedByDimInfo) // Compatible with previous design, value axis (time axis) only stack by index.
    // It may make sense if the user provides elaborately constructed data.
    byIndex = true;
    // Add stack dimension, they can be both calculated by coordinate system in `unionExtent`.
    // That put stack logic in List is for using conveniently in echarts extensions, but it
    // might not be a good way.
    if (stackedDimInfo) {
        // Use a weird name that not duplicated with other names.
        // Also need to use seriesModel.id as postfix because different
        // series may share same data store. The stack dimension needs to be distinguished.
        stackResultDimension = "__\x00ecstackresult_" + seriesModel.id;
        stackedOverDimension = "__\x00ecstackedover_" + seriesModel.id;
        // Create inverted index to fast query index by value.
        if (stackedByDimInfo) stackedByDimInfo.createInvertedIndices = true;
        var stackedDimCoordDim_1 = stackedDimInfo.coordDim;
        var stackedDimType = stackedDimInfo.type;
        var stackedDimCoordIndex_1 = 0;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dimensionDefineList, function(dimensionInfo) {
            if (dimensionInfo.coordDim === stackedDimCoordDim_1) stackedDimCoordIndex_1++;
        });
        var stackedOverDimensionDefine = {
            name: stackResultDimension,
            coordDim: stackedDimCoordDim_1,
            coordDimIndex: stackedDimCoordIndex_1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length
        };
        var stackResultDimensionDefine = {
            name: stackedOverDimension,
            // This dimension contains stack base (generally, 0), so do not set it as
            // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
            coordDim: stackedOverDimension,
            coordDimIndex: stackedDimCoordIndex_1 + 1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length + 1
        };
        if (schema) {
            if (store) {
                stackedOverDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackedOverDimension, stackedDimType);
                stackResultDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackResultDimension, stackedDimType);
            }
            schema.appendCalculationDimension(stackedOverDimensionDefine);
            schema.appendCalculationDimension(stackResultDimensionDefine);
        } else {
            dimensionDefineList.push(stackedOverDimensionDefine);
            dimensionDefineList.push(stackResultDimensionDefine);
        }
    }
    return {
        stackedDimension: stackedDimInfo && stackedDimInfo.name,
        stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
        isStackedByIndex: byIndex,
        stackedOverDimension: stackedOverDimension,
        stackResultDimension: stackResultDimension
    };
}
function $efdd976e4917927c$var$isLegacyDimensionsInput(dimensionsInput) {
    return !(0, $85b723b311a86ffc$export$fafbc856132a3a0e)(dimensionsInput.schema);
}
function $efdd976e4917927c$export$1dedc39359ae35c(data, stackedDim) {
    // Each single series only maps to one pair of axis. So we do not need to
    // check stackByDim, whatever stacked by a dimension or stacked by index.
    return !!stackedDim && stackedDim === data.getCalculationInfo("stackedDimension");
}
function $efdd976e4917927c$export$909db2be4938fbdf(data, targetDim) {
    return $efdd976e4917927c$export$1dedc39359ae35c(data, targetDim) ? data.getCalculationInfo("stackResultDimension") : targetDim;
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/* global Float32Array */ var $5cd50afac93e9148$var$supportFloat32Array = typeof Float32Array !== "undefined";
var $5cd50afac93e9148$var$Float32ArrayCtor = !$5cd50afac93e9148$var$supportFloat32Array ? Array : Float32Array;
function $5cd50afac93e9148$export$21d2298f3f56bbaf(arg) {
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(arg)) // Return self directly if don't support TypedArray.
    return $5cd50afac93e9148$var$supportFloat32Array ? new Float32Array(arg) : arg;
    // Else is number
    return new $5cd50afac93e9148$var$Float32ArrayCtor(arg);
}


var $361c48dd900de28f$var$STACK_PREFIX = "__ec_stack_";
function $361c48dd900de28f$var$getSeriesStackId(seriesModel) {
    return seriesModel.get("stack") || $361c48dd900de28f$var$STACK_PREFIX + seriesModel.seriesIndex;
}
function $361c48dd900de28f$var$getAxisKey(axis) {
    return axis.dim + axis.index;
}
function $361c48dd900de28f$export$658df087977b9e84(opt) {
    var params = [];
    var baseAxis = opt.axis;
    var axisKey = "axis0";
    if (baseAxis.type !== "category") return;
    var bandWidth = baseAxis.getBandWidth();
    for(var i = 0; i < opt.count || 0; i++)params.push((0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        bandWidth: bandWidth,
        axisKey: axisKey,
        stackId: $361c48dd900de28f$var$STACK_PREFIX + i
    }, opt));
    var widthAndOffsets = $361c48dd900de28f$var$doCalBarWidthAndOffset(params);
    var result = [];
    for(var i = 0; i < opt.count; i++){
        var item = widthAndOffsets[axisKey][$361c48dd900de28f$var$STACK_PREFIX + i];
        item.offsetCenter = item.offset + item.width / 2;
        result.push(item);
    }
    return result;
}
function $361c48dd900de28f$export$efbd0c3f5ab0d5e4(seriesType, ecModel) {
    var seriesModels = [];
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        // Check series coordinate, do layout for cartesian2d only
        if ($361c48dd900de28f$var$isOnCartesian(seriesModel)) seriesModels.push(seriesModel);
    });
    return seriesModels;
}
/**
 * Map from (baseAxis.dim + '_' + baseAxis.index) to min gap of two adjacent
 * values.
 * This works for time axes, value axes, and log axes.
 * For a single time axis, return value is in the form like
 * {'x_0': [1000000]}.
 * The value of 1000000 is in milliseconds.
 */ function $361c48dd900de28f$var$getValueAxesMinGaps(barSeries) {
    /**
   * Map from axis.index to values.
   * For a single time axis, axisValues is in the form like
   * {'x_0': [1495555200000, 1495641600000, 1495728000000]}.
   * Items in axisValues[x], e.g. 1495555200000, are time values of all
   * series.
   */ var axisValues = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(barSeries, function(seriesModel) {
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        if (baseAxis.type !== "time" && baseAxis.type !== "value") return;
        var data = seriesModel.getData();
        var key = baseAxis.dim + "_" + baseAxis.index;
        var dimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
        var store = data.getStore();
        for(var i = 0, cnt = store.count(); i < cnt; ++i){
            var value = store.get(dimIdx, i);
            if (!axisValues[key]) // No previous data for the axis
            axisValues[key] = [
                value
            ];
            else // No value in previous series
            axisValues[key].push(value);
        // Ignore duplicated time values in the same axis
        }
    });
    var axisMinGaps = {};
    for(var key in axisValues)if (axisValues.hasOwnProperty(key)) {
        var valuesInAxis = axisValues[key];
        if (valuesInAxis) {
            // Sort axis values into ascending order to calculate gaps
            valuesInAxis.sort(function(a, b) {
                return a - b;
            });
            var min = null;
            for(var j = 1; j < valuesInAxis.length; ++j){
                var delta = valuesInAxis[j] - valuesInAxis[j - 1];
                if (delta > 0) // Ignore 0 delta because they are of the same axis value
                min = min === null ? delta : Math.min(min, delta);
            }
            // Set to null if only have one data
            axisMinGaps[key] = min;
        }
    }
    return axisMinGaps;
}
function $361c48dd900de28f$export$20769dafc84e0299(barSeries) {
    var axisMinGaps = $361c48dd900de28f$var$getValueAxesMinGaps(barSeries);
    var seriesInfoList = [];
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(barSeries, function(seriesModel) {
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var axisExtent = baseAxis.getExtent();
        var bandWidth;
        if (baseAxis.type === "category") bandWidth = baseAxis.getBandWidth();
        else if (baseAxis.type === "value" || baseAxis.type === "time") {
            var key = baseAxis.dim + "_" + baseAxis.index;
            var minGap = axisMinGaps[key];
            var extentSpan = Math.abs(axisExtent[1] - axisExtent[0]);
            var scale = baseAxis.scale.getExtent();
            var scaleSpan = Math.abs(scale[1] - scale[0]);
            bandWidth = minGap ? extentSpan / scaleSpan * minGap : extentSpan; // When there is only one data value
        } else {
            var data = seriesModel.getData();
            bandWidth = Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
        }
        var barWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("barWidth"), bandWidth);
        var barMaxWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("barMaxWidth"), bandWidth);
        var barMinWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(// barMinWidth by default is 0.5 / 1 in cartesian. Because in value axis,
        // the auto-calculated bar width might be less than 0.5 / 1.
        seriesModel.get("barMinWidth") || ($361c48dd900de28f$var$isInLargeMode(seriesModel) ? 0.5 : 1), bandWidth);
        var barGap = seriesModel.get("barGap");
        var barCategoryGap = seriesModel.get("barCategoryGap");
        var defaultBarGap = seriesModel.get("defaultBarGap");
        seriesInfoList.push({
            bandWidth: bandWidth,
            barWidth: barWidth,
            barMaxWidth: barMaxWidth,
            barMinWidth: barMinWidth,
            barGap: barGap,
            barCategoryGap: barCategoryGap,
            defaultBarGap: defaultBarGap,
            axisKey: $361c48dd900de28f$var$getAxisKey(baseAxis),
            stackId: $361c48dd900de28f$var$getSeriesStackId(seriesModel)
        });
    });
    return $361c48dd900de28f$var$doCalBarWidthAndOffset(seriesInfoList);
}
function $361c48dd900de28f$var$doCalBarWidthAndOffset(seriesInfoList) {
    // Columns info on each category axis. Key is cartesian name
    var columnsMap = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(seriesInfoList, function(seriesInfo, idx) {
        var axisKey = seriesInfo.axisKey;
        var bandWidth = seriesInfo.bandWidth;
        var columnsOnAxis = columnsMap[axisKey] || {
            bandWidth: bandWidth,
            remainedWidth: bandWidth,
            autoWidthCount: 0,
            categoryGap: null,
            gap: seriesInfo.defaultBarGap || 0,
            stacks: {}
        };
        var stacks = columnsOnAxis.stacks;
        columnsMap[axisKey] = columnsOnAxis;
        var stackId = seriesInfo.stackId;
        if (!stacks[stackId]) columnsOnAxis.autoWidthCount++;
        stacks[stackId] = stacks[stackId] || {
            width: 0,
            maxWidth: 0
        };
        // Caution: In a single coordinate system, these barGrid attributes
        // will be shared by series. Consider that they have default values,
        // only the attributes set on the last series will work.
        // Do not change this fact unless there will be a break change.
        var barWidth = seriesInfo.barWidth;
        if (barWidth && !stacks[stackId].width) {
            // See #6312, do not restrict width.
            stacks[stackId].width = barWidth;
            barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
            columnsOnAxis.remainedWidth -= barWidth;
        }
        var barMaxWidth = seriesInfo.barMaxWidth;
        barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
        var barMinWidth = seriesInfo.barMinWidth;
        barMinWidth && (stacks[stackId].minWidth = barMinWidth);
        var barGap = seriesInfo.barGap;
        barGap != null && (columnsOnAxis.gap = barGap);
        var barCategoryGap = seriesInfo.barCategoryGap;
        barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
    });
    var result = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(columnsMap, function(columnsOnAxis, coordSysName) {
        result[coordSysName] = {};
        var stacks = columnsOnAxis.stacks;
        var bandWidth = columnsOnAxis.bandWidth;
        var categoryGapPercent = columnsOnAxis.categoryGap;
        if (categoryGapPercent == null) {
            var columnCount = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(stacks).length;
            // More columns in one group
            // the spaces between group is smaller. Or the column will be too thin.
            categoryGapPercent = Math.max(35 - columnCount * 4, 15) + "%";
        }
        var categoryGap = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(categoryGapPercent, bandWidth);
        var barGapPercent = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(columnsOnAxis.gap, 1);
        var remainedWidth = columnsOnAxis.remainedWidth;
        var autoWidthCount = columnsOnAxis.autoWidthCount;
        var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        // Find if any auto calculated bar exceeded maxBarWidth
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(stacks, function(column) {
            var maxWidth = column.maxWidth;
            var minWidth = column.minWidth;
            if (!column.width) {
                var finalWidth = autoWidth;
                if (maxWidth && maxWidth < finalWidth) finalWidth = Math.min(maxWidth, remainedWidth);
                // `minWidth` has higher priority. `minWidth` decide that whether the
                // bar is able to be visible. So `minWidth` should not be restricted
                // by `maxWidth` or `remainedWidth` (which is from `bandWidth`). In
                // the extreme cases for `value` axis, bars are allowed to overlap
                // with each other if `minWidth` specified.
                if (minWidth && minWidth > finalWidth) finalWidth = minWidth;
                if (finalWidth !== autoWidth) {
                    column.width = finalWidth;
                    remainedWidth -= finalWidth + barGapPercent * finalWidth;
                    autoWidthCount--;
                }
            } else {
                // `barMinWidth/barMaxWidth` has higher priority than `barWidth`, as
                // CSS does. Because barWidth can be a percent value, where
                // `barMaxWidth` can be used to restrict the final width.
                var finalWidth = column.width;
                if (maxWidth) finalWidth = Math.min(finalWidth, maxWidth);
                // `minWidth` has higher priority, as described above
                if (minWidth) finalWidth = Math.max(finalWidth, minWidth);
                column.width = finalWidth;
                remainedWidth -= finalWidth + barGapPercent * finalWidth;
                autoWidthCount--;
            }
        });
        // Recalculate width again
        autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        var widthSum = 0;
        var lastColumn;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(stacks, function(column, idx) {
            if (!column.width) column.width = autoWidth;
            lastColumn = column;
            widthSum += column.width * (1 + barGapPercent);
        });
        if (lastColumn) widthSum -= lastColumn.width * barGapPercent;
        var offset = -widthSum / 2;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(stacks, function(column, stackId) {
            result[coordSysName][stackId] = result[coordSysName][stackId] || {
                bandWidth: bandWidth,
                offset: offset,
                width: column.width
            };
            offset += column.width * (1 + barGapPercent);
        });
    });
    return result;
}
function $361c48dd900de28f$export$35920bb6556da1c2(barWidthAndOffset, axis, seriesModel) {
    if (barWidthAndOffset && axis) {
        var result = barWidthAndOffset[$361c48dd900de28f$var$getAxisKey(axis)];
        if (result != null && seriesModel != null) return result[$361c48dd900de28f$var$getSeriesStackId(seriesModel)];
        return result;
    }
}
function $361c48dd900de28f$export$b3219800bda33a1f(seriesType, ecModel) {
    var seriesModels = $361c48dd900de28f$export$efbd0c3f5ab0d5e4(seriesType, ecModel);
    var barWidthAndOffset = $361c48dd900de28f$export$20769dafc84e0299(seriesModels);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(seriesModels, function(seriesModel) {
        var data = seriesModel.getData();
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var stackId = $361c48dd900de28f$var$getSeriesStackId(seriesModel);
        var columnLayoutInfo = barWidthAndOffset[$361c48dd900de28f$var$getAxisKey(baseAxis)][stackId];
        var columnOffset = columnLayoutInfo.offset;
        var columnWidth = columnLayoutInfo.width;
        data.setLayout({
            bandWidth: columnLayoutInfo.bandWidth,
            offset: columnOffset,
            size: columnWidth
        });
    });
}
function $361c48dd900de28f$export$16e8685758531cb6(seriesType) {
    return {
        seriesType: seriesType,
        plan: (0, $cd70075c57b35175$export$2e2bcd8739ae039)(),
        reset: function(seriesModel) {
            if (!$361c48dd900de28f$var$isOnCartesian(seriesModel)) return;
            var data = seriesModel.getData();
            var cartesian = seriesModel.coordinateSystem;
            var baseAxis = cartesian.getBaseAxis();
            var valueAxis = cartesian.getOtherAxis(baseAxis);
            var valueDimIdx = data.getDimensionIndex(data.mapDimension(valueAxis.dim));
            var baseDimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
            var drawBackground = seriesModel.get("showBackground", true);
            var valueDim = data.mapDimension(valueAxis.dim);
            var stackResultDim = data.getCalculationInfo("stackResultDimension");
            var stacked = (0, $efdd976e4917927c$export$1dedc39359ae35c)(data, valueDim) && !!data.getCalculationInfo("stackedOnSeries");
            var isValueAxisH = valueAxis.isHorizontal();
            var valueAxisStart = $361c48dd900de28f$var$getValueAxisStart(baseAxis, valueAxis);
            var isLarge = $361c48dd900de28f$var$isInLargeMode(seriesModel);
            var barMinHeight = seriesModel.get("barMinHeight") || 0;
            var stackedDimIdx = stackResultDim && data.getDimensionIndex(stackResultDim);
            // Layout info.
            var columnWidth = data.getLayout("size");
            var columnOffset = data.getLayout("offset");
            return {
                progress: function(params, data) {
                    var count = params.count;
                    var largePoints = isLarge && (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(count * 3);
                    var largeBackgroundPoints = isLarge && drawBackground && (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(count * 3);
                    var largeDataIndices = isLarge && (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(count);
                    var coordLayout = cartesian.master.getRect();
                    var bgSize = isValueAxisH ? coordLayout.width : coordLayout.height;
                    var dataIndex;
                    var store = data.getStore();
                    var idxOffset = 0;
                    while((dataIndex = params.next()) != null){
                        var value = store.get(stacked ? stackedDimIdx : valueDimIdx, dataIndex);
                        var baseValue = store.get(baseDimIdx, dataIndex);
                        var baseCoord = valueAxisStart;
                        var stackStartValue = void 0;
                        // Because of the barMinHeight, we can not use the value in
                        // stackResultDimension directly.
                        if (stacked) stackStartValue = +value - store.get(valueDimIdx, dataIndex);
                        var x = void 0;
                        var y = void 0;
                        var width = void 0;
                        var height = void 0;
                        if (isValueAxisH) {
                            var coord = cartesian.dataToPoint([
                                value,
                                baseValue
                            ]);
                            if (stacked) {
                                var startCoord = cartesian.dataToPoint([
                                    stackStartValue,
                                    baseValue
                                ]);
                                baseCoord = startCoord[0];
                            }
                            x = baseCoord;
                            y = coord[1] + columnOffset;
                            width = coord[0] - baseCoord;
                            height = columnWidth;
                            if (Math.abs(width) < barMinHeight) width = (width < 0 ? -1 : 1) * barMinHeight;
                        } else {
                            var coord = cartesian.dataToPoint([
                                baseValue,
                                value
                            ]);
                            if (stacked) {
                                var startCoord = cartesian.dataToPoint([
                                    baseValue,
                                    stackStartValue
                                ]);
                                baseCoord = startCoord[1];
                            }
                            x = coord[0] + columnOffset;
                            y = baseCoord;
                            width = columnWidth;
                            height = coord[1] - baseCoord;
                            if (Math.abs(height) < barMinHeight) // Include zero to has a positive bar
                            height = (height <= 0 ? -1 : 1) * barMinHeight;
                        }
                        if (!isLarge) data.setItemLayout(dataIndex, {
                            x: x,
                            y: y,
                            width: width,
                            height: height
                        });
                        else {
                            largePoints[idxOffset] = x;
                            largePoints[idxOffset + 1] = y;
                            largePoints[idxOffset + 2] = isValueAxisH ? width : height;
                            if (largeBackgroundPoints) {
                                largeBackgroundPoints[idxOffset] = isValueAxisH ? coordLayout.x : x;
                                largeBackgroundPoints[idxOffset + 1] = isValueAxisH ? y : coordLayout.y;
                                largeBackgroundPoints[idxOffset + 2] = bgSize;
                            }
                            largeDataIndices[dataIndex] = dataIndex;
                        }
                        idxOffset += 3;
                    }
                    if (isLarge) data.setLayout({
                        largePoints: largePoints,
                        largeDataIndices: largeDataIndices,
                        largeBackgroundPoints: largeBackgroundPoints,
                        valueAxisHorizontal: isValueAxisH
                    });
                }
            };
        }
    };
}
function $361c48dd900de28f$var$isOnCartesian(seriesModel) {
    return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === "cartesian2d";
}
function $361c48dd900de28f$var$isInLargeMode(seriesModel) {
    return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
}
// See cases in `test/bar-start.html` and `#7412`, `#8747`.
function $361c48dd900de28f$var$getValueAxisStart(baseAxis, valueAxis) {
    var startValue = valueAxis.model.get("startValue");
    if (!startValue) startValue = 0;
    return valueAxis.toGlobalCoord(valueAxis.dataToCoord(valueAxis.type === "log" ? startValue > 0 ? startValue : 1 : startValue));
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3a37e5b80322a871$var$samplers = {
    average: function(frame) {
        var sum = 0;
        var count = 0;
        for(var i = 0; i < frame.length; i++)if (!isNaN(frame[i])) {
            sum += frame[i];
            count++;
        }
        // Return NaN if count is 0
        return count === 0 ? NaN : sum / count;
    },
    sum: function(frame) {
        var sum = 0;
        for(var i = 0; i < frame.length; i++)// Ignore NaN
        sum += frame[i] || 0;
        return sum;
    },
    max: function(frame) {
        var max = -Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] > max && (max = frame[i]);
        // NaN will cause illegal axis extent.
        return isFinite(max) ? max : NaN;
    },
    min: function(frame) {
        var min = Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] < min && (min = frame[i]);
        // NaN will cause illegal axis extent.
        return isFinite(min) ? min : NaN;
    },
    // TODO
    // Median
    nearest: function(frame) {
        return frame[0];
    }
};
var $3a37e5b80322a871$var$indexSampler = function(frame) {
    return Math.round(frame.length / 2);
};
function $3a37e5b80322a871$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        // FIXME:TS never used, so comment it
        // modifyOutputEnd: true,
        reset: function(seriesModel, ecModel, api) {
            var data = seriesModel.getData();
            var sampling = seriesModel.get("sampling");
            var coordSys = seriesModel.coordinateSystem;
            var count = data.count();
            // Only cartesian2d support down sampling. Disable it when there is few data.
            if (count > 10 && coordSys.type === "cartesian2d" && sampling) {
                var baseAxis = coordSys.getBaseAxis();
                var valueAxis = coordSys.getOtherAxis(baseAxis);
                var extent = baseAxis.getExtent();
                var dpr = api.getDevicePixelRatio();
                // Coordinste system has been resized
                var size = Math.abs(extent[1] - extent[0]) * (dpr || 1);
                var rate = Math.round(count / size);
                if (isFinite(rate) && rate > 1) {
                    if (sampling === "lttb") seriesModel.setData(data.lttbDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
                    else if (sampling === "minmax") seriesModel.setData(data.minmaxDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
                    var sampler = void 0;
                    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(sampling)) sampler = $3a37e5b80322a871$var$samplers[sampling];
                    else if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(sampling)) sampler = sampling;
                    if (sampler) // Only support sample the first dim mapped from value axis.
                    seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, $3a37e5b80322a871$var$indexSampler));
                }
            }
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Int32Array */ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $306d1c87baff8a10$var$dataIndexMapValueLength(valNumOrArrLengthMoreThan2) {
    return valNumOrArrLengthMoreThan2 == null ? 0 : valNumOrArrLengthMoreThan2.length || 1;
}
function $306d1c87baff8a10$var$defaultKeyGetter(item) {
    return item;
}
var $306d1c87baff8a10$var$DataDiffer = /** @class */ function() {
    /**
   * @param context Can be visited by this.context in callback.
   */ function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context, // By default: 'oneToOne'.
    diffMode) {
        this._old = oldArr;
        this._new = newArr;
        this._oldKeyGetter = oldKeyGetter || $306d1c87baff8a10$var$defaultKeyGetter;
        this._newKeyGetter = newKeyGetter || $306d1c87baff8a10$var$defaultKeyGetter;
        // Visible in callback via `this.context`;
        this.context = context;
        this._diffModeMultiple = diffMode === "multiple";
    }
    /**
   * Callback function when add a data
   */ DataDiffer.prototype.add = function(func) {
        this._add = func;
        return this;
    };
    /**
   * Callback function when update a data
   */ DataDiffer.prototype.update = function(func) {
        this._update = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToOne = function(func) {
        this._updateManyToOne = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateOneToMany = function(func) {
        this._updateOneToMany = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToMany = function(func) {
        this._updateManyToMany = func;
        return this;
    };
    /**
   * Callback function when remove a data
   */ DataDiffer.prototype.remove = function(func) {
        this._remove = func;
        return this;
    };
    DataDiffer.prototype.execute = function() {
        this[this._diffModeMultiple ? "_executeMultiple" : "_executeOneToOne"]();
    };
    DataDiffer.prototype._executeOneToOne = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var newDataIndexMap = {};
        var oldDataKeyArr = new Array(oldArr.length);
        var newDataKeyArr = new Array(newArr.length);
        this._initIndexMap(oldArr, null, oldDataKeyArr, "_oldKeyGetter");
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, "_newKeyGetter");
        for(var i = 0; i < oldArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var newIdxMapValLen = $306d1c87baff8a10$var$dataIndexMapValueLength(newIdxMapVal);
            // idx can never be empty array here. see 'set null' logic below.
            if (newIdxMapValLen > 1) {
                // Consider there is duplicate key (for example, use dataItem.name as key).
                // We should make sure every item in newArr and oldArr can be visited.
                var newIdx = newIdxMapVal.shift();
                if (newIdxMapVal.length === 1) newDataIndexMap[oldKey] = newIdxMapVal[0];
                this._update && this._update(newIdx, i);
            } else if (newIdxMapValLen === 1) {
                newDataIndexMap[oldKey] = null;
                this._update && this._update(newIdxMapVal, i);
            } else this._remove && this._remove(i);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    /**
   * For example, consider the case:
   * oldData: [o0, o1, o2, o3, o4, o5, o6, o7],
   * newData: [n0, n1, n2, n3, n4, n5, n6, n7, n8],
   * Where:
   *     o0, o1, n0 has key 'a' (many to one)
   *     o5, n4, n5, n6 has key 'b' (one to many)
   *     o2, n1 has key 'c' (one to one)
   *     n2, n3 has key 'd' (add)
   *     o3, o4 has key 'e' (remove)
   *     o6, o7, n7, n8 has key 'f' (many to many, treated as add and remove)
   * Then:
   *     (The order of the following directives are not ensured.)
   *     this._updateManyToOne(n0, [o0, o1]);
   *     this._updateOneToMany([n4, n5, n6], o5);
   *     this._update(n1, o2);
   *     this._remove(o3);
   *     this._remove(o4);
   *     this._remove(o6);
   *     this._remove(o7);
   *     this._add(n2);
   *     this._add(n3);
   *     this._add(n7);
   *     this._add(n8);
   */ DataDiffer.prototype._executeMultiple = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var oldDataIndexMap = {};
        var newDataIndexMap = {};
        var oldDataKeyArr = [];
        var newDataKeyArr = [];
        this._initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, "_oldKeyGetter");
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, "_newKeyGetter");
        for(var i = 0; i < oldDataKeyArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var oldIdxMapVal = oldDataIndexMap[oldKey];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var oldIdxMapValLen = $306d1c87baff8a10$var$dataIndexMapValueLength(oldIdxMapVal);
            var newIdxMapValLen = $306d1c87baff8a10$var$dataIndexMapValueLength(newIdxMapVal);
            if (oldIdxMapValLen > 1 && newIdxMapValLen === 1) {
                this._updateManyToOne && this._updateManyToOne(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen > 1) {
                this._updateOneToMany && this._updateOneToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen === 1) {
                this._update && this._update(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1 && newIdxMapValLen > 1) {
                this._updateManyToMany && this._updateManyToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1) for(var i_1 = 0; i_1 < oldIdxMapValLen; i_1++)this._remove && this._remove(oldIdxMapVal[i_1]);
            else this._remove && this._remove(oldIdxMapVal);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    DataDiffer.prototype._performRestAdd = function(newDataKeyArr, newDataIndexMap) {
        for(var i = 0; i < newDataKeyArr.length; i++){
            var newKey = newDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[newKey];
            var idxMapValLen = $306d1c87baff8a10$var$dataIndexMapValueLength(newIdxMapVal);
            if (idxMapValLen > 1) for(var j = 0; j < idxMapValLen; j++)this._add && this._add(newIdxMapVal[j]);
            else if (idxMapValLen === 1) this._add && this._add(newIdxMapVal);
            // Support both `newDataKeyArr` are duplication removed or not removed.
            newDataIndexMap[newKey] = null;
        }
    };
    DataDiffer.prototype._initIndexMap = function(arr, // Can be null.
    map, // In 'byKey', the output `keyArr` is duplication removed.
    // In 'byIndex', the output `keyArr` is not duplication removed and
    //     its indices are accurately corresponding to `arr`.
    keyArr, keyGetterName) {
        var cbModeMultiple = this._diffModeMultiple;
        for(var i = 0; i < arr.length; i++){
            // Add prefix to avoid conflict with Object.prototype.
            var key = "_ec_" + this[keyGetterName](arr[i], i);
            if (!cbModeMultiple) keyArr[i] = key;
            if (!map) continue;
            var idxMapVal = map[key];
            var idxMapValLen = $306d1c87baff8a10$var$dataIndexMapValueLength(idxMapVal);
            if (idxMapValLen === 0) {
                // Simple optimize: in most cases, one index has one key,
                // do not need array.
                map[key] = i;
                if (cbModeMultiple) keyArr.push(key);
            } else if (idxMapValLen === 1) map[key] = [
                idxMapVal,
                i
            ];
            else idxMapVal.push(i);
        }
    };
    return DataDiffer;
}();
var $306d1c87baff8a10$export$2e2bcd8739ae039 = $306d1c87baff8a10$var$DataDiffer;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $18085de91ae59d03$var$DimensionUserOuput = /** @class */ function() {
    function DimensionUserOuput(encode, dimRequest) {
        this._encode = encode;
        this._schema = dimRequest;
    }
    DimensionUserOuput.prototype.get = function() {
        return {
            // Do not generate full dimension name until fist used.
            fullDimensions: this._getFullDimensionNames(),
            encode: this._encode
        };
    };
    /**
   * Get all data store dimension names.
   * Theoretically a series data store is defined both by series and used dataset (if any).
   * If some dimensions are omitted for performance reason in `this.dimensions`,
   * the dimension name may not be auto-generated if user does not specify a dimension name.
   * In this case, the dimension name is `null`/`undefined`.
   */ DimensionUserOuput.prototype._getFullDimensionNames = function() {
        if (!this._cachedDimNames) this._cachedDimNames = this._schema ? this._schema.makeOutputDimensionNames() : [];
        return this._cachedDimNames;
    };
    return DimensionUserOuput;
}();
function $18085de91ae59d03$export$505a22c3734846f1(data, schema) {
    var summary = {};
    var encode = summary.encode = {};
    var notExtraCoordDimMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var defaultedLabel = [];
    var defaultedTooltip = [];
    var userOutputEncode = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(data.dimensions, function(dimName) {
        var dimItem = data.getDimensionInfo(dimName);
        var coordDim = dimItem.coordDim;
        if (coordDim) {
            var coordDimIndex = dimItem.coordDimIndex;
            $18085de91ae59d03$var$getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;
            if (!dimItem.isExtraCoord) {
                notExtraCoordDimMap.set(coordDim, 1);
                // Use the last coord dim (and label friendly) as default label,
                // because when dataset is used, it is hard to guess which dimension
                // can be value dimension. If both show x, y on label is not look good,
                // and conventionally y axis is focused more.
                if ($18085de91ae59d03$var$mayLabelDimType(dimItem.type)) defaultedLabel[0] = dimName;
                // User output encode do not contain generated coords.
                // And it only has index. User can use index to retrieve value from the raw item array.
                $18085de91ae59d03$var$getOrCreateEncodeArr(userOutputEncode, coordDim)[coordDimIndex] = data.getDimensionIndex(dimItem.name);
            }
            if (dimItem.defaultTooltip) defaultedTooltip.push(dimName);
        }
        (0, $cab29724515ce2b8$export$cd51b5ca77f6f0e4).each(function(v, otherDim) {
            var encodeArr = $18085de91ae59d03$var$getOrCreateEncodeArr(encode, otherDim);
            var dimIndex = dimItem.otherDims[otherDim];
            if (dimIndex != null && dimIndex !== false) encodeArr[dimIndex] = dimItem.name;
        });
    });
    var dataDimsOnCoord = [];
    var encodeFirstDimNotExtra = {};
    notExtraCoordDimMap.each(function(v, coordDim) {
        var dimArr = encode[coordDim];
        encodeFirstDimNotExtra[coordDim] = dimArr[0];
        // Not necessary to remove duplicate, because a data
        // dim canot on more than one coordDim.
        dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
    });
    summary.dataDimsOnCoord = dataDimsOnCoord;
    summary.dataDimIndicesOnCoord = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dataDimsOnCoord, function(dimName) {
        return data.getDimensionInfo(dimName).storeDimIndex;
    });
    summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
    var encodeLabel = encode.label;
    // FIXME `encode.label` is not recommended, because formatter cannot be set
    // in this way. Use label.formatter instead. Maybe remove this approach someday.
    if (encodeLabel && encodeLabel.length) defaultedLabel = encodeLabel.slice();
    var encodeTooltip = encode.tooltip;
    if (encodeTooltip && encodeTooltip.length) defaultedTooltip = encodeTooltip.slice();
    else if (!defaultedTooltip.length) defaultedTooltip = defaultedLabel.slice();
    encode.defaultedLabel = defaultedLabel;
    encode.defaultedTooltip = defaultedTooltip;
    summary.userOutput = new $18085de91ae59d03$var$DimensionUserOuput(userOutputEncode, schema);
    return summary;
}
function $18085de91ae59d03$var$getOrCreateEncodeArr(encode, dim) {
    if (!encode.hasOwnProperty(dim)) encode[dim] = [];
    return encode[dim];
}
function $18085de91ae59d03$export$af1622903e71278e(axisType) {
    return axisType === "category" ? "ordinal" : axisType === "time" ? "time" : "float";
}
function $18085de91ae59d03$var$mayLabelDimType(dimType) {
    // In most cases, ordinal and time do not suitable for label.
    // Ordinal info can be displayed on axis. Time is too long.
    return !(dimType === "ordinal" || dimType === "time");
} // function findTheLastDimMayLabel(data) {
 //     // Get last value dim
 //     let dimensions = data.dimensions.slice();
 //     let valueType;
 //     let valueDim;
 //     while (dimensions.length && (
 //         valueDim = dimensions.pop(),
 //         valueType = data.getDimensionInfo(valueDim).type,
 //         valueType === 'ordinal' || valueType === 'time'
 //     )) {} // jshint ignore:line
 //     return valueDim;
 // }


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $5e233867ea3713e7$var$SeriesDimensionDefine = /** @class */ function() {
    /**
   * @param opt All of the fields will be shallow copied.
   */ function SeriesDimensionDefine(opt) {
        /**
     * The format of `otherDims` is:
     * ```js
     * {
     *     tooltip?: number
     *     label?: number
     *     itemName?: number
     *     seriesName?: number
     * }
     * ```
     *
     * A `series.encode` can specified these fields:
     * ```js
     * encode: {
     *     // "3, 1, 5" is the index of data dimension.
     *     tooltip: [3, 1, 5],
     *     label: [0, 3],
     *     ...
     * }
     * ```
     * `otherDims` is the parse result of the `series.encode` above, like:
     * ```js
     * // Suppose the index of this data dimension is `3`.
     * this.otherDims = {
     *     // `3` is at the index `0` of the `encode.tooltip`
     *     tooltip: 0,
     *     // `3` is at the index `1` of the `encode.label`
     *     label: 1
     * };
     * ```
     *
     * This prop should never be `null`/`undefined` after initialized.
     */ this.otherDims = {};
        if (opt != null) $7a1bd9c2710fea0d$export$8b58be045bf06082(this, opt);
    }
    return SeriesDimensionDefine;
}();
var $5e233867ea3713e7$export$2e2bcd8739ae039 = $5e233867ea3713e7$var$SeriesDimensionDefine;








var $0ab0556b819346fd$var$isObject = $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a;
var $0ab0556b819346fd$var$map = $7a1bd9c2710fea0d$export$871de8747c9eaa88;
var $0ab0556b819346fd$var$CtorInt32Array = typeof Int32Array === "undefined" ? Array : Int32Array;
// Use prefix to avoid index to be the same as otherIdList[idx],
// which will cause weird update animation.
var $0ab0556b819346fd$var$ID_PREFIX = "e\x00\x00";
var $0ab0556b819346fd$var$INDEX_NOT_FOUND = -1;
// type SeriesDimensionIndex = DimensionIndex;
var $0ab0556b819346fd$var$TRANSFERABLE_PROPERTIES = [
    "hasItemOption",
    "_nameList",
    "_idList",
    "_invertedIndicesMap",
    "_dimSummary",
    "userOutput",
    "_rawData",
    "_dimValueGetter",
    "_nameDimIdx",
    "_idDimIdx",
    "_nameRepeatCount"
];
var $0ab0556b819346fd$var$CLONE_PROPERTIES = [
    "_approximateExtent"
];
// -----------------------------
// Internal method declarations:
// -----------------------------
var $0ab0556b819346fd$var$prepareInvertedIndex;
var $0ab0556b819346fd$var$getId;
var $0ab0556b819346fd$var$getIdNameFromStore;
var $0ab0556b819346fd$var$normalizeDimensions;
var $0ab0556b819346fd$var$transferProperties;
var $0ab0556b819346fd$var$cloneListForMapAndSample;
var $0ab0556b819346fd$var$makeIdFromName;
var $0ab0556b819346fd$var$SeriesData = /** @class */ function() {
    /**
   * @param dimensionsInput.dimensions
   *        For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
   *        Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
   */ function SeriesData(dimensionsInput, hostModel) {
        this.type = "list";
        this._dimOmitted = false;
        this._nameList = [];
        this._idList = [];
        // Models of data option is stored sparse for optimizing memory cost
        // Never used yet (not used yet).
        // private _optionModels: Model[] = [];
        // Global visual properties after visual coding
        this._visual = {};
        // Global layout properties.
        this._layout = {};
        // Item visual properties after visual coding
        this._itemVisuals = [];
        // Item layout properties after layout
        this._itemLayouts = [];
        // Graphic elements
        this._graphicEls = [];
        // key: dim, value: extent
        this._approximateExtent = {};
        this._calculationInfo = {};
        // Having detected that there is data item is non primitive type
        // (in type `OptionDataItemObject`).
        // Like `data: [ { value: xx, itemStyle: {...} }, ...]`
        // At present it only happen in `SOURCE_FORMAT_ORIGINAL`.
        this.hasItemOption = false;
        // Methods that create a new list based on this list should be listed here.
        // Notice that those method should `RETURN` the new list.
        this.TRANSFERABLE_METHODS = [
            "cloneShallow",
            "downSample",
            "minmaxDownSample",
            "lttbDownSample",
            "map"
        ];
        // Methods that change indices of this list should be listed here.
        this.CHANGABLE_METHODS = [
            "filterSelf",
            "selectRange"
        ];
        this.DOWNSAMPLE_METHODS = [
            "downSample",
            "minmaxDownSample",
            "lttbDownSample"
        ];
        var dimensions;
        var assignStoreDimIdx = false;
        if ((0, $85b723b311a86ffc$export$fafbc856132a3a0e)(dimensionsInput)) {
            dimensions = dimensionsInput.dimensions;
            this._dimOmitted = dimensionsInput.isDimensionOmitted();
            this._schema = dimensionsInput;
        } else {
            assignStoreDimIdx = true;
            dimensions = dimensionsInput;
        }
        dimensions = dimensions || [
            "x",
            "y"
        ];
        var dimensionInfos = {};
        var dimensionNames = [];
        var invertedIndicesMap = {};
        var needsHasOwn = false;
        var emptyObj = {};
        for(var i = 0; i < dimensions.length; i++){
            // Use the original dimensions[i], where other flag props may exists.
            var dimInfoInput = dimensions[i];
            var dimensionInfo = $7a1bd9c2710fea0d$export$844ec244b1367d54(dimInfoInput) ? new (0, $5e233867ea3713e7$export$2e2bcd8739ae039)({
                name: dimInfoInput
            }) : !(dimInfoInput instanceof (0, $5e233867ea3713e7$export$2e2bcd8739ae039)) ? new (0, $5e233867ea3713e7$export$2e2bcd8739ae039)(dimInfoInput) : dimInfoInput;
            var dimensionName = dimensionInfo.name;
            dimensionInfo.type = dimensionInfo.type || "float";
            if (!dimensionInfo.coordDim) {
                dimensionInfo.coordDim = dimensionName;
                dimensionInfo.coordDimIndex = 0;
            }
            var otherDims = dimensionInfo.otherDims = dimensionInfo.otherDims || {};
            dimensionNames.push(dimensionName);
            dimensionInfos[dimensionName] = dimensionInfo;
            if (emptyObj[dimensionName] != null) needsHasOwn = true;
            if (dimensionInfo.createInvertedIndices) invertedIndicesMap[dimensionName] = [];
            var dimIdx = i;
            if ($7a1bd9c2710fea0d$export$7e4aa119212bc614(dimensionInfo.storeDimIndex)) dimIdx = dimensionInfo.storeDimIndex;
            if (otherDims.itemName === 0) this._nameDimIdx = dimIdx;
            if (otherDims.itemId === 0) this._idDimIdx = dimIdx;
            if (assignStoreDimIdx) dimensionInfo.storeDimIndex = i;
        }
        this.dimensions = dimensionNames;
        this._dimInfos = dimensionInfos;
        this._initGetDimensionInfo(needsHasOwn);
        this.hostModel = hostModel;
        this._invertedIndicesMap = invertedIndicesMap;
        if (this._dimOmitted) {
            var dimIdxToName_1 = this._dimIdxToName = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(dimensionNames, function(dimName) {
                dimIdxToName_1.set(dimensionInfos[dimName].storeDimIndex, dimName);
            });
        }
    }
    /**
   *
   * Get concrete dimension name by dimension name or dimension index.
   * If input a dimension name, do not validate whether the dimension name exits.
   *
   * @caution
   * @param dim Must make sure the dimension is `SeriesDimensionLoose`.
   * Because only those dimensions will have auto-generated dimension names if not
   * have a user-specified name, and other dimensions will get a return of null/undefined.
   *
   * @notice Because of this reason, should better use `getDimensionIndex` instead, for examples:
   * ```js
   * const val = data.getStore().get(data.getDimensionIndex(dim), dataIdx);
   * ```
   *
   * @return Concrete dim name.
   */ SeriesData.prototype.getDimension = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx == null) return dim;
        dimIdx = dim;
        if (!this._dimOmitted) return this.dimensions[dimIdx];
        // Retrieve from series dimension definition because it probably contains
        // generated dimension name (like 'x', 'y').
        var dimName = this._dimIdxToName.get(dimIdx);
        if (dimName != null) return dimName;
        var sourceDimDef = this._schema.getSourceDimension(dimIdx);
        if (sourceDimDef) return sourceDimDef.name;
    };
    /**
   * Get dimension index in data store. Return -1 if not found.
   * Can be used to index value from getRawValue.
   */ SeriesData.prototype.getDimensionIndex = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx != null) return dimIdx;
        if (dim == null) return -1;
        var dimInfo = this._getDimInfo(dim);
        return dimInfo ? dimInfo.storeDimIndex : this._dimOmitted ? this._schema.getSourceDimensionIndex(dim) : -1;
    };
    /**
   * The meanings of the input parameter `dim`:
   *
   * + If dim is a number (e.g., `1`), it means the index of the dimension.
   *   For example, `getDimension(0)` will return 'x' or 'lng' or 'radius'.
   * + If dim is a number-like string (e.g., `"1"`):
   *     + If there is the same concrete dim name defined in `series.dimensions` or `dataset.dimensions`,
   *        it means that concrete name.
   *     + If not, it will be converted to a number, which means the index of the dimension.
   *        (why? because of the backward compatibility. We have been tolerating number-like string in
   *        dimension setting, although now it seems that it is not a good idea.)
   *     For example, `visualMap[i].dimension: "1"` is the same meaning as `visualMap[i].dimension: 1`,
   *     if no dimension name is defined as `"1"`.
   * + If dim is a not-number-like string, it means the concrete dim name.
   *   For example, it can be be default name `"x"`, `"y"`, `"z"`, `"lng"`, `"lat"`, `"angle"`, `"radius"`,
   *   or customized in `dimensions` property of option like `"age"`.
   *
   * @return recognized `DimensionIndex`. Otherwise return null/undefined (means that dim is `DimensionName`).
   */ SeriesData.prototype._recognizeDimIndex = function(dim) {
        if ($7a1bd9c2710fea0d$export$7e4aa119212bc614(dim) || dim != null && !isNaN(dim) && !this._getDimInfo(dim) && (!this._dimOmitted || this._schema.getSourceDimensionIndex(dim) < 0)) return +dim;
    };
    SeriesData.prototype._getStoreDimIndex = function(dim) {
        var dimIdx = this.getDimensionIndex(dim);
        return dimIdx;
    };
    /**
   * Get type and calculation info of particular dimension
   * @param dim
   *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
   *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
   */ SeriesData.prototype.getDimensionInfo = function(dim) {
        // Do not clone, because there may be categories in dimInfo.
        return this._getDimInfo(this.getDimension(dim));
    };
    SeriesData.prototype._initGetDimensionInfo = function(needsHasOwn) {
        var dimensionInfos = this._dimInfos;
        this._getDimInfo = needsHasOwn ? function(dimName) {
            return dimensionInfos.hasOwnProperty(dimName) ? dimensionInfos[dimName] : undefined;
        } : function(dimName) {
            return dimensionInfos[dimName];
        };
    };
    /**
   * concrete dimension name list on coord.
   */ SeriesData.prototype.getDimensionsOnCoord = function() {
        return this._dimSummary.dataDimsOnCoord.slice();
    };
    SeriesData.prototype.mapDimension = function(coordDim, idx) {
        var dimensionsSummary = this._dimSummary;
        if (idx == null) return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
        var dims = dimensionsSummary.encode[coordDim];
        return dims ? dims[idx] : null;
    };
    SeriesData.prototype.mapDimensionsAll = function(coordDim) {
        var dimensionsSummary = this._dimSummary;
        var dims = dimensionsSummary.encode[coordDim];
        return (dims || []).slice();
    };
    SeriesData.prototype.getStore = function() {
        return this._store;
    };
    /**
   * Initialize from data
   * @param data source or data or data store.
   * @param nameList The name of a datum is used on data diff and
   *        default label/tooltip.
   *        A name can be specified in encode.itemName,
   *        or dataItem.name (only for series option data),
   *        or provided in nameList from outside.
   */ SeriesData.prototype.initData = function(data, nameList, dimValueGetter) {
        var _this = this;
        var store;
        if (data instanceof (0, $370e5aa482d8420b$export$2e2bcd8739ae039)) store = data;
        if (!store) {
            var dimensions = this.dimensions;
            var provider = (0, $99e22f5c2aa5094b$export$22b808bc02a60488)(data) || $7a1bd9c2710fea0d$export$1e2f57719e155213(data) ? new (0, $8ffb0d67e9446edb$export$b900d7c4c3952a40)(data, dimensions.length) : data;
            store = new (0, $370e5aa482d8420b$export$2e2bcd8739ae039)();
            var dimensionInfos = $0ab0556b819346fd$var$map(dimensions, function(dimName) {
                return {
                    type: _this._dimInfos[dimName].type,
                    property: dimName
                };
            });
            store.initData(provider, dimensionInfos, dimValueGetter);
        }
        this._store = store;
        // Reset
        this._nameList = (nameList || []).slice();
        this._idList = [];
        this._nameRepeatCount = {};
        this._doInit(0, store.count());
        // Cache summary info for fast visit. See "dimensionHelper".
        // Needs to be initialized after store is prepared.
        this._dimSummary = (0, $18085de91ae59d03$export$505a22c3734846f1)(this, this._schema);
        this.userOutput = this._dimSummary.userOutput;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ SeriesData.prototype.appendData = function(data) {
        var range = this._store.appendData(data);
        this._doInit(range[0], range[1]);
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   * This method does not modify `rawData` (`dataProvider`), but only
   * add values to store.
   *
   * The final count will be increased by `Math.max(values.length, names.length)`.
   *
   * @param values That is the SourceType: 'arrayRows', like
   *        [
   *            [12, 33, 44],
   *            [NaN, 43, 1],
   *            ['-', 'asdf', 0]
   *        ]
   *        Each item is exactly corresponding to a dimension.
   */ SeriesData.prototype.appendValues = function(values, names) {
        var _a = this._store.appendValues(values, names && names.length), start = _a.start, end = _a.end;
        var shouldMakeIdFromName = this._shouldMakeIdFromName();
        this._updateOrdinalMeta();
        if (names) for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start;
            this._nameList[idx] = names[sourceIdx];
            if (shouldMakeIdFromName) $0ab0556b819346fd$var$makeIdFromName(this, idx);
        }
    };
    SeriesData.prototype._updateOrdinalMeta = function() {
        var store = this._store;
        var dimensions = this.dimensions;
        for(var i = 0; i < dimensions.length; i++){
            var dimInfo = this._dimInfos[dimensions[i]];
            if (dimInfo.ordinalMeta) store.collectOrdinalMeta(dimInfo.storeDimIndex, dimInfo.ordinalMeta);
        }
    };
    SeriesData.prototype._shouldMakeIdFromName = function() {
        var provider = this._store.getProvider();
        return this._idDimIdx == null && provider.getSource().sourceFormat !== (0, $cab29724515ce2b8$export$a918cb016a382d45) && !provider.fillStorage;
    };
    SeriesData.prototype._doInit = function(start, end) {
        if (start >= end) return;
        var store = this._store;
        var provider = store.getProvider();
        this._updateOrdinalMeta();
        var nameList = this._nameList;
        var idList = this._idList;
        var sourceFormat = provider.getSource().sourceFormat;
        var isFormatOriginal = sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6);
        // Each data item is value
        // [1, 2]
        // 2
        // Bar chart, line chart which uses category axis
        // only gives the 'y' value. 'x' value is the indices of category
        // Use a tempValue to normalize the value to be a (x, y) value
        // If dataItem is {name: ...} or {id: ...}, it has highest priority.
        // This kind of ids and names are always stored `_nameList` and `_idList`.
        if (isFormatOriginal && !provider.pure) {
            var sharedDataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                var dataItem = provider.getItem(idx, sharedDataItem);
                if (!this.hasItemOption && (0, $76d619f648247e6d$export$3e1a543f33ef6883)(dataItem)) this.hasItemOption = true;
                if (dataItem) {
                    var itemName = dataItem.name;
                    if (nameList[idx] == null && itemName != null) nameList[idx] = (0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(itemName, null);
                    var itemId = dataItem.id;
                    if (idList[idx] == null && itemId != null) idList[idx] = (0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(itemId, null);
                }
            }
        }
        if (this._shouldMakeIdFromName()) for(var idx = start; idx < end; idx++)$0ab0556b819346fd$var$makeIdFromName(this, idx);
        $0ab0556b819346fd$var$prepareInvertedIndex(this);
    };
    /**
   * PENDING: In fact currently this function is only used to short-circuit
   * the calling of `scale.unionExtentFromData` when data have been filtered by modules
   * like "dataZoom". `scale.unionExtentFromData` is used to calculate data extent for series on
   * an axis, but if a "axis related data filter module" is used, the extent of the axis have
   * been fixed and no need to calling `scale.unionExtentFromData` actually.
   * But if we add "custom data filter" in future, which is not "axis related", this method may
   * be still needed.
   *
   * Optimize for the scenario that data is filtered by a given extent.
   * Consider that if data amount is more than hundreds of thousand,
   * extent calculation will cost more than 10ms and the cache will
   * be erased because of the filtering.
   */ SeriesData.prototype.getApproximateExtent = function(dim) {
        return this._approximateExtent[dim] || this._store.getDataExtent(this._getStoreDimIndex(dim));
    };
    /**
   * Calculate extent on a filtered data might be time consuming.
   * Approximate extent is only used for: calculate extent of filtered data outside.
   */ SeriesData.prototype.setApproximateExtent = function(extent, dim) {
        dim = this.getDimension(dim);
        this._approximateExtent[dim] = extent.slice();
    };
    SeriesData.prototype.getCalculationInfo = function(key) {
        return this._calculationInfo[key];
    };
    SeriesData.prototype.setCalculationInfo = function(key, value) {
        $0ab0556b819346fd$var$isObject(key) ? $7a1bd9c2710fea0d$export$8b58be045bf06082(this._calculationInfo, key) : this._calculationInfo[key] = value;
    };
    /**
   * @return Never be null/undefined. `number` will be converted to string. Because:
   * In most cases, name is used in display, where returning a string is more convenient.
   * In other cases, name is used in query (see `indexOfName`), where we can keep the
   * rule that name `2` equals to name `'2'`.
   */ SeriesData.prototype.getName = function(idx) {
        var rawIndex = this.getRawIndex(idx);
        var name = this._nameList[rawIndex];
        if (name == null && this._nameDimIdx != null) name = $0ab0556b819346fd$var$getIdNameFromStore(this, this._nameDimIdx, rawIndex);
        if (name == null) name = "";
        return name;
    };
    SeriesData.prototype._getCategory = function(dimIdx, idx) {
        var ordinal = this._store.get(dimIdx, idx);
        var ordinalMeta = this._store.getOrdinalMeta(dimIdx);
        if (ordinalMeta) return ordinalMeta.categories[ordinal];
        return ordinal;
    };
    /**
   * @return Never null/undefined. `number` will be converted to string. Because:
   * In all cases having encountered at present, id is used in making diff comparison, which
   * are usually based on hash map. We can keep the rule that the internal id are always string
   * (treat `2` is the same as `'2'`) to make the related logic simple.
   */ SeriesData.prototype.getId = function(idx) {
        return $0ab0556b819346fd$var$getId(this, this.getRawIndex(idx));
    };
    SeriesData.prototype.count = function() {
        return this._store.count();
    };
    /**
   * Get value. Return NaN if idx is out of range.
   *
   * @notice Should better to use `data.getStore().get(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.get = function(dim, idx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.get(dimInfo.storeDimIndex, idx);
    };
    /**
   * @notice Should better to use `data.getStore().getByRawIndex(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.getByRawIndex = function(dim, rawIdx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.getByRawIndex(dimInfo.storeDimIndex, rawIdx);
    };
    SeriesData.prototype.getIndices = function() {
        return this._store.getIndices();
    };
    SeriesData.prototype.getDataExtent = function(dim) {
        return this._store.getDataExtent(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getSum = function(dim) {
        return this._store.getSum(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getMedian = function(dim) {
        return this._store.getMedian(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getValues = function(dimensions, idx) {
        var _this = this;
        var store = this._store;
        return $7a1bd9c2710fea0d$export$43bee75e5e14138e(dimensions) ? store.getValues($0ab0556b819346fd$var$map(dimensions, function(dim) {
            return _this._getStoreDimIndex(dim);
        }), idx) : store.getValues(dimensions);
    };
    /**
   * If value is NaN. Including '-'
   * Only check the coord dimensions.
   */ SeriesData.prototype.hasValue = function(idx) {
        var dataDimIndicesOnCoord = this._dimSummary.dataDimIndicesOnCoord;
        for(var i = 0, len = dataDimIndicesOnCoord.length; i < len; i++){
            // Ordinal type originally can be string or number.
            // But when an ordinal type is used on coord, it can
            // not be string but only number. So we can also use isNaN.
            if (isNaN(this._store.get(dataDimIndicesOnCoord[i], idx))) return false;
        }
        return true;
    };
    /**
   * Retrieve the index with given name
   */ SeriesData.prototype.indexOfName = function(name) {
        for(var i = 0, len = this._store.count(); i < len; i++){
            if (this.getName(i) === name) return i;
        }
        return -1;
    };
    SeriesData.prototype.getRawIndex = function(idx) {
        return this._store.getRawIndex(idx);
    };
    SeriesData.prototype.indexOfRawIndex = function(rawIndex) {
        return this._store.indexOfRawIndex(rawIndex);
    };
    /**
   * Only support the dimension which inverted index created.
   * Do not support other cases until required.
   * @param dim concrete dim
   * @param value ordinal index
   * @return rawIndex
   */ SeriesData.prototype.rawIndexOf = function(dim, value) {
        var invertedIndices = dim && this._invertedIndicesMap[dim];
        var rawIndex = invertedIndices && invertedIndices[value];
        if (rawIndex == null || isNaN(rawIndex)) return $0ab0556b819346fd$var$INDEX_NOT_FOUND;
        return rawIndex;
    };
    SeriesData.prototype.each = function(dims, cb, ctx) {
        "use strict";
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $0ab0556b819346fd$var$map($0ab0556b819346fd$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store.each(dimIndices, fCtx ? $7a1bd9c2710fea0d$export$2385a24977818dd0(cb, fCtx) : cb);
    };
    SeriesData.prototype.filterSelf = function(dims, cb, ctx) {
        "use strict";
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $0ab0556b819346fd$var$map($0ab0556b819346fd$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store = this._store.filter(dimIndices, fCtx ? $7a1bd9c2710fea0d$export$2385a24977818dd0(cb, fCtx) : cb);
        return this;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ SeriesData.prototype.selectRange = function(range) {
        "use strict";
        var _this = this;
        var innerRange = {};
        var dims = $7a1bd9c2710fea0d$export$ed97f33186d4b816(range);
        var dimIndices = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(dims, function(dim) {
            var dimIdx = _this._getStoreDimIndex(dim);
            innerRange[dimIdx] = range[dim];
            dimIndices.push(dimIdx);
        });
        this._store = this._store.selectRange(innerRange);
        return this;
    };
    /* eslint-enable max-len */ SeriesData.prototype.mapArray = function(dims, cb, ctx) {
        "use strict";
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        ctx = ctx || this;
        var result = [];
        this.each(dims, function() {
            result.push(cb && cb.apply(this, arguments));
        }, ctx);
        return result;
    };
    SeriesData.prototype.map = function(dims, cb, ctx, ctxCompat) {
        "use strict";
        // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $0ab0556b819346fd$var$map($0ab0556b819346fd$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        var list = $0ab0556b819346fd$var$cloneListForMapAndSample(this);
        list._store = this._store.map(dimIndices, fCtx ? $7a1bd9c2710fea0d$export$2385a24977818dd0(cb, fCtx) : cb);
        return list;
    };
    SeriesData.prototype.modify = function(dims, cb, ctx, ctxCompat) {
        var _this = this;
        // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $0ab0556b819346fd$var$map($0ab0556b819346fd$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        // If do shallow clone here, if there are too many stacked series,
        // it still cost lots of memory, because `_store.dimensions` are not shared.
        // We should consider there probably be shallow clone happen in each series
        // in consequent filter/map.
        this._store.modify(dimIndices, fCtx ? $7a1bd9c2710fea0d$export$2385a24977818dd0(cb, fCtx) : cb);
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ SeriesData.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var list = $0ab0556b819346fd$var$cloneListForMapAndSample(this);
        list._store = this._store.downSample(this._getStoreDimIndex(dimension), rate, sampleValue, sampleIndex);
        return list;
    };
    /**
   * Large data down sampling using min-max
   * @param {string} valueDimension
   * @param {number} rate
   */ SeriesData.prototype.minmaxDownSample = function(valueDimension, rate) {
        var list = $0ab0556b819346fd$var$cloneListForMapAndSample(this);
        list._store = this._store.minmaxDownSample(this._getStoreDimIndex(valueDimension), rate);
        return list;
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ SeriesData.prototype.lttbDownSample = function(valueDimension, rate) {
        var list = $0ab0556b819346fd$var$cloneListForMapAndSample(this);
        list._store = this._store.lttbDownSample(this._getStoreDimIndex(valueDimension), rate);
        return list;
    };
    SeriesData.prototype.getRawDataItem = function(idx) {
        return this._store.getRawDataItem(idx);
    };
    /**
   * Get model of one data item.
   */ // TODO: Type of data item
    SeriesData.prototype.getItemModel = function(idx) {
        var hostModel = this.hostModel;
        var dataItem = this.getRawDataItem(idx);
        return new (0, $6818646a97528290$export$2e2bcd8739ae039)(dataItem, hostModel, hostModel && hostModel.ecModel);
    };
    /**
   * Create a data differ
   */ SeriesData.prototype.diff = function(otherList) {
        var thisList = this;
        return new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(otherList ? otherList.getStore().getIndices() : [], this.getStore().getIndices(), function(idx) {
            return $0ab0556b819346fd$var$getId(otherList, idx);
        }, function(idx) {
            return $0ab0556b819346fd$var$getId(thisList, idx);
        });
    };
    /**
   * Get visual property.
   */ SeriesData.prototype.getVisual = function(key) {
        var visual = this._visual;
        return visual && visual[key];
    };
    SeriesData.prototype.setVisual = function(kvObj, val) {
        this._visual = this._visual || {};
        if ($0ab0556b819346fd$var$isObject(kvObj)) $7a1bd9c2710fea0d$export$8b58be045bf06082(this._visual, kvObj);
        else this._visual[kvObj] = val;
    };
    /**
   * Get visual property of single data item
   */ // eslint-disable-next-line
    SeriesData.prototype.getItemVisual = function(idx, key) {
        var itemVisual = this._itemVisuals[idx];
        var val = itemVisual && itemVisual[key];
        if (val == null) // Use global visual property
        return this.getVisual(key);
        return val;
    };
    /**
   * If exists visual property of single data item
   */ SeriesData.prototype.hasItemVisual = function() {
        return this._itemVisuals.length > 0;
    };
    /**
   * Make sure itemVisual property is unique
   */ // TODO: use key to save visual to reduce memory.
    SeriesData.prototype.ensureUniqueItemVisual = function(idx, key) {
        var itemVisuals = this._itemVisuals;
        var itemVisual = itemVisuals[idx];
        if (!itemVisual) itemVisual = itemVisuals[idx] = {};
        var val = itemVisual[key];
        if (val == null) {
            val = this.getVisual(key);
            // TODO Performance?
            if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(val)) val = val.slice();
            else if ($0ab0556b819346fd$var$isObject(val)) val = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, val);
            itemVisual[key] = val;
        }
        return val;
    };
    // eslint-disable-next-line
    SeriesData.prototype.setItemVisual = function(idx, key, value) {
        var itemVisual = this._itemVisuals[idx] || {};
        this._itemVisuals[idx] = itemVisual;
        if ($0ab0556b819346fd$var$isObject(key)) $7a1bd9c2710fea0d$export$8b58be045bf06082(itemVisual, key);
        else itemVisual[key] = value;
    };
    /**
   * Clear itemVisuals and list visual.
   */ SeriesData.prototype.clearAllVisual = function() {
        this._visual = {};
        this._itemVisuals = [];
    };
    SeriesData.prototype.setLayout = function(key, val) {
        $0ab0556b819346fd$var$isObject(key) ? $7a1bd9c2710fea0d$export$8b58be045bf06082(this._layout, key) : this._layout[key] = val;
    };
    /**
   * Get layout property.
   */ SeriesData.prototype.getLayout = function(key) {
        return this._layout[key];
    };
    /**
   * Get layout of single data item
   */ SeriesData.prototype.getItemLayout = function(idx) {
        return this._itemLayouts[idx];
    };
    /**
   * Set layout of single data item
   */ SeriesData.prototype.setItemLayout = function(idx, layout, merge) {
        this._itemLayouts[idx] = merge ? $7a1bd9c2710fea0d$export$8b58be045bf06082(this._itemLayouts[idx] || {}, layout) : layout;
    };
    /**
   * Clear all layout of single data item
   */ SeriesData.prototype.clearItemLayouts = function() {
        this._itemLayouts.length = 0;
    };
    /**
   * Set graphic element relative to data. It can be set as null
   */ SeriesData.prototype.setItemGraphicEl = function(idx, el) {
        var seriesIndex = this.hostModel && this.hostModel.seriesIndex;
        (0, $b1983a2fffd47d56$export$30d6736ebb8e18d5)(seriesIndex, this.dataType, idx, el);
        this._graphicEls[idx] = el;
    };
    SeriesData.prototype.getItemGraphicEl = function(idx) {
        return this._graphicEls[idx];
    };
    SeriesData.prototype.eachItemGraphicEl = function(cb, context) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._graphicEls, function(el, idx) {
            if (el) cb && cb.call(context, el, idx);
        });
    };
    /**
   * Shallow clone a new list except visual and layout properties, and graph elements.
   * New list only change the indices.
   */ SeriesData.prototype.cloneShallow = function(list) {
        if (!list) list = new SeriesData(this._schema ? this._schema : $0ab0556b819346fd$var$map(this.dimensions, this._getDimInfo, this), this.hostModel);
        $0ab0556b819346fd$var$transferProperties(list, this);
        list._store = this._store;
        return list;
    };
    /**
   * Wrap some method to add more feature
   */ SeriesData.prototype.wrapMethod = function(methodName, injectFunction) {
        var originalMethod = this[methodName];
        if (!$7a1bd9c2710fea0d$export$f6e2535fb5126e54(originalMethod)) return;
        this.__wrappedMethods = this.__wrappedMethods || [];
        this.__wrappedMethods.push(methodName);
        this[methodName] = function() {
            var res = originalMethod.apply(this, arguments);
            return injectFunction.apply(this, [
                res
            ].concat($7a1bd9c2710fea0d$export$58adb3bec8346d0f(arguments)));
        };
    };
    // ----------------------------------------------------------
    // A work around for internal method visiting private member.
    // ----------------------------------------------------------
    SeriesData.internalField = function() {
        $0ab0556b819346fd$var$prepareInvertedIndex = function(data) {
            var invertedIndicesMap = data._invertedIndicesMap;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(invertedIndicesMap, function(invertedIndices, dim) {
                var dimInfo = data._dimInfos[dim];
                // Currently, only dimensions that has ordinalMeta can create inverted indices.
                var ordinalMeta = dimInfo.ordinalMeta;
                var store = data._store;
                if (ordinalMeta) {
                    invertedIndices = invertedIndicesMap[dim] = new $0ab0556b819346fd$var$CtorInt32Array(ordinalMeta.categories.length);
                    // The default value of TypedArray is 0. To avoid miss
                    // mapping to 0, we should set it as INDEX_NOT_FOUND.
                    for(var i = 0; i < invertedIndices.length; i++)invertedIndices[i] = $0ab0556b819346fd$var$INDEX_NOT_FOUND;
                    for(var i = 0; i < store.count(); i++)// Only support the case that all values are distinct.
                    invertedIndices[store.get(dimInfo.storeDimIndex, i)] = i;
                }
            });
        };
        $0ab0556b819346fd$var$getIdNameFromStore = function(data, dimIdx, idx) {
            return (0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(data._getCategory(dimIdx, idx), null);
        };
        /**
     * @see the comment of `List['getId']`.
     */ $0ab0556b819346fd$var$getId = function(data, rawIndex) {
            var id = data._idList[rawIndex];
            if (id == null && data._idDimIdx != null) id = $0ab0556b819346fd$var$getIdNameFromStore(data, data._idDimIdx, rawIndex);
            if (id == null) id = $0ab0556b819346fd$var$ID_PREFIX + rawIndex;
            return id;
        };
        $0ab0556b819346fd$var$normalizeDimensions = function(dimensions) {
            if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(dimensions)) dimensions = dimensions != null ? [
                dimensions
            ] : [];
            return dimensions;
        };
        /**
     * Data in excludeDimensions is copied, otherwise transferred.
     */ $0ab0556b819346fd$var$cloneListForMapAndSample = function(original) {
            var list = new SeriesData(original._schema ? original._schema : $0ab0556b819346fd$var$map(original.dimensions, original._getDimInfo, original), original.hostModel);
            // FIXME If needs stackedOn, value may already been stacked
            $0ab0556b819346fd$var$transferProperties(list, original);
            return list;
        };
        $0ab0556b819346fd$var$transferProperties = function(target, source) {
            $7a1bd9c2710fea0d$export$79b2f7037acddd43($0ab0556b819346fd$var$TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function(propName) {
                if (source.hasOwnProperty(propName)) target[propName] = source[propName];
            });
            target.__wrappedMethods = source.__wrappedMethods;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43($0ab0556b819346fd$var$CLONE_PROPERTIES, function(propName) {
                target[propName] = $7a1bd9c2710fea0d$export$9cd59f9826255e47(source[propName]);
            });
            target._calculationInfo = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, source._calculationInfo);
        };
        $0ab0556b819346fd$var$makeIdFromName = function(data, idx) {
            var nameList = data._nameList;
            var idList = data._idList;
            var nameDimIdx = data._nameDimIdx;
            var idDimIdx = data._idDimIdx;
            var name = nameList[idx];
            var id = idList[idx];
            if (name == null && nameDimIdx != null) nameList[idx] = name = $0ab0556b819346fd$var$getIdNameFromStore(data, nameDimIdx, idx);
            if (id == null && idDimIdx != null) idList[idx] = id = $0ab0556b819346fd$var$getIdNameFromStore(data, idDimIdx, idx);
            if (id == null && name != null) {
                var nameRepeatCount = data._nameRepeatCount;
                var nmCnt = nameRepeatCount[name] = (nameRepeatCount[name] || 0) + 1;
                id = name;
                if (nmCnt > 1) id += "__ec__" + nmCnt;
                idList[idx] = id;
            }
        };
    }();
    return SeriesData;
}();
var $0ab0556b819346fd$export$2e2bcd8739ae039 = $0ab0556b819346fd$var$SeriesData;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







function $a27631012b7b377c$export$8066c1b52b2e9504(source, opt) {
    return $a27631012b7b377c$export$2e2bcd8739ae039(source, opt).dimensions;
}
function $a27631012b7b377c$export$2e2bcd8739ae039(// TODO: TYPE completeDimensions type
source, opt) {
    if (!(0, $99e22f5c2aa5094b$export$22b808bc02a60488)(source)) source = (0, $99e22f5c2aa5094b$export$75aef3f97c0a5edf)(source);
    opt = opt || {};
    var sysDims = opt.coordDimensions || [];
    var dimsDef = opt.dimensionsDefine || source.dimensionsDefine || [];
    var coordDimNameMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var resultList = [];
    var dimCount = $a27631012b7b377c$var$getDimCount(source, sysDims, dimsDef, opt.dimensionsCount);
    // Try to ignore unused dimensions if sharing a high dimension datastore
    // 30 is an experience value.
    var omitUnusedDimensions = opt.canOmitUnusedDimensions && (0, $85b723b311a86ffc$export$238b87930d825d87)(dimCount);
    var isUsingSourceDimensionsDef = dimsDef === source.dimensionsDefine;
    var dataDimNameMap = isUsingSourceDimensionsDef ? (0, $85b723b311a86ffc$export$be39ae17310c33f7)(source) : (0, $85b723b311a86ffc$export$a477f5bebfd07944)(dimsDef);
    var encodeDef = opt.encodeDefine;
    if (!encodeDef && opt.encodeDefaulter) encodeDef = opt.encodeDefaulter(source, dimCount);
    var encodeDefMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)(encodeDef);
    var indicesMap = new (0, $370e5aa482d8420b$export$b60d945128546f53)(dimCount);
    for(var i = 0; i < indicesMap.length; i++)indicesMap[i] = -1;
    function getResultItem(dimIdx) {
        var idx = indicesMap[dimIdx];
        if (idx < 0) {
            var dimDefItemRaw = dimsDef[dimIdx];
            var dimDefItem = (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dimDefItemRaw) ? dimDefItemRaw : {
                name: dimDefItemRaw
            };
            var resultItem = new (0, $5e233867ea3713e7$export$2e2bcd8739ae039)();
            var userDimName = dimDefItem.name;
            if (userDimName != null && dataDimNameMap.get(userDimName) != null) // Only if `series.dimensions` is defined in option
            // displayName, will be set, and dimension will be displayed vertically in
            // tooltip by default.
            resultItem.name = resultItem.displayName = userDimName;
            dimDefItem.type != null && (resultItem.type = dimDefItem.type);
            dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
            var newIdx = resultList.length;
            indicesMap[dimIdx] = newIdx;
            resultItem.storeDimIndex = dimIdx;
            resultList.push(resultItem);
            return resultItem;
        }
        return resultList[idx];
    }
    if (!omitUnusedDimensions) for(var i = 0; i < dimCount; i++)getResultItem(i);
    // Set `coordDim` and `coordDimIndex` by `encodeDefMap` and normalize `encodeDefMap`.
    encodeDefMap.each(function(dataDimsRaw, coordDim) {
        var dataDims = (0, $76d619f648247e6d$export$4f07b212a02c8051)(dataDimsRaw).slice();
        // Note: It is allowed that `dataDims.length` is `0`, e.g., options is
        // `{encode: {x: -1, y: 1}}`. Should not filter anything in
        // this case.
        if (dataDims.length === 1 && !(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(dataDims[0]) && dataDims[0] < 0) {
            encodeDefMap.set(coordDim, false);
            return;
        }
        var validDataDims = encodeDefMap.set(coordDim, []);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dataDims, function(resultDimIdxOrName, idx) {
            // The input resultDimIdx can be dim name or index.
            var resultDimIdx = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(resultDimIdxOrName) ? dataDimNameMap.get(resultDimIdxOrName) : resultDimIdxOrName;
            if (resultDimIdx != null && resultDimIdx < dimCount) {
                validDataDims[idx] = resultDimIdx;
                applyDim(getResultItem(resultDimIdx), coordDim, idx);
            }
        });
    });
    // Apply templates and default order from `sysDims`.
    var availDimIdx = 0;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(sysDims, function(sysDimItemRaw) {
        var coordDim;
        var sysDimItemDimsDef;
        var sysDimItemOtherDims;
        var sysDimItem;
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(sysDimItemRaw)) {
            coordDim = sysDimItemRaw;
            sysDimItem = {};
        } else {
            sysDimItem = sysDimItemRaw;
            coordDim = sysDimItem.name;
            var ordinalMeta = sysDimItem.ordinalMeta;
            sysDimItem.ordinalMeta = null;
            sysDimItem = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, sysDimItem);
            sysDimItem.ordinalMeta = ordinalMeta;
            // `coordDimIndex` should not be set directly.
            sysDimItemDimsDef = sysDimItem.dimsDef;
            sysDimItemOtherDims = sysDimItem.otherDims;
            sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
        }
        var dataDims = encodeDefMap.get(coordDim);
        // negative resultDimIdx means no need to mapping.
        if (dataDims === false) return;
        dataDims = (0, $76d619f648247e6d$export$4f07b212a02c8051)(dataDims);
        // dimensions provides default dim sequences.
        if (!dataDims.length) for(var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++){
            while(availDimIdx < dimCount && getResultItem(availDimIdx).coordDim != null)availDimIdx++;
            availDimIdx < dimCount && dataDims.push(availDimIdx++);
        }
        // Apply templates.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dataDims, function(resultDimIdx, coordDimIndex) {
            var resultItem = getResultItem(resultDimIdx);
            // Coordinate system has a higher priority on dim type than source.
            if (isUsingSourceDimensionsDef && sysDimItem.type != null) resultItem.type = sysDimItem.type;
            applyDim((0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(resultItem, sysDimItem), coordDim, coordDimIndex);
            if (resultItem.name == null && sysDimItemDimsDef) {
                var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
                !(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
                    name: sysDimItemDimsDefItem
                });
                resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
                resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
            }
            // FIXME refactor, currently only used in case: {otherDims: {tooltip: false}}
            sysDimItemOtherDims && (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(resultItem.otherDims, sysDimItemOtherDims);
        });
    });
    function applyDim(resultItem, coordDim, coordDimIndex) {
        if ((0, $cab29724515ce2b8$export$cd51b5ca77f6f0e4).get(coordDim) != null) resultItem.otherDims[coordDim] = coordDimIndex;
        else {
            resultItem.coordDim = coordDim;
            resultItem.coordDimIndex = coordDimIndex;
            coordDimNameMap.set(coordDim, true);
        }
    }
    // Make sure the first extra dim is 'value'.
    var generateCoord = opt.generateCoord;
    var generateCoordCount = opt.generateCoordCount;
    var fromZero = generateCoordCount != null;
    generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
    var extra = generateCoord || "value";
    function ifNoNameFillWithCoordName(resultItem) {
        if (resultItem.name == null) // Duplication will be removed in the next step.
        resultItem.name = resultItem.coordDim;
    }
    // Set dim `name` and other `coordDim` and other props.
    if (!omitUnusedDimensions) for(var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++){
        var resultItem = getResultItem(resultDimIdx);
        var coordDim = resultItem.coordDim;
        if (coordDim == null) {
            // TODO no need to generate coordDim for isExtraCoord?
            resultItem.coordDim = $a27631012b7b377c$var$genCoordDimName(extra, coordDimNameMap, fromZero);
            resultItem.coordDimIndex = 0;
            // Series specified generateCoord is using out.
            if (!generateCoord || generateCoordCount <= 0) resultItem.isExtraCoord = true;
            generateCoordCount--;
        }
        ifNoNameFillWithCoordName(resultItem);
        if (resultItem.type == null && ((0, $7dc6cdfd7450ef29$export$c51adf1a2be01b9c)(source, resultDimIdx) === (0, $7dc6cdfd7450ef29$export$328749e9c5b40760).Must || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) resultItem.type = "ordinal";
    }
    else {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(resultList, function(resultItem) {
            // PENDING: guessOrdinal or let user specify type: 'ordinal' manually?
            ifNoNameFillWithCoordName(resultItem);
        });
        // Sort dimensions: there are some rule that use the last dim as label,
        // and for some latter travel process easier.
        resultList.sort(function(item0, item1) {
            return item0.storeDimIndex - item1.storeDimIndex;
        });
    }
    $a27631012b7b377c$var$removeDuplication(resultList);
    return new (0, $85b723b311a86ffc$export$a1ef064685775f3e)({
        source: source,
        dimensions: resultList,
        fullDimensionCount: dimCount,
        dimensionOmitted: omitUnusedDimensions
    });
}
function $a27631012b7b377c$var$removeDuplication(result) {
    var duplicationMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    for(var i = 0; i < result.length; i++){
        var dim = result[i];
        var dimOriginalName = dim.name;
        var count = duplicationMap.get(dimOriginalName) || 0;
        if (count > 0) // Starts from 0.
        dim.name = dimOriginalName + (count - 1);
        count++;
        duplicationMap.set(dimOriginalName, count);
    }
}
// ??? TODO
// Originally detect dimCount by data[0]. Should we
// optimize it to only by sysDims and dimensions and encode.
// So only necessary dims will be initialized.
// But
// (1) custom series should be considered. where other dims
// may be visited.
// (2) sometimes user need to calculate bubble size or use visualMap
// on other dimensions besides coordSys needed.
// So, dims that is not used by system, should be shared in data store?
function $a27631012b7b377c$var$getDimCount(source, sysDims, dimsDef, optDimCount) {
    // Note that the result dimCount should not small than columns count
    // of data, otherwise `dataDimNameMap` checking will be incorrect.
    var dimCount = Math.max(source.dimensionsDetectedCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(sysDims, function(sysDimItem) {
        var sysDimItemDimsDef;
        if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(sysDimItem) && (sysDimItemDimsDef = sysDimItem.dimsDef)) dimCount = Math.max(dimCount, sysDimItemDimsDef.length);
    });
    return dimCount;
}
function $a27631012b7b377c$var$genCoordDimName(name, map, fromZero) {
    if (fromZero || map.hasKey(name)) {
        var i = 0;
        while(map.hasKey(name + i))i++;
        name += i;
    }
    map.set(name, true);
    return name;
}





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Helper for model references.
 * There are many manners to refer axis/coordSys.
 */ // TODO
// merge relevant logic to this file?
// check: "modelHelper" of tooltip and "BrushTargetManager".


/**
 * @class
 * For example:
 * {
 *     coordSysName: 'cartesian2d',
 *     coordSysDims: ['x', 'y', ...],
 *     axisMap: HashMap({
 *         x: xAxisModel,
 *         y: yAxisModel
 *     }),
 *     categoryAxisMap: HashMap({
 *         x: xAxisModel,
 *         y: undefined
 *     }),
 *     // The index of the first category axis in `coordSysDims`.
 *     // `null/undefined` means no category axis exists.
 *     firstCategoryDimIndex: 1,
 *     // To replace user specified encode.
 * }
 */ var $a97e3a3e4c0c9c28$var$CoordSysInfo = /** @class */ function() {
    function CoordSysInfo(coordSysName) {
        this.coordSysDims = [];
        this.axisMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        this.categoryAxisMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        this.coordSysName = coordSysName;
    }
    return CoordSysInfo;
}();
function $a97e3a3e4c0c9c28$export$f2befeb2f4933656(seriesModel) {
    var coordSysName = seriesModel.get("coordinateSystem");
    var result = new $a97e3a3e4c0c9c28$var$CoordSysInfo(coordSysName);
    var fetch = $a97e3a3e4c0c9c28$var$fetchers[coordSysName];
    if (fetch) {
        fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
        return result;
    }
}
// TODO: refactor them to static member of each coord sys, rather than hard code here.
var $a97e3a3e4c0c9c28$var$fetchers = {
    cartesian2d: function(seriesModel, result, axisMap, categoryAxisMap) {
        var xAxisModel = seriesModel.getReferringComponents("xAxis", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        var yAxisModel = seriesModel.getReferringComponents("yAxis", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        result.coordSysDims = [
            "x",
            "y"
        ];
        axisMap.set("x", xAxisModel);
        axisMap.set("y", yAxisModel);
        if ($a97e3a3e4c0c9c28$var$isCategory(xAxisModel)) {
            categoryAxisMap.set("x", xAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($a97e3a3e4c0c9c28$var$isCategory(yAxisModel)) {
            categoryAxisMap.set("y", yAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    singleAxis: function(seriesModel, result, axisMap, categoryAxisMap) {
        var singleAxisModel = seriesModel.getReferringComponents("singleAxis", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        result.coordSysDims = [
            "single"
        ];
        axisMap.set("single", singleAxisModel);
        if ($a97e3a3e4c0c9c28$var$isCategory(singleAxisModel)) {
            categoryAxisMap.set("single", singleAxisModel);
            result.firstCategoryDimIndex = 0;
        }
    },
    polar: function(seriesModel, result, axisMap, categoryAxisMap) {
        var polarModel = seriesModel.getReferringComponents("polar", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        var radiusAxisModel = polarModel.findAxisModel("radiusAxis");
        var angleAxisModel = polarModel.findAxisModel("angleAxis");
        result.coordSysDims = [
            "radius",
            "angle"
        ];
        axisMap.set("radius", radiusAxisModel);
        axisMap.set("angle", angleAxisModel);
        if ($a97e3a3e4c0c9c28$var$isCategory(radiusAxisModel)) {
            categoryAxisMap.set("radius", radiusAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($a97e3a3e4c0c9c28$var$isCategory(angleAxisModel)) {
            categoryAxisMap.set("angle", angleAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    geo: function(seriesModel, result, axisMap, categoryAxisMap) {
        result.coordSysDims = [
            "lng",
            "lat"
        ];
    },
    parallel: function(seriesModel, result, axisMap, categoryAxisMap) {
        var ecModel = seriesModel.ecModel;
        var parallelModel = ecModel.getComponent("parallel", seriesModel.get("parallelIndex"));
        var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(parallelModel.parallelAxisIndex, function(axisIndex, index) {
            var axisModel = ecModel.getComponent("parallelAxis", axisIndex);
            var axisDim = coordSysDims[index];
            axisMap.set(axisDim, axisModel);
            if ($a97e3a3e4c0c9c28$var$isCategory(axisModel)) {
                categoryAxisMap.set(axisDim, axisModel);
                if (result.firstCategoryDimIndex == null) result.firstCategoryDimIndex = index;
            }
        });
    },
    matrix: function(seriesModel, result, axisMap, categoryAxisMap) {
        var matrixModel = seriesModel.getReferringComponents("matrix", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        result.coordSysDims = [
            "x",
            "y"
        ];
        var xModel = matrixModel.getDimensionModel("x");
        var yModel = matrixModel.getDimensionModel("y");
        axisMap.set("x", xModel);
        axisMap.set("y", yModel);
        categoryAxisMap.set("x", xModel);
        categoryAxisMap.set("y", yModel);
    }
};
function $a97e3a3e4c0c9c28$var$isCategory(axisModel) {
    return axisModel.get("type") === "category";
}






function $8afdec5f59c90781$var$getCoordSysDimDefs(seriesModel, coordSysInfo) {
    var coordSysName = seriesModel.get("coordinateSystem");
    var registeredCoordSys = (0, $70c3ede7d3b64757$export$2e2bcd8739ae039).get(coordSysName);
    var coordSysDimDefs;
    if (coordSysInfo && coordSysInfo.coordSysDims) coordSysDimDefs = $7a1bd9c2710fea0d$export$871de8747c9eaa88(coordSysInfo.coordSysDims, function(dim) {
        var dimInfo = {
            name: dim
        };
        var axisModel = coordSysInfo.axisMap.get(dim);
        if (axisModel) {
            var axisType = axisModel.get("type");
            dimInfo.type = (0, $18085de91ae59d03$export$af1622903e71278e)(axisType);
        }
        return dimInfo;
    });
    if (!coordSysDimDefs) // Get dimensions from registered coordinate system
    coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || [
        "x",
        "y"
    ];
    return coordSysDimDefs;
}
function $8afdec5f59c90781$var$injectOrdinalMeta(dimInfoList, createInvertedIndices, coordSysInfo) {
    var firstCategoryDimIndex;
    var hasNameEncode;
    coordSysInfo && $7a1bd9c2710fea0d$export$79b2f7037acddd43(dimInfoList, function(dimInfo, dimIndex) {
        var coordDim = dimInfo.coordDim;
        var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);
        if (categoryAxisModel) {
            if (firstCategoryDimIndex == null) firstCategoryDimIndex = dimIndex;
            dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();
            if (createInvertedIndices) dimInfo.createInvertedIndices = true;
        }
        if (dimInfo.otherDims.itemName != null) hasNameEncode = true;
    });
    if (!hasNameEncode && firstCategoryDimIndex != null) dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
    return firstCategoryDimIndex;
}
/**
 * Caution: there are side effects to `sourceManager` in this method.
 * Should better only be called in `Series['getInitialData']`.
 */ function $8afdec5f59c90781$var$createSeriesData(sourceRaw, seriesModel, opt) {
    opt = opt || {};
    var sourceManager = seriesModel.getSourceManager();
    var source;
    var isOriginalSource = false;
    if (sourceRaw) {
        isOriginalSource = true;
        source = (0, $99e22f5c2aa5094b$export$75aef3f97c0a5edf)(sourceRaw);
    } else {
        source = sourceManager.getSource();
        // Is series.data. not dataset.
        isOriginalSource = source.sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6);
    }
    var coordSysInfo = (0, $a97e3a3e4c0c9c28$export$f2befeb2f4933656)(seriesModel);
    var coordSysDimDefs = $8afdec5f59c90781$var$getCoordSysDimDefs(seriesModel, coordSysInfo);
    var useEncodeDefaulter = opt.useEncodeDefaulter;
    var encodeDefaulter = $7a1bd9c2710fea0d$export$f6e2535fb5126e54(useEncodeDefaulter) ? useEncodeDefaulter : useEncodeDefaulter ? $7a1bd9c2710fea0d$export$c3095a23b368d1f2((0, $7dc6cdfd7450ef29$export$37682b8fdd2e83d), coordSysDimDefs, seriesModel) : null;
    var createDimensionOptions = {
        coordDimensions: coordSysDimDefs,
        generateCoord: opt.generateCoord,
        encodeDefine: seriesModel.getEncode(),
        encodeDefaulter: encodeDefaulter,
        canOmitUnusedDimensions: !isOriginalSource
    };
    var schema = (0, $a27631012b7b377c$export$2e2bcd8739ae039)(source, createDimensionOptions);
    var firstCategoryDimIndex = $8afdec5f59c90781$var$injectOrdinalMeta(schema.dimensions, opt.createInvertedIndices, coordSysInfo);
    var store = !isOriginalSource ? sourceManager.getSharedDataStore(schema) : null;
    var stackCalculationInfo = (0, $efdd976e4917927c$export$f2165f9e8499b278)(seriesModel, {
        schema: schema,
        store: store
    });
    var data = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(schema, seriesModel);
    data.setCalculationInfo(stackCalculationInfo);
    var dimValueGetter = firstCategoryDimIndex != null && $8afdec5f59c90781$var$isNeedCompleteOrdinalData(source) ? function(itemOpt, dimName, dataIndex, dimIndex) {
        // Use dataIndex as ordinal value in categoryAxis
        return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
    } : null;
    data.hasItemOption = false;
    data.initData(// Try to reuse the data store in sourceManager if using dataset.
    isOriginalSource ? source : store, null, dimValueGetter);
    return data;
}
function $8afdec5f59c90781$var$isNeedCompleteOrdinalData(source) {
    if (source.sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6)) {
        var sampleItem = $8afdec5f59c90781$var$firstDataNotNull(source.data || []);
        return !$7a1bd9c2710fea0d$export$43bee75e5e14138e((0, $76d619f648247e6d$export$2c944e12edb48d4b)(sampleItem));
    }
}
function $8afdec5f59c90781$var$firstDataNotNull(arr) {
    var i = 0;
    while(i < arr.length && arr[i] == null)i++;
    return arr[i];
}
var $8afdec5f59c90781$export$2e2bcd8739ae039 = $8afdec5f59c90781$var$createSeriesData;



var $b508252f98157abf$var$BaseBarSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BaseBarSeriesModel, _super);
    function BaseBarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BaseBarSeriesModel.type;
        return _this;
    }
    BaseBarSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true
        });
    };
    BaseBarSeriesModel.prototype.getMarkerPosition = function(value, dims, startingAtTick) {
        var coordSys = this.coordinateSystem;
        if (coordSys && coordSys.clampData) {
            // PENDING if clamp ?
            var clampData_1 = coordSys.clampData(value);
            var pt_1 = coordSys.dataToPoint(clampData_1);
            if (startingAtTick) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordSys.getAxes(), function(axis, idx) {
                // If axis type is category, use tick coords instead
                if (axis.type === "category" && dims != null) {
                    var tickCoords = axis.getTicksCoords();
                    var alignTicksWithLabel = axis.getTickModel().get("alignWithLabel");
                    var targetTickId = clampData_1[idx];
                    // The index of rightmost tick of markArea is 1 larger than x1/y1 index
                    var isEnd = dims[idx] === "x1" || dims[idx] === "y1";
                    if (isEnd && !alignTicksWithLabel) targetTickId += 1;
                    // The only contains one tick, tickCoords is
                    // like [{coord: 0, tickValue: 0}, {coord: 0}]
                    // to the length should always be larger than 1
                    if (tickCoords.length < 2) return;
                    else if (tickCoords.length === 2) {
                        // The left value and right value of the axis are
                        // the same. coord is 0 in both items. Use the max
                        // value of the axis as the coord
                        pt_1[idx] = axis.toGlobalCoord(axis.getExtent()[isEnd ? 1 : 0]);
                        return;
                    }
                    var leftCoord = void 0;
                    var coord = void 0;
                    var stepTickValue = 1;
                    for(var i = 0; i < tickCoords.length; i++){
                        var tickCoord = tickCoords[i].coord;
                        // The last item of tickCoords doesn't contain
                        // tickValue
                        var tickValue = i === tickCoords.length - 1 ? tickCoords[i - 1].tickValue + stepTickValue : tickCoords[i].tickValue;
                        if (tickValue === targetTickId) {
                            coord = tickCoord;
                            break;
                        } else if (tickValue < targetTickId) leftCoord = tickCoord;
                        else if (leftCoord != null && tickValue > targetTickId) {
                            coord = (tickCoord + leftCoord) / 2;
                            break;
                        }
                        if (i === 1) // Here we assume the step of category axes is
                        // the same
                        stepTickValue = tickValue - tickCoords[0].tickValue;
                    }
                    if (coord == null) {
                        if (!leftCoord) // targetTickId is smaller than all tick ids in the
                        // visible area, use the leftmost tick coord
                        coord = tickCoords[0].coord;
                        else if (leftCoord) // targetTickId is larger than all tick ids in the
                        // visible area, use the rightmost tick coord
                        coord = tickCoords[tickCoords.length - 1].coord;
                    }
                    pt_1[idx] = axis.toGlobalCoord(coord);
                }
            });
            else {
                var data = this.getData();
                var offset = data.getLayout("offset");
                var size = data.getLayout("size");
                var offsetIndex = coordSys.getBaseAxis().isHorizontal() ? 0 : 1;
                pt_1[offsetIndex] += offset + size / 2;
            }
            return pt_1;
        }
        return [
            NaN,
            NaN
        ];
    };
    BaseBarSeriesModel.type = "series.__base_bar__";
    BaseBarSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: "cartesian2d",
        legendHoverLink: true,
        // stack: null
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        barMinHeight: 0,
        barMinAngle: 0,
        // cursor: null,
        large: false,
        largeThreshold: 400,
        progressive: 3e3,
        progressiveChunkMode: "mod",
        defaultBarGap: "10%"
    };
    return BaseBarSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
(0, $7c10febb2cdef0d8$export$2e2bcd8739ae039).registerClass($b508252f98157abf$var$BaseBarSeriesModel);
var $b508252f98157abf$export$2e2bcd8739ae039 = $b508252f98157abf$var$BaseBarSeriesModel;





var $1db8e2e676cae702$var$BarSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BarSeriesModel, _super);
    function BarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BarSeriesModel.type;
        return _this;
    }
    BarSeriesModel.prototype.getInitialData = function() {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true,
            createInvertedIndices: !!this.get("realtimeSort", true) || null
        });
    };
    /**
   * @override
   */ BarSeriesModel.prototype.getProgressive = function() {
        // Do not support progressive in normal mode.
        return this.get("large") ? this.get("progressive") : false;
    };
    /**
   * @override
   */ BarSeriesModel.prototype.getProgressiveThreshold = function() {
        // Do not support progressive in normal mode.
        var progressiveThreshold = this.get("progressiveThreshold");
        var largeThreshold = this.get("largeThreshold");
        if (largeThreshold > progressiveThreshold) progressiveThreshold = largeThreshold;
        return progressiveThreshold;
    };
    BarSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        return selectors.rect(data.getItemLayout(dataIndex));
    };
    BarSeriesModel.type = "series.bar";
    BarSeriesModel.dependencies = [
        "grid",
        "polar"
    ];
    BarSeriesModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $b508252f98157abf$export$2e2bcd8739ae039).defaultOption, {
        // If clipped
        // Only available on cartesian2d
        clip: true,
        roundCap: false,
        showBackground: false,
        backgroundStyle: {
            color: "rgba(180, 180, 180, 0.2)",
            borderColor: null,
            borderWidth: 0,
            borderType: "solid",
            borderRadius: 0,
            shadowBlur: 0,
            shadowColor: null,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            opacity: 1
        },
        select: {
            itemStyle: {
                borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.primary,
                borderWidth: 2
            }
        },
        realtimeSort: false
    });
    return BarSeriesModel;
}((0, $b508252f98157abf$export$2e2bcd8739ae039));
var $1db8e2e676cae702$export$2e2bcd8739ae039 = $1db8e2e676cae702$var$BarSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $0e2cc04b3aaad400$export$83958787eb658d14(cartesian, hasAnimation, seriesModel, done, during) {
    var rect = cartesian.getArea();
    var x = rect.x;
    var y = rect.y;
    var width = rect.width;
    var height = rect.height;
    var lineWidth = seriesModel.get([
        "lineStyle",
        "width"
    ]) || 0;
    // Expand the clip path a bit to avoid the border is clipped and looks thinner
    x -= lineWidth / 2;
    y -= lineWidth / 2;
    width += lineWidth;
    height += lineWidth;
    // fix: https://github.com/apache/incubator-echarts/issues/11369
    width = Math.ceil(width);
    if (x !== Math.floor(x)) {
        x = Math.floor(x);
        // if no extra 1px on `width`, it will still be clipped since `x` is floored
        width++;
    }
    var clipPath = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        shape: {
            x: x,
            y: y,
            width: width,
            height: height
        }
    });
    if (hasAnimation) {
        var baseAxis = cartesian.getBaseAxis();
        var isHorizontal = baseAxis.isHorizontal();
        var isAxisInversed = baseAxis.inverse;
        if (isHorizontal) {
            if (isAxisInversed) clipPath.shape.x += width;
            clipPath.shape.width = 0;
        } else {
            if (!isAxisInversed) clipPath.shape.y += height;
            clipPath.shape.height = 0;
        }
        var duringCb = (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(during) ? function(percent) {
            during(percent, clipPath);
        } : null;
        $8b353638fbedfefa$export$a121566aadcfe021(clipPath, {
            shape: {
                width: width,
                height: height,
                x: x,
                y: y
            }
        }, seriesModel, null, done, duringCb);
    }
    return clipPath;
}
function $0e2cc04b3aaad400$export$13dc2b2230df3cb5(polar, hasAnimation, seriesModel) {
    var sectorArea = polar.getArea();
    // Avoid float number rounding error for symbol on the edge of axis extent.
    var r0 = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(sectorArea.r0, 1);
    var r = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(sectorArea.r, 1);
    var clipPath = new $a3e1dec0a3875b49$export$2e2bcd8739ae039({
        shape: {
            cx: (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(polar.cx, 1),
            cy: (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(polar.cy, 1),
            r0: r0,
            r: r,
            startAngle: sectorArea.startAngle,
            endAngle: sectorArea.endAngle,
            clockwise: sectorArea.clockwise
        }
    });
    if (hasAnimation) {
        var isRadial = polar.getBaseAxis().dim === "angle";
        if (isRadial) clipPath.shape.endAngle = sectorArea.startAngle;
        else clipPath.shape.r = r0;
        $8b353638fbedfefa$export$a121566aadcfe021(clipPath, {
            shape: {
                endAngle: sectorArea.endAngle,
                r: r
            }
        }, seriesModel);
    }
    return clipPath;
}
function $0e2cc04b3aaad400$export$e0fe5081209d01c9(coordSys, hasAnimation, seriesModel, done, during) {
    if (!coordSys) return null;
    else if (coordSys.type === "polar") return $0e2cc04b3aaad400$export$13dc2b2230df3cb5(coordSys, hasAnimation, seriesModel);
    else if (coordSys.type === "cartesian2d") return $0e2cc04b3aaad400$export$83958787eb658d14(coordSys, hasAnimation, seriesModel, done, during);
    return null;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/**
 * Sausage: similar to sector, but have half circle on both sides
 */ var $9674946a7a7df213$var$SausageShape = /** @class */ function() {
    function SausageShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return SausageShape;
}();
var $9674946a7a7df213$var$SausagePath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SausagePath, _super);
    function SausagePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "sausage";
        return _this;
    }
    SausagePath.prototype.getDefaultShape = function() {
        return new $9674946a7a7df213$var$SausageShape();
    };
    SausagePath.prototype.buildPath = function(ctx, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var r0 = Math.max(shape.r0 || 0, 0);
        var r = Math.max(shape.r, 0);
        var dr = (r - r0) * 0.5;
        var rCenter = r0 + dr;
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var PI2 = Math.PI * 2;
        var lessThanCircle = clockwise ? endAngle - startAngle < PI2 : startAngle - endAngle < PI2;
        if (!lessThanCircle) // Normalize angles
        startAngle = endAngle - (clockwise ? PI2 : -PI2);
        var unitStartX = Math.cos(startAngle);
        var unitStartY = Math.sin(startAngle);
        var unitEndX = Math.cos(endAngle);
        var unitEndY = Math.sin(endAngle);
        if (lessThanCircle) {
            ctx.moveTo(unitStartX * r0 + cx, unitStartY * r0 + cy);
            ctx.arc(unitStartX * rCenter + cx, unitStartY * rCenter + cy, dr, -Math.PI + startAngle, startAngle, !clockwise);
        } else ctx.moveTo(unitStartX * r + cx, unitStartY * r + cy);
        ctx.arc(cx, cy, r, startAngle, endAngle, !clockwise);
        ctx.arc(unitEndX * rCenter + cx, unitEndY * rCenter + cy, dr, endAngle - Math.PI * 2, endAngle - Math.PI, !clockwise);
        if (r0 !== 0) ctx.arc(cx, cy, r0, endAngle, startAngle, clockwise);
    // ctx.closePath();
    };
    return SausagePath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
var $9674946a7a7df213$export$2e2bcd8739ae039 = $9674946a7a7df213$var$SausagePath;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $3fea949f0512eb55$export$8567506e6336616(coordSys, type) {
    return coordSys.type === type;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $b2475f850d3c0bc2$export$5ff20667590927ed(data, dataIndex) {
    var labelDims = data.mapDimensionsAll("defaultedLabel");
    var len = labelDims.length;
    // Simple optimization (in lots of cases, label dims length is 1)
    if (len === 1) {
        var rawVal = (0, $8ffb0d67e9446edb$export$cde9373da9aad801)(data, dataIndex, labelDims[0]);
        return rawVal != null ? rawVal + "" : null;
    } else if (len) {
        var vals = [];
        for(var i = 0; i < labelDims.length; i++)vals.push((0, $8ffb0d67e9446edb$export$cde9373da9aad801)(data, dataIndex, labelDims[i]));
        return vals.join(" ");
    }
}
function $b2475f850d3c0bc2$export$5f84815e91ca6775(data, interpolatedValue) {
    var labelDims = data.mapDimensionsAll("defaultedLabel");
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(interpolatedValue)) return interpolatedValue + "";
    var vals = [];
    for(var i = 0; i < labelDims.length; i++){
        var dimIndex = data.getDimensionIndex(labelDims[i]);
        if (dimIndex >= 0) vals.push(interpolatedValue[dimIndex]);
    }
    return vals.join(" ");
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $5e4aaa173c31cda6$export$359a1e2d210ed734(positionMapping, opts) {
    opts = opts || {};
    var isRoundCap = opts.isRoundCap;
    return function(out, opts, boundingRect) {
        var textPosition = opts.position;
        if (!textPosition || textPosition instanceof Array) return (0, $6c308355c7107803$export$eee3603b512feab7)(out, opts, boundingRect);
        var mappedSectorPosition = positionMapping(textPosition);
        var distance = opts.distance != null ? opts.distance : 5;
        var sector = this.shape;
        var cx = sector.cx;
        var cy = sector.cy;
        var r = sector.r;
        var r0 = sector.r0;
        var middleR = (r + r0) / 2;
        var startAngle = sector.startAngle;
        var endAngle = sector.endAngle;
        var middleAngle = (startAngle + endAngle) / 2;
        var extraDist = isRoundCap ? Math.abs(r - r0) / 2 : 0;
        var mathCos = Math.cos;
        var mathSin = Math.sin;
        // base position: top-left
        var x = cx + r * mathCos(startAngle);
        var y = cy + r * mathSin(startAngle);
        var textAlign = "left";
        var textVerticalAlign = "top";
        switch(mappedSectorPosition){
            case "startArc":
                x = cx + (r0 - distance) * mathCos(middleAngle);
                y = cy + (r0 - distance) * mathSin(middleAngle);
                textAlign = "center";
                textVerticalAlign = "top";
                break;
            case "insideStartArc":
                x = cx + (r0 + distance) * mathCos(middleAngle);
                y = cy + (r0 + distance) * mathSin(middleAngle);
                textAlign = "center";
                textVerticalAlign = "bottom";
                break;
            case "startAngle":
                x = cx + middleR * mathCos(startAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceX(startAngle, distance + extraDist, false);
                y = cy + middleR * mathSin(startAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceY(startAngle, distance + extraDist, false);
                textAlign = "right";
                textVerticalAlign = "middle";
                break;
            case "insideStartAngle":
                x = cx + middleR * mathCos(startAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceX(startAngle, -distance + extraDist, false);
                y = cy + middleR * mathSin(startAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceY(startAngle, -distance + extraDist, false);
                textAlign = "left";
                textVerticalAlign = "middle";
                break;
            case "middle":
                x = cx + middleR * mathCos(middleAngle);
                y = cy + middleR * mathSin(middleAngle);
                textAlign = "center";
                textVerticalAlign = "middle";
                break;
            case "endArc":
                x = cx + (r + distance) * mathCos(middleAngle);
                y = cy + (r + distance) * mathSin(middleAngle);
                textAlign = "center";
                textVerticalAlign = "bottom";
                break;
            case "insideEndArc":
                x = cx + (r - distance) * mathCos(middleAngle);
                y = cy + (r - distance) * mathSin(middleAngle);
                textAlign = "center";
                textVerticalAlign = "top";
                break;
            case "endAngle":
                x = cx + middleR * mathCos(endAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceX(endAngle, distance + extraDist, true);
                y = cy + middleR * mathSin(endAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceY(endAngle, distance + extraDist, true);
                textAlign = "left";
                textVerticalAlign = "middle";
                break;
            case "insideEndAngle":
                x = cx + middleR * mathCos(endAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceX(endAngle, -distance + extraDist, true);
                y = cy + middleR * mathSin(endAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceY(endAngle, -distance + extraDist, true);
                textAlign = "right";
                textVerticalAlign = "middle";
                break;
            default:
                return (0, $6c308355c7107803$export$eee3603b512feab7)(out, opts, boundingRect);
        }
        out = out || {};
        out.x = x;
        out.y = y;
        out.align = textAlign;
        out.verticalAlign = textVerticalAlign;
        return out;
    };
}
function $5e4aaa173c31cda6$export$672ce504c0db395a(sector, textPosition, positionMapping, rotateType) {
    if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rotateType)) {
        // user-set rotation
        sector.setTextConfig({
            rotation: rotateType
        });
        return;
    } else if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(textPosition)) {
        // user-set position, use 0 as auto rotation
        sector.setTextConfig({
            rotation: 0
        });
        return;
    }
    var shape = sector.shape;
    var startAngle = shape.clockwise ? shape.startAngle : shape.endAngle;
    var endAngle = shape.clockwise ? shape.endAngle : shape.startAngle;
    var middleAngle = (startAngle + endAngle) / 2;
    var anchorAngle;
    var mappedSectorPosition = positionMapping(textPosition);
    switch(mappedSectorPosition){
        case "startArc":
        case "insideStartArc":
        case "middle":
        case "insideEndArc":
        case "endArc":
            anchorAngle = middleAngle;
            break;
        case "startAngle":
        case "insideStartAngle":
            anchorAngle = startAngle;
            break;
        case "endAngle":
        case "insideEndAngle":
            anchorAngle = endAngle;
            break;
        default:
            sector.setTextConfig({
                rotation: 0
            });
            return;
    }
    var rotate = Math.PI * 1.5 - anchorAngle;
    /**
   * TODO: labels with rotate > Math.PI / 2 should be rotate another
   * half round flipped to increase readability. However, only middle
   * position supports this for now, because in other positions, the
   * anchor point is not at the center of the text, so the positions
   * after rotating is not as expected.
   */ if (mappedSectorPosition === "middle" && rotate > Math.PI / 2 && rotate < Math.PI * 1.5) rotate -= Math.PI;
    sector.setTextConfig({
        rotation: rotate
    });
}
function $5e4aaa173c31cda6$var$adjustAngleDistanceX(angle, distance, isEnd) {
    return distance * Math.sin(angle) * (isEnd ? -1 : 1);
}
function $5e4aaa173c31cda6$var$adjustAngleDistanceY(angle, distance, isEnd) {
    return distance * Math.cos(angle) * (isEnd ? 1 : -1);
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $9491a9b96e203579$export$b395eeeb2ad7cce5(model, shape, zeroIfNull) {
    var cornerRadius = model.get("borderRadius");
    if (cornerRadius == null) return zeroIfNull ? {
        cornerRadius: 0
    } : null;
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(cornerRadius)) cornerRadius = [
        cornerRadius,
        cornerRadius,
        cornerRadius,
        cornerRadius
    ];
    var dr = Math.abs(shape.r || 0 - shape.r0 || 0);
    return {
        cornerRadius: (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(cornerRadius, function(cr) {
            return (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(cr, dr);
        })
    };
}


var $0b120d76f26c920d$var$mathMax = Math.max;
var $0b120d76f26c920d$var$mathMin = Math.min;
function $0b120d76f26c920d$var$getClipArea(coord, data) {
    var coordSysClipArea = coord.getArea && coord.getArea();
    if ((0, $3fea949f0512eb55$export$8567506e6336616)(coord, "cartesian2d")) {
        var baseAxis = coord.getBaseAxis();
        // When boundaryGap is false or using time axis. bar may exceed the grid.
        // We should not clip this part.
        // See test/bar2.html
        if (baseAxis.type !== "category" || !baseAxis.onBand) {
            var expandWidth = data.getLayout("bandWidth");
            if (baseAxis.isHorizontal()) {
                coordSysClipArea.x -= expandWidth;
                coordSysClipArea.width += expandWidth * 2;
            } else {
                coordSysClipArea.y -= expandWidth;
                coordSysClipArea.height += expandWidth * 2;
            }
        }
    }
    return coordSysClipArea;
}
var $0b120d76f26c920d$var$BarView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BarView, _super);
    function BarView() {
        var _this = _super.call(this) || this;
        _this.type = BarView.type;
        _this._isFirstFrame = true;
        return _this;
    }
    BarView.prototype.render = function(seriesModel, ecModel, api, payload) {
        this._model = seriesModel;
        this._removeOnRenderedListener(api);
        this._updateDrawMode(seriesModel);
        var coordinateSystemType = seriesModel.get("coordinateSystem");
        if (coordinateSystemType === "cartesian2d" || coordinateSystemType === "polar") {
            // Clear previously rendered progressive elements.
            this._progressiveEls = null;
            this._isLargeDraw ? this._renderLarge(seriesModel, ecModel, api) : this._renderNormal(seriesModel, ecModel, api, payload);
        }
    };
    BarView.prototype.incrementalPrepareRender = function(seriesModel) {
        this._clear();
        this._updateDrawMode(seriesModel);
        // incremental also need to clip, otherwise might be overlow.
        // But must not set clip in each frame, otherwise all of the children will be marked redraw.
        this._updateLargeClip(seriesModel);
    };
    BarView.prototype.incrementalRender = function(params, seriesModel) {
        // Reset
        this._progressiveEls = [];
        // Do not support progressive in normal mode.
        this._incrementalRenderLarge(params, seriesModel);
    };
    BarView.prototype.eachRendered = function(cb) {
        (0, $5b455ae6f843ac47$export$3e564442729bf048)(this._progressiveEls || this.group, cb);
    };
    BarView.prototype._updateDrawMode = function(seriesModel) {
        var isLargeDraw = seriesModel.pipelineContext.large;
        if (this._isLargeDraw == null || isLargeDraw !== this._isLargeDraw) {
            this._isLargeDraw = isLargeDraw;
            this._clear();
        }
    };
    BarView.prototype._renderNormal = function(seriesModel, ecModel, api, payload) {
        var group = this.group;
        var data = seriesModel.getData();
        var oldData = this._data;
        var coord = seriesModel.coordinateSystem;
        var baseAxis = coord.getBaseAxis();
        var isHorizontalOrRadial;
        if (coord.type === "cartesian2d") isHorizontalOrRadial = baseAxis.isHorizontal();
        else if (coord.type === "polar") isHorizontalOrRadial = baseAxis.dim === "angle";
        var animationModel = seriesModel.isAnimationEnabled() ? seriesModel : null;
        var realtimeSortCfg = $0b120d76f26c920d$var$shouldRealtimeSort(seriesModel, coord);
        if (realtimeSortCfg) this._enableRealtimeSort(realtimeSortCfg, data, api);
        var needsClip = seriesModel.get("clip", true) || realtimeSortCfg;
        var coordSysClipArea = $0b120d76f26c920d$var$getClipArea(coord, data);
        // If there is clipPath created in large mode. Remove it.
        group.removeClipPath();
        // We don't use clipPath in normal mode because we needs a perfect animation
        // And don't want the label are clipped.
        var roundCap = seriesModel.get("roundCap", true);
        var drawBackground = seriesModel.get("showBackground", true);
        var backgroundModel = seriesModel.getModel("backgroundStyle");
        var barBorderRadius = backgroundModel.get("borderRadius") || 0;
        var bgEls = [];
        var oldBgEls = this._backgroundEls;
        var isInitSort = payload && payload.isInitSort;
        var isChangeOrder = payload && payload.type === "changeAxisOrder";
        function createBackground(dataIndex) {
            var bgLayout = $0b120d76f26c920d$var$getLayout[coord.type](data, dataIndex);
            if (!bgLayout) return null;
            var bgEl = $0b120d76f26c920d$var$createBackgroundEl(coord, isHorizontalOrRadial, bgLayout);
            bgEl.useStyle(backgroundModel.getItemStyle());
            // Only cartesian2d support borderRadius.
            if (coord.type === "cartesian2d") bgEl.setShape("r", barBorderRadius);
            else bgEl.setShape("cornerRadius", barBorderRadius);
            bgEls[dataIndex] = bgEl;
            return bgEl;
        }
        data.diff(oldData).add(function(dataIndex) {
            var itemModel = data.getItemModel(dataIndex);
            var layout = $0b120d76f26c920d$var$getLayout[coord.type](data, dataIndex, itemModel);
            if (!layout) return;
            if (drawBackground) createBackground(dataIndex);
            // If dataZoom in filteMode: 'empty', the baseValue can be set as NaN in "axisProxy".
            if (!data.hasValue(dataIndex) || !$0b120d76f26c920d$var$isValidLayout[coord.type](layout)) return;
            var isClipped = false;
            if (needsClip) // Clip will modify the layout params.
            // And return a boolean to determine if the shape are fully clipped.
            isClipped = $0b120d76f26c920d$var$clip[coord.type](coordSysClipArea, layout);
            var el = $0b120d76f26c920d$var$elementCreator[coord.type](seriesModel, data, dataIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, false, roundCap);
            if (realtimeSortCfg) /**
         * Force label animation because even if the element is
         * ignored because it's clipped, it may not be clipped after
         * changing order. Then, if not using forceLabelAnimation,
         * the label animation was never started, in which case,
         * the label will be the final value and doesn't have label
         * animation.
         */ el.forceLabelAnimation = true;
            $0b120d76f26c920d$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === "polar");
            if (isInitSort) el.attr({
                shape: layout
            });
            else if (realtimeSortCfg) $0b120d76f26c920d$var$updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, dataIndex, isHorizontalOrRadial, false, false);
            else (0, $8b353638fbedfefa$export$a121566aadcfe021)(el, {
                shape: layout
            }, seriesModel, dataIndex);
            data.setItemGraphicEl(dataIndex, el);
            group.add(el);
            el.ignore = isClipped;
        }).update(function(newIndex, oldIndex) {
            var itemModel = data.getItemModel(newIndex);
            var layout = $0b120d76f26c920d$var$getLayout[coord.type](data, newIndex, itemModel);
            if (!layout) return;
            if (drawBackground) {
                var bgEl = void 0;
                if (oldBgEls.length === 0) bgEl = createBackground(oldIndex);
                else {
                    bgEl = oldBgEls[oldIndex];
                    bgEl.useStyle(backgroundModel.getItemStyle());
                    // Only cartesian2d support borderRadius.
                    if (coord.type === "cartesian2d") bgEl.setShape("r", barBorderRadius);
                    else bgEl.setShape("cornerRadius", barBorderRadius);
                    bgEls[newIndex] = bgEl;
                }
                var bgLayout = $0b120d76f26c920d$var$getLayout[coord.type](data, newIndex);
                var shape = $0b120d76f26c920d$var$createBackgroundShape(isHorizontalOrRadial, bgLayout, coord);
                (0, $8b353638fbedfefa$export$c8dce3c08436e91e)(bgEl, {
                    shape: shape
                }, animationModel, newIndex);
            }
            var el = oldData.getItemGraphicEl(oldIndex);
            if (!data.hasValue(newIndex) || !$0b120d76f26c920d$var$isValidLayout[coord.type](layout)) {
                group.remove(el);
                return;
            }
            var isClipped = false;
            if (needsClip) {
                isClipped = $0b120d76f26c920d$var$clip[coord.type](coordSysClipArea, layout);
                if (isClipped) group.remove(el);
            }
            var roundCapChanged = el && (el.type === "sector" && roundCap || el.type === "sausage" && !roundCap);
            if (roundCapChanged) {
                // roundCap changed, there is no way to use animation from a `sector` to a `sausage` shape,
                // so remove the old one and create a new shape
                el && (0, $8b353638fbedfefa$export$6d0fd725cb4aee8a)(el, seriesModel, oldIndex);
                el = null;
            }
            if (!el) el = $0b120d76f26c920d$var$elementCreator[coord.type](seriesModel, data, newIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, true, roundCap);
            else (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(el);
            if (realtimeSortCfg) el.forceLabelAnimation = true;
            if (isChangeOrder) {
                var textEl = el.getTextContent();
                if (textEl) {
                    var labelInnerStore = (0, $6800dfcb6e1e2a44$export$f62786d3261ab0f4)(textEl);
                    if (labelInnerStore.prevValue != null) /**
             * Set preValue to be value so that no new label
             * should be started, otherwise, it will take a full
             * `animationDurationUpdate` time to finish the
             * animation, which is not expected.
             */ labelInnerStore.prevValue = labelInnerStore.value;
                }
            } else $0b120d76f26c920d$var$updateStyle(el, data, newIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === "polar");
            if (isInitSort) el.attr({
                shape: layout
            });
            else if (realtimeSortCfg) $0b120d76f26c920d$var$updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, newIndex, isHorizontalOrRadial, true, isChangeOrder);
            else (0, $8b353638fbedfefa$export$c8dce3c08436e91e)(el, {
                shape: layout
            }, seriesModel, newIndex, null);
            data.setItemGraphicEl(newIndex, el);
            el.ignore = isClipped;
            group.add(el);
        }).remove(function(dataIndex) {
            var el = oldData.getItemGraphicEl(dataIndex);
            el && (0, $8b353638fbedfefa$export$6d0fd725cb4aee8a)(el, seriesModel, dataIndex);
        }).execute();
        var bgGroup = this._backgroundGroup || (this._backgroundGroup = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)());
        bgGroup.removeAll();
        for(var i = 0; i < bgEls.length; ++i)bgGroup.add(bgEls[i]);
        group.add(bgGroup);
        this._backgroundEls = bgEls;
        this._data = data;
    };
    BarView.prototype._renderLarge = function(seriesModel, ecModel, api) {
        this._clear();
        $0b120d76f26c920d$var$createLarge(seriesModel, this.group);
        this._updateLargeClip(seriesModel);
    };
    BarView.prototype._incrementalRenderLarge = function(params, seriesModel) {
        this._removeBackground();
        $0b120d76f26c920d$var$createLarge(seriesModel, this.group, this._progressiveEls, true);
    };
    BarView.prototype._updateLargeClip = function(seriesModel) {
        // Use clipPath in large mode.
        var clipPath = seriesModel.get("clip", true) && (0, $0e2cc04b3aaad400$export$e0fe5081209d01c9)(seriesModel.coordinateSystem, false, seriesModel);
        var group = this.group;
        if (clipPath) group.setClipPath(clipPath);
        else group.removeClipPath();
    };
    BarView.prototype._enableRealtimeSort = function(realtimeSortCfg, data, api) {
        var _this = this;
        // If no data in the first frame, wait for data to initSort
        if (!data.count()) return;
        var baseAxis = realtimeSortCfg.baseAxis;
        if (this._isFirstFrame) {
            this._dispatchInitSort(data, realtimeSortCfg, api);
            this._isFirstFrame = false;
        } else {
            var orderMapping_1 = function(idx) {
                var el = data.getItemGraphicEl(idx);
                var shape = el && el.shape;
                return shape && // The result should be consistent with the initial sort by data value.
                // Do not support the case that both positive and negative exist.
                Math.abs(baseAxis.isHorizontal() ? shape.height : shape.width) || 0;
            };
            this._onRendered = function() {
                _this._updateSortWithinSameData(data, orderMapping_1, baseAxis, api);
            };
            api.getZr().on("rendered", this._onRendered);
        }
    };
    BarView.prototype._dataSort = function(data, baseAxis, orderMapping) {
        var info = [];
        data.each(data.mapDimension(baseAxis.dim), function(ordinalNumber, dataIdx) {
            var mappedValue = orderMapping(dataIdx);
            mappedValue = mappedValue == null ? NaN : mappedValue;
            info.push({
                dataIndex: dataIdx,
                mappedValue: mappedValue,
                ordinalNumber: ordinalNumber
            });
        });
        info.sort(function(a, b) {
            // If NaN, it will be treated as min val.
            return b.mappedValue - a.mappedValue;
        });
        return {
            ordinalNumbers: (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(info, function(item) {
                return item.ordinalNumber;
            })
        };
    };
    BarView.prototype._isOrderChangedWithinSameData = function(data, orderMapping, baseAxis) {
        var scale = baseAxis.scale;
        var ordinalDataDim = data.mapDimension(baseAxis.dim);
        var lastValue = Number.MAX_VALUE;
        for(var tickNum = 0, len = scale.getOrdinalMeta().categories.length; tickNum < len; ++tickNum){
            var rawIdx = data.rawIndexOf(ordinalDataDim, scale.getRawOrdinalNumber(tickNum));
            var value = rawIdx < 0 ? Number.MIN_VALUE : orderMapping(data.indexOfRawIndex(rawIdx));
            if (value > lastValue) return true;
            lastValue = value;
        }
        return false;
    };
    /*
   * Consider the case when A and B changed order, whose representing
   * bars are both out of sight, we don't wish to trigger reorder action
   * as long as the order in the view doesn't change.
   */ BarView.prototype._isOrderDifferentInView = function(orderInfo, baseAxis) {
        var scale = baseAxis.scale;
        var extent = scale.getExtent();
        var tickNum = Math.max(0, extent[0]);
        var tickMax = Math.min(extent[1], scale.getOrdinalMeta().categories.length - 1);
        for(; tickNum <= tickMax; ++tickNum){
            if (orderInfo.ordinalNumbers[tickNum] !== scale.getRawOrdinalNumber(tickNum)) return true;
        }
    };
    BarView.prototype._updateSortWithinSameData = function(data, orderMapping, baseAxis, api) {
        if (!this._isOrderChangedWithinSameData(data, orderMapping, baseAxis)) return;
        var sortInfo = this._dataSort(data, baseAxis, orderMapping);
        if (this._isOrderDifferentInView(sortInfo, baseAxis)) {
            this._removeOnRenderedListener(api);
            api.dispatchAction({
                type: "changeAxisOrder",
                componentType: baseAxis.dim + "Axis",
                axisId: baseAxis.index,
                sortInfo: sortInfo
            });
        }
    };
    BarView.prototype._dispatchInitSort = function(data, realtimeSortCfg, api) {
        var baseAxis = realtimeSortCfg.baseAxis;
        var sortResult = this._dataSort(data, baseAxis, function(dataIdx) {
            return data.get(data.mapDimension(realtimeSortCfg.otherAxis.dim), dataIdx);
        });
        api.dispatchAction({
            type: "changeAxisOrder",
            componentType: baseAxis.dim + "Axis",
            isInitSort: true,
            axisId: baseAxis.index,
            sortInfo: sortResult
        });
    };
    BarView.prototype.remove = function(ecModel, api) {
        this._clear(this._model);
        this._removeOnRenderedListener(api);
    };
    BarView.prototype.dispose = function(ecModel, api) {
        this._removeOnRenderedListener(api);
    };
    BarView.prototype._removeOnRenderedListener = function(api) {
        if (this._onRendered) {
            api.getZr().off("rendered", this._onRendered);
            this._onRendered = null;
        }
    };
    BarView.prototype._clear = function(model) {
        var group = this.group;
        var data = this._data;
        if (model && model.isAnimationEnabled() && data && !this._isLargeDraw) {
            this._removeBackground();
            this._backgroundEls = [];
            data.eachItemGraphicEl(function(el) {
                (0, $8b353638fbedfefa$export$6d0fd725cb4aee8a)(el, model, (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).dataIndex);
            });
        } else group.removeAll();
        this._data = null;
        this._isFirstFrame = true;
    };
    BarView.prototype._removeBackground = function() {
        this.group.remove(this._backgroundGroup);
        this._backgroundGroup = null;
    };
    BarView.type = "bar";
    return BarView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $0b120d76f26c920d$var$clip = {
    cartesian2d: function(coordSysBoundingRect, layout) {
        var signWidth = layout.width < 0 ? -1 : 1;
        var signHeight = layout.height < 0 ? -1 : 1;
        // Needs positive width and height
        if (signWidth < 0) {
            layout.x += layout.width;
            layout.width = -layout.width;
        }
        if (signHeight < 0) {
            layout.y += layout.height;
            layout.height = -layout.height;
        }
        var coordSysX2 = coordSysBoundingRect.x + coordSysBoundingRect.width;
        var coordSysY2 = coordSysBoundingRect.y + coordSysBoundingRect.height;
        var x = $0b120d76f26c920d$var$mathMax(layout.x, coordSysBoundingRect.x);
        var x2 = $0b120d76f26c920d$var$mathMin(layout.x + layout.width, coordSysX2);
        var y = $0b120d76f26c920d$var$mathMax(layout.y, coordSysBoundingRect.y);
        var y2 = $0b120d76f26c920d$var$mathMin(layout.y + layout.height, coordSysY2);
        var xClipped = x2 < x;
        var yClipped = y2 < y;
        // When xClipped or yClipped, the element will be marked as `ignore`.
        // But we should also place the element at the edge of the coord sys bounding rect.
        // Because if data changed and the bar shows again, its transition animation
        // will begin at this place.
        layout.x = xClipped && x > coordSysX2 ? x2 : x;
        layout.y = yClipped && y > coordSysY2 ? y2 : y;
        layout.width = xClipped ? 0 : x2 - x;
        layout.height = yClipped ? 0 : y2 - y;
        // Reverse back
        if (signWidth < 0) {
            layout.x += layout.width;
            layout.width = -layout.width;
        }
        if (signHeight < 0) {
            layout.y += layout.height;
            layout.height = -layout.height;
        }
        return xClipped || yClipped;
    },
    polar: function(coordSysClipArea, layout) {
        var signR = layout.r0 <= layout.r ? 1 : -1;
        // Make sure r is larger than r0
        if (signR < 0) {
            var tmp = layout.r;
            layout.r = layout.r0;
            layout.r0 = tmp;
        }
        var r = $0b120d76f26c920d$var$mathMin(layout.r, coordSysClipArea.r);
        var r0 = $0b120d76f26c920d$var$mathMax(layout.r0, coordSysClipArea.r0);
        layout.r = r;
        layout.r0 = r0;
        var clipped = r - r0 < 0;
        // Reverse back
        if (signR < 0) {
            var tmp = layout.r;
            layout.r = layout.r0;
            layout.r0 = tmp;
        }
        return clipped;
    }
};
var $0b120d76f26c920d$var$elementCreator = {
    cartesian2d: function(seriesModel, data, newIndex, layout, isHorizontal, animationModel, axisModel, isUpdate, roundCap) {
        var rect = new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
            shape: (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, layout),
            z2: 1
        });
        rect.__dataIndex = newIndex;
        rect.name = "item";
        if (animationModel) {
            var rectShape = rect.shape;
            var animateProperty = isHorizontal ? "height" : "width";
            rectShape[animateProperty] = 0;
        }
        return rect;
    },
    polar: function(seriesModel, data, newIndex, layout, isRadial, animationModel, axisModel, isUpdate, roundCap) {
        var ShapeClass = !isRadial && roundCap ? (0, $9674946a7a7df213$export$2e2bcd8739ae039) : (0, $a3e1dec0a3875b49$export$2e2bcd8739ae039);
        var sector = new ShapeClass({
            shape: layout,
            z2: 1
        });
        sector.name = "item";
        var positionMap = $0b120d76f26c920d$var$createPolarPositionMapping(isRadial);
        sector.calculateTextPosition = (0, $5e4aaa173c31cda6$export$359a1e2d210ed734)(positionMap, {
            isRoundCap: ShapeClass === (0, $9674946a7a7df213$export$2e2bcd8739ae039)
        });
        // Animation
        if (animationModel) {
            var sectorShape = sector.shape;
            var animateProperty = isRadial ? "r" : "endAngle";
            var animateTarget = {};
            sectorShape[animateProperty] = isRadial ? layout.r0 : layout.startAngle;
            animateTarget[animateProperty] = layout[animateProperty];
            (isUpdate ? (0, $8b353638fbedfefa$export$c8dce3c08436e91e) : (0, $8b353638fbedfefa$export$a121566aadcfe021))(sector, {
                shape: animateTarget
            }, animationModel);
        }
        return sector;
    }
};
function $0b120d76f26c920d$var$shouldRealtimeSort(seriesModel, coordSys) {
    var realtimeSortOption = seriesModel.get("realtimeSort", true);
    var baseAxis = coordSys.getBaseAxis();
    if (realtimeSortOption && baseAxis.type === "category" && coordSys.type === "cartesian2d") return {
        baseAxis: baseAxis,
        otherAxis: coordSys.getOtherAxis(baseAxis)
    };
}
function $0b120d76f26c920d$var$updateRealtimeAnimation(realtimeSortCfg, seriesAnimationModel, el, layout, newIndex, isHorizontal, isUpdate, isChangeOrder) {
    var seriesTarget;
    var axisTarget;
    if (isHorizontal) {
        axisTarget = {
            x: layout.x,
            width: layout.width
        };
        seriesTarget = {
            y: layout.y,
            height: layout.height
        };
    } else {
        axisTarget = {
            y: layout.y,
            height: layout.height
        };
        seriesTarget = {
            x: layout.x,
            width: layout.width
        };
    }
    if (!isChangeOrder) // Keep the original growth animation if only axis order changed.
    // Not start a new animation.
    (isUpdate ? (0, $8b353638fbedfefa$export$c8dce3c08436e91e) : (0, $8b353638fbedfefa$export$a121566aadcfe021))(el, {
        shape: seriesTarget
    }, seriesAnimationModel, newIndex, null);
    var axisAnimationModel = seriesAnimationModel ? realtimeSortCfg.baseAxis.model : null;
    (isUpdate ? (0, $8b353638fbedfefa$export$c8dce3c08436e91e) : (0, $8b353638fbedfefa$export$a121566aadcfe021))(el, {
        shape: axisTarget
    }, axisAnimationModel, newIndex);
}
function $0b120d76f26c920d$var$checkPropertiesNotValid(obj, props) {
    for(var i = 0; i < props.length; i++){
        if (!isFinite(obj[props[i]])) return true;
    }
    return false;
}
var $0b120d76f26c920d$var$rectPropties = [
    "x",
    "y",
    "width",
    "height"
];
var $0b120d76f26c920d$var$polarPropties = [
    "cx",
    "cy",
    "r",
    "startAngle",
    "endAngle"
];
var $0b120d76f26c920d$var$isValidLayout = {
    cartesian2d: function(layout) {
        return !$0b120d76f26c920d$var$checkPropertiesNotValid(layout, $0b120d76f26c920d$var$rectPropties);
    },
    polar: function(layout) {
        return !$0b120d76f26c920d$var$checkPropertiesNotValid(layout, $0b120d76f26c920d$var$polarPropties);
    }
};
var $0b120d76f26c920d$var$getLayout = {
    // itemModel is only used to get borderWidth, which is not needed
    // when calculating bar background layout.
    cartesian2d: function(data, dataIndex, itemModel) {
        var layout = data.getItemLayout(dataIndex);
        if (!layout) return null;
        var fixedLineWidth = itemModel ? $0b120d76f26c920d$var$getLineWidth(itemModel, layout) : 0;
        // fix layout with lineWidth
        var signX = layout.width > 0 ? 1 : -1;
        var signY = layout.height > 0 ? 1 : -1;
        return {
            x: layout.x + signX * fixedLineWidth / 2,
            y: layout.y + signY * fixedLineWidth / 2,
            width: layout.width - signX * fixedLineWidth,
            height: layout.height - signY * fixedLineWidth
        };
    },
    polar: function(data, dataIndex, itemModel) {
        var layout = data.getItemLayout(dataIndex);
        return {
            cx: layout.cx,
            cy: layout.cy,
            r0: layout.r0,
            r: layout.r,
            startAngle: layout.startAngle,
            endAngle: layout.endAngle,
            clockwise: layout.clockwise
        };
    }
};
function $0b120d76f26c920d$var$isZeroOnPolar(layout) {
    return layout.startAngle != null && layout.endAngle != null && layout.startAngle === layout.endAngle;
}
function $0b120d76f26c920d$var$createPolarPositionMapping(isRadial) {
    return function(isRadial) {
        var arcOrAngle = isRadial ? "Arc" : "Angle";
        return function(position) {
            switch(position){
                case "start":
                case "insideStart":
                case "end":
                case "insideEnd":
                    return position + arcOrAngle;
                default:
                    return position;
            }
        };
    }(isRadial);
}
function $0b120d76f26c920d$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, isPolar) {
    var style = data.getItemVisual(dataIndex, "style");
    if (!isPolar) {
        var borderRadius = itemModel.get([
            "itemStyle",
            "borderRadius"
        ]) || 0;
        el.setShape("r", borderRadius);
    } else if (!seriesModel.get("roundCap")) {
        var sectorShape = el.shape;
        var cornerRadius = (0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemModel.getModel("itemStyle"), sectorShape, true);
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(sectorShape, cornerRadius);
        el.setShape(sectorShape);
    }
    el.useStyle(style);
    var cursorStyle = itemModel.getShallow("cursor");
    cursorStyle && el.attr("cursor", cursorStyle);
    var labelPositionOutside = isPolar ? isHorizontalOrRadial ? layout.r >= layout.r0 ? "endArc" : "startArc" : layout.endAngle >= layout.startAngle ? "endAngle" : "startAngle" : isHorizontalOrRadial ? layout.height >= 0 ? "bottom" : "top" : layout.width >= 0 ? "right" : "left";
    var labelStatesModels = (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel);
    (0, $6800dfcb6e1e2a44$export$9a13992917966657)(el, labelStatesModels, {
        labelFetcher: seriesModel,
        labelDataIndex: dataIndex,
        defaultText: (0, $b2475f850d3c0bc2$export$5ff20667590927ed)(seriesModel.getData(), dataIndex),
        inheritColor: style.fill,
        defaultOpacity: style.opacity,
        defaultOutsidePosition: labelPositionOutside
    });
    var label = el.getTextContent();
    if (isPolar && label) {
        var position = itemModel.get([
            "label",
            "position"
        ]);
        el.textConfig.inside = position === "middle" ? true : null;
        (0, $5e4aaa173c31cda6$export$672ce504c0db395a)(el, position === "outside" ? labelPositionOutside : position, $0b120d76f26c920d$var$createPolarPositionMapping(isHorizontalOrRadial), itemModel.get([
            "label",
            "rotate"
        ]));
    }
    (0, $6800dfcb6e1e2a44$export$7bdbceaf9ab378f2)(label, labelStatesModels, seriesModel.getRawValue(dataIndex), function(value) {
        return (0, $b2475f850d3c0bc2$export$5f84815e91ca6775)(data, value);
    });
    var emphasisModel = itemModel.getModel([
        "emphasis"
    ]);
    (0, $2bf82c0980125b62$export$e51187539ff11209)(el, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
    (0, $2bf82c0980125b62$export$48b68047d330bbc9)(el, itemModel);
    if ($0b120d76f26c920d$var$isZeroOnPolar(layout)) {
        el.style.fill = "none";
        el.style.stroke = "none";
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(el.states, function(state) {
            if (state.style) state.style.fill = state.style.stroke = "none";
        });
    }
}
// In case width or height are too small.
function $0b120d76f26c920d$var$getLineWidth(itemModel, rawLayout) {
    // Has no border.
    var borderColor = itemModel.get([
        "itemStyle",
        "borderColor"
    ]);
    if (!borderColor || borderColor === "none") return 0;
    var lineWidth = itemModel.get([
        "itemStyle",
        "borderWidth"
    ]) || 0;
    // width or height may be NaN for empty data
    var width = isNaN(rawLayout.width) ? Number.MAX_VALUE : Math.abs(rawLayout.width);
    var height = isNaN(rawLayout.height) ? Number.MAX_VALUE : Math.abs(rawLayout.height);
    return Math.min(lineWidth, width, height);
}
var $0b120d76f26c920d$var$LagePathShape = /** @class */ function() {
    function LagePathShape() {}
    return LagePathShape;
}();
var $0b120d76f26c920d$var$LargePath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LargePath, _super);
    function LargePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "largeBar";
        return _this;
    }
    LargePath.prototype.getDefaultShape = function() {
        return new $0b120d76f26c920d$var$LagePathShape();
    };
    LargePath.prototype.buildPath = function(ctx, shape) {
        // Drawing lines is more efficient than drawing
        // a whole line or drawing rects.
        var points = shape.points;
        var baseDimIdx = this.baseDimIdx;
        var valueDimIdx = 1 - this.baseDimIdx;
        var startPoint = [];
        var size = [];
        var barWidth = this.barWidth;
        for(var i = 0; i < points.length; i += 3){
            size[baseDimIdx] = barWidth;
            size[valueDimIdx] = points[i + 2];
            startPoint[baseDimIdx] = points[i + baseDimIdx];
            startPoint[valueDimIdx] = points[i + valueDimIdx];
            ctx.rect(startPoint[0], startPoint[1], size[0], size[1]);
        }
    };
    return LargePath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
function $0b120d76f26c920d$var$createLarge(seriesModel, group, progressiveEls, incremental) {
    // TODO support polar
    var data = seriesModel.getData();
    var baseDimIdx = data.getLayout("valueAxisHorizontal") ? 1 : 0;
    var largeDataIndices = data.getLayout("largeDataIndices");
    var barWidth = data.getLayout("size");
    var backgroundModel = seriesModel.getModel("backgroundStyle");
    var bgPoints = data.getLayout("largeBackgroundPoints");
    if (bgPoints) {
        var bgEl = new $0b120d76f26c920d$var$LargePath({
            shape: {
                points: bgPoints
            },
            incremental: !!incremental,
            silent: true,
            z2: 0
        });
        bgEl.baseDimIdx = baseDimIdx;
        bgEl.largeDataIndices = largeDataIndices;
        bgEl.barWidth = barWidth;
        bgEl.useStyle(backgroundModel.getItemStyle());
        group.add(bgEl);
        progressiveEls && progressiveEls.push(bgEl);
    }
    var el = new $0b120d76f26c920d$var$LargePath({
        shape: {
            points: data.getLayout("largePoints")
        },
        incremental: !!incremental,
        ignoreCoarsePointer: true,
        z2: 1
    });
    el.baseDimIdx = baseDimIdx;
    el.largeDataIndices = largeDataIndices;
    el.barWidth = barWidth;
    group.add(el);
    el.useStyle(data.getVisual("style"));
    // Stroke is rendered first to avoid overlapping with fill
    el.style.stroke = null;
    // Enable tooltip and user mouse/touch event handlers.
    (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).seriesIndex = seriesModel.seriesIndex;
    if (!seriesModel.get("silent")) {
        el.on("mousedown", $0b120d76f26c920d$var$largePathUpdateDataIndex);
        el.on("mousemove", $0b120d76f26c920d$var$largePathUpdateDataIndex);
    }
    progressiveEls && progressiveEls.push(el);
}
// Use throttle to avoid frequently traverse to find dataIndex.
var $0b120d76f26c920d$var$largePathUpdateDataIndex = (0, $c98659a9437a3d2e$export$de363e709c412c8a)(function(event) {
    var largePath = this;
    var dataIndex = $0b120d76f26c920d$var$largePathFindDataIndex(largePath, event.offsetX, event.offsetY);
    (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(largePath).dataIndex = dataIndex >= 0 ? dataIndex : null;
}, 30, false);
function $0b120d76f26c920d$var$largePathFindDataIndex(largePath, x, y) {
    var baseDimIdx = largePath.baseDimIdx;
    var valueDimIdx = 1 - baseDimIdx;
    var points = largePath.shape.points;
    var largeDataIndices = largePath.largeDataIndices;
    var startPoint = [];
    var size = [];
    var barWidth = largePath.barWidth;
    for(var i = 0, len = points.length / 3; i < len; i++){
        var ii = i * 3;
        size[baseDimIdx] = barWidth;
        size[valueDimIdx] = points[ii + 2];
        startPoint[baseDimIdx] = points[ii + baseDimIdx];
        startPoint[valueDimIdx] = points[ii + valueDimIdx];
        if (size[valueDimIdx] < 0) {
            startPoint[valueDimIdx] += size[valueDimIdx];
            size[valueDimIdx] = -size[valueDimIdx];
        }
        if (x >= startPoint[0] && x <= startPoint[0] + size[0] && y >= startPoint[1] && y <= startPoint[1] + size[1]) return largeDataIndices[i];
    }
    return -1;
}
function $0b120d76f26c920d$var$createBackgroundShape(isHorizontalOrRadial, layout, coord) {
    if ((0, $3fea949f0512eb55$export$8567506e6336616)(coord, "cartesian2d")) {
        var rectShape = layout;
        var coordLayout = coord.getArea();
        return {
            x: isHorizontalOrRadial ? rectShape.x : coordLayout.x,
            y: isHorizontalOrRadial ? coordLayout.y : rectShape.y,
            width: isHorizontalOrRadial ? rectShape.width : coordLayout.width,
            height: isHorizontalOrRadial ? coordLayout.height : rectShape.height
        };
    } else {
        var coordLayout = coord.getArea();
        var sectorShape = layout;
        return {
            cx: coordLayout.cx,
            cy: coordLayout.cy,
            r0: isHorizontalOrRadial ? coordLayout.r0 : sectorShape.r0,
            r: isHorizontalOrRadial ? coordLayout.r : sectorShape.r,
            startAngle: isHorizontalOrRadial ? sectorShape.startAngle : 0,
            endAngle: isHorizontalOrRadial ? sectorShape.endAngle : Math.PI * 2
        };
    }
}
function $0b120d76f26c920d$var$createBackgroundEl(coord, isHorizontalOrRadial, layout) {
    var ElementClz = coord.type === "polar" ? (0, $a3e1dec0a3875b49$export$2e2bcd8739ae039) : (0, $419e5ff2f303755e$export$2e2bcd8739ae039);
    return new ElementClz({
        shape: $0b120d76f26c920d$var$createBackgroundShape(isHorizontalOrRadial, layout, coord),
        silent: true,
        z2: 0
    });
}
var $0b120d76f26c920d$export$2e2bcd8739ae039 = $0b120d76f26c920d$var$BarView;


function $4bb56d1f08552ff4$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $0b120d76f26c920d$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $1db8e2e676cae702$export$2e2bcd8739ae039));
    registers.registerLayout(registers.PRIORITY.VISUAL.LAYOUT, $7a1bd9c2710fea0d$export$c3095a23b368d1f2((0, $361c48dd900de28f$export$b3219800bda33a1f), "bar"));
    // Do layout after other overall layout, which can prepare some information.
    registers.registerLayout(registers.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, (0, $361c48dd900de28f$export$16e8685758531cb6)("bar"));
    // Down sample after filter
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $3a37e5b80322a871$export$2e2bcd8739ae039)("bar"));
    /**
   * @payload
   * @property {string} [componentType=series]
   * @property {number} [dx]
   * @property {number} [dy]
   * @property {number} [zoom]
   * @property {number} [originX]
   * @property {number} [originY]
   */ registers.registerAction({
        type: "changeAxisOrder",
        event: "changeAxisOrder",
        update: "update"
    }, function(payload, ecModel) {
        var componentType = payload.componentType || "series";
        ecModel.eachComponent({
            mainType: componentType,
            query: payload
        }, function(componentModel) {
            if (payload.sortInfo) componentModel.axis.setCategorySortInfo(payload.sortInfo);
        });
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $7e5c3511527c9907$export$2e2bcd8739ae039(seriesModel, opt, nameList) {
    opt = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(opt) && {
        coordDimensions: opt
    } || (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
        encodeDefine: seriesModel.getEncode()
    }, opt);
    var source = seriesModel.getSource();
    var dimensions = (0, $a27631012b7b377c$export$2e2bcd8739ae039)(source, opt).dimensions;
    var list = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(dimensions, seriesModel);
    list.initData(source, nameList);
    return list;
}





var $29bc1fc21a5243a6$export$ccfed902f8630510 = /** @class */ function() {
    function WhiskerBoxCommonMixin() {}
    /**
   * @private
   */ WhiskerBoxCommonMixin.prototype._hasEncodeRule = function(key) {
        var encodeRules = this.getEncode();
        return encodeRules && encodeRules.get(key) != null;
    };
    /**
   * @override
   */ WhiskerBoxCommonMixin.prototype.getInitialData = function(option, ecModel) {
        // When both types of xAxis and yAxis are 'value', layout is
        // needed to be specified by user. Otherwise, layout can be
        // judged by which axis is category.
        var ordinalMeta;
        var xAxisModel = ecModel.getComponent("xAxis", this.get("xAxisIndex"));
        var yAxisModel = ecModel.getComponent("yAxis", this.get("yAxisIndex"));
        var xAxisType = xAxisModel.get("type");
        var yAxisType = yAxisModel.get("type");
        var addOrdinal;
        // FIXME
        // Consider time axis.
        if (xAxisType === "category") {
            option.layout = "horizontal";
            ordinalMeta = xAxisModel.getOrdinalMeta();
            addOrdinal = !this._hasEncodeRule("x");
        } else if (yAxisType === "category") {
            option.layout = "vertical";
            ordinalMeta = yAxisModel.getOrdinalMeta();
            addOrdinal = !this._hasEncodeRule("y");
        } else option.layout = option.layout || "horizontal";
        var coordDims = [
            "x",
            "y"
        ];
        var baseAxisDimIndex = option.layout === "horizontal" ? 0 : 1;
        var baseAxisDim = this._baseAxisDim = coordDims[baseAxisDimIndex];
        var otherAxisDim = coordDims[1 - baseAxisDimIndex];
        var axisModels = [
            xAxisModel,
            yAxisModel
        ];
        var baseAxisType = axisModels[baseAxisDimIndex].get("type");
        var otherAxisType = axisModels[1 - baseAxisDimIndex].get("type");
        var data = option.data;
        // Clone a new data for next setOption({}) usage.
        // Avoid modifying current data will affect further update.
        if (data && addOrdinal) {
            var newOptionData_1 = [];
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(data, function(item, index) {
                var newItem;
                if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(item)) {
                    newItem = item.slice();
                    // Modify current using data.
                    item.unshift(index);
                } else if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(item.value)) {
                    newItem = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, item);
                    newItem.value = newItem.value.slice();
                    // Modify current using data.
                    item.value.unshift(index);
                } else newItem = item;
                newOptionData_1.push(newItem);
            });
            option.data = newOptionData_1;
        }
        var defaultValueDimensions = this.defaultValueDimensions;
        var coordDimensions = [
            {
                name: baseAxisDim,
                type: (0, $18085de91ae59d03$export$af1622903e71278e)(baseAxisType),
                ordinalMeta: ordinalMeta,
                otherDims: {
                    tooltip: false,
                    itemName: 0
                },
                dimsDef: [
                    "base"
                ]
            },
            {
                name: otherAxisDim,
                type: (0, $18085de91ae59d03$export$af1622903e71278e)(otherAxisType),
                dimsDef: defaultValueDimensions.slice()
            }
        ];
        return (0, $7e5c3511527c9907$export$2e2bcd8739ae039)(this, {
            coordDimensions: coordDimensions,
            dimensionsCount: defaultValueDimensions.length + 1,
            encodeDefaulter: $7a1bd9c2710fea0d$export$c3095a23b368d1f2((0, $7dc6cdfd7450ef29$export$37682b8fdd2e83d), coordDimensions, this)
        });
    };
    /**
   * If horizontal, base axis is x, otherwise y.
   * @override
   */ WhiskerBoxCommonMixin.prototype.getBaseAxis = function() {
        var dim = this._baseAxisDim;
        return this.ecModel.getComponent(dim + "Axis", this.get(dim + "AxisIndex")).axis;
    };
    return WhiskerBoxCommonMixin;
}();




var $de6da9192b0ee4cb$var$BoxplotSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BoxplotSeriesModel, _super);
    function BoxplotSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BoxplotSeriesModel.type;
        // TODO
        // box width represents group size, so dimension should have 'size'.
        /**
     * @see <https://en.wikipedia.org/wiki/Box_plot>
     * The meanings of 'min' and 'max' depend on user,
     * and echarts do not need to know it.
     * @readOnly
     */ _this.defaultValueDimensions = [
            {
                name: "min",
                defaultTooltip: true
            },
            {
                name: "Q1",
                defaultTooltip: true
            },
            {
                name: "median",
                defaultTooltip: true
            },
            {
                name: "Q3",
                defaultTooltip: true
            },
            {
                name: "max",
                defaultTooltip: true
            }
        ];
        _this.visualDrawType = "stroke";
        return _this;
    }
    BoxplotSeriesModel.type = "series.boxplot";
    BoxplotSeriesModel.dependencies = [
        "xAxis",
        "yAxis",
        "grid"
    ];
    BoxplotSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: "cartesian2d",
        legendHoverLink: true,
        layout: null,
        boxWidth: [
            7,
            50
        ],
        itemStyle: {
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral00,
            borderWidth: 1
        },
        emphasis: {
            scale: true,
            itemStyle: {
                borderWidth: 2,
                shadowBlur: 5,
                shadowOffsetX: 1,
                shadowOffsetY: 1,
                shadowColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.shadow
            }
        },
        animationDuration: 800
    };
    return BoxplotSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($de6da9192b0ee4cb$var$BoxplotSeriesModel, (0, $29bc1fc21a5243a6$export$ccfed902f8630510), true);
var $de6da9192b0ee4cb$export$2e2bcd8739ae039 = $de6da9192b0ee4cb$var$BoxplotSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $4f6c4593265afb0c$var$BoxplotView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BoxplotView, _super);
    function BoxplotView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BoxplotView.type;
        return _this;
    }
    BoxplotView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var group = this.group;
        var oldData = this._data;
        // There is no old data only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!this._data) group.removeAll();
        var constDim = seriesModel.get("layout") === "horizontal" ? 1 : 0;
        data.diff(oldData).add(function(newIdx) {
            if (data.hasValue(newIdx)) {
                var itemLayout = data.getItemLayout(newIdx);
                var symbolEl = $4f6c4593265afb0c$var$createNormalBox(itemLayout, data, newIdx, constDim, true);
                data.setItemGraphicEl(newIdx, symbolEl);
                group.add(symbolEl);
            }
        }).update(function(newIdx, oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            // Empty data
            if (!data.hasValue(newIdx)) {
                group.remove(symbolEl);
                return;
            }
            var itemLayout = data.getItemLayout(newIdx);
            if (!symbolEl) symbolEl = $4f6c4593265afb0c$var$createNormalBox(itemLayout, data, newIdx, constDim);
            else {
                (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(symbolEl);
                $4f6c4593265afb0c$var$updateNormalBoxData(itemLayout, symbolEl, data, newIdx);
            }
            group.add(symbolEl);
            data.setItemGraphicEl(newIdx, symbolEl);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && group.remove(el);
        }).execute();
        this._data = data;
    };
    BoxplotView.prototype.remove = function(ecModel) {
        var group = this.group;
        var data = this._data;
        this._data = null;
        data && data.eachItemGraphicEl(function(el) {
            el && group.remove(el);
        });
    };
    BoxplotView.type = "boxplot";
    return BoxplotView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $4f6c4593265afb0c$var$BoxPathShape = /** @class */ function() {
    function BoxPathShape() {}
    return BoxPathShape;
}();
var $4f6c4593265afb0c$var$BoxPath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BoxPath, _super);
    function BoxPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "boxplotBoxPath";
        return _this;
    }
    BoxPath.prototype.getDefaultShape = function() {
        return new $4f6c4593265afb0c$var$BoxPathShape();
    };
    BoxPath.prototype.buildPath = function(ctx, shape) {
        var ends = shape.points;
        var i = 0;
        ctx.moveTo(ends[i][0], ends[i][1]);
        i++;
        for(; i < 4; i++)ctx.lineTo(ends[i][0], ends[i][1]);
        ctx.closePath();
        for(; i < ends.length; i++){
            ctx.moveTo(ends[i][0], ends[i][1]);
            i++;
            ctx.lineTo(ends[i][0], ends[i][1]);
        }
    };
    return BoxPath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
function $4f6c4593265afb0c$var$createNormalBox(itemLayout, data, dataIndex, constDim, isInit) {
    var ends = itemLayout.ends;
    var el = new $4f6c4593265afb0c$var$BoxPath({
        shape: {
            points: isInit ? $4f6c4593265afb0c$var$transInit(ends, constDim, itemLayout) : ends
        }
    });
    $4f6c4593265afb0c$var$updateNormalBoxData(itemLayout, el, data, dataIndex, isInit);
    return el;
}
function $4f6c4593265afb0c$var$updateNormalBoxData(itemLayout, el, data, dataIndex, isInit) {
    var seriesModel = data.hostModel;
    var updateMethod = $5b455ae6f843ac47$exports[isInit ? "initProps" : "updateProps"];
    updateMethod(el, {
        shape: {
            points: itemLayout.ends
        }
    }, seriesModel, dataIndex);
    el.useStyle(data.getItemVisual(dataIndex, "style"));
    el.style.strokeNoScale = true;
    el.z2 = 100;
    var itemModel = data.getItemModel(dataIndex);
    var emphasisModel = itemModel.getModel("emphasis");
    (0, $2bf82c0980125b62$export$48b68047d330bbc9)(el, itemModel);
    (0, $2bf82c0980125b62$export$e51187539ff11209)(el, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
}
function $4f6c4593265afb0c$var$transInit(points, dim, itemLayout) {
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88(points, function(point) {
        point = point.slice();
        point[dim] = itemLayout.initBaseline;
        return point;
    });
}
var $4f6c4593265afb0c$export$2e2bcd8739ae039 = $4f6c4593265afb0c$var$BoxplotView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $aa15a3e67343392c$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
function $aa15a3e67343392c$export$2e2bcd8739ae039(ecModel) {
    var groupResult = $aa15a3e67343392c$var$groupSeriesByAxis(ecModel);
    $aa15a3e67343392c$var$each(groupResult, function(groupItem) {
        var seriesModels = groupItem.seriesModels;
        if (!seriesModels.length) return;
        $aa15a3e67343392c$var$calculateBase(groupItem);
        $aa15a3e67343392c$var$each(seriesModels, function(seriesModel, idx) {
            $aa15a3e67343392c$var$layoutSingleSeries(seriesModel, groupItem.boxOffsetList[idx], groupItem.boxWidthList[idx]);
        });
    });
}
/**
 * Group series by axis.
 */ function $aa15a3e67343392c$var$groupSeriesByAxis(ecModel) {
    var result = [];
    var axisList = [];
    ecModel.eachSeriesByType("boxplot", function(seriesModel) {
        var baseAxis = seriesModel.getBaseAxis();
        var idx = $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(axisList, baseAxis);
        if (idx < 0) {
            idx = axisList.length;
            axisList[idx] = baseAxis;
            result[idx] = {
                axis: baseAxis,
                seriesModels: []
            };
        }
        result[idx].seriesModels.push(seriesModel);
    });
    return result;
}
/**
 * Calculate offset and box width for each series.
 */ function $aa15a3e67343392c$var$calculateBase(groupItem) {
    var baseAxis = groupItem.axis;
    var seriesModels = groupItem.seriesModels;
    var seriesCount = seriesModels.length;
    var boxWidthList = groupItem.boxWidthList = [];
    var boxOffsetList = groupItem.boxOffsetList = [];
    var boundList = [];
    var bandWidth;
    if (baseAxis.type === "category") bandWidth = baseAxis.getBandWidth();
    else {
        var maxDataCount_1 = 0;
        $aa15a3e67343392c$var$each(seriesModels, function(seriesModel) {
            maxDataCount_1 = Math.max(maxDataCount_1, seriesModel.getData().count());
        });
        var extent = baseAxis.getExtent();
        bandWidth = Math.abs(extent[1] - extent[0]) / maxDataCount_1;
    }
    $aa15a3e67343392c$var$each(seriesModels, function(seriesModel) {
        var boxWidthBound = seriesModel.get("boxWidth");
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(boxWidthBound)) boxWidthBound = [
            boxWidthBound,
            boxWidthBound
        ];
        boundList.push([
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(boxWidthBound[0], bandWidth) || 0,
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(boxWidthBound[1], bandWidth) || 0
        ]);
    });
    var availableWidth = bandWidth * 0.8 - 2;
    var boxGap = availableWidth / seriesCount * 0.3;
    var boxWidth = (availableWidth - boxGap * (seriesCount - 1)) / seriesCount;
    var base = boxWidth / 2 - availableWidth / 2;
    $aa15a3e67343392c$var$each(seriesModels, function(seriesModel, idx) {
        boxOffsetList.push(base);
        base += boxGap + boxWidth;
        boxWidthList.push(Math.min(Math.max(boxWidth, boundList[idx][0]), boundList[idx][1]));
    });
}
/**
 * Calculate points location for each series.
 */ function $aa15a3e67343392c$var$layoutSingleSeries(seriesModel, offset, boxWidth) {
    var coordSys = seriesModel.coordinateSystem;
    var data = seriesModel.getData();
    var halfWidth = boxWidth / 2;
    var cDimIdx = seriesModel.get("layout") === "horizontal" ? 0 : 1;
    var vDimIdx = 1 - cDimIdx;
    var coordDims = [
        "x",
        "y"
    ];
    var cDim = data.mapDimension(coordDims[cDimIdx]);
    var vDims = data.mapDimensionsAll(coordDims[vDimIdx]);
    if (cDim == null || vDims.length < 5) return;
    for(var dataIndex = 0; dataIndex < data.count(); dataIndex++){
        var axisDimVal = data.get(cDim, dataIndex);
        var median = getPoint(axisDimVal, vDims[2], dataIndex);
        var end1 = getPoint(axisDimVal, vDims[0], dataIndex);
        var end2 = getPoint(axisDimVal, vDims[1], dataIndex);
        var end4 = getPoint(axisDimVal, vDims[3], dataIndex);
        var end5 = getPoint(axisDimVal, vDims[4], dataIndex);
        var ends = [];
        addBodyEnd(ends, end2, false);
        addBodyEnd(ends, end4, true);
        ends.push(end1, end2, end5, end4);
        layEndLine(ends, end1);
        layEndLine(ends, end5);
        layEndLine(ends, median);
        data.setItemLayout(dataIndex, {
            initBaseline: median[vDimIdx],
            ends: ends
        });
    }
    function getPoint(axisDimVal, dim, dataIndex) {
        var val = data.get(dim, dataIndex);
        var p = [];
        p[cDimIdx] = axisDimVal;
        p[vDimIdx] = val;
        var point;
        if (isNaN(axisDimVal) || isNaN(val)) point = [
            NaN,
            NaN
        ];
        else {
            point = coordSys.dataToPoint(p);
            point[cDimIdx] += offset;
        }
        return point;
    }
    function addBodyEnd(ends, point, start) {
        var point1 = point.slice();
        var point2 = point.slice();
        point1[cDimIdx] += halfWidth;
        point2[cDimIdx] -= halfWidth;
        start ? ends.push(point1, point2) : ends.push(point2, point1);
    }
    function layEndLine(ends, endCenter) {
        var from = endCenter.slice();
        var to = endCenter.slice();
        from[cDimIdx] -= halfWidth;
        to[cDimIdx] += halfWidth;
        ends.push(from, to);
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $a9247e275753b379$export$2e2bcd8739ae039(rawData, opt) {
    opt = opt || {};
    var boxData = [];
    var outliers = [];
    var boundIQR = opt.boundIQR;
    var useExtreme = boundIQR === "none" || boundIQR === 0;
    for(var i = 0; i < rawData.length; i++){
        var ascList = (0, $cfc1f3b422a3185f$export$debe6e778e0a6d32)(rawData[i].slice());
        var Q1 = (0, $cfc1f3b422a3185f$export$651fb4afdb6caa4b)(ascList, 0.25);
        var Q2 = (0, $cfc1f3b422a3185f$export$651fb4afdb6caa4b)(ascList, 0.5);
        var Q3 = (0, $cfc1f3b422a3185f$export$651fb4afdb6caa4b)(ascList, 0.75);
        var min = ascList[0];
        var max = ascList[ascList.length - 1];
        var bound = (boundIQR == null ? 1.5 : boundIQR) * (Q3 - Q1);
        var low = useExtreme ? min : Math.max(min, Q1 - bound);
        var high = useExtreme ? max : Math.min(max, Q3 + bound);
        var itemNameFormatter = opt.itemNameFormatter;
        var itemName = (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(itemNameFormatter) ? itemNameFormatter({
            value: i
        }) : (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(itemNameFormatter) ? itemNameFormatter.replace("{value}", i + "") : i + "";
        boxData.push([
            itemName,
            low,
            Q1,
            Q2,
            Q3,
            high
        ]);
        for(var j = 0; j < ascList.length; j++){
            var dataItem = ascList[j];
            if (dataItem < low || dataItem > high) {
                var outlier = [
                    itemName,
                    dataItem
                ];
                outliers.push(outlier);
            }
        }
    }
    return {
        boxData: boxData,
        outliers: outliers
    };
}




var $9203fc6e2b112614$export$e0915fae26dedefc = {
    type: "echarts:boxplot",
    transform: function transform(params) {
        var upstream = params.upstream;
        if (upstream.sourceFormat !== (0, $cab29724515ce2b8$export$fcd62ebf51387903)) {
            var errMsg = "";
            (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        }
        var result = (0, $a9247e275753b379$export$2e2bcd8739ae039)(upstream.getRawData(), params.config);
        return [
            {
                dimensions: [
                    "ItemName",
                    "Low",
                    "Q1",
                    "Q2",
                    "Q3",
                    "High"
                ],
                data: result.boxData
            },
            {
                data: result.outliers
            }
        ];
    }
};


function $0fd6296850ce3099$export$4b3e715f166fdd78(registers) {
    registers.registerSeriesModel((0, $de6da9192b0ee4cb$export$2e2bcd8739ae039));
    registers.registerChartView((0, $4f6c4593265afb0c$export$2e2bcd8739ae039));
    registers.registerLayout((0, $aa15a3e67343392c$export$2e2bcd8739ae039));
    registers.registerTransform((0, $9203fc6e2b112614$export$e0915fae26dedefc));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $f31d4ab399bcabcc$var$positiveBorderColorQuery = [
    "itemStyle",
    "borderColor"
];
var $f31d4ab399bcabcc$var$negativeBorderColorQuery = [
    "itemStyle",
    "borderColor0"
];
var $f31d4ab399bcabcc$var$dojiBorderColorQuery = [
    "itemStyle",
    "borderColorDoji"
];
var $f31d4ab399bcabcc$var$positiveColorQuery = [
    "itemStyle",
    "color"
];
var $f31d4ab399bcabcc$var$negativeColorQuery = [
    "itemStyle",
    "color0"
];
function $f31d4ab399bcabcc$export$5551a2d24ff40153(sign, model) {
    return model.get(sign > 0 ? $f31d4ab399bcabcc$var$positiveColorQuery : $f31d4ab399bcabcc$var$negativeColorQuery);
}
function $f31d4ab399bcabcc$export$dbc6cfecd630bcea(sign, model) {
    return model.get(sign === 0 ? $f31d4ab399bcabcc$var$dojiBorderColorQuery : sign > 0 ? $f31d4ab399bcabcc$var$positiveBorderColorQuery : $f31d4ab399bcabcc$var$negativeBorderColorQuery);
}
var $f31d4ab399bcabcc$var$candlestickVisual = {
    seriesType: "candlestick",
    plan: (0, $cd70075c57b35175$export$2e2bcd8739ae039)(),
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var isLargeRender = seriesModel.pipelineContext.large;
        return !isLargeRender && {
            progress: function(params, data) {
                var dataIndex;
                while((dataIndex = params.next()) != null){
                    var itemModel = data.getItemModel(dataIndex);
                    var sign = data.getItemLayout(dataIndex).sign;
                    var style = itemModel.getItemStyle();
                    style.fill = $f31d4ab399bcabcc$export$5551a2d24ff40153(sign, itemModel);
                    style.stroke = $f31d4ab399bcabcc$export$dbc6cfecd630bcea(sign, itemModel) || style.fill;
                    var existsStyle = data.ensureUniqueItemVisual(dataIndex, "style");
                    (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(existsStyle, style);
                }
            }
        };
    }
};
var $f31d4ab399bcabcc$export$2e2bcd8739ae039 = $f31d4ab399bcabcc$var$candlestickVisual;


var $74dcd5b9be05016d$var$SKIP_PROPS = [
    "color",
    "borderColor"
];
var $74dcd5b9be05016d$var$CandlestickView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CandlestickView, _super);
    function CandlestickView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CandlestickView.type;
        return _this;
    }
    CandlestickView.prototype.render = function(seriesModel, ecModel, api) {
        // If there is clipPath created in large mode. Remove it.
        this.group.removeClipPath();
        // Clear previously rendered progressive elements.
        this._progressiveEls = null;
        this._updateDrawMode(seriesModel);
        this._isLargeDraw ? this._renderLarge(seriesModel) : this._renderNormal(seriesModel);
    };
    CandlestickView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        this._clear();
        this._updateDrawMode(seriesModel);
    };
    CandlestickView.prototype.incrementalRender = function(params, seriesModel, ecModel, api) {
        this._progressiveEls = [];
        this._isLargeDraw ? this._incrementalRenderLarge(params, seriesModel) : this._incrementalRenderNormal(params, seriesModel);
    };
    CandlestickView.prototype.eachRendered = function(cb) {
        $5b455ae6f843ac47$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    CandlestickView.prototype._updateDrawMode = function(seriesModel) {
        var isLargeDraw = seriesModel.pipelineContext.large;
        if (this._isLargeDraw == null || isLargeDraw !== this._isLargeDraw) {
            this._isLargeDraw = isLargeDraw;
            this._clear();
        }
    };
    CandlestickView.prototype._renderNormal = function(seriesModel) {
        var data = seriesModel.getData();
        var oldData = this._data;
        var group = this.group;
        var isSimpleBox = data.getLayout("isSimpleBox");
        var needsClip = seriesModel.get("clip", true);
        var coord = seriesModel.coordinateSystem;
        var clipArea = coord.getArea && coord.getArea();
        // There is no old data only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!this._data) group.removeAll();
        data.diff(oldData).add(function(newIdx) {
            if (data.hasValue(newIdx)) {
                var itemLayout = data.getItemLayout(newIdx);
                if (needsClip && $74dcd5b9be05016d$var$isNormalBoxClipped(clipArea, itemLayout)) return;
                var el = $74dcd5b9be05016d$var$createNormalBox(itemLayout, newIdx, true);
                $8b353638fbedfefa$export$a121566aadcfe021(el, {
                    shape: {
                        points: itemLayout.ends
                    }
                }, seriesModel, newIdx);
                $74dcd5b9be05016d$var$setBoxCommon(el, data, newIdx, isSimpleBox);
                group.add(el);
                data.setItemGraphicEl(newIdx, el);
            }
        }).update(function(newIdx, oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            // Empty data
            if (!data.hasValue(newIdx)) {
                group.remove(el);
                return;
            }
            var itemLayout = data.getItemLayout(newIdx);
            if (needsClip && $74dcd5b9be05016d$var$isNormalBoxClipped(clipArea, itemLayout)) {
                group.remove(el);
                return;
            }
            if (!el) el = $74dcd5b9be05016d$var$createNormalBox(itemLayout, newIdx);
            else {
                $8b353638fbedfefa$export$c8dce3c08436e91e(el, {
                    shape: {
                        points: itemLayout.ends
                    }
                }, seriesModel, newIdx);
                (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(el);
            }
            $74dcd5b9be05016d$var$setBoxCommon(el, data, newIdx, isSimpleBox);
            group.add(el);
            data.setItemGraphicEl(newIdx, el);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && group.remove(el);
        }).execute();
        this._data = data;
    };
    CandlestickView.prototype._renderLarge = function(seriesModel) {
        this._clear();
        $74dcd5b9be05016d$var$createLarge(seriesModel, this.group);
        var clipPath = seriesModel.get("clip", true) ? (0, $0e2cc04b3aaad400$export$e0fe5081209d01c9)(seriesModel.coordinateSystem, false, seriesModel) : null;
        if (clipPath) this.group.setClipPath(clipPath);
        else this.group.removeClipPath();
    };
    CandlestickView.prototype._incrementalRenderNormal = function(params, seriesModel) {
        var data = seriesModel.getData();
        var isSimpleBox = data.getLayout("isSimpleBox");
        var dataIndex;
        while((dataIndex = params.next()) != null){
            var itemLayout = data.getItemLayout(dataIndex);
            var el = $74dcd5b9be05016d$var$createNormalBox(itemLayout, dataIndex);
            $74dcd5b9be05016d$var$setBoxCommon(el, data, dataIndex, isSimpleBox);
            el.incremental = true;
            this.group.add(el);
            this._progressiveEls.push(el);
        }
    };
    CandlestickView.prototype._incrementalRenderLarge = function(params, seriesModel) {
        $74dcd5b9be05016d$var$createLarge(seriesModel, this.group, this._progressiveEls, true);
    };
    CandlestickView.prototype.remove = function(ecModel) {
        this._clear();
    };
    CandlestickView.prototype._clear = function() {
        this.group.removeAll();
        this._data = null;
    };
    CandlestickView.type = "candlestick";
    return CandlestickView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $74dcd5b9be05016d$var$NormalBoxPathShape = /** @class */ function() {
    function NormalBoxPathShape() {}
    return NormalBoxPathShape;
}();
var $74dcd5b9be05016d$var$NormalBoxPath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(NormalBoxPath, _super);
    function NormalBoxPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "normalCandlestickBox";
        return _this;
    }
    NormalBoxPath.prototype.getDefaultShape = function() {
        return new $74dcd5b9be05016d$var$NormalBoxPathShape();
    };
    NormalBoxPath.prototype.buildPath = function(ctx, shape) {
        var ends = shape.points;
        if (this.__simpleBox) {
            ctx.moveTo(ends[4][0], ends[4][1]);
            ctx.lineTo(ends[6][0], ends[6][1]);
        } else {
            ctx.moveTo(ends[0][0], ends[0][1]);
            ctx.lineTo(ends[1][0], ends[1][1]);
            ctx.lineTo(ends[2][0], ends[2][1]);
            ctx.lineTo(ends[3][0], ends[3][1]);
            ctx.closePath();
            ctx.moveTo(ends[4][0], ends[4][1]);
            ctx.lineTo(ends[5][0], ends[5][1]);
            ctx.moveTo(ends[6][0], ends[6][1]);
            ctx.lineTo(ends[7][0], ends[7][1]);
        }
    };
    return NormalBoxPath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
function $74dcd5b9be05016d$var$createNormalBox(itemLayout, dataIndex, isInit) {
    var ends = itemLayout.ends;
    return new $74dcd5b9be05016d$var$NormalBoxPath({
        shape: {
            points: isInit ? $74dcd5b9be05016d$var$transInit(ends, itemLayout) : ends
        },
        z2: 100
    });
}
function $74dcd5b9be05016d$var$isNormalBoxClipped(clipArea, itemLayout) {
    var clipped = true;
    for(var i = 0; i < itemLayout.ends.length; i++)// If any point are in the region.
    if (clipArea.contain(itemLayout.ends[i][0], itemLayout.ends[i][1])) {
        clipped = false;
        break;
    }
    return clipped;
}
function $74dcd5b9be05016d$var$setBoxCommon(el, data, dataIndex, isSimpleBox) {
    var itemModel = data.getItemModel(dataIndex);
    el.useStyle(data.getItemVisual(dataIndex, "style"));
    el.style.strokeNoScale = true;
    el.__simpleBox = isSimpleBox;
    (0, $2bf82c0980125b62$export$48b68047d330bbc9)(el, itemModel);
    var sign = data.getItemLayout(dataIndex).sign;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(el.states, function(state, stateName) {
        var stateModel = itemModel.getModel(stateName);
        var color = (0, $f31d4ab399bcabcc$export$5551a2d24ff40153)(sign, stateModel);
        var borderColor = (0, $f31d4ab399bcabcc$export$dbc6cfecd630bcea)(sign, stateModel) || color;
        var stateStyle = state.style || (state.style = {});
        color && (stateStyle.fill = color);
        borderColor && (stateStyle.stroke = borderColor);
    });
    var emphasisModel = itemModel.getModel("emphasis");
    (0, $2bf82c0980125b62$export$e51187539ff11209)(el, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
}
function $74dcd5b9be05016d$var$transInit(points, itemLayout) {
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88(points, function(point) {
        point = point.slice();
        point[1] = itemLayout.initBaseline;
        return point;
    });
}
var $74dcd5b9be05016d$var$LargeBoxPathShape = /** @class */ function() {
    function LargeBoxPathShape() {}
    return LargeBoxPathShape;
}();
var $74dcd5b9be05016d$var$LargeBoxPath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LargeBoxPath, _super);
    function LargeBoxPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "largeCandlestickBox";
        return _this;
    }
    LargeBoxPath.prototype.getDefaultShape = function() {
        return new $74dcd5b9be05016d$var$LargeBoxPathShape();
    };
    LargeBoxPath.prototype.buildPath = function(ctx, shape) {
        // Drawing lines is more efficient than drawing
        // a whole line or drawing rects.
        var points = shape.points;
        for(var i = 0; i < points.length;)if (this.__sign === points[i++]) {
            var x = points[i++];
            ctx.moveTo(x, points[i++]);
            ctx.lineTo(x, points[i++]);
        } else i += 3;
    };
    return LargeBoxPath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
function $74dcd5b9be05016d$var$createLarge(seriesModel, group, progressiveEls, incremental) {
    var data = seriesModel.getData();
    var largePoints = data.getLayout("largePoints");
    var elP = new $74dcd5b9be05016d$var$LargeBoxPath({
        shape: {
            points: largePoints
        },
        __sign: 1,
        ignoreCoarsePointer: true
    });
    group.add(elP);
    var elN = new $74dcd5b9be05016d$var$LargeBoxPath({
        shape: {
            points: largePoints
        },
        __sign: -1,
        ignoreCoarsePointer: true
    });
    group.add(elN);
    var elDoji = new $74dcd5b9be05016d$var$LargeBoxPath({
        shape: {
            points: largePoints
        },
        __sign: 0,
        ignoreCoarsePointer: true
    });
    group.add(elDoji);
    $74dcd5b9be05016d$var$setLargeStyle(1, elP, seriesModel, data);
    $74dcd5b9be05016d$var$setLargeStyle(-1, elN, seriesModel, data);
    $74dcd5b9be05016d$var$setLargeStyle(0, elDoji, seriesModel, data);
    if (incremental) {
        elP.incremental = true;
        elN.incremental = true;
    }
    if (progressiveEls) progressiveEls.push(elP, elN);
}
function $74dcd5b9be05016d$var$setLargeStyle(sign, el, seriesModel, data) {
    // TODO put in visual?
    var borderColor = (0, $f31d4ab399bcabcc$export$dbc6cfecd630bcea)(sign, seriesModel) || (0, $f31d4ab399bcabcc$export$5551a2d24ff40153)(sign, seriesModel);
    // Color must be excluded.
    // Because symbol provide setColor individually to set fill and stroke
    var itemStyle = seriesModel.getModel("itemStyle").getItemStyle($74dcd5b9be05016d$var$SKIP_PROPS);
    el.useStyle(itemStyle);
    el.style.fill = null;
    el.style.stroke = borderColor;
}
var $74dcd5b9be05016d$export$2e2bcd8739ae039 = $74dcd5b9be05016d$var$CandlestickView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $b79b80243e209954$var$CandlestickSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CandlestickSeriesModel, _super);
    function CandlestickSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CandlestickSeriesModel.type;
        _this.defaultValueDimensions = [
            {
                name: "open",
                defaultTooltip: true
            },
            {
                name: "close",
                defaultTooltip: true
            },
            {
                name: "lowest",
                defaultTooltip: true
            },
            {
                name: "highest",
                defaultTooltip: true
            }
        ];
        return _this;
    }
    /**
   * Get dimension for shadow in dataZoom
   * @return dimension name
   */ CandlestickSeriesModel.prototype.getShadowDim = function() {
        return "open";
    };
    CandlestickSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        var itemLayout = data.getItemLayout(dataIndex);
        return itemLayout && selectors.rect(itemLayout.brushRect);
    };
    CandlestickSeriesModel.type = "series.candlestick";
    CandlestickSeriesModel.dependencies = [
        "xAxis",
        "yAxis",
        "grid"
    ];
    CandlestickSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: "cartesian2d",
        legendHoverLink: true,
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        layout: null,
        clip: true,
        itemStyle: {
            color: "#eb5454",
            color0: "#47b262",
            borderColor: "#eb5454",
            borderColor0: "#47b262",
            borderColorDoji: null,
            // borderColor: '#d24040',
            // borderColor0: '#398f4f',
            borderWidth: 1
        },
        emphasis: {
            itemStyle: {
                borderWidth: 2
            }
        },
        barMaxWidth: null,
        barMinWidth: null,
        barWidth: null,
        large: true,
        largeThreshold: 600,
        progressive: 3e3,
        progressiveThreshold: 1e4,
        progressiveChunkMode: "mod",
        animationEasing: "linear",
        animationDuration: 300
    };
    return CandlestickSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($b79b80243e209954$var$CandlestickSeriesModel, (0, $29bc1fc21a5243a6$export$ccfed902f8630510), true);
var $b79b80243e209954$export$2e2bcd8739ae039 = $b79b80243e209954$var$CandlestickSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $55263b38adc138a7$export$2e2bcd8739ae039(option) {
    if (!option || !$7a1bd9c2710fea0d$export$43bee75e5e14138e(option.series)) return;
    // Translate 'k' to 'candlestick'.
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(option.series, function(seriesItem) {
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(seriesItem) && seriesItem.type === "k") seriesItem.type = "candlestick";
    });
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $a4e49046f9f1fd8b$var$candlestickLayout = {
    seriesType: "candlestick",
    plan: (0, $cd70075c57b35175$export$2e2bcd8739ae039)(),
    reset: function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        var data = seriesModel.getData();
        var candleWidth = $a4e49046f9f1fd8b$var$calculateCandleWidth(seriesModel, data);
        var cDimIdx = 0;
        var vDimIdx = 1;
        var coordDims = [
            "x",
            "y"
        ];
        var cDimI = data.getDimensionIndex(data.mapDimension(coordDims[cDimIdx]));
        var vDimsI = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(data.mapDimensionsAll(coordDims[vDimIdx]), data.getDimensionIndex, data);
        var openDimI = vDimsI[0];
        var closeDimI = vDimsI[1];
        var lowestDimI = vDimsI[2];
        var highestDimI = vDimsI[3];
        data.setLayout({
            candleWidth: candleWidth,
            // The value is experimented visually.
            isSimpleBox: candleWidth <= 1.3
        });
        if (cDimI < 0 || vDimsI.length < 4) return;
        return {
            progress: seriesModel.pipelineContext.large ? largeProgress : normalProgress
        };
        function normalProgress(params, data) {
            var dataIndex;
            var store = data.getStore();
            while((dataIndex = params.next()) != null){
                var axisDimVal = store.get(cDimI, dataIndex);
                var openVal = store.get(openDimI, dataIndex);
                var closeVal = store.get(closeDimI, dataIndex);
                var lowestVal = store.get(lowestDimI, dataIndex);
                var highestVal = store.get(highestDimI, dataIndex);
                var ocLow = Math.min(openVal, closeVal);
                var ocHigh = Math.max(openVal, closeVal);
                var ocLowPoint = getPoint(ocLow, axisDimVal);
                var ocHighPoint = getPoint(ocHigh, axisDimVal);
                var lowestPoint = getPoint(lowestVal, axisDimVal);
                var highestPoint = getPoint(highestVal, axisDimVal);
                var ends = [];
                addBodyEnd(ends, ocHighPoint, 0);
                addBodyEnd(ends, ocLowPoint, 1);
                ends.push(subPixelOptimizePoint(highestPoint), subPixelOptimizePoint(ocHighPoint), subPixelOptimizePoint(lowestPoint), subPixelOptimizePoint(ocLowPoint));
                var itemModel = data.getItemModel(dataIndex);
                var hasDojiColor = !!itemModel.get([
                    "itemStyle",
                    "borderColorDoji"
                ]);
                data.setItemLayout(dataIndex, {
                    sign: $a4e49046f9f1fd8b$var$getSign(store, dataIndex, openVal, closeVal, closeDimI, hasDojiColor),
                    initBaseline: openVal > closeVal ? ocHighPoint[vDimIdx] : ocLowPoint[vDimIdx],
                    ends: ends,
                    brushRect: makeBrushRect(lowestVal, highestVal, axisDimVal)
                });
            }
            function getPoint(val, axisDimVal) {
                var p = [];
                p[cDimIdx] = axisDimVal;
                p[vDimIdx] = val;
                return isNaN(axisDimVal) || isNaN(val) ? [
                    NaN,
                    NaN
                ] : coordSys.dataToPoint(p);
            }
            function addBodyEnd(ends, point, start) {
                var point1 = point.slice();
                var point2 = point.slice();
                point1[cDimIdx] = (0, $5b455ae6f843ac47$export$72c4fd4c1b8fcb10)(point1[cDimIdx] + candleWidth / 2, 1, false);
                point2[cDimIdx] = (0, $5b455ae6f843ac47$export$72c4fd4c1b8fcb10)(point2[cDimIdx] - candleWidth / 2, 1, true);
                start ? ends.push(point1, point2) : ends.push(point2, point1);
            }
            function makeBrushRect(lowestVal, highestVal, axisDimVal) {
                var pmin = getPoint(lowestVal, axisDimVal);
                var pmax = getPoint(highestVal, axisDimVal);
                pmin[cDimIdx] -= candleWidth / 2;
                pmax[cDimIdx] -= candleWidth / 2;
                return {
                    x: pmin[0],
                    y: pmin[1],
                    width: vDimIdx ? candleWidth : pmax[0] - pmin[0],
                    height: vDimIdx ? pmax[1] - pmin[1] : candleWidth
                };
            }
            function subPixelOptimizePoint(point) {
                point[cDimIdx] = (0, $5b455ae6f843ac47$export$72c4fd4c1b8fcb10)(point[cDimIdx], 1);
                return point;
            }
        }
        function largeProgress(params, data) {
            // Structure: [sign, x, yhigh, ylow, sign, x, yhigh, ylow, ...]
            var points = (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(params.count * 4);
            var offset = 0;
            var point;
            var tmpIn = [];
            var tmpOut = [];
            var dataIndex;
            var store = data.getStore();
            var hasDojiColor = !!seriesModel.get([
                "itemStyle",
                "borderColorDoji"
            ]);
            while((dataIndex = params.next()) != null){
                var axisDimVal = store.get(cDimI, dataIndex);
                var openVal = store.get(openDimI, dataIndex);
                var closeVal = store.get(closeDimI, dataIndex);
                var lowestVal = store.get(lowestDimI, dataIndex);
                var highestVal = store.get(highestDimI, dataIndex);
                if (isNaN(axisDimVal) || isNaN(lowestVal) || isNaN(highestVal)) {
                    points[offset++] = NaN;
                    offset += 3;
                    continue;
                }
                points[offset++] = $a4e49046f9f1fd8b$var$getSign(store, dataIndex, openVal, closeVal, closeDimI, hasDojiColor);
                tmpIn[cDimIdx] = axisDimVal;
                tmpIn[vDimIdx] = lowestVal;
                point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                points[offset++] = point ? point[0] : NaN;
                points[offset++] = point ? point[1] : NaN;
                tmpIn[vDimIdx] = highestVal;
                point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                points[offset++] = point ? point[1] : NaN;
            }
            data.setLayout("largePoints", points);
        }
    }
};
/**
 * Get the sign of a single data.
 *
 * @returns 0 for doji with hasDojiColor: true,
 *          1 for positive,
 *          -1 for negative.
 */ function $a4e49046f9f1fd8b$var$getSign(store, dataIndex, openVal, closeVal, closeDimI, hasDojiColor) {
    var sign;
    if (openVal > closeVal) sign = -1;
    else if (openVal < closeVal) sign = 1;
    else sign = hasDojiColor ? 0 : dataIndex > 0 ? store.get(closeDimI, dataIndex - 1) <= closeVal ? 1 : -1 : 1;
    return sign;
}
function $a4e49046f9f1fd8b$var$calculateCandleWidth(seriesModel, data) {
    var baseAxis = seriesModel.getBaseAxis();
    var extent;
    var bandWidth = baseAxis.type === "category" ? baseAxis.getBandWidth() : (extent = baseAxis.getExtent(), Math.abs(extent[1] - extent[0]) / data.count());
    var barMaxWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)((0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(seriesModel.get("barMaxWidth"), bandWidth), bandWidth);
    var barMinWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)((0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(seriesModel.get("barMinWidth"), 1), bandWidth);
    var barWidth = seriesModel.get("barWidth");
    return barWidth != null ? (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(barWidth, bandWidth) : Math.max(Math.min(bandWidth / 2, barMaxWidth), barMinWidth);
}
var $a4e49046f9f1fd8b$export$2e2bcd8739ae039 = $a4e49046f9f1fd8b$var$candlestickLayout;


function $21999577dfdc5807$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $74dcd5b9be05016d$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $b79b80243e209954$export$2e2bcd8739ae039));
    registers.registerPreprocessor((0, $55263b38adc138a7$export$2e2bcd8739ae039));
    registers.registerVisual((0, $f31d4ab399bcabcc$export$2e2bcd8739ae039));
    registers.registerLayout((0, $a4e49046f9f1fd8b$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $eed47112c7f91d02$var$ChordPiece = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ChordPiece, _super);
    function ChordPiece(data, idx, startAngle) {
        var _this = _super.call(this) || this;
        (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(_this).dataType = "node";
        _this.z2 = 2;
        var text = new $fe885cc21795562b$export$2e2bcd8739ae039();
        _this.setTextContent(text);
        _this.updateData(data, idx, startAngle, true);
        return _this;
    }
    ChordPiece.prototype.updateData = function(data, idx, startAngle, firstCreate) {
        var sector = this;
        var node = data.graph.getNodeByIndex(idx);
        var seriesModel = data.hostModel;
        var itemModel = node.getModel();
        var emphasisModel = itemModel.getModel("emphasis");
        // layout position is the center of the sector
        var layout = data.getItemLayout(idx);
        var shape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemModel.getModel("itemStyle"), layout, true), layout);
        var el = this;
        // Ignore NaN data.
        if (isNaN(shape.startAngle)) {
            // Use NaN shape to avoid drawing shape.
            el.setShape(shape);
            return;
        }
        if (firstCreate) el.setShape(shape);
        else $8b353638fbedfefa$export$c8dce3c08436e91e(el, {
            shape: shape
        }, seriesModel, idx);
        var sectorShape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemModel.getModel("itemStyle"), layout, true), layout);
        sector.setShape(sectorShape);
        sector.useStyle(data.getItemVisual(idx, "style"));
        (0, $2bf82c0980125b62$export$48b68047d330bbc9)(sector, itemModel);
        this._updateLabel(seriesModel, itemModel, node);
        data.setItemGraphicEl(idx, el);
        (0, $2bf82c0980125b62$export$48b68047d330bbc9)(el, itemModel, "itemStyle");
        // Add focus/blur states handling
        var focus = emphasisModel.get("focus");
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, focus === "adjacency" ? node.getAdjacentDataIndices() : focus, emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
    };
    ChordPiece.prototype._updateLabel = function(seriesModel, itemModel, node) {
        var label = this.getTextContent();
        var layout = node.getLayout();
        var midAngle = (layout.startAngle + layout.endAngle) / 2;
        var dx = Math.cos(midAngle);
        var dy = Math.sin(midAngle);
        var normalLabelModel = itemModel.getModel("label");
        label.ignore = !normalLabelModel.get("show");
        // Set label style
        var labelStateModels = (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel);
        var style = node.getVisual("style");
        (0, $6800dfcb6e1e2a44$export$9a13992917966657)(label, labelStateModels, {
            labelFetcher: {
                getFormattedLabel: function(dataIndex, stateName, dataType, labelDimIndex, formatter, extendParams) {
                    return seriesModel.getFormattedLabel(dataIndex, stateName, "node", labelDimIndex, // ensure edgeLabel formatter is provided
                    // to prevent the inheritance from `label.formatter` of the series
                    (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(formatter, labelStateModels.normal && labelStateModels.normal.get("formatter"), itemModel.get("name")), extendParams);
                }
            },
            labelDataIndex: node.dataIndex,
            defaultText: node.dataIndex + "",
            inheritColor: style.fill,
            defaultOpacity: style.opacity,
            defaultOutsidePosition: "startArc"
        });
        // Set label position
        var labelPosition = normalLabelModel.get("position") || "outside";
        var labelPadding = normalLabelModel.get("distance") || 0;
        var r;
        if (labelPosition === "outside") r = layout.r + labelPadding;
        else r = (layout.r + layout.r0) / 2;
        this.textConfig = {
            inside: labelPosition !== "outside"
        };
        var align = labelPosition !== "outside" ? normalLabelModel.get("align") || "center" : dx > 0 ? "left" : "right";
        var verticalAlign = labelPosition !== "outside" ? normalLabelModel.get("verticalAlign") || "middle" : dy > 0 ? "top" : "bottom";
        label.attr({
            x: dx * r + layout.cx,
            y: dy * r + layout.cy,
            rotation: 0,
            style: {
                align: align,
                verticalAlign: verticalAlign
            }
        });
    };
    return ChordPiece;
}($a3e1dec0a3875b49$export$2e2bcd8739ae039);
var $eed47112c7f91d02$export$2e2bcd8739ae039 = $eed47112c7f91d02$var$ChordPiece;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $e3c6060f527583e7$export$aba8cafb87a78113 = /** @class */ function() {
    function ChordPathShape() {
        // Souce node, two points forming an arc
        this.s1 = [
            0,
            0
        ];
        this.s2 = [
            0,
            0
        ];
        this.sStartAngle = 0;
        this.sEndAngle = 0;
        // Target node, two points forming an arc
        this.t1 = [
            0,
            0
        ];
        this.t2 = [
            0,
            0
        ];
        this.tStartAngle = 0;
        this.tEndAngle = 0;
        this.cx = 0;
        this.cy = 0;
        // series.r0 of ChordSeries
        this.r = 0;
        this.clockwise = true;
    }
    return ChordPathShape;
}();
var $e3c6060f527583e7$export$468595ff2cf80854 = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ChordEdge, _super);
    function ChordEdge(nodeData, edgeData, edgeIdx, startAngle) {
        var _this = _super.call(this) || this;
        (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(_this).dataType = "edge";
        _this.updateData(nodeData, edgeData, edgeIdx, startAngle, true);
        return _this;
    }
    ChordEdge.prototype.buildPath = function(ctx, shape) {
        // Start from n11
        ctx.moveTo(shape.s1[0], shape.s1[1]);
        var ratio = 0.7;
        var clockwise = shape.clockwise;
        // Draw the arc from n11 to n12
        ctx.arc(shape.cx, shape.cy, shape.r, shape.sStartAngle, shape.sEndAngle, !clockwise);
        // Bezier curve to cp1 and then to n21
        ctx.bezierCurveTo((shape.cx - shape.s2[0]) * ratio + shape.s2[0], (shape.cy - shape.s2[1]) * ratio + shape.s2[1], (shape.cx - shape.t1[0]) * ratio + shape.t1[0], (shape.cy - shape.t1[1]) * ratio + shape.t1[1], shape.t1[0], shape.t1[1]);
        // Draw the arc from n21 to n22
        ctx.arc(shape.cx, shape.cy, shape.r, shape.tStartAngle, shape.tEndAngle, !clockwise);
        // Bezier curve back to cp2 and then to n11
        ctx.bezierCurveTo((shape.cx - shape.t2[0]) * ratio + shape.t2[0], (shape.cy - shape.t2[1]) * ratio + shape.t2[1], (shape.cx - shape.s1[0]) * ratio + shape.s1[0], (shape.cy - shape.s1[1]) * ratio + shape.s1[1], shape.s1[0], shape.s1[1]);
        ctx.closePath();
    };
    ChordEdge.prototype.updateData = function(nodeData, edgeData, edgeIdx, startAngle, firstCreate) {
        var seriesModel = nodeData.hostModel;
        var edge = edgeData.graph.getEdgeByIndex(edgeIdx);
        var layout = edge.getLayout();
        var itemModel = edge.node1.getModel();
        var edgeModel = edgeData.getItemModel(edge.dataIndex);
        var lineStyle = edgeModel.getModel("lineStyle");
        var emphasisModel = edgeModel.getModel("emphasis");
        var focus = emphasisModel.get("focus");
        var shape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemModel.getModel("itemStyle"), layout, true), layout);
        var el = this;
        // Ignore NaN data.
        if (isNaN(shape.sStartAngle) || isNaN(shape.tStartAngle)) {
            // Use NaN shape to avoid drawing shape.
            el.setShape(shape);
            return;
        }
        if (firstCreate) {
            el.setShape(shape);
            $e3c6060f527583e7$var$applyEdgeFill(el, edge, nodeData, lineStyle);
        } else {
            (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(el);
            $e3c6060f527583e7$var$applyEdgeFill(el, edge, nodeData, lineStyle);
            $8b353638fbedfefa$export$c8dce3c08436e91e(el, {
                shape: shape
            }, seriesModel, edgeIdx);
        }
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, focus === "adjacency" ? edge.getAdjacentDataIndices() : focus, emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
        (0, $2bf82c0980125b62$export$48b68047d330bbc9)(el, edgeModel, "lineStyle");
        edgeData.setItemGraphicEl(edge.dataIndex, el);
    };
    return ChordEdge;
}($b02ffe7acd508c08$export$2e2bcd8739ae039);
function $e3c6060f527583e7$var$applyEdgeFill(edgeShape, edge, nodeData, lineStyleModel) {
    var node1 = edge.node1;
    var node2 = edge.node2;
    var edgeStyle = edgeShape.style;
    edgeShape.setStyle(lineStyleModel.getLineStyle());
    var color = lineStyleModel.get("color");
    switch(color){
        case "source":
            // TODO: use visual and node1.getVisual('color');
            edgeStyle.fill = nodeData.getItemVisual(node1.dataIndex, "style").fill;
            edgeStyle.decal = node1.getVisual("style").decal;
            break;
        case "target":
            edgeStyle.fill = nodeData.getItemVisual(node2.dataIndex, "style").fill;
            edgeStyle.decal = node2.getVisual("style").decal;
            break;
        case "gradient":
            var sourceColor = nodeData.getItemVisual(node1.dataIndex, "style").fill;
            var targetColor = nodeData.getItemVisual(node2.dataIndex, "style").fill;
            if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(sourceColor) && (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(targetColor)) {
                // Gradient direction is perpendicular to the mid-angles
                // of source and target nodes.
                var shape = edgeShape.shape;
                var sMidX = (shape.s1[0] + shape.s2[0]) / 2;
                var sMidY = (shape.s1[1] + shape.s2[1]) / 2;
                var tMidX = (shape.t1[0] + shape.t2[0]) / 2;
                var tMidY = (shape.t1[1] + shape.t2[1]) / 2;
                edgeStyle.fill = new $cf44c01491b58e53$export$2e2bcd8739ae039(sMidX, sMidY, tMidX, tMidY, [
                    {
                        offset: 0,
                        color: sourceColor
                    },
                    {
                        offset: 1,
                        color: targetColor
                    }
                ], true);
            }
            break;
    }
}




var $dc6cb5840da6548b$var$RADIAN = Math.PI / 180;
var $dc6cb5840da6548b$var$ChordView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ChordView, _super);
    function ChordView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ChordView.type;
        return _this;
    }
    ChordView.prototype.init = function(ecModel, api) {};
    ChordView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var oldData = this._data;
        var group = this.group;
        var startAngle = -seriesModel.get("startAngle") * $dc6cb5840da6548b$var$RADIAN;
        data.diff(oldData).add(function(newIdx) {
            /* Consider the case when there are only two nodes A and B,
       * and there is a link between A and B.
       * At first, they are both disselected from legend. And then
       * when A is selected, A will go into `add` method. But since
       * there are no edges to be displayed, A should not be added.
       * So we should only add A when layout is defined.
       */ var layout = data.getItemLayout(newIdx);
            if (layout) {
                var el = new (0, $eed47112c7f91d02$export$2e2bcd8739ae039)(data, newIdx, startAngle);
                (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).dataIndex = newIdx;
                group.add(el);
            }
        }).update(function(newIdx, oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            var layout = data.getItemLayout(newIdx);
            /* Consider the case when there are only two nodes A and B,
       * and there is a link between A and B.
       * and when A is disselected from legend, there should be
       * nothing to display. But in the `data.diff` method, B will go
       * into `update` method and having no layout.
       * In this case, we need to remove B.
       */ if (!layout) {
                el && $8b353638fbedfefa$export$6d0fd725cb4aee8a(el, seriesModel, oldIdx);
                return;
            }
            if (!el) el = new (0, $eed47112c7f91d02$export$2e2bcd8739ae039)(data, newIdx, startAngle);
            else el.updateData(data, newIdx, startAngle);
            group.add(el);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && $8b353638fbedfefa$export$6d0fd725cb4aee8a(el, seriesModel, oldIdx);
        }).execute();
        if (!oldData) {
            var center = seriesModel.get("center");
            this.group.scaleX = 0.01;
            this.group.scaleY = 0.01;
            this.group.originX = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[0], api.getWidth());
            this.group.originY = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[1], api.getHeight());
            $8b353638fbedfefa$export$a121566aadcfe021(this.group, {
                scaleX: 1,
                scaleY: 1
            }, seriesModel);
        }
        this._data = data;
        this.renderEdges(seriesModel, startAngle);
    };
    ChordView.prototype.renderEdges = function(seriesModel, startAngle) {
        var nodeData = seriesModel.getData();
        var edgeData = seriesModel.getEdgeData();
        var oldData = this._edgeData;
        var group = this.group;
        edgeData.diff(oldData).add(function(newIdx) {
            var el = new (0, $e3c6060f527583e7$export$468595ff2cf80854)(nodeData, edgeData, newIdx, startAngle);
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).dataIndex = newIdx;
            group.add(el);
        }).update(function(newIdx, oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el.updateData(nodeData, edgeData, newIdx, startAngle);
            group.add(el);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && $8b353638fbedfefa$export$6d0fd725cb4aee8a(el, seriesModel, oldIdx);
        }).execute();
        this._edgeData = edgeData;
    };
    ChordView.prototype.dispose = function() {};
    ChordView.type = "chord";
    return ChordView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $dc6cb5840da6548b$export$2e2bcd8739ae039 = $dc6cb5840da6548b$var$ChordView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
// id may be function name of Object, add a prefix to avoid this problem.
function $7e67f74238c90217$var$generateNodeKey(id) {
    return "_EC_" + id;
}
var $7e67f74238c90217$var$Graph = /** @class */ function() {
    function Graph(directed) {
        this.type = "graph";
        this.nodes = [];
        this.edges = [];
        this._nodesMap = {};
        /**
     * @type {Object.<string, module:echarts/data/Graph.Edge>}
     * @private
     */ this._edgesMap = {};
        this._directed = directed || false;
    }
    /**
   * If is directed graph
   */ Graph.prototype.isDirected = function() {
        return this._directed;
    };
    /**
   * Add a new node
   */ Graph.prototype.addNode = function(id, dataIndex) {
        id = id == null ? "" + dataIndex : "" + id;
        var nodesMap = this._nodesMap;
        if (nodesMap[$7e67f74238c90217$var$generateNodeKey(id)]) return;
        var node = new $7e67f74238c90217$export$32866653dfc29d0d(id, dataIndex);
        node.hostGraph = this;
        this.nodes.push(node);
        nodesMap[$7e67f74238c90217$var$generateNodeKey(id)] = node;
        return node;
    };
    /**
   * Get node by data index
   */ Graph.prototype.getNodeByIndex = function(dataIndex) {
        var rawIdx = this.data.getRawIndex(dataIndex);
        return this.nodes[rawIdx];
    };
    /**
   * Get node by id
   */ Graph.prototype.getNodeById = function(id) {
        return this._nodesMap[$7e67f74238c90217$var$generateNodeKey(id)];
    };
    /**
   * Add a new edge
   */ Graph.prototype.addEdge = function(n1, n2, dataIndex) {
        var nodesMap = this._nodesMap;
        var edgesMap = this._edgesMap;
        // PENDING
        if ($7a1bd9c2710fea0d$export$7e4aa119212bc614(n1)) n1 = this.nodes[n1];
        if ($7a1bd9c2710fea0d$export$7e4aa119212bc614(n2)) n2 = this.nodes[n2];
        if (!(n1 instanceof $7e67f74238c90217$export$32866653dfc29d0d)) n1 = nodesMap[$7e67f74238c90217$var$generateNodeKey(n1)];
        if (!(n2 instanceof $7e67f74238c90217$export$32866653dfc29d0d)) n2 = nodesMap[$7e67f74238c90217$var$generateNodeKey(n2)];
        if (!n1 || !n2) return;
        var key = n1.id + "-" + n2.id;
        var edge = new $7e67f74238c90217$export$87f150720cc8d165(n1, n2, dataIndex);
        edge.hostGraph = this;
        if (this._directed) {
            n1.outEdges.push(edge);
            n2.inEdges.push(edge);
        }
        n1.edges.push(edge);
        if (n1 !== n2) n2.edges.push(edge);
        this.edges.push(edge);
        edgesMap[key] = edge;
        return edge;
    };
    /**
   * Get edge by data index
   */ Graph.prototype.getEdgeByIndex = function(dataIndex) {
        var rawIdx = this.edgeData.getRawIndex(dataIndex);
        return this.edges[rawIdx];
    };
    /**
   * Get edge by two linked nodes
   */ Graph.prototype.getEdge = function(n1, n2) {
        if (n1 instanceof $7e67f74238c90217$export$32866653dfc29d0d) n1 = n1.id;
        if (n2 instanceof $7e67f74238c90217$export$32866653dfc29d0d) n2 = n2.id;
        var edgesMap = this._edgesMap;
        if (this._directed) return edgesMap[n1 + "-" + n2];
        else return edgesMap[n1 + "-" + n2] || edgesMap[n2 + "-" + n1];
    };
    /**
   * Iterate all nodes
   */ Graph.prototype.eachNode = function(cb, context) {
        var nodes = this.nodes;
        var len = nodes.length;
        for(var i = 0; i < len; i++)if (nodes[i].dataIndex >= 0) cb.call(context, nodes[i], i);
    };
    /**
   * Iterate all edges
   */ Graph.prototype.eachEdge = function(cb, context) {
        var edges = this.edges;
        var len = edges.length;
        for(var i = 0; i < len; i++)if (edges[i].dataIndex >= 0 && edges[i].node1.dataIndex >= 0 && edges[i].node2.dataIndex >= 0) cb.call(context, edges[i], i);
    };
    /**
   * Breadth first traverse
   * Return true to stop traversing
   */ Graph.prototype.breadthFirstTraverse = function(cb, startNode, direction, context) {
        if (!(startNode instanceof $7e67f74238c90217$export$32866653dfc29d0d)) startNode = this._nodesMap[$7e67f74238c90217$var$generateNodeKey(startNode)];
        if (!startNode) return;
        var edgeType = direction === "out" ? "outEdges" : direction === "in" ? "inEdges" : "edges";
        for(var i = 0; i < this.nodes.length; i++)this.nodes[i].__visited = false;
        if (cb.call(context, startNode, null)) return;
        var queue = [
            startNode
        ];
        while(queue.length){
            var currentNode = queue.shift();
            var edges = currentNode[edgeType];
            for(var i = 0; i < edges.length; i++){
                var e = edges[i];
                var otherNode = e.node1 === currentNode ? e.node2 : e.node1;
                if (!otherNode.__visited) {
                    if (cb.call(context, otherNode, currentNode)) // Stop traversing
                    return;
                    queue.push(otherNode);
                    otherNode.__visited = true;
                }
            }
        }
    };
    // TODO
    // depthFirstTraverse(
    //     cb, startNode, direction, context
    // ) {
    // };
    // Filter update
    Graph.prototype.update = function() {
        var data = this.data;
        var edgeData = this.edgeData;
        var nodes = this.nodes;
        var edges = this.edges;
        for(var i = 0, len = nodes.length; i < len; i++)nodes[i].dataIndex = -1;
        for(var i = 0, len = data.count(); i < len; i++)nodes[data.getRawIndex(i)].dataIndex = i;
        edgeData.filterSelf(function(idx) {
            var edge = edges[edgeData.getRawIndex(idx)];
            return edge.node1.dataIndex >= 0 && edge.node2.dataIndex >= 0;
        });
        // Update edge
        for(var i = 0, len = edges.length; i < len; i++)edges[i].dataIndex = -1;
        for(var i = 0, len = edgeData.count(); i < len; i++)edges[edgeData.getRawIndex(i)].dataIndex = i;
    };
    /**
   * @return {module:echarts/data/Graph}
   */ Graph.prototype.clone = function() {
        var graph = new Graph(this._directed);
        var nodes = this.nodes;
        var edges = this.edges;
        for(var i = 0; i < nodes.length; i++)graph.addNode(nodes[i].id, nodes[i].dataIndex);
        for(var i = 0; i < edges.length; i++){
            var e = edges[i];
            graph.addEdge(e.node1.id, e.node2.id, e.dataIndex);
        }
        return graph;
    };
    return Graph;
}();
var $7e67f74238c90217$export$32866653dfc29d0d = /** @class */ function() {
    function GraphNode(id, dataIndex) {
        this.inEdges = [];
        this.outEdges = [];
        this.edges = [];
        this.dataIndex = -1;
        this.id = id == null ? "" : id;
        this.dataIndex = dataIndex == null ? -1 : dataIndex;
    }
    /**
   * @return {number}
   */ GraphNode.prototype.degree = function() {
        return this.edges.length;
    };
    /**
   * @return {number}
   */ GraphNode.prototype.inDegree = function() {
        return this.inEdges.length;
    };
    /**
  * @return {number}
  */ GraphNode.prototype.outDegree = function() {
        return this.outEdges.length;
    };
    GraphNode.prototype.getModel = function(path) {
        if (this.dataIndex < 0) return;
        var graph = this.hostGraph;
        var itemModel = graph.data.getItemModel(this.dataIndex);
        return itemModel.getModel(path);
    };
    GraphNode.prototype.getAdjacentDataIndices = function() {
        var dataIndices = {
            edge: [],
            node: []
        };
        for(var i = 0; i < this.edges.length; i++){
            var adjacentEdge = this.edges[i];
            if (adjacentEdge.dataIndex < 0) continue;
            dataIndices.edge.push(adjacentEdge.dataIndex);
            dataIndices.node.push(adjacentEdge.node1.dataIndex, adjacentEdge.node2.dataIndex);
        }
        return dataIndices;
    };
    GraphNode.prototype.getTrajectoryDataIndices = function() {
        var connectedEdgesMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var connectedNodesMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        for(var i = 0, len = this.edges.length; i < len; i++){
            var adjacentEdge = this.edges[i];
            if (adjacentEdge.dataIndex < 0) continue;
            connectedEdgesMap.set(adjacentEdge.dataIndex, true);
            var sourceNodesQueue = [
                adjacentEdge.node1
            ];
            var targetNodesQueue = [
                adjacentEdge.node2
            ];
            var nodeIteratorIndex = 0;
            while(nodeIteratorIndex < sourceNodesQueue.length){
                var sourceNode = sourceNodesQueue[nodeIteratorIndex];
                nodeIteratorIndex++;
                connectedNodesMap.set(sourceNode.dataIndex, true);
                var sourceNodeInEdges = sourceNode.inEdges;
                for(var j = 0, len_1 = sourceNodeInEdges.length, inEdge = void 0, inEdgeDataIndex = void 0; j < len_1; j++){
                    inEdge = sourceNodeInEdges[j];
                    inEdgeDataIndex = inEdge.dataIndex;
                    if (inEdgeDataIndex >= 0 && !connectedEdgesMap.hasKey(inEdgeDataIndex)) {
                        connectedEdgesMap.set(inEdgeDataIndex, true);
                        sourceNodesQueue.push(inEdge.node1);
                    }
                }
            }
            nodeIteratorIndex = 0;
            while(nodeIteratorIndex < targetNodesQueue.length){
                var targetNode = targetNodesQueue[nodeIteratorIndex];
                nodeIteratorIndex++;
                connectedNodesMap.set(targetNode.dataIndex, true);
                var targetNodeOutEdges = targetNode.outEdges;
                for(var j = 0, len_2 = targetNodeOutEdges.length, outEdge = void 0, outEdgeDataIndex = void 0; j < len_2; j++){
                    outEdge = targetNodeOutEdges[j];
                    outEdgeDataIndex = outEdge.dataIndex;
                    if (outEdgeDataIndex >= 0 && !connectedEdgesMap.hasKey(outEdgeDataIndex)) {
                        connectedEdgesMap.set(outEdgeDataIndex, true);
                        targetNodesQueue.push(outEdge.node2);
                    }
                }
            }
        }
        return {
            edge: connectedEdgesMap.keys(),
            node: connectedNodesMap.keys()
        };
    };
    return GraphNode;
}();
var $7e67f74238c90217$export$87f150720cc8d165 = /** @class */ function() {
    function GraphEdge(n1, n2, dataIndex) {
        this.dataIndex = -1;
        this.node1 = n1;
        this.node2 = n2;
        this.dataIndex = dataIndex == null ? -1 : dataIndex;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    GraphEdge.prototype.getModel = function(path) {
        if (this.dataIndex < 0) return;
        var graph = this.hostGraph;
        var itemModel = graph.edgeData.getItemModel(this.dataIndex);
        return itemModel.getModel(path);
    };
    GraphEdge.prototype.getAdjacentDataIndices = function() {
        return {
            edge: [
                this.dataIndex
            ],
            node: [
                this.node1.dataIndex,
                this.node2.dataIndex
            ]
        };
    };
    GraphEdge.prototype.getTrajectoryDataIndices = function() {
        var connectedEdgesMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var connectedNodesMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        connectedEdgesMap.set(this.dataIndex, true);
        var sourceNodes = [
            this.node1
        ];
        var targetNodes = [
            this.node2
        ];
        var nodeIteratorIndex = 0;
        while(nodeIteratorIndex < sourceNodes.length){
            var sourceNode = sourceNodes[nodeIteratorIndex];
            nodeIteratorIndex++;
            connectedNodesMap.set(sourceNode.dataIndex, true);
            var sourceNodeInEdges = sourceNode.inEdges;
            for(var j = 0, len = sourceNodeInEdges.length, inEdge = void 0, inEdgeDataIndex = void 0; j < len; j++){
                inEdge = sourceNode.inEdges[j];
                inEdgeDataIndex = inEdge.dataIndex;
                if (inEdgeDataIndex >= 0 && !connectedEdgesMap.hasKey(inEdgeDataIndex)) {
                    connectedEdgesMap.set(inEdgeDataIndex, true);
                    sourceNodes.push(inEdge.node1);
                }
            }
        }
        nodeIteratorIndex = 0;
        while(nodeIteratorIndex < targetNodes.length){
            var targetNode = targetNodes[nodeIteratorIndex];
            nodeIteratorIndex++;
            connectedNodesMap.set(targetNode.dataIndex, true);
            var targetNodeOutEdges = targetNode.outEdges;
            for(var j = 0, len = targetNodeOutEdges.length, outEdge = void 0, outEdgeDataIndex = void 0; j < len; j++){
                outEdge = targetNode.outEdges[j];
                outEdgeDataIndex = outEdge.dataIndex;
                if (outEdgeDataIndex >= 0 && !connectedEdgesMap.hasKey(outEdgeDataIndex)) {
                    connectedEdgesMap.set(outEdgeDataIndex, true);
                    targetNodes.push(outEdge.node2);
                }
            }
        }
        return {
            edge: connectedEdgesMap.keys(),
            node: connectedNodesMap.keys()
        };
    };
    return GraphEdge;
}();
function $7e67f74238c90217$var$createGraphDataProxyMixin(hostName, dataName) {
    return {
        /**
     * @param Default 'value'. can be 'a', 'b', 'c', 'd', 'e'.
     */ getValue: function(dimension) {
            var data = this[hostName][dataName];
            return data.getStore().get(data.getDimensionIndex(dimension || "value"), this.dataIndex);
        },
        // TODO: TYPE stricter type.
        setVisual: function(key, value) {
            this.dataIndex >= 0 && this[hostName][dataName].setItemVisual(this.dataIndex, key, value);
        },
        getVisual: function(key) {
            return this[hostName][dataName].getItemVisual(this.dataIndex, key);
        },
        setLayout: function(layout, merge) {
            this.dataIndex >= 0 && this[hostName][dataName].setItemLayout(this.dataIndex, layout, merge);
        },
        getLayout: function() {
            return this[hostName][dataName].getItemLayout(this.dataIndex);
        },
        getGraphicEl: function() {
            return this[hostName][dataName].getItemGraphicEl(this.dataIndex);
        },
        getRawIndex: function() {
            return this[hostName][dataName].getRawIndex(this.dataIndex);
        }
    };
}
$7a1bd9c2710fea0d$export$e36fc9d62a853069($7e67f74238c90217$export$32866653dfc29d0d, $7e67f74238c90217$var$createGraphDataProxyMixin("hostGraph", "data"));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($7e67f74238c90217$export$87f150720cc8d165, $7e67f74238c90217$var$createGraphDataProxyMixin("hostGraph", "edgeData"));
var $7e67f74238c90217$export$2e2bcd8739ae039 = $7e67f74238c90217$var$Graph;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Link lists and struct (graph or tree)
 */ 

var $4a8451eb7786c849$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $4a8451eb7786c849$var$linkSeriesData(opt) {
    var mainData = opt.mainData;
    var datas = opt.datas;
    if (!datas) {
        datas = {
            main: mainData
        };
        opt.datasAttr = {
            main: "data"
        };
    }
    opt.datas = opt.mainData = null;
    $4a8451eb7786c849$var$linkAll(mainData, datas, opt);
    // Porxy data original methods.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(datas, function(data) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mainData.TRANSFERABLE_METHODS, function(methodName) {
            data.wrapMethod(methodName, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($4a8451eb7786c849$var$transferInjection, opt));
        });
    });
    // Beyond transfer, additional features should be added to `cloneShallow`.
    mainData.wrapMethod("cloneShallow", (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($4a8451eb7786c849$var$cloneShallowInjection, opt));
    // Only mainData trigger change, because struct.update may trigger
    // another changable methods, which may bring about dead lock.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mainData.CHANGABLE_METHODS, function(methodName) {
        mainData.wrapMethod(methodName, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($4a8451eb7786c849$var$changeInjection, opt));
    });
    // Make sure datas contains mainData.
    (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(datas[mainData.dataType] === mainData);
}
function $4a8451eb7786c849$var$transferInjection(opt, res) {
    if ($4a8451eb7786c849$var$isMainData(this)) {
        // Transfer datas to new main data.
        var datas = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, $4a8451eb7786c849$var$inner(this).datas);
        datas[this.dataType] = res;
        $4a8451eb7786c849$var$linkAll(res, datas, opt);
    } else // Modify the reference in main data to point newData.
    $4a8451eb7786c849$var$linkSingle(res, this.dataType, $4a8451eb7786c849$var$inner(this).mainData, opt);
    return res;
}
function $4a8451eb7786c849$var$changeInjection(opt, res) {
    opt.struct && opt.struct.update();
    return res;
}
function $4a8451eb7786c849$var$cloneShallowInjection(opt, res) {
    // cloneShallow, which brings about some fragilities, may be inappropriate
    // to be exposed as an API. So for implementation simplicity we can make
    // the restriction that cloneShallow of not-mainData should not be invoked
    // outside, but only be invoked here.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($4a8451eb7786c849$var$inner(res).datas, function(data, dataType) {
        data !== res && $4a8451eb7786c849$var$linkSingle(data.cloneShallow(), dataType, res, opt);
    });
    return res;
}
/**
 * Supplement method to List.
 *
 * @public
 * @param [dataType] If not specified, return mainData.
 */ function $4a8451eb7786c849$var$getLinkedData(dataType) {
    var mainData = $4a8451eb7786c849$var$inner(this).mainData;
    return dataType == null || mainData == null ? mainData : $4a8451eb7786c849$var$inner(mainData).datas[dataType];
}
/**
 * Get list of all linked data
 */ function $4a8451eb7786c849$var$getLinkedDataAll() {
    var mainData = $4a8451eb7786c849$var$inner(this).mainData;
    return mainData == null ? [
        {
            data: mainData
        }
    ] : (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)($4a8451eb7786c849$var$inner(mainData).datas), function(type) {
        return {
            type: type,
            data: $4a8451eb7786c849$var$inner(mainData).datas[type]
        };
    });
}
function $4a8451eb7786c849$var$isMainData(data) {
    return $4a8451eb7786c849$var$inner(data).mainData === data;
}
function $4a8451eb7786c849$var$linkAll(mainData, datas, opt) {
    $4a8451eb7786c849$var$inner(mainData).datas = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(datas, function(data, dataType) {
        $4a8451eb7786c849$var$linkSingle(data, dataType, mainData, opt);
    });
}
function $4a8451eb7786c849$var$linkSingle(data, dataType, mainData, opt) {
    $4a8451eb7786c849$var$inner(mainData).datas[dataType] = data;
    $4a8451eb7786c849$var$inner(data).mainData = mainData;
    data.dataType = dataType;
    if (opt.struct) {
        data[opt.structAttr] = opt.struct;
        opt.struct[opt.datasAttr[dataType]] = data;
    }
    // Supplement method.
    data.getLinkedData = $4a8451eb7786c849$var$getLinkedData;
    data.getLinkedDataAll = $4a8451eb7786c849$var$getLinkedDataAll;
}
var $4a8451eb7786c849$export$2e2bcd8739ae039 = $4a8451eb7786c849$var$linkSeriesData;






function $09eb5d193a1ecbce$export$2e2bcd8739ae039(nodes, edges, seriesModel, directed, beforeLink) {
    // ??? TODO
    // support dataset?
    var graph = new (0, $7e67f74238c90217$export$2e2bcd8739ae039)(directed);
    for(var i = 0; i < nodes.length; i++)graph.addNode($7a1bd9c2710fea0d$export$8a4d17b6e8486e66(// Id, name, dataIndex
    nodes[i].id, nodes[i].name, i), i);
    var linkNameList = [];
    var validEdges = [];
    var linkCount = 0;
    for(var i = 0; i < edges.length; i++){
        var link = edges[i];
        var source = link.source;
        var target = link.target;
        // addEdge may fail when source or target not exists
        if (graph.addEdge(source, target, linkCount)) {
            validEdges.push(link);
            linkNameList.push($7a1bd9c2710fea0d$export$8a4d17b6e8486e66((0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(link.id, null), source + " > " + target));
            linkCount++;
        }
    }
    var coordSys = seriesModel.get("coordinateSystem");
    var nodeData;
    if (coordSys === "cartesian2d" || coordSys === "polar" || coordSys === "matrix") nodeData = (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(nodes, seriesModel);
    else {
        var coordSysCtor = (0, $70c3ede7d3b64757$export$2e2bcd8739ae039).get(coordSys);
        var coordDimensions = coordSysCtor ? coordSysCtor.dimensions || [] : [];
        // FIXME: Some geo do not need `value` dimenson, whereas `calendar` needs
        // `value` dimension, but graph need `value` dimension. It's better to
        // uniform this behavior.
        if ($7a1bd9c2710fea0d$export$305f7d4e9d4624f2(coordDimensions, "value") < 0) coordDimensions.concat([
            "value"
        ]);
        var dimensions = (0, $a27631012b7b377c$export$2e2bcd8739ae039)(nodes, {
            coordDimensions: coordDimensions,
            encodeDefine: seriesModel.getEncode()
        }).dimensions;
        nodeData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(dimensions, seriesModel);
        nodeData.initData(nodes);
    }
    var edgeData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)([
        "value"
    ], seriesModel);
    edgeData.initData(validEdges, linkNameList);
    beforeLink && beforeLink(nodeData, edgeData);
    (0, $4a8451eb7786c849$export$2e2bcd8739ae039)({
        mainData: nodeData,
        struct: graph,
        structAttr: "graph",
        datas: {
            node: nodeData,
            edge: edgeData
        },
        datasAttr: {
            node: "data",
            edge: "edgeData"
        }
    });
    // Update dataIndex of nodes and edges because invalid edge may be removed
    graph.update();
    return graph;
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * LegendVisualProvider is an bridge that pick encoded color from data and
 * provide to the legend component.
 */ var $cf24728fc17c4ab6$var$LegendVisualProvider = /** @class */ function() {
    function LegendVisualProvider(// Function to get data after filtered. It stores all the encoding info
    getDataWithEncodedVisual, // Function to get raw data before filtered.
    getRawData) {
        this._getDataWithEncodedVisual = getDataWithEncodedVisual;
        this._getRawData = getRawData;
    }
    LegendVisualProvider.prototype.getAllNames = function() {
        var rawData = this._getRawData();
        // We find the name from the raw data. In case it's filtered by the legend component.
        // Normally, the name can be found in rawData, but can't be found in filtered data will display as gray.
        return rawData.mapArray(rawData.getName);
    };
    LegendVisualProvider.prototype.containName = function(name) {
        var rawData = this._getRawData();
        return rawData.indexOfName(name) >= 0;
    };
    LegendVisualProvider.prototype.indexOfName = function(name) {
        // Only get data when necessary.
        // Because LegendVisualProvider constructor may be new in the stage that data is not prepared yet.
        // Invoking Series#getData immediately will throw an error.
        var dataWithEncodedVisual = this._getDataWithEncodedVisual();
        return dataWithEncodedVisual.indexOfName(name);
    };
    LegendVisualProvider.prototype.getItemVisual = function(dataIndex, key) {
        // Get encoded visual properties from final filtered data.
        var dataWithEncodedVisual = this._getDataWithEncodedVisual();
        return dataWithEncodedVisual.getItemVisual(dataIndex, key);
    };
    return LegendVisualProvider;
}();
var $cf24728fc17c4ab6$export$2e2bcd8739ae039 = $cf24728fc17c4ab6$var$LegendVisualProvider;



var $4d5b20ba15d193e5$var$ChordSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ChordSeriesModel, _super);
    function ChordSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ChordSeriesModel.type;
        return _this;
    }
    ChordSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        this.fillDataTextStyle(option.edges || option.links);
        // Enable legend selection for each data item
        this.legendVisualProvider = new (0, $cf24728fc17c4ab6$export$2e2bcd8739ae039)($7a1bd9c2710fea0d$export$2385a24977818dd0(this.getData, this), $7a1bd9c2710fea0d$export$2385a24977818dd0(this.getRawData, this));
    };
    ChordSeriesModel.prototype.mergeOption = function(option) {
        _super.prototype.mergeOption.apply(this, arguments);
        this.fillDataTextStyle(option.edges || option.links);
    };
    ChordSeriesModel.prototype.getInitialData = function(option, ecModel) {
        var edges = option.edges || option.links || [];
        var nodes = option.data || option.nodes || [];
        if (nodes && edges) {
            var graph = (0, $09eb5d193a1ecbce$export$2e2bcd8739ae039)(nodes, edges, this, true, beforeLink);
            return graph.data;
        }
        function beforeLink(nodeData, edgeData) {
            // TODO Inherit resolveParentPath by default in Model#getModel?
            var oldGetModel = (0, $6818646a97528290$export$2e2bcd8739ae039).prototype.getModel;
            function newGetModel(path, parentModel) {
                var model = oldGetModel.call(this, path, parentModel);
                model.resolveParentPath = resolveParentPath;
                return model;
            }
            edgeData.wrapMethod("getItemModel", function(model) {
                model.resolveParentPath = resolveParentPath;
                model.getModel = newGetModel;
                return model;
            });
            function resolveParentPath(pathArr) {
                if (pathArr && (pathArr[0] === "label" || pathArr[1] === "label")) {
                    var newPathArr = pathArr.slice();
                    if (pathArr[0] === "label") newPathArr[0] = "edgeLabel";
                    else if (pathArr[1] === "label") newPathArr[1] = "edgeLabel";
                    return newPathArr;
                }
                return pathArr;
            }
        }
    };
    ChordSeriesModel.prototype.getGraph = function() {
        return this.getData().graph;
    };
    ChordSeriesModel.prototype.getEdgeData = function() {
        return this.getGraph().edgeData;
    };
    ChordSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var params = this.getDataParams(dataIndex, dataType);
        if (dataType === "edge") {
            var nodeData = this.getData();
            var edge = nodeData.graph.getEdgeByIndex(dataIndex);
            var sourceName = nodeData.getName(edge.node1.dataIndex);
            var targetName = nodeData.getName(edge.node2.dataIndex);
            var nameArr = [];
            sourceName != null && nameArr.push(sourceName);
            targetName != null && nameArr.push(targetName);
            return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
                name: nameArr.join(" > "),
                value: params.value,
                noValue: params.value == null
            });
        }
        // dataType === 'node' or empty
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
            name: params.name,
            value: params.value,
            noValue: params.value == null
        });
    };
    ChordSeriesModel.prototype.getDataParams = function(dataIndex, dataType) {
        var params = _super.prototype.getDataParams.call(this, dataIndex, dataType);
        if (dataType === "node") {
            var nodeData = this.getData();
            var node = this.getGraph().getNodeByIndex(dataIndex);
            // Set name if not already set
            if (params.name == null) params.name = nodeData.getName(dataIndex);
            // Set value if not already set
            if (params.value == null) {
                var nodeValue = node.getLayout().value;
                params.value = nodeValue;
            }
        }
        return params;
    };
    ChordSeriesModel.type = "series.chord";
    ChordSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: "none",
        legendHoverLink: true,
        colorBy: "data",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        width: null,
        height: null,
        center: [
            "50%",
            "50%"
        ],
        radius: [
            "70%",
            "80%"
        ],
        clockwise: true,
        startAngle: 90,
        endAngle: "auto",
        minAngle: 0,
        padAngle: 3,
        itemStyle: {
            borderRadius: [
                0,
                0,
                5,
                5
            ]
        },
        lineStyle: {
            width: 0,
            color: "source",
            opacity: 0.2
        },
        label: {
            show: true,
            position: "outside",
            distance: 5
        },
        emphasis: {
            focus: "adjacency",
            lineStyle: {
                opacity: 0.5
            }
        }
    };
    return ChordSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $4d5b20ba15d193e5$export$2e2bcd8739ae039 = $4d5b20ba15d193e5$var$ChordSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $2d8fac74e61adff4$var$RADIAN = Math.PI / 180;
function $2d8fac74e61adff4$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType("chord", function(seriesModel) {
        $2d8fac74e61adff4$var$chordLayout(seriesModel, api);
    });
}
function $2d8fac74e61adff4$var$chordLayout(seriesModel, api) {
    var nodeData = seriesModel.getData();
    var nodeGraph = nodeData.graph;
    var edgeData = seriesModel.getEdgeData();
    var edgeCount = edgeData.count();
    if (!edgeCount) return;
    var _a = (0, $93b9bc7f22ac7369$export$3101c00baac0ee1f)(seriesModel, api), cx = _a.cx, cy = _a.cy, r = _a.r, r0 = _a.r0;
    var padAngle = Math.max((seriesModel.get("padAngle") || 0) * $2d8fac74e61adff4$var$RADIAN, 0);
    var minAngle = Math.max((seriesModel.get("minAngle") || 0) * $2d8fac74e61adff4$var$RADIAN, 0);
    var startAngle = -seriesModel.get("startAngle") * $2d8fac74e61adff4$var$RADIAN;
    var endAngle = startAngle + Math.PI * 2;
    var clockwise = seriesModel.get("clockwise");
    var dir = clockwise ? 1 : -1;
    // Normalize angles
    var angles = [
        startAngle,
        endAngle
    ];
    (0, $20ebe2448f123f2e$export$bc668021e937022a)(angles, !clockwise);
    var normalizedStartAngle = angles[0], normalizedEndAngle = angles[1];
    var totalAngle = normalizedEndAngle - normalizedStartAngle;
    var allZero = nodeData.getSum("value") === 0 && edgeData.getSum("value") === 0;
    // Sum of each node's edge values
    var nodeValues = [];
    var renderedNodeCount = 0;
    nodeGraph.eachEdge(function(edge) {
        // All links use the same value 1 when allZero is true
        var value = allZero ? 1 : edge.getValue("value");
        if (allZero && (value > 0 || minAngle)) // When allZero is true, angle is in direct proportion to number
        // of links both in and out of the node.
        renderedNodeCount += 2;
        var node1Index = edge.node1.dataIndex;
        var node2Index = edge.node2.dataIndex;
        nodeValues[node1Index] = (nodeValues[node1Index] || 0) + value;
        nodeValues[node2Index] = (nodeValues[node2Index] || 0) + value;
    });
    // Update nodeValues with data.value if exists
    var nodeValueSum = 0;
    nodeGraph.eachNode(function(node) {
        var dataValue = node.getValue("value");
        if (!isNaN(dataValue)) nodeValues[node.dataIndex] = Math.max(dataValue, nodeValues[node.dataIndex] || 0);
        if (!allZero && (nodeValues[node.dataIndex] > 0 || minAngle)) // When allZero is false, angle is in direct proportion to node's
        // value
        renderedNodeCount++;
        nodeValueSum += nodeValues[node.dataIndex] || 0;
    });
    if (renderedNodeCount === 0 || nodeValueSum === 0) return;
    if (padAngle * renderedNodeCount >= Math.abs(totalAngle)) // Not enough angle to render the pad, minAngle has higher priority, and padAngle takes the rest
    padAngle = Math.max(0, (Math.abs(totalAngle) - minAngle * renderedNodeCount) / renderedNodeCount);
    if ((padAngle + minAngle) * renderedNodeCount >= Math.abs(totalAngle)) // Not enough angle to render the minAngle, so ignore the minAngle
    minAngle = (Math.abs(totalAngle) - padAngle * renderedNodeCount) / renderedNodeCount;
    var unitAngle = (totalAngle - padAngle * renderedNodeCount * dir) / nodeValueSum;
    var totalDeficit = 0; // sum of deficits of nodes with span < minAngle
    var totalSurplus = 0; // sum of (spans - minAngle) of nodes with span > minAngle
    var totalSurplusSpan = 0; // sum of spans of nodes with span > minAngle
    var minSurplus = Infinity; // min of (spans - minAngle) of nodes with span > minAngle
    nodeGraph.eachNode(function(node) {
        var value = nodeValues[node.dataIndex] || 0;
        var spanAngle = unitAngle * (nodeValueSum ? value : 1) * dir;
        if (Math.abs(spanAngle) < minAngle) totalDeficit += minAngle - Math.abs(spanAngle);
        else {
            minSurplus = Math.min(minSurplus, Math.abs(spanAngle) - minAngle);
            totalSurplus += Math.abs(spanAngle) - minAngle;
            totalSurplusSpan += Math.abs(spanAngle);
        }
        node.setLayout({
            angle: spanAngle,
            value: value
        });
    });
    var surplusAsMuchAsPossible = false;
    if (totalDeficit > totalSurplus) {
        // Not enough angle to spread the nodes, scale all
        var scale_1 = totalDeficit / totalSurplus;
        nodeGraph.eachNode(function(node) {
            var spanAngle = node.getLayout().angle;
            if (Math.abs(spanAngle) >= minAngle) node.setLayout({
                angle: spanAngle * scale_1,
                ratio: scale_1
            }, true);
            else node.setLayout({
                angle: minAngle,
                ratio: minAngle === 0 ? 1 : spanAngle / minAngle
            }, true);
        });
    } else // For example, if totalDeficit is 60 degrees and totalSurplus is 70
    // degrees but one of the sector can only reduced by 1 degree,
    // if we decrease it with the ratio of value to other surplused nodes,
    // it will have smaller angle than minAngle itself.
    // So we need to borrow some angle from other nodes.
    nodeGraph.eachNode(function(node) {
        if (surplusAsMuchAsPossible) return;
        var spanAngle = node.getLayout().angle;
        var borrowRatio = Math.min(spanAngle / totalSurplusSpan, 1);
        var borrowAngle = borrowRatio * totalDeficit;
        if (spanAngle - borrowAngle < minAngle) // It will have less than minAngle after borrowing
        surplusAsMuchAsPossible = true;
    });
    var restDeficit = totalDeficit;
    nodeGraph.eachNode(function(node) {
        if (restDeficit <= 0) return;
        var spanAngle = node.getLayout().angle;
        if (spanAngle > minAngle && minAngle > 0) {
            var borrowRatio = surplusAsMuchAsPossible ? 1 : Math.min(spanAngle / totalSurplusSpan, 1);
            var maxBorrowAngle = spanAngle - minAngle;
            var borrowAngle = Math.min(maxBorrowAngle, Math.min(restDeficit, totalDeficit * borrowRatio));
            restDeficit -= borrowAngle;
            node.setLayout({
                angle: spanAngle - borrowAngle,
                ratio: (spanAngle - borrowAngle) / spanAngle
            }, true);
        } else if (minAngle > 0) node.setLayout({
            angle: minAngle,
            ratio: spanAngle === 0 ? 1 : minAngle / spanAngle
        }, true);
    });
    var angle = normalizedStartAngle;
    var edgeAccAngle = [];
    nodeGraph.eachNode(function(node) {
        var spanAngle = Math.max(node.getLayout().angle, minAngle);
        node.setLayout({
            cx: cx,
            cy: cy,
            r0: r0,
            r: r,
            startAngle: angle,
            endAngle: angle + spanAngle * dir,
            clockwise: clockwise
        }, true);
        edgeAccAngle[node.dataIndex] = angle;
        angle += (spanAngle + padAngle) * dir;
    });
    nodeGraph.eachEdge(function(edge) {
        var value = allZero ? 1 : edge.getValue("value");
        var spanAngle = unitAngle * (nodeValueSum ? value : 1) * dir;
        var node1Index = edge.node1.dataIndex;
        var sStartAngle = edgeAccAngle[node1Index] || 0;
        var sSpan = Math.abs((edge.node1.getLayout().ratio || 1) * spanAngle);
        var sEndAngle = sStartAngle + sSpan * dir;
        var s1 = [
            cx + r0 * Math.cos(sStartAngle),
            cy + r0 * Math.sin(sStartAngle)
        ];
        var s2 = [
            cx + r0 * Math.cos(sEndAngle),
            cy + r0 * Math.sin(sEndAngle)
        ];
        var node2Index = edge.node2.dataIndex;
        var tStartAngle = edgeAccAngle[node2Index] || 0;
        var tSpan = Math.abs((edge.node2.getLayout().ratio || 1) * spanAngle);
        var tEndAngle = tStartAngle + tSpan * dir;
        var t1 = [
            cx + r0 * Math.cos(tStartAngle),
            cy + r0 * Math.sin(tStartAngle)
        ];
        var t2 = [
            cx + r0 * Math.cos(tEndAngle),
            cy + r0 * Math.sin(tEndAngle)
        ];
        edge.setLayout({
            s1: s1,
            s2: s2,
            sStartAngle: sStartAngle,
            sEndAngle: sEndAngle,
            t1: t1,
            t2: t2,
            tStartAngle: tStartAngle,
            tEndAngle: tEndAngle,
            cx: cx,
            cy: cy,
            r: r0,
            value: value,
            clockwise: clockwise
        });
        edgeAccAngle[node1Index] = sEndAngle;
        edgeAccAngle[node2Index] = tEndAngle;
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $e11a533bf70b759c$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        reset: function(seriesModel, ecModel) {
            var legendModels = ecModel.findComponents({
                mainType: "legend"
            });
            if (!legendModels || !legendModels.length) return;
            var data = seriesModel.getData();
            data.filterSelf(function(idx) {
                var name = data.getName(idx);
                // If in any legend component the status is not selected.
                for(var i = 0; i < legendModels.length; i++){
                    // @ts-ignore FIXME: LegendModel
                    if (!legendModels[i].isSelected(name)) return false;
                }
                return true;
            });
        }
    };
}


function $1c1924ac8c8efc9c$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $dc6cb5840da6548b$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $4d5b20ba15d193e5$export$2e2bcd8739ae039));
    registers.registerLayout(registers.PRIORITY.VISUAL.POST_CHART_LAYOUT, (0, $2d8fac74e61adff4$export$2e2bcd8739ae039));
    // Add data filter processor
    registers.registerProcessor((0, $e11a533bf70b759c$export$2e2bcd8739ae039)("chord"));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $fef28dd8967d3f1b$export$84369c8e2229fa7f = {
    color: "fill",
    borderColor: "stroke"
};
var $fef28dd8967d3f1b$export$734d775a14929701 = {
    symbol: 1,
    symbolSize: 1,
    symbolKeepAspect: 1,
    legendIcon: 1,
    visualMeta: 1,
    liftZ: 1,
    decal: 1
};
var $fef28dd8967d3f1b$export$dd5c3cc86073562f = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $fef28dd8967d3f1b$var$CustomSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CustomSeriesModel, _super);
    function CustomSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CustomSeriesModel.type;
        return _this;
    }
    CustomSeriesModel.prototype.optionUpdated = function() {
        this.currentZLevel = this.get("zlevel", true);
        this.currentZ = this.get("z", true);
    };
    CustomSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this);
    };
    CustomSeriesModel.prototype.getDataParams = function(dataIndex, dataType, el) {
        var params = _super.prototype.getDataParams.call(this, dataIndex, dataType);
        el && (params.info = $fef28dd8967d3f1b$export$dd5c3cc86073562f(el).info);
        return params;
    };
    CustomSeriesModel.type = "series.custom";
    CustomSeriesModel.dependencies = [
        "grid",
        "polar",
        "geo",
        "singleAxis",
        "calendar",
        "matrix"
    ];
    CustomSeriesModel.defaultOption = {
        coordinateSystem: "cartesian2d",
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        // Custom series will not clip by default.
        // Some case will use custom series to draw label
        // For example https://echarts.apache.org/examples/en/editor.html?c=custom-gantt-flight
        clip: false
    };
    return CustomSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $fef28dd8967d3f1b$export$2e2bcd8739ae039 = $fef28dd8967d3f1b$var$CustomSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $eb5b87553d7c5e15$var$dataToCoordSize(dataSize, dataItem) {
    // dataItem is necessary in log axis.
    dataItem = dataItem || [
        0,
        0
    ];
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88([
        "x",
        "y"
    ], function(dim, dimIdx) {
        var axis = this.getAxis(dim);
        var val = dataItem[dimIdx];
        var halfSize = dataSize[dimIdx] / 2;
        return axis.type === "category" ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
    }, this);
}
function $eb5b87553d7c5e15$export$2e2bcd8739ae039(coordSys) {
    var rect = coordSys.master.getRect();
    return {
        coordSys: {
            // The name exposed to user is always 'cartesian2d' but not 'grid'.
            type: "cartesian2d",
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        api: {
            coord: function(data) {
                // do not provide "out" param
                return coordSys.dataToPoint(data);
            },
            size: $7a1bd9c2710fea0d$export$2385a24977818dd0($eb5b87553d7c5e15$var$dataToCoordSize, coordSys)
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $db94904ae7a63a7b$var$dataToCoordSize(dataSize, dataItem) {
    dataItem = dataItem || [
        0,
        0
    ];
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88([
        0,
        1
    ], function(dimIdx) {
        var val = dataItem[dimIdx];
        var halfSize = dataSize[dimIdx] / 2;
        var p1 = [];
        var p2 = [];
        p1[dimIdx] = val - halfSize;
        p2[dimIdx] = val + halfSize;
        p1[1 - dimIdx] = p2[1 - dimIdx] = dataItem[1 - dimIdx];
        return Math.abs(this.dataToPoint(p1)[dimIdx] - this.dataToPoint(p2)[dimIdx]);
    }, this);
}
function $db94904ae7a63a7b$export$2e2bcd8739ae039(coordSys) {
    var rect = coordSys.getBoundingRect();
    return {
        coordSys: {
            type: "geo",
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height,
            zoom: coordSys.getZoom()
        },
        api: {
            coord: function(data) {
                // do not provide "out" and noRoam param,
                // Compatible with this usage:
                // echarts.util.map(item.points, api.coord)
                return coordSys.dataToPoint(data);
            },
            size: $7a1bd9c2710fea0d$export$2385a24977818dd0($db94904ae7a63a7b$var$dataToCoordSize, coordSys)
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $4af7f8b40c63338e$var$dataToCoordSize(dataSize, dataItem) {
    // dataItem is necessary in log axis.
    var axis = this.getAxis();
    var val = dataItem instanceof Array ? dataItem[0] : dataItem;
    var halfSize = (dataSize instanceof Array ? dataSize[0] : dataSize) / 2;
    return axis.type === "category" ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
}
function $4af7f8b40c63338e$export$2e2bcd8739ae039(coordSys) {
    var rect = coordSys.getRect();
    return {
        coordSys: {
            type: "singleAxis",
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        api: {
            coord: function(val) {
                // do not provide "out" param
                return coordSys.dataToPoint(val);
            },
            size: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($4af7f8b40c63338e$var$dataToCoordSize, coordSys)
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
// import AngleAxis from './AngleAxis.js';
function $5542da7477183ee1$var$dataToCoordSize(dataSize, dataItem) {
    // dataItem is necessary in log axis.
    dataItem = dataItem || [
        0,
        0
    ];
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88([
        "Radius",
        "Angle"
    ], function(dim, dimIdx) {
        var getterName = "get" + dim + "Axis";
        // TODO: TYPE Check Angle Axis
        var axis = this[getterName]();
        var val = dataItem[dimIdx];
        var halfSize = dataSize[dimIdx] / 2;
        var result = axis.type === "category" ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
        if (dim === "Angle") result = result * Math.PI / 180;
        return result;
    }, this);
}
function $5542da7477183ee1$export$2e2bcd8739ae039(coordSys) {
    var radiusAxis = coordSys.getRadiusAxis();
    var angleAxis = coordSys.getAngleAxis();
    var radius = radiusAxis.getExtent();
    radius[0] > radius[1] && radius.reverse();
    return {
        coordSys: {
            type: "polar",
            cx: coordSys.cx,
            cy: coordSys.cy,
            r: radius[1],
            r0: radius[0]
        },
        api: {
            coord: function(data) {
                var radius = radiusAxis.dataToRadius(data[0]);
                var angle = angleAxis.dataToAngle(data[1]);
                var coord = coordSys.coordToPoint([
                    radius,
                    angle
                ]);
                coord.push(radius, angle * Math.PI / 180);
                return coord;
            },
            size: $7a1bd9c2710fea0d$export$2385a24977818dd0($5542da7477183ee1$var$dataToCoordSize, coordSys)
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $07a38220d20058fb$export$2e2bcd8739ae039(coordSys) {
    var rect = coordSys.getRect();
    var rangeInfo = coordSys.getRangeInfo();
    return {
        coordSys: {
            type: "calendar",
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height,
            cellWidth: coordSys.getCellWidth(),
            cellHeight: coordSys.getCellHeight(),
            rangeInfo: {
                start: rangeInfo.start,
                end: rangeInfo.end,
                weeks: rangeInfo.weeks,
                dayCount: rangeInfo.allDay
            }
        },
        api: {
            coord: function(data, clamp) {
                return coordSys.dataToPoint(data, clamp);
            },
            layout: function(data, clamp) {
                return coordSys.dataToLayout(data, clamp);
            }
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $05e7f6a59f17536e$export$2e2bcd8739ae039(coordSys) {
    var rect = coordSys.getRect();
    return {
        coordSys: {
            type: "matrix",
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        api: {
            coord: function(data, opt) {
                return coordSys.dataToPoint(data, opt);
            },
            layout: function(data, opt) {
                return coordSys.dataToLayout(data, opt);
            }
        }
    };
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $daa53642c3afcc30$var$deprecatedLogs = {};
function $daa53642c3afcc30$export$3b868abde5eae7d1(style, elType, hasOwnTextContentOption, hasOwnTextConfig) {
    // Since echarts5, `RectText` is separated from its host element and style.text
    // does not exist any more. The compat work brings some extra burden on performance.
    // So we provide:
    // `legacy: true` force make compat.
    // `legacy: false`, force do not compat.
    // `legacy` not set: auto detect whether legacy.
    //     But in this case we do not compat (difficult to detect and rare case):
    //     Because custom series and graphic component support "merge", users may firstly
    //     only set `textStrokeWidth` style or secondly only set `text`.
    return style && (style.legacy || style.legacy !== false && !hasOwnTextContentOption && !hasOwnTextConfig && elType !== "tspan" && (elType === "text" || (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(style, "text")));
}
function $daa53642c3afcc30$export$7748133eaaa8aecc(hostStyle, elType, isNormal) {
    var srcStyle = hostStyle;
    var textConfig;
    var textContent;
    var textContentStyle;
    if (elType === "text") textContentStyle = srcStyle;
    else {
        textContentStyle = {};
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "text") && (textContentStyle.text = srcStyle.text);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "rich") && (textContentStyle.rich = srcStyle.rich);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "textFill") && (textContentStyle.fill = srcStyle.textFill);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "textStroke") && (textContentStyle.stroke = srcStyle.textStroke);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "fontFamily") && (textContentStyle.fontFamily = srcStyle.fontFamily);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "fontSize") && (textContentStyle.fontSize = srcStyle.fontSize);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "fontStyle") && (textContentStyle.fontStyle = srcStyle.fontStyle);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "fontWeight") && (textContentStyle.fontWeight = srcStyle.fontWeight);
        textContent = {
            type: "text",
            style: textContentStyle,
            // ec4 does not support rectText trigger.
            // And when text position is different in normal and emphasis
            // => hover text trigger emphasis;
            // => text position changed, leave mouse pointer immediately;
            // That might cause incorrect state.
            silent: true
        };
        textConfig = {};
        var hasOwnPos = (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "textPosition");
        if (isNormal) textConfig.position = hasOwnPos ? srcStyle.textPosition : "inside";
        else hasOwnPos && (textConfig.position = srcStyle.textPosition);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "textPosition") && (textConfig.position = srcStyle.textPosition);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "textOffset") && (textConfig.offset = srcStyle.textOffset);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "textRotation") && (textConfig.rotation = srcStyle.textRotation);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "textDistance") && (textConfig.distance = srcStyle.textDistance);
    }
    $daa53642c3afcc30$var$convertEC4CompatibleRichItem(textContentStyle, hostStyle);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(textContentStyle.rich, function(richItem) {
        $daa53642c3afcc30$var$convertEC4CompatibleRichItem(richItem, richItem);
    });
    return {
        textConfig: textConfig,
        textContent: textContent
    };
}
/**
 * The result will be set to `out`.
 */ function $daa53642c3afcc30$var$convertEC4CompatibleRichItem(out, richItem) {
    if (!richItem) return;
    // (1) For simplicity, make textXXX properties (deprecated since ec5) has
    // higher priority. For example, consider in ec4 `borderColor: 5, textBorderColor: 10`
    // on a rect means `borderColor: 4` on the rect and `borderColor: 10` on an attached
    // richText in ec5.
    // (2) `out === richItem` if and only if `out` is text el or rich item.
    // So we can overwrite existing props in `out` since textXXX has higher priority.
    richItem.font = richItem.textFont || richItem.font;
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textStrokeWidth") && (out.lineWidth = richItem.textStrokeWidth);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textAlign") && (out.align = richItem.textAlign);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textVerticalAlign") && (out.verticalAlign = richItem.textVerticalAlign);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textLineHeight") && (out.lineHeight = richItem.textLineHeight);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textWidth") && (out.width = richItem.textWidth);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textHeight") && (out.height = richItem.textHeight);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textBackgroundColor") && (out.backgroundColor = richItem.textBackgroundColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textPadding") && (out.padding = richItem.textPadding);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textBorderColor") && (out.borderColor = richItem.textBorderColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textBorderWidth") && (out.borderWidth = richItem.textBorderWidth);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textBorderRadius") && (out.borderRadius = richItem.textBorderRadius);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textBoxShadowColor") && (out.shadowColor = richItem.textBoxShadowColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textBoxShadowBlur") && (out.shadowBlur = richItem.textBoxShadowBlur);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textBoxShadowOffsetX") && (out.shadowOffsetX = richItem.textBoxShadowOffsetX);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textBoxShadowOffsetY") && (out.shadowOffsetY = richItem.textBoxShadowOffsetY);
}
function $daa53642c3afcc30$export$b8ddb75bd1b9b791(itemStl, txStl, txCfg) {
    var out = itemStl;
    // See `custom.ts`, a trick to set extra `textPosition` firstly.
    out.textPosition = out.textPosition || txCfg.position || "inside";
    txCfg.offset != null && (out.textOffset = txCfg.offset);
    txCfg.rotation != null && (out.textRotation = txCfg.rotation);
    txCfg.distance != null && (out.textDistance = txCfg.distance);
    var isInside = out.textPosition.indexOf("inside") >= 0;
    var hostFill = itemStl.fill || (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral99;
    $daa53642c3afcc30$var$convertToEC4RichItem(out, txStl);
    var textFillNotSet = out.textFill == null;
    if (isInside) {
        if (textFillNotSet) {
            out.textFill = txCfg.insideFill || (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral00;
            !out.textStroke && txCfg.insideStroke && (out.textStroke = txCfg.insideStroke);
            !out.textStroke && (out.textStroke = hostFill);
            out.textStrokeWidth == null && (out.textStrokeWidth = 2);
        }
    } else {
        if (textFillNotSet) out.textFill = itemStl.fill || txCfg.outsideFill || (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral00;
        !out.textStroke && txCfg.outsideStroke && (out.textStroke = txCfg.outsideStroke);
    }
    out.text = txStl.text;
    out.rich = txStl.rich;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(txStl.rich, function(richItem) {
        $daa53642c3afcc30$var$convertToEC4RichItem(richItem, richItem);
    });
    return out;
}
function $daa53642c3afcc30$var$convertToEC4RichItem(out, richItem) {
    if (!richItem) return;
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "fill") && (out.textFill = richItem.fill);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "stroke") && (out.textStroke = richItem.fill);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "lineWidth") && (out.textStrokeWidth = richItem.lineWidth);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "font") && (out.font = richItem.font);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "fontStyle") && (out.fontStyle = richItem.fontStyle);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "fontWeight") && (out.fontWeight = richItem.fontWeight);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "fontSize") && (out.fontSize = richItem.fontSize);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "fontFamily") && (out.fontFamily = richItem.fontFamily);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "align") && (out.textAlign = richItem.align);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "verticalAlign") && (out.textVerticalAlign = richItem.verticalAlign);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "lineHeight") && (out.textLineHeight = richItem.lineHeight);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "width") && (out.textWidth = richItem.width);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "height") && (out.textHeight = richItem.height);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "backgroundColor") && (out.textBackgroundColor = richItem.backgroundColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "padding") && (out.textPadding = richItem.padding);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "borderColor") && (out.textBorderColor = richItem.borderColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "borderWidth") && (out.textBorderWidth = richItem.borderWidth);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "borderRadius") && (out.textBorderRadius = richItem.borderRadius);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "shadowColor") && (out.textBoxShadowColor = richItem.shadowColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "shadowBlur") && (out.textBoxShadowBlur = richItem.shadowBlur);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "shadowOffsetX") && (out.textBoxShadowOffsetX = richItem.shadowOffsetX);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "shadowOffsetY") && (out.textBoxShadowOffsetY = richItem.shadowOffsetY);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textShadowColor") && (out.textShadowColor = richItem.textShadowColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textShadowBlur") && (out.textShadowBlur = richItem.textShadowBlur);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textShadowOffsetX") && (out.textShadowOffsetX = richItem.textShadowOffsetX);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textShadowOffsetY") && (out.textShadowOffsetY = richItem.textShadowOffsetY);
}
function $daa53642c3afcc30$export$606a5c06d13e04b6(deprecated, insteadApproach) {
    var key;
}





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $7c104376a000308e$var$LEGACY_TRANSFORM_PROPS_MAP = {
    position: [
        "x",
        "y"
    ],
    scale: [
        "scaleX",
        "scaleY"
    ],
    origin: [
        "originX",
        "originY"
    ]
};
var $7c104376a000308e$var$LEGACY_TRANSFORM_PROPS = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)($7c104376a000308e$var$LEGACY_TRANSFORM_PROPS_MAP);
var $7c104376a000308e$var$TRANSFORM_PROPS_MAP = (0, $7a1bd9c2710fea0d$export$533b26079ad0b4b)((0, $becf2d727f9cf450$export$98ab6203ec3396e2), function(obj, key) {
    obj[key] = 1;
    return obj;
}, {});
var $7c104376a000308e$var$transformPropNamesStr = (0, $becf2d727f9cf450$export$98ab6203ec3396e2).join(", ");
var $7c104376a000308e$export$9a911ad86e905b13 = [
    "",
    "style",
    "shape",
    "extra"
];
var $7c104376a000308e$var$transitionInnerStore = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $7c104376a000308e$var$getElementAnimationConfig(animationType, el, elOption, parentModel, dataIndex) {
    var animationProp = animationType + "Animation";
    var config = (0, $8b353638fbedfefa$export$5cc7add7ab591d0a)(animationType, parentModel, dataIndex) || {};
    var userDuring = $7c104376a000308e$var$transitionInnerStore(el).userDuring;
    // Only set when duration is > 0 and it's need to be animated.
    if (config.duration > 0) {
        // For simplicity, if during not specified, the previous during will not work any more.
        config.during = userDuring ? (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($7c104376a000308e$var$duringCall, {
            el: el,
            userDuring: userDuring
        }) : null;
        config.setToFinal = true;
        config.scope = animationType;
    }
    (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(config, elOption[animationProp]);
    return config;
}
function $7c104376a000308e$export$4342b281b9b5d77e(el, elOption, animatableModel, opts) {
    opts = opts || {};
    var dataIndex = opts.dataIndex, isInit = opts.isInit, clearStyle = opts.clearStyle;
    var hasAnimation = animatableModel.isAnimationEnabled();
    // Save the meta info for further morphing. Like apply on the sub morphing elements.
    var store = $7c104376a000308e$var$transitionInnerStore(el);
    var styleOpt = elOption.style;
    store.userDuring = elOption.during;
    var transFromProps = {};
    var propsToSet = {};
    $7c104376a000308e$var$prepareTransformAllPropsFinal(el, elOption, propsToSet);
    if (el.type === "compound") {
        /**
     * We cannot directly clone shape for compoundPath,
     * because it makes the path to be an object instead of a Path instance,
     * and thus missing `buildPath` method.
     */ var paths = el.shape.paths;
        var optionPaths = elOption.shape.paths;
        for(var i = 0; i < optionPaths.length; i++){
            var path = optionPaths[i];
            $7c104376a000308e$var$prepareShapeOrExtraAllPropsFinal("shape", path, paths[i]);
        }
    } else {
        $7c104376a000308e$var$prepareShapeOrExtraAllPropsFinal("shape", elOption, propsToSet);
        $7c104376a000308e$var$prepareShapeOrExtraAllPropsFinal("extra", elOption, propsToSet);
    }
    if (!isInit && hasAnimation) {
        $7c104376a000308e$var$prepareTransformTransitionFrom(el, elOption, transFromProps);
        $7c104376a000308e$var$prepareShapeOrExtraTransitionFrom("shape", el, elOption, transFromProps);
        $7c104376a000308e$var$prepareShapeOrExtraTransitionFrom("extra", el, elOption, transFromProps);
        $7c104376a000308e$var$prepareStyleTransitionFrom(el, elOption, styleOpt, transFromProps);
    }
    propsToSet.style = styleOpt;
    $7c104376a000308e$var$applyPropsDirectly(el, propsToSet, clearStyle);
    $7c104376a000308e$var$applyMiscProps(el, elOption);
    if (hasAnimation) {
        if (isInit) {
            var enterFromProps_1 = {};
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($7c104376a000308e$export$9a911ad86e905b13, function(propName) {
                var prop = propName ? elOption[propName] : elOption;
                if (prop && prop.enterFrom) {
                    if (propName) enterFromProps_1[propName] = enterFromProps_1[propName] || {};
                    (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(propName ? enterFromProps_1[propName] : enterFromProps_1, prop.enterFrom);
                }
            });
            var config = $7c104376a000308e$var$getElementAnimationConfig("enter", el, elOption, animatableModel, dataIndex);
            if (config.duration > 0) el.animateFrom(enterFromProps_1, config);
        } else $7c104376a000308e$var$applyPropsTransition(el, elOption, dataIndex || 0, animatableModel, transFromProps);
    }
    // Store leave to be used in leave transition.
    $7c104376a000308e$export$a6f11bb1cb100e2a(el, elOption);
    styleOpt ? el.dirty() : el.markRedraw();
}
function $7c104376a000308e$export$a6f11bb1cb100e2a(el, elOption) {
    // Try merge to previous set leaveTo
    var leaveToProps = $7c104376a000308e$var$transitionInnerStore(el).leaveToProps;
    for(var i = 0; i < $7c104376a000308e$export$9a911ad86e905b13.length; i++){
        var propName = $7c104376a000308e$export$9a911ad86e905b13[i];
        var prop = propName ? elOption[propName] : elOption;
        if (prop && prop.leaveTo) {
            if (!leaveToProps) leaveToProps = $7c104376a000308e$var$transitionInnerStore(el).leaveToProps = {};
            if (propName) leaveToProps[propName] = leaveToProps[propName] || {};
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(propName ? leaveToProps[propName] : leaveToProps, prop.leaveTo);
        }
    }
}
function $7c104376a000308e$export$15575b6d82d35bb3(el, elOption, animatableModel, onRemove) {
    if (el) {
        var parent_1 = el.parent;
        var leaveToProps = $7c104376a000308e$var$transitionInnerStore(el).leaveToProps;
        if (leaveToProps) {
            // TODO TODO use leave after leaveAnimation in series is introduced
            // TODO Data index?
            var config = $7c104376a000308e$var$getElementAnimationConfig("update", el, elOption, animatableModel, 0);
            config.done = function() {
                parent_1 && parent_1.remove(el);
                onRemove && onRemove();
            };
            el.animateTo(leaveToProps, config);
        } else {
            parent_1 && parent_1.remove(el);
            onRemove && onRemove();
        }
    }
}
function $7c104376a000308e$export$6f3361b4b8d7a8ba(transition) {
    return transition === "all";
}
function $7c104376a000308e$var$applyPropsDirectly(el, // Can be null/undefined
allPropsFinal, clearStyle) {
    var styleOpt = allPropsFinal.style;
    if (!el.isGroup && styleOpt) {
        if (clearStyle) {
            el.useStyle({});
            // When style object changed, how to trade the existing animation?
            // It is probably complicated and not needed to cover all the cases.
            // But still need consider the case:
            // (1) When using init animation on `style.opacity`, and before the animation
            //     ended users triggers an update by mousewhel. At that time the init
            //     animation should better be continued rather than terminated.
            //     So after `useStyle` called, we should change the animation target manually
            //     to continue the effect of the init animation.
            // (2) PENDING: If the previous animation targeted at a `val1`, and currently we need
            //     to update the value to `val2` and no animation declared, should be terminate
            //     the previous animation or just modify the target of the animation?
            //     Therotically That will happen not only on `style` but also on `shape` and
            //     `transfrom` props. But we haven't handle this case at present yet.
            // (3) PENDING: Is it proper to visit `animators` and `targetName`?
            var animators = el.animators;
            for(var i = 0; i < animators.length; i++){
                var animator = animators[i];
                // targetName is the "topKey".
                if (animator.targetName === "style") animator.changeTarget(el.style);
            }
        }
        el.setStyle(styleOpt);
    }
    if (allPropsFinal) {
        // Not set style here.
        allPropsFinal.style = null;
        // Set el to the final state firstly.
        allPropsFinal && el.attr(allPropsFinal);
        allPropsFinal.style = styleOpt;
    }
}
function $7c104376a000308e$var$applyPropsTransition(el, elOption, dataIndex, model, // Can be null/undefined
transFromProps) {
    if (transFromProps) {
        var config = $7c104376a000308e$var$getElementAnimationConfig("update", el, elOption, model, dataIndex);
        if (config.duration > 0) el.animateFrom(transFromProps, config);
    }
}
function $7c104376a000308e$var$applyMiscProps(el, elOption) {
    // Merge by default.
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(elOption, "silent") && (el.silent = elOption.silent);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(elOption, "ignore") && (el.ignore = elOption.ignore);
    if (el instanceof (0, $56206a6cb4666931$export$2e2bcd8739ae039)) (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(elOption, "invisible") && (el.invisible = elOption.invisible);
    if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(elOption, "autoBatch") && (el.autoBatch = elOption.autoBatch);
}
// Use it to avoid it be exposed to user.
var $7c104376a000308e$var$tmpDuringScope = {};
var $7c104376a000308e$var$transitionDuringAPI = {
    // Usually other props do not need to be changed in animation during.
    setTransform: function(key, val) {
        $7c104376a000308e$var$tmpDuringScope.el[key] = val;
        return this;
    },
    getTransform: function(key) {
        return $7c104376a000308e$var$tmpDuringScope.el[key];
    },
    setShape: function(key, val) {
        var el = $7c104376a000308e$var$tmpDuringScope.el;
        var shape = el.shape || (el.shape = {});
        shape[key] = val;
        el.dirtyShape && el.dirtyShape();
        return this;
    },
    getShape: function(key) {
        var shape = $7c104376a000308e$var$tmpDuringScope.el.shape;
        if (shape) return shape[key];
    },
    setStyle: function(key, val) {
        var el = $7c104376a000308e$var$tmpDuringScope.el;
        var style = el.style;
        if (style) {
            style[key] = val;
            el.dirtyStyle && el.dirtyStyle();
        }
        return this;
    },
    getStyle: function(key) {
        var style = $7c104376a000308e$var$tmpDuringScope.el.style;
        if (style) return style[key];
    },
    setExtra: function(key, val) {
        var extra = $7c104376a000308e$var$tmpDuringScope.el.extra || ($7c104376a000308e$var$tmpDuringScope.el.extra = {});
        extra[key] = val;
        return this;
    },
    getExtra: function(key) {
        var extra = $7c104376a000308e$var$tmpDuringScope.el.extra;
        if (extra) return extra[key];
    }
};
function $7c104376a000308e$var$assertNotReserved(key) {}
function $7c104376a000308e$var$duringCall() {
    // Do not provide "percent" until some requirements come.
    // Because consider thies case:
    // enterFrom: {x: 100, y: 30}, transition: 'x'.
    // And enter duration is different from update duration.
    // Thus it might be confused about the meaning of "percent" in during callback.
    var scope = this;
    var el = scope.el;
    if (!el) return;
    // If el is remove from zr by reason like legend, during still need to called,
    // because el will be added back to zr and the prop value should not be incorrect.
    var latestUserDuring = $7c104376a000308e$var$transitionInnerStore(el).userDuring;
    var scopeUserDuring = scope.userDuring;
    // Ensured a during is only called once in each animation frame.
    // If a during is called multiple times in one frame, maybe some users' calculation logic
    // might be wrong (not sure whether this usage exists).
    // The case of a during might be called twice can be: by default there is a animator for
    // 'x', 'y' when init. Before the init animation finished, call `setOption` to start
    // another animators for 'style'/'shape'/'extra'.
    if (latestUserDuring !== scopeUserDuring) {
        // release
        scope.el = scope.userDuring = null;
        return;
    }
    $7c104376a000308e$var$tmpDuringScope.el = el;
    // Give no `this` to user in "during" calling.
    scopeUserDuring($7c104376a000308e$var$transitionDuringAPI);
// FIXME: if in future meet the case that some prop will be both modified in `during` and `state`,
// consider the issue that the prop might be incorrect when return to "normal" state.
}
function $7c104376a000308e$var$prepareShapeOrExtraTransitionFrom(mainAttr, fromEl, elOption, transFromProps) {
    var attrOpt = elOption[mainAttr];
    if (!attrOpt) return;
    var elPropsInAttr = fromEl[mainAttr];
    var transFromPropsInAttr;
    if (elPropsInAttr) {
        var transition = elOption.transition;
        var attrTransition = attrOpt.transition;
        if (attrTransition) {
            !transFromPropsInAttr && (transFromPropsInAttr = transFromProps[mainAttr] = {});
            if ($7c104376a000308e$export$6f3361b4b8d7a8ba(attrTransition)) (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(transFromPropsInAttr, elPropsInAttr);
            else {
                var transitionKeys = (0, $76d619f648247e6d$export$4f07b212a02c8051)(attrTransition);
                for(var i = 0; i < transitionKeys.length; i++){
                    var key = transitionKeys[i];
                    var elVal = elPropsInAttr[key];
                    transFromPropsInAttr[key] = elVal;
                }
            }
        } else if ($7c104376a000308e$export$6f3361b4b8d7a8ba(transition) || (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(transition, mainAttr) >= 0) {
            !transFromPropsInAttr && (transFromPropsInAttr = transFromProps[mainAttr] = {});
            var elPropsInAttrKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(elPropsInAttr);
            for(var i = 0; i < elPropsInAttrKeys.length; i++){
                var key = elPropsInAttrKeys[i];
                var elVal = elPropsInAttr[key];
                if ($7c104376a000308e$var$isNonStyleTransitionEnabled(attrOpt[key], elVal)) transFromPropsInAttr[key] = elVal;
            }
        }
    }
}
function $7c104376a000308e$var$prepareShapeOrExtraAllPropsFinal(mainAttr, elOption, allProps) {
    var attrOpt = elOption[mainAttr];
    if (!attrOpt) return;
    var allPropsInAttr = allProps[mainAttr] = {};
    var keysInAttr = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(attrOpt);
    for(var i = 0; i < keysInAttr.length; i++){
        var key = keysInAttr[i];
        // To avoid share one object with different element, and
        // to avoid user modify the object inexpectedly, have to clone.
        allPropsInAttr[key] = (0, $76d8a142a20276fc$export$c5e92b7f105af84e)(attrOpt[key]);
    }
}
function $7c104376a000308e$var$prepareTransformTransitionFrom(el, elOption, transFromProps) {
    var transition = elOption.transition;
    var transitionKeys = $7c104376a000308e$export$6f3361b4b8d7a8ba(transition) ? (0, $becf2d727f9cf450$export$98ab6203ec3396e2) : (0, $76d619f648247e6d$export$4f07b212a02c8051)(transition || []);
    for(var i = 0; i < transitionKeys.length; i++){
        var key = transitionKeys[i];
        if (key === "style" || key === "shape" || key === "extra") continue;
        var elVal = el[key];
        // Do not clone, animator will perform that clone.
        transFromProps[key] = elVal;
    }
}
function $7c104376a000308e$var$prepareTransformAllPropsFinal(el, elOption, allProps) {
    for(var i = 0; i < $7c104376a000308e$var$LEGACY_TRANSFORM_PROPS.length; i++){
        var legacyName = $7c104376a000308e$var$LEGACY_TRANSFORM_PROPS[i];
        var xyName = $7c104376a000308e$var$LEGACY_TRANSFORM_PROPS_MAP[legacyName];
        var legacyArr = elOption[legacyName];
        if (legacyArr) {
            allProps[xyName[0]] = legacyArr[0];
            allProps[xyName[1]] = legacyArr[1];
        }
    }
    for(var i = 0; i < (0, $becf2d727f9cf450$export$98ab6203ec3396e2).length; i++){
        var key = (0, $becf2d727f9cf450$export$98ab6203ec3396e2)[i];
        if (elOption[key] != null) allProps[key] = elOption[key];
    }
}
function $7c104376a000308e$var$prepareStyleTransitionFrom(fromEl, elOption, styleOpt, transFromProps) {
    if (!styleOpt) return;
    var fromElStyle = fromEl.style;
    var transFromStyleProps;
    if (fromElStyle) {
        var styleTransition = styleOpt.transition;
        var elTransition = elOption.transition;
        if (styleTransition && !$7c104376a000308e$export$6f3361b4b8d7a8ba(styleTransition)) {
            var transitionKeys = (0, $76d619f648247e6d$export$4f07b212a02c8051)(styleTransition);
            !transFromStyleProps && (transFromStyleProps = transFromProps.style = {});
            for(var i = 0; i < transitionKeys.length; i++){
                var key = transitionKeys[i];
                var elVal = fromElStyle[key];
                // Do not clone, see `checkNonStyleTansitionRefer`.
                transFromStyleProps[key] = elVal;
            }
        } else if (fromEl.getAnimationStyleProps && ($7c104376a000308e$export$6f3361b4b8d7a8ba(elTransition) || $7c104376a000308e$export$6f3361b4b8d7a8ba(styleTransition) || (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(elTransition, "style") >= 0)) {
            var animationProps = fromEl.getAnimationStyleProps();
            var animationStyleProps = animationProps ? animationProps.style : null;
            if (animationStyleProps) {
                !transFromStyleProps && (transFromStyleProps = transFromProps.style = {});
                var styleKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(styleOpt);
                for(var i = 0; i < styleKeys.length; i++){
                    var key = styleKeys[i];
                    if (animationStyleProps[key]) {
                        var elVal = fromElStyle[key];
                        transFromStyleProps[key] = elVal;
                    }
                }
            }
        }
    }
}
function $7c104376a000308e$var$isNonStyleTransitionEnabled(optVal, elVal) {
    // The same as `checkNonStyleTansitionRefer`.
    return !(0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(optVal) ? optVal != null && isFinite(optVal) : optVal !== elVal;
}
var $7c104376a000308e$var$checkTransformPropRefer;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $ab8d73690f09fb6d$var$getStateToRestore = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $ab8d73690f09fb6d$var$KEYFRAME_EXCLUDE_KEYS = [
    "percent",
    "easing",
    "shape",
    "style",
    "extra"
];
function $ab8d73690f09fb6d$export$9e5c70edf1ec0cb4(el) {
    // Stop previous keyframe animation.
    el.stopAnimation("keyframe");
    // Restore
    el.attr($ab8d73690f09fb6d$var$getStateToRestore(el));
}
function $ab8d73690f09fb6d$export$b0aa6a5f01693fa4(el, animationOpts, animatableModel) {
    if (!animatableModel.isAnimationEnabled() || !animationOpts) return;
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(animationOpts)) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(animationOpts, function(singleAnimationOpts) {
            $ab8d73690f09fb6d$export$b0aa6a5f01693fa4(el, singleAnimationOpts, animatableModel);
        });
        return;
    }
    var keyframes = animationOpts.keyframes;
    var duration = animationOpts.duration;
    if (animatableModel && duration == null) {
        // Default to use duration of config.
        // NOTE: animation config from payload will be ignored because they are mainly for transitions.
        var config = (0, $8b353638fbedfefa$export$5cc7add7ab591d0a)("enter", animatableModel, 0);
        duration = config && config.duration;
    }
    if (!keyframes || !duration) return;
    var stateToRestore = $ab8d73690f09fb6d$var$getStateToRestore(el);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $7c104376a000308e$export$9a911ad86e905b13), function(targetPropName) {
        if (targetPropName && !el[targetPropName]) return;
        var animator;
        var endFrameIsSet = false;
        // Sort keyframes by percent.
        keyframes.sort(function(a, b) {
            return a.percent - b.percent;
        });
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(keyframes, function(kf) {
            // Stop current animation.
            var animators = el.animators;
            var kfValues = targetPropName ? kf[targetPropName] : kf;
            if (!kfValues) return;
            var propKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(kfValues);
            if (!targetPropName) // PENDING performance?
            propKeys = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(propKeys, function(key) {
                return (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)($ab8d73690f09fb6d$var$KEYFRAME_EXCLUDE_KEYS, key) < 0;
            });
            if (!propKeys.length) return;
            if (!animator) {
                animator = el.animate(targetPropName, animationOpts.loop, true);
                animator.scope = "keyframe";
            }
            for(var i = 0; i < animators.length; i++)// Stop all other animation that is not keyframe.
            if (animators[i] !== animator && animators[i].targetName === animator.targetName) animators[i].stopTracks(propKeys);
            targetPropName && (stateToRestore[targetPropName] = stateToRestore[targetPropName] || {});
            var savedTarget = targetPropName ? stateToRestore[targetPropName] : stateToRestore;
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(propKeys, function(key) {
                // Save original value.
                savedTarget[key] = ((targetPropName ? el[targetPropName] : el) || {})[key];
            });
            animator.whenWithKeys(duration * kf.percent, kfValues, propKeys, kf.easing);
        });
        if (!animator) return;
        animator.delay(animationOpts.delay || 0).duration(duration).start(animationOpts.easing);
    });
}




var $590d5f44e94a6803$var$EMPHASIS = "emphasis";
var $590d5f44e94a6803$var$NORMAL = "normal";
var $590d5f44e94a6803$var$BLUR = "blur";
var $590d5f44e94a6803$var$SELECT = "select";
var $590d5f44e94a6803$var$STATES = [
    $590d5f44e94a6803$var$NORMAL,
    $590d5f44e94a6803$var$EMPHASIS,
    $590d5f44e94a6803$var$BLUR,
    $590d5f44e94a6803$var$SELECT
];
var $590d5f44e94a6803$var$PATH_ITEM_STYLE = {
    normal: [
        "itemStyle"
    ],
    emphasis: [
        $590d5f44e94a6803$var$EMPHASIS,
        "itemStyle"
    ],
    blur: [
        $590d5f44e94a6803$var$BLUR,
        "itemStyle"
    ],
    select: [
        $590d5f44e94a6803$var$SELECT,
        "itemStyle"
    ]
};
var $590d5f44e94a6803$var$PATH_LABEL = {
    normal: [
        "label"
    ],
    emphasis: [
        $590d5f44e94a6803$var$EMPHASIS,
        "label"
    ],
    blur: [
        $590d5f44e94a6803$var$BLUR,
        "label"
    ],
    select: [
        $590d5f44e94a6803$var$SELECT,
        "label"
    ]
};
var $590d5f44e94a6803$var$DEFAULT_TRANSITION = [
    "x",
    "y"
];
// Use prefix to avoid index to be the same as el.name,
// which will cause weird update animation.
var $590d5f44e94a6803$var$GROUP_DIFF_PREFIX = "e\x00\x00";
var $590d5f44e94a6803$var$attachedTxInfoTmp = {
    normal: {},
    emphasis: {},
    blur: {},
    select: {}
};
/**
 * FIXME: register rather than import directly, for size.
 *
 * To reduce total package size of each coordinate systems, the modules `prepareCustom`
 * of each coordinate systems are not required by each coordinate systems directly, but
 * required by the module `custom`.
 *
 * prepareInfoForCustomSeries {Function}: optional
 *     @return {Object} {coordSys: {...}, api: {
 *         coord: function (data, clamp) {}, // return point in global.
 *         size: function (dataSize, dataItem) {} // return size of each axis in coordSys.
 *     }}
 */ var $590d5f44e94a6803$var$prepareCustoms = {
    cartesian2d: (0, $eb5b87553d7c5e15$export$2e2bcd8739ae039),
    geo: (0, $db94904ae7a63a7b$export$2e2bcd8739ae039),
    single: (0, $4af7f8b40c63338e$export$2e2bcd8739ae039),
    polar: (0, $5542da7477183ee1$export$2e2bcd8739ae039),
    calendar: (0, $07a38220d20058fb$export$2e2bcd8739ae039),
    matrix: (0, $05e7f6a59f17536e$export$2e2bcd8739ae039)
};
function $590d5f44e94a6803$var$isPath(el) {
    return el instanceof $b02ffe7acd508c08$export$2e2bcd8739ae039;
}
function $590d5f44e94a6803$var$isDisplayable(el) {
    return el instanceof (0, $56206a6cb4666931$export$2e2bcd8739ae039);
}
function $590d5f44e94a6803$var$copyElement(sourceEl, targetEl) {
    targetEl.copyTransform(sourceEl);
    if ($590d5f44e94a6803$var$isDisplayable(targetEl) && $590d5f44e94a6803$var$isDisplayable(sourceEl)) {
        targetEl.setStyle(sourceEl.style);
        targetEl.z = sourceEl.z;
        targetEl.z2 = sourceEl.z2;
        targetEl.zlevel = sourceEl.zlevel;
        targetEl.invisible = sourceEl.invisible;
        targetEl.ignore = sourceEl.ignore;
        if ($590d5f44e94a6803$var$isPath(targetEl) && $590d5f44e94a6803$var$isPath(sourceEl)) targetEl.setShape(sourceEl.shape);
    }
}
var $590d5f44e94a6803$var$CustomChartView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CustomChartView, _super);
    function CustomChartView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CustomChartView.type;
        return _this;
    }
    CustomChartView.prototype.render = function(customSeries, ecModel, api, payload) {
        // Clear previously rendered progressive elements.
        this._progressiveEls = null;
        var oldData = this._data;
        var data = customSeries.getData();
        var group = this.group;
        var renderItem = $590d5f44e94a6803$var$makeRenderItem(customSeries, data, ecModel, api);
        if (!oldData) // Previous render is incremental render or first render.
        // Needs remove the incremental rendered elements.
        group.removeAll();
        data.diff(oldData).add(function(newIdx) {
            $590d5f44e94a6803$var$createOrUpdateItem(api, null, newIdx, renderItem(newIdx, payload), customSeries, group, data);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && (0, $7c104376a000308e$export$15575b6d82d35bb3)(el, (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(el).option, customSeries);
        }).update(function(newIdx, oldIdx) {
            var oldEl = oldData.getItemGraphicEl(oldIdx);
            $590d5f44e94a6803$var$createOrUpdateItem(api, oldEl, newIdx, renderItem(newIdx, payload), customSeries, group, data);
        }).execute();
        // Do clipping
        var clipPath = customSeries.get("clip", true) ? (0, $0e2cc04b3aaad400$export$e0fe5081209d01c9)(customSeries.coordinateSystem, false, customSeries) : null;
        if (clipPath) group.setClipPath(clipPath);
        else group.removeClipPath();
        this._data = data;
    };
    CustomChartView.prototype.incrementalPrepareRender = function(customSeries, ecModel, api) {
        this.group.removeAll();
        this._data = null;
    };
    CustomChartView.prototype.incrementalRender = function(params, customSeries, ecModel, api, payload) {
        var data = customSeries.getData();
        var renderItem = $590d5f44e94a6803$var$makeRenderItem(customSeries, data, ecModel, api);
        var progressiveEls = this._progressiveEls = [];
        function setIncrementalAndHoverLayer(el) {
            if (!el.isGroup) {
                el.incremental = true;
                el.ensureState("emphasis").hoverLayer = true;
            }
        }
        for(var idx = params.start; idx < params.end; idx++){
            var el = $590d5f44e94a6803$var$createOrUpdateItem(null, null, idx, renderItem(idx, payload), customSeries, this.group, data);
            if (el) {
                el.traverse(setIncrementalAndHoverLayer);
                progressiveEls.push(el);
            }
        }
    };
    CustomChartView.prototype.eachRendered = function(cb) {
        $5b455ae6f843ac47$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    CustomChartView.prototype.filterForExposedEvent = function(eventType, query, targetEl, packedEvent) {
        var elementName = query.element;
        if (elementName == null || targetEl.name === elementName) return true;
        // Enable to give a name on a group made by `renderItem`, and listen
        // events that are triggered by its descendents.
        while((targetEl = targetEl.__hostTarget || targetEl.parent) && targetEl !== this.group){
            if (targetEl.name === elementName) return true;
        }
        return false;
    };
    CustomChartView.type = "custom";
    return CustomChartView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $590d5f44e94a6803$export$2e2bcd8739ae039 = $590d5f44e94a6803$var$CustomChartView;
function $590d5f44e94a6803$var$createEl(elOption) {
    var graphicType = elOption.type;
    var el;
    // Those graphic elements are not shapes. They should not be
    // overwritten by users, so do them first.
    if (graphicType === "path") {
        var shape = elOption.shape;
        // Using pathRect brings convenience to users sacle svg path.
        var pathRect = shape.width != null && shape.height != null ? {
            x: shape.x || 0,
            y: shape.y || 0,
            width: shape.width,
            height: shape.height
        } : null;
        var pathData = $590d5f44e94a6803$var$getPathData(shape);
        // Path is also used for icon, so layout 'center' by default.
        el = $5b455ae6f843ac47$export$aa9bab72412f5613(pathData, null, pathRect, shape.layout || "center");
        (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(el).customPathData = pathData;
    } else if (graphicType === "image") {
        el = new $86adec94217b86c6$export$2e2bcd8739ae039({});
        (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(el).customImagePath = elOption.style.image;
    } else if (graphicType === "text") el = new $fe885cc21795562b$export$2e2bcd8739ae039({});
    else if (graphicType === "group") el = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
    else if (graphicType === "compoundPath") {
        var shape = elOption.shape;
        if (!shape || !shape.paths) {
            var errMsg = "";
            (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        }
        var paths = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(shape.paths, function(path) {
            if (path.type === "path") return $5b455ae6f843ac47$export$aa9bab72412f5613(path.shape.pathData, path, null);
            var Clz = $5b455ae6f843ac47$export$51df4b5565a58189(path.type);
            if (!Clz) {
                var errMsg = "";
                (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
            }
            return new Clz();
        });
        el = new $e152f3dbf8fba6e2$export$2e2bcd8739ae039({
            shape: {
                paths: paths
            }
        });
    } else {
        var Clz = $5b455ae6f843ac47$export$51df4b5565a58189(graphicType);
        if (!Clz) {
            var errMsg = "";
            (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        }
        el = new Clz();
    }
    (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(el).customGraphicType = graphicType;
    el.name = elOption.name;
    // Compat ec4: the default z2 lift is 1. If changing the number,
    // some cases probably be broken: hierarchy layout along z, like circle packing,
    // where emphasis only intending to modify color/border rather than lift z2.
    el.z2EmphasisLift = 1;
    el.z2SelectLift = 1;
    return el;
}
function $590d5f44e94a6803$var$updateElNormal(// Can be null/undefined
api, el, dataIndex, elOption, attachedTxInfo, seriesModel, isInit) {
    // Stop and restore before update any other attributes.
    (0, $ab8d73690f09fb6d$export$9e5c70edf1ec0cb4)(el);
    var txCfgOpt = attachedTxInfo && attachedTxInfo.normal.cfg;
    if (txCfgOpt) // PENDING: whether use user object directly rather than clone?
    // TODO:5.0 textConfig transition animation?
    el.setTextConfig(txCfgOpt);
    // Default transition ['x', 'y']
    if (elOption && elOption.transition == null) elOption.transition = $590d5f44e94a6803$var$DEFAULT_TRANSITION;
    // Do some normalization on style.
    var styleOpt = elOption && elOption.style;
    if (styleOpt) {
        if (el.type === "text") {
            var textOptionStyle = styleOpt;
            // Compatible with ec4: if `textFill` or `textStroke` exists use them.
            (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(textOptionStyle, "textFill") && (textOptionStyle.fill = textOptionStyle.textFill);
            (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(textOptionStyle, "textStroke") && (textOptionStyle.stroke = textOptionStyle.textStroke);
        }
        var decalPattern = void 0;
        var decalObj = $590d5f44e94a6803$var$isPath(el) ? styleOpt.decal : null;
        if (api && decalObj) {
            decalObj.dirty = true;
            decalPattern = (0, $c6d646aacd243427$export$a3ba048e1a648972)(decalObj, api);
        }
        // Always overwrite in case user specify this prop.
        styleOpt.__decalPattern = decalPattern;
    }
    if ($590d5f44e94a6803$var$isDisplayable(el)) {
        if (styleOpt) {
            var decalPattern = styleOpt.__decalPattern;
            if (decalPattern) styleOpt.decal = decalPattern;
        }
    }
    (0, $7c104376a000308e$export$4342b281b9b5d77e)(el, elOption, seriesModel, {
        dataIndex: dataIndex,
        isInit: isInit,
        clearStyle: true
    });
    (0, $ab8d73690f09fb6d$export$b0aa6a5f01693fa4)(el, elOption.keyframeAnimation, seriesModel);
}
function $590d5f44e94a6803$var$updateElOnState(state, el, elStateOpt, styleOpt, attachedTxInfo) {
    var elDisplayable = el.isGroup ? null : el;
    var txCfgOpt = attachedTxInfo && attachedTxInfo[state].cfg;
    // PENDING:5.0 support customize scale change and transition animation?
    if (elDisplayable) {
        // By default support auto lift color when hover whether `emphasis` specified.
        var stateObj = elDisplayable.ensureState(state);
        if (styleOpt === false) {
            var existingEmphasisState = elDisplayable.getState(state);
            if (existingEmphasisState) existingEmphasisState.style = null;
        } else // style is needed to enable default emphasis.
        stateObj.style = styleOpt || null;
        // If `elOption.styleEmphasis` or `elOption.emphasis.style` is `false`,
        // remove hover style.
        // If `elOption.textConfig` or `elOption.emphasis.textConfig` is null/undefined, it does not
        // make sense. So for simplicity, we do not ditinguish `hasOwnProperty` and null/undefined.
        if (txCfgOpt) stateObj.textConfig = txCfgOpt;
        (0, $2bf82c0980125b62$export$20f39bbe322fb9ab)(elDisplayable);
    }
}
function $590d5f44e94a6803$var$updateZ(el, elOption, seriesModel) {
    // Group not support textContent and not support z yet.
    if (el.isGroup) return;
    var elDisplayable = el;
    var currentZ = seriesModel.currentZ;
    var currentZLevel = seriesModel.currentZLevel;
    // Always erase.
    elDisplayable.z = currentZ;
    elDisplayable.zlevel = currentZLevel;
    // z2 must not be null/undefined, otherwise sort error may occur.
    var optZ2 = elOption.z2;
    optZ2 != null && (elDisplayable.z2 = optZ2 || 0);
    for(var i = 0; i < $590d5f44e94a6803$var$STATES.length; i++)$590d5f44e94a6803$var$updateZForEachState(elDisplayable, elOption, $590d5f44e94a6803$var$STATES[i]);
}
function $590d5f44e94a6803$var$updateZForEachState(elDisplayable, elOption, state) {
    var isNormal = state === $590d5f44e94a6803$var$NORMAL;
    var elStateOpt = isNormal ? elOption : $590d5f44e94a6803$var$retrieveStateOption(elOption, state);
    var optZ2 = elStateOpt ? elStateOpt.z2 : null;
    var stateObj;
    if (optZ2 != null) {
        // Do not `ensureState` until required.
        stateObj = isNormal ? elDisplayable : elDisplayable.ensureState(state);
        stateObj.z2 = optZ2 || 0;
    }
}
function $590d5f44e94a6803$var$makeRenderItem(customSeries, data, ecModel, api) {
    var renderItem = customSeries.get("renderItem");
    if (typeof renderItem === "string") {
        // Find renderItem in registered custom series
        var registeredRenderItem = (0, $b11674322a1bd845$export$2b5db8e5650e8d15)(renderItem);
        if (registeredRenderItem) renderItem = registeredRenderItem;
    }
    var coordSys = customSeries.coordinateSystem;
    var prepareResult = {};
    if (coordSys) // `coordSys.prepareCustoms` is used for external coord sys like bmap.
    prepareResult = coordSys.prepareCustoms ? coordSys.prepareCustoms(coordSys) : $590d5f44e94a6803$var$prepareCustoms[coordSys.type](coordSys);
    var userAPI = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        getWidth: api.getWidth,
        getHeight: api.getHeight,
        getZr: api.getZr,
        getDevicePixelRatio: api.getDevicePixelRatio,
        value: value,
        style: style,
        ordinalRawValue: ordinalRawValue,
        styleEmphasis: styleEmphasis,
        visual: visual,
        barLayout: barLayout,
        currentSeriesIndices: currentSeriesIndices,
        font: font
    }, prepareResult.api || {});
    var userParams = {
        // The life cycle of context: current round of rendering.
        // The global life cycle is probably not necessary, because
        // user can store global status by themselves.
        context: {},
        seriesId: customSeries.id,
        seriesName: customSeries.name,
        seriesIndex: customSeries.seriesIndex,
        coordSys: prepareResult.coordSys,
        dataInsideLength: data.count(),
        encode: $590d5f44e94a6803$var$wrapEncodeDef(customSeries.getData()),
        itemPayload: customSeries.get("itemPayload") || {}
    };
    // If someday intending to refactor them to a class, should consider do not
    // break change: currently these attribute member are encapsulated in a closure
    // so that do not need to force user to call these method with a scope.
    // Do not support call `api` asynchronously without dataIndexInside input.
    var currDataIndexInside;
    var currItemModel;
    var currItemStyleModels = {};
    var currLabelModels = {};
    var seriesItemStyleModels = {};
    var seriesLabelModels = {};
    for(var i = 0; i < $590d5f44e94a6803$var$STATES.length; i++){
        var stateName = $590d5f44e94a6803$var$STATES[i];
        seriesItemStyleModels[stateName] = customSeries.getModel($590d5f44e94a6803$var$PATH_ITEM_STYLE[stateName]);
        seriesLabelModels[stateName] = customSeries.getModel($590d5f44e94a6803$var$PATH_LABEL[stateName]);
    }
    function getItemModel(dataIndexInside) {
        return dataIndexInside === currDataIndexInside ? currItemModel || (currItemModel = data.getItemModel(dataIndexInside)) : data.getItemModel(dataIndexInside);
    }
    function getItemStyleModel(dataIndexInside, state) {
        return !data.hasItemOption ? seriesItemStyleModels[state] : dataIndexInside === currDataIndexInside ? currItemStyleModels[state] || (currItemStyleModels[state] = getItemModel(dataIndexInside).getModel($590d5f44e94a6803$var$PATH_ITEM_STYLE[state])) : getItemModel(dataIndexInside).getModel($590d5f44e94a6803$var$PATH_ITEM_STYLE[state]);
    }
    function getLabelModel(dataIndexInside, state) {
        return !data.hasItemOption ? seriesLabelModels[state] : dataIndexInside === currDataIndexInside ? currLabelModels[state] || (currLabelModels[state] = getItemModel(dataIndexInside).getModel($590d5f44e94a6803$var$PATH_LABEL[state])) : getItemModel(dataIndexInside).getModel($590d5f44e94a6803$var$PATH_LABEL[state]);
    }
    return function(dataIndexInside, payload) {
        currDataIndexInside = dataIndexInside;
        currItemModel = null;
        currItemStyleModels = {};
        currLabelModels = {};
        return renderItem && renderItem((0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
            dataIndexInside: dataIndexInside,
            dataIndex: data.getRawIndex(dataIndexInside),
            // Can be used for optimization when zoom or roam.
            actionType: payload ? payload.type : null
        }, userParams), userAPI);
    };
    /**
   * @public
   * @param dim by default 0.
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function value(dim, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        return data.getStore().get(data.getDimensionIndex(dim || 0), dataIndexInside);
    }
    /**
   * @public
   * @param dim by default 0.
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function ordinalRawValue(dim, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        dim = dim || 0;
        var dimInfo = data.getDimensionInfo(dim);
        if (!dimInfo) {
            var dimIndex = data.getDimensionIndex(dim);
            return dimIndex >= 0 ? data.getStore().get(dimIndex, dataIndexInside) : undefined;
        }
        var val = data.get(dimInfo.name, dataIndexInside);
        var ordinalMeta = dimInfo && dimInfo.ordinalMeta;
        return ordinalMeta ? ordinalMeta.categories[val] : val;
    }
    /**
   * @deprecated The original intention of `api.style` is enable to set itemStyle
   * like other series. But it is not necessary and not easy to give a strict definition
   * of what it returns. And since echarts5 it needs to be make compat work. So
   * deprecates it since echarts5.
   *
   * By default, `visual` is applied to style (to support visualMap).
   * `visual.color` is applied at `fill`. If user want apply visual.color on `stroke`,
   * it can be implemented as:
   * `api.style({stroke: api.visual('color'), fill: null})`;
   *
   * [Compat]: since ec5, RectText has been separated from its hosts el.
   * so `api.style()` will only return the style from `itemStyle` but not handle `label`
   * any more. But `series.label` config is never published in doc.
   * We still compat it in `api.style()`. But not encourage to use it and will still not
   * to pulish it to doc.
   * @public
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function style(userProps, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        var style = data.getItemVisual(dataIndexInside, "style");
        var visualColor = style && style.fill;
        var opacity = style && style.opacity;
        var itemStyle = getItemStyleModel(dataIndexInside, $590d5f44e94a6803$var$NORMAL).getItemStyle();
        visualColor != null && (itemStyle.fill = visualColor);
        opacity != null && (itemStyle.opacity = opacity);
        var opt = {
            inheritColor: (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(visualColor) ? visualColor : (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral99
        };
        var labelModel = getLabelModel(dataIndexInside, $590d5f44e94a6803$var$NORMAL);
        // Now that the feature of "auto adjust text fill/stroke" has been migrated to zrender
        // since ec5, we should set `isAttached` as `false` here and make compat in
        // `convertToEC4StyleForCustomSerise`.
        var textStyle = $6800dfcb6e1e2a44$export$f8998c3d0a13de59(labelModel, null, opt, false, true);
        textStyle.text = labelModel.getShallow("show") ? (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(customSeries.getFormattedLabel(dataIndexInside, $590d5f44e94a6803$var$NORMAL), (0, $b2475f850d3c0bc2$export$5ff20667590927ed)(data, dataIndexInside)) : null;
        var textConfig = $6800dfcb6e1e2a44$export$e149afab8df6e053(labelModel, opt, false);
        preFetchFromExtra(userProps, itemStyle);
        itemStyle = (0, $daa53642c3afcc30$export$b8ddb75bd1b9b791)(itemStyle, textStyle, textConfig);
        userProps && applyUserPropsAfter(itemStyle, userProps);
        itemStyle.legacy = true;
        return itemStyle;
    }
    /**
   * @deprecated The reason see `api.style()`
   * @public
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function styleEmphasis(userProps, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        var itemStyle = getItemStyleModel(dataIndexInside, $590d5f44e94a6803$var$EMPHASIS).getItemStyle();
        var labelModel = getLabelModel(dataIndexInside, $590d5f44e94a6803$var$EMPHASIS);
        var textStyle = $6800dfcb6e1e2a44$export$f8998c3d0a13de59(labelModel, null, null, true, true);
        textStyle.text = labelModel.getShallow("show") ? (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(customSeries.getFormattedLabel(dataIndexInside, $590d5f44e94a6803$var$EMPHASIS), customSeries.getFormattedLabel(dataIndexInside, $590d5f44e94a6803$var$NORMAL), (0, $b2475f850d3c0bc2$export$5ff20667590927ed)(data, dataIndexInside)) : null;
        var textConfig = $6800dfcb6e1e2a44$export$e149afab8df6e053(labelModel, null, true);
        preFetchFromExtra(userProps, itemStyle);
        itemStyle = (0, $daa53642c3afcc30$export$b8ddb75bd1b9b791)(itemStyle, textStyle, textConfig);
        userProps && applyUserPropsAfter(itemStyle, userProps);
        itemStyle.legacy = true;
        return itemStyle;
    }
    function applyUserPropsAfter(itemStyle, extra) {
        for(var key in extra)if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(extra, key)) itemStyle[key] = extra[key];
    }
    function preFetchFromExtra(extra, itemStyle) {
        // A trick to retrieve those props firstly, which are used to
        // apply auto inside fill/stroke in `convertToEC4StyleForCustomSerise`.
        // (It's not reasonable but only for a degree of compat)
        if (extra) {
            extra.textFill && (itemStyle.textFill = extra.textFill);
            extra.textPosition && (itemStyle.textPosition = extra.textPosition);
        }
    }
    /**
   * @public
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function visual(visualType, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)((0, $fef28dd8967d3f1b$export$84369c8e2229fa7f), visualType)) {
            var style_1 = data.getItemVisual(dataIndexInside, "style");
            return style_1 ? style_1[(0, $fef28dd8967d3f1b$export$84369c8e2229fa7f)[visualType]] : null;
        }
        // Only support these visuals. Other visual might be inner tricky
        // for performance (like `style`), do not expose to users.
        if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)((0, $fef28dd8967d3f1b$export$734d775a14929701), visualType)) return data.getItemVisual(dataIndexInside, visualType);
    }
    /**
   * @public
   * @return If not support, return undefined.
   */ function barLayout(opt) {
        if (coordSys.type === "cartesian2d") {
            var baseAxis = coordSys.getBaseAxis();
            return (0, $361c48dd900de28f$export$658df087977b9e84)((0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                axis: baseAxis
            }, opt));
        }
    }
    /**
   * @public
   */ function currentSeriesIndices() {
        return ecModel.getCurrentSeriesIndices();
    }
    /**
   * @public
   * @return font string
   */ function font(opt) {
        return $6800dfcb6e1e2a44$export$155316a870a9d61e(opt, ecModel);
    }
}
function $590d5f44e94a6803$var$wrapEncodeDef(data) {
    var encodeDef = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(data.dimensions, function(dimName) {
        var dimInfo = data.getDimensionInfo(dimName);
        if (!dimInfo.isExtraCoord) {
            var coordDim = dimInfo.coordDim;
            var dataDims = encodeDef[coordDim] = encodeDef[coordDim] || [];
            dataDims[dimInfo.coordDimIndex] = data.getDimensionIndex(dimName);
        }
    });
    return encodeDef;
}
function $590d5f44e94a6803$var$createOrUpdateItem(api, existsEl, dataIndex, elOption, seriesModel, group, data) {
    // [Rule]
    // If `renderItem` returns `null`/`undefined`/`false`, remove the previous el if existing.
    //     (It seems that violate the "merge" principle, but most of users probably intuitively
    //     regard "return;" as "show nothing element whatever", so make a exception to meet the
    //     most cases.)
    // The rule or "merge" see [STRATEGY_MERGE].
    // If `elOption` is `null`/`undefined`/`false` (when `renderItem` returns nothing).
    if (!elOption) {
        group.remove(existsEl);
        return;
    }
    var el = $590d5f44e94a6803$var$doCreateOrUpdateEl(api, existsEl, dataIndex, elOption, seriesModel, group);
    el && data.setItemGraphicEl(dataIndex, el);
    el && (0, $2bf82c0980125b62$export$e51187539ff11209)(el, elOption.focus, elOption.blurScope, elOption.emphasisDisabled);
    return el;
}
function $590d5f44e94a6803$var$doCreateOrUpdateEl(api, existsEl, dataIndex, elOption, seriesModel, group) {
    var toBeReplacedIdx = -1;
    var oldEl = existsEl;
    if (existsEl && $590d5f44e94a6803$var$doesElNeedRecreate(existsEl, elOption, seriesModel)) {
        // Should keep at the original index, otherwise "merge by index" will be incorrect.
        toBeReplacedIdx = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(group.childrenRef(), existsEl);
        existsEl = null;
    }
    var isInit = !existsEl;
    var el = existsEl;
    if (!el) {
        el = $590d5f44e94a6803$var$createEl(elOption);
        if (oldEl) $590d5f44e94a6803$var$copyElement(oldEl, el);
    } else // FIMXE:NEXT unified clearState?
    // If in some case the performance issue arised, consider
    // do not clearState but update cached normal state directly.
    el.clearStates();
    // Need to set morph: false explictly to disable automatically morphing.
    if (elOption.morph === false) el.disableMorphing = true;
    else if (el.disableMorphing) el.disableMorphing = false;
    if (elOption.tooltipDisabled) el.tooltipDisabled = true;
    $590d5f44e94a6803$var$attachedTxInfoTmp.normal.cfg = $590d5f44e94a6803$var$attachedTxInfoTmp.normal.conOpt = $590d5f44e94a6803$var$attachedTxInfoTmp.emphasis.cfg = $590d5f44e94a6803$var$attachedTxInfoTmp.emphasis.conOpt = $590d5f44e94a6803$var$attachedTxInfoTmp.blur.cfg = $590d5f44e94a6803$var$attachedTxInfoTmp.blur.conOpt = $590d5f44e94a6803$var$attachedTxInfoTmp.select.cfg = $590d5f44e94a6803$var$attachedTxInfoTmp.select.conOpt = null;
    $590d5f44e94a6803$var$attachedTxInfoTmp.isLegacy = false;
    $590d5f44e94a6803$var$doCreateOrUpdateAttachedTx(el, dataIndex, elOption, seriesModel, isInit, $590d5f44e94a6803$var$attachedTxInfoTmp);
    $590d5f44e94a6803$var$doCreateOrUpdateClipPath(el, dataIndex, elOption, seriesModel, isInit);
    $590d5f44e94a6803$var$updateElNormal(api, el, dataIndex, elOption, $590d5f44e94a6803$var$attachedTxInfoTmp, seriesModel, isInit);
    // `elOption.info` enables user to mount some info on
    // elements and use them in event handlers.
    // Update them only when user specified, otherwise, remain.
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(elOption, "info") && ((0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(el).info = elOption.info);
    for(var i = 0; i < $590d5f44e94a6803$var$STATES.length; i++){
        var stateName = $590d5f44e94a6803$var$STATES[i];
        if (stateName !== $590d5f44e94a6803$var$NORMAL) {
            var otherStateOpt = $590d5f44e94a6803$var$retrieveStateOption(elOption, stateName);
            var otherStyleOpt = $590d5f44e94a6803$var$retrieveStyleOptionOnState(elOption, otherStateOpt, stateName);
            $590d5f44e94a6803$var$updateElOnState(stateName, el, otherStateOpt, otherStyleOpt, $590d5f44e94a6803$var$attachedTxInfoTmp);
        }
    }
    $590d5f44e94a6803$var$updateZ(el, elOption, seriesModel);
    if (elOption.type === "group") $590d5f44e94a6803$var$mergeChildren(api, el, dataIndex, elOption, seriesModel);
    if (toBeReplacedIdx >= 0) group.replaceAt(el, toBeReplacedIdx);
    else group.add(el);
    return el;
}
// `el` must not be null/undefined.
function $590d5f44e94a6803$var$doesElNeedRecreate(el, elOption, seriesModel) {
    var elInner = (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(el);
    var elOptionType = elOption.type;
    var elOptionShape = elOption.shape;
    var elOptionStyle = elOption.style;
    return(// Always create new if universal transition is enabled.
    // Because we do transition after render. It needs to know what old element is. Replacement will loose it.
    seriesModel.isUniversalTransitionEnabled() || elOptionType != null && elOptionType !== elInner.customGraphicType || elOptionType === "path" && $590d5f44e94a6803$var$hasOwnPathData(elOptionShape) && $590d5f44e94a6803$var$getPathData(elOptionShape) !== elInner.customPathData || elOptionType === "image" && (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(elOptionStyle, "image") && elOptionStyle.image !== elInner.customImagePath);
}
function $590d5f44e94a6803$var$doCreateOrUpdateClipPath(el, dataIndex, elOption, seriesModel, isInit) {
    // Based on the "merge" principle, if no clipPath provided,
    // do nothing. The exists clip will be totally removed only if
    // `el.clipPath` is `false`. Otherwise it will be merged/replaced.
    var clipPathOpt = elOption.clipPath;
    if (clipPathOpt === false) {
        if (el && el.getClipPath()) el.removeClipPath();
    } else if (clipPathOpt) {
        var clipPath = el.getClipPath();
        if (clipPath && $590d5f44e94a6803$var$doesElNeedRecreate(clipPath, clipPathOpt, seriesModel)) clipPath = null;
        if (!clipPath) {
            clipPath = $590d5f44e94a6803$var$createEl(clipPathOpt);
            el.setClipPath(clipPath);
        }
        $590d5f44e94a6803$var$updateElNormal(null, clipPath, dataIndex, clipPathOpt, null, seriesModel, isInit);
    }
// If not define `clipPath` in option, do nothing unnecessary.
}
function $590d5f44e94a6803$var$doCreateOrUpdateAttachedTx(el, dataIndex, elOption, seriesModel, isInit, attachedTxInfo) {
    // Group does not support textContent temporarily until necessary.
    if (el.isGroup || el.type === "compoundPath") return;
    // Normal must be called before emphasis, for `isLegacy` detection.
    $590d5f44e94a6803$var$processTxInfo(elOption, null, attachedTxInfo);
    $590d5f44e94a6803$var$processTxInfo(elOption, $590d5f44e94a6803$var$EMPHASIS, attachedTxInfo);
    // If `elOption.textConfig` or `elOption.textContent` is null/undefined, it does not make sense.
    // So for simplicity, if "elOption hasOwnProperty of them but be null/undefined", we do not
    // trade them as set to null to el.
    // Especially:
    // `elOption.textContent: false` means remove textContent.
    // `elOption.textContent.emphasis.style: false` means remove the style from emphasis state.
    var txConOptNormal = attachedTxInfo.normal.conOpt;
    var txConOptEmphasis = attachedTxInfo.emphasis.conOpt;
    var txConOptBlur = attachedTxInfo.blur.conOpt;
    var txConOptSelect = attachedTxInfo.select.conOpt;
    if (txConOptNormal != null || txConOptEmphasis != null || txConOptSelect != null || txConOptBlur != null) {
        var textContent = el.getTextContent();
        if (txConOptNormal === false) textContent && el.removeTextContent();
        else {
            txConOptNormal = attachedTxInfo.normal.conOpt = txConOptNormal || {
                type: "text"
            };
            if (!textContent) {
                textContent = $590d5f44e94a6803$var$createEl(txConOptNormal);
                el.setTextContent(textContent);
            } else // If in some case the performance issue arised, consider
            // do not clearState but update cached normal state directly.
            textContent.clearStates();
            $590d5f44e94a6803$var$updateElNormal(null, textContent, dataIndex, txConOptNormal, null, seriesModel, isInit);
            var txConStlOptNormal = txConOptNormal && txConOptNormal.style;
            for(var i = 0; i < $590d5f44e94a6803$var$STATES.length; i++){
                var stateName = $590d5f44e94a6803$var$STATES[i];
                if (stateName !== $590d5f44e94a6803$var$NORMAL) {
                    var txConOptOtherState = attachedTxInfo[stateName].conOpt;
                    $590d5f44e94a6803$var$updateElOnState(stateName, textContent, txConOptOtherState, $590d5f44e94a6803$var$retrieveStyleOptionOnState(txConOptNormal, txConOptOtherState, stateName), null);
                }
            }
            txConStlOptNormal ? textContent.dirty() : textContent.markRedraw();
        }
    }
}
function $590d5f44e94a6803$var$processTxInfo(elOption, state, attachedTxInfo) {
    var stateOpt = !state ? elOption : $590d5f44e94a6803$var$retrieveStateOption(elOption, state);
    var styleOpt = !state ? elOption.style : $590d5f44e94a6803$var$retrieveStyleOptionOnState(elOption, stateOpt, $590d5f44e94a6803$var$EMPHASIS);
    var elType = elOption.type;
    var txCfg = stateOpt ? stateOpt.textConfig : null;
    var txConOptNormal = elOption.textContent;
    var txConOpt = !txConOptNormal ? null : !state ? txConOptNormal : $590d5f44e94a6803$var$retrieveStateOption(txConOptNormal, state);
    if (styleOpt && // Because emphasis style has little info to detect legacy,
    // if normal is legacy, emphasis is trade as legacy.
    (attachedTxInfo.isLegacy || (0, $daa53642c3afcc30$export$3b868abde5eae7d1)(styleOpt, elType, !!txCfg, !!txConOpt))) {
        attachedTxInfo.isLegacy = true;
        var convertResult = (0, $daa53642c3afcc30$export$7748133eaaa8aecc)(styleOpt, elType, !state);
        // Explicitly specified `textConfig` and `textContent` has higher priority than
        // the ones generated by legacy style. Otherwise if users use them and `api.style`
        // at the same time, they not both work and hardly to known why.
        if (!txCfg && convertResult.textConfig) txCfg = convertResult.textConfig;
        if (!txConOpt && convertResult.textContent) txConOpt = convertResult.textContent;
    }
    if (!state && txConOpt) {
        var txConOptNormal_1 = txConOpt;
        // `textContent: {type: 'text'}`, the "type" is easy to be missing. So we tolerate it.
        !txConOptNormal_1.type && (txConOptNormal_1.type = "text");
    }
    var info = !state ? attachedTxInfo.normal : attachedTxInfo[state];
    info.cfg = txCfg;
    info.conOpt = txConOpt;
}
function $590d5f44e94a6803$var$retrieveStateOption(elOption, state) {
    return !state ? elOption : elOption ? elOption[state] : null;
}
function $590d5f44e94a6803$var$retrieveStyleOptionOnState(stateOptionNormal, stateOption, state) {
    var style = stateOption && stateOption.style;
    if (style == null && state === $590d5f44e94a6803$var$EMPHASIS && stateOptionNormal) style = stateOptionNormal.styleEmphasis;
    return style;
}
// Usage:
// (1) By default, `elOption.$mergeChildren` is `'byIndex'`, which indicates
//     that the existing children will not be removed, and enables the feature
//     that update some of the props of some of the children simply by construct
//     the returned children of `renderItem` like:
//     `var children = group.children = []; children[3] = {opacity: 0.5};`
// (2) If `elOption.$mergeChildren` is `'byName'`, add/update/remove children
//     by child.name. But that might be lower performance.
// (3) If `elOption.$mergeChildren` is `false`, the existing children will be
//     replaced totally.
// (4) If `!elOption.children`, following the "merge" principle, nothing will
//     happen.
// (5) If `elOption.$mergeChildren` is not `false` neither `'byName'` and the
//     `el` is a group, and if any of the new child is null, it means to remove
//     the element at the same index, if exists. On the other hand, if the new
//     child is and empty object `{}`, it means to keep the element not changed.
//
// For implementation simpleness, do not provide a direct way to remove single
// child (otherwise the total indices of the children array have to be modified).
// User can remove a single child by setting its `ignore` to `true`.
function $590d5f44e94a6803$var$mergeChildren(api, el, dataIndex, elOption, seriesModel) {
    var newChildren = elOption.children;
    var newLen = newChildren ? newChildren.length : 0;
    var mergeChildren = elOption.$mergeChildren;
    // `diffChildrenByName` has been deprecated.
    var byName = mergeChildren === "byName" || elOption.diffChildrenByName;
    var notMerge = mergeChildren === false;
    // For better performance on roam update, only enter if necessary.
    if (!newLen && !byName && !notMerge) return;
    if (byName) {
        $590d5f44e94a6803$var$diffGroupChildren({
            api: api,
            oldChildren: el.children() || [],
            newChildren: newChildren || [],
            dataIndex: dataIndex,
            seriesModel: seriesModel,
            group: el
        });
        return;
    }
    notMerge && el.removeAll();
    // Mapping children of a group simply by index, which
    // might be better performance.
    var index = 0;
    for(; index < newLen; index++){
        var newChild = newChildren[index];
        var oldChild = el.childAt(index);
        if (newChild) {
            if (newChild.ignore == null) // The old child is set to be ignored if null (see comments
            // below). So we need to set ignore to be false back.
            newChild.ignore = false;
            $590d5f44e94a6803$var$doCreateOrUpdateEl(api, oldChild, dataIndex, newChild, seriesModel, el);
        } else // If the new element option is null, it means to remove the old
        // element. But we cannot really remove the element from the group
        // directly, because the element order may not be stable when this
        // element is added back. So we set the element to be ignored.
        oldChild.ignore = true;
    }
    for(var i = el.childCount() - 1; i >= index; i--){
        var child = el.childAt(i);
        $590d5f44e94a6803$var$removeChildFromGroup(el, child, seriesModel);
    }
}
function $590d5f44e94a6803$var$removeChildFromGroup(group, child, seriesModel) {
    // Do not support leave elements that are not mentioned in the latest
    // `renderItem` return. Otherwise users may not have a clear and simple
    // concept that how to control all of the elements.
    child && (0, $7c104376a000308e$export$15575b6d82d35bb3)(child, (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(group).option, seriesModel);
}
function $590d5f44e94a6803$var$diffGroupChildren(context) {
    new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(context.oldChildren, context.newChildren, $590d5f44e94a6803$var$getKey, $590d5f44e94a6803$var$getKey, context).add($590d5f44e94a6803$var$processAddUpdate).update($590d5f44e94a6803$var$processAddUpdate).remove($590d5f44e94a6803$var$processRemove).execute();
}
function $590d5f44e94a6803$var$getKey(item, idx) {
    var name = item && item.name;
    return name != null ? name : $590d5f44e94a6803$var$GROUP_DIFF_PREFIX + idx;
}
function $590d5f44e94a6803$var$processAddUpdate(newIndex, oldIndex) {
    var context = this.context;
    var childOption = newIndex != null ? context.newChildren[newIndex] : null;
    var child = oldIndex != null ? context.oldChildren[oldIndex] : null;
    $590d5f44e94a6803$var$doCreateOrUpdateEl(context.api, child, context.dataIndex, childOption, context.seriesModel, context.group);
}
function $590d5f44e94a6803$var$processRemove(oldIndex) {
    var context = this.context;
    var child = context.oldChildren[oldIndex];
    child && (0, $7c104376a000308e$export$15575b6d82d35bb3)(child, (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(child).option, context.seriesModel);
}
/**
 * @return SVG Path data.
 */ function $590d5f44e94a6803$var$getPathData(shape) {
    // "d" follows the SVG convention.
    return shape && (shape.pathData || shape.d);
}
function $590d5f44e94a6803$var$hasOwnPathData(shape) {
    return shape && ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(shape, "pathData") || (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(shape, "d"));
}


function $3fd02cf8c6a1578a$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $590d5f44e94a6803$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $fef28dd8967d3f1b$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









var $b1d9c3e17ccace80$var$Symbol = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(Symbol, _super);
    function Symbol(data, idx, seriesScope, opts) {
        var _this = _super.call(this) || this;
        _this.updateData(data, idx, seriesScope, opts);
        return _this;
    }
    Symbol.prototype._createSymbol = function(symbolType, data, idx, symbolSize, z2, keepAspect) {
        // Remove paths created before
        this.removeAll();
        // let symbolPath = createSymbol(
        //     symbolType, -0.5, -0.5, 1, 1, color
        // );
        // If width/height are set too small (e.g., set to 1) on ios10
        // and macOS Sierra, a circle stroke become a rect, no matter what
        // the scale is set. So we set width/height as 2. See #4150.
        var symbolPath = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symbolType, -1, -1, 2, 2, null, keepAspect);
        symbolPath.attr({
            z2: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(z2, 100),
            culling: true,
            scaleX: symbolSize[0] / 2,
            scaleY: symbolSize[1] / 2
        });
        // Rewrite drift method
        symbolPath.drift = $b1d9c3e17ccace80$var$driftSymbol;
        this._symbolType = symbolType;
        this.add(symbolPath);
    };
    /**
   * Stop animation
   * @param {boolean} toLastFrame
   */ Symbol.prototype.stopSymbolAnimation = function(toLastFrame) {
        this.childAt(0).stopAnimation(null, toLastFrame);
    };
    Symbol.prototype.getSymbolType = function() {
        return this._symbolType;
    };
    /**
   * FIXME:
   * Caution: This method breaks the encapsulation of this module,
   * but it indeed brings convenience. So do not use the method
   * unless you detailedly know all the implements of `Symbol`,
   * especially animation.
   *
   * Get symbol path element.
   */ Symbol.prototype.getSymbolPath = function() {
        return this.childAt(0);
    };
    /**
   * Highlight symbol
   */ Symbol.prototype.highlight = function() {
        (0, $2bf82c0980125b62$export$b2d02638cc34c042)(this.childAt(0));
    };
    /**
   * Downplay symbol
   */ Symbol.prototype.downplay = function() {
        (0, $2bf82c0980125b62$export$11be6f716239ac55)(this.childAt(0));
    };
    /**
   * @param {number} zlevel
   * @param {number} z
   */ Symbol.prototype.setZ = function(zlevel, z) {
        var symbolPath = this.childAt(0);
        symbolPath.zlevel = zlevel;
        symbolPath.z = z;
    };
    Symbol.prototype.setDraggable = function(draggable, hasCursorOption) {
        var symbolPath = this.childAt(0);
        symbolPath.draggable = draggable;
        symbolPath.cursor = !hasCursorOption && draggable ? "move" : symbolPath.cursor;
    };
    /**
   * Update symbol properties
   */ Symbol.prototype.updateData = function(data, idx, seriesScope, opts) {
        this.silent = false;
        var symbolType = data.getItemVisual(idx, "symbol") || "circle";
        var seriesModel = data.hostModel;
        var symbolSize = Symbol.getSymbolSize(data, idx);
        var z2 = Symbol.getSymbolZ2(data, idx);
        var isInit = symbolType !== this._symbolType;
        var disableAnimation = opts && opts.disableAnimation;
        if (isInit) {
            var keepAspect = data.getItemVisual(idx, "symbolKeepAspect");
            this._createSymbol(symbolType, data, idx, symbolSize, z2, keepAspect);
        } else {
            var symbolPath = this.childAt(0);
            symbolPath.silent = false;
            var target = {
                scaleX: symbolSize[0] / 2,
                scaleY: symbolSize[1] / 2
            };
            disableAnimation ? symbolPath.attr(target) : $8b353638fbedfefa$export$c8dce3c08436e91e(symbolPath, target, seriesModel, idx);
            (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(symbolPath);
        }
        this._updateCommon(data, idx, symbolSize, seriesScope, opts);
        if (isInit) {
            var symbolPath = this.childAt(0);
            if (!disableAnimation) {
                var target = {
                    scaleX: this._sizeX,
                    scaleY: this._sizeY,
                    style: {
                        // Always fadeIn. Because it has fadeOut animation when symbol is removed..
                        opacity: symbolPath.style.opacity
                    }
                };
                symbolPath.scaleX = symbolPath.scaleY = 0;
                symbolPath.style.opacity = 0;
                $8b353638fbedfefa$export$a121566aadcfe021(symbolPath, target, seriesModel, idx);
            }
        }
        if (disableAnimation) // Must stop leave transition manually if don't call initProps or updateProps.
        this.childAt(0).stopAnimation("leave");
    };
    Symbol.prototype._updateCommon = function(data, idx, symbolSize, seriesScope, opts) {
        var symbolPath = this.childAt(0);
        var seriesModel = data.hostModel;
        var emphasisItemStyle;
        var blurItemStyle;
        var selectItemStyle;
        var focus;
        var blurScope;
        var emphasisDisabled;
        var labelStatesModels;
        var hoverScale;
        var cursorStyle;
        if (seriesScope) {
            emphasisItemStyle = seriesScope.emphasisItemStyle;
            blurItemStyle = seriesScope.blurItemStyle;
            selectItemStyle = seriesScope.selectItemStyle;
            focus = seriesScope.focus;
            blurScope = seriesScope.blurScope;
            labelStatesModels = seriesScope.labelStatesModels;
            hoverScale = seriesScope.hoverScale;
            cursorStyle = seriesScope.cursorStyle;
            emphasisDisabled = seriesScope.emphasisDisabled;
        }
        if (!seriesScope || data.hasItemOption) {
            var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx);
            var emphasisModel = itemModel.getModel("emphasis");
            emphasisItemStyle = emphasisModel.getModel("itemStyle").getItemStyle();
            selectItemStyle = itemModel.getModel([
                "select",
                "itemStyle"
            ]).getItemStyle();
            blurItemStyle = itemModel.getModel([
                "blur",
                "itemStyle"
            ]).getItemStyle();
            focus = emphasisModel.get("focus");
            blurScope = emphasisModel.get("blurScope");
            emphasisDisabled = emphasisModel.get("disabled");
            labelStatesModels = (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel);
            hoverScale = emphasisModel.getShallow("scale");
            cursorStyle = itemModel.getShallow("cursor");
        }
        var symbolRotate = data.getItemVisual(idx, "symbolRotate");
        symbolPath.attr("rotation", (symbolRotate || 0) * Math.PI / 180 || 0);
        var symbolOffset = (0, $5370466dadc978d7$export$e3e292895c033f6d)(data.getItemVisual(idx, "symbolOffset"), symbolSize);
        if (symbolOffset) {
            symbolPath.x = symbolOffset[0];
            symbolPath.y = symbolOffset[1];
        }
        cursorStyle && symbolPath.attr("cursor", cursorStyle);
        var symbolStyle = data.getItemVisual(idx, "style");
        var visualColor = symbolStyle.fill;
        if (symbolPath instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
            var pathStyle = symbolPath.style;
            symbolPath.useStyle((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
                // TODO other properties like x, y ?
                image: pathStyle.image,
                x: pathStyle.x,
                y: pathStyle.y,
                width: pathStyle.width,
                height: pathStyle.height
            }, symbolStyle));
        } else {
            if (symbolPath.__isEmptyBrush) // fill and stroke will be swapped if it's empty.
            // So we cloned a new style to avoid it affecting the original style in visual storage.
            // TODO Better implementation. No empty logic!
            symbolPath.useStyle((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, symbolStyle));
            else symbolPath.useStyle(symbolStyle);
            // Disable decal because symbol scale will been applied on the decal.
            symbolPath.style.decal = null;
            symbolPath.setColor(visualColor, opts && opts.symbolInnerColor);
            symbolPath.style.strokeNoScale = true;
        }
        var liftZ = data.getItemVisual(idx, "liftZ");
        var z2Origin = this._z2;
        if (liftZ != null) {
            if (z2Origin == null) {
                this._z2 = symbolPath.z2;
                symbolPath.z2 += liftZ;
            }
        } else if (z2Origin != null) {
            symbolPath.z2 = z2Origin;
            this._z2 = null;
        }
        var useNameLabel = opts && opts.useNameLabel;
        (0, $6800dfcb6e1e2a44$export$9a13992917966657)(symbolPath, labelStatesModels, {
            labelFetcher: seriesModel,
            labelDataIndex: idx,
            defaultText: getLabelDefaultText,
            inheritColor: visualColor,
            defaultOpacity: symbolStyle.opacity
        });
        // Do not execute util needed.
        function getLabelDefaultText(idx) {
            return useNameLabel ? data.getName(idx) : (0, $b2475f850d3c0bc2$export$5ff20667590927ed)(data, idx);
        }
        this._sizeX = symbolSize[0] / 2;
        this._sizeY = symbolSize[1] / 2;
        var emphasisState = symbolPath.ensureState("emphasis");
        emphasisState.style = emphasisItemStyle;
        symbolPath.ensureState("select").style = selectItemStyle;
        symbolPath.ensureState("blur").style = blurItemStyle;
        // null / undefined / true means to use default strategy.
        // 0 / false / negative number / NaN / Infinity means no scale.
        var scaleRatio = hoverScale == null || hoverScale === true ? Math.max(1.1, 3 / this._sizeY) : isFinite(hoverScale) && hoverScale > 0 ? +hoverScale : 1;
        // always set scale to allow resetting
        emphasisState.scaleX = this._sizeX * scaleRatio;
        emphasisState.scaleY = this._sizeY * scaleRatio;
        this.setSymbolScale(1);
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, focus, blurScope, emphasisDisabled);
    };
    Symbol.prototype.setSymbolScale = function(scale) {
        this.scaleX = this.scaleY = scale;
    };
    Symbol.prototype.fadeOut = function(cb, seriesModel, opt) {
        var symbolPath = this.childAt(0);
        var dataIndex = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(this).dataIndex;
        var animationOpt = opt && opt.animation;
        // Avoid mistaken hover when fading out
        this.silent = symbolPath.silent = true;
        // Not show text when animating
        if (opt && opt.fadeLabel) {
            var textContent = symbolPath.getTextContent();
            if (textContent) $8b353638fbedfefa$export$f883456a56996078(textContent, {
                style: {
                    opacity: 0
                }
            }, seriesModel, {
                dataIndex: dataIndex,
                removeOpt: animationOpt,
                cb: function() {
                    symbolPath.removeTextContent();
                }
            });
        } else symbolPath.removeTextContent();
        $8b353638fbedfefa$export$f883456a56996078(symbolPath, {
            style: {
                opacity: 0
            },
            scaleX: 0,
            scaleY: 0
        }, seriesModel, {
            dataIndex: dataIndex,
            cb: cb,
            removeOpt: animationOpt
        });
    };
    Symbol.getSymbolSize = function(data, idx) {
        return (0, $5370466dadc978d7$export$a84524f03e8e8dfb)(data.getItemVisual(idx, "symbolSize"));
    };
    Symbol.getSymbolZ2 = function(data, idx) {
        return data.getItemVisual(idx, "z2");
    };
    return Symbol;
}($7ef7583d8302ffce$export$2e2bcd8739ae039);
function $b1d9c3e17ccace80$var$driftSymbol(dx, dy) {
    this.parent.drift(dx, dy);
}
var $b1d9c3e17ccace80$export$2e2bcd8739ae039 = $b1d9c3e17ccace80$var$Symbol;




function $fedf62268297fcbb$var$symbolNeedsDraw(data, point, idx, opt) {
    return point && !isNaN(point[0]) && !isNaN(point[1]) && !(opt.isIgnore && opt.isIgnore(idx)) && !(opt.clipShape && !opt.clipShape.contain(point[0], point[1])) && data.getItemVisual(idx, "symbol") !== "none";
}
function $fedf62268297fcbb$var$normalizeUpdateOpt(opt) {
    if (opt != null && !(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(opt)) opt = {
        isIgnore: opt
    };
    return opt || {};
}
function $fedf62268297fcbb$var$makeSeriesScope(data) {
    var seriesModel = data.hostModel;
    var emphasisModel = seriesModel.getModel("emphasis");
    return {
        emphasisItemStyle: emphasisModel.getModel("itemStyle").getItemStyle(),
        blurItemStyle: seriesModel.getModel([
            "blur",
            "itemStyle"
        ]).getItemStyle(),
        selectItemStyle: seriesModel.getModel([
            "select",
            "itemStyle"
        ]).getItemStyle(),
        focus: emphasisModel.get("focus"),
        blurScope: emphasisModel.get("blurScope"),
        emphasisDisabled: emphasisModel.get("disabled"),
        hoverScale: emphasisModel.get("scale"),
        labelStatesModels: (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(seriesModel),
        cursorStyle: seriesModel.get("cursor")
    };
}
var $fedf62268297fcbb$var$SymbolDraw = /** @class */ function() {
    function SymbolDraw(SymbolCtor) {
        this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this._SymbolCtor = SymbolCtor || (0, $b1d9c3e17ccace80$export$2e2bcd8739ae039);
    }
    /**
   * Update symbols draw by new data
   */ SymbolDraw.prototype.updateData = function(data, opt) {
        // Remove progressive els.
        this._progressiveEls = null;
        opt = $fedf62268297fcbb$var$normalizeUpdateOpt(opt);
        var group = this.group;
        var seriesModel = data.hostModel;
        var oldData = this._data;
        var SymbolCtor = this._SymbolCtor;
        var disableAnimation = opt.disableAnimation;
        var seriesScope = $fedf62268297fcbb$var$makeSeriesScope(data);
        var symbolUpdateOpt = {
            disableAnimation: disableAnimation
        };
        var getSymbolPoint = opt.getSymbolPoint || function(idx) {
            return data.getItemLayout(idx);
        };
        // There is no oldLineData only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!oldData) group.removeAll();
        data.diff(oldData).add(function(newIdx) {
            var point = getSymbolPoint(newIdx);
            if ($fedf62268297fcbb$var$symbolNeedsDraw(data, point, newIdx, opt)) {
                var symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
                symbolEl.setPosition(point);
                data.setItemGraphicEl(newIdx, symbolEl);
                group.add(symbolEl);
            }
        }).update(function(newIdx, oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            var point = getSymbolPoint(newIdx);
            if (!$fedf62268297fcbb$var$symbolNeedsDraw(data, point, newIdx, opt)) {
                group.remove(symbolEl);
                return;
            }
            var newSymbolType = data.getItemVisual(newIdx, "symbol") || "circle";
            var oldSymbolType = symbolEl && symbolEl.getSymbolType && symbolEl.getSymbolType();
            if (!symbolEl || oldSymbolType && oldSymbolType !== newSymbolType) {
                group.remove(symbolEl);
                symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
                symbolEl.setPosition(point);
            } else {
                symbolEl.updateData(data, newIdx, seriesScope, symbolUpdateOpt);
                var target = {
                    x: point[0],
                    y: point[1]
                };
                disableAnimation ? symbolEl.attr(target) : $8b353638fbedfefa$export$c8dce3c08436e91e(symbolEl, target, seriesModel);
            }
            // Add back
            group.add(symbolEl);
            data.setItemGraphicEl(newIdx, symbolEl);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && el.fadeOut(function() {
                group.remove(el);
            }, seriesModel);
        }).execute();
        this._getSymbolPoint = getSymbolPoint;
        this._data = data;
    };
    SymbolDraw.prototype.updateLayout = function() {
        var _this = this;
        var data = this._data;
        if (data) // Not use animation
        data.eachItemGraphicEl(function(el, idx) {
            var point = _this._getSymbolPoint(idx);
            el.setPosition(point);
            el.markRedraw();
        });
    };
    SymbolDraw.prototype.incrementalPrepareUpdate = function(data) {
        this._seriesScope = $fedf62268297fcbb$var$makeSeriesScope(data);
        this._data = null;
        this.group.removeAll();
    };
    /**
   * Update symbols draw by new data
   */ SymbolDraw.prototype.incrementalUpdate = function(taskParams, data, opt) {
        // Clear
        this._progressiveEls = [];
        opt = $fedf62268297fcbb$var$normalizeUpdateOpt(opt);
        function updateIncrementalAndHover(el) {
            if (!el.isGroup) {
                el.incremental = true;
                el.ensureState("emphasis").hoverLayer = true;
            }
        }
        for(var idx = taskParams.start; idx < taskParams.end; idx++){
            var point = data.getItemLayout(idx);
            if ($fedf62268297fcbb$var$symbolNeedsDraw(data, point, idx, opt)) {
                var el = new this._SymbolCtor(data, idx, this._seriesScope);
                el.traverse(updateIncrementalAndHover);
                el.setPosition(point);
                this.group.add(el);
                data.setItemGraphicEl(idx, el);
                this._progressiveEls.push(el);
            }
        }
    };
    SymbolDraw.prototype.eachRendered = function(cb) {
        $5b455ae6f843ac47$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    SymbolDraw.prototype.remove = function(enableAnimation) {
        var group = this.group;
        var data = this._data;
        // Incremental model do not have this._data.
        if (data && enableAnimation) data.eachItemGraphicEl(function(el) {
            el.fadeOut(function() {
                group.remove(el);
            }, data.hostModel);
        });
        else group.removeAll();
    };
    return SymbolDraw;
}();
var $fedf62268297fcbb$export$2e2bcd8739ae039 = $fedf62268297fcbb$var$SymbolDraw;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




function $fa583301cd9a2f5a$var$updateRipplePath(rippleGroup, effectCfg) {
    var color = effectCfg.rippleEffectColor || effectCfg.color;
    rippleGroup.eachChild(function(ripplePath) {
        ripplePath.attr({
            z: effectCfg.z,
            zlevel: effectCfg.zlevel,
            style: {
                stroke: effectCfg.brushType === "stroke" ? color : null,
                fill: effectCfg.brushType === "fill" ? color : null
            }
        });
    });
}
var $fa583301cd9a2f5a$var$EffectSymbol = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(EffectSymbol, _super);
    function EffectSymbol(data, idx) {
        var _this = _super.call(this) || this;
        var symbol = new (0, $b1d9c3e17ccace80$export$2e2bcd8739ae039)(data, idx);
        var rippleGroup = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        _this.add(symbol);
        _this.add(rippleGroup);
        _this.updateData(data, idx);
        return _this;
    }
    EffectSymbol.prototype.stopEffectAnimation = function() {
        this.childAt(1).removeAll();
    };
    EffectSymbol.prototype.startEffectAnimation = function(effectCfg) {
        var symbolType = effectCfg.symbolType;
        var color = effectCfg.color;
        var rippleNumber = effectCfg.rippleNumber;
        var rippleGroup = this.childAt(1);
        for(var i = 0; i < rippleNumber; i++){
            // If width/height are set too small (e.g., set to 1) on ios10
            // and macOS Sierra, a circle stroke become a rect, no matter what
            // the scale is set. So we set width/height as 2. See #4136.
            var ripplePath = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symbolType, -1, -1, 2, 2, color);
            ripplePath.attr({
                style: {
                    strokeNoScale: true
                },
                z2: 99,
                silent: true,
                scaleX: 0.5,
                scaleY: 0.5
            });
            var delay = -i / rippleNumber * effectCfg.period + effectCfg.effectOffset;
            ripplePath.animate("", true).when(effectCfg.period, {
                scaleX: effectCfg.rippleScale / 2,
                scaleY: effectCfg.rippleScale / 2
            }).delay(delay).start();
            ripplePath.animateStyle(true).when(effectCfg.period, {
                opacity: 0
            }).delay(delay).start();
            rippleGroup.add(ripplePath);
        }
        $fa583301cd9a2f5a$var$updateRipplePath(rippleGroup, effectCfg);
    };
    /**
   * Update effect symbol
   */ EffectSymbol.prototype.updateEffectAnimation = function(effectCfg) {
        var oldEffectCfg = this._effectCfg;
        var rippleGroup = this.childAt(1);
        // Must reinitialize effect if following configuration changed
        var DIFFICULT_PROPS = [
            "symbolType",
            "period",
            "rippleScale",
            "rippleNumber"
        ];
        for(var i = 0; i < DIFFICULT_PROPS.length; i++){
            var propName = DIFFICULT_PROPS[i];
            if (oldEffectCfg[propName] !== effectCfg[propName]) {
                this.stopEffectAnimation();
                this.startEffectAnimation(effectCfg);
                return;
            }
        }
        $fa583301cd9a2f5a$var$updateRipplePath(rippleGroup, effectCfg);
    };
    /**
   * Highlight symbol
   */ EffectSymbol.prototype.highlight = function() {
        (0, $2bf82c0980125b62$export$b2d02638cc34c042)(this);
    };
    /**
   * Downplay symbol
   */ EffectSymbol.prototype.downplay = function() {
        (0, $2bf82c0980125b62$export$11be6f716239ac55)(this);
    };
    EffectSymbol.prototype.getSymbolType = function() {
        var symbol = this.childAt(0);
        return symbol && symbol.getSymbolType();
    };
    /**
   * Update symbol properties
   */ EffectSymbol.prototype.updateData = function(data, idx) {
        var _this = this;
        var seriesModel = data.hostModel;
        this.childAt(0).updateData(data, idx);
        var rippleGroup = this.childAt(1);
        var itemModel = data.getItemModel(idx);
        var symbolType = data.getItemVisual(idx, "symbol");
        var symbolSize = (0, $5370466dadc978d7$export$a84524f03e8e8dfb)(data.getItemVisual(idx, "symbolSize"));
        var symbolStyle = data.getItemVisual(idx, "style");
        var color = symbolStyle && symbolStyle.fill;
        var emphasisModel = itemModel.getModel("emphasis");
        rippleGroup.setScale(symbolSize);
        rippleGroup.traverse(function(ripplePath) {
            ripplePath.setStyle("fill", color);
        });
        var symbolOffset = (0, $5370466dadc978d7$export$e3e292895c033f6d)(data.getItemVisual(idx, "symbolOffset"), symbolSize);
        if (symbolOffset) {
            rippleGroup.x = symbolOffset[0];
            rippleGroup.y = symbolOffset[1];
        }
        var symbolRotate = data.getItemVisual(idx, "symbolRotate");
        rippleGroup.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
        var effectCfg = {};
        effectCfg.showEffectOn = seriesModel.get("showEffectOn");
        effectCfg.rippleScale = itemModel.get([
            "rippleEffect",
            "scale"
        ]);
        effectCfg.brushType = itemModel.get([
            "rippleEffect",
            "brushType"
        ]);
        effectCfg.period = itemModel.get([
            "rippleEffect",
            "period"
        ]) * 1000;
        effectCfg.effectOffset = idx / data.count();
        effectCfg.z = seriesModel.getShallow("z") || 0;
        effectCfg.zlevel = seriesModel.getShallow("zlevel") || 0;
        effectCfg.symbolType = symbolType;
        effectCfg.color = color;
        effectCfg.rippleEffectColor = itemModel.get([
            "rippleEffect",
            "color"
        ]);
        effectCfg.rippleNumber = itemModel.get([
            "rippleEffect",
            "number"
        ]);
        if (effectCfg.showEffectOn === "render") {
            this._effectCfg ? this.updateEffectAnimation(effectCfg) : this.startEffectAnimation(effectCfg);
            this._effectCfg = effectCfg;
        } else {
            // Not keep old effect config
            this._effectCfg = null;
            this.stopEffectAnimation();
            this.onHoverStateChange = function(toState) {
                if (toState === "emphasis") {
                    if (effectCfg.showEffectOn !== "render") _this.startEffectAnimation(effectCfg);
                } else if (toState === "normal") {
                    if (effectCfg.showEffectOn !== "render") _this.stopEffectAnimation();
                }
            };
        }
        this._effectCfg = effectCfg;
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
    };
    EffectSymbol.prototype.fadeOut = function(cb) {
        cb && cb();
    };
    return EffectSymbol;
}((0, $7ef7583d8302ffce$export$2e2bcd8739ae039));
var $fa583301cd9a2f5a$export$2e2bcd8739ae039 = $fa583301cd9a2f5a$var$EffectSymbol;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



function $73b014aa594ea652$export$2e2bcd8739ae039(seriesType, forceStoreInTypedArray) {
    return {
        seriesType: seriesType,
        plan: (0, $cd70075c57b35175$export$2e2bcd8739ae039)(),
        reset: function(seriesModel) {
            var data = seriesModel.getData();
            var coordSys = seriesModel.coordinateSystem;
            var pipelineContext = seriesModel.pipelineContext;
            var useTypedArray = forceStoreInTypedArray || pipelineContext.large;
            if (!coordSys) return;
            var dims = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(coordSys.dimensions, function(dim) {
                return data.mapDimension(dim);
            }).slice(0, 2);
            var dimLen = dims.length;
            var stackResultDim = data.getCalculationInfo("stackResultDimension");
            if ((0, $efdd976e4917927c$export$1dedc39359ae35c)(data, dims[0])) dims[0] = stackResultDim;
            if ((0, $efdd976e4917927c$export$1dedc39359ae35c)(data, dims[1])) dims[1] = stackResultDim;
            var store = data.getStore();
            var dimIdx0 = data.getDimensionIndex(dims[0]);
            var dimIdx1 = data.getDimensionIndex(dims[1]);
            return dimLen && {
                progress: function(params, data) {
                    var segCount = params.end - params.start;
                    var points = useTypedArray && (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(segCount * dimLen);
                    var tmpIn = [];
                    var tmpOut = [];
                    for(var i = params.start, offset = 0; i < params.end; i++){
                        var point = void 0;
                        if (dimLen === 1) {
                            var x = store.get(dimIdx0, i);
                            // NOTE: Make sure the second parameter is null to use default strategy.
                            point = coordSys.dataToPoint(x, null, tmpOut);
                        } else {
                            tmpIn[0] = store.get(dimIdx0, i);
                            tmpIn[1] = store.get(dimIdx1, i);
                            // Let coordinate system to handle the NaN data.
                            point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                        }
                        if (useTypedArray) {
                            points[offset++] = point[0];
                            points[offset++] = point[1];
                        } else data.setItemLayout(i, point.slice());
                    }
                    useTypedArray && data.setLayout("points", points);
                }
            };
        }
    };
}



var $41934e1dad128ad0$var$EffectScatterView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(EffectScatterView, _super);
    function EffectScatterView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = EffectScatterView.type;
        return _this;
    }
    EffectScatterView.prototype.init = function() {
        this._symbolDraw = new (0, $fedf62268297fcbb$export$2e2bcd8739ae039)((0, $fa583301cd9a2f5a$export$2e2bcd8739ae039));
    };
    EffectScatterView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var effectSymbolDraw = this._symbolDraw;
        effectSymbolDraw.updateData(data, {
            clipShape: this._getClipShape(seriesModel)
        });
        this.group.add(effectSymbolDraw.group);
    };
    EffectScatterView.prototype._getClipShape = function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        var clipArea = coordSys && coordSys.getArea && coordSys.getArea();
        return seriesModel.get("clip", true) ? clipArea : null;
    };
    EffectScatterView.prototype.updateTransform = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        this.group.dirty();
        var res = (0, $73b014aa594ea652$export$2e2bcd8739ae039)("").reset(seriesModel, ecModel, api);
        if (res.progress) res.progress({
            start: 0,
            end: data.count(),
            count: data.count()
        }, data);
        this._symbolDraw.updateLayout();
    };
    EffectScatterView.prototype._updateGroupTransform = function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.getRoamTransform) {
            this.group.transform = $f41ebb9dd60b55b4$export$9cd59f9826255e47(coordSys.getRoamTransform());
            this.group.decomposeTransform();
        }
    };
    EffectScatterView.prototype.remove = function(ecModel, api) {
        this._symbolDraw && this._symbolDraw.remove(true);
    };
    EffectScatterView.type = "effectScatter";
    return EffectScatterView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $41934e1dad128ad0$export$2e2bcd8739ae039 = $41934e1dad128ad0$var$EffectScatterView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $719c2a408bc8b7bb$var$EffectScatterSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(EffectScatterSeriesModel, _super);
    function EffectScatterSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = EffectScatterSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    EffectScatterSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true
        });
    };
    EffectScatterSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        return selectors.point(data.getItemLayout(dataIndex));
    };
    EffectScatterSeriesModel.type = "series.effectScatter";
    EffectScatterSeriesModel.dependencies = [
        "grid",
        "polar"
    ];
    EffectScatterSeriesModel.defaultOption = {
        coordinateSystem: "cartesian2d",
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        effectType: "ripple",
        progressive: 0,
        // When to show the effect, option: 'render'|'emphasis'
        showEffectOn: "render",
        clip: true,
        // Ripple effect config
        rippleEffect: {
            period: 4,
            // Scale of ripple
            scale: 2.5,
            // Brush type can be fill or stroke
            brushType: "fill",
            // Ripple number
            number: 3
        },
        universalTransition: {
            divideShape: "clone"
        },
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // Polar coordinate system
        // polarIndex: 0,
        // Geo coordinate system
        // geoIndex: 0,
        // symbol: null,        // 图形类型
        symbolSize: 10 // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
    };
    return EffectScatterSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $719c2a408bc8b7bb$export$2e2bcd8739ae039 = $719c2a408bc8b7bb$var$EffectScatterSeriesModel;



function $a0fd335cdafe9e6e$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $41934e1dad128ad0$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $719c2a408bc8b7bb$export$2e2bcd8739ae039));
    registers.registerLayout((0, $73b014aa594ea652$export$2e2bcd8739ae039)("effectScatter"));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $f4eb87a228be297f$var$PI2 = Math.PI * 2;
var $f4eb87a228be297f$var$CMD = (0, $20ebe2448f123f2e$export$2e2bcd8739ae039).CMD;
var $f4eb87a228be297f$var$DEFAULT_SEARCH_SPACE = [
    "top",
    "right",
    "bottom",
    "left"
];
function $f4eb87a228be297f$var$getCandidateAnchor(pos, distance, rect, outPt, outDir) {
    var width = rect.width;
    var height = rect.height;
    switch(pos){
        case "top":
            outPt.set(rect.x + width / 2, rect.y - distance);
            outDir.set(0, -1);
            break;
        case "bottom":
            outPt.set(rect.x + width / 2, rect.y + height + distance);
            outDir.set(0, 1);
            break;
        case "left":
            outPt.set(rect.x - distance, rect.y + height / 2);
            outDir.set(-1, 0);
            break;
        case "right":
            outPt.set(rect.x + width + distance, rect.y + height / 2);
            outDir.set(1, 0);
            break;
    }
}
function $f4eb87a228be297f$var$projectPointToArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y, out) {
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    x /= d;
    y /= d;
    // Intersect point.
    var ox = x * r + cx;
    var oy = y * r + cy;
    if (Math.abs(startAngle - endAngle) % $f4eb87a228be297f$var$PI2 < 1e-4) {
        // Is a circle
        out[0] = ox;
        out[1] = oy;
        return d - r;
    }
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(endAngle);
        endAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(tmp);
    } else {
        startAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(startAngle);
        endAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(endAngle);
    }
    if (startAngle > endAngle) endAngle += $f4eb87a228be297f$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $f4eb87a228be297f$var$PI2;
    if (angle >= startAngle && angle <= endAngle || angle + $f4eb87a228be297f$var$PI2 >= startAngle && angle + $f4eb87a228be297f$var$PI2 <= endAngle) {
        // Project point is on the arc.
        out[0] = ox;
        out[1] = oy;
        return d - r;
    }
    var x1 = r * Math.cos(startAngle) + cx;
    var y1 = r * Math.sin(startAngle) + cy;
    var x2 = r * Math.cos(endAngle) + cx;
    var y2 = r * Math.sin(endAngle) + cy;
    var d1 = (x1 - x) * (x1 - x) + (y1 - y) * (y1 - y);
    var d2 = (x2 - x) * (x2 - x) + (y2 - y) * (y2 - y);
    if (d1 < d2) {
        out[0] = x1;
        out[1] = y1;
        return Math.sqrt(d1);
    } else {
        out[0] = x2;
        out[1] = y2;
        return Math.sqrt(d2);
    }
}
function $f4eb87a228be297f$var$projectPointToLine(x1, y1, x2, y2, x, y, out, limitToEnds) {
    var dx = x - x1;
    var dy = y - y1;
    var dx1 = x2 - x1;
    var dy1 = y2 - y1;
    var lineLen = Math.sqrt(dx1 * dx1 + dy1 * dy1);
    dx1 /= lineLen;
    dy1 /= lineLen;
    // dot product
    var projectedLen = dx * dx1 + dy * dy1;
    var t = projectedLen / lineLen;
    if (limitToEnds) t = Math.min(Math.max(t, 0), 1);
    t *= lineLen;
    var ox = out[0] = x1 + t * dx1;
    var oy = out[1] = y1 + t * dy1;
    return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}
function $f4eb87a228be297f$var$projectPointToRect(x1, y1, width, height, x, y, out) {
    if (width < 0) {
        x1 = x1 + width;
        width = -width;
    }
    if (height < 0) {
        y1 = y1 + height;
        height = -height;
    }
    var x2 = x1 + width;
    var y2 = y1 + height;
    var ox = out[0] = Math.min(Math.max(x, x1), x2);
    var oy = out[1] = Math.min(Math.max(y, y1), y2);
    return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}
var $f4eb87a228be297f$var$tmpPt = [];
function $f4eb87a228be297f$var$nearestPointOnRect(pt, rect, out) {
    var dist = $f4eb87a228be297f$var$projectPointToRect(rect.x, rect.y, rect.width, rect.height, pt.x, pt.y, $f4eb87a228be297f$var$tmpPt);
    out.set($f4eb87a228be297f$var$tmpPt[0], $f4eb87a228be297f$var$tmpPt[1]);
    return dist;
}
/**
 * Calculate min distance corresponding point.
 * This method won't evaluate if point is in the path.
 */ function $f4eb87a228be297f$var$nearestPointOnPath(pt, path, out) {
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    var minDist = Infinity;
    var data = path.data;
    var x = pt.x;
    var y = pt.y;
    for(var i = 0; i < data.length;){
        var cmd = data[i++];
        if (i === 1) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        var d = minDist;
        switch(cmd){
            case $f4eb87a228be297f$var$CMD.M:
                // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
                // 在 closePath 的时候使用
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $f4eb87a228be297f$var$CMD.L:
                d = $f4eb87a228be297f$var$projectPointToLine(xi, yi, data[i], data[i + 1], x, y, $f4eb87a228be297f$var$tmpPt, true);
                xi = data[i++];
                yi = data[i++];
                break;
            case $f4eb87a228be297f$var$CMD.C:
                d = (0, $747cfc5611b57cea$export$dbaa3801d1284367)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y, $f4eb87a228be297f$var$tmpPt);
                xi = data[i++];
                yi = data[i++];
                break;
            case $f4eb87a228be297f$var$CMD.Q:
                d = (0, $747cfc5611b57cea$export$81915a594fe10dee)(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y, $f4eb87a228be297f$var$tmpPt);
                xi = data[i++];
                yi = data[i++];
                break;
            case $f4eb87a228be297f$var$CMD.A:
                // TODO Arc 判断的开销比较大
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++];
                // TODO Arc 旋转
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy;
                // 不是直接使用 arc 命令
                if (i <= 1) {
                    // 第一个命令起点还未定义
                    x0 = x1;
                    y0 = y1;
                }
                // zr 使用scale来模拟椭圆, 这里也对x做一定的缩放
                var _x = (x - cx) * ry / rx + cx;
                d = $f4eb87a228be297f$var$projectPointToArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y, $f4eb87a228be297f$var$tmpPt);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $f4eb87a228be297f$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                d = $f4eb87a228be297f$var$projectPointToRect(x0, y0, width, height, x, y, $f4eb87a228be297f$var$tmpPt);
                break;
            case $f4eb87a228be297f$var$CMD.Z:
                d = $f4eb87a228be297f$var$projectPointToLine(xi, yi, x0, y0, x, y, $f4eb87a228be297f$var$tmpPt, true);
                xi = x0;
                yi = y0;
                break;
        }
        if (d < minDist) {
            minDist = d;
            out.set($f4eb87a228be297f$var$tmpPt[0], $f4eb87a228be297f$var$tmpPt[1]);
        }
    }
    return minDist;
}
// Temporal variable for intermediate usage.
var $f4eb87a228be297f$var$pt0 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $f4eb87a228be297f$var$pt1 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $f4eb87a228be297f$var$pt2 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $f4eb87a228be297f$var$dir = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $f4eb87a228be297f$var$dir2 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
function $f4eb87a228be297f$export$cc93ba643cd97d83(target, labelLineModel) {
    if (!target) return;
    var labelLine = target.getTextGuideLine();
    var label = target.getTextContent();
    // Needs to create text guide in each charts.
    if (!(label && labelLine)) return;
    var labelGuideConfig = target.textGuideLineConfig || {};
    var points = [
        [
            0,
            0
        ],
        [
            0,
            0
        ],
        [
            0,
            0
        ]
    ];
    var searchSpace = labelGuideConfig.candidates || $f4eb87a228be297f$var$DEFAULT_SEARCH_SPACE;
    var labelRect = label.getBoundingRect().clone();
    labelRect.applyTransform(label.getComputedTransform());
    var minDist = Infinity;
    var anchorPoint = labelGuideConfig.anchor;
    var targetTransform = target.getComputedTransform();
    var targetInversedTransform = targetTransform && (0, $f41ebb9dd60b55b4$export$6897c284b6f9f4dc)([], targetTransform);
    var len = labelLineModel.get("length2") || 0;
    if (anchorPoint) $f4eb87a228be297f$var$pt2.copy(anchorPoint);
    for(var i = 0; i < searchSpace.length; i++){
        var candidate = searchSpace[i];
        $f4eb87a228be297f$var$getCandidateAnchor(candidate, 0, labelRect, $f4eb87a228be297f$var$pt0, $f4eb87a228be297f$var$dir);
        (0, $b887f038f104fe7e$export$2e2bcd8739ae039).scaleAndAdd($f4eb87a228be297f$var$pt1, $f4eb87a228be297f$var$pt0, $f4eb87a228be297f$var$dir, len);
        // Transform to target coord space.
        $f4eb87a228be297f$var$pt1.transform(targetInversedTransform);
        // Note: getBoundingRect will ensure the `path` being created.
        var boundingRect = target.getBoundingRect();
        var dist = anchorPoint ? anchorPoint.distance($f4eb87a228be297f$var$pt1) : target instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039) ? $f4eb87a228be297f$var$nearestPointOnPath($f4eb87a228be297f$var$pt1, target.path, $f4eb87a228be297f$var$pt2) : $f4eb87a228be297f$var$nearestPointOnRect($f4eb87a228be297f$var$pt1, boundingRect, $f4eb87a228be297f$var$pt2);
        // TODO pt2 is in the path
        if (dist < minDist) {
            minDist = dist;
            // Transform back to global space.
            $f4eb87a228be297f$var$pt1.transform(targetTransform);
            $f4eb87a228be297f$var$pt2.transform(targetTransform);
            $f4eb87a228be297f$var$pt2.toArray(points[0]);
            $f4eb87a228be297f$var$pt1.toArray(points[1]);
            $f4eb87a228be297f$var$pt0.toArray(points[2]);
        }
    }
    $f4eb87a228be297f$export$ac52062003fbe6a(points, labelLineModel.get("minTurnAngle"));
    labelLine.setShape({
        points: points
    });
}
// Temporal variable for the limitTurnAngle function
var $f4eb87a228be297f$var$tmpArr = [];
var $f4eb87a228be297f$var$tmpProjPoint = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
function $f4eb87a228be297f$export$ac52062003fbe6a(linePoints, minTurnAngle) {
    if (!(minTurnAngle <= 180 && minTurnAngle > 0)) return;
    minTurnAngle = minTurnAngle / 180 * Math.PI;
    // The line points can be
    //      /pt1----pt2 (label)
    //     /
    // pt0/
    $f4eb87a228be297f$var$pt0.fromArray(linePoints[0]);
    $f4eb87a228be297f$var$pt1.fromArray(linePoints[1]);
    $f4eb87a228be297f$var$pt2.fromArray(linePoints[2]);
    (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub($f4eb87a228be297f$var$dir, $f4eb87a228be297f$var$pt0, $f4eb87a228be297f$var$pt1);
    (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub($f4eb87a228be297f$var$dir2, $f4eb87a228be297f$var$pt2, $f4eb87a228be297f$var$pt1);
    var len1 = $f4eb87a228be297f$var$dir.len();
    var len2 = $f4eb87a228be297f$var$dir2.len();
    if (len1 < 1e-3 || len2 < 1e-3) return;
    $f4eb87a228be297f$var$dir.scale(1 / len1);
    $f4eb87a228be297f$var$dir2.scale(1 / len2);
    var angleCos = $f4eb87a228be297f$var$dir.dot($f4eb87a228be297f$var$dir2);
    var minTurnAngleCos = Math.cos(minTurnAngle);
    if (minTurnAngleCos < angleCos) {
        // Smaller than minTurnAngle
        // Calculate project point of pt0 on pt1-pt2
        var d = $f4eb87a228be297f$var$projectPointToLine($f4eb87a228be297f$var$pt1.x, $f4eb87a228be297f$var$pt1.y, $f4eb87a228be297f$var$pt2.x, $f4eb87a228be297f$var$pt2.y, $f4eb87a228be297f$var$pt0.x, $f4eb87a228be297f$var$pt0.y, $f4eb87a228be297f$var$tmpArr, false);
        $f4eb87a228be297f$var$tmpProjPoint.fromArray($f4eb87a228be297f$var$tmpArr);
        // Calculate new projected length with limited minTurnAngle and get the new connect point
        $f4eb87a228be297f$var$tmpProjPoint.scaleAndAdd($f4eb87a228be297f$var$dir2, d / Math.tan(Math.PI - minTurnAngle));
        // Limit the new calculated connect point between pt1 and pt2.
        var t = $f4eb87a228be297f$var$pt2.x !== $f4eb87a228be297f$var$pt1.x ? ($f4eb87a228be297f$var$tmpProjPoint.x - $f4eb87a228be297f$var$pt1.x) / ($f4eb87a228be297f$var$pt2.x - $f4eb87a228be297f$var$pt1.x) : ($f4eb87a228be297f$var$tmpProjPoint.y - $f4eb87a228be297f$var$pt1.y) / ($f4eb87a228be297f$var$pt2.y - $f4eb87a228be297f$var$pt1.y);
        if (isNaN(t)) return;
        if (t < 0) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy($f4eb87a228be297f$var$tmpProjPoint, $f4eb87a228be297f$var$pt1);
        else if (t > 1) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy($f4eb87a228be297f$var$tmpProjPoint, $f4eb87a228be297f$var$pt2);
        $f4eb87a228be297f$var$tmpProjPoint.toArray(linePoints[1]);
    }
}
function $f4eb87a228be297f$export$973e1fdb2708f71b(linePoints, surfaceNormal, maxSurfaceAngle) {
    if (!(maxSurfaceAngle <= 180 && maxSurfaceAngle > 0)) return;
    maxSurfaceAngle = maxSurfaceAngle / 180 * Math.PI;
    $f4eb87a228be297f$var$pt0.fromArray(linePoints[0]);
    $f4eb87a228be297f$var$pt1.fromArray(linePoints[1]);
    $f4eb87a228be297f$var$pt2.fromArray(linePoints[2]);
    (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub($f4eb87a228be297f$var$dir, $f4eb87a228be297f$var$pt1, $f4eb87a228be297f$var$pt0);
    (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub($f4eb87a228be297f$var$dir2, $f4eb87a228be297f$var$pt2, $f4eb87a228be297f$var$pt1);
    var len1 = $f4eb87a228be297f$var$dir.len();
    var len2 = $f4eb87a228be297f$var$dir2.len();
    if (len1 < 1e-3 || len2 < 1e-3) return;
    $f4eb87a228be297f$var$dir.scale(1 / len1);
    $f4eb87a228be297f$var$dir2.scale(1 / len2);
    var angleCos = $f4eb87a228be297f$var$dir.dot(surfaceNormal);
    var maxSurfaceAngleCos = Math.cos(maxSurfaceAngle);
    if (angleCos < maxSurfaceAngleCos) {
        // Calculate project point of pt0 on pt1-pt2
        var d = $f4eb87a228be297f$var$projectPointToLine($f4eb87a228be297f$var$pt1.x, $f4eb87a228be297f$var$pt1.y, $f4eb87a228be297f$var$pt2.x, $f4eb87a228be297f$var$pt2.y, $f4eb87a228be297f$var$pt0.x, $f4eb87a228be297f$var$pt0.y, $f4eb87a228be297f$var$tmpArr, false);
        $f4eb87a228be297f$var$tmpProjPoint.fromArray($f4eb87a228be297f$var$tmpArr);
        var HALF_PI = Math.PI / 2;
        var angle2 = Math.acos($f4eb87a228be297f$var$dir2.dot(surfaceNormal));
        var newAngle = HALF_PI + angle2 - maxSurfaceAngle;
        if (newAngle >= HALF_PI) // parallel
        (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy($f4eb87a228be297f$var$tmpProjPoint, $f4eb87a228be297f$var$pt2);
        else {
            // Calculate new projected length with limited minTurnAngle and get the new connect point
            $f4eb87a228be297f$var$tmpProjPoint.scaleAndAdd($f4eb87a228be297f$var$dir2, d / Math.tan(Math.PI / 2 - newAngle));
            // Limit the new calculated connect point between pt1 and pt2.
            var t = $f4eb87a228be297f$var$pt2.x !== $f4eb87a228be297f$var$pt1.x ? ($f4eb87a228be297f$var$tmpProjPoint.x - $f4eb87a228be297f$var$pt1.x) / ($f4eb87a228be297f$var$pt2.x - $f4eb87a228be297f$var$pt1.x) : ($f4eb87a228be297f$var$tmpProjPoint.y - $f4eb87a228be297f$var$pt1.y) / ($f4eb87a228be297f$var$pt2.y - $f4eb87a228be297f$var$pt1.y);
            if (isNaN(t)) return;
            if (t < 0) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy($f4eb87a228be297f$var$tmpProjPoint, $f4eb87a228be297f$var$pt1);
            else if (t > 1) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy($f4eb87a228be297f$var$tmpProjPoint, $f4eb87a228be297f$var$pt2);
        }
        $f4eb87a228be297f$var$tmpProjPoint.toArray(linePoints[1]);
    }
}
function $f4eb87a228be297f$var$setLabelLineState(labelLine, ignore, stateName, stateModel) {
    var isNormal = stateName === "normal";
    var stateObj = isNormal ? labelLine : labelLine.ensureState(stateName);
    // Make sure display.
    stateObj.ignore = ignore;
    // Set smooth
    var smooth = stateModel.get("smooth");
    if (smooth && smooth === true) smooth = 0.3;
    stateObj.shape = stateObj.shape || {};
    if (smooth > 0) stateObj.shape.smooth = smooth;
    var styleObj = stateModel.getModel("lineStyle").getLineStyle();
    isNormal ? labelLine.useStyle(styleObj) : stateObj.style = styleObj;
}
function $f4eb87a228be297f$var$buildLabelLinePath(path, shape) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (!points) return;
    path.moveTo(points[0][0], points[0][1]);
    if (smooth > 0 && points.length >= 3) {
        var len1 = $6de594cf8ac295ff$export$6c4a311cc157c764(points[0], points[1]);
        var len2 = $6de594cf8ac295ff$export$6c4a311cc157c764(points[1], points[2]);
        if (!len1 || !len2) {
            path.lineTo(points[1][0], points[1][1]);
            path.lineTo(points[2][0], points[2][1]);
            return;
        }
        var moveLen = Math.min(len1, len2) * smooth;
        var midPoint0 = $6de594cf8ac295ff$export$3a89f8d6f6bf6c9f([], points[1], points[0], moveLen / len1);
        var midPoint2 = $6de594cf8ac295ff$export$3a89f8d6f6bf6c9f([], points[1], points[2], moveLen / len2);
        var midPoint1 = $6de594cf8ac295ff$export$3a89f8d6f6bf6c9f([], midPoint0, midPoint2, 0.5);
        path.bezierCurveTo(midPoint0[0], midPoint0[1], midPoint0[0], midPoint0[1], midPoint1[0], midPoint1[1]);
        path.bezierCurveTo(midPoint2[0], midPoint2[1], midPoint2[0], midPoint2[1], points[2][0], points[2][1]);
    } else for(var i = 1; i < points.length; i++)path.lineTo(points[i][0], points[i][1]);
}
function $f4eb87a228be297f$export$c09e0b0574bdd2dc(targetEl, statesModels, defaultStyle) {
    var labelLine = targetEl.getTextGuideLine();
    var label = targetEl.getTextContent();
    if (!label) {
        // Not show label line if there is no label.
        if (labelLine) targetEl.removeTextGuideLine();
        return;
    }
    var normalModel = statesModels.normal;
    var showNormal = normalModel.get("show");
    var labelIgnoreNormal = label.ignore;
    for(var i = 0; i < (0, $2bf82c0980125b62$export$57ee5306b85ad7d5).length; i++){
        var stateName = (0, $2bf82c0980125b62$export$57ee5306b85ad7d5)[i];
        var stateModel = statesModels[stateName];
        var isNormal = stateName === "normal";
        if (stateModel) {
            var stateShow = stateModel.get("show");
            var isLabelIgnored = isNormal ? labelIgnoreNormal : (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(label.states[stateName] && label.states[stateName].ignore, labelIgnoreNormal);
            if (isLabelIgnored // Not show when label is not shown in this state.
             || !(0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(stateShow, showNormal) // Use normal state by default if not set.
            ) {
                var stateObj = isNormal ? labelLine : labelLine && labelLine.states[stateName];
                if (stateObj) stateObj.ignore = true;
                if (!!labelLine) $f4eb87a228be297f$var$setLabelLineState(labelLine, true, stateName, stateModel);
                continue;
            }
            // Create labelLine if not exists
            if (!labelLine) {
                labelLine = new (0, $d28119f30e6bb670$export$2e2bcd8739ae039)();
                targetEl.setTextGuideLine(labelLine);
                // Reset state of normal because it's new created.
                // NOTE: NORMAL should always been the first!
                if (!isNormal && (labelIgnoreNormal || !showNormal)) $f4eb87a228be297f$var$setLabelLineState(labelLine, true, "normal", statesModels.normal);
                // Use same state proxy.
                if (targetEl.stateProxy) labelLine.stateProxy = targetEl.stateProxy;
            }
            $f4eb87a228be297f$var$setLabelLineState(labelLine, false, stateName, stateModel);
        }
    }
    if (labelLine) {
        (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(labelLine.style, defaultStyle);
        // Not fill.
        labelLine.style.fill = null;
        var showAbove = normalModel.get("showAbove");
        var labelLineConfig = targetEl.textGuideLineConfig = targetEl.textGuideLineConfig || {};
        labelLineConfig.showAbove = showAbove || false;
        // Custom the buildPath.
        labelLine.buildPath = $f4eb87a228be297f$var$buildLabelLinePath;
    }
}
function $f4eb87a228be297f$export$2979fdbf5ebce521(itemModel, labelLineName) {
    labelLineName = labelLineName || "labelLine";
    var statesModels = {
        normal: itemModel.getModel(labelLineName)
    };
    for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
        var stateName = (0, $2bf82c0980125b62$export$151308dceb52d5b)[i];
        statesModels[stateName] = itemModel.getModel([
            stateName,
            labelLineName
        ]);
    }
    return statesModels;
}




var $a34a81cc5e14c818$var$opacityAccessPath = [
    "itemStyle",
    "opacity"
];
/**
 * Piece of pie including Sector, Label, LabelLine
 */ var $a34a81cc5e14c818$var$FunnelPiece = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(FunnelPiece, _super);
    function FunnelPiece(data, idx) {
        var _this = _super.call(this) || this;
        var polygon = _this;
        var labelLine = new $d28119f30e6bb670$export$2e2bcd8739ae039();
        var text = new $fe885cc21795562b$export$2e2bcd8739ae039();
        polygon.setTextContent(text);
        _this.setTextGuideLine(labelLine);
        _this.updateData(data, idx, true);
        return _this;
    }
    FunnelPiece.prototype.updateData = function(data, idx, firstCreate) {
        var polygon = this;
        var seriesModel = data.hostModel;
        var itemModel = data.getItemModel(idx);
        var layout = data.getItemLayout(idx);
        var emphasisModel = itemModel.getModel("emphasis");
        var opacity = itemModel.get($a34a81cc5e14c818$var$opacityAccessPath);
        opacity = opacity == null ? 1 : opacity;
        if (!firstCreate) (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(polygon);
        // Update common style
        polygon.useStyle(data.getItemVisual(idx, "style"));
        polygon.style.lineJoin = "round";
        if (firstCreate) {
            polygon.setShape({
                points: layout.points
            });
            polygon.style.opacity = 0;
            $8b353638fbedfefa$export$a121566aadcfe021(polygon, {
                style: {
                    opacity: opacity
                }
            }, seriesModel, idx);
        } else $8b353638fbedfefa$export$c8dce3c08436e91e(polygon, {
            style: {
                opacity: opacity
            },
            shape: {
                points: layout.points
            }
        }, seriesModel, idx);
        (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polygon, itemModel);
        this._updateLabel(data, idx);
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
    };
    FunnelPiece.prototype._updateLabel = function(data, idx) {
        var polygon = this;
        var labelLine = this.getTextGuideLine();
        var labelText = polygon.getTextContent();
        var seriesModel = data.hostModel;
        var itemModel = data.getItemModel(idx);
        var layout = data.getItemLayout(idx);
        var labelLayout = layout.label;
        var style = data.getItemVisual(idx, "style");
        var visualColor = style.fill;
        (0, $6800dfcb6e1e2a44$export$9a13992917966657)(// position will not be used in setLabelStyle
        labelText, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
            labelFetcher: data.hostModel,
            labelDataIndex: idx,
            defaultOpacity: style.opacity,
            defaultText: data.getName(idx)
        }, {
            normal: {
                align: labelLayout.textAlign,
                verticalAlign: labelLayout.verticalAlign
            }
        });
        var labelModel = itemModel.getModel("label");
        var labelColor = labelModel.get("color");
        var overrideColor = labelColor === "inherit" ? visualColor : null;
        polygon.setTextConfig({
            local: true,
            inside: !!labelLayout.inside,
            insideStroke: overrideColor,
            outsideFill: overrideColor
        });
        var linePoints = labelLayout.linePoints;
        labelLine.setShape({
            points: linePoints
        });
        polygon.textGuideLineConfig = {
            anchor: linePoints ? new $b887f038f104fe7e$export$2e2bcd8739ae039(linePoints[0][0], linePoints[0][1]) : null
        };
        // Make sure update style on labelText after setLabelStyle.
        // Because setLabelStyle will replace a new style on it.
        $8b353638fbedfefa$export$c8dce3c08436e91e(labelText, {
            style: {
                x: labelLayout.x,
                y: labelLayout.y
            }
        }, seriesModel, idx);
        labelText.attr({
            rotation: labelLayout.rotation,
            originX: labelLayout.x,
            originY: labelLayout.y,
            z2: 10
        });
        (0, $f4eb87a228be297f$export$c09e0b0574bdd2dc)(polygon, (0, $f4eb87a228be297f$export$2979fdbf5ebce521)(itemModel), {
            // Default use item visual color
            stroke: visualColor
        });
    };
    return FunnelPiece;
}($51acf033123e1a30$export$2e2bcd8739ae039);
var $a34a81cc5e14c818$var$FunnelView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(FunnelView, _super);
    function FunnelView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = FunnelView.type;
        _this.ignoreLabelLineUpdate = true;
        return _this;
    }
    FunnelView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var oldData = this._data;
        var group = this.group;
        data.diff(oldData).add(function(idx) {
            var funnelPiece = new $a34a81cc5e14c818$var$FunnelPiece(data, idx);
            data.setItemGraphicEl(idx, funnelPiece);
            group.add(funnelPiece);
        }).update(function(newIdx, oldIdx) {
            var piece = oldData.getItemGraphicEl(oldIdx);
            piece.updateData(data, newIdx);
            group.add(piece);
            data.setItemGraphicEl(newIdx, piece);
        }).remove(function(idx) {
            var piece = oldData.getItemGraphicEl(idx);
            $8b353638fbedfefa$export$6d0fd725cb4aee8a(piece, seriesModel, idx);
        }).execute();
        this._data = data;
    };
    FunnelView.prototype.remove = function() {
        this.group.removeAll();
        this._data = null;
    };
    FunnelView.prototype.dispose = function() {};
    FunnelView.type = "funnel";
    return FunnelView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $a34a81cc5e14c818$export$2e2bcd8739ae039 = $a34a81cc5e14c818$var$FunnelView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $3ac6efc4b95638aa$var$FunnelSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(FunnelSeriesModel, _super);
    function FunnelSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = FunnelSeriesModel.type;
        return _this;
    }
    FunnelSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $cf24728fc17c4ab6$export$2e2bcd8739ae039)($7a1bd9c2710fea0d$export$2385a24977818dd0(this.getData, this), $7a1bd9c2710fea0d$export$2385a24977818dd0(this.getRawData, this));
        // Extend labelLine emphasis
        this._defaultLabelLine(option);
    };
    FunnelSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $7e5c3511527c9907$export$2e2bcd8739ae039)(this, {
            coordDimensions: [
                "value"
            ],
            encodeDefaulter: $7a1bd9c2710fea0d$export$c3095a23b368d1f2((0, $7dc6cdfd7450ef29$export$60b8a57d1f2fed26), this)
        });
    };
    FunnelSeriesModel.prototype._defaultLabelLine = function(option) {
        // Extend labelLine emphasis
        (0, $76d619f648247e6d$export$abdcc6a26372f94b)(option, "labelLine", [
            "show"
        ]);
        var labelLineNormalOpt = option.labelLine;
        var labelLineEmphasisOpt = option.emphasis.labelLine;
        // Not show label line if `label.normal.show = false`
        labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
        labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
    };
    // Overwrite
    FunnelSeriesModel.prototype.getDataParams = function(dataIndex) {
        var data = this.getData();
        var params = _super.prototype.getDataParams.call(this, dataIndex);
        var valueDim = data.mapDimension("value");
        var sum = data.getSum(valueDim);
        // Percent is 0 if sum is 0
        params.percent = !sum ? 0 : +(data.get(valueDim, dataIndex) / sum * 100).toFixed(2);
        params.$vars.push("percent");
        return params;
    };
    FunnelSeriesModel.type = "series.funnel";
    FunnelSeriesModel.defaultOption = {
        coordinateSystemUsage: "box",
        // zlevel: 0,                  // 一级层叠
        z: 2,
        legendHoverLink: true,
        colorBy: "data",
        left: 80,
        top: 60,
        right: 80,
        bottom: 65,
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        // 默认取数据最小最大值
        // min: 0,
        // max: 100,
        minSize: "0%",
        maxSize: "100%",
        sort: "descending",
        orient: "vertical",
        gap: 0,
        funnelAlign: "center",
        label: {
            show: true,
            position: "outer"
        },
        labelLine: {
            show: true,
            length: 20,
            lineStyle: {
                // color: 各异,
                width: 1
            }
        },
        itemStyle: {
            // color: 各异,
            borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral00,
            borderWidth: 1
        },
        emphasis: {
            label: {
                show: true
            }
        },
        select: {
            itemStyle: {
                borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.primary
            }
        }
    };
    return FunnelSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $3ac6efc4b95638aa$export$2e2bcd8739ae039 = $3ac6efc4b95638aa$var$FunnelSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $4e9f9ac9332ed124$var$getSortedIndices(data, sort) {
    var valueDim = data.mapDimension("value");
    var valueArr = data.mapArray(valueDim, function(val) {
        return val;
    });
    var indices = [];
    var isAscending = sort === "ascending";
    for(var i = 0, len = data.count(); i < len; i++)indices[i] = i;
    // Add custom sortable function & none sortable opetion by "options.sort"
    if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(sort)) indices.sort(sort);
    else if (sort !== "none") indices.sort(function(a, b) {
        return isAscending ? valueArr[a] - valueArr[b] : valueArr[b] - valueArr[a];
    });
    return indices;
}
function $4e9f9ac9332ed124$var$labelLayout(data) {
    var seriesModel = data.hostModel;
    var orient = seriesModel.get("orient");
    data.each(function(idx) {
        var itemModel = data.getItemModel(idx);
        var labelModel = itemModel.getModel("label");
        var labelPosition = labelModel.get("position");
        var labelLineModel = itemModel.getModel("labelLine");
        var layout = data.getItemLayout(idx);
        var points = layout.points;
        var isLabelInside = labelPosition === "inner" || labelPosition === "inside" || labelPosition === "center" || labelPosition === "insideLeft" || labelPosition === "insideRight";
        var textAlign;
        var textX;
        var textY;
        var linePoints;
        if (isLabelInside) {
            if (labelPosition === "insideLeft") {
                textX = (points[0][0] + points[3][0]) / 2 + 5;
                textY = (points[0][1] + points[3][1]) / 2;
                textAlign = "left";
            } else if (labelPosition === "insideRight") {
                textX = (points[1][0] + points[2][0]) / 2 - 5;
                textY = (points[1][1] + points[2][1]) / 2;
                textAlign = "right";
            } else {
                textX = (points[0][0] + points[1][0] + points[2][0] + points[3][0]) / 4;
                textY = (points[0][1] + points[1][1] + points[2][1] + points[3][1]) / 4;
                textAlign = "center";
            }
            linePoints = [
                [
                    textX,
                    textY
                ],
                [
                    textX,
                    textY
                ]
            ];
        } else {
            var x1 = void 0;
            var y1 = void 0;
            var x2 = void 0;
            var y2 = void 0;
            var labelLineLen = labelLineModel.get("length");
            if (labelPosition === "left") {
                // Left side
                x1 = (points[3][0] + points[0][0]) / 2;
                y1 = (points[3][1] + points[0][1]) / 2;
                x2 = x1 - labelLineLen;
                textX = x2 - 5;
                textAlign = "right";
            } else if (labelPosition === "right") {
                // Right side
                x1 = (points[1][0] + points[2][0]) / 2;
                y1 = (points[1][1] + points[2][1]) / 2;
                x2 = x1 + labelLineLen;
                textX = x2 + 5;
                textAlign = "left";
            } else if (labelPosition === "top") {
                // Top side
                x1 = (points[3][0] + points[0][0]) / 2;
                y1 = (points[3][1] + points[0][1]) / 2;
                y2 = y1 - labelLineLen;
                textY = y2 - 5;
                textAlign = "center";
            } else if (labelPosition === "bottom") {
                // Bottom side
                x1 = (points[1][0] + points[2][0]) / 2;
                y1 = (points[1][1] + points[2][1]) / 2;
                y2 = y1 + labelLineLen;
                textY = y2 + 5;
                textAlign = "center";
            } else if (labelPosition === "rightTop") {
                // RightTop side
                x1 = orient === "horizontal" ? points[3][0] : points[1][0];
                y1 = orient === "horizontal" ? points[3][1] : points[1][1];
                if (orient === "horizontal") {
                    y2 = y1 - labelLineLen;
                    textY = y2 - 5;
                    textAlign = "center";
                } else {
                    x2 = x1 + labelLineLen;
                    textX = x2 + 5;
                    textAlign = "top";
                }
            } else if (labelPosition === "rightBottom") {
                // RightBottom side
                x1 = points[2][0];
                y1 = points[2][1];
                if (orient === "horizontal") {
                    y2 = y1 + labelLineLen;
                    textY = y2 + 5;
                    textAlign = "center";
                } else {
                    x2 = x1 + labelLineLen;
                    textX = x2 + 5;
                    textAlign = "bottom";
                }
            } else if (labelPosition === "leftTop") {
                // LeftTop side
                x1 = points[0][0];
                y1 = orient === "horizontal" ? points[0][1] : points[1][1];
                if (orient === "horizontal") {
                    y2 = y1 - labelLineLen;
                    textY = y2 - 5;
                    textAlign = "center";
                } else {
                    x2 = x1 - labelLineLen;
                    textX = x2 - 5;
                    textAlign = "right";
                }
            } else if (labelPosition === "leftBottom") {
                // LeftBottom side
                x1 = orient === "horizontal" ? points[1][0] : points[3][0];
                y1 = orient === "horizontal" ? points[1][1] : points[2][1];
                if (orient === "horizontal") {
                    y2 = y1 + labelLineLen;
                    textY = y2 + 5;
                    textAlign = "center";
                } else {
                    x2 = x1 - labelLineLen;
                    textX = x2 - 5;
                    textAlign = "right";
                }
            } else {
                // Right side or Bottom side
                x1 = (points[1][0] + points[2][0]) / 2;
                y1 = (points[1][1] + points[2][1]) / 2;
                if (orient === "horizontal") {
                    y2 = y1 + labelLineLen;
                    textY = y2 + 5;
                    textAlign = "center";
                } else {
                    x2 = x1 + labelLineLen;
                    textX = x2 + 5;
                    textAlign = "left";
                }
            }
            if (orient === "horizontal") {
                x2 = x1;
                textX = x2;
            } else {
                y2 = y1;
                textY = y2;
            }
            linePoints = [
                [
                    x1,
                    y1
                ],
                [
                    x2,
                    y2
                ]
            ];
        }
        layout.label = {
            linePoints: linePoints,
            x: textX,
            y: textY,
            verticalAlign: "middle",
            textAlign: textAlign,
            inside: isLabelInside
        };
    });
}
function $4e9f9ac9332ed124$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType("funnel", function(seriesModel) {
        var data = seriesModel.getData();
        var valueDim = data.mapDimension("value");
        var sort = seriesModel.get("sort");
        var layoutRef = $93b9bc7f22ac7369$export$5aec1e94f566e59f(seriesModel, api);
        var viewRect = $93b9bc7f22ac7369$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), layoutRef.refContainer);
        var orient = seriesModel.get("orient");
        var viewWidth = viewRect.width;
        var viewHeight = viewRect.height;
        var indices = $4e9f9ac9332ed124$var$getSortedIndices(data, sort);
        var x = viewRect.x;
        var y = viewRect.y;
        var sizeExtent = orient === "horizontal" ? [
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("minSize"), viewHeight),
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("maxSize"), viewHeight)
        ] : [
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("minSize"), viewWidth),
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("maxSize"), viewWidth)
        ];
        var dataExtent = data.getDataExtent(valueDim);
        var min = seriesModel.get("min");
        var max = seriesModel.get("max");
        if (min == null) min = Math.min(dataExtent[0], 0);
        if (max == null) max = dataExtent[1];
        var funnelAlign = seriesModel.get("funnelAlign");
        var gap = seriesModel.get("gap");
        var viewSize = orient === "horizontal" ? viewWidth : viewHeight;
        var itemSize = (viewSize - gap * (data.count() - 1)) / data.count();
        var getLinePoints = function(idx, offset) {
            // End point index is data.count() and we assign it 0
            if (orient === "horizontal") {
                var val_1 = data.get(valueDim, idx) || 0;
                var itemHeight = (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(val_1, [
                    min,
                    max
                ], sizeExtent, true);
                var y0 = void 0;
                switch(funnelAlign){
                    case "top":
                        y0 = y;
                        break;
                    case "center":
                        y0 = y + (viewHeight - itemHeight) / 2;
                        break;
                    case "bottom":
                        y0 = y + (viewHeight - itemHeight);
                        break;
                }
                return [
                    [
                        offset,
                        y0
                    ],
                    [
                        offset,
                        y0 + itemHeight
                    ]
                ];
            }
            var val = data.get(valueDim, idx) || 0;
            var itemWidth = (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(val, [
                min,
                max
            ], sizeExtent, true);
            var x0;
            switch(funnelAlign){
                case "left":
                    x0 = x;
                    break;
                case "center":
                    x0 = x + (viewWidth - itemWidth) / 2;
                    break;
                case "right":
                    x0 = x + viewWidth - itemWidth;
                    break;
            }
            return [
                [
                    x0,
                    offset
                ],
                [
                    x0 + itemWidth,
                    offset
                ]
            ];
        };
        if (sort === "ascending") {
            // From bottom to top
            itemSize = -itemSize;
            gap = -gap;
            if (orient === "horizontal") x += viewWidth;
            else y += viewHeight;
            indices = indices.reverse();
        }
        for(var i = 0; i < indices.length; i++){
            var idx = indices[i];
            var nextIdx = indices[i + 1];
            var itemModel = data.getItemModel(idx);
            if (orient === "horizontal") {
                var width = itemModel.get([
                    "itemStyle",
                    "width"
                ]);
                if (width == null) width = itemSize;
                else {
                    width = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(width, viewWidth);
                    if (sort === "ascending") width = -width;
                }
                var start = getLinePoints(idx, x);
                var end = getLinePoints(nextIdx, x + width);
                x += width + gap;
                data.setItemLayout(idx, {
                    points: start.concat(end.slice().reverse())
                });
            } else {
                var height = itemModel.get([
                    "itemStyle",
                    "height"
                ]);
                if (height == null) height = itemSize;
                else {
                    height = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(height, viewHeight);
                    if (sort === "ascending") height = -height;
                }
                var start = getLinePoints(idx, y);
                var end = getLinePoints(nextIdx, y + height);
                y += height + gap;
                data.setItemLayout(idx, {
                    points: start.concat(end.slice().reverse())
                });
            }
        }
        $4e9f9ac9332ed124$var$labelLayout(data);
    });
}



function $2bdc3734cdc2f6c8$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $a34a81cc5e14c818$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $3ac6efc4b95638aa$export$2e2bcd8739ae039));
    registers.registerLayout((0, $4e9f9ac9332ed124$export$2e2bcd8739ae039));
    registers.registerProcessor((0, $e11a533bf70b759c$export$2e2bcd8739ae039)("funnel"));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $ea4af8acc4ea1022$var$PointerShape = /** @class */ function() {
    function PointerShape() {
        this.angle = 0;
        this.width = 10;
        this.r = 10;
        this.x = 0;
        this.y = 0;
    }
    return PointerShape;
}();
var $ea4af8acc4ea1022$var$PointerPath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PointerPath, _super);
    function PointerPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "pointer";
        return _this;
    }
    PointerPath.prototype.getDefaultShape = function() {
        return new $ea4af8acc4ea1022$var$PointerShape();
    };
    PointerPath.prototype.buildPath = function(ctx, shape) {
        var mathCos = Math.cos;
        var mathSin = Math.sin;
        var r = shape.r;
        var width = shape.width;
        var angle = shape.angle;
        var x = shape.x - mathCos(angle) * width * (width >= r / 3 ? 1 : 2);
        var y = shape.y - mathSin(angle) * width * (width >= r / 3 ? 1 : 2);
        angle = shape.angle - Math.PI / 2;
        ctx.moveTo(x, y);
        ctx.lineTo(shape.x + mathCos(angle) * width, shape.y + mathSin(angle) * width);
        ctx.lineTo(shape.x + mathCos(shape.angle) * r, shape.y + mathSin(shape.angle) * r);
        ctx.lineTo(shape.x - mathCos(angle) * width, shape.y - mathSin(angle) * width);
        ctx.lineTo(x, y);
    };
    return PointerPath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
var $ea4af8acc4ea1022$export$2e2bcd8739ae039 = $ea4af8acc4ea1022$var$PointerPath;













function $f677de6b1db15bcf$var$parsePosition(seriesModel, api) {
    var center = seriesModel.get("center");
    var width = api.getWidth();
    var height = api.getHeight();
    var size = Math.min(width, height);
    var cx = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[0], api.getWidth());
    var cy = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[1], api.getHeight());
    var r = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("radius"), size / 2);
    return {
        cx: cx,
        cy: cy,
        r: r
    };
}
function $f677de6b1db15bcf$var$formatLabel(value, labelFormatter) {
    var label = value == null ? "" : value + "";
    if (labelFormatter) {
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(labelFormatter)) label = labelFormatter.replace("{value}", label);
        else if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(labelFormatter)) label = labelFormatter(value);
    }
    return label;
}
var $f677de6b1db15bcf$var$GaugeView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GaugeView, _super);
    function GaugeView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GaugeView.type;
        return _this;
    }
    GaugeView.prototype.render = function(seriesModel, ecModel, api) {
        this.group.removeAll();
        var colorList = seriesModel.get([
            "axisLine",
            "lineStyle",
            "color"
        ]);
        var posInfo = $f677de6b1db15bcf$var$parsePosition(seriesModel, api);
        this._renderMain(seriesModel, ecModel, api, colorList, posInfo);
        this._data = seriesModel.getData();
    };
    GaugeView.prototype.dispose = function() {};
    GaugeView.prototype._renderMain = function(seriesModel, ecModel, api, colorList, posInfo) {
        var group = this.group;
        var clockwise = seriesModel.get("clockwise");
        var startAngle = -seriesModel.get("startAngle") / 180 * Math.PI;
        var endAngle = -seriesModel.get("endAngle") / 180 * Math.PI;
        var axisLineModel = seriesModel.getModel("axisLine");
        var roundCap = axisLineModel.get("roundCap");
        var MainPath = roundCap ? (0, $9674946a7a7df213$export$2e2bcd8739ae039) : $a3e1dec0a3875b49$export$2e2bcd8739ae039;
        var showAxis = axisLineModel.get("show");
        var lineStyleModel = axisLineModel.getModel("lineStyle");
        var axisLineWidth = lineStyleModel.get("width");
        var angles = [
            startAngle,
            endAngle
        ];
        (0, $20ebe2448f123f2e$export$bc668021e937022a)(angles, !clockwise);
        startAngle = angles[0];
        endAngle = angles[1];
        var angleRangeSpan = endAngle - startAngle;
        var prevEndAngle = startAngle;
        var sectors = [];
        for(var i = 0; showAxis && i < colorList.length; i++){
            // Clamp
            var percent = Math.min(Math.max(colorList[i][0], 0), 1);
            endAngle = startAngle + angleRangeSpan * percent;
            var sector = new MainPath({
                shape: {
                    startAngle: prevEndAngle,
                    endAngle: endAngle,
                    cx: posInfo.cx,
                    cy: posInfo.cy,
                    clockwise: clockwise,
                    r0: posInfo.r - axisLineWidth,
                    r: posInfo.r
                },
                silent: true
            });
            sector.setStyle({
                fill: colorList[i][1]
            });
            sector.setStyle(lineStyleModel.getLineStyle(// Because we use sector to simulate arc
            // so the properties for stroking are useless
            [
                "color",
                "width"
            ]));
            sectors.push(sector);
            prevEndAngle = endAngle;
        }
        sectors.reverse();
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(sectors, function(sector) {
            return group.add(sector);
        });
        var getColor = function(percent) {
            // Less than 0
            if (percent <= 0) return colorList[0][1];
            var i;
            for(i = 0; i < colorList.length; i++){
                if (colorList[i][0] >= percent && (i === 0 ? 0 : colorList[i - 1][0]) < percent) return colorList[i][1];
            }
            // More than 1
            return colorList[i - 1][1];
        };
        this._renderTicks(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth);
        this._renderTitleAndDetail(seriesModel, ecModel, api, getColor, posInfo);
        this._renderAnchor(seriesModel, posInfo);
        this._renderPointer(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth);
    };
    GaugeView.prototype._renderTicks = function(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth) {
        var group = this.group;
        var cx = posInfo.cx;
        var cy = posInfo.cy;
        var r = posInfo.r;
        var minVal = +seriesModel.get("min");
        var maxVal = +seriesModel.get("max");
        var splitLineModel = seriesModel.getModel("splitLine");
        var tickModel = seriesModel.getModel("axisTick");
        var labelModel = seriesModel.getModel("axisLabel");
        var splitNumber = seriesModel.get("splitNumber");
        var subSplitNumber = tickModel.get("splitNumber");
        var splitLineLen = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(splitLineModel.get("length"), r);
        var tickLen = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(tickModel.get("length"), r);
        var angle = startAngle;
        var step = (endAngle - startAngle) / splitNumber;
        var subStep = step / subSplitNumber;
        var splitLineStyle = splitLineModel.getModel("lineStyle").getLineStyle();
        var tickLineStyle = tickModel.getModel("lineStyle").getLineStyle();
        var splitLineDistance = splitLineModel.get("distance");
        var unitX;
        var unitY;
        for(var i = 0; i <= splitNumber; i++){
            unitX = Math.cos(angle);
            unitY = Math.sin(angle);
            // Split line
            if (splitLineModel.get("show")) {
                var distance = splitLineDistance ? splitLineDistance + axisLineWidth : axisLineWidth;
                var splitLine = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
                    shape: {
                        x1: unitX * (r - distance) + cx,
                        y1: unitY * (r - distance) + cy,
                        x2: unitX * (r - splitLineLen - distance) + cx,
                        y2: unitY * (r - splitLineLen - distance) + cy
                    },
                    style: splitLineStyle,
                    silent: true
                });
                if (splitLineStyle.stroke === "auto") splitLine.setStyle({
                    stroke: getColor(i / splitNumber)
                });
                group.add(splitLine);
            }
            // Label
            if (labelModel.get("show")) {
                var distance = labelModel.get("distance") + splitLineDistance;
                var label = $f677de6b1db15bcf$var$formatLabel((0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(i / splitNumber * (maxVal - minVal) + minVal), labelModel.get("formatter"));
                var autoColor = getColor(i / splitNumber);
                var textStyleX = unitX * (r - splitLineLen - distance) + cx;
                var textStyleY = unitY * (r - splitLineLen - distance) + cy;
                var rotateType = labelModel.get("rotate");
                var rotate = 0;
                if (rotateType === "radial") {
                    rotate = -angle + 2 * Math.PI;
                    if (rotate > Math.PI / 2) rotate += Math.PI;
                } else if (rotateType === "tangential") rotate = -angle - Math.PI / 2;
                else if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rotateType)) rotate = rotateType * Math.PI / 180;
                if (rotate === 0) group.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
                    style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(labelModel, {
                        text: label,
                        x: textStyleX,
                        y: textStyleY,
                        verticalAlign: unitY < -0.8 ? "top" : unitY > 0.8 ? "bottom" : "middle",
                        align: unitX < -0.4 ? "left" : unitX > 0.4 ? "right" : "center"
                    }, {
                        inheritColor: autoColor
                    }),
                    silent: true
                }));
                else group.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
                    style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(labelModel, {
                        text: label,
                        x: textStyleX,
                        y: textStyleY,
                        verticalAlign: "middle",
                        align: "center"
                    }, {
                        inheritColor: autoColor
                    }),
                    silent: true,
                    originX: textStyleX,
                    originY: textStyleY,
                    rotation: rotate
                }));
            }
            // Axis tick
            if (tickModel.get("show") && i !== splitNumber) {
                var distance = tickModel.get("distance");
                distance = distance ? distance + axisLineWidth : axisLineWidth;
                for(var j = 0; j <= subSplitNumber; j++){
                    unitX = Math.cos(angle);
                    unitY = Math.sin(angle);
                    var tickLine = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
                        shape: {
                            x1: unitX * (r - distance) + cx,
                            y1: unitY * (r - distance) + cy,
                            x2: unitX * (r - tickLen - distance) + cx,
                            y2: unitY * (r - tickLen - distance) + cy
                        },
                        silent: true,
                        style: tickLineStyle
                    });
                    if (tickLineStyle.stroke === "auto") tickLine.setStyle({
                        stroke: getColor((i + j / subSplitNumber) / splitNumber)
                    });
                    group.add(tickLine);
                    angle += subStep;
                }
                angle -= subStep;
            } else angle += step;
        }
    };
    GaugeView.prototype._renderPointer = function(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth) {
        var group = this.group;
        var oldData = this._data;
        var oldProgressData = this._progressEls;
        var progressList = [];
        var showPointer = seriesModel.get([
            "pointer",
            "show"
        ]);
        var progressModel = seriesModel.getModel("progress");
        var showProgress = progressModel.get("show");
        var data = seriesModel.getData();
        var valueDim = data.mapDimension("value");
        var minVal = +seriesModel.get("min");
        var maxVal = +seriesModel.get("max");
        var valueExtent = [
            minVal,
            maxVal
        ];
        var angleExtent = [
            startAngle,
            endAngle
        ];
        function createPointer(idx, angle) {
            var itemModel = data.getItemModel(idx);
            var pointerModel = itemModel.getModel("pointer");
            var pointerWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(pointerModel.get("width"), posInfo.r);
            var pointerLength = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(pointerModel.get("length"), posInfo.r);
            var pointerStr = seriesModel.get([
                "pointer",
                "icon"
            ]);
            var pointerOffset = pointerModel.get("offsetCenter");
            var pointerOffsetX = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(pointerOffset[0], posInfo.r);
            var pointerOffsetY = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(pointerOffset[1], posInfo.r);
            var pointerKeepAspect = pointerModel.get("keepAspect");
            var pointer;
            // not exist icon type will be set 'rect'
            if (pointerStr) pointer = (0, $5370466dadc978d7$export$af050e04da3a02e8)(pointerStr, pointerOffsetX - pointerWidth / 2, pointerOffsetY - pointerLength, pointerWidth, pointerLength, null, pointerKeepAspect);
            else pointer = new (0, $ea4af8acc4ea1022$export$2e2bcd8739ae039)({
                shape: {
                    angle: -Math.PI / 2,
                    width: pointerWidth,
                    r: pointerLength,
                    x: pointerOffsetX,
                    y: pointerOffsetY
                }
            });
            pointer.rotation = -(angle + Math.PI / 2);
            pointer.x = posInfo.cx;
            pointer.y = posInfo.cy;
            return pointer;
        }
        function createProgress(idx, endAngle) {
            var roundCap = progressModel.get("roundCap");
            var ProgressPath = roundCap ? (0, $9674946a7a7df213$export$2e2bcd8739ae039) : $a3e1dec0a3875b49$export$2e2bcd8739ae039;
            var isOverlap = progressModel.get("overlap");
            var progressWidth = isOverlap ? progressModel.get("width") : axisLineWidth / data.count();
            var r0 = isOverlap ? posInfo.r - progressWidth : posInfo.r - (idx + 1) * progressWidth;
            var r = isOverlap ? posInfo.r : posInfo.r - idx * progressWidth;
            var progress = new ProgressPath({
                shape: {
                    startAngle: startAngle,
                    endAngle: endAngle,
                    cx: posInfo.cx,
                    cy: posInfo.cy,
                    clockwise: clockwise,
                    r0: r0,
                    r: r
                }
            });
            isOverlap && (progress.z2 = (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(data.get(valueDim, idx), [
                minVal,
                maxVal
            ], [
                100,
                0
            ], true));
            return progress;
        }
        if (showProgress || showPointer) {
            data.diff(oldData).add(function(idx) {
                var val = data.get(valueDim, idx);
                if (showPointer) {
                    var pointer = createPointer(idx, startAngle);
                    // TODO hide pointer on NaN value?
                    $8b353638fbedfefa$export$a121566aadcfe021(pointer, {
                        rotation: -((isNaN(+val) ? angleExtent[0] : (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(val, valueExtent, angleExtent, true)) + Math.PI / 2)
                    }, seriesModel);
                    group.add(pointer);
                    data.setItemGraphicEl(idx, pointer);
                }
                if (showProgress) {
                    var progress = createProgress(idx, startAngle);
                    var isClip = progressModel.get("clip");
                    $8b353638fbedfefa$export$a121566aadcfe021(progress, {
                        shape: {
                            endAngle: (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(val, valueExtent, angleExtent, isClip)
                        }
                    }, seriesModel);
                    group.add(progress);
                    // Add data index and series index for indexing the data by element
                    // Useful in tooltip
                    (0, $b1983a2fffd47d56$export$30d6736ebb8e18d5)(seriesModel.seriesIndex, data.dataType, idx, progress);
                    progressList[idx] = progress;
                }
            }).update(function(newIdx, oldIdx) {
                var val = data.get(valueDim, newIdx);
                if (showPointer) {
                    var previousPointer = oldData.getItemGraphicEl(oldIdx);
                    var previousRotate = previousPointer ? previousPointer.rotation : startAngle;
                    var pointer = createPointer(newIdx, previousRotate);
                    pointer.rotation = previousRotate;
                    $8b353638fbedfefa$export$c8dce3c08436e91e(pointer, {
                        rotation: -((isNaN(+val) ? angleExtent[0] : (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(val, valueExtent, angleExtent, true)) + Math.PI / 2)
                    }, seriesModel);
                    group.add(pointer);
                    data.setItemGraphicEl(newIdx, pointer);
                }
                if (showProgress) {
                    var previousProgress = oldProgressData[oldIdx];
                    var previousEndAngle = previousProgress ? previousProgress.shape.endAngle : startAngle;
                    var progress = createProgress(newIdx, previousEndAngle);
                    var isClip = progressModel.get("clip");
                    $8b353638fbedfefa$export$c8dce3c08436e91e(progress, {
                        shape: {
                            endAngle: (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(val, valueExtent, angleExtent, isClip)
                        }
                    }, seriesModel);
                    group.add(progress);
                    // Add data index and series index for indexing the data by element
                    // Useful in tooltip
                    (0, $b1983a2fffd47d56$export$30d6736ebb8e18d5)(seriesModel.seriesIndex, data.dataType, newIdx, progress);
                    progressList[newIdx] = progress;
                }
            }).execute();
            data.each(function(idx) {
                var itemModel = data.getItemModel(idx);
                var emphasisModel = itemModel.getModel("emphasis");
                var focus = emphasisModel.get("focus");
                var blurScope = emphasisModel.get("blurScope");
                var emphasisDisabled = emphasisModel.get("disabled");
                if (showPointer) {
                    var pointer = data.getItemGraphicEl(idx);
                    var symbolStyle = data.getItemVisual(idx, "style");
                    var visualColor = symbolStyle.fill;
                    if (pointer instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
                        var pathStyle = pointer.style;
                        pointer.useStyle((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
                            image: pathStyle.image,
                            x: pathStyle.x,
                            y: pathStyle.y,
                            width: pathStyle.width,
                            height: pathStyle.height
                        }, symbolStyle));
                    } else {
                        pointer.useStyle(symbolStyle);
                        pointer.type !== "pointer" && pointer.setColor(visualColor);
                    }
                    pointer.setStyle(itemModel.getModel([
                        "pointer",
                        "itemStyle"
                    ]).getItemStyle());
                    if (pointer.style.fill === "auto") pointer.setStyle("fill", getColor((0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(data.get(valueDim, idx), valueExtent, [
                        0,
                        1
                    ], true)));
                    pointer.z2EmphasisLift = 0;
                    (0, $2bf82c0980125b62$export$48b68047d330bbc9)(pointer, itemModel);
                    (0, $2bf82c0980125b62$export$e51187539ff11209)(pointer, focus, blurScope, emphasisDisabled);
                }
                if (showProgress) {
                    var progress = progressList[idx];
                    progress.useStyle(data.getItemVisual(idx, "style"));
                    progress.setStyle(itemModel.getModel([
                        "progress",
                        "itemStyle"
                    ]).getItemStyle());
                    progress.z2EmphasisLift = 0;
                    (0, $2bf82c0980125b62$export$48b68047d330bbc9)(progress, itemModel);
                    (0, $2bf82c0980125b62$export$e51187539ff11209)(progress, focus, blurScope, emphasisDisabled);
                }
            });
            this._progressEls = progressList;
        }
    };
    GaugeView.prototype._renderAnchor = function(seriesModel, posInfo) {
        var anchorModel = seriesModel.getModel("anchor");
        var showAnchor = anchorModel.get("show");
        if (showAnchor) {
            var anchorSize = anchorModel.get("size");
            var anchorType = anchorModel.get("icon");
            var offsetCenter = anchorModel.get("offsetCenter");
            var anchorKeepAspect = anchorModel.get("keepAspect");
            var anchor = (0, $5370466dadc978d7$export$af050e04da3a02e8)(anchorType, posInfo.cx - anchorSize / 2 + (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(offsetCenter[0], posInfo.r), posInfo.cy - anchorSize / 2 + (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(offsetCenter[1], posInfo.r), anchorSize, anchorSize, null, anchorKeepAspect);
            anchor.z2 = anchorModel.get("showAbove") ? 1 : 0;
            anchor.setStyle(anchorModel.getModel("itemStyle").getItemStyle());
            this.group.add(anchor);
        }
    };
    GaugeView.prototype._renderTitleAndDetail = function(seriesModel, ecModel, api, getColor, posInfo) {
        var _this = this;
        var data = seriesModel.getData();
        var valueDim = data.mapDimension("value");
        var minVal = +seriesModel.get("min");
        var maxVal = +seriesModel.get("max");
        var contentGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        var newTitleEls = [];
        var newDetailEls = [];
        var hasAnimation = seriesModel.isAnimationEnabled();
        var showPointerAbove = seriesModel.get([
            "pointer",
            "showAbove"
        ]);
        data.diff(this._data).add(function(idx) {
            newTitleEls[idx] = new $fe885cc21795562b$export$2e2bcd8739ae039({
                silent: true
            });
            newDetailEls[idx] = new $fe885cc21795562b$export$2e2bcd8739ae039({
                silent: true
            });
        }).update(function(idx, oldIdx) {
            newTitleEls[idx] = _this._titleEls[oldIdx];
            newDetailEls[idx] = _this._detailEls[oldIdx];
        }).execute();
        data.each(function(idx) {
            var itemModel = data.getItemModel(idx);
            var value = data.get(valueDim, idx);
            var itemGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
            var autoColor = getColor((0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(value, [
                minVal,
                maxVal
            ], [
                0,
                1
            ], true));
            var itemTitleModel = itemModel.getModel("title");
            if (itemTitleModel.get("show")) {
                var titleOffsetCenter = itemTitleModel.get("offsetCenter");
                var titleX = posInfo.cx + (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(titleOffsetCenter[0], posInfo.r);
                var titleY = posInfo.cy + (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(titleOffsetCenter[1], posInfo.r);
                var labelEl = newTitleEls[idx];
                labelEl.attr({
                    z2: showPointerAbove ? 0 : 2,
                    style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(itemTitleModel, {
                        x: titleX,
                        y: titleY,
                        text: data.getName(idx),
                        align: "center",
                        verticalAlign: "middle"
                    }, {
                        inheritColor: autoColor
                    })
                });
                itemGroup.add(labelEl);
            }
            var itemDetailModel = itemModel.getModel("detail");
            if (itemDetailModel.get("show")) {
                var detailOffsetCenter = itemDetailModel.get("offsetCenter");
                var detailX = posInfo.cx + (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(detailOffsetCenter[0], posInfo.r);
                var detailY = posInfo.cy + (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(detailOffsetCenter[1], posInfo.r);
                var width = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(itemDetailModel.get("width"), posInfo.r);
                var height = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(itemDetailModel.get("height"), posInfo.r);
                var detailColor = seriesModel.get([
                    "progress",
                    "show"
                ]) ? data.getItemVisual(idx, "style").fill : autoColor;
                var labelEl = newDetailEls[idx];
                var formatter_1 = itemDetailModel.get("formatter");
                labelEl.attr({
                    z2: showPointerAbove ? 0 : 2,
                    style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(itemDetailModel, {
                        x: detailX,
                        y: detailY,
                        text: $f677de6b1db15bcf$var$formatLabel(value, formatter_1),
                        width: isNaN(width) ? null : width,
                        height: isNaN(height) ? null : height,
                        align: "center",
                        verticalAlign: "middle"
                    }, {
                        inheritColor: detailColor
                    })
                });
                (0, $6800dfcb6e1e2a44$export$7bdbceaf9ab378f2)(labelEl, {
                    normal: itemDetailModel
                }, value, function(value) {
                    return $f677de6b1db15bcf$var$formatLabel(value, formatter_1);
                });
                hasAnimation && (0, $6800dfcb6e1e2a44$export$dd6101605f5c186)(labelEl, idx, data, seriesModel, {
                    getFormattedLabel: function(labelDataIndex, status, dataType, labelDimIndex, fmt, extendParams) {
                        return $f677de6b1db15bcf$var$formatLabel(extendParams ? extendParams.interpolatedValue : value, formatter_1);
                    }
                });
                itemGroup.add(labelEl);
            }
            contentGroup.add(itemGroup);
        });
        this.group.add(contentGroup);
        this._titleEls = newTitleEls;
        this._detailEls = newDetailEls;
    };
    GaugeView.type = "gauge";
    return GaugeView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $f677de6b1db15bcf$export$2e2bcd8739ae039 = $f677de6b1db15bcf$var$GaugeView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $059503c83684127e$var$GaugeSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GaugeSeriesModel, _super);
    function GaugeSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GaugeSeriesModel.type;
        _this.visualStyleAccessPath = "itemStyle";
        return _this;
    }
    GaugeSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $7e5c3511527c9907$export$2e2bcd8739ae039)(this, [
            "value"
        ]);
    };
    GaugeSeriesModel.type = "series.gauge";
    GaugeSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        colorBy: "data",
        // 默认全局居中
        center: [
            "50%",
            "50%"
        ],
        legendHoverLink: true,
        radius: "75%",
        startAngle: 225,
        endAngle: -45,
        clockwise: true,
        // 最小值
        min: 0,
        // 最大值
        max: 100,
        // 分割段数，默认为10
        splitNumber: 10,
        // 坐标轴线
        axisLine: {
            // 默认显示，属性show控制显示与否
            show: true,
            roundCap: false,
            lineStyle: {
                color: [
                    [
                        1,
                        (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral10
                    ]
                ],
                width: 10
            }
        },
        // 坐标轴线
        progress: {
            // 默认显示，属性show控制显示与否
            show: false,
            overlap: true,
            width: 10,
            roundCap: false,
            clip: true
        },
        // 分隔线
        splitLine: {
            // 默认显示，属性show控制显示与否
            show: true,
            // 属性length控制线长
            length: 10,
            distance: 10,
            // 属性lineStyle（详见lineStyle）控制线条样式
            lineStyle: {
                color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.axisTick,
                width: 3,
                type: "solid"
            }
        },
        // 坐标轴小标记
        axisTick: {
            // 属性show控制显示与否，默认不显示
            show: true,
            // 每份split细分多少段
            splitNumber: 5,
            // 属性length控制线长
            length: 6,
            distance: 10,
            // 属性lineStyle控制线条样式
            lineStyle: {
                color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.axisTickMinor,
                width: 1,
                type: "solid"
            }
        },
        axisLabel: {
            show: true,
            distance: 15,
            // formatter: null,
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.axisLabel,
            fontSize: 12,
            rotate: 0
        },
        pointer: {
            icon: null,
            offsetCenter: [
                0,
                0
            ],
            show: true,
            showAbove: true,
            length: "60%",
            width: 6,
            keepAspect: false
        },
        anchor: {
            show: false,
            showAbove: false,
            size: 6,
            icon: "circle",
            offsetCenter: [
                0,
                0
            ],
            keepAspect: false,
            itemStyle: {
                color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral00,
                borderWidth: 0,
                borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.theme[0]
            }
        },
        title: {
            show: true,
            // x, y，单位px
            offsetCenter: [
                0,
                "20%"
            ],
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.secondary,
            fontSize: 16,
            valueAnimation: false
        },
        detail: {
            show: true,
            backgroundColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.transparent,
            borderWidth: 0,
            borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral40,
            width: 100,
            height: null,
            padding: [
                5,
                10
            ],
            // x, y，单位px
            offsetCenter: [
                0,
                "40%"
            ],
            // formatter: null,
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.primary,
            fontSize: 30,
            fontWeight: "bold",
            lineHeight: 30,
            valueAnimation: false
        }
    };
    return GaugeSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $059503c83684127e$export$2e2bcd8739ae039 = $059503c83684127e$var$GaugeSeriesModel;


function $bf7cb565bb1d2308$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $f677de6b1db15bcf$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $059503c83684127e$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $23b43ea6be789dc3$export$2e2bcd8739ae039(ecModel) {
    var legendModels = ecModel.findComponents({
        mainType: "legend"
    });
    if (!legendModels || !legendModels.length) return;
    ecModel.eachSeriesByType("graph", function(graphSeries) {
        var categoriesData = graphSeries.getCategoriesData();
        var graph = graphSeries.getGraph();
        var data = graph.data;
        var categoryNames = categoriesData.mapArray(categoriesData.getName);
        data.filterSelf(function(idx) {
            var model = data.getItemModel(idx);
            var category = model.getShallow("category");
            if (category != null) {
                if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(category)) category = categoryNames[category];
                // If in any legend component the status is not selected.
                for(var i = 0; i < legendModels.length; i++){
                    if (!legendModels[i].isSelected(category)) return false;
                }
            }
            return true;
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $2c7d64c9b3613d6b$export$2e2bcd8739ae039(ecModel) {
    var paletteScope = {};
    ecModel.eachSeriesByType("graph", function(seriesModel) {
        var categoriesData = seriesModel.getCategoriesData();
        var data = seriesModel.getData();
        var categoryNameIdxMap = {};
        categoriesData.each(function(idx) {
            var name = categoriesData.getName(idx);
            // Add prefix to avoid conflict with Object.prototype.
            categoryNameIdxMap["ec-" + name] = idx;
            var itemModel = categoriesData.getItemModel(idx);
            var style = itemModel.getModel("itemStyle").getItemStyle();
            if (!style.fill) // Get color from palette.
            style.fill = seriesModel.getColorFromPalette(name, paletteScope);
            categoriesData.setItemVisual(idx, "style", style);
            var symbolVisualList = [
                "symbol",
                "symbolSize",
                "symbolKeepAspect"
            ];
            for(var i = 0; i < symbolVisualList.length; i++){
                var symbolVisual = itemModel.getShallow(symbolVisualList[i], true);
                if (symbolVisual != null) categoriesData.setItemVisual(idx, symbolVisualList[i], symbolVisual);
            }
        });
        // Assign category color to visual
        if (categoriesData.count()) data.each(function(idx) {
            var model = data.getItemModel(idx);
            var categoryIdx = model.getShallow("category");
            if (categoryIdx != null) {
                if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(categoryIdx)) categoryIdx = categoryNameIdxMap["ec-" + categoryIdx];
                var categoryStyle = categoriesData.getItemVisual(categoryIdx, "style");
                var style = data.ensureUniqueItemVisual(idx, "style");
                (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(style, categoryStyle);
                var visualList = [
                    "symbol",
                    "symbolSize",
                    "symbolKeepAspect"
                ];
                for(var i = 0; i < visualList.length; i++)data.setItemVisual(idx, visualList[i], categoriesData.getItemVisual(categoryIdx, visualList[i]));
            }
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $11ee0a103a25747c$var$normalize(a) {
    if (!(a instanceof Array)) a = [
        a,
        a
    ];
    return a;
}
function $11ee0a103a25747c$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType("graph", function(seriesModel) {
        var graph = seriesModel.getGraph();
        var edgeData = seriesModel.getEdgeData();
        var symbolType = $11ee0a103a25747c$var$normalize(seriesModel.get("edgeSymbol"));
        var symbolSize = $11ee0a103a25747c$var$normalize(seriesModel.get("edgeSymbolSize"));
        // const colorQuery = ['lineStyle', 'color'] as const;
        // const opacityQuery = ['lineStyle', 'opacity'] as const;
        edgeData.setVisual("fromSymbol", symbolType && symbolType[0]);
        edgeData.setVisual("toSymbol", symbolType && symbolType[1]);
        edgeData.setVisual("fromSymbolSize", symbolSize && symbolSize[0]);
        edgeData.setVisual("toSymbolSize", symbolSize && symbolSize[1]);
        edgeData.setVisual("style", seriesModel.getModel("lineStyle").getLineStyle());
        edgeData.each(function(idx) {
            var itemModel = edgeData.getItemModel(idx);
            var edge = graph.getEdgeByIndex(idx);
            var symbolType = $11ee0a103a25747c$var$normalize(itemModel.getShallow("symbol", true));
            var symbolSize = $11ee0a103a25747c$var$normalize(itemModel.getShallow("symbolSize", true));
            // Edge visual must after node visual
            var style = itemModel.getModel("lineStyle").getLineStyle();
            var existsStyle = edgeData.ensureUniqueItemVisual(idx, "style");
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(existsStyle, style);
            switch(existsStyle.stroke){
                case "source":
                    var nodeStyle = edge.node1.getVisual("style");
                    existsStyle.stroke = nodeStyle && nodeStyle.fill;
                    break;
                case "target":
                    var nodeStyle = edge.node2.getVisual("style");
                    existsStyle.stroke = nodeStyle && nodeStyle.fill;
                    break;
            }
            symbolType[0] && edge.setVisual("fromSymbol", symbolType[0]);
            symbolType[1] && edge.setVisual("toSymbol", symbolType[1]);
            symbolSize[0] && edge.setVisual("fromSymbolSize", symbolSize[0]);
            symbolSize[1] && edge.setVisual("toSymbolSize", symbolSize[1]);
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck

var $0425a00d02ade69a$var$KEY_DELIMITER = "-->";
/**
 * params handler
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @returns {*}
 */ var $0425a00d02ade69a$var$getAutoCurvenessParams = function(seriesModel) {
    return seriesModel.get("autoCurveness") || null;
};
/**
 * Generate a list of edge curvatures, 20 is the default
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @param {number} appendLength
 * @return  20 => [0, -0.2, 0.2, -0.4, 0.4, -0.6, 0.6, -0.8, 0.8, -1, 1, -1.2, 1.2, -1.4, 1.4, -1.6, 1.6, -1.8, 1.8, -2]
 */ var $0425a00d02ade69a$var$createCurveness = function(seriesModel, appendLength) {
    var autoCurvenessParmas = $0425a00d02ade69a$var$getAutoCurvenessParams(seriesModel);
    var length = 20;
    var curvenessList = [];
    // handler the function set
    if ($7a1bd9c2710fea0d$export$7e4aa119212bc614(autoCurvenessParmas)) length = autoCurvenessParmas;
    else if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(autoCurvenessParmas)) {
        seriesModel.__curvenessList = autoCurvenessParmas;
        return;
    }
    // append length
    if (appendLength > length) length = appendLength;
    // make sure the length is even
    var len = length % 2 ? length + 2 : length + 3;
    curvenessList = [];
    for(var i = 0; i < len; i++)curvenessList.push((i % 2 ? i + 1 : i) / 10 * (i % 2 ? -1 : 1));
    seriesModel.__curvenessList = curvenessList;
};
/**
 * Create different cache key data in the positive and negative directions, in order to set the curvature later
 * @param {number|string|module:echarts/data/Graph.Node} n1
 * @param {number|string|module:echarts/data/Graph.Node} n2
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @returns {string} key
 */ var $0425a00d02ade69a$var$getKeyOfEdges = function(n1, n2, seriesModel) {
    var source = [
        n1.id,
        n1.dataIndex
    ].join(".");
    var target = [
        n2.id,
        n2.dataIndex
    ].join(".");
    return [
        seriesModel.uid,
        source,
        target
    ].join($0425a00d02ade69a$var$KEY_DELIMITER);
};
/**
 * get opposite key
 * @param {string} key
 * @returns {string}
 */ var $0425a00d02ade69a$var$getOppositeKey = function(key) {
    var keys = key.split($0425a00d02ade69a$var$KEY_DELIMITER);
    return [
        keys[0],
        keys[2],
        keys[1]
    ].join($0425a00d02ade69a$var$KEY_DELIMITER);
};
/**
 * get edgeMap with key
 * @param edge
 * @param {module:echarts/model/SeriesModel} seriesModel
 */ var $0425a00d02ade69a$var$getEdgeFromMap = function(edge, seriesModel) {
    var key = $0425a00d02ade69a$var$getKeyOfEdges(edge.node1, edge.node2, seriesModel);
    return seriesModel.__edgeMap[key];
};
/**
 * calculate all cases total length
 * @param edge
 * @param seriesModel
 * @returns {number}
 */ var $0425a00d02ade69a$var$getTotalLengthBetweenNodes = function(edge, seriesModel) {
    var len = $0425a00d02ade69a$var$getEdgeMapLengthWithKey($0425a00d02ade69a$var$getKeyOfEdges(edge.node1, edge.node2, seriesModel), seriesModel);
    var lenV = $0425a00d02ade69a$var$getEdgeMapLengthWithKey($0425a00d02ade69a$var$getKeyOfEdges(edge.node2, edge.node1, seriesModel), seriesModel);
    return len + lenV;
};
/**
 *
 * @param key
 */ var $0425a00d02ade69a$var$getEdgeMapLengthWithKey = function(key, seriesModel) {
    var edgeMap = seriesModel.__edgeMap;
    return edgeMap[key] ? edgeMap[key].length : 0;
};
function $0425a00d02ade69a$export$4f05389c1f2934b8(seriesModel) {
    if (!$0425a00d02ade69a$var$getAutoCurvenessParams(seriesModel)) return;
    seriesModel.__curvenessList = [];
    seriesModel.__edgeMap = {};
    // calc the array of curveness List
    $0425a00d02ade69a$var$createCurveness(seriesModel);
}
function $0425a00d02ade69a$export$c47b549eed9a7311(n1, n2, seriesModel, index) {
    if (!$0425a00d02ade69a$var$getAutoCurvenessParams(seriesModel)) return;
    var key = $0425a00d02ade69a$var$getKeyOfEdges(n1, n2, seriesModel);
    var edgeMap = seriesModel.__edgeMap;
    var oppositeEdges = edgeMap[$0425a00d02ade69a$var$getOppositeKey(key)];
    // set direction
    if (edgeMap[key] && !oppositeEdges) edgeMap[key].isForward = true;
    else if (oppositeEdges && edgeMap[key]) {
        oppositeEdges.isForward = true;
        edgeMap[key].isForward = false;
    }
    edgeMap[key] = edgeMap[key] || [];
    edgeMap[key].push(index);
}
function $0425a00d02ade69a$export$7e88123f7f1f62da(edge, seriesModel, index, needReverse) {
    var autoCurvenessParams = $0425a00d02ade69a$var$getAutoCurvenessParams(seriesModel);
    var isArrayParam = $7a1bd9c2710fea0d$export$43bee75e5e14138e(autoCurvenessParams);
    if (!autoCurvenessParams) return null;
    var edgeArray = $0425a00d02ade69a$var$getEdgeFromMap(edge, seriesModel);
    if (!edgeArray) return null;
    var edgeIndex = -1;
    for(var i = 0; i < edgeArray.length; i++)if (edgeArray[i] === index) {
        edgeIndex = i;
        break;
    }
    // if totalLen is Longer createCurveness
    var totalLen = $0425a00d02ade69a$var$getTotalLengthBetweenNodes(edge, seriesModel);
    $0425a00d02ade69a$var$createCurveness(seriesModel, totalLen);
    edge.lineStyle = edge.lineStyle || {};
    // if is opposite edge, must set curvenss to opposite number
    var curKey = $0425a00d02ade69a$var$getKeyOfEdges(edge.node1, edge.node2, seriesModel);
    var curvenessList = seriesModel.__curvenessList;
    // if pass array no need parity
    var parityCorrection = isArrayParam ? 0 : totalLen % 2 ? 0 : 1;
    if (!edgeArray.isForward) {
        // the opposite edge show outside
        var oppositeKey = $0425a00d02ade69a$var$getOppositeKey(curKey);
        var len = $0425a00d02ade69a$var$getEdgeMapLengthWithKey(oppositeKey, seriesModel);
        var resValue = curvenessList[edgeIndex + len + parityCorrection];
        // isNeedReverse, simple, force type need reverse the curveness in the junction of the forword and the opposite
        if (needReverse) {
            // set as array may make the parity handle with the len of opposite
            if (isArrayParam) {
                if (autoCurvenessParams && autoCurvenessParams[0] === 0) return (len + parityCorrection) % 2 ? resValue : -resValue;
                else return ((len % 2 ? 0 : 1) + parityCorrection) % 2 ? resValue : -resValue;
            } else return (len + parityCorrection) % 2 ? resValue : -resValue;
        } else return curvenessList[edgeIndex + len + parityCorrection];
    } else return curvenessList[parityCorrection + edgeIndex];
}


function $159cad03c3625d06$export$6d7efb25f4dcb4db(seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    if (coordSys && coordSys.type !== "view") return;
    var graph = seriesModel.getGraph();
    graph.eachNode(function(node) {
        var model = node.getModel();
        node.setLayout([
            +model.get("x"),
            +model.get("y")
        ]);
    });
    $159cad03c3625d06$export$a25b52345bee32aa(graph, seriesModel);
}
function $159cad03c3625d06$export$a25b52345bee32aa(graph, seriesModel) {
    graph.eachEdge(function(edge, index) {
        var curveness = $7a1bd9c2710fea0d$export$2e94551289abb95b(edge.getModel().get([
            "lineStyle",
            "curveness"
        ]), -(0, $0425a00d02ade69a$export$7e88123f7f1f62da)(edge, seriesModel, index, true), 0);
        var p1 = $6de594cf8ac295ff$export$9cd59f9826255e47(edge.node1.getLayout());
        var p2 = $6de594cf8ac295ff$export$9cd59f9826255e47(edge.node2.getLayout());
        var points = [
            p1,
            p2
        ];
        if (+curveness) points.push([
            (p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * curveness,
            (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * curveness
        ]);
        edge.setLayout(points);
    });
}


function $35717df2daa24f5d$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType("graph", function(seriesModel) {
        var layout = seriesModel.get("layout");
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.type !== "view") {
            var data_1 = seriesModel.getData();
            var dimensions_1 = [];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordSys.dimensions, function(coordDim) {
                dimensions_1 = dimensions_1.concat(data_1.mapDimensionsAll(coordDim));
            });
            for(var dataIndex = 0; dataIndex < data_1.count(); dataIndex++){
                var value = [];
                var hasValue = false;
                for(var i = 0; i < dimensions_1.length; i++){
                    var val = data_1.get(dimensions_1[i], dataIndex);
                    if (!isNaN(val)) hasValue = true;
                    value.push(val);
                }
                if (hasValue) data_1.setItemLayout(dataIndex, coordSys.dataToPoint(value));
                else // Also {Array.<number>}, not undefined to avoid if...else... statement
                data_1.setItemLayout(dataIndex, [
                    NaN,
                    NaN
                ]);
            }
            (0, $159cad03c3625d06$export$a25b52345bee32aa)(data_1.graph, seriesModel);
        } else if (!layout || layout === "none") (0, $159cad03c3625d06$export$6d7efb25f4dcb4db)(seriesModel);
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $ad8b4f94f577d55a$export$e2aa0fb9ed198ba7(seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    if (coordSys.type !== "view") return 1;
    var nodeScaleRatio = seriesModel.option.nodeScaleRatio;
    var groupZoom = coordSys.scaleX;
    // Scale node when zoom changes
    var roamZoom = coordSys.getZoom();
    var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
    return nodeScale / groupZoom;
}
function $ad8b4f94f577d55a$export$8d4a06d3facd414b(node) {
    var symbolSize = node.getVisual("symbolSize");
    if (symbolSize instanceof Array) symbolSize = (symbolSize[0] + symbolSize[1]) / 2;
    return +symbolSize;
}




var $484ee97adf82b508$var$PI = Math.PI;
var $484ee97adf82b508$var$_symbolRadiansHalf = [];
function $484ee97adf82b508$export$cbfed6ae5cab3dae(seriesModel, basedOn, draggingNode, pointer) {
    var coordSys = seriesModel.coordinateSystem;
    if (coordSys && coordSys.type !== "view") return;
    var rect = coordSys.getBoundingRect();
    var nodeData = seriesModel.getData();
    var graph = nodeData.graph;
    var cx = rect.width / 2 + rect.x;
    var cy = rect.height / 2 + rect.y;
    var r = Math.min(rect.width, rect.height) / 2;
    var count = nodeData.count();
    nodeData.setLayout({
        cx: cx,
        cy: cy
    });
    if (!count) return;
    if (draggingNode) {
        var _a = coordSys.pointToData(pointer), tempX = _a[0], tempY = _a[1];
        var v = [
            tempX - cx,
            tempY - cy
        ];
        $6de594cf8ac295ff$export$a3295358bff77e(v, v);
        $6de594cf8ac295ff$export$dcdf75081b88279d(v, v, r);
        draggingNode.setLayout([
            cx + v[0],
            cy + v[1]
        ], true);
        var circularRotateLabel = seriesModel.get([
            "circular",
            "rotateLabel"
        ]);
        $484ee97adf82b508$export$c768377a6a0a9ab8(draggingNode, circularRotateLabel, cx, cy);
    }
    $484ee97adf82b508$var$_layoutNodesBasedOn[basedOn](seriesModel, graph, nodeData, r, cx, cy, count);
    graph.eachEdge(function(edge, index) {
        var curveness = $7a1bd9c2710fea0d$export$2e94551289abb95b(edge.getModel().get([
            "lineStyle",
            "curveness"
        ]), (0, $0425a00d02ade69a$export$7e88123f7f1f62da)(edge, seriesModel, index), 0);
        var p1 = $6de594cf8ac295ff$export$9cd59f9826255e47(edge.node1.getLayout());
        var p2 = $6de594cf8ac295ff$export$9cd59f9826255e47(edge.node2.getLayout());
        var cp1;
        var x12 = (p1[0] + p2[0]) / 2;
        var y12 = (p1[1] + p2[1]) / 2;
        if (+curveness) {
            curveness *= 3;
            cp1 = [
                cx * curveness + x12 * (1 - curveness),
                cy * curveness + y12 * (1 - curveness)
            ];
        }
        edge.setLayout([
            p1,
            p2,
            cp1
        ]);
    });
}
var $484ee97adf82b508$var$_layoutNodesBasedOn = {
    value: function(seriesModel, graph, nodeData, r, cx, cy, count) {
        var angle = 0;
        var sum = nodeData.getSum("value");
        var unitAngle = Math.PI * 2 / (sum || count);
        graph.eachNode(function(node) {
            var value = node.getValue("value");
            var radianHalf = unitAngle * (sum ? value : 1) / 2;
            angle += radianHalf;
            node.setLayout([
                r * Math.cos(angle) + cx,
                r * Math.sin(angle) + cy
            ]);
            angle += radianHalf;
        });
    },
    symbolSize: function(seriesModel, graph, nodeData, r, cx, cy, count) {
        var sumRadian = 0;
        $484ee97adf82b508$var$_symbolRadiansHalf.length = count;
        var nodeScale = (0, $ad8b4f94f577d55a$export$e2aa0fb9ed198ba7)(seriesModel);
        graph.eachNode(function(node) {
            var symbolSize = (0, $ad8b4f94f577d55a$export$8d4a06d3facd414b)(node);
            // Normally this case will not happen, but we still add
            // some the defensive code (2px is an arbitrary value).
            isNaN(symbolSize) && (symbolSize = 2);
            symbolSize < 0 && (symbolSize = 0);
            symbolSize *= nodeScale;
            var symbolRadianHalf = Math.asin(symbolSize / 2 / r);
            // when `symbolSize / 2` is bigger than `r`.
            isNaN(symbolRadianHalf) && (symbolRadianHalf = $484ee97adf82b508$var$PI / 2);
            $484ee97adf82b508$var$_symbolRadiansHalf[node.dataIndex] = symbolRadianHalf;
            sumRadian += symbolRadianHalf * 2;
        });
        var halfRemainRadian = (2 * $484ee97adf82b508$var$PI - sumRadian) / count / 2;
        var angle = 0;
        graph.eachNode(function(node) {
            var radianHalf = halfRemainRadian + $484ee97adf82b508$var$_symbolRadiansHalf[node.dataIndex];
            angle += radianHalf;
            // init circular layout for
            // 1. layout undefined node
            // 2. not fixed node
            (!node.getLayout() || !node.getLayout().fixed) && node.setLayout([
                r * Math.cos(angle) + cx,
                r * Math.sin(angle) + cy
            ]);
            angle += radianHalf;
        });
    }
};
function $484ee97adf82b508$export$c768377a6a0a9ab8(node, circularRotateLabel, cx, cy) {
    var el = node.getGraphicEl();
    // need to check if el exists. '-' value may not create node element.
    if (!el) return;
    var nodeModel = node.getModel();
    var labelRotate = nodeModel.get([
        "label",
        "rotate"
    ]) || 0;
    var symbolPath = el.getSymbolPath();
    if (circularRotateLabel) {
        var pos = node.getLayout();
        var rad = Math.atan2(pos[1] - cy, pos[0] - cx);
        if (rad < 0) rad = Math.PI * 2 + rad;
        var isLeft = pos[0] < cx;
        if (isLeft) rad = rad - Math.PI;
        var textPosition = isLeft ? "left" : "right";
        symbolPath.setTextConfig({
            rotation: -rad,
            position: textPosition,
            origin: "center"
        });
        var emphasisState = symbolPath.ensureState("emphasis");
        $7a1bd9c2710fea0d$export$8b58be045bf06082(emphasisState.textConfig || (emphasisState.textConfig = {}), {
            position: textPosition
        });
    } else symbolPath.setTextConfig({
        rotation: labelRotate *= Math.PI / 180
    });
}


function $3c017b875f1b19fb$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType("graph", function(seriesModel) {
        if (seriesModel.get("layout") === "circular") (0, $484ee97adf82b508$export$cbfed6ae5cab3dae)(seriesModel, "symbolSize");
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embedded for some of the code in this file:
* Some formulas were originally copied from "d3.js" with some
* modifications made for this project.
* (See more details in the comment of the method "step" below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ 
var $b2cd6170c8983d43$var$scaleAndAdd = $6de594cf8ac295ff$export$19cedf1da84ba854;
function $b2cd6170c8983d43$export$100e93b4853dcbde(inNodes, inEdges, opts) {
    var nodes = inNodes;
    var edges = inEdges;
    var rect = opts.rect;
    var width = rect.width;
    var height = rect.height;
    var center = [
        rect.x + width / 2,
        rect.y + height / 2
    ];
    // let scale = opts.scale || 1;
    var gravity = opts.gravity == null ? 0.1 : opts.gravity;
    // for (let i = 0; i < edges.length; i++) {
    //     let e = edges[i];
    //     let n1 = e.n1;
    //     let n2 = e.n2;
    //     n1.edges = n1.edges || [];
    //     n2.edges = n2.edges || [];
    //     n1.edges.push(e);
    //     n2.edges.push(e);
    // }
    // Init position
    for(var i = 0; i < nodes.length; i++){
        var n = nodes[i];
        if (!n.p) n.p = $6de594cf8ac295ff$export$185802fd694ee1f5(width * (Math.random() - 0.5) + center[0], height * (Math.random() - 0.5) + center[1]);
        n.pp = $6de594cf8ac295ff$export$9cd59f9826255e47(n.p);
        n.edges = null;
    }
    // Formula in 'Graph Drawing by Force-directed Placement'
    // let k = scale * Math.sqrt(width * height / nodes.length);
    // let k2 = k * k;
    var initialFriction = opts.friction == null ? 0.6 : opts.friction;
    var friction = initialFriction;
    var beforeStepCallback;
    var afterStepCallback;
    return {
        warmUp: function() {
            friction = initialFriction * 0.8;
        },
        setFixed: function(idx) {
            nodes[idx].fixed = true;
        },
        setUnfixed: function(idx) {
            nodes[idx].fixed = false;
        },
        /**
     * Before step hook
     */ beforeStep: function(cb) {
            beforeStepCallback = cb;
        },
        /**
     * After step hook
     */ afterStep: function(cb) {
            afterStepCallback = cb;
        },
        /**
     * Some formulas were originally copied from "d3.js"
     * https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/layout/force.js
     * with some modifications made for this project.
     * See the license statement at the head of this file.
     */ step: function(cb) {
            beforeStepCallback && beforeStepCallback(nodes, edges);
            var v12 = [];
            var nLen = nodes.length;
            for(var i = 0; i < edges.length; i++){
                var e = edges[i];
                if (e.ignoreForceLayout) continue;
                var n1 = e.n1;
                var n2 = e.n2;
                $6de594cf8ac295ff$export$f93b5905241a7cca(v12, n2.p, n1.p);
                var d = $6de594cf8ac295ff$export$fc1400facf92c78(v12) - e.d;
                var w = n2.w / (n1.w + n2.w);
                if (isNaN(w)) w = 0;
                $6de594cf8ac295ff$export$a3295358bff77e(v12, v12);
                !n1.fixed && $b2cd6170c8983d43$var$scaleAndAdd(n1.p, n1.p, v12, w * d * friction);
                !n2.fixed && $b2cd6170c8983d43$var$scaleAndAdd(n2.p, n2.p, v12, -(1 - w) * d * friction);
            }
            // Gravity
            for(var i = 0; i < nLen; i++){
                var n = nodes[i];
                if (!n.fixed) {
                    $6de594cf8ac295ff$export$f93b5905241a7cca(v12, center, n.p);
                    // let d = vec2.len(v12);
                    // vec2.scale(v12, v12, 1 / d);
                    // let gravityFactor = gravity;
                    $b2cd6170c8983d43$var$scaleAndAdd(n.p, n.p, v12, gravity * friction);
                }
            }
            // Repulsive
            // PENDING
            for(var i = 0; i < nLen; i++){
                var n1 = nodes[i];
                for(var j = i + 1; j < nLen; j++){
                    var n2 = nodes[j];
                    $6de594cf8ac295ff$export$f93b5905241a7cca(v12, n2.p, n1.p);
                    var d = $6de594cf8ac295ff$export$fc1400facf92c78(v12);
                    if (d === 0) {
                        // Random repulse
                        $6de594cf8ac295ff$export$adaa4cf7ef1b65be(v12, Math.random() - 0.5, Math.random() - 0.5);
                        d = 1;
                    }
                    var repFact = (n1.rep + n2.rep) / d / d;
                    !n1.fixed && $b2cd6170c8983d43$var$scaleAndAdd(n1.pp, n1.pp, v12, repFact);
                    !n2.fixed && $b2cd6170c8983d43$var$scaleAndAdd(n2.pp, n2.pp, v12, -repFact);
                }
            }
            var v = [];
            for(var i = 0; i < nLen; i++){
                var n = nodes[i];
                if (!n.fixed) {
                    $6de594cf8ac295ff$export$f93b5905241a7cca(v, n.p, n.pp);
                    $b2cd6170c8983d43$var$scaleAndAdd(n.p, n.p, v, friction);
                    $6de594cf8ac295ff$export$784d13d8ee351f07(n.pp, n.p);
                }
            }
            friction = friction * 0.992;
            var finished = friction < 0.01;
            afterStepCallback && afterStepCallback(nodes, edges, finished);
            cb && cb(finished);
        }
    };
}








function $cd6209901c0041df$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType("graph", function(graphSeries) {
        var coordSys = graphSeries.coordinateSystem;
        if (coordSys && coordSys.type !== "view") return;
        if (graphSeries.get("layout") === "force") {
            var preservedPoints_1 = graphSeries.preservedPoints || {};
            var graph_1 = graphSeries.getGraph();
            var nodeData_1 = graph_1.data;
            var edgeData = graph_1.edgeData;
            var forceModel = graphSeries.getModel("force");
            var initLayout = forceModel.get("initLayout");
            if (graphSeries.preservedPoints) nodeData_1.each(function(idx) {
                var id = nodeData_1.getId(idx);
                nodeData_1.setItemLayout(idx, preservedPoints_1[id] || [
                    NaN,
                    NaN
                ]);
            });
            else if (!initLayout || initLayout === "none") (0, $159cad03c3625d06$export$6d7efb25f4dcb4db)(graphSeries);
            else if (initLayout === "circular") (0, $484ee97adf82b508$export$cbfed6ae5cab3dae)(graphSeries, "value");
            var nodeDataExtent_1 = nodeData_1.getDataExtent("value");
            var edgeDataExtent_1 = edgeData.getDataExtent("value");
            // let edgeDataExtent = edgeData.getDataExtent('value');
            var repulsion = forceModel.get("repulsion");
            var edgeLength = forceModel.get("edgeLength");
            var repulsionArr_1 = $7a1bd9c2710fea0d$export$43bee75e5e14138e(repulsion) ? repulsion : [
                repulsion,
                repulsion
            ];
            var edgeLengthArr_1 = $7a1bd9c2710fea0d$export$43bee75e5e14138e(edgeLength) ? edgeLength : [
                edgeLength,
                edgeLength
            ];
            // Larger value has smaller length
            edgeLengthArr_1 = [
                edgeLengthArr_1[1],
                edgeLengthArr_1[0]
            ];
            var nodes_1 = nodeData_1.mapArray("value", function(value, idx) {
                var point = nodeData_1.getItemLayout(idx);
                var rep = (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(value, nodeDataExtent_1, repulsionArr_1);
                if (isNaN(rep)) rep = (repulsionArr_1[0] + repulsionArr_1[1]) / 2;
                return {
                    w: rep,
                    rep: rep,
                    fixed: nodeData_1.getItemModel(idx).get("fixed"),
                    p: !point || isNaN(point[0]) || isNaN(point[1]) ? null : point
                };
            });
            var edges = edgeData.mapArray("value", function(value, idx) {
                var edge = graph_1.getEdgeByIndex(idx);
                var d = (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(value, edgeDataExtent_1, edgeLengthArr_1);
                if (isNaN(d)) d = (edgeLengthArr_1[0] + edgeLengthArr_1[1]) / 2;
                var edgeModel = edge.getModel();
                var curveness = $7a1bd9c2710fea0d$export$2e94551289abb95b(edge.getModel().get([
                    "lineStyle",
                    "curveness"
                ]), -(0, $0425a00d02ade69a$export$7e88123f7f1f62da)(edge, graphSeries, idx, true), 0);
                return {
                    n1: nodes_1[edge.node1.dataIndex],
                    n2: nodes_1[edge.node2.dataIndex],
                    d: d,
                    curveness: curveness,
                    ignoreForceLayout: edgeModel.get("ignoreForceLayout")
                };
            });
            // let coordSys = graphSeries.coordinateSystem;
            var rect = coordSys.getBoundingRect();
            var forceInstance = (0, $b2cd6170c8983d43$export$100e93b4853dcbde)(nodes_1, edges, {
                rect: rect,
                gravity: forceModel.get("gravity"),
                friction: forceModel.get("friction")
            });
            forceInstance.beforeStep(function(nodes, edges) {
                for(var i = 0, l = nodes.length; i < l; i++)if (nodes[i].fixed) // Write back to layout instance
                $6de594cf8ac295ff$export$784d13d8ee351f07(nodes[i].p, graph_1.getNodeByIndex(i).getLayout());
            });
            forceInstance.afterStep(function(nodes, edges, stopped) {
                for(var i = 0, l = nodes.length; i < l; i++){
                    if (!nodes[i].fixed) graph_1.getNodeByIndex(i).setLayout(nodes[i].p);
                    preservedPoints_1[nodeData_1.getId(i)] = nodes[i].p;
                }
                for(var i = 0, l = edges.length; i < l; i++){
                    var e = edges[i];
                    var edge = graph_1.getEdgeByIndex(i);
                    var p1 = e.n1.p;
                    var p2 = e.n2.p;
                    var points = edge.getLayout();
                    points = points ? points.slice() : [];
                    points[0] = points[0] || [];
                    points[1] = points[1] || [];
                    $6de594cf8ac295ff$export$784d13d8ee351f07(points[0], p1);
                    $6de594cf8ac295ff$export$784d13d8ee351f07(points[1], p2);
                    if (+e.curveness) points[2] = [
                        (p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * e.curveness,
                        (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * e.curveness
                    ];
                    edge.setLayout(points);
                }
            });
            graphSeries.forceLayout = forceInstance;
            graphSeries.preservedPoints = preservedPoints_1;
            // Step to get the layout
            forceInstance.step();
        } else // Remove prev injected forceLayout instance
        graphSeries.forceLayout = null;
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // FIXME Where to create the simple view coordinate system
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $35fd859fd545c4be$export$1e6abcd98caba733(controllerHost, dx, dy) {
    var target = controllerHost.target;
    target.x += dx;
    target.y += dy;
    target.dirty();
}
function $35fd859fd545c4be$export$29b3c66d30a4866(controllerHost, zoomDelta, zoomX, zoomY) {
    var target = controllerHost.target;
    var zoomLimit = controllerHost.zoomLimit;
    var newZoom = controllerHost.zoom = controllerHost.zoom || 1;
    newZoom *= zoomDelta;
    newZoom = $35fd859fd545c4be$export$8b6a36ab62a3dea0(newZoom, zoomLimit);
    var zoomScale = newZoom / controllerHost.zoom;
    controllerHost.zoom = newZoom;
    $35fd859fd545c4be$var$zoomTransformableByOrigin(target, zoomX, zoomY, zoomScale);
    target.dirty();
}
function $35fd859fd545c4be$export$805408382b623838(seriesModel, api, pointerCheckerEl, controller, controllerHost, clipRect) {
    var tmpRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
    controller.enable(seriesModel.get("roam"), {
        api: api,
        zInfo: {
            component: seriesModel
        },
        triggerInfo: {
            roamTrigger: seriesModel.get("roamTrigger"),
            isInSelf: function(e, x, y) {
                tmpRect.copy(pointerCheckerEl.getBoundingRect());
                tmpRect.applyTransform(pointerCheckerEl.getComputedTransform());
                return tmpRect.contain(x, y);
            },
            isInClip: function(e, x, y) {
                return !clipRect || clipRect.contain(x, y);
            }
        }
    });
    controllerHost.zoomLimit = seriesModel.get("scaleLimit");
    var coordinate = seriesModel.coordinateSystem;
    controllerHost.zoom = coordinate ? coordinate.getZoom() : 1;
    var type = seriesModel.subType + "Roam";
    controller.off("pan").off("zoom").on("pan", function(e) {
        $35fd859fd545c4be$export$1e6abcd98caba733(controllerHost, e.dx, e.dy);
        api.dispatchAction({
            seriesId: seriesModel.id,
            type: type,
            dx: e.dx,
            dy: e.dy
        });
    }).on("zoom", function(e) {
        /**
     * FIXME: should do nothing except `api.dispatchAction` here, the other logic
     *  should be performed in the action handler and `updateTransform`; otherwise,
     *  they are inconsistent if user triggers this action explicitly.
     */ $35fd859fd545c4be$export$29b3c66d30a4866(controllerHost, e.scale, e.originX, e.originY);
        api.dispatchAction({
            seriesId: seriesModel.id,
            type: type,
            zoom: e.scale,
            originX: e.originX,
            originY: e.originY
        });
        // Only update label layout on zoom
        api.updateLabelLayout();
    });
}
function $35fd859fd545c4be$var$getCenterCoord(view, point) {
    // Use projected coord as center because it's linear.
    return view.pointToProjected ? view.pointToProjected(point) : view.pointToData(point);
}
function $35fd859fd545c4be$export$94d6a16eae2c4cf4(view, payload, zoomLimit) {
    var previousZoom = view.getZoom();
    var center = view.getCenter();
    var deltaZoom = payload.zoom;
    var point = view.projectedToPoint ? view.projectedToPoint(center) : view.dataToPoint(center);
    if (payload.dx != null && payload.dy != null) {
        point[0] -= payload.dx;
        point[1] -= payload.dy;
        view.setCenter($35fd859fd545c4be$var$getCenterCoord(view, point));
    }
    if (deltaZoom != null) {
        deltaZoom = $35fd859fd545c4be$export$8b6a36ab62a3dea0(previousZoom * deltaZoom, zoomLimit) / previousZoom;
        $35fd859fd545c4be$var$zoomTransformableByOrigin(view, payload.originX, payload.originY, deltaZoom);
        view.updateTransform();
        // [NOTICE] Tricky: `getCetnerCoord` uses `this.invTransform` modified by the `updateTransform` above.
        view.setCenter($35fd859fd545c4be$var$getCenterCoord(view, point));
        view.setZoom(deltaZoom * previousZoom);
    }
    return {
        center: view.getCenter(),
        zoom: view.getZoom()
    };
}
function $35fd859fd545c4be$var$zoomTransformableByOrigin(target, originX, originY, deltaZoom) {
    // Keep the mouse center when scaling.
    target.x -= (originX - target.x) * (deltaZoom - 1);
    target.y -= (originY - target.y) * (deltaZoom - 1);
    target.scaleX *= deltaZoom;
    target.scaleY *= deltaZoom;
}
function $35fd859fd545c4be$export$8b6a36ab62a3dea0(zoom, zoomLimit) {
    if (zoomLimit) {
        var zoomMin = zoomLimit.min || 0;
        var zoomMax = zoomLimit.max || Infinity;
        zoom = Math.max(Math.min(zoomMax, zoom), zoomMin);
    }
    return zoom;
}


var $4a92e7570d47c1fe$var$v2ApplyTransform = $6de594cf8ac295ff$export$9f9dcb98c894b623;
var $4a92e7570d47c1fe$var$View = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(View, _super);
    function View(name, opt) {
        var _this = _super.call(this) || this;
        _this.type = "view";
        _this.dimensions = [
            "x",
            "y"
        ];
        /**
     * Represents the transform brought by roam/zoom.
     * If `View['_viewRect']` applies roam transform,
     * we can get the final displayed rect.
     */ _this._roamTransformable = new (0, $becf2d727f9cf450$export$2e2bcd8739ae039)();
        /**
     * Represents the transform from `View['_rect']` to `View['_viewRect']`.
     */ _this._rawTransformable = new (0, $becf2d727f9cf450$export$2e2bcd8739ae039)();
        _this.name = name;
        _this._opt = opt;
        return _this;
    }
    View.prototype.setBoundingRect = function(x, y, width, height) {
        this._rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height);
        this._updateCenterAndZoom();
        return this._rect;
    };
    View.prototype.getBoundingRect = function() {
        return this._rect;
    };
    /**
   * If no need to transform `View['_rect']` to `View['_viewRect']`, the calling of
   * `setViewRect` can be omitted.
   */ View.prototype.setViewRect = function(x, y, width, height) {
        this._transformTo(x, y, width, height);
        this._viewRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height);
    };
    /**
   * Transformed to particular position and size
   */ View.prototype._transformTo = function(x, y, width, height) {
        var rect = this.getBoundingRect();
        var rawTransform = this._rawTransformable;
        rawTransform.transform = rect.calculateTransform(new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height));
        var rawParent = rawTransform.parent;
        rawTransform.parent = null;
        rawTransform.decomposeTransform();
        rawTransform.parent = rawParent;
        this._updateTransform();
    };
    /**
   * [NOTICE]
   *  The definition of this center has always been irrelevant to some other series center like
   *  'series-pie.center' - this center is a point on the same coord sys as `View['_rect'].x/y`,
   *  rather than canvas viewport, and the unit is not necessarily pixel (e.g., in geo case).
   *  @see {View['_center']} for details.
   */ View.prototype.setCenter = function(centerCoord) {
        // #16904 introcuded percentage string here, such as '33%'. But it was based on canvas
        // width/height, which is not reasonable - the unit may incorrect, and it is unpredictable if
        // the `View['_rect']` is not calculated based on the current canvas rect. Therefore the percentage
        // value is changed to based on `View['_rect'].width/height` since v6. Under this definition, users
        // can use '0%' to map the top-left of `View['_rect']` to the center of `View['_viewRect']`.
        var opt = this._opt;
        if (opt && opt.api && opt.ecModel && opt.ecModel.getShallow("legacyViewCoordSysCenterBase") && centerCoord) centerCoord = [
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(centerCoord[0], opt.api.getWidth()),
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(centerCoord[1], opt.api.getWidth())
        ];
        this._centerOption = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(centerCoord);
        this._updateCenterAndZoom();
    };
    View.prototype.setZoom = function(zoom) {
        this._zoom = (0, $35fd859fd545c4be$export$8b6a36ab62a3dea0)(zoom || 1, this.zoomLimit);
        this._updateCenterAndZoom();
    };
    /**
   * Get default center without roam
   */ View.prototype.getDefaultCenter = function() {
        // Rect before any transform
        var rawRect = this.getBoundingRect();
        var cx = rawRect.x + rawRect.width / 2;
        var cy = rawRect.y + rawRect.height / 2;
        return [
            cx,
            cy
        ];
    };
    View.prototype.getCenter = function() {
        return this._center || this.getDefaultCenter();
    };
    View.prototype.getZoom = function() {
        return this._zoom || 1;
    };
    View.prototype.getRoamTransform = function() {
        return this._roamTransformable.getLocalTransform();
    };
    /**
   * Ensure this method is idempotent, since it should be called when
   * every relevant prop (e.g. _centerOption/_zoom/_rect/_viewRect) changed.
   */ View.prototype._updateCenterAndZoom = function() {
        var centerOption = this._centerOption;
        var rect = this._rect;
        if (centerOption && rect) this._center = [
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(centerOption[0], rect.width, rect.x),
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(centerOption[1], rect.height, rect.y)
        ];
        // Must update after view transform updated
        var rawTransformMatrix = this._rawTransformable.getLocalTransform();
        var roamTransform = this._roamTransformable;
        var defaultCenter = this.getDefaultCenter();
        var center = this.getCenter();
        var zoom = this.getZoom();
        center = $6de594cf8ac295ff$export$9f9dcb98c894b623([], center, rawTransformMatrix);
        defaultCenter = $6de594cf8ac295ff$export$9f9dcb98c894b623([], defaultCenter, rawTransformMatrix);
        roamTransform.originX = center[0];
        roamTransform.originY = center[1];
        roamTransform.x = defaultCenter[0] - center[0];
        roamTransform.y = defaultCenter[1] - center[1];
        roamTransform.scaleX = roamTransform.scaleY = zoom;
        this._updateTransform();
    };
    /**
   * Update transform props on `this` based on the current
   * `this._roamTransformable` and `this._rawTransformable`.
   */ View.prototype._updateTransform = function() {
        var roamTransformable = this._roamTransformable;
        var rawTransformable = this._rawTransformable;
        rawTransformable.parent = roamTransformable;
        roamTransformable.updateTransform();
        rawTransformable.updateTransform();
        $f41ebb9dd60b55b4$export$784d13d8ee351f07(this.transform || (this.transform = []), rawTransformable.transform || $f41ebb9dd60b55b4$export$185802fd694ee1f5());
        this._rawTransform = rawTransformable.getLocalTransform();
        this.invTransform = this.invTransform || [];
        $f41ebb9dd60b55b4$export$6897c284b6f9f4dc(this.invTransform, this.transform);
        this.decomposeTransform();
    };
    View.prototype.getTransformInfo = function() {
        var rawTransformable = this._rawTransformable;
        var roamTransformable = this._roamTransformable;
        // Because roamTransformabel has `originX/originY` modified,
        // but the caller of `getTransformInfo` can not handle `originX/originY`,
        // so need to recalculate them.
        var dummyTransformable = new (0, $becf2d727f9cf450$export$2e2bcd8739ae039)();
        dummyTransformable.transform = roamTransformable.transform;
        dummyTransformable.decomposeTransform();
        return {
            roam: {
                x: dummyTransformable.x,
                y: dummyTransformable.y,
                scaleX: dummyTransformable.scaleX,
                scaleY: dummyTransformable.scaleY
            },
            raw: {
                x: rawTransformable.x,
                y: rawTransformable.y,
                scaleX: rawTransformable.scaleX,
                scaleY: rawTransformable.scaleY
            }
        };
    };
    View.prototype.getViewRect = function() {
        return this._viewRect;
    };
    /**
   * Get view rect after roam transform
   */ View.prototype.getViewRectAfterRoam = function() {
        var rect = this.getBoundingRect().clone();
        rect.applyTransform(this.transform);
        return rect;
    };
    /**
   * Convert a single (lon, lat) data item to (x, y) point.
   */ View.prototype.dataToPoint = function(data, noRoam, out) {
        var transform = noRoam ? this._rawTransform : this.transform;
        out = out || [];
        return transform ? $4a92e7570d47c1fe$var$v2ApplyTransform(out, data, transform) : $6de594cf8ac295ff$export$784d13d8ee351f07(out, data);
    };
    /**
   * Convert a (x, y) point to (lon, lat) data
   */ View.prototype.pointToData = function(point, reserved, out) {
        out = out || [];
        var invTransform = this.invTransform;
        return invTransform ? $4a92e7570d47c1fe$var$v2ApplyTransform(out, point, invTransform) : (out[0] = point[0], out[1] = point[1], out);
    };
    View.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $4a92e7570d47c1fe$var$getCoordSys(finder);
        return coordSys === this ? coordSys.dataToPoint(value) : null;
    };
    View.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $4a92e7570d47c1fe$var$getCoordSys(finder);
        return coordSys === this ? coordSys.pointToData(pixel) : null;
    };
    /**
   * @implements
   */ View.prototype.containPoint = function(point) {
        return this.getViewRectAfterRoam().contain(point[0], point[1]);
    };
    View.dimensions = [
        "x",
        "y"
    ];
    return View;
}((0, $becf2d727f9cf450$export$2e2bcd8739ae039));
function $4a92e7570d47c1fe$var$getCoordSys(finder) {
    var seriesModel = finder.seriesModel;
    return seriesModel ? seriesModel.coordinateSystem : null; // e.g., graph.
}
var $4a92e7570d47c1fe$export$2e2bcd8739ae039 = $4a92e7570d47c1fe$var$View;






function $8491beaca48712b9$var$getViewRect(seriesModel, api, aspect) {
    var layoutRef = (0, $93b9bc7f22ac7369$export$5aec1e94f566e59f)(seriesModel, api);
    var option = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(seriesModel.getBoxLayoutParams(), {
        aspect: aspect
    });
    var viewRect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(option, layoutRef.refContainer);
    return (0, $93b9bc7f22ac7369$export$9fec79e40d579ea7)(seriesModel, viewRect, aspect);
}
function $8491beaca48712b9$export$2e2bcd8739ae039(ecModel, api) {
    var viewList = [];
    ecModel.eachSeriesByType("graph", function(seriesModel) {
        (0, $70c3ede7d3b64757$export$7ed0c09d4f5c932e)({
            targetModel: seriesModel,
            coordSysType: "view",
            coordSysProvider: createViewCoordSys,
            isDefaultDataCoordSys: true
        });
        function createViewCoordSys() {
            var data = seriesModel.getData();
            var positions = data.mapArray(function(idx) {
                var itemModel = data.getItemModel(idx);
                return [
                    +itemModel.get("x"),
                    +itemModel.get("y")
                ];
            });
            var min = [];
            var max = [];
            $af3aab2435198f82$export$188c3cd07b4129dd(positions, min, max);
            // If width or height is 0
            if (max[0] - min[0] === 0) {
                max[0] += 1;
                min[0] -= 1;
            }
            if (max[1] - min[1] === 0) {
                max[1] += 1;
                min[1] -= 1;
            }
            var aspect = (max[0] - min[0]) / (max[1] - min[1]);
            // FIXME If get view rect after data processed?
            var viewRect = $8491beaca48712b9$var$getViewRect(seriesModel, api, aspect);
            // Position may be NaN, use view rect instead
            if (isNaN(aspect)) {
                min = [
                    viewRect.x,
                    viewRect.y
                ];
                max = [
                    viewRect.x + viewRect.width,
                    viewRect.y + viewRect.height
                ];
            }
            var bbWidth = max[0] - min[0];
            var bbHeight = max[1] - min[1];
            var viewCoordSys = new (0, $4a92e7570d47c1fe$export$2e2bcd8739ae039)(null, {
                api: api,
                ecModel: ecModel
            });
            viewCoordSys.zoomLimit = seriesModel.get("scaleLimit");
            viewCoordSys.setBoundingRect(min[0], min[1], bbWidth, bbHeight);
            viewCoordSys.setViewRect(viewRect.x, viewRect.y, viewRect.width, viewRect.height);
            // Update roam info
            viewCoordSys.setCenter(seriesModel.get("center"));
            viewCoordSys.setZoom(seriesModel.get("zoom"));
            viewList.push(viewCoordSys);
            return viewCoordSys;
        }
    });
    return viewList;
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $ab7bf64951ce094b$var$straightLineProto = $7a316ae5ceff7b27$export$2e2bcd8739ae039.prototype;
var $ab7bf64951ce094b$var$bezierCurveProto = $6c7800c49630e431$export$2e2bcd8739ae039.prototype;
var $ab7bf64951ce094b$var$StraightLineShape = /** @class */ function() {
    function StraightLineShape() {
        // Start point
        this.x1 = 0;
        this.y1 = 0;
        // End point
        this.x2 = 0;
        this.y2 = 0;
        this.percent = 1;
    }
    return StraightLineShape;
}();
var $ab7bf64951ce094b$var$CurveShape = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CurveShape, _super);
    function CurveShape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CurveShape;
}($ab7bf64951ce094b$var$StraightLineShape);
function $ab7bf64951ce094b$var$isStraightLine(shape) {
    return isNaN(+shape.cpx1) || isNaN(+shape.cpy1);
}
var $ab7bf64951ce094b$var$ECLinePath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ECLinePath, _super);
    function ECLinePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "ec-line";
        return _this;
    }
    ECLinePath.prototype.getDefaultStyle = function() {
        return {
            stroke: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral99,
            fill: null
        };
    };
    ECLinePath.prototype.getDefaultShape = function() {
        return new $ab7bf64951ce094b$var$StraightLineShape();
    };
    ECLinePath.prototype.buildPath = function(ctx, shape) {
        if ($ab7bf64951ce094b$var$isStraightLine(shape)) $ab7bf64951ce094b$var$straightLineProto.buildPath.call(this, ctx, shape);
        else $ab7bf64951ce094b$var$bezierCurveProto.buildPath.call(this, ctx, shape);
    };
    ECLinePath.prototype.pointAt = function(t) {
        if ($ab7bf64951ce094b$var$isStraightLine(this.shape)) return $ab7bf64951ce094b$var$straightLineProto.pointAt.call(this, t);
        else return $ab7bf64951ce094b$var$bezierCurveProto.pointAt.call(this, t);
    };
    ECLinePath.prototype.tangentAt = function(t) {
        var shape = this.shape;
        var p = $ab7bf64951ce094b$var$isStraightLine(shape) ? [
            shape.x2 - shape.x1,
            shape.y2 - shape.y1
        ] : $ab7bf64951ce094b$var$bezierCurveProto.tangentAt.call(this, t);
        return $6de594cf8ac295ff$export$a3295358bff77e(p, p);
    };
    return ECLinePath;
}($b02ffe7acd508c08$export$2e2bcd8739ae039);
var $ab7bf64951ce094b$export$2e2bcd8739ae039 = $ab7bf64951ce094b$var$ECLinePath;







var $9e0b5f801ab5090c$var$SYMBOL_CATEGORIES = [
    "fromSymbol",
    "toSymbol"
];
function $9e0b5f801ab5090c$var$makeSymbolTypeKey(symbolCategory) {
    return "_" + symbolCategory + "Type";
}
function $9e0b5f801ab5090c$var$makeSymbolTypeValue(name, lineData, idx) {
    var symbolType = lineData.getItemVisual(idx, name);
    if (!symbolType || symbolType === "none") return symbolType;
    var symbolSize = lineData.getItemVisual(idx, name + "Size");
    var symbolRotate = lineData.getItemVisual(idx, name + "Rotate");
    var symbolOffset = lineData.getItemVisual(idx, name + "Offset");
    var symbolKeepAspect = lineData.getItemVisual(idx, name + "KeepAspect");
    var symbolSizeArr = $5370466dadc978d7$export$a84524f03e8e8dfb(symbolSize);
    var symbolOffsetArr = $5370466dadc978d7$export$e3e292895c033f6d(symbolOffset || 0, symbolSizeArr);
    return symbolType + symbolSizeArr + symbolOffsetArr + (symbolRotate || "") + (symbolKeepAspect || "");
}
/**
 * @inner
 */ function $9e0b5f801ab5090c$var$createSymbol(name, lineData, idx) {
    var symbolType = lineData.getItemVisual(idx, name);
    if (!symbolType || symbolType === "none") return;
    var symbolSize = lineData.getItemVisual(idx, name + "Size");
    var symbolRotate = lineData.getItemVisual(idx, name + "Rotate");
    var symbolOffset = lineData.getItemVisual(idx, name + "Offset");
    var symbolKeepAspect = lineData.getItemVisual(idx, name + "KeepAspect");
    var symbolSizeArr = $5370466dadc978d7$export$a84524f03e8e8dfb(symbolSize);
    var symbolOffsetArr = $5370466dadc978d7$export$e3e292895c033f6d(symbolOffset || 0, symbolSizeArr);
    var symbolPath = $5370466dadc978d7$export$af050e04da3a02e8(symbolType, -symbolSizeArr[0] / 2 + symbolOffsetArr[0], -symbolSizeArr[1] / 2 + symbolOffsetArr[1], symbolSizeArr[0], symbolSizeArr[1], null, symbolKeepAspect);
    symbolPath.__specifiedRotation = symbolRotate == null || isNaN(symbolRotate) ? void 0 : +symbolRotate * Math.PI / 180 || 0;
    symbolPath.name = name;
    return symbolPath;
}
function $9e0b5f801ab5090c$var$createLine(points) {
    var line = new (0, $ab7bf64951ce094b$export$2e2bcd8739ae039)({
        name: "line",
        subPixelOptimize: true
    });
    $9e0b5f801ab5090c$var$setLinePoints(line.shape, points);
    return line;
}
function $9e0b5f801ab5090c$var$setLinePoints(targetShape, points) {
    targetShape.x1 = points[0][0];
    targetShape.y1 = points[0][1];
    targetShape.x2 = points[1][0];
    targetShape.y2 = points[1][1];
    targetShape.percent = 1;
    var cp1 = points[2];
    if (cp1) {
        targetShape.cpx1 = cp1[0];
        targetShape.cpy1 = cp1[1];
    } else {
        targetShape.cpx1 = NaN;
        targetShape.cpy1 = NaN;
    }
}
var $9e0b5f801ab5090c$var$Line = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(Line, _super);
    function Line(lineData, idx, seriesScope) {
        var _this = _super.call(this) || this;
        _this._createLine(lineData, idx, seriesScope);
        return _this;
    }
    Line.prototype._createLine = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var linePoints = lineData.getItemLayout(idx);
        var z2 = lineData.getItemVisual(idx, "z2");
        var line = $9e0b5f801ab5090c$var$createLine(linePoints);
        line.shape.percent = 0;
        $8b353638fbedfefa$export$a121566aadcfe021(line, {
            z2: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(z2, 0),
            shape: {
                percent: 1
            }
        }, seriesModel, idx);
        this.add(line);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($9e0b5f801ab5090c$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbol = $9e0b5f801ab5090c$var$createSymbol(symbolCategory, lineData, idx);
            // symbols must added after line to make sure
            // it will be updated after line#update.
            // Or symbol position and rotation update in line#beforeUpdate will be one frame slow
            this.add(symbol);
            this[$9e0b5f801ab5090c$var$makeSymbolTypeKey(symbolCategory)] = $9e0b5f801ab5090c$var$makeSymbolTypeValue(symbolCategory, lineData, idx);
        }, this);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    // TODO More strict on the List type in parameters?
    Line.prototype.updateData = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var line = this.childOfName("line");
        var linePoints = lineData.getItemLayout(idx);
        var target = {
            shape: {}
        };
        $9e0b5f801ab5090c$var$setLinePoints(target.shape, linePoints);
        $8b353638fbedfefa$export$c8dce3c08436e91e(line, target, seriesModel, idx);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($9e0b5f801ab5090c$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbolType = $9e0b5f801ab5090c$var$makeSymbolTypeValue(symbolCategory, lineData, idx);
            var key = $9e0b5f801ab5090c$var$makeSymbolTypeKey(symbolCategory);
            // Symbol changed
            if (this[key] !== symbolType) {
                this.remove(this.childOfName(symbolCategory));
                var symbol = $9e0b5f801ab5090c$var$createSymbol(symbolCategory, lineData, idx);
                this.add(symbol);
            }
            this[key] = symbolType;
        }, this);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    Line.prototype.getLinePath = function() {
        return this.childAt(0);
    };
    Line.prototype._updateCommonStl = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var line = this.childOfName("line");
        var emphasisLineStyle = seriesScope && seriesScope.emphasisLineStyle;
        var blurLineStyle = seriesScope && seriesScope.blurLineStyle;
        var selectLineStyle = seriesScope && seriesScope.selectLineStyle;
        var labelStatesModels = seriesScope && seriesScope.labelStatesModels;
        var emphasisDisabled = seriesScope && seriesScope.emphasisDisabled;
        var focus = seriesScope && seriesScope.focus;
        var blurScope = seriesScope && seriesScope.blurScope;
        // Optimization for large dataset
        if (!seriesScope || lineData.hasItemOption) {
            var itemModel = lineData.getItemModel(idx);
            var emphasisModel = itemModel.getModel("emphasis");
            emphasisLineStyle = emphasisModel.getModel("lineStyle").getLineStyle();
            blurLineStyle = itemModel.getModel([
                "blur",
                "lineStyle"
            ]).getLineStyle();
            selectLineStyle = itemModel.getModel([
                "select",
                "lineStyle"
            ]).getLineStyle();
            emphasisDisabled = emphasisModel.get("disabled");
            focus = emphasisModel.get("focus");
            blurScope = emphasisModel.get("blurScope");
            labelStatesModels = (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel);
        }
        var lineStyle = lineData.getItemVisual(idx, "style");
        var visualColor = lineStyle.stroke;
        line.useStyle(lineStyle);
        line.style.fill = null;
        line.style.strokeNoScale = true;
        line.ensureState("emphasis").style = emphasisLineStyle;
        line.ensureState("blur").style = blurLineStyle;
        line.ensureState("select").style = selectLineStyle;
        // Update symbol
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($9e0b5f801ab5090c$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbol = this.childOfName(symbolCategory);
            if (symbol) {
                // Share opacity and color with line.
                symbol.setColor(visualColor);
                symbol.style.opacity = lineStyle.opacity;
                for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
                    var stateName = (0, $2bf82c0980125b62$export$151308dceb52d5b)[i];
                    var lineState = line.getState(stateName);
                    if (lineState) {
                        var lineStateStyle = lineState.style || {};
                        var state = symbol.ensureState(stateName);
                        var stateStyle = state.style || (state.style = {});
                        if (lineStateStyle.stroke != null) stateStyle[symbol.__isEmptyBrush ? "stroke" : "fill"] = lineStateStyle.stroke;
                        if (lineStateStyle.opacity != null) stateStyle.opacity = lineStateStyle.opacity;
                    }
                }
                symbol.markRedraw();
            }
        }, this);
        var rawVal = seriesModel.getRawValue(idx);
        (0, $6800dfcb6e1e2a44$export$9a13992917966657)(this, labelStatesModels, {
            labelDataIndex: idx,
            labelFetcher: {
                getFormattedLabel: function(dataIndex, stateName) {
                    return seriesModel.getFormattedLabel(dataIndex, stateName, lineData.dataType);
                }
            },
            inheritColor: visualColor || (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral99,
            defaultOpacity: lineStyle.opacity,
            defaultText: (rawVal == null ? lineData.getName(idx) : isFinite(rawVal) ? (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(rawVal) : rawVal) + ""
        });
        var label = this.getTextContent();
        // Always set `textStyle` even if `normalStyle.text` is null, because default
        // values have to be set on `normalStyle`.
        if (label) {
            var labelNormalModel = labelStatesModels.normal;
            label.__align = label.style.align;
            label.__verticalAlign = label.style.verticalAlign;
            // 'start', 'middle', 'end'
            label.__position = labelNormalModel.get("position") || "middle";
            var distance = labelNormalModel.get("distance");
            if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(distance)) distance = [
                distance,
                distance
            ];
            label.__labelDistance = distance;
        }
        this.setTextConfig({
            position: null,
            local: true,
            inside: false // Can't be inside for stroke element.
        });
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, focus, blurScope, emphasisDisabled);
    };
    Line.prototype.highlight = function() {
        (0, $2bf82c0980125b62$export$b2d02638cc34c042)(this);
    };
    Line.prototype.downplay = function() {
        (0, $2bf82c0980125b62$export$11be6f716239ac55)(this);
    };
    Line.prototype.updateLayout = function(lineData, idx) {
        this.setLinePoints(lineData.getItemLayout(idx));
    };
    Line.prototype.setLinePoints = function(points) {
        var linePath = this.childOfName("line");
        $9e0b5f801ab5090c$var$setLinePoints(linePath.shape, points);
        linePath.dirty();
    };
    Line.prototype.beforeUpdate = function() {
        var lineGroup = this;
        var symbolFrom = lineGroup.childOfName("fromSymbol");
        var symbolTo = lineGroup.childOfName("toSymbol");
        var label = lineGroup.getTextContent();
        // Quick reject
        if (!symbolFrom && !symbolTo && (!label || label.ignore)) return;
        var invScale = 1;
        var parentNode = this.parent;
        while(parentNode){
            if (parentNode.scaleX) invScale /= parentNode.scaleX;
            parentNode = parentNode.parent;
        }
        var line = lineGroup.childOfName("line");
        // If line not changed
        // FIXME Parent scale changed
        if (!this.__dirty && !line.__dirty) return;
        var percent = line.shape.percent;
        var fromPos = line.pointAt(0);
        var toPos = line.pointAt(percent);
        var d = $6de594cf8ac295ff$export$f93b5905241a7cca([], toPos, fromPos);
        $6de594cf8ac295ff$export$a3295358bff77e(d, d);
        function setSymbolRotation(symbol, percent) {
            // Fix #12388
            // when symbol is set to be 'arrow' in markLine,
            // symbolRotate value will be ignored, and compulsively use tangent angle.
            // rotate by default if symbol rotation is not specified
            var specifiedRotation = symbol.__specifiedRotation;
            if (specifiedRotation == null) {
                var tangent = line.tangentAt(percent);
                symbol.attr("rotation", (percent === 1 ? -1 : 1) * Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
            } else symbol.attr("rotation", specifiedRotation);
        }
        if (symbolFrom) {
            symbolFrom.setPosition(fromPos);
            setSymbolRotation(symbolFrom, 0);
            symbolFrom.scaleX = symbolFrom.scaleY = invScale * percent;
            symbolFrom.markRedraw();
        }
        if (symbolTo) {
            symbolTo.setPosition(toPos);
            setSymbolRotation(symbolTo, 1);
            symbolTo.scaleX = symbolTo.scaleY = invScale * percent;
            symbolTo.markRedraw();
        }
        if (label && !label.ignore) {
            label.x = label.y = 0;
            label.originX = label.originY = 0;
            var textAlign = void 0;
            var textVerticalAlign = void 0;
            var distance = label.__labelDistance;
            var distanceX = distance[0] * invScale;
            var distanceY = distance[1] * invScale;
            var halfPercent = percent / 2;
            var tangent = line.tangentAt(halfPercent);
            var n = [
                tangent[1],
                -tangent[0]
            ];
            var cp = line.pointAt(halfPercent);
            if (n[1] > 0) {
                n[0] = -n[0];
                n[1] = -n[1];
            }
            var dir = tangent[0] < 0 ? -1 : 1;
            if (label.__position !== "start" && label.__position !== "end") {
                var rotation = -Math.atan2(tangent[1], tangent[0]);
                if (toPos[0] < fromPos[0]) rotation = Math.PI + rotation;
                label.rotation = rotation;
            }
            var dy = void 0;
            switch(label.__position){
                case "insideStartTop":
                case "insideMiddleTop":
                case "insideEndTop":
                case "middle":
                    dy = -distanceY;
                    textVerticalAlign = "bottom";
                    break;
                case "insideStartBottom":
                case "insideMiddleBottom":
                case "insideEndBottom":
                    dy = distanceY;
                    textVerticalAlign = "top";
                    break;
                default:
                    dy = 0;
                    textVerticalAlign = "middle";
            }
            switch(label.__position){
                case "end":
                    label.x = d[0] * distanceX + toPos[0];
                    label.y = d[1] * distanceY + toPos[1];
                    textAlign = d[0] > 0.8 ? "left" : d[0] < -0.8 ? "right" : "center";
                    textVerticalAlign = d[1] > 0.8 ? "top" : d[1] < -0.8 ? "bottom" : "middle";
                    break;
                case "start":
                    label.x = -d[0] * distanceX + fromPos[0];
                    label.y = -d[1] * distanceY + fromPos[1];
                    textAlign = d[0] > 0.8 ? "right" : d[0] < -0.8 ? "left" : "center";
                    textVerticalAlign = d[1] > 0.8 ? "bottom" : d[1] < -0.8 ? "top" : "middle";
                    break;
                case "insideStartTop":
                case "insideStart":
                case "insideStartBottom":
                    label.x = distanceX * dir + fromPos[0];
                    label.y = fromPos[1] + dy;
                    textAlign = tangent[0] < 0 ? "right" : "left";
                    label.originX = -distanceX * dir;
                    label.originY = -dy;
                    break;
                case "insideMiddleTop":
                case "insideMiddle":
                case "insideMiddleBottom":
                case "middle":
                    label.x = cp[0];
                    label.y = cp[1] + dy;
                    textAlign = "center";
                    label.originY = -dy;
                    break;
                case "insideEndTop":
                case "insideEnd":
                case "insideEndBottom":
                    label.x = -distanceX * dir + toPos[0];
                    label.y = toPos[1] + dy;
                    textAlign = tangent[0] >= 0 ? "right" : "left";
                    label.originX = distanceX * dir;
                    label.originY = -dy;
                    break;
            }
            label.scaleX = label.scaleY = invScale;
            label.setStyle({
                // Use the user specified text align and baseline first
                verticalAlign: label.__verticalAlign || textVerticalAlign,
                align: label.__align || textAlign
            });
        }
    };
    return Line;
}($7ef7583d8302ffce$export$2e2bcd8739ae039);
var $9e0b5f801ab5090c$export$2e2bcd8739ae039 = $9e0b5f801ab5090c$var$Line;



var $a2fd63a0fc11274a$var$LineDraw = /** @class */ function() {
    function LineDraw(LineCtor) {
        this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this._LineCtor = LineCtor || (0, $9e0b5f801ab5090c$export$2e2bcd8739ae039);
    }
    LineDraw.prototype.updateData = function(lineData) {
        var _this = this;
        // Remove progressive els.
        this._progressiveEls = null;
        var lineDraw = this;
        var group = lineDraw.group;
        var oldLineData = lineDraw._lineData;
        lineDraw._lineData = lineData;
        // There is no oldLineData only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!oldLineData) group.removeAll();
        var seriesScope = $a2fd63a0fc11274a$var$makeSeriesScope(lineData);
        lineData.diff(oldLineData).add(function(idx) {
            _this._doAdd(lineData, idx, seriesScope);
        }).update(function(newIdx, oldIdx) {
            _this._doUpdate(oldLineData, lineData, oldIdx, newIdx, seriesScope);
        }).remove(function(idx) {
            group.remove(oldLineData.getItemGraphicEl(idx));
        }).execute();
    };
    LineDraw.prototype.updateLayout = function() {
        var lineData = this._lineData;
        // Do not support update layout in incremental mode.
        if (!lineData) return;
        lineData.eachItemGraphicEl(function(el, idx) {
            el.updateLayout(lineData, idx);
        }, this);
    };
    LineDraw.prototype.incrementalPrepareUpdate = function(lineData) {
        this._seriesScope = $a2fd63a0fc11274a$var$makeSeriesScope(lineData);
        this._lineData = null;
        this.group.removeAll();
    };
    LineDraw.prototype.incrementalUpdate = function(taskParams, lineData) {
        this._progressiveEls = [];
        function updateIncrementalAndHover(el) {
            if (!el.isGroup && !$a2fd63a0fc11274a$var$isEffectObject(el)) {
                el.incremental = true;
                el.ensureState("emphasis").hoverLayer = true;
            }
        }
        for(var idx = taskParams.start; idx < taskParams.end; idx++){
            var itemLayout = lineData.getItemLayout(idx);
            if ($a2fd63a0fc11274a$var$lineNeedsDraw(itemLayout)) {
                var el = new this._LineCtor(lineData, idx, this._seriesScope);
                el.traverse(updateIncrementalAndHover);
                this.group.add(el);
                lineData.setItemGraphicEl(idx, el);
                this._progressiveEls.push(el);
            }
        }
    };
    LineDraw.prototype.remove = function() {
        this.group.removeAll();
    };
    LineDraw.prototype.eachRendered = function(cb) {
        $5b455ae6f843ac47$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    LineDraw.prototype._doAdd = function(lineData, idx, seriesScope) {
        var itemLayout = lineData.getItemLayout(idx);
        if (!$a2fd63a0fc11274a$var$lineNeedsDraw(itemLayout)) return;
        var el = new this._LineCtor(lineData, idx, seriesScope);
        lineData.setItemGraphicEl(idx, el);
        this.group.add(el);
    };
    LineDraw.prototype._doUpdate = function(oldLineData, newLineData, oldIdx, newIdx, seriesScope) {
        var itemEl = oldLineData.getItemGraphicEl(oldIdx);
        if (!$a2fd63a0fc11274a$var$lineNeedsDraw(newLineData.getItemLayout(newIdx))) {
            this.group.remove(itemEl);
            return;
        }
        if (!itemEl) itemEl = new this._LineCtor(newLineData, newIdx, seriesScope);
        else itemEl.updateData(newLineData, newIdx, seriesScope);
        newLineData.setItemGraphicEl(newIdx, itemEl);
        this.group.add(itemEl);
    };
    return LineDraw;
}();
function $a2fd63a0fc11274a$var$isEffectObject(el) {
    return el.animators && el.animators.length > 0;
}
function $a2fd63a0fc11274a$var$makeSeriesScope(lineData) {
    var hostModel = lineData.hostModel;
    var emphasisModel = hostModel.getModel("emphasis");
    return {
        lineStyle: hostModel.getModel("lineStyle").getLineStyle(),
        emphasisLineStyle: emphasisModel.getModel([
            "lineStyle"
        ]).getLineStyle(),
        blurLineStyle: hostModel.getModel([
            "blur",
            "lineStyle"
        ]).getLineStyle(),
        selectLineStyle: hostModel.getModel([
            "select",
            "lineStyle"
        ]).getLineStyle(),
        emphasisDisabled: emphasisModel.get("disabled"),
        blurScope: emphasisModel.get("blurScope"),
        focus: emphasisModel.get("focus"),
        labelStatesModels: (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(hostModel)
    };
}
function $a2fd63a0fc11274a$var$isPointNaN(pt) {
    return isNaN(pt[0]) || isNaN(pt[1]);
}
function $a2fd63a0fc11274a$var$lineNeedsDraw(pts) {
    return pts && !$a2fd63a0fc11274a$var$isPointNaN(pts[0]) && !$a2fd63a0fc11274a$var$isPointNaN(pts[1]);
}
var $a2fd63a0fc11274a$export$2e2bcd8739ae039 = $a2fd63a0fc11274a$var$LineDraw;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $befd6a34b30d3f54$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $befd6a34b30d3f54$export$b7df5d561049483a(zr, resourceKey, userKey) {
    $befd6a34b30d3f54$var$inner(zr)[resourceKey] = userKey;
}
function $befd6a34b30d3f54$export$23d3fad09dc44362(zr, resourceKey, userKey) {
    var store = $befd6a34b30d3f54$var$inner(zr);
    var uKey = store[resourceKey];
    if (uKey === userKey) store[resourceKey] = null;
}
function $befd6a34b30d3f54$export$5623cba512bc9470(zr, resourceKey) {
    return !!$befd6a34b30d3f54$var$inner(zr)[resourceKey];
}
/**
 * payload: {
 *     type: 'takeGlobalCursor',
 *     key: 'dataZoomSelect', or 'brush', or ...,
 *         If no userKey, release global cursor.
 * }
 */ // TODO: SELF REGISTERED.
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: "takeGlobalCursor",
    event: "globalCursorTaken",
    update: "update"
}, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bee256db41541054$var$IRRELEVANT_EXCLUDES = {
    "axisPointer": 1,
    "tooltip": 1,
    "brush": 1
};
function $bee256db41541054$export$8a33eacb690eac07(e, api, targetComponent) {
    var eventElComponent = api.getComponentByElement(e.topTarget);
    if (!eventElComponent || eventElComponent === targetComponent || $bee256db41541054$var$IRRELEVANT_EXCLUDES.hasOwnProperty(eventElComponent.mainType)) return false;
    // At present the `true` return is conservative. That is, the caller, such as a RoamController,
    // is more likely to get a `false` return and start a roam behavior, becuase even if the
    // `model.coordinateSystem` does not exist, the `e.topTarget` may be also a relevant element,
    // such as axis split line/area or series elements, where roam should be available. Otherwise,
    // if a dataZoom-served cartesian is full of series elements, the dataZoom-roaming can hardly
    // be triggered.
    var eventElCoordSys = eventElComponent.coordinateSystem;
    // If eventElComponent is axisModel, it works only if it is injected with coordinateSystem.
    if (!eventElCoordSys || eventElCoordSys.model === targetComponent) return false;
    // e.g., if a cartesian is covered by a graph, the graph has a higher presedence in roam.
    // A potential bad case is that RoamController does not prevent the cartesian from handling zr
    // event, such as click and hovering, but it's fine so far.
    // Aslo be conservative, if equals, return false.
    var eventElCmptZInfo = (0, $5b455ae6f843ac47$export$1500a631bea5adda)(eventElComponent);
    var targetCmptZInfo = (0, $5b455ae6f843ac47$export$1500a631bea5adda)(targetComponent);
    if ((eventElCmptZInfo.zlevel - targetCmptZInfo.zlevel || eventElCmptZInfo.z - targetCmptZInfo.z) <= 0) return false;
    return true;
}


/**
 * An manager of zoom and pan(darg) hehavior.
 * But it is not responsible for updating the view, since view updates vary and can
 * not be handled in a uniform way.
 *
 * Note: regarding view updates:
 *  - Transformabe views typically use `coord/View` (e.g., geo and series.graph roaming).
 *    Some commonly used view update logic has been organized into `roamHelper.ts`.
 *  - Non-transformable views handle updates themselves, possibly involving re-layout,
 *    (e.g., treemap).
 *  - Some scenarios do not require transformation (e.g., dataZoom roaming for cartesian,
 *    brush component).
 */ var $15927f329deeab51$var$RoamController = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RoamController, _super);
    function RoamController(zr) {
        var _this = _super.call(this) || this;
        _this._zr = zr;
        // Avoid two roamController bind the same handler
        var mousedownHandler = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._mousedownHandler, _this);
        var mousemoveHandler = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._mousemoveHandler, _this);
        var mouseupHandler = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._mouseupHandler, _this);
        var mousewheelHandler = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._mousewheelHandler, _this);
        var pinchHandler = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._pinchHandler, _this);
        /**
     * Notice:
     *  - only enable needed types. For example, if 'zoom'
     *    is not needed, 'zoom' should not be enabled, otherwise
     *    default mousewheel behaviour (scroll page) will be disabled.
     *  - This method is idempotent.
     */ _this.enable = function(controlType, rawOpt) {
            var zInfo = rawOpt.zInfo;
            var _a = (0, $5b455ae6f843ac47$export$1500a631bea5adda)(zInfo.component), z = _a.z, zlevel = _a.zlevel;
            var zInfoParsed = {
                component: zInfo.component,
                z: z,
                zlevel: zlevel,
                // By default roam controller is the lowest z2 comparing to other elememts in a component.
                z2: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(zInfo.z2, -Infinity)
            };
            var triggerInfo = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, rawOpt.triggerInfo);
            this._opt = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, rawOpt), {
                zoomOnMouseWheel: true,
                moveOnMouseMove: true,
                // By default, wheel do not trigger move.
                moveOnMouseWheel: false,
                preventDefaultMouseMove: true,
                zInfoParsed: zInfoParsed,
                triggerInfo: triggerInfo
            });
            if (controlType == null) controlType = true;
            // A handy optimization for repeatedly calling `enable` during roaming.
            // Assert `disable` is only affected by `controlType`.
            if (!this._enabled || this._controlType !== controlType) {
                this._enabled = true;
                // Disable previous first
                this.disable();
                if (controlType === true || controlType === "move" || controlType === "pan") {
                    $15927f329deeab51$var$addRoamZrListener(zr, "mousedown", mousedownHandler, zInfoParsed);
                    $15927f329deeab51$var$addRoamZrListener(zr, "mousemove", mousemoveHandler, zInfoParsed);
                    $15927f329deeab51$var$addRoamZrListener(zr, "mouseup", mouseupHandler, zInfoParsed);
                }
                if (controlType === true || controlType === "scale" || controlType === "zoom") {
                    $15927f329deeab51$var$addRoamZrListener(zr, "mousewheel", mousewheelHandler, zInfoParsed);
                    $15927f329deeab51$var$addRoamZrListener(zr, "pinch", pinchHandler, zInfoParsed);
                }
            }
        };
        _this.disable = function() {
            this._enabled = false;
            $15927f329deeab51$var$removeRoamZrListener(zr, "mousedown", mousedownHandler);
            $15927f329deeab51$var$removeRoamZrListener(zr, "mousemove", mousemoveHandler);
            $15927f329deeab51$var$removeRoamZrListener(zr, "mouseup", mouseupHandler);
            $15927f329deeab51$var$removeRoamZrListener(zr, "mousewheel", mousewheelHandler);
            $15927f329deeab51$var$removeRoamZrListener(zr, "pinch", pinchHandler);
        };
        return _this;
    }
    RoamController.prototype.isDragging = function() {
        return this._dragging;
    };
    RoamController.prototype.isPinching = function() {
        return this._pinching;
    };
    RoamController.prototype._checkPointer = function(e, x, y) {
        var opt = this._opt;
        var zInfoParsed = opt.zInfoParsed;
        if ((0, $bee256db41541054$export$8a33eacb690eac07)(e, opt.api, zInfoParsed.component)) return false;
        var triggerInfo = opt.triggerInfo;
        var roamTrigger = triggerInfo.roamTrigger;
        var inArea = false;
        if (roamTrigger === "global") inArea = true;
        if (!inArea) inArea = triggerInfo.isInSelf(e, x, y);
        if (inArea && triggerInfo.isInClip && !triggerInfo.isInClip(e, x, y)) inArea = false;
        return inArea;
    };
    RoamController.prototype._decideCursorStyle = function(e, x, y, forReverse) {
        // If this cursor style decision is not strictly consistent with zrender,
        // it's fine - zr will set the cursor on the next mousemove.
        // This `grab` cursor style should take the lowest precedence. If the hovring element already
        // have a cursor, zrender will set it to be non-'default' before entering this handler.
        // (note, e.target is never silent, e.topTarget can be silent be irrelevant.)
        var target = e.target;
        if (!target && this._checkPointer(e, x, y)) // To indicate users that this area is draggable, otherwise users probably cannot kwown
        // that when hovering out of the shape but still inside the bounding rect.
        return "grab";
        if (forReverse) return target && target.cursor || "default";
    };
    RoamController.prototype.dispose = function() {
        this.disable();
    };
    RoamController.prototype._mousedownHandler = function(e) {
        if ($b3864a78637ff9ed$export$b7ae4cded3e71bd2(e) || $15927f329deeab51$var$eventConsumed(e)) return;
        var el = e.target;
        while(el){
            if (el.draggable) return;
            // check if host is draggable
            el = el.__hostTarget || el.parent;
        }
        var x = e.offsetX;
        var y = e.offsetY;
        // To determine dragging start, only by checking on mosedown, but not mousemove.
        // Mouse can be out of target when mouse moving.
        if (this._checkPointer(e, x, y)) {
            this._x = x;
            this._y = y;
            this._dragging = true;
        }
    };
    RoamController.prototype._mousemoveHandler = function(e) {
        var zr = this._zr;
        if (e.gestureEvent === "pinch" || $befd6a34b30d3f54$export$5623cba512bc9470(zr, "globalPan") || $15927f329deeab51$var$eventConsumed(e)) return;
        var x = e.offsetX;
        var y = e.offsetY;
        if (!this._dragging || !$15927f329deeab51$var$isAvailableBehavior("moveOnMouseMove", e, this._opt)) {
            var cursorStyle = this._decideCursorStyle(e, x, y, false);
            if (cursorStyle) zr.setCursorStyle(cursorStyle);
            return;
        }
        zr.setCursorStyle("grabbing");
        var oldX = this._x;
        var oldY = this._y;
        var dx = x - oldX;
        var dy = y - oldY;
        this._x = x;
        this._y = y;
        if (this._opt.preventDefaultMouseMove) $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
        e.__ecRoamConsumed = true;
        $15927f329deeab51$var$trigger(this, "pan", "moveOnMouseMove", e, {
            dx: dx,
            dy: dy,
            oldX: oldX,
            oldY: oldY,
            newX: x,
            newY: y,
            isAvailableBehavior: null
        });
    };
    RoamController.prototype._mouseupHandler = function(e) {
        if ($15927f329deeab51$var$eventConsumed(e)) return;
        var zr = this._zr;
        if (!$b3864a78637ff9ed$export$b7ae4cded3e71bd2(e)) {
            this._dragging = false;
            var cursorStyle = this._decideCursorStyle(e, e.offsetX, e.offsetY, true);
            if (cursorStyle) zr.setCursorStyle(cursorStyle);
        }
    };
    RoamController.prototype._mousewheelHandler = function(e) {
        if ($15927f329deeab51$var$eventConsumed(e)) return;
        var shouldZoom = $15927f329deeab51$var$isAvailableBehavior("zoomOnMouseWheel", e, this._opt);
        var shouldMove = $15927f329deeab51$var$isAvailableBehavior("moveOnMouseWheel", e, this._opt);
        var wheelDelta = e.wheelDelta;
        var absWheelDeltaDelta = Math.abs(wheelDelta);
        var originX = e.offsetX;
        var originY = e.offsetY;
        // wheelDelta maybe -0 in chrome mac.
        if (wheelDelta === 0 || !shouldZoom && !shouldMove) return;
        // If both `shouldZoom` and `shouldMove` is true, trigger
        // their event both, and the final behavior is determined
        // by event listener themselves.
        if (shouldZoom) {
            // Convenience:
            // Mac and VM Windows on Mac: scroll up: zoom out.
            // Windows: scroll up: zoom in.
            // FIXME: Should do more test in different environment.
            // wheelDelta is too complicated in difference nvironment
            // (https://developer.mozilla.org/en-US/docs/Web/Events/mousewheel),
            // although it has been normallized by zrender.
            // wheelDelta of mouse wheel is bigger than touch pad.
            var factor = absWheelDeltaDelta > 3 ? 1.4 : absWheelDeltaDelta > 1 ? 1.2 : 1.1;
            var scale = wheelDelta > 0 ? factor : 1 / factor;
            this._checkTriggerMoveZoom(this, "zoom", "zoomOnMouseWheel", e, {
                scale: scale,
                originX: originX,
                originY: originY,
                isAvailableBehavior: null
            });
        }
        if (shouldMove) {
            // FIXME: Should do more test in different environment.
            var absDelta = Math.abs(wheelDelta);
            // wheelDelta of mouse wheel is bigger than touch pad.
            var scrollDelta = (wheelDelta > 0 ? 1 : -1) * (absDelta > 3 ? 0.4 : absDelta > 1 ? 0.15 : 0.05);
            this._checkTriggerMoveZoom(this, "scrollMove", "moveOnMouseWheel", e, {
                scrollDelta: scrollDelta,
                originX: originX,
                originY: originY,
                isAvailableBehavior: null
            });
        }
    };
    RoamController.prototype._pinchHandler = function(e) {
        if ($befd6a34b30d3f54$export$5623cba512bc9470(this._zr, "globalPan") || $15927f329deeab51$var$eventConsumed(e)) return;
        var scale = e.pinchScale > 1 ? 1.1 : 1 / 1.1;
        this._checkTriggerMoveZoom(this, "zoom", null, e, {
            scale: scale,
            originX: e.pinchX,
            originY: e.pinchY,
            isAvailableBehavior: null
        });
    };
    RoamController.prototype._checkTriggerMoveZoom = function(controller, eventName, behaviorToCheck, e, contollerEvent) {
        if (controller._checkPointer(e, contollerEvent.originX, contollerEvent.originY)) {
            // When mouse is out of roamController rect,
            // default befavoius should not be be disabled, otherwise
            // page sliding is disabled, contrary to expectation.
            $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
            e.__ecRoamConsumed = true;
            $15927f329deeab51$var$trigger(controller, eventName, behaviorToCheck, e, contollerEvent);
        }
    };
    return RoamController;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
function $15927f329deeab51$var$eventConsumed(e) {
    return e.__ecRoamConsumed;
}
var $15927f329deeab51$var$innerZrStore = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $15927f329deeab51$var$ensureZrStore(zr) {
    var store = $15927f329deeab51$var$innerZrStore(zr);
    store.roam = store.roam || {};
    store.uniform = store.uniform || {};
    return store;
}
/**
 * Listeners are sorted by z2/z/zlevel in descending order.
 * This decides the precedence between different roam controllers if they are overlapped.
 *
 * [MEMO]: It's not easy to perfectly reconcile the conflicts caused by overlap.
 *  - Consider cases:
 *    - Multiple roam controllers overlapped.
 *      - Usually only the topmost can trigger roam.
 *    - Roam controllers overlap with other zr elements:
 *      - zr elements are relevant or irrelevent to the host of the roam controller. e.g., axis split line
 *        or series elements is relevant to a cartesian and should trigger roam.
 *      - zr elements is above or below the roam controller host, which affects the precedence of interaction.
 *      - zr elements may not silent only for triggering tooltip by hovering, which is available to roam;
 *        or may not silent for click, where roam is not preferable.
 *  - Approach - `addRoamZrListener+pointerChecker+onIrrelevantElement` (currently used):
 *    - Resolve the precedence between different roam controllers
 *    - But cannot prevent the handling on other zr elements that under the roam controller in z-order.
 *  - Approach - "use an invisible zr elements to receive the zr events to trigger roam":
 *    - More complicated in impl.
 *    - May cause bad cases where zr event cannot be receive due to other non-silient zr elements covering it.
 */ function $15927f329deeab51$var$addRoamZrListener(zr, eventType, listener, zInfoParsed) {
    var store = $15927f329deeab51$var$ensureZrStore(zr);
    var roam = store.roam;
    var listenerList = roam[eventType] = roam[eventType] || [];
    var idx = 0;
    for(; idx < listenerList.length; idx++){
        var currZInfo = listenerList[idx].zInfoParsed;
        if ((currZInfo.zlevel - zInfoParsed.zlevel || currZInfo.z - zInfoParsed.z || currZInfo.z2 - zInfoParsed.z2) <= 0) break;
    }
    listenerList.splice(idx, 0, {
        listener: listener,
        zInfoParsed: zInfoParsed
    });
    $15927f329deeab51$var$ensureUniformListener(zr, eventType);
}
function $15927f329deeab51$var$removeRoamZrListener(zr, eventType, listener) {
    var store = $15927f329deeab51$var$ensureZrStore(zr);
    var listenerList = store.roam[eventType] || [];
    for(var idx = 0; idx < listenerList.length; idx++)if (listenerList[idx].listener === listener) {
        listenerList.splice(idx, 1);
        if (!listenerList.length) $15927f329deeab51$var$removeUniformListener(zr, eventType);
        return;
    }
}
function $15927f329deeab51$var$ensureUniformListener(zr, eventType) {
    var store = $15927f329deeab51$var$ensureZrStore(zr);
    if (!store.uniform[eventType]) zr.on(eventType, store.uniform[eventType] = function(event) {
        var listenerList = store.roam[eventType];
        if (listenerList) for(var i = 0; i < listenerList.length; i++)listenerList[i].listener(event);
    });
}
function $15927f329deeab51$var$removeUniformListener(zr, eventType) {
    var store = $15927f329deeab51$var$ensureZrStore(zr);
    var uniform = store.uniform;
    if (uniform[eventType]) {
        zr.off(eventType, uniform[eventType]);
        uniform[eventType] = null;
    }
}
function $15927f329deeab51$var$trigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
    // Also provide behavior checker for event listener, for some case that
    // multiple components share one listener.
    contollerEvent.isAvailableBehavior = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($15927f329deeab51$var$isAvailableBehavior, null, behaviorToCheck, e);
    // TODO should not have type issue.
    controller.trigger(eventName, contollerEvent);
}
// settings: {
//     zoomOnMouseWheel
//     moveOnMouseMove
//     moveOnMouseWheel
// }
// The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
function $15927f329deeab51$var$isAvailableBehavior(behaviorToCheck, e, settings) {
    var setting = settings[behaviorToCheck];
    return !behaviorToCheck || setting && (!(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(setting) || e.event[setting + "Key"]);
}
var $15927f329deeab51$export$2e2bcd8739ae039 = $15927f329deeab51$var$RoamController;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $197126bedfb0a68b$var$v1 = [];
var $197126bedfb0a68b$var$v2 = [];
var $197126bedfb0a68b$var$v3 = [];
var $197126bedfb0a68b$var$quadraticAt = $747cfc5611b57cea$export$af17094a950f5073;
var $197126bedfb0a68b$var$v2DistSquare = $6de594cf8ac295ff$export$c68db45a034c13b0;
var $197126bedfb0a68b$var$mathAbs = Math.abs;
function $197126bedfb0a68b$var$intersectCurveCircle(curvePoints, center, radius) {
    var p0 = curvePoints[0];
    var p1 = curvePoints[1];
    var p2 = curvePoints[2];
    var d = Infinity;
    var t;
    var radiusSquare = radius * radius;
    var interval = 0.1;
    for(var _t = 0.1; _t <= 0.9; _t += 0.1){
        $197126bedfb0a68b$var$v1[0] = $197126bedfb0a68b$var$quadraticAt(p0[0], p1[0], p2[0], _t);
        $197126bedfb0a68b$var$v1[1] = $197126bedfb0a68b$var$quadraticAt(p0[1], p1[1], p2[1], _t);
        var diff = $197126bedfb0a68b$var$mathAbs($197126bedfb0a68b$var$v2DistSquare($197126bedfb0a68b$var$v1, center) - radiusSquare);
        if (diff < d) {
            d = diff;
            t = _t;
        }
    }
    // Assume the segment is monotone，Find root through Bisection method
    // At most 32 iteration
    for(var i = 0; i < 32; i++){
        // let prev = t - interval;
        var next = t + interval;
        // v1[0] = quadraticAt(p0[0], p1[0], p2[0], prev);
        // v1[1] = quadraticAt(p0[1], p1[1], p2[1], prev);
        $197126bedfb0a68b$var$v2[0] = $197126bedfb0a68b$var$quadraticAt(p0[0], p1[0], p2[0], t);
        $197126bedfb0a68b$var$v2[1] = $197126bedfb0a68b$var$quadraticAt(p0[1], p1[1], p2[1], t);
        $197126bedfb0a68b$var$v3[0] = $197126bedfb0a68b$var$quadraticAt(p0[0], p1[0], p2[0], next);
        $197126bedfb0a68b$var$v3[1] = $197126bedfb0a68b$var$quadraticAt(p0[1], p1[1], p2[1], next);
        var diff = $197126bedfb0a68b$var$v2DistSquare($197126bedfb0a68b$var$v2, center) - radiusSquare;
        if ($197126bedfb0a68b$var$mathAbs(diff) < 1e-2) break;
        // let prevDiff = v2DistSquare(v1, center) - radiusSquare;
        var nextDiff = $197126bedfb0a68b$var$v2DistSquare($197126bedfb0a68b$var$v3, center) - radiusSquare;
        interval /= 2;
        if (diff < 0) {
            if (nextDiff >= 0) t = t + interval;
            else t = t - interval;
        } else if (nextDiff >= 0) t = t - interval;
        else t = t + interval;
    }
    return t;
}
function $197126bedfb0a68b$export$2e2bcd8739ae039(graph, scale) {
    var tmp0 = [];
    var quadraticSubdivide = $747cfc5611b57cea$export$117c659e21a7a060;
    var pts = [
        [],
        [],
        []
    ];
    var pts2 = [
        [],
        []
    ];
    var v = [];
    scale /= 2;
    graph.eachEdge(function(edge, idx) {
        var linePoints = edge.getLayout();
        var fromSymbol = edge.getVisual("fromSymbol");
        var toSymbol = edge.getVisual("toSymbol");
        if (!linePoints.__original) {
            linePoints.__original = [
                $6de594cf8ac295ff$export$9cd59f9826255e47(linePoints[0]),
                $6de594cf8ac295ff$export$9cd59f9826255e47(linePoints[1])
            ];
            if (linePoints[2]) linePoints.__original.push($6de594cf8ac295ff$export$9cd59f9826255e47(linePoints[2]));
        }
        var originalPoints = linePoints.__original;
        // Quadratic curve
        if (linePoints[2] != null) {
            $6de594cf8ac295ff$export$784d13d8ee351f07(pts[0], originalPoints[0]);
            $6de594cf8ac295ff$export$784d13d8ee351f07(pts[1], originalPoints[2]);
            $6de594cf8ac295ff$export$784d13d8ee351f07(pts[2], originalPoints[1]);
            if (fromSymbol && fromSymbol !== "none") {
                var symbolSize = (0, $ad8b4f94f577d55a$export$8d4a06d3facd414b)(edge.node1);
                var t = $197126bedfb0a68b$var$intersectCurveCircle(pts, originalPoints[0], symbolSize * scale);
                // Subdivide and get the second
                quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
                pts[0][0] = tmp0[3];
                pts[1][0] = tmp0[4];
                quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
                pts[0][1] = tmp0[3];
                pts[1][1] = tmp0[4];
            }
            if (toSymbol && toSymbol !== "none") {
                var symbolSize = (0, $ad8b4f94f577d55a$export$8d4a06d3facd414b)(edge.node2);
                var t = $197126bedfb0a68b$var$intersectCurveCircle(pts, originalPoints[1], symbolSize * scale);
                // Subdivide and get the first
                quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
                pts[1][0] = tmp0[1];
                pts[2][0] = tmp0[2];
                quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
                pts[1][1] = tmp0[1];
                pts[2][1] = tmp0[2];
            }
            // Copy back to layout
            $6de594cf8ac295ff$export$784d13d8ee351f07(linePoints[0], pts[0]);
            $6de594cf8ac295ff$export$784d13d8ee351f07(linePoints[1], pts[2]);
            $6de594cf8ac295ff$export$784d13d8ee351f07(linePoints[2], pts[1]);
        } else {
            $6de594cf8ac295ff$export$784d13d8ee351f07(pts2[0], originalPoints[0]);
            $6de594cf8ac295ff$export$784d13d8ee351f07(pts2[1], originalPoints[1]);
            $6de594cf8ac295ff$export$f93b5905241a7cca(v, pts2[1], pts2[0]);
            $6de594cf8ac295ff$export$a3295358bff77e(v, v);
            if (fromSymbol && fromSymbol !== "none") {
                var symbolSize = (0, $ad8b4f94f577d55a$export$8d4a06d3facd414b)(edge.node1);
                $6de594cf8ac295ff$export$19cedf1da84ba854(pts2[0], pts2[0], v, symbolSize * scale);
            }
            if (toSymbol && toSymbol !== "none") {
                var symbolSize = (0, $ad8b4f94f577d55a$export$8d4a06d3facd414b)(edge.node2);
                $6de594cf8ac295ff$export$19cedf1da84ba854(pts2[1], pts2[1], v, -symbolSize * scale);
            }
            $6de594cf8ac295ff$export$784d13d8ee351f07(linePoints[0], pts2[0]);
            $6de594cf8ac295ff$export$784d13d8ee351f07(linePoints[1], pts2[1]);
        }
    });
}









/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/**
 * @caveat Do not import other `src/component/thumbnail/*` files.
 *  This file should be decoupled from them for sake of the size consideration.
 */ /**
 * FIXME: This is a temporary implmentation. May need refactor to decouple
 *  the direct call from series.graph to thumbnail.
 */ var $f9fe8cab4df97889$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $f9fe8cab4df97889$export$a3afb75f2ef39b51(model) {
    if (model) return $f9fe8cab4df97889$var$inner(model).bridge;
}
function $f9fe8cab4df97889$export$db2c4d283c33f141(model, thumbnailBridge) {
    if (model) $f9fe8cab4df97889$var$inner(model).bridge = thumbnailBridge;
}


function $65490d05ca8b2521$var$isViewCoordSys(coordSys) {
    return coordSys.type === "view";
}
var $65490d05ca8b2521$var$GraphView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GraphView, _super);
    function GraphView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GraphView.type;
        return _this;
    }
    GraphView.prototype.init = function(ecModel, api) {
        var symbolDraw = new (0, $fedf62268297fcbb$export$2e2bcd8739ae039)();
        var lineDraw = new (0, $a2fd63a0fc11274a$export$2e2bcd8739ae039)();
        var group = this.group;
        var mainGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this._controller = new (0, $15927f329deeab51$export$2e2bcd8739ae039)(api.getZr());
        this._controllerHost = {
            target: mainGroup
        };
        mainGroup.add(symbolDraw.group);
        mainGroup.add(lineDraw.group);
        group.add(mainGroup);
        this._symbolDraw = symbolDraw;
        this._lineDraw = lineDraw;
        this._mainGroup = mainGroup;
        this._firstRender = true;
    };
    GraphView.prototype.render = function(seriesModel, ecModel, api) {
        var _this = this;
        var coordSys = seriesModel.coordinateSystem;
        var isForceLayout = false;
        this._model = seriesModel;
        this._api = api;
        this._active = true;
        var thumbnailInfo = this._getThumbnailInfo();
        if (thumbnailInfo) thumbnailInfo.bridge.reset(api);
        var symbolDraw = this._symbolDraw;
        var lineDraw = this._lineDraw;
        if ($65490d05ca8b2521$var$isViewCoordSys(coordSys)) {
            var groupNewProp = {
                x: coordSys.x,
                y: coordSys.y,
                scaleX: coordSys.scaleX,
                scaleY: coordSys.scaleY
            };
            if (this._firstRender) this._mainGroup.attr(groupNewProp);
            else $8b353638fbedfefa$export$c8dce3c08436e91e(this._mainGroup, groupNewProp, seriesModel);
        }
        // Fix edge contact point with node
        (0, $197126bedfb0a68b$export$2e2bcd8739ae039)(seriesModel.getGraph(), (0, $ad8b4f94f577d55a$export$e2aa0fb9ed198ba7)(seriesModel));
        var data = seriesModel.getData();
        symbolDraw.updateData(data);
        var edgeData = seriesModel.getEdgeData();
        // TODO: TYPE
        lineDraw.updateData(edgeData);
        this._updateNodeAndLinkScale();
        this._updateController(null, seriesModel, api);
        clearTimeout(this._layoutTimeout);
        var forceLayout = seriesModel.forceLayout;
        var layoutAnimation = seriesModel.get([
            "force",
            "layoutAnimation"
        ]);
        if (forceLayout) {
            isForceLayout = true;
            this._startForceLayoutIteration(forceLayout, api, layoutAnimation);
        }
        var layout = seriesModel.get("layout");
        data.graph.eachNode(function(node) {
            var idx = node.dataIndex;
            var el = node.getGraphicEl();
            var itemModel = node.getModel();
            if (!el) return;
            // Update draggable
            el.off("drag").off("dragend");
            var draggable = itemModel.get("draggable");
            if (draggable) el.on("drag", function(e) {
                switch(layout){
                    case "force":
                        forceLayout.warmUp();
                        !_this._layouting && _this._startForceLayoutIteration(forceLayout, api, layoutAnimation);
                        forceLayout.setFixed(idx);
                        // Write position back to layout
                        data.setItemLayout(idx, [
                            el.x,
                            el.y
                        ]);
                        break;
                    case "circular":
                        data.setItemLayout(idx, [
                            el.x,
                            el.y
                        ]);
                        // mark node fixed
                        node.setLayout({
                            fixed: true
                        }, true);
                        // recalculate circular layout
                        (0, $484ee97adf82b508$export$cbfed6ae5cab3dae)(seriesModel, "symbolSize", node, [
                            e.offsetX,
                            e.offsetY
                        ]);
                        _this.updateLayout(seriesModel);
                        break;
                    case "none":
                    default:
                        data.setItemLayout(idx, [
                            el.x,
                            el.y
                        ]);
                        // update edge
                        (0, $159cad03c3625d06$export$a25b52345bee32aa)(seriesModel.getGraph(), seriesModel);
                        _this.updateLayout(seriesModel);
                        break;
                }
            }).on("dragend", function() {
                if (forceLayout) forceLayout.setUnfixed(idx);
            });
            el.setDraggable(draggable, !!itemModel.get("cursor"));
            var focus = itemModel.get([
                "emphasis",
                "focus"
            ]);
            if (focus === "adjacency") (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).focus = node.getAdjacentDataIndices();
        });
        data.graph.eachEdge(function(edge) {
            var el = edge.getGraphicEl();
            var focus = edge.getModel().get([
                "emphasis",
                "focus"
            ]);
            if (!el) return;
            if (focus === "adjacency") (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).focus = {
                edge: [
                    edge.dataIndex
                ],
                node: [
                    edge.node1.dataIndex,
                    edge.node2.dataIndex
                ]
            };
        });
        var circularRotateLabel = seriesModel.get("layout") === "circular" && seriesModel.get([
            "circular",
            "rotateLabel"
        ]);
        var cx = data.getLayout("cx");
        var cy = data.getLayout("cy");
        data.graph.eachNode(function(node) {
            (0, $484ee97adf82b508$export$c768377a6a0a9ab8)(node, circularRotateLabel, cx, cy);
        });
        this._firstRender = false;
        // Force layout will render thumbnail when layout is finished.
        if (!isForceLayout) this._renderThumbnail(seriesModel, api, this._symbolDraw, this._lineDraw);
    };
    GraphView.prototype.dispose = function() {
        this.remove();
        this._controller && this._controller.dispose();
        this._controllerHost = null;
    };
    GraphView.prototype._startForceLayoutIteration = function(forceLayout, api, layoutAnimation) {
        var self = this;
        var firstRendered = false;
        (function step() {
            forceLayout.step(function(stopped) {
                self.updateLayout(self._model);
                if (stopped || !firstRendered) {
                    firstRendered = true;
                    self._renderThumbnail(self._model, api, self._symbolDraw, self._lineDraw);
                }
                (self._layouting = !stopped) && (layoutAnimation ? self._layoutTimeout = setTimeout(step, 16) : step());
            });
        })();
    };
    GraphView.prototype._updateController = function(clipRect, seriesModel, api) {
        var controller = this._controller;
        var controllerHost = this._controllerHost;
        var coordSys = seriesModel.coordinateSystem;
        if (!$65490d05ca8b2521$var$isViewCoordSys(coordSys)) {
            controller.disable();
            return;
        }
        controller.enable(seriesModel.get("roam"), {
            api: api,
            zInfo: {
                component: seriesModel
            },
            triggerInfo: {
                roamTrigger: seriesModel.get("roamTrigger"),
                isInSelf: function(e, x, y) {
                    return coordSys.containPoint([
                        x,
                        y
                    ]);
                },
                isInClip: function(e, x, y) {
                    return !clipRect || clipRect.contain(x, y);
                }
            }
        });
        controllerHost.zoomLimit = seriesModel.get("scaleLimit");
        controllerHost.zoom = coordSys.getZoom();
        controller.off("pan").off("zoom").on("pan", function(e) {
            api.dispatchAction({
                seriesId: seriesModel.id,
                type: "graphRoam",
                dx: e.dx,
                dy: e.dy
            });
        }).on("zoom", function(e) {
            api.dispatchAction({
                seriesId: seriesModel.id,
                type: "graphRoam",
                zoom: e.scale,
                originX: e.originX,
                originY: e.originY
            });
        });
    };
    /**
   * A performance shortcut - called by action handler to update the view directly
   * without any data/visual processing (which are assumed to be unchanged), while
   * ensuring consistent behavior between internal and external action triggers.
   */ GraphView.prototype.updateViewOnPan = function(seriesModel, api, params) {
        if (!this._active) return;
        (0, $35fd859fd545c4be$export$1e6abcd98caba733)(this._controllerHost, params.dx, params.dy);
        this._updateThumbnailWindow();
    };
    /**
   * A performance shortcut - called by action handler to update the view directly
   * without any data/visual processing (which are assumed to be unchanged), while
   * ensuring consistent behavior between internal and external action triggers.
   */ GraphView.prototype.updateViewOnZoom = function(seriesModel, api, params) {
        if (!this._active) return;
        (0, $35fd859fd545c4be$export$29b3c66d30a4866)(this._controllerHost, params.zoom, params.originX, params.originY);
        this._updateNodeAndLinkScale();
        (0, $197126bedfb0a68b$export$2e2bcd8739ae039)(seriesModel.getGraph(), (0, $ad8b4f94f577d55a$export$e2aa0fb9ed198ba7)(seriesModel));
        this._lineDraw.updateLayout();
        // Only update label layout on zoom
        api.updateLabelLayout();
        this._updateThumbnailWindow();
    };
    GraphView.prototype._updateNodeAndLinkScale = function() {
        var seriesModel = this._model;
        var data = seriesModel.getData();
        var nodeScale = (0, $ad8b4f94f577d55a$export$e2aa0fb9ed198ba7)(seriesModel);
        data.eachItemGraphicEl(function(el, idx) {
            el && el.setSymbolScale(nodeScale);
        });
    };
    GraphView.prototype.updateLayout = function(seriesModel) {
        if (!this._active) return;
        (0, $197126bedfb0a68b$export$2e2bcd8739ae039)(seriesModel.getGraph(), (0, $ad8b4f94f577d55a$export$e2aa0fb9ed198ba7)(seriesModel));
        this._symbolDraw.updateLayout();
        this._lineDraw.updateLayout();
    };
    GraphView.prototype.remove = function() {
        this._active = false;
        clearTimeout(this._layoutTimeout);
        this._layouting = false;
        this._layoutTimeout = null;
        this._symbolDraw && this._symbolDraw.remove();
        this._lineDraw && this._lineDraw.remove();
        this._controller && this._controller.disable();
    };
    /**
   * Get thumbnail data structure only if supported.
   */ GraphView.prototype._getThumbnailInfo = function() {
        var model = this._model;
        var coordSys = model.coordinateSystem;
        if (coordSys.type !== "view") return;
        var bridge = (0, $f9fe8cab4df97889$export$a3afb75f2ef39b51)(model);
        if (!bridge) return;
        return {
            bridge: bridge,
            coordSys: coordSys
        };
    };
    GraphView.prototype._updateThumbnailWindow = function() {
        var info = this._getThumbnailInfo();
        if (info) info.bridge.updateWindow(info.coordSys.transform, this._api);
    };
    GraphView.prototype._renderThumbnail = function(seriesModel, api, symbolDraw, lineDraw) {
        var info = this._getThumbnailInfo();
        if (!info) return;
        var bridgeGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        var symbolNodes = symbolDraw.group.children();
        var lineNodes = lineDraw.group.children();
        var lineGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        var symbolGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        bridgeGroup.add(symbolGroup);
        bridgeGroup.add(lineGroup);
        // TODO: reuse elemenents for performance in large graph?
        for(var i = 0; i < symbolNodes.length; i++){
            var node = symbolNodes[i];
            var sub = node.children()[0];
            var x = node.x;
            var y = node.y;
            var subShape = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(sub.shape);
            var shape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(subShape, {
                width: sub.scaleX,
                height: sub.scaleY,
                x: x - sub.scaleX / 2,
                y: y - sub.scaleY / 2
            });
            var style = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(sub.style);
            var subThumbnail = new sub.constructor({
                shape: shape,
                style: style,
                z2: 151
            });
            symbolGroup.add(subThumbnail);
        }
        for(var i = 0; i < lineNodes.length; i++){
            var node = lineNodes[i];
            var line = node.children()[0];
            var style = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(line.style);
            var shape = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(line.shape);
            var lineThumbnail = new (0, $ab7bf64951ce094b$export$2e2bcd8739ae039)({
                style: style,
                shape: shape,
                z2: 151
            });
            lineGroup.add(lineThumbnail);
        }
        info.bridge.renderContent({
            api: api,
            roamType: seriesModel.get("roam"),
            viewportRect: null,
            group: bridgeGroup,
            targetTrans: info.coordSys.transform
        });
    };
    GraphView.type = "graph";
    return GraphView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $65490d05ca8b2521$export$2e2bcd8739ae039 = $65490d05ca8b2521$var$GraphView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 











var $6c5e3b756b0e9560$var$GraphSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GraphSeriesModel, _super);
    function GraphSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GraphSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    GraphSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        var self = this;
        function getCategoriesData() {
            return self._categoriesData;
        }
        // Provide data for legend select
        this.legendVisualProvider = new (0, $cf24728fc17c4ab6$export$2e2bcd8739ae039)(getCategoriesData, getCategoriesData);
        this.fillDataTextStyle(option.edges || option.links);
        this._updateCategoriesData();
    };
    GraphSeriesModel.prototype.mergeOption = function(option) {
        _super.prototype.mergeOption.apply(this, arguments);
        this.fillDataTextStyle(option.edges || option.links);
        this._updateCategoriesData();
    };
    GraphSeriesModel.prototype.mergeDefaultAndTheme = function(option) {
        _super.prototype.mergeDefaultAndTheme.apply(this, arguments);
        (0, $76d619f648247e6d$export$abdcc6a26372f94b)(option, "edgeLabel", [
            "show"
        ]);
    };
    GraphSeriesModel.prototype.getInitialData = function(option, ecModel) {
        var edges = option.edges || option.links || [];
        var nodes = option.data || option.nodes || [];
        var self = this;
        if (nodes && edges) {
            // auto curveness
            (0, $0425a00d02ade69a$export$4f05389c1f2934b8)(this);
            var graph = (0, $09eb5d193a1ecbce$export$2e2bcd8739ae039)(nodes, edges, this, true, beforeLink);
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(graph.edges, function(edge) {
                (0, $0425a00d02ade69a$export$c47b549eed9a7311)(edge.node1, edge.node2, this, edge.dataIndex);
            }, this);
            return graph.data;
        }
        function beforeLink(nodeData, edgeData) {
            // Overwrite nodeData.getItemModel to
            nodeData.wrapMethod("getItemModel", function(model) {
                var categoriesModels = self._categoriesModels;
                var categoryIdx = model.getShallow("category");
                var categoryModel = categoriesModels[categoryIdx];
                if (categoryModel) {
                    categoryModel.parentModel = model.parentModel;
                    model.parentModel = categoryModel;
                }
                return model;
            });
            // TODO Inherit resolveParentPath by default in Model#getModel?
            var oldGetModel = (0, $6818646a97528290$export$2e2bcd8739ae039).prototype.getModel;
            function newGetModel(path, parentModel) {
                var model = oldGetModel.call(this, path, parentModel);
                model.resolveParentPath = resolveParentPath;
                return model;
            }
            edgeData.wrapMethod("getItemModel", function(model) {
                model.resolveParentPath = resolveParentPath;
                model.getModel = newGetModel;
                return model;
            });
            function resolveParentPath(pathArr) {
                if (pathArr && (pathArr[0] === "label" || pathArr[1] === "label")) {
                    var newPathArr = pathArr.slice();
                    if (pathArr[0] === "label") newPathArr[0] = "edgeLabel";
                    else if (pathArr[1] === "label") newPathArr[1] = "edgeLabel";
                    return newPathArr;
                }
                return pathArr;
            }
        }
    };
    GraphSeriesModel.prototype.getGraph = function() {
        return this.getData().graph;
    };
    GraphSeriesModel.prototype.getEdgeData = function() {
        return this.getGraph().edgeData;
    };
    GraphSeriesModel.prototype.getCategoriesData = function() {
        return this._categoriesData;
    };
    GraphSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        if (dataType === "edge") {
            var nodeData = this.getData();
            var params = this.getDataParams(dataIndex, dataType);
            var edge = nodeData.graph.getEdgeByIndex(dataIndex);
            var sourceName = nodeData.getName(edge.node1.dataIndex);
            var targetName = nodeData.getName(edge.node2.dataIndex);
            var nameArr = [];
            sourceName != null && nameArr.push(sourceName);
            targetName != null && nameArr.push(targetName);
            return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
                name: nameArr.join(" > "),
                value: params.value,
                noValue: params.value == null
            });
        }
        // dataType === 'node' or empty
        var nodeMarkup = (0, $b0d4c63a14430ca1$export$3a110b9fb5c88b34)({
            series: this,
            dataIndex: dataIndex,
            multipleSeries: multipleSeries
        });
        return nodeMarkup;
    };
    GraphSeriesModel.prototype._updateCategoriesData = function() {
        var categories = $7a1bd9c2710fea0d$export$871de8747c9eaa88(this.option.categories || [], function(category) {
            // Data must has value
            return category.value != null ? category : $7a1bd9c2710fea0d$export$8b58be045bf06082({
                value: 0
            }, category);
        });
        var categoriesData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)([
            "value"
        ], this);
        categoriesData.initData(categories);
        this._categoriesData = categoriesData;
        this._categoriesModels = categoriesData.mapArray(function(idx) {
            return categoriesData.getItemModel(idx);
        });
    };
    GraphSeriesModel.prototype.setZoom = function(zoom) {
        this.option.zoom = zoom;
    };
    GraphSeriesModel.prototype.setCenter = function(center) {
        this.option.center = center;
    };
    GraphSeriesModel.prototype.isAnimationEnabled = function() {
        return _super.prototype.isAnimationEnabled.call(this) && !(this.get("layout") === "force" && this.get([
            "force",
            "layoutAnimation"
        ]));
    };
    GraphSeriesModel.type = "series.graph";
    GraphSeriesModel.dependencies = [
        "grid",
        "polar",
        "geo",
        "singleAxis",
        "calendar"
    ];
    GraphSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: "view",
        // Default option for all coordinate systems
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // polarIndex: 0,
        // geoIndex: 0,
        legendHoverLink: true,
        layout: null,
        // Configuration of circular layout
        circular: {
            rotateLabel: false
        },
        // Configuration of force directed layout
        force: {
            initLayout: null,
            // Node repulsion. Can be an array to represent range.
            repulsion: [
                0,
                50
            ],
            gravity: 0.1,
            // Initial friction
            friction: 0.6,
            // Edge length. Can be an array to represent range.
            edgeLength: 30,
            layoutAnimation: true
        },
        left: "center",
        top: "center",
        // right: null,
        // bottom: null,
        // width: '80%',
        // height: '80%',
        symbol: "circle",
        symbolSize: 10,
        edgeSymbol: [
            "none",
            "none"
        ],
        edgeSymbolSize: 10,
        edgeLabel: {
            position: "middle",
            distance: 5
        },
        draggable: false,
        roam: false,
        // Default on center of graph
        center: null,
        zoom: 1,
        // Symbol size scale ratio in roam
        nodeScaleRatio: 0.6,
        // cursor: null,
        // categories: [],
        // data: []
        // Or
        // nodes: []
        //
        // links: []
        // Or
        // edges: []
        label: {
            show: false,
            formatter: "{b}"
        },
        itemStyle: {},
        lineStyle: {
            // Don't use tokens.color.border because of the opacity
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral50,
            width: 1,
            opacity: 0.5
        },
        emphasis: {
            scale: true,
            label: {
                show: true
            }
        },
        select: {
            itemStyle: {
                borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.primary
            }
        }
    };
    return GraphSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $6c5e3b756b0e9560$export$2e2bcd8739ae039 = $6c5e3b756b0e9560$var$GraphSeriesModel;




function $b48bd73bf5d69641$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $65490d05ca8b2521$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $6c5e3b756b0e9560$export$2e2bcd8739ae039));
    registers.registerProcessor((0, $23b43ea6be789dc3$export$2e2bcd8739ae039));
    registers.registerVisual((0, $2c7d64c9b3613d6b$export$2e2bcd8739ae039));
    registers.registerVisual((0, $11ee0a103a25747c$export$2e2bcd8739ae039));
    registers.registerLayout((0, $35717df2daa24f5d$export$2e2bcd8739ae039));
    registers.registerLayout(registers.PRIORITY.VISUAL.POST_CHART_LAYOUT, (0, $3c017b875f1b19fb$export$2e2bcd8739ae039));
    registers.registerLayout((0, $cd6209901c0041df$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem("graphView", {
        dimensions: (0, $4a92e7570d47c1fe$export$2e2bcd8739ae039).dimensions,
        create: (0, $8491beaca48712b9$export$2e2bcd8739ae039)
    });
    // Register legacy focus actions
    registers.registerAction({
        type: "focusNodeAdjacency",
        event: "focusNodeAdjacency",
        update: "series:focusNodeAdjacency"
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
    registers.registerAction({
        type: "unfocusNodeAdjacency",
        event: "unfocusNodeAdjacency",
        update: "series:unfocusNodeAdjacency"
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
    // Register roam action.
    registers.registerAction({
        type: "graphRoam",
        event: "graphRoam",
        update: "none"
    }, function(payload, ecModel, api) {
        ecModel.eachComponent({
            mainType: "series",
            query: payload
        }, function(seriesModel) {
            var graphView = api.getViewOfSeriesModel(seriesModel);
            if (graphView) {
                if (payload.dx != null && payload.dy != null) graphView.updateViewOnPan(seriesModel, api, payload);
                if (payload.zoom != null && payload.originX != null && payload.originY != null) graphView.updateViewOnZoom(seriesModel, api, payload);
            }
            var coordSys = seriesModel.coordinateSystem;
            var res = (0, $35fd859fd545c4be$export$94d6a16eae2c4cf4)(coordSys, payload, seriesModel.get("scaleLimit"));
            seriesModel.setCenter && seriesModel.setCenter(res.center);
            seriesModel.setZoom && seriesModel.setZoom(res.zoom);
        });
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Uint8ClampedArray */ 

var $e72df59f80933534$var$GRADIENT_LEVELS = 256;
var $e72df59f80933534$var$HeatmapLayer = /** @class */ function() {
    function HeatmapLayer() {
        this.blurSize = 30;
        this.pointSize = 20;
        this.maxOpacity = 1;
        this.minOpacity = 0;
        this._gradientPixels = {
            inRange: null,
            outOfRange: null
        };
        var canvas = (0, $c6341dcc9d86826e$export$ef5e599365494451).createCanvas();
        this.canvas = canvas;
    }
    /**
   * Renders Heatmap and returns the rendered canvas
   * @param data array of data, each has x, y, value
   * @param width canvas width
   * @param height canvas height
   */ HeatmapLayer.prototype.update = function(data, width, height, normalize, colorFunc, isInRange) {
        var brush = this._getBrush();
        var gradientInRange = this._getGradient(colorFunc, "inRange");
        var gradientOutOfRange = this._getGradient(colorFunc, "outOfRange");
        var r = this.pointSize + this.blurSize;
        var canvas = this.canvas;
        var ctx = canvas.getContext("2d");
        var len = data.length;
        canvas.width = width;
        canvas.height = height;
        for(var i = 0; i < len; ++i){
            var p = data[i];
            var x = p[0];
            var y = p[1];
            var value = p[2];
            // calculate alpha using value
            var alpha = normalize(value);
            // draw with the circle brush with alpha
            ctx.globalAlpha = alpha;
            ctx.drawImage(brush, x - r, y - r);
        }
        if (!canvas.width || !canvas.height) // Avoid "Uncaught DOMException: Failed to execute 'getImageData' on
        // 'CanvasRenderingContext2D': The source height is 0."
        return canvas;
        // colorize the canvas using alpha value and set with gradient
        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        var pixels = imageData.data;
        var offset = 0;
        var pixelLen = pixels.length;
        var minOpacity = this.minOpacity;
        var maxOpacity = this.maxOpacity;
        var diffOpacity = maxOpacity - minOpacity;
        while(offset < pixelLen){
            var alpha = pixels[offset + 3] / 256;
            var gradientOffset = Math.floor(alpha * ($e72df59f80933534$var$GRADIENT_LEVELS - 1)) * 4;
            // Simple optimize to ignore the empty data
            if (alpha > 0) {
                var gradient = isInRange(alpha) ? gradientInRange : gradientOutOfRange;
                // Any alpha > 0 will be mapped to [minOpacity, maxOpacity]
                alpha > 0 && (alpha = alpha * diffOpacity + minOpacity);
                pixels[offset++] = gradient[gradientOffset];
                pixels[offset++] = gradient[gradientOffset + 1];
                pixels[offset++] = gradient[gradientOffset + 2];
                pixels[offset++] = gradient[gradientOffset + 3] * alpha * 256;
            } else offset += 4;
        }
        ctx.putImageData(imageData, 0, 0);
        return canvas;
    };
    /**
   * get canvas of a black circle brush used for canvas to draw later
   */ HeatmapLayer.prototype._getBrush = function() {
        var brushCanvas = this._brushCanvas || (this._brushCanvas = (0, $c6341dcc9d86826e$export$ef5e599365494451).createCanvas());
        // set brush size
        var r = this.pointSize + this.blurSize;
        var d = r * 2;
        brushCanvas.width = d;
        brushCanvas.height = d;
        var ctx = brushCanvas.getContext("2d");
        ctx.clearRect(0, 0, d, d);
        // in order to render shadow without the distinct circle,
        // draw the distinct circle in an invisible place,
        // and use shadowOffset to draw shadow in the center of the canvas
        ctx.shadowOffsetX = d;
        ctx.shadowBlur = this.blurSize;
        // draw the shadow in black, and use alpha and shadow blur to generate
        // color in color map
        ctx.shadowColor = (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral99;
        // draw circle in the left to the canvas
        ctx.beginPath();
        ctx.arc(-r, r, this.pointSize, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.fill();
        return brushCanvas;
    };
    /**
   * get gradient color map
   * @private
   */ HeatmapLayer.prototype._getGradient = function(colorFunc, state) {
        var gradientPixels = this._gradientPixels;
        var pixelsSingleState = gradientPixels[state] || (gradientPixels[state] = new Uint8ClampedArray(1024));
        var color = [
            0,
            0,
            0,
            0
        ];
        var off = 0;
        for(var i = 0; i < 256; i++){
            colorFunc[state](i / 255, true, color);
            pixelsSingleState[off++] = color[0];
            pixelsSingleState[off++] = color[1];
            pixelsSingleState[off++] = color[2];
            pixelsSingleState[off++] = color[3];
        }
        return pixelsSingleState;
    };
    return HeatmapLayer;
}();
var $e72df59f80933534$export$2e2bcd8739ae039 = $e72df59f80933534$var$HeatmapLayer;






function $62f45dd0b06f949c$var$getIsInPiecewiseRange(dataExtent, pieceList, selected) {
    var dataSpan = dataExtent[1] - dataExtent[0];
    pieceList = $7a1bd9c2710fea0d$export$871de8747c9eaa88(pieceList, function(piece) {
        return {
            interval: [
                (piece.interval[0] - dataExtent[0]) / dataSpan,
                (piece.interval[1] - dataExtent[0]) / dataSpan
            ]
        };
    });
    var len = pieceList.length;
    var lastIndex = 0;
    return function(val) {
        var i;
        // Try to find in the location of the last found
        for(i = lastIndex; i < len; i++){
            var interval = pieceList[i].interval;
            if (interval[0] <= val && val <= interval[1]) {
                lastIndex = i;
                break;
            }
        }
        if (i === len) // Not found, back interation
        for(i = lastIndex - 1; i >= 0; i--){
            var interval = pieceList[i].interval;
            if (interval[0] <= val && val <= interval[1]) {
                lastIndex = i;
                break;
            }
        }
        return i >= 0 && i < len && selected[i];
    };
}
function $62f45dd0b06f949c$var$getIsInContinuousRange(dataExtent, range) {
    var dataSpan = dataExtent[1] - dataExtent[0];
    range = [
        (range[0] - dataExtent[0]) / dataSpan,
        (range[1] - dataExtent[0]) / dataSpan
    ];
    return function(val) {
        return val >= range[0] && val <= range[1];
    };
}
function $62f45dd0b06f949c$var$isGeoCoordSys(coordSys) {
    var dimensions = coordSys.dimensions;
    // Not use coordSys.type === 'geo' because coordSys maybe extended
    return dimensions[0] === "lng" && dimensions[1] === "lat";
}
var $62f45dd0b06f949c$var$HeatmapView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(HeatmapView, _super);
    function HeatmapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = HeatmapView.type;
        return _this;
    }
    HeatmapView.prototype.render = function(seriesModel, ecModel, api) {
        var visualMapOfThisSeries;
        ecModel.eachComponent("visualMap", function(visualMap) {
            visualMap.eachTargetSeries(function(targetSeries) {
                if (targetSeries === seriesModel) visualMapOfThisSeries = visualMap;
            });
        });
        // Clear previously rendered progressive elements.
        this._progressiveEls = null;
        this.group.removeAll();
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys.type === "cartesian2d" || coordSys.type === "calendar" || coordSys.type === "matrix") this._renderOnGridLike(seriesModel, api, 0, seriesModel.getData().count());
        else if ($62f45dd0b06f949c$var$isGeoCoordSys(coordSys)) this._renderOnGeo(coordSys, seriesModel, visualMapOfThisSeries, api);
    };
    HeatmapView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        this.group.removeAll();
    };
    HeatmapView.prototype.incrementalRender = function(params, seriesModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys) {
            // geo does not support incremental rendering?
            if ($62f45dd0b06f949c$var$isGeoCoordSys(coordSys)) this.render(seriesModel, ecModel, api);
            else {
                this._progressiveEls = [];
                this._renderOnGridLike(seriesModel, api, params.start, params.end, true);
            }
        }
    };
    HeatmapView.prototype.eachRendered = function(cb) {
        $5b455ae6f843ac47$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    HeatmapView.prototype._renderOnGridLike = function(seriesModel, api, start, end, incremental) {
        var coordSys = seriesModel.coordinateSystem;
        var isCartesian2d = (0, $3fea949f0512eb55$export$8567506e6336616)(coordSys, "cartesian2d");
        var isMatrix = (0, $3fea949f0512eb55$export$8567506e6336616)(coordSys, "matrix");
        var width;
        var height;
        var xAxisExtent;
        var yAxisExtent;
        if (isCartesian2d) {
            var xAxis = coordSys.getAxis("x");
            var yAxis = coordSys.getAxis("y");
            // add 0.5px to avoid the gaps
            width = xAxis.getBandWidth() + .5;
            height = yAxis.getBandWidth() + .5;
            xAxisExtent = xAxis.scale.getExtent();
            yAxisExtent = yAxis.scale.getExtent();
        }
        var group = this.group;
        var data = seriesModel.getData();
        var emphasisStyle = seriesModel.getModel([
            "emphasis",
            "itemStyle"
        ]).getItemStyle();
        var blurStyle = seriesModel.getModel([
            "blur",
            "itemStyle"
        ]).getItemStyle();
        var selectStyle = seriesModel.getModel([
            "select",
            "itemStyle"
        ]).getItemStyle();
        var borderRadius = seriesModel.get([
            "itemStyle",
            "borderRadius"
        ]);
        var labelStatesModels = (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(seriesModel);
        var emphasisModel = seriesModel.getModel("emphasis");
        var focus = emphasisModel.get("focus");
        var blurScope = emphasisModel.get("blurScope");
        var emphasisDisabled = emphasisModel.get("disabled");
        var dataDims = isCartesian2d || isMatrix ? [
            data.mapDimension("x"),
            data.mapDimension("y"),
            data.mapDimension("value")
        ] : [
            data.mapDimension("time"),
            data.mapDimension("value")
        ];
        for(var idx = start; idx < end; idx++){
            var rect = void 0;
            var style = data.getItemVisual(idx, "style");
            if (isCartesian2d) {
                var dataDimX = data.get(dataDims[0], idx);
                var dataDimY = data.get(dataDims[1], idx);
                // Ignore empty data and out of extent data
                if (isNaN(data.get(dataDims[2], idx)) || isNaN(dataDimX) || isNaN(dataDimY) || dataDimX < xAxisExtent[0] || dataDimX > xAxisExtent[1] || dataDimY < yAxisExtent[0] || dataDimY > yAxisExtent[1]) continue;
                var point = coordSys.dataToPoint([
                    dataDimX,
                    dataDimY
                ]);
                rect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
                    shape: {
                        x: point[0] - width / 2,
                        y: point[1] - height / 2,
                        width: width,
                        height: height
                    },
                    style: style
                });
            } else if (isMatrix) {
                var shape = coordSys.dataToLayout([
                    data.get(dataDims[0], idx),
                    data.get(dataDims[1], idx)
                ]).rect;
                if ($7a1bd9c2710fea0d$export$7d667b9a0c48c975(shape.x)) continue;
                rect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
                    z2: 1,
                    shape: shape,
                    style: style
                });
            } else {
                // Calendar
                // Ignore empty data
                if (isNaN(data.get(dataDims[1], idx))) continue;
                var layout = coordSys.dataToLayout([
                    data.get(dataDims[0], idx)
                ]);
                var shape = layout.contentRect || layout.rect;
                if ($7a1bd9c2710fea0d$export$7d667b9a0c48c975(shape.x) || $7a1bd9c2710fea0d$export$7d667b9a0c48c975(shape.y)) continue;
                rect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
                    z2: 1,
                    shape: shape,
                    style: style
                });
            }
            // Optimization for large dataset
            if (data.hasItemOption) {
                var itemModel = data.getItemModel(idx);
                var emphasisModel_1 = itemModel.getModel("emphasis");
                emphasisStyle = emphasisModel_1.getModel("itemStyle").getItemStyle();
                blurStyle = itemModel.getModel([
                    "blur",
                    "itemStyle"
                ]).getItemStyle();
                selectStyle = itemModel.getModel([
                    "select",
                    "itemStyle"
                ]).getItemStyle();
                // Each item value struct in the data would be firstly
                // {
                //     itemStyle: { borderRadius: [30, 30] },
                //     value: [2022, 02, 22]
                // }
                borderRadius = itemModel.get([
                    "itemStyle",
                    "borderRadius"
                ]);
                focus = emphasisModel_1.get("focus");
                blurScope = emphasisModel_1.get("blurScope");
                emphasisDisabled = emphasisModel_1.get("disabled");
                labelStatesModels = (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel);
            }
            rect.shape.r = borderRadius;
            var rawValue = seriesModel.getRawValue(idx);
            var defaultText = "-";
            if (rawValue && rawValue[2] != null) defaultText = rawValue[2] + "";
            (0, $6800dfcb6e1e2a44$export$9a13992917966657)(rect, labelStatesModels, {
                labelFetcher: seriesModel,
                labelDataIndex: idx,
                defaultOpacity: style.opacity,
                defaultText: defaultText
            });
            rect.ensureState("emphasis").style = emphasisStyle;
            rect.ensureState("blur").style = blurStyle;
            rect.ensureState("select").style = selectStyle;
            (0, $2bf82c0980125b62$export$e51187539ff11209)(rect, focus, blurScope, emphasisDisabled);
            rect.incremental = incremental;
            // PENDING
            if (incremental) // Rect must use hover layer if it's incremental.
            rect.states.emphasis.hoverLayer = true;
            group.add(rect);
            data.setItemGraphicEl(idx, rect);
            if (this._progressiveEls) this._progressiveEls.push(rect);
        }
    };
    HeatmapView.prototype._renderOnGeo = function(geo, seriesModel, visualMapModel, api) {
        var inRangeVisuals = visualMapModel.targetVisuals.inRange;
        var outOfRangeVisuals = visualMapModel.targetVisuals.outOfRange;
        // if (!visualMapping) {
        //     throw new Error('Data range must have color visuals');
        // }
        var data = seriesModel.getData();
        var hmLayer = this._hmLayer || this._hmLayer || new (0, $e72df59f80933534$export$2e2bcd8739ae039)();
        hmLayer.blurSize = seriesModel.get("blurSize");
        hmLayer.pointSize = seriesModel.get("pointSize");
        hmLayer.minOpacity = seriesModel.get("minOpacity");
        hmLayer.maxOpacity = seriesModel.get("maxOpacity");
        var rect = geo.getViewRect().clone();
        var roamTransform = geo.getRoamTransform();
        rect.applyTransform(roamTransform);
        // Clamp on viewport
        var x = Math.max(rect.x, 0);
        var y = Math.max(rect.y, 0);
        var x2 = Math.min(rect.width + rect.x, api.getWidth());
        var y2 = Math.min(rect.height + rect.y, api.getHeight());
        var width = x2 - x;
        var height = y2 - y;
        var dims = [
            data.mapDimension("lng"),
            data.mapDimension("lat"),
            data.mapDimension("value")
        ];
        var points = data.mapArray(dims, function(lng, lat, value) {
            var pt = geo.dataToPoint([
                lng,
                lat
            ]);
            pt[0] -= x;
            pt[1] -= y;
            pt.push(value);
            return pt;
        });
        var dataExtent = visualMapModel.getExtent();
        var isInRange = visualMapModel.type === "visualMap.continuous" ? $62f45dd0b06f949c$var$getIsInContinuousRange(dataExtent, visualMapModel.option.range) : $62f45dd0b06f949c$var$getIsInPiecewiseRange(dataExtent, visualMapModel.getPieceList(), visualMapModel.option.selected);
        hmLayer.update(points, width, height, inRangeVisuals.color.getNormalizer(), {
            inRange: inRangeVisuals.color.getColorMapper(),
            outOfRange: outOfRangeVisuals.color.getColorMapper()
        }, isInRange);
        var img = new $86adec94217b86c6$export$2e2bcd8739ae039({
            style: {
                width: width,
                height: height,
                x: x,
                y: y,
                image: hmLayer.canvas
            },
            silent: true
        });
        this.group.add(img);
    };
    HeatmapView.type = "heatmap";
    return HeatmapView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $62f45dd0b06f949c$export$2e2bcd8739ae039 = $62f45dd0b06f949c$var$HeatmapView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $4b84759fb7a8174c$var$HeatmapSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(HeatmapSeriesModel, _super);
    function HeatmapSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = HeatmapSeriesModel.type;
        return _this;
    }
    HeatmapSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            generateCoord: "value"
        });
    };
    HeatmapSeriesModel.prototype.preventIncremental = function() {
        var coordSysCreator = (0, $70c3ede7d3b64757$export$2e2bcd8739ae039).get(this.get("coordinateSystem"));
        if (coordSysCreator && coordSysCreator.dimensions) return coordSysCreator.dimensions[0] === "lng" && coordSysCreator.dimensions[1] === "lat";
    };
    HeatmapSeriesModel.type = "series.heatmap";
    HeatmapSeriesModel.dependencies = [
        "grid",
        "geo",
        "calendar",
        "matrix"
    ];
    HeatmapSeriesModel.defaultOption = {
        coordinateSystem: "cartesian2d",
        // zlevel: 0,
        z: 2,
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // Geo coordinate system
        geoIndex: 0,
        blurSize: 30,
        pointSize: 20,
        maxOpacity: 1,
        minOpacity: 0,
        select: {
            itemStyle: {
                borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.primary
            }
        }
    };
    return HeatmapSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $4b84759fb7a8174c$export$2e2bcd8739ae039 = $4b84759fb7a8174c$var$HeatmapSeriesModel;


function $c53e84d38e53ec61$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $62f45dd0b06f949c$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $4b84759fb7a8174c$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $04f9db15b0fa1cf8$var$LineSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LineSeriesModel, _super);
    function LineSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LineSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    LineSeriesModel.prototype.getInitialData = function(option) {
        var coordSys;
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true
        });
    };
    LineSeriesModel.prototype.getLegendIcon = function(opt) {
        var group = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        var line = (0, $5370466dadc978d7$export$af050e04da3a02e8)("line", 0, opt.itemHeight / 2, opt.itemWidth, 0, opt.lineStyle.stroke, false);
        group.add(line);
        line.setStyle(opt.lineStyle);
        var visualType = this.getData().getVisual("symbol");
        var visualRotate = this.getData().getVisual("symbolRotate");
        var symbolType = visualType === "none" ? "circle" : visualType;
        // Symbol size is 80% when there is a line
        var size = opt.itemHeight * 0.8;
        var symbol = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symbolType, (opt.itemWidth - size) / 2, (opt.itemHeight - size) / 2, size, size, opt.itemStyle.fill);
        group.add(symbol);
        symbol.setStyle(opt.itemStyle);
        var symbolRotate = opt.iconRotate === "inherit" ? visualRotate : opt.iconRotate || 0;
        symbol.rotation = symbolRotate * Math.PI / 180;
        symbol.setOrigin([
            opt.itemWidth / 2,
            opt.itemHeight / 2
        ]);
        if (symbolType.indexOf("empty") > -1) {
            symbol.style.stroke = symbol.style.fill;
            symbol.style.fill = (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral00;
            symbol.style.lineWidth = 2;
        }
        return group;
    };
    LineSeriesModel.type = "series.line";
    LineSeriesModel.dependencies = [
        "grid",
        "polar"
    ];
    LineSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 3,
        coordinateSystem: "cartesian2d",
        legendHoverLink: true,
        clip: true,
        label: {
            position: "top"
        },
        // itemStyle: {
        // },
        endLabel: {
            show: false,
            valueAnimation: true,
            distance: 8
        },
        lineStyle: {
            width: 2,
            type: "solid"
        },
        emphasis: {
            scale: true
        },
        // areaStyle: {
        // origin of areaStyle. Valid values:
        // `'auto'/null/undefined`: from axisLine to data
        // `'start'`: from min to data
        // `'end'`: from data to max
        // origin: 'auto'
        // },
        // false, 'start', 'end', 'middle'
        step: false,
        // Disabled if step is true
        smooth: false,
        smoothMonotone: null,
        symbol: "emptyCircle",
        symbolSize: 6,
        symbolRotate: null,
        showSymbol: true,
        // `false`: follow the label interval strategy.
        // `true`: show all symbols.
        // `'auto'`: If possible, show all symbols, otherwise
        //           follow the label interval strategy.
        showAllSymbol: "auto",
        // Whether to connect break point.
        connectNulls: false,
        // Sampling for large data. Can be: 'average', 'max', 'min', 'sum', 'lttb'.
        sampling: "none",
        animationEasing: "linear",
        // Disable progressive
        progressive: 0,
        hoverLayerThreshold: Infinity,
        universalTransition: {
            divideShape: "clone"
        },
        triggerLineEvent: false
    };
    return LineSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $04f9db15b0fa1cf8$export$2e2bcd8739ae039 = $04f9db15b0fa1cf8$var$LineSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $af63fd8cd32fb271$export$b488a529581b37e(coordSys, data, valueOrigin) {
    var baseAxis = coordSys.getBaseAxis();
    var valueAxis = coordSys.getOtherAxis(baseAxis);
    var valueStart = $af63fd8cd32fb271$var$getValueStart(valueAxis, valueOrigin);
    var baseAxisDim = baseAxis.dim;
    var valueAxisDim = valueAxis.dim;
    var valueDim = data.mapDimension(valueAxisDim);
    var baseDim = data.mapDimension(baseAxisDim);
    var baseDataOffset = valueAxisDim === "x" || valueAxisDim === "radius" ? 1 : 0;
    var dims = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(coordSys.dimensions, function(coordDim) {
        return data.mapDimension(coordDim);
    });
    var stacked = false;
    var stackResultDim = data.getCalculationInfo("stackResultDimension");
    if ((0, $efdd976e4917927c$export$1dedc39359ae35c)(data, dims[0])) {
        // jshint ignore:line
        stacked = true;
        dims[0] = stackResultDim;
    }
    if ((0, $efdd976e4917927c$export$1dedc39359ae35c)(data, dims[1])) {
        // jshint ignore:line
        stacked = true;
        dims[1] = stackResultDim;
    }
    return {
        dataDimsForPoint: dims,
        valueStart: valueStart,
        valueAxisDim: valueAxisDim,
        baseAxisDim: baseAxisDim,
        stacked: !!stacked,
        valueDim: valueDim,
        baseDim: baseDim,
        baseDataOffset: baseDataOffset,
        stackedOverDimension: data.getCalculationInfo("stackedOverDimension")
    };
}
function $af63fd8cd32fb271$var$getValueStart(valueAxis, valueOrigin) {
    var valueStart = 0;
    var extent = valueAxis.scale.getExtent();
    if (valueOrigin === "start") valueStart = extent[0];
    else if (valueOrigin === "end") valueStart = extent[1];
    else if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(valueOrigin) && !isNaN(valueOrigin)) valueStart = valueOrigin;
    else {
        // Both positive
        if (extent[0] > 0) valueStart = extent[0];
        else if (extent[1] < 0) valueStart = extent[1];
    // If is one positive, and one negative, onZero shall be true
    }
    return valueStart;
}
function $af63fd8cd32fb271$export$c1601aa630e7b5f8(dataCoordInfo, coordSys, data, idx) {
    var value = NaN;
    if (dataCoordInfo.stacked) value = data.get(data.getCalculationInfo("stackedOverDimension"), idx);
    if (isNaN(value)) value = dataCoordInfo.valueStart;
    var baseDataOffset = dataCoordInfo.baseDataOffset;
    var stackedData = [];
    stackedData[baseDataOffset] = data.get(dataCoordInfo.baseDim, idx);
    stackedData[1 - baseDataOffset] = value;
    return coordSys.dataToPoint(stackedData);
}



function $b022c65e2d67ded9$var$diffData(oldData, newData) {
    var diffResult = [];
    newData.diff(oldData).add(function(idx) {
        diffResult.push({
            cmd: "+",
            idx: idx
        });
    }).update(function(newIdx, oldIdx) {
        diffResult.push({
            cmd: "=",
            idx: oldIdx,
            idx1: newIdx
        });
    }).remove(function(idx) {
        diffResult.push({
            cmd: "-",
            idx: idx
        });
    }).execute();
    return diffResult;
}
function $b022c65e2d67ded9$export$2e2bcd8739ae039(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys, oldValueOrigin, newValueOrigin) {
    var diff = $b022c65e2d67ded9$var$diffData(oldData, newData);
    // let newIdList = newData.mapArray(newData.getId);
    // let oldIdList = oldData.mapArray(oldData.getId);
    // convertToIntId(newIdList, oldIdList);
    // // FIXME One data ?
    // diff = arrayDiff(oldIdList, newIdList);
    var currPoints = [];
    var nextPoints = [];
    // Points for stacking base line
    var currStackedPoints = [];
    var nextStackedPoints = [];
    var status = [];
    var sortedIndices = [];
    var rawIndices = [];
    var newDataOldCoordInfo = (0, $af63fd8cd32fb271$export$b488a529581b37e)(oldCoordSys, newData, oldValueOrigin);
    // const oldDataNewCoordInfo = prepareDataCoordInfo(newCoordSys, oldData, newValueOrigin);
    var oldPoints = oldData.getLayout("points") || [];
    var newPoints = newData.getLayout("points") || [];
    for(var i = 0; i < diff.length; i++){
        var diffItem = diff[i];
        var pointAdded = true;
        var oldIdx2 = void 0;
        var newIdx2 = void 0;
        // FIXME, animation is not so perfect when dataZoom window moves fast
        // Which is in case remvoing or add more than one data in the tail or head
        switch(diffItem.cmd){
            case "=":
                oldIdx2 = diffItem.idx * 2;
                newIdx2 = diffItem.idx1 * 2;
                var currentX = oldPoints[oldIdx2];
                var currentY = oldPoints[oldIdx2 + 1];
                var nextX = newPoints[newIdx2];
                var nextY = newPoints[newIdx2 + 1];
                // If previous data is NaN, use next point directly
                if (isNaN(currentX) || isNaN(currentY)) {
                    currentX = nextX;
                    currentY = nextY;
                }
                currPoints.push(currentX, currentY);
                nextPoints.push(nextX, nextY);
                currStackedPoints.push(oldStackedOnPoints[oldIdx2], oldStackedOnPoints[oldIdx2 + 1]);
                nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
                rawIndices.push(newData.getRawIndex(diffItem.idx1));
                break;
            case "+":
                var newIdx = diffItem.idx;
                var newDataDimsForPoint = newDataOldCoordInfo.dataDimsForPoint;
                var oldPt = oldCoordSys.dataToPoint([
                    newData.get(newDataDimsForPoint[0], newIdx),
                    newData.get(newDataDimsForPoint[1], newIdx)
                ]);
                newIdx2 = newIdx * 2;
                currPoints.push(oldPt[0], oldPt[1]);
                nextPoints.push(newPoints[newIdx2], newPoints[newIdx2 + 1]);
                var stackedOnPoint = (0, $af63fd8cd32fb271$export$c1601aa630e7b5f8)(newDataOldCoordInfo, oldCoordSys, newData, newIdx);
                currStackedPoints.push(stackedOnPoint[0], stackedOnPoint[1]);
                nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
                rawIndices.push(newData.getRawIndex(newIdx));
                break;
            case "-":
                pointAdded = false;
        }
        // Original indices
        if (pointAdded) {
            status.push(diffItem);
            sortedIndices.push(sortedIndices.length);
        }
    }
    // Diff result may be crossed if all items are changed
    // Sort by data index
    sortedIndices.sort(function(a, b) {
        return rawIndices[a] - rawIndices[b];
    });
    var len = currPoints.length;
    var sortedCurrPoints = (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(len);
    var sortedNextPoints = (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(len);
    var sortedCurrStackedPoints = (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(len);
    var sortedNextStackedPoints = (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(len);
    var sortedStatus = [];
    for(var i = 0; i < sortedIndices.length; i++){
        var idx = sortedIndices[i];
        var i2 = i * 2;
        var idx2 = idx * 2;
        sortedCurrPoints[i2] = currPoints[idx2];
        sortedCurrPoints[i2 + 1] = currPoints[idx2 + 1];
        sortedNextPoints[i2] = nextPoints[idx2];
        sortedNextPoints[i2 + 1] = nextPoints[idx2 + 1];
        sortedCurrStackedPoints[i2] = currStackedPoints[idx2];
        sortedCurrStackedPoints[i2 + 1] = currStackedPoints[idx2 + 1];
        sortedNextStackedPoints[i2] = nextStackedPoints[idx2];
        sortedNextStackedPoints[i2 + 1] = nextStackedPoints[idx2 + 1];
        sortedStatus[i] = status[idx];
    }
    return {
        current: sortedCurrPoints,
        next: sortedNextPoints,
        stackedOnCurrent: sortedCurrStackedPoints,
        stackedOnNext: sortedNextStackedPoints,
        status: sortedStatus
    };
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $5c417e1ed90142c5$var$mathMin = Math.min;
var $5c417e1ed90142c5$var$mathMax = Math.max;
function $5c417e1ed90142c5$var$isPointNull(x, y) {
    return isNaN(x) || isNaN(y);
}
/**
 * Draw smoothed line in non-monotone, in may cause undesired curve in extreme
 * situations. This should be used when points are non-monotone neither in x or
 * y dimension.
 */ function $5c417e1ed90142c5$var$drawSegment(ctx, points, start, segLen, allLen, dir, smooth, smoothMonotone, connectNulls) {
    var prevX;
    var prevY;
    var cpx0;
    var cpy0;
    var cpx1;
    var cpy1;
    var idx = start;
    var k = 0;
    for(; k < segLen; k++){
        var x = points[idx * 2];
        var y = points[idx * 2 + 1];
        if (idx >= allLen || idx < 0) break;
        if ($5c417e1ed90142c5$var$isPointNull(x, y)) {
            if (connectNulls) {
                idx += dir;
                continue;
            }
            break;
        }
        if (idx === start) {
            ctx[dir > 0 ? "moveTo" : "lineTo"](x, y);
            cpx0 = x;
            cpy0 = y;
        } else {
            var dx = x - prevX;
            var dy = y - prevY;
            // Ignore tiny segment.
            if (dx * dx + dy * dy < 0.5) {
                idx += dir;
                continue;
            }
            if (smooth > 0) {
                var nextIdx = idx + dir;
                var nextX = points[nextIdx * 2];
                var nextY = points[nextIdx * 2 + 1];
                // Ignore duplicate point
                while(nextX === x && nextY === y && k < segLen){
                    k++;
                    nextIdx += dir;
                    idx += dir;
                    nextX = points[nextIdx * 2];
                    nextY = points[nextIdx * 2 + 1];
                    x = points[idx * 2];
                    y = points[idx * 2 + 1];
                    dx = x - prevX;
                    dy = y - prevY;
                }
                var tmpK = k + 1;
                if (connectNulls) // Find next point not null
                while($5c417e1ed90142c5$var$isPointNull(nextX, nextY) && tmpK < segLen){
                    tmpK++;
                    nextIdx += dir;
                    nextX = points[nextIdx * 2];
                    nextY = points[nextIdx * 2 + 1];
                }
                var ratioNextSeg = 0.5;
                var vx = 0;
                var vy = 0;
                var nextCpx0 = void 0;
                var nextCpy0 = void 0;
                // Is last point
                if (tmpK >= segLen || $5c417e1ed90142c5$var$isPointNull(nextX, nextY)) {
                    cpx1 = x;
                    cpy1 = y;
                } else {
                    vx = nextX - prevX;
                    vy = nextY - prevY;
                    var dx0 = x - prevX;
                    var dx1 = nextX - x;
                    var dy0 = y - prevY;
                    var dy1 = nextY - y;
                    var lenPrevSeg = void 0;
                    var lenNextSeg = void 0;
                    if (smoothMonotone === "x") {
                        lenPrevSeg = Math.abs(dx0);
                        lenNextSeg = Math.abs(dx1);
                        var dir_1 = vx > 0 ? 1 : -1;
                        cpx1 = x - dir_1 * lenPrevSeg * smooth;
                        cpy1 = y;
                        nextCpx0 = x + dir_1 * lenNextSeg * smooth;
                        nextCpy0 = y;
                    } else if (smoothMonotone === "y") {
                        lenPrevSeg = Math.abs(dy0);
                        lenNextSeg = Math.abs(dy1);
                        var dir_2 = vy > 0 ? 1 : -1;
                        cpx1 = x;
                        cpy1 = y - dir_2 * lenPrevSeg * smooth;
                        nextCpx0 = x;
                        nextCpy0 = y + dir_2 * lenNextSeg * smooth;
                    } else {
                        lenPrevSeg = Math.sqrt(dx0 * dx0 + dy0 * dy0);
                        lenNextSeg = Math.sqrt(dx1 * dx1 + dy1 * dy1);
                        // Use ratio of seg length
                        ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
                        cpx1 = x - vx * smooth * (1 - ratioNextSeg);
                        cpy1 = y - vy * smooth * (1 - ratioNextSeg);
                        // cp0 of next segment
                        nextCpx0 = x + vx * smooth * ratioNextSeg;
                        nextCpy0 = y + vy * smooth * ratioNextSeg;
                        // Smooth constraint between point and next point.
                        // Avoid exceeding extreme after smoothing.
                        nextCpx0 = $5c417e1ed90142c5$var$mathMin(nextCpx0, $5c417e1ed90142c5$var$mathMax(nextX, x));
                        nextCpy0 = $5c417e1ed90142c5$var$mathMin(nextCpy0, $5c417e1ed90142c5$var$mathMax(nextY, y));
                        nextCpx0 = $5c417e1ed90142c5$var$mathMax(nextCpx0, $5c417e1ed90142c5$var$mathMin(nextX, x));
                        nextCpy0 = $5c417e1ed90142c5$var$mathMax(nextCpy0, $5c417e1ed90142c5$var$mathMin(nextY, y));
                        // Reclaculate cp1 based on the adjusted cp0 of next seg.
                        vx = nextCpx0 - x;
                        vy = nextCpy0 - y;
                        cpx1 = x - vx * lenPrevSeg / lenNextSeg;
                        cpy1 = y - vy * lenPrevSeg / lenNextSeg;
                        // Smooth constraint between point and prev point.
                        // Avoid exceeding extreme after smoothing.
                        cpx1 = $5c417e1ed90142c5$var$mathMin(cpx1, $5c417e1ed90142c5$var$mathMax(prevX, x));
                        cpy1 = $5c417e1ed90142c5$var$mathMin(cpy1, $5c417e1ed90142c5$var$mathMax(prevY, y));
                        cpx1 = $5c417e1ed90142c5$var$mathMax(cpx1, $5c417e1ed90142c5$var$mathMin(prevX, x));
                        cpy1 = $5c417e1ed90142c5$var$mathMax(cpy1, $5c417e1ed90142c5$var$mathMin(prevY, y));
                        // Adjust next cp0 again.
                        vx = x - cpx1;
                        vy = y - cpy1;
                        nextCpx0 = x + vx * lenNextSeg / lenPrevSeg;
                        nextCpy0 = y + vy * lenNextSeg / lenPrevSeg;
                    }
                }
                ctx.bezierCurveTo(cpx0, cpy0, cpx1, cpy1, x, y);
                cpx0 = nextCpx0;
                cpy0 = nextCpy0;
            } else ctx.lineTo(x, y);
        }
        prevX = x;
        prevY = y;
        idx += dir;
    }
    return k;
}
var $5c417e1ed90142c5$var$ECPolylineShape = /** @class */ function() {
    function ECPolylineShape() {
        this.smooth = 0;
        this.smoothConstraint = true;
    }
    return ECPolylineShape;
}();
var $5c417e1ed90142c5$export$bf7c0585b8f7d00f = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ECPolyline, _super);
    function ECPolyline(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "ec-polyline";
        return _this;
    }
    ECPolyline.prototype.getDefaultStyle = function() {
        return {
            stroke: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral99,
            fill: null
        };
    };
    ECPolyline.prototype.getDefaultShape = function() {
        return new $5c417e1ed90142c5$var$ECPolylineShape();
    };
    ECPolyline.prototype.buildPath = function(ctx, shape) {
        var points = shape.points;
        var i = 0;
        var len = points.length / 2;
        // const result = getBoundingBox(points, shape.smoothConstraint);
        if (shape.connectNulls) {
            // Must remove first and last null values avoid draw error in polygon
            for(; len > 0; len--){
                if (!$5c417e1ed90142c5$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
            }
            for(; i < len; i++){
                if (!$5c417e1ed90142c5$var$isPointNull(points[i * 2], points[i * 2 + 1])) break;
            }
        }
        while(i < len)i += $5c417e1ed90142c5$var$drawSegment(ctx, points, i, len, len, 1, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
    };
    ECPolyline.prototype.getPointOn = function(xOrY, dim) {
        if (!this.path) {
            this.createPathProxy();
            this.buildPath(this.path, this.shape);
        }
        var path = this.path;
        var data = path.data;
        var CMD = (0, $20ebe2448f123f2e$export$2e2bcd8739ae039).CMD;
        var x0;
        var y0;
        var isDimX = dim === "x";
        var roots = [];
        for(var i = 0; i < data.length;){
            var cmd = data[i++];
            var x = void 0;
            var y = void 0;
            var x2 = void 0;
            var y2 = void 0;
            var x3 = void 0;
            var y3 = void 0;
            var t = void 0;
            switch(cmd){
                case CMD.M:
                    x0 = data[i++];
                    y0 = data[i++];
                    break;
                case CMD.L:
                    x = data[i++];
                    y = data[i++];
                    t = isDimX ? (xOrY - x0) / (x - x0) : (xOrY - y0) / (y - y0);
                    if (t <= 1 && t >= 0) {
                        var val = isDimX ? (y - y0) * t + y0 : (x - x0) * t + x0;
                        return isDimX ? [
                            xOrY,
                            val
                        ] : [
                            val,
                            xOrY
                        ];
                    }
                    x0 = x;
                    y0 = y;
                    break;
                case CMD.C:
                    x = data[i++];
                    y = data[i++];
                    x2 = data[i++];
                    y2 = data[i++];
                    x3 = data[i++];
                    y3 = data[i++];
                    var nRoot = isDimX ? (0, $747cfc5611b57cea$export$ca5d13faa10b167e)(x0, x, x2, x3, xOrY, roots) : (0, $747cfc5611b57cea$export$ca5d13faa10b167e)(y0, y, y2, y3, xOrY, roots);
                    if (nRoot > 0) for(var i_1 = 0; i_1 < nRoot; i_1++){
                        var t_1 = roots[i_1];
                        if (t_1 <= 1 && t_1 >= 0) {
                            var val = isDimX ? (0, $747cfc5611b57cea$export$547c21de482bbcb2)(y0, y, y2, y3, t_1) : (0, $747cfc5611b57cea$export$547c21de482bbcb2)(x0, x, x2, x3, t_1);
                            return isDimX ? [
                                xOrY,
                                val
                            ] : [
                                val,
                                xOrY
                            ];
                        }
                    }
                    x0 = x3;
                    y0 = y3;
                    break;
            }
        }
    };
    return ECPolyline;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
var $5c417e1ed90142c5$var$ECPolygonShape = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ECPolygonShape, _super);
    function ECPolygonShape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ECPolygonShape;
}($5c417e1ed90142c5$var$ECPolylineShape);
var $5c417e1ed90142c5$export$6042a400d113f2bd = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ECPolygon, _super);
    function ECPolygon(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "ec-polygon";
        return _this;
    }
    ECPolygon.prototype.getDefaultShape = function() {
        return new $5c417e1ed90142c5$var$ECPolygonShape();
    };
    ECPolygon.prototype.buildPath = function(ctx, shape) {
        var points = shape.points;
        var stackedOnPoints = shape.stackedOnPoints;
        var i = 0;
        var len = points.length / 2;
        var smoothMonotone = shape.smoothMonotone;
        if (shape.connectNulls) {
            // Must remove first and last null values avoid draw error in polygon
            for(; len > 0; len--){
                if (!$5c417e1ed90142c5$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
            }
            for(; i < len; i++){
                if (!$5c417e1ed90142c5$var$isPointNull(points[i * 2], points[i * 2 + 1])) break;
            }
        }
        while(i < len){
            var k = $5c417e1ed90142c5$var$drawSegment(ctx, points, i, len, len, 1, shape.smooth, smoothMonotone, shape.connectNulls);
            $5c417e1ed90142c5$var$drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
            i += k + 1;
            ctx.closePath();
        }
    };
    return ECPolygon;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));













function $ada57dad04d4bbf5$var$isPointsSame(points1, points2) {
    if (points1.length !== points2.length) return;
    for(var i = 0; i < points1.length; i++){
        if (points1[i] !== points2[i]) return;
    }
    return true;
}
function $ada57dad04d4bbf5$var$bboxFromPoints(points) {
    var minX = Infinity;
    var minY = Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;
    for(var i = 0; i < points.length;){
        var x = points[i++];
        var y = points[i++];
        if (!isNaN(x)) {
            minX = Math.min(x, minX);
            maxX = Math.max(x, maxX);
        }
        if (!isNaN(y)) {
            minY = Math.min(y, minY);
            maxY = Math.max(y, maxY);
        }
    }
    return [
        [
            minX,
            minY
        ],
        [
            maxX,
            maxY
        ]
    ];
}
function $ada57dad04d4bbf5$var$getBoundingDiff(points1, points2) {
    var _a = $ada57dad04d4bbf5$var$bboxFromPoints(points1), min1 = _a[0], max1 = _a[1];
    var _b = $ada57dad04d4bbf5$var$bboxFromPoints(points2), min2 = _b[0], max2 = _b[1];
    // Get a max value from each corner of two boundings.
    return Math.max(Math.abs(min1[0] - min2[0]), Math.abs(min1[1] - min2[1]), Math.abs(max1[0] - max2[0]), Math.abs(max1[1] - max2[1]));
}
function $ada57dad04d4bbf5$var$getSmooth(smooth) {
    return $7a1bd9c2710fea0d$export$7e4aa119212bc614(smooth) ? smooth : smooth ? 0.5 : 0;
}
function $ada57dad04d4bbf5$var$getStackedOnPoints(coordSys, data, dataCoordInfo) {
    if (!dataCoordInfo.valueDim) return [];
    var len = data.count();
    var points = (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(len * 2);
    for(var idx = 0; idx < len; idx++){
        var pt = (0, $af63fd8cd32fb271$export$c1601aa630e7b5f8)(dataCoordInfo, coordSys, data, idx);
        points[idx * 2] = pt[0];
        points[idx * 2 + 1] = pt[1];
    }
    return points;
}
/**
 * Filter the null data and extend data for step considering `stepTurnAt`
 *
 * @param points data to convert, that may containing null
 * @param basePoints base data to reference, used only for areaStyle points
 * @param coordSys coordinate system
 * @param stepTurnAt 'start' | 'end' | 'middle' | true
 * @param connectNulls whether to connect nulls
 * @returns converted point positions
 */ function $ada57dad04d4bbf5$var$turnPointsIntoStep(points, basePoints, coordSys, stepTurnAt, connectNulls) {
    var baseAxis = coordSys.getBaseAxis();
    var baseIndex = baseAxis.dim === "x" || baseAxis.dim === "radius" ? 0 : 1;
    var stepPoints = [];
    var i = 0;
    var stepPt = [];
    var pt = [];
    var nextPt = [];
    var filteredPoints = [];
    if (connectNulls) {
        for(i = 0; i < points.length; i += 2){
            /**
       * For areaStyle of stepped lines, `stackedOnPoints` should be
       * filtered the same as `points` so that the base axis values
       * should stay the same as the lines above. See #20021
       */ var reference = basePoints || points;
            if (!isNaN(reference[i]) && !isNaN(reference[i + 1])) filteredPoints.push(points[i], points[i + 1]);
        }
        points = filteredPoints;
    }
    for(i = 0; i < points.length - 2; i += 2){
        nextPt[0] = points[i + 2];
        nextPt[1] = points[i + 3];
        pt[0] = points[i];
        pt[1] = points[i + 1];
        stepPoints.push(pt[0], pt[1]);
        switch(stepTurnAt){
            case "end":
                stepPt[baseIndex] = nextPt[baseIndex];
                stepPt[1 - baseIndex] = pt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
                break;
            case "middle":
                var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
                var stepPt2 = [];
                stepPt[baseIndex] = stepPt2[baseIndex] = middle;
                stepPt[1 - baseIndex] = pt[1 - baseIndex];
                stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
                stepPoints.push(stepPt2[0], stepPt2[1]);
                break;
            default:
                // default is start
                stepPt[baseIndex] = pt[baseIndex];
                stepPt[1 - baseIndex] = nextPt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
        }
    }
    // Last points
    stepPoints.push(points[i++], points[i++]);
    return stepPoints;
}
/**
 * Clip color stops to edge. Avoid creating too large gradients.
 * Which may lead to blurry when GPU acceleration is enabled. See #15680
 *
 * The stops has been sorted from small to large.
 */ function $ada57dad04d4bbf5$var$clipColorStops(colorStops, maxSize) {
    var newColorStops = [];
    var len = colorStops.length;
    // coord will always < 0 in prevOutOfRangeColorStop.
    var prevOutOfRangeColorStop;
    var prevInRangeColorStop;
    function lerpStop(stop0, stop1, clippedCoord) {
        var coord0 = stop0.coord;
        var p = (clippedCoord - coord0) / (stop1.coord - coord0);
        var color = (0, $2c037f5bda6341ca$export$3a89f8d6f6bf6c9f)(p, [
            stop0.color,
            stop1.color
        ]);
        return {
            coord: clippedCoord,
            color: color
        };
    }
    for(var i = 0; i < len; i++){
        var stop_1 = colorStops[i];
        var coord = stop_1.coord;
        if (coord < 0) prevOutOfRangeColorStop = stop_1;
        else if (coord > maxSize) {
            if (prevInRangeColorStop) newColorStops.push(lerpStop(prevInRangeColorStop, stop_1, maxSize));
            else if (prevOutOfRangeColorStop) // If there are two stops and coord range is between these two stops
            newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0), lerpStop(prevOutOfRangeColorStop, stop_1, maxSize));
            break;
        } else {
            if (prevOutOfRangeColorStop) {
                newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0));
                // Reset
                prevOutOfRangeColorStop = null;
            }
            newColorStops.push(stop_1);
            prevInRangeColorStop = stop_1;
        }
    }
    return newColorStops;
}
function $ada57dad04d4bbf5$var$getVisualGradient(data, coordSys, api) {
    var visualMetaList = data.getVisual("visualMeta");
    if (!visualMetaList || !visualMetaList.length || !data.count()) // When data.count() is 0, gradient range can not be calculated.
    return;
    if (coordSys.type !== "cartesian2d") return;
    var coordDim;
    var visualMeta;
    for(var i = visualMetaList.length - 1; i >= 0; i--){
        var dimInfo = data.getDimensionInfo(visualMetaList[i].dimension);
        coordDim = dimInfo && dimInfo.coordDim;
        // Can only be x or y
        if (coordDim === "x" || coordDim === "y") {
            visualMeta = visualMetaList[i];
            break;
        }
    }
    if (!visualMeta) return;
    // If the area to be rendered is bigger than area defined by LinearGradient,
    // the canvas spec prescribes that the color of the first stop and the last
    // stop should be used. But if two stops are added at offset 0, in effect
    // browsers use the color of the second stop to render area outside
    // LinearGradient. So we can only infinitesimally extend area defined in
    // LinearGradient to render `outerColors`.
    var axis = coordSys.getAxis(coordDim);
    // dataToCoord mapping may not be linear, but must be monotonic.
    var colorStops = $7a1bd9c2710fea0d$export$871de8747c9eaa88(visualMeta.stops, function(stop) {
        // offset will be calculated later.
        return {
            coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
            color: stop.color
        };
    });
    var stopLen = colorStops.length;
    var outerColors = visualMeta.outerColors.slice();
    if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
        colorStops.reverse();
        outerColors.reverse();
    }
    var colorStopsInRange = $ada57dad04d4bbf5$var$clipColorStops(colorStops, coordDim === "x" ? api.getWidth() : api.getHeight());
    var inRangeStopLen = colorStopsInRange.length;
    if (!inRangeStopLen && stopLen) // All stops are out of range. All will be the same color.
    return colorStops[0].coord < 0 ? outerColors[1] ? outerColors[1] : colorStops[stopLen - 1].color : outerColors[0] ? outerColors[0] : colorStops[0].color;
    var tinyExtent = 10; // Arbitrary value: 10px
    var minCoord = colorStopsInRange[0].coord - tinyExtent;
    var maxCoord = colorStopsInRange[inRangeStopLen - 1].coord + tinyExtent;
    var coordSpan = maxCoord - minCoord;
    if (coordSpan < 1e-3) return "transparent";
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(colorStopsInRange, function(stop) {
        stop.offset = (stop.coord - minCoord) / coordSpan;
    });
    colorStopsInRange.push({
        // NOTE: inRangeStopLen may still be 0 if stoplen is zero.
        offset: inRangeStopLen ? colorStopsInRange[inRangeStopLen - 1].offset : 0.5,
        color: outerColors[1] || "transparent"
    });
    colorStopsInRange.unshift({
        offset: inRangeStopLen ? colorStopsInRange[0].offset : 0.5,
        color: outerColors[0] || "transparent"
    });
    var gradient = new $cf44c01491b58e53$export$2e2bcd8739ae039(0, 0, 0, 0, colorStopsInRange, true);
    gradient[coordDim] = minCoord;
    gradient[coordDim + "2"] = maxCoord;
    return gradient;
}
function $ada57dad04d4bbf5$var$getIsIgnoreFunc(seriesModel, data, coordSys) {
    var showAllSymbol = seriesModel.get("showAllSymbol");
    var isAuto = showAllSymbol === "auto";
    if (showAllSymbol && !isAuto) return;
    var categoryAxis = coordSys.getAxesByScale("ordinal")[0];
    if (!categoryAxis) return;
    // Note that category label interval strategy might bring some weird effect
    // in some scenario: users may wonder why some of the symbols are not
    // displayed. So we show all symbols as possible as we can.
    if (isAuto && $ada57dad04d4bbf5$var$canShowAllSymbolForCategory(categoryAxis, data)) return;
    // Otherwise follow the label interval strategy on category axis.
    var categoryDataDim = data.mapDimension(categoryAxis.dim);
    var labelMap = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(categoryAxis.getViewLabels(), function(labelItem) {
        var ordinalNumber = categoryAxis.scale.getRawOrdinalNumber(labelItem.tickValue);
        labelMap[ordinalNumber] = 1;
    });
    return function(dataIndex) {
        return !labelMap.hasOwnProperty(data.get(categoryDataDim, dataIndex));
    };
}
function $ada57dad04d4bbf5$var$canShowAllSymbolForCategory(categoryAxis, data) {
    // In most cases, line is monotonous on category axis, and the label size
    // is close with each other. So we check the symbol size and some of the
    // label size alone with the category axis to estimate whether all symbol
    // can be shown without overlap.
    var axisExtent = categoryAxis.getExtent();
    var availSize = Math.abs(axisExtent[1] - axisExtent[0]) / categoryAxis.scale.count();
    isNaN(availSize) && (availSize = 0); // 0/0 is NaN.
    // Sampling some points, max 5.
    var dataLen = data.count();
    var step = Math.max(1, Math.round(dataLen / 5));
    for(var dataIndex = 0; dataIndex < dataLen; dataIndex += step){
        if ((0, $b1d9c3e17ccace80$export$2e2bcd8739ae039).getSymbolSize(data, dataIndex)[categoryAxis.isHorizontal() ? 1 : 0] * 1.5 > availSize) return false;
    }
    return true;
}
function $ada57dad04d4bbf5$var$isPointNull(x, y) {
    return isNaN(x) || isNaN(y);
}
function $ada57dad04d4bbf5$var$getLastIndexNotNull(points) {
    var len = points.length / 2;
    for(; len > 0; len--){
        if (!$ada57dad04d4bbf5$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
    }
    return len - 1;
}
function $ada57dad04d4bbf5$var$getPointAtIndex(points, idx) {
    return [
        points[idx * 2],
        points[idx * 2 + 1]
    ];
}
function $ada57dad04d4bbf5$var$getIndexRange(points, xOrY, dim) {
    var len = points.length / 2;
    var dimIdx = dim === "x" ? 0 : 1;
    var a;
    var b;
    var prevIndex = 0;
    var nextIndex = -1;
    for(var i = 0; i < len; i++){
        b = points[i * 2 + dimIdx];
        if (isNaN(b) || isNaN(points[i * 2 + 1 - dimIdx])) continue;
        if (i === 0) {
            a = b;
            continue;
        }
        if (a <= xOrY && b >= xOrY || a >= xOrY && b <= xOrY) {
            nextIndex = i;
            break;
        }
        prevIndex = i;
        a = b;
    }
    return {
        range: [
            prevIndex,
            nextIndex
        ],
        t: (xOrY - a) / (b - a)
    };
}
function $ada57dad04d4bbf5$var$anyStateShowEndLabel(seriesModel) {
    if (seriesModel.get([
        "endLabel",
        "show"
    ])) return true;
    for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
        if (seriesModel.get([
            (0, $2bf82c0980125b62$export$151308dceb52d5b)[i],
            "endLabel",
            "show"
        ])) return true;
    }
    return false;
}
function $ada57dad04d4bbf5$var$createLineClipPath(lineView, coordSys, hasAnimation, seriesModel) {
    if ((0, $3fea949f0512eb55$export$8567506e6336616)(coordSys, "cartesian2d")) {
        var endLabelModel_1 = seriesModel.getModel("endLabel");
        var valueAnimation_1 = endLabelModel_1.get("valueAnimation");
        var data_1 = seriesModel.getData();
        var labelAnimationRecord_1 = {
            lastFrameIndex: 0
        };
        var during = $ada57dad04d4bbf5$var$anyStateShowEndLabel(seriesModel) ? function(percent, clipRect) {
            lineView._endLabelOnDuring(percent, clipRect, data_1, labelAnimationRecord_1, valueAnimation_1, endLabelModel_1, coordSys);
        } : null;
        var isHorizontal = coordSys.getBaseAxis().isHorizontal();
        var clipPath = (0, $0e2cc04b3aaad400$export$83958787eb658d14)(coordSys, hasAnimation, seriesModel, function() {
            var endLabel = lineView._endLabel;
            if (endLabel && hasAnimation) {
                if (labelAnimationRecord_1.originalX != null) endLabel.attr({
                    x: labelAnimationRecord_1.originalX,
                    y: labelAnimationRecord_1.originalY
                });
            }
        }, during);
        // Expand clip shape to avoid clipping when line value exceeds axis
        if (!seriesModel.get("clip", true)) {
            var rectShape = clipPath.shape;
            var expandSize = Math.max(rectShape.width, rectShape.height);
            if (isHorizontal) {
                rectShape.y -= expandSize;
                rectShape.height += expandSize * 2;
            } else {
                rectShape.x -= expandSize;
                rectShape.width += expandSize * 2;
            }
        }
        // Set to the final frame. To make sure label layout is right.
        if (during) during(1, clipPath);
        return clipPath;
    } else return (0, $0e2cc04b3aaad400$export$13dc2b2230df3cb5)(coordSys, hasAnimation, seriesModel);
}
function $ada57dad04d4bbf5$var$getEndLabelStateSpecified(endLabelModel, coordSys) {
    var baseAxis = coordSys.getBaseAxis();
    var isHorizontal = baseAxis.isHorizontal();
    var isBaseInversed = baseAxis.inverse;
    var align = isHorizontal ? isBaseInversed ? "right" : "left" : "center";
    var verticalAlign = isHorizontal ? "middle" : isBaseInversed ? "top" : "bottom";
    return {
        normal: {
            align: endLabelModel.get("align") || align,
            verticalAlign: endLabelModel.get("verticalAlign") || verticalAlign
        }
    };
}
var $ada57dad04d4bbf5$var$LineView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LineView, _super);
    function LineView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LineView.prototype.init = function() {
        var lineGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        var symbolDraw = new (0, $fedf62268297fcbb$export$2e2bcd8739ae039)();
        this.group.add(symbolDraw.group);
        this._symbolDraw = symbolDraw;
        this._lineGroup = lineGroup;
        this._changePolyState = $7a1bd9c2710fea0d$export$2385a24977818dd0(this._changePolyState, this);
    };
    LineView.prototype.render = function(seriesModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var group = this.group;
        var data = seriesModel.getData();
        var lineStyleModel = seriesModel.getModel("lineStyle");
        var areaStyleModel = seriesModel.getModel("areaStyle");
        var points = data.getLayout("points") || [];
        var isCoordSysPolar = coordSys.type === "polar";
        var prevCoordSys = this._coordSys;
        var symbolDraw = this._symbolDraw;
        var polyline = this._polyline;
        var polygon = this._polygon;
        var lineGroup = this._lineGroup;
        var hasAnimation = !ecModel.ssr && seriesModel.get("animation");
        var isAreaChart = !areaStyleModel.isEmpty();
        var valueOrigin = areaStyleModel.get("origin");
        var dataCoordInfo = (0, $af63fd8cd32fb271$export$b488a529581b37e)(coordSys, data, valueOrigin);
        var stackedOnPoints = isAreaChart && $ada57dad04d4bbf5$var$getStackedOnPoints(coordSys, data, dataCoordInfo);
        var showSymbol = seriesModel.get("showSymbol");
        var connectNulls = seriesModel.get("connectNulls");
        var isIgnoreFunc = showSymbol && !isCoordSysPolar && $ada57dad04d4bbf5$var$getIsIgnoreFunc(seriesModel, data, coordSys);
        // Remove temporary symbols
        var oldData = this._data;
        oldData && oldData.eachItemGraphicEl(function(el, idx) {
            if (el.__temp) {
                group.remove(el);
                oldData.setItemGraphicEl(idx, null);
            }
        });
        // Remove previous created symbols if showSymbol changed to false
        if (!showSymbol) symbolDraw.remove();
        group.add(lineGroup);
        // FIXME step not support polar
        var step = !isCoordSysPolar ? seriesModel.get("step") : false;
        var clipShapeForSymbol;
        if (coordSys && coordSys.getArea && seriesModel.get("clip", true)) {
            clipShapeForSymbol = coordSys.getArea();
            // Avoid float number rounding error for symbol on the edge of axis extent.
            // See #7913 and `test/dataZoom-clip.html`.
            if (clipShapeForSymbol.width != null) {
                clipShapeForSymbol.x -= 0.1;
                clipShapeForSymbol.y -= 0.1;
                clipShapeForSymbol.width += 0.2;
                clipShapeForSymbol.height += 0.2;
            } else if (clipShapeForSymbol.r0) {
                clipShapeForSymbol.r0 -= 0.5;
                clipShapeForSymbol.r += 0.5;
            }
        }
        this._clipShapeForSymbol = clipShapeForSymbol;
        var visualColor = $ada57dad04d4bbf5$var$getVisualGradient(data, coordSys, api) || data.getVisual("style")[data.getVisual("drawType")];
        // Initialization animation or coordinate system changed
        if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
            showSymbol && symbolDraw.updateData(data, {
                isIgnore: isIgnoreFunc,
                clipShape: clipShapeForSymbol,
                disableAnimation: true,
                getSymbolPoint: function(idx) {
                    return [
                        points[idx * 2],
                        points[idx * 2 + 1]
                    ];
                }
            });
            hasAnimation && this._initSymbolLabelAnimation(data, coordSys, clipShapeForSymbol);
            if (step) {
                if (stackedOnPoints) stackedOnPoints = $ada57dad04d4bbf5$var$turnPointsIntoStep(stackedOnPoints, points, coordSys, step, connectNulls);
                // TODO If stacked series is not step
                points = $ada57dad04d4bbf5$var$turnPointsIntoStep(points, null, coordSys, step, connectNulls);
            }
            polyline = this._newPolyline(points);
            if (isAreaChart) polygon = this._newPolygon(points, stackedOnPoints);
            else if (polygon) {
                lineGroup.remove(polygon);
                polygon = this._polygon = null;
            }
            // NOTE: Must update _endLabel before setClipPath.
            if (!isCoordSysPolar) this._initOrUpdateEndLabel(seriesModel, coordSys, (0, $c84c9521536c601a$export$cda04d03233e5555)(visualColor));
            lineGroup.setClipPath($ada57dad04d4bbf5$var$createLineClipPath(this, coordSys, true, seriesModel));
        } else {
            if (isAreaChart && !polygon) // If areaStyle is added
            polygon = this._newPolygon(points, stackedOnPoints);
            else if (polygon && !isAreaChart) {
                // If areaStyle is removed
                lineGroup.remove(polygon);
                polygon = this._polygon = null;
            }
            // NOTE: Must update _endLabel before setClipPath.
            if (!isCoordSysPolar) this._initOrUpdateEndLabel(seriesModel, coordSys, (0, $c84c9521536c601a$export$cda04d03233e5555)(visualColor));
            // Update clipPath
            var oldClipPath = lineGroup.getClipPath();
            if (oldClipPath) {
                var newClipPath = $ada57dad04d4bbf5$var$createLineClipPath(this, coordSys, false, seriesModel);
                $8b353638fbedfefa$export$a121566aadcfe021(oldClipPath, {
                    shape: newClipPath.shape
                }, seriesModel);
            } else lineGroup.setClipPath($ada57dad04d4bbf5$var$createLineClipPath(this, coordSys, true, seriesModel));
            // Always update, or it is wrong in the case turning on legend
            // because points are not changed.
            showSymbol && symbolDraw.updateData(data, {
                isIgnore: isIgnoreFunc,
                clipShape: clipShapeForSymbol,
                disableAnimation: true,
                getSymbolPoint: function(idx) {
                    return [
                        points[idx * 2],
                        points[idx * 2 + 1]
                    ];
                }
            });
            // In the case data zoom triggered refreshing frequently
            // Data may not change if line has a category axis. So it should animate nothing.
            if (!$ada57dad04d4bbf5$var$isPointsSame(this._stackedOnPoints, stackedOnPoints) || !$ada57dad04d4bbf5$var$isPointsSame(this._points, points)) {
                if (hasAnimation) this._doUpdateAnimation(data, stackedOnPoints, coordSys, api, step, valueOrigin, connectNulls);
                else {
                    // Not do it in update with animation
                    if (step) {
                        if (stackedOnPoints) stackedOnPoints = $ada57dad04d4bbf5$var$turnPointsIntoStep(stackedOnPoints, points, coordSys, step, connectNulls);
                        // TODO If stacked series is not step
                        points = $ada57dad04d4bbf5$var$turnPointsIntoStep(points, null, coordSys, step, connectNulls);
                    }
                    polyline.setShape({
                        points: points
                    });
                    polygon && polygon.setShape({
                        points: points,
                        stackedOnPoints: stackedOnPoints
                    });
                }
            }
        }
        var emphasisModel = seriesModel.getModel("emphasis");
        var focus = emphasisModel.get("focus");
        var blurScope = emphasisModel.get("blurScope");
        var emphasisDisabled = emphasisModel.get("disabled");
        polyline.useStyle($7a1bd9c2710fea0d$export$ebe90cb607ad99e(// Use color in lineStyle first
        lineStyleModel.getLineStyle(), {
            fill: "none",
            stroke: visualColor,
            lineJoin: "bevel"
        }));
        (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polyline, seriesModel, "lineStyle");
        if (polyline.style.lineWidth > 0 && seriesModel.get([
            "emphasis",
            "lineStyle",
            "width"
        ]) === "bolder") {
            var emphasisLineStyle = polyline.getState("emphasis").style;
            emphasisLineStyle.lineWidth = +polyline.style.lineWidth + 1;
        }
        // Needs seriesIndex for focus
        (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(polyline).seriesIndex = seriesModel.seriesIndex;
        (0, $2bf82c0980125b62$export$e51187539ff11209)(polyline, focus, blurScope, emphasisDisabled);
        var smooth = $ada57dad04d4bbf5$var$getSmooth(seriesModel.get("smooth"));
        var smoothMonotone = seriesModel.get("smoothMonotone");
        polyline.setShape({
            smooth: smooth,
            smoothMonotone: smoothMonotone,
            connectNulls: connectNulls
        });
        if (polygon) {
            var stackedOnSeries = data.getCalculationInfo("stackedOnSeries");
            var stackedOnSmooth = 0;
            polygon.useStyle($7a1bd9c2710fea0d$export$ebe90cb607ad99e(areaStyleModel.getAreaStyle(), {
                fill: visualColor,
                opacity: 0.7,
                lineJoin: "bevel",
                decal: data.getVisual("style").decal
            }));
            if (stackedOnSeries) stackedOnSmooth = $ada57dad04d4bbf5$var$getSmooth(stackedOnSeries.get("smooth"));
            polygon.setShape({
                smooth: smooth,
                stackedOnSmooth: stackedOnSmooth,
                smoothMonotone: smoothMonotone,
                connectNulls: connectNulls
            });
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polygon, seriesModel, "areaStyle");
            // Needs seriesIndex for focus
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(polygon).seriesIndex = seriesModel.seriesIndex;
            (0, $2bf82c0980125b62$export$e51187539ff11209)(polygon, focus, blurScope, emphasisDisabled);
        }
        var changePolyState = this._changePolyState;
        data.eachItemGraphicEl(function(el) {
            // Switch polyline / polygon state if element changed its state.
            el && (el.onHoverStateChange = changePolyState);
        });
        this._polyline.onHoverStateChange = changePolyState;
        this._data = data;
        // Save the coordinate system for transition animation when data changed
        this._coordSys = coordSys;
        this._stackedOnPoints = stackedOnPoints;
        this._points = points;
        this._step = step;
        this._valueOrigin = valueOrigin;
        if (seriesModel.get("triggerLineEvent")) {
            this.packEventData(seriesModel, polyline);
            polygon && this.packEventData(seriesModel, polygon);
        }
    };
    LineView.prototype.packEventData = function(seriesModel, el) {
        (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).eventData = {
            componentType: "series",
            componentSubType: "line",
            componentIndex: seriesModel.componentIndex,
            seriesIndex: seriesModel.seriesIndex,
            seriesName: seriesModel.name,
            seriesType: "line"
        };
    };
    LineView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var dataIndex = $76d619f648247e6d$export$42b26cae8b8d10(data, payload);
        this._changePolyState("emphasis");
        if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
            var points = data.getLayout("points");
            var symbol = data.getItemGraphicEl(dataIndex);
            if (!symbol) {
                // Create a temporary symbol if it is not exists
                var x = points[dataIndex * 2];
                var y = points[dataIndex * 2 + 1];
                if (isNaN(x) || isNaN(y)) // Null data
                return;
                // fix #11360: shouldn't draw symbol outside clipShapeForSymbol
                if (this._clipShapeForSymbol && !this._clipShapeForSymbol.contain(x, y)) return;
                var zlevel = seriesModel.get("zlevel") || 0;
                var z = seriesModel.get("z") || 0;
                symbol = new (0, $b1d9c3e17ccace80$export$2e2bcd8739ae039)(data, dataIndex);
                symbol.x = x;
                symbol.y = y;
                symbol.setZ(zlevel, z);
                // ensure label text of the temporary symbol is in front of line and area polygon
                var symbolLabel = symbol.getSymbolPath().getTextContent();
                if (symbolLabel) {
                    symbolLabel.zlevel = zlevel;
                    symbolLabel.z = z;
                    symbolLabel.z2 = this._polyline.z2 + 1;
                }
                symbol.__temp = true;
                data.setItemGraphicEl(dataIndex, symbol);
                // Stop scale animation
                symbol.stopSymbolAnimation(true);
                this.group.add(symbol);
            }
            symbol.highlight();
        } else // Highlight whole series
        (0, $0dc5061053e23cd3$export$2e2bcd8739ae039).prototype.highlight.call(this, seriesModel, ecModel, api, payload);
    };
    LineView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var dataIndex = $76d619f648247e6d$export$42b26cae8b8d10(data, payload);
        this._changePolyState("normal");
        if (dataIndex != null && dataIndex >= 0) {
            var symbol = data.getItemGraphicEl(dataIndex);
            if (symbol) {
                if (symbol.__temp) {
                    data.setItemGraphicEl(dataIndex, null);
                    this.group.remove(symbol);
                } else symbol.downplay();
            }
        } else // FIXME
        // can not downplay completely.
        // Downplay whole series
        (0, $0dc5061053e23cd3$export$2e2bcd8739ae039).prototype.downplay.call(this, seriesModel, ecModel, api, payload);
    };
    LineView.prototype._changePolyState = function(toState) {
        var polygon = this._polygon;
        (0, $2bf82c0980125b62$export$868ba38adffa9e39)(this._polyline, toState);
        polygon && (0, $2bf82c0980125b62$export$868ba38adffa9e39)(polygon, toState);
    };
    LineView.prototype._newPolyline = function(points) {
        var polyline = this._polyline;
        // Remove previous created polyline
        if (polyline) this._lineGroup.remove(polyline);
        polyline = new (0, $5c417e1ed90142c5$export$bf7c0585b8f7d00f)({
            shape: {
                points: points
            },
            segmentIgnoreThreshold: 2,
            z2: 10
        });
        this._lineGroup.add(polyline);
        this._polyline = polyline;
        return polyline;
    };
    LineView.prototype._newPolygon = function(points, stackedOnPoints) {
        var polygon = this._polygon;
        // Remove previous created polygon
        if (polygon) this._lineGroup.remove(polygon);
        polygon = new (0, $5c417e1ed90142c5$export$6042a400d113f2bd)({
            shape: {
                points: points,
                stackedOnPoints: stackedOnPoints
            },
            segmentIgnoreThreshold: 2
        });
        this._lineGroup.add(polygon);
        this._polygon = polygon;
        return polygon;
    };
    LineView.prototype._initSymbolLabelAnimation = function(data, coordSys, clipShape) {
        var isHorizontalOrRadial;
        var isCoordSysPolar;
        var baseAxis = coordSys.getBaseAxis();
        var isAxisInverse = baseAxis.inverse;
        if (coordSys.type === "cartesian2d") {
            isHorizontalOrRadial = baseAxis.isHorizontal();
            isCoordSysPolar = false;
        } else if (coordSys.type === "polar") {
            isHorizontalOrRadial = baseAxis.dim === "angle";
            isCoordSysPolar = true;
        }
        var seriesModel = data.hostModel;
        var seriesDuration = seriesModel.get("animationDuration");
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(seriesDuration)) seriesDuration = seriesDuration(null);
        var seriesDelay = seriesModel.get("animationDelay") || 0;
        var seriesDelayValue = $7a1bd9c2710fea0d$export$f6e2535fb5126e54(seriesDelay) ? seriesDelay(null) : seriesDelay;
        data.eachItemGraphicEl(function(symbol, idx) {
            var el = symbol;
            if (el) {
                var point = [
                    symbol.x,
                    symbol.y
                ];
                var start = void 0;
                var end = void 0;
                var current = void 0;
                if (clipShape) {
                    if (isCoordSysPolar) {
                        var polarClip = clipShape;
                        var coord = coordSys.pointToCoord(point);
                        if (isHorizontalOrRadial) {
                            start = polarClip.startAngle;
                            end = polarClip.endAngle;
                            current = -coord[1] / 180 * Math.PI;
                        } else {
                            start = polarClip.r0;
                            end = polarClip.r;
                            current = coord[0];
                        }
                    } else {
                        var gridClip = clipShape;
                        if (isHorizontalOrRadial) {
                            start = gridClip.x;
                            end = gridClip.x + gridClip.width;
                            current = symbol.x;
                        } else {
                            start = gridClip.y + gridClip.height;
                            end = gridClip.y;
                            current = symbol.y;
                        }
                    }
                }
                var ratio = end === start ? 0 : (current - start) / (end - start);
                if (isAxisInverse) ratio = 1 - ratio;
                var delay = $7a1bd9c2710fea0d$export$f6e2535fb5126e54(seriesDelay) ? seriesDelay(idx) : seriesDuration * ratio + seriesDelayValue;
                var symbolPath = el.getSymbolPath();
                var text = symbolPath.getTextContent();
                el.attr({
                    scaleX: 0,
                    scaleY: 0
                });
                el.animateTo({
                    scaleX: 1,
                    scaleY: 1
                }, {
                    duration: 200,
                    setToFinal: true,
                    delay: delay
                });
                if (text) text.animateFrom({
                    style: {
                        opacity: 0
                    }
                }, {
                    duration: 300,
                    delay: delay
                });
                symbolPath.disableLabelAnimation = true;
            }
        });
    };
    LineView.prototype._initOrUpdateEndLabel = function(seriesModel, coordSys, inheritColor) {
        var endLabelModel = seriesModel.getModel("endLabel");
        if ($ada57dad04d4bbf5$var$anyStateShowEndLabel(seriesModel)) {
            var data_2 = seriesModel.getData();
            var polyline = this._polyline;
            // series may be filtered.
            var points = data_2.getLayout("points");
            if (!points) {
                polyline.removeTextContent();
                this._endLabel = null;
                return;
            }
            var endLabel = this._endLabel;
            if (!endLabel) {
                endLabel = this._endLabel = new $fe885cc21795562b$export$2e2bcd8739ae039({
                    z2: 200 // should be higher than item symbol
                });
                endLabel.ignoreClip = true;
                polyline.setTextContent(this._endLabel);
                polyline.disableLabelAnimation = true;
            }
            // Find last non-NaN data to display data
            var dataIndex = $ada57dad04d4bbf5$var$getLastIndexNotNull(points);
            if (dataIndex >= 0) {
                (0, $6800dfcb6e1e2a44$export$9a13992917966657)(polyline, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(seriesModel, "endLabel"), {
                    inheritColor: inheritColor,
                    labelFetcher: seriesModel,
                    labelDataIndex: dataIndex,
                    defaultText: function(dataIndex, opt, interpolatedValue) {
                        return interpolatedValue != null ? (0, $b2475f850d3c0bc2$export$5f84815e91ca6775)(data_2, interpolatedValue) : (0, $b2475f850d3c0bc2$export$5ff20667590927ed)(data_2, dataIndex);
                    },
                    enableTextSetter: true
                }, $ada57dad04d4bbf5$var$getEndLabelStateSpecified(endLabelModel, coordSys));
                polyline.textConfig.position = null;
            }
        } else if (this._endLabel) {
            this._polyline.removeTextContent();
            this._endLabel = null;
        }
    };
    LineView.prototype._endLabelOnDuring = function(percent, clipRect, data, animationRecord, valueAnimation, endLabelModel, coordSys) {
        var endLabel = this._endLabel;
        var polyline = this._polyline;
        if (endLabel) {
            // NOTE: Don't remove percent < 1. percent === 1 means the first frame during render.
            // The label is not prepared at this time.
            if (percent < 1 && animationRecord.originalX == null) {
                animationRecord.originalX = endLabel.x;
                animationRecord.originalY = endLabel.y;
            }
            var points = data.getLayout("points");
            var seriesModel = data.hostModel;
            var connectNulls = seriesModel.get("connectNulls");
            var precision = endLabelModel.get("precision");
            var distance = endLabelModel.get("distance") || 0;
            var baseAxis = coordSys.getBaseAxis();
            var isHorizontal = baseAxis.isHorizontal();
            var isBaseInversed = baseAxis.inverse;
            var clipShape = clipRect.shape;
            var xOrY = isBaseInversed ? isHorizontal ? clipShape.x : clipShape.y + clipShape.height : isHorizontal ? clipShape.x + clipShape.width : clipShape.y;
            var distanceX = (isHorizontal ? distance : 0) * (isBaseInversed ? -1 : 1);
            var distanceY = (isHorizontal ? 0 : -distance) * (isBaseInversed ? -1 : 1);
            var dim = isHorizontal ? "x" : "y";
            var dataIndexRange = $ada57dad04d4bbf5$var$getIndexRange(points, xOrY, dim);
            var indices = dataIndexRange.range;
            var diff = indices[1] - indices[0];
            var value = void 0;
            if (diff >= 1) {
                // diff > 1 && connectNulls, which is on the null data.
                if (diff > 1 && !connectNulls) {
                    var pt = $ada57dad04d4bbf5$var$getPointAtIndex(points, indices[0]);
                    endLabel.attr({
                        x: pt[0] + distanceX,
                        y: pt[1] + distanceY
                    });
                    valueAnimation && (value = seriesModel.getRawValue(indices[0]));
                } else {
                    var pt = polyline.getPointOn(xOrY, dim);
                    pt && endLabel.attr({
                        x: pt[0] + distanceX,
                        y: pt[1] + distanceY
                    });
                    var startValue = seriesModel.getRawValue(indices[0]);
                    var endValue = seriesModel.getRawValue(indices[1]);
                    valueAnimation && (value = $76d619f648247e6d$export$bd0439821a1869f3(data, precision, startValue, endValue, dataIndexRange.t));
                }
                animationRecord.lastFrameIndex = indices[0];
            } else {
                // If diff <= 0, which is the range is not found(Include NaN)
                // Choose the first point or last point.
                var idx = percent === 1 || animationRecord.lastFrameIndex > 0 ? indices[0] : 0;
                var pt = $ada57dad04d4bbf5$var$getPointAtIndex(points, idx);
                valueAnimation && (value = seriesModel.getRawValue(idx));
                endLabel.attr({
                    x: pt[0] + distanceX,
                    y: pt[1] + distanceY
                });
            }
            if (valueAnimation) {
                var inner = (0, $6800dfcb6e1e2a44$export$f62786d3261ab0f4)(endLabel);
                if (typeof inner.setLabelText === "function") inner.setLabelText(value);
            }
        }
    };
    /**
   * @private
   */ // FIXME Two value axis
    LineView.prototype._doUpdateAnimation = function(data, stackedOnPoints, coordSys, api, step, valueOrigin, connectNulls) {
        var polyline = this._polyline;
        var polygon = this._polygon;
        var seriesModel = data.hostModel;
        var diff = (0, $b022c65e2d67ded9$export$2e2bcd8739ae039)(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys, this._valueOrigin, valueOrigin);
        var current = diff.current;
        var stackedOnCurrent = diff.stackedOnCurrent;
        var next = diff.next;
        var stackedOnNext = diff.stackedOnNext;
        if (step) {
            // TODO If stacked series is not step
            stackedOnCurrent = $ada57dad04d4bbf5$var$turnPointsIntoStep(diff.stackedOnCurrent, diff.current, coordSys, step, connectNulls);
            current = $ada57dad04d4bbf5$var$turnPointsIntoStep(diff.current, null, coordSys, step, connectNulls);
            stackedOnNext = $ada57dad04d4bbf5$var$turnPointsIntoStep(diff.stackedOnNext, diff.next, coordSys, step, connectNulls);
            next = $ada57dad04d4bbf5$var$turnPointsIntoStep(diff.next, null, coordSys, step, connectNulls);
        }
        // Don't apply animation if diff is large.
        // For better result and avoid memory explosion problems like
        // https://github.com/apache/incubator-echarts/issues/12229
        if ($ada57dad04d4bbf5$var$getBoundingDiff(current, next) > 3000 || polygon && $ada57dad04d4bbf5$var$getBoundingDiff(stackedOnCurrent, stackedOnNext) > 3000) {
            polyline.stopAnimation();
            polyline.setShape({
                points: next
            });
            if (polygon) {
                polygon.stopAnimation();
                polygon.setShape({
                    points: next,
                    stackedOnPoints: stackedOnNext
                });
            }
            return;
        }
        polyline.shape.__points = diff.current;
        polyline.shape.points = current;
        var target = {
            shape: {
                points: next
            }
        };
        // Also animate the original points.
        // If points reference is changed when turning into step line.
        if (diff.current !== current) target.shape.__points = diff.next;
        // Stop previous animation.
        polyline.stopAnimation();
        $8b353638fbedfefa$export$c8dce3c08436e91e(polyline, target, seriesModel);
        if (polygon) {
            polygon.setShape({
                // Reuse the points with polyline.
                points: current,
                stackedOnPoints: stackedOnCurrent
            });
            polygon.stopAnimation();
            $8b353638fbedfefa$export$c8dce3c08436e91e(polygon, {
                shape: {
                    stackedOnPoints: stackedOnNext
                }
            }, seriesModel);
            // If use attr directly in updateProps.
            if (polyline.shape.points !== polygon.shape.points) polygon.shape.points = polyline.shape.points;
        }
        var updatedDataInfo = [];
        var diffStatus = diff.status;
        for(var i = 0; i < diffStatus.length; i++){
            var cmd = diffStatus[i].cmd;
            if (cmd === "=") {
                var el = data.getItemGraphicEl(diffStatus[i].idx1);
                if (el) updatedDataInfo.push({
                    el: el,
                    ptIdx: i // Index of points
                });
            }
        }
        if (polyline.animators && polyline.animators.length) polyline.animators[0].during(function() {
            polygon && polygon.dirtyShape();
            var points = polyline.shape.__points;
            for(var i = 0; i < updatedDataInfo.length; i++){
                var el = updatedDataInfo[i].el;
                var offset = updatedDataInfo[i].ptIdx * 2;
                el.x = points[offset];
                el.y = points[offset + 1];
                el.markRedraw();
            }
        });
    };
    LineView.prototype.remove = function(ecModel) {
        var group = this.group;
        var oldData = this._data;
        this._lineGroup.removeAll();
        this._symbolDraw.remove(true);
        // Remove temporary created elements when highlighting
        oldData && oldData.eachItemGraphicEl(function(el, idx) {
            if (el.__temp) {
                group.remove(el);
                oldData.setItemGraphicEl(idx, null);
            }
        });
        this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._endLabel = this._data = null;
    };
    LineView.type = "line";
    return LineView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $ada57dad04d4bbf5$export$2e2bcd8739ae039 = $ada57dad04d4bbf5$var$LineView;




function $9c1bfdc9a4f78f2d$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $ada57dad04d4bbf5$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $04f9db15b0fa1cf8$export$2e2bcd8739ae039));
    registers.registerLayout((0, $73b014aa594ea652$export$2e2bcd8739ae039)("line", true));
    registers.registerVisual({
        seriesType: "line",
        reset: function(seriesModel) {
            var data = seriesModel.getData();
            // Visual coding for legend
            var lineStyle = seriesModel.getModel("lineStyle").getLineStyle();
            if (lineStyle && !lineStyle.stroke) // Fill in visual should be palette color if
            // has color callback
            lineStyle.stroke = data.getVisual("style").fill;
            data.setVisual("legendLineStyle", lineStyle);
        }
    });
    // Down sample after filter
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $3a37e5b80322a871$export$2e2bcd8739ae039)("line"));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $ac4f44aacfb7dba9$var$EffectLine = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(EffectLine, _super);
    function EffectLine(lineData, idx, seriesScope) {
        var _this = _super.call(this) || this;
        _this.add(_this.createLine(lineData, idx, seriesScope));
        _this._updateEffectSymbol(lineData, idx);
        return _this;
    }
    EffectLine.prototype.createLine = function(lineData, idx, seriesScope) {
        return new (0, $9e0b5f801ab5090c$export$2e2bcd8739ae039)(lineData, idx, seriesScope);
    };
    EffectLine.prototype._updateEffectSymbol = function(lineData, idx) {
        var itemModel = lineData.getItemModel(idx);
        var effectModel = itemModel.getModel("effect");
        var size = effectModel.get("symbolSize");
        var symbolType = effectModel.get("symbol");
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(size)) size = [
            size,
            size
        ];
        var lineStyle = lineData.getItemVisual(idx, "style");
        var color = effectModel.get("color") || lineStyle && lineStyle.stroke;
        var symbol = this.childAt(1);
        if (this._symbolType !== symbolType) {
            // Remove previous
            this.remove(symbol);
            symbol = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symbolType, -0.5, -0.5, 1, 1, color);
            symbol.z2 = 100;
            symbol.culling = true;
            this.add(symbol);
        }
        // Symbol may be removed if loop is false
        if (!symbol) return;
        // Shadow color is same with color in default
        symbol.setStyle("shadowColor", color);
        symbol.setStyle(effectModel.getItemStyle([
            "color"
        ]));
        symbol.scaleX = size[0];
        symbol.scaleY = size[1];
        symbol.setColor(color);
        this._symbolType = symbolType;
        this._symbolScale = size;
        this._updateEffectAnimation(lineData, effectModel, idx);
    };
    EffectLine.prototype._updateEffectAnimation = function(lineData, effectModel, idx) {
        var symbol = this.childAt(1);
        if (!symbol) return;
        var points = lineData.getItemLayout(idx);
        var period = effectModel.get("period") * 1000;
        var loop = effectModel.get("loop");
        var roundTrip = effectModel.get("roundTrip");
        var constantSpeed = effectModel.get("constantSpeed");
        var delayExpr = $7a1bd9c2710fea0d$export$8a4d17b6e8486e66(effectModel.get("delay"), function(idx) {
            return idx / lineData.count() * period / 3;
        });
        // Ignore when updating
        symbol.ignore = true;
        this._updateAnimationPoints(symbol, points);
        if (constantSpeed > 0) period = this._getLineLength(symbol) / constantSpeed * 1000;
        if (period !== this._period || loop !== this._loop || roundTrip !== this._roundTrip) {
            symbol.stopAnimation();
            var delayNum = void 0;
            if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(delayExpr)) delayNum = delayExpr(idx);
            else delayNum = delayExpr;
            if (symbol.__t > 0) delayNum = -period * symbol.__t;
            this._animateSymbol(symbol, period, delayNum, loop, roundTrip);
        }
        this._period = period;
        this._loop = loop;
        this._roundTrip = roundTrip;
    };
    EffectLine.prototype._animateSymbol = function(symbol, period, delayNum, loop, roundTrip) {
        if (period > 0) {
            symbol.__t = 0;
            var self_1 = this;
            var animator = symbol.animate("", loop).when(roundTrip ? period * 2 : period, {
                __t: roundTrip ? 2 : 1
            }).delay(delayNum).during(function() {
                self_1._updateSymbolPosition(symbol);
            });
            if (!loop) animator.done(function() {
                self_1.remove(symbol);
            });
            animator.start();
        }
    };
    EffectLine.prototype._getLineLength = function(symbol) {
        // Not so accurate
        return $6de594cf8ac295ff$export$6c4a311cc157c764(symbol.__p1, symbol.__cp1) + $6de594cf8ac295ff$export$6c4a311cc157c764(symbol.__cp1, symbol.__p2);
    };
    EffectLine.prototype._updateAnimationPoints = function(symbol, points) {
        symbol.__p1 = points[0];
        symbol.__p2 = points[1];
        symbol.__cp1 = points[2] || [
            (points[0][0] + points[1][0]) / 2,
            (points[0][1] + points[1][1]) / 2
        ];
    };
    EffectLine.prototype.updateData = function(lineData, idx, seriesScope) {
        this.childAt(0).updateData(lineData, idx, seriesScope);
        this._updateEffectSymbol(lineData, idx);
    };
    EffectLine.prototype._updateSymbolPosition = function(symbol) {
        var p1 = symbol.__p1;
        var p2 = symbol.__p2;
        var cp1 = symbol.__cp1;
        var t = symbol.__t < 1 ? symbol.__t : 2 - symbol.__t;
        var pos = [
            symbol.x,
            symbol.y
        ];
        var lastPos = pos.slice();
        var quadraticAt = $747cfc5611b57cea$export$af17094a950f5073;
        var quadraticDerivativeAt = $747cfc5611b57cea$export$7e161e77e6fff8cb;
        pos[0] = quadraticAt(p1[0], cp1[0], p2[0], t);
        pos[1] = quadraticAt(p1[1], cp1[1], p2[1], t);
        // Tangent
        var tx = symbol.__t < 1 ? quadraticDerivativeAt(p1[0], cp1[0], p2[0], t) : quadraticDerivativeAt(p2[0], cp1[0], p1[0], 1 - t);
        var ty = symbol.__t < 1 ? quadraticDerivativeAt(p1[1], cp1[1], p2[1], t) : quadraticDerivativeAt(p2[1], cp1[1], p1[1], 1 - t);
        symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
        // enable continuity trail for 'line', 'rect', 'roundRect' symbolType
        if (this._symbolType === "line" || this._symbolType === "rect" || this._symbolType === "roundRect") {
            if (symbol.__lastT !== undefined && symbol.__lastT < symbol.__t) {
                symbol.scaleY = $6de594cf8ac295ff$export$6c4a311cc157c764(lastPos, pos) * 1.05;
                // make sure the last segment render within endPoint
                if (t === 1) {
                    pos[0] = lastPos[0] + (pos[0] - lastPos[0]) / 2;
                    pos[1] = lastPos[1] + (pos[1] - lastPos[1]) / 2;
                }
            } else if (symbol.__lastT === 1) // After first loop, symbol.__t does NOT start with 0, so connect p1 to pos directly.
            symbol.scaleY = 2 * $6de594cf8ac295ff$export$6c4a311cc157c764(p1, pos);
            else symbol.scaleY = this._symbolScale[1];
        }
        symbol.__lastT = symbol.__t;
        symbol.ignore = false;
        symbol.x = pos[0];
        symbol.y = pos[1];
    };
    EffectLine.prototype.updateLayout = function(lineData, idx) {
        this.childAt(0).updateLayout(lineData, idx);
        var effectModel = lineData.getItemModel(idx).getModel("effect");
        this._updateEffectAnimation(lineData, effectModel, idx);
    };
    return EffectLine;
}($7ef7583d8302ffce$export$2e2bcd8739ae039);
var $ac4f44aacfb7dba9$export$2e2bcd8739ae039 = $ac4f44aacfb7dba9$var$EffectLine;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $bdfe7b18bcde1955$var$Polyline = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(Polyline, _super);
    function Polyline(lineData, idx, seriesScope) {
        var _this = _super.call(this) || this;
        _this._createPolyline(lineData, idx, seriesScope);
        return _this;
    }
    Polyline.prototype._createPolyline = function(lineData, idx, seriesScope) {
        // let seriesModel = lineData.hostModel;
        var points = lineData.getItemLayout(idx);
        var line = new $d28119f30e6bb670$export$2e2bcd8739ae039({
            shape: {
                points: points
            }
        });
        this.add(line);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    Polyline.prototype.updateData = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var line = this.childAt(0);
        var target = {
            shape: {
                points: lineData.getItemLayout(idx)
            }
        };
        $8b353638fbedfefa$export$c8dce3c08436e91e(line, target, seriesModel, idx);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    Polyline.prototype._updateCommonStl = function(lineData, idx, seriesScope) {
        var line = this.childAt(0);
        var itemModel = lineData.getItemModel(idx);
        var emphasisLineStyle = seriesScope && seriesScope.emphasisLineStyle;
        var focus = seriesScope && seriesScope.focus;
        var blurScope = seriesScope && seriesScope.blurScope;
        var emphasisDisabled = seriesScope && seriesScope.emphasisDisabled;
        if (!seriesScope || lineData.hasItemOption) {
            var emphasisModel = itemModel.getModel("emphasis");
            emphasisLineStyle = emphasisModel.getModel("lineStyle").getLineStyle();
            emphasisDisabled = emphasisModel.get("disabled");
            focus = emphasisModel.get("focus");
            blurScope = emphasisModel.get("blurScope");
        }
        line.useStyle(lineData.getItemVisual(idx, "style"));
        line.style.fill = null;
        line.style.strokeNoScale = true;
        var lineEmphasisState = line.ensureState("emphasis");
        lineEmphasisState.style = emphasisLineStyle;
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, focus, blurScope, emphasisDisabled);
    };
    Polyline.prototype.updateLayout = function(lineData, idx) {
        var polyline = this.childAt(0);
        polyline.setShape("points", lineData.getItemLayout(idx));
    };
    return Polyline;
}($7ef7583d8302ffce$export$2e2bcd8739ae039);
var $bdfe7b18bcde1955$export$2e2bcd8739ae039 = $bdfe7b18bcde1955$var$Polyline;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $a16373b7bc6b0508$var$EffectPolyline = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(EffectPolyline, _super);
    function EffectPolyline() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._lastFrame = 0;
        _this._lastFramePercent = 0;
        return _this;
    }
    // Override
    EffectPolyline.prototype.createLine = function(lineData, idx, seriesScope) {
        return new (0, $bdfe7b18bcde1955$export$2e2bcd8739ae039)(lineData, idx, seriesScope);
    };
    // Override
    EffectPolyline.prototype._updateAnimationPoints = function(symbol, points) {
        this._points = points;
        var accLenArr = [
            0
        ];
        var len = 0;
        for(var i = 1; i < points.length; i++){
            var p1 = points[i - 1];
            var p2 = points[i];
            len += $6de594cf8ac295ff$export$6c4a311cc157c764(p1, p2);
            accLenArr.push(len);
        }
        if (len === 0) {
            this._length = 0;
            return;
        }
        for(var i = 0; i < accLenArr.length; i++)accLenArr[i] /= len;
        this._offsets = accLenArr;
        this._length = len;
    };
    // Override
    EffectPolyline.prototype._getLineLength = function() {
        return this._length;
    };
    // Override
    EffectPolyline.prototype._updateSymbolPosition = function(symbol) {
        var t = symbol.__t < 1 ? symbol.__t : 2 - symbol.__t;
        var points = this._points;
        var offsets = this._offsets;
        var len = points.length;
        if (!offsets) // Has length 0
        return;
        var lastFrame = this._lastFrame;
        var frame;
        if (t < this._lastFramePercent) {
            // Start from the next frame
            // PENDING start from lastFrame ?
            var start = Math.min(lastFrame + 1, len - 1);
            for(frame = start; frame >= 0; frame--){
                if (offsets[frame] <= t) break;
            }
            // PENDING really need to do this ?
            frame = Math.min(frame, len - 2);
        } else {
            for(frame = lastFrame; frame < len; frame++){
                if (offsets[frame] > t) break;
            }
            frame = Math.min(frame - 1, len - 2);
        }
        var p = (t - offsets[frame]) / (offsets[frame + 1] - offsets[frame]);
        var p0 = points[frame];
        var p1 = points[frame + 1];
        symbol.x = p0[0] * (1 - p) + p * p1[0];
        symbol.y = p0[1] * (1 - p) + p * p1[1];
        var tx = symbol.__t < 1 ? p1[0] - p0[0] : p0[0] - p1[0];
        var ty = symbol.__t < 1 ? p1[1] - p0[1] : p0[1] - p1[1];
        symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
        this._lastFrame = frame;
        this._lastFramePercent = t;
        symbol.ignore = false;
    };
    return EffectPolyline;
}((0, $ac4f44aacfb7dba9$export$2e2bcd8739ae039));
var $a16373b7bc6b0508$export$2e2bcd8739ae039 = $a16373b7bc6b0508$var$EffectPolyline;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $2f5f63360e8576db$var$LargeLinesPathShape = /** @class */ function() {
    function LargeLinesPathShape() {
        this.polyline = false;
        this.curveness = 0;
        this.segs = [];
    }
    return LargeLinesPathShape;
}();
var $2f5f63360e8576db$var$LargeLinesPath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LargeLinesPath, _super);
    function LargeLinesPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this._off = 0;
        _this.hoverDataIdx = -1;
        return _this;
    }
    LargeLinesPath.prototype.reset = function() {
        this.notClear = false;
        this._off = 0;
    };
    LargeLinesPath.prototype.getDefaultStyle = function() {
        return {
            stroke: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral99,
            fill: null
        };
    };
    LargeLinesPath.prototype.getDefaultShape = function() {
        return new $2f5f63360e8576db$var$LargeLinesPathShape();
    };
    LargeLinesPath.prototype.buildPath = function(ctx, shape) {
        var segs = shape.segs;
        var curveness = shape.curveness;
        var i;
        if (shape.polyline) for(i = this._off; i < segs.length;){
            var count = segs[i++];
            if (count > 0) {
                ctx.moveTo(segs[i++], segs[i++]);
                for(var k = 1; k < count; k++)ctx.lineTo(segs[i++], segs[i++]);
            }
        }
        else for(i = this._off; i < segs.length;){
            var x0 = segs[i++];
            var y0 = segs[i++];
            var x1 = segs[i++];
            var y1 = segs[i++];
            ctx.moveTo(x0, y0);
            if (curveness > 0) {
                var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
                var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
                ctx.quadraticCurveTo(x2, y2, x1, y1);
            } else ctx.lineTo(x1, y1);
        }
        if (this.incremental) {
            this._off = i;
            this.notClear = true;
        }
    };
    LargeLinesPath.prototype.findDataIndex = function(x, y) {
        var shape = this.shape;
        var segs = shape.segs;
        var curveness = shape.curveness;
        var lineWidth = this.style.lineWidth;
        if (shape.polyline) {
            var dataIndex = 0;
            for(var i = 0; i < segs.length;){
                var count = segs[i++];
                if (count > 0) {
                    var x0 = segs[i++];
                    var y0 = segs[i++];
                    for(var k = 1; k < count; k++){
                        var x1 = segs[i++];
                        var y1 = segs[i++];
                        if ($beafddd7270f4bea$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y)) return dataIndex;
                    }
                }
                dataIndex++;
            }
        } else {
            var dataIndex = 0;
            for(var i = 0; i < segs.length;){
                var x0 = segs[i++];
                var y0 = segs[i++];
                var x1 = segs[i++];
                var y1 = segs[i++];
                if (curveness > 0) {
                    var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
                    var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
                    if ($a1d80a5bf05b597b$export$8d36b1b5d19157c5(x0, y0, x2, y2, x1, y1, lineWidth, x, y)) return dataIndex;
                } else {
                    if ($beafddd7270f4bea$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y)) return dataIndex;
                }
                dataIndex++;
            }
        }
        return -1;
    };
    LargeLinesPath.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            // Cache found data index.
            var dataIdx = this.hoverDataIdx = this.findDataIndex(x, y);
            return dataIdx >= 0;
        }
        this.hoverDataIdx = -1;
        return false;
    };
    LargeLinesPath.prototype.getBoundingRect = function() {
        // Ignore stroke for large symbol draw.
        var rect = this._rect;
        if (!rect) {
            var shape = this.shape;
            var points = shape.segs;
            var minX = Infinity;
            var minY = Infinity;
            var maxX = -Infinity;
            var maxY = -Infinity;
            for(var i = 0; i < points.length;){
                var x = points[i++];
                var y = points[i++];
                minX = Math.min(x, minX);
                maxX = Math.max(x, maxX);
                minY = Math.min(y, minY);
                maxY = Math.max(y, maxY);
            }
            rect = this._rect = new $1bebe7106c895823$export$2e2bcd8739ae039(minX, minY, maxX, maxY);
        }
        return rect;
    };
    return LargeLinesPath;
}($b02ffe7acd508c08$export$2e2bcd8739ae039);
var $2f5f63360e8576db$var$LargeLineDraw = /** @class */ function() {
    function LargeLineDraw() {
        this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
    }
    /**
   * Update symbols draw by new data
   */ LargeLineDraw.prototype.updateData = function(data) {
        this._clear();
        var lineEl = this._create();
        lineEl.setShape({
            segs: data.getLayout("linesPoints")
        });
        this._setCommon(lineEl, data);
    };
    /**
   * @override
   */ LargeLineDraw.prototype.incrementalPrepareUpdate = function(data) {
        this.group.removeAll();
        this._clear();
    };
    /**
   * @override
   */ LargeLineDraw.prototype.incrementalUpdate = function(taskParams, data) {
        var lastAdded = this._newAdded[0];
        var linePoints = data.getLayout("linesPoints");
        var oldSegs = lastAdded && lastAdded.shape.segs;
        // Merging the exists. Each element has 1e4 points.
        // Consider the performance balance between too much elements and too much points in one shape(may affect hover optimization)
        if (oldSegs && oldSegs.length < 2e4) {
            var oldLen = oldSegs.length;
            var newSegs = new Float32Array(oldLen + linePoints.length);
            // Concat two array
            newSegs.set(oldSegs);
            newSegs.set(linePoints, oldLen);
            lastAdded.setShape({
                segs: newSegs
            });
        } else {
            // Clear
            this._newAdded = [];
            var lineEl = this._create();
            lineEl.incremental = true;
            lineEl.setShape({
                segs: linePoints
            });
            this._setCommon(lineEl, data);
            lineEl.__startIndex = taskParams.start;
        }
    };
    /**
   * @override
   */ LargeLineDraw.prototype.remove = function() {
        this._clear();
    };
    LargeLineDraw.prototype.eachRendered = function(cb) {
        this._newAdded[0] && cb(this._newAdded[0]);
    };
    LargeLineDraw.prototype._create = function() {
        var lineEl = new $2f5f63360e8576db$var$LargeLinesPath({
            cursor: "default",
            ignoreCoarsePointer: true
        });
        this._newAdded.push(lineEl);
        this.group.add(lineEl);
        return lineEl;
    };
    LargeLineDraw.prototype._setCommon = function(lineEl, data, isIncremental) {
        var hostModel = data.hostModel;
        lineEl.setShape({
            polyline: hostModel.get("polyline"),
            curveness: hostModel.get([
                "lineStyle",
                "curveness"
            ])
        });
        lineEl.useStyle(hostModel.getModel("lineStyle").getLineStyle());
        lineEl.style.strokeNoScale = true;
        var style = data.getVisual("style");
        if (style && style.stroke) lineEl.setStyle("stroke", style.stroke);
        lineEl.setStyle("fill", null);
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(lineEl);
        // Enable tooltip
        // PENDING May have performance issue when path is extremely large
        ecData.seriesIndex = hostModel.seriesIndex;
        lineEl.on("mousemove", function(e) {
            ecData.dataIndex = null;
            var dataIndex = lineEl.hoverDataIdx;
            if (dataIndex > 0) // Provide dataIndex for tooltip
            ecData.dataIndex = dataIndex + lineEl.__startIndex;
        });
    };
    LargeLineDraw.prototype._clear = function() {
        this._newAdded = [];
        this.group.removeAll();
    };
    return LargeLineDraw;
}();
var $2f5f63360e8576db$export$2e2bcd8739ae039 = $2f5f63360e8576db$var$LargeLineDraw;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Float32Array */ 

var $e702d3171e9448b0$var$linesLayout = {
    seriesType: "lines",
    plan: (0, $cd70075c57b35175$export$2e2bcd8739ae039)(),
    reset: function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (!coordSys) return;
        var isPolyline = seriesModel.get("polyline");
        var isLarge = seriesModel.pipelineContext.large;
        return {
            progress: function(params, lineData) {
                var lineCoords = [];
                if (isLarge) {
                    var points = void 0;
                    var segCount = params.end - params.start;
                    if (isPolyline) {
                        var totalCoordsCount = 0;
                        for(var i = params.start; i < params.end; i++)totalCoordsCount += seriesModel.getLineCoordsCount(i);
                        points = new Float32Array(segCount + totalCoordsCount * 2);
                    } else points = new Float32Array(segCount * 4);
                    var offset = 0;
                    var pt = [];
                    for(var i = params.start; i < params.end; i++){
                        var len = seriesModel.getLineCoords(i, lineCoords);
                        if (isPolyline) points[offset++] = len;
                        for(var k = 0; k < len; k++){
                            pt = coordSys.dataToPoint(lineCoords[k], false, pt);
                            points[offset++] = pt[0];
                            points[offset++] = pt[1];
                        }
                    }
                    lineData.setLayout("linesPoints", points);
                } else for(var i = params.start; i < params.end; i++){
                    var itemModel = lineData.getItemModel(i);
                    var len = seriesModel.getLineCoords(i, lineCoords);
                    var pts = [];
                    if (isPolyline) for(var j = 0; j < len; j++)pts.push(coordSys.dataToPoint(lineCoords[j]));
                    else {
                        pts[0] = coordSys.dataToPoint(lineCoords[0]);
                        pts[1] = coordSys.dataToPoint(lineCoords[1]);
                        var curveness = itemModel.get([
                            "lineStyle",
                            "curveness"
                        ]);
                        if (+curveness) pts[2] = [
                            (pts[0][0] + pts[1][0]) / 2 - (pts[0][1] - pts[1][1]) * curveness,
                            (pts[0][1] + pts[1][1]) / 2 - (pts[1][0] - pts[0][0]) * curveness
                        ];
                    }
                    lineData.setItemLayout(i, pts);
                }
            }
        };
    }
};
var $e702d3171e9448b0$export$2e2bcd8739ae039 = $e702d3171e9448b0$var$linesLayout;




var $cefff1aea7415b28$var$LinesView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LinesView, _super);
    function LinesView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LinesView.type;
        return _this;
    }
    LinesView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var lineDraw = this._updateLineDraw(data, seriesModel);
        var zlevel = seriesModel.get("zlevel");
        var trailLength = seriesModel.get([
            "effect",
            "trailLength"
        ]);
        var zr = api.getZr();
        // Avoid the drag cause ghost shadow
        // FIXME Better way ?
        // SVG doesn't support
        var isSvg = zr.painter.getType() === "svg";
        if (!isSvg) zr.painter.getLayer(zlevel).clear(true);
        // Config layer with motion blur
        if (this._lastZlevel != null && !isSvg) zr.configLayer(this._lastZlevel, {
            motionBlur: false
        });
        if (this._showEffect(seriesModel) && trailLength > 0) {
            if (!isSvg) zr.configLayer(zlevel, {
                motionBlur: true,
                lastFrameAlpha: Math.max(Math.min(trailLength / 10 + 0.9, 1), 0)
            });
        }
        lineDraw.updateData(data);
        var clipPath = seriesModel.get("clip", true) && (0, $0e2cc04b3aaad400$export$e0fe5081209d01c9)(seriesModel.coordinateSystem, false, seriesModel);
        if (clipPath) this.group.setClipPath(clipPath);
        else this.group.removeClipPath();
        this._lastZlevel = zlevel;
        this._finished = true;
    };
    LinesView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var lineDraw = this._updateLineDraw(data, seriesModel);
        lineDraw.incrementalPrepareUpdate(data);
        this._clearLayer(api);
        this._finished = false;
    };
    LinesView.prototype.incrementalRender = function(taskParams, seriesModel, ecModel) {
        this._lineDraw.incrementalUpdate(taskParams, seriesModel.getData());
        this._finished = taskParams.end === seriesModel.getData().count();
    };
    LinesView.prototype.eachRendered = function(cb) {
        this._lineDraw && this._lineDraw.eachRendered(cb);
    };
    LinesView.prototype.updateTransform = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var pipelineContext = seriesModel.pipelineContext;
        if (!this._finished || pipelineContext.large || pipelineContext.progressiveRender) // TODO Don't have to do update in large mode. Only do it when there are millions of data.
        return {
            update: true
        };
        else {
            // TODO Use same logic with ScatterView.
            // Manually update layout
            var res = (0, $e702d3171e9448b0$export$2e2bcd8739ae039).reset(seriesModel, ecModel, api);
            if (res.progress) res.progress({
                start: 0,
                end: data.count(),
                count: data.count()
            }, data);
            // Not in large mode
            this._lineDraw.updateLayout();
            this._clearLayer(api);
        }
    };
    LinesView.prototype._updateLineDraw = function(data, seriesModel) {
        var lineDraw = this._lineDraw;
        var hasEffect = this._showEffect(seriesModel);
        var isPolyline = !!seriesModel.get("polyline");
        var pipelineContext = seriesModel.pipelineContext;
        var isLargeDraw = pipelineContext.large;
        if (!lineDraw || hasEffect !== this._hasEffet || isPolyline !== this._isPolyline || isLargeDraw !== this._isLargeDraw) {
            if (lineDraw) lineDraw.remove();
            lineDraw = this._lineDraw = isLargeDraw ? new (0, $2f5f63360e8576db$export$2e2bcd8739ae039)() : new (0, $a2fd63a0fc11274a$export$2e2bcd8739ae039)(isPolyline ? hasEffect ? (0, $a16373b7bc6b0508$export$2e2bcd8739ae039) : (0, $bdfe7b18bcde1955$export$2e2bcd8739ae039) : hasEffect ? (0, $ac4f44aacfb7dba9$export$2e2bcd8739ae039) : (0, $9e0b5f801ab5090c$export$2e2bcd8739ae039));
            this._hasEffet = hasEffect;
            this._isPolyline = isPolyline;
            this._isLargeDraw = isLargeDraw;
        }
        this.group.add(lineDraw.group);
        return lineDraw;
    };
    LinesView.prototype._showEffect = function(seriesModel) {
        return !!seriesModel.get([
            "effect",
            "show"
        ]);
    };
    LinesView.prototype._clearLayer = function(api) {
        // Not use motion when dragging or zooming
        var zr = api.getZr();
        var isSvg = zr.painter.getType() === "svg";
        if (!isSvg && this._lastZlevel != null) zr.painter.getLayer(this._lastZlevel).clear(true);
    };
    LinesView.prototype.remove = function(ecModel, api) {
        this._lineDraw && this._lineDraw.remove();
        this._lineDraw = null;
        // Clear motion when lineDraw is removed
        this._clearLayer(api);
    };
    LinesView.prototype.dispose = function(ecModel, api) {
        this.remove(ecModel, api);
    };
    LinesView.type = "lines";
    return LinesView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $cefff1aea7415b28$export$2e2bcd8739ae039 = $cefff1aea7415b28$var$LinesView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $7abeccdc5e740e42$var$Uint32Arr = typeof Uint32Array === "undefined" ? Array : Uint32Array;
var $7abeccdc5e740e42$var$Float64Arr = typeof Float64Array === "undefined" ? Array : Float64Array;
function $7abeccdc5e740e42$var$compatEc2(seriesOpt) {
    var data = seriesOpt.data;
    if (data && data[0] && data[0][0] && data[0][0].coord) seriesOpt.data = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(data, function(itemOpt) {
        var coords = [
            itemOpt[0].coord,
            itemOpt[1].coord
        ];
        var target = {
            coords: coords
        };
        if (itemOpt[0].name) target.fromName = itemOpt[0].name;
        if (itemOpt[1].name) target.toName = itemOpt[1].name;
        return (0, $7a1bd9c2710fea0d$export$18aef43295bbe906)([
            target,
            itemOpt[0],
            itemOpt[1]
        ]);
    });
}
var $7abeccdc5e740e42$var$LinesSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LinesSeriesModel, _super);
    function LinesSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LinesSeriesModel.type;
        _this.visualStyleAccessPath = "lineStyle";
        _this.visualDrawType = "stroke";
        return _this;
    }
    LinesSeriesModel.prototype.init = function(option) {
        // The input data may be null/undefined.
        option.data = option.data || [];
        // Not using preprocessor because mergeOption may not have series.type
        $7abeccdc5e740e42$var$compatEc2(option);
        var result = this._processFlatCoordsArray(option.data);
        this._flatCoords = result.flatCoords;
        this._flatCoordsOffset = result.flatCoordsOffset;
        if (result.flatCoords) option.data = new Float32Array(result.count);
        _super.prototype.init.apply(this, arguments);
    };
    LinesSeriesModel.prototype.mergeOption = function(option) {
        $7abeccdc5e740e42$var$compatEc2(option);
        if (option.data) {
            // Only update when have option data to merge.
            var result = this._processFlatCoordsArray(option.data);
            this._flatCoords = result.flatCoords;
            this._flatCoordsOffset = result.flatCoordsOffset;
            if (result.flatCoords) option.data = new Float32Array(result.count);
        }
        _super.prototype.mergeOption.apply(this, arguments);
    };
    LinesSeriesModel.prototype.appendData = function(params) {
        var result = this._processFlatCoordsArray(params.data);
        if (result.flatCoords) {
            if (!this._flatCoords) {
                this._flatCoords = result.flatCoords;
                this._flatCoordsOffset = result.flatCoordsOffset;
            } else {
                this._flatCoords = (0, $7a1bd9c2710fea0d$export$4fd8af2c48c43416)(this._flatCoords, result.flatCoords);
                this._flatCoordsOffset = (0, $7a1bd9c2710fea0d$export$4fd8af2c48c43416)(this._flatCoordsOffset, result.flatCoordsOffset);
            }
            params.data = new Float32Array(result.count);
        }
        this.getRawData().appendData(params.data);
    };
    LinesSeriesModel.prototype._getCoordsFromItemModel = function(idx) {
        var itemModel = this.getData().getItemModel(idx);
        var coords = itemModel.option instanceof Array ? itemModel.option : itemModel.getShallow("coords");
        return coords;
    };
    LinesSeriesModel.prototype.getLineCoordsCount = function(idx) {
        if (this._flatCoordsOffset) return this._flatCoordsOffset[idx * 2 + 1];
        else return this._getCoordsFromItemModel(idx).length;
    };
    LinesSeriesModel.prototype.getLineCoords = function(idx, out) {
        if (this._flatCoordsOffset) {
            var offset = this._flatCoordsOffset[idx * 2];
            var len = this._flatCoordsOffset[idx * 2 + 1];
            for(var i = 0; i < len; i++){
                out[i] = out[i] || [];
                out[i][0] = this._flatCoords[offset + i * 2];
                out[i][1] = this._flatCoords[offset + i * 2 + 1];
            }
            return len;
        } else {
            var coords = this._getCoordsFromItemModel(idx);
            for(var i = 0; i < coords.length; i++){
                out[i] = out[i] || [];
                out[i][0] = coords[i][0];
                out[i][1] = coords[i][1];
            }
            return coords.length;
        }
    };
    LinesSeriesModel.prototype._processFlatCoordsArray = function(data) {
        var startOffset = 0;
        if (this._flatCoords) startOffset = this._flatCoords.length;
        // Stored as a typed array. In format
        // Points Count(2) | x | y | x | y | Points Count(3) | x |  y | x | y | x | y |
        if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(data[0])) {
            var len = data.length;
            // Store offset and len of each segment
            var coordsOffsetAndLenStorage = new $7abeccdc5e740e42$var$Uint32Arr(len);
            var coordsStorage = new $7abeccdc5e740e42$var$Float64Arr(len);
            var coordsCursor = 0;
            var offsetCursor = 0;
            var dataCount = 0;
            for(var i = 0; i < len;){
                dataCount++;
                var count = data[i++];
                // Offset
                coordsOffsetAndLenStorage[offsetCursor++] = coordsCursor + startOffset;
                // Len
                coordsOffsetAndLenStorage[offsetCursor++] = count;
                for(var k = 0; k < count; k++){
                    var x = data[i++];
                    var y = data[i++];
                    coordsStorage[coordsCursor++] = x;
                    coordsStorage[coordsCursor++] = y;
                }
            }
            return {
                flatCoordsOffset: new Uint32Array(coordsOffsetAndLenStorage.buffer, 0, offsetCursor),
                flatCoords: coordsStorage,
                count: dataCount
            };
        }
        return {
            flatCoordsOffset: null,
            flatCoords: null,
            count: data.length
        };
    };
    LinesSeriesModel.prototype.getInitialData = function(option, ecModel) {
        var CoordSys;
        var lineData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)([
            "value"
        ], this);
        lineData.hasItemOption = false;
        lineData.initData(option.data, [], function(dataItem, dimName, dataIndex, dimIndex) {
            // dataItem is simply coords
            if (dataItem instanceof Array) return NaN;
            else {
                lineData.hasItemOption = true;
                var value = dataItem.value;
                if (value != null) return value instanceof Array ? value[dimIndex] : value;
            }
        });
        return lineData;
    };
    LinesSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var itemModel = data.getItemModel(dataIndex);
        var name = itemModel.get("name");
        if (name) return name;
        var fromName = itemModel.get("fromName");
        var toName = itemModel.get("toName");
        var nameArr = [];
        fromName != null && nameArr.push(fromName);
        toName != null && nameArr.push(toName);
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
            name: nameArr.join(" > ")
        });
    };
    LinesSeriesModel.prototype.preventIncremental = function() {
        return !!this.get([
            "effect",
            "show"
        ]);
    };
    LinesSeriesModel.prototype.getProgressive = function() {
        var progressive = this.option.progressive;
        if (progressive == null) return this.option.large ? 1e4 : this.get("progressive");
        return progressive;
    };
    LinesSeriesModel.prototype.getProgressiveThreshold = function() {
        var progressiveThreshold = this.option.progressiveThreshold;
        if (progressiveThreshold == null) return this.option.large ? 2e4 : this.get("progressiveThreshold");
        return progressiveThreshold;
    };
    LinesSeriesModel.prototype.getZLevelKey = function() {
        var effectModel = this.getModel("effect");
        var trailLength = effectModel.get("trailLength");
        return this.getData().count() > this.getProgressiveThreshold() ? this.id : effectModel.get("show") && trailLength > 0 ? trailLength + "" : "";
    };
    LinesSeriesModel.type = "series.lines";
    LinesSeriesModel.dependencies = [
        "grid",
        "polar",
        "geo",
        "calendar"
    ];
    LinesSeriesModel.defaultOption = {
        coordinateSystem: "geo",
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        // Cartesian coordinate system
        xAxisIndex: 0,
        yAxisIndex: 0,
        symbol: [
            "none",
            "none"
        ],
        symbolSize: [
            10,
            10
        ],
        // Geo coordinate system
        geoIndex: 0,
        effect: {
            show: false,
            period: 4,
            constantSpeed: 0,
            symbol: "circle",
            symbolSize: 3,
            loop: true,
            trailLength: 0.2
        },
        large: false,
        // Available when large is true
        largeThreshold: 2000,
        polyline: false,
        clip: true,
        label: {
            show: false,
            position: "end"
        },
        lineStyle: {
            opacity: 0.5
        }
    };
    return LinesSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $7abeccdc5e740e42$export$2e2bcd8739ae039 = $7abeccdc5e740e42$var$LinesSeriesModel;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $111ea02a392b95a6$var$normalize(a) {
    if (!(a instanceof Array)) a = [
        a,
        a
    ];
    return a;
}
var $111ea02a392b95a6$var$linesVisual = {
    seriesType: "lines",
    reset: function(seriesModel) {
        var symbolType = $111ea02a392b95a6$var$normalize(seriesModel.get("symbol"));
        var symbolSize = $111ea02a392b95a6$var$normalize(seriesModel.get("symbolSize"));
        var data = seriesModel.getData();
        data.setVisual("fromSymbol", symbolType && symbolType[0]);
        data.setVisual("toSymbol", symbolType && symbolType[1]);
        data.setVisual("fromSymbolSize", symbolSize && symbolSize[0]);
        data.setVisual("toSymbolSize", symbolSize && symbolSize[1]);
        function dataEach(data, idx) {
            var itemModel = data.getItemModel(idx);
            var symbolType = $111ea02a392b95a6$var$normalize(itemModel.getShallow("symbol", true));
            var symbolSize = $111ea02a392b95a6$var$normalize(itemModel.getShallow("symbolSize", true));
            symbolType[0] && data.setItemVisual(idx, "fromSymbol", symbolType[0]);
            symbolType[1] && data.setItemVisual(idx, "toSymbol", symbolType[1]);
            symbolSize[0] && data.setItemVisual(idx, "fromSymbolSize", symbolSize[0]);
            symbolSize[1] && data.setItemVisual(idx, "toSymbolSize", symbolSize[1]);
        }
        return {
            dataEach: data.hasItemOption ? dataEach : null
        };
    }
};
var $111ea02a392b95a6$export$2e2bcd8739ae039 = $111ea02a392b95a6$var$linesVisual;


function $52dd2448928cc7d8$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $cefff1aea7415b28$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $7abeccdc5e740e42$export$2e2bcd8739ae039));
    registers.registerLayout((0, $e702d3171e9448b0$export$2e2bcd8739ae039));
    registers.registerVisual((0, $111ea02a392b95a6$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 














function $6d3db85dae3a1192$export$eacefc55fad2867e(svg) {
    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(svg)) {
        var parser = new DOMParser();
        svg = parser.parseFromString(svg, "text/xml");
    }
    var svgNode = svg;
    if (svgNode.nodeType === 9) svgNode = svgNode.firstChild;
    while(svgNode.nodeName.toLowerCase() !== "svg" || svgNode.nodeType !== 1)svgNode = svgNode.nextSibling;
    return svgNode;
}



var $ccaaa4a85c480645$var$nodeParsers;
var $ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP = {
    "fill": "fill",
    "stroke": "stroke",
    "stroke-width": "lineWidth",
    "opacity": "opacity",
    "fill-opacity": "fillOpacity",
    "stroke-opacity": "strokeOpacity",
    "stroke-dasharray": "lineDash",
    "stroke-dashoffset": "lineDashOffset",
    "stroke-linecap": "lineCap",
    "stroke-linejoin": "lineJoin",
    "stroke-miterlimit": "miterLimit",
    "font-family": "fontFamily",
    "font-size": "fontSize",
    "font-style": "fontStyle",
    "font-weight": "fontWeight",
    "text-anchor": "textAlign",
    "visibility": "visibility",
    "display": "display"
};
var $ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)($ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP);
var $ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP = {
    "alignment-baseline": "textBaseline",
    "stop-color": "stopColor"
};
var $ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)($ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP);
var $ccaaa4a85c480645$var$SVGParser = function() {
    function SVGParser() {
        this._defs = {};
        this._root = null;
    }
    SVGParser.prototype.parse = function(xml, opt) {
        opt = opt || {};
        var svg = (0, $6d3db85dae3a1192$export$eacefc55fad2867e)(xml);
        this._defsUsePending = [];
        var root = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        this._root = root;
        var named = [];
        var viewBox = svg.getAttribute("viewBox") || "";
        var width = parseFloat(svg.getAttribute("width") || opt.width);
        var height = parseFloat(svg.getAttribute("height") || opt.height);
        isNaN(width) && (width = null);
        isNaN(height) && (height = null);
        $ccaaa4a85c480645$var$parseAttributes(svg, root, null, true, false);
        var child = svg.firstChild;
        while(child){
            this._parseNode(child, root, named, null, false, false);
            child = child.nextSibling;
        }
        $ccaaa4a85c480645$var$applyDefs(this._defs, this._defsUsePending);
        this._defsUsePending = [];
        var viewBoxRect;
        var viewBoxTransform;
        if (viewBox) {
            var viewBoxArr = $ccaaa4a85c480645$var$splitNumberSequence(viewBox);
            if (viewBoxArr.length >= 4) viewBoxRect = {
                x: parseFloat(viewBoxArr[0] || 0),
                y: parseFloat(viewBoxArr[1] || 0),
                width: parseFloat(viewBoxArr[2]),
                height: parseFloat(viewBoxArr[3])
            };
        }
        if (viewBoxRect && width != null && height != null) {
            viewBoxTransform = $ccaaa4a85c480645$export$3e2db4420f14f50f(viewBoxRect, {
                x: 0,
                y: 0,
                width: width,
                height: height
            });
            if (!opt.ignoreViewBox) {
                var elRoot = root;
                root = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
                root.add(elRoot);
                elRoot.scaleX = elRoot.scaleY = viewBoxTransform.scale;
                elRoot.x = viewBoxTransform.x;
                elRoot.y = viewBoxTransform.y;
            }
        }
        if (!opt.ignoreRootClip && width != null && height != null) root.setClipPath(new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
            shape: {
                x: 0,
                y: 0,
                width: width,
                height: height
            }
        }));
        return {
            root: root,
            width: width,
            height: height,
            viewBoxRect: viewBoxRect,
            viewBoxTransform: viewBoxTransform,
            named: named
        };
    };
    SVGParser.prototype._parseNode = function(xmlNode, parentGroup, named, namedFrom, isInDefs, isInText) {
        var nodeName = xmlNode.nodeName.toLowerCase();
        var el;
        var namedFromForSub = namedFrom;
        if (nodeName === "defs") isInDefs = true;
        if (nodeName === "text") isInText = true;
        if (nodeName === "defs" || nodeName === "switch") el = parentGroup;
        else {
            if (!isInDefs) {
                var parser_1 = $ccaaa4a85c480645$var$nodeParsers[nodeName];
                if (parser_1 && (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)($ccaaa4a85c480645$var$nodeParsers, nodeName)) {
                    el = parser_1.call(this, xmlNode, parentGroup);
                    var nameAttr = xmlNode.getAttribute("name");
                    if (nameAttr) {
                        var newNamed = {
                            name: nameAttr,
                            namedFrom: null,
                            svgNodeTagLower: nodeName,
                            el: el
                        };
                        named.push(newNamed);
                        if (nodeName === "g") namedFromForSub = newNamed;
                    } else if (namedFrom) named.push({
                        name: namedFrom.name,
                        namedFrom: namedFrom,
                        svgNodeTagLower: nodeName,
                        el: el
                    });
                    parentGroup.add(el);
                }
            }
            var parser = $ccaaa4a85c480645$var$paintServerParsers[nodeName];
            if (parser && (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)($ccaaa4a85c480645$var$paintServerParsers, nodeName)) {
                var def = parser.call(this, xmlNode);
                var id = xmlNode.getAttribute("id");
                if (id) this._defs[id] = def;
            }
        }
        if (el && el.isGroup) {
            var child = xmlNode.firstChild;
            while(child){
                if (child.nodeType === 1) this._parseNode(child, el, named, namedFromForSub, isInDefs, isInText);
                else if (child.nodeType === 3 && isInText) this._parseText(child, el);
                child = child.nextSibling;
            }
        }
    };
    SVGParser.prototype._parseText = function(xmlNode, parentGroup) {
        var text = new (0, $c9d5c769fe2f591f$export$2e2bcd8739ae039)({
            style: {
                text: xmlNode.textContent
            },
            silent: true,
            x: this._textX || 0,
            y: this._textY || 0
        });
        $ccaaa4a85c480645$var$inheritStyle(parentGroup, text);
        $ccaaa4a85c480645$var$parseAttributes(xmlNode, text, this._defsUsePending, false, false);
        $ccaaa4a85c480645$var$applyTextAlignment(text, parentGroup);
        var textStyle = text.style;
        var fontSize = textStyle.fontSize;
        if (fontSize && fontSize < 9) {
            textStyle.fontSize = 9;
            text.scaleX *= fontSize / 9;
            text.scaleY *= fontSize / 9;
        }
        var font = (textStyle.fontSize || textStyle.fontFamily) && [
            textStyle.fontStyle,
            textStyle.fontWeight,
            (textStyle.fontSize || 12) + "px",
            textStyle.fontFamily || "sans-serif"
        ].join(" ");
        textStyle.font = font;
        var rect = text.getBoundingRect();
        this._textX += rect.width;
        parentGroup.add(text);
        return text;
    };
    SVGParser.internalField = function() {
        $ccaaa4a85c480645$var$nodeParsers = {
            "g": function(xmlNode, parentGroup) {
                var g = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, g);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, g, this._defsUsePending, false, false);
                return g;
            },
            "rect": function(xmlNode, parentGroup) {
                var rect = new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, rect);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, rect, this._defsUsePending, false, false);
                rect.setShape({
                    x: parseFloat(xmlNode.getAttribute("x") || "0"),
                    y: parseFloat(xmlNode.getAttribute("y") || "0"),
                    width: parseFloat(xmlNode.getAttribute("width") || "0"),
                    height: parseFloat(xmlNode.getAttribute("height") || "0")
                });
                rect.silent = true;
                return rect;
            },
            "circle": function(xmlNode, parentGroup) {
                var circle = new (0, $1e68d8727773abb7$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, circle);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, circle, this._defsUsePending, false, false);
                circle.setShape({
                    cx: parseFloat(xmlNode.getAttribute("cx") || "0"),
                    cy: parseFloat(xmlNode.getAttribute("cy") || "0"),
                    r: parseFloat(xmlNode.getAttribute("r") || "0")
                });
                circle.silent = true;
                return circle;
            },
            "line": function(xmlNode, parentGroup) {
                var line = new (0, $7a316ae5ceff7b27$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, line);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, line, this._defsUsePending, false, false);
                line.setShape({
                    x1: parseFloat(xmlNode.getAttribute("x1") || "0"),
                    y1: parseFloat(xmlNode.getAttribute("y1") || "0"),
                    x2: parseFloat(xmlNode.getAttribute("x2") || "0"),
                    y2: parseFloat(xmlNode.getAttribute("y2") || "0")
                });
                line.silent = true;
                return line;
            },
            "ellipse": function(xmlNode, parentGroup) {
                var ellipse = new (0, $4a809f055a7e524c$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, ellipse);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, ellipse, this._defsUsePending, false, false);
                ellipse.setShape({
                    cx: parseFloat(xmlNode.getAttribute("cx") || "0"),
                    cy: parseFloat(xmlNode.getAttribute("cy") || "0"),
                    rx: parseFloat(xmlNode.getAttribute("rx") || "0"),
                    ry: parseFloat(xmlNode.getAttribute("ry") || "0")
                });
                ellipse.silent = true;
                return ellipse;
            },
            "polygon": function(xmlNode, parentGroup) {
                var pointsStr = xmlNode.getAttribute("points");
                var pointsArr;
                if (pointsStr) pointsArr = $ccaaa4a85c480645$var$parsePoints(pointsStr);
                var polygon = new (0, $51acf033123e1a30$export$2e2bcd8739ae039)({
                    shape: {
                        points: pointsArr || []
                    },
                    silent: true
                });
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, polygon);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, polygon, this._defsUsePending, false, false);
                return polygon;
            },
            "polyline": function(xmlNode, parentGroup) {
                var pointsStr = xmlNode.getAttribute("points");
                var pointsArr;
                if (pointsStr) pointsArr = $ccaaa4a85c480645$var$parsePoints(pointsStr);
                var polyline = new (0, $d28119f30e6bb670$export$2e2bcd8739ae039)({
                    shape: {
                        points: pointsArr || []
                    },
                    silent: true
                });
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, polyline);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, polyline, this._defsUsePending, false, false);
                return polyline;
            },
            "image": function(xmlNode, parentGroup) {
                var img = new (0, $86adec94217b86c6$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, img);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, img, this._defsUsePending, false, false);
                img.setStyle({
                    image: xmlNode.getAttribute("xlink:href") || xmlNode.getAttribute("href"),
                    x: +xmlNode.getAttribute("x"),
                    y: +xmlNode.getAttribute("y"),
                    width: +xmlNode.getAttribute("width"),
                    height: +xmlNode.getAttribute("height")
                });
                img.silent = true;
                return img;
            },
            "text": function(xmlNode, parentGroup) {
                var x = xmlNode.getAttribute("x") || "0";
                var y = xmlNode.getAttribute("y") || "0";
                var dx = xmlNode.getAttribute("dx") || "0";
                var dy = xmlNode.getAttribute("dy") || "0";
                this._textX = parseFloat(x) + parseFloat(dx);
                this._textY = parseFloat(y) + parseFloat(dy);
                var g = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, g);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                return g;
            },
            "tspan": function(xmlNode, parentGroup) {
                var x = xmlNode.getAttribute("x");
                var y = xmlNode.getAttribute("y");
                if (x != null) this._textX = parseFloat(x);
                if (y != null) this._textY = parseFloat(y);
                var dx = xmlNode.getAttribute("dx") || "0";
                var dy = xmlNode.getAttribute("dy") || "0";
                var g = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, g);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                this._textX += parseFloat(dx);
                this._textY += parseFloat(dy);
                return g;
            },
            "path": function(xmlNode, parentGroup) {
                var d = xmlNode.getAttribute("d") || "";
                var path = (0, $15b38920672b9006$export$ae5b259626f00aeb)(d);
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, path);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, path, this._defsUsePending, false, false);
                path.silent = true;
                return path;
            }
        };
    }();
    return SVGParser;
}();
var $ccaaa4a85c480645$var$paintServerParsers = {
    "lineargradient": function(xmlNode) {
        var x1 = parseInt(xmlNode.getAttribute("x1") || "0", 10);
        var y1 = parseInt(xmlNode.getAttribute("y1") || "0", 10);
        var x2 = parseInt(xmlNode.getAttribute("x2") || "10", 10);
        var y2 = parseInt(xmlNode.getAttribute("y2") || "0", 10);
        var gradient = new (0, $cf44c01491b58e53$export$2e2bcd8739ae039)(x1, y1, x2, y2);
        $ccaaa4a85c480645$var$parsePaintServerUnit(xmlNode, gradient);
        $ccaaa4a85c480645$var$parseGradientColorStops(xmlNode, gradient);
        return gradient;
    },
    "radialgradient": function(xmlNode) {
        var cx = parseInt(xmlNode.getAttribute("cx") || "0", 10);
        var cy = parseInt(xmlNode.getAttribute("cy") || "0", 10);
        var r = parseInt(xmlNode.getAttribute("r") || "0", 10);
        var gradient = new (0, $cd2ee2ba32bb26c3$export$2e2bcd8739ae039)(cx, cy, r);
        $ccaaa4a85c480645$var$parsePaintServerUnit(xmlNode, gradient);
        $ccaaa4a85c480645$var$parseGradientColorStops(xmlNode, gradient);
        return gradient;
    }
};
function $ccaaa4a85c480645$var$parsePaintServerUnit(xmlNode, gradient) {
    var gradientUnits = xmlNode.getAttribute("gradientUnits");
    if (gradientUnits === "userSpaceOnUse") gradient.global = true;
}
function $ccaaa4a85c480645$var$parseGradientColorStops(xmlNode, gradient) {
    var stop = xmlNode.firstChild;
    while(stop){
        if (stop.nodeType === 1 && stop.nodeName.toLocaleLowerCase() === "stop") {
            var offsetStr = stop.getAttribute("offset");
            var offset = void 0;
            if (offsetStr && offsetStr.indexOf("%") > 0) offset = parseInt(offsetStr, 10) / 100;
            else if (offsetStr) offset = parseFloat(offsetStr);
            else offset = 0;
            var styleVals = {};
            $ccaaa4a85c480645$var$parseInlineStyle(stop, styleVals, styleVals);
            var stopColor = styleVals.stopColor || stop.getAttribute("stop-color") || "#000000";
            var stopOpacity = styleVals.stopOpacity || stop.getAttribute("stop-opacity");
            if (stopOpacity) {
                var rgba = $2c037f5bda6341ca$export$98e6a39c04603d36(stopColor);
                var stopColorOpacity = rgba && rgba[3];
                if (stopColorOpacity) {
                    rgba[3] *= $2c037f5bda6341ca$export$7638a67891c3b497(stopOpacity);
                    stopColor = $2c037f5bda6341ca$export$fac44ee5b035f737(rgba, "rgba");
                }
            }
            gradient.colorStops.push({
                offset: offset,
                color: stopColor
            });
        }
        stop = stop.nextSibling;
    }
}
function $ccaaa4a85c480645$var$inheritStyle(parent, child) {
    if (parent && parent.__inheritedStyle) {
        if (!child.__inheritedStyle) child.__inheritedStyle = {};
        (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(child.__inheritedStyle, parent.__inheritedStyle);
    }
}
function $ccaaa4a85c480645$var$parsePoints(pointsString) {
    var list = $ccaaa4a85c480645$var$splitNumberSequence(pointsString);
    var points = [];
    for(var i = 0; i < list.length; i += 2){
        var x = parseFloat(list[i]);
        var y = parseFloat(list[i + 1]);
        points.push([
            x,
            y
        ]);
    }
    return points;
}
function $ccaaa4a85c480645$var$parseAttributes(xmlNode, el, defsUsePending, onlyInlineStyle, isTextGroup) {
    var disp = el;
    var inheritedStyle = disp.__inheritedStyle = disp.__inheritedStyle || {};
    var selfStyle = {};
    if (xmlNode.nodeType === 1) {
        $ccaaa4a85c480645$var$parseTransformAttribute(xmlNode, el);
        $ccaaa4a85c480645$var$parseInlineStyle(xmlNode, inheritedStyle, selfStyle);
        if (!onlyInlineStyle) $ccaaa4a85c480645$var$parseAttributeStyle(xmlNode, inheritedStyle, selfStyle);
    }
    disp.style = disp.style || {};
    if (inheritedStyle.fill != null) disp.style.fill = $ccaaa4a85c480645$var$getFillStrokeStyle(disp, "fill", inheritedStyle.fill, defsUsePending);
    if (inheritedStyle.stroke != null) disp.style.stroke = $ccaaa4a85c480645$var$getFillStrokeStyle(disp, "stroke", inheritedStyle.stroke, defsUsePending);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        "lineWidth",
        "opacity",
        "fillOpacity",
        "strokeOpacity",
        "miterLimit",
        "fontSize"
    ], function(propName) {
        if (inheritedStyle[propName] != null) disp.style[propName] = parseFloat(inheritedStyle[propName]);
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        "lineDashOffset",
        "lineCap",
        "lineJoin",
        "fontWeight",
        "fontFamily",
        "fontStyle",
        "textAlign"
    ], function(propName) {
        if (inheritedStyle[propName] != null) disp.style[propName] = inheritedStyle[propName];
    });
    if (isTextGroup) disp.__selfStyle = selfStyle;
    if (inheritedStyle.lineDash) disp.style.lineDash = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)($ccaaa4a85c480645$var$splitNumberSequence(inheritedStyle.lineDash), function(str) {
        return parseFloat(str);
    });
    if (inheritedStyle.visibility === "hidden" || inheritedStyle.visibility === "collapse") disp.invisible = true;
    if (inheritedStyle.display === "none") disp.ignore = true;
}
function $ccaaa4a85c480645$var$applyTextAlignment(text, parentGroup) {
    var parentSelfStyle = parentGroup.__selfStyle;
    if (parentSelfStyle) {
        var textBaseline = parentSelfStyle.textBaseline;
        var zrTextBaseline = textBaseline;
        if (!textBaseline || textBaseline === "auto") zrTextBaseline = "alphabetic";
        else if (textBaseline === "baseline") zrTextBaseline = "alphabetic";
        else if (textBaseline === "before-edge" || textBaseline === "text-before-edge") zrTextBaseline = "top";
        else if (textBaseline === "after-edge" || textBaseline === "text-after-edge") zrTextBaseline = "bottom";
        else if (textBaseline === "central" || textBaseline === "mathematical") zrTextBaseline = "middle";
        text.style.textBaseline = zrTextBaseline;
    }
    var parentInheritedStyle = parentGroup.__inheritedStyle;
    if (parentInheritedStyle) {
        var textAlign = parentInheritedStyle.textAlign;
        var zrTextAlign = textAlign;
        if (textAlign) {
            if (textAlign === "middle") zrTextAlign = "center";
            text.style.textAlign = zrTextAlign;
        }
    }
}
var $ccaaa4a85c480645$var$urlRegex = /^url\(\s*#(.*?)\)/;
function $ccaaa4a85c480645$var$getFillStrokeStyle(el, method, str, defsUsePending) {
    var urlMatch = str && str.match($ccaaa4a85c480645$var$urlRegex);
    if (urlMatch) {
        var url = (0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(urlMatch[1]);
        defsUsePending.push([
            el,
            method,
            url
        ]);
        return;
    }
    if (str === "none") str = null;
    return str;
}
function $ccaaa4a85c480645$var$applyDefs(defs, defsUsePending) {
    for(var i = 0; i < defsUsePending.length; i++){
        var item = defsUsePending[i];
        item[0].style[item[1]] = defs[item[2]];
    }
}
var $ccaaa4a85c480645$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function $ccaaa4a85c480645$var$splitNumberSequence(rawStr) {
    return rawStr.match($ccaaa4a85c480645$var$numberReg) || [];
}
var $ccaaa4a85c480645$var$transformRegex = /(translate|scale|rotate|skewX|skewY|matrix)\(([\-\s0-9\.eE,]*)\)/g;
var $ccaaa4a85c480645$var$DEGREE_TO_ANGLE = Math.PI / 180;
function $ccaaa4a85c480645$var$parseTransformAttribute(xmlNode, node) {
    var transform = xmlNode.getAttribute("transform");
    if (transform) {
        transform = transform.replace(/,/g, " ");
        var transformOps_1 = [];
        var mt = null;
        transform.replace($ccaaa4a85c480645$var$transformRegex, function(str, type, value) {
            transformOps_1.push(type, value);
            return "";
        });
        for(var i = transformOps_1.length - 1; i > 0; i -= 2){
            var value = transformOps_1[i];
            var type = transformOps_1[i - 1];
            var valueArr = $ccaaa4a85c480645$var$splitNumberSequence(value);
            mt = mt || $f41ebb9dd60b55b4$export$185802fd694ee1f5();
            switch(type){
                case "translate":
                    $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(mt, mt, [
                        parseFloat(valueArr[0]),
                        parseFloat(valueArr[1] || "0")
                    ]);
                    break;
                case "scale":
                    $f41ebb9dd60b55b4$export$dcdf75081b88279d(mt, mt, [
                        parseFloat(valueArr[0]),
                        parseFloat(valueArr[1] || valueArr[0])
                    ]);
                    break;
                case "rotate":
                    $f41ebb9dd60b55b4$export$bb628a54ab399bc9(mt, mt, -parseFloat(valueArr[0]) * $ccaaa4a85c480645$var$DEGREE_TO_ANGLE, [
                        parseFloat(valueArr[1] || "0"),
                        parseFloat(valueArr[2] || "0")
                    ]);
                    break;
                case "skewX":
                    var sx = Math.tan(parseFloat(valueArr[0]) * $ccaaa4a85c480645$var$DEGREE_TO_ANGLE);
                    $f41ebb9dd60b55b4$export$6e3a27864ab166fe(mt, [
                        1,
                        0,
                        sx,
                        1,
                        0,
                        0
                    ], mt);
                    break;
                case "skewY":
                    var sy = Math.tan(parseFloat(valueArr[0]) * $ccaaa4a85c480645$var$DEGREE_TO_ANGLE);
                    $f41ebb9dd60b55b4$export$6e3a27864ab166fe(mt, [
                        1,
                        sy,
                        0,
                        1,
                        0,
                        0
                    ], mt);
                    break;
                case "matrix":
                    mt[0] = parseFloat(valueArr[0]);
                    mt[1] = parseFloat(valueArr[1]);
                    mt[2] = parseFloat(valueArr[2]);
                    mt[3] = parseFloat(valueArr[3]);
                    mt[4] = parseFloat(valueArr[4]);
                    mt[5] = parseFloat(valueArr[5]);
                    break;
            }
        }
        node.setLocalTransform(mt);
    }
}
var $ccaaa4a85c480645$var$styleRegex = /([^\s:;]+)\s*:\s*([^:;]+)/g;
function $ccaaa4a85c480645$var$parseInlineStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
    var style = xmlNode.getAttribute("style");
    if (!style) return;
    $ccaaa4a85c480645$var$styleRegex.lastIndex = 0;
    var styleRegResult;
    while((styleRegResult = $ccaaa4a85c480645$var$styleRegex.exec(style)) != null){
        var svgStlAttr = styleRegResult[1];
        var zrInheritableStlAttr = (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)($ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP, svgStlAttr) ? $ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP[svgStlAttr] : null;
        if (zrInheritableStlAttr) inheritableStyleResult[zrInheritableStlAttr] = styleRegResult[2];
        var zrSelfStlAttr = (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)($ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP, svgStlAttr) ? $ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP[svgStlAttr] : null;
        if (zrSelfStlAttr) selfStyleResult[zrSelfStlAttr] = styleRegResult[2];
    }
}
function $ccaaa4a85c480645$var$parseAttributeStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
    for(var i = 0; i < $ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS.length; i++){
        var svgAttrName = $ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS[i];
        var attrValue = xmlNode.getAttribute(svgAttrName);
        if (attrValue != null) inheritableStyleResult[$ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
    }
    for(var i = 0; i < $ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS.length; i++){
        var svgAttrName = $ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS[i];
        var attrValue = xmlNode.getAttribute(svgAttrName);
        if (attrValue != null) selfStyleResult[$ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
    }
}
function $ccaaa4a85c480645$export$3e2db4420f14f50f(viewBoxRect, boundingRect) {
    var scaleX = boundingRect.width / viewBoxRect.width;
    var scaleY = boundingRect.height / viewBoxRect.height;
    var scale = Math.min(scaleX, scaleY);
    return {
        scale: scale,
        x: -(viewBoxRect.x + viewBoxRect.width / 2) * scale + (boundingRect.x + boundingRect.width / 2),
        y: -(viewBoxRect.y + viewBoxRect.height / 2) * scale + (boundingRect.y + boundingRect.height / 2)
    };
}
function $ccaaa4a85c480645$export$1919f5101c220601(xml, opt) {
    var parser = new $ccaaa4a85c480645$var$SVGParser();
    return parser.parse(xml, opt);
}







/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $b4726ec5f917394d$var$EPSILON = 1e-8;
function $b4726ec5f917394d$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $b4726ec5f917394d$var$EPSILON;
}
function $b4726ec5f917394d$export$8893e2b90ba10d92(points, x, y) {
    var w = 0;
    var p = points[0];
    if (!p) return false;
    for(var i = 1; i < points.length; i++){
        var p2 = points[i];
        w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(p[0], p[1], p2[0], p2[1], x, y);
        p = p2;
    }
    var p0 = points[0];
    if (!$b4726ec5f917394d$var$isAroundEqual(p[0], p0[0]) || !$b4726ec5f917394d$var$isAroundEqual(p[1], p0[1])) w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(p[0], p[1], p0[0], p0[1], x, y);
    return w !== 0;
}




var $00e94d08c93517b6$var$TMP_TRANSFORM = [];
function $00e94d08c93517b6$var$transformPoints(points, transform) {
    for(var p = 0; p < points.length; p++)$6de594cf8ac295ff$export$9f9dcb98c894b623(points[p], points[p], transform);
}
function $00e94d08c93517b6$var$updateBBoxFromPoints(points, min, max, projection) {
    for(var i = 0; i < points.length; i++){
        var p = points[i];
        if (projection) // projection may return null point.
        p = projection.project(p);
        if (p && isFinite(p[0]) && isFinite(p[1])) {
            $6de594cf8ac295ff$export$96ec731ed4dcb222(min, min, p);
            $6de594cf8ac295ff$export$8960430cfd85939f(max, max, p);
        }
    }
}
function $00e94d08c93517b6$var$centroid(points) {
    var signedArea = 0;
    var cx = 0;
    var cy = 0;
    var len = points.length;
    var x0 = points[len - 1][0];
    var y0 = points[len - 1][1];
    // Polygon should been closed.
    for(var i = 0; i < len; i++){
        var x1 = points[i][0];
        var y1 = points[i][1];
        var a = x0 * y1 - x1 * y0;
        signedArea += a;
        cx += (x0 + x1) * a;
        cy += (y0 + y1) * a;
        x0 = x1;
        y0 = y1;
    }
    return signedArea ? [
        cx / signedArea / 3,
        cy / signedArea / 3,
        signedArea
    ] : [
        points[0][0] || 0,
        points[0][1] || 0
    ];
}
var $00e94d08c93517b6$export$b1f97c3099fc6872 = /** @class */ function() {
    function Region(name) {
        this.name = name;
    }
    Region.prototype.setCenter = function(center) {
        this._center = center;
    };
    /**
   * Get center point in data unit. That is,
   * for GeoJSONRegion, the unit is lat/lng,
   * for GeoSVGRegion, the unit is SVG local coord.
   */ Region.prototype.getCenter = function() {
        var center = this._center;
        if (!center) // In most cases there are no need to calculate this center.
        // So calculate only when called.
        center = this._center = this.calcCenter();
        return center;
    };
    return Region;
}();
var $00e94d08c93517b6$export$91e20b0f72443753 = /** @class */ function() {
    function GeoJSONPolygonGeometry(exterior, interiors) {
        this.type = "polygon";
        this.exterior = exterior;
        this.interiors = interiors;
    }
    return GeoJSONPolygonGeometry;
}();
var $00e94d08c93517b6$export$335807c9e785d92c = /** @class */ function() {
    function GeoJSONLineStringGeometry(points) {
        this.type = "linestring";
        this.points = points;
    }
    return GeoJSONLineStringGeometry;
}();
var $00e94d08c93517b6$export$ee84fcb463f24b3d = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GeoJSONRegion, _super);
    function GeoJSONRegion(name, geometries, cp) {
        var _this = _super.call(this, name) || this;
        _this.type = "geoJSON";
        _this.geometries = geometries;
        _this._center = cp && [
            cp[0],
            cp[1]
        ];
        return _this;
    }
    GeoJSONRegion.prototype.calcCenter = function() {
        var geometries = this.geometries;
        var largestGeo;
        var largestGeoSize = 0;
        for(var i = 0; i < geometries.length; i++){
            var geo = geometries[i];
            var exterior = geo.exterior;
            // Simple trick to use points count instead of polygon area as region size.
            // Ignore linestring
            var size = exterior && exterior.length;
            if (size > largestGeoSize) {
                largestGeo = geo;
                largestGeoSize = size;
            }
        }
        if (largestGeo) return $00e94d08c93517b6$var$centroid(largestGeo.exterior);
        // from bounding rect by default.
        var rect = this.getBoundingRect();
        return [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    };
    GeoJSONRegion.prototype.getBoundingRect = function(projection) {
        var rect = this._rect;
        // Always recalculate if using projection.
        if (rect && !projection) return rect;
        var min = [
            Infinity,
            Infinity
        ];
        var max = [
            -Infinity,
            -Infinity
        ];
        var geometries = this.geometries;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(geometries, function(geo) {
            if (geo.type === "polygon") // Doesn't consider hole
            $00e94d08c93517b6$var$updateBBoxFromPoints(geo.exterior, min, max, projection);
            else (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(geo.points, function(points) {
                $00e94d08c93517b6$var$updateBBoxFromPoints(points, min, max, projection);
            });
        });
        // Normalie invalid bounding.
        if (!(isFinite(min[0]) && isFinite(min[1]) && isFinite(max[0]) && isFinite(max[1]))) min[0] = min[1] = max[0] = max[1] = 0;
        rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(min[0], min[1], max[0] - min[0], max[1] - min[1]);
        if (!projection) this._rect = rect;
        return rect;
    };
    GeoJSONRegion.prototype.contain = function(coord) {
        var rect = this.getBoundingRect();
        var geometries = this.geometries;
        if (!rect.contain(coord[0], coord[1])) return false;
        loopGeo: for(var i = 0, len = geometries.length; i < len; i++){
            var geo = geometries[i];
            // Only support polygon.
            if (geo.type !== "polygon") continue;
            var exterior = geo.exterior;
            var interiors = geo.interiors;
            if ($b4726ec5f917394d$export$8893e2b90ba10d92(exterior, coord[0], coord[1])) {
                // Not in the region if point is in the hole.
                for(var k = 0; k < (interiors ? interiors.length : 0); k++){
                    if ($b4726ec5f917394d$export$8893e2b90ba10d92(interiors[k], coord[0], coord[1])) continue loopGeo;
                }
                return true;
            }
        }
        return false;
    };
    /**
   * Transform the raw coords to target bounding.
   * @param x
   * @param y
   * @param width
   * @param height
   */ GeoJSONRegion.prototype.transformTo = function(x, y, width, height) {
        var rect = this.getBoundingRect();
        var aspect = rect.width / rect.height;
        if (!width) width = aspect * height;
        else if (!height) height = width / aspect;
        var target = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height);
        var transform = rect.calculateTransform(target);
        var geometries = this.geometries;
        for(var i = 0; i < geometries.length; i++){
            var geo = geometries[i];
            if (geo.type === "polygon") {
                $00e94d08c93517b6$var$transformPoints(geo.exterior, transform);
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(geo.interiors, function(interior) {
                    $00e94d08c93517b6$var$transformPoints(interior, transform);
                });
            } else (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(geo.points, function(points) {
                $00e94d08c93517b6$var$transformPoints(points, transform);
            });
        }
        rect = this._rect;
        rect.copy(target);
        // Update center
        this._center = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    };
    GeoJSONRegion.prototype.cloneShallow = function(name) {
        name == null && (name = this.name);
        var newRegion = new GeoJSONRegion(name, this.geometries, this._center);
        newRegion._rect = this._rect;
        newRegion.transformTo = null; // Simply avoid to be called.
        return newRegion;
    };
    return GeoJSONRegion;
}($00e94d08c93517b6$export$b1f97c3099fc6872);
var $00e94d08c93517b6$export$5f3d89e7254f3e69 = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GeoSVGRegion, _super);
    function GeoSVGRegion(name, elOnlyForCalculate) {
        var _this = _super.call(this, name) || this;
        _this.type = "geoSVG";
        _this._elOnlyForCalculate = elOnlyForCalculate;
        return _this;
    }
    GeoSVGRegion.prototype.calcCenter = function() {
        var el = this._elOnlyForCalculate;
        var rect = el.getBoundingRect();
        var center = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
        var mat = $f41ebb9dd60b55b4$export$f0954fd7d5368655($00e94d08c93517b6$var$TMP_TRANSFORM);
        var target = el;
        while(target && !target.isGeoSVGGraphicRoot){
            $f41ebb9dd60b55b4$export$6e3a27864ab166fe(mat, target.getLocalTransform(), mat);
            target = target.parent;
        }
        $f41ebb9dd60b55b4$export$6897c284b6f9f4dc(mat, mat);
        $6de594cf8ac295ff$export$9f9dcb98c894b623(center, center, mat);
        return center;
    };
    return GeoSVGRegion;
}($00e94d08c93517b6$export$b1f97c3099fc6872);


/**
 * "region available" means that: enable users to set attribute `name="xxx"` on those tags
 * to make it be a region.
 * 1. region styles and its label styles can be defined in echarts opton:
 * ```js
 * geo: {
 *     regions: [{
 *         name: 'xxx',
 *         itemStyle: { ... },
 *         label: { ... }
 *     }, {
 *         ...
 *     },
 *     ...]
 * };
 * ```
 * 2. name can be duplicated in different SVG tag. All of the tags with the same name share
 * a region option. For exampel if there are two <path> representing two lung lobes. They have
 * no common parents but both of them need to display label "lung" inside.
 */ var $decc9bf1380d61c0$var$REGION_AVAILABLE_SVG_TAG_MAP = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)([
    "rect",
    "circle",
    "line",
    "ellipse",
    "polygon",
    "polyline",
    "path",
    // <text> <tspan> are also enabled because some SVG might paint text itself,
    // but still need to trigger events or tooltip.
    "text",
    "tspan",
    // <g> is also enabled because this case: if multiple tags share one name
    // and need label displayed, every tags will display the name, which is not
    // expected. So we can put them into a <g name="xxx">. Thereby only one label
    // displayed and located based on the bounding rect of the <g>.
    "g"
]);
var $decc9bf1380d61c0$export$be52c950efae1f84 = /** @class */ function() {
    function GeoSVGResource(mapName, svg) {
        this.type = "geoSVG";
        // All used graphics. key: hostKey, value: root
        this._usedGraphicMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        // All unused graphics.
        this._freedGraphics = [];
        this._mapName = mapName;
        // Only perform parse to XML object here, which might be time
        // consiming for large SVG.
        // Although convert XML to zrender element is also time consiming,
        // if we do it here, the clone of zrender elements has to be
        // required. So we do it once for each geo instance, util real
        // performance issues call for optimizing it.
        this._parsedXML = (0, $6d3db85dae3a1192$export$eacefc55fad2867e)(svg);
    }
    GeoSVGResource.prototype.load = function() {
        // In the "load" stage, graphic need to be built to
        // get boundingRect for geo coordinate system.
        var firstGraphic = this._firstGraphic;
        // Create the return data structure only when first graphic created.
        // Because they will be used in geo coordinate system update stage,
        // and `regions` will be mounted at `geo` coordinate system,
        // in which there is no "view" info, so that it should better not to
        // make references to graphic elements.
        if (!firstGraphic) {
            firstGraphic = this._firstGraphic = this._buildGraphic(this._parsedXML);
            this._freedGraphics.push(firstGraphic);
            this._boundingRect = this._firstGraphic.boundingRect.clone();
            // PENDING: `nameMap` will not be supported until some real requirement come.
            // if (nameMap) {
            //     named = applyNameMap(named, nameMap);
            // }
            var _a = $decc9bf1380d61c0$var$createRegions(firstGraphic.named), regions = _a.regions, regionsMap = _a.regionsMap;
            this._regions = regions;
            this._regionsMap = regionsMap;
        }
        return {
            boundingRect: this._boundingRect,
            regions: this._regions,
            regionsMap: this._regionsMap
        };
    };
    GeoSVGResource.prototype._buildGraphic = function(svgXML) {
        var result;
        var rootFromParse;
        try {
            result = svgXML && (0, $ccaaa4a85c480645$export$1919f5101c220601)(svgXML, {
                ignoreViewBox: true,
                ignoreRootClip: true
            }) || {};
            rootFromParse = result.root;
            (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(rootFromParse != null);
        } catch (e) {
            throw new Error("Invalid svg format\n" + e.message);
        }
        // Note: we keep the covenant that the root has no transform. So always add an extra root.
        var root = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        root.add(rootFromParse);
        root.isGeoSVGGraphicRoot = true;
        // [THE_RULE_OF_VIEWPORT_AND_VIEWBOX]
        //
        // Consider: `<svg width="..." height="..." viewBox="...">`
        // - the `width/height` we call it `svgWidth/svgHeight` for short.
        // - `(0, 0, svgWidth, svgHeight)` defines the viewport of the SVG, or say,
        //   "viewport boundingRect", or `boundingRect` for short.
        // - `viewBox` defines the transform from the real content ot the viewport.
        //   `viewBox` has the same unit as the content of SVG.
        //   If `viewBox` exists, a transform is defined, so the unit of `svgWidth/svgHeight` become
        //   different from the content of SVG. Otherwise, they are the same.
        //
        // If both `svgWidth/svgHeight/viewBox` are specified in a SVG file, the transform rule will be:
        // 0. `boundingRect` is `(0, 0, svgWidth, svgHeight)`. Set it to Geo['_rect'] (View['_rect']).
        // 1. Make a transform from `viewBox` to `boundingRect`.
        //    Note: only support `preserveAspectRatio 'xMidYMid'` here. That is, this transform will preserve
        //    the aspect ratio.
        // 2. Make a transform from boundingRect to Geo['_viewRect'] (View['_viewRect'])
        //    (`Geo`/`View` will do this job).
        //    Note: this transform might not preserve aspect radio, which depending on how users specify
        //    viewRect in echarts option (e.g., `geo.left/top/width/height` will not preserve aspect ratio,
        //    but `geo.layoutCenter/layoutSize` will preserve aspect ratio).
        //
        // If `svgWidth/svgHeight` not specified, we use `viewBox` as the `boundingRect` to make the SVG
        // layout look good.
        //
        // If neither `svgWidth/svgHeight` nor `viewBox` are not specified, we calculate the boundingRect
        // of the SVG content and use them to make SVG layout look good.
        var svgWidth = result.width;
        var svgHeight = result.height;
        var viewBoxRect = result.viewBoxRect;
        var boundingRect = this._boundingRect;
        if (!boundingRect) {
            var bRectX = void 0;
            var bRectY = void 0;
            var bRectWidth = void 0;
            var bRectHeight = void 0;
            if (svgWidth != null) {
                bRectX = 0;
                bRectWidth = svgWidth;
            } else if (viewBoxRect) {
                bRectX = viewBoxRect.x;
                bRectWidth = viewBoxRect.width;
            }
            if (svgHeight != null) {
                bRectY = 0;
                bRectHeight = svgHeight;
            } else if (viewBoxRect) {
                bRectY = viewBoxRect.y;
                bRectHeight = viewBoxRect.height;
            }
            // If both viewBox and svgWidth/svgHeight not specified,
            // we have to determine how to layout those element to make them look good.
            if (bRectX == null || bRectY == null) {
                var calculatedBoundingRect = rootFromParse.getBoundingRect();
                if (bRectX == null) {
                    bRectX = calculatedBoundingRect.x;
                    bRectWidth = calculatedBoundingRect.width;
                }
                if (bRectY == null) {
                    bRectY = calculatedBoundingRect.y;
                    bRectHeight = calculatedBoundingRect.height;
                }
            }
            boundingRect = this._boundingRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(bRectX, bRectY, bRectWidth, bRectHeight);
        }
        if (viewBoxRect) {
            var viewBoxTransform = (0, $ccaaa4a85c480645$export$3e2db4420f14f50f)(viewBoxRect, boundingRect);
            // Only support `preserveAspectRatio 'xMidYMid'`
            rootFromParse.scaleX = rootFromParse.scaleY = viewBoxTransform.scale;
            rootFromParse.x = viewBoxTransform.x;
            rootFromParse.y = viewBoxTransform.y;
        }
        // SVG needs to clip based on `viewBox`. And some SVG files really rely on this feature.
        // They do not strictly confine all of the content inside a display rect, but deliberately
        // use a `viewBox` to define a displayable rect.
        // PENDING:
        // The drawback of the `setClipPath` here is: the region label (genereted by echarts) near the
        // edge might also be clipped, because region labels are put as `textContent` of the SVG path.
        root.setClipPath(new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
            shape: boundingRect.plain()
        }));
        var named = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(result.named, function(namedItem) {
            if ($decc9bf1380d61c0$var$REGION_AVAILABLE_SVG_TAG_MAP.get(namedItem.svgNodeTagLower) != null) {
                named.push(namedItem);
                $decc9bf1380d61c0$var$setSilent(namedItem.el);
            }
        });
        return {
            root: root,
            boundingRect: boundingRect,
            named: named
        };
    };
    /**
   * Consider:
   * (1) One graphic element can not be shared by different `geoView` running simultaneously.
   *     Notice, also need to consider multiple echarts instances share a `mapRecord`.
   * (2) Converting SVG to graphic elements is time consuming.
   * (3) In the current architecture, `load` should be called frequently to get boundingRect,
   *     and it is called without view info.
   * So we maintain graphic elements in this module, and enables `view` to use/return these
   * graphics from/to the pool with it's uid.
   */ GeoSVGResource.prototype.useGraphic = function(hostKey /* , nameMap: NameMap */ ) {
        var usedRootMap = this._usedGraphicMap;
        var svgGraphic = usedRootMap.get(hostKey);
        if (svgGraphic) return svgGraphic;
        svgGraphic = this._freedGraphics.pop() || this._buildGraphic(this._parsedXML);
        usedRootMap.set(hostKey, svgGraphic);
        // PENDING: `nameMap` will not be supported until some real requirement come.
        // `nameMap` can only be obtained from echarts option.
        // The original `named` must not be modified.
        // if (nameMap) {
        //     svgGraphic = extend({}, svgGraphic);
        //     svgGraphic.named = applyNameMap(svgGraphic.named, nameMap);
        // }
        return svgGraphic;
    };
    GeoSVGResource.prototype.freeGraphic = function(hostKey) {
        var usedRootMap = this._usedGraphicMap;
        var svgGraphic = usedRootMap.get(hostKey);
        if (svgGraphic) {
            usedRootMap.removeKey(hostKey);
            this._freedGraphics.push(svgGraphic);
        }
    };
    return GeoSVGResource;
}();
function $decc9bf1380d61c0$var$setSilent(el) {
    // Only named element has silent: false, other elements should
    // act as background and has no user interaction.
    el.silent = false;
    // text|tspan will be converted to group.
    if (el.isGroup) el.traverse(function(child) {
        child.silent = false;
    });
}
function $decc9bf1380d61c0$var$createRegions(named) {
    var regions = [];
    var regionsMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    // Create resions only for the first graphic.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(named, function(namedItem) {
        // Region has feature to calculate center for tooltip or other features.
        // If there is a <g name="xxx">, the center should be the center of the
        // bounding rect of the g.
        if (namedItem.namedFrom != null) return;
        var region = new (0, $00e94d08c93517b6$export$5f3d89e7254f3e69)(namedItem.name, namedItem.el);
        // PENDING: if `nameMap` supported, this region can not be mounted on
        // `this`, but can only be created each time `load()` called.
        regions.push(region);
        // PENDING: if multiple tag named with the same name, only one will be
        // found by `_regionsMap`. `_regionsMap` is used to find a coordinate
        // by name. We use `region.getCenter()` as the coordinate.
        regionsMap.set(namedItem.name, region);
    });
    return {
        regions: regions,
        regionsMap: regionsMap
    };
} // PENDING: `nameMap` will not be supported until some real requirement come.
 // /**
 //  * Use the alias in geoNameMap.
 //  * The input `named` must not be modified.
 //  */
 // function applyNameMap(
 //     named: GeoSVGGraphicRecord['named'],
 //     nameMap: NameMap
 // ): GeoSVGGraphicRecord['named'] {
 //     const result = [] as GeoSVGGraphicRecord['named'];
 //     for (let i = 0; i < named.length; i++) {
 //         let regionGraphic = named[i];
 //         const name = regionGraphic.name;
 //         if (nameMap && nameMap.hasOwnProperty(name)) {
 //             regionGraphic = extend({}, regionGraphic);
 //             regionGraphic.name = name;
 //         }
 //         result.push(regionGraphic);
 //     }
 //     return result;
 // }


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Parse and decode geo json
 */ 

function $1a1de70a2b6a5dc5$var$decode(json) {
    if (!json.UTF8Encoding) return json;
    var jsonCompressed = json;
    var encodeScale = jsonCompressed.UTF8Scale;
    if (encodeScale == null) encodeScale = 1024;
    var features = jsonCompressed.features;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(features, function(feature) {
        var geometry = feature.geometry;
        var encodeOffsets = geometry.encodeOffsets;
        var coordinates = geometry.coordinates;
        // Geometry may be appeded manually in the script after json loaded.
        // In this case this geometry is usually not encoded.
        if (!encodeOffsets) return;
        switch(geometry.type){
            case "LineString":
                geometry.coordinates = $1a1de70a2b6a5dc5$var$decodeRing(coordinates, encodeOffsets, encodeScale);
                break;
            case "Polygon":
                $1a1de70a2b6a5dc5$var$decodeRings(coordinates, encodeOffsets, encodeScale);
                break;
            case "MultiLineString":
                $1a1de70a2b6a5dc5$var$decodeRings(coordinates, encodeOffsets, encodeScale);
                break;
            case "MultiPolygon":
                $7a1bd9c2710fea0d$export$79b2f7037acddd43(coordinates, function(rings, idx) {
                    return $1a1de70a2b6a5dc5$var$decodeRings(rings, encodeOffsets[idx], encodeScale);
                });
        }
    });
    // Has been decoded
    jsonCompressed.UTF8Encoding = false;
    return jsonCompressed;
}
function $1a1de70a2b6a5dc5$var$decodeRings(rings, encodeOffsets, encodeScale) {
    for(var c = 0; c < rings.length; c++)rings[c] = $1a1de70a2b6a5dc5$var$decodeRing(rings[c], encodeOffsets[c], encodeScale);
}
function $1a1de70a2b6a5dc5$var$decodeRing(coordinate, encodeOffsets, encodeScale) {
    var result = [];
    var prevX = encodeOffsets[0];
    var prevY = encodeOffsets[1];
    for(var i = 0; i < coordinate.length; i += 2){
        var x = coordinate.charCodeAt(i) - 64;
        var y = coordinate.charCodeAt(i + 1) - 64;
        // ZigZag decoding
        x = x >> 1 ^ -(x & 1);
        y = y >> 1 ^ -(y & 1);
        // Delta deocding
        x += prevX;
        y += prevY;
        prevX = x;
        prevY = y;
        // Dequantize
        result.push([
            x / encodeScale,
            y / encodeScale
        ]);
    }
    return result;
}
function $1a1de70a2b6a5dc5$export$2e2bcd8739ae039(geoJson, nameProperty) {
    geoJson = $1a1de70a2b6a5dc5$var$decode(geoJson);
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88($7a1bd9c2710fea0d$export$3dea766d36a8935f(geoJson.features, function(featureObj) {
        // Output of mapshaper may have geometry null
        return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
    }), function(featureObj) {
        var properties = featureObj.properties;
        var geo = featureObj.geometry;
        var geometries = [];
        switch(geo.type){
            case "Polygon":
                var coordinates = geo.coordinates;
                // According to the GeoJSON specification.
                // First must be exterior, and the rest are all interior(holes).
                geometries.push(new (0, $00e94d08c93517b6$export$91e20b0f72443753)(coordinates[0], coordinates.slice(1)));
                break;
            case "MultiPolygon":
                $7a1bd9c2710fea0d$export$79b2f7037acddd43(geo.coordinates, function(item) {
                    if (item[0]) geometries.push(new (0, $00e94d08c93517b6$export$91e20b0f72443753)(item[0], item.slice(1)));
                });
                break;
            case "LineString":
                geometries.push(new (0, $00e94d08c93517b6$export$335807c9e785d92c)([
                    geo.coordinates
                ]));
                break;
            case "MultiLineString":
                geometries.push(new (0, $00e94d08c93517b6$export$335807c9e785d92c)(geo.coordinates));
        }
        var region = new (0, $00e94d08c93517b6$export$ee84fcb463f24b3d)(properties[nameProperty || "name"], geometries, properties.cp);
        region.properties = properties;
        return region;
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Fix for 南海诸岛


var $616ae7a19aad52f4$var$geoCoord = [
    126,
    25
];
var $616ae7a19aad52f4$var$nanhaiName = "\u5357\u6D77\u8BF8\u5C9B";
var $616ae7a19aad52f4$var$points = [
    [
        [
            0,
            3.5
        ],
        [
            7,
            11.2
        ],
        [
            15,
            11.9
        ],
        [
            30,
            7
        ],
        [
            42,
            0.7
        ],
        [
            52,
            0.7
        ],
        [
            56,
            7.7
        ],
        [
            59,
            0.7
        ],
        [
            64,
            0.7
        ],
        [
            64,
            0
        ],
        [
            5,
            0
        ],
        [
            0,
            3.5
        ]
    ],
    [
        [
            13,
            16.1
        ],
        [
            19,
            14.7
        ],
        [
            16,
            21.7
        ],
        [
            11,
            23.1
        ],
        [
            13,
            16.1
        ]
    ],
    [
        [
            12,
            32.2
        ],
        [
            14,
            38.5
        ],
        [
            15,
            38.5
        ],
        [
            13,
            32.2
        ],
        [
            12,
            32.2
        ]
    ],
    [
        [
            16,
            47.6
        ],
        [
            12,
            53.2
        ],
        [
            13,
            53.2
        ],
        [
            18,
            47.6
        ],
        [
            16,
            47.6
        ]
    ],
    [
        [
            6,
            64.4
        ],
        [
            8,
            70
        ],
        [
            9,
            70
        ],
        [
            8,
            64.4
        ],
        [
            6,
            64.4
        ]
    ],
    [
        [
            23,
            82.6
        ],
        [
            29,
            79.8
        ],
        [
            30,
            79.8
        ],
        [
            25,
            82.6
        ],
        [
            23,
            82.6
        ]
    ],
    [
        [
            37,
            70.7
        ],
        [
            43,
            62.3
        ],
        [
            44,
            62.3
        ],
        [
            39,
            70.7
        ],
        [
            37,
            70.7
        ]
    ],
    [
        [
            48,
            51.1
        ],
        [
            51,
            45.5
        ],
        [
            53,
            45.5
        ],
        [
            50,
            51.1
        ],
        [
            48,
            51.1
        ]
    ],
    [
        [
            51,
            35
        ],
        [
            51,
            28.7
        ],
        [
            53,
            28.7
        ],
        [
            53,
            35
        ],
        [
            51,
            35
        ]
    ],
    [
        [
            52,
            22.4
        ],
        [
            55,
            17.5
        ],
        [
            56,
            17.5
        ],
        [
            53,
            22.4
        ],
        [
            52,
            22.4
        ]
    ],
    [
        [
            58,
            12.6
        ],
        [
            62,
            7
        ],
        [
            63,
            7
        ],
        [
            60,
            12.6
        ],
        [
            58,
            12.6
        ]
    ],
    [
        [
            0,
            3.5
        ],
        [
            0,
            93.1
        ],
        [
            64,
            93.1
        ],
        [
            64,
            0
        ],
        [
            63,
            0
        ],
        [
            63,
            92.4
        ],
        [
            1,
            92.4
        ],
        [
            1,
            3.5
        ],
        [
            0,
            3.5
        ]
    ]
];
for(var $616ae7a19aad52f4$var$i = 0; $616ae7a19aad52f4$var$i < $616ae7a19aad52f4$var$points.length; $616ae7a19aad52f4$var$i++)for(var $616ae7a19aad52f4$var$k = 0; $616ae7a19aad52f4$var$k < $616ae7a19aad52f4$var$points[$616ae7a19aad52f4$var$i].length; $616ae7a19aad52f4$var$k++){
    $616ae7a19aad52f4$var$points[$616ae7a19aad52f4$var$i][$616ae7a19aad52f4$var$k][0] /= 10.5;
    $616ae7a19aad52f4$var$points[$616ae7a19aad52f4$var$i][$616ae7a19aad52f4$var$k][1] /= -14;
    $616ae7a19aad52f4$var$points[$616ae7a19aad52f4$var$i][$616ae7a19aad52f4$var$k][0] += $616ae7a19aad52f4$var$geoCoord[0];
    $616ae7a19aad52f4$var$points[$616ae7a19aad52f4$var$i][$616ae7a19aad52f4$var$k][1] += $616ae7a19aad52f4$var$geoCoord[1];
}
function $616ae7a19aad52f4$export$2e2bcd8739ae039(mapType, regions) {
    if (mapType === "china") {
        for(var i = 0; i < regions.length; i++){
            // Already exists.
            if (regions[i].name === $616ae7a19aad52f4$var$nanhaiName) return;
        }
        regions.push(new (0, $00e94d08c93517b6$export$ee84fcb463f24b3d)($616ae7a19aad52f4$var$nanhaiName, $7a1bd9c2710fea0d$export$871de8747c9eaa88($616ae7a19aad52f4$var$points, function(exterior) {
            return {
                type: "polygon",
                exterior: exterior
            };
        }), $616ae7a19aad52f4$var$geoCoord));
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $280c32529827bd03$var$coordsOffsetMap = {
    "\u5357\u6D77\u8BF8\u5C9B": [
        32,
        80
    ],
    // 全国
    "\u5E7F\u4E1C": [
        0,
        -10
    ],
    "\u9999\u6E2F": [
        10,
        5
    ],
    "\u6FB3\u95E8": [
        -10,
        10
    ],
    // '北京': [-10, 0],
    "\u5929\u6D25": [
        5,
        5
    ]
};
function $280c32529827bd03$export$2e2bcd8739ae039(mapType, region) {
    if (mapType === "china") {
        var coordFix = $280c32529827bd03$var$coordsOffsetMap[region.name];
        if (coordFix) {
            var cp = region.getCenter();
            cp[0] += coordFix[0] / 10.5;
            cp[1] += -coordFix[1] / 14;
            region.setCenter(cp);
        }
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Fix for 钓鱼岛
// let Region = require('../Region');
// let zrUtil = require('zrender/lib/core/util');
// let geoCoord = [126, 25];
var $5b04f3878acd754e$var$points = [
    [
        [
            123.45165252685547,
            25.73527164402261
        ],
        [
            123.49731445312499,
            25.73527164402261
        ],
        [
            123.49731445312499,
            25.750734064600884
        ],
        [
            123.45165252685547,
            25.750734064600884
        ],
        [
            123.45165252685547,
            25.73527164402261
        ]
    ]
];
function $5b04f3878acd754e$export$2e2bcd8739ae039(mapType, region) {
    if (mapType === "china" && region.name === "\u53F0\u6E7E") region.geometries.push({
        type: "polygon",
        exterior: $5b04f3878acd754e$var$points[0]
    });
}



var $ca9a35044b20ba4d$var$DEFAULT_NAME_PROPERTY = "name";
var $ca9a35044b20ba4d$export$859cf85c67f2df51 = /** @class */ function() {
    function GeoJSONResource(mapName, geoJSON, specialAreas) {
        this.type = "geoJSON";
        this._parsedMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        this._mapName = mapName;
        this._specialAreas = specialAreas;
        // PENDING: delay the parse to the first usage to rapid up the FMP?
        this._geoJSON = $ca9a35044b20ba4d$var$parseInput(geoJSON);
    }
    /**
   * @param nameMap can be null/undefined
   * @param nameProperty can be null/undefined
   */ GeoJSONResource.prototype.load = function(nameMap, nameProperty) {
        nameProperty = nameProperty || $ca9a35044b20ba4d$var$DEFAULT_NAME_PROPERTY;
        var parsed = this._parsedMap.get(nameProperty);
        if (!parsed) {
            var rawRegions = this._parseToRegions(nameProperty);
            parsed = this._parsedMap.set(nameProperty, {
                regions: rawRegions,
                boundingRect: $ca9a35044b20ba4d$var$calculateBoundingRect(rawRegions)
            });
        }
        var regionsMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        var finalRegions = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(parsed.regions, function(region) {
            var regionName = region.name;
            // Try use the alias in geoNameMap
            if (nameMap && (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(nameMap, regionName)) region = region.cloneShallow(regionName = nameMap[regionName]);
            finalRegions.push(region);
            regionsMap.set(regionName, region);
        });
        return {
            regions: finalRegions,
            boundingRect: parsed.boundingRect || new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0),
            regionsMap: regionsMap
        };
    };
    GeoJSONResource.prototype._parseToRegions = function(nameProperty) {
        var mapName = this._mapName;
        var geoJSON = this._geoJSON;
        var rawRegions;
        // https://jsperf.com/try-catch-performance-overhead
        try {
            rawRegions = geoJSON ? (0, $1a1de70a2b6a5dc5$export$2e2bcd8739ae039)(geoJSON, nameProperty) : [];
        } catch (e) {
            throw new Error("Invalid geoJson format\n" + e.message);
        }
        (0, $616ae7a19aad52f4$export$2e2bcd8739ae039)(mapName, rawRegions);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(rawRegions, function(region) {
            var regionName = region.name;
            (0, $280c32529827bd03$export$2e2bcd8739ae039)(mapName, region);
            (0, $5b04f3878acd754e$export$2e2bcd8739ae039)(mapName, region);
            // Some area like Alaska in USA map needs to be tansformed
            // to look better
            var specialArea = this._specialAreas && this._specialAreas[regionName];
            if (specialArea) region.transformTo(specialArea.left, specialArea.top, specialArea.width, specialArea.height);
        }, this);
        return rawRegions;
    };
    /**
   * Only for exporting to users.
   * **MUST NOT** used internally.
   */ GeoJSONResource.prototype.getMapForUser = function() {
        return {
            // For backward compatibility, use geoJson
            // PENDING: it has been returning them without clone.
            // do we need to avoid outsite modification?
            geoJson: this._geoJSON,
            geoJSON: this._geoJSON,
            specialAreas: this._specialAreas
        };
    };
    return GeoJSONResource;
}();
function $ca9a35044b20ba4d$var$calculateBoundingRect(regions) {
    var rect;
    for(var i = 0; i < regions.length; i++){
        var regionRect = regions[i].getBoundingRect();
        rect = rect || regionRect.clone();
        rect.union(regionRect);
    }
    return rect;
}
function $ca9a35044b20ba4d$var$parseInput(source) {
    return !(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(source) ? source : typeof JSON !== "undefined" && JSON.parse ? JSON.parse(source) : new Function("return (" + source + ");")();
}


var $09550a1229dcb4ad$var$storage = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
var $09550a1229dcb4ad$export$2e2bcd8739ae039 = {
    /**
   * Compatible with previous `echarts.registerMap`.
   *
   * @usage
   * ```js
   *
   * echarts.registerMap('USA', geoJson, specialAreas);
   *
   * echarts.registerMap('USA', {
   *     geoJson: geoJson,
   *     specialAreas: {...}
   * });
   * echarts.registerMap('USA', {
   *     geoJSON: geoJson,
   *     specialAreas: {...}
   * });
   *
   * echarts.registerMap('airport', {
   *     svg: svg
   * }
   * ```
   *
   * Note:
   * Do not support that register multiple geoJSON or SVG
   * one map name. Because different geoJSON and SVG have
   * different unit. It's not easy to make sure how those
   * units are mapping/normalize.
   * If intending to use multiple geoJSON or SVG, we can
   * use multiple geo coordinate system.
   */ registerMap: function(mapName, rawDef, rawSpecialAreas) {
        if (rawDef.svg) {
            var resource = new (0, $decc9bf1380d61c0$export$be52c950efae1f84)(mapName, rawDef.svg);
            $09550a1229dcb4ad$var$storage.set(mapName, resource);
        } else {
            // Recommend:
            //     echarts.registerMap('eu', { geoJSON: xxx, specialAreas: xxx });
            // Backward compatibility:
            //     echarts.registerMap('eu', geoJSON, specialAreas);
            //     echarts.registerMap('eu', { geoJson: xxx, specialAreas: xxx });
            var geoJSON = rawDef.geoJson || rawDef.geoJSON;
            if (geoJSON && !rawDef.features) rawSpecialAreas = rawDef.specialAreas;
            else geoJSON = rawDef;
            var resource = new (0, $ca9a35044b20ba4d$export$859cf85c67f2df51)(mapName, geoJSON, rawSpecialAreas);
            $09550a1229dcb4ad$var$storage.set(mapName, resource);
        }
    },
    getGeoResource: function(mapName) {
        return $09550a1229dcb4ad$var$storage.get(mapName);
    },
    /**
   * Only for exporting to users.
   * **MUST NOT** used internally.
   */ getMapForUser: function(mapName) {
        var resource = $09550a1229dcb4ad$var$storage.get(mapName);
        // Do not support return SVG until some real requirement come.
        return resource && resource.type === "geoJSON" && resource.getMapForUser();
    },
    load: function(mapName, nameMap, nameProperty) {
        var resource = $09550a1229dcb4ad$var$storage.get(mapName);
        if (!resource) return;
        return resource.load(nameMap, nameProperty);
    }
};








/**
 * Only these tags enable use `itemStyle` if they are named in SVG.
 * Other tags like <text> <tspan> <image> might not suitable for `itemStyle`.
 * They will not be considered to be styled until some requirements come.
 */ var $ad029c27e0f2a7ab$var$OPTION_STYLE_ENABLED_TAGS = [
    "rect",
    "circle",
    "line",
    "ellipse",
    "polygon",
    "polyline",
    "path"
];
var $ad029c27e0f2a7ab$var$OPTION_STYLE_ENABLED_TAG_MAP = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4($ad029c27e0f2a7ab$var$OPTION_STYLE_ENABLED_TAGS);
var $ad029c27e0f2a7ab$var$STATE_TRIGGER_TAG_MAP = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4($ad029c27e0f2a7ab$var$OPTION_STYLE_ENABLED_TAGS.concat([
    "g"
]));
var $ad029c27e0f2a7ab$var$LABEL_HOST_MAP = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4($ad029c27e0f2a7ab$var$OPTION_STYLE_ENABLED_TAGS.concat([
    "g"
]));
var $ad029c27e0f2a7ab$var$mapLabelRaw = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $ad029c27e0f2a7ab$var$getFixedItemStyle(model) {
    var itemStyle = model.getItemStyle();
    var areaColor = model.get("areaColor");
    // If user want the color not to be changed when hover,
    // they should both set areaColor and color to be null.
    if (areaColor != null) itemStyle.fill = areaColor;
    return itemStyle;
}
// Only stroke can be used for line.
// Using fill in style if stroke not exits.
// TODO Not sure yet. Perhaps a separate `lineStyle`?
function $ad029c27e0f2a7ab$var$fixLineStyle(styleHost) {
    var style = styleHost.style;
    if (style) {
        style.stroke = style.stroke || style.fill;
        style.fill = null;
    }
}
var $ad029c27e0f2a7ab$var$MapDraw = /** @class */ function() {
    function MapDraw(api) {
        var group = this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        var transformGroup = this._transformGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        group.add(transformGroup);
        this.uid = (0, $5370df662b2caf37$export$6d2b3473b0986646)("ec_map_draw");
        this._controller = new (0, $15927f329deeab51$export$2e2bcd8739ae039)(api.getZr());
        this._controllerHost = {
            target: transformGroup
        };
        transformGroup.add(this._regionsGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039());
        transformGroup.add(this._svgGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039());
    }
    MapDraw.prototype.draw = function(mapOrGeoModel, ecModel, api, fromView, payload) {
        var isGeo = mapOrGeoModel.mainType === "geo";
        // Map series has data. GEO model that controlled by map series
        // will be assigned with map data. Other GEO model has no data.
        var data = mapOrGeoModel.getData && mapOrGeoModel.getData();
        isGeo && ecModel.eachComponent({
            mainType: "series",
            subType: "map"
        }, function(mapSeries) {
            if (!data && mapSeries.getHostGeoModel() === mapOrGeoModel) data = mapSeries.getData();
        });
        var geo = mapOrGeoModel.coordinateSystem;
        var regionsGroup = this._regionsGroup;
        var transformGroup = this._transformGroup;
        var transformInfo = geo.getTransformInfo();
        var transformInfoRaw = transformInfo.raw;
        var transformInfoRoam = transformInfo.roam;
        // No animation when first draw or in action
        var isFirstDraw = !regionsGroup.childAt(0) || payload;
        var clip = mapOrGeoModel.getShallow("clip", true);
        var clipRect;
        if (clip) {
            clipRect = geo.getViewRect().clone();
            this.group.setClipPath(new $419e5ff2f303755e$export$2e2bcd8739ae039({
                shape: clipRect.clone()
            }));
        } else this.group.removeClipPath();
        if (isFirstDraw) {
            transformGroup.x = transformInfoRoam.x;
            transformGroup.y = transformInfoRoam.y;
            transformGroup.scaleX = transformInfoRoam.scaleX;
            transformGroup.scaleY = transformInfoRoam.scaleY;
            transformGroup.dirty();
        } else $8b353638fbedfefa$export$c8dce3c08436e91e(transformGroup, transformInfoRoam, mapOrGeoModel);
        var isVisualEncodedByVisualMap = data && data.getVisual("visualMeta") && data.getVisual("visualMeta").length > 0;
        var viewBuildCtx = {
            api: api,
            geo: geo,
            mapOrGeoModel: mapOrGeoModel,
            data: data,
            isVisualEncodedByVisualMap: isVisualEncodedByVisualMap,
            isGeo: isGeo,
            transformInfoRaw: transformInfoRaw
        };
        if (geo.resourceType === "geoJSON") this._buildGeoJSON(viewBuildCtx);
        else if (geo.resourceType === "geoSVG") this._buildSVG(viewBuildCtx);
        this._updateController(mapOrGeoModel, clipRect, ecModel, api);
        this._updateMapSelectHandler(mapOrGeoModel, regionsGroup, api, fromView);
    };
    MapDraw.prototype._buildGeoJSON = function(viewBuildCtx) {
        var regionsGroupByName = this._regionsGroupByName = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var regionsInfoByName = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var regionsGroup = this._regionsGroup;
        var transformInfoRaw = viewBuildCtx.transformInfoRaw;
        var mapOrGeoModel = viewBuildCtx.mapOrGeoModel;
        var data = viewBuildCtx.data;
        var projection = viewBuildCtx.geo.projection;
        var projectionStream = projection && projection.stream;
        function transformPoint(point, project) {
            if (project) // projection may return null point.
            point = project(point);
            return point && [
                point[0] * transformInfoRaw.scaleX + transformInfoRaw.x,
                point[1] * transformInfoRaw.scaleY + transformInfoRaw.y
            ];
        }
        function transformPolygonPoints(inPoints) {
            var outPoints = [];
            // If projectionStream is provided. Use it instead of single point project.
            var project = !projectionStream && projection && projection.project;
            for(var i = 0; i < inPoints.length; ++i){
                var newPt = transformPoint(inPoints[i], project);
                newPt && outPoints.push(newPt);
            }
            return outPoints;
        }
        function getPolyShape(points) {
            return {
                shape: {
                    points: transformPolygonPoints(points)
                }
            };
        }
        regionsGroup.removeAll();
        // Only when the resource is GeoJSON, there is `geo.regions`.
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(viewBuildCtx.geo.regions, function(region) {
            var regionName = region.name;
            // Consider in GeoJson properties.name may be duplicated, for example,
            // there is multiple region named "United Kindom" or "France" (so many
            // colonies). And it is not appropriate to merge them in geo, which
            // will make them share the same label and bring trouble in label
            // location calculation.
            var regionGroup = regionsGroupByName.get(regionName);
            var _a = regionsInfoByName.get(regionName) || {}, dataIdx = _a.dataIdx, regionModel = _a.regionModel;
            if (!regionGroup) {
                regionGroup = regionsGroupByName.set(regionName, new $7ef7583d8302ffce$export$2e2bcd8739ae039());
                regionsGroup.add(regionGroup);
                dataIdx = data ? data.indexOfName(regionName) : null;
                regionModel = viewBuildCtx.isGeo ? mapOrGeoModel.getRegionModel(regionName) : data ? data.getItemModel(dataIdx) : null;
                var silent = regionModel.get("silent", true);
                silent != null && (regionGroup.silent = silent);
                regionsInfoByName.set(regionName, {
                    dataIdx: dataIdx,
                    regionModel: regionModel
                });
            }
            var polygonSubpaths = [];
            var polylineSubpaths = [];
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(region.geometries, function(geometry) {
                // Polygon and MultiPolygon
                if (geometry.type === "polygon") {
                    var polys = [
                        geometry.exterior
                    ].concat(geometry.interiors || []);
                    if (projectionStream) polys = $ad029c27e0f2a7ab$var$projectPolys(polys, projectionStream);
                    $7a1bd9c2710fea0d$export$79b2f7037acddd43(polys, function(poly) {
                        polygonSubpaths.push(new $51acf033123e1a30$export$2e2bcd8739ae039(getPolyShape(poly)));
                    });
                } else {
                    var points = geometry.points;
                    if (projectionStream) points = $ad029c27e0f2a7ab$var$projectPolys(points, projectionStream, true);
                    $7a1bd9c2710fea0d$export$79b2f7037acddd43(points, function(points) {
                        polylineSubpaths.push(new $d28119f30e6bb670$export$2e2bcd8739ae039(getPolyShape(points)));
                    });
                }
            });
            var centerPt = transformPoint(region.getCenter(), projection && projection.project);
            function createCompoundPath(subpaths, isLine) {
                if (!subpaths.length) return;
                var compoundPath = new $e152f3dbf8fba6e2$export$2e2bcd8739ae039({
                    culling: true,
                    segmentIgnoreThreshold: 1,
                    shape: {
                        paths: subpaths
                    }
                });
                regionGroup.add(compoundPath);
                $ad029c27e0f2a7ab$var$applyOptionStyleForRegion(viewBuildCtx, compoundPath, dataIdx, regionModel);
                $ad029c27e0f2a7ab$var$resetLabelForRegion(viewBuildCtx, compoundPath, regionName, regionModel, mapOrGeoModel, dataIdx, centerPt);
                if (isLine) {
                    $ad029c27e0f2a7ab$var$fixLineStyle(compoundPath);
                    $7a1bd9c2710fea0d$export$79b2f7037acddd43(compoundPath.states, $ad029c27e0f2a7ab$var$fixLineStyle);
                }
            }
            createCompoundPath(polygonSubpaths);
            createCompoundPath(polylineSubpaths, true);
        });
        // Ensure children have been added to `regionGroup` before calling them.
        regionsGroupByName.each(function(regionGroup, regionName) {
            var _a = regionsInfoByName.get(regionName), dataIdx = _a.dataIdx, regionModel = _a.regionModel;
            $ad029c27e0f2a7ab$var$resetEventTriggerForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel, dataIdx);
            $ad029c27e0f2a7ab$var$resetTooltipForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel);
            $ad029c27e0f2a7ab$var$resetStateTriggerForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel);
        }, this);
    };
    MapDraw.prototype._buildSVG = function(viewBuildCtx) {
        var mapName = viewBuildCtx.geo.map;
        var transformInfoRaw = viewBuildCtx.transformInfoRaw;
        this._svgGroup.x = transformInfoRaw.x;
        this._svgGroup.y = transformInfoRaw.y;
        this._svgGroup.scaleX = transformInfoRaw.scaleX;
        this._svgGroup.scaleY = transformInfoRaw.scaleY;
        if (this._svgResourceChanged(mapName)) {
            this._freeSVG();
            this._useSVG(mapName);
        }
        var svgDispatcherMap = this._svgDispatcherMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var focusSelf = false;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._svgGraphicRecord.named, function(namedItem) {
            // Note that we also allow different elements have the same name.
            // For example, a glyph of a city and the label of the city have
            // the same name and their tooltip info can be defined in a single
            // region option.
            var regionName = namedItem.name;
            var mapOrGeoModel = viewBuildCtx.mapOrGeoModel;
            var data = viewBuildCtx.data;
            var svgNodeTagLower = namedItem.svgNodeTagLower;
            var el = namedItem.el;
            var dataIdx = data ? data.indexOfName(regionName) : null;
            var regionModel = mapOrGeoModel.getRegionModel(regionName);
            if ($ad029c27e0f2a7ab$var$OPTION_STYLE_ENABLED_TAG_MAP.get(svgNodeTagLower) != null && el instanceof (0, $56206a6cb4666931$export$2e2bcd8739ae039)) $ad029c27e0f2a7ab$var$applyOptionStyleForRegion(viewBuildCtx, el, dataIdx, regionModel);
            if (el instanceof (0, $56206a6cb4666931$export$2e2bcd8739ae039)) el.culling = true;
            var silent = regionModel.get("silent", true);
            silent != null && (el.silent = silent);
            // We do not know how the SVG like so we'd better not to change z2.
            // Otherwise it might bring some unexpected result. For example,
            // an area hovered that make some inner city can not be clicked.
            el.z2EmphasisLift = 0;
            // If self named:
            if (!namedItem.namedFrom) {
                // label should batter to be displayed based on the center of <g>
                // if it is named rather than displayed on each child.
                if ($ad029c27e0f2a7ab$var$LABEL_HOST_MAP.get(svgNodeTagLower) != null) $ad029c27e0f2a7ab$var$resetLabelForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, dataIdx, null);
                $ad029c27e0f2a7ab$var$resetEventTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, dataIdx);
                $ad029c27e0f2a7ab$var$resetTooltipForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel);
                if ($ad029c27e0f2a7ab$var$STATE_TRIGGER_TAG_MAP.get(svgNodeTagLower) != null) {
                    var focus_1 = $ad029c27e0f2a7ab$var$resetStateTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel);
                    if (focus_1 === "self") focusSelf = true;
                    var els = svgDispatcherMap.get(regionName) || svgDispatcherMap.set(regionName, []);
                    els.push(el);
                }
            }
        }, this);
        this._enableBlurEntireSVG(focusSelf, viewBuildCtx);
    };
    MapDraw.prototype._enableBlurEntireSVG = function(focusSelf, viewBuildCtx) {
        // It's a little complicated to support blurring the entire geoSVG in series-map.
        // So do not support it until some requirements come.
        // At present, in series-map, only regions can be blurred.
        if (focusSelf && viewBuildCtx.isGeo) {
            var blurStyle = viewBuildCtx.mapOrGeoModel.getModel([
                "blur",
                "itemStyle"
            ]).getItemStyle();
            // Only support `opacity` here. Because not sure that other props are suitable for
            // all of the elements generated by SVG (especially for Text/TSpan/Image/... ).
            var opacity_1 = blurStyle.opacity;
            this._svgGraphicRecord.root.traverse(function(el) {
                if (!el.isGroup) {
                    // PENDING: clear those settings to SVG elements when `_freeSVG`.
                    // (Currently it happen not to be needed.)
                    (0, $2bf82c0980125b62$export$20f39bbe322fb9ab)(el);
                    var style = el.ensureState("blur").style || {};
                    // Do not overwrite the region style that already set from region option.
                    if (style.opacity == null && opacity_1 != null) style.opacity = opacity_1;
                    // If `ensureState('blur').style = {}`, there will be default opacity.
                    // Enable `stateTransition` (animation).
                    el.ensureState("emphasis");
                }
            });
        }
    };
    MapDraw.prototype.remove = function() {
        this._regionsGroup.removeAll();
        this._regionsGroupByName = null;
        this._svgGroup.removeAll();
        this._freeSVG();
        this._controller.dispose();
        this._controllerHost = null;
    };
    MapDraw.prototype.findHighDownDispatchers = function(name, geoModel) {
        if (name == null) return [];
        var geo = geoModel.coordinateSystem;
        if (geo.resourceType === "geoJSON") {
            var regionsGroupByName = this._regionsGroupByName;
            if (regionsGroupByName) {
                var regionGroup = regionsGroupByName.get(name);
                return regionGroup ? [
                    regionGroup
                ] : [];
            }
        } else if (geo.resourceType === "geoSVG") return this._svgDispatcherMap && this._svgDispatcherMap.get(name) || [];
    };
    MapDraw.prototype._svgResourceChanged = function(mapName) {
        return this._svgMapName !== mapName;
    };
    MapDraw.prototype._useSVG = function(mapName) {
        var resource = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).getGeoResource(mapName);
        if (resource && resource.type === "geoSVG") {
            var svgGraphic = resource.useGraphic(this.uid);
            this._svgGroup.add(svgGraphic.root);
            this._svgGraphicRecord = svgGraphic;
            this._svgMapName = mapName;
        }
    };
    MapDraw.prototype._freeSVG = function() {
        var mapName = this._svgMapName;
        if (mapName == null) return;
        var resource = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).getGeoResource(mapName);
        if (resource && resource.type === "geoSVG") resource.freeGraphic(this.uid);
        this._svgGraphicRecord = null;
        this._svgDispatcherMap = null;
        this._svgGroup.removeAll();
        this._svgMapName = null;
    };
    MapDraw.prototype._updateController = function(mapOrGeoModel, clipRect, ecModel, api) {
        var geo = mapOrGeoModel.coordinateSystem;
        var controller = this._controller;
        var controllerHost = this._controllerHost;
        controllerHost.zoomLimit = mapOrGeoModel.get("scaleLimit");
        controllerHost.zoom = geo.getZoom();
        // roamType is will be set default true if it is null
        controller.enable(mapOrGeoModel.get("roam") || false, {
            api: api,
            zInfo: {
                component: mapOrGeoModel
            },
            triggerInfo: {
                roamTrigger: mapOrGeoModel.get("roamTrigger"),
                isInSelf: function(e, x, y) {
                    return geo.containPoint([
                        x,
                        y
                    ]);
                },
                isInClip: function(e, x, y) {
                    return !clipRect || clipRect.contain(x, y);
                }
            }
        });
        var mainType = mapOrGeoModel.mainType;
        function makeActionBase() {
            var action = {
                type: "geoRoam",
                componentType: mainType
            };
            action[mainType + "Id"] = mapOrGeoModel.id;
            return action;
        }
        controller.off("pan").on("pan", function(e) {
            this._mouseDownFlag = false;
            $35fd859fd545c4be$export$1e6abcd98caba733(controllerHost, e.dx, e.dy);
            api.dispatchAction($7a1bd9c2710fea0d$export$8b58be045bf06082(makeActionBase(), {
                dx: e.dx,
                dy: e.dy,
                animation: {
                    duration: 0
                }
            }));
        }, this);
        controller.off("zoom").on("zoom", function(e) {
            this._mouseDownFlag = false;
            $35fd859fd545c4be$export$29b3c66d30a4866(controllerHost, e.scale, e.originX, e.originY);
            api.dispatchAction($7a1bd9c2710fea0d$export$8b58be045bf06082(makeActionBase(), {
                totalZoom: controllerHost.zoom,
                zoom: e.scale,
                originX: e.originX,
                originY: e.originY,
                animation: {
                    duration: 0
                }
            }));
        }, this);
    };
    /**
   * FIXME: this is a temporarily workaround.
   * When `geoRoam` the elements need to be reset in `MapView['render']`, because the props like
   * `ignore` might have been modified by `LabelManager`, and `LabelManager#addLabelsOfSeries`
   * will subsequently cache `defaultAttr` like `ignore`. If do not do this reset, the modified
   * props will have no chance to be restored.
   * Note: This reset should be after `clearStates` in `renderSeries` because `useStates` in
   * `renderSeries` will cache the modified `ignore` to `el._normalState`.
   * TODO:
   * Use clone/immutable in `LabelManager`?
   */ MapDraw.prototype.resetForLabelLayout = function() {
        this.group.traverse(function(el) {
            var label = el.getTextContent();
            if (label) label.ignore = $ad029c27e0f2a7ab$var$mapLabelRaw(label).ignore;
        });
    };
    MapDraw.prototype._updateMapSelectHandler = function(mapOrGeoModel, regionsGroup, api, fromView) {
        var mapDraw = this;
        regionsGroup.off("mousedown");
        regionsGroup.off("click");
        // @ts-ignore FIXME:TS resolve type conflict
        if (mapOrGeoModel.get("selectedMode")) {
            regionsGroup.on("mousedown", function() {
                mapDraw._mouseDownFlag = true;
            });
            regionsGroup.on("click", function(e) {
                if (!mapDraw._mouseDownFlag) return;
                mapDraw._mouseDownFlag = false;
            });
        }
    };
    return MapDraw;
}();
function $ad029c27e0f2a7ab$var$applyOptionStyleForRegion(viewBuildCtx, el, dataIndex, regionModel) {
    // All of the path are using `itemStyle`, because
    // (1) Some SVG also use fill on polyline (The different between
    // polyline and polygon is "open" or "close" but not fill or not).
    // (2) For the common props like opacity, if some use itemStyle
    // and some use `lineStyle`, it might confuse users.
    // (3) Most SVG use <path>, where can not detect whether to draw a "line"
    // or a filled shape, so use `itemStyle` for <path>.
    var normalStyleModel = regionModel.getModel("itemStyle");
    var emphasisStyleModel = regionModel.getModel([
        "emphasis",
        "itemStyle"
    ]);
    var blurStyleModel = regionModel.getModel([
        "blur",
        "itemStyle"
    ]);
    var selectStyleModel = regionModel.getModel([
        "select",
        "itemStyle"
    ]);
    // NOTE: DON'T use 'style' in visual when drawing map.
    // This component is used for drawing underlying map for both geo component and map series.
    var normalStyle = $ad029c27e0f2a7ab$var$getFixedItemStyle(normalStyleModel);
    var emphasisStyle = $ad029c27e0f2a7ab$var$getFixedItemStyle(emphasisStyleModel);
    var selectStyle = $ad029c27e0f2a7ab$var$getFixedItemStyle(selectStyleModel);
    var blurStyle = $ad029c27e0f2a7ab$var$getFixedItemStyle(blurStyleModel);
    // Update the itemStyle if has data visual
    var data = viewBuildCtx.data;
    if (data) {
        // Only visual color of each item will be used. It can be encoded by visualMap
        // But visual color of series is used in symbol drawing
        // Visual color for each series is for the symbol draw
        var style = data.getItemVisual(dataIndex, "style");
        var decal = data.getItemVisual(dataIndex, "decal");
        if (viewBuildCtx.isVisualEncodedByVisualMap && style.fill) normalStyle.fill = style.fill;
        if (decal) normalStyle.decal = (0, $c6d646aacd243427$export$a3ba048e1a648972)(decal, viewBuildCtx.api);
    }
    // SVG text, tspan and image can be named but not supporeted
    // to be styled by region option yet.
    el.setStyle(normalStyle);
    el.style.strokeNoScale = true;
    el.ensureState("emphasis").style = emphasisStyle;
    el.ensureState("select").style = selectStyle;
    el.ensureState("blur").style = blurStyle;
    // Enable blur
    (0, $2bf82c0980125b62$export$20f39bbe322fb9ab)(el);
}
function $ad029c27e0f2a7ab$var$resetLabelForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, // Exist only if `viewBuildCtx.data` exists.
dataIdx, // If labelXY not provided, use `textConfig.position: 'inside'`
labelXY) {
    var data = viewBuildCtx.data;
    var isGeo = viewBuildCtx.isGeo;
    var isDataNaN = data && isNaN(data.get(data.mapDimension("value"), dataIdx));
    var itemLayout = data && data.getItemLayout(dataIdx);
    // In the following cases label will be drawn
    // 1. In map series and data value is NaN
    // 2. In geo component
    // 3. Region has no series legendIcon, which will be add a showLabel flag in mapSymbolLayout
    if (isGeo || isDataNaN || itemLayout && itemLayout.showLabel) {
        var query = !isGeo ? dataIdx : regionName;
        var labelFetcher = void 0;
        // Consider dataIdx not found.
        if (!data || dataIdx >= 0) labelFetcher = mapOrGeoModel;
        var specifiedTextOpt = labelXY ? {
            normal: {
                align: "center",
                verticalAlign: "middle"
            }
        } : null;
        // Caveat: must be called after `setDefaultStateProxy(el);` called.
        // because textContent will be assign with `el.stateProxy` inside.
        (0, $6800dfcb6e1e2a44$export$9a13992917966657)(el, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(regionModel), {
            labelFetcher: labelFetcher,
            labelDataIndex: query,
            defaultText: regionName
        }, specifiedTextOpt);
        var textEl = el.getTextContent();
        if (textEl) {
            $ad029c27e0f2a7ab$var$mapLabelRaw(textEl).ignore = textEl.ignore;
            if (el.textConfig && labelXY) {
                // Compute a relative offset based on the el bounding rect.
                var rect = el.getBoundingRect().clone();
                // Need to make sure the percent position base on the same rect in normal and
                // emphasis state. Otherwise if using boundingRect of el, but the emphasis state
                // has borderWidth (even 0.5px), the text position will be changed obviously
                // if the position is very big like ['1234%', '1345%'].
                el.textConfig.layoutRect = rect;
                el.textConfig.position = [
                    (labelXY[0] - rect.x) / rect.width * 100 + "%",
                    (labelXY[1] - rect.y) / rect.height * 100 + "%"
                ];
            }
        }
        // PENDING:
        // If labelLayout is enabled (test/label-layout.html), el.dataIndex should be specified.
        // But el.dataIndex is also used to determine whether user event should be triggered,
        // where el.seriesIndex or el.dataModel must be specified. At present for a single el
        // there is not case that "only label layout enabled but user event disabled", so here
        // we depends `resetEventTriggerForRegion` to do the job of setting `el.dataIndex`.
        el.disableLabelAnimation = true;
    } else {
        el.removeTextContent();
        el.removeTextConfig();
        el.disableLabelAnimation = null;
    }
}
function $ad029c27e0f2a7ab$var$resetEventTriggerForRegion(viewBuildCtx, eventTrigger, regionName, regionModel, mapOrGeoModel, // Exist only if `viewBuildCtx.data` exists.
dataIdx) {
    // setItemGraphicEl, setHoverStyle after all polygons and labels
    // are added to the regionGroup
    if (viewBuildCtx.data) // FIXME: when series-map use a SVG map, and there are duplicated name specified
    // on different SVG elements, after `data.setItemGraphicEl(...)`:
    // (1) all of them will be mounted with `dataIndex`, `seriesIndex`, so that tooltip
    // can be triggered only mouse hover. That's correct.
    // (2) only the last element will be kept in `data`, so that if trigger tooltip
    // by `dispatchAction`, only the last one can be found and triggered. That might be
    // not correct. We will fix it in future if anyone demanding that.
    viewBuildCtx.data.setItemGraphicEl(dataIdx, eventTrigger);
    else // Package custom mouse event for geo component
    (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(eventTrigger).eventData = {
        componentType: "geo",
        componentIndex: mapOrGeoModel.componentIndex,
        geoIndex: mapOrGeoModel.componentIndex,
        name: regionName,
        region: regionModel && regionModel.option || {}
    };
}
function $ad029c27e0f2a7ab$var$resetTooltipForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel) {
    if (!viewBuildCtx.data) $5b455ae6f843ac47$export$fc6410d97fab306c({
        el: el,
        componentModel: mapOrGeoModel,
        itemName: regionName,
        // @ts-ignore FIXME:TS fix the "compatible with each other"?
        itemTooltipOption: regionModel.get("tooltip")
    });
}
function $ad029c27e0f2a7ab$var$resetStateTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel) {
    // @ts-ignore FIXME:TS fix the "compatible with each other"?
    el.highDownSilentOnTouch = !!mapOrGeoModel.get("selectedMode");
    // @ts-ignore FIXME:TS fix the "compatible with each other"?
    var emphasisModel = regionModel.getModel("emphasis");
    var focus = emphasisModel.get("focus");
    (0, $2bf82c0980125b62$export$e51187539ff11209)(el, focus, emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
    if (viewBuildCtx.isGeo) (0, $2bf82c0980125b62$export$4da05a9639f01954)(el, mapOrGeoModel, regionName);
    return focus;
}
function $ad029c27e0f2a7ab$var$projectPolys(rings, // Polygons include exterior and interiors. Or polylines.
createStream, isLine) {
    var polygons = [];
    var curPoly;
    function startPolygon() {
        curPoly = [];
    }
    function endPolygon() {
        if (curPoly.length) {
            polygons.push(curPoly);
            curPoly = [];
        }
    }
    var stream = createStream({
        polygonStart: startPolygon,
        polygonEnd: endPolygon,
        lineStart: startPolygon,
        lineEnd: endPolygon,
        point: function(x, y) {
            // May have NaN values from stream.
            if (isFinite(x) && isFinite(y)) curPoly.push([
                x,
                y
            ]);
        },
        sphere: function() {}
    });
    !isLine && stream.polygonStart();
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(rings, function(ring) {
        stream.lineStart();
        for(var i = 0; i < ring.length; i++)stream.point(ring[i][0], ring[i][1]);
        stream.lineEnd();
    });
    !isLine && stream.polygonEnd();
    return polygons;
}
var $ad029c27e0f2a7ab$export$2e2bcd8739ae039 // @ts-ignore FIXME:TS fix the "compatible with each other"?
 = $ad029c27e0f2a7ab$var$MapDraw;





var $1c3add93106395a4$var$MapView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MapView, _super);
    function MapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MapView.type;
        return _this;
    }
    MapView.prototype.render = function(mapModel, ecModel, api, payload) {
        // Not render if it is an toggleSelect action from self
        if (payload && payload.type === "mapToggleSelect" && payload.from === this.uid) return;
        var group = this.group;
        group.removeAll();
        if (mapModel.getHostGeoModel()) return;
        if (this._mapDraw && payload && payload.type === "geoRoam") this._mapDraw.resetForLabelLayout();
        // Not update map if it is an roam action from self
        if (!(payload && payload.type === "geoRoam" && payload.componentType === "series" && payload.seriesId === mapModel.id)) {
            if (mapModel.needsDrawMap) {
                var mapDraw = this._mapDraw || new (0, $ad029c27e0f2a7ab$export$2e2bcd8739ae039)(api);
                group.add(mapDraw.group);
                mapDraw.draw(mapModel, ecModel, api, this, payload);
                this._mapDraw = mapDraw;
            } else {
                // Remove drawn map
                this._mapDraw && this._mapDraw.remove();
                this._mapDraw = null;
            }
        } else {
            var mapDraw = this._mapDraw;
            mapDraw && group.add(mapDraw.group);
        }
        mapModel.get("showLegendSymbol") && ecModel.getComponent("legend") && this._renderSymbols(mapModel, ecModel, api);
    };
    MapView.prototype.remove = function() {
        this._mapDraw && this._mapDraw.remove();
        this._mapDraw = null;
        this.group.removeAll();
    };
    MapView.prototype.dispose = function() {
        this._mapDraw && this._mapDraw.remove();
        this._mapDraw = null;
    };
    MapView.prototype._renderSymbols = function(mapModel, ecModel, api) {
        var originalData = mapModel.originalData;
        var group = this.group;
        originalData.each(originalData.mapDimension("value"), function(value, originalDataIndex) {
            if (isNaN(value)) return;
            var layout = originalData.getItemLayout(originalDataIndex);
            if (!layout || !layout.point) // Not exists in map
            return;
            var point = layout.point;
            var offset = layout.offset;
            var circle = new $1e68d8727773abb7$export$2e2bcd8739ae039({
                style: {
                    // Because the special of map draw.
                    // Which needs statistic of multiple series and draw on one map.
                    // And each series also need a symbol with legend color
                    //
                    // Layout and visual are put one the different data
                    // TODO
                    fill: mapModel.getData().getVisual("style").fill
                },
                shape: {
                    cx: point[0] + offset * 9,
                    cy: point[1],
                    r: 3
                },
                silent: true,
                // Do not overlap the first series, on which labels are displayed.
                z2: 8 + (!offset ? (0, $2bf82c0980125b62$export$1cb9fc6ed5b9836c) + 1 : 0)
            });
            // Only the series that has the first value on the same region is in charge of rendering the label.
            // But consider the case:
            // series: [
            //     {id: 'X', type: 'map', map: 'm', {data: [{name: 'A', value: 11}, {name: 'B', {value: 22}]},
            //     {id: 'Y', type: 'map', map: 'm', {data: [{name: 'A', value: 21}, {name: 'C', {value: 33}]}
            // ]
            // The offset `0` of item `A` is at series `X`, but of item `C` is at series `Y`.
            // For backward compatibility, we follow the rule that render label `A` by the
            // settings on series `X` but render label `C` by the settings on series `Y`.
            if (!offset) {
                var fullData = mapModel.mainSeries.getData();
                var name_1 = originalData.getName(originalDataIndex);
                var fullIndex_1 = fullData.indexOfName(name_1);
                var itemModel = originalData.getItemModel(originalDataIndex);
                var labelModel = itemModel.getModel("label");
                var regionGroup = fullData.getItemGraphicEl(fullIndex_1);
                // `getFormattedLabel` needs to use `getData` inside. Here
                // `mapModel.getData()` is shallow cloned from `mainSeries.getData()`.
                // FIXME
                // If this is not the `mainSeries`, the item model (like label formatter)
                // set on original data item will never get. But it has been working
                // like that from the beginning, and this scenario is rarely encountered.
                // So it won't be fixed until we have to.
                (0, $6800dfcb6e1e2a44$export$9a13992917966657)(circle, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
                    labelFetcher: {
                        getFormattedLabel: function(idx, state) {
                            return mapModel.getFormattedLabel(fullIndex_1, state);
                        }
                    },
                    defaultText: name_1
                });
                circle.disableLabelAnimation = true;
                if (!labelModel.get("position")) circle.setTextConfig({
                    position: "bottom"
                });
                regionGroup.onHoverStateChange = function(toState) {
                    (0, $2bf82c0980125b62$export$868ba38adffa9e39)(circle, toState);
                };
            }
            group.add(circle);
        });
    };
    MapView.type = "map";
    return MapView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $1c3add93106395a4$export$2e2bcd8739ae039 = $1c3add93106395a4$var$MapView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









var $f2f4aa5429e1d3d3$var$MapSeries = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MapSeries, _super);
    function MapSeries() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MapSeries.type;
        // Only first map series of same mapType will drawMap.
        _this.needsDrawMap = false;
        // Group of all map series with same mapType
        _this.seriesGroup = [];
        _this.getTooltipPosition = function(dataIndex) {
            if (dataIndex != null) {
                var name_1 = this.getData().getName(dataIndex);
                var geo = this.coordinateSystem;
                var region = geo.getRegion(name_1);
                return region && geo.dataToPoint(region.getCenter());
            }
        };
        return _this;
    }
    MapSeries.prototype.getInitialData = function(option) {
        var data = (0, $7e5c3511527c9907$export$2e2bcd8739ae039)(this, {
            coordDimensions: [
                "value"
            ],
            encodeDefaulter: $7a1bd9c2710fea0d$export$c3095a23b368d1f2((0, $7dc6cdfd7450ef29$export$60b8a57d1f2fed26), this)
        });
        var dataNameIndexMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var toAppendItems = [];
        for(var i = 0, len = data.count(); i < len; i++){
            var name_2 = data.getName(i);
            dataNameIndexMap.set(name_2, i);
        }
        var geoSource = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).load(this.getMapType(), this.option.nameMap, this.option.nameProperty);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(geoSource.regions, function(region) {
            var name = region.name;
            var dataNameIdx = dataNameIndexMap.get(name);
            // apply specified echarts style in GeoJSON data
            var specifiedGeoJSONRegionStyle = region.properties && region.properties.echartsStyle;
            var dataItem;
            if (dataNameIdx == null) {
                dataItem = {
                    name: name
                };
                toAppendItems.push(dataItem);
            } else dataItem = data.getRawDataItem(dataNameIdx);
            specifiedGeoJSONRegionStyle && $7a1bd9c2710fea0d$export$4950aa0f605343fb(dataItem, specifiedGeoJSONRegionStyle);
        });
        // Complete data with missing regions. The consequent processes (like visual
        // map and render) can not be performed without a "full data". For example,
        // find `dataIndex` by name.
        data.appendData(toAppendItems);
        return data;
    };
    /**
   * If no host geo model, return null, which means using a
   * inner exclusive geo model.
   */ MapSeries.prototype.getHostGeoModel = function() {
        if ((0, $70c3ede7d3b64757$export$29cb72d70b6b3a71)(this).kind === (0, $70c3ede7d3b64757$export$20673ff3ebf85e08).boxCoordSys) // Always use an internal geo if specify a boxCoordSys.
        // Notice that currently we do not support laying out a geo based on
        // another geo, but preserve the possibility.
        return;
        return this.getReferringComponents("geo", {
            useDefault: false,
            enableAll: false,
            enableNone: false
        }).models[0];
    };
    MapSeries.prototype.getMapType = function() {
        return (this.getHostGeoModel() || this).option.map;
    };
    // _fillOption(option, mapName) {
    // Shallow clone
    // option = zrUtil.extend({}, option);
    // option.data = geoCreator.getFilledRegions(option.data, mapName, option.nameMap);
    // return option;
    // }
    MapSeries.prototype.getRawValue = function(dataIndex) {
        // Use value stored in data instead because it is calculated from multiple series
        // FIXME Provide all value of multiple series ?
        var data = this.getData();
        return data.get(data.mapDimension("value"), dataIndex);
    };
    /**
   * Get model of region
   */ MapSeries.prototype.getRegionModel = function(regionName) {
        var data = this.getData();
        return data.getItemModel(data.indexOfName(regionName));
    };
    /**
   * Map tooltip formatter
   */ MapSeries.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        // FIXME orignalData and data is a bit confusing
        var data = this.getData();
        var value = this.getRawValue(dataIndex);
        var name = data.getName(dataIndex);
        var seriesGroup = this.seriesGroup;
        var seriesNames = [];
        for(var i = 0; i < seriesGroup.length; i++){
            var otherIndex = seriesGroup[i].originalData.indexOfName(name);
            var valueDim = data.mapDimension("value");
            if (!isNaN(seriesGroup[i].originalData.get(valueDim, otherIndex))) seriesNames.push(seriesGroup[i].name);
        }
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("section", {
            header: seriesNames.join(", "),
            noHeader: !seriesNames.length,
            blocks: [
                (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
                    name: name,
                    value: value
                })
            ]
        });
    };
    MapSeries.prototype.setZoom = function(zoom) {
        this.option.zoom = zoom;
    };
    MapSeries.prototype.setCenter = function(center) {
        this.option.center = center;
    };
    MapSeries.prototype.getLegendIcon = function(opt) {
        var iconType = opt.icon || "roundRect";
        var icon = (0, $5370466dadc978d7$export$af050e04da3a02e8)(iconType, 0, 0, opt.itemWidth, opt.itemHeight, opt.itemStyle.fill);
        icon.setStyle(opt.itemStyle);
        // Map do not use itemStyle.borderWidth as border width
        icon.style.stroke = "none";
        // No rotation because no series visual symbol for map
        if (iconType.indexOf("empty") > -1) {
            icon.style.stroke = icon.style.fill;
            icon.style.fill = (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral00;
            icon.style.lineWidth = 2;
        }
        return icon;
    };
    MapSeries.type = "series.map";
    MapSeries.dependencies = [
        "geo"
    ];
    MapSeries.layoutMode = "box";
    MapSeries.defaultOption = {
        // 一级层叠
        // zlevel: 0,
        // 二级层叠
        z: 2,
        coordinateSystem: "geo",
        // map should be explicitly specified since ec3.
        map: "",
        // If `geoIndex` is not specified, a exclusive geo will be
        // created. Otherwise use the specified geo component, and
        // `map` and `mapType` are ignored.
        // geoIndex: 0,
        // 'center' | 'left' | 'right' | 'x%' | {number}
        left: "center",
        // 'center' | 'top' | 'bottom' | 'x%' | {number}
        top: "center",
        // right
        // bottom
        // width:
        // height
        // Aspect is width / height. Inited to be geoJson bbox aspect
        // This parameter is used for scale this aspect
        // Default value:
        // for geoSVG source: 1,
        // for geoJSON source: 0.75.
        aspectScale: null,
        // Layout with center and size
        // If you want to put map in a fixed size box with right aspect ratio
        // This two properties may be more convenient.
        // layoutCenter: [50%, 50%]
        // layoutSize: 100
        showLegendSymbol: true,
        // Define left-top, right-bottom coords to control view
        // For example, [ [180, 90], [-180, -90] ],
        // higher priority than center and zoom
        boundingCoords: null,
        // Default on center of map
        center: null,
        zoom: 1,
        scaleLimit: null,
        selectedMode: true,
        label: {
            show: false,
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.tertiary
        },
        // scaleLimit: null,
        itemStyle: {
            borderWidth: 0.5,
            borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.border,
            areaColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.background
        },
        emphasis: {
            label: {
                show: true,
                color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.primary
            },
            itemStyle: {
                areaColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.highlight
            }
        },
        select: {
            label: {
                show: true,
                color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.primary
            },
            itemStyle: {
                color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.highlight
            }
        },
        nameProperty: "name"
    };
    return MapSeries;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $f2f4aa5429e1d3d3$export$2e2bcd8739ae039 = $f2f4aa5429e1d3d3$var$MapSeries;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
// FIXME 公用？
function $5e3d42588445ae72$var$dataStatistics(datas, statisticType) {
    var dataNameMap = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(datas, function(data) {
        data.each(data.mapDimension("value"), function(value, idx) {
            // Add prefix to avoid conflict with Object.prototype.
            var mapKey = "ec-" + data.getName(idx);
            dataNameMap[mapKey] = dataNameMap[mapKey] || [];
            if (!isNaN(value)) dataNameMap[mapKey].push(value);
        });
    });
    return datas[0].map(datas[0].mapDimension("value"), function(value, idx) {
        var mapKey = "ec-" + datas[0].getName(idx);
        var sum = 0;
        var min = Infinity;
        var max = -Infinity;
        var len = dataNameMap[mapKey].length;
        for(var i = 0; i < len; i++){
            min = Math.min(min, dataNameMap[mapKey][i]);
            max = Math.max(max, dataNameMap[mapKey][i]);
            sum += dataNameMap[mapKey][i];
        }
        var result;
        if (statisticType === "min") result = min;
        else if (statisticType === "max") result = max;
        else if (statisticType === "average") result = sum / len;
        else result = sum;
        return len === 0 ? NaN : result;
    });
}
function $5e3d42588445ae72$export$2e2bcd8739ae039(ecModel) {
    var seriesGroups = {};
    ecModel.eachSeriesByType("map", function(seriesModel) {
        var hostGeoModel = seriesModel.getHostGeoModel();
        var key = hostGeoModel ? "o" + hostGeoModel.id : "i" + seriesModel.getMapType();
        (seriesGroups[key] = seriesGroups[key] || []).push(seriesModel);
    });
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(seriesGroups, function(seriesList, key) {
        var data = $5e3d42588445ae72$var$dataStatistics($7a1bd9c2710fea0d$export$871de8747c9eaa88(seriesList, function(seriesModel) {
            return seriesModel.getData();
        }), seriesList[0].get("mapValueCalculation"));
        for(var i = 0; i < seriesList.length; i++)seriesList[i].originalData = seriesList[i].getData();
        // FIXME Put where?
        for(var i = 0; i < seriesList.length; i++){
            seriesList[i].seriesGroup = seriesList;
            seriesList[i].needsDrawMap = i === 0 && !seriesList[i].getHostGeoModel();
            seriesList[i].setData(data.cloneShallow());
            seriesList[i].mainSeries = seriesList[0];
        }
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $53e61890435fb2d8$export$2e2bcd8739ae039(ecModel) {
    var processedMapType = {};
    ecModel.eachSeriesByType("map", function(mapSeries) {
        var mapType = mapSeries.getMapType();
        if (mapSeries.getHostGeoModel() || processedMapType[mapType]) return;
        var mapSymbolOffsets = {};
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(mapSeries.seriesGroup, function(subMapSeries) {
            var geo = subMapSeries.coordinateSystem;
            var data = subMapSeries.originalData;
            if (subMapSeries.get("showLegendSymbol") && ecModel.getComponent("legend")) data.each(data.mapDimension("value"), function(value, idx) {
                var name = data.getName(idx);
                var region = geo.getRegion(name);
                // If input series.data is [11, 22, '-'/null/undefined, 44],
                // it will be filled with NaN: [11, 22, NaN, 44] and NaN will
                // not be drawn. So here must validate if value is NaN.
                if (!region || isNaN(value)) return;
                var offset = mapSymbolOffsets[name] || 0;
                var point = geo.dataToPoint(region.getCenter());
                mapSymbolOffsets[name] = offset + 1;
                data.setItemLayout(idx, {
                    point: point,
                    offset: offset
                });
            });
        });
        // Show label of those region not has legendIcon (which is offset 0)
        var data = mapSeries.getData();
        data.each(function(idx) {
            var name = data.getName(idx);
            var layout = data.getItemLayout(idx) || {};
            layout.showLabel = !mapSymbolOffsets[name];
            data.setItemLayout(idx, layout);
        });
        processedMapType[mapType] = true;
    });
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $e67116e61e57a131$var$GEO_DEFAULT_PARAMS = {
    "geoJSON": {
        aspectScale: 0.75,
        invertLongitute: true
    },
    "geoSVG": {
        aspectScale: 1,
        invertLongitute: false
    }
};
var $e67116e61e57a131$export$10dbc57975912e0f = [
    "lng",
    "lat"
];
var $e67116e61e57a131$var$Geo = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(Geo, _super);
    function Geo(name, map, opt) {
        var _this = _super.call(this, name, {
            api: opt.api,
            ecModel: opt.ecModel
        }) || this;
        _this.dimensions = $e67116e61e57a131$export$10dbc57975912e0f;
        _this.type = "geo";
        // Only store specified name coord via `addGeoCoord`.
        _this._nameCoordMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        _this.map = map;
        var projection = opt.projection;
        var source = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).load(map, opt.nameMap, opt.nameProperty);
        var resource = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).getGeoResource(map);
        var resourceType = _this.resourceType = resource ? resource.type : null;
        var regions = _this.regions = source.regions;
        var defaultParams = $e67116e61e57a131$var$GEO_DEFAULT_PARAMS[resource.type];
        _this._regionsMap = source.regionsMap;
        _this.regions = source.regions;
        _this.projection = projection;
        var boundingRect;
        if (projection) // Can't reuse the raw bounding rect
        for(var i = 0; i < regions.length; i++){
            var regionRect = regions[i].getBoundingRect(projection);
            boundingRect = boundingRect || regionRect.clone();
            boundingRect.union(regionRect);
        }
        else boundingRect = source.boundingRect;
        _this.setBoundingRect(boundingRect.x, boundingRect.y, boundingRect.width, boundingRect.height);
        // aspectScale and invertLongitute actually is the parameters default raw projection.
        // So we ignore them if projection is given.
        // Ignore default aspect scale if projection exits.
        _this.aspectScale = projection ? 1 : $7a1bd9c2710fea0d$export$995e01f2f5c9d030(opt.aspectScale, defaultParams.aspectScale);
        // Not invert longitude if projection exits.
        _this._invertLongitute = projection ? false : defaultParams.invertLongitute;
        return _this;
    }
    Geo.prototype._transformTo = function(x, y, width, height) {
        var rect = this.getBoundingRect();
        var invertLongitute = this._invertLongitute;
        rect = rect.clone();
        if (invertLongitute) // Longitude is inverted.
        rect.y = -rect.y - rect.height;
        var rawTransformable = this._rawTransformable;
        rawTransformable.transform = rect.calculateTransform(new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height));
        var rawParent = rawTransformable.parent;
        rawTransformable.parent = null;
        rawTransformable.decomposeTransform();
        rawTransformable.parent = rawParent;
        if (invertLongitute) rawTransformable.scaleY = -rawTransformable.scaleY;
        this._updateTransform();
    };
    Geo.prototype.getRegion = function(name) {
        return this._regionsMap.get(name);
    };
    Geo.prototype.getRegionByCoord = function(coord) {
        var regions = this.regions;
        for(var i = 0; i < regions.length; i++){
            var region = regions[i];
            if (region.type === "geoJSON" && region.contain(coord)) return regions[i];
        }
    };
    /**
   * Add geoCoord for indexing by name
   */ Geo.prototype.addGeoCoord = function(name, geoCoord) {
        this._nameCoordMap.set(name, geoCoord);
    };
    /**
   * Get geoCoord by name
   */ Geo.prototype.getGeoCoord = function(name) {
        var region = this._regionsMap.get(name);
        // Calculate center only on demand.
        return this._nameCoordMap.get(name) || region && region.getCenter();
    };
    Geo.prototype.dataToPoint = function(data, noRoam, out) {
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(data)) // Map area name to geoCoord
        data = this.getGeoCoord(data);
        if (data) {
            var projection = this.projection;
            if (projection) // projection may return null point.
            data = projection.project(data);
            return data && this.projectedToPoint(data, noRoam, out);
        }
    };
    Geo.prototype.pointToData = function(point, reserved, out) {
        var projection = this.projection;
        if (projection) // projection may return null point.
        point = projection.unproject(point);
        // FIXME: if no `point`, should return [NaN, NaN], rather than undefined.
        //  null/undefined has special meaning in `convertFromPixel`.
        return point && this.pointToProjected(point, out);
    };
    /**
   * Point to projected data. Same with pointToData when projection is used.
   */ Geo.prototype.pointToProjected = function(point, out) {
        return _super.prototype.pointToData.call(this, point, 0, out);
    };
    Geo.prototype.projectedToPoint = function(projected, noRoam, out) {
        return _super.prototype.dataToPoint.call(this, projected, noRoam, out);
    };
    Geo.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $e67116e61e57a131$var$getCoordSys(finder);
        return coordSys === this ? coordSys.dataToPoint(value) : null;
    };
    Geo.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $e67116e61e57a131$var$getCoordSys(finder);
        return coordSys === this ? coordSys.pointToData(pixel) : null;
    };
    return Geo;
}((0, $4a92e7570d47c1fe$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($e67116e61e57a131$var$Geo, (0, $4a92e7570d47c1fe$export$2e2bcd8739ae039));
function $e67116e61e57a131$var$getCoordSys(finder) {
    var geoModel = finder.geoModel;
    var seriesModel = finder.seriesModel;
    return geoModel ? geoModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem // For map series.
     || (seriesModel.getReferringComponents("geo", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0] || {}).coordinateSystem : null;
}
var $e67116e61e57a131$export$2e2bcd8739ae039 = $e67116e61e57a131$var$Geo;








/**
 * Resize method bound to the geo
 */ function $303164fe3ecc2dc5$var$resizeGeo(geoModel, api) {
    var boundingCoords = geoModel.get("boundingCoords");
    if (boundingCoords != null) {
        var leftTop_1 = boundingCoords[0];
        var rightBottom_1 = boundingCoords[1];
        if (!(isFinite(leftTop_1[0]) && isFinite(leftTop_1[1]) && isFinite(rightBottom_1[0]) && isFinite(rightBottom_1[1]))) ;
        else {
            // Sample around the lng/lat rect and use projection to calculate actual bounding rect.
            var projection_1 = this.projection;
            if (projection_1) {
                var xMin = leftTop_1[0];
                var yMin = leftTop_1[1];
                var xMax = rightBottom_1[0];
                var yMax = rightBottom_1[1];
                leftTop_1 = [
                    Infinity,
                    Infinity
                ];
                rightBottom_1 = [
                    -Infinity,
                    -Infinity
                ];
                // TODO better way?
                var sampleLine = function(x0, y0, x1, y1) {
                    var dx = x1 - x0;
                    var dy = y1 - y0;
                    for(var i = 0; i <= 100; i++){
                        var p = i / 100;
                        var pt = projection_1.project([
                            x0 + dx * p,
                            y0 + dy * p
                        ]);
                        $6de594cf8ac295ff$export$96ec731ed4dcb222(leftTop_1, leftTop_1, pt);
                        $6de594cf8ac295ff$export$8960430cfd85939f(rightBottom_1, rightBottom_1, pt);
                    }
                };
                // Top
                sampleLine(xMin, yMin, xMax, yMin);
                // Right
                sampleLine(xMax, yMin, xMax, yMax);
                // Bottom
                sampleLine(xMax, yMax, xMin, yMax);
                // Left
                sampleLine(xMin, yMax, xMax, yMin);
            }
            this.setBoundingRect(leftTop_1[0], leftTop_1[1], rightBottom_1[0] - leftTop_1[0], rightBottom_1[1] - leftTop_1[1]);
        }
    }
    var rect = this.getBoundingRect();
    var centerOption = geoModel.get("layoutCenter");
    var sizeOption = geoModel.get("layoutSize");
    // Laying out geo on `dataCoordSys`, such as cartesian, works theoretically but not supported yet.
    // Therefore here we only handle cases that laying out on `boxCoordSys`, such as matrix/calendar.
    var refContainer = $93b9bc7f22ac7369$export$5aec1e94f566e59f(geoModel, api).refContainer;
    var aspect = rect.width / rect.height * this.aspectScale;
    var useCenterAndSize = false;
    var center;
    var size;
    if (centerOption && sizeOption) {
        center = [
            $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(centerOption[0], refContainer.width) + refContainer.x,
            $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(centerOption[1], refContainer.height) + refContainer.y
        ];
        size = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(sizeOption, Math.min(refContainer.width, refContainer.height));
        if (!isNaN(center[0]) && !isNaN(center[1]) && !isNaN(size)) useCenterAndSize = true;
    }
    var viewRect;
    if (useCenterAndSize) {
        viewRect = {};
        if (aspect > 1) {
            // Width is same with size
            viewRect.width = size;
            viewRect.height = size / aspect;
        } else {
            viewRect.height = size;
            viewRect.width = size * aspect;
        }
        viewRect.y = center[1] - viewRect.height / 2;
        viewRect.x = center[0] - viewRect.width / 2;
    } else {
        // Use left/top/width/height
        var boxLayoutOption = geoModel.getBoxLayoutParams();
        boxLayoutOption.aspect = aspect;
        viewRect = $93b9bc7f22ac7369$export$4517a5ca639a7293(boxLayoutOption, refContainer);
        viewRect = $93b9bc7f22ac7369$export$9fec79e40d579ea7(geoModel, viewRect, aspect);
    }
    this.setViewRect(viewRect.x, viewRect.y, viewRect.width, viewRect.height);
    this.setCenter(geoModel.get("center"));
    this.setZoom(geoModel.get("zoom"));
}
// Back compat for ECharts2, where the coord map is set on map series:
// {type: 'map', geoCoord: {'cityA': [116.46,39.92], 'cityA': [119.12,24.61]}},
function $303164fe3ecc2dc5$var$setGeoCoords(geo, model) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(model.get("geoCoord"), function(geoCoord, name) {
        geo.addGeoCoord(name, geoCoord);
    });
}
var $303164fe3ecc2dc5$var$GeoCreator = /** @class */ function() {
    function GeoCreator() {
        // For deciding which dimensions to use when creating list data
        this.dimensions = (0, $e67116e61e57a131$export$10dbc57975912e0f);
    }
    GeoCreator.prototype.create = function(ecModel, api) {
        var geoList = [];
        function getCommonGeoProperties(model) {
            return {
                nameProperty: model.get("nameProperty"),
                aspectScale: model.get("aspectScale"),
                projection: model.get("projection")
            };
        }
        // FIXME Create each time may be slow
        ecModel.eachComponent("geo", function(geoModel, idx) {
            var mapName = geoModel.get("map");
            var geo = new (0, $e67116e61e57a131$export$2e2bcd8739ae039)(mapName + idx, mapName, $7a1bd9c2710fea0d$export$8b58be045bf06082({
                nameMap: geoModel.get("nameMap"),
                api: api,
                ecModel: ecModel
            }, getCommonGeoProperties(geoModel)));
            geo.zoomLimit = geoModel.get("scaleLimit");
            geoList.push(geo);
            // setGeoCoords(geo, geoModel);
            geoModel.coordinateSystem = geo;
            geo.model = geoModel;
            // Inject resize method
            geo.resize = $303164fe3ecc2dc5$var$resizeGeo;
            geo.resize(geoModel, api);
        });
        ecModel.eachSeries(function(seriesModel) {
            (0, $70c3ede7d3b64757$export$7ed0c09d4f5c932e)({
                targetModel: seriesModel,
                coordSysType: "geo",
                coordSysProvider: function() {
                    var geoModel = seriesModel.subType === "map" ? seriesModel.getHostGeoModel() : seriesModel.getReferringComponents("geo", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
                    return geoModel && geoModel.coordinateSystem;
                },
                allowNotFound: true
            });
        });
        // If has map series
        var mapModelGroupBySeries = {};
        ecModel.eachSeriesByType("map", function(seriesModel) {
            if (!seriesModel.getHostGeoModel()) {
                var mapType = seriesModel.getMapType();
                mapModelGroupBySeries[mapType] = mapModelGroupBySeries[mapType] || [];
                mapModelGroupBySeries[mapType].push(seriesModel);
            }
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(mapModelGroupBySeries, function(mapSeries, mapType) {
            var nameMapList = $7a1bd9c2710fea0d$export$871de8747c9eaa88(mapSeries, function(singleMapSeries) {
                return singleMapSeries.get("nameMap");
            });
            var geo = new (0, $e67116e61e57a131$export$2e2bcd8739ae039)(mapType, mapType, $7a1bd9c2710fea0d$export$8b58be045bf06082({
                nameMap: $7a1bd9c2710fea0d$export$18aef43295bbe906(nameMapList),
                api: api,
                ecModel: ecModel
            }, getCommonGeoProperties(mapSeries[0])));
            geo.zoomLimit = $7a1bd9c2710fea0d$export$8a4d17b6e8486e66.apply(null, $7a1bd9c2710fea0d$export$871de8747c9eaa88(mapSeries, function(singleMapSeries) {
                return singleMapSeries.get("scaleLimit");
            }));
            geoList.push(geo);
            // Inject resize method
            geo.resize = $303164fe3ecc2dc5$var$resizeGeo;
            geo.resize(mapSeries[0], api);
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(mapSeries, function(singleMapSeries) {
                singleMapSeries.coordinateSystem = geo;
                $303164fe3ecc2dc5$var$setGeoCoords(geo, singleMapSeries);
            });
        });
        return geoList;
    };
    /**
   * Fill given regions array
   */ GeoCreator.prototype.getFilledRegions = function(originRegionArr, mapName, nameMap, nameProperty) {
        // Not use the original
        var regionsArr = (originRegionArr || []).slice();
        var dataNameMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        for(var i = 0; i < regionsArr.length; i++)dataNameMap.set(regionsArr[i].name, regionsArr[i]);
        var source = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).load(mapName, nameMap, nameProperty);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(source.regions, function(region) {
            var name = region.name;
            var regionOption = dataNameMap.get(name);
            // apply specified echarts style in GeoJSON data
            var specifiedGeoJSONRegionStyle = region.properties && region.properties.echartsStyle;
            if (!regionOption) {
                regionOption = {
                    name: name
                };
                regionsArr.push(regionOption);
            }
            specifiedGeoJSONRegionStyle && $7a1bd9c2710fea0d$export$4950aa0f605343fb(regionOption, specifiedGeoJSONRegionStyle);
        });
        return regionsArr;
    };
    return GeoCreator;
}();
var $303164fe3ecc2dc5$var$geoCreator = new $303164fe3ecc2dc5$var$GeoCreator();
var $303164fe3ecc2dc5$export$2e2bcd8739ae039 = $303164fe3ecc2dc5$var$geoCreator;




var $4ff027656cc71ef0$var$GeoModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GeoModel, _super);
    function GeoModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GeoModel.type;
        return _this;
    }
    GeoModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        var source = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).getGeoResource(option.map);
        if (source && source.type === "geoJSON") {
            var itemStyle = option.itemStyle = option.itemStyle || {};
            if (!("color" in itemStyle)) itemStyle.color = option.defaultItemStyleColor || (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.backgroundTint;
        }
        // Default label emphasis `show`
        $76d619f648247e6d$export$abdcc6a26372f94b(option, "label", [
            "show"
        ]);
    };
    GeoModel.prototype.optionUpdated = function() {
        var _this = this;
        var option = this.option;
        option.regions = (0, $303164fe3ecc2dc5$export$2e2bcd8739ae039).getFilledRegions(option.regions, option.map, option.nameMap, option.nameProperty);
        var selectedMap = {};
        this._optionModelMap = $7a1bd9c2710fea0d$export$533b26079ad0b4b(option.regions || [], function(optionModelMap, regionOpt) {
            var regionName = regionOpt.name;
            if (regionName) {
                optionModelMap.set(regionName, new (0, $6818646a97528290$export$2e2bcd8739ae039)(regionOpt, _this, _this.ecModel));
                if (regionOpt.selected) selectedMap[regionName] = true;
            }
            return optionModelMap;
        }, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4());
        if (!option.selectedMap) option.selectedMap = selectedMap;
    };
    /**
   * Get model of region.
   */ GeoModel.prototype.getRegionModel = function(name) {
        return this._optionModelMap.get(name) || new (0, $6818646a97528290$export$2e2bcd8739ae039)(null, this, this.ecModel);
    };
    /**
   * Format label
   * @param name Region name
   */ GeoModel.prototype.getFormattedLabel = function(name, status) {
        var regionModel = this.getRegionModel(name);
        var formatter = status === "normal" ? regionModel.get([
            "label",
            "formatter"
        ]) : regionModel.get([
            "emphasis",
            "label",
            "formatter"
        ]);
        var params = {
            name: name
        };
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(formatter)) {
            params.status = status;
            return formatter(params);
        } else if ($7a1bd9c2710fea0d$export$844ec244b1367d54(formatter)) return formatter.replace("{a}", name != null ? name : "");
    };
    GeoModel.prototype.setZoom = function(zoom) {
        this.option.zoom = zoom;
    };
    GeoModel.prototype.setCenter = function(center) {
        this.option.center = center;
    };
    // PENGING If selectedMode is null ?
    GeoModel.prototype.select = function(name) {
        var option = this.option;
        var selectedMode = option.selectedMode;
        if (!selectedMode) return;
        if (selectedMode !== "multiple") option.selectedMap = null;
        var selectedMap = option.selectedMap || (option.selectedMap = {});
        selectedMap[name] = true;
    };
    GeoModel.prototype.unSelect = function(name) {
        var selectedMap = this.option.selectedMap;
        if (selectedMap) selectedMap[name] = false;
    };
    GeoModel.prototype.toggleSelected = function(name) {
        this[this.isSelected(name) ? "unSelect" : "select"](name);
    };
    GeoModel.prototype.isSelected = function(name) {
        var selectedMap = this.option.selectedMap;
        return !!(selectedMap && selectedMap[name]);
    };
    GeoModel.type = "geo";
    GeoModel.layoutMode = "box";
    GeoModel.defaultOption = {
        // zlevel: 0,
        z: 0,
        show: true,
        left: "center",
        top: "center",
        // Default value:
        // for geoSVG source: 1,
        // for geoJSON source: 0.75.
        aspectScale: null,
        // /// Layout with center and size
        // If you want to put map in a fixed size box with right aspect ratio
        // This two properties may be more convenient
        // layoutCenter: [50%, 50%]
        // layoutSize: 100
        silent: false,
        // Map type
        map: "",
        // Define left-top, right-bottom coords to control view
        // For example, [ [180, 90], [-180, -90] ]
        boundingCoords: null,
        // Default on center of map
        center: null,
        zoom: 1,
        scaleLimit: null,
        // selectedMode: false
        label: {
            show: false,
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.tertiary
        },
        itemStyle: {
            borderWidth: 0.5,
            borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.border
        },
        emphasis: {
            label: {
                show: true,
                color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.primary
            },
            itemStyle: {
                color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.highlight
            }
        },
        select: {
            label: {
                show: true,
                color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.primary
            },
            itemStyle: {
                color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.highlight
            }
        },
        regions: []
    };
    return GeoModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $4ff027656cc71ef0$export$2e2bcd8739ae039 = $4ff027656cc71ef0$var$GeoModel;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $26ced9bb0cf549b8$var$GeoView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GeoView, _super);
    function GeoView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GeoView.type;
        _this.focusBlurEnabled = true;
        return _this;
    }
    GeoView.prototype.init = function(ecModel, api) {
        this._api = api;
    };
    GeoView.prototype.render = function(geoModel, ecModel, api, payload) {
        this._model = geoModel;
        if (!geoModel.get("show")) {
            this._mapDraw && this._mapDraw.remove();
            this._mapDraw = null;
            return;
        }
        if (!this._mapDraw) this._mapDraw = new (0, $ad029c27e0f2a7ab$export$2e2bcd8739ae039)(api);
        var mapDraw = this._mapDraw;
        mapDraw.draw(geoModel, ecModel, api, this, payload);
        mapDraw.group.on("click", this._handleRegionClick, this);
        mapDraw.group.silent = geoModel.get("silent");
        this.group.add(mapDraw.group);
        this.updateSelectStatus(geoModel, ecModel, api);
    };
    GeoView.prototype._handleRegionClick = function(e) {
        var eventData;
        (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(e.target, function(current) {
            return (eventData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(current).eventData) != null;
        }, true);
        if (eventData) this._api.dispatchAction({
            type: "geoToggleSelect",
            geoId: this._model.id,
            name: eventData.name
        });
    };
    GeoView.prototype.updateSelectStatus = function(model, ecModel, api) {
        var _this = this;
        this._mapDraw.group.traverse(function(node) {
            var eventData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(node).eventData;
            if (eventData) {
                _this._model.isSelected(eventData.name) ? api.enterSelect(node) : api.leaveSelect(node);
                // No need to traverse children.
                return true;
            }
        });
    };
    GeoView.prototype.findHighDownDispatchers = function(name) {
        return this._mapDraw && this._mapDraw.findHighDownDispatchers(name, this._model);
    };
    GeoView.prototype.dispose = function() {
        this._mapDraw && this._mapDraw.remove();
    };
    GeoView.type = "geo";
    return GeoView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $26ced9bb0cf549b8$export$2e2bcd8739ae039 = $26ced9bb0cf549b8$var$GeoView;



function $8082b8b129488d44$var$registerMap(mapName, geoJson, specialAreas) {
    (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).registerMap(mapName, geoJson, specialAreas);
}
function $8082b8b129488d44$export$4b3e715f166fdd78(registers) {
    registers.registerCoordinateSystem("geo", (0, $303164fe3ecc2dc5$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $4ff027656cc71ef0$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $26ced9bb0cf549b8$export$2e2bcd8739ae039));
    registers.registerImpl("registerMap", $8082b8b129488d44$var$registerMap);
    registers.registerImpl("getMap", function(mapName) {
        return (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).getMapForUser(mapName);
    });
    function makeAction(method, actionInfo) {
        actionInfo.update = "geo:updateSelectStatus";
        registers.registerAction(actionInfo, function(payload, ecModel) {
            var selected = {};
            var allSelected = [];
            ecModel.eachComponent({
                mainType: "geo",
                query: payload
            }, function(geoModel) {
                geoModel[method](payload.name);
                var geo = geoModel.coordinateSystem;
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(geo.regions, function(region) {
                    selected[region.name] = geoModel.isSelected(region.name) || false;
                });
                // Notice: there might be duplicated name in different regions.
                var names = [];
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(selected, function(v, name) {
                    selected[name] && names.push(name);
                });
                allSelected.push({
                    geoIndex: geoModel.componentIndex,
                    // Use singular, the same naming convention as the event `selectchanged`.
                    name: names
                });
            });
            return {
                selected: selected,
                allSelected: allSelected,
                name: payload.name
            };
        });
    }
    makeAction("toggleSelected", {
        type: "geoToggleSelect",
        event: "geoselectchanged"
    });
    makeAction("select", {
        type: "geoSelect",
        event: "geoselected"
    });
    makeAction("unSelect", {
        type: "geoUnSelect",
        event: "geounselected"
    });
    /**
   * @payload
   * @property {string} [componentType=series]
   * @property {number} [dx]
   * @property {number} [dy]
   * @property {number} [zoom]
   * @property {number} [originX]
   * @property {number} [originY]
   */ registers.registerAction({
        type: "geoRoam",
        event: "geoRoam",
        update: "updateTransform"
    }, function(payload, ecModel, api) {
        var componentType = payload.componentType;
        if (!componentType) {
            // backward compat, but `payload.componentType` is deprecated.
            if (payload.geoId != null) componentType = "geo";
            else if (payload.seriesId != null) componentType = "series";
        }
        if (!componentType) componentType = "series";
        // FIXME: payload.geoId/payload.seriesId should be required, but historically
        //  it is not mandatory, causing that all of the geo or series can be queried below,
        //  which is not reasonable.
        ecModel.eachComponent({
            mainType: componentType,
            query: payload
        }, function(componentModel) {
            var geo = componentModel.coordinateSystem;
            if (geo.type !== "geo") return;
            var res = (0, $35fd859fd545c4be$export$94d6a16eae2c4cf4)(geo, payload, componentModel.get("scaleLimit"));
            componentModel.setCenter && componentModel.setCenter(res.center);
            componentModel.setZoom && componentModel.setZoom(res.zoom);
            // All map series with same `map` use the same geo coordinate system
            // So the center and zoom must be in sync. Include the series not selected by legend
            if (componentType === "series") (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(componentModel.seriesGroup, function(seriesModel) {
                seriesModel.setCenter(res.center);
                seriesModel.setZoom(res.zoom);
            });
        });
    });
}


function $6c94070aa7d5e098$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $8082b8b129488d44$export$4b3e715f166fdd78));
    registers.registerChartView((0, $1c3add93106395a4$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $f2f4aa5429e1d3d3$export$2e2bcd8739ae039));
    registers.registerLayout((0, $53e61890435fb2d8$export$2e2bcd8739ae039));
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $5e3d42588445ae72$export$2e2bcd8739ae039));
    (0, $e855ccf7eff48bce$export$62942ba95693dbfc)("map", registers.registerAction);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $9e57680b9c04f083$var$DEFAULT_SMOOTH = 0.3;
var $9e57680b9c04f083$var$ParallelView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ParallelView, _super);
    function ParallelView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelView.type;
        _this._dataGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        _this._initialized = false;
        return _this;
    }
    ParallelView.prototype.init = function() {
        this.group.add(this._dataGroup);
    };
    /**
   * @override
   */ ParallelView.prototype.render = function(seriesModel, ecModel, api, payload) {
        // Clear previously rendered progressive elements.
        this._progressiveEls = null;
        var dataGroup = this._dataGroup;
        var data = seriesModel.getData();
        var oldData = this._data;
        var coordSys = seriesModel.coordinateSystem;
        var dimensions = coordSys.dimensions;
        var seriesScope = $9e57680b9c04f083$var$makeSeriesScope(seriesModel);
        data.diff(oldData).add(add).update(update).remove(remove).execute();
        function add(newDataIndex) {
            var line = $9e57680b9c04f083$var$addEl(data, dataGroup, newDataIndex, dimensions, coordSys);
            $9e57680b9c04f083$var$updateElCommon(line, data, newDataIndex, seriesScope);
        }
        function update(newDataIndex, oldDataIndex) {
            var line = oldData.getItemGraphicEl(oldDataIndex);
            var points = $9e57680b9c04f083$var$createLinePoints(data, newDataIndex, dimensions, coordSys);
            data.setItemGraphicEl(newDataIndex, line);
            $8b353638fbedfefa$export$c8dce3c08436e91e(line, {
                shape: {
                    points: points
                }
            }, seriesModel, newDataIndex);
            (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(line);
            $9e57680b9c04f083$var$updateElCommon(line, data, newDataIndex, seriesScope);
        }
        function remove(oldDataIndex) {
            var line = oldData.getItemGraphicEl(oldDataIndex);
            dataGroup.remove(line);
        }
        // First create
        if (!this._initialized) {
            this._initialized = true;
            var clipPath = $9e57680b9c04f083$var$createGridClipShape(coordSys, seriesModel, function() {
                // Callback will be invoked immediately if there is no animation
                setTimeout(function() {
                    dataGroup.removeClipPath();
                });
            });
            dataGroup.setClipPath(clipPath);
        }
        this._data = data;
    };
    ParallelView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        this._initialized = true;
        this._data = null;
        this._dataGroup.removeAll();
    };
    ParallelView.prototype.incrementalRender = function(taskParams, seriesModel, ecModel) {
        var data = seriesModel.getData();
        var coordSys = seriesModel.coordinateSystem;
        var dimensions = coordSys.dimensions;
        var seriesScope = $9e57680b9c04f083$var$makeSeriesScope(seriesModel);
        var progressiveEls = this._progressiveEls = [];
        for(var dataIndex = taskParams.start; dataIndex < taskParams.end; dataIndex++){
            var line = $9e57680b9c04f083$var$addEl(data, this._dataGroup, dataIndex, dimensions, coordSys);
            line.incremental = true;
            $9e57680b9c04f083$var$updateElCommon(line, data, dataIndex, seriesScope);
            progressiveEls.push(line);
        }
    };
    ParallelView.prototype.remove = function() {
        this._dataGroup && this._dataGroup.removeAll();
        this._data = null;
    };
    ParallelView.type = "parallel";
    return ParallelView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
function $9e57680b9c04f083$var$createGridClipShape(coordSys, seriesModel, cb) {
    var parallelModel = coordSys.model;
    var rect = coordSys.getRect();
    var rectEl = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        shape: {
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        }
    });
    var dim = parallelModel.get("layout") === "horizontal" ? "width" : "height";
    rectEl.setShape(dim, 0);
    $8b353638fbedfefa$export$a121566aadcfe021(rectEl, {
        shape: {
            width: rect.width,
            height: rect.height
        }
    }, seriesModel, cb);
    return rectEl;
}
function $9e57680b9c04f083$var$createLinePoints(data, dataIndex, dimensions, coordSys) {
    var points = [];
    for(var i = 0; i < dimensions.length; i++){
        var dimName = dimensions[i];
        var value = data.get(data.mapDimension(dimName), dataIndex);
        if (!$9e57680b9c04f083$var$isEmptyValue(value, coordSys.getAxis(dimName).type)) points.push(coordSys.dataToPoint(value, dimName));
    }
    return points;
}
function $9e57680b9c04f083$var$addEl(data, dataGroup, dataIndex, dimensions, coordSys) {
    var points = $9e57680b9c04f083$var$createLinePoints(data, dataIndex, dimensions, coordSys);
    var line = new $d28119f30e6bb670$export$2e2bcd8739ae039({
        shape: {
            points: points
        },
        // silent: true,
        z2: 10
    });
    dataGroup.add(line);
    data.setItemGraphicEl(dataIndex, line);
    return line;
}
function $9e57680b9c04f083$var$makeSeriesScope(seriesModel) {
    var smooth = seriesModel.get("smooth", true);
    smooth === true && (smooth = $9e57680b9c04f083$var$DEFAULT_SMOOTH);
    smooth = (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(smooth);
    (0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(smooth) && (smooth = 0);
    return {
        smooth: smooth
    };
}
function $9e57680b9c04f083$var$updateElCommon(el, data, dataIndex, seriesScope) {
    el.useStyle(data.getItemVisual(dataIndex, "style"));
    el.style.fill = null;
    el.setShape("smooth", seriesScope.smooth);
    var itemModel = data.getItemModel(dataIndex);
    var emphasisModel = itemModel.getModel("emphasis");
    (0, $2bf82c0980125b62$export$48b68047d330bbc9)(el, itemModel, "lineStyle");
    (0, $2bf82c0980125b62$export$e51187539ff11209)(el, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
}
// function simpleDiff(oldData, newData, dimensions) {
//     let oldLen;
//     if (!oldData
//         || !oldData.__plProgressive
//         || (oldLen = oldData.count()) !== newData.count()
//     ) {
//         return true;
//     }
//     let dimLen = dimensions.length;
//     for (let i = 0; i < oldLen; i++) {
//         for (let j = 0; j < dimLen; j++) {
//             if (oldData.get(dimensions[j], i) !== newData.get(dimensions[j], i)) {
//                 return true;
//             }
//         }
//     }
//     return false;
// }
// FIXME put in common util?
function $9e57680b9c04f083$var$isEmptyValue(val, axisType) {
    return axisType === "category" ? val == null : val == null || isNaN(val); // axisType === 'value'
}
var $9e57680b9c04f083$export$2e2bcd8739ae039 = $9e57680b9c04f083$var$ParallelView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $5d63691998e05817$var$ParallelSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ParallelSeriesModel, _super);
    function ParallelSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelSeriesModel.type;
        _this.visualStyleAccessPath = "lineStyle";
        _this.visualDrawType = "stroke";
        return _this;
    }
    ParallelSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($5d63691998e05817$var$makeDefaultEncode, null, this)
        });
    };
    /**
   * User can get data raw indices on 'axisAreaSelected' event received.
   *
   * @return Raw indices
   */ ParallelSeriesModel.prototype.getRawIndicesByActiveState = function(activeState) {
        var coordSys = this.coordinateSystem;
        var data = this.getData();
        var indices = [];
        coordSys.eachActiveState(data, function(theActiveState, dataIndex) {
            if (activeState === theActiveState) indices.push(data.getRawIndex(dataIndex));
        });
        return indices;
    };
    ParallelSeriesModel.type = "series.parallel";
    ParallelSeriesModel.dependencies = [
        "parallel"
    ];
    ParallelSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: "parallel",
        parallelIndex: 0,
        label: {
            show: false
        },
        inactiveOpacity: 0.05,
        activeOpacity: 1,
        lineStyle: {
            width: 1,
            opacity: 0.45,
            type: "solid"
        },
        emphasis: {
            label: {
                show: false
            }
        },
        progressive: 500,
        smooth: false,
        animationEasing: "linear"
    };
    return ParallelSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
function $5d63691998e05817$var$makeDefaultEncode(seriesModel) {
    // The mapping of parallelAxis dimension to data dimension can
    // be specified in parallelAxis.option.dim. For example, if
    // parallelAxis.option.dim is 'dim3', it mapping to the third
    // dimension of data. But `data.encode` has higher priority.
    // Moreover, parallelModel.dimension should not be regarded as data
    // dimensions. Consider dimensions = ['dim4', 'dim2', 'dim6'];
    var parallelModel = seriesModel.ecModel.getComponent("parallel", seriesModel.get("parallelIndex"));
    if (!parallelModel) return;
    var encodeDefine = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(parallelModel.dimensions, function(axisDim) {
        var dataDimIndex = $5d63691998e05817$var$convertDimNameToNumber(axisDim);
        encodeDefine[axisDim] = dataDimIndex;
    });
    return encodeDefine;
}
function $5d63691998e05817$var$convertDimNameToNumber(dimName) {
    return +dimName.replace("dim", "");
}
var $5d63691998e05817$export$2e2bcd8739ae039 = $5d63691998e05817$var$ParallelSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $8148e21d655f67c8$var$opacityAccessPath = [
    "lineStyle",
    "opacity"
];
var $8148e21d655f67c8$var$parallelVisual = {
    seriesType: "parallel",
    reset: function(seriesModel, ecModel) {
        var coordSys = seriesModel.coordinateSystem;
        var opacityMap = {
            normal: seriesModel.get([
                "lineStyle",
                "opacity"
            ]),
            active: seriesModel.get("activeOpacity"),
            inactive: seriesModel.get("inactiveOpacity")
        };
        return {
            progress: function(params, data) {
                coordSys.eachActiveState(data, function(activeState, dataIndex) {
                    var opacity = opacityMap[activeState];
                    if (activeState === "normal" && data.hasItemOption) {
                        var itemOpacity = data.getItemModel(dataIndex).get($8148e21d655f67c8$var$opacityAccessPath, true);
                        itemOpacity != null && (opacity = itemOpacity);
                    }
                    var existsStyle = data.ensureUniqueItemVisual(dataIndex, "style");
                    existsStyle.opacity = opacity;
                }, params.start, params.end);
            }
        };
    }
};
var $8148e21d655f67c8$export$2e2bcd8739ae039 = $8148e21d655f67c8$var$parallelVisual;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $30173db3404062fa$export$2e2bcd8739ae039(option) {
    $30173db3404062fa$var$createParallelIfNeeded(option);
    $30173db3404062fa$var$mergeAxisOptionFromParallel(option);
}
/**
 * Create a parallel coordinate if not exists.
 * @inner
 */ function $30173db3404062fa$var$createParallelIfNeeded(option) {
    if (option.parallel) return;
    var hasParallelSeries = false;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(option.series, function(seriesOpt) {
        if (seriesOpt && seriesOpt.type === "parallel") hasParallelSeries = true;
    });
    if (hasParallelSeries) option.parallel = [
        {}
    ];
}
/**
 * Merge aixs definition from parallel option (if exists) to axis option.
 * @inner
 */ function $30173db3404062fa$var$mergeAxisOptionFromParallel(option) {
    var axes = $76d619f648247e6d$export$4f07b212a02c8051(option.parallelAxis);
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(axes, function(axisOption) {
        if (!$7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(axisOption)) return;
        var parallelIndex = axisOption.parallelIndex || 0;
        var parallelOption = $76d619f648247e6d$export$4f07b212a02c8051(option.parallel)[parallelIndex];
        if (parallelOption && parallelOption.parallelAxisDefault) $7a1bd9c2710fea0d$export$4950aa0f605343fb(axisOption, parallelOption.parallelAxisDefault, false);
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $ccce4513d4baec6a$var$CLICK_THRESHOLD = 5; // > 4
var $ccce4513d4baec6a$var$ParallelView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ParallelView, _super);
    function ParallelView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelView.type;
        return _this;
    }
    ParallelView.prototype.render = function(parallelModel, ecModel, api) {
        this._model = parallelModel;
        this._api = api;
        if (!this._handlers) {
            this._handlers = {};
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($ccce4513d4baec6a$var$handlers, function(handler, eventName) {
                api.getZr().on(eventName, this._handlers[eventName] = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(handler, this));
            }, this);
        }
        (0, $c98659a9437a3d2e$export$958e3e1a02eac4b6)(this, "_throttledDispatchExpand", parallelModel.get("axisExpandRate"), "fixRate");
    };
    ParallelView.prototype.dispose = function(ecModel, api) {
        (0, $c98659a9437a3d2e$export$42ffd38884aecdac)(this, "_throttledDispatchExpand");
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._handlers, function(handler, eventName) {
            api.getZr().off(eventName, handler);
        });
        this._handlers = null;
    };
    /**
   * @internal
   * @param {Object} [opt] If null, cancel the last action triggering for debounce.
   */ ParallelView.prototype._throttledDispatchExpand = function(opt) {
        this._dispatchExpand(opt);
    };
    /**
   * @internal
   */ ParallelView.prototype._dispatchExpand = function(opt) {
        opt && this._api.dispatchAction((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
            type: "parallelAxisExpand"
        }, opt));
    };
    ParallelView.type = "parallel";
    return ParallelView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $ccce4513d4baec6a$var$handlers = {
    mousedown: function(e) {
        if ($ccce4513d4baec6a$var$checkTrigger(this, "click")) this._mouseDownPoint = [
            e.offsetX,
            e.offsetY
        ];
    },
    mouseup: function(e) {
        var mouseDownPoint = this._mouseDownPoint;
        if ($ccce4513d4baec6a$var$checkTrigger(this, "click") && mouseDownPoint) {
            var point = [
                e.offsetX,
                e.offsetY
            ];
            var dist = Math.pow(mouseDownPoint[0] - point[0], 2) + Math.pow(mouseDownPoint[1] - point[1], 2);
            if (dist > $ccce4513d4baec6a$var$CLICK_THRESHOLD) return;
            var result = this._model.coordinateSystem.getSlidedAxisExpandWindow([
                e.offsetX,
                e.offsetY
            ]);
            result.behavior !== "none" && this._dispatchExpand({
                axisExpandWindow: result.axisExpandWindow
            });
        }
        this._mouseDownPoint = null;
    },
    mousemove: function(e) {
        // Should do nothing when brushing.
        if (this._mouseDownPoint || !$ccce4513d4baec6a$var$checkTrigger(this, "mousemove")) return;
        var model = this._model;
        var result = model.coordinateSystem.getSlidedAxisExpandWindow([
            e.offsetX,
            e.offsetY
        ]);
        var behavior = result.behavior;
        behavior === "jump" && this._throttledDispatchExpand.debounceNextCall(model.get("axisExpandDebounce"));
        this._throttledDispatchExpand(behavior === "none" ? null // Cancel the last trigger, in case that mouse slide out of the area quickly.
         : {
            axisExpandWindow: result.axisExpandWindow,
            // Jumping uses animation, and sliding suppresses animation.
            animation: behavior === "jump" ? null : {
                duration: 0 // Disable animation.
            }
        });
    }
};
function $ccce4513d4baec6a$var$checkTrigger(view, triggerOn) {
    var model = view._model;
    return model.get("axisExpandable") && model.get("axisExpandTriggerOn") === triggerOn;
}
var $ccce4513d4baec6a$export$2e2bcd8739ae039 = $ccce4513d4baec6a$var$ParallelView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $a14d8e1511adaa1e$var$ParallelModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ParallelModel, _super);
    function ParallelModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelModel.type;
        return _this;
    }
    ParallelModel.prototype.init = function() {
        _super.prototype.init.apply(this, arguments);
        this.mergeOption({});
    };
    ParallelModel.prototype.mergeOption = function(newOption) {
        var thisOption = this.option;
        newOption && $7a1bd9c2710fea0d$export$4950aa0f605343fb(thisOption, newOption, true);
        this._initDimensions();
    };
    /**
   * Whether series or axis is in this coordinate system.
   */ ParallelModel.prototype.contains = function(model, ecModel) {
        var parallelIndex = model.get("parallelIndex");
        return parallelIndex != null && ecModel.getComponent("parallel", parallelIndex) === this;
    };
    ParallelModel.prototype.setAxisExpand = function(opt) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43([
            "axisExpandable",
            "axisExpandCenter",
            "axisExpandCount",
            "axisExpandWidth",
            "axisExpandWindow"
        ], function(name) {
            if (opt.hasOwnProperty(name)) // @ts-ignore FIXME: why "never" inferred in this.option[name]?
            this.option[name] = opt[name];
        }, this);
    };
    ParallelModel.prototype._initDimensions = function() {
        var dimensions = this.dimensions = [];
        var parallelAxisIndex = this.parallelAxisIndex = [];
        var axisModels = $7a1bd9c2710fea0d$export$3dea766d36a8935f(this.ecModel.queryComponents({
            mainType: "parallelAxis"
        }), function(axisModel) {
            // Can not use this.contains here, because
            // initialization has not been completed yet.
            return (axisModel.get("parallelIndex") || 0) === this.componentIndex;
        }, this);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(axisModels, function(axisModel) {
            dimensions.push("dim" + axisModel.get("dim"));
            parallelAxisIndex.push(axisModel.componentIndex);
        });
    };
    ParallelModel.type = "parallel";
    ParallelModel.dependencies = [
        "parallelAxis"
    ];
    ParallelModel.layoutMode = "box";
    ParallelModel.defaultOption = {
        // zlevel: 0,
        z: 0,
        left: 80,
        top: 60,
        right: 80,
        bottom: 60,
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        layout: "horizontal",
        // FIXME
        // naming?
        axisExpandable: false,
        axisExpandCenter: null,
        axisExpandCount: 0,
        axisExpandWidth: 50,
        axisExpandRate: 17,
        axisExpandDebounce: 50,
        // [out, in, jumpTarget]. In percentage. If use [null, 0.05], null means full.
        // Do not doc to user until necessary.
        axisExpandSlideTriggerArea: [
            -0.15,
            0.05,
            0.4
        ],
        axisExpandTriggerOn: "click",
        parallelAxisDefault: null
    };
    return ParallelModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $a14d8e1511adaa1e$export$2e2bcd8739ae039 = $a14d8e1511adaa1e$var$ParallelModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Parallel coordinate system creater.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Parallel Coordinates
 * <https://en.wikipedia.org/wiki/Parallel_coordinates>
 */ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $60f7f1f3e3996637$export$a8a5b03ea14764df(val) {
    var exp10 = Math.pow(10, (0, $cfc1f3b422a3185f$export$97256a17b20a0c24)(Math.abs(val)));
    var f = Math.abs(val / exp10);
    return f === 0 || f === 1 || f === 2 || f === 3 || f === 5;
}
function $60f7f1f3e3996637$export$dfc8cd28ed7b22a0(scale) {
    return scale.type === "interval" || scale.type === "log";
}
function $60f7f1f3e3996637$export$eeea879a611eb991(extent, spanWithBreaks, splitNumber, minInterval, maxInterval) {
    var result = {};
    var interval = result.interval = (0, $cfc1f3b422a3185f$export$7a695fe44258210b)(spanWithBreaks / splitNumber, true);
    if (minInterval != null && interval < minInterval) interval = result.interval = minInterval;
    if (maxInterval != null && interval > maxInterval) interval = result.interval = maxInterval;
    // Tow more digital for tick.
    var precision = result.intervalPrecision = $60f7f1f3e3996637$export$86a060b060d3d31a(interval);
    // Niced extent inside original extent
    var niceTickExtent = result.niceTickExtent = [
        (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(Math.ceil(extent[0] / interval) * interval, precision),
        (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(Math.floor(extent[1] / interval) * interval, precision)
    ];
    $60f7f1f3e3996637$export$624b8c8c438031ad(niceTickExtent, extent);
    return result;
}
function $60f7f1f3e3996637$export$f39031e8422f329d(interval) {
    var exp10 = Math.pow(10, (0, $cfc1f3b422a3185f$export$97256a17b20a0c24)(interval));
    // Increase interval
    var f = interval / exp10;
    if (!f) f = 1;
    else if (f === 2) f = 3;
    else if (f === 3) f = 5;
    else // f is 1 or 5
    f *= 2;
    return (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(f * exp10);
}
function $60f7f1f3e3996637$export$86a060b060d3d31a(interval) {
    // Tow more digital for tick.
    return (0, $cfc1f3b422a3185f$export$e0c74b50bbd10f68)(interval) + 2;
}
function $60f7f1f3e3996637$var$clamp(niceTickExtent, idx, extent) {
    niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
}
function $60f7f1f3e3996637$export$624b8c8c438031ad(niceTickExtent, extent) {
    !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
    !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
    $60f7f1f3e3996637$var$clamp(niceTickExtent, 0, extent);
    $60f7f1f3e3996637$var$clamp(niceTickExtent, 1, extent);
    if (niceTickExtent[0] > niceTickExtent[1]) niceTickExtent[0] = niceTickExtent[1];
}
function $60f7f1f3e3996637$export$8893e2b90ba10d92(val, extent) {
    return val >= extent[0] && val <= extent[1];
}
var $60f7f1f3e3996637$export$94a76197a12818ce = /** @class */ function() {
    function ScaleCalculator() {
        this.normalize = $60f7f1f3e3996637$var$normalize;
        this.scale = $60f7f1f3e3996637$var$scale;
    }
    ScaleCalculator.prototype.updateMethods = function(brkCtx) {
        if (brkCtx.hasBreaks()) {
            this.normalize = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(brkCtx.normalize, brkCtx);
            this.scale = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(brkCtx.scale, brkCtx);
        } else {
            this.normalize = $60f7f1f3e3996637$var$normalize;
            this.scale = $60f7f1f3e3996637$var$scale;
        }
    };
    return ScaleCalculator;
}();
function $60f7f1f3e3996637$var$normalize(val, extent) {
    if (extent[1] === extent[0]) return 0.5;
    return (val - extent[0]) / (extent[1] - extent[0]);
}
function $60f7f1f3e3996637$var$scale(val, extent) {
    return val * (extent[1] - extent[0]) + extent[0];
}
function $60f7f1f3e3996637$export$a6588cdf5be114b3(base, extent, noClampNegative) {
    var loggedBase = Math.log(base);
    return [
        // log(negative) is NaN, so safe guard here.
        // PENDING: But even getting a -Infinity still does not make sense in extent.
        //  Just keep it as is, getting a NaN to make some previous cases works by coincidence.
        Math.log(noClampNegative ? extent[0] : Math.max(0, extent[0])) / loggedBase,
        Math.log(noClampNegative ? extent[1] : Math.max(0, extent[1])) / loggedBase
    ];
}




var $1754de95b9b9c398$var$Scale = /** @class */ function() {
    function Scale(setting) {
        this._calculator = new (0, $60f7f1f3e3996637$export$94a76197a12818ce)();
        this._setting = setting || {};
        this._extent = [
            Infinity,
            -Infinity
        ];
        var scaleBreakHelper = (0, $639a5974fe354f7a$export$e79b20ac82c2d660)();
        if (scaleBreakHelper) {
            this._brkCtx = scaleBreakHelper.createScaleBreakContext();
            this._brkCtx.update(this._extent);
        }
    }
    Scale.prototype.getSetting = function(name) {
        return this._setting[name];
    };
    /**
   * [CAVEAT]: It should not be overridden!
   */ Scale.prototype._innerUnionExtent = function(other) {
        var extent = this._extent;
        // Considered that number could be NaN and should not write into the extent.
        this._innerSetExtent(other[0] < extent[0] ? other[0] : extent[0], other[1] > extent[1] ? other[1] : extent[1]);
    };
    /**
   * Set extent from data
   */ Scale.prototype.unionExtentFromData = function(data, dim) {
        this._innerUnionExtent(data.getApproximateExtent(dim));
    };
    /**
   * Get a new slice of extent.
   * Extent is always in increase order.
   */ Scale.prototype.getExtent = function() {
        return this._extent.slice();
    };
    Scale.prototype.setExtent = function(start, end) {
        this._innerSetExtent(start, end);
    };
    /**
   * [CAVEAT]: It should not be overridden!
   */ Scale.prototype._innerSetExtent = function(start, end) {
        var thisExtent = this._extent;
        if (!isNaN(start)) thisExtent[0] = start;
        if (!isNaN(end)) thisExtent[1] = end;
        this._brkCtx && this._brkCtx.update(thisExtent);
    };
    /**
   * Prerequisite: Scale#parse is ready.
   */ Scale.prototype.setBreaksFromOption = function(breakOptionList) {
        var scaleBreakHelper = (0, $639a5974fe354f7a$export$e79b20ac82c2d660)();
        if (scaleBreakHelper) this._innerSetBreak(scaleBreakHelper.parseAxisBreakOption(breakOptionList, (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this.parse, this)));
    };
    /**
   * [CAVEAT]: It should not be overridden!
   */ Scale.prototype._innerSetBreak = function(parsed) {
        if (this._brkCtx) {
            this._brkCtx.setBreaks(parsed);
            this._calculator.updateMethods(this._brkCtx);
            this._brkCtx.update(this._extent);
        }
    };
    /**
   * [CAVEAT]: It should not be overridden!
   */ Scale.prototype._innerGetBreaks = function() {
        return this._brkCtx ? this._brkCtx.breaks : [];
    };
    /**
   * Do not expose the internal `_breaks` unless necessary.
   */ Scale.prototype.hasBreaks = function() {
        return this._brkCtx ? this._brkCtx.hasBreaks() : false;
    };
    Scale.prototype._getExtentSpanWithBreaks = function() {
        return this._brkCtx && this._brkCtx.hasBreaks() ? this._brkCtx.getExtentSpan() : this._extent[1] - this._extent[0];
    };
    /**
   * If value is in extent range
   */ Scale.prototype.isInExtentRange = function(value) {
        return this._extent[0] <= value && this._extent[1] >= value;
    };
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   */ Scale.prototype.isBlank = function() {
        return this._isBlank;
    };
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   */ Scale.prototype.setBlank = function(isBlank) {
        this._isBlank = isBlank;
    };
    return Scale;
}();
$cd5f95cf03b4e3e7$export$241315e45585454d($1754de95b9b9c398$var$Scale);
var $1754de95b9b9c398$export$2e2bcd8739ae039 = $1754de95b9b9c398$var$Scale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $57fe7cbbaae9fab0$var$uidBase = 0;
var $57fe7cbbaae9fab0$var$OrdinalMeta = /** @class */ function() {
    /**
   * PENDING - Regarding forcibly converting to string:
   *  In the early days, the underlying hash map impl used JS plain object and converted the key to
   *  string; later in https://github.com/ecomfe/zrender/pull/966 it was changed to a JS Map (in supported
   *  platforms), which does not require string keys. But consider any input that `scale/Ordinal['parse']`
   *  is involved, a number input represents an `OrdinalNumber` (i.e., an index), and affect the query
   *  behavior:
   *    - If forcbily converting to string:
   *      pros: users can use numeric string (such as, '123') to query the raw data (123), tho it's probably
   *      still confusing.
   *      cons: NaN/null/undefined in data will be equals to 'NaN'/'null'/'undefined', if simply using
   *      `val + ''` to convert them, like currently `getName` does.
   *    - Otherwise:
   *      pros: see NaN/null/undefined case above.
   *      cons: users cannot query the raw data (123) any more.
   *  There are two inconsistent behaviors in the current impl:
   *    - Force conversion is applied on the case `xAxis{data: ['aaa', 'bbb', ...]}`,
   *      but no conversion applied to the case `xAxis{data: [{value: 'aaa'}, ...]}` and
   *      the case `dataset: {source: [['aaa', 123], ['bbb', 234], ...]}`.
   *    - behaves differently according to whether JS Map is supported (the polyfill is simply using JS
   *      plain object) (tho it seems rare platform that do not support it).
   *  Since there's no sufficient good solution to offset cost of the breaking change, we preserve the
   *  current behavior, until real issues is reported.
   */ function OrdinalMeta(opt) {
        this.categories = opt.categories || [];
        this._needCollect = opt.needCollect;
        this._deduplication = opt.deduplication;
        this.uid = ++$57fe7cbbaae9fab0$var$uidBase;
        this._onCollect = opt.onCollect;
    }
    OrdinalMeta.createByAxisModel = function(axisModel) {
        var option = axisModel.option;
        var data = option.data;
        var categories = data && (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(data, $57fe7cbbaae9fab0$var$getName);
        return new OrdinalMeta({
            categories: categories,
            needCollect: !categories,
            // deduplication is default in axis.
            deduplication: option.dedplication !== false
        });
    };
    OrdinalMeta.prototype.getOrdinal = function(category) {
        return this._getOrCreateMap().get(category);
    };
    /**
   * @return The ordinal. If not found, return NaN.
   */ OrdinalMeta.prototype.parseAndCollect = function(category) {
        var index;
        var needCollect = this._needCollect;
        // The value of category dim can be the index of the given category set.
        // This feature is only supported when !needCollect, because we should
        // consider a common case: a value is 2017, which is a number but is
        // expected to be tread as a category. This case usually happen in dataset,
        // where it happent to be no need of the index feature.
        if (!(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(category) && !needCollect) return category;
        // Optimize for the scenario:
        // category is ['2012-01-01', '2012-01-02', ...], where the input
        // data has been ensured not duplicate and is large data.
        // Notice, if a dataset dimension provide categroies, usually echarts
        // should remove duplication except user tell echarts dont do that
        // (set axis.deduplication = false), because echarts do not know whether
        // the values in the category dimension has duplication (consider the
        // parallel-aqi example)
        if (needCollect && !this._deduplication) {
            index = this.categories.length;
            this.categories[index] = category;
            this._onCollect && this._onCollect(category, index);
            return index;
        }
        var map = this._getOrCreateMap();
        index = map.get(category);
        if (index == null) {
            if (needCollect) {
                index = this.categories.length;
                this.categories[index] = category;
                map.set(category, index);
                this._onCollect && this._onCollect(category, index);
            } else index = NaN;
        }
        return index;
    };
    // Consider big data, do not create map until needed.
    OrdinalMeta.prototype._getOrCreateMap = function() {
        return this._map || (this._map = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)(this.categories));
    };
    return OrdinalMeta;
}();
function $57fe7cbbaae9fab0$var$getName(obj) {
    if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(obj) && obj.value != null) return obj.value;
    else return obj + "";
}
var $57fe7cbbaae9fab0$export$2e2bcd8739ae039 = $57fe7cbbaae9fab0$var$OrdinalMeta;




var $6e82606ec775d365$var$OrdinalScale = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(OrdinalScale, _super);
    function OrdinalScale(setting) {
        var _this = _super.call(this, setting) || this;
        _this.type = "ordinal";
        var ordinalMeta = _this.getSetting("ordinalMeta");
        // Caution: Should not use instanceof, consider ec-extensions using
        // import approach to get OrdinalMeta class.
        if (!ordinalMeta) ordinalMeta = new (0, $57fe7cbbaae9fab0$export$2e2bcd8739ae039)({});
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(ordinalMeta)) ordinalMeta = new (0, $57fe7cbbaae9fab0$export$2e2bcd8739ae039)({
            categories: (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(ordinalMeta, function(item) {
                return (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(item) ? item.value : item;
            })
        });
        _this._ordinalMeta = ordinalMeta;
        _this._extent = _this.getSetting("extent") || [
            0,
            ordinalMeta.categories.length - 1
        ];
        return _this;
    }
    OrdinalScale.prototype.parse = function(val) {
        // Caution: Math.round(null) will return `0` rather than `NaN`
        if (val == null) return NaN;
        return (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(val) ? this._ordinalMeta.getOrdinal(val) : Math.round(val);
    };
    OrdinalScale.prototype.contain = function(val) {
        return $60f7f1f3e3996637$export$8893e2b90ba10d92(val, this._extent) && val >= 0 && val < this._ordinalMeta.categories.length;
    };
    /**
   * Normalize given rank or name to linear [0, 1]
   * @param val raw ordinal number.
   * @return normalized value in [0, 1].
   */ OrdinalScale.prototype.normalize = function(val) {
        val = this._getTickNumber(val);
        return this._calculator.normalize(val, this._extent);
    };
    /**
   * @param val normalized value in [0, 1].
   * @return raw ordinal number.
   */ OrdinalScale.prototype.scale = function(val) {
        val = Math.round(this._calculator.scale(val, this._extent));
        return this.getRawOrdinalNumber(val);
    };
    OrdinalScale.prototype.getTicks = function() {
        var ticks = [];
        var extent = this._extent;
        var rank = extent[0];
        while(rank <= extent[1]){
            ticks.push({
                value: rank
            });
            rank++;
        }
        return ticks;
    };
    OrdinalScale.prototype.getMinorTicks = function(splitNumber) {
        // Not support.
        return;
    };
    /**
   * @see `Ordinal['_ordinalNumbersByTick']`
   */ OrdinalScale.prototype.setSortInfo = function(info) {
        if (info == null) {
            this._ordinalNumbersByTick = this._ticksByOrdinalNumber = null;
            return;
        }
        var infoOrdinalNumbers = info.ordinalNumbers;
        var ordinalsByTick = this._ordinalNumbersByTick = [];
        var ticksByOrdinal = this._ticksByOrdinalNumber = [];
        // Unnecessary support negative tick in `realtimeSort`.
        var tickNum = 0;
        var allCategoryLen = this._ordinalMeta.categories.length;
        for(var len = Math.min(allCategoryLen, infoOrdinalNumbers.length); tickNum < len; ++tickNum){
            var ordinalNumber = infoOrdinalNumbers[tickNum];
            ordinalsByTick[tickNum] = ordinalNumber;
            ticksByOrdinal[ordinalNumber] = tickNum;
        }
        // Handle that `series.data` only covers part of the `axis.category.data`.
        var unusedOrdinal = 0;
        for(; tickNum < allCategoryLen; ++tickNum){
            while(ticksByOrdinal[unusedOrdinal] != null)unusedOrdinal++;
            ordinalsByTick.push(unusedOrdinal);
            ticksByOrdinal[unusedOrdinal] = tickNum;
        }
    };
    OrdinalScale.prototype._getTickNumber = function(ordinal) {
        var ticksByOrdinalNumber = this._ticksByOrdinalNumber;
        // also support ordinal out of range of `ordinalMeta.categories.length`,
        // where ordinal numbers are used as tick value directly.
        return ticksByOrdinalNumber && ordinal >= 0 && ordinal < ticksByOrdinalNumber.length ? ticksByOrdinalNumber[ordinal] : ordinal;
    };
    /**
   * @usage
   * ```js
   * const ordinalNumber = ordinalScale.getRawOrdinalNumber(tickVal);
   *
   * // case0
   * const rawOrdinalValue = axisModel.getCategories()[ordinalNumber];
   * // case1
   * const rawOrdinalValue = this._ordinalMeta.categories[ordinalNumber];
   * // case2
   * const coord = axis.dataToCoord(ordinalNumber);
   * ```
   *
   * @param {OrdinalNumber} tickNumber index of display
   */ OrdinalScale.prototype.getRawOrdinalNumber = function(tickNumber) {
        var ordinalNumbersByTick = this._ordinalNumbersByTick;
        // tickNumber may be out of range, e.g., when axis max is larger than `ordinalMeta.categories.length`.,
        // where ordinal numbers are used as tick value directly.
        return ordinalNumbersByTick && tickNumber >= 0 && tickNumber < ordinalNumbersByTick.length ? ordinalNumbersByTick[tickNumber] : tickNumber;
    };
    /**
   * Get item on tick
   */ OrdinalScale.prototype.getLabel = function(tick) {
        if (!this.isBlank()) {
            var ordinalNumber = this.getRawOrdinalNumber(tick.value);
            var cateogry = this._ordinalMeta.categories[ordinalNumber];
            // Note that if no data, ordinalMeta.categories is an empty array.
            // Return empty if it's not exist.
            return cateogry == null ? "" : cateogry + "";
        }
    };
    OrdinalScale.prototype.count = function() {
        return this._extent[1] - this._extent[0] + 1;
    };
    /**
   * @override
   * If value is in extent range
   */ OrdinalScale.prototype.isInExtentRange = function(value) {
        value = this._getTickNumber(value);
        return this._extent[0] <= value && this._extent[1] >= value;
    };
    OrdinalScale.prototype.getOrdinalMeta = function() {
        return this._ordinalMeta;
    };
    OrdinalScale.prototype.calcNiceTicks = function() {};
    OrdinalScale.prototype.calcNiceExtent = function() {};
    OrdinalScale.type = "ordinal";
    return OrdinalScale;
}((0, $1754de95b9b9c398$export$2e2bcd8739ae039));
(0, $1754de95b9b9c398$export$2e2bcd8739ae039).registerClass($6e82606ec775d365$var$OrdinalScale);
var $6e82606ec775d365$export$2e2bcd8739ae039 = $6e82606ec775d365$var$OrdinalScale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $dddb89ade16db3d5$var$roundNumber = $cfc1f3b422a3185f$export$2077e0241d6afd3c;
var $dddb89ade16db3d5$var$IntervalScale = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(IntervalScale, _super);
    function IntervalScale() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "interval";
        // Step is calculated in adjustExtent.
        _this._interval = 0;
        _this._intervalPrecision = 2;
        return _this;
    }
    IntervalScale.prototype.parse = function(val) {
        // `Scale#parse` (and its overrids) are typically applied at the axis values input
        // in echarts option. e.g., `axis.min/max`, `dataZoom.min/max`, etc.
        // but `series.data` is not included, which uses `dataValueHelper.ts`#`parseDataValue`.
        // `Scale#parse` originally introduced in fb8c813215098b9d2458966229bb95c510883d5e
        // at 2016 for dataZoom start/end settings (See `parseAxisModelMinMax`).
        //
        // Historically `scale/Interval.ts` returns the input value directly. But numeric
        // values (such as a number-like string '123') effectively passed through here and
        // were involved in calculations, which was error-prone and inconsistent with the
        // declared TS return type. Previously such issues are fixed separately in different
        // places case by case (such as #2475).
        //
        // Now, we perform actual parse to ensure its `number` type here. The parsing rule
        // follows the series data parsing rule (`dataValueHelper.ts`#`parseDataValue`)
        // and maintains compatibility as much as possible (thus a more strict parsing
        // `number.ts`#`numericToNumber` is not used here.)
        //
        // FIXME: `ScaleDataValue` also need to be modified to include numeric string type,
        //  since it effectively does.
        return val == null || val === "" ? NaN : Number(val);
    };
    IntervalScale.prototype.contain = function(val) {
        return $60f7f1f3e3996637$export$8893e2b90ba10d92(val, this._extent);
    };
    IntervalScale.prototype.normalize = function(val) {
        return this._calculator.normalize(val, this._extent);
    };
    IntervalScale.prototype.scale = function(val) {
        return this._calculator.scale(val, this._extent);
    };
    IntervalScale.prototype.getInterval = function() {
        return this._interval;
    };
    IntervalScale.prototype.setInterval = function(interval) {
        this._interval = interval;
        // Dropped auto calculated niceExtent and use user-set extent.
        // We assume user wants to set both interval, min, max to get a better result.
        this._niceExtent = this._extent.slice();
        this._intervalPrecision = $60f7f1f3e3996637$export$86a060b060d3d31a(interval);
    };
    /**
   * @override
   */ IntervalScale.prototype.getTicks = function(opt) {
        opt = opt || {};
        var interval = this._interval;
        var extent = this._extent;
        var niceTickExtent = this._niceExtent;
        var intervalPrecision = this._intervalPrecision;
        var scaleBreakHelper = (0, $639a5974fe354f7a$export$e79b20ac82c2d660)();
        var ticks = [];
        // If interval is 0, return [];
        if (!interval) return ticks;
        if (opt.breakTicks === "only_break" && scaleBreakHelper) {
            scaleBreakHelper.addBreaksToTicks(ticks, this._brkCtx.breaks, this._extent);
            return ticks;
        }
        // Consider this case: using dataZoom toolbox, zoom and zoom.
        var safeLimit = 10000;
        if (extent[0] < niceTickExtent[0]) {
            if (opt.expandToNicedExtent) ticks.push({
                value: $dddb89ade16db3d5$var$roundNumber(niceTickExtent[0] - interval, intervalPrecision)
            });
            else ticks.push({
                value: extent[0]
            });
        }
        var estimateNiceMultiple = function(tickVal, targetTick) {
            return Math.round((targetTick - tickVal) / interval);
        };
        var tick = niceTickExtent[0];
        while(tick <= niceTickExtent[1]){
            ticks.push({
                value: tick
            });
            // Avoid rounding error
            tick = $dddb89ade16db3d5$var$roundNumber(tick + interval, intervalPrecision);
            if (this._brkCtx) {
                var moreMultiple = this._brkCtx.calcNiceTickMultiple(tick, estimateNiceMultiple);
                if (moreMultiple >= 0) tick = $dddb89ade16db3d5$var$roundNumber(tick + moreMultiple * interval, intervalPrecision);
            }
            if (ticks.length > 0 && tick === ticks[ticks.length - 1].value) break;
            if (ticks.length > safeLimit) return [];
        }
        // Consider this case: the last item of ticks is smaller
        // than niceTickExtent[1] and niceTickExtent[1] === extent[1].
        var lastNiceTick = ticks.length ? ticks[ticks.length - 1].value : niceTickExtent[1];
        if (extent[1] > lastNiceTick) {
            if (opt.expandToNicedExtent) ticks.push({
                value: $dddb89ade16db3d5$var$roundNumber(lastNiceTick + interval, intervalPrecision)
            });
            else ticks.push({
                value: extent[1]
            });
        }
        if (scaleBreakHelper) scaleBreakHelper.pruneTicksByBreak(opt.pruneByBreak, ticks, this._brkCtx.breaks, function(item) {
            return item.value;
        }, this._interval, this._extent);
        if (opt.breakTicks !== "none" && scaleBreakHelper) scaleBreakHelper.addBreaksToTicks(ticks, this._brkCtx.breaks, this._extent);
        return ticks;
    };
    IntervalScale.prototype.getMinorTicks = function(splitNumber) {
        var ticks = this.getTicks({
            expandToNicedExtent: true
        });
        // NOTE: In log-scale, do not support minor ticks when breaks exist.
        //  because currently log-scale minor ticks is calculated based on raw values
        //  rather than log-transformed value, due to an odd effect when breaks exist.
        var minorTicks = [];
        var extent = this.getExtent();
        for(var i = 1; i < ticks.length; i++){
            var nextTick = ticks[i];
            var prevTick = ticks[i - 1];
            if (prevTick["break"] || nextTick["break"]) continue;
            var count = 0;
            var minorTicksGroup = [];
            var interval = nextTick.value - prevTick.value;
            var minorInterval = interval / splitNumber;
            var minorIntervalPrecision = $60f7f1f3e3996637$export$86a060b060d3d31a(minorInterval);
            while(count < splitNumber - 1){
                var minorTick = $dddb89ade16db3d5$var$roundNumber(prevTick.value + (count + 1) * minorInterval, minorIntervalPrecision);
                // For the first and last interval. The count may be less than splitNumber.
                if (minorTick > extent[0] && minorTick < extent[1]) minorTicksGroup.push(minorTick);
                count++;
            }
            var scaleBreakHelper = (0, $639a5974fe354f7a$export$e79b20ac82c2d660)();
            scaleBreakHelper && scaleBreakHelper.pruneTicksByBreak("auto", minorTicksGroup, this._getNonTransBreaks(), function(value) {
                return value;
            }, this._interval, extent);
            minorTicks.push(minorTicksGroup);
        }
        return minorTicks;
    };
    IntervalScale.prototype._getNonTransBreaks = function() {
        return this._brkCtx ? this._brkCtx.breaks : [];
    };
    /**
   * @param opt.precision If 'auto', use nice presision.
   * @param opt.pad returns 1.50 but not 1.5 if precision is 2.
   */ IntervalScale.prototype.getLabel = function(data, opt) {
        if (data == null) return "";
        var precision = opt && opt.precision;
        if (precision == null) precision = $cfc1f3b422a3185f$export$e0c74b50bbd10f68(data.value) || 0;
        else if (precision === "auto") // Should be more precise then tick.
        precision = this._intervalPrecision;
        // (1) If `precision` is set, 12.005 should be display as '12.00500'.
        // (2) Use roundNumber (toFixed) to avoid scientific notation like '3.5e-7'.
        var dataNum = $dddb89ade16db3d5$var$roundNumber(data.value, precision, true);
        return $c84c9521536c601a$export$b6fe44657ce35c42(dataNum);
    };
    /**
   * FIXME: refactor - disallow override, use composition instead.
   *
   * The override of `calcNiceTicks` should ensure these members are provided:
   *  this._intervalPrecision
   *  this._interval
   *
   * @param splitNumber By default `5`.
   */ IntervalScale.prototype.calcNiceTicks = function(splitNumber, minInterval, maxInterval) {
        splitNumber = splitNumber || 5;
        var extent = this._extent.slice();
        var span = this._getExtentSpanWithBreaks();
        if (!isFinite(span)) return;
        // User may set axis min 0 and data are all negative
        // FIXME If it needs to reverse ?
        if (span < 0) {
            span = -span;
            extent.reverse();
            this._innerSetExtent(extent[0], extent[1]);
            extent = this._extent.slice();
        }
        var result = $60f7f1f3e3996637$export$eeea879a611eb991(extent, span, splitNumber, minInterval, maxInterval);
        this._intervalPrecision = result.intervalPrecision;
        this._interval = result.interval;
        this._niceExtent = result.niceTickExtent;
    };
    IntervalScale.prototype.calcNiceExtent = function(opt) {
        var extent = this._extent.slice();
        // If extent start and end are same, expand them
        if (extent[0] === extent[1]) {
            if (extent[0] !== 0) {
                // Expand extent
                // Note that extents can be both negative. See #13154
                var expandSize = Math.abs(extent[0]);
                // In the fowllowing case
                //      Axis has been fixed max 100
                //      Plus data are all 100 and axis extent are [100, 100].
                // Extend to the both side will cause expanded max is larger than fixed max.
                // So only expand to the smaller side.
                if (!opt.fixMax) {
                    extent[1] += expandSize / 2;
                    extent[0] -= expandSize / 2;
                } else extent[0] -= expandSize / 2;
            } else extent[1] = 1;
        }
        var span = extent[1] - extent[0];
        // If there are no data and extent are [Infinity, -Infinity]
        if (!isFinite(span)) {
            extent[0] = 0;
            extent[1] = 1;
        }
        this._innerSetExtent(extent[0], extent[1]);
        extent = this._extent.slice();
        this.calcNiceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
        var interval = this._interval;
        var intervalPrecition = this._intervalPrecision;
        if (!opt.fixMin) extent[0] = $dddb89ade16db3d5$var$roundNumber(Math.floor(extent[0] / interval) * interval, intervalPrecition);
        if (!opt.fixMax) extent[1] = $dddb89ade16db3d5$var$roundNumber(Math.ceil(extent[1] / interval) * interval, intervalPrecition);
        this._innerSetExtent(extent[0], extent[1]);
    };
    IntervalScale.prototype.setNiceExtent = function(min, max) {
        this._niceExtent = [
            min,
            max
        ];
    };
    IntervalScale.type = "interval";
    return IntervalScale;
}((0, $1754de95b9b9c398$export$2e2bcd8739ae039));
(0, $1754de95b9b9c398$export$2e2bcd8739ae039).registerClass($dddb89ade16db3d5$var$IntervalScale);
var $dddb89ade16db3d5$export$2e2bcd8739ae039 = $dddb89ade16db3d5$var$IntervalScale;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








// FIXME 公用？
var $7729d7ac367e621c$var$bisect = function(a, x, lo, hi) {
    while(lo < hi){
        var mid = lo + hi >>> 1;
        if (a[mid][1] < x) lo = mid + 1;
        else hi = mid;
    }
    return lo;
};
var $7729d7ac367e621c$var$TimeScale = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TimeScale, _super);
    function TimeScale(settings) {
        var _this = _super.call(this, settings) || this;
        _this.type = "time";
        return _this;
    }
    /**
   * Get label is mainly for other components like dataZoom, tooltip.
   */ TimeScale.prototype.getLabel = function(tick) {
        var useUTC = this.getSetting("useUTC");
        return (0, $0ae0381fb3fd176f$export$d9468344d3651243)(tick.value, (0, $0ae0381fb3fd176f$export$445bdbd8d2334e40)[(0, $0ae0381fb3fd176f$export$124c820721c4f66b)((0, $0ae0381fb3fd176f$export$1da4b91a25d7e1c8)(this._minLevelUnit))] || (0, $0ae0381fb3fd176f$export$445bdbd8d2334e40).second, useUTC, this.getSetting("locale"));
    };
    TimeScale.prototype.getFormattedLabel = function(tick, idx, labelFormatter) {
        var isUTC = this.getSetting("useUTC");
        var lang = this.getSetting("locale");
        return (0, $0ae0381fb3fd176f$export$fe777b6293828b5d)(tick, idx, labelFormatter, lang, isUTC);
    };
    /**
   * @override
   */ TimeScale.prototype.getTicks = function(opt) {
        opt = opt || {};
        var interval = this._interval;
        var extent = this._extent;
        var scaleBreakHelper = (0, $639a5974fe354f7a$export$e79b20ac82c2d660)();
        var ticks = [];
        // If interval is 0, return [];
        if (!interval) return ticks;
        var useUTC = this.getSetting("useUTC");
        if (scaleBreakHelper && opt.breakTicks === "only_break") {
            (0, $639a5974fe354f7a$export$e79b20ac82c2d660)().addBreaksToTicks(ticks, this._brkCtx.breaks, this._extent);
            return ticks;
        }
        var extent0Unit = (0, $0ae0381fb3fd176f$export$4dfb0417ad6555b7)(extent[1], useUTC);
        ticks.push({
            value: extent[0],
            time: {
                level: 0,
                upperTimeUnit: extent0Unit,
                lowerTimeUnit: extent0Unit
            }
        });
        var innerTicks = $7729d7ac367e621c$var$getIntervalTicks(this._minLevelUnit, this._approxInterval, useUTC, extent, this._getExtentSpanWithBreaks(), this._brkCtx);
        ticks = ticks.concat(innerTicks);
        var extent1Unit = (0, $0ae0381fb3fd176f$export$4dfb0417ad6555b7)(extent[1], useUTC);
        ticks.push({
            value: extent[1],
            time: {
                level: 0,
                upperTimeUnit: extent1Unit,
                lowerTimeUnit: extent1Unit
            }
        });
        var isUTC = this.getSetting("useUTC");
        var upperUnitIndex = (0, $0ae0381fb3fd176f$export$87100da04d711986).length - 1;
        var maxLevel = 0;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ticks, function(tick) {
            upperUnitIndex = Math.min(upperUnitIndex, (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)((0, $0ae0381fb3fd176f$export$87100da04d711986), tick.time.upperTimeUnit));
            maxLevel = Math.max(maxLevel, tick.time.level);
        });
        if (scaleBreakHelper) (0, $639a5974fe354f7a$export$e79b20ac82c2d660)().pruneTicksByBreak(opt.pruneByBreak, ticks, this._brkCtx.breaks, function(item) {
            return item.value;
        }, this._approxInterval, this._extent);
        if (scaleBreakHelper && opt.breakTicks !== "none") (0, $639a5974fe354f7a$export$e79b20ac82c2d660)().addBreaksToTicks(ticks, this._brkCtx.breaks, this._extent, function(trimmedBrk) {
            // @see `parseTimeAxisLabelFormatterDictionary`.
            var lowerBrkUnitIndex = Math.max((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)((0, $0ae0381fb3fd176f$export$87100da04d711986), (0, $0ae0381fb3fd176f$export$4dfb0417ad6555b7)(trimmedBrk.vmin, isUTC)), (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)((0, $0ae0381fb3fd176f$export$87100da04d711986), (0, $0ae0381fb3fd176f$export$4dfb0417ad6555b7)(trimmedBrk.vmax, isUTC)));
            var upperBrkUnitIndex = 0;
            for(var unitIdx = 0; unitIdx < (0, $0ae0381fb3fd176f$export$87100da04d711986).length; unitIdx++)if (!$7729d7ac367e621c$var$isPrimaryUnitValueAndGreaterSame((0, $0ae0381fb3fd176f$export$87100da04d711986)[unitIdx], trimmedBrk.vmin, trimmedBrk.vmax, isUTC)) {
                upperBrkUnitIndex = unitIdx;
                break;
            }
            var upperIdx = Math.min(upperBrkUnitIndex, upperUnitIndex);
            var lowerIdx = Math.max(upperIdx, lowerBrkUnitIndex);
            return {
                level: maxLevel,
                lowerTimeUnit: (0, $0ae0381fb3fd176f$export$87100da04d711986)[lowerIdx],
                upperTimeUnit: (0, $0ae0381fb3fd176f$export$87100da04d711986)[upperIdx]
            };
        });
        return ticks;
    };
    TimeScale.prototype.calcNiceExtent = function(opt) {
        var extent = this.getExtent();
        // If extent start and end are same, expand them
        if (extent[0] === extent[1]) {
            // Expand extent
            extent[0] -= (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab);
            extent[1] += (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab);
        }
        // If there are no data and extent are [Infinity, -Infinity]
        if (extent[1] === -Infinity && extent[0] === Infinity) {
            var d = new Date();
            extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
            extent[0] = extent[1] - (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab);
        }
        this._innerSetExtent(extent[0], extent[1]);
        this.calcNiceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
    };
    TimeScale.prototype.calcNiceTicks = function(approxTickNum, minInterval, maxInterval) {
        approxTickNum = approxTickNum || 10;
        var span = this._getExtentSpanWithBreaks();
        this._approxInterval = span / approxTickNum;
        if (minInterval != null && this._approxInterval < minInterval) this._approxInterval = minInterval;
        if (maxInterval != null && this._approxInterval > maxInterval) this._approxInterval = maxInterval;
        var scaleIntervalsLen = $7729d7ac367e621c$var$scaleIntervals.length;
        var idx = Math.min($7729d7ac367e621c$var$bisect($7729d7ac367e621c$var$scaleIntervals, this._approxInterval, 0, scaleIntervalsLen), scaleIntervalsLen - 1);
        // Interval that can be used to calculate ticks
        this._interval = $7729d7ac367e621c$var$scaleIntervals[idx][1];
        this._intervalPrecision = $60f7f1f3e3996637$export$86a060b060d3d31a(this._interval);
        // Min level used when picking ticks from top down.
        // We check one more level to avoid the ticks are to sparse in some case.
        this._minLevelUnit = $7729d7ac367e621c$var$scaleIntervals[Math.max(idx - 1, 0)][0];
    };
    TimeScale.prototype.parse = function(val) {
        // val might be float.
        return (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(val) ? val : +$cfc1f3b422a3185f$export$6b862160d295c8e(val);
    };
    TimeScale.prototype.contain = function(val) {
        return $60f7f1f3e3996637$export$8893e2b90ba10d92(val, this._extent);
    };
    TimeScale.prototype.normalize = function(val) {
        return this._calculator.normalize(val, this._extent);
    };
    TimeScale.prototype.scale = function(val) {
        return this._calculator.scale(val, this._extent);
    };
    TimeScale.type = "time";
    return TimeScale;
}((0, $dddb89ade16db3d5$export$2e2bcd8739ae039));
/**
 * This implementation was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/time/scale.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ var $7729d7ac367e621c$var$scaleIntervals = [
    // Format                           interval
    [
        "second",
        (0, $0ae0381fb3fd176f$export$32c0454ceff7f92d)
    ],
    [
        "minute",
        (0, $0ae0381fb3fd176f$export$35acaebf644db34e)
    ],
    [
        "hour",
        (0, $0ae0381fb3fd176f$export$82541edf19e5e3b0)
    ],
    [
        "quarter-day",
        (0, $0ae0381fb3fd176f$export$82541edf19e5e3b0) * 6
    ],
    [
        "half-day",
        (0, $0ae0381fb3fd176f$export$82541edf19e5e3b0) * 12
    ],
    [
        "day",
        (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab) * 1.2
    ],
    [
        "half-week",
        (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab) * 3.5
    ],
    [
        "week",
        (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab) * 7
    ],
    [
        "month",
        (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab) * 31
    ],
    [
        "quarter",
        (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab) * 95
    ],
    [
        "half-year",
        (0, $0ae0381fb3fd176f$export$99cafda57477293d) / 2
    ],
    [
        "year",
        (0, $0ae0381fb3fd176f$export$99cafda57477293d)
    ] // 1Y
];
function $7729d7ac367e621c$var$isPrimaryUnitValueAndGreaterSame(unit, valueA, valueB, isUTC) {
    return (0, $0ae0381fb3fd176f$export$2ed3384313b02c28)(new Date(valueA), unit, isUTC).getTime() === (0, $0ae0381fb3fd176f$export$2ed3384313b02c28)(new Date(valueB), unit, isUTC).getTime();
}
// function isUnitValueSame(
//     unit: PrimaryTimeUnit,
//     valueA: number,
//     valueB: number,
//     isUTC: boolean
// ): boolean {
//     const dateA = numberUtil.parseDate(valueA) as any;
//     const dateB = numberUtil.parseDate(valueB) as any;
//     const isSame = (unit: PrimaryTimeUnit) => {
//         return getUnitValue(dateA, unit, isUTC)
//             === getUnitValue(dateB, unit, isUTC);
//     };
//     const isSameYear = () => isSame('year');
//     // const isSameHalfYear = () => isSameYear() && isSame('half-year');
//     // const isSameQuater = () => isSameYear() && isSame('quarter');
//     const isSameMonth = () => isSameYear() && isSame('month');
//     const isSameDay = () => isSameMonth() && isSame('day');
//     // const isSameHalfDay = () => isSameDay() && isSame('half-day');
//     const isSameHour = () => isSameDay() && isSame('hour');
//     const isSameMinute = () => isSameHour() && isSame('minute');
//     const isSameSecond = () => isSameMinute() && isSame('second');
//     const isSameMilliSecond = () => isSameSecond() && isSame('millisecond');
//     switch (unit) {
//         case 'year':
//             return isSameYear();
//         case 'month':
//             return isSameMonth();
//         case 'day':
//             return isSameDay();
//         case 'hour':
//             return isSameHour();
//         case 'minute':
//             return isSameMinute();
//         case 'second':
//             return isSameSecond();
//         case 'millisecond':
//             return isSameMilliSecond();
//     }
// }
// const primaryUnitGetters = {
//     year: fullYearGetterName(),
//     month: monthGetterName(),
//     day: dateGetterName(),
//     hour: hoursGetterName(),
//     minute: minutesGetterName(),
//     second: secondsGetterName(),
//     millisecond: millisecondsGetterName()
// };
// const primaryUnitUTCGetters = {
//     year: fullYearGetterName(true),
//     month: monthGetterName(true),
//     day: dateGetterName(true),
//     hour: hoursGetterName(true),
//     minute: minutesGetterName(true),
//     second: secondsGetterName(true),
//     millisecond: millisecondsGetterName(true)
// };
// function moveTick(date: Date, unitName: TimeUnit, step: number, isUTC: boolean) {
//     step = step || 1;
//     switch (getPrimaryTimeUnit(unitName)) {
//         case 'year':
//             date[fullYearSetterName(isUTC)](date[fullYearGetterName(isUTC)]() + step);
//             break;
//         case 'month':
//             date[monthSetterName(isUTC)](date[monthGetterName(isUTC)]() + step);
//             break;
//         case 'day':
//             date[dateSetterName(isUTC)](date[dateGetterName(isUTC)]() + step);
//             break;
//         case 'hour':
//             date[hoursSetterName(isUTC)](date[hoursGetterName(isUTC)]() + step);
//             break;
//         case 'minute':
//             date[minutesSetterName(isUTC)](date[minutesGetterName(isUTC)]() + step);
//             break;
//         case 'second':
//             date[secondsSetterName(isUTC)](date[secondsGetterName(isUTC)]() + step);
//             break;
//         case 'millisecond':
//             date[millisecondsSetterName(isUTC)](date[millisecondsGetterName(isUTC)]() + step);
//             break;
//     }
//     return date.getTime();
// }
// const DATE_INTERVALS = [[8, 7.5], [4, 3.5], [2, 1.5]];
// const MONTH_INTERVALS = [[6, 5.5], [3, 2.5], [2, 1.5]];
// const MINUTES_SECONDS_INTERVALS = [[30, 30], [20, 20], [15, 15], [10, 10], [5, 5], [2, 2]];
function $7729d7ac367e621c$var$getDateInterval(approxInterval, daysInMonth) {
    approxInterval /= (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab);
    return approxInterval > 16 ? 16 : approxInterval > 7.5 ? 7 // TODO week 7 or day 8?
     : approxInterval > 3.5 ? 4 : approxInterval > 1.5 ? 2 : 1;
}
function $7729d7ac367e621c$var$getMonthInterval(approxInterval) {
    var APPROX_ONE_MONTH = 30 * (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab);
    approxInterval /= APPROX_ONE_MONTH;
    return approxInterval > 6 ? 6 : approxInterval > 3 ? 3 : approxInterval > 2 ? 2 : 1;
}
function $7729d7ac367e621c$var$getHourInterval(approxInterval) {
    approxInterval /= (0, $0ae0381fb3fd176f$export$82541edf19e5e3b0);
    return approxInterval > 12 ? 12 : approxInterval > 6 ? 6 : approxInterval > 3.5 ? 4 : approxInterval > 2 ? 2 : 1;
}
function $7729d7ac367e621c$var$getMinutesAndSecondsInterval(approxInterval, isMinutes) {
    approxInterval /= isMinutes ? (0, $0ae0381fb3fd176f$export$35acaebf644db34e) : (0, $0ae0381fb3fd176f$export$32c0454ceff7f92d);
    return approxInterval > 30 ? 30 : approxInterval > 20 ? 20 : approxInterval > 15 ? 15 : approxInterval > 10 ? 10 : approxInterval > 5 ? 5 : approxInterval > 2 ? 2 : 1;
}
function $7729d7ac367e621c$var$getMillisecondsInterval(approxInterval) {
    return $cfc1f3b422a3185f$export$7a695fe44258210b(approxInterval, true);
}
// e.g., if the input unit is 'day', start calculate ticks from the first day of
// that month to make ticks "nice".
function $7729d7ac367e621c$var$getFirstTimestampOfUnit(timestamp, unitName, isUTC) {
    var upperUnitIdx = Math.max(0, (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)((0, $0ae0381fb3fd176f$export$87100da04d711986), unitName) - 1);
    return (0, $0ae0381fb3fd176f$export$2ed3384313b02c28)(new Date(timestamp), (0, $0ae0381fb3fd176f$export$87100da04d711986)[upperUnitIdx], isUTC).getTime();
}
function $7729d7ac367e621c$var$createEstimateNiceMultiple(setMethodName, dateMethodInterval) {
    var tmpDate = new Date(0);
    tmpDate[setMethodName](1);
    var tmpTime = tmpDate.getTime();
    tmpDate[setMethodName](1 + dateMethodInterval);
    var approxTimeInterval = tmpDate.getTime() - tmpTime;
    return function(tickVal, targetValue) {
        // Only in month that accurate result can not get by division of
        // timestamp interval, but no need accurate here.
        return Math.max(0, Math.round((targetValue - tickVal) / approxTimeInterval));
    };
}
function $7729d7ac367e621c$var$getIntervalTicks(bottomUnitName, approxInterval, isUTC, extent, extentSpanWithBreaks, brkCtx) {
    var safeLimit = 10000;
    var unitNames = (0, $0ae0381fb3fd176f$export$833c398a55654bb7);
    var iter = 0;
    function addTicksInSpan(interval, minTimestamp, maxTimestamp, getMethodName, setMethodName, isDate, out) {
        var estimateNiceMultiple = $7729d7ac367e621c$var$createEstimateNiceMultiple(setMethodName, interval);
        var dateTime = minTimestamp;
        var date = new Date(dateTime);
        // if (isDate) {
        //     d -= 1; // Starts with 0;   PENDING
        // }
        while(dateTime < maxTimestamp && dateTime <= extent[1]){
            out.push({
                value: dateTime
            });
            if (iter++ > safeLimit) break;
            date[setMethodName](date[getMethodName]() + interval);
            dateTime = date.getTime();
            if (brkCtx) {
                var moreMultiple = brkCtx.calcNiceTickMultiple(dateTime, estimateNiceMultiple);
                if (moreMultiple > 0) {
                    date[setMethodName](date[getMethodName]() + moreMultiple * interval);
                    dateTime = date.getTime();
                }
            }
        }
        // This extra tick is for calcuating ticks of next level. Will not been added to the final result
        out.push({
            value: dateTime,
            notAdd: true
        });
    }
    function addLevelTicks(unitName, lastLevelTicks, levelTicks) {
        var newAddedTicks = [];
        var isFirstLevel = !lastLevelTicks.length;
        if ($7729d7ac367e621c$var$isPrimaryUnitValueAndGreaterSame((0, $0ae0381fb3fd176f$export$1da4b91a25d7e1c8)(unitName), extent[0], extent[1], isUTC)) return;
        if (isFirstLevel) lastLevelTicks = [
            {
                value: $7729d7ac367e621c$var$getFirstTimestampOfUnit(extent[0], unitName, isUTC)
            },
            {
                value: extent[1]
            }
        ];
        for(var i = 0; i < lastLevelTicks.length - 1; i++){
            var startTick = lastLevelTicks[i].value;
            var endTick = lastLevelTicks[i + 1].value;
            if (startTick === endTick) continue;
            var interval = void 0;
            var getterName = void 0;
            var setterName = void 0;
            var isDate = false;
            switch(unitName){
                case "year":
                    interval = Math.max(1, Math.round(approxInterval / (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab) / 365));
                    getterName = (0, $0ae0381fb3fd176f$export$8d046fefed9a548e)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$43fbeac90913b151)(isUTC);
                    break;
                case "half-year":
                case "quarter":
                case "month":
                    interval = $7729d7ac367e621c$var$getMonthInterval(approxInterval);
                    getterName = (0, $0ae0381fb3fd176f$export$5c242a801a23eec7)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$233f59998ed71c09)(isUTC);
                    break;
                case "week":
                case "half-week":
                case "day":
                    interval = $7729d7ac367e621c$var$getDateInterval(approxInterval, 31); // Use 32 days and let interval been 16
                    getterName = (0, $0ae0381fb3fd176f$export$4189e6cbc9753260)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$82fd379a67f37fa0)(isUTC);
                    isDate = true;
                    break;
                case "half-day":
                case "quarter-day":
                case "hour":
                    interval = $7729d7ac367e621c$var$getHourInterval(approxInterval);
                    getterName = (0, $0ae0381fb3fd176f$export$8b40b55b3c06cbe2)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$b6f943e8d23c15bb)(isUTC);
                    break;
                case "minute":
                    interval = $7729d7ac367e621c$var$getMinutesAndSecondsInterval(approxInterval, true);
                    getterName = (0, $0ae0381fb3fd176f$export$8807847c5c71eded)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$50303078793fc7d)(isUTC);
                    break;
                case "second":
                    interval = $7729d7ac367e621c$var$getMinutesAndSecondsInterval(approxInterval, false);
                    getterName = (0, $0ae0381fb3fd176f$export$8f49e73e2eebd168)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$a4a908acda9c3118)(isUTC);
                    break;
                case "millisecond":
                    interval = $7729d7ac367e621c$var$getMillisecondsInterval(approxInterval);
                    getterName = (0, $0ae0381fb3fd176f$export$312207a92d041116)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$c047afab75f6d84)(isUTC);
                    break;
            }
            // Notice: This expansion by `getFirstTimestampOfUnit` may cause too many ticks and
            // iteration. e.g., when three levels of ticks is displayed, which can be caused by
            // data zoom and axis breaks. Thus trim them here.
            if (endTick >= extent[0] && startTick <= extent[1]) addTicksInSpan(interval, startTick, endTick, getterName, setterName, isDate, newAddedTicks);
            if (unitName === "year" && levelTicks.length > 1 && i === 0) // Add nearest years to the left extent.
            levelTicks.unshift({
                value: levelTicks[0].value - interval
            });
        }
        for(var i = 0; i < newAddedTicks.length; i++)levelTicks.push(newAddedTicks[i]);
    }
    var levelsTicks = [];
    var currentLevelTicks = [];
    var tickCount = 0;
    var lastLevelTickCount = 0;
    for(var i = 0; i < unitNames.length; ++i){
        var primaryTimeUnit = (0, $0ae0381fb3fd176f$export$1da4b91a25d7e1c8)(unitNames[i]);
        if (!(0, $0ae0381fb3fd176f$export$beb5920b69c13da)(unitNames[i])) continue;
        addLevelTicks(unitNames[i], levelsTicks[levelsTicks.length - 1] || [], currentLevelTicks);
        var nextPrimaryTimeUnit = unitNames[i + 1] ? (0, $0ae0381fb3fd176f$export$1da4b91a25d7e1c8)(unitNames[i + 1]) : null;
        if (primaryTimeUnit !== nextPrimaryTimeUnit) {
            if (currentLevelTicks.length) {
                lastLevelTickCount = tickCount;
                // Remove the duplicate so the tick count can be precisely.
                currentLevelTicks.sort(function(a, b) {
                    return a.value - b.value;
                });
                var levelTicksRemoveDuplicated = [];
                for(var i_1 = 0; i_1 < currentLevelTicks.length; ++i_1){
                    var tickValue = currentLevelTicks[i_1].value;
                    if (i_1 === 0 || currentLevelTicks[i_1 - 1].value !== tickValue) {
                        levelTicksRemoveDuplicated.push(currentLevelTicks[i_1]);
                        if (tickValue >= extent[0] && tickValue <= extent[1]) tickCount++;
                    }
                }
                var targetTickNum = extentSpanWithBreaks / approxInterval;
                // Added too much in this level and not too less in last level
                if (tickCount > targetTickNum * 1.5 && lastLevelTickCount > targetTickNum / 1.5) break;
                // Only treat primary time unit as one level.
                levelsTicks.push(levelTicksRemoveDuplicated);
                if (tickCount > targetTickNum || bottomUnitName === unitNames[i]) break;
            }
            // Reset if next unitName is primary
            currentLevelTicks = [];
        }
    }
    var levelsTicksInExtent = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(levelsTicks, function(levelTicks) {
        return (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(levelTicks, function(tick) {
            return tick.value >= extent[0] && tick.value <= extent[1] && !tick.notAdd;
        });
    }), function(levelTicks) {
        return levelTicks.length > 0;
    });
    var ticks = [];
    var maxLevel = levelsTicksInExtent.length - 1;
    for(var i = 0; i < levelsTicksInExtent.length; ++i){
        var levelTicks = levelsTicksInExtent[i];
        for(var k = 0; k < levelTicks.length; ++k){
            var unit = (0, $0ae0381fb3fd176f$export$4dfb0417ad6555b7)(levelTicks[k].value, isUTC);
            ticks.push({
                value: levelTicks[k].value,
                time: {
                    level: maxLevel - i,
                    upperTimeUnit: unit,
                    lowerTimeUnit: unit
                }
            });
        }
    }
    ticks.sort(function(a, b) {
        return a.value - b.value;
    });
    // Remove duplicates
    var result = [];
    for(var i = 0; i < ticks.length; ++i)if (i === 0 || ticks[i].value !== ticks[i - 1].value) result.push(ticks[i]);
    return result;
}
(0, $1754de95b9b9c398$export$2e2bcd8739ae039).registerClass($7729d7ac367e621c$var$TimeScale);
var $7729d7ac367e621c$export$2e2bcd8739ae039 = $7729d7ac367e621c$var$TimeScale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $ae24d1f3a7f905fc$var$fixRound = $cfc1f3b422a3185f$export$2077e0241d6afd3c;
var $ae24d1f3a7f905fc$var$mathFloor = Math.floor;
var $ae24d1f3a7f905fc$var$mathCeil = Math.ceil;
var $ae24d1f3a7f905fc$var$mathPow = Math.pow;
var $ae24d1f3a7f905fc$var$mathLog = Math.log;
var $ae24d1f3a7f905fc$var$LogScale = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LogScale, _super);
    function LogScale() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "log";
        _this.base = 10;
        _this._originalScale = new (0, $dddb89ade16db3d5$export$2e2bcd8739ae039)();
        return _this;
    }
    /**
   * @param Whether expand the ticks to niced extent.
   */ LogScale.prototype.getTicks = function(opt) {
        opt = opt || {};
        var extent = this._extent.slice();
        var originalExtent = this._originalScale.getExtent();
        var ticks = _super.prototype.getTicks.call(this, opt);
        var base = this.base;
        var originalBreaks = this._originalScale._innerGetBreaks();
        var scaleBreakHelper = (0, $639a5974fe354f7a$export$e79b20ac82c2d660)();
        return $7a1bd9c2710fea0d$export$871de8747c9eaa88(ticks, function(tick) {
            var val = tick.value;
            var roundingCriterion = null;
            var powVal = $ae24d1f3a7f905fc$var$mathPow(base, val);
            // Fix #4158
            if (val === extent[0] && this._fixMin) roundingCriterion = originalExtent[0];
            else if (val === extent[1] && this._fixMax) roundingCriterion = originalExtent[1];
            var vBreak;
            if (scaleBreakHelper) {
                var transformed = scaleBreakHelper.getTicksLogTransformBreak(tick, base, originalBreaks, $ae24d1f3a7f905fc$var$fixRoundingError);
                vBreak = transformed.vBreak;
                if (roundingCriterion == null) roundingCriterion = transformed.brkRoundingCriterion;
            }
            if (roundingCriterion != null) powVal = $ae24d1f3a7f905fc$var$fixRoundingError(powVal, roundingCriterion);
            return {
                value: powVal,
                "break": vBreak
            };
        }, this);
    };
    LogScale.prototype._getNonTransBreaks = function() {
        return this._originalScale._innerGetBreaks();
    };
    LogScale.prototype.setExtent = function(start, end) {
        this._originalScale.setExtent(start, end);
        var loggedExtent = (0, $60f7f1f3e3996637$export$a6588cdf5be114b3)(this.base, [
            start,
            end
        ]);
        _super.prototype.setExtent.call(this, loggedExtent[0], loggedExtent[1]);
    };
    /**
   * @return {number} end
   */ LogScale.prototype.getExtent = function() {
        var base = this.base;
        var extent = _super.prototype.getExtent.call(this);
        extent[0] = $ae24d1f3a7f905fc$var$mathPow(base, extent[0]);
        extent[1] = $ae24d1f3a7f905fc$var$mathPow(base, extent[1]);
        // Fix #4158
        var originalExtent = this._originalScale.getExtent();
        this._fixMin && (extent[0] = $ae24d1f3a7f905fc$var$fixRoundingError(extent[0], originalExtent[0]));
        this._fixMax && (extent[1] = $ae24d1f3a7f905fc$var$fixRoundingError(extent[1], originalExtent[1]));
        return extent;
    };
    LogScale.prototype.unionExtentFromData = function(data, dim) {
        this._originalScale.unionExtentFromData(data, dim);
        var loggedOther = (0, $60f7f1f3e3996637$export$a6588cdf5be114b3)(this.base, data.getApproximateExtent(dim), true);
        this._innerUnionExtent(loggedOther);
    };
    /**
   * Update interval and extent of intervals for nice ticks
   * @param approxTickNum default 10 Given approx tick number
   */ LogScale.prototype.calcNiceTicks = function(approxTickNum) {
        approxTickNum = approxTickNum || 10;
        var extent = this._extent.slice();
        var span = this._getExtentSpanWithBreaks();
        if (!isFinite(span) || span <= 0) return;
        var interval = $cfc1f3b422a3185f$export$82dd68b83a44b253(span);
        var err = approxTickNum / span * interval;
        // Filter ticks to get closer to the desired count.
        if (err <= 0.5) interval *= 10;
        // Interval should be integer
        while(!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0)interval *= 10;
        var niceExtent = [
            $ae24d1f3a7f905fc$var$fixRound($ae24d1f3a7f905fc$var$mathCeil(extent[0] / interval) * interval),
            $ae24d1f3a7f905fc$var$fixRound($ae24d1f3a7f905fc$var$mathFloor(extent[1] / interval) * interval)
        ];
        this._interval = interval;
        this._intervalPrecision = (0, $60f7f1f3e3996637$export$86a060b060d3d31a)(interval);
        this._niceExtent = niceExtent;
    };
    LogScale.prototype.calcNiceExtent = function(opt) {
        _super.prototype.calcNiceExtent.call(this, opt);
        this._fixMin = opt.fixMin;
        this._fixMax = opt.fixMax;
    };
    LogScale.prototype.contain = function(val) {
        val = $ae24d1f3a7f905fc$var$mathLog(val) / $ae24d1f3a7f905fc$var$mathLog(this.base);
        return _super.prototype.contain.call(this, val);
    };
    LogScale.prototype.normalize = function(val) {
        val = $ae24d1f3a7f905fc$var$mathLog(val) / $ae24d1f3a7f905fc$var$mathLog(this.base);
        return _super.prototype.normalize.call(this, val);
    };
    LogScale.prototype.scale = function(val) {
        val = _super.prototype.scale.call(this, val);
        return $ae24d1f3a7f905fc$var$mathPow(this.base, val);
    };
    LogScale.prototype.setBreaksFromOption = function(breakOptionList) {
        var scaleBreakHelper = (0, $639a5974fe354f7a$export$e79b20ac82c2d660)();
        if (!scaleBreakHelper) return;
        var _a = scaleBreakHelper.logarithmicParseBreaksFromOption(breakOptionList, this.base, $7a1bd9c2710fea0d$export$2385a24977818dd0(this.parse, this)), parsedOriginal = _a.parsedOriginal, parsedLogged = _a.parsedLogged;
        this._originalScale._innerSetBreak(parsedOriginal);
        this._innerSetBreak(parsedLogged);
    };
    LogScale.type = "log";
    return LogScale;
}((0, $dddb89ade16db3d5$export$2e2bcd8739ae039));
function $ae24d1f3a7f905fc$var$fixRoundingError(val, originalVal) {
    return $ae24d1f3a7f905fc$var$fixRound(val, $cfc1f3b422a3185f$export$e0c74b50bbd10f68(originalVal));
}
(0, $1754de95b9b9c398$export$2e2bcd8739ae039).registerClass($ae24d1f3a7f905fc$var$LogScale);
var $ae24d1f3a7f905fc$export$2e2bcd8739ae039 = $ae24d1f3a7f905fc$var$LogScale;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $483be9695e74220c$export$c35454f678e99c82 = /** @class */ function() {
    function ScaleRawExtentInfo(scale, model, // Usually: data extent from all series on this axis.
    originalExtent) {
        this._prepareParams(scale, model, originalExtent);
    }
    /**
   * Parameters depending on outside (like model, user callback)
   * are prepared and fixed here.
   */ ScaleRawExtentInfo.prototype._prepareParams = function(scale, model, // Usually: data extent from all series on this axis.
    dataExtent) {
        if (dataExtent[1] < dataExtent[0]) dataExtent = [
            NaN,
            NaN
        ];
        this._dataMin = dataExtent[0];
        this._dataMax = dataExtent[1];
        var isOrdinal = this._isOrdinal = scale.type === "ordinal";
        this._needCrossZero = scale.type === "interval" && model.getNeedCrossZero && model.getNeedCrossZero();
        var axisMinValue = model.get("min", true);
        if (axisMinValue == null) axisMinValue = model.get("startValue", true);
        var modelMinRaw = this._modelMinRaw = axisMinValue;
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(modelMinRaw)) // This callback always provides users the full data extent (before data is filtered).
        this._modelMinNum = $483be9695e74220c$export$d02f2e65dfc3c2b(scale, modelMinRaw({
            min: dataExtent[0],
            max: dataExtent[1]
        }));
        else if (modelMinRaw !== "dataMin") this._modelMinNum = $483be9695e74220c$export$d02f2e65dfc3c2b(scale, modelMinRaw);
        var modelMaxRaw = this._modelMaxRaw = model.get("max", true);
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(modelMaxRaw)) // This callback always provides users the full data extent (before data is filtered).
        this._modelMaxNum = $483be9695e74220c$export$d02f2e65dfc3c2b(scale, modelMaxRaw({
            min: dataExtent[0],
            max: dataExtent[1]
        }));
        else if (modelMaxRaw !== "dataMax") this._modelMaxNum = $483be9695e74220c$export$d02f2e65dfc3c2b(scale, modelMaxRaw);
        if (isOrdinal) // FIXME: there is a flaw here: if there is no "block" data processor like `dataZoom`,
        // and progressive rendering is using, here the category result might just only contain
        // the processed chunk rather than the entire result.
        this._axisDataLen = model.getCategories().length;
        else {
            var boundaryGap = model.get("boundaryGap");
            var boundaryGapArr = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(boundaryGap) ? boundaryGap : [
                boundaryGap || 0,
                boundaryGap || 0
            ];
            if (typeof boundaryGapArr[0] === "boolean" || typeof boundaryGapArr[1] === "boolean") this._boundaryGapInner = [
                0,
                0
            ];
            else this._boundaryGapInner = [
                (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(boundaryGapArr[0], 1),
                (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(boundaryGapArr[1], 1)
            ];
        }
    };
    /**
   * Calculate extent by prepared parameters.
   * This method has no external dependency and can be called duplicatedly,
   * getting the same result.
   * If parameters changed, should call this method to recalcuate.
   */ ScaleRawExtentInfo.prototype.calculate = function() {
        // Notice: When min/max is not set (that is, when there are null/undefined,
        // which is the most common case), these cases should be ensured:
        // (1) For 'ordinal', show all axis.data.
        // (2) For others:
        //      + `boundaryGap` is applied (if min/max set, boundaryGap is
        //      disabled).
        //      + If `needCrossZero`, min/max should be zero, otherwise, min/max should
        //      be the result that originalExtent enlarged by boundaryGap.
        // (3) If no data, it should be ensured that `scale.setBlank` is set.
        var isOrdinal = this._isOrdinal;
        var dataMin = this._dataMin;
        var dataMax = this._dataMax;
        var axisDataLen = this._axisDataLen;
        var boundaryGapInner = this._boundaryGapInner;
        var span = !isOrdinal ? dataMax - dataMin || Math.abs(dataMin) : null;
        // Currently if a `'value'` axis model min is specified as 'dataMin'/'dataMax',
        // `boundaryGap` will not be used. It's the different from specifying as `null`/`undefined`.
        var min = this._modelMinRaw === "dataMin" ? dataMin : this._modelMinNum;
        var max = this._modelMaxRaw === "dataMax" ? dataMax : this._modelMaxNum;
        // If `_modelMinNum`/`_modelMaxNum` is `null`/`undefined`, should not be fixed.
        var minFixed = min != null;
        var maxFixed = max != null;
        if (min == null) min = isOrdinal ? axisDataLen ? 0 : NaN : dataMin - boundaryGapInner[0] * span;
        if (max == null) max = isOrdinal ? axisDataLen ? axisDataLen - 1 : NaN : dataMax + boundaryGapInner[1] * span;
        (min == null || !isFinite(min)) && (min = NaN);
        (max == null || !isFinite(max)) && (max = NaN);
        var isBlank = (0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(min) || (0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(max) || isOrdinal && !axisDataLen;
        // If data extent modified, need to recalculated to ensure cross zero.
        if (this._needCrossZero) {
            // Axis is over zero and min is not set
            if (min > 0 && max > 0 && !minFixed) min = 0;
            // Axis is under zero and max is not set
            if (min < 0 && max < 0 && !maxFixed) max = 0;
        // PENDING:
        // When `needCrossZero` and all data is positive/negative, should it be ensured
        // that the results processed by boundaryGap are positive/negative?
        // If so, here `minFixed`/`maxFixed` need to be set.
        }
        var determinedMin = this._determinedMin;
        var determinedMax = this._determinedMax;
        if (determinedMin != null) {
            min = determinedMin;
            minFixed = true;
        }
        if (determinedMax != null) {
            max = determinedMax;
            maxFixed = true;
        }
        // Ensure min/max be finite number or NaN here. (not to be null/undefined)
        // `NaN` means min/max axis is blank.
        return {
            min: min,
            max: max,
            minFixed: minFixed,
            maxFixed: maxFixed,
            isBlank: isBlank
        };
    };
    ScaleRawExtentInfo.prototype.modifyDataMinMax = function(minMaxName, val) {
        this[$483be9695e74220c$var$DATA_MIN_MAX_ATTR[minMaxName]] = val;
    };
    ScaleRawExtentInfo.prototype.setDeterminedMinMax = function(minMaxName, val) {
        var attr = $483be9695e74220c$var$DETERMINED_MIN_MAX_ATTR[minMaxName];
        this[attr] = val;
    };
    ScaleRawExtentInfo.prototype.freeze = function() {
        // @ts-ignore
        this.frozen = true;
    };
    return ScaleRawExtentInfo;
}();
var $483be9695e74220c$var$DETERMINED_MIN_MAX_ATTR = {
    min: "_determinedMin",
    max: "_determinedMax"
};
var $483be9695e74220c$var$DATA_MIN_MAX_ATTR = {
    min: "_dataMin",
    max: "_dataMax"
};
function $483be9695e74220c$export$5c3dbcbeb9ce7f5a(scale, model, // Usually: data extent from all series on this axis.
originalExtent) {
    // Do not permit to recreate.
    var rawExtentInfo = scale.rawExtentInfo;
    if (rawExtentInfo) return rawExtentInfo;
    rawExtentInfo = new $483be9695e74220c$export$c35454f678e99c82(scale, model, originalExtent);
    // @ts-ignore
    scale.rawExtentInfo = rawExtentInfo;
    return rawExtentInfo;
}
function $483be9695e74220c$export$d02f2e65dfc3c2b(scale, minMax) {
    return minMax == null ? null : (0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(minMax) ? NaN : scale.parse(minMax);
}





function $2d646e51cc34f840$export$9c0ba8df7eb7b328(scale, model) {
    var scaleType = scale.type;
    var rawExtentResult = (0, $483be9695e74220c$export$5c3dbcbeb9ce7f5a)(scale, model, scale.getExtent()).calculate();
    scale.setBlank(rawExtentResult.isBlank);
    var min = rawExtentResult.min;
    var max = rawExtentResult.max;
    // If bars are placed on a base axis of type time or interval account for axis boundary overflow and current axis
    // is base axis
    // FIXME
    // (1) Consider support value axis, where below zero and axis `onZero` should be handled properly.
    // (2) Refactor the logic with `barGrid`. Is it not need to `makeBarWidthAndOffsetInfo` twice with different extent?
    //     Should not depend on series type `bar`?
    // (3) Fix that might overlap when using dataZoom.
    // (4) Consider other chart types using `barGrid`?
    // See #6728, #4862, `test/bar-overflow-time-plot.html`
    var ecModel = model.ecModel;
    if (ecModel && scaleType === "time" /* || scaleType === 'interval' */ ) {
        var barSeriesModels = (0, $361c48dd900de28f$export$efbd0c3f5ab0d5e4)("bar", ecModel);
        var isBaseAxisAndHasBarSeries_1 = false;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(barSeriesModels, function(seriesModel) {
            isBaseAxisAndHasBarSeries_1 = isBaseAxisAndHasBarSeries_1 || seriesModel.getBaseAxis() === model.axis;
        });
        if (isBaseAxisAndHasBarSeries_1) {
            // Calculate placement of bars on axis. TODO should be decoupled
            // with barLayout
            var barWidthAndOffset = (0, $361c48dd900de28f$export$20769dafc84e0299)(barSeriesModels);
            // Adjust axis min and max to account for overflow
            var adjustedScale = $2d646e51cc34f840$var$adjustScaleForOverflow(min, max, model, barWidthAndOffset);
            min = adjustedScale.min;
            max = adjustedScale.max;
        }
    }
    return {
        extent: [
            min,
            max
        ],
        // "fix" means "fixed", the value should not be
        // changed in the subsequent steps.
        fixMin: rawExtentResult.minFixed,
        fixMax: rawExtentResult.maxFixed
    };
}
function $2d646e51cc34f840$var$adjustScaleForOverflow(min, max, model, // Only support cartesian coord yet.
barWidthAndOffset) {
    // Get Axis Length
    var axisExtent = model.axis.getExtent();
    var axisLength = Math.abs(axisExtent[1] - axisExtent[0]);
    // Get bars on current base axis and calculate min and max overflow
    var barsOnCurrentAxis = (0, $361c48dd900de28f$export$35920bb6556da1c2)(barWidthAndOffset, model.axis);
    if (barsOnCurrentAxis === undefined) return {
        min: min,
        max: max
    };
    var minOverflow = Infinity;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(barsOnCurrentAxis, function(item) {
        minOverflow = Math.min(item.offset, minOverflow);
    });
    var maxOverflow = -Infinity;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(barsOnCurrentAxis, function(item) {
        maxOverflow = Math.max(item.offset + item.width, maxOverflow);
    });
    minOverflow = Math.abs(minOverflow);
    maxOverflow = Math.abs(maxOverflow);
    var totalOverFlow = minOverflow + maxOverflow;
    // Calculate required buffer based on old range and overflow
    var oldRange = max - min;
    var oldRangePercentOfNew = 1 - (minOverflow + maxOverflow) / axisLength;
    var overflowBuffer = oldRange / oldRangePercentOfNew - oldRange;
    max += overflowBuffer * (maxOverflow / totalOverFlow);
    min -= overflowBuffer * (minOverflow / totalOverFlow);
    return {
        min: min,
        max: max
    };
}
function $2d646e51cc34f840$export$51f3e70a54405d5a(scale, inModel) {
    var model = inModel;
    var extentInfo = $2d646e51cc34f840$export$9c0ba8df7eb7b328(scale, model);
    var extent = extentInfo.extent;
    var splitNumber = model.get("splitNumber");
    if (scale instanceof (0, $ae24d1f3a7f905fc$export$2e2bcd8739ae039)) scale.base = model.get("logBase");
    var scaleType = scale.type;
    var interval = model.get("interval");
    var isIntervalOrTime = scaleType === "interval" || scaleType === "time";
    scale.setBreaksFromOption($2d646e51cc34f840$export$8094779d9b724f85(model));
    scale.setExtent(extent[0], extent[1]);
    scale.calcNiceExtent({
        splitNumber: splitNumber,
        fixMin: extentInfo.fixMin,
        fixMax: extentInfo.fixMax,
        minInterval: isIntervalOrTime ? model.get("minInterval") : null,
        maxInterval: isIntervalOrTime ? model.get("maxInterval") : null
    });
    // If some one specified the min, max. And the default calculated interval
    // is not good enough. He can specify the interval. It is often appeared
    // in angle axis with angle 0 - 360. Interval calculated in interval scale is hard
    // to be 60.
    // FIXME
    if (interval != null) scale.setInterval && scale.setInterval(interval);
}
function $2d646e51cc34f840$export$8941c4cacdc8f5a5(model, axisType) {
    axisType = axisType || model.get("type");
    if (axisType) switch(axisType){
        // Buildin scale
        case "category":
            return new (0, $6e82606ec775d365$export$2e2bcd8739ae039)({
                ordinalMeta: model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(),
                extent: [
                    Infinity,
                    -Infinity
                ]
            });
        case "time":
            return new (0, $7729d7ac367e621c$export$2e2bcd8739ae039)({
                locale: model.ecModel.getLocaleModel(),
                useUTC: model.ecModel.get("useUTC")
            });
        default:
            // case 'value'/'interval', 'log', or others.
            return new ((0, $1754de95b9b9c398$export$2e2bcd8739ae039).getClass(axisType) || (0, $dddb89ade16db3d5$export$2e2bcd8739ae039))();
    }
}
function $2d646e51cc34f840$export$3eac36a69f37d52(axis) {
    var dataExtent = axis.scale.getExtent();
    var min = dataExtent[0];
    var max = dataExtent[1];
    return !(min > 0 && max > 0 || min < 0 && max < 0);
}
function $2d646e51cc34f840$export$742f19a75415b2ae(axis) {
    var labelFormatter = axis.getLabelModel().get("formatter");
    if (axis.type === "time") {
        var parsed_1 = (0, $0ae0381fb3fd176f$export$f16a827770bdffb5)(labelFormatter);
        return function(tick, idx) {
            return axis.scale.getFormattedLabel(tick, idx, parsed_1);
        };
    } else if ($7a1bd9c2710fea0d$export$844ec244b1367d54(labelFormatter)) return function(tick) {
        // For category axis, get raw value; for numeric axis,
        // get formatted label like '1,333,444'.
        var label = axis.scale.getLabel(tick);
        var text = labelFormatter.replace("{value}", label != null ? label : "");
        return text;
    };
    else if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(labelFormatter)) {
        if (axis.type === "category") return function(tick, idx) {
            // The original intention of `idx` is "the index of the tick in all ticks".
            // But the previous implementation of category axis do not consider the
            // `axisLabel.interval`, which cause that, for example, the `interval` is
            // `1`, then the ticks "name5", "name7", "name9" are displayed, where the
            // corresponding `idx` are `0`, `2`, `4`, but not `0`, `1`, `2`. So we keep
            // the definition here for back compatibility.
            return labelFormatter($2d646e51cc34f840$export$a5a32f324c1fa457(axis, tick), tick.value - axis.scale.getExtent()[0], null // Using `null` just for backward compat.
            );
        };
        var scaleBreakHelper_1 = (0, $639a5974fe354f7a$export$e79b20ac82c2d660)();
        return function(tick, idx) {
            // Using `null` just for backward compat. It's been found that in the `test/axis-customTicks.html`,
            // there is a formatter `function (value, index, revers = true) { ... }`. Although the third param
            // `revers` is incorrect and always `null`, changing it might introduce a breaking change.
            var extra = null;
            if (scaleBreakHelper_1) extra = scaleBreakHelper_1.makeAxisLabelFormatterParamBreak(extra, tick["break"]);
            return labelFormatter($2d646e51cc34f840$export$a5a32f324c1fa457(axis, tick), idx, extra);
        };
    } else return function(tick) {
        return axis.scale.getLabel(tick);
    };
}
function $2d646e51cc34f840$export$a5a32f324c1fa457(axis, tick) {
    // In category axis with data zoom, tick is not the original
    // index of axis.data. So tick should not be exposed to user
    // in category axis.
    return axis.type === "category" ? axis.scale.getLabel(tick) : tick.value;
}
function $2d646e51cc34f840$export$6d0bc2429155c088(model) {
    var interval = model.get("interval");
    return interval == null ? "auto" : interval;
}
function $2d646e51cc34f840$export$c2911c025243d6a6(axis) {
    return axis.type === "category" && $2d646e51cc34f840$export$6d0bc2429155c088(axis.getLabelModel()) === 0;
}
function $2d646e51cc34f840$export$e4cf30b1e74cd69d(data, axisDim) {
    // Remove duplicated dat dimensions caused by `getStackedDimension`.
    var dataDimMap = {};
    // Currently `mapDimensionsAll` will contain stack result dimension ('__\0ecstackresult').
    // PENDING: is it reasonable? Do we need to remove the original dim from "coord dim" since
    // there has been stacked result dim?
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(data.mapDimensionsAll(axisDim), function(dataDim) {
        // For example, the extent of the original dimension
        // is [0.1, 0.5], the extent of the `stackResultDimension`
        // is [7, 9], the final extent should NOT include [0.1, 0.5],
        // because there is no graphic corresponding to [0.1, 0.5].
        // See the case in `test/area-stack.html` `main1`, where area line
        // stack needs `yAxis` not start from 0.
        dataDimMap[(0, $efdd976e4917927c$export$909db2be4938fbdf)(data, dataDim)] = true;
    });
    return $7a1bd9c2710fea0d$export$ed97f33186d4b816(dataDimMap);
}
function $2d646e51cc34f840$export$635fe7f20d0f4c70(dataExtent, data, axisDim) {
    if (data) $7a1bd9c2710fea0d$export$79b2f7037acddd43($2d646e51cc34f840$export$e4cf30b1e74cd69d(data, axisDim), function(dim) {
        var seriesExtent = data.getApproximateExtent(dim);
        seriesExtent[0] < dataExtent[0] && (dataExtent[0] = seriesExtent[0]);
        seriesExtent[1] > dataExtent[1] && (dataExtent[1] = seriesExtent[1]);
    });
}
function $2d646e51cc34f840$export$c06aa22293dea9d2(nameLocation) {
    return nameLocation === "middle" || nameLocation === "center";
}
function $2d646e51cc34f840$export$75b737736393e03c(axisModel) {
    return axisModel.getShallow("show");
}
function $2d646e51cc34f840$export$8094779d9b724f85(model) {
    var option = model.get("breaks", true);
    if (option != null) {
        if (!(0, $639a5974fe354f7a$export$e79b20ac82c2d660)()) return undefined;
        if (!$2d646e51cc34f840$var$isSupportAxisBreak(model.axis)) return undefined;
        return option;
    }
}
function $2d646e51cc34f840$var$isSupportAxisBreak(axis) {
    // The polar radius axis can also support break feasibly. Do not do it until the requirements are met.
    return (axis.dim === "x" || axis.dim === "y" || axis.dim === "z" || axis.dim === "single") && axis.type !== "category";
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $6a439e51dccdc432$var$modelInner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $6a439e51dccdc432$var$axisInner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $6a439e51dccdc432$export$31cba7db0a663292 = {
    estimate: 1,
    determine: 2
};
function $6a439e51dccdc432$export$12d6ac38274c43e7(kind) {
    return {
        out: {
            noPxChangeTryDetermine: []
        },
        kind: kind
    };
}
function $6a439e51dccdc432$var$tickValuesToNumbers(axis, values) {
    var nums = $7a1bd9c2710fea0d$export$871de8747c9eaa88(values, function(val) {
        return axis.scale.parse(val);
    });
    if (axis.type === "time" && nums.length > 0) {
        // Time axis needs duplicate first/last tick (see TimeScale.getTicks())
        // The first and last tick/label don't get drawn
        nums.sort();
        nums.unshift(nums[0]);
        nums.push(nums[nums.length - 1]);
    }
    return nums;
}
function $6a439e51dccdc432$export$10216ebd3e3e485e(axis, ctx) {
    var custom = axis.getLabelModel().get("customValues");
    if (custom) {
        var labelFormatter_1 = (0, $2d646e51cc34f840$export$742f19a75415b2ae)(axis);
        var extent_1 = axis.scale.getExtent();
        var tickNumbers = $6a439e51dccdc432$var$tickValuesToNumbers(axis, custom);
        var ticks = $7a1bd9c2710fea0d$export$3dea766d36a8935f(tickNumbers, function(val) {
            return val >= extent_1[0] && val <= extent_1[1];
        });
        return {
            labels: $7a1bd9c2710fea0d$export$871de8747c9eaa88(ticks, function(numval) {
                var tick = {
                    value: numval
                };
                return {
                    formattedLabel: labelFormatter_1(tick),
                    rawLabel: axis.scale.getLabel(tick),
                    tickValue: numval,
                    time: undefined,
                    "break": undefined
                };
            })
        };
    }
    // Only ordinal scale support tick interval
    return axis.type === "category" ? $6a439e51dccdc432$var$makeCategoryLabels(axis, ctx) : $6a439e51dccdc432$var$makeRealNumberLabels(axis);
}
function $6a439e51dccdc432$export$7cccf6836ae8323c(axis, tickModel, opt) {
    var custom = axis.getTickModel().get("customValues");
    if (custom) {
        var extent_2 = axis.scale.getExtent();
        var tickNumbers = $6a439e51dccdc432$var$tickValuesToNumbers(axis, custom);
        return {
            ticks: $7a1bd9c2710fea0d$export$3dea766d36a8935f(tickNumbers, function(val) {
                return val >= extent_2[0] && val <= extent_2[1];
            })
        };
    }
    // Only ordinal scale support tick interval
    return axis.type === "category" ? $6a439e51dccdc432$var$makeCategoryTicks(axis, tickModel) : {
        ticks: $7a1bd9c2710fea0d$export$871de8747c9eaa88(axis.scale.getTicks(opt), function(tick) {
            return tick.value;
        })
    };
}
function $6a439e51dccdc432$var$makeCategoryLabels(axis, ctx) {
    var labelModel = axis.getLabelModel();
    var result = $6a439e51dccdc432$var$makeCategoryLabelsActually(axis, labelModel, ctx);
    return !labelModel.get("show") || axis.scale.isBlank() ? {
        labels: []
    } : result;
}
function $6a439e51dccdc432$var$makeCategoryLabelsActually(axis, labelModel, ctx) {
    var labelsCache = $6a439e51dccdc432$var$ensureCategoryLabelCache(axis);
    var optionLabelInterval = (0, $2d646e51cc34f840$export$6d0bc2429155c088)(labelModel);
    var isEstimate = ctx.kind === $6a439e51dccdc432$export$31cba7db0a663292.estimate;
    // In AxisTickLabelComputingKind.estimate, the result likely varies during a single
    // pass of ec main process,due to the change of axisExtent, and will not be shared with
    // splitLine. Therefore no cache is used.
    if (!isEstimate) {
        // PENDING: check necessary?
        var result_1 = $6a439e51dccdc432$var$axisCacheGet(labelsCache, optionLabelInterval);
        if (result_1) return result_1;
    }
    var labels;
    var numericLabelInterval;
    if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(optionLabelInterval)) labels = $6a439e51dccdc432$var$makeLabelsByCustomizedCategoryInterval(axis, optionLabelInterval);
    else {
        numericLabelInterval = optionLabelInterval === "auto" ? $6a439e51dccdc432$var$makeAutoCategoryInterval(axis, ctx) : optionLabelInterval;
        labels = $6a439e51dccdc432$var$makeLabelsByNumericCategoryInterval(axis, numericLabelInterval);
    }
    var result = {
        labels: labels,
        labelCategoryInterval: numericLabelInterval
    };
    if (!isEstimate) $6a439e51dccdc432$var$axisCacheSet(labelsCache, optionLabelInterval, result);
    else ctx.out.noPxChangeTryDetermine.push(function() {
        $6a439e51dccdc432$var$axisCacheSet(labelsCache, optionLabelInterval, result);
        return true;
    });
    return result;
}
function $6a439e51dccdc432$var$makeCategoryTicks(axis, tickModel) {
    var ticksCache = $6a439e51dccdc432$var$ensureCategoryTickCache(axis);
    var optionTickInterval = (0, $2d646e51cc34f840$export$6d0bc2429155c088)(tickModel);
    var result = $6a439e51dccdc432$var$axisCacheGet(ticksCache, optionTickInterval);
    if (result) return result;
    var ticks;
    var tickCategoryInterval;
    // Optimize for the case that large category data and no label displayed,
    // we should not return all ticks.
    if (!tickModel.get("show") || axis.scale.isBlank()) ticks = [];
    if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(optionTickInterval)) ticks = $6a439e51dccdc432$var$makeLabelsByCustomizedCategoryInterval(axis, optionTickInterval, true);
    else if (optionTickInterval === "auto") {
        var labelsResult = $6a439e51dccdc432$var$makeCategoryLabelsActually(axis, axis.getLabelModel(), $6a439e51dccdc432$export$12d6ac38274c43e7($6a439e51dccdc432$export$31cba7db0a663292.determine));
        tickCategoryInterval = labelsResult.labelCategoryInterval;
        ticks = $7a1bd9c2710fea0d$export$871de8747c9eaa88(labelsResult.labels, function(labelItem) {
            return labelItem.tickValue;
        });
    } else {
        tickCategoryInterval = optionTickInterval;
        ticks = $6a439e51dccdc432$var$makeLabelsByNumericCategoryInterval(axis, tickCategoryInterval, true);
    }
    // Cache to avoid calling interval function repeatedly.
    return $6a439e51dccdc432$var$axisCacheSet(ticksCache, optionTickInterval, {
        ticks: ticks,
        tickCategoryInterval: tickCategoryInterval
    });
}
function $6a439e51dccdc432$var$makeRealNumberLabels(axis) {
    var ticks = axis.scale.getTicks();
    var labelFormatter = (0, $2d646e51cc34f840$export$742f19a75415b2ae)(axis);
    return {
        labels: $7a1bd9c2710fea0d$export$871de8747c9eaa88(ticks, function(tick, idx) {
            return {
                formattedLabel: labelFormatter(tick, idx),
                rawLabel: axis.scale.getLabel(tick),
                tickValue: tick.value,
                time: tick.time,
                "break": tick["break"]
            };
        })
    };
}
// Large category data calculation is performance sensitive, and ticks and label probably will
// be fetched multiple times (e.g. shared by splitLine and axisTick). So we cache the result.
// axis is created each time during a ec process, so we do not need to clear cache.
var $6a439e51dccdc432$var$ensureCategoryTickCache = $6a439e51dccdc432$var$initAxisCacheMethod("axisTick");
var $6a439e51dccdc432$var$ensureCategoryLabelCache = $6a439e51dccdc432$var$initAxisCacheMethod("axisLabel");
/**
 * PENDING: refactor to JS Map? Because key can be a function or more complicated object, and
 * cache size always is small, and currently no JS Map object key polyfill, we use a simple
 * array cache instead of plain object hash.
 */ function $6a439e51dccdc432$var$initAxisCacheMethod(prop) {
    return function ensureCache(axis) {
        return $6a439e51dccdc432$var$axisInner(axis)[prop] || ($6a439e51dccdc432$var$axisInner(axis)[prop] = {
            list: []
        });
    };
}
function $6a439e51dccdc432$var$axisCacheGet(cache, key) {
    for(var i = 0; i < cache.list.length; i++){
        if (cache.list[i].key === key) return cache.list[i].value;
    }
}
function $6a439e51dccdc432$var$axisCacheSet(cache, key, value) {
    cache.list.push({
        key: key,
        value: value
    });
    return value;
}
function $6a439e51dccdc432$var$makeAutoCategoryInterval(axis, ctx) {
    if (ctx.kind === $6a439e51dccdc432$export$31cba7db0a663292.estimate) {
        // Currently axisTick is not involved in estimate kind, and the result likely varies during a
        // single pass of ec main process, due to the change of axisExtent. Therefore no cache is used.
        var result_2 = axis.calculateCategoryInterval(ctx);
        ctx.out.noPxChangeTryDetermine.push(function() {
            $6a439e51dccdc432$var$axisInner(axis).autoInterval = result_2;
            return true;
        });
        return result_2;
    }
    // Both tick and label uses this result, cacah it to avoid recompute.
    var result = $6a439e51dccdc432$var$axisInner(axis).autoInterval;
    return result != null ? result : $6a439e51dccdc432$var$axisInner(axis).autoInterval = axis.calculateCategoryInterval(ctx);
}
function $6a439e51dccdc432$export$9ea1d3f146a5a65f(axis, ctx) {
    var kind = ctx.kind;
    var params = $6a439e51dccdc432$var$fetchAutoCategoryIntervalCalculationParams(axis);
    var labelFormatter = (0, $2d646e51cc34f840$export$742f19a75415b2ae)(axis);
    var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent();
    // Providing this method is for optimization:
    // avoid generating a long array by `getTicks`
    // in large category data case.
    var tickCount = ordinalScale.count();
    if (ordinalExtent[1] - ordinalExtent[0] < 1) return 0;
    var step = 1;
    // Simple optimization. Arbitrary value.
    var maxCount = 40;
    if (tickCount > maxCount) step = Math.max(1, Math.floor(tickCount / maxCount));
    var tickValue = ordinalExtent[0];
    var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
    var unitW = Math.abs(unitSpan * Math.cos(rotation));
    var unitH = Math.abs(unitSpan * Math.sin(rotation));
    var maxW = 0;
    var maxH = 0;
    // Caution: Performance sensitive for large category data.
    // Consider dataZoom, we should make appropriate step to avoid O(n) loop.
    for(; tickValue <= ordinalExtent[1]; tickValue += step){
        var width = 0;
        var height = 0;
        // Not precise, do not consider align and vertical align
        // and each distance from axis line yet.
        var rect = $6c308355c7107803$export$c381147bfed79d9f(labelFormatter({
            value: tickValue
        }), params.font, "center", "top");
        // Magic number
        width = rect.width * 1.3;
        height = rect.height * 1.3;
        // Min size, void long loop.
        maxW = Math.max(maxW, width, 7);
        maxH = Math.max(maxH, height, 7);
    }
    var dw = maxW / unitW;
    var dh = maxH / unitH;
    // 0/0 is NaN, 1/0 is Infinity.
    isNaN(dw) && (dw = Infinity);
    isNaN(dh) && (dh = Infinity);
    var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
    if (kind === $6a439e51dccdc432$export$31cba7db0a663292.estimate) {
        // In estimate kind, the inteval likely varies, thus do not erase the cache.
        ctx.out.noPxChangeTryDetermine.push($7a1bd9c2710fea0d$export$2385a24977818dd0($6a439e51dccdc432$var$calculateCategoryIntervalTryDetermine, null, axis, interval, tickCount));
        return interval;
    }
    var lastInterval = $6a439e51dccdc432$var$calculateCategoryIntervalDealCache(axis, interval, tickCount);
    return lastInterval != null ? lastInterval : interval;
}
function $6a439e51dccdc432$var$calculateCategoryIntervalTryDetermine(axis, interval, tickCount) {
    return $6a439e51dccdc432$var$calculateCategoryIntervalDealCache(axis, interval, tickCount) == null;
}
// Return the lastInterval if need to use it, otherwise return NullUndefined and save cache.
function $6a439e51dccdc432$var$calculateCategoryIntervalDealCache(axis, interval, tickCount) {
    var cache = $6a439e51dccdc432$var$modelInner(axis.model);
    var axisExtent = axis.getExtent();
    var lastAutoInterval = cache.lastAutoInterval;
    var lastTickCount = cache.lastTickCount;
    // Use cache to keep interval stable while moving zoom window,
    // otherwise the calculated interval might jitter when the zoom
    // window size is close to the interval-changing size.
    // For example, if all of the axis labels are `a, b, c, d, e, f, g`.
    // The jitter will cause that sometimes the displayed labels are
    // `a, d, g` (interval: 2) sometimes `a, c, e`(interval: 1).
    if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 && lastAutoInterval > interval && cache.axisExtent0 === axisExtent[0] && cache.axisExtent1 === axisExtent[1]) return lastAutoInterval;
    else {
        cache.lastTickCount = tickCount;
        cache.lastAutoInterval = interval;
        cache.axisExtent0 = axisExtent[0];
        cache.axisExtent1 = axisExtent[1];
    }
}
function $6a439e51dccdc432$var$fetchAutoCategoryIntervalCalculationParams(axis) {
    var labelModel = axis.getLabelModel();
    return {
        axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
        labelRotate: labelModel.get("rotate") || 0,
        font: labelModel.getFont()
    };
}
function $6a439e51dccdc432$var$makeLabelsByNumericCategoryInterval(axis, categoryInterval, onlyTick) {
    var labelFormatter = (0, $2d646e51cc34f840$export$742f19a75415b2ae)(axis);
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent();
    var labelModel = axis.getLabelModel();
    var result = [];
    // TODO: axisType: ordinalTime, pick the tick from each month/day/year/...
    var step = Math.max((categoryInterval || 0) + 1, 1);
    var startTick = ordinalExtent[0];
    var tickCount = ordinalScale.count();
    // Calculate start tick based on zero if possible to keep label consistent
    // while zooming and moving while interval > 0. Otherwise the selection
    // of displayable ticks and symbols probably keep changing.
    // 3 is empirical value.
    if (startTick !== 0 && step > 1 && tickCount / step > 2) startTick = Math.round(Math.ceil(startTick / step) * step);
    // (1) Only add min max label here but leave overlap checking
    // to render stage, which also ensure the returned list
    // suitable for splitLine and splitArea rendering.
    // (2) Scales except category always contain min max label so
    // do not need to perform this process.
    var showAllLabel = (0, $2d646e51cc34f840$export$c2911c025243d6a6)(axis);
    var includeMinLabel = labelModel.get("showMinLabel") || showAllLabel;
    var includeMaxLabel = labelModel.get("showMaxLabel") || showAllLabel;
    if (includeMinLabel && startTick !== ordinalExtent[0]) addItem(ordinalExtent[0]);
    // Optimize: avoid generating large array by `ordinalScale.getTicks()`.
    var tickValue = startTick;
    for(; tickValue <= ordinalExtent[1]; tickValue += step)addItem(tickValue);
    if (includeMaxLabel && tickValue - step !== ordinalExtent[1]) addItem(ordinalExtent[1]);
    function addItem(tickValue) {
        var tickObj = {
            value: tickValue
        };
        result.push(onlyTick ? tickValue : {
            formattedLabel: labelFormatter(tickObj),
            rawLabel: ordinalScale.getLabel(tickObj),
            tickValue: tickValue,
            time: undefined,
            "break": undefined
        });
    }
    return result;
}
function $6a439e51dccdc432$var$makeLabelsByCustomizedCategoryInterval(axis, categoryInterval, onlyTick) {
    var ordinalScale = axis.scale;
    var labelFormatter = (0, $2d646e51cc34f840$export$742f19a75415b2ae)(axis);
    var result = [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(ordinalScale.getTicks(), function(tick) {
        var rawLabel = ordinalScale.getLabel(tick);
        var tickValue = tick.value;
        if (categoryInterval(tick.value, rawLabel)) result.push(onlyTick ? tickValue : {
            formattedLabel: labelFormatter(tick),
            rawLabel: rawLabel,
            tickValue: tickValue,
            time: undefined,
            "break": undefined
        });
    });
    return result;
}


var $c2b1efffe5ae3f42$var$NORMALIZED_EXTENT = [
    0,
    1
];
/**
 * Base class of Axis.
 *
 * Lifetime: recreate for each main process.
 * [NOTICE]: Some caches is stored on the axis instance (see `axisTickLabelBuilder.ts`)
 *  which is based on this lifetime.
 */ var $c2b1efffe5ae3f42$var$Axis = /** @class */ function() {
    function Axis(dim, scale, extent) {
        this.onBand = false;
        // Make sure that `extent[0] > extent[1]` only if `inverse: true`.
        // `inverse` can be inferred by `extent` unless `extent[0] === extent[1]`.
        this.inverse = false;
        this.dim = dim;
        this.scale = scale;
        this._extent = extent || [
            0,
            0
        ];
    }
    /**
   * If axis extent contain given coord
   */ Axis.prototype.contain = function(coord) {
        var extent = this._extent;
        var min = Math.min(extent[0], extent[1]);
        var max = Math.max(extent[0], extent[1]);
        return coord >= min && coord <= max;
    };
    /**
   * If axis extent contain given data
   */ Axis.prototype.containData = function(data) {
        return this.scale.contain(this.scale.parse(data));
    };
    /**
   * Get coord extent.
   */ Axis.prototype.getExtent = function() {
        return this._extent.slice();
    };
    /**
   * Get precision used for formatting
   */ Axis.prototype.getPixelPrecision = function(dataExtent) {
        return (0, $cfc1f3b422a3185f$export$666260d9a2dda8a7)(dataExtent || this.scale.getExtent(), this._extent);
    };
    /**
   * Set coord extent
   */ Axis.prototype.setExtent = function(start, end) {
        var extent = this._extent;
        extent[0] = start;
        extent[1] = end;
    };
    /**
   * Convert data to coord. Data is the rank if it has an ordinal scale
   */ Axis.prototype.dataToCoord = function(data, clamp) {
        var extent = this._extent;
        var scale = this.scale;
        data = scale.normalize(scale.parse(data));
        if (this.onBand && scale.type === "ordinal") {
            extent = extent.slice();
            $c2b1efffe5ae3f42$var$fixExtentWithBands(extent, scale.count());
        }
        return (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(data, $c2b1efffe5ae3f42$var$NORMALIZED_EXTENT, extent, clamp);
    };
    /**
   * Convert coord to data. Data is the rank if it has an ordinal scale
   */ Axis.prototype.coordToData = function(coord, clamp) {
        var extent = this._extent;
        var scale = this.scale;
        if (this.onBand && scale.type === "ordinal") {
            extent = extent.slice();
            $c2b1efffe5ae3f42$var$fixExtentWithBands(extent, scale.count());
        }
        var t = (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(coord, extent, $c2b1efffe5ae3f42$var$NORMALIZED_EXTENT, clamp);
        return this.scale.scale(t);
    };
    /**
   * Convert pixel point to data in axis
   */ Axis.prototype.pointToData = function(point, clamp) {
        // Should be implemented in derived class if necessary.
        return;
    };
    /**
   * Different from `zrUtil.map(axis.getTicks(), axis.dataToCoord, axis)`,
   * `axis.getTicksCoords` considers `onBand`, which is used by
   * `boundaryGap:true` of category axis and splitLine and splitArea.
   * @param opt.tickModel default: axis.model.getModel('axisTick')
   * @param opt.clamp If `true`, the first and the last
   *        tick must be at the axis end points. Otherwise, clip ticks
   *        that outside the axis extent.
   */ Axis.prototype.getTicksCoords = function(opt) {
        opt = opt || {};
        var tickModel = opt.tickModel || this.getTickModel();
        var result = (0, $6a439e51dccdc432$export$7cccf6836ae8323c)(this, tickModel, {
            breakTicks: opt.breakTicks,
            pruneByBreak: opt.pruneByBreak
        });
        var ticks = result.ticks;
        var ticksCoords = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(ticks, function(tickVal) {
            return {
                coord: this.dataToCoord(this.scale.type === "ordinal" ? this.scale.getRawOrdinalNumber(tickVal) : tickVal),
                tickValue: tickVal
            };
        }, this);
        var alignWithLabel = tickModel.get("alignWithLabel");
        $c2b1efffe5ae3f42$var$fixOnBandTicksCoords(this, ticksCoords, alignWithLabel, opt.clamp);
        return ticksCoords;
    };
    Axis.prototype.getMinorTicksCoords = function() {
        if (this.scale.type === "ordinal") // Category axis doesn't support minor ticks
        return [];
        var minorTickModel = this.model.getModel("minorTick");
        var splitNumber = minorTickModel.get("splitNumber");
        // Protection.
        if (!(splitNumber > 0 && splitNumber < 100)) splitNumber = 5;
        var minorTicks = this.scale.getMinorTicks(splitNumber);
        var minorTicksCoords = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(minorTicks, function(minorTicksGroup) {
            return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(minorTicksGroup, function(minorTick) {
                return {
                    coord: this.dataToCoord(minorTick),
                    tickValue: minorTick
                };
            }, this);
        }, this);
        return minorTicksCoords;
    };
    Axis.prototype.getViewLabels = function(ctx) {
        ctx = ctx || (0, $6a439e51dccdc432$export$12d6ac38274c43e7)((0, $6a439e51dccdc432$export$31cba7db0a663292).determine);
        return (0, $6a439e51dccdc432$export$10216ebd3e3e485e)(this, ctx).labels;
    };
    Axis.prototype.getLabelModel = function() {
        return this.model.getModel("axisLabel");
    };
    /**
   * Notice here we only get the default tick model. For splitLine
   * or splitArea, we should pass the splitLineModel or splitAreaModel
   * manually when calling `getTicksCoords`.
   * In GL, this method may be overridden to:
   * `axisModel.getModel('axisTick', grid3DModel.getModel('axisTick'));`
   */ Axis.prototype.getTickModel = function() {
        return this.model.getModel("axisTick");
    };
    /**
   * Get width of band
   */ Axis.prototype.getBandWidth = function() {
        var axisExtent = this._extent;
        var dataExtent = this.scale.getExtent();
        var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0);
        // Fix #2728, avoid NaN when only one data.
        len === 0 && (len = 1);
        var size = Math.abs(axisExtent[1] - axisExtent[0]);
        return Math.abs(size) / len;
    };
    /**
   * Only be called in category axis.
   * Can be overridden, consider other axes like in 3D.
   * @return Auto interval for cateogry axis tick and label
   */ Axis.prototype.calculateCategoryInterval = function(ctx) {
        ctx = ctx || (0, $6a439e51dccdc432$export$12d6ac38274c43e7)((0, $6a439e51dccdc432$export$31cba7db0a663292).determine);
        return (0, $6a439e51dccdc432$export$9ea1d3f146a5a65f)(this, ctx);
    };
    return Axis;
}();
function $c2b1efffe5ae3f42$var$fixExtentWithBands(extent, nTick) {
    var size = extent[1] - extent[0];
    var len = nTick;
    var margin = size / len / 2;
    extent[0] += margin;
    extent[1] -= margin;
}
// If axis has labels [1, 2, 3, 4]. Bands on the axis are
// |---1---|---2---|---3---|---4---|.
// So the displayed ticks and splitLine/splitArea should between
// each data item, otherwise cause misleading (e.g., split tow bars
// of a single data item when there are two bar series).
// Also consider if tickCategoryInterval > 0 and onBand, ticks and
// splitLine/spliteArea should layout appropriately corresponding
// to displayed labels. (So we should not use `getBandWidth` in this
// case).
function $c2b1efffe5ae3f42$var$fixOnBandTicksCoords(axis, ticksCoords, alignWithLabel, clamp) {
    var ticksLen = ticksCoords.length;
    if (!axis.onBand || alignWithLabel || !ticksLen) return;
    var axisExtent = axis.getExtent();
    var last;
    var diffSize;
    if (ticksLen === 1) {
        ticksCoords[0].coord = axisExtent[0];
        ticksCoords[0].onBand = true;
        last = ticksCoords[1] = {
            coord: axisExtent[1],
            tickValue: ticksCoords[0].tickValue,
            onBand: true
        };
    } else {
        var crossLen = ticksCoords[ticksLen - 1].tickValue - ticksCoords[0].tickValue;
        var shift_1 = (ticksCoords[ticksLen - 1].coord - ticksCoords[0].coord) / crossLen;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ticksCoords, function(ticksItem) {
            ticksItem.coord -= shift_1 / 2;
            ticksItem.onBand = true;
        });
        var dataExtent = axis.scale.getExtent();
        diffSize = 1 + dataExtent[1] - ticksCoords[ticksLen - 1].tickValue;
        last = {
            coord: ticksCoords[ticksLen - 1].coord + shift_1 * diffSize,
            tickValue: dataExtent[1] + 1,
            onBand: true
        };
        ticksCoords.push(last);
    }
    var inverse = axisExtent[0] > axisExtent[1];
    // Handling clamp.
    if (littleThan(ticksCoords[0].coord, axisExtent[0])) clamp ? ticksCoords[0].coord = axisExtent[0] : ticksCoords.shift();
    if (clamp && littleThan(axisExtent[0], ticksCoords[0].coord)) ticksCoords.unshift({
        coord: axisExtent[0],
        onBand: true
    });
    if (littleThan(axisExtent[1], last.coord)) clamp ? last.coord = axisExtent[1] : ticksCoords.pop();
    if (clamp && littleThan(last.coord, axisExtent[1])) ticksCoords.push({
        coord: axisExtent[1],
        onBand: true
    });
    function littleThan(a, b) {
        // Avoid rounding error cause calculated tick coord different with extent.
        // It may cause an extra unnecessary tick added.
        a = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(a);
        b = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(b);
        return inverse ? a > b : a < b;
    }
}
var $c2b1efffe5ae3f42$export$2e2bcd8739ae039 = $c2b1efffe5ae3f42$var$Axis;


var $ec1c8727611588c2$var$ParallelAxis = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ParallelAxis, _super);
    function ParallelAxis(dim, scale, coordExtent, axisType, axisIndex) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        _this.type = axisType || "value";
        _this.axisIndex = axisIndex;
        return _this;
    }
    ParallelAxis.prototype.isHorizontal = function() {
        return this.coordinateSystem.getModel().get("layout") !== "horizontal";
    };
    return ParallelAxis;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
var $ec1c8727611588c2$export$2e2bcd8739ae039 = $ec1c8727611588c2$var$ParallelAxis;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Calculate slider move result.
 * Usage:
 * (1) If both handle0 and handle1 are needed to be moved, set minSpan the same as
 * maxSpan and the same as `Math.abs(handleEnd[1] - handleEnds[0])`.
 * (2) If handle0 is forbidden to cross handle1, set minSpan as `0`.
 *
 * @param delta Move length.
 * @param handleEnds handleEnds[0] can be bigger then handleEnds[1].
 *              handleEnds will be modified in this method.
 * @param extent handleEnds is restricted by extent.
 *              extent[0] should less or equals than extent[1].
 * @param handleIndex Can be 'all', means that both move the two handleEnds.
 * @param minSpan The range of dataZoom can not be smaller than that.
 *              If not set, handle0 and cross handle1. If set as a non-negative
 *              number (including `0`), handles will push each other when reaching
 *              the minSpan.
 * @param maxSpan The range of dataZoom can not be larger than that.
 * @return The input handleEnds.
 */ function $00a8003b34293330$export$2e2bcd8739ae039(delta, handleEnds, extent, handleIndex, minSpan, maxSpan) {
    delta = delta || 0;
    var extentSpan = extent[1] - extent[0];
    // Notice maxSpan and minSpan can be null/undefined.
    if (minSpan != null) minSpan = $00a8003b34293330$var$restrict(minSpan, [
        0,
        extentSpan
    ]);
    if (maxSpan != null) maxSpan = Math.max(maxSpan, minSpan != null ? minSpan : 0);
    if (handleIndex === "all") {
        var handleSpan = Math.abs(handleEnds[1] - handleEnds[0]);
        handleSpan = $00a8003b34293330$var$restrict(handleSpan, [
            0,
            extentSpan
        ]);
        minSpan = maxSpan = $00a8003b34293330$var$restrict(handleSpan, [
            minSpan,
            maxSpan
        ]);
        handleIndex = 0;
    }
    handleEnds[0] = $00a8003b34293330$var$restrict(handleEnds[0], extent);
    handleEnds[1] = $00a8003b34293330$var$restrict(handleEnds[1], extent);
    var originalDistSign = $00a8003b34293330$var$getSpanSign(handleEnds, handleIndex);
    handleEnds[handleIndex] += delta;
    // Restrict in extent.
    var extentMinSpan = minSpan || 0;
    var realExtent = extent.slice();
    originalDistSign.sign < 0 ? realExtent[0] += extentMinSpan : realExtent[1] -= extentMinSpan;
    handleEnds[handleIndex] = $00a8003b34293330$var$restrict(handleEnds[handleIndex], realExtent);
    // Expand span.
    var currDistSign;
    currDistSign = $00a8003b34293330$var$getSpanSign(handleEnds, handleIndex);
    if (minSpan != null && (currDistSign.sign !== originalDistSign.sign || currDistSign.span < minSpan)) // If minSpan exists, 'cross' is forbidden.
    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + originalDistSign.sign * minSpan;
    // Shrink span.
    currDistSign = $00a8003b34293330$var$getSpanSign(handleEnds, handleIndex);
    if (maxSpan != null && currDistSign.span > maxSpan) handleEnds[1 - handleIndex] = handleEnds[handleIndex] + currDistSign.sign * maxSpan;
    return handleEnds;
}
function $00a8003b34293330$var$getSpanSign(handleEnds, handleIndex) {
    var dist = handleEnds[handleIndex] - handleEnds[1 - handleIndex];
    // If `handleEnds[0] === handleEnds[1]`, always believe that handleEnd[0]
    // is at left of handleEnds[1] for non-cross case.
    return {
        span: Math.abs(dist),
        sign: dist > 0 ? -1 : dist < 0 ? 1 : handleIndex ? -1 : 1
    };
}
function $00a8003b34293330$var$restrict(value, extend) {
    return Math.min(extend[1] != null ? extend[1] : Infinity, Math.max(extend[0] != null ? extend[0] : -Infinity, value));
}


var $a26a2212b9c3ac89$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $a26a2212b9c3ac89$var$mathMin = Math.min;
var $a26a2212b9c3ac89$var$mathMax = Math.max;
var $a26a2212b9c3ac89$var$mathFloor = Math.floor;
var $a26a2212b9c3ac89$var$mathCeil = Math.ceil;
var $a26a2212b9c3ac89$var$round = $cfc1f3b422a3185f$export$2077e0241d6afd3c;
var $a26a2212b9c3ac89$var$PI = Math.PI;
var $a26a2212b9c3ac89$var$Parallel = /** @class */ function() {
    function Parallel(parallelModel, ecModel, api) {
        this.type = "parallel";
        /**
     * key: dimension
     */ this._axesMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        /**
     * key: dimension
     * value: {position: [], rotation, }
     */ this._axesLayout = {};
        this.dimensions = parallelModel.dimensions;
        this._model = parallelModel;
        this._init(parallelModel, ecModel, api);
    }
    Parallel.prototype._init = function(parallelModel, ecModel, api) {
        var dimensions = parallelModel.dimensions;
        var parallelAxisIndex = parallelModel.parallelAxisIndex;
        $a26a2212b9c3ac89$var$each(dimensions, function(dim, idx) {
            var axisIndex = parallelAxisIndex[idx];
            var axisModel = ecModel.getComponent("parallelAxis", axisIndex);
            var axis = this._axesMap.set(dim, new (0, $ec1c8727611588c2$export$2e2bcd8739ae039)(dim, $2d646e51cc34f840$export$8941c4cacdc8f5a5(axisModel), [
                0,
                0
            ], axisModel.get("type"), axisIndex));
            var isCategory = axis.type === "category";
            axis.onBand = isCategory && axisModel.get("boundaryGap");
            axis.inverse = axisModel.get("inverse");
            // Injection
            axisModel.axis = axis;
            axis.model = axisModel;
            axis.coordinateSystem = axisModel.coordinateSystem = this;
        }, this);
    };
    /**
   * Update axis scale after data processed
   */ Parallel.prototype.update = function(ecModel, api) {
        this._updateAxesFromSeries(this._model, ecModel);
    };
    Parallel.prototype.containPoint = function(point) {
        var layoutInfo = this._makeLayoutInfo();
        var axisBase = layoutInfo.axisBase;
        var layoutBase = layoutInfo.layoutBase;
        var pixelDimIndex = layoutInfo.pixelDimIndex;
        var pAxis = point[1 - pixelDimIndex];
        var pLayout = point[pixelDimIndex];
        return pAxis >= axisBase && pAxis <= axisBase + layoutInfo.axisLength && pLayout >= layoutBase && pLayout <= layoutBase + layoutInfo.layoutLength;
    };
    Parallel.prototype.getModel = function() {
        return this._model;
    };
    /**
   * Update properties from series
   */ Parallel.prototype._updateAxesFromSeries = function(parallelModel, ecModel) {
        ecModel.eachSeries(function(seriesModel) {
            if (!parallelModel.contains(seriesModel, ecModel)) return;
            var data = seriesModel.getData();
            $a26a2212b9c3ac89$var$each(this.dimensions, function(dim) {
                var axis = this._axesMap.get(dim);
                axis.scale.unionExtentFromData(data, data.mapDimension(dim));
                $2d646e51cc34f840$export$51f3e70a54405d5a(axis.scale, axis.model);
            }, this);
        }, this);
    };
    /**
   * Resize the parallel coordinate system.
   */ Parallel.prototype.resize = function(parallelModel, api) {
        var refContainer = $93b9bc7f22ac7369$export$5aec1e94f566e59f(parallelModel, api).refContainer;
        this._rect = $93b9bc7f22ac7369$export$4517a5ca639a7293(parallelModel.getBoxLayoutParams(), refContainer);
        this._layoutAxes();
    };
    Parallel.prototype.getRect = function() {
        return this._rect;
    };
    Parallel.prototype._makeLayoutInfo = function() {
        var parallelModel = this._model;
        var rect = this._rect;
        var xy = [
            "x",
            "y"
        ];
        var wh = [
            "width",
            "height"
        ];
        var layout = parallelModel.get("layout");
        var pixelDimIndex = layout === "horizontal" ? 0 : 1;
        var layoutLength = rect[wh[pixelDimIndex]];
        var layoutExtent = [
            0,
            layoutLength
        ];
        var axisCount = this.dimensions.length;
        var axisExpandWidth = $a26a2212b9c3ac89$var$restrict(parallelModel.get("axisExpandWidth"), layoutExtent);
        var axisExpandCount = $a26a2212b9c3ac89$var$restrict(parallelModel.get("axisExpandCount") || 0, [
            0,
            axisCount
        ]);
        var axisExpandable = parallelModel.get("axisExpandable") && axisCount > 3 && axisCount > axisExpandCount && axisExpandCount > 1 && axisExpandWidth > 0 && layoutLength > 0;
        // `axisExpandWindow` is According to the coordinates of [0, axisExpandLength],
        // for sake of consider the case that axisCollapseWidth is 0 (when screen is narrow),
        // where collapsed axes should be overlapped.
        var axisExpandWindow = parallelModel.get("axisExpandWindow");
        var winSize;
        if (!axisExpandWindow) {
            winSize = $a26a2212b9c3ac89$var$restrict(axisExpandWidth * (axisExpandCount - 1), layoutExtent);
            var axisExpandCenter = parallelModel.get("axisExpandCenter") || $a26a2212b9c3ac89$var$mathFloor(axisCount / 2);
            axisExpandWindow = [
                axisExpandWidth * axisExpandCenter - winSize / 2
            ];
            axisExpandWindow[1] = axisExpandWindow[0] + winSize;
        } else {
            winSize = $a26a2212b9c3ac89$var$restrict(axisExpandWindow[1] - axisExpandWindow[0], layoutExtent);
            axisExpandWindow[1] = axisExpandWindow[0] + winSize;
        }
        var axisCollapseWidth = (layoutLength - winSize) / (axisCount - axisExpandCount);
        // Avoid axisCollapseWidth is too small.
        axisCollapseWidth < 3 && (axisCollapseWidth = 0);
        // Find the first and last indices > ewin[0] and < ewin[1].
        var winInnerIndices = [
            $a26a2212b9c3ac89$var$mathFloor($a26a2212b9c3ac89$var$round(axisExpandWindow[0] / axisExpandWidth, 1)) + 1,
            $a26a2212b9c3ac89$var$mathCeil($a26a2212b9c3ac89$var$round(axisExpandWindow[1] / axisExpandWidth, 1)) - 1
        ];
        // Pos in ec coordinates.
        var axisExpandWindow0Pos = axisCollapseWidth / axisExpandWidth * axisExpandWindow[0];
        return {
            layout: layout,
            pixelDimIndex: pixelDimIndex,
            layoutBase: rect[xy[pixelDimIndex]],
            layoutLength: layoutLength,
            axisBase: rect[xy[1 - pixelDimIndex]],
            axisLength: rect[wh[1 - pixelDimIndex]],
            axisExpandable: axisExpandable,
            axisExpandWidth: axisExpandWidth,
            axisCollapseWidth: axisCollapseWidth,
            axisExpandWindow: axisExpandWindow,
            axisCount: axisCount,
            winInnerIndices: winInnerIndices,
            axisExpandWindow0Pos: axisExpandWindow0Pos
        };
    };
    Parallel.prototype._layoutAxes = function() {
        var rect = this._rect;
        var axes = this._axesMap;
        var dimensions = this.dimensions;
        var layoutInfo = this._makeLayoutInfo();
        var layout = layoutInfo.layout;
        axes.each(function(axis) {
            var axisExtent = [
                0,
                layoutInfo.axisLength
            ];
            var idx = axis.inverse ? 1 : 0;
            axis.setExtent(axisExtent[idx], axisExtent[1 - idx]);
        });
        $a26a2212b9c3ac89$var$each(dimensions, function(dim, idx) {
            var posInfo = (layoutInfo.axisExpandable ? $a26a2212b9c3ac89$var$layoutAxisWithExpand : $a26a2212b9c3ac89$var$layoutAxisWithoutExpand)(idx, layoutInfo);
            var positionTable = {
                horizontal: {
                    x: posInfo.position,
                    y: layoutInfo.axisLength
                },
                vertical: {
                    x: 0,
                    y: posInfo.position
                }
            };
            var rotationTable = {
                horizontal: $a26a2212b9c3ac89$var$PI / 2,
                vertical: 0
            };
            var position = [
                positionTable[layout].x + rect.x,
                positionTable[layout].y + rect.y
            ];
            var rotation = rotationTable[layout];
            var transform = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
            $f41ebb9dd60b55b4$export$bb628a54ab399bc9(transform, transform, rotation);
            $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(transform, transform, position);
            // TODO
            // tick layout info
            // TODO
            // update dimensions info based on axis order.
            this._axesLayout[dim] = {
                position: position,
                rotation: rotation,
                transform: transform,
                axisNameAvailableWidth: posInfo.axisNameAvailableWidth,
                axisLabelShow: posInfo.axisLabelShow,
                nameTruncateMaxWidth: posInfo.nameTruncateMaxWidth,
                tickDirection: 1,
                labelDirection: 1
            };
        }, this);
    };
    /**
   * Get axis by dim.
   */ Parallel.prototype.getAxis = function(dim) {
        return this._axesMap.get(dim);
    };
    /**
   * Convert a dim value of a single item of series data to Point.
   */ Parallel.prototype.dataToPoint = function(value, dim) {
        return this.axisCoordToPoint(this._axesMap.get(dim).dataToCoord(value), dim);
    };
    /**
   * Travel data for one time, get activeState of each data item.
   * @param start the start dataIndex that travel from.
   * @param end the next dataIndex of the last dataIndex will be travel.
   */ Parallel.prototype.eachActiveState = function(data, callback, start, end) {
        start == null && (start = 0);
        end == null && (end = data.count());
        var axesMap = this._axesMap;
        var dimensions = this.dimensions;
        var dataDimensions = [];
        var axisModels = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(dimensions, function(axisDim) {
            dataDimensions.push(data.mapDimension(axisDim));
            axisModels.push(axesMap.get(axisDim).model);
        });
        var hasActiveSet = this.hasAxisBrushed();
        for(var dataIndex = start; dataIndex < end; dataIndex++){
            var activeState = void 0;
            if (!hasActiveSet) activeState = "normal";
            else {
                activeState = "active";
                var values = data.getValues(dataDimensions, dataIndex);
                for(var j = 0, lenj = dimensions.length; j < lenj; j++){
                    var state = axisModels[j].getActiveState(values[j]);
                    if (state === "inactive") {
                        activeState = "inactive";
                        break;
                    }
                }
            }
            callback(activeState, dataIndex);
        }
    };
    /**
   * Whether has any activeSet.
   */ Parallel.prototype.hasAxisBrushed = function() {
        var dimensions = this.dimensions;
        var axesMap = this._axesMap;
        var hasActiveSet = false;
        for(var j = 0, lenj = dimensions.length; j < lenj; j++)if (axesMap.get(dimensions[j]).model.getActiveState() !== "normal") hasActiveSet = true;
        return hasActiveSet;
    };
    /**
   * Convert coords of each axis to Point.
   *  Return point. For example: [10, 20]
   */ Parallel.prototype.axisCoordToPoint = function(coord, dim) {
        var axisLayout = this._axesLayout[dim];
        return $5b455ae6f843ac47$export$9f9dcb98c894b623([
            coord,
            0
        ], axisLayout.transform);
    };
    /**
   * Get axis layout.
   */ Parallel.prototype.getAxisLayout = function(dim) {
        return $7a1bd9c2710fea0d$export$9cd59f9826255e47(this._axesLayout[dim]);
    };
    /**
   * @return {Object} {axisExpandWindow, delta, behavior: 'jump' | 'slide' | 'none'}.
   */ Parallel.prototype.getSlidedAxisExpandWindow = function(point) {
        var layoutInfo = this._makeLayoutInfo();
        var pixelDimIndex = layoutInfo.pixelDimIndex;
        var axisExpandWindow = layoutInfo.axisExpandWindow.slice();
        var winSize = axisExpandWindow[1] - axisExpandWindow[0];
        var extent = [
            0,
            layoutInfo.axisExpandWidth * (layoutInfo.axisCount - 1)
        ];
        // Out of the area of coordinate system.
        if (!this.containPoint(point)) return {
            behavior: "none",
            axisExpandWindow: axisExpandWindow
        };
        // Convert the point from global to expand coordinates.
        var pointCoord = point[pixelDimIndex] - layoutInfo.layoutBase - layoutInfo.axisExpandWindow0Pos;
        // For dragging operation convenience, the window should not be
        // slided when mouse is the center area of the window.
        var delta;
        var behavior = "slide";
        var axisCollapseWidth = layoutInfo.axisCollapseWidth;
        var triggerArea = this._model.get("axisExpandSlideTriggerArea");
        // But consider touch device, jump is necessary.
        var useJump = triggerArea[0] != null;
        if (axisCollapseWidth) {
            if (useJump && axisCollapseWidth && pointCoord < winSize * triggerArea[0]) {
                behavior = "jump";
                delta = pointCoord - winSize * triggerArea[2];
            } else if (useJump && axisCollapseWidth && pointCoord > winSize * (1 - triggerArea[0])) {
                behavior = "jump";
                delta = pointCoord - winSize * (1 - triggerArea[2]);
            } else (delta = pointCoord - winSize * triggerArea[1]) >= 0 && (delta = pointCoord - winSize * (1 - triggerArea[1])) <= 0 && (delta = 0);
            delta *= layoutInfo.axisExpandWidth / axisCollapseWidth;
            delta ? (0, $00a8003b34293330$export$2e2bcd8739ae039)(delta, axisExpandWindow, extent, "all") : behavior = "none";
        } else {
            var winSize2 = axisExpandWindow[1] - axisExpandWindow[0];
            var pos = extent[1] * pointCoord / winSize2;
            axisExpandWindow = [
                $a26a2212b9c3ac89$var$mathMax(0, pos - winSize2 / 2)
            ];
            axisExpandWindow[1] = $a26a2212b9c3ac89$var$mathMin(extent[1], axisExpandWindow[0] + winSize2);
            axisExpandWindow[0] = axisExpandWindow[1] - winSize2;
        }
        return {
            axisExpandWindow: axisExpandWindow,
            behavior: behavior
        };
    };
    return Parallel;
}();
function $a26a2212b9c3ac89$var$restrict(len, extent) {
    return $a26a2212b9c3ac89$var$mathMin($a26a2212b9c3ac89$var$mathMax(len, extent[0]), extent[1]);
}
function $a26a2212b9c3ac89$var$layoutAxisWithoutExpand(axisIndex, layoutInfo) {
    var step = layoutInfo.layoutLength / (layoutInfo.axisCount - 1);
    return {
        position: step * axisIndex,
        axisNameAvailableWidth: step,
        axisLabelShow: true
    };
}
function $a26a2212b9c3ac89$var$layoutAxisWithExpand(axisIndex, layoutInfo) {
    var layoutLength = layoutInfo.layoutLength;
    var axisExpandWidth = layoutInfo.axisExpandWidth;
    var axisCount = layoutInfo.axisCount;
    var axisCollapseWidth = layoutInfo.axisCollapseWidth;
    var winInnerIndices = layoutInfo.winInnerIndices;
    var position;
    var axisNameAvailableWidth = axisCollapseWidth;
    var axisLabelShow = false;
    var nameTruncateMaxWidth;
    if (axisIndex < winInnerIndices[0]) {
        position = axisIndex * axisCollapseWidth;
        nameTruncateMaxWidth = axisCollapseWidth;
    } else if (axisIndex <= winInnerIndices[1]) {
        position = layoutInfo.axisExpandWindow0Pos + axisIndex * axisExpandWidth - layoutInfo.axisExpandWindow[0];
        axisNameAvailableWidth = axisExpandWidth;
        axisLabelShow = true;
    } else {
        position = layoutLength - (axisCount - 1 - axisIndex) * axisCollapseWidth;
        nameTruncateMaxWidth = axisCollapseWidth;
    }
    return {
        position: position,
        axisNameAvailableWidth: axisNameAvailableWidth,
        axisLabelShow: axisLabelShow,
        nameTruncateMaxWidth: nameTruncateMaxWidth
    };
}
var $a26a2212b9c3ac89$export$2e2bcd8739ae039 = $a26a2212b9c3ac89$var$Parallel;



function $88531590cdbcfc26$var$createParallelCoordSys(ecModel, api) {
    var coordSysList = [];
    ecModel.eachComponent("parallel", function(parallelModel, idx) {
        var coordSys = new (0, $a26a2212b9c3ac89$export$2e2bcd8739ae039)(parallelModel, ecModel, api);
        coordSys.name = "parallel_" + idx;
        coordSys.resize(parallelModel, api);
        parallelModel.coordinateSystem = coordSys;
        coordSys.model = parallelModel;
        coordSysList.push(coordSys);
    });
    // Inject the coordinateSystems into seriesModel
    ecModel.eachSeries(function(seriesModel) {
        if (seriesModel.get("coordinateSystem") === "parallel") {
            var parallelModel = seriesModel.getReferringComponents("parallel", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
            seriesModel.coordinateSystem = parallelModel.coordinateSystem;
        }
    });
    return coordSysList;
}
var $88531590cdbcfc26$var$parallelCoordSysCreator = {
    create: $88531590cdbcfc26$var$createParallelCoordSys
};
var $88531590cdbcfc26$export$2e2bcd8739ae039 = $88531590cdbcfc26$var$parallelCoordSysCreator;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $ad861b9162f24222$var$defaultOption = {
    show: true,
    // zlevel: 0,
    z: 0,
    // Inverse the axis.
    inverse: false,
    // Axis name displayed.
    name: "",
    // 'start' | 'middle' | 'end'
    nameLocation: "end",
    // By degree. By default auto rotate by nameLocation.
    nameRotate: null,
    nameTruncate: {
        maxWidth: null,
        ellipsis: "...",
        placeholder: "."
    },
    // Use global text style by default.
    nameTextStyle: {
    },
    // The gap between axisName and axisLine.
    nameGap: 15,
    // Default `false` to support tooltip.
    silent: false,
    // Default `false` to avoid legacy user event listener fail.
    triggerEvent: false,
    tooltip: {
        show: false
    },
    axisPointer: {},
    axisLine: {
        show: true,
        onZero: true,
        onZeroAxisIndex: null,
        lineStyle: {
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.axisLine,
            width: 1,
            type: "solid"
        },
        // The arrow at both ends the the axis.
        symbol: [
            "none",
            "none"
        ],
        symbolSize: [
            10,
            15
        ],
        breakLine: true
    },
    axisTick: {
        show: true,
        // Whether axisTick is inside the grid or outside the grid.
        inside: false,
        // The length of axisTick.
        length: 5,
        lineStyle: {
            width: 1
        }
    },
    axisLabel: {
        show: true,
        // Whether axisLabel is inside the grid or outside the grid.
        inside: false,
        rotate: 0,
        // true | false | null/undefined (auto)
        showMinLabel: null,
        // true | false | null/undefined (auto)
        showMaxLabel: null,
        margin: 8,
        // formatter: null,
        fontSize: 12,
        color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.axisLabel,
        // In scenarios like axis labels, when labels text's progression direction matches the label
        // layout direction (e.g., when all letters are in a single line), extra start/end margin is
        // needed to prevent the text from appearing visually joined. In the other case, when lables
        // are stacked (e.g., having rotation or horizontal labels on yAxis), the layout needs to be
        // compact, so NO extra top/bottom margin should be applied.
        textMargin: [
            0,
            3
        ]
    },
    splitLine: {
        show: true,
        showMinLine: true,
        showMaxLine: true,
        lineStyle: {
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.axisSplitLine,
            width: 1,
            type: "solid"
        }
    },
    splitArea: {
        show: false,
        areaStyle: {
            color: [
                (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.backgroundTint,
                (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.backgroundTransparent
            ]
        }
    },
    breakArea: {
        show: true,
        itemStyle: {
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral00,
            // Break border color should be darker than the splitLine
            // because it has opacity and should be more prominent
            borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.border,
            borderWidth: 1,
            borderType: [
                3,
                3
            ],
            opacity: 0.6
        },
        zigzagAmplitude: 4,
        zigzagMinSpan: 4,
        zigzagMaxSpan: 20,
        zigzagZ: 100,
        expandOnClick: true
    },
    breakLabelLayout: {
        moveOverlap: "auto"
    }
};
var $ad861b9162f24222$var$categoryAxis = $7a1bd9c2710fea0d$export$4950aa0f605343fb({
    // The gap at both ends of the axis. For categoryAxis, boolean.
    boundaryGap: true,
    // Set false to faster category collection.
    deduplication: null,
    jitter: 0,
    jitterOverlap: true,
    jitterMargin: 2,
    // splitArea: {
    // show: false
    // },
    splitLine: {
        show: false
    },
    axisTick: {
        // If tick is align with label when boundaryGap is true
        alignWithLabel: false,
        interval: "auto",
        show: "auto"
    },
    axisLabel: {
        interval: "auto"
    }
}, $ad861b9162f24222$var$defaultOption);
var $ad861b9162f24222$var$valueAxis = $7a1bd9c2710fea0d$export$4950aa0f605343fb({
    boundaryGap: [
        0,
        0
    ],
    axisLine: {
        // Not shown when other axis is categoryAxis in cartesian
        show: "auto"
    },
    axisTick: {
        // Not shown when other axis is categoryAxis in cartesian
        show: "auto"
    },
    // TODO
    // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
    splitNumber: 5,
    minorTick: {
        // Minor tick, not available for cateogry axis.
        show: false,
        // Split number of minor ticks. The value should be in range of (0, 100)
        splitNumber: 5,
        // Length of minor tick
        length: 3,
        // Line style
        lineStyle: {
        }
    },
    minorSplitLine: {
        show: false,
        lineStyle: {
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.axisMinorSplitLine,
            width: 1
        }
    }
}, $ad861b9162f24222$var$defaultOption);
var $ad861b9162f24222$var$timeAxis = $7a1bd9c2710fea0d$export$4950aa0f605343fb({
    splitNumber: 6,
    axisLabel: {
        // To eliminate labels that are not nice
        showMinLabel: false,
        showMaxLabel: false,
        rich: {
            primary: {
                fontWeight: "bold"
            }
        }
    },
    splitLine: {
        show: false
    }
}, $ad861b9162f24222$var$valueAxis);
var $ad861b9162f24222$var$logAxis = $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
    logBase: 10
}, $ad861b9162f24222$var$valueAxis);
var $ad861b9162f24222$export$2e2bcd8739ae039 = {
    category: $ad861b9162f24222$var$categoryAxis,
    value: $ad861b9162f24222$var$valueAxis,
    time: $ad861b9162f24222$var$timeAxis,
    log: $ad861b9162f24222$var$logAxis
};




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $5dc621cc2f35ccb4$export$2e0057d176d6f690 = {
    value: 1,
    category: 1,
    time: 1,
    log: 1
};



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $0d1e9c0f651d5d16$var$_impl = null;
function $0d1e9c0f651d5d16$export$f5ec8c7ef7a59f4c(impl) {
    if (!$0d1e9c0f651d5d16$var$_impl) $0d1e9c0f651d5d16$var$_impl = impl;
}
function $0d1e9c0f651d5d16$export$c1d9b2cc33e7e5e() {
    return $0d1e9c0f651d5d16$var$_impl;
}


function $c5c4c85259d60abe$export$2e2bcd8739ae039(registers, axisName, BaseAxisModelClass, extraDefaultOption) {
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $5dc621cc2f35ccb4$export$2e0057d176d6f690), function(v, axisType) {
        var defaultOption = (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)((0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)({}, (0, $ad861b9162f24222$export$2e2bcd8739ae039)[axisType], true), extraDefaultOption, true);
        var AxisModel = /** @class */ function(_super) {
            (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(AxisModel, _super);
            function AxisModel() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.type = axisName + "Axis." + axisType;
                return _this;
            }
            AxisModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
                var layoutMode = (0, $93b9bc7f22ac7369$export$3968a28a7cbd6063)(this);
                var inputPositionParams = layoutMode ? (0, $93b9bc7f22ac7369$export$4b0d20af19c9875e)(option) : {};
                var themeModel = ecModel.getTheme();
                (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(option, themeModel.get(axisType + "Axis"));
                (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(option, this.getDefaultOption());
                option.type = $c5c4c85259d60abe$var$getAxisType(option);
                if (layoutMode) (0, $93b9bc7f22ac7369$export$1754cb91f16ca028)(option, inputPositionParams, layoutMode);
            };
            AxisModel.prototype.optionUpdated = function() {
                var thisOption = this.option;
                if (thisOption.type === "category") this.__ordinalMeta = (0, $57fe7cbbaae9fab0$export$2e2bcd8739ae039).createByAxisModel(this);
            };
            /**
       * Should not be called before all of 'getInitailData' finished.
       * Because categories are collected during initializing data.
       */ AxisModel.prototype.getCategories = function(rawData) {
                var option = this.option;
                // FIXME
                // warning if called before all of 'getInitailData' finished.
                if (option.type === "category") {
                    if (rawData) return option.data;
                    return this.__ordinalMeta.categories;
                }
            };
            AxisModel.prototype.getOrdinalMeta = function() {
                return this.__ordinalMeta;
            };
            AxisModel.prototype.updateAxisBreaks = function(payload) {
                var axisBreakHelper = (0, $0d1e9c0f651d5d16$export$c1d9b2cc33e7e5e)();
                return axisBreakHelper ? axisBreakHelper.updateModelAxisBreak(this, payload) : {
                    breaks: []
                };
            };
            AxisModel.type = axisName + "Axis." + axisType;
            AxisModel.defaultOption = defaultOption;
            return AxisModel;
        }(BaseAxisModelClass);
        registers.registerComponentModel(AxisModel);
    });
    registers.registerSubTypeDefaulter(axisName + "Axis", $c5c4c85259d60abe$var$getAxisType);
}
function $c5c4c85259d60abe$var$getAxisType(option) {
    // Default axis with data is category axis
    return option.type || (option.data ? "category" : "value");
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // eslint-disable-next-line @typescript-eslint/no-unused-vars
var $3449fd4c0590d99e$export$5c54b224726edb5a = /** @class */ function() {
    function AxisModelCommonMixin() {}
    AxisModelCommonMixin.prototype.getNeedCrossZero = function() {
        var option = this.option;
        return !option.scale;
    };
    /**
   * Should be implemented by each axis model if necessary.
   * @return coordinate system model
   */ AxisModelCommonMixin.prototype.getCoordSysModel = function() {
        return;
    };
    return AxisModelCommonMixin;
}();


var $839a50fcb1c6f44b$var$ParallelAxisModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ParallelAxisModel, _super);
    function ParallelAxisModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelAxisModel.type;
        /**
     * @readOnly
     */ _this.activeIntervals = [];
        return _this;
    }
    ParallelAxisModel.prototype.getAreaSelectStyle = function() {
        return (0, $06542048a26d4d91$export$2e2bcd8739ae039)([
            [
                "fill",
                "color"
            ],
            [
                "lineWidth",
                "borderWidth"
            ],
            [
                "stroke",
                "borderColor"
            ],
            [
                "width",
                "width"
            ],
            [
                "opacity",
                "opacity"
            ]
        ])(this.getModel("areaSelectStyle"));
    };
    /**
   * The code of this feature is put on AxisModel but not ParallelAxis,
   * because axisModel can be alive after echarts updating but instance of
   * ParallelAxis having been disposed. this._activeInterval should be kept
   * when action dispatched (i.e. legend click).
   *
   * @param intervals `interval.length === 0` means set all active.
   */ ParallelAxisModel.prototype.setActiveIntervals = function(intervals) {
        var activeIntervals = this.activeIntervals = $7a1bd9c2710fea0d$export$9cd59f9826255e47(intervals);
        // Normalize
        if (activeIntervals) for(var i = activeIntervals.length - 1; i >= 0; i--)$cfc1f3b422a3185f$export$debe6e778e0a6d32(activeIntervals[i]);
    };
    /**
   * @param value When only attempting detect whether 'no activeIntervals set',
   *        `value` is not needed to be input.
   */ ParallelAxisModel.prototype.getActiveState = function(value) {
        var activeIntervals = this.activeIntervals;
        if (!activeIntervals.length) return "normal";
        if (value == null || isNaN(+value)) return "inactive";
        // Simple optimization
        if (activeIntervals.length === 1) {
            var interval = activeIntervals[0];
            if (interval[0] <= value && value <= interval[1]) return "active";
        } else for(var i = 0, len = activeIntervals.length; i < len; i++){
            if (activeIntervals[i][0] <= value && value <= activeIntervals[i][1]) return "active";
        }
        return "inactive";
    };
    return ParallelAxisModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($839a50fcb1c6f44b$var$ParallelAxisModel, (0, $3449fd4c0590d99e$export$5c54b224726edb5a));
var $839a50fcb1c6f44b$export$2e2bcd8739ae039 = $839a50fcb1c6f44b$var$ParallelAxisModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $11dac7a73f36cc2c$var$LABEL_LAYOUT_BASE_PROPS = [
    "label",
    "labelLine",
    "layoutOption",
    "priority",
    "defaultAttr",
    "marginForce",
    "minMarginForce",
    "marginDefault",
    "suggestIgnore"
];
var $11dac7a73f36cc2c$var$LABEL_LAYOUT_DIRTY_BIT_OTHERS = 1;
var $11dac7a73f36cc2c$var$LABEL_LAYOUT_DIRTY_BIT_OBB = 2;
var $11dac7a73f36cc2c$var$LABEL_LAYOUT_DIRTY_ALL = $11dac7a73f36cc2c$var$LABEL_LAYOUT_DIRTY_BIT_OTHERS | $11dac7a73f36cc2c$var$LABEL_LAYOUT_DIRTY_BIT_OBB;
function $11dac7a73f36cc2c$export$1551ece3f059eafb(labelGeometry, dirtyOrClear, dirtyBits) {
    dirtyBits = dirtyBits || $11dac7a73f36cc2c$var$LABEL_LAYOUT_DIRTY_ALL;
    dirtyOrClear ? labelGeometry.dirty |= dirtyBits : labelGeometry.dirty &= ~dirtyBits;
}
function $11dac7a73f36cc2c$var$isLabelLayoutDirty(labelGeometry, dirtyBits) {
    dirtyBits = dirtyBits || $11dac7a73f36cc2c$var$LABEL_LAYOUT_DIRTY_ALL;
    return labelGeometry.dirty == null || !!(labelGeometry.dirty & dirtyBits);
}
function $11dac7a73f36cc2c$export$471916f4e89eb5da(labelLayout) {
    if (!labelLayout) return;
    if ($11dac7a73f36cc2c$var$isLabelLayoutDirty(labelLayout)) $11dac7a73f36cc2c$export$af9bffc2d00de2cc(labelLayout, labelLayout.label, labelLayout);
    return labelLayout;
}
function $11dac7a73f36cc2c$export$af9bffc2d00de2cc(out, label, opt) {
    // [CAUTION] These props may be modified directly for performance consideration,
    //  therefore, do not output the internal data structure of zrender Element.
    var rawTransform = label.getComputedTransform();
    out.transform = (0, $5b455ae6f843ac47$export$4d61283a070e0362)(out.transform, rawTransform);
    // NOTE: should call `getBoundingRect` after `getComputedTransform`, or may get an inaccurate bounding rect.
    //  The reason is that `getComputedTransform` calls `__host.updateInnerText()` internally, which updates the label
    //  by `textConfig` mounted on the host.
    // PENDING: add a dirty bit for that in zrender?
    var outLocalRect = out.localRect = (0, $5b455ae6f843ac47$export$38128dfd9a498e1)(out.localRect, label.getBoundingRect());
    var labelStyleExt = label.style;
    var margin = labelStyleExt.margin;
    var marginForce = opt && opt.marginForce;
    var minMarginForce = opt && opt.minMarginForce;
    var marginDefault = opt && opt.marginDefault;
    var marginType = labelStyleExt.__marginType;
    if (marginType == null && marginDefault) {
        margin = marginDefault;
        marginType = (0, $6800dfcb6e1e2a44$export$2b18df2bc75ae422).textMargin;
    }
    // `textMargin` and `minMargin` can not exist both.
    for(var i = 0; i < 4; i++)$11dac7a73f36cc2c$var$_tmpLabelMargin[i] = marginType === (0, $6800dfcb6e1e2a44$export$2b18df2bc75ae422).minMargin && minMarginForce && minMarginForce[i] != null ? minMarginForce[i] : marginForce && marginForce[i] != null ? marginForce[i] : margin ? margin[i] : 0;
    if (marginType === (0, $6800dfcb6e1e2a44$export$2b18df2bc75ae422).textMargin) (0, $5b455ae6f843ac47$export$81ed941fdeb91c7c)(outLocalRect, $11dac7a73f36cc2c$var$_tmpLabelMargin, false, false);
    var outGlobalRect = out.rect = (0, $5b455ae6f843ac47$export$38128dfd9a498e1)(out.rect, outLocalRect);
    if (rawTransform) outGlobalRect.applyTransform(rawTransform);
    // Notice: label.style.margin is actually `minMargin / 2`, handled by `setTextStyleCommon`.
    if (marginType === (0, $6800dfcb6e1e2a44$export$2b18df2bc75ae422).minMargin) (0, $5b455ae6f843ac47$export$81ed941fdeb91c7c)(outGlobalRect, $11dac7a73f36cc2c$var$_tmpLabelMargin, false, false);
    out.axisAligned = (0, $5b455ae6f843ac47$export$576610ccf2234b72)(rawTransform);
    (out.label = out.label || {}).ignore = label.ignore;
    $11dac7a73f36cc2c$export$1551ece3f059eafb(out, false);
    $11dac7a73f36cc2c$export$1551ece3f059eafb(out, true, $11dac7a73f36cc2c$var$LABEL_LAYOUT_DIRTY_BIT_OBB);
    // Do not remove `obb` (if existing) for reuse, just reset the dirty bit.
    return out;
}
var $11dac7a73f36cc2c$var$_tmpLabelMargin = [
    0,
    0,
    0,
    0
];
function $11dac7a73f36cc2c$export$bc37ae3f8412d105(out, rawLocalRect, rawTransform) {
    out.transform = (0, $5b455ae6f843ac47$export$4d61283a070e0362)(out.transform, rawTransform);
    out.localRect = (0, $5b455ae6f843ac47$export$38128dfd9a498e1)(out.localRect, rawLocalRect);
    out.rect = (0, $5b455ae6f843ac47$export$38128dfd9a498e1)(out.rect, rawLocalRect);
    if (rawTransform) out.rect.applyTransform(rawTransform);
    out.axisAligned = (0, $5b455ae6f843ac47$export$576610ccf2234b72)(rawTransform);
    out.obb = undefined; // Reset to undefined, will be created by `ensureOBB` when using.
    (out.label = out.label || {}).ignore = false;
    return out;
}
function $11dac7a73f36cc2c$export$91f733c27ab0712f(labelLayout, offset) {
    if (!labelLayout) return;
    labelLayout.label.x += offset.x;
    labelLayout.label.y += offset.y;
    labelLayout.label.markRedraw();
    var transform = labelLayout.transform;
    if (transform) {
        transform[4] += offset.x;
        transform[5] += offset.y;
    }
    var globalRect = labelLayout.rect;
    if (globalRect) {
        globalRect.x += offset.x;
        globalRect.y += offset.y;
    }
    var obb = labelLayout.obb;
    if (obb) obb.fromBoundingRect(labelLayout.localRect, transform);
}
function $11dac7a73f36cc2c$export$a1cfd37e9b88106b(newBaseWithDefaults, source) {
    for(var i = 0; i < $11dac7a73f36cc2c$var$LABEL_LAYOUT_BASE_PROPS.length; i++){
        var prop = $11dac7a73f36cc2c$var$LABEL_LAYOUT_BASE_PROPS[i];
        if (newBaseWithDefaults[prop] == null) newBaseWithDefaults[prop] = source[prop];
    }
    return $11dac7a73f36cc2c$export$471916f4e89eb5da(newBaseWithDefaults);
}
/**
 * Create obb if no one, can cache it.
 */ function $11dac7a73f36cc2c$var$ensureOBB(labelGeometry) {
    var obb = labelGeometry.obb;
    if (!obb || $11dac7a73f36cc2c$var$isLabelLayoutDirty(labelGeometry, $11dac7a73f36cc2c$var$LABEL_LAYOUT_DIRTY_BIT_OBB)) {
        labelGeometry.obb = obb = obb || new (0, $f9793b4d8aade116$export$2e2bcd8739ae039)();
        obb.fromBoundingRect(labelGeometry.localRect, labelGeometry.transform);
        $11dac7a73f36cc2c$export$1551ece3f059eafb(labelGeometry, false, $11dac7a73f36cc2c$var$LABEL_LAYOUT_DIRTY_BIT_OBB);
    }
    return obb;
}
function $11dac7a73f36cc2c$export$73ee08bc808f6f3f(list, xyDimIdx, // 0 for x, 1 for y
minBound, // for x, leftBound; for y, topBound
maxBound, // for x, rightBound; for y, bottomBound
// If average the shifts on all labels and add them to 0
// TODO: Not sure if should enable it.
// Pros: The angle of lines will distribute more equally
// Cons: In some layout. It may not what user wanted. like in pie. the label of last sector is usually changed unexpectedly.
balanceShift) {
    var len = list.length;
    var xyDim = (0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[xyDimIdx];
    var sizeDim = (0, $5b455ae6f843ac47$export$a3fe6d967173a3ac)[xyDimIdx];
    if (len < 2) return false;
    list.sort(function(a, b) {
        return a.rect[xyDim] - b.rect[xyDim];
    });
    var lastPos = 0;
    var delta;
    var adjusted = false;
    // const shifts = [];
    var totalShifts = 0;
    for(var i = 0; i < len; i++){
        var item = list[i];
        var rect = item.rect;
        delta = rect[xyDim] - lastPos;
        if (delta < 0) {
            // shiftForward(i, len, -delta);
            rect[xyDim] -= delta;
            item.label[xyDim] -= delta;
            adjusted = true;
        }
        var shift = Math.max(-delta, 0);
        // shifts.push(shift);
        totalShifts += shift;
        lastPos = rect[xyDim] + rect[sizeDim];
    }
    if (totalShifts > 0 && balanceShift) // Shift back to make the distribution more equally.
    shiftList(-totalShifts / len, 0, len);
    // TODO bleedMargin?
    var first = list[0];
    var last = list[len - 1];
    var minGap;
    var maxGap;
    updateMinMaxGap();
    // If ends exceed two bounds, squeeze at most 80%, then take the gap of two bounds.
    minGap < 0 && squeezeGaps(-minGap, 0.8);
    maxGap < 0 && squeezeGaps(maxGap, 0.8);
    updateMinMaxGap();
    takeBoundsGap(minGap, maxGap, 1);
    takeBoundsGap(maxGap, minGap, -1);
    // Handle bailout when there is not enough space.
    updateMinMaxGap();
    if (minGap < 0) squeezeWhenBailout(-minGap);
    if (maxGap < 0) squeezeWhenBailout(maxGap);
    function updateMinMaxGap() {
        minGap = first.rect[xyDim] - minBound;
        maxGap = maxBound - last.rect[xyDim] - last.rect[sizeDim];
    }
    function takeBoundsGap(gapThisBound, gapOtherBound, moveDir) {
        if (gapThisBound < 0) {
            // Move from other gap if can.
            var moveFromMaxGap = Math.min(gapOtherBound, -gapThisBound);
            if (moveFromMaxGap > 0) {
                shiftList(moveFromMaxGap * moveDir, 0, len);
                var remained = moveFromMaxGap + gapThisBound;
                if (remained < 0) squeezeGaps(-remained * moveDir, 1);
            } else squeezeGaps(-gapThisBound * moveDir, 1);
        }
    }
    function shiftList(delta, start, end) {
        if (delta !== 0) adjusted = true;
        for(var i = start; i < end; i++){
            var item = list[i];
            var rect = item.rect;
            rect[xyDim] += delta;
            item.label[xyDim] += delta;
        }
    }
    // Squeeze gaps if the labels exceed margin.
    function squeezeGaps(delta, maxSqeezePercent) {
        var gaps = [];
        var totalGaps = 0;
        for(var i = 1; i < len; i++){
            var prevItemRect = list[i - 1].rect;
            var gap = Math.max(list[i].rect[xyDim] - prevItemRect[xyDim] - prevItemRect[sizeDim], 0);
            gaps.push(gap);
            totalGaps += gap;
        }
        if (!totalGaps) return;
        var squeezePercent = Math.min(Math.abs(delta) / totalGaps, maxSqeezePercent);
        if (delta > 0) for(var i = 0; i < len - 1; i++){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i] * squeezePercent;
            // Forward
            shiftList(movement, 0, i + 1);
        }
        else // Backward
        for(var i = len - 1; i > 0; i--){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i - 1] * squeezePercent;
            shiftList(-movement, i, len);
        }
    }
    /**
   * Squeeze to allow overlap if there is no more space available.
   * Let other overlapping strategy like hideOverlap do the job instead of keep exceeding the bounds.
   */ function squeezeWhenBailout(delta) {
        var dir = delta < 0 ? -1 : 1;
        delta = Math.abs(delta);
        var moveForEachLabel = Math.ceil(delta / (len - 1));
        for(var i = 0; i < len - 1; i++){
            if (dir > 0) // Forward
            shiftList(moveForEachLabel, 0, i + 1);
            else // Backward
            shiftList(-moveForEachLabel, len - i - 1, len);
            delta -= moveForEachLabel;
            if (delta <= 0) return;
        }
    }
    return adjusted;
}
function $11dac7a73f36cc2c$export$ff775ae4fbb23435(labelList) {
    for(var i = 0; i < labelList.length; i++){
        var labelItem = labelList[i];
        var defaultAttr = labelItem.defaultAttr;
        var labelLine = labelItem.labelLine;
        labelItem.label.attr("ignore", defaultAttr.ignore);
        labelLine && labelLine.attr("ignore", defaultAttr.labelGuideIgnore);
    }
}
function $11dac7a73f36cc2c$export$8ce774e164a49410(labelList) {
    var displayedLabels = [];
    // TODO, render overflow visible first, put in the displayedLabels.
    labelList.sort(function(a, b) {
        return (b.suggestIgnore ? 1 : 0) - (a.suggestIgnore ? 1 : 0) || b.priority - a.priority;
    });
    function hideEl(el) {
        if (!el.ignore) {
            // Show on emphasis.
            var emphasisState = el.ensureState("emphasis");
            if (emphasisState.ignore == null) emphasisState.ignore = false;
        }
        el.ignore = true;
    }
    for(var i = 0; i < labelList.length; i++){
        var labelItem = $11dac7a73f36cc2c$export$471916f4e89eb5da(labelList[i]);
        // The current `el.ignore` is involved, since some previous overlap
        // resolving strategies may have set `el.ignore` to true.
        if (labelItem.label.ignore) continue;
        var label = labelItem.label;
        var labelLine = labelItem.labelLine;
        // NOTICE: even when the with/height of globalRect of a label is 0, the label line should
        // still be displayed, since we should follow the concept of "truncation", meaning that
        // something exists even if it cannot be fully displayed. A visible label line is necessary
        // to allow users to get a tooltip with label info on hover.
        var overlapped = false;
        for(var j = 0; j < displayedLabels.length; j++)if ($11dac7a73f36cc2c$export$f28bfabef115ba96(labelItem, displayedLabels[j], null, {
            touchThreshold: 0.05
        })) {
            overlapped = true;
            break;
        }
        // TODO Callback to determine if this overlap should be handled?
        if (overlapped) {
            hideEl(label);
            labelLine && hideEl(labelLine);
        } else displayedLabels.push(labelItem);
    }
}
function $11dac7a73f36cc2c$export$f28bfabef115ba96(baseLayoutInfo, targetLayoutInfo, mtv, intersectOpt) {
    if (!baseLayoutInfo || !targetLayoutInfo) return false;
    if (baseLayoutInfo.label && baseLayoutInfo.label.ignore || targetLayoutInfo.label && targetLayoutInfo.label.ignore) return false;
    // Fast rejection.
    if (!baseLayoutInfo.rect.intersect(targetLayoutInfo.rect, mtv, intersectOpt)) return false;
    if (baseLayoutInfo.axisAligned && targetLayoutInfo.axisAligned) return true; // obb is the same as the normal bounding rect.
    return $11dac7a73f36cc2c$var$ensureOBB(baseLayoutInfo).intersect($11dac7a73f36cc2c$var$ensureOBB(targetLayoutInfo), mtv, intersectOpt);
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $6a77b1cfe2c04bae$export$12319e2083cd71ce = "expandAxisBreak";
var $6a77b1cfe2c04bae$export$8ba710d11f5d9b28 = "collapseAxisBreak";
var $6a77b1cfe2c04bae$export$cfaa507333440c5e = "toggleAxisBreak";
var $6a77b1cfe2c04bae$var$AXIS_BREAK_CHANGED_EVENT_TYPE = "axisbreakchanged";
var $6a77b1cfe2c04bae$var$expandAxisBreakActionInfo = {
    type: $6a77b1cfe2c04bae$export$12319e2083cd71ce,
    event: $6a77b1cfe2c04bae$var$AXIS_BREAK_CHANGED_EVENT_TYPE,
    update: "update",
    refineEvent: $6a77b1cfe2c04bae$var$refineAxisBreakChangeEvent
};
var $6a77b1cfe2c04bae$var$collapseAxisBreakActionInfo = {
    type: $6a77b1cfe2c04bae$export$8ba710d11f5d9b28,
    event: $6a77b1cfe2c04bae$var$AXIS_BREAK_CHANGED_EVENT_TYPE,
    update: "update",
    refineEvent: $6a77b1cfe2c04bae$var$refineAxisBreakChangeEvent
};
var $6a77b1cfe2c04bae$var$toggleAxisBreakActionInfo = {
    type: $6a77b1cfe2c04bae$export$cfaa507333440c5e,
    event: $6a77b1cfe2c04bae$var$AXIS_BREAK_CHANGED_EVENT_TYPE,
    update: "update",
    refineEvent: $6a77b1cfe2c04bae$var$refineAxisBreakChangeEvent
};
function $6a77b1cfe2c04bae$var$refineAxisBreakChangeEvent(actionResultBatch, payload, ecModel, api) {
    var breaks = [];
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(actionResultBatch, function(actionResult) {
        breaks = breaks.concat(actionResult.eventBreaks);
    });
    return {
        eventContent: {
            breaks: breaks
        }
    };
}
function $6a77b1cfe2c04bae$export$408c24786cd729c6(registers) {
    registers.registerAction($6a77b1cfe2c04bae$var$expandAxisBreakActionInfo, actionHandler);
    registers.registerAction($6a77b1cfe2c04bae$var$collapseAxisBreakActionInfo, actionHandler);
    registers.registerAction($6a77b1cfe2c04bae$var$toggleAxisBreakActionInfo, actionHandler);
    function actionHandler(payload, ecModel) {
        var eventBreaks = [];
        var finderResult = (0, $76d619f648247e6d$export$95de80076abac814)(ecModel, payload);
        function dealUpdate(modelProp, indexProp) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(finderResult[modelProp], function(axisModel) {
                var result = axisModel.updateAxisBreaks(payload);
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(result.breaks, function(item) {
                    var _a;
                    eventBreaks.push((0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)((_a = {}, _a[indexProp] = axisModel.componentIndex, _a), item));
                });
            });
        }
        dealUpdate("xAxisModels", "xAxisIndex");
        dealUpdate("yAxisModels", "yAxisIndex");
        dealUpdate("singleAxisModels", "singleAxisIndex");
        return {
            eventBreaks: eventBreaks
        };
    }
}







var $dfe15f745e1c3c2b$var$PI = Math.PI;
var $dfe15f745e1c3c2b$var$DEFAULT_CENTER_NAME_MARGIN_LEVELS = [
    [
        1,
        2,
        1,
        2
    ],
    [
        5,
        3,
        5,
        3
    ],
    [
        8,
        3,
        8,
        3
    ]
];
var $dfe15f745e1c3c2b$var$DEFAULT_ENDS_NAME_MARGIN_LEVELS = [
    [
        0,
        1,
        0,
        1
    ],
    [
        0,
        3,
        0,
        3
    ],
    [
        0,
        3,
        0,
        3
    ]
];
var $dfe15f745e1c3c2b$export$c392b818a26a879e = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $dfe15f745e1c3c2b$var$getTickInner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
/**
 * A context shared by difference axisBuilder instances.
 * For cross-axes overlap resolving.
 *
 * Lifecycle constraint: should not over a pass of ec main process.
 *  If model is changed, the context must be disposed.
 *
 * @see AxisBuilderLocalContext
 */ var $dfe15f745e1c3c2b$export$f2e237206f7393f5 = /** @class */ function() {
    function AxisBuilderSharedContext(resolveAxisNameOverlap) {
        /**
     * [CAUTION] Do not modify this data structure outside this class.
     */ this.recordMap = {};
        this.resolveAxisNameOverlap = resolveAxisNameOverlap;
    }
    AxisBuilderSharedContext.prototype.ensureRecord = function(axisModel) {
        var dim = axisModel.axis.dim;
        var idx = axisModel.componentIndex;
        var recordMap = this.recordMap;
        var records = recordMap[dim] || (recordMap[dim] = []);
        return records[idx] || (records[idx] = {
            ready: {}
        });
    };
    return AxisBuilderSharedContext;
}();
/**
 * [CAUTION]
 *  1. The call of this function must be after axisLabel overlap handlings
 *     (such as `hideOverlap`, `fixMinMaxLabelShow`) and after transform calculating.
 *  2. Can be called multiple times and should be idempotent.
 */ function $dfe15f745e1c3c2b$var$resetOverlapRecordToShared(cfg, shared, axisModel, labelLayoutList) {
    var axis = axisModel.axis;
    var record = shared.ensureRecord(axisModel);
    var labelInfoList = [];
    var stOccupiedRect;
    var useStOccupiedRect = $dfe15f745e1c3c2b$var$hasAxisName(cfg.axisName) && (0, $2d646e51cc34f840$export$c06aa22293dea9d2)(cfg.nameLocation);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(labelLayoutList, function(layout) {
        var layoutInfo = (0, $11dac7a73f36cc2c$export$471916f4e89eb5da)(layout);
        if (!layoutInfo || layoutInfo.label.ignore) return;
        labelInfoList.push(layoutInfo);
        var transGroup = record.transGroup;
        if (useStOccupiedRect) {
            // Transform to "standard axis" for creating stOccupiedRect (the label rects union).
            transGroup.transform ? $f41ebb9dd60b55b4$export$6897c284b6f9f4dc($dfe15f745e1c3c2b$var$_stTransTmp, transGroup.transform) : $f41ebb9dd60b55b4$export$f0954fd7d5368655($dfe15f745e1c3c2b$var$_stTransTmp);
            if (layoutInfo.transform) $f41ebb9dd60b55b4$export$6e3a27864ab166fe($dfe15f745e1c3c2b$var$_stTransTmp, $dfe15f745e1c3c2b$var$_stTransTmp, layoutInfo.transform);
            (0, $1bebe7106c895823$export$2e2bcd8739ae039).copy($dfe15f745e1c3c2b$var$_stLabelRectTmp, layoutInfo.localRect);
            $dfe15f745e1c3c2b$var$_stLabelRectTmp.applyTransform($dfe15f745e1c3c2b$var$_stTransTmp);
            stOccupiedRect ? stOccupiedRect.union($dfe15f745e1c3c2b$var$_stLabelRectTmp) : (0, $1bebe7106c895823$export$2e2bcd8739ae039).copy(stOccupiedRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0), $dfe15f745e1c3c2b$var$_stLabelRectTmp);
        }
    });
    var sortByDim = Math.abs(record.dirVec.x) > 0.1 ? "x" : "y";
    var sortByValue = record.transGroup[sortByDim];
    labelInfoList.sort(function(info1, info2) {
        return Math.abs(info1.label[sortByDim] - sortByValue) - Math.abs(info2.label[sortByDim] - sortByValue);
    });
    if (useStOccupiedRect && stOccupiedRect) {
        var extent = axis.getExtent();
        var axisLineX = Math.min(extent[0], extent[1]);
        var axisLineWidth = Math.max(extent[0], extent[1]) - axisLineX;
        // If `nameLocation` is 'middle', enlarge axis labels boundingRect to axisLine to avoid bad
        //  case like that axis name is placed in the gap between axis labels and axis line.
        // If only one label exists, the entire band should be occupied for
        // visual consistency, so extent it to [0, canvas width].
        stOccupiedRect.union(new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(axisLineX, 0, axisLineWidth, 1));
    }
    record.stOccupiedRect = stOccupiedRect;
    record.labelInfoList = labelInfoList;
}
var $dfe15f745e1c3c2b$var$_stTransTmp = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
var $dfe15f745e1c3c2b$var$_stLabelRectTmp = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $dfe15f745e1c3c2b$export$7fcb8742f5816cae = function(cfg, ctx, axisModel, nameLayoutInfo, nameMoveDirVec, thisRecord) {
    if ((0, $2d646e51cc34f840$export$c06aa22293dea9d2)(cfg.nameLocation)) {
        var stOccupiedRect = thisRecord.stOccupiedRect;
        if (stOccupiedRect) $dfe15f745e1c3c2b$var$moveIfOverlap((0, $11dac7a73f36cc2c$export$bc37ae3f8412d105)({}, stOccupiedRect, thisRecord.transGroup.transform), nameLayoutInfo, nameMoveDirVec);
    } else $dfe15f745e1c3c2b$export$e033c6449cc6f6a1(thisRecord.labelInfoList, thisRecord.dirVec, nameLayoutInfo, nameMoveDirVec);
};
// [NOTICE] not consider ignore.
function $dfe15f745e1c3c2b$var$moveIfOverlap(basedLayoutInfo, movableLayoutInfo, moveDirVec) {
    var mtv = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
    if ((0, $11dac7a73f36cc2c$export$f28bfabef115ba96)(basedLayoutInfo, movableLayoutInfo, mtv, {
        direction: Math.atan2(moveDirVec.y, moveDirVec.x),
        bidirectional: false,
        touchThreshold: 0.05
    })) (0, $11dac7a73f36cc2c$export$91f733c27ab0712f)(movableLayoutInfo, mtv);
}
function $dfe15f745e1c3c2b$export$e033c6449cc6f6a1(baseLayoutInfoList, baseDirVec, movableLayoutInfo, moveDirVec) {
    // Detect and move from far to close.
    var sameDir = (0, $b887f038f104fe7e$export$2e2bcd8739ae039).dot(moveDirVec, baseDirVec) >= 0;
    for(var idx = 0, len = baseLayoutInfoList.length; idx < len; idx++){
        var labelInfo = baseLayoutInfoList[sameDir ? idx : len - 1 - idx];
        if (!labelInfo.label.ignore) $dfe15f745e1c3c2b$var$moveIfOverlap(labelInfo, movableLayoutInfo, moveDirVec);
    }
}
/**
 * @caution
 * - Ensure it is called after the data processing stage finished.
 * - It might be called before `CahrtView#render`, sush as called at `CoordinateSystem#update`,
 *  thus ensure the result the same whenever it is called.
 *
 * A builder for a straight-line axis.
 *
 * A final axis is translated and rotated from a "standard axis".
 * So opt.position and opt.rotation is required.
 *
 * A "standard axis" is the axis [0,0]-->[abs(axisExtent[1]-axisExtent[0]),0]
 * for example: [0,0]-->[50,0]
 */ var $dfe15f745e1c3c2b$var$AxisBuilder = /** @class */ function() {
    /**
   * [CAUTION]: axisModel.axis.extent/scale must be ready to use.
   */ function AxisBuilder(axisModel, api, opt, shared) {
        this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this._axisModel = axisModel;
        this._api = api;
        this._local = {};
        this._shared = shared || new $dfe15f745e1c3c2b$export$f2e237206f7393f5($dfe15f745e1c3c2b$export$7fcb8742f5816cae);
        this._resetCfgDetermined(opt);
    }
    /**
   * Regarding axis label related configurations, only the change of label.x/y is supported; other
   * changes are not necessary and not performant. To be specific, only `axis.position`
   * (and consequently `labelOffset`) and `axis.extent` can be changed, and assume everything in
   * `axisModel` are not changed.
   * Axis line related configurations can be changed since this method can only be called
   * before they are created.
   */ AxisBuilder.prototype.updateCfg = function(opt) {
        var ready;
        var raw = this._cfg.raw;
        raw.position = opt.position;
        raw.labelOffset = opt.labelOffset;
        this._resetCfgDetermined(raw);
    };
    /**
   * [CAUTION] For debug usage. Never change it outside!
   */ AxisBuilder.prototype.__getRawCfg = function() {
        return this._cfg.raw;
    };
    AxisBuilder.prototype._resetCfgDetermined = function(raw) {
        var axisModel = this._axisModel;
        // FIXME:
        //  Currently there is no uniformed way to set default values if an option
        //  is specified null/undefined by user (intentionally or unintentionally),
        //  e.g. null/undefined is not a illegal value for `nameLocation`.
        //  Try to use `getDefaultOption` to address it. But radar has no `getDefaultOption`.
        var axisModelDefaultOption = axisModel.getDefaultOption ? axisModel.getDefaultOption() : {};
        // Default value
        var axisName = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(raw.axisName, axisModel.get("name"));
        var nameMoveOverlapOption = axisModel.get("nameMoveOverlap");
        if (nameMoveOverlapOption == null || nameMoveOverlapOption === "auto") nameMoveOverlapOption = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(raw.defaultNameMoveOverlap, true);
        var cfg = {
            raw: raw,
            position: raw.position,
            rotation: raw.rotation,
            nameDirection: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(raw.nameDirection, 1),
            tickDirection: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(raw.tickDirection, 1),
            labelDirection: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(raw.labelDirection, 1),
            labelOffset: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(raw.labelOffset, 0),
            silent: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(raw.silent, true),
            axisName: axisName,
            nameLocation: (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(axisModel.get("nameLocation"), axisModelDefaultOption.nameLocation, "end"),
            shouldNameMoveOverlap: $dfe15f745e1c3c2b$var$hasAxisName(axisName) && nameMoveOverlapOption,
            optionHideOverlap: axisModel.get([
                "axisLabel",
                "hideOverlap"
            ]),
            showMinorTicks: axisModel.get([
                "minorTick",
                "show"
            ])
        };
        this._cfg = cfg;
        // FIXME Not use a separate text group?
        var transformGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039({
            x: cfg.position[0],
            y: cfg.position[1],
            rotation: cfg.rotation
        });
        transformGroup.updateTransform();
        this._transformGroup = transformGroup;
        var record = this._shared.ensureRecord(axisModel);
        record.transGroup = this._transformGroup;
        record.dirVec = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(Math.cos(-cfg.rotation), Math.sin(-cfg.rotation));
    };
    AxisBuilder.prototype.build = function(axisPartNameMap, extraParams) {
        var _this = this;
        if (!axisPartNameMap) axisPartNameMap = {
            axisLine: true,
            axisTickLabelEstimate: false,
            axisTickLabelDetermine: true,
            axisName: true
        };
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($dfe15f745e1c3c2b$var$AXIS_BUILDER_AXIS_PART_NAMES, function(partName) {
            if (axisPartNameMap[partName]) $dfe15f745e1c3c2b$var$builders[partName](_this._cfg, _this._local, _this._shared, _this._axisModel, _this.group, _this._transformGroup, _this._api, extraParams || {});
        });
        return this;
    };
    /**
   * Currently only get text align/verticalAlign by rotation.
   * NO `position` is involved, otherwise it have to be performed for each `updateAxisLabelChangableProps`.
   */ AxisBuilder.innerTextLayout = function(axisRotation, textRotation, direction) {
        var rotationDiff = (0, $cfc1f3b422a3185f$export$2ca6dd70a288b1c3)(textRotation - axisRotation);
        var textAlign;
        var textVerticalAlign;
        if ((0, $cfc1f3b422a3185f$export$d1df570aea2868f)(rotationDiff)) {
            // Label is parallel with axis line.
            textVerticalAlign = direction > 0 ? "top" : "bottom";
            textAlign = "center";
        } else if ((0, $cfc1f3b422a3185f$export$d1df570aea2868f)(rotationDiff - $dfe15f745e1c3c2b$var$PI)) {
            // Label is inverse parallel with axis line.
            textVerticalAlign = direction > 0 ? "bottom" : "top";
            textAlign = "center";
        } else {
            textVerticalAlign = "middle";
            if (rotationDiff > 0 && rotationDiff < $dfe15f745e1c3c2b$var$PI) textAlign = direction > 0 ? "right" : "left";
            else textAlign = direction > 0 ? "left" : "right";
        }
        return {
            rotation: rotationDiff,
            textAlign: textAlign,
            textVerticalAlign: textVerticalAlign
        };
    };
    AxisBuilder.makeAxisEventDataBase = function(axisModel) {
        var eventData = {
            componentType: axisModel.mainType,
            componentIndex: axisModel.componentIndex
        };
        eventData[axisModel.mainType + "Index"] = axisModel.componentIndex;
        return eventData;
    };
    AxisBuilder.isLabelSilent = function(axisModel) {
        var tooltipOpt = axisModel.get("tooltip");
        return axisModel.get("silent") || !(axisModel.get("triggerEvent") || tooltipOpt && tooltipOpt.show);
    };
    return AxisBuilder;
}();
// Sorted by dependency order.
var $dfe15f745e1c3c2b$var$AXIS_BUILDER_AXIS_PART_NAMES = [
    "axisLine",
    "axisTickLabelEstimate",
    "axisTickLabelDetermine",
    "axisName"
];
var $dfe15f745e1c3c2b$var$builders = {
    axisLine: function(cfg, local, shared, axisModel, group, transformGroup, api) {
        var ready;
        var shown = axisModel.get([
            "axisLine",
            "show"
        ]);
        if (shown === "auto") {
            shown = true;
            if (cfg.raw.axisLineAutoShow != null) shown = !!cfg.raw.axisLineAutoShow;
        }
        if (!shown) return;
        var extent = axisModel.axis.getExtent();
        var matrix = transformGroup.transform;
        var pt1 = [
            extent[0],
            0
        ];
        var pt2 = [
            extent[1],
            0
        ];
        var inverse = pt1[0] > pt2[0];
        if (matrix) {
            (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(pt1, pt1, matrix);
            (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(pt2, pt2, matrix);
        }
        var lineStyle = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
            lineCap: "round"
        }, axisModel.getModel([
            "axisLine",
            "lineStyle"
        ]).getLineStyle());
        var pathBaseProp = {
            strokeContainThreshold: cfg.raw.strokeContainThreshold || 5,
            silent: true,
            z2: 1,
            style: lineStyle
        };
        if (axisModel.get([
            "axisLine",
            "breakLine"
        ]) && axisModel.axis.scale.hasBreaks()) (0, $0d1e9c0f651d5d16$export$c1d9b2cc33e7e5e)().buildAxisBreakLine(axisModel, group, transformGroup, pathBaseProp);
        else {
            var line = new $7a316ae5ceff7b27$export$2e2bcd8739ae039((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
                shape: {
                    x1: pt1[0],
                    y1: pt1[1],
                    x2: pt2[0],
                    y2: pt2[1]
                }
            }, pathBaseProp));
            $5b455ae6f843ac47$export$8b4b620d7f4aad1b(line.shape, line.style.lineWidth);
            line.anid = "line";
            group.add(line);
        }
        var arrows = axisModel.get([
            "axisLine",
            "symbol"
        ]);
        if (arrows != null) {
            var arrowSize = axisModel.get([
                "axisLine",
                "symbolSize"
            ]);
            if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(arrows)) // Use the same arrow for start and end point
            arrows = [
                arrows,
                arrows
            ];
            if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(arrowSize) || (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(arrowSize)) // Use the same size for width and height
            arrowSize = [
                arrowSize,
                arrowSize
            ];
            var arrowOffset = (0, $5370466dadc978d7$export$e3e292895c033f6d)(axisModel.get([
                "axisLine",
                "symbolOffset"
            ]) || 0, arrowSize);
            var symbolWidth_1 = arrowSize[0];
            var symbolHeight_1 = arrowSize[1];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
                {
                    rotate: cfg.rotation + Math.PI / 2,
                    offset: arrowOffset[0],
                    r: 0
                },
                {
                    rotate: cfg.rotation - Math.PI / 2,
                    offset: arrowOffset[1],
                    r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
                }
            ], function(point, index) {
                if (arrows[index] !== "none" && arrows[index] != null) {
                    var symbol = (0, $5370466dadc978d7$export$af050e04da3a02e8)(arrows[index], -symbolWidth_1 / 2, -symbolHeight_1 / 2, symbolWidth_1, symbolHeight_1, lineStyle.stroke, true);
                    // Calculate arrow position with offset
                    var r = point.r + point.offset;
                    var pt = inverse ? pt2 : pt1;
                    symbol.attr({
                        rotation: point.rotate,
                        x: pt[0] + r * Math.cos(cfg.rotation),
                        y: pt[1] - r * Math.sin(cfg.rotation),
                        silent: true,
                        z2: 11
                    });
                    group.add(symbol);
                }
            });
        }
    },
    /**
   * [CAUTION] This method can be called multiple times, following the change due to `resetCfg` called
   *  in size measurement. Thus this method should be idempotent, and should be performant.
   */ axisTickLabelEstimate: function(cfg, local, shared, axisModel, group, transformGroup, api, extraParams) {
        var ready;
        var needCallLayout = $dfe15f745e1c3c2b$var$dealLastTickLabelResultReusable(local, group, extraParams);
        if (needCallLayout) $dfe15f745e1c3c2b$var$layOutAxisTickLabel(cfg, local, shared, axisModel, group, transformGroup, api, (0, $6a439e51dccdc432$export$31cba7db0a663292).estimate);
    },
    /**
   * Finish axis tick label build.
   * Can be only called once.
   */ axisTickLabelDetermine: function(cfg, local, shared, axisModel, group, transformGroup, api, extraParams) {
        var ready;
        var needCallLayout = $dfe15f745e1c3c2b$var$dealLastTickLabelResultReusable(local, group, extraParams);
        if (needCallLayout) $dfe15f745e1c3c2b$var$layOutAxisTickLabel(cfg, local, shared, axisModel, group, transformGroup, api, (0, $6a439e51dccdc432$export$31cba7db0a663292).determine);
        var ticksEls = $dfe15f745e1c3c2b$var$buildAxisMajorTicks(cfg, group, transformGroup, axisModel);
        $dfe15f745e1c3c2b$var$syncLabelIgnoreToMajorTicks(cfg, local.labelLayoutList, ticksEls);
        $dfe15f745e1c3c2b$var$buildAxisMinorTicks(cfg, group, transformGroup, axisModel, cfg.tickDirection);
    },
    /**
   * [CAUTION] This method can be called multiple times, following the change due to `resetCfg` called
   *  in size measurement. Thus this method should be idempotent, and should be performant.
   */ axisName: function(cfg, local, shared, axisModel, group, transformGroup, api, extraParams) {
        var sharedRecord = shared.ensureRecord(axisModel);
        var ready;
        // Remove the existing name result created in estimation phase.
        if (local.nameEl) {
            group.remove(local.nameEl);
            local.nameEl = sharedRecord.nameLayout = sharedRecord.nameLocation = null;
        }
        var name = cfg.axisName;
        if (!$dfe15f745e1c3c2b$var$hasAxisName(name)) return;
        var nameLocation = cfg.nameLocation;
        var nameDirection = cfg.nameDirection;
        var textStyleModel = axisModel.getModel("nameTextStyle");
        var gap = axisModel.get("nameGap") || 0;
        var extent = axisModel.axis.getExtent();
        var gapStartEndSignal = axisModel.axis.inverse ? -1 : 1;
        var pos = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(0, 0);
        var nameMoveDirVec = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(0, 0);
        if (nameLocation === "start") {
            pos.x = extent[0] - gapStartEndSignal * gap;
            nameMoveDirVec.x = -gapStartEndSignal;
        } else if (nameLocation === "end") {
            pos.x = extent[1] + gapStartEndSignal * gap;
            nameMoveDirVec.x = gapStartEndSignal;
        } else {
            // 'middle' or 'center'
            pos.x = (extent[0] + extent[1]) / 2;
            pos.y = cfg.labelOffset + nameDirection * gap;
            nameMoveDirVec.y = nameDirection;
        }
        var mt = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
        nameMoveDirVec.transform($f41ebb9dd60b55b4$export$bb628a54ab399bc9(mt, mt, cfg.rotation));
        var nameRotation = axisModel.get("nameRotate");
        if (nameRotation != null) nameRotation = nameRotation * $dfe15f745e1c3c2b$var$PI / 180; // To radian.
        var labelLayout;
        var axisNameAvailableWidth;
        if ((0, $2d646e51cc34f840$export$c06aa22293dea9d2)(nameLocation)) labelLayout = $dfe15f745e1c3c2b$var$AxisBuilder.innerTextLayout(cfg.rotation, nameRotation != null ? nameRotation : cfg.rotation, // Adapt to axis.
        nameDirection);
        else {
            labelLayout = $dfe15f745e1c3c2b$var$endTextLayout(cfg.rotation, nameLocation, nameRotation || 0, extent);
            axisNameAvailableWidth = cfg.raw.axisNameAvailableWidth;
            if (axisNameAvailableWidth != null) {
                axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
                !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
            }
        }
        var textFont = textStyleModel.getFont();
        var truncateOpt = axisModel.get("nameTruncate", true) || {};
        var ellipsis = truncateOpt.ellipsis;
        var maxWidth = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(cfg.raw.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth);
        var nameMarginLevel = extraParams.nameMarginLevel || 0;
        var textEl = new $fe885cc21795562b$export$2e2bcd8739ae039({
            x: pos.x,
            y: pos.y,
            rotation: labelLayout.rotation,
            silent: $dfe15f745e1c3c2b$var$AxisBuilder.isLabelSilent(axisModel),
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                text: name,
                font: textFont,
                overflow: "truncate",
                width: maxWidth,
                ellipsis: ellipsis,
                fill: textStyleModel.getTextColor() || axisModel.get([
                    "axisLine",
                    "lineStyle",
                    "color"
                ]),
                align: textStyleModel.get("align") || labelLayout.textAlign,
                verticalAlign: textStyleModel.get("verticalAlign") || labelLayout.textVerticalAlign
            }),
            z2: 1
        });
        $5b455ae6f843ac47$export$fc6410d97fab306c({
            el: textEl,
            componentModel: axisModel,
            itemName: name
        });
        textEl.__fullText = name;
        // Id for animation
        textEl.anid = "name";
        if (axisModel.get("triggerEvent")) {
            var eventData = $dfe15f745e1c3c2b$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = "axisName";
            eventData.name = name;
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(textEl).eventData = eventData;
        }
        transformGroup.add(textEl);
        textEl.updateTransform();
        local.nameEl = textEl;
        var nameLayout = sharedRecord.nameLayout = (0, $11dac7a73f36cc2c$export$471916f4e89eb5da)({
            label: textEl,
            priority: textEl.z2,
            defaultAttr: {
                ignore: textEl.ignore
            },
            marginDefault: (0, $2d646e51cc34f840$export$c06aa22293dea9d2)(nameLocation) ? $dfe15f745e1c3c2b$var$DEFAULT_CENTER_NAME_MARGIN_LEVELS[nameMarginLevel] : $dfe15f745e1c3c2b$var$DEFAULT_ENDS_NAME_MARGIN_LEVELS[nameMarginLevel]
        });
        sharedRecord.nameLocation = nameLocation;
        group.add(textEl);
        textEl.decomposeTransform();
        if (cfg.shouldNameMoveOverlap && nameLayout) {
            var record = shared.ensureRecord(axisModel);
            shared.resolveAxisNameOverlap(cfg, shared, axisModel, nameLayout, nameMoveDirVec, record);
        }
    }
};
function $dfe15f745e1c3c2b$var$layOutAxisTickLabel(cfg, local, shared, axisModel, group, transformGroup, api, kind) {
    if (!$dfe15f745e1c3c2b$var$axisLabelBuildResultExists(local)) $dfe15f745e1c3c2b$var$buildAxisLabel(cfg, local, group, kind, axisModel, api);
    var labelLayoutList = local.labelLayoutList;
    $dfe15f745e1c3c2b$var$updateAxisLabelChangableProps(cfg, axisModel, labelLayoutList, transformGroup);
    $dfe15f745e1c3c2b$var$adjustBreakLabels(axisModel, cfg.rotation, labelLayoutList);
    var optionHideOverlap = cfg.optionHideOverlap;
    $dfe15f745e1c3c2b$var$fixMinMaxLabelShow(axisModel, labelLayoutList, optionHideOverlap);
    if (optionHideOverlap) // This bit fixes the label overlap issue for the time chart.
    // See https://github.com/apache/echarts/issues/14266 for more.
    (0, $11dac7a73f36cc2c$export$8ce774e164a49410)(// Filter the already ignored labels by the previous overlap resolving methods.
    (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(labelLayoutList, function(layout) {
        return layout && !layout.label.ignore;
    }));
    // Always call it even this axis has no name, since it serves in overlapping detection
    // and grid outerBounds on other axis.
    $dfe15f745e1c3c2b$var$resetOverlapRecordToShared(cfg, shared, axisModel, labelLayoutList);
}
function $dfe15f745e1c3c2b$var$endTextLayout(rotation, textPosition, textRotate, extent) {
    var rotationDiff = (0, $cfc1f3b422a3185f$export$2ca6dd70a288b1c3)(textRotate - rotation);
    var textAlign;
    var textVerticalAlign;
    var inverse = extent[0] > extent[1];
    var onLeft = textPosition === "start" && !inverse || textPosition !== "start" && inverse;
    if ((0, $cfc1f3b422a3185f$export$d1df570aea2868f)(rotationDiff - $dfe15f745e1c3c2b$var$PI / 2)) {
        textVerticalAlign = onLeft ? "bottom" : "top";
        textAlign = "center";
    } else if ((0, $cfc1f3b422a3185f$export$d1df570aea2868f)(rotationDiff - $dfe15f745e1c3c2b$var$PI * 1.5)) {
        textVerticalAlign = onLeft ? "top" : "bottom";
        textAlign = "center";
    } else {
        textVerticalAlign = "middle";
        if (rotationDiff < $dfe15f745e1c3c2b$var$PI * 1.5 && rotationDiff > $dfe15f745e1c3c2b$var$PI / 2) textAlign = onLeft ? "left" : "right";
        else textAlign = onLeft ? "right" : "left";
    }
    return {
        rotation: rotationDiff,
        textAlign: textAlign,
        textVerticalAlign: textVerticalAlign
    };
}
/**
 * Assume `labelLayoutList` has no `label.ignore: true`.
 * Assume `labelLayoutList` have been sorted by value ascending order.
 */ function $dfe15f745e1c3c2b$var$fixMinMaxLabelShow(axisModel, labelLayoutList, optionHideOverlap) {
    if ((0, $2d646e51cc34f840$export$c2911c025243d6a6)(axisModel.axis)) return;
    // FIXME
    // Have not consider onBand yet, where tick els is more than label els.
    // Assert no ignore in labels.
    function deal(showMinMaxLabel, outmostLabelIdx, innerLabelIdx) {
        var outmostLabelLayout = (0, $11dac7a73f36cc2c$export$471916f4e89eb5da)(labelLayoutList[outmostLabelIdx]);
        var innerLabelLayout = (0, $11dac7a73f36cc2c$export$471916f4e89eb5da)(labelLayoutList[innerLabelIdx]);
        if (!outmostLabelLayout || !innerLabelLayout) return;
        if (showMinMaxLabel === false || outmostLabelLayout.suggestIgnore) {
            $dfe15f745e1c3c2b$var$ignoreEl(outmostLabelLayout.label);
            return;
        }
        if (innerLabelLayout.suggestIgnore) {
            $dfe15f745e1c3c2b$var$ignoreEl(innerLabelLayout.label);
            return;
        }
        // PENDING: Originally we thought `optionHideOverlap === false` means do not hide anything,
        //  since currently the bounding rect of text might not accurate enough and might slightly bigger,
        //  which causes false positive. But `optionHideOverlap: null/undfined` is falsy and likely
        //  be treated as false.
        // In most fonts the glyph does not reach the boundary of the bounding rect.
        // This is needed to avoid too aggressive to hide two elements that meet at the edge
        // due to compact layout by the same bounding rect or OBB.
        var touchThreshold = 0.1;
        // This treatment is for backward compatibility. And `!optionHideOverlap` implies that
        // the user accepts the visual touch between adjacent labels, thus "hide min/max label"
        // should be conservative, since the space might be sufficient in this case.
        if (!optionHideOverlap) {
            var marginForce = [
                0,
                0,
                0,
                0
            ];
            // Make a copy to apply `ignoreMargin`.
            outmostLabelLayout = (0, $11dac7a73f36cc2c$export$a1cfd37e9b88106b)({
                marginForce: marginForce
            }, outmostLabelLayout);
            innerLabelLayout = (0, $11dac7a73f36cc2c$export$a1cfd37e9b88106b)({
                marginForce: marginForce
            }, innerLabelLayout);
        }
        if ((0, $11dac7a73f36cc2c$export$f28bfabef115ba96)(outmostLabelLayout, innerLabelLayout, null, {
            touchThreshold: touchThreshold
        })) {
            if (showMinMaxLabel) $dfe15f745e1c3c2b$var$ignoreEl(innerLabelLayout.label);
            else $dfe15f745e1c3c2b$var$ignoreEl(outmostLabelLayout.label);
        }
    }
    // If min or max are user set, we need to check
    // If the tick on min(max) are overlap on their neighbour tick
    // If they are overlapped, we need to hide the min(max) tick label
    var showMinLabel = axisModel.get([
        "axisLabel",
        "showMinLabel"
    ]);
    var showMaxLabel = axisModel.get([
        "axisLabel",
        "showMaxLabel"
    ]);
    var labelsLen = labelLayoutList.length;
    deal(showMinLabel, 0, 1);
    deal(showMaxLabel, labelsLen - 1, labelsLen - 2);
}
// PENDING: Is it necessary to display a tick while the corresponding label is ignored?
function $dfe15f745e1c3c2b$var$syncLabelIgnoreToMajorTicks(cfg, labelLayoutList, tickEls) {
    if (cfg.showMinorTicks) // It probably unreaasonable to hide major ticks when show minor ticks.
    return;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(labelLayoutList, function(labelLayout) {
        if (labelLayout && labelLayout.label.ignore) for(var idx = 0; idx < tickEls.length; idx++){
            var tickEl = tickEls[idx];
            // Assume small array, linear search is fine for performance.
            // PENDING: measure?
            var tickInner = $dfe15f745e1c3c2b$var$getTickInner(tickEl);
            var labelInner = $dfe15f745e1c3c2b$export$c392b818a26a879e(labelLayout.label);
            if (tickInner.tickValue != null && !tickInner.onBand && tickInner.tickValue === labelInner.tickValue) {
                $dfe15f745e1c3c2b$var$ignoreEl(tickEl);
                return;
            }
        }
    });
}
function $dfe15f745e1c3c2b$var$ignoreEl(el) {
    el && (el.ignore = true);
}
function $dfe15f745e1c3c2b$var$createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, anidPrefix) {
    var tickEls = [];
    var pt1 = [];
    var pt2 = [];
    for(var i = 0; i < ticksCoords.length; i++){
        var tickCoord = ticksCoords[i].coord;
        pt1[0] = tickCoord;
        pt1[1] = 0;
        pt2[0] = tickCoord;
        pt2[1] = tickEndCoord;
        if (tickTransform) {
            (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(pt1, pt1, tickTransform);
            (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(pt2, pt2, tickTransform);
        }
        // Tick line, Not use group transform to have better line draw
        var tickEl = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
            shape: {
                x1: pt1[0],
                y1: pt1[1],
                x2: pt2[0],
                y2: pt2[1]
            },
            style: tickLineStyle,
            z2: 2,
            autoBatch: true,
            silent: true
        });
        $5b455ae6f843ac47$export$8b4b620d7f4aad1b(tickEl.shape, tickEl.style.lineWidth);
        tickEl.anid = anidPrefix + "_" + ticksCoords[i].tickValue;
        tickEls.push(tickEl);
        var inner = $dfe15f745e1c3c2b$var$getTickInner(tickEl);
        inner.onBand = !!ticksCoords[i].onBand;
        inner.tickValue = ticksCoords[i].tickValue;
    }
    return tickEls;
}
function $dfe15f745e1c3c2b$var$buildAxisMajorTicks(cfg, group, transformGroup, axisModel) {
    var axis = axisModel.axis;
    var tickModel = axisModel.getModel("axisTick");
    var shown = tickModel.get("show");
    if (shown === "auto") {
        shown = true;
        if (cfg.raw.axisTickAutoShow != null) shown = !!cfg.raw.axisTickAutoShow;
    }
    if (!shown || axis.scale.isBlank()) return [];
    var lineStyleModel = tickModel.getModel("lineStyle");
    var tickEndCoord = cfg.tickDirection * tickModel.get("length");
    var ticksCoords = axis.getTicksCoords();
    var ticksEls = $dfe15f745e1c3c2b$var$createTicks(ticksCoords, transformGroup.transform, tickEndCoord, (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(lineStyleModel.getLineStyle(), {
        stroke: axisModel.get([
            "axisLine",
            "lineStyle",
            "color"
        ])
    }), "ticks");
    for(var i = 0; i < ticksEls.length; i++)group.add(ticksEls[i]);
    return ticksEls;
}
function $dfe15f745e1c3c2b$var$buildAxisMinorTicks(cfg, group, transformGroup, axisModel, tickDirection) {
    var axis = axisModel.axis;
    var minorTickModel = axisModel.getModel("minorTick");
    if (!cfg.showMinorTicks || axis.scale.isBlank()) return;
    var minorTicksCoords = axis.getMinorTicksCoords();
    if (!minorTicksCoords.length) return;
    var lineStyleModel = minorTickModel.getModel("lineStyle");
    var tickEndCoord = tickDirection * minorTickModel.get("length");
    var minorTickLineStyle = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(lineStyleModel.getLineStyle(), (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(axisModel.getModel("axisTick").getLineStyle(), {
        stroke: axisModel.get([
            "axisLine",
            "lineStyle",
            "color"
        ])
    }));
    for(var i = 0; i < minorTicksCoords.length; i++){
        var minorTicksEls = $dfe15f745e1c3c2b$var$createTicks(minorTicksCoords[i], transformGroup.transform, tickEndCoord, minorTickLineStyle, "minorticks_" + i);
        for(var k = 0; k < minorTicksEls.length; k++)group.add(minorTicksEls[k]);
    }
}
// Return whether need to call `layOutAxisTickLabel` again.
function $dfe15f745e1c3c2b$var$dealLastTickLabelResultReusable(local, group, extraParams) {
    if ($dfe15f745e1c3c2b$var$axisLabelBuildResultExists(local)) {
        var axisLabelsCreationContext = local.axisLabelsCreationContext;
        var noPxChangeTryDetermine = axisLabelsCreationContext.out.noPxChangeTryDetermine;
        if (extraParams.noPxChange) {
            var canDetermine = true;
            for(var idx = 0; idx < noPxChangeTryDetermine.length; idx++)canDetermine = canDetermine && noPxChangeTryDetermine[idx]();
            if (canDetermine) return false;
        }
        if (noPxChangeTryDetermine.length) {
            // Remove the result of `buildAxisLabel`
            group.remove(local.labelGroup);
            $dfe15f745e1c3c2b$var$axisLabelBuildResultSet(local, null, null, null);
        }
    }
    return true;
}
function $dfe15f745e1c3c2b$var$buildAxisLabel(cfg, local, group, kind, axisModel, api) {
    var axis = axisModel.axis;
    var show = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(cfg.raw.axisLabelShow, axisModel.get([
        "axisLabel",
        "show"
    ]));
    var labelGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
    group.add(labelGroup);
    var axisLabelCreationCtx = (0, $6a439e51dccdc432$export$12d6ac38274c43e7)(kind);
    if (!show || axis.scale.isBlank()) {
        $dfe15f745e1c3c2b$var$axisLabelBuildResultSet(local, [], labelGroup, axisLabelCreationCtx);
        return;
    }
    var labelModel = axisModel.getModel("axisLabel");
    var labels = axis.getViewLabels(axisLabelCreationCtx);
    // Special label rotate.
    var labelRotation = ((0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(cfg.raw.labelRotate, labelModel.get("rotate")) || 0) * $dfe15f745e1c3c2b$var$PI / 180;
    var labelLayout = $dfe15f745e1c3c2b$var$AxisBuilder.innerTextLayout(cfg.rotation, labelRotation, cfg.labelDirection);
    var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
    var labelEls = [];
    var triggerEvent = axisModel.get("triggerEvent");
    var z2Min = Infinity;
    var z2Max = -Infinity;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(labels, function(labelItem, index) {
        var _a;
        var tickValue = axis.scale.type === "ordinal" ? axis.scale.getRawOrdinalNumber(labelItem.tickValue) : labelItem.tickValue;
        var formattedLabel = labelItem.formattedLabel;
        var rawLabel = labelItem.rawLabel;
        var itemLabelModel = labelModel;
        if (rawCategoryData && rawCategoryData[tickValue]) {
            var rawCategoryItem = rawCategoryData[tickValue];
            if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(rawCategoryItem) && rawCategoryItem.textStyle) itemLabelModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(rawCategoryItem.textStyle, labelModel, axisModel.ecModel);
        }
        var textColor = itemLabelModel.getTextColor() || axisModel.get([
            "axisLine",
            "lineStyle",
            "color"
        ]);
        var align = itemLabelModel.getShallow("align", true) || labelLayout.textAlign;
        var alignMin = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemLabelModel.getShallow("alignMinLabel", true), align);
        var alignMax = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemLabelModel.getShallow("alignMaxLabel", true), align);
        var verticalAlign = itemLabelModel.getShallow("verticalAlign", true) || itemLabelModel.getShallow("baseline", true) || labelLayout.textVerticalAlign;
        var verticalAlignMin = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemLabelModel.getShallow("verticalAlignMinLabel", true), verticalAlign);
        var verticalAlignMax = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemLabelModel.getShallow("verticalAlignMaxLabel", true), verticalAlign);
        var z2 = 10 + (((_a = labelItem.time) === null || _a === void 0 ? void 0 : _a.level) || 0);
        z2Min = Math.min(z2Min, z2);
        z2Max = Math.max(z2Max, z2);
        var textEl = new $fe885cc21795562b$export$2e2bcd8739ae039({
            // --- transform props start ---
            // All of the transform props MUST not be set here, but should be set in
            // `updateAxisLabelChangableProps`, because they may change in estimation,
            // and need to calculate based on global coord sys by `decomposeTransform`.
            x: 0,
            y: 0,
            rotation: 0,
            // --- transform props end ---
            silent: $dfe15f745e1c3c2b$var$AxisBuilder.isLabelSilent(axisModel),
            z2: z2,
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(itemLabelModel, {
                text: formattedLabel,
                align: index === 0 ? alignMin : index === labels.length - 1 ? alignMax : align,
                verticalAlign: index === 0 ? verticalAlignMin : index === labels.length - 1 ? verticalAlignMax : verticalAlign,
                fill: (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(textColor) ? textColor(// (1) In category axis with data zoom, tick is not the original
                // index of axis.data. So tick should not be exposed to user
                // in category axis.
                // (2) Compatible with previous version, which always use formatted label as
                // input. But in interval scale the formatted label is like '223,445', which
                // maked user replace ','. So we modify it to return original val but remain
                // it as 'string' to avoid error in replacing.
                axis.type === "category" ? rawLabel : axis.type === "value" ? tickValue + "" : tickValue, index) : textColor
            })
        });
        textEl.anid = "label_" + tickValue;
        var inner = $dfe15f745e1c3c2b$export$c392b818a26a879e(textEl);
        inner["break"] = labelItem["break"];
        inner.tickValue = tickValue;
        inner.layoutRotation = labelLayout.rotation;
        $5b455ae6f843ac47$export$fc6410d97fab306c({
            el: textEl,
            componentModel: axisModel,
            itemName: formattedLabel,
            formatterParamsExtra: {
                isTruncated: function() {
                    return textEl.isTruncated;
                },
                value: rawLabel,
                tickIndex: index
            }
        });
        // Pack data for mouse event
        if (triggerEvent) {
            var eventData = $dfe15f745e1c3c2b$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = "axisLabel";
            eventData.value = rawLabel;
            eventData.tickIndex = index;
            if (labelItem["break"]) eventData["break"] = {
                // type: labelItem.break.type,
                start: labelItem["break"].parsedBreak.vmin,
                end: labelItem["break"].parsedBreak.vmax
            };
            if (axis.type === "category") eventData.dataIndex = tickValue;
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(textEl).eventData = eventData;
            if (labelItem["break"]) $dfe15f745e1c3c2b$var$addBreakEventHandler(axisModel, api, textEl, labelItem["break"]);
        }
        labelEls.push(textEl);
        labelGroup.add(textEl);
    });
    var labelLayoutList = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(labelEls, function(label) {
        return {
            label: label,
            priority: $dfe15f745e1c3c2b$export$c392b818a26a879e(label)["break"] ? label.z2 + (z2Max - z2Min + 1 // Make break labels be highest priority.
            ) : label.z2,
            defaultAttr: {
                ignore: label.ignore
            }
        };
    });
    $dfe15f745e1c3c2b$var$axisLabelBuildResultSet(local, labelLayoutList, labelGroup, axisLabelCreationCtx);
}
// Indicate that `layOutAxisTickLabel` has been called.
function $dfe15f745e1c3c2b$var$axisLabelBuildResultExists(local) {
    return !!local.labelLayoutList;
}
function $dfe15f745e1c3c2b$var$axisLabelBuildResultSet(local, labelLayoutList, labelGroup, axisLabelsCreationContext) {
    // Ensure the same lifetime.
    local.labelLayoutList = labelLayoutList;
    local.labelGroup = labelGroup;
    local.axisLabelsCreationContext = axisLabelsCreationContext;
}
function $dfe15f745e1c3c2b$var$updateAxisLabelChangableProps(cfg, axisModel, labelLayoutList, transformGroup) {
    var labelMargin = axisModel.get([
        "axisLabel",
        "margin"
    ]);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(labelLayoutList, function(layout, idx) {
        var geometry = (0, $11dac7a73f36cc2c$export$471916f4e89eb5da)(layout);
        if (!geometry) return;
        var labelEl = geometry.label;
        var inner = $dfe15f745e1c3c2b$export$c392b818a26a879e(labelEl);
        // See the comment in `suggestIgnore`.
        geometry.suggestIgnore = labelEl.ignore;
        // Currently no `ignore:true` is set in `buildAxisLabel`
        // But `ignore:true` may be set subsequently for overlap handling, thus reset it here.
        labelEl.ignore = false;
        (0, $becf2d727f9cf450$export$234b1c16dfa57d6a)($dfe15f745e1c3c2b$var$_tmpLayoutEl, $dfe15f745e1c3c2b$var$_tmpLayoutElReset);
        $dfe15f745e1c3c2b$var$_tmpLayoutEl.x = axisModel.axis.dataToCoord(inner.tickValue);
        $dfe15f745e1c3c2b$var$_tmpLayoutEl.y = cfg.labelOffset + cfg.labelDirection * labelMargin;
        $dfe15f745e1c3c2b$var$_tmpLayoutEl.rotation = inner.layoutRotation;
        transformGroup.add($dfe15f745e1c3c2b$var$_tmpLayoutEl);
        $dfe15f745e1c3c2b$var$_tmpLayoutEl.updateTransform();
        transformGroup.remove($dfe15f745e1c3c2b$var$_tmpLayoutEl);
        $dfe15f745e1c3c2b$var$_tmpLayoutEl.decomposeTransform();
        (0, $becf2d727f9cf450$export$234b1c16dfa57d6a)(labelEl, $dfe15f745e1c3c2b$var$_tmpLayoutEl);
        labelEl.markRedraw();
        (0, $11dac7a73f36cc2c$export$1551ece3f059eafb)(geometry, true);
        (0, $11dac7a73f36cc2c$export$471916f4e89eb5da)(geometry);
    });
}
var $dfe15f745e1c3c2b$var$_tmpLayoutEl = new $419e5ff2f303755e$export$2e2bcd8739ae039();
var $dfe15f745e1c3c2b$var$_tmpLayoutElReset = new $419e5ff2f303755e$export$2e2bcd8739ae039();
function $dfe15f745e1c3c2b$var$hasAxisName(axisName) {
    return !!axisName;
}
function $dfe15f745e1c3c2b$var$addBreakEventHandler(axisModel, api, textEl, visualBreak) {
    textEl.on("click", function(params) {
        var payload = {
            type: (0, $6a77b1cfe2c04bae$export$12319e2083cd71ce),
            breaks: [
                {
                    start: visualBreak.parsedBreak.breakOption.start,
                    end: visualBreak.parsedBreak.breakOption.end
                }
            ]
        };
        payload[axisModel.axis.dim + "AxisIndex"] = axisModel.componentIndex;
        api.dispatchAction(payload);
    });
}
function $dfe15f745e1c3c2b$var$adjustBreakLabels(axisModel, axisRotation, labelLayoutList) {
    var scaleBreakHelper = (0, $639a5974fe354f7a$export$e79b20ac82c2d660)();
    if (!scaleBreakHelper) return;
    var breakLabelIndexPairs = scaleBreakHelper.retrieveAxisBreakPairs(labelLayoutList, function(layoutInfo) {
        return layoutInfo && $dfe15f745e1c3c2b$export$c392b818a26a879e(layoutInfo.label)["break"];
    }, true);
    var moveOverlap = axisModel.get([
        "breakLabelLayout",
        "moveOverlap"
    ], true);
    if (moveOverlap === true || moveOverlap === "auto") (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(breakLabelIndexPairs, function(idxPair) {
        (0, $0d1e9c0f651d5d16$export$c1d9b2cc33e7e5e)().adjustBreakLabelPair(axisModel.axis.inverse, axisRotation, [
            (0, $11dac7a73f36cc2c$export$471916f4e89eb5da)(labelLayoutList[idxPair[0]]),
            (0, $11dac7a73f36cc2c$export$471916f4e89eb5da)(labelLayoutList[idxPair[1]])
        ]);
    });
}
var $dfe15f745e1c3c2b$export$2e2bcd8739ae039 = $dfe15f745e1c3c2b$var$AxisBuilder;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL = true;
var $91342d1cfa622c5a$var$mathMin = Math.min;
var $91342d1cfa622c5a$var$mathMax = Math.max;
var $91342d1cfa622c5a$var$mathPow = Math.pow;
var $91342d1cfa622c5a$var$COVER_Z = 10000;
var $91342d1cfa622c5a$var$UNSELECT_THRESHOLD = 6;
var $91342d1cfa622c5a$var$MIN_RESIZE_LINE_WIDTH = 6;
var $91342d1cfa622c5a$var$MUTEX_RESOURCE_KEY = "globalPan";
var $91342d1cfa622c5a$var$DIRECTION_MAP = {
    w: [
        0,
        0
    ],
    e: [
        0,
        1
    ],
    n: [
        1,
        0
    ],
    s: [
        1,
        1
    ]
};
var $91342d1cfa622c5a$var$CURSOR_MAP = {
    w: "ew",
    e: "ew",
    n: "ns",
    s: "ns",
    ne: "nesw",
    sw: "nesw",
    nw: "nwse",
    se: "nwse"
};
var $91342d1cfa622c5a$var$DEFAULT_BRUSH_OPT = {
    brushStyle: {
        lineWidth: 2,
        stroke: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.backgroundTint,
        fill: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.borderTint
    },
    transformable: true,
    brushMode: "single",
    removeOnClick: false
};
var $91342d1cfa622c5a$var$baseUID = 0;
/**
 * params:
 *     areas: Array.<Array>, coord relates to container group,
 *                             If no container specified, to global.
 *     opt {
 *         isEnd: boolean,
 *         removeOnClick: boolean
 *     }
 */ var $91342d1cfa622c5a$var$BrushController = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BrushController, _super);
    function BrushController(zr) {
        var _this = _super.call(this) || this;
        /**
     * @internal
     */ _this._track = [];
        /**
     * @internal
     */ _this._covers = [];
        _this._handlers = {};
        _this._zr = zr;
        _this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        _this._uid = "brushController_" + $91342d1cfa622c5a$var$baseUID++;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($91342d1cfa622c5a$var$pointerHandlers, function(handler, eventName) {
            this._handlers[eventName] = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(handler, this);
        }, _this);
        return _this;
    }
    /**
   * If set to `false`, select disabled.
   */ BrushController.prototype.enableBrush = function(brushOption) {
        this._brushType && this._doDisableBrush();
        brushOption.brushType && this._doEnableBrush(brushOption);
        return this;
    };
    BrushController.prototype._doEnableBrush = function(brushOption) {
        var zr = this._zr;
        // Consider roam, which takes globalPan too.
        if (!this._enableGlobalPan) $befd6a34b30d3f54$export$b7df5d561049483a(zr, $91342d1cfa622c5a$var$MUTEX_RESOURCE_KEY, this._uid);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._handlers, function(handler, eventName) {
            zr.on(eventName, handler);
        });
        this._brushType = brushOption.brushType;
        this._brushOption = (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)($91342d1cfa622c5a$var$DEFAULT_BRUSH_OPT), brushOption, true);
    };
    BrushController.prototype._doDisableBrush = function() {
        var zr = this._zr;
        $befd6a34b30d3f54$export$23d3fad09dc44362(zr, $91342d1cfa622c5a$var$MUTEX_RESOURCE_KEY, this._uid);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._handlers, function(handler, eventName) {
            zr.off(eventName, handler);
        });
        this._brushType = this._brushOption = null;
    };
    /**
   * @param panelOpts If not pass, it is global brush.
   */ BrushController.prototype.setPanels = function(panelOpts) {
        if (panelOpts && panelOpts.length) {
            var panels_1 = this._panels = {};
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(panelOpts, function(panelOpts) {
                panels_1[panelOpts.panelId] = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(panelOpts);
            });
        } else this._panels = null;
        return this;
    };
    BrushController.prototype.mount = function(opt) {
        opt = opt || {};
        this._enableGlobalPan = opt.enableGlobalPan;
        var thisGroup = this.group;
        this._zr.add(thisGroup);
        thisGroup.attr({
            x: opt.x || 0,
            y: opt.y || 0,
            rotation: opt.rotation || 0,
            scaleX: opt.scaleX || 1,
            scaleY: opt.scaleY || 1
        });
        this._transform = thisGroup.getLocalTransform();
        return this;
    };
    // eachCover(cb, context): void {
    //     each(this._covers, cb, context);
    // }
    /**
   * Update covers.
   * @param coverConfigList
   *        If coverConfigList is null/undefined, all covers removed.
   */ BrushController.prototype.updateCovers = function(coverConfigList) {
        coverConfigList = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(coverConfigList, function(coverConfig) {
            return (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)($91342d1cfa622c5a$var$DEFAULT_BRUSH_OPT), coverConfig, true);
        });
        var tmpIdPrefix = "\x00-brush-index-";
        var oldCovers = this._covers;
        var newCovers = this._covers = [];
        var controller = this;
        var creatingCover = this._creatingCover;
        new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(oldCovers, coverConfigList, oldGetKey, getKey).add(addOrUpdate).update(addOrUpdate).remove(remove).execute();
        return this;
        function getKey(brushOption, index) {
            return (brushOption.id != null ? brushOption.id : tmpIdPrefix + index) + "-" + brushOption.brushType;
        }
        function oldGetKey(cover, index) {
            return getKey(cover.__brushOption, index);
        }
        function addOrUpdate(newIndex, oldIndex) {
            var newBrushInternal = coverConfigList[newIndex];
            // Consider setOption in event listener of brushSelect,
            // where updating cover when creating should be forbidden.
            if (oldIndex != null && oldCovers[oldIndex] === creatingCover) newCovers[newIndex] = oldCovers[oldIndex];
            else {
                var cover = newCovers[newIndex] = oldIndex != null ? (oldCovers[oldIndex].__brushOption = newBrushInternal, oldCovers[oldIndex]) : $91342d1cfa622c5a$var$endCreating(controller, $91342d1cfa622c5a$var$createCover(controller, newBrushInternal));
                $91342d1cfa622c5a$var$updateCoverAfterCreation(controller, cover);
            }
        }
        function remove(oldIndex) {
            if (oldCovers[oldIndex] !== creatingCover) controller.group.remove(oldCovers[oldIndex]);
        }
    };
    BrushController.prototype.unmount = function() {
        this.enableBrush(false);
        // container may 'removeAll' outside.
        $91342d1cfa622c5a$var$clearCovers(this);
        this._zr.remove(this.group);
        return this;
    };
    BrushController.prototype.dispose = function() {
        this.unmount();
        this.off();
    };
    return BrushController;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
function $91342d1cfa622c5a$var$createCover(controller, brushOption) {
    var cover = $91342d1cfa622c5a$var$coverRenderers[brushOption.brushType].createCover(controller, brushOption);
    cover.__brushOption = brushOption;
    $91342d1cfa622c5a$var$updateZ(cover, brushOption);
    controller.group.add(cover);
    return cover;
}
function $91342d1cfa622c5a$var$endCreating(controller, creatingCover) {
    var coverRenderer = $91342d1cfa622c5a$var$getCoverRenderer(creatingCover);
    if (coverRenderer.endCreating) {
        coverRenderer.endCreating(controller, creatingCover);
        $91342d1cfa622c5a$var$updateZ(creatingCover, creatingCover.__brushOption);
    }
    return creatingCover;
}
function $91342d1cfa622c5a$var$updateCoverShape(controller, cover) {
    var brushOption = cover.__brushOption;
    $91342d1cfa622c5a$var$getCoverRenderer(cover).updateCoverShape(controller, cover, brushOption.range, brushOption);
}
function $91342d1cfa622c5a$var$updateZ(cover, brushOption) {
    var z = brushOption.z;
    z == null && (z = $91342d1cfa622c5a$var$COVER_Z);
    cover.traverse(function(el) {
        el.z = z;
        el.z2 = z; // Consider in given container.
    });
}
function $91342d1cfa622c5a$var$updateCoverAfterCreation(controller, cover) {
    $91342d1cfa622c5a$var$getCoverRenderer(cover).updateCommon(controller, cover);
    $91342d1cfa622c5a$var$updateCoverShape(controller, cover);
}
function $91342d1cfa622c5a$var$getCoverRenderer(cover) {
    return $91342d1cfa622c5a$var$coverRenderers[cover.__brushOption.brushType];
}
// return target panel or `true` (means global panel)
function $91342d1cfa622c5a$var$getPanelByPoint(controller, e, localCursorPoint) {
    var panels = controller._panels;
    if (!panels) return $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL; // Global panel
    var panel;
    var transform = controller._transform;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(panels, function(pn) {
        pn.isTargetByCursor(e, localCursorPoint, transform) && (panel = pn);
    });
    return panel;
}
// Return a panel or true
function $91342d1cfa622c5a$var$getPanelByCover(controller, cover) {
    var panels = controller._panels;
    if (!panels) return $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL; // Global panel
    var panelId = cover.__brushOption.panelId;
    // User may give cover without coord sys info,
    // which is then treated as global panel.
    return panelId != null ? panels[panelId] : $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL;
}
function $91342d1cfa622c5a$var$clearCovers(controller) {
    var covers = controller._covers;
    var originalLength = covers.length;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(covers, function(cover) {
        controller.group.remove(cover);
    }, controller);
    covers.length = 0;
    return !!originalLength;
}
function $91342d1cfa622c5a$var$trigger(controller, opt) {
    var areas = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(controller._covers, function(cover) {
        var brushOption = cover.__brushOption;
        var range = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(brushOption.range);
        return {
            brushType: brushOption.brushType,
            panelId: brushOption.panelId,
            range: range
        };
    });
    controller.trigger("brush", {
        areas: areas,
        isEnd: !!opt.isEnd,
        removeOnClick: !!opt.removeOnClick
    });
}
function $91342d1cfa622c5a$var$shouldShowCover(controller) {
    var track = controller._track;
    if (!track.length) return false;
    var p2 = track[track.length - 1];
    var p1 = track[0];
    var dx = p2[0] - p1[0];
    var dy = p2[1] - p1[1];
    var dist = $91342d1cfa622c5a$var$mathPow(dx * dx + dy * dy, 0.5);
    return dist > $91342d1cfa622c5a$var$UNSELECT_THRESHOLD;
}
function $91342d1cfa622c5a$var$getTrackEnds(track) {
    var tail = track.length - 1;
    tail < 0 && (tail = 0);
    return [
        track[0],
        track[tail]
    ];
}
function $91342d1cfa622c5a$var$createBaseRectCover(rectRangeConverter, controller, brushOption, edgeNameSequences) {
    var cover = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
    cover.add(new $419e5ff2f303755e$export$2e2bcd8739ae039({
        name: "main",
        style: $91342d1cfa622c5a$var$makeStyle(brushOption),
        silent: true,
        draggable: true,
        cursor: "move",
        drift: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($91342d1cfa622c5a$var$driftRect, rectRangeConverter, controller, cover, [
            "n",
            "s",
            "w",
            "e"
        ]),
        ondragend: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($91342d1cfa622c5a$var$trigger, controller, {
            isEnd: true
        })
    }));
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(edgeNameSequences, function(nameSequence) {
        cover.add(new $419e5ff2f303755e$export$2e2bcd8739ae039({
            name: nameSequence.join(""),
            style: {
                opacity: 0
            },
            draggable: true,
            silent: true,
            invisible: true,
            drift: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($91342d1cfa622c5a$var$driftRect, rectRangeConverter, controller, cover, nameSequence),
            ondragend: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($91342d1cfa622c5a$var$trigger, controller, {
                isEnd: true
            })
        }));
    });
    return cover;
}
function $91342d1cfa622c5a$var$updateBaseRect(controller, cover, localRange, brushOption) {
    var lineWidth = brushOption.brushStyle.lineWidth || 0;
    var handleSize = $91342d1cfa622c5a$var$mathMax(lineWidth, $91342d1cfa622c5a$var$MIN_RESIZE_LINE_WIDTH);
    var x = localRange[0][0];
    var y = localRange[1][0];
    var xa = x - lineWidth / 2;
    var ya = y - lineWidth / 2;
    var x2 = localRange[0][1];
    var y2 = localRange[1][1];
    var x2a = x2 - handleSize + lineWidth / 2;
    var y2a = y2 - handleSize + lineWidth / 2;
    var width = x2 - x;
    var height = y2 - y;
    var widtha = width + lineWidth;
    var heighta = height + lineWidth;
    $91342d1cfa622c5a$var$updateRectShape(controller, cover, "main", x, y, width, height);
    if (brushOption.transformable) {
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, "w", xa, ya, handleSize, heighta);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, "e", x2a, ya, handleSize, heighta);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, "n", xa, ya, widtha, handleSize);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, "s", xa, y2a, widtha, handleSize);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, "nw", xa, ya, handleSize, handleSize);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, "ne", x2a, ya, handleSize, handleSize);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, "sw", xa, y2a, handleSize, handleSize);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, "se", x2a, y2a, handleSize, handleSize);
    }
}
function $91342d1cfa622c5a$var$updateCommon(controller, cover) {
    var brushOption = cover.__brushOption;
    var transformable = brushOption.transformable;
    var mainEl = cover.childAt(0);
    mainEl.useStyle($91342d1cfa622c5a$var$makeStyle(brushOption));
    mainEl.attr({
        silent: !transformable,
        cursor: transformable ? "move" : "default"
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        [
            "w"
        ],
        [
            "e"
        ],
        [
            "n"
        ],
        [
            "s"
        ],
        [
            "s",
            "e"
        ],
        [
            "s",
            "w"
        ],
        [
            "n",
            "e"
        ],
        [
            "n",
            "w"
        ]
    ], function(nameSequence) {
        var el = cover.childOfName(nameSequence.join(""));
        var globalDir = nameSequence.length === 1 ? $91342d1cfa622c5a$var$getGlobalDirection1(controller, nameSequence[0]) : $91342d1cfa622c5a$var$getGlobalDirection2(controller, nameSequence);
        el && el.attr({
            silent: !transformable,
            invisible: !transformable,
            cursor: transformable ? $91342d1cfa622c5a$var$CURSOR_MAP[globalDir] + "-resize" : null
        });
    });
}
function $91342d1cfa622c5a$var$updateRectShape(controller, cover, name, x, y, w, h) {
    var el = cover.childOfName(name);
    el && el.setShape($91342d1cfa622c5a$var$pointsToRect($91342d1cfa622c5a$var$clipByPanel(controller, cover, [
        [
            x,
            y
        ],
        [
            x + w,
            y + h
        ]
    ])));
}
function $91342d1cfa622c5a$var$makeStyle(brushOption) {
    return (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        strokeNoScale: true
    }, brushOption.brushStyle);
}
function $91342d1cfa622c5a$var$formatRectRange(x, y, x2, y2) {
    var min = [
        $91342d1cfa622c5a$var$mathMin(x, x2),
        $91342d1cfa622c5a$var$mathMin(y, y2)
    ];
    var max = [
        $91342d1cfa622c5a$var$mathMax(x, x2),
        $91342d1cfa622c5a$var$mathMax(y, y2)
    ];
    return [
        [
            min[0],
            max[0]
        ],
        [
            min[1],
            max[1]
        ] // y range
    ];
}
function $91342d1cfa622c5a$var$getTransform(controller) {
    return $5b455ae6f843ac47$export$fce0c6cfca85ed96(controller.group);
}
function $91342d1cfa622c5a$var$getGlobalDirection1(controller, localDirName) {
    var map = {
        w: "left",
        e: "right",
        n: "top",
        s: "bottom"
    };
    var inverseMap = {
        left: "w",
        right: "e",
        top: "n",
        bottom: "s"
    };
    var dir = $5b455ae6f843ac47$export$fff94e9792354cfa(map[localDirName], $91342d1cfa622c5a$var$getTransform(controller));
    return inverseMap[dir];
}
function $91342d1cfa622c5a$var$getGlobalDirection2(controller, localDirNameSeq) {
    var globalDir = [
        $91342d1cfa622c5a$var$getGlobalDirection1(controller, localDirNameSeq[0]),
        $91342d1cfa622c5a$var$getGlobalDirection1(controller, localDirNameSeq[1])
    ];
    (globalDir[0] === "e" || globalDir[0] === "w") && globalDir.reverse();
    return globalDir.join("");
}
function $91342d1cfa622c5a$var$driftRect(rectRangeConverter, controller, cover, dirNameSequence, dx, dy) {
    var brushOption = cover.__brushOption;
    var rectRange = rectRangeConverter.toRectRange(brushOption.range);
    var localDelta = $91342d1cfa622c5a$var$toLocalDelta(controller, dx, dy);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dirNameSequence, function(dirName) {
        var ind = $91342d1cfa622c5a$var$DIRECTION_MAP[dirName];
        rectRange[ind[0]][ind[1]] += localDelta[ind[0]];
    });
    brushOption.range = rectRangeConverter.fromRectRange($91342d1cfa622c5a$var$formatRectRange(rectRange[0][0], rectRange[1][0], rectRange[0][1], rectRange[1][1]));
    $91342d1cfa622c5a$var$updateCoverAfterCreation(controller, cover);
    $91342d1cfa622c5a$var$trigger(controller, {
        isEnd: false
    });
}
function $91342d1cfa622c5a$var$driftPolygon(controller, cover, dx, dy) {
    var range = cover.__brushOption.range;
    var localDelta = $91342d1cfa622c5a$var$toLocalDelta(controller, dx, dy);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(range, function(point) {
        point[0] += localDelta[0];
        point[1] += localDelta[1];
    });
    $91342d1cfa622c5a$var$updateCoverAfterCreation(controller, cover);
    $91342d1cfa622c5a$var$trigger(controller, {
        isEnd: false
    });
}
function $91342d1cfa622c5a$var$toLocalDelta(controller, dx, dy) {
    var thisGroup = controller.group;
    var localD = thisGroup.transformCoordToLocal(dx, dy);
    var localZero = thisGroup.transformCoordToLocal(0, 0);
    return [
        localD[0] - localZero[0],
        localD[1] - localZero[1]
    ];
}
function $91342d1cfa622c5a$var$clipByPanel(controller, cover, data) {
    var panel = $91342d1cfa622c5a$var$getPanelByCover(controller, cover);
    return panel && panel !== $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL ? panel.clipPath(data, controller._transform) : (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(data);
}
function $91342d1cfa622c5a$var$pointsToRect(points) {
    var xmin = $91342d1cfa622c5a$var$mathMin(points[0][0], points[1][0]);
    var ymin = $91342d1cfa622c5a$var$mathMin(points[0][1], points[1][1]);
    var xmax = $91342d1cfa622c5a$var$mathMax(points[0][0], points[1][0]);
    var ymax = $91342d1cfa622c5a$var$mathMax(points[0][1], points[1][1]);
    return {
        x: xmin,
        y: ymin,
        width: xmax - xmin,
        height: ymax - ymin
    };
}
function $91342d1cfa622c5a$var$resetCursor(controller, e, localCursorPoint) {
    if (// Check active
    !controller._brushType || $91342d1cfa622c5a$var$isOutsideZrArea(controller, e.offsetX, e.offsetY)) return;
    var zr = controller._zr;
    var covers = controller._covers;
    var currPanel = $91342d1cfa622c5a$var$getPanelByPoint(controller, e, localCursorPoint);
    // Check whether in covers.
    if (!controller._dragging) for(var i = 0; i < covers.length; i++){
        var brushOption = covers[i].__brushOption;
        if (currPanel && (currPanel === $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL || brushOption.panelId === currPanel.panelId) && $91342d1cfa622c5a$var$coverRenderers[brushOption.brushType].contain(covers[i], localCursorPoint[0], localCursorPoint[1])) // Use cursor style set on cover.
        return;
    }
    currPanel && zr.setCursorStyle("crosshair");
}
function $91342d1cfa622c5a$var$preventDefault(e) {
    var rawE = e.event;
    rawE.preventDefault && rawE.preventDefault();
}
function $91342d1cfa622c5a$var$mainShapeContain(cover, x, y) {
    return cover.childOfName("main").contain(x, y);
}
function $91342d1cfa622c5a$var$updateCoverByMouse(controller, e, localCursorPoint, isEnd) {
    var creatingCover = controller._creatingCover;
    var panel = controller._creatingPanel;
    var thisBrushOption = controller._brushOption;
    var eventParams;
    controller._track.push(localCursorPoint.slice());
    if ($91342d1cfa622c5a$var$shouldShowCover(controller) || creatingCover) {
        if (panel && !creatingCover) {
            thisBrushOption.brushMode === "single" && $91342d1cfa622c5a$var$clearCovers(controller);
            var brushOption = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(thisBrushOption);
            brushOption.brushType = $91342d1cfa622c5a$var$determineBrushType(brushOption.brushType, panel);
            brushOption.panelId = panel === $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL ? null : panel.panelId;
            creatingCover = controller._creatingCover = $91342d1cfa622c5a$var$createCover(controller, brushOption);
            controller._covers.push(creatingCover);
        }
        if (creatingCover) {
            var coverRenderer = $91342d1cfa622c5a$var$coverRenderers[$91342d1cfa622c5a$var$determineBrushType(controller._brushType, panel)];
            var coverBrushOption = creatingCover.__brushOption;
            coverBrushOption.range = coverRenderer.getCreatingRange($91342d1cfa622c5a$var$clipByPanel(controller, creatingCover, controller._track));
            if (isEnd) {
                $91342d1cfa622c5a$var$endCreating(controller, creatingCover);
                coverRenderer.updateCommon(controller, creatingCover);
            }
            $91342d1cfa622c5a$var$updateCoverShape(controller, creatingCover);
            eventParams = {
                isEnd: isEnd
            };
        }
    } else if (isEnd && thisBrushOption.brushMode === "single" && thisBrushOption.removeOnClick) // Help user to remove covers easily, only by a tiny drag, in 'single' mode.
    // But a single click do not clear covers, because user may have casual
    // clicks (for example, click on other component and do not expect covers
    // disappear).
    // Only some cover removed, trigger action, but not every click trigger action.
    {
        if ($91342d1cfa622c5a$var$getPanelByPoint(controller, e, localCursorPoint) && $91342d1cfa622c5a$var$clearCovers(controller)) eventParams = {
            isEnd: isEnd,
            removeOnClick: true
        };
    }
    return eventParams;
}
function $91342d1cfa622c5a$var$determineBrushType(brushType, panel) {
    if (brushType === "auto") return panel.defaultBrushType;
    return brushType;
}
var $91342d1cfa622c5a$var$pointerHandlers = {
    mousedown: function(e) {
        if (this._dragging) // In case some browser do not support globalOut,
        // and release mouse out side the browser.
        $91342d1cfa622c5a$var$handleDragEnd(this, e);
        else if (!e.target || !e.target.draggable) {
            $91342d1cfa622c5a$var$preventDefault(e);
            var localCursorPoint = this.group.transformCoordToLocal(e.offsetX, e.offsetY);
            this._creatingCover = null;
            var panel = this._creatingPanel = $91342d1cfa622c5a$var$getPanelByPoint(this, e, localCursorPoint);
            if (panel) {
                this._dragging = true;
                this._track = [
                    localCursorPoint.slice()
                ];
            }
        }
    },
    mousemove: function(e) {
        var x = e.offsetX;
        var y = e.offsetY;
        var localCursorPoint = this.group.transformCoordToLocal(x, y);
        $91342d1cfa622c5a$var$resetCursor(this, e, localCursorPoint);
        if (this._dragging) {
            $91342d1cfa622c5a$var$preventDefault(e);
            var eventParams = $91342d1cfa622c5a$var$updateCoverByMouse(this, e, localCursorPoint, false);
            eventParams && $91342d1cfa622c5a$var$trigger(this, eventParams);
        }
    },
    mouseup: function(e) {
        $91342d1cfa622c5a$var$handleDragEnd(this, e);
    }
};
function $91342d1cfa622c5a$var$handleDragEnd(controller, e) {
    if (controller._dragging) {
        $91342d1cfa622c5a$var$preventDefault(e);
        var x = e.offsetX;
        var y = e.offsetY;
        var localCursorPoint = controller.group.transformCoordToLocal(x, y);
        var eventParams = $91342d1cfa622c5a$var$updateCoverByMouse(controller, e, localCursorPoint, true);
        controller._dragging = false;
        controller._track = [];
        controller._creatingCover = null;
        // trigger event should be at final, after procedure will be nested.
        eventParams && $91342d1cfa622c5a$var$trigger(controller, eventParams);
    }
}
function $91342d1cfa622c5a$var$isOutsideZrArea(controller, x, y) {
    var zr = controller._zr;
    return x < 0 || x > zr.getWidth() || y < 0 || y > zr.getHeight();
}
/**
 * key: brushType
 */ var $91342d1cfa622c5a$var$coverRenderers = {
    lineX: $91342d1cfa622c5a$var$getLineRenderer(0),
    lineY: $91342d1cfa622c5a$var$getLineRenderer(1),
    rect: {
        createCover: function(controller, brushOption) {
            function returnInput(range) {
                return range;
            }
            return $91342d1cfa622c5a$var$createBaseRectCover({
                toRectRange: returnInput,
                fromRectRange: returnInput
            }, controller, brushOption, [
                [
                    "w"
                ],
                [
                    "e"
                ],
                [
                    "n"
                ],
                [
                    "s"
                ],
                [
                    "s",
                    "e"
                ],
                [
                    "s",
                    "w"
                ],
                [
                    "n",
                    "e"
                ],
                [
                    "n",
                    "w"
                ]
            ]);
        },
        getCreatingRange: function(localTrack) {
            var ends = $91342d1cfa622c5a$var$getTrackEnds(localTrack);
            return $91342d1cfa622c5a$var$formatRectRange(ends[1][0], ends[1][1], ends[0][0], ends[0][1]);
        },
        updateCoverShape: function(controller, cover, localRange, brushOption) {
            $91342d1cfa622c5a$var$updateBaseRect(controller, cover, localRange, brushOption);
        },
        updateCommon: $91342d1cfa622c5a$var$updateCommon,
        contain: $91342d1cfa622c5a$var$mainShapeContain
    },
    polygon: {
        createCover: function(controller, brushOption) {
            var cover = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
            // Do not use graphic.Polygon because graphic.Polyline do not close the
            // border of the shape when drawing, which is a better experience for user.
            cover.add(new $d28119f30e6bb670$export$2e2bcd8739ae039({
                name: "main",
                style: $91342d1cfa622c5a$var$makeStyle(brushOption),
                silent: true
            }));
            return cover;
        },
        getCreatingRange: function(localTrack) {
            return localTrack;
        },
        endCreating: function(controller, cover) {
            cover.remove(cover.childAt(0));
            // Use graphic.Polygon close the shape.
            cover.add(new $51acf033123e1a30$export$2e2bcd8739ae039({
                name: "main",
                draggable: true,
                drift: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($91342d1cfa622c5a$var$driftPolygon, controller, cover),
                ondragend: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($91342d1cfa622c5a$var$trigger, controller, {
                    isEnd: true
                })
            }));
        },
        updateCoverShape: function(controller, cover, localRange, brushOption) {
            cover.childAt(0).setShape({
                points: $91342d1cfa622c5a$var$clipByPanel(controller, cover, localRange)
            });
        },
        updateCommon: $91342d1cfa622c5a$var$updateCommon,
        contain: $91342d1cfa622c5a$var$mainShapeContain
    }
};
function $91342d1cfa622c5a$var$getLineRenderer(xyIndex) {
    return {
        createCover: function(controller, brushOption) {
            return $91342d1cfa622c5a$var$createBaseRectCover({
                toRectRange: function(range) {
                    var rectRange = [
                        range,
                        [
                            0,
                            100
                        ]
                    ];
                    xyIndex && rectRange.reverse();
                    return rectRange;
                },
                fromRectRange: function(rectRange) {
                    return rectRange[xyIndex];
                }
            }, controller, brushOption, [
                [
                    [
                        "w"
                    ],
                    [
                        "e"
                    ]
                ],
                [
                    [
                        "n"
                    ],
                    [
                        "s"
                    ]
                ]
            ][xyIndex]);
        },
        getCreatingRange: function(localTrack) {
            var ends = $91342d1cfa622c5a$var$getTrackEnds(localTrack);
            var min = $91342d1cfa622c5a$var$mathMin(ends[0][xyIndex], ends[1][xyIndex]);
            var max = $91342d1cfa622c5a$var$mathMax(ends[0][xyIndex], ends[1][xyIndex]);
            return [
                min,
                max
            ];
        },
        updateCoverShape: function(controller, cover, localRange, brushOption) {
            var otherExtent;
            // If brushWidth not specified, fit the panel.
            var panel = $91342d1cfa622c5a$var$getPanelByCover(controller, cover);
            if (panel !== $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL && panel.getLinearBrushOtherExtent) otherExtent = panel.getLinearBrushOtherExtent(xyIndex);
            else {
                var zr = controller._zr;
                otherExtent = [
                    0,
                    [
                        zr.getWidth(),
                        zr.getHeight()
                    ][1 - xyIndex]
                ];
            }
            var rectRange = [
                localRange,
                otherExtent
            ];
            xyIndex && rectRange.reverse();
            $91342d1cfa622c5a$var$updateBaseRect(controller, cover, rectRange, brushOption);
        },
        updateCommon: $91342d1cfa622c5a$var$updateCommon,
        contain: $91342d1cfa622c5a$var$mainShapeContain
    };
}
var $91342d1cfa622c5a$export$2e2bcd8739ae039 = $91342d1cfa622c5a$var$BrushController;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $d9c171f7dfe1f12f$export$fee17964a62a87a7(rect) {
    rect = $d9c171f7dfe1f12f$var$normalizeRect(rect);
    return function(localPoints) {
        return $5b455ae6f843ac47$export$e2f409471bbbc1dc(localPoints, rect);
    };
}
function $d9c171f7dfe1f12f$export$7280070e90fad7a0(rect, specifiedXYIndex) {
    rect = $d9c171f7dfe1f12f$var$normalizeRect(rect);
    return function(xyIndex) {
        var idx = specifiedXYIndex != null ? specifiedXYIndex : xyIndex;
        var brushWidth = idx ? rect.width : rect.height;
        var base = idx ? rect.x : rect.y;
        return [
            base,
            base + (brushWidth || 0)
        ];
    };
}
function $d9c171f7dfe1f12f$export$e63e66b3b18aa99f(rect, api, targetModel) {
    var boundingRect = $d9c171f7dfe1f12f$var$normalizeRect(rect);
    return function(e, localCursorPoint) {
        return boundingRect.contain(localCursorPoint[0], localCursorPoint[1]) && !(0, $bee256db41541054$export$8a33eacb690eac07)(e, api, targetModel);
    };
}
// Consider width/height is negative.
function $d9c171f7dfe1f12f$var$normalizeRect(rect) {
    return (0, $1bebe7106c895823$export$2e2bcd8739ae039).create(rect);
}




var $90a4a8a0234865c7$var$ParallelAxisView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ParallelAxisView, _super);
    function ParallelAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelAxisView.type;
        return _this;
    }
    ParallelAxisView.prototype.init = function(ecModel, api) {
        _super.prototype.init.apply(this, arguments);
        (this._brushController = new (0, $91342d1cfa622c5a$export$2e2bcd8739ae039)(api.getZr())).on("brush", $7a1bd9c2710fea0d$export$2385a24977818dd0(this._onBrush, this));
    };
    ParallelAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        if ($90a4a8a0234865c7$var$fromAxisAreaSelect(axisModel, ecModel, payload)) return;
        this.axisModel = axisModel;
        this.api = api;
        this.group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this.group.add(this._axisGroup);
        if (!axisModel.get("show")) return;
        var coordSysModel = $90a4a8a0234865c7$var$getCoordSysModel(axisModel, ecModel);
        var coordSys = coordSysModel.coordinateSystem;
        var areaSelectStyle = axisModel.getAreaSelectStyle();
        var areaWidth = areaSelectStyle.width;
        var dim = axisModel.axis.dim;
        var axisLayout = coordSys.getAxisLayout(dim);
        var builderOpt = $7a1bd9c2710fea0d$export$8b58be045bf06082({
            strokeContainThreshold: areaWidth
        }, axisLayout);
        var axisBuilder = new (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039)(axisModel, api, builderOpt);
        axisBuilder.build();
        this._axisGroup.add(axisBuilder.group);
        this._refreshBrushController(builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api);
        $5b455ae6f843ac47$export$64fcab7860c216ae(oldAxisGroup, this._axisGroup, axisModel);
    };
    // /**
    //  * @override
    //  */
    // updateVisual(axisModel, ecModel, api, payload) {
    //     this._brushController && this._brushController
    //         .updateCovers(getCoverInfoList(axisModel));
    // }
    ParallelAxisView.prototype._refreshBrushController = function(builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api) {
        // After filtering, axis may change, select area needs to be update.
        var extent = axisModel.axis.getExtent();
        var extentLen = extent[1] - extent[0];
        var extra = Math.min(30, Math.abs(extentLen) * 0.1); // Arbitrary value.
        // width/height might be negative, which will be
        // normalized in BoundingRect.
        var rect = $1bebe7106c895823$export$2e2bcd8739ae039.create({
            x: extent[0],
            y: -areaWidth / 2,
            width: extentLen,
            height: areaWidth
        });
        rect.x -= extra;
        rect.width += 2 * extra;
        this._brushController.mount({
            enableGlobalPan: true,
            rotation: builderOpt.rotation,
            x: builderOpt.position[0],
            y: builderOpt.position[1]
        }).setPanels([
            {
                panelId: "pl",
                clipPath: $d9c171f7dfe1f12f$export$fee17964a62a87a7(rect),
                isTargetByCursor: $d9c171f7dfe1f12f$export$e63e66b3b18aa99f(rect, api, coordSysModel),
                getLinearBrushOtherExtent: $d9c171f7dfe1f12f$export$7280070e90fad7a0(rect, 0)
            }
        ]).enableBrush({
            brushType: "lineX",
            brushStyle: areaSelectStyle,
            removeOnClick: true
        }).updateCovers($90a4a8a0234865c7$var$getCoverInfoList(axisModel));
    };
    ParallelAxisView.prototype._onBrush = function(eventParam) {
        var coverInfoList = eventParam.areas;
        // Do not cache these object, because the mey be changed.
        var axisModel = this.axisModel;
        var axis = axisModel.axis;
        var intervals = $7a1bd9c2710fea0d$export$871de8747c9eaa88(coverInfoList, function(coverInfo) {
            return [
                axis.coordToData(coverInfo.range[0], true),
                axis.coordToData(coverInfo.range[1], true)
            ];
        });
        // If realtime is true, action is not dispatched on drag end, because
        // the drag end emits the same params with the last drag move event,
        // and may have some delay when using touch pad.
        if (!axisModel.option.realtime === eventParam.isEnd || eventParam.removeOnClick) // jshint ignore:line
        this.api.dispatchAction({
            type: "axisAreaSelect",
            parallelAxisId: axisModel.id,
            intervals: intervals
        });
    };
    ParallelAxisView.prototype.dispose = function() {
        this._brushController.dispose();
    };
    ParallelAxisView.type = "parallelAxis";
    return ParallelAxisView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $90a4a8a0234865c7$var$fromAxisAreaSelect(axisModel, ecModel, payload) {
    return payload && payload.type === "axisAreaSelect" && ecModel.findComponents({
        mainType: "parallelAxis",
        query: payload
    })[0] === axisModel;
}
function $90a4a8a0234865c7$var$getCoverInfoList(axisModel) {
    var axis = axisModel.axis;
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88(axisModel.activeIntervals, function(interval) {
        return {
            brushType: "lineX",
            panelId: "pl",
            range: [
                axis.dataToCoord(interval[0], true),
                axis.dataToCoord(interval[1], true)
            ]
        };
    });
}
function $90a4a8a0234865c7$var$getCoordSysModel(axisModel, ecModel) {
    return ecModel.getComponent("parallel", axisModel.get("parallelIndex"));
}
var $90a4a8a0234865c7$export$2e2bcd8739ae039 = $90a4a8a0234865c7$var$ParallelAxisView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $1c10e648a7cc8028$var$actionInfo = {
    type: "axisAreaSelect",
    event: "axisAreaSelected"
};
function $1c10e648a7cc8028$export$a97c1e0aa84f4f71(registers) {
    registers.registerAction($1c10e648a7cc8028$var$actionInfo, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "parallelAxis",
            query: payload
        }, function(parallelAxisModel) {
            parallelAxisModel.axis.model.setActiveIntervals(payload.intervals);
        });
    });
    /**
   * @payload
   */ registers.registerAction("parallelAxisExpand", function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "parallel",
            query: payload
        }, function(parallelModel) {
            parallelModel.setAxisExpand(payload);
        });
    });
}


var $462857bad733a944$var$defaultAxisOption = {
    type: "value",
    areaSelectStyle: {
        width: 20,
        borderWidth: 1,
        borderColor: "rgba(160,197,232)",
        color: "rgba(160,197,232)",
        opacity: 0.3
    },
    realtime: true,
    z: 10
};
function $462857bad733a944$export$4b3e715f166fdd78(registers) {
    registers.registerComponentView((0, $ccce4513d4baec6a$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $a14d8e1511adaa1e$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem("parallel", (0, $88531590cdbcfc26$export$2e2bcd8739ae039));
    registers.registerPreprocessor((0, $30173db3404062fa$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $839a50fcb1c6f44b$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $90a4a8a0234865c7$export$2e2bcd8739ae039));
    (0, $c5c4c85259d60abe$export$2e2bcd8739ae039)(registers, "parallel", (0, $839a50fcb1c6f44b$export$2e2bcd8739ae039), $462857bad733a944$var$defaultAxisOption);
    (0, $1c10e648a7cc8028$export$a97c1e0aa84f4f71)(registers);
}


function $4d1dc874f9d8653d$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $462857bad733a944$export$4b3e715f166fdd78));
    registers.registerChartView((0, $9e57680b9c04f083$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $5d63691998e05817$export$2e2bcd8739ae039));
    registers.registerVisual(registers.PRIORITY.VISUAL.BRUSH, (0, $8148e21d655f67c8$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 











var $55a0f29f32f7b1c4$var$BAR_BORDER_WIDTH_QUERY = [
    "itemStyle",
    "borderWidth"
];
// index: +isHorizontal
var $55a0f29f32f7b1c4$var$LAYOUT_ATTRS = [
    {
        xy: "x",
        wh: "width",
        index: 0,
        posDesc: [
            "left",
            "right"
        ]
    },
    {
        xy: "y",
        wh: "height",
        index: 1,
        posDesc: [
            "top",
            "bottom"
        ]
    }
];
var $55a0f29f32f7b1c4$var$pathForLineWidth = new $5b455ae6f843ac47$exports.Circle();
var $55a0f29f32f7b1c4$var$PictorialBarView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PictorialBarView, _super);
    function PictorialBarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PictorialBarView.type;
        return _this;
    }
    PictorialBarView.prototype.render = function(seriesModel, ecModel, api) {
        var group = this.group;
        var data = seriesModel.getData();
        var oldData = this._data;
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var isHorizontal = baseAxis.isHorizontal();
        var coordSysRect = cartesian.master.getRect();
        var opt = {
            ecSize: {
                width: api.getWidth(),
                height: api.getHeight()
            },
            seriesModel: seriesModel,
            coordSys: cartesian,
            coordSysExtent: [
                [
                    coordSysRect.x,
                    coordSysRect.x + coordSysRect.width
                ],
                [
                    coordSysRect.y,
                    coordSysRect.y + coordSysRect.height
                ]
            ],
            isHorizontal: isHorizontal,
            valueDim: $55a0f29f32f7b1c4$var$LAYOUT_ATTRS[+isHorizontal],
            categoryDim: $55a0f29f32f7b1c4$var$LAYOUT_ATTRS[1 - +isHorizontal]
        };
        data.diff(oldData).add(function(dataIndex) {
            if (!data.hasValue(dataIndex)) return;
            var itemModel = $55a0f29f32f7b1c4$var$getItemModel(data, dataIndex);
            var symbolMeta = $55a0f29f32f7b1c4$var$getSymbolMeta(data, dataIndex, itemModel, opt);
            var bar = $55a0f29f32f7b1c4$var$createBar(data, opt, symbolMeta);
            data.setItemGraphicEl(dataIndex, bar);
            group.add(bar);
            $55a0f29f32f7b1c4$var$updateCommon(bar, opt, symbolMeta);
        }).update(function(newIndex, oldIndex) {
            var bar = oldData.getItemGraphicEl(oldIndex);
            if (!data.hasValue(newIndex)) {
                group.remove(bar);
                return;
            }
            var itemModel = $55a0f29f32f7b1c4$var$getItemModel(data, newIndex);
            var symbolMeta = $55a0f29f32f7b1c4$var$getSymbolMeta(data, newIndex, itemModel, opt);
            var pictorialShapeStr = $55a0f29f32f7b1c4$var$getShapeStr(data, symbolMeta);
            if (bar && pictorialShapeStr !== bar.__pictorialShapeStr) {
                group.remove(bar);
                data.setItemGraphicEl(newIndex, null);
                bar = null;
            }
            if (bar) $55a0f29f32f7b1c4$var$updateBar(bar, opt, symbolMeta);
            else bar = $55a0f29f32f7b1c4$var$createBar(data, opt, symbolMeta, true);
            data.setItemGraphicEl(newIndex, bar);
            bar.__pictorialSymbolMeta = symbolMeta;
            // Add back
            group.add(bar);
            $55a0f29f32f7b1c4$var$updateCommon(bar, opt, symbolMeta);
        }).remove(function(dataIndex) {
            var bar = oldData.getItemGraphicEl(dataIndex);
            bar && $55a0f29f32f7b1c4$var$removeBar(oldData, dataIndex, bar.__pictorialSymbolMeta.animationModel, bar);
        }).execute();
        // Do clipping
        var clipPath = seriesModel.get("clip", true) ? (0, $0e2cc04b3aaad400$export$e0fe5081209d01c9)(seriesModel.coordinateSystem, false, seriesModel) : null;
        if (clipPath) group.setClipPath(clipPath);
        else group.removeClipPath();
        this._data = data;
        return this.group;
    };
    PictorialBarView.prototype.remove = function(ecModel, api) {
        var group = this.group;
        var data = this._data;
        if (ecModel.get("animation")) {
            if (data) data.eachItemGraphicEl(function(bar) {
                $55a0f29f32f7b1c4$var$removeBar(data, (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(bar).dataIndex, ecModel, bar);
            });
        } else group.removeAll();
    };
    PictorialBarView.type = "pictorialBar";
    return PictorialBarView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
// Set or calculate default value about symbol, and calculate layout info.
function $55a0f29f32f7b1c4$var$getSymbolMeta(data, dataIndex, itemModel, opt) {
    var layout = data.getItemLayout(dataIndex);
    var symbolRepeat = itemModel.get("symbolRepeat");
    var symbolClip = itemModel.get("symbolClip");
    var symbolPosition = itemModel.get("symbolPosition") || "start";
    var symbolRotate = itemModel.get("symbolRotate");
    var rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
    var symbolPatternSize = itemModel.get("symbolPatternSize") || 2;
    var isAnimationEnabled = itemModel.isAnimationEnabled();
    var symbolMeta = {
        dataIndex: dataIndex,
        layout: layout,
        itemModel: itemModel,
        symbolType: data.getItemVisual(dataIndex, "symbol") || "circle",
        style: data.getItemVisual(dataIndex, "style"),
        symbolClip: symbolClip,
        symbolRepeat: symbolRepeat,
        symbolRepeatDirection: itemModel.get("symbolRepeatDirection"),
        symbolPatternSize: symbolPatternSize,
        rotation: rotation,
        animationModel: isAnimationEnabled ? itemModel : null,
        hoverScale: isAnimationEnabled && itemModel.get([
            "emphasis",
            "scale"
        ]),
        z2: itemModel.getShallow("z", true) || 0
    };
    $55a0f29f32f7b1c4$var$prepareBarLength(itemModel, symbolRepeat, layout, opt, symbolMeta);
    $55a0f29f32f7b1c4$var$prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, symbolMeta.boundingLength, symbolMeta.pxSign, symbolPatternSize, opt, symbolMeta);
    $55a0f29f32f7b1c4$var$prepareLineWidth(itemModel, symbolMeta.symbolScale, rotation, opt, symbolMeta);
    var symbolSize = symbolMeta.symbolSize;
    var symbolOffset = (0, $5370466dadc978d7$export$e3e292895c033f6d)(itemModel.get("symbolOffset"), symbolSize);
    $55a0f29f32f7b1c4$var$prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, symbolMeta.valueLineWidth, symbolMeta.boundingLength, symbolMeta.repeatCutLength, opt, symbolMeta);
    return symbolMeta;
}
// bar length can be negative.
function $55a0f29f32f7b1c4$var$prepareBarLength(itemModel, symbolRepeat, layout, opt, outputSymbolMeta) {
    var valueDim = opt.valueDim;
    var symbolBoundingData = itemModel.get("symbolBoundingData");
    var valueAxis = opt.coordSys.getOtherAxis(opt.coordSys.getBaseAxis());
    var zeroPx = valueAxis.toGlobalCoord(valueAxis.dataToCoord(0));
    var pxSignIdx = 1 - +(layout[valueDim.wh] <= 0);
    var boundingLength;
    if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(symbolBoundingData)) {
        var symbolBoundingExtent = [
            $55a0f29f32f7b1c4$var$convertToCoordOnAxis(valueAxis, symbolBoundingData[0]) - zeroPx,
            $55a0f29f32f7b1c4$var$convertToCoordOnAxis(valueAxis, symbolBoundingData[1]) - zeroPx
        ];
        symbolBoundingExtent[1] < symbolBoundingExtent[0] && symbolBoundingExtent.reverse();
        boundingLength = symbolBoundingExtent[pxSignIdx];
    } else if (symbolBoundingData != null) boundingLength = $55a0f29f32f7b1c4$var$convertToCoordOnAxis(valueAxis, symbolBoundingData) - zeroPx;
    else if (symbolRepeat) boundingLength = opt.coordSysExtent[valueDim.index][pxSignIdx] - zeroPx;
    else boundingLength = layout[valueDim.wh];
    outputSymbolMeta.boundingLength = boundingLength;
    if (symbolRepeat) outputSymbolMeta.repeatCutLength = layout[valueDim.wh];
    // if 'pxSign' means sign of pixel,  it can't be zero, or symbolScale will be zero
    // and when borderWidth be settled, the actual linewidth will be NaN
    var isXAxis = valueDim.xy === "x";
    var isInverse = valueAxis.inverse;
    outputSymbolMeta.pxSign = isXAxis && !isInverse || !isXAxis && isInverse ? boundingLength >= 0 ? 1 : -1 : boundingLength > 0 ? 1 : -1;
}
function $55a0f29f32f7b1c4$var$convertToCoordOnAxis(axis, value) {
    return axis.toGlobalCoord(axis.dataToCoord(axis.scale.parse(value)));
}
// Support ['100%', '100%']
function $55a0f29f32f7b1c4$var$prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, boundingLength, pxSign, symbolPatternSize, opt, outputSymbolMeta) {
    var valueDim = opt.valueDim;
    var categoryDim = opt.categoryDim;
    var categorySize = Math.abs(layout[categoryDim.wh]);
    var symbolSize = data.getItemVisual(dataIndex, "symbolSize");
    var parsedSymbolSize;
    if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(symbolSize)) parsedSymbolSize = symbolSize.slice();
    else if (symbolSize == null) // will parse to number below
    parsedSymbolSize = [
        "100%",
        "100%"
    ];
    else parsedSymbolSize = [
        symbolSize,
        symbolSize
    ];
    // Note: percentage symbolSize (like '100%') do not consider lineWidth, because it is
    // to complicated to calculate real percent value if considering scaled lineWidth.
    // So the actual size will bigger than layout size if lineWidth is bigger than zero,
    // which can be tolerated in pictorial chart.
    parsedSymbolSize[categoryDim.index] = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(parsedSymbolSize[categoryDim.index], categorySize);
    parsedSymbolSize[valueDim.index] = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(parsedSymbolSize[valueDim.index], symbolRepeat ? categorySize : Math.abs(boundingLength));
    outputSymbolMeta.symbolSize = parsedSymbolSize;
    // If x or y is less than zero, show reversed shape.
    var symbolScale = outputSymbolMeta.symbolScale = [
        parsedSymbolSize[0] / symbolPatternSize,
        parsedSymbolSize[1] / symbolPatternSize
    ];
    // Follow convention, 'right' and 'top' is the normal scale.
    symbolScale[valueDim.index] *= (opt.isHorizontal ? -1 : 1) * pxSign;
}
function $55a0f29f32f7b1c4$var$prepareLineWidth(itemModel, symbolScale, rotation, opt, outputSymbolMeta) {
    // In symbols are drawn with scale, so do not need to care about the case that width
    // or height are too small. But symbol use strokeNoScale, where acture lineWidth should
    // be calculated.
    var valueLineWidth = itemModel.get($55a0f29f32f7b1c4$var$BAR_BORDER_WIDTH_QUERY) || 0;
    if (valueLineWidth) {
        $55a0f29f32f7b1c4$var$pathForLineWidth.attr({
            scaleX: symbolScale[0],
            scaleY: symbolScale[1],
            rotation: rotation
        });
        $55a0f29f32f7b1c4$var$pathForLineWidth.updateTransform();
        valueLineWidth /= $55a0f29f32f7b1c4$var$pathForLineWidth.getLineScale();
        valueLineWidth *= symbolScale[opt.valueDim.index];
    }
    outputSymbolMeta.valueLineWidth = valueLineWidth || 0;
}
function $55a0f29f32f7b1c4$var$prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, valueLineWidth, boundingLength, repeatCutLength, opt, outputSymbolMeta) {
    var categoryDim = opt.categoryDim;
    var valueDim = opt.valueDim;
    var pxSign = outputSymbolMeta.pxSign;
    var unitLength = Math.max(symbolSize[valueDim.index] + valueLineWidth, 0);
    var pathLen = unitLength;
    // Note: rotation will not effect the layout of symbols, because user may
    // want symbols to rotate on its center, which should not be translated
    // when rotating.
    if (symbolRepeat) {
        var absBoundingLength = Math.abs(boundingLength);
        var symbolMargin = $7a1bd9c2710fea0d$export$8a4d17b6e8486e66(itemModel.get("symbolMargin"), "15%") + "";
        var hasEndGap = false;
        if (symbolMargin.lastIndexOf("!") === symbolMargin.length - 1) {
            hasEndGap = true;
            symbolMargin = symbolMargin.slice(0, symbolMargin.length - 1);
        }
        var symbolMarginNumeric = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(symbolMargin, symbolSize[valueDim.index]);
        var uLenWithMargin = Math.max(unitLength + symbolMarginNumeric * 2, 0);
        // When symbol margin is less than 0, margin at both ends will be subtracted
        // to ensure that all of the symbols will not be overflow the given area.
        var endFix = hasEndGap ? 0 : symbolMarginNumeric * 2;
        // Both final repeatTimes and final symbolMarginNumeric area calculated based on
        // boundingLength.
        var repeatSpecified = (0, $cfc1f3b422a3185f$export$e90fb89750dba83f)(symbolRepeat);
        var repeatTimes = repeatSpecified ? symbolRepeat : $55a0f29f32f7b1c4$var$toIntTimes((absBoundingLength + endFix) / uLenWithMargin);
        // Adjust calculate margin, to ensure each symbol is displayed
        // entirely in the given layout area.
        var mDiff = absBoundingLength - repeatTimes * unitLength;
        symbolMarginNumeric = mDiff / 2 / (hasEndGap ? repeatTimes : Math.max(repeatTimes - 1, 1));
        uLenWithMargin = unitLength + symbolMarginNumeric * 2;
        endFix = hasEndGap ? 0 : symbolMarginNumeric * 2;
        // Update repeatTimes when not all symbol will be shown.
        if (!repeatSpecified && symbolRepeat !== "fixed") repeatTimes = repeatCutLength ? $55a0f29f32f7b1c4$var$toIntTimes((Math.abs(repeatCutLength) + endFix) / uLenWithMargin) : 0;
        pathLen = repeatTimes * uLenWithMargin - endFix;
        outputSymbolMeta.repeatTimes = repeatTimes;
        outputSymbolMeta.symbolMargin = symbolMarginNumeric;
    }
    var sizeFix = pxSign * (pathLen / 2);
    var pathPosition = outputSymbolMeta.pathPosition = [];
    pathPosition[categoryDim.index] = layout[categoryDim.wh] / 2;
    pathPosition[valueDim.index] = symbolPosition === "start" ? sizeFix : symbolPosition === "end" ? boundingLength - sizeFix : boundingLength / 2; // 'center'
    if (symbolOffset) {
        pathPosition[0] += symbolOffset[0];
        pathPosition[1] += symbolOffset[1];
    }
    var bundlePosition = outputSymbolMeta.bundlePosition = [];
    bundlePosition[categoryDim.index] = layout[categoryDim.xy];
    bundlePosition[valueDim.index] = layout[valueDim.xy];
    var barRectShape = outputSymbolMeta.barRectShape = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, layout);
    barRectShape[valueDim.wh] = pxSign * Math.max(Math.abs(layout[valueDim.wh]), Math.abs(pathPosition[valueDim.index] + sizeFix));
    barRectShape[categoryDim.wh] = layout[categoryDim.wh];
    var clipShape = outputSymbolMeta.clipShape = {};
    // Consider that symbol may be overflow layout rect.
    clipShape[categoryDim.xy] = -layout[categoryDim.xy];
    clipShape[categoryDim.wh] = opt.ecSize[categoryDim.wh];
    clipShape[valueDim.xy] = 0;
    clipShape[valueDim.wh] = layout[valueDim.wh];
}
function $55a0f29f32f7b1c4$var$createPath(symbolMeta) {
    var symbolPatternSize = symbolMeta.symbolPatternSize;
    var path = (0, $5370466dadc978d7$export$af050e04da3a02e8)(// Consider texture img, make a big size.
    symbolMeta.symbolType, -symbolPatternSize / 2, -symbolPatternSize / 2, symbolPatternSize, symbolPatternSize);
    path.attr({
        culling: true
    });
    path.type !== "image" && path.setStyle({
        strokeNoScale: true
    });
    return path;
}
function $55a0f29f32f7b1c4$var$createOrUpdateRepeatSymbols(bar, opt, symbolMeta, isUpdate) {
    var bundle = bar.__pictorialBundle;
    var symbolSize = symbolMeta.symbolSize;
    var valueLineWidth = symbolMeta.valueLineWidth;
    var pathPosition = symbolMeta.pathPosition;
    var valueDim = opt.valueDim;
    var repeatTimes = symbolMeta.repeatTimes || 0;
    var index = 0;
    var unit = symbolSize[opt.valueDim.index] + valueLineWidth + symbolMeta.symbolMargin * 2;
    $55a0f29f32f7b1c4$var$eachPath(bar, function(path) {
        path.__pictorialAnimationIndex = index;
        path.__pictorialRepeatTimes = repeatTimes;
        if (index < repeatTimes) $55a0f29f32f7b1c4$var$updateAttr(path, null, makeTarget(index), symbolMeta, isUpdate);
        else $55a0f29f32f7b1c4$var$updateAttr(path, null, {
            scaleX: 0,
            scaleY: 0
        }, symbolMeta, isUpdate, function() {
            bundle.remove(path);
        });
        // updateHoverAnimation(path, symbolMeta);
        index++;
    });
    for(; index < repeatTimes; index++){
        var path = $55a0f29f32f7b1c4$var$createPath(symbolMeta);
        path.__pictorialAnimationIndex = index;
        path.__pictorialRepeatTimes = repeatTimes;
        bundle.add(path);
        var target = makeTarget(index);
        $55a0f29f32f7b1c4$var$updateAttr(path, {
            x: target.x,
            y: target.y,
            scaleX: 0,
            scaleY: 0
        }, {
            scaleX: target.scaleX,
            scaleY: target.scaleY,
            rotation: target.rotation
        }, symbolMeta, isUpdate);
    }
    function makeTarget(index) {
        var position = pathPosition.slice();
        // (start && pxSign > 0) || (end && pxSign < 0): i = repeatTimes - index
        // Otherwise: i = index;
        var pxSign = symbolMeta.pxSign;
        var i = index;
        if (symbolMeta.symbolRepeatDirection === "start" ? pxSign > 0 : pxSign < 0) i = repeatTimes - 1 - index;
        position[valueDim.index] = unit * (i - repeatTimes / 2 + 0.5) + pathPosition[valueDim.index];
        return {
            x: position[0],
            y: position[1],
            scaleX: symbolMeta.symbolScale[0],
            scaleY: symbolMeta.symbolScale[1],
            rotation: symbolMeta.rotation
        };
    }
}
function $55a0f29f32f7b1c4$var$createOrUpdateSingleSymbol(bar, opt, symbolMeta, isUpdate) {
    var bundle = bar.__pictorialBundle;
    var mainPath = bar.__pictorialMainPath;
    if (!mainPath) {
        mainPath = bar.__pictorialMainPath = $55a0f29f32f7b1c4$var$createPath(symbolMeta);
        bundle.add(mainPath);
        $55a0f29f32f7b1c4$var$updateAttr(mainPath, {
            x: symbolMeta.pathPosition[0],
            y: symbolMeta.pathPosition[1],
            scaleX: 0,
            scaleY: 0,
            rotation: symbolMeta.rotation
        }, {
            scaleX: symbolMeta.symbolScale[0],
            scaleY: symbolMeta.symbolScale[1]
        }, symbolMeta, isUpdate);
    } else $55a0f29f32f7b1c4$var$updateAttr(mainPath, null, {
        x: symbolMeta.pathPosition[0],
        y: symbolMeta.pathPosition[1],
        scaleX: symbolMeta.symbolScale[0],
        scaleY: symbolMeta.symbolScale[1],
        rotation: symbolMeta.rotation
    }, symbolMeta, isUpdate);
}
// bar rect is used for label.
function $55a0f29f32f7b1c4$var$createOrUpdateBarRect(bar, symbolMeta, isUpdate) {
    var rectShape = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, symbolMeta.barRectShape);
    var barRect = bar.__pictorialBarRect;
    if (!barRect) {
        barRect = bar.__pictorialBarRect = new $5b455ae6f843ac47$exports.Rect({
            z2: 2,
            shape: rectShape,
            silent: true,
            style: {
                stroke: "transparent",
                fill: "transparent",
                lineWidth: 0
            }
        });
        barRect.disableMorphing = true;
        bar.add(barRect);
    } else $55a0f29f32f7b1c4$var$updateAttr(barRect, null, {
        shape: rectShape
    }, symbolMeta, isUpdate);
}
function $55a0f29f32f7b1c4$var$createOrUpdateClip(bar, opt, symbolMeta, isUpdate) {
    // If not clip, symbol will be remove and rebuilt.
    if (symbolMeta.symbolClip) {
        var clipPath = bar.__pictorialClipPath;
        var clipShape = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, symbolMeta.clipShape);
        var valueDim = opt.valueDim;
        var animationModel = symbolMeta.animationModel;
        var dataIndex = symbolMeta.dataIndex;
        if (clipPath) $5b455ae6f843ac47$exports.updateProps(clipPath, {
            shape: clipShape
        }, animationModel, dataIndex);
        else {
            clipShape[valueDim.wh] = 0;
            clipPath = new $5b455ae6f843ac47$exports.Rect({
                shape: clipShape
            });
            bar.__pictorialBundle.setClipPath(clipPath);
            bar.__pictorialClipPath = clipPath;
            var target = {};
            target[valueDim.wh] = symbolMeta.clipShape[valueDim.wh];
            $5b455ae6f843ac47$exports[isUpdate ? "updateProps" : "initProps"](clipPath, {
                shape: target
            }, animationModel, dataIndex);
        }
    }
}
function $55a0f29f32f7b1c4$var$getItemModel(data, dataIndex) {
    var itemModel = data.getItemModel(dataIndex);
    itemModel.getAnimationDelayParams = $55a0f29f32f7b1c4$var$getAnimationDelayParams;
    itemModel.isAnimationEnabled = $55a0f29f32f7b1c4$var$isAnimationEnabled;
    return itemModel;
}
function $55a0f29f32f7b1c4$var$getAnimationDelayParams(path) {
    // The order is the same as the z-order, see `symbolRepeatDiretion`.
    return {
        index: path.__pictorialAnimationIndex,
        count: path.__pictorialRepeatTimes
    };
}
function $55a0f29f32f7b1c4$var$isAnimationEnabled() {
    // `animation` prop can be set on itemModel in pictorial bar chart.
    return this.parentModel.isAnimationEnabled() && !!this.getShallow("animation");
}
function $55a0f29f32f7b1c4$var$createBar(data, opt, symbolMeta, isUpdate) {
    // bar is the main element for each data.
    var bar = new $5b455ae6f843ac47$exports.Group();
    // bundle is used for location and clip.
    var bundle = new $5b455ae6f843ac47$exports.Group();
    bar.add(bundle);
    bar.__pictorialBundle = bundle;
    bundle.x = symbolMeta.bundlePosition[0];
    bundle.y = symbolMeta.bundlePosition[1];
    if (symbolMeta.symbolRepeat) $55a0f29f32f7b1c4$var$createOrUpdateRepeatSymbols(bar, opt, symbolMeta);
    else $55a0f29f32f7b1c4$var$createOrUpdateSingleSymbol(bar, opt, symbolMeta);
    $55a0f29f32f7b1c4$var$createOrUpdateBarRect(bar, symbolMeta, isUpdate);
    $55a0f29f32f7b1c4$var$createOrUpdateClip(bar, opt, symbolMeta, isUpdate);
    bar.__pictorialShapeStr = $55a0f29f32f7b1c4$var$getShapeStr(data, symbolMeta);
    bar.__pictorialSymbolMeta = symbolMeta;
    return bar;
}
function $55a0f29f32f7b1c4$var$updateBar(bar, opt, symbolMeta) {
    var animationModel = symbolMeta.animationModel;
    var dataIndex = symbolMeta.dataIndex;
    var bundle = bar.__pictorialBundle;
    $5b455ae6f843ac47$exports.updateProps(bundle, {
        x: symbolMeta.bundlePosition[0],
        y: symbolMeta.bundlePosition[1]
    }, animationModel, dataIndex);
    if (symbolMeta.symbolRepeat) $55a0f29f32f7b1c4$var$createOrUpdateRepeatSymbols(bar, opt, symbolMeta, true);
    else $55a0f29f32f7b1c4$var$createOrUpdateSingleSymbol(bar, opt, symbolMeta, true);
    $55a0f29f32f7b1c4$var$createOrUpdateBarRect(bar, symbolMeta, true);
    $55a0f29f32f7b1c4$var$createOrUpdateClip(bar, opt, symbolMeta, true);
}
function $55a0f29f32f7b1c4$var$removeBar(data, dataIndex, animationModel, bar) {
    // Not show text when animating
    var labelRect = bar.__pictorialBarRect;
    labelRect && labelRect.removeTextContent();
    var paths = [];
    $55a0f29f32f7b1c4$var$eachPath(bar, function(path) {
        paths.push(path);
    });
    bar.__pictorialMainPath && paths.push(bar.__pictorialMainPath);
    // I do not find proper remove animation for clip yet.
    bar.__pictorialClipPath && (animationModel = null);
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(paths, function(path) {
        $5b455ae6f843ac47$exports.removeElement(path, {
            scaleX: 0,
            scaleY: 0
        }, animationModel, dataIndex, function() {
            bar.parent && bar.parent.remove(bar);
        });
    });
    data.setItemGraphicEl(dataIndex, null);
}
function $55a0f29f32f7b1c4$var$getShapeStr(data, symbolMeta) {
    return [
        data.getItemVisual(symbolMeta.dataIndex, "symbol") || "none",
        !!symbolMeta.symbolRepeat,
        !!symbolMeta.symbolClip
    ].join(":");
}
function $55a0f29f32f7b1c4$var$eachPath(bar, cb, context) {
    // Do not use Group#eachChild, because it do not support remove.
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(bar.__pictorialBundle.children(), function(el) {
        el !== bar.__pictorialBarRect && cb.call(context, el);
    });
}
function $55a0f29f32f7b1c4$var$updateAttr(el, immediateAttrs, animationAttrs, symbolMeta, isUpdate, cb) {
    immediateAttrs && el.attr(immediateAttrs);
    // when symbolCip used, only clip path has init animation, otherwise it would be weird effect.
    if (symbolMeta.symbolClip && !isUpdate) animationAttrs && el.attr(animationAttrs);
    else animationAttrs && $5b455ae6f843ac47$exports[isUpdate ? "updateProps" : "initProps"](el, animationAttrs, symbolMeta.animationModel, symbolMeta.dataIndex, cb);
}
function $55a0f29f32f7b1c4$var$updateCommon(bar, opt, symbolMeta) {
    var dataIndex = symbolMeta.dataIndex;
    var itemModel = symbolMeta.itemModel;
    // Color must be excluded.
    // Because symbol provide setColor individually to set fill and stroke
    var emphasisModel = itemModel.getModel("emphasis");
    var emphasisStyle = emphasisModel.getModel("itemStyle").getItemStyle();
    var blurStyle = itemModel.getModel([
        "blur",
        "itemStyle"
    ]).getItemStyle();
    var selectStyle = itemModel.getModel([
        "select",
        "itemStyle"
    ]).getItemStyle();
    var cursorStyle = itemModel.getShallow("cursor");
    var focus = emphasisModel.get("focus");
    var blurScope = emphasisModel.get("blurScope");
    var hoverScale = emphasisModel.get("scale");
    $55a0f29f32f7b1c4$var$eachPath(bar, function(path) {
        if (path instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
            var pathStyle = path.style;
            path.useStyle($7a1bd9c2710fea0d$export$8b58be045bf06082({
                // TODO other properties like dx, dy ?
                image: pathStyle.image,
                x: pathStyle.x,
                y: pathStyle.y,
                width: pathStyle.width,
                height: pathStyle.height
            }, symbolMeta.style));
        } else path.useStyle(symbolMeta.style);
        var emphasisState = path.ensureState("emphasis");
        emphasisState.style = emphasisStyle;
        if (hoverScale) {
            // NOTE: Must after scale is set after updateAttr
            emphasisState.scaleX = path.scaleX * 1.1;
            emphasisState.scaleY = path.scaleY * 1.1;
        }
        path.ensureState("blur").style = blurStyle;
        path.ensureState("select").style = selectStyle;
        cursorStyle && (path.cursor = cursorStyle);
        path.z2 = symbolMeta.z2;
    });
    var barPositionOutside = opt.valueDim.posDesc[+(symbolMeta.boundingLength > 0)];
    var barRect = bar.__pictorialBarRect;
    barRect.ignoreClip = true;
    (0, $6800dfcb6e1e2a44$export$9a13992917966657)(barRect, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
        labelFetcher: opt.seriesModel,
        labelDataIndex: dataIndex,
        defaultText: (0, $b2475f850d3c0bc2$export$5ff20667590927ed)(opt.seriesModel.getData(), dataIndex),
        inheritColor: symbolMeta.style.fill,
        defaultOpacity: symbolMeta.style.opacity,
        defaultOutsidePosition: barPositionOutside
    });
    (0, $2bf82c0980125b62$export$e51187539ff11209)(bar, focus, blurScope, emphasisModel.get("disabled"));
}
function $55a0f29f32f7b1c4$var$toIntTimes(times) {
    var roundedTimes = Math.round(times);
    // Escapse accurate error
    return Math.abs(times - roundedTimes) < 1e-4 ? roundedTimes : Math.ceil(times);
}
var $55a0f29f32f7b1c4$export$2e2bcd8739ae039 = $55a0f29f32f7b1c4$var$PictorialBarView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $eb46f662d47de4a6$var$PictorialBarSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PictorialBarSeriesModel, _super);
    function PictorialBarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PictorialBarSeriesModel.type;
        _this.hasSymbolVisual = true;
        _this.defaultSymbol = "roundRect";
        return _this;
    }
    PictorialBarSeriesModel.prototype.getInitialData = function(option) {
        // Disable stack.
        option.stack = null;
        return _super.prototype.getInitialData.apply(this, arguments);
    };
    PictorialBarSeriesModel.type = "series.pictorialBar";
    PictorialBarSeriesModel.dependencies = [
        "grid"
    ];
    PictorialBarSeriesModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $b508252f98157abf$export$2e2bcd8739ae039).defaultOption, {
        symbol: "circle",
        symbolSize: null,
        symbolRotate: null,
        symbolPosition: null,
        symbolOffset: null,
        symbolMargin: null,
        symbolRepeat: false,
        symbolRepeatDirection: "end",
        symbolClip: false,
        symbolBoundingData: null,
        symbolPatternSize: 400,
        barGap: "-100%",
        // Pictorial bar do not clip by default because in many cases
        // xAxis and yAxis are not displayed and it's expected not to clip
        clip: false,
        // z can be set in data item, which is z2 actually.
        // Disable progressive
        progressive: 0,
        emphasis: {
            // By default pictorialBar do not hover scale. Hover scale is not suitable
            // for the case that both has foreground and background.
            scale: false
        },
        select: {
            itemStyle: {
                borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.primary
            }
        }
    });
    return PictorialBarSeriesModel;
}((0, $b508252f98157abf$export$2e2bcd8739ae039));
var $eb46f662d47de4a6$export$2e2bcd8739ae039 = $eb46f662d47de4a6$var$PictorialBarSeriesModel;




function $7e25595b74be81a3$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $55a0f29f32f7b1c4$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $eb46f662d47de4a6$export$2e2bcd8739ae039));
    registers.registerLayout(registers.PRIORITY.VISUAL.LAYOUT, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)((0, $361c48dd900de28f$export$b3219800bda33a1f), "pictorialBar"));
    // Do layout after other overall layout, which can prepare some information.
    registers.registerLayout(registers.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, (0, $361c48dd900de28f$export$16e8685758531cb6)("pictorialBar"));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $21576fcf4c669316$var$PI2 = Math.PI * 2;
var $21576fcf4c669316$var$RADIAN = Math.PI / 180;
function $21576fcf4c669316$export$2e2bcd8739ae039(seriesType, ecModel, api) {
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        var data = seriesModel.getData();
        var valueDim = data.mapDimension("value");
        var _a = (0, $93b9bc7f22ac7369$export$3101c00baac0ee1f)(seriesModel, api), cx = _a.cx, cy = _a.cy, r = _a.r, r0 = _a.r0, viewRect = _a.viewRect;
        var startAngle = -seriesModel.get("startAngle") * $21576fcf4c669316$var$RADIAN;
        var endAngle = seriesModel.get("endAngle");
        var padAngle = seriesModel.get("padAngle") * $21576fcf4c669316$var$RADIAN;
        endAngle = endAngle === "auto" ? startAngle - $21576fcf4c669316$var$PI2 : -endAngle * $21576fcf4c669316$var$RADIAN;
        var minAngle = seriesModel.get("minAngle") * $21576fcf4c669316$var$RADIAN;
        var minAndPadAngle = minAngle + padAngle;
        var validDataCount = 0;
        data.each(valueDim, function(value) {
            !isNaN(value) && validDataCount++;
        });
        var sum = data.getSum(valueDim);
        // Sum may be 0
        var unitRadian = Math.PI / (sum || validDataCount) * 2;
        var clockwise = seriesModel.get("clockwise");
        var roseType = seriesModel.get("roseType");
        var stillShowZeroSum = seriesModel.get("stillShowZeroSum");
        // [0...max]
        var extent = data.getDataExtent(valueDim);
        extent[0] = 0;
        var dir = clockwise ? 1 : -1;
        var angles = [
            startAngle,
            endAngle
        ];
        var halfPadAngle = dir * padAngle / 2;
        (0, $20ebe2448f123f2e$export$bc668021e937022a)(angles, !clockwise);
        startAngle = angles[0], endAngle = angles[1];
        var layoutData = $21576fcf4c669316$export$4e43b88a06b9f223(seriesModel);
        layoutData.startAngle = startAngle;
        layoutData.endAngle = endAngle;
        layoutData.clockwise = clockwise;
        layoutData.cx = cx;
        layoutData.cy = cy;
        layoutData.r = r;
        layoutData.r0 = r0;
        var angleRange = Math.abs(endAngle - startAngle);
        // In the case some sector angle is smaller than minAngle
        var restAngle = angleRange;
        var valueSumLargerThanMinAngle = 0;
        var currentAngle = startAngle;
        // Requird by `pieLabelLayout`.
        data.setLayout({
            viewRect: viewRect,
            r: r
        });
        data.each(valueDim, function(value, idx) {
            var angle;
            if (isNaN(value)) {
                data.setItemLayout(idx, {
                    angle: NaN,
                    startAngle: NaN,
                    endAngle: NaN,
                    clockwise: clockwise,
                    cx: cx,
                    cy: cy,
                    r0: r0,
                    r: roseType ? NaN : r
                });
                return;
            }
            // FIXME 兼容 2.0 但是 roseType 是 area 的时候才是这样？
            if (roseType !== "area") angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
            else angle = angleRange / validDataCount;
            if (angle < minAndPadAngle) {
                angle = minAndPadAngle;
                restAngle -= minAndPadAngle;
            } else valueSumLargerThanMinAngle += value;
            var endAngle = currentAngle + dir * angle;
            // calculate display angle
            var actualStartAngle = 0;
            var actualEndAngle = 0;
            if (padAngle > angle) {
                actualStartAngle = currentAngle + dir * angle / 2;
                actualEndAngle = actualStartAngle;
            } else {
                actualStartAngle = currentAngle + halfPadAngle;
                actualEndAngle = endAngle - halfPadAngle;
            }
            data.setItemLayout(idx, {
                angle: angle,
                startAngle: actualStartAngle,
                endAngle: actualEndAngle,
                clockwise: clockwise,
                cx: cx,
                cy: cy,
                r0: r0,
                r: roseType ? (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(value, extent, [
                    r0,
                    r
                ]) : r
            });
            currentAngle = endAngle;
        });
        // Some sector is constrained by minAngle and padAngle
        // Rest sectors needs recalculate angle
        if (restAngle < $21576fcf4c669316$var$PI2 && validDataCount) {
            // Average the angle if rest angle is not enough after all angles is
            // Constrained by minAngle and padAngle
            if (restAngle <= 1e-3) {
                var angle_1 = angleRange / validDataCount;
                data.each(valueDim, function(value, idx) {
                    if (!isNaN(value)) {
                        var layout = data.getItemLayout(idx);
                        layout.angle = angle_1;
                        var actualStartAngle = 0;
                        var actualEndAngle = 0;
                        if (angle_1 < padAngle) {
                            actualStartAngle = startAngle + dir * (idx + 0.5) * angle_1;
                            actualEndAngle = actualStartAngle;
                        } else {
                            actualStartAngle = startAngle + dir * idx * angle_1 + halfPadAngle;
                            actualEndAngle = startAngle + dir * (idx + 1) * angle_1 - halfPadAngle;
                        }
                        layout.startAngle = actualStartAngle;
                        layout.endAngle = actualEndAngle;
                    }
                });
            } else {
                unitRadian = restAngle / valueSumLargerThanMinAngle;
                currentAngle = startAngle;
                data.each(valueDim, function(value, idx) {
                    if (!isNaN(value)) {
                        var layout = data.getItemLayout(idx);
                        var angle = layout.angle === minAndPadAngle ? minAndPadAngle : value * unitRadian;
                        var actualStartAngle = 0;
                        var actualEndAngle = 0;
                        if (angle < padAngle) {
                            actualStartAngle = currentAngle + dir * angle / 2;
                            actualEndAngle = actualStartAngle;
                        } else {
                            actualStartAngle = currentAngle + halfPadAngle;
                            actualEndAngle = currentAngle + dir * angle - halfPadAngle;
                        }
                        layout.startAngle = actualStartAngle;
                        layout.endAngle = actualEndAngle;
                        currentAngle += dir * angle;
                    }
                });
            }
        }
    });
}
var $21576fcf4c669316$export$4e43b88a06b9f223 = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // FIXME emphasis label position is not same with normal label position






var $4b109d23b790ee9a$var$RADIAN = Math.PI / 180;
function $4b109d23b790ee9a$var$adjustSingleSide(list, cx, cy, r, dir, viewWidth, viewHeight, viewLeft, viewTop, farthestX) {
    if (list.length < 2) return;
    function recalculateXOnSemiToAlignOnEllipseCurve(semi) {
        var rB = semi.rB;
        var rB2 = rB * rB;
        for(var i = 0; i < semi.list.length; i++){
            var item = semi.list[i];
            var dy = Math.abs(item.label.y - cy);
            // horizontal r is always same with original r because x is not changed.
            var rA = r + item.len;
            var rA2 = rA * rA;
            // Use ellipse implicit function to calculate x
            var dx = Math.sqrt(Math.abs((1 - dy * dy / rB2) * rA2));
            var newX = cx + (dx + item.len2) * dir;
            var deltaX = newX - item.label.x;
            var newTargetWidth = item.targetTextWidth - deltaX * dir;
            // text x is changed, so need to recalculate width.
            $4b109d23b790ee9a$var$constrainTextWidth(item, newTargetWidth, true);
            item.label.x = newX;
        }
    }
    // Adjust X based on the shifted y. Make tight labels aligned on an ellipse curve.
    function recalculateX(items) {
        // Extremes of
        var topSemi = {
            list: [],
            maxY: 0
        };
        var bottomSemi = {
            list: [],
            maxY: 0
        };
        for(var i = 0; i < items.length; i++){
            if (items[i].labelAlignTo !== "none") continue;
            var item = items[i];
            var semi = item.label.y > cy ? bottomSemi : topSemi;
            var dy = Math.abs(item.label.y - cy);
            if (dy >= semi.maxY) {
                var dx = item.label.x - cx - item.len2 * dir;
                // horizontal r is always same with original r because x is not changed.
                var rA = r + item.len;
                // Canculate rB based on the topest / bottemest label.
                var rB = Math.abs(dx) < rA ? Math.sqrt(dy * dy / (1 - dx * dx / rA / rA)) : rA;
                semi.rB = rB;
                semi.maxY = dy;
            }
            semi.list.push(item);
        }
        recalculateXOnSemiToAlignOnEllipseCurve(topSemi);
        recalculateXOnSemiToAlignOnEllipseCurve(bottomSemi);
    }
    var len = list.length;
    for(var i = 0; i < len; i++)if (list[i].position === "outer" && list[i].labelAlignTo === "labelLine") {
        var dx = list[i].label.x - farthestX;
        list[i].linePoints[1][0] += dx;
        list[i].label.x = farthestX;
    }
    if ((0, $11dac7a73f36cc2c$export$73ee08bc808f6f3f)(list, 1, viewTop, viewTop + viewHeight)) recalculateX(list);
}
function $4b109d23b790ee9a$var$avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop) {
    var leftList = [];
    var rightList = [];
    var leftmostX = Number.MAX_VALUE;
    var rightmostX = -Number.MAX_VALUE;
    for(var i = 0; i < labelLayoutList.length; i++){
        var label = labelLayoutList[i].label;
        if ($4b109d23b790ee9a$var$isPositionCenter(labelLayoutList[i])) continue;
        if (label.x < cx) {
            leftmostX = Math.min(leftmostX, label.x);
            leftList.push(labelLayoutList[i]);
        } else {
            rightmostX = Math.max(rightmostX, label.x);
            rightList.push(labelLayoutList[i]);
        }
    }
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        if (!$4b109d23b790ee9a$var$isPositionCenter(layout) && layout.linePoints) {
            if (layout.labelStyleWidth != null) continue;
            var label = layout.label;
            var linePoints = layout.linePoints;
            var targetTextWidth = void 0;
            if (layout.labelAlignTo === "edge") {
                if (label.x < cx) targetTextWidth = linePoints[2][0] - layout.labelDistance - viewLeft - layout.edgeDistance;
                else targetTextWidth = viewLeft + viewWidth - layout.edgeDistance - linePoints[2][0] - layout.labelDistance;
            } else if (layout.labelAlignTo === "labelLine") {
                if (label.x < cx) targetTextWidth = leftmostX - viewLeft - layout.bleedMargin;
                else targetTextWidth = viewLeft + viewWidth - rightmostX - layout.bleedMargin;
            } else if (label.x < cx) targetTextWidth = label.x - viewLeft - layout.bleedMargin;
            else targetTextWidth = viewLeft + viewWidth - label.x - layout.bleedMargin;
            layout.targetTextWidth = targetTextWidth;
            $4b109d23b790ee9a$var$constrainTextWidth(layout, targetTextWidth, false);
        }
    }
    $4b109d23b790ee9a$var$adjustSingleSide(rightList, cx, cy, r, 1, viewWidth, viewHeight, viewLeft, viewTop, rightmostX);
    $4b109d23b790ee9a$var$adjustSingleSide(leftList, cx, cy, r, -1, viewWidth, viewHeight, viewLeft, viewTop, leftmostX);
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        if (!$4b109d23b790ee9a$var$isPositionCenter(layout) && layout.linePoints) {
            var label = layout.label;
            var linePoints = layout.linePoints;
            var isAlignToEdge = layout.labelAlignTo === "edge";
            var padding = label.style.padding;
            var paddingH = padding ? padding[1] + padding[3] : 0;
            // textRect.width already contains paddingH if bgColor is set
            var extraPaddingH = label.style.backgroundColor ? 0 : paddingH;
            var realTextWidth = layout.rect.width + extraPaddingH;
            var dist = linePoints[1][0] - linePoints[2][0];
            if (isAlignToEdge) {
                if (label.x < cx) linePoints[2][0] = viewLeft + layout.edgeDistance + realTextWidth + layout.labelDistance;
                else linePoints[2][0] = viewLeft + viewWidth - layout.edgeDistance - realTextWidth - layout.labelDistance;
            } else {
                if (label.x < cx) linePoints[2][0] = label.x + layout.labelDistance;
                else linePoints[2][0] = label.x - layout.labelDistance;
                linePoints[1][0] = linePoints[2][0] + dist;
            }
            linePoints[1][1] = linePoints[2][1] = label.y;
        }
    }
}
/**
 * Set max width of each label, and then wrap each label to the max width.
 *
 * @param layout label layout
 * @param availableWidth max width for the label to display
 * @param forceRecalculate recaculate the text layout even if the current width
 * is smaller than `availableWidth`. This is useful when the text was previously
 * wrapped by calling `constrainTextWidth` but now `availableWidth` changed, in
 * which case, previous wrapping should be redo.
 */ function $4b109d23b790ee9a$var$constrainTextWidth(layout, availableWidth, forceRecalculate) {
    if (layout.labelStyleWidth != null) // User-defined style.width has the highest priority.
    return;
    var label = layout.label;
    var style = label.style;
    var textRect = layout.rect;
    var bgColor = style.backgroundColor;
    var padding = style.padding;
    var paddingH = padding ? padding[1] + padding[3] : 0;
    var overflow = style.overflow;
    // textRect.width already contains paddingH if bgColor is set
    var oldOuterWidth = textRect.width + (bgColor ? 0 : paddingH);
    if (availableWidth < oldOuterWidth || forceRecalculate) {
        if (overflow && overflow.match("break")) {
            // Temporarily set background to be null to calculate
            // the bounding box without background.
            label.setStyle("backgroundColor", null);
            // Set constraining width
            label.setStyle("width", availableWidth - paddingH);
            // This is the real bounding box of the text without padding.
            var innerRect = label.getBoundingRect();
            label.setStyle("width", Math.ceil(innerRect.width));
            label.setStyle("backgroundColor", bgColor);
        } else {
            var availableInnerWidth = availableWidth - paddingH;
            var newWidth = availableWidth < oldOuterWidth ? availableInnerWidth : // Current available width is enough, but the text may have
            // already been wrapped with a smaller available width.
            forceRecalculate ? availableInnerWidth > layout.unconstrainedWidth ? null : availableInnerWidth : null;
            label.setStyle("width", newWidth);
        }
        $4b109d23b790ee9a$var$computeLabelGlobalRect(textRect, label);
    }
}
function $4b109d23b790ee9a$var$computeLabelGlobalRect(out, label) {
    $4b109d23b790ee9a$var$_tmpLabelGeometry.rect = out;
    (0, $11dac7a73f36cc2c$export$af9bffc2d00de2cc)($4b109d23b790ee9a$var$_tmpLabelGeometry, label, $4b109d23b790ee9a$var$_computeLabelGeometryOpt);
}
var $4b109d23b790ee9a$var$_computeLabelGeometryOpt = {
    minMarginForce: [
        null,
        0,
        null,
        0
    ],
    marginDefault: [
        1,
        0,
        1,
        0
    ]
};
var $4b109d23b790ee9a$var$_tmpLabelGeometry = {};
function $4b109d23b790ee9a$var$isPositionCenter(sectorShape) {
    // Not change x for center label
    return sectorShape.position === "center";
}
function $4b109d23b790ee9a$export$2e2bcd8739ae039(seriesModel) {
    var data = seriesModel.getData();
    var labelLayoutList = [];
    var cx;
    var cy;
    var hasLabelRotate = false;
    var minShowLabelRadian = (seriesModel.get("minShowLabelAngle") || 0) * $4b109d23b790ee9a$var$RADIAN;
    var viewRect = data.getLayout("viewRect");
    var r = data.getLayout("r");
    var viewWidth = viewRect.width;
    var viewLeft = viewRect.x;
    var viewTop = viewRect.y;
    var viewHeight = viewRect.height;
    function setNotShow(el) {
        el.ignore = true;
    }
    function isLabelShown(label) {
        if (!label.ignore) return true;
        for(var key in label.states){
            if (label.states[key].ignore === false) return true;
        }
        return false;
    }
    data.each(function(idx) {
        var sector = data.getItemGraphicEl(idx);
        var sectorShape = sector.shape;
        var label = sector.getTextContent();
        var labelLine = sector.getTextGuideLine();
        var itemModel = data.getItemModel(idx);
        var labelModel = itemModel.getModel("label");
        // Use position in normal or emphasis
        var labelPosition = labelModel.get("position") || itemModel.get([
            "emphasis",
            "label",
            "position"
        ]);
        var labelDistance = labelModel.get("distanceToLabelLine");
        var labelAlignTo = labelModel.get("alignTo");
        var edgeDistance = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(labelModel.get("edgeDistance"), viewWidth);
        var bleedMargin = labelModel.get("bleedMargin");
        if (bleedMargin == null) // An arbitrary strategy for small viewRect - especial pie is layout in calendar or matrix coord sys.
        bleedMargin = Math.min(viewWidth, viewHeight) > 200 ? 10 : 2;
        var labelLineModel = itemModel.getModel("labelLine");
        var labelLineLen = labelLineModel.get("length");
        labelLineLen = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(labelLineLen, viewWidth);
        var labelLineLen2 = labelLineModel.get("length2");
        labelLineLen2 = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(labelLineLen2, viewWidth);
        if (Math.abs(sectorShape.endAngle - sectorShape.startAngle) < minShowLabelRadian) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(label.states, setNotShow);
            label.ignore = true;
            if (labelLine) {
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(labelLine.states, setNotShow);
                labelLine.ignore = true;
            }
            return;
        }
        if (!isLabelShown(label)) return;
        var midAngle = (sectorShape.startAngle + sectorShape.endAngle) / 2;
        var nx = Math.cos(midAngle);
        var ny = Math.sin(midAngle);
        var textX;
        var textY;
        var linePoints;
        var textAlign;
        cx = sectorShape.cx;
        cy = sectorShape.cy;
        var isLabelInside = labelPosition === "inside" || labelPosition === "inner";
        if (labelPosition === "center") {
            textX = sectorShape.cx;
            textY = sectorShape.cy;
            textAlign = "center";
        } else {
            var x1 = (isLabelInside ? (sectorShape.r + sectorShape.r0) / 2 * nx : sectorShape.r * nx) + cx;
            var y1 = (isLabelInside ? (sectorShape.r + sectorShape.r0) / 2 * ny : sectorShape.r * ny) + cy;
            textX = x1 + nx * 3;
            textY = y1 + ny * 3;
            if (!isLabelInside) {
                // For roseType
                var x2 = x1 + nx * (labelLineLen + r - sectorShape.r);
                var y2 = y1 + ny * (labelLineLen + r - sectorShape.r);
                var x3 = x2 + (nx < 0 ? -1 : 1) * labelLineLen2;
                var y3 = y2;
                if (labelAlignTo === "edge") // Adjust textX because text align of edge is opposite
                textX = nx < 0 ? viewLeft + edgeDistance : viewLeft + viewWidth - edgeDistance;
                else textX = x3 + (nx < 0 ? -labelDistance : labelDistance);
                textY = y3;
                linePoints = [
                    [
                        x1,
                        y1
                    ],
                    [
                        x2,
                        y2
                    ],
                    [
                        x3,
                        y3
                    ]
                ];
            }
            textAlign = isLabelInside ? "center" : labelAlignTo === "edge" ? nx > 0 ? "right" : "left" : nx > 0 ? "left" : "right";
        }
        var PI = Math.PI;
        var labelRotate = 0;
        var rotate = labelModel.get("rotate");
        if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rotate)) labelRotate = rotate * (PI / 180);
        else if (labelPosition === "center") labelRotate = 0;
        else if (rotate === "radial" || rotate === true) {
            var radialAngle = nx < 0 ? -midAngle + PI : -midAngle;
            labelRotate = radialAngle;
        } else if (rotate === "tangential" && labelPosition !== "outside" && labelPosition !== "outer") {
            var rad = Math.atan2(nx, ny);
            if (rad < 0) rad = PI * 2 + rad;
            var isDown = ny > 0;
            if (isDown) rad = PI + rad;
            labelRotate = rad - PI;
        }
        hasLabelRotate = !!labelRotate;
        label.x = textX;
        label.y = textY;
        label.rotation = labelRotate;
        label.setStyle({
            verticalAlign: "middle"
        });
        // Not sectorShape the inside label
        if (!isLabelInside) {
            var textRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
            $4b109d23b790ee9a$var$computeLabelGlobalRect(textRect, label);
            labelLayoutList.push({
                label: label,
                labelLine: labelLine,
                position: labelPosition,
                len: labelLineLen,
                len2: labelLineLen2,
                minTurnAngle: labelLineModel.get("minTurnAngle"),
                maxSurfaceAngle: labelLineModel.get("maxSurfaceAngle"),
                surfaceNormal: new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(nx, ny),
                linePoints: linePoints,
                textAlign: textAlign,
                labelDistance: labelDistance,
                labelAlignTo: labelAlignTo,
                edgeDistance: edgeDistance,
                bleedMargin: bleedMargin,
                rect: textRect,
                unconstrainedWidth: textRect.width,
                labelStyleWidth: label.style.width
            });
        } else {
            label.setStyle({
                align: textAlign
            });
            var selectState = label.states.select;
            if (selectState) {
                selectState.x += label.x;
                selectState.y += label.y;
            }
        }
        sector.setTextConfig({
            inside: isLabelInside
        });
    });
    if (!hasLabelRotate && seriesModel.get("avoidLabelOverlap")) $4b109d23b790ee9a$var$avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop);
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        var label = layout.label;
        var labelLine = layout.labelLine;
        var notShowLabel = isNaN(label.x) || isNaN(label.y);
        if (label) {
            label.setStyle({
                align: layout.textAlign
            });
            if (notShowLabel) {
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(label.states, setNotShow);
                label.ignore = true;
            }
            var selectState = label.states.select;
            if (selectState) {
                selectState.x += label.x;
                selectState.y += label.y;
            }
        }
        if (labelLine) {
            var linePoints = layout.linePoints;
            if (notShowLabel || !linePoints) {
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(labelLine.states, setNotShow);
                labelLine.ignore = true;
            } else {
                (0, $f4eb87a228be297f$export$ac52062003fbe6a)(linePoints, layout.minTurnAngle);
                (0, $f4eb87a228be297f$export$973e1fdb2708f71b)(linePoints, layout.surfaceNormal, layout.maxSurfaceAngle);
                labelLine.setShape({
                    points: linePoints
                });
                // Set the anchor to the midpoint of sector
                label.__hostTarget.textGuideLineConfig = {
                    anchor: new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(linePoints[0][0], linePoints[0][1])
                };
            }
        }
    }
}







/**
 * Piece of pie including Sector, Label, LabelLine
 */ var $773d25f97e67400e$var$PiePiece = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PiePiece, _super);
    function PiePiece(data, idx, startAngle) {
        var _this = _super.call(this) || this;
        _this.z2 = 2;
        var text = new $fe885cc21795562b$export$2e2bcd8739ae039();
        _this.setTextContent(text);
        _this.updateData(data, idx, startAngle, true);
        return _this;
    }
    PiePiece.prototype.updateData = function(data, idx, startAngle, firstCreate) {
        var sector = this;
        var seriesModel = data.hostModel;
        var itemModel = data.getItemModel(idx);
        var emphasisModel = itemModel.getModel("emphasis");
        var layout = data.getItemLayout(idx);
        // cornerRadius & innerCornerRadius doesn't exist in the item layout. Use `0` if null value is specified.
        // see `setItemLayout` in `pieLayout.ts`.
        var sectorShape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemModel.getModel("itemStyle"), layout, true), layout);
        // Ignore NaN data.
        if (isNaN(sectorShape.startAngle)) {
            // Use NaN shape to avoid drawing shape.
            sector.setShape(sectorShape);
            return;
        }
        if (firstCreate) {
            sector.setShape(sectorShape);
            var animationType = seriesModel.getShallow("animationType");
            if (seriesModel.ecModel.ssr) {
                // Use scale animation in SSR mode(opacity?)
                // Because CSS SVG animation doesn't support very customized shape animation.
                $8b353638fbedfefa$export$a121566aadcfe021(sector, {
                    scaleX: 0,
                    scaleY: 0
                }, seriesModel, {
                    dataIndex: idx,
                    isFrom: true
                });
                sector.originX = sectorShape.cx;
                sector.originY = sectorShape.cy;
            } else if (animationType === "scale") {
                sector.shape.r = layout.r0;
                $8b353638fbedfefa$export$a121566aadcfe021(sector, {
                    shape: {
                        r: layout.r
                    }
                }, seriesModel, idx);
            } else if (startAngle != null) {
                sector.setShape({
                    startAngle: startAngle,
                    endAngle: startAngle
                });
                $8b353638fbedfefa$export$a121566aadcfe021(sector, {
                    shape: {
                        startAngle: layout.startAngle,
                        endAngle: layout.endAngle
                    }
                }, seriesModel, idx);
            } else {
                sector.shape.endAngle = layout.startAngle;
                $8b353638fbedfefa$export$c8dce3c08436e91e(sector, {
                    shape: {
                        endAngle: layout.endAngle
                    }
                }, seriesModel, idx);
            }
        } else {
            (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(sector);
            // Transition animation from the old shape
            $8b353638fbedfefa$export$c8dce3c08436e91e(sector, {
                shape: sectorShape
            }, seriesModel, idx);
        }
        sector.useStyle(data.getItemVisual(idx, "style"));
        (0, $2bf82c0980125b62$export$48b68047d330bbc9)(sector, itemModel);
        var midAngle = (layout.startAngle + layout.endAngle) / 2;
        var offset = seriesModel.get("selectedOffset");
        var dx = Math.cos(midAngle) * offset;
        var dy = Math.sin(midAngle) * offset;
        var cursorStyle = itemModel.getShallow("cursor");
        cursorStyle && sector.attr("cursor", cursorStyle);
        this._updateLabel(seriesModel, data, idx);
        sector.ensureState("emphasis").shape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
            r: layout.r + (emphasisModel.get("scale") ? emphasisModel.get("scaleSize") || 0 : 0)
        }, (0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(emphasisModel.getModel("itemStyle"), layout));
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(sector.ensureState("select"), {
            x: dx,
            y: dy,
            shape: (0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemModel.getModel([
                "select",
                "itemStyle"
            ]), layout)
        });
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(sector.ensureState("blur"), {
            shape: (0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemModel.getModel([
                "blur",
                "itemStyle"
            ]), layout)
        });
        var labelLine = sector.getTextGuideLine();
        var labelText = sector.getTextContent();
        labelLine && (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(labelLine.ensureState("select"), {
            x: dx,
            y: dy
        });
        // TODO: needs dx, dy in zrender?
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(labelText.ensureState("select"), {
            x: dx,
            y: dy
        });
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
    };
    PiePiece.prototype._updateLabel = function(seriesModel, data, idx) {
        var sector = this;
        var itemModel = data.getItemModel(idx);
        var labelLineModel = itemModel.getModel("labelLine");
        var style = data.getItemVisual(idx, "style");
        var visualColor = style && style.fill;
        var visualOpacity = style && style.opacity;
        (0, $6800dfcb6e1e2a44$export$9a13992917966657)(sector, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
            labelFetcher: data.hostModel,
            labelDataIndex: idx,
            inheritColor: visualColor,
            defaultOpacity: visualOpacity,
            defaultText: seriesModel.getFormattedLabel(idx, "normal") || data.getName(idx)
        });
        var labelText = sector.getTextContent();
        // Set textConfig on sector.
        sector.setTextConfig({
            // reset position, rotation
            position: null,
            rotation: null
        });
        // Make sure update style on labelText after setLabelStyle.
        // Because setLabelStyle will replace a new style on it.
        labelText.attr({
            z2: 10
        });
        var labelPosition = itemModel.get([
            "label",
            "position"
        ]);
        if (labelPosition !== "outside" && labelPosition !== "outer") sector.removeTextGuideLine();
        else {
            var polyline = this.getTextGuideLine();
            if (!polyline) {
                polyline = new $d28119f30e6bb670$export$2e2bcd8739ae039();
                this.setTextGuideLine(polyline);
            }
            // Default use item visual color
            (0, $f4eb87a228be297f$export$c09e0b0574bdd2dc)(this, (0, $f4eb87a228be297f$export$2979fdbf5ebce521)(itemModel), {
                stroke: visualColor,
                opacity: (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(labelLineModel.get([
                    "lineStyle",
                    "opacity"
                ]), visualOpacity, 1)
            });
        }
    };
    return PiePiece;
}($a3e1dec0a3875b49$export$2e2bcd8739ae039);
// Pie view
var $773d25f97e67400e$var$PieView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PieView, _super);
    function PieView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ignoreLabelLineUpdate = true;
        return _this;
    }
    PieView.prototype.render = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var oldData = this._data;
        var group = this.group;
        var startAngle;
        // First render
        if (!oldData && data.count() > 0) {
            var shape = data.getItemLayout(0);
            for(var s = 1; isNaN(shape && shape.startAngle) && s < data.count(); ++s)shape = data.getItemLayout(s);
            if (shape) startAngle = shape.startAngle;
        }
        // remove empty-circle if it exists
        if (this._emptyCircleSector) group.remove(this._emptyCircleSector);
        // when all data are filtered, show lightgray empty circle
        if (data.count() === 0 && seriesModel.get("showEmptyCircle")) {
            var layoutData = (0, $21576fcf4c669316$export$4e43b88a06b9f223)(seriesModel);
            var sector = new $a3e1dec0a3875b49$export$2e2bcd8739ae039({
                shape: (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(layoutData)
            });
            sector.useStyle(seriesModel.getModel("emptyCircleStyle").getItemStyle());
            this._emptyCircleSector = sector;
            group.add(sector);
        }
        data.diff(oldData).add(function(idx) {
            var piePiece = new $773d25f97e67400e$var$PiePiece(data, idx, startAngle);
            data.setItemGraphicEl(idx, piePiece);
            group.add(piePiece);
        }).update(function(newIdx, oldIdx) {
            var piePiece = oldData.getItemGraphicEl(oldIdx);
            piePiece.updateData(data, newIdx, startAngle);
            piePiece.off("click");
            group.add(piePiece);
            data.setItemGraphicEl(newIdx, piePiece);
        }).remove(function(idx) {
            var piePiece = oldData.getItemGraphicEl(idx);
            $8b353638fbedfefa$export$6d0fd725cb4aee8a(piePiece, seriesModel, idx);
        }).execute();
        (0, $4b109d23b790ee9a$export$2e2bcd8739ae039)(seriesModel);
        // Always use initial animation.
        if (seriesModel.get("animationTypeUpdate") !== "expansion") this._data = data;
    };
    PieView.prototype.dispose = function() {};
    PieView.prototype.containPoint = function(point, seriesModel) {
        var data = seriesModel.getData();
        var itemLayout = data.getItemLayout(0);
        if (itemLayout) {
            var dx = point[0] - itemLayout.cx;
            var dy = point[1] - itemLayout.cy;
            var radius = Math.sqrt(dx * dx + dy * dy);
            return radius <= itemLayout.r && radius >= itemLayout.r0;
        }
    };
    PieView.type = "pie";
    return PieView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $773d25f97e67400e$export$2e2bcd8739ae039 = $773d25f97e67400e$var$PieView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








var $9de67b16c98ecc62$var$innerData = $76d619f648247e6d$export$64df9f8d92ae083f();
var $9de67b16c98ecc62$var$PieSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PieSeriesModel, _super);
    function PieSeriesModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @overwrite
   */ PieSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $cf24728fc17c4ab6$export$2e2bcd8739ae039)($7a1bd9c2710fea0d$export$2385a24977818dd0(this.getData, this), $7a1bd9c2710fea0d$export$2385a24977818dd0(this.getRawData, this));
        this._defaultLabelLine(option);
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.mergeOption = function() {
        _super.prototype.mergeOption.apply(this, arguments);
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.getInitialData = function() {
        return (0, $7e5c3511527c9907$export$2e2bcd8739ae039)(this, {
            coordDimensions: [
                "value"
            ],
            encodeDefaulter: $7a1bd9c2710fea0d$export$c3095a23b368d1f2((0, $7dc6cdfd7450ef29$export$60b8a57d1f2fed26), this)
        });
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.getDataParams = function(dataIndex) {
        var data = this.getData();
        // update seats when data is changed
        var dataInner = $9de67b16c98ecc62$var$innerData(data);
        var seats = dataInner.seats;
        if (!seats) {
            var valueList_1 = [];
            data.each(data.mapDimension("value"), function(value) {
                valueList_1.push(value);
            });
            seats = dataInner.seats = (0, $cfc1f3b422a3185f$export$222dabb13d5320df)(valueList_1, data.hostModel.get("percentPrecision"));
        }
        var params = _super.prototype.getDataParams.call(this, dataIndex);
        // seats may be empty when sum is 0
        params.percent = seats[dataIndex] || 0;
        params.$vars.push("percent");
        return params;
    };
    PieSeriesModel.prototype._defaultLabelLine = function(option) {
        // Extend labelLine emphasis
        $76d619f648247e6d$export$abdcc6a26372f94b(option, "labelLine", [
            "show"
        ]);
        var labelLineNormalOpt = option.labelLine;
        var labelLineEmphasisOpt = option.emphasis.labelLine;
        // Not show label line if `label.normal.show = false`
        labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
        labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
    };
    PieSeriesModel.type = "series.pie";
    PieSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        colorBy: "data",
        // 默认全局居中
        center: [
            "50%",
            "50%"
        ],
        radius: [
            0,
            "50%"
        ],
        // 默认顺时针
        clockwise: true,
        startAngle: 90,
        endAngle: "auto",
        padAngle: 0,
        // 最小角度改为0
        minAngle: 0,
        // If the angle of a sector less than `minShowLabelAngle`,
        // the label will not be displayed.
        minShowLabelAngle: 0,
        // 选中时扇区偏移量
        selectedOffset: 10,
        // 选择模式，默认关闭，可选single，multiple
        // selectedMode: false,
        // 南丁格尔玫瑰图模式，'radius'（半径） | 'area'（面积）
        // roseType: null,
        percentPrecision: 2,
        // If still show when all data zero.
        stillShowZeroSum: true,
        // cursor: null,
        coordinateSystemUsage: "box",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        width: null,
        height: null,
        label: {
            // color: 'inherit',
            // If rotate around circle
            rotate: 0,
            show: true,
            overflow: "truncate",
            // 'outer', 'inside', 'center'
            position: "outer",
            // 'none', 'labelLine', 'edge'. Works only when position is 'outer'
            alignTo: "none",
            // Closest distance between label and chart edge.
            // Works only position is 'outer' and alignTo is 'edge'.
            edgeDistance: "25%",
            // Works only position is 'outer' and alignTo is not 'edge'.
            // The default `bleedMargin` is auto determined according to view rect size.
            // bleedMargin: 10,
            // Distance between text and label line.
            distanceToLabelLine: 5
        },
        // Enabled when label.normal.position is 'outer'
        labelLine: {
            show: true,
            // 引导线两段中的第一段长度
            length: 15,
            // 引导线两段中的第二段长度
            length2: 30,
            smooth: false,
            minTurnAngle: 90,
            maxSurfaceAngle: 90,
            lineStyle: {
                // color: 各异,
                width: 1,
                type: "solid"
            }
        },
        itemStyle: {
            borderWidth: 1,
            borderJoin: "round"
        },
        showEmptyCircle: true,
        emptyCircleStyle: {
            color: "lightgray",
            opacity: 1
        },
        labelLayout: {
            // Hide the overlapped label.
            hideOverlap: true
        },
        emphasis: {
            scale: true,
            scaleSize: 5
        },
        // If use strategy to avoid label overlapping
        avoidLabelOverlap: true,
        // Animation type. Valid values: expansion, scale
        animationType: "expansion",
        animationDuration: 1000,
        // Animation type when update. Valid values: transition, expansion
        animationTypeUpdate: "transition",
        animationEasingUpdate: "cubicInOut",
        animationDurationUpdate: 500,
        animationEasing: "cubicInOut"
    };
    return PieSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
(0, $70c3ede7d3b64757$export$b8fb890203e861d5)({
    fullType: $9de67b16c98ecc62$var$PieSeriesModel.type,
    getCoord2: function(model) {
        // Not able to validate `center` type here.
        // But percentage center, such as '12%', is not allowed in this case.
        return model.getShallow("center");
    }
});
var $9de67b16c98ecc62$export$2e2bcd8739ae039 = $9de67b16c98ecc62$var$PieSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $10dfc09d63e54240$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        reset: function(seriesModel, ecModel) {
            var data = seriesModel.getData();
            data.filterSelf(function(idx) {
                // handle negative value condition
                var valueDim = data.mapDimension("value");
                var curValue = data.get(valueDim, idx);
                if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(curValue) && !isNaN(curValue) && curValue < 0) return false;
                return true;
            });
        }
    };
}


function $6b7ead9b40180cba$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $773d25f97e67400e$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $9de67b16c98ecc62$export$2e2bcd8739ae039));
    (0, $e855ccf7eff48bce$export$62942ba95693dbfc)("pie", registers.registerAction);
    registers.registerLayout((0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)((0, $21576fcf4c669316$export$2e2bcd8739ae039), "pie"));
    registers.registerProcessor((0, $e11a533bf70b759c$export$2e2bcd8739ae039)("pie"));
    registers.registerProcessor((0, $10dfc09d63e54240$export$2e2bcd8739ae039)("pie"));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $bec68b02ebcf9063$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType("radar", function(seriesModel) {
        var data = seriesModel.getData();
        var points = [];
        var coordSys = seriesModel.coordinateSystem;
        if (!coordSys) return;
        var axes = coordSys.getIndicatorAxes();
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(axes, function(axis, axisIndex) {
            data.each(data.mapDimension(axes[axisIndex].dim), function(val, dataIndex) {
                points[dataIndex] = points[dataIndex] || [];
                var point = coordSys.dataToPoint(val, axisIndex);
                points[dataIndex][axisIndex] = $bec68b02ebcf9063$var$isValidPoint(point) ? point : $bec68b02ebcf9063$var$getValueMissingPoint(coordSys);
            });
        });
        // Close polygon
        data.each(function(idx) {
            // TODO
            // Is it appropriate to connect to the next data when some data is missing?
            // Or, should trade it like `connectNull` in line chart?
            var firstPoint = $7a1bd9c2710fea0d$export$71aa6c912b956294(points[idx], function(point) {
                return $bec68b02ebcf9063$var$isValidPoint(point);
            }) || $bec68b02ebcf9063$var$getValueMissingPoint(coordSys);
            // Copy the first actual point to the end of the array
            points[idx].push(firstPoint.slice());
            data.setItemLayout(idx, points[idx]);
        });
    });
}
function $bec68b02ebcf9063$var$isValidPoint(point) {
    return !isNaN(point[0]) && !isNaN(point[1]);
}
function $bec68b02ebcf9063$var$getValueMissingPoint(coordSys) {
    // It is error-prone to input [NaN, NaN] into polygon, polygon.
    // (probably cause problem when refreshing or animating)
    return [
        coordSys.cx,
        coordSys.cy
    ];
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck
// Backward compat for radar chart in 2

function $506480c8f28f74be$export$2e2bcd8739ae039(option) {
    var polarOptArr = option.polar;
    if (polarOptArr) {
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(polarOptArr)) polarOptArr = [
            polarOptArr
        ];
        var polarNotRadar_1 = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(polarOptArr, function(polarOpt, idx) {
            if (polarOpt.indicator) {
                if (polarOpt.type && !polarOpt.shape) polarOpt.shape = polarOpt.type;
                option.radar = option.radar || [];
                if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(option.radar)) option.radar = [
                    option.radar
                ];
                option.radar.push(polarOpt);
            } else polarNotRadar_1.push(polarOpt);
        });
        option.polar = polarNotRadar_1;
    }
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(option.series, function(seriesOpt) {
        if (seriesOpt && seriesOpt.type === "radar" && seriesOpt.polarIndex) seriesOpt.radarIndex = seriesOpt.polarIndex;
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








var $1fc9e69f4602cced$var$RadarView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RadarView, _super);
    function RadarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadarView.type;
        return _this;
    }
    RadarView.prototype.render = function(seriesModel, ecModel, api) {
        var polar = seriesModel.coordinateSystem;
        var group = this.group;
        var data = seriesModel.getData();
        var oldData = this._data;
        function createSymbol(data, idx) {
            var symbolType = data.getItemVisual(idx, "symbol") || "circle";
            if (symbolType === "none") return;
            var symbolSize = $5370466dadc978d7$export$a84524f03e8e8dfb(data.getItemVisual(idx, "symbolSize"));
            var symbolPath = $5370466dadc978d7$export$af050e04da3a02e8(symbolType, -1, -1, 2, 2);
            var symbolRotate = data.getItemVisual(idx, "symbolRotate") || 0;
            symbolPath.attr({
                style: {
                    strokeNoScale: true
                },
                z2: 100,
                scaleX: symbolSize[0] / 2,
                scaleY: symbolSize[1] / 2,
                rotation: symbolRotate * Math.PI / 180 || 0
            });
            return symbolPath;
        }
        function updateSymbols(oldPoints, newPoints, symbolGroup, data, idx, isInit) {
            // Simply rerender all
            symbolGroup.removeAll();
            for(var i = 0; i < newPoints.length - 1; i++){
                var symbolPath = createSymbol(data, idx);
                if (symbolPath) {
                    symbolPath.__dimIdx = i;
                    if (oldPoints[i]) {
                        symbolPath.setPosition(oldPoints[i]);
                        $5b455ae6f843ac47$exports[isInit ? "initProps" : "updateProps"](symbolPath, {
                            x: newPoints[i][0],
                            y: newPoints[i][1]
                        }, seriesModel, idx);
                    } else symbolPath.setPosition(newPoints[i]);
                    symbolGroup.add(symbolPath);
                }
            }
        }
        function getInitialPoints(points) {
            return $7a1bd9c2710fea0d$export$871de8747c9eaa88(points, function(pt) {
                return [
                    polar.cx,
                    polar.cy
                ];
            });
        }
        data.diff(oldData).add(function(idx) {
            var points = data.getItemLayout(idx);
            if (!points) return;
            var polygon = new $5b455ae6f843ac47$exports.Polygon();
            var polyline = new $5b455ae6f843ac47$exports.Polyline();
            var target = {
                shape: {
                    points: points
                }
            };
            polygon.shape.points = getInitialPoints(points);
            polyline.shape.points = getInitialPoints(points);
            $5b455ae6f843ac47$exports.initProps(polygon, target, seriesModel, idx);
            $5b455ae6f843ac47$exports.initProps(polyline, target, seriesModel, idx);
            var itemGroup = new $5b455ae6f843ac47$exports.Group();
            var symbolGroup = new $5b455ae6f843ac47$exports.Group();
            itemGroup.add(polyline);
            itemGroup.add(polygon);
            itemGroup.add(symbolGroup);
            updateSymbols(polyline.shape.points, points, symbolGroup, data, idx, true);
            data.setItemGraphicEl(idx, itemGroup);
        }).update(function(newIdx, oldIdx) {
            var itemGroup = oldData.getItemGraphicEl(oldIdx);
            var polyline = itemGroup.childAt(0);
            var polygon = itemGroup.childAt(1);
            var symbolGroup = itemGroup.childAt(2);
            var target = {
                shape: {
                    points: data.getItemLayout(newIdx)
                }
            };
            if (!target.shape.points) return;
            updateSymbols(polyline.shape.points, target.shape.points, symbolGroup, data, newIdx, false);
            (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(polygon);
            (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(polyline);
            $5b455ae6f843ac47$exports.updateProps(polyline, target, seriesModel);
            $5b455ae6f843ac47$exports.updateProps(polygon, target, seriesModel);
            data.setItemGraphicEl(newIdx, itemGroup);
        }).remove(function(idx) {
            group.remove(oldData.getItemGraphicEl(idx));
        }).execute();
        data.eachItemGraphicEl(function(itemGroup, idx) {
            var itemModel = data.getItemModel(idx);
            var polyline = itemGroup.childAt(0);
            var polygon = itemGroup.childAt(1);
            var symbolGroup = itemGroup.childAt(2);
            // Radar uses the visual encoded from itemStyle.
            var itemStyle = data.getItemVisual(idx, "style");
            var color = itemStyle.fill;
            group.add(itemGroup);
            polyline.useStyle($7a1bd9c2710fea0d$export$ebe90cb607ad99e(itemModel.getModel("lineStyle").getLineStyle(), {
                fill: "none",
                stroke: color
            }));
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polyline, itemModel, "lineStyle");
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polygon, itemModel, "areaStyle");
            var areaStyleModel = itemModel.getModel("areaStyle");
            var polygonIgnore = areaStyleModel.isEmpty() && areaStyleModel.parentModel.isEmpty();
            polygon.ignore = polygonIgnore;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43([
                "emphasis",
                "select",
                "blur"
            ], function(stateName) {
                var stateModel = itemModel.getModel([
                    stateName,
                    "areaStyle"
                ]);
                var stateIgnore = stateModel.isEmpty() && stateModel.parentModel.isEmpty();
                // Won't be ignore if normal state is not ignore.
                polygon.ensureState(stateName).ignore = stateIgnore && polygonIgnore;
                var lineStyle = itemModel.getModel([
                    stateName,
                    "lineStyle"
                ]).getLineStyle();
                polyline.ensureState(stateName).style = lineStyle;
                var areaStyle = stateModel.getAreaStyle();
                polygon.ensureState(stateName).style = areaStyle;
                var itemStateStyle = itemModel.getModel([
                    stateName,
                    "itemStyle"
                ]).getItemStyle();
                symbolGroup.eachChild(function(symbolPath) {
                    symbolPath.ensureState(stateName).style = $7a1bd9c2710fea0d$export$9cd59f9826255e47(itemStateStyle);
                });
            });
            polygon.useStyle($7a1bd9c2710fea0d$export$ebe90cb607ad99e(itemModel.getModel("areaStyle").getAreaStyle(), {
                fill: color,
                opacity: 0.7,
                decal: itemStyle.decal
            }));
            var emphasisModel = itemModel.getModel("emphasis");
            symbolGroup.eachChild(function(symbolPath) {
                if (symbolPath instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
                    var pathStyle = symbolPath.style;
                    symbolPath.useStyle($7a1bd9c2710fea0d$export$8b58be045bf06082({
                        // TODO other properties like x, y ?
                        image: pathStyle.image,
                        x: pathStyle.x,
                        y: pathStyle.y,
                        width: pathStyle.width,
                        height: pathStyle.height
                    }, itemStyle));
                } else {
                    symbolPath.useStyle(itemStyle);
                    symbolPath.setColor(color);
                    symbolPath.style.strokeNoScale = true;
                }
                var defaultText = data.getStore().get(data.getDimensionIndex(symbolPath.__dimIdx), idx);
                (defaultText == null || isNaN(defaultText)) && (defaultText = "");
                (0, $6800dfcb6e1e2a44$export$9a13992917966657)(symbolPath, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
                    labelFetcher: data.hostModel,
                    labelDataIndex: idx,
                    labelDimIndex: symbolPath.__dimIdx,
                    defaultText: defaultText,
                    inheritColor: color,
                    defaultOpacity: itemStyle.opacity
                });
            });
            (0, $2bf82c0980125b62$export$e51187539ff11209)(itemGroup, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
        });
        this._data = data;
    };
    RadarView.prototype.remove = function() {
        this.group.removeAll();
        this._data = null;
    };
    RadarView.type = "radar";
    return RadarView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $1fc9e69f4602cced$export$2e2bcd8739ae039 = $1fc9e69f4602cced$var$RadarView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $3895e6b103877b59$var$RadarSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RadarSeriesModel, _super);
    function RadarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadarSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    // Overwrite
    RadarSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $cf24728fc17c4ab6$export$2e2bcd8739ae039)($7a1bd9c2710fea0d$export$2385a24977818dd0(this.getData, this), $7a1bd9c2710fea0d$export$2385a24977818dd0(this.getRawData, this));
    };
    RadarSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $7e5c3511527c9907$export$2e2bcd8739ae039)(this, {
            generateCoord: "indicator_",
            generateCoordCount: Infinity
        });
    };
    RadarSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var coordSys = this.coordinateSystem;
        var indicatorAxes = coordSys.getIndicatorAxes();
        var name = this.getData().getName(dataIndex);
        var nameToDisplay = name === "" ? this.name : name;
        var markerColor = (0, $d5ab84c08d6657ec$export$ea15628039c0fa93)(this, dataIndex);
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("section", {
            header: nameToDisplay,
            sortBlocks: true,
            blocks: $7a1bd9c2710fea0d$export$871de8747c9eaa88(indicatorAxes, function(axis) {
                var val = data.get(data.mapDimension(axis.dim), dataIndex);
                return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
                    markerType: "subItem",
                    markerColor: markerColor,
                    name: axis.name,
                    value: val,
                    sortParam: val
                });
            })
        });
    };
    RadarSeriesModel.prototype.getTooltipPosition = function(dataIndex) {
        if (dataIndex != null) {
            var data_1 = this.getData();
            var coordSys = this.coordinateSystem;
            var values = data_1.getValues($7a1bd9c2710fea0d$export$871de8747c9eaa88(coordSys.dimensions, function(dim) {
                return data_1.mapDimension(dim);
            }), dataIndex);
            for(var i = 0, len = values.length; i < len; i++)if (!isNaN(values[i])) {
                var indicatorAxes = coordSys.getIndicatorAxes();
                return coordSys.coordToPoint(indicatorAxes[i].dataToCoord(values[i]), i);
            }
        }
    };
    RadarSeriesModel.type = "series.radar";
    RadarSeriesModel.dependencies = [
        "radar"
    ];
    RadarSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        colorBy: "data",
        coordinateSystem: "radar",
        legendHoverLink: true,
        radarIndex: 0,
        lineStyle: {
            width: 2,
            type: "solid",
            join: "round"
        },
        label: {
            position: "top"
        },
        // areaStyle: {
        // },
        // itemStyle: {}
        symbolSize: 8
    };
    return RadarSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $3895e6b103877b59$export$2e2bcd8739ae039 = $3895e6b103877b59$var$RadarSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $19c8b0d3f7411edb$var$valueAxisDefault = (0, $ad861b9162f24222$export$2e2bcd8739ae039).value;
function $19c8b0d3f7411edb$var$defaultsShow(opt, show) {
    return $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
        show: show
    }, opt);
}
var $19c8b0d3f7411edb$var$RadarModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RadarModel, _super);
    function RadarModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadarModel.type;
        return _this;
    }
    RadarModel.prototype.optionUpdated = function() {
        var boundaryGap = this.get("boundaryGap");
        var splitNumber = this.get("splitNumber");
        var scale = this.get("scale");
        var axisLine = this.get("axisLine");
        var axisTick = this.get("axisTick");
        // let axisType = this.get('axisType');
        var axisLabel = this.get("axisLabel");
        var nameTextStyle = this.get("axisName");
        var showName = this.get([
            "axisName",
            "show"
        ]);
        var nameFormatter = this.get([
            "axisName",
            "formatter"
        ]);
        var nameGap = this.get("axisNameGap");
        var triggerEvent = this.get("triggerEvent");
        var indicatorModels = $7a1bd9c2710fea0d$export$871de8747c9eaa88(this.get("indicator") || [], function(indicatorOpt) {
            // PENDING
            if (indicatorOpt.max != null && indicatorOpt.max > 0 && !indicatorOpt.min) indicatorOpt.min = 0;
            else if (indicatorOpt.min != null && indicatorOpt.min < 0 && !indicatorOpt.max) indicatorOpt.max = 0;
            var iNameTextStyle = nameTextStyle;
            if (indicatorOpt.color != null) iNameTextStyle = $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                color: indicatorOpt.color
            }, nameTextStyle);
            // Use same configuration
            var innerIndicatorOpt = $7a1bd9c2710fea0d$export$4950aa0f605343fb($7a1bd9c2710fea0d$export$9cd59f9826255e47(indicatorOpt), {
                boundaryGap: boundaryGap,
                splitNumber: splitNumber,
                scale: scale,
                axisLine: axisLine,
                axisTick: axisTick,
                // axisType: axisType,
                axisLabel: axisLabel,
                // Compatible with 2 and use text
                name: indicatorOpt.text,
                showName: showName,
                nameLocation: "end",
                nameGap: nameGap,
                // min: 0,
                nameTextStyle: iNameTextStyle,
                triggerEvent: triggerEvent
            }, false);
            if ($7a1bd9c2710fea0d$export$844ec244b1367d54(nameFormatter)) {
                var indName = innerIndicatorOpt.name;
                innerIndicatorOpt.name = nameFormatter.replace("{value}", indName != null ? indName : "");
            } else if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(nameFormatter)) innerIndicatorOpt.name = nameFormatter(innerIndicatorOpt.name, innerIndicatorOpt);
            var model = new (0, $6818646a97528290$export$2e2bcd8739ae039)(innerIndicatorOpt, null, this.ecModel);
            $7a1bd9c2710fea0d$export$e36fc9d62a853069(model, (0, $3449fd4c0590d99e$export$5c54b224726edb5a).prototype);
            // For triggerEvent.
            model.mainType = "radar";
            model.componentIndex = this.componentIndex;
            return model;
        }, this);
        this._indicatorModels = indicatorModels;
    };
    RadarModel.prototype.getIndicatorModels = function() {
        return this._indicatorModels;
    };
    RadarModel.type = "radar";
    RadarModel.defaultOption = {
        // zlevel: 0,
        z: 0,
        center: [
            "50%",
            "50%"
        ],
        radius: "50%",
        startAngle: 90,
        axisName: {
            show: true,
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.axisLabel
        },
        boundaryGap: [
            0,
            0
        ],
        splitNumber: 5,
        axisNameGap: 15,
        scale: false,
        // Polygon or circle
        shape: "polygon",
        axisLine: $7a1bd9c2710fea0d$export$4950aa0f605343fb({
            lineStyle: {
                color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral20
            }
        }, $19c8b0d3f7411edb$var$valueAxisDefault.axisLine),
        axisLabel: $19c8b0d3f7411edb$var$defaultsShow($19c8b0d3f7411edb$var$valueAxisDefault.axisLabel, false),
        axisTick: $19c8b0d3f7411edb$var$defaultsShow($19c8b0d3f7411edb$var$valueAxisDefault.axisTick, false),
        // axisType: 'value',
        splitLine: $19c8b0d3f7411edb$var$defaultsShow($19c8b0d3f7411edb$var$valueAxisDefault.splitLine, true),
        splitArea: $19c8b0d3f7411edb$var$defaultsShow($19c8b0d3f7411edb$var$valueAxisDefault.splitArea, true),
        // {text, min, max}
        indicator: []
    };
    return RadarModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $19c8b0d3f7411edb$export$2e2bcd8739ae039 = $19c8b0d3f7411edb$var$RadarModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $9604af4c260571a1$var$RadarView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RadarView, _super);
    function RadarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadarView.type;
        return _this;
    }
    RadarView.prototype.render = function(radarModel, ecModel, api) {
        var group = this.group;
        group.removeAll();
        this._buildAxes(radarModel, api);
        this._buildSplitLineAndArea(radarModel);
    };
    RadarView.prototype._buildAxes = function(radarModel, api) {
        var radar = radarModel.coordinateSystem;
        var indicatorAxes = radar.getIndicatorAxes();
        var axisBuilders = $7a1bd9c2710fea0d$export$871de8747c9eaa88(indicatorAxes, function(indicatorAxis) {
            var axisName = indicatorAxis.model.get("showName") ? indicatorAxis.name : ""; // hide name
            var axisBuilder = new (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039)(indicatorAxis.model, api, {
                axisName: axisName,
                position: [
                    radar.cx,
                    radar.cy
                ],
                rotation: indicatorAxis.angle,
                labelDirection: -1,
                tickDirection: -1,
                nameDirection: 1
            });
            return axisBuilder;
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(axisBuilders, function(axisBuilder) {
            axisBuilder.build();
            this.group.add(axisBuilder.group);
        }, this);
    };
    RadarView.prototype._buildSplitLineAndArea = function(radarModel) {
        var radar = radarModel.coordinateSystem;
        var indicatorAxes = radar.getIndicatorAxes();
        if (!indicatorAxes.length) return;
        var shape = radarModel.get("shape");
        var splitLineModel = radarModel.getModel("splitLine");
        var splitAreaModel = radarModel.getModel("splitArea");
        var lineStyleModel = splitLineModel.getModel("lineStyle");
        var areaStyleModel = splitAreaModel.getModel("areaStyle");
        var showSplitLine = splitLineModel.get("show");
        var showSplitArea = splitAreaModel.get("show");
        var splitLineColors = lineStyleModel.get("color");
        var splitAreaColors = areaStyleModel.get("color");
        var splitLineColorsArr = $7a1bd9c2710fea0d$export$43bee75e5e14138e(splitLineColors) ? splitLineColors : [
            splitLineColors
        ];
        var splitAreaColorsArr = $7a1bd9c2710fea0d$export$43bee75e5e14138e(splitAreaColors) ? splitAreaColors : [
            splitAreaColors
        ];
        var splitLines = [];
        var splitAreas = [];
        function getColorIndex(areaOrLine, areaOrLineColorList, idx) {
            var colorIndex = idx % areaOrLineColorList.length;
            areaOrLine[colorIndex] = areaOrLine[colorIndex] || [];
            return colorIndex;
        }
        if (shape === "circle") {
            var ticksRadius = indicatorAxes[0].getTicksCoords();
            var cx = radar.cx;
            var cy = radar.cy;
            for(var i = 0; i < ticksRadius.length; i++){
                if (showSplitLine) {
                    var colorIndex = getColorIndex(splitLines, splitLineColorsArr, i);
                    splitLines[colorIndex].push(new $1e68d8727773abb7$export$2e2bcd8739ae039({
                        shape: {
                            cx: cx,
                            cy: cy,
                            r: ticksRadius[i].coord
                        }
                    }));
                }
                if (showSplitArea && i < ticksRadius.length - 1) {
                    var colorIndex = getColorIndex(splitAreas, splitAreaColorsArr, i);
                    splitAreas[colorIndex].push(new $9da0cbfd3f86fdc1$export$2e2bcd8739ae039({
                        shape: {
                            cx: cx,
                            cy: cy,
                            r0: ticksRadius[i].coord,
                            r: ticksRadius[i + 1].coord
                        }
                    }));
                }
            }
        } else {
            var realSplitNumber_1;
            var axesTicksPoints = $7a1bd9c2710fea0d$export$871de8747c9eaa88(indicatorAxes, function(indicatorAxis, idx) {
                var ticksCoords = indicatorAxis.getTicksCoords();
                realSplitNumber_1 = realSplitNumber_1 == null ? ticksCoords.length - 1 : Math.min(ticksCoords.length - 1, realSplitNumber_1);
                return $7a1bd9c2710fea0d$export$871de8747c9eaa88(ticksCoords, function(tickCoord) {
                    return radar.coordToPoint(tickCoord.coord, idx);
                });
            });
            var prevPoints = [];
            for(var i = 0; i <= realSplitNumber_1; i++){
                var points = [];
                for(var j = 0; j < indicatorAxes.length; j++)points.push(axesTicksPoints[j][i]);
                // Close
                if (points[0]) points.push(points[0].slice());
                if (showSplitLine) {
                    var colorIndex = getColorIndex(splitLines, splitLineColorsArr, i);
                    splitLines[colorIndex].push(new $d28119f30e6bb670$export$2e2bcd8739ae039({
                        shape: {
                            points: points
                        }
                    }));
                }
                if (showSplitArea && prevPoints) {
                    var colorIndex = getColorIndex(splitAreas, splitAreaColorsArr, i - 1);
                    splitAreas[colorIndex].push(new $51acf033123e1a30$export$2e2bcd8739ae039({
                        shape: {
                            points: points.concat(prevPoints)
                        }
                    }));
                }
                prevPoints = points.slice().reverse();
            }
        }
        var lineStyle = lineStyleModel.getLineStyle();
        var areaStyle = areaStyleModel.getAreaStyle();
        // Add splitArea before splitLine
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(splitAreas, function(splitAreas, idx) {
            this.group.add($5b455ae6f843ac47$export$7b1dd269fbc4e903(splitAreas, {
                style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                    stroke: "none",
                    fill: splitAreaColorsArr[idx % splitAreaColorsArr.length]
                }, areaStyle),
                silent: true
            }));
        }, this);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(splitLines, function(splitLines, idx) {
            this.group.add($5b455ae6f843ac47$export$7b1dd269fbc4e903(splitLines, {
                style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                    fill: "none",
                    stroke: splitLineColorsArr[idx % splitLineColorsArr.length]
                }, lineStyle),
                silent: true
            }));
        }, this);
    };
    RadarView.type = "radar";
    return RadarView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $9604af4c260571a1$export$2e2bcd8739ae039 = $9604af4c260571a1$var$RadarView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO clockwise
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $5d6acabddf826472$var$IndicatorAxis = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(IndicatorAxis, _super);
    function IndicatorAxis(dim, scale, radiusExtent) {
        var _this = _super.call(this, dim, scale, radiusExtent) || this;
        _this.type = "value";
        _this.angle = 0;
        _this.name = "";
        return _this;
    }
    return IndicatorAxis;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
var $5d6acabddf826472$export$2e2bcd8739ae039 = $5d6acabddf826472$var$IndicatorAxis;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




function $0591b52263f31374$export$c0b3be0e9eb0c2d9(scale, axisModel, alignToScale) {
    var _a;
    var intervalScaleProto = (0, $dddb89ade16db3d5$export$2e2bcd8739ae039).prototype;
    // NOTE: There is a precondition for log scale  here:
    // In log scale we store _interval and _extent of exponent value.
    // So if we use the method of InternalScale to set/get these data.
    // It process the exponent value, which is linear and what we want here.
    var alignToTicks = intervalScaleProto.getTicks.call(alignToScale);
    var alignToNicedTicks = intervalScaleProto.getTicks.call(alignToScale, {
        expandToNicedExtent: true
    });
    var alignToSplitNumber = alignToTicks.length - 1;
    var alignToInterval = intervalScaleProto.getInterval.call(alignToScale);
    var scaleExtent = (0, $2d646e51cc34f840$export$9c0ba8df7eb7b328)(scale, axisModel);
    var rawExtent = scaleExtent.extent;
    var isMinFixed = scaleExtent.fixMin;
    var isMaxFixed = scaleExtent.fixMax;
    if (scale.type === "log") rawExtent = (0, $60f7f1f3e3996637$export$a6588cdf5be114b3)(scale.base, rawExtent, true);
    scale.setBreaksFromOption((0, $2d646e51cc34f840$export$8094779d9b724f85)(axisModel));
    scale.setExtent(rawExtent[0], rawExtent[1]);
    scale.calcNiceExtent({
        splitNumber: alignToSplitNumber,
        fixMin: isMinFixed,
        fixMax: isMaxFixed
    });
    var extent = intervalScaleProto.getExtent.call(scale);
    // Need to update the rawExtent.
    // Because value in rawExtent may be not parsed. e.g. 'dataMin', 'dataMax'
    if (isMinFixed) rawExtent[0] = extent[0];
    if (isMaxFixed) rawExtent[1] = extent[1];
    var interval = intervalScaleProto.getInterval.call(scale);
    var min = rawExtent[0];
    var max = rawExtent[1];
    if (isMinFixed && isMaxFixed) // User set min, max, divide to get new interval
    interval = (max - min) / alignToSplitNumber;
    else if (isMinFixed) {
        max = rawExtent[0] + interval * alignToSplitNumber;
        // User set min, expand extent on the other side
        while(max < rawExtent[1] && isFinite(max) && isFinite(rawExtent[1])){
            interval = (0, $60f7f1f3e3996637$export$f39031e8422f329d)(interval);
            max = rawExtent[0] + interval * alignToSplitNumber;
        }
    } else if (isMaxFixed) {
        // User set max, expand extent on the other side
        min = rawExtent[1] - interval * alignToSplitNumber;
        while(min > rawExtent[0] && isFinite(min) && isFinite(rawExtent[0])){
            interval = (0, $60f7f1f3e3996637$export$f39031e8422f329d)(interval);
            min = rawExtent[1] - interval * alignToSplitNumber;
        }
    } else {
        var nicedSplitNumber = scale.getTicks().length - 1;
        if (nicedSplitNumber > alignToSplitNumber) interval = (0, $60f7f1f3e3996637$export$f39031e8422f329d)(interval);
        var range = interval * alignToSplitNumber;
        max = Math.ceil(rawExtent[1] / interval) * interval;
        min = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(max - range);
        // Not change the result that crossing zero.
        if (min < 0 && rawExtent[0] >= 0) {
            min = 0;
            max = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(range);
        } else if (max > 0 && rawExtent[1] <= 0) {
            max = 0;
            min = -(0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(range);
        }
    }
    // Adjust min, max based on the extent of alignTo. When min or max is set in alignTo scale
    var t0 = (alignToTicks[0].value - alignToNicedTicks[0].value) / alignToInterval;
    var t1 = (alignToTicks[alignToSplitNumber].value - alignToNicedTicks[alignToSplitNumber].value) / alignToInterval;
    // NOTE: Must in setExtent -> setInterval -> setNiceExtent order.
    intervalScaleProto.setExtent.call(scale, min + interval * t0, max + interval * t1);
    intervalScaleProto.setInterval.call(scale, interval);
    if (t0 || t1) intervalScaleProto.setNiceExtent.call(scale, min + interval, max - interval);
    var ticks;
}



var $11c0ac35da5ff3e8$var$Radar = /** @class */ function() {
    function Radar(radarModel, ecModel, api) {
        /**
     *
     * Radar dimensions
     */ this.dimensions = [];
        this._model = radarModel;
        this._indicatorAxes = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(radarModel.getIndicatorModels(), function(indicatorModel, idx) {
            var dim = "indicator_" + idx;
            var indicatorAxis = new (0, $5d6acabddf826472$export$2e2bcd8739ae039)(dim, new (0, $dddb89ade16db3d5$export$2e2bcd8739ae039)());
            indicatorAxis.name = indicatorModel.get("name");
            // Inject model and axis
            indicatorAxis.model = indicatorModel;
            indicatorModel.axis = indicatorAxis;
            this.dimensions.push(dim);
            return indicatorAxis;
        }, this);
        this.resize(radarModel, api);
    }
    Radar.prototype.getIndicatorAxes = function() {
        return this._indicatorAxes;
    };
    Radar.prototype.dataToPoint = function(value, indicatorIndex) {
        var indicatorAxis = this._indicatorAxes[indicatorIndex];
        return this.coordToPoint(indicatorAxis.dataToCoord(value), indicatorIndex);
    };
    // TODO: API should be coordToPoint([coord, indicatorIndex])
    Radar.prototype.coordToPoint = function(coord, indicatorIndex) {
        var indicatorAxis = this._indicatorAxes[indicatorIndex];
        var angle = indicatorAxis.angle;
        var x = this.cx + coord * Math.cos(angle);
        var y = this.cy - coord * Math.sin(angle);
        return [
            x,
            y
        ];
    };
    Radar.prototype.pointToData = function(pt) {
        var dx = pt[0] - this.cx;
        var dy = pt[1] - this.cy;
        var radius = Math.sqrt(dx * dx + dy * dy);
        dx /= radius;
        dy /= radius;
        var radian = Math.atan2(-dy, dx);
        // Find the closest angle
        // FIXME index can calculated directly
        var minRadianDiff = Infinity;
        var closestAxis;
        var closestAxisIdx = -1;
        for(var i = 0; i < this._indicatorAxes.length; i++){
            var indicatorAxis = this._indicatorAxes[i];
            var diff = Math.abs(radian - indicatorAxis.angle);
            if (diff < minRadianDiff) {
                closestAxis = indicatorAxis;
                closestAxisIdx = i;
                minRadianDiff = diff;
            }
        }
        return [
            closestAxisIdx,
            +(closestAxis && closestAxis.coordToData(radius))
        ];
    };
    Radar.prototype.resize = function(radarModel, api) {
        var refContainer = (0, $93b9bc7f22ac7369$export$5aec1e94f566e59f)(radarModel, api).refContainer;
        var center = radarModel.get("center");
        var viewSize = Math.min(refContainer.width, refContainer.height) / 2;
        this.cx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(center[0], refContainer.width) + refContainer.x;
        this.cy = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(center[1], refContainer.height) + refContainer.y;
        this.startAngle = radarModel.get("startAngle") * Math.PI / 180;
        // radius may be single value like `20`, `'80%'`, or array like `[10, '80%']`
        var radius = radarModel.get("radius");
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(radius) || (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(radius)) radius = [
            0,
            radius
        ];
        this.r0 = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(radius[0], viewSize);
        this.r = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(radius[1], viewSize);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._indicatorAxes, function(indicatorAxis, idx) {
            indicatorAxis.setExtent(this.r0, this.r);
            var angle = this.startAngle + idx * Math.PI * 2 / this._indicatorAxes.length;
            // Normalize to [-PI, PI]
            angle = Math.atan2(Math.sin(angle), Math.cos(angle));
            indicatorAxis.angle = angle;
        }, this);
    };
    Radar.prototype.update = function(ecModel, api) {
        var indicatorAxes = this._indicatorAxes;
        var radarModel = this._model;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(indicatorAxes, function(indicatorAxis) {
            indicatorAxis.scale.setExtent(Infinity, -Infinity);
        });
        ecModel.eachSeriesByType("radar", function(radarSeries, idx) {
            if (radarSeries.get("coordinateSystem") !== "radar" || ecModel.getComponent("radar", radarSeries.get("radarIndex")) !== radarModel) return;
            var data = radarSeries.getData();
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(indicatorAxes, function(indicatorAxis) {
                indicatorAxis.scale.unionExtentFromData(data, data.mapDimension(indicatorAxis.dim));
            });
        }, this);
        var splitNumber = radarModel.get("splitNumber");
        var dummyScale = new (0, $dddb89ade16db3d5$export$2e2bcd8739ae039)();
        dummyScale.setExtent(0, splitNumber);
        dummyScale.setInterval(1);
        // Force all the axis fixing the maxSplitNumber.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(indicatorAxes, function(indicatorAxis, idx) {
            (0, $0591b52263f31374$export$c0b3be0e9eb0c2d9)(indicatorAxis.scale, indicatorAxis.model, dummyScale);
        });
    };
    Radar.prototype.convertToPixel = function(ecModel, finder, value) {
        console.warn("Not implemented.");
        return null;
    };
    Radar.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        console.warn("Not implemented.");
        return null;
    };
    Radar.prototype.containPoint = function(point) {
        console.warn("Not implemented.");
        return false;
    };
    Radar.create = function(ecModel, api) {
        var radarList = [];
        ecModel.eachComponent("radar", function(radarModel) {
            var radar = new Radar(radarModel, ecModel, api);
            radarList.push(radar);
            radarModel.coordinateSystem = radar;
        });
        ecModel.eachSeriesByType("radar", function(radarSeries) {
            if (radarSeries.get("coordinateSystem") === "radar") // Inject coordinate system
            // @ts-ignore
            radarSeries.coordinateSystem = radarList[radarSeries.get("radarIndex") || 0];
        });
        return radarList;
    };
    /**
   * Radar dimensions is based on the data
   */ Radar.dimensions = [];
    return Radar;
}();
var $11c0ac35da5ff3e8$export$2e2bcd8739ae039 = $11c0ac35da5ff3e8$var$Radar;


function $82e3ee94e7369a99$export$4b3e715f166fdd78(registers) {
    registers.registerCoordinateSystem("radar", (0, $11c0ac35da5ff3e8$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $19c8b0d3f7411edb$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $9604af4c260571a1$export$2e2bcd8739ae039));
    registers.registerVisual({
        seriesType: "radar",
        reset: function(seriesModel) {
            var data = seriesModel.getData();
            // itemVisual symbol is for selected data
            data.each(function(idx) {
                data.setItemVisual(idx, "legendIcon", "roundRect");
            });
            // visual is for unselected data
            data.setVisual("legendIcon", "roundRect");
        }
    });
}


function $a8120efef8bcaaa0$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $82e3ee94e7369a99$export$4b3e715f166fdd78));
    registers.registerChartView((0, $1fc9e69f4602cced$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $3895e6b103877b59$export$2e2bcd8739ae039));
    registers.registerLayout((0, $bec68b02ebcf9063$export$2e2bcd8739ae039));
    registers.registerProcessor((0, $e11a533bf70b759c$export$2e2bcd8739ae039)("radar"));
    registers.registerPreprocessor((0, $506480c8f28f74be$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









var $58364a2c82b0ec77$var$SankeyPathShape = /** @class */ function() {
    function SankeyPathShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.cpx1 = 0;
        this.cpy1 = 0;
        this.cpx2 = 0;
        this.cpy2 = 0;
        this.extent = 0;
    }
    return SankeyPathShape;
}();
var $58364a2c82b0ec77$var$SankeyPath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SankeyPath, _super);
    function SankeyPath(opts) {
        return _super.call(this, opts) || this;
    }
    SankeyPath.prototype.getDefaultShape = function() {
        return new $58364a2c82b0ec77$var$SankeyPathShape();
    };
    SankeyPath.prototype.buildPath = function(ctx, shape) {
        var extent = shape.extent;
        ctx.moveTo(shape.x1, shape.y1);
        ctx.bezierCurveTo(shape.cpx1, shape.cpy1, shape.cpx2, shape.cpy2, shape.x2, shape.y2);
        if (shape.orient === "vertical") {
            ctx.lineTo(shape.x2 + extent, shape.y2);
            ctx.bezierCurveTo(shape.cpx2 + extent, shape.cpy2, shape.cpx1 + extent, shape.cpy1, shape.x1 + extent, shape.y1);
        } else {
            ctx.lineTo(shape.x2, shape.y2 + extent);
            ctx.bezierCurveTo(shape.cpx2, shape.cpy2 + extent, shape.cpx1, shape.cpy1 + extent, shape.x1, shape.y1 + extent);
        }
        ctx.closePath();
    };
    SankeyPath.prototype.highlight = function() {
        (0, $2bf82c0980125b62$export$b2d02638cc34c042)(this);
    };
    SankeyPath.prototype.downplay = function() {
        (0, $2bf82c0980125b62$export$11be6f716239ac55)(this);
    };
    return SankeyPath;
}($b02ffe7acd508c08$export$2e2bcd8739ae039);
var $58364a2c82b0ec77$var$SankeyView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SankeyView, _super);
    function SankeyView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SankeyView.type;
        _this._mainGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        _this._focusAdjacencyDisabled = false;
        return _this;
    }
    SankeyView.prototype.init = function(ecModel, api) {
        this._controller = new (0, $15927f329deeab51$export$2e2bcd8739ae039)(api.getZr());
        this._controllerHost = {
            target: this.group
        };
        this.group.add(this._mainGroup);
    };
    SankeyView.prototype.render = function(seriesModel, ecModel, api) {
        var sankeyView = this;
        var graph = seriesModel.getGraph();
        var mainGroup = this._mainGroup;
        var layoutInfo = seriesModel.layoutInfo;
        // view width
        var width = layoutInfo.width;
        // view height
        var height = layoutInfo.height;
        var nodeData = seriesModel.getData();
        var edgeData = seriesModel.getData("edge");
        var orient = seriesModel.get("orient");
        this._model = seriesModel;
        mainGroup.removeAll();
        mainGroup.x = layoutInfo.x;
        mainGroup.y = layoutInfo.y;
        this._updateViewCoordSys(seriesModel, api);
        $35fd859fd545c4be$export$805408382b623838(seriesModel, api, mainGroup, this._controller, this._controllerHost, null);
        // generate a bezire Curve for each edge
        graph.eachEdge(function(edge) {
            var curve = new $58364a2c82b0ec77$var$SankeyPath();
            var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(curve);
            ecData.dataIndex = edge.dataIndex;
            ecData.seriesIndex = seriesModel.seriesIndex;
            ecData.dataType = "edge";
            var edgeModel = edge.getModel();
            var lineStyleModel = edgeModel.getModel("lineStyle");
            var curvature = lineStyleModel.get("curveness");
            var n1Layout = edge.node1.getLayout();
            var node1Model = edge.node1.getModel();
            var dragX1 = node1Model.get("localX");
            var dragY1 = node1Model.get("localY");
            var n2Layout = edge.node2.getLayout();
            var node2Model = edge.node2.getModel();
            var dragX2 = node2Model.get("localX");
            var dragY2 = node2Model.get("localY");
            var edgeLayout = edge.getLayout();
            var x1;
            var y1;
            var x2;
            var y2;
            var cpx1;
            var cpy1;
            var cpx2;
            var cpy2;
            curve.shape.extent = Math.max(1, edgeLayout.dy);
            curve.shape.orient = orient;
            if (orient === "vertical") {
                x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + edgeLayout.sy;
                y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + n1Layout.dy;
                x2 = (dragX2 != null ? dragX2 * width : n2Layout.x) + edgeLayout.ty;
                y2 = dragY2 != null ? dragY2 * height : n2Layout.y;
                cpx1 = x1;
                cpy1 = y1 * (1 - curvature) + y2 * curvature;
                cpx2 = x2;
                cpy2 = y1 * curvature + y2 * (1 - curvature);
            } else {
                x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + n1Layout.dx;
                y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + edgeLayout.sy;
                x2 = dragX2 != null ? dragX2 * width : n2Layout.x;
                y2 = (dragY2 != null ? dragY2 * height : n2Layout.y) + edgeLayout.ty;
                cpx1 = x1 * (1 - curvature) + x2 * curvature;
                cpy1 = y1;
                cpx2 = x1 * curvature + x2 * (1 - curvature);
                cpy2 = y2;
            }
            curve.setShape({
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                cpx1: cpx1,
                cpy1: cpy1,
                cpx2: cpx2,
                cpy2: cpy2
            });
            curve.useStyle(lineStyleModel.getItemStyle());
            // Special color, use source node color or target node color
            $58364a2c82b0ec77$var$applyCurveStyle(curve.style, orient, edge);
            var defaultEdgeLabelText = "" + edgeModel.get("value");
            var edgeLabelStateModels = (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(edgeModel, "edgeLabel");
            (0, $6800dfcb6e1e2a44$export$9a13992917966657)(curve, edgeLabelStateModels, {
                labelFetcher: {
                    getFormattedLabel: function(dataIndex, stateName, dataType, labelDimIndex, formatter, extendParams) {
                        return seriesModel.getFormattedLabel(dataIndex, stateName, "edge", labelDimIndex, // ensure edgeLabel formatter is provided
                        // to prevent the inheritance from `label.formatter` of the series
                        (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(formatter, edgeLabelStateModels.normal && edgeLabelStateModels.normal.get("formatter"), defaultEdgeLabelText), extendParams);
                    }
                },
                labelDataIndex: edge.dataIndex,
                defaultText: defaultEdgeLabelText
            });
            curve.setTextConfig({
                position: "inside"
            });
            var emphasisModel = edgeModel.getModel("emphasis");
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(curve, edgeModel, "lineStyle", function(model) {
                var style = model.getItemStyle();
                $58364a2c82b0ec77$var$applyCurveStyle(style, orient, edge);
                return style;
            });
            mainGroup.add(curve);
            edgeData.setItemGraphicEl(edge.dataIndex, curve);
            var focus = emphasisModel.get("focus");
            (0, $2bf82c0980125b62$export$e51187539ff11209)(curve, focus === "adjacency" ? edge.getAdjacentDataIndices() : focus === "trajectory" ? edge.getTrajectoryDataIndices() : focus, emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
        });
        // Generate a rect for each node
        graph.eachNode(function(node) {
            var layout = node.getLayout();
            var itemModel = node.getModel();
            var dragX = itemModel.get("localX");
            var dragY = itemModel.get("localY");
            var emphasisModel = itemModel.getModel("emphasis");
            var borderRadius = itemModel.get([
                "itemStyle",
                "borderRadius"
            ]) || 0;
            var rect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
                shape: {
                    x: dragX != null ? dragX * width : layout.x,
                    y: dragY != null ? dragY * height : layout.y,
                    width: layout.dx,
                    height: layout.dy,
                    r: borderRadius
                },
                style: itemModel.getModel("itemStyle").getItemStyle(),
                z2: 10
            });
            (0, $6800dfcb6e1e2a44$export$9a13992917966657)(rect, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
                labelFetcher: {
                    getFormattedLabel: function(dataIndex, stateName) {
                        return seriesModel.getFormattedLabel(dataIndex, stateName, "node");
                    }
                },
                labelDataIndex: node.dataIndex,
                defaultText: node.id
            });
            rect.disableLabelAnimation = true;
            rect.setStyle("fill", node.getVisual("color"));
            rect.setStyle("decal", node.getVisual("style").decal);
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(rect, itemModel);
            mainGroup.add(rect);
            nodeData.setItemGraphicEl(node.dataIndex, rect);
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(rect).dataType = "node";
            var focus = emphasisModel.get("focus");
            (0, $2bf82c0980125b62$export$e51187539ff11209)(rect, focus === "adjacency" ? node.getAdjacentDataIndices() : focus === "trajectory" ? node.getTrajectoryDataIndices() : focus, emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
        });
        nodeData.eachItemGraphicEl(function(el, dataIndex) {
            var itemModel = nodeData.getItemModel(dataIndex);
            if (itemModel.get("draggable")) {
                el.drift = function(dx, dy) {
                    sankeyView._focusAdjacencyDisabled = true;
                    this.shape.x += dx;
                    this.shape.y += dy;
                    this.dirty();
                    api.dispatchAction({
                        type: "dragNode",
                        seriesId: seriesModel.id,
                        dataIndex: nodeData.getRawIndex(dataIndex),
                        localX: this.shape.x / width,
                        localY: this.shape.y / height
                    });
                };
                el.ondragend = function() {
                    sankeyView._focusAdjacencyDisabled = false;
                };
                el.draggable = true;
                el.cursor = "move";
            }
        });
        if (!this._data && seriesModel.isAnimationEnabled()) mainGroup.setClipPath($58364a2c82b0ec77$var$createGridClipShape(mainGroup.getBoundingRect(), seriesModel, function() {
            mainGroup.removeClipPath();
        }));
        this._data = seriesModel.getData();
    };
    SankeyView.prototype.dispose = function() {
        this._controller && this._controller.dispose();
        this._controllerHost = null;
    };
    SankeyView.prototype._updateViewCoordSys = function(seriesModel, api) {
        var layoutInfo = seriesModel.layoutInfo;
        var width = layoutInfo.width;
        var height = layoutInfo.height;
        var viewCoordSys = seriesModel.coordinateSystem = new (0, $4a92e7570d47c1fe$export$2e2bcd8739ae039)(null, {
            api: api,
            ecModel: seriesModel.ecModel
        });
        viewCoordSys.zoomLimit = seriesModel.get("scaleLimit");
        viewCoordSys.setBoundingRect(0, 0, width, height);
        viewCoordSys.setCenter(seriesModel.get("center"));
        viewCoordSys.setZoom(seriesModel.get("zoom"));
        this._controllerHost.target.attr({
            x: viewCoordSys.x,
            y: viewCoordSys.y,
            scaleX: viewCoordSys.scaleX,
            scaleY: viewCoordSys.scaleY
        });
    };
    SankeyView.type = "sankey";
    return SankeyView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
/**
 * Special color, use source node color or target node color
 * @param curveProps curve's style to parse
 * @param orient direction
 * @param edge current curve data
 */ function $58364a2c82b0ec77$var$applyCurveStyle(curveProps, orient, edge) {
    switch(curveProps.fill){
        case "source":
            curveProps.fill = edge.node1.getVisual("color");
            curveProps.decal = edge.node1.getVisual("style").decal;
            break;
        case "target":
            curveProps.fill = edge.node2.getVisual("color");
            curveProps.decal = edge.node2.getVisual("style").decal;
            break;
        case "gradient":
            var sourceColor = edge.node1.getVisual("color");
            var targetColor = edge.node2.getVisual("color");
            if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(sourceColor) && (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(targetColor)) curveProps.fill = new $cf44c01491b58e53$export$2e2bcd8739ae039(0, 0, +(orient === "horizontal"), +(orient === "vertical"), [
                {
                    color: sourceColor,
                    offset: 0
                },
                {
                    color: targetColor,
                    offset: 1
                }
            ]);
    }
}
// Add animation to the view
function $58364a2c82b0ec77$var$createGridClipShape(rect, seriesModel, cb) {
    var rectEl = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        shape: {
            x: rect.x - 10,
            y: rect.y - 10,
            width: 0,
            height: rect.height + 20
        }
    });
    $8b353638fbedfefa$export$a121566aadcfe021(rectEl, {
        shape: {
            width: rect.width + 20
        }
    }, seriesModel, cb);
    return rectEl;
}
var $58364a2c82b0ec77$export$2e2bcd8739ae039 = $58364a2c82b0ec77$var$SankeyView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $f213d63e219306d2$var$SankeySeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SankeySeriesModel, _super);
    function SankeySeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SankeySeriesModel.type;
        return _this;
    }
    /**
   * Init a graph data structure from data in option series
   */ SankeySeriesModel.prototype.getInitialData = function(option, ecModel) {
        var links = option.edges || option.links || [];
        var nodes = option.data || option.nodes || [];
        var levels = option.levels || [];
        this.levelModels = [];
        var levelModels = this.levelModels;
        for(var i = 0; i < levels.length; i++)if (levels[i].depth != null && levels[i].depth >= 0) levelModels[levels[i].depth] = new (0, $6818646a97528290$export$2e2bcd8739ae039)(levels[i], this, ecModel);
        var graph = (0, $09eb5d193a1ecbce$export$2e2bcd8739ae039)(nodes, links, this, true, beforeLink);
        return graph.data;
        function beforeLink(nodeData, edgeData) {
            nodeData.wrapMethod("getItemModel", function(model, idx) {
                var seriesModel = model.parentModel;
                var layout = seriesModel.getData().getItemLayout(idx);
                if (layout) {
                    var nodeDepth = layout.depth;
                    var levelModel = seriesModel.levelModels[nodeDepth];
                    if (levelModel) model.parentModel = levelModel;
                }
                return model;
            });
            edgeData.wrapMethod("getItemModel", function(model, idx) {
                var seriesModel = model.parentModel;
                var edge = seriesModel.getGraph().getEdgeByIndex(idx);
                var layout = edge.node1.getLayout();
                if (layout) {
                    var depth = layout.depth;
                    var levelModel = seriesModel.levelModels[depth];
                    if (levelModel) model.parentModel = levelModel;
                }
                return model;
            });
        }
    };
    SankeySeriesModel.prototype.setNodePosition = function(dataIndex, localPosition) {
        var nodes = this.option.data || this.option.nodes;
        var dataItem = nodes[dataIndex];
        dataItem.localX = localPosition[0];
        dataItem.localY = localPosition[1];
    };
    SankeySeriesModel.prototype.setCenter = function(center) {
        this.option.center = center;
    };
    SankeySeriesModel.prototype.setZoom = function(zoom) {
        this.option.zoom = zoom;
    };
    /**
   * Return the graphic data structure
   *
   * @return graphic data structure
   */ SankeySeriesModel.prototype.getGraph = function() {
        return this.getData().graph;
    };
    /**
   * Get edge data of graphic data structure
   *
   * @return data structure of list
   */ SankeySeriesModel.prototype.getEdgeData = function() {
        return this.getGraph().edgeData;
    };
    SankeySeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        function noValue(val) {
            return isNaN(val) || val == null;
        }
        // dataType === 'node' or empty do not show tooltip by default
        if (dataType === "edge") {
            var params = this.getDataParams(dataIndex, dataType);
            var rawDataOpt = params.data;
            var edgeValue = params.value;
            var edgeName = rawDataOpt.source + " -- " + rawDataOpt.target;
            return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
                name: edgeName,
                value: edgeValue,
                noValue: noValue(edgeValue)
            });
        } else {
            var node = this.getGraph().getNodeByIndex(dataIndex);
            var value = node.getLayout().value;
            var name_1 = this.getDataParams(dataIndex, dataType).data.name;
            return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
                name: name_1 != null ? name_1 + "" : null,
                value: value,
                noValue: noValue(value)
            });
        }
    };
    SankeySeriesModel.prototype.optionUpdated = function() {};
    // Override Series.getDataParams()
    SankeySeriesModel.prototype.getDataParams = function(dataIndex, dataType) {
        var params = _super.prototype.getDataParams.call(this, dataIndex, dataType);
        if (params.value == null && dataType === "node") {
            var node = this.getGraph().getNodeByIndex(dataIndex);
            var nodeValue = node.getLayout().value;
            params.value = nodeValue;
        }
        return params;
    };
    SankeySeriesModel.type = "series.sankey";
    SankeySeriesModel.layoutMode = "box";
    SankeySeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        // `coordinateSystem` can be declared as 'matrix', 'calendar',
        //  which provides box layout container.
        coordinateSystemUsage: "box",
        left: "5%",
        top: "5%",
        right: "20%",
        bottom: "5%",
        orient: "horizontal",
        nodeWidth: 20,
        nodeGap: 8,
        draggable: true,
        layoutIterations: 32,
        // true | false | 'move' | 'scale', see module:component/helper/RoamController.
        roam: false,
        roamTrigger: "global",
        center: null,
        zoom: 1,
        label: {
            show: true,
            position: "right",
            fontSize: 12
        },
        edgeLabel: {
            show: false,
            fontSize: 12
        },
        levels: [],
        nodeAlign: "justify",
        lineStyle: {
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral50,
            opacity: 0.2,
            curveness: 0.5
        },
        emphasis: {
            label: {
                show: true
            },
            lineStyle: {
                opacity: 0.5
            }
        },
        select: {
            itemStyle: {
                borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.primary
            }
        },
        animationEasing: "linear",
        animationDuration: 1000
    };
    return SankeySeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $f213d63e219306d2$export$2e2bcd8739ae039 = $f213d63e219306d2$var$SankeySeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $b2e36df99c285454$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType("sankey", function(seriesModel) {
        var nodeWidth = seriesModel.get("nodeWidth");
        var nodeGap = seriesModel.get("nodeGap");
        var refContainer = (0, $93b9bc7f22ac7369$export$5aec1e94f566e59f)(seriesModel, api).refContainer;
        var layoutInfo = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(seriesModel.getBoxLayoutParams(), refContainer);
        seriesModel.layoutInfo = layoutInfo;
        var width = layoutInfo.width;
        var height = layoutInfo.height;
        var graph = seriesModel.getGraph();
        var nodes = graph.nodes;
        var edges = graph.edges;
        $b2e36df99c285454$var$computeNodeValues(nodes);
        var filteredNodes = $7a1bd9c2710fea0d$export$3dea766d36a8935f(nodes, function(node) {
            return node.getLayout().value === 0;
        });
        var iterations = filteredNodes.length !== 0 ? 0 : seriesModel.get("layoutIterations");
        var orient = seriesModel.get("orient");
        var nodeAlign = seriesModel.get("nodeAlign");
        $b2e36df99c285454$var$layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign);
    });
}
function $b2e36df99c285454$var$layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign) {
    $b2e36df99c285454$var$computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign);
    $b2e36df99c285454$var$computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient);
    $b2e36df99c285454$var$computeEdgeDepths(nodes, orient);
}
/**
 * Compute the value of each node by summing the associated edge's value
 */ function $b2e36df99c285454$var$computeNodeValues(nodes) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
        var value1 = $b2e36df99c285454$var$sum(node.outEdges, $b2e36df99c285454$var$getEdgeValue);
        var value2 = $b2e36df99c285454$var$sum(node.inEdges, $b2e36df99c285454$var$getEdgeValue);
        var nodeRawValue = node.getValue() || 0;
        var value = Math.max(value1, value2, nodeRawValue);
        node.setLayout({
            value: value
        }, true);
    });
}
/**
 * Compute the x-position for each node.
 *
 * Here we use Kahn algorithm to detect cycle when we traverse
 * the node to computer the initial x position.
 */ function $b2e36df99c285454$var$computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign) {
    // Used to mark whether the edge is deleted. if it is deleted,
    // the value is 0, otherwise it is 1.
    var remainEdges = [];
    // Storage each node's indegree.
    var indegreeArr = [];
    // Used to storage the node with indegree is equal to 0.
    var zeroIndegrees = [];
    var nextTargetNode = [];
    var x = 0;
    // let kx = 0;
    for(var i = 0; i < edges.length; i++)remainEdges[i] = 1;
    for(var i = 0; i < nodes.length; i++){
        indegreeArr[i] = nodes[i].inEdges.length;
        if (indegreeArr[i] === 0) zeroIndegrees.push(nodes[i]);
    }
    var maxNodeDepth = -1;
    // Traversing nodes using topological sorting to calculate the
    // horizontal(if orient === 'horizontal') or vertical(if orient === 'vertical')
    // position of the nodes.
    while(zeroIndegrees.length){
        for(var idx = 0; idx < zeroIndegrees.length; idx++){
            var node = zeroIndegrees[idx];
            var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
            var isItemDepth = item.depth != null && item.depth >= 0;
            if (isItemDepth && item.depth > maxNodeDepth) maxNodeDepth = item.depth;
            node.setLayout({
                depth: isItemDepth ? item.depth : x
            }, true);
            orient === "vertical" ? node.setLayout({
                dy: nodeWidth
            }, true) : node.setLayout({
                dx: nodeWidth
            }, true);
            for(var edgeIdx = 0; edgeIdx < node.outEdges.length; edgeIdx++){
                var edge = node.outEdges[edgeIdx];
                var indexEdge = edges.indexOf(edge);
                remainEdges[indexEdge] = 0;
                var targetNode = edge.node2;
                var nodeIndex = nodes.indexOf(targetNode);
                if (--indegreeArr[nodeIndex] === 0 && nextTargetNode.indexOf(targetNode) < 0) nextTargetNode.push(targetNode);
            }
        }
        ++x;
        zeroIndegrees = nextTargetNode;
        nextTargetNode = [];
    }
    for(var i = 0; i < remainEdges.length; i++){
        if (remainEdges[i] === 1) throw new Error("Sankey is a DAG, the original data has cycle!");
    }
    var maxDepth = maxNodeDepth > x - 1 ? maxNodeDepth : x - 1;
    if (nodeAlign && nodeAlign !== "left") $b2e36df99c285454$var$adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth);
    var kx = orient === "vertical" ? (height - nodeWidth) / maxDepth : (width - nodeWidth) / maxDepth;
    $b2e36df99c285454$var$scaleNodeBreadths(nodes, kx, orient);
}
function $b2e36df99c285454$var$isNodeDepth(node) {
    var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
    return item.depth != null && item.depth >= 0;
}
function $b2e36df99c285454$var$adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth) {
    if (nodeAlign === "right") {
        var nextSourceNode = [];
        var remainNodes = nodes;
        var nodeHeight = 0;
        while(remainNodes.length){
            for(var i = 0; i < remainNodes.length; i++){
                var node = remainNodes[i];
                node.setLayout({
                    skNodeHeight: nodeHeight
                }, true);
                for(var j = 0; j < node.inEdges.length; j++){
                    var edge = node.inEdges[j];
                    if (nextSourceNode.indexOf(edge.node1) < 0) nextSourceNode.push(edge.node1);
                }
            }
            remainNodes = nextSourceNode;
            nextSourceNode = [];
            ++nodeHeight;
        }
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
            if (!$b2e36df99c285454$var$isNodeDepth(node)) node.setLayout({
                depth: Math.max(0, maxDepth - node.getLayout().skNodeHeight)
            }, true);
        });
    } else if (nodeAlign === "justify") $b2e36df99c285454$var$moveSinksRight(nodes, maxDepth);
}
/**
 * All the node without outEgdes are assigned maximum x-position and
 *     be aligned in the last column.
 *
 * @param nodes.  node of sankey view.
 * @param maxDepth.  use to assign to node without outEdges as x-position.
 */ function $b2e36df99c285454$var$moveSinksRight(nodes, maxDepth) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
        if (!$b2e36df99c285454$var$isNodeDepth(node) && !node.outEdges.length) node.setLayout({
            depth: maxDepth
        }, true);
    });
}
/**
 * Scale node x-position to the width
 *
 * @param nodes  node of sankey view
 * @param kx   multiple used to scale nodes
 */ function $b2e36df99c285454$var$scaleNodeBreadths(nodes, kx, orient) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
        var nodeDepth = node.getLayout().depth * kx;
        orient === "vertical" ? node.setLayout({
            y: nodeDepth
        }, true) : node.setLayout({
            x: nodeDepth
        }, true);
    });
}
/**
 * Using Gauss-Seidel iterations method to compute the node depth(y-position)
 *
 * @param nodes  node of sankey view
 * @param edges  edge of sankey view
 * @param height  the whole height of the area to draw the view
 * @param nodeGap  the vertical distance between two nodes
 *     in the same column.
 * @param iterations  the number of iterations for the algorithm
 */ function $b2e36df99c285454$var$computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient) {
    var nodesByBreadth = $b2e36df99c285454$var$prepareNodesByBreadth(nodes, orient);
    $b2e36df99c285454$var$initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient);
    $b2e36df99c285454$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
    for(var alpha = 1; iterations > 0; iterations--){
        // 0.99 is a experience parameter, ensure that each iterations of
        // changes as small as possible.
        alpha *= 0.99;
        $b2e36df99c285454$var$relaxRightToLeft(nodesByBreadth, alpha, orient);
        $b2e36df99c285454$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
        $b2e36df99c285454$var$relaxLeftToRight(nodesByBreadth, alpha, orient);
        $b2e36df99c285454$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
    }
}
function $b2e36df99c285454$var$prepareNodesByBreadth(nodes, orient) {
    var nodesByBreadth = [];
    var keyAttr = orient === "vertical" ? "y" : "x";
    var groupResult = (0, $76d619f648247e6d$export$7ab5bda43e13168f)(nodes, function(node) {
        return node.getLayout()[keyAttr];
    });
    groupResult.keys.sort(function(a, b) {
        return a - b;
    });
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(groupResult.keys, function(key) {
        nodesByBreadth.push(groupResult.buckets.get(key));
    });
    return nodesByBreadth;
}
/**
 * Compute the original y-position for each node
 */ function $b2e36df99c285454$var$initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient) {
    var minKy = Infinity;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodesByBreadth, function(nodes) {
        var n = nodes.length;
        var sum = 0;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
            sum += node.getLayout().value;
        });
        var ky = orient === "vertical" ? (width - (n - 1) * nodeGap) / sum : (height - (n - 1) * nodeGap) / sum;
        if (ky < minKy) minKy = ky;
    });
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodesByBreadth, function(nodes) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node, i) {
            var nodeDy = node.getLayout().value * minKy;
            if (orient === "vertical") {
                node.setLayout({
                    x: i
                }, true);
                node.setLayout({
                    dx: nodeDy
                }, true);
            } else {
                node.setLayout({
                    y: i
                }, true);
                node.setLayout({
                    dy: nodeDy
                }, true);
            }
        });
    });
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(edges, function(edge) {
        var edgeDy = +edge.getValue() * minKy;
        edge.setLayout({
            dy: edgeDy
        }, true);
    });
}
/**
 * Resolve the collision of initialized depth (y-position)
 */ function $b2e36df99c285454$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient) {
    var keyAttr = orient === "vertical" ? "x" : "y";
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodesByBreadth, function(nodes) {
        nodes.sort(function(a, b) {
            return a.getLayout()[keyAttr] - b.getLayout()[keyAttr];
        });
        var nodeX;
        var node;
        var dy;
        var y0 = 0;
        var n = nodes.length;
        var nodeDyAttr = orient === "vertical" ? "dx" : "dy";
        for(var i = 0; i < n; i++){
            node = nodes[i];
            dy = y0 - node.getLayout()[keyAttr];
            if (dy > 0) {
                nodeX = node.getLayout()[keyAttr] + dy;
                orient === "vertical" ? node.setLayout({
                    x: nodeX
                }, true) : node.setLayout({
                    y: nodeX
                }, true);
            }
            y0 = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap;
        }
        var viewWidth = orient === "vertical" ? width : height;
        // If the bottommost node goes outside the bounds, push it back up
        dy = y0 - nodeGap - viewWidth;
        if (dy > 0) {
            nodeX = node.getLayout()[keyAttr] - dy;
            orient === "vertical" ? node.setLayout({
                x: nodeX
            }, true) : node.setLayout({
                y: nodeX
            }, true);
            y0 = nodeX;
            for(var i = n - 2; i >= 0; --i){
                node = nodes[i];
                dy = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap - y0;
                if (dy > 0) {
                    nodeX = node.getLayout()[keyAttr] - dy;
                    orient === "vertical" ? node.setLayout({
                        x: nodeX
                    }, true) : node.setLayout({
                        y: nodeX
                    }, true);
                }
                y0 = node.getLayout()[keyAttr];
            }
        }
    });
}
/**
 * Change the y-position of the nodes, except most the right side nodes
 * @param nodesByBreadth
 * @param alpha  parameter used to adjust the nodes y-position
 */ function $b2e36df99c285454$var$relaxRightToLeft(nodesByBreadth, alpha, orient) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodesByBreadth.slice().reverse(), function(nodes) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
            if (node.outEdges.length) {
                var y = $b2e36df99c285454$var$sum(node.outEdges, $b2e36df99c285454$var$weightedTarget, orient) / $b2e36df99c285454$var$sum(node.outEdges, $b2e36df99c285454$var$getEdgeValue);
                if (isNaN(y)) {
                    var len = node.outEdges.length;
                    y = len ? $b2e36df99c285454$var$sum(node.outEdges, $b2e36df99c285454$var$centerTarget, orient) / len : 0;
                }
                if (orient === "vertical") {
                    var nodeX = node.getLayout().x + (y - $b2e36df99c285454$var$center(node, orient)) * alpha;
                    node.setLayout({
                        x: nodeX
                    }, true);
                } else {
                    var nodeY = node.getLayout().y + (y - $b2e36df99c285454$var$center(node, orient)) * alpha;
                    node.setLayout({
                        y: nodeY
                    }, true);
                }
            }
        });
    });
}
function $b2e36df99c285454$var$weightedTarget(edge, orient) {
    return $b2e36df99c285454$var$center(edge.node2, orient) * edge.getValue();
}
function $b2e36df99c285454$var$centerTarget(edge, orient) {
    return $b2e36df99c285454$var$center(edge.node2, orient);
}
function $b2e36df99c285454$var$weightedSource(edge, orient) {
    return $b2e36df99c285454$var$center(edge.node1, orient) * edge.getValue();
}
function $b2e36df99c285454$var$centerSource(edge, orient) {
    return $b2e36df99c285454$var$center(edge.node1, orient);
}
function $b2e36df99c285454$var$center(node, orient) {
    return orient === "vertical" ? node.getLayout().x + node.getLayout().dx / 2 : node.getLayout().y + node.getLayout().dy / 2;
}
function $b2e36df99c285454$var$getEdgeValue(edge) {
    return edge.getValue();
}
function $b2e36df99c285454$var$sum(array, cb, orient) {
    var sum = 0;
    var len = array.length;
    var i = -1;
    while(++i < len){
        var value = +cb(array[i], orient);
        if (!isNaN(value)) sum += value;
    }
    return sum;
}
/**
 * Change the y-position of the nodes, except most the left side nodes
 */ function $b2e36df99c285454$var$relaxLeftToRight(nodesByBreadth, alpha, orient) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodesByBreadth, function(nodes) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
            if (node.inEdges.length) {
                var y = $b2e36df99c285454$var$sum(node.inEdges, $b2e36df99c285454$var$weightedSource, orient) / $b2e36df99c285454$var$sum(node.inEdges, $b2e36df99c285454$var$getEdgeValue);
                if (isNaN(y)) {
                    var len = node.inEdges.length;
                    y = len ? $b2e36df99c285454$var$sum(node.inEdges, $b2e36df99c285454$var$centerSource, orient) / len : 0;
                }
                if (orient === "vertical") {
                    var nodeX = node.getLayout().x + (y - $b2e36df99c285454$var$center(node, orient)) * alpha;
                    node.setLayout({
                        x: nodeX
                    }, true);
                } else {
                    var nodeY = node.getLayout().y + (y - $b2e36df99c285454$var$center(node, orient)) * alpha;
                    node.setLayout({
                        y: nodeY
                    }, true);
                }
            }
        });
    });
}
/**
 * Compute the depth(y-position) of each edge
 */ function $b2e36df99c285454$var$computeEdgeDepths(nodes, orient) {
    var keyAttr = orient === "vertical" ? "x" : "y";
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
        node.outEdges.sort(function(a, b) {
            return a.node2.getLayout()[keyAttr] - b.node2.getLayout()[keyAttr];
        });
        node.inEdges.sort(function(a, b) {
            return a.node1.getLayout()[keyAttr] - b.node1.getLayout()[keyAttr];
        });
    });
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
        var sy = 0;
        var ty = 0;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(node.outEdges, function(edge) {
            edge.setLayout({
                sy: sy
            }, true);
            sy += edge.getLayout().dy;
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(node.inEdges, function(edge) {
            edge.setLayout({
                ty: ty
            }, true);
            ty += edge.getLayout().dy;
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $7b50f502cfd189d5$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $7b50f502cfd189d5$var$isObject = $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a;
var $7b50f502cfd189d5$var$CATEGORY_DEFAULT_VISUAL_INDEX = -1;
var $7b50f502cfd189d5$var$VisualMapping = /** @class */ function() {
    function VisualMapping(option) {
        var mappingMethod = option.mappingMethod;
        var visualType = option.type;
        var thisOption = this.option = $7a1bd9c2710fea0d$export$9cd59f9826255e47(option);
        this.type = visualType;
        this.mappingMethod = mappingMethod;
        this._normalizeData = $7b50f502cfd189d5$var$normalizers[mappingMethod];
        var visualHandler = VisualMapping.visualHandlers[visualType];
        this.applyVisual = visualHandler.applyVisual;
        this.getColorMapper = visualHandler.getColorMapper;
        this._normalizedToVisual = visualHandler._normalizedToVisual[mappingMethod];
        if (mappingMethod === "piecewise") {
            $7b50f502cfd189d5$var$normalizeVisualRange(thisOption);
            $7b50f502cfd189d5$var$preprocessForPiecewise(thisOption);
        } else if (mappingMethod === "category") thisOption.categories ? $7b50f502cfd189d5$var$preprocessForSpecifiedCategory(thisOption) : $7b50f502cfd189d5$var$normalizeVisualRange(thisOption, true);
        else {
            // mappingMethod === 'linear' or 'fixed'
            $7a1bd9c2710fea0d$export$a7a9523472993e97(mappingMethod !== "linear" || thisOption.dataExtent);
            $7b50f502cfd189d5$var$normalizeVisualRange(thisOption);
        }
    }
    VisualMapping.prototype.mapValueToVisual = function(value) {
        var normalized = this._normalizeData(value);
        return this._normalizedToVisual(normalized, value);
    };
    VisualMapping.prototype.getNormalizer = function() {
        return $7a1bd9c2710fea0d$export$2385a24977818dd0(this._normalizeData, this);
    };
    /**
   * List available visual types.
   *
   * @public
   * @return {Array.<string>}
   */ VisualMapping.listVisualTypes = function() {
        return $7a1bd9c2710fea0d$export$ed97f33186d4b816(VisualMapping.visualHandlers);
    };
    // /**
    //  * @public
    //  */
    // static addVisualHandler(name, handler) {
    //     visualHandlers[name] = handler;
    // }
    /**
   * @public
   */ VisualMapping.isValidType = function(visualType) {
        return VisualMapping.visualHandlers.hasOwnProperty(visualType);
    };
    /**
   * Convenient method.
   * Visual can be Object or Array or primary type.
   */ VisualMapping.eachVisual = function(visual, callback, context) {
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(visual)) $7a1bd9c2710fea0d$export$79b2f7037acddd43(visual, callback, context);
        else callback.call(context, visual);
    };
    VisualMapping.mapVisual = function(visual, callback, context) {
        var isPrimary;
        var newVisual = $7a1bd9c2710fea0d$export$43bee75e5e14138e(visual) ? [] : $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(visual) ? {} : (isPrimary = true, null);
        VisualMapping.eachVisual(visual, function(v, key) {
            var newVal = callback.call(context, v, key);
            isPrimary ? newVisual = newVal : newVisual[key] = newVal;
        });
        return newVisual;
    };
    /**
   * Retrieve visual properties from given object.
   */ VisualMapping.retrieveVisuals = function(obj) {
        var ret = {};
        var hasVisual;
        obj && $7b50f502cfd189d5$var$each(VisualMapping.visualHandlers, function(h, visualType) {
            if (obj.hasOwnProperty(visualType)) {
                ret[visualType] = obj[visualType];
                hasVisual = true;
            }
        });
        return hasVisual ? ret : null;
    };
    /**
   * Give order to visual types, considering colorSaturation, colorAlpha depends on color.
   *
   * @public
   * @param {(Object|Array)} visualTypes If Object, like: {color: ..., colorSaturation: ...}
   *                                     IF Array, like: ['color', 'symbol', 'colorSaturation']
   * @return {Array.<string>} Sorted visual types.
   */ VisualMapping.prepareVisualTypes = function(visualTypes) {
        if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(visualTypes)) visualTypes = visualTypes.slice();
        else if ($7b50f502cfd189d5$var$isObject(visualTypes)) {
            var types_1 = [];
            $7b50f502cfd189d5$var$each(visualTypes, function(item, type) {
                types_1.push(type);
            });
            visualTypes = types_1;
        } else return [];
        visualTypes.sort(function(type1, type2) {
            // color should be front of colorSaturation, colorAlpha, ...
            // symbol and symbolSize do not matter.
            return type2 === "color" && type1 !== "color" && type1.indexOf("color") === 0 ? 1 : -1;
        });
        return visualTypes;
    };
    /**
   * 'color', 'colorSaturation', 'colorAlpha', ... are depends on 'color'.
   * Other visuals are only depends on themself.
   */ VisualMapping.dependsOn = function(visualType1, visualType2) {
        return visualType2 === "color" ? !!(visualType1 && visualType1.indexOf(visualType2) === 0) : visualType1 === visualType2;
    };
    /**
   * @param value
   * @param pieceList [{value: ..., interval: [min, max]}, ...]
   *                         Always from small to big.
   * @param findClosestWhenOutside Default to be false
   * @return index
   */ VisualMapping.findPieceIndex = function(value, pieceList, findClosestWhenOutside) {
        var possibleI;
        var abs = Infinity;
        // value has the higher priority.
        for(var i = 0, len = pieceList.length; i < len; i++){
            var pieceValue = pieceList[i].value;
            if (pieceValue != null) {
                if (pieceValue === value || $7a1bd9c2710fea0d$export$844ec244b1367d54(pieceValue) && pieceValue === value + "") return i;
                findClosestWhenOutside && updatePossible(pieceValue, i);
            }
        }
        for(var i = 0, len = pieceList.length; i < len; i++){
            var piece = pieceList[i];
            var interval = piece.interval;
            var close_1 = piece.close;
            if (interval) {
                if (interval[0] === -Infinity) {
                    if ($7b50f502cfd189d5$var$littleThan(close_1[1], value, interval[1])) return i;
                } else if (interval[1] === Infinity) {
                    if ($7b50f502cfd189d5$var$littleThan(close_1[0], interval[0], value)) return i;
                } else if ($7b50f502cfd189d5$var$littleThan(close_1[0], interval[0], value) && $7b50f502cfd189d5$var$littleThan(close_1[1], value, interval[1])) return i;
                findClosestWhenOutside && updatePossible(interval[0], i);
                findClosestWhenOutside && updatePossible(interval[1], i);
            }
        }
        if (findClosestWhenOutside) return value === Infinity ? pieceList.length - 1 : value === -Infinity ? 0 : possibleI;
        function updatePossible(val, index) {
            var newAbs = Math.abs(val - value);
            if (newAbs < abs) {
                abs = newAbs;
                possibleI = index;
            }
        }
    };
    VisualMapping.visualHandlers = {
        color: {
            applyVisual: $7b50f502cfd189d5$var$makeApplyVisual("color"),
            getColorMapper: function() {
                var thisOption = this.option;
                return $7a1bd9c2710fea0d$export$2385a24977818dd0(thisOption.mappingMethod === "category" ? function(value, isNormalized) {
                    !isNormalized && (value = this._normalizeData(value));
                    return $7b50f502cfd189d5$var$doMapCategory.call(this, value);
                } : function(value, isNormalized, out) {
                    // If output rgb array
                    // which will be much faster and useful in pixel manipulation
                    var returnRGBArray = !!out;
                    !isNormalized && (value = this._normalizeData(value));
                    out = $2c037f5bda6341ca$export$66cb3c0e9efc61c8(value, thisOption.parsedVisual, out);
                    return returnRGBArray ? out : $2c037f5bda6341ca$export$fac44ee5b035f737(out, "rgba");
                }, this);
            },
            _normalizedToVisual: {
                linear: function(normalized) {
                    return $2c037f5bda6341ca$export$fac44ee5b035f737($2c037f5bda6341ca$export$66cb3c0e9efc61c8(normalized, this.option.parsedVisual), "rgba");
                },
                category: $7b50f502cfd189d5$var$doMapCategory,
                piecewise: function(normalized, value) {
                    var result = $7b50f502cfd189d5$var$getSpecifiedVisual.call(this, value);
                    if (result == null) result = $2c037f5bda6341ca$export$fac44ee5b035f737($2c037f5bda6341ca$export$66cb3c0e9efc61c8(normalized, this.option.parsedVisual), "rgba");
                    return result;
                },
                fixed: $7b50f502cfd189d5$var$doMapFixed
            }
        },
        colorHue: $7b50f502cfd189d5$var$makePartialColorVisualHandler(function(color, value) {
            return $2c037f5bda6341ca$export$d898ae866e27bf18(color, value);
        }),
        colorSaturation: $7b50f502cfd189d5$var$makePartialColorVisualHandler(function(color, value) {
            return $2c037f5bda6341ca$export$d898ae866e27bf18(color, null, value);
        }),
        colorLightness: $7b50f502cfd189d5$var$makePartialColorVisualHandler(function(color, value) {
            return $2c037f5bda6341ca$export$d898ae866e27bf18(color, null, null, value);
        }),
        colorAlpha: $7b50f502cfd189d5$var$makePartialColorVisualHandler(function(color, value) {
            return $2c037f5bda6341ca$export$ab4754bf42583a26(color, value);
        }),
        decal: {
            applyVisual: $7b50f502cfd189d5$var$makeApplyVisual("decal"),
            _normalizedToVisual: {
                linear: null,
                category: $7b50f502cfd189d5$var$doMapCategory,
                piecewise: null,
                fixed: null
            }
        },
        opacity: {
            applyVisual: $7b50f502cfd189d5$var$makeApplyVisual("opacity"),
            _normalizedToVisual: $7b50f502cfd189d5$var$createNormalizedToNumericVisual([
                0,
                1
            ])
        },
        liftZ: {
            applyVisual: $7b50f502cfd189d5$var$makeApplyVisual("liftZ"),
            _normalizedToVisual: {
                linear: $7b50f502cfd189d5$var$doMapFixed,
                category: $7b50f502cfd189d5$var$doMapFixed,
                piecewise: $7b50f502cfd189d5$var$doMapFixed,
                fixed: $7b50f502cfd189d5$var$doMapFixed
            }
        },
        symbol: {
            applyVisual: function(value, getter, setter) {
                var symbolCfg = this.mapValueToVisual(value);
                setter("symbol", symbolCfg);
            },
            _normalizedToVisual: {
                linear: $7b50f502cfd189d5$var$doMapToArray,
                category: $7b50f502cfd189d5$var$doMapCategory,
                piecewise: function(normalized, value) {
                    var result = $7b50f502cfd189d5$var$getSpecifiedVisual.call(this, value);
                    if (result == null) result = $7b50f502cfd189d5$var$doMapToArray.call(this, normalized);
                    return result;
                },
                fixed: $7b50f502cfd189d5$var$doMapFixed
            }
        },
        symbolSize: {
            applyVisual: $7b50f502cfd189d5$var$makeApplyVisual("symbolSize"),
            _normalizedToVisual: $7b50f502cfd189d5$var$createNormalizedToNumericVisual([
                0,
                1
            ])
        }
    };
    return VisualMapping;
}();
function $7b50f502cfd189d5$var$preprocessForPiecewise(thisOption) {
    var pieceList = thisOption.pieceList;
    thisOption.hasSpecialVisual = false;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(pieceList, function(piece, index) {
        piece.originIndex = index;
        // piece.visual is "result visual value" but not
        // a visual range, so it does not need to be normalized.
        if (piece.visual != null) thisOption.hasSpecialVisual = true;
    });
}
function $7b50f502cfd189d5$var$preprocessForSpecifiedCategory(thisOption) {
    // Hash categories.
    var categories = thisOption.categories;
    var categoryMap = thisOption.categoryMap = {};
    var visual = thisOption.visual;
    $7b50f502cfd189d5$var$each(categories, function(cate, index) {
        categoryMap[cate] = index;
    });
    // Process visual map input.
    if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(visual)) {
        var visualArr_1 = [];
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(visual)) $7b50f502cfd189d5$var$each(visual, function(v, cate) {
            var index = categoryMap[cate];
            visualArr_1[index != null ? index : $7b50f502cfd189d5$var$CATEGORY_DEFAULT_VISUAL_INDEX] = v;
        });
        else // Is primary type, represents default visual.
        visualArr_1[$7b50f502cfd189d5$var$CATEGORY_DEFAULT_VISUAL_INDEX] = visual;
        visual = $7b50f502cfd189d5$var$setVisualToOption(thisOption, visualArr_1);
    }
    // Remove categories that has no visual,
    // then we can mapping them to CATEGORY_DEFAULT_VISUAL_INDEX.
    for(var i = categories.length - 1; i >= 0; i--)if (visual[i] == null) {
        delete categoryMap[categories[i]];
        categories.pop();
    }
}
function $7b50f502cfd189d5$var$normalizeVisualRange(thisOption, isCategory) {
    var visual = thisOption.visual;
    var visualArr = [];
    if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(visual)) $7b50f502cfd189d5$var$each(visual, function(v) {
        visualArr.push(v);
    });
    else if (visual != null) visualArr.push(visual);
    var doNotNeedPair = {
        color: 1,
        symbol: 1
    };
    if (!isCategory && visualArr.length === 1 && !doNotNeedPair.hasOwnProperty(thisOption.type)) // Do not care visualArr.length === 0, which is illegal.
    visualArr[1] = visualArr[0];
    $7b50f502cfd189d5$var$setVisualToOption(thisOption, visualArr);
}
function $7b50f502cfd189d5$var$makePartialColorVisualHandler(applyValue) {
    return {
        applyVisual: function(value, getter, setter) {
            // Only used in HSL
            var colorChannel = this.mapValueToVisual(value);
            // Must not be array value
            setter("color", applyValue(getter("color"), colorChannel));
        },
        _normalizedToVisual: $7b50f502cfd189d5$var$createNormalizedToNumericVisual([
            0,
            1
        ])
    };
}
function $7b50f502cfd189d5$var$doMapToArray(normalized) {
    var visual = this.option.visual;
    return visual[Math.round((0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(normalized, [
        0,
        1
    ], [
        0,
        visual.length - 1
    ], true))] || {}; // TODO {}?
}
function $7b50f502cfd189d5$var$makeApplyVisual(visualType) {
    return function(value, getter, setter) {
        setter(visualType, this.mapValueToVisual(value));
    };
}
function $7b50f502cfd189d5$var$doMapCategory(normalized) {
    var visual = this.option.visual;
    return visual[this.option.loop && normalized !== $7b50f502cfd189d5$var$CATEGORY_DEFAULT_VISUAL_INDEX ? normalized % visual.length : normalized];
}
function $7b50f502cfd189d5$var$doMapFixed() {
    // visual will be convert to array.
    return this.option.visual[0];
}
/**
 * Create mapped to numeric visual
 */ function $7b50f502cfd189d5$var$createNormalizedToNumericVisual(sourceExtent) {
    return {
        linear: function(normalized) {
            return (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(normalized, sourceExtent, this.option.visual, true);
        },
        category: $7b50f502cfd189d5$var$doMapCategory,
        piecewise: function(normalized, value) {
            var result = $7b50f502cfd189d5$var$getSpecifiedVisual.call(this, value);
            if (result == null) result = (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(normalized, sourceExtent, this.option.visual, true);
            return result;
        },
        fixed: $7b50f502cfd189d5$var$doMapFixed
    };
}
function $7b50f502cfd189d5$var$getSpecifiedVisual(value) {
    var thisOption = this.option;
    var pieceList = thisOption.pieceList;
    if (thisOption.hasSpecialVisual) {
        var pieceIndex = $7b50f502cfd189d5$var$VisualMapping.findPieceIndex(value, pieceList);
        var piece = pieceList[pieceIndex];
        if (piece && piece.visual) return piece.visual[this.type];
    }
}
function $7b50f502cfd189d5$var$setVisualToOption(thisOption, visualArr) {
    thisOption.visual = visualArr;
    if (thisOption.type === "color") thisOption.parsedVisual = $7a1bd9c2710fea0d$export$871de8747c9eaa88(visualArr, function(item) {
        var color = $2c037f5bda6341ca$export$98e6a39c04603d36(item);
        return color || [
            0,
            0,
            0,
            1
        ];
    });
    return visualArr;
}
/**
 * Normalizers by mapping methods.
 */ var $7b50f502cfd189d5$var$normalizers = {
    linear: function(value) {
        return (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(value, this.option.dataExtent, [
            0,
            1
        ], true);
    },
    piecewise: function(value) {
        var pieceList = this.option.pieceList;
        var pieceIndex = $7b50f502cfd189d5$var$VisualMapping.findPieceIndex(value, pieceList, true);
        if (pieceIndex != null) return (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(pieceIndex, [
            0,
            pieceList.length - 1
        ], [
            0,
            1
        ], true);
    },
    category: function(value) {
        var index = this.option.categories ? this.option.categoryMap[value] : value; // ordinal value
        return index == null ? $7b50f502cfd189d5$var$CATEGORY_DEFAULT_VISUAL_INDEX : index;
    },
    fixed: $7a1bd9c2710fea0d$export$8793edee2d425525
};
function $7b50f502cfd189d5$var$littleThan(close, a, b) {
    return close ? a <= b : a < b;
}
var $7b50f502cfd189d5$export$2e2bcd8739ae039 = $7b50f502cfd189d5$var$VisualMapping;


function $5379d5704c92d7dd$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType("sankey", function(seriesModel) {
        var graph = seriesModel.getGraph();
        var nodes = graph.nodes;
        var edges = graph.edges;
        if (nodes.length) {
            var minValue_1 = Infinity;
            var maxValue_1 = -Infinity;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
                var nodeValue = node.getLayout().value;
                if (nodeValue < minValue_1) minValue_1 = nodeValue;
                if (nodeValue > maxValue_1) maxValue_1 = nodeValue;
            });
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
                var mapping = new (0, $7b50f502cfd189d5$export$2e2bcd8739ae039)({
                    type: "color",
                    mappingMethod: "linear",
                    dataExtent: [
                        minValue_1,
                        maxValue_1
                    ],
                    visual: seriesModel.get("color")
                });
                var mapValueToColor = mapping.mapValueToVisual(node.getLayout().value);
                var customColor = node.getModel().get([
                    "itemStyle",
                    "color"
                ]);
                if (customColor != null) {
                    node.setVisual("color", customColor);
                    node.setVisual("style", {
                        fill: customColor
                    });
                } else {
                    node.setVisual("color", mapValueToColor);
                    node.setVisual("style", {
                        fill: mapValueToColor
                    });
                }
            });
        }
        if (edges.length) $7a1bd9c2710fea0d$export$79b2f7037acddd43(edges, function(edge) {
            var edgeStyle = edge.getModel().get("lineStyle");
            edge.setVisual("style", edgeStyle);
        });
    });
}



function $2439b31c49c21b38$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $58364a2c82b0ec77$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $f213d63e219306d2$export$2e2bcd8739ae039));
    registers.registerLayout((0, $b2e36df99c285454$export$2e2bcd8739ae039));
    registers.registerVisual((0, $5379d5704c92d7dd$export$2e2bcd8739ae039));
    registers.registerAction({
        type: "dragNode",
        event: "dragnode",
        // here can only use 'update' now, other value is not support in echarts.
        update: "update"
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "series",
            subType: "sankey",
            query: payload
        }, function(seriesModel) {
            seriesModel.setNodePosition(payload.dataIndex, [
                payload.localX,
                payload.localY
            ]);
        });
    });
    registers.registerAction({
        type: "sankeyRoam",
        event: "sankeyRoam",
        update: "none"
    }, function(payload, ecModel, api) {
        ecModel.eachComponent({
            mainType: "series",
            subType: "sankey",
            query: payload
        }, function(seriesModel) {
            var coordSys = seriesModel.coordinateSystem;
            var res = (0, $35fd859fd545c4be$export$94d6a16eae2c4cf4)(coordSys, payload, seriesModel.get("scaleLimit"));
            seriesModel.setCenter(res.center);
            seriesModel.setZoom(res.zoom);
        });
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $00ab9646b588965f$var$ScatterSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ScatterSeriesModel, _super);
    function ScatterSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScatterSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    ScatterSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true
        });
    };
    ScatterSeriesModel.prototype.getProgressive = function() {
        var progressive = this.option.progressive;
        if (progressive == null) // PENDING
        return this.option.large ? 5e3 : this.get("progressive");
        return progressive;
    };
    ScatterSeriesModel.prototype.getProgressiveThreshold = function() {
        var progressiveThreshold = this.option.progressiveThreshold;
        if (progressiveThreshold == null) // PENDING
        return this.option.large ? 1e4 : this.get("progressiveThreshold");
        return progressiveThreshold;
    };
    ScatterSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        return selectors.point(data.getItemLayout(dataIndex));
    };
    ScatterSeriesModel.prototype.getZLevelKey = function() {
        // Each progressive series has individual key.
        return this.getData().count() > this.getProgressiveThreshold() ? this.id : "";
    };
    ScatterSeriesModel.type = "series.scatter";
    ScatterSeriesModel.dependencies = [
        "grid",
        "polar",
        "geo",
        "singleAxis",
        "calendar",
        "matrix"
    ];
    ScatterSeriesModel.defaultOption = {
        coordinateSystem: "cartesian2d",
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        symbolSize: 10,
        // symbolRotate: null,  // 图形旋转控制
        large: false,
        // Available when large is true
        largeThreshold: 2000,
        // cursor: null,
        itemStyle: {
            opacity: 0.8
        },
        emphasis: {
            scale: true
        },
        // If clip the overflow graphics
        // Works on cartesian / polar series
        clip: true,
        select: {
            itemStyle: {
                borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.primary
            }
        },
        universalTransition: {
            divideShape: "clone"
        }
    };
    return ScatterSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $00ab9646b588965f$export$2e2bcd8739ae039 = $00ab9646b588965f$var$ScatterSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $69bbf770a3ca2c75$var$BOOST_SIZE_THRESHOLD = 4;
var $69bbf770a3ca2c75$var$LargeSymbolPathShape = /** @class */ function() {
    function LargeSymbolPathShape() {}
    return LargeSymbolPathShape;
}();
var $69bbf770a3ca2c75$var$LargeSymbolPath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LargeSymbolPath, _super);
    function LargeSymbolPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this._off = 0;
        _this.hoverDataIdx = -1;
        return _this;
    }
    LargeSymbolPath.prototype.getDefaultShape = function() {
        return new $69bbf770a3ca2c75$var$LargeSymbolPathShape();
    };
    LargeSymbolPath.prototype.reset = function() {
        this.notClear = false;
        this._off = 0;
    };
    LargeSymbolPath.prototype.buildPath = function(path, shape) {
        var points = shape.points;
        var size = shape.size;
        var symbolProxy = this.symbolProxy;
        var symbolProxyShape = symbolProxy.shape;
        var ctx = path.getContext ? path.getContext() : path;
        var canBoost = ctx && size[0] < $69bbf770a3ca2c75$var$BOOST_SIZE_THRESHOLD;
        var softClipShape = this.softClipShape;
        var i;
        // Do draw in afterBrush.
        if (canBoost) {
            this._ctx = ctx;
            return;
        }
        this._ctx = null;
        for(i = this._off; i < points.length;){
            var x = points[i++];
            var y = points[i++];
            if (isNaN(x) || isNaN(y)) continue;
            if (softClipShape && !softClipShape.contain(x, y)) continue;
            symbolProxyShape.x = x - size[0] / 2;
            symbolProxyShape.y = y - size[1] / 2;
            symbolProxyShape.width = size[0];
            symbolProxyShape.height = size[1];
            symbolProxy.buildPath(path, symbolProxyShape, true);
        }
        if (this.incremental) {
            this._off = i;
            this.notClear = true;
        }
    };
    LargeSymbolPath.prototype.afterBrush = function() {
        var shape = this.shape;
        var points = shape.points;
        var size = shape.size;
        var ctx = this._ctx;
        var softClipShape = this.softClipShape;
        var i;
        if (!ctx) return;
        // PENDING If style or other canvas status changed?
        for(i = this._off; i < points.length;){
            var x = points[i++];
            var y = points[i++];
            if (isNaN(x) || isNaN(y)) continue;
            if (softClipShape && !softClipShape.contain(x, y)) continue;
            // fillRect is faster than building a rect path and draw.
            // And it support light globalCompositeOperation.
            ctx.fillRect(x - size[0] / 2, y - size[1] / 2, size[0], size[1]);
        }
        if (this.incremental) {
            this._off = i;
            this.notClear = true;
        }
    };
    LargeSymbolPath.prototype.findDataIndex = function(x, y) {
        // TODO ???
        // Consider transform
        var shape = this.shape;
        var points = shape.points;
        var size = shape.size;
        var w = Math.max(size[0], 4);
        var h = Math.max(size[1], 4);
        // Not consider transform
        // Treat each element as a rect
        // top down traverse
        for(var idx = points.length / 2 - 1; idx >= 0; idx--){
            var i = idx * 2;
            var x0 = points[i] - w / 2;
            var y0 = points[i + 1] - h / 2;
            if (x >= x0 && y >= y0 && x <= x0 + w && y <= y0 + h) return idx;
        }
        return -1;
    };
    LargeSymbolPath.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            // Cache found data index.
            var dataIdx = this.hoverDataIdx = this.findDataIndex(x, y);
            return dataIdx >= 0;
        }
        this.hoverDataIdx = -1;
        return false;
    };
    LargeSymbolPath.prototype.getBoundingRect = function() {
        // Ignore stroke for large symbol draw.
        var rect = this._rect;
        if (!rect) {
            var shape = this.shape;
            var points = shape.points;
            var size = shape.size;
            var w = size[0];
            var h = size[1];
            var minX = Infinity;
            var minY = Infinity;
            var maxX = -Infinity;
            var maxY = -Infinity;
            for(var i = 0; i < points.length;){
                var x = points[i++];
                var y = points[i++];
                minX = Math.min(x, minX);
                maxX = Math.max(x, maxX);
                minY = Math.min(y, minY);
                maxY = Math.max(y, maxY);
            }
            rect = this._rect = new $1bebe7106c895823$export$2e2bcd8739ae039(minX - w / 2, minY - h / 2, maxX - minX + w, maxY - minY + h);
        }
        return rect;
    };
    return LargeSymbolPath;
}($b02ffe7acd508c08$export$2e2bcd8739ae039);
var $69bbf770a3ca2c75$var$LargeSymbolDraw = /** @class */ function() {
    function LargeSymbolDraw() {
        this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
    }
    /**
   * Update symbols draw by new data
   */ LargeSymbolDraw.prototype.updateData = function(data, opt) {
        this._clear();
        var symbolEl = this._create();
        symbolEl.setShape({
            points: data.getLayout("points")
        });
        this._setCommon(symbolEl, data, opt);
    };
    LargeSymbolDraw.prototype.updateLayout = function(data) {
        var points = data.getLayout("points");
        this.group.eachChild(function(child) {
            if (child.startIndex != null) {
                var len = (child.endIndex - child.startIndex) * 2;
                var byteOffset = child.startIndex * 8;
                points = new Float32Array(points.buffer, byteOffset, len);
            }
            child.setShape("points", points);
            // Reset draw cursor.
            child.reset();
        });
    };
    LargeSymbolDraw.prototype.incrementalPrepareUpdate = function(data) {
        this._clear();
    };
    LargeSymbolDraw.prototype.incrementalUpdate = function(taskParams, data, opt) {
        var lastAdded = this._newAdded[0];
        var points = data.getLayout("points");
        var oldPoints = lastAdded && lastAdded.shape.points;
        // Merging the exists. Each element has 1e4 points.
        // Consider the performance balance between too much elements and too much points in one shape(may affect hover optimization)
        if (oldPoints && oldPoints.length < 2e4) {
            var oldLen = oldPoints.length;
            var newPoints = new Float32Array(oldLen + points.length);
            // Concat two array
            newPoints.set(oldPoints);
            newPoints.set(points, oldLen);
            // Update endIndex
            lastAdded.endIndex = taskParams.end;
            lastAdded.setShape({
                points: newPoints
            });
        } else {
            // Clear
            this._newAdded = [];
            var symbolEl = this._create();
            symbolEl.startIndex = taskParams.start;
            symbolEl.endIndex = taskParams.end;
            symbolEl.incremental = true;
            symbolEl.setShape({
                points: points
            });
            this._setCommon(symbolEl, data, opt);
        }
    };
    LargeSymbolDraw.prototype.eachRendered = function(cb) {
        this._newAdded[0] && cb(this._newAdded[0]);
    };
    LargeSymbolDraw.prototype._create = function() {
        var symbolEl = new $69bbf770a3ca2c75$var$LargeSymbolPath({
            cursor: "default"
        });
        symbolEl.ignoreCoarsePointer = true;
        this.group.add(symbolEl);
        this._newAdded.push(symbolEl);
        return symbolEl;
    };
    LargeSymbolDraw.prototype._setCommon = function(symbolEl, data, opt) {
        var hostModel = data.hostModel;
        opt = opt || {};
        var size = data.getVisual("symbolSize");
        symbolEl.setShape("size", size instanceof Array ? size : [
            size,
            size
        ]);
        symbolEl.softClipShape = opt.clipShape || null;
        // Create symbolProxy to build path for each data
        symbolEl.symbolProxy = (0, $5370466dadc978d7$export$af050e04da3a02e8)(data.getVisual("symbol"), 0, 0, 0, 0);
        // Use symbolProxy setColor method
        symbolEl.setColor = symbolEl.symbolProxy.setColor;
        var extrudeShadow = symbolEl.shape.size[0] < $69bbf770a3ca2c75$var$BOOST_SIZE_THRESHOLD;
        symbolEl.useStyle(// Draw shadow when doing fillRect is extremely slow.
        hostModel.getModel("itemStyle").getItemStyle(extrudeShadow ? [
            "color",
            "shadowBlur",
            "shadowColor"
        ] : [
            "color"
        ]));
        var globalStyle = data.getVisual("style");
        var visualColor = globalStyle && globalStyle.fill;
        if (visualColor) symbolEl.setColor(visualColor);
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(symbolEl);
        // Enable tooltip
        // PENDING May have performance issue when path is extremely large
        ecData.seriesIndex = hostModel.seriesIndex;
        symbolEl.on("mousemove", function(e) {
            ecData.dataIndex = null;
            var dataIndex = symbolEl.hoverDataIdx;
            if (dataIndex >= 0) // Provide dataIndex for tooltip
            ecData.dataIndex = dataIndex + (symbolEl.startIndex || 0);
        });
    };
    LargeSymbolDraw.prototype.remove = function() {
        this._clear();
    };
    LargeSymbolDraw.prototype._clear = function() {
        this._newAdded = [];
        this.group.removeAll();
    };
    return LargeSymbolDraw;
}();
var $69bbf770a3ca2c75$export$2e2bcd8739ae039 = $69bbf770a3ca2c75$var$LargeSymbolDraw;




var $c92a7ada0c69ef68$var$ScatterView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ScatterView, _super);
    function ScatterView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScatterView.type;
        return _this;
    }
    ScatterView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var symbolDraw = this._updateSymbolDraw(data, seriesModel);
        symbolDraw.updateData(data, {
            // TODO
            // If this parameter should be a shape or a bounding volume
            // shape will be more general.
            // But bounding volume like bounding rect will be much faster in the contain calculation
            clipShape: this._getClipShape(seriesModel)
        });
        this._finished = true;
    };
    ScatterView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var symbolDraw = this._updateSymbolDraw(data, seriesModel);
        symbolDraw.incrementalPrepareUpdate(data);
        this._finished = false;
    };
    ScatterView.prototype.incrementalRender = function(taskParams, seriesModel, ecModel) {
        this._symbolDraw.incrementalUpdate(taskParams, seriesModel.getData(), {
            clipShape: this._getClipShape(seriesModel)
        });
        this._finished = taskParams.end === seriesModel.getData().count();
    };
    ScatterView.prototype.updateTransform = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        // Must mark group dirty and make sure the incremental layer will be cleared
        // PENDING
        this.group.dirty();
        if (!this._finished || data.count() > 1e4) return {
            update: true
        };
        else {
            var res = (0, $73b014aa594ea652$export$2e2bcd8739ae039)("").reset(seriesModel, ecModel, api);
            if (res.progress) res.progress({
                start: 0,
                end: data.count(),
                count: data.count()
            }, data);
            this._symbolDraw.updateLayout(data);
        }
    };
    ScatterView.prototype.eachRendered = function(cb) {
        this._symbolDraw && this._symbolDraw.eachRendered(cb);
    };
    ScatterView.prototype._getClipShape = function(seriesModel) {
        if (!seriesModel.get("clip", true)) return;
        var coordSys = seriesModel.coordinateSystem;
        // PENDING make `0.1` configurable, for example, `clipTolerance`?
        return coordSys && coordSys.getArea && coordSys.getArea(.1);
    };
    ScatterView.prototype._updateSymbolDraw = function(data, seriesModel) {
        var symbolDraw = this._symbolDraw;
        var pipelineContext = seriesModel.pipelineContext;
        var isLargeDraw = pipelineContext.large;
        if (!symbolDraw || isLargeDraw !== this._isLargeDraw) {
            symbolDraw && symbolDraw.remove();
            symbolDraw = this._symbolDraw = isLargeDraw ? new (0, $69bbf770a3ca2c75$export$2e2bcd8739ae039)() : new (0, $fedf62268297fcbb$export$2e2bcd8739ae039)();
            this._isLargeDraw = isLargeDraw;
            this.group.removeAll();
        }
        this.group.add(symbolDraw.group);
        return symbolDraw;
    };
    ScatterView.prototype.remove = function(ecModel, api) {
        this._symbolDraw && this._symbolDraw.remove(true);
        this._symbolDraw = null;
    };
    ScatterView.prototype.dispose = function() {};
    ScatterView.type = "scatter";
    return ScatterView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $c92a7ada0c69ef68$export$2e2bcd8739ae039 = $c92a7ada0c69ef68$var$ScatterView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $d67c268180aaad04$export$57b4bb4ff2a0950c = {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
};
var $d67c268180aaad04$export$e78e6bf4dcc3e485 = [
    "25%",
    "25%"
];
var $d67c268180aaad04$var$GridModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GridModel, _super);
    function GridModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var outerBoundsCp = (0, $93b9bc7f22ac7369$export$4b0d20af19c9875e)(option.outerBounds);
        _super.prototype.mergeDefaultAndTheme.apply(this, arguments);
        if (outerBoundsCp && option.outerBounds) (0, $93b9bc7f22ac7369$export$1754cb91f16ca028)(option.outerBounds, outerBoundsCp);
    };
    GridModel.prototype.mergeOption = function(newOption, ecModel) {
        _super.prototype.mergeOption.apply(this, arguments);
        if (this.option.outerBounds && newOption.outerBounds) (0, $93b9bc7f22ac7369$export$1754cb91f16ca028)(this.option.outerBounds, newOption.outerBounds);
    };
    GridModel.type = "grid";
    GridModel.dependencies = [
        "xAxis",
        "yAxis"
    ];
    GridModel.layoutMode = "box";
    GridModel.defaultOption = {
        show: false,
        // zlevel: 0,
        z: 0,
        left: "15%",
        top: 65,
        right: "10%",
        bottom: 80,
        // If grid size contain label
        containLabel: false,
        outerBoundsMode: "auto",
        outerBounds: $d67c268180aaad04$export$57b4bb4ff2a0950c,
        outerBoundsContain: "all",
        outerBoundsClampWidth: $d67c268180aaad04$export$e78e6bf4dcc3e485[0],
        outerBoundsClampHeight: $d67c268180aaad04$export$e78e6bf4dcc3e485[1],
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        backgroundColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.transparent,
        borderWidth: 1,
        borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral30
    };
    return GridModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $d67c268180aaad04$export$2e2bcd8739ae039 = $d67c268180aaad04$var$GridModel;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $008426c98740266e$export$483dc37e6ad83a3c = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CartesianAxisModel, _super);
    function CartesianAxisModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CartesianAxisModel.prototype.getCoordSysModel = function() {
        return this.getReferringComponents("grid", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
    };
    CartesianAxisModel.type = "cartesian2dAxis";
    return CartesianAxisModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($008426c98740266e$export$483dc37e6ad83a3c, (0, $3449fd4c0590d99e$export$5c54b224726edb5a));
var $008426c98740266e$export$2e2bcd8739ae039 = $008426c98740266e$export$483dc37e6ad83a3c;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Grid is a region which contains at most 4 cartesian systems
 *
 * TODO Default cartesian
 */ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $f0775b150bc00f28$var$Cartesian = /** @class */ function() {
    function Cartesian(name) {
        this.type = "cartesian";
        this._dimList = [];
        this._axes = {};
        this.name = name || "";
    }
    Cartesian.prototype.getAxis = function(dim) {
        return this._axes[dim];
    };
    Cartesian.prototype.getAxes = function() {
        return $7a1bd9c2710fea0d$export$871de8747c9eaa88(this._dimList, function(dim) {
            return this._axes[dim];
        }, this);
    };
    Cartesian.prototype.getAxesByScale = function(scaleType) {
        scaleType = scaleType.toLowerCase();
        return $7a1bd9c2710fea0d$export$3dea766d36a8935f(this.getAxes(), function(axis) {
            return axis.scale.type === scaleType;
        });
    };
    Cartesian.prototype.addAxis = function(axis) {
        var dim = axis.dim;
        this._axes[dim] = axis;
        this._dimList.push(dim);
    };
    return Cartesian;
}();
var $f0775b150bc00f28$export$2e2bcd8739ae039 = $f0775b150bc00f28$var$Cartesian;




var $6bea838ef63ff2bb$export$988a008d2b9120f4 = [
    "x",
    "y"
];
function $6bea838ef63ff2bb$var$canCalculateAffineTransform(scale) {
    return (scale.type === "interval" || scale.type === "time") && !scale.hasBreaks();
}
var $6bea838ef63ff2bb$var$Cartesian2D = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(Cartesian2D, _super);
    function Cartesian2D() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "cartesian2d";
        _this.dimensions = $6bea838ef63ff2bb$export$988a008d2b9120f4;
        return _this;
    }
    /**
   * Calculate an affine transform matrix if two axes are time or value.
   * It's mainly for accelartion on the large time series data.
   */ Cartesian2D.prototype.calcAffineTransform = function() {
        this._transform = this._invTransform = null;
        var xAxisScale = this.getAxis("x").scale;
        var yAxisScale = this.getAxis("y").scale;
        if (!$6bea838ef63ff2bb$var$canCalculateAffineTransform(xAxisScale) || !$6bea838ef63ff2bb$var$canCalculateAffineTransform(yAxisScale)) return;
        var xScaleExtent = xAxisScale.getExtent();
        var yScaleExtent = yAxisScale.getExtent();
        var start = this.dataToPoint([
            xScaleExtent[0],
            yScaleExtent[0]
        ]);
        var end = this.dataToPoint([
            xScaleExtent[1],
            yScaleExtent[1]
        ]);
        var xScaleSpan = xScaleExtent[1] - xScaleExtent[0];
        var yScaleSpan = yScaleExtent[1] - yScaleExtent[0];
        if (!xScaleSpan || !yScaleSpan) return;
        // Accelerate data to point calculation on the special large time series data.
        var scaleX = (end[0] - start[0]) / xScaleSpan;
        var scaleY = (end[1] - start[1]) / yScaleSpan;
        var translateX = start[0] - xScaleExtent[0] * scaleX;
        var translateY = start[1] - yScaleExtent[0] * scaleY;
        var m = this._transform = [
            scaleX,
            0,
            0,
            scaleY,
            translateX,
            translateY
        ];
        this._invTransform = (0, $f41ebb9dd60b55b4$export$6897c284b6f9f4dc)([], m);
    };
    /**
   * Base axis will be used on stacking.
   */ Cartesian2D.prototype.getBaseAxis = function() {
        return this.getAxesByScale("ordinal")[0] || this.getAxesByScale("time")[0] || this.getAxis("x");
    };
    Cartesian2D.prototype.containPoint = function(point) {
        var axisX = this.getAxis("x");
        var axisY = this.getAxis("y");
        return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
    };
    Cartesian2D.prototype.containData = function(data) {
        return this.getAxis("x").containData(data[0]) && this.getAxis("y").containData(data[1]);
    };
    Cartesian2D.prototype.containZone = function(data1, data2) {
        var zoneDiag1 = this.dataToPoint(data1);
        var zoneDiag2 = this.dataToPoint(data2);
        var area = this.getArea();
        var zone = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(zoneDiag1[0], zoneDiag1[1], zoneDiag2[0] - zoneDiag1[0], zoneDiag2[1] - zoneDiag1[1]);
        return area.intersect(zone);
    };
    Cartesian2D.prototype.dataToPoint = function(data, clamp, out) {
        out = out || [];
        var xVal = data[0];
        var yVal = data[1];
        // [CAVEAT]: Do not add time consuming operation within and before fast path.
        // Fast path.
        if (this._transform && xVal != null && isFinite(xVal) && yVal != null && isFinite(yVal)) return (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(out, data, this._transform);
        var xAxis = this.getAxis("x");
        var yAxis = this.getAxis("y");
        out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(xVal, clamp));
        out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(yVal, clamp));
        return out;
    };
    Cartesian2D.prototype.clampData = function(data, out) {
        var xScale = this.getAxis("x").scale;
        var yScale = this.getAxis("y").scale;
        var xAxisExtent = xScale.getExtent();
        var yAxisExtent = yScale.getExtent();
        var x = xScale.parse(data[0]);
        var y = yScale.parse(data[1]);
        out = out || [];
        out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
        out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
        return out;
    };
    Cartesian2D.prototype.pointToData = function(point, clamp, out) {
        out = out || [];
        if (this._invTransform) return (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(out, point, this._invTransform);
        var xAxis = this.getAxis("x");
        var yAxis = this.getAxis("y");
        out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]), clamp);
        out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]), clamp);
        return out;
    };
    Cartesian2D.prototype.getOtherAxis = function(axis) {
        return this.getAxis(axis.dim === "x" ? "y" : "x");
    };
    /**
   * Get rect area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   */ Cartesian2D.prototype.getArea = function(tolerance) {
        tolerance = tolerance || 0;
        var xExtent = this.getAxis("x").getGlobalExtent();
        var yExtent = this.getAxis("y").getGlobalExtent();
        var x = Math.min(xExtent[0], xExtent[1]) - tolerance;
        var y = Math.min(yExtent[0], yExtent[1]) - tolerance;
        var width = Math.max(xExtent[0], xExtent[1]) - x + tolerance;
        var height = Math.max(yExtent[0], yExtent[1]) - y + tolerance;
        return new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height);
    };
    return Cartesian2D;
}((0, $f0775b150bc00f28$export$2e2bcd8739ae039));
var $6bea838ef63ff2bb$export$2e2bcd8739ae039 = $6bea838ef63ff2bb$var$Cartesian2D;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $23369073c2236a8d$var$Axis2D = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(Axis2D, _super);
    function Axis2D(dim, scale, coordExtent, axisType, position) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        /**
     * Index of axis, can be used as key
     * Injected outside.
     */ _this.index = 0;
        _this.type = axisType || "value";
        _this.position = position || "bottom";
        return _this;
    }
    Axis2D.prototype.isHorizontal = function() {
        var position = this.position;
        return position === "top" || position === "bottom";
    };
    /**
   * Each item cooresponds to this.getExtent(), which
   * means globalExtent[0] may greater than globalExtent[1],
   * unless `asc` is input.
   *
   * @param {boolean} [asc]
   * @return {Array.<number>}
   */ Axis2D.prototype.getGlobalExtent = function(asc) {
        var ret = this.getExtent();
        ret[0] = this.toGlobalCoord(ret[0]);
        ret[1] = this.toGlobalCoord(ret[1]);
        asc && ret[0] > ret[1] && ret.reverse();
        return ret;
    };
    Axis2D.prototype.pointToData = function(point, clamp) {
        return this.coordToData(this.toLocalCoord(point[this.dim === "x" ? 0 : 1]), clamp);
    };
    /**
   * Set ordinalSortInfo
   * @param info new OrdinalSortInfo
   */ Axis2D.prototype.setCategorySortInfo = function(info) {
        if (this.type !== "category") return false;
        this.model.option.categorySortInfo = info;
        this.scale.setSortInfo(info);
    };
    return Axis2D;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
var $23369073c2236a8d$export$2e2bcd8739ae039 = $23369073c2236a8d$var$Axis2D;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



function $88c937c9bc0ca068$export$b3219800bda33a1f(rect, axisModel, opt) {
    opt = opt || {};
    var axis = axisModel.axis;
    var layout = {};
    var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
    var rawAxisPosition = axis.position;
    var axisPosition = otherAxisOnZeroOf ? "onZero" : rawAxisPosition;
    var axisDim = axis.dim;
    var rectBound = [
        rect.x,
        rect.x + rect.width,
        rect.y,
        rect.y + rect.height
    ];
    var idx = {
        left: 0,
        right: 1,
        top: 0,
        bottom: 1,
        onZero: 2
    };
    var axisOffset = axisModel.get("offset") || 0;
    var posBound = axisDim === "x" ? [
        rectBound[2] - axisOffset,
        rectBound[3] + axisOffset
    ] : [
        rectBound[0] - axisOffset,
        rectBound[1] + axisOffset
    ];
    if (otherAxisOnZeroOf) {
        var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
        posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
    }
    // Axis position
    layout.position = [
        axisDim === "y" ? posBound[idx[axisPosition]] : rectBound[0],
        axisDim === "x" ? posBound[idx[axisPosition]] : rectBound[3]
    ];
    // Axis rotation
    layout.rotation = Math.PI / 2 * (axisDim === "x" ? 0 : 1);
    // Tick and label direction, x y is axisDim
    var dirMap = {
        top: -1,
        bottom: 1,
        left: -1,
        right: 1
    };
    layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
    layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;
    if (axisModel.get([
        "axisTick",
        "inside"
    ])) layout.tickDirection = -layout.tickDirection;
    if ($7a1bd9c2710fea0d$export$8a4d17b6e8486e66(opt.labelInside, axisModel.get([
        "axisLabel",
        "inside"
    ]))) layout.labelDirection = -layout.labelDirection;
    // Special label rotation
    var labelRotate = axisModel.get([
        "axisLabel",
        "rotate"
    ]);
    layout.labelRotate = axisPosition === "top" ? -labelRotate : labelRotate;
    // Over splitLine and splitArea
    layout.z2 = 1;
    return layout;
}
function $88c937c9bc0ca068$export$1a2a248dbebc52b5(seriesModel) {
    return seriesModel.get("coordinateSystem") === "cartesian2d";
}
function $88c937c9bc0ca068$export$e447722773749af(seriesModel) {
    return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === "cartesian2d";
}
function $88c937c9bc0ca068$export$8220131ac1d61d28(seriesModel) {
    var axisModelMap = {
        xAxisModel: null,
        yAxisModel: null
    };
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(axisModelMap, function(v, key) {
        var axisType = key.replace(/Model$/, "");
        var axisModel = seriesModel.getReferringComponents(axisType, (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        axisModelMap[key] = axisModel;
    });
    return axisModelMap;
}
function $88c937c9bc0ca068$export$2b2ce820c3e1e776(gridRect, cartesians, axisModel, api, ctx, defaultNameMoveOverlap) {
    var layoutResult = $88c937c9bc0ca068$export$b3219800bda33a1f(gridRect, axisModel);
    var axisLineAutoShow = false;
    var axisTickAutoShow = false;
    // Not show axisTick or axisLine if other axis is category / time
    for(var i = 0; i < cartesians.length; i++)if ((0, $60f7f1f3e3996637$export$dfc8cd28ed7b22a0)(cartesians[i].getOtherAxis(axisModel.axis).scale)) {
        // Still show axis tick or axisLine if other axis is value / log
        axisLineAutoShow = axisTickAutoShow = true;
        if (axisModel.axis.type === "category" && axisModel.axis.onBand) axisTickAutoShow = false;
    }
    layoutResult.axisLineAutoShow = axisLineAutoShow;
    layoutResult.axisTickAutoShow = axisTickAutoShow;
    layoutResult.defaultNameMoveOverlap = defaultNameMoveOverlap;
    return new (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039)(axisModel, api, layoutResult, ctx);
}
function $88c937c9bc0ca068$export$3e8d41f03e1a6a39(axisBuilder, gridRect, axisModel) {
    var newRaw = $88c937c9bc0ca068$export$b3219800bda33a1f(gridRect, axisModel);
    var oldRaw_1;
    axisBuilder.updateCfg(newRaw);
}










// margin is [top, right, bottom, left]
var $8e1d1b12d8439742$var$XY_TO_MARGIN_IDX = [
    [
        3,
        1
    ],
    [
        0,
        2
    ] // xyIdx 1 => 'y'
];
var $8e1d1b12d8439742$var$Grid = /** @class */ function() {
    function Grid(gridModel, ecModel, api) {
        // FIXME:TS where used (different from registered type 'cartesian2d')?
        this.type = "grid";
        this._coordsMap = {};
        this._coordsList = [];
        this._axesMap = {};
        this._axesList = [];
        this.axisPointerEnabled = true;
        this.dimensions = (0, $6bea838ef63ff2bb$export$988a008d2b9120f4);
        this._initCartesian(gridModel, ecModel, api);
        this.model = gridModel;
    }
    Grid.prototype.getRect = function() {
        return this._rect;
    };
    Grid.prototype.update = function(ecModel, api) {
        var axesMap = this._axesMap;
        this._updateScale(ecModel, this.model);
        function updateAxisTicks(axes) {
            var alignTo;
            // Axis is added in order of axisIndex.
            var axesIndices = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(axes);
            var len = axesIndices.length;
            if (!len) return;
            var axisNeedsAlign = [];
            // Process once and calculate the ticks for those don't use alignTicks.
            for(var i = len - 1; i >= 0; i--){
                var idx = +axesIndices[i]; // Convert to number.
                var axis = axes[idx];
                var model = axis.model;
                var scale = axis.scale;
                if (// Only value and log axis without interval support alignTicks.
                (0, $60f7f1f3e3996637$export$dfc8cd28ed7b22a0)(scale) && model.get("alignTicks") && model.get("interval") == null) axisNeedsAlign.push(axis);
                else {
                    (0, $2d646e51cc34f840$export$51f3e70a54405d5a)(scale, model);
                    if ((0, $60f7f1f3e3996637$export$dfc8cd28ed7b22a0)(scale)) // Can only align to interval or log axis.
                    alignTo = axis;
                }
            }
            // All axes has set alignTicks. Pick the first one.
            // PENDING. Should we find the axis that both set interval, min, max and align to this one?
            if (axisNeedsAlign.length) {
                if (!alignTo) {
                    alignTo = axisNeedsAlign.pop();
                    (0, $2d646e51cc34f840$export$51f3e70a54405d5a)(alignTo.scale, alignTo.model);
                }
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisNeedsAlign, function(axis) {
                    (0, $0591b52263f31374$export$c0b3be0e9eb0c2d9)(axis.scale, axis.model, alignTo.scale);
                });
            }
        }
        updateAxisTicks(axesMap.x);
        updateAxisTicks(axesMap.y);
        // Key: axisDim_axisIndex, value: boolean, whether onZero target.
        var onZeroRecords = {};
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesMap.x, function(xAxis) {
            $8e1d1b12d8439742$var$fixAxisOnZero(axesMap, "y", xAxis, onZeroRecords);
        });
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesMap.y, function(yAxis) {
            $8e1d1b12d8439742$var$fixAxisOnZero(axesMap, "x", yAxis, onZeroRecords);
        });
        // Resize again if containLabel is enabled
        // FIXME It may cause getting wrong grid size in data processing stage
        this.resize(this.model, api);
    };
    /**
   * Resize the grid.
   *
   * [NOTE]
   * If both "grid.containLabel/grid.contain" and pixel-required-data-processing (such as, "dataSampling")
   * exist, circular dependency occurs in logic.
   * The final compromised sequence is:
   *  1. Calculate "axis.extent" (pixel extent) and AffineTransform based on only "grid layout options".
   *      Not accurate if "grid.containLabel/grid.contain" is required, but it is a compromise to avoid
   *      circular dependency.
   *  2. Perform "series data processing" (where "dataSampling" requires "axis.extent").
   *  3. Calculate "scale.extent" (data extent) based on "processed series data".
   *  4. Modify "axis.extent" for "grid.containLabel/grid.contain":
   *      4.1. Calculate "axis labels" based on "scale.extent".
   *      4.2. Modify "axis.extent" by the bounding rects of "axis labels and names".
   */ Grid.prototype.resize = function(gridModel, api, beforeDataProcessing) {
        var layoutRef = (0, $93b9bc7f22ac7369$export$5aec1e94f566e59f)(gridModel, api);
        var gridRect = this._rect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(gridModel.getBoxLayoutParams(), layoutRef.refContainer);
        // PENDING: whether to support that if the input `coord` is out of the base coord sys,
        //  do not render anything. At present, the behavior is undefined.
        var axesMap = this._axesMap;
        var coordsList = this._coordsList;
        var optionContainLabel = gridModel.get("containLabel"); // No `.get(, true)` for backward compat.
        $8e1d1b12d8439742$var$updateAllAxisExtentTransByGridRect(axesMap, gridRect);
        if (!beforeDataProcessing) {
            var axisBuilderSharedCtx = $8e1d1b12d8439742$var$createAxisBiulders(gridRect, coordsList, axesMap, optionContainLabel, api);
            var noPxChange = void 0;
            if (optionContainLabel) {
                if ($8e1d1b12d8439742$var$legacyLayOutGridByContainLabel) {
                    // console.time('legacyLayOutGridByContainLabel');
                    $8e1d1b12d8439742$var$legacyLayOutGridByContainLabel(this._axesList, gridRect);
                    $8e1d1b12d8439742$var$updateAllAxisExtentTransByGridRect(axesMap, gridRect);
                // console.timeEnd('legacyLayOutGridByContainLabel');
                } else noPxChange = $8e1d1b12d8439742$var$layOutGridByOuterBounds(gridRect.clone(), "axisLabel", null, gridRect, axesMap, axisBuilderSharedCtx, layoutRef);
            } else {
                var _a = $8e1d1b12d8439742$var$prepareOuterBounds(gridModel, gridRect, layoutRef), outerBoundsRect = _a.outerBoundsRect, parsedOuterBoundsContain = _a.parsedOuterBoundsContain, outerBoundsClamp = _a.outerBoundsClamp;
                if (outerBoundsRect) // console.time('layOutGridByOuterBounds');
                noPxChange = $8e1d1b12d8439742$var$layOutGridByOuterBounds(outerBoundsRect, parsedOuterBoundsContain, outerBoundsClamp, gridRect, axesMap, axisBuilderSharedCtx, layoutRef);
            }
            // console.time('buildAxesView_determine');
            $8e1d1b12d8439742$var$createOrUpdateAxesView(gridRect, axesMap, (0, $6a439e51dccdc432$export$31cba7db0a663292).determine, null, noPxChange, layoutRef);
        // console.timeEnd('buildAxesView_determine');
        } // End of beforeDataProcessing
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._coordsList, function(coord) {
            // Calculate affine matrix to accelerate the data to point transform.
            // If all the axes scales are time or value.
            coord.calcAffineTransform();
        });
    };
    Grid.prototype.getAxis = function(dim, axisIndex) {
        var axesMapOnDim = this._axesMap[dim];
        if (axesMapOnDim != null) return axesMapOnDim[axisIndex || 0];
    };
    Grid.prototype.getAxes = function() {
        return this._axesList.slice();
    };
    Grid.prototype.getCartesian = function(xAxisIndex, yAxisIndex) {
        if (xAxisIndex != null && yAxisIndex != null) {
            var key = "x" + xAxisIndex + "y" + yAxisIndex;
            return this._coordsMap[key];
        }
        if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(xAxisIndex)) {
            yAxisIndex = xAxisIndex.yAxisIndex;
            xAxisIndex = xAxisIndex.xAxisIndex;
        }
        for(var i = 0, coordList = this._coordsList; i < coordList.length; i++){
            if (coordList[i].getAxis("x").index === xAxisIndex || coordList[i].getAxis("y").index === yAxisIndex) return coordList[i];
        }
    };
    Grid.prototype.getCartesians = function() {
        return this._coordsList.slice();
    };
    /**
   * @implements
   */ Grid.prototype.convertToPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
    };
    /**
   * @implements
   */ Grid.prototype.convertFromPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
    };
    Grid.prototype._findConvertTarget = function(finder) {
        var seriesModel = finder.seriesModel;
        var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents("xAxis", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents("yAxis", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        var gridModel = finder.gridModel;
        var coordsList = this._coordsList;
        var cartesian;
        var axis;
        if (seriesModel) {
            cartesian = seriesModel.coordinateSystem;
            (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(coordsList, cartesian) < 0 && (cartesian = null);
        } else if (xAxisModel && yAxisModel) cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
        else if (xAxisModel) axis = this.getAxis("x", xAxisModel.componentIndex);
        else if (yAxisModel) axis = this.getAxis("y", yAxisModel.componentIndex);
        else if (gridModel) {
            var grid = gridModel.coordinateSystem;
            if (grid === this) cartesian = this._coordsList[0];
        }
        return {
            cartesian: cartesian,
            axis: axis
        };
    };
    /**
   * @implements
   */ Grid.prototype.containPoint = function(point) {
        var coord = this._coordsList[0];
        if (coord) return coord.containPoint(point);
    };
    /**
   * Initialize cartesian coordinate systems
   */ Grid.prototype._initCartesian = function(gridModel, ecModel, api) {
        var _this = this;
        var grid = this;
        var axisPositionUsed = {
            left: false,
            right: false,
            top: false,
            bottom: false
        };
        var axesMap = {
            x: {},
            y: {}
        };
        var axesCount = {
            x: 0,
            y: 0
        };
        // Create axis
        ecModel.eachComponent("xAxis", createAxisCreator("x"), this);
        ecModel.eachComponent("yAxis", createAxisCreator("y"), this);
        if (!axesCount.x || !axesCount.y) {
            // Roll back when there no either x or y axis
            this._axesMap = {};
            this._axesList = [];
            return;
        }
        this._axesMap = axesMap;
        // Create cartesian2d
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesMap.x, function(xAxis, xAxisIndex) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesMap.y, function(yAxis, yAxisIndex) {
                var key = "x" + xAxisIndex + "y" + yAxisIndex;
                var cartesian = new (0, $6bea838ef63ff2bb$export$2e2bcd8739ae039)(key);
                cartesian.master = _this;
                cartesian.model = gridModel;
                _this._coordsMap[key] = cartesian;
                _this._coordsList.push(cartesian);
                cartesian.addAxis(xAxis);
                cartesian.addAxis(yAxis);
            });
        });
        function createAxisCreator(dimName) {
            return function(axisModel, idx) {
                if (!$8e1d1b12d8439742$var$isAxisUsedInTheGrid(axisModel, gridModel)) return;
                var axisPosition = axisModel.get("position");
                if (dimName === "x") // Fix position
                {
                    if (axisPosition !== "top" && axisPosition !== "bottom") // Default bottom of X
                    axisPosition = axisPositionUsed.bottom ? "top" : "bottom";
                } else // Fix position
                if (axisPosition !== "left" && axisPosition !== "right") // Default left of Y
                axisPosition = axisPositionUsed.left ? "right" : "left";
                axisPositionUsed[axisPosition] = true;
                var axis = new (0, $23369073c2236a8d$export$2e2bcd8739ae039)(dimName, (0, $2d646e51cc34f840$export$8941c4cacdc8f5a5)(axisModel), [
                    0,
                    0
                ], axisModel.get("type"), axisPosition);
                var isCategory = axis.type === "category";
                axis.onBand = isCategory && axisModel.get("boundaryGap");
                axis.inverse = axisModel.get("inverse");
                // Inject axis into axisModel
                axisModel.axis = axis;
                // Inject axisModel into axis
                axis.model = axisModel;
                // Inject grid info axis
                axis.grid = grid;
                // Index of axis, can be used as key
                axis.index = idx;
                grid._axesList.push(axis);
                axesMap[dimName][idx] = axis;
                axesCount[dimName]++;
            };
        }
    };
    /**
   * Update cartesian properties from series.
   */ Grid.prototype._updateScale = function(ecModel, gridModel) {
        // Reset scale
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._axesList, function(axis) {
            axis.scale.setExtent(Infinity, -Infinity);
            if (axis.type === "category") {
                var categorySortInfo = axis.model.get("categorySortInfo");
                axis.scale.setSortInfo(categorySortInfo);
            }
        });
        ecModel.eachSeries(function(seriesModel) {
            // If pie (or other similar series) use cartesian2d, the unionExtent logic below is
            // wrong, therefore skip it temporarily. See also in `defaultAxisExtentFromData.ts`.
            // TODO: support union extent in this case.
            if ((0, $88c937c9bc0ca068$export$e447722773749af)(seriesModel)) {
                var axesModelMap = (0, $88c937c9bc0ca068$export$8220131ac1d61d28)(seriesModel);
                var xAxisModel = axesModelMap.xAxisModel;
                var yAxisModel = axesModelMap.yAxisModel;
                if (!$8e1d1b12d8439742$var$isAxisUsedInTheGrid(xAxisModel, gridModel) || !$8e1d1b12d8439742$var$isAxisUsedInTheGrid(yAxisModel, gridModel)) return;
                var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
                var data = seriesModel.getData();
                var xAxis = cartesian.getAxis("x");
                var yAxis = cartesian.getAxis("y");
                unionExtent(data, xAxis);
                unionExtent(data, yAxis);
            }
        }, this);
        function unionExtent(data, axis) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $2d646e51cc34f840$export$e4cf30b1e74cd69d)(data, axis.dim), function(dim) {
                axis.scale.unionExtentFromData(data, dim);
            });
        }
    };
    /**
   * @param dim 'x' or 'y' or 'auto' or null/undefined
   */ Grid.prototype.getTooltipAxes = function(dim) {
        var baseAxes = [];
        var otherAxes = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this.getCartesians(), function(cartesian) {
            var baseAxis = dim != null && dim !== "auto" ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
            var otherAxis = cartesian.getOtherAxis(baseAxis);
            (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
            (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
        });
        return {
            baseAxes: baseAxes,
            otherAxes: otherAxes
        };
    };
    Grid.create = function(ecModel, api) {
        var grids = [];
        ecModel.eachComponent("grid", function(gridModel, idx) {
            var grid = new Grid(gridModel, ecModel, api);
            grid.name = "grid_" + idx;
            // dataSampling requires axis extent, so resize
            // should be performed in create stage.
            grid.resize(gridModel, api, true);
            gridModel.coordinateSystem = grid;
            grids.push(grid);
        });
        // Inject the coordinateSystems into seriesModel
        ecModel.eachSeries(function(seriesModel) {
            (0, $70c3ede7d3b64757$export$7ed0c09d4f5c932e)({
                targetModel: seriesModel,
                coordSysType: "cartesian2d",
                coordSysProvider: coordSysProvider
            });
            function coordSysProvider() {
                var axesModelMap = (0, $88c937c9bc0ca068$export$8220131ac1d61d28)(seriesModel);
                var xAxisModel = axesModelMap.xAxisModel;
                var yAxisModel = axesModelMap.yAxisModel;
                var gridModel = xAxisModel.getCoordSysModel();
                var grid = gridModel.coordinateSystem;
                return grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
            }
        });
        return grids;
    };
    // For deciding which dimensions to use when creating list data
    Grid.dimensions = (0, $6bea838ef63ff2bb$export$988a008d2b9120f4);
    return Grid;
}();
/**
 * Check if the axis is used in the specified grid.
 */ function $8e1d1b12d8439742$var$isAxisUsedInTheGrid(axisModel, gridModel) {
    return axisModel.getCoordSysModel() === gridModel;
}
function $8e1d1b12d8439742$var$fixAxisOnZero(axesMap, otherAxisDim, axis, // Key: see `getOnZeroRecordKey`
onZeroRecords) {
    axis.getAxesOnZeroOf = function() {
        // TODO: onZero of multiple axes.
        return otherAxisOnZeroOf ? [
            otherAxisOnZeroOf
        ] : [];
    };
    // onZero can not be enabled in these two situations:
    // 1. When any other axis is a category axis.
    // 2. When no axis is cross 0 point.
    var otherAxes = axesMap[otherAxisDim];
    var otherAxisOnZeroOf;
    var axisModel = axis.model;
    var onZero = axisModel.get([
        "axisLine",
        "onZero"
    ]);
    var onZeroAxisIndex = axisModel.get([
        "axisLine",
        "onZeroAxisIndex"
    ]);
    if (!onZero) return;
    // If target axis is specified.
    if (onZeroAxisIndex != null) {
        if ($8e1d1b12d8439742$var$canOnZeroToAxis(otherAxes[onZeroAxisIndex])) otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
    } else {
        // Find the first available other axis.
        for(var idx in otherAxes)if (otherAxes.hasOwnProperty(idx) && $8e1d1b12d8439742$var$canOnZeroToAxis(otherAxes[idx]) && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
            otherAxisOnZeroOf = otherAxes[idx];
            break;
        }
    }
    if (otherAxisOnZeroOf) onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
    function getOnZeroRecordKey(axis) {
        return axis.dim + "_" + axis.index;
    }
}
function $8e1d1b12d8439742$var$canOnZeroToAxis(axis) {
    return axis && axis.type !== "category" && axis.type !== "time" && (0, $2d646e51cc34f840$export$3eac36a69f37d52)(axis);
}
function $8e1d1b12d8439742$var$updateAxisTransform(axis, coordBase) {
    var axisExtent = axis.getExtent();
    var axisExtentSum = axisExtent[0] + axisExtent[1];
    // Fast transform
    axis.toGlobalCoord = axis.dim === "x" ? function(coord) {
        return coord + coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
    axis.toLocalCoord = axis.dim === "x" ? function(coord) {
        return coord - coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
}
function $8e1d1b12d8439742$var$updateAllAxisExtentTransByGridRect(axesMap, gridRect) {
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesMap.x, function(axis) {
        return $8e1d1b12d8439742$var$updateAxisExtentTransByGridRect(axis, gridRect.x, gridRect.width);
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesMap.y, function(axis) {
        return $8e1d1b12d8439742$var$updateAxisExtentTransByGridRect(axis, gridRect.y, gridRect.height);
    });
}
function $8e1d1b12d8439742$var$updateAxisExtentTransByGridRect(axis, gridXY, gridWH) {
    var extent = [
        0,
        gridWH
    ];
    var idx = axis.inverse ? 1 : 0;
    axis.setExtent(extent[idx], extent[1 - idx]);
    $8e1d1b12d8439742$var$updateAxisTransform(axis, gridXY);
}
var $8e1d1b12d8439742$var$legacyLayOutGridByContainLabel;
function $8e1d1b12d8439742$export$9da5287b2e41f334(impl) {
    $8e1d1b12d8439742$var$legacyLayOutGridByContainLabel = impl;
}
// Return noPxChange.
function $8e1d1b12d8439742$var$layOutGridByOuterBounds(outerBoundsRect, outerBoundsContain, outerBoundsClamp, gridRect, axesMap, axisBuilderSharedCtx, layoutRef) {
    // Assume `updateAllAxisExtentTransByGridRect` has been performed once before this call.
    // [NOTE]:
    // - The bounding rect of the axis elements might be sensitve to variations in `axis.extent` due to strategies
    //  like hideOverlap/moveOverlap. @see the comment in `LabelLayoutBase['suggestIgnore']`.
    // - The final `gridRect` might be slightly smaller than the ideally expected result if labels are giant and
    //  get hidden due to overlapping. More iterations could improve precision, but not performant. We consider
    //  the current result acceptable, since no alignment among charts can be guaranteed when using this feature.
    $8e1d1b12d8439742$var$createOrUpdateAxesView(gridRect, axesMap, (0, $6a439e51dccdc432$export$31cba7db0a663292).estimate, outerBoundsContain, false, layoutRef);
    var margin = [
        0,
        0,
        0,
        0
    ];
    fillLabelNameOverflowOnOneDimension(0);
    fillLabelNameOverflowOnOneDimension(1);
    // If axis is blank, no label can be used to detect overflow.
    // gridRect itself should not overflow.
    fillMarginOnOneDimension(gridRect, 0, NaN);
    fillMarginOnOneDimension(gridRect, 1, NaN);
    var noPxChange = (0, $7a1bd9c2710fea0d$export$71aa6c912b956294)(margin, function(item) {
        return item > 0;
    }) == null;
    (0, $5b455ae6f843ac47$export$81ed941fdeb91c7c)(gridRect, margin, true, true, outerBoundsClamp);
    $8e1d1b12d8439742$var$updateAllAxisExtentTransByGridRect(axesMap, gridRect);
    return noPxChange;
    function fillLabelNameOverflowOnOneDimension(xyIdx) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesMap[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[xyIdx]], function(axis) {
            if (!(0, $2d646e51cc34f840$export$75b737736393e03c)(axis.model)) return;
            // FIXME: zr Group.union may wrongly union (0, 0, 0, 0) and not performant.
            // unionRect.union(axis.axisBuilder.group.getBoundingRect());
            // If ussing Group.getBoundingRect to calculate shrink space, it is not strictly accurate when
            // the outermost label is ignored and the secondary label is very long and contribute to the
            // union extension:
            //      -|---|---|---|
            //         1,000,000,000
            // Therefore we calculate them one by one.
            // Also considered axis may be blank or no labels.
            var sharedRecord = axisBuilderSharedCtx.ensureRecord(axis.model);
            var labelInfoList = sharedRecord.labelInfoList;
            if (labelInfoList) for(var idx = 0; idx < labelInfoList.length; idx++){
                var labelInfo = labelInfoList[idx];
                var proportion = axis.scale.normalize((0, $dfe15f745e1c3c2b$export$c392b818a26a879e)(labelInfo.label).tickValue);
                proportion = xyIdx === 1 ? 1 - proportion : proportion;
                // xAxis use proportion on x, yAxis use proprotion on y, otherwise not.
                fillMarginOnOneDimension(labelInfo.rect, xyIdx, proportion);
                fillMarginOnOneDimension(labelInfo.rect, 1 - xyIdx, NaN);
            }
            var nameLayout = sharedRecord.nameLayout;
            if (nameLayout) {
                var proportion = (0, $2d646e51cc34f840$export$c06aa22293dea9d2)(sharedRecord.nameLocation) ? 0.5 : NaN;
                fillMarginOnOneDimension(nameLayout.rect, xyIdx, proportion);
                fillMarginOnOneDimension(nameLayout.rect, 1 - xyIdx, NaN);
            }
        });
    }
    function fillMarginOnOneDimension(itemRect, xyIdx, proportion // NaN mean no use proportion
    ) {
        var overflow1 = outerBoundsRect[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[xyIdx]] - itemRect[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[xyIdx]];
        var overflow2 = itemRect[(0, $5b455ae6f843ac47$export$a3fe6d967173a3ac)[xyIdx]] + itemRect[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[xyIdx]] - (outerBoundsRect[(0, $5b455ae6f843ac47$export$a3fe6d967173a3ac)[xyIdx]] + outerBoundsRect[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[xyIdx]]);
        overflow1 = applyProportion(overflow1, 1 - proportion);
        overflow2 = applyProportion(overflow2, proportion);
        var minIdx = $8e1d1b12d8439742$var$XY_TO_MARGIN_IDX[xyIdx][0];
        var maxIdx = $8e1d1b12d8439742$var$XY_TO_MARGIN_IDX[xyIdx][1];
        margin[minIdx] = (0, $cfc1f3b422a3185f$export$2ca8010d037f830f)(margin[minIdx], overflow1);
        margin[maxIdx] = (0, $cfc1f3b422a3185f$export$2ca8010d037f830f)(margin[maxIdx], overflow2);
    }
    function applyProportion(overflow, proportion) {
        // proportion is not likely to near zero. If so, give up shrink
        if (overflow > 0 && !(0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(proportion) && proportion > 1e-4) overflow /= proportion;
        return overflow;
    }
}
function $8e1d1b12d8439742$var$createAxisBiulders(gridRect, cartesians, axesMap, optionContainLabel, api) {
    var axisBuilderSharedCtx = new (0, $dfe15f745e1c3c2b$export$f2e237206f7393f5)($8e1d1b12d8439742$var$resolveAxisNameOverlapForGrid);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesMap, function(axisList) {
        return (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisList, function(axis) {
            if ((0, $2d646e51cc34f840$export$75b737736393e03c)(axis.model)) {
                // See `AxisBaseOptionCommon['nameMoveOverlap']`.
                var defaultNameMoveOverlap = !optionContainLabel;
                axis.axisBuilder = (0, $88c937c9bc0ca068$export$2b2ce820c3e1e776)(gridRect, cartesians, axis.model, api, axisBuilderSharedCtx, defaultNameMoveOverlap);
            }
        });
    });
    return axisBuilderSharedCtx;
}
/**
 * Promote the axis-elements-building from "view render" stage to "coordinate system resize" stage.
 * This is aimed to resovle overlap across multiple axes, since currently it's hard to reconcile
 * multiple axes in "view render" stage.
 *
 * [CAUTION] But this promotion assumes that the subsequent "visual mapping" stage does not affect
 * this axis-elements-building; otherwise we have to refactor it again.
 */ function $8e1d1b12d8439742$var$createOrUpdateAxesView(gridRect, axesMap, kind, outerBoundsContain, noPxChange, layoutRef) {
    var isDetermine = kind === (0, $6a439e51dccdc432$export$31cba7db0a663292).determine;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesMap, function(axisList) {
        return (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisList, function(axis) {
            if ((0, $2d646e51cc34f840$export$75b737736393e03c)(axis.model)) {
                (0, $88c937c9bc0ca068$export$3e8d41f03e1a6a39)(axis.axisBuilder, gridRect, axis.model);
                axis.axisBuilder.build(isDetermine ? {
                    axisTickLabelDetermine: true
                } : {
                    axisTickLabelEstimate: true
                }, {
                    noPxChange: noPxChange
                });
            }
        });
    });
    var nameMarginLevelMap = {
        x: 0,
        y: 0
    };
    calcNameMarginLevel(0);
    calcNameMarginLevel(1);
    function calcNameMarginLevel(xyIdx) {
        nameMarginLevelMap[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[1 - xyIdx]] = gridRect[(0, $5b455ae6f843ac47$export$a3fe6d967173a3ac)[xyIdx]] <= layoutRef.refContainer[(0, $5b455ae6f843ac47$export$a3fe6d967173a3ac)[xyIdx]] * 0.5 ? 0 : 1 - xyIdx === 1 ? 2 : 1;
    }
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesMap, function(axisList, xy) {
        return (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisList, function(axis) {
            if ((0, $2d646e51cc34f840$export$75b737736393e03c)(axis.model)) {
                if (outerBoundsContain === "all" || isDetermine) // To resolve overlap, `axisName` layout depends on `axisTickLabel` layout result
                // (all of the axes of the same `grid`; consider multiple x or y axes).
                axis.axisBuilder.build({
                    axisName: true
                }, {
                    nameMarginLevel: nameMarginLevelMap[xy]
                });
                if (isDetermine) axis.axisBuilder.build({
                    axisLine: true
                });
            }
        });
    });
}
function $8e1d1b12d8439742$var$prepareOuterBounds(gridModel, rawRridRect, layoutRef) {
    var outerBoundsRect;
    var optionOuterBoundsMode = gridModel.get("outerBoundsMode", true);
    if (optionOuterBoundsMode === "same") outerBoundsRect = rawRridRect.clone();
    else if (optionOuterBoundsMode == null || optionOuterBoundsMode === "auto") outerBoundsRect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(gridModel.get("outerBounds", true) || (0, $d67c268180aaad04$export$57b4bb4ff2a0950c), layoutRef.refContainer);
    else optionOuterBoundsMode;
    var optionOuterBoundsContain = gridModel.get("outerBoundsContain", true);
    var parsedOuterBoundsContain;
    if (optionOuterBoundsContain == null || optionOuterBoundsContain === "auto") parsedOuterBoundsContain = "all";
    else if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)([
        "all",
        "axisLabel"
    ], optionOuterBoundsContain) < 0) parsedOuterBoundsContain = "all";
    else parsedOuterBoundsContain = optionOuterBoundsContain;
    var outerBoundsClamp = [
        (0, $cfc1f3b422a3185f$export$6b392db7c2374a1a)((0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(gridModel.get("outerBoundsClampWidth", true), (0, $d67c268180aaad04$export$e78e6bf4dcc3e485)[0]), rawRridRect.width),
        (0, $cfc1f3b422a3185f$export$6b392db7c2374a1a)((0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(gridModel.get("outerBoundsClampHeight", true), (0, $d67c268180aaad04$export$e78e6bf4dcc3e485)[1]), rawRridRect.height)
    ];
    return {
        outerBoundsRect: outerBoundsRect,
        parsedOuterBoundsContain: parsedOuterBoundsContain,
        outerBoundsClamp: outerBoundsClamp
    };
}
var $8e1d1b12d8439742$var$resolveAxisNameOverlapForGrid = function(cfg, ctx, axisModel, nameLayoutInfo, nameMoveDirVec, thisRecord) {
    var perpendicularDim = axisModel.axis.dim === "x" ? "y" : "x";
    (0, $dfe15f745e1c3c2b$export$7fcb8742f5816cae)(cfg, ctx, axisModel, nameLayoutInfo, nameMoveDirVec, thisRecord);
    // If nameLocation 'center', and there are multiple axes parallel to this axis, do not adjust by
    //  other axes, because the axis name should be close to its axis line as much as possible even
    //  if overlapping; otherwise it might cause misleading.
    // If nameLocation 'center', do not adjust by perpendicular axes, since they are not likely to overlap.
    // If nameLocation 'start'/'end', move name within the same direction to escape overlap with the
    //  perpendicular axes.
    if (!(0, $2d646e51cc34f840$export$c06aa22293dea9d2)(cfg.nameLocation)) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ctx.recordMap[perpendicularDim], function(perpenRecord) {
        // perpendicular axis may be no name.
        if (perpenRecord && perpenRecord.labelInfoList && perpenRecord.dirVec) (0, $dfe15f745e1c3c2b$export$e033c6449cc6f6a1)(perpenRecord.labelInfoList, perpenRecord.dirVec, nameLayoutInfo, nameMoveDirVec);
    });
};
var $8e1d1b12d8439742$export$2e2bcd8739ae039 = $8e1d1b12d8439742$var$Grid;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $84d826b9ba8bf009$export$bb44f104e3c54dae(ecModel, api) {
    var result = {
        /**
     * key: makeKey(axis.model)
     * value: {
     *      axis,
     *      coordSys,
     *      axisPointerModel,
     *      triggerTooltip,
     *      triggerEmphasis,
     *      involveSeries,
     *      snap,
     *      seriesModels,
     *      seriesDataCount
     * }
     */ axesInfo: {},
        seriesInvolved: false,
        /**
     * key: makeKey(coordSys.model)
     * value: Object: key makeKey(axis.model), value: axisInfo
     */ coordSysAxesInfo: {},
        coordSysMap: {}
    };
    $84d826b9ba8bf009$var$collectAxesInfo(result, ecModel, api);
    // Check seriesInvolved for performance, in case too many series in some chart.
    result.seriesInvolved && $84d826b9ba8bf009$var$collectSeriesInfo(result, ecModel);
    return result;
}
function $84d826b9ba8bf009$var$collectAxesInfo(result, ecModel, api) {
    var globalTooltipModel = ecModel.getComponent("tooltip");
    var globalAxisPointerModel = ecModel.getComponent("axisPointer");
    // links can only be set on global.
    var linksOption = globalAxisPointerModel.get("link", true) || [];
    var linkGroups = [];
    // Collect axes info.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(api.getCoordinateSystems(), function(coordSys) {
        // Some coordinate system do not support axes, like geo.
        if (!coordSys.axisPointerEnabled) return;
        var coordSysKey = $84d826b9ba8bf009$export$d01b444bafb1a792(coordSys.model);
        var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
        result.coordSysMap[coordSysKey] = coordSys;
        // Set tooltip (like 'cross') is a convenient way to show axisPointer
        // for user. So we enable setting tooltip on coordSys model.
        var coordSysModel = coordSys.model;
        var baseTooltipModel = coordSysModel.getModel("tooltip", globalTooltipModel);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordSys.getAxes(), (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)(saveTooltipAxisInfo, false, null));
        // If axis tooltip used, choose tooltip axis for each coordSys.
        // Notice this case: coordSys is `grid` but not `cartesian2D` here.
        if (coordSys.getTooltipAxes && globalTooltipModel && baseTooltipModel.get("show")) {
            // Compatible with previous logic. But series.tooltip.trigger: 'axis'
            // or series.data[n].tooltip.trigger: 'axis' are not support any more.
            var triggerAxis = baseTooltipModel.get("trigger") === "axis";
            var cross = baseTooltipModel.get([
                "axisPointer",
                "type"
            ]) === "cross";
            var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get([
                "axisPointer",
                "axis"
            ]));
            if (triggerAxis || cross) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(tooltipAxes.baseAxes, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)(saveTooltipAxisInfo, cross ? "cross" : true, triggerAxis));
            if (cross) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(tooltipAxes.otherAxes, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)(saveTooltipAxisInfo, "cross", false));
        }
        // fromTooltip: true | false | 'cross'
        // triggerTooltip: true | false | null
        function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
            var axisPointerModel = axis.model.getModel("axisPointer", globalAxisPointerModel);
            var axisPointerShow = axisPointerModel.get("show");
            if (!axisPointerShow || axisPointerShow === "auto" && !fromTooltip && !$84d826b9ba8bf009$var$isHandleTrigger(axisPointerModel)) return;
            if (triggerTooltip == null) triggerTooltip = axisPointerModel.get("triggerTooltip");
            axisPointerModel = fromTooltip ? $84d826b9ba8bf009$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
            var snap = axisPointerModel.get("snap");
            var triggerEmphasis = axisPointerModel.get("triggerEmphasis");
            var axisKey = $84d826b9ba8bf009$export$d01b444bafb1a792(axis.model);
            var involveSeries = triggerTooltip || snap || axis.type === "category";
            // If result.axesInfo[key] exist, override it (tooltip has higher priority).
            var axisInfo = result.axesInfo[axisKey] = {
                key: axisKey,
                axis: axis,
                coordSys: coordSys,
                axisPointerModel: axisPointerModel,
                triggerTooltip: triggerTooltip,
                triggerEmphasis: triggerEmphasis,
                involveSeries: involveSeries,
                snap: snap,
                useHandle: $84d826b9ba8bf009$var$isHandleTrigger(axisPointerModel),
                seriesModels: [],
                linkGroup: null
            };
            axesInfoInCoordSys[axisKey] = axisInfo;
            result.seriesInvolved = result.seriesInvolved || involveSeries;
            var groupIndex = $84d826b9ba8bf009$var$getLinkGroupIndex(linksOption, axis);
            if (groupIndex != null) {
                var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
                    axesInfo: {}
                });
                linkGroup.axesInfo[axisKey] = axisInfo;
                linkGroup.mapper = linksOption[groupIndex].mapper;
                axisInfo.linkGroup = linkGroup;
            }
        }
    });
}
function $84d826b9ba8bf009$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
    var tooltipAxisPointerModel = baseTooltipModel.getModel("axisPointer");
    var fields = [
        "type",
        "snap",
        "lineStyle",
        "shadowStyle",
        "label",
        "animation",
        "animationDurationUpdate",
        "animationEasingUpdate",
        "z"
    ];
    var volatileOption = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(fields, function(field) {
        volatileOption[field] = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(tooltipAxisPointerModel.get(field));
    });
    // category axis do not auto snap, otherwise some tick that do not
    // has value can not be hovered. value/time/log axis default snap if
    // triggered from tooltip and trigger tooltip.
    volatileOption.snap = axis.type !== "category" && !!triggerTooltip;
    // Compatible with previous behavior, tooltip axis does not show label by default.
    // Only these properties can be overridden from tooltip to axisPointer.
    if (tooltipAxisPointerModel.get("type") === "cross") volatileOption.type = "line";
    var labelOption = volatileOption.label || (volatileOption.label = {});
    // Follow the convention, do not show label when triggered by tooltip by default.
    labelOption.show == null && (labelOption.show = false);
    if (fromTooltip === "cross") {
        // When 'cross', both axes show labels.
        var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get([
            "label",
            "show"
        ]);
        labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true;
        // If triggerTooltip, this is a base axis, which should better not use cross style
        // (cross style is dashed by default)
        if (!triggerTooltip) {
            var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get("crossStyle");
            crossStyle && (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(labelOption, crossStyle.textStyle);
        }
    }
    return axis.model.getModel("axisPointer", new (0, $6818646a97528290$export$2e2bcd8739ae039)(volatileOption, globalAxisPointerModel, ecModel));
}
function $84d826b9ba8bf009$var$collectSeriesInfo(result, ecModel) {
    // Prepare data for axis trigger
    ecModel.eachSeries(function(seriesModel) {
        // Notice this case: this coordSys is `cartesian2D` but not `grid`.
        var coordSys = seriesModel.coordinateSystem;
        var seriesTooltipTrigger = seriesModel.get([
            "tooltip",
            "trigger"
        ], true);
        var seriesTooltipShow = seriesModel.get([
            "tooltip",
            "show"
        ], true);
        if (!coordSys || !coordSys.model // PENDING: radar do not have a model.
         || seriesTooltipTrigger === "none" || seriesTooltipTrigger === false || seriesTooltipTrigger === "item" || seriesTooltipShow === false || seriesModel.get([
            "axisPointer",
            "show"
        ], true) === false) return;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(result.coordSysAxesInfo[$84d826b9ba8bf009$export$d01b444bafb1a792(coordSys.model)], function(axisInfo) {
            var axis = axisInfo.axis;
            if (coordSys.getAxis(axis.dim) === axis) {
                axisInfo.seriesModels.push(seriesModel);
                axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
                axisInfo.seriesDataCount += seriesModel.getData().count();
            }
        });
    });
}
/**
 * For example:
 * {
 *     axisPointer: {
 *         links: [{
 *             xAxisIndex: [2, 4],
 *             yAxisIndex: 'all'
 *         }, {
 *             xAxisId: ['a5', 'a7'],
 *             xAxisName: 'xxx'
 *         }]
 *     }
 * }
 */ function $84d826b9ba8bf009$var$getLinkGroupIndex(linksOption, axis) {
    var axisModel = axis.model;
    var dim = axis.dim;
    for(var i = 0; i < linksOption.length; i++){
        var linkOption = linksOption[i] || {};
        if ($84d826b9ba8bf009$var$checkPropInLink(linkOption[dim + "AxisId"], axisModel.id) || $84d826b9ba8bf009$var$checkPropInLink(linkOption[dim + "AxisIndex"], axisModel.componentIndex) || $84d826b9ba8bf009$var$checkPropInLink(linkOption[dim + "AxisName"], axisModel.name)) return i;
    }
}
function $84d826b9ba8bf009$var$checkPropInLink(linkPropValue, axisPropValue) {
    return linkPropValue === "all" || (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(linkPropValue) && (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
}
function $84d826b9ba8bf009$export$f5ea32e3629d8043(axisModel) {
    var axisInfo = $84d826b9ba8bf009$export$bd39458db76002ab(axisModel);
    if (!axisInfo) return;
    var axisPointerModel = axisInfo.axisPointerModel;
    var scale = axisInfo.axis.scale;
    var option = axisPointerModel.option;
    var status = axisPointerModel.get("status");
    var value = axisPointerModel.get("value");
    // Parse init value for category and time axis.
    if (value != null) value = scale.parse(value);
    var useHandle = $84d826b9ba8bf009$var$isHandleTrigger(axisPointerModel);
    // If `handle` used, `axisPointer` will always be displayed, so value
    // and status should be initialized.
    if (status == null) option.status = useHandle ? "show" : "hide";
    var extent = scale.getExtent().slice();
    extent[0] > extent[1] && extent.reverse();
    if (// Pick a value on axis when initializing.
    value == null || value > extent[1]) // Make handle displayed on the end of the axis when init, which looks better.
    value = extent[1];
    if (value < extent[0]) value = extent[0];
    option.value = value;
    if (useHandle) option.status = axisInfo.axis.scale.isBlank() ? "hide" : "show";
}
function $84d826b9ba8bf009$export$bd39458db76002ab(axisModel) {
    var coordSysAxesInfo = (axisModel.ecModel.getComponent("axisPointer") || {}).coordSysAxesInfo;
    return coordSysAxesInfo && coordSysAxesInfo.axesInfo[$84d826b9ba8bf009$export$d01b444bafb1a792(axisModel)];
}
function $84d826b9ba8bf009$export$3b06fce3f68b734(axisModel) {
    var axisInfo = $84d826b9ba8bf009$export$bd39458db76002ab(axisModel);
    return axisInfo && axisInfo.axisPointerModel;
}
function $84d826b9ba8bf009$var$isHandleTrigger(axisPointerModel) {
    return !!axisPointerModel.get([
        "handle",
        "show"
    ]);
}
function $84d826b9ba8bf009$export$d01b444bafb1a792(model) {
    return model.type + "||" + model.id;
}



var $58c48a3ef1aa0746$var$axisPointerClazz = {};
/**
 * Base class of AxisView.
 */ var $58c48a3ef1aa0746$var$AxisView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(AxisView, _super);
    function AxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisView.type;
        return _this;
    }
    /**
   * @override
   */ AxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        // FIXME
        // This process should proformed after coordinate systems updated
        // (axis scale updated), and should be performed each time update.
        // So put it here temporarily, although it is not appropriate to
        // put a model-writing procedure in `view`.
        this.axisPointerClass && $84d826b9ba8bf009$export$f5ea32e3629d8043(axisModel);
        _super.prototype.render.apply(this, arguments);
        this._doUpdateAxisPointerClass(axisModel, api, true);
    };
    /**
   * Action handler.
   */ AxisView.prototype.updateAxisPointer = function(axisModel, ecModel, api, payload) {
        this._doUpdateAxisPointerClass(axisModel, api, false);
    };
    /**
   * @override
   */ AxisView.prototype.remove = function(ecModel, api) {
        var axisPointer = this._axisPointer;
        axisPointer && axisPointer.remove(api);
    };
    /**
   * @override
   */ AxisView.prototype.dispose = function(ecModel, api) {
        this._disposeAxisPointer(api);
        _super.prototype.dispose.apply(this, arguments);
    };
    AxisView.prototype._doUpdateAxisPointerClass = function(axisModel, api, forceRender) {
        var Clazz = AxisView.getAxisPointerClass(this.axisPointerClass);
        if (!Clazz) return;
        var axisPointerModel = $84d826b9ba8bf009$export$3b06fce3f68b734(axisModel);
        axisPointerModel ? (this._axisPointer || (this._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : this._disposeAxisPointer(api);
    };
    AxisView.prototype._disposeAxisPointer = function(api) {
        this._axisPointer && this._axisPointer.dispose(api);
        this._axisPointer = null;
    };
    AxisView.registerAxisPointerClass = function(type, clazz) {
        $58c48a3ef1aa0746$var$axisPointerClazz[type] = clazz;
    };
    AxisView.getAxisPointerClass = function(type) {
        return type && $58c48a3ef1aa0746$var$axisPointerClazz[type];
    };
    AxisView.type = "axis";
    return AxisView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $58c48a3ef1aa0746$export$2e2bcd8739ae039 = $58c48a3ef1aa0746$var$AxisView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $ff3096b1f24c33b6$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $ff3096b1f24c33b6$export$c80b7ef1527ec8c9(axisView, axisGroup, axisModel, gridModel) {
    var axis = axisModel.axis;
    if (axis.scale.isBlank()) return;
    // TODO: TYPE
    var splitAreaModel = axisModel.getModel("splitArea");
    var areaStyleModel = splitAreaModel.getModel("areaStyle");
    var areaColors = areaStyleModel.get("color");
    var gridRect = gridModel.coordinateSystem.getRect();
    var ticksCoords = axis.getTicksCoords({
        tickModel: splitAreaModel,
        clamp: true,
        breakTicks: "none",
        pruneByBreak: "preserve_extent_bound"
    });
    if (!ticksCoords.length) return;
    // For Making appropriate splitArea animation, the color and anid
    // should be corresponding to previous one if possible.
    var areaColorsLen = areaColors.length;
    var lastSplitAreaColors = $ff3096b1f24c33b6$var$inner(axisView).splitAreaColors;
    var newSplitAreaColors = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
    var colorIndex = 0;
    if (lastSplitAreaColors) for(var i = 0; i < ticksCoords.length; i++){
        var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);
        if (cIndex != null) {
            colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
            break;
        }
    }
    var prev = axis.toGlobalCoord(ticksCoords[0].coord);
    var areaStyle = areaStyleModel.getAreaStyle();
    areaColors = $7a1bd9c2710fea0d$export$43bee75e5e14138e(areaColors) ? areaColors : [
        areaColors
    ];
    for(var i = 1; i < ticksCoords.length; i++){
        var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
        var x = void 0;
        var y = void 0;
        var width = void 0;
        var height = void 0;
        if (axis.isHorizontal()) {
            x = prev;
            y = gridRect.y;
            width = tickCoord - x;
            height = gridRect.height;
            prev = x + width;
        } else {
            x = gridRect.x;
            y = prev;
            width = gridRect.width;
            height = tickCoord - y;
            prev = y + height;
        }
        var tickValue = ticksCoords[i - 1].tickValue;
        tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
        axisGroup.add(new $419e5ff2f303755e$export$2e2bcd8739ae039({
            anid: tickValue != null ? "area_" + tickValue : null,
            shape: {
                x: x,
                y: y,
                width: width,
                height: height
            },
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                fill: areaColors[colorIndex]
            }, areaStyle),
            autoBatch: true,
            silent: true
        }));
        colorIndex = (colorIndex + 1) % areaColorsLen;
    }
    $ff3096b1f24c33b6$var$inner(axisView).splitAreaColors = newSplitAreaColors;
}
function $ff3096b1f24c33b6$export$48ebf2d6ce8ad076(axisView) {
    $ff3096b1f24c33b6$var$inner(axisView).splitAreaColors = null;
}




var $c87c0ba584696283$var$selfBuilderAttrs = [
    "splitArea",
    "splitLine",
    "minorSplitLine",
    "breakArea"
];
var $c87c0ba584696283$var$CartesianAxisView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CartesianAxisView, _super);
    function CartesianAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianAxisView.type;
        _this.axisPointerClass = "CartesianAxisPointer";
        return _this;
    }
    /**
   * @override
   */ CartesianAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        this.group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this.group.add(this._axisGroup);
        if (!(0, $2d646e51cc34f840$export$75b737736393e03c)(axisModel)) return;
        this._axisGroup.add(axisModel.axis.axisBuilder.group);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($c87c0ba584696283$var$selfBuilderAttrs, function(name) {
            if (axisModel.get([
                name,
                "show"
            ])) $c87c0ba584696283$var$axisElementBuilders[name](this, this._axisGroup, axisModel, axisModel.getCoordSysModel(), api);
        }, this);
        // THIS is a special case for bar racing chart.
        // Update the axis label from the natural initial layout to
        // sorted layout should has no animation.
        var isInitialSortFromBarRacing = payload && payload.type === "changeAxisOrder" && payload.isInitSort;
        if (!isInitialSortFromBarRacing) $5b455ae6f843ac47$export$64fcab7860c216ae(oldAxisGroup, this._axisGroup, axisModel);
        _super.prototype.render.call(this, axisModel, ecModel, api, payload);
    };
    CartesianAxisView.prototype.remove = function() {
        (0, $ff3096b1f24c33b6$export$48ebf2d6ce8ad076)(this);
    };
    CartesianAxisView.type = "cartesianAxis";
    return CartesianAxisView;
}((0, $58c48a3ef1aa0746$export$2e2bcd8739ae039));
var $c87c0ba584696283$var$axisElementBuilders = {
    splitLine: function(axisView, axisGroup, axisModel, gridModel, api) {
        var axis = axisModel.axis;
        if (axis.scale.isBlank()) return;
        var splitLineModel = axisModel.getModel("splitLine");
        var lineStyleModel = splitLineModel.getModel("lineStyle");
        var lineColors = lineStyleModel.get("color");
        var showMinLine = splitLineModel.get("showMinLine") !== false;
        var showMaxLine = splitLineModel.get("showMaxLine") !== false;
        lineColors = $7a1bd9c2710fea0d$export$43bee75e5e14138e(lineColors) ? lineColors : [
            lineColors
        ];
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var lineCount = 0;
        var ticksCoords = axis.getTicksCoords({
            tickModel: splitLineModel,
            breakTicks: "none",
            pruneByBreak: "preserve_extent_bound"
        });
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < ticksCoords.length; i++){
            var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
            if (i === 0 && !showMinLine || i === ticksCoords.length - 1 && !showMaxLine) continue;
            var tickValue = ticksCoords[i].tickValue;
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var colorIndex = lineCount++ % lineColors.length;
            var line = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
                anid: tickValue != null ? "line_" + tickValue : null,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                    stroke: lineColors[colorIndex]
                }, lineStyle),
                silent: true
            });
            $5b455ae6f843ac47$export$8b4b620d7f4aad1b(line.shape, lineStyle.lineWidth);
            axisGroup.add(line);
        }
    },
    minorSplitLine: function(axisView, axisGroup, axisModel, gridModel, api) {
        var axis = axisModel.axis;
        var minorSplitLineModel = axisModel.getModel("minorSplitLine");
        var lineStyleModel = minorSplitLineModel.getModel("lineStyle");
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var minorTicksCoords = axis.getMinorTicksCoords();
        if (!minorTicksCoords.length) return;
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < minorTicksCoords.length; i++)for(var k = 0; k < minorTicksCoords[i].length; k++){
            var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var line = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
                anid: "minor_line_" + minorTicksCoords[i][k].tickValue,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: lineStyle,
                silent: true
            });
            $5b455ae6f843ac47$export$8b4b620d7f4aad1b(line.shape, lineStyle.lineWidth);
            axisGroup.add(line);
        }
    },
    splitArea: function(axisView, axisGroup, axisModel, gridModel, api) {
        (0, $ff3096b1f24c33b6$export$c80b7ef1527ec8c9)(axisView, axisGroup, axisModel, gridModel);
    },
    breakArea: function(axisView, axisGroup, axisModel, gridModel, api) {
        var axisBreakHelper = (0, $0d1e9c0f651d5d16$export$c1d9b2cc33e7e5e)();
        var scale = axisModel.axis.scale;
        if (axisBreakHelper && scale.type !== "ordinal") axisBreakHelper.rectCoordBuildBreakAxis(axisGroup, axisView, axisModel, gridModel.coordinateSystem.getRect(), api);
    }
};
var $c87c0ba584696283$export$b6d40cd875b8a1c8 = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CartesianXAxisView, _super);
    function CartesianXAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianXAxisView.type;
        return _this;
    }
    CartesianXAxisView.type = "xAxis";
    return CartesianXAxisView;
}($c87c0ba584696283$var$CartesianAxisView);
var $c87c0ba584696283$export$417e1bdd0616e0dc = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CartesianYAxisView, _super);
    function CartesianYAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $c87c0ba584696283$export$b6d40cd875b8a1c8.type;
        return _this;
    }
    CartesianYAxisView.type = "yAxis";
    return CartesianYAxisView;
}($c87c0ba584696283$var$CartesianAxisView);
var $c87c0ba584696283$export$2e2bcd8739ae039 = $c87c0ba584696283$var$CartesianAxisView;


// Grid view
var $1021478d6a16b0aa$var$GridView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GridView, _super);
    function GridView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "grid";
        return _this;
    }
    GridView.prototype.render = function(gridModel, ecModel) {
        this.group.removeAll();
        if (gridModel.get("show")) this.group.add(new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
            shape: gridModel.coordinateSystem.getRect(),
            style: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                fill: gridModel.get("backgroundColor")
            }, gridModel.getItemStyle()),
            silent: true,
            z2: -1
        }));
    };
    GridView.type = "grid";
    return GridView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $1021478d6a16b0aa$var$extraOption = {
    // gridIndex: 0,
    // gridId: '',
    offset: 0
};
function $1021478d6a16b0aa$export$4b3e715f166fdd78(registers) {
    registers.registerComponentView($1021478d6a16b0aa$var$GridView);
    registers.registerComponentModel((0, $d67c268180aaad04$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem("cartesian2d", (0, $8e1d1b12d8439742$export$2e2bcd8739ae039));
    (0, $c5c4c85259d60abe$export$2e2bcd8739ae039)(registers, "x", (0, $008426c98740266e$export$483dc37e6ad83a3c), $1021478d6a16b0aa$var$extraOption);
    (0, $c5c4c85259d60abe$export$2e2bcd8739ae039)(registers, "y", (0, $008426c98740266e$export$483dc37e6ad83a3c), $1021478d6a16b0aa$var$extraOption);
    registers.registerComponentView((0, $c87c0ba584696283$export$b6d40cd875b8a1c8));
    registers.registerComponentView((0, $c87c0ba584696283$export$417e1bdd0616e0dc));
    registers.registerPreprocessor(function(option) {
        // Only create grid when need
        if (option.xAxis && option.yAxis && !option.grid) option.grid = {};
    });
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $24a1559be671c8a5$export$3d0d41e580ffa4e6(seriesModel, axis) {
    var coordinateSystem = seriesModel.coordinateSystem;
    var coordType = coordinateSystem && coordinateSystem.type;
    var baseAxis = coordinateSystem && coordinateSystem.getBaseAxis && coordinateSystem.getBaseAxis();
    var scaleType = baseAxis && baseAxis.scale && baseAxis.scale.type;
    var seriesValid = coordType === "cartesian2d" && scaleType === "ordinal" || coordType === "single";
    var axisValid = axis.model.get("jitter") > 0;
    return seriesValid && axisValid;
}
var $24a1559be671c8a5$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $24a1559be671c8a5$export$99f76258a03259ba(fixedAxis, fixedCoord, floatCoord, radius) {
    if (fixedAxis instanceof (0, $23369073c2236a8d$export$2e2bcd8739ae039)) {
        var scaleType = fixedAxis.scale.type;
        if (scaleType !== "category" && scaleType !== "ordinal") return floatCoord;
    }
    var axisModel = fixedAxis.model;
    var jitter = axisModel.get("jitter");
    var jitterOverlap = axisModel.get("jitterOverlap");
    var jitterMargin = axisModel.get("jitterMargin") || 0;
    // Get band width to limit jitter range
    var bandWidth = fixedAxis.scale.type === "ordinal" ? fixedAxis.getBandWidth() : null;
    if (jitter > 0) {
        if (jitterOverlap) return $24a1559be671c8a5$var$fixJitterIgnoreOverlaps(floatCoord, jitter, bandWidth, radius);
        else return $24a1559be671c8a5$var$fixJitterAvoidOverlaps(fixedAxis, fixedCoord, floatCoord, radius, jitter, jitterMargin);
    }
    return floatCoord;
}
function $24a1559be671c8a5$var$fixJitterIgnoreOverlaps(floatCoord, jitter, bandWidth, radius) {
    // Don't clamp single axis
    if (bandWidth === null) return floatCoord + (Math.random() - 0.5) * jitter;
    var maxJitter = bandWidth - radius * 2;
    var actualJitter = Math.min(Math.max(0, jitter), maxJitter);
    return floatCoord + (Math.random() - 0.5) * actualJitter;
}
function $24a1559be671c8a5$var$fixJitterAvoidOverlaps(fixedAxis, fixedCoord, floatCoord, radius, jitter, margin) {
    var store = $24a1559be671c8a5$var$inner(fixedAxis);
    if (!store.items) store.items = [];
    var items = store.items;
    // Try both positive and negative directions, choose the one with smaller movement
    var overlapA = $24a1559be671c8a5$var$placeJitterOnDirection(items, fixedCoord, floatCoord, radius, jitter, margin, 1);
    var overlapB = $24a1559be671c8a5$var$placeJitterOnDirection(items, fixedCoord, floatCoord, radius, jitter, margin, -1);
    var minFloat = Math.abs(overlapA - floatCoord) < Math.abs(overlapB - floatCoord) ? overlapA : overlapB;
    // Clamp only category axis
    var bandWidth = fixedAxis.scale.type === "ordinal" ? fixedAxis.getBandWidth() : null;
    var distance = Math.abs(minFloat - floatCoord);
    if (distance > jitter / 2 || bandWidth && distance > bandWidth / 2 - radius) // If the new item is moved too far, then give up.
    // Fall back to random jitter.
    return $24a1559be671c8a5$var$fixJitterIgnoreOverlaps(floatCoord, jitter, bandWidth, radius);
    // Add new point to array
    items.push({
        fixedCoord: fixedCoord,
        floatCoord: minFloat,
        r: radius
    });
    return minFloat;
}
function $24a1559be671c8a5$var$placeJitterOnDirection(items, fixedCoord, floatCoord, radius, jitter, margin, direction) {
    var y = floatCoord;
    // Check all existing items for overlap and find the maximum adjustment needed
    for(var i = 0; i < items.length; i++){
        var item = items[i];
        var dx = fixedCoord - item.fixedCoord;
        var dy = y - item.floatCoord;
        var d2 = dx * dx + dy * dy;
        var r = radius + item.r + margin;
        if (d2 < r * r) {
            // Has overlap, calculate required adjustment
            var requiredY = item.floatCoord + Math.sqrt(r * r - dx * dx) * direction;
            // Check if this adjustment would move too far
            if (Math.abs(requiredY - floatCoord) > jitter / 2) return Number.MAX_VALUE; // Give up
            // Update y only when it's larger to the center
            if (direction === 1 && requiredY > y || direction === -1 && requiredY < y) {
                y = requiredY;
                // Loop from the start again
                i = -1; // Reset index to recheck all items
                continue; // Recalculate with the new y position
            }
        }
    }
    return y;
}


function $9f6fa7f5c553dca1$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType("scatter", function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && (coordSys.type === "cartesian2d" || coordSys.type === "single")) {
            var baseAxis_1 = coordSys.getBaseAxis ? coordSys.getBaseAxis() : null;
            var hasJitter = baseAxis_1 && (0, $24a1559be671c8a5$export$3d0d41e580ffa4e6)(seriesModel, baseAxis_1);
            if (hasJitter) {
                var data_1 = seriesModel.getData();
                data_1.each(function(idx) {
                    var dim = baseAxis_1.dim;
                    var orient = baseAxis_1.orient;
                    var isSingleY = orient === "horizontal" && baseAxis_1.type !== "category" || orient === "vertical" && baseAxis_1.type === "category";
                    var layout = data_1.getItemLayout(idx);
                    var rawSize = data_1.getItemVisual(idx, "symbolSize");
                    var size = rawSize instanceof Array ? (rawSize[1] + rawSize[0]) / 2 : rawSize;
                    if (dim === "y" || dim === "single" && isSingleY) {
                        // x is fixed, and y is floating
                        var jittered = (0, $24a1559be671c8a5$export$99f76258a03259ba)(baseAxis_1, layout[0], layout[1], size / 2);
                        data_1.setItemLayout(idx, [
                            layout[0],
                            jittered
                        ]);
                    } else if (dim === "x" || dim === "single" && !isSingleY) {
                        // y is fixed, and x is floating
                        var jittered = (0, $24a1559be671c8a5$export$99f76258a03259ba)(baseAxis_1, layout[1], layout[0], size / 2);
                        data_1.setItemLayout(idx, [
                            jittered,
                            layout[1]
                        ]);
                    }
                });
            }
        }
    });
}


function $1214e5d7a4a6f990$export$4b3e715f166fdd78(registers) {
    // In case developer forget to include grid component
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $1021478d6a16b0aa$export$4b3e715f166fdd78));
    registers.registerSeriesModel((0, $00ab9646b588965f$export$2e2bcd8739ae039));
    registers.registerChartView((0, $c92a7ada0c69ef68$export$2e2bcd8739ae039));
    registers.registerLayout((0, $73b014aa594ea652$export$2e2bcd8739ae039)("scatter"));
}
function $1214e5d7a4a6f990$export$7dc06c71cf84167d(registers) {
    registers.registerLayout(registers.PRIORITY.VISUAL.POST_CHART_LAYOUT, (0, $9f6fa7f5c553dca1$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 










var $9b5b8a865cafa8ae$var$DEFAULT_SECTOR_Z = 2;
var $9b5b8a865cafa8ae$var$DEFAULT_TEXT_Z = 4;
/**
 * Sunburstce of Sunburst including Sector, Label, LabelLine
 */ var $9b5b8a865cafa8ae$var$SunburstPiece = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SunburstPiece, _super);
    function SunburstPiece(node, seriesModel, ecModel, api) {
        var _this = _super.call(this) || this;
        _this.z2 = $9b5b8a865cafa8ae$var$DEFAULT_SECTOR_Z;
        _this.textConfig = {
            inside: true
        };
        (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(_this).seriesIndex = seriesModel.seriesIndex;
        var text = new $fe885cc21795562b$export$2e2bcd8739ae039({
            z2: $9b5b8a865cafa8ae$var$DEFAULT_TEXT_Z,
            silent: node.getModel().get([
                "label",
                "silent"
            ])
        });
        _this.setTextContent(text);
        _this.updateData(true, node, seriesModel, ecModel, api);
        return _this;
    }
    SunburstPiece.prototype.updateData = function(firstCreate, node, // state: 'emphasis' | 'normal' | 'highlight' | 'downplay',
    seriesModel, ecModel, api) {
        this.node = node;
        node.piece = this;
        seriesModel = seriesModel || this._seriesModel;
        ecModel = ecModel || this._ecModel;
        var sector = this;
        (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(sector).dataIndex = node.dataIndex;
        var itemModel = node.getModel();
        var emphasisModel = itemModel.getModel("emphasis");
        var layout = node.getLayout();
        var sectorShape = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, layout);
        sectorShape.label = null;
        var normalStyle = node.getVisual("style");
        normalStyle.lineJoin = "bevel";
        var decal = node.getVisual("decal");
        if (decal) normalStyle.decal = (0, $c6d646aacd243427$export$a3ba048e1a648972)(decal, api);
        var cornerRadius = (0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemModel.getModel("itemStyle"), sectorShape, true);
        $7a1bd9c2710fea0d$export$8b58be045bf06082(sectorShape, cornerRadius);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43((0, $2bf82c0980125b62$export$151308dceb52d5b), function(stateName) {
            var state = sector.ensureState(stateName);
            var itemStyleModel = itemModel.getModel([
                stateName,
                "itemStyle"
            ]);
            state.style = itemStyleModel.getItemStyle();
            // border radius
            var cornerRadius = (0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemStyleModel, sectorShape);
            if (cornerRadius) state.shape = cornerRadius;
        });
        if (firstCreate) {
            sector.setShape(sectorShape);
            sector.shape.r = layout.r0;
            $8b353638fbedfefa$export$a121566aadcfe021(sector, {
                shape: {
                    r: layout.r
                }
            }, seriesModel, node.dataIndex);
        } else {
            // Disable animation for gradient since no interpolation method
            // is supported for gradient
            $8b353638fbedfefa$export$c8dce3c08436e91e(sector, {
                shape: sectorShape
            }, seriesModel);
            (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(sector);
        }
        sector.useStyle(normalStyle);
        this._updateLabel(seriesModel);
        var cursorStyle = itemModel.getShallow("cursor");
        cursorStyle && sector.attr("cursor", cursorStyle);
        this._seriesModel = seriesModel || this._seriesModel;
        this._ecModel = ecModel || this._ecModel;
        var focus = emphasisModel.get("focus");
        var focusOrIndices = focus === "relative" ? $7a1bd9c2710fea0d$export$4fd8af2c48c43416(node.getAncestorsIndices(), node.getDescendantIndices()) : focus === "ancestor" ? node.getAncestorsIndices() : focus === "descendant" ? node.getDescendantIndices() : focus;
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, focusOrIndices, emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
    };
    SunburstPiece.prototype._updateLabel = function(seriesModel) {
        var _this = this;
        var itemModel = this.node.getModel();
        var normalLabelModel = itemModel.getModel("label");
        var layout = this.node.getLayout();
        var angle = layout.endAngle - layout.startAngle;
        var midAngle = (layout.startAngle + layout.endAngle) / 2;
        var dx = Math.cos(midAngle);
        var dy = Math.sin(midAngle);
        var sector = this;
        var label = sector.getTextContent();
        var dataIndex = this.node.dataIndex;
        var labelMinAngle = normalLabelModel.get("minAngle") / 180 * Math.PI;
        var isNormalShown = normalLabelModel.get("show") && !(labelMinAngle != null && Math.abs(angle) < labelMinAngle);
        label.ignore = !isNormalShown;
        // TODO use setLabelStyle
        $7a1bd9c2710fea0d$export$79b2f7037acddd43((0, $2bf82c0980125b62$export$57ee5306b85ad7d5), function(stateName) {
            var labelStateModel = stateName === "normal" ? itemModel.getModel("label") : itemModel.getModel([
                stateName,
                "label"
            ]);
            var isNormal = stateName === "normal";
            var state = isNormal ? label : label.ensureState(stateName);
            var text = seriesModel.getFormattedLabel(dataIndex, stateName);
            if (isNormal) text = text || _this.node.name;
            state.style = (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(labelStateModel, {}, null, stateName !== "normal", true);
            if (text) state.style.text = text;
            // Not displaying text when angle is too small
            var isShown = labelStateModel.get("show");
            if (isShown != null && !isNormal) state.ignore = !isShown;
            var labelPosition = getLabelAttr(labelStateModel, "position");
            var sectorState = isNormal ? sector : sector.states[stateName];
            var labelColor = sectorState.style.fill;
            sectorState.textConfig = {
                outsideFill: labelStateModel.get("color") === "inherit" ? labelColor : null,
                inside: labelPosition !== "outside"
            };
            var r;
            var labelPadding = getLabelAttr(labelStateModel, "distance") || 0;
            var textAlign = getLabelAttr(labelStateModel, "align");
            var rotateType = getLabelAttr(labelStateModel, "rotate");
            var flipStartAngle = Math.PI * 0.5;
            var flipEndAngle = Math.PI * 1.5;
            var midAngleNormal = (0, $b44a8536c7214e4f$export$d44861331f213635)(rotateType === "tangential" ? Math.PI / 2 - midAngle : midAngle);
            // For text that is up-side down, rotate 180 degrees to make sure
            // it's readable
            var needsFlip = midAngleNormal > flipStartAngle && !(0, $cfc1f3b422a3185f$export$d1df570aea2868f)(midAngleNormal - flipStartAngle) && midAngleNormal < flipEndAngle;
            if (labelPosition === "outside") {
                r = layout.r + labelPadding;
                textAlign = needsFlip ? "right" : "left";
            } else {
                if (!textAlign || textAlign === "center") {
                    // Put label in the center if it's a circle
                    if (angle === 2 * Math.PI && layout.r0 === 0) r = 0;
                    else r = (layout.r + layout.r0) / 2;
                    textAlign = "center";
                } else if (textAlign === "left") {
                    r = layout.r0 + labelPadding;
                    textAlign = needsFlip ? "right" : "left";
                } else if (textAlign === "right") {
                    r = layout.r - labelPadding;
                    textAlign = needsFlip ? "left" : "right";
                }
            }
            state.style.align = textAlign;
            state.style.verticalAlign = getLabelAttr(labelStateModel, "verticalAlign") || "middle";
            state.x = r * dx + layout.cx;
            state.y = r * dy + layout.cy;
            var rotate = 0;
            if (rotateType === "radial") rotate = (0, $b44a8536c7214e4f$export$d44861331f213635)(-midAngle) + (needsFlip ? Math.PI : 0);
            else if (rotateType === "tangential") rotate = (0, $b44a8536c7214e4f$export$d44861331f213635)(Math.PI / 2 - midAngle) + (needsFlip ? Math.PI : 0);
            else if ($7a1bd9c2710fea0d$export$7e4aa119212bc614(rotateType)) rotate = rotateType * Math.PI / 180;
            state.rotation = (0, $b44a8536c7214e4f$export$d44861331f213635)(rotate);
        });
        function getLabelAttr(model, name) {
            var stateAttr = model.get(name);
            if (stateAttr == null) return normalLabelModel.get(name);
            return stateAttr;
        }
        label.dirtyStyle();
    };
    return SunburstPiece;
}($a3e1dec0a3875b49$export$2e2bcd8739ae039);
var $9b5b8a865cafa8ae$export$2e2bcd8739ae039 = $9b5b8a865cafa8ae$var$SunburstPiece;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $6341f66602946a06$export$c5445fa59c15dec4(payload, validPayloadTypes, seriesModel) {
    if (payload && $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(validPayloadTypes, payload.type) >= 0) {
        var root = seriesModel.getData().tree.root;
        var targetNode = payload.targetNode;
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(targetNode)) targetNode = root.getNodeById(targetNode);
        if (targetNode && root.contains(targetNode)) return {
            node: targetNode
        };
        var targetNodeId = payload.targetNodeId;
        if (targetNodeId != null && (targetNode = root.getNodeById(targetNodeId))) return {
            node: targetNode
        };
    }
}
function $6341f66602946a06$export$6be31fe4499506f9(node) {
    var path = [];
    while(node){
        node = node.parentNode;
        node && path.push(node);
    }
    return path.reverse();
}
function $6341f66602946a06$export$df59de26c77b5bea(viewRoot, node) {
    var viewPath = $6341f66602946a06$export$6be31fe4499506f9(viewRoot);
    return $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(viewPath, node) >= 0;
}
function $6341f66602946a06$export$c5baa480d6ceb0a3(node, seriesModel) {
    var treePathInfo = [];
    while(node){
        var nodeDataIndex = node.dataIndex;
        treePathInfo.push({
            name: node.name,
            dataIndex: nodeDataIndex,
            value: seriesModel.getRawValue(nodeDataIndex)
        });
        node = node.parentNode;
    }
    treePathInfo.reverse();
    return treePathInfo;
}


var $aae4889dfc91fba0$export$b06afbbb40399c8b = "sunburstRootToNode";
var $aae4889dfc91fba0$var$HIGHLIGHT_ACTION = "sunburstHighlight";
var $aae4889dfc91fba0$var$UNHIGHLIGHT_ACTION = "sunburstUnhighlight";
function $aae4889dfc91fba0$export$d2def111ea616eb3(registers) {
    registers.registerAction({
        type: $aae4889dfc91fba0$export$b06afbbb40399c8b,
        update: "updateView"
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "series",
            subType: "sunburst",
            query: payload
        }, handleRootToNode);
        function handleRootToNode(model, index) {
            var targetInfo = (0, $6341f66602946a06$export$c5445fa59c15dec4)(payload, [
                $aae4889dfc91fba0$export$b06afbbb40399c8b
            ], model);
            if (targetInfo) {
                var originViewRoot = model.getViewRoot();
                if (originViewRoot) payload.direction = (0, $6341f66602946a06$export$df59de26c77b5bea)(originViewRoot, targetInfo.node) ? "rollUp" : "drillDown";
                model.resetViewRoot(targetInfo.node);
            }
        }
    });
    registers.registerAction({
        type: $aae4889dfc91fba0$var$HIGHLIGHT_ACTION,
        update: "none"
    }, function(payload, ecModel, api) {
        // Clone
        payload = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, payload);
        ecModel.eachComponent({
            mainType: "series",
            subType: "sunburst",
            query: payload
        }, handleHighlight);
        function handleHighlight(model) {
            var targetInfo = (0, $6341f66602946a06$export$c5445fa59c15dec4)(payload, [
                $aae4889dfc91fba0$var$HIGHLIGHT_ACTION
            ], model);
            if (targetInfo) payload.dataIndex = targetInfo.node.dataIndex;
        }
        // Fast forward action
        api.dispatchAction((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(payload, {
            type: "highlight"
        }));
    });
    registers.registerAction({
        type: $aae4889dfc91fba0$var$UNHIGHLIGHT_ACTION,
        update: "updateView"
    }, function(payload, ecModel, api) {
        payload = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, payload);
        api.dispatchAction((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(payload, {
            type: "downplay"
        }));
    });
}



var $270cb27be00846ce$var$SunburstView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SunburstView, _super);
    function SunburstView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SunburstView.type;
        return _this;
    }
    SunburstView.prototype.render = function(seriesModel, ecModel, api, // @ts-ignore
    payload) {
        var self = this;
        this.seriesModel = seriesModel;
        this.api = api;
        this.ecModel = ecModel;
        var data = seriesModel.getData();
        var virtualRoot = data.tree.root;
        var newRoot = seriesModel.getViewRoot();
        var group = this.group;
        var renderLabelForZeroData = seriesModel.get("renderLabelForZeroData");
        var newChildren = [];
        newRoot.eachNode(function(node) {
            newChildren.push(node);
        });
        var oldChildren = this._oldChildren || [];
        dualTravel(newChildren, oldChildren);
        renderRollUp(virtualRoot, newRoot);
        this._initEvents();
        this._oldChildren = newChildren;
        function dualTravel(newChildren, oldChildren) {
            if (newChildren.length === 0 && oldChildren.length === 0) return;
            new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(oldChildren, newChildren, getKey, getKey).add(processNode).update(processNode).remove($7a1bd9c2710fea0d$export$c3095a23b368d1f2(processNode, null)).execute();
            function getKey(node) {
                return node.getId();
            }
            function processNode(newIdx, oldIdx) {
                var newNode = newIdx == null ? null : newChildren[newIdx];
                var oldNode = oldIdx == null ? null : oldChildren[oldIdx];
                doRenderNode(newNode, oldNode);
            }
        }
        function doRenderNode(newNode, oldNode) {
            if (!renderLabelForZeroData && newNode && !newNode.getValue()) // Not render data with value 0
            newNode = null;
            if (newNode !== virtualRoot && oldNode !== virtualRoot) {
                if (oldNode && oldNode.piece) {
                    if (newNode) {
                        // Update
                        oldNode.piece.updateData(false, newNode, seriesModel, ecModel, api);
                        // For tooltip
                        data.setItemGraphicEl(newNode.dataIndex, oldNode.piece);
                    } else // Remove
                    removeNode(oldNode);
                } else if (newNode) {
                    // Add
                    var piece = new (0, $9b5b8a865cafa8ae$export$2e2bcd8739ae039)(newNode, seriesModel, ecModel, api);
                    group.add(piece);
                    // For tooltip
                    data.setItemGraphicEl(newNode.dataIndex, piece);
                }
            }
        }
        function removeNode(node) {
            if (!node) return;
            if (node.piece) {
                group.remove(node.piece);
                node.piece = null;
            }
        }
        function renderRollUp(virtualRoot, viewRoot) {
            if (viewRoot.depth > 0) {
                // Render
                if (self.virtualPiece) // Update
                self.virtualPiece.updateData(false, virtualRoot, seriesModel, ecModel, api);
                else {
                    // Add
                    self.virtualPiece = new (0, $9b5b8a865cafa8ae$export$2e2bcd8739ae039)(virtualRoot, seriesModel, ecModel, api);
                    group.add(self.virtualPiece);
                }
                // TODO event scope
                viewRoot.piece.off("click");
                self.virtualPiece.on("click", function(e) {
                    self._rootToNode(viewRoot.parentNode);
                });
            } else if (self.virtualPiece) {
                // Remove
                group.remove(self.virtualPiece);
                self.virtualPiece = null;
            }
        }
    };
    /**
   * @private
   */ SunburstView.prototype._initEvents = function() {
        var _this = this;
        this.group.off("click");
        this.group.on("click", function(e) {
            var targetFound = false;
            var viewRoot = _this.seriesModel.getViewRoot();
            viewRoot.eachNode(function(node) {
                if (!targetFound && node.piece && node.piece === e.target) {
                    var nodeClick = node.getModel().get("nodeClick");
                    if (nodeClick === "rootToNode") _this._rootToNode(node);
                    else if (nodeClick === "link") {
                        var itemModel = node.getModel();
                        var link = itemModel.get("link");
                        if (link) {
                            var linkTarget = itemModel.get("target", true) || "_blank";
                            (0, $c84c9521536c601a$export$13e13f9b96dbe8fa)(link, linkTarget);
                        }
                    }
                    targetFound = true;
                }
            });
        });
    };
    /**
   * @private
   */ SunburstView.prototype._rootToNode = function(node) {
        if (node !== this.seriesModel.getViewRoot()) this.api.dispatchAction({
            type: (0, $aae4889dfc91fba0$export$b06afbbb40399c8b),
            from: this.uid,
            seriesId: this.seriesModel.id,
            targetNode: node
        });
    };
    /**
   * @implement
   */ SunburstView.prototype.containPoint = function(point, seriesModel) {
        var treeRoot = seriesModel.getData();
        var itemLayout = treeRoot.getItemLayout(0);
        if (itemLayout) {
            var dx = point[0] - itemLayout.cx;
            var dy = point[1] - itemLayout.cy;
            var radius = Math.sqrt(dx * dx + dy * dy);
            return radius <= itemLayout.r && radius >= itemLayout.r0;
        }
    };
    SunburstView.type = "sunburst";
    return SunburstView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $270cb27be00846ce$export$2e2bcd8739ae039 = $270cb27be00846ce$var$SunburstView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Tree data structure
 */ 




var $116fa5bb9335391f$export$2eba8ec3a333fdbb = /** @class */ function() {
    function TreeNode(name, hostTree) {
        this.depth = 0;
        this.height = 0;
        /**
     * Reference to list item.
     * Do not persistent dataIndex outside,
     * besause it may be changed by list.
     * If dataIndex -1,
     * this node is logical deleted (filtered) in list.
     */ this.dataIndex = -1;
        this.children = [];
        this.viewChildren = [];
        this.isExpand = false;
        this.name = name || "";
        this.hostTree = hostTree;
    }
    /**
   * The node is removed.
   */ TreeNode.prototype.isRemoved = function() {
        return this.dataIndex < 0;
    };
    TreeNode.prototype.eachNode = function(options, cb, context) {
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(options)) {
            context = cb;
            cb = options;
            options = null;
        }
        options = options || {};
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(options)) options = {
            order: options
        };
        var order = options.order || "preorder";
        var children = this[options.attr || "children"];
        var suppressVisitSub;
        order === "preorder" && (suppressVisitSub = cb.call(context, this));
        for(var i = 0; !suppressVisitSub && i < children.length; i++)children[i].eachNode(options, cb, context);
        order === "postorder" && cb.call(context, this);
    };
    /**
   * Update depth and height of this subtree.
   */ TreeNode.prototype.updateDepthAndHeight = function(depth) {
        var height = 0;
        this.depth = depth;
        for(var i = 0; i < this.children.length; i++){
            var child = this.children[i];
            child.updateDepthAndHeight(depth + 1);
            if (child.height > height) height = child.height;
        }
        this.height = height + 1;
    };
    TreeNode.prototype.getNodeById = function(id) {
        if (this.getId() === id) return this;
        for(var i = 0, children = this.children, len = children.length; i < len; i++){
            var res = children[i].getNodeById(id);
            if (res) return res;
        }
    };
    TreeNode.prototype.contains = function(node) {
        if (node === this) return true;
        for(var i = 0, children = this.children, len = children.length; i < len; i++){
            var res = children[i].contains(node);
            if (res) return res;
        }
    };
    /**
   * @param includeSelf Default false.
   * @return order: [root, child, grandchild, ...]
   */ TreeNode.prototype.getAncestors = function(includeSelf) {
        var ancestors = [];
        var node = includeSelf ? this : this.parentNode;
        while(node){
            ancestors.push(node);
            node = node.parentNode;
        }
        ancestors.reverse();
        return ancestors;
    };
    TreeNode.prototype.getAncestorsIndices = function() {
        var indices = [];
        var currNode = this;
        while(currNode){
            indices.push(currNode.dataIndex);
            currNode = currNode.parentNode;
        }
        indices.reverse();
        return indices;
    };
    TreeNode.prototype.getDescendantIndices = function() {
        var indices = [];
        this.eachNode(function(childNode) {
            indices.push(childNode.dataIndex);
        });
        return indices;
    };
    TreeNode.prototype.getValue = function(dimension) {
        var data = this.hostTree.data;
        return data.getStore().get(data.getDimensionIndex(dimension || "value"), this.dataIndex);
    };
    TreeNode.prototype.setLayout = function(layout, merge) {
        this.dataIndex >= 0 && this.hostTree.data.setItemLayout(this.dataIndex, layout, merge);
    };
    /**
   * @return {Object} layout
   */ TreeNode.prototype.getLayout = function() {
        return this.hostTree.data.getItemLayout(this.dataIndex);
    };
    // @depcrecated
    // getModel<T = unknown, S extends keyof T = keyof T>(path: S): Model<T[S]>
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    TreeNode.prototype.getModel = function(path) {
        if (this.dataIndex < 0) return;
        var hostTree = this.hostTree;
        var itemModel = hostTree.data.getItemModel(this.dataIndex);
        return itemModel.getModel(path);
    };
    // TODO: TYPE More specific model
    TreeNode.prototype.getLevelModel = function() {
        return (this.hostTree.levelModels || [])[this.depth];
    };
    TreeNode.prototype.setVisual = function(key, value) {
        this.dataIndex >= 0 && this.hostTree.data.setItemVisual(this.dataIndex, key, value);
    };
    /**
   * Get item visual
   * FIXME: make return type better
   */ TreeNode.prototype.getVisual = function(key) {
        return this.hostTree.data.getItemVisual(this.dataIndex, key);
    };
    TreeNode.prototype.getRawIndex = function() {
        return this.hostTree.data.getRawIndex(this.dataIndex);
    };
    TreeNode.prototype.getId = function() {
        return this.hostTree.data.getId(this.dataIndex);
    };
    /**
   * index in parent's children
   */ TreeNode.prototype.getChildIndex = function() {
        if (this.parentNode) {
            var children = this.parentNode.children;
            for(var i = 0; i < children.length; ++i){
                if (children[i] === this) return i;
            }
            return -1;
        }
        return -1;
    };
    /**
   * if this is an ancestor of another node
   *
   * @param node another node
   * @return if is ancestor
   */ TreeNode.prototype.isAncestorOf = function(node) {
        var parent = node.parentNode;
        while(parent){
            if (parent === this) return true;
            parent = parent.parentNode;
        }
        return false;
    };
    /**
   * if this is an descendant of another node
   *
   * @param node another node
   * @return if is descendant
   */ TreeNode.prototype.isDescendantOf = function(node) {
        return node !== this && node.isAncestorOf(this);
    };
    return TreeNode;
}();
var $116fa5bb9335391f$var$Tree = /** @class */ function() {
    function Tree(hostModel) {
        this.type = "tree";
        this._nodes = [];
        this.hostModel = hostModel;
    }
    Tree.prototype.eachNode = function(options, cb, context) {
        this.root.eachNode(options, cb, context);
    };
    Tree.prototype.getNodeByDataIndex = function(dataIndex) {
        var rawIndex = this.data.getRawIndex(dataIndex);
        return this._nodes[rawIndex];
    };
    Tree.prototype.getNodeById = function(name) {
        return this.root.getNodeById(name);
    };
    /**
   * Update item available by list,
   * when list has been performed options like 'filterSelf' or 'map'.
   */ Tree.prototype.update = function() {
        var data = this.data;
        var nodes = this._nodes;
        for(var i = 0, len = nodes.length; i < len; i++)nodes[i].dataIndex = -1;
        for(var i = 0, len = data.count(); i < len; i++)nodes[data.getRawIndex(i)].dataIndex = i;
    };
    /**
   * Clear all layouts
   */ Tree.prototype.clearLayouts = function() {
        this.data.clearItemLayouts();
    };
    /**
   * data node format:
   * {
   *     name: ...
   *     value: ...
   *     children: [
   *         {
   *             name: ...
   *             value: ...
   *             children: ...
   *         },
   *         ...
   *     ]
   * }
   */ Tree.createTree = function(dataRoot, hostModel, beforeLink) {
        var tree = new Tree(hostModel);
        var listData = [];
        var dimMax = 1;
        buildHierarchy(dataRoot);
        function buildHierarchy(dataNode, parentNode) {
            var value = dataNode.value;
            dimMax = Math.max(dimMax, $7a1bd9c2710fea0d$export$43bee75e5e14138e(value) ? value.length : 1);
            listData.push(dataNode);
            var node = new $116fa5bb9335391f$export$2eba8ec3a333fdbb((0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(dataNode.name, ""), tree);
            parentNode ? $116fa5bb9335391f$var$addChild(node, parentNode) : tree.root = node;
            tree._nodes.push(node);
            var children = dataNode.children;
            if (children) for(var i = 0; i < children.length; i++)buildHierarchy(children[i], node);
        }
        tree.root.updateDepthAndHeight(0);
        var dimensions = (0, $a27631012b7b377c$export$2e2bcd8739ae039)(listData, {
            coordDimensions: [
                "value"
            ],
            dimensionsCount: dimMax
        }).dimensions;
        var list = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(dimensions, hostModel);
        list.initData(listData);
        beforeLink && beforeLink(list);
        (0, $4a8451eb7786c849$export$2e2bcd8739ae039)({
            mainData: list,
            struct: tree,
            structAttr: "tree"
        });
        tree.update();
        return tree;
    };
    return Tree;
}();
/**
 * It is needed to consider the mess of 'list', 'hostModel' when creating a TreeNote,
 * so this function is not ready and not necessary to be public.
 */ function $116fa5bb9335391f$var$addChild(child, node) {
    var children = node.children;
    if (child.parentNode === node) return;
    children.push(child);
    child.parentNode = node;
}
var $116fa5bb9335391f$export$2e2bcd8739ae039 = $116fa5bb9335391f$var$Tree;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $a116b59e46d9072c$export$2e2bcd8739ae039(seriesModel) {
    var data = seriesModel.getData();
    var tree = data.tree;
    var decalPaletteScope = {};
    tree.eachNode(function(node) {
        // Use decal of level 1 node
        var current = node;
        while(current && current.depth > 1)current = current.parentNode;
        var decal = (0, $e7fbd47751ca3c28$export$e4d892222945a227)(seriesModel.ecModel, current.name || current.dataIndex + "", decalPaletteScope);
        node.setVisual("decal", decal);
    });
}


var $5204df39d5781117$var$SunburstSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SunburstSeriesModel, _super);
    function SunburstSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SunburstSeriesModel.type;
        _this.ignoreStyleOnData = true;
        return _this;
    }
    SunburstSeriesModel.prototype.getInitialData = function(option, ecModel) {
        // Create a virtual root.
        var root = {
            name: option.name,
            children: option.data
        };
        $5204df39d5781117$var$completeTreeValue(root);
        var levelModels = this._levelModels = $7a1bd9c2710fea0d$export$871de8747c9eaa88(option.levels || [], function(levelDefine) {
            return new (0, $6818646a97528290$export$2e2bcd8739ae039)(levelDefine, this, ecModel);
        }, this);
        // Make sure always a new tree is created when setOption,
        // in TreemapView, we check whether oldTree === newTree
        // to choose mappings approach among old shapes and new shapes.
        var tree = (0, $116fa5bb9335391f$export$2e2bcd8739ae039).createTree(root, this, beforeLink);
        function beforeLink(nodeData) {
            nodeData.wrapMethod("getItemModel", function(model, idx) {
                var node = tree.getNodeByDataIndex(idx);
                var levelModel = levelModels[node.depth];
                levelModel && (model.parentModel = levelModel);
                return model;
            });
        }
        return tree.data;
    };
    SunburstSeriesModel.prototype.optionUpdated = function() {
        this.resetViewRoot();
    };
    /*
   * @override
   */ SunburstSeriesModel.prototype.getDataParams = function(dataIndex) {
        var params = _super.prototype.getDataParams.apply(this, arguments);
        var node = this.getData().tree.getNodeByDataIndex(dataIndex);
        params.treePathInfo = (0, $6341f66602946a06$export$c5baa480d6ceb0a3)(node, this);
        return params;
    };
    SunburstSeriesModel.prototype.getLevelModel = function(node) {
        return this._levelModels && this._levelModels[node.depth];
    };
    SunburstSeriesModel.prototype.getViewRoot = function() {
        return this._viewRoot;
    };
    SunburstSeriesModel.prototype.resetViewRoot = function(viewRoot) {
        viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
        var root = this.getRawData().tree.root;
        if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) this._viewRoot = root;
    };
    SunburstSeriesModel.prototype.enableAriaDecal = function() {
        (0, $a116b59e46d9072c$export$2e2bcd8739ae039)(this);
    };
    SunburstSeriesModel.type = "series.sunburst";
    SunburstSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        // 默认全局居中
        center: [
            "50%",
            "50%"
        ],
        radius: [
            0,
            "75%"
        ],
        // 默认顺时针
        clockwise: true,
        startAngle: 90,
        // 最小角度改为0
        minAngle: 0,
        // If still show when all data zero.
        stillShowZeroSum: true,
        // 'rootToNode', 'link', or false
        nodeClick: "rootToNode",
        renderLabelForZeroData: false,
        label: {
            // could be: 'radial', 'tangential', or 'none'
            rotate: "radial",
            show: true,
            opacity: 1,
            // 'left' is for inner side of inside, and 'right' is for outer
            // side for inside
            align: "center",
            position: "inside",
            distance: 5,
            silent: true
        },
        itemStyle: {
            borderWidth: 1,
            borderColor: "white",
            borderType: "solid",
            shadowBlur: 0,
            shadowColor: "rgba(0, 0, 0, 0.2)",
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            opacity: 1
        },
        emphasis: {
            focus: "descendant"
        },
        blur: {
            itemStyle: {
                opacity: 0.2
            },
            label: {
                opacity: 0.1
            }
        },
        // Animation type can be expansion, scale.
        animationType: "expansion",
        animationDuration: 1000,
        animationDurationUpdate: 500,
        data: [],
        /**
     * Sort order.
     *
     * Valid values: 'desc', 'asc', null, or callback function.
     * 'desc' and 'asc' for descend and ascendant order;
     * null for not sorting;
     * example of callback function:
     * function(nodeA, nodeB) {
     *     return nodeA.getValue() - nodeB.getValue();
     * }
     */ sort: "desc"
    };
    return SunburstSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
function $5204df39d5781117$var$completeTreeValue(dataNode) {
    // Postorder travel tree.
    // If value of none-leaf node is not set,
    // calculate it by suming up the value of all children.
    var sum = 0;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(dataNode.children, function(child) {
        $5204df39d5781117$var$completeTreeValue(child);
        var childValue = child.value;
        // TODO First value of array must be a number
        $7a1bd9c2710fea0d$export$43bee75e5e14138e(childValue) && (childValue = childValue[0]);
        sum += childValue;
    });
    var thisValue = dataNode.value;
    if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(thisValue)) thisValue = thisValue[0];
    if (thisValue == null || isNaN(thisValue)) thisValue = sum;
    // Value should not less than 0.
    if (thisValue < 0) thisValue = 0;
    $7a1bd9c2710fea0d$export$43bee75e5e14138e(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
}
var $5204df39d5781117$export$2e2bcd8739ae039 = $5204df39d5781117$var$SunburstSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

// let PI2 = Math.PI * 2;
var $2ac615e1f67ae37a$var$RADIAN = Math.PI / 180;
function $2ac615e1f67ae37a$export$2e2bcd8739ae039(seriesType, ecModel, api) {
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        var center = seriesModel.get("center");
        var radius = seriesModel.get("radius");
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(radius)) radius = [
            0,
            radius
        ];
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(center)) center = [
            center,
            center
        ];
        var width = api.getWidth();
        var height = api.getHeight();
        var size = Math.min(width, height);
        var cx = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[0], width);
        var cy = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[1], height);
        var r0 = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(radius[0], size / 2);
        var r = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(radius[1], size / 2);
        var startAngle = -seriesModel.get("startAngle") * $2ac615e1f67ae37a$var$RADIAN;
        var minAngle = seriesModel.get("minAngle") * $2ac615e1f67ae37a$var$RADIAN;
        var virtualRoot = seriesModel.getData().tree.root;
        var treeRoot = seriesModel.getViewRoot();
        var rootDepth = treeRoot.depth;
        var sort = seriesModel.get("sort");
        if (sort != null) $2ac615e1f67ae37a$var$initChildren(treeRoot, sort);
        var validDataCount = 0;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(treeRoot.children, function(child) {
            !isNaN(child.getValue()) && validDataCount++;
        });
        var sum = treeRoot.getValue();
        // Sum may be 0
        var unitRadian = Math.PI / (sum || validDataCount) * 2;
        var renderRollupNode = treeRoot.depth > 0;
        var levels = treeRoot.height - (renderRollupNode ? -1 : 1);
        var rPerLevel = (r - r0) / (levels || 1);
        var clockwise = seriesModel.get("clockwise");
        var stillShowZeroSum = seriesModel.get("stillShowZeroSum");
        // In the case some sector angle is smaller than minAngle
        // let restAngle = PI2;
        // let valueSumLargerThanMinAngle = 0;
        var dir = clockwise ? 1 : -1;
        /**
     * Render a tree
     * @return increased angle
     */ var renderNode = function(node, startAngle) {
            if (!node) return;
            var endAngle = startAngle;
            // Render self
            if (node !== virtualRoot) {
                // Tree node is virtual, so it doesn't need to be drawn
                var value = node.getValue();
                var angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
                if (angle < minAngle) angle = minAngle;
                // else {
                //     valueSumLargerThanMinAngle += value;
                // }
                endAngle = startAngle + dir * angle;
                var depth = node.depth - rootDepth - (renderRollupNode ? -1 : 1);
                var rStart = r0 + rPerLevel * depth;
                var rEnd = r0 + rPerLevel * (depth + 1);
                var levelModel = seriesModel.getLevelModel(node);
                if (levelModel) {
                    var r0_1 = levelModel.get("r0", true);
                    var r_1 = levelModel.get("r", true);
                    var radius_1 = levelModel.get("radius", true);
                    if (radius_1 != null) {
                        r0_1 = radius_1[0];
                        r_1 = radius_1[1];
                    }
                    r0_1 != null && (rStart = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(r0_1, size / 2));
                    r_1 != null && (rEnd = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(r_1, size / 2));
                }
                node.setLayout({
                    angle: angle,
                    startAngle: startAngle,
                    endAngle: endAngle,
                    clockwise: clockwise,
                    cx: cx,
                    cy: cy,
                    r0: rStart,
                    r: rEnd
                });
            }
            // Render children
            if (node.children && node.children.length) {
                // currentAngle = startAngle;
                var siblingAngle_1 = 0;
                $7a1bd9c2710fea0d$export$79b2f7037acddd43(node.children, function(node) {
                    siblingAngle_1 += renderNode(node, startAngle + siblingAngle_1);
                });
            }
            return endAngle - startAngle;
        };
        // Virtual root node for roll up
        if (renderRollupNode) {
            var rStart = r0;
            var rEnd = r0 + rPerLevel;
            var angle = Math.PI * 2;
            virtualRoot.setLayout({
                angle: angle,
                startAngle: startAngle,
                endAngle: startAngle + angle,
                clockwise: clockwise,
                cx: cx,
                cy: cy,
                r0: rStart,
                r: rEnd
            });
        }
        renderNode(treeRoot, startAngle);
    });
}
/**
 * Init node children by order and update visual
 */ function $2ac615e1f67ae37a$var$initChildren(node, sortOrder) {
    var children = node.children || [];
    node.children = $2ac615e1f67ae37a$var$sort(children, sortOrder);
    // Init children recursively
    if (children.length) $7a1bd9c2710fea0d$export$79b2f7037acddd43(node.children, function(child) {
        $2ac615e1f67ae37a$var$initChildren(child, sortOrder);
    });
}
/**
 * Sort children nodes
 *
 * @param {TreeNode[]}               children children of node to be sorted
 * @param {string | function | null} sort sort method
 *                                   See SunburstSeries.js for details.
 */ function $2ac615e1f67ae37a$var$sort(children, sortOrder) {
    if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(sortOrder)) {
        var sortTargets = $7a1bd9c2710fea0d$export$871de8747c9eaa88(children, function(child, idx) {
            var value = child.getValue();
            return {
                params: {
                    depth: child.depth,
                    height: child.height,
                    dataIndex: child.dataIndex,
                    getValue: function() {
                        return value;
                    }
                },
                index: idx
            };
        });
        sortTargets.sort(function(a, b) {
            return sortOrder(a.params, b.params);
        });
        return $7a1bd9c2710fea0d$export$871de8747c9eaa88(sortTargets, function(target) {
            return children[target.index];
        });
    } else {
        var isAsc_1 = sortOrder === "asc";
        return children.sort(function(a, b) {
            var diff = (a.getValue() - b.getValue()) * (isAsc_1 ? 1 : -1);
            return diff === 0 ? (a.dataIndex - b.dataIndex) * (isAsc_1 ? -1 : 1) : diff;
        });
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $a3ad73d5b7f783f0$export$2e2bcd8739ae039(ecModel) {
    var paletteScope = {};
    // Default color strategy
    function pickColor(node, seriesModel, treeHeight) {
        if (node.depth === 0) // Don't use palette color for the root node, because it's displayed only when drilling down.
        return (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral50;
        // Choose color from palette based on the first level.
        var current = node;
        while(current && current.depth > 1)current = current.parentNode;
        var color = seriesModel.getColorFromPalette(current.name || current.dataIndex + "", paletteScope);
        if (node.depth > 1 && (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(color)) // Lighter on the deeper level.
        color = (0, $2c037f5bda6341ca$export$590e8b2c435046d9)(color, (node.depth - 1) / (treeHeight - 1) * 0.5);
        return color;
    }
    ecModel.eachSeriesByType("sunburst", function(seriesModel) {
        var data = seriesModel.getData();
        var tree = data.tree;
        tree.eachNode(function(node) {
            var model = node.getModel();
            var style = model.getModel("itemStyle").getItemStyle();
            if (!style.fill) style.fill = pickColor(node, seriesModel, tree.root.height);
            var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, "style");
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(existsStyle, style);
        });
    });
}





function $b7341ef122ec790d$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $270cb27be00846ce$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $5204df39d5781117$export$2e2bcd8739ae039));
    registers.registerLayout((0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)((0, $2ac615e1f67ae37a$export$2e2bcd8739ae039), "sunburst"));
    registers.registerProcessor((0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)((0, $e11a533bf70b759c$export$2e2bcd8739ae039), "sunburst"));
    registers.registerVisual((0, $a3ad73d5b7f783f0$export$2e2bcd8739ae039));
    (0, $aae4889dfc91fba0$export$d2def111ea616eb3)(registers);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








var $91b53b7eca57e10b$var$ThemeRiverView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ThemeRiverView, _super);
    function ThemeRiverView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ThemeRiverView.type;
        _this._layers = [];
        return _this;
    }
    ThemeRiverView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var self = this;
        var group = this.group;
        var layersSeries = seriesModel.getLayerSeries();
        var layoutInfo = data.getLayout("layoutInfo");
        var rect = layoutInfo.rect;
        var boundaryGap = layoutInfo.boundaryGap;
        group.x = 0;
        group.y = rect.y + boundaryGap[0];
        function keyGetter(item) {
            return item.name;
        }
        var dataDiffer = new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(this._layersSeries || [], layersSeries, keyGetter, keyGetter);
        var newLayersGroups = [];
        dataDiffer.add((0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(process, this, "add")).update((0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(process, this, "update")).remove((0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(process, this, "remove")).execute();
        function process(status, idx, oldIdx) {
            var oldLayersGroups = self._layers;
            if (status === "remove") {
                group.remove(oldLayersGroups[idx]);
                return;
            }
            var points0 = [];
            var points1 = [];
            var style;
            var indices = layersSeries[idx].indices;
            var j = 0;
            for(; j < indices.length; j++){
                var layout = data.getItemLayout(indices[j]);
                var x = layout.x;
                var y0 = layout.y0;
                var y = layout.y;
                points0.push(x, y0);
                points1.push(x, y0 + y);
                style = data.getItemVisual(indices[j], "style");
            }
            var polygon;
            var textLayout = data.getItemLayout(indices[0]);
            var labelModel = seriesModel.getModel("label");
            var margin = labelModel.get("margin");
            var emphasisModel = seriesModel.getModel("emphasis");
            if (status === "add") {
                var layerGroup = newLayersGroups[idx] = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
                polygon = new (0, $5c417e1ed90142c5$export$6042a400d113f2bd)({
                    shape: {
                        points: points0,
                        stackedOnPoints: points1,
                        smooth: 0.4,
                        stackedOnSmooth: 0.4,
                        smoothConstraint: false
                    },
                    z2: 0
                });
                layerGroup.add(polygon);
                group.add(layerGroup);
                if (seriesModel.isAnimationEnabled()) polygon.setClipPath($91b53b7eca57e10b$var$createGridClipShape(polygon.getBoundingRect(), seriesModel, function() {
                    polygon.removeClipPath();
                }));
            } else {
                var layerGroup = oldLayersGroups[oldIdx];
                polygon = layerGroup.childAt(0);
                group.add(layerGroup);
                newLayersGroups[idx] = layerGroup;
                $8b353638fbedfefa$export$c8dce3c08436e91e(polygon, {
                    shape: {
                        points: points0,
                        stackedOnPoints: points1
                    }
                }, seriesModel);
                (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(polygon);
            }
            (0, $6800dfcb6e1e2a44$export$9a13992917966657)(polygon, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(seriesModel), {
                labelDataIndex: indices[j - 1],
                defaultText: data.getName(indices[j - 1]),
                inheritColor: style.fill
            }, {
                normal: {
                    verticalAlign: "middle"
                }
            });
            polygon.setTextConfig({
                position: null,
                local: true
            });
            var labelEl = polygon.getTextContent();
            // TODO More label position options.
            if (labelEl) {
                labelEl.x = textLayout.x - margin;
                labelEl.y = textLayout.y0 + textLayout.y / 2;
            }
            polygon.useStyle(style);
            data.setItemGraphicEl(idx, polygon);
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polygon, seriesModel);
            (0, $2bf82c0980125b62$export$e51187539ff11209)(polygon, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
        }
        this._layersSeries = layersSeries;
        this._layers = newLayersGroups;
    };
    ThemeRiverView.type = "themeRiver";
    return ThemeRiverView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
// add animation to the view
function $91b53b7eca57e10b$var$createGridClipShape(rect, seriesModel, cb) {
    var rectEl = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        shape: {
            x: rect.x - 10,
            y: rect.y - 10,
            width: 0,
            height: rect.height + 20
        }
    });
    $8b353638fbedfefa$export$a121566aadcfe021(rectEl, {
        shape: {
            x: rect.x - 50,
            width: rect.width + 100,
            height: rect.height + 20
        }
    }, seriesModel, cb);
    return rectEl;
}
var $91b53b7eca57e10b$export$2e2bcd8739ae039 = $91b53b7eca57e10b$var$ThemeRiverView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








var $5814c4cad54e1e96$var$DATA_NAME_INDEX = 2;
var $5814c4cad54e1e96$var$ThemeRiverSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ThemeRiverSeriesModel, _super);
    function ThemeRiverSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ThemeRiverSeriesModel.type;
        return _this;
    }
    /**
   * @override
   */ ThemeRiverSeriesModel.prototype.init = function(option) {
        // eslint-disable-next-line
        _super.prototype.init.apply(this, arguments);
        // Put this function here is for the sake of consistency of code style.
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $cf24728fc17c4ab6$export$2e2bcd8739ae039)($7a1bd9c2710fea0d$export$2385a24977818dd0(this.getData, this), $7a1bd9c2710fea0d$export$2385a24977818dd0(this.getRawData, this));
    };
    /**
   * If there is no value of a certain point in the time for some event,set it value to 0.
   *
   * @param {Array} data  initial data in the option
   * @return {Array}
   */ ThemeRiverSeriesModel.prototype.fixData = function(data) {
        var rawDataLength = data.length;
        /**
     * Make sure every layer data get the same keys.
     * The value index tells which layer has visited.
     * {
     *  2014/01/01: -1
     * }
     */ var timeValueKeys = {};
        // grouped data by name
        var groupResult = (0, $76d619f648247e6d$export$7ab5bda43e13168f)(data, function(item) {
            if (!timeValueKeys.hasOwnProperty(item[0] + "")) timeValueKeys[item[0] + ""] = -1;
            return item[2];
        });
        var layerData = [];
        groupResult.buckets.each(function(items, key) {
            layerData.push({
                name: key,
                dataList: items
            });
        });
        var layerNum = layerData.length;
        for(var k = 0; k < layerNum; ++k){
            var name_1 = layerData[k].name;
            for(var j = 0; j < layerData[k].dataList.length; ++j){
                var timeValue = layerData[k].dataList[j][0] + "";
                timeValueKeys[timeValue] = k;
            }
            for(var timeValue in timeValueKeys)if (timeValueKeys.hasOwnProperty(timeValue) && timeValueKeys[timeValue] !== k) {
                timeValueKeys[timeValue] = k;
                data[rawDataLength] = [
                    timeValue,
                    0,
                    name_1
                ];
                rawDataLength++;
            }
        }
        return data;
    };
    /**
   * @override
   * @param  option  the initial option that user gave
   * @param  ecModel  the model object for themeRiver option
   */ ThemeRiverSeriesModel.prototype.getInitialData = function(option, ecModel) {
        var singleAxisModel = this.getReferringComponents("singleAxis", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        var axisType = singleAxisModel.get("type");
        // filter the data item with the value of label is undefined
        var filterData = $7a1bd9c2710fea0d$export$3dea766d36a8935f(option.data, function(dataItem) {
            return dataItem[2] !== undefined;
        });
        // ??? TODO design a stage to transfer data for themeRiver and lines?
        var data = this.fixData(filterData || []);
        var nameList = [];
        var nameMap = this.nameMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var count = 0;
        for(var i = 0; i < data.length; ++i){
            nameList.push(data[i][$5814c4cad54e1e96$var$DATA_NAME_INDEX]);
            if (!nameMap.get(data[i][$5814c4cad54e1e96$var$DATA_NAME_INDEX])) {
                nameMap.set(data[i][$5814c4cad54e1e96$var$DATA_NAME_INDEX], count);
                count++;
            }
        }
        var dimensions = (0, $a27631012b7b377c$export$2e2bcd8739ae039)(data, {
            coordDimensions: [
                "single"
            ],
            dimensionsDefine: [
                {
                    name: "time",
                    type: (0, $18085de91ae59d03$export$af1622903e71278e)(axisType)
                },
                {
                    name: "value",
                    type: "float"
                },
                {
                    name: "name",
                    type: "ordinal"
                }
            ],
            encodeDefine: {
                single: 0,
                value: 1,
                itemName: 2
            }
        }).dimensions;
        var list = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(dimensions, this);
        list.initData(data);
        return list;
    };
    /**
   * The raw data is divided into multiple layers and each layer
   *     has same name.
   */ ThemeRiverSeriesModel.prototype.getLayerSeries = function() {
        var data = this.getData();
        var lenCount = data.count();
        var indexArr = [];
        for(var i = 0; i < lenCount; ++i)indexArr[i] = i;
        var timeDim = data.mapDimension("single");
        // data group by name
        var groupResult = (0, $76d619f648247e6d$export$7ab5bda43e13168f)(indexArr, function(index) {
            return data.get("name", index);
        });
        var layerSeries = [];
        groupResult.buckets.each(function(items, key) {
            items.sort(function(index1, index2) {
                return data.get(timeDim, index1) - data.get(timeDim, index2);
            });
            layerSeries.push({
                name: key,
                indices: items
            });
        });
        return layerSeries;
    };
    /**
   * Get data indices for show tooltip content
   */ ThemeRiverSeriesModel.prototype.getAxisTooltipData = function(dim, value, baseAxis) {
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(dim)) dim = dim ? [
            dim
        ] : [];
        var data = this.getData();
        var layerSeries = this.getLayerSeries();
        var indices = [];
        var layerNum = layerSeries.length;
        var nestestValue;
        for(var i = 0; i < layerNum; ++i){
            var minDist = Number.MAX_VALUE;
            var nearestIdx = -1;
            var pointNum = layerSeries[i].indices.length;
            for(var j = 0; j < pointNum; ++j){
                var theValue = data.get(dim[0], layerSeries[i].indices[j]);
                var dist = Math.abs(theValue - value);
                if (dist <= minDist) {
                    nestestValue = theValue;
                    minDist = dist;
                    nearestIdx = layerSeries[i].indices[j];
                }
            }
            indices.push(nearestIdx);
        }
        return {
            dataIndices: indices,
            nestestValue: nestestValue
        };
    };
    ThemeRiverSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var name = data.getName(dataIndex);
        var value = data.get(data.mapDimension("value"), dataIndex);
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
            name: name,
            value: value
        });
    };
    ThemeRiverSeriesModel.type = "series.themeRiver";
    ThemeRiverSeriesModel.dependencies = [
        "singleAxis"
    ];
    ThemeRiverSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        colorBy: "data",
        coordinateSystem: "singleAxis",
        // gap in axis's orthogonal orientation
        boundaryGap: [
            "10%",
            "10%"
        ],
        // legendHoverLink: true,
        singleAxisIndex: 0,
        animationEasing: "linear",
        label: {
            margin: 4,
            show: true,
            position: "left",
            fontSize: 11
        },
        emphasis: {
            label: {
                show: true
            }
        }
    };
    return ThemeRiverSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $5814c4cad54e1e96$export$2e2bcd8739ae039 = $5814c4cad54e1e96$var$ThemeRiverSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $7dda345d99fef8ed$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType("themeRiver", function(seriesModel) {
        var data = seriesModel.getData();
        var single = seriesModel.coordinateSystem;
        var layoutInfo = {};
        // use the axis boundingRect for view
        var rect = single.getRect();
        layoutInfo.rect = rect;
        var boundaryGap = seriesModel.get("boundaryGap");
        var axis = single.getAxis();
        layoutInfo.boundaryGap = boundaryGap;
        if (axis.orient === "horizontal") {
            boundaryGap[0] = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(boundaryGap[0], rect.height);
            boundaryGap[1] = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(boundaryGap[1], rect.height);
            var height = rect.height - boundaryGap[0] - boundaryGap[1];
            $7dda345d99fef8ed$var$doThemeRiverLayout(data, seriesModel, height);
        } else {
            boundaryGap[0] = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(boundaryGap[0], rect.width);
            boundaryGap[1] = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(boundaryGap[1], rect.width);
            var width = rect.width - boundaryGap[0] - boundaryGap[1];
            $7dda345d99fef8ed$var$doThemeRiverLayout(data, seriesModel, width);
        }
        data.setLayout("layoutInfo", layoutInfo);
    });
}
/**
 * The layout information about themeriver
 *
 * @param data  data in the series
 * @param seriesModel  the model object of themeRiver series
 * @param height  value used to compute every series height
 */ function $7dda345d99fef8ed$var$doThemeRiverLayout(data, seriesModel, height) {
    if (!data.count()) return;
    var coordSys = seriesModel.coordinateSystem;
    // the data in each layer are organized into a series.
    var layerSeries = seriesModel.getLayerSeries();
    // the points in each layer.
    var timeDim = data.mapDimension("single");
    var valueDim = data.mapDimension("value");
    var layerPoints = $7a1bd9c2710fea0d$export$871de8747c9eaa88(layerSeries, function(singleLayer) {
        return $7a1bd9c2710fea0d$export$871de8747c9eaa88(singleLayer.indices, function(idx) {
            var pt = coordSys.dataToPoint(data.get(timeDim, idx));
            pt[1] = data.get(valueDim, idx);
            return pt;
        });
    });
    var base = $7dda345d99fef8ed$var$computeBaseline(layerPoints);
    var baseLine = base.y0;
    var ky = height / base.max;
    // set layout information for each item.
    var n = layerSeries.length;
    var m = layerSeries[0].indices.length;
    var baseY0;
    for(var j = 0; j < m; ++j){
        baseY0 = baseLine[j] * ky;
        data.setItemLayout(layerSeries[0].indices[j], {
            layerIndex: 0,
            x: layerPoints[0][j][0],
            y0: baseY0,
            y: layerPoints[0][j][1] * ky
        });
        for(var i = 1; i < n; ++i){
            baseY0 += layerPoints[i - 1][j][1] * ky;
            data.setItemLayout(layerSeries[i].indices[j], {
                layerIndex: i,
                x: layerPoints[i][j][0],
                y0: baseY0,
                y: layerPoints[i][j][1] * ky
            });
        }
    }
}
/**
 * Compute the baseLine of the rawdata
 * Inspired by Lee Byron's paper Stacked Graphs - Geometry & Aesthetics
 *
 * @param  data  the points in each layer
 */ function $7dda345d99fef8ed$var$computeBaseline(data) {
    var layerNum = data.length;
    var pointNum = data[0].length;
    var sums = [];
    var y0 = [];
    var max = 0;
    for(var i = 0; i < pointNum; ++i){
        var temp = 0;
        for(var j = 0; j < layerNum; ++j)temp += data[j][i][1];
        if (temp > max) max = temp;
        sums.push(temp);
    }
    for(var k = 0; k < pointNum; ++k)y0[k] = (max - sums[k]) / 2;
    max = 0;
    for(var l = 0; l < pointNum; ++l){
        var sum = sums[l] + y0[l];
        if (sum > max) max = sum;
    }
    return {
        y0: y0,
        max: max
    };
}



function $e883cd02390b2e6d$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $91b53b7eca57e10b$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $5814c4cad54e1e96$export$2e2bcd8739ae039));
    registers.registerLayout((0, $7dda345d99fef8ed$export$2e2bcd8739ae039));
    registers.registerProcessor((0, $e11a533bf70b759c$export$2e2bcd8739ae039)("themeRiver"));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Initialize all computational message for following algorithm.
 */ function $172d7581b75555e9$export$2cd8252107eb640b(inRoot) {
    var root = inRoot;
    root.hierNode = {
        defaultAncestor: null,
        ancestor: root,
        prelim: 0,
        modifier: 0,
        change: 0,
        shift: 0,
        i: 0,
        thread: null
    };
    var nodes = [
        root
    ];
    var node;
    var children;
    while(node = nodes.pop()){
        // jshint ignore:line
        children = node.children;
        if (node.isExpand && children.length) {
            var n = children.length;
            for(var i = n - 1; i >= 0; i--){
                var child = children[i];
                child.hierNode = {
                    defaultAncestor: null,
                    ancestor: child,
                    prelim: 0,
                    modifier: 0,
                    change: 0,
                    shift: 0,
                    i: i,
                    thread: null
                };
                nodes.push(child);
            }
        }
    }
}
function $172d7581b75555e9$export$f7eff93d75358a2c(node, separation) {
    var children = node.isExpand ? node.children : [];
    var siblings = node.parentNode.children;
    var subtreeW = node.hierNode.i ? siblings[node.hierNode.i - 1] : null;
    if (children.length) {
        $172d7581b75555e9$var$executeShifts(node);
        var midPoint = (children[0].hierNode.prelim + children[children.length - 1].hierNode.prelim) / 2;
        if (subtreeW) {
            node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
            node.hierNode.modifier = node.hierNode.prelim - midPoint;
        } else node.hierNode.prelim = midPoint;
    } else if (subtreeW) node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
    node.parentNode.hierNode.defaultAncestor = $172d7581b75555e9$var$apportion(node, subtreeW, node.parentNode.hierNode.defaultAncestor || siblings[0], separation);
}
function $172d7581b75555e9$export$39e6f19b1ce889be(node) {
    var nodeX = node.hierNode.prelim + node.parentNode.hierNode.modifier;
    node.setLayout({
        x: nodeX
    }, true);
    node.hierNode.modifier += node.parentNode.hierNode.modifier;
}
function $172d7581b75555e9$export$3bf720ece7bc7b2e(cb) {
    return arguments.length ? cb : $172d7581b75555e9$var$defaultSeparation;
}
function $172d7581b75555e9$export$60198ec123d36099(rad, r) {
    rad -= Math.PI / 2;
    return {
        x: r * Math.cos(rad),
        y: r * Math.sin(rad)
    };
}
/**
 * All other shifts, applied to the smaller subtrees between w- and w+, are
 * performed by this function.
 *
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ function $172d7581b75555e9$var$executeShifts(node) {
    var children = node.children;
    var n = children.length;
    var shift = 0;
    var change = 0;
    while(--n >= 0){
        var child = children[n];
        child.hierNode.prelim += shift;
        child.hierNode.modifier += shift;
        change += child.hierNode.change;
        shift += child.hierNode.shift + change;
    }
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * The core of the algorithm. Here, a new subtree is combined with the
 * previous subtrees. Threads are used to traverse the inside and outside
 * contours of the left and right subtree up to the highest common level.
 * Whenever two nodes of the inside contours conflict, we compute the left
 * one of the greatest uncommon ancestors using the function nextAncestor()
 * and call moveSubtree() to shift the subtree and prepare the shifts of
 * smaller subtrees. Finally, we add a new thread (if necessary).
 */ function $172d7581b75555e9$var$apportion(subtreeV, subtreeW, ancestor, separation) {
    if (subtreeW) {
        var nodeOutRight = subtreeV;
        var nodeInRight = subtreeV;
        var nodeOutLeft = nodeInRight.parentNode.children[0];
        var nodeInLeft = subtreeW;
        var sumOutRight = nodeOutRight.hierNode.modifier;
        var sumInRight = nodeInRight.hierNode.modifier;
        var sumOutLeft = nodeOutLeft.hierNode.modifier;
        var sumInLeft = nodeInLeft.hierNode.modifier;
        while(nodeInLeft = $172d7581b75555e9$var$nextRight(nodeInLeft), nodeInRight = $172d7581b75555e9$var$nextLeft(nodeInRight), nodeInLeft && nodeInRight){
            nodeOutRight = $172d7581b75555e9$var$nextRight(nodeOutRight);
            nodeOutLeft = $172d7581b75555e9$var$nextLeft(nodeOutLeft);
            nodeOutRight.hierNode.ancestor = subtreeV;
            var shift = nodeInLeft.hierNode.prelim + sumInLeft - nodeInRight.hierNode.prelim - sumInRight + separation(nodeInLeft, nodeInRight);
            if (shift > 0) {
                $172d7581b75555e9$var$moveSubtree($172d7581b75555e9$var$nextAncestor(nodeInLeft, subtreeV, ancestor), subtreeV, shift);
                sumInRight += shift;
                sumOutRight += shift;
            }
            sumInLeft += nodeInLeft.hierNode.modifier;
            sumInRight += nodeInRight.hierNode.modifier;
            sumOutRight += nodeOutRight.hierNode.modifier;
            sumOutLeft += nodeOutLeft.hierNode.modifier;
        }
        if (nodeInLeft && !$172d7581b75555e9$var$nextRight(nodeOutRight)) {
            nodeOutRight.hierNode.thread = nodeInLeft;
            nodeOutRight.hierNode.modifier += sumInLeft - sumOutRight;
        }
        if (nodeInRight && !$172d7581b75555e9$var$nextLeft(nodeOutLeft)) {
            nodeOutLeft.hierNode.thread = nodeInRight;
            nodeOutLeft.hierNode.modifier += sumInRight - sumOutLeft;
            ancestor = subtreeV;
        }
    }
    return ancestor;
}
/**
 * This function is used to traverse the right contour of a subtree.
 * It returns the rightmost child of node or the thread of node. The function
 * returns null if and only if node is on the highest depth of its subtree.
 */ function $172d7581b75555e9$var$nextRight(node) {
    var children = node.children;
    return children.length && node.isExpand ? children[children.length - 1] : node.hierNode.thread;
}
/**
 * This function is used to traverse the left contour of a subtree (or a subforest).
 * It returns the leftmost child of node or the thread of node. The function
 * returns null if and only if node is on the highest depth of its subtree.
 */ function $172d7581b75555e9$var$nextLeft(node) {
    var children = node.children;
    return children.length && node.isExpand ? children[0] : node.hierNode.thread;
}
/**
 * If nodeInLeft’s ancestor is a sibling of node, returns nodeInLeft’s ancestor.
 * Otherwise, returns the specified ancestor.
 */ function $172d7581b75555e9$var$nextAncestor(nodeInLeft, node, ancestor) {
    return nodeInLeft.hierNode.ancestor.parentNode === node.parentNode ? nodeInLeft.hierNode.ancestor : ancestor;
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * Shifts the current subtree rooted at wr.
 * This is done by increasing prelim(w+) and modifier(w+) by shift.
 */ function $172d7581b75555e9$var$moveSubtree(wl, wr, shift) {
    var change = shift / (wr.hierNode.i - wl.hierNode.i);
    wr.hierNode.change -= change;
    wr.hierNode.shift += shift;
    wr.hierNode.modifier += shift;
    wr.hierNode.prelim += shift;
    wl.hierNode.change += change;
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ function $172d7581b75555e9$var$defaultSeparation(node1, node2) {
    return node1.parentNode === node2.parentNode ? 1 : 2;
}











var $c673dc2ab6ad4136$var$TreeEdgeShape = /** @class */ function() {
    function TreeEdgeShape() {
        this.parentPoint = [];
        this.childPoints = [];
    }
    return TreeEdgeShape;
}();
var $c673dc2ab6ad4136$var$TreePath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TreePath, _super);
    function TreePath(opts) {
        return _super.call(this, opts) || this;
    }
    TreePath.prototype.getDefaultStyle = function() {
        return {
            stroke: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral99,
            fill: null
        };
    };
    TreePath.prototype.getDefaultShape = function() {
        return new $c673dc2ab6ad4136$var$TreeEdgeShape();
    };
    TreePath.prototype.buildPath = function(ctx, shape) {
        var childPoints = shape.childPoints;
        var childLen = childPoints.length;
        var parentPoint = shape.parentPoint;
        var firstChildPos = childPoints[0];
        var lastChildPos = childPoints[childLen - 1];
        if (childLen === 1) {
            ctx.moveTo(parentPoint[0], parentPoint[1]);
            ctx.lineTo(firstChildPos[0], firstChildPos[1]);
            return;
        }
        var orient = shape.orient;
        var forkDim = orient === "TB" || orient === "BT" ? 0 : 1;
        var otherDim = 1 - forkDim;
        var forkPosition = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(shape.forkPosition, 1);
        var tmpPoint = [];
        tmpPoint[forkDim] = parentPoint[forkDim];
        tmpPoint[otherDim] = parentPoint[otherDim] + (lastChildPos[otherDim] - parentPoint[otherDim]) * forkPosition;
        ctx.moveTo(parentPoint[0], parentPoint[1]);
        ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        ctx.moveTo(firstChildPos[0], firstChildPos[1]);
        tmpPoint[forkDim] = firstChildPos[forkDim];
        ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        tmpPoint[forkDim] = lastChildPos[forkDim];
        ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        ctx.lineTo(lastChildPos[0], lastChildPos[1]);
        for(var i = 1; i < childLen - 1; i++){
            var point = childPoints[i];
            ctx.moveTo(point[0], point[1]);
            tmpPoint[forkDim] = point[forkDim];
            ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        }
    };
    return TreePath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
var $c673dc2ab6ad4136$var$TreeView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TreeView, _super);
    function TreeView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TreeView.type;
        _this._mainGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        return _this;
    }
    TreeView.prototype.init = function(ecModel, api) {
        this._controller = new (0, $15927f329deeab51$export$2e2bcd8739ae039)(api.getZr());
        this._controllerHost = {
            target: this.group
        };
        this.group.add(this._mainGroup);
    };
    TreeView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var layoutInfo = seriesModel.layoutInfo;
        var group = this._mainGroup;
        var layout = seriesModel.get("layout");
        if (layout === "radial") {
            group.x = layoutInfo.x + layoutInfo.width / 2;
            group.y = layoutInfo.y + layoutInfo.height / 2;
        } else {
            group.x = layoutInfo.x;
            group.y = layoutInfo.y;
        }
        this._updateViewCoordSys(seriesModel, api);
        this._updateController(seriesModel, null, ecModel, api);
        var oldData = this._data;
        data.diff(oldData).add(function(newIdx) {
            if ($c673dc2ab6ad4136$var$symbolNeedsDraw(data, newIdx)) // Create node and edge
            $c673dc2ab6ad4136$var$updateNode(data, newIdx, null, group, seriesModel);
        }).update(function(newIdx, oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            if (!$c673dc2ab6ad4136$var$symbolNeedsDraw(data, newIdx)) {
                symbolEl && $c673dc2ab6ad4136$var$removeNode(oldData, oldIdx, symbolEl, group, seriesModel);
                return;
            }
            // Update node and edge
            $c673dc2ab6ad4136$var$updateNode(data, newIdx, symbolEl, group, seriesModel);
        }).remove(function(oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            // When remove a collapsed node of subtree, since the collapsed
            // node haven't been initialized with a symbol element,
            // you can't found it's symbol element through index.
            // so if we want to remove the symbol element we should insure
            // that the symbol element is not null.
            if (symbolEl) $c673dc2ab6ad4136$var$removeNode(oldData, oldIdx, symbolEl, group, seriesModel);
        }).execute();
        this._nodeScaleRatio = seriesModel.get("nodeScaleRatio");
        this._updateNodeAndLinkScale(seriesModel);
        if (seriesModel.get("expandAndCollapse") === true) data.eachItemGraphicEl(function(el, dataIndex) {
            el.off("click").on("click", function() {
                api.dispatchAction({
                    type: "treeExpandAndCollapse",
                    seriesId: seriesModel.id,
                    dataIndex: dataIndex
                });
            });
        });
        this._data = data;
    };
    TreeView.prototype._updateViewCoordSys = function(seriesModel, api) {
        var data = seriesModel.getData();
        var points = [];
        data.each(function(idx) {
            var layout = data.getItemLayout(idx);
            if (layout && !isNaN(layout.x) && !isNaN(layout.y)) points.push([
                +layout.x,
                +layout.y
            ]);
        });
        var min = [];
        var max = [];
        $af3aab2435198f82$export$188c3cd07b4129dd(points, min, max);
        // If don't Store min max when collapse the root node after roam,
        // the root node will disappear.
        var oldMin = this._min;
        var oldMax = this._max;
        // If width or height is 0
        if (max[0] - min[0] === 0) {
            min[0] = oldMin ? oldMin[0] : min[0] - 1;
            max[0] = oldMax ? oldMax[0] : max[0] + 1;
        }
        if (max[1] - min[1] === 0) {
            min[1] = oldMin ? oldMin[1] : min[1] - 1;
            max[1] = oldMax ? oldMax[1] : max[1] + 1;
        }
        var viewCoordSys = seriesModel.coordinateSystem = new (0, $4a92e7570d47c1fe$export$2e2bcd8739ae039)(null, {
            api: api,
            ecModel: seriesModel.ecModel
        });
        viewCoordSys.zoomLimit = seriesModel.get("scaleLimit");
        viewCoordSys.setBoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
        viewCoordSys.setCenter(seriesModel.get("center"));
        viewCoordSys.setZoom(seriesModel.get("zoom"));
        // Here we use viewCoordSys just for computing the 'position' and 'scale' of the group,
        // and 'treeRoam' action.
        this.group.attr({
            x: viewCoordSys.x,
            y: viewCoordSys.y,
            scaleX: viewCoordSys.scaleX,
            scaleY: viewCoordSys.scaleY
        });
        this._min = min;
        this._max = max;
    };
    TreeView.prototype._updateController = function(seriesModel, clipRect, ecModel, api) {
        var _this = this;
        $35fd859fd545c4be$export$805408382b623838(seriesModel, api, this.group, this._controller, this._controllerHost, clipRect);
        this._controller.on("zoom", function(e) {
            _this._updateNodeAndLinkScale(seriesModel);
        });
    };
    TreeView.prototype._updateNodeAndLinkScale = function(seriesModel) {
        var data = seriesModel.getData();
        var nodeScale = this._getNodeGlobalScale(seriesModel);
        data.eachItemGraphicEl(function(el, idx) {
            el.setSymbolScale(nodeScale);
        });
    };
    TreeView.prototype._getNodeGlobalScale = function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys.type !== "view") return 1;
        var nodeScaleRatio = this._nodeScaleRatio;
        var groupZoom = coordSys.scaleX || 1;
        // Scale node when zoom changes
        var roamZoom = coordSys.getZoom();
        var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
        return nodeScale / groupZoom;
    };
    TreeView.prototype.dispose = function() {
        this._controller && this._controller.dispose();
        this._controllerHost = null;
    };
    TreeView.prototype.remove = function() {
        this._mainGroup.removeAll();
        this._data = null;
    };
    TreeView.type = "tree";
    return TreeView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
function $c673dc2ab6ad4136$var$symbolNeedsDraw(data, dataIndex) {
    var layout = data.getItemLayout(dataIndex);
    return layout && !isNaN(layout.x) && !isNaN(layout.y);
}
function $c673dc2ab6ad4136$var$updateNode(data, dataIndex, symbolEl, group, seriesModel) {
    var isInit = !symbolEl;
    var node = data.tree.getNodeByDataIndex(dataIndex);
    var itemModel = node.getModel();
    var visualColor = node.getVisual("style").fill;
    var symbolInnerColor = node.isExpand === false && node.children.length !== 0 ? visualColor : (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral00;
    var virtualRoot = data.tree.root;
    var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
    var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
    var sourceLayout = source.getLayout();
    var sourceOldLayout = sourceSymbolEl ? {
        x: sourceSymbolEl.__oldX,
        y: sourceSymbolEl.__oldY,
        rawX: sourceSymbolEl.__radialOldRawX,
        rawY: sourceSymbolEl.__radialOldRawY
    } : sourceLayout;
    var targetLayout = node.getLayout();
    if (isInit) {
        symbolEl = new (0, $b1d9c3e17ccace80$export$2e2bcd8739ae039)(data, dataIndex, null, {
            symbolInnerColor: symbolInnerColor,
            useNameLabel: true
        });
        symbolEl.x = sourceOldLayout.x;
        symbolEl.y = sourceOldLayout.y;
    } else symbolEl.updateData(data, dataIndex, null, {
        symbolInnerColor: symbolInnerColor,
        useNameLabel: true
    });
    symbolEl.__radialOldRawX = symbolEl.__radialRawX;
    symbolEl.__radialOldRawY = symbolEl.__radialRawY;
    symbolEl.__radialRawX = targetLayout.rawX;
    symbolEl.__radialRawY = targetLayout.rawY;
    group.add(symbolEl);
    data.setItemGraphicEl(dataIndex, symbolEl);
    symbolEl.__oldX = symbolEl.x;
    symbolEl.__oldY = symbolEl.y;
    $8b353638fbedfefa$export$c8dce3c08436e91e(symbolEl, {
        x: targetLayout.x,
        y: targetLayout.y
    }, seriesModel);
    var symbolPath = symbolEl.getSymbolPath();
    if (seriesModel.get("layout") === "radial") {
        var realRoot = virtualRoot.children[0];
        var rootLayout = realRoot.getLayout();
        var length_1 = realRoot.children.length;
        var rad = void 0;
        var isLeft = void 0;
        if (targetLayout.x === rootLayout.x && node.isExpand === true && realRoot.children.length) {
            var center = {
                x: (realRoot.children[0].getLayout().x + realRoot.children[length_1 - 1].getLayout().x) / 2,
                y: (realRoot.children[0].getLayout().y + realRoot.children[length_1 - 1].getLayout().y) / 2
            };
            rad = Math.atan2(center.y - rootLayout.y, center.x - rootLayout.x);
            if (rad < 0) rad = Math.PI * 2 + rad;
            isLeft = center.x < rootLayout.x;
            if (isLeft) rad = rad - Math.PI;
        } else {
            rad = Math.atan2(targetLayout.y - rootLayout.y, targetLayout.x - rootLayout.x);
            if (rad < 0) rad = Math.PI * 2 + rad;
            if (node.children.length === 0 || node.children.length !== 0 && node.isExpand === false) {
                isLeft = targetLayout.x < rootLayout.x;
                if (isLeft) rad = rad - Math.PI;
            } else {
                isLeft = targetLayout.x > rootLayout.x;
                if (!isLeft) rad = rad - Math.PI;
            }
        }
        var textPosition = isLeft ? "left" : "right";
        var normalLabelModel = itemModel.getModel("label");
        var rotate = normalLabelModel.get("rotate");
        var labelRotateRadian = rotate * (Math.PI / 180);
        var textContent = symbolPath.getTextContent();
        if (textContent) {
            symbolPath.setTextConfig({
                position: normalLabelModel.get("position") || textPosition,
                rotation: rotate == null ? -rad : labelRotateRadian,
                origin: "center"
            });
            textContent.setStyle("verticalAlign", "middle");
        }
    }
    // Handle status
    var focus = itemModel.get([
        "emphasis",
        "focus"
    ]);
    var focusDataIndices = focus === "relative" ? $7a1bd9c2710fea0d$export$4fd8af2c48c43416(node.getAncestorsIndices(), node.getDescendantIndices()) : focus === "ancestor" ? node.getAncestorsIndices() : focus === "descendant" ? node.getDescendantIndices() : null;
    if (focusDataIndices) // Modify the focus to data indices.
    (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(symbolEl).focus = focusDataIndices;
    $c673dc2ab6ad4136$var$drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group);
    if (symbolEl.__edge) symbolEl.onHoverStateChange = function(toState) {
        if (toState !== "blur") {
            // NOTE: Ensure the parent elements will been blurred firstly.
            // According to the return of getAncestorsIndices and getDescendantIndices
            // TODO: A bit tricky.
            var parentEl = node.parentNode && data.getItemGraphicEl(node.parentNode.dataIndex);
            if (!(parentEl && parentEl.hoverState === (0, $2bf82c0980125b62$export$1307d6a87d56baa))) (0, $2bf82c0980125b62$export$868ba38adffa9e39)(symbolEl.__edge, toState);
        }
    };
}
function $c673dc2ab6ad4136$var$drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group) {
    var itemModel = node.getModel();
    var edgeShape = seriesModel.get("edgeShape");
    var layout = seriesModel.get("layout");
    var orient = seriesModel.getOrient();
    var curvature = seriesModel.get([
        "lineStyle",
        "curveness"
    ]);
    var edgeForkPosition = seriesModel.get("edgeForkPosition");
    var lineStyle = itemModel.getModel("lineStyle").getLineStyle();
    var edge = symbolEl.__edge;
    // curve edge from node -> parent
    // polyline edge from node -> children
    if (edgeShape === "curve") {
        if (node.parentNode && node.parentNode !== virtualRoot) {
            if (!edge) edge = symbolEl.__edge = new $6c7800c49630e431$export$2e2bcd8739ae039({
                shape: $c673dc2ab6ad4136$var$getEdgeShape(layout, orient, curvature, sourceOldLayout, sourceOldLayout)
            });
            $8b353638fbedfefa$export$c8dce3c08436e91e(edge, {
                shape: $c673dc2ab6ad4136$var$getEdgeShape(layout, orient, curvature, sourceLayout, targetLayout)
            }, seriesModel);
        }
    } else if (edgeShape === "polyline") {
        if (layout === "orthogonal") {
            if (node !== virtualRoot && node.children && node.children.length !== 0 && node.isExpand === true) {
                var children = node.children;
                var childPoints = [];
                for(var i = 0; i < children.length; i++){
                    var childLayout = children[i].getLayout();
                    childPoints.push([
                        childLayout.x,
                        childLayout.y
                    ]);
                }
                if (!edge) edge = symbolEl.__edge = new $c673dc2ab6ad4136$var$TreePath({
                    shape: {
                        parentPoint: [
                            targetLayout.x,
                            targetLayout.y
                        ],
                        childPoints: [
                            [
                                targetLayout.x,
                                targetLayout.y
                            ]
                        ],
                        orient: orient,
                        forkPosition: edgeForkPosition
                    }
                });
                $8b353638fbedfefa$export$c8dce3c08436e91e(edge, {
                    shape: {
                        parentPoint: [
                            targetLayout.x,
                            targetLayout.y
                        ],
                        childPoints: childPoints
                    }
                }, seriesModel);
            }
        }
    }
    // show all edge when edgeShape is 'curve', filter node `isExpand` is false when edgeShape is 'polyline'
    if (edge && !(edgeShape === "polyline" && !node.isExpand)) {
        edge.useStyle($7a1bd9c2710fea0d$export$ebe90cb607ad99e({
            strokeNoScale: true,
            fill: null
        }, lineStyle));
        (0, $2bf82c0980125b62$export$48b68047d330bbc9)(edge, itemModel, "lineStyle");
        (0, $2bf82c0980125b62$export$20f39bbe322fb9ab)(edge);
        group.add(edge);
    }
}
function $c673dc2ab6ad4136$var$removeNodeEdge(node, data, group, seriesModel, removeAnimationOpt) {
    var virtualRoot = data.tree.root;
    var _a = $c673dc2ab6ad4136$var$getSourceNode(virtualRoot, node), source = _a.source, sourceLayout = _a.sourceLayout;
    var symbolEl = data.getItemGraphicEl(node.dataIndex);
    if (!symbolEl) return;
    var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
    var sourceEdge = sourceSymbolEl.__edge;
    // 1. when expand the sub tree, delete the children node should delete the edge of
    // the source at the same time. because the polyline edge shape is only owned by the source.
    // 2.when the node is the only children of the source, delete the node should delete the edge of
    // the source at the same time. the same reason as above.
    var edge = symbolEl.__edge || (source.isExpand === false || source.children.length === 1 ? sourceEdge : undefined);
    var edgeShape = seriesModel.get("edgeShape");
    var layoutOpt = seriesModel.get("layout");
    var orient = seriesModel.get("orient");
    var curvature = seriesModel.get([
        "lineStyle",
        "curveness"
    ]);
    if (edge) {
        if (edgeShape === "curve") $8b353638fbedfefa$export$f883456a56996078(edge, {
            shape: $c673dc2ab6ad4136$var$getEdgeShape(layoutOpt, orient, curvature, sourceLayout, sourceLayout),
            style: {
                opacity: 0
            }
        }, seriesModel, {
            cb: function() {
                group.remove(edge);
            },
            removeOpt: removeAnimationOpt
        });
        else if (edgeShape === "polyline" && seriesModel.get("layout") === "orthogonal") $8b353638fbedfefa$export$f883456a56996078(edge, {
            shape: {
                parentPoint: [
                    sourceLayout.x,
                    sourceLayout.y
                ],
                childPoints: [
                    [
                        sourceLayout.x,
                        sourceLayout.y
                    ]
                ]
            },
            style: {
                opacity: 0
            }
        }, seriesModel, {
            cb: function() {
                group.remove(edge);
            },
            removeOpt: removeAnimationOpt
        });
    }
}
function $c673dc2ab6ad4136$var$getSourceNode(virtualRoot, node) {
    var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
    var sourceLayout;
    while(sourceLayout = source.getLayout(), sourceLayout == null)source = source.parentNode === virtualRoot ? source : source.parentNode || source;
    return {
        source: source,
        sourceLayout: sourceLayout
    };
}
function $c673dc2ab6ad4136$var$removeNode(data, dataIndex, symbolEl, group, seriesModel) {
    var node = data.tree.getNodeByDataIndex(dataIndex);
    var virtualRoot = data.tree.root;
    var sourceLayout = $c673dc2ab6ad4136$var$getSourceNode(virtualRoot, node).sourceLayout;
    // Use same duration and easing with update to have more consistent animation.
    var removeAnimationOpt = {
        duration: seriesModel.get("animationDurationUpdate"),
        easing: seriesModel.get("animationEasingUpdate")
    };
    $8b353638fbedfefa$export$f883456a56996078(symbolEl, {
        x: sourceLayout.x + 1,
        y: sourceLayout.y + 1
    }, seriesModel, {
        cb: function() {
            group.remove(symbolEl);
            data.setItemGraphicEl(dataIndex, null);
        },
        removeOpt: removeAnimationOpt
    });
    symbolEl.fadeOut(null, data.hostModel, {
        fadeLabel: true,
        animation: removeAnimationOpt
    });
    // remove edge as parent node
    node.children.forEach(function(childNode) {
        $c673dc2ab6ad4136$var$removeNodeEdge(childNode, data, group, seriesModel, removeAnimationOpt);
    });
    // remove edge as child node
    $c673dc2ab6ad4136$var$removeNodeEdge(node, data, group, seriesModel, removeAnimationOpt);
}
function $c673dc2ab6ad4136$var$getEdgeShape(layoutOpt, orient, curvature, sourceLayout, targetLayout) {
    var cpx1;
    var cpy1;
    var cpx2;
    var cpy2;
    var x1;
    var x2;
    var y1;
    var y2;
    if (layoutOpt === "radial") {
        x1 = sourceLayout.rawX;
        y1 = sourceLayout.rawY;
        x2 = targetLayout.rawX;
        y2 = targetLayout.rawY;
        var radialCoor1 = (0, $172d7581b75555e9$export$60198ec123d36099)(x1, y1);
        var radialCoor2 = (0, $172d7581b75555e9$export$60198ec123d36099)(x1, y1 + (y2 - y1) * curvature);
        var radialCoor3 = (0, $172d7581b75555e9$export$60198ec123d36099)(x2, y2 + (y1 - y2) * curvature);
        var radialCoor4 = (0, $172d7581b75555e9$export$60198ec123d36099)(x2, y2);
        return {
            x1: radialCoor1.x || 0,
            y1: radialCoor1.y || 0,
            x2: radialCoor4.x || 0,
            y2: radialCoor4.y || 0,
            cpx1: radialCoor2.x || 0,
            cpy1: radialCoor2.y || 0,
            cpx2: radialCoor3.x || 0,
            cpy2: radialCoor3.y || 0
        };
    } else {
        x1 = sourceLayout.x;
        y1 = sourceLayout.y;
        x2 = targetLayout.x;
        y2 = targetLayout.y;
        if (orient === "LR" || orient === "RL") {
            cpx1 = x1 + (x2 - x1) * curvature;
            cpy1 = y1;
            cpx2 = x2 + (x1 - x2) * curvature;
            cpy2 = y2;
        }
        if (orient === "TB" || orient === "BT") {
            cpx1 = x1;
            cpy1 = y1 + (y2 - y1) * curvature;
            cpx2 = x2;
            cpy2 = y2 + (y1 - y2) * curvature;
        }
    }
    return {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
        cpx1: cpx1,
        cpy1: cpy1,
        cpx2: cpx2,
        cpy2: cpy2
    };
}
var $c673dc2ab6ad4136$export$2e2bcd8739ae039 = $c673dc2ab6ad4136$var$TreeView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $908076d89767d409$var$TreeSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TreeSeriesModel, _super);
    function TreeSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasSymbolVisual = true;
        // Do it self.
        _this.ignoreStyleOnData = true;
        return _this;
    }
    /**
   * Init a tree data structure from data in option series
   */ TreeSeriesModel.prototype.getInitialData = function(option) {
        // create a virtual root
        var root = {
            name: option.name,
            children: option.data
        };
        var leaves = option.leaves || {};
        var leavesModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(leaves, this, this.ecModel);
        var tree = (0, $116fa5bb9335391f$export$2e2bcd8739ae039).createTree(root, this, beforeLink);
        function beforeLink(nodeData) {
            nodeData.wrapMethod("getItemModel", function(model, idx) {
                var node = tree.getNodeByDataIndex(idx);
                if (!(node && node.children.length && node.isExpand)) model.parentModel = leavesModel;
                return model;
            });
        }
        var treeDepth = 0;
        tree.eachNode("preorder", function(node) {
            if (node.depth > treeDepth) treeDepth = node.depth;
        });
        var expandAndCollapse = option.expandAndCollapse;
        var expandTreeDepth = expandAndCollapse && option.initialTreeDepth >= 0 ? option.initialTreeDepth : treeDepth;
        tree.root.eachNode("preorder", function(node) {
            var item = node.hostTree.data.getRawDataItem(node.dataIndex);
            // Add item.collapsed != null, because users can collapse node original in the series.data.
            node.isExpand = item && item.collapsed != null ? !item.collapsed : node.depth <= expandTreeDepth;
        });
        return tree.data;
    };
    /**
   * Make the configuration 'orient' backward compatibly, with 'horizontal = LR', 'vertical = TB'.
   * @returns {string} orient
   */ TreeSeriesModel.prototype.getOrient = function() {
        var orient = this.get("orient");
        if (orient === "horizontal") orient = "LR";
        else if (orient === "vertical") orient = "TB";
        return orient;
    };
    TreeSeriesModel.prototype.setZoom = function(zoom) {
        this.option.zoom = zoom;
    };
    TreeSeriesModel.prototype.setCenter = function(center) {
        this.option.center = center;
    };
    TreeSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var tree = this.getData().tree;
        var realRoot = tree.root.children[0];
        var node = tree.getNodeByDataIndex(dataIndex);
        var value = node.getValue();
        var name = node.name;
        while(node && node !== realRoot){
            name = node.parentNode.name + "." + name;
            node = node.parentNode;
        }
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
            name: name,
            value: value,
            noValue: isNaN(value) || value == null
        });
    };
    // Add tree path to tooltip param
    TreeSeriesModel.prototype.getDataParams = function(dataIndex) {
        var params = _super.prototype.getDataParams.apply(this, arguments);
        var node = this.getData().tree.getNodeByDataIndex(dataIndex);
        params.treeAncestors = (0, $6341f66602946a06$export$c5baa480d6ceb0a3)(node, this);
        params.collapsed = !node.isExpand;
        return params;
    };
    TreeSeriesModel.type = "series.tree";
    // can support the position parameters 'left', 'top','right','bottom', 'width',
    // 'height' in the setOption() with 'merge' mode normal.
    TreeSeriesModel.layoutMode = "box";
    TreeSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        // `coordinateSystem` can be declared as 'matrix', 'calendar',
        //  which provides box layout container.
        coordinateSystemUsage: "box",
        // the position of the whole view
        left: "12%",
        top: "12%",
        right: "12%",
        bottom: "12%",
        // the layout of the tree, two value can be selected, 'orthogonal' or 'radial'
        layout: "orthogonal",
        // value can be 'polyline'
        edgeShape: "curve",
        edgeForkPosition: "50%",
        // true | false | 'move' | 'scale', see module:component/helper/RoamController.
        roam: false,
        roamTrigger: "global",
        // Symbol size scale ratio in roam
        nodeScaleRatio: 0.4,
        // Default on center of graph
        center: null,
        zoom: 1,
        orient: "LR",
        symbol: "emptyCircle",
        symbolSize: 7,
        expandAndCollapse: true,
        initialTreeDepth: 2,
        lineStyle: {
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.borderTint,
            width: 1.5,
            curveness: 0.5
        },
        itemStyle: {
            color: "lightsteelblue",
            // borderColor: '#c23531',
            borderWidth: 1.5
        },
        label: {
            show: true
        },
        animationEasing: "linear",
        animationDuration: 700,
        animationDurationUpdate: 500
    };
    return TreeSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $908076d89767d409$export$2e2bcd8739ae039 = $908076d89767d409$var$TreeSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Traverse the tree from bottom to top and do something
 */ function $40241c7ef27c3238$export$bd961f70bc91ffb4(root, callback, separation) {
    var nodes = [
        root
    ];
    var next = [];
    var node;
    while(node = nodes.pop()){
        // jshint ignore:line
        next.push(node);
        if (node.isExpand) {
            var children = node.children;
            if (children.length) for(var i = 0; i < children.length; i++)nodes.push(children[i]);
        }
    }
    while(node = next.pop())// jshint ignore:line
    callback(node, separation);
}
/**
 * Traverse the tree from top to bottom and do something
 */ function $40241c7ef27c3238$export$32a66ec2b39acdac(root, callback) {
    var nodes = [
        root
    ];
    var node;
    while(node = nodes.pop()){
        // jshint ignore:line
        callback(node);
        if (node.isExpand) {
            var children = node.children;
            if (children.length) for(var i = children.length - 1; i >= 0; i--)nodes.push(children[i]);
        }
    }
}




function $121bf97d85edc8b9$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType("tree", function(seriesModel) {
        $121bf97d85edc8b9$var$commonLayout(seriesModel, api);
    });
}
function $121bf97d85edc8b9$var$commonLayout(seriesModel, api) {
    var refContainer = (0, $93b9bc7f22ac7369$export$5aec1e94f566e59f)(seriesModel, api).refContainer;
    var layoutInfo = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(seriesModel.getBoxLayoutParams(), refContainer);
    seriesModel.layoutInfo = layoutInfo;
    var layout = seriesModel.get("layout");
    var width = 0;
    var height = 0;
    var separation = null;
    if (layout === "radial") {
        width = 2 * Math.PI;
        height = Math.min(layoutInfo.height, layoutInfo.width) / 2;
        separation = (0, $172d7581b75555e9$export$3bf720ece7bc7b2e)(function(node1, node2) {
            return (node1.parentNode === node2.parentNode ? 1 : 2) / node1.depth;
        });
    } else {
        width = layoutInfo.width;
        height = layoutInfo.height;
        separation = (0, $172d7581b75555e9$export$3bf720ece7bc7b2e)();
    }
    var virtualRoot = seriesModel.getData().tree.root;
    var realRoot = virtualRoot.children[0];
    if (realRoot) {
        (0, $172d7581b75555e9$export$2cd8252107eb640b)(virtualRoot);
        (0, $40241c7ef27c3238$export$bd961f70bc91ffb4)(realRoot, (0, $172d7581b75555e9$export$f7eff93d75358a2c), separation);
        virtualRoot.hierNode.modifier = -realRoot.hierNode.prelim;
        (0, $40241c7ef27c3238$export$32a66ec2b39acdac)(realRoot, (0, $172d7581b75555e9$export$39e6f19b1ce889be));
        var left_1 = realRoot;
        var right_1 = realRoot;
        var bottom_1 = realRoot;
        (0, $40241c7ef27c3238$export$32a66ec2b39acdac)(realRoot, function(node) {
            var x = node.getLayout().x;
            if (x < left_1.getLayout().x) left_1 = node;
            if (x > right_1.getLayout().x) right_1 = node;
            if (node.depth > bottom_1.depth) bottom_1 = node;
        });
        var delta = left_1 === right_1 ? 1 : separation(left_1, right_1) / 2;
        var tx_1 = delta - left_1.getLayout().x;
        var kx_1 = 0;
        var ky_1 = 0;
        var coorX_1 = 0;
        var coorY_1 = 0;
        if (layout === "radial") {
            kx_1 = width / (right_1.getLayout().x + delta + tx_1);
            // here we use (node.depth - 1), bucause the real root's depth is 1
            ky_1 = height / (bottom_1.depth - 1 || 1);
            (0, $40241c7ef27c3238$export$32a66ec2b39acdac)(realRoot, function(node) {
                coorX_1 = (node.getLayout().x + tx_1) * kx_1;
                coorY_1 = (node.depth - 1) * ky_1;
                var finalCoor = (0, $172d7581b75555e9$export$60198ec123d36099)(coorX_1, coorY_1);
                node.setLayout({
                    x: finalCoor.x,
                    y: finalCoor.y,
                    rawX: coorX_1,
                    rawY: coorY_1
                }, true);
            });
        } else {
            var orient_1 = seriesModel.getOrient();
            if (orient_1 === "RL" || orient_1 === "LR") {
                ky_1 = height / (right_1.getLayout().x + delta + tx_1);
                kx_1 = width / (bottom_1.depth - 1 || 1);
                (0, $40241c7ef27c3238$export$32a66ec2b39acdac)(realRoot, function(node) {
                    coorY_1 = (node.getLayout().x + tx_1) * ky_1;
                    coorX_1 = orient_1 === "LR" ? (node.depth - 1) * kx_1 : width - (node.depth - 1) * kx_1;
                    node.setLayout({
                        x: coorX_1,
                        y: coorY_1
                    }, true);
                });
            } else if (orient_1 === "TB" || orient_1 === "BT") {
                kx_1 = width / (right_1.getLayout().x + delta + tx_1);
                ky_1 = height / (bottom_1.depth - 1 || 1);
                (0, $40241c7ef27c3238$export$32a66ec2b39acdac)(realRoot, function(node) {
                    coorX_1 = (node.getLayout().x + tx_1) * kx_1;
                    coorY_1 = orient_1 === "TB" ? (node.depth - 1) * ky_1 : height - (node.depth - 1) * ky_1;
                    node.setLayout({
                        x: coorX_1,
                        y: coorY_1
                    }, true);
                });
            }
        }
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $d90852cc2c74d10f$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType("tree", function(seriesModel) {
        var data = seriesModel.getData();
        var tree = data.tree;
        tree.eachNode(function(node) {
            var model = node.getModel();
            // TODO Optimize
            var style = model.getModel("itemStyle").getItemStyle();
            var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, "style");
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(existsStyle, style);
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $0f83bac2aba33cc4$export$83b6a0f4104bd4f4(registers) {
    registers.registerAction({
        type: "treeExpandAndCollapse",
        event: "treeExpandAndCollapse",
        update: "update"
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "series",
            subType: "tree",
            query: payload
        }, function(seriesModel) {
            var dataIndex = payload.dataIndex;
            var tree = seriesModel.getData().tree;
            var node = tree.getNodeByDataIndex(dataIndex);
            node.isExpand = !node.isExpand;
        });
    });
    registers.registerAction({
        type: "treeRoam",
        event: "treeRoam",
        // Here we set 'none' instead of 'update', because roam action
        // just need to update the transform matrix without having to recalculate
        // the layout. So don't need to go through the whole update process, such
        // as 'dataPrcocess', 'coordSystemUpdate', 'layout' and so on.
        update: "none"
    }, function(payload, ecModel, api) {
        ecModel.eachComponent({
            mainType: "series",
            subType: "tree",
            query: payload
        }, function(seriesModel) {
            var coordSys = seriesModel.coordinateSystem;
            var res = (0, $35fd859fd545c4be$export$94d6a16eae2c4cf4)(coordSys, payload, seriesModel.get("scaleLimit"));
            seriesModel.setCenter(res.center);
            seriesModel.setZoom(res.zoom);
        });
    });
}


function $44a5d4d260c7de78$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $c673dc2ab6ad4136$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $908076d89767d409$export$2e2bcd8739ae039));
    registers.registerLayout((0, $121bf97d85edc8b9$export$2e2bcd8739ae039));
    registers.registerVisual((0, $d90852cc2c74d10f$export$2e2bcd8739ae039));
    (0, $0f83bac2aba33cc4$export$83b6a0f4104bd4f4)(registers);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $26d493e9cdfadb01$var$actionTypes = [
    "treemapZoomToNode",
    "treemapRender",
    "treemapMove"
];
function $26d493e9cdfadb01$export$1ad90fc3f3a8bbf9(registers) {
    for(var i = 0; i < $26d493e9cdfadb01$var$actionTypes.length; i++)registers.registerAction({
        type: $26d493e9cdfadb01$var$actionTypes[i],
        update: "updateView"
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
    registers.registerAction({
        type: "treemapRootToNode",
        update: "updateView"
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "series",
            subType: "treemap",
            query: payload
        }, handleRootToNode);
        function handleRootToNode(model, index) {
            var types = [
                "treemapZoomToNode",
                "treemapRootToNode"
            ];
            var targetInfo = $6341f66602946a06$export$c5445fa59c15dec4(payload, types, model);
            if (targetInfo) {
                var originViewRoot = model.getViewRoot();
                if (originViewRoot) payload.direction = $6341f66602946a06$export$df59de26c77b5bea(originViewRoot, targetInfo.node) ? "rollUp" : "drillDown";
                model.resetViewRoot(targetInfo.node);
            }
        }
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









var $10d079b37d9731a3$var$TreemapSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TreemapSeriesModel, _super);
    function TreemapSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TreemapSeriesModel.type;
        _this.preventUsingHoverLayer = true;
        return _this;
    }
    /**
   * @override
   */ TreemapSeriesModel.prototype.getInitialData = function(option, ecModel) {
        // Create a virtual root.
        var root = {
            name: option.name,
            children: option.data
        };
        $10d079b37d9731a3$var$completeTreeValue(root);
        var levels = option.levels || [];
        // Used in "visual priority" in `treemapVisual.js`.
        // This way is a little tricky, must satisfy the precondition:
        //   1. There is no `treeNode.getModel('itemStyle.xxx')` used.
        //   2. The `Model.prototype.getModel()` will not use any clone-like way.
        var designatedVisualItemStyle = this.designatedVisualItemStyle = {};
        var designatedVisualModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)({
            itemStyle: designatedVisualItemStyle
        }, this, ecModel);
        levels = option.levels = $10d079b37d9731a3$var$setDefault(levels, ecModel);
        var levelModels = $7a1bd9c2710fea0d$export$871de8747c9eaa88(levels || [], function(levelDefine) {
            return new (0, $6818646a97528290$export$2e2bcd8739ae039)(levelDefine, designatedVisualModel, ecModel);
        }, this);
        // Make sure always a new tree is created when setOption,
        // in TreemapView, we check whether oldTree === newTree
        // to choose mappings approach among old shapes and new shapes.
        var tree = (0, $116fa5bb9335391f$export$2e2bcd8739ae039).createTree(root, this, beforeLink);
        function beforeLink(nodeData) {
            nodeData.wrapMethod("getItemModel", function(model, idx) {
                var node = tree.getNodeByDataIndex(idx);
                var levelModel = node ? levelModels[node.depth] : null;
                // If no levelModel, we also need `designatedVisualModel`.
                model.parentModel = levelModel || designatedVisualModel;
                return model;
            });
        }
        return tree.data;
    };
    TreemapSeriesModel.prototype.optionUpdated = function() {
        this.resetViewRoot();
    };
    /**
   * @override
   * @param {number} dataIndex
   * @param {boolean} [mutipleSeries=false]
   */ TreemapSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var value = this.getRawValue(dataIndex);
        var name = data.getName(dataIndex);
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
            name: name,
            value: value
        });
    };
    /**
   * Add tree path to tooltip param
   *
   * @override
   * @param {number} dataIndex
   * @return {Object}
   */ TreemapSeriesModel.prototype.getDataParams = function(dataIndex) {
        var params = _super.prototype.getDataParams.apply(this, arguments);
        var node = this.getData().tree.getNodeByDataIndex(dataIndex);
        params.treeAncestors = (0, $6341f66602946a06$export$c5baa480d6ceb0a3)(node, this);
        // compatitable the previous code.
        params.treePathInfo = params.treeAncestors;
        return params;
    };
    /**
   * @public
   * @param {Object} layoutInfo {
   *                                x: containerGroup x
   *                                y: containerGroup y
   *                                width: containerGroup width
   *                                height: containerGroup height
   *                            }
   */ TreemapSeriesModel.prototype.setLayoutInfo = function(layoutInfo) {
        /**
     * @readOnly
     * @type {Object}
     */ this.layoutInfo = this.layoutInfo || {};
        $7a1bd9c2710fea0d$export$8b58be045bf06082(this.layoutInfo, layoutInfo);
    };
    /**
   * @param  {string} id
   * @return {number} index
   */ TreemapSeriesModel.prototype.mapIdToIndex = function(id) {
        // A feature is implemented:
        // index is monotone increasing with the sequence of
        // input id at the first time.
        // This feature can make sure that each data item and its
        // mapped color have the same index between data list and
        // color list at the beginning, which is useful for user
        // to adjust data-color mapping.
        /**
     * @private
     * @type {Object}
     */ var idIndexMap = this._idIndexMap;
        if (!idIndexMap) {
            idIndexMap = this._idIndexMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
            /**
       * @private
       * @type {number}
       */ this._idIndexMapCount = 0;
        }
        var index = idIndexMap.get(id);
        if (index == null) idIndexMap.set(id, index = this._idIndexMapCount++);
        return index;
    };
    TreemapSeriesModel.prototype.getViewRoot = function() {
        return this._viewRoot;
    };
    TreemapSeriesModel.prototype.resetViewRoot = function(viewRoot) {
        viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
        var root = this.getRawData().tree.root;
        if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) this._viewRoot = root;
    };
    TreemapSeriesModel.prototype.enableAriaDecal = function() {
        (0, $a116b59e46d9072c$export$2e2bcd8739ae039)(this);
    };
    TreemapSeriesModel.type = "series.treemap";
    TreemapSeriesModel.layoutMode = "box";
    TreemapSeriesModel.defaultOption = {
        // Disable progressive rendering
        progressive: 0,
        // size: ['80%', '80%'],            // deprecated, compatible with ec2.
        // `coordinateSystem` can be declared as 'matrix', 'calendar',
        //  which provides box layout container.
        coordinateSystemUsage: "box",
        left: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).size.l,
        top: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).size.xxxl,
        right: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).size.l,
        bottom: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).size.xxxl,
        sort: true,
        clipWindow: "origin",
        squareRatio: 0.5 * (1 + Math.sqrt(5)),
        leafDepth: null,
        drillDownIcon: "\u25B6",
        // to align specialized icon. ▷▶❒❐▼✚
        zoomToNodeRatio: 0.1024,
        scaleLimit: {
            max: 5,
            min: 0.2
        },
        roam: true,
        roamTrigger: "global",
        nodeClick: "zoomToNode",
        animation: true,
        animationDurationUpdate: 900,
        animationEasing: "quinticInOut",
        breadcrumb: {
            show: true,
            height: 22,
            left: "center",
            bottom: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).size.m,
            // right
            // bottom
            emptyItemWidth: 25,
            itemStyle: {
                color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.backgroundShade,
                textStyle: {
                    color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.secondary
                }
            },
            emphasis: {
                itemStyle: {
                    color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.background
                }
            }
        },
        label: {
            show: true,
            // Do not use textDistance, for ellipsis rect just the same as treemap node rect.
            distance: 0,
            padding: 5,
            position: "inside",
            // formatter: null,
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral00,
            overflow: "truncate"
        },
        upperLabel: {
            show: false,
            position: [
                0,
                "50%"
            ],
            height: 20,
            // formatter: null,
            // color: '#fff',
            overflow: "truncate",
            // align: null,
            verticalAlign: "middle"
        },
        itemStyle: {
            color: null,
            colorAlpha: null,
            colorSaturation: null,
            borderWidth: 0,
            gapWidth: 0,
            borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral00,
            borderColorSaturation: null // If specified, borderColor will be ineffective, and the
        },
        emphasis: {
            upperLabel: {
                show: true,
                position: [
                    0,
                    "50%"
                ],
                overflow: "truncate",
                verticalAlign: "middle"
            }
        },
        visualDimension: 0,
        visualMin: null,
        visualMax: null,
        color: [],
        // level[n].color (if necessary).
        // + Specify color list of each level. level[0].color would be global
        // color list if not specified. (see method `setDefault`).
        // + But set as a empty array to forbid fetch color from global palette
        // when using nodeModel.get('color'), otherwise nodes on deep level
        // will always has color palette set and are not able to inherit color
        // from parent node.
        // + TreemapSeries.color can not be set as 'none', otherwise effect
        // legend color fetching (see seriesColor.js).
        colorAlpha: null,
        colorSaturation: null,
        colorMappingBy: "index",
        visibleMin: 10,
        // be rendered. Only works when sort is 'asc' or 'desc'.
        childrenVisibleMin: null,
        // grandchildren will not show.
        // Why grandchildren? If not grandchildren but children,
        // some siblings show children and some not,
        // the appearance may be mess and not consistent,
        levels: [] // Each item: {
    };
    return TreemapSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
/**
 * @param {Object} dataNode
 */ function $10d079b37d9731a3$var$completeTreeValue(dataNode) {
    // Postorder travel tree.
    // If value of none-leaf node is not set,
    // calculate it by suming up the value of all children.
    var sum = 0;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(dataNode.children, function(child) {
        $10d079b37d9731a3$var$completeTreeValue(child);
        var childValue = child.value;
        $7a1bd9c2710fea0d$export$43bee75e5e14138e(childValue) && (childValue = childValue[0]);
        sum += childValue;
    });
    var thisValue = dataNode.value;
    if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(thisValue)) thisValue = thisValue[0];
    if (thisValue == null || isNaN(thisValue)) thisValue = sum;
    // Value should not less than 0.
    if (thisValue < 0) thisValue = 0;
    $7a1bd9c2710fea0d$export$43bee75e5e14138e(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
}
/**
 * set default to level configuration
 */ function $10d079b37d9731a3$var$setDefault(levels, ecModel) {
    var globalColorList = (0, $76d619f648247e6d$export$4f07b212a02c8051)(ecModel.get("color"));
    var globalDecalList = (0, $76d619f648247e6d$export$4f07b212a02c8051)(ecModel.get([
        "aria",
        "decal",
        "decals"
    ]));
    if (!globalColorList) return;
    levels = levels || [];
    var hasColorDefine;
    var hasDecalDefine;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(levels, function(levelDefine) {
        var model = new (0, $6818646a97528290$export$2e2bcd8739ae039)(levelDefine);
        var modelColor = model.get("color");
        var modelDecal = model.get("decal");
        if (model.get([
            "itemStyle",
            "color"
        ]) || modelColor && modelColor !== "none") hasColorDefine = true;
        if (model.get([
            "itemStyle",
            "decal"
        ]) || modelDecal && modelDecal !== "none") hasDecalDefine = true;
    });
    var level0 = levels[0] || (levels[0] = {});
    if (!hasColorDefine) level0.color = globalColorList.slice();
    if (!hasDecalDefine && globalDecalList) level0.decal = globalDecalList.slice();
    return levels;
}
var $10d079b37d9731a3$export$2e2bcd8739ae039 = $10d079b37d9731a3$var$TreemapSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $504a89857fe7780b$var$TEXT_PADDING = 8;
var $504a89857fe7780b$var$ITEM_GAP = 8;
var $504a89857fe7780b$var$ARRAY_LENGTH = 5;
var $504a89857fe7780b$var$Breadcrumb = /** @class */ function() {
    function Breadcrumb(containerGroup) {
        this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        containerGroup.add(this.group);
    }
    Breadcrumb.prototype.render = function(seriesModel, api, targetNode, onSelect) {
        var model = seriesModel.getModel("breadcrumb");
        var thisGroup = this.group;
        thisGroup.removeAll();
        if (!model.get("show") || !targetNode) return;
        var normalStyleModel = model.getModel("itemStyle");
        var emphasisModel = model.getModel("emphasis");
        var textStyleModel = normalStyleModel.getModel("textStyle");
        var emphasisTextStyleModel = emphasisModel.getModel([
            "itemStyle",
            "textStyle"
        ]);
        var refContainer = $93b9bc7f22ac7369$export$5aec1e94f566e59f(seriesModel, api).refContainer;
        var boxLayoutParams = {
            left: model.get("left"),
            right: model.get("right"),
            top: model.get("top"),
            bottom: model.get("bottom")
        };
        var layoutParam = {
            emptyItemWidth: model.get("emptyItemWidth"),
            totalWidth: 0,
            renderList: []
        };
        var availableSize = $93b9bc7f22ac7369$export$4517a5ca639a7293(boxLayoutParams, refContainer);
        this._prepare(targetNode, layoutParam, textStyleModel);
        this._renderContent(seriesModel, layoutParam, availableSize, normalStyleModel, emphasisModel, textStyleModel, emphasisTextStyleModel, onSelect);
        $93b9bc7f22ac7369$export$74054bd96b5eeef1(thisGroup, boxLayoutParams, refContainer);
    };
    /**
   * Prepare render list and total width
   * @private
   */ Breadcrumb.prototype._prepare = function(targetNode, layoutParam, textStyleModel) {
        for(var node = targetNode; node; node = node.parentNode){
            var text = (0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(node.getModel().get("name"), "");
            var textRect = textStyleModel.getTextRect(text);
            var itemWidth = Math.max(textRect.width + $504a89857fe7780b$var$TEXT_PADDING * 2, layoutParam.emptyItemWidth);
            layoutParam.totalWidth += itemWidth + $504a89857fe7780b$var$ITEM_GAP;
            layoutParam.renderList.push({
                node: node,
                text: text,
                width: itemWidth
            });
        }
    };
    /**
   * @private
   */ Breadcrumb.prototype._renderContent = function(seriesModel, layoutParam, availableSize, normalStyleModel, emphasisModel, textStyleModel, emphasisTextStyleModel, onSelect) {
        // Start rendering.
        var lastX = 0;
        var emptyItemWidth = layoutParam.emptyItemWidth;
        var height = seriesModel.get([
            "breadcrumb",
            "height"
        ]);
        var totalWidth = layoutParam.totalWidth;
        var renderList = layoutParam.renderList;
        var emphasisItemStyle = emphasisModel.getModel("itemStyle").getItemStyle();
        for(var i = renderList.length - 1; i >= 0; i--){
            var item = renderList[i];
            var itemNode = item.node;
            var itemWidth = item.width;
            var text = item.text;
            // Hdie text and shorten width if necessary.
            if (totalWidth > availableSize.width) {
                totalWidth -= itemWidth - emptyItemWidth;
                itemWidth = emptyItemWidth;
                text = null;
            }
            var el = new $51acf033123e1a30$export$2e2bcd8739ae039({
                shape: {
                    points: $504a89857fe7780b$var$makeItemPoints(lastX, 0, itemWidth, height, i === renderList.length - 1, i === 0)
                },
                style: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(normalStyleModel.getItemStyle(), {
                    lineJoin: "bevel"
                }),
                textContent: new $fe885cc21795562b$export$2e2bcd8739ae039({
                    style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                        text: text
                    })
                }),
                textConfig: {
                    position: "inside"
                },
                z2: (0, $2bf82c0980125b62$export$1cb9fc6ed5b9836c) * 1e4,
                onclick: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)(onSelect, itemNode)
            });
            el.disableLabelAnimation = true;
            el.getTextContent().ensureState("emphasis").style = (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(emphasisTextStyleModel, {
                text: text
            });
            el.ensureState("emphasis").style = emphasisItemStyle;
            (0, $2bf82c0980125b62$export$e51187539ff11209)(el, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
            this.group.add(el);
            $504a89857fe7780b$var$packEventData(el, seriesModel, itemNode);
            lastX += itemWidth + $504a89857fe7780b$var$ITEM_GAP;
        }
    };
    Breadcrumb.prototype.remove = function() {
        this.group.removeAll();
    };
    return Breadcrumb;
}();
function $504a89857fe7780b$var$makeItemPoints(x, y, itemWidth, itemHeight, head, tail) {
    var points = [
        [
            head ? x : x - $504a89857fe7780b$var$ARRAY_LENGTH,
            y
        ],
        [
            x + itemWidth,
            y
        ],
        [
            x + itemWidth,
            y + itemHeight
        ],
        [
            head ? x : x - $504a89857fe7780b$var$ARRAY_LENGTH,
            y + itemHeight
        ]
    ];
    !tail && points.splice(2, 0, [
        x + itemWidth + $504a89857fe7780b$var$ARRAY_LENGTH,
        y + itemHeight / 2
    ]);
    !head && points.push([
        x,
        y + itemHeight / 2
    ]);
    return points;
}
// Package custom mouse event.
function $504a89857fe7780b$var$packEventData(el, seriesModel, itemNode) {
    (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).eventData = {
        componentType: "series",
        componentSubType: "treemap",
        componentIndex: seriesModel.componentIndex,
        seriesIndex: seriesModel.seriesIndex,
        seriesName: seriesModel.name,
        seriesType: "treemap",
        selfType: "breadcrumb",
        nodeData: {
            dataIndex: itemNode && itemNode.dataIndex,
            name: itemNode && itemNode.name
        },
        treePathInfo: itemNode && (0, $6341f66602946a06$export$c5baa480d6ceb0a3)(itemNode, seriesModel)
    };
}
var $504a89857fe7780b$export$2e2bcd8739ae039 = $504a89857fe7780b$var$Breadcrumb;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Animate multiple elements with a single done-callback.
 *
 * @example
 *  animation
 *      .createWrap()
 *      .add(el1, {x: 10, y: 10})
 *      .add(el2, {shape: {width: 500}, style: {fill: 'red'}}, 400)
 *      .done(function () { // done })
 *      .start('cubicOut');
 */ var $d83d3d8d08e5712f$var$AnimationWrap = /** @class */ function() {
    function AnimationWrap() {
        this._storage = [];
        this._elExistsMap = {};
    }
    /**
   * Caution: a el can only be added once, otherwise 'done'
   * might not be called. This method checks this (by el.id),
   * suppresses adding and returns false when existing el found.
   *
   * @return Whether adding succeeded.
   */ AnimationWrap.prototype.add = function(el, target, duration, delay, easing) {
        if (this._elExistsMap[el.id]) return false;
        this._elExistsMap[el.id] = true;
        this._storage.push({
            el: el,
            target: target,
            duration: duration,
            delay: delay,
            easing: easing
        });
        return true;
    };
    /**
   * Only execute when animation done/aborted.
   */ AnimationWrap.prototype.finished = function(callback) {
        this._finishedCallback = callback;
        return this;
    };
    /**
   * Will stop exist animation firstly.
   */ AnimationWrap.prototype.start = function() {
        var _this = this;
        var count = this._storage.length;
        var checkTerminate = function() {
            count--;
            if (count <= 0) {
                // Guard.
                _this._storage.length = 0;
                _this._elExistsMap = {};
                _this._finishedCallback && _this._finishedCallback();
            }
        };
        for(var i = 0, len = this._storage.length; i < len; i++){
            var item = this._storage[i];
            item.el.animateTo(item.target, {
                duration: item.duration,
                delay: item.delay,
                easing: item.easing,
                setToFinal: true,
                done: checkTerminate,
                aborted: checkTerminate
            });
        }
        return this;
    };
    return AnimationWrap;
}();
function $d83d3d8d08e5712f$export$944643101ee10c7() {
    return new $d83d3d8d08e5712f$var$AnimationWrap();
}








var $ca67abe413e4c090$var$Group = $7ef7583d8302ffce$export$2e2bcd8739ae039;
var $ca67abe413e4c090$var$Rect = $419e5ff2f303755e$export$2e2bcd8739ae039;
var $ca67abe413e4c090$var$DRAG_THRESHOLD = 3;
var $ca67abe413e4c090$var$PATH_LABEL_NOAMAL = "label";
var $ca67abe413e4c090$var$PATH_UPPERLABEL_NORMAL = "upperLabel";
// Should larger than emphasis states lift z
var $ca67abe413e4c090$var$Z2_BASE = (0, $2bf82c0980125b62$export$1cb9fc6ed5b9836c) * 10; // Should bigger than every z2.
var $ca67abe413e4c090$var$Z2_BG = (0, $2bf82c0980125b62$export$1cb9fc6ed5b9836c) * 2;
var $ca67abe413e4c090$var$Z2_CONTENT = (0, $2bf82c0980125b62$export$1cb9fc6ed5b9836c) * 3;
var $ca67abe413e4c090$var$getStateItemStyle = (0, $06542048a26d4d91$export$2e2bcd8739ae039)([
    [
        "fill",
        "color"
    ],
    // `borderColor` and `borderWidth` has been occupied,
    // so use `stroke` to indicate the stroke of the rect.
    [
        "stroke",
        "strokeColor"
    ],
    [
        "lineWidth",
        "strokeWidth"
    ],
    [
        "shadowBlur"
    ],
    [
        "shadowOffsetX"
    ],
    [
        "shadowOffsetY"
    ],
    [
        "shadowColor"
    ]
]);
var $ca67abe413e4c090$var$getItemStyleNormal = function(model) {
    // Normal style props should include emphasis style props.
    var itemStyle = $ca67abe413e4c090$var$getStateItemStyle(model);
    // Clear styles set by emphasis.
    itemStyle.stroke = itemStyle.fill = itemStyle.lineWidth = null;
    return itemStyle;
};
var $ca67abe413e4c090$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $ca67abe413e4c090$var$TreemapView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TreemapView, _super);
    function TreemapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TreemapView.type;
        _this._state = "ready";
        _this._storage = $ca67abe413e4c090$var$createStorage();
        return _this;
    }
    /**
   * @override
   */ TreemapView.prototype.render = function(seriesModel, ecModel, api, payload) {
        var models = ecModel.findComponents({
            mainType: "series",
            subType: "treemap",
            query: payload
        });
        if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(models, seriesModel) < 0) return;
        this.seriesModel = seriesModel;
        this.api = api;
        this.ecModel = ecModel;
        var types = [
            "treemapZoomToNode",
            "treemapRootToNode"
        ];
        var targetInfo = $6341f66602946a06$export$c5445fa59c15dec4(payload, types, seriesModel);
        var payloadType = payload && payload.type;
        var layoutInfo = seriesModel.layoutInfo;
        var isInit = !this._oldTree;
        var thisStorage = this._storage;
        // Mark new root when action is treemapRootToNode.
        var reRoot = payloadType === "treemapRootToNode" && targetInfo && thisStorage ? {
            rootNodeGroup: thisStorage.nodeGroup[targetInfo.node.getRawIndex()],
            direction: payload.direction
        } : null;
        var containerGroup = this._giveContainerGroup(layoutInfo);
        var hasAnimation = seriesModel.get("animation");
        var renderResult = this._doRender(containerGroup, seriesModel, reRoot);
        hasAnimation && !isInit && (!payloadType || payloadType === "treemapZoomToNode" || payloadType === "treemapRootToNode") ? this._doAnimation(containerGroup, renderResult, seriesModel, reRoot) : renderResult.renderFinally();
        this._resetController(api);
        this._renderBreadcrumb(seriesModel, api, targetInfo);
    };
    TreemapView.prototype._giveContainerGroup = function(layoutInfo) {
        var containerGroup = this._containerGroup;
        if (!containerGroup) {
            // FIXME
            // 加一层containerGroup是为了clip，但是现在clip功能并没有实现。
            containerGroup = this._containerGroup = new $ca67abe413e4c090$var$Group();
            this._initEvents(containerGroup);
            this.group.add(containerGroup);
        }
        containerGroup.x = layoutInfo.x;
        containerGroup.y = layoutInfo.y;
        return containerGroup;
    };
    TreemapView.prototype._doRender = function(containerGroup, seriesModel, reRoot) {
        var thisTree = seriesModel.getData().tree;
        var oldTree = this._oldTree;
        // Clear last shape records.
        var lastsForAnimation = $ca67abe413e4c090$var$createStorage();
        var thisStorage = $ca67abe413e4c090$var$createStorage();
        var oldStorage = this._storage;
        var willInvisibleEls = [];
        function doRenderNode(thisNode, oldNode, parentGroup, depth) {
            return $ca67abe413e4c090$var$renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth);
        }
        // Notice: When thisTree and oldTree are the same tree (see list.cloneShallow),
        // the oldTree is actually losted, so we cannot find all of the old graphic
        // elements from tree. So we use this strategy: make element storage, move
        // from old storage to new storage, clear old storage.
        dualTravel(thisTree.root ? [
            thisTree.root
        ] : [], oldTree && oldTree.root ? [
            oldTree.root
        ] : [], containerGroup, thisTree === oldTree || !oldTree, 0);
        // Process all removing.
        var willDeleteEls = clearStorage(oldStorage);
        this._oldTree = thisTree;
        this._storage = thisStorage;
        if (this._controllerHost) {
            var _oldRootLayout = this.seriesModel.layoutInfo;
            var rootLayout = thisTree.root.getLayout();
            if (rootLayout.width === _oldRootLayout.width && rootLayout.height === _oldRootLayout.height) this._controllerHost.zoom = 1;
        }
        return {
            lastsForAnimation: lastsForAnimation,
            willDeleteEls: willDeleteEls,
            renderFinally: renderFinally
        };
        function dualTravel(thisViewChildren, oldViewChildren, parentGroup, sameTree, depth) {
            // When 'render' is triggered by action,
            // 'this' and 'old' may be the same tree,
            // we use rawIndex in that case.
            if (sameTree) {
                oldViewChildren = thisViewChildren;
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(thisViewChildren, function(child, index) {
                    !child.isRemoved() && processNode(index, index);
                });
            } else new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(oldViewChildren, thisViewChildren, getKey, getKey).add(processNode).update(processNode).remove((0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)(processNode, null)).execute();
            function getKey(node) {
                // Identify by name or raw index.
                return node.getId();
            }
            function processNode(newIndex, oldIndex) {
                var thisNode = newIndex != null ? thisViewChildren[newIndex] : null;
                var oldNode = oldIndex != null ? oldViewChildren[oldIndex] : null;
                var group = doRenderNode(thisNode, oldNode, parentGroup, depth);
                group && dualTravel(thisNode && thisNode.viewChildren || [], oldNode && oldNode.viewChildren || [], group, sameTree, depth + 1);
            }
        }
        function clearStorage(storage) {
            var willDeleteEls = $ca67abe413e4c090$var$createStorage();
            storage && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(storage, function(store, storageName) {
                var delEls = willDeleteEls[storageName];
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(store, function(el) {
                    el && (delEls.push(el), $ca67abe413e4c090$var$inner(el).willDelete = true);
                });
            });
            return willDeleteEls;
        }
        function renderFinally() {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(willDeleteEls, function(els) {
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(els, function(el) {
                    el.parent && el.parent.remove(el);
                });
            });
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(willInvisibleEls, function(el) {
                el.invisible = true;
                // Setting invisible is for optimizing, so no need to set dirty,
                // just mark as invisible.
                el.dirty();
            });
        }
    };
    TreemapView.prototype._doAnimation = function(containerGroup, renderResult, seriesModel, reRoot) {
        var durationOption = seriesModel.get("animationDurationUpdate");
        var easingOption = seriesModel.get("animationEasing");
        // TODO: do not support function until necessary.
        var duration = ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(durationOption) ? 0 : durationOption) || 0;
        var easing = ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(easingOption) ? null : easingOption) || "cubicOut";
        var animationWrap = $d83d3d8d08e5712f$export$944643101ee10c7();
        // Make delete animations.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(renderResult.willDeleteEls, function(store, storageName) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(store, function(el, rawIndex) {
                if (el.invisible) return;
                var parent = el.parent; // Always has parent, and parent is nodeGroup.
                var target;
                var innerStore = $ca67abe413e4c090$var$inner(parent);
                if (reRoot && reRoot.direction === "drillDown") target = parent === reRoot.rootNodeGroup ? {
                    shape: {
                        x: 0,
                        y: 0,
                        width: innerStore.nodeWidth,
                        height: innerStore.nodeHeight
                    },
                    style: {
                        opacity: 0
                    }
                } : {
                    style: {
                        opacity: 0
                    }
                };
                else {
                    var targetX = 0;
                    var targetY = 0;
                    if (!innerStore.willDelete) {
                        // Let node animate to right-bottom corner, cooperating with fadeout,
                        // which is appropriate for user understanding.
                        // Divided by 2 for reRoot rolling up effect.
                        targetX = innerStore.nodeWidth / 2;
                        targetY = innerStore.nodeHeight / 2;
                    }
                    target = storageName === "nodeGroup" ? {
                        x: targetX,
                        y: targetY,
                        style: {
                            opacity: 0
                        }
                    } : {
                        shape: {
                            x: targetX,
                            y: targetY,
                            width: 0,
                            height: 0
                        },
                        style: {
                            opacity: 0
                        }
                    };
                }
                // TODO: do not support delay until necessary.
                target && animationWrap.add(el, target, duration, 0, easing);
            });
        });
        // Make other animations
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._storage, function(store, storageName) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(store, function(el, rawIndex) {
                var last = renderResult.lastsForAnimation[storageName][rawIndex];
                var target = {};
                if (!last) return;
                if (el instanceof $7ef7583d8302ffce$export$2e2bcd8739ae039) {
                    if (last.oldX != null) {
                        target.x = el.x;
                        target.y = el.y;
                        el.x = last.oldX;
                        el.y = last.oldY;
                    }
                } else {
                    if (last.oldShape) {
                        target.shape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, el.shape);
                        el.setShape(last.oldShape);
                    }
                    if (last.fadein) {
                        el.setStyle("opacity", 0);
                        target.style = {
                            opacity: 1
                        };
                    } else if (el.style.opacity !== 1) target.style = {
                        opacity: 1
                    };
                }
                animationWrap.add(el, target, duration, 0, easing);
            });
        }, this);
        this._state = "animating";
        animationWrap.finished((0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(function() {
            this._state = "ready";
            renderResult.renderFinally();
        }, this)).start();
    };
    TreemapView.prototype._resetController = function(api) {
        var _this = this;
        var controller = this._controller;
        var controllerHost = this._controllerHost;
        if (!controllerHost) {
            this._controllerHost = {
                target: this.group
            };
            controllerHost = this._controllerHost;
        }
        var seriesModel = this.seriesModel;
        // Init controller.
        if (!controller) {
            controller = this._controller = new (0, $15927f329deeab51$export$2e2bcd8739ae039)(api.getZr());
            controller.on("pan", (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onPan, this));
            controller.on("zoom", (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onZoom, this));
        }
        controller.enable(seriesModel.get("roam"), {
            api: api,
            zInfo: {
                component: seriesModel
            },
            triggerInfo: {
                roamTrigger: seriesModel.get("roamTrigger"),
                isInSelf: function(e, x, y) {
                    var containerGroup = _this._containerGroup;
                    return containerGroup ? containerGroup.getBoundingRect().contain(x - containerGroup.x, y - containerGroup.y) : false;
                }
            }
        });
        controllerHost.zoomLimit = seriesModel.get("scaleLimit");
        controllerHost.zoom = seriesModel.get("zoom");
    };
    TreemapView.prototype._clearController = function() {
        var controller = this._controller;
        this._controllerHost = null;
        if (controller) {
            controller.dispose();
            controller = null;
        }
    };
    TreemapView.prototype._onPan = function(e) {
        if (this._state !== "animating" && (Math.abs(e.dx) > $ca67abe413e4c090$var$DRAG_THRESHOLD || Math.abs(e.dy) > $ca67abe413e4c090$var$DRAG_THRESHOLD)) {
            // These param must not be cached.
            var root = this.seriesModel.getData().tree.root;
            if (!root) return;
            var rootLayout = root.getLayout();
            if (!rootLayout) return;
            this.api.dispatchAction({
                type: "treemapMove",
                from: this.uid,
                seriesId: this.seriesModel.id,
                rootRect: {
                    x: rootLayout.x + e.dx,
                    y: rootLayout.y + e.dy,
                    width: rootLayout.width,
                    height: rootLayout.height
                }
            });
        }
    };
    TreemapView.prototype._onZoom = function(e) {
        var mouseX = e.originX;
        var mouseY = e.originY;
        var zoomDelta = e.scale;
        if (this._state !== "animating") {
            // These param must not be cached.
            var root = this.seriesModel.getData().tree.root;
            if (!root) return;
            var rootLayout = root.getLayout();
            if (!rootLayout) return;
            var rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(rootLayout.x, rootLayout.y, rootLayout.width, rootLayout.height);
            // scaleLimit
            var zoomLimit = null;
            var _controllerHost = this._controllerHost;
            zoomLimit = _controllerHost.zoomLimit;
            var newZoom = _controllerHost.zoom = _controllerHost.zoom || 1;
            newZoom *= zoomDelta;
            if (zoomLimit) {
                var zoomMin = zoomLimit.min || 0;
                var zoomMax = zoomLimit.max || Infinity;
                newZoom = Math.max(Math.min(zoomMax, newZoom), zoomMin);
            }
            var zoomScale = newZoom / _controllerHost.zoom;
            _controllerHost.zoom = newZoom;
            var layoutInfo = this.seriesModel.layoutInfo;
            // Transform mouse coord from global to containerGroup.
            mouseX -= layoutInfo.x;
            mouseY -= layoutInfo.y;
            // Scale root bounding rect.
            var m = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
            $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(m, m, [
                -mouseX,
                -mouseY
            ]);
            $f41ebb9dd60b55b4$export$dcdf75081b88279d(m, m, [
                zoomScale,
                zoomScale
            ]);
            $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(m, m, [
                mouseX,
                mouseY
            ]);
            rect.applyTransform(m);
            this.api.dispatchAction({
                type: "treemapRender",
                from: this.uid,
                seriesId: this.seriesModel.id,
                rootRect: {
                    x: rect.x,
                    y: rect.y,
                    width: rect.width,
                    height: rect.height
                }
            });
        }
    };
    TreemapView.prototype._initEvents = function(containerGroup) {
        var _this = this;
        containerGroup.on("click", function(e) {
            if (_this._state !== "ready") return;
            var nodeClick = _this.seriesModel.get("nodeClick", true);
            if (!nodeClick) return;
            var targetInfo = _this.findTarget(e.offsetX, e.offsetY);
            if (!targetInfo) return;
            var node = targetInfo.node;
            if (node.getLayout().isLeafRoot) _this._rootToNode(targetInfo);
            else {
                if (nodeClick === "zoomToNode") _this._zoomToNode(targetInfo);
                else if (nodeClick === "link") {
                    var itemModel = node.hostTree.data.getItemModel(node.dataIndex);
                    var link = itemModel.get("link", true);
                    var linkTarget = itemModel.get("target", true) || "blank";
                    link && (0, $c84c9521536c601a$export$13e13f9b96dbe8fa)(link, linkTarget);
                }
            }
        }, this);
    };
    TreemapView.prototype._renderBreadcrumb = function(seriesModel, api, targetInfo) {
        var _this = this;
        if (!targetInfo) {
            targetInfo = seriesModel.get("leafDepth", true) != null ? {
                node: seriesModel.getViewRoot()
            } : this.findTarget(api.getWidth() / 2, api.getHeight() / 2);
            if (!targetInfo) targetInfo = {
                node: seriesModel.getData().tree.root
            };
        }
        (this._breadcrumb || (this._breadcrumb = new (0, $504a89857fe7780b$export$2e2bcd8739ae039)(this.group))).render(seriesModel, api, targetInfo.node, function(node) {
            if (_this._state !== "animating") $6341f66602946a06$export$df59de26c77b5bea(seriesModel.getViewRoot(), node) ? _this._rootToNode({
                node: node
            }) : _this._zoomToNode({
                node: node
            });
        });
    };
    /**
   * @override
   */ TreemapView.prototype.remove = function() {
        this._clearController();
        this._containerGroup && this._containerGroup.removeAll();
        this._storage = $ca67abe413e4c090$var$createStorage();
        this._state = "ready";
        this._breadcrumb && this._breadcrumb.remove();
    };
    TreemapView.prototype.dispose = function() {
        this._clearController();
    };
    TreemapView.prototype._zoomToNode = function(targetInfo) {
        this.api.dispatchAction({
            type: "treemapZoomToNode",
            from: this.uid,
            seriesId: this.seriesModel.id,
            targetNode: targetInfo.node
        });
    };
    TreemapView.prototype._rootToNode = function(targetInfo) {
        this.api.dispatchAction({
            type: "treemapRootToNode",
            from: this.uid,
            seriesId: this.seriesModel.id,
            targetNode: targetInfo.node
        });
    };
    /**
   * @param x Global coord x.
   * @param y Global coord y.
   * @return info If not found, return undefined;
   * @return info.node Target node.
   * @return info.offsetX x refer to target node.
   * @return info.offsetY y refer to target node.
   */ TreemapView.prototype.findTarget = function(x, y) {
        var targetInfo;
        var viewRoot = this.seriesModel.getViewRoot();
        viewRoot.eachNode({
            attr: "viewChildren",
            order: "preorder"
        }, function(node) {
            var bgEl = this._storage.background[node.getRawIndex()];
            // If invisible, there might be no element.
            if (bgEl) {
                var point = bgEl.transformCoordToLocal(x, y);
                var shape = bgEl.shape;
                // For performance consideration, don't use 'getBoundingRect'.
                if (shape.x <= point[0] && point[0] <= shape.x + shape.width && shape.y <= point[1] && point[1] <= shape.y + shape.height) targetInfo = {
                    node: node,
                    offsetX: point[0],
                    offsetY: point[1]
                };
                else return false; // Suppress visit subtree.
            }
        }, this);
        return targetInfo;
    };
    TreemapView.type = "treemap";
    return TreemapView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
function $ca67abe413e4c090$var$createStorage() {
    return {
        nodeGroup: [],
        background: [],
        content: []
    };
}
/**
 * @return Return undefined means do not travel further.
 */ function $ca67abe413e4c090$var$renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth) {
    // Whether under viewRoot.
    if (!thisNode) // Deleting nodes will be performed finally. This method just find
    // element from old storage, or create new element, set them to new
    // storage, and set styles.
    return;
    // -------------------------------------------------------------------
    // Start of closure variables available in "Procedures in renderNode".
    var thisLayout = thisNode.getLayout();
    var data = seriesModel.getData();
    var nodeModel = thisNode.getModel();
    // Only for enabling highlight/downplay. Clear firstly.
    // Because some node will not be rendered.
    data.setItemGraphicEl(thisNode.dataIndex, null);
    if (!thisLayout || !thisLayout.isInView) return;
    var thisWidth = thisLayout.width;
    var thisHeight = thisLayout.height;
    var borderWidth = thisLayout.borderWidth;
    var thisInvisible = thisLayout.invisible;
    var thisRawIndex = thisNode.getRawIndex();
    var oldRawIndex = oldNode && oldNode.getRawIndex();
    var thisViewChildren = thisNode.viewChildren;
    var upperHeight = thisLayout.upperHeight;
    var isParent = thisViewChildren && thisViewChildren.length;
    var itemStyleNormalModel = nodeModel.getModel("itemStyle");
    var itemStyleEmphasisModel = nodeModel.getModel([
        "emphasis",
        "itemStyle"
    ]);
    var itemStyleBlurModel = nodeModel.getModel([
        "blur",
        "itemStyle"
    ]);
    var itemStyleSelectModel = nodeModel.getModel([
        "select",
        "itemStyle"
    ]);
    var borderRadius = itemStyleNormalModel.get("borderRadius") || 0;
    // End of closure ariables available in "Procedures in renderNode".
    // -----------------------------------------------------------------
    // Node group
    var group = giveGraphic("nodeGroup", $ca67abe413e4c090$var$Group);
    if (!group) return;
    parentGroup.add(group);
    // x,y are not set when el is above view root.
    group.x = thisLayout.x || 0;
    group.y = thisLayout.y || 0;
    group.markRedraw();
    $ca67abe413e4c090$var$inner(group).nodeWidth = thisWidth;
    $ca67abe413e4c090$var$inner(group).nodeHeight = thisHeight;
    if (thisLayout.isAboveViewRoot) return group;
    // Background
    var bg = giveGraphic("background", $ca67abe413e4c090$var$Rect, depth, $ca67abe413e4c090$var$Z2_BG);
    bg && renderBackground(group, bg, isParent && thisLayout.upperLabelHeight);
    var emphasisModel = nodeModel.getModel("emphasis");
    var focus = emphasisModel.get("focus");
    var blurScope = emphasisModel.get("blurScope");
    var isDisabled = emphasisModel.get("disabled");
    var focusOrIndices = focus === "ancestor" ? thisNode.getAncestorsIndices() : focus === "descendant" ? thisNode.getDescendantIndices() : focus;
    // No children, render content.
    if (isParent) {
        // Because of the implementation about "traverse" in graphic hover style, we
        // can not set hover listener on the "group" of non-leaf node. Otherwise the
        // hover event from the descendents will be listenered.
        if ((0, $2bf82c0980125b62$export$77d1445f699c58b5)(group)) (0, $2bf82c0980125b62$export$9ba15aea1e048d48)(group, false);
        if (bg) {
            (0, $2bf82c0980125b62$export$9ba15aea1e048d48)(bg, !isDisabled);
            // Only for enabling highlight/downplay.
            data.setItemGraphicEl(thisNode.dataIndex, bg);
            (0, $2bf82c0980125b62$export$24972466b2b62ac2)(bg, focusOrIndices, blurScope);
        }
    } else {
        var content = giveGraphic("content", $ca67abe413e4c090$var$Rect, depth, $ca67abe413e4c090$var$Z2_CONTENT);
        content && renderContent(group, content);
        bg.disableMorphing = true;
        if (bg && (0, $2bf82c0980125b62$export$77d1445f699c58b5)(bg)) (0, $2bf82c0980125b62$export$9ba15aea1e048d48)(bg, false);
        (0, $2bf82c0980125b62$export$9ba15aea1e048d48)(group, !isDisabled);
        // Only for enabling highlight/downplay.
        data.setItemGraphicEl(thisNode.dataIndex, group);
        var cursorStyle = nodeModel.getShallow("cursor");
        cursorStyle && content.attr("cursor", cursorStyle);
        (0, $2bf82c0980125b62$export$24972466b2b62ac2)(group, focusOrIndices, blurScope);
    }
    return group;
    // ----------------------------
    // | Procedures in renderNode |
    // ----------------------------
    function renderBackground(group, bg, useUpperLabel) {
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(bg);
        // For tooltip.
        ecData.dataIndex = thisNode.dataIndex;
        ecData.seriesIndex = seriesModel.seriesIndex;
        bg.setShape({
            x: 0,
            y: 0,
            width: thisWidth,
            height: thisHeight,
            r: borderRadius
        });
        if (thisInvisible) // If invisible, do not set visual, otherwise the element will
        // change immediately before animation. We think it is OK to
        // remain its origin color when moving out of the view window.
        processInvisible(bg);
        else {
            bg.invisible = false;
            var style = thisNode.getVisual("style");
            var visualBorderColor = style.stroke;
            var normalStyle = $ca67abe413e4c090$var$getItemStyleNormal(itemStyleNormalModel);
            normalStyle.fill = visualBorderColor;
            var emphasisStyle = $ca67abe413e4c090$var$getStateItemStyle(itemStyleEmphasisModel);
            emphasisStyle.fill = itemStyleEmphasisModel.get("borderColor");
            var blurStyle = $ca67abe413e4c090$var$getStateItemStyle(itemStyleBlurModel);
            blurStyle.fill = itemStyleBlurModel.get("borderColor");
            var selectStyle = $ca67abe413e4c090$var$getStateItemStyle(itemStyleSelectModel);
            selectStyle.fill = itemStyleSelectModel.get("borderColor");
            if (useUpperLabel) {
                var upperLabelWidth = thisWidth - 2 * borderWidth;
                prepareText(// PENDING: convert ZRColor to ColorString for text.
                bg, visualBorderColor, style.opacity, {
                    x: borderWidth,
                    y: 0,
                    width: upperLabelWidth,
                    height: upperHeight
                });
            } else bg.removeTextContent();
            bg.setStyle(normalStyle);
            bg.ensureState("emphasis").style = emphasisStyle;
            bg.ensureState("blur").style = blurStyle;
            bg.ensureState("select").style = selectStyle;
            (0, $2bf82c0980125b62$export$20f39bbe322fb9ab)(bg);
        }
        group.add(bg);
    }
    function renderContent(group, content) {
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(content);
        // For tooltip.
        ecData.dataIndex = thisNode.dataIndex;
        ecData.seriesIndex = seriesModel.seriesIndex;
        var contentWidth = Math.max(thisWidth - 2 * borderWidth, 0);
        var contentHeight = Math.max(thisHeight - 2 * borderWidth, 0);
        content.culling = true;
        content.setShape({
            x: borderWidth,
            y: borderWidth,
            width: contentWidth,
            height: contentHeight,
            r: borderRadius
        });
        if (thisInvisible) // If invisible, do not set visual, otherwise the element will
        // change immediately before animation. We think it is OK to
        // remain its origin color when moving out of the view window.
        processInvisible(content);
        else {
            content.invisible = false;
            var nodeStyle = thisNode.getVisual("style");
            var visualColor = nodeStyle.fill;
            var normalStyle = $ca67abe413e4c090$var$getItemStyleNormal(itemStyleNormalModel);
            normalStyle.fill = visualColor;
            normalStyle.decal = nodeStyle.decal;
            var emphasisStyle = $ca67abe413e4c090$var$getStateItemStyle(itemStyleEmphasisModel);
            var blurStyle = $ca67abe413e4c090$var$getStateItemStyle(itemStyleBlurModel);
            var selectStyle = $ca67abe413e4c090$var$getStateItemStyle(itemStyleSelectModel);
            // PENDING: convert ZRColor to ColorString for text.
            prepareText(content, visualColor, nodeStyle.opacity, null);
            content.setStyle(normalStyle);
            content.ensureState("emphasis").style = emphasisStyle;
            content.ensureState("blur").style = blurStyle;
            content.ensureState("select").style = selectStyle;
            (0, $2bf82c0980125b62$export$20f39bbe322fb9ab)(content);
        }
        group.add(content);
    }
    function processInvisible(element) {
        // Delay invisible setting utill animation finished,
        // avoid element vanish suddenly before animation.
        !element.invisible && willInvisibleEls.push(element);
    }
    function prepareText(rectEl, visualColor, visualOpacity, // Can be null/undefined
    upperLabelRect) {
        var normalLabelModel = nodeModel.getModel(upperLabelRect ? $ca67abe413e4c090$var$PATH_UPPERLABEL_NORMAL : $ca67abe413e4c090$var$PATH_LABEL_NOAMAL);
        var defaultText = (0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(nodeModel.get("name"), null);
        var isShow = normalLabelModel.getShallow("show");
        (0, $6800dfcb6e1e2a44$export$9a13992917966657)(rectEl, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(nodeModel, upperLabelRect ? $ca67abe413e4c090$var$PATH_UPPERLABEL_NORMAL : $ca67abe413e4c090$var$PATH_LABEL_NOAMAL), {
            defaultText: isShow ? defaultText : null,
            inheritColor: visualColor,
            defaultOpacity: visualOpacity,
            labelFetcher: seriesModel,
            labelDataIndex: thisNode.dataIndex
        });
        var textEl = rectEl.getTextContent();
        if (!textEl) return;
        var textStyle = textEl.style;
        var textPadding = (0, $7a1bd9c2710fea0d$export$f3a38102c49f4268)(textStyle.padding || 0);
        if (upperLabelRect) {
            rectEl.setTextConfig({
                layoutRect: upperLabelRect
            });
            textEl.disableLabelLayout = true;
        }
        textEl.beforeUpdate = function() {
            var width = Math.max((upperLabelRect ? upperLabelRect.width : rectEl.shape.width) - textPadding[1] - textPadding[3], 0);
            var height = Math.max((upperLabelRect ? upperLabelRect.height : rectEl.shape.height) - textPadding[0] - textPadding[2], 0);
            if (textStyle.width !== width || textStyle.height !== height) textEl.setStyle({
                width: width,
                height: height
            });
        };
        textStyle.truncateMinChar = 2;
        textStyle.lineOverflow = "truncate";
        addDrillDownIcon(textStyle, upperLabelRect, thisLayout);
        var textEmphasisState = textEl.getState("emphasis");
        addDrillDownIcon(textEmphasisState ? textEmphasisState.style : null, upperLabelRect, thisLayout);
    }
    function addDrillDownIcon(style, upperLabelRect, thisLayout) {
        var text = style ? style.text : null;
        if (!upperLabelRect && thisLayout.isLeafRoot && text != null) {
            var iconChar = seriesModel.get("drillDownIcon", true);
            style.text = iconChar ? iconChar + " " + text : text;
        }
    }
    function giveGraphic(storageName, Ctor, depth, z) {
        var element = oldRawIndex != null && oldStorage[storageName][oldRawIndex];
        var lasts = lastsForAnimation[storageName];
        if (element) {
            // Remove from oldStorage
            oldStorage[storageName][oldRawIndex] = null;
            prepareAnimationWhenHasOld(lasts, element);
        } else if (!thisInvisible) {
            element = new Ctor();
            if (element instanceof (0, $56206a6cb4666931$export$2e2bcd8739ae039)) element.z2 = $ca67abe413e4c090$var$calculateZ2(depth, z);
            prepareAnimationWhenNoOld(lasts, element);
        }
        // Set to thisStorage
        return thisStorage[storageName][thisRawIndex] = element;
    }
    function prepareAnimationWhenHasOld(lasts, element) {
        var lastCfg = lasts[thisRawIndex] = {};
        if (element instanceof $ca67abe413e4c090$var$Group) {
            lastCfg.oldX = element.x;
            lastCfg.oldY = element.y;
        } else lastCfg.oldShape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, element.shape);
    }
    // If a element is new, we need to find the animation start point carefully,
    // otherwise it will looks strange when 'zoomToNode'.
    function prepareAnimationWhenNoOld(lasts, element) {
        var lastCfg = lasts[thisRawIndex] = {};
        var parentNode = thisNode.parentNode;
        var isGroup = element instanceof $7ef7583d8302ffce$export$2e2bcd8739ae039;
        if (parentNode && (!reRoot || reRoot.direction === "drillDown")) {
            var parentOldX = 0;
            var parentOldY = 0;
            // New nodes appear from right-bottom corner in 'zoomToNode' animation.
            // For convenience, get old bounding rect from background.
            var parentOldBg = lastsForAnimation.background[parentNode.getRawIndex()];
            if (!reRoot && parentOldBg && parentOldBg.oldShape) {
                parentOldX = parentOldBg.oldShape.width;
                parentOldY = parentOldBg.oldShape.height;
            }
            // When no parent old shape found, its parent is new too,
            // so we can just use {x:0, y:0}.
            if (isGroup) {
                lastCfg.oldX = 0;
                lastCfg.oldY = parentOldY;
            } else lastCfg.oldShape = {
                x: parentOldX,
                y: parentOldY,
                width: 0,
                height: 0
            };
        }
        // Fade in, user can be aware that these nodes are new.
        lastCfg.fadein = !isGroup;
    }
}
// We cannot set all background with the same z, because the behaviour of
// drill down and roll up differ background creation sequence from tree
// hierarchy sequence, which cause lower background elements to overlap
// upper ones. So we calculate z based on depth.
// Moreover, we try to shrink down z interval to [0, 1] to avoid that
// treemap with large z overlaps other components.
function $ca67abe413e4c090$var$calculateZ2(depth, z2InLevel) {
    return depth * $ca67abe413e4c090$var$Z2_BASE + z2InLevel;
}
var $ca67abe413e4c090$export$2e2bcd8739ae039 = $ca67abe413e4c090$var$TreemapView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $e6cba72659c474bb$var$ITEM_STYLE_NORMAL = "itemStyle";
var $e6cba72659c474bb$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $e6cba72659c474bb$export$2e2bcd8739ae039 = {
    seriesType: "treemap",
    reset: function(seriesModel) {
        var tree = seriesModel.getData().tree;
        var root = tree.root;
        if (root.isRemoved()) return;
        $e6cba72659c474bb$var$travelTree(root, // Visual should calculate from tree root but not view root.
        {}, seriesModel.getViewRoot().getAncestors(), seriesModel);
    }
};
function $e6cba72659c474bb$var$travelTree(node, designatedVisual, viewRootAncestors, seriesModel) {
    var nodeModel = node.getModel();
    var nodeLayout = node.getLayout();
    var data = node.hostTree.data;
    // Optimize
    if (!nodeLayout || nodeLayout.invisible || !nodeLayout.isInView) return;
    var nodeItemStyleModel = nodeModel.getModel($e6cba72659c474bb$var$ITEM_STYLE_NORMAL);
    var visuals = $e6cba72659c474bb$var$buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel);
    var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, "style");
    // calculate border color
    var borderColor = nodeItemStyleModel.get("borderColor");
    var borderColorSaturation = nodeItemStyleModel.get("borderColorSaturation");
    var thisNodeColor;
    if (borderColorSaturation != null) {
        // For performance, do not always execute 'calculateColor'.
        thisNodeColor = $e6cba72659c474bb$var$calculateColor(visuals);
        borderColor = $e6cba72659c474bb$var$calculateBorderColor(borderColorSaturation, thisNodeColor);
    }
    existsStyle.stroke = borderColor;
    var viewChildren = node.viewChildren;
    if (!viewChildren || !viewChildren.length) {
        thisNodeColor = $e6cba72659c474bb$var$calculateColor(visuals);
        // Apply visual to this node.
        existsStyle.fill = thisNodeColor;
    } else {
        var mapping_1 = $e6cba72659c474bb$var$buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren);
        // Designate visual to children.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(viewChildren, function(child, index) {
            // If higher than viewRoot, only ancestors of viewRoot is needed to visit.
            if (child.depth >= viewRootAncestors.length || child === viewRootAncestors[child.depth]) {
                var childVisual = $e6cba72659c474bb$var$mapVisual(nodeModel, visuals, child, index, mapping_1, seriesModel);
                $e6cba72659c474bb$var$travelTree(child, childVisual, viewRootAncestors, seriesModel);
            }
        });
    }
}
function $e6cba72659c474bb$var$buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel) {
    var visuals = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, designatedVisual);
    var designatedVisualItemStyle = seriesModel.designatedVisualItemStyle;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        "color",
        "colorAlpha",
        "colorSaturation"
    ], function(visualName) {
        // Priority: thisNode > thisLevel > parentNodeDesignated > seriesModel
        designatedVisualItemStyle[visualName] = designatedVisual[visualName];
        var val = nodeItemStyleModel.get(visualName);
        designatedVisualItemStyle[visualName] = null;
        val != null && (visuals[visualName] = val);
    });
    return visuals;
}
function $e6cba72659c474bb$var$calculateColor(visuals) {
    var color = $e6cba72659c474bb$var$getValueVisualDefine(visuals, "color");
    if (color) {
        var colorAlpha = $e6cba72659c474bb$var$getValueVisualDefine(visuals, "colorAlpha");
        var colorSaturation = $e6cba72659c474bb$var$getValueVisualDefine(visuals, "colorSaturation");
        if (colorSaturation) color = (0, $2c037f5bda6341ca$export$d898ae866e27bf18)(color, null, null, colorSaturation);
        if (colorAlpha) color = (0, $2c037f5bda6341ca$export$ab4754bf42583a26)(color, colorAlpha);
        return color;
    }
}
function $e6cba72659c474bb$var$calculateBorderColor(borderColorSaturation, thisNodeColor) {
    return thisNodeColor != null ? (0, $2c037f5bda6341ca$export$d898ae866e27bf18)(thisNodeColor, null, null, borderColorSaturation) : null;
}
function $e6cba72659c474bb$var$getValueVisualDefine(visuals, name) {
    var value = visuals[name];
    if (value != null && value !== "none") return value;
}
function $e6cba72659c474bb$var$buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren) {
    if (!viewChildren || !viewChildren.length) return;
    var rangeVisual = $e6cba72659c474bb$var$getRangeVisual(nodeModel, "color") || visuals.color != null && visuals.color !== "none" && ($e6cba72659c474bb$var$getRangeVisual(nodeModel, "colorAlpha") || $e6cba72659c474bb$var$getRangeVisual(nodeModel, "colorSaturation"));
    if (!rangeVisual) return;
    var visualMin = nodeModel.get("visualMin");
    var visualMax = nodeModel.get("visualMax");
    var dataExtent = nodeLayout.dataExtent.slice();
    visualMin != null && visualMin < dataExtent[0] && (dataExtent[0] = visualMin);
    visualMax != null && visualMax > dataExtent[1] && (dataExtent[1] = visualMax);
    var colorMappingBy = nodeModel.get("colorMappingBy");
    var opt = {
        type: rangeVisual.name,
        dataExtent: dataExtent,
        visual: rangeVisual.range
    };
    if (opt.type === "color" && (colorMappingBy === "index" || colorMappingBy === "id")) {
        opt.mappingMethod = "category";
        opt.loop = true;
    // categories is ordinal, so do not set opt.categories.
    } else opt.mappingMethod = "linear";
    var mapping = new (0, $7b50f502cfd189d5$export$2e2bcd8739ae039)(opt);
    $e6cba72659c474bb$var$inner(mapping).drColorMappingBy = colorMappingBy;
    return mapping;
}
// Notice: If we don't have the attribute 'colorRange', but only use
// attribute 'color' to represent both concepts of 'colorRange' and 'color',
// (It means 'colorRange' when 'color' is Array, means 'color' when not array),
// this problem will be encountered:
// If a level-1 node doesn't have children, and its siblings have children,
// and colorRange is set on level-1, then the node cannot be colored.
// So we separate 'colorRange' and 'color' to different attributes.
function $e6cba72659c474bb$var$getRangeVisual(nodeModel, name) {
    // 'colorRange', 'colorARange', 'colorSRange'.
    // If not exists on this node, fetch from levels and series.
    var range = nodeModel.get(name);
    return (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(range) && range.length ? {
        name: name,
        range: range
    } : null;
}
function $e6cba72659c474bb$var$mapVisual(nodeModel, visuals, child, index, mapping, seriesModel) {
    var childVisuals = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, visuals);
    if (mapping) {
        // Only support color, colorAlpha, colorSaturation.
        var mappingType = mapping.type;
        var colorMappingBy = mappingType === "color" && $e6cba72659c474bb$var$inner(mapping).drColorMappingBy;
        var value = colorMappingBy === "index" ? index : colorMappingBy === "id" ? seriesModel.mapIdToIndex(child.getId()) : child.getValue(nodeModel.get("visualDimension"));
        childVisuals[mappingType] = mapping.mapValueToVisual(value);
    }
    return childVisuals;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embedded for some of the code in this file:
* The treemap layout implementation was originally copied from
* "d3.js" with some modifications made for this project.
* (See more details in the comment of the method "squarify" below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ 




var $2f13a432668907b0$var$mathMax = Math.max;
var $2f13a432668907b0$var$mathMin = Math.min;
var $2f13a432668907b0$var$retrieveValue = $7a1bd9c2710fea0d$export$8a4d17b6e8486e66;
var $2f13a432668907b0$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $2f13a432668907b0$var$PATH_BORDER_WIDTH = [
    "itemStyle",
    "borderWidth"
];
var $2f13a432668907b0$var$PATH_GAP_WIDTH = [
    "itemStyle",
    "gapWidth"
];
var $2f13a432668907b0$var$PATH_UPPER_LABEL_SHOW = [
    "upperLabel",
    "show"
];
var $2f13a432668907b0$var$PATH_UPPER_LABEL_HEIGHT = [
    "upperLabel",
    "height"
];
var /**
 * @public
 */ $2f13a432668907b0$export$2e2bcd8739ae039 = {
    seriesType: "treemap",
    reset: function(seriesModel, ecModel, api, payload) {
        // Layout result in each node:
        // {x, y, width, height, area, borderWidth}
        var seriesOption = seriesModel.option;
        var refContainer = $93b9bc7f22ac7369$export$5aec1e94f566e59f(seriesModel, api).refContainer;
        var layoutInfo = $93b9bc7f22ac7369$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), refContainer);
        var size = seriesOption.size || []; // Compatible with ec2.
        var containerWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)($2f13a432668907b0$var$retrieveValue(layoutInfo.width, size[0]), refContainer.width);
        var containerHeight = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)($2f13a432668907b0$var$retrieveValue(layoutInfo.height, size[1]), refContainer.height);
        // Fetch payload info.
        var payloadType = payload && payload.type;
        var types = [
            "treemapZoomToNode",
            "treemapRootToNode"
        ];
        var targetInfo = $6341f66602946a06$export$c5445fa59c15dec4(payload, types, seriesModel);
        var rootRect = payloadType === "treemapRender" || payloadType === "treemapMove" ? payload.rootRect : null;
        var viewRoot = seriesModel.getViewRoot();
        var viewAbovePath = $6341f66602946a06$export$6be31fe4499506f9(viewRoot);
        if (payloadType !== "treemapMove") {
            var rootSize = payloadType === "treemapZoomToNode" ? $2f13a432668907b0$var$estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) : rootRect ? [
                rootRect.width,
                rootRect.height
            ] : [
                containerWidth,
                containerHeight
            ];
            var sort_1 = seriesOption.sort;
            if (sort_1 && sort_1 !== "asc" && sort_1 !== "desc") // Default to be desc order.
            sort_1 = "desc";
            var options = {
                squareRatio: seriesOption.squareRatio,
                sort: sort_1,
                leafDepth: seriesOption.leafDepth
            };
            // layout should be cleared because using updateView but not update.
            viewRoot.hostTree.clearLayouts();
            // TODO
            // optimize: if out of view clip, do not layout.
            // But take care that if do not render node out of view clip,
            // how to calculate start po
            var viewRootLayout_1 = {
                x: 0,
                y: 0,
                width: rootSize[0],
                height: rootSize[1],
                area: rootSize[0] * rootSize[1]
            };
            viewRoot.setLayout(viewRootLayout_1);
            $2f13a432668907b0$var$squarify(viewRoot, options, false, 0);
            // Supplement layout.
            viewRootLayout_1 = viewRoot.getLayout();
            $2f13a432668907b0$var$each(viewAbovePath, function(node, index) {
                var childValue = (viewAbovePath[index + 1] || viewRoot).getValue();
                node.setLayout($7a1bd9c2710fea0d$export$8b58be045bf06082({
                    dataExtent: [
                        childValue,
                        childValue
                    ],
                    borderWidth: 0,
                    upperHeight: 0
                }, viewRootLayout_1));
            });
        }
        var treeRoot = seriesModel.getData().tree.root;
        treeRoot.setLayout($2f13a432668907b0$var$calculateRootPosition(layoutInfo, rootRect, targetInfo), true);
        seriesModel.setLayoutInfo(layoutInfo);
        // FIXME: narrow down pruning boungding rect.
        // Currently ec width/height is used becuases clip is not supported.
        $2f13a432668907b0$var$prunning(treeRoot, // Transform to base element coordinate system.
        new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(-layoutInfo.x, -layoutInfo.y, api.getWidth(), api.getHeight()), viewAbovePath, viewRoot, 0);
    }
};
/**
 * Layout treemap with squarify algorithm.
 * The original presentation of this algorithm
 * was made by Mark Bruls, Kees Huizing, and Jarke J. van Wijk
 * <https://graphics.ethz.ch/teaching/scivis_common/Literature/squarifiedTreeMaps.pdf>.
 * The implementation of this algorithm was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/layout/treemap.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * @protected
 * @param {module:echarts/data/Tree~TreeNode} node
 * @param {Object} options
 * @param {string} options.sort 'asc' or 'desc'
 * @param {number} options.squareRatio
 * @param {boolean} hideChildren
 * @param {number} depth
 */ function $2f13a432668907b0$var$squarify(node, options, hideChildren, depth) {
    var width;
    var height;
    if (node.isRemoved()) return;
    var thisLayout = node.getLayout();
    width = thisLayout.width;
    height = thisLayout.height;
    // Considering border and gap
    var nodeModel = node.getModel();
    var borderWidth = nodeModel.get($2f13a432668907b0$var$PATH_BORDER_WIDTH);
    var halfGapWidth = nodeModel.get($2f13a432668907b0$var$PATH_GAP_WIDTH) / 2;
    var upperLabelHeight = $2f13a432668907b0$var$getUpperLabelHeight(nodeModel);
    var upperHeight = Math.max(borderWidth, upperLabelHeight);
    var layoutOffset = borderWidth - halfGapWidth;
    var layoutOffsetUpper = upperHeight - halfGapWidth;
    node.setLayout({
        borderWidth: borderWidth,
        upperHeight: upperHeight,
        upperLabelHeight: upperLabelHeight
    }, true);
    width = $2f13a432668907b0$var$mathMax(width - 2 * layoutOffset, 0);
    height = $2f13a432668907b0$var$mathMax(height - layoutOffset - layoutOffsetUpper, 0);
    var totalArea = width * height;
    var viewChildren = $2f13a432668907b0$var$initChildren(node, nodeModel, totalArea, options, hideChildren, depth);
    if (!viewChildren.length) return;
    var rect = {
        x: layoutOffset,
        y: layoutOffsetUpper,
        width: width,
        height: height
    };
    var rowFixedLength = $2f13a432668907b0$var$mathMin(width, height);
    var best = Infinity; // the best row score so far
    var row = [];
    row.area = 0;
    for(var i = 0, len = viewChildren.length; i < len;){
        var child = viewChildren[i];
        row.push(child);
        row.area += child.getLayout().area;
        var score = $2f13a432668907b0$var$worst(row, rowFixedLength, options.squareRatio);
        // continue with this orientation
        if (score <= best) {
            i++;
            best = score;
        } else {
            row.area -= row.pop().getLayout().area;
            $2f13a432668907b0$var$position(row, rowFixedLength, rect, halfGapWidth, false);
            rowFixedLength = $2f13a432668907b0$var$mathMin(rect.width, rect.height);
            row.length = row.area = 0;
            best = Infinity;
        }
    }
    if (row.length) $2f13a432668907b0$var$position(row, rowFixedLength, rect, halfGapWidth, true);
    if (!hideChildren) {
        var childrenVisibleMin = nodeModel.get("childrenVisibleMin");
        if (childrenVisibleMin != null && totalArea < childrenVisibleMin) hideChildren = true;
    }
    for(var i = 0, len = viewChildren.length; i < len; i++)$2f13a432668907b0$var$squarify(viewChildren[i], options, hideChildren, depth + 1);
}
/**
 * Set area to each child, and calculate data extent for visual coding.
 */ function $2f13a432668907b0$var$initChildren(node, nodeModel, totalArea, options, hideChildren, depth) {
    var viewChildren = node.children || [];
    var orderBy = options.sort;
    orderBy !== "asc" && orderBy !== "desc" && (orderBy = null);
    var overLeafDepth = options.leafDepth != null && options.leafDepth <= depth;
    // leafDepth has higher priority.
    if (hideChildren && !overLeafDepth) return node.viewChildren = [];
    // Sort children, order by desc.
    viewChildren = $7a1bd9c2710fea0d$export$3dea766d36a8935f(viewChildren, function(child) {
        return !child.isRemoved();
    });
    $2f13a432668907b0$var$sort(viewChildren, orderBy);
    var info = $2f13a432668907b0$var$statistic(nodeModel, viewChildren, orderBy);
    if (info.sum === 0) return node.viewChildren = [];
    info.sum = $2f13a432668907b0$var$filterByThreshold(nodeModel, totalArea, info.sum, orderBy, viewChildren);
    if (info.sum === 0) return node.viewChildren = [];
    // Set area to each child.
    for(var i = 0, len = viewChildren.length; i < len; i++){
        var area = viewChildren[i].getValue() / info.sum * totalArea;
        // Do not use setLayout({...}, true), because it is needed to clear last layout.
        viewChildren[i].setLayout({
            area: area
        });
    }
    if (overLeafDepth) {
        viewChildren.length && node.setLayout({
            isLeafRoot: true
        }, true);
        viewChildren.length = 0;
    }
    node.viewChildren = viewChildren;
    node.setLayout({
        dataExtent: info.dataExtent
    }, true);
    return viewChildren;
}
/**
 * Consider 'visibleMin'. Modify viewChildren and get new sum.
 */ function $2f13a432668907b0$var$filterByThreshold(nodeModel, totalArea, sum, orderBy, orderedChildren) {
    // visibleMin is not supported yet when no option.sort.
    if (!orderBy) return sum;
    var visibleMin = nodeModel.get("visibleMin");
    var len = orderedChildren.length;
    var deletePoint = len;
    // Always travel from little value to big value.
    for(var i = len - 1; i >= 0; i--){
        var value = orderedChildren[orderBy === "asc" ? len - i - 1 : i].getValue();
        if (value / sum * totalArea < visibleMin) {
            deletePoint = i;
            sum -= value;
        }
    }
    orderBy === "asc" ? orderedChildren.splice(0, len - deletePoint) : orderedChildren.splice(deletePoint, len - deletePoint);
    return sum;
}
/**
 * Sort
 */ function $2f13a432668907b0$var$sort(viewChildren, orderBy) {
    if (orderBy) viewChildren.sort(function(a, b) {
        var diff = orderBy === "asc" ? a.getValue() - b.getValue() : b.getValue() - a.getValue();
        return diff === 0 ? orderBy === "asc" ? a.dataIndex - b.dataIndex : b.dataIndex - a.dataIndex : diff;
    });
    return viewChildren;
}
/**
 * Statistic
 */ function $2f13a432668907b0$var$statistic(nodeModel, children, orderBy) {
    // Calculate sum.
    var sum = 0;
    for(var i = 0, len = children.length; i < len; i++)sum += children[i].getValue();
    // Statistic data extent for latter visual coding.
    // Notice: data extent should be calculate based on raw children
    // but not filtered view children, otherwise visual mapping will not
    // be stable when zoom (where children is filtered by visibleMin).
    var dimension = nodeModel.get("visualDimension");
    var dataExtent;
    // The same as area dimension.
    if (!children || !children.length) dataExtent = [
        NaN,
        NaN
    ];
    else if (dimension === "value" && orderBy) {
        dataExtent = [
            children[children.length - 1].getValue(),
            children[0].getValue()
        ];
        orderBy === "asc" && dataExtent.reverse();
    } else {
        dataExtent = [
            Infinity,
            -Infinity
        ];
        $2f13a432668907b0$var$each(children, function(child) {
            var value = child.getValue(dimension);
            value < dataExtent[0] && (dataExtent[0] = value);
            value > dataExtent[1] && (dataExtent[1] = value);
        });
    }
    return {
        sum: sum,
        dataExtent: dataExtent
    };
}
/**
 * Computes the score for the specified row,
 * as the worst aspect ratio.
 */ function $2f13a432668907b0$var$worst(row, rowFixedLength, ratio) {
    var areaMax = 0;
    var areaMin = Infinity;
    for(var i = 0, area = void 0, len = row.length; i < len; i++){
        area = row[i].getLayout().area;
        if (area) {
            area < areaMin && (areaMin = area);
            area > areaMax && (areaMax = area);
        }
    }
    var squareArea = row.area * row.area;
    var f = rowFixedLength * rowFixedLength * ratio;
    return squareArea ? $2f13a432668907b0$var$mathMax(f * areaMax / squareArea, squareArea / (f * areaMin)) : Infinity;
}
/**
 * Positions the specified row of nodes. Modifies `rect`.
 */ function $2f13a432668907b0$var$position(row, rowFixedLength, rect, halfGapWidth, flush) {
    // When rowFixedLength === rect.width,
    // it is horizontal subdivision,
    // rowFixedLength is the width of the subdivision,
    // rowOtherLength is the height of the subdivision,
    // and nodes will be positioned from left to right.
    // wh[idx0WhenH] means: when horizontal,
    //      wh[idx0WhenH] => wh[0] => 'width'.
    //      xy[idx1WhenH] => xy[1] => 'y'.
    var idx0WhenH = rowFixedLength === rect.width ? 0 : 1;
    var idx1WhenH = 1 - idx0WhenH;
    var xy = [
        "x",
        "y"
    ];
    var wh = [
        "width",
        "height"
    ];
    var last = rect[xy[idx0WhenH]];
    var rowOtherLength = rowFixedLength ? row.area / rowFixedLength : 0;
    if (flush || rowOtherLength > rect[wh[idx1WhenH]]) rowOtherLength = rect[wh[idx1WhenH]]; // over+underflow
    for(var i = 0, rowLen = row.length; i < rowLen; i++){
        var node = row[i];
        var nodeLayout = {};
        var step = rowOtherLength ? node.getLayout().area / rowOtherLength : 0;
        var wh1 = nodeLayout[wh[idx1WhenH]] = $2f13a432668907b0$var$mathMax(rowOtherLength - 2 * halfGapWidth, 0);
        // We use Math.max/min to avoid negative width/height when considering gap width.
        var remain = rect[xy[idx0WhenH]] + rect[wh[idx0WhenH]] - last;
        var modWH = i === rowLen - 1 || remain < step ? remain : step;
        var wh0 = nodeLayout[wh[idx0WhenH]] = $2f13a432668907b0$var$mathMax(modWH - 2 * halfGapWidth, 0);
        nodeLayout[xy[idx1WhenH]] = rect[xy[idx1WhenH]] + $2f13a432668907b0$var$mathMin(halfGapWidth, wh1 / 2);
        nodeLayout[xy[idx0WhenH]] = last + $2f13a432668907b0$var$mathMin(halfGapWidth, wh0 / 2);
        last += modWH;
        node.setLayout(nodeLayout, true);
    }
    rect[xy[idx1WhenH]] += rowOtherLength;
    rect[wh[idx1WhenH]] -= rowOtherLength;
}
// Return [containerWidth, containerHeight] as default.
function $2f13a432668907b0$var$estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) {
    // If targetInfo.node exists, we zoom to the node,
    // so estimate whole width and height by target node.
    var currNode = (targetInfo || {}).node;
    var defaultSize = [
        containerWidth,
        containerHeight
    ];
    if (!currNode || currNode === viewRoot) return defaultSize;
    var parent;
    var viewArea = containerWidth * containerHeight;
    var area = viewArea * seriesModel.option.zoomToNodeRatio;
    while(parent = currNode.parentNode){
        // jshint ignore:line
        var sum = 0;
        var siblings = parent.children;
        for(var i = 0, len = siblings.length; i < len; i++)sum += siblings[i].getValue();
        var currNodeValue = currNode.getValue();
        if (currNodeValue === 0) return defaultSize;
        area *= sum / currNodeValue;
        // Considering border, suppose aspect ratio is 1.
        var parentModel = parent.getModel();
        var borderWidth = parentModel.get($2f13a432668907b0$var$PATH_BORDER_WIDTH);
        var upperHeight = Math.max(borderWidth, $2f13a432668907b0$var$getUpperLabelHeight(parentModel));
        area += 4 * borderWidth * borderWidth + (3 * borderWidth + upperHeight) * Math.pow(area, 0.5);
        area > (0, $cfc1f3b422a3185f$export$18510406f204a1b9) && (area = (0, $cfc1f3b422a3185f$export$18510406f204a1b9));
        currNode = parent;
    }
    area < viewArea && (area = viewArea);
    var scale = Math.pow(area / viewArea, 0.5);
    return [
        containerWidth * scale,
        containerHeight * scale
    ];
}
// Root position based on coord of containerGroup
function $2f13a432668907b0$var$calculateRootPosition(layoutInfo, rootRect, targetInfo) {
    if (rootRect) return {
        x: rootRect.x,
        y: rootRect.y
    };
    var defaultPosition = {
        x: 0,
        y: 0
    };
    if (!targetInfo) return defaultPosition;
    // If targetInfo is fetched by 'retrieveTargetInfo',
    // old tree and new tree are the same tree,
    // so the node still exists and we can visit it.
    var targetNode = targetInfo.node;
    var layout = targetNode.getLayout();
    if (!layout) return defaultPosition;
    // Transform coord from local to container.
    var targetCenter = [
        layout.width / 2,
        layout.height / 2
    ];
    var node = targetNode;
    while(node){
        var nodeLayout = node.getLayout();
        targetCenter[0] += nodeLayout.x;
        targetCenter[1] += nodeLayout.y;
        node = node.parentNode;
    }
    return {
        x: layoutInfo.width / 2 - targetCenter[0],
        y: layoutInfo.height / 2 - targetCenter[1]
    };
}
// Mark nodes visible for prunning when visual coding and rendering.
// Prunning depends on layout and root position, so we have to do it after layout.
function $2f13a432668907b0$var$prunning(node, clipRect, viewAbovePath, viewRoot, depth) {
    var nodeLayout = node.getLayout();
    var nodeInViewAbovePath = viewAbovePath[depth];
    var isAboveViewRoot = nodeInViewAbovePath && nodeInViewAbovePath === node;
    if (nodeInViewAbovePath && !isAboveViewRoot || depth === viewAbovePath.length && node !== viewRoot) return;
    node.setLayout({
        // isInView means: viewRoot sub tree + viewAbovePath
        isInView: true,
        // invisible only means: outside view clip so that the node can not
        // see but still layout for animation preparation but not render.
        invisible: !isAboveViewRoot && !clipRect.intersect(nodeLayout),
        isAboveViewRoot: isAboveViewRoot
    }, true);
    // Transform to child coordinate.
    var childClipRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(clipRect.x - nodeLayout.x, clipRect.y - nodeLayout.y, clipRect.width, clipRect.height);
    $2f13a432668907b0$var$each(node.viewChildren || [], function(child) {
        $2f13a432668907b0$var$prunning(child, childClipRect, viewAbovePath, viewRoot, depth + 1);
    });
}
function $2f13a432668907b0$var$getUpperLabelHeight(model) {
    return model.get($2f13a432668907b0$var$PATH_UPPER_LABEL_SHOW) ? model.get($2f13a432668907b0$var$PATH_UPPER_LABEL_HEIGHT) : 0;
}


function $330b7dc841112eff$export$4b3e715f166fdd78(registers) {
    registers.registerSeriesModel((0, $10d079b37d9731a3$export$2e2bcd8739ae039));
    registers.registerChartView((0, $ca67abe413e4c090$export$2e2bcd8739ae039));
    registers.registerVisual((0, $e6cba72659c474bb$export$2e2bcd8739ae039));
    registers.registerLayout((0, $2f13a432668907b0$export$2e2bcd8739ae039));
    (0, $26d493e9cdfadb01$export$1ad90fc3f3a8bbf9)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $98990baee36aa4ed$var$DEFAULT_OPTION = {
    label: {
        enabled: true
    },
    decal: {
        show: false
    }
};
var $98990baee36aa4ed$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $98990baee36aa4ed$var$decalPaletteScope = {};
function $98990baee36aa4ed$export$2e2bcd8739ae039(ecModel, api) {
    var ariaModel = ecModel.getModel("aria");
    // See "area enabled" detection code in `GlobalModel.ts`.
    if (!ariaModel.get("enabled")) return;
    var defaultOption = $7a1bd9c2710fea0d$export$9cd59f9826255e47($98990baee36aa4ed$var$DEFAULT_OPTION);
    $7a1bd9c2710fea0d$export$4950aa0f605343fb(defaultOption.label, ecModel.getLocaleModel().get("aria"), false);
    $7a1bd9c2710fea0d$export$4950aa0f605343fb(ariaModel.option, defaultOption, false);
    setDecal();
    setLabel();
    function setDecal() {
        var decalModel = ariaModel.getModel("decal");
        var useDecal = decalModel.get("show");
        if (useDecal) {
            // Each type of series use one scope.
            // Pie and funnel are using different scopes.
            var paletteScopeGroupByType_1 = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
            ecModel.eachSeries(function(seriesModel) {
                if (seriesModel.isColorBySeries()) return;
                var decalScope = paletteScopeGroupByType_1.get(seriesModel.type);
                if (!decalScope) {
                    decalScope = {};
                    paletteScopeGroupByType_1.set(seriesModel.type, decalScope);
                }
                $98990baee36aa4ed$var$inner(seriesModel).scope = decalScope;
            });
            ecModel.eachRawSeries(function(seriesModel) {
                if (ecModel.isSeriesFiltered(seriesModel)) return;
                if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(seriesModel.enableAriaDecal)) {
                    // Let series define how to use decal palette on data
                    seriesModel.enableAriaDecal();
                    return;
                }
                var data = seriesModel.getData();
                if (!seriesModel.isColorBySeries()) {
                    var dataAll_1 = seriesModel.getRawData();
                    var idxMap_1 = {};
                    var decalScope_1 = $98990baee36aa4ed$var$inner(seriesModel).scope;
                    data.each(function(idx) {
                        var rawIdx = data.getRawIndex(idx);
                        idxMap_1[rawIdx] = idx;
                    });
                    var dataCount_1 = dataAll_1.count();
                    dataAll_1.each(function(rawIdx) {
                        var idx = idxMap_1[rawIdx];
                        var name = dataAll_1.getName(rawIdx) || rawIdx + "";
                        var paletteDecal = (0, $e7fbd47751ca3c28$export$e4d892222945a227)(seriesModel.ecModel, name, decalScope_1, dataCount_1);
                        var specifiedDecal = data.getItemVisual(idx, "decal");
                        data.setItemVisual(idx, "decal", mergeDecal(specifiedDecal, paletteDecal));
                    });
                } else {
                    var paletteDecal = (0, $e7fbd47751ca3c28$export$e4d892222945a227)(seriesModel.ecModel, seriesModel.name, $98990baee36aa4ed$var$decalPaletteScope, ecModel.getSeriesCount());
                    var specifiedDecal = data.getVisual("decal");
                    data.setVisual("decal", mergeDecal(specifiedDecal, paletteDecal));
                }
                function mergeDecal(specifiedDecal, paletteDecal) {
                    // Merge decal from palette to decal from itemStyle.
                    // User do not need to specify all of the decal props.
                    var resultDecal = specifiedDecal ? $7a1bd9c2710fea0d$export$8b58be045bf06082($7a1bd9c2710fea0d$export$8b58be045bf06082({}, paletteDecal), specifiedDecal) : paletteDecal;
                    resultDecal.dirty = true;
                    return resultDecal;
                }
            });
        }
    }
    function setLabel() {
        var dom = api.getZr().dom;
        // TODO: support for SSR
        if (!dom) return;
        var labelLocale = ecModel.getLocaleModel().get("aria");
        var labelModel = ariaModel.getModel("label");
        labelModel.option = $7a1bd9c2710fea0d$export$ebe90cb607ad99e(labelModel.option, labelLocale);
        if (!labelModel.get("enabled")) return;
        dom.setAttribute("role", "img");
        if (labelModel.get("description")) {
            dom.setAttribute("aria-label", labelModel.get("description"));
            return;
        }
        var seriesCnt = ecModel.getSeriesCount();
        var maxDataCnt = labelModel.get([
            "data",
            "maxCount"
        ]) || 10;
        var maxSeriesCnt = labelModel.get([
            "series",
            "maxCount"
        ]) || 10;
        var displaySeriesCnt = Math.min(seriesCnt, maxSeriesCnt);
        var ariaLabel;
        if (seriesCnt < 1) // No series, no aria label
        return;
        else {
            var title = getTitle();
            if (title) {
                var withTitle = labelModel.get([
                    "general",
                    "withTitle"
                ]);
                ariaLabel = replace(withTitle, {
                    title: title
                });
            } else ariaLabel = labelModel.get([
                "general",
                "withoutTitle"
            ]);
            var seriesLabels_1 = [];
            var prefix = seriesCnt > 1 ? labelModel.get([
                "series",
                "multiple",
                "prefix"
            ]) : labelModel.get([
                "series",
                "single",
                "prefix"
            ]);
            ariaLabel += replace(prefix, {
                seriesCount: seriesCnt
            });
            ecModel.eachSeries(function(seriesModel, idx) {
                if (idx < displaySeriesCnt) {
                    var seriesLabel = void 0;
                    var seriesName = seriesModel.get("name");
                    var withName = seriesName ? "withName" : "withoutName";
                    seriesLabel = seriesCnt > 1 ? labelModel.get([
                        "series",
                        "multiple",
                        withName
                    ]) : labelModel.get([
                        "series",
                        "single",
                        withName
                    ]);
                    seriesLabel = replace(seriesLabel, {
                        seriesId: seriesModel.seriesIndex,
                        seriesName: seriesModel.get("name"),
                        seriesType: getSeriesTypeName(seriesModel.subType)
                    });
                    var data = seriesModel.getData();
                    if (data.count() > maxDataCnt) {
                        // Show part of data
                        var partialLabel = labelModel.get([
                            "data",
                            "partialData"
                        ]);
                        seriesLabel += replace(partialLabel, {
                            displayCnt: maxDataCnt
                        });
                    } else seriesLabel += labelModel.get([
                        "data",
                        "allData"
                    ]);
                    var middleSeparator_1 = labelModel.get([
                        "data",
                        "separator",
                        "middle"
                    ]);
                    var endSeparator_1 = labelModel.get([
                        "data",
                        "separator",
                        "end"
                    ]);
                    var excludeDimensionId_1 = labelModel.get([
                        "data",
                        "excludeDimensionId"
                    ]);
                    var dataLabels = [];
                    for(var i = 0; i < data.count(); i++)if (i < maxDataCnt) {
                        var name_1 = data.getName(i);
                        var value = !excludeDimensionId_1 ? data.getValues(i) : $7a1bd9c2710fea0d$export$3dea766d36a8935f(data.getValues(i), function(v, j) {
                            return $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(excludeDimensionId_1, j) === -1;
                        });
                        var dataLabel = labelModel.get([
                            "data",
                            name_1 ? "withName" : "withoutName"
                        ]);
                        dataLabels.push(replace(dataLabel, {
                            name: name_1,
                            value: value.join(middleSeparator_1)
                        }));
                    }
                    seriesLabel += dataLabels.join(middleSeparator_1) + endSeparator_1;
                    seriesLabels_1.push(seriesLabel);
                }
            });
            var separatorModel = labelModel.getModel([
                "series",
                "multiple",
                "separator"
            ]);
            var middleSeparator = separatorModel.get("middle");
            var endSeparator = separatorModel.get("end");
            ariaLabel += seriesLabels_1.join(middleSeparator) + endSeparator;
            dom.setAttribute("aria-label", ariaLabel);
        }
    }
    function replace(str, keyValues) {
        if (!$7a1bd9c2710fea0d$export$844ec244b1367d54(str)) return str;
        var result = str;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(keyValues, function(value, key) {
            result = result.replace(new RegExp("\\{\\s*" + key + "\\s*\\}", "g"), value);
        });
        return result;
    }
    function getTitle() {
        var title = ecModel.get("title");
        if (title && title.length) title = title[0];
        return title && title.text;
    }
    function getSeriesTypeName(type) {
        var typeNames = ecModel.getLocaleModel().get([
            "series",
            "typeNames"
        ]);
        return typeNames[type] || typeNames.chart;
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $6f6d6469de000c68$export$2e2bcd8739ae039(option) {
    if (!option || !option.aria) return;
    var aria = option.aria;
    // aria.show is deprecated and should use aria.enabled instead
    if (aria.show != null) aria.enabled = aria.show;
    aria.label = aria.label || {};
    // move description, general, series, data to be under aria.label
    $7a1bd9c2710fea0d$export$79b2f7037acddd43([
        "description",
        "general",
        "series",
        "data"
    ], function(name) {
        if (aria[name] != null) aria.label[name] = aria[name];
    });
}


function $772c09ed30d27c33$export$4b3e715f166fdd78(registers) {
    registers.registerPreprocessor((0, $6f6d6469de000c68$export$2e2bcd8739ae039));
    registers.registerVisual(registers.PRIORITY.VISUAL.ARIA, (0, $98990baee36aa4ed$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $a331d7a6c631e6d9$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $a331d7a6c631e6d9$var$clone = $7a1bd9c2710fea0d$export$9cd59f9826255e47;
var $a331d7a6c631e6d9$var$bind = $7a1bd9c2710fea0d$export$2385a24977818dd0;
/**
 * Base axis pointer class in 2D.
 */ var $a331d7a6c631e6d9$var$BaseAxisPointer = /** @class */ function() {
    function BaseAxisPointer() {
        this._dragging = false;
        /**
     * In px, arbitrary value. Do not set too small,
     * no animation is ok for most cases.
     */ this.animationThreshold = 15;
    }
    /**
   * @implement
   */ BaseAxisPointer.prototype.render = function(axisModel, axisPointerModel, api, forceRender) {
        var value = axisPointerModel.get("value");
        var status = axisPointerModel.get("status");
        // Bind them to `this`, not in closure, otherwise they will not
        // be replaced when user calling setOption in not merge mode.
        this._axisModel = axisModel;
        this._axisPointerModel = axisPointerModel;
        this._api = api;
        // Optimize: `render` will be called repeatedly during mouse move.
        // So it is power consuming if performing `render` each time,
        // especially on mobile device.
        if (!forceRender && this._lastValue === value && this._lastStatus === status) return;
        this._lastValue = value;
        this._lastStatus = status;
        var group = this._group;
        var handle = this._handle;
        if (!status || status === "hide") {
            // Do not clear here, for animation better.
            group && group.hide();
            handle && handle.hide();
            return;
        }
        group && group.show();
        handle && handle.show();
        // Otherwise status is 'show'
        var elOption = {};
        this.makeElOption(elOption, value, axisModel, axisPointerModel, api);
        // Enable change axis pointer type.
        var graphicKey = elOption.graphicKey;
        if (graphicKey !== this._lastGraphicKey) this.clear(api);
        this._lastGraphicKey = graphicKey;
        var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);
        if (!group) {
            group = this._group = new $5b455ae6f843ac47$exports.Group();
            this.createPointerEl(group, elOption, axisModel, axisPointerModel);
            this.createLabelEl(group, elOption, axisModel, axisPointerModel);
            api.getZr().add(group);
        } else {
            var doUpdateProps = $7a1bd9c2710fea0d$export$c3095a23b368d1f2($a331d7a6c631e6d9$var$updateProps, axisPointerModel, moveAnimation);
            this.updatePointerEl(group, elOption, doUpdateProps);
            this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
        }
        $a331d7a6c631e6d9$var$updateMandatoryProps(group, axisPointerModel, true);
        this._renderHandle(value);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.remove = function(api) {
        this.clear(api);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.dispose = function(api) {
        this.clear(api);
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.determineAnimation = function(axisModel, axisPointerModel) {
        var animation = axisPointerModel.get("animation");
        var axis = axisModel.axis;
        var isCategoryAxis = axis.type === "category";
        var useSnap = axisPointerModel.get("snap");
        // Value axis without snap always do not snap.
        if (!useSnap && !isCategoryAxis) return false;
        if (animation === "auto" || animation == null) {
            var animationThreshold = this.animationThreshold;
            if (isCategoryAxis && axis.getBandWidth() > animationThreshold) return true;
            // It is important to auto animation when snap used. Consider if there is
            // a dataZoom, animation will be disabled when too many points exist, while
            // it will be enabled for better visual effect when little points exist.
            if (useSnap) {
                var seriesDataCount = $84d826b9ba8bf009$export$bd39458db76002ab(axisModel).seriesDataCount;
                var axisExtent = axis.getExtent();
                // Approximate band width
                return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
            }
            return false;
        }
        return animation === true;
    };
    /**
   * add {pointer, label, graphicKey} to elOption
   * @protected
   */ BaseAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
    // Should be implemenented by sub-class.
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.createPointerEl = function(group, elOption, axisModel, axisPointerModel) {
        var pointerOption = elOption.pointer;
        if (pointerOption) {
            var pointerEl = $a331d7a6c631e6d9$var$inner(group).pointerEl = new $5b455ae6f843ac47$exports[pointerOption.type]($a331d7a6c631e6d9$var$clone(elOption.pointer));
            group.add(pointerEl);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.createLabelEl = function(group, elOption, axisModel, axisPointerModel) {
        if (elOption.label) {
            var labelEl = $a331d7a6c631e6d9$var$inner(group).labelEl = new $5b455ae6f843ac47$exports.Text($a331d7a6c631e6d9$var$clone(elOption.label));
            group.add(labelEl);
            $a331d7a6c631e6d9$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updatePointerEl = function(group, elOption, updateProps) {
        var pointerEl = $a331d7a6c631e6d9$var$inner(group).pointerEl;
        if (pointerEl && elOption.pointer) {
            pointerEl.setStyle(elOption.pointer.style);
            updateProps(pointerEl, {
                shape: elOption.pointer.shape
            });
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updateLabelEl = function(group, elOption, updateProps, axisPointerModel) {
        var labelEl = $a331d7a6c631e6d9$var$inner(group).labelEl;
        if (labelEl) {
            labelEl.setStyle(elOption.label.style);
            updateProps(labelEl, {
                // Consider text length change in vertical axis, animation should
                // be used on shape, otherwise the effect will be weird.
                // TODOTODO
                // shape: elOption.label.shape,
                x: elOption.label.x,
                y: elOption.label.y
            });
            $a331d7a6c631e6d9$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @private
   */ BaseAxisPointer.prototype._renderHandle = function(value) {
        if (this._dragging || !this.updateHandleTransform) return;
        var axisPointerModel = this._axisPointerModel;
        var zr = this._api.getZr();
        var handle = this._handle;
        var handleModel = axisPointerModel.getModel("handle");
        var status = axisPointerModel.get("status");
        if (!handleModel.get("show") || !status || status === "hide") {
            handle && zr.remove(handle);
            this._handle = null;
            return;
        }
        var isInit;
        if (!this._handle) {
            isInit = true;
            handle = this._handle = $5b455ae6f843ac47$exports.createIcon(handleModel.get("icon"), {
                cursor: "move",
                draggable: true,
                onmousemove: function(e) {
                    // For mobile device, prevent screen slider on the button.
                    $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
                },
                onmousedown: $a331d7a6c631e6d9$var$bind(this._onHandleDragMove, this, 0, 0),
                drift: $a331d7a6c631e6d9$var$bind(this._onHandleDragMove, this),
                ondragend: $a331d7a6c631e6d9$var$bind(this._onHandleDragEnd, this)
            });
            zr.add(handle);
        }
        $a331d7a6c631e6d9$var$updateMandatoryProps(handle, axisPointerModel, false);
        // update style
        handle.setStyle(handleModel.getItemStyle(null, [
            "color",
            "borderColor",
            "borderWidth",
            "opacity",
            "shadowColor",
            "shadowBlur",
            "shadowOffsetX",
            "shadowOffsetY"
        ]));
        // update position
        var handleSize = handleModel.get("size");
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(handleSize)) handleSize = [
            handleSize,
            handleSize
        ];
        handle.scaleX = handleSize[0] / 2;
        handle.scaleY = handleSize[1] / 2;
        $c98659a9437a3d2e$export$958e3e1a02eac4b6(this, "_doDispatchAxisPointer", handleModel.get("throttle") || 0, "fixRate");
        this._moveHandleToValue(value, isInit);
    };
    BaseAxisPointer.prototype._moveHandleToValue = function(value, isInit) {
        $a331d7a6c631e6d9$var$updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, $a331d7a6c631e6d9$var$getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
    };
    BaseAxisPointer.prototype._onHandleDragMove = function(dx, dy) {
        var handle = this._handle;
        if (!handle) return;
        this._dragging = true;
        // Persistent for throttle.
        var trans = this.updateHandleTransform($a331d7a6c631e6d9$var$getHandleTransProps(handle), [
            dx,
            dy
        ], this._axisModel, this._axisPointerModel);
        this._payloadInfo = trans;
        handle.stopAnimation();
        handle.attr($a331d7a6c631e6d9$var$getHandleTransProps(trans));
        $a331d7a6c631e6d9$var$inner(handle).lastProp = null;
        this._doDispatchAxisPointer();
    };
    /**
   * Throttled method.
   */ BaseAxisPointer.prototype._doDispatchAxisPointer = function() {
        var handle = this._handle;
        if (!handle) return;
        var payloadInfo = this._payloadInfo;
        var axisModel = this._axisModel;
        this._api.dispatchAction({
            type: "updateAxisPointer",
            x: payloadInfo.cursorPoint[0],
            y: payloadInfo.cursorPoint[1],
            tooltipOption: payloadInfo.tooltipOption,
            axesInfo: [
                {
                    axisDim: axisModel.axis.dim,
                    axisIndex: axisModel.componentIndex
                }
            ]
        });
    };
    BaseAxisPointer.prototype._onHandleDragEnd = function() {
        this._dragging = false;
        var handle = this._handle;
        if (!handle) return;
        var value = this._axisPointerModel.get("value");
        // Consider snap or categroy axis, handle may be not consistent with
        // axisPointer. So move handle to align the exact value position when
        // drag ended.
        this._moveHandleToValue(value);
        // For the effect: tooltip will be shown when finger holding on handle
        // button, and will be hidden after finger left handle button.
        this._api.dispatchAction({
            type: "hideTip"
        });
    };
    /**
   * @private
   */ BaseAxisPointer.prototype.clear = function(api) {
        this._lastValue = null;
        this._lastStatus = null;
        var zr = api.getZr();
        var group = this._group;
        var handle = this._handle;
        if (zr && group) {
            this._lastGraphicKey = null;
            group && zr.remove(group);
            handle && zr.remove(handle);
            this._group = null;
            this._handle = null;
            this._payloadInfo = null;
        }
        $c98659a9437a3d2e$export$42ffd38884aecdac(this, "_doDispatchAxisPointer");
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.doClear = function() {
    // Implemented by sub-class if necessary.
    };
    BaseAxisPointer.prototype.buildLabel = function(xy, wh, xDimIndex) {
        xDimIndex = xDimIndex || 0;
        return {
            x: xy[xDimIndex],
            y: xy[1 - xDimIndex],
            width: wh[xDimIndex],
            height: wh[1 - xDimIndex]
        };
    };
    return BaseAxisPointer;
}();
function $a331d7a6c631e6d9$var$updateProps(animationModel, moveAnimation, el, props) {
    // Animation optimize.
    if (!$a331d7a6c631e6d9$var$propsEqual($a331d7a6c631e6d9$var$inner(el).lastProp, props)) {
        $a331d7a6c631e6d9$var$inner(el).lastProp = props;
        moveAnimation ? $5b455ae6f843ac47$exports.updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
    }
}
function $a331d7a6c631e6d9$var$propsEqual(lastProps, newProps) {
    if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(lastProps) && $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(newProps)) {
        var equals_1 = true;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(newProps, function(item, key) {
            equals_1 = equals_1 && $a331d7a6c631e6d9$var$propsEqual(lastProps[key], item);
        });
        return !!equals_1;
    } else return lastProps === newProps;
}
function $a331d7a6c631e6d9$var$updateLabelShowHide(labelEl, axisPointerModel) {
    labelEl[axisPointerModel.get([
        "label",
        "show"
    ]) ? "show" : "hide"]();
}
function $a331d7a6c631e6d9$var$getHandleTransProps(trans) {
    return {
        x: trans.x || 0,
        y: trans.y || 0,
        rotation: trans.rotation || 0
    };
}
function $a331d7a6c631e6d9$var$updateMandatoryProps(group, axisPointerModel, silent) {
    var z = axisPointerModel.get("z");
    var zlevel = axisPointerModel.get("zlevel");
    group && group.traverse(function(el) {
        if (el.type !== "group") {
            z != null && (el.z = z);
            zlevel != null && (el.zlevel = zlevel);
            el.silent = silent;
        }
    });
}
var $a331d7a6c631e6d9$export$2e2bcd8739ae039 = $a331d7a6c631e6d9$var$BaseAxisPointer;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







function $51dec70890757374$export$b7fe459c7cc50060(axisPointerModel) {
    var axisPointerType = axisPointerModel.get("type");
    var styleModel = axisPointerModel.getModel(axisPointerType + "Style");
    var style;
    if (axisPointerType === "line") {
        style = styleModel.getLineStyle();
        style.fill = null;
    } else if (axisPointerType === "shadow") {
        style = styleModel.getAreaStyle();
        style.stroke = null;
    }
    return style;
}
function $51dec70890757374$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, labelPos) {
    var value = axisPointerModel.get("value");
    var text = $51dec70890757374$export$7cffee0f9aed39d0(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get("seriesDataIndices"), {
        precision: axisPointerModel.get([
            "label",
            "precision"
        ]),
        formatter: axisPointerModel.get([
            "label",
            "formatter"
        ])
    });
    var labelModel = axisPointerModel.getModel("label");
    var paddings = $c84c9521536c601a$export$f3a38102c49f4268(labelModel.get("padding") || 0);
    var font = labelModel.getFont();
    var textRect = $6c308355c7107803$export$c381147bfed79d9f(text, font);
    var position = labelPos.position;
    var width = textRect.width + paddings[1] + paddings[3];
    var height = textRect.height + paddings[0] + paddings[2];
    // Adjust by align.
    var align = labelPos.align;
    align === "right" && (position[0] -= width);
    align === "center" && (position[0] -= width / 2);
    var verticalAlign = labelPos.verticalAlign;
    verticalAlign === "bottom" && (position[1] -= height);
    verticalAlign === "middle" && (position[1] -= height / 2);
    // Not overflow ec container
    $51dec70890757374$var$confineInContainer(position, width, height, api);
    var bgColor = labelModel.get("backgroundColor");
    if (!bgColor || bgColor === "auto") bgColor = axisModel.get([
        "axisLine",
        "lineStyle",
        "color"
    ]);
    elOption.label = {
        // shape: {x: 0, y: 0, width: width, height: height, r: labelModel.get('borderRadius')},
        x: position[0],
        y: position[1],
        style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(labelModel, {
            text: text,
            font: font,
            fill: labelModel.getTextColor(),
            padding: paddings,
            backgroundColor: bgColor
        }),
        // Label should be over axisPointer.
        z2: 10
    };
}
// Do not overflow ec container
function $51dec70890757374$var$confineInContainer(position, width, height, api) {
    var viewWidth = api.getWidth();
    var viewHeight = api.getHeight();
    position[0] = Math.min(position[0] + width, viewWidth) - width;
    position[1] = Math.min(position[1] + height, viewHeight) - height;
    position[0] = Math.max(position[0], 0);
    position[1] = Math.max(position[1], 0);
}
function $51dec70890757374$export$7cffee0f9aed39d0(value, axis, ecModel, seriesDataIndices, opt) {
    value = axis.scale.parse(value);
    var text = axis.scale.getLabel({
        value: value
    }, {
        // If `precision` is set, width can be fixed (like '12.00500'), which
        // helps to debounce when when moving label.
        precision: opt.precision
    });
    var formatter = opt.formatter;
    if (formatter) {
        var params_1 = {
            value: $2d646e51cc34f840$export$a5a32f324c1fa457(axis, {
                value: value
            }),
            axisDimension: axis.dim,
            axisIndex: axis.index,
            seriesData: []
        };
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(seriesDataIndices, function(idxItem) {
            var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
            var dataIndex = idxItem.dataIndexInside;
            var dataParams = series && series.getDataParams(dataIndex);
            dataParams && params_1.seriesData.push(dataParams);
        });
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(formatter)) text = formatter.replace("{value}", text);
        else if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(formatter)) text = formatter(params_1);
    }
    return text;
}
function $51dec70890757374$export$4bb66440324c3a3d(axis, value, layoutInfo) {
    var transform = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
    $f41ebb9dd60b55b4$export$bb628a54ab399bc9(transform, transform, layoutInfo.rotation);
    $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(transform, transform, layoutInfo.position);
    return $5b455ae6f843ac47$export$9f9dcb98c894b623([
        axis.dataToCoord(value),
        (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)
    ], transform);
}
function $51dec70890757374$export$fd3eb3812211a173(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
    var textLayout = (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039).innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
    layoutInfo.labelMargin = axisPointerModel.get([
        "label",
        "margin"
    ]);
    $51dec70890757374$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, {
        position: $51dec70890757374$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo),
        align: textLayout.textAlign,
        verticalAlign: textLayout.textVerticalAlign
    });
}
function $51dec70890757374$export$885fa0ad5a826207(p1, p2, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x1: p1[xDimIndex],
        y1: p1[1 - xDimIndex],
        x2: p2[xDimIndex],
        y2: p2[1 - xDimIndex]
    };
}
function $51dec70890757374$export$a8b35248bcc02756(xy, wh, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x: xy[xDimIndex],
        y: xy[1 - xDimIndex],
        width: wh[xDimIndex],
        height: wh[1 - xDimIndex]
    };
}
function $51dec70890757374$export$b0cf82e7ebc0d7d0(cx, cy, r0, r, startAngle, endAngle) {
    return {
        cx: cx,
        cy: cy,
        r0: r0,
        r: r,
        startAngle: startAngle,
        endAngle: endAngle,
        clockwise: true
    };
}



var $044c80eefb03ac3d$var$CartesianAxisPointer = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CartesianAxisPointer, _super);
    function CartesianAxisPointer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @override
   */ CartesianAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisPointerType = axisPointerModel.get("type");
        var otherExtent = $044c80eefb03ac3d$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));
        if (axisPointerType && axisPointerType !== "none") {
            var elStyle = $51dec70890757374$export$b7fe459c7cc50060(axisPointerModel);
            var pointerOption = $044c80eefb03ac3d$var$pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var layoutInfo = $88c937c9bc0ca068$export$b3219800bda33a1f(grid.getRect(), axisModel);
        $51dec70890757374$export$fd3eb3812211a173(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.getHandleTransform = function(value, axisModel, axisPointerModel) {
        var layoutInfo = $88c937c9bc0ca068$export$b3219800bda33a1f(axisModel.axis.grid.getRect(), axisModel, {
            labelInside: false
        });
        layoutInfo.labelMargin = axisPointerModel.get([
            "handle",
            "margin"
        ]);
        var pos = $51dec70890757374$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo);
        return {
            x: pos[0],
            y: pos[1],
            rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
        };
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.updateHandleTransform = function(transform, delta, axisModel, axisPointerModel) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisExtent = axis.getGlobalExtent(true);
        var otherExtent = $044c80eefb03ac3d$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var dimIndex = axis.dim === "x" ? 0 : 1;
        var currPosition = [
            transform.x,
            transform.y
        ];
        currPosition[dimIndex] += delta[dimIndex];
        currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
        currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
        var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
        var cursorPoint = [
            cursorOtherValue,
            cursorOtherValue
        ];
        cursorPoint[dimIndex] = currPosition[dimIndex];
        // Make tooltip do not overlap axisPointer and in the middle of the grid.
        var tooltipOptions = [
            {
                verticalAlign: "middle"
            },
            {
                align: "center"
            }
        ];
        return {
            x: currPosition[0],
            y: currPosition[1],
            rotation: transform.rotation,
            cursorPoint: cursorPoint,
            tooltipOption: tooltipOptions[dimIndex]
        };
    };
    return CartesianAxisPointer;
}((0, $a331d7a6c631e6d9$export$2e2bcd8739ae039));
function $044c80eefb03ac3d$var$getCartesian(grid, axis) {
    var opt = {};
    opt[axis.dim + "AxisIndex"] = axis.index;
    return grid.getCartesian(opt);
}
var $044c80eefb03ac3d$var$pointerShapeBuilder = {
    line: function(axis, pixelValue, otherExtent) {
        var targetShape = $51dec70890757374$export$885fa0ad5a826207([
            pixelValue,
            otherExtent[0]
        ], [
            pixelValue,
            otherExtent[1]
        ], $044c80eefb03ac3d$var$getAxisDimIndex(axis));
        return {
            type: "Line",
            subPixelOptimize: true,
            shape: targetShape
        };
    },
    shadow: function(axis, pixelValue, otherExtent) {
        var bandWidth = Math.max(1, axis.getBandWidth());
        var span = otherExtent[1] - otherExtent[0];
        return {
            type: "Rect",
            shape: $51dec70890757374$export$a8b35248bcc02756([
                pixelValue - bandWidth / 2,
                otherExtent[0]
            ], [
                bandWidth,
                span
            ], $044c80eefb03ac3d$var$getAxisDimIndex(axis))
        };
    }
};
function $044c80eefb03ac3d$var$getAxisDimIndex(axis) {
    return axis.dim === "x" ? 0 : 1;
}
var $044c80eefb03ac3d$export$2e2bcd8739ae039 = $044c80eefb03ac3d$var$CartesianAxisPointer;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $f55b7040bd1041c6$var$AxisPointerModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(AxisPointerModel, _super);
    function AxisPointerModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerModel.type;
        return _this;
    }
    AxisPointerModel.type = "axisPointer";
    AxisPointerModel.defaultOption = {
        // 'auto' means that show when triggered by tooltip or handle.
        show: "auto",
        // zlevel: 0,
        z: 50,
        type: "line",
        // axispointer triggered by tootip determine snap automatically,
        // see `modelHelper`.
        snap: false,
        triggerTooltip: true,
        triggerEmphasis: true,
        value: null,
        status: null,
        link: [],
        // Do not set 'auto' here, otherwise global animation: false
        // will not effect at this axispointer.
        animation: null,
        animationDurationUpdate: 200,
        lineStyle: {
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.border,
            width: 1,
            type: "dashed"
        },
        shadowStyle: {
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.shadowTint
        },
        label: {
            show: true,
            formatter: null,
            precision: "auto",
            margin: 3,
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral00,
            padding: [
                5,
                7,
                5,
                7
            ],
            backgroundColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent60,
            borderColor: null,
            borderWidth: 0,
            borderRadius: 3
        },
        handle: {
            show: false,
            // eslint-disable-next-line
            icon: "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z",
            size: 45,
            // handle margin is from symbol center to axis, which is stable when circular move.
            margin: 50,
            // color: '#1b8bbd'
            // color: '#2f4554'
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent40,
            // For mobile performance
            throttle: 40
        }
    };
    return AxisPointerModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $f55b7040bd1041c6$export$2e2bcd8739ae039 = $f55b7040bd1041c6$var$AxisPointerModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $84450f5aa7fbde00$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $84450f5aa7fbde00$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
function $84450f5aa7fbde00$export$6503ec6e8aabbaf(key, api, handler) {
    if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node) return;
    var zr = api.getZr();
    $84450f5aa7fbde00$var$inner(zr).records || ($84450f5aa7fbde00$var$inner(zr).records = {});
    $84450f5aa7fbde00$var$initGlobalListeners(zr, api);
    var record = $84450f5aa7fbde00$var$inner(zr).records[key] || ($84450f5aa7fbde00$var$inner(zr).records[key] = {});
    record.handler = handler;
}
function $84450f5aa7fbde00$var$initGlobalListeners(zr, api) {
    if ($84450f5aa7fbde00$var$inner(zr).initialized) return;
    $84450f5aa7fbde00$var$inner(zr).initialized = true;
    useHandler("click", $7a1bd9c2710fea0d$export$c3095a23b368d1f2($84450f5aa7fbde00$var$doEnter, "click"));
    useHandler("mousemove", $7a1bd9c2710fea0d$export$c3095a23b368d1f2($84450f5aa7fbde00$var$doEnter, "mousemove"));
    // useHandler('mouseout', onLeave);
    useHandler("globalout", $84450f5aa7fbde00$var$onLeave);
    function useHandler(eventType, cb) {
        zr.on(eventType, function(e) {
            var dis = $84450f5aa7fbde00$var$makeDispatchAction(api);
            $84450f5aa7fbde00$var$each($84450f5aa7fbde00$var$inner(zr).records, function(record) {
                record && cb(record, e, dis.dispatchAction);
            });
            $84450f5aa7fbde00$var$dispatchTooltipFinally(dis.pendings, api);
        });
    }
}
function $84450f5aa7fbde00$var$dispatchTooltipFinally(pendings, api) {
    var showLen = pendings.showTip.length;
    var hideLen = pendings.hideTip.length;
    var actuallyPayload;
    if (showLen) actuallyPayload = pendings.showTip[showLen - 1];
    else if (hideLen) actuallyPayload = pendings.hideTip[hideLen - 1];
    if (actuallyPayload) {
        actuallyPayload.dispatchAction = null;
        api.dispatchAction(actuallyPayload);
    }
}
function $84450f5aa7fbde00$var$onLeave(record, e, dispatchAction) {
    record.handler("leave", null, dispatchAction);
}
function $84450f5aa7fbde00$var$doEnter(currTrigger, record, e, dispatchAction) {
    record.handler(currTrigger, e, dispatchAction);
}
function $84450f5aa7fbde00$var$makeDispatchAction(api) {
    var pendings = {
        showTip: [],
        hideTip: []
    };
    // FIXME
    // better approach?
    // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
    // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
    // So we have to add "final stage" to merge those dispatched actions.
    var dispatchAction = function(payload) {
        var pendingList = pendings[payload.type];
        if (pendingList) pendingList.push(payload);
        else {
            payload.dispatchAction = dispatchAction;
            api.dispatchAction(payload);
        }
    };
    return {
        dispatchAction: dispatchAction,
        pendings: pendings
    };
}
function $84450f5aa7fbde00$export$d07f55d4c15c0440(key, api) {
    if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node) return;
    var zr = api.getZr();
    var record = ($84450f5aa7fbde00$var$inner(zr).records || {})[key];
    if (record) $84450f5aa7fbde00$var$inner(zr).records[key] = null;
}



var $615cfe2d5ef5fcce$var$AxisPointerView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(AxisPointerView, _super);
    function AxisPointerView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerView.type;
        return _this;
    }
    AxisPointerView.prototype.render = function(globalAxisPointerModel, ecModel, api) {
        var globalTooltipModel = ecModel.getComponent("tooltip");
        var triggerOn = globalAxisPointerModel.get("triggerOn") || globalTooltipModel && globalTooltipModel.get("triggerOn") || "mousemove|click";
        // Register global listener in AxisPointerView to enable
        // AxisPointerView to be independent to Tooltip.
        $84450f5aa7fbde00$export$6503ec6e8aabbaf("axisPointer", api, function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== "none" && (currTrigger === "leave" || triggerOn.indexOf(currTrigger) >= 0)) dispatchAction({
                type: "updateAxisPointer",
                currTrigger: currTrigger,
                x: e && e.offsetX,
                y: e && e.offsetY
            });
        });
    };
    AxisPointerView.prototype.remove = function(ecModel, api) {
        $84450f5aa7fbde00$export$d07f55d4c15c0440("axisPointer", api);
    };
    AxisPointerView.prototype.dispose = function(ecModel, api) {
        $84450f5aa7fbde00$export$d07f55d4c15c0440("axisPointer", api);
    };
    AxisPointerView.type = "axisPointer";
    return AxisPointerView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $615cfe2d5ef5fcce$export$2e2bcd8739ae039 = $615cfe2d5ef5fcce$var$AxisPointerView;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $4cab5d8b3532dad5$export$2e2bcd8739ae039(finder, ecModel) {
    var point = [];
    var seriesIndex = finder.seriesIndex;
    var seriesModel;
    if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) return {
        point: []
    };
    var data = seriesModel.getData();
    var dataIndex = $76d619f648247e6d$export$42b26cae8b8d10(data, finder);
    if (dataIndex == null || dataIndex < 0 || $7a1bd9c2710fea0d$export$43bee75e5e14138e(dataIndex)) return {
        point: []
    };
    var el = data.getItemGraphicEl(dataIndex);
    var coordSys = seriesModel.coordinateSystem;
    if (seriesModel.getTooltipPosition) point = seriesModel.getTooltipPosition(dataIndex) || [];
    else if (coordSys && coordSys.dataToPoint) {
        if (finder.isStacked) {
            var baseAxis = coordSys.getBaseAxis();
            var valueAxis = coordSys.getOtherAxis(baseAxis);
            var valueAxisDim = valueAxis.dim;
            var baseAxisDim = baseAxis.dim;
            var baseDataOffset = valueAxisDim === "x" || valueAxisDim === "radius" ? 1 : 0;
            var baseDim = data.mapDimension(baseAxisDim);
            var stackedData = [];
            stackedData[baseDataOffset] = data.get(baseDim, dataIndex);
            stackedData[1 - baseDataOffset] = data.get(data.getCalculationInfo("stackResultDimension"), dataIndex);
            point = coordSys.dataToPoint(stackedData) || [];
        } else point = coordSys.dataToPoint(data.getValues($7a1bd9c2710fea0d$export$871de8747c9eaa88(coordSys.dimensions, function(dim) {
            return data.mapDimension(dim);
        }), dataIndex)) || [];
    } else if (el) {
        // Use graphic bounding rect
        var rect = el.getBoundingRect().clone();
        rect.applyTransform(el.transform);
        point = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    }
    return {
        point: point,
        el: el
    };
}



var $1cb2191f8bc71b5b$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $1cb2191f8bc71b5b$export$2e2bcd8739ae039(payload, ecModel, api) {
    var currTrigger = payload.currTrigger;
    var point = [
        payload.x,
        payload.y
    ];
    var finder = payload;
    var dispatchAction = payload.dispatchAction || (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(api.dispatchAction, api);
    var coordSysAxesInfo = ecModel.getComponent("axisPointer").coordSysAxesInfo;
    // Pending
    // See #6121. But we are not able to reproduce it yet.
    if (!coordSysAxesInfo) return;
    if ($1cb2191f8bc71b5b$var$illegalPoint(point)) // Used in the default behavior of `connection`: use the sample seriesIndex
    // and dataIndex. And also used in the tooltipView trigger.
    point = (0, $4cab5d8b3532dad5$export$2e2bcd8739ae039)({
        seriesIndex: finder.seriesIndex,
        // Do not use dataIndexInside from other ec instance.
        // FIXME: auto detect it?
        dataIndex: finder.dataIndex
    }, ecModel).point;
    var isIllegalPoint = $1cb2191f8bc71b5b$var$illegalPoint(point);
    // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
    // Notice: In this case, it is difficult to get the `point` (which is necessary to show
    // tooltip, so if point is not given, we just use the point found by sample seriesIndex
    // and dataIndex.
    var inputAxesInfo = finder.axesInfo;
    var axesInfo = coordSysAxesInfo.axesInfo;
    var shouldHide = currTrigger === "leave" || $1cb2191f8bc71b5b$var$illegalPoint(point);
    var outputPayload = {};
    var showValueMap = {};
    var dataByCoordSys = {
        list: [],
        map: {}
    };
    var updaters = {
        showPointer: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($1cb2191f8bc71b5b$var$showPointer, showValueMap),
        showTooltip: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($1cb2191f8bc71b5b$var$showTooltip, dataByCoordSys)
    };
    // Process for triggered axes.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordSysAxesInfo.coordSysMap, function(coordSys, coordSysKey) {
        // If a point given, it must be contained by the coordinate system.
        var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function(axisInfo, key) {
            var axis = axisInfo.axis;
            var inputAxisInfo = $1cb2191f8bc71b5b$var$findInputAxisInfo(inputAxesInfo, axisInfo);
            // If no inputAxesInfo, no axis is restricted.
            if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
                var val = inputAxisInfo && inputAxisInfo.value;
                if (val == null && !isIllegalPoint) val = axis.pointToData(point);
                val != null && $1cb2191f8bc71b5b$var$processOnAxis(axisInfo, val, updaters, false, outputPayload);
            }
        });
    });
    // Process for linked axes.
    var linkTriggers = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesInfo, function(tarAxisInfo, tarKey) {
        var linkGroup = tarAxisInfo.linkGroup;
        // If axis has been triggered in the previous stage, it should not be triggered by link.
        if (linkGroup && !showValueMap[tarKey]) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(linkGroup.axesInfo, function(srcAxisInfo, srcKey) {
            var srcValItem = showValueMap[srcKey];
            // If srcValItem exist, source axis is triggered, so link to target axis.
            if (srcAxisInfo !== tarAxisInfo && srcValItem) {
                var val = srcValItem.value;
                linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, $1cb2191f8bc71b5b$var$makeMapperParam(srcAxisInfo), $1cb2191f8bc71b5b$var$makeMapperParam(tarAxisInfo))));
                linkTriggers[tarAxisInfo.key] = val;
            }
        });
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(linkTriggers, function(val, tarKey) {
        $1cb2191f8bc71b5b$var$processOnAxis(axesInfo[tarKey], val, updaters, true, outputPayload);
    });
    $1cb2191f8bc71b5b$var$updateModelActually(showValueMap, axesInfo, outputPayload);
    $1cb2191f8bc71b5b$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
    $1cb2191f8bc71b5b$var$dispatchHighDownActually(axesInfo, dispatchAction, api);
    return outputPayload;
}
function $1cb2191f8bc71b5b$var$processOnAxis(axisInfo, newValue, updaters, noSnap, outputFinder) {
    var axis = axisInfo.axis;
    if (axis.scale.isBlank() || !axis.containData(newValue)) return;
    if (!axisInfo.involveSeries) {
        updaters.showPointer(axisInfo, newValue);
        return;
    }
    // Heavy calculation. So put it after axis.containData checking.
    var payloadInfo = $1cb2191f8bc71b5b$var$buildPayloadsBySeries(newValue, axisInfo);
    var payloadBatch = payloadInfo.payloadBatch;
    var snapToValue = payloadInfo.snapToValue;
    // Fill content of event obj for echarts.connect.
    // By default use the first involved series data as a sample to connect.
    if (payloadBatch[0] && outputFinder.seriesIndex == null) (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(outputFinder, payloadBatch[0]);
    // If no linkSource input, this process is for collecting link
    // target, where snap should not be accepted.
    if (!noSnap && axisInfo.snap) {
        if (axis.containData(snapToValue) && snapToValue != null) newValue = snapToValue;
    }
    updaters.showPointer(axisInfo, newValue, payloadBatch);
    // Tooltip should always be snapToValue, otherwise there will be
    // incorrect "axis value ~ series value" mapping displayed in tooltip.
    updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
}
function $1cb2191f8bc71b5b$var$buildPayloadsBySeries(value, axisInfo) {
    var axis = axisInfo.axis;
    var dim = axis.dim;
    var snapToValue = value;
    var payloadBatch = [];
    var minDist = Number.MAX_VALUE;
    var minDiff = -1;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisInfo.seriesModels, function(series, idx) {
        var dataDim = series.getData().mapDimensionsAll(dim);
        var seriesNestestValue;
        var dataIndices;
        if (series.getAxisTooltipData) {
            var result = series.getAxisTooltipData(dataDim, value, axis);
            dataIndices = result.dataIndices;
            seriesNestestValue = result.nestestValue;
        } else {
            dataIndices = series.indicesOfNearest(dim, dataDim[0], value, // Add a threshold to avoid find the wrong dataIndex
            // when data length is not same.
            // false,
            axis.type === "category" ? 0.5 : null);
            if (!dataIndices.length) return;
            seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
        }
        if (seriesNestestValue == null || !isFinite(seriesNestestValue)) return;
        var diff = value - seriesNestestValue;
        var dist = Math.abs(diff);
        // Consider category case
        if (dist <= minDist) {
            if (dist < minDist || diff >= 0 && minDiff < 0) {
                minDist = dist;
                minDiff = diff;
                snapToValue = seriesNestestValue;
                payloadBatch.length = 0;
            }
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dataIndices, function(dataIndex) {
                payloadBatch.push({
                    seriesIndex: series.seriesIndex,
                    dataIndexInside: dataIndex,
                    dataIndex: series.getData().getRawIndex(dataIndex)
                });
            });
        }
    });
    return {
        payloadBatch: payloadBatch,
        snapToValue: snapToValue
    };
}
function $1cb2191f8bc71b5b$var$showPointer(showValueMap, axisInfo, value, payloadBatch) {
    showValueMap[axisInfo.key] = {
        value: value,
        payloadBatch: payloadBatch
    };
}
function $1cb2191f8bc71b5b$var$showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
    var payloadBatch = payloadInfo.payloadBatch;
    var axis = axisInfo.axis;
    var axisModel = axis.model;
    var axisPointerModel = axisInfo.axisPointerModel;
    // If no data, do not create anything in dataByCoordSys,
    // whose length will be used to judge whether dispatch action.
    if (!axisInfo.triggerTooltip || !payloadBatch.length) return;
    var coordSysModel = axisInfo.coordSys.model;
    var coordSysKey = $84d826b9ba8bf009$export$d01b444bafb1a792(coordSysModel);
    var coordSysItem = dataByCoordSys.map[coordSysKey];
    if (!coordSysItem) {
        coordSysItem = dataByCoordSys.map[coordSysKey] = {
            coordSysId: coordSysModel.id,
            coordSysIndex: coordSysModel.componentIndex,
            coordSysType: coordSysModel.type,
            coordSysMainType: coordSysModel.mainType,
            dataByAxis: []
        };
        dataByCoordSys.list.push(coordSysItem);
    }
    coordSysItem.dataByAxis.push({
        axisDim: axis.dim,
        axisIndex: axisModel.componentIndex,
        axisType: axisModel.type,
        axisId: axisModel.id,
        value: value,
        // Caustion: viewHelper.getValueLabel is actually on "view stage", which
        // depends that all models have been updated. So it should not be performed
        // here. Considering axisPointerModel used here is volatile, which is hard
        // to be retrieve in TooltipView, we prepare parameters here.
        valueLabelOpt: {
            precision: axisPointerModel.get([
                "label",
                "precision"
            ]),
            formatter: axisPointerModel.get([
                "label",
                "formatter"
            ])
        },
        seriesDataIndices: payloadBatch.slice()
    });
}
function $1cb2191f8bc71b5b$var$updateModelActually(showValueMap, axesInfo, outputPayload) {
    var outputAxesInfo = outputPayload.axesInfo = [];
    // Basic logic: If no 'show' required, 'hide' this axisPointer.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        var valItem = showValueMap[key];
        if (valItem) {
            !axisInfo.useHandle && (option.status = "show");
            option.value = valItem.value;
            // For label formatter param and highlight.
            option.seriesDataIndices = (valItem.payloadBatch || []).slice();
        } else // If hide, value still need to be set, consider
        // click legend to toggle axis blank.
        !axisInfo.useHandle && (option.status = "hide");
        // If status is 'hide', should be no info in payload.
        option.status === "show" && outputAxesInfo.push({
            axisDim: axisInfo.axis.dim,
            axisIndex: axisInfo.axis.model.componentIndex,
            value: option.value
        });
    });
}
function $1cb2191f8bc71b5b$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
    // Basic logic: If no showTip required, hideTip will be dispatched.
    if ($1cb2191f8bc71b5b$var$illegalPoint(point) || !dataByCoordSys.list.length) {
        dispatchAction({
            type: "hideTip"
        });
        return;
    }
    // In most case only one axis (or event one series is used). It is
    // convenient to fetch payload.seriesIndex and payload.dataIndex
    // directly. So put the first seriesIndex and dataIndex of the first
    // axis on the payload.
    var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
    dispatchAction({
        type: "showTip",
        escapeConnect: true,
        x: point[0],
        y: point[1],
        tooltipOption: payload.tooltipOption,
        position: payload.position,
        dataIndexInside: sampleItem.dataIndexInside,
        dataIndex: sampleItem.dataIndex,
        seriesIndex: sampleItem.seriesIndex,
        dataByCoordSys: dataByCoordSys.list
    });
}
function $1cb2191f8bc71b5b$var$dispatchHighDownActually(axesInfo, dispatchAction, api) {
    // FIXME
    // highlight status modification should be a stage of main process?
    // (Consider confilct (e.g., legend and axisPointer) and setOption)
    var zr = api.getZr();
    var highDownKey = "axisPointerLastHighlights";
    var lastHighlights = $1cb2191f8bc71b5b$var$inner(zr)[highDownKey] || {};
    var newHighlights = $1cb2191f8bc71b5b$var$inner(zr)[highDownKey] = {};
    // Update highlight/downplay status according to axisPointer model.
    // Build hash map and remove duplicate incidentally.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        option.status === "show" && axisInfo.triggerEmphasis && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(option.seriesDataIndices, function(batchItem) {
            var key = batchItem.seriesIndex + " | " + batchItem.dataIndex;
            newHighlights[key] = batchItem;
        });
    });
    // Diff.
    var toHighlight = [];
    var toDownplay = [];
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(lastHighlights, function(batchItem, key) {
        !newHighlights[key] && toDownplay.push(batchItem);
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newHighlights, function(batchItem, key) {
        !lastHighlights[key] && toHighlight.push(batchItem);
    });
    toDownplay.length && api.dispatchAction({
        type: "downplay",
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toDownplay
    });
    toHighlight.length && api.dispatchAction({
        type: "highlight",
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toHighlight
    });
}
function $1cb2191f8bc71b5b$var$findInputAxisInfo(inputAxesInfo, axisInfo) {
    for(var i = 0; i < (inputAxesInfo || []).length; i++){
        var inputAxisInfo = inputAxesInfo[i];
        if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) return inputAxisInfo;
    }
}
function $1cb2191f8bc71b5b$var$makeMapperParam(axisInfo) {
    var axisModel = axisInfo.axis.model;
    var item = {};
    var dim = item.axisDim = axisInfo.axis.dim;
    item.axisIndex = item[dim + "AxisIndex"] = axisModel.componentIndex;
    item.axisName = item[dim + "AxisName"] = axisModel.name;
    item.axisId = item[dim + "AxisId"] = axisModel.id;
    return item;
}
function $1cb2191f8bc71b5b$var$illegalPoint(point) {
    return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
}


function $589507869c21caa1$export$4b3e715f166fdd78(registers) {
    // CartesianAxisPointer is not supposed to be required here. But consider
    // echarts.simple.js and online build tooltip, which only require gridSimple,
    // CartesianAxisPointer should be able to required somewhere.
    (0, $58c48a3ef1aa0746$export$2e2bcd8739ae039).registerAxisPointerClass("CartesianAxisPointer", (0, $044c80eefb03ac3d$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $f55b7040bd1041c6$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $615cfe2d5ef5fcce$export$2e2bcd8739ae039));
    registers.registerPreprocessor(function(option) {
        // Always has a global axisPointerModel for default setting.
        if (option) {
            (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
            var link = option.axisPointer.link;
            // Normalize to array to avoid object mergin. But if link
            // is not set, remain null/undefined, otherwise it will
            // override existent link setting.
            if (link && !(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(link)) option.axisPointer.link = [
                link
            ];
        }
    });
    // This process should proformed after coordinate systems created
    // and series data processed. So put it on statistic processing stage.
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, function(ecModel, api) {
        // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
        // allAxesInfo should be updated when setOption performed.
        ecModel.getComponent("axisPointer").coordSysAxesInfo = (0, $84d826b9ba8bf009$export$bb44f104e3c54dae)(ecModel, api);
    });
    // Broadcast to all views.
    registers.registerAction({
        type: "updateAxisPointer",
        event: "updateAxisPointer",
        update: ":updateAxisPointer"
    }, (0, $1cb2191f8bc71b5b$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $860dd9ca08385e85$var$DEFAULT_TOOLBOX_BTNS = [
    "rect",
    "polygon",
    "keep",
    "clear"
];
function $860dd9ca08385e85$export$2e2bcd8739ae039(option, isNew) {
    var brushComponents = (0, $76d619f648247e6d$export$4f07b212a02c8051)(option ? option.brush : []);
    if (!brushComponents.length) return;
    var brushComponentSpecifiedBtns = [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(brushComponents, function(brushOpt) {
        var tbs = brushOpt.hasOwnProperty("toolbox") ? brushOpt.toolbox : [];
        if (tbs instanceof Array) brushComponentSpecifiedBtns = brushComponentSpecifiedBtns.concat(tbs);
    });
    var toolbox = option && option.toolbox;
    if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(toolbox)) toolbox = toolbox[0];
    if (!toolbox) {
        toolbox = {
            feature: {}
        };
        option.toolbox = [
            toolbox
        ];
    }
    var toolboxFeature = toolbox.feature || (toolbox.feature = {});
    var toolboxBrush = toolboxFeature.brush || (toolboxFeature.brush = {});
    var brushTypes = toolboxBrush.type || (toolboxBrush.type = []);
    brushTypes.push.apply(brushTypes, brushComponentSpecifiedBtns);
    $860dd9ca08385e85$var$removeDuplicate(brushTypes);
    if (isNew && !brushTypes.length) brushTypes.push.apply(brushTypes, $860dd9ca08385e85$var$DEFAULT_TOOLBOX_BTNS);
}
function $860dd9ca08385e85$var$removeDuplicate(arr) {
    var map = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(arr, function(val) {
        map[val] = 1;
    });
    arr.length = 0;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(map, function(flag, val) {
        arr.push(val);
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @file Visual solution, for consistent option specification.
 */ 


var $87ea23222d1c134e$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
function $87ea23222d1c134e$var$hasKeys(obj) {
    if (obj) for(var name_1 in obj){
        if (obj.hasOwnProperty(name_1)) return true;
    }
}
function $87ea23222d1c134e$export$89974527642f24a0(option, stateList, supplementVisualOption) {
    var visualMappings = {};
    $87ea23222d1c134e$var$each(stateList, function(state) {
        var mappings = visualMappings[state] = createMappings();
        $87ea23222d1c134e$var$each(option[state], function(visualData, visualType) {
            if (!(0, $7b50f502cfd189d5$export$2e2bcd8739ae039).isValidType(visualType)) return;
            var mappingOption = {
                type: visualType,
                visual: visualData
            };
            supplementVisualOption && supplementVisualOption(mappingOption, state);
            mappings[visualType] = new (0, $7b50f502cfd189d5$export$2e2bcd8739ae039)(mappingOption);
            // Prepare a alpha for opacity, for some case that opacity
            // is not supported, such as rendering using gradient color.
            if (visualType === "opacity") {
                mappingOption = $7a1bd9c2710fea0d$export$9cd59f9826255e47(mappingOption);
                mappingOption.type = "colorAlpha";
                mappings.__hidden.__alphaForOpacity = new (0, $7b50f502cfd189d5$export$2e2bcd8739ae039)(mappingOption);
            }
        });
    });
    return visualMappings;
    function createMappings() {
        var Creater = function() {};
        // Make sure hidden fields will not be visited by
        // object iteration (with hasOwnProperty checking).
        Creater.prototype.__hidden = Creater.prototype;
        var obj = new Creater();
        return obj;
    }
}
function $87ea23222d1c134e$export$797d20c0a6de578f(thisOption, newOption, keys) {
    // Visual attributes merge is not supported, otherwise it
    // brings overcomplicated merge logic. See #2853. So if
    // newOption has anyone of these keys, all of these keys
    // will be reset. Otherwise, all keys remain.
    var has;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(keys, function(key) {
        if (newOption.hasOwnProperty(key) && $87ea23222d1c134e$var$hasKeys(newOption[key])) has = true;
    });
    has && $7a1bd9c2710fea0d$export$79b2f7037acddd43(keys, function(key) {
        if (newOption.hasOwnProperty(key) && $87ea23222d1c134e$var$hasKeys(newOption[key])) thisOption[key] = $7a1bd9c2710fea0d$export$9cd59f9826255e47(newOption[key]);
        else delete thisOption[key];
    });
}
function $87ea23222d1c134e$export$bb1ef43951d58629(stateList, visualMappings, data, getValueState, scope, dimension) {
    var visualTypesMap = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(stateList, function(state) {
        var visualTypes = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).prepareVisualTypes(visualMappings[state]);
        visualTypesMap[state] = visualTypes;
    });
    var dataIndex;
    function getVisual(key) {
        return (0, $ea13f1ab2169d82d$export$91d919a86b2df624)(data, dataIndex, key);
    }
    function setVisual(key, value) {
        (0, $ea13f1ab2169d82d$export$3aab879e9d0e7c75)(data, dataIndex, key, value);
    }
    if (dimension == null) data.each(eachItem);
    else data.each([
        dimension
    ], eachItem);
    function eachItem(valueOrIndex, index) {
        dataIndex = dimension == null ? valueOrIndex // First argument is index
         : index;
        var rawDataItem = data.getRawDataItem(dataIndex);
        // Consider performance
        // @ts-ignore
        if (rawDataItem && rawDataItem.visualMap === false) return;
        var valueState = getValueState.call(scope, valueOrIndex);
        var mappings = visualMappings[valueState];
        var visualTypes = visualTypesMap[valueState];
        for(var i = 0, len = visualTypes.length; i < len; i++){
            var type = visualTypes[i];
            mappings[type] && mappings[type].applyVisual(valueOrIndex, getVisual, setVisual);
        }
    }
}
function $87ea23222d1c134e$export$fc0ef8703cccf128(stateList, visualMappings, getValueState, dim) {
    var visualTypesMap = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(stateList, function(state) {
        var visualTypes = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).prepareVisualTypes(visualMappings[state]);
        visualTypesMap[state] = visualTypes;
    });
    return {
        progress: function progress(params, data) {
            var dimIndex;
            if (dim != null) dimIndex = data.getDimensionIndex(dim);
            function getVisual(key) {
                return (0, $ea13f1ab2169d82d$export$91d919a86b2df624)(data, dataIndex, key);
            }
            function setVisual(key, value) {
                (0, $ea13f1ab2169d82d$export$3aab879e9d0e7c75)(data, dataIndex, key, value);
            }
            var dataIndex;
            var store = data.getStore();
            while((dataIndex = params.next()) != null){
                var rawDataItem = data.getRawDataItem(dataIndex);
                // Consider performance
                // @ts-ignore
                if (rawDataItem && rawDataItem.visualMap === false) continue;
                var value = dim != null ? store.get(dimIndex, dataIndex) : dataIndex;
                var valueState = getValueState(value);
                var mappings = visualMappings[valueState];
                var visualTypes = visualTypesMap[valueState];
                for(var i = 0, len = visualTypes.length; i < len; i++){
                    var type = visualTypes[i];
                    mappings[type] && mappings[type].applyVisual(value, getVisual, setVisual);
                }
            }
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $431fae42b264171b$export$2225cfa0a999c142(area) {
    var brushType = area.brushType;
    // Do not use function binding or curry for performance.
    var selectors = {
        point: function(itemLayout) {
            return $431fae42b264171b$var$selector[brushType].point(itemLayout, selectors, area);
        },
        rect: function(itemLayout) {
            return $431fae42b264171b$var$selector[brushType].rect(itemLayout, selectors, area);
        }
    };
    return selectors;
}
var $431fae42b264171b$var$selector = {
    lineX: $431fae42b264171b$var$getLineSelectors(0),
    lineY: $431fae42b264171b$var$getLineSelectors(1),
    rect: {
        point: function(itemLayout, selectors, area) {
            return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]);
        },
        rect: function(itemLayout, selectors, area) {
            return itemLayout && area.boundingRect.intersect(itemLayout);
        }
    },
    polygon: {
        point: function(itemLayout, selectors, area) {
            return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]) && $b4726ec5f917394d$export$8893e2b90ba10d92(area.range, itemLayout[0], itemLayout[1]);
        },
        rect: function(itemLayout, selectors, area) {
            var points = area.range;
            if (!itemLayout || points.length <= 1) return false;
            var x = itemLayout.x;
            var y = itemLayout.y;
            var width = itemLayout.width;
            var height = itemLayout.height;
            var p = points[0];
            if ($b4726ec5f917394d$export$8893e2b90ba10d92(points, x, y) || $b4726ec5f917394d$export$8893e2b90ba10d92(points, x + width, y) || $b4726ec5f917394d$export$8893e2b90ba10d92(points, x, y + height) || $b4726ec5f917394d$export$8893e2b90ba10d92(points, x + width, y + height) || (0, $1bebe7106c895823$export$2e2bcd8739ae039).create(itemLayout).contain(p[0], p[1]) || (0, $5b455ae6f843ac47$export$4f47c855a5e9ae9)(x, y, x + width, y, points) || (0, $5b455ae6f843ac47$export$4f47c855a5e9ae9)(x, y, x, y + height, points) || (0, $5b455ae6f843ac47$export$4f47c855a5e9ae9)(x + width, y, x + width, y + height, points) || (0, $5b455ae6f843ac47$export$4f47c855a5e9ae9)(x, y + height, x + width, y + height, points)) return true;
        }
    }
};
function $431fae42b264171b$var$getLineSelectors(xyIndex) {
    var xy = [
        "x",
        "y"
    ];
    var wh = [
        "width",
        "height"
    ];
    return {
        point: function(itemLayout, selectors, area) {
            if (itemLayout) {
                var range = area.range;
                var p = itemLayout[xyIndex];
                return $431fae42b264171b$var$inLineRange(p, range);
            }
        },
        rect: function(itemLayout, selectors, area) {
            if (itemLayout) {
                var range = area.range;
                var layoutRange = [
                    itemLayout[xy[xyIndex]],
                    itemLayout[xy[xyIndex]] + itemLayout[wh[xyIndex]]
                ];
                layoutRange[1] < layoutRange[0] && layoutRange.reverse();
                return $431fae42b264171b$var$inLineRange(layoutRange[0], range) || $431fae42b264171b$var$inLineRange(layoutRange[1], range) || $431fae42b264171b$var$inLineRange(range[0], layoutRange) || $431fae42b264171b$var$inLineRange(range[1], layoutRange);
            }
        }
    };
}
function $431fae42b264171b$var$inLineRange(p, range) {
    return range[0] <= p && p <= range[1];
}
var $431fae42b264171b$export$2e2bcd8739ae039 = $431fae42b264171b$var$selector;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



// FIXME
// how to genarialize to more coordinate systems.
var $6213fed8aa63fab1$var$INCLUDE_FINDER_MAIN_TYPES = [
    "grid",
    "xAxis",
    "yAxis",
    "geo",
    "graph",
    "polar",
    "radiusAxis",
    "angleAxis",
    "bmap"
];
var $6213fed8aa63fab1$var$BrushTargetManager = /** @class */ function() {
    /**
   * @param finder contains Index/Id/Name of xAxis/yAxis/geo/grid
   *        Each can be {number|Array.<number>}. like: {xAxisIndex: [3, 4]}
   * @param opt.include include coordinate system types.
   */ function BrushTargetManager(finder, ecModel, opt) {
        var _this = this;
        this._targetInfoList = [];
        var foundCpts = $6213fed8aa63fab1$var$parseFinder(ecModel, finder);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($6213fed8aa63fab1$var$targetInfoBuilders, function(builder, type) {
            if (!opt || !opt.include || (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(opt.include, type) >= 0) builder(foundCpts, _this._targetInfoList);
        });
    }
    BrushTargetManager.prototype.setOutputRanges = function(areas, ecModel) {
        this.matchOutputRanges(areas, ecModel, function(area, coordRange, coordSys) {
            (area.coordRanges || (area.coordRanges = [])).push(coordRange);
            // area.coordRange is the first of area.coordRanges
            if (!area.coordRange) {
                area.coordRange = coordRange;
                // In 'category' axis, coord to pixel is not reversible, so we can not
                // rebuild range by coordRange accrately, which may bring trouble when
                // brushing only one item. So we use __rangeOffset to rebuilding range
                // by coordRange. And this it only used in brush component so it is no
                // need to be adapted to coordRanges.
                var result = $6213fed8aa63fab1$var$coordConvert[area.brushType](0, coordSys, coordRange);
                area.__rangeOffset = {
                    offset: $6213fed8aa63fab1$var$diffProcessor[area.brushType](result.values, area.range, [
                        1,
                        1
                    ]),
                    xyMinMax: result.xyMinMax
                };
            }
        });
        return areas;
    };
    BrushTargetManager.prototype.matchOutputRanges = function(areas, ecModel, cb) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(areas, function(area) {
            var targetInfo = this.findTargetInfo(area, ecModel);
            if (targetInfo && targetInfo !== true) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(targetInfo.coordSyses, function(coordSys) {
                var result = $6213fed8aa63fab1$var$coordConvert[area.brushType](1, coordSys, area.range, true);
                cb(area, result.values, coordSys, ecModel);
            });
        }, this);
    };
    /**
   * the `areas` is `BrushModel.areas`.
   * Called in layout stage.
   * convert `area.coordRange` to global range and set panelId to `area.range`.
   */ BrushTargetManager.prototype.setInputRanges = function(areas, ecModel) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(areas, function(area) {
            var targetInfo = this.findTargetInfo(area, ecModel);
            area.range = area.range || [];
            // convert coordRange to global range and set panelId.
            if (targetInfo && targetInfo !== true) {
                area.panelId = targetInfo.panelId;
                // (1) area.range should always be calculate from coordRange but does
                // not keep its original value, for the sake of the dataZoom scenario,
                // where area.coordRange remains unchanged but area.range may be changed.
                // (2) Only support converting one coordRange to pixel range in brush
                // component. So do not consider `coordRanges`.
                // (3) About __rangeOffset, see comment above.
                var result = $6213fed8aa63fab1$var$coordConvert[area.brushType](0, targetInfo.coordSys, area.coordRange);
                var rangeOffset = area.__rangeOffset;
                area.range = rangeOffset ? $6213fed8aa63fab1$var$diffProcessor[area.brushType](result.values, rangeOffset.offset, $6213fed8aa63fab1$var$getScales(result.xyMinMax, rangeOffset.xyMinMax)) : result.values;
            }
        }, this);
    };
    BrushTargetManager.prototype.makePanelOpts = function(api, getDefaultBrushType) {
        return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(this._targetInfoList, function(targetInfo) {
            var rect = targetInfo.getPanelRect();
            return {
                panelId: targetInfo.panelId,
                defaultBrushType: getDefaultBrushType ? getDefaultBrushType(targetInfo) : null,
                clipPath: $d9c171f7dfe1f12f$export$fee17964a62a87a7(rect),
                isTargetByCursor: $d9c171f7dfe1f12f$export$e63e66b3b18aa99f(rect, api, targetInfo.coordSysModel),
                getLinearBrushOtherExtent: $d9c171f7dfe1f12f$export$7280070e90fad7a0(rect)
            };
        });
    };
    BrushTargetManager.prototype.controlSeries = function(area, seriesModel, ecModel) {
        // Check whether area is bound in coord, and series do not belong to that coord.
        // If do not do this check, some brush (like lineX) will controll all axes.
        var targetInfo = this.findTargetInfo(area, ecModel);
        return targetInfo === true || targetInfo && (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(targetInfo.coordSyses, seriesModel.coordinateSystem) >= 0;
    };
    /**
   * If return Object, a coord found.
   * If return true, global found.
   * Otherwise nothing found.
   */ BrushTargetManager.prototype.findTargetInfo = function(area, ecModel) {
        var targetInfoList = this._targetInfoList;
        var foundCpts = $6213fed8aa63fab1$var$parseFinder(ecModel, area);
        for(var i = 0; i < targetInfoList.length; i++){
            var targetInfo = targetInfoList[i];
            var areaPanelId = area.panelId;
            if (areaPanelId) {
                if (targetInfo.panelId === areaPanelId) return targetInfo;
            } else for(var j = 0; j < $6213fed8aa63fab1$var$targetInfoMatchers.length; j++){
                if ($6213fed8aa63fab1$var$targetInfoMatchers[j](foundCpts, targetInfo)) return targetInfo;
            }
        }
        return true;
    };
    return BrushTargetManager;
}();
function $6213fed8aa63fab1$var$formatMinMax(minMax) {
    minMax[0] > minMax[1] && minMax.reverse();
    return minMax;
}
function $6213fed8aa63fab1$var$parseFinder(ecModel, finder) {
    return (0, $76d619f648247e6d$export$95de80076abac814)(ecModel, finder, {
        includeMainTypes: $6213fed8aa63fab1$var$INCLUDE_FINDER_MAIN_TYPES
    });
}
var $6213fed8aa63fab1$var$targetInfoBuilders = {
    grid: function(foundCpts, targetInfoList) {
        var xAxisModels = foundCpts.xAxisModels;
        var yAxisModels = foundCpts.yAxisModels;
        var gridModels = foundCpts.gridModels;
        // Remove duplicated.
        var gridModelMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        var xAxesHas = {};
        var yAxesHas = {};
        if (!xAxisModels && !yAxisModels && !gridModels) return;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(xAxisModels, function(axisModel) {
            var gridModel = axisModel.axis.grid.model;
            gridModelMap.set(gridModel.id, gridModel);
            xAxesHas[gridModel.id] = true;
        });
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(yAxisModels, function(axisModel) {
            var gridModel = axisModel.axis.grid.model;
            gridModelMap.set(gridModel.id, gridModel);
            yAxesHas[gridModel.id] = true;
        });
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(gridModels, function(gridModel) {
            gridModelMap.set(gridModel.id, gridModel);
            xAxesHas[gridModel.id] = true;
            yAxesHas[gridModel.id] = true;
        });
        gridModelMap.each(function(gridModel) {
            var grid = gridModel.coordinateSystem;
            var cartesians = [];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(grid.getCartesians(), function(cartesian, index) {
                if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(xAxisModels, cartesian.getAxis("x").model) >= 0 || (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(yAxisModels, cartesian.getAxis("y").model) >= 0) cartesians.push(cartesian);
            });
            targetInfoList.push({
                panelId: "grid--" + gridModel.id,
                gridModel: gridModel,
                coordSysModel: gridModel,
                // Use the first one as the representitive coordSys.
                coordSys: cartesians[0],
                coordSyses: cartesians,
                getPanelRect: $6213fed8aa63fab1$var$panelRectBuilders.grid,
                xAxisDeclared: xAxesHas[gridModel.id],
                yAxisDeclared: yAxesHas[gridModel.id]
            });
        });
    },
    geo: function(foundCpts, targetInfoList) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(foundCpts.geoModels, function(geoModel) {
            var coordSys = geoModel.coordinateSystem;
            targetInfoList.push({
                panelId: "geo--" + geoModel.id,
                geoModel: geoModel,
                coordSysModel: geoModel,
                coordSys: coordSys,
                coordSyses: [
                    coordSys
                ],
                getPanelRect: $6213fed8aa63fab1$var$panelRectBuilders.geo
            });
        });
    }
};
var $6213fed8aa63fab1$var$targetInfoMatchers = [
    // grid
    function(foundCpts, targetInfo) {
        var xAxisModel = foundCpts.xAxisModel;
        var yAxisModel = foundCpts.yAxisModel;
        var gridModel = foundCpts.gridModel;
        !gridModel && xAxisModel && (gridModel = xAxisModel.axis.grid.model);
        !gridModel && yAxisModel && (gridModel = yAxisModel.axis.grid.model);
        return gridModel && gridModel === targetInfo.gridModel;
    },
    // geo
    function(foundCpts, targetInfo) {
        var geoModel = foundCpts.geoModel;
        return geoModel && geoModel === targetInfo.geoModel;
    }
];
var $6213fed8aa63fab1$var$panelRectBuilders = {
    grid: function() {
        // grid is not Transformable.
        return this.coordSys.master.getRect().clone();
    },
    geo: function() {
        var coordSys = this.coordSys;
        var rect = coordSys.getBoundingRect().clone();
        // geo roam and zoom transform
        rect.applyTransform($5b455ae6f843ac47$export$fce0c6cfca85ed96(coordSys));
        return rect;
    }
};
var $6213fed8aa63fab1$var$coordConvert = {
    lineX: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($6213fed8aa63fab1$var$axisConvert, 0),
    lineY: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($6213fed8aa63fab1$var$axisConvert, 1),
    rect: function(to, coordSys, rangeOrCoordRange, clamp) {
        var xminymin = to ? coordSys.pointToData([
            rangeOrCoordRange[0][0],
            rangeOrCoordRange[1][0]
        ], clamp) : coordSys.dataToPoint([
            rangeOrCoordRange[0][0],
            rangeOrCoordRange[1][0]
        ], clamp);
        var xmaxymax = to ? coordSys.pointToData([
            rangeOrCoordRange[0][1],
            rangeOrCoordRange[1][1]
        ], clamp) : coordSys.dataToPoint([
            rangeOrCoordRange[0][1],
            rangeOrCoordRange[1][1]
        ], clamp);
        var values = [
            $6213fed8aa63fab1$var$formatMinMax([
                xminymin[0],
                xmaxymax[0]
            ]),
            $6213fed8aa63fab1$var$formatMinMax([
                xminymin[1],
                xmaxymax[1]
            ])
        ];
        return {
            values: values,
            xyMinMax: values
        };
    },
    polygon: function(to, coordSys, rangeOrCoordRange, clamp) {
        var xyMinMax = [
            [
                Infinity,
                -Infinity
            ],
            [
                Infinity,
                -Infinity
            ]
        ];
        var values = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(rangeOrCoordRange, function(item) {
            var p = to ? coordSys.pointToData(item, clamp) : coordSys.dataToPoint(item, clamp);
            xyMinMax[0][0] = Math.min(xyMinMax[0][0], p[0]);
            xyMinMax[1][0] = Math.min(xyMinMax[1][0], p[1]);
            xyMinMax[0][1] = Math.max(xyMinMax[0][1], p[0]);
            xyMinMax[1][1] = Math.max(xyMinMax[1][1], p[1]);
            return p;
        });
        return {
            values: values,
            xyMinMax: xyMinMax
        };
    }
};
function $6213fed8aa63fab1$var$axisConvert(axisNameIndex, to, coordSys, rangeOrCoordRange) {
    var axis = coordSys.getAxis([
        "x",
        "y"
    ][axisNameIndex]);
    var values = $6213fed8aa63fab1$var$formatMinMax((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)([
        0,
        1
    ], function(i) {
        return to ? axis.coordToData(axis.toLocalCoord(rangeOrCoordRange[i]), true) : axis.toGlobalCoord(axis.dataToCoord(rangeOrCoordRange[i]));
    }));
    var xyMinMax = [];
    xyMinMax[axisNameIndex] = values;
    xyMinMax[1 - axisNameIndex] = [
        NaN,
        NaN
    ];
    return {
        values: values,
        xyMinMax: xyMinMax
    };
}
var $6213fed8aa63fab1$var$diffProcessor = {
    lineX: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($6213fed8aa63fab1$var$axisDiffProcessor, 0),
    lineY: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($6213fed8aa63fab1$var$axisDiffProcessor, 1),
    rect: function(values, refer, scales) {
        return [
            [
                values[0][0] - scales[0] * refer[0][0],
                values[0][1] - scales[0] * refer[0][1]
            ],
            [
                values[1][0] - scales[1] * refer[1][0],
                values[1][1] - scales[1] * refer[1][1]
            ]
        ];
    },
    polygon: function(values, refer, scales) {
        return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(values, function(item, idx) {
            return [
                item[0] - scales[0] * refer[idx][0],
                item[1] - scales[1] * refer[idx][1]
            ];
        });
    }
};
function $6213fed8aa63fab1$var$axisDiffProcessor(axisNameIndex, values, refer, scales) {
    return [
        values[0] - scales[axisNameIndex] * refer[0],
        values[1] - scales[axisNameIndex] * refer[1]
    ];
}
// We have to process scale caused by dataZoom manually,
// although it might be not accurate.
// Return [0~1, 0~1]
function $6213fed8aa63fab1$var$getScales(xyMinMaxCurr, xyMinMaxOrigin) {
    var sizeCurr = $6213fed8aa63fab1$var$getSize(xyMinMaxCurr);
    var sizeOrigin = $6213fed8aa63fab1$var$getSize(xyMinMaxOrigin);
    var scales = [
        sizeCurr[0] / sizeOrigin[0],
        sizeCurr[1] / sizeOrigin[1]
    ];
    isNaN(scales[0]) && (scales[0] = 1);
    isNaN(scales[1]) && (scales[1] = 1);
    return scales;
}
function $6213fed8aa63fab1$var$getSize(xyMinMax) {
    return xyMinMax ? [
        xyMinMax[0][1] - xyMinMax[0][0],
        xyMinMax[1][1] - xyMinMax[1][0]
    ] : [
        NaN,
        NaN
    ];
}
var $6213fed8aa63fab1$export$2e2bcd8739ae039 = $6213fed8aa63fab1$var$BrushTargetManager;


var $8c565e07fd43a6ee$var$STATE_LIST = [
    "inBrush",
    "outOfBrush"
];
var $8c565e07fd43a6ee$var$DISPATCH_METHOD = "__ecBrushSelect";
var $8c565e07fd43a6ee$var$DISPATCH_FLAG = "__ecInBrushSelectEvent";
function $8c565e07fd43a6ee$export$ead1205d8c0d8375(ecModel) {
    ecModel.eachComponent({
        mainType: "brush"
    }, function(brushModel) {
        var brushTargetManager = brushModel.brushTargetManager = new (0, $6213fed8aa63fab1$export$2e2bcd8739ae039)(brushModel.option, ecModel);
        brushTargetManager.setInputRanges(brushModel.areas, ecModel);
    });
}
function $8c565e07fd43a6ee$export$2e2bcd8739ae039(ecModel, api, payload) {
    var brushSelected = [];
    var throttleType;
    var throttleDelay;
    ecModel.eachComponent({
        mainType: "brush"
    }, function(brushModel) {
        payload && payload.type === "takeGlobalCursor" && brushModel.setBrushOption(payload.key === "brush" ? payload.brushOption : {
            brushType: false
        });
    });
    $8c565e07fd43a6ee$export$ead1205d8c0d8375(ecModel);
    ecModel.eachComponent({
        mainType: "brush"
    }, function(brushModel, brushIndex) {
        var thisBrushSelected = {
            brushId: brushModel.id,
            brushIndex: brushIndex,
            brushName: brushModel.name,
            areas: $7a1bd9c2710fea0d$export$9cd59f9826255e47(brushModel.areas),
            selected: []
        };
        // Every brush component exists in event params, convenient
        // for user to find by index.
        brushSelected.push(thisBrushSelected);
        var brushOption = brushModel.option;
        var brushLink = brushOption.brushLink;
        var linkedSeriesMap = [];
        var selectedDataIndexForLink = [];
        var rangeInfoBySeries = [];
        var hasBrushExists = false;
        if (!brushIndex) {
            // Only the first throttle setting works.
            throttleType = brushOption.throttleType;
            throttleDelay = brushOption.throttleDelay;
        }
        // Add boundingRect and selectors to range.
        var areas = $7a1bd9c2710fea0d$export$871de8747c9eaa88(brushModel.areas, function(area) {
            var builder = $8c565e07fd43a6ee$var$boundingRectBuilders[area.brushType];
            var selectableArea = $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                boundingRect: builder ? builder(area) : void 0
            }, area);
            selectableArea.selectors = (0, $431fae42b264171b$export$2225cfa0a999c142)(selectableArea);
            return selectableArea;
        });
        var visualMappings = $87ea23222d1c134e$export$89974527642f24a0(brushModel.option, $8c565e07fd43a6ee$var$STATE_LIST, function(mappingOption) {
            mappingOption.mappingMethod = "fixed";
        });
        $7a1bd9c2710fea0d$export$43bee75e5e14138e(brushLink) && $7a1bd9c2710fea0d$export$79b2f7037acddd43(brushLink, function(seriesIndex) {
            linkedSeriesMap[seriesIndex] = 1;
        });
        function linkOthers(seriesIndex) {
            return brushLink === "all" || !!linkedSeriesMap[seriesIndex];
        }
        // If no supported brush or no brush on the series,
        // all visuals should be in original state.
        function brushed(rangeInfoList) {
            return !!rangeInfoList.length;
        }
        /**
     * Logic for each series: (If the logic has to be modified one day, do it carefully!)
     *
     * ( brushed ┬ && ┬hasBrushExist ┬ && linkOthers  ) => StepA: ┬record, ┬ StepB: ┬visualByRecord.
     *   !brushed┘    ├hasBrushExist ┤                            └nothing,┘        ├visualByRecord.
     *                └!hasBrushExist┘                                              └nothing.
     * ( !brushed  && ┬hasBrushExist ┬ && linkOthers  ) => StepA:  nothing,  StepB: ┬visualByRecord.
     *                └!hasBrushExist┘                                              └nothing.
     * ( brushed ┬ &&                     !linkOthers ) => StepA:  nothing,  StepB: ┬visualByCheck.
     *   !brushed┘                                                                  └nothing.
     * ( !brushed  &&                     !linkOthers ) => StepA:  nothing,  StepB:  nothing.
     */ // Step A
        ecModel.eachSeries(function(seriesModel, seriesIndex) {
            var rangeInfoList = rangeInfoBySeries[seriesIndex] = [];
            seriesModel.subType === "parallel" ? stepAParallel(seriesModel, seriesIndex) : stepAOthers(seriesModel, seriesIndex, rangeInfoList);
        });
        function stepAParallel(seriesModel, seriesIndex) {
            var coordSys = seriesModel.coordinateSystem;
            hasBrushExists = hasBrushExists || coordSys.hasAxisBrushed();
            linkOthers(seriesIndex) && coordSys.eachActiveState(seriesModel.getData(), function(activeState, dataIndex) {
                activeState === "active" && (selectedDataIndexForLink[dataIndex] = 1);
            });
        }
        function stepAOthers(seriesModel, seriesIndex, rangeInfoList) {
            if (!seriesModel.brushSelector || $8c565e07fd43a6ee$var$brushModelNotControll(brushModel, seriesIndex)) return;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(areas, function(area) {
                if (brushModel.brushTargetManager.controlSeries(area, seriesModel, ecModel)) rangeInfoList.push(area);
                hasBrushExists = hasBrushExists || brushed(rangeInfoList);
            });
            if (linkOthers(seriesIndex) && brushed(rangeInfoList)) {
                var data_1 = seriesModel.getData();
                data_1.each(function(dataIndex) {
                    if ($8c565e07fd43a6ee$var$checkInRange(seriesModel, rangeInfoList, data_1, dataIndex)) selectedDataIndexForLink[dataIndex] = 1;
                });
            }
        }
        // Step B
        ecModel.eachSeries(function(seriesModel, seriesIndex) {
            var seriesBrushSelected = {
                seriesId: seriesModel.id,
                seriesIndex: seriesIndex,
                seriesName: seriesModel.name,
                dataIndex: []
            };
            // Every series exists in event params, convenient
            // for user to find series by seriesIndex.
            thisBrushSelected.selected.push(seriesBrushSelected);
            var rangeInfoList = rangeInfoBySeries[seriesIndex];
            var data = seriesModel.getData();
            var getValueState = linkOthers(seriesIndex) ? function(dataIndex) {
                return selectedDataIndexForLink[dataIndex] ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), "inBrush") : "outOfBrush";
            } : function(dataIndex) {
                return $8c565e07fd43a6ee$var$checkInRange(seriesModel, rangeInfoList, data, dataIndex) ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), "inBrush") : "outOfBrush";
            };
            // If no supported brush or no brush, all visuals are in original state.
            (linkOthers(seriesIndex) ? hasBrushExists : brushed(rangeInfoList)) && $87ea23222d1c134e$export$bb1ef43951d58629($8c565e07fd43a6ee$var$STATE_LIST, visualMappings, data, getValueState);
        });
    });
    $8c565e07fd43a6ee$var$dispatchAction(api, throttleType, throttleDelay, brushSelected, payload);
}
function $8c565e07fd43a6ee$var$dispatchAction(api, throttleType, throttleDelay, brushSelected, payload) {
    // This event will not be triggered when `setOpion`, otherwise dead lock may
    // triggered when do `setOption` in event listener, which we do not find
    // satisfactory way to solve yet. Some considered resolutions:
    // (a) Diff with prevoius selected data ant only trigger event when changed.
    // But store previous data and diff precisely (i.e., not only by dataIndex, but
    // also detect value changes in selected data) might bring complexity or fragility.
    // (b) Use spectial param like `silent` to suppress event triggering.
    // But such kind of volatile param may be weird in `setOption`.
    if (!payload) return;
    var zr = api.getZr();
    if (zr[$8c565e07fd43a6ee$var$DISPATCH_FLAG]) return;
    if (!zr[$8c565e07fd43a6ee$var$DISPATCH_METHOD]) zr[$8c565e07fd43a6ee$var$DISPATCH_METHOD] = $8c565e07fd43a6ee$var$doDispatch;
    var fn = $c98659a9437a3d2e$export$958e3e1a02eac4b6(zr, $8c565e07fd43a6ee$var$DISPATCH_METHOD, throttleDelay, throttleType);
    fn(api, brushSelected);
}
function $8c565e07fd43a6ee$var$doDispatch(api, brushSelected) {
    if (!api.isDisposed()) {
        var zr = api.getZr();
        zr[$8c565e07fd43a6ee$var$DISPATCH_FLAG] = true;
        api.dispatchAction({
            type: "brushSelect",
            batch: brushSelected
        });
        zr[$8c565e07fd43a6ee$var$DISPATCH_FLAG] = false;
    }
}
function $8c565e07fd43a6ee$var$checkInRange(seriesModel, rangeInfoList, data, dataIndex) {
    for(var i = 0, len = rangeInfoList.length; i < len; i++){
        var area = rangeInfoList[i];
        if (seriesModel.brushSelector(dataIndex, data, area.selectors, area)) return true;
    }
}
function $8c565e07fd43a6ee$var$brushModelNotControll(brushModel, seriesIndex) {
    var seriesIndices = brushModel.option.seriesIndex;
    return seriesIndices != null && seriesIndices !== "all" && ($7a1bd9c2710fea0d$export$43bee75e5e14138e(seriesIndices) ? $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(seriesIndices, seriesIndex) < 0 : seriesIndex !== seriesIndices);
}
var $8c565e07fd43a6ee$var$boundingRectBuilders = {
    rect: function(area) {
        return $8c565e07fd43a6ee$var$getBoundingRectFromMinMax(area.range);
    },
    polygon: function(area) {
        var minMax;
        var range = area.range;
        for(var i = 0, len = range.length; i < len; i++){
            minMax = minMax || [
                [
                    Infinity,
                    -Infinity
                ],
                [
                    Infinity,
                    -Infinity
                ]
            ];
            var rg = range[i];
            rg[0] < minMax[0][0] && (minMax[0][0] = rg[0]);
            rg[0] > minMax[0][1] && (minMax[0][1] = rg[0]);
            rg[1] < minMax[1][0] && (minMax[1][0] = rg[1]);
            rg[1] > minMax[1][1] && (minMax[1][1] = rg[1]);
        }
        return minMax && $8c565e07fd43a6ee$var$getBoundingRectFromMinMax(minMax);
    }
};
function $8c565e07fd43a6ee$var$getBoundingRectFromMinMax(minMax) {
    return new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(minMax[0][0], minMax[1][0], minMax[0][1] - minMax[0][0], minMax[1][1] - minMax[1][0]);
}



var $b3094615d1ff0264$var$BrushView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BrushView, _super);
    function BrushView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BrushView.type;
        return _this;
    }
    BrushView.prototype.init = function(ecModel, api) {
        this.ecModel = ecModel;
        this.api = api;
        this.model;
        (this._brushController = new (0, $91342d1cfa622c5a$export$2e2bcd8739ae039)(api.getZr())).on("brush", $7a1bd9c2710fea0d$export$2385a24977818dd0(this._onBrush, this)).mount();
    };
    BrushView.prototype.render = function(brushModel, ecModel, api, payload) {
        this.model = brushModel;
        this._updateController(brushModel, ecModel, api, payload);
    };
    BrushView.prototype.updateTransform = function(brushModel, ecModel, api, payload) {
        // PENDING: `updateTransform` is a little tricky, whose layout need
        // to be calculate mandatorily and other stages will not be performed.
        // Take care the correctness of the logic. See #11754 .
        (0, $8c565e07fd43a6ee$export$ead1205d8c0d8375)(ecModel);
        this._updateController(brushModel, ecModel, api, payload);
    };
    BrushView.prototype.updateVisual = function(brushModel, ecModel, api, payload) {
        this.updateTransform(brushModel, ecModel, api, payload);
    };
    BrushView.prototype.updateView = function(brushModel, ecModel, api, payload) {
        this._updateController(brushModel, ecModel, api, payload);
    };
    BrushView.prototype._updateController = function(brushModel, ecModel, api, payload) {
        // Do not update controller when drawing.
        (!payload || payload.$from !== brushModel.id) && this._brushController.setPanels(brushModel.brushTargetManager.makePanelOpts(api)).enableBrush(brushModel.brushOption).updateCovers(brushModel.areas.slice());
    };
    // updateLayout: updateController,
    // updateVisual: updateController,
    BrushView.prototype.dispose = function() {
        this._brushController.dispose();
    };
    BrushView.prototype._onBrush = function(eventParam) {
        var modelId = this.model.id;
        var areas = this.model.brushTargetManager.setOutputRanges(eventParam.areas, this.ecModel);
        // Action is not dispatched on drag end, because the drag end
        // emits the same params with the last drag move event, and
        // may have some delay when using touch pad, which makes
        // animation not smooth (when using debounce).
        (!eventParam.isEnd || eventParam.removeOnClick) && this.api.dispatchAction({
            type: "brush",
            brushId: modelId,
            areas: $7a1bd9c2710fea0d$export$9cd59f9826255e47(areas),
            $from: modelId
        });
        eventParam.isEnd && this.api.dispatchAction({
            type: "brushEnd",
            brushId: modelId,
            areas: $7a1bd9c2710fea0d$export$9cd59f9826255e47(areas),
            $from: modelId
        });
    };
    BrushView.type = "brush";
    return BrushView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $b3094615d1ff0264$export$2e2bcd8739ae039 = $b3094615d1ff0264$var$BrushView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $c309289727ee7770$var$BrushModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BrushModel, _super);
    function BrushModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BrushModel.type;
        /**
     * @readOnly
     */ _this.areas = [];
        /**
     * Current brush painting area settings.
     * @readOnly
     */ _this.brushOption = {};
        return _this;
    }
    BrushModel.prototype.optionUpdated = function(newOption, isInit) {
        var thisOption = this.option;
        !isInit && $87ea23222d1c134e$export$797d20c0a6de578f(thisOption, newOption, [
            "inBrush",
            "outOfBrush"
        ]);
        var inBrush = thisOption.inBrush = thisOption.inBrush || {};
        // Always give default visual, consider setOption at the second time.
        thisOption.outOfBrush = thisOption.outOfBrush || {
            color: this.option.defaultOutOfBrushColor
        };
        if (!inBrush.hasOwnProperty("liftZ")) // Bigger than the highlight z lift, otherwise it will
        // be effected by the highlight z when brush.
        inBrush.liftZ = 5;
    };
    /**
   * If `areas` is null/undefined, range state remain.
   */ BrushModel.prototype.setAreas = function(areas) {
        // If areas is null/undefined, range state remain.
        // This helps user to dispatchAction({type: 'brush'}) with no areas
        // set but just want to get the current brush select info from a `brush` event.
        if (!areas) return;
        this.areas = $7a1bd9c2710fea0d$export$871de8747c9eaa88(areas, function(area) {
            return $c309289727ee7770$var$generateBrushOption(this.option, area);
        }, this);
    };
    /**
   * Set the current painting brush option.
   */ BrushModel.prototype.setBrushOption = function(brushOption) {
        this.brushOption = $c309289727ee7770$var$generateBrushOption(this.option, brushOption);
        this.brushType = this.brushOption.brushType;
    };
    BrushModel.type = "brush";
    BrushModel.dependencies = [
        "geo",
        "grid",
        "xAxis",
        "yAxis",
        "parallel",
        "series"
    ];
    BrushModel.defaultOption = {
        seriesIndex: "all",
        brushType: "rect",
        brushMode: "single",
        transformable: true,
        brushStyle: {
            borderWidth: 1,
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.backgroundTint,
            borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.borderTint
        },
        throttleType: "fixRate",
        throttleDelay: 0,
        removeOnClick: true,
        z: 10000,
        defaultOutOfBrushColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.disabled
    };
    return BrushModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
function $c309289727ee7770$var$generateBrushOption(option, brushOption) {
    return $7a1bd9c2710fea0d$export$4950aa0f605343fb({
        brushType: option.brushType,
        brushMode: option.brushMode,
        transformable: option.transformable,
        brushStyle: new (0, $6818646a97528290$export$2e2bcd8739ae039)(option.brushStyle).getItemStyle(),
        removeOnClick: option.removeOnClick,
        z: option.z
    }, brushOption, true);
}
var $c309289727ee7770$export$2e2bcd8739ae039 = $c309289727ee7770$var$BrushModel;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ var $974ee7656e10f2d0$export$1426bfb1b0bcf539 = /** @class */ function() {
    function ToolboxFeature() {}
    return ToolboxFeature;
}();
var $974ee7656e10f2d0$var$features = {};
function $974ee7656e10f2d0$export$c6213a6f247cf906(name, ctor) {
    $974ee7656e10f2d0$var$features[name] = ctor;
}
function $974ee7656e10f2d0$export$bba2e7bbd72e62e1(name) {
    return $974ee7656e10f2d0$var$features[name];
}


var $0ea8e48a326f7b6d$var$ICON_TYPES = [
    "rect",
    "polygon",
    "lineX",
    "lineY",
    "keep",
    "clear"
];
var $0ea8e48a326f7b6d$var$BrushFeature = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BrushFeature, _super);
    function BrushFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BrushFeature.prototype.render = function(featureModel, ecModel, api) {
        var brushType;
        var brushMode;
        var isBrushed;
        ecModel.eachComponent({
            mainType: "brush"
        }, function(brushModel) {
            brushType = brushModel.brushType;
            brushMode = brushModel.brushOption.brushMode || "single";
            isBrushed = isBrushed || !!brushModel.areas.length;
        });
        this._brushType = brushType;
        this._brushMode = brushMode;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(featureModel.get("type", true), function(type) {
            featureModel.setIconStatus(type, (type === "keep" ? brushMode === "multiple" : type === "clear" ? isBrushed : type === brushType) ? "emphasis" : "normal");
        });
    };
    BrushFeature.prototype.updateView = function(featureModel, ecModel, api) {
        this.render(featureModel, ecModel, api);
    };
    BrushFeature.prototype.getIcons = function() {
        var model = this.model;
        var availableIcons = model.get("icon", true);
        var icons = {};
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(model.get("type", true), function(type) {
            if (availableIcons[type]) icons[type] = availableIcons[type];
        });
        return icons;
    };
    BrushFeature.prototype.onclick = function(ecModel, api, type) {
        var brushType = this._brushType;
        var brushMode = this._brushMode;
        if (type === "clear") {
            // Trigger parallel action firstly
            api.dispatchAction({
                type: "axisAreaSelect",
                intervals: []
            });
            api.dispatchAction({
                type: "brush",
                command: "clear",
                // Clear all areas of all brush components.
                areas: []
            });
        } else api.dispatchAction({
            type: "takeGlobalCursor",
            key: "brush",
            brushOption: {
                brushType: type === "keep" ? brushType : brushType === type ? false : type,
                brushMode: type === "keep" ? brushMode === "multiple" ? "single" : "multiple" : brushMode
            }
        });
    };
    BrushFeature.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            type: $0ea8e48a326f7b6d$var$ICON_TYPES.slice(),
            icon: {
                /* eslint-disable */ rect: "M7.3,34.7 M0.4,10V-0.2h9.8 M89.6,10V-0.2h-9.8 M0.4,60v10.2h9.8 M89.6,60v10.2h-9.8 M12.3,22.4V10.5h13.1 M33.6,10.5h7.8 M49.1,10.5h7.8 M77.5,22.4V10.5h-13 M12.3,31.1v8.2 M77.7,31.1v8.2 M12.3,47.6v11.9h13.1 M33.6,59.5h7.6 M49.1,59.5 h7.7 M77.5,47.6v11.9h-13",
                polygon: "M55.2,34.9c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1S53.5,34.9,55.2,34.9z M50.4,51c1.7,0,3.1,1.4,3.1,3.1c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1 C47.3,52.4,48.7,51,50.4,51z M55.6,37.1l1.5-7.8 M60.1,13.5l1.6-8.7l-7.8,4 M59,19l-1,5.3 M24,16.1l6.4,4.9l6.4-3.3 M48.5,11.6 l-5.9,3.1 M19.1,12.8L9.7,5.1l1.1,7.7 M13.4,29.8l1,7.3l6.6,1.6 M11.6,18.4l1,6.1 M32.8,41.9 M26.6,40.4 M27.3,40.2l6.1,1.6 M49.9,52.1l-5.6-7.6l-4.9-1.2",
                lineX: "M15.2,30 M19.7,15.6V1.9H29 M34.8,1.9H40.4 M55.3,15.6V1.9H45.9 M19.7,44.4V58.1H29 M34.8,58.1H40.4 M55.3,44.4 V58.1H45.9 M12.5,20.3l-9.4,9.6l9.6,9.8 M3.1,29.9h16.5 M62.5,20.3l9.4,9.6L62.3,39.7 M71.9,29.9H55.4",
                lineY: "M38.8,7.7 M52.7,12h13.2v9 M65.9,26.6V32 M52.7,46.3h13.2v-9 M24.9,12H11.8v9 M11.8,26.6V32 M24.9,46.3H11.8v-9 M48.2,5.1l-9.3-9l-9.4,9.2 M38.9-3.9V12 M48.2,53.3l-9.3,9l-9.4-9.2 M38.9,62.3V46.4",
                keep: "M4,10.5V1h10.3 M20.7,1h6.1 M33,1h6.1 M55.4,10.5V1H45.2 M4,17.3v6.6 M55.6,17.3v6.6 M4,30.5V40h10.3 M20.7,40 h6.1 M33,40h6.1 M55.4,30.5V40H45.2 M21,18.9h62.9v48.6H21V18.9z",
                clear: "M22,14.7l30.9,31 M52.9,14.7L22,45.7 M4.7,16.8V4.2h13.1 M26,4.2h7.8 M41.6,4.2h7.8 M70.3,16.8V4.2H57.2 M4.7,25.9v8.6 M70.3,25.9v8.6 M4.7,43.2v12.6h13.1 M26,55.8h7.8 M41.6,55.8h7.8 M70.3,43.2v12.6H57.2" // jshint ignore:line
            },
            // `rect`, `polygon`, `lineX`, `lineY`, `keep`, `clear`
            title: ecModel.getLocaleModel().get([
                "toolbox",
                "brush",
                "title"
            ])
        };
        return defaultOption;
    };
    return BrushFeature;
}((0, $974ee7656e10f2d0$export$1426bfb1b0bcf539));
var $0ea8e48a326f7b6d$export$2e2bcd8739ae039 = $0ea8e48a326f7b6d$var$BrushFeature;




function $e97a928e0b93a54f$export$4b3e715f166fdd78(registers) {
    registers.registerComponentView((0, $b3094615d1ff0264$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $c309289727ee7770$export$2e2bcd8739ae039));
    registers.registerPreprocessor((0, $860dd9ca08385e85$export$2e2bcd8739ae039));
    registers.registerVisual(registers.PRIORITY.VISUAL.BRUSH, (0, $8c565e07fd43a6ee$export$2e2bcd8739ae039));
    registers.registerAction({
        type: "brush",
        event: "brush",
        update: "updateVisual"
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "brush",
            query: payload
        }, function(brushModel) {
            brushModel.setAreas(payload.areas);
        });
    });
    /**
   * payload: {
   *      brushComponents: [
   *          {
   *              brushId,
   *              brushIndex,
   *              brushName,
   *              series: [
   *                  {
   *                      seriesId,
   *                      seriesIndex,
   *                      seriesName,
   *                      rawIndices: [21, 34, ...]
   *                  },
   *                  ...
   *              ]
   *          },
   *          ...
   *      ]
   * }
   */ registers.registerAction({
        type: "brushSelect",
        event: "brushSelected",
        update: "none"
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
    registers.registerAction({
        type: "brushEnd",
        event: "brushEnd",
        update: "none"
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
    (0, $974ee7656e10f2d0$export$c6213a6f247cf906)("brush", (0, $0ea8e48a326f7b6d$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $795d2d92b1d02c70$var$CalendarModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CalendarModel, _super);
    function CalendarModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CalendarModel.type;
        return _this;
    }
    /**
   * @override
   */ CalendarModel.prototype.init = function(option, parentModel, ecModel) {
        var inputPositionParams = (0, $93b9bc7f22ac7369$export$4b0d20af19c9875e)(option);
        _super.prototype.init.apply(this, arguments);
        $795d2d92b1d02c70$var$mergeAndNormalizeLayoutParams(option, inputPositionParams);
    };
    /**
   * @override
   */ CalendarModel.prototype.mergeOption = function(option) {
        _super.prototype.mergeOption.apply(this, arguments);
        $795d2d92b1d02c70$var$mergeAndNormalizeLayoutParams(this.option, option);
    };
    CalendarModel.prototype.getCellSize = function() {
        // Has been normalized
        return this.option.cellSize;
    };
    CalendarModel.type = "calendar";
    CalendarModel.layoutMode = "box";
    CalendarModel.defaultOption = {
        // zlevel: 0,
        // TODO: theoretically, the z of the calendar should be lower
        // than series, but we don't want the series to be displayed
        // on top of the borders like month split line. To align with
        // the effect of previous versions, we set the z to 2 for now
        // until better solution is found.
        z: 2,
        left: 80,
        top: 60,
        cellSize: 20,
        // horizontal vertical
        orient: "horizontal",
        // month separate line style
        splitLine: {
            show: true,
            lineStyle: {
                color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.axisLine,
                width: 1,
                type: "solid"
            }
        },
        // rect style  temporarily unused emphasis
        itemStyle: {
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral00,
            borderWidth: 1,
            borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral10
        },
        // week text style
        dayLabel: {
            show: true,
            firstDay: 0,
            // start end
            position: "start",
            margin: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).size.s,
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.secondary
        },
        // month text style
        monthLabel: {
            show: true,
            // start end
            position: "start",
            margin: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).size.s,
            // center or left
            align: "center",
            formatter: null,
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.secondary
        },
        // year text style
        yearLabel: {
            show: true,
            // top bottom left right
            position: null,
            margin: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).size.xl,
            formatter: null,
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.quaternary,
            fontFamily: "sans-serif",
            fontWeight: "bolder",
            fontSize: 20
        }
    };
    return CalendarModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
function $795d2d92b1d02c70$var$mergeAndNormalizeLayoutParams(target, raw) {
    // Normalize cellSize
    var cellSize = target.cellSize;
    var cellSizeArr;
    if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(cellSize)) cellSizeArr = target.cellSize = [
        cellSize,
        cellSize
    ];
    else cellSizeArr = cellSize;
    if (cellSizeArr.length === 1) cellSizeArr[1] = cellSizeArr[0];
    var ignoreSize = $7a1bd9c2710fea0d$export$871de8747c9eaa88([
        0,
        1
    ], function(hvIdx) {
        // If user have set `width` or both `left` and `right`, cellSizeArr
        // will be automatically set to 'auto', otherwise the default
        // setting of cellSizeArr will make `width` setting not work.
        if ((0, $93b9bc7f22ac7369$export$7ede609e8ebc9650)(raw, hvIdx)) cellSizeArr[hvIdx] = "auto";
        return cellSizeArr[hvIdx] != null && cellSizeArr[hvIdx] !== "auto";
    });
    (0, $93b9bc7f22ac7369$export$1754cb91f16ca028)(target, raw, {
        type: "box",
        ignoreSize: ignoreSize
    });
}
var $795d2d92b1d02c70$export$2e2bcd8739ae039 = $795d2d92b1d02c70$var$CalendarModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $e6b2dc17a91ad4af$var$CalendarView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CalendarView, _super);
    function CalendarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CalendarView.type;
        return _this;
    }
    CalendarView.prototype.render = function(calendarModel, ecModel, api) {
        var group = this.group;
        group.removeAll();
        var coordSys = calendarModel.coordinateSystem;
        // range info
        var rangeData = coordSys.getRangeInfo();
        var orient = coordSys.getOrient();
        // locale
        var localeModel = ecModel.getLocaleModel();
        this._renderDayRect(calendarModel, rangeData, group);
        // _renderLines must be called prior to following function
        this._renderLines(calendarModel, rangeData, orient, group);
        this._renderYearText(calendarModel, rangeData, orient, group);
        this._renderMonthText(calendarModel, localeModel, orient, group);
        this._renderWeekText(calendarModel, localeModel, rangeData, orient, group);
    };
    // render day rect
    CalendarView.prototype._renderDayRect = function(calendarModel, rangeData, group) {
        var coordSys = calendarModel.coordinateSystem;
        var itemRectStyleModel = calendarModel.getModel("itemStyle").getItemStyle();
        var sw = coordSys.getCellWidth();
        var sh = coordSys.getCellHeight();
        for(var i = rangeData.start.time; i <= rangeData.end.time; i = coordSys.getNextNDay(i, 1).time){
            var point = coordSys.dataToCalendarLayout([
                i
            ], false).tl;
            // every rect
            var rect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
                shape: {
                    x: point[0],
                    y: point[1],
                    width: sw,
                    height: sh
                },
                cursor: "default",
                style: itemRectStyleModel
            });
            group.add(rect);
        }
    };
    // render separate line
    CalendarView.prototype._renderLines = function(calendarModel, rangeData, orient, group) {
        var self = this;
        var coordSys = calendarModel.coordinateSystem;
        var lineStyleModel = calendarModel.getModel([
            "splitLine",
            "lineStyle"
        ]).getLineStyle();
        var show = calendarModel.get([
            "splitLine",
            "show"
        ]);
        var lineWidth = lineStyleModel.lineWidth;
        this._tlpoints = [];
        this._blpoints = [];
        this._firstDayOfMonth = [];
        this._firstDayPoints = [];
        var firstDay = rangeData.start;
        for(var i = 0; firstDay.time <= rangeData.end.time; i++){
            addPoints(firstDay.formatedDate);
            if (i === 0) firstDay = coordSys.getDateInfo(rangeData.start.y + "-" + rangeData.start.m);
            var date = firstDay.date;
            date.setMonth(date.getMonth() + 1);
            firstDay = coordSys.getDateInfo(date);
        }
        addPoints(coordSys.getNextNDay(rangeData.end.time, 1).formatedDate);
        function addPoints(date) {
            self._firstDayOfMonth.push(coordSys.getDateInfo(date));
            self._firstDayPoints.push(coordSys.dataToCalendarLayout([
                date
            ], false).tl);
            var points = self._getLinePointsOfOneWeek(calendarModel, date, orient);
            self._tlpoints.push(points[0]);
            self._blpoints.push(points[points.length - 1]);
            show && self._drawSplitline(points, lineStyleModel, group);
        }
        // render top/left line
        show && this._drawSplitline(self._getEdgesPoints(self._tlpoints, lineWidth, orient), lineStyleModel, group);
        // render bottom/right line
        show && this._drawSplitline(self._getEdgesPoints(self._blpoints, lineWidth, orient), lineStyleModel, group);
    };
    // get points at both ends
    CalendarView.prototype._getEdgesPoints = function(points, lineWidth, orient) {
        var rs = [
            points[0].slice(),
            points[points.length - 1].slice()
        ];
        var idx = orient === "horizontal" ? 0 : 1;
        // both ends of the line are extend half lineWidth
        rs[0][idx] = rs[0][idx] - lineWidth / 2;
        rs[1][idx] = rs[1][idx] + lineWidth / 2;
        return rs;
    };
    // render split line
    CalendarView.prototype._drawSplitline = function(points, lineStyle, group) {
        var poyline = new $d28119f30e6bb670$export$2e2bcd8739ae039({
            z2: 20,
            shape: {
                points: points
            },
            style: lineStyle
        });
        group.add(poyline);
    };
    // render month line of one week points
    CalendarView.prototype._getLinePointsOfOneWeek = function(calendarModel, date, orient) {
        var coordSys = calendarModel.coordinateSystem;
        var parsedDate = coordSys.getDateInfo(date);
        var points = [];
        for(var i = 0; i < 7; i++){
            var tmpD = coordSys.getNextNDay(parsedDate.time, i);
            var point = coordSys.dataToCalendarLayout([
                tmpD.time
            ], false);
            points[2 * tmpD.day] = point.tl;
            points[2 * tmpD.day + 1] = point[orient === "horizontal" ? "bl" : "tr"];
        }
        return points;
    };
    CalendarView.prototype._formatterLabel = function(formatter, params) {
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(formatter) && formatter) return (0, $c84c9521536c601a$export$2fa08233ee42f8e1)(formatter, params);
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(formatter)) return formatter(params);
        return params.nameMap;
    };
    CalendarView.prototype._yearTextPositionControl = function(textEl, point, orient, position, margin) {
        var x = point[0];
        var y = point[1];
        var aligns = [
            "center",
            "bottom"
        ];
        if (position === "bottom") {
            y += margin;
            aligns = [
                "center",
                "top"
            ];
        } else if (position === "left") x -= margin;
        else if (position === "right") {
            x += margin;
            aligns = [
                "center",
                "top"
            ];
        } else // top
        y -= margin;
        var rotate = 0;
        if (position === "left" || position === "right") rotate = Math.PI / 2;
        return {
            rotation: rotate,
            x: x,
            y: y,
            style: {
                align: aligns[0],
                verticalAlign: aligns[1]
            }
        };
    };
    // render year
    CalendarView.prototype._renderYearText = function(calendarModel, rangeData, orient, group) {
        var yearLabel = calendarModel.getModel("yearLabel");
        if (!yearLabel.get("show")) return;
        var margin = yearLabel.get("margin");
        var pos = yearLabel.get("position");
        if (!pos) pos = orient !== "horizontal" ? "top" : "left";
        var points = [
            this._tlpoints[this._tlpoints.length - 1],
            this._blpoints[0]
        ];
        var xc = (points[0][0] + points[1][0]) / 2;
        var yc = (points[0][1] + points[1][1]) / 2;
        var idx = orient === "horizontal" ? 0 : 1;
        var posPoints = {
            top: [
                xc,
                points[idx][1]
            ],
            bottom: [
                xc,
                points[1 - idx][1]
            ],
            left: [
                points[1 - idx][0],
                yc
            ],
            right: [
                points[idx][0],
                yc
            ]
        };
        var name = rangeData.start.y;
        if (+rangeData.end.y > +rangeData.start.y) name = name + "-" + rangeData.end.y;
        var formatter = yearLabel.get("formatter");
        var params = {
            start: rangeData.start.y,
            end: rangeData.end.y,
            nameMap: name
        };
        var content = this._formatterLabel(formatter, params);
        var yearText = new $fe885cc21795562b$export$2e2bcd8739ae039({
            z2: 30,
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(yearLabel, {
                text: content
            }),
            silent: yearLabel.get("silent")
        });
        yearText.attr(this._yearTextPositionControl(yearText, posPoints[pos], orient, pos, margin));
        group.add(yearText);
    };
    CalendarView.prototype._monthTextPositionControl = function(point, isCenter, orient, position, margin) {
        var align = "left";
        var vAlign = "top";
        var x = point[0];
        var y = point[1];
        if (orient === "horizontal") {
            y = y + margin;
            if (isCenter) align = "center";
            if (position === "start") vAlign = "bottom";
        } else {
            x = x + margin;
            if (isCenter) vAlign = "middle";
            if (position === "start") align = "right";
        }
        return {
            x: x,
            y: y,
            align: align,
            verticalAlign: vAlign
        };
    };
    // render month and year text
    CalendarView.prototype._renderMonthText = function(calendarModel, localeModel, orient, group) {
        var monthLabel = calendarModel.getModel("monthLabel");
        if (!monthLabel.get("show")) return;
        var nameMap = monthLabel.get("nameMap");
        var margin = monthLabel.get("margin");
        var pos = monthLabel.get("position");
        var align = monthLabel.get("align");
        var termPoints = [
            this._tlpoints,
            this._blpoints
        ];
        if (!nameMap || (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(nameMap)) {
            if (nameMap) // case-sensitive
            localeModel = (0, $9b0a1ef4bcc91e7d$export$37cc638e0e11865f)(nameMap) || localeModel;
            // PENDING
            // for ZH locale, original form is `一月` but current form is `1月`
            nameMap = localeModel.get([
                "time",
                "monthAbbr"
            ]) || [];
        }
        var idx = pos === "start" ? 0 : 1;
        var axis = orient === "horizontal" ? 0 : 1;
        margin = pos === "start" ? -margin : margin;
        var isCenter = align === "center";
        var labelSilent = monthLabel.get("silent");
        for(var i = 0; i < termPoints[idx].length - 1; i++){
            var tmp = termPoints[idx][i].slice();
            var firstDay = this._firstDayOfMonth[i];
            if (isCenter) {
                var firstDayPoints = this._firstDayPoints[i];
                tmp[axis] = (firstDayPoints[axis] + termPoints[0][i + 1][axis]) / 2;
            }
            var formatter = monthLabel.get("formatter");
            var name_1 = nameMap[+firstDay.m - 1];
            var params = {
                yyyy: firstDay.y,
                yy: (firstDay.y + "").slice(2),
                MM: firstDay.m,
                M: +firstDay.m,
                nameMap: name_1
            };
            var content = this._formatterLabel(formatter, params);
            var monthText = new $fe885cc21795562b$export$2e2bcd8739ae039({
                z2: 30,
                style: (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(monthLabel, {
                    text: content
                }), this._monthTextPositionControl(tmp, isCenter, orient, pos, margin)),
                silent: labelSilent
            });
            group.add(monthText);
        }
    };
    CalendarView.prototype._weekTextPositionControl = function(point, orient, position, margin, cellSize) {
        var align = "center";
        var vAlign = "middle";
        var x = point[0];
        var y = point[1];
        var isStart = position === "start";
        if (orient === "horizontal") {
            x = x + margin + (isStart ? 1 : -1) * cellSize[0] / 2;
            align = isStart ? "right" : "left";
        } else {
            y = y + margin + (isStart ? 1 : -1) * cellSize[1] / 2;
            vAlign = isStart ? "bottom" : "top";
        }
        return {
            x: x,
            y: y,
            align: align,
            verticalAlign: vAlign
        };
    };
    // render weeks
    CalendarView.prototype._renderWeekText = function(calendarModel, localeModel, rangeData, orient, group) {
        var dayLabel = calendarModel.getModel("dayLabel");
        if (!dayLabel.get("show")) return;
        var coordSys = calendarModel.coordinateSystem;
        var pos = dayLabel.get("position");
        var nameMap = dayLabel.get("nameMap");
        var margin = dayLabel.get("margin");
        var firstDayOfWeek = coordSys.getFirstDayOfWeek();
        if (!nameMap || (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(nameMap)) {
            if (nameMap) // case-sensitive
            localeModel = (0, $9b0a1ef4bcc91e7d$export$37cc638e0e11865f)(nameMap) || localeModel;
            // Use the first letter of `dayOfWeekAbbr` if `dayOfWeekShort` doesn't exist in the locale file
            var dayOfWeekShort = localeModel.get([
                "time",
                "dayOfWeekShort"
            ]);
            nameMap = dayOfWeekShort || (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(localeModel.get([
                "time",
                "dayOfWeekAbbr"
            ]), function(val) {
                return val[0];
            });
        }
        var start = coordSys.getNextNDay(rangeData.end.time, 7 - rangeData.lweek).time;
        var cellSize = [
            coordSys.getCellWidth(),
            coordSys.getCellHeight()
        ];
        margin = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(margin, Math.min(cellSize[1], cellSize[0]));
        if (pos === "start") {
            start = coordSys.getNextNDay(rangeData.start.time, -(7 + rangeData.fweek)).time;
            margin = -margin;
        }
        var labelSilent = dayLabel.get("silent");
        for(var i = 0; i < 7; i++){
            var tmpD = coordSys.getNextNDay(start, i);
            var point = coordSys.dataToCalendarLayout([
                tmpD.time
            ], false).center;
            var day = i;
            day = Math.abs((i + firstDayOfWeek) % 7);
            var weekText = new $fe885cc21795562b$export$2e2bcd8739ae039({
                z2: 30,
                style: (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(dayLabel, {
                    text: nameMap[day]
                }), this._weekTextPositionControl(point, orient, pos, margin, cellSize)),
                silent: labelSilent
            });
            group.add(weekText);
        }
    };
    CalendarView.type = "calendar";
    return CalendarView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $e6b2dc17a91ad4af$export$2e2bcd8739ae039 = $e6b2dc17a91ad4af$var$CalendarView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





// (24*60*60*1000)
var $be2279b8e0028cb2$var$PROXIMATE_ONE_DAY = 86400000;
var $be2279b8e0028cb2$var$Calendar = /** @class */ function() {
    function Calendar(calendarModel, ecModel, api) {
        this.type = "calendar";
        this.dimensions = Calendar.dimensions;
        // Required in createListFromData
        this.getDimensionsInfo = Calendar.getDimensionsInfo;
        this._model = calendarModel;
        this._update(ecModel, api);
    }
    Calendar.getDimensionsInfo = function() {
        return [
            {
                name: "time",
                type: "time"
            },
            "value"
        ];
    };
    Calendar.prototype.getRangeInfo = function() {
        return this._rangeInfo;
    };
    Calendar.prototype.getModel = function() {
        return this._model;
    };
    Calendar.prototype.getRect = function() {
        return this._rect;
    };
    Calendar.prototype.getCellWidth = function() {
        return this._sw;
    };
    Calendar.prototype.getCellHeight = function() {
        return this._sh;
    };
    Calendar.prototype.getOrient = function() {
        return this._orient;
    };
    /**
   * getFirstDayOfWeek
   *
   * @example
   *     0 : start at Sunday
   *     1 : start at Monday
   *
   * @return {number}
   */ Calendar.prototype.getFirstDayOfWeek = function() {
        return this._firstDayOfWeek;
    };
    /**
   * get date info
   * }
   */ Calendar.prototype.getDateInfo = function(date) {
        date = $cfc1f3b422a3185f$export$6b862160d295c8e(date);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        var mStr = m < 10 ? "0" + m : "" + m;
        var d = date.getDate();
        var dStr = d < 10 ? "0" + d : "" + d;
        var day = date.getDay();
        day = Math.abs((day + 7 - this.getFirstDayOfWeek()) % 7);
        return {
            y: y + "",
            m: mStr,
            d: dStr,
            day: day,
            time: date.getTime(),
            formatedDate: y + "-" + mStr + "-" + dStr,
            date: date
        };
    };
    Calendar.prototype.getNextNDay = function(date, n) {
        n = n || 0;
        if (n === 0) return this.getDateInfo(date);
        date = new Date(this.getDateInfo(date).time);
        date.setDate(date.getDate() + n);
        return this.getDateInfo(date);
    };
    Calendar.prototype._update = function(ecModel, api) {
        this._firstDayOfWeek = +this._model.getModel("dayLabel").get("firstDay");
        this._orient = this._model.get("orient");
        this._lineWidth = this._model.getModel("itemStyle").getItemStyle().lineWidth || 0;
        this._rangeInfo = this._getRangeInfo(this._initRangeOption());
        var weeks = this._rangeInfo.weeks || 1;
        var whNames = [
            "width",
            "height"
        ];
        var cellSize = this._model.getCellSize().slice();
        var layoutParams = this._model.getBoxLayoutParams();
        var cellNumbers = this._orient === "horizontal" ? [
            weeks,
            7
        ] : [
            7,
            weeks
        ];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43([
            0,
            1
        ], function(idx) {
            if (cellSizeSpecified(cellSize, idx)) layoutParams[whNames[idx]] = cellSize[idx] * cellNumbers[idx];
        });
        var whGlobal = {
            width: api.getWidth(),
            height: api.getHeight()
        };
        var calendarRect = this._rect = $93b9bc7f22ac7369$export$4517a5ca639a7293(layoutParams, whGlobal);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43([
            0,
            1
        ], function(idx) {
            if (!cellSizeSpecified(cellSize, idx)) cellSize[idx] = calendarRect[whNames[idx]] / cellNumbers[idx];
        });
        function cellSizeSpecified(cellSize, idx) {
            return cellSize[idx] != null && cellSize[idx] !== "auto";
        }
        // Has been calculated out number.
        this._sw = cellSize[0];
        this._sh = cellSize[1];
    };
    /**
   * Convert a time data(time, value) item to (x, y) point.
   */ // TODO Clamp of calendar is not same with cartesian coordinate systems.
    // It will return NaN if data exceeds.
    Calendar.prototype.dataToPoint = function(data, clamp, out) {
        out = out || [];
        $7a1bd9c2710fea0d$export$43bee75e5e14138e(data) && (data = data[0]);
        clamp == null && (clamp = true);
        var dayInfo = this.getDateInfo(data);
        var range = this._rangeInfo;
        var date = dayInfo.formatedDate;
        // if not in range return [NaN, NaN]
        if (clamp && !(dayInfo.time >= range.start.time && dayInfo.time < range.end.time + $be2279b8e0028cb2$var$PROXIMATE_ONE_DAY)) {
            out[0] = out[1] = NaN;
            return out;
        }
        var week = dayInfo.day;
        var nthWeek = this._getRangeInfo([
            range.start.time,
            date
        ]).nthWeek;
        if (this._orient === "vertical") {
            out[0] = this._rect.x + week * this._sw + this._sw / 2;
            out[1] = this._rect.y + nthWeek * this._sh + this._sh / 2;
        } else {
            out[0] = this._rect.x + nthWeek * this._sw + this._sw / 2;
            out[1] = this._rect.y + week * this._sh + this._sh / 2;
        }
        return out;
    };
    /**
   * Convert a (x, y) point to time data
   */ Calendar.prototype.pointToData = function(point) {
        var date = this.pointToDate(point);
        return date && date.time;
    };
    Calendar.prototype.dataToLayout = function(data, clamp, out) {
        out = out || {};
        var rect = out.rect = out.rect || {};
        var contentRect = out.contentRect = out.contentRect || {};
        var point = this.dataToPoint(data, clamp);
        rect.x = point[0] - this._sw / 2;
        rect.y = point[1] - this._sh / 2;
        rect.width = this._sw;
        rect.height = this._sh;
        (0, $1bebe7106c895823$export$2e2bcd8739ae039).copy(contentRect, rect);
        (0, $5b455ae6f843ac47$export$81ed941fdeb91c7c)(contentRect, this._lineWidth / 2, true, true);
        return out;
    };
    /**
   * Convert a time date item to (x, y) four point.
   */ Calendar.prototype.dataToCalendarLayout = function(data, clamp) {
        var point = this.dataToPoint(data, clamp);
        return {
            center: point,
            tl: [
                point[0] - this._sw / 2,
                point[1] - this._sh / 2
            ],
            tr: [
                point[0] + this._sw / 2,
                point[1] - this._sh / 2
            ],
            br: [
                point[0] + this._sw / 2,
                point[1] + this._sh / 2
            ],
            bl: [
                point[0] - this._sw / 2,
                point[1] + this._sh / 2
            ]
        };
    };
    /**
   * Convert a (x, y) point to time date
   *
   * @param  {Array} point point
   * @return {Object}       date
   */ Calendar.prototype.pointToDate = function(point) {
        var nthX = Math.floor((point[0] - this._rect.x) / this._sw) + 1;
        var nthY = Math.floor((point[1] - this._rect.y) / this._sh) + 1;
        var range = this._rangeInfo.range;
        if (this._orient === "vertical") return this._getDateByWeeksAndDay(nthY, nthX - 1, range);
        return this._getDateByWeeksAndDay(nthX, nthY - 1, range);
    };
    Calendar.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $be2279b8e0028cb2$var$getCoordSys(finder);
        return coordSys === this ? coordSys.dataToPoint(value) : null;
    };
    Calendar.prototype.convertToLayout = function(ecModel, finder, value) {
        var coordSys = $be2279b8e0028cb2$var$getCoordSys(finder);
        return coordSys === this ? coordSys.dataToLayout(value) : null;
    };
    Calendar.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $be2279b8e0028cb2$var$getCoordSys(finder);
        return coordSys === this ? coordSys.pointToData(pixel) : null;
    };
    Calendar.prototype.containPoint = function(point) {
        console.warn("Not implemented.");
        return false;
    };
    /**
   * initRange
   * Normalize to an [start, end] array
   */ Calendar.prototype._initRangeOption = function() {
        var range = this._model.get("range");
        var normalizedRange;
        // Convert [1990] to 1990
        if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(range) && range.length === 1) range = range[0];
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(range)) {
            var rangeStr = range.toString();
            // One year.
            if (/^\d{4}$/.test(rangeStr)) normalizedRange = [
                rangeStr + "-01-01",
                rangeStr + "-12-31"
            ];
            // One month
            if (/^\d{4}[\/|-]\d{1,2}$/.test(rangeStr)) {
                var start = this.getDateInfo(rangeStr);
                var firstDay = start.date;
                firstDay.setMonth(firstDay.getMonth() + 1);
                var end = this.getNextNDay(firstDay, -1);
                normalizedRange = [
                    start.formatedDate,
                    end.formatedDate
                ];
            }
            // One day
            if (/^\d{4}[\/|-]\d{1,2}[\/|-]\d{1,2}$/.test(rangeStr)) normalizedRange = [
                rangeStr,
                rangeStr
            ];
        } else normalizedRange = range;
        if (!normalizedRange) // Not handling it.
        return range;
        var tmp = this._getRangeInfo(normalizedRange);
        if (tmp.start.time > tmp.end.time) normalizedRange.reverse();
        return normalizedRange;
    };
    /**
   * range info
   *
   * @private
   * @param  {Array} range range ['2017-01-01', '2017-07-08']
   *  If range[0] > range[1], they will not be reversed.
   * @return {Object}       obj
   */ Calendar.prototype._getRangeInfo = function(range) {
        var parsedRange = [
            this.getDateInfo(range[0]),
            this.getDateInfo(range[1])
        ];
        var reversed;
        if (parsedRange[0].time > parsedRange[1].time) {
            reversed = true;
            parsedRange.reverse();
        }
        var allDay = Math.floor(parsedRange[1].time / $be2279b8e0028cb2$var$PROXIMATE_ONE_DAY) - Math.floor(parsedRange[0].time / $be2279b8e0028cb2$var$PROXIMATE_ONE_DAY) + 1;
        // Consider case1 (#11677 #10430):
        // Set the system timezone as "UK", set the range to `['2016-07-01', '2016-12-31']`
        // Consider case2:
        // Firstly set system timezone as "Time Zone: America/Toronto",
        // ```
        // let first = new Date(1478412000000 - 3600 * 1000 * 2.5);
        // let second = new Date(1478412000000);
        // let allDays = Math.floor(second / ONE_DAY) - Math.floor(first / ONE_DAY) + 1;
        // ```
        // will get wrong result because of DST. So we should fix it.
        var date = new Date(parsedRange[0].time);
        var startDateNum = date.getDate();
        var endDateNum = parsedRange[1].date.getDate();
        date.setDate(startDateNum + allDay - 1);
        // The bias can not over a month, so just compare date.
        var dateNum = date.getDate();
        if (dateNum !== endDateNum) {
            var sign = date.getTime() - parsedRange[1].time > 0 ? 1 : -1;
            while((dateNum = date.getDate()) !== endDateNum && (date.getTime() - parsedRange[1].time) * sign > 0){
                allDay -= sign;
                date.setDate(dateNum - sign);
            }
        }
        var weeks = Math.floor((allDay + parsedRange[0].day + 6) / 7);
        var nthWeek = reversed ? -weeks + 1 : weeks - 1;
        reversed && parsedRange.reverse();
        return {
            range: [
                parsedRange[0].formatedDate,
                parsedRange[1].formatedDate
            ],
            start: parsedRange[0],
            end: parsedRange[1],
            allDay: allDay,
            weeks: weeks,
            // From 0.
            nthWeek: nthWeek,
            fweek: parsedRange[0].day,
            lweek: parsedRange[1].day
        };
    };
    /**
   * get date by nthWeeks and week day in range
   *
   * @private
   * @param  {number} nthWeek the week
   * @param  {number} day   the week day
   * @param  {Array} range [d1, d2]
   * @return {Object}
   */ Calendar.prototype._getDateByWeeksAndDay = function(nthWeek, day, range) {
        var rangeInfo = this._getRangeInfo(range);
        if (nthWeek > rangeInfo.weeks || nthWeek === 0 && day < rangeInfo.fweek || nthWeek === rangeInfo.weeks && day > rangeInfo.lweek) return null;
        var nthDay = (nthWeek - 1) * 7 - rangeInfo.fweek + day;
        var date = new Date(rangeInfo.start.time);
        date.setDate(+rangeInfo.start.d + nthDay);
        return this.getDateInfo(date);
    };
    Calendar.create = function(ecModel, api) {
        var calendarList = [];
        ecModel.eachComponent("calendar", function(calendarModel) {
            var calendar = new Calendar(calendarModel, ecModel, api);
            calendarList.push(calendar);
            calendarModel.coordinateSystem = calendar;
        });
        // Inject coordinate system
        ecModel.eachComponent(function(mainType, componentModel) {
            (0, $70c3ede7d3b64757$export$7ed0c09d4f5c932e)({
                targetModel: componentModel,
                coordSysType: "calendar",
                coordSysProvider: (0, $70c3ede7d3b64757$export$33b06c851894cd19)
            });
        });
        return calendarList;
    };
    Calendar.dimensions = [
        "time",
        "value"
    ];
    return Calendar;
}();
function $be2279b8e0028cb2$var$getCoordSys(finder) {
    var calendarModel = finder.calendarModel;
    var seriesModel = finder.seriesModel;
    var coordSys = calendarModel ? calendarModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem : null;
    return coordSys;
}
var $be2279b8e0028cb2$export$2e2bcd8739ae039 = $be2279b8e0028cb2$var$Calendar;


function $c1c3b68ff9dcc3e7$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $795d2d92b1d02c70$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $e6b2dc17a91ad4af$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem("calendar", (0, $be2279b8e0028cb2$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $afb70cea6fec4fe0$export$83e718f1c3c9edae = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(DatasetModel, _super);
    function DatasetModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "dataset";
        return _this;
    }
    DatasetModel.prototype.init = function(option, parentModel, ecModel) {
        _super.prototype.init.call(this, option, parentModel, ecModel);
        this._sourceManager = new (0, $1c87d176de397e7e$export$af4db9ec7e200ea2)(this);
        (0, $1c87d176de397e7e$export$9451f4e9047441ec)(this);
    };
    DatasetModel.prototype.mergeOption = function(newOption, ecModel) {
        _super.prototype.mergeOption.call(this, newOption, ecModel);
        (0, $1c87d176de397e7e$export$9451f4e9047441ec)(this);
    };
    DatasetModel.prototype.optionUpdated = function() {
        this._sourceManager.dirty();
    };
    DatasetModel.prototype.getSourceManager = function() {
        return this._sourceManager;
    };
    DatasetModel.type = "dataset";
    DatasetModel.defaultOption = {
        seriesLayoutBy: (0, $cab29724515ce2b8$export$7b3f3c6551b4949b)
    };
    return DatasetModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $afb70cea6fec4fe0$var$DatasetView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(DatasetView, _super);
    function DatasetView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "dataset";
        return _this;
    }
    DatasetView.type = "dataset";
    return DatasetView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $afb70cea6fec4fe0$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel($afb70cea6fec4fe0$export$83e718f1c3c9edae);
    registers.registerComponentView($afb70cea6fec4fe0$var$DatasetView);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $554cb472ba0e05d3$export$f25521e726513e83 = [
    "x",
    "y",
    "radius",
    "angle",
    "single"
];
// Supported coords.
// FIXME: polar has been broken (but rarely used).
var $554cb472ba0e05d3$var$SERIES_COORDS = [
    "cartesian2d",
    "polar",
    "singleAxis"
];
function $554cb472ba0e05d3$export$2d449d4adc0d2cfc(seriesModel) {
    var coordType = seriesModel.get("coordinateSystem");
    return (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)($554cb472ba0e05d3$var$SERIES_COORDS, coordType) >= 0;
}
function $554cb472ba0e05d3$export$90855f7219399082(axisDim) {
    return axisDim + "Axis";
}
function $554cb472ba0e05d3$export$f9c16e110bf1e902(axisDim) {
    return axisDim + "AxisIndex";
}
function $554cb472ba0e05d3$export$fa8714b2310ddff9(axisDim) {
    return axisDim + "AxisId";
}
function $554cb472ba0e05d3$export$9e00b6c2b8b2e9a7(ecModel, payload) {
    // Key: `DataZoomAxisDimension`
    var axisRecords = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var effectedModels = [];
    // Key: uid of dataZoomModel
    var effectedModelMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    // Find the dataZooms specified by payload.
    ecModel.eachComponent({
        mainType: "dataZoom",
        query: payload
    }, function(dataZoomModel) {
        if (!effectedModelMap.get(dataZoomModel.uid)) addToEffected(dataZoomModel);
    });
    // Start from the given dataZoomModels, travel the graph to find
    // all of the linked dataZoom models.
    var foundNewLink;
    do {
        foundNewLink = false;
        ecModel.eachComponent("dataZoom", processSingle);
    }while (foundNewLink);
    function processSingle(dataZoomModel) {
        if (!effectedModelMap.get(dataZoomModel.uid) && isLinked(dataZoomModel)) {
            addToEffected(dataZoomModel);
            foundNewLink = true;
        }
    }
    function addToEffected(dataZoom) {
        effectedModelMap.set(dataZoom.uid, true);
        effectedModels.push(dataZoom);
        markAxisControlled(dataZoom);
    }
    function isLinked(dataZoomModel) {
        var isLink = false;
        dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
            var axisIdxArr = axisRecords.get(axisDim);
            if (axisIdxArr && axisIdxArr[axisIndex]) isLink = true;
        });
        return isLink;
    }
    function markAxisControlled(dataZoomModel) {
        dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
            (axisRecords.get(axisDim) || axisRecords.set(axisDim, []))[axisIndex] = true;
        });
    }
    return effectedModels;
}
function $554cb472ba0e05d3$export$b41173dee9da195b(dataZoomModel) {
    var ecModel = dataZoomModel.ecModel;
    var coordSysInfoWrap = {
        infoList: [],
        infoMap: (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)()
    };
    dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
        var axisModel = ecModel.getComponent($554cb472ba0e05d3$export$90855f7219399082(axisDim), axisIndex);
        if (!axisModel) return;
        var coordSysModel = axisModel.getCoordSysModel();
        if (!coordSysModel) return;
        var coordSysUid = coordSysModel.uid;
        var coordSysInfo = coordSysInfoWrap.infoMap.get(coordSysUid);
        if (!coordSysInfo) {
            coordSysInfo = {
                model: coordSysModel,
                axisModels: []
            };
            coordSysInfoWrap.infoList.push(coordSysInfo);
            coordSysInfoWrap.infoMap.set(coordSysUid, coordSysInfo);
        }
        coordSysInfo.axisModels.push(axisModel);
    });
    return coordSysInfoWrap;
}



var $41d57478d16bff21$var$DataZoomAxisInfo = /** @class */ function() {
    function DataZoomAxisInfo() {
        this.indexList = [];
        this.indexMap = [];
    }
    DataZoomAxisInfo.prototype.add = function(axisCmptIdx) {
        // Remove duplication.
        if (!this.indexMap[axisCmptIdx]) {
            this.indexList.push(axisCmptIdx);
            this.indexMap[axisCmptIdx] = true;
        }
    };
    return DataZoomAxisInfo;
}();
var $41d57478d16bff21$var$DataZoomModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(DataZoomModel, _super);
    function DataZoomModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = DataZoomModel.type;
        _this._autoThrottle = true;
        _this._noTarget = true;
        /**
     * It is `[rangeModeForMin, rangeModeForMax]`.
     * The optional values for `rangeMode`:
     * + `'value'` mode: the axis extent will always be determined by
     *     `dataZoom.startValue` and `dataZoom.endValue`, despite
     *     how data like and how `axis.min` and `axis.max` are.
     * + `'percent'` mode: `100` represents 100% of the `[dMin, dMax]`,
     *     where `dMin` is `axis.min` if `axis.min` specified, otherwise `data.extent[0]`,
     *     and `dMax` is `axis.max` if `axis.max` specified, otherwise `data.extent[1]`.
     *     Axis extent will be determined by the result of the percent of `[dMin, dMax]`.
     *
     * For example, when users are using dynamic data (update data periodically via `setOption`),
     * if in `'value`' mode, the window will be kept in a fixed value range despite how
     * data are appended, while if in `'percent'` mode, whe window range will be changed alone with
     * the appended data (suppose `axis.min` and `axis.max` are not specified).
     */ _this._rangePropMode = [
            "percent",
            "percent"
        ];
        return _this;
    }
    DataZoomModel.prototype.init = function(option, parentModel, ecModel) {
        var inputRawOption = $41d57478d16bff21$var$retrieveRawOption(option);
        /**
     * Suppose a "main process" start at the point that model prepared (that is,
     * model initialized or merged or method called in `action`).
     * We should keep the `main process` idempotent, that is, given a set of values
     * on `option`, we get the same result.
     *
     * But sometimes, values on `option` will be updated for providing users
     * a "final calculated value" (`dataZoomProcessor` will do that). Those value
     * should not be the base/input of the `main process`.
     *
     * So in that case we should save and keep the input of the `main process`
     * separately, called `settledOption`.
     *
     * For example, consider the case:
     * (Step_1) brush zoom the grid by `toolbox.dataZoom`,
     *     where the original input `option.startValue`, `option.endValue` are earsed by
     *     calculated value.
     * (Step)2) click the legend to hide and show a series,
     *     where the new range is calculated by the earsed `startValue` and `endValue`,
     *     which brings incorrect result.
     */ this.settledOption = inputRawOption;
        this.mergeDefaultAndTheme(option, ecModel);
        this._doInit(inputRawOption);
    };
    DataZoomModel.prototype.mergeOption = function(newOption) {
        var inputRawOption = $41d57478d16bff21$var$retrieveRawOption(newOption);
        // FIX #2591
        (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(this.option, newOption, true);
        (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(this.settledOption, inputRawOption, true);
        this._doInit(inputRawOption);
    };
    DataZoomModel.prototype._doInit = function(inputRawOption) {
        var thisOption = this.option;
        this._setDefaultThrottle(inputRawOption);
        this._updateRangeUse(inputRawOption);
        var settledOption = this.settledOption;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            [
                "start",
                "startValue"
            ],
            [
                "end",
                "endValue"
            ]
        ], function(names, index) {
            // start/end has higher priority over startValue/endValue if they
            // both set, but we should make chart.setOption({endValue: 1000})
            // effective, rather than chart.setOption({endValue: 1000, end: null}).
            if (this._rangePropMode[index] === "value") thisOption[names[0]] = settledOption[names[0]] = null;
        // Otherwise do nothing and use the merge result.
        }, this);
        this._resetTarget();
    };
    DataZoomModel.prototype._resetTarget = function() {
        var optionOrient = this.get("orient", true);
        var targetAxisIndexMap = this._targetAxisInfoMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        var hasAxisSpecified = this._fillSpecifiedTargetAxis(targetAxisIndexMap);
        if (hasAxisSpecified) this._orient = optionOrient || this._makeAutoOrientByTargetAxis();
        else {
            this._orient = optionOrient || "horizontal";
            this._fillAutoTargetAxisByOrient(targetAxisIndexMap, this._orient);
        }
        this._noTarget = true;
        targetAxisIndexMap.each(function(axisInfo) {
            if (axisInfo.indexList.length) this._noTarget = false;
        }, this);
    };
    DataZoomModel.prototype._fillSpecifiedTargetAxis = function(targetAxisIndexMap) {
        var hasAxisSpecified = false;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $554cb472ba0e05d3$export$f25521e726513e83), function(axisDim) {
            var refering = this.getReferringComponents((0, $554cb472ba0e05d3$export$90855f7219399082)(axisDim), (0, $76d619f648247e6d$export$48d598924ce4892c));
            // When user set axisIndex as a empty array, we think that user specify axisIndex
            // but do not want use auto mode. Because empty array may be encountered when
            // some error occurred.
            if (!refering.specified) return;
            hasAxisSpecified = true;
            var axisInfo = new $41d57478d16bff21$var$DataZoomAxisInfo();
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(refering.models, function(axisModel) {
                axisInfo.add(axisModel.componentIndex);
            });
            targetAxisIndexMap.set(axisDim, axisInfo);
        }, this);
        return hasAxisSpecified;
    };
    DataZoomModel.prototype._fillAutoTargetAxisByOrient = function(targetAxisIndexMap, orient) {
        var ecModel = this.ecModel;
        var needAuto = true;
        // Find axis that parallel to dataZoom as default.
        if (needAuto) {
            var axisDim = orient === "vertical" ? "y" : "x";
            var axisModels = ecModel.findComponents({
                mainType: axisDim + "Axis"
            });
            setParallelAxis(axisModels, axisDim);
        }
        // Find axis that parallel to dataZoom as default.
        if (needAuto) {
            var axisModels = ecModel.findComponents({
                mainType: "singleAxis",
                filter: function(axisModel) {
                    return axisModel.get("orient", true) === orient;
                }
            });
            setParallelAxis(axisModels, "single");
        }
        function setParallelAxis(axisModels, axisDim) {
            // At least use the first parallel axis as the target axis.
            var axisModel = axisModels[0];
            if (!axisModel) return;
            var axisInfo = new $41d57478d16bff21$var$DataZoomAxisInfo();
            axisInfo.add(axisModel.componentIndex);
            targetAxisIndexMap.set(axisDim, axisInfo);
            needAuto = false;
            // Find parallel axes in the same grid.
            if (axisDim === "x" || axisDim === "y") {
                var gridModel_1 = axisModel.getReferringComponents("grid", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
                gridModel_1 && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisModels, function(axModel) {
                    if (axisModel.componentIndex !== axModel.componentIndex && gridModel_1 === axModel.getReferringComponents("grid", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0]) axisInfo.add(axModel.componentIndex);
                });
            }
        }
        if (needAuto) // If no parallel axis, find the first category axis as default. (Also consider polar).
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $554cb472ba0e05d3$export$f25521e726513e83), function(axisDim) {
            if (!needAuto) return;
            var axisModels = ecModel.findComponents({
                mainType: (0, $554cb472ba0e05d3$export$90855f7219399082)(axisDim),
                filter: function(axisModel) {
                    return axisModel.get("type", true) === "category";
                }
            });
            if (axisModels[0]) {
                var axisInfo = new $41d57478d16bff21$var$DataZoomAxisInfo();
                axisInfo.add(axisModels[0].componentIndex);
                targetAxisIndexMap.set(axisDim, axisInfo);
                needAuto = false;
            }
        }, this);
    };
    DataZoomModel.prototype._makeAutoOrientByTargetAxis = function() {
        var dim;
        // Find the first axis
        this.eachTargetAxis(function(axisDim) {
            !dim && (dim = axisDim);
        }, this);
        return dim === "y" ? "vertical" : "horizontal";
    };
    DataZoomModel.prototype._setDefaultThrottle = function(inputRawOption) {
        // When first time user set throttle, auto throttle ends.
        if (inputRawOption.hasOwnProperty("throttle")) this._autoThrottle = false;
        if (this._autoThrottle) {
            var globalOption = this.ecModel.option;
            this.option.throttle = globalOption.animation && globalOption.animationDurationUpdate > 0 ? 100 : 20;
        }
    };
    DataZoomModel.prototype._updateRangeUse = function(inputRawOption) {
        var rangePropMode = this._rangePropMode;
        var rangeModeInOption = this.get("rangeMode");
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            [
                "start",
                "startValue"
            ],
            [
                "end",
                "endValue"
            ]
        ], function(names, index) {
            var percentSpecified = inputRawOption[names[0]] != null;
            var valueSpecified = inputRawOption[names[1]] != null;
            if (percentSpecified && !valueSpecified) rangePropMode[index] = "percent";
            else if (!percentSpecified && valueSpecified) rangePropMode[index] = "value";
            else if (rangeModeInOption) rangePropMode[index] = rangeModeInOption[index];
            else if (percentSpecified) // percentSpecified && valueSpecified
            rangePropMode[index] = "percent";
        // else remain its original setting.
        });
    };
    DataZoomModel.prototype.noTarget = function() {
        return this._noTarget;
    };
    DataZoomModel.prototype.getFirstTargetAxisModel = function() {
        var firstAxisModel;
        this.eachTargetAxis(function(axisDim, axisIndex) {
            if (firstAxisModel == null) firstAxisModel = this.ecModel.getComponent((0, $554cb472ba0e05d3$export$90855f7219399082)(axisDim), axisIndex);
        }, this);
        return firstAxisModel;
    };
    /**
   * @param {Function} callback param: axisModel, dimNames, axisIndex, dataZoomModel, ecModel
   */ DataZoomModel.prototype.eachTargetAxis = function(callback, context) {
        this._targetAxisInfoMap.each(function(axisInfo, axisDim) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisInfo.indexList, function(axisIndex) {
                callback.call(context, axisDim, axisIndex);
            });
        });
    };
    /**
   * @return If not found, return null/undefined.
   */ DataZoomModel.prototype.getAxisProxy = function(axisDim, axisIndex) {
        var axisModel = this.getAxisModel(axisDim, axisIndex);
        if (axisModel) return axisModel.__dzAxisProxy;
    };
    /**
   * @return If not found, return null/undefined.
   */ DataZoomModel.prototype.getAxisModel = function(axisDim, axisIndex) {
        var axisInfo = this._targetAxisInfoMap.get(axisDim);
        if (axisInfo && axisInfo.indexMap[axisIndex]) return this.ecModel.getComponent((0, $554cb472ba0e05d3$export$90855f7219399082)(axisDim), axisIndex);
    };
    /**
   * If not specified, set to undefined.
   */ DataZoomModel.prototype.setRawRange = function(opt) {
        var thisOption = this.option;
        var settledOption = this.settledOption;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            [
                "start",
                "startValue"
            ],
            [
                "end",
                "endValue"
            ]
        ], function(names) {
            // Consider the pair <start, startValue>:
            // If one has value and the other one is `null/undefined`, we both set them
            // to `settledOption`. This strategy enables the feature to clear the original
            // value in `settledOption` to `null/undefined`.
            // But if both of them are `null/undefined`, we do not set them to `settledOption`
            // and keep `settledOption` with the original value. This strategy enables users to
            // only set <end or endValue> but not set <start or startValue> when calling
            // `dispatchAction`.
            // The pair <end, endValue> is treated in the same way.
            if (opt[names[0]] != null || opt[names[1]] != null) {
                thisOption[names[0]] = settledOption[names[0]] = opt[names[0]];
                thisOption[names[1]] = settledOption[names[1]] = opt[names[1]];
            }
        }, this);
        this._updateRangeUse(opt);
    };
    DataZoomModel.prototype.setCalculatedRange = function(opt) {
        var option = this.option;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            "start",
            "startValue",
            "end",
            "endValue"
        ], function(name) {
            option[name] = opt[name];
        });
    };
    DataZoomModel.prototype.getPercentRange = function() {
        var axisProxy = this.findRepresentativeAxisProxy();
        if (axisProxy) return axisProxy.getDataPercentWindow();
    };
    /**
   * For example, chart.getModel().getComponent('dataZoom').getValueRange('y', 0);
   *
   * @return [startValue, endValue] value can only be '-' or finite number.
   */ DataZoomModel.prototype.getValueRange = function(axisDim, axisIndex) {
        if (axisDim == null && axisIndex == null) {
            var axisProxy = this.findRepresentativeAxisProxy();
            if (axisProxy) return axisProxy.getDataValueWindow();
        } else return this.getAxisProxy(axisDim, axisIndex).getDataValueWindow();
    };
    /**
   * @param axisModel If axisModel given, find axisProxy
   *      corresponding to the axisModel
   */ DataZoomModel.prototype.findRepresentativeAxisProxy = function(axisModel) {
        if (axisModel) return axisModel.__dzAxisProxy;
        // Find the first hosted axisProxy
        var firstProxy;
        var axisDimList = this._targetAxisInfoMap.keys();
        for(var i = 0; i < axisDimList.length; i++){
            var axisDim = axisDimList[i];
            var axisInfo = this._targetAxisInfoMap.get(axisDim);
            for(var j = 0; j < axisInfo.indexList.length; j++){
                var proxy = this.getAxisProxy(axisDim, axisInfo.indexList[j]);
                if (proxy.hostedBy(this)) return proxy;
                if (!firstProxy) firstProxy = proxy;
            }
        }
        // If no hosted proxy found, still need to return a proxy.
        // This case always happens in toolbox dataZoom, where axes are all hosted by
        // other dataZooms.
        return firstProxy;
    };
    DataZoomModel.prototype.getRangePropMode = function() {
        return this._rangePropMode.slice();
    };
    DataZoomModel.prototype.getOrient = function() {
        return this._orient;
    };
    DataZoomModel.type = "dataZoom";
    DataZoomModel.dependencies = [
        "xAxis",
        "yAxis",
        "radiusAxis",
        "angleAxis",
        "singleAxis",
        "series",
        "toolbox"
    ];
    DataZoomModel.defaultOption = {
        // zlevel: 0,
        z: 4,
        filterMode: "filter",
        start: 0,
        end: 100
    };
    return DataZoomModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
/**
 * Retrieve those raw params from option, which will be cached separately,
 * because they will be overwritten by normalized/calculated values in the main
 * process.
 */ function $41d57478d16bff21$var$retrieveRawOption(option) {
    var ret = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        "start",
        "end",
        "startValue",
        "endValue",
        "throttle"
    ], function(name) {
        option.hasOwnProperty(name) && (ret[name] = option[name]);
    });
    return ret;
}
var $41d57478d16bff21$export$2e2bcd8739ae039 = $41d57478d16bff21$var$DataZoomModel;



var $6cccca1a1040a7a1$var$InsideZoomModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(InsideZoomModel, _super);
    function InsideZoomModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = InsideZoomModel.type;
        return _this;
    }
    InsideZoomModel.type = "dataZoom.inside";
    InsideZoomModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $41d57478d16bff21$export$2e2bcd8739ae039).defaultOption, {
        disabled: false,
        zoomLock: false,
        zoomOnMouseWheel: true,
        moveOnMouseMove: true,
        moveOnMouseWheel: false,
        preventDefaultMouseMove: true
    });
    return InsideZoomModel;
}((0, $41d57478d16bff21$export$2e2bcd8739ae039));
var $6cccca1a1040a7a1$export$2e2bcd8739ae039 = $6cccca1a1040a7a1$var$InsideZoomModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $80d6a03162f25654$var$DataZoomView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(DataZoomView, _super);
    function DataZoomView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = DataZoomView.type;
        return _this;
    }
    DataZoomView.prototype.render = function(dataZoomModel, ecModel, api, payload) {
        this.dataZoomModel = dataZoomModel;
        this.ecModel = ecModel;
        this.api = api;
    };
    DataZoomView.type = "dataZoom";
    return DataZoomView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $80d6a03162f25654$export$2e2bcd8739ae039 = $80d6a03162f25654$var$DataZoomView;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Only create one roam controller for each coordinate system.
// one roam controller might be refered by two inside data zoom
// components (for example, one for x and one for y). When user
// pan or zoom, only dispatch one action for those data zoom
// components.





var $6379ab7b9c3fbfb6$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $6379ab7b9c3fbfb6$export$c499fdc26107c565(api, dataZoomModel, getRange) {
    $6379ab7b9c3fbfb6$var$inner(api).coordSysRecordMap.each(function(coordSysRecord) {
        var dzInfo = coordSysRecord.dataZoomInfoMap.get(dataZoomModel.uid);
        if (dzInfo) dzInfo.getRange = getRange;
    });
}
function $6379ab7b9c3fbfb6$export$d074fdbbb2bf218c(api, dataZoomModel) {
    var coordSysRecordMap = $6379ab7b9c3fbfb6$var$inner(api).coordSysRecordMap;
    var coordSysKeyArr = coordSysRecordMap.keys();
    for(var i = 0; i < coordSysKeyArr.length; i++){
        var coordSysKey = coordSysKeyArr[i];
        var coordSysRecord = coordSysRecordMap.get(coordSysKey);
        var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap;
        if (dataZoomInfoMap) {
            var dzUid = dataZoomModel.uid;
            var dzInfo = dataZoomInfoMap.get(dzUid);
            if (dzInfo) {
                dataZoomInfoMap.removeKey(dzUid);
                if (!dataZoomInfoMap.keys().length) $6379ab7b9c3fbfb6$var$disposeCoordSysRecord(coordSysRecordMap, coordSysRecord);
            }
        }
    }
}
function $6379ab7b9c3fbfb6$var$disposeCoordSysRecord(coordSysRecordMap, coordSysRecord) {
    if (coordSysRecord) {
        coordSysRecordMap.removeKey(coordSysRecord.model.uid);
        var controller = coordSysRecord.controller;
        controller && controller.dispose();
    }
}
function $6379ab7b9c3fbfb6$var$createCoordSysRecord(api, coordSysModel) {
    // These init props will never change after record created.
    var coordSysRecord = {
        model: coordSysModel,
        containsPoint: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($6379ab7b9c3fbfb6$var$containsPoint, coordSysModel),
        dispatchAction: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($6379ab7b9c3fbfb6$var$dispatchAction, api),
        dataZoomInfoMap: null,
        controller: null
    };
    // Must not do anything depends on coordSysRecord outside the event handler here,
    // because coordSysRecord not completed yet.
    var controller = coordSysRecord.controller = new (0, $15927f329deeab51$export$2e2bcd8739ae039)(api.getZr());
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        "pan",
        "zoom",
        "scrollMove"
    ], function(eventName) {
        controller.on(eventName, function(event) {
            var batch = [];
            coordSysRecord.dataZoomInfoMap.each(function(dzInfo) {
                // Check whether the behaviors (zoomOnMouseWheel, moveOnMouseMove,
                // moveOnMouseWheel, ...) enabled.
                if (!event.isAvailableBehavior(dzInfo.model.option)) return;
                var method = (dzInfo.getRange || {})[eventName];
                var range = method && method(dzInfo.dzReferCoordSysInfo, coordSysRecord.model.mainType, coordSysRecord.controller, event);
                !dzInfo.model.get("disabled", true) && range && batch.push({
                    dataZoomId: dzInfo.model.id,
                    start: range[0],
                    end: range[1]
                });
            });
            batch.length && coordSysRecord.dispatchAction(batch);
        });
    });
    return coordSysRecord;
}
/**
 * This action will be throttled.
 */ function $6379ab7b9c3fbfb6$var$dispatchAction(api, batch) {
    if (!api.isDisposed()) api.dispatchAction({
        type: "dataZoom",
        animation: {
            easing: "cubicOut",
            duration: 100
        },
        batch: batch
    });
}
function $6379ab7b9c3fbfb6$var$containsPoint(coordSysModel, e, x, y) {
    return coordSysModel.coordinateSystem.containPoint([
        x,
        y
    ]);
}
/**
 * Merge roamController settings when multiple dataZooms share one roamController.
 */ function $6379ab7b9c3fbfb6$var$mergeControllerParams(dataZoomInfoMap, coordSysRecord, api) {
    var controlType;
    // DO NOT use reserved word (true, false, undefined) as key literally. Even if encapsulated
    // as string, it is probably revert to reserved word by compress tool. See #7411.
    var prefix = "type_";
    var typePriority = {
        "type_true": 2,
        "type_move": 1,
        "type_false": 0,
        "type_undefined": -1
    };
    var preventDefaultMouseMove = true;
    dataZoomInfoMap.each(function(dataZoomInfo) {
        var dataZoomModel = dataZoomInfo.model;
        var oneType = dataZoomModel.get("disabled", true) ? false : dataZoomModel.get("zoomLock", true) ? "move" : true;
        if (typePriority[prefix + oneType] > typePriority[prefix + controlType]) controlType = oneType;
        // Prevent default move event by default. If one false, do not prevent. Otherwise
        // users may be confused why it does not work when multiple insideZooms exist.
        preventDefaultMouseMove = preventDefaultMouseMove && dataZoomModel.get("preventDefaultMouseMove", true);
    });
    return {
        controlType: controlType,
        opt: {
            // RoamController will enable all of these functionalities,
            // and the final behavior is determined by its event listener
            // provided by each inside zoom.
            zoomOnMouseWheel: true,
            moveOnMouseMove: true,
            moveOnMouseWheel: true,
            preventDefaultMouseMove: !!preventDefaultMouseMove,
            api: api,
            zInfo: {
                component: coordSysRecord.model
            },
            triggerInfo: {
                roamTrigger: null,
                isInSelf: coordSysRecord.containsPoint
            }
        }
    };
}
function $6379ab7b9c3fbfb6$export$f3632ddafc9ea51e(registers) {
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.FILTER, function(ecModel, api) {
        var apiInner = $6379ab7b9c3fbfb6$var$inner(api);
        var coordSysRecordMap = apiInner.coordSysRecordMap || (apiInner.coordSysRecordMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)());
        coordSysRecordMap.each(function(coordSysRecord) {
            // `coordSysRecordMap` always exists (because it holds the `roam controller`, which should
            // better not re-create each time), but clear `dataZoomInfoMap` each round of the workflow.
            coordSysRecord.dataZoomInfoMap = null;
        });
        ecModel.eachComponent({
            mainType: "dataZoom",
            subType: "inside"
        }, function(dataZoomModel) {
            var dzReferCoordSysWrap = (0, $554cb472ba0e05d3$export$b41173dee9da195b)(dataZoomModel);
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dzReferCoordSysWrap.infoList, function(dzCoordSysInfo) {
                var coordSysUid = dzCoordSysInfo.model.uid;
                var coordSysRecord = coordSysRecordMap.get(coordSysUid) || coordSysRecordMap.set(coordSysUid, $6379ab7b9c3fbfb6$var$createCoordSysRecord(api, dzCoordSysInfo.model));
                var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap || (coordSysRecord.dataZoomInfoMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)());
                // Notice these props might be changed each time for a single dataZoomModel.
                dataZoomInfoMap.set(dataZoomModel.uid, {
                    dzReferCoordSysInfo: dzCoordSysInfo,
                    model: dataZoomModel,
                    getRange: null
                });
            });
        });
        // (1) Merge dataZoom settings for each coord sys and set to the roam controller.
        // (2) Clear coord sys if not refered by any dataZoom.
        coordSysRecordMap.each(function(coordSysRecord) {
            var controller = coordSysRecord.controller;
            var firstDzInfo;
            var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap;
            if (dataZoomInfoMap) {
                var firstDzKey = dataZoomInfoMap.keys()[0];
                if (firstDzKey != null) firstDzInfo = dataZoomInfoMap.get(firstDzKey);
            }
            if (!firstDzInfo) {
                $6379ab7b9c3fbfb6$var$disposeCoordSysRecord(coordSysRecordMap, coordSysRecord);
                return;
            }
            var controllerParams = $6379ab7b9c3fbfb6$var$mergeControllerParams(dataZoomInfoMap, coordSysRecord, api);
            controller.enable(controllerParams.controlType, controllerParams.opt);
            $c98659a9437a3d2e$export$958e3e1a02eac4b6(coordSysRecord, "dispatchAction", firstDzInfo.model.get("throttle", true), "fixRate");
        });
    });
}



var $ad4d16a462c12aaf$var$InsideZoomView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(InsideZoomView, _super);
    function InsideZoomView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "dataZoom.inside";
        return _this;
    }
    InsideZoomView.prototype.render = function(dataZoomModel, ecModel, api) {
        _super.prototype.render.apply(this, arguments);
        if (dataZoomModel.noTarget()) {
            this._clear();
            return;
        }
        // Hence the `throttle` util ensures to preserve command order,
        // here simply updating range all the time will not cause missing
        // any of the the roam change.
        this.range = dataZoomModel.getPercentRange();
        // Reset controllers.
        $6379ab7b9c3fbfb6$export$c499fdc26107c565(api, dataZoomModel, {
            pan: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($ad4d16a462c12aaf$var$getRangeHandlers.pan, this),
            zoom: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($ad4d16a462c12aaf$var$getRangeHandlers.zoom, this),
            scrollMove: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($ad4d16a462c12aaf$var$getRangeHandlers.scrollMove, this)
        });
    };
    InsideZoomView.prototype.dispose = function() {
        this._clear();
        _super.prototype.dispose.apply(this, arguments);
    };
    InsideZoomView.prototype._clear = function() {
        $6379ab7b9c3fbfb6$export$d074fdbbb2bf218c(this.api, this.dataZoomModel);
        this.range = null;
    };
    InsideZoomView.type = "dataZoom.inside";
    return InsideZoomView;
}((0, $80d6a03162f25654$export$2e2bcd8739ae039));
var $ad4d16a462c12aaf$var$getRangeHandlers = {
    zoom: function(coordSysInfo, coordSysMainType, controller, e) {
        var lastRange = this.range;
        var range = lastRange.slice();
        // Calculate transform by the first axis.
        var axisModel = coordSysInfo.axisModels[0];
        if (!axisModel) return;
        var directionInfo = $ad4d16a462c12aaf$var$getDirectionInfo[coordSysMainType](null, [
            e.originX,
            e.originY
        ], axisModel, controller, coordSysInfo);
        var percentPoint = (directionInfo.signal > 0 ? directionInfo.pixelStart + directionInfo.pixelLength - directionInfo.pixel : directionInfo.pixel - directionInfo.pixelStart) / directionInfo.pixelLength * (range[1] - range[0]) + range[0];
        var scale = Math.max(1 / e.scale, 0);
        range[0] = (range[0] - percentPoint) * scale + percentPoint;
        range[1] = (range[1] - percentPoint) * scale + percentPoint;
        // Restrict range.
        var minMaxSpan = this.dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
        (0, $00a8003b34293330$export$2e2bcd8739ae039)(0, range, [
            0,
            100
        ], 0, minMaxSpan.minSpan, minMaxSpan.maxSpan);
        this.range = range;
        if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) return range;
    },
    pan: $ad4d16a462c12aaf$var$makeMover(function(range, axisModel, coordSysInfo, coordSysMainType, controller, e) {
        var directionInfo = $ad4d16a462c12aaf$var$getDirectionInfo[coordSysMainType]([
            e.oldX,
            e.oldY
        ], [
            e.newX,
            e.newY
        ], axisModel, controller, coordSysInfo);
        return directionInfo.signal * (range[1] - range[0]) * directionInfo.pixel / directionInfo.pixelLength;
    }),
    scrollMove: $ad4d16a462c12aaf$var$makeMover(function(range, axisModel, coordSysInfo, coordSysMainType, controller, e) {
        var directionInfo = $ad4d16a462c12aaf$var$getDirectionInfo[coordSysMainType]([
            0,
            0
        ], [
            e.scrollDelta,
            e.scrollDelta
        ], axisModel, controller, coordSysInfo);
        return directionInfo.signal * (range[1] - range[0]) * e.scrollDelta;
    })
};
function $ad4d16a462c12aaf$var$makeMover(getPercentDelta) {
    return function(coordSysInfo, coordSysMainType, controller, e) {
        var lastRange = this.range;
        var range = lastRange.slice();
        // Calculate transform by the first axis.
        var axisModel = coordSysInfo.axisModels[0];
        if (!axisModel) return;
        var percentDelta = getPercentDelta(range, axisModel, coordSysInfo, coordSysMainType, controller, e);
        (0, $00a8003b34293330$export$2e2bcd8739ae039)(percentDelta, range, [
            0,
            100
        ], "all");
        this.range = range;
        if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) return range;
    };
}
var $ad4d16a462c12aaf$var$getDirectionInfo = {
    grid: function(oldPoint, newPoint, axisModel, controller, coordSysInfo) {
        var axis = axisModel.axis;
        var ret = {};
        var rect = coordSysInfo.model.coordinateSystem.getRect();
        oldPoint = oldPoint || [
            0,
            0
        ];
        if (axis.dim === "x") {
            ret.pixel = newPoint[0] - oldPoint[0];
            ret.pixelLength = rect.width;
            ret.pixelStart = rect.x;
            ret.signal = axis.inverse ? 1 : -1;
        } else {
            // axis.dim === 'y'
            ret.pixel = newPoint[1] - oldPoint[1];
            ret.pixelLength = rect.height;
            ret.pixelStart = rect.y;
            ret.signal = axis.inverse ? -1 : 1;
        }
        return ret;
    },
    polar: function(oldPoint, newPoint, axisModel, controller, coordSysInfo) {
        var axis = axisModel.axis;
        var ret = {};
        var polar = coordSysInfo.model.coordinateSystem;
        var radiusExtent = polar.getRadiusAxis().getExtent();
        var angleExtent = polar.getAngleAxis().getExtent();
        oldPoint = oldPoint ? polar.pointToCoord(oldPoint) : [
            0,
            0
        ];
        newPoint = polar.pointToCoord(newPoint);
        if (axisModel.mainType === "radiusAxis") {
            ret.pixel = newPoint[0] - oldPoint[0];
            // ret.pixelLength = Math.abs(radiusExtent[1] - radiusExtent[0]);
            // ret.pixelStart = Math.min(radiusExtent[0], radiusExtent[1]);
            ret.pixelLength = radiusExtent[1] - radiusExtent[0];
            ret.pixelStart = radiusExtent[0];
            ret.signal = axis.inverse ? 1 : -1;
        } else {
            // 'angleAxis'
            ret.pixel = newPoint[1] - oldPoint[1];
            // ret.pixelLength = Math.abs(angleExtent[1] - angleExtent[0]);
            // ret.pixelStart = Math.min(angleExtent[0], angleExtent[1]);
            ret.pixelLength = angleExtent[1] - angleExtent[0];
            ret.pixelStart = angleExtent[0];
            ret.signal = axis.inverse ? -1 : 1;
        }
        return ret;
    },
    singleAxis: function(oldPoint, newPoint, axisModel, controller, coordSysInfo) {
        var axis = axisModel.axis;
        var rect = coordSysInfo.model.coordinateSystem.getRect();
        var ret = {};
        oldPoint = oldPoint || [
            0,
            0
        ];
        if (axis.orient === "horizontal") {
            ret.pixel = newPoint[0] - oldPoint[0];
            ret.pixelLength = rect.width;
            ret.pixelStart = rect.x;
            ret.signal = axis.inverse ? 1 : -1;
        } else {
            // 'vertical'
            ret.pixel = newPoint[1] - oldPoint[1];
            ret.pixelLength = rect.height;
            ret.pixelStart = rect.y;
            ret.signal = axis.inverse ? -1 : 1;
        }
        return ret;
    }
};
var $ad4d16a462c12aaf$export$2e2bcd8739ae039 = $ad4d16a462c12aaf$var$InsideZoomView;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $06639d6035d20694$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $06639d6035d20694$var$asc = $cfc1f3b422a3185f$export$debe6e778e0a6d32;
/**
 * Operate single axis.
 * One axis can only operated by one axis operator.
 * Different dataZoomModels may be defined to operate the same axis.
 * (i.e. 'inside' data zoom and 'slider' data zoom components)
 * So dataZoomModels share one axisProxy in that case.
 */ var $06639d6035d20694$var$AxisProxy = /** @class */ function() {
    function AxisProxy(dimName, axisIndex, dataZoomModel, ecModel) {
        this._dimName = dimName;
        this._axisIndex = axisIndex;
        this.ecModel = ecModel;
        this._dataZoomModel = dataZoomModel;
    // /**
    //  * @readOnly
    //  * @private
    //  */
    // this.hasSeriesStacked;
    }
    /**
   * Whether the axisProxy is hosted by dataZoomModel.
   */ AxisProxy.prototype.hostedBy = function(dataZoomModel) {
        return this._dataZoomModel === dataZoomModel;
    };
    /**
   * @return Value can only be NaN or finite value.
   */ AxisProxy.prototype.getDataValueWindow = function() {
        return this._valueWindow.slice();
    };
    /**
   * @return {Array.<number>}
   */ AxisProxy.prototype.getDataPercentWindow = function() {
        return this._percentWindow.slice();
    };
    AxisProxy.prototype.getTargetSeriesModels = function() {
        var seriesModels = [];
        this.ecModel.eachSeries(function(seriesModel) {
            if ((0, $554cb472ba0e05d3$export$2d449d4adc0d2cfc)(seriesModel)) {
                var axisMainType = (0, $554cb472ba0e05d3$export$90855f7219399082)(this._dimName);
                var axisModel = seriesModel.getReferringComponents(axisMainType, (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
                if (axisModel && this._axisIndex === axisModel.componentIndex) seriesModels.push(seriesModel);
            }
        }, this);
        return seriesModels;
    };
    AxisProxy.prototype.getAxisModel = function() {
        return this.ecModel.getComponent(this._dimName + "Axis", this._axisIndex);
    };
    AxisProxy.prototype.getMinMaxSpan = function() {
        return $7a1bd9c2710fea0d$export$9cd59f9826255e47(this._minMaxSpan);
    };
    /**
   * Only calculate by given range and this._dataExtent, do not change anything.
   */ AxisProxy.prototype.calculateDataWindow = function(opt) {
        var dataExtent = this._dataExtent;
        var axisModel = this.getAxisModel();
        var scale = axisModel.axis.scale;
        var rangePropMode = this._dataZoomModel.getRangePropMode();
        var percentExtent = [
            0,
            100
        ];
        var percentWindow = [];
        var valueWindow = [];
        var hasPropModeValue;
        $06639d6035d20694$var$each([
            "start",
            "end"
        ], function(prop, idx) {
            var boundPercent = opt[prop];
            var boundValue = opt[prop + "Value"];
            // Notice: dataZoom is based either on `percentProp` ('start', 'end') or
            // on `valueProp` ('startValue', 'endValue'). (They are based on the data extent
            // but not min/max of axis, which will be calculated by data window then).
            // The former one is suitable for cases that a dataZoom component controls multiple
            // axes with different unit or extent, and the latter one is suitable for accurate
            // zoom by pixel (e.g., in dataZoomSelect).
            // we use `getRangePropMode()` to mark which prop is used. `rangePropMode` is updated
            // only when setOption or dispatchAction, otherwise it remains its original value.
            // (Why not only record `percentProp` and always map to `valueProp`? Because
            // the map `valueProp` -> `percentProp` -> `valueProp` probably not the original
            // `valueProp`. consider two axes constrolled by one dataZoom. They have different
            // data extent. All of values that are overflow the `dataExtent` will be calculated
            // to percent '100%').
            if (rangePropMode[idx] === "percent") {
                boundPercent == null && (boundPercent = percentExtent[idx]);
                // Use scale.parse to math round for category or time axis.
                boundValue = scale.parse($cfc1f3b422a3185f$export$d3f68fbaa670562(boundPercent, percentExtent, dataExtent));
            } else {
                hasPropModeValue = true;
                boundValue = boundValue == null ? dataExtent[idx] : scale.parse(boundValue);
                // Calculating `percent` from `value` may be not accurate, because
                // This calculation can not be inversed, because all of values that
                // are overflow the `dataExtent` will be calculated to percent '100%'
                boundPercent = $cfc1f3b422a3185f$export$d3f68fbaa670562(boundValue, dataExtent, percentExtent);
            }
            // valueWindow[idx] = round(boundValue);
            // percentWindow[idx] = round(boundPercent);
            // fallback to extent start/end when parsed value or percent is invalid
            valueWindow[idx] = boundValue == null || isNaN(boundValue) ? dataExtent[idx] : boundValue;
            percentWindow[idx] = boundPercent == null || isNaN(boundPercent) ? percentExtent[idx] : boundPercent;
        });
        $06639d6035d20694$var$asc(valueWindow);
        $06639d6035d20694$var$asc(percentWindow);
        // The windows from user calling of `dispatchAction` might be out of the extent,
        // or do not obey the `min/maxSpan`, `min/maxValueSpan`. But we don't restrict window
        // by `zoomLock` here, because we see `zoomLock` just as a interaction constraint,
        // where API is able to initialize/modify the window size even though `zoomLock`
        // specified.
        var spans = this._minMaxSpan;
        hasPropModeValue ? restrictSet(valueWindow, percentWindow, dataExtent, percentExtent, false) : restrictSet(percentWindow, valueWindow, percentExtent, dataExtent, true);
        function restrictSet(fromWindow, toWindow, fromExtent, toExtent, toValue) {
            var suffix = toValue ? "Span" : "ValueSpan";
            (0, $00a8003b34293330$export$2e2bcd8739ae039)(0, fromWindow, fromExtent, "all", spans["min" + suffix], spans["max" + suffix]);
            for(var i = 0; i < 2; i++){
                toWindow[i] = $cfc1f3b422a3185f$export$d3f68fbaa670562(fromWindow[i], fromExtent, toExtent, true);
                toValue && (toWindow[i] = scale.parse(toWindow[i]));
            }
        }
        return {
            valueWindow: valueWindow,
            percentWindow: percentWindow
        };
    };
    /**
   * Notice: reset should not be called before series.restoreData() is called,
   * so it is recommended to be called in "process stage" but not "model init
   * stage".
   */ AxisProxy.prototype.reset = function(dataZoomModel) {
        if (dataZoomModel !== this._dataZoomModel) return;
        var targetSeries = this.getTargetSeriesModels();
        // Culculate data window and data extent, and record them.
        this._dataExtent = $06639d6035d20694$var$calculateDataExtent(this, this._dimName, targetSeries);
        // `calculateDataWindow` uses min/maxSpan.
        this._updateMinMaxSpan();
        var dataWindow = this.calculateDataWindow(dataZoomModel.settledOption);
        this._valueWindow = dataWindow.valueWindow;
        this._percentWindow = dataWindow.percentWindow;
        // Update axis setting then.
        this._setAxisModel();
    };
    AxisProxy.prototype.filterData = function(dataZoomModel, api) {
        if (dataZoomModel !== this._dataZoomModel) return;
        var axisDim = this._dimName;
        var seriesModels = this.getTargetSeriesModels();
        var filterMode = dataZoomModel.get("filterMode");
        var valueWindow = this._valueWindow;
        if (filterMode === "none") return;
        // FIXME
        // Toolbox may has dataZoom injected. And if there are stacked bar chart
        // with NaN data, NaN will be filtered and stack will be wrong.
        // So we need to force the mode to be set empty.
        // In fect, it is not a big deal that do not support filterMode-'filter'
        // when using toolbox#dataZoom, utill tooltip#dataZoom support "single axis
        // selection" some day, which might need "adapt to data extent on the
        // otherAxis", which is disabled by filterMode-'empty'.
        // But currently, stack has been fixed to based on value but not index,
        // so this is not an issue any more.
        // let otherAxisModel = this.getOtherAxisModel();
        // if (dataZoomModel.get('$fromToolbox')
        //     && otherAxisModel
        //     && otherAxisModel.hasSeriesStacked
        // ) {
        //     filterMode = 'empty';
        // }
        // TODO
        // filterMode 'weakFilter' and 'empty' is not optimized for huge data yet.
        $06639d6035d20694$var$each(seriesModels, function(seriesModel) {
            var seriesData = seriesModel.getData();
            var dataDims = seriesData.mapDimensionsAll(axisDim);
            if (!dataDims.length) return;
            if (filterMode === "weakFilter") {
                var store_1 = seriesData.getStore();
                var dataDimIndices_1 = $7a1bd9c2710fea0d$export$871de8747c9eaa88(dataDims, function(dim) {
                    return seriesData.getDimensionIndex(dim);
                }, seriesData);
                seriesData.filterSelf(function(dataIndex) {
                    var leftOut;
                    var rightOut;
                    var hasValue;
                    for(var i = 0; i < dataDims.length; i++){
                        var value = store_1.get(dataDimIndices_1[i], dataIndex);
                        var thisHasValue = !isNaN(value);
                        var thisLeftOut = value < valueWindow[0];
                        var thisRightOut = value > valueWindow[1];
                        if (thisHasValue && !thisLeftOut && !thisRightOut) return true;
                        thisHasValue && (hasValue = true);
                        thisLeftOut && (leftOut = true);
                        thisRightOut && (rightOut = true);
                    }
                    // If both left out and right out, do not filter.
                    return hasValue && leftOut && rightOut;
                });
            } else $06639d6035d20694$var$each(dataDims, function(dim) {
                if (filterMode === "empty") seriesModel.setData(seriesData = seriesData.map(dim, function(value) {
                    return !isInWindow(value) ? NaN : value;
                }));
                else {
                    var range = {};
                    range[dim] = valueWindow;
                    // console.time('select');
                    seriesData.selectRange(range);
                // console.timeEnd('select');
                }
            });
            $06639d6035d20694$var$each(dataDims, function(dim) {
                seriesData.setApproximateExtent(valueWindow, dim);
            });
        });
        function isInWindow(value) {
            return value >= valueWindow[0] && value <= valueWindow[1];
        }
    };
    AxisProxy.prototype._updateMinMaxSpan = function() {
        var minMaxSpan = this._minMaxSpan = {};
        var dataZoomModel = this._dataZoomModel;
        var dataExtent = this._dataExtent;
        $06639d6035d20694$var$each([
            "min",
            "max"
        ], function(minMax) {
            var percentSpan = dataZoomModel.get(minMax + "Span");
            var valueSpan = dataZoomModel.get(minMax + "ValueSpan");
            valueSpan != null && (valueSpan = this.getAxisModel().axis.scale.parse(valueSpan));
            // minValueSpan and maxValueSpan has higher priority than minSpan and maxSpan
            if (valueSpan != null) percentSpan = $cfc1f3b422a3185f$export$d3f68fbaa670562(dataExtent[0] + valueSpan, dataExtent, [
                0,
                100
            ], true);
            else if (percentSpan != null) valueSpan = $cfc1f3b422a3185f$export$d3f68fbaa670562(percentSpan, [
                0,
                100
            ], dataExtent, true) - dataExtent[0];
            minMaxSpan[minMax + "Span"] = percentSpan;
            minMaxSpan[minMax + "ValueSpan"] = valueSpan;
        }, this);
    };
    AxisProxy.prototype._setAxisModel = function() {
        var axisModel = this.getAxisModel();
        var percentWindow = this._percentWindow;
        var valueWindow = this._valueWindow;
        if (!percentWindow) return;
        // [0, 500]: arbitrary value, guess axis extent.
        var precision = $cfc1f3b422a3185f$export$666260d9a2dda8a7(valueWindow, [
            0,
            500
        ]);
        precision = Math.min(precision, 20);
        // For value axis, if min/max/scale are not set, we just use the extent obtained
        // by series data, which may be a little different from the extent calculated by
        // `axisHelper.getScaleExtent`. But the different just affects the experience a
        // little when zooming. So it will not be fixed until some users require it strongly.
        var rawExtentInfo = axisModel.axis.scale.rawExtentInfo;
        if (percentWindow[0] !== 0) rawExtentInfo.setDeterminedMinMax("min", +valueWindow[0].toFixed(precision));
        if (percentWindow[1] !== 100) rawExtentInfo.setDeterminedMinMax("max", +valueWindow[1].toFixed(precision));
        rawExtentInfo.freeze();
    };
    return AxisProxy;
}();
function $06639d6035d20694$var$calculateDataExtent(axisProxy, axisDim, seriesModels) {
    var dataExtent = [
        Infinity,
        -Infinity
    ];
    $06639d6035d20694$var$each(seriesModels, function(seriesModel) {
        (0, $2d646e51cc34f840$export$635fe7f20d0f4c70)(dataExtent, seriesModel.getData(), axisDim);
    });
    // It is important to get "consistent" extent when more then one axes is
    // controlled by a `dataZoom`, otherwise those axes will not be synchronized
    // when zooming. But it is difficult to know what is "consistent", considering
    // axes have different type or even different meanings (For example, two
    // time axes are used to compare data of the same date in different years).
    // So basically dataZoom just obtains extent by series.data (in category axis
    // extent can be obtained from axis.data).
    // Nevertheless, user can set min/max/scale on axes to make extent of axes
    // consistent.
    var axisModel = axisProxy.getAxisModel();
    var rawExtentResult = (0, $483be9695e74220c$export$5c3dbcbeb9ce7f5a)(axisModel.axis.scale, axisModel, dataExtent).calculate();
    return [
        rawExtentResult.min,
        rawExtentResult.max
    ];
}
var $06639d6035d20694$export$2e2bcd8739ae039 = $06639d6035d20694$var$AxisProxy;


var $e1090934575f11ee$var$dataZoomProcessor = {
    // `dataZoomProcessor` will only be performed in needed series. Consider if
    // there is a line series and a pie series, it is better not to update the
    // line series if only pie series is needed to be updated.
    getTargetSeries: function(ecModel) {
        function eachAxisModel(cb) {
            ecModel.eachComponent("dataZoom", function(dataZoomModel) {
                dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
                    var axisModel = ecModel.getComponent((0, $554cb472ba0e05d3$export$90855f7219399082)(axisDim), axisIndex);
                    cb(axisDim, axisIndex, axisModel, dataZoomModel);
                });
            });
        }
        // FIXME: it brings side-effect to `getTargetSeries`.
        // Prepare axis proxies.
        eachAxisModel(function(axisDim, axisIndex, axisModel, dataZoomModel) {
            // dispose all last axis proxy, in case that some axis are deleted.
            axisModel.__dzAxisProxy = null;
        });
        var proxyList = [];
        eachAxisModel(function(axisDim, axisIndex, axisModel, dataZoomModel) {
            // Different dataZooms may constrol the same axis. In that case,
            // an axisProxy serves both of them.
            if (!axisModel.__dzAxisProxy) {
                // Use the first dataZoomModel as the main model of axisProxy.
                axisModel.__dzAxisProxy = new (0, $06639d6035d20694$export$2e2bcd8739ae039)(axisDim, axisIndex, dataZoomModel, ecModel);
                proxyList.push(axisModel.__dzAxisProxy);
            }
        });
        var seriesModelMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(proxyList, function(axisProxy) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisProxy.getTargetSeriesModels(), function(seriesModel) {
                seriesModelMap.set(seriesModel.uid, seriesModel);
            });
        });
        return seriesModelMap;
    },
    // Consider appendData, where filter should be performed. Because data process is
    // in block mode currently, it is not need to worry about that the overallProgress
    // execute every frame.
    overallReset: function(ecModel, api) {
        ecModel.eachComponent("dataZoom", function(dataZoomModel) {
            // We calculate window and reset axis here but not in model
            // init stage and not after action dispatch handler, because
            // reset should be called after seriesData.restoreData.
            dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
                dataZoomModel.getAxisProxy(axisDim, axisIndex).reset(dataZoomModel);
            });
            // Caution: data zoom filtering is order sensitive when using
            // percent range and no min/max/scale set on axis.
            // For example, we have dataZoom definition:
            // [
            //      {xAxisIndex: 0, start: 30, end: 70},
            //      {yAxisIndex: 0, start: 20, end: 80}
            // ]
            // In this case, [20, 80] of y-dataZoom should be based on data
            // that have filtered by x-dataZoom using range of [30, 70],
            // but should not be based on full raw data. Thus sliding
            // x-dataZoom will change both ranges of xAxis and yAxis,
            // while sliding y-dataZoom will only change the range of yAxis.
            // So we should filter x-axis after reset x-axis immediately,
            // and then reset y-axis and filter y-axis.
            dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
                dataZoomModel.getAxisProxy(axisDim, axisIndex).filterData(dataZoomModel, api);
            });
        });
        ecModel.eachComponent("dataZoom", function(dataZoomModel) {
            // Fullfill all of the range props so that user
            // is able to get them from chart.getOption().
            var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
            if (axisProxy) {
                var percentRange = axisProxy.getDataPercentWindow();
                var valueRange = axisProxy.getDataValueWindow();
                dataZoomModel.setCalculatedRange({
                    start: percentRange[0],
                    end: percentRange[1],
                    startValue: valueRange[0],
                    endValue: valueRange[1]
                });
            }
        });
    }
};
var $e1090934575f11ee$export$2e2bcd8739ae039 = $e1090934575f11ee$var$dataZoomProcessor;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $de61ff13130c6dae$export$2e2bcd8739ae039(registers) {
    registers.registerAction("dataZoom", function(payload, ecModel) {
        var effectedModels = (0, $554cb472ba0e05d3$export$9e00b6c2b8b2e9a7)(ecModel, payload);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(effectedModels, function(dataZoomModel) {
            dataZoomModel.setRawRange({
                start: payload.start,
                end: payload.end,
                startValue: payload.startValue,
                endValue: payload.endValue
            });
        });
    });
}


var $8904ef10f452e35c$var$installed = false;
function $8904ef10f452e35c$export$2e2bcd8739ae039(registers) {
    if ($8904ef10f452e35c$var$installed) return;
    $8904ef10f452e35c$var$installed = true;
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.FILTER, (0, $e1090934575f11ee$export$2e2bcd8739ae039));
    (0, $de61ff13130c6dae$export$2e2bcd8739ae039)(registers);
    registers.registerSubTypeDefaulter("dataZoom", function() {
        // Default 'slider' when no type specified.
        return "slider";
    });
}


function $b5ee445cd897e37a$export$4b3e715f166fdd78(registers) {
    (0, $8904ef10f452e35c$export$2e2bcd8739ae039)(registers);
    registers.registerComponentModel((0, $6cccca1a1040a7a1$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $ad4d16a462c12aaf$export$2e2bcd8739ae039));
    (0, $6379ab7b9c3fbfb6$export$f3632ddafc9ea51e)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $8fa9b5e71c234965$var$SliderZoomModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SliderZoomModel, _super);
    function SliderZoomModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SliderZoomModel.type;
        return _this;
    }
    SliderZoomModel.type = "dataZoom.slider";
    SliderZoomModel.layoutMode = "box";
    SliderZoomModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $41d57478d16bff21$export$2e2bcd8739ae039).defaultOption, {
        show: true,
        // deault value can only be drived in view stage.
        right: "ph",
        top: "ph",
        width: "ph",
        height: "ph",
        left: null,
        bottom: null,
        borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent10,
        borderRadius: 0,
        backgroundColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.transparent,
        // dataBackgroundColor: '#ddd',
        dataBackground: {
            lineStyle: {
                color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent30,
                width: 0.5
            },
            areaStyle: {
                color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent20,
                opacity: 0.2
            }
        },
        selectedDataBackground: {
            lineStyle: {
                color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent40,
                width: 0.5
            },
            areaStyle: {
                color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent20,
                opacity: 0.3
            }
        },
        // Color of selected window.
        fillerColor: "rgba(135,175,274,0.2)",
        handleIcon: "path://M-9.35,34.56V42m0-40V9.5m-2,0h4a2,2,0,0,1,2,2v21a2,2,0,0,1-2,2h-4a2,2,0,0,1-2-2v-21A2,2,0,0,1-11.35,9.5Z",
        // Percent of the slider height
        handleSize: "100%",
        handleStyle: {
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral00,
            borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent20
        },
        moveHandleSize: 7,
        moveHandleIcon: "path://M-320.9-50L-320.9-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-348-41-339-50-320.9-50z M-212.3-50L-212.3-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-239.4-41-230.4-50-212.3-50z M-103.7-50L-103.7-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-130.9-41-121.8-50-103.7-50z",
        moveHandleStyle: {
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent40,
            opacity: 0.5
        },
        showDetail: true,
        showDataShadow: "auto",
        realtime: true,
        zoomLock: false,
        textStyle: {
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.tertiary
        },
        brushSelect: true,
        brushStyle: {
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent30,
            opacity: 0.3
        },
        emphasis: {
            handleLabel: {
                show: true
            },
            handleStyle: {
                borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent40
            },
            moveHandleStyle: {
                opacity: 0.8
            }
        },
        defaultLocationEdgeGap: 15
    });
    return SliderZoomModel;
}((0, $41d57478d16bff21$export$2e2bcd8739ae039));
var $8fa9b5e71c234965$export$2e2bcd8739ae039 = $8fa9b5e71c234965$var$SliderZoomModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 














var $eee50458c1b708ef$var$Rect = $419e5ff2f303755e$export$2e2bcd8739ae039;
// Constants
var $eee50458c1b708ef$var$DEFAULT_FRAME_BORDER_WIDTH = 1;
var $eee50458c1b708ef$var$DEFAULT_FILLER_SIZE = 30;
var $eee50458c1b708ef$var$DEFAULT_MOVE_HANDLE_SIZE = 7;
var $eee50458c1b708ef$var$HORIZONTAL = "horizontal";
var $eee50458c1b708ef$var$VERTICAL = "vertical";
var $eee50458c1b708ef$var$LABEL_GAP = 5;
var $eee50458c1b708ef$var$SHOW_DATA_SHADOW_SERIES_TYPE = [
    "line",
    "bar",
    "candlestick",
    "scatter"
];
var $eee50458c1b708ef$var$REALTIME_ANIMATION_CONFIG = {
    easing: "cubicOut",
    duration: 100,
    delay: 0
};
var $eee50458c1b708ef$var$SliderZoomView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SliderZoomView, _super);
    function SliderZoomView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SliderZoomView.type;
        _this._displayables = {};
        return _this;
    }
    SliderZoomView.prototype.init = function(ecModel, api) {
        this.api = api;
        // A unique handler for each dataZoom component
        this._onBrush = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onBrush, this);
        this._onBrushEnd = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onBrushEnd, this);
    };
    SliderZoomView.prototype.render = function(dataZoomModel, ecModel, api, payload) {
        _super.prototype.render.apply(this, arguments);
        $c98659a9437a3d2e$export$958e3e1a02eac4b6(this, "_dispatchZoomAction", dataZoomModel.get("throttle"), "fixRate");
        this._orient = dataZoomModel.getOrient();
        if (dataZoomModel.get("show") === false) {
            this.group.removeAll();
            return;
        }
        if (dataZoomModel.noTarget()) {
            this._clear();
            this.group.removeAll();
            return;
        }
        // Notice: this._resetInterval() should not be executed when payload.type
        // is 'dataZoom', origin this._range should be maintained, otherwise 'pan'
        // or 'zoom' info will be missed because of 'throttle' of this.dispatchAction,
        if (!payload || payload.type !== "dataZoom" || payload.from !== this.uid) this._buildView();
        this._updateView();
    };
    SliderZoomView.prototype.dispose = function() {
        this._clear();
        _super.prototype.dispose.apply(this, arguments);
    };
    SliderZoomView.prototype._clear = function() {
        $c98659a9437a3d2e$export$42ffd38884aecdac(this, "_dispatchZoomAction");
        var zr = this.api.getZr();
        zr.off("mousemove", this._onBrush);
        zr.off("mouseup", this._onBrushEnd);
    };
    SliderZoomView.prototype._buildView = function() {
        var thisGroup = this.group;
        thisGroup.removeAll();
        this._brushing = false;
        this._displayables.brushRect = null;
        this._resetLocation();
        this._resetInterval();
        var barGroup = this._displayables.sliderGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this._renderBackground();
        this._renderHandle();
        this._renderDataShadow();
        thisGroup.add(barGroup);
        this._positionGroup();
    };
    SliderZoomView.prototype._resetLocation = function() {
        var dataZoomModel = this.dataZoomModel;
        var api = this.api;
        var showMoveHandle = dataZoomModel.get("brushSelect");
        var moveHandleSize = showMoveHandle ? $eee50458c1b708ef$var$DEFAULT_MOVE_HANDLE_SIZE : 0;
        var refContainer = $93b9bc7f22ac7369$export$5aec1e94f566e59f(dataZoomModel, api).refContainer;
        // If some of x/y/width/height are not specified,
        // auto-adapt according to target grid.
        var coordRect = this._findCoordRect();
        var edgeGap = dataZoomModel.get("defaultLocationEdgeGap", true) || 0;
        // Default align by coordinate system rect.
        var positionInfo = this._orient === $eee50458c1b708ef$var$HORIZONTAL ? {
            // Why using 'right', because right should be used in vertical,
            // and it is better to be consistent for dealing with position param merge.
            right: refContainer.width - coordRect.x - coordRect.width,
            top: refContainer.height - $eee50458c1b708ef$var$DEFAULT_FILLER_SIZE - edgeGap - moveHandleSize,
            width: coordRect.width,
            height: $eee50458c1b708ef$var$DEFAULT_FILLER_SIZE
        } : {
            right: edgeGap,
            top: coordRect.y,
            width: $eee50458c1b708ef$var$DEFAULT_FILLER_SIZE,
            height: coordRect.height
        };
        // Do not write back to option and replace value 'ph', because
        // the 'ph' value should be recalculated when resize.
        var layoutParams = $93b9bc7f22ac7369$export$4b0d20af19c9875e(dataZoomModel.option);
        // Replace the placeholder value.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            "right",
            "top",
            "width",
            "height"
        ], function(name) {
            if (layoutParams[name] === "ph") layoutParams[name] = positionInfo[name];
        });
        var layoutRect = $93b9bc7f22ac7369$export$4517a5ca639a7293(layoutParams, refContainer);
        this._location = {
            x: layoutRect.x,
            y: layoutRect.y
        };
        this._size = [
            layoutRect.width,
            layoutRect.height
        ];
        this._orient === $eee50458c1b708ef$var$VERTICAL && this._size.reverse();
    };
    SliderZoomView.prototype._positionGroup = function() {
        var thisGroup = this.group;
        var location = this._location;
        var orient = this._orient;
        // Just use the first axis to determine mapping.
        var targetAxisModel = this.dataZoomModel.getFirstTargetAxisModel();
        var inverse = targetAxisModel && targetAxisModel.get("inverse");
        var sliderGroup = this._displayables.sliderGroup;
        var otherAxisInverse = (this._dataShadowInfo || {}).otherAxisInverse;
        // Transform barGroup.
        sliderGroup.attr(orient === $eee50458c1b708ef$var$HORIZONTAL && !inverse ? {
            scaleY: otherAxisInverse ? 1 : -1,
            scaleX: 1
        } : orient === $eee50458c1b708ef$var$HORIZONTAL && inverse ? {
            scaleY: otherAxisInverse ? 1 : -1,
            scaleX: -1
        } : orient === $eee50458c1b708ef$var$VERTICAL && !inverse ? {
            scaleY: otherAxisInverse ? -1 : 1,
            scaleX: 1,
            rotation: Math.PI / 2
        } : {
            scaleY: otherAxisInverse ? -1 : 1,
            scaleX: -1,
            rotation: Math.PI / 2
        });
        // Position barGroup
        var rect = thisGroup.getBoundingRect([
            sliderGroup
        ]);
        thisGroup.x = location.x - rect.x;
        thisGroup.y = location.y - rect.y;
        thisGroup.markRedraw();
    };
    SliderZoomView.prototype._getViewExtent = function() {
        return [
            0,
            this._size[0]
        ];
    };
    SliderZoomView.prototype._renderBackground = function() {
        var dataZoomModel = this.dataZoomModel;
        var size = this._size;
        var barGroup = this._displayables.sliderGroup;
        var brushSelect = dataZoomModel.get("brushSelect");
        barGroup.add(new $eee50458c1b708ef$var$Rect({
            silent: true,
            shape: {
                x: 0,
                y: 0,
                width: size[0],
                height: size[1]
            },
            style: {
                fill: dataZoomModel.get("backgroundColor")
            },
            z2: -40
        }));
        // Click panel, over shadow, below handles.
        var clickPanel = new $eee50458c1b708ef$var$Rect({
            shape: {
                x: 0,
                y: 0,
                width: size[0],
                height: size[1]
            },
            style: {
                fill: "transparent"
            },
            z2: 0,
            onclick: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onClickPanel, this)
        });
        var zr = this.api.getZr();
        if (brushSelect) {
            clickPanel.on("mousedown", this._onBrushStart, this);
            clickPanel.cursor = "crosshair";
            zr.on("mousemove", this._onBrush);
            zr.on("mouseup", this._onBrushEnd);
        } else {
            zr.off("mousemove", this._onBrush);
            zr.off("mouseup", this._onBrushEnd);
        }
        barGroup.add(clickPanel);
    };
    SliderZoomView.prototype._renderDataShadow = function() {
        var info = this._dataShadowInfo = this._prepareDataShadowInfo();
        this._displayables.dataShadowSegs = [];
        if (!info) return;
        var size = this._size;
        var oldSize = this._shadowSize || [];
        var seriesModel = info.series;
        var data = seriesModel.getRawData();
        var candlestickDim = seriesModel.getShadowDim && seriesModel.getShadowDim();
        var otherDim = candlestickDim && data.getDimensionInfo(candlestickDim) ? seriesModel.getShadowDim() // @see candlestick
         : info.otherDim;
        if (otherDim == null) return;
        var polygonPts = this._shadowPolygonPts;
        var polylinePts = this._shadowPolylinePts;
        // Not re-render if data doesn't change.
        if (data !== this._shadowData || otherDim !== this._shadowDim || size[0] !== oldSize[0] || size[1] !== oldSize[1]) {
            var thisDataExtent_1 = data.getDataExtent(info.thisDim);
            var otherDataExtent_1 = data.getDataExtent(otherDim);
            // Nice extent.
            var otherOffset = (otherDataExtent_1[1] - otherDataExtent_1[0]) * 0.3;
            otherDataExtent_1 = [
                otherDataExtent_1[0] - otherOffset,
                otherDataExtent_1[1] + otherOffset
            ];
            var otherShadowExtent_1 = [
                0,
                size[1]
            ];
            var thisShadowExtent = [
                0,
                size[0]
            ];
            var areaPoints_1 = [
                [
                    size[0],
                    0
                ],
                [
                    0,
                    0
                ]
            ];
            var linePoints_1 = [];
            var step_1 = thisShadowExtent[1] / Math.max(1, data.count() - 1);
            var normalizationConstant_1 = size[0] / (thisDataExtent_1[1] - thisDataExtent_1[0]);
            var isTimeAxis_1 = info.thisAxis.type === "time";
            var thisCoord_1 = -step_1;
            // Optimize for large data shadow
            var stride_1 = Math.round(data.count() / size[0]);
            var lastIsEmpty_1;
            data.each([
                info.thisDim,
                otherDim
            ], function(thisValue, otherValue, index) {
                if (stride_1 > 0 && index % stride_1) {
                    if (!isTimeAxis_1) thisCoord_1 += step_1;
                    return;
                }
                thisCoord_1 = isTimeAxis_1 ? (+thisValue - thisDataExtent_1[0]) * normalizationConstant_1 : thisCoord_1 + step_1;
                // FIXME
                // Should consider axis.min/axis.max when drawing dataShadow.
                // FIXME
                // 应该使用统一的空判断？还是在list里进行空判断？
                var isEmpty = otherValue == null || isNaN(otherValue) || otherValue === "";
                // See #4235.
                var otherCoord = isEmpty ? 0 : (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(otherValue, otherDataExtent_1, otherShadowExtent_1, true);
                // Attempt to draw data shadow precisely when there are empty value.
                if (isEmpty && !lastIsEmpty_1 && index) {
                    areaPoints_1.push([
                        areaPoints_1[areaPoints_1.length - 1][0],
                        0
                    ]);
                    linePoints_1.push([
                        linePoints_1[linePoints_1.length - 1][0],
                        0
                    ]);
                } else if (!isEmpty && lastIsEmpty_1) {
                    areaPoints_1.push([
                        thisCoord_1,
                        0
                    ]);
                    linePoints_1.push([
                        thisCoord_1,
                        0
                    ]);
                }
                if (!isEmpty) {
                    areaPoints_1.push([
                        thisCoord_1,
                        otherCoord
                    ]);
                    linePoints_1.push([
                        thisCoord_1,
                        otherCoord
                    ]);
                }
                lastIsEmpty_1 = isEmpty;
            });
            polygonPts = this._shadowPolygonPts = areaPoints_1;
            polylinePts = this._shadowPolylinePts = linePoints_1;
        }
        this._shadowData = data;
        this._shadowDim = otherDim;
        this._shadowSize = [
            size[0],
            size[1]
        ];
        var dataZoomModel = this.dataZoomModel;
        function createDataShadowGroup(isSelectedArea) {
            var model = dataZoomModel.getModel(isSelectedArea ? "selectedDataBackground" : "dataBackground");
            var group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
            var polygon = new $51acf033123e1a30$export$2e2bcd8739ae039({
                shape: {
                    points: polygonPts
                },
                segmentIgnoreThreshold: 1,
                style: model.getModel("areaStyle").getAreaStyle(),
                silent: true,
                z2: -20
            });
            var polyline = new $d28119f30e6bb670$export$2e2bcd8739ae039({
                shape: {
                    points: polylinePts
                },
                segmentIgnoreThreshold: 1,
                style: model.getModel("lineStyle").getLineStyle(),
                silent: true,
                z2: -19
            });
            group.add(polygon);
            group.add(polyline);
            return group;
        }
        // let dataBackgroundModel = dataZoomModel.getModel('dataBackground');
        for(var i = 0; i < 3; i++){
            var group = createDataShadowGroup(i === 1);
            this._displayables.sliderGroup.add(group);
            this._displayables.dataShadowSegs.push(group);
        }
    };
    SliderZoomView.prototype._prepareDataShadowInfo = function() {
        var dataZoomModel = this.dataZoomModel;
        var showDataShadow = dataZoomModel.get("showDataShadow");
        if (showDataShadow === false) return;
        // Find a representative series.
        var result;
        var ecModel = this.ecModel;
        dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
            var seriesModels = dataZoomModel.getAxisProxy(axisDim, axisIndex).getTargetSeriesModels();
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(seriesModels, function(seriesModel) {
                if (result) return;
                if (showDataShadow !== true && (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)($eee50458c1b708ef$var$SHOW_DATA_SHADOW_SERIES_TYPE, seriesModel.get("type")) < 0) return;
                var thisAxis = ecModel.getComponent((0, $554cb472ba0e05d3$export$90855f7219399082)(axisDim), axisIndex).axis;
                var otherDim = $eee50458c1b708ef$var$getOtherDim(axisDim);
                var otherAxisInverse;
                var coordSys = seriesModel.coordinateSystem;
                if (otherDim != null && coordSys.getOtherAxis) otherAxisInverse = coordSys.getOtherAxis(thisAxis).inverse;
                otherDim = seriesModel.getData().mapDimension(otherDim);
                var thisDim = seriesModel.getData().mapDimension(axisDim);
                result = {
                    thisAxis: thisAxis,
                    series: seriesModel,
                    thisDim: thisDim,
                    otherDim: otherDim,
                    otherAxisInverse: otherAxisInverse
                };
            }, this);
        }, this);
        return result;
    };
    SliderZoomView.prototype._renderHandle = function() {
        var thisGroup = this.group;
        var displayables = this._displayables;
        var handles = displayables.handles = [
            null,
            null
        ];
        var handleLabels = displayables.handleLabels = [
            null,
            null
        ];
        var sliderGroup = this._displayables.sliderGroup;
        var size = this._size;
        var dataZoomModel = this.dataZoomModel;
        var api = this.api;
        var borderRadius = dataZoomModel.get("borderRadius") || 0;
        var brushSelect = dataZoomModel.get("brushSelect");
        var filler = displayables.filler = new $eee50458c1b708ef$var$Rect({
            silent: brushSelect,
            style: {
                fill: dataZoomModel.get("fillerColor")
            },
            textConfig: {
                position: "inside"
            }
        });
        sliderGroup.add(filler);
        // Frame border.
        sliderGroup.add(new $eee50458c1b708ef$var$Rect({
            silent: true,
            subPixelOptimize: true,
            shape: {
                x: 0,
                y: 0,
                width: size[0],
                height: size[1],
                r: borderRadius
            },
            style: {
                // deprecated option
                stroke: dataZoomModel.get("dataBackgroundColor") || dataZoomModel.get("borderColor"),
                lineWidth: $eee50458c1b708ef$var$DEFAULT_FRAME_BORDER_WIDTH,
                fill: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.transparent
            }
        }));
        // Left and right handle to resize
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            0,
            1
        ], function(handleIndex) {
            var iconStr = dataZoomModel.get("handleIcon");
            if (!(0, $5370466dadc978d7$export$33fc3b478d332725)[iconStr] && iconStr.indexOf("path://") < 0 && iconStr.indexOf("image://") < 0) // Compatitable with the old icon parsers. Which can use a path string without path://
            iconStr = "path://" + iconStr;
            var path = (0, $5370466dadc978d7$export$af050e04da3a02e8)(iconStr, -1, 0, 2, 2, null, true);
            path.attr({
                cursor: $eee50458c1b708ef$var$getCursor(this._orient),
                draggable: true,
                drift: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onDragMove, this, handleIndex),
                ondragend: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onDragEnd, this),
                onmouseover: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._showDataInfo, this, true),
                onmouseout: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._showDataInfo, this, false),
                z2: 5
            });
            var bRect = path.getBoundingRect();
            var handleSize = dataZoomModel.get("handleSize");
            this._handleHeight = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(handleSize, this._size[1]);
            this._handleWidth = bRect.width / bRect.height * this._handleHeight;
            path.setStyle(dataZoomModel.getModel("handleStyle").getItemStyle());
            path.style.strokeNoScale = true;
            path.rectHover = true;
            path.ensureState("emphasis").style = dataZoomModel.getModel([
                "emphasis",
                "handleStyle"
            ]).getItemStyle();
            (0, $2bf82c0980125b62$export$5f393df0b5aee2e7)(path);
            var handleColor = dataZoomModel.get("handleColor"); // deprecated option
            // Compatitable with previous version
            if (handleColor != null) path.style.fill = handleColor;
            sliderGroup.add(handles[handleIndex] = path);
            var textStyleModel = dataZoomModel.getModel("textStyle");
            var handleLabel = dataZoomModel.get("handleLabel") || {};
            var handleLabelShow = handleLabel.show || false;
            thisGroup.add(handleLabels[handleIndex] = new $fe885cc21795562b$export$2e2bcd8739ae039({
                silent: true,
                invisible: !handleLabelShow,
                style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                    x: 0,
                    y: 0,
                    text: "",
                    verticalAlign: "middle",
                    align: "center",
                    fill: textStyleModel.getTextColor(),
                    font: textStyleModel.getFont()
                }),
                z2: 10
            }));
        }, this);
        // Handle to move. Only visible when brushSelect is set true.
        var actualMoveZone = filler;
        if (brushSelect) {
            var moveHandleHeight = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(dataZoomModel.get("moveHandleSize"), size[1]);
            var moveHandle_1 = displayables.moveHandle = new $419e5ff2f303755e$export$2e2bcd8739ae039({
                style: dataZoomModel.getModel("moveHandleStyle").getItemStyle(),
                silent: true,
                shape: {
                    r: [
                        0,
                        0,
                        2,
                        2
                    ],
                    y: size[1] - 0.5,
                    height: moveHandleHeight
                }
            });
            var iconSize = moveHandleHeight * 0.8;
            var moveHandleIcon = displayables.moveHandleIcon = (0, $5370466dadc978d7$export$af050e04da3a02e8)(dataZoomModel.get("moveHandleIcon"), -iconSize / 2, -iconSize / 2, iconSize, iconSize, (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral00, true);
            moveHandleIcon.silent = true;
            moveHandleIcon.y = size[1] + moveHandleHeight / 2 - 0.5;
            moveHandle_1.ensureState("emphasis").style = dataZoomModel.getModel([
                "emphasis",
                "moveHandleStyle"
            ]).getItemStyle();
            var moveZoneExpandSize = Math.min(size[1] / 2, Math.max(moveHandleHeight, 10));
            actualMoveZone = displayables.moveZone = new $419e5ff2f303755e$export$2e2bcd8739ae039({
                invisible: true,
                shape: {
                    y: size[1] - moveZoneExpandSize,
                    height: moveHandleHeight + moveZoneExpandSize
                }
            });
            actualMoveZone.on("mouseover", function() {
                api.enterEmphasis(moveHandle_1);
            }).on("mouseout", function() {
                api.leaveEmphasis(moveHandle_1);
            });
            sliderGroup.add(moveHandle_1);
            sliderGroup.add(moveHandleIcon);
            sliderGroup.add(actualMoveZone);
        }
        actualMoveZone.attr({
            draggable: true,
            cursor: "default",
            drift: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onDragMove, this, "all"),
            ondragstart: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._showDataInfo, this, true),
            ondragend: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onDragEnd, this),
            onmouseover: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._showDataInfo, this, true),
            onmouseout: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._showDataInfo, this, false)
        });
    };
    SliderZoomView.prototype._resetInterval = function() {
        var range = this._range = this.dataZoomModel.getPercentRange();
        var viewExtent = this._getViewExtent();
        this._handleEnds = [
            (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(range[0], [
                0,
                100
            ], viewExtent, true),
            (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(range[1], [
                0,
                100
            ], viewExtent, true)
        ];
    };
    SliderZoomView.prototype._updateInterval = function(handleIndex, delta) {
        var dataZoomModel = this.dataZoomModel;
        var handleEnds = this._handleEnds;
        var viewExtend = this._getViewExtent();
        var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
        var percentExtent = [
            0,
            100
        ];
        (0, $00a8003b34293330$export$2e2bcd8739ae039)(delta, handleEnds, viewExtend, dataZoomModel.get("zoomLock") ? "all" : handleIndex, minMaxSpan.minSpan != null ? (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(minMaxSpan.minSpan, percentExtent, viewExtend, true) : null, minMaxSpan.maxSpan != null ? (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(minMaxSpan.maxSpan, percentExtent, viewExtend, true) : null);
        var lastRange = this._range;
        var range = this._range = (0, $cfc1f3b422a3185f$export$debe6e778e0a6d32)([
            (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(handleEnds[0], viewExtend, percentExtent, true),
            (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(handleEnds[1], viewExtend, percentExtent, true)
        ]);
        return !lastRange || lastRange[0] !== range[0] || lastRange[1] !== range[1];
    };
    SliderZoomView.prototype._updateView = function(nonRealtime) {
        var displaybles = this._displayables;
        var handleEnds = this._handleEnds;
        var handleInterval = (0, $cfc1f3b422a3185f$export$debe6e778e0a6d32)(handleEnds.slice());
        var size = this._size;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            0,
            1
        ], function(handleIndex) {
            // Handles
            var handle = displaybles.handles[handleIndex];
            var handleHeight = this._handleHeight;
            handle.attr({
                scaleX: handleHeight / 2,
                scaleY: handleHeight / 2,
                // This is a trick, by adding an extra tiny offset to let the default handle's end point align to the drag window.
                // NOTE: It may affect some custom shapes a bit. But we prefer to have better result by default.
                x: handleEnds[handleIndex] + (handleIndex ? -1 : 1),
                y: size[1] / 2 - handleHeight / 2
            });
        }, this);
        // Filler
        displaybles.filler.setShape({
            x: handleInterval[0],
            y: 0,
            width: handleInterval[1] - handleInterval[0],
            height: size[1]
        });
        var viewExtent = {
            x: handleInterval[0],
            width: handleInterval[1] - handleInterval[0]
        };
        // Move handle
        if (displaybles.moveHandle) {
            displaybles.moveHandle.setShape(viewExtent);
            displaybles.moveZone.setShape(viewExtent);
            // Force update path on the invisible object
            displaybles.moveZone.getBoundingRect();
            displaybles.moveHandleIcon && displaybles.moveHandleIcon.attr("x", viewExtent.x + viewExtent.width / 2);
        }
        // update clip path of shadow.
        var dataShadowSegs = displaybles.dataShadowSegs;
        var segIntervals = [
            0,
            handleInterval[0],
            handleInterval[1],
            size[0]
        ];
        for(var i = 0; i < dataShadowSegs.length; i++){
            var segGroup = dataShadowSegs[i];
            var clipPath = segGroup.getClipPath();
            if (!clipPath) {
                clipPath = new $419e5ff2f303755e$export$2e2bcd8739ae039();
                segGroup.setClipPath(clipPath);
            }
            clipPath.setShape({
                x: segIntervals[i],
                y: 0,
                width: segIntervals[i + 1] - segIntervals[i],
                height: size[1]
            });
        }
        this._updateDataInfo(nonRealtime);
    };
    SliderZoomView.prototype._updateDataInfo = function(nonRealtime) {
        var dataZoomModel = this.dataZoomModel;
        var displaybles = this._displayables;
        var handleLabels = displaybles.handleLabels;
        var orient = this._orient;
        var labelTexts = [
            "",
            ""
        ];
        // FIXME
        // date型，支持formatter，autoformatter（ec2 date.getAutoFormatter）
        if (dataZoomModel.get("showDetail")) {
            var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
            if (axisProxy) {
                var axis = axisProxy.getAxisModel().axis;
                var range = this._range;
                var dataInterval = nonRealtime ? axisProxy.calculateDataWindow({
                    start: range[0],
                    end: range[1]
                }).valueWindow : axisProxy.getDataValueWindow();
                labelTexts = [
                    this._formatLabel(dataInterval[0], axis),
                    this._formatLabel(dataInterval[1], axis)
                ];
            }
        }
        var orderedHandleEnds = (0, $cfc1f3b422a3185f$export$debe6e778e0a6d32)(this._handleEnds.slice());
        setLabel.call(this, 0);
        setLabel.call(this, 1);
        function setLabel(handleIndex) {
            // Label
            // Text should not transform by barGroup.
            // Ignore handlers transform
            var barTransform = $5b455ae6f843ac47$export$fce0c6cfca85ed96(displaybles.handles[handleIndex].parent, this.group);
            var direction = $5b455ae6f843ac47$export$fff94e9792354cfa(handleIndex === 0 ? "right" : "left", barTransform);
            var offset = this._handleWidth / 2 + $eee50458c1b708ef$var$LABEL_GAP;
            var textPoint = $5b455ae6f843ac47$export$9f9dcb98c894b623([
                orderedHandleEnds[handleIndex] + (handleIndex === 0 ? -offset : offset),
                this._size[1] / 2
            ], barTransform);
            handleLabels[handleIndex].setStyle({
                x: textPoint[0],
                y: textPoint[1],
                verticalAlign: orient === $eee50458c1b708ef$var$HORIZONTAL ? "middle" : direction,
                align: orient === $eee50458c1b708ef$var$HORIZONTAL ? direction : "center",
                text: labelTexts[handleIndex]
            });
        }
    };
    SliderZoomView.prototype._formatLabel = function(value, axis) {
        var dataZoomModel = this.dataZoomModel;
        var labelFormatter = dataZoomModel.get("labelFormatter");
        var labelPrecision = dataZoomModel.get("labelPrecision");
        if (labelPrecision == null || labelPrecision === "auto") labelPrecision = axis.getPixelPrecision();
        var valueStr = value == null || isNaN(value) ? "" : axis.type === "category" || axis.type === "time" ? axis.scale.getLabel({
            value: Math.round(value)
        }) : value.toFixed(Math.min(labelPrecision, 20));
        return (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(labelFormatter) ? labelFormatter(value, valueStr) : (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(labelFormatter) ? labelFormatter.replace("{value}", valueStr) : valueStr;
    };
    /**
   * @param isEmphasis true: show, false: hide
   */ SliderZoomView.prototype._showDataInfo = function(isEmphasis) {
        var handleLabel = this.dataZoomModel.get("handleLabel") || {};
        var normalShow = handleLabel.show || false;
        var emphasisHandleLabel = this.dataZoomModel.getModel([
            "emphasis",
            "handleLabel"
        ]);
        var emphasisShow = emphasisHandleLabel.get("show") || false;
        // Dragging is considered as emphasis, unless emphasisShow is false
        var toShow = isEmphasis || this._dragging ? emphasisShow : normalShow;
        var displayables = this._displayables;
        var handleLabels = displayables.handleLabels;
        handleLabels[0].attr("invisible", !toShow);
        handleLabels[1].attr("invisible", !toShow);
        // Highlight move handle
        displayables.moveHandle && this.api[toShow ? "enterEmphasis" : "leaveEmphasis"](displayables.moveHandle, 1);
    };
    SliderZoomView.prototype._onDragMove = function(handleIndex, dx, dy, event) {
        this._dragging = true;
        // For mobile device, prevent screen slider on the button.
        $b3864a78637ff9ed$export$fa6813432f753b0d(event.event);
        // Transform dx, dy to bar coordination.
        var barTransform = this._displayables.sliderGroup.getLocalTransform();
        var vertex = $5b455ae6f843ac47$export$9f9dcb98c894b623([
            dx,
            dy
        ], barTransform, true);
        var changed = this._updateInterval(handleIndex, vertex[0]);
        var realtime = this.dataZoomModel.get("realtime");
        this._updateView(!realtime);
        // Avoid dispatch dataZoom repeatly but range not changed,
        // which cause bad visual effect when progressive enabled.
        changed && realtime && this._dispatchZoomAction(true);
    };
    SliderZoomView.prototype._onDragEnd = function() {
        this._dragging = false;
        this._showDataInfo(false);
        // While in realtime mode and stream mode, dispatch action when
        // drag end will cause the whole view rerender, which is unnecessary.
        var realtime = this.dataZoomModel.get("realtime");
        !realtime && this._dispatchZoomAction(false);
    };
    SliderZoomView.prototype._onClickPanel = function(e) {
        var size = this._size;
        var localPoint = this._displayables.sliderGroup.transformCoordToLocal(e.offsetX, e.offsetY);
        if (localPoint[0] < 0 || localPoint[0] > size[0] || localPoint[1] < 0 || localPoint[1] > size[1]) return;
        var handleEnds = this._handleEnds;
        var center = (handleEnds[0] + handleEnds[1]) / 2;
        var changed = this._updateInterval("all", localPoint[0] - center);
        this._updateView();
        changed && this._dispatchZoomAction(false);
    };
    SliderZoomView.prototype._onBrushStart = function(e) {
        var x = e.offsetX;
        var y = e.offsetY;
        this._brushStart = new $b887f038f104fe7e$export$2e2bcd8739ae039(x, y);
        this._brushing = true;
        this._brushStartTime = +new Date();
    // this._updateBrushRect(x, y);
    };
    SliderZoomView.prototype._onBrushEnd = function(e) {
        if (!this._brushing) return;
        var brushRect = this._displayables.brushRect;
        this._brushing = false;
        if (!brushRect) return;
        brushRect.attr("ignore", true);
        var brushShape = brushRect.shape;
        var brushEndTime = +new Date();
        // console.log(brushEndTime - this._brushStartTime);
        if (brushEndTime - this._brushStartTime < 200 && Math.abs(brushShape.width) < 5) // Will treat it as a click
        return;
        var viewExtend = this._getViewExtent();
        var percentExtent = [
            0,
            100
        ];
        var handleEnds = this._handleEnds = [
            brushShape.x,
            brushShape.x + brushShape.width
        ];
        var minMaxSpan = this.dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
        // Restrict range.
        (0, $00a8003b34293330$export$2e2bcd8739ae039)(0, handleEnds, viewExtend, 0, minMaxSpan.minSpan != null ? (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(minMaxSpan.minSpan, percentExtent, viewExtend, true) : null, minMaxSpan.maxSpan != null ? (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(minMaxSpan.maxSpan, percentExtent, viewExtend, true) : null);
        this._range = (0, $cfc1f3b422a3185f$export$debe6e778e0a6d32)([
            (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(handleEnds[0], viewExtend, percentExtent, true),
            (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(handleEnds[1], viewExtend, percentExtent, true)
        ]);
        this._updateView();
        this._dispatchZoomAction(false);
    };
    SliderZoomView.prototype._onBrush = function(e) {
        if (this._brushing) {
            // For mobile device, prevent screen slider on the button.
            $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
            this._updateBrushRect(e.offsetX, e.offsetY);
        }
    };
    SliderZoomView.prototype._updateBrushRect = function(mouseX, mouseY) {
        var displayables = this._displayables;
        var dataZoomModel = this.dataZoomModel;
        var brushRect = displayables.brushRect;
        if (!brushRect) {
            brushRect = displayables.brushRect = new $eee50458c1b708ef$var$Rect({
                silent: true,
                style: dataZoomModel.getModel("brushStyle").getItemStyle()
            });
            displayables.sliderGroup.add(brushRect);
        }
        brushRect.attr("ignore", false);
        var brushStart = this._brushStart;
        var sliderGroup = this._displayables.sliderGroup;
        var endPoint = sliderGroup.transformCoordToLocal(mouseX, mouseY);
        var startPoint = sliderGroup.transformCoordToLocal(brushStart.x, brushStart.y);
        var size = this._size;
        endPoint[0] = Math.max(Math.min(size[0], endPoint[0]), 0);
        brushRect.setShape({
            x: startPoint[0],
            y: 0,
            width: endPoint[0] - startPoint[0],
            height: size[1]
        });
    };
    /**
   * This action will be throttled.
   */ SliderZoomView.prototype._dispatchZoomAction = function(realtime) {
        var range = this._range;
        this.api.dispatchAction({
            type: "dataZoom",
            from: this.uid,
            dataZoomId: this.dataZoomModel.id,
            animation: realtime ? $eee50458c1b708ef$var$REALTIME_ANIMATION_CONFIG : null,
            start: range[0],
            end: range[1]
        });
    };
    SliderZoomView.prototype._findCoordRect = function() {
        // Find the grid corresponding to the first axis referred by dataZoom.
        var rect;
        var coordSysInfoList = (0, $554cb472ba0e05d3$export$b41173dee9da195b)(this.dataZoomModel).infoList;
        if (!rect && coordSysInfoList.length) {
            var coordSys = coordSysInfoList[0].model.coordinateSystem;
            rect = coordSys.getRect && coordSys.getRect();
        }
        if (!rect) {
            var width = this.api.getWidth();
            var height = this.api.getHeight();
            rect = {
                x: width * 0.2,
                y: height * 0.2,
                width: width * 0.6,
                height: height * 0.6
            };
        }
        return rect;
    };
    SliderZoomView.type = "dataZoom.slider";
    return SliderZoomView;
}((0, $80d6a03162f25654$export$2e2bcd8739ae039));
function $eee50458c1b708ef$var$getOtherDim(thisDim) {
    // FIXME
    // 这个逻辑和getOtherAxis里一致，但是写在这里是否不好
    var map = {
        x: "y",
        y: "x",
        radius: "angle",
        angle: "radius"
    };
    return map[thisDim];
}
function $eee50458c1b708ef$var$getCursor(orient) {
    return orient === "vertical" ? "ns-resize" : "ew-resize";
}
var $eee50458c1b708ef$export$2e2bcd8739ae039 = $eee50458c1b708ef$var$SliderZoomView;



function $794c23331e97718e$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $8fa9b5e71c234965$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $eee50458c1b708ef$export$2e2bcd8739ae039));
    (0, $8904ef10f452e35c$export$2e2bcd8739ae039)(registers);
}


function $aa2dc70f9fa9453b$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $b5ee445cd897e37a$export$4b3e715f166fdd78));
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $794c23331e97718e$export$4b3e715f166fdd78));
// Do not install './dataZoomSelect',
// since it only work for toolbox dataZoom.
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




function $21e1121941dbd8a9$export$f6339b3d96c5d3d7(resultItem, newElOption) {
    var existElOption = resultItem.existing;
    // Set id and type after id assigned.
    newElOption.id = resultItem.keyInfo.id;
    !newElOption.type && existElOption && (newElOption.type = existElOption.type);
    // Set parent id if not specified
    if (newElOption.parentId == null) {
        var newElParentOption = newElOption.parentOption;
        if (newElParentOption) newElOption.parentId = newElParentOption.id;
        else if (existElOption) newElOption.parentId = existElOption.parentId;
    }
    // Clear
    newElOption.parentOption = null;
}
function $21e1121941dbd8a9$var$isSetLoc(obj, props) {
    var isSet;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(props, function(prop) {
        obj[prop] != null && obj[prop] !== "auto" && (isSet = true);
    });
    return isSet;
}
function $21e1121941dbd8a9$var$mergeNewElOptionToExist(existList, index, newElOption) {
    // Update existing options, for `getOption` feature.
    var newElOptCopy = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, newElOption);
    var existElOption = existList[index];
    var $action = newElOption.$action || "merge";
    if ($action === "merge") {
        if (existElOption) {
            var newType;
            // We can ensure that newElOptCopy and existElOption are not
            // the same object, so `merge` will not change newElOptCopy.
            $7a1bd9c2710fea0d$export$4950aa0f605343fb(existElOption, newElOptCopy, true);
            // Rigid body, use ignoreSize.
            (0, $93b9bc7f22ac7369$export$1754cb91f16ca028)(existElOption, newElOptCopy, {
                ignoreSize: true
            });
            // Will be used in render.
            (0, $93b9bc7f22ac7369$export$7438999faea9b6cc)(newElOption, existElOption);
            // Copy transition info to new option so it can be used in the transition.
            // DO IT AFTER merge
            $21e1121941dbd8a9$var$copyTransitionInfo(newElOption, existElOption);
            $21e1121941dbd8a9$var$copyTransitionInfo(newElOption, existElOption, "shape");
            $21e1121941dbd8a9$var$copyTransitionInfo(newElOption, existElOption, "style");
            $21e1121941dbd8a9$var$copyTransitionInfo(newElOption, existElOption, "extra");
            // Copy clipPath
            newElOption.clipPath = existElOption.clipPath;
        } else existList[index] = newElOptCopy;
    } else if ($action === "replace") existList[index] = newElOptCopy;
    else if ($action === "remove") // null will be cleaned later.
    existElOption && (existList[index] = null);
}
var $21e1121941dbd8a9$var$TRANSITION_PROPS_TO_COPY = [
    "transition",
    "enterFrom",
    "leaveTo"
];
var $21e1121941dbd8a9$var$ROOT_TRANSITION_PROPS_TO_COPY = $21e1121941dbd8a9$var$TRANSITION_PROPS_TO_COPY.concat([
    "enterAnimation",
    "updateAnimation",
    "leaveAnimation"
]);
function $21e1121941dbd8a9$var$copyTransitionInfo(target, source, targetProp) {
    if (targetProp) {
        if (!target[targetProp] && source[targetProp]) // TODO avoid creating this empty object when there is no transition configuration.
        target[targetProp] = {};
        target = target[targetProp];
        source = source[targetProp];
    }
    if (!target || !source) return;
    var props = targetProp ? $21e1121941dbd8a9$var$TRANSITION_PROPS_TO_COPY : $21e1121941dbd8a9$var$ROOT_TRANSITION_PROPS_TO_COPY;
    for(var i = 0; i < props.length; i++){
        var prop = props[i];
        if (target[prop] == null && source[prop] != null) target[prop] = source[prop];
    }
}
function $21e1121941dbd8a9$var$setLayoutInfoToExist(existItem, newElOption) {
    if (!existItem) return;
    existItem.hv = newElOption.hv = [
        // Rigid body, don't care about `width`.
        $21e1121941dbd8a9$var$isSetLoc(newElOption, [
            "left",
            "right"
        ]),
        // Rigid body, don't care about `height`.
        $21e1121941dbd8a9$var$isSetLoc(newElOption, [
            "top",
            "bottom"
        ])
    ];
    // Give default group size. Otherwise layout error may occur.
    if (existItem.type === "group") {
        var existingGroupOpt = existItem;
        var newGroupOpt = newElOption;
        existingGroupOpt.width == null && (existingGroupOpt.width = newGroupOpt.width = 0);
        existingGroupOpt.height == null && (existingGroupOpt.height = newGroupOpt.height = 0);
    }
}
var $21e1121941dbd8a9$export$6d85925da4d2cf23 = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GraphicComponentModel, _super);
    function GraphicComponentModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GraphicComponentModel.type;
        _this.preventAutoZ = true;
        return _this;
    }
    GraphicComponentModel.prototype.mergeOption = function(option, ecModel) {
        // Prevent default merge to elements
        var elements = this.option.elements;
        this.option.elements = null;
        _super.prototype.mergeOption.call(this, option, ecModel);
        this.option.elements = elements;
    };
    GraphicComponentModel.prototype.optionUpdated = function(newOption, isInit) {
        var thisOption = this.option;
        var newList = (isInit ? thisOption : newOption).elements;
        var existList = thisOption.elements = isInit ? [] : thisOption.elements;
        var flattenedList = [];
        this._flatten(newList, flattenedList, null);
        var mappingResult = $76d619f648247e6d$export$574f818966e4da87(existList, flattenedList, "normalMerge");
        // Clear elOptionsToUpdate
        var elOptionsToUpdate = this._elOptionsToUpdate = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(mappingResult, function(resultItem, index) {
            var newElOption = resultItem.newOption;
            if (!newElOption) return;
            elOptionsToUpdate.push(newElOption);
            $21e1121941dbd8a9$export$f6339b3d96c5d3d7(resultItem, newElOption);
            $21e1121941dbd8a9$var$mergeNewElOptionToExist(existList, index, newElOption);
            $21e1121941dbd8a9$var$setLayoutInfoToExist(existList[index], newElOption);
        }, this);
        // Clean
        thisOption.elements = $7a1bd9c2710fea0d$export$3dea766d36a8935f(existList, function(item) {
            // $action should be volatile, otherwise option gotten from
            // `getOption` will contain unexpected $action.
            item && delete item.$action;
            return item != null;
        });
    };
    /**
   * Convert
   * [{
   *  type: 'group',
   *  id: 'xx',
   *  children: [{type: 'circle'}, {type: 'polygon'}]
   * }]
   * to
   * [
   *  {type: 'group', id: 'xx'},
   *  {type: 'circle', parentId: 'xx'},
   *  {type: 'polygon', parentId: 'xx'}
   * ]
   */ GraphicComponentModel.prototype._flatten = function(optionList, result, parentOption) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(optionList, function(option) {
            if (!option) return;
            if (parentOption) option.parentOption = parentOption;
            result.push(option);
            var children = option.children;
            // here we don't judge if option.type is `group`
            // when new option doesn't provide `type`, it will cause that the children can't be updated.
            if (children && children.length) this._flatten(children, result, option);
            // Deleting for JSON output, and for not affecting group creation.
            delete option.children;
        }, this);
    };
    // FIXME
    // Pass to view using payload? setOption has a payload?
    GraphicComponentModel.prototype.useElOptionsToUpdate = function() {
        var els = this._elOptionsToUpdate;
        // Clear to avoid render duplicately when zooming.
        this._elOptionsToUpdate = null;
        return els;
    };
    GraphicComponentModel.type = "graphic";
    GraphicComponentModel.defaultOption = {
        elements: []
    };
    return GraphicComponentModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 












var $2b680c3ccdb25c77$var$nonShapeGraphicElements = {
    // Reserved but not supported in graphic component.
    path: null,
    compoundPath: null,
    // Supported in graphic component.
    group: $7ef7583d8302ffce$export$2e2bcd8739ae039,
    image: $86adec94217b86c6$export$2e2bcd8739ae039,
    text: $fe885cc21795562b$export$2e2bcd8739ae039
};
var $2b680c3ccdb25c77$export$4ae363f1d88fb658 = $76d619f648247e6d$export$64df9f8d92ae083f();
// ------------------------
// View
// ------------------------
var $2b680c3ccdb25c77$export$1132c9ab9ad80748 = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GraphicComponentView, _super);
    function GraphicComponentView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GraphicComponentView.type;
        return _this;
    }
    GraphicComponentView.prototype.init = function() {
        this._elMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
    };
    GraphicComponentView.prototype.render = function(graphicModel, ecModel, api) {
        // Having leveraged between use cases and algorithm complexity, a very
        // simple layout mechanism is used:
        // The size(width/height) can be determined by itself or its parent (not
        // implemented yet), but can not by its children. (Top-down travel)
        // The location(x/y) can be determined by the bounding rect of itself
        // (can including its descendants or not) and the size of its parent.
        // (Bottom-up travel)
        // When `chart.clear()` or `chart.setOption({...}, true)` with the same id,
        // view will be reused.
        if (graphicModel !== this._lastGraphicModel) this._clear();
        this._lastGraphicModel = graphicModel;
        this._updateElements(graphicModel);
        this._relocate(graphicModel, api);
    };
    /**
   * Update graphic elements.
   */ GraphicComponentView.prototype._updateElements = function(graphicModel) {
        var elOptionsToUpdate = graphicModel.useElOptionsToUpdate();
        if (!elOptionsToUpdate) return;
        var elMap = this._elMap;
        var rootGroup = this.group;
        var globalZ = graphicModel.get("z");
        var globalZLevel = graphicModel.get("zlevel");
        // Top-down tranverse to assign graphic settings to each elements.
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(elOptionsToUpdate, function(elOption) {
            var id = $76d619f648247e6d$export$fb1a222ba5dd6e51(elOption.id, null);
            var elExisting = id != null ? elMap.get(id) : null;
            var parentId = $76d619f648247e6d$export$fb1a222ba5dd6e51(elOption.parentId, null);
            var targetElParent = parentId != null ? elMap.get(parentId) : rootGroup;
            var elType = elOption.type;
            var elOptionStyle = elOption.style;
            if (elType === "text" && elOptionStyle) // In top/bottom mode, textVerticalAlign should not be used, which cause
            // inaccurately locating.
            {
                if (elOption.hv && elOption.hv[1]) elOptionStyle.textVerticalAlign = elOptionStyle.textBaseline = elOptionStyle.verticalAlign = elOptionStyle.align = null;
            }
            var textContentOption = elOption.textContent;
            var textConfig = elOption.textConfig;
            if (elOptionStyle && (0, $daa53642c3afcc30$export$3b868abde5eae7d1)(elOptionStyle, elType, !!textConfig, !!textContentOption)) {
                var convertResult = (0, $daa53642c3afcc30$export$7748133eaaa8aecc)(elOptionStyle, elType, true);
                if (!textConfig && convertResult.textConfig) textConfig = elOption.textConfig = convertResult.textConfig;
                if (!textContentOption && convertResult.textContent) textContentOption = convertResult.textContent;
            }
            // Remove unnecessary props to avoid potential problems.
            var elOptionCleaned = $2b680c3ccdb25c77$var$getCleanedElOption(elOption);
            var $action = elOption.$action || "merge";
            var isMerge = $action === "merge";
            var isReplace = $action === "replace";
            if (isMerge) {
                var isInit = !elExisting;
                var el_1 = elExisting;
                if (isInit) el_1 = $2b680c3ccdb25c77$var$createEl(id, targetElParent, elOption.type, elMap);
                else {
                    el_1 && ($2b680c3ccdb25c77$export$4ae363f1d88fb658(el_1).isNew = false);
                    // Stop and restore before update any other attributes.
                    (0, $ab8d73690f09fb6d$export$9e5c70edf1ec0cb4)(el_1);
                }
                if (el_1) {
                    (0, $7c104376a000308e$export$4342b281b9b5d77e)(el_1, elOptionCleaned, graphicModel, {
                        isInit: isInit
                    });
                    $2b680c3ccdb25c77$var$updateCommonAttrs(el_1, elOption, globalZ, globalZLevel);
                }
            } else if (isReplace) {
                $2b680c3ccdb25c77$var$removeEl(elExisting, elOption, elMap, graphicModel);
                var el_2 = $2b680c3ccdb25c77$var$createEl(id, targetElParent, elOption.type, elMap);
                if (el_2) {
                    (0, $7c104376a000308e$export$4342b281b9b5d77e)(el_2, elOptionCleaned, graphicModel, {
                        isInit: true
                    });
                    $2b680c3ccdb25c77$var$updateCommonAttrs(el_2, elOption, globalZ, globalZLevel);
                }
            } else if ($action === "remove") {
                (0, $7c104376a000308e$export$a6f11bb1cb100e2a)(elExisting, elOption);
                $2b680c3ccdb25c77$var$removeEl(elExisting, elOption, elMap, graphicModel);
            }
            var el = elMap.get(id);
            if (el && textContentOption) {
                if (isMerge) {
                    var textContentExisting = el.getTextContent();
                    textContentExisting ? textContentExisting.attr(textContentOption) : el.setTextContent(new $fe885cc21795562b$export$2e2bcd8739ae039(textContentOption));
                } else if (isReplace) el.setTextContent(new $fe885cc21795562b$export$2e2bcd8739ae039(textContentOption));
            }
            if (el) {
                var clipPathOption = elOption.clipPath;
                if (clipPathOption) {
                    var clipPathType = clipPathOption.type;
                    var clipPath = void 0;
                    var isInit = false;
                    if (isMerge) {
                        var oldClipPath = el.getClipPath();
                        isInit = !oldClipPath || $2b680c3ccdb25c77$export$4ae363f1d88fb658(oldClipPath).type !== clipPathType;
                        clipPath = isInit ? $2b680c3ccdb25c77$var$newEl(clipPathType) : oldClipPath;
                    } else if (isReplace) {
                        isInit = true;
                        clipPath = $2b680c3ccdb25c77$var$newEl(clipPathType);
                    }
                    el.setClipPath(clipPath);
                    (0, $7c104376a000308e$export$4342b281b9b5d77e)(clipPath, clipPathOption, graphicModel, {
                        isInit: isInit
                    });
                    (0, $ab8d73690f09fb6d$export$b0aa6a5f01693fa4)(clipPath, clipPathOption.keyframeAnimation, graphicModel);
                }
                var elInner = $2b680c3ccdb25c77$export$4ae363f1d88fb658(el);
                el.setTextConfig(textConfig);
                elInner.option = elOption;
                $2b680c3ccdb25c77$var$setEventData(el, graphicModel, elOption);
                $5b455ae6f843ac47$export$fc6410d97fab306c({
                    el: el,
                    componentModel: graphicModel,
                    itemName: el.name,
                    itemTooltipOption: elOption.tooltip
                });
                (0, $ab8d73690f09fb6d$export$b0aa6a5f01693fa4)(el, elOption.keyframeAnimation, graphicModel);
            }
        });
    };
    /**
   * Locate graphic elements.
   */ GraphicComponentView.prototype._relocate = function(graphicModel, api) {
        var elOptions = graphicModel.option.elements;
        var rootGroup = this.group;
        var elMap = this._elMap;
        var apiWidth = api.getWidth();
        var apiHeight = api.getHeight();
        var xy = [
            "x",
            "y"
        ];
        // Top-down to calculate percentage width/height of group
        for(var i = 0; i < elOptions.length; i++){
            var elOption = elOptions[i];
            var id = $76d619f648247e6d$export$fb1a222ba5dd6e51(elOption.id, null);
            var el = id != null ? elMap.get(id) : null;
            if (!el || !el.isGroup) continue;
            var parentEl = el.parent;
            var isParentRoot = parentEl === rootGroup;
            // Like 'position:absolut' in css, default 0.
            var elInner = $2b680c3ccdb25c77$export$4ae363f1d88fb658(el);
            var parentElInner = $2b680c3ccdb25c77$export$4ae363f1d88fb658(parentEl);
            elInner.width = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(elInner.option.width, isParentRoot ? apiWidth : parentElInner.width) || 0;
            elInner.height = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(elInner.option.height, isParentRoot ? apiHeight : parentElInner.height) || 0;
        }
        // Bottom-up tranvese all elements (consider ec resize) to locate elements.
        for(var i = elOptions.length - 1; i >= 0; i--){
            var elOption = elOptions[i];
            var id = $76d619f648247e6d$export$fb1a222ba5dd6e51(elOption.id, null);
            var el = id != null ? elMap.get(id) : null;
            if (!el) continue;
            var parentEl = el.parent;
            var parentElInner = $2b680c3ccdb25c77$export$4ae363f1d88fb658(parentEl);
            var containerInfo = parentEl === rootGroup ? {
                width: apiWidth,
                height: apiHeight
            } : {
                width: parentElInner.width,
                height: parentElInner.height
            };
            // PENDING
            // Currently, when `bounding: 'all'`, the union bounding rect of the group
            // does not include the rect of [0, 0, group.width, group.height], which
            // is probably weird for users. Should we make a break change for it?
            var layoutPos = {};
            var layouted = $93b9bc7f22ac7369$export$74054bd96b5eeef1(el, elOption, containerInfo, null, {
                hv: elOption.hv,
                boundingMode: elOption.bounding
            }, layoutPos);
            if (!$2b680c3ccdb25c77$export$4ae363f1d88fb658(el).isNew && layouted) {
                var transition = elOption.transition;
                var animatePos = {};
                for(var k = 0; k < xy.length; k++){
                    var key = xy[k];
                    var val = layoutPos[key];
                    if (transition && ((0, $7c104376a000308e$export$6f3361b4b8d7a8ba)(transition) || $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(transition, key) >= 0)) animatePos[key] = val;
                    else el[key] = val;
                }
                (0, $8b353638fbedfefa$export$c8dce3c08436e91e)(el, animatePos, graphicModel, 0);
            } else el.attr(layoutPos);
        }
    };
    /**
   * Clear all elements.
   */ GraphicComponentView.prototype._clear = function() {
        var _this = this;
        var elMap = this._elMap;
        elMap.each(function(el) {
            $2b680c3ccdb25c77$var$removeEl(el, $2b680c3ccdb25c77$export$4ae363f1d88fb658(el).option, elMap, _this._lastGraphicModel);
        });
        this._elMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
    };
    GraphicComponentView.prototype.dispose = function() {
        this._clear();
    };
    GraphicComponentView.type = "graphic";
    return GraphicComponentView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $2b680c3ccdb25c77$var$newEl(graphicType) {
    var Clz = $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3($2b680c3ccdb25c77$var$nonShapeGraphicElements, graphicType) ? $2b680c3ccdb25c77$var$nonShapeGraphicElements[graphicType] : $5b455ae6f843ac47$export$51df4b5565a58189(graphicType);
    var el = new Clz({});
    $2b680c3ccdb25c77$export$4ae363f1d88fb658(el).type = graphicType;
    return el;
}
function $2b680c3ccdb25c77$var$createEl(id, targetElParent, graphicType, elMap) {
    var el = $2b680c3ccdb25c77$var$newEl(graphicType);
    targetElParent.add(el);
    elMap.set(id, el);
    $2b680c3ccdb25c77$export$4ae363f1d88fb658(el).id = id;
    $2b680c3ccdb25c77$export$4ae363f1d88fb658(el).isNew = true;
    return el;
}
function $2b680c3ccdb25c77$var$removeEl(elExisting, elOption, elMap, graphicModel) {
    var existElParent = elExisting && elExisting.parent;
    if (existElParent) {
        elExisting.type === "group" && elExisting.traverse(function(el) {
            $2b680c3ccdb25c77$var$removeEl(el, elOption, elMap, graphicModel);
        });
        (0, $7c104376a000308e$export$15575b6d82d35bb3)(elExisting, elOption, graphicModel);
        elMap.removeKey($2b680c3ccdb25c77$export$4ae363f1d88fb658(elExisting).id);
    }
}
function $2b680c3ccdb25c77$var$updateCommonAttrs(el, elOption, defaultZ, defaultZlevel) {
    if (!el.isGroup) $7a1bd9c2710fea0d$export$79b2f7037acddd43([
        [
            "cursor",
            (0, $56206a6cb4666931$export$2e2bcd8739ae039).prototype.cursor
        ],
        // We should not support configure z and zlevel in the element level.
        // But seems we didn't limit it previously. So here still use it to avoid breaking.
        [
            "zlevel",
            defaultZlevel || 0
        ],
        [
            "z",
            defaultZ || 0
        ],
        // z2 must not be null/undefined, otherwise sort error may occur.
        [
            "z2",
            0
        ]
    ], function(item) {
        var prop = item[0];
        if ($7a1bd9c2710fea0d$export$b5a638e9b3fff9f3(elOption, prop)) el[prop] = $7a1bd9c2710fea0d$export$995e01f2f5c9d030(elOption[prop], item[1]);
        else if (el[prop] == null) el[prop] = item[1];
    });
    $7a1bd9c2710fea0d$export$79b2f7037acddd43($7a1bd9c2710fea0d$export$ed97f33186d4b816(elOption), function(key) {
        // Assign event handlers.
        // PENDING: should enumerate all event names or use pattern matching?
        if (key.indexOf("on") === 0) {
            var val = elOption[key];
            el[key] = $7a1bd9c2710fea0d$export$f6e2535fb5126e54(val) ? val : null;
        }
    });
    if ($7a1bd9c2710fea0d$export$b5a638e9b3fff9f3(elOption, "draggable")) el.draggable = elOption.draggable;
    // Other attributes
    elOption.name != null && (el.name = elOption.name);
    elOption.id != null && (el.id = elOption.id);
}
// Remove unnecessary props to avoid potential problems.
function $2b680c3ccdb25c77$var$getCleanedElOption(elOption) {
    elOption = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, elOption);
    $7a1bd9c2710fea0d$export$79b2f7037acddd43([
        "id",
        "parentId",
        "$action",
        "hv",
        "bounding",
        "textContent",
        "clipPath"
    ].concat($93b9bc7f22ac7369$export$a9aa2cc018afbed), function(name) {
        delete elOption[name];
    });
    return elOption;
}
function $2b680c3ccdb25c77$var$setEventData(el, graphicModel, elOption) {
    var eventData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).eventData;
    // Simple optimize for large amount of elements that no need event.
    if (!el.silent && !el.ignore && !eventData) eventData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).eventData = {
        componentType: "graphic",
        componentIndex: graphicModel.componentIndex,
        name: el.name
    };
    // `elOption.info` enables user to mount some info on
    // elements and use them in event handlers.
    if (eventData) eventData.info = elOption.info;
}


function $48174658d54922b7$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $21e1121941dbd8a9$export$6d85925da4d2cf23));
    registers.registerComponentView((0, $2b680c3ccdb25c77$export$1132c9ab9ad80748));
    registers.registerPreprocessor(function(option) {
        var graphicOption = option.graphic;
        // Convert
        // {graphic: [{left: 10, type: 'circle'}, ...]}
        // or
        // {graphic: {left: 10, type: 'circle'}}
        // to
        // {graphic: [{elements: [{left: 10, type: 'circle'}, ...]}]}
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(graphicOption)) {
            if (!graphicOption[0] || !graphicOption[0].elements) option.graphic = [
                {
                    elements: graphicOption
                }
            ];
            else // Only one graphic instance can be instantiated. (We don't
            // want that too many views are created in echarts._viewMap.)
            option.graphic = [
                option.graphic[0]
            ];
        } else if (graphicOption && !graphicOption.elements) option.graphic = [
            {
                elements: [
                    graphicOption
                ]
            }
        ];
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $30909b2e837c2175$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $1021478d6a16b0aa$export$4b3e715f166fdd78));
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $589507869c21caa1$export$4b3e715f166fdd78));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $0fbb1ae1b8df4cab$var$getDefaultSelectorOptions = function(ecModel, type) {
    if (type === "all") return {
        type: "all",
        title: ecModel.getLocaleModel().get([
            "legend",
            "selector",
            "all"
        ])
    };
    else if (type === "inverse") return {
        type: "inverse",
        title: ecModel.getLocaleModel().get([
            "legend",
            "selector",
            "inverse"
        ])
    };
};
var $0fbb1ae1b8df4cab$var$LegendModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LegendModel, _super);
    function LegendModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LegendModel.type;
        _this.layoutMode = {
            type: "box",
            // legend.width/height are maxWidth/maxHeight actually,
            // whereas real width/height is calculated by its content.
            // (Setting {left: 10, right: 10} does not make sense).
            // So consider the case:
            // `setOption({legend: {left: 10});`
            // then `setOption({legend: {right: 10});`
            // The previous `left` should be cleared by setting `ignoreSize`.
            ignoreSize: true
        };
        return _this;
    }
    LegendModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        option.selected = option.selected || {};
        this._updateSelector(option);
    };
    LegendModel.prototype.mergeOption = function(option, ecModel) {
        _super.prototype.mergeOption.call(this, option, ecModel);
        this._updateSelector(option);
    };
    LegendModel.prototype._updateSelector = function(option) {
        var selector = option.selector;
        var ecModel = this.ecModel;
        if (selector === true) selector = option.selector = [
            "all",
            "inverse"
        ];
        if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(selector)) $7a1bd9c2710fea0d$export$79b2f7037acddd43(selector, function(item, index) {
            $7a1bd9c2710fea0d$export$844ec244b1367d54(item) && (item = {
                type: item
            });
            selector[index] = $7a1bd9c2710fea0d$export$4950aa0f605343fb(item, $0fbb1ae1b8df4cab$var$getDefaultSelectorOptions(ecModel, item.type));
        });
    };
    LegendModel.prototype.optionUpdated = function() {
        this._updateData(this.ecModel);
        var legendData = this._data;
        // If selectedMode is single, try to select one
        if (legendData[0] && this.get("selectedMode") === "single") {
            var hasSelected = false;
            // If has any selected in option.selected
            for(var i = 0; i < legendData.length; i++){
                var name_1 = legendData[i].get("name");
                if (this.isSelected(name_1)) {
                    // Force to unselect others
                    this.select(name_1);
                    hasSelected = true;
                    break;
                }
            }
            // Try select the first if selectedMode is single
            !hasSelected && this.select(legendData[0].get("name"));
        }
    };
    LegendModel.prototype._updateData = function(ecModel) {
        var potentialData = [];
        var availableNames = [];
        ecModel.eachRawSeries(function(seriesModel) {
            var seriesName = seriesModel.name;
            availableNames.push(seriesName);
            var isPotential;
            if (seriesModel.legendVisualProvider) {
                var provider = seriesModel.legendVisualProvider;
                var names = provider.getAllNames();
                if (!ecModel.isSeriesFiltered(seriesModel)) availableNames = availableNames.concat(names);
                if (names.length) potentialData = potentialData.concat(names);
                else isPotential = true;
            } else isPotential = true;
            if (isPotential && (0, $76d619f648247e6d$export$beae19a2652b3368)(seriesModel)) potentialData.push(seriesModel.name);
        });
        /**
     * @type {Array.<string>}
     * @private
     */ this._availableNames = availableNames;
        // If legend.data is not specified in option, use availableNames as data,
        // which is convenient for user preparing option.
        var rawData = this.get("data") || potentialData;
        var legendNameMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var legendData = $7a1bd9c2710fea0d$export$871de8747c9eaa88(rawData, function(dataItem) {
            // Can be string or number
            if ($7a1bd9c2710fea0d$export$844ec244b1367d54(dataItem) || $7a1bd9c2710fea0d$export$7e4aa119212bc614(dataItem)) dataItem = {
                name: dataItem
            };
            if (legendNameMap.get(dataItem.name)) // remove legend name duplicate
            return null;
            legendNameMap.set(dataItem.name, true);
            return new (0, $6818646a97528290$export$2e2bcd8739ae039)(dataItem, this, this.ecModel);
        }, this);
        /**
     * @type {Array.<module:echarts/model/Model>}
     * @private
     */ this._data = $7a1bd9c2710fea0d$export$3dea766d36a8935f(legendData, function(item) {
            return !!item;
        });
    };
    LegendModel.prototype.getData = function() {
        return this._data;
    };
    LegendModel.prototype.select = function(name) {
        var selected = this.option.selected;
        var selectedMode = this.get("selectedMode");
        if (selectedMode === "single") {
            var data = this._data;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(data, function(dataItem) {
                selected[dataItem.get("name")] = false;
            });
        }
        selected[name] = true;
    };
    LegendModel.prototype.unSelect = function(name) {
        if (this.get("selectedMode") !== "single") this.option.selected[name] = false;
    };
    LegendModel.prototype.toggleSelected = function(name) {
        var selected = this.option.selected;
        // Default is true
        if (!selected.hasOwnProperty(name)) selected[name] = true;
        this[selected[name] ? "unSelect" : "select"](name);
    };
    LegendModel.prototype.allSelect = function() {
        var data = this._data;
        var selected = this.option.selected;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(data, function(dataItem) {
            selected[dataItem.get("name", true)] = true;
        });
    };
    LegendModel.prototype.inverseSelect = function() {
        var data = this._data;
        var selected = this.option.selected;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(data, function(dataItem) {
            var name = dataItem.get("name", true);
            // Initially, default value is true
            if (!selected.hasOwnProperty(name)) selected[name] = true;
            selected[name] = !selected[name];
        });
    };
    LegendModel.prototype.isSelected = function(name) {
        var selected = this.option.selected;
        return !(selected.hasOwnProperty(name) && !selected[name]) && $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(this._availableNames, name) >= 0;
    };
    LegendModel.prototype.getOrient = function() {
        return this.get("orient") === "vertical" ? {
            index: 1,
            name: "vertical"
        } : {
            index: 0,
            name: "horizontal"
        };
    };
    LegendModel.type = "legend.plain";
    LegendModel.dependencies = [
        "series"
    ];
    LegendModel.defaultOption = {
        // zlevel: 0,
        z: 4,
        show: true,
        orient: "horizontal",
        left: "center",
        // right: 'center',
        // top: 0,
        bottom: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).size.m,
        align: "auto",
        backgroundColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.transparent,
        borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.border,
        borderRadius: 0,
        borderWidth: 0,
        padding: 5,
        itemGap: 8,
        itemWidth: 25,
        itemHeight: 14,
        symbolRotate: "inherit",
        symbolKeepAspect: true,
        inactiveColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.disabled,
        inactiveBorderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.disabled,
        inactiveBorderWidth: "auto",
        itemStyle: {
            color: "inherit",
            opacity: "inherit",
            borderColor: "inherit",
            borderWidth: "auto",
            borderCap: "inherit",
            borderJoin: "inherit",
            borderDashOffset: "inherit",
            borderMiterLimit: "inherit"
        },
        lineStyle: {
            width: "auto",
            color: "inherit",
            inactiveColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.disabled,
            inactiveWidth: 2,
            opacity: "inherit",
            type: "inherit",
            cap: "inherit",
            join: "inherit",
            dashOffset: "inherit",
            miterLimit: "inherit"
        },
        textStyle: {
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.secondary
        },
        selectedMode: true,
        selector: false,
        selectorLabel: {
            show: true,
            borderRadius: 10,
            padding: [
                3,
                5,
                3,
                5
            ],
            fontSize: 12,
            fontFamily: "sans-serif",
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.tertiary,
            borderWidth: 1,
            borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.border
        },
        emphasis: {
            selectorLabel: {
                show: true,
                color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.quaternary
            }
        },
        selectorPosition: "auto",
        selectorItemGap: 7,
        selectorButtonGap: 10,
        tooltip: {
            show: false
        },
        triggerEvent: false
    };
    return LegendModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $0fbb1ae1b8df4cab$export$2e2bcd8739ae039 = $0fbb1ae1b8df4cab$var$LegendModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $40fca678c85406ff$export$fae23936eedfad4f(rect, componentModel) {
    var padding = $c84c9521536c601a$export$f3a38102c49f4268(componentModel.get("padding"));
    var style = componentModel.getItemStyle([
        "color",
        "opacity"
    ]);
    style.fill = componentModel.get("backgroundColor");
    var bgRect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        shape: {
            x: rect.x - padding[3],
            y: rect.y - padding[0],
            width: rect.width + padding[1] + padding[3],
            height: rect.height + padding[0] + padding[2],
            r: componentModel.get("borderRadius")
        },
        style: style,
        silent: true,
        z2: -1
    });
    // FIXME
    // `subPixelOptimizeRect` may bring some gap between edge of viewpart
    // and background rect when setting like `left: 0`, `top: 0`.
    // graphic.subPixelOptimizeRect(rect);
    return bgRect;
}








var $c2e212625ccc38b4$var$curry = $7a1bd9c2710fea0d$export$c3095a23b368d1f2;
var $c2e212625ccc38b4$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $c2e212625ccc38b4$var$Group = $7ef7583d8302ffce$export$2e2bcd8739ae039;
var $c2e212625ccc38b4$var$LegendView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LegendView, _super);
    function LegendView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LegendView.type;
        _this.newlineDisabled = false;
        return _this;
    }
    LegendView.prototype.init = function() {
        this.group.add(this._contentGroup = new $c2e212625ccc38b4$var$Group());
        this.group.add(this._selectorGroup = new $c2e212625ccc38b4$var$Group());
        this._isFirstRender = true;
    };
    /**
   * @protected
   */ LegendView.prototype.getContentGroup = function() {
        return this._contentGroup;
    };
    /**
   * @protected
   */ LegendView.prototype.getSelectorGroup = function() {
        return this._selectorGroup;
    };
    /**
   * @override
   */ LegendView.prototype.render = function(legendModel, ecModel, api) {
        var isFirstRender = this._isFirstRender;
        this._isFirstRender = false;
        this.resetInner();
        if (!legendModel.get("show", true)) return;
        var itemAlign = legendModel.get("align");
        var orient = legendModel.get("orient");
        if (!itemAlign || itemAlign === "auto") itemAlign = legendModel.get("left") === "right" && orient === "vertical" ? "right" : "left";
        // selector has been normalized to an array in model
        var selector = legendModel.get("selector", true);
        var selectorPosition = legendModel.get("selectorPosition", true);
        if (selector && (!selectorPosition || selectorPosition === "auto")) selectorPosition = orient === "horizontal" ? "end" : "start";
        this.renderInner(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
        // Perform layout.
        var refContainer = $93b9bc7f22ac7369$export$5aec1e94f566e59f(legendModel, api).refContainer;
        var positionInfo = legendModel.getBoxLayoutParams();
        var padding = legendModel.get("padding");
        var maxSize = $93b9bc7f22ac7369$export$4517a5ca639a7293(positionInfo, refContainer, padding);
        var mainRect = this.layoutInner(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition);
        // Place mainGroup, based on the calculated `mainRect`.
        var layoutRect = $93b9bc7f22ac7369$export$4517a5ca639a7293($7a1bd9c2710fea0d$export$ebe90cb607ad99e({
            width: mainRect.width,
            height: mainRect.height
        }, positionInfo), refContainer, padding);
        this.group.x = layoutRect.x - mainRect.x;
        this.group.y = layoutRect.y - mainRect.y;
        this.group.markRedraw();
        // Render background after group is layout.
        this.group.add(this._backgroundEl = (0, $40fca678c85406ff$export$fae23936eedfad4f)(mainRect, // FXIME: most itemStyle options does not work in background because inherit is not handled yet.
        legendModel));
    };
    LegendView.prototype.resetInner = function() {
        this.getContentGroup().removeAll();
        this._backgroundEl && this.group.remove(this._backgroundEl);
        this.getSelectorGroup().removeAll();
    };
    LegendView.prototype.renderInner = function(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
        var contentGroup = this.getContentGroup();
        var legendDrawnMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var selectMode = legendModel.get("selectedMode");
        var triggerEvent = legendModel.get("triggerEvent");
        var excludeSeriesId = [];
        ecModel.eachRawSeries(function(seriesModel) {
            !seriesModel.get("legendHoverLink") && excludeSeriesId.push(seriesModel.id);
        });
        $c2e212625ccc38b4$var$each(legendModel.getData(), function(legendItemModel, dataIndex) {
            var _this = this;
            var name = legendItemModel.get("name");
            // Use empty string or \n as a newline string
            if (!this.newlineDisabled && (name === "" || name === "\n")) {
                var g = new $c2e212625ccc38b4$var$Group();
                // @ts-ignore
                g.newline = true;
                contentGroup.add(g);
                return;
            }
            // Representitive series.
            var seriesModel = ecModel.getSeriesByName(name)[0];
            if (legendDrawnMap.get(name)) // Have been drawn
            return;
            // Legend to control series.
            if (seriesModel) {
                var data = seriesModel.getData();
                var lineVisualStyle = data.getVisual("legendLineStyle") || {};
                var legendIcon = data.getVisual("legendIcon");
                /**
         * `data.getVisual('style')` may be the color from the register
         * in series. For example, for line series,
         */ var style = data.getVisual("style");
                var itemGroup = this._createItem(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, lineVisualStyle, style, legendIcon, selectMode, api);
                itemGroup.on("click", $c2e212625ccc38b4$var$curry($c2e212625ccc38b4$var$dispatchSelectAction, name, null, api, excludeSeriesId)).on("mouseover", $c2e212625ccc38b4$var$curry($c2e212625ccc38b4$var$dispatchHighlightAction, seriesModel.name, null, api, excludeSeriesId)).on("mouseout", $c2e212625ccc38b4$var$curry($c2e212625ccc38b4$var$dispatchDownplayAction, seriesModel.name, null, api, excludeSeriesId));
                if (ecModel.ssr) itemGroup.eachChild(function(child) {
                    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(child);
                    ecData.seriesIndex = seriesModel.seriesIndex;
                    ecData.dataIndex = dataIndex;
                    ecData.ssrType = "legend";
                });
                if (triggerEvent) itemGroup.eachChild(function(child) {
                    _this.packEventData(child, legendModel, seriesModel, dataIndex, name);
                });
                legendDrawnMap.set(name, true);
            } else // Legend to control data. In pie and funnel.
            ecModel.eachRawSeries(function(seriesModel) {
                var _this = this;
                // In case multiple series has same data name
                if (legendDrawnMap.get(name)) return;
                if (seriesModel.legendVisualProvider) {
                    var provider = seriesModel.legendVisualProvider;
                    if (!provider.containName(name)) return;
                    var idx = provider.indexOfName(name);
                    var style = provider.getItemVisual(idx, "style");
                    var legendIcon = provider.getItemVisual(idx, "legendIcon");
                    var colorArr = (0, $2c037f5bda6341ca$export$98e6a39c04603d36)(style.fill);
                    // Color may be set to transparent in visualMap when data is out of range.
                    // Do not show nothing.
                    if (colorArr && colorArr[3] === 0) {
                        colorArr[3] = 0.2;
                        // TODO color is set to 0, 0, 0, 0. Should show correct RGBA
                        style = $7a1bd9c2710fea0d$export$8b58be045bf06082($7a1bd9c2710fea0d$export$8b58be045bf06082({}, style), {
                            fill: (0, $2c037f5bda6341ca$export$fac44ee5b035f737)(colorArr, "rgba")
                        });
                    }
                    var itemGroup = this._createItem(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, {}, style, legendIcon, selectMode, api);
                    // FIXME: consider different series has items with the same name.
                    itemGroup.on("click", $c2e212625ccc38b4$var$curry($c2e212625ccc38b4$var$dispatchSelectAction, null, name, api, excludeSeriesId))// Should not specify the series name, consider legend controls
                    // more than one pie series.
                    .on("mouseover", $c2e212625ccc38b4$var$curry($c2e212625ccc38b4$var$dispatchHighlightAction, null, name, api, excludeSeriesId)).on("mouseout", $c2e212625ccc38b4$var$curry($c2e212625ccc38b4$var$dispatchDownplayAction, null, name, api, excludeSeriesId));
                    if (ecModel.ssr) itemGroup.eachChild(function(child) {
                        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(child);
                        ecData.seriesIndex = seriesModel.seriesIndex;
                        ecData.dataIndex = dataIndex;
                        ecData.ssrType = "legend";
                    });
                    if (triggerEvent) itemGroup.eachChild(function(child) {
                        _this.packEventData(child, legendModel, seriesModel, dataIndex, name);
                    });
                    legendDrawnMap.set(name, true);
                }
            }, this);
        }, this);
        if (selector) this._createSelector(selector, legendModel, api, orient, selectorPosition);
    };
    LegendView.prototype.packEventData = function(el, legendModel, seriesModel, dataIndex, name) {
        var eventData = {
            componentType: "legend",
            componentIndex: legendModel.componentIndex,
            dataIndex: dataIndex,
            value: name,
            seriesIndex: seriesModel.seriesIndex
        };
        (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).eventData = eventData;
    };
    LegendView.prototype._createSelector = function(selector, legendModel, api, orient, selectorPosition) {
        var selectorGroup = this.getSelectorGroup();
        $c2e212625ccc38b4$var$each(selector, function createSelectorButton(selectorItem) {
            var type = selectorItem.type;
            var labelText = new $fe885cc21795562b$export$2e2bcd8739ae039({
                style: {
                    x: 0,
                    y: 0,
                    align: "center",
                    verticalAlign: "middle"
                },
                onclick: function() {
                    api.dispatchAction({
                        type: type === "all" ? "legendAllSelect" : "legendInverseSelect",
                        legendId: legendModel.id
                    });
                }
            });
            selectorGroup.add(labelText);
            var labelModel = legendModel.getModel("selectorLabel");
            var emphasisLabelModel = legendModel.getModel([
                "emphasis",
                "selectorLabel"
            ]);
            (0, $6800dfcb6e1e2a44$export$9a13992917966657)(labelText, {
                normal: labelModel,
                emphasis: emphasisLabelModel
            }, {
                defaultText: selectorItem.title
            });
            (0, $2bf82c0980125b62$export$5f393df0b5aee2e7)(labelText);
        });
    };
    LegendView.prototype._createItem = function(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, lineVisualStyle, itemVisualStyle, legendIcon, selectMode, api) {
        var drawType = seriesModel.visualDrawType;
        var itemWidth = legendModel.get("itemWidth");
        var itemHeight = legendModel.get("itemHeight");
        var isSelected = legendModel.isSelected(name);
        var iconRotate = legendItemModel.get("symbolRotate");
        var symbolKeepAspect = legendItemModel.get("symbolKeepAspect");
        var legendIconType = legendItemModel.get("icon");
        legendIcon = legendIconType || legendIcon || "roundRect";
        var style = $c2e212625ccc38b4$var$getLegendStyle(legendIcon, legendItemModel, lineVisualStyle, itemVisualStyle, drawType, isSelected, api);
        var itemGroup = new $c2e212625ccc38b4$var$Group();
        var textStyleModel = legendItemModel.getModel("textStyle");
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(seriesModel.getLegendIcon) && (!legendIconType || legendIconType === "inherit")) // Series has specific way to define legend icon
        itemGroup.add(seriesModel.getLegendIcon({
            itemWidth: itemWidth,
            itemHeight: itemHeight,
            icon: legendIcon,
            iconRotate: iconRotate,
            itemStyle: style.itemStyle,
            lineStyle: style.lineStyle,
            symbolKeepAspect: symbolKeepAspect
        }));
        else {
            // Use default legend icon policy for most series
            var rotate = legendIconType === "inherit" && seriesModel.getData().getVisual("symbol") ? iconRotate === "inherit" ? seriesModel.getData().getVisual("symbolRotate") : iconRotate : 0; // No rotation for no icon
            itemGroup.add($c2e212625ccc38b4$var$getDefaultLegendIcon({
                itemWidth: itemWidth,
                itemHeight: itemHeight,
                icon: legendIcon,
                iconRotate: rotate,
                itemStyle: style.itemStyle,
                lineStyle: style.lineStyle,
                symbolKeepAspect: symbolKeepAspect
            }));
        }
        var textX = itemAlign === "left" ? itemWidth + 5 : -5;
        var textAlign = itemAlign;
        var formatter = legendModel.get("formatter");
        var content = name;
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(formatter) && formatter) content = formatter.replace("{name}", name != null ? name : "");
        else if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(formatter)) content = formatter(name);
        var textColor = isSelected ? textStyleModel.getTextColor() : legendItemModel.get("inactiveColor");
        itemGroup.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                text: content,
                x: textX,
                y: itemHeight / 2,
                fill: textColor,
                align: textAlign,
                verticalAlign: "middle"
            }, {
                inheritColor: textColor
            })
        }));
        // Add a invisible rect to increase the area of mouse hover
        var hitRect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
            shape: itemGroup.getBoundingRect(),
            style: {
                // Cannot use 'invisible' because SVG SSR will miss the node
                fill: "transparent"
            }
        });
        var tooltipModel = legendItemModel.getModel("tooltip");
        if (tooltipModel.get("show")) $5b455ae6f843ac47$export$fc6410d97fab306c({
            el: hitRect,
            componentModel: legendModel,
            itemName: name,
            itemTooltipOption: tooltipModel.option
        });
        itemGroup.add(hitRect);
        itemGroup.eachChild(function(child) {
            child.silent = true;
        });
        hitRect.silent = !selectMode;
        this.getContentGroup().add(itemGroup);
        (0, $2bf82c0980125b62$export$5f393df0b5aee2e7)(itemGroup);
        // @ts-ignore
        itemGroup.__legendDataIndex = dataIndex;
        return itemGroup;
    };
    LegendView.prototype.layoutInner = function(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
        var contentGroup = this.getContentGroup();
        var selectorGroup = this.getSelectorGroup();
        // Place items in contentGroup.
        $93b9bc7f22ac7369$export$827f4ee28efc37(legendModel.get("orient"), contentGroup, legendModel.get("itemGap"), maxSize.width, maxSize.height);
        var contentRect = contentGroup.getBoundingRect();
        var contentPos = [
            -contentRect.x,
            -contentRect.y
        ];
        selectorGroup.markRedraw();
        contentGroup.markRedraw();
        if (selector) {
            // Place buttons in selectorGroup
            $93b9bc7f22ac7369$export$827f4ee28efc37(// Buttons in selectorGroup always layout horizontally
            "horizontal", selectorGroup, legendModel.get("selectorItemGap", true));
            var selectorRect = selectorGroup.getBoundingRect();
            var selectorPos = [
                -selectorRect.x,
                -selectorRect.y
            ];
            var selectorButtonGap = legendModel.get("selectorButtonGap", true);
            var orientIdx = legendModel.getOrient().index;
            var wh = orientIdx === 0 ? "width" : "height";
            var hw = orientIdx === 0 ? "height" : "width";
            var yx = orientIdx === 0 ? "y" : "x";
            if (selectorPosition === "end") selectorPos[orientIdx] += contentRect[wh] + selectorButtonGap;
            else contentPos[orientIdx] += selectorRect[wh] + selectorButtonGap;
            // Always align selector to content as 'middle'
            selectorPos[1 - orientIdx] += contentRect[hw] / 2 - selectorRect[hw] / 2;
            selectorGroup.x = selectorPos[0];
            selectorGroup.y = selectorPos[1];
            contentGroup.x = contentPos[0];
            contentGroup.y = contentPos[1];
            var mainRect = {
                x: 0,
                y: 0
            };
            mainRect[wh] = contentRect[wh] + selectorButtonGap + selectorRect[wh];
            mainRect[hw] = Math.max(contentRect[hw], selectorRect[hw]);
            mainRect[yx] = Math.min(0, selectorRect[yx] + selectorPos[1 - orientIdx]);
            return mainRect;
        } else {
            contentGroup.x = contentPos[0];
            contentGroup.y = contentPos[1];
            return this.group.getBoundingRect();
        }
    };
    /**
   * @protected
   */ LegendView.prototype.remove = function() {
        this.getContentGroup().removeAll();
        this._isFirstRender = true;
    };
    LegendView.type = "legend.plain";
    return LegendView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $c2e212625ccc38b4$var$getLegendStyle(iconType, legendItemModel, lineVisualStyle, itemVisualStyle, drawType, isSelected, api) {
    /**
   * Use series style if is inherit;
   * elsewise, use legend style
   */ function handleCommonProps(style, visualStyle) {
        // If lineStyle.width is 'auto', it is set to be 2 if series has border
        if (style.lineWidth === "auto") style.lineWidth = visualStyle.lineWidth > 0 ? 2 : 0;
        $c2e212625ccc38b4$var$each(style, function(propVal, propName) {
            style[propName] === "inherit" && (style[propName] = visualStyle[propName]);
        });
    }
    // itemStyle
    var itemStyleModel = legendItemModel.getModel("itemStyle");
    var itemStyle = itemStyleModel.getItemStyle();
    var iconBrushType = iconType.lastIndexOf("empty", 0) === 0 ? "fill" : "stroke";
    var decalStyle = itemStyleModel.getShallow("decal");
    itemStyle.decal = !decalStyle || decalStyle === "inherit" ? itemVisualStyle.decal : (0, $c6d646aacd243427$export$a3ba048e1a648972)(decalStyle, api);
    if (itemStyle.fill === "inherit") /**
     * Series with visualDrawType as 'stroke' should have
     * series stroke as legend fill
     */ itemStyle.fill = itemVisualStyle[drawType];
    if (itemStyle.stroke === "inherit") /**
     * icon type with "emptyXXX" should use fill color
     * in visual style
     */ itemStyle.stroke = itemVisualStyle[iconBrushType];
    if (itemStyle.opacity === "inherit") /**
     * Use lineStyle.opacity if drawType is stroke
     */ itemStyle.opacity = (drawType === "fill" ? itemVisualStyle : lineVisualStyle).opacity;
    handleCommonProps(itemStyle, itemVisualStyle);
    // lineStyle
    var legendLineModel = legendItemModel.getModel("lineStyle");
    var lineStyle = legendLineModel.getLineStyle();
    handleCommonProps(lineStyle, lineVisualStyle);
    // Fix auto color to real color
    itemStyle.fill === "auto" && (itemStyle.fill = itemVisualStyle.fill);
    itemStyle.stroke === "auto" && (itemStyle.stroke = itemVisualStyle.fill);
    lineStyle.stroke === "auto" && (lineStyle.stroke = itemVisualStyle.fill);
    if (!isSelected) {
        var borderWidth = legendItemModel.get("inactiveBorderWidth");
        /**
     * Since stroke is set to be inactiveBorderColor, it may occur that
     * there is no border in series but border in legend, so we need to
     * use border only when series has border if is set to be auto
     */ var visualHasBorder = itemStyle[iconBrushType];
        itemStyle.lineWidth = borderWidth === "auto" ? itemVisualStyle.lineWidth > 0 && visualHasBorder ? 2 : 0 : itemStyle.lineWidth;
        itemStyle.fill = legendItemModel.get("inactiveColor");
        itemStyle.stroke = legendItemModel.get("inactiveBorderColor");
        lineStyle.stroke = legendLineModel.get("inactiveColor");
        lineStyle.lineWidth = legendLineModel.get("inactiveWidth");
    }
    return {
        itemStyle: itemStyle,
        lineStyle: lineStyle
    };
}
function $c2e212625ccc38b4$var$getDefaultLegendIcon(opt) {
    var symboType = opt.icon || "roundRect";
    var icon = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symboType, 0, 0, opt.itemWidth, opt.itemHeight, opt.itemStyle.fill, opt.symbolKeepAspect);
    icon.setStyle(opt.itemStyle);
    icon.rotation = (opt.iconRotate || 0) * Math.PI / 180;
    icon.setOrigin([
        opt.itemWidth / 2,
        opt.itemHeight / 2
    ]);
    if (symboType.indexOf("empty") > -1) {
        icon.style.stroke = icon.style.fill;
        icon.style.fill = (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral00;
        icon.style.lineWidth = 2;
    }
    return icon;
}
function $c2e212625ccc38b4$var$dispatchSelectAction(seriesName, dataName, api, excludeSeriesId) {
    // downplay before unselect
    $c2e212625ccc38b4$var$dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId);
    api.dispatchAction({
        type: "legendToggleSelect",
        name: seriesName != null ? seriesName : dataName
    });
    // highlight after select
    // TODO highlight immediately may cause animation loss.
    $c2e212625ccc38b4$var$dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId);
}
function $c2e212625ccc38b4$var$isUseHoverLayer(api) {
    var list = api.getZr().storage.getDisplayList();
    var emphasisState;
    var i = 0;
    var len = list.length;
    while(i < len && !(emphasisState = list[i].states.emphasis))i++;
    return emphasisState && emphasisState.hoverLayer;
}
function $c2e212625ccc38b4$var$dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId) {
    // If element hover will move to a hoverLayer.
    if (!$c2e212625ccc38b4$var$isUseHoverLayer(api)) api.dispatchAction({
        type: "highlight",
        seriesName: seriesName,
        name: dataName,
        excludeSeriesId: excludeSeriesId
    });
}
function $c2e212625ccc38b4$var$dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId) {
    // If element hover will move to a hoverLayer.
    if (!$c2e212625ccc38b4$var$isUseHoverLayer(api)) api.dispatchAction({
        type: "downplay",
        seriesName: seriesName,
        name: dataName,
        excludeSeriesId: excludeSeriesId
    });
}
var $c2e212625ccc38b4$export$2e2bcd8739ae039 = $c2e212625ccc38b4$var$LegendView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $c618818715ebe216$export$2e2bcd8739ae039(ecModel) {
    var legendModels = ecModel.findComponents({
        mainType: "legend"
    });
    if (legendModels && legendModels.length) ecModel.filterSeries(function(series) {
        // If in any legend component the status is not selected.
        // Because in legend series is assumed selected when it is not in the legend data.
        for(var i = 0; i < legendModels.length; i++){
            if (!legendModels[i].isSelected(series.name)) return false;
        }
        return true;
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $19822663d90c963e$var$legendSelectActionHandler(methodName, payload, ecModel) {
    var isAllSelect = methodName === "allSelect" || methodName === "inverseSelect";
    var selectedMap = {};
    var actionLegendIndices = [];
    ecModel.eachComponent({
        mainType: "legend",
        query: payload
    }, function(legendModel) {
        if (isAllSelect) legendModel[methodName]();
        else legendModel[methodName](payload.name);
        $19822663d90c963e$var$makeSelectedMap(legendModel, selectedMap);
        actionLegendIndices.push(legendModel.componentIndex);
    });
    var allSelectedMap = {};
    // make selectedMap from all legend components
    ecModel.eachComponent("legend", function(legendModel) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(selectedMap, function(isSelected, name) {
            // Force other legend has same selected status
            // Or the first is toggled to true and other are toggled to false
            // In the case one legend has some item unSelected in option. And if other legend
            // doesn't has the item, they will assume it is selected.
            legendModel[isSelected ? "select" : "unSelect"](name);
        });
        $19822663d90c963e$var$makeSelectedMap(legendModel, allSelectedMap);
    });
    // Return the event explicitly
    return isAllSelect ? {
        selected: allSelectedMap,
        // return legendIndex array to tell the developers which legends are allSelect / inverseSelect
        legendIndex: actionLegendIndices
    } : {
        name: payload.name,
        selected: allSelectedMap
    };
}
function $19822663d90c963e$var$makeSelectedMap(legendModel, out) {
    var selectedMap = out || {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(legendModel.getData(), function(model) {
        var name = model.get("name");
        // Wrap element
        if (name === "\n" || name === "") return;
        var isItemSelected = legendModel.isSelected(name);
        if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(selectedMap, name)) // Unselected if any legend is unselected
        selectedMap[name] = selectedMap[name] && isItemSelected;
        else selectedMap[name] = isItemSelected;
    });
    return selectedMap;
}
function $19822663d90c963e$export$139982ea529c452f(registers) {
    /**
   * @event legendToggleSelect
   * @type {Object}
   * @property {string} type 'legendToggleSelect'
   * @property {string} [from]
   * @property {string} name Series name or data item name
   */ registers.registerAction("legendToggleSelect", "legendselectchanged", (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($19822663d90c963e$var$legendSelectActionHandler, "toggleSelected"));
    registers.registerAction("legendAllSelect", "legendselectall", (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($19822663d90c963e$var$legendSelectActionHandler, "allSelect"));
    registers.registerAction("legendInverseSelect", "legendinverseselect", (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($19822663d90c963e$var$legendSelectActionHandler, "inverseSelect"));
    /**
   * @event legendSelect
   * @type {Object}
   * @property {string} type 'legendSelect'
   * @property {string} name Series name or data item name
   */ registers.registerAction("legendSelect", "legendselected", (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($19822663d90c963e$var$legendSelectActionHandler, "select"));
    /**
   * @event legendUnSelect
   * @type {Object}
   * @property {string} type 'legendUnSelect'
   * @property {string} name Series name or data item name
   */ registers.registerAction("legendUnSelect", "legendunselected", (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($19822663d90c963e$var$legendSelectActionHandler, "unSelect"));
}


function $407c7fdad108ade5$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $0fbb1ae1b8df4cab$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $c2e212625ccc38b4$export$2e2bcd8739ae039));
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.SERIES_FILTER, (0, $c618818715ebe216$export$2e2bcd8739ae039));
    registers.registerSubTypeDefaulter("legend", function() {
        return "plain";
    });
    (0, $19822663d90c963e$export$139982ea529c452f)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $a19f9768bdff02b5$var$ScrollableLegendModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ScrollableLegendModel, _super);
    function ScrollableLegendModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScrollableLegendModel.type;
        return _this;
    }
    /**
   * @param {number} scrollDataIndex
   */ ScrollableLegendModel.prototype.setScrollDataIndex = function(scrollDataIndex) {
        this.option.scrollDataIndex = scrollDataIndex;
    };
    ScrollableLegendModel.prototype.init = function(option, parentModel, ecModel) {
        var inputPositionParams = (0, $93b9bc7f22ac7369$export$4b0d20af19c9875e)(option);
        _super.prototype.init.call(this, option, parentModel, ecModel);
        $a19f9768bdff02b5$var$mergeAndNormalizeLayoutParams(this, option, inputPositionParams);
    };
    /**
   * @override
   */ ScrollableLegendModel.prototype.mergeOption = function(option, ecModel) {
        _super.prototype.mergeOption.call(this, option, ecModel);
        $a19f9768bdff02b5$var$mergeAndNormalizeLayoutParams(this, this.option, option);
    };
    ScrollableLegendModel.type = "legend.scroll";
    ScrollableLegendModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $0fbb1ae1b8df4cab$export$2e2bcd8739ae039).defaultOption, {
        scrollDataIndex: 0,
        pageButtonItemGap: 5,
        pageButtonGap: null,
        pageButtonPosition: "end",
        pageFormatter: "{current}/{total}",
        pageIcons: {
            horizontal: [
                "M0,0L12,-10L12,10z",
                "M0,0L-12,-10L-12,10z"
            ],
            vertical: [
                "M0,0L20,0L10,-20z",
                "M0,0L20,0L10,20z"
            ]
        },
        pageIconColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent50,
        pageIconInactiveColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent10,
        pageIconSize: 15,
        pageTextStyle: {
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.tertiary
        },
        animationDurationUpdate: 800
    });
    return ScrollableLegendModel;
}((0, $0fbb1ae1b8df4cab$export$2e2bcd8739ae039));
// Do not `ignoreSize` to enable setting {left: 10, right: 10}.
function $a19f9768bdff02b5$var$mergeAndNormalizeLayoutParams(legendModel, target, raw) {
    var orient = legendModel.getOrient();
    var ignoreSize = [
        1,
        1
    ];
    ignoreSize[orient.index] = 0;
    (0, $93b9bc7f22ac7369$export$1754cb91f16ca028)(target, raw, {
        type: "box",
        ignoreSize: !!ignoreSize
    });
}
var $a19f9768bdff02b5$export$2e2bcd8739ae039 = $a19f9768bdff02b5$var$ScrollableLegendModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $47ff4587191e73cd$var$Group = $7ef7583d8302ffce$export$2e2bcd8739ae039;
var $47ff4587191e73cd$var$WH = [
    "width",
    "height"
];
var $47ff4587191e73cd$var$XY = [
    "x",
    "y"
];
var $47ff4587191e73cd$var$ScrollableLegendView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ScrollableLegendView, _super);
    function ScrollableLegendView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScrollableLegendView.type;
        _this.newlineDisabled = true;
        _this._currentIndex = 0;
        return _this;
    }
    ScrollableLegendView.prototype.init = function() {
        _super.prototype.init.call(this);
        this.group.add(this._containerGroup = new $47ff4587191e73cd$var$Group());
        this._containerGroup.add(this.getContentGroup());
        this.group.add(this._controllerGroup = new $47ff4587191e73cd$var$Group());
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.resetInner = function() {
        _super.prototype.resetInner.call(this);
        this._controllerGroup.removeAll();
        this._containerGroup.removeClipPath();
        this._containerGroup.__rectSize = null;
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.renderInner = function(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
        var self = this;
        // Render content items.
        _super.prototype.renderInner.call(this, itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
        var controllerGroup = this._controllerGroup;
        // FIXME: support be 'auto' adapt to size number text length,
        // e.g., '3/12345' should not overlap with the control arrow button.
        var pageIconSize = legendModel.get("pageIconSize", true);
        var pageIconSizeArr = $7a1bd9c2710fea0d$export$43bee75e5e14138e(pageIconSize) ? pageIconSize : [
            pageIconSize,
            pageIconSize
        ];
        createPageButton("pagePrev", 0);
        var pageTextStyleModel = legendModel.getModel("pageTextStyle");
        controllerGroup.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
            name: "pageText",
            style: {
                // Placeholder to calculate a proper layout.
                text: "xx/xx",
                fill: pageTextStyleModel.getTextColor(),
                font: pageTextStyleModel.getFont(),
                verticalAlign: "middle",
                align: "center"
            },
            silent: true
        }));
        createPageButton("pageNext", 1);
        function createPageButton(name, iconIdx) {
            var pageDataIndexName = name + "DataIndex";
            var icon = $5b455ae6f843ac47$export$274edc73af1ae9c8(legendModel.get("pageIcons", true)[legendModel.getOrient().name][iconIdx], {
                // Buttons will be created in each render, so we do not need
                // to worry about avoiding using legendModel kept in scope.
                onclick: $7a1bd9c2710fea0d$export$2385a24977818dd0(self._pageGo, self, pageDataIndexName, legendModel, api)
            }, {
                x: -pageIconSizeArr[0] / 2,
                y: -pageIconSizeArr[1] / 2,
                width: pageIconSizeArr[0],
                height: pageIconSizeArr[1]
            });
            icon.name = name;
            controllerGroup.add(icon);
        }
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.layoutInner = function(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
        var selectorGroup = this.getSelectorGroup();
        var orientIdx = legendModel.getOrient().index;
        var wh = $47ff4587191e73cd$var$WH[orientIdx];
        var xy = $47ff4587191e73cd$var$XY[orientIdx];
        var hw = $47ff4587191e73cd$var$WH[1 - orientIdx];
        var yx = $47ff4587191e73cd$var$XY[1 - orientIdx];
        selector && $93b9bc7f22ac7369$export$827f4ee28efc37(// Buttons in selectorGroup always layout horizontally
        "horizontal", selectorGroup, legendModel.get("selectorItemGap", true));
        var selectorButtonGap = legendModel.get("selectorButtonGap", true);
        var selectorRect = selectorGroup.getBoundingRect();
        var selectorPos = [
            -selectorRect.x,
            -selectorRect.y
        ];
        var processMaxSize = $7a1bd9c2710fea0d$export$9cd59f9826255e47(maxSize);
        selector && (processMaxSize[wh] = maxSize[wh] - selectorRect[wh] - selectorButtonGap);
        var mainRect = this._layoutContentAndController(legendModel, isFirstRender, processMaxSize, orientIdx, wh, hw, yx, xy);
        if (selector) {
            if (selectorPosition === "end") selectorPos[orientIdx] += mainRect[wh] + selectorButtonGap;
            else {
                var offset = selectorRect[wh] + selectorButtonGap;
                selectorPos[orientIdx] -= offset;
                mainRect[xy] -= offset;
            }
            mainRect[wh] += selectorRect[wh] + selectorButtonGap;
            selectorPos[1 - orientIdx] += mainRect[yx] + mainRect[hw] / 2 - selectorRect[hw] / 2;
            mainRect[hw] = Math.max(mainRect[hw], selectorRect[hw]);
            mainRect[yx] = Math.min(mainRect[yx], selectorRect[yx] + selectorPos[1 - orientIdx]);
            selectorGroup.x = selectorPos[0];
            selectorGroup.y = selectorPos[1];
            selectorGroup.markRedraw();
        }
        return mainRect;
    };
    ScrollableLegendView.prototype._layoutContentAndController = function(legendModel, isFirstRender, maxSize, orientIdx, wh, hw, yx, xy) {
        var contentGroup = this.getContentGroup();
        var containerGroup = this._containerGroup;
        var controllerGroup = this._controllerGroup;
        // Place items in contentGroup.
        $93b9bc7f22ac7369$export$827f4ee28efc37(legendModel.get("orient"), contentGroup, legendModel.get("itemGap"), !orientIdx ? null : maxSize.width, orientIdx ? null : maxSize.height);
        $93b9bc7f22ac7369$export$827f4ee28efc37(// Buttons in controller are layout always horizontally.
        "horizontal", controllerGroup, legendModel.get("pageButtonItemGap", true));
        var contentRect = contentGroup.getBoundingRect();
        var controllerRect = controllerGroup.getBoundingRect();
        var showController = this._showController = contentRect[wh] > maxSize[wh];
        // In case that the inner elements of contentGroup layout do not based on [0, 0]
        var contentPos = [
            -contentRect.x,
            -contentRect.y
        ];
        // Remain contentPos when scroll animation perfroming.
        // If first rendering, `contentGroup.position` is [0, 0], which
        // does not make sense and may cause unexepcted animation if adopted.
        if (!isFirstRender) contentPos[orientIdx] = contentGroup[xy];
        // Layout container group based on 0.
        var containerPos = [
            0,
            0
        ];
        var controllerPos = [
            -controllerRect.x,
            -controllerRect.y
        ];
        var pageButtonGap = $7a1bd9c2710fea0d$export$995e01f2f5c9d030(legendModel.get("pageButtonGap", true), legendModel.get("itemGap", true));
        // Place containerGroup and controllerGroup and contentGroup.
        if (showController) {
            var pageButtonPosition = legendModel.get("pageButtonPosition", true);
            // controller is on the right / bottom.
            if (pageButtonPosition === "end") controllerPos[orientIdx] += maxSize[wh] - controllerRect[wh];
            else containerPos[orientIdx] += controllerRect[wh] + pageButtonGap;
        }
        // Always align controller to content as 'middle'.
        controllerPos[1 - orientIdx] += contentRect[hw] / 2 - controllerRect[hw] / 2;
        contentGroup.setPosition(contentPos);
        containerGroup.setPosition(containerPos);
        controllerGroup.setPosition(controllerPos);
        // Calculate `mainRect` and set `clipPath`.
        // mainRect should not be calculated by `this.group.getBoundingRect()`
        // for sake of the overflow.
        var mainRect = {
            x: 0,
            y: 0
        };
        // Consider content may be overflow (should be clipped).
        mainRect[wh] = showController ? maxSize[wh] : contentRect[wh];
        mainRect[hw] = Math.max(contentRect[hw], controllerRect[hw]);
        // `containerRect[yx] + containerPos[1 - orientIdx]` is 0.
        mainRect[yx] = Math.min(0, controllerRect[yx] + controllerPos[1 - orientIdx]);
        containerGroup.__rectSize = maxSize[wh];
        if (showController) {
            var clipShape = {
                x: 0,
                y: 0
            };
            clipShape[wh] = Math.max(maxSize[wh] - controllerRect[wh] - pageButtonGap, 0);
            clipShape[hw] = mainRect[hw];
            containerGroup.setClipPath(new $419e5ff2f303755e$export$2e2bcd8739ae039({
                shape: clipShape
            }));
            // Consider content may be larger than container, container rect
            // can not be obtained from `containerGroup.getBoundingRect()`.
            containerGroup.__rectSize = clipShape[wh];
        } else // Do not remove or ignore controller. Keep them set as placeholders.
        controllerGroup.eachChild(function(child) {
            child.attr({
                invisible: true,
                silent: true
            });
        });
        // Content translate animation.
        var pageInfo = this._getPageInfo(legendModel);
        pageInfo.pageIndex != null && $8b353638fbedfefa$export$c8dce3c08436e91e(contentGroup, {
            x: pageInfo.contentPosition[0],
            y: pageInfo.contentPosition[1]
        }, // When switch from "show controller" to "not show controller", view should be
        // updated immediately without animation, otherwise causes weird effect.
        showController ? legendModel : null);
        this._updatePageInfoView(legendModel, pageInfo);
        return mainRect;
    };
    ScrollableLegendView.prototype._pageGo = function(to, legendModel, api) {
        var scrollDataIndex = this._getPageInfo(legendModel)[to];
        scrollDataIndex != null && api.dispatchAction({
            type: "legendScroll",
            scrollDataIndex: scrollDataIndex,
            legendId: legendModel.id
        });
    };
    ScrollableLegendView.prototype._updatePageInfoView = function(legendModel, pageInfo) {
        var controllerGroup = this._controllerGroup;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43([
            "pagePrev",
            "pageNext"
        ], function(name) {
            var key = name + "DataIndex";
            var canJump = pageInfo[key] != null;
            var icon = controllerGroup.childOfName(name);
            if (icon) {
                icon.setStyle("fill", canJump ? legendModel.get("pageIconColor", true) : legendModel.get("pageIconInactiveColor", true));
                icon.cursor = canJump ? "pointer" : "default";
            }
        });
        var pageText = controllerGroup.childOfName("pageText");
        var pageFormatter = legendModel.get("pageFormatter");
        var pageIndex = pageInfo.pageIndex;
        var current = pageIndex != null ? pageIndex + 1 : 0;
        var total = pageInfo.pageCount;
        pageText && pageFormatter && pageText.setStyle("text", $7a1bd9c2710fea0d$export$844ec244b1367d54(pageFormatter) ? pageFormatter.replace("{current}", current == null ? "" : current + "").replace("{total}", total == null ? "" : total + "") : pageFormatter({
            current: current,
            total: total
        }));
    };
    /**
   *  contentPosition: Array.<number>, null when data item not found.
   *  pageIndex: number, null when data item not found.
   *  pageCount: number, always be a number, can be 0.
   *  pagePrevDataIndex: number, null when no previous page.
   *  pageNextDataIndex: number, null when no next page.
   * }
   */ ScrollableLegendView.prototype._getPageInfo = function(legendModel) {
        var scrollDataIndex = legendModel.get("scrollDataIndex", true);
        var contentGroup = this.getContentGroup();
        var containerRectSize = this._containerGroup.__rectSize;
        var orientIdx = legendModel.getOrient().index;
        var wh = $47ff4587191e73cd$var$WH[orientIdx];
        var xy = $47ff4587191e73cd$var$XY[orientIdx];
        var targetItemIndex = this._findTargetItemIndex(scrollDataIndex);
        var children = contentGroup.children();
        var targetItem = children[targetItemIndex];
        var itemCount = children.length;
        var pCount = !itemCount ? 0 : 1;
        var result = {
            contentPosition: [
                contentGroup.x,
                contentGroup.y
            ],
            pageCount: pCount,
            pageIndex: pCount - 1,
            pagePrevDataIndex: null,
            pageNextDataIndex: null
        };
        if (!targetItem) return result;
        var targetItemInfo = getItemInfo(targetItem);
        result.contentPosition[orientIdx] = -targetItemInfo.s;
        // Strategy:
        // (1) Always align based on the left/top most item.
        // (2) It is user-friendly that the last item shown in the
        // current window is shown at the begining of next window.
        // Otherwise if half of the last item is cut by the window,
        // it will have no chance to display entirely.
        // (3) Consider that item size probably be different, we
        // have calculate pageIndex by size rather than item index,
        // and we can not get page index directly by division.
        // (4) The window is to narrow to contain more than
        // one item, we should make sure that the page can be fliped.
        for(var i = targetItemIndex + 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i <= itemCount; ++i){
            currItemInfo = getItemInfo(children[i]);
            if (// Half of the last item is out of the window.
            !currItemInfo && winEndItemInfo.e > winStartItemInfo.s + containerRectSize || currItemInfo && !intersect(currItemInfo, winStartItemInfo.s)) {
                if (winEndItemInfo.i > winStartItemInfo.i) winStartItemInfo = winEndItemInfo;
                else // e.g., when page size is smaller than item size.
                winStartItemInfo = currItemInfo;
                if (winStartItemInfo) {
                    if (result.pageNextDataIndex == null) result.pageNextDataIndex = winStartItemInfo.i;
                    ++result.pageCount;
                }
            }
            winEndItemInfo = currItemInfo;
        }
        for(var i = targetItemIndex - 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i >= -1; --i){
            currItemInfo = getItemInfo(children[i]);
            if (// If the the end item does not intersect with the window started
            // from the current item, a page can be settled.
            (!currItemInfo || !intersect(winEndItemInfo, currItemInfo.s)) && winStartItemInfo.i < winEndItemInfo.i) {
                winEndItemInfo = winStartItemInfo;
                if (result.pagePrevDataIndex == null) result.pagePrevDataIndex = winStartItemInfo.i;
                ++result.pageCount;
                ++result.pageIndex;
            }
            winStartItemInfo = currItemInfo;
        }
        return result;
        function getItemInfo(el) {
            if (el) {
                var itemRect = el.getBoundingRect();
                var start = itemRect[xy] + el[xy];
                return {
                    s: start,
                    e: start + itemRect[wh],
                    i: el.__legendDataIndex
                };
            }
        }
        function intersect(itemInfo, winStart) {
            return itemInfo.e >= winStart && itemInfo.s <= winStart + containerRectSize;
        }
    };
    ScrollableLegendView.prototype._findTargetItemIndex = function(targetDataIndex) {
        if (!this._showController) return 0;
        var index;
        var contentGroup = this.getContentGroup();
        var defaultIndex;
        contentGroup.eachChild(function(child, idx) {
            var legendDataIdx = child.__legendDataIndex;
            // FIXME
            // If the given targetDataIndex (from model) is illegal,
            // we use defaultIndex. But the index on the legend model and
            // action payload is still illegal. That case will not be
            // changed until some scenario requires.
            if (defaultIndex == null && legendDataIdx != null) defaultIndex = idx;
            if (legendDataIdx === targetDataIndex) index = idx;
        });
        return index != null ? index : defaultIndex;
    };
    ScrollableLegendView.type = "legend.scroll";
    return ScrollableLegendView;
}((0, $c2e212625ccc38b4$export$2e2bcd8739ae039));
var $47ff4587191e73cd$export$2e2bcd8739ae039 = $47ff4587191e73cd$var$ScrollableLegendView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $8ff9a37bcf939bdd$export$2e2bcd8739ae039(registers) {
    /**
   * @event legendScroll
   * @type {Object}
   * @property {string} type 'legendScroll'
   * @property {string} scrollDataIndex
   */ registers.registerAction("legendScroll", "legendscroll", function(payload, ecModel) {
        var scrollDataIndex = payload.scrollDataIndex;
        scrollDataIndex != null && ecModel.eachComponent({
            mainType: "legend",
            subType: "scroll",
            query: payload
        }, function(legendModel) {
            legendModel.setScrollDataIndex(scrollDataIndex);
        });
    });
}


function $2861842f2dfd6682$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $407c7fdad108ade5$export$4b3e715f166fdd78));
    registers.registerComponentModel((0, $a19f9768bdff02b5$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $47ff4587191e73cd$export$2e2bcd8739ae039));
    (0, $8ff9a37bcf939bdd$export$2e2bcd8739ae039)(registers);
}


function $1a0761510a437d9f$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $407c7fdad108ade5$export$4b3e715f166fdd78));
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $2861842f2dfd6682$export$4b3e715f166fdd78));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $bab2c9b6be98f0ce$export$2e2bcd8739ae039(seriesOpts, markerType) {
    if (!seriesOpts) return false;
    var seriesOptArr = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(seriesOpts) ? seriesOpts : [
        seriesOpts
    ];
    for(var idx = 0; idx < seriesOptArr.length; idx++){
        if (seriesOptArr[idx] && seriesOptArr[idx][markerType]) return true;
    }
    return false;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






function $1bab71219c0cd9a9$var$fillLabel(opt) {
    (0, $76d619f648247e6d$export$abdcc6a26372f94b)(opt, "label", [
        "show"
    ]);
}
// { [componentType]: MarkerModel }
var $1bab71219c0cd9a9$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $1bab71219c0cd9a9$var$MarkerModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MarkerModel, _super);
    function MarkerModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkerModel.type;
        /**
     * If marker model is created by self from series
     */ _this.createdBySelf = false;
        _this.preventAutoZ = true;
        return _this;
    }
    /**
   * @overrite
   */ MarkerModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        this._mergeOption(option, ecModel, false, true);
    };
    MarkerModel.prototype.isAnimationEnabled = function() {
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node) return false;
        var hostSeries = this.__hostSeries;
        return this.getShallow("animation") && hostSeries && hostSeries.isAnimationEnabled();
    };
    /**
   * @overrite
   */ MarkerModel.prototype.mergeOption = function(newOpt, ecModel) {
        this._mergeOption(newOpt, ecModel, false, false);
    };
    MarkerModel.prototype._mergeOption = function(newOpt, ecModel, createdBySelf, isInit) {
        var componentType = this.mainType;
        if (!createdBySelf) ecModel.eachSeries(function(seriesModel) {
            // mainType can be markPoint, markLine, markArea
            var markerOpt = seriesModel.get(this.mainType, true);
            var markerModel = $1bab71219c0cd9a9$var$inner(seriesModel)[componentType];
            if (!markerOpt || !markerOpt.data) {
                $1bab71219c0cd9a9$var$inner(seriesModel)[componentType] = null;
                return;
            }
            if (!markerModel) {
                if (isInit) // Default label emphasis `position` and `show`
                $1bab71219c0cd9a9$var$fillLabel(markerOpt);
                $7a1bd9c2710fea0d$export$79b2f7037acddd43(markerOpt.data, function(item) {
                    // FIXME Overwrite fillLabel method ?
                    if (item instanceof Array) {
                        $1bab71219c0cd9a9$var$fillLabel(item[0]);
                        $1bab71219c0cd9a9$var$fillLabel(item[1]);
                    } else $1bab71219c0cd9a9$var$fillLabel(item);
                });
                markerModel = this.createMarkerModelFromSeries(markerOpt, this, ecModel);
                // markerModel = new ImplementedMarkerModel(
                //     markerOpt, this, ecModel
                // );
                $7a1bd9c2710fea0d$export$8b58be045bf06082(markerModel, {
                    mainType: this.mainType,
                    // Use the same series index and name
                    seriesIndex: seriesModel.seriesIndex,
                    name: seriesModel.name,
                    createdBySelf: true
                });
                markerModel.__hostSeries = seriesModel;
            } else markerModel._mergeOption(markerOpt, ecModel, true);
            $1bab71219c0cd9a9$var$inner(seriesModel)[componentType] = markerModel;
        }, this);
    };
    MarkerModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var value = this.getRawValue(dataIndex);
        var itemName = data.getName(dataIndex);
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("section", {
            header: this.name,
            blocks: [
                (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
                    name: itemName,
                    value: value,
                    noName: !itemName,
                    noValue: value == null
                })
            ]
        });
    };
    MarkerModel.prototype.getData = function() {
        return this._data;
    };
    MarkerModel.prototype.setData = function(data) {
        this._data = data;
    };
    MarkerModel.prototype.getDataParams = function(dataIndex, dataType) {
        var params = (0, $655dd6075cc63601$export$f23396ae04ea95a7).prototype.getDataParams.call(this, dataIndex, dataType);
        var hostSeries = this.__hostSeries;
        if (hostSeries) {
            params.seriesId = hostSeries.id;
            params.seriesName = hostSeries.name;
            params.seriesType = hostSeries.subType;
        }
        return params;
    };
    MarkerModel.getMarkerModelFromSeries = function(seriesModel, // Support three types of markers. Strict check.
    componentType) {
        return $1bab71219c0cd9a9$var$inner(seriesModel)[componentType];
    };
    MarkerModel.type = "marker";
    MarkerModel.dependencies = [
        "series",
        "grid",
        "polar",
        "geo"
    ];
    return MarkerModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($1bab71219c0cd9a9$var$MarkerModel, (0, $655dd6075cc63601$export$f23396ae04ea95a7).prototype);
var $1bab71219c0cd9a9$export$2e2bcd8739ae039 = $1bab71219c0cd9a9$var$MarkerModel;


var $a4d9f6e367e83128$var$MarkAreaModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MarkAreaModel, _super);
    function MarkAreaModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkAreaModel.type;
        return _this;
    }
    MarkAreaModel.prototype.createMarkerModelFromSeries = function(markerOpt, masterMarkerModel, ecModel) {
        return new MarkAreaModel(markerOpt, masterMarkerModel, ecModel);
    };
    MarkAreaModel.type = "markArea";
    MarkAreaModel.defaultOption = {
        // zlevel: 0,
        // PENDING
        z: 1,
        tooltip: {
            trigger: "item"
        },
        // markArea should fixed on the coordinate system
        animation: false,
        label: {
            show: true,
            position: "top"
        },
        itemStyle: {
            // color and borderColor default to use color from series
            // color: 'auto'
            // borderColor: 'auto'
            borderWidth: 0
        },
        emphasis: {
            label: {
                show: true,
                position: "top"
            }
        }
    };
    return MarkAreaModel;
}((0, $1bab71219c0cd9a9$export$2e2bcd8739ae039));
var $a4d9f6e367e83128$export$2e2bcd8739ae039 = $a4d9f6e367e83128$var$MarkAreaModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



function $e4ec0ddef831b3b2$var$hasXOrY(item) {
    return !(isNaN(parseFloat(item.x)) && isNaN(parseFloat(item.y)));
}
function $e4ec0ddef831b3b2$var$hasXAndY(item) {
    return !isNaN(parseFloat(item.x)) && !isNaN(parseFloat(item.y));
}
function $e4ec0ddef831b3b2$var$markerTypeCalculatorWithExtent(markerType, data, axisDim, otherDataDim, targetDataDim, otherCoordIndex, targetCoordIndex) {
    var coordArr = [];
    var stacked = (0, $efdd976e4917927c$export$1dedc39359ae35c)(data, targetDataDim /* , otherDataDim */ );
    var calcDataDim = stacked ? data.getCalculationInfo("stackResultDimension") : targetDataDim;
    var value = $e4ec0ddef831b3b2$export$18ddefb55c03640b(data, calcDataDim, markerType);
    var seriesModel = data.hostModel;
    var dataIndex = seriesModel.indicesOfNearest(axisDim, calcDataDim, value)[0];
    coordArr[otherCoordIndex] = data.get(otherDataDim, dataIndex);
    coordArr[targetCoordIndex] = data.get(calcDataDim, dataIndex);
    var coordArrValue = data.get(targetDataDim, dataIndex);
    // Make it simple, do not visit all stacked value to count precision.
    var precision = $cfc1f3b422a3185f$export$e0c74b50bbd10f68(data.get(targetDataDim, dataIndex));
    precision = Math.min(precision, 20);
    if (precision >= 0) coordArr[targetCoordIndex] = +coordArr[targetCoordIndex].toFixed(precision);
    return [
        coordArr,
        coordArrValue
    ];
}
// TODO Specified percent
var $e4ec0ddef831b3b2$var$markerTypeCalculator = {
    min: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($e4ec0ddef831b3b2$var$markerTypeCalculatorWithExtent, "min"),
    max: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($e4ec0ddef831b3b2$var$markerTypeCalculatorWithExtent, "max"),
    average: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($e4ec0ddef831b3b2$var$markerTypeCalculatorWithExtent, "average"),
    median: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($e4ec0ddef831b3b2$var$markerTypeCalculatorWithExtent, "median")
};
function $e4ec0ddef831b3b2$export$3eebd2d54b98c04f(seriesModel, item) {
    if (!item) return;
    var data = seriesModel.getData();
    var coordSys = seriesModel.coordinateSystem;
    var dims = coordSys && coordSys.dimensions;
    // 1. If not specify the position with pixel directly
    // 2. If `coord` is not a data array. Which uses `xAxis`,
    // `yAxis` to specify the coord on each dimension
    // parseFloat first because item.x and item.y can be percent string like '20%'
    if (!$e4ec0ddef831b3b2$var$hasXAndY(item) && !(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(item.coord) && (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(dims)) {
        var axisInfo = $e4ec0ddef831b3b2$export$bd39458db76002ab(item, data, coordSys, seriesModel);
        // Clone the option
        // Transform the properties xAxis, yAxis, radiusAxis, angleAxis, geoCoord to value
        item = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(item);
        if (item.type && $e4ec0ddef831b3b2$var$markerTypeCalculator[item.type] && axisInfo.baseAxis && axisInfo.valueAxis) {
            var otherCoordIndex = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(dims, axisInfo.baseAxis.dim);
            var targetCoordIndex = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(dims, axisInfo.valueAxis.dim);
            var coordInfo = $e4ec0ddef831b3b2$var$markerTypeCalculator[item.type](data, axisInfo.valueAxis.dim, axisInfo.baseDataDim, axisInfo.valueDataDim, otherCoordIndex, targetCoordIndex);
            item.coord = coordInfo[0];
            // Force to use the value of calculated value.
            // let item use the value without stack.
            item.value = coordInfo[1];
        } else // FIXME Only has one of xAxis and yAxis.
        item.coord = [
            item.xAxis != null ? item.xAxis : item.radiusAxis,
            item.yAxis != null ? item.yAxis : item.angleAxis
        ];
    }
    // x y is provided
    if (item.coord == null || !(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(dims)) {
        item.coord = [];
        var baseAxis = seriesModel.getBaseAxis();
        if (baseAxis && item.type && $e4ec0ddef831b3b2$var$markerTypeCalculator[item.type]) {
            var otherAxis = coordSys.getOtherAxis(baseAxis);
            if (otherAxis) item.value = $e4ec0ddef831b3b2$export$18ddefb55c03640b(data, data.mapDimension(otherAxis.dim), item.type);
        }
    } else {
        // Each coord support max, min, average
        var coord = item.coord;
        for(var i = 0; i < 2; i++)if ($e4ec0ddef831b3b2$var$markerTypeCalculator[coord[i]]) coord[i] = $e4ec0ddef831b3b2$export$18ddefb55c03640b(data, data.mapDimension(dims[i]), coord[i]);
    }
    return item;
}
function $e4ec0ddef831b3b2$export$bd39458db76002ab(item, data, coordSys, seriesModel) {
    var ret = {};
    if (item.valueIndex != null || item.valueDim != null) {
        ret.valueDataDim = item.valueIndex != null ? data.getDimension(item.valueIndex) : item.valueDim;
        ret.valueAxis = coordSys.getAxis($e4ec0ddef831b3b2$var$dataDimToCoordDim(seriesModel, ret.valueDataDim));
        ret.baseAxis = coordSys.getOtherAxis(ret.valueAxis);
        ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
    } else {
        ret.baseAxis = seriesModel.getBaseAxis();
        ret.valueAxis = coordSys.getOtherAxis(ret.baseAxis);
        ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
        ret.valueDataDim = data.mapDimension(ret.valueAxis.dim);
    }
    return ret;
}
function $e4ec0ddef831b3b2$var$dataDimToCoordDim(seriesModel, dataDim) {
    var dimItem = seriesModel.getData().getDimensionInfo(dataDim);
    return dimItem && dimItem.coordDim;
}
function $e4ec0ddef831b3b2$export$179695f4a9040f73(// Currently only polar and cartesian has containData.
coordSys, item) {
    // Always return true if there is no coordSys
    return coordSys && coordSys.containData && item.coord && !$e4ec0ddef831b3b2$var$hasXOrY(item) ? coordSys.containData(item.coord) : true;
}
function $e4ec0ddef831b3b2$export$c869311b63462da6(// Currently only polar and cartesian has containData.
coordSys, item1, item2) {
    // Always return true if there is no coordSys
    return coordSys && coordSys.containZone && item1.coord && item2.coord && !$e4ec0ddef831b3b2$var$hasXOrY(item1) && !$e4ec0ddef831b3b2$var$hasXOrY(item2) ? coordSys.containZone(item1.coord, item2.coord) : true;
}
function $e4ec0ddef831b3b2$export$a53767c3c8f69cf7(inCoordSys, dims) {
    return inCoordSys ? function(item, dimName, dataIndex, dimIndex) {
        var rawVal = dimIndex < 2 ? item.coord && item.coord[dimIndex] : item.value;
        return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(rawVal, dims[dimIndex]);
    } : function(item, dimName, dataIndex, dimIndex) {
        return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(item.value, dims[dimIndex]);
    };
}
function $e4ec0ddef831b3b2$export$18ddefb55c03640b(data, valueDataDim, type) {
    if (type === "average") {
        var sum_1 = 0;
        var count_1 = 0;
        data.each(valueDataDim, function(val, idx) {
            if (!isNaN(val)) {
                sum_1 += val;
                count_1++;
            }
        });
        return sum_1 / count_1;
    } else if (type === "median") return data.getMedian(valueDataDim);
    else // max & min
    return data.getDataExtent(valueDataDim)[type === "max" ? 1 : 0];
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $ed6cf827ec8a4c83$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $ed6cf827ec8a4c83$var$MarkerView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MarkerView, _super);
    function MarkerView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkerView.type;
        return _this;
    }
    MarkerView.prototype.init = function() {
        this.markerGroupMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    };
    MarkerView.prototype.render = function(markerModel, ecModel, api) {
        var _this = this;
        var markerGroupMap = this.markerGroupMap;
        markerGroupMap.each(function(item) {
            $ed6cf827ec8a4c83$var$inner(item).keep = false;
        });
        ecModel.eachSeries(function(seriesModel) {
            var markerModel = (0, $1bab71219c0cd9a9$export$2e2bcd8739ae039).getMarkerModelFromSeries(seriesModel, _this.type);
            markerModel && _this.renderSeries(seriesModel, markerModel, ecModel, api);
        });
        markerGroupMap.each(function(item) {
            !$ed6cf827ec8a4c83$var$inner(item).keep && _this.group.remove(item.group);
        });
        $ed6cf827ec8a4c83$var$updateZ(ecModel, markerGroupMap, this.type);
    };
    MarkerView.prototype.markKeep = function(drawGroup) {
        $ed6cf827ec8a4c83$var$inner(drawGroup).keep = true;
    };
    MarkerView.prototype.toggleBlurSeries = function(seriesModelList, isBlur) {
        var _this = this;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(seriesModelList, function(seriesModel) {
            var markerModel = (0, $1bab71219c0cd9a9$export$2e2bcd8739ae039).getMarkerModelFromSeries(seriesModel, _this.type);
            if (markerModel) {
                var data = markerModel.getData();
                data.eachItemGraphicEl(function(el) {
                    if (el) isBlur ? (0, $2bf82c0980125b62$export$207f9cb3e1099375)(el) : (0, $2bf82c0980125b62$export$fd4a9ec75456d3c1)(el);
                });
            }
        });
    };
    MarkerView.type = "marker";
    return MarkerView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $ed6cf827ec8a4c83$var$updateZ(ecModel, markerGroupMap, type) {
    ecModel.eachSeries(function(seriesModel) {
        var markerModel = (0, $1bab71219c0cd9a9$export$2e2bcd8739ae039).getMarkerModelFromSeries(seriesModel, type);
        var markerDraw = markerGroupMap.get(seriesModel.id);
        if (markerModel && markerDraw && markerDraw.group) {
            var _a = (0, $5b455ae6f843ac47$export$1500a631bea5adda)(markerModel), z = _a.z, zlevel = _a.zlevel;
            (0, $5b455ae6f843ac47$export$d31cf465bf5e8879)(markerDraw.group, z, zlevel);
        }
    });
}
var $ed6cf827ec8a4c83$export$2e2bcd8739ae039 = $ed6cf827ec8a4c83$var$MarkerView;











var $83ebccb52de64002$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $83ebccb52de64002$var$markAreaTransform = function(seriesModel, coordSys, maModel, item) {
    // item may be null
    var item0 = item[0];
    var item1 = item[1];
    if (!item0 || !item1) return;
    var lt = $e4ec0ddef831b3b2$export$3eebd2d54b98c04f(seriesModel, item0);
    var rb = $e4ec0ddef831b3b2$export$3eebd2d54b98c04f(seriesModel, item1);
    // FIXME make sure lt is less than rb
    var ltCoord = lt.coord;
    var rbCoord = rb.coord;
    ltCoord[0] = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(ltCoord[0], -Infinity);
    ltCoord[1] = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(ltCoord[1], -Infinity);
    rbCoord[0] = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(rbCoord[0], Infinity);
    rbCoord[1] = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(rbCoord[1], Infinity);
    // Merge option into one
    var result = (0, $7a1bd9c2710fea0d$export$18aef43295bbe906)([
        {},
        lt,
        rb
    ]);
    result.coord = [
        lt.coord,
        rb.coord
    ];
    result.x0 = lt.x;
    result.y0 = lt.y;
    result.x1 = rb.x;
    result.y1 = rb.y;
    return result;
};
function $83ebccb52de64002$var$isInfinity(val) {
    return !isNaN(val) && !isFinite(val);
}
// If a markArea has one dim
function $83ebccb52de64002$var$ifMarkAreaHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
    var otherDimIndex = 1 - dimIndex;
    return $83ebccb52de64002$var$isInfinity(fromCoord[otherDimIndex]) && $83ebccb52de64002$var$isInfinity(toCoord[otherDimIndex]);
}
function $83ebccb52de64002$var$markAreaFilter(coordSys, item) {
    var fromCoord = item.coord[0];
    var toCoord = item.coord[1];
    var item0 = {
        coord: fromCoord,
        x: item.x0,
        y: item.y0
    };
    var item1 = {
        coord: toCoord,
        x: item.x1,
        y: item.y1
    };
    if ((0, $3fea949f0512eb55$export$8567506e6336616)(coordSys, "cartesian2d")) {
        // In case
        // {
        //  markArea: {
        //    data: [{ yAxis: 2 }]
        //  }
        // }
        if (fromCoord && toCoord && ($83ebccb52de64002$var$ifMarkAreaHasOnlyDim(1, fromCoord, toCoord, coordSys) || $83ebccb52de64002$var$ifMarkAreaHasOnlyDim(0, fromCoord, toCoord, coordSys))) return true;
        // Directly returning true may also do the work,
        // because markArea will not be shown automatically
        // when it's not included in coordinate system.
        // But filtering ahead can avoid keeping rendering markArea
        // when there are too many of them.
        return $e4ec0ddef831b3b2$export$c869311b63462da6(coordSys, item0, item1);
    }
    return $e4ec0ddef831b3b2$export$179695f4a9040f73(coordSys, item0) || $e4ec0ddef831b3b2$export$179695f4a9040f73(coordSys, item1);
}
// dims can be ['x0', 'y0'], ['x1', 'y1'], ['x0', 'y1'], ['x1', 'y0']
function $83ebccb52de64002$var$getSingleMarkerEndPoint(data, idx, dims, seriesModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var itemModel = data.getItemModel(idx);
    var point;
    var xPx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(itemModel.get(dims[0]), api.getWidth());
    var yPx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(itemModel.get(dims[1]), api.getHeight());
    if (!isNaN(xPx) && !isNaN(yPx)) point = [
        xPx,
        yPx
    ];
    else {
        // Chart like bar may have there own marker positioning logic
        if (seriesModel.getMarkerPosition) {
            // Consider the case that user input the right-bottom point first
            // Pick the larger x and y as 'x1' and 'y1'
            var pointValue0 = data.getValues([
                "x0",
                "y0"
            ], idx);
            var pointValue1 = data.getValues([
                "x1",
                "y1"
            ], idx);
            var clampPointValue0 = coordSys.clampData(pointValue0);
            var clampPointValue1 = coordSys.clampData(pointValue1);
            var pointValue = [];
            if (dims[0] === "x0") pointValue[0] = clampPointValue0[0] > clampPointValue1[0] ? pointValue1[0] : pointValue0[0];
            else pointValue[0] = clampPointValue0[0] > clampPointValue1[0] ? pointValue0[0] : pointValue1[0];
            if (dims[1] === "y0") pointValue[1] = clampPointValue0[1] > clampPointValue1[1] ? pointValue1[1] : pointValue0[1];
            else pointValue[1] = clampPointValue0[1] > clampPointValue1[1] ? pointValue0[1] : pointValue1[1];
            // Use the getMarkerPosition
            point = seriesModel.getMarkerPosition(pointValue, dims, true);
        } else {
            var x = data.get(dims[0], idx);
            var y = data.get(dims[1], idx);
            var pt = [
                x,
                y
            ];
            coordSys.clampData && coordSys.clampData(pt, pt);
            point = coordSys.dataToPoint(pt, true);
        }
        if ((0, $3fea949f0512eb55$export$8567506e6336616)(coordSys, "cartesian2d")) {
            // TODO: TYPE ts@4.1 may still infer it as Axis instead of Axis2D. Not sure if it's a bug
            var xAxis = coordSys.getAxis("x");
            var yAxis = coordSys.getAxis("y");
            var x = data.get(dims[0], idx);
            var y = data.get(dims[1], idx);
            if ($83ebccb52de64002$var$isInfinity(x)) point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[dims[0] === "x0" ? 0 : 1]);
            else if ($83ebccb52de64002$var$isInfinity(y)) point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[dims[1] === "y0" ? 0 : 1]);
        }
        // Use x, y if has any
        if (!isNaN(xPx)) point[0] = xPx;
        if (!isNaN(yPx)) point[1] = yPx;
    }
    return point;
}
var $83ebccb52de64002$export$fc5a505a325de211 = [
    [
        "x0",
        "y0"
    ],
    [
        "x1",
        "y0"
    ],
    [
        "x1",
        "y1"
    ],
    [
        "x0",
        "y1"
    ]
];
var $83ebccb52de64002$var$MarkAreaView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MarkAreaView, _super);
    function MarkAreaView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkAreaView.type;
        return _this;
    }
    MarkAreaView.prototype.updateTransform = function(markAreaModel, ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            var maModel = (0, $1bab71219c0cd9a9$export$2e2bcd8739ae039).getMarkerModelFromSeries(seriesModel, "markArea");
            if (maModel) {
                var areaData_1 = maModel.getData();
                areaData_1.each(function(idx) {
                    var points = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)($83ebccb52de64002$export$fc5a505a325de211, function(dim) {
                        return $83ebccb52de64002$var$getSingleMarkerEndPoint(areaData_1, idx, dim, seriesModel, api);
                    });
                    // Layout
                    areaData_1.setItemLayout(idx, points);
                    var el = areaData_1.getItemGraphicEl(idx);
                    el.setShape("points", points);
                });
            }
        }, this);
    };
    MarkAreaView.prototype.renderSeries = function(seriesModel, maModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var seriesId = seriesModel.id;
        var seriesData = seriesModel.getData();
        var areaGroupMap = this.markerGroupMap;
        var polygonGroup = areaGroupMap.get(seriesId) || areaGroupMap.set(seriesId, {
            group: new $7ef7583d8302ffce$export$2e2bcd8739ae039()
        });
        this.group.add(polygonGroup.group);
        this.markKeep(polygonGroup);
        var areaData = $83ebccb52de64002$var$createList(coordSys, seriesModel, maModel);
        // Line data for tooltip and formatter
        maModel.setData(areaData);
        // Update visual and layout of line
        areaData.each(function(idx) {
            // Layout
            var points = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)($83ebccb52de64002$export$fc5a505a325de211, function(dim) {
                return $83ebccb52de64002$var$getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
            });
            var xAxisScale = coordSys.getAxis("x").scale;
            var yAxisScale = coordSys.getAxis("y").scale;
            var xAxisExtent = xAxisScale.getExtent();
            var yAxisExtent = yAxisScale.getExtent();
            var xPointExtent = [
                xAxisScale.parse(areaData.get("x0", idx)),
                xAxisScale.parse(areaData.get("x1", idx))
            ];
            var yPointExtent = [
                yAxisScale.parse(areaData.get("y0", idx)),
                yAxisScale.parse(areaData.get("y1", idx))
            ];
            $cfc1f3b422a3185f$export$debe6e778e0a6d32(xPointExtent);
            $cfc1f3b422a3185f$export$debe6e778e0a6d32(yPointExtent);
            var overlapped = !(xAxisExtent[0] > xPointExtent[1] || xAxisExtent[1] < xPointExtent[0] || yAxisExtent[0] > yPointExtent[1] || yAxisExtent[1] < yPointExtent[0]);
            // If none of the area is inside coordSys, allClipped is set to be true
            // in layout so that label will not be displayed. See #12591
            var allClipped = !overlapped;
            areaData.setItemLayout(idx, {
                points: points,
                allClipped: allClipped
            });
            var itemModel = areaData.getItemModel(idx);
            var style = itemModel.getModel("itemStyle").getItemStyle();
            var z2 = itemModel.get("z2");
            var color = (0, $ea13f1ab2169d82d$export$d76e333a86ea1a2)(seriesData, "color");
            if (!style.fill) {
                style.fill = color;
                if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(style.fill)) style.fill = $2c037f5bda6341ca$export$ab4754bf42583a26(style.fill, 0.4);
            }
            if (!style.stroke) style.stroke = color;
            // Visual
            areaData.setItemVisual(idx, "style", style);
            areaData.setItemVisual(idx, "z2", (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(z2, 0));
        });
        areaData.diff($83ebccb52de64002$var$inner(polygonGroup).data).add(function(idx) {
            var layout = areaData.getItemLayout(idx);
            var z2 = areaData.getItemVisual(idx, "z2");
            if (!layout.allClipped) {
                var polygon = new $51acf033123e1a30$export$2e2bcd8739ae039({
                    z2: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(z2, 0),
                    shape: {
                        points: layout.points
                    }
                });
                areaData.setItemGraphicEl(idx, polygon);
                polygonGroup.group.add(polygon);
            }
        }).update(function(newIdx, oldIdx) {
            var polygon = $83ebccb52de64002$var$inner(polygonGroup).data.getItemGraphicEl(oldIdx);
            var layout = areaData.getItemLayout(newIdx);
            var z2 = areaData.getItemVisual(newIdx, "z2");
            if (!layout.allClipped) {
                if (polygon) $8b353638fbedfefa$export$c8dce3c08436e91e(polygon, {
                    z2: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(z2, 0),
                    shape: {
                        points: layout.points
                    }
                }, maModel, newIdx);
                else polygon = new $51acf033123e1a30$export$2e2bcd8739ae039({
                    shape: {
                        points: layout.points
                    }
                });
                areaData.setItemGraphicEl(newIdx, polygon);
                polygonGroup.group.add(polygon);
            } else if (polygon) polygonGroup.group.remove(polygon);
        }).remove(function(idx) {
            var polygon = $83ebccb52de64002$var$inner(polygonGroup).data.getItemGraphicEl(idx);
            polygonGroup.group.remove(polygon);
        }).execute();
        areaData.eachItemGraphicEl(function(polygon, idx) {
            var itemModel = areaData.getItemModel(idx);
            var style = areaData.getItemVisual(idx, "style");
            polygon.useStyle(areaData.getItemVisual(idx, "style"));
            (0, $6800dfcb6e1e2a44$export$9a13992917966657)(polygon, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
                labelFetcher: maModel,
                labelDataIndex: idx,
                defaultText: areaData.getName(idx) || "",
                inheritColor: (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(style.fill) ? $2c037f5bda6341ca$export$ab4754bf42583a26(style.fill, 1) : (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral99
            });
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polygon, itemModel);
            (0, $2bf82c0980125b62$export$e51187539ff11209)(polygon, null, null, itemModel.get([
                "emphasis",
                "disabled"
            ]));
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(polygon).dataModel = maModel;
        });
        $83ebccb52de64002$var$inner(polygonGroup).data = areaData;
        polygonGroup.group.silent = maModel.get("silent") || seriesModel.get("silent");
    };
    MarkAreaView.type = "markArea";
    return MarkAreaView;
}((0, $ed6cf827ec8a4c83$export$2e2bcd8739ae039));
function $83ebccb52de64002$var$createList(coordSys, seriesModel, maModel) {
    var areaData;
    var dataDims;
    var dims = [
        "x0",
        "y0",
        "x1",
        "y1"
    ];
    if (coordSys) {
        var coordDimsInfos_1 = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(coordSys && coordSys.dimensions, function(coordDim) {
            var data = seriesModel.getData();
            var info = data.getDimensionInfo(data.mapDimension(coordDim)) || {};
            // In map series data don't have lng and lat dimension. Fallback to same with coordSys
            return (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, info), {
                name: coordDim,
                // DON'T use ordinalMeta to parse and collect ordinal.
                ordinalMeta: null
            });
        });
        dataDims = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dims, function(dim, idx) {
            return {
                name: dim,
                type: coordDimsInfos_1[idx % 2].type
            };
        });
        areaData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(dataDims, maModel);
    } else {
        dataDims = [
            {
                name: "value",
                type: "float"
            }
        ];
        areaData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(dataDims, maModel);
    }
    var optData = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(maModel.get("data"), (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($83ebccb52de64002$var$markAreaTransform, seriesModel, coordSys, maModel));
    if (coordSys) optData = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(optData, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($83ebccb52de64002$var$markAreaFilter, coordSys));
    var dimValueGetter = coordSys ? function(item, dimName, dataIndex, dimIndex) {
        // TODO should convert to ParsedValue?
        var rawVal = item.coord[Math.floor(dimIndex / 2)][dimIndex % 2];
        return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(rawVal, dataDims[dimIndex]);
    } : function(item, dimName, dataIndex, dimIndex) {
        return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(item.value, dataDims[dimIndex]);
    };
    areaData.initData(optData, null, dimValueGetter);
    areaData.hasItemOption = true;
    return areaData;
}
var $83ebccb52de64002$export$2e2bcd8739ae039 = $83ebccb52de64002$var$MarkAreaView;


function $8a8e80722bf1c081$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $a4d9f6e367e83128$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $83ebccb52de64002$export$2e2bcd8739ae039));
    registers.registerPreprocessor(function(opt) {
        if ((0, $bab2c9b6be98f0ce$export$2e2bcd8739ae039)(opt.series, "markArea")) // Make sure markArea component is enabled
        opt.markArea = opt.markArea || {};
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $ed1b4c8534a4bb68$var$MarkLineModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MarkLineModel, _super);
    function MarkLineModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkLineModel.type;
        return _this;
    }
    MarkLineModel.prototype.createMarkerModelFromSeries = function(markerOpt, masterMarkerModel, ecModel) {
        return new MarkLineModel(markerOpt, masterMarkerModel, ecModel);
    };
    MarkLineModel.type = "markLine";
    MarkLineModel.defaultOption = {
        // zlevel: 0,
        z: 5,
        symbol: [
            "circle",
            "arrow"
        ],
        symbolSize: [
            8,
            16
        ],
        // symbolRotate: 0,
        symbolOffset: 0,
        precision: 2,
        tooltip: {
            trigger: "item"
        },
        label: {
            show: true,
            position: "end",
            distance: 5
        },
        lineStyle: {
            type: "dashed"
        },
        emphasis: {
            label: {
                show: true
            },
            lineStyle: {
                width: 3
            }
        },
        animationEasing: "linear"
    };
    return MarkLineModel;
}((0, $1bab71219c0cd9a9$export$2e2bcd8739ae039));
var $ed1b4c8534a4bb68$export$2e2bcd8739ae039 = $ed1b4c8534a4bb68$var$MarkLineModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 












var $87a9be5fb3657486$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $87a9be5fb3657486$var$markLineTransform = function(seriesModel, coordSys, mlModel, item) {
    var data = seriesModel.getData();
    var itemArray;
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(item)) {
        // Special type markLine like 'min', 'max', 'average', 'median'
        var mlType = item.type;
        if (mlType === "min" || mlType === "max" || mlType === "average" || mlType === "median" || item.xAxis != null || item.yAxis != null) {
            var valueAxis = void 0;
            var value = void 0;
            if (item.yAxis != null || item.xAxis != null) {
                valueAxis = coordSys.getAxis(item.yAxis != null ? "y" : "x");
                value = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(item.yAxis, item.xAxis);
            } else {
                var axisInfo = $e4ec0ddef831b3b2$export$bd39458db76002ab(item, data, coordSys, seriesModel);
                valueAxis = axisInfo.valueAxis;
                var valueDataDim = (0, $efdd976e4917927c$export$909db2be4938fbdf)(data, axisInfo.valueDataDim);
                value = $e4ec0ddef831b3b2$export$18ddefb55c03640b(data, valueDataDim, mlType);
            }
            var valueIndex = valueAxis.dim === "x" ? 0 : 1;
            var baseIndex = 1 - valueIndex;
            // Normized to 2d data with start and end point
            var mlFrom = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(item);
            var mlTo = {
                coord: []
            };
            mlFrom.type = null;
            mlFrom.coord = [];
            mlFrom.coord[baseIndex] = -Infinity;
            mlTo.coord[baseIndex] = Infinity;
            var precision = mlModel.get("precision");
            if (precision >= 0 && (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(value)) value = +value.toFixed(Math.min(precision, 20));
            mlFrom.coord[valueIndex] = mlTo.coord[valueIndex] = value;
            itemArray = [
                mlFrom,
                mlTo,
                {
                    type: mlType,
                    valueIndex: item.valueIndex,
                    // Force to use the value of calculated value.
                    value: value
                }
            ];
        } else itemArray = [];
    } else itemArray = item;
    var normalizedItem = [
        $e4ec0ddef831b3b2$export$3eebd2d54b98c04f(seriesModel, itemArray[0]),
        $e4ec0ddef831b3b2$export$3eebd2d54b98c04f(seriesModel, itemArray[1]),
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, itemArray[2])
    ];
    // Avoid line data type is extended by from(to) data type
    normalizedItem[2].type = normalizedItem[2].type || null;
    // Merge from option and to option into line option
    (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(normalizedItem[2], normalizedItem[0]);
    (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(normalizedItem[2], normalizedItem[1]);
    return normalizedItem;
};
function $87a9be5fb3657486$var$isInfinity(val) {
    return !isNaN(val) && !isFinite(val);
}
// If a markLine has one dim
function $87a9be5fb3657486$var$ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
    var otherDimIndex = 1 - dimIndex;
    var dimName = coordSys.dimensions[dimIndex];
    return $87a9be5fb3657486$var$isInfinity(fromCoord[otherDimIndex]) && $87a9be5fb3657486$var$isInfinity(toCoord[otherDimIndex]) && fromCoord[dimIndex] === toCoord[dimIndex] && coordSys.getAxis(dimName).containData(fromCoord[dimIndex]);
}
function $87a9be5fb3657486$var$markLineFilter(coordSys, item) {
    if (coordSys.type === "cartesian2d") {
        var fromCoord = item[0].coord;
        var toCoord = item[1].coord;
        // In case
        // {
        //  markLine: {
        //    data: [{ yAxis: 2 }]
        //  }
        // }
        if (fromCoord && toCoord && ($87a9be5fb3657486$var$ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || $87a9be5fb3657486$var$ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) return true;
    }
    return $e4ec0ddef831b3b2$export$179695f4a9040f73(coordSys, item[0]) && $e4ec0ddef831b3b2$export$179695f4a9040f73(coordSys, item[1]);
}
function $87a9be5fb3657486$var$updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var itemModel = data.getItemModel(idx);
    var point;
    var xPx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(itemModel.get("x"), api.getWidth());
    var yPx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(itemModel.get("y"), api.getHeight());
    if (!isNaN(xPx) && !isNaN(yPx)) point = [
        xPx,
        yPx
    ];
    else {
        // Chart like bar may have there own marker positioning logic
        if (seriesModel.getMarkerPosition) // Use the getMarkerPosition
        point = seriesModel.getMarkerPosition(data.getValues(data.dimensions, idx));
        else {
            var dims = coordSys.dimensions;
            var x = data.get(dims[0], idx);
            var y = data.get(dims[1], idx);
            point = coordSys.dataToPoint([
                x,
                y
            ]);
        }
        // Expand line to the edge of grid if value on one axis is Inifnity
        // In case
        //  markLine: {
        //    data: [{
        //      yAxis: 2
        //      // or
        //      type: 'average'
        //    }]
        //  }
        if ((0, $3fea949f0512eb55$export$8567506e6336616)(coordSys, "cartesian2d")) {
            // TODO: TYPE ts@4.1 may still infer it as Axis instead of Axis2D. Not sure if it's a bug
            var xAxis = coordSys.getAxis("x");
            var yAxis = coordSys.getAxis("y");
            var dims = coordSys.dimensions;
            if ($87a9be5fb3657486$var$isInfinity(data.get(dims[0], idx))) point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[isFrom ? 0 : 1]);
            else if ($87a9be5fb3657486$var$isInfinity(data.get(dims[1], idx))) point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[isFrom ? 0 : 1]);
        }
        // Use x, y if has any
        if (!isNaN(xPx)) point[0] = xPx;
        if (!isNaN(yPx)) point[1] = yPx;
    }
    data.setItemLayout(idx, point);
}
var $87a9be5fb3657486$var$MarkLineView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MarkLineView, _super);
    function MarkLineView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkLineView.type;
        return _this;
    }
    MarkLineView.prototype.updateTransform = function(markLineModel, ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            var mlModel = (0, $1bab71219c0cd9a9$export$2e2bcd8739ae039).getMarkerModelFromSeries(seriesModel, "markLine");
            if (mlModel) {
                var mlData_1 = mlModel.getData();
                var fromData_1 = $87a9be5fb3657486$var$inner(mlModel).from;
                var toData_1 = $87a9be5fb3657486$var$inner(mlModel).to;
                // Update visual and layout of from symbol and to symbol
                fromData_1.each(function(idx) {
                    $87a9be5fb3657486$var$updateSingleMarkerEndLayout(fromData_1, idx, true, seriesModel, api);
                    $87a9be5fb3657486$var$updateSingleMarkerEndLayout(toData_1, idx, false, seriesModel, api);
                });
                // Update layout of line
                mlData_1.each(function(idx) {
                    mlData_1.setItemLayout(idx, [
                        fromData_1.getItemLayout(idx),
                        toData_1.getItemLayout(idx)
                    ]);
                });
                this.markerGroupMap.get(seriesModel.id).updateLayout();
            }
        }, this);
    };
    MarkLineView.prototype.renderSeries = function(seriesModel, mlModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var seriesId = seriesModel.id;
        var seriesData = seriesModel.getData();
        var lineDrawMap = this.markerGroupMap;
        var lineDraw = lineDrawMap.get(seriesId) || lineDrawMap.set(seriesId, new (0, $a2fd63a0fc11274a$export$2e2bcd8739ae039)());
        this.group.add(lineDraw.group);
        var mlData = $87a9be5fb3657486$var$createList(coordSys, seriesModel, mlModel);
        var fromData = mlData.from;
        var toData = mlData.to;
        var lineData = mlData.line;
        $87a9be5fb3657486$var$inner(mlModel).from = fromData;
        $87a9be5fb3657486$var$inner(mlModel).to = toData;
        // Line data for tooltip and formatter
        mlModel.setData(lineData);
        // TODO
        // Functionally, `symbolSize` & `symbolOffset` can also be 2D array now.
        // But the related logic and type definition are not finished yet.
        // Finish it if required
        var symbolType = mlModel.get("symbol");
        var symbolSize = mlModel.get("symbolSize");
        var symbolRotate = mlModel.get("symbolRotate");
        var symbolOffset = mlModel.get("symbolOffset");
        // TODO: support callback function like markPoint
        if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(symbolType)) symbolType = [
            symbolType,
            symbolType
        ];
        if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(symbolSize)) symbolSize = [
            symbolSize,
            symbolSize
        ];
        if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(symbolRotate)) symbolRotate = [
            symbolRotate,
            symbolRotate
        ];
        if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(symbolOffset)) symbolOffset = [
            symbolOffset,
            symbolOffset
        ];
        // Update visual and layout of from symbol and to symbol
        mlData.from.each(function(idx) {
            updateDataVisualAndLayout(fromData, idx, true);
            updateDataVisualAndLayout(toData, idx, false);
        });
        // Update visual and layout of line
        lineData.each(function(idx) {
            var itemModel = lineData.getItemModel(idx);
            var lineStyle = itemModel.getModel("lineStyle").getLineStyle();
            // lineData.setItemVisual(idx, {
            //     color: lineColor || fromData.getItemVisual(idx, 'color')
            // });
            lineData.setItemLayout(idx, [
                fromData.getItemLayout(idx),
                toData.getItemLayout(idx)
            ]);
            var z2 = itemModel.get("z2");
            if (lineStyle.stroke == null) lineStyle.stroke = fromData.getItemVisual(idx, "style").fill;
            lineData.setItemVisual(idx, {
                z2: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(z2, 0),
                fromSymbolKeepAspect: fromData.getItemVisual(idx, "symbolKeepAspect"),
                fromSymbolOffset: fromData.getItemVisual(idx, "symbolOffset"),
                fromSymbolRotate: fromData.getItemVisual(idx, "symbolRotate"),
                fromSymbolSize: fromData.getItemVisual(idx, "symbolSize"),
                fromSymbol: fromData.getItemVisual(idx, "symbol"),
                toSymbolKeepAspect: toData.getItemVisual(idx, "symbolKeepAspect"),
                toSymbolOffset: toData.getItemVisual(idx, "symbolOffset"),
                toSymbolRotate: toData.getItemVisual(idx, "symbolRotate"),
                toSymbolSize: toData.getItemVisual(idx, "symbolSize"),
                toSymbol: toData.getItemVisual(idx, "symbol"),
                style: lineStyle
            });
        });
        lineDraw.updateData(lineData);
        // Set host model for tooltip
        // FIXME
        mlData.line.eachItemGraphicEl(function(el) {
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).dataModel = mlModel;
            el.traverse(function(child) {
                (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(child).dataModel = mlModel;
            });
        });
        function updateDataVisualAndLayout(data, idx, isFrom) {
            var itemModel = data.getItemModel(idx);
            $87a9be5fb3657486$var$updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api);
            var style = itemModel.getModel("itemStyle").getItemStyle();
            if (style.fill == null) style.fill = (0, $ea13f1ab2169d82d$export$d76e333a86ea1a2)(seriesData, "color");
            data.setItemVisual(idx, {
                symbolKeepAspect: itemModel.get("symbolKeepAspect"),
                // `0` should be considered as a valid value, so use `retrieve2` instead of `||`
                symbolOffset: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemModel.get("symbolOffset", true), symbolOffset[isFrom ? 0 : 1]),
                symbolRotate: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemModel.get("symbolRotate", true), symbolRotate[isFrom ? 0 : 1]),
                // TODO: when 2d array is supported, it should ignore parent
                symbolSize: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemModel.get("symbolSize"), symbolSize[isFrom ? 0 : 1]),
                symbol: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemModel.get("symbol", true), symbolType[isFrom ? 0 : 1]),
                style: style
            });
        }
        this.markKeep(lineDraw);
        lineDraw.group.silent = mlModel.get("silent") || seriesModel.get("silent");
    };
    MarkLineView.type = "markLine";
    return MarkLineView;
}((0, $ed6cf827ec8a4c83$export$2e2bcd8739ae039));
function $87a9be5fb3657486$var$createList(coordSys, seriesModel, mlModel) {
    var coordDimsInfos;
    if (coordSys) coordDimsInfos = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(coordSys && coordSys.dimensions, function(coordDim) {
        var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {};
        // In map series data don't have lng and lat dimension. Fallback to same with coordSys
        return (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, info), {
            name: coordDim,
            // DON'T use ordinalMeta to parse and collect ordinal.
            ordinalMeta: null
        });
    });
    else coordDimsInfos = [
        {
            name: "value",
            type: "float"
        }
    ];
    var fromData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(coordDimsInfos, mlModel);
    var toData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(coordDimsInfos, mlModel);
    // No dimensions
    var lineData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)([], mlModel);
    var optData = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(mlModel.get("data"), (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($87a9be5fb3657486$var$markLineTransform, seriesModel, coordSys, mlModel));
    if (coordSys) optData = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(optData, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($87a9be5fb3657486$var$markLineFilter, coordSys));
    var dimValueGetter = $e4ec0ddef831b3b2$export$a53767c3c8f69cf7(!!coordSys, coordDimsInfos);
    fromData.initData((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(optData, function(item) {
        return item[0];
    }), null, dimValueGetter);
    toData.initData((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(optData, function(item) {
        return item[1];
    }), null, dimValueGetter);
    lineData.initData((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(optData, function(item) {
        return item[2];
    }));
    lineData.hasItemOption = true;
    return {
        from: fromData,
        to: toData,
        line: lineData
    };
}
var $87a9be5fb3657486$export$2e2bcd8739ae039 = $87a9be5fb3657486$var$MarkLineView;


function $0fc27d0a088604ed$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $ed1b4c8534a4bb68$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $87a9be5fb3657486$export$2e2bcd8739ae039));
    registers.registerPreprocessor(function(opt) {
        if ((0, $bab2c9b6be98f0ce$export$2e2bcd8739ae039)(opt.series, "markLine")) // Make sure markLine component is enabled
        opt.markLine = opt.markLine || {};
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $2a559db54433a753$var$MarkPointModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MarkPointModel, _super);
    function MarkPointModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkPointModel.type;
        return _this;
    }
    MarkPointModel.prototype.createMarkerModelFromSeries = function(markerOpt, masterMarkerModel, ecModel) {
        return new MarkPointModel(markerOpt, masterMarkerModel, ecModel);
    };
    MarkPointModel.type = "markPoint";
    MarkPointModel.defaultOption = {
        // zlevel: 0,
        z: 5,
        symbol: "pin",
        symbolSize: 50,
        // symbolRotate: 0,
        // symbolOffset: [0, 0]
        tooltip: {
            trigger: "item"
        },
        label: {
            show: true,
            position: "inside"
        },
        itemStyle: {
            borderWidth: 2
        },
        emphasis: {
            label: {
                show: true
            }
        }
    };
    return MarkPointModel;
}((0, $1bab71219c0cd9a9$export$2e2bcd8739ae039));
var $2a559db54433a753$export$2e2bcd8739ae039 = $2a559db54433a753$var$MarkPointModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









function $80c0cdc6385c1c58$var$updateMarkerLayout(mpData, seriesModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var apiWidth = api.getWidth();
    var apiHeight = api.getHeight();
    var coordRect = coordSys && coordSys.getArea && coordSys.getArea();
    mpData.each(function(idx) {
        var itemModel = mpData.getItemModel(idx);
        var isRelativeToCoordinate = itemModel.get("relativeTo") === "coordinate";
        var width = isRelativeToCoordinate ? coordRect ? coordRect.width : 0 : apiWidth;
        var height = isRelativeToCoordinate ? coordRect ? coordRect.height : 0 : apiHeight;
        var left = isRelativeToCoordinate && coordRect ? coordRect.x : 0;
        var top = isRelativeToCoordinate && coordRect ? coordRect.y : 0;
        var point;
        var xPx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(itemModel.get("x"), width) + left;
        var yPx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(itemModel.get("y"), height) + top;
        if (!isNaN(xPx) && !isNaN(yPx)) point = [
            xPx,
            yPx
        ];
        else if (seriesModel.getMarkerPosition) // Use the getMarkerPosition
        point = seriesModel.getMarkerPosition(mpData.getValues(mpData.dimensions, idx));
        else if (coordSys) {
            var x = mpData.get(coordSys.dimensions[0], idx);
            var y = mpData.get(coordSys.dimensions[1], idx);
            point = coordSys.dataToPoint([
                x,
                y
            ]);
        }
        // Use x, y if has any
        if (!isNaN(xPx)) point[0] = xPx;
        if (!isNaN(yPx)) point[1] = yPx;
        mpData.setItemLayout(idx, point);
    });
}
var $80c0cdc6385c1c58$var$MarkPointView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MarkPointView, _super);
    function MarkPointView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkPointView.type;
        return _this;
    }
    MarkPointView.prototype.updateTransform = function(markPointModel, ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            var mpModel = (0, $1bab71219c0cd9a9$export$2e2bcd8739ae039).getMarkerModelFromSeries(seriesModel, "markPoint");
            if (mpModel) {
                $80c0cdc6385c1c58$var$updateMarkerLayout(mpModel.getData(), seriesModel, api);
                this.markerGroupMap.get(seriesModel.id).updateLayout();
            }
        }, this);
    };
    MarkPointView.prototype.renderSeries = function(seriesModel, mpModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var seriesId = seriesModel.id;
        var seriesData = seriesModel.getData();
        var symbolDrawMap = this.markerGroupMap;
        var symbolDraw = symbolDrawMap.get(seriesId) || symbolDrawMap.set(seriesId, new (0, $fedf62268297fcbb$export$2e2bcd8739ae039)());
        var mpData = $80c0cdc6385c1c58$var$createData(coordSys, seriesModel, mpModel);
        // FIXME
        mpModel.setData(mpData);
        $80c0cdc6385c1c58$var$updateMarkerLayout(mpModel.getData(), seriesModel, api);
        mpData.each(function(idx) {
            var itemModel = mpData.getItemModel(idx);
            var symbol = itemModel.getShallow("symbol");
            var symbolSize = itemModel.getShallow("symbolSize");
            var symbolRotate = itemModel.getShallow("symbolRotate");
            var symbolOffset = itemModel.getShallow("symbolOffset");
            var symbolKeepAspect = itemModel.getShallow("symbolKeepAspect");
            // TODO: refactor needed: single data item should not support callback function
            if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbol) || (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbolSize) || (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbolRotate) || (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbolOffset)) {
                var rawIdx = mpModel.getRawValue(idx);
                var dataParams = mpModel.getDataParams(idx);
                if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbol)) symbol = symbol(rawIdx, dataParams);
                if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbolSize)) // FIXME 这里不兼容 ECharts 2.x，2.x 貌似参数是整个数据？
                symbolSize = symbolSize(rawIdx, dataParams);
                if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbolRotate)) symbolRotate = symbolRotate(rawIdx, dataParams);
                if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbolOffset)) symbolOffset = symbolOffset(rawIdx, dataParams);
            }
            var style = itemModel.getModel("itemStyle").getItemStyle();
            var z2 = itemModel.get("z2");
            var color = (0, $ea13f1ab2169d82d$export$d76e333a86ea1a2)(seriesData, "color");
            if (!style.fill) style.fill = color;
            mpData.setItemVisual(idx, {
                z2: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(z2, 0),
                symbol: symbol,
                symbolSize: symbolSize,
                symbolRotate: symbolRotate,
                symbolOffset: symbolOffset,
                symbolKeepAspect: symbolKeepAspect,
                style: style
            });
        });
        // TODO Text are wrong
        symbolDraw.updateData(mpData);
        this.group.add(symbolDraw.group);
        // Set host model for tooltip
        // FIXME
        mpData.eachItemGraphicEl(function(el) {
            el.traverse(function(child) {
                (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(child).dataModel = mpModel;
            });
        });
        this.markKeep(symbolDraw);
        symbolDraw.group.silent = mpModel.get("silent") || seriesModel.get("silent");
    };
    MarkPointView.type = "markPoint";
    return MarkPointView;
}((0, $ed6cf827ec8a4c83$export$2e2bcd8739ae039));
function $80c0cdc6385c1c58$var$createData(coordSys, seriesModel, mpModel) {
    var coordDimsInfos;
    if (coordSys) coordDimsInfos = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(coordSys && coordSys.dimensions, function(coordDim) {
        var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {};
        // In map series data don't have lng and lat dimension. Fallback to same with coordSys
        return (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, info), {
            name: coordDim,
            // DON'T use ordinalMeta to parse and collect ordinal.
            ordinalMeta: null
        });
    });
    else coordDimsInfos = [
        {
            name: "value",
            type: "float"
        }
    ];
    var mpData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(coordDimsInfos, mpModel);
    var dataOpt = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(mpModel.get("data"), (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($e4ec0ddef831b3b2$export$3eebd2d54b98c04f, seriesModel));
    if (coordSys) dataOpt = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(dataOpt, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($e4ec0ddef831b3b2$export$179695f4a9040f73, coordSys));
    var dimValueGetter = $e4ec0ddef831b3b2$export$a53767c3c8f69cf7(!!coordSys, coordDimsInfos);
    mpData.initData(dataOpt, null, dimValueGetter);
    return mpData;
}
var $80c0cdc6385c1c58$export$2e2bcd8739ae039 = $80c0cdc6385c1c58$var$MarkPointView;


function $4edaa7c972a7e0d1$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $2a559db54433a753$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $80c0cdc6385c1c58$export$2e2bcd8739ae039));
    registers.registerPreprocessor(function(opt) {
        if ((0, $bab2c9b6be98f0ce$export$2e2bcd8739ae039)(opt.series, "markPoint")) // Make sure markPoint component is enabled
        opt.markPoint = opt.markPoint || {};
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $8d8dfe9e89a287c4$export$e605ddc25c355f0b = {
    level: 1,
    leaf: 2,
    nonLeaf: 3
};
var $8d8dfe9e89a287c4$export$f6f60f1901b7a690 = {
    // No clamp, be falsy, equals to null/undefined. It means if the input part is
    // null/undefined/NaN/outOfBoundary, the result part is NaN, rather than clamp to
    // the boundary of the matrix.
    none: 0,
    // Clamp, where null/undefined/NaN/outOfBoundary can be used to cover the entire row/column.
    all: 1,
    body: 2,
    corner: 3
};
function $8d8dfe9e89a287c4$export$7b1fafd1ec24d455(coordValue, dims, thisDimIdx // 0 | 1
) {
    // Find in body.
    var result = dims[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[thisDimIdx]].getCell(coordValue);
    // Find in corner or dimension area.
    if (!result && (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(coordValue) && coordValue < 0) result = dims[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[1 - thisDimIdx]].getUnitLayoutInfo(thisDimIdx, Math.round(coordValue));
    return result;
}
function $8d8dfe9e89a287c4$export$7083aa8e2f333744(out) {
    var rg = out || [];
    rg[0] = rg[0] || [];
    rg[1] = rg[1] || [];
    rg[0][0] = rg[0][1] = rg[1][0] = rg[1][1] = NaN;
    return rg;
}
function $8d8dfe9e89a287c4$export$1dc03edb4e724e02(locOut, // If illegal input or can not find any target, save reason to it.
// Do nothing if `NullUndefined`.
reasonOut, data, dims, clamp) {
    // x and y are supported to be handled separately - if one dimension is invalid
    // (may be users do not need that), the other one should also be calculated.
    $8d8dfe9e89a287c4$var$parseCoordRangeOptionOnOneDim(locOut[0], reasonOut, clamp, data, dims, 0);
    $8d8dfe9e89a287c4$var$parseCoordRangeOptionOnOneDim(locOut[1], reasonOut, clamp, data, dims, 1);
}
function $8d8dfe9e89a287c4$var$parseCoordRangeOptionOnOneDim(locDimOut, reasonOut, clamp, data, dims, dimIdx) {
    locDimOut[0] = Infinity;
    locDimOut[1] = -Infinity;
    var dataOnDim = data[dimIdx];
    var coordValArr = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(dataOnDim) ? dataOnDim : [
        dataOnDim
    ];
    var len = coordValArr.length;
    var hasClamp = !!clamp;
    if (len >= 1) {
        $8d8dfe9e89a287c4$var$parseCoordRangeOptionOnOneDimOnePart(locDimOut, reasonOut, coordValArr, hasClamp, dims, dimIdx, 0);
        if (len > 1) // Users may intuitively input the coords like `[[x1, x2, x3], ...]`;
        // consider the range as `[x1, x3]` in this case.
        $8d8dfe9e89a287c4$var$parseCoordRangeOptionOnOneDimOnePart(locDimOut, reasonOut, coordValArr, hasClamp, dims, dimIdx, len - 1);
    } else locDimOut[0] = locDimOut[1] = NaN;
    if (hasClamp) {
        // null/undefined/NaN or illegal data represents the entire row/column;
        // Cover the entire locator regardless of body or corner, and confine it later.
        var locLowerBound = -dims[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[1 - dimIdx]].getLocatorCount(dimIdx);
        var locUpperBound = dims[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]].getLocatorCount(dimIdx) - 1;
        if (clamp === $8d8dfe9e89a287c4$export$f6f60f1901b7a690.body) locLowerBound = (0, $cfc1f3b422a3185f$export$2ca8010d037f830f)(0, locLowerBound);
        else if (clamp === $8d8dfe9e89a287c4$export$f6f60f1901b7a690.corner) locUpperBound = (0, $cfc1f3b422a3185f$export$e411eeaf23dccbe8)(-1, locUpperBound);
        if (locUpperBound < locLowerBound) // Also considered that both x and y has no cell.
        locLowerBound = locUpperBound = NaN;
        if ((0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(locDimOut[0])) locDimOut[0] = locLowerBound;
        if ((0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(locDimOut[1])) locDimOut[1] = locUpperBound;
        locDimOut[0] = (0, $cfc1f3b422a3185f$export$2ca8010d037f830f)((0, $cfc1f3b422a3185f$export$e411eeaf23dccbe8)(locDimOut[0], locUpperBound), locLowerBound);
        locDimOut[1] = (0, $cfc1f3b422a3185f$export$2ca8010d037f830f)((0, $cfc1f3b422a3185f$export$e411eeaf23dccbe8)(locDimOut[1], locUpperBound), locLowerBound);
    }
}
// The return val must be finite or NaN.
function $8d8dfe9e89a287c4$var$parseCoordRangeOptionOnOneDimOnePart(locDimOut, reasonOut, coordValArr, hasClamp, dims, dimIdx, partIdx) {
    var layout = $8d8dfe9e89a287c4$export$7b1fafd1ec24d455(coordValArr[partIdx], dims, dimIdx);
    if (!layout) {
        locDimOut[0] = locDimOut[1] = NaN;
        return;
    }
    var locatorA = layout.id[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]];
    var locatorB = locatorA;
    var dimCell = $8d8dfe9e89a287c4$var$cellLayoutInfoToDimCell(layout);
    if (dimCell) // Handle non-leaf
    locatorB += dimCell.span[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]] - 1;
    locDimOut[0] = (0, $cfc1f3b422a3185f$export$e411eeaf23dccbe8)(locDimOut[0], locatorA, locatorB);
    locDimOut[1] = (0, $cfc1f3b422a3185f$export$2ca8010d037f830f)(locDimOut[1], locatorA, locatorB);
}
function $8d8dfe9e89a287c4$export$6f30d23446b696e5(locatorRange, dimIdx) {
    return (0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(locatorRange[dimIdx][0]) || (0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(locatorRange[dimIdx][1]);
}
function $8d8dfe9e89a287c4$export$e83f541b68a414bd(inOutLocatorRange, // Item indices coorespond to mergeDefList (len: mergeDefListTravelLen).
// Indicating whether each item has be merged into the `locatorRange`
outMergedMarkList, mergeDefList, mergeDefListTravelLen) {
    outMergedMarkList = outMergedMarkList || $8d8dfe9e89a287c4$var$_tmpOutMergedMarkList;
    for(var idx = 0; idx < mergeDefListTravelLen; idx++)outMergedMarkList[idx] = false;
    // In most case, cell merging definition list length is smaller than the range extent,
    // therefore, to detection intersection, travelling cell merging definition list is probably
    // performant than traveling the four edges of the rect formed by the locator range.
    while(true){
        var expanded = false;
        for(var idx = 0; idx < mergeDefListTravelLen; idx++){
            var mergeDef = mergeDefList[idx];
            if (!outMergedMarkList[idx] && mergeDef.cellMergeOwner && $8d8dfe9e89a287c4$var$expandXYLocatorRangeIfIntersect(inOutLocatorRange, mergeDef.locatorRange)) {
                outMergedMarkList[idx] = true;
                expanded = true;
            }
        }
        if (!expanded) break;
    }
}
var $8d8dfe9e89a287c4$var$_tmpOutMergedMarkList = [];
// Return whether intersect.
// `thisLocRange` will be expanded (modified) if an intersection is encountered.
function $8d8dfe9e89a287c4$var$expandXYLocatorRangeIfIntersect(thisLocRange, otherLocRange) {
    if (!$8d8dfe9e89a287c4$var$locatorRangeIntersectOneDim(thisLocRange[0], otherLocRange[0]) || !$8d8dfe9e89a287c4$var$locatorRangeIntersectOneDim(thisLocRange[1], otherLocRange[1])) return false;
    thisLocRange[0][0] = (0, $cfc1f3b422a3185f$export$e411eeaf23dccbe8)(thisLocRange[0][0], otherLocRange[0][0]);
    thisLocRange[0][1] = (0, $cfc1f3b422a3185f$export$2ca8010d037f830f)(thisLocRange[0][1], otherLocRange[0][1]);
    thisLocRange[1][0] = (0, $cfc1f3b422a3185f$export$e411eeaf23dccbe8)(thisLocRange[1][0], otherLocRange[1][0]);
    thisLocRange[1][1] = (0, $cfc1f3b422a3185f$export$2ca8010d037f830f)(thisLocRange[1][1], otherLocRange[1][1]);
    return true;
}
// Notice: If containing NaN, not intersect.
function $8d8dfe9e89a287c4$var$locatorRangeIntersectOneDim(locRange1OneDim, locRange2OneDim) {
    return locRange1OneDim[1] >= locRange2OneDim[0] && locRange1OneDim[0] <= locRange2OneDim[1];
}
function $8d8dfe9e89a287c4$export$af43ef7117c4b8ed(owner, locatorRange) {
    owner.id.set(locatorRange[0][0], locatorRange[1][0]);
    owner.span.set(locatorRange[0][1] - owner.id.x + 1, locatorRange[1][1] - owner.id.y + 1);
}
function $8d8dfe9e89a287c4$export$1939176e25597afc(target, source) {
    target[0][0] = source[0][0];
    target[0][1] = source[0][1];
    target[1][0] = source[1][0];
    target[1][1] = source[1][1];
}
function $8d8dfe9e89a287c4$export$209b48cb1590c2e6(oneDimOut, locRange, dims, dimIdx) {
    var layoutMin = $8d8dfe9e89a287c4$export$7b1fafd1ec24d455(locRange[dimIdx][0], dims, dimIdx);
    var layoutMax = $8d8dfe9e89a287c4$export$7b1fafd1ec24d455(locRange[dimIdx][1], dims, dimIdx);
    oneDimOut[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]] = oneDimOut[(0, $5b455ae6f843ac47$export$a3fe6d967173a3ac)[dimIdx]] = NaN;
    if (layoutMin && layoutMax) {
        oneDimOut[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]] = layoutMin.xy;
        oneDimOut[(0, $5b455ae6f843ac47$export$a3fe6d967173a3ac)[dimIdx]] = layoutMax.xy + layoutMax.wh - layoutMin.xy;
    }
}
function $8d8dfe9e89a287c4$export$4c9247b5137873ac(out, dimIdx, // 0 | 1
valueOnThisDim, valueOnOtherDim) {
    out[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]] = valueOnThisDim;
    out[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[1 - dimIdx]] = valueOnOtherDim;
    return out;
}
/**
 * Return NullUndefined if not dimension cell.
 */ function $8d8dfe9e89a287c4$var$cellLayoutInfoToDimCell(cellLayoutInfo) {
    return cellLayoutInfo && (cellLayoutInfo.type === $8d8dfe9e89a287c4$export$e605ddc25c355f0b.leaf || cellLayoutInfo.type === $8d8dfe9e89a287c4$export$e605ddc25c355f0b.nonLeaf) ? cellLayoutInfo : null;
}
function $8d8dfe9e89a287c4$export$97431b409739b7a9() {
    return {
        x: NaN,
        y: NaN,
        width: NaN,
        height: NaN
    };
}




/**
 * Lifetime: the same with `MatrixModel`, but different from `coord/Matrix`.
 */ var $4297d32c91f2432d$export$1a8bd0fc6596656f = /** @class */ function() {
    function MatrixDim(dim, dimModel) {
        // Under the current definition, every leave corresponds a unit cell,
        // and leaves can serve as the locator of cells.
        // Therefore make sure:
        //  - The first `_leavesCount` elements in `_cells` are leaves.
        //  - `_cells[leaf.id[XY[this.dimIdx]]]` is the leaf itself.
        //  - Leaves of each subtree are placed together, that is, the leaves of a dimCell are:
        //    `this._cells.slice(dimCell.firstLeafLocator, dimCell.span[XY[this.dimIdx]])`
        this._cells = [];
        // Can be visited by `_levels[cell.level]` or `_levels[cell.id[1 - dimIdx] + _levels.length]`.
        // Items are never be null/undefined after initialized.
        this._levels = [];
        this.dim = dim;
        this.dimIdx = dim === "x" ? 0 : 1;
        this._model = dimModel;
        this._uniqueValueGen = $4297d32c91f2432d$var$createUniqueValueGenerator(dim);
        var dimModelData = dimModel.get("data", true);
        if (dimModelData != null && !(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(dimModelData)) dimModelData = [];
        if (dimModelData) this._initByDimModelData(dimModelData);
        else this._initBySeriesData();
    }
    MatrixDim.prototype._initByDimModelData = function(dimModelData) {
        var self = this;
        var _cells = self._cells;
        var _levels = self._levels;
        var sameLocatorCellsLists = []; // Save for sorting.
        var _cellCount = 0;
        self._leavesCount = traverseInitCells(dimModelData, 0, 0);
        postInitCells();
        return;
        function traverseInitCells(dimModelData, firstLeafLocator, level) {
            var totalSpan = 0;
            if (!dimModelData) return totalSpan;
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dimModelData, function(option, optionIdx) {
                var invalidOption = false;
                var cellOption;
                if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(option)) cellOption = {
                    value: option
                };
                else if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(option)) {
                    cellOption = option;
                    if (option.value != null && !(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(option.value)) {
                        invalidOption = true;
                        cellOption = {
                            value: null
                        };
                    }
                } else {
                    cellOption = {
                        value: null
                    };
                    if (option != null) invalidOption = true;
                }
                invalidOption;
                var cell = {
                    type: (0, $8d8dfe9e89a287c4$export$e605ddc25c355f0b).nonLeaf,
                    ordinal: NaN,
                    level: level,
                    firstLeafLocator: firstLeafLocator,
                    id: new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(),
                    span: (0, $8d8dfe9e89a287c4$export$4c9247b5137873ac)(new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(), self.dimIdx, 1, 1),
                    option: cellOption,
                    xy: NaN,
                    wh: NaN,
                    dim: self,
                    rect: (0, $8d8dfe9e89a287c4$export$97431b409739b7a9)()
                };
                _cellCount++;
                (sameLocatorCellsLists[firstLeafLocator] || (sameLocatorCellsLists[firstLeafLocator] = [])).push(cell);
                if (!_levels[level]) // Create a level only if at least one cell exists.
                _levels[level] = {
                    type: (0, $8d8dfe9e89a287c4$export$e605ddc25c355f0b).level,
                    xy: NaN,
                    wh: NaN,
                    option: null,
                    id: new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(),
                    dim: self
                };
                var childrenSpan = traverseInitCells(cellOption.children, firstLeafLocator, level + 1);
                var subSpan = Math.max(1, childrenSpan);
                cell.span[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[self.dimIdx]] = subSpan;
                totalSpan += subSpan;
                firstLeafLocator += subSpan;
            });
            return totalSpan;
        }
        function postInitCells() {
            // Sort to make sure the leaves are at the beginning, so that
            // they can be used as the locator of body cells.
            var categories = [];
            while(_cells.length < _cellCount)for(var locator = 0; locator < sameLocatorCellsLists.length; locator++){
                var cell = sameLocatorCellsLists[locator].pop();
                if (cell) {
                    cell.ordinal = categories.length;
                    var val = cell.option.value;
                    categories.push(val);
                    _cells.push(cell);
                    self._uniqueValueGen.calcDupBase(val);
                }
            }
            self._uniqueValueGen.ensureValueUnique(categories, _cells);
            var ordinalMeta = self._ordinalMeta = new (0, $57fe7cbbaae9fab0$export$2e2bcd8739ae039)({
                categories: categories,
                needCollect: false,
                deduplication: false
            });
            self._scale = new (0, $6e82606ec775d365$export$2e2bcd8739ae039)({
                ordinalMeta: ordinalMeta
            });
            for(var idx = 0; idx < self._leavesCount; idx++){
                var leaf = self._cells[idx];
                leaf.type = (0, $8d8dfe9e89a287c4$export$e605ddc25c355f0b).leaf;
                // Handle the tree level variation: enlarge the span of the leaves to reach the body cells.
                leaf.span[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[1 - self.dimIdx]] = self._levels.length - leaf.level;
            }
            self._initCellsId();
            self._initLevelIdOptions();
        }
    };
    MatrixDim.prototype._initBySeriesData = function() {
        var self = this;
        self._leavesCount = 0;
        self._levels = [
            {
                type: (0, $8d8dfe9e89a287c4$export$e605ddc25c355f0b).level,
                xy: NaN,
                wh: NaN,
                option: null,
                id: new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(),
                dim: self
            }
        ];
        self._initLevelIdOptions();
        var ordinalMeta = self._ordinalMeta = new (0, $57fe7cbbaae9fab0$export$2e2bcd8739ae039)({
            needCollect: true,
            deduplication: true,
            onCollect: function(value, ordinalNumber) {
                var cell = self._cells[ordinalNumber] = {
                    type: (0, $8d8dfe9e89a287c4$export$e605ddc25c355f0b).leaf,
                    ordinal: ordinalNumber,
                    level: 0,
                    firstLeafLocator: ordinalNumber,
                    id: new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(),
                    span: (0, $8d8dfe9e89a287c4$export$4c9247b5137873ac)(new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(), self.dimIdx, 1, 1),
                    // Theoretically `value` is from `dataset` or `series.data`, so it may be any type.
                    // Do not restrict this case for user's convenience, and here simply convert it to
                    // string for display.
                    option: {
                        value: value + ""
                    },
                    xy: NaN,
                    wh: NaN,
                    dim: self,
                    rect: (0, $8d8dfe9e89a287c4$export$97431b409739b7a9)()
                };
                self._leavesCount++;
                self._setCellId(cell);
            }
        });
        self._scale = new (0, $6e82606ec775d365$export$2e2bcd8739ae039)({
            ordinalMeta: ordinalMeta
        });
    };
    MatrixDim.prototype._setCellId = function(cell) {
        var levelsLen = this._levels.length;
        var dimIdx = this.dimIdx;
        (0, $8d8dfe9e89a287c4$export$4c9247b5137873ac)(cell.id, dimIdx, cell.firstLeafLocator, cell.level - levelsLen);
    };
    MatrixDim.prototype._initCellsId = function() {
        var levelsLen = this._levels.length;
        var dimIdx = this.dimIdx;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._cells, function(cell) {
            (0, $8d8dfe9e89a287c4$export$4c9247b5137873ac)(cell.id, dimIdx, cell.firstLeafLocator, cell.level - levelsLen);
        });
    };
    MatrixDim.prototype._initLevelIdOptions = function() {
        var levelsLen = this._levels.length;
        var dimIdx = this.dimIdx;
        var levelOptionList = this._model.get("levels", true);
        levelOptionList = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(levelOptionList) ? levelOptionList : [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._levels, function(levelCfg, level) {
            (0, $8d8dfe9e89a287c4$export$4c9247b5137873ac)(levelCfg.id, dimIdx, 0, level - levelsLen);
            levelCfg.option = levelOptionList[level];
        });
    };
    MatrixDim.prototype.shouldShow = function() {
        return !!this._model.getShallow("show", true);
    };
    /**
   * Iterate leaves (they are layout units) if dimIdx === this.dimIdx.
   * Iterate levels if dimIdx !== this.dimIdx.
   */ MatrixDim.prototype.resetLayoutIterator = function(it, dimIdx, startLocator, count) {
        it = it || new (0, $76d619f648247e6d$export$4e38036c4470d56c)();
        if (dimIdx === this.dimIdx) {
            var len = this._leavesCount;
            var startIdx = startLocator != null ? Math.max(0, startLocator) : 0;
            count = count != null ? Math.min(count, len) : len;
            it.reset(this._cells, startIdx, startIdx + count);
        } else {
            var len = this._levels.length;
            // Corner locator is from `-this._levels.length` to `-1`.
            var startIdx = startLocator != null ? Math.max(0, startLocator + len) : 0;
            count = count != null ? Math.min(count, len) : len;
            it.reset(this._levels, startIdx, startIdx + count);
        }
        return it;
    };
    MatrixDim.prototype.resetCellIterator = function(it) {
        return (it || new (0, $76d619f648247e6d$export$4e38036c4470d56c)()).reset(this._cells, 0);
    };
    MatrixDim.prototype.resetLevelIterator = function(it) {
        return (it || new (0, $76d619f648247e6d$export$4e38036c4470d56c)()).reset(this._levels, 0);
    };
    MatrixDim.prototype.getLayout = function(outRect, dimIdx, locator) {
        var layout = this.getUnitLayoutInfo(dimIdx, locator);
        outRect[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]] = layout ? layout.xy : NaN;
        outRect[(0, $5b455ae6f843ac47$export$a3fe6d967173a3ac)[dimIdx]] = layout ? layout.wh : NaN;
    };
    /**
   * Get leaf cell or get level info.
   * Should be able to return null/undefined if not found on x or y, thus input `dimIdx` is needed.
   */ MatrixDim.prototype.getUnitLayoutInfo = function(dimIdx, locator) {
        return dimIdx === this.dimIdx ? locator < this._leavesCount ? this._cells[locator] : undefined : this._levels[locator + this._levels.length];
    };
    /**
   * Get dimension cell by data, including leaves and non-leaves.
   */ MatrixDim.prototype.getCell = function(value) {
        var ordinal = this._scale.parse(value);
        return (0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(ordinal) ? undefined : this._cells[ordinal];
    };
    /**
   * Get leaf count or get level count.
   */ MatrixDim.prototype.getLocatorCount = function(dimIdx) {
        return dimIdx === this.dimIdx ? this._leavesCount : this._levels.length;
    };
    MatrixDim.prototype.getOrdinalMeta = function() {
        return this._ordinalMeta;
    };
    return MatrixDim;
}();
function $4297d32c91f2432d$var$createUniqueValueGenerator(dim) {
    var dimUpper = dim.toUpperCase();
    var defaultValReg = new RegExp("^" + dimUpper + "([0-9]+)$");
    var dupBase = 0;
    function calcDupBase(val) {
        var matchResult;
        if (val != null && (matchResult = val.match(defaultValReg))) dupBase = (0, $cfc1f3b422a3185f$export$2ca8010d037f830f)(dupBase, +matchResult[1] + 1);
    }
    function makeUniqueValue() {
        return "" + dimUpper + dupBase++;
    }
    // Duplicated value is allowed, because the `matrix.x/y.data` can be a tree and it's reasonable
    // that leaves in different subtrees has the same text. But only the first one is allowed to be
    // queried by the text, and the other ones can only be queried by index.
    // Additionally, `matrix.x/y.data: [null, null, ...]` is allowed.
    function ensureValueUnique(categories, cells) {
        // A simple way to deduplicate or handle illegal or not specified values to avoid unexpected behaviors.
        // The tree structure should not be broken even if duplicated.
        var cateMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        for(var idx = 0; idx < categories.length; idx++){
            var value = categories[idx];
            // value may be set to NullUndefined by users or if illegal.
            if (value == null || cateMap.get(value) != null) {
                // Still display the original option.value if duplicated, but loose the ability to query by text.
                categories[idx] = value = makeUniqueValue();
                cells[idx].option = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                    value: value
                }, cells[idx].option);
            }
            cateMap.set(value, true);
        }
    }
    return {
        calcDupBase: calcDupBase,
        ensureValueUnique: ensureValueUnique
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/**
 * Lifetime: the same with `MatrixModel`, but different from `coord/Matrix`.
 */ var $087d6423f4ac0e67$export$4a91097e7bc6c9d0 = /** @class */ function() {
    function MatrixBodyCorner(kind, bodyOrCornerModel, dims) {
        this._model = bodyOrCornerModel;
        this._dims = dims;
        this._kind = kind;
        this._cellMergeOwnerList = [];
    }
    /**
   * Can not be called before series models initialization finished, since the ordinalMeta may
   * use collect the values from `series.data` in series initialization.
   */ MatrixBodyCorner.prototype._ensureCellMap = function() {
        var self = this;
        var _cellMap = self._cellMap;
        if (!_cellMap) {
            _cellMap = self._cellMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
            fillCellMap();
        }
        return _cellMap;
        function fillCellMap() {
            var parsedList = [];
            var cellOptionList = self._model.getShallow("data");
            if (cellOptionList && !(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(cellOptionList)) cellOptionList = null;
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(cellOptionList, function(option, idx) {
                if (!(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(option) || !(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(option.coord)) return;
                var locatorRange = (0, $8d8dfe9e89a287c4$export$7083aa8e2f333744)([]);
                var reasonArr = null;
                (0, $8d8dfe9e89a287c4$export$1dc03edb4e724e02)(locatorRange, reasonArr, option.coord, self._dims, option.coordClamp ? (0, $8d8dfe9e89a287c4$export$f6f60f1901b7a690)[self._kind] : (0, $8d8dfe9e89a287c4$export$f6f60f1901b7a690).none);
                if ((0, $8d8dfe9e89a287c4$export$6f30d23446b696e5)(locatorRange, 0) || (0, $8d8dfe9e89a287c4$export$6f30d23446b696e5)(locatorRange, 1)) return;
                var cellMergeOwner = option && option.mergeCells;
                var parsed = {
                    id: new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(),
                    span: new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(),
                    locatorRange: locatorRange,
                    option: option,
                    cellMergeOwner: cellMergeOwner
                };
                (0, $8d8dfe9e89a287c4$export$af43ef7117c4b8ed)(parsed, locatorRange);
                // The order of the `parsedList` determines the precedence of the styles, if there
                // are overlaps between ranges specified in different items. Preserve the original
                // order of `matrix.body/corner/data` to make it predictable for users.
                parsedList.push(parsed);
            });
            // Resolve cell merging intersection - union to a larger rect.
            var mergedMarkList = [];
            for(var parsedIdx = 0; parsedIdx < parsedList.length; parsedIdx++){
                var parsed = parsedList[parsedIdx];
                if (!parsed.cellMergeOwner) continue;
                var locatorRange = parsed.locatorRange;
                (0, $8d8dfe9e89a287c4$export$e83f541b68a414bd)(locatorRange, mergedMarkList, parsedList, parsedIdx);
                for(var idx = 0; idx < parsedIdx; idx++)if (mergedMarkList[idx]) parsedList[idx].cellMergeOwner = false;
                if (locatorRange[0][0] !== parsed.id.x || locatorRange[1][0] !== parsed.id.y) {
                    // The top-left cell of the unioned locatorRange is not this cell any more.
                    parsed.cellMergeOwner = false;
                    // Reconcile: simply use the last style and value option if multiple styles involved
                    // in a merged area, since there might be no commonly used merge strategy.
                    var newOption = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, parsed.option);
                    newOption.coord = null;
                    var newParsed = {
                        id: new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(),
                        span: new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(),
                        locatorRange: locatorRange,
                        option: newOption,
                        cellMergeOwner: true
                    };
                    (0, $8d8dfe9e89a287c4$export$af43ef7117c4b8ed)(newParsed, locatorRange);
                    parsedList.push(newParsed);
                }
            }
            // Assign options to cells.
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(parsedList, function(parsed) {
                var topLeftCell = ensureBodyOrCornerCell(parsed.id.x, parsed.id.y);
                if (parsed.cellMergeOwner) {
                    topLeftCell.cellMergeOwner = true;
                    topLeftCell.span = parsed.span;
                    topLeftCell.locatorRange = parsed.locatorRange;
                    topLeftCell.spanRect = (0, $8d8dfe9e89a287c4$export$97431b409739b7a9)();
                    self._cellMergeOwnerList.push(topLeftCell);
                }
                if (!parsed.cellMergeOwner && !parsed.option) return;
                for(var yidx = 0; yidx < parsed.span.y; yidx++)for(var xidx = 0; xidx < parsed.span.x; xidx++){
                    var cell = ensureBodyOrCornerCell(parsed.id.x + xidx, parsed.id.y + yidx);
                    // If multiple style options are defined on a cell, the later ones takes precedence.
                    cell.option = parsed.option;
                    if (parsed.cellMergeOwner) cell.inSpanOf = topLeftCell;
                }
            });
        } // End of fillCellMap
        function ensureBodyOrCornerCell(x, y) {
            var key = $087d6423f4ac0e67$var$makeCellMapKey(x, y);
            var cell = _cellMap.get(key);
            if (!cell) cell = _cellMap.set(key, {
                id: new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(x, y),
                option: null,
                inSpanOf: null,
                span: null,
                spanRect: null,
                locatorRange: null,
                cellMergeOwner: false
            });
            return cell;
        }
    };
    /**
   * Body cells or corner cell are not commonly defined specifically, especially in a large
   * table, thus his is a sparse data structure - bodys or corner cells exist only if there
   * are options specified to it (in `matrix.body.data` or `matrix.corner.data`);
   * otherwise, return `NullUndefined`.
   */ MatrixBodyCorner.prototype.getCell = function(xy) {
        // Assert xy do not contain NaN
        return this._ensureCellMap().get($087d6423f4ac0e67$var$makeCellMapKey(xy[0], xy[1]));
    };
    /**
   * Only cell existing (has specific definition or props) will be travelled.
   */ MatrixBodyCorner.prototype.travelExistingCells = function(cb) {
        this._ensureCellMap().each(cb);
    };
    /**
   * @param locatorRange Must be the return of `parseCoordRangeOption`.
   */ MatrixBodyCorner.prototype.expandRangeByCellMerge = function(locatorRange) {
        if (!(0, $8d8dfe9e89a287c4$export$6f30d23446b696e5)(locatorRange, 0) && !(0, $8d8dfe9e89a287c4$export$6f30d23446b696e5)(locatorRange, 1) && locatorRange[0][0] === locatorRange[0][1] && locatorRange[1][0] === locatorRange[1][1]) {
            // If it locates to a single cell, use this quick path to avoid travelling.
            // It is based on the fact that any cell is not contained by more than one cell merging rect.
            $087d6423f4ac0e67$var$_tmpERBCMLocator[0] = locatorRange[0][0];
            $087d6423f4ac0e67$var$_tmpERBCMLocator[1] = locatorRange[1][0];
            var cell = this.getCell($087d6423f4ac0e67$var$_tmpERBCMLocator);
            var inSpanOf = cell && cell.inSpanOf;
            if (inSpanOf) {
                (0, $8d8dfe9e89a287c4$export$1939176e25597afc)(locatorRange, inSpanOf.locatorRange);
                return;
            }
        }
        var list = this._cellMergeOwnerList;
        (0, $8d8dfe9e89a287c4$export$e83f541b68a414bd)(locatorRange, null, list, list.length);
    };
    return MatrixBodyCorner;
}();
var $087d6423f4ac0e67$var$_tmpERBCMLocator = [];
function $087d6423f4ac0e67$var$makeCellMapKey(x, y) {
    return x + "|" + y;
}



var $2d910f533f587e5a$var$defaultLabelOption = {
    show: true,
    color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.secondary,
    // overflow: 'truncate',
    overflow: "break",
    lineOverflow: "truncate",
    padding: [
        2,
        3,
        2,
        3
    ],
    // Prefer to use `padding`, rather than distance.
    distance: 0
};
function $2d910f533f587e5a$var$makeDefaultCellItemStyleOption(isCorner) {
    return {
        color: "none",
        borderWidth: 1,
        borderColor: isCorner ? "none" : (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.borderTint
    };
}
var $2d910f533f587e5a$var$defaultDimOption = {
    show: true,
    label: $2d910f533f587e5a$var$defaultLabelOption,
    itemStyle: $2d910f533f587e5a$var$makeDefaultCellItemStyleOption(false),
    silent: undefined,
    dividerLineStyle: {
        width: 1,
        color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.border
    }
};
var $2d910f533f587e5a$var$defaultBodyOption = {
    label: $2d910f533f587e5a$var$defaultLabelOption,
    itemStyle: $2d910f533f587e5a$var$makeDefaultCellItemStyleOption(false),
    silent: undefined
};
var $2d910f533f587e5a$var$defaultCornerOption = {
    label: $2d910f533f587e5a$var$defaultLabelOption,
    itemStyle: $2d910f533f587e5a$var$makeDefaultCellItemStyleOption(true),
    silent: undefined
};
var $2d910f533f587e5a$var$defaultMatrixOption = {
    // As a most basic coord sys, `z` should be lower than
    // other series and coord sys, such as, grid.
    z: -50,
    left: "10%",
    top: "10%",
    right: "10%",
    bottom: "10%",
    x: $2d910f533f587e5a$var$defaultDimOption,
    y: $2d910f533f587e5a$var$defaultDimOption,
    body: $2d910f533f587e5a$var$defaultBodyOption,
    corner: $2d910f533f587e5a$var$defaultCornerOption,
    backgroundStyle: {
        color: "none",
        borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.axisLine,
        borderWidth: 1
    }
};
var $2d910f533f587e5a$var$MatrixModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MatrixModel, _super);
    function MatrixModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MatrixModel.type;
        return _this;
    }
    MatrixModel.prototype.optionUpdated = function() {
        // Simply re-create all to follow model changes.
        var dimModels = this._dimModels = {
            // Do not use matrixModel as the parent model, for preventing from cascade-fetching options to it.
            x: new $2d910f533f587e5a$export$f3b280f0e470ad1f(this.get("x", true) || {}),
            y: new $2d910f533f587e5a$export$f3b280f0e470ad1f(this.get("y", true) || {})
        };
        dimModels.x.option.type = dimModels.y.option.type = "category";
        var xDim = dimModels.x.dim = new (0, $4297d32c91f2432d$export$1a8bd0fc6596656f)("x", dimModels.x);
        var yDim = dimModels.y.dim = new (0, $4297d32c91f2432d$export$1a8bd0fc6596656f)("y", dimModels.y);
        var dims = {
            x: xDim,
            y: yDim
        };
        this._body = new (0, $087d6423f4ac0e67$export$4a91097e7bc6c9d0)("body", new (0, $6818646a97528290$export$2e2bcd8739ae039)(this.getShallow("body")), dims);
        this._corner = new (0, $087d6423f4ac0e67$export$4a91097e7bc6c9d0)("corner", new (0, $6818646a97528290$export$2e2bcd8739ae039)(this.getShallow("corner")), dims);
    };
    MatrixModel.prototype.getDimensionModel = function(dim) {
        return this._dimModels[dim];
    };
    MatrixModel.prototype.getBody = function() {
        return this._body;
    };
    MatrixModel.prototype.getCorner = function() {
        return this._corner;
    };
    MatrixModel.type = "matrix";
    MatrixModel.layoutMode = "box";
    MatrixModel.defaultOption = $2d910f533f587e5a$var$defaultMatrixOption;
    return MatrixModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $2d910f533f587e5a$export$f3b280f0e470ad1f = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MatrixDimensionModel, _super);
    function MatrixDimensionModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MatrixDimensionModel.prototype.getOrdinalMeta = function() {
        return this.dim.getOrdinalMeta();
    };
    return MatrixDimensionModel;
}((0, $6818646a97528290$export$2e2bcd8739ae039));
var $2d910f533f587e5a$export$2e2bcd8739ae039 = $2d910f533f587e5a$var$MatrixModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 










var $a4152ff1bafb56ac$var$round = Math.round;
var $a4152ff1bafb56ac$var$Z2_BACKGROUND = 0;
var $a4152ff1bafb56ac$var$Z2_OUTER_BORDER = 99;
var $a4152ff1bafb56ac$var$Z2_BODY_CORNER_CELL_DEFAULT = {
    normal: 25,
    special: 100
};
var $a4152ff1bafb56ac$var$Z2_DIMENSION_CELL_DEFAULT = {
    normal: 50,
    special: 125
};
var $a4152ff1bafb56ac$var$MatrixView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MatrixView, _super);
    function MatrixView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MatrixView.type;
        return _this;
    }
    MatrixView.prototype.render = function(matrixModel, ecModel) {
        this.group.removeAll();
        var group = this.group;
        var coordSys = matrixModel.coordinateSystem;
        var rect = coordSys.getRect();
        var xDimModel = matrixModel.getDimensionModel("x");
        var yDimModel = matrixModel.getDimensionModel("y");
        var xDim = xDimModel.dim;
        var yDim = yDimModel.dim;
        // PENDING:
        //  reuse the existing text and rect elements for performance?
        $a4152ff1bafb56ac$var$renderDimensionCells(group, matrixModel, ecModel);
        $a4152ff1bafb56ac$var$createBodyAndCorner(group, matrixModel, xDim, yDim, ecModel);
        var borderZ2Option = matrixModel.getShallow("borderZ2", true);
        var outerBorderZ2 = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(borderZ2Option, $a4152ff1bafb56ac$var$Z2_OUTER_BORDER);
        var dividerLineZ2 = outerBorderZ2 - 1;
        // Outer border and overall background. Use separate elements because of z-order:
        // The overall background should appear below any other elements.
        // But in most cases, the outer border and the divider line should be above the normal cell borders -
        // especially when cell borders have different colors. But users may highlight some specific cells by
        // overstirking their border, in which case it should be above the outer border.
        var bgStyle = matrixModel.getModel("backgroundStyle").getItemStyle([
            "borderWidth"
        ]);
        bgStyle.lineWidth = 0;
        var borderStyle = matrixModel.getModel("backgroundStyle").getItemStyle([
            "color",
            "decal",
            "shadowColor",
            "shadowBlur",
            "shadowOffsetX",
            "shadowOffsetY"
        ]);
        borderStyle.fill = "none";
        var bgRect = $a4152ff1bafb56ac$var$createMatrixRect(rect.clone(), bgStyle, $a4152ff1bafb56ac$var$Z2_BACKGROUND);
        var borderRect = $a4152ff1bafb56ac$var$createMatrixRect(rect.clone(), borderStyle, outerBorderZ2);
        bgRect.silent = true;
        borderRect.silent = true;
        group.add(bgRect);
        group.add(borderRect);
        // Header split line.
        var xDimCell0 = xDim.getUnitLayoutInfo(0, 0);
        var yDimCell0 = yDim.getUnitLayoutInfo(1, 0);
        if (xDimCell0 && yDimCell0) {
            if (xDim.shouldShow()) group.add($a4152ff1bafb56ac$var$createMatrixLine({
                x1: rect.x,
                y1: yDimCell0.xy,
                x2: rect.x + rect.width,
                y2: yDimCell0.xy
            }, xDimModel.getModel("dividerLineStyle").getLineStyle(), dividerLineZ2));
            if (yDim.shouldShow()) group.add($a4152ff1bafb56ac$var$createMatrixLine({
                x1: xDimCell0.xy,
                y1: rect.y,
                x2: xDimCell0.xy,
                y2: rect.y + rect.height
            }, yDimModel.getModel("dividerLineStyle").getLineStyle(), dividerLineZ2));
        }
    };
    MatrixView.type = "matrix";
    return MatrixView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $a4152ff1bafb56ac$var$renderDimensionCells(group, matrixModel, ecModel) {
    renderOnDimension(0);
    renderOnDimension(1);
    function renderOnDimension(dimIdx) {
        var thisDimModel = matrixModel.getDimensionModel((0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]);
        var thisDim = thisDimModel.dim;
        if (!thisDim.shouldShow()) return;
        var thisDimBgStyleModel = thisDimModel.getModel("itemStyle");
        var thisDimLabelModel = thisDimModel.getModel("label");
        var tooltipOption = matrixModel.getShallow("tooltip", true);
        var xyLocator = [];
        for(var it_1 = thisDim.resetCellIterator(); it_1.next();){
            var dimCell = it_1.item;
            var shape = {};
            (0, $1bebe7106c895823$export$2e2bcd8739ae039).copy(shape, dimCell.rect);
            $6de594cf8ac295ff$export$adaa4cf7ef1b65be(xyLocator, dimCell.id.x, dimCell.id.y);
            $a4152ff1bafb56ac$var$createMatrixCell(xyLocator, matrixModel, group, ecModel, dimCell.option, thisDimBgStyleModel, thisDimLabelModel, thisDimModel, shape, dimCell.option.value, $a4152ff1bafb56ac$var$Z2_DIMENSION_CELL_DEFAULT, tooltipOption);
        }
    }
}
function $a4152ff1bafb56ac$var$createBodyAndCorner(group, matrixModel, xDim, yDim, ecModel) {
    createBodyOrCornerCells("body", matrixModel.getBody(), xDim, yDim);
    if (xDim.shouldShow() && yDim.shouldShow()) createBodyOrCornerCells("corner", matrixModel.getCorner(), yDim, xDim);
    function createBodyOrCornerCells(bodyCornerOptionRoot, bodyOrCorner, dimForCoordX, // Can be `matrix.y` (transposed) for corners.
    dimForCoordY) {
        // Prevent inheriting from ancestor.
        var parentCellModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(matrixModel.getShallow(bodyCornerOptionRoot, true));
        var parentItemStyleModel = parentCellModel.getModel("itemStyle");
        var parentLabelModel = parentCellModel.getModel("label");
        var itx = new (0, $76d619f648247e6d$export$4e38036c4470d56c)();
        var ity = new (0, $76d619f648247e6d$export$4e38036c4470d56c)();
        var xyLocator = [];
        var tooltipOption = matrixModel.getShallow("tooltip", true);
        for(dimForCoordY.resetLayoutIterator(ity, 1); ity.next();)for(dimForCoordX.resetLayoutIterator(itx, 0); itx.next();){
            var xLayout = itx.item;
            var yLayout = ity.item;
            $6de594cf8ac295ff$export$adaa4cf7ef1b65be(xyLocator, xLayout.id.x, yLayout.id.y);
            var bodyCornerCell = bodyOrCorner.getCell(xyLocator);
            // If in span of an other body or corner cell, never render it.
            if (bodyCornerCell && bodyCornerCell.inSpanOf && bodyCornerCell.inSpanOf !== bodyCornerCell) continue;
            var shape = {};
            if (bodyCornerCell && bodyCornerCell.span) (0, $1bebe7106c895823$export$2e2bcd8739ae039).copy(shape, bodyCornerCell.spanRect);
            else {
                xLayout.dim.getLayout(shape, 0, xyLocator[0]);
                yLayout.dim.getLayout(shape, 1, xyLocator[1]);
            }
            var bodyCornerCellOption = bodyCornerCell ? bodyCornerCell.option : null;
            $a4152ff1bafb56ac$var$createMatrixCell(xyLocator, matrixModel, group, ecModel, bodyCornerCellOption, parentItemStyleModel, parentLabelModel, parentCellModel, shape, bodyCornerCellOption ? bodyCornerCellOption.value : null, $a4152ff1bafb56ac$var$Z2_BODY_CORNER_CELL_DEFAULT, tooltipOption);
        }
    } // End of createBodyOrCornerCells
}
function $a4152ff1bafb56ac$var$createMatrixCell(xyLocator, matrixModel, group, ecModel, cellOption, parentItemStyleModel, parentLabelModel, parentCellModel, shape, textValue, zrCellDefault, tooltipOption) {
    var _a;
    // Do not use getModel for handy performance optimization.
    $a4152ff1bafb56ac$var$_tmpCellItemStyleModel.option = cellOption ? cellOption.itemStyle : null;
    $a4152ff1bafb56ac$var$_tmpCellItemStyleModel.parentModel = parentItemStyleModel;
    $a4152ff1bafb56ac$var$_tmpCellModel.option = cellOption;
    $a4152ff1bafb56ac$var$_tmpCellModel.parentModel = parentCellModel;
    // Use different z2 because special border may be defined in itemStyle.
    var z2 = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)($a4152ff1bafb56ac$var$_tmpCellModel.getShallow("z2"), cellOption && cellOption.itemStyle ? zrCellDefault.special : zrCellDefault.normal);
    var tooltipOptionShow = tooltipOption && tooltipOption.show;
    var cellRect = $a4152ff1bafb56ac$var$createMatrixRect(shape, $a4152ff1bafb56ac$var$_tmpCellItemStyleModel.getItemStyle(), z2);
    group.add(cellRect);
    var cursorOption = $a4152ff1bafb56ac$var$_tmpCellModel.get("cursor");
    if (cursorOption != null) cellRect.attr("cursor", cursorOption);
    var cellText;
    if (textValue != null) {
        var text = textValue + "";
        $a4152ff1bafb56ac$var$_tmpCellLabelModel.option = cellOption ? cellOption.label : null;
        $a4152ff1bafb56ac$var$_tmpCellLabelModel.parentModel = parentLabelModel;
        // This is to accept `option.textStyle` as the default.
        $a4152ff1bafb56ac$var$_tmpCellLabelModel.ecModel = ecModel;
        (0, $6800dfcb6e1e2a44$export$9a13992917966657)(cellRect, // Currently do not support other states (`emphasis`, `select`, `blur`)
        {
            normal: $a4152ff1bafb56ac$var$_tmpCellLabelModel
        }, {
            defaultText: text,
            autoOverflowArea: true,
            // By default based on boundingRect. But boundingRect contains borderWidth,
            // and borderWidth is half outside the cell. Thus specific `layoutRect` explicitly.
            layoutRect: (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(cellRect.shape)
        });
        cellText = cellRect.getTextContent();
        if (cellText) {
            cellText.z2 = z2 + 1;
            var style = cellText.style;
            if (style && style.overflow && style.overflow !== "none" && style.lineOverflow) {
                // `overflow: 'break'/'breakAll'/'truncate'` does not guarantee prevention of overflow
                // when space is insufficient. Use a `clipPath` in such case.
                var clipShape = {};
                (0, $1bebe7106c895823$export$2e2bcd8739ae039).copy(clipShape, shape);
                // `lineWidth` is half outside half inside the bounding rect.
                (0, $5b455ae6f843ac47$export$81ed941fdeb91c7c)(clipShape, (((_a = cellRect.style) === null || _a === void 0 ? void 0 : _a.lineWidth) || 0) / 2, true, true);
                cellRect.updateInnerText();
                cellText.getLocalTransform($a4152ff1bafb56ac$var$_tmpInnerTextTrans);
                (0, $f41ebb9dd60b55b4$export$6897c284b6f9f4dc)($a4152ff1bafb56ac$var$_tmpInnerTextTrans, $a4152ff1bafb56ac$var$_tmpInnerTextTrans);
                (0, $1bebe7106c895823$export$2e2bcd8739ae039).applyTransform(clipShape, clipShape, $a4152ff1bafb56ac$var$_tmpInnerTextTrans);
                cellText.setClipPath(new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
                    shape: clipShape
                }));
            }
        }
        (0, $5b455ae6f843ac47$export$fc6410d97fab306c)({
            el: cellRect,
            componentModel: matrixModel,
            itemName: text,
            itemTooltipOption: tooltipOption,
            formatterParamsExtra: {
                xyLocator: xyLocator.slice()
            }
        });
    }
    // Set silent
    if (cellText) {
        var labelSilent = $a4152ff1bafb56ac$var$_tmpCellLabelModel.get("silent");
        // auto, tooltip of text cells need silient: false, but non-text cells
        // do not need a special cursor in most cases.
        if (labelSilent == null) labelSilent = !tooltipOptionShow;
        cellText.silent = labelSilent;
        cellText.ignoreHostSilent = true;
    }
    var rectSilent = $a4152ff1bafb56ac$var$_tmpCellModel.get("silent");
    if (rectSilent == null) rectSilent = // If no background color in cell, set `rect.silent: false` will cause that only
    // the border response to mouse hovering, which is probably weird.
    !cellRect.style || cellRect.style.fill === "none" || !cellRect.style.fill;
    cellRect.silent = rectSilent;
    (0, $76d619f648247e6d$export$be44d6593b016f3e)($a4152ff1bafb56ac$var$_tmpCellModel);
    (0, $76d619f648247e6d$export$be44d6593b016f3e)($a4152ff1bafb56ac$var$_tmpCellItemStyleModel);
    (0, $76d619f648247e6d$export$be44d6593b016f3e)($a4152ff1bafb56ac$var$_tmpCellLabelModel);
}
var $a4152ff1bafb56ac$var$_tmpCellModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)();
var $a4152ff1bafb56ac$var$_tmpCellItemStyleModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)();
var $a4152ff1bafb56ac$var$_tmpCellLabelModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)();
var $a4152ff1bafb56ac$var$_tmpInnerTextTrans = [];
// FIXME: move all of the subpixel process to Matrix.ts resize, otherwise the result of
// `dataToLayout` is not consistent with this rendering, and the caller (like heatmap) can
// not precisely align with the matrix border.
function $a4152ff1bafb56ac$var$createMatrixRect(shape, style, z2) {
    // Currently `subPixelOptimizeRect` can not be used here because it will break rect alignment.
    // Optimize line and rect with the same direction.
    var lineWidth = style.lineWidth;
    if (lineWidth) {
        var x2Original = shape.x + shape.width;
        var y2Original = shape.y + shape.height;
        shape.x = (0, $4d5544821af8d796$export$72c4fd4c1b8fcb10)(shape.x, lineWidth, true);
        shape.y = (0, $4d5544821af8d796$export$72c4fd4c1b8fcb10)(shape.y, lineWidth, true);
        shape.width = (0, $4d5544821af8d796$export$72c4fd4c1b8fcb10)(x2Original, lineWidth, true) - shape.x;
        shape.height = (0, $4d5544821af8d796$export$72c4fd4c1b8fcb10)(y2Original, lineWidth, true) - shape.y;
    }
    return new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
        shape: shape,
        style: style,
        z2: z2
    });
}
function $a4152ff1bafb56ac$var$createMatrixLine(shape, style, z2) {
    var lineWidth = style.lineWidth;
    if (lineWidth) {
        if ($a4152ff1bafb56ac$var$round(shape.x1 * 2) === $a4152ff1bafb56ac$var$round(shape.x2 * 2)) shape.x1 = shape.x2 = (0, $4d5544821af8d796$export$72c4fd4c1b8fcb10)(shape.x1, lineWidth, true);
        if ($a4152ff1bafb56ac$var$round(shape.y1 * 2) === $a4152ff1bafb56ac$var$round(shape.y2 * 2)) shape.y1 = shape.y2 = (0, $4d5544821af8d796$export$72c4fd4c1b8fcb10)(shape.y1, lineWidth, true);
    }
    return new (0, $7a316ae5ceff7b27$export$2e2bcd8739ae039)({
        shape: shape,
        style: style,
        silent: true,
        z2: z2
    });
}
var $a4152ff1bafb56ac$export$2e2bcd8739ae039 = $a4152ff1bafb56ac$var$MatrixView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








var $c149a9163f5b19cd$var$Matrix = /** @class */ function() {
    function Matrix(matrixModel, ecModel, api) {
        this.dimensions = Matrix.dimensions;
        this.type = "matrix";
        this._model = matrixModel;
        var models = this._dimModels = {
            x: matrixModel.getDimensionModel("x"),
            y: matrixModel.getDimensionModel("y")
        };
        this._dims = {
            x: models.x.dim,
            y: models.y.dim
        };
        this._resize(matrixModel, api);
    }
    /**
   * @see fetchers in `model/referHelper.ts`,
   * which is used to parse data in ordinal way.
   * In most series only 'x' and 'y' is required,
   * but some series, such as heatmap, can specify value.
   */ Matrix.getDimensionsInfo = function() {
        return [
            {
                name: "x",
                type: "ordinal"
            },
            {
                name: "y",
                type: "ordinal"
            },
            {
                name: "value"
            }
        ];
    };
    Matrix.create = function(ecModel, api) {
        var matrixList = [];
        ecModel.eachComponent("matrix", function(matrixModel) {
            var matrix = new Matrix(matrixModel, ecModel, api);
            matrixList.push(matrix);
            matrixModel.coordinateSystem = matrix;
        });
        // Inject coordinate system
        // PENDING: optimize to not to travel all components?
        //  (collect relevant components in ecModel only when model update?)
        ecModel.eachComponent(function(mainType, componentModel) {
            (0, $70c3ede7d3b64757$export$7ed0c09d4f5c932e)({
                targetModel: componentModel,
                coordSysType: "matrix",
                coordSysProvider: (0, $70c3ede7d3b64757$export$33b06c851894cd19)
            });
        });
        return matrixList;
    };
    Matrix.prototype.getRect = function() {
        return this._rect;
    };
    Matrix.prototype._resize = function(matrixModel, api) {
        var dims = this._dims;
        var dimModels = this._dimModels;
        var rect = this._rect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(matrixModel.getBoxLayoutParams(), {
            width: api.getWidth(),
            height: api.getHeight()
        });
        $c149a9163f5b19cd$var$layOutUnitsOnDimension(dimModels, dims, rect, 0);
        $c149a9163f5b19cd$var$layOutUnitsOnDimension(dimModels, dims, rect, 1);
        $c149a9163f5b19cd$var$layOutDimCellsRestInfoByUnit(0, dims);
        $c149a9163f5b19cd$var$layOutDimCellsRestInfoByUnit(1, dims);
        $c149a9163f5b19cd$var$layOutBodyCornerCellMerge(this._model.getBody(), dims);
        $c149a9163f5b19cd$var$layOutBodyCornerCellMerge(this._model.getCorner(), dims);
    };
    /**
   * @implement
   * - The input is allowed to be `[NaN/null/undefined, xxx]`/`[xxx, NaN/null/undefined]`;
   *  the return is `[NaN, xxxresult]`/`[xxxresult, NaN]` or clamped boundary value if
   *  `clamp` passed. This is for the usage that only get coord on single x or y.
   * - Alwasy return an numeric array, but never be null/undefined.
   *  If it can not be located or invalid, return `[NaN, NaN]`.
   */ Matrix.prototype.dataToPoint = function(data, opt, out) {
        out = out || [];
        this.dataToLayout(data, opt, $c149a9163f5b19cd$var$_dtpOutDataToLayout);
        out[0] = $c149a9163f5b19cd$var$_dtpOutDataToLayout.rect.x + $c149a9163f5b19cd$var$_dtpOutDataToLayout.rect.width / 2;
        out[1] = $c149a9163f5b19cd$var$_dtpOutDataToLayout.rect.y + $c149a9163f5b19cd$var$_dtpOutDataToLayout.rect.height / 2;
        return out;
    };
    /**
   * @implement
   * - The input is allowed to be `[NaN/null/undefined, xxx]`/`[xxx, NaN/null/undefined]`;
   *  the return is `{x: NaN, width: NaN, y: xxxresulty, height: xxxresulth}`/
   *  `{y: NaN, height: NaN, x: xxxresultx, width: xxxresultw}` or clamped boundary value
   *  if `clamp` passed. This is for the usage that only get coord on single x or y.
   * - The returned `out.rect` and `out.matrixXYLocatorRange` is always an object or an 2d-array,
   *  but never be null/undefined. If it cannot be located or invalid, `NaN` is in their
   *  corresponding number props.
   * - Do not provide `out.contentRect`, because it's allowed to input non-leaf dimension x/y or
   *  a range of x/y, which determines a rect covering multiple cells (even not merged), in which
   *  case the padding and borderWidth can not be determined to make a contentRect. Therefore only
   *  return `out.rect` in any case for consistency. The caller is responsible for adding space to
   *  avoid covering cell borders, if necessary.
   */ Matrix.prototype.dataToLayout = function(data, opt, out) {
        var dims = this._dims;
        out = out || {};
        var outRect = out.rect = out.rect || {};
        outRect.x = outRect.y = outRect.width = outRect.height = NaN;
        var outLocRange = out.matrixXYLocatorRange = (0, $8d8dfe9e89a287c4$export$7083aa8e2f333744)(out.matrixXYLocatorRange);
        if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(data)) return out;
        (0, $8d8dfe9e89a287c4$export$1dc03edb4e724e02)(outLocRange, null, data, dims, (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(opt && opt.clamp, (0, $8d8dfe9e89a287c4$export$f6f60f1901b7a690).none));
        if (!opt || !opt.ignoreMergeCells) {
            if (!opt || opt.clamp !== (0, $8d8dfe9e89a287c4$export$f6f60f1901b7a690).corner) this._model.getBody().expandRangeByCellMerge(outLocRange);
            if (!opt || opt.clamp !== (0, $8d8dfe9e89a287c4$export$f6f60f1901b7a690).body) this._model.getCorner().expandRangeByCellMerge(outLocRange);
        }
        (0, $8d8dfe9e89a287c4$export$209b48cb1590c2e6)(outRect, outLocRange, dims, 0);
        (0, $8d8dfe9e89a287c4$export$209b48cb1590c2e6)(outRect, outLocRange, dims, 1);
        return out;
    };
    /**
   * The returned locator pair can be the input of `dataToPoint` or `dataToLayout`.
   *
   * If point[0] is out of the matrix rect,
   *  the out[0] is NaN;
   * else if it is on the right of top-left corner of body,
   *  the out[0] is the oridinal number (>= 0).
   * else
   *  out[0] is the locator for corner or header (<= 0).
   *
   * The same rule goes for point[1] and out[1].
   *
   * But point[0] and point[1] are calculated separately, i.e.,
   * the reuslt can be `[1, NaN]` or `[NaN, 1]` if only one dimension is out of boundary.
   *
   * @implement
   */ Matrix.prototype.pointToData = function(point, opt, out) {
        var dims = this._dims;
        $c149a9163f5b19cd$var$pointToDataOneDimPrepareCtx($c149a9163f5b19cd$var$_tmpCtxPointToData, 0, dims, point, opt && opt.clamp);
        $c149a9163f5b19cd$var$pointToDataOneDimPrepareCtx($c149a9163f5b19cd$var$_tmpCtxPointToData, 1, dims, point, opt && opt.clamp);
        out = out || [];
        out[0] = out[1] = NaN;
        if ($c149a9163f5b19cd$var$_tmpCtxPointToData.y === $c149a9163f5b19cd$var$CtxPointToDataAreaType.inCorner && $c149a9163f5b19cd$var$_tmpCtxPointToData.x === $c149a9163f5b19cd$var$CtxPointToDataAreaType.inBody) $c149a9163f5b19cd$var$pointToDataOnlyHeaderFillOut($c149a9163f5b19cd$var$_tmpCtxPointToData, out, 0, dims);
        else if ($c149a9163f5b19cd$var$_tmpCtxPointToData.x === $c149a9163f5b19cd$var$CtxPointToDataAreaType.inCorner && $c149a9163f5b19cd$var$_tmpCtxPointToData.y === $c149a9163f5b19cd$var$CtxPointToDataAreaType.inBody) $c149a9163f5b19cd$var$pointToDataOnlyHeaderFillOut($c149a9163f5b19cd$var$_tmpCtxPointToData, out, 1, dims);
        else {
            $c149a9163f5b19cd$var$pointToDataBodyCornerFillOut($c149a9163f5b19cd$var$_tmpCtxPointToData, out, 0, dims);
            $c149a9163f5b19cd$var$pointToDataBodyCornerFillOut($c149a9163f5b19cd$var$_tmpCtxPointToData, out, 1, dims);
        }
        return out;
    };
    Matrix.prototype.convertToPixel = function(ecModel, finder, value, opt) {
        var coordSys = $c149a9163f5b19cd$var$getCoordSys(finder);
        return coordSys === this ? coordSys.dataToPoint(value, opt) : undefined;
    };
    Matrix.prototype.convertToLayout = function(ecModel, finder, value, opt) {
        var coordSys = $c149a9163f5b19cd$var$getCoordSys(finder);
        return coordSys === this ? coordSys.dataToLayout(value, opt) : undefined;
    };
    Matrix.prototype.convertFromPixel = function(ecModel, finder, pixel, opt) {
        var coordSys = $c149a9163f5b19cd$var$getCoordSys(finder);
        return coordSys === this ? coordSys.pointToData(pixel, opt) : undefined;
    };
    Matrix.prototype.containPoint = function(point) {
        return this._rect.contain(point[0], point[1]);
    };
    Matrix.dimensions = [
        "x",
        "y",
        "value"
    ];
    return Matrix;
}();
var $c149a9163f5b19cd$var$_dtpOutDataToLayout = {
    rect: (0, $8d8dfe9e89a287c4$export$97431b409739b7a9)()
};
var $c149a9163f5b19cd$var$_ptdLevelIt = new (0, $76d619f648247e6d$export$4e38036c4470d56c)();
var $c149a9163f5b19cd$var$_ptdDimCellIt = new (0, $76d619f648247e6d$export$4e38036c4470d56c)();
function $c149a9163f5b19cd$var$layOutUnitsOnDimension(dimModels, dims, matrixRect, dimIdx) {
    var otherDimIdx = 1 - dimIdx;
    var thisDim = dims[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]];
    var otherDim = dims[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[otherDimIdx]];
    // Notice: If matrix.x/y.show is false, still lay out, to ensure the
    // consistent return of `dataToLayout`.
    var otherDimShow = otherDim.shouldShow();
    // Reset
    for(var it_1 = thisDim.resetCellIterator(); it_1.next();)it_1.item.wh = it_1.item.xy = NaN;
    for(var it_2 = otherDim.resetLayoutIterator(null, dimIdx); it_2.next();)it_2.item.wh = it_2.item.xy = NaN;
    // Set specified size from option.
    var restSize = matrixRect[(0, $5b455ae6f843ac47$export$a3fe6d967173a3ac)[dimIdx]];
    var restCellsCount = thisDim.getLocatorCount(dimIdx) + otherDim.getLocatorCount(dimIdx);
    var tmpLevelModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)();
    for(var it_3 = otherDim.resetLevelIterator(); it_3.next();){
        // Consider `matrix.x.levelSize` and `matrix.x.levels[i].levelSize`.
        tmpLevelModel.option = it_3.item.option;
        tmpLevelModel.parentModel = dimModels[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[otherDimIdx]];
        layOutSpecified(it_3.item, otherDimShow ? tmpLevelModel.get("levelSize") : 0);
    }
    var tmpCellModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)();
    for(var it_4 = thisDim.resetCellIterator(); it_4.next();)// Only leaf support size specification, to avoid unnecessary complexity.
    if (it_4.item.type === (0, $8d8dfe9e89a287c4$export$e605ddc25c355f0b).leaf) {
        tmpCellModel.option = it_4.item.option;
        tmpCellModel.parentModel = undefined;
        layOutSpecified(it_4.item, tmpCellModel.get("size"));
    }
    function layOutSpecified(item, sizeOption) {
        var size = $c149a9163f5b19cd$var$parseSizeOption(sizeOption, dimIdx, matrixRect);
        if (!(0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(size)) {
            item.wh = $c149a9163f5b19cd$var$confineSize(size, restSize);
            restSize = $c149a9163f5b19cd$var$confineSize(restSize - item.wh);
            restCellsCount--;
        }
    }
    // Set all sizes and positions to levels and leaf cells of which size is unspecified.
    // Contents lay out based on matrix, rather than inverse; therefore do not support
    // calculating size based on content, but allocate equally.
    var computedCellWH = restCellsCount ? restSize / restCellsCount : 0;
    // If all size specified, but some space remain (may also caused by matrix.x/y.show: false)
    // do not align to the big most edge.
    var notAlignToBigmost = !restCellsCount && restSize >= 1; // `1` for cumulative precision error.
    var currXY = matrixRect[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]];
    var maxLocator = thisDim.getLocatorCount(dimIdx) - 1;
    var it = new (0, $76d619f648247e6d$export$4e38036c4470d56c)();
    // Lay out levels of the perpendicular dim.
    for(otherDim.resetLayoutIterator(it, dimIdx); it.next();)layOutUnspecified(it.item);
    for(thisDim.resetLayoutIterator(it, dimIdx); it.next();)layOutUnspecified(it.item);
    function layOutUnspecified(item) {
        if ((0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(item.wh)) item.wh = computedCellWH;
        item.xy = currXY;
        if (item.id[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]] === maxLocator && !notAlignToBigmost) // Align to the rightmost border, consider cumulative precision error.
        item.wh = matrixRect[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]] + matrixRect[(0, $5b455ae6f843ac47$export$a3fe6d967173a3ac)[dimIdx]] - item.xy;
        currXY += item.wh;
    }
}
function $c149a9163f5b19cd$var$layOutDimCellsRestInfoByUnit(dimIdx, dims) {
    // Finally save layout info based on the unit leaves and levels.
    for(var it_5 = dims[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]].resetCellIterator(); it_5.next();){
        var dimCell = it_5.item;
        $c149a9163f5b19cd$var$layOutRectOneDimBasedOnUnit(dimCell.rect, dimIdx, dimCell.id, dimCell.span, dims);
        // Consider level varitation on tree leaves, should extend the size to touch matrix body
        // to avoid weird appearance.
        $c149a9163f5b19cd$var$layOutRectOneDimBasedOnUnit(dimCell.rect, 1 - dimIdx, dimCell.id, dimCell.span, dims);
        if (dimCell.type === (0, $8d8dfe9e89a287c4$export$e605ddc25c355f0b).nonLeaf) {
            // `xy` and `wh` need to be saved in non-leaf since it supports locating by non-leaf
            // in `dataToPoint` or `dataToLayout`.
            dimCell.xy = dimCell.rect[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]];
            dimCell.wh = dimCell.rect[(0, $5b455ae6f843ac47$export$a3fe6d967173a3ac)[dimIdx]];
        }
    }
}
function $c149a9163f5b19cd$var$layOutBodyCornerCellMerge(bodyOrCorner, dims) {
    bodyOrCorner.travelExistingCells(function(cell) {
        var computedSpan = cell.span;
        if (computedSpan) {
            var layoutRect = cell.spanRect;
            var id = cell.id;
            $c149a9163f5b19cd$var$layOutRectOneDimBasedOnUnit(layoutRect, 0, id, computedSpan, dims);
            $c149a9163f5b19cd$var$layOutRectOneDimBasedOnUnit(layoutRect, 1, id, computedSpan, dims);
        }
    });
}
// Save to rect for rendering.
function $c149a9163f5b19cd$var$layOutRectOneDimBasedOnUnit(outRect, dimIdx, id, span, dims) {
    outRect[(0, $5b455ae6f843ac47$export$a3fe6d967173a3ac)[dimIdx]] = 0;
    var locator = id[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]];
    var dim = locator < 0 ? dims[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[1 - dimIdx]] : dims[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]];
    var layoutUnit = dim.getUnitLayoutInfo(dimIdx, id[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]]);
    outRect[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]] = layoutUnit.xy;
    outRect[(0, $5b455ae6f843ac47$export$a3fe6d967173a3ac)[dimIdx]] = layoutUnit.wh;
    if (span[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]] > 1) {
        var layoutUnit2 = dim.getUnitLayoutInfo(dimIdx, id[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]] + span[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]] - 1);
        // Be careful the cumulative error - cell must be aligned.
        outRect[(0, $5b455ae6f843ac47$export$a3fe6d967173a3ac)[dimIdx]] = layoutUnit2.xy + layoutUnit2.wh - layoutUnit.xy;
    }
}
/**
 * Return NaN if not defined or invalid.
 */ function $c149a9163f5b19cd$var$parseSizeOption(sizeOption, dimIdx, matrixRect) {
    var sizeNum = (0, $cfc1f3b422a3185f$export$6b392db7c2374a1a)(sizeOption, matrixRect[(0, $5b455ae6f843ac47$export$a3fe6d967173a3ac)[dimIdx]]);
    return $c149a9163f5b19cd$var$confineSize(sizeNum, matrixRect[(0, $5b455ae6f843ac47$export$a3fe6d967173a3ac)[dimIdx]]);
}
function $c149a9163f5b19cd$var$confineSize(sizeNum, sizeLimit) {
    return Math.max(Math.min(sizeNum, (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(sizeLimit, Infinity)), 0);
}
function $c149a9163f5b19cd$var$getCoordSys(finder) {
    var matrixModel = finder.matrixModel;
    var seriesModel = finder.seriesModel;
    var coordSys = matrixModel ? matrixModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem : null;
    return coordSys;
}
var $c149a9163f5b19cd$var$CtxPointToDataAreaType = {
    inBody: 1,
    inCorner: 2,
    outside: 3
};
// For handy performance optimization in pointToData.
var $c149a9163f5b19cd$var$_tmpCtxPointToData = {
    x: null,
    y: null,
    point: []
};
function $c149a9163f5b19cd$var$pointToDataOneDimPrepareCtx(ctx, dimIdx, dims, point, clamp) {
    var thisDim = dims[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]];
    var otherDim = dims[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[1 - dimIdx]];
    // Notice: considered cases: `matrix.x/y.show: false`, `matrix.x/y.data` is empty.
    // In this cases the `layout.xy` is on the edge and `layout.wh` is `0`; they still can be
    // use to calculate clampping.
    var bodyMaxUnit = thisDim.getUnitLayoutInfo(dimIdx, thisDim.getLocatorCount(dimIdx) - 1);
    var body0Unit = thisDim.getUnitLayoutInfo(dimIdx, 0);
    var cornerMinUnit = otherDim.getUnitLayoutInfo(dimIdx, -otherDim.getLocatorCount(dimIdx));
    var cornerMinus1Unit = otherDim.shouldShow() ? otherDim.getUnitLayoutInfo(dimIdx, -1) : null;
    var coord = ctx.point[dimIdx] = point[dimIdx]; // Transfer the oridinal coord.
    if (!body0Unit && !cornerMinus1Unit) {
        ctx[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]] = $c149a9163f5b19cd$var$CtxPointToDataAreaType.outside;
        return;
    }
    if (clamp === (0, $8d8dfe9e89a287c4$export$f6f60f1901b7a690).body) {
        if (body0Unit) {
            ctx[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]] = $c149a9163f5b19cd$var$CtxPointToDataAreaType.inBody;
            coord = (0, $cfc1f3b422a3185f$export$e411eeaf23dccbe8)(bodyMaxUnit.xy + bodyMaxUnit.wh, (0, $cfc1f3b422a3185f$export$2ca8010d037f830f)(body0Unit.xy, coord));
            ctx.point[dimIdx] = coord;
        } else // If clamp to body, the result must not be in header.
        ctx[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]] = $c149a9163f5b19cd$var$CtxPointToDataAreaType.outside;
        return;
    } else if (clamp === (0, $8d8dfe9e89a287c4$export$f6f60f1901b7a690).corner) {
        if (cornerMinus1Unit) {
            ctx[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]] = $c149a9163f5b19cd$var$CtxPointToDataAreaType.inCorner;
            coord = (0, $cfc1f3b422a3185f$export$e411eeaf23dccbe8)(cornerMinus1Unit.xy + cornerMinus1Unit.wh, (0, $cfc1f3b422a3185f$export$2ca8010d037f830f)(cornerMinUnit.xy, coord));
            ctx.point[dimIdx] = coord;
        } else // If clamp to corner, the result must not be in body.
        ctx[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]] = $c149a9163f5b19cd$var$CtxPointToDataAreaType.outside;
        return;
    }
    var pxLoc0 = body0Unit ? body0Unit.xy : cornerMinus1Unit ? cornerMinus1Unit.xy + cornerMinus1Unit.wh : NaN;
    var pxMin = cornerMinUnit ? cornerMinUnit.xy : pxLoc0;
    var pxMax = bodyMaxUnit ? bodyMaxUnit.xy + bodyMaxUnit.wh : pxLoc0;
    if (coord < pxMin) {
        if (!clamp) {
            // Quick pass for later calc, since mouse event on any place will enter this method if use `pointToData`.
            ctx[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]] = $c149a9163f5b19cd$var$CtxPointToDataAreaType.outside;
            return;
        }
        coord = pxMin;
    } else if (coord > pxMax) {
        if (!clamp) {
            ctx[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]] = $c149a9163f5b19cd$var$CtxPointToDataAreaType.outside;
            return;
        }
        coord = pxMax;
    }
    ctx.point[dimIdx] = coord; // Save the updated coord.
    ctx[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]] = pxLoc0 <= coord && coord <= pxMax ? $c149a9163f5b19cd$var$CtxPointToDataAreaType.inBody : pxMin <= coord && coord <= pxLoc0 ? $c149a9163f5b19cd$var$CtxPointToDataAreaType.inCorner : $c149a9163f5b19cd$var$CtxPointToDataAreaType.outside;
// Every props in ctx must be set in every branch of this method.
}
// Assume partialOut has been set to NaN outside.
// This method may fill out[0] and out[1] in one call.
function $c149a9163f5b19cd$var$pointToDataOnlyHeaderFillOut(ctx, partialOut, dimIdx, dims) {
    var otherDimIdx = 1 - dimIdx;
    if (ctx[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]] === $c149a9163f5b19cd$var$CtxPointToDataAreaType.outside) return;
    for(dims[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]].resetCellIterator($c149a9163f5b19cd$var$_ptdDimCellIt); $c149a9163f5b19cd$var$_ptdDimCellIt.next();){
        var cell = $c149a9163f5b19cd$var$_ptdDimCellIt.item;
        if ($c149a9163f5b19cd$var$isCoordInRect(ctx.point[dimIdx], cell.rect, dimIdx) && $c149a9163f5b19cd$var$isCoordInRect(ctx.point[otherDimIdx], cell.rect, otherDimIdx)) {
            // non-leaves are also allowed to be located.
            // If the point is in x or y dimension cell area, should check both x and y coord to
            // determine a cell; in this way a non-leaf cell can be determined.
            partialOut[dimIdx] = cell.ordinal;
            partialOut[otherDimIdx] = cell.id[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[otherDimIdx]];
            return;
        }
    }
}
// Assume partialOut has been set to NaN outside.
// This method may fill out[0] and out[1] in one call.
function $c149a9163f5b19cd$var$pointToDataBodyCornerFillOut(ctx, partialOut, dimIdx, dims) {
    if (ctx[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]] === $c149a9163f5b19cd$var$CtxPointToDataAreaType.outside) return;
    var dim = ctx[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]] === $c149a9163f5b19cd$var$CtxPointToDataAreaType.inCorner ? dims[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[1 - dimIdx]] : dims[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]];
    for(dim.resetLayoutIterator($c149a9163f5b19cd$var$_ptdLevelIt, dimIdx); $c149a9163f5b19cd$var$_ptdLevelIt.next();)if ($c149a9163f5b19cd$var$isCoordInLayoutInfo(ctx.point[dimIdx], $c149a9163f5b19cd$var$_ptdLevelIt.item)) {
        partialOut[dimIdx] = $c149a9163f5b19cd$var$_ptdLevelIt.item.id[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]];
        return;
    }
}
function $c149a9163f5b19cd$var$isCoordInLayoutInfo(coord, cell) {
    return cell.xy <= coord && coord <= cell.xy + cell.wh;
}
function $c149a9163f5b19cd$var$isCoordInRect(coord, rect, dimIdx) {
    return rect[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]] <= coord && coord <= rect[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimIdx]] + rect[(0, $5b455ae6f843ac47$export$a3fe6d967173a3ac)[dimIdx]];
}
var $c149a9163f5b19cd$export$2e2bcd8739ae039 = $c149a9163f5b19cd$var$Matrix;


function $0a1ba7f84a4891f5$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $2d910f533f587e5a$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $a4152ff1bafb56ac$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem("matrix", (0, $c149a9163f5b19cd$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $692a4df2164e3c50$var$PolarAxisPointer = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PolarAxisPointer, _super);
    function PolarAxisPointer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @override
   */ PolarAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        if (axis.dim === "angle") this.animationThreshold = Math.PI / 18;
        var polar = axis.polar;
        var otherAxis = polar.getOtherAxis(axis);
        var otherExtent = otherAxis.getExtent();
        var coordValue = axis.dataToCoord(value);
        var axisPointerType = axisPointerModel.get("type");
        if (axisPointerType && axisPointerType !== "none") {
            var elStyle = $51dec70890757374$export$b7fe459c7cc50060(axisPointerModel);
            var pointerOption = $692a4df2164e3c50$var$pointerShapeBuilder[axisPointerType](axis, polar, coordValue, otherExtent);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var labelMargin = axisPointerModel.get([
            "label",
            "margin"
        ]);
        var labelPos = $692a4df2164e3c50$var$getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin);
        $51dec70890757374$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, labelPos);
    };
    return PolarAxisPointer;
}((0, $a331d7a6c631e6d9$export$2e2bcd8739ae039));
function $692a4df2164e3c50$var$getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin) {
    var axis = axisModel.axis;
    var coord = axis.dataToCoord(value);
    var axisAngle = polar.getAngleAxis().getExtent()[0];
    axisAngle = axisAngle / 180 * Math.PI;
    var radiusExtent = polar.getRadiusAxis().getExtent();
    var position;
    var align;
    var verticalAlign;
    if (axis.dim === "radius") {
        var transform = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
        $f41ebb9dd60b55b4$export$bb628a54ab399bc9(transform, transform, axisAngle);
        $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(transform, transform, [
            polar.cx,
            polar.cy
        ]);
        position = $5b455ae6f843ac47$export$9f9dcb98c894b623([
            coord,
            -labelMargin
        ], transform);
        var labelRotation = axisModel.getModel("axisLabel").get("rotate") || 0;
        // @ts-ignore
        var labelLayout = (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039).innerTextLayout(axisAngle, labelRotation * Math.PI / 180, -1);
        align = labelLayout.textAlign;
        verticalAlign = labelLayout.textVerticalAlign;
    } else {
        // angle axis
        var r = radiusExtent[1];
        position = polar.coordToPoint([
            r + labelMargin,
            coord
        ]);
        var cx = polar.cx;
        var cy = polar.cy;
        align = Math.abs(position[0] - cx) / r < 0.3 ? "center" : position[0] > cx ? "left" : "right";
        verticalAlign = Math.abs(position[1] - cy) / r < 0.3 ? "middle" : position[1] > cy ? "top" : "bottom";
    }
    return {
        position: position,
        align: align,
        verticalAlign: verticalAlign
    };
}
var $692a4df2164e3c50$var$pointerShapeBuilder = {
    line: function(axis, polar, coordValue, otherExtent) {
        return axis.dim === "angle" ? {
            type: "Line",
            shape: $51dec70890757374$export$885fa0ad5a826207(polar.coordToPoint([
                otherExtent[0],
                coordValue
            ]), polar.coordToPoint([
                otherExtent[1],
                coordValue
            ]))
        } : {
            type: "Circle",
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: coordValue
            }
        };
    },
    shadow: function(axis, polar, coordValue, otherExtent) {
        var bandWidth = Math.max(1, axis.getBandWidth());
        var radian = Math.PI / 180;
        return axis.dim === "angle" ? {
            type: "Sector",
            shape: $51dec70890757374$export$b0cf82e7ebc0d7d0(polar.cx, polar.cy, otherExtent[0], otherExtent[1], // In ECharts y is negative if angle is positive
            (-coordValue - bandWidth / 2) * radian, (-coordValue + bandWidth / 2) * radian)
        } : {
            type: "Sector",
            shape: $51dec70890757374$export$b0cf82e7ebc0d7d0(polar.cx, polar.cy, coordValue - bandWidth / 2, coordValue + bandWidth / 2, 0, Math.PI * 2)
        };
    }
};
var $692a4df2164e3c50$export$2e2bcd8739ae039 = $692a4df2164e3c50$var$PolarAxisPointer;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $657132d924424c20$var$PolarModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PolarModel, _super);
    function PolarModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PolarModel.type;
        return _this;
    }
    PolarModel.prototype.findAxisModel = function(axisType) {
        var foundAxisModel;
        var ecModel = this.ecModel;
        ecModel.eachComponent(axisType, function(axisModel) {
            if (axisModel.getCoordSysModel() === this) foundAxisModel = axisModel;
        }, this);
        return foundAxisModel;
    };
    PolarModel.type = "polar";
    PolarModel.dependencies = [
        "radiusAxis",
        "angleAxis"
    ];
    PolarModel.defaultOption = {
        // zlevel: 0,
        z: 0,
        center: [
            "50%",
            "50%"
        ],
        radius: "80%"
    };
    return PolarModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $657132d924424c20$export$2e2bcd8739ae039 = $657132d924424c20$var$PolarModel;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $d885303d9d4b2eee$export$ae9b190f9f84c66f = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PolarAxisModel, _super);
    function PolarAxisModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PolarAxisModel.prototype.getCoordSysModel = function() {
        return this.getReferringComponents("polar", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
    };
    PolarAxisModel.type = "polarAxis";
    return PolarAxisModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($d885303d9d4b2eee$export$ae9b190f9f84c66f, (0, $3449fd4c0590d99e$export$5c54b224726edb5a));
var $d885303d9d4b2eee$export$34735c2c701428ca = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(AngleAxisModel, _super);
    function AngleAxisModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AngleAxisModel.type;
        return _this;
    }
    AngleAxisModel.type = "angleAxis";
    return AngleAxisModel;
}($d885303d9d4b2eee$export$ae9b190f9f84c66f);
var $d885303d9d4b2eee$export$de202388c212a23b = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RadiusAxisModel, _super);
    function RadiusAxisModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadiusAxisModel.type;
        return _this;
    }
    RadiusAxisModel.type = "radiusAxis";
    return RadiusAxisModel;
}($d885303d9d4b2eee$export$ae9b190f9f84c66f);


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO Axis scale

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $bf08c49320f1faba$var$RadiusAxis = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RadiusAxis, _super);
    function RadiusAxis(scale, radiusExtent) {
        return _super.call(this, "radius", scale, radiusExtent) || this;
    }
    RadiusAxis.prototype.pointToData = function(point, clamp) {
        return this.polar.pointToData(point, clamp)[this.dim === "radius" ? 0 : 1];
    };
    return RadiusAxis;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
$bf08c49320f1faba$var$RadiusAxis.prototype.dataToRadius = (0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039).prototype.dataToCoord;
$bf08c49320f1faba$var$RadiusAxis.prototype.radiusToData = (0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039).prototype.coordToData;
var $bf08c49320f1faba$export$2e2bcd8739ae039 = $bf08c49320f1faba$var$RadiusAxis;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $4a9e505d5dd42027$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $4a9e505d5dd42027$var$AngleAxis = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(AngleAxis, _super);
    function AngleAxis(scale, angleExtent) {
        return _super.call(this, "angle", scale, angleExtent || [
            0,
            360
        ]) || this;
    }
    AngleAxis.prototype.pointToData = function(point, clamp) {
        return this.polar.pointToData(point, clamp)[this.dim === "radius" ? 0 : 1];
    };
    /**
   * Only be called in category axis.
   * Angle axis uses text height to decide interval
   *
   * @override
   * @return {number} Auto interval for cateogry axis tick and label
   */ AngleAxis.prototype.calculateCategoryInterval = function() {
        var axis = this;
        var labelModel = axis.getLabelModel();
        var ordinalScale = axis.scale;
        var ordinalExtent = ordinalScale.getExtent();
        // Providing this method is for optimization:
        // avoid generating a long array by `getTicks`
        // in large category data case.
        var tickCount = ordinalScale.count();
        if (ordinalExtent[1] - ordinalExtent[0] < 1) return 0;
        var tickValue = ordinalExtent[0];
        var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
        var unitH = Math.abs(unitSpan);
        // Not precise, just use height as text width
        // and each distance from axis line yet.
        var rect = $6c308355c7107803$export$c381147bfed79d9f(tickValue == null ? "" : tickValue + "", labelModel.getFont(), "center", "top");
        var maxH = Math.max(rect.height, 7);
        var dh = maxH / unitH;
        // 0/0 is NaN, 1/0 is Infinity.
        isNaN(dh) && (dh = Infinity);
        var interval = Math.max(0, Math.floor(dh));
        var cache = $4a9e505d5dd42027$var$inner(axis.model);
        var lastAutoInterval = cache.lastAutoInterval;
        var lastTickCount = cache.lastTickCount;
        // Use cache to keep interval stable while moving zoom window,
        // otherwise the calculated interval might jitter when the zoom
        // window size is close to the interval-changing size.
        if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 && lastAutoInterval > interval) interval = lastAutoInterval;
        else {
            cache.lastTickCount = tickCount;
            cache.lastAutoInterval = interval;
        }
        return interval;
    };
    return AngleAxis;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
$4a9e505d5dd42027$var$AngleAxis.prototype.dataToAngle = (0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039).prototype.dataToCoord;
$4a9e505d5dd42027$var$AngleAxis.prototype.angleToData = (0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039).prototype.coordToData;
var $4a9e505d5dd42027$export$2e2bcd8739ae039 = $4a9e505d5dd42027$var$AngleAxis;


var $bbec1db3de81c4bf$export$f6d9521c10640456 = [
    "radius",
    "angle"
];
var $bbec1db3de81c4bf$var$Polar = /** @class */ function() {
    function Polar(name) {
        this.dimensions = $bbec1db3de81c4bf$export$f6d9521c10640456;
        this.type = "polar";
        /**
     * x of polar center
     */ this.cx = 0;
        /**
     * y of polar center
     */ this.cy = 0;
        this._radiusAxis = new (0, $bf08c49320f1faba$export$2e2bcd8739ae039)();
        this._angleAxis = new (0, $4a9e505d5dd42027$export$2e2bcd8739ae039)();
        this.axisPointerEnabled = true;
        this.name = name || "";
        this._radiusAxis.polar = this._angleAxis.polar = this;
    }
    /**
   * If contain coord
   */ Polar.prototype.containPoint = function(point) {
        var coord = this.pointToCoord(point);
        return this._radiusAxis.contain(coord[0]) && this._angleAxis.contain(coord[1]);
    };
    /**
   * If contain data
   */ Polar.prototype.containData = function(data) {
        return this._radiusAxis.containData(data[0]) && this._angleAxis.containData(data[1]);
    };
    Polar.prototype.getAxis = function(dim) {
        var key = "_" + dim + "Axis";
        return this[key];
    };
    Polar.prototype.getAxes = function() {
        return [
            this._radiusAxis,
            this._angleAxis
        ];
    };
    /**
   * Get axes by type of scale
   */ Polar.prototype.getAxesByScale = function(scaleType) {
        var axes = [];
        var angleAxis = this._angleAxis;
        var radiusAxis = this._radiusAxis;
        angleAxis.scale.type === scaleType && axes.push(angleAxis);
        radiusAxis.scale.type === scaleType && axes.push(radiusAxis);
        return axes;
    };
    Polar.prototype.getAngleAxis = function() {
        return this._angleAxis;
    };
    Polar.prototype.getRadiusAxis = function() {
        return this._radiusAxis;
    };
    Polar.prototype.getOtherAxis = function(axis) {
        var angleAxis = this._angleAxis;
        return axis === angleAxis ? this._radiusAxis : angleAxis;
    };
    /**
   * Base axis will be used on stacking.
   *
   */ Polar.prototype.getBaseAxis = function() {
        return this.getAxesByScale("ordinal")[0] || this.getAxesByScale("time")[0] || this.getAngleAxis();
    };
    Polar.prototype.getTooltipAxes = function(dim) {
        var baseAxis = dim != null && dim !== "auto" ? this.getAxis(dim) : this.getBaseAxis();
        return {
            baseAxes: [
                baseAxis
            ],
            otherAxes: [
                this.getOtherAxis(baseAxis)
            ]
        };
    };
    /**
   * Convert a single data item to (x, y) point.
   * Parameter data is an array which the first element is radius and the second is angle
   */ Polar.prototype.dataToPoint = function(data, clamp, out) {
        return this.coordToPoint([
            this._radiusAxis.dataToRadius(data[0], clamp),
            this._angleAxis.dataToAngle(data[1], clamp)
        ], out);
    };
    /**
   * Convert a (x, y) point to data
   */ Polar.prototype.pointToData = function(point, clamp, out) {
        out = out || [];
        var coord = this.pointToCoord(point);
        out[0] = this._radiusAxis.radiusToData(coord[0], clamp);
        out[1] = this._angleAxis.angleToData(coord[1], clamp);
        return out;
    };
    /**
   * Convert a (x, y) point to (radius, angle) coord
   */ Polar.prototype.pointToCoord = function(point) {
        var dx = point[0] - this.cx;
        var dy = point[1] - this.cy;
        var angleAxis = this.getAngleAxis();
        var extent = angleAxis.getExtent();
        var minAngle = Math.min(extent[0], extent[1]);
        var maxAngle = Math.max(extent[0], extent[1]);
        // Fix fixed extent in polarCreator
        // FIXME
        angleAxis.inverse ? minAngle = maxAngle - 360 : maxAngle = minAngle + 360;
        var radius = Math.sqrt(dx * dx + dy * dy);
        dx /= radius;
        dy /= radius;
        var radian = Math.atan2(-dy, dx) / Math.PI * 180;
        // move to angleExtent
        var dir = radian < minAngle ? 1 : -1;
        while(radian < minAngle || radian > maxAngle)radian += dir * 360;
        return [
            radius,
            radian
        ];
    };
    /**
   * Convert a (radius, angle) coord to (x, y) point
   */ Polar.prototype.coordToPoint = function(coord, out) {
        out = out || [];
        var radius = coord[0];
        var radian = coord[1] / 180 * Math.PI;
        out[0] = Math.cos(radian) * radius + this.cx;
        // Inverse the y
        out[1] = -Math.sin(radian) * radius + this.cy;
        return out;
    };
    /**
   * Get ring area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   */ Polar.prototype.getArea = function() {
        var angleAxis = this.getAngleAxis();
        var radiusAxis = this.getRadiusAxis();
        var radiusExtent = radiusAxis.getExtent().slice();
        radiusExtent[0] > radiusExtent[1] && radiusExtent.reverse();
        var angleExtent = angleAxis.getExtent();
        var RADIAN = Math.PI / 180;
        var EPSILON = 1e-4;
        return {
            cx: this.cx,
            cy: this.cy,
            r0: radiusExtent[0],
            r: radiusExtent[1],
            startAngle: -angleExtent[0] * RADIAN,
            endAngle: -angleExtent[1] * RADIAN,
            clockwise: angleAxis.inverse,
            contain: function(x, y) {
                // It's a ring shape.
                // Start angle and end angle don't matter
                var dx = x - this.cx;
                var dy = y - this.cy;
                var d2 = dx * dx + dy * dy;
                var r = this.r;
                var r0 = this.r0;
                // minus a tiny value 1e-4 in double side to avoid being clipped unexpectedly
                // r == r0 contain nothing
                return r !== r0 && d2 - EPSILON <= r * r && d2 + EPSILON >= r0 * r0;
            },
            // As the bounding box
            x: this.cx - radiusExtent[1],
            y: this.cy - radiusExtent[1],
            width: radiusExtent[1] * 2,
            height: radiusExtent[1] * 2
        };
    };
    Polar.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $bbec1db3de81c4bf$var$getCoordSys(finder);
        return coordSys === this ? this.dataToPoint(value) : null;
    };
    Polar.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $bbec1db3de81c4bf$var$getCoordSys(finder);
        return coordSys === this ? this.pointToData(pixel) : null;
    };
    return Polar;
}();
function $bbec1db3de81c4bf$var$getCoordSys(finder) {
    var seriesModel = finder.seriesModel;
    var polarModel = finder.polarModel;
    return polarModel && polarModel.coordinateSystem || seriesModel && seriesModel.coordinateSystem;
}
var $bbec1db3de81c4bf$export$2e2bcd8739ae039 = $bbec1db3de81c4bf$var$Polar;






/**
 * Resize method bound to the polar
 */ function $45211ba328a63245$var$resizePolar(polar, polarModel, api) {
    var center = polarModel.get("center");
    var refContainer = (0, $93b9bc7f22ac7369$export$5aec1e94f566e59f)(polarModel, api).refContainer;
    polar.cx = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[0], refContainer.width) + refContainer.x;
    polar.cy = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[1], refContainer.height) + refContainer.y;
    var radiusAxis = polar.getRadiusAxis();
    var size = Math.min(refContainer.width, refContainer.height) / 2;
    var radius = polarModel.get("radius");
    if (radius == null) radius = [
        0,
        "100%"
    ];
    else if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(radius)) // r0 = 0
    radius = [
        0,
        radius
    ];
    var parsedRadius = [
        (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(radius[0], size),
        (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(radius[1], size)
    ];
    radiusAxis.inverse ? radiusAxis.setExtent(parsedRadius[1], parsedRadius[0]) : radiusAxis.setExtent(parsedRadius[0], parsedRadius[1]);
}
/**
 * Update polar
 */ function $45211ba328a63245$var$updatePolarScale(ecModel, api) {
    var polar = this;
    var angleAxis = polar.getAngleAxis();
    var radiusAxis = polar.getRadiusAxis();
    // Reset scale
    angleAxis.scale.setExtent(Infinity, -Infinity);
    radiusAxis.scale.setExtent(Infinity, -Infinity);
    ecModel.eachSeries(function(seriesModel) {
        if (seriesModel.coordinateSystem === polar) {
            var data_1 = seriesModel.getData();
            $7a1bd9c2710fea0d$export$79b2f7037acddd43((0, $2d646e51cc34f840$export$e4cf30b1e74cd69d)(data_1, "radius"), function(dim) {
                radiusAxis.scale.unionExtentFromData(data_1, dim);
            });
            $7a1bd9c2710fea0d$export$79b2f7037acddd43((0, $2d646e51cc34f840$export$e4cf30b1e74cd69d)(data_1, "angle"), function(dim) {
                angleAxis.scale.unionExtentFromData(data_1, dim);
            });
        }
    });
    (0, $2d646e51cc34f840$export$51f3e70a54405d5a)(angleAxis.scale, angleAxis.model);
    (0, $2d646e51cc34f840$export$51f3e70a54405d5a)(radiusAxis.scale, radiusAxis.model);
    // Fix extent of category angle axis
    if (angleAxis.type === "category" && !angleAxis.onBand) {
        var extent = angleAxis.getExtent();
        var diff = 360 / angleAxis.scale.count();
        angleAxis.inverse ? extent[1] += diff : extent[1] -= diff;
        angleAxis.setExtent(extent[0], extent[1]);
    }
}
function $45211ba328a63245$var$isAngleAxisModel(axisModel) {
    return axisModel.mainType === "angleAxis";
}
/**
 * Set common axis properties
 */ function $45211ba328a63245$var$setAxis(axis, axisModel) {
    var _a;
    axis.type = axisModel.get("type");
    axis.scale = (0, $2d646e51cc34f840$export$8941c4cacdc8f5a5)(axisModel);
    axis.onBand = axisModel.get("boundaryGap") && axis.type === "category";
    axis.inverse = axisModel.get("inverse");
    if ($45211ba328a63245$var$isAngleAxisModel(axisModel)) {
        axis.inverse = axis.inverse !== axisModel.get("clockwise");
        var startAngle = axisModel.get("startAngle");
        var endAngle = (_a = axisModel.get("endAngle")) !== null && _a !== void 0 ? _a : startAngle + (axis.inverse ? -360 : 360);
        axis.setExtent(startAngle, endAngle);
    }
    // Inject axis instance
    axisModel.axis = axis;
    axis.model = axisModel;
}
var $45211ba328a63245$var$polarCreator = {
    dimensions: (0, $bbec1db3de81c4bf$export$f6d9521c10640456),
    create: function(ecModel, api) {
        var polarList = [];
        ecModel.eachComponent("polar", function(polarModel, idx) {
            var polar = new (0, $bbec1db3de81c4bf$export$2e2bcd8739ae039)(idx + "");
            // Inject resize and update method
            polar.update = $45211ba328a63245$var$updatePolarScale;
            var radiusAxis = polar.getRadiusAxis();
            var angleAxis = polar.getAngleAxis();
            var radiusAxisModel = polarModel.findAxisModel("radiusAxis");
            var angleAxisModel = polarModel.findAxisModel("angleAxis");
            $45211ba328a63245$var$setAxis(radiusAxis, radiusAxisModel);
            $45211ba328a63245$var$setAxis(angleAxis, angleAxisModel);
            $45211ba328a63245$var$resizePolar(polar, polarModel, api);
            polarList.push(polar);
            polarModel.coordinateSystem = polar;
            polar.model = polarModel;
        });
        // Inject coordinateSystem to series
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.get("coordinateSystem") === "polar") {
                var polarModel = seriesModel.getReferringComponents("polar", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
                seriesModel.coordinateSystem = polarModel.coordinateSystem;
            }
        });
        return polarList;
    }
};
var $45211ba328a63245$export$2e2bcd8739ae039 = $45211ba328a63245$var$polarCreator;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $6fbccfdf5ee55341$var$elementList = [
    "axisLine",
    "axisLabel",
    "axisTick",
    "minorTick",
    "splitLine",
    "minorSplitLine",
    "splitArea"
];
function $6fbccfdf5ee55341$var$getAxisLineShape(polar, rExtent, angle) {
    rExtent[1] > rExtent[0] && (rExtent = rExtent.slice().reverse());
    var start = polar.coordToPoint([
        rExtent[0],
        angle
    ]);
    var end = polar.coordToPoint([
        rExtent[1],
        angle
    ]);
    return {
        x1: start[0],
        y1: start[1],
        x2: end[0],
        y2: end[1]
    };
}
function $6fbccfdf5ee55341$var$getRadiusIdx(polar) {
    var radiusAxis = polar.getRadiusAxis();
    return radiusAxis.inverse ? 0 : 1;
}
// Remove the last tick which will overlap the first tick
function $6fbccfdf5ee55341$var$fixAngleOverlap(list) {
    var firstItem = list[0];
    var lastItem = list[list.length - 1];
    if (firstItem && lastItem && Math.abs(Math.abs(firstItem.coord - lastItem.coord) - 360) < 1e-4) list.pop();
}
var $6fbccfdf5ee55341$var$AngleAxisView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(AngleAxisView, _super);
    function AngleAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AngleAxisView.type;
        _this.axisPointerClass = "PolarAxisPointer";
        return _this;
    }
    AngleAxisView.prototype.render = function(angleAxisModel, ecModel) {
        this.group.removeAll();
        if (!angleAxisModel.get("show")) return;
        var angleAxis = angleAxisModel.axis;
        var polar = angleAxis.polar;
        var radiusExtent = polar.getRadiusAxis().getExtent();
        var ticksAngles = angleAxis.getTicksCoords({
            breakTicks: "none"
        });
        var minorTickAngles = angleAxis.getMinorTicksCoords();
        var labels = $7a1bd9c2710fea0d$export$871de8747c9eaa88(angleAxis.getViewLabels(), function(labelItem) {
            labelItem = $7a1bd9c2710fea0d$export$9cd59f9826255e47(labelItem);
            var scale = angleAxis.scale;
            var tickValue = scale.type === "ordinal" ? scale.getRawOrdinalNumber(labelItem.tickValue) : labelItem.tickValue;
            labelItem.coord = angleAxis.dataToCoord(tickValue);
            return labelItem;
        });
        $6fbccfdf5ee55341$var$fixAngleOverlap(labels);
        $6fbccfdf5ee55341$var$fixAngleOverlap(ticksAngles);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($6fbccfdf5ee55341$var$elementList, function(name) {
            if (angleAxisModel.get([
                name,
                "show"
            ]) && (!angleAxis.scale.isBlank() || name === "axisLine")) $6fbccfdf5ee55341$var$angelAxisElementsBuilders[name](this.group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels);
        }, this);
    };
    AngleAxisView.type = "angleAxis";
    return AngleAxisView;
}((0, $58c48a3ef1aa0746$export$2e2bcd8739ae039));
var $6fbccfdf5ee55341$var$angelAxisElementsBuilders = {
    axisLine: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        var lineStyleModel = angleAxisModel.getModel([
            "axisLine",
            "lineStyle"
        ]);
        var angleAxis = polar.getAngleAxis();
        var RADIAN = Math.PI / 180;
        var angleExtent = angleAxis.getExtent();
        // extent id of the axis radius (r0 and r)
        var rId = $6fbccfdf5ee55341$var$getRadiusIdx(polar);
        var r0Id = rId ? 0 : 1;
        var shape;
        var shapeType = Math.abs(angleExtent[1] - angleExtent[0]) === 360 ? "Circle" : "Arc";
        if (radiusExtent[r0Id] === 0) shape = new $5b455ae6f843ac47$exports[shapeType]({
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: radiusExtent[rId],
                startAngle: -angleExtent[0] * RADIAN,
                endAngle: -angleExtent[1] * RADIAN,
                clockwise: angleAxis.inverse
            },
            style: lineStyleModel.getLineStyle(),
            z2: 1,
            silent: true
        });
        else shape = new $5b455ae6f843ac47$exports.Ring({
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: radiusExtent[rId],
                r0: radiusExtent[r0Id]
            },
            style: lineStyleModel.getLineStyle(),
            z2: 1,
            silent: true
        });
        shape.style.fill = null;
        group.add(shape);
    },
    axisTick: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        var tickModel = angleAxisModel.getModel("axisTick");
        var tickLen = (tickModel.get("inside") ? -1 : 1) * tickModel.get("length");
        var radius = radiusExtent[$6fbccfdf5ee55341$var$getRadiusIdx(polar)];
        var lines = $7a1bd9c2710fea0d$export$871de8747c9eaa88(ticksAngles, function(tickAngleItem) {
            return new $5b455ae6f843ac47$exports.Line({
                shape: $6fbccfdf5ee55341$var$getAxisLineShape(polar, [
                    radius,
                    radius + tickLen
                ], tickAngleItem.coord)
            });
        });
        group.add($5b455ae6f843ac47$exports.mergePath(lines, {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e(tickModel.getModel("lineStyle").getLineStyle(), {
                stroke: angleAxisModel.get([
                    "axisLine",
                    "lineStyle",
                    "color"
                ])
            })
        }));
    },
    minorTick: function(group, angleAxisModel, polar, tickAngles, minorTickAngles, radiusExtent) {
        if (!minorTickAngles.length) return;
        var tickModel = angleAxisModel.getModel("axisTick");
        var minorTickModel = angleAxisModel.getModel("minorTick");
        var tickLen = (tickModel.get("inside") ? -1 : 1) * minorTickModel.get("length");
        var radius = radiusExtent[$6fbccfdf5ee55341$var$getRadiusIdx(polar)];
        var lines = [];
        for(var i = 0; i < minorTickAngles.length; i++)for(var k = 0; k < minorTickAngles[i].length; k++)lines.push(new $5b455ae6f843ac47$exports.Line({
            shape: $6fbccfdf5ee55341$var$getAxisLineShape(polar, [
                radius,
                radius + tickLen
            ], minorTickAngles[i][k].coord)
        }));
        group.add($5b455ae6f843ac47$exports.mergePath(lines, {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e(minorTickModel.getModel("lineStyle").getLineStyle(), $7a1bd9c2710fea0d$export$ebe90cb607ad99e(tickModel.getLineStyle(), {
                stroke: angleAxisModel.get([
                    "axisLine",
                    "lineStyle",
                    "color"
                ])
            }))
        }));
    },
    axisLabel: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels) {
        var rawCategoryData = angleAxisModel.getCategories(true);
        var commonLabelModel = angleAxisModel.getModel("axisLabel");
        var labelMargin = commonLabelModel.get("margin");
        var triggerEvent = angleAxisModel.get("triggerEvent");
        // Use length of ticksAngles because it may remove the last tick to avoid overlapping
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(labels, function(labelItem, idx) {
            var labelModel = commonLabelModel;
            var tickValue = labelItem.tickValue;
            var r = radiusExtent[$6fbccfdf5ee55341$var$getRadiusIdx(polar)];
            var p = polar.coordToPoint([
                r + labelMargin,
                labelItem.coord
            ]);
            var cx = polar.cx;
            var cy = polar.cy;
            var labelTextAlign = Math.abs(p[0] - cx) / r < 0.3 ? "center" : p[0] > cx ? "left" : "right";
            var labelTextVerticalAlign = Math.abs(p[1] - cy) / r < 0.3 ? "middle" : p[1] > cy ? "top" : "bottom";
            if (rawCategoryData && rawCategoryData[tickValue]) {
                var rawCategoryItem = rawCategoryData[tickValue];
                if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(rawCategoryItem) && rawCategoryItem.textStyle) labelModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(rawCategoryItem.textStyle, commonLabelModel, commonLabelModel.ecModel);
            }
            var textEl = new $5b455ae6f843ac47$exports.Text({
                silent: (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039).isLabelSilent(angleAxisModel),
                style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(labelModel, {
                    x: p[0],
                    y: p[1],
                    fill: labelModel.getTextColor() || angleAxisModel.get([
                        "axisLine",
                        "lineStyle",
                        "color"
                    ]),
                    text: labelItem.formattedLabel,
                    align: labelTextAlign,
                    verticalAlign: labelTextVerticalAlign
                })
            });
            group.add(textEl);
            $5b455ae6f843ac47$exports.setTooltipConfig({
                el: textEl,
                componentModel: angleAxisModel,
                itemName: labelItem.formattedLabel,
                formatterParamsExtra: {
                    isTruncated: function() {
                        return textEl.isTruncated;
                    },
                    value: labelItem.rawLabel,
                    tickIndex: idx
                }
            });
            // Pack data for mouse event
            if (triggerEvent) {
                var eventData = (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039).makeAxisEventDataBase(angleAxisModel);
                eventData.targetType = "axisLabel";
                eventData.value = labelItem.rawLabel;
                (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(textEl).eventData = eventData;
            }
        }, this);
    },
    splitLine: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        var splitLineModel = angleAxisModel.getModel("splitLine");
        var lineStyleModel = splitLineModel.getModel("lineStyle");
        var lineColors = lineStyleModel.get("color");
        var lineCount = 0;
        lineColors = lineColors instanceof Array ? lineColors : [
            lineColors
        ];
        var splitLines = [];
        for(var i = 0; i < ticksAngles.length; i++){
            var colorIndex = lineCount++ % lineColors.length;
            splitLines[colorIndex] = splitLines[colorIndex] || [];
            splitLines[colorIndex].push(new $5b455ae6f843ac47$exports.Line({
                shape: $6fbccfdf5ee55341$var$getAxisLineShape(polar, radiusExtent, ticksAngles[i].coord)
            }));
        }
        // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitLines.length; i++)group.add($5b455ae6f843ac47$exports.mergePath(splitLines[i], {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                stroke: lineColors[i % lineColors.length]
            }, lineStyleModel.getLineStyle()),
            silent: true,
            z: angleAxisModel.get("z")
        }));
    },
    minorSplitLine: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        if (!minorTickAngles.length) return;
        var minorSplitLineModel = angleAxisModel.getModel("minorSplitLine");
        var lineStyleModel = minorSplitLineModel.getModel("lineStyle");
        var lines = [];
        for(var i = 0; i < minorTickAngles.length; i++)for(var k = 0; k < minorTickAngles[i].length; k++)lines.push(new $5b455ae6f843ac47$exports.Line({
            shape: $6fbccfdf5ee55341$var$getAxisLineShape(polar, radiusExtent, minorTickAngles[i][k].coord)
        }));
        group.add($5b455ae6f843ac47$exports.mergePath(lines, {
            style: lineStyleModel.getLineStyle(),
            silent: true,
            z: angleAxisModel.get("z")
        }));
    },
    splitArea: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        if (!ticksAngles.length) return;
        var splitAreaModel = angleAxisModel.getModel("splitArea");
        var areaStyleModel = splitAreaModel.getModel("areaStyle");
        var areaColors = areaStyleModel.get("color");
        var lineCount = 0;
        areaColors = areaColors instanceof Array ? areaColors : [
            areaColors
        ];
        var splitAreas = [];
        var RADIAN = Math.PI / 180;
        var prevAngle = -ticksAngles[0].coord * RADIAN;
        var r0 = Math.min(radiusExtent[0], radiusExtent[1]);
        var r1 = Math.max(radiusExtent[0], radiusExtent[1]);
        var clockwise = angleAxisModel.get("clockwise");
        for(var i = 1, len = ticksAngles.length; i <= len; i++){
            var coord = i === len ? ticksAngles[0].coord : ticksAngles[i].coord;
            var colorIndex = lineCount++ % areaColors.length;
            splitAreas[colorIndex] = splitAreas[colorIndex] || [];
            splitAreas[colorIndex].push(new $5b455ae6f843ac47$exports.Sector({
                shape: {
                    cx: polar.cx,
                    cy: polar.cy,
                    r0: r0,
                    r: r1,
                    startAngle: prevAngle,
                    endAngle: -coord * RADIAN,
                    clockwise: clockwise
                },
                silent: true
            }));
            prevAngle = -coord * RADIAN;
        }
        // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitAreas.length; i++)group.add($5b455ae6f843ac47$exports.mergePath(splitAreas[i], {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                fill: areaColors[i % areaColors.length]
            }, areaStyleModel.getAreaStyle()),
            silent: true
        }));
    }
};
var $6fbccfdf5ee55341$export$2e2bcd8739ae039 = $6fbccfdf5ee55341$var$AngleAxisView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $e1f5ed5855e953f0$var$selfBuilderAttrs = [
    "splitLine",
    "splitArea",
    "minorSplitLine"
];
var $e1f5ed5855e953f0$var$RadiusAxisView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RadiusAxisView, _super);
    function RadiusAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadiusAxisView.type;
        _this.axisPointerClass = "PolarAxisPointer";
        return _this;
    }
    RadiusAxisView.prototype.render = function(radiusAxisModel, ecModel, api) {
        this.group.removeAll();
        if (!radiusAxisModel.get("show")) return;
        var oldAxisGroup = this._axisGroup;
        var newAxisGroup = this._axisGroup = new $5b455ae6f843ac47$exports.Group();
        this.group.add(newAxisGroup);
        var radiusAxis = radiusAxisModel.axis;
        var polar = radiusAxis.polar;
        var angleAxis = polar.getAngleAxis();
        var ticksCoords = radiusAxis.getTicksCoords();
        var minorTicksCoords = radiusAxis.getMinorTicksCoords();
        var axisAngle = angleAxis.getExtent()[0];
        var radiusExtent = radiusAxis.getExtent();
        var layout = $e1f5ed5855e953f0$var$layoutAxis(polar, radiusAxisModel, axisAngle);
        var axisBuilder = new (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039)(radiusAxisModel, api, layout);
        axisBuilder.build();
        newAxisGroup.add(axisBuilder.group);
        $5b455ae6f843ac47$exports.groupTransition(oldAxisGroup, newAxisGroup, radiusAxisModel);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($e1f5ed5855e953f0$var$selfBuilderAttrs, function(name) {
            if (radiusAxisModel.get([
                name,
                "show"
            ]) && !radiusAxis.scale.isBlank()) $e1f5ed5855e953f0$var$axisElementBuilders[name](this.group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords);
        }, this);
    };
    RadiusAxisView.type = "radiusAxis";
    return RadiusAxisView;
}((0, $58c48a3ef1aa0746$export$2e2bcd8739ae039));
var $e1f5ed5855e953f0$var$axisElementBuilders = {
    splitLine: function(group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
        var splitLineModel = radiusAxisModel.getModel("splitLine");
        var lineStyleModel = splitLineModel.getModel("lineStyle");
        var lineColors = lineStyleModel.get("color");
        var lineCount = 0;
        var angleAxis = polar.getAngleAxis();
        var RADIAN = Math.PI / 180;
        var angleExtent = angleAxis.getExtent();
        var shapeType = Math.abs(angleExtent[1] - angleExtent[0]) === 360 ? "Circle" : "Arc";
        lineColors = lineColors instanceof Array ? lineColors : [
            lineColors
        ];
        var splitLines = [];
        for(var i = 0; i < ticksCoords.length; i++){
            var colorIndex = lineCount++ % lineColors.length;
            splitLines[colorIndex] = splitLines[colorIndex] || [];
            splitLines[colorIndex].push(new $5b455ae6f843ac47$exports[shapeType]({
                shape: {
                    cx: polar.cx,
                    cy: polar.cy,
                    // ensure circle radius >= 0
                    r: Math.max(ticksCoords[i].coord, 0),
                    startAngle: -angleExtent[0] * RADIAN,
                    endAngle: -angleExtent[1] * RADIAN,
                    clockwise: angleAxis.inverse
                }
            }));
        }
        // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitLines.length; i++)group.add($5b455ae6f843ac47$exports.mergePath(splitLines[i], {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                stroke: lineColors[i % lineColors.length],
                fill: null
            }, lineStyleModel.getLineStyle()),
            silent: true
        }));
    },
    minorSplitLine: function(group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords) {
        if (!minorTicksCoords.length) return;
        var minorSplitLineModel = radiusAxisModel.getModel("minorSplitLine");
        var lineStyleModel = minorSplitLineModel.getModel("lineStyle");
        var lines = [];
        for(var i = 0; i < minorTicksCoords.length; i++)for(var k = 0; k < minorTicksCoords[i].length; k++)lines.push(new $5b455ae6f843ac47$exports.Circle({
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: minorTicksCoords[i][k].coord
            }
        }));
        group.add($5b455ae6f843ac47$exports.mergePath(lines, {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                fill: null
            }, lineStyleModel.getLineStyle()),
            silent: true
        }));
    },
    splitArea: function(group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
        if (!ticksCoords.length) return;
        var splitAreaModel = radiusAxisModel.getModel("splitArea");
        var areaStyleModel = splitAreaModel.getModel("areaStyle");
        var areaColors = areaStyleModel.get("color");
        var lineCount = 0;
        areaColors = areaColors instanceof Array ? areaColors : [
            areaColors
        ];
        var splitAreas = [];
        var prevRadius = ticksCoords[0].coord;
        for(var i = 1; i < ticksCoords.length; i++){
            var colorIndex = lineCount++ % areaColors.length;
            splitAreas[colorIndex] = splitAreas[colorIndex] || [];
            splitAreas[colorIndex].push(new $5b455ae6f843ac47$exports.Sector({
                shape: {
                    cx: polar.cx,
                    cy: polar.cy,
                    r0: prevRadius,
                    r: ticksCoords[i].coord,
                    startAngle: 0,
                    endAngle: Math.PI * 2
                },
                silent: true
            }));
            prevRadius = ticksCoords[i].coord;
        }
        // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitAreas.length; i++)group.add($5b455ae6f843ac47$exports.mergePath(splitAreas[i], {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                fill: areaColors[i % areaColors.length]
            }, areaStyleModel.getAreaStyle()),
            silent: true
        }));
    }
};
/**
 * @inner
 */ function $e1f5ed5855e953f0$var$layoutAxis(polar, radiusAxisModel, axisAngle) {
    return {
        position: [
            polar.cx,
            polar.cy
        ],
        rotation: axisAngle / 180 * Math.PI,
        labelDirection: -1,
        tickDirection: -1,
        nameDirection: 1,
        labelRotate: radiusAxisModel.getModel("axisLabel").get("rotate"),
        // Over splitLine and splitArea
        z2: 1
    };
}
var $e1f5ed5855e953f0$export$2e2bcd8739ae039 = $e1f5ed5855e953f0$var$RadiusAxisView;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $ee4ff9541971b552$var$getSeriesStackId(seriesModel) {
    return seriesModel.get("stack") || "__ec_stack_" + seriesModel.seriesIndex;
}
function $ee4ff9541971b552$var$getAxisKey(polar, axis) {
    return axis.dim + polar.model.componentIndex;
}
function $ee4ff9541971b552$var$barLayoutPolar(seriesType, ecModel, api) {
    var lastStackCoords = {};
    var barWidthAndOffset = $ee4ff9541971b552$var$calRadialBar($7a1bd9c2710fea0d$export$3dea766d36a8935f(ecModel.getSeriesByType(seriesType), function(seriesModel) {
        return !ecModel.isSeriesFiltered(seriesModel) && seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === "polar";
    }));
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        // Check series coordinate, do layout for polar only
        if (seriesModel.coordinateSystem.type !== "polar") return;
        var data = seriesModel.getData();
        var polar = seriesModel.coordinateSystem;
        var baseAxis = polar.getBaseAxis();
        var axisKey = $ee4ff9541971b552$var$getAxisKey(polar, baseAxis);
        var stackId = $ee4ff9541971b552$var$getSeriesStackId(seriesModel);
        var columnLayoutInfo = barWidthAndOffset[axisKey][stackId];
        var columnOffset = columnLayoutInfo.offset;
        var columnWidth = columnLayoutInfo.width;
        var valueAxis = polar.getOtherAxis(baseAxis);
        var cx = seriesModel.coordinateSystem.cx;
        var cy = seriesModel.coordinateSystem.cy;
        var barMinHeight = seriesModel.get("barMinHeight") || 0;
        var barMinAngle = seriesModel.get("barMinAngle") || 0;
        lastStackCoords[stackId] = lastStackCoords[stackId] || [];
        var valueDim = data.mapDimension(valueAxis.dim);
        var baseDim = data.mapDimension(baseAxis.dim);
        var stacked = (0, $efdd976e4917927c$export$1dedc39359ae35c)(data, valueDim /* , baseDim */ );
        var clampLayout = baseAxis.dim !== "radius" || !seriesModel.get("roundCap", true);
        var valueAxisModel = valueAxis.model;
        var startValue = valueAxisModel.get("startValue");
        var valueAxisStart = valueAxis.dataToCoord(startValue || 0);
        for(var idx = 0, len = data.count(); idx < len; idx++){
            var value = data.get(valueDim, idx);
            var baseValue = data.get(baseDim, idx);
            var sign = value >= 0 ? "p" : "n";
            var baseCoord = valueAxisStart;
            // Because of the barMinHeight, we can not use the value in
            // stackResultDimension directly.
            // Only ordinal axis can be stacked.
            if (stacked) {
                if (!lastStackCoords[stackId][baseValue]) lastStackCoords[stackId][baseValue] = {
                    p: valueAxisStart,
                    n: valueAxisStart // Negative stack
                };
                // Should also consider #4243
                baseCoord = lastStackCoords[stackId][baseValue][sign];
            }
            var r0 = void 0;
            var r = void 0;
            var startAngle = void 0;
            var endAngle = void 0;
            // radial sector
            if (valueAxis.dim === "radius") {
                var radiusSpan = valueAxis.dataToCoord(value) - valueAxisStart;
                var angle = baseAxis.dataToCoord(baseValue);
                if (Math.abs(radiusSpan) < barMinHeight) radiusSpan = (radiusSpan < 0 ? -1 : 1) * barMinHeight;
                r0 = baseCoord;
                r = baseCoord + radiusSpan;
                startAngle = angle - columnOffset;
                endAngle = startAngle - columnWidth;
                stacked && (lastStackCoords[stackId][baseValue][sign] = r);
            } else {
                var angleSpan = valueAxis.dataToCoord(value, clampLayout) - valueAxisStart;
                var radius = baseAxis.dataToCoord(baseValue);
                if (Math.abs(angleSpan) < barMinAngle) angleSpan = (angleSpan < 0 ? -1 : 1) * barMinAngle;
                r0 = radius + columnOffset;
                r = r0 + columnWidth;
                startAngle = baseCoord;
                endAngle = baseCoord + angleSpan;
                // if the previous stack is at the end of the ring,
                // add a round to differentiate it from origin
                // let extent = angleAxis.getExtent();
                // let stackCoord = angle;
                // if (stackCoord === extent[0] && value > 0) {
                //     stackCoord = extent[1];
                // }
                // else if (stackCoord === extent[1] && value < 0) {
                //     stackCoord = extent[0];
                // }
                stacked && (lastStackCoords[stackId][baseValue][sign] = endAngle);
            }
            data.setItemLayout(idx, {
                cx: cx,
                cy: cy,
                r0: r0,
                r: r,
                // Consider that positive angle is anti-clockwise,
                // while positive radian of sector is clockwise
                startAngle: -startAngle * Math.PI / 180,
                endAngle: -endAngle * Math.PI / 180,
                /**
         * Keep the same logic with bar in catesion: use end value to
         * control direction. Notice that if clockwise is true (by
         * default), the sector will always draw clockwisely, no matter
         * whether endAngle is greater or less than startAngle.
         */ clockwise: startAngle >= endAngle
            });
        }
    });
}
/**
 * Calculate bar width and offset for radial bar charts
 */ function $ee4ff9541971b552$var$calRadialBar(barSeries) {
    // Columns info on each category axis. Key is polar name
    var columnsMap = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(barSeries, function(seriesModel, idx) {
        var data = seriesModel.getData();
        var polar = seriesModel.coordinateSystem;
        var baseAxis = polar.getBaseAxis();
        var axisKey = $ee4ff9541971b552$var$getAxisKey(polar, baseAxis);
        var axisExtent = baseAxis.getExtent();
        var bandWidth = baseAxis.type === "category" ? baseAxis.getBandWidth() : Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
        var columnsOnAxis = columnsMap[axisKey] || {
            bandWidth: bandWidth,
            remainedWidth: bandWidth,
            autoWidthCount: 0,
            categoryGap: "20%",
            gap: "30%",
            stacks: {}
        };
        var stacks = columnsOnAxis.stacks;
        columnsMap[axisKey] = columnsOnAxis;
        var stackId = $ee4ff9541971b552$var$getSeriesStackId(seriesModel);
        if (!stacks[stackId]) columnsOnAxis.autoWidthCount++;
        stacks[stackId] = stacks[stackId] || {
            width: 0,
            maxWidth: 0
        };
        var barWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("barWidth"), bandWidth);
        var barMaxWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("barMaxWidth"), bandWidth);
        var barGap = seriesModel.get("barGap");
        var barCategoryGap = seriesModel.get("barCategoryGap");
        if (barWidth && !stacks[stackId].width) {
            barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
            stacks[stackId].width = barWidth;
            columnsOnAxis.remainedWidth -= barWidth;
        }
        barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
        barGap != null && (columnsOnAxis.gap = barGap);
        barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
    });
    var result = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(columnsMap, function(columnsOnAxis, coordSysName) {
        result[coordSysName] = {};
        var stacks = columnsOnAxis.stacks;
        var bandWidth = columnsOnAxis.bandWidth;
        var categoryGap = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(columnsOnAxis.categoryGap, bandWidth);
        var barGapPercent = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(columnsOnAxis.gap, 1);
        var remainedWidth = columnsOnAxis.remainedWidth;
        var autoWidthCount = columnsOnAxis.autoWidthCount;
        var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        // Find if any auto calculated bar exceeded maxBarWidth
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(stacks, function(column, stack) {
            var maxWidth = column.maxWidth;
            if (maxWidth && maxWidth < autoWidth) {
                maxWidth = Math.min(maxWidth, remainedWidth);
                if (column.width) maxWidth = Math.min(maxWidth, column.width);
                remainedWidth -= maxWidth;
                column.width = maxWidth;
                autoWidthCount--;
            }
        });
        // Recalculate width again
        autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        var widthSum = 0;
        var lastColumn;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(stacks, function(column, idx) {
            if (!column.width) column.width = autoWidth;
            lastColumn = column;
            widthSum += column.width * (1 + barGapPercent);
        });
        if (lastColumn) widthSum -= lastColumn.width * barGapPercent;
        var offset = -widthSum / 2;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(stacks, function(column, stackId) {
            result[coordSysName][stackId] = result[coordSysName][stackId] || {
                offset: offset,
                width: column.width
            };
            offset += column.width * (1 + barGapPercent);
        });
    });
    return result;
}
var $ee4ff9541971b552$export$2e2bcd8739ae039 = $ee4ff9541971b552$var$barLayoutPolar;


var $0a6536a72e92ce0b$var$angleAxisExtraOption = {
    startAngle: 90,
    clockwise: true,
    splitNumber: 12,
    axisLabel: {
        rotate: 0
    }
};
var $0a6536a72e92ce0b$var$radiusAxisExtraOption = {
    splitNumber: 5
};
var $0a6536a72e92ce0b$var$PolarView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PolarView, _super);
    function PolarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PolarView.type;
        return _this;
    }
    PolarView.type = "polar";
    return PolarView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $0a6536a72e92ce0b$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $589507869c21caa1$export$4b3e715f166fdd78));
    (0, $58c48a3ef1aa0746$export$2e2bcd8739ae039).registerAxisPointerClass("PolarAxisPointer", (0, $692a4df2164e3c50$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem("polar", (0, $45211ba328a63245$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $657132d924424c20$export$2e2bcd8739ae039));
    registers.registerComponentView($0a6536a72e92ce0b$var$PolarView);
    // Model and view for angleAxis and radiusAxis
    (0, $c5c4c85259d60abe$export$2e2bcd8739ae039)(registers, "angle", (0, $d885303d9d4b2eee$export$34735c2c701428ca), $0a6536a72e92ce0b$var$angleAxisExtraOption);
    (0, $c5c4c85259d60abe$export$2e2bcd8739ae039)(registers, "radius", (0, $d885303d9d4b2eee$export$de202388c212a23b), $0a6536a72e92ce0b$var$radiusAxisExtraOption);
    registers.registerComponentView((0, $6fbccfdf5ee55341$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $e1f5ed5855e953f0$export$2e2bcd8739ae039));
    registers.registerLayout((0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)((0, $ee4ff9541971b552$export$2e2bcd8739ae039), "bar"));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $eb958aa0a28bdfd8$export$b3219800bda33a1f(axisModel, opt) {
    opt = opt || {};
    var single = axisModel.coordinateSystem;
    var axis = axisModel.axis;
    var layout = {};
    var axisPosition = axis.position;
    var orient = axis.orient;
    var rect = single.getRect();
    var rectBound = [
        rect.x,
        rect.x + rect.width,
        rect.y,
        rect.y + rect.height
    ];
    var positionMap = {
        horizontal: {
            top: rectBound[2],
            bottom: rectBound[3]
        },
        vertical: {
            left: rectBound[0],
            right: rectBound[1]
        }
    };
    layout.position = [
        orient === "vertical" ? positionMap.vertical[axisPosition] : rectBound[0],
        orient === "horizontal" ? positionMap.horizontal[axisPosition] : rectBound[3]
    ];
    var r = {
        horizontal: 0,
        vertical: 1
    };
    layout.rotation = Math.PI / 2 * r[orient];
    var directionMap = {
        top: -1,
        bottom: 1,
        right: 1,
        left: -1
    };
    layout.labelDirection = layout.tickDirection = layout.nameDirection = directionMap[axisPosition];
    if (axisModel.get([
        "axisTick",
        "inside"
    ])) layout.tickDirection = -layout.tickDirection;
    if ($7a1bd9c2710fea0d$export$8a4d17b6e8486e66(opt.labelInside, axisModel.get([
        "axisLabel",
        "inside"
    ]))) layout.labelDirection = -layout.labelDirection;
    var labelRotate = axisModel.get([
        "axisLabel",
        "rotate"
    ]);
    layout.labelRotate = axisPosition === "top" ? -labelRotate : labelRotate;
    layout.z2 = 1;
    return layout;
}





var $e0635e836f59c3c6$var$selfBuilderAttrs = [
    "splitArea",
    "splitLine",
    "breakArea"
];
var $e0635e836f59c3c6$var$SingleAxisView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SingleAxisView, _super);
    function SingleAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SingleAxisView.type;
        _this.axisPointerClass = "SingleAxisPointer";
        return _this;
    }
    SingleAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        var group = this.group;
        group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        var layout = $eb958aa0a28bdfd8$export$b3219800bda33a1f(axisModel);
        var axisBuilder = new (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039)(axisModel, api, layout);
        axisBuilder.build();
        group.add(this._axisGroup);
        group.add(axisBuilder.group);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($e0635e836f59c3c6$var$selfBuilderAttrs, function(name) {
            if (axisModel.get([
                name,
                "show"
            ])) $e0635e836f59c3c6$var$axisElementBuilders[name](this, this.group, this._axisGroup, axisModel, api);
        }, this);
        $5b455ae6f843ac47$export$64fcab7860c216ae(oldAxisGroup, this._axisGroup, axisModel);
        _super.prototype.render.call(this, axisModel, ecModel, api, payload);
    };
    SingleAxisView.prototype.remove = function() {
        (0, $ff3096b1f24c33b6$export$48ebf2d6ce8ad076)(this);
    };
    SingleAxisView.type = "singleAxis";
    return SingleAxisView;
}((0, $58c48a3ef1aa0746$export$2e2bcd8739ae039));
var $e0635e836f59c3c6$var$axisElementBuilders = {
    splitLine: function(axisView, group, axisGroup, axisModel, api) {
        var axis = axisModel.axis;
        if (axis.scale.isBlank()) return;
        var splitLineModel = axisModel.getModel("splitLine");
        var lineStyleModel = splitLineModel.getModel("lineStyle");
        var lineColors = lineStyleModel.get("color");
        lineColors = lineColors instanceof Array ? lineColors : [
            lineColors
        ];
        var lineWidth = lineStyleModel.get("width");
        var gridRect = axisModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var splitLines = [];
        var lineCount = 0;
        var ticksCoords = axis.getTicksCoords({
            tickModel: splitLineModel,
            breakTicks: "none",
            pruneByBreak: "preserve_extent_bound"
        });
        var p1 = [];
        var p2 = [];
        for(var i = 0; i < ticksCoords.length; ++i){
            var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var line = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                silent: true
            });
            $5b455ae6f843ac47$export$8b4b620d7f4aad1b(line.shape, lineWidth);
            var colorIndex = lineCount++ % lineColors.length;
            splitLines[colorIndex] = splitLines[colorIndex] || [];
            splitLines[colorIndex].push(line);
        }
        var lineStyle = lineStyleModel.getLineStyle([
            "color"
        ]);
        for(var i = 0; i < splitLines.length; ++i)group.add($5b455ae6f843ac47$export$7b1dd269fbc4e903(splitLines[i], {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                stroke: lineColors[i % lineColors.length]
            }, lineStyle),
            silent: true
        }));
    },
    splitArea: function(axisView, group, axisGroup, axisModel, api) {
        (0, $ff3096b1f24c33b6$export$c80b7ef1527ec8c9)(axisView, axisGroup, axisModel, axisModel);
    },
    breakArea: function(axisView, group, axisGroup, axisModel, api) {
        var axisBreakHelper = (0, $0d1e9c0f651d5d16$export$c1d9b2cc33e7e5e)();
        var scale = axisModel.axis.scale;
        if (axisBreakHelper && scale.type !== "ordinal") axisBreakHelper.rectCoordBuildBreakAxis(group, axisView, axisModel, axisModel.coordinateSystem.getRect(), api);
    }
};
var $e0635e836f59c3c6$export$2e2bcd8739ae039 = $e0635e836f59c3c6$var$SingleAxisView;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $0b0fbc117344336a$var$SingleAxisModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SingleAxisModel, _super);
    function SingleAxisModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SingleAxisModel.type;
        return _this;
    }
    SingleAxisModel.prototype.getCoordSysModel = function() {
        return this;
    };
    SingleAxisModel.type = "singleAxis";
    SingleAxisModel.layoutMode = "box";
    SingleAxisModel.defaultOption = {
        left: "5%",
        top: "5%",
        right: "5%",
        bottom: "5%",
        type: "value",
        position: "bottom",
        orient: "horizontal",
        axisLine: {
            show: true,
            lineStyle: {
                width: 1,
                type: "solid"
            }
        },
        // Single coordinate system and single axis is the,
        // which is used as the parent tooltip model.
        // same model, so we set default tooltip show as true.
        tooltip: {
            show: true
        },
        axisTick: {
            show: true,
            length: 6,
            lineStyle: {
                width: 1
            }
        },
        axisLabel: {
            show: true,
            interval: "auto"
        },
        splitLine: {
            show: true,
            lineStyle: {
                type: "dashed",
                opacity: 0.2
            }
        },
        jitter: 0,
        jitterOverlap: true,
        jitterMargin: 2
    };
    return SingleAxisModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($0b0fbc117344336a$var$SingleAxisModel, (0, $3449fd4c0590d99e$export$5c54b224726edb5a).prototype);
var $0b0fbc117344336a$export$2e2bcd8739ae039 = $0b0fbc117344336a$var$SingleAxisModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Single coordinate system creator.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Single coordinates system.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $75328fa4f01e808e$var$SingleAxis = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SingleAxis, _super);
    function SingleAxis(dim, scale, coordExtent, axisType, position) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        _this.type = axisType || "value";
        _this.position = position || "bottom";
        return _this;
    }
    /**
   * Judge the orient of the axis.
   */ SingleAxis.prototype.isHorizontal = function() {
        var position = this.position;
        return position === "top" || position === "bottom";
    };
    SingleAxis.prototype.pointToData = function(point, clamp) {
        return this.coordinateSystem.pointToData(point)[0];
    };
    return SingleAxis;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
var $75328fa4f01e808e$export$2e2bcd8739ae039 = $75328fa4f01e808e$var$SingleAxis;





var $2e4ce743775bada6$export$28486687f659fb1a = [
    "single"
];
/**
 * Create a single coordinates system.
 */ var $2e4ce743775bada6$var$Single = /** @class */ function() {
    function Single(axisModel, ecModel, api) {
        this.type = "single";
        this.dimension = "single";
        /**
     * Add it just for draw tooltip.
     */ this.dimensions = $2e4ce743775bada6$export$28486687f659fb1a;
        this.axisPointerEnabled = true;
        this.model = axisModel;
        this._init(axisModel, ecModel, api);
    }
    /**
   * Initialize single coordinate system.
   */ Single.prototype._init = function(axisModel, ecModel, api) {
        var dim = this.dimension;
        var axis = new (0, $75328fa4f01e808e$export$2e2bcd8739ae039)(dim, $2d646e51cc34f840$export$8941c4cacdc8f5a5(axisModel), [
            0,
            0
        ], axisModel.get("type"), axisModel.get("position"));
        var isCategory = axis.type === "category";
        axis.onBand = isCategory && axisModel.get("boundaryGap");
        axis.inverse = axisModel.get("inverse");
        axis.orient = axisModel.get("orient");
        axisModel.axis = axis;
        axis.model = axisModel;
        axis.coordinateSystem = this;
        this._axis = axis;
    };
    /**
   * Update axis scale after data processed
   */ Single.prototype.update = function(ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.coordinateSystem === this) {
                var data_1 = seriesModel.getData();
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(data_1.mapDimensionsAll(this.dimension), function(dim) {
                    this._axis.scale.unionExtentFromData(data_1, dim);
                }, this);
                $2d646e51cc34f840$export$51f3e70a54405d5a(this._axis.scale, this._axis.model);
            }
        }, this);
    };
    /**
   * Resize the single coordinate system.
   */ Single.prototype.resize = function(axisModel, api) {
        var refContainer = (0, $93b9bc7f22ac7369$export$5aec1e94f566e59f)(axisModel, api).refContainer;
        this._rect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(axisModel.getBoxLayoutParams(), refContainer);
        this._adjustAxis();
    };
    Single.prototype.getRect = function() {
        return this._rect;
    };
    Single.prototype._adjustAxis = function() {
        var rect = this._rect;
        var axis = this._axis;
        var isHorizontal = axis.isHorizontal();
        var extent = isHorizontal ? [
            0,
            rect.width
        ] : [
            0,
            rect.height
        ];
        var idx = axis.inverse ? 1 : 0;
        axis.setExtent(extent[idx], extent[1 - idx]);
        this._updateAxisTransform(axis, isHorizontal ? rect.x : rect.y);
    };
    Single.prototype._updateAxisTransform = function(axis, coordBase) {
        var axisExtent = axis.getExtent();
        var extentSum = axisExtent[0] + axisExtent[1];
        var isHorizontal = axis.isHorizontal();
        axis.toGlobalCoord = isHorizontal ? function(coord) {
            return coord + coordBase;
        } : function(coord) {
            return extentSum - coord + coordBase;
        };
        axis.toLocalCoord = isHorizontal ? function(coord) {
            return coord - coordBase;
        } : function(coord) {
            return extentSum - coord + coordBase;
        };
    };
    /**
   * Get axis.
   */ Single.prototype.getAxis = function() {
        return this._axis;
    };
    /**
   * Get axis, add it just for draw tooltip.
   */ Single.prototype.getBaseAxis = function() {
        return this._axis;
    };
    Single.prototype.getAxes = function() {
        return [
            this._axis
        ];
    };
    Single.prototype.getTooltipAxes = function() {
        return {
            baseAxes: [
                this.getAxis()
            ],
            // Empty otherAxes
            otherAxes: []
        };
    };
    /**
   * If contain point.
   */ Single.prototype.containPoint = function(point) {
        var rect = this.getRect();
        var axis = this.getAxis();
        var orient = axis.orient;
        if (orient === "horizontal") return axis.contain(axis.toLocalCoord(point[0])) && point[1] >= rect.y && point[1] <= rect.y + rect.height;
        else return axis.contain(axis.toLocalCoord(point[1])) && point[0] >= rect.y && point[0] <= rect.y + rect.height;
    };
    Single.prototype.pointToData = function(point, reserved, out) {
        out = out || [];
        var axis = this.getAxis();
        out[0] = axis.coordToData(axis.toLocalCoord(point[axis.orient === "horizontal" ? 0 : 1]));
        return out;
    };
    /**
   * Convert the series data to concrete point.
   * Can be [val] | val
   */ Single.prototype.dataToPoint = function(val, reserved, out) {
        var axis = this.getAxis();
        var rect = this.getRect();
        out = out || [];
        var idx = axis.orient === "horizontal" ? 0 : 1;
        if (val instanceof Array) val = val[0];
        out[idx] = axis.toGlobalCoord(axis.dataToCoord(+val));
        out[1 - idx] = idx === 0 ? rect.y + rect.height / 2 : rect.x + rect.width / 2;
        return out;
    };
    Single.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $2e4ce743775bada6$var$getCoordSys(finder);
        return coordSys === this ? this.dataToPoint(value) : null;
    };
    Single.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $2e4ce743775bada6$var$getCoordSys(finder);
        return coordSys === this ? this.pointToData(pixel) : null;
    };
    return Single;
}();
function $2e4ce743775bada6$var$getCoordSys(finder) {
    var seriesModel = finder.seriesModel;
    var singleModel = finder.singleAxisModel;
    return singleModel && singleModel.coordinateSystem || seriesModel && seriesModel.coordinateSystem;
}
var $2e4ce743775bada6$export$2e2bcd8739ae039 = $2e4ce743775bada6$var$Single;



/**
 * Create single coordinate system and inject it into seriesModel.
 */ function $65313efe3e93ec7e$var$create(ecModel, api) {
    var singles = [];
    ecModel.eachComponent("singleAxis", function(axisModel, idx) {
        var single = new (0, $2e4ce743775bada6$export$2e2bcd8739ae039)(axisModel, ecModel, api);
        single.name = "single_" + idx;
        single.resize(axisModel, api);
        axisModel.coordinateSystem = single;
        singles.push(single);
    });
    ecModel.eachSeries(function(seriesModel) {
        if (seriesModel.get("coordinateSystem") === "singleAxis") {
            var singleAxisModel = seriesModel.getReferringComponents("singleAxis", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
            seriesModel.coordinateSystem = singleAxisModel && singleAxisModel.coordinateSystem;
        }
    });
    return singles;
}
var $65313efe3e93ec7e$var$singleCreator = {
    create: $65313efe3e93ec7e$var$create,
    dimensions: (0, $2e4ce743775bada6$export$28486687f659fb1a)
};
var $65313efe3e93ec7e$export$2e2bcd8739ae039 = $65313efe3e93ec7e$var$singleCreator;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $26df41956a30cbbf$var$XY = [
    "x",
    "y"
];
var $26df41956a30cbbf$var$WH = [
    "width",
    "height"
];
var $26df41956a30cbbf$var$SingleAxisPointer = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SingleAxisPointer, _super);
    function SingleAxisPointer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @override
   */ SingleAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        var coordSys = axis.coordinateSystem;
        var otherExtent = $26df41956a30cbbf$var$getGlobalExtent(coordSys, 1 - $26df41956a30cbbf$var$getPointDimIndex(axis));
        var pixelValue = coordSys.dataToPoint(value)[0];
        var axisPointerType = axisPointerModel.get("type");
        if (axisPointerType && axisPointerType !== "none") {
            var elStyle = $51dec70890757374$export$b7fe459c7cc50060(axisPointerModel);
            var pointerOption = $26df41956a30cbbf$var$pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var layoutInfo = $eb958aa0a28bdfd8$export$b3219800bda33a1f(axisModel);
        $51dec70890757374$export$fd3eb3812211a173(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
    };
    /**
   * @override
   */ SingleAxisPointer.prototype.getHandleTransform = function(value, axisModel, axisPointerModel) {
        var layoutInfo = $eb958aa0a28bdfd8$export$b3219800bda33a1f(axisModel, {
            labelInside: false
        });
        layoutInfo.labelMargin = axisPointerModel.get([
            "handle",
            "margin"
        ]);
        var position = $51dec70890757374$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo);
        return {
            x: position[0],
            y: position[1],
            rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
        };
    };
    /**
   * @override
   */ SingleAxisPointer.prototype.updateHandleTransform = function(transform, delta, axisModel, axisPointerModel) {
        var axis = axisModel.axis;
        var coordSys = axis.coordinateSystem;
        var dimIndex = $26df41956a30cbbf$var$getPointDimIndex(axis);
        var axisExtent = $26df41956a30cbbf$var$getGlobalExtent(coordSys, dimIndex);
        var currPosition = [
            transform.x,
            transform.y
        ];
        currPosition[dimIndex] += delta[dimIndex];
        currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
        currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
        var otherExtent = $26df41956a30cbbf$var$getGlobalExtent(coordSys, 1 - dimIndex);
        var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
        var cursorPoint = [
            cursorOtherValue,
            cursorOtherValue
        ];
        cursorPoint[dimIndex] = currPosition[dimIndex];
        return {
            x: currPosition[0],
            y: currPosition[1],
            rotation: transform.rotation,
            cursorPoint: cursorPoint,
            tooltipOption: {
                verticalAlign: "middle"
            }
        };
    };
    return SingleAxisPointer;
}((0, $a331d7a6c631e6d9$export$2e2bcd8739ae039));
var $26df41956a30cbbf$var$pointerShapeBuilder = {
    line: function(axis, pixelValue, otherExtent) {
        var targetShape = $51dec70890757374$export$885fa0ad5a826207([
            pixelValue,
            otherExtent[0]
        ], [
            pixelValue,
            otherExtent[1]
        ], $26df41956a30cbbf$var$getPointDimIndex(axis));
        return {
            type: "Line",
            subPixelOptimize: true,
            shape: targetShape
        };
    },
    shadow: function(axis, pixelValue, otherExtent) {
        var bandWidth = axis.getBandWidth();
        var span = otherExtent[1] - otherExtent[0];
        return {
            type: "Rect",
            shape: $51dec70890757374$export$a8b35248bcc02756([
                pixelValue - bandWidth / 2,
                otherExtent[0]
            ], [
                bandWidth,
                span
            ], $26df41956a30cbbf$var$getPointDimIndex(axis))
        };
    }
};
function $26df41956a30cbbf$var$getPointDimIndex(axis) {
    return axis.isHorizontal() ? 0 : 1;
}
function $26df41956a30cbbf$var$getGlobalExtent(coordSys, dimIndex) {
    var rect = coordSys.getRect();
    return [
        rect[$26df41956a30cbbf$var$XY[dimIndex]],
        rect[$26df41956a30cbbf$var$XY[dimIndex]] + rect[$26df41956a30cbbf$var$WH[dimIndex]]
    ];
}
var $26df41956a30cbbf$export$2e2bcd8739ae039 = $26df41956a30cbbf$var$SingleAxisPointer;


var $2e3198006a202a14$var$SingleView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SingleView, _super);
    function SingleView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SingleView.type;
        return _this;
    }
    SingleView.type = "single";
    return SingleView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $2e3198006a202a14$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $589507869c21caa1$export$4b3e715f166fdd78));
    (0, $58c48a3ef1aa0746$export$2e2bcd8739ae039).registerAxisPointerClass("SingleAxisPointer", (0, $26df41956a30cbbf$export$2e2bcd8739ae039));
    registers.registerComponentView($2e3198006a202a14$var$SingleView);
    // Axis
    registers.registerComponentView((0, $e0635e836f59c3c6$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $0b0fbc117344336a$export$2e2bcd8739ae039));
    (0, $c5c4c85259d60abe$export$2e2bcd8739ae039)(registers, "single", (0, $0b0fbc117344336a$export$2e2bcd8739ae039), (0, $0b0fbc117344336a$export$2e2bcd8739ae039).defaultOption);
    registers.registerCoordinateSystem("single", (0, $65313efe3e93ec7e$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/**
 * [CAVEAT]: the call order of `ThumbnailView['render']` and other
 *  `ChartView['render']/ComponentView['render']` is not guaranteed.
 */ var $0e6d94028275d751$export$69d81bd4a41e2e2b = /** @class */ function() {
    function ThumbnailBridgeImpl(thumbnailModel) {
        this._thumbnailModel = thumbnailModel;
    }
    ThumbnailBridgeImpl.prototype.reset = function(api) {
        this._renderVersion = api.getMainProcessVersion();
    };
    ThumbnailBridgeImpl.prototype.renderContent = function(opt) {
        var thumbnailView = opt.api.getViewOfComponentModel(this._thumbnailModel);
        if (!thumbnailView) return;
        opt.group.silent = true;
        thumbnailView.renderContent({
            group: opt.group,
            targetTrans: opt.targetTrans,
            z2Range: (0, $5b455ae6f843ac47$export$8215ea00957327f2)(opt.group),
            roamType: opt.roamType,
            viewportRect: opt.viewportRect,
            renderVersion: this._renderVersion
        });
    };
    ThumbnailBridgeImpl.prototype.updateWindow = function(targetTrans, api) {
        var thumbnailView = api.getViewOfComponentModel(this._thumbnailModel);
        if (!thumbnailView) return;
        thumbnailView.updateWindow({
            targetTrans: targetTrans,
            renderVersion: this._renderVersion
        });
    };
    return ThumbnailBridgeImpl;
}();


var $21f24ff984a0f864$export$f107faa448341c12 = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ThumbnailModel, _super);
    function ThumbnailModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ThumbnailModel.type;
        _this.preventAutoZ = true;
        return _this;
    }
    ThumbnailModel.prototype.optionUpdated = function(newCptOption, isInit) {
        this._updateBridge();
    };
    ThumbnailModel.prototype._updateBridge = function() {
        var bridge = this._birdge = this._birdge || new (0, $0e6d94028275d751$export$69d81bd4a41e2e2b)(this);
        // Clear all, in case of option changed.
        this._target = null;
        this.ecModel.eachSeries(function(series) {
            (0, $f9fe8cab4df97889$export$db2c4d283c33f141)(series, null);
        });
        if (this.shouldShow()) {
            var target = this.getTarget();
            // If a component is targeted by more than one thumbnails, simply only the last one works.
            (0, $f9fe8cab4df97889$export$db2c4d283c33f141)(target.baseMapProvider, bridge);
        }
    };
    ThumbnailModel.prototype.shouldShow = function() {
        return this.getShallow("show", true);
    };
    ThumbnailModel.prototype.getBridge = function() {
        return this._birdge;
    };
    ThumbnailModel.prototype.getTarget = function() {
        if (this._target) return this._target;
        // Find by `seriesId`/`seriesIndex`.
        var series = this.getReferringComponents("series", {
            useDefault: false,
            enableAll: false,
            enableNone: false
        }).models[0];
        if (series) {
            if (series.subType !== "graph") series = null;
        } else // If no xxxId and xxxIndex specified, find the first series.graph. If other components,
        // such as geo, is supported in future, the default stretagy may be extended.
        series = this.ecModel.queryComponents({
            mainType: "series",
            subType: "graph"
        })[0];
        this._target = {
            baseMapProvider: series
        };
        return this._target;
    };
    ThumbnailModel.type = "thumbnail";
    ThumbnailModel.layoutMode = "box";
    // All the supported components should be added here.
    ThumbnailModel.dependencies = [
        "series",
        "geo"
    ];
    ThumbnailModel.defaultOption = {
        show: true,
        right: 1,
        bottom: 1,
        height: "25%",
        width: "25%",
        itemStyle: {
            // Use echarts option.backgorundColor by default.
            borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.border,
            borderWidth: 2
        },
        windowStyle: {
            borderWidth: 1,
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral30,
            borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral40,
            opacity: 0.3
        },
        z: 10
    };
    return ThumbnailModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 










var $7ee093dd64d44d97$export$f06e14e146c0b896 = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ThumbnailView, _super);
    function ThumbnailView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ThumbnailView.type;
        return _this;
    }
    ThumbnailView.prototype.render = function(thumbnailModel, ecModel, api) {
        this._api = api;
        this._model = thumbnailModel;
        if (!this._coordSys) this._coordSys = new (0, $4a92e7570d47c1fe$export$2e2bcd8739ae039)();
        if (!this._isEnabled()) {
            this._clear();
            return;
        }
        this._renderVersion = api.getMainProcessVersion();
        var group = this.group;
        group.removeAll();
        var itemStyleModel = thumbnailModel.getModel("itemStyle");
        var itemStyle = itemStyleModel.getItemStyle();
        if (itemStyle.fill == null) itemStyle.fill = ecModel.get("backgroundColor") || (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral00;
        var refContainer = (0, $93b9bc7f22ac7369$export$5aec1e94f566e59f)(thumbnailModel, api).refContainer;
        var boxRect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)((0, $93b9bc7f22ac7369$export$22344244a123da8)(thumbnailModel, true), refContainer);
        var boxBorderWidth = itemStyle.lineWidth || 0;
        var contentRect = this._contentRect = (0, $5b455ae6f843ac47$export$81ed941fdeb91c7c)(boxRect.clone(), boxBorderWidth / 2, true, true);
        var contentGroup = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        group.add(contentGroup);
        contentGroup.setClipPath(new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
            shape: contentRect.plain()
        }));
        var targetGroup = this._targetGroup = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        contentGroup.add(targetGroup);
        // Draw border and background and shadow of thumbnail box.
        var borderShape = boxRect.plain();
        borderShape.r = itemStyleModel.getShallow("borderRadius", true);
        group.add(this._bgRect = new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
            style: itemStyle,
            shape: borderShape,
            silent: false,
            cursor: "grab"
        }));
        var windowStyleModel = thumbnailModel.getModel("windowStyle");
        var windowR = windowStyleModel.getShallow("borderRadius", true);
        contentGroup.add(this._windowRect = new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
            shape: {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
                r: windowR
            },
            style: windowStyleModel.getItemStyle(),
            silent: false,
            cursor: "grab"
        }));
        this._dealRenderContent();
        this._dealUpdateWindow();
        $7ee093dd64d44d97$var$updateZ(thumbnailModel, this);
    };
    /**
   * Can be called asynchronously directly.
   * This method should be idempotent.
   */ ThumbnailView.prototype.renderContent = function(bridgeRendered) {
        this._bridgeRendered = bridgeRendered;
        if (this._isEnabled()) {
            this._dealRenderContent();
            this._dealUpdateWindow();
            $7ee093dd64d44d97$var$updateZ(this._model, this);
        }
    };
    ThumbnailView.prototype._dealRenderContent = function() {
        var bridgeRendered = this._bridgeRendered;
        if (!bridgeRendered || bridgeRendered.renderVersion !== this._renderVersion) return;
        var targetGroup = this._targetGroup;
        var coordSys = this._coordSys;
        var contentRect = this._contentRect;
        targetGroup.removeAll();
        if (!bridgeRendered) return;
        var bridgeGroup = bridgeRendered.group;
        var bridgeRect = bridgeGroup.getBoundingRect();
        targetGroup.add(bridgeGroup);
        this._bgRect.z2 = bridgeRendered.z2Range.min - 10;
        coordSys.setBoundingRect(bridgeRect.x, bridgeRect.y, bridgeRect.width, bridgeRect.height);
        // Use `getLayoutRect` is just to find an approperiate rect in thumbnail.
        var viewRect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)({
            left: "center",
            top: "center",
            aspect: bridgeRect.width / bridgeRect.height
        }, contentRect);
        coordSys.setViewRect(viewRect.x, viewRect.y, viewRect.width, viewRect.height);
        bridgeGroup.attr(coordSys.getTransformInfo().raw);
        this._windowRect.z2 = bridgeRendered.z2Range.max + 10;
        this._resetRoamController(bridgeRendered.roamType);
    };
    /**
   * Can be called from action handler directly.
   * This method should be idempotent.
   */ ThumbnailView.prototype.updateWindow = function(param) {
        var bridgeRendered = this._bridgeRendered;
        if (bridgeRendered && bridgeRendered.renderVersion === param.renderVersion) bridgeRendered.targetTrans = param.targetTrans;
        if (this._isEnabled()) this._dealUpdateWindow();
    };
    ThumbnailView.prototype._dealUpdateWindow = function() {
        var bridgeRendered = this._bridgeRendered;
        if (!bridgeRendered || bridgeRendered.renderVersion !== this._renderVersion) return;
        var invTargetTrans = $f41ebb9dd60b55b4$export$6897c284b6f9f4dc([], bridgeRendered.targetTrans);
        var transTargetToThis = $f41ebb9dd60b55b4$export$6e3a27864ab166fe([], this._coordSys.transform, invTargetTrans);
        this._transThisToTarget = $f41ebb9dd60b55b4$export$6897c284b6f9f4dc([], transTargetToThis);
        var viewportRect = bridgeRendered.viewportRect;
        if (!viewportRect) viewportRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, this._api.getWidth(), this._api.getHeight());
        else viewportRect = viewportRect.clone();
        viewportRect.applyTransform(transTargetToThis);
        var windowRect = this._windowRect;
        var r = windowRect.shape.r;
        windowRect.setShape((0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
            r: r
        }, viewportRect));
    };
    ThumbnailView.prototype._resetRoamController = function(roamType) {
        var _this = this;
        var api = this._api;
        var roamController = this._roamController;
        if (!roamController) roamController = this._roamController = new (0, $15927f329deeab51$export$2e2bcd8739ae039)(api.getZr());
        if (!roamType || !this._isEnabled()) {
            roamController.disable();
            return;
        }
        roamController.enable(roamType, {
            api: api,
            zInfo: {
                component: this._model
            },
            triggerInfo: {
                roamTrigger: null,
                isInSelf: function(e, x, y) {
                    return _this._contentRect.contain(x, y);
                }
            }
        });
        roamController.off("pan").off("zoom").on("pan", (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onPan, this)).on("zoom", (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onZoom, this));
    };
    ThumbnailView.prototype._onPan = function(event) {
        var trans = this._transThisToTarget;
        if (!this._isEnabled() || !trans) return;
        var oldOffset = (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)([], [
            event.oldX,
            event.oldY
        ], trans);
        var newOffset = (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)([], [
            event.oldX - event.dx,
            event.oldY - event.dy
        ], trans);
        this._api.dispatchAction($7ee093dd64d44d97$var$makeRoamPayload(this._model.getTarget().baseMapProvider, {
            dx: newOffset[0] - oldOffset[0],
            dy: newOffset[1] - oldOffset[1]
        }));
    };
    ThumbnailView.prototype._onZoom = function(event) {
        var trans = this._transThisToTarget;
        if (!this._isEnabled() || !trans) return;
        var offset = (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)([], [
            event.originX,
            event.originY
        ], trans);
        this._api.dispatchAction($7ee093dd64d44d97$var$makeRoamPayload(this._model.getTarget().baseMapProvider, {
            zoom: 1 / event.scale,
            originX: offset[0],
            originY: offset[1]
        }));
    };
    /**
   * This method is also responsible for check enable in asynchronous situation,
   * e.g., in event listeners that is supposed to be outdated but not be removed.
   */ ThumbnailView.prototype._isEnabled = function() {
        var thumbnailModel = this._model;
        if (!thumbnailModel || !thumbnailModel.shouldShow()) return false;
        var baseMapProvider = thumbnailModel.getTarget().baseMapProvider;
        if (!baseMapProvider) return false;
        return true;
    };
    ThumbnailView.prototype._clear = function() {
        this.group.removeAll();
        this._bridgeRendered = null;
        if (this._roamController) this._roamController.disable();
    };
    ThumbnailView.prototype.remove = function() {
        this._clear();
    };
    ThumbnailView.prototype.dispose = function() {
        this._clear();
    };
    ThumbnailView.type = "thumbnail";
    return ThumbnailView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $7ee093dd64d44d97$var$makeRoamPayload(baseMapProvider, params) {
    var type = baseMapProvider.mainType === "series" ? baseMapProvider.subType + "Roam" // e.g. 'graphRoam'
     : baseMapProvider.mainType + "Roam"; // e.g., 'geoRoam'
    var payload = {
        type: type
    };
    payload[baseMapProvider.mainType + "Id"] = baseMapProvider.id;
    (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(payload, params);
    return payload;
}
function $7ee093dd64d44d97$var$updateZ(thumbnailModel, thumbnailView) {
    var zInfo = (0, $5b455ae6f843ac47$export$1500a631bea5adda)(thumbnailModel);
    (0, $5b455ae6f843ac47$export$d31cf465bf5e8879)(thumbnailView.group, zInfo.z, zInfo.zlevel);
}


function $3659e9d1145d1e8b$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $21f24ff984a0f864$export$f107faa448341c12));
    registers.registerComponentView((0, $7ee093dd64d44d97$export$f06e14e146c0b896));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $0a5c39a9e7129dc4$var$TimelineModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TimelineModel, _super);
    function TimelineModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TimelineModel.type;
        _this.layoutMode = "box";
        return _this;
    }
    /**
   * @override
   */ TimelineModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        this._initData();
    };
    /**
   * @override
   */ TimelineModel.prototype.mergeOption = function(option) {
        _super.prototype.mergeOption.apply(this, arguments);
        this._initData();
    };
    TimelineModel.prototype.setCurrentIndex = function(currentIndex) {
        if (currentIndex == null) currentIndex = this.option.currentIndex;
        var count = this._data.count();
        if (this.option.loop) currentIndex = (currentIndex % count + count) % count;
        else {
            currentIndex >= count && (currentIndex = count - 1);
            currentIndex < 0 && (currentIndex = 0);
        }
        this.option.currentIndex = currentIndex;
    };
    /**
   * @return {number} currentIndex
   */ TimelineModel.prototype.getCurrentIndex = function() {
        return this.option.currentIndex;
    };
    /**
   * @return {boolean}
   */ TimelineModel.prototype.isIndexMax = function() {
        return this.getCurrentIndex() >= this._data.count() - 1;
    };
    /**
   * @param {boolean} state true: play, false: stop
   */ TimelineModel.prototype.setPlayState = function(state) {
        this.option.autoPlay = !!state;
    };
    /**
   * @return {boolean} true: play, false: stop
   */ TimelineModel.prototype.getPlayState = function() {
        return !!this.option.autoPlay;
    };
    /**
   * @private
   */ TimelineModel.prototype._initData = function() {
        var thisOption = this.option;
        var dataArr = thisOption.data || [];
        var axisType = thisOption.axisType;
        var names = this._names = [];
        var processedDataArr;
        if (axisType === "category") {
            processedDataArr = [];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dataArr, function(item, index) {
                var value = (0, $76d619f648247e6d$export$fb1a222ba5dd6e51)((0, $76d619f648247e6d$export$2c944e12edb48d4b)(item), "");
                var newItem;
                if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(item)) {
                    newItem = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(item);
                    newItem.value = index;
                } else newItem = index;
                processedDataArr.push(newItem);
                names.push(value);
            });
        } else processedDataArr = dataArr;
        var dimType = {
            category: "ordinal",
            time: "time",
            value: "number"
        }[axisType] || "number";
        var data = this._data = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)([
            {
                name: "value",
                type: dimType
            }
        ], this);
        data.initData(processedDataArr, names);
    };
    TimelineModel.prototype.getData = function() {
        return this._data;
    };
    /**
   * @public
   * @return {Array.<string>} categoreis
   */ TimelineModel.prototype.getCategories = function() {
        if (this.get("axisType") === "category") return this._names.slice();
    };
    TimelineModel.type = "timeline";
    /**
   * @protected
   */ TimelineModel.defaultOption = {
        // zlevel: 0,                  // 一级层叠
        z: 4,
        show: true,
        axisType: "time",
        realtime: true,
        left: "20%",
        top: null,
        right: "20%",
        bottom: 0,
        width: null,
        height: 40,
        padding: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).size.m,
        controlPosition: "left",
        autoPlay: false,
        rewind: false,
        loop: true,
        playInterval: 2000,
        currentIndex: 0,
        itemStyle: {},
        label: {
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.secondary
        },
        data: []
    };
    return TimelineModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $0a5c39a9e7129dc4$export$2e2bcd8739ae039 = $0a5c39a9e7129dc4$var$TimelineModel;






var $22b93c2a0cce341f$var$SliderTimelineModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SliderTimelineModel, _super);
    function SliderTimelineModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SliderTimelineModel.type;
        return _this;
    }
    SliderTimelineModel.type = "timeline.slider";
    /**
   * @protected
   */ SliderTimelineModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $0a5c39a9e7129dc4$export$2e2bcd8739ae039).defaultOption, {
        backgroundColor: "rgba(0,0,0,0)",
        borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.border,
        borderWidth: 0,
        orient: "horizontal",
        inverse: false,
        tooltip: {
            trigger: "item" // data item may also have tootip attr.
        },
        symbol: "circle",
        symbolSize: 12,
        lineStyle: {
            show: true,
            width: 2,
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent10
        },
        label: {
            position: "auto",
            // When using number, label position is not
            // restricted by viewRect.
            // positive: right/bottom, negative: left/top
            show: true,
            interval: "auto",
            rotate: 0,
            // formatter: null,
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.tertiary
        },
        itemStyle: {
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent20,
            borderWidth: 0
        },
        checkpointStyle: {
            symbol: "circle",
            symbolSize: 15,
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent50,
            borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent50,
            borderWidth: 0,
            shadowBlur: 0,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "rgba(0, 0, 0, 0)",
            // borderColor: 'rgba(194,53,49, 0.5)',
            animation: true,
            animationDuration: 300,
            animationEasing: "quinticInOut"
        },
        controlStyle: {
            show: true,
            showPlayBtn: true,
            showPrevBtn: true,
            showNextBtn: true,
            itemSize: 24,
            itemGap: 12,
            position: "left",
            playIcon: "path://M15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0ZM15 3C8.37258 3 3 8.37258 3 15C3 21.6274 8.37258 27 15 27C21.6274 27 27 21.6274 27 15C27 8.37258 21.6274 3 15 3ZM11.5 10.6699C11.5 9.90014 12.3333 9.41887 13 9.80371L20.5 14.1338C21.1667 14.5187 21.1667 15.4813 20.5 15.8662L13 20.1963C12.3333 20.5811 11.5 20.0999 11.5 19.3301V10.6699Z",
            stopIcon: "path://M15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0ZM15 3C8.37258 3 3 8.37258 3 15C3 21.6274 8.37258 27 15 27C21.6274 27 27 21.6274 27 15C27 8.37258 21.6274 3 15 3ZM11.5 10C12.3284 10 13 10.6716 13 11.5V18.5C13 19.3284 12.3284 20 11.5 20C10.6716 20 10 19.3284 10 18.5V11.5C10 10.6716 10.6716 10 11.5 10ZM18.5 10C19.3284 10 20 10.6716 20 11.5V18.5C20 19.3284 19.3284 20 18.5 20C17.6716 20 17 19.3284 17 18.5V11.5C17 10.6716 17.6716 10 18.5 10Z",
            // eslint-disable-next-line max-len
            nextIcon: "path://M0.838834 18.7383C0.253048 18.1525 0.253048 17.2028 0.838834 16.617L7.55635 9.89949L0.838834 3.18198C0.253048 2.59619 0.253048 1.64645 0.838834 1.06066C1.42462 0.474874 2.37437 0.474874 2.96015 1.06066L10.7383 8.83883L10.8412 8.95277C11.2897 9.50267 11.2897 10.2963 10.8412 10.8462L10.7383 10.9602L2.96015 18.7383C2.37437 19.3241 1.42462 19.3241 0.838834 18.7383Z",
            // eslint-disable-next-line max-len
            prevIcon: "path://M10.9602 1.06066C11.5459 1.64645 11.5459 2.59619 10.9602 3.18198L4.24264 9.89949L10.9602 16.617C11.5459 17.2028 11.5459 18.1525 10.9602 18.7383C10.3744 19.3241 9.42462 19.3241 8.83883 18.7383L1.06066 10.9602L0.957771 10.8462C0.509245 10.2963 0.509245 9.50267 0.957771 8.95277L1.06066 8.83883L8.83883 1.06066C9.42462 0.474874 10.3744 0.474874 10.9602 1.06066Z",
            prevBtnSize: 18,
            nextBtnSize: 18,
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent50,
            borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent50,
            borderWidth: 0
        },
        emphasis: {
            label: {
                show: true,
                // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent60
            },
            itemStyle: {
                color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent60,
                borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent60
            },
            controlStyle: {
                color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent70,
                borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent70
            }
        },
        progress: {
            lineStyle: {
                color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent30
            },
            itemStyle: {
                color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent40
            }
        },
        data: []
    });
    return SliderTimelineModel;
}((0, $0a5c39a9e7129dc4$export$2e2bcd8739ae039));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($22b93c2a0cce341f$var$SliderTimelineModel, (0, $655dd6075cc63601$export$f23396ae04ea95a7).prototype);
var $22b93c2a0cce341f$export$2e2bcd8739ae039 = $22b93c2a0cce341f$var$SliderTimelineModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $79b71ced407c5926$var$TimelineView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TimelineView, _super);
    function TimelineView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TimelineView.type;
        return _this;
    }
    TimelineView.type = "timeline";
    return TimelineView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $79b71ced407c5926$export$2e2bcd8739ae039 = $79b71ced407c5926$var$TimelineView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/**
 * Extend axis 2d
 */ var $d38633a847120ec8$var$TimelineAxis = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TimelineAxis, _super);
    function TimelineAxis(dim, scale, coordExtent, axisType) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        _this.type = axisType || "value";
        return _this;
    }
    /**
   * @override
   */ TimelineAxis.prototype.getLabelModel = function() {
        // Force override
        return this.model.getModel("label");
    };
    /**
   * @override
   */ TimelineAxis.prototype.isHorizontal = function() {
        return this.model.get("orient") === "horizontal";
    };
    return TimelineAxis;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
var $d38633a847120ec8$export$2e2bcd8739ae039 = $d38633a847120ec8$var$TimelineAxis;













var $aba52479ef639cd6$var$PI = Math.PI;
var $aba52479ef639cd6$var$labelDataIndexStore = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $aba52479ef639cd6$var$SliderTimelineView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SliderTimelineView, _super);
    function SliderTimelineView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SliderTimelineView.type;
        return _this;
    }
    SliderTimelineView.prototype.init = function(ecModel, api) {
        this.api = api;
    };
    /**
   * @override
   */ SliderTimelineView.prototype.render = function(timelineModel, ecModel, api) {
        this.model = timelineModel;
        this.api = api;
        this.ecModel = ecModel;
        this.group.removeAll();
        if (timelineModel.get("show", true)) {
            var layoutInfo_1 = this._layout(timelineModel, api);
            var mainGroup_1 = this._createGroup("_mainGroup");
            var labelGroup = this._createGroup("_labelGroup");
            var axis_1 = this._axis = this._createAxis(layoutInfo_1, timelineModel);
            timelineModel.formatTooltip = function(dataIndex) {
                var name = axis_1.scale.getLabel({
                    value: dataIndex
                });
                return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
                    noName: true,
                    value: name
                });
            };
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
                "AxisLine",
                "AxisTick",
                "Control",
                "CurrentPointer"
            ], function(name) {
                this["_render" + name](layoutInfo_1, mainGroup_1, axis_1, timelineModel);
            }, this);
            this._renderAxisLabel(layoutInfo_1, labelGroup, axis_1, timelineModel);
            this._position(layoutInfo_1, timelineModel);
        }
        this._doPlayStop();
        this._updateTicksStatus();
    };
    /**
   * @override
   */ SliderTimelineView.prototype.remove = function() {
        this._clearTimer();
        this.group.removeAll();
    };
    /**
   * @override
   */ SliderTimelineView.prototype.dispose = function() {
        this._clearTimer();
    };
    SliderTimelineView.prototype._layout = function(timelineModel, api) {
        var labelPosOpt = timelineModel.get([
            "label",
            "position"
        ]);
        var orient = timelineModel.get("orient");
        var viewRect = $aba52479ef639cd6$var$getViewRect(timelineModel, api);
        var parsedLabelPos;
        // Auto label offset.
        if (labelPosOpt == null || labelPosOpt === "auto") parsedLabelPos = orient === "horizontal" ? viewRect.y + viewRect.height / 2 < api.getHeight() / 2 ? "-" : "+" : viewRect.x + viewRect.width / 2 < api.getWidth() / 2 ? "+" : "-";
        else if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(labelPosOpt)) parsedLabelPos = ({
            horizontal: {
                top: "-",
                bottom: "+"
            },
            vertical: {
                left: "-",
                right: "+"
            }
        })[orient][labelPosOpt];
        else // is number
        parsedLabelPos = labelPosOpt;
        var labelAlignMap = {
            horizontal: "center",
            vertical: parsedLabelPos >= 0 || parsedLabelPos === "+" ? "left" : "right"
        };
        var labelBaselineMap = {
            horizontal: parsedLabelPos >= 0 || parsedLabelPos === "+" ? "top" : "bottom",
            vertical: "middle"
        };
        var rotationMap = {
            horizontal: 0,
            vertical: $aba52479ef639cd6$var$PI / 2
        };
        // Position
        var mainLength = orient === "vertical" ? viewRect.height : viewRect.width;
        var controlModel = timelineModel.getModel("controlStyle");
        var showControl = controlModel.get("show", true);
        var controlSize = showControl ? controlModel.get("itemSize") : 0;
        var controlGap = showControl ? controlModel.get("itemGap") : 0;
        var sizePlusGap = controlSize + controlGap;
        // Special label rotate.
        var labelRotation = timelineModel.get([
            "label",
            "rotate"
        ]) || 0;
        labelRotation = labelRotation * $aba52479ef639cd6$var$PI / 180; // To radian.
        var playPosition;
        var prevBtnPosition;
        var nextBtnPosition;
        var controlPosition = controlModel.get("position", true);
        var showPlayBtn = showControl && controlModel.get("showPlayBtn", true);
        var showPrevBtn = showControl && controlModel.get("showPrevBtn", true);
        var showNextBtn = showControl && controlModel.get("showNextBtn", true);
        var xLeft = 0;
        var xRight = mainLength;
        // position[0] means left, position[1] means middle.
        if (controlPosition === "left" || controlPosition === "bottom") {
            showPlayBtn && (playPosition = [
                0,
                0
            ], xLeft += sizePlusGap);
            showPrevBtn && (prevBtnPosition = [
                xLeft,
                0
            ], xLeft += sizePlusGap);
            showNextBtn && (nextBtnPosition = [
                xRight - controlSize,
                0
            ], xRight -= sizePlusGap);
        } else {
            // 'top' 'right'
            showPlayBtn && (playPosition = [
                xRight - controlSize,
                0
            ], xRight -= sizePlusGap);
            showPrevBtn && (prevBtnPosition = [
                0,
                0
            ], xLeft += sizePlusGap);
            showNextBtn && (nextBtnPosition = [
                xRight - controlSize,
                0
            ], xRight -= sizePlusGap);
        }
        var axisExtent = [
            xLeft,
            xRight
        ];
        if (timelineModel.get("inverse")) axisExtent.reverse();
        return {
            viewRect: viewRect,
            mainLength: mainLength,
            orient: orient,
            rotation: rotationMap[orient],
            labelRotation: labelRotation,
            labelPosOpt: parsedLabelPos,
            labelAlign: timelineModel.get([
                "label",
                "align"
            ]) || labelAlignMap[orient],
            labelBaseline: timelineModel.get([
                "label",
                "verticalAlign"
            ]) || timelineModel.get([
                "label",
                "baseline"
            ]) || labelBaselineMap[orient],
            // Based on mainGroup.
            playPosition: playPosition,
            prevBtnPosition: prevBtnPosition,
            nextBtnPosition: nextBtnPosition,
            axisExtent: axisExtent,
            controlSize: controlSize,
            controlGap: controlGap
        };
    };
    SliderTimelineView.prototype._position = function(layoutInfo, timelineModel) {
        // Position is be called finally, because bounding rect is needed for
        // adapt content to fill viewRect (auto adapt offset).
        // Timeline may be not all in the viewRect when 'offset' is specified
        // as a number, because it is more appropriate that label aligns at
        // 'offset' but not the other edge defined by viewRect.
        var mainGroup = this._mainGroup;
        var labelGroup = this._labelGroup;
        var viewRect = layoutInfo.viewRect;
        if (layoutInfo.orient === "vertical") {
            // transform to horizontal, inverse rotate by left-top point.
            var m = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
            var rotateOriginX = viewRect.x;
            var rotateOriginY = viewRect.y + viewRect.height;
            $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(m, m, [
                -rotateOriginX,
                -rotateOriginY
            ]);
            $f41ebb9dd60b55b4$export$bb628a54ab399bc9(m, m, -$aba52479ef639cd6$var$PI / 2);
            $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(m, m, [
                rotateOriginX,
                rotateOriginY
            ]);
            viewRect = viewRect.clone();
            viewRect.applyTransform(m);
        }
        var viewBound = getBound(viewRect);
        var mainBound = getBound(mainGroup.getBoundingRect());
        var labelBound = getBound(labelGroup.getBoundingRect());
        var mainPosition = [
            mainGroup.x,
            mainGroup.y
        ];
        var labelsPosition = [
            labelGroup.x,
            labelGroup.y
        ];
        labelsPosition[0] = mainPosition[0] = viewBound[0][0];
        var labelPosOpt = layoutInfo.labelPosOpt;
        if (labelPosOpt == null || (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(labelPosOpt)) {
            // '+' or '-'
            var mainBoundIdx = labelPosOpt === "+" ? 0 : 1;
            toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
            toBound(labelsPosition, labelBound, viewBound, 1, 1 - mainBoundIdx);
        } else {
            var mainBoundIdx = labelPosOpt >= 0 ? 0 : 1;
            toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
            labelsPosition[1] = mainPosition[1] + labelPosOpt;
        }
        mainGroup.setPosition(mainPosition);
        labelGroup.setPosition(labelsPosition);
        mainGroup.rotation = labelGroup.rotation = layoutInfo.rotation;
        setOrigin(mainGroup);
        setOrigin(labelGroup);
        function setOrigin(targetGroup) {
            targetGroup.originX = viewBound[0][0] - targetGroup.x;
            targetGroup.originY = viewBound[1][0] - targetGroup.y;
        }
        function getBound(rect) {
            // [[xmin, xmax], [ymin, ymax]]
            return [
                [
                    rect.x,
                    rect.x + rect.width
                ],
                [
                    rect.y,
                    rect.y + rect.height
                ]
            ];
        }
        function toBound(fromPos, from, to, dimIdx, boundIdx) {
            fromPos[dimIdx] += to[dimIdx][boundIdx] - from[dimIdx][boundIdx];
        }
    };
    SliderTimelineView.prototype._createAxis = function(layoutInfo, timelineModel) {
        var data = timelineModel.getData();
        var axisType = timelineModel.get("axisType");
        var scale = $aba52479ef639cd6$var$createScaleByModel(timelineModel, axisType);
        // Customize scale. The `tickValue` is `dataIndex`.
        scale.getTicks = function() {
            return data.mapArray([
                "value"
            ], function(value) {
                return {
                    value: value
                };
            });
        };
        var dataExtent = data.getDataExtent("value");
        scale.setExtent(dataExtent[0], dataExtent[1]);
        scale.calcNiceTicks();
        var axis = new (0, $d38633a847120ec8$export$2e2bcd8739ae039)("value", scale, layoutInfo.axisExtent, axisType);
        axis.model = timelineModel;
        return axis;
    };
    SliderTimelineView.prototype._createGroup = function(key) {
        var newGroup = this[key] = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this.group.add(newGroup);
        return newGroup;
    };
    SliderTimelineView.prototype._renderAxisLine = function(layoutInfo, group, axis, timelineModel) {
        var axisExtent = axis.getExtent();
        if (!timelineModel.get([
            "lineStyle",
            "show"
        ])) return;
        var line = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
            shape: {
                x1: axisExtent[0],
                y1: 0,
                x2: axisExtent[1],
                y2: 0
            },
            style: (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
                lineCap: "round"
            }, timelineModel.getModel("lineStyle").getLineStyle()),
            silent: true,
            z2: 1
        });
        group.add(line);
        var progressLine = this._progressLine = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
            shape: {
                x1: axisExtent[0],
                x2: this._currentPointer ? this._currentPointer.x : axisExtent[0],
                y1: 0,
                y2: 0
            },
            style: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                lineCap: "round",
                lineWidth: line.style.lineWidth
            }, timelineModel.getModel([
                "progress",
                "lineStyle"
            ]).getLineStyle()),
            silent: true,
            z2: 1
        });
        group.add(progressLine);
    };
    SliderTimelineView.prototype._renderAxisTick = function(layoutInfo, group, axis, timelineModel) {
        var _this = this;
        var data = timelineModel.getData();
        // Show all ticks, despite ignoring strategy.
        var ticks = axis.scale.getTicks();
        this._tickSymbols = [];
        // The value is dataIndex, see the customized scale.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ticks, function(tick) {
            var tickCoord = axis.dataToCoord(tick.value);
            var itemModel = data.getItemModel(tick.value);
            var itemStyleModel = itemModel.getModel("itemStyle");
            var hoverStyleModel = itemModel.getModel([
                "emphasis",
                "itemStyle"
            ]);
            var progressStyleModel = itemModel.getModel([
                "progress",
                "itemStyle"
            ]);
            var symbolOpt = {
                x: tickCoord,
                y: 0,
                onclick: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._changeTimeline, _this, tick.value)
            };
            var el = $aba52479ef639cd6$var$giveSymbol(itemModel, itemStyleModel, group, symbolOpt);
            el.ensureState("emphasis").style = hoverStyleModel.getItemStyle();
            el.ensureState("progress").style = progressStyleModel.getItemStyle();
            (0, $2bf82c0980125b62$export$5f393df0b5aee2e7)(el);
            var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
            if (itemModel.get("tooltip")) {
                ecData.dataIndex = tick.value;
                ecData.dataModel = timelineModel;
            } else ecData.dataIndex = ecData.dataModel = null;
            _this._tickSymbols.push(el);
        });
    };
    SliderTimelineView.prototype._renderAxisLabel = function(layoutInfo, group, axis, timelineModel) {
        var _this = this;
        var labelModel = axis.getLabelModel();
        if (!labelModel.get("show")) return;
        var data = timelineModel.getData();
        var labels = axis.getViewLabels();
        this._tickLabels = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(labels, function(labelItem) {
            // The tickValue is dataIndex, see the customized scale.
            var dataIndex = labelItem.tickValue;
            var itemModel = data.getItemModel(dataIndex);
            var normalLabelModel = itemModel.getModel("label");
            var hoverLabelModel = itemModel.getModel([
                "emphasis",
                "label"
            ]);
            var progressLabelModel = itemModel.getModel([
                "progress",
                "label"
            ]);
            var tickCoord = axis.dataToCoord(labelItem.tickValue);
            var textEl = new $fe885cc21795562b$export$2e2bcd8739ae039({
                x: tickCoord,
                y: 0,
                rotation: layoutInfo.labelRotation - layoutInfo.rotation,
                onclick: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._changeTimeline, _this, dataIndex),
                silent: false,
                style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(normalLabelModel, {
                    text: labelItem.formattedLabel,
                    align: layoutInfo.labelAlign,
                    verticalAlign: layoutInfo.labelBaseline
                })
            });
            textEl.ensureState("emphasis").style = (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(hoverLabelModel);
            textEl.ensureState("progress").style = (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(progressLabelModel);
            group.add(textEl);
            (0, $2bf82c0980125b62$export$5f393df0b5aee2e7)(textEl);
            $aba52479ef639cd6$var$labelDataIndexStore(textEl).dataIndex = dataIndex;
            _this._tickLabels.push(textEl);
        });
    };
    SliderTimelineView.prototype._renderControl = function(layoutInfo, group, axis, timelineModel) {
        var controlSize = layoutInfo.controlSize;
        var rotation = layoutInfo.rotation;
        var itemStyle = timelineModel.getModel("controlStyle").getItemStyle();
        var hoverStyle = timelineModel.getModel([
            "emphasis",
            "controlStyle"
        ]).getItemStyle();
        var playState = timelineModel.getPlayState();
        var inverse = timelineModel.get("inverse", true);
        makeBtn(layoutInfo.nextBtnPosition, "next", (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._changeTimeline, this, inverse ? "-" : "+"));
        makeBtn(layoutInfo.prevBtnPosition, "prev", (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._changeTimeline, this, inverse ? "+" : "-"));
        makeBtn(layoutInfo.playPosition, playState ? "stop" : "play", (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._handlePlayClick, this, !playState), true);
        function makeBtn(position, iconName, onclick, willRotate) {
            if (!position) return;
            var iconSize = (0, $6c308355c7107803$export$e8514cb5a5e2b40f)((0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(timelineModel.get([
                "controlStyle",
                iconName + "BtnSize"
            ]), controlSize), controlSize);
            var rect = [
                0,
                -iconSize / 2,
                iconSize,
                iconSize
            ];
            var btn = $aba52479ef639cd6$var$makeControlIcon(timelineModel, iconName + "Icon", rect, {
                x: position[0],
                y: position[1],
                originX: controlSize / 2,
                originY: 0,
                rotation: willRotate ? -rotation : 0,
                rectHover: true,
                style: itemStyle,
                onclick: onclick
            });
            btn.ensureState("emphasis").style = hoverStyle;
            group.add(btn);
            (0, $2bf82c0980125b62$export$5f393df0b5aee2e7)(btn);
        }
    };
    SliderTimelineView.prototype._renderCurrentPointer = function(layoutInfo, group, axis, timelineModel) {
        var data = timelineModel.getData();
        var currentIndex = timelineModel.getCurrentIndex();
        var pointerModel = data.getItemModel(currentIndex).getModel("checkpointStyle");
        var me = this;
        var callback = {
            onCreate: function(pointer) {
                pointer.draggable = true;
                pointer.drift = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(me._handlePointerDrag, me);
                pointer.ondragend = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(me._handlePointerDragend, me);
                $aba52479ef639cd6$var$pointerMoveTo(pointer, me._progressLine, currentIndex, axis, timelineModel, true);
            },
            onUpdate: function(pointer) {
                $aba52479ef639cd6$var$pointerMoveTo(pointer, me._progressLine, currentIndex, axis, timelineModel);
            }
        };
        // Reuse when exists, for animation and drag.
        this._currentPointer = $aba52479ef639cd6$var$giveSymbol(pointerModel, pointerModel, this._mainGroup, {}, this._currentPointer, callback);
    };
    SliderTimelineView.prototype._handlePlayClick = function(nextState) {
        this._clearTimer();
        this.api.dispatchAction({
            type: "timelinePlayChange",
            playState: nextState,
            from: this.uid
        });
    };
    SliderTimelineView.prototype._handlePointerDrag = function(dx, dy, e) {
        this._clearTimer();
        this._pointerChangeTimeline([
            e.offsetX,
            e.offsetY
        ]);
    };
    SliderTimelineView.prototype._handlePointerDragend = function(e) {
        this._pointerChangeTimeline([
            e.offsetX,
            e.offsetY
        ], true);
    };
    SliderTimelineView.prototype._pointerChangeTimeline = function(mousePos, trigger) {
        var toCoord = this._toAxisCoord(mousePos)[0];
        var axis = this._axis;
        var axisExtent = $cfc1f3b422a3185f$export$debe6e778e0a6d32(axis.getExtent().slice());
        toCoord > axisExtent[1] && (toCoord = axisExtent[1]);
        toCoord < axisExtent[0] && (toCoord = axisExtent[0]);
        this._currentPointer.x = toCoord;
        this._currentPointer.markRedraw();
        var progressLine = this._progressLine;
        if (progressLine) {
            progressLine.shape.x2 = toCoord;
            progressLine.dirty();
        }
        var targetDataIndex = this._findNearestTick(toCoord);
        var timelineModel = this.model;
        if (trigger || targetDataIndex !== timelineModel.getCurrentIndex() && timelineModel.get("realtime")) this._changeTimeline(targetDataIndex);
    };
    SliderTimelineView.prototype._doPlayStop = function() {
        var _this = this;
        this._clearTimer();
        if (this.model.getPlayState()) this._timer = setTimeout(function() {
            // Do not cache
            var timelineModel = _this.model;
            _this._changeTimeline(timelineModel.getCurrentIndex() + (timelineModel.get("rewind", true) ? -1 : 1));
        }, this.model.get("playInterval"));
    };
    SliderTimelineView.prototype._toAxisCoord = function(vertex) {
        var trans = this._mainGroup.getLocalTransform();
        return $5b455ae6f843ac47$export$9f9dcb98c894b623(vertex, trans, true);
    };
    SliderTimelineView.prototype._findNearestTick = function(axisCoord) {
        var data = this.model.getData();
        var dist = Infinity;
        var targetDataIndex;
        var axis = this._axis;
        data.each([
            "value"
        ], function(value, dataIndex) {
            var coord = axis.dataToCoord(value);
            var d = Math.abs(coord - axisCoord);
            if (d < dist) {
                dist = d;
                targetDataIndex = dataIndex;
            }
        });
        return targetDataIndex;
    };
    SliderTimelineView.prototype._clearTimer = function() {
        if (this._timer) {
            clearTimeout(this._timer);
            this._timer = null;
        }
    };
    SliderTimelineView.prototype._changeTimeline = function(nextIndex) {
        var currentIndex = this.model.getCurrentIndex();
        if (nextIndex === "+") nextIndex = currentIndex + 1;
        else if (nextIndex === "-") nextIndex = currentIndex - 1;
        this.api.dispatchAction({
            type: "timelineChange",
            currentIndex: nextIndex,
            from: this.uid
        });
    };
    SliderTimelineView.prototype._updateTicksStatus = function() {
        var currentIndex = this.model.getCurrentIndex();
        var tickSymbols = this._tickSymbols;
        var tickLabels = this._tickLabels;
        if (tickSymbols) for(var i = 0; i < tickSymbols.length; i++)tickSymbols && tickSymbols[i] && tickSymbols[i].toggleState("progress", i < currentIndex);
        if (tickLabels) for(var i = 0; i < tickLabels.length; i++)tickLabels && tickLabels[i] && tickLabels[i].toggleState("progress", $aba52479ef639cd6$var$labelDataIndexStore(tickLabels[i]).dataIndex <= currentIndex);
    };
    SliderTimelineView.type = "timeline.slider";
    return SliderTimelineView;
}((0, $79b71ced407c5926$export$2e2bcd8739ae039));
function $aba52479ef639cd6$var$createScaleByModel(model, axisType) {
    axisType = axisType || model.get("type");
    if (axisType) switch(axisType){
        // Buildin scale
        case "category":
            return new (0, $6e82606ec775d365$export$2e2bcd8739ae039)({
                ordinalMeta: model.getCategories(),
                extent: [
                    Infinity,
                    -Infinity
                ]
            });
        case "time":
            return new (0, $7729d7ac367e621c$export$2e2bcd8739ae039)({
                locale: model.ecModel.getLocaleModel(),
                useUTC: model.ecModel.get("useUTC")
            });
        default:
            // default to be value
            return new (0, $dddb89ade16db3d5$export$2e2bcd8739ae039)();
    }
}
function $aba52479ef639cd6$var$getViewRect(model, api) {
    return $93b9bc7f22ac7369$export$4517a5ca639a7293(model.getBoxLayoutParams(), $93b9bc7f22ac7369$export$5aec1e94f566e59f(model, api).refContainer, model.get("padding"));
}
function $aba52479ef639cd6$var$makeControlIcon(timelineModel, objPath, rect, opts) {
    var style = opts.style;
    var icon = $5b455ae6f843ac47$export$274edc73af1ae9c8(timelineModel.get([
        "controlStyle",
        objPath
    ]), opts || {}, new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(rect[0], rect[1], rect[2], rect[3]));
    // TODO createIcon won't use style in opt.
    if (style) icon.setStyle(style);
    return icon;
}
/**
 * Create symbol or update symbol
 * opt: basic position and event handlers
 */ function $aba52479ef639cd6$var$giveSymbol(hostModel, itemStyleModel, group, opt, symbol, callback) {
    var color = itemStyleModel.get("color");
    if (!symbol) {
        var symbolType = hostModel.get("symbol");
        symbol = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symbolType, -1, -1, 2, 2, color);
        symbol.setStyle("strokeNoScale", true);
        group.add(symbol);
        callback && callback.onCreate(symbol);
    } else {
        symbol.setColor(color);
        group.add(symbol); // Group may be new, also need to add.
        callback && callback.onUpdate(symbol);
    }
    // Style
    var itemStyle = itemStyleModel.getItemStyle([
        "color"
    ]);
    symbol.setStyle(itemStyle);
    // Transform and events.
    opt = (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)({
        rectHover: true,
        z2: 100
    }, opt, true);
    var symbolSize = (0, $5370466dadc978d7$export$a84524f03e8e8dfb)(hostModel.get("symbolSize"));
    opt.scaleX = symbolSize[0] / 2;
    opt.scaleY = symbolSize[1] / 2;
    var symbolOffset = (0, $5370466dadc978d7$export$e3e292895c033f6d)(hostModel.get("symbolOffset"), symbolSize);
    if (symbolOffset) {
        opt.x = (opt.x || 0) + symbolOffset[0];
        opt.y = (opt.y || 0) + symbolOffset[1];
    }
    var symbolRotate = hostModel.get("symbolRotate");
    opt.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
    symbol.attr(opt);
    // FIXME
    // (1) When symbol.style.strokeNoScale is true and updateTransform is not performed,
    // getBoundingRect will return wrong result.
    // (This is supposed to be resolved in zrender, but it is a little difficult to
    // leverage performance and auto updateTransform)
    // (2) All of ancesters of symbol do not scale, so we can just updateTransform symbol.
    symbol.updateTransform();
    return symbol;
}
function $aba52479ef639cd6$var$pointerMoveTo(pointer, progressLine, dataIndex, axis, timelineModel, noAnimation) {
    if (pointer.dragging) return;
    var pointerModel = timelineModel.getModel("checkpointStyle");
    var toCoord = axis.dataToCoord(timelineModel.getData().get("value", dataIndex));
    if (noAnimation || !pointerModel.get("animation", true)) {
        pointer.attr({
            x: toCoord,
            y: 0
        });
        progressLine && progressLine.attr({
            shape: {
                x2: toCoord
            }
        });
    } else {
        var animationCfg = {
            duration: pointerModel.get("animationDuration", true),
            easing: pointerModel.get("animationEasing", true)
        };
        pointer.stopAnimation(null, true);
        pointer.animateTo({
            x: toCoord,
            y: 0
        }, animationCfg);
        progressLine && progressLine.animateTo({
            shape: {
                x2: toCoord
            }
        }, animationCfg);
    }
}
var $aba52479ef639cd6$export$2e2bcd8739ae039 = $aba52479ef639cd6$var$SliderTimelineView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $001a2b3d09da4e02$export$780c34b7cfe44e86(registers) {
    registers.registerAction({
        type: "timelineChange",
        event: "timelineChanged",
        update: "prepareAndUpdate"
    }, function(payload, ecModel, api) {
        var timelineModel = ecModel.getComponent("timeline");
        if (timelineModel && payload.currentIndex != null) {
            timelineModel.setCurrentIndex(payload.currentIndex);
            if (!timelineModel.get("loop", true) && timelineModel.isIndexMax() && timelineModel.getPlayState()) {
                timelineModel.setPlayState(false);
                // The timeline has played to the end, trigger event
                api.dispatchAction({
                    type: "timelinePlayChange",
                    playState: false,
                    from: payload.from
                });
            }
        }
        // Set normalized currentIndex to payload.
        ecModel.resetOption("timeline", {
            replaceMerge: timelineModel.get("replaceMerge", true)
        });
        return (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
            currentIndex: timelineModel.option.currentIndex
        }, payload);
    });
    registers.registerAction({
        type: "timelinePlayChange",
        event: "timelinePlayChanged",
        update: "update"
    }, function(payload, ecModel) {
        var timelineModel = ecModel.getComponent("timeline");
        if (timelineModel && payload.playState != null) timelineModel.setPlayState(payload.playState);
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck

function $a77b6788fc89e6e1$export$2e2bcd8739ae039(option) {
    var timelineOpt = option && option.timeline;
    if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(timelineOpt)) timelineOpt = timelineOpt ? [
        timelineOpt
    ] : [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(timelineOpt, function(opt) {
        if (!opt) return;
        $a77b6788fc89e6e1$var$compatibleEC2(opt);
    });
}
function $a77b6788fc89e6e1$var$compatibleEC2(opt) {
    var type = opt.type;
    var ec2Types = {
        "number": "value",
        "time": "time"
    };
    // Compatible with ec2
    if (ec2Types[type]) {
        opt.axisType = ec2Types[type];
        delete opt.type;
    }
    $a77b6788fc89e6e1$var$transferItem(opt);
    if ($a77b6788fc89e6e1$var$has(opt, "controlPosition")) {
        var controlStyle = opt.controlStyle || (opt.controlStyle = {});
        if (!$a77b6788fc89e6e1$var$has(controlStyle, "position")) controlStyle.position = opt.controlPosition;
        if (controlStyle.position === "none" && !$a77b6788fc89e6e1$var$has(controlStyle, "show")) {
            controlStyle.show = false;
            delete controlStyle.position;
        }
        delete opt.controlPosition;
    }
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(opt.data || [], function(dataItem) {
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(dataItem) && !$7a1bd9c2710fea0d$export$43bee75e5e14138e(dataItem)) {
            if (!$a77b6788fc89e6e1$var$has(dataItem, "value") && $a77b6788fc89e6e1$var$has(dataItem, "name")) // In ec2, using name as value.
            dataItem.value = dataItem.name;
            $a77b6788fc89e6e1$var$transferItem(dataItem);
        }
    });
}
function $a77b6788fc89e6e1$var$transferItem(opt) {
    var itemStyle = opt.itemStyle || (opt.itemStyle = {});
    var itemStyleEmphasis = itemStyle.emphasis || (itemStyle.emphasis = {});
    // Transfer label out
    var label = opt.label || opt.label || {};
    var labelNormal = label.normal || (label.normal = {});
    var excludeLabelAttr = {
        normal: 1,
        emphasis: 1
    };
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(label, function(value, name) {
        if (!excludeLabelAttr[name] && !$a77b6788fc89e6e1$var$has(labelNormal, name)) labelNormal[name] = value;
    });
    if (itemStyleEmphasis.label && !$a77b6788fc89e6e1$var$has(label, "emphasis")) {
        label.emphasis = itemStyleEmphasis.label;
        delete itemStyleEmphasis.label;
    }
}
function $a77b6788fc89e6e1$var$has(obj, attr) {
    return obj.hasOwnProperty(attr);
}


function $d41f79c5664eb934$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $22b93c2a0cce341f$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $aba52479ef639cd6$export$2e2bcd8739ae039));
    registers.registerSubTypeDefaulter("timeline", function() {
        // Only slider now.
        return "slider";
    });
    (0, $001a2b3d09da4e02$export$780c34b7cfe44e86)(registers);
    registers.registerPreprocessor((0, $a77b6788fc89e6e1$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









var $66707465bee49836$var$TitleModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TitleModel, _super);
    function TitleModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TitleModel.type;
        _this.layoutMode = {
            type: "box",
            ignoreSize: true
        };
        return _this;
    }
    TitleModel.type = "title";
    TitleModel.defaultOption = {
        // zlevel: 0,
        z: 6,
        show: true,
        text: "",
        target: "blank",
        subtext: "",
        subtarget: "blank",
        left: "center",
        top: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).size.m,
        backgroundColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.transparent,
        borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.primary,
        borderWidth: 0,
        padding: 5,
        itemGap: 10,
        textStyle: {
            fontSize: 18,
            fontWeight: "bold",
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.primary
        },
        subtextStyle: {
            fontSize: 12,
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.quaternary
        }
    };
    return TitleModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
// View
var $66707465bee49836$var$TitleView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TitleView, _super);
    function TitleView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TitleView.type;
        return _this;
    }
    TitleView.prototype.render = function(titleModel, ecModel, api) {
        this.group.removeAll();
        if (!titleModel.get("show")) return;
        var group = this.group;
        var textStyleModel = titleModel.getModel("textStyle");
        var subtextStyleModel = titleModel.getModel("subtextStyle");
        var textAlign = titleModel.get("textAlign");
        var textVerticalAlign = $7a1bd9c2710fea0d$export$995e01f2f5c9d030(titleModel.get("textBaseline"), titleModel.get("textVerticalAlign"));
        var textEl = new $fe885cc21795562b$export$2e2bcd8739ae039({
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                text: titleModel.get("text"),
                fill: textStyleModel.getTextColor()
            }, {
                disableBox: true
            }),
            z2: 10
        });
        var textRect = textEl.getBoundingRect();
        var subText = titleModel.get("subtext");
        var subTextEl = new $fe885cc21795562b$export$2e2bcd8739ae039({
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(subtextStyleModel, {
                text: subText,
                fill: subtextStyleModel.getTextColor(),
                y: textRect.height + titleModel.get("itemGap"),
                verticalAlign: "top"
            }, {
                disableBox: true
            }),
            z2: 10
        });
        var link = titleModel.get("link");
        var sublink = titleModel.get("sublink");
        var triggerEvent = titleModel.get("triggerEvent", true);
        textEl.silent = !link && !triggerEvent;
        subTextEl.silent = !sublink && !triggerEvent;
        if (link) textEl.on("click", function() {
            (0, $c84c9521536c601a$export$13e13f9b96dbe8fa)(link, "_" + titleModel.get("target"));
        });
        if (sublink) subTextEl.on("click", function() {
            (0, $c84c9521536c601a$export$13e13f9b96dbe8fa)(sublink, "_" + titleModel.get("subtarget"));
        });
        (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(textEl).eventData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(subTextEl).eventData = triggerEvent ? {
            componentType: "title",
            componentIndex: titleModel.componentIndex
        } : null;
        group.add(textEl);
        subText && group.add(subTextEl);
        // If no subText, but add subTextEl, there will be an empty line.
        var groupRect = group.getBoundingRect();
        var layoutOption = titleModel.getBoxLayoutParams();
        layoutOption.width = groupRect.width;
        layoutOption.height = groupRect.height;
        var layoutRef = (0, $93b9bc7f22ac7369$export$5aec1e94f566e59f)(titleModel, api);
        var layoutRect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(layoutOption, layoutRef.refContainer, titleModel.get("padding"));
        // Adjust text align based on position
        if (!textAlign) {
            // Align left if title is on the left. center and right is same
            textAlign = titleModel.get("left") || titleModel.get("right");
            // @ts-ignore
            if (textAlign === "middle") textAlign = "center";
            // Adjust layout by text align
            if (textAlign === "right") layoutRect.x += layoutRect.width;
            else if (textAlign === "center") layoutRect.x += layoutRect.width / 2;
        }
        if (!textVerticalAlign) {
            textVerticalAlign = titleModel.get("top") || titleModel.get("bottom");
            // @ts-ignore
            if (textVerticalAlign === "center") textVerticalAlign = "middle";
            if (textVerticalAlign === "bottom") layoutRect.y += layoutRect.height;
            else if (textVerticalAlign === "middle") layoutRect.y += layoutRect.height / 2;
            textVerticalAlign = textVerticalAlign || "top";
        }
        group.x = layoutRect.x;
        group.y = layoutRect.y;
        group.markRedraw();
        var alignStyle = {
            align: textAlign,
            verticalAlign: textVerticalAlign
        };
        textEl.setStyle(alignStyle);
        subTextEl.setStyle(alignStyle);
        // Render background
        // Get groupRect again because textAlign has been changed
        groupRect = group.getBoundingRect();
        var padding = layoutRect.margin;
        var style = titleModel.getItemStyle([
            "color",
            "opacity"
        ]);
        style.fill = titleModel.get("backgroundColor");
        var rect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
            shape: {
                x: groupRect.x - padding[3],
                y: groupRect.y - padding[0],
                width: groupRect.width + padding[1] + padding[3],
                height: groupRect.height + padding[0] + padding[2],
                r: titleModel.get("borderRadius")
            },
            style: style,
            subPixelOptimize: true,
            silent: true
        });
        group.add(rect);
    };
    TitleView.type = "title";
    return TitleView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $66707465bee49836$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel($66707465bee49836$var$TitleModel);
    registers.registerComponentView($66707465bee49836$var$TitleView);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $4f28f1fbb9446d57$var$SelectDataZoomModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SelectDataZoomModel, _super);
    function SelectDataZoomModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SelectDataZoomModel.type;
        return _this;
    }
    SelectDataZoomModel.type = "dataZoom.select";
    return SelectDataZoomModel;
}((0, $41d57478d16bff21$export$2e2bcd8739ae039));
var $4f28f1fbb9446d57$export$2e2bcd8739ae039 = $4f28f1fbb9446d57$var$SelectDataZoomModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $ee4d1f83b7568801$var$SelectDataZoomView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SelectDataZoomView, _super);
    function SelectDataZoomView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SelectDataZoomView.type;
        return _this;
    }
    SelectDataZoomView.type = "dataZoom.select";
    return SelectDataZoomView;
}((0, $80d6a03162f25654$export$2e2bcd8739ae039));
var $ee4d1f83b7568801$export$2e2bcd8739ae039 = $ee4d1f83b7568801$var$SelectDataZoomView;



function $738a563bbc36032b$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $4f28f1fbb9446d57$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $ee4d1f83b7568801$export$2e2bcd8739ae039));
    (0, $8904ef10f452e35c$export$2e2bcd8739ae039)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $f3a05ea4ae929f91$var$ToolboxModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ToolboxModel, _super);
    function ToolboxModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ToolboxModel.type;
        return _this;
    }
    ToolboxModel.prototype.optionUpdated = function() {
        _super.prototype.optionUpdated.apply(this, arguments);
        var ecModel = this.ecModel;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this.option.feature, function(featureOpt, featureName) {
            var Feature = $974ee7656e10f2d0$export$bba2e7bbd72e62e1(featureName);
            if (Feature) {
                if (Feature.getDefaultOption) Feature.defaultOption = Feature.getDefaultOption(ecModel);
                $7a1bd9c2710fea0d$export$4950aa0f605343fb(featureOpt, Feature.defaultOption);
            }
        });
    };
    ToolboxModel.type = "toolbox";
    ToolboxModel.layoutMode = {
        type: "box",
        ignoreSize: true
    };
    ToolboxModel.defaultOption = {
        show: true,
        z: 6,
        // zlevel: 0,
        orient: "horizontal",
        left: "right",
        top: "top",
        // right
        // bottom
        backgroundColor: "transparent",
        borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.border,
        borderRadius: 0,
        borderWidth: 0,
        padding: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).size.m,
        itemSize: 15,
        itemGap: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).size.s,
        showTitle: true,
        iconStyle: {
            borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent50,
            color: "none"
        },
        emphasis: {
            iconStyle: {
                borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent50
            }
        },
        // textStyle: {},
        // feature
        tooltip: {
            show: false,
            position: "bottom"
        }
    };
    return ToolboxModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $f3a05ea4ae929f91$export$2e2bcd8739ae039 = $f3a05ea4ae929f91$var$ToolboxModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 














var $e0876f124cc8d5c9$var$ToolboxView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ToolboxView, _super);
    function ToolboxView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToolboxView.prototype.render = function(toolboxModel, ecModel, api, payload) {
        var group = this.group;
        group.removeAll();
        if (!toolboxModel.get("show")) return;
        var itemSize = +toolboxModel.get("itemSize");
        var isVertical = toolboxModel.get("orient") === "vertical";
        var featureOpts = toolboxModel.get("feature") || {};
        var features = this._features || (this._features = {});
        var featureNames = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(featureOpts, function(opt, name) {
            featureNames.push(name);
        });
        new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(this._featureNames || [], featureNames).add(processFeature).update(processFeature).remove($7a1bd9c2710fea0d$export$c3095a23b368d1f2(processFeature, null)).execute();
        // Keep for diff.
        this._featureNames = featureNames;
        function processFeature(newIndex, oldIndex) {
            var featureName = featureNames[newIndex];
            var oldName = featureNames[oldIndex];
            var featureOpt = featureOpts[featureName];
            var featureModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(featureOpt, toolboxModel, toolboxModel.ecModel);
            var feature;
            // FIX#11236, merge feature title from MagicType newOption. TODO: consider seriesIndex ?
            if (payload && payload.newTitle != null && payload.featureName === featureName) featureOpt.title = payload.newTitle;
            if (featureName && !oldName) {
                // Create
                if ($e0876f124cc8d5c9$var$isUserFeatureName(featureName)) feature = {
                    onclick: featureModel.option.onclick,
                    featureName: featureName
                };
                else {
                    var Feature = (0, $974ee7656e10f2d0$export$bba2e7bbd72e62e1)(featureName);
                    if (!Feature) return;
                    feature = new Feature();
                }
                features[featureName] = feature;
            } else {
                feature = features[oldName];
                // If feature does not exist.
                if (!feature) return;
            }
            feature.uid = (0, $5370df662b2caf37$export$6d2b3473b0986646)("toolbox-feature");
            feature.model = featureModel;
            feature.ecModel = ecModel;
            feature.api = api;
            var isToolboxFeature = feature instanceof (0, $974ee7656e10f2d0$export$1426bfb1b0bcf539);
            if (!featureName && oldName) {
                isToolboxFeature && feature.dispose && feature.dispose(ecModel, api);
                return;
            }
            if (!featureModel.get("show") || isToolboxFeature && feature.unusable) {
                isToolboxFeature && feature.remove && feature.remove(ecModel, api);
                return;
            }
            createIconPaths(featureModel, feature, featureName);
            featureModel.setIconStatus = function(iconName, status) {
                var option = this.option;
                var iconPaths = this.iconPaths;
                option.iconStatus = option.iconStatus || {};
                option.iconStatus[iconName] = status;
                if (iconPaths[iconName]) (status === "emphasis" ? (0, $2bf82c0980125b62$export$b2d02638cc34c042) : (0, $2bf82c0980125b62$export$11be6f716239ac55))(iconPaths[iconName]);
            };
            if (feature instanceof (0, $974ee7656e10f2d0$export$1426bfb1b0bcf539)) {
                if (feature.render) feature.render(featureModel, ecModel, api, payload);
            }
        }
        function createIconPaths(featureModel, feature, featureName) {
            var iconStyleModel = featureModel.getModel("iconStyle");
            var iconStyleEmphasisModel = featureModel.getModel([
                "emphasis",
                "iconStyle"
            ]);
            // If one feature has multiple icons, they are organized as
            // {
            //     icon: {
            //         foo: '',
            //         bar: ''
            //     },
            //     title: {
            //         foo: '',
            //         bar: ''
            //     }
            // }
            var icons = feature instanceof (0, $974ee7656e10f2d0$export$1426bfb1b0bcf539) && feature.getIcons ? feature.getIcons() : featureModel.get("icon");
            var titles = featureModel.get("title") || {};
            var iconsMap;
            var titlesMap;
            if ($7a1bd9c2710fea0d$export$844ec244b1367d54(icons)) {
                iconsMap = {};
                iconsMap[featureName] = icons;
            } else iconsMap = icons;
            if ($7a1bd9c2710fea0d$export$844ec244b1367d54(titles)) {
                titlesMap = {};
                titlesMap[featureName] = titles;
            } else titlesMap = titles;
            var iconPaths = featureModel.iconPaths = {};
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(iconsMap, function(iconStr, iconName) {
                var path = $5b455ae6f843ac47$export$274edc73af1ae9c8(iconStr, {}, {
                    x: -itemSize / 2,
                    y: -itemSize / 2,
                    width: itemSize,
                    height: itemSize
                }); // TODO handling image
                path.setStyle(iconStyleModel.getItemStyle());
                var pathEmphasisState = path.ensureState("emphasis");
                pathEmphasisState.style = iconStyleEmphasisModel.getItemStyle();
                // Text position calculation
                // TODO: extract `textStyle` from `iconStyle` and use `createTextStyle`
                var textContent = new (0, $fe885cc21795562b$export$2e2bcd8739ae039)({
                    style: {
                        text: titlesMap[iconName],
                        align: iconStyleEmphasisModel.get("textAlign"),
                        borderRadius: iconStyleEmphasisModel.get("textBorderRadius"),
                        padding: iconStyleEmphasisModel.get("textPadding"),
                        fill: null,
                        font: (0, $6800dfcb6e1e2a44$export$155316a870a9d61e)({
                            fontStyle: iconStyleEmphasisModel.get("textFontStyle"),
                            fontFamily: iconStyleEmphasisModel.get("textFontFamily"),
                            fontSize: iconStyleEmphasisModel.get("textFontSize"),
                            fontWeight: iconStyleEmphasisModel.get("textFontWeight")
                        }, ecModel)
                    },
                    ignore: true
                });
                path.setTextContent(textContent);
                $5b455ae6f843ac47$export$fc6410d97fab306c({
                    el: path,
                    componentModel: toolboxModel,
                    itemName: iconName,
                    formatterParamsExtra: {
                        title: titlesMap[iconName]
                    }
                });
                path.__title = titlesMap[iconName];
                path.on("mouseover", function() {
                    // Should not reuse above hoverStyle, which might be modified.
                    var hoverStyle = iconStyleEmphasisModel.getItemStyle();
                    var defaultTextPosition = isVertical ? toolboxModel.get("right") == null && toolboxModel.get("left") !== "right" ? "right" : "left" : toolboxModel.get("bottom") == null && toolboxModel.get("top") !== "bottom" ? "bottom" : "top";
                    textContent.setStyle({
                        fill: iconStyleEmphasisModel.get("textFill") || hoverStyle.fill || hoverStyle.stroke || (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral99,
                        backgroundColor: iconStyleEmphasisModel.get("textBackgroundColor")
                    });
                    path.setTextConfig({
                        position: iconStyleEmphasisModel.get("textPosition") || defaultTextPosition
                    });
                    textContent.ignore = !toolboxModel.get("showTitle");
                    // Use enterEmphasis and leaveEmphasis provide by ec.
                    // There are flags managed by the echarts.
                    api.enterEmphasis(this);
                }).on("mouseout", function() {
                    if (featureModel.get([
                        "iconStatus",
                        iconName
                    ]) !== "emphasis") api.leaveEmphasis(this);
                    textContent.hide();
                });
                (featureModel.get([
                    "iconStatus",
                    iconName
                ]) === "emphasis" ? (0, $2bf82c0980125b62$export$b2d02638cc34c042) : (0, $2bf82c0980125b62$export$11be6f716239ac55))(path);
                group.add(path);
                path.on("click", $7a1bd9c2710fea0d$export$2385a24977818dd0(feature.onclick, feature, ecModel, api, iconName));
                iconPaths[iconName] = path;
            });
        }
        var refContainer = (0, $93b9bc7f22ac7369$export$5aec1e94f566e59f)(toolboxModel, api).refContainer;
        var boxLayoutParams = toolboxModel.getBoxLayoutParams();
        var padding = toolboxModel.get("padding");
        var viewRect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(boxLayoutParams, refContainer, padding);
        (0, $93b9bc7f22ac7369$export$827f4ee28efc37)(toolboxModel.get("orient"), group, toolboxModel.get("itemGap"), viewRect.width, viewRect.height);
        (0, $93b9bc7f22ac7369$export$74054bd96b5eeef1)(group, boxLayoutParams, refContainer, padding);
        // Render background after group is layout
        // FIXME
        group.add($40fca678c85406ff$export$fae23936eedfad4f(group.getBoundingRect(), toolboxModel));
        // Adjust icon title positions to avoid them out of screen
        isVertical || group.eachChild(function(icon) {
            var titleText = icon.__title;
            // const hoverStyle = icon.hoverStyle;
            // TODO simplify code?
            var emphasisState = icon.ensureState("emphasis");
            var emphasisTextConfig = emphasisState.textConfig || (emphasisState.textConfig = {});
            var textContent = icon.getTextContent();
            var emphasisTextState = textContent && textContent.ensureState("emphasis");
            // May be background element
            if (emphasisTextState && !$7a1bd9c2710fea0d$export$f6e2535fb5126e54(emphasisTextState) && titleText) {
                var emphasisTextStyle = emphasisTextState.style || (emphasisTextState.style = {});
                var rect = $6c308355c7107803$export$c381147bfed79d9f(titleText, (0, $fe885cc21795562b$export$2e2bcd8739ae039).makeFont(emphasisTextStyle));
                var offsetX = icon.x + group.x;
                var offsetY = icon.y + group.y + itemSize;
                var needPutOnTop = false;
                if (offsetY + rect.height > api.getHeight()) {
                    emphasisTextConfig.position = "top";
                    needPutOnTop = true;
                }
                var topOffset = needPutOnTop ? -5 - rect.height : itemSize + 10;
                if (offsetX + rect.width / 2 > api.getWidth()) {
                    emphasisTextConfig.position = [
                        "100%",
                        topOffset
                    ];
                    emphasisTextStyle.align = "right";
                } else if (offsetX - rect.width / 2 < 0) {
                    emphasisTextConfig.position = [
                        0,
                        topOffset
                    ];
                    emphasisTextStyle.align = "left";
                }
            }
        });
    };
    ToolboxView.prototype.updateView = function(toolboxModel, ecModel, api, payload) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._features, function(feature) {
            feature instanceof (0, $974ee7656e10f2d0$export$1426bfb1b0bcf539) && feature.updateView && feature.updateView(feature.model, ecModel, api, payload);
        });
    };
    // updateLayout(toolboxModel, ecModel, api, payload) {
    //     zrUtil.each(this._features, function (feature) {
    //         feature.updateLayout && feature.updateLayout(feature.model, ecModel, api, payload);
    //     });
    // },
    ToolboxView.prototype.remove = function(ecModel, api) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._features, function(feature) {
            feature instanceof (0, $974ee7656e10f2d0$export$1426bfb1b0bcf539) && feature.remove && feature.remove(ecModel, api);
        });
        this.group.removeAll();
    };
    ToolboxView.prototype.dispose = function(ecModel, api) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._features, function(feature) {
            feature instanceof (0, $974ee7656e10f2d0$export$1426bfb1b0bcf539) && feature.dispose && feature.dispose(ecModel, api);
        });
    };
    ToolboxView.type = "toolbox";
    return ToolboxView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $e0876f124cc8d5c9$var$isUserFeatureName(featureName) {
    return featureName.indexOf("my") === 0;
}
var $e0876f124cc8d5c9$export$2e2bcd8739ae039 = $e0876f124cc8d5c9$var$ToolboxView;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $1abd70fc7852729e$var$SaveAsImage = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SaveAsImage, _super);
    function SaveAsImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SaveAsImage.prototype.onclick = function(ecModel, api) {
        var model = this.model;
        var title = model.get("name") || ecModel.get("title.0.text") || "echarts";
        var isSvg = api.getZr().painter.getType() === "svg";
        var type = isSvg ? "svg" : model.get("type", true) || "png";
        var url = api.getConnectedDataURL({
            type: type,
            backgroundColor: model.get("backgroundColor", true) || ecModel.get("backgroundColor") || (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral00,
            connectedBackgroundColor: model.get("connectedBackgroundColor"),
            excludeComponents: model.get("excludeComponents"),
            pixelRatio: model.get("pixelRatio")
        });
        var browser = (0, $ce6dd58693a21851$export$2e2bcd8739ae039).browser;
        // Chrome, Firefox, New Edge
        if (typeof MouseEvent === "function" && (browser.newEdge || !browser.ie && !browser.edge)) {
            var $a = document.createElement("a");
            $a.download = title + "." + type;
            $a.target = "_blank";
            $a.href = url;
            var evt = new MouseEvent("click", {
                // some micro front-end framework， window maybe is a Proxy
                view: document.defaultView,
                bubbles: true,
                cancelable: false
            });
            $a.dispatchEvent(evt);
        } else // @ts-ignore
        if (window.navigator.msSaveOrOpenBlob || isSvg) {
            var parts = url.split(",");
            // data:[<mime type>][;charset=<charset>][;base64],<encoded data>
            var base64Encoded = parts[0].indexOf("base64") > -1;
            var bstr = isSvg ? decodeURIComponent(parts[1]) : parts[1];
            // only `atob` when the data uri is encoded with base64
            // otherwise, like `svg` data uri exported by zrender,
            // there will be an error, for it's not encoded with base64.
            // (just a url-encoded string through `encodeURIComponent`)
            base64Encoded && (bstr = window.atob(bstr));
            var filename = title + "." + type;
            // @ts-ignore
            if (window.navigator.msSaveOrOpenBlob) {
                var n = bstr.length;
                var u8arr = new Uint8Array(n);
                while(n--)u8arr[n] = bstr.charCodeAt(n);
                var blob = new Blob([
                    u8arr
                ]); // @ts-ignore
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                var frame = document.createElement("iframe");
                document.body.appendChild(frame);
                var cw = frame.contentWindow;
                var doc = cw.document;
                doc.open("image/svg+xml", "replace");
                doc.write(bstr);
                doc.close();
                cw.focus();
                doc.execCommand("SaveAs", true, filename);
                document.body.removeChild(frame);
            }
        } else {
            var lang = model.get("lang");
            var html = '<body style="margin:0;"><img src="' + url + '" style="max-width:100%;" title="' + (lang && lang[0] || "") + '" />' + "</body>";
            var tab = window.open();
            tab.document.write(html);
            tab.document.title = title;
        }
    };
    SaveAsImage.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            icon: "M4.7,22.9L29.3,45.5L54.7,23.4M4.6,43.6L4.6,58L53.8,58L53.8,43.6M29.2,45.1L29.2,0",
            title: ecModel.getLocaleModel().get([
                "toolbox",
                "saveAsImage",
                "title"
            ]),
            type: "png",
            // Default use option.backgroundColor
            // backgroundColor: '#fff',
            connectedBackgroundColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral00,
            name: "",
            excludeComponents: [
                "toolbox"
            ],
            // use current pixel ratio of device by default
            // pixelRatio: 1,
            lang: ecModel.getLocaleModel().get([
                "toolbox",
                "saveAsImage",
                "lang"
            ])
        };
        return defaultOption;
    };
    return SaveAsImage;
}((0, $974ee7656e10f2d0$export$1426bfb1b0bcf539));
var $1abd70fc7852729e$export$2e2bcd8739ae039 = $1abd70fc7852729e$var$SaveAsImage;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $1a3c941566c70505$var$INNER_STACK_KEYWORD = "__ec_magicType_stack__";
var $1a3c941566c70505$var$ICON_TYPES = [
    "line",
    "bar",
    "stack"
];
// stack and tiled appears in pair for the title
var $1a3c941566c70505$var$TITLE_TYPES = [
    "line",
    "bar",
    "stack",
    "tiled"
];
var $1a3c941566c70505$var$radioTypes = [
    [
        "line",
        "bar"
    ],
    [
        "stack"
    ]
];
var $1a3c941566c70505$var$MagicType = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MagicType, _super);
    function MagicType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MagicType.prototype.getIcons = function() {
        var model = this.model;
        var availableIcons = model.get("icon");
        var icons = {};
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(model.get("type"), function(type) {
            if (availableIcons[type]) icons[type] = availableIcons[type];
        });
        return icons;
    };
    MagicType.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            type: [],
            // Icon group
            icon: {
                line: "M4.1,28.9h7.1l9.3-22l7.4,38l9.7-19.7l3,12.8h14.9M4.1,58h51.4",
                bar: "M6.7,22.9h10V48h-10V22.9zM24.9,13h10v35h-10V13zM43.2,2h10v46h-10V2zM3.1,58h53.7",
                // eslint-disable-next-line
                stack: "M8.2,38.4l-8.4,4.1l30.6,15.3L60,42.5l-8.1-4.1l-21.5,11L8.2,38.4z M51.9,30l-8.1,4.2l-13.4,6.9l-13.9-6.9L8.2,30l-8.4,4.2l8.4,4.2l22.2,11l21.5-11l8.1-4.2L51.9,30z M51.9,21.7l-8.1,4.2L35.7,30l-5.3,2.8L24.9,30l-8.4-4.1l-8.3-4.2l-8.4,4.2L8.2,30l8.3,4.2l13.9,6.9l13.4-6.9l8.1-4.2l8.1-4.1L51.9,21.7zM30.4,2.2L-0.2,17.5l8.4,4.1l8.3,4.2l8.4,4.2l5.5,2.7l5.3-2.7l8.1-4.2l8.1-4.2l8.1-4.1L30.4,2.2z" // jshint ignore:line
            },
            // `line`, `bar`, `stack`, `tiled`
            title: ecModel.getLocaleModel().get([
                "toolbox",
                "magicType",
                "title"
            ]),
            option: {},
            seriesIndex: {}
        };
        return defaultOption;
    };
    MagicType.prototype.onclick = function(ecModel, api, type) {
        var model = this.model;
        var seriesIndex = model.get([
            "seriesIndex",
            type
        ]);
        // Not supported magicType
        if (!$1a3c941566c70505$var$seriesOptGenreator[type]) return;
        var newOption = {
            series: []
        };
        var generateNewSeriesTypes = function(seriesModel) {
            var seriesType = seriesModel.subType;
            var seriesId = seriesModel.id;
            var newSeriesOpt = $1a3c941566c70505$var$seriesOptGenreator[type](seriesType, seriesId, seriesModel, model);
            if (newSeriesOpt) {
                // PENDING If merge original option?
                $7a1bd9c2710fea0d$export$ebe90cb607ad99e(newSeriesOpt, seriesModel.option);
                newOption.series.push(newSeriesOpt);
            }
            // Modify boundaryGap
            var coordSys = seriesModel.coordinateSystem;
            if (coordSys && coordSys.type === "cartesian2d" && (type === "line" || type === "bar")) {
                var categoryAxis = coordSys.getAxesByScale("ordinal")[0];
                if (categoryAxis) {
                    var axisDim = categoryAxis.dim;
                    var axisType = axisDim + "Axis";
                    var axisModel = seriesModel.getReferringComponents(axisType, (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
                    var axisIndex = axisModel.componentIndex;
                    newOption[axisType] = newOption[axisType] || [];
                    for(var i = 0; i <= axisIndex; i++)newOption[axisType][axisIndex] = newOption[axisType][axisIndex] || {};
                    newOption[axisType][axisIndex].boundaryGap = type === "bar";
                }
            }
        };
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($1a3c941566c70505$var$radioTypes, function(radio) {
            if ($7a1bd9c2710fea0d$export$305f7d4e9d4624f2(radio, type) >= 0) $7a1bd9c2710fea0d$export$79b2f7037acddd43(radio, function(item) {
                model.setIconStatus(item, "normal");
            });
        });
        model.setIconStatus(type, "emphasis");
        ecModel.eachComponent({
            mainType: "series",
            query: seriesIndex == null ? null : {
                seriesIndex: seriesIndex
            }
        }, generateNewSeriesTypes);
        var newTitle;
        var currentType = type;
        // Change title of stack
        if (type === "stack") {
            // use titles in model instead of ecModel
            // as stack and tiled appears in pair, just flip them
            // no need of checking stack state
            newTitle = $7a1bd9c2710fea0d$export$4950aa0f605343fb({
                stack: model.option.title.tiled,
                tiled: model.option.title.stack
            }, model.option.title);
            if (model.get([
                "iconStatus",
                type
            ]) !== "emphasis") currentType = "tiled";
        }
        api.dispatchAction({
            type: "changeMagicType",
            currentType: currentType,
            newOption: newOption,
            newTitle: newTitle,
            featureName: "magicType"
        });
    };
    return MagicType;
}((0, $974ee7656e10f2d0$export$1426bfb1b0bcf539));
var $1a3c941566c70505$var$seriesOptGenreator = {
    "line": function(seriesType, seriesId, seriesModel, model) {
        if (seriesType === "bar") return $7a1bd9c2710fea0d$export$4950aa0f605343fb({
            id: seriesId,
            type: "line",
            // Preserve data related option
            data: seriesModel.get("data"),
            stack: seriesModel.get("stack"),
            markPoint: seriesModel.get("markPoint"),
            markLine: seriesModel.get("markLine")
        }, model.get([
            "option",
            "line"
        ]) || {}, true);
    },
    "bar": function(seriesType, seriesId, seriesModel, model) {
        if (seriesType === "line") return $7a1bd9c2710fea0d$export$4950aa0f605343fb({
            id: seriesId,
            type: "bar",
            // Preserve data related option
            data: seriesModel.get("data"),
            stack: seriesModel.get("stack"),
            markPoint: seriesModel.get("markPoint"),
            markLine: seriesModel.get("markLine")
        }, model.get([
            "option",
            "bar"
        ]) || {}, true);
    },
    "stack": function(seriesType, seriesId, seriesModel, model) {
        var isStack = seriesModel.get("stack") === $1a3c941566c70505$var$INNER_STACK_KEYWORD;
        if (seriesType === "line" || seriesType === "bar") {
            model.setIconStatus("stack", isStack ? "normal" : "emphasis");
            return $7a1bd9c2710fea0d$export$4950aa0f605343fb({
                id: seriesId,
                stack: isStack ? "" : $1a3c941566c70505$var$INNER_STACK_KEYWORD
            }, model.get([
                "option",
                "stack"
            ]) || {}, true);
        }
    }
};
// TODO: SELF REGISTERED.
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: "changeMagicType",
    event: "magicTypeChanged",
    update: "prepareAndUpdate"
}, function(payload, ecModel) {
    ecModel.mergeOption(payload.newOption);
});
var $1a3c941566c70505$export$2e2bcd8739ae039 = $1a3c941566c70505$var$MagicType;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






/* global document */ var $c28a86c6c47fb2f6$var$BLOCK_SPLITER = new Array(60).join("-");
var $c28a86c6c47fb2f6$var$ITEM_SPLITER = "	";
/**
 * Group series into two types
 *  1. on category axis, like line, bar
 *  2. others, like scatter, pie
 */ function $c28a86c6c47fb2f6$var$groupSeries(ecModel) {
    var seriesGroupByCategoryAxis = {};
    var otherSeries = [];
    var meta = [];
    ecModel.eachRawSeries(function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && (coordSys.type === "cartesian2d" || coordSys.type === "polar")) {
            // TODO: TYPE Consider polar? Include polar may increase unecessary bundle size.
            var baseAxis = coordSys.getBaseAxis();
            if (baseAxis.type === "category") {
                var key = baseAxis.dim + "_" + baseAxis.index;
                if (!seriesGroupByCategoryAxis[key]) {
                    seriesGroupByCategoryAxis[key] = {
                        categoryAxis: baseAxis,
                        valueAxis: coordSys.getOtherAxis(baseAxis),
                        series: []
                    };
                    meta.push({
                        axisDim: baseAxis.dim,
                        axisIndex: baseAxis.index
                    });
                }
                seriesGroupByCategoryAxis[key].series.push(seriesModel);
            } else otherSeries.push(seriesModel);
        } else otherSeries.push(seriesModel);
    });
    return {
        seriesGroupByCategoryAxis: seriesGroupByCategoryAxis,
        other: otherSeries,
        meta: meta
    };
}
/**
 * Assemble content of series on cateogory axis
 * @inner
 */ function $c28a86c6c47fb2f6$var$assembleSeriesWithCategoryAxis(groups) {
    var tables = [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(groups, function(group, key) {
        var categoryAxis = group.categoryAxis;
        var valueAxis = group.valueAxis;
        var valueAxisDim = valueAxis.dim;
        var headers = [
            " "
        ].concat($7a1bd9c2710fea0d$export$871de8747c9eaa88(group.series, function(series) {
            return series.name;
        }));
        // @ts-ignore TODO Polar
        var columns = [
            categoryAxis.model.getCategories()
        ];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(group.series, function(series) {
            var rawData = series.getRawData();
            columns.push(series.getRawData().mapArray(rawData.mapDimension(valueAxisDim), function(val) {
                return val;
            }));
        });
        // Assemble table content
        var lines = [
            headers.join($c28a86c6c47fb2f6$var$ITEM_SPLITER)
        ];
        for(var i = 0; i < columns[0].length; i++){
            var items = [];
            for(var j = 0; j < columns.length; j++)items.push(columns[j][i]);
            lines.push(items.join($c28a86c6c47fb2f6$var$ITEM_SPLITER));
        }
        tables.push(lines.join("\n"));
    });
    return tables.join("\n\n" + $c28a86c6c47fb2f6$var$BLOCK_SPLITER + "\n\n");
}
/**
 * Assemble content of other series
 */ function $c28a86c6c47fb2f6$var$assembleOtherSeries(series) {
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88(series, function(series) {
        var data = series.getRawData();
        var lines = [
            series.name
        ];
        var vals = [];
        data.each(data.dimensions, function() {
            var argLen = arguments.length;
            var dataIndex = arguments[argLen - 1];
            var name = data.getName(dataIndex);
            for(var i = 0; i < argLen - 1; i++)vals[i] = arguments[i];
            lines.push((name ? name + $c28a86c6c47fb2f6$var$ITEM_SPLITER : "") + vals.join($c28a86c6c47fb2f6$var$ITEM_SPLITER));
        });
        return lines.join("\n");
    }).join("\n\n" + $c28a86c6c47fb2f6$var$BLOCK_SPLITER + "\n\n");
}
function $c28a86c6c47fb2f6$var$getContentFromModel(ecModel) {
    var result = $c28a86c6c47fb2f6$var$groupSeries(ecModel);
    return {
        value: $7a1bd9c2710fea0d$export$3dea766d36a8935f([
            $c28a86c6c47fb2f6$var$assembleSeriesWithCategoryAxis(result.seriesGroupByCategoryAxis),
            $c28a86c6c47fb2f6$var$assembleOtherSeries(result.other)
        ], function(str) {
            return !!str.replace(/[\n\t\s]/g, "");
        }).join("\n\n" + $c28a86c6c47fb2f6$var$BLOCK_SPLITER + "\n\n"),
        meta: result.meta
    };
}
function $c28a86c6c47fb2f6$var$trim(str) {
    return str.replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
/**
 * If a block is tsv format
 */ function $c28a86c6c47fb2f6$var$isTSVFormat(block) {
    // Simple method to find out if a block is tsv format
    var firstLine = block.slice(0, block.indexOf("\n"));
    if (firstLine.indexOf($c28a86c6c47fb2f6$var$ITEM_SPLITER) >= 0) return true;
}
var $c28a86c6c47fb2f6$var$itemSplitRegex = new RegExp("[" + $c28a86c6c47fb2f6$var$ITEM_SPLITER + "]+", "g");
/**
 * @param {string} tsv
 * @return {Object}
 */ function $c28a86c6c47fb2f6$var$parseTSVContents(tsv) {
    var tsvLines = tsv.split(/\n+/g);
    var headers = $c28a86c6c47fb2f6$var$trim(tsvLines.shift()).split($c28a86c6c47fb2f6$var$itemSplitRegex);
    var categories = [];
    var series = $7a1bd9c2710fea0d$export$871de8747c9eaa88(headers, function(header) {
        return {
            name: header,
            data: []
        };
    });
    for(var i = 0; i < tsvLines.length; i++){
        var items = $c28a86c6c47fb2f6$var$trim(tsvLines[i]).split($c28a86c6c47fb2f6$var$itemSplitRegex);
        categories.push(items.shift());
        for(var j = 0; j < items.length; j++)series[j] && (series[j].data[i] = items[j]);
    }
    return {
        series: series,
        categories: categories
    };
}
function $c28a86c6c47fb2f6$var$parseListContents(str) {
    var lines = str.split(/\n+/g);
    var seriesName = $c28a86c6c47fb2f6$var$trim(lines.shift());
    var data = [];
    for(var i = 0; i < lines.length; i++){
        // if line is empty, ignore it.
        // there is a case that a user forgot to delete `\n`.
        var line = $c28a86c6c47fb2f6$var$trim(lines[i]);
        if (!line) continue;
        var items = line.split($c28a86c6c47fb2f6$var$itemSplitRegex);
        var name_1 = "";
        var value = void 0;
        var hasName = false;
        if (isNaN(items[0])) {
            // First item is name
            hasName = true;
            name_1 = items[0];
            items = items.slice(1);
            data[i] = {
                name: name_1,
                value: []
            };
            value = data[i].value;
        } else value = data[i] = [];
        for(var j = 0; j < items.length; j++)value.push(+items[j]);
        if (value.length === 1) hasName ? data[i].value = value[0] : data[i] = value[0];
    }
    return {
        name: seriesName,
        data: data
    };
}
function $c28a86c6c47fb2f6$var$parseContents(str, blockMetaList) {
    var blocks = str.split(new RegExp("\n*" + $c28a86c6c47fb2f6$var$BLOCK_SPLITER + "\n*", "g"));
    var newOption = {
        series: []
    };
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(blocks, function(block, idx) {
        if ($c28a86c6c47fb2f6$var$isTSVFormat(block)) {
            var result = $c28a86c6c47fb2f6$var$parseTSVContents(block);
            var blockMeta = blockMetaList[idx];
            var axisKey = blockMeta.axisDim + "Axis";
            if (blockMeta) {
                newOption[axisKey] = newOption[axisKey] || [];
                newOption[axisKey][blockMeta.axisIndex] = {
                    data: result.categories
                };
                newOption.series = newOption.series.concat(result.series);
            }
        } else {
            var result = $c28a86c6c47fb2f6$var$parseListContents(block);
            newOption.series.push(result);
        }
    });
    return newOption;
}
var $c28a86c6c47fb2f6$var$DataView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(DataView, _super);
    function DataView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataView.prototype.onclick = function(ecModel, api) {
        // FIXME: better way?
        setTimeout(function() {
            api.dispatchAction({
                type: "hideTip"
            });
        });
        var container = api.getDom();
        var model = this.model;
        if (this._dom) container.removeChild(this._dom);
        var root = document.createElement("div");
        // use padding to avoid 5px whitespace
        root.style.cssText = "position:absolute;top:0;bottom:0;left:0;right:0;padding:5px";
        root.style.backgroundColor = model.get("backgroundColor") || (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral00;
        // Create elements
        var header = document.createElement("h4");
        var lang = model.get("lang") || [];
        header.innerHTML = lang[0] || model.get("title");
        header.style.cssText = "margin:10px 20px";
        header.style.color = model.get("textColor");
        var viewMain = document.createElement("div");
        var textarea = document.createElement("textarea");
        viewMain.style.cssText = "overflow:auto";
        var optionToContent = model.get("optionToContent");
        var contentToOption = model.get("contentToOption");
        var result = $c28a86c6c47fb2f6$var$getContentFromModel(ecModel);
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(optionToContent)) {
            var htmlOrDom = optionToContent(api.getOption());
            if ($7a1bd9c2710fea0d$export$844ec244b1367d54(htmlOrDom)) viewMain.innerHTML = htmlOrDom;
            else if ($7a1bd9c2710fea0d$export$9f57505b7bd8dae(htmlOrDom)) viewMain.appendChild(htmlOrDom);
        } else {
            // Use default textarea
            textarea.readOnly = model.get("readOnly");
            var style = textarea.style;
            // eslint-disable-next-line max-len
            style.cssText = "display:block;width:100%;height:100%;font-family:monospace;font-size:14px;line-height:1.6rem;resize:none;box-sizing:border-box;outline:none";
            style.color = model.get("textColor");
            style.borderColor = model.get("textareaBorderColor");
            style.backgroundColor = model.get("textareaColor");
            textarea.value = result.value;
            viewMain.appendChild(textarea);
        }
        var blockMetaList = result.meta;
        var buttonContainer = document.createElement("div");
        buttonContainer.style.cssText = "position:absolute;bottom:5px;left:0;right:0";
        // eslint-disable-next-line max-len
        var buttonStyle = "float:right;margin-right:20px;border:none;cursor:pointer;padding:2px 5px;font-size:12px;border-radius:3px";
        var closeButton = document.createElement("div");
        var refreshButton = document.createElement("div");
        buttonStyle += ";background-color:" + model.get("buttonColor");
        buttonStyle += ";color:" + model.get("buttonTextColor");
        var self = this;
        function close() {
            container.removeChild(root);
            self._dom = null;
        }
        (0, $b3864a78637ff9ed$export$3f65cefe8380dbea)(closeButton, "click", close);
        (0, $b3864a78637ff9ed$export$3f65cefe8380dbea)(refreshButton, "click", function() {
            if (contentToOption == null && optionToContent != null || contentToOption != null && optionToContent == null) {
                close();
                return;
            }
            var newOption;
            try {
                if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(contentToOption)) newOption = contentToOption(viewMain, api.getOption());
                else newOption = $c28a86c6c47fb2f6$var$parseContents(textarea.value, blockMetaList);
            } catch (e) {
                close();
                throw new Error("Data view format error " + e);
            }
            if (newOption) api.dispatchAction({
                type: "changeDataView",
                newOption: newOption
            });
            close();
        });
        closeButton.innerHTML = lang[1];
        refreshButton.innerHTML = lang[2];
        refreshButton.style.cssText = closeButton.style.cssText = buttonStyle;
        !model.get("readOnly") && buttonContainer.appendChild(refreshButton);
        buttonContainer.appendChild(closeButton);
        root.appendChild(header);
        root.appendChild(viewMain);
        root.appendChild(buttonContainer);
        viewMain.style.height = container.clientHeight - 80 + "px";
        container.appendChild(root);
        this._dom = root;
    };
    DataView.prototype.remove = function(ecModel, api) {
        this._dom && api.getDom().removeChild(this._dom);
    };
    DataView.prototype.dispose = function(ecModel, api) {
        this.remove(ecModel, api);
    };
    DataView.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            readOnly: false,
            optionToContent: null,
            contentToOption: null,
            // eslint-disable-next-line
            icon: "M17.5,17.3H33 M17.5,17.3H33 M45.4,29.5h-28 M11.5,2v56H51V14.8L38.4,2H11.5z M38.4,2.2v12.7H51 M45.4,41.7h-28",
            title: ecModel.getLocaleModel().get([
                "toolbox",
                "dataView",
                "title"
            ]),
            lang: ecModel.getLocaleModel().get([
                "toolbox",
                "dataView",
                "lang"
            ]),
            backgroundColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.background,
            textColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.primary,
            textareaColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.background,
            textareaBorderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.border,
            buttonColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.accent50,
            buttonTextColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral00
        };
        return defaultOption;
    };
    return DataView;
}((0, $974ee7656e10f2d0$export$1426bfb1b0bcf539));
/**
 * @inner
 */ function $c28a86c6c47fb2f6$var$tryMergeDataOption(newData, originalData) {
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88(newData, function(newVal, idx) {
        var original = originalData && originalData[idx];
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(original) && !$7a1bd9c2710fea0d$export$43bee75e5e14138e(original)) {
            var newValIsObject = $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(newVal) && !$7a1bd9c2710fea0d$export$43bee75e5e14138e(newVal);
            if (!newValIsObject) newVal = {
                value: newVal
            };
            // original data has name but new data has no name
            var shouldDeleteName = original.name != null && newVal.name == null;
            // Original data has option
            newVal = $7a1bd9c2710fea0d$export$ebe90cb607ad99e(newVal, original);
            shouldDeleteName && delete newVal.name;
            return newVal;
        } else return newVal;
    });
}
// TODO: SELF REGISTERED.
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: "changeDataView",
    event: "dataViewChanged",
    update: "prepareAndUpdate"
}, function(payload, ecModel) {
    var newSeriesOptList = [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(payload.newOption.series, function(seriesOpt) {
        var seriesModel = ecModel.getSeriesByName(seriesOpt.name)[0];
        if (!seriesModel) // New created series
        // Geuss the series type
        newSeriesOptList.push($7a1bd9c2710fea0d$export$8b58be045bf06082({
            // Default is scatter
            type: "scatter"
        }, seriesOpt));
        else {
            var originalData = seriesModel.get("data");
            newSeriesOptList.push({
                name: seriesOpt.name,
                data: $c28a86c6c47fb2f6$var$tryMergeDataOption(seriesOpt.data, originalData)
            });
        }
    });
    ecModel.mergeOption($7a1bd9c2710fea0d$export$ebe90cb607ad99e({
        series: newSeriesOptList
    }, payload.newOption));
});
var $c28a86c6c47fb2f6$export$2e2bcd8739ae039 = $c28a86c6c47fb2f6$var$DataView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $61ea33782638ccd3$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $61ea33782638ccd3$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $61ea33782638ccd3$export$4cbf152802aa238(ecModel, newSnapshot) {
    var storedSnapshots = $61ea33782638ccd3$var$getStoreSnapshots(ecModel);
    // If previous dataZoom can not be found,
    // complete an range with current range.
    $61ea33782638ccd3$var$each(newSnapshot, function(batchItem, dataZoomId) {
        var i = storedSnapshots.length - 1;
        for(; i >= 0; i--){
            var snapshot = storedSnapshots[i];
            if (snapshot[dataZoomId]) break;
        }
        if (i < 0) {
            // No origin range set, create one by current range.
            var dataZoomModel = ecModel.queryComponents({
                mainType: "dataZoom",
                subType: "select",
                id: dataZoomId
            })[0];
            if (dataZoomModel) {
                var percentRange = dataZoomModel.getPercentRange();
                storedSnapshots[0][dataZoomId] = {
                    dataZoomId: dataZoomId,
                    start: percentRange[0],
                    end: percentRange[1]
                };
            }
        }
    });
    storedSnapshots.push(newSnapshot);
}
function $61ea33782638ccd3$export$3e41007ebfff0e64(ecModel) {
    var storedSnapshots = $61ea33782638ccd3$var$getStoreSnapshots(ecModel);
    var head = storedSnapshots[storedSnapshots.length - 1];
    storedSnapshots.length > 1 && storedSnapshots.pop();
    // Find top for all dataZoom.
    var snapshot = {};
    $61ea33782638ccd3$var$each(head, function(batchItem, dataZoomId) {
        for(var i = storedSnapshots.length - 1; i >= 0; i--){
            batchItem = storedSnapshots[i][dataZoomId];
            if (batchItem) {
                snapshot[dataZoomId] = batchItem;
                break;
            }
        }
    });
    return snapshot;
}
function $61ea33782638ccd3$export$42ffd38884aecdac(ecModel) {
    $61ea33782638ccd3$var$inner(ecModel).snapshots = null;
}
function $61ea33782638ccd3$export$85b9a36db797e02b(ecModel) {
    return $61ea33782638ccd3$var$getStoreSnapshots(ecModel).length;
}
/**
 * History length of each dataZoom may be different.
 * this._history[0] is used to store origin range.
 */ function $61ea33782638ccd3$var$getStoreSnapshots(ecModel) {
    var store = $61ea33782638ccd3$var$inner(ecModel);
    if (!store.snapshots) store.snapshots = [
        {}
    ];
    return store.snapshots;
}



var $5719d35bf0243166$var$RestoreOption = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RestoreOption, _super);
    function RestoreOption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RestoreOption.prototype.onclick = function(ecModel, api) {
        $61ea33782638ccd3$export$42ffd38884aecdac(ecModel);
        api.dispatchAction({
            type: "restore",
            from: this.uid
        });
    };
    RestoreOption.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            // eslint-disable-next-line
            icon: "M3.8,33.4 M47,18.9h9.8V8.7 M56.3,20.1 C52.1,9,40.5,0.6,26.8,2.1C12.6,3.7,1.6,16.2,2.1,30.6 M13,41.1H3.1v10.2 M3.7,39.9c4.2,11.1,15.8,19.5,29.5,18 c14.2-1.6,25.2-14.1,24.7-28.5",
            title: ecModel.getLocaleModel().get([
                "toolbox",
                "restore",
                "title"
            ])
        };
        return defaultOption;
    };
    return RestoreOption;
}((0, $974ee7656e10f2d0$export$1426bfb1b0bcf539));
// TODO: SELF REGISTERED.
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: "restore",
    event: "restore",
    update: "prepareAndUpdate"
}, function(payload, ecModel) {
    ecModel.resetOption("recreate");
});
var $5719d35bf0243166$export$2e2bcd8739ae039 = $5719d35bf0243166$var$RestoreOption;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









var $d48e21e24ee5fc18$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $d48e21e24ee5fc18$var$DATA_ZOOM_ID_BASE = (0, $76d619f648247e6d$export$1753133c42e665e8)("toolbox-dataZoom_");
var $d48e21e24ee5fc18$var$ICON_TYPES = [
    "zoom",
    "back"
];
var $d48e21e24ee5fc18$var$DataZoomFeature = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(DataZoomFeature, _super);
    function DataZoomFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataZoomFeature.prototype.render = function(featureModel, ecModel, api, payload) {
        if (!this._brushController) {
            this._brushController = new (0, $91342d1cfa622c5a$export$2e2bcd8739ae039)(api.getZr());
            this._brushController.on("brush", $7a1bd9c2710fea0d$export$2385a24977818dd0(this._onBrush, this)).mount();
        }
        $d48e21e24ee5fc18$var$updateZoomBtnStatus(featureModel, ecModel, this, payload, api);
        $d48e21e24ee5fc18$var$updateBackBtnStatus(featureModel, ecModel);
    };
    DataZoomFeature.prototype.onclick = function(ecModel, api, type) {
        $d48e21e24ee5fc18$var$handlers[type].call(this);
    };
    DataZoomFeature.prototype.remove = function(ecModel, api) {
        this._brushController && this._brushController.unmount();
    };
    DataZoomFeature.prototype.dispose = function(ecModel, api) {
        this._brushController && this._brushController.dispose();
    };
    DataZoomFeature.prototype._onBrush = function(eventParam) {
        var areas = eventParam.areas;
        if (!eventParam.isEnd || !areas.length) return;
        var snapshot = {};
        var ecModel = this.ecModel;
        this._brushController.updateCovers([]); // remove cover
        var brushTargetManager = new (0, $6213fed8aa63fab1$export$2e2bcd8739ae039)($d48e21e24ee5fc18$var$makeAxisFinder(this.model), ecModel, {
            include: [
                "grid"
            ]
        });
        brushTargetManager.matchOutputRanges(areas, ecModel, function(area, coordRange, coordSys) {
            if (coordSys.type !== "cartesian2d") return;
            var brushType = area.brushType;
            if (brushType === "rect") {
                setBatch("x", coordSys, coordRange[0]);
                setBatch("y", coordSys, coordRange[1]);
            } else setBatch({
                lineX: "x",
                lineY: "y"
            }[brushType], coordSys, coordRange);
        });
        $61ea33782638ccd3$export$4cbf152802aa238(ecModel, snapshot);
        this._dispatchZoomAction(snapshot);
        function setBatch(dimName, coordSys, minMax) {
            var axis = coordSys.getAxis(dimName);
            var axisModel = axis.model;
            var dataZoomModel = findDataZoom(dimName, axisModel, ecModel);
            // Restrict range.
            var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy(axisModel).getMinMaxSpan();
            if (minMaxSpan.minValueSpan != null || minMaxSpan.maxValueSpan != null) minMax = (0, $00a8003b34293330$export$2e2bcd8739ae039)(0, minMax.slice(), axis.scale.getExtent(), 0, minMaxSpan.minValueSpan, minMaxSpan.maxValueSpan);
            dataZoomModel && (snapshot[dataZoomModel.id] = {
                dataZoomId: dataZoomModel.id,
                startValue: minMax[0],
                endValue: minMax[1]
            });
        }
        function findDataZoom(dimName, axisModel, ecModel) {
            var found;
            ecModel.eachComponent({
                mainType: "dataZoom",
                subType: "select"
            }, function(dzModel) {
                var has = dzModel.getAxisModel(dimName, axisModel.componentIndex);
                has && (found = dzModel);
            });
            return found;
        }
    };
    DataZoomFeature.prototype._dispatchZoomAction = function(snapshot) {
        var batch = [];
        // Convert from hash map to array.
        $d48e21e24ee5fc18$var$each(snapshot, function(batchItem, dataZoomId) {
            batch.push($7a1bd9c2710fea0d$export$9cd59f9826255e47(batchItem));
        });
        batch.length && this.api.dispatchAction({
            type: "dataZoom",
            from: this.uid,
            batch: batch
        });
    };
    DataZoomFeature.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            filterMode: "filter",
            // Icon group
            icon: {
                zoom: "M0,13.5h26.9 M13.5,26.9V0 M32.1,13.5H58V58H13.5 V32.1",
                back: "M22,1.4L9.9,13.5l12.3,12.3 M10.3,13.5H54.9v44.6 H10.3v-26"
            },
            // `zoom`, `back`
            title: ecModel.getLocaleModel().get([
                "toolbox",
                "dataZoom",
                "title"
            ]),
            brushStyle: {
                borderWidth: 0,
                color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.backgroundTint
            }
        };
        return defaultOption;
    };
    return DataZoomFeature;
}((0, $974ee7656e10f2d0$export$1426bfb1b0bcf539));
var $d48e21e24ee5fc18$var$handlers = {
    zoom: function() {
        var nextActive = !this._isZoomActive;
        this.api.dispatchAction({
            type: "takeGlobalCursor",
            key: "dataZoomSelect",
            dataZoomSelectActive: nextActive
        });
    },
    back: function() {
        this._dispatchZoomAction($61ea33782638ccd3$export$3e41007ebfff0e64(this.ecModel));
    }
};
function $d48e21e24ee5fc18$var$makeAxisFinder(dzFeatureModel) {
    var setting = {
        xAxisIndex: dzFeatureModel.get("xAxisIndex", true),
        yAxisIndex: dzFeatureModel.get("yAxisIndex", true),
        xAxisId: dzFeatureModel.get("xAxisId", true),
        yAxisId: dzFeatureModel.get("yAxisId", true)
    };
    // If both `xAxisIndex` `xAxisId` not set, it means 'all'.
    // If both `yAxisIndex` `yAxisId` not set, it means 'all'.
    // Some old cases set like this below to close yAxis control but leave xAxis control:
    // `{ feature: { dataZoom: { yAxisIndex: false } }`.
    if (setting.xAxisIndex == null && setting.xAxisId == null) setting.xAxisIndex = "all";
    if (setting.yAxisIndex == null && setting.yAxisId == null) setting.yAxisIndex = "all";
    return setting;
}
function $d48e21e24ee5fc18$var$updateBackBtnStatus(featureModel, ecModel) {
    featureModel.setIconStatus("back", $61ea33782638ccd3$export$85b9a36db797e02b(ecModel) > 1 ? "emphasis" : "normal");
}
function $d48e21e24ee5fc18$var$updateZoomBtnStatus(featureModel, ecModel, view, payload, api) {
    var zoomActive = view._isZoomActive;
    if (payload && payload.type === "takeGlobalCursor") zoomActive = payload.key === "dataZoomSelect" ? payload.dataZoomSelectActive : false;
    view._isZoomActive = zoomActive;
    featureModel.setIconStatus("zoom", zoomActive ? "emphasis" : "normal");
    var brushTargetManager = new (0, $6213fed8aa63fab1$export$2e2bcd8739ae039)($d48e21e24ee5fc18$var$makeAxisFinder(featureModel), ecModel, {
        include: [
            "grid"
        ]
    });
    var panels = brushTargetManager.makePanelOpts(api, function(targetInfo) {
        return targetInfo.xAxisDeclared && !targetInfo.yAxisDeclared ? "lineX" : !targetInfo.xAxisDeclared && targetInfo.yAxisDeclared ? "lineY" : "rect";
    });
    view._brushController.setPanels(panels).enableBrush(zoomActive && panels.length ? {
        brushType: "auto",
        brushStyle: featureModel.getModel("brushStyle").getItemStyle()
    } : false);
}
(0, $a625fe571efb4064$export$5a90be4668898d38)("dataZoom", function(ecModel) {
    var toolboxModel = ecModel.getComponent("toolbox", 0);
    var featureDataZoomPath = [
        "feature",
        "dataZoom"
    ];
    if (!toolboxModel || toolboxModel.get(featureDataZoomPath) == null) return;
    var dzFeatureModel = toolboxModel.getModel(featureDataZoomPath);
    var dzOptions = [];
    var finder = $d48e21e24ee5fc18$var$makeAxisFinder(dzFeatureModel);
    var finderResult = (0, $76d619f648247e6d$export$95de80076abac814)(ecModel, finder);
    $d48e21e24ee5fc18$var$each(finderResult.xAxisModels, function(axisModel) {
        return buildInternalOptions(axisModel, "xAxis", "xAxisIndex");
    });
    $d48e21e24ee5fc18$var$each(finderResult.yAxisModels, function(axisModel) {
        return buildInternalOptions(axisModel, "yAxis", "yAxisIndex");
    });
    function buildInternalOptions(axisModel, axisMainType, axisIndexPropName) {
        var axisIndex = axisModel.componentIndex;
        var newOpt = {
            type: "select",
            $fromToolbox: true,
            // Default to be filter
            filterMode: dzFeatureModel.get("filterMode", true) || "filter",
            // Id for merge mapping.
            id: $d48e21e24ee5fc18$var$DATA_ZOOM_ID_BASE + axisMainType + axisIndex
        };
        newOpt[axisIndexPropName] = axisIndex;
        dzOptions.push(newOpt);
    }
    return dzOptions;
});
var $d48e21e24ee5fc18$export$2e2bcd8739ae039 = $d48e21e24ee5fc18$var$DataZoomFeature;


function $db487da8ce0e4ca6$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $f3a05ea4ae929f91$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $e0876f124cc8d5c9$export$2e2bcd8739ae039));
    (0, $974ee7656e10f2d0$export$c6213a6f247cf906)("saveAsImage", (0, $1abd70fc7852729e$export$2e2bcd8739ae039));
    (0, $974ee7656e10f2d0$export$c6213a6f247cf906)("magicType", (0, $1a3c941566c70505$export$2e2bcd8739ae039));
    (0, $974ee7656e10f2d0$export$c6213a6f247cf906)("dataView", (0, $c28a86c6c47fb2f6$export$2e2bcd8739ae039));
    (0, $974ee7656e10f2d0$export$c6213a6f247cf906)("dataZoom", (0, $d48e21e24ee5fc18$export$2e2bcd8739ae039));
    (0, $974ee7656e10f2d0$export$c6213a6f247cf906)("restore", (0, $5719d35bf0243166$export$2e2bcd8739ae039));
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $738a563bbc36032b$export$4b3e715f166fdd78));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $310c8e7a9655a722$var$TooltipModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TooltipModel, _super);
    function TooltipModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TooltipModel.type;
        return _this;
    }
    TooltipModel.type = "tooltip";
    TooltipModel.dependencies = [
        "axisPointer"
    ];
    TooltipModel.defaultOption = {
        // zlevel: 0,
        z: 60,
        show: true,
        // tooltip main content
        showContent: true,
        // 'trigger' only works on coordinate system.
        // 'item' | 'axis' | 'none'
        trigger: "item",
        // 'click' | 'mousemove' | 'none'
        triggerOn: "mousemove|click",
        alwaysShowContent: false,
        renderMode: "auto",
        // whether restraint content inside viewRect.
        // If renderMode: 'richText', default true.
        // If renderMode: 'html', defaults to `false` (for backward compat).
        confine: null,
        showDelay: 0,
        hideDelay: 100,
        // Animation transition time, unit is second
        transitionDuration: 0.4,
        displayTransition: true,
        enterable: false,
        backgroundColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral00,
        // box shadow
        shadowBlur: 10,
        shadowColor: "rgba(0, 0, 0, .2)",
        shadowOffsetX: 1,
        shadowOffsetY: 2,
        // tooltip border radius, unit is px, default is 4
        borderRadius: 4,
        // tooltip border width, unit is px, default is 0 (no border)
        borderWidth: 1,
        defaultBorderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.border,
        // Tooltip inside padding, default is 5 for all direction
        // Array is allowed to set up, right, bottom, left, same with css
        // The default value: See `tooltip/tooltipMarkup.ts#getPaddingFromTooltipModel`.
        padding: null,
        // Extra css text
        extraCssText: "",
        // axis indicator, trigger by axis
        axisPointer: {
            // default is line
            // legal values: 'line' | 'shadow' | 'cross'
            type: "line",
            // Valid when type is line, appoint tooltip line locate on which line. Optional
            // legal values: 'x' | 'y' | 'angle' | 'radius' | 'auto'
            // default is 'auto', chose the axis which type is category.
            // for multiply y axis, cartesian coord chose x axis, polar chose angle axis
            axis: "auto",
            animation: "auto",
            animationDurationUpdate: 200,
            animationEasingUpdate: "exponentialOut",
            crossStyle: {
                color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.borderShade,
                width: 1,
                type: "dashed",
                // TODO formatter
                textStyle: {}
            }
        },
        textStyle: {
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.tertiary,
            fontSize: 14
        }
    };
    return TooltipModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $310c8e7a9655a722$export$2e2bcd8739ae039 = $310c8e7a9655a722$var$TooltipModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $c6d80cf697426e46$export$a309528050824ba4(tooltipModel) {
    var confineOption = tooltipModel.get("confine");
    return confineOption != null ? !!confineOption : tooltipModel.get("renderMode") === "richText";
}
function $c6d80cf697426e46$var$testStyle(styleProps) {
    if (!(0, $ce6dd58693a21851$export$2e2bcd8739ae039).domSupported) return;
    var style = document.documentElement.style;
    for(var i = 0, len = styleProps.length; i < len; i++){
        if (styleProps[i] in style) return styleProps[i];
    }
}
var $c6d80cf697426e46$export$7b4286b1e4a23439 = $c6d80cf697426e46$var$testStyle([
    "transform",
    "webkitTransform",
    "OTransform",
    "MozTransform",
    "msTransform"
]);
var $c6d80cf697426e46$export$70a631ae991b5e76 = $c6d80cf697426e46$var$testStyle([
    "webkitTransition",
    "transition",
    "OTransition",
    "MozTransition",
    "msTransition"
]);
function $c6d80cf697426e46$export$5886acafe29a08d1(styleVendor, styleProp) {
    if (!styleVendor) return styleProp;
    styleProp = (0, $c84c9521536c601a$export$86f54f62aa7a7514)(styleProp, true);
    var idx = styleVendor.indexOf(styleProp);
    styleVendor = idx === -1 ? styleProp : "-" + styleVendor.slice(0, idx) + "-" + styleProp;
    return styleVendor.toLowerCase();
}
function $c6d80cf697426e46$export$3735103072e4a80(el, style) {
    var stl = el.currentStyle || document.defaultView && document.defaultView.getComputedStyle(el);
    return stl ? style ? stl[style] : stl : null;
}



/* global document, window */ var $501187a7e974c4e1$var$CSS_TRANSITION_VENDOR = (0, $c6d80cf697426e46$export$5886acafe29a08d1)((0, $c6d80cf697426e46$export$70a631ae991b5e76), "transition");
var $501187a7e974c4e1$var$CSS_TRANSFORM_VENDOR = (0, $c6d80cf697426e46$export$5886acafe29a08d1)((0, $c6d80cf697426e46$export$7b4286b1e4a23439), "transform");
// eslint-disable-next-line
var $501187a7e974c4e1$var$gCssText = "position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;" + ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).transform3dSupported ? "will-change:transform;" : "");
function $501187a7e974c4e1$var$mirrorPos(pos) {
    pos = pos === "left" ? "right" : pos === "right" ? "left" : pos === "top" ? "bottom" : "top";
    return pos;
}
function $501187a7e974c4e1$var$assembleArrow(tooltipModel, borderColor, arrowPosition) {
    if (!(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(arrowPosition) || arrowPosition === "inside") return "";
    var backgroundColor = tooltipModel.get("backgroundColor");
    var borderWidth = tooltipModel.get("borderWidth");
    borderColor = (0, $c84c9521536c601a$export$cda04d03233e5555)(borderColor);
    var arrowPos = $501187a7e974c4e1$var$mirrorPos(arrowPosition);
    var arrowSize = Math.max(Math.round(borderWidth) * 1.5, 6);
    var positionStyle = "";
    var transformStyle = $501187a7e974c4e1$var$CSS_TRANSFORM_VENDOR + ":";
    var rotateDeg;
    if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)([
        "left",
        "right"
    ], arrowPos) > -1) {
        positionStyle += "top:50%";
        transformStyle += "translateY(-50%) rotate(" + (rotateDeg = arrowPos === "left" ? -225 : -45) + "deg)";
    } else {
        positionStyle += "left:50%";
        transformStyle += "translateX(-50%) rotate(" + (rotateDeg = arrowPos === "top" ? 225 : 45) + "deg)";
    }
    var rotateRadian = rotateDeg * Math.PI / 180;
    var arrowWH = arrowSize + borderWidth;
    var rotatedWH = arrowWH * Math.abs(Math.cos(rotateRadian)) + arrowWH * Math.abs(Math.sin(rotateRadian));
    var arrowOffset = Math.round(((rotatedWH - Math.SQRT2 * borderWidth) / 2 + Math.SQRT2 * borderWidth - (rotatedWH - arrowWH) / 2) * 100) / 100;
    positionStyle += ";" + arrowPos + ":-" + arrowOffset + "px";
    var borderStyle = borderColor + " solid " + borderWidth + "px;";
    var styleCss = [
        "position:absolute;width:" + arrowSize + "px;height:" + arrowSize + "px;z-index:-1;",
        positionStyle + ";" + transformStyle + ";",
        "border-bottom:" + borderStyle,
        "border-right:" + borderStyle,
        "background-color:" + backgroundColor + ";"
    ];
    return '<div style="' + styleCss.join("") + '"></div>';
}
function $501187a7e974c4e1$var$assembleTransition(duration, onlyFadeTransition, enableDisplayTransition) {
    var transitionCurve = "cubic-bezier(0.23,1,0.32,1)";
    var transitionOption = "";
    var transitionText = "";
    if (enableDisplayTransition) {
        transitionOption = " " + duration / 2 + "s " + transitionCurve;
        transitionText = "opacity" + transitionOption + ",visibility" + transitionOption;
    }
    if (!onlyFadeTransition) {
        transitionOption = " " + duration + "s " + transitionCurve;
        transitionText += (transitionText.length ? "," : "") + ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).transformSupported ? "" + $501187a7e974c4e1$var$CSS_TRANSFORM_VENDOR + transitionOption : ",left" + transitionOption + ",top" + transitionOption);
    }
    return $501187a7e974c4e1$var$CSS_TRANSITION_VENDOR + ":" + transitionText;
}
function $501187a7e974c4e1$var$assembleTransform(x, y, toString) {
    // If using float on style, the final width of the dom might
    // keep changing slightly while mouse move. So `toFixed(0)` them.
    var x0 = x.toFixed(0) + "px";
    var y0 = y.toFixed(0) + "px";
    // not support transform, use `left` and `top` instead.
    if (!(0, $ce6dd58693a21851$export$2e2bcd8739ae039).transformSupported) return toString ? "top:" + y0 + ";left:" + x0 + ";" : [
        [
            "top",
            y0
        ],
        [
            "left",
            x0
        ]
    ];
    // support transform
    var is3d = (0, $ce6dd58693a21851$export$2e2bcd8739ae039).transform3dSupported;
    var translate = "translate" + (is3d ? "3d" : "") + "(" + x0 + "," + y0 + (is3d ? ",0" : "") + ")";
    return toString ? "top:0;left:0;" + $501187a7e974c4e1$var$CSS_TRANSFORM_VENDOR + ":" + translate + ";" : [
        [
            "top",
            0
        ],
        [
            "left",
            0
        ],
        [
            (0, $c6d80cf697426e46$export$7b4286b1e4a23439),
            translate
        ]
    ];
}
/**
 * @param {Object} textStyle
 * @return {string}
 * @inner
 */ function $501187a7e974c4e1$var$assembleFont(textStyleModel) {
    var cssText = [];
    var fontSize = textStyleModel.get("fontSize");
    var color = textStyleModel.getTextColor();
    color && cssText.push("color:" + color);
    cssText.push("font:" + textStyleModel.getFont());
    // @ts-ignore, leave it to the tooltip refactor.
    var lineHeight = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.get("lineHeight"), Math.round(fontSize * 3 / 2));
    fontSize && cssText.push("line-height:" + lineHeight + "px");
    var shadowColor = textStyleModel.get("textShadowColor");
    var shadowBlur = textStyleModel.get("textShadowBlur") || 0;
    var shadowOffsetX = textStyleModel.get("textShadowOffsetX") || 0;
    var shadowOffsetY = textStyleModel.get("textShadowOffsetY") || 0;
    shadowColor && shadowBlur && cssText.push("text-shadow:" + shadowOffsetX + "px " + shadowOffsetY + "px " + shadowBlur + "px " + shadowColor);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        "decoration",
        "align"
    ], function(name) {
        var val = textStyleModel.get(name);
        val && cssText.push("text-" + name + ":" + val);
    });
    return cssText.join(";");
}
function $501187a7e974c4e1$var$assembleCssText(tooltipModel, enableTransition, onlyFadeTransition, enableDisplayTransition) {
    var cssText = [];
    var transitionDuration = tooltipModel.get("transitionDuration");
    var backgroundColor = tooltipModel.get("backgroundColor");
    var shadowBlur = tooltipModel.get("shadowBlur");
    var shadowColor = tooltipModel.get("shadowColor");
    var shadowOffsetX = tooltipModel.get("shadowOffsetX");
    var shadowOffsetY = tooltipModel.get("shadowOffsetY");
    var textStyleModel = tooltipModel.getModel("textStyle");
    var padding = (0, $d5ab84c08d6657ec$export$3048212c802df496)(tooltipModel, "html");
    var boxShadow = shadowOffsetX + "px " + shadowOffsetY + "px " + shadowBlur + "px " + shadowColor;
    cssText.push("box-shadow:" + boxShadow);
    // Animation transition. Do not animate when transitionDuration <= 0.
    enableTransition && transitionDuration > 0 && cssText.push($501187a7e974c4e1$var$assembleTransition(transitionDuration, onlyFadeTransition, enableDisplayTransition));
    if (backgroundColor) cssText.push("background-color:" + backgroundColor);
    // Border style
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        "width",
        "color",
        "radius"
    ], function(name) {
        var borderName = "border-" + name;
        var camelCase = (0, $c84c9521536c601a$export$86f54f62aa7a7514)(borderName);
        var val = tooltipModel.get(camelCase);
        val != null && cssText.push(borderName + ":" + val + (name === "color" ? "" : "px"));
    });
    // Text style
    cssText.push($501187a7e974c4e1$var$assembleFont(textStyleModel));
    // Padding
    if (padding != null) cssText.push("padding:" + (0, $c84c9521536c601a$export$f3a38102c49f4268)(padding).join("px ") + "px");
    return cssText.join(";") + ";";
}
// If not able to make, do not modify the input `out`.
function $501187a7e974c4e1$var$makeStyleCoord(out, zr, container, zrX, zrY) {
    var zrPainter = zr && zr.painter;
    if (container) {
        var zrViewportRoot = zrPainter && zrPainter.getViewportRoot();
        if (zrViewportRoot) // Some APPs might use scale on body, so we support CSS transform here.
        (0, $664e052f390bd76e$export$8c5c02e118307e20)(out, zrViewportRoot, container, zrX, zrY);
    } else {
        out[0] = zrX;
        out[1] = zrY;
        // xy should be based on canvas root. But tooltipContent is
        // the sibling of canvas root. So padding of ec container
        // should be considered here.
        var viewportRootOffset = zrPainter && zrPainter.getViewportRootOffset();
        if (viewportRootOffset) {
            out[0] += viewportRootOffset.offsetLeft;
            out[1] += viewportRootOffset.offsetTop;
        }
    }
    out[2] = out[0] / zr.getWidth();
    out[3] = out[1] / zr.getHeight();
}
var $501187a7e974c4e1$var$TooltipHTMLContent = /** @class */ function() {
    function TooltipHTMLContent(api, opt) {
        this._show = false;
        this._styleCoord = [
            0,
            0,
            0,
            0
        ];
        this._enterable = true;
        this._alwaysShowContent = false;
        this._firstShow = true;
        this._longHide = true;
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).wxa) return null;
        var el = document.createElement("div");
        // TODO: TYPE
        el.domBelongToZr = true;
        this.el = el;
        var zr = this._zr = api.getZr();
        var appendTo = opt.appendTo;
        var container = appendTo && ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(appendTo) ? document.querySelector(appendTo) : (0, $7a1bd9c2710fea0d$export$9f57505b7bd8dae)(appendTo) ? appendTo : (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(appendTo) && appendTo(api.getDom()));
        $501187a7e974c4e1$var$makeStyleCoord(this._styleCoord, zr, container, api.getWidth() / 2, api.getHeight() / 2);
        (container || api.getDom()).appendChild(el);
        this._api = api;
        this._container = container;
        // FIXME
        // Is it needed to trigger zr event manually if
        // the browser do not support `pointer-events: none`.
        var self = this;
        el.onmouseenter = function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        };
        el.onmousemove = function(e) {
            e = e || window.event;
            if (!self._enterable) {
                // `pointer-events: none` is set to tooltip content div
                // if `enterable` is set as `false`, and `el.onmousemove`
                // can not be triggered. But in browser that do not
                // support `pointer-events`, we need to do this:
                // Try trigger zrender event to avoid mouse
                // in and out shape too frequently
                var handler = zr.handler;
                var zrViewportRoot = zr.painter.getViewportRoot();
                (0, $b3864a78637ff9ed$export$40fadb093aebad71)(zrViewportRoot, e, true);
                handler.dispatch("mousemove", e);
            }
        };
        el.onmouseleave = function() {
            // set `_inContent` to `false` before `hideLater`
            self._inContent = false;
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
        };
    }
    /**
   * Update when tooltip is rendered
   */ TooltipHTMLContent.prototype.update = function(tooltipModel) {
        // FIXME
        // Move this logic to ec main?
        if (!this._container) {
            var container = this._api.getDom();
            var position = (0, $c6d80cf697426e46$export$3735103072e4a80)(container, "position");
            var domStyle = container.style;
            if (domStyle.position !== "absolute" && position !== "absolute") domStyle.position = "relative";
        }
        // move tooltip if chart resized
        var alwaysShowContent = tooltipModel.get("alwaysShowContent");
        alwaysShowContent && this._moveIfResized();
        // update alwaysShowContent
        this._alwaysShowContent = alwaysShowContent;
        this._enableDisplayTransition = tooltipModel.get("displayTransition") && tooltipModel.get("transitionDuration") > 0;
        // update className
        this.el.className = tooltipModel.get("className") || "";
    // Hide the tooltip
    // PENDING
    // this.hide();
    };
    TooltipHTMLContent.prototype.show = function(tooltipModel, nearPointColor) {
        clearTimeout(this._hideTimeout);
        clearTimeout(this._longHideTimeout);
        var el = this.el;
        var style = el.style;
        var styleCoord = this._styleCoord;
        if (!el.innerHTML) style.display = "none";
        else style.cssText = $501187a7e974c4e1$var$gCssText + $501187a7e974c4e1$var$assembleCssText(tooltipModel, !this._firstShow, this._longHide, this._enableDisplayTransition) + $501187a7e974c4e1$var$assembleTransform(styleCoord[0], styleCoord[1], true) + ("border-color:" + (0, $c84c9521536c601a$export$cda04d03233e5555)(nearPointColor) + ";") + (tooltipModel.get("extraCssText") || "") + (";pointer-events:" + (this._enterable ? "auto" : "none"));
        this._show = true;
        this._firstShow = false;
        this._longHide = false;
    };
    TooltipHTMLContent.prototype.setContent = function(content, markers, tooltipModel, borderColor, arrowPosition) {
        var el = this.el;
        if (content == null) {
            el.innerHTML = "";
            return;
        }
        var arrow = "";
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(arrowPosition) && tooltipModel.get("trigger") === "item" && !(0, $c6d80cf697426e46$export$a309528050824ba4)(tooltipModel)) arrow = $501187a7e974c4e1$var$assembleArrow(tooltipModel, borderColor, arrowPosition);
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(content)) el.innerHTML = content + arrow;
        else if (content) {
            // Clear previous
            el.innerHTML = "";
            if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(content)) content = [
                content
            ];
            for(var i = 0; i < content.length; i++)if ((0, $7a1bd9c2710fea0d$export$9f57505b7bd8dae)(content[i]) && content[i].parentNode !== el) el.appendChild(content[i]);
            // no arrow if empty
            if (arrow && el.childNodes.length) {
                // no need to create a new parent element, but it's not supported by IE 10 and older.
                // const arrowEl = document.createRange().createContextualFragment(arrow);
                var arrowEl = document.createElement("div");
                arrowEl.innerHTML = arrow;
                el.appendChild(arrowEl);
            }
        }
    };
    TooltipHTMLContent.prototype.setEnterable = function(enterable) {
        this._enterable = enterable;
    };
    TooltipHTMLContent.prototype.getSize = function() {
        var el = this.el;
        return el ? [
            el.offsetWidth,
            el.offsetHeight
        ] : [
            0,
            0
        ];
    };
    TooltipHTMLContent.prototype.moveTo = function(zrX, zrY) {
        if (!this.el) return;
        var styleCoord = this._styleCoord;
        $501187a7e974c4e1$var$makeStyleCoord(styleCoord, this._zr, this._container, zrX, zrY);
        if (styleCoord[0] != null && styleCoord[1] != null) {
            var style_1 = this.el.style;
            var transforms = $501187a7e974c4e1$var$assembleTransform(styleCoord[0], styleCoord[1]);
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(transforms, function(transform) {
                style_1[transform[0]] = transform[1];
            });
        }
    };
    /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */ TooltipHTMLContent.prototype._moveIfResized = function() {
        // The ratio of left to width
        var ratioX = this._styleCoord[2];
        // The ratio of top to height
        var ratioY = this._styleCoord[3];
        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
    };
    TooltipHTMLContent.prototype.hide = function() {
        var _this = this;
        var style = this.el.style;
        if (this._enableDisplayTransition) {
            style.visibility = "hidden";
            style.opacity = "0";
        } else style.display = "none";
        (0, $ce6dd58693a21851$export$2e2bcd8739ae039).transform3dSupported && (style.willChange = "");
        this._show = false;
        this._longHideTimeout = setTimeout(function() {
            return _this._longHide = true;
        }, 500);
    };
    TooltipHTMLContent.prototype.hideLater = function(time) {
        if (this._show && !(this._inContent && this._enterable) && !this._alwaysShowContent) {
            if (time) {
                this._hideDelay = time;
                // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout((0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this.hide, this), time);
            } else this.hide();
        }
    };
    TooltipHTMLContent.prototype.isShow = function() {
        return this._show;
    };
    TooltipHTMLContent.prototype.dispose = function() {
        clearTimeout(this._hideTimeout);
        clearTimeout(this._longHideTimeout);
        var zr = this._zr;
        (0, $664e052f390bd76e$export$a29dbe4b7d3cd586)(zr && zr.painter && zr.painter.getViewportRoot(), this._container);
        var el = this.el;
        if (el) {
            el.onmouseenter = el.onmousemove = el.onmouseleave = null;
            var parentNode = el.parentNode;
            parentNode && parentNode.removeChild(el);
        }
        this.el = this._container = null;
    };
    return TooltipHTMLContent;
}();
var $501187a7e974c4e1$export$2e2bcd8739ae039 = $501187a7e974c4e1$var$TooltipHTMLContent;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $62f65ba5b769b0ae$var$TooltipRichContent = /** @class */ function() {
    function TooltipRichContent(api) {
        this._show = false;
        this._styleCoord = [
            0,
            0,
            0,
            0
        ];
        this._alwaysShowContent = false;
        this._enterable = true;
        this._zr = api.getZr();
        $62f65ba5b769b0ae$var$makeStyleCoord(this._styleCoord, this._zr, api.getWidth() / 2, api.getHeight() / 2);
    }
    /**
   * Update when tooltip is rendered
   */ TooltipRichContent.prototype.update = function(tooltipModel) {
        var alwaysShowContent = tooltipModel.get("alwaysShowContent");
        alwaysShowContent && this._moveIfResized();
        // update alwaysShowContent
        this._alwaysShowContent = alwaysShowContent;
    };
    TooltipRichContent.prototype.show = function() {
        if (this._hideTimeout) clearTimeout(this._hideTimeout);
        this.el.show();
        this._show = true;
    };
    /**
   * Set tooltip content
   */ TooltipRichContent.prototype.setContent = function(content, markupStyleCreator, tooltipModel, borderColor, arrowPosition) {
        var _this = this;
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(content)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)("");
        if (this.el) this._zr.remove(this.el);
        var textStyleModel = tooltipModel.getModel("textStyle");
        this.el = new (0, $fe885cc21795562b$export$2e2bcd8739ae039)({
            style: {
                rich: markupStyleCreator.richTextStyles,
                text: content,
                lineHeight: 22,
                borderWidth: 1,
                borderColor: borderColor,
                textShadowColor: textStyleModel.get("textShadowColor"),
                fill: tooltipModel.get([
                    "textStyle",
                    "color"
                ]),
                padding: (0, $d5ab84c08d6657ec$export$3048212c802df496)(tooltipModel, "richText"),
                verticalAlign: "top",
                align: "left"
            },
            z: tooltipModel.get("z")
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43([
            "backgroundColor",
            "borderRadius",
            "shadowColor",
            "shadowBlur",
            "shadowOffsetX",
            "shadowOffsetY"
        ], function(propName) {
            _this.el.style[propName] = tooltipModel.get(propName);
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43([
            "textShadowBlur",
            "textShadowOffsetX",
            "textShadowOffsetY"
        ], function(propName) {
            _this.el.style[propName] = textStyleModel.get(propName) || 0;
        });
        this._zr.add(this.el);
        var self = this;
        this.el.on("mouseover", function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        });
        this.el.on("mouseout", function() {
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
            self._inContent = false;
        });
    };
    TooltipRichContent.prototype.setEnterable = function(enterable) {
        this._enterable = enterable;
    };
    TooltipRichContent.prototype.getSize = function() {
        var el = this.el;
        var bounding = this.el.getBoundingRect();
        // bounding rect does not include shadow. For renderMode richText,
        // if overflow, it will be cut. So calculate them accurately.
        var shadowOuterSize = $62f65ba5b769b0ae$var$calcShadowOuterSize(el.style);
        return [
            bounding.width + shadowOuterSize.left + shadowOuterSize.right,
            bounding.height + shadowOuterSize.top + shadowOuterSize.bottom
        ];
    };
    TooltipRichContent.prototype.moveTo = function(x, y) {
        var el = this.el;
        if (el) {
            var styleCoord = this._styleCoord;
            $62f65ba5b769b0ae$var$makeStyleCoord(styleCoord, this._zr, x, y);
            x = styleCoord[0];
            y = styleCoord[1];
            var style = el.style;
            var borderWidth = $62f65ba5b769b0ae$var$mathMaxWith0(style.borderWidth || 0);
            var shadowOuterSize = $62f65ba5b769b0ae$var$calcShadowOuterSize(style);
            // rich text x, y do not include border.
            el.x = x + borderWidth + shadowOuterSize.left;
            el.y = y + borderWidth + shadowOuterSize.top;
            el.markRedraw();
        }
    };
    /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */ TooltipRichContent.prototype._moveIfResized = function() {
        // The ratio of left to width
        var ratioX = this._styleCoord[2];
        // The ratio of top to height
        var ratioY = this._styleCoord[3];
        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
    };
    TooltipRichContent.prototype.hide = function() {
        if (this.el) this.el.hide();
        this._show = false;
    };
    TooltipRichContent.prototype.hideLater = function(time) {
        if (this._show && !(this._inContent && this._enterable) && !this._alwaysShowContent) {
            if (time) {
                this._hideDelay = time;
                // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout($7a1bd9c2710fea0d$export$2385a24977818dd0(this.hide, this), time);
            } else this.hide();
        }
    };
    TooltipRichContent.prototype.isShow = function() {
        return this._show;
    };
    TooltipRichContent.prototype.dispose = function() {
        this._zr.remove(this.el);
    };
    return TooltipRichContent;
}();
function $62f65ba5b769b0ae$var$mathMaxWith0(val) {
    return Math.max(0, val);
}
function $62f65ba5b769b0ae$var$calcShadowOuterSize(style) {
    var shadowBlur = $62f65ba5b769b0ae$var$mathMaxWith0(style.shadowBlur || 0);
    var shadowOffsetX = $62f65ba5b769b0ae$var$mathMaxWith0(style.shadowOffsetX || 0);
    var shadowOffsetY = $62f65ba5b769b0ae$var$mathMaxWith0(style.shadowOffsetY || 0);
    return {
        left: $62f65ba5b769b0ae$var$mathMaxWith0(shadowBlur - shadowOffsetX),
        right: $62f65ba5b769b0ae$var$mathMaxWith0(shadowBlur + shadowOffsetX),
        top: $62f65ba5b769b0ae$var$mathMaxWith0(shadowBlur - shadowOffsetY),
        bottom: $62f65ba5b769b0ae$var$mathMaxWith0(shadowBlur + shadowOffsetY)
    };
}
function $62f65ba5b769b0ae$var$makeStyleCoord(out, zr, zrX, zrY) {
    out[0] = zrX;
    out[1] = zrY;
    out[2] = out[0] / zr.getWidth();
    out[3] = out[1] / zr.getHeight();
}
var $62f65ba5b769b0ae$export$2e2bcd8739ae039 = $62f65ba5b769b0ae$var$TooltipRichContent;




















var $1b2ffe835052ab23$var$proxyRect = new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
    shape: {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    }
});
var $1b2ffe835052ab23$var$TooltipView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TooltipView, _super);
    function TooltipView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TooltipView.type;
        return _this;
    }
    TooltipView.prototype.init = function(ecModel, api) {
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node || !api.getDom()) return;
        var tooltipModel = ecModel.getComponent("tooltip");
        var renderMode = this._renderMode = (0, $76d619f648247e6d$export$cc0a17a5d27b4e17)(tooltipModel.get("renderMode"));
        this._tooltipContent = renderMode === "richText" ? new (0, $62f65ba5b769b0ae$export$2e2bcd8739ae039)(api) : new (0, $501187a7e974c4e1$export$2e2bcd8739ae039)(api, {
            appendTo: tooltipModel.get("appendToBody", true) ? "body" : tooltipModel.get("appendTo", true)
        });
    };
    TooltipView.prototype.render = function(tooltipModel, ecModel, api) {
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node || !api.getDom()) return;
        // Reset
        this.group.removeAll();
        this._tooltipModel = tooltipModel;
        this._ecModel = ecModel;
        this._api = api;
        var tooltipContent = this._tooltipContent;
        tooltipContent.update(tooltipModel);
        tooltipContent.setEnterable(tooltipModel.get("enterable"));
        this._initGlobalListener();
        this._keepShow();
        // PENDING
        // `mousemove` event will be triggered very frequently when the mouse moves fast,
        // which causes that the `updatePosition` function was also called frequently.
        // In Chrome with devtools open and Firefox, tooltip looks laggy and shakes. See #14695 #16101
        // To avoid frequent triggering,
        // consider throttling it in 50ms when transition is enabled
        if (this._renderMode !== "richText" && tooltipModel.get("transitionDuration")) (0, $c98659a9437a3d2e$export$958e3e1a02eac4b6)(this, "_updatePosition", 50, "fixRate");
        else (0, $c98659a9437a3d2e$export$42ffd38884aecdac)(this, "_updatePosition");
    };
    TooltipView.prototype._initGlobalListener = function() {
        var tooltipModel = this._tooltipModel;
        var triggerOn = tooltipModel.get("triggerOn");
        $84450f5aa7fbde00$export$6503ec6e8aabbaf("itemTooltip", this._api, (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== "none") {
                if (triggerOn.indexOf(currTrigger) >= 0) this._tryShow(e, dispatchAction);
                else if (currTrigger === "leave") this._hide(dispatchAction);
            }
        }, this));
    };
    TooltipView.prototype._keepShow = function() {
        var tooltipModel = this._tooltipModel;
        var ecModel = this._ecModel;
        var api = this._api;
        var triggerOn = tooltipModel.get("triggerOn");
        // Try to keep the tooltip show when refreshing
        if (this._lastX != null && this._lastY != null && triggerOn !== "none" && triggerOn !== "click") {
            var self_1 = this;
            clearTimeout(this._refreshUpdateTimeout);
            this._refreshUpdateTimeout = setTimeout(function() {
                // Show tip next tick after other charts are rendered
                // In case highlight action has wrong result
                // FIXME
                !api.isDisposed() && self_1.manuallyShowTip(tooltipModel, ecModel, api, {
                    x: self_1._lastX,
                    y: self_1._lastY,
                    dataByCoordSys: self_1._lastDataByCoordSys
                });
            });
        }
    };
    /**
   * Show tip manually by
   * dispatchAction({
   *     type: 'showTip',
   *     x: 10,
   *     y: 10
   * });
   * Or
   * dispatchAction({
   *      type: 'showTip',
   *      seriesIndex: 0,
   *      dataIndex or dataIndexInside or name
   * });
   *
   *  TODO Batch
   */ TooltipView.prototype.manuallyShowTip = function(tooltipModel, ecModel, api, payload) {
        if (payload.from === this.uid || (0, $ce6dd58693a21851$export$2e2bcd8739ae039).node || !api.getDom()) return;
        var dispatchAction = $1b2ffe835052ab23$var$makeDispatchAction(payload, api);
        // Reset ticket
        this._ticket = "";
        // When triggered from axisPointer.
        var dataByCoordSys = payload.dataByCoordSys;
        var cmptRef = $1b2ffe835052ab23$var$findComponentReference(payload, ecModel, api);
        if (cmptRef) {
            var rect = cmptRef.el.getBoundingRect().clone();
            rect.applyTransform(cmptRef.el.transform);
            this._tryShow({
                offsetX: rect.x + rect.width / 2,
                offsetY: rect.y + rect.height / 2,
                target: cmptRef.el,
                position: payload.position,
                // When manully trigger, the mouse is not on the el, so we'd better to
                // position tooltip on the bottom of the el and display arrow is possible.
                positionDefault: "bottom"
            }, dispatchAction);
        } else if (payload.tooltip && payload.x != null && payload.y != null) {
            var el = $1b2ffe835052ab23$var$proxyRect;
            el.x = payload.x;
            el.y = payload.y;
            el.update();
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).tooltipConfig = {
                name: null,
                option: payload.tooltip
            };
            // Manually show tooltip while view is not using zrender elements.
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                target: el
            }, dispatchAction);
        } else if (dataByCoordSys) this._tryShow({
            offsetX: payload.x,
            offsetY: payload.y,
            position: payload.position,
            dataByCoordSys: dataByCoordSys,
            tooltipOption: payload.tooltipOption
        }, dispatchAction);
        else if (payload.seriesIndex != null) {
            if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) return;
            var pointInfo = (0, $4cab5d8b3532dad5$export$2e2bcd8739ae039)(payload, ecModel);
            var cx = pointInfo.point[0];
            var cy = pointInfo.point[1];
            if (cx != null && cy != null) this._tryShow({
                offsetX: cx,
                offsetY: cy,
                target: pointInfo.el,
                position: payload.position,
                // When manully trigger, the mouse is not on the el, so we'd better to
                // position tooltip on the bottom of the el and display arrow is possible.
                positionDefault: "bottom"
            }, dispatchAction);
        } else if (payload.x != null && payload.y != null) {
            // FIXME
            // should wrap dispatchAction like `axisPointer/globalListener` ?
            api.dispatchAction({
                type: "updateAxisPointer",
                x: payload.x,
                y: payload.y
            });
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                position: payload.position,
                target: api.getZr().findHover(payload.x, payload.y).target
            }, dispatchAction);
        }
    };
    TooltipView.prototype.manuallyHideTip = function(tooltipModel, ecModel, api, payload) {
        var tooltipContent = this._tooltipContent;
        if (this._tooltipModel) tooltipContent.hideLater(this._tooltipModel.get("hideDelay"));
        this._lastX = this._lastY = this._lastDataByCoordSys = null;
        if (payload.from !== this.uid) this._hide($1b2ffe835052ab23$var$makeDispatchAction(payload, api));
    };
    // Be compatible with previous design, that is, when tooltip.type is 'axis' and
    // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
    // and tooltip.
    TooltipView.prototype._manuallyAxisShowTip = function(tooltipModel, ecModel, api, payload) {
        var seriesIndex = payload.seriesIndex;
        var dataIndex = payload.dataIndex;
        // @ts-ignore
        var coordSysAxesInfo = ecModel.getComponent("axisPointer").coordSysAxesInfo;
        if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) return;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        if (!seriesModel) return;
        var data = seriesModel.getData();
        var tooltipCascadedModel = $1b2ffe835052ab23$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            seriesModel,
            (seriesModel.coordinateSystem || {}).model
        ], this._tooltipModel);
        if (tooltipCascadedModel.get("trigger") !== "axis") return;
        api.dispatchAction({
            type: "updateAxisPointer",
            seriesIndex: seriesIndex,
            dataIndex: dataIndex,
            position: payload.position
        });
        return true;
    };
    TooltipView.prototype._tryShow = function(e, dispatchAction) {
        var el = e.target;
        var tooltipModel = this._tooltipModel;
        if (!tooltipModel) return;
        // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed
        this._lastX = e.offsetX;
        this._lastY = e.offsetY;
        var dataByCoordSys = e.dataByCoordSys;
        if (dataByCoordSys && dataByCoordSys.length) this._showAxisTooltip(dataByCoordSys, e);
        else if (el) {
            var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
            if (ecData.ssrType === "legend") // Don't trigger tooltip for legend tooltip item
            return;
            this._lastDataByCoordSys = null;
            var seriesDispatcher_1;
            var cmptDispatcher_1;
            (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(el, function(target) {
                if (target.tooltipDisabled) {
                    seriesDispatcher_1 = cmptDispatcher_1 = null;
                    return true;
                }
                if (seriesDispatcher_1 || cmptDispatcher_1) return;
                // Always show item tooltip if mouse is on the element with dataIndex
                if ((0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(target).dataIndex != null) seriesDispatcher_1 = target;
                else if ((0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(target).tooltipConfig != null) cmptDispatcher_1 = target;
            }, true);
            if (seriesDispatcher_1) this._showSeriesItemTooltip(e, seriesDispatcher_1, dispatchAction);
            else if (cmptDispatcher_1) this._showComponentItemTooltip(e, cmptDispatcher_1, dispatchAction);
            else this._hide(dispatchAction);
        } else {
            this._lastDataByCoordSys = null;
            this._hide(dispatchAction);
        }
    };
    TooltipView.prototype._showOrMove = function(tooltipModel, cb) {
        // showDelay is used in this case: tooltip.enterable is set
        // as true. User intent to move mouse into tooltip and click
        // something. `showDelay` makes it easier to enter the content
        // but tooltip do not move immediately.
        var delay = tooltipModel.get("showDelay");
        cb = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(cb, this);
        clearTimeout(this._showTimout);
        delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
    };
    TooltipView.prototype._showAxisTooltip = function(dataByCoordSys, e) {
        var ecModel = this._ecModel;
        var globalTooltipModel = this._tooltipModel;
        var point = [
            e.offsetX,
            e.offsetY
        ];
        var singleTooltipModel = $1b2ffe835052ab23$var$buildTooltipModel([
            e.tooltipOption
        ], globalTooltipModel);
        var renderMode = this._renderMode;
        var cbParamsList = [];
        var articleMarkup = (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("section", {
            blocks: [],
            noHeader: true
        });
        // Only for legacy: `Serise['formatTooltip']` returns a string.
        var markupTextArrLegacy = [];
        var markupStyleCreator = new (0, $d5ab84c08d6657ec$export$2fba3afbcdcf3e18)();
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dataByCoordSys, function(itemCoordSys) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(itemCoordSys.dataByAxis, function(axisItem) {
                var axisModel = ecModel.getComponent(axisItem.axisDim + "Axis", axisItem.axisIndex);
                var axisValue = axisItem.value;
                if (!axisModel || axisValue == null) return;
                // FIXME: when using `tooltip.trigger: 'axis'`, the precision of the axis value displayed in tooltip
                //  should match the original series values rather than using the default stretegy in Interval.ts
                //  (getPrecision(interval) + 2); otherwise it may cuase confusion.
                var axisValueLabel = $51dec70890757374$export$7cffee0f9aed39d0(axisValue, axisModel.axis, ecModel, axisItem.seriesDataIndices, axisItem.valueLabelOpt);
                var axisSectionMarkup = (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("section", {
                    header: axisValueLabel,
                    noHeader: !(0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(axisValueLabel),
                    sortBlocks: true,
                    blocks: []
                });
                articleMarkup.blocks.push(axisSectionMarkup);
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisItem.seriesDataIndices, function(idxItem) {
                    var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
                    var dataIndex = idxItem.dataIndexInside;
                    var cbParams = series.getDataParams(dataIndex);
                    // Can't find data.
                    if (cbParams.dataIndex < 0) return;
                    cbParams.axisDim = axisItem.axisDim;
                    cbParams.axisIndex = axisItem.axisIndex;
                    cbParams.axisType = axisItem.axisType;
                    cbParams.axisId = axisItem.axisId;
                    cbParams.axisValue = $2d646e51cc34f840$export$a5a32f324c1fa457(axisModel.axis, {
                        value: axisValue
                    });
                    cbParams.axisValueLabel = axisValueLabel;
                    // Pre-create marker style for makers. Users can assemble richText
                    // text in `formatter` callback and use those markers style.
                    cbParams.marker = markupStyleCreator.makeTooltipMarker("item", (0, $c84c9521536c601a$export$cda04d03233e5555)(cbParams.color), renderMode);
                    var seriesTooltipResult = (0, $655dd6075cc63601$export$2d16fa82a50c4741)(series.formatTooltip(dataIndex, true, null));
                    var frag = seriesTooltipResult.frag;
                    if (frag) {
                        var valueFormatter = $1b2ffe835052ab23$var$buildTooltipModel([
                            series
                        ], globalTooltipModel).get("valueFormatter");
                        axisSectionMarkup.blocks.push(valueFormatter ? (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
                            valueFormatter: valueFormatter
                        }, frag) : frag);
                    }
                    if (seriesTooltipResult.text) markupTextArrLegacy.push(seriesTooltipResult.text);
                    cbParamsList.push(cbParams);
                });
            });
        });
        // In most cases, the second axis is displays upper on the first one.
        // So we reverse it to look better.
        articleMarkup.blocks.reverse();
        markupTextArrLegacy.reverse();
        var positionExpr = e.position;
        var orderMode = singleTooltipModel.get("order");
        var builtMarkupText = (0, $d5ab84c08d6657ec$export$6969ffb02c1cb49a)(articleMarkup, markupStyleCreator, renderMode, orderMode, ecModel.get("useUTC"), singleTooltipModel.get("textStyle"));
        builtMarkupText && markupTextArrLegacy.unshift(builtMarkupText);
        var blockBreak = renderMode === "richText" ? "\n\n" : "<br/>";
        var allMarkupText = markupTextArrLegacy.join(blockBreak);
        this._showOrMove(singleTooltipModel, function() {
            if (this._updateContentNotChangedOnAxis(dataByCoordSys, cbParamsList)) this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, cbParamsList);
            else this._showTooltipContent(singleTooltipModel, allMarkupText, cbParamsList, Math.random() + "", point[0], point[1], positionExpr, null, markupStyleCreator);
        });
    // Do not trigger events here, because this branch only be entered
    // from dispatchAction.
    };
    TooltipView.prototype._showSeriesItemTooltip = function(e, dispatcher, dispatchAction) {
        var ecModel = this._ecModel;
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(dispatcher);
        // Use dataModel in element if possible
        // Used when mouseover on a element like markPoint or edge
        // In which case, the data is not main data in series.
        var seriesIndex = ecData.seriesIndex;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        // For example, graph link.
        var dataModel = ecData.dataModel || seriesModel;
        var dataIndex = ecData.dataIndex;
        var dataType = ecData.dataType;
        var data = dataModel.getData(dataType);
        var renderMode = this._renderMode;
        var positionDefault = e.positionDefault;
        var tooltipModel = $1b2ffe835052ab23$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            dataModel,
            seriesModel && (seriesModel.coordinateSystem || {}).model
        ], this._tooltipModel, positionDefault ? {
            position: positionDefault
        } : null);
        var tooltipTrigger = tooltipModel.get("trigger");
        if (tooltipTrigger != null && tooltipTrigger !== "item") return;
        var params = dataModel.getDataParams(dataIndex, dataType);
        var markupStyleCreator = new (0, $d5ab84c08d6657ec$export$2fba3afbcdcf3e18)();
        // Pre-create marker style for makers. Users can assemble richText
        // text in `formatter` callback and use those markers style.
        params.marker = markupStyleCreator.makeTooltipMarker("item", (0, $c84c9521536c601a$export$cda04d03233e5555)(params.color), renderMode);
        var seriesTooltipResult = (0, $655dd6075cc63601$export$2d16fa82a50c4741)(dataModel.formatTooltip(dataIndex, false, dataType));
        var orderMode = tooltipModel.get("order");
        var valueFormatter = tooltipModel.get("valueFormatter");
        var frag = seriesTooltipResult.frag;
        var markupText = frag ? (0, $d5ab84c08d6657ec$export$6969ffb02c1cb49a)(valueFormatter ? (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
            valueFormatter: valueFormatter
        }, frag) : frag, markupStyleCreator, renderMode, orderMode, ecModel.get("useUTC"), tooltipModel.get("textStyle")) : seriesTooltipResult.text;
        var asyncTicket = "item_" + dataModel.name + "_" + dataIndex;
        this._showOrMove(tooltipModel, function() {
            this._showTooltipContent(tooltipModel, markupText, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target, markupStyleCreator);
        });
        // FIXME
        // duplicated showtip if manuallyShowTip is called from dispatchAction.
        dispatchAction({
            type: "showTip",
            dataIndexInside: dataIndex,
            dataIndex: data.getRawIndex(dataIndex),
            seriesIndex: seriesIndex,
            from: this.uid
        });
    };
    TooltipView.prototype._showComponentItemTooltip = function(e, el, dispatchAction) {
        var isHTMLRenderMode = this._renderMode === "html";
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
        var tooltipConfig = ecData.tooltipConfig;
        var tooltipOpt = tooltipConfig.option || {};
        var encodeHTMLContent = tooltipOpt.encodeHTMLContent;
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(tooltipOpt)) {
            var content = tooltipOpt;
            tooltipOpt = {
                content: content,
                // Fixed formatter
                formatter: content
            };
            // when `tooltipConfig.option` is a string rather than an object,
            // we can't know if the content needs to be encoded
            // for the sake of security, encode it by default.
            encodeHTMLContent = true;
        }
        if (encodeHTMLContent && isHTMLRenderMode && tooltipOpt.content) {
            // clone might be unnecessary?
            tooltipOpt = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(tooltipOpt);
            tooltipOpt.content = (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(tooltipOpt.content);
        }
        var tooltipModelCascade = [
            tooltipOpt
        ];
        var cmpt = this._ecModel.getComponent(ecData.componentMainType, ecData.componentIndex);
        if (cmpt) tooltipModelCascade.push(cmpt);
        // In most cases, component tooltip formatter has different params with series tooltip formatter,
        // so that they cannot share the same formatter. Since the global tooltip formatter is used for series
        // by convention, we do not use it as the default formatter for component.
        tooltipModelCascade.push({
            formatter: tooltipOpt.content
        });
        var positionDefault = e.positionDefault;
        var subTooltipModel = $1b2ffe835052ab23$var$buildTooltipModel(tooltipModelCascade, this._tooltipModel, positionDefault ? {
            position: positionDefault
        } : null);
        var defaultHtml = subTooltipModel.get("content");
        var asyncTicket = Math.random() + "";
        // PENDING: this case do not support richText style yet.
        var markupStyleCreator = new (0, $d5ab84c08d6657ec$export$2fba3afbcdcf3e18)();
        // Do not check whether `trigger` is 'none' here, because `trigger`
        // only works on coordinate system. In fact, we have not found case
        // that requires setting `trigger` nothing on component yet.
        this._showOrMove(subTooltipModel, function() {
            // Use formatterParams from element defined in component
            // Avoid users modify it.
            var formatterParams = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(subTooltipModel.get("formatterParams") || {});
            this._showTooltipContent(subTooltipModel, defaultHtml, formatterParams, asyncTicket, e.offsetX, e.offsetY, e.position, el, markupStyleCreator);
        });
        // If not dispatch showTip, tip may be hide triggered by axis.
        dispatchAction({
            type: "showTip",
            from: this.uid
        });
    };
    TooltipView.prototype._showTooltipContent = function(// Use Model<TooltipOption> insteadof TooltipModel because this model may be from series or other options.
    // Instead of top level tooltip.
    tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el, markupStyleCreator) {
        // Reset ticket
        this._ticket = "";
        if (!tooltipModel.get("showContent") || !tooltipModel.get("show")) return;
        var tooltipContent = this._tooltipContent;
        tooltipContent.setEnterable(tooltipModel.get("enterable"));
        var formatter = tooltipModel.get("formatter");
        positionExpr = positionExpr || tooltipModel.get("position");
        var html = defaultHtml;
        var nearPoint = this._getNearestPoint([
            x,
            y
        ], params, tooltipModel.get("trigger"), tooltipModel.get("borderColor"), tooltipModel.get("defaultBorderColor", true));
        var nearPointColor = nearPoint.color;
        if (formatter) {
            if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(formatter)) {
                var useUTC = tooltipModel.ecModel.get("useUTC");
                var params0 = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(params) ? params[0] : params;
                var isTimeAxis = params0 && params0.axisType && params0.axisType.indexOf("time") >= 0;
                html = formatter;
                if (isTimeAxis) html = (0, $0ae0381fb3fd176f$export$d9468344d3651243)(params0.axisValue, html, useUTC);
                html = (0, $c84c9521536c601a$export$2028496a35766e41)(html, params, true);
            } else if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(formatter)) {
                var callback = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(function(cbTicket, html) {
                    if (cbTicket === this._ticket) {
                        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
                        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
                    }
                }, this);
                this._ticket = asyncTicket;
                html = formatter(params, asyncTicket, callback);
            } else html = formatter;
        }
        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
        tooltipContent.show(tooltipModel, nearPointColor);
        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
    };
    TooltipView.prototype._getNearestPoint = function(point, tooltipDataParams, trigger, borderColor, defaultBorderColor) {
        if (trigger === "axis" || (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(tooltipDataParams)) return {
            color: borderColor || defaultBorderColor
        };
        if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(tooltipDataParams)) return {
            color: borderColor || tooltipDataParams.color || tooltipDataParams.borderColor
        };
    };
    TooltipView.prototype._updatePosition = function(tooltipModel, positionExpr, x, // Mouse x
    y, // Mouse y
    content, params, el) {
        var viewWidth = this._api.getWidth();
        var viewHeight = this._api.getHeight();
        positionExpr = positionExpr || tooltipModel.get("position");
        var contentSize = content.getSize();
        var align = tooltipModel.get("align");
        var vAlign = tooltipModel.get("verticalAlign");
        var rect = el && el.getBoundingRect().clone();
        el && rect.applyTransform(el.transform);
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(positionExpr)) // Callback of position can be an array or a string specify the position
        positionExpr = positionExpr([
            x,
            y
        ], params, content.el, rect, {
            viewSize: [
                viewWidth,
                viewHeight
            ],
            contentSize: contentSize.slice()
        });
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(positionExpr)) {
            x = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionExpr[0], viewWidth);
            y = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionExpr[1], viewHeight);
        } else if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(positionExpr)) {
            var boxLayoutPosition = positionExpr;
            boxLayoutPosition.width = contentSize[0];
            boxLayoutPosition.height = contentSize[1];
            var layoutRect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(boxLayoutPosition, {
                width: viewWidth,
                height: viewHeight
            });
            x = layoutRect.x;
            y = layoutRect.y;
            align = null;
            // When positionExpr is left/top/right/bottom,
            // align and verticalAlign will not work.
            vAlign = null;
        } else if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(positionExpr) && el) {
            var pos = $1b2ffe835052ab23$var$calcTooltipPosition(positionExpr, rect, contentSize, tooltipModel.get("borderWidth"));
            x = pos[0];
            y = pos[1];
        } else {
            var pos = $1b2ffe835052ab23$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
            x = pos[0];
            y = pos[1];
        }
        align && (x -= $1b2ffe835052ab23$var$isCenterAlign(align) ? contentSize[0] / 2 : align === "right" ? contentSize[0] : 0);
        vAlign && (y -= $1b2ffe835052ab23$var$isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === "bottom" ? contentSize[1] : 0);
        if ((0, $c6d80cf697426e46$export$a309528050824ba4)(tooltipModel)) {
            var pos = $1b2ffe835052ab23$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight);
            x = pos[0];
            y = pos[1];
        }
        content.moveTo(x, y);
    };
    // FIXME
    // Should we remove this but leave this to user?
    TooltipView.prototype._updateContentNotChangedOnAxis = function(dataByCoordSys, cbParamsList) {
        var lastCoordSys = this._lastDataByCoordSys;
        var lastCbParamsList = this._cbParamsList;
        var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
        contentNotChanged && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(lastCoordSys, function(lastItemCoordSys, indexCoordSys) {
            var lastDataByAxis = lastItemCoordSys.dataByAxis || [];
            var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
            var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
            contentNotChanged = contentNotChanged && lastDataByAxis.length === thisDataByAxis.length;
            contentNotChanged && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(lastDataByAxis, function(lastItem, indexAxis) {
                var thisItem = thisDataByAxis[indexAxis] || {};
                var lastIndices = lastItem.seriesDataIndices || [];
                var newIndices = thisItem.seriesDataIndices || [];
                contentNotChanged = contentNotChanged && lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
                contentNotChanged && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(lastIndices, function(lastIdxItem, j) {
                    var newIdxItem = newIndices[j];
                    contentNotChanged = contentNotChanged && lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
                });
                // check is cbParams data value changed
                lastCbParamsList && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(lastItem.seriesDataIndices, function(idxItem) {
                    var seriesIdx = idxItem.seriesIndex;
                    var cbParams = cbParamsList[seriesIdx];
                    var lastCbParams = lastCbParamsList[seriesIdx];
                    if (cbParams && lastCbParams && lastCbParams.data !== cbParams.data) contentNotChanged = false;
                });
            });
        });
        this._lastDataByCoordSys = dataByCoordSys;
        this._cbParamsList = cbParamsList;
        return !!contentNotChanged;
    };
    TooltipView.prototype._hide = function(dispatchAction) {
        // Do not directly hideLater here, because this behavior may be prevented
        // in dispatchAction when showTip is dispatched.
        // FIXME
        // duplicated hideTip if manuallyHideTip is called from dispatchAction.
        this._lastDataByCoordSys = null;
        dispatchAction({
            type: "hideTip",
            from: this.uid
        });
    };
    TooltipView.prototype.dispose = function(ecModel, api) {
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node || !api.getDom()) return;
        (0, $c98659a9437a3d2e$export$42ffd38884aecdac)(this, "_updatePosition");
        this._tooltipContent.dispose();
        $84450f5aa7fbde00$export$d07f55d4c15c0440("itemTooltip", api);
    };
    TooltipView.type = "tooltip";
    return TooltipView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
/**
 * From top to bottom. (the last one should be globalTooltipModel);
 */ function $1b2ffe835052ab23$var$buildTooltipModel(modelCascade, globalTooltipModel, defaultTooltipOption) {
    // Last is always tooltip model.
    var ecModel = globalTooltipModel.ecModel;
    var resultModel;
    if (defaultTooltipOption) {
        resultModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(defaultTooltipOption, ecModel, ecModel);
        resultModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(globalTooltipModel.option, resultModel, ecModel);
    } else resultModel = globalTooltipModel;
    for(var i = modelCascade.length - 1; i >= 0; i--){
        var tooltipOpt = modelCascade[i];
        if (tooltipOpt) {
            if (tooltipOpt instanceof (0, $6818646a97528290$export$2e2bcd8739ae039)) tooltipOpt = tooltipOpt.get("tooltip", true);
            // In each data item tooltip can be simply write:
            // {
            //  value: 10,
            //  tooltip: 'Something you need to know'
            // }
            if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(tooltipOpt)) tooltipOpt = {
                formatter: tooltipOpt
            };
            if (tooltipOpt) resultModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(tooltipOpt, resultModel, ecModel);
        }
    }
    return resultModel;
}
function $1b2ffe835052ab23$var$makeDispatchAction(payload, api) {
    return payload.dispatchAction || (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(api.dispatchAction, api);
}
function $1b2ffe835052ab23$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, gapH, gapV) {
    var size = content.getSize();
    var width = size[0];
    var height = size[1];
    if (gapH != null) {
        // Add extra 2 pixels for this case:
        // At present the "values" in default tooltip are using CSS `float: right`.
        // When the right edge of the tooltip box is on the right side of the
        // viewport, the `float` layout might push the "values" to the second line.
        if (x + width + gapH + 2 > viewWidth) x -= width + gapH;
        else x += gapH;
    }
    if (gapV != null) {
        if (y + height + gapV > viewHeight) y -= height + gapV;
        else y += gapV;
    }
    return [
        x,
        y
    ];
}
function $1b2ffe835052ab23$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight) {
    var size = content.getSize();
    var width = size[0];
    var height = size[1];
    x = Math.min(x + width, viewWidth) - width;
    y = Math.min(y + height, viewHeight) - height;
    x = Math.max(x, 0);
    y = Math.max(y, 0);
    return [
        x,
        y
    ];
}
function $1b2ffe835052ab23$var$calcTooltipPosition(position, rect, contentSize, borderWidth) {
    var domWidth = contentSize[0];
    var domHeight = contentSize[1];
    var offset = Math.ceil(Math.SQRT2 * borderWidth) + 8;
    var x = 0;
    var y = 0;
    var rectWidth = rect.width;
    var rectHeight = rect.height;
    switch(position){
        case "inside":
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case "top":
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y - domHeight - offset;
            break;
        case "bottom":
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight + offset;
            break;
        case "left":
            x = rect.x - domWidth - offset;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case "right":
            x = rect.x + rectWidth + offset;
            y = rect.y + rectHeight / 2 - domHeight / 2;
    }
    return [
        x,
        y
    ];
}
function $1b2ffe835052ab23$var$isCenterAlign(align) {
    return align === "center" || align === "middle";
}
/**
 * Find target component by payload like:
 * ```js
 * { legendId: 'some_id', name: 'xxx' }
 * { toolboxIndex: 1, name: 'xxx' }
 * { geoName: 'some_name', name: 'xxx' }
 * ```
 * PENDING: at present only
 *
 * If not found, return null/undefined.
 */ function $1b2ffe835052ab23$var$findComponentReference(payload, ecModel, api) {
    var queryOptionMap = (0, $76d619f648247e6d$export$fe600815775d9400)(payload).queryOptionMap;
    var componentMainType = queryOptionMap.keys()[0];
    if (!componentMainType || componentMainType === "series") return;
    var queryResult = (0, $76d619f648247e6d$export$dc741340f7e5f186)(ecModel, componentMainType, queryOptionMap.get(componentMainType), {
        useDefault: false,
        enableAll: false,
        enableNone: false
    });
    var model = queryResult.models[0];
    if (!model) return;
    var view = api.getViewOfComponentModel(model);
    var el;
    view.group.traverse(function(subEl) {
        var tooltipConfig = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(subEl).tooltipConfig;
        if (tooltipConfig && tooltipConfig.name === payload.name) {
            el = subEl;
            return true; // stop
        }
    });
    if (el) return {
        componentMainType: componentMainType,
        componentIndex: model.componentIndex,
        el: el
    };
}
var $1b2ffe835052ab23$export$2e2bcd8739ae039 = $1b2ffe835052ab23$var$TooltipView;



function $46e639bec576c55c$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $589507869c21caa1$export$4b3e715f166fdd78));
    registers.registerComponentModel((0, $310c8e7a9655a722$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $1b2ffe835052ab23$export$2e2bcd8739ae039));
    /**
   * @action
   * @property {string} type
   * @property {number} seriesIndex
   * @property {number} dataIndex
   * @property {number} [x]
   * @property {number} [y]
   */ registers.registerAction({
        type: "showTip",
        event: "showTip",
        update: "tooltip:manuallyShowTip"
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
    registers.registerAction({
        type: "hideTip",
        event: "hideTip",
        update: "tooltip:manuallyHideTip"
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $9c7e3d8a1f578014$var$RELATIONAL_EXPRESSION_OP_ALIAS_MAP = {
    value: "eq",
    // PENDING: not good for literal semantic?
    "<": "lt",
    "<=": "lte",
    ">": "gt",
    ">=": "gte",
    "=": "eq",
    "!=": "ne",
    "<>": "ne"
};
// type RelationalExpressionOpEvaluate = (tarVal: unknown, condVal: unknown) => boolean;
var $9c7e3d8a1f578014$var$RegExpEvaluator = /** @class */ function() {
    function RegExpEvaluator(rVal) {
        // Support condVal: RegExp | string
        var condValue = this._condVal = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(rVal) ? new RegExp(rVal) : (0, $7a1bd9c2710fea0d$export$49841c62b9eff15)(rVal) ? rVal : null;
        if (condValue == null) {
            var errMsg = "";
            (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        }
    }
    RegExpEvaluator.prototype.evaluate = function(lVal) {
        var type = typeof lVal;
        return (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(type) ? this._condVal.test(lVal) : (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(type) ? this._condVal.test(lVal + "") : false;
    };
    return RegExpEvaluator;
}();
var $9c7e3d8a1f578014$var$ConstConditionInternal = /** @class */ function() {
    function ConstConditionInternal() {}
    ConstConditionInternal.prototype.evaluate = function() {
        return this.value;
    };
    return ConstConditionInternal;
}();
var $9c7e3d8a1f578014$var$AndConditionInternal = /** @class */ function() {
    function AndConditionInternal() {}
    AndConditionInternal.prototype.evaluate = function() {
        var children = this.children;
        for(var i = 0; i < children.length; i++){
            if (!children[i].evaluate()) return false;
        }
        return true;
    };
    return AndConditionInternal;
}();
var $9c7e3d8a1f578014$var$OrConditionInternal = /** @class */ function() {
    function OrConditionInternal() {}
    OrConditionInternal.prototype.evaluate = function() {
        var children = this.children;
        for(var i = 0; i < children.length; i++){
            if (children[i].evaluate()) return true;
        }
        return false;
    };
    return OrConditionInternal;
}();
var $9c7e3d8a1f578014$var$NotConditionInternal = /** @class */ function() {
    function NotConditionInternal() {}
    NotConditionInternal.prototype.evaluate = function() {
        return !this.child.evaluate();
    };
    return NotConditionInternal;
}();
var $9c7e3d8a1f578014$var$RelationalConditionInternal = /** @class */ function() {
    function RelationalConditionInternal() {}
    RelationalConditionInternal.prototype.evaluate = function() {
        var needParse = !!this.valueParser;
        // Call getValue with no `this`.
        var getValue = this.getValue;
        var tarValRaw = getValue(this.valueGetterParam);
        var tarValParsed = needParse ? this.valueParser(tarValRaw) : null;
        // Relational cond follow "and" logic internally.
        for(var i = 0; i < this.subCondList.length; i++){
            if (!this.subCondList[i].evaluate(needParse ? tarValParsed : tarValRaw)) return false;
        }
        return true;
    };
    return RelationalConditionInternal;
}();
function $9c7e3d8a1f578014$var$parseOption(exprOption, getters) {
    if (exprOption === true || exprOption === false) {
        var cond = new $9c7e3d8a1f578014$var$ConstConditionInternal();
        cond.value = exprOption;
        return cond;
    }
    var errMsg = "";
    if (!$9c7e3d8a1f578014$var$isObjectNotArray(exprOption)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    if (exprOption.and) return $9c7e3d8a1f578014$var$parseAndOrOption("and", exprOption, getters);
    else if (exprOption.or) return $9c7e3d8a1f578014$var$parseAndOrOption("or", exprOption, getters);
    else if (exprOption.not) return $9c7e3d8a1f578014$var$parseNotOption(exprOption, getters);
    return $9c7e3d8a1f578014$var$parseRelationalOption(exprOption, getters);
}
function $9c7e3d8a1f578014$var$parseAndOrOption(op, exprOption, getters) {
    var subOptionArr = exprOption[op];
    var errMsg = "";
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(subOptionArr)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    if (!subOptionArr.length) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    var cond = op === "and" ? new $9c7e3d8a1f578014$var$AndConditionInternal() : new $9c7e3d8a1f578014$var$OrConditionInternal();
    cond.children = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(subOptionArr, function(subOption) {
        return $9c7e3d8a1f578014$var$parseOption(subOption, getters);
    });
    if (!cond.children.length) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    return cond;
}
function $9c7e3d8a1f578014$var$parseNotOption(exprOption, getters) {
    var subOption = exprOption.not;
    var errMsg = "";
    if (!$9c7e3d8a1f578014$var$isObjectNotArray(subOption)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    var cond = new $9c7e3d8a1f578014$var$NotConditionInternal();
    cond.child = $9c7e3d8a1f578014$var$parseOption(subOption, getters);
    if (!cond.child) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    return cond;
}
function $9c7e3d8a1f578014$var$parseRelationalOption(exprOption, getters) {
    var errMsg = "";
    var valueGetterParam = getters.prepareGetValue(exprOption);
    var subCondList = [];
    var exprKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(exprOption);
    var parserName = exprOption.parser;
    var valueParser = parserName ? (0, $40ab59f44b7d2db6$export$c88237b7c265b36b)(parserName) : null;
    for(var i = 0; i < exprKeys.length; i++){
        var keyRaw = exprKeys[i];
        if (keyRaw === "parser" || getters.valueGetterAttrMap.get(keyRaw)) continue;
        var op = (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)($9c7e3d8a1f578014$var$RELATIONAL_EXPRESSION_OP_ALIAS_MAP, keyRaw) ? $9c7e3d8a1f578014$var$RELATIONAL_EXPRESSION_OP_ALIAS_MAP[keyRaw] : keyRaw;
        var condValueRaw = exprOption[keyRaw];
        var condValueParsed = valueParser ? valueParser(condValueRaw) : condValueRaw;
        var evaluator = (0, $40ab59f44b7d2db6$export$f2644c3485f94c4e)(op, condValueParsed) || op === "reg" && new $9c7e3d8a1f578014$var$RegExpEvaluator(condValueParsed);
        if (!evaluator) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        subCondList.push(evaluator);
    }
    if (!subCondList.length) // No relational operator always disabled in case of dangers result.
    (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    var cond = new $9c7e3d8a1f578014$var$RelationalConditionInternal();
    cond.valueGetterParam = valueGetterParam;
    cond.valueParser = valueParser;
    cond.getValue = getters.getValue;
    cond.subCondList = subCondList;
    return cond;
}
function $9c7e3d8a1f578014$var$isObjectNotArray(val) {
    return (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(val) && !(0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(val);
}
var $9c7e3d8a1f578014$var$ConditionalExpressionParsed = /** @class */ function() {
    function ConditionalExpressionParsed(exprOption, getters) {
        this._cond = $9c7e3d8a1f578014$var$parseOption(exprOption, getters);
    }
    ConditionalExpressionParsed.prototype.evaluate = function() {
        return this._cond.evaluate();
    };
    return ConditionalExpressionParsed;
}();
function $9c7e3d8a1f578014$export$cd61647d82cec762(exprOption, getters) {
    return new $9c7e3d8a1f578014$var$ConditionalExpressionParsed(exprOption, getters);
}




var $0e1e10ffafe52e71$export$dc15474d94cdc2b3 = {
    type: "echarts:filter",
    // PENDING: enhance to filter by index rather than create new data
    transform: function(params) {
        // [Caveat] Fail-Fast:
        // Do not return the whole dataset unless user config indicates it explicitly.
        // For example, if no condition is specified by mistake, returning an empty result
        // is better than returning the entire raw source for the user to find the mistake.
        var upstream = params.upstream;
        var rawItem;
        var condition = (0, $9c7e3d8a1f578014$export$cd61647d82cec762)(params.config, {
            valueGetterAttrMap: (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)({
                dimension: true
            }),
            prepareGetValue: function(exprOption) {
                var errMsg = "";
                var dimLoose = exprOption.dimension;
                if (!(0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(exprOption, "dimension")) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
                var dimInfo = upstream.getDimensionInfo(dimLoose);
                if (!dimInfo) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
                return {
                    dimIdx: dimInfo.index
                };
            },
            getValue: function(param) {
                return upstream.retrieveValueFromItem(rawItem, param.dimIdx);
            }
        });
        var resultData = [];
        for(var i = 0, len = upstream.count(); i < len; i++){
            rawItem = upstream.getRawDataItem(i);
            if (condition.evaluate()) resultData.push(rawItem);
        }
        return {
            data: resultData
        };
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $7781c153e964c2e9$var$sampleLog = "";
var $7781c153e964c2e9$export$505f1bb66427eaee = {
    type: "echarts:sort",
    transform: function(params) {
        var upstream = params.upstream;
        var config = params.config;
        var errMsg = "";
        // Normalize
        // const orderExprList: OrderExpression[] = isArray(config[0])
        //     ? config as OrderExpression[]
        //     : [config as OrderExpression];
        var orderExprList = (0, $76d619f648247e6d$export$4f07b212a02c8051)(config);
        if (!orderExprList.length) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        var orderDefList = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(orderExprList, function(orderExpr) {
            var dimLoose = orderExpr.dimension;
            var order = orderExpr.order;
            var parserName = orderExpr.parser;
            var incomparable = orderExpr.incomparable;
            if (dimLoose == null) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
            if (order !== "asc" && order !== "desc") (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
            if (incomparable && incomparable !== "min" && incomparable !== "max") {
                var errMsg_1 = "";
                (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg_1);
            }
            if (order !== "asc" && order !== "desc") {
                var errMsg_2 = "";
                (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg_2);
            }
            var dimInfo = upstream.getDimensionInfo(dimLoose);
            if (!dimInfo) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
            var parser = parserName ? (0, $40ab59f44b7d2db6$export$c88237b7c265b36b)(parserName) : null;
            if (parserName && !parser) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
            orderDefList.push({
                dimIdx: dimInfo.index,
                parser: parser,
                comparator: new (0, $40ab59f44b7d2db6$export$ed75a5d7b0144167)(order, incomparable)
            });
        });
        // TODO: support it?
        var sourceFormat = upstream.sourceFormat;
        if (sourceFormat !== (0, $cab29724515ce2b8$export$fcd62ebf51387903) && sourceFormat !== (0, $cab29724515ce2b8$export$703ae8a2d83f441)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        // Other upstream format are all array.
        var resultData = [];
        for(var i = 0, len = upstream.count(); i < len; i++)resultData.push(upstream.getRawDataItem(i));
        resultData.sort(function(item0, item1) {
            for(var i = 0; i < orderDefList.length; i++){
                var orderDef = orderDefList[i];
                var val0 = upstream.retrieveValueFromItem(item0, orderDef.dimIdx);
                var val1 = upstream.retrieveValueFromItem(item1, orderDef.dimIdx);
                if (orderDef.parser) {
                    val0 = orderDef.parser(val0);
                    val1 = orderDef.parser(val1);
                }
                var result = orderDef.comparator.evaluate(val0, val1);
                if (result !== 0) return result;
            }
            return 0;
        });
        return {
            data: resultData
        };
    }
};


function $d6bad095dfa9594d$export$4b3e715f166fdd78(registers) {
    registers.registerTransform((0, $0e1e10ffafe52e71$export$dc15474d94cdc2b3));
    registers.registerTransform((0, $7781c153e964c2e9$export$505f1bb66427eaee));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @file Visual mapping.
 */ 

var $ef3bd976f9d1f7a2$var$visualDefault = {
    /**
   * @public
   */ get: function(visualType, key, isCategory) {
        var value = $7a1bd9c2710fea0d$export$9cd59f9826255e47(($ef3bd976f9d1f7a2$var$defaultOption[visualType] || {})[key]);
        return isCategory ? $7a1bd9c2710fea0d$export$43bee75e5e14138e(value) ? value[value.length - 1] : value : value;
    }
};
var $ef3bd976f9d1f7a2$var$defaultOption = {
    color: {
        active: [
            "#006edd",
            "#e0ffff"
        ],
        inactive: [
            (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.transparent
        ]
    },
    colorHue: {
        active: [
            0,
            360
        ],
        inactive: [
            0,
            0
        ]
    },
    colorSaturation: {
        active: [
            0.3,
            1
        ],
        inactive: [
            0,
            0
        ]
    },
    colorLightness: {
        active: [
            0.9,
            0.5
        ],
        inactive: [
            0,
            0
        ]
    },
    colorAlpha: {
        active: [
            0.3,
            1
        ],
        inactive: [
            0,
            0
        ]
    },
    opacity: {
        active: [
            0.3,
            1
        ],
        inactive: [
            0,
            0
        ]
    },
    symbol: {
        active: [
            "circle",
            "roundRect",
            "diamond"
        ],
        inactive: [
            "none"
        ]
    },
    symbolSize: {
        active: [
            10,
            50
        ],
        inactive: [
            0,
            0
        ]
    }
};
var $ef3bd976f9d1f7a2$export$2e2bcd8739ae039 = $ef3bd976f9d1f7a2$var$visualDefault;








var $fca0c970f405ff38$var$mapVisual = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).mapVisual;
var $fca0c970f405ff38$var$eachVisual = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).eachVisual;
var $fca0c970f405ff38$var$isArray = $7a1bd9c2710fea0d$export$43bee75e5e14138e;
var $fca0c970f405ff38$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $fca0c970f405ff38$var$asc = $cfc1f3b422a3185f$export$debe6e778e0a6d32;
var $fca0c970f405ff38$var$linearMap = $cfc1f3b422a3185f$export$d3f68fbaa670562;
var $fca0c970f405ff38$var$VisualMapModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(VisualMapModel, _super);
    function VisualMapModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = VisualMapModel.type;
        _this.stateList = [
            "inRange",
            "outOfRange"
        ];
        _this.replacableOptionKeys = [
            "inRange",
            "outOfRange",
            "target",
            "controller",
            "color"
        ];
        _this.layoutMode = {
            type: "box",
            ignoreSize: true
        };
        /**
     * [lowerBound, upperBound]
     */ _this.dataBound = [
            -Infinity,
            Infinity
        ];
        _this.targetVisuals = {};
        _this.controllerVisuals = {};
        return _this;
    }
    VisualMapModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
    };
    /**
   * @protected
   */ VisualMapModel.prototype.optionUpdated = function(newOption, isInit) {
        var thisOption = this.option;
        !isInit && $87ea23222d1c134e$export$797d20c0a6de578f(thisOption, newOption, this.replacableOptionKeys);
        this.textStyleModel = this.getModel("textStyle");
        this.resetItemSize();
        this.completeVisualOption();
    };
    /**
   * @protected
   */ VisualMapModel.prototype.resetVisual = function(supplementVisualOption) {
        var stateList = this.stateList;
        supplementVisualOption = $7a1bd9c2710fea0d$export$2385a24977818dd0(supplementVisualOption, this);
        this.controllerVisuals = $87ea23222d1c134e$export$89974527642f24a0(this.option.controller, stateList, supplementVisualOption);
        this.targetVisuals = $87ea23222d1c134e$export$89974527642f24a0(this.option.target, stateList, supplementVisualOption);
    };
    /**
   * @public
   */ VisualMapModel.prototype.getItemSymbol = function() {
        return null;
    };
    /**
   * @return An array of series indices.
   */ VisualMapModel.prototype.getTargetSeriesIndices = function() {
        var optionSeriesId = this.option.seriesId;
        var optionSeriesIndex = this.option.seriesIndex;
        if (optionSeriesIndex == null && optionSeriesId == null) optionSeriesIndex = "all";
        var seriesModels = $76d619f648247e6d$export$dc741340f7e5f186(this.ecModel, "series", {
            index: optionSeriesIndex,
            id: optionSeriesId
        }, {
            useDefault: false,
            enableAll: true,
            enableNone: false
        }).models;
        return $7a1bd9c2710fea0d$export$871de8747c9eaa88(seriesModels, function(seriesModel) {
            return seriesModel.componentIndex;
        });
    };
    /**
   * @public
   */ VisualMapModel.prototype.eachTargetSeries = function(callback, context) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this.getTargetSeriesIndices(), function(seriesIndex) {
            var seriesModel = this.ecModel.getSeriesByIndex(seriesIndex);
            if (seriesModel) callback.call(context, seriesModel);
        }, this);
    };
    /**
   * @pubilc
   */ VisualMapModel.prototype.isTargetSeries = function(seriesModel) {
        var is = false;
        this.eachTargetSeries(function(model) {
            model === seriesModel && (is = true);
        });
        return is;
    };
    /**
   * @example
   * this.formatValueText(someVal); // format single numeric value to text.
   * this.formatValueText(someVal, true); // format single category value to text.
   * this.formatValueText([min, max]); // format numeric min-max to text.
   * this.formatValueText([this.dataBound[0], max]); // using data lower bound.
   * this.formatValueText([min, this.dataBound[1]]); // using data upper bound.
   *
   * @param value Real value, or this.dataBound[0 or 1].
   * @param isCategory Only available when value is number.
   * @param edgeSymbols Open-close symbol when value is interval.
   * @protected
   */ VisualMapModel.prototype.formatValueText = function(value, isCategory, edgeSymbols) {
        var option = this.option;
        var precision = option.precision;
        var dataBound = this.dataBound;
        var formatter = option.formatter;
        var isMinMax;
        edgeSymbols = edgeSymbols || [
            "<",
            ">"
        ];
        if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(value)) {
            value = value.slice();
            isMinMax = true;
        }
        var textValue = isCategory ? value // Value is string when isCategory
         : isMinMax ? [
            toFixed(value[0]),
            toFixed(value[1])
        ] : toFixed(value);
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(formatter)) return formatter.replace("{value}", isMinMax ? textValue[0] : textValue).replace("{value2}", isMinMax ? textValue[1] : textValue);
        else if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(formatter)) return isMinMax ? formatter(value[0], value[1]) : formatter(value);
        if (isMinMax) {
            if (value[0] === dataBound[0]) return edgeSymbols[0] + " " + textValue[1];
            else if (value[1] === dataBound[1]) return edgeSymbols[1] + " " + textValue[0];
            else return textValue[0] + " - " + textValue[1];
        } else // Format single value (includes category case).
        return textValue;
        function toFixed(val) {
            return val === dataBound[0] ? "min" : val === dataBound[1] ? "max" : (+val).toFixed(Math.min(precision, 20));
        }
    };
    /**
   * @protected
   */ VisualMapModel.prototype.resetExtent = function() {
        var thisOption = this.option;
        // Can not calculate data extent by data here.
        // Because series and data may be modified in processing stage.
        // So we do not support the feature "auto min/max".
        var extent = $fca0c970f405ff38$var$asc([
            thisOption.min,
            thisOption.max
        ]);
        this._dataExtent = extent;
    };
    /**
   * PENDING:
   * delete this method if no outer usage.
   *
   * Return  Concrete dimension. If null/undefined is returned, no dimension is used.
   */ // getDataDimension(data: SeriesData) {
    //     const optDim = this.option.dimension;
    //     if (optDim != null) {
    //         return data.getDimension(optDim);
    //     }
    //     const dimNames = data.dimensions;
    //     for (let i = dimNames.length - 1; i >= 0; i--) {
    //         const dimName = dimNames[i];
    //         const dimInfo = data.getDimensionInfo(dimName);
    //         if (!dimInfo.isCalculationCoord) {
    //             return dimName;
    //         }
    //     }
    // }
    VisualMapModel.prototype.getDataDimensionIndex = function(data) {
        var optDim = this.option.dimension;
        if (optDim != null) return data.getDimensionIndex(optDim);
        var dimNames = data.dimensions;
        for(var i = dimNames.length - 1; i >= 0; i--){
            var dimName = dimNames[i];
            var dimInfo = data.getDimensionInfo(dimName);
            if (!dimInfo.isCalculationCoord) return dimInfo.storeDimIndex;
        }
    };
    VisualMapModel.prototype.getExtent = function() {
        return this._dataExtent.slice();
    };
    VisualMapModel.prototype.completeVisualOption = function() {
        var ecModel = this.ecModel;
        var thisOption = this.option;
        var base = {
            inRange: thisOption.inRange,
            outOfRange: thisOption.outOfRange
        };
        var target = thisOption.target || (thisOption.target = {});
        var controller = thisOption.controller || (thisOption.controller = {});
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(target, base); // Do not override
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(controller, base); // Do not override
        var isCategory = this.isCategory();
        completeSingle.call(this, target);
        completeSingle.call(this, controller);
        completeInactive.call(this, target, "inRange", "outOfRange");
        // completeInactive.call(this, target, 'outOfRange', 'inRange');
        completeController.call(this, controller);
        function completeSingle(base) {
            // Compatible with ec2 dataRange.color.
            // The mapping order of dataRange.color is: [high value, ..., low value]
            // whereas inRange.color and outOfRange.color is [low value, ..., high value]
            // Notice: ec2 has no inverse.
            if ($fca0c970f405ff38$var$isArray(thisOption.color) && !base.inRange) base.inRange = {
                color: thisOption.color.slice().reverse()
            };
            // Compatible with previous logic, always give a default color, otherwise
            // simple config with no inRange and outOfRange will not work.
            // Originally we use visualMap.color as the default color, but setOption at
            // the second time the default color will be erased. So we change to use
            // constant DEFAULT_COLOR.
            // If user do not want the default color, set inRange: {color: null}.
            base.inRange = base.inRange || {
                color: ecModel.get("gradientColor")
            };
        }
        function completeInactive(base, stateExist, stateAbsent) {
            var optExist = base[stateExist];
            var optAbsent = base[stateAbsent];
            if (optExist && !optAbsent) {
                optAbsent = base[stateAbsent] = {};
                $fca0c970f405ff38$var$each(optExist, function(visualData, visualType) {
                    if (!(0, $7b50f502cfd189d5$export$2e2bcd8739ae039).isValidType(visualType)) return;
                    var defa = (0, $ef3bd976f9d1f7a2$export$2e2bcd8739ae039).get(visualType, "inactive", isCategory);
                    if (defa != null) {
                        optAbsent[visualType] = defa;
                        // Compatibable with ec2:
                        // Only inactive color to rgba(0,0,0,0) can not
                        // make label transparent, so use opacity also.
                        if (visualType === "color" && !optAbsent.hasOwnProperty("opacity") && !optAbsent.hasOwnProperty("colorAlpha")) optAbsent.opacity = [
                            0,
                            0
                        ];
                    }
                });
            }
        }
        function completeController(controller) {
            var symbolExists = (controller.inRange || {}).symbol || (controller.outOfRange || {}).symbol;
            var symbolSizeExists = (controller.inRange || {}).symbolSize || (controller.outOfRange || {}).symbolSize;
            var inactiveColor = this.get("inactiveColor");
            var itemSymbol = this.getItemSymbol();
            var defaultSymbol = itemSymbol || "roundRect";
            $fca0c970f405ff38$var$each(this.stateList, function(state) {
                var itemSize = this.itemSize;
                var visuals = controller[state];
                // Set inactive color for controller if no other color
                // attr (like colorAlpha) specified.
                if (!visuals) visuals = controller[state] = {
                    color: isCategory ? inactiveColor : [
                        inactiveColor
                    ]
                };
                // Consistent symbol and symbolSize if not specified.
                if (visuals.symbol == null) visuals.symbol = symbolExists && $7a1bd9c2710fea0d$export$9cd59f9826255e47(symbolExists) || (isCategory ? defaultSymbol : [
                    defaultSymbol
                ]);
                if (visuals.symbolSize == null) visuals.symbolSize = symbolSizeExists && $7a1bd9c2710fea0d$export$9cd59f9826255e47(symbolSizeExists) || (isCategory ? itemSize[0] : [
                    itemSize[0],
                    itemSize[0]
                ]);
                // Filter none
                visuals.symbol = $fca0c970f405ff38$var$mapVisual(visuals.symbol, function(symbol) {
                    return symbol === "none" ? defaultSymbol : symbol;
                });
                // Normalize symbolSize
                var symbolSize = visuals.symbolSize;
                if (symbolSize != null) {
                    var max_1 = -Infinity;
                    // symbolSize can be object when categories defined.
                    $fca0c970f405ff38$var$eachVisual(symbolSize, function(value) {
                        value > max_1 && (max_1 = value);
                    });
                    visuals.symbolSize = $fca0c970f405ff38$var$mapVisual(symbolSize, function(value) {
                        return $fca0c970f405ff38$var$linearMap(value, [
                            0,
                            max_1
                        ], [
                            0,
                            itemSize[0]
                        ], true);
                    });
                }
            }, this);
        }
    };
    VisualMapModel.prototype.resetItemSize = function() {
        this.itemSize = [
            parseFloat(this.get("itemWidth")),
            parseFloat(this.get("itemHeight"))
        ];
    };
    VisualMapModel.prototype.isCategory = function() {
        return !!this.option.categories;
    };
    /**
   * @public
   * @abstract
   */ VisualMapModel.prototype.setSelected = function(selected) {};
    VisualMapModel.prototype.getSelected = function() {
        return null;
    };
    /**
   * @public
   * @abstract
   */ VisualMapModel.prototype.getValueState = function(value) {
        return null;
    };
    /**
   * FIXME
   * Do not publish to thirt-part-dev temporarily
   * util the interface is stable. (Should it return
   * a function but not visual meta?)
   *
   * @pubilc
   * @abstract
   * @param getColorVisual
   *        params: value, valueState
   *        return: color
   * @return {Object} visualMeta
   *        should includes {stops, outerColors}
   *        outerColor means [colorBeyondMinValue, colorBeyondMaxValue]
   */ VisualMapModel.prototype.getVisualMeta = function(getColorVisual) {
        return null;
    };
    VisualMapModel.type = "visualMap";
    VisualMapModel.dependencies = [
        "series"
    ];
    VisualMapModel.defaultOption = {
        show: true,
        // zlevel: 0,
        z: 4,
        // seriesIndex: 'all',
        min: 0,
        max: 200,
        left: 0,
        right: null,
        top: null,
        bottom: 0,
        itemWidth: null,
        itemHeight: null,
        inverse: false,
        orient: "vertical",
        backgroundColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.transparent,
        borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.borderTint,
        contentColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.theme[0],
        inactiveColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.disabled,
        borderWidth: 0,
        padding: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).size.m,
        // 接受数组分别设定上右下左边距，同css
        textGap: 10,
        precision: 0,
        textStyle: {
            color: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.secondary // 值域文字颜色
        }
    };
    return VisualMapModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $fca0c970f405ff38$export$2e2bcd8739ae039 = $fca0c970f405ff38$var$VisualMapModel;





// Constant
var $91b3756da4f00019$var$DEFAULT_BAR_BOUND = [
    20,
    140
];
var $91b3756da4f00019$var$ContinuousModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ContinuousModel, _super);
    function ContinuousModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ContinuousModel.type;
        return _this;
    }
    /**
   * @override
   */ ContinuousModel.prototype.optionUpdated = function(newOption, isInit) {
        _super.prototype.optionUpdated.apply(this, arguments);
        this.resetExtent();
        this.resetVisual(function(mappingOption) {
            mappingOption.mappingMethod = "linear";
            mappingOption.dataExtent = this.getExtent();
        });
        this._resetRange();
    };
    /**
   * @protected
   * @override
   */ ContinuousModel.prototype.resetItemSize = function() {
        _super.prototype.resetItemSize.apply(this, arguments);
        var itemSize = this.itemSize;
        (itemSize[0] == null || isNaN(itemSize[0])) && (itemSize[0] = $91b3756da4f00019$var$DEFAULT_BAR_BOUND[0]);
        (itemSize[1] == null || isNaN(itemSize[1])) && (itemSize[1] = $91b3756da4f00019$var$DEFAULT_BAR_BOUND[1]);
    };
    /**
   * @private
   */ ContinuousModel.prototype._resetRange = function() {
        var dataExtent = this.getExtent();
        var range = this.option.range;
        if (!range || range.auto) {
            // `range` should always be array (so we don't use other
            // value like 'auto') for user-friend. (consider getOption).
            dataExtent.auto = 1;
            this.option.range = dataExtent;
        } else if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(range)) {
            if (range[0] > range[1]) range.reverse();
            range[0] = Math.max(range[0], dataExtent[0]);
            range[1] = Math.min(range[1], dataExtent[1]);
        }
    };
    /**
   * @protected
   * @override
   */ ContinuousModel.prototype.completeVisualOption = function() {
        _super.prototype.completeVisualOption.apply(this, arguments);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this.stateList, function(state) {
            var symbolSize = this.option.controller[state].symbolSize;
            if (symbolSize && symbolSize[0] !== symbolSize[1]) symbolSize[0] = symbolSize[1] / 3; // For good looking.
        }, this);
    };
    /**
   * @override
   */ ContinuousModel.prototype.setSelected = function(selected) {
        this.option.range = selected.slice();
        this._resetRange();
    };
    /**
   * @public
   */ ContinuousModel.prototype.getSelected = function() {
        var dataExtent = this.getExtent();
        var dataInterval = $cfc1f3b422a3185f$export$debe6e778e0a6d32((this.get("range") || []).slice());
        // Clamp
        dataInterval[0] > dataExtent[1] && (dataInterval[0] = dataExtent[1]);
        dataInterval[1] > dataExtent[1] && (dataInterval[1] = dataExtent[1]);
        dataInterval[0] < dataExtent[0] && (dataInterval[0] = dataExtent[0]);
        dataInterval[1] < dataExtent[0] && (dataInterval[1] = dataExtent[0]);
        return dataInterval;
    };
    /**
   * @override
   */ ContinuousModel.prototype.getValueState = function(value) {
        var range = this.option.range;
        var dataExtent = this.getExtent();
        var unboundedRange = $7a1bd9c2710fea0d$export$995e01f2f5c9d030(this.option.unboundedRange, true);
        return (unboundedRange && range[0] <= dataExtent[0] || range[0] <= value) && (unboundedRange && range[1] >= dataExtent[1] || value <= range[1]) ? "inRange" : "outOfRange";
    };
    ContinuousModel.prototype.findTargetDataIndices = function(range) {
        var result = [];
        this.eachTargetSeries(function(seriesModel) {
            var dataIndices = [];
            var data = seriesModel.getData();
            data.each(this.getDataDimensionIndex(data), function(value, dataIndex) {
                range[0] <= value && value <= range[1] && dataIndices.push(dataIndex);
            }, this);
            result.push({
                seriesId: seriesModel.id,
                dataIndex: dataIndices
            });
        }, this);
        return result;
    };
    /**
   * @implement
   */ ContinuousModel.prototype.getVisualMeta = function(getColorVisual) {
        var oVals = $91b3756da4f00019$var$getColorStopValues(this, "outOfRange", this.getExtent());
        var iVals = $91b3756da4f00019$var$getColorStopValues(this, "inRange", this.option.range.slice());
        var stops = [];
        function setStop(value, valueState) {
            stops.push({
                value: value,
                color: getColorVisual(value, valueState)
            });
        }
        // Format to: outOfRange -- inRange -- outOfRange.
        var iIdx = 0;
        var oIdx = 0;
        var iLen = iVals.length;
        var oLen = oVals.length;
        for(; oIdx < oLen && (!iVals.length || oVals[oIdx] <= iVals[0]); oIdx++)// If oVal[oIdx] === iVals[iIdx], oVal[oIdx] should be ignored.
        if (oVals[oIdx] < iVals[iIdx]) setStop(oVals[oIdx], "outOfRange");
        for(var first = 1; iIdx < iLen; iIdx++, first = 0){
            // If range is full, value beyond min, max will be clamped.
            // make a singularity
            first && stops.length && setStop(iVals[iIdx], "outOfRange");
            setStop(iVals[iIdx], "inRange");
        }
        for(var first = 1; oIdx < oLen; oIdx++)if (!iVals.length || iVals[iVals.length - 1] < oVals[oIdx]) {
            // make a singularity
            if (first) {
                stops.length && setStop(stops[stops.length - 1].value, "outOfRange");
                first = 0;
            }
            setStop(oVals[oIdx], "outOfRange");
        }
        var stopsLen = stops.length;
        return {
            stops: stops,
            outerColors: [
                stopsLen ? stops[0].color : "transparent",
                stopsLen ? stops[stopsLen - 1].color : "transparent"
            ]
        };
    };
    ContinuousModel.type = "visualMap.continuous";
    ContinuousModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $fca0c970f405ff38$export$2e2bcd8739ae039).defaultOption, {
        align: "auto",
        calculable: false,
        hoverLink: true,
        realtime: true,
        handleIcon: "path://M-11.39,9.77h0a3.5,3.5,0,0,1-3.5,3.5h-22a3.5,3.5,0,0,1-3.5-3.5h0a3.5,3.5,0,0,1,3.5-3.5h22A3.5,3.5,0,0,1-11.39,9.77Z",
        handleSize: "120%",
        handleStyle: {
            borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral00,
            borderWidth: 1
        },
        indicatorIcon: "circle",
        indicatorSize: "50%",
        indicatorStyle: {
            borderColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.neutral00,
            borderWidth: 2,
            shadowBlur: 2,
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowColor: (0, $02653a4b1be313bf$export$2e2bcd8739ae039).color.shadow
        }
    });
    return ContinuousModel;
}((0, $fca0c970f405ff38$export$2e2bcd8739ae039));
function $91b3756da4f00019$var$getColorStopValues(visualMapModel, valueState, dataExtent) {
    if (dataExtent[0] === dataExtent[1]) return dataExtent.slice();
    // When using colorHue mapping, it is not linear color any more.
    // Moreover, canvas gradient seems not to be accurate linear.
    // FIXME
    // Should be arbitrary value 100? or based on pixel size?
    var count = 200;
    var step = (dataExtent[1] - dataExtent[0]) / count;
    var value = dataExtent[0];
    var stopValues = [];
    for(var i = 0; i <= count && value < dataExtent[1]; i++){
        stopValues.push(value);
        value += step;
    }
    stopValues.push(dataExtent[1]);
    return stopValues;
}
var $91b3756da4f00019$export$2e2bcd8739ae039 = $91b3756da4f00019$var$ContinuousModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $0eb56f276c16b145$var$VisualMapView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(VisualMapView, _super);
    function VisualMapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = VisualMapView.type;
        _this.autoPositionValues = {
            left: 1,
            right: 1,
            top: 1,
            bottom: 1
        };
        return _this;
    }
    VisualMapView.prototype.init = function(ecModel, api) {
        this.ecModel = ecModel;
        this.api = api;
    };
    /**
   * @protected
   */ VisualMapView.prototype.render = function(visualMapModel, ecModel, api, payload // TODO: TYPE
    ) {
        this.visualMapModel = visualMapModel;
        if (visualMapModel.get("show") === false) {
            this.group.removeAll();
            return;
        }
        this.doRender(visualMapModel, ecModel, api, payload);
    };
    /**
   * @protected
   */ VisualMapView.prototype.renderBackground = function(group) {
        var visualMapModel = this.visualMapModel;
        var padding = $c84c9521536c601a$export$f3a38102c49f4268(visualMapModel.get("padding") || 0);
        var rect = group.getBoundingRect();
        group.add(new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
            z2: -1,
            silent: true,
            shape: {
                x: rect.x - padding[3],
                y: rect.y - padding[0],
                width: rect.width + padding[3] + padding[1],
                height: rect.height + padding[0] + padding[2]
            },
            style: {
                fill: visualMapModel.get("backgroundColor"),
                stroke: visualMapModel.get("borderColor"),
                lineWidth: visualMapModel.get("borderWidth")
            }
        }));
    };
    /**
   * @protected
   * @param targetValue can be Infinity or -Infinity
   * @param visualCluster Only can be 'color' 'opacity' 'symbol' 'symbolSize'
   * @param opts
   * @param opts.forceState Specify state, instead of using getValueState method.
   * @param opts.convertOpacityToAlpha For color gradient in controller widget.
   * @return {*} Visual value.
   */ VisualMapView.prototype.getControllerVisual = function(targetValue, visualCluster, opts) {
        opts = opts || {};
        var forceState = opts.forceState;
        var visualMapModel = this.visualMapModel;
        var visualObj = {};
        // Default values.
        if (visualCluster === "color") {
            var defaultColor = visualMapModel.get("contentColor");
            visualObj.color = defaultColor;
        }
        function getter(key) {
            return visualObj[key];
        }
        function setter(key, value) {
            visualObj[key] = value;
        }
        var mappings = visualMapModel.controllerVisuals[forceState || visualMapModel.getValueState(targetValue)];
        var visualTypes = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).prepareVisualTypes(mappings);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(visualTypes, function(type) {
            var visualMapping = mappings[type];
            if (opts.convertOpacityToAlpha && type === "opacity") {
                type = "colorAlpha";
                visualMapping = mappings.__alphaForOpacity;
            }
            if ((0, $7b50f502cfd189d5$export$2e2bcd8739ae039).dependsOn(type, visualCluster)) visualMapping && visualMapping.applyVisual(targetValue, getter, setter);
        });
        return visualObj[visualCluster];
    };
    VisualMapView.prototype.positionGroup = function(group) {
        var model = this.visualMapModel;
        var api = this.api;
        var refContainer = $93b9bc7f22ac7369$export$5aec1e94f566e59f(model, api).refContainer;
        $93b9bc7f22ac7369$export$74054bd96b5eeef1(group, model.getBoxLayoutParams(), refContainer);
    };
    VisualMapView.prototype.doRender = function(visualMapModel, ecModel, api, payload) {};
    VisualMapView.type = "visualMap";
    return VisualMapView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $0eb56f276c16b145$export$2e2bcd8739ae039 = $0eb56f276c16b145$var$VisualMapView;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $1a17eb3ffb707117$var$paramsSet = [
    [
        "left",
        "right",
        "width"
    ],
    [
        "top",
        "bottom",
        "height"
    ]
];
function $1a17eb3ffb707117$export$dca53c4702e35c6(visualMapModel, api, itemSize) {
    var modelOption = visualMapModel.option;
    var itemAlign = modelOption.align;
    if (itemAlign != null && itemAlign !== "auto") return itemAlign;
    // Auto decision align.
    var ecSize = {
        width: api.getWidth(),
        height: api.getHeight()
    };
    var realIndex = modelOption.orient === "horizontal" ? 1 : 0;
    var reals = $1a17eb3ffb707117$var$paramsSet[realIndex];
    var fakeValue = [
        0,
        null,
        10
    ];
    var layoutInput = {};
    for(var i = 0; i < 3; i++){
        layoutInput[$1a17eb3ffb707117$var$paramsSet[1 - realIndex][i]] = fakeValue[i];
        layoutInput[reals[i]] = i === 2 ? itemSize[0] : modelOption[reals[i]];
    }
    var rParam = [
        [
            "x",
            "width",
            3
        ],
        [
            "y",
            "height",
            0
        ]
    ][realIndex];
    var rect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(layoutInput, ecSize, modelOption.padding);
    return reals[(rect.margin[rParam[2]] || 0) + rect[rParam[0]] + rect[rParam[1]] * 0.5 < ecSize[rParam[1]] * 0.5 ? 0 : 1];
}
function $1a17eb3ffb707117$export$5381a9dc5427ba18(batch, visualMapModel) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(batch || [], function(batchItem) {
        if (batchItem.dataIndex != null) {
            batchItem.dataIndexInside = batchItem.dataIndex;
            batchItem.dataIndex = null;
        }
        batchItem.highlightKey = "visualMap" + (visualMapModel ? visualMapModel.componentIndex : "");
    });
    return batch;
}










var $46b89608ba6c0e8b$var$linearMap = $cfc1f3b422a3185f$export$d3f68fbaa670562;
var $46b89608ba6c0e8b$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $46b89608ba6c0e8b$var$mathMin = Math.min;
var $46b89608ba6c0e8b$var$mathMax = Math.max;
// Arbitrary value
var $46b89608ba6c0e8b$var$HOVER_LINK_SIZE = 12;
var $46b89608ba6c0e8b$var$HOVER_LINK_OUT = 6;
// Notice:
// Any "interval" should be by the order of [low, high].
// "handle0" (handleIndex === 0) maps to
// low data value: this._dataInterval[0] and has low coord.
// "handle1" (handleIndex === 1) maps to
// high data value: this._dataInterval[1] and has high coord.
// The logic of transform is implemented in this._createBarGroup.
var $46b89608ba6c0e8b$var$ContinuousView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ContinuousView, _super);
    function ContinuousView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ContinuousView.type;
        _this._shapes = {};
        _this._dataInterval = [];
        _this._handleEnds = [];
        _this._hoverLinkDataIndices = [];
        return _this;
    }
    ContinuousView.prototype.init = function(ecModel, api) {
        _super.prototype.init.call(this, ecModel, api);
        this._hoverLinkFromSeriesMouseOver = $7a1bd9c2710fea0d$export$2385a24977818dd0(this._hoverLinkFromSeriesMouseOver, this);
        this._hideIndicator = $7a1bd9c2710fea0d$export$2385a24977818dd0(this._hideIndicator, this);
    };
    ContinuousView.prototype.doRender = function(visualMapModel, ecModel, api, payload) {
        if (!payload || payload.type !== "selectDataRange" || payload.from !== this.uid) this._buildView();
    };
    ContinuousView.prototype._buildView = function() {
        this.group.removeAll();
        var visualMapModel = this.visualMapModel;
        var thisGroup = this.group;
        this._orient = visualMapModel.get("orient");
        this._useHandle = visualMapModel.get("calculable");
        this._resetInterval();
        this._renderBar(thisGroup);
        var dataRangeText = visualMapModel.get("text");
        this._renderEndsText(thisGroup, dataRangeText, 0);
        this._renderEndsText(thisGroup, dataRangeText, 1);
        // Do this for background size calculation.
        this._updateView(true);
        // After updating view, inner shapes is built completely,
        // and then background can be rendered.
        this.renderBackground(thisGroup);
        // Real update view
        this._updateView();
        this._enableHoverLinkToSeries();
        this._enableHoverLinkFromSeries();
        this.positionGroup(thisGroup);
    };
    ContinuousView.prototype._renderEndsText = function(group, dataRangeText, endsIndex) {
        if (!dataRangeText) return;
        // Compatible with ec2, text[0] map to high value, text[1] map low value.
        var text = dataRangeText[1 - endsIndex];
        text = text != null ? text + "" : "";
        var visualMapModel = this.visualMapModel;
        var textGap = visualMapModel.get("textGap");
        var itemSize = visualMapModel.itemSize;
        var barGroup = this._shapes.mainGroup;
        var position = this._applyTransform([
            itemSize[0] / 2,
            endsIndex === 0 ? -textGap : itemSize[1] + textGap
        ], barGroup);
        var align = this._applyTransform(endsIndex === 0 ? "bottom" : "top", barGroup);
        var orient = this._orient;
        var textStyleModel = this.visualMapModel.textStyleModel;
        this.group.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                x: position[0],
                y: position[1],
                verticalAlign: textStyleModel.get("verticalAlign") || (orient === "horizontal" ? "middle" : align),
                align: textStyleModel.get("align") || (orient === "horizontal" ? align : "center"),
                text: text
            })
        }));
    };
    ContinuousView.prototype._renderBar = function(targetGroup) {
        var visualMapModel = this.visualMapModel;
        var shapes = this._shapes;
        var itemSize = visualMapModel.itemSize;
        var orient = this._orient;
        var useHandle = this._useHandle;
        var itemAlign = $1a17eb3ffb707117$export$dca53c4702e35c6(visualMapModel, this.api, itemSize);
        var mainGroup = shapes.mainGroup = this._createBarGroup(itemAlign);
        var gradientBarGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        mainGroup.add(gradientBarGroup);
        // Bar
        gradientBarGroup.add(shapes.outOfRange = $46b89608ba6c0e8b$var$createPolygon());
        gradientBarGroup.add(shapes.inRange = $46b89608ba6c0e8b$var$createPolygon(null, useHandle ? $46b89608ba6c0e8b$var$getCursor(this._orient) : null, $7a1bd9c2710fea0d$export$2385a24977818dd0(this._dragHandle, this, "all", false), $7a1bd9c2710fea0d$export$2385a24977818dd0(this._dragHandle, this, "all", true)));
        // A border radius clip.
        gradientBarGroup.setClipPath(new $419e5ff2f303755e$export$2e2bcd8739ae039({
            shape: {
                x: 0,
                y: 0,
                width: itemSize[0],
                height: itemSize[1],
                r: 3
            }
        }));
        var textRect = visualMapModel.textStyleModel.getTextRect("\u56FD");
        var textSize = $46b89608ba6c0e8b$var$mathMax(textRect.width, textRect.height);
        // Handle
        if (useHandle) {
            shapes.handleThumbs = [];
            shapes.handleLabels = [];
            shapes.handleLabelPoints = [];
            this._createHandle(visualMapModel, mainGroup, 0, itemSize, textSize, orient);
            this._createHandle(visualMapModel, mainGroup, 1, itemSize, textSize, orient);
        }
        this._createIndicator(visualMapModel, mainGroup, itemSize, textSize, orient);
        targetGroup.add(mainGroup);
    };
    ContinuousView.prototype._createHandle = function(visualMapModel, mainGroup, handleIndex, itemSize, textSize, orient) {
        var onDrift = $7a1bd9c2710fea0d$export$2385a24977818dd0(this._dragHandle, this, handleIndex, false);
        var onDragEnd = $7a1bd9c2710fea0d$export$2385a24977818dd0(this._dragHandle, this, handleIndex, true);
        var handleSize = (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(visualMapModel.get("handleSize"), itemSize[0]);
        var handleThumb = (0, $5370466dadc978d7$export$af050e04da3a02e8)(visualMapModel.get("handleIcon"), -handleSize / 2, -handleSize / 2, handleSize, handleSize, null, true);
        var cursor = $46b89608ba6c0e8b$var$getCursor(this._orient);
        handleThumb.attr({
            cursor: cursor,
            draggable: true,
            drift: onDrift,
            ondragend: onDragEnd,
            onmousemove: function(e) {
                $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
            }
        });
        handleThumb.x = itemSize[0] / 2;
        handleThumb.useStyle(visualMapModel.getModel("handleStyle").getItemStyle());
        handleThumb.setStyle({
            strokeNoScale: true,
            strokeFirst: true
        });
        handleThumb.style.lineWidth *= 2;
        handleThumb.ensureState("emphasis").style = visualMapModel.getModel([
            "emphasis",
            "handleStyle"
        ]).getItemStyle();
        (0, $2bf82c0980125b62$export$9ba15aea1e048d48)(handleThumb, true);
        mainGroup.add(handleThumb);
        // Text is always horizontal layout but should not be effected by
        // transform (orient/inverse). So label is built separately but not
        // use zrender/graphic/helper/RectText, and is located based on view
        // group (according to handleLabelPoint) but not barGroup.
        var textStyleModel = this.visualMapModel.textStyleModel;
        var handleLabel = new $fe885cc21795562b$export$2e2bcd8739ae039({
            cursor: cursor,
            draggable: true,
            drift: onDrift,
            onmousemove: function(e) {
                // For mobile device, prevent screen slider on the button.
                $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
            },
            ondragend: onDragEnd,
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                x: 0,
                y: 0,
                text: ""
            })
        });
        handleLabel.ensureState("blur").style = {
            opacity: 0.1
        };
        handleLabel.stateTransition = {
            duration: 200
        };
        this.group.add(handleLabel);
        var handleLabelPoint = [
            handleSize,
            0
        ];
        var shapes = this._shapes;
        shapes.handleThumbs[handleIndex] = handleThumb;
        shapes.handleLabelPoints[handleIndex] = handleLabelPoint;
        shapes.handleLabels[handleIndex] = handleLabel;
    };
    ContinuousView.prototype._createIndicator = function(visualMapModel, mainGroup, itemSize, textSize, orient) {
        var scale = (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(visualMapModel.get("indicatorSize"), itemSize[0]);
        var indicator = (0, $5370466dadc978d7$export$af050e04da3a02e8)(visualMapModel.get("indicatorIcon"), -scale / 2, -scale / 2, scale, scale, null, true);
        indicator.attr({
            cursor: "move",
            invisible: true,
            silent: true,
            x: itemSize[0] / 2
        });
        var indicatorStyle = visualMapModel.getModel("indicatorStyle").getItemStyle();
        if (indicator instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
            var pathStyle = indicator.style;
            indicator.useStyle($7a1bd9c2710fea0d$export$8b58be045bf06082({
                // TODO other properties like x, y ?
                image: pathStyle.image,
                x: pathStyle.x,
                y: pathStyle.y,
                width: pathStyle.width,
                height: pathStyle.height
            }, indicatorStyle));
        } else indicator.useStyle(indicatorStyle);
        mainGroup.add(indicator);
        var textStyleModel = this.visualMapModel.textStyleModel;
        var indicatorLabel = new $fe885cc21795562b$export$2e2bcd8739ae039({
            silent: true,
            invisible: true,
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                x: 0,
                y: 0,
                text: ""
            })
        });
        this.group.add(indicatorLabel);
        var indicatorLabelPoint = [
            (orient === "horizontal" ? textSize / 2 : $46b89608ba6c0e8b$var$HOVER_LINK_OUT) + itemSize[0] / 2,
            0
        ];
        var shapes = this._shapes;
        shapes.indicator = indicator;
        shapes.indicatorLabel = indicatorLabel;
        shapes.indicatorLabelPoint = indicatorLabelPoint;
        this._firstShowIndicator = true;
    };
    ContinuousView.prototype._dragHandle = function(handleIndex, isEnd, // dx is event from ondragend if isEnd is true. It's not used
    dx, dy) {
        if (!this._useHandle) return;
        this._dragging = !isEnd;
        if (!isEnd) {
            // Transform dx, dy to bar coordination.
            var vertex = this._applyTransform([
                dx,
                dy
            ], this._shapes.mainGroup, true);
            this._updateInterval(handleIndex, vertex[1]);
            this._hideIndicator();
            // Considering realtime, update view should be executed
            // before dispatch action.
            this._updateView();
        }
        // dragEnd do not dispatch action when realtime.
        if (isEnd === !this.visualMapModel.get("realtime")) // jshint ignore:line
        this.api.dispatchAction({
            type: "selectDataRange",
            from: this.uid,
            visualMapId: this.visualMapModel.id,
            selected: this._dataInterval.slice()
        });
        if (isEnd) !this._hovering && this._clearHoverLinkToSeries();
        else if ($46b89608ba6c0e8b$var$useHoverLinkOnHandle(this.visualMapModel)) this._doHoverLinkToSeries(this._handleEnds[handleIndex], false);
    };
    ContinuousView.prototype._resetInterval = function() {
        var visualMapModel = this.visualMapModel;
        var dataInterval = this._dataInterval = visualMapModel.getSelected();
        var dataExtent = visualMapModel.getExtent();
        var sizeExtent = [
            0,
            visualMapModel.itemSize[1]
        ];
        this._handleEnds = [
            $46b89608ba6c0e8b$var$linearMap(dataInterval[0], dataExtent, sizeExtent, true),
            $46b89608ba6c0e8b$var$linearMap(dataInterval[1], dataExtent, sizeExtent, true)
        ];
    };
    /**
   * @private
   * @param {(number|string)} handleIndex 0 or 1 or 'all'
   * @param {number} dx
   * @param {number} dy
   */ ContinuousView.prototype._updateInterval = function(handleIndex, delta) {
        delta = delta || 0;
        var visualMapModel = this.visualMapModel;
        var handleEnds = this._handleEnds;
        var sizeExtent = [
            0,
            visualMapModel.itemSize[1]
        ];
        (0, $00a8003b34293330$export$2e2bcd8739ae039)(delta, handleEnds, sizeExtent, handleIndex, // cross is forbidden
        0);
        var dataExtent = visualMapModel.getExtent();
        // Update data interval.
        this._dataInterval = [
            $46b89608ba6c0e8b$var$linearMap(handleEnds[0], sizeExtent, dataExtent, true),
            $46b89608ba6c0e8b$var$linearMap(handleEnds[1], sizeExtent, dataExtent, true)
        ];
    };
    ContinuousView.prototype._updateView = function(forSketch) {
        var visualMapModel = this.visualMapModel;
        var dataExtent = visualMapModel.getExtent();
        var shapes = this._shapes;
        var outOfRangeHandleEnds = [
            0,
            visualMapModel.itemSize[1]
        ];
        var inRangeHandleEnds = forSketch ? outOfRangeHandleEnds : this._handleEnds;
        var visualInRange = this._createBarVisual(this._dataInterval, dataExtent, inRangeHandleEnds, "inRange");
        var visualOutOfRange = this._createBarVisual(dataExtent, dataExtent, outOfRangeHandleEnds, "outOfRange");
        shapes.inRange.setStyle({
            fill: visualInRange.barColor
        }).setShape("points", visualInRange.barPoints);
        shapes.outOfRange.setStyle({
            fill: visualOutOfRange.barColor
        }).setShape("points", visualOutOfRange.barPoints);
        this._updateHandle(inRangeHandleEnds, visualInRange);
    };
    ContinuousView.prototype._createBarVisual = function(dataInterval, dataExtent, handleEnds, forceState) {
        var opts = {
            forceState: forceState,
            convertOpacityToAlpha: true
        };
        var colorStops = this._makeColorGradient(dataInterval, opts);
        var symbolSizes = [
            this.getControllerVisual(dataInterval[0], "symbolSize", opts),
            this.getControllerVisual(dataInterval[1], "symbolSize", opts)
        ];
        var barPoints = this._createBarPoints(handleEnds, symbolSizes);
        return {
            barColor: new (0, $cf44c01491b58e53$export$2e2bcd8739ae039)(0, 0, 0, 1, colorStops),
            barPoints: barPoints,
            handlesColor: [
                colorStops[0].color,
                colorStops[colorStops.length - 1].color
            ]
        };
    };
    ContinuousView.prototype._makeColorGradient = function(dataInterval, opts) {
        // Considering colorHue, which is not linear, so we have to sample
        // to calculate gradient color stops, but not only calculate head
        // and tail.
        var sampleNumber = 100; // Arbitrary value.
        var colorStops = [];
        var step = (dataInterval[1] - dataInterval[0]) / sampleNumber;
        colorStops.push({
            color: this.getControllerVisual(dataInterval[0], "color", opts),
            offset: 0
        });
        for(var i = 1; i < sampleNumber; i++){
            var currValue = dataInterval[0] + step * i;
            if (currValue > dataInterval[1]) break;
            colorStops.push({
                color: this.getControllerVisual(currValue, "color", opts),
                offset: i / sampleNumber
            });
        }
        colorStops.push({
            color: this.getControllerVisual(dataInterval[1], "color", opts),
            offset: 1
        });
        return colorStops;
    };
    ContinuousView.prototype._createBarPoints = function(handleEnds, symbolSizes) {
        var itemSize = this.visualMapModel.itemSize;
        return [
            [
                itemSize[0] - symbolSizes[0],
                handleEnds[0]
            ],
            [
                itemSize[0],
                handleEnds[0]
            ],
            [
                itemSize[0],
                handleEnds[1]
            ],
            [
                itemSize[0] - symbolSizes[1],
                handleEnds[1]
            ]
        ];
    };
    ContinuousView.prototype._createBarGroup = function(itemAlign) {
        var orient = this._orient;
        var inverse = this.visualMapModel.get("inverse");
        return new $7ef7583d8302ffce$export$2e2bcd8739ae039(orient === "horizontal" && !inverse ? {
            scaleX: itemAlign === "bottom" ? 1 : -1,
            rotation: Math.PI / 2
        } : orient === "horizontal" && inverse ? {
            scaleX: itemAlign === "bottom" ? -1 : 1,
            rotation: -Math.PI / 2
        } : orient === "vertical" && !inverse ? {
            scaleX: itemAlign === "left" ? 1 : -1,
            scaleY: -1
        } : {
            scaleX: itemAlign === "left" ? 1 : -1
        });
    };
    ContinuousView.prototype._updateHandle = function(handleEnds, visualInRange) {
        if (!this._useHandle) return;
        var shapes = this._shapes;
        var visualMapModel = this.visualMapModel;
        var handleThumbs = shapes.handleThumbs;
        var handleLabels = shapes.handleLabels;
        var itemSize = visualMapModel.itemSize;
        var dataExtent = visualMapModel.getExtent();
        var align = this._applyTransform("left", shapes.mainGroup);
        $46b89608ba6c0e8b$var$each([
            0,
            1
        ], function(handleIndex) {
            var handleThumb = handleThumbs[handleIndex];
            handleThumb.setStyle("fill", visualInRange.handlesColor[handleIndex]);
            handleThumb.y = handleEnds[handleIndex];
            var val = $46b89608ba6c0e8b$var$linearMap(handleEnds[handleIndex], [
                0,
                itemSize[1]
            ], dataExtent, true);
            var symbolSize = this.getControllerVisual(val, "symbolSize");
            handleThumb.scaleX = handleThumb.scaleY = symbolSize / itemSize[0];
            handleThumb.x = itemSize[0] - symbolSize / 2;
            // Update handle label position.
            var textPoint = $5b455ae6f843ac47$export$9f9dcb98c894b623(shapes.handleLabelPoints[handleIndex], $5b455ae6f843ac47$export$fce0c6cfca85ed96(handleThumb, this.group));
            if (this._orient === "horizontal") {
                // If visualMap controls symbol size, an additional offset needs to be added to labels to avoid collision at minimum size.
                // Offset reaches value of 0 at "maximum" position, so maximum position is not altered at all.
                var minimumOffset = align === "left" || align === "top" ? (itemSize[0] - symbolSize) / 2 : (itemSize[0] - symbolSize) / -2;
                textPoint[1] += minimumOffset;
            }
            handleLabels[handleIndex].setStyle({
                x: textPoint[0],
                y: textPoint[1],
                text: visualMapModel.formatValueText(this._dataInterval[handleIndex]),
                verticalAlign: "middle",
                align: this._orient === "vertical" ? this._applyTransform("left", shapes.mainGroup) : "center"
            });
        }, this);
    };
    ContinuousView.prototype._showIndicator = function(cursorValue, textValue, rangeSymbol, halfHoverLinkSize) {
        var visualMapModel = this.visualMapModel;
        var dataExtent = visualMapModel.getExtent();
        var itemSize = visualMapModel.itemSize;
        var sizeExtent = [
            0,
            itemSize[1]
        ];
        var shapes = this._shapes;
        var indicator = shapes.indicator;
        if (!indicator) return;
        indicator.attr("invisible", false);
        var opts = {
            convertOpacityToAlpha: true
        };
        var color = this.getControllerVisual(cursorValue, "color", opts);
        var symbolSize = this.getControllerVisual(cursorValue, "symbolSize");
        var y = $46b89608ba6c0e8b$var$linearMap(cursorValue, dataExtent, sizeExtent, true);
        var x = itemSize[0] - symbolSize / 2;
        var oldIndicatorPos = {
            x: indicator.x,
            y: indicator.y
        };
        // Update handle label position.
        indicator.y = y;
        indicator.x = x;
        var textPoint = $5b455ae6f843ac47$export$9f9dcb98c894b623(shapes.indicatorLabelPoint, $5b455ae6f843ac47$export$fce0c6cfca85ed96(indicator, this.group));
        var indicatorLabel = shapes.indicatorLabel;
        indicatorLabel.attr("invisible", false);
        var align = this._applyTransform("left", shapes.mainGroup);
        var orient = this._orient;
        var isHorizontal = orient === "horizontal";
        indicatorLabel.setStyle({
            text: (rangeSymbol ? rangeSymbol : "") + visualMapModel.formatValueText(textValue),
            verticalAlign: isHorizontal ? align : "middle",
            align: isHorizontal ? "center" : align
        });
        var indicatorNewProps = {
            x: x,
            y: y,
            style: {
                fill: color
            }
        };
        var labelNewProps = {
            style: {
                x: textPoint[0],
                y: textPoint[1]
            }
        };
        if (visualMapModel.ecModel.isAnimationEnabled() && !this._firstShowIndicator) {
            var animationCfg = {
                duration: 100,
                easing: "cubicInOut",
                additive: true
            };
            indicator.x = oldIndicatorPos.x;
            indicator.y = oldIndicatorPos.y;
            indicator.animateTo(indicatorNewProps, animationCfg);
            indicatorLabel.animateTo(labelNewProps, animationCfg);
        } else {
            indicator.attr(indicatorNewProps);
            indicatorLabel.attr(labelNewProps);
        }
        this._firstShowIndicator = false;
        var handleLabels = this._shapes.handleLabels;
        if (handleLabels) for(var i = 0; i < handleLabels.length; i++)// Fade out handle labels.
        // NOTE: Must use api enter/leave on emphasis/blur/select state. Or the global states manager will change it.
        this.api.enterBlur(handleLabels[i]);
    };
    ContinuousView.prototype._enableHoverLinkToSeries = function() {
        var self = this;
        this._shapes.mainGroup.on("mousemove", function(e) {
            self._hovering = true;
            if (!self._dragging) {
                var itemSize = self.visualMapModel.itemSize;
                var pos = self._applyTransform([
                    e.offsetX,
                    e.offsetY
                ], self._shapes.mainGroup, true, true);
                // For hover link show when hover handle, which might be
                // below or upper than sizeExtent.
                pos[1] = $46b89608ba6c0e8b$var$mathMin($46b89608ba6c0e8b$var$mathMax(0, pos[1]), itemSize[1]);
                self._doHoverLinkToSeries(pos[1], 0 <= pos[0] && pos[0] <= itemSize[0]);
            }
        }).on("mouseout", function() {
            // When mouse is out of handle, hoverLink still need
            // to be displayed when realtime is set as false.
            self._hovering = false;
            !self._dragging && self._clearHoverLinkToSeries();
        });
    };
    ContinuousView.prototype._enableHoverLinkFromSeries = function() {
        var zr = this.api.getZr();
        if (this.visualMapModel.option.hoverLink) {
            zr.on("mouseover", this._hoverLinkFromSeriesMouseOver, this);
            zr.on("mouseout", this._hideIndicator, this);
        } else this._clearHoverLinkFromSeries();
    };
    ContinuousView.prototype._doHoverLinkToSeries = function(cursorPos, hoverOnBar) {
        var visualMapModel = this.visualMapModel;
        var itemSize = visualMapModel.itemSize;
        if (!visualMapModel.option.hoverLink) return;
        var sizeExtent = [
            0,
            itemSize[1]
        ];
        var dataExtent = visualMapModel.getExtent();
        // For hover link show when hover handle, which might be below or upper than sizeExtent.
        cursorPos = $46b89608ba6c0e8b$var$mathMin($46b89608ba6c0e8b$var$mathMax(sizeExtent[0], cursorPos), sizeExtent[1]);
        var halfHoverLinkSize = $46b89608ba6c0e8b$var$getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent);
        var hoverRange = [
            cursorPos - halfHoverLinkSize,
            cursorPos + halfHoverLinkSize
        ];
        var cursorValue = $46b89608ba6c0e8b$var$linearMap(cursorPos, sizeExtent, dataExtent, true);
        var valueRange = [
            $46b89608ba6c0e8b$var$linearMap(hoverRange[0], sizeExtent, dataExtent, true),
            $46b89608ba6c0e8b$var$linearMap(hoverRange[1], sizeExtent, dataExtent, true)
        ];
        // Consider data range is out of visualMap range, see test/visualMap-continuous.html,
        // where china and india has very large population.
        hoverRange[0] < sizeExtent[0] && (valueRange[0] = -Infinity);
        hoverRange[1] > sizeExtent[1] && (valueRange[1] = Infinity);
        // Do not show indicator when mouse is over handle,
        // otherwise labels overlap, especially when dragging.
        if (hoverOnBar) {
            if (valueRange[0] === -Infinity) this._showIndicator(cursorValue, valueRange[1], "< ", halfHoverLinkSize);
            else if (valueRange[1] === Infinity) this._showIndicator(cursorValue, valueRange[0], "> ", halfHoverLinkSize);
            else this._showIndicator(cursorValue, cursorValue, "\u2248 ", halfHoverLinkSize);
        }
        // When realtime is set as false, handles, which are in barGroup,
        // also trigger hoverLink, which help user to realize where they
        // focus on when dragging. (see test/heatmap-large.html)
        // When realtime is set as true, highlight will not show when hover
        // handle, because the label on handle, which displays a exact value
        // but not range, might mislead users.
        var oldBatch = this._hoverLinkDataIndices;
        var newBatch = [];
        if (hoverOnBar || $46b89608ba6c0e8b$var$useHoverLinkOnHandle(visualMapModel)) newBatch = this._hoverLinkDataIndices = visualMapModel.findTargetDataIndices(valueRange);
        var resultBatches = $76d619f648247e6d$export$6d12cabb0c9bf8e3(oldBatch, newBatch);
        this._dispatchHighDown("downplay", $1a17eb3ffb707117$export$5381a9dc5427ba18(resultBatches[0], visualMapModel));
        this._dispatchHighDown("highlight", $1a17eb3ffb707117$export$5381a9dc5427ba18(resultBatches[1], visualMapModel));
    };
    ContinuousView.prototype._hoverLinkFromSeriesMouseOver = function(e) {
        var ecData;
        (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(e.target, function(target) {
            var currECData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(target);
            if (currECData.dataIndex != null) {
                ecData = currECData;
                return true;
            }
        }, true);
        if (!ecData) return;
        var dataModel = this.ecModel.getSeriesByIndex(ecData.seriesIndex);
        var visualMapModel = this.visualMapModel;
        if (!visualMapModel.isTargetSeries(dataModel)) return;
        var data = dataModel.getData(ecData.dataType);
        var value = data.getStore().get(visualMapModel.getDataDimensionIndex(data), ecData.dataIndex);
        if (!isNaN(value)) this._showIndicator(value, value);
    };
    ContinuousView.prototype._hideIndicator = function() {
        var shapes = this._shapes;
        shapes.indicator && shapes.indicator.attr("invisible", true);
        shapes.indicatorLabel && shapes.indicatorLabel.attr("invisible", true);
        var handleLabels = this._shapes.handleLabels;
        if (handleLabels) for(var i = 0; i < handleLabels.length; i++)// Fade out handle labels.
        // NOTE: Must use api enter/leave on emphasis/blur/select state. Or the global states manager will change it.
        this.api.leaveBlur(handleLabels[i]);
    };
    ContinuousView.prototype._clearHoverLinkToSeries = function() {
        this._hideIndicator();
        var indices = this._hoverLinkDataIndices;
        this._dispatchHighDown("downplay", $1a17eb3ffb707117$export$5381a9dc5427ba18(indices, this.visualMapModel));
        indices.length = 0;
    };
    ContinuousView.prototype._clearHoverLinkFromSeries = function() {
        this._hideIndicator();
        var zr = this.api.getZr();
        zr.off("mouseover", this._hoverLinkFromSeriesMouseOver);
        zr.off("mouseout", this._hideIndicator);
    };
    ContinuousView.prototype._applyTransform = function(vertex, element, inverse, global) {
        var transform = $5b455ae6f843ac47$export$fce0c6cfca85ed96(element, global ? null : this.group);
        return $7a1bd9c2710fea0d$export$43bee75e5e14138e(vertex) ? $5b455ae6f843ac47$export$9f9dcb98c894b623(vertex, transform, inverse) : $5b455ae6f843ac47$export$fff94e9792354cfa(vertex, transform, inverse);
    };
    // TODO: TYPE more specified payload types.
    ContinuousView.prototype._dispatchHighDown = function(type, batch) {
        batch && batch.length && this.api.dispatchAction({
            type: type,
            batch: batch
        });
    };
    /**
   * @override
   */ ContinuousView.prototype.dispose = function() {
        this._clearHoverLinkFromSeries();
        this._clearHoverLinkToSeries();
    };
    ContinuousView.type = "visualMap.continuous";
    return ContinuousView;
}((0, $0eb56f276c16b145$export$2e2bcd8739ae039));
function $46b89608ba6c0e8b$var$createPolygon(points, cursor, onDrift, onDragEnd) {
    return new $51acf033123e1a30$export$2e2bcd8739ae039({
        shape: {
            points: points
        },
        draggable: !!onDrift,
        cursor: cursor,
        drift: onDrift,
        onmousemove: function(e) {
            // For mobile device, prevent screen slider on the button.
            $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
        },
        ondragend: onDragEnd
    });
}
function $46b89608ba6c0e8b$var$getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent) {
    var halfHoverLinkSize = $46b89608ba6c0e8b$var$HOVER_LINK_SIZE / 2;
    var hoverLinkDataSize = visualMapModel.get("hoverLinkDataSize");
    if (hoverLinkDataSize) halfHoverLinkSize = $46b89608ba6c0e8b$var$linearMap(hoverLinkDataSize, dataExtent, sizeExtent, true) / 2;
    return halfHoverLinkSize;
}
function $46b89608ba6c0e8b$var$useHoverLinkOnHandle(visualMapModel) {
    var hoverLinkOnHandle = visualMapModel.get("hoverLinkOnHandle");
    return !!(hoverLinkOnHandle == null ? visualMapModel.get("realtime") : hoverLinkOnHandle);
}
function $46b89608ba6c0e8b$var$getCursor(orient) {
    return orient === "vertical" ? "ns-resize" : "ew-resize";
}
var $46b89608ba6c0e8b$export$2e2bcd8739ae039 = $46b89608ba6c0e8b$var$ContinuousView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $395ebe650d46f583$export$c5097295b52f5ecd = {
    type: "selectDataRange",
    event: "dataRangeSelected",
    // FIXME use updateView appears wrong
    update: "update"
};
var $395ebe650d46f583$export$8655c04a6fcbaa76 = function(payload, ecModel) {
    ecModel.eachComponent({
        mainType: "visualMap",
        query: payload
    }, function(model) {
        model.setSelected(payload.selected);
    });
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $561e4a618ab15558$export$5933e7c74ab358d1 = [
    {
        createOnAllSeries: true,
        reset: function(seriesModel, ecModel) {
            var resetDefines = [];
            ecModel.eachComponent("visualMap", function(visualMapModel) {
                var pipelineContext = seriesModel.pipelineContext;
                if (!visualMapModel.isTargetSeries(seriesModel) || pipelineContext && pipelineContext.large) return;
                resetDefines.push($87ea23222d1c134e$export$fc0ef8703cccf128(visualMapModel.stateList, visualMapModel.targetVisuals, $7a1bd9c2710fea0d$export$2385a24977818dd0(visualMapModel.getValueState, visualMapModel), visualMapModel.getDataDimensionIndex(seriesModel.getData())));
            });
            return resetDefines;
        }
    },
    // Only support color.
    {
        createOnAllSeries: true,
        reset: function(seriesModel, ecModel) {
            var data = seriesModel.getData();
            var visualMetaList = [];
            ecModel.eachComponent("visualMap", function(visualMapModel) {
                if (visualMapModel.isTargetSeries(seriesModel)) {
                    var visualMeta = visualMapModel.getVisualMeta($7a1bd9c2710fea0d$export$2385a24977818dd0($561e4a618ab15558$var$getColorVisual, null, seriesModel, visualMapModel)) || {
                        stops: [],
                        outerColors: []
                    };
                    var dimIdx = visualMapModel.getDataDimensionIndex(data);
                    if (dimIdx >= 0) {
                        // visualMeta.dimension should be dimension index, but not concrete dimension.
                        visualMeta.dimension = dimIdx;
                        visualMetaList.push(visualMeta);
                    }
                }
            });
            // console.log(JSON.stringify(visualMetaList.map(a => a.stops)));
            seriesModel.getData().setVisual("visualMeta", visualMetaList);
        }
    }
];
// FIXME
// performance and export for heatmap?
// value can be Infinity or -Infinity
function $561e4a618ab15558$var$getColorVisual(seriesModel, visualMapModel, value, valueState) {
    var mappings = visualMapModel.targetVisuals[valueState];
    var visualTypes = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).prepareVisualTypes(mappings);
    var resultVisual = {
        color: (0, $ea13f1ab2169d82d$export$d76e333a86ea1a2)(seriesModel.getData(), "color") // default color.
    };
    for(var i = 0, len = visualTypes.length; i < len; i++){
        var type = visualTypes[i];
        var mapping = mappings[type === "opacity" ? "__alphaForOpacity" : type];
        mapping && mapping.applyVisual(value, getVisual, setVisual);
    }
    return resultVisual.color;
    function getVisual(key) {
        return resultVisual[key];
    }
    function setVisual(key, value) {
        resultVisual[key] = value;
    }
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck

var $92519f6317138812$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
function $92519f6317138812$export$2e2bcd8739ae039(option) {
    var visualMap = option && option.visualMap;
    if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(visualMap)) visualMap = visualMap ? [
        visualMap
    ] : [];
    $92519f6317138812$var$each(visualMap, function(opt) {
        if (!opt) return;
        // rename splitList to pieces
        if ($92519f6317138812$var$has(opt, "splitList") && !$92519f6317138812$var$has(opt, "pieces")) {
            opt.pieces = opt.splitList;
            delete opt.splitList;
        }
        var pieces = opt.pieces;
        if (pieces && $7a1bd9c2710fea0d$export$43bee75e5e14138e(pieces)) $92519f6317138812$var$each(pieces, function(piece) {
            if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(piece)) {
                if ($92519f6317138812$var$has(piece, "start") && !$92519f6317138812$var$has(piece, "min")) piece.min = piece.start;
                if ($92519f6317138812$var$has(piece, "end") && !$92519f6317138812$var$has(piece, "max")) piece.max = piece.end;
            }
        });
    });
}
function $92519f6317138812$var$has(obj, name) {
    return obj && obj.hasOwnProperty && obj.hasOwnProperty(name);
}


var $769f929efa66b3be$var$installed = false;
function $769f929efa66b3be$export$2e2bcd8739ae039(registers) {
    if ($769f929efa66b3be$var$installed) return;
    $769f929efa66b3be$var$installed = true;
    registers.registerSubTypeDefaulter("visualMap", function(option) {
        // Compatible with ec2, when splitNumber === 0, continuous visualMap will be used.
        return !option.categories && (!(option.pieces ? option.pieces.length > 0 : option.splitNumber > 0) || option.calculable) ? "continuous" : "piecewise";
    });
    registers.registerAction((0, $395ebe650d46f583$export$c5097295b52f5ecd), (0, $395ebe650d46f583$export$8655c04a6fcbaa76));
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $561e4a618ab15558$export$5933e7c74ab358d1), function(handler) {
        registers.registerVisual(registers.PRIORITY.VISUAL.COMPONENT, handler);
    });
    registers.registerPreprocessor((0, $92519f6317138812$export$2e2bcd8739ae039));
}


function $a0f8a196dd8b4cba$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $91b3756da4f00019$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $46b89608ba6c0e8b$export$2e2bcd8739ae039));
    (0, $769f929efa66b3be$export$2e2bcd8739ae039)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $800f031000e0c641$var$PiecewiseModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PiecewiseModel, _super);
    function PiecewiseModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PiecewiseModel.type;
        /**
     * The order is always [low, ..., high].
     * [{text: string, interval: Array.<number>}, ...]
     */ _this._pieceList = [];
        return _this;
    }
    PiecewiseModel.prototype.optionUpdated = function(newOption, isInit) {
        _super.prototype.optionUpdated.apply(this, arguments);
        this.resetExtent();
        var mode = this._mode = this._determineMode();
        this._pieceList = [];
        $800f031000e0c641$var$resetMethods[this._mode].call(this, this._pieceList);
        this._resetSelected(newOption, isInit);
        var categories = this.option.categories;
        this.resetVisual(function(mappingOption, state) {
            if (mode === "categories") {
                mappingOption.mappingMethod = "category";
                mappingOption.categories = $7a1bd9c2710fea0d$export$9cd59f9826255e47(categories);
            } else {
                mappingOption.dataExtent = this.getExtent();
                mappingOption.mappingMethod = "piecewise";
                mappingOption.pieceList = $7a1bd9c2710fea0d$export$871de8747c9eaa88(this._pieceList, function(piece) {
                    piece = $7a1bd9c2710fea0d$export$9cd59f9826255e47(piece);
                    if (state !== "inRange") // FIXME
                    // outOfRange do not support special visual in pieces.
                    piece.visual = null;
                    return piece;
                });
            }
        });
    };
    /**
   * @protected
   * @override
   */ PiecewiseModel.prototype.completeVisualOption = function() {
        // Consider this case:
        // visualMap: {
        //      pieces: [{symbol: 'circle', lt: 0}, {symbol: 'rect', gte: 0}]
        // }
        // where no inRange/outOfRange set but only pieces. So we should make
        // default inRange/outOfRange for this case, otherwise visuals that only
        // appear in `pieces` will not be taken into account in visual encoding.
        var option = this.option;
        var visualTypesInPieces = {};
        var visualTypes = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).listVisualTypes();
        var isCategory = this.isCategory();
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(option.pieces, function(piece) {
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(visualTypes, function(visualType) {
                if (piece.hasOwnProperty(visualType)) visualTypesInPieces[visualType] = 1;
            });
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(visualTypesInPieces, function(v, visualType) {
            var exists = false;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(this.stateList, function(state) {
                exists = exists || has(option, state, visualType) || has(option.target, state, visualType);
            }, this);
            !exists && $7a1bd9c2710fea0d$export$79b2f7037acddd43(this.stateList, function(state) {
                (option[state] || (option[state] = {}))[visualType] = (0, $ef3bd976f9d1f7a2$export$2e2bcd8739ae039).get(visualType, state === "inRange" ? "active" : "inactive", isCategory);
            });
        }, this);
        function has(obj, state, visualType) {
            return obj && obj[state] && obj[state].hasOwnProperty(visualType);
        }
        _super.prototype.completeVisualOption.apply(this, arguments);
    };
    PiecewiseModel.prototype._resetSelected = function(newOption, isInit) {
        var thisOption = this.option;
        var pieceList = this._pieceList;
        // Selected do not merge but all override.
        var selected = (isInit ? thisOption : newOption).selected || {};
        thisOption.selected = selected;
        // Consider 'not specified' means true.
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(pieceList, function(piece, index) {
            var key = this.getSelectedMapKey(piece);
            if (!selected.hasOwnProperty(key)) selected[key] = true;
        }, this);
        if (thisOption.selectedMode === "single") {
            // Ensure there is only one selected.
            var hasSel_1 = false;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(pieceList, function(piece, index) {
                var key = this.getSelectedMapKey(piece);
                if (selected[key]) hasSel_1 ? selected[key] = false : hasSel_1 = true;
            }, this);
        }
    // thisOption.selectedMode === 'multiple', default: all selected.
    };
    /**
   * @public
   */ PiecewiseModel.prototype.getItemSymbol = function() {
        return this.get("itemSymbol");
    };
    /**
   * @public
   */ PiecewiseModel.prototype.getSelectedMapKey = function(piece) {
        return this._mode === "categories" ? piece.value + "" : piece.index + "";
    };
    /**
   * @public
   */ PiecewiseModel.prototype.getPieceList = function() {
        return this._pieceList;
    };
    /**
   * @return {string}
   */ PiecewiseModel.prototype._determineMode = function() {
        var option = this.option;
        return option.pieces && option.pieces.length > 0 ? "pieces" : this.option.categories ? "categories" : "splitNumber";
    };
    /**
   * @override
   */ PiecewiseModel.prototype.setSelected = function(selected) {
        this.option.selected = $7a1bd9c2710fea0d$export$9cd59f9826255e47(selected);
    };
    /**
   * @override
   */ PiecewiseModel.prototype.getValueState = function(value) {
        var index = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).findPieceIndex(value, this._pieceList);
        return index != null ? this.option.selected[this.getSelectedMapKey(this._pieceList[index])] ? "inRange" : "outOfRange" : "outOfRange";
    };
    /**
   * @public
   * @param pieceIndex piece index in visualMapModel.getPieceList()
   */ PiecewiseModel.prototype.findTargetDataIndices = function(pieceIndex) {
        var result = [];
        var pieceList = this._pieceList;
        this.eachTargetSeries(function(seriesModel) {
            var dataIndices = [];
            var data = seriesModel.getData();
            data.each(this.getDataDimensionIndex(data), function(value, dataIndex) {
                // Should always base on model pieceList, because it is order sensitive.
                var pIdx = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).findPieceIndex(value, pieceList);
                pIdx === pieceIndex && dataIndices.push(dataIndex);
            }, this);
            result.push({
                seriesId: seriesModel.id,
                dataIndex: dataIndices
            });
        }, this);
        return result;
    };
    /**
   * @private
   * @param piece piece.value or piece.interval is required.
   * @return  Can be Infinity or -Infinity
   */ PiecewiseModel.prototype.getRepresentValue = function(piece) {
        var representValue;
        if (this.isCategory()) representValue = piece.value;
        else if (piece.value != null) representValue = piece.value;
        else {
            var pieceInterval = piece.interval || [];
            representValue = pieceInterval[0] === -Infinity && pieceInterval[1] === Infinity ? 0 : (pieceInterval[0] + pieceInterval[1]) / 2;
        }
        return representValue;
    };
    PiecewiseModel.prototype.getVisualMeta = function(getColorVisual) {
        // Do not support category. (category axis is ordinal, numerical)
        if (this.isCategory()) return;
        var stops = [];
        var outerColors = [
            "",
            ""
        ];
        var visualMapModel = this;
        function setStop(interval, valueState) {
            var representValue = visualMapModel.getRepresentValue({
                interval: interval
            }); // Not category
            if (!valueState) valueState = visualMapModel.getValueState(representValue);
            var color = getColorVisual(representValue, valueState);
            if (interval[0] === -Infinity) outerColors[0] = color;
            else if (interval[1] === Infinity) outerColors[1] = color;
            else stops.push({
                value: interval[0],
                color: color
            }, {
                value: interval[1],
                color: color
            });
        }
        // Suplement
        var pieceList = this._pieceList.slice();
        if (!pieceList.length) pieceList.push({
            interval: [
                -Infinity,
                Infinity
            ]
        });
        else {
            var edge = pieceList[0].interval[0];
            edge !== -Infinity && pieceList.unshift({
                interval: [
                    -Infinity,
                    edge
                ]
            });
            edge = pieceList[pieceList.length - 1].interval[1];
            edge !== Infinity && pieceList.push({
                interval: [
                    edge,
                    Infinity
                ]
            });
        }
        var curr = -Infinity;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(pieceList, function(piece) {
            var interval = piece.interval;
            if (interval) {
                // Fulfill gap.
                interval[0] > curr && setStop([
                    curr,
                    interval[0]
                ], "outOfRange");
                setStop(interval.slice());
                curr = interval[1];
            }
        }, this);
        return {
            stops: stops,
            outerColors: outerColors
        };
    };
    PiecewiseModel.type = "visualMap.piecewise";
    PiecewiseModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $fca0c970f405ff38$export$2e2bcd8739ae039).defaultOption, {
        selected: null,
        minOpen: false,
        maxOpen: false,
        align: "auto",
        itemWidth: 20,
        itemHeight: 14,
        itemSymbol: "roundRect",
        pieces: null,
        categories: null,
        splitNumber: 5,
        selectedMode: "multiple",
        itemGap: 10,
        hoverLink: true // Enable hover highlight.
    });
    return PiecewiseModel;
}((0, $fca0c970f405ff38$export$2e2bcd8739ae039));
/**
 * Key is this._mode
 * @type {Object}
 * @this {module:echarts/component/viusalMap/PiecewiseMode}
 */ var $800f031000e0c641$var$resetMethods = {
    splitNumber: function(outPieceList) {
        var thisOption = this.option;
        var precision = Math.min(thisOption.precision, 20);
        var dataExtent = this.getExtent();
        var splitNumber = thisOption.splitNumber;
        splitNumber = Math.max(parseInt(splitNumber, 10), 1);
        thisOption.splitNumber = splitNumber;
        var splitStep = (dataExtent[1] - dataExtent[0]) / splitNumber;
        // Precision auto-adaption
        while(+splitStep.toFixed(precision) !== splitStep && precision < 5)precision++;
        thisOption.precision = precision;
        splitStep = +splitStep.toFixed(precision);
        if (thisOption.minOpen) outPieceList.push({
            interval: [
                -Infinity,
                dataExtent[0]
            ],
            close: [
                0,
                0
            ]
        });
        for(var index = 0, curr = dataExtent[0]; index < splitNumber; curr += splitStep, index++){
            var max = index === splitNumber - 1 ? dataExtent[1] : curr + splitStep;
            outPieceList.push({
                interval: [
                    curr,
                    max
                ],
                close: [
                    1,
                    1
                ]
            });
        }
        if (thisOption.maxOpen) outPieceList.push({
            interval: [
                dataExtent[1],
                Infinity
            ],
            close: [
                0,
                0
            ]
        });
        (0, $cfc1f3b422a3185f$export$12f7386070bc380a)(outPieceList);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(outPieceList, function(piece, index) {
            piece.index = index;
            piece.text = this.formatValueText(piece.interval);
        }, this);
    },
    categories: function(outPieceList) {
        var thisOption = this.option;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(thisOption.categories, function(cate) {
            // FIXME category模式也使用pieceList，但在visualMapping中不是使用pieceList。
            // 是否改一致。
            outPieceList.push({
                text: this.formatValueText(cate, true),
                value: cate
            });
        }, this);
        // See "Order Rule".
        $800f031000e0c641$var$normalizeReverse(thisOption, outPieceList);
    },
    pieces: function(outPieceList) {
        var thisOption = this.option;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(thisOption.pieces, function(pieceListItem, index) {
            if (!$7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(pieceListItem)) pieceListItem = {
                value: pieceListItem
            };
            var item = {
                text: "",
                index: index
            };
            if (pieceListItem.label != null) item.text = pieceListItem.label;
            if (pieceListItem.hasOwnProperty("value")) {
                var value = item.value = pieceListItem.value;
                item.interval = [
                    value,
                    value
                ];
                item.close = [
                    1,
                    1
                ];
            } else {
                // `min` `max` is legacy option.
                // `lt` `gt` `lte` `gte` is recommended.
                var interval = item.interval = [];
                var close_1 = item.close = [
                    0,
                    0
                ];
                var closeList = [
                    1,
                    0,
                    1
                ];
                var infinityList = [
                    -Infinity,
                    Infinity
                ];
                var useMinMax = [];
                for(var lg = 0; lg < 2; lg++){
                    var names = [
                        [
                            "gte",
                            "gt",
                            "min"
                        ],
                        [
                            "lte",
                            "lt",
                            "max"
                        ]
                    ][lg];
                    for(var i = 0; i < 3 && interval[lg] == null; i++){
                        interval[lg] = pieceListItem[names[i]];
                        close_1[lg] = closeList[i];
                        useMinMax[lg] = i === 2;
                    }
                    interval[lg] == null && (interval[lg] = infinityList[lg]);
                }
                useMinMax[0] && interval[1] === Infinity && (close_1[0] = 0);
                useMinMax[1] && interval[0] === -Infinity && (close_1[1] = 0);
                if (interval[0] === interval[1] && close_1[0] && close_1[1]) // Consider: [{min: 5, max: 5, visual: {...}}, {min: 0, max: 5}],
                // we use value to lift the priority when min === max
                item.value = interval[0];
            }
            item.visual = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).retrieveVisuals(pieceListItem);
            outPieceList.push(item);
        }, this);
        // See "Order Rule".
        $800f031000e0c641$var$normalizeReverse(thisOption, outPieceList);
        // Only pieces
        (0, $cfc1f3b422a3185f$export$12f7386070bc380a)(outPieceList);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(outPieceList, function(piece) {
            var close = piece.close;
            var edgeSymbols = [
                [
                    "<",
                    "\u2264"
                ][close[1]],
                [
                    ">",
                    "\u2265"
                ][close[0]]
            ];
            piece.text = piece.text || this.formatValueText(piece.value != null ? piece.value : piece.interval, false, edgeSymbols);
        }, this);
    }
};
function $800f031000e0c641$var$normalizeReverse(thisOption, pieceList) {
    var inverse = thisOption.inverse;
    if (thisOption.orient === "vertical" ? !inverse : inverse) pieceList.reverse();
}
var $800f031000e0c641$export$2e2bcd8739ae039 = $800f031000e0c641$var$PiecewiseModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $54f263ebb7934a99$var$PiecewiseVisualMapView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PiecewiseVisualMapView, _super);
    function PiecewiseVisualMapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PiecewiseVisualMapView.type;
        return _this;
    }
    PiecewiseVisualMapView.prototype.doRender = function() {
        var thisGroup = this.group;
        thisGroup.removeAll();
        var visualMapModel = this.visualMapModel;
        var textGap = visualMapModel.get("textGap");
        var textStyleModel = visualMapModel.textStyleModel;
        var itemAlign = this._getItemAlign();
        var itemSize = visualMapModel.itemSize;
        var viewData = this._getViewData();
        var endsText = viewData.endsText;
        var showLabel = $7a1bd9c2710fea0d$export$8a4d17b6e8486e66(visualMapModel.get("showLabel", true), !endsText);
        var silent = !visualMapModel.get("selectedMode");
        endsText && this._renderEndsText(thisGroup, endsText[0], itemSize, showLabel, itemAlign);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(viewData.viewPieceList, function(item) {
            var piece = item.piece;
            var itemGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
            itemGroup.onclick = $7a1bd9c2710fea0d$export$2385a24977818dd0(this._onItemClick, this, piece);
            this._enableHoverLink(itemGroup, item.indexInModelPieceList);
            // TODO Category
            var representValue = visualMapModel.getRepresentValue(piece);
            this._createItemSymbol(itemGroup, representValue, [
                0,
                0,
                itemSize[0],
                itemSize[1]
            ], silent);
            if (showLabel) {
                var visualState = this.visualMapModel.getValueState(representValue);
                var align = textStyleModel.get("align") || itemAlign;
                itemGroup.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
                    style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                        x: align === "right" ? -textGap : itemSize[0] + textGap,
                        y: itemSize[1] / 2,
                        text: piece.text,
                        verticalAlign: textStyleModel.get("verticalAlign") || "middle",
                        align: align,
                        opacity: $7a1bd9c2710fea0d$export$995e01f2f5c9d030(textStyleModel.get("opacity"), visualState === "outOfRange" ? 0.5 : 1)
                    }),
                    silent: silent
                }));
            }
            thisGroup.add(itemGroup);
        }, this);
        endsText && this._renderEndsText(thisGroup, endsText[1], itemSize, showLabel, itemAlign);
        $93b9bc7f22ac7369$export$827f4ee28efc37(visualMapModel.get("orient"), thisGroup, visualMapModel.get("itemGap"));
        this.renderBackground(thisGroup);
        this.positionGroup(thisGroup);
    };
    PiecewiseVisualMapView.prototype._enableHoverLink = function(itemGroup, pieceIndex) {
        var _this = this;
        itemGroup.on("mouseover", function() {
            return onHoverLink("highlight");
        }).on("mouseout", function() {
            return onHoverLink("downplay");
        });
        var onHoverLink = function(method) {
            var visualMapModel = _this.visualMapModel;
            // TODO: TYPE More detailed action types
            visualMapModel.option.hoverLink && _this.api.dispatchAction({
                type: method,
                batch: $1a17eb3ffb707117$export$5381a9dc5427ba18(visualMapModel.findTargetDataIndices(pieceIndex), visualMapModel)
            });
        };
    };
    PiecewiseVisualMapView.prototype._getItemAlign = function() {
        var visualMapModel = this.visualMapModel;
        var modelOption = visualMapModel.option;
        if (modelOption.orient === "vertical") return $1a17eb3ffb707117$export$dca53c4702e35c6(visualMapModel, this.api, visualMapModel.itemSize);
        else {
            // horizontal, most case left unless specifying right.
            var align = modelOption.align;
            if (!align || align === "auto") align = "left";
            return align;
        }
    };
    PiecewiseVisualMapView.prototype._renderEndsText = function(group, text, itemSize, showLabel, itemAlign) {
        if (!text) return;
        var itemGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        var textStyleModel = this.visualMapModel.textStyleModel;
        itemGroup.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                x: showLabel ? itemAlign === "right" ? itemSize[0] : 0 : itemSize[0] / 2,
                y: itemSize[1] / 2,
                verticalAlign: "middle",
                align: showLabel ? itemAlign : "center",
                text: text
            })
        }));
        group.add(itemGroup);
    };
    /**
   * @private
   * @return {Object} {peiceList, endsText} The order is the same as screen pixel order.
   */ PiecewiseVisualMapView.prototype._getViewData = function() {
        var visualMapModel = this.visualMapModel;
        var viewPieceList = $7a1bd9c2710fea0d$export$871de8747c9eaa88(visualMapModel.getPieceList(), function(piece, index) {
            return {
                piece: piece,
                indexInModelPieceList: index
            };
        });
        var endsText = visualMapModel.get("text");
        // Consider orient and inverse.
        var orient = visualMapModel.get("orient");
        var inverse = visualMapModel.get("inverse");
        // Order of model pieceList is always [low, ..., high]
        if (orient === "horizontal" ? inverse : !inverse) viewPieceList.reverse();
        else if (endsText) endsText = endsText.slice().reverse();
        return {
            viewPieceList: viewPieceList,
            endsText: endsText
        };
    };
    PiecewiseVisualMapView.prototype._createItemSymbol = function(group, representValue, shapeParam, silent) {
        var itemSymbol = (0, $5370466dadc978d7$export$af050e04da3a02e8)(// symbol will be string
        this.getControllerVisual(representValue, "symbol"), shapeParam[0], shapeParam[1], shapeParam[2], shapeParam[3], // color will be string
        this.getControllerVisual(representValue, "color"));
        itemSymbol.silent = silent;
        group.add(itemSymbol);
    };
    PiecewiseVisualMapView.prototype._onItemClick = function(piece) {
        var visualMapModel = this.visualMapModel;
        var option = visualMapModel.option;
        var selectedMode = option.selectedMode;
        if (!selectedMode) return;
        var selected = $7a1bd9c2710fea0d$export$9cd59f9826255e47(option.selected);
        var newKey = visualMapModel.getSelectedMapKey(piece);
        if (selectedMode === "single" || selectedMode === true) {
            selected[newKey] = true;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(selected, function(o, key) {
                selected[key] = key === newKey;
            });
        } else selected[newKey] = !selected[newKey];
        this.api.dispatchAction({
            type: "selectDataRange",
            from: this.uid,
            visualMapId: this.visualMapModel.id,
            selected: selected
        });
    };
    PiecewiseVisualMapView.type = "visualMap.piecewise";
    return PiecewiseVisualMapView;
}((0, $0eb56f276c16b145$export$2e2bcd8739ae039));
var $54f263ebb7934a99$export$2e2bcd8739ae039 = $54f263ebb7934a99$var$PiecewiseVisualMapView;



function $312d2d640a7c60e1$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $800f031000e0c641$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $54f263ebb7934a99$export$2e2bcd8739ae039));
    (0, $769f929efa66b3be$export$2e2bcd8739ae039)(registers);
}


function $1df0d53aa7db8747$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $a0f8a196dd8b4cba$export$4b3e715f166fdd78));
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $312d2d640a7c60e1$export$4b3e715f166fdd78));
// Do not install './dataZoomSelect',
// since it only work for toolbox dataZoom.
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/**
 * @caution
 *  Must not export anything except `installScaleBreakHelper`
 */ var $ee3a60bafdecc6ba$var$ScaleBreakContextImpl = /** @class */ function() {
    function ScaleBreakContextImpl() {
        // [CAVEAT]: Should set only by `ScaleBreakContext#setBreaks`!
        this.breaks = [];
        // [CAVEAT]: Should update only by `ScaleBreakContext#update`!
        // They are the values that scaleExtent[0] and scaleExtent[1] are mapped to a numeric axis
        // that breaks are applied, primarily for optimization of `Scale#normalize`.
        this._elapsedExtent = [
            Infinity,
            -Infinity
        ];
    }
    ScaleBreakContextImpl.prototype.setBreaks = function(parsed) {
        // @ts-ignore
        this.breaks = parsed.breaks;
    };
    /**
   * [CAVEAT]: Must be called immediately each time scale extent and breaks are updated!
   */ ScaleBreakContextImpl.prototype.update = function(scaleExtent) {
        $ee3a60bafdecc6ba$var$updateAxisBreakGapReal(this, scaleExtent);
        var elapsedExtent = this._elapsedExtent;
        elapsedExtent[0] = this.elapse(scaleExtent[0]);
        elapsedExtent[1] = this.elapse(scaleExtent[1]);
    };
    ScaleBreakContextImpl.prototype.hasBreaks = function() {
        return !!this.breaks.length;
    };
    /**
   * When iteratively generating ticks by nice interval, currently the `interval`, which is
   * calculated by break-elapsed extent span, is probably very small comparing to the original
   * extent, leading to a large number of iteration and tick generation, even over `safeLimit`.
   * Thus stepping over breaks is necessary in that loop.
   *
   * "Nice" should be ensured on ticks when step over the breaks. Thus this method returns
   * a integer multiple of the "nice tick interval".
   *
   * This method does little work; it is just for unifying and restricting the behavior.
   */ ScaleBreakContextImpl.prototype.calcNiceTickMultiple = function(tickVal, estimateNiceMultiple) {
        for(var idx = 0; idx < this.breaks.length; idx++){
            var brk = this.breaks[idx];
            if (brk.vmin < tickVal && tickVal < brk.vmax) {
                var multiple = estimateNiceMultiple(tickVal, brk.vmax);
                return multiple;
            }
        }
        return 0;
    };
    ScaleBreakContextImpl.prototype.getExtentSpan = function() {
        return this._elapsedExtent[1] - this._elapsedExtent[0];
    };
    ScaleBreakContextImpl.prototype.normalize = function(val) {
        var elapsedSpan = this._elapsedExtent[1] - this._elapsedExtent[0];
        // The same logic as `Scale#normalize`.
        if (elapsedSpan === 0) return 0.5;
        return (this.elapse(val) - this._elapsedExtent[0]) / elapsedSpan;
    };
    ScaleBreakContextImpl.prototype.scale = function(val) {
        return this.unelapse(val * (this._elapsedExtent[1] - this._elapsedExtent[0]) + this._elapsedExtent[0]);
    };
    /**
   * Suppose:
   *    AXIS_BREAK_LAST_BREAK_END_BASE: 0
   *    AXIS_BREAK_ELAPSED_BASE: 0
   *    breaks: [
   *        {start: -400, end: -300, gap: 27},
   *        {start: -100, end: 100, gap: 10},
   *        {start: 200, end: 400, gap: 300},
   *    ]
   * The mapping will be:
   *        |        |
   *    400 +   ->   +  237
   *     |  |        |   |  (gap: 300)
   *    200 +   ->   + -63
   *        |        |
   *    100 +   ->   + -163
   *     |  |        |   |  (gap: 10)
   *   -100 +   ->   + -173
   *        |        |
   *   -300 +   ->   + -373
   *     |  |        |   |  (gap: 27)
   *   -400 +   ->   + -400
   *        |        |
   *   origianl     elapsed
   *
   * Note:
   *   The mapping has nothing to do with "scale extent".
   */ ScaleBreakContextImpl.prototype.elapse = function(val) {
        // If the value is in the break, return the normalized value in the break
        var elapsedVal = $ee3a60bafdecc6ba$var$AXIS_BREAK_ELAPSED_BASE;
        var lastBreakEnd = $ee3a60bafdecc6ba$var$AXIS_BREAK_LAST_BREAK_END_BASE;
        var stillOver = true;
        for(var i = 0; i < this.breaks.length; i++){
            var brk = this.breaks[i];
            if (val <= brk.vmax) {
                if (val > brk.vmin) elapsedVal += brk.vmin - lastBreakEnd + (val - brk.vmin) / (brk.vmax - brk.vmin) * brk.gapReal;
                else elapsedVal += val - lastBreakEnd;
                lastBreakEnd = brk.vmax;
                stillOver = false;
                break;
            }
            elapsedVal += brk.vmin - lastBreakEnd + brk.gapReal;
            lastBreakEnd = brk.vmax;
        }
        if (stillOver) elapsedVal += val - lastBreakEnd;
        return elapsedVal;
    };
    ScaleBreakContextImpl.prototype.unelapse = function(elapsedVal) {
        var lastElapsedEnd = $ee3a60bafdecc6ba$var$AXIS_BREAK_ELAPSED_BASE;
        var lastBreakEnd = $ee3a60bafdecc6ba$var$AXIS_BREAK_LAST_BREAK_END_BASE;
        var stillOver = true;
        var unelapsedVal = 0;
        for(var i = 0; i < this.breaks.length; i++){
            var brk = this.breaks[i];
            var elapsedStart = lastElapsedEnd + brk.vmin - lastBreakEnd;
            var elapsedEnd = elapsedStart + brk.gapReal;
            if (elapsedVal <= elapsedEnd) {
                if (elapsedVal > elapsedStart) unelapsedVal = brk.vmin + (elapsedVal - elapsedStart) / (elapsedEnd - elapsedStart) * (brk.vmax - brk.vmin);
                else unelapsedVal = lastBreakEnd + elapsedVal - lastElapsedEnd;
                lastBreakEnd = brk.vmax;
                stillOver = false;
                break;
            }
            lastElapsedEnd = elapsedEnd;
            lastBreakEnd = brk.vmax;
        }
        if (stillOver) unelapsedVal = lastBreakEnd + elapsedVal - lastElapsedEnd;
        return unelapsedVal;
    };
    return ScaleBreakContextImpl;
}();
function $ee3a60bafdecc6ba$var$createScaleBreakContext() {
    return new $ee3a60bafdecc6ba$var$ScaleBreakContextImpl();
}
// Both can start with any finite value, and are not necessaryily equal. But they need to
// be the same in `axisBreakElapse` and `axisBreakUnelapse` respectively.
var $ee3a60bafdecc6ba$var$AXIS_BREAK_ELAPSED_BASE = 0;
var $ee3a60bafdecc6ba$var$AXIS_BREAK_LAST_BREAK_END_BASE = 0;
/**
 * `gapReal` in brkCtx.breaks will be calculated.
 */ function $ee3a60bafdecc6ba$var$updateAxisBreakGapReal(brkCtx, scaleExtent) {
    // Considered the effect:
    //  - Use dataZoom to move some of the breaks outside the extent.
    //  - Some scenarios that `series.clip: false`.
    //
    // How to calculate `prctBrksGapRealSum`:
    //  Based on the formula:
    //      xxx.span = brk.vmax - brk.vmin
    //      xxx.tpPrct.val / xxx.tpAbs.val means ParsedAxisBreak['gapParsed']['val']
    //      .S/.E means a break that is semi in scaleExtent[0] or scaleExtent[1]
    //      valP = (
    //          + (fullyInExtBrksSum.tpAbs.gapReal - fullyInExtBrksSum.tpAbs.span)
    //          + (semiInExtBrk.S.tpAbs.gapReal - semiInExtBrk.S.tpAbs.span) * semiInExtBrk.S.tpAbs.inExtFrac
    //          + (semiInExtBrk.E.tpAbs.gapReal - semiInExtBrk.E.tpAbs.span) * semiInExtBrk.E.tpAbs.inExtFrac
    //      )
    //      valQ = (
    //          - fullyInExtBrksSum.tpPrct.span
    //          - semiInExtBrk.S.tpPrct.span * semiInExtBrk.S.tpPrct.inExtFrac
    //          - semiInExtBrk.E.tpPrct.span * semiInExtBrk.E.tpPrct.inExtFrac
    //      )
    //      gapPrctSum = sum(xxx.tpPrct.val)
    //      gapPrctSum = prctBrksGapRealSum / (
    //          + (scaleExtent[1] - scaleExtent[0]) + valP + valQ
    //          + fullyInExtBrksSum.tpPrct.gapReal
    //          + semiInExtBrk.S.tpPrct.gapReal * semiInExtBrk.S.tpPrct.inExtFrac
    //          + semiInExtBrk.E.tpPrct.gapReal * semiInExtBrk.E.tpPrct.inExtFrac
    //      )
    //  Assume:
    //      xxx.tpPrct.gapReal = xxx.tpPrct.val / gapPrctSum * prctBrksGapRealSum
    //         (NOTE: This is not accurate when semi-in-extent break exist because its
    //         proportion is not linear, but this assumption approximately works.)
    //  Derived as follows:
    //      prctBrksGapRealSum = gapPrctSum * ( (scaleExtent[1] - scaleExtent[0]) + valP + valQ )
    //          / (1
    //              - fullyInExtBrksSum.tpPrct.val
    //              - semiInExtBrk.S.tpPrct.val * semiInExtBrk.S.tpPrct.inExtFrac
    //              - semiInExtBrk.E.tpPrct.val * semiInExtBrk.E.tpPrct.inExtFrac
    //          )
    var gapPrctSum = 0;
    var fullyInExtBrksSum = {
        tpAbs: {
            span: 0,
            val: 0
        },
        tpPrct: {
            span: 0,
            val: 0
        }
    };
    var init = function() {
        return {
            has: false,
            span: NaN,
            inExtFrac: NaN,
            val: NaN
        };
    };
    var semiInExtBrk = {
        S: {
            tpAbs: init(),
            tpPrct: init()
        },
        E: {
            tpAbs: init(),
            tpPrct: init()
        }
    };
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(brkCtx.breaks, function(brk) {
        var gapParsed = brk.gapParsed;
        if (gapParsed.type === "tpPrct") gapPrctSum += gapParsed.val;
        var clampedBrk = $ee3a60bafdecc6ba$var$clampBreakByExtent(brk, scaleExtent);
        if (clampedBrk) {
            var vminClamped = clampedBrk.vmin !== brk.vmin;
            var vmaxClamped = clampedBrk.vmax !== brk.vmax;
            var clampedSpan = clampedBrk.vmax - clampedBrk.vmin;
            if (vminClamped && vmaxClamped) ;
            else if (vminClamped || vmaxClamped) {
                var sOrE = vminClamped ? "S" : "E";
                semiInExtBrk[sOrE][gapParsed.type].has = true;
                semiInExtBrk[sOrE][gapParsed.type].span = clampedSpan;
                semiInExtBrk[sOrE][gapParsed.type].inExtFrac = clampedSpan / (brk.vmax - brk.vmin);
                semiInExtBrk[sOrE][gapParsed.type].val = gapParsed.val;
            } else {
                fullyInExtBrksSum[gapParsed.type].span += clampedSpan;
                fullyInExtBrksSum[gapParsed.type].val += gapParsed.val;
            }
        }
    });
    var prctBrksGapRealSum = gapPrctSum * (0 + (scaleExtent[1] - scaleExtent[0]) + (fullyInExtBrksSum.tpAbs.val - fullyInExtBrksSum.tpAbs.span) + (semiInExtBrk.S.tpAbs.has ? (semiInExtBrk.S.tpAbs.val - semiInExtBrk.S.tpAbs.span) * semiInExtBrk.S.tpAbs.inExtFrac : 0) + (semiInExtBrk.E.tpAbs.has ? (semiInExtBrk.E.tpAbs.val - semiInExtBrk.E.tpAbs.span) * semiInExtBrk.E.tpAbs.inExtFrac : 0) - fullyInExtBrksSum.tpPrct.span - (semiInExtBrk.S.tpPrct.has ? semiInExtBrk.S.tpPrct.span * semiInExtBrk.S.tpPrct.inExtFrac : 0) - (semiInExtBrk.E.tpPrct.has ? semiInExtBrk.E.tpPrct.span * semiInExtBrk.E.tpPrct.inExtFrac : 0)) / (1 - fullyInExtBrksSum.tpPrct.val - (semiInExtBrk.S.tpPrct.has ? semiInExtBrk.S.tpPrct.val * semiInExtBrk.S.tpPrct.inExtFrac : 0) - (semiInExtBrk.E.tpPrct.has ? semiInExtBrk.E.tpPrct.val * semiInExtBrk.E.tpPrct.inExtFrac : 0));
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(brkCtx.breaks, function(brk) {
        var gapParsed = brk.gapParsed;
        if (gapParsed.type === "tpPrct") brk.gapReal = gapPrctSum !== 0 ? Math.max(prctBrksGapRealSum, 0) * gapParsed.val / gapPrctSum : 0;
        if (gapParsed.type === "tpAbs") brk.gapReal = gapParsed.val;
        if (brk.gapReal == null) brk.gapReal = 0;
    });
}
function $ee3a60bafdecc6ba$var$pruneTicksByBreak(pruneByBreak, ticks, breaks, getValue, interval, scaleExtent) {
    if (pruneByBreak === "no") return;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(breaks, function(brk) {
        // break.vmin/vmax that out of extent must not impact the visible of
        // normal ticks and labels.
        var clampedBrk = $ee3a60bafdecc6ba$var$clampBreakByExtent(brk, scaleExtent);
        if (!clampedBrk) return;
        // Remove some normal ticks to avoid zigzag shapes overlapping with split lines
        // and to avoid break labels overlapping with normal tick labels (thouth it can
        // also be avoided by `axisLabel.hideOverlap`).
        // It's OK to O(n^2) since the number of `ticks` are small.
        for(var j = ticks.length - 1; j >= 0; j--){
            var tick = ticks[j];
            var val = getValue(tick);
            // 1. Ensure there is no ticks inside `break.vmin` and `break.vmax`.
            // 2. Use an empirically gap value here. Theoritically `zigzagAmplitude` is
            //  supposed to be involved to provide better precision but it will brings
            //  more complexity. The empirically gap value is conservative because break
            //  labels and normal tick lables are prone to overlapping.
            var gap = interval * 3 / 4;
            if (val > clampedBrk.vmin - gap && val < clampedBrk.vmax + gap && (pruneByBreak !== "preserve_extent_bound" || val !== scaleExtent[0] && val !== scaleExtent[1])) ticks.splice(j, 1);
        }
    });
}
function $ee3a60bafdecc6ba$var$addBreaksToTicks(// The input ticks should be in accending order.
ticks, breaks, scaleExtent, // Keep the break ends at the same level to avoid an awkward appearance.
getTimeProps) {
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(breaks, function(brk) {
        var clampedBrk = $ee3a60bafdecc6ba$var$clampBreakByExtent(brk, scaleExtent);
        if (!clampedBrk) return;
        // - When neight `break.vmin` nor `break.vmax` is in scale extent,
        //  break label should not be displayed and we do not add them to the result.
        // - When only one of `break.vmin` and `break.vmax` is inside the extent and the
        //  other is outsite, we comply with the extent and display only part of the breaks area,
        //  because the extent might be determined by user settings (such as `axis.min/max`)
        ticks.push({
            value: clampedBrk.vmin,
            "break": {
                type: "vmin",
                parsedBreak: clampedBrk
            },
            time: getTimeProps ? getTimeProps(clampedBrk) : undefined
        });
        // When gap is 0, start tick overlap with end tick, but we still count both of them. Break
        // area shape can address that overlapping. `axisLabel` need draw both start and end separately,
        // otherwise it brings complexity to the logic of label overlapping resolving (e.g., when label
        // rotated), and introduces inconsistency to users in `axisLabel.formatter` between gap is 0 or not.
        ticks.push({
            value: clampedBrk.vmax,
            "break": {
                type: "vmax",
                parsedBreak: clampedBrk
            },
            time: getTimeProps ? getTimeProps(clampedBrk) : undefined
        });
    });
    if (breaks.length) ticks.sort(function(a, b) {
        return a.value - b.value;
    });
}
/**
 * If break and extent does not intersect, return null/undefined.
 * If the intersection is only a point at scaleExtent[0] or scaleExtent[1], return null/undefined.
 */ function $ee3a60bafdecc6ba$var$clampBreakByExtent(brk, scaleExtent) {
    var vmin = Math.max(brk.vmin, scaleExtent[0]);
    var vmax = Math.min(brk.vmax, scaleExtent[1]);
    return vmin < vmax || vmin === vmax && vmin > scaleExtent[0] && vmin < scaleExtent[1] ? {
        vmin: vmin,
        vmax: vmax,
        breakOption: brk.breakOption,
        gapParsed: brk.gapParsed,
        gapReal: brk.gapReal
    } : null;
}
function $ee3a60bafdecc6ba$var$parseAxisBreakOption(// raw user input breaks, retrieved from axis model.
breakOptionList, parse, opt) {
    var parsedBreaks = [];
    if (!breakOptionList) return {
        breaks: parsedBreaks
    };
    function validatePercent(normalizedPercent, msg) {
        if (normalizedPercent >= 0 && normalizedPercent < 1 - 1e-5) // Avoid division error.
        return true;
        return false;
    }
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(breakOptionList, function(brkOption) {
        if (!brkOption || brkOption.start == null || brkOption.end == null) return;
        if (brkOption.isExpanded) return;
        var parsedBrk = {
            breakOption: (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(brkOption),
            vmin: parse(brkOption.start),
            vmax: parse(brkOption.end),
            gapParsed: {
                type: "tpAbs",
                val: 0
            },
            gapReal: null
        };
        if (brkOption.gap != null) {
            var isPrct = false;
            if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(brkOption.gap)) {
                var trimmedGap = (0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(brkOption.gap);
                if (trimmedGap.match(/%$/)) {
                    var normalizedPercent = parseFloat(trimmedGap) / 100;
                    if (!validatePercent(normalizedPercent, "Percent gap")) normalizedPercent = 0;
                    parsedBrk.gapParsed.type = "tpPrct";
                    parsedBrk.gapParsed.val = normalizedPercent;
                    isPrct = true;
                }
            }
            if (!isPrct) {
                var absolute = parse(brkOption.gap);
                if (!isFinite(absolute) || absolute < 0) absolute = 0;
                parsedBrk.gapParsed.type = "tpAbs";
                parsedBrk.gapParsed.val = absolute;
            }
        }
        if (parsedBrk.vmin === parsedBrk.vmax) {
            parsedBrk.gapParsed.type = "tpAbs";
            parsedBrk.gapParsed.val = 0;
        }
        if (opt && opt.noNegative) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            "vmin",
            "vmax"
        ], function(se) {
            if (parsedBrk[se] < 0) parsedBrk[se] = 0;
        });
        // Ascending numerical order is the prerequisite of the calculation in Scale#normalize.
        // User are allowed to input desending vmin/vmax for simplifying the usage.
        if (parsedBrk.vmin > parsedBrk.vmax) {
            var tmp = parsedBrk.vmax;
            parsedBrk.vmax = parsedBrk.vmin;
            parsedBrk.vmin = tmp;
        }
        parsedBreaks.push(parsedBrk);
    });
    // Ascending numerical order is the prerequisite of the calculation in Scale#normalize.
    parsedBreaks.sort(function(item1, item2) {
        return item1.vmin - item2.vmin;
    });
    // Make sure that the intervals in breaks are not overlap.
    var lastEnd = -Infinity;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(parsedBreaks, function(brk, idx) {
        if (lastEnd > brk.vmin) parsedBreaks[idx] = null;
        lastEnd = brk.vmax;
    });
    return {
        breaks: parsedBreaks.filter(function(brk) {
            return !!brk;
        })
    };
}
function $ee3a60bafdecc6ba$var$identifyAxisBreak(brk, identifier) {
    return $ee3a60bafdecc6ba$var$serializeAxisBreakIdentifier(identifier) === $ee3a60bafdecc6ba$var$serializeAxisBreakIdentifier(brk);
}
function $ee3a60bafdecc6ba$var$serializeAxisBreakIdentifier(identifier) {
    // We use user input start/end to identify break. Considered cases like `start: new Date(xxx)`,
    // Theoretically `Scale#parse` should be used here, but not used currently to reduce dependencies,
    // since simply converting to string happens to be correct.
    return identifier.start + "_\x00_" + identifier.end;
}
/**
 * - A break pair represents `[vmin, vmax]`,
 * - Only both vmin and vmax item exist, they are counted as a pair.
 */ function $ee3a60bafdecc6ba$var$retrieveAxisBreakPairs(itemList, getVisualAxisBreak, returnIdx) {
    var idxPairList = [];
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(itemList, function(el, idx) {
        var vBreak = getVisualAxisBreak(el);
        if (vBreak && vBreak.type === "vmin") idxPairList.push([
            idx
        ]);
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(itemList, function(el, idx) {
        var vBreak = getVisualAxisBreak(el);
        if (vBreak && vBreak.type === "vmax") {
            var idxPair = (0, $7a1bd9c2710fea0d$export$71aa6c912b956294)(idxPairList, // parsedBreak may be changed, can only use breakOption to match them.
            function(pr) {
                return $ee3a60bafdecc6ba$var$identifyAxisBreak(getVisualAxisBreak(itemList[pr[0]]).parsedBreak.breakOption, vBreak.parsedBreak.breakOption);
            });
            idxPair && idxPair.push(idx);
        }
    });
    var result = [];
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(idxPairList, function(idxPair) {
        if (idxPair.length === 2) result.push(returnIdx ? idxPair : [
            itemList[idxPair[0]],
            itemList[idxPair[1]]
        ]);
    });
    return result;
}
function $ee3a60bafdecc6ba$var$getTicksLogTransformBreak(tick, logBase, logOriginalBreaks, fixRoundingError) {
    var vBreak;
    var brkRoundingCriterion;
    if (tick["break"]) {
        var brk = tick["break"].parsedBreak;
        var originalBreak = (0, $7a1bd9c2710fea0d$export$71aa6c912b956294)(logOriginalBreaks, function(brk) {
            return $ee3a60bafdecc6ba$var$identifyAxisBreak(brk.breakOption, tick["break"].parsedBreak.breakOption);
        });
        var vmin = fixRoundingError(Math.pow(logBase, brk.vmin), originalBreak.vmin);
        var vmax = fixRoundingError(Math.pow(logBase, brk.vmax), originalBreak.vmax);
        var gapParsed = {
            type: brk.gapParsed.type,
            val: brk.gapParsed.type === "tpAbs" ? (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(Math.pow(logBase, brk.vmin + brk.gapParsed.val)) - vmin : brk.gapParsed.val
        };
        vBreak = {
            type: tick["break"].type,
            parsedBreak: {
                breakOption: brk.breakOption,
                vmin: vmin,
                vmax: vmax,
                gapParsed: gapParsed,
                gapReal: brk.gapReal
            }
        };
        brkRoundingCriterion = originalBreak[tick["break"].type];
    }
    return {
        brkRoundingCriterion: brkRoundingCriterion,
        vBreak: vBreak
    };
}
function $ee3a60bafdecc6ba$var$logarithmicParseBreaksFromOption(breakOptionList, logBase, parse) {
    var opt = {
        noNegative: true
    };
    var parsedOriginal = $ee3a60bafdecc6ba$var$parseAxisBreakOption(breakOptionList, parse, opt);
    var parsedLogged = $ee3a60bafdecc6ba$var$parseAxisBreakOption(breakOptionList, parse, opt);
    var loggedBase = Math.log(logBase);
    parsedLogged.breaks = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(parsedLogged.breaks, function(brk) {
        var vmin = Math.log(brk.vmin) / loggedBase;
        var vmax = Math.log(brk.vmax) / loggedBase;
        var gapParsed = {
            type: brk.gapParsed.type,
            val: brk.gapParsed.type === "tpAbs" ? Math.log(brk.vmin + brk.gapParsed.val) / loggedBase - vmin : brk.gapParsed.val
        };
        return {
            vmin: vmin,
            vmax: vmax,
            gapParsed: gapParsed,
            gapReal: brk.gapReal,
            breakOption: brk.breakOption
        };
    });
    return {
        parsedOriginal: parsedOriginal,
        parsedLogged: parsedLogged
    };
}
var $ee3a60bafdecc6ba$var$BREAK_MIN_MAX_TO_PARAM = {
    vmin: "start",
    vmax: "end"
};
function $ee3a60bafdecc6ba$var$makeAxisLabelFormatterParamBreak(extraParam, vBreak) {
    if (vBreak) {
        extraParam = extraParam || {};
        extraParam["break"] = {
            type: $ee3a60bafdecc6ba$var$BREAK_MIN_MAX_TO_PARAM[vBreak.type],
            start: vBreak.parsedBreak.vmin,
            end: vBreak.parsedBreak.vmax
        };
    }
    return extraParam;
}
function $ee3a60bafdecc6ba$export$8a93e423db92f59c() {
    (0, $639a5974fe354f7a$export$11977f1e90ef55cf)({
        createScaleBreakContext: $ee3a60bafdecc6ba$var$createScaleBreakContext,
        pruneTicksByBreak: $ee3a60bafdecc6ba$var$pruneTicksByBreak,
        addBreaksToTicks: $ee3a60bafdecc6ba$var$addBreaksToTicks,
        parseAxisBreakOption: $ee3a60bafdecc6ba$var$parseAxisBreakOption,
        identifyAxisBreak: $ee3a60bafdecc6ba$var$identifyAxisBreak,
        serializeAxisBreakIdentifier: $ee3a60bafdecc6ba$var$serializeAxisBreakIdentifier,
        retrieveAxisBreakPairs: $ee3a60bafdecc6ba$var$retrieveAxisBreakPairs,
        getTicksLogTransformBreak: $ee3a60bafdecc6ba$var$getTicksLogTransformBreak,
        logarithmicParseBreaksFromOption: $ee3a60bafdecc6ba$var$logarithmicParseBreaksFromOption,
        makeAxisLabelFormatterParamBreak: $ee3a60bafdecc6ba$var$makeAxisLabelFormatterParamBreak
    });
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 










/**
 * @caution
 *  Must not export anything except `installAxisBreakHelper`
 */ /**
 * The zigzag shapes for axis breaks are generated according to some random
 * factors. It should persist as much as possible to avoid constantly
 * changing by every user operation.
 */ var $351ad66f5420b6ac$var$viewCache = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $351ad66f5420b6ac$var$ensureVisualInCache(visualList, targetBreak) {
    var visual = (0, $7a1bd9c2710fea0d$export$71aa6c912b956294)(visualList, function(item) {
        return (0, $639a5974fe354f7a$export$e79b20ac82c2d660)().identifyAxisBreak(item.parsedBreak.breakOption, targetBreak.breakOption);
    });
    if (!visual) visualList.push(visual = {
        zigzagRandomList: [],
        parsedBreak: targetBreak,
        shouldRemove: false
    });
    return visual;
}
function $351ad66f5420b6ac$var$resetCacheVisualRemoveFlag(visualList) {
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(visualList, function(item) {
        return item.shouldRemove = true;
    });
}
function $351ad66f5420b6ac$var$removeUnusedCacheVisual(visualList) {
    for(var i = visualList.length - 1; i >= 0; i--)if (visualList[i].shouldRemove) visualList.splice(i, 1);
}
function $351ad66f5420b6ac$var$rectCoordBuildBreakAxis(axisGroup, axisView, axisModel, coordSysRect, api) {
    var axis = axisModel.axis;
    if (axis.scale.isBlank() || !(0, $639a5974fe354f7a$export$e79b20ac82c2d660)()) return;
    var breakPairs = (0, $639a5974fe354f7a$export$e79b20ac82c2d660)().retrieveAxisBreakPairs(axis.scale.getTicks({
        breakTicks: "only_break"
    }), function(tick) {
        return tick["break"];
    }, false);
    if (!breakPairs.length) return;
    var breakAreaModel = axisModel.getModel("breakArea");
    var zigzagAmplitude = breakAreaModel.get("zigzagAmplitude");
    var zigzagMinSpan = breakAreaModel.get("zigzagMinSpan");
    var zigzagMaxSpan = breakAreaModel.get("zigzagMaxSpan");
    // Use arbitrary value to avoid dead loop if user gives inappropriate settings.
    zigzagMinSpan = Math.max(2, zigzagMinSpan || 0);
    zigzagMaxSpan = Math.max(zigzagMinSpan, zigzagMaxSpan || 0);
    var expandOnClick = breakAreaModel.get("expandOnClick");
    var zigzagZ = breakAreaModel.get("zigzagZ");
    var itemStyleModel = breakAreaModel.getModel("itemStyle");
    var itemStyle = itemStyleModel.getItemStyle();
    var borderColor = itemStyle.stroke;
    var borderWidth = itemStyle.lineWidth;
    var borderType = itemStyle.lineDash;
    var color = itemStyle.fill;
    var group = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)({
        ignoreModelZ: true
    });
    var isAxisHorizontal = axis.isHorizontal();
    var cachedVisualList = $351ad66f5420b6ac$var$viewCache(axisView).visualList || ($351ad66f5420b6ac$var$viewCache(axisView).visualList = []);
    $351ad66f5420b6ac$var$resetCacheVisualRemoveFlag(cachedVisualList);
    var _loop_1 = function(i) {
        var parsedBreak = breakPairs[i][0]["break"].parsedBreak;
        // Even if brk.gap is 0, we should also draw the breakArea because
        // border is sometimes required to be visible (as a line)
        var coords = [];
        coords[0] = axis.toGlobalCoord(axis.dataToCoord(parsedBreak.vmin, true));
        coords[1] = axis.toGlobalCoord(axis.dataToCoord(parsedBreak.vmax, true));
        if (coords[1] < coords[0]) coords.reverse();
        var cachedVisual = $351ad66f5420b6ac$var$ensureVisualInCache(cachedVisualList, parsedBreak);
        cachedVisual.shouldRemove = false;
        var breakGroup = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        addZigzagShapes(cachedVisual.zigzagRandomList, breakGroup, coords[0], coords[1], isAxisHorizontal, parsedBreak);
        if (expandOnClick) breakGroup.on("click", function() {
            var payload = {
                type: (0, $6a77b1cfe2c04bae$export$12319e2083cd71ce),
                breaks: [
                    {
                        start: parsedBreak.breakOption.start,
                        end: parsedBreak.breakOption.end
                    }
                ]
            };
            payload[axis.dim + "AxisIndex"] = axisModel.componentIndex;
            api.dispatchAction(payload);
        });
        breakGroup.silent = !expandOnClick;
        group.add(breakGroup);
    };
    for(var i = 0; i < breakPairs.length; i++)_loop_1(i);
    axisGroup.add(group);
    $351ad66f5420b6ac$var$removeUnusedCacheVisual(cachedVisualList);
    function addZigzagShapes(zigzagRandomList, breakGroup, startCoord, endCoord, isAxisHorizontal, trimmedBreak) {
        var polylineStyle = {
            stroke: borderColor,
            lineWidth: borderWidth,
            lineDash: borderType,
            fill: "none"
        };
        var dimBrk = isAxisHorizontal ? 0 : 1;
        var dimZigzag = 1 - dimBrk;
        var zigzagCoordMax = coordSysRect[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimZigzag]] + coordSysRect[(0, $5b455ae6f843ac47$export$a3fe6d967173a3ac)[dimZigzag]];
        // Apply `subPixelOptimizeLine` for alignning with break ticks.
        function subPixelOpt(brkCoord) {
            var pBrk = [];
            var dummyP = [];
            pBrk[dimBrk] = dummyP[dimBrk] = brkCoord;
            pBrk[dimZigzag] = coordSysRect[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimZigzag]];
            dummyP[dimZigzag] = zigzagCoordMax;
            var dummyShape = {
                x1: pBrk[0],
                y1: pBrk[1],
                x2: dummyP[0],
                y2: dummyP[1]
            };
            (0, $4d5544821af8d796$export$8b4b620d7f4aad1b)(dummyShape, dummyShape, {
                lineWidth: 1
            });
            pBrk[0] = dummyShape.x1;
            pBrk[1] = dummyShape.y1;
            return pBrk[dimBrk];
        }
        startCoord = subPixelOpt(startCoord);
        endCoord = subPixelOpt(endCoord);
        var pointsA = [];
        var pointsB = [];
        var isSwap = true;
        var current = coordSysRect[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimZigzag]];
        for(var idx = 0;; idx++){
            // Use `isFirstPoint` `isLastPoint` to ensure the intersections between zigzag
            // and axis are precise, thus it can join its axis tick correctly.
            var isFirstPoint = current === coordSysRect[(0, $5b455ae6f843ac47$export$cb4c12294149dd2d)[dimZigzag]];
            var isLastPoint = current >= zigzagCoordMax;
            if (isLastPoint) current = zigzagCoordMax;
            var pA = [];
            var pB = [];
            pA[dimBrk] = startCoord;
            pB[dimBrk] = endCoord;
            if (!isFirstPoint && !isLastPoint) {
                pA[dimBrk] += isSwap ? -zigzagAmplitude : zigzagAmplitude;
                pB[dimBrk] -= !isSwap ? -zigzagAmplitude : zigzagAmplitude;
            }
            pA[dimZigzag] = current;
            pB[dimZigzag] = current;
            pointsA.push(pA);
            pointsB.push(pB);
            var randomVal = void 0;
            if (idx < zigzagRandomList.length) randomVal = zigzagRandomList[idx];
            else {
                randomVal = Math.random();
                zigzagRandomList.push(randomVal);
            }
            current += randomVal * (zigzagMaxSpan - zigzagMinSpan) + zigzagMinSpan;
            isSwap = !isSwap;
            if (isLastPoint) break;
        }
        var anidSuffix = (0, $639a5974fe354f7a$export$e79b20ac82c2d660)().serializeAxisBreakIdentifier(trimmedBreak.breakOption);
        // Create two polylines and add them to the breakGroup
        breakGroup.add(new (0, $d28119f30e6bb670$export$2e2bcd8739ae039)({
            anid: "break_a_" + anidSuffix,
            shape: {
                points: pointsA
            },
            style: polylineStyle,
            z: zigzagZ
        }));
        /* Add the second polyline and a polygon only if the gap is not zero
     * Otherwise if the polyline is with dashed line or being opaque,
     * it may not be constant with breaks with non-zero gaps. */ if (trimmedBreak.gapReal !== 0) {
            breakGroup.add(new (0, $d28119f30e6bb670$export$2e2bcd8739ae039)({
                anid: "break_b_" + anidSuffix,
                shape: {
                    // Not reverse to keep the dash stable when dragging resizing.
                    points: pointsB
                },
                style: polylineStyle,
                z: zigzagZ
            }));
            // Creating the polygon that fills the area between the polylines
            // From end to start for polygon.
            var pointsB2 = pointsB.slice();
            pointsB2.reverse();
            var polygonPoints = pointsA.concat(pointsB2);
            breakGroup.add(new (0, $51acf033123e1a30$export$2e2bcd8739ae039)({
                anid: "break_c_" + anidSuffix,
                shape: {
                    points: polygonPoints
                },
                style: {
                    fill: color,
                    opacity: itemStyle.opacity
                },
                z: zigzagZ
            }));
        }
    }
}
function $351ad66f5420b6ac$var$buildAxisBreakLine(axisModel, group, transformGroup, pathBaseProp) {
    var axis = axisModel.axis;
    var transform = transformGroup.transform;
    (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(pathBaseProp.style);
    var extent = axis.getExtent();
    if (axis.inverse) {
        extent = extent.slice();
        extent.reverse();
    }
    var breakPairs = (0, $639a5974fe354f7a$export$e79b20ac82c2d660)().retrieveAxisBreakPairs(axis.scale.getTicks({
        breakTicks: "only_break"
    }), function(tick) {
        return tick["break"];
    }, false);
    var brkLayoutList = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(breakPairs, function(breakPair) {
        var parsedBreak = breakPair[0]["break"].parsedBreak;
        var coordPair = [
            axis.dataToCoord(parsedBreak.vmin, true),
            axis.dataToCoord(parsedBreak.vmax, true)
        ];
        coordPair[0] > coordPair[1] && coordPair.reverse();
        return {
            coordPair: coordPair,
            brkId: (0, $639a5974fe354f7a$export$e79b20ac82c2d660)().serializeAxisBreakIdentifier(parsedBreak.breakOption)
        };
    });
    brkLayoutList.sort(function(layout1, layout2) {
        return layout1.coordPair[0] - layout2.coordPair[0];
    });
    var ySegMin = extent[0];
    var lastLayout = null;
    for(var idx = 0; idx < brkLayoutList.length; idx++){
        var layout = brkLayoutList[idx];
        var brkTirmmedMin = Math.max(layout.coordPair[0], extent[0]);
        var brkTirmmedMax = Math.min(layout.coordPair[1], extent[1]);
        if (ySegMin <= brkTirmmedMin) addSeg(ySegMin, brkTirmmedMin, lastLayout, layout);
        ySegMin = brkTirmmedMax;
        lastLayout = layout;
    }
    if (ySegMin <= extent[1]) addSeg(ySegMin, extent[1], lastLayout, null);
    function addSeg(min, max, layout1, layout2) {
        function trans(p1, p2) {
            if (transform) {
                (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(p1, p1, transform);
                (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(p2, p2, transform);
            }
        }
        function subPixelOptimizePP(p1, p2) {
            var shape = {
                x1: p1[0],
                y1: p1[1],
                x2: p2[0],
                y2: p2[1]
            };
            (0, $4d5544821af8d796$export$8b4b620d7f4aad1b)(shape, shape, pathBaseProp.style);
            p1[0] = shape.x1;
            p1[1] = shape.y1;
            p2[0] = shape.x2;
            p2[1] = shape.y2;
        }
        var lineP1 = [
            min,
            0
        ];
        var lineP2 = [
            max,
            0
        ];
        // dummy tick is used to align the line segment ends with axis ticks
        // after `subPixelOptimizeLine` being applied.
        var dummyTickEnd1 = [
            min,
            5
        ];
        var dummyTickEnd2 = [
            max,
            5
        ];
        trans(lineP1, dummyTickEnd1);
        subPixelOptimizePP(lineP1, dummyTickEnd1);
        trans(lineP2, dummyTickEnd2);
        subPixelOptimizePP(lineP2, dummyTickEnd2);
        // Apply it keeping the same as the normal axis line.
        subPixelOptimizePP(lineP1, lineP2);
        var seg = new (0, $7a316ae5ceff7b27$export$2e2bcd8739ae039)((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
            shape: {
                x1: lineP1[0],
                y1: lineP1[1],
                x2: lineP2[0],
                y2: lineP2[1]
            }
        }, pathBaseProp));
        group.add(seg);
        // Animation should be precise to be consistent with tick and split line animation.
        seg.anid = "breakLine_" + (layout1 ? layout1.brkId : "\x00") + "_\x00_" + (layout2 ? layout2.brkId : "\x00");
    }
}
/**
 * Resolve the overlap of a pair of labels.
 *
 * [CAUTION] Only label.x/y are allowed to change.
 */ function $351ad66f5420b6ac$var$adjustBreakLabelPair(axisInverse, axisRotation, layoutPair) {
    if ((0, $7a1bd9c2710fea0d$export$71aa6c912b956294)(layoutPair, function(item) {
        return !item;
    })) return;
    var mtv = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
    if (!(0, $11dac7a73f36cc2c$export$f28bfabef115ba96)(layoutPair[0], layoutPair[1], mtv, {
        // Assert `labelPair` is `[break_min, break_max]`.
        // `axis.inverse: true` means a smaller scale value corresponds to a bigger value in axis.extent.
        // The axisRotation indicates mtv direction of OBB intersecting.
        direction: -(axisInverse ? axisRotation + Math.PI : axisRotation),
        touchThreshold: 0,
        // If need to resovle intersection align axis by moving labels according to MTV,
        // the direction must not be opposite, otherwise cause misleading.
        bidirectional: false
    })) return;
    // Rotate axis back to (1, 0) direction, to be a standard axis.
    var axisStTrans = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
    $f41ebb9dd60b55b4$export$bb628a54ab399bc9(axisStTrans, axisStTrans, -axisRotation);
    var labelPairStTrans = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(layoutPair, function(layout) {
        return layout.transform ? $f41ebb9dd60b55b4$export$6e3a27864ab166fe($f41ebb9dd60b55b4$export$185802fd694ee1f5(), axisStTrans, layout.transform) : axisStTrans;
    });
    function isParallelToAxis(whIdx) {
        // Assert label[0] and label[1] has the same rotation, so only use [0].
        var localRect = layoutPair[0].localRect;
        var labelVec0 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(localRect[(0, $5b455ae6f843ac47$export$a3fe6d967173a3ac)[whIdx]] * labelPairStTrans[0][0], localRect[(0, $5b455ae6f843ac47$export$a3fe6d967173a3ac)[whIdx]] * labelPairStTrans[0][1]);
        return Math.abs(labelVec0.y) < 1e-5;
    }
    // If overlapping, move pair[0] pair[1] apart a little. We need to calculate a ratio k to
    // distribute mtv to pair[0] and pair[1]. This is to place the text gap as close as possible
    // to the center of the break ticks, otherwise it might looks weird or misleading.
    // - When labels' width/height are not parallel to axis (usually by rotation),
    //  we can simply treat the k as `0.5`.
    var k = 0.5;
    // - When labels' width/height are parallel to axis, the width/height need to be considered,
    //  since they may differ significantly. In this case we keep textAlign as 'center' rather
    //  than 'left'/'right', due to considerations of space utilization for wide break.gap.
    //  A sample case: break on xAxis(no inverse) is [200, 300000].
    //  We calculate k based on the formula below:
    //      Rotated axis and labels to the direction of (1, 0).
    //      uval = ( (pair[0].insidePt - mtv*k) + (pair[1].insidePt + mtv*(1-k)) ) / 2 - brkCenter
    //      0 <= k <= 1
    //      |uval| should be as small as possible.
    //  Derived as follows:
    //      qval = (pair[0].insidePt + pair[1].insidePt + mtv) / 2 - brkCenter
    //      k = (qval - uval) / mtv
    //      min(qval, qval-mtv) <= uval <= max(qval, qval-mtv)
    if (isParallelToAxis(0) || isParallelToAxis(1)) {
        var rectSt = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(layoutPair, function(layout, idx) {
            var rect = layout.localRect.clone();
            rect.applyTransform(labelPairStTrans[idx]);
            return rect;
        });
        var brkCenterSt = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
        brkCenterSt.copy(layoutPair[0].label).add(layoutPair[1].label).scale(0.5);
        brkCenterSt.transform(axisStTrans);
        var mtvSt = mtv.clone().transform(axisStTrans);
        var insidePtSum = rectSt[0].x + rectSt[1].x + (mtvSt.x >= 0 ? rectSt[0].width : rectSt[1].width);
        var qval = (insidePtSum + mtvSt.x) / 2 - brkCenterSt.x;
        var uvalMin = Math.min(qval, qval - mtvSt.x);
        var uvalMax = Math.max(qval, qval - mtvSt.x);
        var uval = uvalMax < 0 ? uvalMax : uvalMin > 0 ? uvalMin : 0;
        k = (qval - uval) / mtvSt.x;
    }
    var delta0 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
    var delta1 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
    (0, $b887f038f104fe7e$export$2e2bcd8739ae039).scale(delta0, mtv, -k);
    (0, $b887f038f104fe7e$export$2e2bcd8739ae039).scale(delta1, mtv, 1 - k);
    (0, $11dac7a73f36cc2c$export$91f733c27ab0712f)(layoutPair[0], delta0);
    (0, $11dac7a73f36cc2c$export$91f733c27ab0712f)(layoutPair[1], delta1);
}
function $351ad66f5420b6ac$var$updateModelAxisBreak(model, payload) {
    var result = {
        breaks: []
    };
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(payload.breaks, function(inputBrk) {
        if (!inputBrk) return;
        var breakOption = (0, $7a1bd9c2710fea0d$export$71aa6c912b956294)(model.get("breaks", true), function(brkOption) {
            return (0, $639a5974fe354f7a$export$e79b20ac82c2d660)().identifyAxisBreak(brkOption, inputBrk);
        });
        if (!breakOption) return;
        var actionType = payload.type;
        var old = {
            isExpanded: !!breakOption.isExpanded
        };
        breakOption.isExpanded = actionType === (0, $6a77b1cfe2c04bae$export$12319e2083cd71ce) ? true : actionType === (0, $6a77b1cfe2c04bae$export$8ba710d11f5d9b28) ? false : actionType === (0, $6a77b1cfe2c04bae$export$cfaa507333440c5e) ? !breakOption.isExpanded : breakOption.isExpanded;
        result.breaks.push({
            start: breakOption.start,
            end: breakOption.end,
            isExpanded: !!breakOption.isExpanded,
            old: old
        });
    });
    return result;
}
function $351ad66f5420b6ac$export$6ecf2ccbc1d386b1() {
    (0, $0d1e9c0f651d5d16$export$f5ec8c7ef7a59f4c)({
        adjustBreakLabelPair: $351ad66f5420b6ac$var$adjustBreakLabelPair,
        buildAxisBreakLine: $351ad66f5420b6ac$var$buildAxisBreakLine,
        rectCoordBuildBreakAxis: $351ad66f5420b6ac$var$rectCoordBuildBreakAxis,
        updateModelAxisBreak: $351ad66f5420b6ac$var$updateModelAxisBreak
    });
}


function $6dff6eb93aaa7720$export$f3d2e42c14594d5b(registers) {
    (0, $6a77b1cfe2c04bae$export$408c24786cd729c6)(registers);
    (0, $ee3a60bafdecc6ba$export$8a93e423db92f59c)();
    (0, $351ad66f5420b6ac$export$6ecf2ccbc1d386b1)();
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO: move labels out of viewport.










function $e10cf2049e185956$var$cloneArr(points) {
    if (points) {
        var newPoints = [];
        for(var i = 0; i < points.length; i++)newPoints.push(points[i].slice());
        return newPoints;
    }
}
function $e10cf2049e185956$var$prepareLayoutCallbackParams(labelItem, hostEl) {
    var label = labelItem.label;
    var labelLine = hostEl && hostEl.getTextGuideLine();
    return {
        dataIndex: labelItem.dataIndex,
        dataType: labelItem.dataType,
        seriesIndex: labelItem.seriesModel.seriesIndex,
        text: labelItem.label.style.text,
        rect: labelItem.hostRect,
        labelRect: labelItem.rect,
        // x: labelAttr.x,
        // y: labelAttr.y,
        align: label.style.align,
        verticalAlign: label.style.verticalAlign,
        labelLinePoints: $e10cf2049e185956$var$cloneArr(labelLine && labelLine.shape.points)
    };
}
var $e10cf2049e185956$var$LABEL_OPTION_TO_STYLE_KEYS = [
    "align",
    "verticalAlign",
    "width",
    "height",
    "fontSize"
];
var $e10cf2049e185956$var$dummyTransformable = new (0, $becf2d727f9cf450$export$2e2bcd8739ae039)();
var $e10cf2049e185956$var$labelLayoutInnerStore = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $e10cf2049e185956$var$labelLineAnimationStore = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $e10cf2049e185956$var$extendWithKeys(target, source, keys) {
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (source[key] != null) target[key] = source[key];
    }
}
var $e10cf2049e185956$var$LABEL_LAYOUT_PROPS = [
    "x",
    "y",
    "rotation"
];
var $e10cf2049e185956$var$LabelManager = /** @class */ function() {
    function LabelManager() {
        this._labelList = [];
        this._chartViewList = [];
    }
    LabelManager.prototype.clearLabels = function() {
        this._labelList = [];
        this._chartViewList = [];
    };
    /**
   * Add label to manager
   */ LabelManager.prototype._addLabel = function(dataIndex, dataType, seriesModel, label, layoutOptionOrCb) {
        var labelStyle = label.style;
        var hostEl = label.__hostTarget;
        var textConfig = hostEl.textConfig || {};
        // TODO: If label is in other state.
        var labelTransform = label.getComputedTransform();
        var labelRect = label.getBoundingRect().plain();
        (0, $1bebe7106c895823$export$2e2bcd8739ae039).applyTransform(labelRect, labelRect, labelTransform);
        if (labelTransform) $e10cf2049e185956$var$dummyTransformable.setLocalTransform(labelTransform);
        else {
            // Identity transform.
            $e10cf2049e185956$var$dummyTransformable.x = $e10cf2049e185956$var$dummyTransformable.y = $e10cf2049e185956$var$dummyTransformable.rotation = $e10cf2049e185956$var$dummyTransformable.originX = $e10cf2049e185956$var$dummyTransformable.originY = 0;
            $e10cf2049e185956$var$dummyTransformable.scaleX = $e10cf2049e185956$var$dummyTransformable.scaleY = 1;
        }
        $e10cf2049e185956$var$dummyTransformable.rotation = (0, $b44a8536c7214e4f$export$d44861331f213635)($e10cf2049e185956$var$dummyTransformable.rotation);
        var host = label.__hostTarget;
        var hostRect;
        if (host) {
            hostRect = host.getBoundingRect().plain();
            var transform = host.getComputedTransform();
            (0, $1bebe7106c895823$export$2e2bcd8739ae039).applyTransform(hostRect, hostRect, transform);
        }
        var labelGuide = hostRect && host.getTextGuideLine();
        this._labelList.push({
            label: label,
            labelLine: labelGuide,
            seriesModel: seriesModel,
            dataIndex: dataIndex,
            dataType: dataType,
            layoutOptionOrCb: layoutOptionOrCb,
            layoutOption: null,
            rect: labelRect,
            hostRect: hostRect,
            // Label with lower priority will be hidden when overlapped
            // Use rect size as default priority
            priority: hostRect ? hostRect.width * hostRect.height : 0,
            // Save default label attributes.
            // For restore if developers want get back to default value in callback.
            defaultAttr: {
                ignore: label.ignore,
                labelGuideIgnore: labelGuide && labelGuide.ignore,
                x: $e10cf2049e185956$var$dummyTransformable.x,
                y: $e10cf2049e185956$var$dummyTransformable.y,
                scaleX: $e10cf2049e185956$var$dummyTransformable.scaleX,
                scaleY: $e10cf2049e185956$var$dummyTransformable.scaleY,
                rotation: $e10cf2049e185956$var$dummyTransformable.rotation,
                style: {
                    x: labelStyle.x,
                    y: labelStyle.y,
                    align: labelStyle.align,
                    verticalAlign: labelStyle.verticalAlign,
                    width: labelStyle.width,
                    height: labelStyle.height,
                    fontSize: labelStyle.fontSize
                },
                cursor: label.cursor,
                attachedPos: textConfig.position,
                attachedRot: textConfig.rotation
            }
        });
    };
    LabelManager.prototype.addLabelsOfSeries = function(chartView) {
        var _this = this;
        this._chartViewList.push(chartView);
        var seriesModel = chartView.__model;
        var layoutOption = seriesModel.get("labelLayout");
        /**
     * Ignore layouting if it's not specified anything.
     */ if (!((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(layoutOption) || (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(layoutOption).length)) return;
        chartView.group.traverse(function(child) {
            if (child.ignore) return true; // Stop traverse descendants.
            // Only support label being hosted on graphic elements.
            var textEl = child.getTextContent();
            var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(child);
            // Can only attach the text on the element with dataIndex
            if (textEl && !textEl.disableLabelLayout) _this._addLabel(ecData.dataIndex, ecData.dataType, seriesModel, textEl, layoutOption);
        });
    };
    LabelManager.prototype.updateLayoutConfig = function(api) {
        var width = api.getWidth();
        var height = api.getHeight();
        function createDragHandler(el, labelLineModel) {
            return function() {
                (0, $f4eb87a228be297f$export$cc93ba643cd97d83)(el, labelLineModel);
            };
        }
        for(var i = 0; i < this._labelList.length; i++){
            var labelItem = this._labelList[i];
            var label = labelItem.label;
            var hostEl = label.__hostTarget;
            var defaultLabelAttr = labelItem.defaultAttr;
            var layoutOption = void 0;
            // TODO A global layout option?
            if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(labelItem.layoutOptionOrCb)) layoutOption = labelItem.layoutOptionOrCb($e10cf2049e185956$var$prepareLayoutCallbackParams(labelItem, hostEl));
            else layoutOption = labelItem.layoutOptionOrCb;
            layoutOption = layoutOption || {};
            labelItem.layoutOption = layoutOption;
            var degreeToRadian = Math.PI / 180;
            // TODO hostEl should always exists.
            // Or label should not have parent because the x, y is all in global space.
            if (hostEl) hostEl.setTextConfig({
                // Force to set local false.
                local: false,
                // Ignore position and rotation config on the host el if x or y is changed.
                position: layoutOption.x != null || layoutOption.y != null ? null : defaultLabelAttr.attachedPos,
                // Ignore rotation config on the host el if rotation is changed.
                rotation: layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.attachedRot,
                offset: [
                    layoutOption.dx || 0,
                    layoutOption.dy || 0
                ]
            });
            var needsUpdateLabelLine = false;
            if (layoutOption.x != null) {
                // TODO width of chart view.
                label.x = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(layoutOption.x, width);
                label.setStyle("x", 0); // Ignore movement in style. TODO: origin.
                needsUpdateLabelLine = true;
            } else {
                label.x = defaultLabelAttr.x;
                label.setStyle("x", defaultLabelAttr.style.x);
            }
            if (layoutOption.y != null) {
                // TODO height of chart view.
                label.y = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(layoutOption.y, height);
                label.setStyle("y", 0); // Ignore movement in style.
                needsUpdateLabelLine = true;
            } else {
                label.y = defaultLabelAttr.y;
                label.setStyle("y", defaultLabelAttr.style.y);
            }
            if (layoutOption.labelLinePoints) {
                var guideLine = hostEl.getTextGuideLine();
                if (guideLine) {
                    guideLine.setShape({
                        points: layoutOption.labelLinePoints
                    });
                    // Not update
                    needsUpdateLabelLine = false;
                }
            }
            var labelLayoutStore = $e10cf2049e185956$var$labelLayoutInnerStore(label);
            labelLayoutStore.needsUpdateLabelLine = needsUpdateLabelLine;
            label.rotation = layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.rotation;
            label.scaleX = defaultLabelAttr.scaleX;
            label.scaleY = defaultLabelAttr.scaleY;
            for(var k = 0; k < $e10cf2049e185956$var$LABEL_OPTION_TO_STYLE_KEYS.length; k++){
                var key = $e10cf2049e185956$var$LABEL_OPTION_TO_STYLE_KEYS[k];
                label.setStyle(key, layoutOption[key] != null ? layoutOption[key] : defaultLabelAttr.style[key]);
            }
            if (layoutOption.draggable) {
                label.draggable = true;
                label.cursor = "move";
                if (hostEl) {
                    var hostModel = labelItem.seriesModel;
                    if (labelItem.dataIndex != null) {
                        var data = labelItem.seriesModel.getData(labelItem.dataType);
                        hostModel = data.getItemModel(labelItem.dataIndex);
                    }
                    label.on("drag", createDragHandler(hostEl, hostModel.getModel("labelLine")));
                }
            } else {
                // TODO Other drag functions?
                label.off("drag");
                label.cursor = defaultLabelAttr.cursor;
            }
        }
    };
    LabelManager.prototype.layout = function(api) {
        var width = api.getWidth();
        var height = api.getHeight();
        var labelList = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._labelList, function(inputItem) {
            if (!inputItem.defaultAttr.ignore) labelList.push((0, $11dac7a73f36cc2c$export$a1cfd37e9b88106b)({}, inputItem));
        });
        var labelsNeedsAdjustOnX = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(labelList, function(item) {
            return item.layoutOption.moveOverlap === "shiftX";
        });
        var labelsNeedsAdjustOnY = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(labelList, function(item) {
            return item.layoutOption.moveOverlap === "shiftY";
        });
        (0, $11dac7a73f36cc2c$export$73ee08bc808f6f3f)(labelsNeedsAdjustOnX, 0, 0, width);
        (0, $11dac7a73f36cc2c$export$73ee08bc808f6f3f)(labelsNeedsAdjustOnY, 1, 0, height);
        var labelsNeedsHideOverlap = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(labelList, function(item) {
            return item.layoutOption.hideOverlap;
        });
        (0, $11dac7a73f36cc2c$export$ff775ae4fbb23435)(labelsNeedsHideOverlap);
        (0, $11dac7a73f36cc2c$export$8ce774e164a49410)(labelsNeedsHideOverlap);
    };
    /**
   * Process all labels. Not only labels with layoutOption.
   */ LabelManager.prototype.processLabelsOverall = function() {
        var _this = this;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._chartViewList, function(chartView) {
            var seriesModel = chartView.__model;
            var ignoreLabelLineUpdate = chartView.ignoreLabelLineUpdate;
            var animationEnabled = seriesModel.isAnimationEnabled();
            chartView.group.traverse(function(child) {
                if (child.ignore && !child.forceLabelAnimation) return true; // Stop traverse descendants.
                var needsUpdateLabelLine = !ignoreLabelLineUpdate;
                var label = child.getTextContent();
                if (!needsUpdateLabelLine && label) needsUpdateLabelLine = $e10cf2049e185956$var$labelLayoutInnerStore(label).needsUpdateLabelLine;
                if (needsUpdateLabelLine) _this._updateLabelLine(child, seriesModel);
                if (animationEnabled) _this._animateLabels(child, seriesModel);
            });
        });
    };
    LabelManager.prototype._updateLabelLine = function(el, seriesModel) {
        // Only support label being hosted on graphic elements.
        var textEl = el.getTextContent();
        // Update label line style.
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
        var dataIndex = ecData.dataIndex;
        // Only support labelLine on the labels represent data.
        if (textEl && dataIndex != null) {
            var data = seriesModel.getData(ecData.dataType);
            var itemModel = data.getItemModel(dataIndex);
            var defaultStyle = {};
            var visualStyle = data.getItemVisual(dataIndex, "style");
            if (visualStyle) {
                var visualType = data.getVisual("drawType");
                // Default to be same with main color
                defaultStyle.stroke = visualStyle[visualType];
            }
            var labelLineModel = itemModel.getModel("labelLine");
            (0, $f4eb87a228be297f$export$c09e0b0574bdd2dc)(el, (0, $f4eb87a228be297f$export$2979fdbf5ebce521)(itemModel), defaultStyle);
            (0, $f4eb87a228be297f$export$cc93ba643cd97d83)(el, labelLineModel);
        }
    };
    LabelManager.prototype._animateLabels = function(el, seriesModel) {
        var textEl = el.getTextContent();
        var guideLine = el.getTextGuideLine();
        // Animate
        if (textEl && (el.forceLabelAnimation || !textEl.ignore && !textEl.invisible && !el.disableLabelAnimation && !(0, $8b353638fbedfefa$export$5b89d4b643713034)(el))) {
            var layoutStore = $e10cf2049e185956$var$labelLayoutInnerStore(textEl);
            var oldLayout = layoutStore.oldLayout;
            var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
            var dataIndex = ecData.dataIndex;
            var newProps = {
                x: textEl.x,
                y: textEl.y,
                rotation: textEl.rotation
            };
            var data = seriesModel.getData(ecData.dataType);
            if (!oldLayout) {
                textEl.attr(newProps);
                // Disable fade in animation if value animation is enabled.
                if (!(0, $6800dfcb6e1e2a44$export$f62786d3261ab0f4)(textEl).valueAnimation) {
                    var oldOpacity = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textEl.style.opacity, 1);
                    // Fade in animation
                    textEl.style.opacity = 0;
                    (0, $8b353638fbedfefa$export$a121566aadcfe021)(textEl, {
                        style: {
                            opacity: oldOpacity
                        }
                    }, seriesModel, dataIndex);
                }
            } else {
                textEl.attr(oldLayout);
                // Make sure the animation from is in the right status.
                var prevStates = el.prevStates;
                if (prevStates) {
                    if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(prevStates, "select") >= 0) textEl.attr(layoutStore.oldLayoutSelect);
                    if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(prevStates, "emphasis") >= 0) textEl.attr(layoutStore.oldLayoutEmphasis);
                }
                (0, $8b353638fbedfefa$export$c8dce3c08436e91e)(textEl, newProps, seriesModel, dataIndex);
            }
            layoutStore.oldLayout = newProps;
            if (textEl.states.select) {
                var layoutSelect = layoutStore.oldLayoutSelect = {};
                $e10cf2049e185956$var$extendWithKeys(layoutSelect, newProps, $e10cf2049e185956$var$LABEL_LAYOUT_PROPS);
                $e10cf2049e185956$var$extendWithKeys(layoutSelect, textEl.states.select, $e10cf2049e185956$var$LABEL_LAYOUT_PROPS);
            }
            if (textEl.states.emphasis) {
                var layoutEmphasis = layoutStore.oldLayoutEmphasis = {};
                $e10cf2049e185956$var$extendWithKeys(layoutEmphasis, newProps, $e10cf2049e185956$var$LABEL_LAYOUT_PROPS);
                $e10cf2049e185956$var$extendWithKeys(layoutEmphasis, textEl.states.emphasis, $e10cf2049e185956$var$LABEL_LAYOUT_PROPS);
            }
            (0, $6800dfcb6e1e2a44$export$dd6101605f5c186)(textEl, dataIndex, data, seriesModel, seriesModel);
        }
        if (guideLine && !guideLine.ignore && !guideLine.invisible) {
            var layoutStore = $e10cf2049e185956$var$labelLineAnimationStore(guideLine);
            var oldLayout = layoutStore.oldLayout;
            var newLayout = {
                points: guideLine.shape.points
            };
            if (!oldLayout) {
                guideLine.setShape(newLayout);
                guideLine.style.strokePercent = 0;
                (0, $8b353638fbedfefa$export$a121566aadcfe021)(guideLine, {
                    style: {
                        strokePercent: 1
                    }
                }, seriesModel);
            } else {
                guideLine.attr({
                    shape: oldLayout
                });
                (0, $8b353638fbedfefa$export$c8dce3c08436e91e)(guideLine, {
                    shape: newLayout
                }, seriesModel);
            }
            layoutStore.oldLayout = newLayout;
        }
    };
    return LabelManager;
}();
var $e10cf2049e185956$export$2e2bcd8739ae039 = $e10cf2049e185956$var$LabelManager;


var $de19ea5da3bb8f56$var$getLabelManager = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $de19ea5da3bb8f56$export$5320d1b3745c02a5(registers) {
    registers.registerUpdateLifecycle("series:beforeupdate", function(ecModel, api, params) {
        // TODO api provide an namespace that can save stuff per instance
        var labelManager = $de19ea5da3bb8f56$var$getLabelManager(api).labelManager;
        if (!labelManager) labelManager = $de19ea5da3bb8f56$var$getLabelManager(api).labelManager = new (0, $e10cf2049e185956$export$2e2bcd8739ae039)();
        labelManager.clearLabels();
    });
    registers.registerUpdateLifecycle("series:layoutlabels", function(ecModel, api, params) {
        var labelManager = $de19ea5da3bb8f56$var$getLabelManager(api).labelManager;
        params.updatedSeries.forEach(function(series) {
            labelManager.addLabelsOfSeries(api.getViewOfSeriesModel(series));
        });
        labelManager.updateLayoutConfig(api);
        labelManager.layout(api);
        labelManager.processLabelsOverall();
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




function $8defd9d7c6d36f4c$export$81228e37d220ba46() {
    (0, $8e1d1b12d8439742$export$9da5287b2e41f334)($8defd9d7c6d36f4c$var$legacyLayOutGridByContained);
}
/**
 * The input gridRect and axes will be modified.
 */ function $8defd9d7c6d36f4c$var$legacyLayOutGridByContained(axesList, gridRect) {
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesList, function(axis) {
        if (!axis.model.get([
            "axisLabel",
            "inside"
        ])) {
            var labelUnionRect = $8defd9d7c6d36f4c$var$estimateLabelUnionRect(axis);
            if (labelUnionRect) {
                var dim = axis.isHorizontal() ? "height" : "width";
                var margin = axis.model.get([
                    "axisLabel",
                    "margin"
                ]);
                gridRect[dim] -= labelUnionRect[dim] + margin;
                if (axis.position === "top") gridRect.y += labelUnionRect.height + margin;
                else if (axis.position === "left") gridRect.x += labelUnionRect.width + margin;
            }
        }
    });
}
/**
 * @return Be null/undefined if no labels.
 */ function $8defd9d7c6d36f4c$var$estimateLabelUnionRect(axis) {
    var axisModel = axis.model;
    var scale = axis.scale;
    if (!axisModel.get([
        "axisLabel",
        "show"
    ]) || scale.isBlank()) return;
    var realNumberScaleTicks;
    var tickCount;
    var categoryScaleExtent = scale.getExtent();
    // Optimize for large category data, avoid call `getTicks()`.
    if (scale instanceof (0, $6e82606ec775d365$export$2e2bcd8739ae039)) tickCount = scale.count();
    else {
        realNumberScaleTicks = scale.getTicks();
        tickCount = realNumberScaleTicks.length;
    }
    var axisLabelModel = axis.getLabelModel();
    var labelFormatter = (0, $2d646e51cc34f840$export$742f19a75415b2ae)(axis);
    var rect;
    var step = 1;
    // Simple optimization for large amount of category labels
    if (tickCount > 40) step = Math.ceil(tickCount / 40);
    for(var i = 0; i < tickCount; i += step){
        var tick = realNumberScaleTicks ? realNumberScaleTicks[i] : {
            value: categoryScaleExtent[0] + i
        };
        var label = labelFormatter(tick, i);
        var unrotatedSingleRect = axisLabelModel.getTextRect(label);
        var singleRect = rotateTextRect(unrotatedSingleRect, axisLabelModel.get("rotate") || 0);
        rect ? rect.union(singleRect) : rect = singleRect;
    }
    return rect;
    function rotateTextRect(textRect, rotate) {
        var rotateRadians = rotate * Math.PI / 180;
        var beforeWidth = textRect.width;
        var beforeHeight = textRect.height;
        var afterWidth = beforeWidth * Math.abs(Math.cos(rotateRadians)) + Math.abs(beforeHeight * Math.sin(rotateRadians));
        var afterHeight = beforeWidth * Math.abs(Math.sin(rotateRadians)) + Math.abs(beforeHeight * Math.cos(rotateRadians));
        var rotatedRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(textRect.x, textRect.y, afterWidth, afterHeight);
        return rotatedRect;
    }
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Universal transitions that can animate between any shapes(series) and any properties in any amounts.


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 














var $2a60c506580ea7a9$var$CMD = (0, $20ebe2448f123f2e$export$2e2bcd8739ae039).CMD;
function $2a60c506580ea7a9$var$aroundEqual(a, b) {
    return Math.abs(a - b) < 1e-5;
}
function $2a60c506580ea7a9$export$fbc91cffd4bdf629(path) {
    var data = path.data;
    var len = path.len();
    var bezierArrayGroups = [];
    var currentSubpath;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    function createNewSubpath(x, y) {
        if (currentSubpath && currentSubpath.length > 2) bezierArrayGroups.push(currentSubpath);
        currentSubpath = [
            x,
            y
        ];
    }
    function addLine(x0, y0, x1, y1) {
        if (!($2a60c506580ea7a9$var$aroundEqual(x0, x1) && $2a60c506580ea7a9$var$aroundEqual(y0, y1))) currentSubpath.push(x0, y0, x1, y1, x1, y1);
    }
    function addArc(startAngle, endAngle, cx, cy, rx, ry) {
        var delta = Math.abs(endAngle - startAngle);
        var len = Math.tan(delta / 4) * 4 / 3;
        var dir = endAngle < startAngle ? -1 : 1;
        var c1 = Math.cos(startAngle);
        var s1 = Math.sin(startAngle);
        var c2 = Math.cos(endAngle);
        var s2 = Math.sin(endAngle);
        var x1 = c1 * rx + cx;
        var y1 = s1 * ry + cy;
        var x4 = c2 * rx + cx;
        var y4 = s2 * ry + cy;
        var hx = rx * len * dir;
        var hy = ry * len * dir;
        currentSubpath.push(x1 - hx * s1, y1 + hy * c1, x4 + hx * s2, y4 - hy * c2, x4, y4);
    }
    var x1;
    var y1;
    var x2;
    var y2;
    for(var i = 0; i < len;){
        var cmd = data[i++];
        var isFirst = i === 1;
        if (isFirst) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
            if (cmd === $2a60c506580ea7a9$var$CMD.L || cmd === $2a60c506580ea7a9$var$CMD.C || cmd === $2a60c506580ea7a9$var$CMD.Q) currentSubpath = [
                x0,
                y0
            ];
        }
        switch(cmd){
            case $2a60c506580ea7a9$var$CMD.M:
                xi = x0 = data[i++];
                yi = y0 = data[i++];
                createNewSubpath(x0, y0);
                break;
            case $2a60c506580ea7a9$var$CMD.L:
                x1 = data[i++];
                y1 = data[i++];
                addLine(xi, yi, x1, y1);
                xi = x1;
                yi = y1;
                break;
            case $2a60c506580ea7a9$var$CMD.C:
                currentSubpath.push(data[i++], data[i++], data[i++], data[i++], xi = data[i++], yi = data[i++]);
                break;
            case $2a60c506580ea7a9$var$CMD.Q:
                x1 = data[i++];
                y1 = data[i++];
                x2 = data[i++];
                y2 = data[i++];
                currentSubpath.push(xi + 2 / 3 * (x1 - xi), yi + 2 / 3 * (y1 - yi), x2 + 2 / 3 * (x1 - x2), y2 + 2 / 3 * (y1 - y2), x2, y2);
                xi = x2;
                yi = y2;
                break;
            case $2a60c506580ea7a9$var$CMD.A:
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var startAngle = data[i++];
                var endAngle = data[i++] + startAngle;
                i += 1;
                var anticlockwise = !data[i++];
                x1 = Math.cos(startAngle) * rx + cx;
                y1 = Math.sin(startAngle) * ry + cy;
                if (isFirst) {
                    x0 = x1;
                    y0 = y1;
                    createNewSubpath(x0, y0);
                } else addLine(xi, yi, x1, y1);
                xi = Math.cos(endAngle) * rx + cx;
                yi = Math.sin(endAngle) * ry + cy;
                var step = (anticlockwise ? -1 : 1) * Math.PI / 2;
                for(var angle = startAngle; anticlockwise ? angle > endAngle : angle < endAngle; angle += step){
                    var nextAngle = anticlockwise ? Math.max(angle + step, endAngle) : Math.min(angle + step, endAngle);
                    addArc(angle, nextAngle, cx, cy, rx, ry);
                }
                break;
            case $2a60c506580ea7a9$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                x1 = x0 + data[i++];
                y1 = y0 + data[i++];
                createNewSubpath(x1, y0);
                addLine(x1, y0, x1, y1);
                addLine(x1, y1, x0, y1);
                addLine(x0, y1, x0, y0);
                addLine(x0, y0, x1, y0);
                break;
            case $2a60c506580ea7a9$var$CMD.Z:
                currentSubpath && addLine(xi, yi, x0, y0);
                xi = x0;
                yi = y0;
                break;
        }
    }
    if (currentSubpath && currentSubpath.length > 2) bezierArrayGroups.push(currentSubpath);
    return bezierArrayGroups;
}
function $2a60c506580ea7a9$var$adpativeBezier(x0, y0, x1, y1, x2, y2, x3, y3, out, scale) {
    if ($2a60c506580ea7a9$var$aroundEqual(x0, x1) && $2a60c506580ea7a9$var$aroundEqual(y0, y1) && $2a60c506580ea7a9$var$aroundEqual(x2, x3) && $2a60c506580ea7a9$var$aroundEqual(y2, y3)) {
        out.push(x3, y3);
        return;
    }
    var PIXEL_DISTANCE = 2 / scale;
    var PIXEL_DISTANCE_SQR = PIXEL_DISTANCE * PIXEL_DISTANCE;
    var dx = x3 - x0;
    var dy = y3 - y0;
    var d = Math.sqrt(dx * dx + dy * dy);
    dx /= d;
    dy /= d;
    var dx1 = x1 - x0;
    var dy1 = y1 - y0;
    var dx2 = x2 - x3;
    var dy2 = y2 - y3;
    var cp1LenSqr = dx1 * dx1 + dy1 * dy1;
    var cp2LenSqr = dx2 * dx2 + dy2 * dy2;
    if (cp1LenSqr < PIXEL_DISTANCE_SQR && cp2LenSqr < PIXEL_DISTANCE_SQR) {
        out.push(x3, y3);
        return;
    }
    var projLen1 = dx * dx1 + dy * dy1;
    var projLen2 = -dx * dx2 - dy * dy2;
    var d1Sqr = cp1LenSqr - projLen1 * projLen1;
    var d2Sqr = cp2LenSqr - projLen2 * projLen2;
    if (d1Sqr < PIXEL_DISTANCE_SQR && projLen1 >= 0 && d2Sqr < PIXEL_DISTANCE_SQR && projLen2 >= 0) {
        out.push(x3, y3);
        return;
    }
    var tmpSegX = [];
    var tmpSegY = [];
    (0, $747cfc5611b57cea$export$a2ee23a0567039da)(x0, x1, x2, x3, 0.5, tmpSegX);
    (0, $747cfc5611b57cea$export$a2ee23a0567039da)(y0, y1, y2, y3, 0.5, tmpSegY);
    $2a60c506580ea7a9$var$adpativeBezier(tmpSegX[0], tmpSegY[0], tmpSegX[1], tmpSegY[1], tmpSegX[2], tmpSegY[2], tmpSegX[3], tmpSegY[3], out, scale);
    $2a60c506580ea7a9$var$adpativeBezier(tmpSegX[4], tmpSegY[4], tmpSegX[5], tmpSegY[5], tmpSegX[6], tmpSegY[6], tmpSegX[7], tmpSegY[7], out, scale);
}
function $2a60c506580ea7a9$export$163f4950160f2337(path, scale) {
    var bezierArrayGroups = $2a60c506580ea7a9$export$fbc91cffd4bdf629(path);
    var polygons = [];
    scale = scale || 1;
    for(var i = 0; i < bezierArrayGroups.length; i++){
        var beziers = bezierArrayGroups[i];
        var polygon = [];
        var x0 = beziers[0];
        var y0 = beziers[1];
        polygon.push(x0, y0);
        for(var k = 2; k < beziers.length;){
            var x1 = beziers[k++];
            var y1 = beziers[k++];
            var x2 = beziers[k++];
            var y2 = beziers[k++];
            var x3 = beziers[k++];
            var y3 = beziers[k++];
            $2a60c506580ea7a9$var$adpativeBezier(x0, y0, x1, y1, x2, y2, x3, y3, polygon, scale);
            x0 = x3;
            y0 = y3;
        }
        polygons.push(polygon);
    }
    return polygons;
}



function $640f8b532a910a4f$var$getDividingGrids(dimSize, rowDim, count) {
    var rowSize = dimSize[rowDim];
    var columnSize = dimSize[1 - rowDim];
    var ratio = Math.abs(rowSize / columnSize);
    var rowCount = Math.ceil(Math.sqrt(ratio * count));
    var columnCount = Math.floor(count / rowCount);
    if (columnCount === 0) {
        columnCount = 1;
        rowCount = count;
    }
    var grids = [];
    for(var i = 0; i < rowCount; i++)grids.push(columnCount);
    var currentCount = rowCount * columnCount;
    var remained = count - currentCount;
    if (remained > 0) for(var i = 0; i < remained; i++)grids[i % rowCount] += 1;
    return grids;
}
function $640f8b532a910a4f$var$divideSector(sectorShape, count, outShapes) {
    var r0 = sectorShape.r0;
    var r = sectorShape.r;
    var startAngle = sectorShape.startAngle;
    var endAngle = sectorShape.endAngle;
    var angle = Math.abs(endAngle - startAngle);
    var arcLen = angle * r;
    var deltaR = r - r0;
    var isAngleRow = arcLen > Math.abs(deltaR);
    var grids = $640f8b532a910a4f$var$getDividingGrids([
        arcLen,
        deltaR
    ], isAngleRow ? 0 : 1, count);
    var rowSize = (isAngleRow ? angle : deltaR) / grids.length;
    for(var row = 0; row < grids.length; row++){
        var columnSize = (isAngleRow ? deltaR : angle) / grids[row];
        for(var column = 0; column < grids[row]; column++){
            var newShape = {};
            if (isAngleRow) {
                newShape.startAngle = startAngle + rowSize * row;
                newShape.endAngle = startAngle + rowSize * (row + 1);
                newShape.r0 = r0 + columnSize * column;
                newShape.r = r0 + columnSize * (column + 1);
            } else {
                newShape.startAngle = startAngle + columnSize * column;
                newShape.endAngle = startAngle + columnSize * (column + 1);
                newShape.r0 = r0 + rowSize * row;
                newShape.r = r0 + rowSize * (row + 1);
            }
            newShape.clockwise = sectorShape.clockwise;
            newShape.cx = sectorShape.cx;
            newShape.cy = sectorShape.cy;
            outShapes.push(newShape);
        }
    }
}
function $640f8b532a910a4f$var$divideRect(rectShape, count, outShapes) {
    var width = rectShape.width;
    var height = rectShape.height;
    var isHorizontalRow = width > height;
    var grids = $640f8b532a910a4f$var$getDividingGrids([
        width,
        height
    ], isHorizontalRow ? 0 : 1, count);
    var rowSizeDim = isHorizontalRow ? "width" : "height";
    var columnSizeDim = isHorizontalRow ? "height" : "width";
    var rowDim = isHorizontalRow ? "x" : "y";
    var columnDim = isHorizontalRow ? "y" : "x";
    var rowSize = rectShape[rowSizeDim] / grids.length;
    for(var row = 0; row < grids.length; row++){
        var columnSize = rectShape[columnSizeDim] / grids[row];
        for(var column = 0; column < grids[row]; column++){
            var newShape = {};
            newShape[rowDim] = row * rowSize;
            newShape[columnDim] = column * columnSize;
            newShape[rowSizeDim] = rowSize;
            newShape[columnSizeDim] = columnSize;
            newShape.x += rectShape.x;
            newShape.y += rectShape.y;
            outShapes.push(newShape);
        }
    }
}
function $640f8b532a910a4f$var$crossProduct2d(x1, y1, x2, y2) {
    return x1 * y2 - x2 * y1;
}
function $640f8b532a910a4f$var$lineLineIntersect(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
    var mx = a2x - a1x;
    var my = a2y - a1y;
    var nx = b2x - b1x;
    var ny = b2y - b1y;
    var nmCrossProduct = $640f8b532a910a4f$var$crossProduct2d(nx, ny, mx, my);
    if (Math.abs(nmCrossProduct) < 1e-6) return null;
    var b1a1x = a1x - b1x;
    var b1a1y = a1y - b1y;
    var p = $640f8b532a910a4f$var$crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
    if (p < 0 || p > 1) return null;
    return new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(p * mx + a1x, p * my + a1y);
}
function $640f8b532a910a4f$var$projPtOnLine(pt, lineA, lineB) {
    var dir = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
    (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub(dir, lineB, lineA);
    dir.normalize();
    var dir2 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
    (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub(dir2, pt, lineA);
    var len = dir2.dot(dir);
    return len;
}
function $640f8b532a910a4f$var$addToPoly(poly, pt) {
    var last = poly[poly.length - 1];
    if (last && last[0] === pt[0] && last[1] === pt[1]) return;
    poly.push(pt);
}
function $640f8b532a910a4f$var$splitPolygonByLine(points, lineA, lineB) {
    var len = points.length;
    var intersections = [];
    for(var i = 0; i < len; i++){
        var p0 = points[i];
        var p1 = points[(i + 1) % len];
        var intersectionPt = $640f8b532a910a4f$var$lineLineIntersect(p0[0], p0[1], p1[0], p1[1], lineA.x, lineA.y, lineB.x, lineB.y);
        if (intersectionPt) intersections.push({
            projPt: $640f8b532a910a4f$var$projPtOnLine(intersectionPt, lineA, lineB),
            pt: intersectionPt,
            idx: i
        });
    }
    if (intersections.length < 2) return [
        {
            points: points
        },
        {
            points: points
        }
    ];
    intersections.sort(function(a, b) {
        return a.projPt - b.projPt;
    });
    var splitPt0 = intersections[0];
    var splitPt1 = intersections[intersections.length - 1];
    if (splitPt1.idx < splitPt0.idx) {
        var tmp = splitPt0;
        splitPt0 = splitPt1;
        splitPt1 = tmp;
    }
    var splitPt0Arr = [
        splitPt0.pt.x,
        splitPt0.pt.y
    ];
    var splitPt1Arr = [
        splitPt1.pt.x,
        splitPt1.pt.y
    ];
    var newPolyA = [
        splitPt0Arr
    ];
    var newPolyB = [
        splitPt1Arr
    ];
    for(var i = splitPt0.idx + 1; i <= splitPt1.idx; i++)$640f8b532a910a4f$var$addToPoly(newPolyA, points[i].slice());
    $640f8b532a910a4f$var$addToPoly(newPolyA, splitPt1Arr);
    $640f8b532a910a4f$var$addToPoly(newPolyA, splitPt0Arr);
    for(var i = splitPt1.idx + 1; i <= splitPt0.idx + len; i++)$640f8b532a910a4f$var$addToPoly(newPolyB, points[i % len].slice());
    $640f8b532a910a4f$var$addToPoly(newPolyB, splitPt0Arr);
    $640f8b532a910a4f$var$addToPoly(newPolyB, splitPt1Arr);
    return [
        {
            points: newPolyA
        },
        {
            points: newPolyB
        }
    ];
}
function $640f8b532a910a4f$var$binaryDividePolygon(polygonShape) {
    var points = polygonShape.points;
    var min = [];
    var max = [];
    (0, $af3aab2435198f82$export$188c3cd07b4129dd)(points, min, max);
    var boundingRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(min[0], min[1], max[0] - min[0], max[1] - min[1]);
    var width = boundingRect.width;
    var height = boundingRect.height;
    var x = boundingRect.x;
    var y = boundingRect.y;
    var pt0 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
    var pt1 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
    if (width > height) {
        pt0.x = pt1.x = x + width / 2;
        pt0.y = y;
        pt1.y = y + height;
    } else {
        pt0.y = pt1.y = y + height / 2;
        pt0.x = x;
        pt1.x = x + width;
    }
    return $640f8b532a910a4f$var$splitPolygonByLine(points, pt0, pt1);
}
function $640f8b532a910a4f$var$binaryDivideRecursive(divider, shape, count, out) {
    if (count === 1) out.push(shape);
    else {
        var mid = Math.floor(count / 2);
        var sub = divider(shape);
        $640f8b532a910a4f$var$binaryDivideRecursive(divider, sub[0], mid, out);
        $640f8b532a910a4f$var$binaryDivideRecursive(divider, sub[1], count - mid, out);
    }
    return out;
}
function $640f8b532a910a4f$export$9cd59f9826255e47(path, count) {
    var paths = [];
    for(var i = 0; i < count; i++)paths.push((0, $15b38920672b9006$export$18711d956bf1c3eb)(path));
    return paths;
}
function $640f8b532a910a4f$var$copyPathProps(source, target) {
    target.setStyle(source.style);
    target.z = source.z;
    target.z2 = source.z2;
    target.zlevel = source.zlevel;
}
function $640f8b532a910a4f$var$polygonConvert(points) {
    var out = [];
    for(var i = 0; i < points.length;)out.push([
        points[i++],
        points[i++]
    ]);
    return out;
}
function $640f8b532a910a4f$export$65980d18b75784e2(path, count) {
    var outShapes = [];
    var shape = path.shape;
    var OutShapeCtor;
    switch(path.type){
        case "rect":
            $640f8b532a910a4f$var$divideRect(shape, count, outShapes);
            OutShapeCtor = (0, $419e5ff2f303755e$export$2e2bcd8739ae039);
            break;
        case "sector":
            $640f8b532a910a4f$var$divideSector(shape, count, outShapes);
            OutShapeCtor = (0, $a3e1dec0a3875b49$export$2e2bcd8739ae039);
            break;
        case "circle":
            $640f8b532a910a4f$var$divideSector({
                r0: 0,
                r: shape.r,
                startAngle: 0,
                endAngle: Math.PI * 2,
                cx: shape.cx,
                cy: shape.cy
            }, count, outShapes);
            OutShapeCtor = (0, $a3e1dec0a3875b49$export$2e2bcd8739ae039);
            break;
        default:
            var m = path.getComputedTransform();
            var scale = m ? Math.sqrt(Math.max(m[0] * m[0] + m[1] * m[1], m[2] * m[2] + m[3] * m[3])) : 1;
            var polygons = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $2a60c506580ea7a9$export$163f4950160f2337)(path.getUpdatedPathProxy(), scale), function(poly) {
                return $640f8b532a910a4f$var$polygonConvert(poly);
            });
            var polygonCount = polygons.length;
            if (polygonCount === 0) $640f8b532a910a4f$var$binaryDivideRecursive($640f8b532a910a4f$var$binaryDividePolygon, {
                points: polygons[0]
            }, count, outShapes);
            else if (polygonCount === count) for(var i = 0; i < polygonCount; i++)outShapes.push({
                points: polygons[i]
            });
            else {
                var totalArea_1 = 0;
                var items = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(polygons, function(poly) {
                    var min = [];
                    var max = [];
                    (0, $af3aab2435198f82$export$188c3cd07b4129dd)(poly, min, max);
                    var area = (max[1] - min[1]) * (max[0] - min[0]);
                    totalArea_1 += area;
                    return {
                        poly: poly,
                        area: area
                    };
                });
                items.sort(function(a, b) {
                    return b.area - a.area;
                });
                var left = count;
                for(var i = 0; i < polygonCount; i++){
                    var item = items[i];
                    if (left <= 0) break;
                    var selfCount = i === polygonCount - 1 ? left : Math.ceil(item.area / totalArea_1 * count);
                    if (selfCount < 0) continue;
                    $640f8b532a910a4f$var$binaryDivideRecursive($640f8b532a910a4f$var$binaryDividePolygon, {
                        points: item.poly
                    }, selfCount, outShapes);
                    left -= selfCount;
                }
            }
            OutShapeCtor = (0, $51acf033123e1a30$export$2e2bcd8739ae039);
            break;
    }
    if (!OutShapeCtor) return $640f8b532a910a4f$export$9cd59f9826255e47(path, count);
    var out = [];
    for(var i = 0; i < outShapes.length; i++){
        var subPath = new OutShapeCtor();
        subPath.setShape(outShapes[i]);
        $640f8b532a910a4f$var$copyPathProps(path, subPath);
        out.push(subPath);
    }
    return out;
}



function $2ef03ef3a2bb366a$var$alignSubpath(subpath1, subpath2) {
    var len1 = subpath1.length;
    var len2 = subpath2.length;
    if (len1 === len2) return [
        subpath1,
        subpath2
    ];
    var tmpSegX = [];
    var tmpSegY = [];
    var shorterPath = len1 < len2 ? subpath1 : subpath2;
    var shorterLen = Math.min(len1, len2);
    var diff = Math.abs(len2 - len1) / 6;
    var shorterBezierCount = (shorterLen - 2) / 6;
    var eachCurveSubDivCount = Math.ceil(diff / shorterBezierCount) + 1;
    var newSubpath = [
        shorterPath[0],
        shorterPath[1]
    ];
    var remained = diff;
    for(var i = 2; i < shorterLen;){
        var x0 = shorterPath[i - 2];
        var y0 = shorterPath[i - 1];
        var x1 = shorterPath[i++];
        var y1 = shorterPath[i++];
        var x2 = shorterPath[i++];
        var y2 = shorterPath[i++];
        var x3 = shorterPath[i++];
        var y3 = shorterPath[i++];
        if (remained <= 0) {
            newSubpath.push(x1, y1, x2, y2, x3, y3);
            continue;
        }
        var actualSubDivCount = Math.min(remained, eachCurveSubDivCount - 1) + 1;
        for(var k = 1; k <= actualSubDivCount; k++){
            var p = k / actualSubDivCount;
            (0, $747cfc5611b57cea$export$a2ee23a0567039da)(x0, x1, x2, x3, p, tmpSegX);
            (0, $747cfc5611b57cea$export$a2ee23a0567039da)(y0, y1, y2, y3, p, tmpSegY);
            x0 = tmpSegX[3];
            y0 = tmpSegY[3];
            newSubpath.push(tmpSegX[1], tmpSegY[1], tmpSegX[2], tmpSegY[2], x0, y0);
            x1 = tmpSegX[5];
            y1 = tmpSegY[5];
            x2 = tmpSegX[6];
            y2 = tmpSegY[6];
        }
        remained -= actualSubDivCount - 1;
    }
    return shorterPath === subpath1 ? [
        newSubpath,
        subpath2
    ] : [
        subpath1,
        newSubpath
    ];
}
function $2ef03ef3a2bb366a$var$createSubpath(lastSubpathSubpath, otherSubpath) {
    var len = lastSubpathSubpath.length;
    var lastX = lastSubpathSubpath[len - 2];
    var lastY = lastSubpathSubpath[len - 1];
    var newSubpath = [];
    for(var i = 0; i < otherSubpath.length;){
        newSubpath[i++] = lastX;
        newSubpath[i++] = lastY;
    }
    return newSubpath;
}
function $2ef03ef3a2bb366a$export$d7b853a0ab412a07(array1, array2) {
    var _a;
    var lastSubpath1;
    var lastSubpath2;
    var newArray1 = [];
    var newArray2 = [];
    for(var i = 0; i < Math.max(array1.length, array2.length); i++){
        var subpath1 = array1[i];
        var subpath2 = array2[i];
        var newSubpath1 = void 0;
        var newSubpath2 = void 0;
        if (!subpath1) {
            newSubpath1 = $2ef03ef3a2bb366a$var$createSubpath(lastSubpath1 || subpath2, subpath2);
            newSubpath2 = subpath2;
        } else if (!subpath2) {
            newSubpath2 = $2ef03ef3a2bb366a$var$createSubpath(lastSubpath2 || subpath1, subpath1);
            newSubpath1 = subpath1;
        } else {
            _a = $2ef03ef3a2bb366a$var$alignSubpath(subpath1, subpath2), newSubpath1 = _a[0], newSubpath2 = _a[1];
            lastSubpath1 = newSubpath1;
            lastSubpath2 = newSubpath2;
        }
        newArray1.push(newSubpath1);
        newArray2.push(newSubpath2);
    }
    return [
        newArray1,
        newArray2
    ];
}
function $2ef03ef3a2bb366a$export$e2a20c553f6c85ce(array) {
    var signedArea = 0;
    var cx = 0;
    var cy = 0;
    var len = array.length;
    for(var i = 0, j = len - 2; i < len; j = i, i += 2){
        var x0 = array[j];
        var y0 = array[j + 1];
        var x1 = array[i];
        var y1 = array[i + 1];
        var a = x0 * y1 - x1 * y0;
        signedArea += a;
        cx += (x0 + x1) * a;
        cy += (y0 + y1) * a;
    }
    if (signedArea === 0) return [
        array[0] || 0,
        array[1] || 0
    ];
    return [
        cx / signedArea / 3,
        cy / signedArea / 3,
        signedArea
    ];
}
function $2ef03ef3a2bb366a$var$findBestRingOffset(fromSubBeziers, toSubBeziers, fromCp, toCp) {
    var bezierCount = (fromSubBeziers.length - 2) / 6;
    var bestScore = Infinity;
    var bestOffset = 0;
    var len = fromSubBeziers.length;
    var len2 = len - 2;
    for(var offset = 0; offset < bezierCount; offset++){
        var cursorOffset = offset * 6;
        var score = 0;
        for(var k = 0; k < len; k += 2){
            var idx = k === 0 ? cursorOffset : (cursorOffset + k - 2) % len2 + 2;
            var x0 = fromSubBeziers[idx] - fromCp[0];
            var y0 = fromSubBeziers[idx + 1] - fromCp[1];
            var x1 = toSubBeziers[k] - toCp[0];
            var y1 = toSubBeziers[k + 1] - toCp[1];
            var dx = x1 - x0;
            var dy = y1 - y0;
            score += dx * dx + dy * dy;
        }
        if (score < bestScore) {
            bestScore = score;
            bestOffset = offset;
        }
    }
    return bestOffset;
}
function $2ef03ef3a2bb366a$var$reverse(array) {
    var newArr = [];
    var len = array.length;
    for(var i = 0; i < len; i += 2){
        newArr[i] = array[len - i - 2];
        newArr[i + 1] = array[len - i - 1];
    }
    return newArr;
}
function $2ef03ef3a2bb366a$var$findBestMorphingRotation(fromArr, toArr, searchAngleIteration, searchAngleRange) {
    var result = [];
    var fromNeedsReverse;
    for(var i = 0; i < fromArr.length; i++){
        var fromSubpathBezier = fromArr[i];
        var toSubpathBezier = toArr[i];
        var fromCp = $2ef03ef3a2bb366a$export$e2a20c553f6c85ce(fromSubpathBezier);
        var toCp = $2ef03ef3a2bb366a$export$e2a20c553f6c85ce(toSubpathBezier);
        if (fromNeedsReverse == null) fromNeedsReverse = fromCp[2] < 0 !== toCp[2] < 0;
        var newFromSubpathBezier = [];
        var newToSubpathBezier = [];
        var bestAngle = 0;
        var bestScore = Infinity;
        var tmpArr = [];
        var len = fromSubpathBezier.length;
        if (fromNeedsReverse) fromSubpathBezier = $2ef03ef3a2bb366a$var$reverse(fromSubpathBezier);
        var offset = $2ef03ef3a2bb366a$var$findBestRingOffset(fromSubpathBezier, toSubpathBezier, fromCp, toCp) * 6;
        var len2 = len - 2;
        for(var k = 0; k < len2; k += 2){
            var idx = (offset + k) % len2 + 2;
            newFromSubpathBezier[k + 2] = fromSubpathBezier[idx] - fromCp[0];
            newFromSubpathBezier[k + 3] = fromSubpathBezier[idx + 1] - fromCp[1];
        }
        newFromSubpathBezier[0] = fromSubpathBezier[offset] - fromCp[0];
        newFromSubpathBezier[1] = fromSubpathBezier[offset + 1] - fromCp[1];
        if (searchAngleIteration > 0) {
            var step = searchAngleRange / searchAngleIteration;
            for(var angle = -searchAngleRange / 2; angle <= searchAngleRange / 2; angle += step){
                var sa = Math.sin(angle);
                var ca = Math.cos(angle);
                var score = 0;
                for(var k = 0; k < fromSubpathBezier.length; k += 2){
                    var x0 = newFromSubpathBezier[k];
                    var y0 = newFromSubpathBezier[k + 1];
                    var x1 = toSubpathBezier[k] - toCp[0];
                    var y1 = toSubpathBezier[k + 1] - toCp[1];
                    var newX1 = x1 * ca - y1 * sa;
                    var newY1 = x1 * sa + y1 * ca;
                    tmpArr[k] = newX1;
                    tmpArr[k + 1] = newY1;
                    var dx = newX1 - x0;
                    var dy = newY1 - y0;
                    score += dx * dx + dy * dy;
                }
                if (score < bestScore) {
                    bestScore = score;
                    bestAngle = angle;
                    for(var m = 0; m < tmpArr.length; m++)newToSubpathBezier[m] = tmpArr[m];
                }
            }
        } else for(var i_1 = 0; i_1 < len; i_1 += 2){
            newToSubpathBezier[i_1] = toSubpathBezier[i_1] - toCp[0];
            newToSubpathBezier[i_1 + 1] = toSubpathBezier[i_1 + 1] - toCp[1];
        }
        result.push({
            from: newFromSubpathBezier,
            to: newToSubpathBezier,
            fromCp: fromCp,
            toCp: toCp,
            rotation: -bestAngle
        });
    }
    return result;
}
function $2ef03ef3a2bb366a$export$f9f720a01590a46f(path) {
    return path.__isCombineMorphing;
}
function $2ef03ef3a2bb366a$export$ddee3124b756354f(el) {
    return el.__morphT >= 0;
}
var $2ef03ef3a2bb366a$var$SAVED_METHOD_PREFIX = "__mOriginal_";
function $2ef03ef3a2bb366a$var$saveAndModifyMethod(obj, methodName, modifiers) {
    var savedMethodName = $2ef03ef3a2bb366a$var$SAVED_METHOD_PREFIX + methodName;
    var originalMethod = obj[savedMethodName] || obj[methodName];
    if (!obj[savedMethodName]) obj[savedMethodName] = obj[methodName];
    var replace = modifiers.replace;
    var after = modifiers.after;
    var before = modifiers.before;
    obj[methodName] = function() {
        var args = arguments;
        var res;
        before && before.apply(this, args);
        if (replace) res = replace.apply(this, args);
        else res = originalMethod.apply(this, args);
        after && after.apply(this, args);
        return res;
    };
}
function $2ef03ef3a2bb366a$var$restoreMethod(obj, methodName) {
    var savedMethodName = $2ef03ef3a2bb366a$var$SAVED_METHOD_PREFIX + methodName;
    if (obj[savedMethodName]) {
        obj[methodName] = obj[savedMethodName];
        obj[savedMethodName] = null;
    }
}
function $2ef03ef3a2bb366a$var$applyTransformOnBeziers(bezierCurves, mm) {
    for(var i = 0; i < bezierCurves.length; i++){
        var subBeziers = bezierCurves[i];
        for(var k = 0; k < subBeziers.length;){
            var x = subBeziers[k];
            var y = subBeziers[k + 1];
            subBeziers[k++] = mm[0] * x + mm[2] * y + mm[4];
            subBeziers[k++] = mm[1] * x + mm[3] * y + mm[5];
        }
    }
}
function $2ef03ef3a2bb366a$var$prepareMorphPath(fromPath, toPath) {
    var fromPathProxy = fromPath.getUpdatedPathProxy();
    var toPathProxy = toPath.getUpdatedPathProxy();
    var _a = $2ef03ef3a2bb366a$export$d7b853a0ab412a07((0, $2a60c506580ea7a9$export$fbc91cffd4bdf629)(fromPathProxy), (0, $2a60c506580ea7a9$export$fbc91cffd4bdf629)(toPathProxy)), fromBezierCurves = _a[0], toBezierCurves = _a[1];
    var fromPathTransform = fromPath.getComputedTransform();
    var toPathTransform = toPath.getComputedTransform();
    function updateIdentityTransform() {
        this.transform = null;
    }
    fromPathTransform && $2ef03ef3a2bb366a$var$applyTransformOnBeziers(fromBezierCurves, fromPathTransform);
    toPathTransform && $2ef03ef3a2bb366a$var$applyTransformOnBeziers(toBezierCurves, toPathTransform);
    $2ef03ef3a2bb366a$var$saveAndModifyMethod(toPath, "updateTransform", {
        replace: updateIdentityTransform
    });
    toPath.transform = null;
    var morphingData = $2ef03ef3a2bb366a$var$findBestMorphingRotation(fromBezierCurves, toBezierCurves, 10, Math.PI);
    var tmpArr = [];
    $2ef03ef3a2bb366a$var$saveAndModifyMethod(toPath, "buildPath", {
        replace: function(path) {
            var t = toPath.__morphT;
            var onet = 1 - t;
            var newCp = [];
            for(var i = 0; i < morphingData.length; i++){
                var item = morphingData[i];
                var from = item.from;
                var to = item.to;
                var angle = item.rotation * t;
                var fromCp = item.fromCp;
                var toCp = item.toCp;
                var sa = Math.sin(angle);
                var ca = Math.cos(angle);
                (0, $6de594cf8ac295ff$export$3a89f8d6f6bf6c9f)(newCp, fromCp, toCp, t);
                for(var m = 0; m < from.length; m += 2){
                    var x0_1 = from[m];
                    var y0_1 = from[m + 1];
                    var x1 = to[m];
                    var y1 = to[m + 1];
                    var x = x0_1 * onet + x1 * t;
                    var y = y0_1 * onet + y1 * t;
                    tmpArr[m] = x * ca - y * sa + newCp[0];
                    tmpArr[m + 1] = x * sa + y * ca + newCp[1];
                }
                var x0 = tmpArr[0];
                var y0 = tmpArr[1];
                path.moveTo(x0, y0);
                for(var m = 2; m < from.length;){
                    var x1 = tmpArr[m++];
                    var y1 = tmpArr[m++];
                    var x2 = tmpArr[m++];
                    var y2 = tmpArr[m++];
                    var x3 = tmpArr[m++];
                    var y3 = tmpArr[m++];
                    if (x0 === x1 && y0 === y1 && x2 === x3 && y2 === y3) path.lineTo(x3, y3);
                    else path.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                    x0 = x3;
                    y0 = y3;
                }
            }
        }
    });
}
function $2ef03ef3a2bb366a$export$7174e282c1c7df1c(fromPath, toPath, animationOpts) {
    if (!fromPath || !toPath) return toPath;
    var oldDone = animationOpts.done;
    var oldDuring = animationOpts.during;
    $2ef03ef3a2bb366a$var$prepareMorphPath(fromPath, toPath);
    toPath.__morphT = 0;
    function restoreToPath() {
        $2ef03ef3a2bb366a$var$restoreMethod(toPath, "buildPath");
        $2ef03ef3a2bb366a$var$restoreMethod(toPath, "updateTransform");
        toPath.__morphT = -1;
        toPath.createPathProxy();
        toPath.dirtyShape();
    }
    toPath.animateTo({
        __morphT: 1
    }, (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        during: function(p) {
            toPath.dirtyShape();
            oldDuring && oldDuring(p);
        },
        done: function() {
            restoreToPath();
            oldDone && oldDone();
        }
    }, animationOpts));
    return toPath;
}
function $2ef03ef3a2bb366a$var$hilbert(x, y, minX, minY, maxX, maxY) {
    var bits = 16;
    x = maxX === minX ? 0 : Math.round(32767 * (x - minX) / (maxX - minX));
    y = maxY === minY ? 0 : Math.round(32767 * (y - minY) / (maxY - minY));
    var d = 0;
    var tmp;
    for(var s = (1 << bits) / 2; s > 0; s /= 2){
        var rx = 0;
        var ry = 0;
        if ((x & s) > 0) rx = 1;
        if ((y & s) > 0) ry = 1;
        d += s * s * (3 * rx ^ ry);
        if (ry === 0) {
            if (rx === 1) {
                x = s - 1 - x;
                y = s - 1 - y;
            }
            tmp = x;
            x = y;
            y = tmp;
        }
    }
    return d;
}
function $2ef03ef3a2bb366a$var$sortPaths(pathList) {
    var xMin = Infinity;
    var yMin = Infinity;
    var xMax = -Infinity;
    var yMax = -Infinity;
    var cps = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(pathList, function(path) {
        var rect = path.getBoundingRect();
        var m = path.getComputedTransform();
        var x = rect.x + rect.width / 2 + (m ? m[4] : 0);
        var y = rect.y + rect.height / 2 + (m ? m[5] : 0);
        xMin = Math.min(x, xMin);
        yMin = Math.min(y, yMin);
        xMax = Math.max(x, xMax);
        yMax = Math.max(y, yMax);
        return [
            x,
            y
        ];
    });
    var items = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(cps, function(cp, idx) {
        return {
            cp: cp,
            z: $2ef03ef3a2bb366a$var$hilbert(cp[0], cp[1], xMin, yMin, xMax, yMax),
            path: pathList[idx]
        };
    });
    return items.sort(function(a, b) {
        return a.z - b.z;
    }).map(function(item) {
        return item.path;
    });
}
function $2ef03ef3a2bb366a$var$defaultDividePath(param) {
    return (0, $640f8b532a910a4f$export$65980d18b75784e2)(param.path, param.count);
}
function $2ef03ef3a2bb366a$var$createEmptyReturn() {
    return {
        fromIndividuals: [],
        toIndividuals: [],
        count: 0
    };
}
function $2ef03ef3a2bb366a$export$57d3bac3565fd555(fromList, toPath, animationOpts) {
    var fromPathList = [];
    function addFromPath(fromList) {
        for(var i = 0; i < fromList.length; i++){
            var from = fromList[i];
            if ($2ef03ef3a2bb366a$export$f9f720a01590a46f(from)) addFromPath(from.childrenRef());
            else if (from instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) fromPathList.push(from);
        }
    }
    addFromPath(fromList);
    var separateCount = fromPathList.length;
    if (!separateCount) return $2ef03ef3a2bb366a$var$createEmptyReturn();
    var dividePath = animationOpts.dividePath || $2ef03ef3a2bb366a$var$defaultDividePath;
    var toSubPathList = dividePath({
        path: toPath,
        count: separateCount
    });
    if (toSubPathList.length !== separateCount) {
        console.error("Invalid morphing: unmatched splitted path");
        return $2ef03ef3a2bb366a$var$createEmptyReturn();
    }
    fromPathList = $2ef03ef3a2bb366a$var$sortPaths(fromPathList);
    toSubPathList = $2ef03ef3a2bb366a$var$sortPaths(toSubPathList);
    var oldDone = animationOpts.done;
    var oldDuring = animationOpts.during;
    var individualDelay = animationOpts.individualDelay;
    var identityTransform = new (0, $becf2d727f9cf450$export$2e2bcd8739ae039)();
    for(var i = 0; i < separateCount; i++){
        var from = fromPathList[i];
        var to = toSubPathList[i];
        to.parent = toPath;
        to.copyTransform(identityTransform);
        if (!individualDelay) $2ef03ef3a2bb366a$var$prepareMorphPath(from, to);
    }
    toPath.__isCombineMorphing = true;
    toPath.childrenRef = function() {
        return toSubPathList;
    };
    function addToSubPathListToZr(zr) {
        for(var i = 0; i < toSubPathList.length; i++)toSubPathList[i].addSelfToZr(zr);
    }
    $2ef03ef3a2bb366a$var$saveAndModifyMethod(toPath, "addSelfToZr", {
        after: function(zr) {
            addToSubPathListToZr(zr);
        }
    });
    $2ef03ef3a2bb366a$var$saveAndModifyMethod(toPath, "removeSelfFromZr", {
        after: function(zr) {
            for(var i = 0; i < toSubPathList.length; i++)toSubPathList[i].removeSelfFromZr(zr);
        }
    });
    function restoreToPath() {
        toPath.__isCombineMorphing = false;
        toPath.__morphT = -1;
        toPath.childrenRef = null;
        $2ef03ef3a2bb366a$var$restoreMethod(toPath, "addSelfToZr");
        $2ef03ef3a2bb366a$var$restoreMethod(toPath, "removeSelfFromZr");
    }
    var toLen = toSubPathList.length;
    if (individualDelay) {
        var animating_1 = toLen;
        var eachDone = function() {
            animating_1--;
            if (animating_1 === 0) {
                restoreToPath();
                oldDone && oldDone();
            }
        };
        for(var i = 0; i < toLen; i++){
            var indivdualAnimationOpts = individualDelay ? (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                delay: (animationOpts.delay || 0) + individualDelay(i, toLen, fromPathList[i], toSubPathList[i]),
                done: eachDone
            }, animationOpts) : animationOpts;
            $2ef03ef3a2bb366a$export$7174e282c1c7df1c(fromPathList[i], toSubPathList[i], indivdualAnimationOpts);
        }
    } else {
        toPath.__morphT = 0;
        toPath.animateTo({
            __morphT: 1
        }, (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
            during: function(p) {
                for(var i = 0; i < toLen; i++){
                    var child = toSubPathList[i];
                    child.__morphT = toPath.__morphT;
                    child.dirtyShape();
                }
                oldDuring && oldDuring(p);
            },
            done: function() {
                restoreToPath();
                for(var i = 0; i < fromList.length; i++)$2ef03ef3a2bb366a$var$restoreMethod(fromList[i], "updateTransform");
                oldDone && oldDone();
            }
        }, animationOpts));
    }
    if (toPath.__zr) addToSubPathListToZr(toPath.__zr);
    return {
        fromIndividuals: fromPathList,
        toIndividuals: toSubPathList,
        count: toLen
    };
}
function $2ef03ef3a2bb366a$export$b6ed198024fe6db8(fromPath, toPathList, animationOpts) {
    var toLen = toPathList.length;
    var fromPathList = [];
    var dividePath = animationOpts.dividePath || $2ef03ef3a2bb366a$var$defaultDividePath;
    function addFromPath(fromList) {
        for(var i = 0; i < fromList.length; i++){
            var from = fromList[i];
            if ($2ef03ef3a2bb366a$export$f9f720a01590a46f(from)) addFromPath(from.childrenRef());
            else if (from instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) fromPathList.push(from);
        }
    }
    if ($2ef03ef3a2bb366a$export$f9f720a01590a46f(fromPath)) {
        addFromPath(fromPath.childrenRef());
        var fromLen = fromPathList.length;
        if (fromLen < toLen) {
            var k = 0;
            for(var i = fromLen; i < toLen; i++)fromPathList.push((0, $15b38920672b9006$export$18711d956bf1c3eb)(fromPathList[k++ % fromLen]));
        }
        fromPathList.length = toLen;
    } else {
        fromPathList = dividePath({
            path: fromPath,
            count: toLen
        });
        var fromPathTransform = fromPath.getComputedTransform();
        for(var i = 0; i < fromPathList.length; i++)fromPathList[i].setLocalTransform(fromPathTransform);
        if (fromPathList.length !== toLen) {
            console.error("Invalid morphing: unmatched splitted path");
            return $2ef03ef3a2bb366a$var$createEmptyReturn();
        }
    }
    fromPathList = $2ef03ef3a2bb366a$var$sortPaths(fromPathList);
    toPathList = $2ef03ef3a2bb366a$var$sortPaths(toPathList);
    var individualDelay = animationOpts.individualDelay;
    for(var i = 0; i < toLen; i++){
        var indivdualAnimationOpts = individualDelay ? (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
            delay: (animationOpts.delay || 0) + individualDelay(i, toLen, fromPathList[i], toPathList[i])
        }, animationOpts) : animationOpts;
        $2ef03ef3a2bb366a$export$7174e282c1c7df1c(fromPathList[i], toPathList[i], indivdualAnimationOpts);
    }
    return {
        fromIndividuals: fromPathList,
        toIndividuals: toPathList,
        count: toPathList.length
    };
}






function $2a0c51260032b767$var$isMultiple(elements) {
    return (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(elements[0]);
}
function $2a0c51260032b767$var$prepareMorphBatches(one, many) {
    var batches = [];
    var batchCount = one.length;
    for(var i = 0; i < batchCount; i++)batches.push({
        one: one[i],
        many: []
    });
    for(var i = 0; i < many.length; i++){
        var len = many[i].length;
        var k = void 0;
        for(k = 0; k < len; k++)batches[k % batchCount].many.push(many[i][k]);
    }
    var off = 0;
    // If one has more paths than each one of many. average them.
    for(var i = batchCount - 1; i >= 0; i--)if (!batches[i].many.length) {
        var moveFrom = batches[off].many;
        if (moveFrom.length <= 1) {
            // Not enough
            // Start from the first one.
            if (off) off = 0;
            else return batches;
        }
        var len = moveFrom.length;
        var mid = Math.ceil(len / 2);
        batches[i].many = moveFrom.slice(mid, len);
        batches[off].many = moveFrom.slice(0, mid);
        off++;
    }
    return batches;
}
var $2a0c51260032b767$var$pathDividers = {
    clone: function(params) {
        var ret = [];
        // Fitting the alpha
        var approxOpacity = 1 - Math.pow(1 - params.path.style.opacity, 1 / params.count);
        for(var i = 0; i < params.count; i++){
            var cloned = (0, $15b38920672b9006$export$18711d956bf1c3eb)(params.path);
            cloned.setStyle("opacity", approxOpacity);
            ret.push(cloned);
        }
        return ret;
    },
    // Use the default divider
    split: null
};
function $2a0c51260032b767$export$c6ab3ab2bfe1ec39(from, to, divideShape, seriesModel, dataIndex, animateOtherProps) {
    if (!from.length || !to.length) return;
    var updateAnimationCfg = (0, $8b353638fbedfefa$export$5cc7add7ab591d0a)("update", seriesModel, dataIndex);
    if (!(updateAnimationCfg && updateAnimationCfg.duration > 0)) return;
    var animationDelay = seriesModel.getModel("universalTransition").get("delay");
    var animationCfg = Object.assign({
        // Need to setToFinal so the further calculation based on the style can be correct.
        // Like emphasis color.
        setToFinal: true
    }, updateAnimationCfg);
    var many;
    var one;
    if ($2a0c51260032b767$var$isMultiple(from)) {
        // manyToOne
        many = from;
        one = to;
    }
    if ($2a0c51260032b767$var$isMultiple(to)) {
        // oneToMany
        many = to;
        one = from;
    }
    function morphOneBatch(batch, fromIsMany, animateIndex, animateCount, forceManyOne) {
        var batchMany = batch.many;
        var batchOne = batch.one;
        if (batchMany.length === 1 && !forceManyOne) {
            // Is one to one
            var batchFrom = fromIsMany ? batchMany[0] : batchOne;
            var batchTo = fromIsMany ? batchOne : batchMany[0];
            if ((0, $2ef03ef3a2bb366a$export$f9f720a01590a46f)(batchFrom)) // Keep doing combine animation.
            morphOneBatch({
                many: [
                    batchFrom
                ],
                one: batchTo
            }, true, animateIndex, animateCount, true);
            else {
                var individualAnimationCfg = animationDelay ? (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                    delay: animationDelay(animateIndex, animateCount)
                }, animationCfg) : animationCfg;
                (0, $2ef03ef3a2bb366a$export$7174e282c1c7df1c)(batchFrom, batchTo, individualAnimationCfg);
                animateOtherProps(batchFrom, batchTo, batchFrom, batchTo, individualAnimationCfg);
            }
        } else {
            var separateAnimationCfg = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                dividePath: $2a0c51260032b767$var$pathDividers[divideShape],
                individualDelay: animationDelay && function(idx, count, fromPath, toPath) {
                    return animationDelay(idx + animateIndex, animateCount);
                }
            }, animationCfg);
            var _a = fromIsMany ? (0, $2ef03ef3a2bb366a$export$57d3bac3565fd555)(batchMany, batchOne, separateAnimationCfg) : (0, $2ef03ef3a2bb366a$export$b6ed198024fe6db8)(batchOne, batchMany, separateAnimationCfg), fromIndividuals = _a.fromIndividuals, toIndividuals = _a.toIndividuals;
            var count = fromIndividuals.length;
            for(var k = 0; k < count; k++){
                var individualAnimationCfg = animationDelay ? (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                    delay: animationDelay(k, count)
                }, animationCfg) : animationCfg;
                animateOtherProps(fromIndividuals[k], toIndividuals[k], fromIsMany ? batchMany[k] : batch.one, fromIsMany ? batch.one : batchMany[k], individualAnimationCfg);
            }
        }
    }
    var fromIsMany = many ? many === from : from.length > to.length;
    var morphBatches = many ? $2a0c51260032b767$var$prepareMorphBatches(one, many) : $2a0c51260032b767$var$prepareMorphBatches(fromIsMany ? to : from, [
        fromIsMany ? from : to
    ]);
    var animateCount = 0;
    for(var i = 0; i < morphBatches.length; i++)animateCount += morphBatches[i].many.length;
    var animateIndex = 0;
    for(var i = 0; i < morphBatches.length; i++){
        morphOneBatch(morphBatches[i], fromIsMany, animateIndex, animateCount);
        animateIndex += morphBatches[i].many.length;
    }
}
function $2a0c51260032b767$export$ad61593d7c3fa814(elements) {
    if (!elements) return [];
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(elements)) {
        var pathList_1 = [];
        for(var i = 0; i < elements.length; i++)pathList_1.push($2a0c51260032b767$export$ad61593d7c3fa814(elements[i]));
        return pathList_1;
    }
    var pathList = [];
    elements.traverse(function(el) {
        if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039) && !el.disableMorphing && !el.invisible && !el.ignore) pathList.push(el);
    });
    return pathList;
}









var $2915cc4a2282c523$var$DATA_COUNT_THRESHOLD = 1e4;
var $2915cc4a2282c523$var$TRANSITION_NONE = 0;
var $2915cc4a2282c523$var$TRANSITION_P2C = 1;
var $2915cc4a2282c523$var$TRANSITION_C2P = 2;
var $2915cc4a2282c523$var$getUniversalTransitionGlobalStore = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $2915cc4a2282c523$var$getDimension(data, visualDimension) {
    var dimensions = data.dimensions;
    for(var i = 0; i < dimensions.length; i++){
        var dimInfo = data.getDimensionInfo(dimensions[i]);
        if (dimInfo && dimInfo.otherDims[visualDimension] === 0) return dimensions[i];
    }
}
// get value by dimension. (only get value of itemGroupId or childGroupId, so convert it to string)
function $2915cc4a2282c523$var$getValueByDimension(data, dataIndex, dimension) {
    var dimInfo = data.getDimensionInfo(dimension);
    var dimOrdinalMeta = dimInfo && dimInfo.ordinalMeta;
    if (dimInfo) {
        var value = data.get(dimInfo.name, dataIndex);
        if (dimOrdinalMeta) return dimOrdinalMeta.categories[value] || value + "";
        return value + "";
    }
}
function $2915cc4a2282c523$var$getGroupId(data, dataIndex, dataGroupId, isChild) {
    // try to get groupId from encode
    var visualDimension = isChild ? "itemChildGroupId" : "itemGroupId";
    var groupIdDim = $2915cc4a2282c523$var$getDimension(data, visualDimension);
    if (groupIdDim) {
        var groupId = $2915cc4a2282c523$var$getValueByDimension(data, dataIndex, groupIdDim);
        return groupId;
    }
    // try to get groupId from raw data item
    var rawDataItem = data.getRawDataItem(dataIndex);
    var property = isChild ? "childGroupId" : "groupId";
    if (rawDataItem && rawDataItem[property]) return rawDataItem[property] + "";
    // fallback
    if (isChild) return;
    // try to use series.dataGroupId as groupId, otherwise use dataItem's id as groupId
    return dataGroupId || data.getId(dataIndex);
}
// flatten all data items from different serieses into one arrary
function $2915cc4a2282c523$var$flattenDataDiffItems(list) {
    var items = [];
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(list, function(seriesInfo) {
        var data = seriesInfo.data;
        var dataGroupId = seriesInfo.dataGroupId;
        if (data.count() > $2915cc4a2282c523$var$DATA_COUNT_THRESHOLD) return;
        var indices = data.getIndices();
        for(var dataIndex = 0; dataIndex < indices.length; dataIndex++)items.push({
            data: data,
            groupId: $2915cc4a2282c523$var$getGroupId(data, dataIndex, dataGroupId, false),
            childGroupId: $2915cc4a2282c523$var$getGroupId(data, dataIndex, dataGroupId, true),
            divide: seriesInfo.divide,
            dataIndex: dataIndex
        });
    });
    return items;
}
function $2915cc4a2282c523$var$fadeInElement(newEl, newSeries, newIndex) {
    newEl.traverse(function(el) {
        if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) // TODO use fade in animation for target element.
        (0, $8b353638fbedfefa$export$a121566aadcfe021)(el, {
            style: {
                opacity: 0
            }
        }, newSeries, {
            dataIndex: newIndex,
            isFrom: true
        });
    });
}
function $2915cc4a2282c523$var$removeEl(el) {
    if (el.parent) {
        // Bake parent transform to element.
        // So it can still have proper transform to transition after it's removed.
        var computedTransform = el.getComputedTransform();
        el.setLocalTransform(computedTransform);
        el.parent.remove(el);
    }
}
function $2915cc4a2282c523$var$stopAnimation(el) {
    el.stopAnimation();
    if (el.isGroup) el.traverse(function(child) {
        child.stopAnimation();
    });
}
function $2915cc4a2282c523$var$animateElementStyles(el, dataIndex, seriesModel) {
    var animationConfig = (0, $8b353638fbedfefa$export$5cc7add7ab591d0a)("update", seriesModel, dataIndex);
    animationConfig && el.traverse(function(child) {
        if (child instanceof (0, $56206a6cb4666931$export$2e2bcd8739ae039)) {
            var oldStyle = (0, $8b353638fbedfefa$export$ccb1f1e4d2fa86ac)(child);
            if (oldStyle) child.animateFrom({
                style: oldStyle
            }, animationConfig);
        }
    });
}
function $2915cc4a2282c523$var$isAllIdSame(oldDiffItems, newDiffItems) {
    var len = oldDiffItems.length;
    if (len !== newDiffItems.length) return false;
    for(var i = 0; i < len; i++){
        var oldItem = oldDiffItems[i];
        var newItem = newDiffItems[i];
        if (oldItem.data.getId(oldItem.dataIndex) !== newItem.data.getId(newItem.dataIndex)) return false;
    }
    return true;
}
function $2915cc4a2282c523$var$transitionBetween(oldList, newList, api) {
    var oldDiffItems = $2915cc4a2282c523$var$flattenDataDiffItems(oldList);
    var newDiffItems = $2915cc4a2282c523$var$flattenDataDiffItems(newList);
    function updateMorphingPathProps(from, to, rawFrom, rawTo, animationCfg) {
        if (rawFrom || from) to.animateFrom({
            style: rawFrom && rawFrom !== from ? (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, rawFrom.style), from.style) : from.style
        }, animationCfg);
    }
    var hasMorphAnimation = false;
    /**
   * With groupId and childGroupId, we can build parent-child relationships between dataItems.
   * However, we should mind the parent-child "direction" between old and new options.
   *
   * For example, suppose we have two dataItems from two series.data:
   *
   * dataA: [                          dataB: [
   *   {                                 {
   *     value: 5,                         value: 3,
   *     groupId: 'creatures',             groupId: 'animals',
   *     childGroupId: 'animals'           childGroupId: 'dogs'
   *   },                                },
   *   ...                               ...
   * ]                                 ]
   *
   * where dataA is belong to optionA and dataB is belong to optionB.
   *
   * When we `setOption(optionB)` from optionA, we choose childGroupId of dataItemA and groupId of
   * dataItemB as keys so the two keys are matched (both are 'animals'), then universalTransition
   * will work. This derection is "parent -> child".
   *
   * If we `setOption(optionA)` from optionB, we also choose groupId of dataItemB and childGroupId
   * of dataItemA as keys and universalTransition will work. This derection is "child -> parent".
   *
   * If there is no childGroupId specified, which means no multiLevelDrillDown/Up is needed and no
   * parent-child relationship exists. This direction is "none".
   *
   * So we need to know whether to use groupId or childGroupId as the key when we call the keyGetter
   * functions. Thus, we need to decide the direction first.
   *
   * The rule is:
   *
   * if (all childGroupIds in oldDiffItems and all groupIds in newDiffItems have common value) {
   *   direction = 'parent -> child';
   * } else if (all groupIds in oldDiffItems and all childGroupIds in newDiffItems have common value) {
   *   direction = 'child -> parent';
   * } else {
   *   direction = 'none';
   * }
   */ var direction = $2915cc4a2282c523$var$TRANSITION_NONE;
    // find all groupIds and childGroupIds from oldDiffItems
    var oldGroupIds = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var oldChildGroupIds = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    oldDiffItems.forEach(function(item) {
        item.groupId && oldGroupIds.set(item.groupId, true);
        item.childGroupId && oldChildGroupIds.set(item.childGroupId, true);
    });
    // traverse newDiffItems and decide the direction according to the rule
    for(var i = 0; i < newDiffItems.length; i++){
        var newGroupId = newDiffItems[i].groupId;
        if (oldChildGroupIds.get(newGroupId)) {
            direction = $2915cc4a2282c523$var$TRANSITION_P2C;
            break;
        }
        var newChildGroupId = newDiffItems[i].childGroupId;
        if (newChildGroupId && oldGroupIds.get(newChildGroupId)) {
            direction = $2915cc4a2282c523$var$TRANSITION_C2P;
            break;
        }
    }
    function createKeyGetter(isOld, onlyGetId) {
        return function(diffItem) {
            var data = diffItem.data;
            var dataIndex = diffItem.dataIndex;
            // TODO if specified dim
            if (onlyGetId) return data.getId(dataIndex);
            if (isOld) return direction === $2915cc4a2282c523$var$TRANSITION_P2C ? diffItem.childGroupId : diffItem.groupId;
            else return direction === $2915cc4a2282c523$var$TRANSITION_C2P ? diffItem.childGroupId : diffItem.groupId;
        };
    }
    // Use id if it's very likely to be an one to one animation
    // It's more robust than groupId
    // TODO Check if key dimension is specified.
    var useId = $2915cc4a2282c523$var$isAllIdSame(oldDiffItems, newDiffItems);
    var isElementStillInChart = {};
    if (!useId) // We may have different diff strategy with basicTransition if we use other dimension as key.
    // If so, we can't simply check if oldEl is same with newEl. We need a map to check if oldEl is still being used in the new chart.
    // We can't use the elements that already being morphed. Let it keep it's original basic transition.
    for(var i = 0; i < newDiffItems.length; i++){
        var newItem = newDiffItems[i];
        var el = newItem.data.getItemGraphicEl(newItem.dataIndex);
        if (el) isElementStillInChart[el.id] = true;
    }
    function updateOneToOne(newIndex, oldIndex) {
        var oldItem = oldDiffItems[oldIndex];
        var newItem = newDiffItems[newIndex];
        var newSeries = newItem.data.hostModel;
        // TODO Mark this elements is morphed and don't morph them anymore
        var oldEl = oldItem.data.getItemGraphicEl(oldItem.dataIndex);
        var newEl = newItem.data.getItemGraphicEl(newItem.dataIndex);
        // Can't handle same elements.
        if (oldEl === newEl) {
            newEl && $2915cc4a2282c523$var$animateElementStyles(newEl, newItem.dataIndex, newSeries);
            return;
        }
        if (// We can't use the elements that already being morphed
        oldEl && isElementStillInChart[oldEl.id]) return;
        if (newEl) {
            // TODO: If keep animating the group in case
            // some of the elements don't want to be morphed.
            // TODO Label?
            $2915cc4a2282c523$var$stopAnimation(newEl);
            if (oldEl) {
                $2915cc4a2282c523$var$stopAnimation(oldEl);
                // If old element is doing leaving animation. stop it and remove it immediately.
                $2915cc4a2282c523$var$removeEl(oldEl);
                hasMorphAnimation = true;
                (0, $2a0c51260032b767$export$c6ab3ab2bfe1ec39)((0, $2a0c51260032b767$export$ad61593d7c3fa814)(oldEl), (0, $2a0c51260032b767$export$ad61593d7c3fa814)(newEl), newItem.divide, newSeries, newIndex, updateMorphingPathProps);
            } else $2915cc4a2282c523$var$fadeInElement(newEl, newSeries, newIndex);
        }
    // else keep oldEl leaving animation.
    }
    new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(oldDiffItems, newDiffItems, createKeyGetter(true, useId), createKeyGetter(false, useId), null, "multiple").update(updateOneToOne).updateManyToOne(function(newIndex, oldIndices) {
        var newItem = newDiffItems[newIndex];
        var newData = newItem.data;
        var newSeries = newData.hostModel;
        var newEl = newData.getItemGraphicEl(newItem.dataIndex);
        var oldElsList = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(oldIndices, function(idx) {
            return oldDiffItems[idx].data.getItemGraphicEl(oldDiffItems[idx].dataIndex);
        }), function(oldEl) {
            return oldEl && oldEl !== newEl && !isElementStillInChart[oldEl.id];
        });
        if (newEl) {
            $2915cc4a2282c523$var$stopAnimation(newEl);
            if (oldElsList.length) {
                // If old element is doing leaving animation. stop it and remove it immediately.
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(oldElsList, function(oldEl) {
                    $2915cc4a2282c523$var$stopAnimation(oldEl);
                    $2915cc4a2282c523$var$removeEl(oldEl);
                });
                hasMorphAnimation = true;
                (0, $2a0c51260032b767$export$c6ab3ab2bfe1ec39)((0, $2a0c51260032b767$export$ad61593d7c3fa814)(oldElsList), (0, $2a0c51260032b767$export$ad61593d7c3fa814)(newEl), newItem.divide, newSeries, newIndex, updateMorphingPathProps);
            } else $2915cc4a2282c523$var$fadeInElement(newEl, newSeries, newItem.dataIndex);
        }
    // else keep oldEl leaving animation.
    }).updateOneToMany(function(newIndices, oldIndex) {
        var oldItem = oldDiffItems[oldIndex];
        var oldEl = oldItem.data.getItemGraphicEl(oldItem.dataIndex);
        // We can't use the elements that already being morphed
        if (oldEl && isElementStillInChart[oldEl.id]) return;
        var newElsList = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(newIndices, function(idx) {
            return newDiffItems[idx].data.getItemGraphicEl(newDiffItems[idx].dataIndex);
        }), function(el) {
            return el && el !== oldEl;
        });
        var newSeris = newDiffItems[newIndices[0]].data.hostModel;
        if (newElsList.length) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newElsList, function(newEl) {
                return $2915cc4a2282c523$var$stopAnimation(newEl);
            });
            if (oldEl) {
                $2915cc4a2282c523$var$stopAnimation(oldEl);
                // If old element is doing leaving animation. stop it and remove it immediately.
                $2915cc4a2282c523$var$removeEl(oldEl);
                hasMorphAnimation = true;
                (0, $2a0c51260032b767$export$c6ab3ab2bfe1ec39)((0, $2a0c51260032b767$export$ad61593d7c3fa814)(oldEl), (0, $2a0c51260032b767$export$ad61593d7c3fa814)(newElsList), oldItem.divide, // Use divide on old.
                newSeris, newIndices[0], updateMorphingPathProps);
            } else (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newElsList, function(newEl) {
                return $2915cc4a2282c523$var$fadeInElement(newEl, newSeris, newIndices[0]);
            });
        }
    // else keep oldEl leaving animation.
    }).updateManyToMany(function(newIndices, oldIndices) {
        // If two data are same and both have groupId.
        // Normally they should be diff by id.
        new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(oldIndices, newIndices, function(rawIdx) {
            return oldDiffItems[rawIdx].data.getId(oldDiffItems[rawIdx].dataIndex);
        }, function(rawIdx) {
            return newDiffItems[rawIdx].data.getId(newDiffItems[rawIdx].dataIndex);
        }).update(function(newIndex, oldIndex) {
            // Use the original index
            updateOneToOne(newIndices[newIndex], oldIndices[oldIndex]);
        }).execute();
    }).execute();
    if (hasMorphAnimation) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newList, function(_a) {
        var data = _a.data;
        var seriesModel = data.hostModel;
        var view = seriesModel && api.getViewOfSeriesModel(seriesModel);
        var animationCfg = (0, $8b353638fbedfefa$export$5cc7add7ab591d0a)("update", seriesModel, 0); // use 0 index.
        if (view && seriesModel.isAnimationEnabled() && animationCfg && animationCfg.duration > 0) view.group.traverse(function(el) {
            if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039) && !el.animators.length) // We can't accept there still exists element that has no animation
            // if universalTransition is enabled
            el.animateFrom({
                style: {
                    opacity: 0
                }
            }, animationCfg);
        });
    });
}
function $2915cc4a2282c523$var$getSeriesTransitionKey(series) {
    var seriesKey = series.getModel("universalTransition").get("seriesKey");
    if (!seriesKey) // Use series id by default.
    return series.id;
    return seriesKey;
}
function $2915cc4a2282c523$var$convertArraySeriesKeyToString(seriesKey) {
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(seriesKey)) // Order independent.
    return seriesKey.sort().join(",");
    return seriesKey;
}
function $2915cc4a2282c523$var$getDivideShapeFromData(data) {
    if (data.hostModel) return data.hostModel.getModel("universalTransition").get("divideShape");
}
function $2915cc4a2282c523$var$findTransitionSeriesBatches(globalStore, params) {
    var updateBatches = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var oldDataMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    // Map that only store key in array seriesKey.
    // Which is used to query the old data when transition from one to multiple series.
    var oldDataMapForSplit = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(globalStore.oldSeries, function(series, idx) {
        var oldDataGroupId = globalStore.oldDataGroupIds[idx];
        var oldData = globalStore.oldData[idx];
        var transitionKey = $2915cc4a2282c523$var$getSeriesTransitionKey(series);
        var transitionKeyStr = $2915cc4a2282c523$var$convertArraySeriesKeyToString(transitionKey);
        oldDataMap.set(transitionKeyStr, {
            dataGroupId: oldDataGroupId,
            data: oldData
        });
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(transitionKey)) // Same key can't in different array seriesKey.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(transitionKey, function(key) {
            oldDataMapForSplit.set(key, {
                key: transitionKeyStr,
                dataGroupId: oldDataGroupId,
                data: oldData
            });
        });
    });
    function checkTransitionSeriesKeyDuplicated(transitionKeyStr) {
        if (updateBatches.get(transitionKeyStr)) (0, $84bc7667c27ccedc$export$c106dd0671a0fc2d)("Duplicated seriesKey in universalTransition " + transitionKeyStr);
    }
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(params.updatedSeries, function(series) {
        if (series.isUniversalTransitionEnabled() && series.isAnimationEnabled()) {
            var newDataGroupId = series.get("dataGroupId");
            var newData = series.getData();
            var transitionKey = $2915cc4a2282c523$var$getSeriesTransitionKey(series);
            var transitionKeyStr = $2915cc4a2282c523$var$convertArraySeriesKeyToString(transitionKey);
            // Only transition between series with same id.
            var oldData = oldDataMap.get(transitionKeyStr);
            // string transition key is the best match.
            if (oldData) // TODO check if data is same?
            updateBatches.set(transitionKeyStr, {
                oldSeries: [
                    {
                        dataGroupId: oldData.dataGroupId,
                        divide: $2915cc4a2282c523$var$getDivideShapeFromData(oldData.data),
                        data: oldData.data
                    }
                ],
                newSeries: [
                    {
                        dataGroupId: newDataGroupId,
                        divide: $2915cc4a2282c523$var$getDivideShapeFromData(newData),
                        data: newData
                    }
                ]
            });
            else // Transition from multiple series.
            // e.g. 'female', 'male' -> ['female', 'male']
            if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(transitionKey)) {
                var oldSeries_1 = [];
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(transitionKey, function(key) {
                    var oldData = oldDataMap.get(key);
                    if (oldData.data) oldSeries_1.push({
                        dataGroupId: oldData.dataGroupId,
                        divide: $2915cc4a2282c523$var$getDivideShapeFromData(oldData.data),
                        data: oldData.data
                    });
                });
                if (oldSeries_1.length) updateBatches.set(transitionKeyStr, {
                    oldSeries: oldSeries_1,
                    newSeries: [
                        {
                            dataGroupId: newDataGroupId,
                            data: newData,
                            divide: $2915cc4a2282c523$var$getDivideShapeFromData(newData)
                        }
                    ]
                });
            } else {
                // Try transition to multiple series.
                // e.g. ['female', 'male'] -> 'female', 'male'
                var oldData_1 = oldDataMapForSplit.get(transitionKey);
                if (oldData_1) {
                    var batch = updateBatches.get(oldData_1.key);
                    if (!batch) {
                        batch = {
                            oldSeries: [
                                {
                                    dataGroupId: oldData_1.dataGroupId,
                                    data: oldData_1.data,
                                    divide: $2915cc4a2282c523$var$getDivideShapeFromData(oldData_1.data)
                                }
                            ],
                            newSeries: []
                        };
                        updateBatches.set(oldData_1.key, batch);
                    }
                    batch.newSeries.push({
                        dataGroupId: newDataGroupId,
                        data: newData,
                        divide: $2915cc4a2282c523$var$getDivideShapeFromData(newData)
                    });
                }
            }
        }
    });
    return updateBatches;
}
function $2915cc4a2282c523$var$querySeries(series, finder) {
    for(var i = 0; i < series.length; i++){
        var found = finder.seriesIndex != null && finder.seriesIndex === series[i].seriesIndex || finder.seriesId != null && finder.seriesId === series[i].id;
        if (found) return i;
    }
}
function $2915cc4a2282c523$var$transitionSeriesFromOpt(transitionOpt, globalStore, params, api) {
    var from = [];
    var to = [];
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(transitionOpt.from), function(finder) {
        var idx = $2915cc4a2282c523$var$querySeries(globalStore.oldSeries, finder);
        if (idx >= 0) from.push({
            dataGroupId: globalStore.oldDataGroupIds[idx],
            data: globalStore.oldData[idx],
            // TODO can specify divideShape in transition.
            divide: $2915cc4a2282c523$var$getDivideShapeFromData(globalStore.oldData[idx]),
            groupIdDim: finder.dimension
        });
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(transitionOpt.to), function(finder) {
        var idx = $2915cc4a2282c523$var$querySeries(params.updatedSeries, finder);
        if (idx >= 0) {
            var data = params.updatedSeries[idx].getData();
            to.push({
                dataGroupId: globalStore.oldDataGroupIds[idx],
                data: data,
                divide: $2915cc4a2282c523$var$getDivideShapeFromData(data),
                groupIdDim: finder.dimension
            });
        }
    });
    if (from.length > 0 && to.length > 0) $2915cc4a2282c523$var$transitionBetween(from, to, api);
}
function $2915cc4a2282c523$export$efd07f28fd73e88c(registers) {
    registers.registerUpdateLifecycle("series:beforeupdate", function(ecMOdel, api, params) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(params.seriesTransition), function(transOpt) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(transOpt.to), function(finder) {
                var series = params.updatedSeries;
                for(var i = 0; i < series.length; i++)if (finder.seriesIndex != null && finder.seriesIndex === series[i].seriesIndex || finder.seriesId != null && finder.seriesId === series[i].id) series[i][0, $7c10febb2cdef0d8$export$e960441116ae2799] = true;
            });
        });
    });
    registers.registerUpdateLifecycle("series:transition", function(ecModel, api, params) {
        // TODO api provide an namespace that can save stuff per instance
        var globalStore = $2915cc4a2282c523$var$getUniversalTransitionGlobalStore(api);
        // TODO multiple to multiple series.
        if (globalStore.oldSeries && params.updatedSeries && params.optionChanged) {
            // TODO transitionOpt was used in an old implementation and can be removed now
            // Use give transition config if its' give;
            var transitionOpt = params.seriesTransition;
            if (transitionOpt) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(transitionOpt), function(opt) {
                $2915cc4a2282c523$var$transitionSeriesFromOpt(opt, globalStore, params, api);
            });
            else {
                // Else guess from series based on transition series key.
                var updateBatches_1 = $2915cc4a2282c523$var$findTransitionSeriesBatches(globalStore, params);
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(updateBatches_1.keys(), function(key) {
                    var batch = updateBatches_1.get(key);
                    $2915cc4a2282c523$var$transitionBetween(batch.oldSeries, batch.newSeries, api);
                });
            }
            // Reset
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(params.updatedSeries, function(series) {
                // Reset;
                if (series[0, $7c10febb2cdef0d8$export$e960441116ae2799]) series[0, $7c10febb2cdef0d8$export$e960441116ae2799] = false;
            });
        }
        // Save all series of current update. Not only the updated one.
        var allSeries = ecModel.getSeries();
        var savedSeries = globalStore.oldSeries = [];
        var savedDataGroupIds = globalStore.oldDataGroupIds = [];
        var savedData = globalStore.oldData = [];
        for(var i = 0; i < allSeries.length; i++){
            var data = allSeries[i].getData();
            // Only save the data that can have transition.
            // Avoid large data costing too much extra memory
            if (data.count() < $2915cc4a2282c523$var$DATA_COUNT_THRESHOLD) {
                savedSeries.push(allSeries[i]);
                savedDataGroupIds.push(allSeries[i].get("dataGroupId"));
                savedData.push(data);
            }
        }
    });
}


// -----------------
// Render engines
// -----------------
// Render via Canvas.
// echarts.init(dom, null, { renderer: 'canvas' })
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)([
    (0, $e792bf2f67d76098$export$4b3e715f166fdd78)
]);
// Render via SVG.
// echarts.init(dom, null, { renderer: 'svg' })
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)([
    (0, $8d8c6eb926bbdd0e$export$4b3e715f166fdd78)
]);
// ----------------
// Charts (series)
// ----------------
// All of the series types, for example:
// chart.setOption({
//     series: [{
//         type: 'line' // or 'bar', 'pie', ...
//     }]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)([
    (0, $9c1bfdc9a4f78f2d$export$4b3e715f166fdd78),
    (0, $4bb56d1f08552ff4$export$4b3e715f166fdd78),
    (0, $6b7ead9b40180cba$export$4b3e715f166fdd78),
    (0, $1214e5d7a4a6f990$export$4b3e715f166fdd78),
    (0, $a8120efef8bcaaa0$export$4b3e715f166fdd78),
    (0, $6c94070aa7d5e098$export$4b3e715f166fdd78),
    (0, $44a5d4d260c7de78$export$4b3e715f166fdd78),
    (0, $330b7dc841112eff$export$4b3e715f166fdd78),
    (0, $b48bd73bf5d69641$export$4b3e715f166fdd78),
    (0, $1c1924ac8c8efc9c$export$4b3e715f166fdd78),
    (0, $bf7cb565bb1d2308$export$4b3e715f166fdd78),
    (0, $2bdc3734cdc2f6c8$export$4b3e715f166fdd78),
    (0, $4d1dc874f9d8653d$export$4b3e715f166fdd78),
    (0, $2439b31c49c21b38$export$4b3e715f166fdd78),
    (0, $0fd6296850ce3099$export$4b3e715f166fdd78),
    (0, $21999577dfdc5807$export$4b3e715f166fdd78),
    (0, $a0fd335cdafe9e6e$export$4b3e715f166fdd78),
    (0, $52dd2448928cc7d8$export$4b3e715f166fdd78),
    (0, $c53e84d38e53ec61$export$4b3e715f166fdd78),
    (0, $7e25595b74be81a3$export$4b3e715f166fdd78),
    (0, $e883cd02390b2e6d$export$4b3e715f166fdd78),
    (0, $b7341ef122ec790d$export$4b3e715f166fdd78),
    (0, $3fd02cf8c6a1578a$export$4b3e715f166fdd78)
]);
// -------------------
// Coordinate systems
// -------------------
// All of the axis modules have been included in the
// coordinate system module below, do not need to
// make extra import.
// `cartesian` coordinate system. For some historical
// reasons, it is named as grid, for example:
// chart.setOption({
//     grid: {...},
//     xAxis: {...},
//     yAxis: {...},
//     series: [{...}]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $30909b2e837c2175$export$4b3e715f166fdd78));
// `polar` coordinate system, for example:
// chart.setOption({
//     polar: {...},
//     radiusAxis: {...},
//     angleAxis: {...},
//     series: [{
//         coordinateSystem: 'polar'
//     }]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $0a6536a72e92ce0b$export$4b3e715f166fdd78));
// `geo` coordinate system, for example:
// chart.setOption({
//     geo: {...},
//     series: [{
//         coordinateSystem: 'geo'
//     }]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $8082b8b129488d44$export$4b3e715f166fdd78));
// `singleAxis` coordinate system (notice, it is a coordinate system
// with only one axis, work for chart like theme river), for example:
// chart.setOption({
//     singleAxis: {...}
//     series: [{type: 'themeRiver', ...}]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $2e3198006a202a14$export$4b3e715f166fdd78));
// `parallel` coordinate system, only work for parallel series, for example:
// chart.setOption({
//     parallel: {...},
//     parallelAxis: [{...}, ...],
//     series: [{
//         type: 'parallel'
//     }]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $462857bad733a944$export$4b3e715f166fdd78));
// `calendar` coordinate system. for example,
// chart.setOption({
//     calendar: {...},
//     series: [{
//         coordinateSystem: 'calendar'
//     }]
// );
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $c1c3b68ff9dcc3e7$export$4b3e715f166fdd78));
// `matrix` coordinate system. for example,
// chart.setOption({
//     matrix: {...},
//     series: [{
//         coordinateSystem: 'matrix'
//     }]
// );
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $0a1ba7f84a4891f5$export$4b3e715f166fdd78));
// ------------------
// Other components
// ------------------
// `graphic` component, for example:
// chart.setOption({
//     graphic: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $48174658d54922b7$export$4b3e715f166fdd78));
// `toolbox` component, for example:
// chart.setOption({
//     toolbox: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $db487da8ce0e4ca6$export$4b3e715f166fdd78));
// `tooltip` component, for example:
// chart.setOption({
//     tooltip: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $46e639bec576c55c$export$4b3e715f166fdd78));
// `axisPointer` component, for example:
// chart.setOption({
//     tooltip: {axisPointer: {...}, ...}
// });
// Or
// chart.setOption({
//     axisPointer: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $589507869c21caa1$export$4b3e715f166fdd78));
// `brush` component, for example:
// chart.setOption({
//     brush: {...}
// });
// Or
// chart.setOption({
//     tooltip: {feature: {brush: {...}}
// })
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $e97a928e0b93a54f$export$4b3e715f166fdd78));
// `title` component, for example:
// chart.setOption({
//     title: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $66707465bee49836$export$4b3e715f166fdd78));
// `timeline` component, for example:
// chart.setOption({
//     timeline: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $d41f79c5664eb934$export$4b3e715f166fdd78));
// `markPoint` component, for example:
// chart.setOption({
//     series: [{markPoint: {...}}]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $4edaa7c972a7e0d1$export$4b3e715f166fdd78));
// `markLine` component, for example:
// chart.setOption({
//     series: [{markLine: {...}}]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $0fc27d0a088604ed$export$4b3e715f166fdd78));
// `markArea` component, for example:
// chart.setOption({
//     series: [{markArea: {...}}]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $8a8e80722bf1c081$export$4b3e715f166fdd78));
// `legend` component not scrollable. for example:
// chart.setOption({
//     legend: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $1a0761510a437d9f$export$4b3e715f166fdd78));
// `dataZoom` component including both `dataZoomInside` and `dataZoomSlider`.
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $aa2dc70f9fa9453b$export$4b3e715f166fdd78));
// `dataZoom` component providing drag, pinch, wheel behaviors
// inside coordinate system, for example:
// chart.setOption({
//     dataZoom: {type: 'inside'}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $b5ee445cd897e37a$export$4b3e715f166fdd78));
// `dataZoom` component providing a slider bar, for example:
// chart.setOption({
//     dataZoom: {type: 'slider'}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $794c23331e97718e$export$4b3e715f166fdd78));
// `visualMap` component including both `visualMapContinuous` and `visualMapPiecewise`.
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $1df0d53aa7db8747$export$4b3e715f166fdd78));
// `visualMap` component providing continuous bar, for example:
// chart.setOption({
//     visualMap: {type: 'continuous'}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $a0f8a196dd8b4cba$export$4b3e715f166fdd78));
// `visualMap` component providing pieces bar, for example:
// chart.setOption({
//     visualMap: {type: 'piecewise'}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $312d2d640a7c60e1$export$4b3e715f166fdd78));
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $3659e9d1145d1e8b$export$4b3e715f166fdd78));
// `aria` component providing aria, for example:
// chart.setOption({
//     aria: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $772c09ed30d27c33$export$4b3e715f166fdd78));
// dataset transform
// chart.setOption({
//     dataset: {
//          transform: []
//     }
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $d6bad095dfa9594d$export$4b3e715f166fdd78));
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $afb70cea6fec4fe0$export$4b3e715f166fdd78));
// universal transition
// chart.setOption({
//     series: {
//         universalTransition: { enabled: true }
//     }
// })
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $2915cc4a2282c523$export$efd07f28fd73e88c));
// label layout
// chart.setOption({
//     series: {
//         labelLayout: { hideOverlap: true }
//     }
// })
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $de19ea5da3bb8f56$export$5320d1b3745c02a5));
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $6dff6eb93aaa7720$export$f3d2e42c14594d5b));
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $8defd9d7c6d36f4c$export$81228e37d220ba46));
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $1214e5d7a4a6f990$export$7dc06c71cf84167d));


// Element IDs
const $b4e14b6b8da86996$var$noBluetoothDivID = "warn-no-blueooth";
const $b4e14b6b8da86996$var$deviceNameID = "controls-device-name";
const $b4e14b6b8da86996$var$connectButtonID = "controls-connect";
const $b4e14b6b8da86996$var$disconnectButtonID = "controls-disconnect";
const $b4e14b6b8da86996$var$dataSectionID = "data";
const $b4e14b6b8da86996$var$currentStatusID = "data-current-status";
const $b4e14b6b8da86996$var$currentSpeedID = "data-current-speed";
const $b4e14b6b8da86996$var$targetSpeedID = "data-target-speed";
const $b4e14b6b8da86996$var$currentDistanceID = "data-current-distance";
const $b4e14b6b8da86996$var$currentTimeID = "data-current-time";
const $b4e14b6b8da86996$var$currentKcalID = "data-current-kcal";
// Control elements
const $b4e14b6b8da86996$var$dataControlsID = "data-controls";
const $b4e14b6b8da86996$var$speedDecreaseID = "speed-decrease";
const $b4e14b6b8da86996$var$speedIncreaseID = "speed-increase";
const $b4e14b6b8da86996$var$speedDecreaseLargeID = "speed-decrease-large";
const $b4e14b6b8da86996$var$speedIncreaseLargeID = "speed-increase-large";
const $b4e14b6b8da86996$var$controlStartID = "control-start";
const $b4e14b6b8da86996$var$controlStopID = "control-stop";
// Connection status elements
const $b4e14b6b8da86996$var$connectionStatusID = "connection-status";
const $b4e14b6b8da86996$var$connectionMessageID = "connection-message";
const $b4e14b6b8da86996$var$cancelReconnectID = "controls-cancel-reconnect";
// History elements
const $b4e14b6b8da86996$var$historyToggleID = "history-toggle";
const $b4e14b6b8da86996$var$historyContentID = "history-content";
const $b4e14b6b8da86996$var$historyRefreshID = "history-refresh";
const $b4e14b6b8da86996$var$historyDeleteSelectedID = "history-delete-selected";
const $b4e14b6b8da86996$var$historyExportCsvID = "history-export-csv";
const $b4e14b6b8da86996$var$historyExportJsonID = "history-export-json";
const $b4e14b6b8da86996$var$historyListID = "history-list";
const $b4e14b6b8da86996$var$historyEmptyID = "history-empty";
const $b4e14b6b8da86996$var$historyDetailID = "history-detail";
const $b4e14b6b8da86996$var$historyDetailCloseID = "history-detail-close";
const $b4e14b6b8da86996$var$historyDetailContentID = "history-detail-content";
// Goals elements (inputs are now in Settings)
const $b4e14b6b8da86996$var$goalDistanceInputID = "goal-distance";
const $b4e14b6b8da86996$var$goalDurationInputID = "goal-duration";
const $b4e14b6b8da86996$var$goalsProgressID = "goals-section";
const $b4e14b6b8da86996$var$goalDistanceCurrentID = "goal-distance-current";
const $b4e14b6b8da86996$var$goalDistanceTargetID = "goal-distance-target";
const $b4e14b6b8da86996$var$goalDistanceBarID = "goal-distance-bar";
const $b4e14b6b8da86996$var$goalDurationCurrentID = "goal-duration-current";
const $b4e14b6b8da86996$var$goalDurationTargetID = "goal-duration-target";
const $b4e14b6b8da86996$var$goalDurationBarID = "goal-duration-bar";
// Settings elements
const $b4e14b6b8da86996$var$settingsToggleID = "settings-toggle";
const $b4e14b6b8da86996$var$settingsContentID = "settings-content";
const $b4e14b6b8da86996$var$settingsWeightID = "settings-weight";
const $b4e14b6b8da86996$var$settingsSaveID = "settings-save";
// Summary elements
const $b4e14b6b8da86996$var$summaryToggleID = "summary-toggle";
const $b4e14b6b8da86996$var$summaryContentID = "summary-content";
const $b4e14b6b8da86996$var$summaryWeeklyID = "summary-weekly";
const $b4e14b6b8da86996$var$summaryMonthlyID = "summary-monthly";
const $b4e14b6b8da86996$var$summarySessionsID = "summary-sessions";
const $b4e14b6b8da86996$var$summaryDistanceID = "summary-distance";
const $b4e14b6b8da86996$var$summaryTimeID = "summary-time";
const $b4e14b6b8da86996$var$summaryChartID = "summary-chart";
// Toast container
const $b4e14b6b8da86996$var$toastContainerID = "toast-container";
// Cached elements
const $b4e14b6b8da86996$var$deviceName = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$deviceNameID);
const $b4e14b6b8da86996$var$connectButton = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$connectButtonID);
const $b4e14b6b8da86996$var$disconnectButton = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$disconnectButtonID);
const $b4e14b6b8da86996$var$dataSection = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$dataSectionID);
const $b4e14b6b8da86996$var$currentStatus = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$currentStatusID);
const $b4e14b6b8da86996$var$currentSpeed = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$currentSpeedID);
const $b4e14b6b8da86996$var$targetSpeedDisplay = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$targetSpeedID);
const $b4e14b6b8da86996$var$currentDistance = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$currentDistanceID);
const $b4e14b6b8da86996$var$currentTime = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$currentTimeID);
const $b4e14b6b8da86996$var$currentKcal = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$currentKcalID);
const $b4e14b6b8da86996$var$dataControls = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$dataControlsID);
const $b4e14b6b8da86996$var$speedDecrease = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$speedDecreaseID);
const $b4e14b6b8da86996$var$speedIncrease = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$speedIncreaseID);
const $b4e14b6b8da86996$var$speedDecreaseLarge = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$speedDecreaseLargeID);
const $b4e14b6b8da86996$var$speedIncreaseLarge = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$speedIncreaseLargeID);
const $b4e14b6b8da86996$var$controlStart = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$controlStartID);
const $b4e14b6b8da86996$var$controlStop = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$controlStopID);
const $b4e14b6b8da86996$var$connectionStatus = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$connectionStatusID);
const $b4e14b6b8da86996$var$connectionMessage = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$connectionMessageID);
const $b4e14b6b8da86996$var$cancelReconnect = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$cancelReconnectID);
const $b4e14b6b8da86996$var$historyToggle = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$historyToggleID);
const $b4e14b6b8da86996$var$historyContent = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$historyContentID);
const $b4e14b6b8da86996$var$historyRefresh = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$historyRefreshID);
const $b4e14b6b8da86996$var$historyDeleteSelected = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$historyDeleteSelectedID);
const $b4e14b6b8da86996$var$historyExportCsv = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$historyExportCsvID);
const $b4e14b6b8da86996$var$historyExportJson = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$historyExportJsonID);
const $b4e14b6b8da86996$var$historyList = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$historyListID);
const $b4e14b6b8da86996$var$historyEmpty = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$historyEmptyID);
const $b4e14b6b8da86996$var$historyDetail = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$historyDetailID);
const $b4e14b6b8da86996$var$historyDetailClose = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$historyDetailCloseID);
const $b4e14b6b8da86996$var$historyDetailContent = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$historyDetailContentID);
const $b4e14b6b8da86996$var$goalDistanceInput = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$goalDistanceInputID);
const $b4e14b6b8da86996$var$goalDurationInput = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$goalDurationInputID);
const $b4e14b6b8da86996$var$goalsProgress = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$goalsProgressID);
const $b4e14b6b8da86996$var$goalDistanceCurrent = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$goalDistanceCurrentID);
const $b4e14b6b8da86996$var$goalDistanceTarget = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$goalDistanceTargetID);
const $b4e14b6b8da86996$var$goalDistanceBar = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$goalDistanceBarID);
const $b4e14b6b8da86996$var$goalDurationCurrent = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$goalDurationCurrentID);
const $b4e14b6b8da86996$var$goalDurationTarget = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$goalDurationTargetID);
const $b4e14b6b8da86996$var$goalDurationBar = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$goalDurationBarID);
const $b4e14b6b8da86996$var$settingsToggle = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$settingsToggleID);
const $b4e14b6b8da86996$var$settingsContent = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$settingsContentID);
const $b4e14b6b8da86996$var$settingsWeight = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$settingsWeightID);
const $b4e14b6b8da86996$var$settingsSave = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$settingsSaveID);
const $b4e14b6b8da86996$var$summaryToggle = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$summaryToggleID);
const $b4e14b6b8da86996$var$summaryContent = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$summaryContentID);
const $b4e14b6b8da86996$var$summaryWeekly = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$summaryWeeklyID);
const $b4e14b6b8da86996$var$summaryMonthly = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$summaryMonthlyID);
const $b4e14b6b8da86996$var$summarySessions = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$summarySessionsID);
const $b4e14b6b8da86996$var$summaryDistance = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$summaryDistanceID);
const $b4e14b6b8da86996$var$summaryTime = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$summaryTimeID);
const $b4e14b6b8da86996$var$toastContainer = $b4e14b6b8da86996$var$findElement($b4e14b6b8da86996$var$toastContainerID);
let $b4e14b6b8da86996$var$treadmill = null;
let $b4e14b6b8da86996$var$db;
let $b4e14b6b8da86996$var$currentSettings;
let $b4e14b6b8da86996$var$selectedSessionIds = new Set();
let $b4e14b6b8da86996$var$distanceGoalAlerted = false;
let $b4e14b6b8da86996$var$durationGoalAlerted = false;
function $b4e14b6b8da86996$var$findElement(id) {
    const e = document.querySelector(`#${id}`);
    if (!e) throw new Error(`element not found: ${id}`);
    return e;
}
function $b4e14b6b8da86996$var$formatDate(timestamp) {
    return new Date(timestamp).toLocaleString();
}
function $b4e14b6b8da86996$var$formatDuration(seconds) {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    if (h > 0) return `${h}:${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
    return `${m}:${s.toString().padStart(2, "0")}`;
}
function $b4e14b6b8da86996$var$formatMinutes(minutes) {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    if (h > 0) return `${h}:${m.toString().padStart(2, "0")}`;
    return `${m}:00`;
}
// Toggle collapsible sections
function $b4e14b6b8da86996$var$setupToggle(toggle, content) {
    toggle.addEventListener("click", ()=>{
        const expanded = toggle.getAttribute("aria-expanded") === "true";
        toggle.setAttribute("aria-expanded", (!expanded).toString());
        toggle.textContent = toggle.textContent?.replace(expanded ? "\u25BC" : "\u25B6", expanded ? "\u25B6" : "\u25BC") || "";
        content.classList.toggle("hidden");
    });
}
function $b4e14b6b8da86996$var$showToast(message, type = "info", duration = 3000) {
    const toast = document.createElement("div");
    toast.className = `toast toast-${type}`;
    toast.textContent = message;
    $b4e14b6b8da86996$var$toastContainer.appendChild(toast);
    setTimeout(()=>{
        toast.classList.add("toast-fade-out");
        setTimeout(()=>toast.remove(), 300);
    }, duration);
}
function $b4e14b6b8da86996$var$playAlertSound(frequency = 800, duration = 200) {
    try {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const oscillator = audioContext.createOscillator();
        const gainNode = audioContext.createGain();
        oscillator.connect(gainNode);
        gainNode.connect(audioContext.destination);
        oscillator.frequency.value = frequency;
        oscillator.type = "sine";
        gainNode.gain.value = 0.3;
        oscillator.start();
        setTimeout(()=>{
            oscillator.stop();
            audioContext.close();
        }, duration);
    } catch (e) {
    // Audio not supported, ignore
    }
}
function $b4e14b6b8da86996$var$vibrate(pattern = 200) {
    if ("vibrate" in navigator) navigator.vibrate(pattern);
}
function $b4e14b6b8da86996$var$alertGoalReached(goalType) {
    const message = goalType === "distance" ? "Distance goal reached!" : "Duration goal reached!";
    $b4e14b6b8da86996$var$showToast(message, "goal", 5000);
    $b4e14b6b8da86996$var$playAlertSound(1000, 300);
    $b4e14b6b8da86996$var$vibrate([
        200,
        100,
        200
    ]);
}
function $b4e14b6b8da86996$var$alertSessionStarted() {
    $b4e14b6b8da86996$var$showToast("Workout started", "success");
}
function $b4e14b6b8da86996$var$alertSessionEnded() {
    $b4e14b6b8da86996$var$showToast("Workout complete!", "success", 4000);
    $b4e14b6b8da86996$var$playAlertSound(600, 150);
}
// Session History
async function $b4e14b6b8da86996$var$loadSessions() {
    return await $b4e14b6b8da86996$var$db.session.orderBy("started").reverse().toArray();
}
async function $b4e14b6b8da86996$var$renderSessionList() {
    const sessions = await $b4e14b6b8da86996$var$loadSessions();
    $b4e14b6b8da86996$var$selectedSessionIds.clear();
    $b4e14b6b8da86996$var$updateDeleteButton();
    if (sessions.length === 0) {
        $b4e14b6b8da86996$var$historyEmpty.classList.remove("hidden");
        // Remove any existing session items
        $b4e14b6b8da86996$var$historyList.querySelectorAll(".session-item").forEach((el)=>el.remove());
        return;
    }
    $b4e14b6b8da86996$var$historyEmpty.classList.add("hidden");
    $b4e14b6b8da86996$var$historyList.querySelectorAll(".session-item").forEach((el)=>el.remove());
    sessions.forEach((session)=>{
        const item = document.createElement("div");
        item.className = "session-item";
        item.dataset.sessionId = session.id?.toString();
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.addEventListener("change", (e)=>{
            e.stopPropagation();
            if (checkbox.checked) $b4e14b6b8da86996$var$selectedSessionIds.add(session.id);
            else $b4e14b6b8da86996$var$selectedSessionIds.delete(session.id);
            $b4e14b6b8da86996$var$updateDeleteButton();
        });
        const info = document.createElement("div");
        info.className = "session-item-info";
        const date = document.createElement("div");
        date.className = "session-item-date";
        date.textContent = $b4e14b6b8da86996$var$formatDate(session.started);
        const stats = document.createElement("div");
        stats.className = "session-item-stats";
        stats.textContent = `${$b4e14b6b8da86996$var$formatDuration(session.duration)} \xb7 ${session.distance.toFixed(2)} mi \xb7 ${session.averageSpeed.toFixed(1)} mph avg`;
        info.appendChild(date);
        info.appendChild(stats);
        item.appendChild(checkbox);
        item.appendChild(info);
        item.addEventListener("click", (e)=>{
            if (e.target.tagName !== "INPUT") $b4e14b6b8da86996$var$showSessionDetail(session);
        });
        $b4e14b6b8da86996$var$historyList.appendChild(item);
    });
}
function $b4e14b6b8da86996$var$showSessionDetail(session) {
    $b4e14b6b8da86996$var$historyList.classList.add("hidden");
    $b4e14b6b8da86996$var$historyDetail.classList.remove("hidden");
    $b4e14b6b8da86996$var$historyDetailContent.innerHTML = `
    <div class="detail-row"><span>Date</span><span>${$b4e14b6b8da86996$var$formatDate(session.started)}</span></div>
    <div class="detail-row"><span>Duration</span><span>${$b4e14b6b8da86996$var$formatDuration(session.duration)}</span></div>
    <div class="detail-row"><span>Distance</span><span>${session.distance.toFixed(2)} miles</span></div>
    <div class="detail-row"><span>Average Speed</span><span>${session.averageSpeed.toFixed(1)} mph</span></div>
    <div class="detail-row"><span>Calories</span><span>${session.energyExpended} kcal</span></div>
    <div class="detail-row"><span>Started</span><span>${$b4e14b6b8da86996$var$formatDate(session.started)}</span></div>
    <div class="detail-row"><span>Ended</span><span>${$b4e14b6b8da86996$var$formatDate(session.ended)}</span></div>
    <div class="chart-container" id="session-chart"></div>
  `;
    // Load chart data if ECharts is available
    $b4e14b6b8da86996$var$loadSessionChart(session);
}
async function $b4e14b6b8da86996$var$loadSessionChart(session) {
    const dataPoints = await $b4e14b6b8da86996$var$db.treadmillData.where("timestamp").between(session.started, session.ended).toArray();
    if (dataPoints.length === 0) return;
    const chartContainer = document.getElementById("session-chart");
    if (!chartContainer) return;
    const chart = $4d59907f44a2d0ad$export$2cd8252107eb640b(chartContainer);
    const times = dataPoints.map((d)=>$b4e14b6b8da86996$var$formatDuration(d.elapsedTime));
    const speeds = dataPoints.map((d)=>d.speed);
    const distances = dataPoints.map((d)=>d.distance);
    chart.setOption({
        tooltip: {
            trigger: "axis"
        },
        legend: {
            data: [
                "Speed (mph)",
                "Distance (mi)"
            ]
        },
        xAxis: {
            type: "category",
            data: times
        },
        yAxis: [
            {
                type: "value",
                name: "Speed (mph)",
                position: "left"
            },
            {
                type: "value",
                name: "Distance (mi)",
                position: "right"
            }
        ],
        series: [
            {
                name: "Speed (mph)",
                type: "line",
                data: speeds,
                smooth: true
            },
            {
                name: "Distance (mi)",
                type: "line",
                data: distances,
                yAxisIndex: 1,
                smooth: true
            }
        ]
    });
    window.addEventListener("resize", ()=>chart.resize());
}
function $b4e14b6b8da86996$var$hideSessionDetail() {
    $b4e14b6b8da86996$var$historyDetail.classList.add("hidden");
    $b4e14b6b8da86996$var$historyList.classList.remove("hidden");
}
function $b4e14b6b8da86996$var$updateDeleteButton() {
    $b4e14b6b8da86996$var$historyDeleteSelected.disabled = $b4e14b6b8da86996$var$selectedSessionIds.size === 0;
}
async function $b4e14b6b8da86996$var$deleteSelectedSessions() {
    if ($b4e14b6b8da86996$var$selectedSessionIds.size === 0) return;
    if (!confirm(`Delete ${$b4e14b6b8da86996$var$selectedSessionIds.size} session(s)?`)) return;
    await $b4e14b6b8da86996$var$db.session.bulkDelete([
        ...$b4e14b6b8da86996$var$selectedSessionIds
    ]);
    await $b4e14b6b8da86996$var$renderSessionList();
}
// Export functions
function $b4e14b6b8da86996$var$exportSessionsCsv(sessions) {
    const headers = [
        "id",
        "started",
        "ended",
        "duration",
        "distance",
        "averageSpeed",
        "energyExpended"
    ];
    const rows = sessions.map((s)=>[
            s.id,
            new Date(s.started).toISOString(),
            new Date(s.ended).toISOString(),
            s.duration,
            s.distance,
            s.averageSpeed,
            s.energyExpended
        ]);
    const csv = [
        headers.join(","),
        ...rows.map((r)=>r.join(","))
    ].join("\n");
    $b4e14b6b8da86996$var$downloadFile(csv, "sessions.csv", "text/csv");
}
function $b4e14b6b8da86996$var$exportSessionsJson(sessions) {
    const json = JSON.stringify(sessions, null, 2);
    $b4e14b6b8da86996$var$downloadFile(json, "sessions.json", "application/json");
}
function $b4e14b6b8da86996$var$downloadFile(content, filename, mimeType) {
    const blob = new Blob([
        content
    ], {
        type: mimeType
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}
// Goals
function $b4e14b6b8da86996$var$updateGoalsFromSettings() {
    if ($b4e14b6b8da86996$var$currentSettings.goalDistanceMiles) $b4e14b6b8da86996$var$goalDistanceInput.value = $b4e14b6b8da86996$var$currentSettings.goalDistanceMiles.toString();
    if ($b4e14b6b8da86996$var$currentSettings.goalDurationMinutes) $b4e14b6b8da86996$var$goalDurationInput.value = $b4e14b6b8da86996$var$currentSettings.goalDurationMinutes.toString();
    $b4e14b6b8da86996$var$updateGoalsVisibility();
}
function $b4e14b6b8da86996$var$updateGoalsVisibility() {
    const hasDistanceGoal = $b4e14b6b8da86996$var$currentSettings.goalDistanceMiles !== null && $b4e14b6b8da86996$var$currentSettings.goalDistanceMiles > 0;
    const hasDurationGoal = $b4e14b6b8da86996$var$currentSettings.goalDurationMinutes !== null && $b4e14b6b8da86996$var$currentSettings.goalDurationMinutes > 0;
    // Update target display values
    if (hasDistanceGoal) $b4e14b6b8da86996$var$goalDistanceTarget.textContent = $b4e14b6b8da86996$var$currentSettings.goalDistanceMiles.toFixed(1);
    else $b4e14b6b8da86996$var$goalDistanceTarget.textContent = "0";
    if (hasDurationGoal) $b4e14b6b8da86996$var$goalDurationTarget.textContent = $b4e14b6b8da86996$var$formatMinutes($b4e14b6b8da86996$var$currentSettings.goalDurationMinutes);
    else $b4e14b6b8da86996$var$goalDurationTarget.textContent = "0:00";
}
async function $b4e14b6b8da86996$var$saveGoals() {
    const distanceValue = parseFloat($b4e14b6b8da86996$var$goalDistanceInput.value);
    const durationValue = parseInt($b4e14b6b8da86996$var$goalDurationInput.value, 10);
    await $b4e14b6b8da86996$var$db.saveSettings({
        goalDistanceMiles: isNaN(distanceValue) || distanceValue <= 0 ? null : distanceValue,
        goalDurationMinutes: isNaN(durationValue) || durationValue <= 0 ? null : durationValue
    });
    $b4e14b6b8da86996$var$currentSettings = await $b4e14b6b8da86996$var$db.getSettings();
    $b4e14b6b8da86996$var$updateGoalsVisibility();
}
async function $b4e14b6b8da86996$var$clearGoals() {
    $b4e14b6b8da86996$var$goalDistanceInput.value = "";
    $b4e14b6b8da86996$var$goalDurationInput.value = "";
    await $b4e14b6b8da86996$var$db.saveSettings({
        goalDistanceMiles: null,
        goalDurationMinutes: null
    });
    $b4e14b6b8da86996$var$currentSettings = await $b4e14b6b8da86996$var$db.getSettings();
    $b4e14b6b8da86996$var$updateGoalsVisibility();
}
function $b4e14b6b8da86996$var$updateGoalProgress(distance, elapsedTimeSeconds) {
    if ($b4e14b6b8da86996$var$currentSettings.goalDistanceMiles && $b4e14b6b8da86996$var$currentSettings.goalDistanceMiles > 0) {
        $b4e14b6b8da86996$var$goalDistanceCurrent.textContent = distance.toFixed(2);
        const percent = Math.min(100, distance / $b4e14b6b8da86996$var$currentSettings.goalDistanceMiles * 100);
        $b4e14b6b8da86996$var$goalDistanceBar.value = percent;
        if (percent >= 100) {
            $b4e14b6b8da86996$var$goalDistanceCurrent.parentElement?.classList.add("goal-reached");
            if (!$b4e14b6b8da86996$var$distanceGoalAlerted) {
                $b4e14b6b8da86996$var$distanceGoalAlerted = true;
                $b4e14b6b8da86996$var$alertGoalReached("distance");
            }
        }
    }
    if ($b4e14b6b8da86996$var$currentSettings.goalDurationMinutes && $b4e14b6b8da86996$var$currentSettings.goalDurationMinutes > 0) {
        const elapsedMinutes = elapsedTimeSeconds / 60;
        $b4e14b6b8da86996$var$goalDurationCurrent.textContent = $b4e14b6b8da86996$var$formatDuration(elapsedTimeSeconds);
        const percent = Math.min(100, elapsedMinutes / $b4e14b6b8da86996$var$currentSettings.goalDurationMinutes * 100);
        $b4e14b6b8da86996$var$goalDurationBar.value = percent;
        if (percent >= 100) {
            $b4e14b6b8da86996$var$goalDurationCurrent.parentElement?.classList.add("goal-reached");
            if (!$b4e14b6b8da86996$var$durationGoalAlerted) {
                $b4e14b6b8da86996$var$durationGoalAlerted = true;
                $b4e14b6b8da86996$var$alertGoalReached("duration");
            }
        }
    }
}
function $b4e14b6b8da86996$var$resetGoalProgress() {
    $b4e14b6b8da86996$var$goalDistanceCurrent.textContent = "0";
    $b4e14b6b8da86996$var$goalDurationCurrent.textContent = "0:00";
    $b4e14b6b8da86996$var$goalDistanceBar.value = 0;
    $b4e14b6b8da86996$var$goalDurationBar.value = 0;
    $b4e14b6b8da86996$var$goalDistanceCurrent.parentElement?.classList.remove("goal-reached");
    $b4e14b6b8da86996$var$goalDurationCurrent.parentElement?.classList.remove("goal-reached");
    $b4e14b6b8da86996$var$distanceGoalAlerted = false;
    $b4e14b6b8da86996$var$durationGoalAlerted = false;
}
// Settings
function $b4e14b6b8da86996$var$updateSettingsFromDb() {
    if ($b4e14b6b8da86996$var$currentSettings.weightLbs > 0) $b4e14b6b8da86996$var$settingsWeight.value = $b4e14b6b8da86996$var$currentSettings.weightLbs.toString();
}
async function $b4e14b6b8da86996$var$saveUserSettings() {
    const weightValue = parseFloat($b4e14b6b8da86996$var$settingsWeight.value);
    await $b4e14b6b8da86996$var$db.saveSettings({
        weightLbs: isNaN(weightValue) || weightValue <= 0 ? 0 : weightValue
    });
    $b4e14b6b8da86996$var$currentSettings = await $b4e14b6b8da86996$var$db.getSettings();
    $b4e14b6b8da86996$var$showToast("Settings saved!", "success");
}
// Summary Charts
let $b4e14b6b8da86996$var$summaryChart = null;
let $b4e14b6b8da86996$var$summaryPeriod = "weekly";
async function $b4e14b6b8da86996$var$loadSummaryChart() {
    const sessions = await $b4e14b6b8da86996$var$loadSessions();
    if (sessions.length === 0) {
        $b4e14b6b8da86996$var$summarySessions.textContent = "0";
        $b4e14b6b8da86996$var$summaryDistance.textContent = "0";
        $b4e14b6b8da86996$var$summaryTime.textContent = "0:00";
        return;
    }
    // Group sessions by period
    const now = Date.now();
    const periodMs = $b4e14b6b8da86996$var$summaryPeriod === "weekly" ? 604800000 : 2592000000;
    const periods = {};
    // Get data for the last 8 weeks or 6 months
    const numPeriods = $b4e14b6b8da86996$var$summaryPeriod === "weekly" ? 8 : 6;
    const periodStart = now - numPeriods * periodMs;
    sessions.filter((s)=>s.started >= periodStart).forEach((s)=>{
        const periodIndex = Math.floor((now - s.started) / periodMs);
        const periodKey = $b4e14b6b8da86996$var$summaryPeriod === "weekly" ? `Week -${periodIndex}` : `Month -${periodIndex}`;
        if (!periods[periodKey]) periods[periodKey] = {
            sessions: 0,
            distance: 0,
            duration: 0
        };
        periods[periodKey].sessions++;
        periods[periodKey].distance += s.distance;
        periods[periodKey].duration += s.duration;
    });
    // Calculate totals for recent period
    const recentPeriodKey = $b4e14b6b8da86996$var$summaryPeriod === "weekly" ? "Week -0" : "Month -0";
    const recent = periods[recentPeriodKey] || {
        sessions: 0,
        distance: 0,
        duration: 0
    };
    $b4e14b6b8da86996$var$summarySessions.textContent = recent.sessions.toString();
    $b4e14b6b8da86996$var$summaryDistance.textContent = recent.distance.toFixed(2);
    $b4e14b6b8da86996$var$summaryTime.textContent = $b4e14b6b8da86996$var$formatDuration(recent.duration);
    // Create chart data
    const labels = [];
    const distanceData = [];
    const durationData = [];
    for(let i = numPeriods - 1; i >= 0; i--){
        const key = $b4e14b6b8da86996$var$summaryPeriod === "weekly" ? `Week -${i}` : `Month -${i}`;
        labels.push(i === 0 ? "Current" : $b4e14b6b8da86996$var$summaryPeriod === "weekly" ? `-${i}w` : `-${i}m`);
        const data = periods[key] || {
            sessions: 0,
            distance: 0,
            duration: 0
        };
        distanceData.push(Math.round(data.distance * 100) / 100);
        durationData.push(Math.round(data.duration / 60)); // Convert to minutes
    }
    const chartContainer = document.getElementById($b4e14b6b8da86996$var$summaryChartID);
    if (!chartContainer) return;
    if ($b4e14b6b8da86996$var$summaryChart) $b4e14b6b8da86996$var$summaryChart.dispose();
    $b4e14b6b8da86996$var$summaryChart = $4d59907f44a2d0ad$export$2cd8252107eb640b(chartContainer);
    $b4e14b6b8da86996$var$summaryChart.setOption({
        tooltip: {
            trigger: "axis"
        },
        legend: {
            data: [
                "Distance (mi)",
                "Duration (min)"
            ]
        },
        xAxis: {
            type: "category",
            data: labels
        },
        yAxis: [
            {
                type: "value",
                name: "Distance (mi)",
                position: "left"
            },
            {
                type: "value",
                name: "Duration (min)",
                position: "right"
            }
        ],
        series: [
            {
                name: "Distance (mi)",
                type: "bar",
                data: distanceData
            },
            {
                name: "Duration (min)",
                type: "bar",
                data: durationData,
                yAxisIndex: 1
            }
        ]
    });
    window.addEventListener("resize", ()=>$b4e14b6b8da86996$var$summaryChart?.resize());
}
function $b4e14b6b8da86996$var$setSummaryPeriod(period) {
    $b4e14b6b8da86996$var$summaryPeriod = period;
    $b4e14b6b8da86996$var$summaryWeekly.classList.toggle("active", period === "weekly");
    $b4e14b6b8da86996$var$summaryMonthly.classList.toggle("active", period === "monthly");
    $b4e14b6b8da86996$var$loadSummaryChart();
}
// Calorie calculation using MET formula
function $b4e14b6b8da86996$var$calculateCalories(weightLbs, speedMph, durationMinutes) {
    if (weightLbs <= 0) return 0;
    // MET values for walking/running at different speeds
    // https://sites.google.com/site/compendiumofphysicalactivities/
    let met;
    if (speedMph < 2.0) met = 2.0;
    else if (speedMph < 2.5) met = 2.5;
    else if (speedMph < 3.0) met = 3.0;
    else if (speedMph < 3.5) met = 3.5;
    else if (speedMph < 4.0) met = 4.3;
    else if (speedMph < 4.5) met = 5.0;
    else if (speedMph < 5.0) met = 8.3;
    else if (speedMph < 6.0) met = 9.8;
    else if (speedMph < 7.0) met = 11.0;
    else met = 12.5;
    const weightKg = weightLbs * 0.453592;
    return Math.round(met * weightKg * durationMinutes / 60);
}
// Connection state handler
function $b4e14b6b8da86996$var$onConnectionStateChanged(e) {
    const event = e;
    const { state: state, attempt: attempt } = event.detail;
    // Update status indicator
    $b4e14b6b8da86996$var$connectionStatus.className = `status-${state}`;
    // Update message and show toasts
    switch(state){
        case "disconnected":
            $b4e14b6b8da86996$var$connectionMessage.classList.add("hidden");
            $b4e14b6b8da86996$var$cancelReconnect.classList.add("hidden");
            $b4e14b6b8da86996$var$showToast("Disconnected from treadmill", "warning");
            break;
        case "connecting":
            $b4e14b6b8da86996$var$connectionMessage.textContent = "Connecting...";
            $b4e14b6b8da86996$var$connectionMessage.classList.remove("hidden");
            $b4e14b6b8da86996$var$cancelReconnect.classList.add("hidden");
            break;
        case "connected":
            $b4e14b6b8da86996$var$connectionMessage.classList.add("hidden");
            $b4e14b6b8da86996$var$cancelReconnect.classList.add("hidden");
            $b4e14b6b8da86996$var$showToast("Connected to treadmill", "success");
            break;
        case "reconnecting":
            $b4e14b6b8da86996$var$connectionMessage.textContent = `Reconnecting... (attempt ${attempt}/5)`;
            $b4e14b6b8da86996$var$connectionMessage.classList.remove("hidden");
            $b4e14b6b8da86996$var$cancelReconnect.classList.remove("hidden");
            if (attempt === 1) $b4e14b6b8da86996$var$showToast("Connection lost, attempting to reconnect...", "warning");
            break;
    }
}
function $b4e14b6b8da86996$var$onTreadmillReconnected() {
    // Re-show controls if they were visible before
    if ($b4e14b6b8da86996$var$treadmill?.hasControlPoint) {
        $b4e14b6b8da86996$var$dataControls.classList.remove("hidden");
        $b4e14b6b8da86996$var$updateControlButtons();
    }
    $b4e14b6b8da86996$var$showToast("Reconnected to treadmill!", "success");
}
function $b4e14b6b8da86996$var$handleCancelReconnect() {
    $b4e14b6b8da86996$var$treadmill?.cancelReconnect();
    $b4e14b6b8da86996$var$onTreadmillDisconnected();
}
// Connection handlers
function $b4e14b6b8da86996$var$connectButtonClickListener(worker) {
    return async ()=>{
        $b4e14b6b8da86996$var$connectButton.disabled = true;
        try {
            const d = await (0, $5834f5097160e8a3$export$30c823bc834d6ab4)();
            $b4e14b6b8da86996$var$treadmill = new (0, $bffbb1fe8606acaa$export$d29d5a99a033a8c6)(d);
            await $b4e14b6b8da86996$var$treadmill.connect();
            $b4e14b6b8da86996$var$dataSection.classList.remove("hidden");
            $b4e14b6b8da86996$var$deviceName.textContent = $b4e14b6b8da86996$var$treadmill.name;
            $b4e14b6b8da86996$var$connectButton.classList.add("hidden");
            $b4e14b6b8da86996$var$disconnectButton.disabled = false;
            $b4e14b6b8da86996$var$disconnectButton.classList.remove("hidden");
            $b4e14b6b8da86996$var$resetGoalProgress();
            // Show controls if control point is available
            if ($b4e14b6b8da86996$var$treadmill.hasControlPoint) {
                $b4e14b6b8da86996$var$dataControls.classList.remove("hidden");
                $b4e14b6b8da86996$var$updateControlButtons();
                // Show initial target speed
                $b4e14b6b8da86996$var$targetSpeedDisplay.textContent = $b4e14b6b8da86996$var$treadmill.targetSpeed.toFixed(1);
            }
        } catch (e) {
            $b4e14b6b8da86996$var$connectButton.disabled = false;
            console.error("treadmill failed to connect: ", e);
        }
    };
}
function $b4e14b6b8da86996$var$updateControlButtons() {
    if (!$b4e14b6b8da86996$var$treadmill) return;
    const isRunning = $b4e14b6b8da86996$var$treadmill.status === "Manual Mode (Quick Start)";
    $b4e14b6b8da86996$var$controlStart.classList.toggle("hidden", isRunning);
    $b4e14b6b8da86996$var$controlStop.classList.toggle("hidden", !isRunning);
}
async function $b4e14b6b8da86996$var$handleStart() {
    if (!$b4e14b6b8da86996$var$treadmill) return;
    $b4e14b6b8da86996$var$controlStart.disabled = true;
    const success = await $b4e14b6b8da86996$var$treadmill.start();
    if (!success) console.error("Failed to start treadmill");
    $b4e14b6b8da86996$var$controlStart.disabled = false;
}
async function $b4e14b6b8da86996$var$handleStop() {
    if (!$b4e14b6b8da86996$var$treadmill) return;
    $b4e14b6b8da86996$var$controlStop.disabled = true;
    const success = await $b4e14b6b8da86996$var$treadmill.stop();
    if (!success) console.error("Failed to stop treadmill");
    $b4e14b6b8da86996$var$controlStop.disabled = false;
}
async function $b4e14b6b8da86996$var$handleSpeedDecrease() {
    console.log("[UI] Speed decrease clicked, treadmill:", !!$b4e14b6b8da86996$var$treadmill);
    if (!$b4e14b6b8da86996$var$treadmill) return;
    $b4e14b6b8da86996$var$speedDecrease.disabled = true;
    await $b4e14b6b8da86996$var$treadmill.decreaseSpeed(0.1);
    console.log("[UI] New target speed:", $b4e14b6b8da86996$var$treadmill.targetSpeed);
    $b4e14b6b8da86996$var$speedDecrease.disabled = false;
}
async function $b4e14b6b8da86996$var$handleSpeedIncrease() {
    console.log("[UI] Speed increase clicked, treadmill:", !!$b4e14b6b8da86996$var$treadmill);
    if (!$b4e14b6b8da86996$var$treadmill) return;
    $b4e14b6b8da86996$var$speedIncrease.disabled = true;
    await $b4e14b6b8da86996$var$treadmill.increaseSpeed(0.1);
    console.log("[UI] New target speed:", $b4e14b6b8da86996$var$treadmill.targetSpeed);
    $b4e14b6b8da86996$var$speedIncrease.disabled = false;
}
async function $b4e14b6b8da86996$var$handleSpeedDecreaseLarge() {
    console.log("[UI] Speed decrease large clicked, treadmill:", !!$b4e14b6b8da86996$var$treadmill);
    if (!$b4e14b6b8da86996$var$treadmill) return;
    $b4e14b6b8da86996$var$speedDecreaseLarge.disabled = true;
    await $b4e14b6b8da86996$var$treadmill.decreaseSpeed(0.5);
    console.log("[UI] New target speed:", $b4e14b6b8da86996$var$treadmill.targetSpeed);
    $b4e14b6b8da86996$var$speedDecreaseLarge.disabled = false;
}
async function $b4e14b6b8da86996$var$handleSpeedIncreaseLarge() {
    console.log("[UI] Speed increase large clicked, treadmill:", !!$b4e14b6b8da86996$var$treadmill);
    if (!$b4e14b6b8da86996$var$treadmill) return;
    $b4e14b6b8da86996$var$speedIncreaseLarge.disabled = true;
    await $b4e14b6b8da86996$var$treadmill.increaseSpeed(0.5);
    console.log("[UI] New target speed:", $b4e14b6b8da86996$var$treadmill.targetSpeed);
    $b4e14b6b8da86996$var$speedIncreaseLarge.disabled = false;
}
function $b4e14b6b8da86996$var$treadmillDataEventListener(worker) {
    return (e)=>{
        const d = e;
        worker.postMessage(d.detail);
        $b4e14b6b8da86996$var$currentSpeed.textContent = d.detail.speed.toFixed(1);
        $b4e14b6b8da86996$var$currentDistance.textContent = d.detail.distance.toFixed(2);
        $b4e14b6b8da86996$var$currentTime.textContent = d.detail.formattedTime;
        // Update calorie display with calculated value if we have weight
        if ($b4e14b6b8da86996$var$currentSettings.weightLbs > 0) {
            const calculatedKcal = $b4e14b6b8da86996$var$calculateCalories($b4e14b6b8da86996$var$currentSettings.weightLbs, d.detail.speed, d.detail.elapsedTime / 60);
            $b4e14b6b8da86996$var$currentKcal.textContent = calculatedKcal.toString();
        } else $b4e14b6b8da86996$var$currentKcal.textContent = d.detail.kcal.toString();
        // Update goal progress
        $b4e14b6b8da86996$var$updateGoalProgress(d.detail.distance, d.detail.elapsedTime);
    };
}
function $b4e14b6b8da86996$var$onTreadmillDisconnected() {
    $b4e14b6b8da86996$var$treadmill = null;
    $b4e14b6b8da86996$var$deviceName.textContent = "nothing";
    $b4e14b6b8da86996$var$dataSection.classList.add("hidden");
    $b4e14b6b8da86996$var$dataControls.classList.add("hidden");
    $b4e14b6b8da86996$var$disconnectButton.disabled = true;
    $b4e14b6b8da86996$var$disconnectButton.classList.add("hidden");
    $b4e14b6b8da86996$var$connectButton.classList.remove("hidden");
    $b4e14b6b8da86996$var$connectButton.disabled = false;
}
function $b4e14b6b8da86996$var$trainingStatusEventListener(worker) {
    return (e)=>{
        const d = e;
        worker.postMessage(d.detail);
        $b4e14b6b8da86996$var$currentStatus.textContent = d.detail.stringFromStatus;
        if (d.detail.stringFromStatus === "Idle") $b4e14b6b8da86996$var$idle();
        if (d.detail.stringFromStatus === "Pre-Workout") $b4e14b6b8da86996$var$alertSessionStarted();
        $b4e14b6b8da86996$var$updateControlButtons();
    };
}
function $b4e14b6b8da86996$var$sessionEndedEventListener(worker) {
    return (e)=>{
        const d = e;
        console.log("session ended", d.detail);
        worker.postMessage(d.detail);
        $b4e14b6b8da86996$var$alertSessionEnded();
        // Refresh session list if history is open
        if (!$b4e14b6b8da86996$var$historyContent.classList.contains("hidden")) $b4e14b6b8da86996$var$renderSessionList();
    };
}
function $b4e14b6b8da86996$var$idle() {
    $b4e14b6b8da86996$var$currentStatus.innerText = "Idle";
    $b4e14b6b8da86996$var$currentSpeed.innerText = "0";
    $b4e14b6b8da86996$var$currentDistance.innerText = "0";
    $b4e14b6b8da86996$var$currentTime.innerText = "0:00:00";
    $b4e14b6b8da86996$var$currentKcal.innerText = "0";
    $b4e14b6b8da86996$var$resetGoalProgress();
}
var $33c009c367ff3b18$exports = {};
var $56b621a6dd25b2cb$exports = {};
"use strict";
$56b621a6dd25b2cb$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};


let $33c009c367ff3b18$var$url = new URL("storage-worker.3f31b64c.js", import.meta.url);
$33c009c367ff3b18$exports = $56b621a6dd25b2cb$exports($33c009c367ff3b18$var$url.toString(), $33c009c367ff3b18$var$url.origin, true);


var $5cccb5591bb3b1ca$exports = {};
$5cccb5591bb3b1ca$exports = new URL("sw.js", import.meta.url).toString();


// Initialize
(async function() {
    if (!await (0, $5834f5097160e8a3$export$17b446b869dad473)()) {
        document.querySelector(`#${$b4e14b6b8da86996$var$noBluetoothDivID}`)?.classList.remove("hidden");
        throw new Error("webbluetooth not supported");
    }
    // Initialize database
    $b4e14b6b8da86996$var$db = new (0, $372d9dcfc71c4a48$export$a0911963a0fbc1ef)();
    $b4e14b6b8da86996$var$currentSettings = await $b4e14b6b8da86996$var$db.getSettings();
    // @ts-expect-error 1343
    const worker = new Worker($33c009c367ff3b18$exports);
    // Set up event listeners
    document.addEventListener("treadmilldisconnected", $b4e14b6b8da86996$var$onTreadmillDisconnected);
    document.addEventListener("treadmilldata", $b4e14b6b8da86996$var$treadmillDataEventListener(worker));
    document.addEventListener("trainingstatuschanged", $b4e14b6b8da86996$var$trainingStatusEventListener(worker));
    document.addEventListener("sessionended", $b4e14b6b8da86996$var$sessionEndedEventListener(worker));
    document.addEventListener("connectionstatechanged", $b4e14b6b8da86996$var$onConnectionStateChanged);
    document.addEventListener("treadmillreconnected", $b4e14b6b8da86996$var$onTreadmillReconnected);
    document.addEventListener("targetspeedchanged", (e)=>{
        const speed = e.detail;
        $b4e14b6b8da86996$var$targetSpeedDisplay.textContent = speed.toFixed(1);
    });
    $b4e14b6b8da86996$var$connectButton.addEventListener("click", $b4e14b6b8da86996$var$connectButtonClickListener(worker));
    $b4e14b6b8da86996$var$disconnectButton.addEventListener("click", ()=>{
        $b4e14b6b8da86996$var$treadmill?.disconnect();
    });
    $b4e14b6b8da86996$var$cancelReconnect.addEventListener("click", $b4e14b6b8da86996$var$handleCancelReconnect);
    $b4e14b6b8da86996$var$connectButton.disabled = false;
    // Control button handlers
    $b4e14b6b8da86996$var$controlStart.addEventListener("click", $b4e14b6b8da86996$var$handleStart);
    $b4e14b6b8da86996$var$controlStop.addEventListener("click", $b4e14b6b8da86996$var$handleStop);
    $b4e14b6b8da86996$var$speedDecrease.addEventListener("click", $b4e14b6b8da86996$var$handleSpeedDecrease);
    $b4e14b6b8da86996$var$speedIncrease.addEventListener("click", $b4e14b6b8da86996$var$handleSpeedIncrease);
    $b4e14b6b8da86996$var$speedDecreaseLarge.addEventListener("click", $b4e14b6b8da86996$var$handleSpeedDecreaseLarge);
    $b4e14b6b8da86996$var$speedIncreaseLarge.addEventListener("click", $b4e14b6b8da86996$var$handleSpeedIncreaseLarge);
    // Set up collapsible sections
    $b4e14b6b8da86996$var$setupToggle($b4e14b6b8da86996$var$historyToggle, $b4e14b6b8da86996$var$historyContent);
    $b4e14b6b8da86996$var$setupToggle($b4e14b6b8da86996$var$settingsToggle, $b4e14b6b8da86996$var$settingsContent);
    $b4e14b6b8da86996$var$setupToggle($b4e14b6b8da86996$var$summaryToggle, $b4e14b6b8da86996$var$summaryContent);
    // History handlers
    $b4e14b6b8da86996$var$historyToggle.addEventListener("click", ()=>{
        // Check if NOT hidden (was just opened by setupToggle)
        if (!$b4e14b6b8da86996$var$historyContent.classList.contains("hidden")) $b4e14b6b8da86996$var$renderSessionList();
    });
    $b4e14b6b8da86996$var$historyRefresh.addEventListener("click", $b4e14b6b8da86996$var$renderSessionList);
    $b4e14b6b8da86996$var$historyDeleteSelected.addEventListener("click", $b4e14b6b8da86996$var$deleteSelectedSessions);
    $b4e14b6b8da86996$var$historyDetailClose.addEventListener("click", $b4e14b6b8da86996$var$hideSessionDetail);
    $b4e14b6b8da86996$var$historyExportCsv.addEventListener("click", async ()=>{
        const sessions = await $b4e14b6b8da86996$var$loadSessions();
        $b4e14b6b8da86996$var$exportSessionsCsv(sessions);
    });
    $b4e14b6b8da86996$var$historyExportJson.addEventListener("click", async ()=>{
        const sessions = await $b4e14b6b8da86996$var$loadSessions();
        $b4e14b6b8da86996$var$exportSessionsJson(sessions);
    });
    // Goals handlers
    $b4e14b6b8da86996$var$goalDistanceInput.addEventListener("change", $b4e14b6b8da86996$var$saveGoals);
    $b4e14b6b8da86996$var$goalDurationInput.addEventListener("change", $b4e14b6b8da86996$var$saveGoals);
    $b4e14b6b8da86996$var$updateGoalsFromSettings();
    // Settings handlers
    $b4e14b6b8da86996$var$settingsSave.addEventListener("click", $b4e14b6b8da86996$var$saveUserSettings);
    $b4e14b6b8da86996$var$updateSettingsFromDb();
    // Summary handlers
    $b4e14b6b8da86996$var$summaryToggle.addEventListener("click", ()=>{
        // Check if NOT hidden (was just opened by setupToggle)
        if (!$b4e14b6b8da86996$var$summaryContent.classList.contains("hidden")) $b4e14b6b8da86996$var$loadSummaryChart();
    });
    $b4e14b6b8da86996$var$summaryWeekly.addEventListener("click", ()=>$b4e14b6b8da86996$var$setSummaryPeriod("weekly"));
    $b4e14b6b8da86996$var$summaryMonthly.addEventListener("click", ()=>$b4e14b6b8da86996$var$setSummaryPeriod("monthly"));
    // Register service worker for PWA
    if ("serviceWorker" in navigator) // @ts-expect-error - Parcel requires URL constructor for service workers
    navigator.serviceWorker.register($5cccb5591bb3b1ca$exports).then((registration)=>{
        console.log("Service Worker registered:", registration.scope);
    }, (error)=>{
        console.error("Service Worker registration failed:", error);
    });
})();


//# sourceMappingURL=index.a3e68895.js.map
